
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire5fc5"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire5fc5"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("acw62", function(module, exports) {
"use strict";

module.exports = (parcelRequire("2pUnB"));

});
parcelRegister("2pUnB", function(module, exports) {

$parcel$export(module.exports, "Children", () => $1c29a66706a62afd$export$dca3b0875bd9a954, (v) => $1c29a66706a62afd$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $1c29a66706a62afd$export$16fa2f45be04daa8, (v) => $1c29a66706a62afd$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $1c29a66706a62afd$export$ffb0004e005737fa, (v) => $1c29a66706a62afd$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $1c29a66706a62afd$export$e2c29f18771995cb, (v) => $1c29a66706a62afd$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $1c29a66706a62afd$export$221d75b3f55bb0bd, (v) => $1c29a66706a62afd$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $1c29a66706a62afd$export$5f8d39834fd61797, (v) => $1c29a66706a62afd$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $1c29a66706a62afd$export$74bf444e3cd11ea5, (v) => $1c29a66706a62afd$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $1c29a66706a62afd$export$ae55be85d98224ed, (v) => $1c29a66706a62afd$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "cloneElement", () => $1c29a66706a62afd$export$e530037191fcd5d7, (v) => $1c29a66706a62afd$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $1c29a66706a62afd$export$fd42f52fd3ae1109, (v) => $1c29a66706a62afd$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $1c29a66706a62afd$export$c8a8987d4410bf2d, (v) => $1c29a66706a62afd$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $1c29a66706a62afd$export$d38cd72104c1f0e9, (v) => $1c29a66706a62afd$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $1c29a66706a62afd$export$7d1e3a5e95ceca43, (v) => $1c29a66706a62afd$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $1c29a66706a62afd$export$257a8862b851cb5b, (v) => $1c29a66706a62afd$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $1c29a66706a62afd$export$a8257692ac88316c, (v) => $1c29a66706a62afd$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $1c29a66706a62afd$export$488013bae63b21da, (v) => $1c29a66706a62afd$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $1c29a66706a62afd$export$7c73462e0d25e514, (v) => $1c29a66706a62afd$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "useCallback", () => $1c29a66706a62afd$export$35808ee640e87ca7, (v) => $1c29a66706a62afd$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $1c29a66706a62afd$export$fae74005e78b1a27, (v) => $1c29a66706a62afd$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $1c29a66706a62afd$export$dc8fbce3eb94dc1e, (v) => $1c29a66706a62afd$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useEffect", () => $1c29a66706a62afd$export$6d9c69b0de29b591, (v) => $1c29a66706a62afd$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $1c29a66706a62afd$export$d5a552a76deda3c2, (v) => $1c29a66706a62afd$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $1c29a66706a62afd$export$e5c5a5f917a5871c, (v) => $1c29a66706a62afd$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $1c29a66706a62afd$export$1538c33de8887b59, (v) => $1c29a66706a62afd$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $1c29a66706a62afd$export$13e3392192263954, (v) => $1c29a66706a62afd$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $1c29a66706a62afd$export$b8f5890fc79d6aca, (v) => $1c29a66706a62afd$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $1c29a66706a62afd$export$60241385465d0a34, (v) => $1c29a66706a62afd$export$60241385465d0a34 = v);
$parcel$export(module.exports, "version", () => $1c29a66706a62afd$export$83d89fbfd8236492, (v) => $1c29a66706a62afd$export$83d89fbfd8236492 = v);
/** @license React v16.14.0
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1c29a66706a62afd$export$dca3b0875bd9a954;
var $1c29a66706a62afd$export$16fa2f45be04daa8;
var $1c29a66706a62afd$export$ffb0004e005737fa;
var $1c29a66706a62afd$export$e2c29f18771995cb;
var $1c29a66706a62afd$export$221d75b3f55bb0bd;
var $1c29a66706a62afd$export$5f8d39834fd61797;
var $1c29a66706a62afd$export$74bf444e3cd11ea5;
var $1c29a66706a62afd$export$ae55be85d98224ed;
var $1c29a66706a62afd$export$e530037191fcd5d7;
var $1c29a66706a62afd$export$fd42f52fd3ae1109;
var $1c29a66706a62afd$export$c8a8987d4410bf2d;
var $1c29a66706a62afd$export$d38cd72104c1f0e9;
var $1c29a66706a62afd$export$7d1e3a5e95ceca43;
var $1c29a66706a62afd$export$257a8862b851cb5b;
var $1c29a66706a62afd$export$a8257692ac88316c;
var $1c29a66706a62afd$export$488013bae63b21da;
var $1c29a66706a62afd$export$7c73462e0d25e514;
var $1c29a66706a62afd$export$35808ee640e87ca7;
var $1c29a66706a62afd$export$fae74005e78b1a27;
var $1c29a66706a62afd$export$dc8fbce3eb94dc1e;
var $1c29a66706a62afd$export$6d9c69b0de29b591;
var $1c29a66706a62afd$export$d5a552a76deda3c2;
var $1c29a66706a62afd$export$e5c5a5f917a5871c;
var $1c29a66706a62afd$export$1538c33de8887b59;
var $1c29a66706a62afd$export$13e3392192263954;
var $1c29a66706a62afd$export$b8f5890fc79d6aca;
var $1c29a66706a62afd$export$60241385465d0a34;
var $1c29a66706a62afd$export$83d89fbfd8236492;
"use strict";

var $8coUR = parcelRequire("8coUR");
var $1c29a66706a62afd$var$n = "function" === typeof Symbol && Symbol.for, $1c29a66706a62afd$var$p = $1c29a66706a62afd$var$n ? Symbol.for("react.element") : 60103, $1c29a66706a62afd$var$q = $1c29a66706a62afd$var$n ? Symbol.for("react.portal") : 60106, $1c29a66706a62afd$var$r = $1c29a66706a62afd$var$n ? Symbol.for("react.fragment") : 60107, $1c29a66706a62afd$var$t = $1c29a66706a62afd$var$n ? Symbol.for("react.strict_mode") : 60108, $1c29a66706a62afd$var$u = $1c29a66706a62afd$var$n ? Symbol.for("react.profiler") : 60114, $1c29a66706a62afd$var$v = $1c29a66706a62afd$var$n ? Symbol.for("react.provider") : 60109, $1c29a66706a62afd$var$w = $1c29a66706a62afd$var$n ? Symbol.for("react.context") : 60110, $1c29a66706a62afd$var$x = $1c29a66706a62afd$var$n ? Symbol.for("react.forward_ref") : 60112, $1c29a66706a62afd$var$y = $1c29a66706a62afd$var$n ? Symbol.for("react.suspense") : 60113, $1c29a66706a62afd$var$z = $1c29a66706a62afd$var$n ? Symbol.for("react.memo") : 60115, $1c29a66706a62afd$var$A = $1c29a66706a62afd$var$n ? Symbol.for("react.lazy") : 60116, $1c29a66706a62afd$var$B = "function" === typeof Symbol && Symbol.iterator;
function $1c29a66706a62afd$var$C(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $1c29a66706a62afd$var$D = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $1c29a66706a62afd$var$E = {};
function $1c29a66706a62afd$var$F(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$E;
    this.updater = c || $1c29a66706a62afd$var$D;
}
$1c29a66706a62afd$var$F.prototype.isReactComponent = {};
$1c29a66706a62afd$var$F.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error($1c29a66706a62afd$var$C(85));
    this.updater.enqueueSetState(this, a, b, "setState");
};
$1c29a66706a62afd$var$F.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $1c29a66706a62afd$var$G() {}
$1c29a66706a62afd$var$G.prototype = $1c29a66706a62afd$var$F.prototype;
function $1c29a66706a62afd$var$H(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$E;
    this.updater = c || $1c29a66706a62afd$var$D;
}
var $1c29a66706a62afd$var$I = $1c29a66706a62afd$var$H.prototype = new $1c29a66706a62afd$var$G;
$1c29a66706a62afd$var$I.constructor = $1c29a66706a62afd$var$H;
$8coUR($1c29a66706a62afd$var$I, $1c29a66706a62afd$var$F.prototype);
$1c29a66706a62afd$var$I.isPureReactComponent = !0;
var $1c29a66706a62afd$var$J = {
    current: null
}, $1c29a66706a62afd$var$K = Object.prototype.hasOwnProperty, $1c29a66706a62afd$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $1c29a66706a62afd$var$M(a, b, c) {
    var e, d = {}, g = null, k = null;
    if (null != b) for(e in void 0 !== b.ref && (k = b.ref), void 0 !== b.key && (g = "" + b.key), b)$1c29a66706a62afd$var$K.call(b, e) && !$1c29a66706a62afd$var$L.hasOwnProperty(e) && (d[e] = b[e]);
    var f = arguments.length - 2;
    if (1 === f) d.children = c;
    else if (1 < f) {
        for(var h = Array(f), m = 0; m < f; m++)h[m] = arguments[m + 2];
        d.children = h;
    }
    if (a && a.defaultProps) for(e in f = a.defaultProps, f)void 0 === d[e] && (d[e] = f[e]);
    return {
        $$typeof: $1c29a66706a62afd$var$p,
        type: a,
        key: g,
        ref: k,
        props: d,
        _owner: $1c29a66706a62afd$var$J.current
    };
}
function $1c29a66706a62afd$var$N(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$p,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $1c29a66706a62afd$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $1c29a66706a62afd$var$p;
}
function $1c29a66706a62afd$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + ("" + a).replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $1c29a66706a62afd$var$P = /\/+/g, $1c29a66706a62afd$var$Q = [];
function $1c29a66706a62afd$var$R(a, b, c, e) {
    if ($1c29a66706a62afd$var$Q.length) {
        var d = $1c29a66706a62afd$var$Q.pop();
        d.result = a;
        d.keyPrefix = b;
        d.func = c;
        d.context = e;
        d.count = 0;
        return d;
    }
    return {
        result: a,
        keyPrefix: b,
        func: c,
        context: e,
        count: 0
    };
}
function $1c29a66706a62afd$var$S(a) {
    a.result = null;
    a.keyPrefix = null;
    a.func = null;
    a.context = null;
    a.count = 0;
    10 > $1c29a66706a62afd$var$Q.length && $1c29a66706a62afd$var$Q.push(a);
}
function $1c29a66706a62afd$var$T(a, b, c, e) {
    var d = typeof a;
    if ("undefined" === d || "boolean" === d) a = null;
    var g = !1;
    if (null === a) g = !0;
    else switch(d){
        case "string":
        case "number":
            g = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $1c29a66706a62afd$var$p:
                case $1c29a66706a62afd$var$q:
                    g = !0;
            }
    }
    if (g) return c(e, a, "" === b ? "." + $1c29a66706a62afd$var$U(a, 0) : b), 1;
    g = 0;
    b = "" === b ? "." : b + ":";
    if (Array.isArray(a)) for(var k = 0; k < a.length; k++){
        d = a[k];
        var f = b + $1c29a66706a62afd$var$U(d, k);
        g += $1c29a66706a62afd$var$T(d, f, c, e);
    }
    else if (null === a || "object" !== typeof a ? f = null : (f = $1c29a66706a62afd$var$B && a[$1c29a66706a62afd$var$B] || a["@@iterator"], f = "function" === typeof f ? f : null), "function" === typeof f) for(a = f.call(a), k = 0; !(d = a.next()).done;)d = d.value, f = b + $1c29a66706a62afd$var$U(d, k++), g += $1c29a66706a62afd$var$T(d, f, c, e);
    else if ("object" === d) throw c = "" + a, Error($1c29a66706a62afd$var$C(31, "[object Object]" === c ? "object with keys {" + Object.keys(a).join(", ") + "}" : c, ""));
    return g;
}
function $1c29a66706a62afd$var$V(a, b, c) {
    return null == a ? 0 : $1c29a66706a62afd$var$T(a, "", b, c);
}
function $1c29a66706a62afd$var$U(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $1c29a66706a62afd$var$escape(a.key) : b.toString(36);
}
function $1c29a66706a62afd$var$W(a, b) {
    a.func.call(a.context, b, a.count++);
}
function $1c29a66706a62afd$var$aa(a, b, c) {
    var e = a.result, d = a.keyPrefix;
    a = a.func.call(a.context, b, a.count++);
    Array.isArray(a) ? $1c29a66706a62afd$var$X(a, e, c, function(a) {
        return a;
    }) : null != a && ($1c29a66706a62afd$var$O(a) && (a = $1c29a66706a62afd$var$N(a, d + (!a.key || b && b.key === a.key ? "" : ("" + a.key).replace($1c29a66706a62afd$var$P, "$&/") + "/") + c)), e.push(a));
}
function $1c29a66706a62afd$var$X(a, b, c, e, d) {
    var g = "";
    null != c && (g = ("" + c).replace($1c29a66706a62afd$var$P, "$&/") + "/");
    b = $1c29a66706a62afd$var$R(b, g, e, d);
    $1c29a66706a62afd$var$V(a, $1c29a66706a62afd$var$aa, b);
    $1c29a66706a62afd$var$S(b);
}
var $1c29a66706a62afd$var$Y = {
    current: null
};
function $1c29a66706a62afd$var$Z() {
    var a = $1c29a66706a62afd$var$Y.current;
    if (null === a) throw Error($1c29a66706a62afd$var$C(321));
    return a;
}
var $1c29a66706a62afd$var$ba = {
    ReactCurrentDispatcher: $1c29a66706a62afd$var$Y,
    ReactCurrentBatchConfig: {
        suspense: null
    },
    ReactCurrentOwner: $1c29a66706a62afd$var$J,
    IsSomeRendererActing: {
        current: !1
    },
    assign: $8coUR
};
$1c29a66706a62afd$export$dca3b0875bd9a954 = {
    map: function(a, b, c) {
        if (null == a) return a;
        var e = [];
        $1c29a66706a62afd$var$X(a, e, null, b, c);
        return e;
    },
    forEach: function(a, b, c) {
        if (null == a) return a;
        b = $1c29a66706a62afd$var$R(null, null, b, c);
        $1c29a66706a62afd$var$V(a, $1c29a66706a62afd$var$W, b);
        $1c29a66706a62afd$var$S(b);
    },
    count: function(a) {
        return $1c29a66706a62afd$var$V(a, function() {
            return null;
        }, null);
    },
    toArray: function(a) {
        var b = [];
        $1c29a66706a62afd$var$X(a, b, null, function(a) {
            return a;
        });
        return b;
    },
    only: function(a) {
        if (!$1c29a66706a62afd$var$O(a)) throw Error($1c29a66706a62afd$var$C(143));
        return a;
    }
};
$1c29a66706a62afd$export$16fa2f45be04daa8 = $1c29a66706a62afd$var$F;
$1c29a66706a62afd$export$ffb0004e005737fa = $1c29a66706a62afd$var$r;
$1c29a66706a62afd$export$e2c29f18771995cb = $1c29a66706a62afd$var$u;
$1c29a66706a62afd$export$221d75b3f55bb0bd = $1c29a66706a62afd$var$H;
$1c29a66706a62afd$export$5f8d39834fd61797 = $1c29a66706a62afd$var$t;
$1c29a66706a62afd$export$74bf444e3cd11ea5 = $1c29a66706a62afd$var$y;
$1c29a66706a62afd$export$ae55be85d98224ed = $1c29a66706a62afd$var$ba;
$1c29a66706a62afd$export$e530037191fcd5d7 = function(a, b, c) {
    if (null === a || void 0 === a) throw Error($1c29a66706a62afd$var$C(267, a));
    var e = $8coUR({}, a.props), d = a.key, g = a.ref, k = a._owner;
    if (null != b) {
        void 0 !== b.ref && (g = b.ref, k = $1c29a66706a62afd$var$J.current);
        void 0 !== b.key && (d = "" + b.key);
        if (a.type && a.type.defaultProps) var f = a.type.defaultProps;
        for(h in b)$1c29a66706a62afd$var$K.call(b, h) && !$1c29a66706a62afd$var$L.hasOwnProperty(h) && (e[h] = void 0 === b[h] && void 0 !== f ? f[h] : b[h]);
    }
    var h = arguments.length - 2;
    if (1 === h) e.children = c;
    else if (1 < h) {
        f = Array(h);
        for(var m = 0; m < h; m++)f[m] = arguments[m + 2];
        e.children = f;
    }
    return {
        $$typeof: $1c29a66706a62afd$var$p,
        type: a.type,
        key: d,
        ref: g,
        props: e,
        _owner: k
    };
};
$1c29a66706a62afd$export$fd42f52fd3ae1109 = function(a, b) {
    void 0 === b && (b = null);
    a = {
        $$typeof: $1c29a66706a62afd$var$w,
        _calculateChangedBits: b,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    a.Provider = {
        $$typeof: $1c29a66706a62afd$var$v,
        _context: a
    };
    return a.Consumer = a;
};
$1c29a66706a62afd$export$c8a8987d4410bf2d = $1c29a66706a62afd$var$M;
$1c29a66706a62afd$export$d38cd72104c1f0e9 = function(a) {
    var b = $1c29a66706a62afd$var$M.bind(null, a);
    b.type = a;
    return b;
};
$1c29a66706a62afd$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$1c29a66706a62afd$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$x,
        render: a
    };
};
$1c29a66706a62afd$export$a8257692ac88316c = $1c29a66706a62afd$var$O;
$1c29a66706a62afd$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$A,
        _ctor: a,
        _status: -1,
        _result: null
    };
};
$1c29a66706a62afd$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$z,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$1c29a66706a62afd$export$35808ee640e87ca7 = function(a, b) {
    return $1c29a66706a62afd$var$Z().useCallback(a, b);
};
$1c29a66706a62afd$export$fae74005e78b1a27 = function(a, b) {
    return $1c29a66706a62afd$var$Z().useContext(a, b);
};
$1c29a66706a62afd$export$dc8fbce3eb94dc1e = function() {};
$1c29a66706a62afd$export$6d9c69b0de29b591 = function(a, b) {
    return $1c29a66706a62afd$var$Z().useEffect(a, b);
};
$1c29a66706a62afd$export$d5a552a76deda3c2 = function(a, b, c) {
    return $1c29a66706a62afd$var$Z().useImperativeHandle(a, b, c);
};
$1c29a66706a62afd$export$e5c5a5f917a5871c = function(a, b) {
    return $1c29a66706a62afd$var$Z().useLayoutEffect(a, b);
};
$1c29a66706a62afd$export$1538c33de8887b59 = function(a, b) {
    return $1c29a66706a62afd$var$Z().useMemo(a, b);
};
$1c29a66706a62afd$export$13e3392192263954 = function(a, b, c) {
    return $1c29a66706a62afd$var$Z().useReducer(a, b, c);
};
$1c29a66706a62afd$export$b8f5890fc79d6aca = function(a) {
    return $1c29a66706a62afd$var$Z().useRef(a);
};
$1c29a66706a62afd$export$60241385465d0a34 = function(a) {
    return $1c29a66706a62afd$var$Z().useState(a);
};
$1c29a66706a62afd$export$83d89fbfd8236492 = "16.14.0";

});
parcelRegister("8coUR", function(module, exports) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ "use strict";
/* eslint-disable no-unused-vars */ var $5f82c58e3d599bd6$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $5f82c58e3d599bd6$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $5f82c58e3d599bd6$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $5f82c58e3d599bd6$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(val);
}
function $5f82c58e3d599bd6$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String("abc"); // eslint-disable-line no-new-wrappers
        test1[5] = "de";
        if (Object.getOwnPropertyNames(test1)[0] === "5") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2["_" + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join("") !== "0123456789") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        "abcdefghijklmnopqrst".split("").forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = $5f82c58e3d599bd6$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $5f82c58e3d599bd6$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($5f82c58e3d599bd6$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($5f82c58e3d599bd6$var$getOwnPropertySymbols) {
            symbols = $5f82c58e3d599bd6$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($5f82c58e3d599bd6$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

});



parcelRegister("1u0KT", function(module, exports) {
"use strict";
function $11492dca620dcaa5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($11492dca620dcaa5$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$11492dca620dcaa5$var$checkDCE();

module.exports = (parcelRequire("Xw6Mv"));

});
parcelRegister("Xw6Mv", function(module, exports) {
/** @license React v16.14.0
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ "use strict";

var $acw62 = parcelRequire("acw62");

var $8coUR = parcelRequire("8coUR");

var $fO90s = parcelRequire("fO90s");
function u(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
if (!$acw62) throw Error(u(227));
function ba(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var da = !1, ea = null, fa = !1, ha = null, ia = {
    onError: function(a) {
        da = !0;
        ea = a;
    }
};
function ja(a, b, c, d, e, f, g, h, k) {
    da = !1;
    ea = null;
    ba.apply(ia, arguments);
}
function ka(a, b, c, d, e, f, g, h, k) {
    ja.apply(this, arguments);
    if (da) {
        if (da) {
            var l = ea;
            da = !1;
            ea = null;
        } else throw Error(u(198));
        fa || (fa = !0, ha = l);
    }
}
var la = null, ma = null, na = null;
function oa(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = na(c);
    ka(d, b, void 0, a);
    a.currentTarget = null;
}
var pa = null, qa = {};
function ra() {
    if (pa) for(var a in qa){
        var b = qa[a], c = pa.indexOf(a);
        if (!(-1 < c)) throw Error(u(96, a));
        if (!sa[c]) {
            if (!b.extractEvents) throw Error(u(97, a));
            sa[c] = b;
            c = b.eventTypes;
            for(var d in c){
                var e = void 0;
                var f = c[d], g = b, h = d;
                if (ta.hasOwnProperty(h)) throw Error(u(99, h));
                ta[h] = f;
                var k = f.phasedRegistrationNames;
                if (k) {
                    for(e in k)k.hasOwnProperty(e) && ua(k[e], g, h);
                    e = !0;
                } else f.registrationName ? (ua(f.registrationName, g, h), e = !0) : e = !1;
                if (!e) throw Error(u(98, d, a));
            }
        }
    }
}
function ua(a, b, c) {
    if (va[a]) throw Error(u(100, a));
    va[a] = b;
    wa[a] = b.eventTypes[c].dependencies;
}
var sa = [], ta = {}, va = {}, wa = {};
function xa(a) {
    var b = !1, c;
    for(c in a)if (a.hasOwnProperty(c)) {
        var d = a[c];
        if (!qa.hasOwnProperty(c) || qa[c] !== d) {
            if (qa[c]) throw Error(u(102, c));
            qa[c] = d;
            b = !0;
        }
    }
    b && ra();
}
var ya = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), za = null, Aa = null, Ba = null;
function Ca(a) {
    if (a = ma(a)) {
        if ("function" !== typeof za) throw Error(u(280));
        var b = a.stateNode;
        b && (b = la(b), za(a.stateNode, a.type, b));
    }
}
function Da(a) {
    Aa ? Ba ? Ba.push(a) : Ba = [
        a
    ] : Aa = a;
}
function Ea() {
    if (Aa) {
        var a = Aa, b = Ba;
        Ba = Aa = null;
        Ca(a);
        if (b) for(a = 0; a < b.length; a++)Ca(b[a]);
    }
}
function Fa(a, b) {
    return a(b);
}
function Ga(a, b, c, d, e) {
    return a(b, c, d, e);
}
function Ha() {}
var Ia = Fa, Ja = !1, Ka = !1;
function La() {
    if (null !== Aa || null !== Ba) Ha(), Ea();
}
function Ma(a, b, c) {
    if (Ka) return a(b, c);
    Ka = !0;
    try {
        return Ia(a, b, c);
    } finally{
        Ka = !1, La();
    }
}
var Na = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, Oa = Object.prototype.hasOwnProperty, Pa = {}, Qa = {};
function Ra(a) {
    if (Oa.call(Qa, a)) return !0;
    if (Oa.call(Pa, a)) return !1;
    if (Na.test(a)) return Qa[a] = !0;
    Pa[a] = !0;
    return !1;
}
function Sa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function Ta(a, b, c, d) {
    if (null === b || "undefined" === typeof b || Sa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function v(a, b, c, d, e, f) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
}
var C = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    C[a] = new v(a, 0, !1, a, null, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    C[b] = new v(b, 1, !1, a[1], null, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    C[a] = new v(a, 2, !1, a.toLowerCase(), null, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    C[a] = new v(a, 2, !1, a, null, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    C[a] = new v(a, 3, !1, a.toLowerCase(), null, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    C[a] = new v(a, 3, !0, a, null, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    C[a] = new v(a, 4, !1, a, null, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    C[a] = new v(a, 6, !1, a, null, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    C[a] = new v(a, 5, !1, a.toLowerCase(), null, !1);
});
var Ua = /[\-:]([a-z])/g;
function Va(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace(Ua, Va);
    C[b] = new v(b, 1, !1, a, null, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace(Ua, Va);
    C[b] = new v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace(Ua, Va);
    C[b] = new v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    C[a] = new v(a, 1, !1, a.toLowerCase(), null, !1);
});
C.xlinkHref = new v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    C[a] = new v(a, 1, !1, a.toLowerCase(), null, !0);
});
var Wa = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
Wa.hasOwnProperty("ReactCurrentDispatcher") || (Wa.ReactCurrentDispatcher = {
    current: null
});
Wa.hasOwnProperty("ReactCurrentBatchConfig") || (Wa.ReactCurrentBatchConfig = {
    suspense: null
});
function Xa(a, b, c, d) {
    var e = C.hasOwnProperty(b) ? C[b] : null;
    var f = null !== e ? 0 === e.type : d ? !1 : !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1] ? !1 : !0;
    f || (Ta(b, c, e, d) && (c = null), d || null === e ? Ra(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c))));
}
var Ya = /^(.*)[\\\/]/, E = "function" === typeof Symbol && Symbol.for, Za = E ? Symbol.for("react.element") : 60103, $a = E ? Symbol.for("react.portal") : 60106, ab = E ? Symbol.for("react.fragment") : 60107, bb = E ? Symbol.for("react.strict_mode") : 60108, cb = E ? Symbol.for("react.profiler") : 60114, db = E ? Symbol.for("react.provider") : 60109, eb = E ? Symbol.for("react.context") : 60110, fb = E ? Symbol.for("react.concurrent_mode") : 60111, gb = E ? Symbol.for("react.forward_ref") : 60112, hb = E ? Symbol.for("react.suspense") : 60113, ib = E ? Symbol.for("react.suspense_list") : 60120, jb = E ? Symbol.for("react.memo") : 60115, kb = E ? Symbol.for("react.lazy") : 60116, lb = E ? Symbol.for("react.block") : 60121, mb = "function" === typeof Symbol && Symbol.iterator;
function nb(a) {
    if (null === a || "object" !== typeof a) return null;
    a = mb && a[mb] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
function ob(a) {
    if (-1 === a._status) {
        a._status = 0;
        var b = a._ctor;
        b = b();
        a._result = b;
        b.then(function(b) {
            0 === a._status && (b = b.default, a._status = 1, a._result = b);
        }, function(b) {
            0 === a._status && (a._status = 2, a._result = b);
        });
    }
}
function pb(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case ab:
            return "Fragment";
        case $a:
            return "Portal";
        case cb:
            return "Profiler";
        case bb:
            return "StrictMode";
        case hb:
            return "Suspense";
        case ib:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case eb:
            return "Context.Consumer";
        case db:
            return "Context.Provider";
        case gb:
            var b = a.render;
            b = b.displayName || b.name || "";
            return a.displayName || ("" !== b ? "ForwardRef(" + b + ")" : "ForwardRef");
        case jb:
            return pb(a.type);
        case lb:
            return pb(a.render);
        case kb:
            if (a = 1 === a._status ? a._result : null) return pb(a);
    }
    return null;
}
function qb(a) {
    var b = "";
    do {
        a: switch(a.tag){
            case 3:
            case 4:
            case 6:
            case 7:
            case 10:
            case 9:
                var c = "";
                break a;
            default:
                var d = a._debugOwner, e = a._debugSource, f = pb(a.type);
                c = null;
                d && (c = pb(d.type));
                d = f;
                f = "";
                e ? f = " (at " + e.fileName.replace(Ya, "") + ":" + e.lineNumber + ")" : c && (f = " (created by " + c + ")");
                c = "\n    in " + (d || "Unknown") + f;
        }
        b += c;
        a = a.return;
    }while (a);
    return b;
}
function rb(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "object":
        case "string":
        case "undefined":
            return a;
        default:
            return "";
    }
}
function sb(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function tb(a) {
    var b = sb(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function xb(a) {
    a._valueTracker || (a._valueTracker = tb(a));
}
function yb(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = sb(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function zb(a, b) {
    var c = b.checked;
    return $8coUR({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function Ab(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = rb(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function Bb(a, b) {
    b = b.checked;
    null != b && Xa(a, "checked", b, !1);
}
function Cb(a, b) {
    Bb(a, b);
    var c = rb(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? Db(a, b.type, c) : b.hasOwnProperty("defaultValue") && Db(a, b.type, rb(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function Eb(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function Db(a, b, c) {
    if ("number" !== b || a.ownerDocument.activeElement !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
function Fb(a) {
    var b = "";
    $acw62.Children.forEach(a, function(a) {
        null != a && (b += a);
    });
    return b;
}
function Gb(a, b) {
    a = $8coUR({
        children: void 0
    }, b);
    if (b = Fb(b.children)) a.children = b;
    return a;
}
function Hb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + rb(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function Ib(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error(u(91));
    return $8coUR({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function Jb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error(u(92));
            if (Array.isArray(c)) {
                if (!(1 >= c.length)) throw Error(u(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: rb(c)
    };
}
function Kb(a, b) {
    var c = rb(b.value), d = rb(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function Lb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
var Mb = {
    html: "http://www.w3.org/1999/xhtml",
    mathml: "http://www.w3.org/1998/Math/MathML",
    svg: "http://www.w3.org/2000/svg"
};
function Nb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function Ob(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? Nb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var Pb, Qb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if (a.namespaceURI !== Mb.svg || "innerHTML" in a) a.innerHTML = b;
    else {
        Pb = Pb || document.createElement("div");
        Pb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = Pb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function Rb(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
function Sb(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var Tb = {
    animationend: Sb("Animation", "AnimationEnd"),
    animationiteration: Sb("Animation", "AnimationIteration"),
    animationstart: Sb("Animation", "AnimationStart"),
    transitionend: Sb("Transition", "TransitionEnd")
}, Ub = {}, Vb = {};
ya && (Vb = document.createElement("div").style, "AnimationEvent" in window || (delete Tb.animationend.animation, delete Tb.animationiteration.animation, delete Tb.animationstart.animation), "TransitionEvent" in window || delete Tb.transitionend.transition);
function Wb(a) {
    if (Ub[a]) return Ub[a];
    if (!Tb[a]) return a;
    var b = Tb[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in Vb) return Ub[a] = b[c];
    return a;
}
var Xb = Wb("animationend"), Yb = Wb("animationiteration"), Zb = Wb("animationstart"), $b = Wb("transitionend"), ac = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), bc = new ("function" === typeof WeakMap ? WeakMap : Map);
function cc(a) {
    var b = bc.get(a);
    void 0 === b && (b = new Map, bc.set(a, b));
    return b;
}
function dc(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.effectTag & 1026) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function ec(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function fc(a) {
    if (dc(a) !== a) throw Error(u(188));
}
function gc(a) {
    var b = a.alternate;
    if (!b) {
        b = dc(a);
        if (null === b) throw Error(u(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return fc(e), a;
                if (f === d) return fc(e), b;
                f = f.sibling;
            }
            throw Error(u(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error(u(189));
            }
        }
        if (c.alternate !== d) throw Error(u(190));
    }
    if (3 !== c.tag) throw Error(u(188));
    return c.stateNode.current === c ? a : b;
}
function hc(a) {
    a = gc(a);
    if (!a) return null;
    for(var b = a;;){
        if (5 === b.tag || 6 === b.tag) return b;
        if (b.child) b.child.return = b, b = b.child;
        else {
            if (b === a) break;
            for(; !b.sibling;){
                if (!b.return || b.return === a) return null;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return null;
}
function ic(a, b) {
    if (null == b) throw Error(u(30));
    if (null == a) return b;
    if (Array.isArray(a)) {
        if (Array.isArray(b)) return a.push.apply(a, b), a;
        a.push(b);
        return a;
    }
    return Array.isArray(b) ? [
        a
    ].concat(b) : [
        a,
        b
    ];
}
function jc(a, b, c) {
    Array.isArray(a) ? a.forEach(b, c) : a && b.call(c, a);
}
var kc = null;
function lc(a) {
    if (a) {
        var b = a._dispatchListeners, c = a._dispatchInstances;
        if (Array.isArray(b)) for(var d = 0; d < b.length && !a.isPropagationStopped(); d++)oa(a, b[d], c[d]);
        else b && oa(a, b, c);
        a._dispatchListeners = null;
        a._dispatchInstances = null;
        a.isPersistent() || a.constructor.release(a);
    }
}
function mc(a) {
    null !== a && (kc = ic(kc, a));
    a = kc;
    kc = null;
    if (a) {
        jc(a, lc);
        if (kc) throw Error(u(95));
        if (fa) throw a = ha, fa = !1, ha = null, a;
    }
}
function nc(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
function oc(a) {
    if (!ya) return !1;
    a = "on" + a;
    var b = a in document;
    b || (b = document.createElement("div"), b.setAttribute(a, "return;"), b = "function" === typeof b[a]);
    return b;
}
var pc = [];
function qc(a) {
    a.topLevelType = null;
    a.nativeEvent = null;
    a.targetInst = null;
    a.ancestors.length = 0;
    10 > pc.length && pc.push(a);
}
function rc(a, b, c, d) {
    if (pc.length) {
        var e = pc.pop();
        e.topLevelType = a;
        e.eventSystemFlags = d;
        e.nativeEvent = b;
        e.targetInst = c;
        return e;
    }
    return {
        topLevelType: a,
        eventSystemFlags: d,
        nativeEvent: b,
        targetInst: c,
        ancestors: []
    };
}
function sc(a) {
    var b = a.targetInst, c = b;
    do {
        if (!c) {
            a.ancestors.push(c);
            break;
        }
        var d = c;
        if (3 === d.tag) d = d.stateNode.containerInfo;
        else {
            for(; d.return;)d = d.return;
            d = 3 !== d.tag ? null : d.stateNode.containerInfo;
        }
        if (!d) break;
        b = c.tag;
        5 !== b && 6 !== b || a.ancestors.push(c);
        c = tc(d);
    }while (c);
    for(c = 0; c < a.ancestors.length; c++){
        b = a.ancestors[c];
        var e = nc(a.nativeEvent);
        d = a.topLevelType;
        var f = a.nativeEvent, g = a.eventSystemFlags;
        0 === c && (g |= 64);
        for(var h = null, k = 0; k < sa.length; k++){
            var l = sa[k];
            l && (l = l.extractEvents(d, b, f, e, g)) && (h = ic(h, l));
        }
        mc(h);
    }
}
function uc(a, b, c) {
    if (!c.has(a)) {
        switch(a){
            case "scroll":
                vc(b, "scroll", !0);
                break;
            case "focus":
            case "blur":
                vc(b, "focus", !0);
                vc(b, "blur", !0);
                c.set("blur", null);
                c.set("focus", null);
                break;
            case "cancel":
            case "close":
                oc(a) && vc(b, a, !0);
                break;
            case "invalid":
            case "submit":
            case "reset":
                break;
            default:
                -1 === ac.indexOf(a) && F(a, b);
        }
        c.set(a, null);
    }
}
var wc, xc, yc, zc = !1, Ac = [], Bc = null, Cc = null, Dc = null, Ec = new Map, Fc = new Map, Gc = [], Hc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput close cancel copy cut paste click change contextmenu reset submit".split(" "), Ic = "focus blur dragenter dragleave mouseover mouseout pointerover pointerout gotpointercapture lostpointercapture".split(" ");
function Jc(a, b) {
    var c = cc(b);
    Hc.forEach(function(a) {
        uc(a, b, c);
    });
    Ic.forEach(function(a) {
        uc(a, b, c);
    });
}
function Kc(a, b, c, d, e) {
    return {
        blockedOn: a,
        topLevelType: b,
        eventSystemFlags: c | 32,
        nativeEvent: e,
        container: d
    };
}
function Lc(a, b) {
    switch(a){
        case "focus":
        case "blur":
            Bc = null;
            break;
        case "dragenter":
        case "dragleave":
            Cc = null;
            break;
        case "mouseover":
        case "mouseout":
            Dc = null;
            break;
        case "pointerover":
        case "pointerout":
            Ec.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            Fc.delete(b.pointerId);
    }
}
function Mc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = Kc(b, c, d, e, f), null !== b && (b = Nc(b), null !== b && xc(b)), a;
    a.eventSystemFlags |= d;
    return a;
}
function Oc(a, b, c, d, e) {
    switch(b){
        case "focus":
            return Bc = Mc(Bc, a, b, c, d, e), !0;
        case "dragenter":
            return Cc = Mc(Cc, a, b, c, d, e), !0;
        case "mouseover":
            return Dc = Mc(Dc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            Ec.set(f, Mc(Ec.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, Fc.set(f, Mc(Fc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function Pc(a) {
    var b = tc(a.target);
    if (null !== b) {
        var c = dc(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = ec(c), null !== b) {
                    a.blockedOn = b;
                    $fO90s.unstable_runWithPriority(a.priority, function() {
                        yc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.hydrate) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function Qc(a) {
    if (null !== a.blockedOn) return !1;
    var b = Rc(a.topLevelType, a.eventSystemFlags, a.container, a.nativeEvent);
    if (null !== b) {
        var c = Nc(b);
        null !== c && xc(c);
        a.blockedOn = b;
        return !1;
    }
    return !0;
}
function Sc(a, b, c) {
    Qc(a) && c.delete(b);
}
function Tc() {
    for(zc = !1; 0 < Ac.length;){
        var a = Ac[0];
        if (null !== a.blockedOn) {
            a = Nc(a.blockedOn);
            null !== a && wc(a);
            break;
        }
        var b = Rc(a.topLevelType, a.eventSystemFlags, a.container, a.nativeEvent);
        null !== b ? a.blockedOn = b : Ac.shift();
    }
    null !== Bc && Qc(Bc) && (Bc = null);
    null !== Cc && Qc(Cc) && (Cc = null);
    null !== Dc && Qc(Dc) && (Dc = null);
    Ec.forEach(Sc);
    Fc.forEach(Sc);
}
function Uc(a, b) {
    a.blockedOn === b && (a.blockedOn = null, zc || (zc = !0, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, Tc)));
}
function Vc(a) {
    function b(b) {
        return Uc(b, a);
    }
    if (0 < Ac.length) {
        Uc(Ac[0], a);
        for(var c = 1; c < Ac.length; c++){
            var d = Ac[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== Bc && Uc(Bc, a);
    null !== Cc && Uc(Cc, a);
    null !== Dc && Uc(Dc, a);
    Ec.forEach(b);
    Fc.forEach(b);
    for(c = 0; c < Gc.length; c++)d = Gc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < Gc.length && (c = Gc[0], null === c.blockedOn);)Pc(c), null === c.blockedOn && Gc.shift();
}
var Wc = {}, Yc = new Map, Zc = new Map, $c = [
    "abort",
    "abort",
    Xb,
    "animationEnd",
    Yb,
    "animationIteration",
    Zb,
    "animationStart",
    "canplay",
    "canPlay",
    "canplaythrough",
    "canPlayThrough",
    "durationchange",
    "durationChange",
    "emptied",
    "emptied",
    "encrypted",
    "encrypted",
    "ended",
    "ended",
    "error",
    "error",
    "gotpointercapture",
    "gotPointerCapture",
    "load",
    "load",
    "loadeddata",
    "loadedData",
    "loadedmetadata",
    "loadedMetadata",
    "loadstart",
    "loadStart",
    "lostpointercapture",
    "lostPointerCapture",
    "playing",
    "playing",
    "progress",
    "progress",
    "seeking",
    "seeking",
    "stalled",
    "stalled",
    "suspend",
    "suspend",
    "timeupdate",
    "timeUpdate",
    $b,
    "transitionEnd",
    "waiting",
    "waiting"
];
function ad(a, b) {
    for(var c = 0; c < a.length; c += 2){
        var d = a[c], e = a[c + 1], f = "on" + (e[0].toUpperCase() + e.slice(1));
        f = {
            phasedRegistrationNames: {
                bubbled: f,
                captured: f + "Capture"
            },
            dependencies: [
                d
            ],
            eventPriority: b
        };
        Zc.set(d, b);
        Yc.set(d, f);
        Wc[e] = f;
    }
}
ad("blur blur cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focus focus input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "), 0);
ad("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "), 1);
ad($c, 2);
for(var bd = "change selectionchange textInput compositionstart compositionend compositionupdate".split(" "), cd = 0; cd < bd.length; cd++)Zc.set(bd[cd], 0);
var dd = $fO90s.unstable_UserBlockingPriority, ed = $fO90s.unstable_runWithPriority, fd = !0;
function F(a, b) {
    vc(b, a, !1);
}
function vc(a, b, c) {
    var d = Zc.get(b);
    switch(void 0 === d ? 2 : d){
        case 0:
            d = gd.bind(null, b, 1, a);
            break;
        case 1:
            d = hd.bind(null, b, 1, a);
            break;
        default:
            d = id.bind(null, b, 1, a);
    }
    c ? a.addEventListener(b, d, !0) : a.addEventListener(b, d, !1);
}
function gd(a, b, c, d) {
    Ja || Ha();
    var e = id, f = Ja;
    Ja = !0;
    try {
        Ga(e, a, b, c, d);
    } finally{
        (Ja = f) || La();
    }
}
function hd(a, b, c, d) {
    ed(dd, id.bind(null, a, b, c, d));
}
function id(a, b, c, d) {
    if (fd) {
        if (0 < Ac.length && -1 < Hc.indexOf(a)) a = Kc(null, a, b, c, d), Ac.push(a);
        else {
            var e = Rc(a, b, c, d);
            if (null === e) Lc(a, d);
            else if (-1 < Hc.indexOf(a)) a = Kc(e, a, b, c, d), Ac.push(a);
            else if (!Oc(e, a, b, c, d)) {
                Lc(a, d);
                a = rc(a, d, null, b);
                try {
                    Ma(sc, a);
                } finally{
                    qc(a);
                }
            }
        }
    }
}
function Rc(a, b, c, d) {
    c = nc(d);
    c = tc(c);
    if (null !== c) {
        var e = dc(c);
        if (null === e) c = null;
        else {
            var f = e.tag;
            if (13 === f) {
                c = ec(e);
                if (null !== c) return c;
                c = null;
            } else if (3 === f) {
                if (e.stateNode.hydrate) return 3 === e.tag ? e.stateNode.containerInfo : null;
                c = null;
            } else e !== c && (c = null);
        }
    }
    a = rc(a, d, c, b);
    try {
        Ma(sc, a);
    } finally{
        qc(a);
    }
    return null;
}
var jd = {
    animationIterationCount: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, kd = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys(jd).forEach(function(a) {
    kd.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        jd[b] = jd[a];
    });
});
function ld(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || jd.hasOwnProperty(a) && jd[a] ? ("" + b).trim() : b + "px";
}
function md(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = ld(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var nd = $8coUR({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function od(a, b) {
    if (b) {
        if (nd[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error(u(137, a, ""));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error(u(60));
            if (!("object" === typeof b.dangerouslySetInnerHTML && "__html" in b.dangerouslySetInnerHTML)) throw Error(u(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error(u(62, ""));
    }
}
function pd(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var qd = Mb.html;
function rd(a, b) {
    a = 9 === a.nodeType || 11 === a.nodeType ? a : a.ownerDocument;
    var c = cc(a);
    b = wa[b];
    for(var d = 0; d < b.length; d++)uc(b[d], a, c);
}
function sd() {}
function td(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function ud(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function vd(a, b) {
    var c = ud(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = ud(c);
    }
}
function wd(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? wd(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function xd() {
    for(var a = window, b = td(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = td(a.document);
    }
    return b;
}
function yd(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
var zd = "$", Ad = "/$", Bd = "$?", Cd = "$!", Dd = null, Ed = null;
function Fd(a, b) {
    switch(a){
        case "button":
        case "input":
        case "select":
        case "textarea":
            return !!b.autoFocus;
    }
    return !1;
}
function Gd(a, b) {
    return "textarea" === a || "option" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var Hd = "function" === typeof setTimeout ? setTimeout : void 0, Id = "function" === typeof clearTimeout ? clearTimeout : void 0;
function Jd(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
    }
    return a;
}
function Kd(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if (c === zd || c === Cd || c === Bd) {
                if (0 === b) return a;
                b--;
            } else c === Ad && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var Ld = Math.random().toString(36).slice(2), Md = "__reactInternalInstance$" + Ld, Nd = "__reactEventHandlers$" + Ld, Od = "__reactContainere$" + Ld;
function tc(a) {
    var b = a[Md];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[Od] || c[Md]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = Kd(a); null !== a;){
                if (c = a[Md]) return c;
                a = Kd(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function Nc(a) {
    a = a[Md] || a[Od];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function Pd(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error(u(33));
}
function Qd(a) {
    return a[Nd] || null;
}
function Rd(a) {
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function Sd(a, b) {
    var c = a.stateNode;
    if (!c) return null;
    var d = la(c);
    if (!d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error(u(231, b, typeof c));
    return c;
}
function Td(a, b, c) {
    if (b = Sd(a, c.dispatchConfig.phasedRegistrationNames[b])) c._dispatchListeners = ic(c._dispatchListeners, b), c._dispatchInstances = ic(c._dispatchInstances, a);
}
function Ud(a) {
    if (a && a.dispatchConfig.phasedRegistrationNames) {
        for(var b = a._targetInst, c = []; b;)c.push(b), b = Rd(b);
        for(b = c.length; 0 < b--;)Td(c[b], "captured", a);
        for(b = 0; b < c.length; b++)Td(c[b], "bubbled", a);
    }
}
function Vd(a, b, c) {
    a && c && c.dispatchConfig.registrationName && (b = Sd(a, c.dispatchConfig.registrationName)) && (c._dispatchListeners = ic(c._dispatchListeners, b), c._dispatchInstances = ic(c._dispatchInstances, a));
}
function Wd(a) {
    a && a.dispatchConfig.registrationName && Vd(a._targetInst, null, a);
}
function Xd(a) {
    jc(a, Ud);
}
var Yd = null, Zd = null, $d = null;
function ae() {
    if ($d) return $d;
    var a, b = Zd, c = b.length, d, e = "value" in Yd ? Yd.value : Yd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $d = e.slice(a, 1 < d ? 1 - d : void 0);
}
function be() {
    return !0;
}
function ce() {
    return !1;
}
function G(a, b, c, d) {
    this.dispatchConfig = a;
    this._targetInst = b;
    this.nativeEvent = c;
    a = this.constructor.Interface;
    for(var e in a)a.hasOwnProperty(e) && ((b = a[e]) ? this[e] = b(c) : "target" === e ? this.target = d : this[e] = c[e]);
    this.isDefaultPrevented = (null != c.defaultPrevented ? c.defaultPrevented : !1 === c.returnValue) ? be : ce;
    this.isPropagationStopped = ce;
    return this;
}
$8coUR(G.prototype, {
    preventDefault: function() {
        this.defaultPrevented = !0;
        var a = this.nativeEvent;
        a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = be);
    },
    stopPropagation: function() {
        var a = this.nativeEvent;
        a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = be);
    },
    persist: function() {
        this.isPersistent = be;
    },
    isPersistent: ce,
    destructor: function() {
        var a = this.constructor.Interface, b;
        for(b in a)this[b] = null;
        this.nativeEvent = this._targetInst = this.dispatchConfig = null;
        this.isPropagationStopped = this.isDefaultPrevented = ce;
        this._dispatchInstances = this._dispatchListeners = null;
    }
});
G.Interface = {
    type: null,
    target: null,
    currentTarget: function() {
        return null;
    },
    eventPhase: null,
    bubbles: null,
    cancelable: null,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: null,
    isTrusted: null
};
G.extend = function(a) {
    function b() {}
    function c() {
        return d.apply(this, arguments);
    }
    var d = this;
    b.prototype = d.prototype;
    var e = new b;
    $8coUR(e, c.prototype);
    c.prototype = e;
    c.prototype.constructor = c;
    c.Interface = $8coUR({}, d.Interface, a);
    c.extend = d.extend;
    de(c);
    return c;
};
de(G);
function ee(a, b, c, d) {
    if (this.eventPool.length) {
        var e = this.eventPool.pop();
        this.call(e, a, b, c, d);
        return e;
    }
    return new this(a, b, c, d);
}
function fe(a) {
    if (!(a instanceof this)) throw Error(u(279));
    a.destructor();
    10 > this.eventPool.length && this.eventPool.push(a);
}
function de(a) {
    a.eventPool = [];
    a.getPooled = ee;
    a.release = fe;
}
var ge = G.extend({
    data: null
}), he = G.extend({
    data: null
}), ie = [
    9,
    13,
    27,
    32
], je = ya && "CompositionEvent" in window, ke = null;
ya && "documentMode" in document && (ke = document.documentMode);
var le = ya && "TextEvent" in window && !ke, me = ya && (!je || ke && 8 < ke && 11 >= ke), ne = String.fromCharCode(32), oe = {
    beforeInput: {
        phasedRegistrationNames: {
            bubbled: "onBeforeInput",
            captured: "onBeforeInputCapture"
        },
        dependencies: [
            "compositionend",
            "keypress",
            "textInput",
            "paste"
        ]
    },
    compositionEnd: {
        phasedRegistrationNames: {
            bubbled: "onCompositionEnd",
            captured: "onCompositionEndCapture"
        },
        dependencies: "blur compositionend keydown keypress keyup mousedown".split(" ")
    },
    compositionStart: {
        phasedRegistrationNames: {
            bubbled: "onCompositionStart",
            captured: "onCompositionStartCapture"
        },
        dependencies: "blur compositionstart keydown keypress keyup mousedown".split(" ")
    },
    compositionUpdate: {
        phasedRegistrationNames: {
            bubbled: "onCompositionUpdate",
            captured: "onCompositionUpdateCapture"
        },
        dependencies: "blur compositionupdate keydown keypress keyup mousedown".split(" ")
    }
}, pe = !1;
function qe(a, b) {
    switch(a){
        case "keyup":
            return -1 !== ie.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "blur":
            return !0;
        default:
            return !1;
    }
}
function re(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var se = !1;
function te(a, b) {
    switch(a){
        case "compositionend":
            return re(b);
        case "keypress":
            if (32 !== b.which) return null;
            pe = !0;
            return ne;
        case "textInput":
            return a = b.data, a === ne && pe ? null : a;
        default:
            return null;
    }
}
function ue(a, b) {
    if (se) return "compositionend" === a || !je && qe(a, b) ? (a = ae(), $d = Zd = Yd = null, se = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return me && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var ve = {
    eventTypes: oe,
    extractEvents: function(a, b, c, d) {
        var e;
        if (je) b: {
            switch(a){
                case "compositionstart":
                    var f = oe.compositionStart;
                    break b;
                case "compositionend":
                    f = oe.compositionEnd;
                    break b;
                case "compositionupdate":
                    f = oe.compositionUpdate;
                    break b;
            }
            f = void 0;
        }
        else se ? qe(a, c) && (f = oe.compositionEnd) : "keydown" === a && 229 === c.keyCode && (f = oe.compositionStart);
        f ? (me && "ko" !== c.locale && (se || f !== oe.compositionStart ? f === oe.compositionEnd && se && (e = ae()) : (Yd = d, Zd = "value" in Yd ? Yd.value : Yd.textContent, se = !0)), f = ge.getPooled(f, b, c, d), e ? f.data = e : (e = re(c), null !== e && (f.data = e)), Xd(f), e = f) : e = null;
        (a = le ? te(a, c) : ue(a, c)) ? (b = he.getPooled(oe.beforeInput, b, c, d), b.data = a, Xd(b)) : b = null;
        return null === e ? b : null === b ? e : [
            e,
            b
        ];
    }
}, we = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function xe(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!we[a.type] : "textarea" === b ? !0 : !1;
}
var ye = {
    change: {
        phasedRegistrationNames: {
            bubbled: "onChange",
            captured: "onChangeCapture"
        },
        dependencies: "blur change click focus input keydown keyup selectionchange".split(" ")
    }
};
function ze(a, b, c) {
    a = G.getPooled(ye.change, a, b, c);
    a.type = "change";
    Da(c);
    Xd(a);
    return a;
}
var Ae = null, Be = null;
function Ce(a) {
    mc(a);
}
function De(a) {
    var b = Pd(a);
    if (yb(b)) return a;
}
function Ee(a, b) {
    if ("change" === a) return b;
}
var Fe = !1;
ya && (Fe = oc("input") && (!document.documentMode || 9 < document.documentMode));
function Ge() {
    Ae && (Ae.detachEvent("onpropertychange", He), Be = Ae = null);
}
function He(a) {
    if ("value" === a.propertyName && De(Be)) {
        if (a = ze(Be, a, nc(a)), Ja) mc(a);
        else {
            Ja = !0;
            try {
                Fa(Ce, a);
            } finally{
                Ja = !1, La();
            }
        }
    }
}
function Ie(a, b, c) {
    "focus" === a ? (Ge(), Ae = b, Be = c, Ae.attachEvent("onpropertychange", He)) : "blur" === a && Ge();
}
function Je(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return De(Be);
}
function Ke(a, b) {
    if ("click" === a) return De(b);
}
function Le(a, b) {
    if ("input" === a || "change" === a) return De(b);
}
var Me = {
    eventTypes: ye,
    _isInputEventSupported: Fe,
    extractEvents: function(a, b, c, d) {
        var e = b ? Pd(b) : window, f = e.nodeName && e.nodeName.toLowerCase();
        if ("select" === f || "input" === f && "file" === e.type) var g = Ee;
        else if (xe(e)) {
            if (Fe) g = Le;
            else {
                g = Je;
                var h = Ie;
            }
        } else (f = e.nodeName) && "input" === f.toLowerCase() && ("checkbox" === e.type || "radio" === e.type) && (g = Ke);
        if (g && (g = g(a, b))) return ze(g, c, d);
        h && h(a, e, b);
        "blur" === a && (a = e._wrapperState) && a.controlled && "number" === e.type && Db(e, "number", e.value);
    }
}, Ne = G.extend({
    view: null,
    detail: null
}), Oe = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function Pe(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = Oe[a]) ? !!b[a] : !1;
}
function Qe() {
    return Pe;
}
var Re = 0, Se = 0, Te = !1, Ue = !1, Ve = Ne.extend({
    screenX: null,
    screenY: null,
    clientX: null,
    clientY: null,
    pageX: null,
    pageY: null,
    ctrlKey: null,
    shiftKey: null,
    altKey: null,
    metaKey: null,
    getModifierState: Qe,
    button: null,
    buttons: null,
    relatedTarget: function(a) {
        return a.relatedTarget || (a.fromElement === a.srcElement ? a.toElement : a.fromElement);
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        var b = Re;
        Re = a.screenX;
        return Te ? "mousemove" === a.type ? a.screenX - b : 0 : (Te = !0, 0);
    },
    movementY: function(a) {
        if ("movementY" in a) return a.movementY;
        var b = Se;
        Se = a.screenY;
        return Ue ? "mousemove" === a.type ? a.screenY - b : 0 : (Ue = !0, 0);
    }
}), We = Ve.extend({
    pointerId: null,
    width: null,
    height: null,
    pressure: null,
    tangentialPressure: null,
    tiltX: null,
    tiltY: null,
    twist: null,
    pointerType: null,
    isPrimary: null
}), Xe = {
    mouseEnter: {
        registrationName: "onMouseEnter",
        dependencies: [
            "mouseout",
            "mouseover"
        ]
    },
    mouseLeave: {
        registrationName: "onMouseLeave",
        dependencies: [
            "mouseout",
            "mouseover"
        ]
    },
    pointerEnter: {
        registrationName: "onPointerEnter",
        dependencies: [
            "pointerout",
            "pointerover"
        ]
    },
    pointerLeave: {
        registrationName: "onPointerLeave",
        dependencies: [
            "pointerout",
            "pointerover"
        ]
    }
}, Ye = {
    eventTypes: Xe,
    extractEvents: function(a, b, c, d, e) {
        var f = "mouseover" === a || "pointerover" === a, g = "mouseout" === a || "pointerout" === a;
        if (f && 0 === (e & 32) && (c.relatedTarget || c.fromElement) || !g && !f) return null;
        f = d.window === d ? d : (f = d.ownerDocument) ? f.defaultView || f.parentWindow : window;
        if (g) {
            if (g = b, b = (b = c.relatedTarget || c.toElement) ? tc(b) : null, null !== b) {
                var h = dc(b);
                if (b !== h || 5 !== b.tag && 6 !== b.tag) b = null;
            }
        } else g = null;
        if (g === b) return null;
        if ("mouseout" === a || "mouseover" === a) {
            var k = Ve;
            var l = Xe.mouseLeave;
            var m = Xe.mouseEnter;
            var p = "mouse";
        } else if ("pointerout" === a || "pointerover" === a) k = We, l = Xe.pointerLeave, m = Xe.pointerEnter, p = "pointer";
        a = null == g ? f : Pd(g);
        f = null == b ? f : Pd(b);
        l = k.getPooled(l, g, c, d);
        l.type = p + "leave";
        l.target = a;
        l.relatedTarget = f;
        c = k.getPooled(m, b, c, d);
        c.type = p + "enter";
        c.target = f;
        c.relatedTarget = a;
        d = g;
        p = b;
        if (d && p) a: {
            k = d;
            m = p;
            g = 0;
            for(a = k; a; a = Rd(a))g++;
            a = 0;
            for(b = m; b; b = Rd(b))a++;
            for(; 0 < g - a;)k = Rd(k), g--;
            for(; 0 < a - g;)m = Rd(m), a--;
            for(; g--;){
                if (k === m || k === m.alternate) break a;
                k = Rd(k);
                m = Rd(m);
            }
            k = null;
        }
        else k = null;
        m = k;
        for(k = []; d && d !== m;){
            g = d.alternate;
            if (null !== g && g === m) break;
            k.push(d);
            d = Rd(d);
        }
        for(d = []; p && p !== m;){
            g = p.alternate;
            if (null !== g && g === m) break;
            d.push(p);
            p = Rd(p);
        }
        for(p = 0; p < k.length; p++)Vd(k[p], "bubbled", l);
        for(p = d.length; 0 < p--;)Vd(d[p], "captured", c);
        return 0 === (e & 64) ? [
            l
        ] : [
            l,
            c
        ];
    }
};
function Ze(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $e = "function" === typeof Object.is ? Object.is : Ze, af = Object.prototype.hasOwnProperty;
function bf(a, b) {
    if ($e(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++)if (!af.call(b, c[d]) || !$e(a[c[d]], b[c[d]])) return !1;
    return !0;
}
var cf = ya && "documentMode" in document && 11 >= document.documentMode, df = {
    select: {
        phasedRegistrationNames: {
            bubbled: "onSelect",
            captured: "onSelectCapture"
        },
        dependencies: "blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")
    }
}, ef = null, ff = null, gf = null, hf = !1;
function jf(a, b) {
    var c = b.window === b ? b.document : 9 === b.nodeType ? b : b.ownerDocument;
    if (hf || null == ef || ef !== td(c)) return null;
    c = ef;
    "selectionStart" in c && yd(c) ? c = {
        start: c.selectionStart,
        end: c.selectionEnd
    } : (c = (c.ownerDocument && c.ownerDocument.defaultView || window).getSelection(), c = {
        anchorNode: c.anchorNode,
        anchorOffset: c.anchorOffset,
        focusNode: c.focusNode,
        focusOffset: c.focusOffset
    });
    return gf && bf(gf, c) ? null : (gf = c, a = G.getPooled(df.select, ff, a, b), a.type = "select", a.target = ef, Xd(a), a);
}
var kf = {
    eventTypes: df,
    extractEvents: function(a, b, c, d, e, f) {
        e = f || (d.window === d ? d.document : 9 === d.nodeType ? d : d.ownerDocument);
        if (!(f = !e)) {
            a: {
                e = cc(e);
                f = wa.onSelect;
                for(var g = 0; g < f.length; g++)if (!e.has(f[g])) {
                    e = !1;
                    break a;
                }
                e = !0;
            }
            f = !e;
        }
        if (f) return null;
        e = b ? Pd(b) : window;
        switch(a){
            case "focus":
                if (xe(e) || "true" === e.contentEditable) ef = e, ff = b, gf = null;
                break;
            case "blur":
                gf = ff = ef = null;
                break;
            case "mousedown":
                hf = !0;
                break;
            case "contextmenu":
            case "mouseup":
            case "dragend":
                return hf = !1, jf(c, d);
            case "selectionchange":
                if (cf) break;
            case "keydown":
            case "keyup":
                return jf(c, d);
        }
        return null;
    }
}, lf = G.extend({
    animationName: null,
    elapsedTime: null,
    pseudoElement: null
}), mf = G.extend({
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), nf = Ne.extend({
    relatedTarget: null
});
function of(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
var pf = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, qf = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, rf = Ne.extend({
    key: function(a) {
        if (a.key) {
            var b = pf[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = of(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? qf[a.keyCode] || "Unidentified" : "";
    },
    location: null,
    ctrlKey: null,
    shiftKey: null,
    altKey: null,
    metaKey: null,
    repeat: null,
    locale: null,
    getModifierState: Qe,
    charCode: function(a) {
        return "keypress" === a.type ? of(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? of(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), sf = Ve.extend({
    dataTransfer: null
}), tf = Ne.extend({
    touches: null,
    targetTouches: null,
    changedTouches: null,
    altKey: null,
    metaKey: null,
    ctrlKey: null,
    shiftKey: null,
    getModifierState: Qe
}), uf = G.extend({
    propertyName: null,
    elapsedTime: null,
    pseudoElement: null
}), vf = Ve.extend({
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: null,
    deltaMode: null
}), wf = {
    eventTypes: Wc,
    extractEvents: function(a, b, c, d) {
        var e = Yc.get(a);
        if (!e) return null;
        switch(a){
            case "keypress":
                if (0 === of(c)) return null;
            case "keydown":
            case "keyup":
                a = rf;
                break;
            case "blur":
            case "focus":
                a = nf;
                break;
            case "click":
                if (2 === c.button) return null;
            case "auxclick":
            case "dblclick":
            case "mousedown":
            case "mousemove":
            case "mouseup":
            case "mouseout":
            case "mouseover":
            case "contextmenu":
                a = Ve;
                break;
            case "drag":
            case "dragend":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "dragstart":
            case "drop":
                a = sf;
                break;
            case "touchcancel":
            case "touchend":
            case "touchmove":
            case "touchstart":
                a = tf;
                break;
            case Xb:
            case Yb:
            case Zb:
                a = lf;
                break;
            case $b:
                a = uf;
                break;
            case "scroll":
                a = Ne;
                break;
            case "wheel":
                a = vf;
                break;
            case "copy":
            case "cut":
            case "paste":
                a = mf;
                break;
            case "gotpointercapture":
            case "lostpointercapture":
            case "pointercancel":
            case "pointerdown":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "pointerup":
                a = We;
                break;
            default:
                a = G;
        }
        b = a.getPooled(e, b, c, d);
        Xd(b);
        return b;
    }
};
if (pa) throw Error(u(101));
pa = Array.prototype.slice.call("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));
ra();
var xf = Nc;
la = Qd;
ma = xf;
na = Pd;
xa({
    SimpleEventPlugin: wf,
    EnterLeaveEventPlugin: Ye,
    ChangeEventPlugin: Me,
    SelectEventPlugin: kf,
    BeforeInputEventPlugin: ve
});
var yf = [], zf = -1;
function H(a) {
    0 > zf || (a.current = yf[zf], yf[zf] = null, zf--);
}
function I(a, b) {
    zf++;
    yf[zf] = a.current;
    a.current = b;
}
var Af = {}, J = {
    current: Af
}, K = {
    current: !1
}, Bf = Af;
function Cf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return Af;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function L(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function Df() {
    H(K);
    H(J);
}
function Ef(a, b, c) {
    if (J.current !== Af) throw Error(u(168));
    I(J, b);
    I(K, c);
}
function Ff(a, b, c) {
    var d = a.stateNode;
    a = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in a)) throw Error(u(108, pb(b) || "Unknown", e));
    return $8coUR({}, c, {}, d);
}
function Gf(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || Af;
    Bf = J.current;
    I(J, a);
    I(K, K.current);
    return !0;
}
function Hf(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error(u(169));
    c ? (a = Ff(a, b, Bf), d.__reactInternalMemoizedMergedChildContext = a, H(K), H(J), I(J, a)) : H(K);
    I(K, c);
}
var If = $fO90s.unstable_runWithPriority, Jf = $fO90s.unstable_scheduleCallback, Kf = $fO90s.unstable_cancelCallback, Lf = $fO90s.unstable_requestPaint, Mf = $fO90s.unstable_now, Nf = $fO90s.unstable_getCurrentPriorityLevel, Of = $fO90s.unstable_ImmediatePriority, Pf = $fO90s.unstable_UserBlockingPriority, Qf = $fO90s.unstable_NormalPriority, Rf = $fO90s.unstable_LowPriority, Sf = $fO90s.unstable_IdlePriority, Tf = {}, Uf = $fO90s.unstable_shouldYield, Vf = void 0 !== Lf ? Lf : function() {}, Wf = null, Xf = null, Yf = !1, Zf = Mf(), $f = 1E4 > Zf ? Mf : function() {
    return Mf() - Zf;
};
function ag() {
    switch(Nf()){
        case Of:
            return 99;
        case Pf:
            return 98;
        case Qf:
            return 97;
        case Rf:
            return 96;
        case Sf:
            return 95;
        default:
            throw Error(u(332));
    }
}
function bg(a) {
    switch(a){
        case 99:
            return Of;
        case 98:
            return Pf;
        case 97:
            return Qf;
        case 96:
            return Rf;
        case 95:
            return Sf;
        default:
            throw Error(u(332));
    }
}
function cg(a, b) {
    a = bg(a);
    return If(a, b);
}
function dg(a, b, c) {
    a = bg(a);
    return Jf(a, b, c);
}
function eg(a) {
    null === Wf ? (Wf = [
        a
    ], Xf = Jf(Of, fg)) : Wf.push(a);
    return Tf;
}
function gg() {
    if (null !== Xf) {
        var a = Xf;
        Xf = null;
        Kf(a);
    }
    fg();
}
function fg() {
    if (!Yf && null !== Wf) {
        Yf = !0;
        var a = 0;
        try {
            var b = Wf;
            cg(99, function() {
                for(; a < b.length; a++){
                    var c = b[a];
                    do c = c(!0);
                    while (null !== c);
                }
            });
            Wf = null;
        } catch (c) {
            throw null !== Wf && (Wf = Wf.slice(a + 1)), Jf(Of, gg), c;
        } finally{
            Yf = !1;
        }
    }
}
function hg(a, b, c) {
    c /= 10;
    return 1073741821 - (((1073741821 - a + b / 10) / c | 0) + 1) * c;
}
function ig(a, b) {
    if (a && a.defaultProps) {
        b = $8coUR({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
    }
    return b;
}
var jg = {
    current: null
}, kg = null, lg = null, mg = null;
function ng() {
    mg = lg = kg = null;
}
function og(a) {
    var b = jg.current;
    H(jg);
    a.type._context._currentValue = b;
}
function pg(a, b) {
    for(; null !== a;){
        var c = a.alternate;
        if (a.childExpirationTime < b) a.childExpirationTime = b, null !== c && c.childExpirationTime < b && (c.childExpirationTime = b);
        else if (null !== c && c.childExpirationTime < b) c.childExpirationTime = b;
        else break;
        a = a.return;
    }
}
function qg(a, b) {
    kg = a;
    mg = lg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (a.expirationTime >= b && (rg = !0), a.firstContext = null);
}
function sg(a, b) {
    if (mg !== a && !1 !== b && 0 !== b) {
        if ("number" !== typeof b || 1073741823 === b) mg = a, b = 1073741823;
        b = {
            context: a,
            observedBits: b,
            next: null
        };
        if (null === lg) {
            if (null === kg) throw Error(u(308));
            lg = b;
            kg.dependencies = {
                expirationTime: 0,
                firstContext: b,
                responders: null
            };
        } else lg = lg.next = b;
    }
    return a._currentValue;
}
var tg = !1;
function ug(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        baseQueue: null,
        shared: {
            pending: null
        },
        effects: null
    };
}
function vg(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        baseQueue: a.baseQueue,
        shared: a.shared,
        effects: a.effects
    });
}
function wg(a, b) {
    a = {
        expirationTime: a,
        suspenseConfig: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
    return a.next = a;
}
function xg(a, b) {
    a = a.updateQueue;
    if (null !== a) {
        a = a.shared;
        var c = a.pending;
        null === c ? b.next = b : (b.next = c.next, c.next = b);
        a.pending = b;
    }
}
function yg(a, b) {
    var c = a.alternate;
    null !== c && vg(c, a);
    a = a.updateQueue;
    c = a.baseQueue;
    null === c ? (a.baseQueue = b.next = b, b.next = b) : (b.next = c.next, c.next = b);
}
function zg(a, b, c, d) {
    var e = a.updateQueue;
    tg = !1;
    var f = e.baseQueue, g = e.shared.pending;
    if (null !== g) {
        if (null !== f) {
            var h = f.next;
            f.next = g.next;
            g.next = h;
        }
        f = g;
        e.shared.pending = null;
        h = a.alternate;
        null !== h && (h = h.updateQueue, null !== h && (h.baseQueue = g));
    }
    if (null !== f) {
        h = f.next;
        var k = e.baseState, l = 0, m = null, p = null, x = null;
        if (null !== h) {
            var z = h;
            do {
                g = z.expirationTime;
                if (g < d) {
                    var ca = {
                        expirationTime: z.expirationTime,
                        suspenseConfig: z.suspenseConfig,
                        tag: z.tag,
                        payload: z.payload,
                        callback: z.callback,
                        next: null
                    };
                    null === x ? (p = x = ca, m = k) : x = x.next = ca;
                    g > l && (l = g);
                } else {
                    null !== x && (x = x.next = {
                        expirationTime: 1073741823,
                        suspenseConfig: z.suspenseConfig,
                        tag: z.tag,
                        payload: z.payload,
                        callback: z.callback,
                        next: null
                    });
                    Ag(g, z.suspenseConfig);
                    a: {
                        var D = a, t = z;
                        g = b;
                        ca = c;
                        switch(t.tag){
                            case 1:
                                D = t.payload;
                                if ("function" === typeof D) {
                                    k = D.call(ca, k, g);
                                    break a;
                                }
                                k = D;
                                break a;
                            case 3:
                                D.effectTag = D.effectTag & -4097 | 64;
                            case 0:
                                D = t.payload;
                                g = "function" === typeof D ? D.call(ca, k, g) : D;
                                if (null === g || void 0 === g) break a;
                                k = $8coUR({}, k, g);
                                break a;
                            case 2:
                                tg = !0;
                        }
                    }
                    null !== z.callback && (a.effectTag |= 32, g = e.effects, null === g ? e.effects = [
                        z
                    ] : g.push(z));
                }
                z = z.next;
                if (null === z || z === h) {
                    if (g = e.shared.pending, null === g) break;
                    else z = f.next = g.next, g.next = h, e.baseQueue = f = g, e.shared.pending = null;
                }
            }while (1);
        }
        null === x ? m = k : x.next = p;
        e.baseState = m;
        e.baseQueue = x;
        Bg(l);
        a.expirationTime = l;
        a.memoizedState = k;
    }
}
function Cg(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = e;
            e = c;
            if ("function" !== typeof d) throw Error(u(191, d));
            d.call(e);
        }
    }
}
var Dg = Wa.ReactCurrentBatchConfig, Eg = (new $acw62.Component).refs;
function Fg(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $8coUR({}, b, c);
    a.memoizedState = c;
    0 === a.expirationTime && (a.updateQueue.baseState = c);
}
var Jg = {
    isMounted: function(a) {
        return (a = a._reactInternalFiber) ? dc(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternalFiber;
        var d = Gg(), e = Dg.suspense;
        d = Hg(d, a, e);
        e = wg(d, e);
        e.payload = b;
        void 0 !== c && null !== c && (e.callback = c);
        xg(a, e);
        Ig(a, d);
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternalFiber;
        var d = Gg(), e = Dg.suspense;
        d = Hg(d, a, e);
        e = wg(d, e);
        e.tag = 1;
        e.payload = b;
        void 0 !== c && null !== c && (e.callback = c);
        xg(a, e);
        Ig(a, d);
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternalFiber;
        var c = Gg(), d = Dg.suspense;
        c = Hg(c, a, d);
        d = wg(c, d);
        d.tag = 2;
        void 0 !== b && null !== b && (d.callback = b);
        xg(a, d);
        Ig(a, c);
    }
};
function Kg(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !bf(c, d) || !bf(e, f) : !0;
}
function Lg(a, b, c) {
    var d = !1, e = Af;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = sg(f) : (e = L(b) ? Bf : J.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? Cf(a, e) : Af);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = Jg;
    a.stateNode = b;
    b._reactInternalFiber = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function Mg(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && Jg.enqueueReplaceState(b, b.state, null);
}
function Ng(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = Eg;
    ug(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = sg(f) : (f = L(b) ? Bf : J.current, e.context = Cf(a, f));
    zg(a, c, e, d);
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && (Fg(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && Jg.enqueueReplaceState(e, e.state, null), zg(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.effectTag |= 4);
}
var Og = Array.isArray;
function Pg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error(u(309));
                var d = c.stateNode;
            }
            if (!d) throw Error(u(147, a));
            var e = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === e) return b.ref;
            b = function(a) {
                var b = d.refs;
                b === Eg && (b = d.refs = {});
                null === a ? delete b[e] : b[e] = a;
            };
            b._stringRef = e;
            return b;
        }
        if ("string" !== typeof a) throw Error(u(284));
        if (!c._owner) throw Error(u(290, a));
    }
    return a;
}
function Qg(a, b) {
    if ("textarea" !== a.type) throw Error(u(31, "[object Object]" === Object.prototype.toString.call(b) ? "object with keys {" + Object.keys(b).join(", ") + "}" : b, ""));
}
function Rg(a) {
    function b(b, c) {
        if (a) {
            var d = b.lastEffect;
            null !== d ? (d.nextEffect = c, b.lastEffect = c) : b.firstEffect = b.lastEffect = c;
            c.nextEffect = null;
            c.effectTag = 8;
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = Sg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.effectTag = 2, c) : d;
        b.effectTag = 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.effectTag = 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = Tg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        if (null !== b && b.elementType === c.type) return d = e(b, c.props), d.ref = Pg(a, b, c), d.return = a, d;
        d = Ug(c.type, c.key, c.props, null, a.mode, d);
        d.ref = Pg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = Vg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = Wg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function p(a, b, c) {
        if ("string" === typeof b || "number" === typeof b) return b = Tg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case Za:
                    return c = Ug(b.type, b.key, b.props, null, a.mode, c), c.ref = Pg(a, null, b), c.return = a, c;
                case $a:
                    return b = Vg(b, a.mode, c), b.return = a, b;
            }
            if (Og(b) || nb(b)) return b = Wg(b, a.mode, c, null), b.return = a, b;
            Qg(a, b);
        }
        return null;
    }
    function x(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case Za:
                    return c.key === e ? c.type === ab ? m(a, b, c.props.children, d, e) : k(a, b, c, d) : null;
                case $a:
                    return c.key === e ? l(a, b, c, d) : null;
            }
            if (Og(c) || nb(c)) return null !== e ? null : m(a, b, c, d, null);
            Qg(a, c);
        }
        return null;
    }
    function z(a, b, c, d, e) {
        if ("string" === typeof d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case Za:
                    return a = a.get(null === d.key ? c : d.key) || null, d.type === ab ? m(b, a, d.props.children, e, d.key) : k(b, a, d, e);
                case $a:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
            }
            if (Og(d) || nb(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            Qg(b, d);
        }
        return null;
    }
    function ca(e, g, h, k) {
        for(var l = null, t = null, m = g, y = g = 0, A = null; null !== m && y < h.length; y++){
            m.index > y ? (A = m, m = null) : A = m.sibling;
            var q = x(e, m, h[y], k);
            if (null === q) {
                null === m && (m = A);
                break;
            }
            a && m && null === q.alternate && b(e, m);
            g = f(q, g, y);
            null === t ? l = q : t.sibling = q;
            t = q;
            m = A;
        }
        if (y === h.length) return c(e, m), l;
        if (null === m) {
            for(; y < h.length; y++)m = p(e, h[y], k), null !== m && (g = f(m, g, y), null === t ? l = m : t.sibling = m, t = m);
            return l;
        }
        for(m = d(e, m); y < h.length; y++)A = z(m, e, y, h[y], k), null !== A && (a && null !== A.alternate && m.delete(null === A.key ? y : A.key), g = f(A, g, y), null === t ? l = A : t.sibling = A, t = A);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        return l;
    }
    function D(e, g, h, l) {
        var k = nb(h);
        if ("function" !== typeof k) throw Error(u(150));
        h = k.call(h);
        if (null == h) throw Error(u(151));
        for(var m = k = null, t = g, y = g = 0, A = null, q = h.next(); null !== t && !q.done; y++, q = h.next()){
            t.index > y ? (A = t, t = null) : A = t.sibling;
            var D = x(e, t, q.value, l);
            if (null === D) {
                null === t && (t = A);
                break;
            }
            a && t && null === D.alternate && b(e, t);
            g = f(D, g, y);
            null === m ? k = D : m.sibling = D;
            m = D;
            t = A;
        }
        if (q.done) return c(e, t), k;
        if (null === t) {
            for(; !q.done; y++, q = h.next())q = p(e, q.value, l), null !== q && (g = f(q, g, y), null === m ? k = q : m.sibling = q, m = q);
            return k;
        }
        for(t = d(e, t); !q.done; y++, q = h.next())q = z(t, e, y, q.value, l), null !== q && (a && null !== q.alternate && t.delete(null === q.key ? y : q.key), g = f(q, g, y), null === m ? k = q : m.sibling = q, m = q);
        a && t.forEach(function(a) {
            return b(e, a);
        });
        return k;
    }
    return function(a, d, f, h) {
        var k = "object" === typeof f && null !== f && f.type === ab && null === f.key;
        k && (f = f.props.children);
        var l = "object" === typeof f && null !== f;
        if (l) switch(f.$$typeof){
            case Za:
                a: {
                    l = f.key;
                    for(k = d; null !== k;){
                        if (k.key === l) {
                            switch(k.tag){
                                case 7:
                                    if (f.type === ab) {
                                        c(a, k.sibling);
                                        d = e(k, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                    break;
                                default:
                                    if (k.elementType === f.type) {
                                        c(a, k.sibling);
                                        d = e(k, f.props);
                                        d.ref = Pg(a, k, f);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                            }
                            c(a, k);
                            break;
                        } else b(a, k);
                        k = k.sibling;
                    }
                    f.type === ab ? (d = Wg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = Ug(f.type, f.key, f.props, null, a.mode, h), h.ref = Pg(a, d, f), h.return = a, a = h);
                }
                return g(a);
            case $a:
                a: {
                    for(k = f.key; null !== d;){
                        if (d.key === k) {
                            if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                c(a, d.sibling);
                                d = e(d, f.children || []);
                                d.return = a;
                                a = d;
                                break a;
                            } else {
                                c(a, d);
                                break;
                            }
                        } else b(a, d);
                        d = d.sibling;
                    }
                    d = Vg(f, a.mode, h);
                    d.return = a;
                    a = d;
                }
                return g(a);
        }
        if ("string" === typeof f || "number" === typeof f) return f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = Tg(f, a.mode, h), d.return = a, a = d), g(a);
        if (Og(f)) return ca(a, d, f, h);
        if (nb(f)) return D(a, d, f, h);
        l && Qg(a, f);
        if ("undefined" === typeof f && !k) switch(a.tag){
            case 1:
            case 0:
                throw a = a.type, Error(u(152, a.displayName || a.name || "Component"));
        }
        return c(a, d);
    };
}
var Xg = Rg(!0), Yg = Rg(!1), Zg = {}, $g = {
    current: Zg
}, ah = {
    current: Zg
}, bh = {
    current: Zg
};
function ch(a) {
    if (a === Zg) throw Error(u(174));
    return a;
}
function dh(a, b) {
    I(bh, b);
    I(ah, a);
    I($g, Zg);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : Ob(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = Ob(b, a);
    }
    H($g);
    I($g, b);
}
function eh() {
    H($g);
    H(ah);
    H(bh);
}
function fh(a) {
    ch(bh.current);
    var b = ch($g.current);
    var c = Ob(b, a.type);
    b !== c && (I(ah, a), I($g, c));
}
function gh(a) {
    ah.current === a && (H($g), H(ah));
}
var M = {
    current: 0
};
function hh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || c.data === Bd || c.data === Cd)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.effectTag & 64)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
function ih(a, b) {
    return {
        responder: a,
        props: b
    };
}
var jh = Wa.ReactCurrentDispatcher, kh = Wa.ReactCurrentBatchConfig, lh = 0, N = null, O = null, P = null, mh = !1;
function Q() {
    throw Error(u(321));
}
function nh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$e(a[c], b[c])) return !1;
    return !0;
}
function oh(a, b, c, d, e, f) {
    lh = f;
    N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.expirationTime = 0;
    jh.current = null === a || null === a.memoizedState ? ph : qh;
    a = c(d, e);
    if (b.expirationTime === lh) {
        f = 0;
        do {
            b.expirationTime = 0;
            if (!(25 > f)) throw Error(u(301));
            f += 1;
            P = O = null;
            b.updateQueue = null;
            jh.current = rh;
            a = c(d, e);
        }while (b.expirationTime === lh);
    }
    jh.current = sh;
    b = null !== O && null !== O.next;
    lh = 0;
    P = O = N = null;
    mh = !1;
    if (b) throw Error(u(300));
    return a;
}
function th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === P ? N.memoizedState = P = a : P = P.next = a;
    return P;
}
function uh() {
    if (null === O) {
        var a = N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = O.next;
    var b = null === P ? N.memoizedState : P.next;
    if (null !== b) P = b, O = a;
    else {
        if (null === a) throw Error(u(310));
        O = a;
        a = {
            memoizedState: O.memoizedState,
            baseState: O.baseState,
            baseQueue: O.baseQueue,
            queue: O.queue,
            next: null
        };
        null === P ? N.memoizedState = P = a : P = P.next = a;
    }
    return P;
}
function vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function wh(a) {
    var b = uh(), c = b.queue;
    if (null === c) throw Error(u(311));
    c.lastRenderedReducer = a;
    var d = O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        e = e.next;
        d = d.baseState;
        var h = g = f = null, k = e;
        do {
            var l = k.expirationTime;
            if (l < lh) {
                var m = {
                    expirationTime: k.expirationTime,
                    suspenseConfig: k.suspenseConfig,
                    action: k.action,
                    eagerReducer: k.eagerReducer,
                    eagerState: k.eagerState,
                    next: null
                };
                null === h ? (g = h = m, f = d) : h = h.next = m;
                l > N.expirationTime && (N.expirationTime = l, Bg(l));
            } else null !== h && (h = h.next = {
                expirationTime: 1073741823,
                suspenseConfig: k.suspenseConfig,
                action: k.action,
                eagerReducer: k.eagerReducer,
                eagerState: k.eagerState,
                next: null
            }), Ag(l, k.suspenseConfig), d = k.eagerReducer === a ? k.eagerState : a(d, k.action);
            k = k.next;
        }while (null !== k && k !== e);
        null === h ? f = d : h.next = g;
        $e(d, b.memoizedState) || (rg = !0);
        b.memoizedState = d;
        b.baseState = f;
        b.baseQueue = h;
        c.lastRenderedState = d;
    }
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function xh(a) {
    var b = uh(), c = b.queue;
    if (null === c) throw Error(u(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $e(f, b.memoizedState) || (rg = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function yh(a) {
    var b = th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = b.queue = {
        pending: null,
        dispatch: null,
        lastRenderedReducer: vh,
        lastRenderedState: a
    };
    a = a.dispatch = zh.bind(null, N, a);
    return [
        b.memoizedState,
        a
    ];
}
function Ah(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = N.updateQueue;
    null === b ? (b = {
        lastEffect: null
    }, N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function Bh() {
    return uh().memoizedState;
}
function Ch(a, b, c, d) {
    var e = th();
    N.effectTag |= a;
    e.memoizedState = Ah(1 | b, c, void 0, void 0 === d ? null : d);
}
function Dh(a, b, c, d) {
    var e = uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== O) {
        var g = O.memoizedState;
        f = g.destroy;
        if (null !== d && nh(d, g.deps)) {
            Ah(b, c, f, d);
            return;
        }
    }
    N.effectTag |= a;
    e.memoizedState = Ah(1 | b, c, f, d);
}
function Eh(a, b) {
    return Ch(516, 4, a, b);
}
function Fh(a, b) {
    return Dh(516, 4, a, b);
}
function Gh(a, b) {
    return Dh(4, 2, a, b);
}
function Hh(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function Ih(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return Dh(4, 2, Hh.bind(null, b, a), c);
}
function Jh() {}
function Kh(a, b) {
    th().memoizedState = [
        a,
        void 0 === b ? null : b
    ];
    return a;
}
function Lh(a, b) {
    var c = uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && nh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function Mh(a, b) {
    var c = uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && nh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function Nh(a, b, c) {
    var d = ag();
    cg(98 > d ? 98 : d, function() {
        a(!0);
    });
    cg(97 < d ? 97 : d, function() {
        var d = kh.suspense;
        kh.suspense = void 0 === b ? null : b;
        try {
            a(!1), c();
        } finally{
            kh.suspense = d;
        }
    });
}
function zh(a, b, c) {
    var d = Gg(), e = Dg.suspense;
    d = Hg(d, a, e);
    e = {
        expirationTime: d,
        suspenseConfig: e,
        action: c,
        eagerReducer: null,
        eagerState: null,
        next: null
    };
    var f = b.pending;
    null === f ? e.next = e : (e.next = f.next, f.next = e);
    b.pending = e;
    f = a.alternate;
    if (a === N || null !== f && f === N) mh = !0, e.expirationTime = lh, N.expirationTime = lh;
    else {
        if (0 === a.expirationTime && (null === f || 0 === f.expirationTime) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.eagerReducer = f;
            e.eagerState = h;
            if ($e(h, g)) return;
        } catch (k) {} finally{}
        Ig(a, d);
    }
}
var sh = {
    readContext: sg,
    useCallback: Q,
    useContext: Q,
    useEffect: Q,
    useImperativeHandle: Q,
    useLayoutEffect: Q,
    useMemo: Q,
    useReducer: Q,
    useRef: Q,
    useState: Q,
    useDebugValue: Q,
    useResponder: Q,
    useDeferredValue: Q,
    useTransition: Q
}, ph = {
    readContext: sg,
    useCallback: Kh,
    useContext: sg,
    useEffect: Eh,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return Ch(4, 2, Hh.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return Ch(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = d.queue = {
            pending: null,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        a = a.dispatch = zh.bind(null, N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: yh,
    useDebugValue: Jh,
    useResponder: ih,
    useDeferredValue: function(a, b) {
        var c = yh(a), d = c[0], e = c[1];
        Eh(function() {
            var c = kh.suspense;
            kh.suspense = void 0 === b ? null : b;
            try {
                e(a);
            } finally{
                kh.suspense = c;
            }
        }, [
            a,
            b
        ]);
        return d;
    },
    useTransition: function(a) {
        var b = yh(!1), c = b[0];
        b = b[1];
        return [
            Kh(Nh.bind(null, b, a), [
                b,
                a
            ]),
            c
        ];
    }
}, qh = {
    readContext: sg,
    useCallback: Lh,
    useContext: sg,
    useEffect: Fh,
    useImperativeHandle: Ih,
    useLayoutEffect: Gh,
    useMemo: Mh,
    useReducer: wh,
    useRef: Bh,
    useState: function() {
        return wh(vh);
    },
    useDebugValue: Jh,
    useResponder: ih,
    useDeferredValue: function(a, b) {
        var c = wh(vh), d = c[0], e = c[1];
        Fh(function() {
            var c = kh.suspense;
            kh.suspense = void 0 === b ? null : b;
            try {
                e(a);
            } finally{
                kh.suspense = c;
            }
        }, [
            a,
            b
        ]);
        return d;
    },
    useTransition: function(a) {
        var b = wh(vh), c = b[0];
        b = b[1];
        return [
            Lh(Nh.bind(null, b, a), [
                b,
                a
            ]),
            c
        ];
    }
}, rh = {
    readContext: sg,
    useCallback: Lh,
    useContext: sg,
    useEffect: Fh,
    useImperativeHandle: Ih,
    useLayoutEffect: Gh,
    useMemo: Mh,
    useReducer: xh,
    useRef: Bh,
    useState: function() {
        return xh(vh);
    },
    useDebugValue: Jh,
    useResponder: ih,
    useDeferredValue: function(a, b) {
        var c = xh(vh), d = c[0], e = c[1];
        Fh(function() {
            var c = kh.suspense;
            kh.suspense = void 0 === b ? null : b;
            try {
                e(a);
            } finally{
                kh.suspense = c;
            }
        }, [
            a,
            b
        ]);
        return d;
    },
    useTransition: function(a) {
        var b = xh(vh), c = b[0];
        b = b[1];
        return [
            Lh(Nh.bind(null, b, a), [
                b,
                a
            ]),
            c
        ];
    }
}, Oh = null, Ph = null, Qh = !1;
function Rh(a, b) {
    var c = Sh(5, null, null, 0);
    c.elementType = "DELETED";
    c.type = "DELETED";
    c.stateNode = b;
    c.return = a;
    c.effectTag = 8;
    null !== a.lastEffect ? (a.lastEffect.nextEffect = c, a.lastEffect = c) : a.firstEffect = a.lastEffect = c;
}
function Th(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, !0) : !1;
        case 13:
            return !1;
        default:
            return !1;
    }
}
function Uh(a) {
    if (Qh) {
        var b = Ph;
        if (b) {
            var c = b;
            if (!Th(a, b)) {
                b = Jd(c.nextSibling);
                if (!b || !Th(a, b)) {
                    a.effectTag = a.effectTag & -1025 | 2;
                    Qh = !1;
                    Oh = a;
                    return;
                }
                Rh(Oh, c);
            }
            Oh = a;
            Ph = Jd(b.firstChild);
        } else a.effectTag = a.effectTag & -1025 | 2, Qh = !1, Oh = a;
    }
}
function Vh(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    Oh = a;
}
function Wh(a) {
    if (a !== Oh) return !1;
    if (!Qh) return Vh(a), Qh = !0, !1;
    var b = a.type;
    if (5 !== a.tag || "head" !== b && "body" !== b && !Gd(b, a.memoizedProps)) for(b = Ph; b;)Rh(a, b), b = Jd(b.nextSibling);
    Vh(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error(u(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if (c === Ad) {
                        if (0 === b) {
                            Ph = Jd(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else c !== zd && c !== Cd && c !== Bd || b++;
                }
                a = a.nextSibling;
            }
            Ph = null;
        }
    } else Ph = Oh ? Jd(a.stateNode.nextSibling) : null;
    return !0;
}
function Xh() {
    Ph = Oh = null;
    Qh = !1;
}
var Yh = Wa.ReactCurrentOwner, rg = !1;
function R(a, b, c, d) {
    b.child = null === a ? Yg(b, null, c, d) : Xg(b, a.child, c, d);
}
function Zh(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    qg(b, e);
    d = oh(a, b, c, d, f, e);
    if (null !== a && !rg) return b.updateQueue = a.updateQueue, b.effectTag &= -517, a.expirationTime <= e && (a.expirationTime = 0), $h(a, b, e);
    b.effectTag |= 1;
    R(a, b, d, e);
    return b.child;
}
function ai(a, b, c, d, e, f) {
    if (null === a) {
        var g = c.type;
        if ("function" === typeof g && !bi(g) && void 0 === g.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = g, ci(a, b, g, d, e, f);
        a = Ug(c.type, null, d, null, b.mode, f);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    g = a.child;
    if (e < f && (e = g.memoizedProps, c = c.compare, c = null !== c ? c : bf, c(e, d) && a.ref === b.ref)) return $h(a, b, f);
    b.effectTag |= 1;
    a = Sg(g, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function ci(a, b, c, d, e, f) {
    return null !== a && bf(a.memoizedProps, d) && a.ref === b.ref && (rg = !1, e < f) ? (b.expirationTime = a.expirationTime, $h(a, b, f)) : di(a, b, c, d, f);
}
function ei(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.effectTag |= 128;
}
function di(a, b, c, d, e) {
    var f = L(c) ? Bf : J.current;
    f = Cf(b, f);
    qg(b, e);
    c = oh(a, b, c, d, f, e);
    if (null !== a && !rg) return b.updateQueue = a.updateQueue, b.effectTag &= -517, a.expirationTime <= e && (a.expirationTime = 0), $h(a, b, e);
    b.effectTag |= 1;
    R(a, b, c, e);
    return b.child;
}
function fi(a, b, c, d, e) {
    if (L(c)) {
        var f = !0;
        Gf(b);
    } else f = !1;
    qg(b, e);
    if (null === b.stateNode) null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2), Lg(b, c, d), Ng(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = sg(l) : (l = L(c) ? Bf : J.current, l = Cf(b, l));
        var m = c.getDerivedStateFromProps, p = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        p || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && Mg(b, g, d, l);
        tg = !1;
        var x = b.memoizedState;
        g.state = x;
        zg(b, d, g, e);
        k = b.memoizedState;
        h !== d || x !== k || K.current || tg ? ("function" === typeof m && (Fg(b, c, m, d), k = b.memoizedState), (h = tg || Kg(b, c, h, d, x, k, l)) ? (p || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.effectTag |= 4)) : ("function" === typeof g.componentDidMount && (b.effectTag |= 4), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.effectTag |= 4), d = !1);
    } else g = b.stateNode, vg(a, b), h = b.memoizedProps, g.props = b.type === b.elementType ? h : ig(b.type, h), k = g.context, l = c.contextType, "object" === typeof l && null !== l ? l = sg(l) : (l = L(c) ? Bf : J.current, l = Cf(b, l)), m = c.getDerivedStateFromProps, (p = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && Mg(b, g, d, l), tg = !1, k = b.memoizedState, g.state = k, zg(b, d, g, e), x = b.memoizedState, h !== d || k !== x || K.current || tg ? ("function" === typeof m && (Fg(b, c, m, d), x = b.memoizedState), (m = tg || Kg(b, c, h, d, k, x, l)) ? (p || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, x, l), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, x, l)), "function" === typeof g.componentDidUpdate && (b.effectTag |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.effectTag |= 256)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && k === a.memoizedState || (b.effectTag |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && k === a.memoizedState || (b.effectTag |= 256), b.memoizedProps = d, b.memoizedState = x), g.props = d, g.state = x, g.context = l, d = m) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && k === a.memoizedState || (b.effectTag |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && k === a.memoizedState || (b.effectTag |= 256), d = !1);
    return gi(a, b, c, d, f, e);
}
function gi(a, b, c, d, e, f) {
    ei(a, b);
    var g = 0 !== (b.effectTag & 64);
    if (!d && !g) return e && Hf(b, c, !1), $h(a, b, f);
    d = b.stateNode;
    Yh.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.effectTag |= 1;
    null !== a && g ? (b.child = Xg(b, a.child, null, f), b.child = Xg(b, null, h, f)) : R(a, b, h, f);
    b.memoizedState = d.state;
    e && Hf(b, c, !0);
    return b.child;
}
function hi(a) {
    var b = a.stateNode;
    b.pendingContext ? Ef(a, b.pendingContext, b.pendingContext !== b.context) : b.context && Ef(a, b.context, !1);
    dh(a, b.containerInfo);
}
var ii = {
    dehydrated: null,
    retryTime: 0
};
function ji(a, b, c) {
    var d = b.mode, e = b.pendingProps, f = M.current, g = !1, h;
    (h = 0 !== (b.effectTag & 64)) || (h = 0 !== (f & 2) && (null === a || null !== a.memoizedState));
    h ? (g = !0, b.effectTag &= -65) : null !== a && null === a.memoizedState || void 0 === e.fallback || !0 === e.unstable_avoidThisFallback || (f |= 1);
    I(M, f & 1);
    if (null === a) {
        void 0 !== e.fallback && Uh(b);
        if (g) {
            g = e.fallback;
            e = Wg(null, d, 0, null);
            e.return = b;
            if (0 === (b.mode & 2)) for(a = null !== b.memoizedState ? b.child.child : b.child, e.child = a; null !== a;)a.return = e, a = a.sibling;
            c = Wg(g, d, c, null);
            c.return = b;
            e.sibling = c;
            b.memoizedState = ii;
            b.child = e;
            return c;
        }
        d = e.children;
        b.memoizedState = null;
        return b.child = Yg(b, null, d, c);
    }
    if (null !== a.memoizedState) {
        a = a.child;
        d = a.sibling;
        if (g) {
            e = e.fallback;
            c = Sg(a, a.pendingProps);
            c.return = b;
            if (0 === (b.mode & 2) && (g = null !== b.memoizedState ? b.child.child : b.child, g !== a.child)) for(c.child = g; null !== g;)g.return = c, g = g.sibling;
            d = Sg(d, e);
            d.return = b;
            c.sibling = d;
            c.childExpirationTime = 0;
            b.memoizedState = ii;
            b.child = c;
            return d;
        }
        c = Xg(b, a.child, e.children, c);
        b.memoizedState = null;
        return b.child = c;
    }
    a = a.child;
    if (g) {
        g = e.fallback;
        e = Wg(null, d, 0, null);
        e.return = b;
        e.child = a;
        null !== a && (a.return = e);
        if (0 === (b.mode & 2)) for(a = null !== b.memoizedState ? b.child.child : b.child, e.child = a; null !== a;)a.return = e, a = a.sibling;
        c = Wg(g, d, c, null);
        c.return = b;
        e.sibling = c;
        c.effectTag |= 2;
        e.childExpirationTime = 0;
        b.memoizedState = ii;
        b.child = e;
        return c;
    }
    b.memoizedState = null;
    return b.child = Xg(b, a, e.children, c);
}
function ki(a, b) {
    a.expirationTime < b && (a.expirationTime = b);
    var c = a.alternate;
    null !== c && c.expirationTime < b && (c.expirationTime = b);
    pg(a.return, b);
}
function li(a, b, c, d, e, f) {
    var g = a.memoizedState;
    null === g ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailExpiration: 0,
        tailMode: e,
        lastEffect: f
    } : (g.isBackwards = b, g.rendering = null, g.renderingStartTime = 0, g.last = d, g.tail = c, g.tailExpiration = 0, g.tailMode = e, g.lastEffect = f);
}
function mi(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    R(a, b, d.children, c);
    d = M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.effectTag |= 64;
    else {
        if (null !== a && 0 !== (a.effectTag & 64)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && ki(a, c);
            else if (19 === a.tag) ki(a, c);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    I(M, d);
    if (0 === (b.mode & 2)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === hh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            li(b, !1, e, c, f, b.lastEffect);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === hh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            li(b, !0, c, null, f, b.lastEffect);
            break;
        case "together":
            li(b, !1, null, null, void 0, b.lastEffect);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $h(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    var d = b.expirationTime;
    0 !== d && Bg(d);
    if (b.childExpirationTime < c) return null;
    if (null !== a && b.child !== a.child) throw Error(u(153));
    if (null !== b.child) {
        a = b.child;
        c = Sg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = Sg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
var ni, oi, pi, qi;
ni = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
oi = function() {};
pi = function(a, b, c, d, e) {
    var f = a.memoizedProps;
    if (f !== d) {
        var g = b.stateNode;
        ch($g.current);
        a = null;
        switch(c){
            case "input":
                f = zb(g, f);
                d = zb(g, d);
                a = [];
                break;
            case "option":
                f = Gb(g, f);
                d = Gb(g, d);
                a = [];
                break;
            case "select":
                f = $8coUR({}, f, {
                    value: void 0
                });
                d = $8coUR({}, d, {
                    value: void 0
                });
                a = [];
                break;
            case "textarea":
                f = Ib(g, f);
                d = Ib(g, d);
                a = [];
                break;
            default:
                "function" !== typeof f.onClick && "function" === typeof d.onClick && (g.onclick = sd);
        }
        od(c, d);
        var h, k;
        c = null;
        for(h in f)if (!d.hasOwnProperty(h) && f.hasOwnProperty(h) && null != f[h]) {
            if ("style" === h) for(k in g = f[h], g)g.hasOwnProperty(k) && (c || (c = {}), c[k] = "");
            else "dangerouslySetInnerHTML" !== h && "children" !== h && "suppressContentEditableWarning" !== h && "suppressHydrationWarning" !== h && "autoFocus" !== h && (va.hasOwnProperty(h) ? a || (a = []) : (a = a || []).push(h, null));
        }
        for(h in d){
            var l = d[h];
            g = null != f ? f[h] : void 0;
            if (d.hasOwnProperty(h) && l !== g && (null != l || null != g)) {
                if ("style" === h) {
                    if (g) {
                        for(k in g)!g.hasOwnProperty(k) || l && l.hasOwnProperty(k) || (c || (c = {}), c[k] = "");
                        for(k in l)l.hasOwnProperty(k) && g[k] !== l[k] && (c || (c = {}), c[k] = l[k]);
                    } else c || (a || (a = []), a.push(h, c)), c = l;
                } else "dangerouslySetInnerHTML" === h ? (l = l ? l.__html : void 0, g = g ? g.__html : void 0, null != l && g !== l && (a = a || []).push(h, l)) : "children" === h ? g === l || "string" !== typeof l && "number" !== typeof l || (a = a || []).push(h, "" + l) : "suppressContentEditableWarning" !== h && "suppressHydrationWarning" !== h && (va.hasOwnProperty(h) ? (null != l && rd(e, h), a || g === l || (a = [])) : (a = a || []).push(h, l));
            }
        }
        c && (a = a || []).push("style", c);
        e = a;
        if (b.updateQueue = e) b.effectTag |= 4;
    }
};
qi = function(a, b, c, d) {
    c !== d && (b.effectTag |= 4);
};
function ri(a, b) {
    switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function si(a, b, c) {
    var d = b.pendingProps;
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return null;
        case 1:
            return L(b.type) && Df(), null;
        case 3:
            return eh(), H(K), H(J), c = b.stateNode, c.pendingContext && (c.context = c.pendingContext, c.pendingContext = null), null !== a && null !== a.child || !Wh(b) || (b.effectTag |= 4), oi(b), null;
        case 5:
            gh(b);
            c = ch(bh.current);
            var e = b.type;
            if (null !== a && null != b.stateNode) pi(a, b, e, d, c), a.ref !== b.ref && (b.effectTag |= 128);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error(u(166));
                    return null;
                }
                a = ch($g.current);
                if (Wh(b)) {
                    d = b.stateNode;
                    e = b.type;
                    var f = b.memoizedProps;
                    d[Md] = b;
                    d[Nd] = f;
                    switch(e){
                        case "iframe":
                        case "object":
                        case "embed":
                            F("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(a = 0; a < ac.length; a++)F(ac[a], d);
                            break;
                        case "source":
                            F("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            F("error", d);
                            F("load", d);
                            break;
                        case "form":
                            F("reset", d);
                            F("submit", d);
                            break;
                        case "details":
                            F("toggle", d);
                            break;
                        case "input":
                            Ab(d, f);
                            F("invalid", d);
                            rd(c, "onChange");
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            F("invalid", d);
                            rd(c, "onChange");
                            break;
                        case "textarea":
                            Jb(d, f), F("invalid", d), rd(c, "onChange");
                    }
                    od(e, f);
                    a = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (a = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (a = [
                            "children",
                            "" + h
                        ]) : va.hasOwnProperty(g) && null != h && rd(c, g);
                    }
                    switch(e){
                        case "input":
                            xb(d);
                            Eb(d, f, !0);
                            break;
                        case "textarea":
                            xb(d);
                            Lb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = sd);
                    }
                    c = a;
                    b.updateQueue = c;
                    null !== c && (b.effectTag |= 4);
                } else {
                    g = 9 === c.nodeType ? c : c.ownerDocument;
                    a === qd && (a = Nb(e));
                    a === qd ? "script" === e ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(e, {
                        is: d.is
                    }) : (a = g.createElement(e), "select" === e && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, e);
                    a[Md] = b;
                    a[Nd] = d;
                    ni(a, b, !1, !1);
                    b.stateNode = a;
                    g = pd(e, d);
                    switch(e){
                        case "iframe":
                        case "object":
                        case "embed":
                            F("load", a);
                            h = d;
                            break;
                        case "video":
                        case "audio":
                            for(h = 0; h < ac.length; h++)F(ac[h], a);
                            h = d;
                            break;
                        case "source":
                            F("error", a);
                            h = d;
                            break;
                        case "img":
                        case "image":
                        case "link":
                            F("error", a);
                            F("load", a);
                            h = d;
                            break;
                        case "form":
                            F("reset", a);
                            F("submit", a);
                            h = d;
                            break;
                        case "details":
                            F("toggle", a);
                            h = d;
                            break;
                        case "input":
                            Ab(a, d);
                            h = zb(a, d);
                            F("invalid", a);
                            rd(c, "onChange");
                            break;
                        case "option":
                            h = Gb(a, d);
                            break;
                        case "select":
                            a._wrapperState = {
                                wasMultiple: !!d.multiple
                            };
                            h = $8coUR({}, d, {
                                value: void 0
                            });
                            F("invalid", a);
                            rd(c, "onChange");
                            break;
                        case "textarea":
                            Jb(a, d);
                            h = Ib(a, d);
                            F("invalid", a);
                            rd(c, "onChange");
                            break;
                        default:
                            h = d;
                    }
                    od(e, h);
                    var k = h;
                    for(f in k)if (k.hasOwnProperty(f)) {
                        var l = k[f];
                        "style" === f ? md(a, l) : "dangerouslySetInnerHTML" === f ? (l = l ? l.__html : void 0, null != l && Qb(a, l)) : "children" === f ? "string" === typeof l ? ("textarea" !== e || "" !== l) && Rb(a, l) : "number" === typeof l && Rb(a, "" + l) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && (va.hasOwnProperty(f) ? null != l && rd(c, f) : null != l && Xa(a, f, l, g));
                    }
                    switch(e){
                        case "input":
                            xb(a);
                            Eb(a, d, !1);
                            break;
                        case "textarea":
                            xb(a);
                            Lb(a);
                            break;
                        case "option":
                            null != d.value && a.setAttribute("value", "" + rb(d.value));
                            break;
                        case "select":
                            a.multiple = !!d.multiple;
                            c = d.value;
                            null != c ? Hb(a, !!d.multiple, c, !1) : null != d.defaultValue && Hb(a, !!d.multiple, d.defaultValue, !0);
                            break;
                        default:
                            "function" === typeof h.onClick && (a.onclick = sd);
                    }
                    Fd(e, d) && (b.effectTag |= 4);
                }
                null !== b.ref && (b.effectTag |= 128);
            }
            return null;
        case 6:
            if (a && null != b.stateNode) qi(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error(u(166));
                c = ch(bh.current);
                ch($g.current);
                Wh(b) ? (c = b.stateNode, d = b.memoizedProps, c[Md] = b, c.nodeValue !== d && (b.effectTag |= 4)) : (c = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), c[Md] = b, b.stateNode = c);
            }
            return null;
        case 13:
            H(M);
            d = b.memoizedState;
            if (0 !== (b.effectTag & 64)) return b.expirationTime = c, b;
            c = null !== d;
            d = !1;
            null === a ? void 0 !== b.memoizedProps.fallback && Wh(b) : (e = a.memoizedState, d = null !== e, c || null === e || (e = a.child.sibling, null !== e && (f = b.firstEffect, null !== f ? (b.firstEffect = e, e.nextEffect = f) : (b.firstEffect = b.lastEffect = e, e.nextEffect = null), e.effectTag = 8)));
            if (c && !d && 0 !== (b.mode & 2)) {
                if (null === a && !0 !== b.memoizedProps.unstable_avoidThisFallback || 0 !== (M.current & 1)) S === ti && (S = ui);
                else {
                    if (S === ti || S === ui) S = vi;
                    0 !== wi && null !== T && (xi(T, U), yi(T, wi));
                }
            }
            if (c || d) b.effectTag |= 4;
            return null;
        case 4:
            return eh(), oi(b), null;
        case 10:
            return og(b), null;
        case 17:
            return L(b.type) && Df(), null;
        case 19:
            H(M);
            d = b.memoizedState;
            if (null === d) return null;
            e = 0 !== (b.effectTag & 64);
            f = d.rendering;
            if (null === f) {
                if (e) ri(d, !1);
                else {
                    if (S !== ti || null !== a && 0 !== (a.effectTag & 64)) for(f = b.child; null !== f;){
                        a = hh(f);
                        if (null !== a) {
                            b.effectTag |= 64;
                            ri(d, !1);
                            e = a.updateQueue;
                            null !== e && (b.updateQueue = e, b.effectTag |= 4);
                            null === d.lastEffect && (b.firstEffect = null);
                            b.lastEffect = d.lastEffect;
                            for(d = b.child; null !== d;)e = d, f = c, e.effectTag &= 2, e.nextEffect = null, e.firstEffect = null, e.lastEffect = null, a = e.alternate, null === a ? (e.childExpirationTime = 0, e.expirationTime = f, e.child = null, e.memoizedProps = null, e.memoizedState = null, e.updateQueue = null, e.dependencies = null) : (e.childExpirationTime = a.childExpirationTime, e.expirationTime = a.expirationTime, e.child = a.child, e.memoizedProps = a.memoizedProps, e.memoizedState = a.memoizedState, e.updateQueue = a.updateQueue, f = a.dependencies, e.dependencies = null === f ? null : {
                                expirationTime: f.expirationTime,
                                firstContext: f.firstContext,
                                responders: f.responders
                            }), d = d.sibling;
                            I(M, M.current & 1 | 2);
                            return b.child;
                        }
                        f = f.sibling;
                    }
                }
            } else {
                if (!e) {
                    if (a = hh(f), null !== a) {
                        if (b.effectTag |= 64, e = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.effectTag |= 4), ri(d, !0), null === d.tail && "hidden" === d.tailMode && !f.alternate) return b = b.lastEffect = d.lastEffect, null !== b && (b.nextEffect = null), null;
                    } else 2 * $f() - d.renderingStartTime > d.tailExpiration && 1 < c && (b.effectTag |= 64, e = !0, ri(d, !1), b.expirationTime = b.childExpirationTime = c - 1);
                }
                d.isBackwards ? (f.sibling = b.child, b.child = f) : (c = d.last, null !== c ? c.sibling = f : b.child = f, d.last = f);
            }
            return null !== d.tail ? (0 === d.tailExpiration && (d.tailExpiration = $f() + 500), c = d.tail, d.rendering = c, d.tail = c.sibling, d.lastEffect = b.lastEffect, d.renderingStartTime = $f(), c.sibling = null, b = M.current, I(M, e ? b & 1 | 2 : b & 1), c) : null;
    }
    throw Error(u(156, b.tag));
}
function zi(a) {
    switch(a.tag){
        case 1:
            L(a.type) && Df();
            var b = a.effectTag;
            return b & 4096 ? (a.effectTag = b & -4097 | 64, a) : null;
        case 3:
            eh();
            H(K);
            H(J);
            b = a.effectTag;
            if (0 !== (b & 64)) throw Error(u(285));
            a.effectTag = b & -4097 | 64;
            return a;
        case 5:
            return gh(a), null;
        case 13:
            return H(M), b = a.effectTag, b & 4096 ? (a.effectTag = b & -4097 | 64, a) : null;
        case 19:
            return H(M), null;
        case 4:
            return eh(), null;
        case 10:
            return og(a), null;
        default:
            return null;
    }
}
function Ai(a, b) {
    return {
        value: a,
        source: b,
        stack: qb(b)
    };
}
var Bi = "function" === typeof WeakSet ? WeakSet : Set;
function Ci(a, b) {
    var c = b.source, d = b.stack;
    null === d && null !== c && (d = qb(c));
    null !== c && pb(c.type);
    b = b.value;
    null !== a && 1 === a.tag && pb(a.type);
    try {
        console.error(b);
    } catch (e) {
        setTimeout(function() {
            throw e;
        });
    }
}
function Di(a, b) {
    try {
        b.props = a.memoizedProps, b.state = a.memoizedState, b.componentWillUnmount();
    } catch (c) {
        Ei(a, c);
    }
}
function Fi(a) {
    var b = a.ref;
    if (null !== b) {
        if ("function" === typeof b) try {
            b(null);
        } catch (c) {
            Ei(a, c);
        }
        else b.current = null;
    }
}
function Gi(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            return;
        case 1:
            if (b.effectTag & 256 && null !== a) {
                var c = a.memoizedProps, d = a.memoizedState;
                a = b.stateNode;
                b = a.getSnapshotBeforeUpdate(b.elementType === b.type ? c : ig(b.type, c), d);
                a.__reactInternalSnapshotBeforeUpdate = b;
            }
            return;
        case 3:
        case 5:
        case 6:
        case 4:
        case 17:
            return;
    }
    throw Error(u(163));
}
function Hi(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.destroy;
                c.destroy = void 0;
                void 0 !== d && d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function Ii(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function Ji(a, b, c) {
    switch(c.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            Ii(3, c);
            return;
        case 1:
            a = c.stateNode;
            if (c.effectTag & 4) {
                if (null === b) a.componentDidMount();
                else {
                    var d = c.elementType === c.type ? b.memoizedProps : ig(c.type, b.memoizedProps);
                    a.componentDidUpdate(d, b.memoizedState, a.__reactInternalSnapshotBeforeUpdate);
                }
            }
            b = c.updateQueue;
            null !== b && Cg(c, b, a);
            return;
        case 3:
            b = c.updateQueue;
            if (null !== b) {
                a = null;
                if (null !== c.child) switch(c.child.tag){
                    case 5:
                        a = c.child.stateNode;
                        break;
                    case 1:
                        a = c.child.stateNode;
                }
                Cg(c, b, a);
            }
            return;
        case 5:
            a = c.stateNode;
            null === b && c.effectTag & 4 && Fd(c.type, c.memoizedProps) && a.focus();
            return;
        case 6:
            return;
        case 4:
            return;
        case 12:
            return;
        case 13:
            null === c.memoizedState && (c = c.alternate, null !== c && (c = c.memoizedState, null !== c && (c = c.dehydrated, null !== c && Vc(c))));
            return;
        case 19:
        case 17:
        case 20:
        case 21:
            return;
    }
    throw Error(u(163));
}
function Ki(a, b, c) {
    "function" === typeof Li && Li(b);
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            a = b.updateQueue;
            if (null !== a && (a = a.lastEffect, null !== a)) {
                var d = a.next;
                cg(97 < c ? 97 : c, function() {
                    var a = d;
                    do {
                        var c = a.destroy;
                        if (void 0 !== c) {
                            var g = b;
                            try {
                                c();
                            } catch (h) {
                                Ei(g, h);
                            }
                        }
                        a = a.next;
                    }while (a !== d);
                });
            }
            break;
        case 1:
            Fi(b);
            c = b.stateNode;
            "function" === typeof c.componentWillUnmount && Di(b, c);
            break;
        case 5:
            Fi(b);
            break;
        case 4:
            Mi(a, b, c);
    }
}
function Ni(a) {
    var b = a.alternate;
    a.return = null;
    a.child = null;
    a.memoizedState = null;
    a.updateQueue = null;
    a.dependencies = null;
    a.alternate = null;
    a.firstEffect = null;
    a.lastEffect = null;
    a.pendingProps = null;
    a.memoizedProps = null;
    a.stateNode = null;
    null !== b && Ni(b);
}
function Oi(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function Pi(a) {
    a: {
        for(var b = a.return; null !== b;){
            if (Oi(b)) {
                var c = b;
                break a;
            }
            b = b.return;
        }
        throw Error(u(160));
    }
    b = c.stateNode;
    switch(c.tag){
        case 5:
            var d = !1;
            break;
        case 3:
            b = b.containerInfo;
            d = !0;
            break;
        case 4:
            b = b.containerInfo;
            d = !0;
            break;
        default:
            throw Error(u(161));
    }
    c.effectTag & 16 && (Rb(b, ""), c.effectTag &= -17);
    a: b: for(c = a;;){
        for(; null === c.sibling;){
            if (null === c.return || Oi(c.return)) {
                c = null;
                break a;
            }
            c = c.return;
        }
        c.sibling.return = c.return;
        for(c = c.sibling; 5 !== c.tag && 6 !== c.tag && 18 !== c.tag;){
            if (c.effectTag & 2) continue b;
            if (null === c.child || 4 === c.tag) continue b;
            else c.child.return = c, c = c.child;
        }
        if (!(c.effectTag & 2)) {
            c = c.stateNode;
            break a;
        }
    }
    d ? Qi(a, c, b) : Ri(a, c, b);
}
function Qi(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = sd));
    else if (4 !== d && (a = a.child, null !== a)) for(Qi(a, b, c), a = a.sibling; null !== a;)Qi(a, b, c), a = a.sibling;
}
function Ri(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for(Ri(a, b, c), a = a.sibling; null !== a;)Ri(a, b, c), a = a.sibling;
}
function Mi(a, b, c) {
    for(var d = b, e = !1, f, g;;){
        if (!e) {
            e = d.return;
            a: for(;;){
                if (null === e) throw Error(u(160));
                f = e.stateNode;
                switch(e.tag){
                    case 5:
                        g = !1;
                        break a;
                    case 3:
                        f = f.containerInfo;
                        g = !0;
                        break a;
                    case 4:
                        f = f.containerInfo;
                        g = !0;
                        break a;
                }
                e = e.return;
            }
            e = !0;
        }
        if (5 === d.tag || 6 === d.tag) {
            a: for(var h = a, k = d, l = c, m = k;;)if (Ki(h, m, l), null !== m.child && 4 !== m.tag) m.child.return = m, m = m.child;
            else {
                if (m === k) break a;
                for(; null === m.sibling;){
                    if (null === m.return || m.return === k) break a;
                    m = m.return;
                }
                m.sibling.return = m.return;
                m = m.sibling;
            }
            g ? (h = f, k = d.stateNode, 8 === h.nodeType ? h.parentNode.removeChild(k) : h.removeChild(k)) : f.removeChild(d.stateNode);
        } else if (4 === d.tag) {
            if (null !== d.child) {
                f = d.stateNode.containerInfo;
                g = !0;
                d.child.return = d;
                d = d.child;
                continue;
            }
        } else if (Ki(a, d, c), null !== d.child) {
            d.child.return = d;
            d = d.child;
            continue;
        }
        if (d === b) break;
        for(; null === d.sibling;){
            if (null === d.return || d.return === b) return;
            d = d.return;
            4 === d.tag && (e = !1);
        }
        d.sibling.return = d.return;
        d = d.sibling;
    }
}
function Si(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            Hi(3, b);
            return;
        case 1:
            return;
        case 5:
            var c = b.stateNode;
            if (null != c) {
                var d = b.memoizedProps, e = null !== a ? a.memoizedProps : d;
                a = b.type;
                var f = b.updateQueue;
                b.updateQueue = null;
                if (null !== f) {
                    c[Nd] = d;
                    "input" === a && "radio" === d.type && null != d.name && Bb(c, d);
                    pd(a, e);
                    b = pd(a, d);
                    for(e = 0; e < f.length; e += 2){
                        var g = f[e], h = f[e + 1];
                        "style" === g ? md(c, h) : "dangerouslySetInnerHTML" === g ? Qb(c, h) : "children" === g ? Rb(c, h) : Xa(c, g, h, b);
                    }
                    switch(a){
                        case "input":
                            Cb(c, d);
                            break;
                        case "textarea":
                            Kb(c, d);
                            break;
                        case "select":
                            b = c._wrapperState.wasMultiple, c._wrapperState.wasMultiple = !!d.multiple, a = d.value, null != a ? Hb(c, !!d.multiple, a, !1) : b !== !!d.multiple && (null != d.defaultValue ? Hb(c, !!d.multiple, d.defaultValue, !0) : Hb(c, !!d.multiple, d.multiple ? [] : "", !1));
                    }
                }
            }
            return;
        case 6:
            if (null === b.stateNode) throw Error(u(162));
            b.stateNode.nodeValue = b.memoizedProps;
            return;
        case 3:
            b = b.stateNode;
            b.hydrate && (b.hydrate = !1, Vc(b.containerInfo));
            return;
        case 12:
            return;
        case 13:
            c = b;
            null === b.memoizedState ? d = !1 : (d = !0, c = b.child, Ti = $f());
            if (null !== c) a: for(a = c;;){
                if (5 === a.tag) f = a.stateNode, d ? (f = f.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (f = a.stateNode, e = a.memoizedProps.style, e = void 0 !== e && null !== e && e.hasOwnProperty("display") ? e.display : null, f.style.display = ld("display", e));
                else if (6 === a.tag) a.stateNode.nodeValue = d ? "" : a.memoizedProps;
                else if (13 === a.tag && null !== a.memoizedState && null === a.memoizedState.dehydrated) {
                    f = a.child.sibling;
                    f.return = a;
                    a = f;
                    continue;
                } else if (null !== a.child) {
                    a.child.return = a;
                    a = a.child;
                    continue;
                }
                if (a === c) break;
                for(; null === a.sibling;){
                    if (null === a.return || a.return === c) break a;
                    a = a.return;
                }
                a.sibling.return = a.return;
                a = a.sibling;
            }
            Ui(b);
            return;
        case 19:
            Ui(b);
            return;
        case 17:
            return;
    }
    throw Error(u(163));
}
function Ui(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new Bi);
        b.forEach(function(b) {
            var d = Vi.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
var Wi = "function" === typeof WeakMap ? WeakMap : Map;
function Xi(a, b, c) {
    c = wg(c, null);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        Yi || (Yi = !0, Zi = d);
        Ci(a, b);
    };
    return c;
}
function $i(a, b, c) {
    c = wg(c, null);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            Ci(a, b);
            return d(e);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        "function" !== typeof d && (null === aj ? aj = new Set([
            this
        ]) : aj.add(this), Ci(a, b));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
var bj = Math.ceil, cj = Wa.ReactCurrentDispatcher, dj = Wa.ReactCurrentOwner, V = 0, ej = 8, fj = 16, gj = 32, ti = 0, hj = 1, ij = 2, ui = 3, vi = 4, jj = 5, W = V, T = null, X = null, U = 0, S = ti, kj = null, lj = 1073741823, mj = 1073741823, nj = null, wi = 0, oj = !1, Ti = 0, pj = 500, Y = null, Yi = !1, Zi = null, aj = null, qj = !1, rj = null, sj = 90, tj = null, uj = 0, vj = null, wj = 0;
function Gg() {
    return (W & (fj | gj)) !== V ? 1073741821 - ($f() / 10 | 0) : 0 !== wj ? wj : wj = 1073741821 - ($f() / 10 | 0);
}
function Hg(a, b, c) {
    b = b.mode;
    if (0 === (b & 2)) return 1073741823;
    var d = ag();
    if (0 === (b & 4)) return 99 === d ? 1073741823 : 1073741822;
    if ((W & fj) !== V) return U;
    if (null !== c) a = hg(a, c.timeoutMs | 0 || 5E3, 250);
    else switch(d){
        case 99:
            a = 1073741823;
            break;
        case 98:
            a = hg(a, 150, 100);
            break;
        case 97:
        case 96:
            a = hg(a, 5E3, 250);
            break;
        case 95:
            a = 2;
            break;
        default:
            throw Error(u(326));
    }
    null !== T && a === U && --a;
    return a;
}
function Ig(a, b) {
    if (50 < uj) throw uj = 0, vj = null, Error(u(185));
    a = xj(a, b);
    if (null !== a) {
        var c = ag();
        1073741823 === b ? (W & ej) !== V && (W & (fj | gj)) === V ? yj(a) : (Z(a), W === V && gg()) : Z(a);
        (W & 4) === V || 98 !== c && 99 !== c || (null === tj ? tj = new Map([
            [
                a,
                b
            ]
        ]) : (c = tj.get(a), (void 0 === c || c > b) && tj.set(a, b)));
    }
}
function xj(a, b) {
    a.expirationTime < b && (a.expirationTime = b);
    var c = a.alternate;
    null !== c && c.expirationTime < b && (c.expirationTime = b);
    var d = a.return, e = null;
    if (null === d && 3 === a.tag) e = a.stateNode;
    else for(; null !== d;){
        c = d.alternate;
        d.childExpirationTime < b && (d.childExpirationTime = b);
        null !== c && c.childExpirationTime < b && (c.childExpirationTime = b);
        if (null === d.return && 3 === d.tag) {
            e = d.stateNode;
            break;
        }
        d = d.return;
    }
    null !== e && (T === e && (Bg(b), S === vi && xi(e, U)), yi(e, b));
    return e;
}
function zj(a) {
    var b = a.lastExpiredTime;
    if (0 !== b) return b;
    b = a.firstPendingTime;
    if (!Aj(a, b)) return b;
    var c = a.lastPingedTime;
    a = a.nextKnownPendingLevel;
    a = c > a ? c : a;
    return 2 >= a && b !== a ? 0 : a;
}
function Z(a) {
    if (0 !== a.lastExpiredTime) a.callbackExpirationTime = 1073741823, a.callbackPriority = 99, a.callbackNode = eg(yj.bind(null, a));
    else {
        var b = zj(a), c = a.callbackNode;
        if (0 === b) null !== c && (a.callbackNode = null, a.callbackExpirationTime = 0, a.callbackPriority = 90);
        else {
            var d = Gg();
            1073741823 === b ? d = 99 : 1 === b || 2 === b ? d = 95 : (d = 10 * (1073741821 - b) - 10 * (1073741821 - d), d = 0 >= d ? 99 : 250 >= d ? 98 : 5250 >= d ? 97 : 95);
            if (null !== c) {
                var e = a.callbackPriority;
                if (a.callbackExpirationTime === b && e >= d) return;
                c !== Tf && Kf(c);
            }
            a.callbackExpirationTime = b;
            a.callbackPriority = d;
            b = 1073741823 === b ? eg(yj.bind(null, a)) : dg(d, Bj.bind(null, a), {
                timeout: 10 * (1073741821 - b) - $f()
            });
            a.callbackNode = b;
        }
    }
}
function Bj(a, b) {
    wj = 0;
    if (b) return b = Gg(), Cj(a, b), Z(a), null;
    var c = zj(a);
    if (0 !== c) {
        b = a.callbackNode;
        if ((W & (fj | gj)) !== V) throw Error(u(327));
        Dj();
        a === T && c === U || Ej(a, c);
        if (null !== X) {
            var d = W;
            W |= fj;
            var e = Fj();
            for(;;)try {
                Gj();
                break;
            } catch (h) {
                Hj(a, h);
            }
            ng();
            W = d;
            cj.current = e;
            if (S === hj) throw b = kj, Ej(a, c), xi(a, c), Z(a), b;
            if (null === X) switch(e = a.finishedWork = a.current.alternate, a.finishedExpirationTime = c, d = S, T = null, d){
                case ti:
                case hj:
                    throw Error(u(345));
                case ij:
                    Cj(a, 2 < c ? 2 : c);
                    break;
                case ui:
                    xi(a, c);
                    d = a.lastSuspendedTime;
                    c === d && (a.nextKnownPendingLevel = Ij(e));
                    if (1073741823 === lj && (e = Ti + pj - $f(), 10 < e)) {
                        if (oj) {
                            var f = a.lastPingedTime;
                            if (0 === f || f >= c) {
                                a.lastPingedTime = c;
                                Ej(a, c);
                                break;
                            }
                        }
                        f = zj(a);
                        if (0 !== f && f !== c) break;
                        if (0 !== d && d !== c) {
                            a.lastPingedTime = d;
                            break;
                        }
                        a.timeoutHandle = Hd(Jj.bind(null, a), e);
                        break;
                    }
                    Jj(a);
                    break;
                case vi:
                    xi(a, c);
                    d = a.lastSuspendedTime;
                    c === d && (a.nextKnownPendingLevel = Ij(e));
                    if (oj && (e = a.lastPingedTime, 0 === e || e >= c)) {
                        a.lastPingedTime = c;
                        Ej(a, c);
                        break;
                    }
                    e = zj(a);
                    if (0 !== e && e !== c) break;
                    if (0 !== d && d !== c) {
                        a.lastPingedTime = d;
                        break;
                    }
                    1073741823 !== mj ? d = 10 * (1073741821 - mj) - $f() : 1073741823 === lj ? d = 0 : (d = 10 * (1073741821 - lj) - 5E3, e = $f(), c = 10 * (1073741821 - c) - e, d = e - d, 0 > d && (d = 0), d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * bj(d / 1960)) - d, c < d && (d = c));
                    if (10 < d) {
                        a.timeoutHandle = Hd(Jj.bind(null, a), d);
                        break;
                    }
                    Jj(a);
                    break;
                case jj:
                    if (1073741823 !== lj && null !== nj) {
                        f = lj;
                        var g = nj;
                        d = g.busyMinDurationMs | 0;
                        0 >= d ? d = 0 : (e = g.busyDelayMs | 0, f = $f() - (10 * (1073741821 - f) - (g.timeoutMs | 0 || 5E3)), d = f <= e ? 0 : e + d - f);
                        if (10 < d) {
                            xi(a, c);
                            a.timeoutHandle = Hd(Jj.bind(null, a), d);
                            break;
                        }
                    }
                    Jj(a);
                    break;
                default:
                    throw Error(u(329));
            }
            Z(a);
            if (a.callbackNode === b) return Bj.bind(null, a);
        }
    }
    return null;
}
function yj(a) {
    var b = a.lastExpiredTime;
    b = 0 !== b ? b : 1073741823;
    if ((W & (fj | gj)) !== V) throw Error(u(327));
    Dj();
    a === T && b === U || Ej(a, b);
    if (null !== X) {
        var c = W;
        W |= fj;
        var d = Fj();
        for(;;)try {
            Kj();
            break;
        } catch (e) {
            Hj(a, e);
        }
        ng();
        W = c;
        cj.current = d;
        if (S === hj) throw c = kj, Ej(a, b), xi(a, b), Z(a), c;
        if (null !== X) throw Error(u(261));
        a.finishedWork = a.current.alternate;
        a.finishedExpirationTime = b;
        T = null;
        Jj(a);
        Z(a);
    }
    return null;
}
function Lj() {
    if (null !== tj) {
        var a = tj;
        tj = null;
        a.forEach(function(a, c) {
            Cj(c, a);
            Z(c);
        });
        gg();
    }
}
function Mj(a, b) {
    var c = W;
    W |= 1;
    try {
        return a(b);
    } finally{
        W = c, W === V && gg();
    }
}
function Nj(a, b) {
    var c = W;
    W &= -2;
    W |= ej;
    try {
        return a(b);
    } finally{
        W = c, W === V && gg();
    }
}
function Ej(a, b) {
    a.finishedWork = null;
    a.finishedExpirationTime = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, Id(c));
    if (null !== X) for(c = X.return; null !== c;){
        var d = c;
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && Df();
                break;
            case 3:
                eh();
                H(K);
                H(J);
                break;
            case 5:
                gh(d);
                break;
            case 4:
                eh();
                break;
            case 13:
                H(M);
                break;
            case 19:
                H(M);
                break;
            case 10:
                og(d);
        }
        c = c.return;
    }
    T = a;
    X = Sg(a.current, null);
    U = b;
    S = ti;
    kj = null;
    mj = lj = 1073741823;
    nj = null;
    wi = 0;
    oj = !1;
}
function Hj(a, b) {
    do {
        try {
            ng();
            jh.current = sh;
            if (mh) for(var c = N.memoizedState; null !== c;){
                var d = c.queue;
                null !== d && (d.pending = null);
                c = c.next;
            }
            lh = 0;
            P = O = N = null;
            mh = !1;
            if (null === X || null === X.return) return S = hj, kj = b, X = null;
            a: {
                var e = a, f = X.return, g = X, h = b;
                b = U;
                g.effectTag |= 2048;
                g.firstEffect = g.lastEffect = null;
                if (null !== h && "object" === typeof h && "function" === typeof h.then) {
                    var k = h;
                    if (0 === (g.mode & 2)) {
                        var l = g.alternate;
                        l ? (g.updateQueue = l.updateQueue, g.memoizedState = l.memoizedState, g.expirationTime = l.expirationTime) : (g.updateQueue = null, g.memoizedState = null);
                    }
                    var m = 0 !== (M.current & 1), p = f;
                    do {
                        var x;
                        if (x = 13 === p.tag) {
                            var z = p.memoizedState;
                            if (null !== z) x = null !== z.dehydrated ? !0 : !1;
                            else {
                                var ca = p.memoizedProps;
                                x = void 0 === ca.fallback ? !1 : !0 !== ca.unstable_avoidThisFallback ? !0 : m ? !1 : !0;
                            }
                        }
                        if (x) {
                            var D = p.updateQueue;
                            if (null === D) {
                                var t = new Set;
                                t.add(k);
                                p.updateQueue = t;
                            } else D.add(k);
                            if (0 === (p.mode & 2)) {
                                p.effectTag |= 64;
                                g.effectTag &= -2981;
                                if (1 === g.tag) {
                                    if (null === g.alternate) g.tag = 17;
                                    else {
                                        var y = wg(1073741823, null);
                                        y.tag = 2;
                                        xg(g, y);
                                    }
                                }
                                g.expirationTime = 1073741823;
                                break a;
                            }
                            h = void 0;
                            g = b;
                            var A = e.pingCache;
                            null === A ? (A = e.pingCache = new Wi, h = new Set, A.set(k, h)) : (h = A.get(k), void 0 === h && (h = new Set, A.set(k, h)));
                            if (!h.has(g)) {
                                h.add(g);
                                var q = Oj.bind(null, e, k, g);
                                k.then(q, q);
                            }
                            p.effectTag |= 4096;
                            p.expirationTime = b;
                            break a;
                        }
                        p = p.return;
                    }while (null !== p);
                    h = Error((pb(g.type) || "A React component") + " suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display." + qb(g));
                }
                S !== jj && (S = ij);
                h = Ai(h, g);
                p = f;
                do {
                    switch(p.tag){
                        case 3:
                            k = h;
                            p.effectTag |= 4096;
                            p.expirationTime = b;
                            var B = Xi(p, k, b);
                            yg(p, B);
                            break a;
                        case 1:
                            k = h;
                            var w = p.type, ub = p.stateNode;
                            if (0 === (p.effectTag & 64) && ("function" === typeof w.getDerivedStateFromError || null !== ub && "function" === typeof ub.componentDidCatch && (null === aj || !aj.has(ub)))) {
                                p.effectTag |= 4096;
                                p.expirationTime = b;
                                var vb = $i(p, k, b);
                                yg(p, vb);
                                break a;
                            }
                    }
                    p = p.return;
                }while (null !== p);
            }
            X = Pj(X);
        } catch (Xc) {
            b = Xc;
            continue;
        }
        break;
    }while (1);
}
function Fj() {
    var a = cj.current;
    cj.current = sh;
    return null === a ? sh : a;
}
function Ag(a, b) {
    a < lj && 2 < a && (lj = a);
    null !== b && a < mj && 2 < a && (mj = a, nj = b);
}
function Bg(a) {
    a > wi && (wi = a);
}
function Kj() {
    for(; null !== X;)X = Qj(X);
}
function Gj() {
    for(; null !== X && !Uf();)X = Qj(X);
}
function Qj(a) {
    var b = Rj(a.alternate, a, U);
    a.memoizedProps = a.pendingProps;
    null === b && (b = Pj(a));
    dj.current = null;
    return b;
}
function Pj(a) {
    X = a;
    do {
        var b = X.alternate;
        a = X.return;
        if (0 === (X.effectTag & 2048)) {
            b = si(b, X, U);
            if (1 === U || 1 !== X.childExpirationTime) {
                for(var c = 0, d = X.child; null !== d;){
                    var e = d.expirationTime, f = d.childExpirationTime;
                    e > c && (c = e);
                    f > c && (c = f);
                    d = d.sibling;
                }
                X.childExpirationTime = c;
            }
            if (null !== b) return b;
            null !== a && 0 === (a.effectTag & 2048) && (null === a.firstEffect && (a.firstEffect = X.firstEffect), null !== X.lastEffect && (null !== a.lastEffect && (a.lastEffect.nextEffect = X.firstEffect), a.lastEffect = X.lastEffect), 1 < X.effectTag && (null !== a.lastEffect ? a.lastEffect.nextEffect = X : a.firstEffect = X, a.lastEffect = X));
        } else {
            b = zi(X);
            if (null !== b) return b.effectTag &= 2047, b;
            null !== a && (a.firstEffect = a.lastEffect = null, a.effectTag |= 2048);
        }
        b = X.sibling;
        if (null !== b) return b;
        X = a;
    }while (null !== X);
    S === ti && (S = jj);
    return null;
}
function Ij(a) {
    var b = a.expirationTime;
    a = a.childExpirationTime;
    return b > a ? b : a;
}
function Jj(a) {
    var b = ag();
    cg(99, Sj.bind(null, a, b));
    return null;
}
function Sj(a, b) {
    do Dj();
    while (null !== rj);
    if ((W & (fj | gj)) !== V) throw Error(u(327));
    var c = a.finishedWork, d = a.finishedExpirationTime;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedExpirationTime = 0;
    if (c === a.current) throw Error(u(177));
    a.callbackNode = null;
    a.callbackExpirationTime = 0;
    a.callbackPriority = 90;
    a.nextKnownPendingLevel = 0;
    var e = Ij(c);
    a.firstPendingTime = e;
    d <= a.lastSuspendedTime ? a.firstSuspendedTime = a.lastSuspendedTime = a.nextKnownPendingLevel = 0 : d <= a.firstSuspendedTime && (a.firstSuspendedTime = d - 1);
    d <= a.lastPingedTime && (a.lastPingedTime = 0);
    d <= a.lastExpiredTime && (a.lastExpiredTime = 0);
    a === T && (X = T = null, U = 0);
    1 < c.effectTag ? null !== c.lastEffect ? (c.lastEffect.nextEffect = c, e = c.firstEffect) : e = c : e = c.firstEffect;
    if (null !== e) {
        var f = W;
        W |= gj;
        dj.current = null;
        Dd = fd;
        var g = xd();
        if (yd(g)) {
            if ("selectionStart" in g) var h = {
                start: g.selectionStart,
                end: g.selectionEnd
            };
            else a: {
                h = (h = g.ownerDocument) && h.defaultView || window;
                var k = h.getSelection && h.getSelection();
                if (k && 0 !== k.rangeCount) {
                    h = k.anchorNode;
                    var l = k.anchorOffset, m = k.focusNode;
                    k = k.focusOffset;
                    try {
                        h.nodeType, m.nodeType;
                    } catch (wb) {
                        h = null;
                        break a;
                    }
                    var p = 0, x = -1, z = -1, ca = 0, D = 0, t = g, y = null;
                    b: for(;;){
                        for(var A;;){
                            t !== h || 0 !== l && 3 !== t.nodeType || (x = p + l);
                            t !== m || 0 !== k && 3 !== t.nodeType || (z = p + k);
                            3 === t.nodeType && (p += t.nodeValue.length);
                            if (null === (A = t.firstChild)) break;
                            y = t;
                            t = A;
                        }
                        for(;;){
                            if (t === g) break b;
                            y === h && ++ca === l && (x = p);
                            y === m && ++D === k && (z = p);
                            if (null !== (A = t.nextSibling)) break;
                            t = y;
                            y = t.parentNode;
                        }
                        t = A;
                    }
                    h = -1 === x || -1 === z ? null : {
                        start: x,
                        end: z
                    };
                } else h = null;
            }
            h = h || {
                start: 0,
                end: 0
            };
        } else h = null;
        Ed = {
            activeElementDetached: null,
            focusedElem: g,
            selectionRange: h
        };
        fd = !1;
        Y = e;
        do try {
            Tj();
        } catch (wb) {
            if (null === Y) throw Error(u(330));
            Ei(Y, wb);
            Y = Y.nextEffect;
        }
        while (null !== Y);
        Y = e;
        do try {
            for(g = a, h = b; null !== Y;){
                var q = Y.effectTag;
                q & 16 && Rb(Y.stateNode, "");
                if (q & 128) {
                    var B = Y.alternate;
                    if (null !== B) {
                        var w = B.ref;
                        null !== w && ("function" === typeof w ? w(null) : w.current = null);
                    }
                }
                switch(q & 1038){
                    case 2:
                        Pi(Y);
                        Y.effectTag &= -3;
                        break;
                    case 6:
                        Pi(Y);
                        Y.effectTag &= -3;
                        Si(Y.alternate, Y);
                        break;
                    case 1024:
                        Y.effectTag &= -1025;
                        break;
                    case 1028:
                        Y.effectTag &= -1025;
                        Si(Y.alternate, Y);
                        break;
                    case 4:
                        Si(Y.alternate, Y);
                        break;
                    case 8:
                        l = Y, Mi(g, l, h), Ni(l);
                }
                Y = Y.nextEffect;
            }
        } catch (wb) {
            if (null === Y) throw Error(u(330));
            Ei(Y, wb);
            Y = Y.nextEffect;
        }
        while (null !== Y);
        w = Ed;
        B = xd();
        q = w.focusedElem;
        h = w.selectionRange;
        if (B !== q && q && q.ownerDocument && wd(q.ownerDocument.documentElement, q)) {
            null !== h && yd(q) && (B = h.start, w = h.end, void 0 === w && (w = B), "selectionStart" in q ? (q.selectionStart = B, q.selectionEnd = Math.min(w, q.value.length)) : (w = (B = q.ownerDocument || document) && B.defaultView || window, w.getSelection && (w = w.getSelection(), l = q.textContent.length, g = Math.min(h.start, l), h = void 0 === h.end ? g : Math.min(h.end, l), !w.extend && g > h && (l = h, h = g, g = l), l = vd(q, g), m = vd(q, h), l && m && (1 !== w.rangeCount || w.anchorNode !== l.node || w.anchorOffset !== l.offset || w.focusNode !== m.node || w.focusOffset !== m.offset) && (B = B.createRange(), B.setStart(l.node, l.offset), w.removeAllRanges(), g > h ? (w.addRange(B), w.extend(m.node, m.offset)) : (B.setEnd(m.node, m.offset), w.addRange(B))))));
            B = [];
            for(w = q; w = w.parentNode;)1 === w.nodeType && B.push({
                element: w,
                left: w.scrollLeft,
                top: w.scrollTop
            });
            "function" === typeof q.focus && q.focus();
            for(q = 0; q < B.length; q++)w = B[q], w.element.scrollLeft = w.left, w.element.scrollTop = w.top;
        }
        fd = !!Dd;
        Ed = Dd = null;
        a.current = c;
        Y = e;
        do try {
            for(q = a; null !== Y;){
                var ub = Y.effectTag;
                ub & 36 && Ji(q, Y.alternate, Y);
                if (ub & 128) {
                    B = void 0;
                    var vb = Y.ref;
                    if (null !== vb) {
                        var Xc = Y.stateNode;
                        switch(Y.tag){
                            case 5:
                                B = Xc;
                                break;
                            default:
                                B = Xc;
                        }
                        "function" === typeof vb ? vb(B) : vb.current = B;
                    }
                }
                Y = Y.nextEffect;
            }
        } catch (wb) {
            if (null === Y) throw Error(u(330));
            Ei(Y, wb);
            Y = Y.nextEffect;
        }
        while (null !== Y);
        Y = null;
        Vf();
        W = f;
    } else a.current = c;
    if (qj) qj = !1, rj = a, sj = b;
    else for(Y = e; null !== Y;)b = Y.nextEffect, Y.nextEffect = null, Y = b;
    b = a.firstPendingTime;
    0 === b && (aj = null);
    1073741823 === b ? a === vj ? uj++ : (uj = 0, vj = a) : uj = 0;
    "function" === typeof Uj && Uj(c.stateNode, d);
    Z(a);
    if (Yi) throw Yi = !1, a = Zi, Zi = null, a;
    if ((W & ej) !== V) return null;
    gg();
    return null;
}
function Tj() {
    for(; null !== Y;){
        var a = Y.effectTag;
        0 !== (a & 256) && Gi(Y.alternate, Y);
        0 === (a & 512) || qj || (qj = !0, dg(97, function() {
            Dj();
            return null;
        }));
        Y = Y.nextEffect;
    }
}
function Dj() {
    if (90 !== sj) {
        var a = 97 < sj ? 97 : sj;
        sj = 90;
        return cg(a, Vj);
    }
}
function Vj() {
    if (null === rj) return !1;
    var a = rj;
    rj = null;
    if ((W & (fj | gj)) !== V) throw Error(u(331));
    var b = W;
    W |= gj;
    for(a = a.current.firstEffect; null !== a;){
        try {
            var c = a;
            if (0 !== (c.effectTag & 512)) switch(c.tag){
                case 0:
                case 11:
                case 15:
                case 22:
                    Hi(5, c), Ii(5, c);
            }
        } catch (d) {
            if (null === a) throw Error(u(330));
            Ei(a, d);
        }
        c = a.nextEffect;
        a.nextEffect = null;
        a = c;
    }
    W = b;
    gg();
    return !0;
}
function Wj(a, b, c) {
    b = Ai(c, b);
    b = Xi(a, b, 1073741823);
    xg(a, b);
    a = xj(a, 1073741823);
    null !== a && Z(a);
}
function Ei(a, b) {
    if (3 === a.tag) Wj(a, a, b);
    else for(var c = a.return; null !== c;){
        if (3 === c.tag) {
            Wj(c, a, b);
            break;
        } else if (1 === c.tag) {
            var d = c.stateNode;
            if ("function" === typeof c.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === aj || !aj.has(d))) {
                a = Ai(b, a);
                a = $i(c, a, 1073741823);
                xg(c, a);
                c = xj(c, 1073741823);
                null !== c && Z(c);
                break;
            }
        }
        c = c.return;
    }
}
function Oj(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    T === a && U === c ? S === vi || S === ui && 1073741823 === lj && $f() - Ti < pj ? Ej(a, U) : oj = !0 : Aj(a, c) && (b = a.lastPingedTime, 0 !== b && b < c || (a.lastPingedTime = c, Z(a)));
}
function Vi(a, b) {
    var c = a.stateNode;
    null !== c && c.delete(b);
    b = 0;
    0 === b && (b = Gg(), b = Hg(b, a, null));
    a = xj(a, b);
    null !== a && Z(a);
}
var Rj;
Rj = function(a, b, c) {
    var d = b.expirationTime;
    if (null !== a) {
        var e = b.pendingProps;
        if (a.memoizedProps !== e || K.current) rg = !0;
        else {
            if (d < c) {
                rg = !1;
                switch(b.tag){
                    case 3:
                        hi(b);
                        Xh();
                        break;
                    case 5:
                        fh(b);
                        if (b.mode & 4 && 1 !== c && e.hidden) return b.expirationTime = b.childExpirationTime = 1, null;
                        break;
                    case 1:
                        L(b.type) && Gf(b);
                        break;
                    case 4:
                        dh(b, b.stateNode.containerInfo);
                        break;
                    case 10:
                        d = b.memoizedProps.value;
                        e = b.type._context;
                        I(jg, e._currentValue);
                        e._currentValue = d;
                        break;
                    case 13:
                        if (null !== b.memoizedState) {
                            d = b.child.childExpirationTime;
                            if (0 !== d && d >= c) return ji(a, b, c);
                            I(M, M.current & 1);
                            b = $h(a, b, c);
                            return null !== b ? b.sibling : null;
                        }
                        I(M, M.current & 1);
                        break;
                    case 19:
                        d = b.childExpirationTime >= c;
                        if (0 !== (a.effectTag & 64)) {
                            if (d) return mi(a, b, c);
                            b.effectTag |= 64;
                        }
                        e = b.memoizedState;
                        null !== e && (e.rendering = null, e.tail = null);
                        I(M, M.current);
                        if (!d) return null;
                }
                return $h(a, b, c);
            }
            rg = !1;
        }
    } else rg = !1;
    b.expirationTime = 0;
    switch(b.tag){
        case 2:
            d = b.type;
            null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2);
            a = b.pendingProps;
            e = Cf(b, J.current);
            qg(b, c);
            e = oh(null, b, d, a, e, c);
            b.effectTag |= 1;
            if ("object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof) {
                b.tag = 1;
                b.memoizedState = null;
                b.updateQueue = null;
                if (L(d)) {
                    var f = !0;
                    Gf(b);
                } else f = !1;
                b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null;
                ug(b);
                var g = d.getDerivedStateFromProps;
                "function" === typeof g && Fg(b, d, g, a);
                e.updater = Jg;
                b.stateNode = e;
                e._reactInternalFiber = b;
                Ng(b, d, a, c);
                b = gi(null, b, d, !0, f, c);
            } else b.tag = 0, R(null, b, e, c), b = b.child;
            return b;
        case 16:
            a: {
                e = b.elementType;
                null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2);
                a = b.pendingProps;
                ob(e);
                if (1 !== e._status) throw e._result;
                e = e._result;
                b.type = e;
                f = b.tag = Xj(e);
                a = ig(e, a);
                switch(f){
                    case 0:
                        b = di(null, b, e, a, c);
                        break a;
                    case 1:
                        b = fi(null, b, e, a, c);
                        break a;
                    case 11:
                        b = Zh(null, b, e, a, c);
                        break a;
                    case 14:
                        b = ai(null, b, e, ig(e.type, a), d, c);
                        break a;
                }
                throw Error(u(306, e, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : ig(d, e), di(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : ig(d, e), fi(a, b, d, e, c);
        case 3:
            hi(b);
            d = b.updateQueue;
            if (null === a || null === d) throw Error(u(282));
            d = b.pendingProps;
            e = b.memoizedState;
            e = null !== e ? e.element : null;
            vg(a, b);
            zg(b, d, null, c);
            d = b.memoizedState.element;
            if (d === e) Xh(), b = $h(a, b, c);
            else {
                if (e = b.stateNode.hydrate) Ph = Jd(b.stateNode.containerInfo.firstChild), Oh = b, e = Qh = !0;
                if (e) for(c = Yg(b, null, d, c), b.child = c; c;)c.effectTag = c.effectTag & -3 | 1024, c = c.sibling;
                else R(a, b, d, c), Xh();
                b = b.child;
            }
            return b;
        case 5:
            return fh(b), null === a && Uh(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, Gd(d, e) ? g = null : null !== f && Gd(d, f) && (b.effectTag |= 16), ei(a, b), b.mode & 4 && 1 !== c && e.hidden ? (b.expirationTime = b.childExpirationTime = 1, b = null) : (R(a, b, g, c), b = b.child), b;
        case 6:
            return null === a && Uh(b), null;
        case 13:
            return ji(a, b, c);
        case 4:
            return dh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = Xg(b, null, d, c) : R(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : ig(d, e), Zh(a, b, d, e, c);
        case 7:
            return R(a, b, b.pendingProps, c), b.child;
        case 8:
            return R(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return R(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                g = b.memoizedProps;
                f = e.value;
                var h = b.type._context;
                I(jg, h._currentValue);
                h._currentValue = f;
                if (null !== g) {
                    if (h = g.value, f = $e(h, f) ? 0 : ("function" === typeof d._calculateChangedBits ? d._calculateChangedBits(h, f) : 1073741823) | 0, 0 === f) {
                        if (g.children === e.children && !K.current) {
                            b = $h(a, b, c);
                            break a;
                        }
                    } else for(h = b.child, null !== h && (h.return = b); null !== h;){
                        var k = h.dependencies;
                        if (null !== k) {
                            g = h.child;
                            for(var l = k.firstContext; null !== l;){
                                if (l.context === d && 0 !== (l.observedBits & f)) {
                                    1 === h.tag && (l = wg(c, null), l.tag = 2, xg(h, l));
                                    h.expirationTime < c && (h.expirationTime = c);
                                    l = h.alternate;
                                    null !== l && l.expirationTime < c && (l.expirationTime = c);
                                    pg(h.return, c);
                                    k.expirationTime < c && (k.expirationTime = c);
                                    break;
                                }
                                l = l.next;
                            }
                        } else g = 10 === h.tag ? h.type === b.type ? null : h.child : h.child;
                        if (null !== g) g.return = h;
                        else for(g = h; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            h = g.sibling;
                            if (null !== h) {
                                h.return = g.return;
                                g = h;
                                break;
                            }
                            g = g.return;
                        }
                        h = g;
                    }
                }
                R(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, f = b.pendingProps, d = f.children, qg(b, c), e = sg(e, f.unstable_observedBits), d = d(e), b.effectTag |= 1, R(a, b, d, c), b.child;
        case 14:
            return e = b.type, f = ig(e, b.pendingProps), f = ig(e.type, f), ai(a, b, e, f, d, c);
        case 15:
            return ci(a, b, b.type, b.pendingProps, d, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : ig(d, e), null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2), b.tag = 1, L(d) ? (a = !0, Gf(b)) : a = !1, qg(b, c), Lg(b, d, e), Ng(b, d, e, c), gi(null, b, d, !0, a, c);
        case 19:
            return mi(a, b, c);
    }
    throw Error(u(156, b.tag));
};
var Uj = null, Li = null;
function Yj(a) {
    if ("undefined" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) return !1;
    var b = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (b.isDisabled || !b.supportsFiber) return !0;
    try {
        var c = b.inject(a);
        Uj = function(a) {
            try {
                b.onCommitFiberRoot(c, a, void 0, 64 === (a.current.effectTag & 64));
            } catch (e) {}
        };
        Li = function(a) {
            try {
                b.onCommitFiberUnmount(c, a);
            } catch (e) {}
        };
    } catch (d) {}
    return !0;
}
function Zj(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.effectTag = 0;
    this.lastEffect = this.firstEffect = this.nextEffect = null;
    this.childExpirationTime = this.expirationTime = 0;
    this.alternate = null;
}
function Sh(a, b, c, d) {
    return new Zj(a, b, c, d);
}
function bi(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function Xj(a) {
    if ("function" === typeof a) return bi(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === gb) return 11;
        if (a === jb) return 14;
    }
    return 2;
}
function Sg(a, b) {
    var c = a.alternate;
    null === c ? (c = Sh(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.effectTag = 0, c.nextEffect = null, c.firstEffect = null, c.lastEffect = null);
    c.childExpirationTime = a.childExpirationTime;
    c.expirationTime = a.expirationTime;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        expirationTime: b.expirationTime,
        firstContext: b.firstContext,
        responders: b.responders
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function Ug(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) bi(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case ab:
            return Wg(c.children, e, f, b);
        case fb:
            g = 8;
            e |= 7;
            break;
        case bb:
            g = 8;
            e |= 1;
            break;
        case cb:
            return a = Sh(12, c, b, e | 8), a.elementType = cb, a.type = cb, a.expirationTime = f, a;
        case hb:
            return a = Sh(13, c, b, e), a.type = hb, a.elementType = hb, a.expirationTime = f, a;
        case ib:
            return a = Sh(19, c, b, e), a.elementType = ib, a.expirationTime = f, a;
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case db:
                    g = 10;
                    break a;
                case eb:
                    g = 9;
                    break a;
                case gb:
                    g = 11;
                    break a;
                case jb:
                    g = 14;
                    break a;
                case kb:
                    g = 16;
                    d = null;
                    break a;
                case lb:
                    g = 22;
                    break a;
            }
            throw Error(u(130, null == a ? a : typeof a, ""));
    }
    b = Sh(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.expirationTime = f;
    return b;
}
function Wg(a, b, c, d) {
    a = Sh(7, a, d, b);
    a.expirationTime = c;
    return a;
}
function Tg(a, b, c) {
    a = Sh(6, a, null, b);
    a.expirationTime = c;
    return a;
}
function Vg(a, b, c) {
    b = Sh(4, null !== a.children ? a.children : [], a.key, b);
    b.expirationTime = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function ak(a, b, c) {
    this.tag = b;
    this.current = null;
    this.containerInfo = a;
    this.pingCache = this.pendingChildren = null;
    this.finishedExpirationTime = 0;
    this.finishedWork = null;
    this.timeoutHandle = -1;
    this.pendingContext = this.context = null;
    this.hydrate = c;
    this.callbackNode = null;
    this.callbackPriority = 90;
    this.lastExpiredTime = this.lastPingedTime = this.nextKnownPendingLevel = this.lastSuspendedTime = this.firstSuspendedTime = this.firstPendingTime = 0;
}
function Aj(a, b) {
    var c = a.firstSuspendedTime;
    a = a.lastSuspendedTime;
    return 0 !== c && c >= b && a <= b;
}
function xi(a, b) {
    var c = a.firstSuspendedTime, d = a.lastSuspendedTime;
    c < b && (a.firstSuspendedTime = b);
    if (d > b || 0 === c) a.lastSuspendedTime = b;
    b <= a.lastPingedTime && (a.lastPingedTime = 0);
    b <= a.lastExpiredTime && (a.lastExpiredTime = 0);
}
function yi(a, b) {
    b > a.firstPendingTime && (a.firstPendingTime = b);
    var c = a.firstSuspendedTime;
    0 !== c && (b >= c ? a.firstSuspendedTime = a.lastSuspendedTime = a.nextKnownPendingLevel = 0 : b >= a.lastSuspendedTime && (a.lastSuspendedTime = b + 1), b > a.nextKnownPendingLevel && (a.nextKnownPendingLevel = b));
}
function Cj(a, b) {
    var c = a.lastExpiredTime;
    if (0 === c || c > b) a.lastExpiredTime = b;
}
function bk(a, b, c, d) {
    var e = b.current, f = Gg(), g = Dg.suspense;
    f = Hg(f, e, g);
    a: if (c) {
        c = c._reactInternalFiber;
        b: {
            if (dc(c) !== c || 1 !== c.tag) throw Error(u(170));
            var h = c;
            do {
                switch(h.tag){
                    case 3:
                        h = h.stateNode.context;
                        break b;
                    case 1:
                        if (L(h.type)) {
                            h = h.stateNode.__reactInternalMemoizedMergedChildContext;
                            break b;
                        }
                }
                h = h.return;
            }while (null !== h);
            throw Error(u(171));
        }
        if (1 === c.tag) {
            var k = c.type;
            if (L(k)) {
                c = Ff(c, k, h);
                break a;
            }
        }
        c = h;
    } else c = Af;
    null === b.context ? b.context = c : b.pendingContext = c;
    b = wg(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    xg(e, b);
    Ig(e, f);
    return f;
}
function ck(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function dk(a, b) {
    a = a.memoizedState;
    null !== a && null !== a.dehydrated && a.retryTime < b && (a.retryTime = b);
}
function ek(a, b) {
    dk(a, b);
    (a = a.alternate) && dk(a, b);
}
function fk(a, b, c) {
    c = null != c && !0 === c.hydrate;
    var d = new ak(a, b, c), e = Sh(3, null, null, 2 === b ? 7 : 1 === b ? 3 : 0);
    d.current = e;
    e.stateNode = d;
    ug(e);
    a[Od] = d.current;
    c && 0 !== b && Jc(a, 9 === a.nodeType ? a : a.ownerDocument);
    this._internalRoot = d;
}
fk.prototype.render = function(a) {
    bk(a, this._internalRoot, null, null);
};
fk.prototype.unmount = function() {
    var a = this._internalRoot, b = a.containerInfo;
    bk(null, a, null, function() {
        b[Od] = null;
    });
};
function gk(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function hk(a, b) {
    b || (b = a ? 9 === a.nodeType ? a.documentElement : a.firstChild : null, b = !(!b || 1 !== b.nodeType || !b.hasAttribute("data-reactroot")));
    if (!b) for(var c; c = a.lastChild;)a.removeChild(c);
    return new fk(a, 0, b ? {
        hydrate: !0
    } : void 0);
}
function ik(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f._internalRoot;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = ck(g);
                h.call(a);
            };
        }
        bk(b, g, a, e);
    } else {
        f = c._reactRootContainer = hk(c, d);
        g = f._internalRoot;
        if ("function" === typeof e) {
            var k = e;
            e = function() {
                var a = ck(g);
                k.call(a);
            };
        }
        Nj(function() {
            bk(b, g, a, e);
        });
    }
    return ck(g);
}
function jk(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $a,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
wc = function(a) {
    if (13 === a.tag) {
        var b = hg(Gg(), 150, 100);
        Ig(a, b);
        ek(a, b);
    }
};
xc = function(a) {
    13 === a.tag && (Ig(a, 3), ek(a, 3));
};
yc = function(a) {
    if (13 === a.tag) {
        var b = Gg();
        b = Hg(b, a, null);
        Ig(a, b);
        ek(a, b);
    }
};
za = function(a, b, c) {
    switch(b){
        case "input":
            Cb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = Qd(d);
                        if (!e) throw Error(u(90));
                        yb(d);
                        Cb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            Kb(a, c);
            break;
        case "select":
            b = c.value, null != b && Hb(a, !!c.multiple, b, !1);
    }
};
Fa = Mj;
Ga = function(a, b, c, d, e) {
    var f = W;
    W |= 4;
    try {
        return cg(98, a.bind(null, b, c, d, e));
    } finally{
        W = f, W === V && gg();
    }
};
Ha = function() {
    (W & (1 | fj | gj)) === V && (Lj(), Dj());
};
Ia = function(a, b) {
    var c = W;
    W |= 2;
    try {
        return a(b);
    } finally{
        W = c, W === V && gg();
    }
};
function kk(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!gk(b)) throw Error(u(200));
    return jk(a, b, null, c);
}
var lk = {
    Events: [
        Nc,
        Pd,
        Qd,
        xa,
        ta,
        Xd,
        function(a) {
            jc(a, Wd);
        },
        Da,
        Ea,
        id,
        mc,
        Dj,
        {
            current: !1
        }
    ]
};
(function(a) {
    var b = a.findFiberByHostInstance;
    return Yj($8coUR({}, a, {
        overrideHookState: null,
        overrideProps: null,
        setSuspenseHandler: null,
        scheduleUpdate: null,
        currentDispatcherRef: Wa.ReactCurrentDispatcher,
        findHostInstanceByFiber: function(a) {
            a = hc(a);
            return null === a ? null : a.stateNode;
        },
        findFiberByHostInstance: function(a) {
            return b ? b(a) : null;
        },
        findHostInstancesForRefresh: null,
        scheduleRefresh: null,
        scheduleRoot: null,
        setRefreshHandler: null,
        getCurrentFiber: null
    }));
})({
    findFiberByHostInstance: tc,
    bundleType: 0,
    version: "16.14.0",
    rendererPackageName: "react-dom"
});
exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = lk;
exports.createPortal = kk;
exports.findDOMNode = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternalFiber;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error(u(188));
        throw Error(u(268, Object.keys(a)));
    }
    a = hc(b);
    a = null === a ? null : a.stateNode;
    return a;
};
exports.flushSync = function(a, b) {
    if ((W & (fj | gj)) !== V) throw Error(u(187));
    var c = W;
    W |= 1;
    try {
        return cg(99, a.bind(null, b));
    } finally{
        W = c, gg();
    }
};
exports.hydrate = function(a, b, c) {
    if (!gk(b)) throw Error(u(200));
    return ik(null, a, b, !0, c);
};
exports.render = function(a, b, c) {
    if (!gk(b)) throw Error(u(200));
    return ik(null, a, b, !1, c);
};
exports.unmountComponentAtNode = function(a) {
    if (!gk(a)) throw Error(u(40));
    return a._reactRootContainer ? (Nj(function() {
        ik(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[Od] = null;
        });
    }), !0) : !1;
};
exports.unstable_batchedUpdates = Mj;
exports.unstable_createPortal = function(a, b) {
    return kk(a, b, 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null);
};
exports.unstable_renderSubtreeIntoContainer = function(a, b, c, d) {
    if (!gk(c)) throw Error(u(200));
    if (null == a || void 0 === a._reactInternalFiber) throw Error(u(38));
    return ik(a, b, c, !1, d);
};
exports.version = "16.14.0";

});
parcelRegister("fO90s", function(module, exports) {
"use strict";

module.exports = (parcelRequire("gcnCG"));

});
parcelRegister("gcnCG", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $bcb017604639e9d7$export$c4744153514ff05d, (v) => $bcb017604639e9d7$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $bcb017604639e9d7$export$d66a1c1c77bd778b, (v) => $bcb017604639e9d7$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $bcb017604639e9d7$export$3e506c1ccc9cc1a7, (v) => $bcb017604639e9d7$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $bcb017604639e9d7$export$e26fe2ed2fa76875, (v) => $bcb017604639e9d7$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $bcb017604639e9d7$export$502329bbf4b505b1, (v) => $bcb017604639e9d7$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $bcb017604639e9d7$export$6e3807111c4874c4, (v) => $bcb017604639e9d7$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $bcb017604639e9d7$export$c27134553091fb3a, (v) => $bcb017604639e9d7$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $bcb017604639e9d7$export$33ee1acdc04fd2a2, (v) => $bcb017604639e9d7$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $bcb017604639e9d7$export$b00a404bbd5edef2, (v) => $bcb017604639e9d7$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $bcb017604639e9d7$export$8352ce38b91d0c62, (v) => $bcb017604639e9d7$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $bcb017604639e9d7$export$d3dfb8e4810cb555, (v) => $bcb017604639e9d7$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $bcb017604639e9d7$export$839f9183b0465a69, (v) => $bcb017604639e9d7$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $bcb017604639e9d7$export$72fdf0e06517287b, (v) => $bcb017604639e9d7$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $bcb017604639e9d7$export$4b844e58a3e414b4, (v) => $bcb017604639e9d7$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $bcb017604639e9d7$export$816d2913ae6b83b1, (v) => $bcb017604639e9d7$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $bcb017604639e9d7$export$61bcfe829111a1d0, (v) => $bcb017604639e9d7$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $bcb017604639e9d7$export$7ee8c9beb337bc3f, (v) => $bcb017604639e9d7$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $bcb017604639e9d7$export$b5836b71941fa3ed, (v) => $bcb017604639e9d7$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $bcb017604639e9d7$export$cf845f2c119da08a, (v) => $bcb017604639e9d7$export$cf845f2c119da08a = v);
/** @license React v0.19.1
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bcb017604639e9d7$export$c4744153514ff05d;
var $bcb017604639e9d7$export$d66a1c1c77bd778b;
var $bcb017604639e9d7$export$3e506c1ccc9cc1a7;
var $bcb017604639e9d7$export$e26fe2ed2fa76875;
var $bcb017604639e9d7$export$502329bbf4b505b1;
var $bcb017604639e9d7$export$6e3807111c4874c4;
var $bcb017604639e9d7$export$c27134553091fb3a;
var $bcb017604639e9d7$export$33ee1acdc04fd2a2;
var $bcb017604639e9d7$export$b00a404bbd5edef2;
var $bcb017604639e9d7$export$8352ce38b91d0c62;
var $bcb017604639e9d7$export$d3dfb8e4810cb555;
var $bcb017604639e9d7$export$839f9183b0465a69;
var $bcb017604639e9d7$export$72fdf0e06517287b;
var $bcb017604639e9d7$export$4b844e58a3e414b4;
var $bcb017604639e9d7$export$816d2913ae6b83b1;
var $bcb017604639e9d7$export$61bcfe829111a1d0;
var $bcb017604639e9d7$export$7ee8c9beb337bc3f;
var $bcb017604639e9d7$export$b5836b71941fa3ed;
var $bcb017604639e9d7$export$cf845f2c119da08a;
"use strict";
var $bcb017604639e9d7$var$f, $bcb017604639e9d7$var$g, $bcb017604639e9d7$var$h, $bcb017604639e9d7$var$k, $bcb017604639e9d7$var$l;
if ("undefined" === typeof window || "function" !== typeof MessageChannel) {
    var $bcb017604639e9d7$var$p = null, $bcb017604639e9d7$var$q = null, $bcb017604639e9d7$var$t = function() {
        if (null !== $bcb017604639e9d7$var$p) try {
            var a = $bcb017604639e9d7$export$c4744153514ff05d();
            $bcb017604639e9d7$var$p(!0, a);
            $bcb017604639e9d7$var$p = null;
        } catch (b) {
            throw setTimeout($bcb017604639e9d7$var$t, 0), b;
        }
    }, $bcb017604639e9d7$var$u = Date.now();
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return Date.now() - $bcb017604639e9d7$var$u;
    };
    $bcb017604639e9d7$var$f = function(a) {
        null !== $bcb017604639e9d7$var$p ? setTimeout($bcb017604639e9d7$var$f, 0, a) : ($bcb017604639e9d7$var$p = a, setTimeout($bcb017604639e9d7$var$t, 0));
    };
    $bcb017604639e9d7$var$g = function(a, b) {
        $bcb017604639e9d7$var$q = setTimeout(a, b);
    };
    $bcb017604639e9d7$var$h = function() {
        clearTimeout($bcb017604639e9d7$var$q);
    };
    $bcb017604639e9d7$var$k = function() {
        return !1;
    };
    $bcb017604639e9d7$var$l = $bcb017604639e9d7$export$d66a1c1c77bd778b = function() {};
} else {
    var $bcb017604639e9d7$var$w = window.performance, $bcb017604639e9d7$var$x = window.Date, $bcb017604639e9d7$var$y = window.setTimeout, $bcb017604639e9d7$var$z = window.clearTimeout;
    if ("undefined" !== typeof console) {
        var $bcb017604639e9d7$var$A = window.cancelAnimationFrame;
        "function" !== typeof window.requestAnimationFrame && console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");
        "function" !== typeof $bcb017604639e9d7$var$A && console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");
    }
    if ("object" === typeof $bcb017604639e9d7$var$w && "function" === typeof $bcb017604639e9d7$var$w.now) $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$w.now();
    };
    else {
        var $bcb017604639e9d7$var$B = $bcb017604639e9d7$var$x.now();
        $bcb017604639e9d7$export$c4744153514ff05d = function() {
            return $bcb017604639e9d7$var$x.now() - $bcb017604639e9d7$var$B;
        };
    }
    var $bcb017604639e9d7$var$C = !1, $bcb017604639e9d7$var$D = null, $bcb017604639e9d7$var$E = -1, $bcb017604639e9d7$var$F = 5, $bcb017604639e9d7$var$G = 0;
    $bcb017604639e9d7$var$k = function() {
        return $bcb017604639e9d7$export$c4744153514ff05d() >= $bcb017604639e9d7$var$G;
    };
    $bcb017604639e9d7$var$l = function() {};
    $bcb017604639e9d7$export$d66a1c1c77bd778b = function(a) {
        0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported") : $bcb017604639e9d7$var$F = 0 < a ? Math.floor(1E3 / a) : 5;
    };
    var $bcb017604639e9d7$var$H = new MessageChannel, $bcb017604639e9d7$var$I = $bcb017604639e9d7$var$H.port2;
    $bcb017604639e9d7$var$H.port1.onmessage = function() {
        if (null !== $bcb017604639e9d7$var$D) {
            var a = $bcb017604639e9d7$export$c4744153514ff05d();
            $bcb017604639e9d7$var$G = a + $bcb017604639e9d7$var$F;
            try {
                $bcb017604639e9d7$var$D(!0, a) ? $bcb017604639e9d7$var$I.postMessage(null) : ($bcb017604639e9d7$var$C = !1, $bcb017604639e9d7$var$D = null);
            } catch (b) {
                throw $bcb017604639e9d7$var$I.postMessage(null), b;
            }
        } else $bcb017604639e9d7$var$C = !1;
    };
    $bcb017604639e9d7$var$f = function(a) {
        $bcb017604639e9d7$var$D = a;
        $bcb017604639e9d7$var$C || ($bcb017604639e9d7$var$C = !0, $bcb017604639e9d7$var$I.postMessage(null));
    };
    $bcb017604639e9d7$var$g = function(a, b) {
        $bcb017604639e9d7$var$E = $bcb017604639e9d7$var$y(function() {
            a($bcb017604639e9d7$export$c4744153514ff05d());
        }, b);
    };
    $bcb017604639e9d7$var$h = function() {
        $bcb017604639e9d7$var$z($bcb017604639e9d7$var$E);
        $bcb017604639e9d7$var$E = -1;
    };
}
function $bcb017604639e9d7$var$J(a, b) {
    var c = a.length;
    a.push(b);
    a: for(;;){
        var d = c - 1 >>> 1, e = a[d];
        if (void 0 !== e && 0 < $bcb017604639e9d7$var$K(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $bcb017604639e9d7$var$L(a) {
    a = a[0];
    return void 0 === a ? null : a;
}
function $bcb017604639e9d7$var$M(a) {
    var b = a[0];
    if (void 0 !== b) {
        var c = a.pop();
        if (c !== b) {
            a[0] = c;
            a: for(var d = 0, e = a.length; d < e;){
                var m = 2 * (d + 1) - 1, n = a[m], v = m + 1, r = a[v];
                if (void 0 !== n && 0 > $bcb017604639e9d7$var$K(n, c)) void 0 !== r && 0 > $bcb017604639e9d7$var$K(r, n) ? (a[d] = r, a[v] = c, d = v) : (a[d] = n, a[m] = c, d = m);
                else if (void 0 !== r && 0 > $bcb017604639e9d7$var$K(r, c)) a[d] = r, a[v] = c, d = v;
                else break a;
            }
        }
        return b;
    }
    return null;
}
function $bcb017604639e9d7$var$K(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
var $bcb017604639e9d7$var$N = [], $bcb017604639e9d7$var$O = [], $bcb017604639e9d7$var$P = 1, $bcb017604639e9d7$var$Q = null, $bcb017604639e9d7$var$R = 3, $bcb017604639e9d7$var$S = !1, $bcb017604639e9d7$var$T = !1, $bcb017604639e9d7$var$U = !1;
function $bcb017604639e9d7$var$V(a) {
    for(var b = $bcb017604639e9d7$var$L($bcb017604639e9d7$var$O); null !== b;){
        if (null === b.callback) $bcb017604639e9d7$var$M($bcb017604639e9d7$var$O);
        else if (b.startTime <= a) $bcb017604639e9d7$var$M($bcb017604639e9d7$var$O), b.sortIndex = b.expirationTime, $bcb017604639e9d7$var$J($bcb017604639e9d7$var$N, b);
        else break;
        b = $bcb017604639e9d7$var$L($bcb017604639e9d7$var$O);
    }
}
function $bcb017604639e9d7$var$W(a) {
    $bcb017604639e9d7$var$U = !1;
    $bcb017604639e9d7$var$V(a);
    if (!$bcb017604639e9d7$var$T) {
        if (null !== $bcb017604639e9d7$var$L($bcb017604639e9d7$var$N)) $bcb017604639e9d7$var$T = !0, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$X);
        else {
            var b = $bcb017604639e9d7$var$L($bcb017604639e9d7$var$O);
            null !== b && $bcb017604639e9d7$var$g($bcb017604639e9d7$var$W, b.startTime - a);
        }
    }
}
function $bcb017604639e9d7$var$X(a, b) {
    $bcb017604639e9d7$var$T = !1;
    $bcb017604639e9d7$var$U && ($bcb017604639e9d7$var$U = !1, $bcb017604639e9d7$var$h());
    $bcb017604639e9d7$var$S = !0;
    var c = $bcb017604639e9d7$var$R;
    try {
        $bcb017604639e9d7$var$V(b);
        for($bcb017604639e9d7$var$Q = $bcb017604639e9d7$var$L($bcb017604639e9d7$var$N); null !== $bcb017604639e9d7$var$Q && (!($bcb017604639e9d7$var$Q.expirationTime > b) || a && !$bcb017604639e9d7$var$k());){
            var d = $bcb017604639e9d7$var$Q.callback;
            if (null !== d) {
                $bcb017604639e9d7$var$Q.callback = null;
                $bcb017604639e9d7$var$R = $bcb017604639e9d7$var$Q.priorityLevel;
                var e = d($bcb017604639e9d7$var$Q.expirationTime <= b);
                b = $bcb017604639e9d7$export$c4744153514ff05d();
                "function" === typeof e ? $bcb017604639e9d7$var$Q.callback = e : $bcb017604639e9d7$var$Q === $bcb017604639e9d7$var$L($bcb017604639e9d7$var$N) && $bcb017604639e9d7$var$M($bcb017604639e9d7$var$N);
                $bcb017604639e9d7$var$V(b);
            } else $bcb017604639e9d7$var$M($bcb017604639e9d7$var$N);
            $bcb017604639e9d7$var$Q = $bcb017604639e9d7$var$L($bcb017604639e9d7$var$N);
        }
        if (null !== $bcb017604639e9d7$var$Q) var m = !0;
        else {
            var n = $bcb017604639e9d7$var$L($bcb017604639e9d7$var$O);
            null !== n && $bcb017604639e9d7$var$g($bcb017604639e9d7$var$W, n.startTime - b);
            m = !1;
        }
        return m;
    } finally{
        $bcb017604639e9d7$var$Q = null, $bcb017604639e9d7$var$R = c, $bcb017604639e9d7$var$S = !1;
    }
}
function $bcb017604639e9d7$var$Y(a) {
    switch(a){
        case 1:
            return -1;
        case 2:
            return 250;
        case 5:
            return 1073741823;
        case 4:
            return 1E4;
        default:
            return 5E3;
    }
}
var $bcb017604639e9d7$var$Z = $bcb017604639e9d7$var$l;
$bcb017604639e9d7$export$3e506c1ccc9cc1a7 = 5;
$bcb017604639e9d7$export$e26fe2ed2fa76875 = 1;
$bcb017604639e9d7$export$502329bbf4b505b1 = 4;
$bcb017604639e9d7$export$6e3807111c4874c4 = 3;
$bcb017604639e9d7$export$c27134553091fb3a = null;
$bcb017604639e9d7$export$33ee1acdc04fd2a2 = 2;
$bcb017604639e9d7$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$bcb017604639e9d7$export$8352ce38b91d0c62 = function() {
    $bcb017604639e9d7$var$T || $bcb017604639e9d7$var$S || ($bcb017604639e9d7$var$T = !0, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$X));
};
$bcb017604639e9d7$export$d3dfb8e4810cb555 = function() {
    return $bcb017604639e9d7$var$R;
};
$bcb017604639e9d7$export$839f9183b0465a69 = function() {
    return $bcb017604639e9d7$var$L($bcb017604639e9d7$var$N);
};
$bcb017604639e9d7$export$72fdf0e06517287b = function(a) {
    switch($bcb017604639e9d7$var$R){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $bcb017604639e9d7$var$R;
    }
    var c = $bcb017604639e9d7$var$R;
    $bcb017604639e9d7$var$R = b;
    try {
        return a();
    } finally{
        $bcb017604639e9d7$var$R = c;
    }
};
$bcb017604639e9d7$export$4b844e58a3e414b4 = function() {};
$bcb017604639e9d7$export$816d2913ae6b83b1 = $bcb017604639e9d7$var$Z;
$bcb017604639e9d7$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $bcb017604639e9d7$var$R;
    $bcb017604639e9d7$var$R = a;
    try {
        return b();
    } finally{
        $bcb017604639e9d7$var$R = c;
    }
};
$bcb017604639e9d7$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $bcb017604639e9d7$export$c4744153514ff05d();
    if ("object" === typeof c && null !== c) {
        var e = c.delay;
        e = "number" === typeof e && 0 < e ? d + e : d;
        c = "number" === typeof c.timeout ? c.timeout : $bcb017604639e9d7$var$Y(a);
    } else c = $bcb017604639e9d7$var$Y(a), e = d;
    c = e + c;
    a = {
        id: $bcb017604639e9d7$var$P++,
        callback: b,
        priorityLevel: a,
        startTime: e,
        expirationTime: c,
        sortIndex: -1
    };
    e > d ? (a.sortIndex = e, $bcb017604639e9d7$var$J($bcb017604639e9d7$var$O, a), null === $bcb017604639e9d7$var$L($bcb017604639e9d7$var$N) && a === $bcb017604639e9d7$var$L($bcb017604639e9d7$var$O) && ($bcb017604639e9d7$var$U ? $bcb017604639e9d7$var$h() : $bcb017604639e9d7$var$U = !0, $bcb017604639e9d7$var$g($bcb017604639e9d7$var$W, e - d))) : (a.sortIndex = c, $bcb017604639e9d7$var$J($bcb017604639e9d7$var$N, a), $bcb017604639e9d7$var$T || $bcb017604639e9d7$var$S || ($bcb017604639e9d7$var$T = !0, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$X)));
    return a;
};
$bcb017604639e9d7$export$b5836b71941fa3ed = function() {
    var a = $bcb017604639e9d7$export$c4744153514ff05d();
    $bcb017604639e9d7$var$V(a);
    var b = $bcb017604639e9d7$var$L($bcb017604639e9d7$var$N);
    return b !== $bcb017604639e9d7$var$Q && null !== $bcb017604639e9d7$var$Q && null !== b && null !== b.callback && b.startTime <= a && b.expirationTime < $bcb017604639e9d7$var$Q.expirationTime || $bcb017604639e9d7$var$k();
};
$bcb017604639e9d7$export$cf845f2c119da08a = function(a) {
    var b = $bcb017604639e9d7$var$R;
    return function() {
        var c = $bcb017604639e9d7$var$R;
        $bcb017604639e9d7$var$R = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $bcb017604639e9d7$var$R = c;
        }
    };
};

});




parcelRegister("hOzOt", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $kZO5c = parcelRequire("kZO5c");
function $cf82e2ef667d5788$var$emptyFunction() {}
function $cf82e2ef667d5788$var$emptyFunctionWithReset() {}
$cf82e2ef667d5788$var$emptyFunctionWithReset.resetWarningCache = $cf82e2ef667d5788$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $kZO5c) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = "Invariant Violation";
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $cf82e2ef667d5788$var$emptyFunctionWithReset,
        resetWarningCache: $cf82e2ef667d5788$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("kZO5c", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var $f4905a8b274aa381$var$ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = $f4905a8b274aa381$var$ReactPropTypesSecret;

});


parcelRegister("i5C3F", function(module, exports) {
//
module.exports = function shallowEqual(objA, objB, compare, compareContext) {
    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
    if (ret !== void 0) return !!ret;
    if (objA === objB) return true;
    if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    // Test for A's keys different from B.
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key)) return false;
        var valueA = objA[key];
        var valueB = objB[key];
        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (ret === false || ret === void 0 && valueA !== valueB) return false;
    }
    return true;
};

});

parcelRegister("3WZaY", function(module, exports) {

var $37I7d = parcelRequire("37I7d");

$37I7d.registerLanguage("1c", (parcelRequire("8m5tQ")));

$37I7d.registerLanguage("abnf", (parcelRequire("jzZa4")));

$37I7d.registerLanguage("accesslog", (parcelRequire("ePTdO")));

$37I7d.registerLanguage("actionscript", (parcelRequire("jYOgV")));

$37I7d.registerLanguage("ada", (parcelRequire("7wzO7")));

$37I7d.registerLanguage("angelscript", (parcelRequire("2PUwx")));

$37I7d.registerLanguage("apache", (parcelRequire("9hmTb")));

$37I7d.registerLanguage("applescript", (parcelRequire("8Vvqc")));

$37I7d.registerLanguage("arcade", (parcelRequire("j1C1h")));

$37I7d.registerLanguage("cpp", (parcelRequire("lmzvz")));

$37I7d.registerLanguage("arduino", (parcelRequire("hlBw7")));

$37I7d.registerLanguage("armasm", (parcelRequire("dlNkY")));

$37I7d.registerLanguage("xml", (parcelRequire("kB1SH")));

$37I7d.registerLanguage("asciidoc", (parcelRequire("gkbm1")));

$37I7d.registerLanguage("aspectj", (parcelRequire("63yFf")));

$37I7d.registerLanguage("autohotkey", (parcelRequire("8BAsx")));

$37I7d.registerLanguage("autoit", (parcelRequire("hfevr")));

$37I7d.registerLanguage("avrasm", (parcelRequire("6w0Vy")));

$37I7d.registerLanguage("awk", (parcelRequire("4FtHV")));

$37I7d.registerLanguage("axapta", (parcelRequire("HfSOx")));

$37I7d.registerLanguage("bash", (parcelRequire("cheUk")));

$37I7d.registerLanguage("basic", (parcelRequire("ahe0r")));

$37I7d.registerLanguage("bnf", (parcelRequire("MnP3I")));

$37I7d.registerLanguage("brainfuck", (parcelRequire("5IOyj")));

$37I7d.registerLanguage("cal", (parcelRequire("ixHQI")));

$37I7d.registerLanguage("capnproto", (parcelRequire("74F4K")));

$37I7d.registerLanguage("ceylon", (parcelRequire("jfjbY")));

$37I7d.registerLanguage("clean", (parcelRequire("bNu1a")));

$37I7d.registerLanguage("clojure", (parcelRequire("8Pjhc")));

$37I7d.registerLanguage("clojure-repl", (parcelRequire("4GKer")));

$37I7d.registerLanguage("cmake", (parcelRequire("e8EoF")));

$37I7d.registerLanguage("coffeescript", (parcelRequire("aK6iY")));

$37I7d.registerLanguage("coq", (parcelRequire("jlnGk")));

$37I7d.registerLanguage("cos", (parcelRequire("dUE2d")));

$37I7d.registerLanguage("crmsh", (parcelRequire("6QJGt")));

$37I7d.registerLanguage("crystal", (parcelRequire("2jJYq")));

$37I7d.registerLanguage("cs", (parcelRequire("85w0G")));

$37I7d.registerLanguage("csp", (parcelRequire("jrFBM")));

$37I7d.registerLanguage("css", (parcelRequire("jRcsb")));

$37I7d.registerLanguage("d", (parcelRequire("4N24D")));

$37I7d.registerLanguage("markdown", (parcelRequire("c1rMz")));

$37I7d.registerLanguage("dart", (parcelRequire("iUUCy")));

$37I7d.registerLanguage("delphi", (parcelRequire("7Nt9h")));

$37I7d.registerLanguage("diff", (parcelRequire("7CY40")));

$37I7d.registerLanguage("django", (parcelRequire("hSwnX")));

$37I7d.registerLanguage("dns", (parcelRequire("eb8CG")));

$37I7d.registerLanguage("dockerfile", (parcelRequire("5nRkt")));

$37I7d.registerLanguage("dos", (parcelRequire("9jpnQ")));

$37I7d.registerLanguage("dsconfig", (parcelRequire("3ipgz")));

$37I7d.registerLanguage("dts", (parcelRequire("gntgi")));

$37I7d.registerLanguage("dust", (parcelRequire("4CIEe")));

$37I7d.registerLanguage("ebnf", (parcelRequire("ahRAo")));

$37I7d.registerLanguage("elixir", (parcelRequire("b2fxC")));

$37I7d.registerLanguage("elm", (parcelRequire("j8dfG")));

$37I7d.registerLanguage("ruby", (parcelRequire("6ykfy")));

$37I7d.registerLanguage("erb", (parcelRequire("dliKk")));

$37I7d.registerLanguage("erlang-repl", (parcelRequire("ldUmx")));

$37I7d.registerLanguage("erlang", (parcelRequire("lpGxw")));

$37I7d.registerLanguage("excel", (parcelRequire("jetw7")));

$37I7d.registerLanguage("fix", (parcelRequire("2gdJp")));

$37I7d.registerLanguage("flix", (parcelRequire("gh4Hb")));

$37I7d.registerLanguage("fortran", (parcelRequire("b6Sro")));

$37I7d.registerLanguage("fsharp", (parcelRequire("l9gyx")));

$37I7d.registerLanguage("gams", (parcelRequire("dsDLC")));

$37I7d.registerLanguage("gauss", (parcelRequire("7BbCT")));

$37I7d.registerLanguage("gcode", (parcelRequire("iB6Fn")));

$37I7d.registerLanguage("gherkin", (parcelRequire("3BTtX")));

$37I7d.registerLanguage("glsl", (parcelRequire("gp7HK")));

$37I7d.registerLanguage("gml", (parcelRequire("3jkHQ")));

$37I7d.registerLanguage("go", (parcelRequire("eCnIO")));

$37I7d.registerLanguage("golo", (parcelRequire("fItrr")));

$37I7d.registerLanguage("gradle", (parcelRequire("l8Fwd")));

$37I7d.registerLanguage("groovy", (parcelRequire("8cUJC")));

$37I7d.registerLanguage("haml", (parcelRequire("higtC")));

$37I7d.registerLanguage("handlebars", (parcelRequire("hkha6")));

$37I7d.registerLanguage("haskell", (parcelRequire("ciB8y")));

$37I7d.registerLanguage("haxe", (parcelRequire("freT9")));

$37I7d.registerLanguage("hsp", (parcelRequire("fWLHt")));

$37I7d.registerLanguage("htmlbars", (parcelRequire("3lp2P")));

$37I7d.registerLanguage("http", (parcelRequire("dFhmZ")));

$37I7d.registerLanguage("hy", (parcelRequire("43oHJ")));

$37I7d.registerLanguage("inform7", (parcelRequire("c9gLT")));

$37I7d.registerLanguage("ini", (parcelRequire("3oDqc")));

$37I7d.registerLanguage("irpf90", (parcelRequire("gM8oT")));

$37I7d.registerLanguage("isbl", (parcelRequire("ewc1c")));

$37I7d.registerLanguage("java", (parcelRequire("lhbPW")));

$37I7d.registerLanguage("javascript", (parcelRequire("hXeXQ")));

$37I7d.registerLanguage("jboss-cli", (parcelRequire("14ZtH")));

$37I7d.registerLanguage("json", (parcelRequire("hIDeD")));

$37I7d.registerLanguage("julia", (parcelRequire("lMPba")));

$37I7d.registerLanguage("julia-repl", (parcelRequire("b58C8")));

$37I7d.registerLanguage("kotlin", (parcelRequire("kJmbc")));

$37I7d.registerLanguage("lasso", (parcelRequire("fcj0z")));

$37I7d.registerLanguage("ldif", (parcelRequire("e6tv5")));

$37I7d.registerLanguage("leaf", (parcelRequire("1zfr3")));

$37I7d.registerLanguage("less", (parcelRequire("hL458")));

$37I7d.registerLanguage("lisp", (parcelRequire("atsIb")));

$37I7d.registerLanguage("livecodeserver", (parcelRequire("16j1K")));

$37I7d.registerLanguage("livescript", (parcelRequire("5bJQY")));

$37I7d.registerLanguage("llvm", (parcelRequire("lCRAk")));

$37I7d.registerLanguage("lsl", (parcelRequire("9Re3w")));

$37I7d.registerLanguage("lua", (parcelRequire("7rY7i")));

$37I7d.registerLanguage("makefile", (parcelRequire("6YHAI")));

$37I7d.registerLanguage("mathematica", (parcelRequire("9e07y")));

$37I7d.registerLanguage("matlab", (parcelRequire("2DX6A")));

$37I7d.registerLanguage("maxima", (parcelRequire("aUT8O")));

$37I7d.registerLanguage("mel", (parcelRequire("z4A3a")));

$37I7d.registerLanguage("mercury", (parcelRequire("jU8Uv")));

$37I7d.registerLanguage("mipsasm", (parcelRequire("bwGfp")));

$37I7d.registerLanguage("mizar", (parcelRequire("fQkZ1")));

$37I7d.registerLanguage("perl", (parcelRequire("8MPLA")));

$37I7d.registerLanguage("mojolicious", (parcelRequire("fkIyq")));

$37I7d.registerLanguage("monkey", (parcelRequire("adFFh")));

$37I7d.registerLanguage("moonscript", (parcelRequire("6QlzV")));

$37I7d.registerLanguage("n1ql", (parcelRequire("39pDl")));

$37I7d.registerLanguage("nginx", (parcelRequire("gPoTD")));

$37I7d.registerLanguage("nimrod", (parcelRequire("YMF7L")));

$37I7d.registerLanguage("nix", (parcelRequire("1m60g")));

$37I7d.registerLanguage("nsis", (parcelRequire("dHmDc")));

$37I7d.registerLanguage("objectivec", (parcelRequire("dCB9T")));

$37I7d.registerLanguage("ocaml", (parcelRequire("f6CSv")));

$37I7d.registerLanguage("openscad", (parcelRequire("1vj8j")));

$37I7d.registerLanguage("oxygene", (parcelRequire("amStw")));

$37I7d.registerLanguage("parser3", (parcelRequire("caY3R")));

$37I7d.registerLanguage("pf", (parcelRequire("2YmYa")));

$37I7d.registerLanguage("pgsql", (parcelRequire("5h1Dk")));

$37I7d.registerLanguage("php", (parcelRequire("5CEHT")));

$37I7d.registerLanguage("plaintext", (parcelRequire("1FKm9")));

$37I7d.registerLanguage("pony", (parcelRequire("7jCd3")));

$37I7d.registerLanguage("powershell", (parcelRequire("5SMky")));

$37I7d.registerLanguage("processing", (parcelRequire("8wTNK")));

$37I7d.registerLanguage("profile", (parcelRequire("9W4AC")));

$37I7d.registerLanguage("prolog", (parcelRequire("cRudC")));

$37I7d.registerLanguage("properties", (parcelRequire("iF6qb")));

$37I7d.registerLanguage("protobuf", (parcelRequire("6vldq")));

$37I7d.registerLanguage("puppet", (parcelRequire("3Lh4K")));

$37I7d.registerLanguage("purebasic", (parcelRequire("5JTQt")));

$37I7d.registerLanguage("python", (parcelRequire("ly5Ff")));

$37I7d.registerLanguage("q", (parcelRequire("bzIMw")));

$37I7d.registerLanguage("qml", (parcelRequire("6fYUw")));

$37I7d.registerLanguage("r", (parcelRequire("bqL6M")));

$37I7d.registerLanguage("reasonml", (parcelRequire("fKypu")));

$37I7d.registerLanguage("rib", (parcelRequire("f88HE")));

$37I7d.registerLanguage("roboconf", (parcelRequire("gbKHl")));

$37I7d.registerLanguage("routeros", (parcelRequire("iQUn5")));

$37I7d.registerLanguage("rsl", (parcelRequire("2mZxq")));

$37I7d.registerLanguage("ruleslanguage", (parcelRequire("gfBOr")));

$37I7d.registerLanguage("rust", (parcelRequire("bfORy")));

$37I7d.registerLanguage("sas", (parcelRequire("2bWJg")));

$37I7d.registerLanguage("scala", (parcelRequire("gJPco")));

$37I7d.registerLanguage("scheme", (parcelRequire("2kAZn")));

$37I7d.registerLanguage("scilab", (parcelRequire("k3MqZ")));

$37I7d.registerLanguage("scss", (parcelRequire("3qcwH")));

$37I7d.registerLanguage("shell", (parcelRequire("68ktp")));

$37I7d.registerLanguage("smali", (parcelRequire("2htv8")));

$37I7d.registerLanguage("smalltalk", (parcelRequire("le1df")));

$37I7d.registerLanguage("sml", (parcelRequire("eKuVF")));

$37I7d.registerLanguage("sqf", (parcelRequire("16hNA")));

$37I7d.registerLanguage("sql", (parcelRequire("5VO9I")));

$37I7d.registerLanguage("stan", (parcelRequire("djWDs")));

$37I7d.registerLanguage("stata", (parcelRequire("czGB8")));

$37I7d.registerLanguage("step21", (parcelRequire("lsJDk")));

$37I7d.registerLanguage("stylus", (parcelRequire("6hHNE")));

$37I7d.registerLanguage("subunit", (parcelRequire("7JIKd")));

$37I7d.registerLanguage("swift", (parcelRequire("3Vwbc")));

$37I7d.registerLanguage("taggerscript", (parcelRequire("95S8w")));

$37I7d.registerLanguage("yaml", (parcelRequire("9Q3uF")));

$37I7d.registerLanguage("tap", (parcelRequire("e9h52")));

$37I7d.registerLanguage("tcl", (parcelRequire("5a08n")));

$37I7d.registerLanguage("tex", (parcelRequire("bjTAz")));

$37I7d.registerLanguage("thrift", (parcelRequire("7FuCM")));

$37I7d.registerLanguage("tp", (parcelRequire("fZGmp")));

$37I7d.registerLanguage("twig", (parcelRequire("2NhyA")));

$37I7d.registerLanguage("typescript", (parcelRequire("1loeR")));

$37I7d.registerLanguage("vala", (parcelRequire("c7YeD")));

$37I7d.registerLanguage("vbnet", (parcelRequire("ctiKc")));

$37I7d.registerLanguage("vbscript", (parcelRequire("aCEs1")));

$37I7d.registerLanguage("vbscript-html", (parcelRequire("i3NKp")));

$37I7d.registerLanguage("verilog", (parcelRequire("e1Vbh")));

$37I7d.registerLanguage("vhdl", (parcelRequire("fqQ9v")));

$37I7d.registerLanguage("vim", (parcelRequire("gs6c3")));

$37I7d.registerLanguage("x86asm", (parcelRequire("1shLC")));

$37I7d.registerLanguage("xl", (parcelRequire("2Q6SU")));

$37I7d.registerLanguage("xquery", (parcelRequire("in7A8")));

$37I7d.registerLanguage("zephir", (parcelRequire("2c2Kl")));
module.exports = $37I7d;

});
parcelRegister("37I7d", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
/*
Syntax highlighting with language autodetection.
https://highlightjs.org/
*/ (function(factory) {
    // Find the global object for export to both the browser and web workers.
    var globalObject = typeof window === "object" && window || typeof self === "object" && self;
    // Setup highlight.js for different environments. First is Node.js or
    // CommonJS.
    // `nodeType` is checked to ensure that `exports` is not a HTML element.
    if (!module.exports.nodeType) factory(module.exports);
    else if (globalObject) {
        // Export hljs globally even when using AMD for cases when this script
        // is loaded with others that may still expect a global hljs.
        globalObject.hljs = factory({});
        // Finally register the global hljs with AMD.
        if (typeof define === "function" && define.amd) define([], function() {
            return globalObject.hljs;
        });
    }
})(function(hljs) {
    var showedUpgradeWarning = false;
    // Convenience variables for build-in objects
    var ArrayProto = [], objectKeys = Object.keys;
    // Global internal variables used within the highlight.js library.
    var languages = Object.create(null), aliases = Object.create(null);
    // safe/production mode - swallows more errors, tries to keep running
    // even if a single syntax or parse hits a fatal error
    var SAFE_MODE = true;
    // Regular expressions used throughout the highlight.js library.
    var noHighlightRe = /^(no-?highlight|plain|text)$/i, languagePrefixRe = /\blang(?:uage)?-([\w-]+)\b/i, fixMarkupRe = /((^(<[^>]+>|\t|)+|(?:\n)))/gm;
    // The object will be assigned by the build tool. It used to synchronize API
    // of external language files with minified version of the highlight.js library.
    var API_REPLACES;
    var spanEndTag = "</span>";
    var LANGUAGE_NOT_FOUND = "Could not find the language '{}', did you forget to load/include a language module?";
    // Global options used when within external APIs. This is modified when
    // calling the `hljs.configure` function.
    var options = {
        hideUpgradeWarningAcceptNoSupportOrSecurityUpdates: false,
        classPrefix: "hljs-",
        tabReplace: null,
        useBR: false,
        languages: undefined
    };
    // keywords that should have no default relevance value
    var COMMON_KEYWORDS = "of and for in not or if then".split(" ");
    /* Utility functions */ function escape(value) {
        return value.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
    }
    function tag(node) {
        return node.nodeName.toLowerCase();
    }
    function testRe(re, lexeme) {
        var match = re && re.exec(lexeme);
        return match && match.index === 0;
    }
    function isNotHighlighted(language) {
        return noHighlightRe.test(language);
    }
    function blockLanguage(block) {
        var i, match, length, _class;
        var classes = block.className + " ";
        classes += block.parentNode ? block.parentNode.className : "";
        // language-* takes precedence over non-prefixed class names.
        match = languagePrefixRe.exec(classes);
        if (match) {
            var language = getLanguage(match[1]);
            if (!language) {
                console.warn(LANGUAGE_NOT_FOUND.replace("{}", match[1]));
                console.warn("Falling back to no-highlight mode for this block.", block);
            }
            return language ? match[1] : "no-highlight";
        }
        classes = classes.split(/\s+/);
        for(i = 0, length = classes.length; i < length; i++){
            _class = classes[i];
            if (isNotHighlighted(_class) || getLanguage(_class)) return _class;
        }
    }
    /**
   * performs a shallow merge of multiple objects into one
   *
   * @arguments list of objects with properties to merge
   * @returns a single new object
   */ function inherit(parent) {
        var key;
        var result = {};
        var objects = Array.prototype.slice.call(arguments, 1);
        for(key in parent)result[key] = parent[key];
        objects.forEach(function(obj) {
            for(key in obj)result[key] = obj[key];
        });
        return result;
    }
    /* Stream merging */ function nodeStream(node) {
        var result = [];
        (function _nodeStream(node, offset) {
            for(var child = node.firstChild; child; child = child.nextSibling){
                if (child.nodeType === 3) offset += child.nodeValue.length;
                else if (child.nodeType === 1) {
                    result.push({
                        event: "start",
                        offset: offset,
                        node: child
                    });
                    offset = _nodeStream(child, offset);
                    // Prevent void elements from having an end tag that would actually
                    // double them in the output. There are more void elements in HTML
                    // but we list only those realistically expected in code display.
                    if (!tag(child).match(/br|hr|img|input/)) result.push({
                        event: "stop",
                        offset: offset,
                        node: child
                    });
                }
            }
            return offset;
        })(node, 0);
        return result;
    }
    function mergeStreams(original, highlighted, value) {
        var processed = 0;
        var result = "";
        var nodeStack = [];
        function selectStream() {
            if (!original.length || !highlighted.length) return original.length ? original : highlighted;
            if (original[0].offset !== highlighted[0].offset) return original[0].offset < highlighted[0].offset ? original : highlighted;
            /*
      To avoid starting the stream just before it should stop the order is
      ensured that original always starts first and closes last:

      if (event1 == 'start' && event2 == 'start')
        return original;
      if (event1 == 'start' && event2 == 'stop')
        return highlighted;
      if (event1 == 'stop' && event2 == 'start')
        return original;
      if (event1 == 'stop' && event2 == 'stop')
        return highlighted;

      ... which is collapsed to:
      */ return highlighted[0].event === "start" ? original : highlighted;
        }
        function open(node) {
            function attr_str(a) {
                return " " + a.nodeName + '="' + escape(a.value).replace(/"/g, "&quot;") + '"';
            }
            result += "<" + tag(node) + ArrayProto.map.call(node.attributes, attr_str).join("") + ">";
        }
        function close(node) {
            result += "</" + tag(node) + ">";
        }
        function render(event) {
            (event.event === "start" ? open : close)(event.node);
        }
        while(original.length || highlighted.length){
            var stream = selectStream();
            result += escape(value.substring(processed, stream[0].offset));
            processed = stream[0].offset;
            if (stream === original) {
                /*
        On any opening or closing tag of the original markup we first close
        the entire highlighted node stack, then render the original tag along
        with all the following original tags at the same offset and then
        reopen all the tags on the highlighted stack.
        */ nodeStack.reverse().forEach(close);
                do {
                    render(stream.splice(0, 1)[0]);
                    stream = selectStream();
                }while (stream === original && stream.length && stream[0].offset === processed);
                nodeStack.reverse().forEach(open);
            } else {
                if (stream[0].event === "start") nodeStack.push(stream[0].node);
                else nodeStack.pop();
                render(stream.splice(0, 1)[0]);
            }
        }
        return result + escape(value.substr(processed));
    }
    /* Initialization */ function dependencyOnParent(mode) {
        if (!mode) return false;
        return mode.endsWithParent || dependencyOnParent(mode.starts);
    }
    function expand_or_clone_mode(mode) {
        if (mode.variants && !mode.cached_variants) mode.cached_variants = mode.variants.map(function(variant) {
            return inherit(mode, {
                variants: null
            }, variant);
        });
        // EXPAND
        // if we have variants then essentially "replace" the mode with the variants
        // this happens in compileMode, where this function is called from
        if (mode.cached_variants) return mode.cached_variants;
        // CLONE
        // if we have dependencies on parents then we need a unique
        // instance of ourselves, so we can be reused with many
        // different parents without issue
        if (dependencyOnParent(mode)) return [
            inherit(mode, {
                starts: mode.starts ? inherit(mode.starts) : null
            })
        ];
        if (Object.isFrozen(mode)) return [
            inherit(mode)
        ];
        // no special dependency issues, just return ourselves
        return [
            mode
        ];
    }
    function restoreLanguageApi(obj) {
        if (API_REPLACES && !obj.langApiRestored) {
            obj.langApiRestored = true;
            for(var key in API_REPLACES)if (obj[key]) obj[API_REPLACES[key]] = obj[key];
            (obj.contains || []).concat(obj.variants || []).forEach(restoreLanguageApi);
        }
    }
    function compileKeywords(rawKeywords, case_insensitive) {
        var compiled_keywords = {};
        if (typeof rawKeywords === "string") splitAndCompile("keyword", rawKeywords);
        else objectKeys(rawKeywords).forEach(function(className) {
            splitAndCompile(className, rawKeywords[className]);
        });
        return compiled_keywords;
        // ---
        function splitAndCompile(className, str) {
            if (case_insensitive) str = str.toLowerCase();
            str.split(" ").forEach(function(keyword) {
                var pair = keyword.split("|");
                compiled_keywords[pair[0]] = [
                    className,
                    scoreForKeyword(pair[0], pair[1])
                ];
            });
        }
    }
    function scoreForKeyword(keyword, providedScore) {
        // manual scores always win over common keywords
        // so you can force a score of 1 if you really insist
        if (providedScore) return Number(providedScore);
        return commonKeyword(keyword) ? 0 : 1;
    }
    function commonKeyword(word) {
        return COMMON_KEYWORDS.indexOf(word.toLowerCase()) != -1;
    }
    function compileLanguage(language) {
        function reStr(re) {
            return re && re.source || re;
        }
        function langRe(value, global) {
            return new RegExp(reStr(value), "m" + (language.case_insensitive ? "i" : "") + (global ? "g" : ""));
        }
        function reCountMatchGroups(re) {
            return new RegExp(re.toString() + "|").exec("").length - 1;
        }
        // joinRe logically computes regexps.join(separator), but fixes the
        // backreferences so they continue to match.
        // it also places each individual regular expression into it's own
        // match group, keeping track of the sequencing of those match groups
        // is currently an exercise for the caller. :-)
        function joinRe(regexps, separator) {
            // backreferenceRe matches an open parenthesis or backreference. To avoid
            // an incorrect parse, it additionally matches the following:
            // - [...] elements, where the meaning of parentheses and escapes change
            // - other escape sequences, so we do not misparse escape sequences as
            //   interesting elements
            // - non-matching or lookahead parentheses, which do not capture. These
            //   follow the '(' with a '?'.
            var backreferenceRe = /\[(?:[^\\\]]|\\.)*\]|\(\??|\\([1-9][0-9]*)|\\./;
            var numCaptures = 0;
            var ret = "";
            for(var i = 0; i < regexps.length; i++){
                numCaptures += 1;
                var offset = numCaptures;
                var re = reStr(regexps[i]);
                if (i > 0) ret += separator;
                ret += "(";
                while(re.length > 0){
                    var match = backreferenceRe.exec(re);
                    if (match == null) {
                        ret += re;
                        break;
                    }
                    ret += re.substring(0, match.index);
                    re = re.substring(match.index + match[0].length);
                    if (match[0][0] == "\\" && match[1]) // Adjust the backreference.
                    ret += "\\" + String(Number(match[1]) + offset);
                    else {
                        ret += match[0];
                        if (match[0] == "(") numCaptures++;
                    }
                }
                ret += ")";
            }
            return ret;
        }
        function buildModeRegex(mode) {
            var matchIndexes = {};
            var matcherRe;
            var regexes = [];
            var matcher = {};
            var matchAt = 1;
            function addRule(rule, regex) {
                matchIndexes[matchAt] = rule;
                regexes.push([
                    rule,
                    regex
                ]);
                matchAt += reCountMatchGroups(regex) + 1;
            }
            var term;
            for(var i = 0; i < mode.contains.length; i++){
                var re;
                term = mode.contains[i];
                if (term.beginKeywords) re = "\\.?(?:" + term.begin + ")\\.?";
                else re = term.begin;
                addRule(term, re);
            }
            if (mode.terminator_end) addRule("end", mode.terminator_end);
            if (mode.illegal) addRule("illegal", mode.illegal);
            var terminators = regexes.map(function(el) {
                return el[1];
            });
            matcherRe = langRe(joinRe(terminators, "|"), true);
            matcher.lastIndex = 0;
            matcher.exec = function(s) {
                var rule;
                if (regexes.length === 0) return null;
                matcherRe.lastIndex = matcher.lastIndex;
                var match = matcherRe.exec(s);
                if (!match) return null;
                for(var i = 0; i < match.length; i++)if (match[i] != undefined && matchIndexes["" + i] != undefined) {
                    rule = matchIndexes["" + i];
                    break;
                }
                // illegal or end match
                if (typeof rule === "string") {
                    match.type = rule;
                    match.extra = [
                        mode.illegal,
                        mode.terminator_end
                    ];
                } else {
                    match.type = "begin";
                    match.rule = rule;
                }
                return match;
            };
            return matcher;
        }
        function compileMode(mode, parent) {
            if (mode.compiled) return;
            mode.compiled = true;
            mode.keywords = mode.keywords || mode.beginKeywords;
            if (mode.keywords) mode.keywords = compileKeywords(mode.keywords, language.case_insensitive);
            mode.lexemesRe = langRe(mode.lexemes || /\w+/, true);
            if (parent) {
                if (mode.beginKeywords) mode.begin = "\\b(" + mode.beginKeywords.split(" ").join("|") + ")\\b";
                if (!mode.begin) mode.begin = /\B|\b/;
                mode.beginRe = langRe(mode.begin);
                if (mode.endSameAsBegin) mode.end = mode.begin;
                if (!mode.end && !mode.endsWithParent) mode.end = /\B|\b/;
                if (mode.end) mode.endRe = langRe(mode.end);
                mode.terminator_end = reStr(mode.end) || "";
                if (mode.endsWithParent && parent.terminator_end) mode.terminator_end += (mode.end ? "|" : "") + parent.terminator_end;
            }
            if (mode.illegal) mode.illegalRe = langRe(mode.illegal);
            if (mode.relevance == null) mode.relevance = 1;
            if (!mode.contains) mode.contains = [];
            mode.contains = Array.prototype.concat.apply([], mode.contains.map(function(c) {
                return expand_or_clone_mode(c === "self" ? mode : c);
            }));
            mode.contains.forEach(function(c) {
                compileMode(c, mode);
            });
            if (mode.starts) compileMode(mode.starts, parent);
            mode.terminators = buildModeRegex(mode);
        }
        // self is not valid at the top-level
        if (language.contains && language.contains.indexOf("self") != -1) {
            if (!SAFE_MODE) throw new Error("ERR: contains `self` is not supported at the top-level of a language.  See documentation.");
            else // silently remove the broken rule (effectively ignoring it), this has historically
            // been the behavior in the past, so this removal preserves compatibility with broken
            // grammars when running in Safe Mode
            language.contains = language.contains.filter(function(mode) {
                return mode != "self";
            });
        }
        compileMode(language);
    }
    function hideUpgradeWarning() {
        if (options.hideUpgradeWarningAcceptNoSupportOrSecurityUpdates) return true;
        typeof $hPtJY === "object" && typeof $hPtJY.env === "object" && undefined;
    }
    /**
   * Core highlighting function.
   *
   * @param {string} languageName - the language to use for highlighting
   * @param {string} code - the code to highlight
   * @param {boolean} ignore_illegals - whether to ignore illegal matches, default is to bail
   * @param {array<mode>} continuation - array of continuation modes
   *
   * @returns an object that represents the result
   * @property {string} language - the language name
   * @property {number} relevance - the relevance score
   * @property {string} value - the highlighted HTML code
   * @property {mode} top - top of the current mode stack
   * @property {boolean} illegal - indicates whether any illegal matches were found
  */ function highlight(languageName, code, ignore_illegals, continuation) {
        if (!hideUpgradeWarning()) {
            if (!showedUpgradeWarning) {
                showedUpgradeWarning = true;
                console.log("Version 9 of Highlight.js has reached EOL and is no longer supported.\nPlease upgrade or ask whatever dependency you are using to upgrade.\nhttps://github.com/highlightjs/highlight.js/issues/2877");
            }
        }
        var codeToHighlight = code;
        function escapeRe(value) {
            return new RegExp(value.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&"), "m");
        }
        function endOfMode(mode, lexeme) {
            if (testRe(mode.endRe, lexeme)) {
                while(mode.endsParent && mode.parent)mode = mode.parent;
                return mode;
            }
            if (mode.endsWithParent) return endOfMode(mode.parent, lexeme);
        }
        function keywordMatch(mode, match) {
            var match_str = language.case_insensitive ? match[0].toLowerCase() : match[0];
            return mode.keywords.hasOwnProperty(match_str) && mode.keywords[match_str];
        }
        function buildSpan(className, insideSpan, leaveOpen, noPrefix) {
            if (!leaveOpen && insideSpan === "") return "";
            if (!className) return insideSpan;
            var classPrefix = noPrefix ? "" : options.classPrefix, openSpan = '<span class="' + classPrefix, closeSpan = leaveOpen ? "" : spanEndTag;
            openSpan += className + '">';
            return openSpan + insideSpan + closeSpan;
        }
        function processKeywords() {
            var keyword_match, last_index, match, result;
            if (!top.keywords) return escape(mode_buffer);
            result = "";
            last_index = 0;
            top.lexemesRe.lastIndex = 0;
            match = top.lexemesRe.exec(mode_buffer);
            while(match){
                result += escape(mode_buffer.substring(last_index, match.index));
                keyword_match = keywordMatch(top, match);
                if (keyword_match) {
                    relevance += keyword_match[1];
                    result += buildSpan(keyword_match[0], escape(match[0]));
                } else result += escape(match[0]);
                last_index = top.lexemesRe.lastIndex;
                match = top.lexemesRe.exec(mode_buffer);
            }
            return result + escape(mode_buffer.substr(last_index));
        }
        function processSubLanguage() {
            var explicit = typeof top.subLanguage === "string";
            if (explicit && !languages[top.subLanguage]) return escape(mode_buffer);
            var result = explicit ? highlight(top.subLanguage, mode_buffer, true, continuations[top.subLanguage]) : highlightAuto(mode_buffer, top.subLanguage.length ? top.subLanguage : undefined);
            // Counting embedded language score towards the host language may be disabled
            // with zeroing the containing mode relevance. Use case in point is Markdown that
            // allows XML everywhere and makes every XML snippet to have a much larger Markdown
            // score.
            if (top.relevance > 0) relevance += result.relevance;
            if (explicit) continuations[top.subLanguage] = result.top;
            return buildSpan(result.language, result.value, false, true);
        }
        function processBuffer() {
            result += top.subLanguage != null ? processSubLanguage() : processKeywords();
            mode_buffer = "";
        }
        function startNewMode(mode) {
            result += mode.className ? buildSpan(mode.className, "", true) : "";
            top = Object.create(mode, {
                parent: {
                    value: top
                }
            });
        }
        function doBeginMatch(match) {
            var lexeme = match[0];
            var new_mode = match.rule;
            if (new_mode && new_mode.endSameAsBegin) new_mode.endRe = escapeRe(lexeme);
            if (new_mode.skip) mode_buffer += lexeme;
            else {
                if (new_mode.excludeBegin) mode_buffer += lexeme;
                processBuffer();
                if (!new_mode.returnBegin && !new_mode.excludeBegin) mode_buffer = lexeme;
            }
            startNewMode(new_mode);
            return new_mode.returnBegin ? 0 : lexeme.length;
        }
        function doEndMatch(match) {
            var lexeme = match[0];
            var matchPlusRemainder = codeToHighlight.substr(match.index);
            var end_mode = endOfMode(top, matchPlusRemainder);
            if (!end_mode) return;
            var origin = top;
            if (origin.skip) mode_buffer += lexeme;
            else {
                if (!(origin.returnEnd || origin.excludeEnd)) mode_buffer += lexeme;
                processBuffer();
                if (origin.excludeEnd) mode_buffer = lexeme;
            }
            do {
                if (top.className) result += spanEndTag;
                if (!top.skip && !top.subLanguage) relevance += top.relevance;
                top = top.parent;
            }while (top !== end_mode.parent);
            if (end_mode.starts) {
                if (end_mode.endSameAsBegin) end_mode.starts.endRe = end_mode.endRe;
                startNewMode(end_mode.starts);
            }
            return origin.returnEnd ? 0 : lexeme.length;
        }
        var lastMatch = {};
        function processLexeme(text_before_match, match) {
            var lexeme = match && match[0];
            // add non-matched text to the current mode buffer
            mode_buffer += text_before_match;
            if (lexeme == null) {
                processBuffer();
                return 0;
            }
            // we've found a 0 width match and we're stuck, so we need to advance
            // this happens when we have badly behaved rules that have optional matchers to the degree that
            // sometimes they can end up matching nothing at all
            // Ref: https://github.com/highlightjs/highlight.js/issues/2140
            if (lastMatch.type == "begin" && match.type == "end" && lastMatch.index == match.index && lexeme === "") {
                // spit the "skipped" character that our regex choked on back into the output sequence
                mode_buffer += codeToHighlight.slice(match.index, match.index + 1);
                return 1;
            }
            // edge case for when illegal matches $ (end of line) which is technically
            // a 0 width match but not a begin/end match so it's not caught by the
            // first handler (when ignoreIllegals is true)
            // https://github.com/highlightjs/highlight.js/issues/2522
            if (lastMatch.type === "illegal" && lexeme === "") {
                mode_buffer += codeToHighlight.slice(match.index, match.index + 1);
                return 1;
            }
            lastMatch = match;
            if (match.type === "begin") return doBeginMatch(match);
            else if (match.type === "illegal" && !ignore_illegals) // illegal match, we do not continue processing
            throw new Error('Illegal lexeme "' + lexeme + '" for mode "' + (top.className || "<unnamed>") + '"');
            else if (match.type === "end") {
                var processed = doEndMatch(match);
                if (processed != undefined) return processed;
            }
            /*
      Why might be find ourselves here?  Only one occasion now.  An end match that was
      triggered but could not be completed.  When might this happen?  When an `endSameasBegin`
      rule sets the end rule to a specific match.  Since the overall mode termination rule that's
      being used to scan the text isn't recompiled that means that any match that LOOKS like
      the end (but is not, because it is not an exact match to the beginning) will
      end up here.  A definite end match, but when `doEndMatch` tries to "reapply"
      the end rule and fails to match, we wind up here, and just silently ignore the end.

      This causes no real harm other than stopping a few times too many.
      */ mode_buffer += lexeme;
            return lexeme.length;
        }
        var language = getLanguage(languageName);
        if (!language) {
            console.error(LANGUAGE_NOT_FOUND.replace("{}", languageName));
            throw new Error('Unknown language: "' + languageName + '"');
        }
        compileLanguage(language);
        var top = continuation || language;
        var continuations = {}; // keep continuations for sub-languages
        var result = "", current;
        for(current = top; current !== language; current = current.parent)if (current.className) result = buildSpan(current.className, "", true) + result;
        var mode_buffer = "";
        var relevance = 0;
        try {
            var match, count, index = 0;
            while(true){
                top.terminators.lastIndex = index;
                match = top.terminators.exec(codeToHighlight);
                if (!match) break;
                count = processLexeme(codeToHighlight.substring(index, match.index), match);
                index = match.index + count;
            }
            processLexeme(codeToHighlight.substr(index));
            for(current = top; current.parent; current = current.parent)if (current.className) result += spanEndTag;
            return {
                relevance: relevance,
                value: result,
                illegal: false,
                language: languageName,
                top: top
            };
        } catch (err) {
            if (err.message && err.message.indexOf("Illegal") !== -1) return {
                illegal: true,
                relevance: 0,
                value: escape(codeToHighlight)
            };
            else if (SAFE_MODE) return {
                relevance: 0,
                value: escape(codeToHighlight),
                language: languageName,
                top: top,
                errorRaised: err
            };
            else throw err;
        }
    }
    /*
  Highlighting with language detection. Accepts a string with the code to
  highlight. Returns an object with the following properties:

  - language (detected language)
  - relevance (int)
  - value (an HTML string with highlighting markup)
  - second_best (object with the same structure for second-best heuristically
    detected language, may be absent)

  */ function highlightAuto(code, languageSubset) {
        languageSubset = languageSubset || options.languages || objectKeys(languages);
        var result = {
            relevance: 0,
            value: escape(code)
        };
        var second_best = result;
        languageSubset.filter(getLanguage).filter(autoDetection).forEach(function(name) {
            var current = highlight(name, code, false);
            current.language = name;
            if (current.relevance > second_best.relevance) second_best = current;
            if (current.relevance > result.relevance) {
                second_best = result;
                result = current;
            }
        });
        if (second_best.language) result.second_best = second_best;
        return result;
    }
    /*
  Post-processing of the highlighted markup:

  - replace TABs with something more useful
  - replace real line-breaks with '<br>' for non-pre containers

  */ function fixMarkup(value) {
        if (!(options.tabReplace || options.useBR)) return value;
        return value.replace(fixMarkupRe, function(match, p1) {
            if (options.useBR && match === "\n") return "<br>";
            else if (options.tabReplace) return p1.replace(/\t/g, options.tabReplace);
            return "";
        });
    }
    function buildClassName(prevClassName, currentLang, resultLang) {
        var language = currentLang ? aliases[currentLang] : resultLang, result = [
            prevClassName.trim()
        ];
        if (!prevClassName.match(/\bhljs\b/)) result.push("hljs");
        if (prevClassName.indexOf(language) === -1) result.push(language);
        return result.join(" ").trim();
    }
    /*
  Applies highlighting to a DOM node containing code. Accepts a DOM node and
  two optional parameters for fixMarkup.
  */ function highlightBlock(block) {
        var node, originalStream, result, resultNode, text;
        var language = blockLanguage(block);
        if (isNotHighlighted(language)) return;
        if (options.useBR) {
            node = document.createElement("div");
            node.innerHTML = block.innerHTML.replace(/\n/g, "").replace(/<br[ \/]*>/g, "\n");
        } else node = block;
        text = node.textContent;
        result = language ? highlight(language, text, true) : highlightAuto(text);
        originalStream = nodeStream(node);
        if (originalStream.length) {
            resultNode = document.createElement("div");
            resultNode.innerHTML = result.value;
            result.value = mergeStreams(originalStream, nodeStream(resultNode), text);
        }
        result.value = fixMarkup(result.value);
        block.innerHTML = result.value;
        block.className = buildClassName(block.className, language, result.language);
        block.result = {
            language: result.language,
            re: result.relevance
        };
        if (result.second_best) block.second_best = {
            language: result.second_best.language,
            re: result.second_best.relevance
        };
    }
    /*
  Updates highlight.js global options with values passed in the form of an object.
  */ function configure(user_options) {
        options = inherit(options, user_options);
    }
    /*
  Applies highlighting to all <pre><code>..</code></pre> blocks on a page.
  */ function initHighlighting() {
        if (initHighlighting.called) return;
        initHighlighting.called = true;
        var blocks = document.querySelectorAll("pre code");
        ArrayProto.forEach.call(blocks, highlightBlock);
    }
    /*
  Attaches highlighting to the page load event.
  */ function initHighlightingOnLoad() {
        window.addEventListener("DOMContentLoaded", initHighlighting, false);
        window.addEventListener("load", initHighlighting, false);
    }
    var PLAINTEXT_LANGUAGE = {
        disableAutodetect: true
    };
    function registerLanguage(name, language) {
        var lang;
        try {
            lang = language(hljs);
        } catch (error) {
            console.error("Language definition for '{}' could not be registered.".replace("{}", name));
            // hard or soft error
            if (!SAFE_MODE) throw error;
            else console.error(error);
            // languages that have serious errors are replaced with essentially a
            // "plaintext" stand-in so that the code blocks will still get normal
            // css classes applied to them - and one bad language won't break the
            // entire highlighter
            lang = PLAINTEXT_LANGUAGE;
        }
        languages[name] = lang;
        restoreLanguageApi(lang);
        lang.rawDefinition = language.bind(null, hljs);
        if (lang.aliases) lang.aliases.forEach(function(alias) {
            aliases[alias] = name;
        });
    }
    function listLanguages() {
        return objectKeys(languages);
    }
    /*
    intended usage: When one language truly requires another

    Unlike `getLanguage`, this will throw when the requested language
    is not available.
  */ function requireLanguage(name) {
        var lang = getLanguage(name);
        if (lang) return lang;
        var err = new Error("The '{}' language is required, but not loaded.".replace("{}", name));
        throw err;
    }
    function getLanguage(name) {
        name = (name || "").toLowerCase();
        return languages[name] || languages[aliases[name]];
    }
    function autoDetection(name) {
        var lang = getLanguage(name);
        return lang && !lang.disableAutodetect;
    }
    /* Interface definition */ hljs.highlight = highlight;
    hljs.highlightAuto = highlightAuto;
    hljs.fixMarkup = fixMarkup;
    hljs.highlightBlock = highlightBlock;
    hljs.configure = configure;
    hljs.initHighlighting = initHighlighting;
    hljs.initHighlightingOnLoad = initHighlightingOnLoad;
    hljs.registerLanguage = registerLanguage;
    hljs.listLanguages = listLanguages;
    hljs.getLanguage = getLanguage;
    hljs.requireLanguage = requireLanguage;
    hljs.autoDetection = autoDetection;
    hljs.inherit = inherit;
    hljs.debugMode = function() {
        SAFE_MODE = false;
    };
    // Common regexps
    hljs.IDENT_RE = "[a-zA-Z]\\w*";
    hljs.UNDERSCORE_IDENT_RE = "[a-zA-Z_]\\w*";
    hljs.NUMBER_RE = "\\b\\d+(\\.\\d+)?";
    hljs.C_NUMBER_RE = "(-?)(\\b0[xX][a-fA-F0-9]+|(\\b\\d+(\\.\\d*)?|\\.\\d+)([eE][-+]?\\d+)?)"; // 0x..., 0..., decimal, float
    hljs.BINARY_NUMBER_RE = "\\b(0b[01]+)"; // 0b...
    hljs.RE_STARTERS_RE = "!|!=|!==|%|%=|&|&&|&=|\\*|\\*=|\\+|\\+=|,|-|-=|/=|/|:|;|<<|<<=|<=|<|===|==|=|>>>=|>>=|>=|>>>|>>|>|\\?|\\[|\\{|\\(|\\^|\\^=|\\||\\|=|\\|\\||~";
    // Common modes
    hljs.BACKSLASH_ESCAPE = {
        begin: "\\\\[\\s\\S]",
        relevance: 0
    };
    hljs.APOS_STRING_MODE = {
        className: "string",
        begin: "'",
        end: "'",
        illegal: "\\n",
        contains: [
            hljs.BACKSLASH_ESCAPE
        ]
    };
    hljs.QUOTE_STRING_MODE = {
        className: "string",
        begin: '"',
        end: '"',
        illegal: "\\n",
        contains: [
            hljs.BACKSLASH_ESCAPE
        ]
    };
    hljs.PHRASAL_WORDS_MODE = {
        begin: /\b(a|an|the|are|I'm|isn't|don't|doesn't|won't|but|just|should|pretty|simply|enough|gonna|going|wtf|so|such|will|you|your|they|like|more)\b/
    };
    hljs.COMMENT = function(begin, end, inherits) {
        var mode = hljs.inherit({
            className: "comment",
            begin: begin,
            end: end,
            contains: []
        }, inherits || {});
        mode.contains.push(hljs.PHRASAL_WORDS_MODE);
        mode.contains.push({
            className: "doctag",
            begin: "(?:TODO|FIXME|NOTE|BUG|XXX):",
            relevance: 0
        });
        return mode;
    };
    hljs.C_LINE_COMMENT_MODE = hljs.COMMENT("//", "$");
    hljs.C_BLOCK_COMMENT_MODE = hljs.COMMENT("/\\*", "\\*/");
    hljs.HASH_COMMENT_MODE = hljs.COMMENT("#", "$");
    hljs.NUMBER_MODE = {
        className: "number",
        begin: hljs.NUMBER_RE,
        relevance: 0
    };
    hljs.C_NUMBER_MODE = {
        className: "number",
        begin: hljs.C_NUMBER_RE,
        relevance: 0
    };
    hljs.BINARY_NUMBER_MODE = {
        className: "number",
        begin: hljs.BINARY_NUMBER_RE,
        relevance: 0
    };
    hljs.CSS_NUMBER_MODE = {
        className: "number",
        begin: hljs.NUMBER_RE + "(" + "%|em|ex|ch|rem" + "|vw|vh|vmin|vmax" + "|cm|mm|in|pt|pc|px" + "|deg|grad|rad|turn" + "|s|ms" + "|Hz|kHz" + "|dpi|dpcm|dppx" + ")?",
        relevance: 0
    };
    hljs.REGEXP_MODE = {
        className: "regexp",
        begin: /\//,
        end: /\/[gimuy]*/,
        illegal: /\n/,
        contains: [
            hljs.BACKSLASH_ESCAPE,
            {
                begin: /\[/,
                end: /\]/,
                relevance: 0,
                contains: [
                    hljs.BACKSLASH_ESCAPE
                ]
            }
        ]
    };
    hljs.TITLE_MODE = {
        className: "title",
        begin: hljs.IDENT_RE,
        relevance: 0
    };
    hljs.UNDERSCORE_TITLE_MODE = {
        className: "title",
        begin: hljs.UNDERSCORE_IDENT_RE,
        relevance: 0
    };
    hljs.METHOD_GUARD = {
        // excludes method names from keyword processing
        begin: "\\.\\s*" + hljs.UNDERSCORE_IDENT_RE,
        relevance: 0
    };
    var constants = [
        hljs.BACKSLASH_ESCAPE,
        hljs.APOS_STRING_MODE,
        hljs.QUOTE_STRING_MODE,
        hljs.PHRASAL_WORDS_MODE,
        hljs.COMMENT,
        hljs.C_LINE_COMMENT_MODE,
        hljs.C_BLOCK_COMMENT_MODE,
        hljs.HASH_COMMENT_MODE,
        hljs.NUMBER_MODE,
        hljs.C_NUMBER_MODE,
        hljs.BINARY_NUMBER_MODE,
        hljs.CSS_NUMBER_MODE,
        hljs.REGEXP_MODE,
        hljs.TITLE_MODE,
        hljs.UNDERSCORE_TITLE_MODE,
        hljs.METHOD_GUARD
    ];
    constants.forEach(function(obj) {
        deepFreeze(obj);
    });
    // https://github.com/substack/deep-freeze/blob/master/index.js
    function deepFreeze(o) {
        Object.freeze(o);
        var objIsFunction = typeof o === "function";
        Object.getOwnPropertyNames(o).forEach(function(prop) {
            if (o.hasOwnProperty(prop) && o[prop] !== null && (typeof o[prop] === "object" || typeof o[prop] === "function") && (objIsFunction ? prop !== "caller" && prop !== "callee" && prop !== "arguments" : true) && !Object.isFrozen(o[prop])) deepFreeze(o[prop]);
        });
        return o;
    }
    return hljs;
});

});
parcelRegister("hPtJY", function(module, exports) {
// shim for using process in browser
var $cfae44f0dfdf62c0$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $cfae44f0dfdf62c0$var$cachedSetTimeout;
var $cfae44f0dfdf62c0$var$cachedClearTimeout;
function $cfae44f0dfdf62c0$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $cfae44f0dfdf62c0$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        else $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        else $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    }
})();
function $cfae44f0dfdf62c0$var$runTimeout(fun) {
    if ($cfae44f0dfdf62c0$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedSetTimeout === $cfae44f0dfdf62c0$var$defaultSetTimout || !$cfae44f0dfdf62c0$var$cachedSetTimeout) && setTimeout) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $cfae44f0dfdf62c0$var$runClearTimeout(marker) {
    if ($cfae44f0dfdf62c0$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedClearTimeout === $cfae44f0dfdf62c0$var$defaultClearTimeout || !$cfae44f0dfdf62c0$var$cachedClearTimeout) && clearTimeout) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $cfae44f0dfdf62c0$var$queue = [];
var $cfae44f0dfdf62c0$var$draining = false;
var $cfae44f0dfdf62c0$var$currentQueue;
var $cfae44f0dfdf62c0$var$queueIndex = -1;
function $cfae44f0dfdf62c0$var$cleanUpNextTick() {
    if (!$cfae44f0dfdf62c0$var$draining || !$cfae44f0dfdf62c0$var$currentQueue) return;
    $cfae44f0dfdf62c0$var$draining = false;
    if ($cfae44f0dfdf62c0$var$currentQueue.length) $cfae44f0dfdf62c0$var$queue = $cfae44f0dfdf62c0$var$currentQueue.concat($cfae44f0dfdf62c0$var$queue);
    else $cfae44f0dfdf62c0$var$queueIndex = -1;
    if ($cfae44f0dfdf62c0$var$queue.length) $cfae44f0dfdf62c0$var$drainQueue();
}
function $cfae44f0dfdf62c0$var$drainQueue() {
    if ($cfae44f0dfdf62c0$var$draining) return;
    var timeout = $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$cleanUpNextTick);
    $cfae44f0dfdf62c0$var$draining = true;
    var len = $cfae44f0dfdf62c0$var$queue.length;
    while(len){
        $cfae44f0dfdf62c0$var$currentQueue = $cfae44f0dfdf62c0$var$queue;
        $cfae44f0dfdf62c0$var$queue = [];
        while(++$cfae44f0dfdf62c0$var$queueIndex < len)if ($cfae44f0dfdf62c0$var$currentQueue) $cfae44f0dfdf62c0$var$currentQueue[$cfae44f0dfdf62c0$var$queueIndex].run();
        $cfae44f0dfdf62c0$var$queueIndex = -1;
        len = $cfae44f0dfdf62c0$var$queue.length;
    }
    $cfae44f0dfdf62c0$var$currentQueue = null;
    $cfae44f0dfdf62c0$var$draining = false;
    $cfae44f0dfdf62c0$var$runClearTimeout(timeout);
}
$cfae44f0dfdf62c0$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $cfae44f0dfdf62c0$var$queue.push(new $cfae44f0dfdf62c0$var$Item(fun, args));
    if ($cfae44f0dfdf62c0$var$queue.length === 1 && !$cfae44f0dfdf62c0$var$draining) $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$drainQueue);
};
// v8 likes predictible objects
function $cfae44f0dfdf62c0$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$cfae44f0dfdf62c0$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$cfae44f0dfdf62c0$var$process.title = "browser";
$cfae44f0dfdf62c0$var$process.browser = true;
$cfae44f0dfdf62c0$var$process.env = {};
$cfae44f0dfdf62c0$var$process.argv = [];
$cfae44f0dfdf62c0$var$process.version = ""; // empty string to avoid regexp issues
$cfae44f0dfdf62c0$var$process.versions = {};
function $cfae44f0dfdf62c0$var$noop() {}
$cfae44f0dfdf62c0$var$process.on = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.addListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.once = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.off = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeAllListeners = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.emit = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependOnceListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.listeners = function(name) {
    return [];
};
$cfae44f0dfdf62c0$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$cfae44f0dfdf62c0$var$process.cwd = function() {
    return "/";
};
$cfae44f0dfdf62c0$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$cfae44f0dfdf62c0$var$process.umask = function() {
    return 0;
};

});


parcelRegister("8m5tQ", function(module, exports) {
module.exports = function(hljs) {
    // общий паттерн для определения идентификаторов
    var UNDERSCORE_IDENT_RE = "[A-Za-z\u0410-\u042F\u0430-\u044F\u0451\u0401_][A-Za-z\u0410-\u042F\u0430-\u044F\u0451\u0401_0-9]+";
    // v7 уникальные ключевые слова, отсутствующие в v8 ==> keyword
    var v7_keywords = "\u0434\u0430\u043B\u0435\u0435 ";
    // v8 ключевые слова ==> keyword
    var v8_keywords = "\u0432\u043E\u0437\u0432\u0440\u0430\u0442 \u0432\u044B\u0437\u0432\u0430\u0442\u044C\u0438\u0441\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0435 \u0432\u044B\u043F\u043E\u043B\u043D\u0438\u0442\u044C \u0434\u043B\u044F \u0435\u0441\u043B\u0438 \u0438 \u0438\u0437 \u0438\u043B\u0438 \u0438\u043D\u0430\u0447\u0435 \u0438\u043D\u0430\u0447\u0435\u0435\u0441\u043B\u0438 \u0438\u0441\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0435 \u043A\u0430\u0436\u0434\u043E\u0433\u043E \u043A\u043E\u043D\u0435\u0446\u0435\u0441\u043B\u0438 \u043A\u043E\u043D\u0435\u0446\u043F\u043E\u043F\u044B\u0442\u043A\u0438 \u043A\u043E\u043D\u0435\u0446\u0446\u0438\u043A\u043B\u0430 \u043D\u0435 \u043D\u043E\u0432\u044B\u0439 \u043F\u0435\u0440\u0435\u0439\u0442\u0438 \u043F\u0435\u0440\u0435\u043C \u043F\u043E \u043F\u043E\u043A\u0430 \u043F\u043E\u043F\u044B\u0442\u043A\u0430 \u043F\u0440\u0435\u0440\u0432\u0430\u0442\u044C \u043F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u044C \u0442\u043E\u0433\u0434\u0430 \u0446\u0438\u043A\u043B \u044D\u043A\u0441\u043F\u043E\u0440\u0442 ";
    // keyword : ключевые слова
    var KEYWORD = v7_keywords + v8_keywords;
    // v7 уникальные директивы, отсутствующие в v8 ==> meta-keyword
    var v7_meta_keywords = "\u0437\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C\u0438\u0437\u0444\u0430\u0439\u043B\u0430 ";
    // v8 ключевые слова в инструкциях препроцессора, директивах компиляции, аннотациях ==> meta-keyword
    var v8_meta_keywords = "\u0432\u0435\u0431\u043A\u043B\u0438\u0435\u043D\u0442 \u0432\u043C\u0435\u0441\u0442\u043E \u0432\u043D\u0435\u0448\u043D\u0435\u0435\u0441\u043E\u0435\u0434\u0438\u043D\u0435\u043D\u0438\u0435 \u043A\u043B\u0438\u0435\u043D\u0442 \u043A\u043E\u043D\u0435\u0446\u043E\u0431\u043B\u0430\u0441\u0442\u0438 \u043C\u043E\u0431\u0438\u043B\u044C\u043D\u043E\u0435\u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435\u043A\u043B\u0438\u0435\u043D\u0442 \u043C\u043E\u0431\u0438\u043B\u044C\u043D\u043E\u0435\u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435\u0441\u0435\u0440\u0432\u0435\u0440 \u043D\u0430\u043A\u043B\u0438\u0435\u043D\u0442\u0435 \u043D\u0430\u043A\u043B\u0438\u0435\u043D\u0442\u0435\u043D\u0430\u0441\u0435\u0440\u0432\u0435\u0440\u0435 \u043D\u0430\u043A\u043B\u0438\u0435\u043D\u0442\u0435\u043D\u0430\u0441\u0435\u0440\u0432\u0435\u0440\u0435\u0431\u0435\u0437\u043A\u043E\u043D\u0442\u0435\u043A\u0441\u0442\u0430 \u043D\u0430\u0441\u0435\u0440\u0432\u0435\u0440\u0435 \u043D\u0430\u0441\u0435\u0440\u0432\u0435\u0440\u0435\u0431\u0435\u0437\u043A\u043E\u043D\u0442\u0435\u043A\u0441\u0442\u0430 \u043E\u0431\u043B\u0430\u0441\u0442\u044C \u043F\u0435\u0440\u0435\u0434 \u043F\u043E\u0441\u043B\u0435 \u0441\u0435\u0440\u0432\u0435\u0440 \u0442\u043E\u043B\u0441\u0442\u044B\u0439\u043A\u043B\u0438\u0435\u043D\u0442\u043E\u0431\u044B\u0447\u043D\u043E\u0435\u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435 \u0442\u043E\u043B\u0441\u0442\u044B\u0439\u043A\u043B\u0438\u0435\u043D\u0442\u0443\u043F\u0440\u0430\u0432\u043B\u044F\u0435\u043C\u043E\u0435\u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435 \u0442\u043E\u043D\u043A\u0438\u0439\u043A\u043B\u0438\u0435\u043D\u0442 ";
    // meta-keyword : ключевые слова в инструкциях препроцессора, директивах компиляции, аннотациях
    var METAKEYWORD = v7_meta_keywords + v8_meta_keywords;
    // v7 системные константы ==> built_in
    var v7_system_constants = "\u0440\u0430\u0437\u0434\u0435\u043B\u0438\u0442\u0435\u043B\u044C\u0441\u0442\u0440\u0430\u043D\u0438\u0446 \u0440\u0430\u0437\u0434\u0435\u043B\u0438\u0442\u0435\u043B\u044C\u0441\u0442\u0440\u043E\u043A \u0441\u0438\u043C\u0432\u043E\u043B\u0442\u0430\u0431\u0443\u043B\u044F\u0446\u0438\u0438 ";
    // v7 уникальные методы глобального контекста, отсутствующие в v8 ==> built_in
    var v7_global_context_methods = "ansitooem oemtoansi \u0432\u0432\u0435\u0441\u0442\u0438\u0432\u0438\u0434\u0441\u0443\u0431\u043A\u043E\u043D\u0442\u043E \u0432\u0432\u0435\u0441\u0442\u0438\u043F\u0435\u0440\u0435\u0447\u0438\u0441\u043B\u0435\u043D\u0438\u0435 \u0432\u0432\u0435\u0441\u0442\u0438\u043F\u0435\u0440\u0438\u043E\u0434 \u0432\u0432\u0435\u0441\u0442\u0438\u043F\u043B\u0430\u043D\u0441\u0447\u0435\u0442\u043E\u0432 \u0432\u044B\u0431\u0440\u0430\u043D\u043D\u044B\u0439\u043F\u043B\u0430\u043D\u0441\u0447\u0435\u0442\u043E\u0432 \u0434\u0430\u0442\u0430\u0433\u043E\u0434 \u0434\u0430\u0442\u0430\u043C\u0435\u0441\u044F\u0446 \u0434\u0430\u0442\u0430\u0447\u0438\u0441\u043B\u043E \u0437\u0430\u0433\u043E\u043B\u043E\u0432\u043E\u043A\u0441\u0438\u0441\u0442\u0435\u043C\u044B \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435\u0432\u0441\u0442\u0440\u043E\u043A\u0443 \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435\u0438\u0437\u0441\u0442\u0440\u043E\u043A\u0438 \u043A\u0430\u0442\u0430\u043B\u043E\u0433\u0438\u0431 \u043A\u0430\u0442\u0430\u043B\u043E\u0433\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F \u043A\u043E\u0434\u0441\u0438\u043C\u0432 \u043A\u043E\u043D\u0433\u043E\u0434\u0430 \u043A\u043E\u043D\u0435\u0446\u043F\u0435\u0440\u0438\u043E\u0434\u0430\u0431\u0438 \u043A\u043E\u043D\u0435\u0446\u0440\u0430\u0441\u0441\u0447\u0438\u0442\u0430\u043D\u043D\u043E\u0433\u043E\u043F\u0435\u0440\u0438\u043E\u0434\u0430\u0431\u0438 \u043A\u043E\u043D\u0435\u0446\u0441\u0442\u0430\u043D\u0434\u0430\u0440\u0442\u043D\u043E\u0433\u043E\u0438\u043D\u0442\u0435\u0440\u0432\u0430\u043B\u0430 \u043A\u043E\u043D\u043A\u0432\u0430\u0440\u0442\u0430\u043B\u0430 \u043A\u043E\u043D\u043C\u0435\u0441\u044F\u0446\u0430 \u043A\u043E\u043D\u043D\u0435\u0434\u0435\u043B\u0438 \u043B\u043E\u0433 \u043B\u043E\u043310 \u043C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u044C\u043D\u043E\u0435\u043A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E\u0441\u0443\u0431\u043A\u043E\u043D\u0442\u043E \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u0435\u0438\u043D\u0442\u0435\u0440\u0444\u0435\u0439\u0441\u0430 \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u0435\u043D\u0430\u0431\u043E\u0440\u0430\u043F\u0440\u0430\u0432 \u043D\u0430\u0437\u043D\u0430\u0447\u0438\u0442\u044C\u0432\u0438\u0434 \u043D\u0430\u0437\u043D\u0430\u0447\u0438\u0442\u044C\u0441\u0447\u0435\u0442 \u043D\u0430\u0439\u0442\u0438\u0441\u0441\u044B\u043B\u043A\u0438 \u043D\u0430\u0447\u0430\u043B\u043E\u043F\u0435\u0440\u0438\u043E\u0434\u0430\u0431\u0438 \u043D\u0430\u0447\u0430\u043B\u043E\u0441\u0442\u0430\u043D\u0434\u0430\u0440\u0442\u043D\u043E\u0433\u043E\u0438\u043D\u0442\u0435\u0440\u0432\u0430\u043B\u0430 \u043D\u0430\u0447\u0433\u043E\u0434\u0430 \u043D\u0430\u0447\u043A\u0432\u0430\u0440\u0442\u0430\u043B\u0430 \u043D\u0430\u0447\u043C\u0435\u0441\u044F\u0446\u0430 \u043D\u0430\u0447\u043D\u0435\u0434\u0435\u043B\u0438 \u043D\u043E\u043C\u0435\u0440\u0434\u043D\u044F\u0433\u043E\u0434\u0430 \u043D\u043E\u043C\u0435\u0440\u0434\u043D\u044F\u043D\u0435\u0434\u0435\u043B\u0438 \u043D\u043E\u043C\u0435\u0440\u043D\u0435\u0434\u0435\u043B\u0438\u0433\u043E\u0434\u0430 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0430\u043E\u0436\u0438\u0434\u0430\u043D\u0438\u044F \u043E\u0441\u043D\u043E\u0432\u043D\u043E\u0439\u0436\u0443\u0440\u043D\u0430\u043B\u0440\u0430\u0441\u0447\u0435\u0442\u043E\u0432 \u043E\u0441\u043D\u043E\u0432\u043D\u043E\u0439\u043F\u043B\u0430\u043D\u0441\u0447\u0435\u0442\u043E\u0432 \u043E\u0441\u043D\u043E\u0432\u043D\u043E\u0439\u044F\u0437\u044B\u043A \u043E\u0447\u0438\u0441\u0442\u0438\u0442\u044C\u043E\u043A\u043D\u043E\u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0439 \u043F\u0435\u0440\u0438\u043E\u0434\u0441\u0442\u0440 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u0432\u0440\u0435\u043C\u044F\u0442\u0430 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u0434\u0430\u0442\u0443\u0442\u0430 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0442\u0430 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u044F\u043E\u0442\u0431\u043E\u0440\u0430 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u043F\u043E\u0437\u0438\u0446\u0438\u044E\u0442\u0430 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u043F\u0443\u0441\u0442\u043E\u0435\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u0442\u0430 \u043F\u0440\u0435\u0444\u0438\u043A\u0441\u0430\u0432\u0442\u043E\u043D\u0443\u043C\u0435\u0440\u0430\u0446\u0438\u0438 \u043F\u0440\u043E\u043F\u0438\u0441\u044C \u043F\u0443\u0441\u0442\u043E\u0435\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435 \u0440\u0430\u0437\u043C \u0440\u0430\u0437\u043E\u0431\u0440\u0430\u0442\u044C\u043F\u043E\u0437\u0438\u0446\u0438\u044E\u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430 \u0440\u0430\u0441\u0441\u0447\u0438\u0442\u0430\u0442\u044C\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u044B\u043D\u0430 \u0440\u0430\u0441\u0441\u0447\u0438\u0442\u0430\u0442\u044C\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u044B\u043F\u043E \u0441\u0438\u043C\u0432 \u0441\u043E\u0437\u0434\u0430\u0442\u044C\u043E\u0431\u044A\u0435\u043A\u0442 \u0441\u0442\u0430\u0442\u0443\u0441\u0432\u043E\u0437\u0432\u0440\u0430\u0442\u0430 \u0441\u0442\u0440\u043A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E\u0441\u0442\u0440\u043E\u043A \u0441\u0444\u043E\u0440\u043C\u0438\u0440\u043E\u0432\u0430\u0442\u044C\u043F\u043E\u0437\u0438\u0446\u0438\u044E\u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430 \u0441\u0447\u0435\u0442\u043F\u043E\u043A\u043E\u0434\u0443 \u0442\u0435\u043A\u0443\u0449\u0435\u0435\u0432\u0440\u0435\u043C\u044F \u0442\u0438\u043F\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u044F \u0442\u0438\u043F\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u044F\u0441\u0442\u0440 \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C\u0442\u0430\u043D\u0430 \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C\u0442\u0430\u043F\u043E \u0444\u0438\u043A\u0441\u0448\u0430\u0431\u043B\u043E\u043D \u0448\u0430\u0431\u043B\u043E\u043D ";
    // v8 методы глобального контекста ==> built_in
    var v8_global_context_methods = "acos asin atan base64\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435 base64\u0441\u0442\u0440\u043E\u043A\u0430 cos exp log log10 pow sin sqrt tan xml\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435 xml\u0441\u0442\u0440\u043E\u043A\u0430 xml\u0442\u0438\u043F xml\u0442\u0438\u043F\u0437\u043D\u0447 \u0430\u043A\u0442\u0438\u0432\u043D\u043E\u0435\u043E\u043A\u043D\u043E \u0431\u0435\u0437\u043E\u043F\u0430\u0441\u043D\u044B\u0439\u0440\u0435\u0436\u0438\u043C \u0431\u0435\u0437\u043E\u043F\u0430\u0441\u043D\u044B\u0439\u0440\u0435\u0436\u0438\u043C\u0440\u0430\u0437\u0434\u0435\u043B\u0435\u043D\u0438\u044F\u0434\u0430\u043D\u043D\u044B\u0445 \u0431\u0443\u043B\u0435\u0432\u043E \u0432\u0432\u0435\u0441\u0442\u0438\u0434\u0430\u0442\u0443 \u0432\u0432\u0435\u0441\u0442\u0438\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435 \u0432\u0432\u0435\u0441\u0442\u0438\u0441\u0442\u0440\u043E\u043A\u0443 \u0432\u0432\u0435\u0441\u0442\u0438\u0447\u0438\u0441\u043B\u043E \u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E\u0441\u0442\u044C\u0447\u0442\u0435\u043D\u0438\u044Fxml \u0432\u043E\u043F\u0440\u043E\u0441 \u0432\u043E\u0441\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435 \u0432\u0440\u0435\u0433 \u0432\u044B\u0433\u0440\u0443\u0437\u0438\u0442\u044C\u0436\u0443\u0440\u043D\u0430\u043B\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438 \u0432\u044B\u043F\u043E\u043B\u043D\u0438\u0442\u044C\u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0443\u043E\u043F\u043E\u0432\u0435\u0449\u0435\u043D\u0438\u044F \u0432\u044B\u043F\u043E\u043B\u043D\u0438\u0442\u044C\u043F\u0440\u043E\u0432\u0435\u0440\u043A\u0443\u043F\u0440\u0430\u0432\u0434\u043E\u0441\u0442\u0443\u043F\u0430 \u0432\u044B\u0447\u0438\u0441\u043B\u0438\u0442\u044C \u0433\u043E\u0434 \u0434\u0430\u043D\u043D\u044B\u0435\u0444\u043E\u0440\u043C\u044B\u0432\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435 \u0434\u0430\u0442\u0430 \u0434\u0435\u043D\u044C \u0434\u0435\u043D\u044C\u0433\u043E\u0434\u0430 \u0434\u0435\u043D\u044C\u043D\u0435\u0434\u0435\u043B\u0438 \u0434\u043E\u0431\u0430\u0432\u0438\u0442\u044C\u043C\u0435\u0441\u044F\u0446 \u0437\u0430\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u0442\u044C\u0434\u0430\u043D\u043D\u044B\u0435\u0434\u043B\u044F\u0440\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F \u0437\u0430\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u0442\u044C\u0440\u0430\u0431\u043E\u0442\u0443\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F \u0437\u0430\u0432\u0435\u0440\u0448\u0438\u0442\u044C\u0440\u0430\u0431\u043E\u0442\u0443\u0441\u0438\u0441\u0442\u0435\u043C\u044B \u0437\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C\u0432\u043D\u0435\u0448\u043D\u044E\u044E\u043A\u043E\u043C\u043F\u043E\u043D\u0435\u043D\u0442\u0443 \u0437\u0430\u043A\u0440\u044B\u0442\u044C\u0441\u043F\u0440\u0430\u0432\u043A\u0443 \u0437\u0430\u043F\u0438\u0441\u0430\u0442\u044Cjson \u0437\u0430\u043F\u0438\u0441\u0430\u0442\u044Cxml \u0437\u0430\u043F\u0438\u0441\u0430\u0442\u044C\u0434\u0430\u0442\u0443json \u0437\u0430\u043F\u0438\u0441\u044C\u0436\u0443\u0440\u043D\u0430\u043B\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438 \u0437\u0430\u043F\u043E\u043B\u043D\u0438\u0442\u044C\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u044F\u0441\u0432\u043E\u0439\u0441\u0442\u0432 \u0437\u0430\u043F\u0440\u043E\u0441\u0438\u0442\u044C\u0440\u0430\u0437\u0440\u0435\u0448\u0435\u043D\u0438\u0435\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F \u0437\u0430\u043F\u0443\u0441\u0442\u0438\u0442\u044C\u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435 \u0437\u0430\u043F\u0443\u0441\u0442\u0438\u0442\u044C\u0441\u0438\u0441\u0442\u0435\u043C\u0443 \u0437\u0430\u0444\u0438\u043A\u0441\u0438\u0440\u043E\u0432\u0430\u0442\u044C\u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0438\u044E \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435\u0432\u0434\u0430\u043D\u043D\u044B\u0435\u0444\u043E\u0440\u043C\u044B \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435\u0432\u0441\u0442\u0440\u043E\u043A\u0443\u0432\u043D\u0443\u0442\u0440 \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435\u0432\u0444\u0430\u0439\u043B \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435\u0437\u0430\u043F\u043E\u043B\u043D\u0435\u043D\u043E \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435\u0438\u0437\u0441\u0442\u0440\u043E\u043A\u0438\u0432\u043D\u0443\u0442\u0440 \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435\u0438\u0437\u0444\u0430\u0439\u043B\u0430 \u0438\u0437xml\u0442\u0438\u043F\u0430 \u0438\u043C\u043F\u043E\u0440\u0442\u043C\u043E\u0434\u0435\u043B\u0438xdto \u0438\u043C\u044F\u043A\u043E\u043C\u043F\u044C\u044E\u0442\u0435\u0440\u0430 \u0438\u043C\u044F\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F \u0438\u043D\u0438\u0446\u0438\u0430\u043B\u0438\u0437\u0438\u0440\u043E\u0432\u0430\u0442\u044C\u043F\u0440\u0435\u0434\u043E\u043F\u0440\u0435\u0434\u0435\u043B\u0435\u043D\u043D\u044B\u0435\u0434\u0430\u043D\u043D\u044B\u0435 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F\u043E\u0431\u043E\u0448\u0438\u0431\u043A\u0435 \u043A\u0430\u0442\u0430\u043B\u043E\u0433\u0431\u0438\u0431\u043B\u0438\u043E\u0442\u0435\u043A\u0438\u043C\u043E\u0431\u0438\u043B\u044C\u043D\u043E\u0433\u043E\u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u0430 \u043A\u0430\u0442\u0430\u043B\u043E\u0433\u0432\u0440\u0435\u043C\u0435\u043D\u043D\u044B\u0445\u0444\u0430\u0439\u043B\u043E\u0432 \u043A\u0430\u0442\u0430\u043B\u043E\u0433\u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u043E\u0432 \u043A\u0430\u0442\u0430\u043B\u043E\u0433\u043F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u044B \u043A\u043E\u0434\u0438\u0440\u043E\u0432\u0430\u0442\u044C\u0441\u0442\u0440\u043E\u043A\u0443 \u043A\u043E\u0434\u043B\u043E\u043A\u0430\u043B\u0438\u0437\u0430\u0446\u0438\u0438\u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u043E\u043D\u043D\u043E\u0439\u0431\u0430\u0437\u044B \u043A\u043E\u0434\u0441\u0438\u043C\u0432\u043E\u043B\u0430 \u043A\u043E\u043C\u0430\u043D\u0434\u0430\u0441\u0438\u0441\u0442\u0435\u043C\u044B \u043A\u043E\u043D\u0435\u0446\u0433\u043E\u0434\u0430 \u043A\u043E\u043D\u0435\u0446\u0434\u043D\u044F \u043A\u043E\u043D\u0435\u0446\u043A\u0432\u0430\u0440\u0442\u0430\u043B\u0430 \u043A\u043E\u043D\u0435\u0446\u043C\u0435\u0441\u044F\u0446\u0430 \u043A\u043E\u043D\u0435\u0446\u043C\u0438\u043D\u0443\u0442\u044B \u043A\u043E\u043D\u0435\u0446\u043D\u0435\u0434\u0435\u043B\u0438 \u043A\u043E\u043D\u0435\u0446\u0447\u0430\u0441\u0430 \u043A\u043E\u043D\u0444\u0438\u0433\u0443\u0440\u0430\u0446\u0438\u044F\u0431\u0430\u0437\u044B\u0434\u0430\u043D\u043D\u044B\u0445\u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0430\u0434\u0438\u043D\u0430\u043C\u0438\u0447\u0435\u0441\u043A\u0438 \u043A\u043E\u043D\u0444\u0438\u0433\u0443\u0440\u0430\u0446\u0438\u044F\u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0430 \u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C\u0434\u0430\u043D\u043D\u044B\u0435\u0444\u043E\u0440\u043C\u044B \u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C\u0444\u0430\u0439\u043B \u043A\u0440\u0430\u0442\u043A\u043E\u0435\u043F\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0438\u0435\u043E\u0448\u0438\u0431\u043A\u0438 \u043B\u0435\u0432 \u043C\u0430\u043A\u0441 \u043C\u0435\u0441\u0442\u043D\u043E\u0435\u0432\u0440\u0435\u043C\u044F \u043C\u0435\u0441\u044F\u0446 \u043C\u0438\u043D \u043C\u0438\u043D\u0443\u0442\u0430 \u043C\u043E\u043D\u043E\u043F\u043E\u043B\u044C\u043D\u044B\u0439\u0440\u0435\u0436\u0438\u043C \u043D\u0430\u0439\u0442\u0438 \u043D\u0430\u0439\u0442\u0438\u043D\u0435\u0434\u043E\u043F\u0443\u0441\u0442\u0438\u043C\u044B\u0435\u0441\u0438\u043C\u0432\u043E\u043B\u044Bxml \u043D\u0430\u0439\u0442\u0438\u043E\u043A\u043D\u043E\u043F\u043E\u043D\u0430\u0432\u0438\u0433\u0430\u0446\u0438\u043E\u043D\u043D\u043E\u0439\u0441\u0441\u044B\u043B\u043A\u0435 \u043D\u0430\u0439\u0442\u0438\u043F\u043E\u043C\u0435\u0447\u0435\u043D\u043D\u044B\u0435\u043D\u0430\u0443\u0434\u0430\u043B\u0435\u043D\u0438\u0435 \u043D\u0430\u0439\u0442\u0438\u043F\u043E\u0441\u0441\u044B\u043B\u043A\u0430\u043C \u043D\u0430\u0439\u0442\u0438\u0444\u0430\u0439\u043B\u044B \u043D\u0430\u0447\u0430\u043B\u043E\u0433\u043E\u0434\u0430 \u043D\u0430\u0447\u0430\u043B\u043E\u0434\u043D\u044F \u043D\u0430\u0447\u0430\u043B\u043E\u043A\u0432\u0430\u0440\u0442\u0430\u043B\u0430 \u043D\u0430\u0447\u0430\u043B\u043E\u043C\u0435\u0441\u044F\u0446\u0430 \u043D\u0430\u0447\u0430\u043B\u043E\u043C\u0438\u043D\u0443\u0442\u044B \u043D\u0430\u0447\u0430\u043B\u043E\u043D\u0435\u0434\u0435\u043B\u0438 \u043D\u0430\u0447\u0430\u043B\u043E\u0447\u0430\u0441\u0430 \u043D\u0430\u0447\u0430\u0442\u044C\u0437\u0430\u043F\u0440\u043E\u0441\u0440\u0430\u0437\u0440\u0435\u0448\u0435\u043D\u0438\u044F\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F \u043D\u0430\u0447\u0430\u0442\u044C\u0437\u0430\u043F\u0443\u0441\u043A\u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u044F \u043D\u0430\u0447\u0430\u0442\u044C\u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435\u0444\u0430\u0439\u043B\u0430 \u043D\u0430\u0447\u0430\u0442\u044C\u043F\u0435\u0440\u0435\u043C\u0435\u0449\u0435\u043D\u0438\u0435\u0444\u0430\u0439\u043B\u0430 \u043D\u0430\u0447\u0430\u0442\u044C\u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0435\u0432\u043D\u0435\u0448\u043D\u0435\u0439\u043A\u043E\u043C\u043F\u043E\u043D\u0435\u043D\u0442\u044B \u043D\u0430\u0447\u0430\u0442\u044C\u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0435\u0440\u0430\u0441\u0448\u0438\u0440\u0435\u043D\u0438\u044F\u0440\u0430\u0431\u043E\u0442\u044B\u0441\u043A\u0440\u0438\u043F\u0442\u043E\u0433\u0440\u0430\u0444\u0438\u0435\u0439 \u043D\u0430\u0447\u0430\u0442\u044C\u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0435\u0440\u0430\u0441\u0448\u0438\u0440\u0435\u043D\u0438\u044F\u0440\u0430\u0431\u043E\u0442\u044B\u0441\u0444\u0430\u0439\u043B\u0430\u043C\u0438 \u043D\u0430\u0447\u0430\u0442\u044C\u043F\u043E\u0438\u0441\u043A\u0444\u0430\u0439\u043B\u043E\u0432 \u043D\u0430\u0447\u0430\u0442\u044C\u043F\u043E\u043B\u0443\u0447\u0435\u043D\u0438\u0435\u043A\u0430\u0442\u0430\u043B\u043E\u0433\u0430\u0432\u0440\u0435\u043C\u0435\u043D\u043D\u044B\u0445\u0444\u0430\u0439\u043B\u043E\u0432 \u043D\u0430\u0447\u0430\u0442\u044C\u043F\u043E\u043B\u0443\u0447\u0435\u043D\u0438\u0435\u043A\u0430\u0442\u0430\u043B\u043E\u0433\u0430\u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u043E\u0432 \u043D\u0430\u0447\u0430\u0442\u044C\u043F\u043E\u043B\u0443\u0447\u0435\u043D\u0438\u0435\u0440\u0430\u0431\u043E\u0447\u0435\u0433\u043E\u043A\u0430\u0442\u0430\u043B\u043E\u0433\u0430\u0434\u0430\u043D\u043D\u044B\u0445\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F \u043D\u0430\u0447\u0430\u0442\u044C\u043F\u043E\u043B\u0443\u0447\u0435\u043D\u0438\u0435\u0444\u0430\u0439\u043B\u043E\u0432 \u043D\u0430\u0447\u0430\u0442\u044C\u043F\u043E\u043C\u0435\u0449\u0435\u043D\u0438\u0435\u0444\u0430\u0439\u043B\u0430 \u043D\u0430\u0447\u0430\u0442\u044C\u043F\u043E\u043C\u0435\u0449\u0435\u043D\u0438\u0435\u0444\u0430\u0439\u043B\u043E\u0432 \u043D\u0430\u0447\u0430\u0442\u044C\u0441\u043E\u0437\u0434\u0430\u043D\u0438\u0435\u0434\u0432\u043E\u0438\u0447\u043D\u044B\u0445\u0434\u0430\u043D\u043D\u044B\u0445\u0438\u0437\u0444\u0430\u0439\u043B\u0430 \u043D\u0430\u0447\u0430\u0442\u044C\u0441\u043E\u0437\u0434\u0430\u043D\u0438\u0435\u043A\u0430\u0442\u0430\u043B\u043E\u0433\u0430 \u043D\u0430\u0447\u0430\u0442\u044C\u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0438\u044E \u043D\u0430\u0447\u0430\u0442\u044C\u0443\u0434\u0430\u043B\u0435\u043D\u0438\u0435\u0444\u0430\u0439\u043B\u043E\u0432 \u043D\u0430\u0447\u0430\u0442\u044C\u0443\u0441\u0442\u0430\u043D\u043E\u0432\u043A\u0443\u0432\u043D\u0435\u0448\u043D\u0435\u0439\u043A\u043E\u043C\u043F\u043E\u043D\u0435\u043D\u0442\u044B \u043D\u0430\u0447\u0430\u0442\u044C\u0443\u0441\u0442\u0430\u043D\u043E\u0432\u043A\u0443\u0440\u0430\u0441\u0448\u0438\u0440\u0435\u043D\u0438\u044F\u0440\u0430\u0431\u043E\u0442\u044B\u0441\u043A\u0440\u0438\u043F\u0442\u043E\u0433\u0440\u0430\u0444\u0438\u0435\u0439 \u043D\u0430\u0447\u0430\u0442\u044C\u0443\u0441\u0442\u0430\u043D\u043E\u0432\u043A\u0443\u0440\u0430\u0441\u0448\u0438\u0440\u0435\u043D\u0438\u044F\u0440\u0430\u0431\u043E\u0442\u044B\u0441\u0444\u0430\u0439\u043B\u0430\u043C\u0438 \u043D\u0435\u0434\u0435\u043B\u044F\u0433\u043E\u0434\u0430 \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E\u0441\u0442\u044C\u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0438\u044F\u0441\u043E\u0435\u0434\u0438\u043D\u0435\u043D\u0438\u044F \u043D\u043E\u043C\u0435\u0440\u0441\u0435\u0430\u043D\u0441\u0430\u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u043E\u043D\u043D\u043E\u0439\u0431\u0430\u0437\u044B \u043D\u043E\u043C\u0435\u0440\u0441\u043E\u0435\u0434\u0438\u043D\u0435\u043D\u0438\u044F\u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u043E\u043D\u043D\u043E\u0439\u0431\u0430\u0437\u044B \u043D\u0440\u0435\u0433 \u043D\u0441\u0442\u0440 \u043E\u0431\u043D\u043E\u0432\u0438\u0442\u044C\u0438\u043D\u0442\u0435\u0440\u0444\u0435\u0439\u0441 \u043E\u0431\u043D\u043E\u0432\u0438\u0442\u044C\u043D\u0443\u043C\u0435\u0440\u0430\u0446\u0438\u044E\u043E\u0431\u044A\u0435\u043A\u0442\u043E\u0432 \u043E\u0431\u043D\u043E\u0432\u0438\u0442\u044C\u043F\u043E\u0432\u0442\u043E\u0440\u043D\u043E\u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0435\u043C\u044B\u0435\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u044F \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0430\u043F\u0440\u0435\u0440\u044B\u0432\u0430\u043D\u0438\u044F\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F \u043E\u0431\u044A\u0435\u0434\u0438\u043D\u0438\u0442\u044C\u0444\u0430\u0439\u043B\u044B \u043E\u043A\u0440 \u043E\u043F\u0438\u0441\u0430\u043D\u0438\u0435\u043E\u0448\u0438\u0431\u043A\u0438 \u043E\u043F\u043E\u0432\u0435\u0441\u0442\u0438\u0442\u044C \u043E\u043F\u043E\u0432\u0435\u0441\u0442\u0438\u0442\u044C\u043E\u0431\u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u0438 \u043E\u0442\u043A\u043B\u044E\u0447\u0438\u0442\u044C\u043E\u0431\u0440\u0430\u0431\u043E\u0442\u0447\u0438\u043A\u0437\u0430\u043F\u0440\u043E\u0441\u0430\u043D\u0430\u0441\u0442\u0440\u043E\u0435\u043A\u043A\u043B\u0438\u0435\u043D\u0442\u0430\u043B\u0438\u0446\u0435\u043D\u0437\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F \u043E\u0442\u043A\u043B\u044E\u0447\u0438\u0442\u044C\u043E\u0431\u0440\u0430\u0431\u043E\u0442\u0447\u0438\u043A\u043E\u0436\u0438\u0434\u0430\u043D\u0438\u044F \u043E\u0442\u043A\u043B\u044E\u0447\u0438\u0442\u044C\u043E\u0431\u0440\u0430\u0431\u043E\u0442\u0447\u0438\u043A\u043E\u043F\u043E\u0432\u0435\u0449\u0435\u043D\u0438\u044F \u043E\u0442\u043A\u0440\u044B\u0442\u044C\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435 \u043E\u0442\u043A\u0440\u044B\u0442\u044C\u0438\u043D\u0434\u0435\u043A\u0441\u0441\u043F\u0440\u0430\u0432\u043A\u0438 \u043E\u0442\u043A\u0440\u044B\u0442\u044C\u0441\u043E\u0434\u0435\u0440\u0436\u0430\u043D\u0438\u0435\u0441\u043F\u0440\u0430\u0432\u043A\u0438 \u043E\u0442\u043A\u0440\u044B\u0442\u044C\u0441\u043F\u0440\u0430\u0432\u043A\u0443 \u043E\u0442\u043A\u0440\u044B\u0442\u044C\u0444\u043E\u0440\u043C\u0443 \u043E\u0442\u043A\u0440\u044B\u0442\u044C\u0444\u043E\u0440\u043C\u0443\u043C\u043E\u0434\u0430\u043B\u044C\u043D\u043E \u043E\u0442\u043C\u0435\u043D\u0438\u0442\u044C\u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0438\u044E \u043E\u0447\u0438\u0441\u0442\u0438\u0442\u044C\u0436\u0443\u0440\u043D\u0430\u043B\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438 \u043E\u0447\u0438\u0441\u0442\u0438\u0442\u044C\u043D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F \u043E\u0447\u0438\u0441\u0442\u0438\u0442\u044C\u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u044F \u043F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u044B\u0434\u043E\u0441\u0442\u0443\u043F\u0430 \u043F\u0435\u0440\u0435\u0439\u0442\u0438\u043F\u043E\u043D\u0430\u0432\u0438\u0433\u0430\u0446\u0438\u043E\u043D\u043D\u043E\u0439\u0441\u0441\u044B\u043B\u043A\u0435 \u043F\u0435\u0440\u0435\u043C\u0435\u0441\u0442\u0438\u0442\u044C\u0444\u0430\u0439\u043B \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0438\u0442\u044C\u0432\u043D\u0435\u0448\u043D\u044E\u044E\u043A\u043E\u043C\u043F\u043E\u043D\u0435\u043D\u0442\u0443 \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0438\u0442\u044C\u043E\u0431\u0440\u0430\u0431\u043E\u0442\u0447\u0438\u043A\u0437\u0430\u043F\u0440\u043E\u0441\u0430\u043D\u0430\u0441\u0442\u0440\u043E\u0435\u043A\u043A\u043B\u0438\u0435\u043D\u0442\u0430\u043B\u0438\u0446\u0435\u043D\u0437\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0438\u0442\u044C\u043E\u0431\u0440\u0430\u0431\u043E\u0442\u0447\u0438\u043A\u043E\u0436\u0438\u0434\u0430\u043D\u0438\u044F \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0438\u0442\u044C\u043E\u0431\u0440\u0430\u0431\u043E\u0442\u0447\u0438\u043A\u043E\u043F\u043E\u0432\u0435\u0449\u0435\u043D\u0438\u044F \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0438\u0442\u044C\u0440\u0430\u0441\u0448\u0438\u0440\u0435\u043D\u0438\u0435\u0440\u0430\u0431\u043E\u0442\u044B\u0441\u043A\u0440\u0438\u043F\u0442\u043E\u0433\u0440\u0430\u0444\u0438\u0435\u0439 \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0438\u0442\u044C\u0440\u0430\u0441\u0448\u0438\u0440\u0435\u043D\u0438\u0435\u0440\u0430\u0431\u043E\u0442\u044B\u0441\u0444\u0430\u0439\u043B\u0430\u043C\u0438 \u043F\u043E\u0434\u0440\u043E\u0431\u043D\u043E\u0435\u043F\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0438\u0435\u043E\u0448\u0438\u0431\u043A\u0438 \u043F\u043E\u043A\u0430\u0437\u0430\u0442\u044C\u0432\u0432\u043E\u0434\u0434\u0430\u0442\u044B \u043F\u043E\u043A\u0430\u0437\u0430\u0442\u044C\u0432\u0432\u043E\u0434\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u044F \u043F\u043E\u043A\u0430\u0437\u0430\u0442\u044C\u0432\u0432\u043E\u0434\u0441\u0442\u0440\u043E\u043A\u0438 \u043F\u043E\u043A\u0430\u0437\u0430\u0442\u044C\u0432\u0432\u043E\u0434\u0447\u0438\u0441\u043B\u0430 \u043F\u043E\u043A\u0430\u0437\u0430\u0442\u044C\u0432\u043E\u043F\u0440\u043E\u0441 \u043F\u043E\u043A\u0430\u0437\u0430\u0442\u044C\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435 \u043F\u043E\u043A\u0430\u0437\u0430\u0442\u044C\u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044E\u043E\u0431\u043E\u0448\u0438\u0431\u043A\u0435 \u043F\u043E\u043A\u0430\u0437\u0430\u0442\u044C\u043D\u0430\u043A\u0430\u0440\u0442\u0435 \u043F\u043E\u043A\u0430\u0437\u0430\u0442\u044C\u043E\u043F\u043E\u0432\u0435\u0449\u0435\u043D\u0438\u0435\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F \u043F\u043E\u043A\u0430\u0437\u0430\u0442\u044C\u043F\u0440\u0435\u0434\u0443\u043F\u0440\u0435\u0436\u0434\u0435\u043D\u0438\u0435 \u043F\u043E\u043B\u043D\u043E\u0435\u0438\u043C\u044F\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044Ccom\u043E\u0431\u044A\u0435\u043A\u0442 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044Cxml\u0442\u0438\u043F \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u0430\u0434\u0440\u0435\u0441\u043F\u043E\u043C\u0435\u0441\u0442\u043E\u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u044E \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u043A\u0443\u0441\u0435\u0430\u043D\u0441\u043E\u0432 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u0432\u0440\u0435\u043C\u044F\u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0438\u044F\u0441\u043F\u044F\u0449\u0435\u0433\u043E\u0441\u0435\u0430\u043D\u0441\u0430 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u0432\u0440\u0435\u043C\u044F\u0437\u0430\u0441\u044B\u043F\u0430\u043D\u0438\u044F\u043F\u0430\u0441\u0441\u0438\u0432\u043D\u043E\u0433\u043E\u0441\u0435\u0430\u043D\u0441\u0430 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u0432\u0440\u0435\u043C\u044F\u043E\u0436\u0438\u0434\u0430\u043D\u0438\u044F\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u0434\u0430\u043D\u043D\u044B\u0435\u0432\u044B\u0431\u043E\u0440\u0430 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u0434\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0439\u043F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u043A\u043B\u0438\u0435\u043D\u0442\u0430\u043B\u0438\u0446\u0435\u043D\u0437\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u0434\u043E\u043F\u0443\u0441\u0442\u0438\u043C\u044B\u0435\u043A\u043E\u0434\u044B\u043B\u043E\u043A\u0430\u043B\u0438\u0437\u0430\u0446\u0438\u0438 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u0434\u043E\u043F\u0443\u0441\u0442\u0438\u043C\u044B\u0435\u0447\u0430\u0441\u043E\u0432\u044B\u0435\u043F\u043E\u044F\u0441\u0430 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u0437\u0430\u0433\u043E\u043B\u043E\u0432\u043E\u043A\u043A\u043B\u0438\u0435\u043D\u0442\u0441\u043A\u043E\u0433\u043E\u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u044F \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u0437\u0430\u0433\u043E\u043B\u043E\u0432\u043E\u043A\u0441\u0438\u0441\u0442\u0435\u043C\u044B \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u044F\u043E\u0442\u0431\u043E\u0440\u0430\u0436\u0443\u0440\u043D\u0430\u043B\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u0438\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440\u043A\u043E\u043D\u0444\u0438\u0433\u0443\u0440\u0430\u0446\u0438\u0438 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u0438\u0437\u0432\u0440\u0435\u043C\u0435\u043D\u043D\u043E\u0433\u043E\u0445\u0440\u0430\u043D\u0438\u043B\u0438\u0449\u0430 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u0438\u043C\u044F\u0432\u0440\u0435\u043C\u0435\u043D\u043D\u043E\u0433\u043E\u0444\u0430\u0439\u043B\u0430 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u0438\u043C\u044F\u043A\u043B\u0438\u0435\u043D\u0442\u0430\u043B\u0438\u0446\u0435\u043D\u0437\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044E\u044D\u043A\u0440\u0430\u043D\u043E\u0432\u043A\u043B\u0438\u0435\u043D\u0442\u0430 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435\u0436\u0443\u0440\u043D\u0430\u043B\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435\u0441\u043E\u0431\u044B\u0442\u0438\u044F\u0436\u0443\u0440\u043D\u0430\u043B\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u043A\u0440\u0430\u0442\u043A\u0438\u0439\u0437\u0430\u0433\u043E\u043B\u043E\u0432\u043E\u043A\u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u044F \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u043C\u0430\u043A\u0435\u0442\u043E\u0444\u043E\u0440\u043C\u043B\u0435\u043D\u0438\u044F \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u043C\u0430\u0441\u043A\u0443\u0432\u0441\u0435\u0444\u0430\u0439\u043B\u044B \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u043C\u0430\u0441\u043A\u0443\u0432\u0441\u0435\u0444\u0430\u0439\u043B\u044B\u043A\u043B\u0438\u0435\u043D\u0442\u0430 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u043C\u0430\u0441\u043A\u0443\u0432\u0441\u0435\u0444\u0430\u0439\u043B\u044B\u0441\u0435\u0440\u0432\u0435\u0440\u0430 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u043C\u0435\u0441\u0442\u043E\u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0435\u043F\u043E\u0430\u0434\u0440\u0435\u0441\u0443 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u043C\u0438\u043D\u0438\u043C\u0430\u043B\u044C\u043D\u0443\u044E\u0434\u043B\u0438\u043D\u0443\u043F\u0430\u0440\u043E\u043B\u0435\u0439\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u0439 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u043D\u0430\u0432\u0438\u0433\u0430\u0446\u0438\u043E\u043D\u043D\u0443\u044E\u0441\u0441\u044B\u043B\u043A\u0443 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u043D\u0430\u0432\u0438\u0433\u0430\u0446\u0438\u043E\u043D\u043D\u0443\u044E\u0441\u0441\u044B\u043B\u043A\u0443\u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u043E\u043D\u043D\u043E\u0439\u0431\u0430\u0437\u044B \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u0435\u043A\u043E\u043D\u0444\u0438\u0433\u0443\u0440\u0430\u0446\u0438\u0438\u0431\u0430\u0437\u044B\u0434\u0430\u043D\u043D\u044B\u0445 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u0435\u043F\u0440\u0435\u0434\u043E\u043F\u0440\u0435\u0434\u0435\u043B\u0435\u043D\u043D\u044B\u0445\u0434\u0430\u043D\u043D\u044B\u0445\u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u043E\u043D\u043D\u043E\u0439\u0431\u0430\u0437\u044B \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u043E\u0431\u0449\u0438\u0439\u043C\u0430\u043A\u0435\u0442 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u043E\u0431\u0449\u0443\u044E\u0444\u043E\u0440\u043C\u0443 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u043E\u043A\u043D\u0430 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u043E\u043F\u0435\u0440\u0430\u0442\u0438\u0432\u043D\u0443\u044E\u043E\u0442\u043C\u0435\u0442\u043A\u0443\u0432\u0440\u0435\u043C\u0435\u043D\u0438 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u043E\u0442\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0435\u0431\u0435\u0437\u043E\u043F\u0430\u0441\u043D\u043E\u0433\u043E\u0440\u0435\u0436\u0438\u043C\u0430 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u043F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u044B\u0444\u0443\u043D\u043A\u0446\u0438\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0445\u043E\u043F\u0446\u0438\u0439\u0438\u043D\u0442\u0435\u0440\u0444\u0435\u0439\u0441\u0430 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u043F\u043E\u043B\u043D\u043E\u0435\u0438\u043C\u044F\u043F\u0440\u0435\u0434\u043E\u043F\u0440\u0435\u0434\u0435\u043B\u0435\u043D\u043D\u043E\u0433\u043E\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u044F \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u043F\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0438\u044F\u043D\u0430\u0432\u0438\u0433\u0430\u0446\u0438\u043E\u043D\u043D\u044B\u0445\u0441\u0441\u044B\u043B\u043E\u043A \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u043F\u0440\u043E\u0432\u0435\u0440\u043A\u0443\u0441\u043B\u043E\u0436\u043D\u043E\u0441\u0442\u0438\u043F\u0430\u0440\u043E\u043B\u0435\u0439\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u0439 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u0440\u0430\u0437\u0434\u0435\u043B\u0438\u0442\u0435\u043B\u044C\u043F\u0443\u0442\u0438 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u0440\u0430\u0437\u0434\u0435\u043B\u0438\u0442\u0435\u043B\u044C\u043F\u0443\u0442\u0438\u043A\u043B\u0438\u0435\u043D\u0442\u0430 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u0440\u0430\u0437\u0434\u0435\u043B\u0438\u0442\u0435\u043B\u044C\u043F\u0443\u0442\u0438\u0441\u0435\u0440\u0432\u0435\u0440\u0430 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u0441\u0435\u0430\u043D\u0441\u044B\u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u043E\u043D\u043D\u043E\u0439\u0431\u0430\u0437\u044B \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u0441\u043A\u043E\u0440\u043E\u0441\u0442\u044C\u043A\u043B\u0438\u0435\u043D\u0442\u0441\u043A\u043E\u0433\u043E\u0441\u043E\u0435\u0434\u0438\u043D\u0435\u043D\u0438\u044F \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u0441\u043E\u0435\u0434\u0438\u043D\u0435\u043D\u0438\u044F\u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u043E\u043D\u043D\u043E\u0439\u0431\u0430\u0437\u044B \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u044F\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044E \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0438\u0435\u043E\u0431\u044A\u0435\u043A\u0442\u0430\u0438\u0444\u043E\u0440\u043C\u044B \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u0441\u043E\u0441\u0442\u0430\u0432\u0441\u0442\u0430\u043D\u0434\u0430\u0440\u0442\u043D\u043E\u0433\u043E\u0438\u043D\u0442\u0435\u0440\u0444\u0435\u0439\u0441\u0430odata \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u0441\u0442\u0440\u0443\u043A\u0442\u0443\u0440\u0443\u0445\u0440\u0430\u043D\u0435\u043D\u0438\u044F\u0431\u0430\u0437\u044B\u0434\u0430\u043D\u043D\u044B\u0445 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u0442\u0435\u043A\u0443\u0449\u0438\u0439\u0441\u0435\u0430\u043D\u0441\u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u043E\u043D\u043D\u043E\u0439\u0431\u0430\u0437\u044B \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u0444\u0430\u0439\u043B \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u0444\u0430\u0439\u043B\u044B \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u0444\u043E\u0440\u043C\u0443 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u0444\u0443\u043D\u043A\u0446\u0438\u043E\u043D\u0430\u043B\u044C\u043D\u0443\u044E\u043E\u043F\u0446\u0438\u044E \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u0444\u0443\u043D\u043A\u0446\u0438\u043E\u043D\u0430\u043B\u044C\u043D\u0443\u044E\u043E\u043F\u0446\u0438\u044E\u0438\u043D\u0442\u0435\u0440\u0444\u0435\u0439\u0441\u0430 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u0447\u0430\u0441\u043E\u0432\u043E\u0439\u043F\u043E\u044F\u0441\u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u043E\u043D\u043D\u043E\u0439\u0431\u0430\u0437\u044B \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0438\u043E\u0441 \u043F\u043E\u043C\u0435\u0441\u0442\u0438\u0442\u044C\u0432\u043E\u0432\u0440\u0435\u043C\u0435\u043D\u043D\u043E\u0435\u0445\u0440\u0430\u043D\u0438\u043B\u0438\u0449\u0435 \u043F\u043E\u043C\u0435\u0441\u0442\u0438\u0442\u044C\u0444\u0430\u0439\u043B \u043F\u043E\u043C\u0435\u0441\u0442\u0438\u0442\u044C\u0444\u0430\u0439\u043B\u044B \u043F\u0440\u0430\u0432 \u043F\u0440\u0430\u0432\u043E\u0434\u043E\u0441\u0442\u0443\u043F\u0430 \u043F\u0440\u0435\u0434\u043E\u043F\u0440\u0435\u0434\u0435\u043B\u0435\u043D\u043D\u043E\u0435\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435 \u043F\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0438\u0435\u043A\u043E\u0434\u0430\u043B\u043E\u043A\u0430\u043B\u0438\u0437\u0430\u0446\u0438\u0438 \u043F\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0438\u0435\u043F\u0435\u0440\u0438\u043E\u0434\u0430 \u043F\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0438\u0435\u043F\u0440\u0430\u0432\u0430 \u043F\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0438\u0435\u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u044F \u043F\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0438\u0435\u0441\u043E\u0431\u044B\u0442\u0438\u044F\u0436\u0443\u0440\u043D\u0430\u043B\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438 \u043F\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0438\u0435\u0447\u0430\u0441\u043E\u0432\u043E\u0433\u043E\u043F\u043E\u044F\u0441\u0430 \u043F\u0440\u0435\u0434\u0443\u043F\u0440\u0435\u0436\u0434\u0435\u043D\u0438\u0435 \u043F\u0440\u0435\u043A\u0440\u0430\u0442\u0438\u0442\u044C\u0440\u0430\u0431\u043E\u0442\u0443\u0441\u0438\u0441\u0442\u0435\u043C\u044B \u043F\u0440\u0438\u0432\u0438\u043B\u0435\u0433\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u0439\u0440\u0435\u0436\u0438\u043C \u043F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u044C\u0432\u044B\u0437\u043E\u0432 \u043F\u0440\u043E\u0447\u0438\u0442\u0430\u0442\u044Cjson \u043F\u0440\u043E\u0447\u0438\u0442\u0430\u0442\u044Cxml \u043F\u0440\u043E\u0447\u0438\u0442\u0430\u0442\u044C\u0434\u0430\u0442\u0443json \u043F\u0443\u0441\u0442\u0430\u044F\u0441\u0442\u0440\u043E\u043A\u0430 \u0440\u0430\u0431\u043E\u0447\u0438\u0439\u043A\u0430\u0442\u0430\u043B\u043E\u0433\u0434\u0430\u043D\u043D\u044B\u0445\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F \u0440\u0430\u0437\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u0442\u044C\u0434\u0430\u043D\u043D\u044B\u0435\u0434\u043B\u044F\u0440\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F \u0440\u0430\u0437\u0434\u0435\u043B\u0438\u0442\u044C\u0444\u0430\u0439\u043B \u0440\u0430\u0437\u043E\u0440\u0432\u0430\u0442\u044C\u0441\u043E\u0435\u0434\u0438\u043D\u0435\u043D\u0438\u0435\u0441\u0432\u043D\u0435\u0448\u043D\u0438\u043C\u0438\u0441\u0442\u043E\u0447\u043D\u0438\u043A\u043E\u043C\u0434\u0430\u043D\u043D\u044B\u0445 \u0440\u0430\u0441\u043A\u043E\u0434\u0438\u0440\u043E\u0432\u0430\u0442\u044C\u0441\u0442\u0440\u043E\u043A\u0443 \u0440\u043E\u043B\u044C\u0434\u043E\u0441\u0442\u0443\u043F\u043D\u0430 \u0441\u0435\u043A\u0443\u043D\u0434\u0430 \u0441\u0438\u0433\u043D\u0430\u043B \u0441\u0438\u043C\u0432\u043E\u043B \u0441\u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C\u0436\u0443\u0440\u043D\u0430\u043B\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438 \u0441\u043C\u0435\u0449\u0435\u043D\u0438\u0435\u043B\u0435\u0442\u043D\u0435\u0433\u043E\u0432\u0440\u0435\u043C\u0435\u043D\u0438 \u0441\u043C\u0435\u0449\u0435\u043D\u0438\u0435\u0441\u0442\u0430\u043D\u0434\u0430\u0440\u0442\u043D\u043E\u0433\u043E\u0432\u0440\u0435\u043C\u0435\u043D\u0438 \u0441\u043E\u0435\u0434\u0438\u043D\u0438\u0442\u044C\u0431\u0443\u0444\u0435\u0440\u044B\u0434\u0432\u043E\u0438\u0447\u043D\u044B\u0445\u0434\u0430\u043D\u043D\u044B\u0445 \u0441\u043E\u0437\u0434\u0430\u0442\u044C\u043A\u0430\u0442\u0430\u043B\u043E\u0433 \u0441\u043E\u0437\u0434\u0430\u0442\u044C\u0444\u0430\u0431\u0440\u0438\u043A\u0443xdto \u0441\u043E\u043A\u0440\u043B \u0441\u043E\u043A\u0440\u043B\u043F \u0441\u043E\u043A\u0440\u043F \u0441\u043E\u043E\u0431\u0449\u0438\u0442\u044C \u0441\u043E\u0441\u0442\u043E\u044F\u043D\u0438\u0435 \u0441\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435 \u0441\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C\u043D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F \u0441\u0440\u0435\u0434 \u0441\u0442\u0440\u0434\u043B\u0438\u043D\u0430 \u0441\u0442\u0440\u0437\u0430\u043A\u0430\u043D\u0447\u0438\u0432\u0430\u0435\u0442\u0441\u044F\u043D\u0430 \u0441\u0442\u0440\u0437\u0430\u043C\u0435\u043D\u0438\u0442\u044C \u0441\u0442\u0440\u043D\u0430\u0439\u0442\u0438 \u0441\u0442\u0440\u043D\u0430\u0447\u0438\u043D\u0430\u0435\u0442\u0441\u044F\u0441 \u0441\u0442\u0440\u043E\u043A\u0430 \u0441\u0442\u0440\u043E\u043A\u0430\u0441\u043E\u0435\u0434\u0438\u043D\u0435\u043D\u0438\u044F\u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u043E\u043D\u043D\u043E\u0439\u0431\u0430\u0437\u044B \u0441\u0442\u0440\u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u0441\u0442\u0440\u043E\u043A\u0443 \u0441\u0442\u0440\u0440\u0430\u0437\u0434\u0435\u043B\u0438\u0442\u044C \u0441\u0442\u0440\u0441\u043E\u0435\u0434\u0438\u043D\u0438\u0442\u044C \u0441\u0442\u0440\u0441\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0441\u0442\u0440\u0447\u0438\u0441\u043B\u043E\u0432\u0445\u043E\u0436\u0434\u0435\u043D\u0438\u0439 \u0441\u0442\u0440\u0447\u0438\u0441\u043B\u043E\u0441\u0442\u0440\u043E\u043A \u0441\u0442\u0440\u0448\u0430\u0431\u043B\u043E\u043D \u0442\u0435\u043A\u0443\u0449\u0430\u044F\u0434\u0430\u0442\u0430 \u0442\u0435\u043A\u0443\u0449\u0430\u044F\u0434\u0430\u0442\u0430\u0441\u0435\u0430\u043D\u0441\u0430 \u0442\u0435\u043A\u0443\u0449\u0430\u044F\u0443\u043D\u0438\u0432\u0435\u0440\u0441\u0430\u043B\u044C\u043D\u0430\u044F\u0434\u0430\u0442\u0430 \u0442\u0435\u043A\u0443\u0449\u0430\u044F\u0443\u043D\u0438\u0432\u0435\u0440\u0441\u0430\u043B\u044C\u043D\u0430\u044F\u0434\u0430\u0442\u0430\u0432\u043C\u0438\u043B\u043B\u0438\u0441\u0435\u043A\u0443\u043D\u0434\u0430\u0445 \u0442\u0435\u043A\u0443\u0449\u0438\u0439\u0432\u0430\u0440\u0438\u0430\u043D\u0442\u0438\u043D\u0442\u0435\u0440\u0444\u0435\u0439\u0441\u0430\u043A\u043B\u0438\u0435\u043D\u0442\u0441\u043A\u043E\u0433\u043E\u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u044F \u0442\u0435\u043A\u0443\u0449\u0438\u0439\u0432\u0430\u0440\u0438\u0430\u043D\u0442\u043E\u0441\u043D\u043E\u0432\u043D\u043E\u0433\u043E\u0448\u0440\u0438\u0444\u0442\u0430\u043A\u043B\u0438\u0435\u043D\u0442\u0441\u043A\u043E\u0433\u043E\u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u044F \u0442\u0435\u043A\u0443\u0449\u0438\u0439\u043A\u043E\u0434\u043B\u043E\u043A\u0430\u043B\u0438\u0437\u0430\u0446\u0438\u0438 \u0442\u0435\u043A\u0443\u0449\u0438\u0439\u0440\u0435\u0436\u0438\u043C\u0437\u0430\u043F\u0443\u0441\u043A\u0430 \u0442\u0435\u043A\u0443\u0449\u0438\u0439\u044F\u0437\u044B\u043A \u0442\u0435\u043A\u0443\u0449\u0438\u0439\u044F\u0437\u044B\u043A\u0441\u0438\u0441\u0442\u0435\u043C\u044B \u0442\u0438\u043F \u0442\u0438\u043F\u0437\u043D\u0447 \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0438\u044F\u0430\u043A\u0442\u0438\u0432\u043D\u0430 \u0442\u0440\u0435\u0433 \u0443\u0434\u0430\u043B\u0438\u0442\u044C\u0434\u0430\u043D\u043D\u044B\u0435\u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u043E\u043D\u043D\u043E\u0439\u0431\u0430\u0437\u044B \u0443\u0434\u0430\u043B\u0438\u0442\u044C\u0438\u0437\u0432\u0440\u0435\u043C\u0435\u043D\u043D\u043E\u0433\u043E\u0445\u0440\u0430\u043D\u0438\u043B\u0438\u0449\u0430 \u0443\u0434\u0430\u043B\u0438\u0442\u044C\u043E\u0431\u044A\u0435\u043A\u0442\u044B \u0443\u0434\u0430\u043B\u0438\u0442\u044C\u0444\u0430\u0439\u043B\u044B \u0443\u043D\u0438\u0432\u0435\u0440\u0441\u0430\u043B\u044C\u043D\u043E\u0435\u0432\u0440\u0435\u043C\u044F \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C\u0431\u0435\u0437\u043E\u043F\u0430\u0441\u043D\u044B\u0439\u0440\u0435\u0436\u0438\u043C \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C\u0431\u0435\u0437\u043E\u043F\u0430\u0441\u043D\u044B\u0439\u0440\u0435\u0436\u0438\u043C\u0440\u0430\u0437\u0434\u0435\u043B\u0435\u043D\u0438\u044F\u0434\u0430\u043D\u043D\u044B\u0445 \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u043A\u0443\u0441\u0435\u0430\u043D\u0441\u043E\u0432 \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C\u0432\u043D\u0435\u0448\u043D\u044E\u044E\u043A\u043E\u043C\u043F\u043E\u043D\u0435\u043D\u0442\u0443 \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C\u0432\u0440\u0435\u043C\u044F\u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0438\u044F\u0441\u043F\u044F\u0449\u0435\u0433\u043E\u0441\u0435\u0430\u043D\u0441\u0430 \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C\u0432\u0440\u0435\u043C\u044F\u0437\u0430\u0441\u044B\u043F\u0430\u043D\u0438\u044F\u043F\u0430\u0441\u0441\u0438\u0432\u043D\u043E\u0433\u043E\u0441\u0435\u0430\u043D\u0441\u0430 \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C\u0432\u0440\u0435\u043C\u044F\u043E\u0436\u0438\u0434\u0430\u043D\u0438\u044F\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C\u0437\u0430\u0433\u043E\u043B\u043E\u0432\u043E\u043A\u043A\u043B\u0438\u0435\u043D\u0442\u0441\u043A\u043E\u0433\u043E\u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u044F \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C\u0437\u0430\u0433\u043E\u043B\u043E\u0432\u043E\u043A\u0441\u0438\u0441\u0442\u0435\u043C\u044B \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C\u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435\u0436\u0443\u0440\u043D\u0430\u043B\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438 \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C\u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435\u0441\u043E\u0431\u044B\u0442\u0438\u044F\u0436\u0443\u0440\u043D\u0430\u043B\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438 \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C\u043A\u0440\u0430\u0442\u043A\u0438\u0439\u0437\u0430\u0433\u043E\u043B\u043E\u0432\u043E\u043A\u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u044F \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C\u043C\u0438\u043D\u0438\u043C\u0430\u043B\u044C\u043D\u0443\u044E\u0434\u043B\u0438\u043D\u0443\u043F\u0430\u0440\u043E\u043B\u0435\u0439\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u0439 \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C\u043C\u043E\u043D\u043E\u043F\u043E\u043B\u044C\u043D\u044B\u0439\u0440\u0435\u0436\u0438\u043C \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C\u043D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438\u043A\u043B\u0438\u0435\u043D\u0442\u0430\u043B\u0438\u0446\u0435\u043D\u0437\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C\u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u0435\u043F\u0440\u0435\u0434\u043E\u043F\u0440\u0435\u0434\u0435\u043B\u0435\u043D\u043D\u044B\u0445\u0434\u0430\u043D\u043D\u044B\u0445\u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u043E\u043D\u043D\u043E\u0439\u0431\u0430\u0437\u044B \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C\u043E\u0442\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0435\u0431\u0435\u0437\u043E\u043F\u0430\u0441\u043D\u043E\u0433\u043E\u0440\u0435\u0436\u0438\u043C\u0430 \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C\u043F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u044B\u0444\u0443\u043D\u043A\u0446\u0438\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0445\u043E\u043F\u0446\u0438\u0439\u0438\u043D\u0442\u0435\u0440\u0444\u0435\u0439\u0441\u0430 \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C\u043F\u0440\u0438\u0432\u0438\u043B\u0435\u0433\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u0439\u0440\u0435\u0436\u0438\u043C \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C\u043F\u0440\u043E\u0432\u0435\u0440\u043A\u0443\u0441\u043B\u043E\u0436\u043D\u043E\u0441\u0442\u0438\u043F\u0430\u0440\u043E\u043B\u0435\u0439\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u0439 \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C\u0440\u0430\u0441\u0448\u0438\u0440\u0435\u043D\u0438\u0435\u0440\u0430\u0431\u043E\u0442\u044B\u0441\u043A\u0440\u0438\u043F\u0442\u043E\u0433\u0440\u0430\u0444\u0438\u0435\u0439 \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C\u0440\u0430\u0441\u0448\u0438\u0440\u0435\u043D\u0438\u0435\u0440\u0430\u0431\u043E\u0442\u044B\u0441\u0444\u0430\u0439\u043B\u0430\u043C\u0438 \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C\u0441\u043E\u0435\u0434\u0438\u043D\u0435\u043D\u0438\u0435\u0441\u0432\u043D\u0435\u0448\u043D\u0438\u043C\u0438\u0441\u0442\u043E\u0447\u043D\u0438\u043A\u043E\u043C\u0434\u0430\u043D\u043D\u044B\u0445 \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C\u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0438\u0435\u043E\u0431\u044A\u0435\u043A\u0442\u0430\u0438\u0444\u043E\u0440\u043C\u044B \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C\u0441\u043E\u0441\u0442\u0430\u0432\u0441\u0442\u0430\u043D\u0434\u0430\u0440\u0442\u043D\u043E\u0433\u043E\u0438\u043D\u0442\u0435\u0440\u0444\u0435\u0439\u0441\u0430odata \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C\u0447\u0430\u0441\u043E\u0432\u043E\u0439\u043F\u043E\u044F\u0441\u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u043E\u043D\u043D\u043E\u0439\u0431\u0430\u0437\u044B \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C\u0447\u0430\u0441\u043E\u0432\u043E\u0439\u043F\u043E\u044F\u0441\u0441\u0435\u0430\u043D\u0441\u0430 \u0444\u043E\u0440\u043C\u0430\u0442 \u0446\u0435\u043B \u0447\u0430\u0441 \u0447\u0430\u0441\u043E\u0432\u043E\u0439\u043F\u043E\u044F\u0441 \u0447\u0430\u0441\u043E\u0432\u043E\u0439\u043F\u043E\u044F\u0441\u0441\u0435\u0430\u043D\u0441\u0430 \u0447\u0438\u0441\u043B\u043E \u0447\u0438\u0441\u043B\u043E\u043F\u0440\u043E\u043F\u0438\u0441\u044C\u044E \u044D\u0442\u043E\u0430\u0434\u0440\u0435\u0441\u0432\u0440\u0435\u043C\u0435\u043D\u043D\u043E\u0433\u043E\u0445\u0440\u0430\u043D\u0438\u043B\u0438\u0449\u0430 ";
    // v8 свойства глобального контекста ==> built_in
    var v8_global_context_property = "ws\u0441\u0441\u044B\u043B\u043A\u0438 \u0431\u0438\u0431\u043B\u0438\u043E\u0442\u0435\u043A\u0430\u043A\u0430\u0440\u0442\u0438\u043D\u043E\u043A \u0431\u0438\u0431\u043B\u0438\u043E\u0442\u0435\u043A\u0430\u043C\u0430\u043A\u0435\u0442\u043E\u0432\u043E\u0444\u043E\u0440\u043C\u043B\u0435\u043D\u0438\u044F\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u0431\u0438\u0431\u043B\u0438\u043E\u0442\u0435\u043A\u0430\u0441\u0442\u0438\u043B\u0435\u0439 \u0431\u0438\u0437\u043D\u0435\u0441\u043F\u0440\u043E\u0446\u0435\u0441\u0441\u044B \u0432\u043D\u0435\u0448\u043D\u0438\u0435\u0438\u0441\u0442\u043E\u0447\u043D\u0438\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u0432\u043D\u0435\u0448\u043D\u0438\u0435\u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0438 \u0432\u043D\u0435\u0448\u043D\u0438\u0435\u043E\u0442\u0447\u0435\u0442\u044B \u0432\u0441\u0442\u0440\u043E\u0435\u043D\u043D\u044B\u0435\u043F\u043E\u043A\u0443\u043F\u043A\u0438 \u0433\u043B\u0430\u0432\u043D\u044B\u0439\u0438\u043D\u0442\u0435\u0440\u0444\u0435\u0439\u0441 \u0433\u043B\u0430\u0432\u043D\u044B\u0439\u0441\u0442\u0438\u043B\u044C \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u044B \u0434\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u043C\u044B\u0435\u0443\u0432\u0435\u0434\u043E\u043C\u043B\u0435\u043D\u0438\u044F \u0436\u0443\u0440\u043D\u0430\u043B\u044B\u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u043E\u0432 \u0437\u0430\u0434\u0430\u0447\u0438 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F\u043E\u0431\u0438\u043D\u0442\u0435\u0440\u043D\u0435\u0442\u0441\u043E\u0435\u0434\u0438\u043D\u0435\u043D\u0438\u0438 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435\u0440\u0430\u0431\u043E\u0447\u0435\u0439\u0434\u0430\u0442\u044B \u0438\u0441\u0442\u043E\u0440\u0438\u044F\u0440\u0430\u0431\u043E\u0442\u044B\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F \u043A\u043E\u043D\u0441\u0442\u0430\u043D\u0442\u044B \u043A\u0440\u0438\u0442\u0435\u0440\u0438\u0438\u043E\u0442\u0431\u043E\u0440\u0430 \u043C\u0435\u0442\u0430\u0434\u0430\u043D\u043D\u044B\u0435 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0438 \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435\u0440\u0435\u043A\u043B\u0430\u043C\u044B \u043E\u0442\u043F\u0440\u0430\u0432\u043A\u0430\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u043C\u044B\u0445\u0443\u0432\u0435\u0434\u043E\u043C\u043B\u0435\u043D\u0438\u0439 \u043E\u0442\u0447\u0435\u0442\u044B \u043F\u0430\u043D\u0435\u043B\u044C\u0437\u0430\u0434\u0430\u0447\u043E\u0441 \u043F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u0437\u0430\u043F\u0443\u0441\u043A\u0430 \u043F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u044B\u0441\u0435\u0430\u043D\u0441\u0430 \u043F\u0435\u0440\u0435\u0447\u0438\u0441\u043B\u0435\u043D\u0438\u044F \u043F\u043B\u0430\u043D\u044B\u0432\u0438\u0434\u043E\u0432\u0440\u0430\u0441\u0447\u0435\u0442\u0430 \u043F\u043B\u0430\u043D\u044B\u0432\u0438\u0434\u043E\u0432\u0445\u0430\u0440\u0430\u043A\u0442\u0435\u0440\u0438\u0441\u0442\u0438\u043A \u043F\u043B\u0430\u043D\u044B\u043E\u0431\u043C\u0435\u043D\u0430 \u043F\u043B\u0430\u043D\u044B\u0441\u0447\u0435\u0442\u043E\u0432 \u043F\u043E\u043B\u043D\u043E\u0442\u0435\u043A\u0441\u0442\u043E\u0432\u044B\u0439\u043F\u043E\u0438\u0441\u043A \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0438\u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u043E\u043D\u043D\u043E\u0439\u0431\u0430\u0437\u044B \u043F\u043E\u0441\u043B\u0435\u0434\u043E\u0432\u0430\u0442\u0435\u043B\u044C\u043D\u043E\u0441\u0442\u0438 \u043F\u0440\u043E\u0432\u0435\u0440\u043A\u0430\u0432\u0441\u0442\u0440\u043E\u0435\u043D\u043D\u044B\u0445\u043F\u043E\u043A\u0443\u043F\u043E\u043A \u0440\u0430\u0431\u043E\u0447\u0430\u044F\u0434\u0430\u0442\u0430 \u0440\u0430\u0441\u0448\u0438\u0440\u0435\u043D\u0438\u044F\u043A\u043E\u043D\u0444\u0438\u0433\u0443\u0440\u0430\u0446\u0438\u0438 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u044B\u0431\u0443\u0445\u0433\u0430\u043B\u0442\u0435\u0440\u0438\u0438 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u044B\u043D\u0430\u043A\u043E\u043F\u043B\u0435\u043D\u0438\u044F \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u044B\u0440\u0430\u0441\u0447\u0435\u0442\u0430 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u044B\u0441\u0432\u0435\u0434\u0435\u043D\u0438\u0439 \u0440\u0435\u0433\u043B\u0430\u043C\u0435\u043D\u0442\u043D\u044B\u0435\u0437\u0430\u0434\u0430\u043D\u0438\u044F \u0441\u0435\u0440\u0438\u0430\u043B\u0438\u0437\u0430\u0442\u043E\u0440xdto \u0441\u043F\u0440\u0430\u0432\u043E\u0447\u043D\u0438\u043A\u0438 \u0441\u0440\u0435\u0434\u0441\u0442\u0432\u0430\u0433\u0435\u043E\u043F\u043E\u0437\u0438\u0446\u0438\u043E\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F \u0441\u0440\u0435\u0434\u0441\u0442\u0432\u0430\u043A\u0440\u0438\u043F\u0442\u043E\u0433\u0440\u0430\u0444\u0438\u0438 \u0441\u0440\u0435\u0434\u0441\u0442\u0432\u0430\u043C\u0443\u043B\u044C\u0442\u0438\u043C\u0435\u0434\u0438\u0430 \u0441\u0440\u0435\u0434\u0441\u0442\u0432\u0430\u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u044F\u0440\u0435\u043A\u043B\u0430\u043C\u044B \u0441\u0440\u0435\u0434\u0441\u0442\u0432\u0430\u043F\u043E\u0447\u0442\u044B \u0441\u0440\u0435\u0434\u0441\u0442\u0432\u0430\u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0438\u0438 \u0444\u0430\u0431\u0440\u0438\u043A\u0430xdto \u0444\u0430\u0439\u043B\u043E\u0432\u044B\u0435\u043F\u043E\u0442\u043E\u043A\u0438 \u0444\u043E\u043D\u043E\u0432\u044B\u0435\u0437\u0430\u0434\u0430\u043D\u0438\u044F \u0445\u0440\u0430\u043D\u0438\u043B\u0438\u0449\u0430\u043D\u0430\u0441\u0442\u0440\u043E\u0435\u043A \u0445\u0440\u0430\u043D\u0438\u043B\u0438\u0449\u0435\u0432\u0430\u0440\u0438\u0430\u043D\u0442\u043E\u0432\u043E\u0442\u0447\u0435\u0442\u043E\u0432 \u0445\u0440\u0430\u043D\u0438\u043B\u0438\u0449\u0435\u043D\u0430\u0441\u0442\u0440\u043E\u0435\u043A\u0434\u0430\u043D\u043D\u044B\u0445\u0444\u043E\u0440\u043C \u0445\u0440\u0430\u043D\u0438\u043B\u0438\u0449\u0435\u043E\u0431\u0449\u0438\u0445\u043D\u0430\u0441\u0442\u0440\u043E\u0435\u043A \u0445\u0440\u0430\u043D\u0438\u043B\u0438\u0449\u0435\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C\u0441\u043A\u0438\u0445\u043D\u0430\u0441\u0442\u0440\u043E\u0435\u043A\u0434\u0438\u043D\u0430\u043C\u0438\u0447\u0435\u0441\u043A\u0438\u0445\u0441\u043F\u0438\u0441\u043A\u043E\u0432 \u0445\u0440\u0430\u043D\u0438\u043B\u0438\u0449\u0435\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C\u0441\u043A\u0438\u0445\u043D\u0430\u0441\u0442\u0440\u043E\u0435\u043A\u043E\u0442\u0447\u0435\u0442\u043E\u0432 \u0445\u0440\u0430\u043D\u0438\u043B\u0438\u0449\u0435\u0441\u0438\u0441\u0442\u0435\u043C\u043D\u044B\u0445\u043D\u0430\u0441\u0442\u0440\u043E\u0435\u043A ";
    // built_in : встроенные или библиотечные объекты (константы, классы, функции)
    var BUILTIN = v7_system_constants + v7_global_context_methods + v8_global_context_methods + v8_global_context_property;
    // v8 системные наборы значений ==> class
    var v8_system_sets_of_values = "web\u0446\u0432\u0435\u0442\u0430 windows\u0446\u0432\u0435\u0442\u0430 windows\u0448\u0440\u0438\u0444\u0442\u044B \u0431\u0438\u0431\u043B\u0438\u043E\u0442\u0435\u043A\u0430\u043A\u0430\u0440\u0442\u0438\u043D\u043E\u043A \u0440\u0430\u043C\u043A\u0438\u0441\u0442\u0438\u043B\u044F \u0441\u0438\u043C\u0432\u043E\u043B\u044B \u0446\u0432\u0435\u0442\u0430\u0441\u0442\u0438\u043B\u044F \u0448\u0440\u0438\u0444\u0442\u044B\u0441\u0442\u0438\u043B\u044F ";
    // v8 системные перечисления - интерфейсные ==> class
    var v8_system_enums_interface = "\u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u0435\u0441\u043A\u043E\u0435\u0441\u043E\u0445\u0440\u0430\u043D\u0435\u043D\u0438\u0435\u0434\u0430\u043D\u043D\u044B\u0445\u0444\u043E\u0440\u043C\u044B\u0432\u043D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0430\u0445 \u0430\u0432\u0442\u043E\u043D\u0443\u043C\u0435\u0440\u0430\u0446\u0438\u044F\u0432\u0444\u043E\u0440\u043C\u0435 \u0430\u0432\u0442\u043E\u0440\u0430\u0437\u0434\u0432\u0438\u0436\u0435\u043D\u0438\u0435\u0441\u0435\u0440\u0438\u0439 \u0430\u043D\u0438\u043C\u0430\u0446\u0438\u044F\u0434\u0438\u0430\u0433\u0440\u0430\u043C\u043C\u044B \u0432\u0430\u0440\u0438\u0430\u043D\u0442\u0432\u044B\u0440\u0430\u0432\u043D\u0438\u0432\u0430\u043D\u0438\u044F\u044D\u043B\u0435\u043C\u0435\u043D\u0442\u043E\u0432\u0438\u0437\u0430\u0433\u043E\u043B\u043E\u0432\u043A\u043E\u0432 \u0432\u0430\u0440\u0438\u0430\u043D\u0442\u0443\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u044F\u0432\u044B\u0441\u043E\u0442\u043E\u0439\u0442\u0430\u0431\u043B\u0438\u0446\u044B \u0432\u0435\u0440\u0442\u0438\u043A\u0430\u043B\u044C\u043D\u0430\u044F\u043F\u0440\u043E\u043A\u0440\u0443\u0442\u043A\u0430\u0444\u043E\u0440\u043C\u044B \u0432\u0435\u0440\u0442\u0438\u043A\u0430\u043B\u044C\u043D\u043E\u0435\u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0435 \u0432\u0435\u0440\u0442\u0438\u043A\u0430\u043B\u044C\u043D\u043E\u0435\u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0435\u044D\u043B\u0435\u043C\u0435\u043D\u0442\u0430 \u0432\u0438\u0434\u0433\u0440\u0443\u043F\u043F\u044B\u0444\u043E\u0440\u043C\u044B \u0432\u0438\u0434\u0434\u0435\u043A\u043E\u0440\u0430\u0446\u0438\u0438\u0444\u043E\u0440\u043C\u044B \u0432\u0438\u0434\u0434\u043E\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u044F\u044D\u043B\u0435\u043C\u0435\u043D\u0442\u0430\u0444\u043E\u0440\u043C\u044B \u0432\u0438\u0434\u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u044F\u0434\u0430\u043D\u043D\u044B\u0445 \u0432\u0438\u0434\u043A\u043D\u043E\u043F\u043A\u0438\u0444\u043E\u0440\u043C\u044B \u0432\u0438\u0434\u043F\u0435\u0440\u0435\u043A\u043B\u044E\u0447\u0430\u0442\u0435\u043B\u044F \u0432\u0438\u0434\u043F\u043E\u0434\u043F\u0438\u0441\u0435\u0439\u043A\u0434\u0438\u0430\u0433\u0440\u0430\u043C\u043C\u0435 \u0432\u0438\u0434\u043F\u043E\u043B\u044F\u0444\u043E\u0440\u043C\u044B \u0432\u0438\u0434\u0444\u043B\u0430\u0436\u043A\u0430 \u0432\u043B\u0438\u044F\u043D\u0438\u0435\u0440\u0430\u0437\u043C\u0435\u0440\u0430\u043D\u0430\u043F\u0443\u0437\u044B\u0440\u0435\u043A\u0434\u0438\u0430\u0433\u0440\u0430\u043C\u043C\u044B \u0433\u043E\u0440\u0438\u0437\u043E\u043D\u0442\u0430\u043B\u044C\u043D\u043E\u0435\u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0435 \u0433\u043E\u0440\u0438\u0437\u043E\u043D\u0442\u0430\u043B\u044C\u043D\u043E\u0435\u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0435\u044D\u043B\u0435\u043C\u0435\u043D\u0442\u0430 \u0433\u0440\u0443\u043F\u043F\u0438\u0440\u043E\u0432\u043A\u0430\u043A\u043E\u043B\u043E\u043D\u043E\u043A \u0433\u0440\u0443\u043F\u043F\u0438\u0440\u043E\u0432\u043A\u0430\u043F\u043E\u0434\u0447\u0438\u043D\u0435\u043D\u043D\u044B\u0445\u044D\u043B\u0435\u043C\u0435\u043D\u0442\u043E\u0432\u0444\u043E\u0440\u043C\u044B \u0433\u0440\u0443\u043F\u043F\u044B\u0438\u044D\u043B\u0435\u043C\u0435\u043D\u0442\u044B \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0435\u043F\u0435\u0440\u0435\u0442\u0430\u0441\u043A\u0438\u0432\u0430\u043D\u0438\u044F \u0434\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0439\u0440\u0435\u0436\u0438\u043C\u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u044F \u0434\u043E\u043F\u0443\u0441\u0442\u0438\u043C\u044B\u0435\u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044F\u043F\u0435\u0440\u0435\u0442\u0430\u0441\u043A\u0438\u0432\u0430\u043D\u0438\u044F \u0438\u043D\u0442\u0435\u0440\u0432\u0430\u043B\u043C\u0435\u0436\u0434\u0443\u044D\u043B\u0435\u043C\u0435\u043D\u0442\u0430\u043C\u0438\u0444\u043E\u0440\u043C\u044B \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435\u0432\u044B\u0432\u043E\u0434\u0430 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435\u043F\u043E\u043B\u043E\u0441\u044B\u043F\u0440\u043E\u043A\u0440\u0443\u0442\u043A\u0438 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0435\u043C\u043E\u0435\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435\u0442\u043E\u0447\u043A\u0438\u0431\u0438\u0440\u0436\u0435\u0432\u043E\u0439\u0434\u0438\u0430\u0433\u0440\u0430\u043C\u043C\u044B \u0438\u0441\u0442\u043E\u0440\u0438\u044F\u0432\u044B\u0431\u043E\u0440\u0430\u043F\u0440\u0438\u0432\u0432\u043E\u0434\u0435 \u0438\u0441\u0442\u043E\u0447\u043D\u0438\u043A\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0439\u043E\u0441\u0438\u0442\u043E\u0447\u0435\u043A\u0434\u0438\u0430\u0433\u0440\u0430\u043C\u043C\u044B \u0438\u0441\u0442\u043E\u0447\u043D\u0438\u043A\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u044F\u0440\u0430\u0437\u043C\u0435\u0440\u0430\u043F\u0443\u0437\u044B\u0440\u044C\u043A\u0430\u0434\u0438\u0430\u0433\u0440\u0430\u043C\u043C\u044B \u043A\u0430\u0442\u0435\u0433\u043E\u0440\u0438\u044F\u0433\u0440\u0443\u043F\u043F\u044B\u043A\u043E\u043C\u0430\u043D\u0434 \u043C\u0430\u043A\u0441\u0438\u043C\u0443\u043C\u0441\u0435\u0440\u0438\u0439 \u043D\u0430\u0447\u0430\u043B\u044C\u043D\u043E\u0435\u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435\u0434\u0435\u0440\u0435\u0432\u0430 \u043D\u0430\u0447\u0430\u043B\u044C\u043D\u043E\u0435\u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435\u0441\u043F\u0438\u0441\u043A\u0430 \u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u0435\u0442\u0435\u043A\u0441\u0442\u0430\u0440\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F \u043E\u0440\u0438\u0435\u043D\u0442\u0430\u0446\u0438\u044F\u0434\u0435\u043D\u0434\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u044B \u043E\u0440\u0438\u0435\u043D\u0442\u0430\u0446\u0438\u044F\u0434\u0438\u0430\u0433\u0440\u0430\u043C\u043C\u044B \u043E\u0440\u0438\u0435\u043D\u0442\u0430\u0446\u0438\u044F\u043C\u0435\u0442\u043E\u043A\u0434\u0438\u0430\u0433\u0440\u0430\u043C\u043C\u044B \u043E\u0440\u0438\u0435\u043D\u0442\u0430\u0446\u0438\u044F\u043C\u0435\u0442\u043E\u043A\u0441\u0432\u043E\u0434\u043D\u043E\u0439\u0434\u0438\u0430\u0433\u0440\u0430\u043C\u043C\u044B \u043E\u0440\u0438\u0435\u043D\u0442\u0430\u0446\u0438\u044F\u044D\u043B\u0435\u043C\u0435\u043D\u0442\u0430\u0444\u043E\u0440\u043C\u044B \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435\u0432\u0434\u0438\u0430\u0433\u0440\u0430\u043C\u043C\u0435 \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435\u0432\u043B\u0435\u0433\u0435\u043D\u0434\u0435\u0434\u0438\u0430\u0433\u0440\u0430\u043C\u043C\u044B \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435\u0433\u0440\u0443\u043F\u043F\u044B\u043A\u043D\u043E\u043F\u043E\u043A \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435\u0437\u0430\u0433\u043E\u043B\u043E\u0432\u043A\u0430\u0448\u043A\u0430\u043B\u044B\u0434\u0438\u0430\u0433\u0440\u0430\u043C\u043C\u044B \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0439\u0441\u0432\u043E\u0434\u043D\u043E\u0439\u0434\u0438\u0430\u0433\u0440\u0430\u043C\u043C\u044B \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u044F\u0438\u0437\u043C\u0435\u0440\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0439\u0434\u0438\u0430\u0433\u0440\u0430\u043C\u043C\u044B \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435\u0438\u043D\u0442\u0435\u0440\u0432\u0430\u043B\u0430\u0434\u0438\u0430\u0433\u0440\u0430\u043C\u043C\u044B\u0433\u0430\u043D\u0442\u0430 \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435\u043A\u043D\u043E\u043F\u043A\u0438 \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435\u043A\u043D\u043E\u043F\u043A\u0438\u0432\u044B\u0431\u043E\u0440\u0430 \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435\u043E\u0431\u0441\u0443\u0436\u0434\u0435\u043D\u0438\u0439\u0444\u043E\u0440\u043C\u044B \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435\u043E\u0431\u044B\u0447\u043D\u043E\u0439\u0433\u0440\u0443\u043F\u043F\u044B \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435\u043E\u0442\u0440\u0438\u0446\u0430\u0442\u0435\u043B\u044C\u043D\u044B\u0445\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0439\u043F\u0443\u0437\u044B\u0440\u044C\u043A\u043E\u0432\u043E\u0439\u0434\u0438\u0430\u0433\u0440\u0430\u043C\u043C\u044B \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435\u043F\u0430\u043D\u0435\u043B\u0438\u043F\u043E\u0438\u0441\u043A\u0430 \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435\u043F\u043E\u0434\u0441\u043A\u0430\u0437\u043A\u0438 \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435\u043F\u0440\u0435\u0434\u0443\u043F\u0440\u0435\u0436\u0434\u0435\u043D\u0438\u044F\u043F\u0440\u0438\u0440\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0438 \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435\u0440\u0430\u0437\u043C\u0435\u0442\u043A\u0438\u043F\u043E\u043B\u043E\u0441\u044B\u0440\u0435\u0433\u0443\u043B\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435\u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0444\u043E\u0440\u043C\u044B \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435\u0442\u0430\u0431\u043B\u0438\u0446\u044B \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435\u0442\u0435\u043A\u0441\u0442\u0430\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u044F\u0434\u0438\u0430\u0433\u0440\u0430\u043C\u043C\u044B\u0433\u0430\u043D\u0442\u0430 \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435\u0443\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u044F\u043E\u0431\u044B\u0447\u043D\u043E\u0439\u0433\u0440\u0443\u043F\u043F\u044B \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435\u0444\u0438\u0433\u0443\u0440\u044B\u043A\u043D\u043E\u043F\u043A\u0438 \u043F\u0430\u043B\u0438\u0442\u0440\u0430\u0446\u0432\u0435\u0442\u043E\u0432\u0434\u0438\u0430\u0433\u0440\u0430\u043C\u043C\u044B \u043F\u043E\u0432\u0435\u0434\u0435\u043D\u0438\u0435\u043E\u0431\u044B\u0447\u043D\u043E\u0439\u0433\u0440\u0443\u043F\u043F\u044B \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0430\u043C\u0430\u0441\u0448\u0442\u0430\u0431\u0430\u0434\u0435\u043D\u0434\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u044B \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0430\u043C\u0430\u0441\u0448\u0442\u0430\u0431\u0430\u0434\u0438\u0430\u0433\u0440\u0430\u043C\u043C\u044B\u0433\u0430\u043D\u0442\u0430 \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0430\u043C\u0430\u0441\u0448\u0442\u0430\u0431\u0430\u0441\u0432\u043E\u0434\u043D\u043E\u0439\u0434\u0438\u0430\u0433\u0440\u0430\u043C\u043C\u044B \u043F\u043E\u0438\u0441\u043A\u0432\u0442\u0430\u0431\u043B\u0438\u0446\u0435\u043F\u0440\u0438\u0432\u0432\u043E\u0434\u0435 \u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0435\u0437\u0430\u0433\u043E\u043B\u043E\u0432\u043A\u0430\u044D\u043B\u0435\u043C\u0435\u043D\u0442\u0430\u0444\u043E\u0440\u043C\u044B \u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0435\u043A\u0430\u0440\u0442\u0438\u043D\u043A\u0438\u043A\u043D\u043E\u043F\u043A\u0438\u0444\u043E\u0440\u043C\u044B \u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0435\u043A\u0430\u0440\u0442\u0438\u043D\u043A\u0438\u044D\u043B\u0435\u043C\u0435\u043D\u0442\u0430\u0433\u0440\u0430\u0444\u0438\u0447\u0435\u0441\u043A\u043E\u0439\u0441\u0445\u0435\u043C\u044B \u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0435\u043A\u043E\u043C\u0430\u043D\u0434\u043D\u043E\u0439\u043F\u0430\u043D\u0435\u043B\u0438\u0444\u043E\u0440\u043C\u044B \u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0435\u043A\u043E\u043C\u0430\u043D\u0434\u043D\u043E\u0439\u043F\u0430\u043D\u0435\u043B\u0438\u044D\u043B\u0435\u043C\u0435\u043D\u0442\u0430\u0444\u043E\u0440\u043C\u044B \u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0435\u043E\u043F\u043E\u0440\u043D\u043E\u0439\u0442\u043E\u0447\u043A\u0438\u043E\u0442\u0440\u0438\u0441\u043E\u0432\u043A\u0438 \u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0435\u043F\u043E\u0434\u043F\u0438\u0441\u0435\u0439\u043A\u0434\u0438\u0430\u0433\u0440\u0430\u043C\u043C\u0435 \u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0435\u043F\u043E\u0434\u043F\u0438\u0441\u0435\u0439\u0448\u043A\u0430\u043B\u044B\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0439\u0438\u0437\u043C\u0435\u0440\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0439\u0434\u0438\u0430\u0433\u0440\u0430\u043C\u043C\u044B \u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0435\u0441\u043E\u0441\u0442\u043E\u044F\u043D\u0438\u044F\u043F\u0440\u043E\u0441\u043C\u043E\u0442\u0440\u0430 \u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0435\u0441\u0442\u0440\u043E\u043A\u0438\u043F\u043E\u0438\u0441\u043A\u0430 \u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0435\u0442\u0435\u043A\u0441\u0442\u0430\u0441\u043E\u0435\u0434\u0438\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0439\u043B\u0438\u043D\u0438\u0438 \u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0435\u0443\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u044F\u043F\u043E\u0438\u0441\u043A\u043E\u043C \u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0435\u0448\u043A\u0430\u043B\u044B\u0432\u0440\u0435\u043C\u0435\u043D\u0438 \u043F\u043E\u0440\u044F\u0434\u043E\u043A\u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u044F\u0442\u043E\u0447\u0435\u043A\u0433\u043E\u0440\u0438\u0437\u043E\u043D\u0442\u0430\u043B\u044C\u043D\u043E\u0439\u0433\u0438\u0441\u0442\u043E\u0433\u0440\u0430\u043C\u043C\u044B \u043F\u043E\u0440\u044F\u0434\u043E\u043A\u0441\u0435\u0440\u0438\u0439\u0432\u043B\u0435\u0433\u0435\u043D\u0434\u0435\u0434\u0438\u0430\u0433\u0440\u0430\u043C\u043C\u044B \u0440\u0430\u0437\u043C\u0435\u0440\u043A\u0430\u0440\u0442\u0438\u043D\u043A\u0438 \u0440\u0430\u0441\u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0435\u0437\u0430\u0433\u043E\u043B\u043E\u0432\u043A\u0430\u0448\u043A\u0430\u043B\u044B\u0434\u0438\u0430\u0433\u0440\u0430\u043C\u043C\u044B \u0440\u0430\u0441\u0442\u044F\u0433\u0438\u0432\u0430\u043D\u0438\u0435\u043F\u043E\u0432\u0435\u0440\u0442\u0438\u043A\u0430\u043B\u0438\u0434\u0438\u0430\u0433\u0440\u0430\u043C\u043C\u044B\u0433\u0430\u043D\u0442\u0430 \u0440\u0435\u0436\u0438\u043C\u0430\u0432\u0442\u043E\u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u044F\u0441\u043E\u0441\u0442\u043E\u044F\u043D\u0438\u044F \u0440\u0435\u0436\u0438\u043C\u0432\u0432\u043E\u0434\u0430\u0441\u0442\u0440\u043E\u043A\u0442\u0430\u0431\u043B\u0438\u0446\u044B \u0440\u0435\u0436\u0438\u043C\u0432\u044B\u0431\u043E\u0440\u0430\u043D\u0435\u0437\u0430\u043F\u043E\u043B\u043D\u0435\u043D\u043D\u043E\u0433\u043E \u0440\u0435\u0436\u0438\u043C\u0432\u044B\u0434\u0435\u043B\u0435\u043D\u0438\u044F\u0434\u0430\u0442\u044B \u0440\u0435\u0436\u0438\u043C\u0432\u044B\u0434\u0435\u043B\u0435\u043D\u0438\u044F\u0441\u0442\u0440\u043E\u043A\u0438\u0442\u0430\u0431\u043B\u0438\u0446\u044B \u0440\u0435\u0436\u0438\u043C\u0432\u044B\u0434\u0435\u043B\u0435\u043D\u0438\u044F\u0442\u0430\u0431\u043B\u0438\u0446\u044B \u0440\u0435\u0436\u0438\u043C\u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u044F\u0440\u0430\u0437\u043C\u0435\u0440\u0430 \u0440\u0435\u0436\u0438\u043C\u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u044F\u0441\u0432\u044F\u0437\u0430\u043D\u043D\u043E\u0433\u043E\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u044F \u0440\u0435\u0436\u0438\u043C\u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F\u0434\u0438\u0430\u043B\u043E\u0433\u0430\u043F\u0435\u0447\u0430\u0442\u0438 \u0440\u0435\u0436\u0438\u043C\u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F\u043F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u0430\u043A\u043E\u043C\u0430\u043D\u0434\u044B \u0440\u0435\u0436\u0438\u043C\u043C\u0430\u0441\u0448\u0442\u0430\u0431\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F\u043F\u0440\u043E\u0441\u043C\u043E\u0442\u0440\u0430 \u0440\u0435\u0436\u0438\u043C\u043E\u0441\u043D\u043E\u0432\u043D\u043E\u0433\u043E\u043E\u043A\u043D\u0430\u043A\u043B\u0438\u0435\u043D\u0442\u0441\u043A\u043E\u0433\u043E\u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u044F \u0440\u0435\u0436\u0438\u043C\u043E\u0442\u043A\u0440\u044B\u0442\u0438\u044F\u043E\u043A\u043D\u0430\u0444\u043E\u0440\u043C\u044B \u0440\u0435\u0436\u0438\u043C\u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u044F\u0432\u044B\u0434\u0435\u043B\u0435\u043D\u0438\u044F \u0440\u0435\u0436\u0438\u043C\u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u044F\u0433\u0435\u043E\u0433\u0440\u0430\u0444\u0438\u0447\u0435\u0441\u043A\u043E\u0439\u0441\u0445\u0435\u043C\u044B \u0440\u0435\u0436\u0438\u043C\u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u044F\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0439\u0441\u0435\u0440\u0438\u0438 \u0440\u0435\u0436\u0438\u043C\u043E\u0442\u0440\u0438\u0441\u043E\u0432\u043A\u0438\u0441\u0435\u0442\u043A\u0438\u0433\u0440\u0430\u0444\u0438\u0447\u0435\u0441\u043A\u043E\u0439\u0441\u0445\u0435\u043C\u044B \u0440\u0435\u0436\u0438\u043C\u043F\u043E\u043B\u0443\u043F\u0440\u043E\u0437\u0440\u0430\u0447\u043D\u043E\u0441\u0442\u0438\u0434\u0438\u0430\u0433\u0440\u0430\u043C\u043C\u044B \u0440\u0435\u0436\u0438\u043C\u043F\u0440\u043E\u0431\u0435\u043B\u043E\u0432\u0434\u0438\u0430\u0433\u0440\u0430\u043C\u043C\u044B \u0440\u0435\u0436\u0438\u043C\u0440\u0430\u0437\u043C\u0435\u0449\u0435\u043D\u0438\u044F\u043D\u0430\u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0435 \u0440\u0435\u0436\u0438\u043C\u0440\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F\u043A\u043E\u043B\u043E\u043D\u043A\u0438 \u0440\u0435\u0436\u0438\u043C\u0441\u0433\u043B\u0430\u0436\u0438\u0432\u0430\u043D\u0438\u044F\u0434\u0438\u0430\u0433\u0440\u0430\u043C\u043C\u044B \u0440\u0435\u0436\u0438\u043C\u0441\u0433\u043B\u0430\u0436\u0438\u0432\u0430\u043D\u0438\u044F\u0438\u043D\u0434\u0438\u043A\u0430\u0442\u043E\u0440\u0430 \u0440\u0435\u0436\u0438\u043C\u0441\u043F\u0438\u0441\u043A\u0430\u0437\u0430\u0434\u0430\u0447 \u0441\u043A\u0432\u043E\u0437\u043D\u043E\u0435\u0432\u044B\u0440\u0430\u0432\u043D\u0438\u0432\u0430\u043D\u0438\u0435 \u0441\u043E\u0445\u0440\u0430\u043D\u0435\u043D\u0438\u0435\u0434\u0430\u043D\u043D\u044B\u0445\u0444\u043E\u0440\u043C\u044B\u0432\u043D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0430\u0445 \u0441\u043F\u043E\u0441\u043E\u0431\u0437\u0430\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u044F\u0442\u0435\u043A\u0441\u0442\u0430\u0437\u0430\u0433\u043E\u043B\u043E\u0432\u043A\u0430\u0448\u043A\u0430\u043B\u044B\u0434\u0438\u0430\u0433\u0440\u0430\u043C\u043C\u044B \u0441\u043F\u043E\u0441\u043E\u0431\u043E\u043F\u0440\u0435\u0434\u0435\u043B\u0435\u043D\u0438\u044F\u043E\u0433\u0440\u0430\u043D\u0438\u0447\u0438\u0432\u0430\u044E\u0449\u0435\u0433\u043E\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u044F\u0434\u0438\u0430\u0433\u0440\u0430\u043C\u043C\u044B \u0441\u0442\u0430\u043D\u0434\u0430\u0440\u0442\u043D\u0430\u044F\u0433\u0440\u0443\u043F\u043F\u0430\u043A\u043E\u043C\u0430\u043D\u0434 \u0441\u0442\u0430\u043D\u0434\u0430\u0440\u0442\u043D\u043E\u0435\u043E\u0444\u043E\u0440\u043C\u043B\u0435\u043D\u0438\u0435 \u0441\u0442\u0430\u0442\u0443\u0441\u043E\u043F\u043E\u0432\u0435\u0449\u0435\u043D\u0438\u044F\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F \u0441\u0442\u0438\u043B\u044C\u0441\u0442\u0440\u0435\u043B\u043A\u0438 \u0442\u0438\u043F\u0430\u043F\u043F\u0440\u043E\u043A\u0441\u0438\u043C\u0430\u0446\u0438\u0438\u043B\u0438\u043D\u0438\u0438\u0442\u0440\u0435\u043D\u0434\u0430\u0434\u0438\u0430\u0433\u0440\u0430\u043C\u043C\u044B \u0442\u0438\u043F\u0434\u0438\u0430\u0433\u0440\u0430\u043C\u043C\u044B \u0442\u0438\u043F\u0435\u0434\u0438\u043D\u0438\u0446\u044B\u0448\u043A\u0430\u043B\u044B\u0432\u0440\u0435\u043C\u0435\u043D\u0438 \u0442\u0438\u043F\u0438\u043C\u043F\u043E\u0440\u0442\u0430\u0441\u0435\u0440\u0438\u0439\u0441\u043B\u043E\u044F\u0433\u0435\u043E\u0433\u0440\u0430\u0444\u0438\u0447\u0435\u0441\u043A\u043E\u0439\u0441\u0445\u0435\u043C\u044B \u0442\u0438\u043F\u043B\u0438\u043D\u0438\u0438\u0433\u0435\u043E\u0433\u0440\u0430\u0444\u0438\u0447\u0435\u0441\u043A\u043E\u0439\u0441\u0445\u0435\u043C\u044B \u0442\u0438\u043F\u043B\u0438\u043D\u0438\u0438\u0434\u0438\u0430\u0433\u0440\u0430\u043C\u043C\u044B \u0442\u0438\u043F\u043C\u0430\u0440\u043A\u0435\u0440\u0430\u0433\u0435\u043E\u0433\u0440\u0430\u0444\u0438\u0447\u0435\u0441\u043A\u043E\u0439\u0441\u0445\u0435\u043C\u044B \u0442\u0438\u043F\u043C\u0430\u0440\u043A\u0435\u0440\u0430\u0434\u0438\u0430\u0433\u0440\u0430\u043C\u043C\u044B \u0442\u0438\u043F\u043E\u0431\u043B\u0430\u0441\u0442\u0438\u043E\u0444\u043E\u0440\u043C\u043B\u0435\u043D\u0438\u044F \u0442\u0438\u043F\u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u0438\u0438\u0441\u0442\u043E\u0447\u043D\u0438\u043A\u0430\u0434\u0430\u043D\u043D\u044B\u0445\u0433\u0435\u043E\u0433\u0440\u0430\u0444\u0438\u0447\u0435\u0441\u043A\u043E\u0439\u0441\u0445\u0435\u043C\u044B \u0442\u0438\u043F\u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u044F\u0441\u0435\u0440\u0438\u0438\u0441\u043B\u043E\u044F\u0433\u0435\u043E\u0433\u0440\u0430\u0444\u0438\u0447\u0435\u0441\u043A\u043E\u0439\u0441\u0445\u0435\u043C\u044B \u0442\u0438\u043F\u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u044F\u0442\u043E\u0447\u0435\u0447\u043D\u043E\u0433\u043E\u043E\u0431\u044A\u0435\u043A\u0442\u0430\u0433\u0435\u043E\u0433\u0440\u0430\u0444\u0438\u0447\u0435\u0441\u043A\u043E\u0439\u0441\u0445\u0435\u043C\u044B \u0442\u0438\u043F\u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u044F\u0448\u043A\u0430\u043B\u044B\u044D\u043B\u0435\u043C\u0435\u043D\u0442\u0430\u043B\u0435\u0433\u0435\u043D\u0434\u044B\u0433\u0435\u043E\u0433\u0440\u0430\u0444\u0438\u0447\u0435\u0441\u043A\u043E\u0439\u0441\u0445\u0435\u043C\u044B \u0442\u0438\u043F\u043F\u043E\u0438\u0441\u043A\u0430\u043E\u0431\u044A\u0435\u043A\u0442\u043E\u0432\u0433\u0435\u043E\u0433\u0440\u0430\u0444\u0438\u0447\u0435\u0441\u043A\u043E\u0439\u0441\u0445\u0435\u043C\u044B \u0442\u0438\u043F\u043F\u0440\u043E\u0435\u043A\u0446\u0438\u0438\u0433\u0435\u043E\u0433\u0440\u0430\u0444\u0438\u0447\u0435\u0441\u043A\u043E\u0439\u0441\u0445\u0435\u043C\u044B \u0442\u0438\u043F\u0440\u0430\u0437\u043C\u0435\u0449\u0435\u043D\u0438\u044F\u0438\u0437\u043C\u0435\u0440\u0435\u043D\u0438\u0439 \u0442\u0438\u043F\u0440\u0430\u0437\u043C\u0435\u0449\u0435\u043D\u0438\u044F\u0440\u0435\u043A\u0432\u0438\u0437\u0438\u0442\u043E\u0432\u0438\u0437\u043C\u0435\u0440\u0435\u043D\u0438\u0439 \u0442\u0438\u043F\u0440\u0430\u043C\u043A\u0438\u044D\u043B\u0435\u043C\u0435\u043D\u0442\u0430\u0443\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u044F \u0442\u0438\u043F\u0441\u0432\u043E\u0434\u043D\u043E\u0439\u0434\u0438\u0430\u0433\u0440\u0430\u043C\u043C\u044B \u0442\u0438\u043F\u0441\u0432\u044F\u0437\u0438\u0434\u0438\u0430\u0433\u0440\u0430\u043C\u043C\u044B\u0433\u0430\u043D\u0442\u0430 \u0442\u0438\u043F\u0441\u043E\u0435\u0434\u0438\u043D\u0435\u043D\u0438\u044F\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0439\u043F\u043E\u0441\u0435\u0440\u0438\u044F\u043C\u0434\u0438\u0430\u0433\u0440\u0430\u043C\u043C\u044B \u0442\u0438\u043F\u0441\u043E\u0435\u0434\u0438\u043D\u0435\u043D\u0438\u044F\u0442\u043E\u0447\u0435\u043A\u0434\u0438\u0430\u0433\u0440\u0430\u043C\u043C\u044B \u0442\u0438\u043F\u0441\u043E\u0435\u0434\u0438\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0439\u043B\u0438\u043D\u0438\u0438 \u0442\u0438\u043F\u0441\u0442\u043E\u0440\u043E\u043D\u044B\u044D\u043B\u0435\u043C\u0435\u043D\u0442\u0430\u0433\u0440\u0430\u0444\u0438\u0447\u0435\u0441\u043A\u043E\u0439\u0441\u0445\u0435\u043C\u044B \u0442\u0438\u043F\u0444\u043E\u0440\u043C\u044B\u043E\u0442\u0447\u0435\u0442\u0430 \u0442\u0438\u043F\u0448\u043A\u0430\u043B\u044B\u0440\u0430\u0434\u0430\u0440\u043D\u043E\u0439\u0434\u0438\u0430\u0433\u0440\u0430\u043C\u043C\u044B \u0444\u0430\u043A\u0442\u043E\u0440\u043B\u0438\u043D\u0438\u0438\u0442\u0440\u0435\u043D\u0434\u0430\u0434\u0438\u0430\u0433\u0440\u0430\u043C\u043C\u044B \u0444\u0438\u0433\u0443\u0440\u0430\u043A\u043D\u043E\u043F\u043A\u0438 \u0444\u0438\u0433\u0443\u0440\u044B\u0433\u0440\u0430\u0444\u0438\u0447\u0435\u0441\u043A\u043E\u0439\u0441\u0445\u0435\u043C\u044B \u0444\u0438\u043A\u0441\u0430\u0446\u0438\u044F\u0432\u0442\u0430\u0431\u043B\u0438\u0446\u0435 \u0444\u043E\u0440\u043C\u0430\u0442\u0434\u043D\u044F\u0448\u043A\u0430\u043B\u044B\u0432\u0440\u0435\u043C\u0435\u043D\u0438 \u0444\u043E\u0440\u043C\u0430\u0442\u043A\u0430\u0440\u0442\u0438\u043D\u043A\u0438 \u0448\u0438\u0440\u0438\u043D\u0430\u043F\u043E\u0434\u0447\u0438\u043D\u0435\u043D\u043D\u044B\u0445\u044D\u043B\u0435\u043C\u0435\u043D\u0442\u043E\u0432\u0444\u043E\u0440\u043C\u044B ";
    // v8 системные перечисления - свойства прикладных объектов ==> class
    var v8_system_enums_objects_properties = "\u0432\u0438\u0434\u0434\u0432\u0438\u0436\u0435\u043D\u0438\u044F\u0431\u0443\u0445\u0433\u0430\u043B\u0442\u0435\u0440\u0438\u0438 \u0432\u0438\u0434\u0434\u0432\u0438\u0436\u0435\u043D\u0438\u044F\u043D\u0430\u043A\u043E\u043F\u043B\u0435\u043D\u0438\u044F \u0432\u0438\u0434\u043F\u0435\u0440\u0438\u043E\u0434\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0440\u0430\u0441\u0447\u0435\u0442\u0430 \u0432\u0438\u0434\u0441\u0447\u0435\u0442\u0430 \u0432\u0438\u0434\u0442\u043E\u0447\u043A\u0438\u043C\u0430\u0440\u0448\u0440\u0443\u0442\u0430\u0431\u0438\u0437\u043D\u0435\u0441\u043F\u0440\u043E\u0446\u0435\u0441\u0441\u0430 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435\u0430\u0433\u0440\u0435\u0433\u0430\u0442\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u043D\u0430\u043A\u043E\u043F\u043B\u0435\u043D\u0438\u044F \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435\u0433\u0440\u0443\u043F\u043F\u0438\u044D\u043B\u0435\u043C\u0435\u043D\u0442\u043E\u0432 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435\u0440\u0435\u0436\u0438\u043C\u0430\u043F\u0440\u043E\u0432\u0435\u0434\u0435\u043D\u0438\u044F \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435\u0441\u0440\u0435\u0437\u0430 \u043F\u0435\u0440\u0438\u043E\u0434\u0438\u0447\u043D\u043E\u0441\u0442\u044C\u0430\u0433\u0440\u0435\u0433\u0430\u0442\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u043D\u0430\u043A\u043E\u043F\u043B\u0435\u043D\u0438\u044F \u0440\u0435\u0436\u0438\u043C\u0430\u0432\u0442\u043E\u0432\u0440\u0435\u043C\u044F \u0440\u0435\u0436\u0438\u043C\u0437\u0430\u043F\u0438\u0441\u0438\u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430 \u0440\u0435\u0436\u0438\u043C\u043F\u0440\u043E\u0432\u0435\u0434\u0435\u043D\u0438\u044F\u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430 ";
    // v8 системные перечисления - планы обмена ==> class
    var v8_system_enums_exchange_plans = "\u0430\u0432\u0442\u043E\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u044F\u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u0439 \u0434\u043E\u043F\u0443\u0441\u0442\u0438\u043C\u044B\u0439\u043D\u043E\u043C\u0435\u0440\u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u044F \u043E\u0442\u043F\u0440\u0430\u0432\u043A\u0430\u044D\u043B\u0435\u043C\u0435\u043D\u0442\u0430\u0434\u0430\u043D\u043D\u044B\u0445 \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u0438\u0435\u044D\u043B\u0435\u043C\u0435\u043D\u0442\u0430\u0434\u0430\u043D\u043D\u044B\u0445 ";
    // v8 системные перечисления - табличный документ ==> class
    var v8_system_enums_tabular_document = "\u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435\u0440\u0430\u0441\u0448\u0438\u0444\u0440\u043E\u0432\u043A\u0438\u0442\u0430\u0431\u043B\u0438\u0447\u043D\u043E\u0433\u043E\u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430 \u043E\u0440\u0438\u0435\u043D\u0442\u0430\u0446\u0438\u044F\u0441\u0442\u0440\u0430\u043D\u0438\u0446\u044B \u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0435\u0438\u0442\u043E\u0433\u043E\u0432\u043A\u043E\u043B\u043E\u043D\u043E\u043A\u0441\u0432\u043E\u0434\u043D\u043E\u0439\u0442\u0430\u0431\u043B\u0438\u0446\u044B \u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0435\u0438\u0442\u043E\u0433\u043E\u0432\u0441\u0442\u0440\u043E\u043A\u0441\u0432\u043E\u0434\u043D\u043E\u0439\u0442\u0430\u0431\u043B\u0438\u0446\u044B \u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0435\u0442\u0435\u043A\u0441\u0442\u0430\u043E\u0442\u043D\u043E\u0441\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u043A\u0430\u0440\u0442\u0438\u043D\u043A\u0438 \u0440\u0430\u0441\u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0435\u0437\u0430\u0433\u043E\u043B\u043E\u0432\u043A\u0430\u0433\u0440\u0443\u043F\u043F\u0438\u0440\u043E\u0432\u043A\u0438\u0442\u0430\u0431\u043B\u0438\u0447\u043D\u043E\u0433\u043E\u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430 \u0441\u043F\u043E\u0441\u043E\u0431\u0447\u0442\u0435\u043D\u0438\u044F\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0439\u0442\u0430\u0431\u043B\u0438\u0447\u043D\u043E\u0433\u043E\u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430 \u0442\u0438\u043F\u0434\u0432\u0443\u0441\u0442\u043E\u0440\u043E\u043D\u043D\u0435\u0439\u043F\u0435\u0447\u0430\u0442\u0438 \u0442\u0438\u043F\u0437\u0430\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u044F\u043E\u0431\u043B\u0430\u0441\u0442\u0438\u0442\u0430\u0431\u043B\u0438\u0447\u043D\u043E\u0433\u043E\u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430 \u0442\u0438\u043F\u043A\u0443\u0440\u0441\u043E\u0440\u043E\u0432\u0442\u0430\u0431\u043B\u0438\u0447\u043D\u043E\u0433\u043E\u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430 \u0442\u0438\u043F\u043B\u0438\u043D\u0438\u0438\u0440\u0438\u0441\u0443\u043D\u043A\u0430\u0442\u0430\u0431\u043B\u0438\u0447\u043D\u043E\u0433\u043E\u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430 \u0442\u0438\u043F\u043B\u0438\u043D\u0438\u0438\u044F\u0447\u0435\u0439\u043A\u0438\u0442\u0430\u0431\u043B\u0438\u0447\u043D\u043E\u0433\u043E\u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430 \u0442\u0438\u043F\u043D\u0430\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u044F\u043F\u0435\u0440\u0435\u0445\u043E\u0434\u0430\u0442\u0430\u0431\u043B\u0438\u0447\u043D\u043E\u0433\u043E\u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430 \u0442\u0438\u043F\u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u044F\u0432\u044B\u0434\u0435\u043B\u0435\u043D\u0438\u044F\u0442\u0430\u0431\u043B\u0438\u0447\u043D\u043E\u0433\u043E\u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430 \u0442\u0438\u043F\u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u044F\u043B\u0438\u043D\u0438\u0439\u0441\u0432\u043E\u0434\u043D\u043E\u0439\u0442\u0430\u0431\u043B\u0438\u0446\u044B \u0442\u0438\u043F\u0440\u0430\u0437\u043C\u0435\u0449\u0435\u043D\u0438\u044F\u0442\u0435\u043A\u0441\u0442\u0430\u0442\u0430\u0431\u043B\u0438\u0447\u043D\u043E\u0433\u043E\u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430 \u0442\u0438\u043F\u0440\u0438\u0441\u0443\u043D\u043A\u0430\u0442\u0430\u0431\u043B\u0438\u0447\u043D\u043E\u0433\u043E\u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430 \u0442\u0438\u043F\u0441\u043C\u0435\u0449\u0435\u043D\u0438\u044F\u0442\u0430\u0431\u043B\u0438\u0447\u043D\u043E\u0433\u043E\u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430 \u0442\u0438\u043F\u0443\u0437\u043E\u0440\u0430\u0442\u0430\u0431\u043B\u0438\u0447\u043D\u043E\u0433\u043E\u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430 \u0442\u0438\u043F\u0444\u0430\u0439\u043B\u0430\u0442\u0430\u0431\u043B\u0438\u0447\u043D\u043E\u0433\u043E\u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430 \u0442\u043E\u0447\u043D\u043E\u0441\u0442\u044C\u043F\u0435\u0447\u0430\u0442\u0438 \u0447\u0435\u0440\u0435\u0434\u043E\u0432\u0430\u043D\u0438\u0435\u0440\u0430\u0441\u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u044F\u0441\u0442\u0440\u0430\u043D\u0438\u0446 ";
    // v8 системные перечисления - планировщик ==> class
    var v8_system_enums_sheduler = "\u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435\u0432\u0440\u0435\u043C\u0435\u043D\u0438\u044D\u043B\u0435\u043C\u0435\u043D\u0442\u043E\u0432\u043F\u043B\u0430\u043D\u0438\u0440\u043E\u0432\u0449\u0438\u043A\u0430 ";
    // v8 системные перечисления - форматированный документ ==> class
    var v8_system_enums_formatted_document = "\u0442\u0438\u043F\u0444\u0430\u0439\u043B\u0430\u0444\u043E\u0440\u043C\u0430\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u043E\u0433\u043E\u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430 ";
    // v8 системные перечисления - запрос ==> class
    var v8_system_enums_query = "\u043E\u0431\u0445\u043E\u0434\u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u0430\u0437\u0430\u043F\u0440\u043E\u0441\u0430 \u0442\u0438\u043F\u0437\u0430\u043F\u0438\u0441\u0438\u0437\u0430\u043F\u0440\u043E\u0441\u0430 ";
    // v8 системные перечисления - построитель отчета ==> class
    var v8_system_enums_report_builder = "\u0432\u0438\u0434\u0437\u0430\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u044F\u0440\u0430\u0441\u0448\u0438\u0444\u0440\u043E\u0432\u043A\u0438\u043F\u043E\u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044F\u043E\u0442\u0447\u0435\u0442\u0430 \u0442\u0438\u043F\u0434\u043E\u0431\u0430\u0432\u043B\u0435\u043D\u0438\u044F\u043F\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0438\u0439 \u0442\u0438\u043F\u0438\u0437\u043C\u0435\u0440\u0435\u043D\u0438\u044F\u043F\u043E\u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044F\u043E\u0442\u0447\u0435\u0442\u0430 \u0442\u0438\u043F\u0440\u0430\u0437\u043C\u0435\u0449\u0435\u043D\u0438\u044F\u0438\u0442\u043E\u0433\u043E\u0432 ";
    // v8 системные перечисления - работа с файлами ==> class
    var v8_system_enums_files = "\u0434\u043E\u0441\u0442\u0443\u043F\u043A\u0444\u0430\u0439\u043B\u0443 \u0440\u0435\u0436\u0438\u043C\u0434\u0438\u0430\u043B\u043E\u0433\u0430\u0432\u044B\u0431\u043E\u0440\u0430\u0444\u0430\u0439\u043B\u0430 \u0440\u0435\u0436\u0438\u043C\u043E\u0442\u043A\u0440\u044B\u0442\u0438\u044F\u0444\u0430\u0439\u043B\u0430 ";
    // v8 системные перечисления - построитель запроса ==> class
    var v8_system_enums_query_builder = "\u0442\u0438\u043F\u0438\u0437\u043C\u0435\u0440\u0435\u043D\u0438\u044F\u043F\u043E\u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044F\u0437\u0430\u043F\u0440\u043E\u0441\u0430 ";
    // v8 системные перечисления - анализ данных ==> class
    var v8_system_enums_data_analysis = "\u0432\u0438\u0434\u0434\u0430\u043D\u043D\u044B\u0445\u0430\u043D\u0430\u043B\u0438\u0437\u0430 \u043C\u0435\u0442\u043E\u0434\u043A\u043B\u0430\u0441\u0442\u0435\u0440\u0438\u0437\u0430\u0446\u0438\u0438 \u0442\u0438\u043F\u0435\u0434\u0438\u043D\u0438\u0446\u044B\u0438\u043D\u0442\u0435\u0440\u0432\u0430\u043B\u0430\u0432\u0440\u0435\u043C\u0435\u043D\u0438\u0430\u043D\u0430\u043B\u0438\u0437\u0430\u0434\u0430\u043D\u043D\u044B\u0445 \u0442\u0438\u043F\u0437\u0430\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u044F\u0442\u0430\u0431\u043B\u0438\u0446\u044B\u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u0430\u0430\u043D\u0430\u043B\u0438\u0437\u0430\u0434\u0430\u043D\u043D\u044B\u0445 \u0442\u0438\u043F\u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F\u0447\u0438\u0441\u043B\u043E\u0432\u044B\u0445\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0439\u0430\u043D\u0430\u043B\u0438\u0437\u0430\u0434\u0430\u043D\u043D\u044B\u0445 \u0442\u0438\u043F\u0438\u0441\u0442\u043E\u0447\u043D\u0438\u043A\u0430\u0434\u0430\u043D\u043D\u044B\u0445\u043F\u043E\u0438\u0441\u043A\u0430\u0430\u0441\u0441\u043E\u0446\u0438\u0430\u0446\u0438\u0439 \u0442\u0438\u043F\u043A\u043E\u043B\u043E\u043D\u043A\u0438\u0430\u043D\u0430\u043B\u0438\u0437\u0430\u0434\u0430\u043D\u043D\u044B\u0445\u0434\u0435\u0440\u0435\u0432\u043E\u0440\u0435\u0448\u0435\u043D\u0438\u0439 \u0442\u0438\u043F\u043A\u043E\u043B\u043E\u043D\u043A\u0438\u0430\u043D\u0430\u043B\u0438\u0437\u0430\u0434\u0430\u043D\u043D\u044B\u0445\u043A\u043B\u0430\u0441\u0442\u0435\u0440\u0438\u0437\u0430\u0446\u0438\u044F \u0442\u0438\u043F\u043A\u043E\u043B\u043E\u043D\u043A\u0438\u0430\u043D\u0430\u043B\u0438\u0437\u0430\u0434\u0430\u043D\u043D\u044B\u0445\u043E\u0431\u0449\u0430\u044F\u0441\u0442\u0430\u0442\u0438\u0441\u0442\u0438\u043A\u0430 \u0442\u0438\u043F\u043A\u043E\u043B\u043E\u043D\u043A\u0438\u0430\u043D\u0430\u043B\u0438\u0437\u0430\u0434\u0430\u043D\u043D\u044B\u0445\u043F\u043E\u0438\u0441\u043A\u0430\u0441\u0441\u043E\u0446\u0438\u0430\u0446\u0438\u0439 \u0442\u0438\u043F\u043A\u043E\u043B\u043E\u043D\u043A\u0438\u0430\u043D\u0430\u043B\u0438\u0437\u0430\u0434\u0430\u043D\u043D\u044B\u0445\u043F\u043E\u0438\u0441\u043A\u043F\u043E\u0441\u043B\u0435\u0434\u043E\u0432\u0430\u0442\u0435\u043B\u044C\u043D\u043E\u0441\u0442\u0435\u0439 \u0442\u0438\u043F\u043A\u043E\u043B\u043E\u043D\u043A\u0438\u043C\u043E\u0434\u0435\u043B\u0438\u043F\u0440\u043E\u0433\u043D\u043E\u0437\u0430 \u0442\u0438\u043F\u043C\u0435\u0440\u044B\u0440\u0430\u0441\u0441\u0442\u043E\u044F\u043D\u0438\u044F\u0430\u043D\u0430\u043B\u0438\u0437\u0430\u0434\u0430\u043D\u043D\u044B\u0445 \u0442\u0438\u043F\u043E\u0442\u0441\u0435\u0447\u0435\u043D\u0438\u044F\u043F\u0440\u0430\u0432\u0438\u043B\u0430\u0441\u0441\u043E\u0446\u0438\u0430\u0446\u0438\u0438 \u0442\u0438\u043F\u043F\u043E\u043B\u044F\u0430\u043D\u0430\u043B\u0438\u0437\u0430\u0434\u0430\u043D\u043D\u044B\u0445 \u0442\u0438\u043F\u0441\u0442\u0430\u043D\u0434\u0430\u0440\u0442\u0438\u0437\u0430\u0446\u0438\u0438\u0430\u043D\u0430\u043B\u0438\u0437\u0430\u0434\u0430\u043D\u043D\u044B\u0445 \u0442\u0438\u043F\u0443\u043F\u043E\u0440\u044F\u0434\u043E\u0447\u0438\u0432\u0430\u043D\u0438\u044F\u043F\u0440\u0430\u0432\u0438\u043B\u0430\u0441\u0441\u043E\u0446\u0438\u0430\u0446\u0438\u0438\u0430\u043D\u0430\u043B\u0438\u0437\u0430\u0434\u0430\u043D\u043D\u044B\u0445 \u0442\u0438\u043F\u0443\u043F\u043E\u0440\u044F\u0434\u043E\u0447\u0438\u0432\u0430\u043D\u0438\u044F\u0448\u0430\u0431\u043B\u043E\u043D\u043E\u0432\u043F\u043E\u0441\u043B\u0435\u0434\u043E\u0432\u0430\u0442\u0435\u043B\u044C\u043D\u043E\u0441\u0442\u0435\u0439\u0430\u043D\u0430\u043B\u0438\u0437\u0430\u0434\u0430\u043D\u043D\u044B\u0445 \u0442\u0438\u043F\u0443\u043F\u0440\u043E\u0449\u0435\u043D\u0438\u044F\u0434\u0435\u0440\u0435\u0432\u0430\u0440\u0435\u0448\u0435\u043D\u0438\u0439 ";
    // v8 системные перечисления - xml, json, xs, dom, xdto, web-сервисы ==> class
    var v8_system_enums_xml_json_xs_dom_xdto_ws = "ws\u043D\u0430\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u0435\u043F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u0430 \u0432\u0430\u0440\u0438\u0430\u043D\u0442xpathxs \u0432\u0430\u0440\u0438\u0430\u043D\u0442\u0437\u0430\u043F\u0438\u0441\u0438\u0434\u0430\u0442\u044Bjson \u0432\u0430\u0440\u0438\u0430\u043D\u0442\u043F\u0440\u043E\u0441\u0442\u043E\u0433\u043E\u0442\u0438\u043F\u0430xs \u0432\u0438\u0434\u0433\u0440\u0443\u043F\u043F\u044B\u043C\u043E\u0434\u0435\u043B\u0438xs \u0432\u0438\u0434\u0444\u0430\u0441\u0435\u0442\u0430xdto \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0435\u043F\u043E\u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044Fdom \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u043D\u043E\u0441\u0442\u044C\u043F\u0440\u043E\u0441\u0442\u043E\u0433\u043E\u0442\u0438\u043F\u0430xs \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u043D\u043E\u0441\u0442\u044C\u0441\u043E\u0441\u0442\u0430\u0432\u043D\u043E\u0433\u043E\u0442\u0438\u043F\u0430xs \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u043D\u043E\u0441\u0442\u044C\u0441\u0445\u0435\u043C\u044Bxs \u0437\u0430\u043F\u0440\u0435\u0449\u0435\u043D\u043D\u044B\u0435\u043F\u043E\u0434\u0441\u0442\u0430\u043D\u043E\u0432\u043A\u0438xs \u0438\u0441\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u044F\u0433\u0440\u0443\u043F\u043F\u043F\u043E\u0434\u0441\u0442\u0430\u043D\u043E\u0432\u043A\u0438xs \u043A\u0430\u0442\u0435\u0433\u043E\u0440\u0438\u044F\u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F\u0430\u0442\u0440\u0438\u0431\u0443\u0442\u0430xs \u043A\u0430\u0442\u0435\u0433\u043E\u0440\u0438\u044F\u043E\u0433\u0440\u0430\u043D\u0438\u0447\u0435\u043D\u0438\u044F\u0438\u0434\u0435\u043D\u0442\u0438\u0447\u043D\u043E\u0441\u0442\u0438xs \u043A\u0430\u0442\u0435\u0433\u043E\u0440\u0438\u044F\u043E\u0433\u0440\u0430\u043D\u0438\u0447\u0435\u043D\u0438\u044F\u043F\u0440\u043E\u0441\u0442\u0440\u0430\u043D\u0441\u0442\u0432\u0438\u043C\u0435\u043Dxs \u043C\u0435\u0442\u043E\u0434\u043D\u0430\u0441\u043B\u0435\u0434\u043E\u0432\u0430\u043D\u0438\u044Fxs \u043C\u043E\u0434\u0435\u043B\u044C\u0441\u043E\u0434\u0435\u0440\u0436\u0438\u043C\u043E\u0433\u043Exs \u043D\u0430\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435\u0442\u0438\u043F\u0430xml \u043D\u0435\u0434\u043E\u043F\u0443\u0441\u0442\u0438\u043C\u044B\u0435\u043F\u043E\u0434\u0441\u0442\u0430\u043D\u043E\u0432\u043A\u0438xs \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0430\u043F\u0440\u043E\u0431\u0435\u043B\u044C\u043D\u044B\u0445\u0441\u0438\u043C\u0432\u043E\u043B\u043E\u0432xs \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0430\u0441\u043E\u0434\u0435\u0440\u0436\u0438\u043C\u043E\u0433\u043Exs \u043E\u0433\u0440\u0430\u043D\u0438\u0447\u0435\u043D\u0438\u0435\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u044Fxs \u043F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u044B\u043E\u0442\u0431\u043E\u0440\u0430\u0443\u0437\u043B\u043E\u0432dom \u043F\u0435\u0440\u0435\u043D\u043E\u0441\u0441\u0442\u0440\u043E\u043Ajson \u043F\u043E\u0437\u0438\u0446\u0438\u044F\u0432\u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0435dom \u043F\u0440\u043E\u0431\u0435\u043B\u044C\u043D\u044B\u0435\u0441\u0438\u043C\u0432\u043E\u043B\u044Bxml \u0442\u0438\u043F\u0430\u0442\u0440\u0438\u0431\u0443\u0442\u0430xml \u0442\u0438\u043F\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u044Fjson \u0442\u0438\u043F\u043A\u0430\u043D\u043E\u043D\u0438\u0447\u0435\u0441\u043A\u043E\u0433\u043Exml \u0442\u0438\u043F\u043A\u043E\u043C\u043F\u043E\u043D\u0435\u043D\u0442\u044Bxs \u0442\u0438\u043F\u043F\u0440\u043E\u0432\u0435\u0440\u043A\u0438xml \u0442\u0438\u043F\u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u0430domxpath \u0442\u0438\u043F\u0443\u0437\u043B\u0430dom \u0442\u0438\u043F\u0443\u0437\u043B\u0430xml \u0444\u043E\u0440\u043C\u0430xml \u0444\u043E\u0440\u043C\u0430\u043F\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0438\u044Fxs \u0444\u043E\u0440\u043C\u0430\u0442\u0434\u0430\u0442\u044Bjson \u044D\u043A\u0440\u0430\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435\u0441\u0438\u043C\u0432\u043E\u043B\u043E\u0432json ";
    // v8 системные перечисления - система компоновки данных ==> class
    var v8_system_enums_data_composition_system = "\u0432\u0438\u0434\u0441\u0440\u0430\u0432\u043D\u0435\u043D\u0438\u044F\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0435\u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0438\u0440\u0430\u0441\u0448\u0438\u0444\u0440\u043E\u0432\u043A\u0438\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u043D\u0430\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u0435\u0441\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u043A\u0438\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u0440\u0430\u0441\u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0435\u0432\u043B\u043E\u0436\u0435\u043D\u043D\u044B\u0445\u044D\u043B\u0435\u043C\u0435\u043D\u0442\u043E\u0432\u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u0430\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u0440\u0430\u0441\u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0435\u0438\u0442\u043E\u0433\u043E\u0432\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u0440\u0430\u0441\u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0435\u0433\u0440\u0443\u043F\u043F\u0438\u0440\u043E\u0432\u043A\u0438\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u0440\u0430\u0441\u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0435\u043F\u043E\u043B\u0435\u0439\u0433\u0440\u0443\u043F\u043F\u0438\u0440\u043E\u0432\u043A\u0438\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u0440\u0430\u0441\u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0435\u043F\u043E\u043B\u044F\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u0440\u0430\u0441\u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0435\u0440\u0435\u043A\u0432\u0438\u0437\u0438\u0442\u043E\u0432\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u0440\u0430\u0441\u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0435\u0440\u0435\u0441\u0443\u0440\u0441\u043E\u0432\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u0442\u0438\u043F\u0431\u0443\u0445\u0433\u0430\u043B\u0442\u0435\u0440\u0441\u043A\u043E\u0433\u043E\u043E\u0441\u0442\u0430\u0442\u043A\u0430\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u0442\u0438\u043F\u0432\u044B\u0432\u043E\u0434\u0430\u0442\u0435\u043A\u0441\u0442\u0430\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u0442\u0438\u043F\u0433\u0440\u0443\u043F\u043F\u0438\u0440\u043E\u0432\u043A\u0438\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u0442\u0438\u043F\u0433\u0440\u0443\u043F\u043F\u044B\u044D\u043B\u0435\u043C\u0435\u043D\u0442\u043E\u0432\u043E\u0442\u0431\u043E\u0440\u0430\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u0442\u0438\u043F\u0434\u043E\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u044F\u043F\u0435\u0440\u0438\u043E\u0434\u0430\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u0442\u0438\u043F\u0437\u0430\u0433\u043E\u043B\u043E\u0432\u043A\u0430\u043F\u043E\u043B\u0435\u0439\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u0442\u0438\u043F\u043C\u0430\u043A\u0435\u0442\u0430\u0433\u0440\u0443\u043F\u043F\u0438\u0440\u043E\u0432\u043A\u0438\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u0442\u0438\u043F\u043C\u0430\u043A\u0435\u0442\u0430\u043E\u0431\u043B\u0430\u0441\u0442\u0438\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u0442\u0438\u043F\u043E\u0441\u0442\u0430\u0442\u043A\u0430\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u0442\u0438\u043F\u043F\u0435\u0440\u0438\u043E\u0434\u0430\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u0442\u0438\u043F\u0440\u0430\u0437\u043C\u0435\u0449\u0435\u043D\u0438\u044F\u0442\u0435\u043A\u0441\u0442\u0430\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u0442\u0438\u043F\u0441\u0432\u044F\u0437\u0438\u043D\u0430\u0431\u043E\u0440\u043E\u0432\u0434\u0430\u043D\u043D\u044B\u0445\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u0442\u0438\u043F\u044D\u043B\u0435\u043C\u0435\u043D\u0442\u0430\u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u0430\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u0440\u0430\u0441\u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0435\u043B\u0435\u0433\u0435\u043D\u0434\u044B\u0434\u0438\u0430\u0433\u0440\u0430\u043C\u043C\u044B\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u0442\u0438\u043F\u043F\u0440\u0438\u043C\u0435\u043D\u0435\u043D\u0438\u044F\u043E\u0442\u0431\u043E\u0440\u0430\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u0440\u0435\u0436\u0438\u043C\u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u044F\u044D\u043B\u0435\u043C\u0435\u043D\u0442\u0430\u043D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u0440\u0435\u0436\u0438\u043C\u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u044F\u043D\u0430\u0441\u0442\u0440\u043E\u0435\u043A\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u0441\u043E\u0441\u0442\u043E\u044F\u043D\u0438\u0435\u044D\u043B\u0435\u043C\u0435\u043D\u0442\u0430\u043D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u0441\u043F\u043E\u0441\u043E\u0431\u0432\u043E\u0441\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u044F\u043D\u0430\u0441\u0442\u0440\u043E\u0435\u043A\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u0440\u0435\u0436\u0438\u043C\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u0430 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435\u043F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u0430\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u0430\u0432\u0442\u043E\u043F\u043E\u0437\u0438\u0446\u0438\u044F\u0440\u0435\u0441\u0443\u0440\u0441\u043E\u0432\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u0432\u0430\u0440\u0438\u0430\u043D\u0442\u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F\u0433\u0440\u0443\u043F\u043F\u0438\u0440\u043E\u0432\u043A\u0438\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u0440\u0430\u0441\u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0435\u0440\u0435\u0441\u0443\u0440\u0441\u043E\u0432\u0432\u0434\u0438\u0430\u0433\u0440\u0430\u043C\u043C\u0435\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u0444\u0438\u043A\u0441\u0430\u0446\u0438\u044F\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435\u0443\u0441\u043B\u043E\u0432\u043D\u043E\u0433\u043E\u043E\u0444\u043E\u0440\u043C\u043B\u0435\u043D\u0438\u044F\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 ";
    // v8 системные перечисления - почта ==> class
    var v8_system_enums_email = "\u0432\u0430\u0436\u043D\u043E\u0441\u0442\u044C\u0438\u043D\u0442\u0435\u0440\u043D\u0435\u0442\u043F\u043E\u0447\u0442\u043E\u0432\u043E\u0433\u043E\u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u044F \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0430\u0442\u0435\u043A\u0441\u0442\u0430\u0438\u043D\u0442\u0435\u0440\u043D\u0435\u0442\u043F\u043E\u0447\u0442\u043E\u0432\u043E\u0433\u043E\u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u044F \u0441\u043F\u043E\u0441\u043E\u0431\u043A\u043E\u0434\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F\u0438\u043D\u0442\u0435\u0440\u043D\u0435\u0442\u043F\u043E\u0447\u0442\u043E\u0432\u043E\u0433\u043E\u0432\u043B\u043E\u0436\u0435\u043D\u0438\u044F \u0441\u043F\u043E\u0441\u043E\u0431\u043A\u043E\u0434\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F\u043D\u0435ascii\u0441\u0438\u043C\u0432\u043E\u043B\u043E\u0432\u0438\u043D\u0442\u0435\u0440\u043D\u0435\u0442\u043F\u043E\u0447\u0442\u043E\u0432\u043E\u0433\u043E\u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u044F \u0442\u0438\u043F\u0442\u0435\u043A\u0441\u0442\u0430\u043F\u043E\u0447\u0442\u043E\u0432\u043E\u0433\u043E\u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u044F \u043F\u0440\u043E\u0442\u043E\u043A\u043E\u043B\u0438\u043D\u0442\u0435\u0440\u043D\u0435\u0442\u043F\u043E\u0447\u0442\u044B \u0441\u0442\u0430\u0442\u0443\u0441\u0440\u0430\u0437\u0431\u043E\u0440\u0430\u043F\u043E\u0447\u0442\u043E\u0432\u043E\u0433\u043E\u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u044F ";
    // v8 системные перечисления - журнал регистрации ==> class
    var v8_system_enums_logbook = "\u0440\u0435\u0436\u0438\u043C\u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0438\u0438\u0437\u0430\u043F\u0438\u0441\u0438\u0436\u0443\u0440\u043D\u0430\u043B\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438 \u0441\u0442\u0430\u0442\u0443\u0441\u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0438\u0438\u0437\u0430\u043F\u0438\u0441\u0438\u0436\u0443\u0440\u043D\u0430\u043B\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438 \u0443\u0440\u043E\u0432\u0435\u043D\u044C\u0436\u0443\u0440\u043D\u0430\u043B\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438 ";
    // v8 системные перечисления - криптография ==> class
    var v8_system_enums_cryptography = "\u0440\u0430\u0441\u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0435\u0445\u0440\u0430\u043D\u0438\u043B\u0438\u0449\u0430\u0441\u0435\u0440\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0432\u043A\u0440\u0438\u043F\u0442\u043E\u0433\u0440\u0430\u0444\u0438\u0438 \u0440\u0435\u0436\u0438\u043C\u0432\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u044F\u0441\u0435\u0440\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0432\u043A\u0440\u0438\u043F\u0442\u043E\u0433\u0440\u0430\u0444\u0438\u0438 \u0440\u0435\u0436\u0438\u043C\u043F\u0440\u043E\u0432\u0435\u0440\u043A\u0438\u0441\u0435\u0440\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u0430\u043A\u0440\u0438\u043F\u0442\u043E\u0433\u0440\u0430\u0444\u0438\u0438 \u0442\u0438\u043F\u0445\u0440\u0430\u043D\u0438\u043B\u0438\u0449\u0430\u0441\u0435\u0440\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0432\u043A\u0440\u0438\u043F\u0442\u043E\u0433\u0440\u0430\u0444\u0438\u0438 ";
    // v8 системные перечисления - ZIP ==> class
    var v8_system_enums_zip = "\u043A\u043E\u0434\u0438\u0440\u043E\u0432\u043A\u0430\u0438\u043C\u0435\u043D\u0444\u0430\u0439\u043B\u043E\u0432\u0432zip\u0444\u0430\u0439\u043B\u0435 \u043C\u0435\u0442\u043E\u0434\u0441\u0436\u0430\u0442\u0438\u044Fzip \u043C\u0435\u0442\u043E\u0434\u0448\u0438\u0444\u0440\u043E\u0432\u0430\u043D\u0438\u044Fzip \u0440\u0435\u0436\u0438\u043C\u0432\u043E\u0441\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u044F\u043F\u0443\u0442\u0435\u0439\u0444\u0430\u0439\u043B\u043E\u0432zip \u0440\u0435\u0436\u0438\u043C\u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0438\u043F\u043E\u0434\u043A\u0430\u0442\u0430\u043B\u043E\u0433\u043E\u0432zip \u0440\u0435\u0436\u0438\u043C\u0441\u043E\u0445\u0440\u0430\u043D\u0435\u043D\u0438\u044F\u043F\u0443\u0442\u0435\u0439zip \u0443\u0440\u043E\u0432\u0435\u043D\u044C\u0441\u0436\u0430\u0442\u0438\u044Fzip ";
    // v8 системные перечисления - 
    // Блокировка данных, Фоновые задания, Автоматизированное тестирование,
    // Доставляемые уведомления, Встроенные покупки, Интернет, Работа с двоичными данными ==> class
    var v8_system_enums_other = "\u0437\u0432\u0443\u043A\u043E\u0432\u043E\u0435\u043E\u043F\u043E\u0432\u0435\u0449\u0435\u043D\u0438\u0435 \u043D\u0430\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u0435\u043F\u0435\u0440\u0435\u0445\u043E\u0434\u0430\u043A\u0441\u0442\u0440\u043E\u043A\u0435 \u043F\u043E\u0437\u0438\u0446\u0438\u044F\u0432\u043F\u043E\u0442\u043E\u043A\u0435 \u043F\u043E\u0440\u044F\u0434\u043E\u043A\u0431\u0430\u0439\u0442\u043E\u0432 \u0440\u0435\u0436\u0438\u043C\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u0440\u0435\u0436\u0438\u043C\u0443\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u044F\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u043A\u043E\u0439\u0434\u0430\u043D\u043D\u044B\u0445 \u0441\u0435\u0440\u0432\u0438\u0441\u0432\u0441\u0442\u0440\u043E\u0435\u043D\u043D\u044B\u0445\u043F\u043E\u043A\u0443\u043F\u043E\u043A \u0441\u043E\u0441\u0442\u043E\u044F\u043D\u0438\u0435\u0444\u043E\u043D\u043E\u0432\u043E\u0433\u043E\u0437\u0430\u0434\u0430\u043D\u0438\u044F \u0442\u0438\u043F\u043F\u043E\u0434\u043F\u0438\u0441\u0447\u0438\u043A\u0430\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u043C\u044B\u0445\u0443\u0432\u0435\u0434\u043E\u043C\u043B\u0435\u043D\u0438\u0439 \u0443\u0440\u043E\u0432\u0435\u043D\u044C\u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F\u0437\u0430\u0449\u0438\u0449\u0435\u043D\u043D\u043E\u0433\u043E\u0441\u043E\u0435\u0434\u0438\u043D\u0435\u043D\u0438\u044Fftp ";
    // v8 системные перечисления - схема запроса ==> class
    var v8_system_enums_request_schema = "\u043D\u0430\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u0435\u043F\u043E\u0440\u044F\u0434\u043A\u0430\u0441\u0445\u0435\u043C\u044B\u0437\u0430\u043F\u0440\u043E\u0441\u0430 \u0442\u0438\u043F\u0434\u043E\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u044F\u043F\u0435\u0440\u0438\u043E\u0434\u0430\u043C\u0438\u0441\u0445\u0435\u043C\u044B\u0437\u0430\u043F\u0440\u043E\u0441\u0430 \u0442\u0438\u043F\u043A\u043E\u043D\u0442\u0440\u043E\u043B\u044C\u043D\u043E\u0439\u0442\u043E\u0447\u043A\u0438\u0441\u0445\u0435\u043C\u044B\u0437\u0430\u043F\u0440\u043E\u0441\u0430 \u0442\u0438\u043F\u043E\u0431\u044A\u0435\u0434\u0438\u043D\u0435\u043D\u0438\u044F\u0441\u0445\u0435\u043C\u044B\u0437\u0430\u043F\u0440\u043E\u0441\u0430 \u0442\u0438\u043F\u043F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u0430\u0434\u043E\u0441\u0442\u0443\u043F\u043D\u043E\u0439\u0442\u0430\u0431\u043B\u0438\u0446\u044B\u0441\u0445\u0435\u043C\u044B\u0437\u0430\u043F\u0440\u043E\u0441\u0430 \u0442\u0438\u043F\u0441\u043E\u0435\u0434\u0438\u043D\u0435\u043D\u0438\u044F\u0441\u0445\u0435\u043C\u044B\u0437\u0430\u043F\u0440\u043E\u0441\u0430 ";
    // v8 системные перечисления - свойства объектов метаданных ==> class
    var v8_system_enums_properties_of_metadata_objects = "http\u043C\u0435\u0442\u043E\u0434 \u0430\u0432\u0442\u043E\u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435\u043E\u0431\u0449\u0435\u0433\u043E\u0440\u0435\u043A\u0432\u0438\u0437\u0438\u0442\u0430 \u0430\u0432\u0442\u043E\u043F\u0440\u0435\u0444\u0438\u043A\u0441\u043D\u043E\u043C\u0435\u0440\u0430\u0437\u0430\u0434\u0430\u0447\u0438 \u0432\u0430\u0440\u0438\u0430\u043D\u0442\u0432\u0441\u0442\u0440\u043E\u0435\u043D\u043D\u043E\u0433\u043E\u044F\u0437\u044B\u043A\u0430 \u0432\u0438\u0434\u0438\u0435\u0440\u0430\u0440\u0445\u0438\u0438 \u0432\u0438\u0434\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u043D\u0430\u043A\u043E\u043F\u043B\u0435\u043D\u0438\u044F \u0432\u0438\u0434\u0442\u0430\u0431\u043B\u0438\u0446\u044B\u0432\u043D\u0435\u0448\u043D\u0435\u0433\u043E\u0438\u0441\u0442\u043E\u0447\u043D\u0438\u043A\u0430\u0434\u0430\u043D\u043D\u044B\u0445 \u0437\u0430\u043F\u0438\u0441\u044C\u0434\u0432\u0438\u0436\u0435\u043D\u0438\u0439\u043F\u0440\u0438\u043F\u0440\u043E\u0432\u0435\u0434\u0435\u043D\u0438\u0438 \u0437\u0430\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u0435\u043F\u043E\u0441\u043B\u0435\u0434\u043E\u0432\u0430\u0442\u0435\u043B\u044C\u043D\u043E\u0441\u0442\u0435\u0439 \u0438\u043D\u0434\u0435\u043A\u0441\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435\u0431\u0430\u0437\u044B\u043F\u043B\u0430\u043D\u0430\u0432\u0438\u0434\u043E\u0432\u0440\u0430\u0441\u0447\u0435\u0442\u0430 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435\u0431\u044B\u0441\u0442\u0440\u043E\u0433\u043E\u0432\u044B\u0431\u043E\u0440\u0430 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435\u043E\u0431\u0449\u0435\u0433\u043E\u0440\u0435\u043A\u0432\u0438\u0437\u0438\u0442\u0430 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435\u043F\u043E\u0434\u0447\u0438\u043D\u0435\u043D\u0438\u044F \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435\u043F\u043E\u043B\u043D\u043E\u0442\u0435\u043A\u0441\u0442\u043E\u0432\u043E\u0433\u043E\u043F\u043E\u0438\u0441\u043A\u0430 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435\u0440\u0430\u0437\u0434\u0435\u043B\u044F\u0435\u043C\u044B\u0445\u0434\u0430\u043D\u043D\u044B\u0445\u043E\u0431\u0449\u0435\u0433\u043E\u0440\u0435\u043A\u0432\u0438\u0437\u0438\u0442\u0430 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435\u0440\u0435\u043A\u0432\u0438\u0437\u0438\u0442\u0430 \u043D\u0430\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435\u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F\u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u044F \u043D\u0430\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435\u0440\u0430\u0441\u0448\u0438\u0440\u0435\u043D\u0438\u044F\u043A\u043E\u043D\u0444\u0438\u0433\u0443\u0440\u0430\u0446\u0438\u0438 \u043D\u0430\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u0435\u043F\u0435\u0440\u0435\u0434\u0430\u0447\u0438 \u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u0435\u043F\u0440\u0435\u0434\u043E\u043F\u0440\u0435\u0434\u0435\u043B\u0435\u043D\u043D\u044B\u0445\u0434\u0430\u043D\u043D\u044B\u0445 \u043E\u043F\u0435\u0440\u0430\u0442\u0438\u0432\u043D\u043E\u0435\u043F\u0440\u043E\u0432\u0435\u0434\u0435\u043D\u0438\u0435 \u043E\u0441\u043D\u043E\u0432\u043D\u043E\u0435\u043F\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0438\u0435\u0432\u0438\u0434\u0430\u0440\u0430\u0441\u0447\u0435\u0442\u0430 \u043E\u0441\u043D\u043E\u0432\u043D\u043E\u0435\u043F\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0438\u0435\u0432\u0438\u0434\u0430\u0445\u0430\u0440\u0430\u043A\u0442\u0435\u0440\u0438\u0441\u0442\u0438\u043A\u0438 \u043E\u0441\u043D\u043E\u0432\u043D\u043E\u0435\u043F\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0438\u0435\u0437\u0430\u0434\u0430\u0447\u0438 \u043E\u0441\u043D\u043E\u0432\u043D\u043E\u0435\u043F\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0438\u0435\u043F\u043B\u0430\u043D\u0430\u043E\u0431\u043C\u0435\u043D\u0430 \u043E\u0441\u043D\u043E\u0432\u043D\u043E\u0435\u043F\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0438\u0435\u0441\u043F\u0440\u0430\u0432\u043E\u0447\u043D\u0438\u043A\u0430 \u043E\u0441\u043D\u043E\u0432\u043D\u043E\u0435\u043F\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0438\u0435\u0441\u0447\u0435\u0442\u0430 \u043F\u0435\u0440\u0435\u043C\u0435\u0449\u0435\u043D\u0438\u0435\u0433\u0440\u0430\u043D\u0438\u0446\u044B\u043F\u0440\u0438\u043F\u0440\u043E\u0432\u0435\u0434\u0435\u043D\u0438\u0438 \u043F\u0435\u0440\u0438\u043E\u0434\u0438\u0447\u043D\u043E\u0441\u0442\u044C\u043D\u043E\u043C\u0435\u0440\u0430\u0431\u0438\u0437\u043D\u0435\u0441\u043F\u0440\u043E\u0446\u0435\u0441\u0441\u0430 \u043F\u0435\u0440\u0438\u043E\u0434\u0438\u0447\u043D\u043E\u0441\u0442\u044C\u043D\u043E\u043C\u0435\u0440\u0430\u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430 \u043F\u0435\u0440\u0438\u043E\u0434\u0438\u0447\u043D\u043E\u0441\u0442\u044C\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0440\u0430\u0441\u0447\u0435\u0442\u0430 \u043F\u0435\u0440\u0438\u043E\u0434\u0438\u0447\u043D\u043E\u0441\u0442\u044C\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0441\u0432\u0435\u0434\u0435\u043D\u0438\u0439 \u043F\u043E\u0432\u0442\u043E\u0440\u043D\u043E\u0435\u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435\u0432\u043E\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u043C\u044B\u0445\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0439 \u043F\u043E\u043B\u043D\u043E\u0442\u0435\u043A\u0441\u0442\u043E\u0432\u044B\u0439\u043F\u043E\u0438\u0441\u043A\u043F\u0440\u0438\u0432\u0432\u043E\u0434\u0435\u043F\u043E\u0441\u0442\u0440\u043E\u043A\u0435 \u043F\u0440\u0438\u043D\u0430\u0434\u043B\u0435\u0436\u043D\u043E\u0441\u0442\u044C\u043E\u0431\u044A\u0435\u043A\u0442\u0430 \u043F\u0440\u043E\u0432\u0435\u0434\u0435\u043D\u0438\u0435 \u0440\u0430\u0437\u0434\u0435\u043B\u0435\u043D\u0438\u0435\u0430\u0443\u0442\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u0438\u043E\u0431\u0449\u0435\u0433\u043E\u0440\u0435\u043A\u0432\u0438\u0437\u0438\u0442\u0430 \u0440\u0430\u0437\u0434\u0435\u043B\u0435\u043D\u0438\u0435\u0434\u0430\u043D\u043D\u044B\u0445\u043E\u0431\u0449\u0435\u0433\u043E\u0440\u0435\u043A\u0432\u0438\u0437\u0438\u0442\u0430 \u0440\u0430\u0437\u0434\u0435\u043B\u0435\u043D\u0438\u0435\u0440\u0430\u0441\u0448\u0438\u0440\u0435\u043D\u0438\u0439\u043A\u043E\u043D\u0444\u0438\u0433\u0443\u0440\u0430\u0446\u0438\u0438\u043E\u0431\u0449\u0435\u0433\u043E\u0440\u0435\u043A\u0432\u0438\u0437\u0438\u0442\u0430 \u0440\u0435\u0436\u0438\u043C\u0430\u0432\u0442\u043E\u043D\u0443\u043C\u0435\u0440\u0430\u0446\u0438\u0438\u043E\u0431\u044A\u0435\u043A\u0442\u043E\u0432 \u0440\u0435\u0436\u0438\u043C\u0437\u0430\u043F\u0438\u0441\u0438\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430 \u0440\u0435\u0436\u0438\u043C\u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F\u043C\u043E\u0434\u0430\u043B\u044C\u043D\u043E\u0441\u0442\u0438 \u0440\u0435\u0436\u0438\u043C\u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F\u0441\u0438\u043D\u0445\u0440\u043E\u043D\u043D\u044B\u0445\u0432\u044B\u0437\u043E\u0432\u043E\u0432\u0440\u0430\u0441\u0448\u0438\u0440\u0435\u043D\u0438\u0439\u043F\u043B\u0430\u0442\u0444\u043E\u0440\u043C\u044B\u0438\u0432\u043D\u0435\u0448\u043D\u0438\u0445\u043A\u043E\u043C\u043F\u043E\u043D\u0435\u043D\u0442 \u0440\u0435\u0436\u0438\u043C\u043F\u043E\u0432\u0442\u043E\u0440\u043D\u043E\u0433\u043E\u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F\u0441\u0435\u0430\u043D\u0441\u043E\u0432 \u0440\u0435\u0436\u0438\u043C\u043F\u043E\u043B\u0443\u0447\u0435\u043D\u0438\u044F\u0434\u0430\u043D\u043D\u044B\u0445\u0432\u044B\u0431\u043E\u0440\u0430\u043F\u0440\u0438\u0432\u0432\u043E\u0434\u0435\u043F\u043E\u0441\u0442\u0440\u043E\u043A\u0435 \u0440\u0435\u0436\u0438\u043C\u0441\u043E\u0432\u043C\u0435\u0441\u0442\u0438\u043C\u043E\u0441\u0442\u0438 \u0440\u0435\u0436\u0438\u043C\u0441\u043E\u0432\u043C\u0435\u0441\u0442\u0438\u043C\u043E\u0441\u0442\u0438\u0438\u043D\u0442\u0435\u0440\u0444\u0435\u0439\u0441\u0430 \u0440\u0435\u0436\u0438\u043C\u0443\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u044F\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u043A\u043E\u0439\u0434\u0430\u043D\u043D\u044B\u0445\u043F\u043E\u0443\u043C\u043E\u043B\u0447\u0430\u043D\u0438\u044E \u0441\u0435\u0440\u0438\u0438\u043A\u043E\u0434\u043E\u0432\u043F\u043B\u0430\u043D\u0430\u0432\u0438\u0434\u043E\u0432\u0445\u0430\u0440\u0430\u043A\u0442\u0435\u0440\u0438\u0441\u0442\u0438\u043A \u0441\u0435\u0440\u0438\u0438\u043A\u043E\u0434\u043E\u0432\u043F\u043B\u0430\u043D\u0430\u0441\u0447\u0435\u0442\u043E\u0432 \u0441\u0435\u0440\u0438\u0438\u043A\u043E\u0434\u043E\u0432\u0441\u043F\u0440\u0430\u0432\u043E\u0447\u043D\u0438\u043A\u0430 \u0441\u043E\u0437\u0434\u0430\u043D\u0438\u0435\u043F\u0440\u0438\u0432\u0432\u043E\u0434\u0435 \u0441\u043F\u043E\u0441\u043E\u0431\u0432\u044B\u0431\u043E\u0440\u0430 \u0441\u043F\u043E\u0441\u043E\u0431\u043F\u043E\u0438\u0441\u043A\u0430\u0441\u0442\u0440\u043E\u043A\u0438\u043F\u0440\u0438\u0432\u0432\u043E\u0434\u0435\u043F\u043E\u0441\u0442\u0440\u043E\u043A\u0435 \u0441\u043F\u043E\u0441\u043E\u0431\u0440\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F \u0442\u0438\u043F\u0434\u0430\u043D\u043D\u044B\u0445\u0442\u0430\u0431\u043B\u0438\u0446\u044B\u0432\u043D\u0435\u0448\u043D\u0435\u0433\u043E\u0438\u0441\u0442\u043E\u0447\u043D\u0438\u043A\u0430\u0434\u0430\u043D\u043D\u044B\u0445 \u0442\u0438\u043F\u043A\u043E\u0434\u0430\u043F\u043B\u0430\u043D\u0430\u0432\u0438\u0434\u043E\u0432\u0440\u0430\u0441\u0447\u0435\u0442\u0430 \u0442\u0438\u043F\u043A\u043E\u0434\u0430\u0441\u043F\u0440\u0430\u0432\u043E\u0447\u043D\u0438\u043A\u0430 \u0442\u0438\u043F\u043C\u0430\u043A\u0435\u0442\u0430 \u0442\u0438\u043F\u043D\u043E\u043C\u0435\u0440\u0430\u0431\u0438\u0437\u043D\u0435\u0441\u043F\u0440\u043E\u0446\u0435\u0441\u0441\u0430 \u0442\u0438\u043F\u043D\u043E\u043C\u0435\u0440\u0430\u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430 \u0442\u0438\u043F\u043D\u043E\u043C\u0435\u0440\u0430\u0437\u0430\u0434\u0430\u0447\u0438 \u0442\u0438\u043F\u0444\u043E\u0440\u043C\u044B \u0443\u0434\u0430\u043B\u0435\u043D\u0438\u0435\u0434\u0432\u0438\u0436\u0435\u043D\u0438\u0439 ";
    // v8 системные перечисления - разные ==> class
    var v8_system_enums_differents = "\u0432\u0430\u0436\u043D\u043E\u0441\u0442\u044C\u043F\u0440\u043E\u0431\u043B\u0435\u043C\u044B\u043F\u0440\u0438\u043C\u0435\u043D\u0435\u043D\u0438\u044F\u0440\u0430\u0441\u0448\u0438\u0440\u0435\u043D\u0438\u044F\u043A\u043E\u043D\u0444\u0438\u0433\u0443\u0440\u0430\u0446\u0438\u0438 \u0432\u0430\u0440\u0438\u0430\u043D\u0442\u0438\u043D\u0442\u0435\u0440\u0444\u0435\u0439\u0441\u0430\u043A\u043B\u0438\u0435\u043D\u0442\u0441\u043A\u043E\u0433\u043E\u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u044F \u0432\u0430\u0440\u0438\u0430\u043D\u0442\u043C\u0430\u0441\u0448\u0442\u0430\u0431\u0430\u0444\u043E\u0440\u043C\u043A\u043B\u0438\u0435\u043D\u0442\u0441\u043A\u043E\u0433\u043E\u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u044F \u0432\u0430\u0440\u0438\u0430\u043D\u0442\u043E\u0441\u043D\u043E\u0432\u043D\u043E\u0433\u043E\u0448\u0440\u0438\u0444\u0442\u0430\u043A\u043B\u0438\u0435\u043D\u0442\u0441\u043A\u043E\u0433\u043E\u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u044F \u0432\u0430\u0440\u0438\u0430\u043D\u0442\u0441\u0442\u0430\u043D\u0434\u0430\u0440\u0442\u043D\u043E\u0433\u043E\u043F\u0435\u0440\u0438\u043E\u0434\u0430 \u0432\u0430\u0440\u0438\u0430\u043D\u0442\u0441\u0442\u0430\u043D\u0434\u0430\u0440\u0442\u043D\u043E\u0439\u0434\u0430\u0442\u044B\u043D\u0430\u0447\u0430\u043B\u0430 \u0432\u0438\u0434\u0433\u0440\u0430\u043D\u0438\u0446\u044B \u0432\u0438\u0434\u043A\u0430\u0440\u0442\u0438\u043D\u043A\u0438 \u0432\u0438\u0434\u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u044F\u043F\u043E\u043B\u043D\u043E\u0442\u0435\u043A\u0441\u0442\u043E\u0432\u043E\u0433\u043E\u043F\u043E\u0438\u0441\u043A\u0430 \u0432\u0438\u0434\u0440\u0430\u043C\u043A\u0438 \u0432\u0438\u0434\u0441\u0440\u0430\u0432\u043D\u0435\u043D\u0438\u044F \u0432\u0438\u0434\u0446\u0432\u0435\u0442\u0430 \u0432\u0438\u0434\u0447\u0438\u0441\u043B\u043E\u0432\u043E\u0433\u043E\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u044F \u0432\u0438\u0434\u0448\u0440\u0438\u0444\u0442\u0430 \u0434\u043E\u043F\u0443\u0441\u0442\u0438\u043C\u0430\u044F\u0434\u043B\u0438\u043D\u0430 \u0434\u043E\u043F\u0443\u0441\u0442\u0438\u043C\u044B\u0439\u0437\u043D\u0430\u043A \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435byteordermark \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435\u043C\u0435\u0442\u0430\u0434\u0430\u043D\u043D\u044B\u0445\u043F\u043E\u043B\u043D\u043E\u0442\u0435\u043A\u0441\u0442\u043E\u0432\u043E\u0433\u043E\u043F\u043E\u0438\u0441\u043A\u0430 \u0438\u0441\u0442\u043E\u0447\u043D\u0438\u043A\u0440\u0430\u0441\u0448\u0438\u0440\u0435\u043D\u0438\u0439\u043A\u043E\u043D\u0444\u0438\u0433\u0443\u0440\u0430\u0446\u0438\u0438 \u043A\u043B\u0430\u0432\u0438\u0448\u0430 \u043A\u043E\u0434\u0432\u043E\u0437\u0432\u0440\u0430\u0442\u0430\u0434\u0438\u0430\u043B\u043E\u0433\u0430 \u043A\u043E\u0434\u0438\u0440\u043E\u0432\u043A\u0430xbase \u043A\u043E\u0434\u0438\u0440\u043E\u0432\u043A\u0430\u0442\u0435\u043A\u0441\u0442\u0430 \u043D\u0430\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u0435\u043F\u043E\u0438\u0441\u043A\u0430 \u043D\u0430\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u0435\u0441\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u043A\u0438 \u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u0435\u043F\u0440\u0435\u0434\u043E\u043F\u0440\u0435\u0434\u0435\u043B\u0435\u043D\u043D\u044B\u0445\u0434\u0430\u043D\u043D\u044B\u0445 \u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u0435\u043F\u0440\u0438\u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435\u043F\u0430\u043D\u0435\u043B\u0438\u0440\u0430\u0437\u0434\u0435\u043B\u043E\u0432 \u043F\u0440\u043E\u0432\u0435\u0440\u043A\u0430\u0437\u0430\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u044F \u0440\u0435\u0436\u0438\u043C\u0434\u0438\u0430\u043B\u043E\u0433\u0430\u0432\u043E\u043F\u0440\u043E\u0441 \u0440\u0435\u0436\u0438\u043C\u0437\u0430\u043F\u0443\u0441\u043A\u0430\u043A\u043B\u0438\u0435\u043D\u0442\u0441\u043A\u043E\u0433\u043E\u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u044F \u0440\u0435\u0436\u0438\u043C\u043E\u043A\u0440\u0443\u0433\u043B\u0435\u043D\u0438\u044F \u0440\u0435\u0436\u0438\u043C\u043E\u0442\u043A\u0440\u044B\u0442\u0438\u044F\u0444\u043E\u0440\u043C\u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u044F \u0440\u0435\u0436\u0438\u043C\u043F\u043E\u043B\u043D\u043E\u0442\u0435\u043A\u0441\u0442\u043E\u0432\u043E\u0433\u043E\u043F\u043E\u0438\u0441\u043A\u0430 \u0441\u043A\u043E\u0440\u043E\u0441\u0442\u044C\u043A\u043B\u0438\u0435\u043D\u0442\u0441\u043A\u043E\u0433\u043E\u0441\u043E\u0435\u0434\u0438\u043D\u0435\u043D\u0438\u044F \u0441\u043E\u0441\u0442\u043E\u044F\u043D\u0438\u0435\u0432\u043D\u0435\u0448\u043D\u0435\u0433\u043E\u0438\u0441\u0442\u043E\u0447\u043D\u0438\u043A\u0430\u0434\u0430\u043D\u043D\u044B\u0445 \u0441\u043E\u0441\u0442\u043E\u044F\u043D\u0438\u0435\u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u044F\u043A\u043E\u043D\u0444\u0438\u0433\u0443\u0440\u0430\u0446\u0438\u0438\u0431\u0430\u0437\u044B\u0434\u0430\u043D\u043D\u044B\u0445 \u0441\u043F\u043E\u0441\u043E\u0431\u0432\u044B\u0431\u043E\u0440\u0430\u0441\u0435\u0440\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u0430windows \u0441\u043F\u043E\u0441\u043E\u0431\u043A\u043E\u0434\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F\u0441\u0442\u0440\u043E\u043A\u0438 \u0441\u0442\u0430\u0442\u0443\u0441\u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u044F \u0442\u0438\u043F\u0432\u043D\u0435\u0448\u043D\u0435\u0439\u043A\u043E\u043C\u043F\u043E\u043D\u0435\u043D\u0442\u044B \u0442\u0438\u043F\u043F\u043B\u0430\u0442\u0444\u043E\u0440\u043C\u044B \u0442\u0438\u043F\u043F\u043E\u0432\u0435\u0434\u0435\u043D\u0438\u044F\u043A\u043B\u0430\u0432\u0438\u0448\u0438enter \u0442\u0438\u043F\u044D\u043B\u0435\u043C\u0435\u043D\u0442\u0430\u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0438\u043E\u0432\u044B\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u0438\u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u044F\u043A\u043E\u043D\u0444\u0438\u0433\u0443\u0440\u0430\u0446\u0438\u0438\u0431\u0430\u0437\u044B\u0434\u0430\u043D\u043D\u044B\u0445 \u0443\u0440\u043E\u0432\u0435\u043D\u044C\u0438\u0437\u043E\u043B\u044F\u0446\u0438\u0438\u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0438\u0439 \u0445\u0435\u0448\u0444\u0443\u043D\u043A\u0446\u0438\u044F \u0447\u0430\u0441\u0442\u0438\u0434\u0430\u0442\u044B";
    // class: встроенные наборы значений, системные перечисления (содержат дочерние значения, обращения к которым через разыменование)
    var CLASS = v8_system_sets_of_values + v8_system_enums_interface + v8_system_enums_objects_properties + v8_system_enums_exchange_plans + v8_system_enums_tabular_document + v8_system_enums_sheduler + v8_system_enums_formatted_document + v8_system_enums_query + v8_system_enums_report_builder + v8_system_enums_files + v8_system_enums_query_builder + v8_system_enums_data_analysis + v8_system_enums_xml_json_xs_dom_xdto_ws + v8_system_enums_data_composition_system + v8_system_enums_email + v8_system_enums_logbook + v8_system_enums_cryptography + v8_system_enums_zip + v8_system_enums_other + v8_system_enums_request_schema + v8_system_enums_properties_of_metadata_objects + v8_system_enums_differents;
    // v8 общие объекты (у объектов есть конструктор, экземпляры создаются методом НОВЫЙ) ==> type
    var v8_shared_object = "com\u043E\u0431\u044A\u0435\u043A\u0442 ftp\u0441\u043E\u0435\u0434\u0438\u043D\u0435\u043D\u0438\u0435 http\u0437\u0430\u043F\u0440\u043E\u0441 http\u0441\u0435\u0440\u0432\u0438\u0441\u043E\u0442\u0432\u0435\u0442 http\u0441\u043E\u0435\u0434\u0438\u043D\u0435\u043D\u0438\u0435 ws\u043E\u043F\u0440\u0435\u0434\u0435\u043B\u0435\u043D\u0438\u044F ws\u043F\u0440\u043E\u043A\u0441\u0438 xbase \u0430\u043D\u0430\u043B\u0438\u0437\u0434\u0430\u043D\u043D\u044B\u0445 \u0430\u043D\u043D\u043E\u0442\u0430\u0446\u0438\u044Fxs \u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u043A\u0430\u0434\u0430\u043D\u043D\u044B\u0445 \u0431\u0443\u0444\u0435\u0440\u0434\u0432\u043E\u0438\u0447\u043D\u044B\u0445\u0434\u0430\u043D\u043D\u044B\u0445 \u0432\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0435xs \u0432\u044B\u0440\u0430\u0436\u0435\u043D\u0438\u0435\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u0433\u0435\u043D\u0435\u0440\u0430\u0442\u043E\u0440\u0441\u043B\u0443\u0447\u0430\u0439\u043D\u044B\u0445\u0447\u0438\u0441\u0435\u043B \u0433\u0435\u043E\u0433\u0440\u0430\u0444\u0438\u0447\u0435\u0441\u043A\u0430\u044F\u0441\u0445\u0435\u043C\u0430 \u0433\u0435\u043E\u0433\u0440\u0430\u0444\u0438\u0447\u0435\u0441\u043A\u0438\u0435\u043A\u043E\u043E\u0440\u0434\u0438\u043D\u0430\u0442\u044B \u0433\u0440\u0430\u0444\u0438\u0447\u0435\u0441\u043A\u0430\u044F\u0441\u0445\u0435\u043C\u0430 \u0433\u0440\u0443\u043F\u043F\u0430\u043C\u043E\u0434\u0435\u043B\u0438xs \u0434\u0430\u043D\u043D\u044B\u0435\u0440\u0430\u0441\u0448\u0438\u0444\u0440\u043E\u0432\u043A\u0438\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u0434\u0432\u043E\u0438\u0447\u043D\u044B\u0435\u0434\u0430\u043D\u043D\u044B\u0435 \u0434\u0435\u043D\u0434\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u0430 \u0434\u0438\u0430\u0433\u0440\u0430\u043C\u043C\u0430 \u0434\u0438\u0430\u0433\u0440\u0430\u043C\u043C\u0430\u0433\u0430\u043D\u0442\u0430 \u0434\u0438\u0430\u043B\u043E\u0433\u0432\u044B\u0431\u043E\u0440\u0430\u0444\u0430\u0439\u043B\u0430 \u0434\u0438\u0430\u043B\u043E\u0433\u0432\u044B\u0431\u043E\u0440\u0430\u0446\u0432\u0435\u0442\u0430 \u0434\u0438\u0430\u043B\u043E\u0433\u0432\u044B\u0431\u043E\u0440\u0430\u0448\u0440\u0438\u0444\u0442\u0430 \u0434\u0438\u0430\u043B\u043E\u0433\u0440\u0430\u0441\u043F\u0438\u0441\u0430\u043D\u0438\u044F\u0440\u0435\u0433\u043B\u0430\u043C\u0435\u043D\u0442\u043D\u043E\u0433\u043E\u0437\u0430\u0434\u0430\u043D\u0438\u044F \u0434\u0438\u0430\u043B\u043E\u0433\u0440\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F\u0441\u0442\u0430\u043D\u0434\u0430\u0440\u0442\u043D\u043E\u0433\u043E\u043F\u0435\u0440\u0438\u043E\u0434\u0430 \u0434\u0438\u0430\u043F\u0430\u0437\u043E\u043D \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442dom \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442html \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430\u0446\u0438\u044Fxs \u0434\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u043C\u043E\u0435\u0443\u0432\u0435\u0434\u043E\u043C\u043B\u0435\u043D\u0438\u0435 \u0437\u0430\u043F\u0438\u0441\u044Cdom \u0437\u0430\u043F\u0438\u0441\u044Cfastinfoset \u0437\u0430\u043F\u0438\u0441\u044Chtml \u0437\u0430\u043F\u0438\u0441\u044Cjson \u0437\u0430\u043F\u0438\u0441\u044Cxml \u0437\u0430\u043F\u0438\u0441\u044Czip\u0444\u0430\u0439\u043B\u0430 \u0437\u0430\u043F\u0438\u0441\u044C\u0434\u0430\u043D\u043D\u044B\u0445 \u0437\u0430\u043F\u0438\u0441\u044C\u0442\u0435\u043A\u0441\u0442\u0430 \u0437\u0430\u043F\u0438\u0441\u044C\u0443\u0437\u043B\u043E\u0432dom \u0437\u0430\u043F\u0440\u043E\u0441 \u0437\u0430\u0449\u0438\u0449\u0435\u043D\u043D\u043E\u0435\u0441\u043E\u0435\u0434\u0438\u043D\u0435\u043D\u0438\u0435openssl \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u044F\u043F\u043E\u043B\u0435\u0439\u0440\u0430\u0441\u0448\u0438\u0444\u0440\u043E\u0432\u043A\u0438\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u0438\u0437\u0432\u043B\u0435\u0447\u0435\u043D\u0438\u0435\u0442\u0435\u043A\u0441\u0442\u0430 \u0438\u043C\u043F\u043E\u0440\u0442xs \u0438\u043D\u0442\u0435\u0440\u043D\u0435\u0442\u043F\u043E\u0447\u0442\u0430 \u0438\u043D\u0442\u0435\u0440\u043D\u0435\u0442\u043F\u043E\u0447\u0442\u043E\u0432\u043E\u0435\u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435 \u0438\u043D\u0442\u0435\u0440\u043D\u0435\u0442\u043F\u043E\u0447\u0442\u043E\u0432\u044B\u0439\u043F\u0440\u043E\u0444\u0438\u043B\u044C \u0438\u043D\u0442\u0435\u0440\u043D\u0435\u0442\u043F\u0440\u043E\u043A\u0441\u0438 \u0438\u043D\u0442\u0435\u0440\u043D\u0435\u0442\u0441\u043E\u0435\u0434\u0438\u043D\u0435\u043D\u0438\u0435 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F\u0434\u043B\u044F\u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u044Fxs \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435\u0430\u0442\u0440\u0438\u0431\u0443\u0442\u0430xs \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435\u0441\u043E\u0431\u044B\u0442\u0438\u044F\u0436\u0443\u0440\u043D\u0430\u043B\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438 \u0438\u0441\u0442\u043E\u0447\u043D\u0438\u043A\u0434\u043E\u0441\u0442\u0443\u043F\u043D\u044B\u0445\u043D\u0430\u0441\u0442\u0440\u043E\u0435\u043A\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u0438\u0442\u0435\u0440\u0430\u0442\u043E\u0440\u0443\u0437\u043B\u043E\u0432dom \u043A\u0430\u0440\u0442\u0438\u043D\u043A\u0430 \u043A\u0432\u0430\u043B\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440\u044B\u0434\u0430\u0442\u044B \u043A\u0432\u0430\u043B\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440\u044B\u0434\u0432\u043E\u0438\u0447\u043D\u044B\u0445\u0434\u0430\u043D\u043D\u044B\u0445 \u043A\u0432\u0430\u043B\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440\u044B\u0441\u0442\u0440\u043E\u043A\u0438 \u043A\u0432\u0430\u043B\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440\u044B\u0447\u0438\u0441\u043B\u0430 \u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u0449\u0438\u043A\u043C\u0430\u043A\u0435\u0442\u0430\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u0449\u0438\u043A\u043D\u0430\u0441\u0442\u0440\u043E\u0435\u043A\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u043A\u043E\u043D\u0441\u0442\u0440\u0443\u043A\u0442\u043E\u0440\u043C\u0430\u043A\u0435\u0442\u0430\u043E\u0444\u043E\u0440\u043C\u043B\u0435\u043D\u0438\u044F\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u043A\u043E\u043D\u0441\u0442\u0440\u0443\u043A\u0442\u043E\u0440\u043D\u0430\u0441\u0442\u0440\u043E\u0435\u043A\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u043A\u043E\u043D\u0441\u0442\u0440\u0443\u043A\u0442\u043E\u0440\u0444\u043E\u0440\u043C\u0430\u0442\u043D\u043E\u0439\u0441\u0442\u0440\u043E\u043A\u0438 \u043B\u0438\u043D\u0438\u044F \u043C\u0430\u043A\u0435\u0442\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u043C\u0430\u043A\u0435\u0442\u043E\u0431\u043B\u0430\u0441\u0442\u0438\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u043C\u0430\u043A\u0435\u0442\u043E\u0444\u043E\u0440\u043C\u043B\u0435\u043D\u0438\u044F\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u043C\u0430\u0441\u043A\u0430xs \u043C\u0435\u043D\u0435\u0434\u0436\u0435\u0440\u043A\u0440\u0438\u043F\u0442\u043E\u0433\u0440\u0430\u0444\u0438\u0438 \u043D\u0430\u0431\u043E\u0440\u0441\u0445\u0435\u043Cxml \u043D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u043D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438\u0441\u0435\u0440\u0438\u0430\u043B\u0438\u0437\u0430\u0446\u0438\u0438json \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0430\u043A\u0430\u0440\u0442\u0438\u043D\u043E\u043A \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0430\u0440\u0430\u0441\u0448\u0438\u0444\u0440\u043E\u0432\u043A\u0438\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u043E\u0431\u0445\u043E\u0434\u0434\u0435\u0440\u0435\u0432\u0430dom \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0435\u0430\u0442\u0440\u0438\u0431\u0443\u0442\u0430xs \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0435\u043D\u043E\u0442\u0430\u0446\u0438\u0438xs \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0435\u044D\u043B\u0435\u043C\u0435\u043D\u0442\u0430xs \u043E\u043F\u0438\u0441\u0430\u043D\u0438\u0435\u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F\u0441\u043E\u0431\u044B\u0442\u0438\u044F\u0434\u043E\u0441\u0442\u0443\u043F\u0436\u0443\u0440\u043D\u0430\u043B\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438 \u043E\u043F\u0438\u0441\u0430\u043D\u0438\u0435\u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F\u0441\u043E\u0431\u044B\u0442\u0438\u044F\u043E\u0442\u043A\u0430\u0437\u0432\u0434\u043E\u0441\u0442\u0443\u043F\u0435\u0436\u0443\u0440\u043D\u0430\u043B\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438 \u043E\u043F\u0438\u0441\u0430\u043D\u0438\u0435\u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0438\u0440\u0430\u0441\u0448\u0438\u0444\u0440\u043E\u0432\u043A\u0438\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u043E\u043F\u0438\u0441\u0430\u043D\u0438\u0435\u043F\u0435\u0440\u0435\u0434\u0430\u0432\u0430\u0435\u043C\u043E\u0433\u043E\u0444\u0430\u0439\u043B\u0430 \u043E\u043F\u0438\u0441\u0430\u043D\u0438\u0435\u0442\u0438\u043F\u043E\u0432 \u043E\u043F\u0440\u0435\u0434\u0435\u043B\u0435\u043D\u0438\u0435\u0433\u0440\u0443\u043F\u043F\u044B\u0430\u0442\u0440\u0438\u0431\u0443\u0442\u043E\u0432xs \u043E\u043F\u0440\u0435\u0434\u0435\u043B\u0435\u043D\u0438\u0435\u0433\u0440\u0443\u043F\u043F\u044B\u043C\u043E\u0434\u0435\u043B\u0438xs \u043E\u043F\u0440\u0435\u0434\u0435\u043B\u0435\u043D\u0438\u0435\u043E\u0433\u0440\u0430\u043D\u0438\u0447\u0435\u043D\u0438\u044F\u0438\u0434\u0435\u043D\u0442\u0438\u0447\u043D\u043E\u0441\u0442\u0438xs \u043E\u043F\u0440\u0435\u0434\u0435\u043B\u0435\u043D\u0438\u0435\u043F\u0440\u043E\u0441\u0442\u043E\u0433\u043E\u0442\u0438\u043F\u0430xs \u043E\u043F\u0440\u0435\u0434\u0435\u043B\u0435\u043D\u0438\u0435\u0441\u043E\u0441\u0442\u0430\u0432\u043D\u043E\u0433\u043E\u0442\u0438\u043F\u0430xs \u043E\u043F\u0440\u0435\u0434\u0435\u043B\u0435\u043D\u0438\u0435\u0442\u0438\u043F\u0430\u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430dom \u043E\u043F\u0440\u0435\u0434\u0435\u043B\u0435\u043D\u0438\u044Fxpathxs \u043E\u0442\u0431\u043E\u0440\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u043F\u0430\u043A\u0435\u0442\u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0430\u0435\u043C\u044B\u0445\u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u043E\u0432 \u043F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u0432\u044B\u0431\u043E\u0440\u0430 \u043F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u043F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u044B\u0437\u0430\u043F\u0438\u0441\u0438json \u043F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u044B\u0437\u0430\u043F\u0438\u0441\u0438xml \u043F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u044B\u0447\u0442\u0435\u043D\u0438\u044Fxml \u043F\u0435\u0440\u0435\u043E\u043F\u0440\u0435\u0434\u0435\u043B\u0435\u043D\u0438\u0435xs \u043F\u043B\u0430\u043D\u0438\u0440\u043E\u0432\u0449\u0438\u043A \u043F\u043E\u043B\u0435\u0430\u043D\u0430\u043B\u0438\u0437\u0430\u0434\u0430\u043D\u043D\u044B\u0445 \u043F\u043E\u043B\u0435\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u043F\u043E\u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044Cdom \u043F\u043E\u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u0437\u0430\u043F\u0440\u043E\u0441\u0430 \u043F\u043E\u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u043E\u0442\u0447\u0435\u0442\u0430 \u043F\u043E\u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u043E\u0442\u0447\u0435\u0442\u0430\u0430\u043D\u0430\u043B\u0438\u0437\u0430\u0434\u0430\u043D\u043D\u044B\u0445 \u043F\u043E\u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u0441\u0445\u0435\u043Cxml \u043F\u043E\u0442\u043E\u043A \u043F\u043E\u0442\u043E\u043A\u0432\u043F\u0430\u043C\u044F\u0442\u0438 \u043F\u043E\u0447\u0442\u0430 \u043F\u043E\u0447\u0442\u043E\u0432\u043E\u0435\u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435 \u043F\u0440\u0435\u043E\u0431\u0440\u0430\u0437\u043E\u0432\u0430\u043D\u0438\u0435xsl \u043F\u0440\u0435\u043E\u0431\u0440\u0430\u0437\u043E\u0432\u0430\u043D\u0438\u0435\u043A\u043A\u0430\u043D\u043E\u043D\u0438\u0447\u0435\u0441\u043A\u043E\u043C\u0443xml \u043F\u0440\u043E\u0446\u0435\u0441\u0441\u043E\u0440\u0432\u044B\u0432\u043E\u0434\u0430\u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u0430\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445\u0432\u043A\u043E\u043B\u043B\u0435\u043A\u0446\u0438\u044E\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0439 \u043F\u0440\u043E\u0446\u0435\u0441\u0441\u043E\u0440\u0432\u044B\u0432\u043E\u0434\u0430\u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u0430\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445\u0432\u0442\u0430\u0431\u043B\u0438\u0447\u043D\u044B\u0439\u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442 \u043F\u0440\u043E\u0446\u0435\u0441\u0441\u043E\u0440\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u0440\u0430\u0437\u044B\u043C\u0435\u043D\u043E\u0432\u0430\u0442\u0435\u043B\u044C\u043F\u0440\u043E\u0441\u0442\u0440\u0430\u043D\u0441\u0442\u0432\u0438\u043C\u0435\u043Ddom \u0440\u0430\u043C\u043A\u0430 \u0440\u0430\u0441\u043F\u0438\u0441\u0430\u043D\u0438\u0435\u0440\u0435\u0433\u043B\u0430\u043C\u0435\u043D\u0442\u043D\u043E\u0433\u043E\u0437\u0430\u0434\u0430\u043D\u0438\u044F \u0440\u0430\u0441\u0448\u0438\u0440\u0435\u043D\u043D\u043E\u0435\u0438\u043C\u044Fxml \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u0447\u0442\u0435\u043D\u0438\u044F\u0434\u0430\u043D\u043D\u044B\u0445 \u0441\u0432\u043E\u0434\u043D\u0430\u044F\u0434\u0438\u0430\u0433\u0440\u0430\u043C\u043C\u0430 \u0441\u0432\u044F\u0437\u044C\u043F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u0430\u0432\u044B\u0431\u043E\u0440\u0430 \u0441\u0432\u044F\u0437\u044C\u043F\u043E\u0442\u0438\u043F\u0443 \u0441\u0432\u044F\u0437\u044C\u043F\u043E\u0442\u0438\u043F\u0443\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u0441\u0435\u0440\u0438\u0430\u043B\u0438\u0437\u0430\u0442\u043E\u0440xdto \u0441\u0435\u0440\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043A\u043B\u0438\u0435\u043D\u0442\u0430windows \u0441\u0435\u0440\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043A\u043B\u0438\u0435\u043D\u0442\u0430\u0444\u0430\u0439\u043B \u0441\u0435\u0440\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043A\u0440\u0438\u043F\u0442\u043E\u0433\u0440\u0430\u0444\u0438\u0438 \u0441\u0435\u0440\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u044B\u0443\u0434\u043E\u0441\u0442\u043E\u0432\u0435\u0440\u044F\u044E\u0449\u0438\u0445\u0446\u0435\u043D\u0442\u0440\u043E\u0432windows \u0441\u0435\u0440\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u044B\u0443\u0434\u043E\u0441\u0442\u043E\u0432\u0435\u0440\u044F\u044E\u0449\u0438\u0445\u0446\u0435\u043D\u0442\u0440\u043E\u0432\u0444\u0430\u0439\u043B \u0441\u0436\u0430\u0442\u0438\u0435\u0434\u0430\u043D\u043D\u044B\u0445 \u0441\u0438\u0441\u0442\u0435\u043C\u043D\u0430\u044F\u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044E \u0441\u043E\u0447\u0435\u0442\u0430\u043D\u0438\u0435\u043A\u043B\u0430\u0432\u0438\u0448 \u0441\u0440\u0430\u0432\u043D\u0435\u043D\u0438\u0435\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0439 \u0441\u0442\u0430\u043D\u0434\u0430\u0440\u0442\u043D\u0430\u044F\u0434\u0430\u0442\u0430\u043D\u0430\u0447\u0430\u043B\u0430 \u0441\u0442\u0430\u043D\u0434\u0430\u0440\u0442\u043D\u044B\u0439\u043F\u0435\u0440\u0438\u043E\u0434 \u0441\u0445\u0435\u043C\u0430xml \u0441\u0445\u0435\u043C\u0430\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u0442\u0430\u0431\u043B\u0438\u0447\u043D\u044B\u0439\u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442 \u0442\u0435\u043A\u0441\u0442\u043E\u0432\u044B\u0439\u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442 \u0442\u0435\u0441\u0442\u0438\u0440\u0443\u0435\u043C\u043E\u0435\u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435 \u0442\u0438\u043F\u0434\u0430\u043D\u043D\u044B\u0445xml \u0443\u043D\u0438\u043A\u0430\u043B\u044C\u043D\u044B\u0439\u0438\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440 \u0444\u0430\u0431\u0440\u0438\u043A\u0430xdto \u0444\u0430\u0439\u043B \u0444\u0430\u0439\u043B\u043E\u0432\u044B\u0439\u043F\u043E\u0442\u043E\u043A \u0444\u0430\u0441\u0435\u0442\u0434\u043B\u0438\u043D\u044Bxs \u0444\u0430\u0441\u0435\u0442\u043A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u0430\u0440\u0430\u0437\u0440\u044F\u0434\u043E\u0432\u0434\u0440\u043E\u0431\u043D\u043E\u0439\u0447\u0430\u0441\u0442\u0438xs \u0444\u0430\u0441\u0435\u0442\u043C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u044C\u043D\u043E\u0433\u043E\u0432\u043A\u043B\u044E\u0447\u0430\u044E\u0449\u0435\u0433\u043E\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u044Fxs \u0444\u0430\u0441\u0435\u0442\u043C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u044C\u043D\u043E\u0433\u043E\u0438\u0441\u043A\u043B\u044E\u0447\u0430\u044E\u0449\u0435\u0433\u043E\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u044Fxs \u0444\u0430\u0441\u0435\u0442\u043C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u044C\u043D\u043E\u0439\u0434\u043B\u0438\u043D\u044Bxs \u0444\u0430\u0441\u0435\u0442\u043C\u0438\u043D\u0438\u043C\u0430\u043B\u044C\u043D\u043E\u0433\u043E\u0432\u043A\u043B\u044E\u0447\u0430\u044E\u0449\u0435\u0433\u043E\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u044Fxs \u0444\u0430\u0441\u0435\u0442\u043C\u0438\u043D\u0438\u043C\u0430\u043B\u044C\u043D\u043E\u0433\u043E\u0438\u0441\u043A\u043B\u044E\u0447\u0430\u044E\u0449\u0435\u0433\u043E\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u044Fxs \u0444\u0430\u0441\u0435\u0442\u043C\u0438\u043D\u0438\u043C\u0430\u043B\u044C\u043D\u043E\u0439\u0434\u043B\u0438\u043D\u044Bxs \u0444\u0430\u0441\u0435\u0442\u043E\u0431\u0440\u0430\u0437\u0446\u0430xs \u0444\u0430\u0441\u0435\u0442\u043E\u0431\u0449\u0435\u0433\u043E\u043A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u0430\u0440\u0430\u0437\u0440\u044F\u0434\u043E\u0432xs \u0444\u0430\u0441\u0435\u0442\u043F\u0435\u0440\u0435\u0447\u0438\u0441\u043B\u0435\u043D\u0438\u044Fxs \u0444\u0430\u0441\u0435\u0442\u043F\u0440\u043E\u0431\u0435\u043B\u044C\u043D\u044B\u0445\u0441\u0438\u043C\u0432\u043E\u043B\u043E\u0432xs \u0444\u0438\u043B\u044C\u0442\u0440\u0443\u0437\u043B\u043E\u0432dom \u0444\u043E\u0440\u043C\u0430\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u0430\u044F\u0441\u0442\u0440\u043E\u043A\u0430 \u0444\u043E\u0440\u043C\u0430\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u0439\u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442 \u0444\u0440\u0430\u0433\u043C\u0435\u043D\u0442xs \u0445\u0435\u0448\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435\u0434\u0430\u043D\u043D\u044B\u0445 \u0445\u0440\u0430\u043D\u0438\u043B\u0438\u0449\u0435\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u044F \u0446\u0432\u0435\u0442 \u0447\u0442\u0435\u043D\u0438\u0435fastinfoset \u0447\u0442\u0435\u043D\u0438\u0435html \u0447\u0442\u0435\u043D\u0438\u0435json \u0447\u0442\u0435\u043D\u0438\u0435xml \u0447\u0442\u0435\u043D\u0438\u0435zip\u0444\u0430\u0439\u043B\u0430 \u0447\u0442\u0435\u043D\u0438\u0435\u0434\u0430\u043D\u043D\u044B\u0445 \u0447\u0442\u0435\u043D\u0438\u0435\u0442\u0435\u043A\u0441\u0442\u0430 \u0447\u0442\u0435\u043D\u0438\u0435\u0443\u0437\u043B\u043E\u0432dom \u0448\u0440\u0438\u0444\u0442 \u044D\u043B\u0435\u043C\u0435\u043D\u0442\u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u0430\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 ";
    // v8 универсальные коллекции значений ==> type
    var v8_universal_collection = "comsafearray \u0434\u0435\u0440\u0435\u0432\u043E\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0439 \u043C\u0430\u0441\u0441\u0438\u0432 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0438\u0435 \u0441\u043F\u0438\u0441\u043E\u043A\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0439 \u0441\u0442\u0440\u0443\u043A\u0442\u0443\u0440\u0430 \u0442\u0430\u0431\u043B\u0438\u0446\u0430\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0439 \u0444\u0438\u043A\u0441\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u0430\u044F\u0441\u0442\u0440\u0443\u043A\u0442\u0443\u0440\u0430 \u0444\u0438\u043A\u0441\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u043E\u0435\u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0438\u0435 \u0444\u0438\u043A\u0441\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u0439\u043C\u0430\u0441\u0441\u0438\u0432 ";
    // type : встроенные типы
    var TYPE = v8_shared_object + v8_universal_collection;
    // literal : примитивные типы
    var LITERAL = "null \u0438\u0441\u0442\u0438\u043D\u0430 \u043B\u043E\u0436\u044C \u043D\u0435\u043E\u043F\u0440\u0435\u0434\u0435\u043B\u0435\u043D\u043E";
    // number : числа
    var NUMBERS = hljs.inherit(hljs.NUMBER_MODE);
    // string : строки
    var STRINGS = {
        className: "string",
        begin: '"|\\|',
        end: '"|$',
        contains: [
            {
                begin: '""'
            }
        ]
    };
    // number : даты
    var DATE = {
        begin: "'",
        end: "'",
        excludeBegin: true,
        excludeEnd: true,
        contains: [
            {
                className: "number",
                begin: "\\d{4}([\\.\\\\/:-]?\\d{2}){0,5}"
            }
        ]
    };
    // comment : комментарии
    var COMMENTS = hljs.inherit(hljs.C_LINE_COMMENT_MODE);
    // meta : инструкции препроцессора, директивы компиляции
    var META = {
        className: "meta",
        lexemes: UNDERSCORE_IDENT_RE,
        begin: "#|&",
        end: "$",
        keywords: {
            "meta-keyword": KEYWORD + METAKEYWORD
        },
        contains: [
            COMMENTS
        ]
    };
    // symbol : метка goto
    var SYMBOL = {
        className: "symbol",
        begin: "~",
        end: ";|:",
        excludeEnd: true
    };
    // function : объявление процедур и функций
    var FUNCTION = {
        className: "function",
        lexemes: UNDERSCORE_IDENT_RE,
        variants: [
            {
                begin: "\u043F\u0440\u043E\u0446\u0435\u0434\u0443\u0440\u0430|\u0444\u0443\u043D\u043A\u0446\u0438\u044F",
                end: "\\)",
                keywords: "\u043F\u0440\u043E\u0446\u0435\u0434\u0443\u0440\u0430 \u0444\u0443\u043D\u043A\u0446\u0438\u044F"
            },
            {
                begin: "\u043A\u043E\u043D\u0435\u0446\u043F\u0440\u043E\u0446\u0435\u0434\u0443\u0440\u044B|\u043A\u043E\u043D\u0435\u0446\u0444\u0443\u043D\u043A\u0446\u0438\u0438",
                keywords: "\u043A\u043E\u043D\u0435\u0446\u043F\u0440\u043E\u0446\u0435\u0434\u0443\u0440\u044B \u043A\u043E\u043D\u0435\u0446\u0444\u0443\u043D\u043A\u0446\u0438\u0438"
            }
        ],
        contains: [
            {
                begin: "\\(",
                end: "\\)",
                endsParent: true,
                contains: [
                    {
                        className: "params",
                        lexemes: UNDERSCORE_IDENT_RE,
                        begin: UNDERSCORE_IDENT_RE,
                        end: ",",
                        excludeEnd: true,
                        endsWithParent: true,
                        keywords: {
                            keyword: "\u0437\u043D\u0430\u0447",
                            literal: LITERAL
                        },
                        contains: [
                            NUMBERS,
                            STRINGS,
                            DATE
                        ]
                    },
                    COMMENTS
                ]
            },
            hljs.inherit(hljs.TITLE_MODE, {
                begin: UNDERSCORE_IDENT_RE
            })
        ]
    };
    return {
        case_insensitive: true,
        lexemes: UNDERSCORE_IDENT_RE,
        keywords: {
            keyword: KEYWORD,
            built_in: BUILTIN,
            class: CLASS,
            type: TYPE,
            literal: LITERAL
        },
        contains: [
            META,
            FUNCTION,
            COMMENTS,
            SYMBOL,
            NUMBERS,
            STRINGS,
            DATE
        ]
    };
};

});

parcelRegister("jzZa4", function(module, exports) {
module.exports = function(hljs) {
    var regexes = {
        ruleDeclaration: "^[a-zA-Z][a-zA-Z0-9-]*",
        unexpectedChars: "[!@#$^&',?+~`|:]"
    };
    var keywords = [
        "ALPHA",
        "BIT",
        "CHAR",
        "CR",
        "CRLF",
        "CTL",
        "DIGIT",
        "DQUOTE",
        "HEXDIG",
        "HTAB",
        "LF",
        "LWSP",
        "OCTET",
        "SP",
        "VCHAR",
        "WSP"
    ];
    var commentMode = hljs.COMMENT(";", "$");
    var terminalBinaryMode = {
        className: "symbol",
        begin: /%b[0-1]+(-[0-1]+|(\.[0-1]+)+){0,1}/
    };
    var terminalDecimalMode = {
        className: "symbol",
        begin: /%d[0-9]+(-[0-9]+|(\.[0-9]+)+){0,1}/
    };
    var terminalHexadecimalMode = {
        className: "symbol",
        begin: /%x[0-9A-F]+(-[0-9A-F]+|(\.[0-9A-F]+)+){0,1}/
    };
    var caseSensitivityIndicatorMode = {
        className: "symbol",
        begin: /%[si]/
    };
    var ruleDeclarationMode = {
        className: "attribute",
        begin: regexes.ruleDeclaration + "(?=\\s*=)"
    };
    return {
        illegal: regexes.unexpectedChars,
        keywords: keywords.join(" "),
        contains: [
            ruleDeclarationMode,
            commentMode,
            terminalBinaryMode,
            terminalDecimalMode,
            terminalHexadecimalMode,
            caseSensitivityIndicatorMode,
            hljs.QUOTE_STRING_MODE,
            hljs.NUMBER_MODE
        ]
    };
};

});

parcelRegister("ePTdO", function(module, exports) {
module.exports = function(hljs) {
    // https://developer.mozilla.org/en-US/docs/Web/HTTP/Methods
    var HTTP_VERBS = [
        "GET",
        "POST",
        "HEAD",
        "PUT",
        "DELETE",
        "CONNECT",
        "OPTIONS",
        "PATCH",
        "TRACE"
    ];
    return {
        contains: [
            // IP
            {
                className: "number",
                begin: "^\\d{1,3}\\.\\d{1,3}\\.\\d{1,3}\\.\\d{1,3}(:\\d{1,5})?\\b",
                relevance: 5
            },
            // Other numbers
            {
                className: "number",
                begin: "\\b\\d+\\b",
                relevance: 0
            },
            // Requests
            {
                className: "string",
                begin: '"(' + HTTP_VERBS.join("|") + ")",
                end: '"',
                keywords: HTTP_VERBS.join(" "),
                illegal: "\\n",
                relevance: 5,
                contains: [
                    {
                        begin: "HTTP/[12]\\.\\d",
                        relevance: 5
                    }
                ]
            },
            // Dates
            {
                className: "string",
                // dates must have a certain length, this prevents matching
                // simple array accesses a[123] and [] and other common patterns
                // found in other languages
                begin: /\[\d[^\]\n]{8,}\]/,
                illegal: "\\n",
                relevance: 1
            },
            {
                className: "string",
                begin: /\[/,
                end: /\]/,
                illegal: "\\n",
                relevance: 0
            },
            // User agent / relevance boost
            {
                className: "string",
                begin: '"Mozilla/\\d\\.\\d \\(',
                end: '"',
                illegal: "\\n",
                relevance: 3
            },
            // Strings
            {
                className: "string",
                begin: '"',
                end: '"',
                illegal: "\\n",
                relevance: 0
            }
        ]
    };
};

});

parcelRegister("jYOgV", function(module, exports) {
module.exports = function(hljs) {
    var IDENT_RE = "[a-zA-Z_$][a-zA-Z0-9_$]*";
    var IDENT_FUNC_RETURN_TYPE_RE = "([*]|[a-zA-Z_$][a-zA-Z0-9_$]*)";
    var AS3_REST_ARG_MODE = {
        className: "rest_arg",
        begin: "[.]{3}",
        end: IDENT_RE,
        relevance: 10
    };
    return {
        aliases: [
            "as"
        ],
        keywords: {
            keyword: "as break case catch class const continue default delete do dynamic each else extends final finally for function get if implements import in include instanceof interface internal is namespace native new override package private protected public return set static super switch this throw try typeof use var void while with",
            literal: "true false null undefined"
        },
        contains: [
            hljs.APOS_STRING_MODE,
            hljs.QUOTE_STRING_MODE,
            hljs.C_LINE_COMMENT_MODE,
            hljs.C_BLOCK_COMMENT_MODE,
            hljs.C_NUMBER_MODE,
            {
                className: "class",
                beginKeywords: "package",
                end: "{",
                contains: [
                    hljs.TITLE_MODE
                ]
            },
            {
                className: "class",
                beginKeywords: "class interface",
                end: "{",
                excludeEnd: true,
                contains: [
                    {
                        beginKeywords: "extends implements"
                    },
                    hljs.TITLE_MODE
                ]
            },
            {
                className: "meta",
                beginKeywords: "import include",
                end: ";",
                keywords: {
                    "meta-keyword": "import include"
                }
            },
            {
                className: "function",
                beginKeywords: "function",
                end: "[{;]",
                excludeEnd: true,
                illegal: "\\S",
                contains: [
                    hljs.TITLE_MODE,
                    {
                        className: "params",
                        begin: "\\(",
                        end: "\\)",
                        contains: [
                            hljs.APOS_STRING_MODE,
                            hljs.QUOTE_STRING_MODE,
                            hljs.C_LINE_COMMENT_MODE,
                            hljs.C_BLOCK_COMMENT_MODE,
                            AS3_REST_ARG_MODE
                        ]
                    },
                    {
                        begin: ":\\s*" + IDENT_FUNC_RETURN_TYPE_RE
                    }
                ]
            },
            hljs.METHOD_GUARD
        ],
        illegal: /#/
    };
};

});

parcelRegister("7wzO7", function(module, exports) {
module.exports = //
// We highlight all appearances of types, keywords, literals (string, char, number, bool)
// and titles (user defined function/procedure/package)
// CSS classes are set accordingly
//
// Languages causing problems for language detection:
// xml (broken by Foo : Bar type), elm (broken by Foo : Bar type), vbscript-html (broken by body keyword)
// sql (ada default.txt has a lot of sql keywords)
function(hljs) {
    // Regular expression for Ada numeric literals.
    // stolen form the VHDL highlighter
    // Decimal literal:
    var INTEGER_RE = "\\d(_|\\d)*";
    var EXPONENT_RE = "[eE][-+]?" + INTEGER_RE;
    var DECIMAL_LITERAL_RE = INTEGER_RE + "(\\." + INTEGER_RE + ")?" + "(" + EXPONENT_RE + ")?";
    // Based literal:
    var BASED_INTEGER_RE = "\\w+";
    var BASED_LITERAL_RE = INTEGER_RE + "#" + BASED_INTEGER_RE + "(\\." + BASED_INTEGER_RE + ")?" + "#" + "(" + EXPONENT_RE + ")?";
    var NUMBER_RE = "\\b(" + BASED_LITERAL_RE + "|" + DECIMAL_LITERAL_RE + ")";
    // Identifier regex
    var ID_REGEX = "[A-Za-z](_?[A-Za-z0-9.])*";
    // bad chars, only allowed in literals
    var BAD_CHARS = "[]{}%#'\"";
    // Ada doesn't have block comments, only line comments
    var COMMENTS = hljs.COMMENT("--", "$");
    // variable declarations of the form
    // Foo : Bar := Baz;
    // where only Bar will be highlighted
    var VAR_DECLS = {
        // TODO: These spaces are not required by the Ada syntax
        // however, I have yet to see handwritten Ada code where
        // someone does not put spaces around :
        begin: "\\s+:\\s+",
        end: "\\s*(:=|;|\\)|=>|$)",
        // endsWithParent: true,
        // returnBegin: true,
        illegal: BAD_CHARS,
        contains: [
            {
                // workaround to avoid highlighting
                // named loops and declare blocks
                beginKeywords: "loop for declare others",
                endsParent: true
            },
            {
                // properly highlight all modifiers
                className: "keyword",
                beginKeywords: "not null constant access function procedure in out aliased exception"
            },
            {
                className: "type",
                begin: ID_REGEX,
                endsParent: true,
                relevance: 0
            }
        ]
    };
    return {
        case_insensitive: true,
        keywords: {
            keyword: "abort else new return abs elsif not reverse abstract end accept entry select access exception of separate aliased exit or some all others subtype and for out synchronized array function overriding at tagged generic package task begin goto pragma terminate body private then if procedure type case in protected constant interface is raise use declare range delay limited record when delta loop rem while digits renames with do mod requeue xor",
            literal: "True False"
        },
        contains: [
            COMMENTS,
            // strings "foobar"
            {
                className: "string",
                begin: /"/,
                end: /"/,
                contains: [
                    {
                        begin: /""/,
                        relevance: 0
                    }
                ]
            },
            // characters ''
            {
                // character literals always contain one char
                className: "string",
                begin: /'.'/
            },
            {
                // number literals
                className: "number",
                begin: NUMBER_RE,
                relevance: 0
            },
            {
                // Attributes
                className: "symbol",
                begin: "'" + ID_REGEX
            },
            {
                // package definition, maybe inside generic
                className: "title",
                begin: "(\\bwith\\s+)?(\\bprivate\\s+)?\\bpackage\\s+(\\bbody\\s+)?",
                end: "(is|$)",
                keywords: "package body",
                excludeBegin: true,
                excludeEnd: true,
                illegal: BAD_CHARS
            },
            {
                // function/procedure declaration/definition
                // maybe inside generic
                begin: "(\\b(with|overriding)\\s+)?\\b(function|procedure)\\s+",
                end: "(\\bis|\\bwith|\\brenames|\\)\\s*;)",
                keywords: "overriding function procedure with is renames return",
                // we need to re-match the 'function' keyword, so that
                // the title mode below matches only exactly once
                returnBegin: true,
                contains: [
                    COMMENTS,
                    {
                        // name of the function/procedure
                        className: "title",
                        begin: "(\\bwith\\s+)?\\b(function|procedure)\\s+",
                        end: "(\\(|\\s+|$)",
                        excludeBegin: true,
                        excludeEnd: true,
                        illegal: BAD_CHARS
                    },
                    // 'self'
                    // // parameter types
                    VAR_DECLS,
                    {
                        // return type
                        className: "type",
                        begin: "\\breturn\\s+",
                        end: "(\\s+|;|$)",
                        keywords: "return",
                        excludeBegin: true,
                        excludeEnd: true,
                        // we are done with functions
                        endsParent: true,
                        illegal: BAD_CHARS
                    }
                ]
            },
            {
                // new type declarations
                // maybe inside generic
                className: "type",
                begin: "\\b(sub)?type\\s+",
                end: "\\s+",
                keywords: "type",
                excludeBegin: true,
                illegal: BAD_CHARS
            },
            // see comment above the definition
            VAR_DECLS
        ]
    };
};

});

parcelRegister("2PUwx", function(module, exports) {
module.exports = function(hljs) {
    var builtInTypeMode = {
        className: "built_in",
        begin: "\\b(void|bool|int|int8|int16|int32|int64|uint|uint8|uint16|uint32|uint64|string|ref|array|double|float|auto|dictionary)"
    };
    var objectHandleMode = {
        className: "symbol",
        begin: "[a-zA-Z0-9_]+@"
    };
    var genericMode = {
        className: "keyword",
        begin: "<",
        end: ">",
        contains: [
            builtInTypeMode,
            objectHandleMode
        ]
    };
    builtInTypeMode.contains = [
        genericMode
    ];
    objectHandleMode.contains = [
        genericMode
    ];
    return {
        aliases: [
            "asc"
        ],
        keywords: "for in|0 break continue while do|0 return if else case switch namespace is cast or and xor not get|0 in inout|10 out override set|0 private public const default|0 final shared external mixin|10 enum typedef funcdef this super import from interface abstract|0 try catch protected explicit property",
        // avoid close detection with C# and JS
        illegal: "(^using\\s+[A-Za-z0-9_\\.]+;$|\\bfunctions*[^\\(])",
        contains: [
            {
                className: "string",
                begin: "'",
                end: "'",
                illegal: "\\n",
                contains: [
                    hljs.BACKSLASH_ESCAPE
                ],
                relevance: 0
            },
            {
                className: "string",
                begin: '"',
                end: '"',
                illegal: "\\n",
                contains: [
                    hljs.BACKSLASH_ESCAPE
                ],
                relevance: 0
            },
            // """heredoc strings"""
            {
                className: "string",
                begin: '"""',
                end: '"""'
            },
            hljs.C_LINE_COMMENT_MODE,
            hljs.C_BLOCK_COMMENT_MODE,
            {
                beginKeywords: "interface namespace",
                end: "{",
                illegal: "[;.\\-]",
                contains: [
                    {
                        className: "symbol",
                        begin: "[a-zA-Z0-9_]+"
                    }
                ]
            },
            {
                beginKeywords: "class",
                end: "{",
                illegal: "[;.\\-]",
                contains: [
                    {
                        className: "symbol",
                        begin: "[a-zA-Z0-9_]+",
                        contains: [
                            {
                                begin: "[:,]\\s*",
                                contains: [
                                    {
                                        className: "symbol",
                                        begin: "[a-zA-Z0-9_]+"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            builtInTypeMode,
            objectHandleMode,
            {
                className: "literal",
                begin: "\\b(null|true|false)"
            },
            {
                className: "number",
                begin: "(-?)(\\b0[xX][a-fA-F0-9]+|(\\b\\d+(\\.\\d*)?f?|\\.\\d+f?)([eE][-+]?\\d+f?)?)"
            }
        ]
    };
};

});

parcelRegister("9hmTb", function(module, exports) {
module.exports = function(hljs) {
    var NUMBER = {
        className: "number",
        begin: "[\\$%]\\d+"
    };
    return {
        aliases: [
            "apacheconf"
        ],
        case_insensitive: true,
        contains: [
            hljs.HASH_COMMENT_MODE,
            {
                className: "section",
                begin: "</?",
                end: ">"
            },
            {
                className: "attribute",
                begin: /\w+/,
                relevance: 0,
                // keywords aren’t needed for highlighting per se, they only boost relevance
                // for a very generally defined mode (starts with a word, ends with line-end
                keywords: {
                    nomarkup: "order deny allow setenv rewriterule rewriteengine rewritecond documentroot sethandler errordocument loadmodule options header listen serverroot servername"
                },
                starts: {
                    end: /$/,
                    relevance: 0,
                    keywords: {
                        literal: "on off all"
                    },
                    contains: [
                        {
                            className: "meta",
                            begin: "\\s\\[",
                            end: "\\]$"
                        },
                        {
                            className: "variable",
                            begin: "[\\$%]\\{",
                            end: "\\}",
                            contains: [
                                "self",
                                NUMBER
                            ]
                        },
                        NUMBER,
                        hljs.QUOTE_STRING_MODE
                    ]
                }
            }
        ],
        illegal: /\S/
    };
};

});

parcelRegister("8Vvqc", function(module, exports) {
module.exports = function(hljs) {
    var STRING = hljs.inherit(hljs.QUOTE_STRING_MODE, {
        illegal: ""
    });
    var PARAMS = {
        className: "params",
        begin: "\\(",
        end: "\\)",
        contains: [
            "self",
            hljs.C_NUMBER_MODE,
            STRING
        ]
    };
    var COMMENT_MODE_1 = hljs.COMMENT("--", "$");
    var COMMENT_MODE_2 = hljs.COMMENT("\\(\\*", "\\*\\)", {
        contains: [
            "self",
            COMMENT_MODE_1
        ] //allow nesting
    });
    var COMMENTS = [
        COMMENT_MODE_1,
        COMMENT_MODE_2,
        hljs.HASH_COMMENT_MODE
    ];
    return {
        aliases: [
            "osascript"
        ],
        keywords: {
            keyword: "about above after against and around as at back before beginning behind below beneath beside between but by considering contain contains continue copy div does eighth else end equal equals error every exit fifth first for fourth from front get given global if ignoring in into is it its last local me middle mod my ninth not of on onto or over prop property put ref reference repeat returning script second set seventh since sixth some tell tenth that the|0 then third through thru timeout times to transaction try until where while whose with without",
            literal: "AppleScript false linefeed return pi quote result space tab true",
            built_in: "alias application boolean class constant date file integer list number real record string text activate beep count delay launch log offset read round run say summarize write character characters contents day frontmost id item length month name paragraph paragraphs rest reverse running time version weekday word words year"
        },
        contains: [
            STRING,
            hljs.C_NUMBER_MODE,
            {
                className: "built_in",
                begin: "\\b(clipboard info|the clipboard|info for|list (disks|folder)|mount volume|path to|(close|open for) access|(get|set) eof|current date|do shell script|get volume settings|random number|set volume|system attribute|system info|time to GMT|(load|run|store) script|scripting components|ASCII (character|number)|localized string|choose (application|color|file|file name|folder|from list|remote application|URL)|display (alert|dialog))\\b|^\\s*return\\b"
            },
            {
                className: "literal",
                begin: "\\b(text item delimiters|current application|missing value)\\b"
            },
            {
                className: "keyword",
                begin: "\\b(apart from|aside from|instead of|out of|greater than|isn't|(doesn't|does not) (equal|come before|come after|contain)|(greater|less) than( or equal)?|(starts?|ends|begins?) with|contained by|comes (before|after)|a (ref|reference)|POSIX file|POSIX path|(date|time) string|quoted form)\\b"
            },
            {
                beginKeywords: "on",
                illegal: "[${=;\\n]",
                contains: [
                    hljs.UNDERSCORE_TITLE_MODE,
                    PARAMS
                ]
            }
        ].concat(COMMENTS),
        illegal: "//|->|=>|\\[\\["
    };
};

});

parcelRegister("j1C1h", function(module, exports) {
module.exports = function(hljs) {
    var IDENT_RE = "[A-Za-z_][0-9A-Za-z_]*";
    var KEYWORDS = {
        keyword: "if for while var new function do return void else break",
        literal: "BackSlash DoubleQuote false ForwardSlash Infinity NaN NewLine null PI SingleQuote Tab TextFormatting true undefined",
        built_in: "Abs Acos Angle Attachments Area AreaGeodetic Asin Atan Atan2 Average Bearing Boolean Buffer BufferGeodetic Ceil Centroid Clip Console Constrain Contains Cos Count Crosses Cut Date DateAdd DateDiff Day Decode DefaultValue Dictionary Difference Disjoint Distance DistanceGeodetic Distinct DomainCode DomainName Equals Exp Extent Feature FeatureSet FeatureSetByAssociation FeatureSetById FeatureSetByPortalItem FeatureSetByRelationshipName FeatureSetByTitle FeatureSetByUrl Filter First Floor Geometry GroupBy Guid HasKey Hour IIf IndexOf Intersection Intersects IsEmpty IsNan IsSelfIntersecting Length LengthGeodetic Log Max Mean Millisecond Min Minute Month MultiPartToSinglePart Multipoint NextSequenceValue Now Number OrderBy Overlaps Point Polygon Polyline Portal Pow Random Relate Reverse RingIsClockWise Round Second SetGeometry Sin Sort Sqrt Stdev Sum SymmetricDifference Tan Text Timestamp Today ToLocal Top Touches ToUTC TrackCurrentTime TrackGeometryWindow TrackIndex TrackStartTime TrackWindow TypeOf Union UrlEncode Variance Weekday When Within Year "
    };
    var EXPRESSIONS;
    var SYMBOL = {
        className: "symbol",
        begin: "\\$[datastore|feature|layer|map|measure|sourcefeature|sourcelayer|targetfeature|targetlayer|value|view]+"
    };
    var NUMBER = {
        className: "number",
        variants: [
            {
                begin: "\\b(0[bB][01]+)"
            },
            {
                begin: "\\b(0[oO][0-7]+)"
            },
            {
                begin: hljs.C_NUMBER_RE
            }
        ],
        relevance: 0
    };
    var SUBST = {
        className: "subst",
        begin: "\\$\\{",
        end: "\\}",
        keywords: KEYWORDS,
        contains: [] // defined later
    };
    var TEMPLATE_STRING = {
        className: "string",
        begin: "`",
        end: "`",
        contains: [
            hljs.BACKSLASH_ESCAPE,
            SUBST
        ]
    };
    SUBST.contains = [
        hljs.APOS_STRING_MODE,
        hljs.QUOTE_STRING_MODE,
        TEMPLATE_STRING,
        NUMBER,
        hljs.REGEXP_MODE
    ];
    var PARAMS_CONTAINS = SUBST.contains.concat([
        hljs.C_BLOCK_COMMENT_MODE,
        hljs.C_LINE_COMMENT_MODE
    ]);
    return {
        aliases: [
            "arcade"
        ],
        keywords: KEYWORDS,
        contains: [
            hljs.APOS_STRING_MODE,
            hljs.QUOTE_STRING_MODE,
            TEMPLATE_STRING,
            hljs.C_LINE_COMMENT_MODE,
            hljs.C_BLOCK_COMMENT_MODE,
            SYMBOL,
            NUMBER,
            {
                begin: /[{,]\s*/,
                relevance: 0,
                contains: [
                    {
                        begin: IDENT_RE + "\\s*:",
                        returnBegin: true,
                        relevance: 0,
                        contains: [
                            {
                                className: "attr",
                                begin: IDENT_RE,
                                relevance: 0
                            }
                        ]
                    }
                ]
            },
            {
                begin: "(" + hljs.RE_STARTERS_RE + "|\\b(return)\\b)\\s*",
                keywords: "return",
                contains: [
                    hljs.C_LINE_COMMENT_MODE,
                    hljs.C_BLOCK_COMMENT_MODE,
                    hljs.REGEXP_MODE,
                    {
                        className: "function",
                        begin: "(\\(.*?\\)|" + IDENT_RE + ")\\s*=>",
                        returnBegin: true,
                        end: "\\s*=>",
                        contains: [
                            {
                                className: "params",
                                variants: [
                                    {
                                        begin: IDENT_RE
                                    },
                                    {
                                        begin: /\(\s*\)/
                                    },
                                    {
                                        begin: /\(/,
                                        end: /\)/,
                                        excludeBegin: true,
                                        excludeEnd: true,
                                        keywords: KEYWORDS,
                                        contains: PARAMS_CONTAINS
                                    }
                                ]
                            }
                        ]
                    }
                ],
                relevance: 0
            },
            {
                className: "function",
                beginKeywords: "function",
                end: /\{/,
                excludeEnd: true,
                contains: [
                    hljs.inherit(hljs.TITLE_MODE, {
                        begin: IDENT_RE
                    }),
                    {
                        className: "params",
                        begin: /\(/,
                        end: /\)/,
                        excludeBegin: true,
                        excludeEnd: true,
                        contains: PARAMS_CONTAINS
                    }
                ],
                illegal: /\[|%/
            },
            {
                begin: /\$[(.]/
            }
        ],
        illegal: /#(?!!)/
    };
};

});

parcelRegister("lmzvz", function(module, exports) {
module.exports = function(hljs) {
    function optional(s) {
        return "(?:" + s + ")?";
    }
    var DECLTYPE_AUTO_RE = "decltype\\(auto\\)";
    var NAMESPACE_RE = "[a-zA-Z_]\\w*::";
    var TEMPLATE_ARGUMENT_RE = "<.*?>";
    var FUNCTION_TYPE_RE = "(" + DECLTYPE_AUTO_RE + "|" + optional(NAMESPACE_RE) + "[a-zA-Z_]\\w*" + optional(TEMPLATE_ARGUMENT_RE) + ")";
    var CPP_PRIMITIVE_TYPES = {
        className: "keyword",
        begin: "\\b[a-z\\d_]*_t\\b"
    };
    // https://en.cppreference.com/w/cpp/language/escape
    // \\ \x \xFF \u2837 \u00323747 \374
    var CHARACTER_ESCAPES = "\\\\(x[0-9A-Fa-f]{2}|u[0-9A-Fa-f]{4,8}|[0-7]{3}|\\S)";
    var STRINGS = {
        className: "string",
        variants: [
            {
                begin: '(u8?|U|L)?"',
                end: '"',
                illegal: "\\n",
                contains: [
                    hljs.BACKSLASH_ESCAPE
                ]
            },
            {
                begin: "(u8?|U|L)?'(" + CHARACTER_ESCAPES + "|.)",
                end: "'",
                illegal: "."
            },
            {
                begin: /(?:u8?|U|L)?R"([^()\\ ]{0,16})\((?:.|\n)*?\)\1"/
            }
        ]
    };
    var NUMBERS = {
        className: "number",
        variants: [
            {
                begin: "\\b(0b[01']+)"
            },
            {
                begin: "(-?)\\b([\\d']+(\\.[\\d']*)?|\\.[\\d']+)(u|U|l|L|ul|UL|f|F|b|B)"
            },
            {
                begin: "(-?)(\\b0[xX][a-fA-F0-9']+|(\\b[\\d']+(\\.[\\d']*)?|\\.[\\d']+)([eE][-+]?[\\d']+)?)"
            }
        ],
        relevance: 0
    };
    var PREPROCESSOR = {
        className: "meta",
        begin: /#\s*[a-z]+\b/,
        end: /$/,
        keywords: {
            "meta-keyword": "if else elif endif define undef warning error line pragma _Pragma ifdef ifndef include"
        },
        contains: [
            {
                begin: /\\\n/,
                relevance: 0
            },
            hljs.inherit(STRINGS, {
                className: "meta-string"
            }),
            {
                className: "meta-string",
                begin: /<.*?>/,
                end: /$/,
                illegal: "\\n"
            },
            hljs.C_LINE_COMMENT_MODE,
            hljs.C_BLOCK_COMMENT_MODE
        ]
    };
    var TITLE_MODE = {
        className: "title",
        begin: optional(NAMESPACE_RE) + hljs.IDENT_RE,
        relevance: 0
    };
    var FUNCTION_TITLE = optional(NAMESPACE_RE) + hljs.IDENT_RE + "\\s*\\(";
    var CPP_KEYWORDS = {
        keyword: "int float while private char char8_t char16_t char32_t catch import module export virtual operator sizeof dynamic_cast|10 typedef const_cast|10 const for static_cast|10 union namespace unsigned long volatile static protected bool template mutable if public friend do goto auto void enum else break extern using asm case typeid wchar_tshort reinterpret_cast|10 default double register explicit signed typename try this switch continue inline delete alignas alignof constexpr consteval constinit decltype concept co_await co_return co_yield requires noexcept static_assert thread_local restrict final override atomic_bool atomic_char atomic_schar atomic_uchar atomic_short atomic_ushort atomic_int atomic_uint atomic_long atomic_ulong atomic_llong atomic_ullong new throw return and and_eq bitand bitor compl not not_eq or or_eq xor xor_eq",
        built_in: "std string wstring cin cout cerr clog stdin stdout stderr stringstream istringstream ostringstream auto_ptr deque list queue stack vector map set bitset multiset multimap unordered_set unordered_map unordered_multiset unordered_multimap array shared_ptr abort terminate abs acos asin atan2 atan calloc ceil cosh cos exit exp fabs floor fmod fprintf fputs free frexp fscanf future isalnum isalpha iscntrl isdigit isgraph islower isprint ispunct isspace isupper isxdigit tolower toupper labs ldexp log10 log malloc realloc memchr memcmp memcpy memset modf pow printf putchar puts scanf sinh sin snprintf sprintf sqrt sscanf strcat strchr strcmp strcpy strcspn strlen strncat strncmp strncpy strpbrk strrchr strspn strstr tanh tan vfprintf vprintf vsprintf endl initializer_list unique_ptr _Bool complex _Complex imaginary _Imaginary",
        literal: "true false nullptr NULL"
    };
    var EXPRESSION_CONTAINS = [
        CPP_PRIMITIVE_TYPES,
        hljs.C_LINE_COMMENT_MODE,
        hljs.C_BLOCK_COMMENT_MODE,
        NUMBERS,
        STRINGS
    ];
    var EXPRESSION_CONTEXT = {
        // This mode covers expression context where we can't expect a function
        // definition and shouldn't highlight anything that looks like one:
        // `return some()`, `else if()`, `(x*sum(1, 2))`
        variants: [
            {
                begin: /=/,
                end: /;/
            },
            {
                begin: /\(/,
                end: /\)/
            },
            {
                beginKeywords: "new throw return else",
                end: /;/
            }
        ],
        keywords: CPP_KEYWORDS,
        contains: EXPRESSION_CONTAINS.concat([
            {
                begin: /\(/,
                end: /\)/,
                keywords: CPP_KEYWORDS,
                contains: EXPRESSION_CONTAINS.concat([
                    "self"
                ]),
                relevance: 0
            }
        ]),
        relevance: 0
    };
    var FUNCTION_DECLARATION = {
        className: "function",
        begin: "(" + FUNCTION_TYPE_RE + "[\\*&\\s]+)+" + FUNCTION_TITLE,
        returnBegin: true,
        end: /[{;=]/,
        excludeEnd: true,
        keywords: CPP_KEYWORDS,
        illegal: /[^\w\s\*&:<>]/,
        contains: [
            {
                begin: DECLTYPE_AUTO_RE,
                keywords: CPP_KEYWORDS,
                relevance: 0
            },
            {
                begin: FUNCTION_TITLE,
                returnBegin: true,
                contains: [
                    TITLE_MODE
                ],
                relevance: 0
            },
            {
                className: "params",
                begin: /\(/,
                end: /\)/,
                keywords: CPP_KEYWORDS,
                relevance: 0,
                contains: [
                    hljs.C_LINE_COMMENT_MODE,
                    hljs.C_BLOCK_COMMENT_MODE,
                    STRINGS,
                    NUMBERS,
                    CPP_PRIMITIVE_TYPES,
                    // Count matching parentheses.
                    {
                        begin: /\(/,
                        end: /\)/,
                        keywords: CPP_KEYWORDS,
                        relevance: 0,
                        contains: [
                            "self",
                            hljs.C_LINE_COMMENT_MODE,
                            hljs.C_BLOCK_COMMENT_MODE,
                            STRINGS,
                            NUMBERS,
                            CPP_PRIMITIVE_TYPES
                        ]
                    }
                ]
            },
            CPP_PRIMITIVE_TYPES,
            hljs.C_LINE_COMMENT_MODE,
            hljs.C_BLOCK_COMMENT_MODE,
            PREPROCESSOR
        ]
    };
    return {
        aliases: [
            "c",
            "cc",
            "h",
            "c++",
            "h++",
            "hpp",
            "hh",
            "hxx",
            "cxx"
        ],
        keywords: CPP_KEYWORDS,
        illegal: "</",
        contains: [].concat(EXPRESSION_CONTEXT, FUNCTION_DECLARATION, EXPRESSION_CONTAINS, [
            PREPROCESSOR,
            {
                begin: "\\b(deque|list|queue|stack|vector|map|set|bitset|multiset|multimap|unordered_map|unordered_set|unordered_multiset|unordered_multimap|array)\\s*<",
                end: ">",
                keywords: CPP_KEYWORDS,
                contains: [
                    "self",
                    CPP_PRIMITIVE_TYPES
                ]
            },
            {
                begin: hljs.IDENT_RE + "::",
                keywords: CPP_KEYWORDS
            },
            {
                className: "class",
                beginKeywords: "class struct",
                end: /[{;:]/,
                contains: [
                    {
                        begin: /</,
                        end: />/,
                        contains: [
                            "self"
                        ]
                    },
                    hljs.TITLE_MODE
                ]
            }
        ]),
        exports: {
            preprocessor: PREPROCESSOR,
            strings: STRINGS,
            keywords: CPP_KEYWORDS
        }
    };
};

});

parcelRegister("hlBw7", function(module, exports) {
module.exports = function(hljs) {
    var ARDUINO_KW = {
        keyword: "boolean byte word String",
        built_in: "setup loopKeyboardController MouseController SoftwareSerial EthernetServer EthernetClient LiquidCrystal RobotControl GSMVoiceCall EthernetUDP EsploraTFT HttpClient RobotMotor WiFiClient GSMScanner FileSystem Scheduler GSMServer YunClient YunServer IPAddress GSMClient GSMModem Keyboard Ethernet Console GSMBand Esplora Stepper Process WiFiUDP GSM_SMS Mailbox USBHost Firmata PImage Client Server GSMPIN FileIO Bridge Serial EEPROM Stream Mouse Audio Servo File Task GPRS WiFi Wire TFT GSM SPI SD runShellCommandAsynchronously analogWriteResolution retrieveCallingNumber printFirmwareVersion analogReadResolution sendDigitalPortPair noListenOnLocalhost readJoystickButton setFirmwareVersion readJoystickSwitch scrollDisplayRight getVoiceCallStatus scrollDisplayLeft writeMicroseconds delayMicroseconds beginTransmission getSignalStrength runAsynchronously getAsynchronously listenOnLocalhost getCurrentCarrier readAccelerometer messageAvailable sendDigitalPorts lineFollowConfig countryNameWrite runShellCommand readStringUntil rewindDirectory readTemperature setClockDivider readLightSensor endTransmission analogReference detachInterrupt countryNameRead attachInterrupt encryptionType readBytesUntil robotNameWrite readMicrophone robotNameRead cityNameWrite userNameWrite readJoystickY readJoystickX mouseReleased openNextFile scanNetworks noInterrupts digitalWrite beginSpeaker mousePressed isActionDone mouseDragged displayLogos noAutoscroll addParameter remoteNumber getModifiers keyboardRead userNameRead waitContinue processInput parseCommand printVersion readNetworks writeMessage blinkVersion cityNameRead readMessage setDataMode parsePacket isListening setBitOrder beginPacket isDirectory motorsWrite drawCompass digitalRead clearScreen serialEvent rightToLeft setTextSize leftToRight requestFrom keyReleased compassRead analogWrite interrupts WiFiServer disconnect playMelody parseFloat autoscroll getPINUsed setPINUsed setTimeout sendAnalog readSlider analogRead beginWrite createChar motorsStop keyPressed tempoWrite readButton subnetMask debugPrint macAddress writeGreen randomSeed attachGPRS readString sendString remotePort releaseAll mouseMoved background getXChange getYChange answerCall getResult voiceCall endPacket constrain getSocket writeJSON getButton available connected findUntil readBytes exitValue readGreen writeBlue startLoop IPAddress isPressed sendSysex pauseMode gatewayIP setCursor getOemKey tuneWrite noDisplay loadImage switchPIN onRequest onReceive changePIN playFile noBuffer parseInt overflow checkPIN knobRead beginTFT bitClear updateIR bitWrite position writeRGB highByte writeRed setSpeed readBlue noStroke remoteIP transfer shutdown hangCall beginSMS endWrite attached maintain noCursor checkReg checkPUK shiftOut isValid shiftIn pulseIn connect println localIP pinMode getIMEI display noBlink process getBand running beginSD drawBMP lowByte setBand release bitRead prepare pointTo readRed setMode noFill remove listen stroke detach attach noTone exists buffer height bitSet circle config cursor random IRread setDNS endSMS getKey micros millis begin print write ready flush width isPIN blink clear press mkdir rmdir close point yield image BSSID click delay read text move peek beep rect line open seek fill size turn stop home find step tone sqrt RSSI SSID end bit tan cos sin pow map abs max min get run put",
        literal: "DIGITAL_MESSAGE FIRMATA_STRING ANALOG_MESSAGE REPORT_DIGITAL REPORT_ANALOG INPUT_PULLUP SET_PIN_MODE INTERNAL2V56 SYSTEM_RESET LED_BUILTIN INTERNAL1V1 SYSEX_START INTERNAL EXTERNAL DEFAULT OUTPUT INPUT HIGH LOW"
    };
    var ARDUINO = hljs.requireLanguage("cpp").rawDefinition();
    var kws = ARDUINO.keywords;
    kws.keyword += " " + ARDUINO_KW.keyword;
    kws.literal += " " + ARDUINO_KW.literal;
    kws.built_in += " " + ARDUINO_KW.built_in;
    return ARDUINO;
};

});

parcelRegister("dlNkY", function(module, exports) {
module.exports = function(hljs) {
    //local labels: %?[FB]?[AT]?\d{1,2}\w+
    return {
        case_insensitive: true,
        aliases: [
            "arm"
        ],
        lexemes: "\\.?" + hljs.IDENT_RE,
        keywords: {
            meta: //GNU preprocs
            ".2byte .4byte .align .ascii .asciz .balign .byte .code .data .else .end .endif .endm .endr .equ .err .exitm .extern .global .hword .if .ifdef .ifndef .include .irp .long .macro .rept .req .section .set .skip .space .text .word .arm .thumb .code16 .code32 .force_thumb .thumb_func .ltorg ALIAS ALIGN ARM AREA ASSERT ATTR CN CODE CODE16 CODE32 COMMON CP DATA DCB DCD DCDU DCDO DCFD DCFDU DCI DCQ DCQU DCW DCWU DN ELIF ELSE END ENDFUNC ENDIF ENDP ENTRY EQU EXPORT EXPORTAS EXTERN FIELD FILL FUNCTION GBLA GBLL GBLS GET GLOBAL IF IMPORT INCBIN INCLUDE INFO KEEP LCLA LCLL LCLS LTORG MACRO MAP MEND MEXIT NOFP OPT PRESERVE8 PROC QN READONLY RELOC REQUIRE REQUIRE8 RLIST FN ROUT SETA SETL SETS SN SPACE SUBT THUMB THUMBX TTL WHILE WEND ",
            built_in: "r0 r1 r2 r3 r4 r5 r6 r7 r8 r9 r10 r11 r12 r13 r14 r15 pc lr sp ip sl sb fp a1 a2 a3 a4 v1 v2 v3 v4 v5 v6 v7 v8 f0 f1 f2 f3 f4 f5 f6 f7 p0 p1 p2 p3 p4 p5 p6 p7 p8 p9 p10 p11 p12 p13 p14 p15 c0 c1 c2 c3 c4 c5 c6 c7 c8 c9 c10 c11 c12 c13 c14 c15 q0 q1 q2 q3 q4 q5 q6 q7 q8 q9 q10 q11 q12 q13 q14 q15 cpsr_c cpsr_x cpsr_s cpsr_f cpsr_cx cpsr_cxs cpsr_xs cpsr_xsf cpsr_sf cpsr_cxsf spsr_c spsr_x spsr_s spsr_f spsr_cx spsr_cxs spsr_xs spsr_xsf spsr_sf spsr_cxsf s0 s1 s2 s3 s4 s5 s6 s7 s8 s9 s10 s11 s12 s13 s14 s15 s16 s17 s18 s19 s20 s21 s22 s23 s24 s25 s26 s27 s28 s29 s30 s31 d0 d1 d2 d3 d4 d5 d6 d7 d8 d9 d10 d11 d12 d13 d14 d15 d16 d17 d18 d19 d20 d21 d22 d23 d24 d25 d26 d27 d28 d29 d30 d31 {PC} {VAR} {TRUE} {FALSE} {OPT} {CONFIG} {ENDIAN} {CODESIZE} {CPU} {FPU} {ARCHITECTURE} {PCSTOREOFFSET} {ARMASM_VERSION} {INTER} {ROPI} {RWPI} {SWST} {NOSWST} . @"
        },
        contains: [
            {
                className: "keyword",
                begin: "\\b(adc|(qd?|sh?|u[qh]?)?add(8|16)?|usada?8|(q|sh?|u[qh]?)?(as|sa)x|and|adrl?|sbc|rs[bc]|asr|b[lx]?|blx|bxj|cbn?z|tb[bh]|bic|bfc|bfi|[su]bfx|bkpt|cdp2?|clz|clrex|cmp|cmn|cpsi[ed]|cps|setend|dbg|dmb|dsb|eor|isb|it[te]{0,3}|lsl|lsr|ror|rrx|ldm(([id][ab])|f[ds])?|ldr((s|ex)?[bhd])?|movt?|mvn|mra|mar|mul|[us]mull|smul[bwt][bt]|smu[as]d|smmul|smmla|mla|umlaal|smlal?([wbt][bt]|d)|mls|smlsl?[ds]|smc|svc|sev|mia([bt]{2}|ph)?|mrr?c2?|mcrr2?|mrs|msr|orr|orn|pkh(tb|bt)|rbit|rev(16|sh)?|sel|[su]sat(16)?|nop|pop|push|rfe([id][ab])?|stm([id][ab])?|str(ex)?[bhd]?|(qd?)?sub|(sh?|q|u[qh]?)?sub(8|16)|[su]xt(a?h|a?b(16)?)|srs([id][ab])?|swpb?|swi|smi|tst|teq|wfe|wfi|yield)(eq|ne|cs|cc|mi|pl|vs|vc|hi|ls|ge|lt|gt|le|al|hs|lo)?[sptrx]?",
                end: "\\s"
            },
            hljs.COMMENT("[;@]", "$", {
                relevance: 0
            }),
            hljs.C_BLOCK_COMMENT_MODE,
            hljs.QUOTE_STRING_MODE,
            {
                className: "string",
                begin: "'",
                end: "[^\\\\]'",
                relevance: 0
            },
            {
                className: "title",
                begin: "\\|",
                end: "\\|",
                illegal: "\\n",
                relevance: 0
            },
            {
                className: "number",
                variants: [
                    {
                        begin: "[#$=]?0x[0-9a-f]+"
                    },
                    {
                        begin: "[#$=]?0b[01]+"
                    },
                    {
                        begin: "[#$=]\\d+"
                    },
                    {
                        begin: "\\b\\d+"
                    } //bare number
                ],
                relevance: 0
            },
            {
                className: "symbol",
                variants: [
                    {
                        begin: "^[a-z_\\.\\$][a-z0-9_\\.\\$]+"
                    },
                    {
                        begin: "^\\s*[a-z_\\.\\$][a-z0-9_\\.\\$]+:"
                    },
                    {
                        begin: "[=#]\\w+"
                    } //label reference
                ],
                relevance: 0
            }
        ]
    };
};

});

parcelRegister("kB1SH", function(module, exports) {
module.exports = function(hljs) {
    var XML_IDENT_RE = "[A-Za-z0-9\\._:-]+";
    var XML_ENTITIES = {
        className: "symbol",
        begin: "&[a-z]+;|&#[0-9]+;|&#x[a-f0-9]+;"
    };
    var XML_META_KEYWORDS = {
        begin: "\\s",
        contains: [
            {
                className: "meta-keyword",
                begin: "#?[a-z_][a-z1-9_-]+",
                illegal: "\\n"
            }
        ]
    };
    var XML_META_PAR_KEYWORDS = hljs.inherit(XML_META_KEYWORDS, {
        begin: "\\(",
        end: "\\)"
    });
    var APOS_META_STRING_MODE = hljs.inherit(hljs.APOS_STRING_MODE, {
        className: "meta-string"
    });
    var QUOTE_META_STRING_MODE = hljs.inherit(hljs.QUOTE_STRING_MODE, {
        className: "meta-string"
    });
    var TAG_INTERNALS = {
        endsWithParent: true,
        illegal: /</,
        relevance: 0,
        contains: [
            {
                className: "attr",
                begin: XML_IDENT_RE,
                relevance: 0
            },
            {
                begin: /=\s*/,
                relevance: 0,
                contains: [
                    {
                        className: "string",
                        endsParent: true,
                        variants: [
                            {
                                begin: /"/,
                                end: /"/,
                                contains: [
                                    XML_ENTITIES
                                ]
                            },
                            {
                                begin: /'/,
                                end: /'/,
                                contains: [
                                    XML_ENTITIES
                                ]
                            },
                            {
                                begin: /[^\s"'=<>`]+/
                            }
                        ]
                    }
                ]
            }
        ]
    };
    return {
        aliases: [
            "html",
            "xhtml",
            "rss",
            "atom",
            "xjb",
            "xsd",
            "xsl",
            "plist",
            "wsf",
            "svg"
        ],
        case_insensitive: true,
        contains: [
            {
                className: "meta",
                begin: "<![a-z]",
                end: ">",
                relevance: 10,
                contains: [
                    XML_META_KEYWORDS,
                    QUOTE_META_STRING_MODE,
                    APOS_META_STRING_MODE,
                    XML_META_PAR_KEYWORDS,
                    {
                        begin: "\\[",
                        end: "\\]",
                        contains: [
                            {
                                className: "meta",
                                begin: "<![a-z]",
                                end: ">",
                                contains: [
                                    XML_META_KEYWORDS,
                                    XML_META_PAR_KEYWORDS,
                                    QUOTE_META_STRING_MODE,
                                    APOS_META_STRING_MODE
                                ]
                            }
                        ]
                    }
                ]
            },
            hljs.COMMENT("<!--", "-->", {
                relevance: 10
            }),
            {
                begin: "<\\!\\[CDATA\\[",
                end: "\\]\\]>",
                relevance: 10
            },
            XML_ENTITIES,
            {
                className: "meta",
                begin: /<\?xml/,
                end: /\?>/,
                relevance: 10
            },
            {
                begin: /<\?(php)?/,
                end: /\?>/,
                subLanguage: "php",
                contains: [
                    // We don't want the php closing tag ?> to close the PHP block when
                    // inside any of the following blocks:
                    {
                        begin: "/\\*",
                        end: "\\*/",
                        skip: true
                    },
                    {
                        begin: 'b"',
                        end: '"',
                        skip: true
                    },
                    {
                        begin: "b'",
                        end: "'",
                        skip: true
                    },
                    hljs.inherit(hljs.APOS_STRING_MODE, {
                        illegal: null,
                        className: null,
                        contains: null,
                        skip: true
                    }),
                    hljs.inherit(hljs.QUOTE_STRING_MODE, {
                        illegal: null,
                        className: null,
                        contains: null,
                        skip: true
                    })
                ]
            },
            {
                className: "tag",
                /*
        The lookahead pattern (?=...) ensures that 'begin' only matches
        '<style' as a single word, followed by a whitespace or an
        ending braket. The '$' is needed for the lexeme to be recognized
        by hljs.subMode() that tests lexemes outside the stream.
        */ begin: "<style(?=\\s|>)",
                end: ">",
                keywords: {
                    name: "style"
                },
                contains: [
                    TAG_INTERNALS
                ],
                starts: {
                    end: "</style>",
                    returnEnd: true,
                    subLanguage: [
                        "css",
                        "xml"
                    ]
                }
            },
            {
                className: "tag",
                // See the comment in the <style tag about the lookahead pattern
                begin: "<script(?=\\s|>)",
                end: ">",
                keywords: {
                    name: "script"
                },
                contains: [
                    TAG_INTERNALS
                ],
                starts: {
                    end: "</script>",
                    returnEnd: true,
                    subLanguage: [
                        "actionscript",
                        "javascript",
                        "handlebars",
                        "xml"
                    ]
                }
            },
            {
                className: "tag",
                begin: "</?",
                end: "/?>",
                contains: [
                    {
                        className: "name",
                        begin: /[^\/><\s]+/,
                        relevance: 0
                    },
                    TAG_INTERNALS
                ]
            }
        ]
    };
};

});

parcelRegister("gkbm1", function(module, exports) {
module.exports = function(hljs) {
    return {
        aliases: [
            "adoc"
        ],
        contains: [
            // block comment
            hljs.COMMENT("^/{4,}\\n", "\\n/{4,}$", // can also be done as...
            //'^/{4,}$',
            //'^/{4,}$',
            {
                relevance: 10
            }),
            // line comment
            hljs.COMMENT("^//", "$", {
                relevance: 0
            }),
            // title
            {
                className: "title",
                begin: "^\\.\\w.*$"
            },
            // example, admonition & sidebar blocks
            {
                begin: "^[=\\*]{4,}\\n",
                end: "\\n^[=\\*]{4,}$",
                relevance: 10
            },
            // headings
            {
                className: "section",
                relevance: 10,
                variants: [
                    {
                        begin: "^(={1,5}) .+?( \\1)?$"
                    },
                    {
                        begin: "^[^\\[\\]\\n]+?\\n[=\\-~\\^\\+]{2,}$"
                    }
                ]
            },
            // document attributes
            {
                className: "meta",
                begin: "^:.+?:",
                end: "\\s",
                excludeEnd: true,
                relevance: 10
            },
            // block attributes
            {
                className: "meta",
                begin: "^\\[.+?\\]$",
                relevance: 0
            },
            // quoteblocks
            {
                className: "quote",
                begin: "^_{4,}\\n",
                end: "\\n_{4,}$",
                relevance: 10
            },
            // listing and literal blocks
            {
                className: "code",
                begin: "^[\\-\\.]{4,}\\n",
                end: "\\n[\\-\\.]{4,}$",
                relevance: 10
            },
            // passthrough blocks
            {
                begin: "^\\+{4,}\\n",
                end: "\\n\\+{4,}$",
                contains: [
                    {
                        begin: "<",
                        end: ">",
                        subLanguage: "xml",
                        relevance: 0
                    }
                ],
                relevance: 10
            },
            // lists (can only capture indicators)
            {
                className: "bullet",
                begin: "^(\\*+|\\-+|\\.+|[^\\n]+?::)\\s+"
            },
            // admonition
            {
                className: "symbol",
                begin: "^(NOTE|TIP|IMPORTANT|WARNING|CAUTION):\\s+",
                relevance: 10
            },
            // inline strong
            {
                className: "strong",
                // must not follow a word character or be followed by an asterisk or space
                begin: "\\B\\*(?![\\*\\s])",
                end: "(\\n{2}|\\*)",
                // allow escaped asterisk followed by word char
                contains: [
                    {
                        begin: "\\\\*\\w",
                        relevance: 0
                    }
                ]
            },
            // inline emphasis
            {
                className: "emphasis",
                // must not follow a word character or be followed by a single quote or space
                begin: "\\B'(?!['\\s])",
                end: "(\\n{2}|')",
                // allow escaped single quote followed by word char
                contains: [
                    {
                        begin: "\\\\'\\w",
                        relevance: 0
                    }
                ],
                relevance: 0
            },
            // inline emphasis (alt)
            {
                className: "emphasis",
                // must not follow a word character or be followed by an underline or space
                begin: "_(?![_\\s])",
                end: "(\\n{2}|_)",
                relevance: 0
            },
            // inline smart quotes
            {
                className: "string",
                variants: [
                    {
                        begin: "``.+?''"
                    },
                    {
                        begin: "`.+?'"
                    }
                ]
            },
            // inline code snippets (TODO should get same treatment as strong and emphasis)
            {
                className: "code",
                begin: "(`.+?`|\\+.+?\\+)",
                relevance: 0
            },
            // indented literal block
            {
                className: "code",
                begin: "^[ \\t]",
                end: "$",
                relevance: 0
            },
            // horizontal rules
            {
                begin: "^'{3,}[ \\t]*$",
                relevance: 10
            },
            // images and links
            {
                begin: "(link:)?(http|https|ftp|file|irc|image:?):\\S+\\[.*?\\]",
                returnBegin: true,
                contains: [
                    {
                        begin: "(link|image:?):",
                        relevance: 0
                    },
                    {
                        className: "link",
                        begin: "\\w",
                        end: "[^\\[]+",
                        relevance: 0
                    },
                    {
                        className: "string",
                        begin: "\\[",
                        end: "\\]",
                        excludeBegin: true,
                        excludeEnd: true,
                        relevance: 0
                    }
                ],
                relevance: 10
            }
        ]
    };
};

});

parcelRegister("63yFf", function(module, exports) {
module.exports = function(hljs) {
    var KEYWORDS = "false synchronized int abstract float private char boolean static null if const for true while long throw strictfp finally protected import native final return void enum else extends implements break transient new catch instanceof byte super volatile case assert short package default double public try this switch continue throws privileged aspectOf adviceexecution proceed cflowbelow cflow initialization preinitialization staticinitialization withincode target within execution getWithinTypeName handler thisJoinPoint thisJoinPointStaticPart thisEnclosingJoinPointStaticPart declare parents warning error soft precedence thisAspectInstance";
    var SHORTKEYS = "get set args call";
    return {
        keywords: KEYWORDS,
        illegal: /<\/|#/,
        contains: [
            hljs.COMMENT("/\\*\\*", "\\*/", {
                relevance: 0,
                contains: [
                    {
                        // eat up @'s in emails to prevent them to be recognized as doctags
                        begin: /\w+@/,
                        relevance: 0
                    },
                    {
                        className: "doctag",
                        begin: "@[A-Za-z]+"
                    }
                ]
            }),
            hljs.C_LINE_COMMENT_MODE,
            hljs.C_BLOCK_COMMENT_MODE,
            hljs.APOS_STRING_MODE,
            hljs.QUOTE_STRING_MODE,
            {
                className: "class",
                beginKeywords: "aspect",
                end: /[{;=]/,
                excludeEnd: true,
                illegal: /[:;"\[\]]/,
                contains: [
                    {
                        beginKeywords: "extends implements pertypewithin perthis pertarget percflowbelow percflow issingleton"
                    },
                    hljs.UNDERSCORE_TITLE_MODE,
                    {
                        begin: /\([^\)]*/,
                        end: /[)]+/,
                        keywords: KEYWORDS + " " + SHORTKEYS,
                        excludeEnd: false
                    }
                ]
            },
            {
                className: "class",
                beginKeywords: "class interface",
                end: /[{;=]/,
                excludeEnd: true,
                relevance: 0,
                keywords: "class interface",
                illegal: /[:"\[\]]/,
                contains: [
                    {
                        beginKeywords: "extends implements"
                    },
                    hljs.UNDERSCORE_TITLE_MODE
                ]
            },
            {
                // AspectJ Constructs
                beginKeywords: "pointcut after before around throwing returning",
                end: /[)]/,
                excludeEnd: false,
                illegal: /["\[\]]/,
                contains: [
                    {
                        begin: hljs.UNDERSCORE_IDENT_RE + "\\s*\\(",
                        returnBegin: true,
                        contains: [
                            hljs.UNDERSCORE_TITLE_MODE
                        ]
                    }
                ]
            },
            {
                begin: /[:]/,
                returnBegin: true,
                end: /[{;]/,
                relevance: 0,
                excludeEnd: false,
                keywords: KEYWORDS,
                illegal: /["\[\]]/,
                contains: [
                    {
                        begin: hljs.UNDERSCORE_IDENT_RE + "\\s*\\(",
                        keywords: KEYWORDS + " " + SHORTKEYS,
                        relevance: 0
                    },
                    hljs.QUOTE_STRING_MODE
                ]
            },
            {
                // this prevents 'new Name(...), or throw ...' from being recognized as a function definition
                beginKeywords: "new throw",
                relevance: 0
            },
            {
                // the function class is a bit different for AspectJ compared to the Java language
                className: "function",
                begin: /\w+ +\w+(\.)?\w+\s*\([^\)]*\)\s*((throws)[\w\s,]+)?[\{;]/,
                returnBegin: true,
                end: /[{;=]/,
                keywords: KEYWORDS,
                excludeEnd: true,
                contains: [
                    {
                        begin: hljs.UNDERSCORE_IDENT_RE + "\\s*\\(",
                        returnBegin: true,
                        relevance: 0,
                        contains: [
                            hljs.UNDERSCORE_TITLE_MODE
                        ]
                    },
                    {
                        className: "params",
                        begin: /\(/,
                        end: /\)/,
                        relevance: 0,
                        keywords: KEYWORDS,
                        contains: [
                            hljs.APOS_STRING_MODE,
                            hljs.QUOTE_STRING_MODE,
                            hljs.C_NUMBER_MODE,
                            hljs.C_BLOCK_COMMENT_MODE
                        ]
                    },
                    hljs.C_LINE_COMMENT_MODE,
                    hljs.C_BLOCK_COMMENT_MODE
                ]
            },
            hljs.C_NUMBER_MODE,
            {
                // annotation is also used in this language
                className: "meta",
                begin: "@[A-Za-z]+"
            }
        ]
    };
};

});

parcelRegister("8BAsx", function(module, exports) {
module.exports = function(hljs) {
    var BACKTICK_ESCAPE = {
        begin: "`[\\s\\S]"
    };
    return {
        case_insensitive: true,
        aliases: [
            "ahk"
        ],
        keywords: {
            keyword: "Break Continue Critical Exit ExitApp Gosub Goto New OnExit Pause return SetBatchLines SetTimer Suspend Thread Throw Until ahk_id ahk_class ahk_pid ahk_exe ahk_group",
            literal: "true false NOT AND OR",
            built_in: "ComSpec Clipboard ClipboardAll ErrorLevel"
        },
        contains: [
            BACKTICK_ESCAPE,
            hljs.inherit(hljs.QUOTE_STRING_MODE, {
                contains: [
                    BACKTICK_ESCAPE
                ]
            }),
            hljs.COMMENT(";", "$", {
                relevance: 0
            }),
            hljs.C_BLOCK_COMMENT_MODE,
            {
                className: "number",
                begin: hljs.NUMBER_RE,
                relevance: 0
            },
            {
                className: "variable",
                begin: "%[a-zA-Z0-9#_$@]+%"
            },
            {
                className: "built_in",
                begin: "^\\s*\\w+\\s*(,|%)"
            },
            {
                className: "title",
                //meaning that it would fail to highlight anything
                variants: [
                    {
                        begin: '^[^\\n";]+::(?!=)'
                    },
                    {
                        begin: '^[^\\n";]+:(?!=)',
                        relevance: 0
                    } // zero relevance as it catches a lot of things
                ]
            },
            {
                className: "meta",
                begin: "^\\s*#\\w+",
                end: "$",
                relevance: 0
            },
            {
                className: "built_in",
                begin: "A_[a-zA-Z0-9]+"
            },
            {
                // consecutive commas, not for highlighting but just for relevance
                begin: ",\\s*,"
            }
        ]
    };
};

});

parcelRegister("hfevr", function(module, exports) {
module.exports = function(hljs) {
    var KEYWORDS = "ByRef Case Const ContinueCase ContinueLoop Default Dim Do Else ElseIf EndFunc EndIf EndSelect EndSwitch EndWith Enum Exit ExitLoop For Func Global If In Local Next ReDim Return Select Static Step Switch Then To Until Volatile WEnd While With", LITERAL = "True False And Null Not Or", BUILT_IN = "Abs ACos AdlibRegister AdlibUnRegister Asc AscW ASin Assign ATan AutoItSetOption AutoItWinGetTitle AutoItWinSetTitle Beep Binary BinaryLen BinaryMid BinaryToString BitAND BitNOT BitOR BitRotate BitShift BitXOR BlockInput Break Call CDTray Ceiling Chr ChrW ClipGet ClipPut ConsoleRead ConsoleWrite ConsoleWriteError ControlClick ControlCommand ControlDisable ControlEnable ControlFocus ControlGetFocus ControlGetHandle ControlGetPos ControlGetText ControlHide ControlListView ControlMove ControlSend ControlSetText ControlShow ControlTreeView Cos Dec DirCopy DirCreate DirGetSize DirMove DirRemove DllCall DllCallAddress DllCallbackFree DllCallbackGetPtr DllCallbackRegister DllClose DllOpen DllStructCreate DllStructGetData DllStructGetPtr DllStructGetSize DllStructSetData DriveGetDrive DriveGetFileSystem DriveGetLabel DriveGetSerial DriveGetType DriveMapAdd DriveMapDel DriveMapGet DriveSetLabel DriveSpaceFree DriveSpaceTotal DriveStatus EnvGet EnvSet EnvUpdate Eval Execute Exp FileChangeDir FileClose FileCopy FileCreateNTFSLink FileCreateShortcut FileDelete FileExists FileFindFirstFile FileFindNextFile FileFlush FileGetAttrib FileGetEncoding FileGetLongName FileGetPos FileGetShortcut FileGetShortName FileGetSize FileGetTime FileGetVersion FileInstall FileMove FileOpen FileOpenDialog FileRead FileReadLine FileReadToArray FileRecycle FileRecycleEmpty FileSaveDialog FileSelectFolder FileSetAttrib FileSetEnd FileSetPos FileSetTime FileWrite FileWriteLine Floor FtpSetProxy FuncName GUICreate GUICtrlCreateAvi GUICtrlCreateButton GUICtrlCreateCheckbox GUICtrlCreateCombo GUICtrlCreateContextMenu GUICtrlCreateDate GUICtrlCreateDummy GUICtrlCreateEdit GUICtrlCreateGraphic GUICtrlCreateGroup GUICtrlCreateIcon GUICtrlCreateInput GUICtrlCreateLabel GUICtrlCreateList GUICtrlCreateListView GUICtrlCreateListViewItem GUICtrlCreateMenu GUICtrlCreateMenuItem GUICtrlCreateMonthCal GUICtrlCreateObj GUICtrlCreatePic GUICtrlCreateProgress GUICtrlCreateRadio GUICtrlCreateSlider GUICtrlCreateTab GUICtrlCreateTabItem GUICtrlCreateTreeView GUICtrlCreateTreeViewItem GUICtrlCreateUpdown GUICtrlDelete GUICtrlGetHandle GUICtrlGetState GUICtrlRead GUICtrlRecvMsg GUICtrlRegisterListViewSort GUICtrlSendMsg GUICtrlSendToDummy GUICtrlSetBkColor GUICtrlSetColor GUICtrlSetCursor GUICtrlSetData GUICtrlSetDefBkColor GUICtrlSetDefColor GUICtrlSetFont GUICtrlSetGraphic GUICtrlSetImage GUICtrlSetLimit GUICtrlSetOnEvent GUICtrlSetPos GUICtrlSetResizing GUICtrlSetState GUICtrlSetStyle GUICtrlSetTip GUIDelete GUIGetCursorInfo GUIGetMsg GUIGetStyle GUIRegisterMsg GUISetAccelerators GUISetBkColor GUISetCoord GUISetCursor GUISetFont GUISetHelp GUISetIcon GUISetOnEvent GUISetState GUISetStyle GUIStartGroup GUISwitch Hex HotKeySet HttpSetProxy HttpSetUserAgent HWnd InetClose InetGet InetGetInfo InetGetSize InetRead IniDelete IniRead IniReadSection IniReadSectionNames IniRenameSection IniWrite IniWriteSection InputBox Int IsAdmin IsArray IsBinary IsBool IsDeclared IsDllStruct IsFloat IsFunc IsHWnd IsInt IsKeyword IsNumber IsObj IsPtr IsString Log MemGetStats Mod MouseClick MouseClickDrag MouseDown MouseGetCursor MouseGetPos MouseMove MouseUp MouseWheel MsgBox Number ObjCreate ObjCreateInterface ObjEvent ObjGet ObjName OnAutoItExitRegister OnAutoItExitUnRegister Ping PixelChecksum PixelGetColor PixelSearch ProcessClose ProcessExists ProcessGetStats ProcessList ProcessSetPriority ProcessWait ProcessWaitClose ProgressOff ProgressOn ProgressSet Ptr Random RegDelete RegEnumKey RegEnumVal RegRead RegWrite Round Run RunAs RunAsWait RunWait Send SendKeepActive SetError SetExtended ShellExecute ShellExecuteWait Shutdown Sin Sleep SoundPlay SoundSetWaveVolume SplashImageOn SplashOff SplashTextOn Sqrt SRandom StatusbarGetText StderrRead StdinWrite StdioClose StdoutRead String StringAddCR StringCompare StringFormat StringFromASCIIArray StringInStr StringIsAlNum StringIsAlpha StringIsASCII StringIsDigit StringIsFloat StringIsInt StringIsLower StringIsSpace StringIsUpper StringIsXDigit StringLeft StringLen StringLower StringMid StringRegExp StringRegExpReplace StringReplace StringReverse StringRight StringSplit StringStripCR StringStripWS StringToASCIIArray StringToBinary StringTrimLeft StringTrimRight StringUpper Tan TCPAccept TCPCloseSocket TCPConnect TCPListen TCPNameToIP TCPRecv TCPSend TCPShutdown, UDPShutdown TCPStartup, UDPStartup TimerDiff TimerInit ToolTip TrayCreateItem TrayCreateMenu TrayGetMsg TrayItemDelete TrayItemGetHandle TrayItemGetState TrayItemGetText TrayItemSetOnEvent TrayItemSetState TrayItemSetText TraySetClick TraySetIcon TraySetOnEvent TraySetPauseIcon TraySetState TraySetToolTip TrayTip UBound UDPBind UDPCloseSocket UDPOpen UDPRecv UDPSend VarGetType WinActivate WinActive WinClose WinExists WinFlash WinGetCaretPos WinGetClassList WinGetClientSize WinGetHandle WinGetPos WinGetProcess WinGetState WinGetText WinGetTitle WinKill WinList WinMenuSelectItem WinMinimizeAll WinMinimizeAllUndo WinMove WinSetOnTop WinSetState WinSetTitle WinSetTrans WinWait", COMMENT = {
        variants: [
            hljs.COMMENT(";", "$", {
                relevance: 0
            }),
            hljs.COMMENT("#cs", "#ce"),
            hljs.COMMENT("#comments-start", "#comments-end")
        ]
    }, VARIABLE = {
        begin: "\\$[A-z0-9_]+"
    }, STRING = {
        className: "string",
        variants: [
            {
                begin: /"/,
                end: /"/,
                contains: [
                    {
                        begin: /""/,
                        relevance: 0
                    }
                ]
            },
            {
                begin: /'/,
                end: /'/,
                contains: [
                    {
                        begin: /''/,
                        relevance: 0
                    }
                ]
            }
        ]
    }, NUMBER = {
        variants: [
            hljs.BINARY_NUMBER_MODE,
            hljs.C_NUMBER_MODE
        ]
    }, PREPROCESSOR = {
        className: "meta",
        begin: "#",
        end: "$",
        keywords: {
            "meta-keyword": "comments include include-once NoTrayIcon OnAutoItStartRegister pragma compile RequireAdmin"
        },
        contains: [
            {
                begin: /\\\n/,
                relevance: 0
            },
            {
                beginKeywords: "include",
                keywords: {
                    "meta-keyword": "include"
                },
                end: "$",
                contains: [
                    STRING,
                    {
                        className: "meta-string",
                        variants: [
                            {
                                begin: "<",
                                end: ">"
                            },
                            {
                                begin: /"/,
                                end: /"/,
                                contains: [
                                    {
                                        begin: /""/,
                                        relevance: 0
                                    }
                                ]
                            },
                            {
                                begin: /'/,
                                end: /'/,
                                contains: [
                                    {
                                        begin: /''/,
                                        relevance: 0
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            STRING,
            COMMENT
        ]
    }, CONSTANT = {
        className: "symbol",
        // begin: '@',
        // end: '$',
        // keywords: 'AppDataCommonDir AppDataDir AutoItExe AutoItPID AutoItVersion AutoItX64 COM_EventObj CommonFilesDir Compiled ComputerName ComSpec CPUArch CR CRLF DesktopCommonDir DesktopDepth DesktopDir DesktopHeight DesktopRefresh DesktopWidth DocumentsCommonDir error exitCode exitMethod extended FavoritesCommonDir FavoritesDir GUI_CtrlHandle GUI_CtrlId GUI_DragFile GUI_DragId GUI_DropId GUI_WinHandle HomeDrive HomePath HomeShare HotKeyPressed HOUR IPAddress1 IPAddress2 IPAddress3 IPAddress4 KBLayout LF LocalAppDataDir LogonDNSDomain LogonDomain LogonServer MDAY MIN MON MSEC MUILang MyDocumentsDir NumParams OSArch OSBuild OSLang OSServicePack OSType OSVersion ProgramFilesDir ProgramsCommonDir ProgramsDir ScriptDir ScriptFullPath ScriptLineNumber ScriptName SEC StartMenuCommonDir StartMenuDir StartupCommonDir StartupDir SW_DISABLE SW_ENABLE SW_HIDE SW_LOCK SW_MAXIMIZE SW_MINIMIZE SW_RESTORE SW_SHOW SW_SHOWDEFAULT SW_SHOWMAXIMIZED SW_SHOWMINIMIZED SW_SHOWMINNOACTIVE SW_SHOWNA SW_SHOWNOACTIVATE SW_SHOWNORMAL SW_UNLOCK SystemDir TAB TempDir TRAY_ID TrayIconFlashing TrayIconVisible UserName UserProfileDir WDAY WindowsDir WorkingDir YDAY YEAR',
        // relevance: 5
        begin: "@[A-z0-9_]+"
    }, FUNCTION = {
        className: "function",
        beginKeywords: "Func",
        end: "$",
        illegal: "\\$|\\[|%",
        contains: [
            hljs.UNDERSCORE_TITLE_MODE,
            {
                className: "params",
                begin: "\\(",
                end: "\\)",
                contains: [
                    VARIABLE,
                    STRING,
                    NUMBER
                ]
            }
        ]
    };
    return {
        case_insensitive: true,
        illegal: /\/\*/,
        keywords: {
            keyword: KEYWORDS,
            built_in: BUILT_IN,
            literal: LITERAL
        },
        contains: [
            COMMENT,
            VARIABLE,
            STRING,
            NUMBER,
            PREPROCESSOR,
            CONSTANT,
            FUNCTION
        ]
    };
};

});

parcelRegister("6w0Vy", function(module, exports) {
module.exports = function(hljs) {
    return {
        case_insensitive: true,
        lexemes: "\\.?" + hljs.IDENT_RE,
        keywords: {
            keyword: /* mnemonic */ "adc add adiw and andi asr bclr bld brbc brbs brcc brcs break breq brge brhc brhs brid brie brlo brlt brmi brne brpl brsh brtc brts brvc brvs bset bst call cbi cbr clc clh cli cln clr cls clt clv clz com cp cpc cpi cpse dec eicall eijmp elpm eor fmul fmuls fmulsu icall ijmp in inc jmp ld ldd ldi lds lpm lsl lsr mov movw mul muls mulsu neg nop or ori out pop push rcall ret reti rjmp rol ror sbc sbr sbrc sbrs sec seh sbi sbci sbic sbis sbiw sei sen ser ses set sev sez sleep spm st std sts sub subi swap tst wdr",
            built_in: /* general purpose registers */ "r0 r1 r2 r3 r4 r5 r6 r7 r8 r9 r10 r11 r12 r13 r14 r15 r16 r17 r18 r19 r20 r21 r22 r23 r24 r25 r26 r27 r28 r29 r30 r31 x|0 xh xl y|0 yh yl z|0 zh zl ucsr1c udr1 ucsr1a ucsr1b ubrr1l ubrr1h ucsr0c ubrr0h tccr3c tccr3a tccr3b tcnt3h tcnt3l ocr3ah ocr3al ocr3bh ocr3bl ocr3ch ocr3cl icr3h icr3l etimsk etifr tccr1c ocr1ch ocr1cl twcr twdr twar twsr twbr osccal xmcra xmcrb eicra spmcsr spmcr portg ddrg ping portf ddrf sreg sph spl xdiv rampz eicrb eimsk gimsk gicr eifr gifr timsk tifr mcucr mcucsr tccr0 tcnt0 ocr0 assr tccr1a tccr1b tcnt1h tcnt1l ocr1ah ocr1al ocr1bh ocr1bl icr1h icr1l tccr2 tcnt2 ocr2 ocdr wdtcr sfior eearh eearl eedr eecr porta ddra pina portb ddrb pinb portc ddrc pinc portd ddrd pind spdr spsr spcr udr0 ucsr0a ucsr0b ubrr0l acsr admux adcsr adch adcl porte ddre pine pinf",
            meta: ".byte .cseg .db .def .device .dseg .dw .endmacro .equ .eseg .exit .include .list .listmac .macro .nolist .org .set"
        },
        contains: [
            hljs.C_BLOCK_COMMENT_MODE,
            hljs.COMMENT(";", "$", {
                relevance: 0
            }),
            hljs.C_NUMBER_MODE,
            hljs.BINARY_NUMBER_MODE,
            {
                className: "number",
                begin: "\\b(\\$[a-zA-Z0-9]+|0o[0-7]+)" // $..., 0o...
            },
            hljs.QUOTE_STRING_MODE,
            {
                className: "string",
                begin: "'",
                end: "[^\\\\]'",
                illegal: "[^\\\\][^']"
            },
            {
                className: "symbol",
                begin: "^[A-Za-z0-9_.$]+:"
            },
            {
                className: "meta",
                begin: "#",
                end: "$"
            },
            {
                className: "subst",
                begin: "@[0-9]+"
            }
        ]
    };
};

});

parcelRegister("4FtHV", function(module, exports) {
module.exports = function(hljs) {
    var VARIABLE = {
        className: "variable",
        variants: [
            {
                begin: /\$[\w\d#@][\w\d_]*/
            },
            {
                begin: /\$\{(.*?)}/
            }
        ]
    };
    var KEYWORDS = "BEGIN END if else while do for in break continue delete next nextfile function func exit|10";
    var STRING = {
        className: "string",
        contains: [
            hljs.BACKSLASH_ESCAPE
        ],
        variants: [
            {
                begin: /(u|b)?r?'''/,
                end: /'''/,
                relevance: 10
            },
            {
                begin: /(u|b)?r?"""/,
                end: /"""/,
                relevance: 10
            },
            {
                begin: /(u|r|ur)'/,
                end: /'/,
                relevance: 10
            },
            {
                begin: /(u|r|ur)"/,
                end: /"/,
                relevance: 10
            },
            {
                begin: /(b|br)'/,
                end: /'/
            },
            {
                begin: /(b|br)"/,
                end: /"/
            },
            hljs.APOS_STRING_MODE,
            hljs.QUOTE_STRING_MODE
        ]
    };
    return {
        keywords: {
            keyword: KEYWORDS
        },
        contains: [
            VARIABLE,
            STRING,
            hljs.REGEXP_MODE,
            hljs.HASH_COMMENT_MODE,
            hljs.NUMBER_MODE
        ]
    };
};

});

parcelRegister("HfSOx", function(module, exports) {
module.exports = function(hljs) {
    return {
        keywords: "false int abstract private char boolean static null if for true while long throw finally protected final return void enum else break new catch byte super case short default double public try this switch continue reverse firstfast firstonly forupdate nofetch sum avg minof maxof count order group by asc desc index hint like dispaly edit client server ttsbegin ttscommit str real date container anytype common div mod",
        contains: [
            hljs.C_LINE_COMMENT_MODE,
            hljs.C_BLOCK_COMMENT_MODE,
            hljs.APOS_STRING_MODE,
            hljs.QUOTE_STRING_MODE,
            hljs.C_NUMBER_MODE,
            {
                className: "meta",
                begin: "#",
                end: "$"
            },
            {
                className: "class",
                beginKeywords: "class interface",
                end: "{",
                excludeEnd: true,
                illegal: ":",
                contains: [
                    {
                        beginKeywords: "extends implements"
                    },
                    hljs.UNDERSCORE_TITLE_MODE
                ]
            }
        ]
    };
};

});

parcelRegister("cheUk", function(module, exports) {
module.exports = function(hljs) {
    var VAR = {
        className: "variable",
        variants: [
            {
                begin: /\$[\w\d#@][\w\d_]*/
            },
            {
                begin: /\$\{(.*?)}/
            }
        ]
    };
    var QUOTE_STRING = {
        className: "string",
        begin: /"/,
        end: /"/,
        contains: [
            hljs.BACKSLASH_ESCAPE,
            VAR,
            {
                className: "variable",
                begin: /\$\(/,
                end: /\)/,
                contains: [
                    hljs.BACKSLASH_ESCAPE
                ]
            }
        ]
    };
    var ESCAPED_QUOTE = {
        className: "",
        begin: /\\"/
    };
    var APOS_STRING = {
        className: "string",
        begin: /'/,
        end: /'/
    };
    return {
        aliases: [
            "sh",
            "zsh"
        ],
        lexemes: /\b-?[a-z\._]+\b/,
        keywords: {
            keyword: "if then else elif fi for while in do done case esac function",
            literal: "true false",
            built_in: // Shell built-ins
            // http://www.gnu.org/software/bash/manual/html_node/Shell-Builtin-Commands.html
            "break cd continue eval exec exit export getopts hash pwd readonly return shift test times trap umask unset alias bind builtin caller command declare echo enable help let local logout mapfile printf read readarray source type typeset ulimit unalias set shopt autoload bg bindkey bye cap chdir clone comparguments compcall compctl compdescribe compfiles compgroups compquote comptags comptry compvalues dirs disable disown echotc echoti emulate fc fg float functions getcap getln history integer jobs kill limit log noglob popd print pushd pushln rehash sched setcap setopt stat suspend ttyctl unfunction unhash unlimit unsetopt vared wait whence where which zcompile zformat zftp zle zmodload zparseopts zprof zpty zregexparse zsocket zstyle ztcp",
            _: "-ne -eq -lt -gt -f -d -e -s -l -a" // relevance booster
        },
        contains: [
            {
                className: "meta",
                begin: /^#![^\n]+sh\s*$/,
                relevance: 10
            },
            {
                className: "function",
                begin: /\w[\w\d_]*\s*\(\s*\)\s*\{/,
                returnBegin: true,
                contains: [
                    hljs.inherit(hljs.TITLE_MODE, {
                        begin: /\w[\w\d_]*/
                    })
                ],
                relevance: 0
            },
            hljs.HASH_COMMENT_MODE,
            QUOTE_STRING,
            ESCAPED_QUOTE,
            APOS_STRING,
            VAR
        ]
    };
};

});

parcelRegister("ahe0r", function(module, exports) {
module.exports = function(hljs) {
    return {
        case_insensitive: true,
        illegal: "^.",
        // Support explicitely typed variables that end with $%! or #.
        lexemes: "[a-zA-Z][a-zA-Z0-9_$%!#]*",
        keywords: {
            keyword: "ABS ASC AND ATN AUTO|0 BEEP BLOAD|10 BSAVE|10 CALL CALLS CDBL CHAIN CHDIR CHR$|10 CINT CIRCLE CLEAR CLOSE CLS COLOR COM COMMON CONT COS CSNG CSRLIN CVD CVI CVS DATA DATE$ DEFDBL DEFINT DEFSNG DEFSTR DEF|0 SEG USR DELETE DIM DRAW EDIT END ENVIRON ENVIRON$ EOF EQV ERASE ERDEV ERDEV$ ERL ERR ERROR EXP FIELD FILES FIX FOR|0 FRE GET GOSUB|10 GOTO HEX$ IF THEN ELSE|0 INKEY$ INP INPUT INPUT# INPUT$ INSTR IMP INT IOCTL IOCTL$ KEY ON OFF LIST KILL LEFT$ LEN LET LINE LLIST LOAD LOC LOCATE LOF LOG LPRINT USING LSET MERGE MID$ MKDIR MKD$ MKI$ MKS$ MOD NAME NEW NEXT NOISE NOT OCT$ ON OR PEN PLAY STRIG OPEN OPTION BASE OUT PAINT PALETTE PCOPY PEEK PMAP POINT POKE POS PRINT PRINT] PSET PRESET PUT RANDOMIZE READ REM RENUM RESET|0 RESTORE RESUME RETURN|0 RIGHT$ RMDIR RND RSET RUN SAVE SCREEN SGN SHELL SIN SOUND SPACE$ SPC SQR STEP STICK STOP STR$ STRING$ SWAP SYSTEM TAB TAN TIME$ TIMER TROFF TRON TO USR VAL VARPTR VARPTR$ VIEW WAIT WHILE WEND WIDTH WINDOW WRITE XOR"
        },
        contains: [
            hljs.QUOTE_STRING_MODE,
            hljs.COMMENT("REM", "$", {
                relevance: 10
            }),
            hljs.COMMENT("'", "$", {
                relevance: 0
            }),
            {
                // Match line numbers
                className: "symbol",
                begin: "^[0-9]+ ",
                relevance: 10
            },
            {
                // Match typed numeric constants (1000, 12.34!, 1.2e5, 1.5#, 1.2D2)
                className: "number",
                begin: "\\b([0-9]+[0-9edED.]*[#!]?)",
                relevance: 0
            },
            {
                // Match hexadecimal numbers (&Hxxxx)
                className: "number",
                begin: "(&[hH][0-9a-fA-F]{1,4})"
            },
            {
                // Match octal numbers (&Oxxxxxx)
                className: "number",
                begin: "(&[oO][0-7]{1,6})"
            }
        ]
    };
};

});

parcelRegister("MnP3I", function(module, exports) {
module.exports = function(hljs) {
    return {
        contains: [
            // Attribute
            {
                className: "attribute",
                begin: /</,
                end: />/
            },
            // Specific
            {
                begin: /::=/,
                starts: {
                    end: /$/,
                    contains: [
                        {
                            begin: /</,
                            end: />/
                        },
                        // Common
                        hljs.C_LINE_COMMENT_MODE,
                        hljs.C_BLOCK_COMMENT_MODE,
                        hljs.APOS_STRING_MODE,
                        hljs.QUOTE_STRING_MODE
                    ]
                }
            }
        ]
    };
};

});

parcelRegister("5IOyj", function(module, exports) {
module.exports = function(hljs) {
    var LITERAL = {
        className: "literal",
        begin: "[\\+\\-]",
        relevance: 0
    };
    return {
        aliases: [
            "bf"
        ],
        contains: [
            hljs.COMMENT("[^\\[\\]\\.,\\+\\-<> \r\n]", "[\\[\\]\\.,\\+\\-<> \r\n]", {
                returnEnd: true,
                relevance: 0
            }),
            {
                className: "title",
                begin: "[\\[\\]]",
                relevance: 0
            },
            {
                className: "string",
                begin: "[\\.,]",
                relevance: 0
            },
            {
                // this mode works as the only relevance counter
                begin: /(?:\+\+|\-\-)/,
                contains: [
                    LITERAL
                ]
            },
            LITERAL
        ]
    };
};

});

parcelRegister("ixHQI", function(module, exports) {
module.exports = function(hljs) {
    var KEYWORDS = "div mod in and or not xor asserterror begin case do downto else end exit for if of repeat then to until while with var";
    var LITERALS = "false true";
    var COMMENT_MODES = [
        hljs.C_LINE_COMMENT_MODE,
        hljs.COMMENT(/\{/, /\}/, {
            relevance: 0
        }),
        hljs.COMMENT(/\(\*/, /\*\)/, {
            relevance: 10
        })
    ];
    var STRING = {
        className: "string",
        begin: /'/,
        end: /'/,
        contains: [
            {
                begin: /''/
            }
        ]
    };
    var CHAR_STRING = {
        className: "string",
        begin: /(#\d+)+/
    };
    var DATE = {
        className: "number",
        begin: "\\b\\d+(\\.\\d+)?(DT|D|T)",
        relevance: 0
    };
    var DBL_QUOTED_VARIABLE = {
        className: "string",
        begin: '"',
        end: '"'
    };
    var PROCEDURE = {
        className: "function",
        beginKeywords: "procedure",
        end: /[:;]/,
        keywords: "procedure|10",
        contains: [
            hljs.TITLE_MODE,
            {
                className: "params",
                begin: /\(/,
                end: /\)/,
                keywords: KEYWORDS,
                contains: [
                    STRING,
                    CHAR_STRING
                ]
            }
        ].concat(COMMENT_MODES)
    };
    var OBJECT = {
        className: "class",
        begin: "OBJECT (Table|Form|Report|Dataport|Codeunit|XMLport|MenuSuite|Page|Query) (\\d+) ([^\\r\\n]+)",
        returnBegin: true,
        contains: [
            hljs.TITLE_MODE,
            PROCEDURE
        ]
    };
    return {
        case_insensitive: true,
        keywords: {
            keyword: KEYWORDS,
            literal: LITERALS
        },
        illegal: /\/\*/,
        contains: [
            STRING,
            CHAR_STRING,
            DATE,
            DBL_QUOTED_VARIABLE,
            hljs.NUMBER_MODE,
            OBJECT,
            PROCEDURE
        ]
    };
};

});

parcelRegister("74F4K", function(module, exports) {
module.exports = function(hljs) {
    return {
        aliases: [
            "capnp"
        ],
        keywords: {
            keyword: "struct enum interface union group import using const annotation extends in of on as with from fixed",
            built_in: "Void Bool Int8 Int16 Int32 Int64 UInt8 UInt16 UInt32 UInt64 Float32 Float64 Text Data AnyPointer AnyStruct Capability List",
            literal: "true false"
        },
        contains: [
            hljs.QUOTE_STRING_MODE,
            hljs.NUMBER_MODE,
            hljs.HASH_COMMENT_MODE,
            {
                className: "meta",
                begin: /@0x[\w\d]{16};/,
                illegal: /\n/
            },
            {
                className: "symbol",
                begin: /@\d+\b/
            },
            {
                className: "class",
                beginKeywords: "struct enum",
                end: /\{/,
                illegal: /\n/,
                contains: [
                    hljs.inherit(hljs.TITLE_MODE, {
                        starts: {
                            endsWithParent: true,
                            excludeEnd: true
                        } // hack: eating everything after the first title
                    })
                ]
            },
            {
                className: "class",
                beginKeywords: "interface",
                end: /\{/,
                illegal: /\n/,
                contains: [
                    hljs.inherit(hljs.TITLE_MODE, {
                        starts: {
                            endsWithParent: true,
                            excludeEnd: true
                        } // hack: eating everything after the first title
                    })
                ]
            }
        ]
    };
};

});

parcelRegister("jfjbY", function(module, exports) {
module.exports = function(hljs) {
    // 2.3. Identifiers and keywords
    var KEYWORDS = "assembly module package import alias class interface object given value assign void function new of extends satisfies abstracts in out return break continue throw assert dynamic if else switch case for while try catch finally then let this outer super is exists nonempty";
    // 7.4.1 Declaration Modifiers
    var DECLARATION_MODIFIERS = "shared abstract formal default actual variable late native deprecatedfinal sealed annotation suppressWarnings small";
    // 7.4.2 Documentation
    var DOCUMENTATION = "doc by license see throws tagged";
    var SUBST = {
        className: "subst",
        excludeBegin: true,
        excludeEnd: true,
        begin: /``/,
        end: /``/,
        keywords: KEYWORDS,
        relevance: 10
    };
    var EXPRESSIONS = [
        {
            // verbatim string
            className: "string",
            begin: '"""',
            end: '"""',
            relevance: 10
        },
        {
            // string literal or template
            className: "string",
            begin: '"',
            end: '"',
            contains: [
                SUBST
            ]
        },
        {
            // character literal
            className: "string",
            begin: "'",
            end: "'"
        },
        {
            // numeric literal
            className: "number",
            begin: "#[0-9a-fA-F_]+|\\$[01_]+|[0-9_]+(?:\\.[0-9_](?:[eE][+-]?\\d+)?)?[kMGTPmunpf]?",
            relevance: 0
        }
    ];
    SUBST.contains = EXPRESSIONS;
    return {
        keywords: {
            keyword: KEYWORDS + " " + DECLARATION_MODIFIERS,
            meta: DOCUMENTATION
        },
        illegal: "\\$[^01]|#[^0-9a-fA-F]",
        contains: [
            hljs.C_LINE_COMMENT_MODE,
            hljs.COMMENT("/\\*", "\\*/", {
                contains: [
                    "self"
                ]
            }),
            {
                // compiler annotation
                className: "meta",
                begin: '@[a-z]\\w*(?:\\:"[^"]*")?'
            }
        ].concat(EXPRESSIONS)
    };
};

});

parcelRegister("bNu1a", function(module, exports) {
module.exports = function(hljs) {
    return {
        aliases: [
            "clean",
            "icl",
            "dcl"
        ],
        keywords: {
            keyword: "if let in with where case of class instance otherwise implementation definition system module from import qualified as special code inline foreign export ccall stdcall generic derive infix infixl infixr",
            built_in: "Int Real Char Bool",
            literal: "True False"
        },
        contains: [
            hljs.C_LINE_COMMENT_MODE,
            hljs.C_BLOCK_COMMENT_MODE,
            hljs.APOS_STRING_MODE,
            hljs.QUOTE_STRING_MODE,
            hljs.C_NUMBER_MODE,
            {
                begin: "->|<-[|:]?|#!?|>>=|\\{\\||\\|\\}|:==|=:|<>"
            } // relevance booster
        ]
    };
};

});

parcelRegister("8Pjhc", function(module, exports) {
module.exports = function(hljs) {
    var keywords = {
        "builtin-name": // Clojure keywords
        "def defonce cond apply if-not if-let if not not= = < > <= >= == + / * - rem quot neg? pos? delay? symbol? keyword? true? false? integer? empty? coll? list? set? ifn? fn? associative? sequential? sorted? counted? reversible? number? decimal? class? distinct? isa? float? rational? reduced? ratio? odd? even? char? seq? vector? string? map? nil? contains? zero? instance? not-every? not-any? libspec? -> ->> .. . inc compare do dotimes mapcat take remove take-while drop letfn drop-last take-last drop-while while intern condp case reduced cycle split-at split-with repeat replicate iterate range merge zipmap declare line-seq sort comparator sort-by dorun doall nthnext nthrest partition eval doseq await await-for let agent atom send send-off release-pending-sends add-watch mapv filterv remove-watch agent-error restart-agent set-error-handler error-handler set-error-mode! error-mode shutdown-agents quote var fn loop recur throw try monitor-enter monitor-exit defmacro defn defn- macroexpand macroexpand-1 for dosync and or when when-not when-let comp juxt partial sequence memoize constantly complement identity assert peek pop doto proxy defstruct first rest cons defprotocol cast coll deftype defrecord last butlast sigs reify second ffirst fnext nfirst nnext defmulti defmethod meta with-meta ns in-ns create-ns import refer keys select-keys vals key val rseq name namespace promise into transient persistent! conj! assoc! dissoc! pop! disj! use class type num float double short byte boolean bigint biginteger bigdec print-method print-dup throw-if printf format load compile get-in update-in pr pr-on newline flush read slurp read-line subvec with-open memfn time re-find re-groups rand-int rand mod locking assert-valid-fdecl alias resolve ref deref refset swap! reset! set-validator! compare-and-set! alter-meta! reset-meta! commute get-validator alter ref-set ref-history-count ref-min-history ref-max-history ensure sync io! new next conj set! to-array future future-call into-array aset gen-class reduce map filter find empty hash-map hash-set sorted-map sorted-map-by sorted-set sorted-set-by vec vector seq flatten reverse assoc dissoc list disj get union difference intersection extend extend-type extend-protocol int nth delay count concat chunk chunk-buffer chunk-append chunk-first chunk-rest max min dec unchecked-inc-int unchecked-inc unchecked-dec-inc unchecked-dec unchecked-negate unchecked-add-int unchecked-add unchecked-subtract-int unchecked-subtract chunk-next chunk-cons chunked-seq? prn vary-meta lazy-seq spread list* str find-keyword keyword symbol gensym force rationalize"
    };
    var SYMBOLSTART = "a-zA-Z_\\-!.?+*=<>&#'";
    var SYMBOL_RE = "[" + SYMBOLSTART + "][" + SYMBOLSTART + "0-9/;:]*";
    var SIMPLE_NUMBER_RE = "[-+]?\\d+(\\.\\d+)?";
    var SYMBOL = {
        begin: SYMBOL_RE,
        relevance: 0
    };
    var NUMBER = {
        className: "number",
        begin: SIMPLE_NUMBER_RE,
        relevance: 0
    };
    var STRING = hljs.inherit(hljs.QUOTE_STRING_MODE, {
        illegal: null
    });
    var COMMENT = hljs.COMMENT(";", "$", {
        relevance: 0
    });
    var LITERAL = {
        className: "literal",
        begin: /\b(true|false|nil)\b/
    };
    var COLLECTION = {
        begin: "[\\[\\{]",
        end: "[\\]\\}]"
    };
    var HINT = {
        className: "comment",
        begin: "\\^" + SYMBOL_RE
    };
    var HINT_COL = hljs.COMMENT("\\^\\{", "\\}");
    var KEY = {
        className: "symbol",
        begin: "[:]{1,2}" + SYMBOL_RE
    };
    var LIST = {
        begin: "\\(",
        end: "\\)"
    };
    var BODY = {
        endsWithParent: true,
        relevance: 0
    };
    var NAME = {
        keywords: keywords,
        lexemes: SYMBOL_RE,
        className: "name",
        begin: SYMBOL_RE,
        starts: BODY
    };
    var DEFAULT_CONTAINS = [
        LIST,
        STRING,
        HINT,
        HINT_COL,
        COMMENT,
        KEY,
        COLLECTION,
        NUMBER,
        LITERAL,
        SYMBOL
    ];
    LIST.contains = [
        hljs.COMMENT("comment", ""),
        NAME,
        BODY
    ];
    BODY.contains = DEFAULT_CONTAINS;
    COLLECTION.contains = DEFAULT_CONTAINS;
    HINT_COL.contains = [
        COLLECTION
    ];
    return {
        aliases: [
            "clj"
        ],
        illegal: /\S/,
        contains: [
            LIST,
            STRING,
            HINT,
            HINT_COL,
            COMMENT,
            KEY,
            COLLECTION,
            NUMBER,
            LITERAL
        ]
    };
};

});

parcelRegister("4GKer", function(module, exports) {
module.exports = function(hljs) {
    return {
        contains: [
            {
                className: "meta",
                begin: /^([\w.-]+|\s*#_)?=>/,
                starts: {
                    end: /$/,
                    subLanguage: "clojure"
                }
            }
        ]
    };
};

});

parcelRegister("e8EoF", function(module, exports) {
module.exports = function(hljs) {
    return {
        aliases: [
            "cmake.in"
        ],
        case_insensitive: true,
        keywords: {
            keyword: // scripting commands
            "break cmake_host_system_information cmake_minimum_required cmake_parse_arguments cmake_policy configure_file continue elseif else endforeach endfunction endif endmacro endwhile execute_process file find_file find_library find_package find_path find_program foreach function get_cmake_property get_directory_property get_filename_component get_property if include include_guard list macro mark_as_advanced math message option return separate_arguments set_directory_properties set_property set site_name string unset variable_watch while add_compile_definitions add_compile_options add_custom_command add_custom_target add_definitions add_dependencies add_executable add_library add_link_options add_subdirectory add_test aux_source_directory build_command create_test_sourcelist define_property enable_language enable_testing export fltk_wrap_ui get_source_file_property get_target_property get_test_property include_directories include_external_msproject include_regular_expression install link_directories link_libraries load_cache project qt_wrap_cpp qt_wrap_ui remove_definitions set_source_files_properties set_target_properties set_tests_properties source_group target_compile_definitions target_compile_features target_compile_options target_include_directories target_link_directories target_link_libraries target_link_options target_sources try_compile try_run ctest_build ctest_configure ctest_coverage ctest_empty_binary_directory ctest_memcheck ctest_read_custom_files ctest_run_script ctest_sleep ctest_start ctest_submit ctest_test ctest_update ctest_upload build_name exec_program export_library_dependencies install_files install_programs install_targets load_command make_directory output_required_files remove subdir_depends subdirs use_mangled_mesa utility_source variable_requires write_file qt5_use_modules qt5_use_package qt5_wrap_cpp on off true false and or not command policy target test exists is_newer_than is_directory is_symlink is_absolute matches less greater equal less_equal greater_equal strless strgreater strequal strless_equal strgreater_equal version_less version_greater version_equal version_less_equal version_greater_equal in_list defined"
        },
        contains: [
            {
                className: "variable",
                begin: "\\${",
                end: "}"
            },
            hljs.HASH_COMMENT_MODE,
            hljs.QUOTE_STRING_MODE,
            hljs.NUMBER_MODE
        ]
    };
};

});

parcelRegister("aK6iY", function(module, exports) {
module.exports = function(hljs) {
    var KEYWORDS = {
        keyword: // JS keywords
        "in if for while finally new do return else break catch instanceof throw try this switch continue typeof delete debugger super yield import export from as default await then unless until loop of by when and or is isnt not",
        literal: // JS literals
        "true false null undefined yes no on off",
        built_in: "npm require console print module global window document"
    };
    var JS_IDENT_RE = "[A-Za-z$_][0-9A-Za-z$_]*";
    var SUBST = {
        className: "subst",
        begin: /#\{/,
        end: /}/,
        keywords: KEYWORDS
    };
    var EXPRESSIONS = [
        hljs.BINARY_NUMBER_MODE,
        hljs.inherit(hljs.C_NUMBER_MODE, {
            starts: {
                end: "(\\s*/)?",
                relevance: 0
            }
        }),
        {
            className: "string",
            variants: [
                {
                    begin: /'''/,
                    end: /'''/,
                    contains: [
                        hljs.BACKSLASH_ESCAPE
                    ]
                },
                {
                    begin: /'/,
                    end: /'/,
                    contains: [
                        hljs.BACKSLASH_ESCAPE
                    ]
                },
                {
                    begin: /"""/,
                    end: /"""/,
                    contains: [
                        hljs.BACKSLASH_ESCAPE,
                        SUBST
                    ]
                },
                {
                    begin: /"/,
                    end: /"/,
                    contains: [
                        hljs.BACKSLASH_ESCAPE,
                        SUBST
                    ]
                }
            ]
        },
        {
            className: "regexp",
            variants: [
                {
                    begin: "///",
                    end: "///",
                    contains: [
                        SUBST,
                        hljs.HASH_COMMENT_MODE
                    ]
                },
                {
                    begin: "//[gim]{0,3}(?=\\W)",
                    relevance: 0
                },
                {
                    // regex can't start with space to parse x / 2 / 3 as two divisions
                    // regex can't start with *, and it supports an "illegal" in the main mode
                    begin: /\/(?![ *]).*?(?![\\]).\/[gim]{0,3}(?=\W)/
                }
            ]
        },
        {
            begin: "@" + JS_IDENT_RE // relevance booster
        },
        {
            subLanguage: "javascript",
            excludeBegin: true,
            excludeEnd: true,
            variants: [
                {
                    begin: "```",
                    end: "```"
                },
                {
                    begin: "`",
                    end: "`"
                }
            ]
        }
    ];
    SUBST.contains = EXPRESSIONS;
    var TITLE = hljs.inherit(hljs.TITLE_MODE, {
        begin: JS_IDENT_RE
    });
    var PARAMS_RE = "(\\(.*\\))?\\s*\\B[-=]>";
    var PARAMS = {
        className: "params",
        begin: "\\([^\\(]",
        returnBegin: true,
        /* We need another contained nameless mode to not have every nested
    pair of parens to be called "params" */ contains: [
            {
                begin: /\(/,
                end: /\)/,
                keywords: KEYWORDS,
                contains: [
                    "self"
                ].concat(EXPRESSIONS)
            }
        ]
    };
    return {
        aliases: [
            "coffee",
            "cson",
            "iced"
        ],
        keywords: KEYWORDS,
        illegal: /\/\*/,
        contains: EXPRESSIONS.concat([
            hljs.COMMENT("###", "###"),
            hljs.HASH_COMMENT_MODE,
            {
                className: "function",
                begin: "^\\s*" + JS_IDENT_RE + "\\s*=\\s*" + PARAMS_RE,
                end: "[-=]>",
                returnBegin: true,
                contains: [
                    TITLE,
                    PARAMS
                ]
            },
            {
                // anonymous function start
                begin: /[:\(,=]\s*/,
                relevance: 0,
                contains: [
                    {
                        className: "function",
                        begin: PARAMS_RE,
                        end: "[-=]>",
                        returnBegin: true,
                        contains: [
                            PARAMS
                        ]
                    }
                ]
            },
            {
                className: "class",
                beginKeywords: "class",
                end: "$",
                illegal: /[:="\[\]]/,
                contains: [
                    {
                        beginKeywords: "extends",
                        endsWithParent: true,
                        illegal: /[:="\[\]]/,
                        contains: [
                            TITLE
                        ]
                    },
                    TITLE
                ]
            },
            {
                begin: JS_IDENT_RE + ":",
                end: ":",
                returnBegin: true,
                returnEnd: true,
                relevance: 0
            }
        ])
    };
};

});

parcelRegister("jlnGk", function(module, exports) {
module.exports = function(hljs) {
    return {
        keywords: {
            keyword: "_|0 as at cofix else end exists exists2 fix for forall fun if IF in let match mod Prop return Set then Type using where with Abort About Add Admit Admitted All Arguments Assumptions Axiom Back BackTo Backtrack Bind Blacklist Canonical Cd Check Class Classes Close Coercion Coercions CoFixpoint CoInductive Collection Combined Compute Conjecture Conjectures Constant constr Constraint Constructors Context Corollary CreateHintDb Cut Declare Defined Definition Delimit Dependencies DependentDerive Drop eauto End Equality Eval Example Existential Existentials Existing Export exporting Extern Extract Extraction Fact Field Fields File Fixpoint Focus for From Function Functional Generalizable Global Goal Grab Grammar Graph Guarded Heap Hint HintDb Hints Hypotheses Hypothesis ident Identity If Immediate Implicit Import Include Inductive Infix Info Initial Inline Inspect Instance Instances Intro Intros Inversion Inversion_clear Language Left Lemma Let Libraries Library Load LoadPath Local Locate Ltac ML Mode Module Modules Monomorphic Morphism Next NoInline Notation Obligation Obligations Opaque Open Optimize Options Parameter Parameters Parametric Path Paths pattern Polymorphic Preterm Print Printing Program Projections Proof Proposition Pwd Qed Quit Rec Record Recursive Redirect Relation Remark Remove Require Reserved Reset Resolve Restart Rewrite Right Ring Rings Save Scheme Scope Scopes Script Search SearchAbout SearchHead SearchPattern SearchRewrite Section Separate Set Setoid Show Solve Sorted Step Strategies Strategy Structure SubClass Table Tables Tactic Term Test Theorem Time Timeout Transparent Type Typeclasses Types Undelimit Undo Unfocus Unfocused Unfold Universe Universes Unset Unshelve using Variable Variables Variant Verbose Visibility where with",
            built_in: "abstract absurd admit after apply as assert assumption at auto autorewrite autounfold before bottom btauto by case case_eq cbn cbv change classical_left classical_right clear clearbody cofix compare compute congruence constr_eq constructor contradict contradiction cut cutrewrite cycle decide decompose dependent destruct destruction dintuition discriminate discrR do double dtauto eapply eassumption eauto ecase econstructor edestruct ediscriminate eelim eexact eexists einduction einjection eleft elim elimtype enough equality erewrite eright esimplify_eq esplit evar exact exactly_once exfalso exists f_equal fail field field_simplify field_simplify_eq first firstorder fix fold fourier functional generalize generalizing gfail give_up has_evar hnf idtac in induction injection instantiate intro intro_pattern intros intuition inversion inversion_clear is_evar is_var lapply lazy left lia lra move native_compute nia nsatz omega once pattern pose progress proof psatz quote record red refine reflexivity remember rename repeat replace revert revgoals rewrite rewrite_strat right ring ring_simplify rtauto set setoid_reflexivity setoid_replace setoid_rewrite setoid_symmetry setoid_transitivity shelve shelve_unifiable simpl simple simplify_eq solve specialize split split_Rabs split_Rmult stepl stepr subst sum swap symmetry tactic tauto time timeout top transitivity trivial try tryif unfold unify until using vm_compute with"
        },
        contains: [
            hljs.QUOTE_STRING_MODE,
            hljs.COMMENT("\\(\\*", "\\*\\)"),
            hljs.C_NUMBER_MODE,
            {
                className: "type",
                excludeBegin: true,
                begin: "\\|\\s*",
                end: "\\w+"
            },
            {
                begin: /[-=]>/
            } // relevance booster
        ]
    };
};

});

parcelRegister("dUE2d", function(module, exports) {
module.exports = function cos(hljs) {
    var STRINGS = {
        className: "string",
        variants: [
            {
                begin: '"',
                end: '"',
                contains: [
                    {
                        begin: '""',
                        relevance: 0
                    }
                ]
            }
        ]
    };
    var NUMBERS = {
        className: "number",
        begin: "\\b(\\d+(\\.\\d*)?|\\.\\d+)",
        relevance: 0
    };
    var COS_KEYWORDS = "property parameter class classmethod clientmethod extends as break catch close continue do d|0 else elseif for goto halt hang h|0 if job j|0 kill k|0 lock l|0 merge new open quit q|0 read r|0 return set s|0 tcommit throw trollback try tstart use view while write w|0 xecute x|0 zkill znspace zn ztrap zwrite zw zzdump zzwrite print zbreak zinsert zload zprint zremove zsave zzprint mv mvcall mvcrt mvdim mvprint zquit zsync ascii";
    // registered function - no need in them due to all functions are highlighted,
    // but I'll just leave this here.
    //"$bit", "$bitcount",
    //"$bitfind", "$bitlogic", "$case", "$char", "$classmethod", "$classname",
    //"$compile", "$data", "$decimal", "$double", "$extract", "$factor",
    //"$find", "$fnumber", "$get", "$increment", "$inumber", "$isobject",
    //"$isvaliddouble", "$isvalidnum", "$justify", "$length", "$list",
    //"$listbuild", "$listdata", "$listfind", "$listfromstring", "$listget",
    //"$listlength", "$listnext", "$listsame", "$listtostring", "$listvalid",
    //"$locate", "$match", "$method", "$name", "$nconvert", "$next",
    //"$normalize", "$now", "$number", "$order", "$parameter", "$piece",
    //"$prefetchoff", "$prefetchon", "$property", "$qlength", "$qsubscript",
    //"$query", "$random", "$replace", "$reverse", "$sconvert", "$select",
    //"$sortbegin", "$sortend", "$stack", "$text", "$translate", "$view",
    //"$wascii", "$wchar", "$wextract", "$wfind", "$wiswide", "$wlength",
    //"$wreverse", "$xecute", "$zabs", "$zarccos", "$zarcsin", "$zarctan",
    //"$zcos", "$zcot", "$zcsc", "$zdate", "$zdateh", "$zdatetime",
    //"$zdatetimeh", "$zexp", "$zhex", "$zln", "$zlog", "$zpower", "$zsec",
    //"$zsin", "$zsqr", "$ztan", "$ztime", "$ztimeh", "$zboolean",
    //"$zconvert", "$zcrc", "$zcyc", "$zdascii", "$zdchar", "$zf",
    //"$ziswide", "$zlascii", "$zlchar", "$zname", "$zposition", "$zqascii",
    //"$zqchar", "$zsearch", "$zseek", "$zstrip", "$zwascii", "$zwchar",
    //"$zwidth", "$zwpack", "$zwbpack", "$zwunpack", "$zwbunpack", "$zzenkaku",
    //"$change", "$mv", "$mvat", "$mvfmt", "$mvfmts", "$mviconv",
    //"$mviconvs", "$mvinmat", "$mvlover", "$mvoconv", "$mvoconvs", "$mvraise",
    //"$mvtrans", "$mvv", "$mvname", "$zbitand", "$zbitcount", "$zbitfind",
    //"$zbitget", "$zbitlen", "$zbitnot", "$zbitor", "$zbitset", "$zbitstr",
    //"$zbitxor", "$zincrement", "$znext", "$zorder", "$zprevious", "$zsort",
    //"device", "$ecode", "$estack", "$etrap", "$halt", "$horolog",
    //"$io", "$job", "$key", "$namespace", "$principal", "$quit", "$roles",
    //"$storage", "$system", "$test", "$this", "$tlevel", "$username",
    //"$x", "$y", "$za", "$zb", "$zchild", "$zeof", "$zeos", "$zerror",
    //"$zhorolog", "$zio", "$zjob", "$zmode", "$znspace", "$zparent", "$zpi",
    //"$zpos", "$zreference", "$zstorage", "$ztimestamp", "$ztimezone",
    //"$ztrap", "$zversion"
    return {
        case_insensitive: true,
        aliases: [
            "cos",
            "cls"
        ],
        keywords: COS_KEYWORDS,
        contains: [
            NUMBERS,
            STRINGS,
            hljs.C_LINE_COMMENT_MODE,
            hljs.C_BLOCK_COMMENT_MODE,
            {
                className: "comment",
                begin: /;/,
                end: "$",
                relevance: 0
            },
            {
                className: "built_in",
                begin: /(?:\$\$?|\.\.)\^?[a-zA-Z]+/
            },
            {
                className: "built_in",
                begin: /\$\$\$[a-zA-Z]+/
            },
            {
                className: "built_in",
                begin: /%[a-z]+(?:\.[a-z]+)*/
            },
            {
                className: "symbol",
                begin: /\^%?[a-zA-Z][\w]*/
            },
            {
                className: "keyword",
                begin: /##class|##super|#define|#dim/
            },
            // sub-languages: are not fully supported by hljs by 11/15/2015
            // left for the future implementation.
            {
                begin: /&sql\(/,
                end: /\)/,
                excludeBegin: true,
                excludeEnd: true,
                subLanguage: "sql"
            },
            {
                begin: /&(js|jscript|javascript)</,
                end: />/,
                excludeBegin: true,
                excludeEnd: true,
                subLanguage: "javascript"
            },
            {
                // this brakes first and last tag, but this is the only way to embed a valid html
                begin: /&html<\s*</,
                end: />\s*>/,
                subLanguage: "xml"
            }
        ]
    };
};

});

parcelRegister("6QJGt", function(module, exports) {
module.exports = function(hljs) {
    var RESOURCES = "primitive rsc_template";
    var COMMANDS = "group clone ms master location colocation order fencing_topology rsc_ticket acl_target acl_group user role tag xml";
    var PROPERTY_SETS = "property rsc_defaults op_defaults";
    var KEYWORDS = "params meta operations op rule attributes utilization";
    var OPERATORS = "read write deny defined not_defined in_range date spec in ref reference attribute type xpath version and or lt gt tag lte gte eq ne \\";
    var TYPES = "number string";
    var LITERALS = "Master Started Slave Stopped start promote demote stop monitor true false";
    return {
        aliases: [
            "crm",
            "pcmk"
        ],
        case_insensitive: true,
        keywords: {
            keyword: KEYWORDS + " " + OPERATORS + " " + TYPES,
            literal: LITERALS
        },
        contains: [
            hljs.HASH_COMMENT_MODE,
            {
                beginKeywords: "node",
                starts: {
                    end: "\\s*([\\w_-]+:)?",
                    starts: {
                        className: "title",
                        end: "\\s*[\\$\\w_][\\w_-]*"
                    }
                }
            },
            {
                beginKeywords: RESOURCES,
                starts: {
                    className: "title",
                    end: "\\s*[\\$\\w_][\\w_-]*",
                    starts: {
                        end: "\\s*@?[\\w_][\\w_\\.:-]*"
                    }
                }
            },
            {
                begin: "\\b(" + COMMANDS.split(" ").join("|") + ")\\s+",
                keywords: COMMANDS,
                starts: {
                    className: "title",
                    end: "[\\$\\w_][\\w_-]*"
                }
            },
            {
                beginKeywords: PROPERTY_SETS,
                starts: {
                    className: "title",
                    end: "\\s*([\\w_-]+:)?"
                }
            },
            hljs.QUOTE_STRING_MODE,
            {
                className: "meta",
                begin: "(ocf|systemd|service|lsb):[\\w_:-]+",
                relevance: 0
            },
            {
                className: "number",
                begin: "\\b\\d+(\\.\\d+)?(ms|s|h|m)?",
                relevance: 0
            },
            {
                className: "literal",
                begin: "[-]?(infinity|inf)",
                relevance: 0
            },
            {
                className: "attr",
                begin: /([A-Za-z\$_\#][\w_-]+)=/,
                relevance: 0
            },
            {
                className: "tag",
                begin: "</?",
                end: "/?>",
                relevance: 0
            }
        ]
    };
};

});

parcelRegister("2jJYq", function(module, exports) {
module.exports = function(hljs) {
    var INT_SUFFIX = "(_*[ui](8|16|32|64|128))?";
    var FLOAT_SUFFIX = "(_*f(32|64))?";
    var CRYSTAL_IDENT_RE = "[a-zA-Z_]\\w*[!?=]?";
    var CRYSTAL_METHOD_RE = "[a-zA-Z_]\\w*[!?=]?|[-+~]\\@|<<|>>|[=!]~|===?|<=>|[<>]=?|\\*\\*|[-/+%^&*~|]|//|//=|&[-+*]=?|&\\*\\*|\\[\\][=?]?";
    var CRYSTAL_PATH_RE = "[A-Za-z_]\\w*(::\\w+)*(\\?|\\!)?";
    var CRYSTAL_KEYWORDS = {
        keyword: "abstract alias annotation as as? asm begin break case class def do else elsif end ensure enum extend for fun if include instance_sizeof is_a? lib macro module next nil? of out pointerof private protected rescue responds_to? return require select self sizeof struct super then type typeof union uninitialized unless until verbatim when while with yield __DIR__ __END_LINE__ __FILE__ __LINE__",
        literal: "false nil true"
    };
    var SUBST = {
        className: "subst",
        begin: "#{",
        end: "}",
        keywords: CRYSTAL_KEYWORDS
    };
    var EXPANSION = {
        className: "template-variable",
        variants: [
            {
                begin: "\\{\\{",
                end: "\\}\\}"
            },
            {
                begin: "\\{%",
                end: "%\\}"
            }
        ],
        keywords: CRYSTAL_KEYWORDS
    };
    function recursiveParen(begin, end) {
        var contains = [
            {
                begin: begin,
                end: end
            }
        ];
        contains[0].contains = contains;
        return contains;
    }
    var STRING = {
        className: "string",
        contains: [
            hljs.BACKSLASH_ESCAPE,
            SUBST
        ],
        variants: [
            {
                begin: /'/,
                end: /'/
            },
            {
                begin: /"/,
                end: /"/
            },
            {
                begin: /`/,
                end: /`/
            },
            {
                begin: "%[Qwi]?\\(",
                end: "\\)",
                contains: recursiveParen("\\(", "\\)")
            },
            {
                begin: "%[Qwi]?\\[",
                end: "\\]",
                contains: recursiveParen("\\[", "\\]")
            },
            {
                begin: "%[Qwi]?{",
                end: "}",
                contains: recursiveParen("{", "}")
            },
            {
                begin: "%[Qwi]?<",
                end: ">",
                contains: recursiveParen("<", ">")
            },
            {
                begin: "%[Qwi]?\\|",
                end: "\\|"
            },
            {
                begin: /<<-\w+$/,
                end: /^\s*\w+$/
            }
        ],
        relevance: 0
    };
    var Q_STRING = {
        className: "string",
        variants: [
            {
                begin: "%q\\(",
                end: "\\)",
                contains: recursiveParen("\\(", "\\)")
            },
            {
                begin: "%q\\[",
                end: "\\]",
                contains: recursiveParen("\\[", "\\]")
            },
            {
                begin: "%q{",
                end: "}",
                contains: recursiveParen("{", "}")
            },
            {
                begin: "%q<",
                end: ">",
                contains: recursiveParen("<", ">")
            },
            {
                begin: "%q\\|",
                end: "\\|"
            },
            {
                begin: /<<-'\w+'$/,
                end: /^\s*\w+$/
            }
        ],
        relevance: 0
    };
    var REGEXP = {
        begin: "(?!%})(" + hljs.RE_STARTERS_RE + "|\\n|\\b(case|if|select|unless|until|when|while)\\b)\\s*",
        keywords: "case if select unless until when while",
        contains: [
            {
                className: "regexp",
                contains: [
                    hljs.BACKSLASH_ESCAPE,
                    SUBST
                ],
                variants: [
                    {
                        begin: "//[a-z]*",
                        relevance: 0
                    },
                    {
                        begin: "/(?!\\/)",
                        end: "/[a-z]*"
                    }
                ]
            }
        ],
        relevance: 0
    };
    var REGEXP2 = {
        className: "regexp",
        contains: [
            hljs.BACKSLASH_ESCAPE,
            SUBST
        ],
        variants: [
            {
                begin: "%r\\(",
                end: "\\)",
                contains: recursiveParen("\\(", "\\)")
            },
            {
                begin: "%r\\[",
                end: "\\]",
                contains: recursiveParen("\\[", "\\]")
            },
            {
                begin: "%r{",
                end: "}",
                contains: recursiveParen("{", "}")
            },
            {
                begin: "%r<",
                end: ">",
                contains: recursiveParen("<", ">")
            },
            {
                begin: "%r\\|",
                end: "\\|"
            }
        ],
        relevance: 0
    };
    var ATTRIBUTE = {
        className: "meta",
        begin: "@\\[",
        end: "\\]",
        contains: [
            hljs.inherit(hljs.QUOTE_STRING_MODE, {
                className: "meta-string"
            })
        ]
    };
    var CRYSTAL_DEFAULT_CONTAINS = [
        EXPANSION,
        STRING,
        Q_STRING,
        REGEXP2,
        REGEXP,
        ATTRIBUTE,
        hljs.HASH_COMMENT_MODE,
        {
            className: "class",
            beginKeywords: "class module struct",
            end: "$|;",
            illegal: /=/,
            contains: [
                hljs.HASH_COMMENT_MODE,
                hljs.inherit(hljs.TITLE_MODE, {
                    begin: CRYSTAL_PATH_RE
                }),
                {
                    begin: "<"
                } // relevance booster for inheritance
            ]
        },
        {
            className: "class",
            beginKeywords: "lib enum union",
            end: "$|;",
            illegal: /=/,
            contains: [
                hljs.HASH_COMMENT_MODE,
                hljs.inherit(hljs.TITLE_MODE, {
                    begin: CRYSTAL_PATH_RE
                })
            ],
            relevance: 10
        },
        {
            beginKeywords: "annotation",
            end: "$|;",
            illegal: /=/,
            contains: [
                hljs.HASH_COMMENT_MODE,
                hljs.inherit(hljs.TITLE_MODE, {
                    begin: CRYSTAL_PATH_RE
                })
            ],
            relevance: 10
        },
        {
            className: "function",
            beginKeywords: "def",
            end: /\B\b/,
            contains: [
                hljs.inherit(hljs.TITLE_MODE, {
                    begin: CRYSTAL_METHOD_RE,
                    endsParent: true
                })
            ]
        },
        {
            className: "function",
            beginKeywords: "fun macro",
            end: /\B\b/,
            contains: [
                hljs.inherit(hljs.TITLE_MODE, {
                    begin: CRYSTAL_METHOD_RE,
                    endsParent: true
                })
            ],
            relevance: 5
        },
        {
            className: "symbol",
            begin: hljs.UNDERSCORE_IDENT_RE + "(\\!|\\?)?:",
            relevance: 0
        },
        {
            className: "symbol",
            begin: ":",
            contains: [
                STRING,
                {
                    begin: CRYSTAL_METHOD_RE
                }
            ],
            relevance: 0
        },
        {
            className: "number",
            variants: [
                {
                    begin: "\\b0b([01_]+)" + INT_SUFFIX
                },
                {
                    begin: "\\b0o([0-7_]+)" + INT_SUFFIX
                },
                {
                    begin: "\\b0x([A-Fa-f0-9_]+)" + INT_SUFFIX
                },
                {
                    begin: "\\b([1-9][0-9_]*[0-9]|[0-9])(\\.[0-9][0-9_]*)?([eE]_*[-+]?[0-9_]*)?" + FLOAT_SUFFIX + "(?!_)"
                },
                {
                    begin: "\\b([1-9][0-9_]*|0)" + INT_SUFFIX
                }
            ],
            relevance: 0
        }
    ];
    SUBST.contains = CRYSTAL_DEFAULT_CONTAINS;
    EXPANSION.contains = CRYSTAL_DEFAULT_CONTAINS.slice(1); // without EXPANSION
    return {
        aliases: [
            "cr"
        ],
        lexemes: CRYSTAL_IDENT_RE,
        keywords: CRYSTAL_KEYWORDS,
        contains: CRYSTAL_DEFAULT_CONTAINS
    };
};

});

parcelRegister("85w0G", function(module, exports) {
module.exports = function(hljs) {
    var KEYWORDS = {
        keyword: // Normal keywords.
        "abstract as base bool break byte case catch char checked const continue decimal default delegate do double enum event explicit extern finally fixed float for foreach goto if implicit in int interface internal is lock long object operator out override params private protected public readonly ref sbyte sealed short sizeof stackalloc static string struct switch this try typeof uint ulong unchecked unsafe ushort using virtual void volatile while add alias ascending async await by descending dynamic equals from get global group into join let nameof on orderby partial remove select set value var when where yield",
        literal: "null false true"
    };
    var NUMBERS = {
        className: "number",
        variants: [
            {
                begin: "\\b(0b[01']+)"
            },
            {
                begin: "(-?)\\b([\\d']+(\\.[\\d']*)?|\\.[\\d']+)(u|U|l|L|ul|UL|f|F|b|B)"
            },
            {
                begin: "(-?)(\\b0[xX][a-fA-F0-9']+|(\\b[\\d']+(\\.[\\d']*)?|\\.[\\d']+)([eE][-+]?[\\d']+)?)"
            }
        ],
        relevance: 0
    };
    var VERBATIM_STRING = {
        className: "string",
        begin: '@"',
        end: '"',
        contains: [
            {
                begin: '""'
            }
        ]
    };
    var VERBATIM_STRING_NO_LF = hljs.inherit(VERBATIM_STRING, {
        illegal: /\n/
    });
    var SUBST = {
        className: "subst",
        begin: "{",
        end: "}",
        keywords: KEYWORDS
    };
    var SUBST_NO_LF = hljs.inherit(SUBST, {
        illegal: /\n/
    });
    var INTERPOLATED_STRING = {
        className: "string",
        begin: /\$"/,
        end: '"',
        illegal: /\n/,
        contains: [
            {
                begin: "{{"
            },
            {
                begin: "}}"
            },
            hljs.BACKSLASH_ESCAPE,
            SUBST_NO_LF
        ]
    };
    var INTERPOLATED_VERBATIM_STRING = {
        className: "string",
        begin: /\$@"/,
        end: '"',
        contains: [
            {
                begin: "{{"
            },
            {
                begin: "}}"
            },
            {
                begin: '""'
            },
            SUBST
        ]
    };
    var INTERPOLATED_VERBATIM_STRING_NO_LF = hljs.inherit(INTERPOLATED_VERBATIM_STRING, {
        illegal: /\n/,
        contains: [
            {
                begin: "{{"
            },
            {
                begin: "}}"
            },
            {
                begin: '""'
            },
            SUBST_NO_LF
        ]
    });
    SUBST.contains = [
        INTERPOLATED_VERBATIM_STRING,
        INTERPOLATED_STRING,
        VERBATIM_STRING,
        hljs.APOS_STRING_MODE,
        hljs.QUOTE_STRING_MODE,
        NUMBERS,
        hljs.C_BLOCK_COMMENT_MODE
    ];
    SUBST_NO_LF.contains = [
        INTERPOLATED_VERBATIM_STRING_NO_LF,
        INTERPOLATED_STRING,
        VERBATIM_STRING_NO_LF,
        hljs.APOS_STRING_MODE,
        hljs.QUOTE_STRING_MODE,
        NUMBERS,
        hljs.inherit(hljs.C_BLOCK_COMMENT_MODE, {
            illegal: /\n/
        })
    ];
    var STRING = {
        variants: [
            INTERPOLATED_VERBATIM_STRING,
            INTERPOLATED_STRING,
            VERBATIM_STRING,
            hljs.APOS_STRING_MODE,
            hljs.QUOTE_STRING_MODE
        ]
    };
    var TYPE_IDENT_RE = hljs.IDENT_RE + "(<" + hljs.IDENT_RE + "(\\s*,\\s*" + hljs.IDENT_RE + ")*>)?(\\[\\])?";
    return {
        aliases: [
            "csharp",
            "c#"
        ],
        keywords: KEYWORDS,
        illegal: /::/,
        contains: [
            hljs.COMMENT("///", "$", {
                returnBegin: true,
                contains: [
                    {
                        className: "doctag",
                        variants: [
                            {
                                begin: "///",
                                relevance: 0
                            },
                            {
                                begin: "<!--|-->"
                            },
                            {
                                begin: "</?",
                                end: ">"
                            }
                        ]
                    }
                ]
            }),
            hljs.C_LINE_COMMENT_MODE,
            hljs.C_BLOCK_COMMENT_MODE,
            {
                className: "meta",
                begin: "#",
                end: "$",
                keywords: {
                    "meta-keyword": "if else elif endif define undef warning error line region endregion pragma checksum"
                }
            },
            STRING,
            NUMBERS,
            {
                beginKeywords: "class interface",
                end: /[{;=]/,
                illegal: /[^\s:,]/,
                contains: [
                    hljs.TITLE_MODE,
                    hljs.C_LINE_COMMENT_MODE,
                    hljs.C_BLOCK_COMMENT_MODE
                ]
            },
            {
                beginKeywords: "namespace",
                end: /[{;=]/,
                illegal: /[^\s:]/,
                contains: [
                    hljs.inherit(hljs.TITLE_MODE, {
                        begin: "[a-zA-Z](\\.?\\w)*"
                    }),
                    hljs.C_LINE_COMMENT_MODE,
                    hljs.C_BLOCK_COMMENT_MODE
                ]
            },
            {
                // [Attributes("")]
                className: "meta",
                begin: "^\\s*\\[",
                excludeBegin: true,
                end: "\\]",
                excludeEnd: true,
                contains: [
                    {
                        className: "meta-string",
                        begin: /"/,
                        end: /"/
                    }
                ]
            },
            {
                // Expression keywords prevent 'keyword Name(...)' from being
                // recognized as a function definition
                beginKeywords: "new return throw await else",
                relevance: 0
            },
            {
                className: "function",
                begin: "(" + TYPE_IDENT_RE + "\\s+)+" + hljs.IDENT_RE + "\\s*\\(",
                returnBegin: true,
                end: /\s*[{;=]/,
                excludeEnd: true,
                keywords: KEYWORDS,
                contains: [
                    {
                        begin: hljs.IDENT_RE + "\\s*\\(",
                        returnBegin: true,
                        contains: [
                            hljs.TITLE_MODE
                        ],
                        relevance: 0
                    },
                    {
                        className: "params",
                        begin: /\(/,
                        end: /\)/,
                        excludeBegin: true,
                        excludeEnd: true,
                        keywords: KEYWORDS,
                        relevance: 0,
                        contains: [
                            STRING,
                            NUMBERS,
                            hljs.C_BLOCK_COMMENT_MODE
                        ]
                    },
                    hljs.C_LINE_COMMENT_MODE,
                    hljs.C_BLOCK_COMMENT_MODE
                ]
            }
        ]
    };
};

});

parcelRegister("jrFBM", function(module, exports) {
module.exports = function(hljs) {
    return {
        case_insensitive: false,
        lexemes: "[a-zA-Z][a-zA-Z0-9_-]*",
        keywords: {
            keyword: "base-uri child-src connect-src default-src font-src form-action frame-ancestors frame-src img-src media-src object-src plugin-types report-uri sandbox script-src style-src"
        },
        contains: [
            {
                className: "string",
                begin: "'",
                end: "'"
            },
            {
                className: "attribute",
                begin: "^Content",
                end: ":",
                excludeEnd: true
            }
        ]
    };
};

});

parcelRegister("jRcsb", function(module, exports) {
module.exports = function(hljs) {
    var FUNCTION_LIKE = {
        begin: /[\w-]+\(/,
        returnBegin: true,
        contains: [
            {
                className: "built_in",
                begin: /[\w-]+/
            },
            {
                begin: /\(/,
                end: /\)/,
                contains: [
                    hljs.APOS_STRING_MODE,
                    hljs.QUOTE_STRING_MODE,
                    hljs.CSS_NUMBER_MODE
                ]
            }
        ]
    };
    var ATTRIBUTE = {
        className: "attribute",
        begin: /\S/,
        end: ":",
        excludeEnd: true,
        starts: {
            endsWithParent: true,
            excludeEnd: true,
            contains: [
                FUNCTION_LIKE,
                hljs.CSS_NUMBER_MODE,
                hljs.QUOTE_STRING_MODE,
                hljs.APOS_STRING_MODE,
                hljs.C_BLOCK_COMMENT_MODE,
                {
                    className: "number",
                    begin: "#[0-9A-Fa-f]+"
                },
                {
                    className: "meta",
                    begin: "!important"
                }
            ]
        }
    };
    var AT_IDENTIFIER = "@[a-z-]+" // @font-face
    ;
    var AT_MODIFIERS = "and or not only";
    var MEDIA_TYPES = "all print screen speech";
    var AT_PROPERTY_RE = /@\-?\w[\w]*(\-\w+)*/ // @-webkit-keyframes
    ;
    var IDENT_RE = "[a-zA-Z-][a-zA-Z0-9_-]*";
    var RULE = {
        begin: /(?:[A-Z\_\.\-]+|--[a-zA-Z0-9_-]+)\s*:/,
        returnBegin: true,
        end: ";",
        endsWithParent: true,
        contains: [
            ATTRIBUTE
        ]
    };
    return {
        case_insensitive: true,
        illegal: /[=\/|'\$]/,
        contains: [
            hljs.C_BLOCK_COMMENT_MODE,
            {
                className: "selector-id",
                begin: /#[A-Za-z0-9_-]+/
            },
            {
                className: "selector-class",
                begin: /\.[A-Za-z0-9_-]+/
            },
            {
                className: "selector-attr",
                begin: /\[/,
                end: /\]/,
                illegal: "$",
                contains: [
                    hljs.APOS_STRING_MODE,
                    hljs.QUOTE_STRING_MODE
                ]
            },
            {
                className: "selector-pseudo",
                begin: /:(:)?[a-zA-Z0-9\_\-\+\(\)"'.]+/
            },
            // matching these here allows us to treat them more like regular CSS
            // rules so everything between the {} gets regular rule highlighting,
            // which is what we want for page and font-face
            {
                begin: "@(page|font-face)",
                lexemes: AT_IDENTIFIER,
                keywords: "@page @font-face"
            },
            {
                begin: "@",
                end: "[{;]",
                // because it doesn’t let it to be parsed as
                // a rule set but instead drops parser into
                // the default mode which is how it should be.
                illegal: /:/,
                returnBegin: true,
                contains: [
                    {
                        className: "keyword",
                        begin: AT_PROPERTY_RE
                    },
                    {
                        begin: /\s/,
                        endsWithParent: true,
                        excludeEnd: true,
                        relevance: 0,
                        keywords: AT_MODIFIERS,
                        contains: [
                            {
                                begin: /[a-z-]+:/,
                                className: "attribute"
                            },
                            hljs.APOS_STRING_MODE,
                            hljs.QUOTE_STRING_MODE,
                            hljs.CSS_NUMBER_MODE
                        ]
                    }
                ]
            },
            {
                className: "selector-tag",
                begin: IDENT_RE,
                relevance: 0
            },
            {
                begin: "{",
                end: "}",
                illegal: /\S/,
                contains: [
                    hljs.C_BLOCK_COMMENT_MODE,
                    RULE
                ]
            }
        ]
    };
};

});

parcelRegister("4N24D", function(module, exports) {
module.exports = /**
 * Known issues:
 *
 * - invalid hex string literals will be recognized as a double quoted strings
 *   but 'x' at the beginning of string will not be matched
 *
 * - delimited string literals are not checked for matching end delimiter
 *   (not possible to do with js regexp)
 *
 * - content of token string is colored as a string (i.e. no keyword coloring inside a token string)
 *   also, content of token string is not validated to contain only valid D tokens
 *
 * - special token sequence rule is not strictly following D grammar (anything following #line
 *   up to the end of line is matched as special token sequence)
 */ function(hljs) {
    /**
   * Language keywords
   *
   * @type {Object}
   */ var D_KEYWORDS = {
        keyword: "abstract alias align asm assert auto body break byte case cast catch class const continue debug default delete deprecated do else enum export extern final finally for foreach foreach_reverse|10 goto if immutable import in inout int interface invariant is lazy macro mixin module new nothrow out override package pragma private protected public pure ref return scope shared static struct super switch synchronized template this throw try typedef typeid typeof union unittest version void volatile while with __FILE__ __LINE__ __gshared|10 __thread __traits __DATE__ __EOF__ __TIME__ __TIMESTAMP__ __VENDOR__ __VERSION__",
        built_in: "bool cdouble cent cfloat char creal dchar delegate double dstring float function idouble ifloat ireal long real short string ubyte ucent uint ulong ushort wchar wstring",
        literal: "false null true"
    };
    /**
   * Number literal regexps
   *
   * @type {String}
   */ var decimal_integer_re = "(0|[1-9][\\d_]*)", decimal_integer_nosus_re = "(0|[1-9][\\d_]*|\\d[\\d_]*|[\\d_]+?\\d)", binary_integer_re = "0[bB][01_]+", hexadecimal_digits_re = "([\\da-fA-F][\\da-fA-F_]*|_[\\da-fA-F][\\da-fA-F_]*)", hexadecimal_integer_re = "0[xX]" + hexadecimal_digits_re, decimal_exponent_re = "([eE][+-]?" + decimal_integer_nosus_re + ")", decimal_float_re = "(" + decimal_integer_nosus_re + "(\\.\\d*|" + decimal_exponent_re + ")|" + "\\d+\\." + decimal_integer_nosus_re + decimal_integer_nosus_re + "|" + "\\." + decimal_integer_re + decimal_exponent_re + "?" + ")", hexadecimal_float_re = "(0[xX](" + hexadecimal_digits_re + "\\." + hexadecimal_digits_re + "|" + "\\.?" + hexadecimal_digits_re + ")[pP][+-]?" + decimal_integer_nosus_re + ")", integer_re = "(" + decimal_integer_re + "|" + binary_integer_re + "|" + hexadecimal_integer_re + ")", float_re = "(" + hexadecimal_float_re + "|" + decimal_float_re + ")";
    /**
   * Escape sequence supported in D string and character literals
   *
   * @type {String}
   */ var escape_sequence_re = "\\\\(['\"\\?\\\\abfnrtv]|u[\\dA-Fa-f]{4}|[0-7]{1,3}|x[\\dA-Fa-f]{2}|U[\\dA-Fa-f]{8})|&[a-zA-Z\\d]{2,};"; // named character entity
    /**
   * D integer number literals
   *
   * @type {Object}
   */ var D_INTEGER_MODE = {
        className: "number",
        begin: "\\b" + integer_re + "(L|u|U|Lu|LU|uL|UL)?",
        relevance: 0
    };
    /**
   * [D_FLOAT_MODE description]
   * @type {Object}
   */ var D_FLOAT_MODE = {
        className: "number",
        begin: "\\b(" + float_re + "([fF]|L|i|[fF]i|Li)?|" + integer_re + "(i|[fF]i|Li)" + ")",
        relevance: 0
    };
    /**
   * D character literal
   *
   * @type {Object}
   */ var D_CHARACTER_MODE = {
        className: "string",
        begin: "'(" + escape_sequence_re + "|.)",
        end: "'",
        illegal: "."
    };
    /**
   * D string escape sequence
   *
   * @type {Object}
   */ var D_ESCAPE_SEQUENCE = {
        begin: escape_sequence_re,
        relevance: 0
    };
    /**
   * D double quoted string literal
   *
   * @type {Object}
   */ var D_STRING_MODE = {
        className: "string",
        begin: '"',
        contains: [
            D_ESCAPE_SEQUENCE
        ],
        end: '"[cwd]?'
    };
    /**
   * D wysiwyg and delimited string literals
   *
   * @type {Object}
   */ var D_WYSIWYG_DELIMITED_STRING_MODE = {
        className: "string",
        begin: '[rq]"',
        end: '"[cwd]?',
        relevance: 5
    };
    /**
   * D alternate wysiwyg string literal
   *
   * @type {Object}
   */ var D_ALTERNATE_WYSIWYG_STRING_MODE = {
        className: "string",
        begin: "`",
        end: "`[cwd]?"
    };
    /**
   * D hexadecimal string literal
   *
   * @type {Object}
   */ var D_HEX_STRING_MODE = {
        className: "string",
        begin: 'x"[\\da-fA-F\\s\\n\\r]*"[cwd]?',
        relevance: 10
    };
    /**
   * D delimited string literal
   *
   * @type {Object}
   */ var D_TOKEN_STRING_MODE = {
        className: "string",
        begin: 'q"\\{',
        end: '\\}"'
    };
    /**
   * Hashbang support
   *
   * @type {Object}
   */ var D_HASHBANG_MODE = {
        className: "meta",
        begin: "^#!",
        end: "$",
        relevance: 5
    };
    /**
   * D special token sequence
   *
   * @type {Object}
   */ var D_SPECIAL_TOKEN_SEQUENCE_MODE = {
        className: "meta",
        begin: "#(line)",
        end: "$",
        relevance: 5
    };
    /**
   * D attributes
   *
   * @type {Object}
   */ var D_ATTRIBUTE_MODE = {
        className: "keyword",
        begin: "@[a-zA-Z_][a-zA-Z_\\d]*"
    };
    /**
   * D nesting comment
   *
   * @type {Object}
   */ var D_NESTING_COMMENT_MODE = hljs.COMMENT("\\/\\+", "\\+\\/", {
        contains: [
            "self"
        ],
        relevance: 10
    });
    return {
        lexemes: hljs.UNDERSCORE_IDENT_RE,
        keywords: D_KEYWORDS,
        contains: [
            hljs.C_LINE_COMMENT_MODE,
            hljs.C_BLOCK_COMMENT_MODE,
            D_NESTING_COMMENT_MODE,
            D_HEX_STRING_MODE,
            D_STRING_MODE,
            D_WYSIWYG_DELIMITED_STRING_MODE,
            D_ALTERNATE_WYSIWYG_STRING_MODE,
            D_TOKEN_STRING_MODE,
            D_FLOAT_MODE,
            D_INTEGER_MODE,
            D_CHARACTER_MODE,
            D_HASHBANG_MODE,
            D_SPECIAL_TOKEN_SEQUENCE_MODE,
            D_ATTRIBUTE_MODE
        ]
    };
};

});

parcelRegister("c1rMz", function(module, exports) {
module.exports = function(hljs) {
    return {
        aliases: [
            "md",
            "mkdown",
            "mkd"
        ],
        contains: [
            // highlight headers
            {
                className: "section",
                variants: [
                    {
                        begin: "^#{1,6}",
                        end: "$"
                    },
                    {
                        begin: "^.+?\\n[=-]{2,}$"
                    }
                ]
            },
            // inline html
            {
                begin: "<",
                end: ">",
                subLanguage: "xml",
                relevance: 0
            },
            // lists (indicators only)
            {
                className: "bullet",
                begin: "^\\s*([*+-]|(\\d+\\.))\\s+"
            },
            // strong segments
            {
                className: "strong",
                begin: "[*_]{2}.+?[*_]{2}"
            },
            // emphasis segments
            {
                className: "emphasis",
                variants: [
                    {
                        begin: "\\*.+?\\*"
                    },
                    {
                        begin: "_.+?_",
                        relevance: 0
                    }
                ]
            },
            // blockquotes
            {
                className: "quote",
                begin: "^>\\s+",
                end: "$"
            },
            // code snippets
            {
                className: "code",
                variants: [
                    {
                        begin: "^```\\w*\\s*$",
                        end: "^```[ ]*$"
                    },
                    {
                        begin: "`.+?`"
                    },
                    {
                        begin: "^( {4}|\\t)",
                        end: "$",
                        relevance: 0
                    }
                ]
            },
            // horizontal rules
            {
                begin: "^[-\\*]{3,}",
                end: "$"
            },
            // using links - title and link
            {
                begin: "\\[.+?\\][\\(\\[].*?[\\)\\]]",
                returnBegin: true,
                contains: [
                    {
                        className: "string",
                        begin: "\\[",
                        end: "\\]",
                        excludeBegin: true,
                        returnEnd: true,
                        relevance: 0
                    },
                    {
                        className: "link",
                        begin: "\\]\\(",
                        end: "\\)",
                        excludeBegin: true,
                        excludeEnd: true
                    },
                    {
                        className: "symbol",
                        begin: "\\]\\[",
                        end: "\\]",
                        excludeBegin: true,
                        excludeEnd: true
                    }
                ],
                relevance: 10
            },
            {
                begin: /^\[[^\n]+\]:/,
                returnBegin: true,
                contains: [
                    {
                        className: "symbol",
                        begin: /\[/,
                        end: /\]/,
                        excludeBegin: true,
                        excludeEnd: true
                    },
                    {
                        className: "link",
                        begin: /:\s*/,
                        end: /$/,
                        excludeBegin: true
                    }
                ]
            }
        ]
    };
};

});

parcelRegister("iUUCy", function(module, exports) {
module.exports = function(hljs) {
    var SUBST = {
        className: "subst",
        variants: [
            {
                begin: "\\$[A-Za-z0-9_]+"
            }
        ]
    };
    var BRACED_SUBST = {
        className: "subst",
        variants: [
            {
                begin: "\\${",
                end: "}"
            }
        ],
        keywords: "true false null this is new super"
    };
    var STRING = {
        className: "string",
        variants: [
            {
                begin: "r'''",
                end: "'''"
            },
            {
                begin: 'r"""',
                end: '"""'
            },
            {
                begin: "r'",
                end: "'",
                illegal: "\\n"
            },
            {
                begin: 'r"',
                end: '"',
                illegal: "\\n"
            },
            {
                begin: "'''",
                end: "'''",
                contains: [
                    hljs.BACKSLASH_ESCAPE,
                    SUBST,
                    BRACED_SUBST
                ]
            },
            {
                begin: '"""',
                end: '"""',
                contains: [
                    hljs.BACKSLASH_ESCAPE,
                    SUBST,
                    BRACED_SUBST
                ]
            },
            {
                begin: "'",
                end: "'",
                illegal: "\\n",
                contains: [
                    hljs.BACKSLASH_ESCAPE,
                    SUBST,
                    BRACED_SUBST
                ]
            },
            {
                begin: '"',
                end: '"',
                illegal: "\\n",
                contains: [
                    hljs.BACKSLASH_ESCAPE,
                    SUBST,
                    BRACED_SUBST
                ]
            }
        ]
    };
    BRACED_SUBST.contains = [
        hljs.C_NUMBER_MODE,
        STRING
    ];
    var KEYWORDS = {
        keyword: "abstract as assert async await break case catch class const continue covariant default deferred do dynamic else enum export extends extension external factory false final finally for Function get hide if implements import in inferface is library mixin new null on operator part rethrow return set show static super switch sync this throw true try typedef var void while with yield",
        built_in: // dart:core
        "Comparable DateTime Duration Function Iterable Iterator List Map Match Null Object Pattern RegExp Set Stopwatch String StringBuffer StringSink Symbol Type Uri bool double dynamic int num print Element ElementList document querySelector querySelectorAll window"
    };
    return {
        keywords: KEYWORDS,
        contains: [
            STRING,
            hljs.COMMENT("/\\*\\*", "\\*/", {
                subLanguage: "markdown"
            }),
            hljs.COMMENT("///+\\s*", "$", {
                contains: [
                    {
                        subLanguage: "markdown",
                        begin: ".",
                        end: "$"
                    }
                ]
            }),
            hljs.C_LINE_COMMENT_MODE,
            hljs.C_BLOCK_COMMENT_MODE,
            {
                className: "class",
                beginKeywords: "class interface",
                end: "{",
                excludeEnd: true,
                contains: [
                    {
                        beginKeywords: "extends implements"
                    },
                    hljs.UNDERSCORE_TITLE_MODE
                ]
            },
            hljs.C_NUMBER_MODE,
            {
                className: "meta",
                begin: "@[A-Za-z]+"
            },
            {
                begin: "=>" // No markup, just a relevance booster
            }
        ]
    };
};

});

parcelRegister("7Nt9h", function(module, exports) {
module.exports = function(hljs) {
    var KEYWORDS = "exports register file shl array record property for mod while set ally label uses raise not stored class safecall var interface or private static exit index inherited to else stdcall override shr asm far resourcestring finalization packed virtual out and protected library do xorwrite goto near function end div overload object unit begin string on inline repeat until destructor write message program with read initialization except default nil if case cdecl in downto threadvar of try pascal const external constructor type public then implementation finally published procedure absolute reintroduce operator as is abstract alias assembler bitpacked break continue cppdecl cvar enumerator experimental platform deprecated unimplemented dynamic export far16 forward generic helper implements interrupt iochecks local name nodefault noreturn nostackframe oldfpccall otherwise saveregisters softfloat specialize strict unaligned varargs ";
    var COMMENT_MODES = [
        hljs.C_LINE_COMMENT_MODE,
        hljs.COMMENT(/\{/, /\}/, {
            relevance: 0
        }),
        hljs.COMMENT(/\(\*/, /\*\)/, {
            relevance: 10
        })
    ];
    var DIRECTIVE = {
        className: "meta",
        variants: [
            {
                begin: /\{\$/,
                end: /\}/
            },
            {
                begin: /\(\*\$/,
                end: /\*\)/
            }
        ]
    };
    var STRING = {
        className: "string",
        begin: /'/,
        end: /'/,
        contains: [
            {
                begin: /''/
            }
        ]
    };
    var CHAR_STRING = {
        className: "string",
        begin: /(#\d+)+/
    };
    var CLASS = {
        begin: hljs.IDENT_RE + "\\s*=\\s*class\\s*\\(",
        returnBegin: true,
        contains: [
            hljs.TITLE_MODE
        ]
    };
    var FUNCTION = {
        className: "function",
        beginKeywords: "function constructor destructor procedure",
        end: /[:;]/,
        keywords: "function constructor|10 destructor|10 procedure|10",
        contains: [
            hljs.TITLE_MODE,
            {
                className: "params",
                begin: /\(/,
                end: /\)/,
                keywords: KEYWORDS,
                contains: [
                    STRING,
                    CHAR_STRING,
                    DIRECTIVE
                ].concat(COMMENT_MODES)
            },
            DIRECTIVE
        ].concat(COMMENT_MODES)
    };
    return {
        aliases: [
            "dpr",
            "dfm",
            "pas",
            "pascal",
            "freepascal",
            "lazarus",
            "lpr",
            "lfm"
        ],
        case_insensitive: true,
        keywords: KEYWORDS,
        illegal: /"|\$[G-Zg-z]|\/\*|<\/|\|/,
        contains: [
            STRING,
            CHAR_STRING,
            hljs.NUMBER_MODE,
            CLASS,
            FUNCTION,
            DIRECTIVE
        ].concat(COMMENT_MODES)
    };
};

});

parcelRegister("7CY40", function(module, exports) {
module.exports = function(hljs) {
    return {
        aliases: [
            "patch"
        ],
        contains: [
            {
                className: "meta",
                relevance: 10,
                variants: [
                    {
                        begin: /^@@ +\-\d+,\d+ +\+\d+,\d+ +@@$/
                    },
                    {
                        begin: /^\*\*\* +\d+,\d+ +\*\*\*\*$/
                    },
                    {
                        begin: /^\-\-\- +\d+,\d+ +\-\-\-\-$/
                    }
                ]
            },
            {
                className: "comment",
                variants: [
                    {
                        begin: /Index: /,
                        end: /$/
                    },
                    {
                        begin: /={3,}/,
                        end: /$/
                    },
                    {
                        begin: /^\-{3}/,
                        end: /$/
                    },
                    {
                        begin: /^\*{3} /,
                        end: /$/
                    },
                    {
                        begin: /^\+{3}/,
                        end: /$/
                    },
                    {
                        begin: /^\*{15}$/
                    }
                ]
            },
            {
                className: "addition",
                begin: "^\\+",
                end: "$"
            },
            {
                className: "deletion",
                begin: "^\\-",
                end: "$"
            },
            {
                className: "addition",
                begin: "^\\!",
                end: "$"
            }
        ]
    };
};

});

parcelRegister("hSwnX", function(module, exports) {
module.exports = function(hljs) {
    var FILTER = {
        begin: /\|[A-Za-z]+:?/,
        keywords: {
            name: "truncatewords removetags linebreaksbr yesno get_digit timesince random striptags filesizeformat escape linebreaks length_is ljust rjust cut urlize fix_ampersands title floatformat capfirst pprint divisibleby add make_list unordered_list urlencode timeuntil urlizetrunc wordcount stringformat linenumbers slice date dictsort dictsortreversed default_if_none pluralize lower join center default truncatewords_html upper length phone2numeric wordwrap time addslashes slugify first escapejs force_escape iriencode last safe safeseq truncatechars localize unlocalize localtime utc timezone"
        },
        contains: [
            hljs.QUOTE_STRING_MODE,
            hljs.APOS_STRING_MODE
        ]
    };
    return {
        aliases: [
            "jinja"
        ],
        case_insensitive: true,
        subLanguage: "xml",
        contains: [
            hljs.COMMENT(/\{%\s*comment\s*%}/, /\{%\s*endcomment\s*%}/),
            hljs.COMMENT(/\{#/, /#}/),
            {
                className: "template-tag",
                begin: /\{%/,
                end: /%}/,
                contains: [
                    {
                        className: "name",
                        begin: /\w+/,
                        keywords: {
                            name: "comment endcomment load templatetag ifchanged endifchanged if endif firstof for endfor ifnotequal endifnotequal widthratio extends include spaceless endspaceless regroup ifequal endifequal ssi now with cycle url filter endfilter debug block endblock else autoescape endautoescape csrf_token empty elif endwith static trans blocktrans endblocktrans get_static_prefix get_media_prefix plural get_current_language language get_available_languages get_current_language_bidi get_language_info get_language_info_list localize endlocalize localtime endlocaltime timezone endtimezone get_current_timezone verbatim"
                        },
                        starts: {
                            endsWithParent: true,
                            keywords: "in by as",
                            contains: [
                                FILTER
                            ],
                            relevance: 0
                        }
                    }
                ]
            },
            {
                className: "template-variable",
                begin: /\{\{/,
                end: /}}/,
                contains: [
                    FILTER
                ]
            }
        ]
    };
};

});

parcelRegister("eb8CG", function(module, exports) {
module.exports = function(hljs) {
    return {
        aliases: [
            "bind",
            "zone"
        ],
        keywords: {
            keyword: "IN A AAAA AFSDB APL CAA CDNSKEY CDS CERT CNAME DHCID DLV DNAME DNSKEY DS HIP IPSECKEY KEY KX LOC MX NAPTR NS NSEC NSEC3 NSEC3PARAM PTR RRSIG RP SIG SOA SRV SSHFP TA TKEY TLSA TSIG TXT"
        },
        contains: [
            hljs.COMMENT(";", "$", {
                relevance: 0
            }),
            {
                className: "meta",
                begin: /^\$(TTL|GENERATE|INCLUDE|ORIGIN)\b/
            },
            // IPv6
            {
                className: "number",
                begin: "((([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)(\\.(25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)(\\.(25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)(\\.(25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)(\\.(25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)(\\.(25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){1}(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)(\\.(25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)(\\.(25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)){3}))|:)))\\b"
            },
            // IPv4
            {
                className: "number",
                begin: "((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]).){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\\b"
            },
            hljs.inherit(hljs.NUMBER_MODE, {
                begin: /\b\d+[dhwm]?/
            })
        ]
    };
};

});

parcelRegister("5nRkt", function(module, exports) {
module.exports = function(hljs) {
    return {
        aliases: [
            "docker"
        ],
        case_insensitive: true,
        keywords: "from maintainer expose env arg user onbuild stopsignal",
        contains: [
            hljs.HASH_COMMENT_MODE,
            hljs.APOS_STRING_MODE,
            hljs.QUOTE_STRING_MODE,
            hljs.NUMBER_MODE,
            {
                beginKeywords: "run cmd entrypoint volume add copy workdir label healthcheck shell",
                starts: {
                    end: /[^\\]$/,
                    subLanguage: "bash"
                }
            }
        ],
        illegal: "</"
    };
};

});

parcelRegister("9jpnQ", function(module, exports) {
module.exports = function(hljs) {
    var COMMENT = hljs.COMMENT(/^\s*@?rem\b/, /$/, {
        relevance: 10
    });
    var LABEL = {
        className: "symbol",
        begin: "^\\s*[A-Za-z._?][A-Za-z0-9_$#@~.?]*(:|\\s+label)",
        relevance: 0
    };
    return {
        aliases: [
            "bat",
            "cmd"
        ],
        case_insensitive: true,
        illegal: /\/\*/,
        keywords: {
            keyword: "if else goto for in do call exit not exist errorlevel defined equ neq lss leq gtr geq",
            built_in: "prn nul lpt3 lpt2 lpt1 con com4 com3 com2 com1 aux shift cd dir echo setlocal endlocal set pause copy append assoc at attrib break cacls cd chcp chdir chkdsk chkntfs cls cmd color comp compact convert date dir diskcomp diskcopy doskey erase fs find findstr format ftype graftabl help keyb label md mkdir mode more move path pause print popd pushd promt rd recover rem rename replace restore rmdir shiftsort start subst time title tree type ver verify vol ping net ipconfig taskkill xcopy ren del"
        },
        contains: [
            {
                className: "variable",
                begin: /%%[^ ]|%[^ ]+?%|![^ ]+?!/
            },
            {
                className: "function",
                begin: LABEL.begin,
                end: "goto:eof",
                contains: [
                    hljs.inherit(hljs.TITLE_MODE, {
                        begin: "([_a-zA-Z]\\w*\\.)*([_a-zA-Z]\\w*:)?[_a-zA-Z]\\w*"
                    }),
                    COMMENT
                ]
            },
            {
                className: "number",
                begin: "\\b\\d+",
                relevance: 0
            },
            COMMENT
        ]
    };
};

});

parcelRegister("3ipgz", function(module, exports) {
module.exports = function(hljs) {
    var QUOTED_PROPERTY = {
        className: "string",
        begin: /"/,
        end: /"/
    };
    var APOS_PROPERTY = {
        className: "string",
        begin: /'/,
        end: /'/
    };
    var UNQUOTED_PROPERTY = {
        className: "string",
        begin: "[\\w-?]+:\\w+",
        end: "\\W",
        relevance: 0
    };
    var VALUELESS_PROPERTY = {
        className: "string",
        begin: "\\w+-?\\w+",
        end: "\\W",
        relevance: 0
    };
    return {
        keywords: "dsconfig",
        contains: [
            {
                className: "keyword",
                begin: "^dsconfig",
                end: "\\s",
                excludeEnd: true,
                relevance: 10
            },
            {
                className: "built_in",
                begin: "(list|create|get|set|delete)-(\\w+)",
                end: "\\s",
                excludeEnd: true,
                illegal: "!@#$%^&*()",
                relevance: 10
            },
            {
                className: "built_in",
                begin: "--(\\w+)",
                end: "\\s",
                excludeEnd: true
            },
            QUOTED_PROPERTY,
            APOS_PROPERTY,
            UNQUOTED_PROPERTY,
            VALUELESS_PROPERTY,
            hljs.HASH_COMMENT_MODE
        ]
    };
};

});

parcelRegister("gntgi", function(module, exports) {
module.exports = function(hljs) {
    var STRINGS = {
        className: "string",
        variants: [
            hljs.inherit(hljs.QUOTE_STRING_MODE, {
                begin: '((u8?|U)|L)?"'
            }),
            {
                begin: '(u8?|U)?R"',
                end: '"',
                contains: [
                    hljs.BACKSLASH_ESCAPE
                ]
            },
            {
                begin: "'\\\\?.",
                end: "'",
                illegal: "."
            }
        ]
    };
    var NUMBERS = {
        className: "number",
        variants: [
            {
                begin: "\\b(\\d+(\\.\\d*)?|\\.\\d+)(u|U|l|L|ul|UL|f|F)"
            },
            {
                begin: hljs.C_NUMBER_RE
            }
        ],
        relevance: 0
    };
    var PREPROCESSOR = {
        className: "meta",
        begin: "#",
        end: "$",
        keywords: {
            "meta-keyword": "if else elif endif define undef ifdef ifndef"
        },
        contains: [
            {
                begin: /\\\n/,
                relevance: 0
            },
            {
                beginKeywords: "include",
                end: "$",
                keywords: {
                    "meta-keyword": "include"
                },
                contains: [
                    hljs.inherit(STRINGS, {
                        className: "meta-string"
                    }),
                    {
                        className: "meta-string",
                        begin: "<",
                        end: ">",
                        illegal: "\\n"
                    }
                ]
            },
            STRINGS,
            hljs.C_LINE_COMMENT_MODE,
            hljs.C_BLOCK_COMMENT_MODE
        ]
    };
    var DTS_REFERENCE = {
        className: "variable",
        begin: "\\&[a-z\\d_]*\\b"
    };
    var DTS_KEYWORD = {
        className: "meta-keyword",
        begin: "/[a-z][a-z\\d-]*/"
    };
    var DTS_LABEL = {
        className: "symbol",
        begin: "^\\s*[a-zA-Z_][a-zA-Z\\d_]*:"
    };
    var DTS_CELL_PROPERTY = {
        className: "params",
        begin: "<",
        end: ">",
        contains: [
            NUMBERS,
            DTS_REFERENCE
        ]
    };
    var DTS_NODE = {
        className: "class",
        begin: /[a-zA-Z_][a-zA-Z\d_@]*\s{/,
        end: /[{;=]/,
        returnBegin: true,
        excludeEnd: true
    };
    var DTS_ROOT_NODE = {
        className: "class",
        begin: "/\\s*{",
        end: "};",
        relevance: 10,
        contains: [
            DTS_REFERENCE,
            DTS_KEYWORD,
            DTS_LABEL,
            DTS_NODE,
            DTS_CELL_PROPERTY,
            hljs.C_LINE_COMMENT_MODE,
            hljs.C_BLOCK_COMMENT_MODE,
            NUMBERS,
            STRINGS
        ]
    };
    return {
        keywords: "",
        contains: [
            DTS_ROOT_NODE,
            DTS_REFERENCE,
            DTS_KEYWORD,
            DTS_LABEL,
            DTS_NODE,
            DTS_CELL_PROPERTY,
            hljs.C_LINE_COMMENT_MODE,
            hljs.C_BLOCK_COMMENT_MODE,
            NUMBERS,
            STRINGS,
            PREPROCESSOR,
            {
                begin: hljs.IDENT_RE + "::",
                keywords: ""
            }
        ]
    };
};

});

parcelRegister("4CIEe", function(module, exports) {
module.exports = function(hljs) {
    var EXPRESSION_KEYWORDS = "if eq ne lt lte gt gte select default math sep";
    return {
        aliases: [
            "dst"
        ],
        case_insensitive: true,
        subLanguage: "xml",
        contains: [
            {
                className: "template-tag",
                begin: /\{[#\/]/,
                end: /\}/,
                illegal: /;/,
                contains: [
                    {
                        className: "name",
                        begin: /[a-zA-Z\.-]+/,
                        starts: {
                            endsWithParent: true,
                            relevance: 0,
                            contains: [
                                hljs.QUOTE_STRING_MODE
                            ]
                        }
                    }
                ]
            },
            {
                className: "template-variable",
                begin: /\{/,
                end: /\}/,
                illegal: /;/,
                keywords: EXPRESSION_KEYWORDS
            }
        ]
    };
};

});

parcelRegister("ahRAo", function(module, exports) {
module.exports = function(hljs) {
    var commentMode = hljs.COMMENT(/\(\*/, /\*\)/);
    var nonTerminalMode = {
        className: "attribute",
        begin: /^[ ]*[a-zA-Z][a-zA-Z-_]*([\s-_]+[a-zA-Z][a-zA-Z]*)*/
    };
    var specialSequenceMode = {
        className: "meta",
        begin: /\?.*\?/
    };
    var ruleBodyMode = {
        begin: /=/,
        end: /[.;]/,
        contains: [
            commentMode,
            specialSequenceMode,
            {
                // terminals
                className: "string",
                variants: [
                    hljs.APOS_STRING_MODE,
                    hljs.QUOTE_STRING_MODE,
                    {
                        begin: "`",
                        end: "`"
                    }
                ]
            }
        ]
    };
    return {
        illegal: /\S/,
        contains: [
            commentMode,
            nonTerminalMode,
            ruleBodyMode
        ]
    };
};

});

parcelRegister("b2fxC", function(module, exports) {
module.exports = function(hljs) {
    var ELIXIR_IDENT_RE = "[a-zA-Z_][a-zA-Z0-9_.]*(\\!|\\?)?";
    var ELIXIR_METHOD_RE = "[a-zA-Z_]\\w*[!?=]?|[-+~]\\@|<<|>>|=~|===?|<=>|[<>]=?|\\*\\*|[-/+%^&*~`|]|\\[\\]=?";
    var ELIXIR_KEYWORDS = "and false then defined module in return redo retry end for true self when next until do begin unless nil break not case cond alias while ensure or include use alias fn quote require import with|0";
    var SUBST = {
        className: "subst",
        begin: "#\\{",
        end: "}",
        lexemes: ELIXIR_IDENT_RE,
        keywords: ELIXIR_KEYWORDS
    };
    var SIGIL_DELIMITERS = "[/|([{<\"']";
    var LOWERCASE_SIGIL = {
        className: "string",
        begin: "~[a-z](?=" + SIGIL_DELIMITERS + ")",
        contains: [
            {
                endsParent: true,
                contains: [
                    {
                        contains: [
                            hljs.BACKSLASH_ESCAPE,
                            SUBST
                        ],
                        variants: [
                            {
                                begin: /"/,
                                end: /"/
                            },
                            {
                                begin: /'/,
                                end: /'/
                            },
                            {
                                begin: /\//,
                                end: /\//
                            },
                            {
                                begin: /\|/,
                                end: /\|/
                            },
                            {
                                begin: /\(/,
                                end: /\)/
                            },
                            {
                                begin: /\[/,
                                end: /\]/
                            },
                            {
                                begin: /\{/,
                                end: /\}/
                            },
                            {
                                begin: /</,
                                end: />/
                            }
                        ]
                    }
                ]
            }
        ]
    };
    var UPCASE_SIGIL = {
        className: "string",
        begin: "~[A-Z](?=" + SIGIL_DELIMITERS + ")",
        contains: [
            {
                begin: /"/,
                end: /"/
            },
            {
                begin: /'/,
                end: /'/
            },
            {
                begin: /\//,
                end: /\//
            },
            {
                begin: /\|/,
                end: /\|/
            },
            {
                begin: /\(/,
                end: /\)/
            },
            {
                begin: /\[/,
                end: /\]/
            },
            {
                begin: /\{/,
                end: /\}/
            },
            {
                begin: /\</,
                end: /\>/
            }
        ]
    };
    var STRING = {
        className: "string",
        contains: [
            hljs.BACKSLASH_ESCAPE,
            SUBST
        ],
        variants: [
            {
                begin: /"""/,
                end: /"""/
            },
            {
                begin: /'''/,
                end: /'''/
            },
            {
                begin: /~S"""/,
                end: /"""/,
                contains: []
            },
            {
                begin: /~S"/,
                end: /"/,
                contains: []
            },
            {
                begin: /~S'''/,
                end: /'''/,
                contains: []
            },
            {
                begin: /~S'/,
                end: /'/,
                contains: []
            },
            {
                begin: /'/,
                end: /'/
            },
            {
                begin: /"/,
                end: /"/
            }
        ]
    };
    var FUNCTION = {
        className: "function",
        beginKeywords: "def defp defmacro",
        end: /\B\b/,
        contains: [
            hljs.inherit(hljs.TITLE_MODE, {
                begin: ELIXIR_IDENT_RE,
                endsParent: true
            })
        ]
    };
    var CLASS = hljs.inherit(FUNCTION, {
        className: "class",
        beginKeywords: "defimpl defmodule defprotocol defrecord",
        end: /\bdo\b|$|;/
    });
    var ELIXIR_DEFAULT_CONTAINS = [
        STRING,
        UPCASE_SIGIL,
        LOWERCASE_SIGIL,
        hljs.HASH_COMMENT_MODE,
        CLASS,
        FUNCTION,
        {
            begin: "::"
        },
        {
            className: "symbol",
            begin: ":(?![\\s:])",
            contains: [
                STRING,
                {
                    begin: ELIXIR_METHOD_RE
                }
            ],
            relevance: 0
        },
        {
            className: "symbol",
            begin: ELIXIR_IDENT_RE + ":(?!:)",
            relevance: 0
        },
        {
            className: "number",
            begin: "(\\b0o[0-7_]+)|(\\b0b[01_]+)|(\\b0x[0-9a-fA-F_]+)|(-?\\b[1-9][0-9_]*(.[0-9_]+([eE][-+]?[0-9]+)?)?)",
            relevance: 0
        },
        {
            className: "variable",
            begin: "(\\$\\W)|((\\$|\\@\\@?)(\\w+))"
        },
        {
            begin: "->"
        },
        {
            begin: "(" + hljs.RE_STARTERS_RE + ")\\s*",
            contains: [
                hljs.HASH_COMMENT_MODE,
                {
                    className: "regexp",
                    illegal: "\\n",
                    contains: [
                        hljs.BACKSLASH_ESCAPE,
                        SUBST
                    ],
                    variants: [
                        {
                            begin: "/",
                            end: "/[a-z]*"
                        },
                        {
                            begin: "%r\\[",
                            end: "\\][a-z]*"
                        }
                    ]
                }
            ],
            relevance: 0
        }
    ];
    SUBST.contains = ELIXIR_DEFAULT_CONTAINS;
    return {
        lexemes: ELIXIR_IDENT_RE,
        keywords: ELIXIR_KEYWORDS,
        contains: ELIXIR_DEFAULT_CONTAINS
    };
};

});

parcelRegister("j8dfG", function(module, exports) {
module.exports = function(hljs) {
    var COMMENT = {
        variants: [
            hljs.COMMENT("--", "$"),
            hljs.COMMENT("{-", "-}", {
                contains: [
                    "self"
                ]
            })
        ]
    };
    var CONSTRUCTOR = {
        className: "type",
        begin: "\\b[A-Z][\\w']*",
        relevance: 0
    };
    var LIST = {
        begin: "\\(",
        end: "\\)",
        illegal: '"',
        contains: [
            {
                className: "type",
                begin: "\\b[A-Z][\\w]*(\\((\\.\\.|,|\\w+)\\))?"
            },
            COMMENT
        ]
    };
    var RECORD = {
        begin: "{",
        end: "}",
        contains: LIST.contains
    };
    var CHARACTER = {
        className: "string",
        begin: "'\\\\?.",
        end: "'",
        illegal: "."
    };
    return {
        keywords: "let in if then else case of where module import exposing type alias as infix infixl infixr port effect command subscription",
        contains: [
            // Top-level constructions.
            {
                beginKeywords: "port effect module",
                end: "exposing",
                keywords: "port effect module where command subscription exposing",
                contains: [
                    LIST,
                    COMMENT
                ],
                illegal: "\\W\\.|;"
            },
            {
                begin: "import",
                end: "$",
                keywords: "import as exposing",
                contains: [
                    LIST,
                    COMMENT
                ],
                illegal: "\\W\\.|;"
            },
            {
                begin: "type",
                end: "$",
                keywords: "type alias",
                contains: [
                    CONSTRUCTOR,
                    LIST,
                    RECORD,
                    COMMENT
                ]
            },
            {
                beginKeywords: "infix infixl infixr",
                end: "$",
                contains: [
                    hljs.C_NUMBER_MODE,
                    COMMENT
                ]
            },
            {
                begin: "port",
                end: "$",
                keywords: "port",
                contains: [
                    COMMENT
                ]
            },
            // Literals and names.
            CHARACTER,
            hljs.QUOTE_STRING_MODE,
            hljs.C_NUMBER_MODE,
            CONSTRUCTOR,
            hljs.inherit(hljs.TITLE_MODE, {
                begin: "^[_a-z][\\w']*"
            }),
            COMMENT,
            {
                begin: "->|<-"
            } // No markup, relevance booster
        ],
        illegal: /;/
    };
};

});

parcelRegister("6ykfy", function(module, exports) {
module.exports = function(hljs) {
    var RUBY_METHOD_RE = "[a-zA-Z_]\\w*[!?=]?|[-+~]\\@|<<|>>|=~|===?|<=>|[<>]=?|\\*\\*|[-/+%^&*~`|]|\\[\\]=?";
    var RUBY_KEYWORDS = {
        keyword: "and then defined module in return redo if BEGIN retry end for self when next until do begin unless END rescue else break undef not super class case require yield alias while ensure elsif or include attr_reader attr_writer attr_accessor",
        literal: "true false nil"
    };
    var YARDOCTAG = {
        className: "doctag",
        begin: "@[A-Za-z]+"
    };
    var IRB_OBJECT = {
        begin: "#<",
        end: ">"
    };
    var COMMENT_MODES = [
        hljs.COMMENT("#", "$", {
            contains: [
                YARDOCTAG
            ]
        }),
        hljs.COMMENT("^\\=begin", "^\\=end", {
            contains: [
                YARDOCTAG
            ],
            relevance: 10
        }),
        hljs.COMMENT("^__END__", "\\n$")
    ];
    var SUBST = {
        className: "subst",
        begin: "#\\{",
        end: "}",
        keywords: RUBY_KEYWORDS
    };
    var STRING = {
        className: "string",
        contains: [
            hljs.BACKSLASH_ESCAPE,
            SUBST
        ],
        variants: [
            {
                begin: /'/,
                end: /'/
            },
            {
                begin: /"/,
                end: /"/
            },
            {
                begin: /`/,
                end: /`/
            },
            {
                begin: "%[qQwWx]?\\(",
                end: "\\)"
            },
            {
                begin: "%[qQwWx]?\\[",
                end: "\\]"
            },
            {
                begin: "%[qQwWx]?{",
                end: "}"
            },
            {
                begin: "%[qQwWx]?<",
                end: ">"
            },
            {
                begin: "%[qQwWx]?/",
                end: "/"
            },
            {
                begin: "%[qQwWx]?%",
                end: "%"
            },
            {
                begin: "%[qQwWx]?-",
                end: "-"
            },
            {
                begin: "%[qQwWx]?\\|",
                end: "\\|"
            },
            {
                // \B in the beginning suppresses recognition of ?-sequences where ?
                // is the last character of a preceding identifier, as in: `func?4`
                begin: /\B\?(\\\d{1,3}|\\x[A-Fa-f0-9]{1,2}|\\u[A-Fa-f0-9]{4}|\\?\S)\b/
            },
            {
                begin: /<<[-~]?'?(\w+)(?:.|\n)*?\n\s*\1\b/,
                returnBegin: true,
                contains: [
                    {
                        begin: /<<[-~]?'?/
                    },
                    {
                        begin: /\w+/,
                        endSameAsBegin: true,
                        contains: [
                            hljs.BACKSLASH_ESCAPE,
                            SUBST
                        ]
                    }
                ]
            }
        ]
    };
    var PARAMS = {
        className: "params",
        begin: "\\(",
        end: "\\)",
        endsParent: true,
        keywords: RUBY_KEYWORDS
    };
    var RUBY_DEFAULT_CONTAINS = [
        STRING,
        IRB_OBJECT,
        {
            className: "class",
            beginKeywords: "class module",
            end: "$|;",
            illegal: /=/,
            contains: [
                hljs.inherit(hljs.TITLE_MODE, {
                    begin: "[A-Za-z_]\\w*(::\\w+)*(\\?|\\!)?"
                }),
                {
                    begin: "<\\s*",
                    contains: [
                        {
                            begin: "(" + hljs.IDENT_RE + "::)?" + hljs.IDENT_RE
                        }
                    ]
                }
            ].concat(COMMENT_MODES)
        },
        {
            className: "function",
            beginKeywords: "def",
            end: "$|;",
            contains: [
                hljs.inherit(hljs.TITLE_MODE, {
                    begin: RUBY_METHOD_RE
                }),
                PARAMS
            ].concat(COMMENT_MODES)
        },
        {
            // swallow namespace qualifiers before symbols
            begin: hljs.IDENT_RE + "::"
        },
        {
            className: "symbol",
            begin: hljs.UNDERSCORE_IDENT_RE + "(\\!|\\?)?:",
            relevance: 0
        },
        {
            className: "symbol",
            begin: ":(?!\\s)",
            contains: [
                STRING,
                {
                    begin: RUBY_METHOD_RE
                }
            ],
            relevance: 0
        },
        {
            className: "number",
            begin: "(\\b0[0-7_]+)|(\\b0x[0-9a-fA-F_]+)|(\\b[1-9][0-9_]*(\\.[0-9_]+)?)|[0_]\\b",
            relevance: 0
        },
        {
            begin: "(\\$\\W)|((\\$|\\@\\@?)(\\w+))" // variables
        },
        {
            className: "params",
            begin: /\|/,
            end: /\|/,
            keywords: RUBY_KEYWORDS
        },
        {
            begin: "(" + hljs.RE_STARTERS_RE + "|unless)\\s*",
            keywords: "unless",
            contains: [
                IRB_OBJECT,
                {
                    className: "regexp",
                    contains: [
                        hljs.BACKSLASH_ESCAPE,
                        SUBST
                    ],
                    illegal: /\n/,
                    variants: [
                        {
                            begin: "/",
                            end: "/[a-z]*"
                        },
                        {
                            begin: "%r{",
                            end: "}[a-z]*"
                        },
                        {
                            begin: "%r\\(",
                            end: "\\)[a-z]*"
                        },
                        {
                            begin: "%r!",
                            end: "![a-z]*"
                        },
                        {
                            begin: "%r\\[",
                            end: "\\][a-z]*"
                        }
                    ]
                }
            ].concat(COMMENT_MODES),
            relevance: 0
        }
    ].concat(COMMENT_MODES);
    SUBST.contains = RUBY_DEFAULT_CONTAINS;
    PARAMS.contains = RUBY_DEFAULT_CONTAINS;
    var SIMPLE_PROMPT = "[>?]>";
    var DEFAULT_PROMPT = "[\\w#]+\\(\\w+\\):\\d+:\\d+>";
    var RVM_PROMPT = "(\\w+-)?\\d+\\.\\d+\\.\\d(p\\d+)?[^>]+>";
    var IRB_DEFAULT = [
        {
            begin: /^\s*=>/,
            starts: {
                end: "$",
                contains: RUBY_DEFAULT_CONTAINS
            }
        },
        {
            className: "meta",
            begin: "^(" + SIMPLE_PROMPT + "|" + DEFAULT_PROMPT + "|" + RVM_PROMPT + ")",
            starts: {
                end: "$",
                contains: RUBY_DEFAULT_CONTAINS
            }
        }
    ];
    return {
        aliases: [
            "rb",
            "gemspec",
            "podspec",
            "thor",
            "irb"
        ],
        keywords: RUBY_KEYWORDS,
        illegal: /\/\*/,
        contains: COMMENT_MODES.concat(IRB_DEFAULT).concat(RUBY_DEFAULT_CONTAINS)
    };
};

});

parcelRegister("dliKk", function(module, exports) {
module.exports = function(hljs) {
    return {
        subLanguage: "xml",
        contains: [
            hljs.COMMENT("<%#", "%>"),
            {
                begin: "<%[%=-]?",
                end: "[%-]?%>",
                subLanguage: "ruby",
                excludeBegin: true,
                excludeEnd: true
            }
        ]
    };
};

});

parcelRegister("ldUmx", function(module, exports) {
module.exports = function(hljs) {
    return {
        keywords: {
            built_in: "spawn spawn_link self",
            keyword: "after and andalso|10 band begin bnot bor bsl bsr bxor case catch cond div end fun if let not of or orelse|10 query receive rem try when xor"
        },
        contains: [
            {
                className: "meta",
                begin: "^[0-9]+> ",
                relevance: 10
            },
            hljs.COMMENT("%", "$"),
            {
                className: "number",
                begin: "\\b(\\d+#[a-fA-F0-9]+|\\d+(\\.\\d+)?([eE][-+]?\\d+)?)",
                relevance: 0
            },
            hljs.APOS_STRING_MODE,
            hljs.QUOTE_STRING_MODE,
            {
                begin: "\\?(::)?([A-Z]\\w*(::)?)+"
            },
            {
                begin: "->"
            },
            {
                begin: "ok"
            },
            {
                begin: "!"
            },
            {
                begin: "(\\b[a-z'][a-zA-Z0-9_']*:[a-z'][a-zA-Z0-9_']*)|(\\b[a-z'][a-zA-Z0-9_']*)",
                relevance: 0
            },
            {
                begin: "[A-Z][a-zA-Z0-9_']*",
                relevance: 0
            }
        ]
    };
};

});

parcelRegister("lpGxw", function(module, exports) {
module.exports = function(hljs) {
    var BASIC_ATOM_RE = "[a-z'][a-zA-Z0-9_']*";
    var FUNCTION_NAME_RE = "(" + BASIC_ATOM_RE + ":" + BASIC_ATOM_RE + "|" + BASIC_ATOM_RE + ")";
    var ERLANG_RESERVED = {
        keyword: "after and andalso|10 band begin bnot bor bsl bzr bxor case catch cond div end fun if let not of orelse|10 query receive rem try when xor",
        literal: "false true"
    };
    var COMMENT = hljs.COMMENT("%", "$");
    var NUMBER = {
        className: "number",
        begin: "\\b(\\d+#[a-fA-F0-9]+|\\d+(\\.\\d+)?([eE][-+]?\\d+)?)",
        relevance: 0
    };
    var NAMED_FUN = {
        begin: "fun\\s+" + BASIC_ATOM_RE + "/\\d+"
    };
    var FUNCTION_CALL = {
        begin: FUNCTION_NAME_RE + "\\(",
        end: "\\)",
        returnBegin: true,
        relevance: 0,
        contains: [
            {
                begin: FUNCTION_NAME_RE,
                relevance: 0
            },
            {
                begin: "\\(",
                end: "\\)",
                endsWithParent: true,
                returnEnd: true,
                relevance: 0
            }
        ]
    };
    var TUPLE = {
        begin: "{",
        end: "}",
        relevance: 0
    };
    var VAR1 = {
        begin: "\\b_([A-Z][A-Za-z0-9_]*)?",
        relevance: 0
    };
    var VAR2 = {
        begin: "[A-Z][a-zA-Z0-9_]*",
        relevance: 0
    };
    var RECORD_ACCESS = {
        begin: "#" + hljs.UNDERSCORE_IDENT_RE,
        relevance: 0,
        returnBegin: true,
        contains: [
            {
                begin: "#" + hljs.UNDERSCORE_IDENT_RE,
                relevance: 0
            },
            {
                begin: "{",
                end: "}",
                relevance: 0
            }
        ]
    };
    var BLOCK_STATEMENTS = {
        beginKeywords: "fun receive if try case",
        end: "end",
        keywords: ERLANG_RESERVED
    };
    BLOCK_STATEMENTS.contains = [
        COMMENT,
        NAMED_FUN,
        hljs.inherit(hljs.APOS_STRING_MODE, {
            className: ""
        }),
        BLOCK_STATEMENTS,
        FUNCTION_CALL,
        hljs.QUOTE_STRING_MODE,
        NUMBER,
        TUPLE,
        VAR1,
        VAR2,
        RECORD_ACCESS
    ];
    var BASIC_MODES = [
        COMMENT,
        NAMED_FUN,
        BLOCK_STATEMENTS,
        FUNCTION_CALL,
        hljs.QUOTE_STRING_MODE,
        NUMBER,
        TUPLE,
        VAR1,
        VAR2,
        RECORD_ACCESS
    ];
    FUNCTION_CALL.contains[1].contains = BASIC_MODES;
    TUPLE.contains = BASIC_MODES;
    RECORD_ACCESS.contains[1].contains = BASIC_MODES;
    var PARAMS = {
        className: "params",
        begin: "\\(",
        end: "\\)",
        contains: BASIC_MODES
    };
    return {
        aliases: [
            "erl"
        ],
        keywords: ERLANG_RESERVED,
        illegal: "(</|\\*=|\\+=|-=|/\\*|\\*/|\\(\\*|\\*\\))",
        contains: [
            {
                className: "function",
                begin: "^" + BASIC_ATOM_RE + "\\s*\\(",
                end: "->",
                returnBegin: true,
                illegal: "\\(|#|//|/\\*|\\\\|:|;",
                contains: [
                    PARAMS,
                    hljs.inherit(hljs.TITLE_MODE, {
                        begin: BASIC_ATOM_RE
                    })
                ],
                starts: {
                    end: ";|\\.",
                    keywords: ERLANG_RESERVED,
                    contains: BASIC_MODES
                }
            },
            COMMENT,
            {
                begin: "^-",
                end: "\\.",
                relevance: 0,
                excludeEnd: true,
                returnBegin: true,
                lexemes: "-" + hljs.IDENT_RE,
                keywords: "-module -record -undef -export -ifdef -ifndef -author -copyright -doc -vsn -import -include -include_lib -compile -define -else -endif -file -behaviour -behavior -spec",
                contains: [
                    PARAMS
                ]
            },
            NUMBER,
            hljs.QUOTE_STRING_MODE,
            RECORD_ACCESS,
            VAR1,
            VAR2,
            TUPLE,
            {
                begin: /\.$/
            } // relevance booster
        ]
    };
};

});

parcelRegister("jetw7", function(module, exports) {
module.exports = function(hljs) {
    return {
        aliases: [
            "xlsx",
            "xls"
        ],
        case_insensitive: true,
        lexemes: /[a-zA-Z][\w\.]*/,
        // built-in functions imported from https://web.archive.org/web/20160513042710/https://support.office.com/en-us/article/Excel-functions-alphabetical-b3944572-255d-4efb-bb96-c6d90033e188
        keywords: {
            built_in: "ABS ACCRINT ACCRINTM ACOS ACOSH ACOT ACOTH AGGREGATE ADDRESS AMORDEGRC AMORLINC AND ARABIC AREAS ASC ASIN ASINH ATAN ATAN2 ATANH AVEDEV AVERAGE AVERAGEA AVERAGEIF AVERAGEIFS BAHTTEXT BASE BESSELI BESSELJ BESSELK BESSELY BETADIST BETA.DIST BETAINV BETA.INV BIN2DEC BIN2HEX BIN2OCT BINOMDIST BINOM.DIST BINOM.DIST.RANGE BINOM.INV BITAND BITLSHIFT BITOR BITRSHIFT BITXOR CALL CEILING CEILING.MATH CEILING.PRECISE CELL CHAR CHIDIST CHIINV CHITEST CHISQ.DIST CHISQ.DIST.RT CHISQ.INV CHISQ.INV.RT CHISQ.TEST CHOOSE CLEAN CODE COLUMN COLUMNS COMBIN COMBINA COMPLEX CONCAT CONCATENATE CONFIDENCE CONFIDENCE.NORM CONFIDENCE.T CONVERT CORREL COS COSH COT COTH COUNT COUNTA COUNTBLANK COUNTIF COUNTIFS COUPDAYBS COUPDAYS COUPDAYSNC COUPNCD COUPNUM COUPPCD COVAR COVARIANCE.P COVARIANCE.S CRITBINOM CSC CSCH CUBEKPIMEMBER CUBEMEMBER CUBEMEMBERPROPERTY CUBERANKEDMEMBER CUBESET CUBESETCOUNT CUBEVALUE CUMIPMT CUMPRINC DATE DATEDIF DATEVALUE DAVERAGE DAY DAYS DAYS360 DB DBCS DCOUNT DCOUNTA DDB DEC2BIN DEC2HEX DEC2OCT DECIMAL DEGREES DELTA DEVSQ DGET DISC DMAX DMIN DOLLAR DOLLARDE DOLLARFR DPRODUCT DSTDEV DSTDEVP DSUM DURATION DVAR DVARP EDATE EFFECT ENCODEURL EOMONTH ERF ERF.PRECISE ERFC ERFC.PRECISE ERROR.TYPE EUROCONVERT EVEN EXACT EXP EXPON.DIST EXPONDIST FACT FACTDOUBLE FALSE|0 F.DIST FDIST F.DIST.RT FILTERXML FIND FINDB F.INV F.INV.RT FINV FISHER FISHERINV FIXED FLOOR FLOOR.MATH FLOOR.PRECISE FORECAST FORECAST.ETS FORECAST.ETS.CONFINT FORECAST.ETS.SEASONALITY FORECAST.ETS.STAT FORECAST.LINEAR FORMULATEXT FREQUENCY F.TEST FTEST FV FVSCHEDULE GAMMA GAMMA.DIST GAMMADIST GAMMA.INV GAMMAINV GAMMALN GAMMALN.PRECISE GAUSS GCD GEOMEAN GESTEP GETPIVOTDATA GROWTH HARMEAN HEX2BIN HEX2DEC HEX2OCT HLOOKUP HOUR HYPERLINK HYPGEOM.DIST HYPGEOMDIST IF IFERROR IFNA IFS IMABS IMAGINARY IMARGUMENT IMCONJUGATE IMCOS IMCOSH IMCOT IMCSC IMCSCH IMDIV IMEXP IMLN IMLOG10 IMLOG2 IMPOWER IMPRODUCT IMREAL IMSEC IMSECH IMSIN IMSINH IMSQRT IMSUB IMSUM IMTAN INDEX INDIRECT INFO INT INTERCEPT INTRATE IPMT IRR ISBLANK ISERR ISERROR ISEVEN ISFORMULA ISLOGICAL ISNA ISNONTEXT ISNUMBER ISODD ISREF ISTEXT ISO.CEILING ISOWEEKNUM ISPMT JIS KURT LARGE LCM LEFT LEFTB LEN LENB LINEST LN LOG LOG10 LOGEST LOGINV LOGNORM.DIST LOGNORMDIST LOGNORM.INV LOOKUP LOWER MATCH MAX MAXA MAXIFS MDETERM MDURATION MEDIAN MID MIDBs MIN MINIFS MINA MINUTE MINVERSE MIRR MMULT MOD MODE MODE.MULT MODE.SNGL MONTH MROUND MULTINOMIAL MUNIT N NA NEGBINOM.DIST NEGBINOMDIST NETWORKDAYS NETWORKDAYS.INTL NOMINAL NORM.DIST NORMDIST NORMINV NORM.INV NORM.S.DIST NORMSDIST NORM.S.INV NORMSINV NOT NOW NPER NPV NUMBERVALUE OCT2BIN OCT2DEC OCT2HEX ODD ODDFPRICE ODDFYIELD ODDLPRICE ODDLYIELD OFFSET OR PDURATION PEARSON PERCENTILE.EXC PERCENTILE.INC PERCENTILE PERCENTRANK.EXC PERCENTRANK.INC PERCENTRANK PERMUT PERMUTATIONA PHI PHONETIC PI PMT POISSON.DIST POISSON POWER PPMT PRICE PRICEDISC PRICEMAT PROB PRODUCT PROPER PV QUARTILE QUARTILE.EXC QUARTILE.INC QUOTIENT RADIANS RAND RANDBETWEEN RANK.AVG RANK.EQ RANK RATE RECEIVED REGISTER.ID REPLACE REPLACEB REPT RIGHT RIGHTB ROMAN ROUND ROUNDDOWN ROUNDUP ROW ROWS RRI RSQ RTD SEARCH SEARCHB SEC SECH SECOND SERIESSUM SHEET SHEETS SIGN SIN SINH SKEW SKEW.P SLN SLOPE SMALL SQL.REQUEST SQRT SQRTPI STANDARDIZE STDEV STDEV.P STDEV.S STDEVA STDEVP STDEVPA STEYX SUBSTITUTE SUBTOTAL SUM SUMIF SUMIFS SUMPRODUCT SUMSQ SUMX2MY2 SUMX2PY2 SUMXMY2 SWITCH SYD T TAN TANH TBILLEQ TBILLPRICE TBILLYIELD T.DIST T.DIST.2T T.DIST.RT TDIST TEXT TEXTJOIN TIME TIMEVALUE T.INV T.INV.2T TINV TODAY TRANSPOSE TREND TRIM TRIMMEAN TRUE|0 TRUNC T.TEST TTEST TYPE UNICHAR UNICODE UPPER VALUE VAR VAR.P VAR.S VARA VARP VARPA VDB VLOOKUP WEBSERVICE WEEKDAY WEEKNUM WEIBULL WEIBULL.DIST WORKDAY WORKDAY.INTL XIRR XNPV XOR YEAR YEARFRAC YIELD YIELDDISC YIELDMAT Z.TEST ZTEST"
        },
        contains: [
            {
                /* matches a beginning equal sign found in Excel formula examples */ begin: /^=/,
                end: /[^=]/,
                returnEnd: true,
                illegal: /=/,
                /* only allow single equal sign at front of line */ relevance: 10
            },
            /* technically, there can be more than 2 letters in column names, but this prevents conflict with some keywords */ {
                /* matches a reference to a single cell */ className: "symbol",
                begin: /\b[A-Z]{1,2}\d+\b/,
                end: /[^\d]/,
                excludeEnd: true,
                relevance: 0
            },
            {
                /* matches a reference to a range of cells */ className: "symbol",
                begin: /[A-Z]{0,2}\d*:[A-Z]{0,2}\d*/,
                relevance: 0
            },
            hljs.BACKSLASH_ESCAPE,
            hljs.QUOTE_STRING_MODE,
            {
                className: "number",
                begin: hljs.NUMBER_RE + "(%)?",
                relevance: 0
            },
            /* Excel formula comments are done by putting the comment in a function call to N() */ hljs.COMMENT(/\bN\(/, /\)/, {
                excludeBegin: true,
                excludeEnd: true,
                illegal: /\n/
            })
        ]
    };
};

});

parcelRegister("2gdJp", function(module, exports) {
module.exports = function(hljs) {
    return {
        contains: [
            {
                begin: /[^\u2401\u0001]+/,
                end: /[\u2401\u0001]/,
                excludeEnd: true,
                returnBegin: true,
                returnEnd: false,
                contains: [
                    {
                        begin: /([^\u2401\u0001=]+)/,
                        end: /=([^\u2401\u0001=]+)/,
                        returnEnd: true,
                        returnBegin: false,
                        className: "attr"
                    },
                    {
                        begin: /=/,
                        end: /([\u2401\u0001])/,
                        excludeEnd: true,
                        excludeBegin: true,
                        className: "string"
                    }
                ]
            }
        ],
        case_insensitive: true
    };
};

});

parcelRegister("gh4Hb", function(module, exports) {
module.exports = function(hljs) {
    var CHAR = {
        className: "string",
        begin: /'(.|\\[xXuU][a-zA-Z0-9]+)'/
    };
    var STRING = {
        className: "string",
        variants: [
            {
                begin: '"',
                end: '"'
            }
        ]
    };
    var NAME = {
        className: "title",
        begin: /[^0-9\n\t "'(),.`{}\[\]:;][^\n\t "'(),.`{}\[\]:;]+|[^0-9\n\t "'(),.`{}\[\]:;=]/
    };
    var METHOD = {
        className: "function",
        beginKeywords: "def",
        end: /[:={\[(\n;]/,
        excludeEnd: true,
        contains: [
            NAME
        ]
    };
    return {
        keywords: {
            literal: "true false",
            keyword: "case class def else enum if impl import in lat rel index let match namespace switch type yield with"
        },
        contains: [
            hljs.C_LINE_COMMENT_MODE,
            hljs.C_BLOCK_COMMENT_MODE,
            CHAR,
            STRING,
            METHOD,
            hljs.C_NUMBER_MODE
        ]
    };
};

});

parcelRegister("b6Sro", function(module, exports) {
module.exports = function(hljs) {
    var PARAMS = {
        className: "params",
        begin: "\\(",
        end: "\\)"
    };
    var F_KEYWORDS = {
        literal: ".False. .True.",
        keyword: "kind do while private call intrinsic where elsewhere type endtype endmodule endselect endinterface end enddo endif if forall endforall only contains default return stop then block endblock public subroutine|10 function program .and. .or. .not. .le. .eq. .ge. .gt. .lt. goto save else use module select case access blank direct exist file fmt form formatted iostat name named nextrec number opened rec recl sequential status unformatted unit continue format pause cycle exit c_null_char c_alert c_backspace c_form_feed flush wait decimal round iomsg synchronous nopass non_overridable pass protected volatile abstract extends import non_intrinsic value deferred generic final enumerator class associate bind enum c_int c_short c_long c_long_long c_signed_char c_size_t c_int8_t c_int16_t c_int32_t c_int64_t c_int_least8_t c_int_least16_t c_int_least32_t c_int_least64_t c_int_fast8_t c_int_fast16_t c_int_fast32_t c_int_fast64_t c_intmax_t C_intptr_t c_float c_double c_long_double c_float_complex c_double_complex c_long_double_complex c_bool c_char c_null_ptr c_null_funptr c_new_line c_carriage_return c_horizontal_tab c_vertical_tab iso_c_binding c_loc c_funloc c_associated  c_f_pointer c_ptr c_funptr iso_fortran_env character_storage_size error_unit file_storage_size input_unit iostat_end iostat_eor numeric_storage_size output_unit c_f_procpointer ieee_arithmetic ieee_support_underflow_control ieee_get_underflow_mode ieee_set_underflow_mode newunit contiguous recursive pad position action delim readwrite eor advance nml interface procedure namelist include sequence elemental pure integer real character complex logical dimension allocatable|10 parameter external implicit|10 none double precision assign intent optional pointer target in out common equivalence data",
        built_in: "alog alog10 amax0 amax1 amin0 amin1 amod cabs ccos cexp clog csin csqrt dabs dacos dasin datan datan2 dcos dcosh ddim dexp dint dlog dlog10 dmax1 dmin1 dmod dnint dsign dsin dsinh dsqrt dtan dtanh float iabs idim idint idnint ifix isign max0 max1 min0 min1 sngl algama cdabs cdcos cdexp cdlog cdsin cdsqrt cqabs cqcos cqexp cqlog cqsin cqsqrt dcmplx dconjg derf derfc dfloat dgamma dimag dlgama iqint qabs qacos qasin qatan qatan2 qcmplx qconjg qcos qcosh qdim qerf qerfc qexp qgamma qimag qlgama qlog qlog10 qmax1 qmin1 qmod qnint qsign qsin qsinh qsqrt qtan qtanh abs acos aimag aint anint asin atan atan2 char cmplx conjg cos cosh exp ichar index int log log10 max min nint sign sin sinh sqrt tan tanh print write dim lge lgt lle llt mod nullify allocate deallocate adjustl adjustr all allocated any associated bit_size btest ceiling count cshift date_and_time digits dot_product eoshift epsilon exponent floor fraction huge iand ibclr ibits ibset ieor ior ishft ishftc lbound len_trim matmul maxexponent maxloc maxval merge minexponent minloc minval modulo mvbits nearest pack present product radix random_number random_seed range repeat reshape rrspacing scale scan selected_int_kind selected_real_kind set_exponent shape size spacing spread sum system_clock tiny transpose trim ubound unpack verify achar iachar transfer dble entry dprod cpu_time command_argument_count get_command get_command_argument get_environment_variable is_iostat_end ieee_arithmetic ieee_support_underflow_control ieee_get_underflow_mode ieee_set_underflow_mode is_iostat_eor move_alloc new_line selected_char_kind same_type_as extends_type_ofacosh asinh atanh bessel_j0 bessel_j1 bessel_jn bessel_y0 bessel_y1 bessel_yn erf erfc erfc_scaled gamma log_gamma hypot norm2 atomic_define atomic_ref execute_command_line leadz trailz storage_size merge_bits bge bgt ble blt dshiftl dshiftr findloc iall iany iparity image_index lcobound ucobound maskl maskr num_images parity popcnt poppar shifta shiftl shiftr this_image"
    };
    return {
        case_insensitive: true,
        aliases: [
            "f90",
            "f95"
        ],
        keywords: F_KEYWORDS,
        illegal: /\/\*/,
        contains: [
            hljs.inherit(hljs.APOS_STRING_MODE, {
                className: "string",
                relevance: 0
            }),
            hljs.inherit(hljs.QUOTE_STRING_MODE, {
                className: "string",
                relevance: 0
            }),
            {
                className: "function",
                beginKeywords: "subroutine function program",
                illegal: "[${=\\n]",
                contains: [
                    hljs.UNDERSCORE_TITLE_MODE,
                    PARAMS
                ]
            },
            hljs.COMMENT("!", "$", {
                relevance: 0
            }),
            {
                className: "number",
                begin: "(?=\\b|\\+|\\-|\\.)(?=\\.\\d|\\d)(?:\\d+)?(?:\\.?\\d*)(?:[de][+-]?\\d+)?\\b\\.?",
                relevance: 0
            }
        ]
    };
};

});

parcelRegister("l9gyx", function(module, exports) {
module.exports = function(hljs) {
    var TYPEPARAM = {
        begin: "<",
        end: ">",
        contains: [
            hljs.inherit(hljs.TITLE_MODE, {
                begin: /'[a-zA-Z0-9_]+/
            })
        ]
    };
    return {
        aliases: [
            "fs"
        ],
        keywords: "abstract and as assert base begin class default delegate do done downcast downto elif else end exception extern false finally for fun function global if in inherit inline interface internal lazy let match member module mutable namespace new null of open or override private public rec return sig static struct then to true try type upcast use val void when while with yield",
        illegal: /\/\*/,
        contains: [
            {
                // monad builder keywords (matches before non-bang kws)
                className: "keyword",
                begin: /\b(yield|return|let|do)!/
            },
            {
                className: "string",
                begin: '@"',
                end: '"',
                contains: [
                    {
                        begin: '""'
                    }
                ]
            },
            {
                className: "string",
                begin: '"""',
                end: '"""'
            },
            hljs.COMMENT("\\(\\*", "\\*\\)"),
            {
                className: "class",
                beginKeywords: "type",
                end: "\\(|=|$",
                excludeEnd: true,
                contains: [
                    hljs.UNDERSCORE_TITLE_MODE,
                    TYPEPARAM
                ]
            },
            {
                className: "meta",
                begin: "\\[<",
                end: ">\\]",
                relevance: 10
            },
            {
                className: "symbol",
                begin: "\\B('[A-Za-z])\\b",
                contains: [
                    hljs.BACKSLASH_ESCAPE
                ]
            },
            hljs.C_LINE_COMMENT_MODE,
            hljs.inherit(hljs.QUOTE_STRING_MODE, {
                illegal: null
            }),
            hljs.C_NUMBER_MODE
        ]
    };
};

});

parcelRegister("dsDLC", function(module, exports) {
module.exports = function(hljs) {
    var KEYWORDS = {
        "keyword": "abort acronym acronyms alias all and assign binary card diag display else eq file files for free ge gt if integer le loop lt maximizing minimizing model models ne negative no not option options or ord positive prod put putpage puttl repeat sameas semicont semiint smax smin solve sos1 sos2 sum system table then until using while xor yes",
        "literal": "eps inf na",
        "built-in": "abs arccos arcsin arctan arctan2 Beta betaReg binomial ceil centropy cos cosh cvPower div div0 eDist entropy errorf execSeed exp fact floor frac gamma gammaReg log logBeta logGamma log10 log2 mapVal max min mod ncpCM ncpF ncpVUpow ncpVUsin normal pi poly power randBinomial randLinear randTriangle round rPower sigmoid sign signPower sin sinh slexp sllog10 slrec sqexp sqlog10 sqr sqrec sqrt tan tanh trunc uniform uniformInt vcPower bool_and bool_eqv bool_imp bool_not bool_or bool_xor ifThen rel_eq rel_ge rel_gt rel_le rel_lt rel_ne gday gdow ghour gleap gmillisec gminute gmonth gsecond gyear jdate jnow jstart jtime errorLevel execError gamsRelease gamsVersion handleCollect handleDelete handleStatus handleSubmit heapFree heapLimit heapSize jobHandle jobKill jobStatus jobTerminate licenseLevel licenseStatus maxExecError sleep timeClose timeComp timeElapsed timeExec timeStart"
    };
    var PARAMS = {
        className: "params",
        begin: /\(/,
        end: /\)/,
        excludeBegin: true,
        excludeEnd: true
    };
    var SYMBOLS = {
        className: "symbol",
        variants: [
            {
                begin: /\=[lgenxc]=/
            },
            {
                begin: /\$/
            }
        ]
    };
    var QSTR = {
        className: "comment",
        variants: [
            {
                begin: "'",
                end: "'"
            },
            {
                begin: '"',
                end: '"'
            }
        ],
        illegal: "\\n",
        contains: [
            hljs.BACKSLASH_ESCAPE
        ]
    };
    var ASSIGNMENT = {
        begin: "/",
        end: "/",
        keywords: KEYWORDS,
        contains: [
            QSTR,
            hljs.C_LINE_COMMENT_MODE,
            hljs.C_BLOCK_COMMENT_MODE,
            hljs.QUOTE_STRING_MODE,
            hljs.APOS_STRING_MODE,
            hljs.C_NUMBER_MODE
        ]
    };
    var DESCTEXT = {
        begin: /[a-z][a-z0-9_]*(\([a-z0-9_, ]*\))?[ \t]+/,
        excludeBegin: true,
        end: "$",
        endsWithParent: true,
        contains: [
            QSTR,
            ASSIGNMENT,
            {
                className: "comment",
                begin: /([ ]*[a-z0-9&#*=?@>\\<:\-,()$\[\]_.{}!+%^]+)+/,
                relevance: 0
            }
        ]
    };
    return {
        aliases: [
            "gms"
        ],
        case_insensitive: true,
        keywords: KEYWORDS,
        contains: [
            hljs.COMMENT(/^\$ontext/, /^\$offtext/),
            {
                className: "meta",
                begin: "^\\$[a-z0-9]+",
                end: "$",
                returnBegin: true,
                contains: [
                    {
                        className: "meta-keyword",
                        begin: "^\\$[a-z0-9]+"
                    }
                ]
            },
            hljs.COMMENT("^\\*", "$"),
            hljs.C_LINE_COMMENT_MODE,
            hljs.C_BLOCK_COMMENT_MODE,
            hljs.QUOTE_STRING_MODE,
            hljs.APOS_STRING_MODE,
            // Declarations
            {
                beginKeywords: "set sets parameter parameters variable variables scalar scalars equation equations",
                end: ";",
                contains: [
                    hljs.COMMENT("^\\*", "$"),
                    hljs.C_LINE_COMMENT_MODE,
                    hljs.C_BLOCK_COMMENT_MODE,
                    hljs.QUOTE_STRING_MODE,
                    hljs.APOS_STRING_MODE,
                    ASSIGNMENT,
                    DESCTEXT
                ]
            },
            {
                beginKeywords: "table",
                end: ";",
                returnBegin: true,
                contains: [
                    {
                        beginKeywords: "table",
                        end: "$",
                        contains: [
                            DESCTEXT
                        ]
                    },
                    hljs.COMMENT("^\\*", "$"),
                    hljs.C_LINE_COMMENT_MODE,
                    hljs.C_BLOCK_COMMENT_MODE,
                    hljs.QUOTE_STRING_MODE,
                    hljs.APOS_STRING_MODE,
                    hljs.C_NUMBER_MODE
                ]
            },
            // Function definitions
            {
                className: "function",
                begin: /^[a-z][a-z0-9_,\-+' ()$]+\.{2}/,
                returnBegin: true,
                contains: [
                    {
                        className: "title",
                        begin: /^[a-z0-9_]+/
                    },
                    PARAMS,
                    SYMBOLS
                ]
            },
            hljs.C_NUMBER_MODE,
            SYMBOLS
        ]
    };
};

});

parcelRegister("7BbCT", function(module, exports) {
module.exports = function(hljs) {
    var KEYWORDS = {
        keyword: "bool break call callexe checkinterrupt clear clearg closeall cls comlog compile continue create debug declare delete disable dlibrary dllcall do dos ed edit else elseif enable end endfor endif endp endo errorlog errorlogat expr external fn for format goto gosub graph if keyword let lib library line load loadarray loadexe loadf loadk loadm loadp loads loadx local locate loopnextindex lprint lpwidth lshow matrix msym ndpclex new open output outwidth plot plotsym pop prcsn print printdos proc push retp return rndcon rndmod rndmult rndseed run save saveall screen scroll setarray show sparse stop string struct system trace trap threadfor threadendfor threadbegin threadjoin threadstat threadend until use while winprint ne ge le gt lt and xor or not eq eqv",
        built_in: "abs acf aconcat aeye amax amean AmericanBinomCall AmericanBinomCall_Greeks AmericanBinomCall_ImpVol AmericanBinomPut AmericanBinomPut_Greeks AmericanBinomPut_ImpVol AmericanBSCall AmericanBSCall_Greeks AmericanBSCall_ImpVol AmericanBSPut AmericanBSPut_Greeks AmericanBSPut_ImpVol amin amult annotationGetDefaults annotationSetBkd annotationSetFont annotationSetLineColor annotationSetLineStyle annotationSetLineThickness annualTradingDays arccos arcsin areshape arrayalloc arrayindex arrayinit arraytomat asciiload asclabel astd astds asum atan atan2 atranspose axmargin balance band bandchol bandcholsol bandltsol bandrv bandsolpd bar base10 begwind besselj bessely beta box boxcox cdfBeta cdfBetaInv cdfBinomial cdfBinomialInv cdfBvn cdfBvn2 cdfBvn2e cdfCauchy cdfCauchyInv cdfChic cdfChii cdfChinc cdfChincInv cdfExp cdfExpInv cdfFc cdfFnc cdfFncInv cdfGam cdfGenPareto cdfHyperGeo cdfLaplace cdfLaplaceInv cdfLogistic cdfLogisticInv cdfmControlCreate cdfMvn cdfMvn2e cdfMvnce cdfMvne cdfMvt2e cdfMvtce cdfMvte cdfN cdfN2 cdfNc cdfNegBinomial cdfNegBinomialInv cdfNi cdfPoisson cdfPoissonInv cdfRayleigh cdfRayleighInv cdfTc cdfTci cdfTnc cdfTvn cdfWeibull cdfWeibullInv cdir ceil ChangeDir chdir chiBarSquare chol choldn cholsol cholup chrs close code cols colsf combinate combinated complex con cond conj cons ConScore contour conv convertsatostr convertstrtosa corrm corrms corrvc corrx corrxs cos cosh counts countwts crossprd crout croutp csrcol csrlin csvReadM csvReadSA cumprodc cumsumc curve cvtos datacreate datacreatecomplex datalist dataload dataloop dataopen datasave date datestr datestring datestrymd dayinyr dayofweek dbAddDatabase dbClose dbCommit dbCreateQuery dbExecQuery dbGetConnectOptions dbGetDatabaseName dbGetDriverName dbGetDrivers dbGetHostName dbGetLastErrorNum dbGetLastErrorText dbGetNumericalPrecPolicy dbGetPassword dbGetPort dbGetTableHeaders dbGetTables dbGetUserName dbHasFeature dbIsDriverAvailable dbIsOpen dbIsOpenError dbOpen dbQueryBindValue dbQueryClear dbQueryCols dbQueryExecPrepared dbQueryFetchAllM dbQueryFetchAllSA dbQueryFetchOneM dbQueryFetchOneSA dbQueryFinish dbQueryGetBoundValue dbQueryGetBoundValues dbQueryGetField dbQueryGetLastErrorNum dbQueryGetLastErrorText dbQueryGetLastInsertID dbQueryGetLastQuery dbQueryGetPosition dbQueryIsActive dbQueryIsForwardOnly dbQueryIsNull dbQueryIsSelect dbQueryIsValid dbQueryPrepare dbQueryRows dbQuerySeek dbQuerySeekFirst dbQuerySeekLast dbQuerySeekNext dbQuerySeekPrevious dbQuerySetForwardOnly dbRemoveDatabase dbRollback dbSetConnectOptions dbSetDatabaseName dbSetHostName dbSetNumericalPrecPolicy dbSetPort dbSetUserName dbTransaction DeleteFile delif delrows denseToSp denseToSpRE denToZero design det detl dfft dffti diag diagrv digamma doswin DOSWinCloseall DOSWinOpen dotfeq dotfeqmt dotfge dotfgemt dotfgt dotfgtmt dotfle dotflemt dotflt dotfltmt dotfne dotfnemt draw drop dsCreate dstat dstatmt dstatmtControlCreate dtdate dtday dttime dttodtv dttostr dttoutc dtvnormal dtvtodt dtvtoutc dummy dummybr dummydn eig eigh eighv eigv elapsedTradingDays endwind envget eof eqSolve eqSolvemt eqSolvemtControlCreate eqSolvemtOutCreate eqSolveset erf erfc erfccplx erfcplx error etdays ethsec etstr EuropeanBinomCall EuropeanBinomCall_Greeks EuropeanBinomCall_ImpVol EuropeanBinomPut EuropeanBinomPut_Greeks EuropeanBinomPut_ImpVol EuropeanBSCall EuropeanBSCall_Greeks EuropeanBSCall_ImpVol EuropeanBSPut EuropeanBSPut_Greeks EuropeanBSPut_ImpVol exctsmpl exec execbg exp extern eye fcheckerr fclearerr feq feqmt fflush fft ffti fftm fftmi fftn fge fgemt fgets fgetsa fgetsat fgetst fgt fgtmt fileinfo filesa fle flemt floor flt fltmt fmod fne fnemt fonts fopen formatcv formatnv fputs fputst fseek fstrerror ftell ftocv ftos ftostrC gamma gammacplx gammaii gausset gdaAppend gdaCreate gdaDStat gdaDStatMat gdaGetIndex gdaGetName gdaGetNames gdaGetOrders gdaGetType gdaGetTypes gdaGetVarInfo gdaIsCplx gdaLoad gdaPack gdaRead gdaReadByIndex gdaReadSome gdaReadSparse gdaReadStruct gdaReportVarInfo gdaSave gdaUpdate gdaUpdateAndPack gdaVars gdaWrite gdaWrite32 gdaWriteSome getarray getdims getf getGAUSShome getmatrix getmatrix4D getname getnamef getNextTradingDay getNextWeekDay getnr getorders getpath getPreviousTradingDay getPreviousWeekDay getRow getscalar3D getscalar4D getTrRow getwind glm gradcplx gradMT gradMTm gradMTT gradMTTm gradp graphprt graphset hasimag header headermt hess hessMT hessMTg hessMTgw hessMTm hessMTmw hessMTT hessMTTg hessMTTgw hessMTTm hessMTw hessp hist histf histp hsec imag indcv indexcat indices indices2 indicesf indicesfn indnv indsav integrate1d integrateControlCreate intgrat2 intgrat3 inthp1 inthp2 inthp3 inthp4 inthpControlCreate intquad1 intquad2 intquad3 intrleav intrleavsa intrsect intsimp inv invpd invswp iscplx iscplxf isden isinfnanmiss ismiss key keyav keyw lag lag1 lagn lapEighb lapEighi lapEighvb lapEighvi lapgEig lapgEigh lapgEighv lapgEigv lapgSchur lapgSvdcst lapgSvds lapgSvdst lapSvdcusv lapSvds lapSvdusv ldlp ldlsol linSolve listwise ln lncdfbvn lncdfbvn2 lncdfmvn lncdfn lncdfn2 lncdfnc lnfact lngammacplx lnpdfmvn lnpdfmvt lnpdfn lnpdft loadd loadstruct loadwind loess loessmt loessmtControlCreate log loglog logx logy lower lowmat lowmat1 ltrisol lu lusol machEpsilon make makevars makewind margin matalloc matinit mattoarray maxbytes maxc maxindc maxv maxvec mbesselei mbesselei0 mbesselei1 mbesseli mbesseli0 mbesseli1 meanc median mergeby mergevar minc minindc minv miss missex missrv moment momentd movingave movingaveExpwgt movingaveWgt nextindex nextn nextnevn nextwind ntos null null1 numCombinations ols olsmt olsmtControlCreate olsqr olsqr2 olsqrmt ones optn optnevn orth outtyp pacf packedToSp packr parse pause pdfCauchy pdfChi pdfExp pdfGenPareto pdfHyperGeo pdfLaplace pdfLogistic pdfn pdfPoisson pdfRayleigh pdfWeibull pi pinv pinvmt plotAddArrow plotAddBar plotAddBox plotAddHist plotAddHistF plotAddHistP plotAddPolar plotAddScatter plotAddShape plotAddTextbox plotAddTS plotAddXY plotArea plotBar plotBox plotClearLayout plotContour plotCustomLayout plotGetDefaults plotHist plotHistF plotHistP plotLayout plotLogLog plotLogX plotLogY plotOpenWindow plotPolar plotSave plotScatter plotSetAxesPen plotSetBar plotSetBarFill plotSetBarStacked plotSetBkdColor plotSetFill plotSetGrid plotSetLegend plotSetLineColor plotSetLineStyle plotSetLineSymbol plotSetLineThickness plotSetNewWindow plotSetTitle plotSetWhichYAxis plotSetXAxisShow plotSetXLabel plotSetXRange plotSetXTicInterval plotSetXTicLabel plotSetYAxisShow plotSetYLabel plotSetYRange plotSetZAxisShow plotSetZLabel plotSurface plotTS plotXY polar polychar polyeval polygamma polyint polymake polymat polymroot polymult polyroot pqgwin previousindex princomp printfm printfmt prodc psi putarray putf putvals pvCreate pvGetIndex pvGetParNames pvGetParVector pvLength pvList pvPack pvPacki pvPackm pvPackmi pvPacks pvPacksi pvPacksm pvPacksmi pvPutParVector pvTest pvUnpack QNewton QNewtonmt QNewtonmtControlCreate QNewtonmtOutCreate QNewtonSet QProg QProgmt QProgmtInCreate qqr qqre qqrep qr qre qrep qrsol qrtsol qtyr qtyre qtyrep quantile quantiled qyr qyre qyrep qz rank rankindx readr real reclassify reclassifyCuts recode recserar recsercp recserrc rerun rescale reshape rets rev rfft rffti rfftip rfftn rfftnp rfftp rndBernoulli rndBeta rndBinomial rndCauchy rndChiSquare rndCon rndCreateState rndExp rndGamma rndGeo rndGumbel rndHyperGeo rndi rndKMbeta rndKMgam rndKMi rndKMn rndKMnb rndKMp rndKMu rndKMvm rndLaplace rndLCbeta rndLCgam rndLCi rndLCn rndLCnb rndLCp rndLCu rndLCvm rndLogNorm rndMTu rndMVn rndMVt rndn rndnb rndNegBinomial rndp rndPoisson rndRayleigh rndStateSkip rndu rndvm rndWeibull rndWishart rotater round rows rowsf rref sampleData satostrC saved saveStruct savewind scale scale3d scalerr scalinfnanmiss scalmiss schtoc schur searchsourcepath seekr select selif seqa seqm setdif setdifsa setvars setvwrmode setwind shell shiftr sin singleindex sinh sleep solpd sortc sortcc sortd sorthc sorthcc sortind sortindc sortmc sortr sortrc spBiconjGradSol spChol spConjGradSol spCreate spDenseSubmat spDiagRvMat spEigv spEye spLDL spline spLU spNumNZE spOnes spreadSheetReadM spreadSheetReadSA spreadSheetWrite spScale spSubmat spToDense spTrTDense spTScalar spZeros sqpSolve sqpSolveMT sqpSolveMTControlCreate sqpSolveMTlagrangeCreate sqpSolveMToutCreate sqpSolveSet sqrt statements stdc stdsc stocv stof strcombine strindx strlen strput strrindx strsect strsplit strsplitPad strtodt strtof strtofcplx strtriml strtrimr strtrunc strtruncl strtruncpad strtruncr submat subscat substute subvec sumc sumr surface svd svd1 svd2 svdcusv svds svdusv sysstate tab tan tanh tempname time timedt timestr timeutc title tkf2eps tkf2ps tocart todaydt toeplitz token topolar trapchk trigamma trimr trunc type typecv typef union unionsa uniqindx uniqindxsa unique uniquesa upmat upmat1 upper utctodt utctodtv utrisol vals varCovMS varCovXS varget vargetl varmall varmares varput varputl vartypef vcm vcms vcx vcxs vec vech vecr vector vget view viewxyz vlist vnamecv volume vput vread vtypecv wait waitc walkindex where window writer xlabel xlsGetSheetCount xlsGetSheetSize xlsGetSheetTypes xlsMakeRange xlsReadM xlsReadSA xlsWrite xlsWriteM xlsWriteSA xpnd xtics xy xyz ylabel ytics zeros zeta zlabel ztics cdfEmpirical dot h5create h5open h5read h5readAttribute h5write h5writeAttribute ldl plotAddErrorBar plotAddSurface plotCDFEmpirical plotSetColormap plotSetContourLabels plotSetLegendFont plotSetTextInterpreter plotSetXTicCount plotSetYTicCount plotSetZLevels powerm strjoin sylvester strtrim",
        literal: "DB_AFTER_LAST_ROW DB_ALL_TABLES DB_BATCH_OPERATIONS DB_BEFORE_FIRST_ROW DB_BLOB DB_EVENT_NOTIFICATIONS DB_FINISH_QUERY DB_HIGH_PRECISION DB_LAST_INSERT_ID DB_LOW_PRECISION_DOUBLE DB_LOW_PRECISION_INT32 DB_LOW_PRECISION_INT64 DB_LOW_PRECISION_NUMBERS DB_MULTIPLE_RESULT_SETS DB_NAMED_PLACEHOLDERS DB_POSITIONAL_PLACEHOLDERS DB_PREPARED_QUERIES DB_QUERY_SIZE DB_SIMPLE_LOCKING DB_SYSTEM_TABLES DB_TABLES DB_TRANSACTIONS DB_UNICODE DB_VIEWS __STDIN __STDOUT __STDERR __FILE_DIR"
    };
    var AT_COMMENT_MODE = hljs.COMMENT("@", "@");
    var PREPROCESSOR = {
        className: "meta",
        begin: "#",
        end: "$",
        keywords: {
            "meta-keyword": "define definecs|10 undef ifdef ifndef iflight ifdllcall ifmac ifos2win ifunix else endif lineson linesoff srcfile srcline"
        },
        contains: [
            {
                begin: /\\\n/,
                relevance: 0
            },
            {
                beginKeywords: "include",
                end: "$",
                keywords: {
                    "meta-keyword": "include"
                },
                contains: [
                    {
                        className: "meta-string",
                        begin: '"',
                        end: '"',
                        illegal: "\\n"
                    }
                ]
            },
            hljs.C_LINE_COMMENT_MODE,
            hljs.C_BLOCK_COMMENT_MODE,
            AT_COMMENT_MODE
        ]
    };
    var STRUCT_TYPE = {
        begin: /\bstruct\s+/,
        end: /\s/,
        keywords: "struct",
        contains: [
            {
                className: "type",
                begin: hljs.UNDERSCORE_IDENT_RE,
                relevance: 0
            }
        ]
    };
    // only for definitions
    var PARSE_PARAMS = [
        {
            className: "params",
            begin: /\(/,
            end: /\)/,
            excludeBegin: true,
            excludeEnd: true,
            endsWithParent: true,
            relevance: 0,
            contains: [
                {
                    className: "literal",
                    begin: /\.\.\./
                },
                hljs.C_NUMBER_MODE,
                hljs.C_BLOCK_COMMENT_MODE,
                AT_COMMENT_MODE,
                STRUCT_TYPE
            ]
        }
    ];
    var FUNCTION_DEF = {
        className: "title",
        begin: hljs.UNDERSCORE_IDENT_RE,
        relevance: 0
    };
    var DEFINITION = function(beginKeywords, end, inherits) {
        var mode = hljs.inherit({
            className: "function",
            beginKeywords: beginKeywords,
            end: end,
            excludeEnd: true,
            contains: [].concat(PARSE_PARAMS)
        }, inherits || {});
        mode.contains.push(FUNCTION_DEF);
        mode.contains.push(hljs.C_NUMBER_MODE);
        mode.contains.push(hljs.C_BLOCK_COMMENT_MODE);
        mode.contains.push(AT_COMMENT_MODE);
        return mode;
    };
    var BUILT_IN_REF = {
        className: "built_in",
        begin: "\\b(" + KEYWORDS.built_in.split(" ").join("|") + ")\\b"
    };
    var STRING_REF = {
        className: "string",
        begin: '"',
        end: '"',
        contains: [
            hljs.BACKSLASH_ESCAPE
        ],
        relevance: 0
    };
    var FUNCTION_REF = {
        //className: "fn_ref",
        begin: hljs.UNDERSCORE_IDENT_RE + "\\s*\\(",
        returnBegin: true,
        keywords: KEYWORDS,
        relevance: 0,
        contains: [
            {
                beginKeywords: KEYWORDS.keyword
            },
            BUILT_IN_REF,
            {
                className: "built_in",
                begin: hljs.UNDERSCORE_IDENT_RE,
                relevance: 0
            }
        ]
    };
    var FUNCTION_REF_PARAMS = {
        //className: "fn_ref_params",
        begin: /\(/,
        end: /\)/,
        relevance: 0,
        keywords: {
            built_in: KEYWORDS.built_in,
            literal: KEYWORDS.literal
        },
        contains: [
            hljs.C_NUMBER_MODE,
            hljs.C_BLOCK_COMMENT_MODE,
            AT_COMMENT_MODE,
            BUILT_IN_REF,
            FUNCTION_REF,
            STRING_REF,
            "self"
        ]
    };
    FUNCTION_REF.contains.push(FUNCTION_REF_PARAMS);
    return {
        aliases: [
            "gss"
        ],
        case_insensitive: true,
        keywords: KEYWORDS,
        illegal: /(\{[%#]|[%#]\}| <- )/,
        contains: [
            hljs.C_NUMBER_MODE,
            hljs.C_LINE_COMMENT_MODE,
            hljs.C_BLOCK_COMMENT_MODE,
            AT_COMMENT_MODE,
            STRING_REF,
            PREPROCESSOR,
            {
                className: "keyword",
                begin: /\bexternal (matrix|string|array|sparse matrix|struct|proc|keyword|fn)/
            },
            DEFINITION("proc keyword", ";"),
            DEFINITION("fn", "="),
            {
                beginKeywords: "for threadfor",
                end: /;/,
                //end: /\(/,
                relevance: 0,
                contains: [
                    hljs.C_BLOCK_COMMENT_MODE,
                    AT_COMMENT_MODE,
                    FUNCTION_REF_PARAMS
                ]
            },
            {
                // excludes method names from keyword processing
                variants: [
                    {
                        begin: hljs.UNDERSCORE_IDENT_RE + "\\." + hljs.UNDERSCORE_IDENT_RE
                    },
                    {
                        begin: hljs.UNDERSCORE_IDENT_RE + "\\s*="
                    }
                ],
                relevance: 0
            },
            FUNCTION_REF,
            STRUCT_TYPE
        ]
    };
};

});

parcelRegister("iB6Fn", function(module, exports) {
module.exports = function(hljs) {
    var GCODE_IDENT_RE = "[A-Z_][A-Z0-9_.]*";
    var GCODE_CLOSE_RE = "\\%";
    var GCODE_KEYWORDS = "IF DO WHILE ENDWHILE CALL ENDIF SUB ENDSUB GOTO REPEAT ENDREPEAT EQ LT GT NE GE LE OR XOR";
    var GCODE_START = {
        className: "meta",
        begin: "([O])([0-9]+)"
    };
    var GCODE_CODE = [
        hljs.C_LINE_COMMENT_MODE,
        hljs.C_BLOCK_COMMENT_MODE,
        hljs.COMMENT(/\(/, /\)/),
        hljs.inherit(hljs.C_NUMBER_MODE, {
            begin: "([-+]?([0-9]*\\.?[0-9]+\\.?))|" + hljs.C_NUMBER_RE
        }),
        hljs.inherit(hljs.APOS_STRING_MODE, {
            illegal: null
        }),
        hljs.inherit(hljs.QUOTE_STRING_MODE, {
            illegal: null
        }),
        {
            className: "name",
            begin: "([G])([0-9]+\\.?[0-9]?)"
        },
        {
            className: "name",
            begin: "([M])([0-9]+\\.?[0-9]?)"
        },
        {
            className: "attr",
            begin: "(VC|VS|#)",
            end: "(\\d+)"
        },
        {
            className: "attr",
            begin: "(VZOFX|VZOFY|VZOFZ)"
        },
        {
            className: "built_in",
            begin: "(ATAN|ABS|ACOS|ASIN|SIN|COS|EXP|FIX|FUP|ROUND|LN|TAN)(\\[)",
            end: "([-+]?([0-9]*\\.?[0-9]+\\.?))(\\])"
        },
        {
            className: "symbol",
            variants: [
                {
                    begin: "N",
                    end: "\\d+",
                    illegal: "\\W"
                }
            ]
        }
    ];
    return {
        aliases: [
            "nc"
        ],
        // Some implementations (CNC controls) of G-code are interoperable with uppercase and lowercase letters seamlessly.
        // However, most prefer all uppercase and uppercase is customary.
        case_insensitive: true,
        lexemes: GCODE_IDENT_RE,
        keywords: GCODE_KEYWORDS,
        contains: [
            {
                className: "meta",
                begin: GCODE_CLOSE_RE
            },
            GCODE_START
        ].concat(GCODE_CODE)
    };
};

});

parcelRegister("3BTtX", function(module, exports) {
module.exports = function(hljs) {
    return {
        aliases: [
            "feature"
        ],
        keywords: "Feature Background Ability Business Need Scenario Scenarios Scenario Outline Scenario Template Examples Given And Then But When",
        contains: [
            {
                className: "symbol",
                begin: "\\*",
                relevance: 0
            },
            {
                className: "meta",
                begin: "@[^@\\s]+"
            },
            {
                begin: "\\|",
                end: "\\|\\w*$",
                contains: [
                    {
                        className: "string",
                        begin: "[^|]+"
                    }
                ]
            },
            {
                className: "variable",
                begin: "<",
                end: ">"
            },
            hljs.HASH_COMMENT_MODE,
            {
                className: "string",
                begin: '"""',
                end: '"""'
            },
            hljs.QUOTE_STRING_MODE
        ]
    };
};

});

parcelRegister("gp7HK", function(module, exports) {
module.exports = function(hljs) {
    return {
        keywords: {
            keyword: // Statements
            "break continue discard do else for if return while switch case default attribute binding buffer ccw centroid centroid varying coherent column_major const cw depth_any depth_greater depth_less depth_unchanged early_fragment_tests equal_spacing flat fractional_even_spacing fractional_odd_spacing highp in index inout invariant invocations isolines layout line_strip lines lines_adjacency local_size_x local_size_y local_size_z location lowp max_vertices mediump noperspective offset origin_upper_left out packed patch pixel_center_integer point_mode points precise precision quads r11f_g11f_b10f r16 r16_snorm r16f r16i r16ui r32f r32i r32ui r8 r8_snorm r8i r8ui readonly restrict rg16 rg16_snorm rg16f rg16i rg16ui rg32f rg32i rg32ui rg8 rg8_snorm rg8i rg8ui rgb10_a2 rgb10_a2ui rgba16 rgba16_snorm rgba16f rgba16i rgba16ui rgba32f rgba32i rgba32ui rgba8 rgba8_snorm rgba8i rgba8ui row_major sample shared smooth std140 std430 stream triangle_strip triangles triangles_adjacency uniform varying vertices volatile writeonly",
            type: "atomic_uint bool bvec2 bvec3 bvec4 dmat2 dmat2x2 dmat2x3 dmat2x4 dmat3 dmat3x2 dmat3x3 dmat3x4 dmat4 dmat4x2 dmat4x3 dmat4x4 double dvec2 dvec3 dvec4 float iimage1D iimage1DArray iimage2D iimage2DArray iimage2DMS iimage2DMSArray iimage2DRect iimage3D iimageBufferiimageCube iimageCubeArray image1D image1DArray image2D image2DArray image2DMS image2DMSArray image2DRect image3D imageBuffer imageCube imageCubeArray int isampler1D isampler1DArray isampler2D isampler2DArray isampler2DMS isampler2DMSArray isampler2DRect isampler3D isamplerBuffer isamplerCube isamplerCubeArray ivec2 ivec3 ivec4 mat2 mat2x2 mat2x3 mat2x4 mat3 mat3x2 mat3x3 mat3x4 mat4 mat4x2 mat4x3 mat4x4 sampler1D sampler1DArray sampler1DArrayShadow sampler1DShadow sampler2D sampler2DArray sampler2DArrayShadow sampler2DMS sampler2DMSArray sampler2DRect sampler2DRectShadow sampler2DShadow sampler3D samplerBuffer samplerCube samplerCubeArray samplerCubeArrayShadow samplerCubeShadow image1D uimage1DArray uimage2D uimage2DArray uimage2DMS uimage2DMSArray uimage2DRect uimage3D uimageBuffer uimageCube uimageCubeArray uint usampler1D usampler1DArray usampler2D usampler2DArray usampler2DMS usampler2DMSArray usampler2DRect usampler3D samplerBuffer usamplerCube usamplerCubeArray uvec2 uvec3 uvec4 vec2 vec3 vec4 void",
            built_in: // Constants
            "gl_MaxAtomicCounterBindings gl_MaxAtomicCounterBufferSize gl_MaxClipDistances gl_MaxClipPlanes gl_MaxCombinedAtomicCounterBuffers gl_MaxCombinedAtomicCounters gl_MaxCombinedImageUniforms gl_MaxCombinedImageUnitsAndFragmentOutputs gl_MaxCombinedTextureImageUnits gl_MaxComputeAtomicCounterBuffers gl_MaxComputeAtomicCounters gl_MaxComputeImageUniforms gl_MaxComputeTextureImageUnits gl_MaxComputeUniformComponents gl_MaxComputeWorkGroupCount gl_MaxComputeWorkGroupSize gl_MaxDrawBuffers gl_MaxFragmentAtomicCounterBuffers gl_MaxFragmentAtomicCounters gl_MaxFragmentImageUniforms gl_MaxFragmentInputComponents gl_MaxFragmentInputVectors gl_MaxFragmentUniformComponents gl_MaxFragmentUniformVectors gl_MaxGeometryAtomicCounterBuffers gl_MaxGeometryAtomicCounters gl_MaxGeometryImageUniforms gl_MaxGeometryInputComponents gl_MaxGeometryOutputComponents gl_MaxGeometryOutputVertices gl_MaxGeometryTextureImageUnits gl_MaxGeometryTotalOutputComponents gl_MaxGeometryUniformComponents gl_MaxGeometryVaryingComponents gl_MaxImageSamples gl_MaxImageUnits gl_MaxLights gl_MaxPatchVertices gl_MaxProgramTexelOffset gl_MaxTessControlAtomicCounterBuffers gl_MaxTessControlAtomicCounters gl_MaxTessControlImageUniforms gl_MaxTessControlInputComponents gl_MaxTessControlOutputComponents gl_MaxTessControlTextureImageUnits gl_MaxTessControlTotalOutputComponents gl_MaxTessControlUniformComponents gl_MaxTessEvaluationAtomicCounterBuffers gl_MaxTessEvaluationAtomicCounters gl_MaxTessEvaluationImageUniforms gl_MaxTessEvaluationInputComponents gl_MaxTessEvaluationOutputComponents gl_MaxTessEvaluationTextureImageUnits gl_MaxTessEvaluationUniformComponents gl_MaxTessGenLevel gl_MaxTessPatchComponents gl_MaxTextureCoords gl_MaxTextureImageUnits gl_MaxTextureUnits gl_MaxVaryingComponents gl_MaxVaryingFloats gl_MaxVaryingVectors gl_MaxVertexAtomicCounterBuffers gl_MaxVertexAtomicCounters gl_MaxVertexAttribs gl_MaxVertexImageUniforms gl_MaxVertexOutputComponents gl_MaxVertexOutputVectors gl_MaxVertexTextureImageUnits gl_MaxVertexUniformComponents gl_MaxVertexUniformVectors gl_MaxViewports gl_MinProgramTexelOffset gl_BackColor gl_BackLightModelProduct gl_BackLightProduct gl_BackMaterial gl_BackSecondaryColor gl_ClipDistance gl_ClipPlane gl_ClipVertex gl_Color gl_DepthRange gl_EyePlaneQ gl_EyePlaneR gl_EyePlaneS gl_EyePlaneT gl_Fog gl_FogCoord gl_FogFragCoord gl_FragColor gl_FragCoord gl_FragData gl_FragDepth gl_FrontColor gl_FrontFacing gl_FrontLightModelProduct gl_FrontLightProduct gl_FrontMaterial gl_FrontSecondaryColor gl_GlobalInvocationID gl_InstanceID gl_InvocationID gl_Layer gl_LightModel gl_LightSource gl_LocalInvocationID gl_LocalInvocationIndex gl_ModelViewMatrix gl_ModelViewMatrixInverse gl_ModelViewMatrixInverseTranspose gl_ModelViewMatrixTranspose gl_ModelViewProjectionMatrix gl_ModelViewProjectionMatrixInverse gl_ModelViewProjectionMatrixInverseTranspose gl_ModelViewProjectionMatrixTranspose gl_MultiTexCoord0 gl_MultiTexCoord1 gl_MultiTexCoord2 gl_MultiTexCoord3 gl_MultiTexCoord4 gl_MultiTexCoord5 gl_MultiTexCoord6 gl_MultiTexCoord7 gl_Normal gl_NormalMatrix gl_NormalScale gl_NumSamples gl_NumWorkGroups gl_ObjectPlaneQ gl_ObjectPlaneR gl_ObjectPlaneS gl_ObjectPlaneT gl_PatchVerticesIn gl_Point gl_PointCoord gl_PointSize gl_Position gl_PrimitiveID gl_PrimitiveIDIn gl_ProjectionMatrix gl_ProjectionMatrixInverse gl_ProjectionMatrixInverseTranspose gl_ProjectionMatrixTranspose gl_SampleID gl_SampleMask gl_SampleMaskIn gl_SamplePosition gl_SecondaryColor gl_TessCoord gl_TessLevelInner gl_TessLevelOuter gl_TexCoord gl_TextureEnvColor gl_TextureMatrix gl_TextureMatrixInverse gl_TextureMatrixInverseTranspose gl_TextureMatrixTranspose gl_Vertex gl_VertexID gl_ViewportIndex gl_WorkGroupID gl_WorkGroupSize gl_in gl_out EmitStreamVertex EmitVertex EndPrimitive EndStreamPrimitive abs acos acosh all any asin asinh atan atanh atomicAdd atomicAnd atomicCompSwap atomicCounter atomicCounterDecrement atomicCounterIncrement atomicExchange atomicMax atomicMin atomicOr atomicXor barrier bitCount bitfieldExtract bitfieldInsert bitfieldReverse ceil clamp cos cosh cross dFdx dFdy degrees determinant distance dot equal exp exp2 faceforward findLSB findMSB floatBitsToInt floatBitsToUint floor fma fract frexp ftransform fwidth greaterThan greaterThanEqual groupMemoryBarrier imageAtomicAdd imageAtomicAnd imageAtomicCompSwap imageAtomicExchange imageAtomicMax imageAtomicMin imageAtomicOr imageAtomicXor imageLoad imageSize imageStore imulExtended intBitsToFloat interpolateAtCentroid interpolateAtOffset interpolateAtSample inverse inversesqrt isinf isnan ldexp length lessThan lessThanEqual log log2 matrixCompMult max memoryBarrier memoryBarrierAtomicCounter memoryBarrierBuffer memoryBarrierImage memoryBarrierShared min mix mod modf noise1 noise2 noise3 noise4 normalize not notEqual outerProduct packDouble2x32 packHalf2x16 packSnorm2x16 packSnorm4x8 packUnorm2x16 packUnorm4x8 pow radians reflect refract round roundEven shadow1D shadow1DLod shadow1DProj shadow1DProjLod shadow2D shadow2DLod shadow2DProj shadow2DProjLod sign sin sinh smoothstep sqrt step tan tanh texelFetch texelFetchOffset texture texture1D texture1DLod texture1DProj texture1DProjLod texture2D texture2DLod texture2DProj texture2DProjLod texture3D texture3DLod texture3DProj texture3DProjLod textureCube textureCubeLod textureGather textureGatherOffset textureGatherOffsets textureGrad textureGradOffset textureLod textureLodOffset textureOffset textureProj textureProjGrad textureProjGradOffset textureProjLod textureProjLodOffset textureProjOffset textureQueryLevels textureQueryLod textureSize transpose trunc uaddCarry uintBitsToFloat umulExtended unpackDouble2x32 unpackHalf2x16 unpackSnorm2x16 unpackSnorm4x8 unpackUnorm2x16 unpackUnorm4x8 usubBorrow",
            literal: "true false"
        },
        illegal: '"',
        contains: [
            hljs.C_LINE_COMMENT_MODE,
            hljs.C_BLOCK_COMMENT_MODE,
            hljs.C_NUMBER_MODE,
            {
                className: "meta",
                begin: "#",
                end: "$"
            }
        ]
    };
};

});

parcelRegister("3jkHQ", function(module, exports) {
module.exports = function(hljs) {
    var GML_KEYWORDS = {
        keyword: "begin end if then else while do for break continue with until repeat exit and or xor not return mod div switch case default var globalvar enum #macro #region #endregion",
        built_in: "is_real is_string is_array is_undefined is_int32 is_int64 is_ptr is_vec3 is_vec4 is_matrix is_bool typeof variable_global_exists variable_global_get variable_global_set variable_instance_exists variable_instance_get variable_instance_set variable_instance_get_names array_length_1d array_length_2d array_height_2d array_equals array_create array_copy random random_range irandom irandom_range random_set_seed random_get_seed randomize randomise choose abs round floor ceil sign frac sqrt sqr exp ln log2 log10 sin cos tan arcsin arccos arctan arctan2 dsin dcos dtan darcsin darccos darctan darctan2 degtorad radtodeg power logn min max mean median clamp lerp dot_product dot_product_3d dot_product_normalised dot_product_3d_normalised dot_product_normalized dot_product_3d_normalized math_set_epsilon math_get_epsilon angle_difference point_distance_3d point_distance point_direction lengthdir_x lengthdir_y real string int64 ptr string_format chr ansi_char ord string_length string_byte_length string_pos string_copy string_char_at string_ord_at string_byte_at string_set_byte_at string_delete string_insert string_lower string_upper string_repeat string_letters string_digits string_lettersdigits string_replace string_replace_all string_count string_hash_to_newline clipboard_has_text clipboard_set_text clipboard_get_text date_current_datetime date_create_datetime date_valid_datetime date_inc_year date_inc_month date_inc_week date_inc_day date_inc_hour date_inc_minute date_inc_second date_get_year date_get_month date_get_week date_get_day date_get_hour date_get_minute date_get_second date_get_weekday date_get_day_of_year date_get_hour_of_year date_get_minute_of_year date_get_second_of_year date_year_span date_month_span date_week_span date_day_span date_hour_span date_minute_span date_second_span date_compare_datetime date_compare_date date_compare_time date_date_of date_time_of date_datetime_string date_date_string date_time_string date_days_in_month date_days_in_year date_leap_year date_is_today date_set_timezone date_get_timezone game_set_speed game_get_speed motion_set motion_add place_free place_empty place_meeting place_snapped move_random move_snap move_towards_point move_contact_solid move_contact_all move_outside_solid move_outside_all move_bounce_solid move_bounce_all move_wrap distance_to_point distance_to_object position_empty position_meeting path_start path_end mp_linear_step mp_potential_step mp_linear_step_object mp_potential_step_object mp_potential_settings mp_linear_path mp_potential_path mp_linear_path_object mp_potential_path_object mp_grid_create mp_grid_destroy mp_grid_clear_all mp_grid_clear_cell mp_grid_clear_rectangle mp_grid_add_cell mp_grid_get_cell mp_grid_add_rectangle mp_grid_add_instances mp_grid_path mp_grid_draw mp_grid_to_ds_grid collision_point collision_rectangle collision_circle collision_ellipse collision_line collision_point_list collision_rectangle_list collision_circle_list collision_ellipse_list collision_line_list instance_position_list instance_place_list point_in_rectangle point_in_triangle point_in_circle rectangle_in_rectangle rectangle_in_triangle rectangle_in_circle instance_find instance_exists instance_number instance_position instance_nearest instance_furthest instance_place instance_create_depth instance_create_layer instance_copy instance_change instance_destroy position_destroy position_change instance_id_get instance_deactivate_all instance_deactivate_object instance_deactivate_region instance_activate_all instance_activate_object instance_activate_region room_goto room_goto_previous room_goto_next room_previous room_next room_restart game_end game_restart game_load game_save game_save_buffer game_load_buffer event_perform event_user event_perform_object event_inherited show_debug_message show_debug_overlay debug_event debug_get_callstack alarm_get alarm_set font_texture_page_size keyboard_set_map keyboard_get_map keyboard_unset_map keyboard_check keyboard_check_pressed keyboard_check_released keyboard_check_direct keyboard_get_numlock keyboard_set_numlock keyboard_key_press keyboard_key_release keyboard_clear io_clear mouse_check_button mouse_check_button_pressed mouse_check_button_released mouse_wheel_up mouse_wheel_down mouse_clear draw_self draw_sprite draw_sprite_pos draw_sprite_ext draw_sprite_stretched draw_sprite_stretched_ext draw_sprite_tiled draw_sprite_tiled_ext draw_sprite_part draw_sprite_part_ext draw_sprite_general draw_clear draw_clear_alpha draw_point draw_line draw_line_width draw_rectangle draw_roundrect draw_roundrect_ext draw_triangle draw_circle draw_ellipse draw_set_circle_precision draw_arrow draw_button draw_path draw_healthbar draw_getpixel draw_getpixel_ext draw_set_colour draw_set_color draw_set_alpha draw_get_colour draw_get_color draw_get_alpha merge_colour make_colour_rgb make_colour_hsv colour_get_red colour_get_green colour_get_blue colour_get_hue colour_get_saturation colour_get_value merge_color make_color_rgb make_color_hsv color_get_red color_get_green color_get_blue color_get_hue color_get_saturation color_get_value merge_color screen_save screen_save_part draw_set_font draw_set_halign draw_set_valign draw_text draw_text_ext string_width string_height string_width_ext string_height_ext draw_text_transformed draw_text_ext_transformed draw_text_colour draw_text_ext_colour draw_text_transformed_colour draw_text_ext_transformed_colour draw_text_color draw_text_ext_color draw_text_transformed_color draw_text_ext_transformed_color draw_point_colour draw_line_colour draw_line_width_colour draw_rectangle_colour draw_roundrect_colour draw_roundrect_colour_ext draw_triangle_colour draw_circle_colour draw_ellipse_colour draw_point_color draw_line_color draw_line_width_color draw_rectangle_color draw_roundrect_color draw_roundrect_color_ext draw_triangle_color draw_circle_color draw_ellipse_color draw_primitive_begin draw_vertex draw_vertex_colour draw_vertex_color draw_primitive_end sprite_get_uvs font_get_uvs sprite_get_texture font_get_texture texture_get_width texture_get_height texture_get_uvs draw_primitive_begin_texture draw_vertex_texture draw_vertex_texture_colour draw_vertex_texture_color texture_global_scale surface_create surface_create_ext surface_resize surface_free surface_exists surface_get_width surface_get_height surface_get_texture surface_set_target surface_set_target_ext surface_reset_target surface_depth_disable surface_get_depth_disable draw_surface draw_surface_stretched draw_surface_tiled draw_surface_part draw_surface_ext draw_surface_stretched_ext draw_surface_tiled_ext draw_surface_part_ext draw_surface_general surface_getpixel surface_getpixel_ext surface_save surface_save_part surface_copy surface_copy_part application_surface_draw_enable application_get_position application_surface_enable application_surface_is_enabled display_get_width display_get_height display_get_orientation display_get_gui_width display_get_gui_height display_reset display_mouse_get_x display_mouse_get_y display_mouse_set display_set_ui_visibility window_set_fullscreen window_get_fullscreen window_set_caption window_set_min_width window_set_max_width window_set_min_height window_set_max_height window_get_visible_rects window_get_caption window_set_cursor window_get_cursor window_set_colour window_get_colour window_set_color window_get_color window_set_position window_set_size window_set_rectangle window_center window_get_x window_get_y window_get_width window_get_height window_mouse_get_x window_mouse_get_y window_mouse_set window_view_mouse_get_x window_view_mouse_get_y window_views_mouse_get_x window_views_mouse_get_y audio_listener_position audio_listener_velocity audio_listener_orientation audio_emitter_position audio_emitter_create audio_emitter_free audio_emitter_exists audio_emitter_pitch audio_emitter_velocity audio_emitter_falloff audio_emitter_gain audio_play_sound audio_play_sound_on audio_play_sound_at audio_stop_sound audio_resume_music audio_music_is_playing audio_resume_sound audio_pause_sound audio_pause_music audio_channel_num audio_sound_length audio_get_type audio_falloff_set_model audio_play_music audio_stop_music audio_master_gain audio_music_gain audio_sound_gain audio_sound_pitch audio_stop_all audio_resume_all audio_pause_all audio_is_playing audio_is_paused audio_exists audio_sound_set_track_position audio_sound_get_track_position audio_emitter_get_gain audio_emitter_get_pitch audio_emitter_get_x audio_emitter_get_y audio_emitter_get_z audio_emitter_get_vx audio_emitter_get_vy audio_emitter_get_vz audio_listener_set_position audio_listener_set_velocity audio_listener_set_orientation audio_listener_get_data audio_set_master_gain audio_get_master_gain audio_sound_get_gain audio_sound_get_pitch audio_get_name audio_sound_set_track_position audio_sound_get_track_position audio_create_stream audio_destroy_stream audio_create_sync_group audio_destroy_sync_group audio_play_in_sync_group audio_start_sync_group audio_stop_sync_group audio_pause_sync_group audio_resume_sync_group audio_sync_group_get_track_pos audio_sync_group_debug audio_sync_group_is_playing audio_debug audio_group_load audio_group_unload audio_group_is_loaded audio_group_load_progress audio_group_name audio_group_stop_all audio_group_set_gain audio_create_buffer_sound audio_free_buffer_sound audio_create_play_queue audio_free_play_queue audio_queue_sound audio_get_recorder_count audio_get_recorder_info audio_start_recording audio_stop_recording audio_sound_get_listener_mask audio_emitter_get_listener_mask audio_get_listener_mask audio_sound_set_listener_mask audio_emitter_set_listener_mask audio_set_listener_mask audio_get_listener_count audio_get_listener_info audio_system show_message show_message_async clickable_add clickable_add_ext clickable_change clickable_change_ext clickable_delete clickable_exists clickable_set_style show_question show_question_async get_integer get_string get_integer_async get_string_async get_login_async get_open_filename get_save_filename get_open_filename_ext get_save_filename_ext show_error highscore_clear highscore_add highscore_value highscore_name draw_highscore sprite_exists sprite_get_name sprite_get_number sprite_get_width sprite_get_height sprite_get_xoffset sprite_get_yoffset sprite_get_bbox_left sprite_get_bbox_right sprite_get_bbox_top sprite_get_bbox_bottom sprite_save sprite_save_strip sprite_set_cache_size sprite_set_cache_size_ext sprite_get_tpe sprite_prefetch sprite_prefetch_multi sprite_flush sprite_flush_multi sprite_set_speed sprite_get_speed_type sprite_get_speed font_exists font_get_name font_get_fontname font_get_bold font_get_italic font_get_first font_get_last font_get_size font_set_cache_size path_exists path_get_name path_get_length path_get_time path_get_kind path_get_closed path_get_precision path_get_number path_get_point_x path_get_point_y path_get_point_speed path_get_x path_get_y path_get_speed script_exists script_get_name timeline_add timeline_delete timeline_clear timeline_exists timeline_get_name timeline_moment_clear timeline_moment_add_script timeline_size timeline_max_moment object_exists object_get_name object_get_sprite object_get_solid object_get_visible object_get_persistent object_get_mask object_get_parent object_get_physics object_is_ancestor room_exists room_get_name sprite_set_offset sprite_duplicate sprite_assign sprite_merge sprite_add sprite_replace sprite_create_from_surface sprite_add_from_surface sprite_delete sprite_set_alpha_from_sprite sprite_collision_mask font_add_enable_aa font_add_get_enable_aa font_add font_add_sprite font_add_sprite_ext font_replace font_replace_sprite font_replace_sprite_ext font_delete path_set_kind path_set_closed path_set_precision path_add path_assign path_duplicate path_append path_delete path_add_point path_insert_point path_change_point path_delete_point path_clear_points path_reverse path_mirror path_flip path_rotate path_rescale path_shift script_execute object_set_sprite object_set_solid object_set_visible object_set_persistent object_set_mask room_set_width room_set_height room_set_persistent room_set_background_colour room_set_background_color room_set_view room_set_viewport room_get_viewport room_set_view_enabled room_add room_duplicate room_assign room_instance_add room_instance_clear room_get_camera room_set_camera asset_get_index asset_get_type file_text_open_from_string file_text_open_read file_text_open_write file_text_open_append file_text_close file_text_write_string file_text_write_real file_text_writeln file_text_read_string file_text_read_real file_text_readln file_text_eof file_text_eoln file_exists file_delete file_rename file_copy directory_exists directory_create directory_destroy file_find_first file_find_next file_find_close file_attributes filename_name filename_path filename_dir filename_drive filename_ext filename_change_ext file_bin_open file_bin_rewrite file_bin_close file_bin_position file_bin_size file_bin_seek file_bin_write_byte file_bin_read_byte parameter_count parameter_string environment_get_variable ini_open_from_string ini_open ini_close ini_read_string ini_read_real ini_write_string ini_write_real ini_key_exists ini_section_exists ini_key_delete ini_section_delete ds_set_precision ds_exists ds_stack_create ds_stack_destroy ds_stack_clear ds_stack_copy ds_stack_size ds_stack_empty ds_stack_push ds_stack_pop ds_stack_top ds_stack_write ds_stack_read ds_queue_create ds_queue_destroy ds_queue_clear ds_queue_copy ds_queue_size ds_queue_empty ds_queue_enqueue ds_queue_dequeue ds_queue_head ds_queue_tail ds_queue_write ds_queue_read ds_list_create ds_list_destroy ds_list_clear ds_list_copy ds_list_size ds_list_empty ds_list_add ds_list_insert ds_list_replace ds_list_delete ds_list_find_index ds_list_find_value ds_list_mark_as_list ds_list_mark_as_map ds_list_sort ds_list_shuffle ds_list_write ds_list_read ds_list_set ds_map_create ds_map_destroy ds_map_clear ds_map_copy ds_map_size ds_map_empty ds_map_add ds_map_add_list ds_map_add_map ds_map_replace ds_map_replace_map ds_map_replace_list ds_map_delete ds_map_exists ds_map_find_value ds_map_find_previous ds_map_find_next ds_map_find_first ds_map_find_last ds_map_write ds_map_read ds_map_secure_save ds_map_secure_load ds_map_secure_load_buffer ds_map_secure_save_buffer ds_map_set ds_priority_create ds_priority_destroy ds_priority_clear ds_priority_copy ds_priority_size ds_priority_empty ds_priority_add ds_priority_change_priority ds_priority_find_priority ds_priority_delete_value ds_priority_delete_min ds_priority_find_min ds_priority_delete_max ds_priority_find_max ds_priority_write ds_priority_read ds_grid_create ds_grid_destroy ds_grid_copy ds_grid_resize ds_grid_width ds_grid_height ds_grid_clear ds_grid_set ds_grid_add ds_grid_multiply ds_grid_set_region ds_grid_add_region ds_grid_multiply_region ds_grid_set_disk ds_grid_add_disk ds_grid_multiply_disk ds_grid_set_grid_region ds_grid_add_grid_region ds_grid_multiply_grid_region ds_grid_get ds_grid_get_sum ds_grid_get_max ds_grid_get_min ds_grid_get_mean ds_grid_get_disk_sum ds_grid_get_disk_min ds_grid_get_disk_max ds_grid_get_disk_mean ds_grid_value_exists ds_grid_value_x ds_grid_value_y ds_grid_value_disk_exists ds_grid_value_disk_x ds_grid_value_disk_y ds_grid_shuffle ds_grid_write ds_grid_read ds_grid_sort ds_grid_set ds_grid_get effect_create_below effect_create_above effect_clear part_type_create part_type_destroy part_type_exists part_type_clear part_type_shape part_type_sprite part_type_size part_type_scale part_type_orientation part_type_life part_type_step part_type_death part_type_speed part_type_direction part_type_gravity part_type_colour1 part_type_colour2 part_type_colour3 part_type_colour_mix part_type_colour_rgb part_type_colour_hsv part_type_color1 part_type_color2 part_type_color3 part_type_color_mix part_type_color_rgb part_type_color_hsv part_type_alpha1 part_type_alpha2 part_type_alpha3 part_type_blend part_system_create part_system_create_layer part_system_destroy part_system_exists part_system_clear part_system_draw_order part_system_depth part_system_position part_system_automatic_update part_system_automatic_draw part_system_update part_system_drawit part_system_get_layer part_system_layer part_particles_create part_particles_create_colour part_particles_create_color part_particles_clear part_particles_count part_emitter_create part_emitter_destroy part_emitter_destroy_all part_emitter_exists part_emitter_clear part_emitter_region part_emitter_burst part_emitter_stream external_call external_define external_free window_handle window_device matrix_get matrix_set matrix_build_identity matrix_build matrix_build_lookat matrix_build_projection_ortho matrix_build_projection_perspective matrix_build_projection_perspective_fov matrix_multiply matrix_transform_vertex matrix_stack_push matrix_stack_pop matrix_stack_multiply matrix_stack_set matrix_stack_clear matrix_stack_top matrix_stack_is_empty browser_input_capture os_get_config os_get_info os_get_language os_get_region os_lock_orientation display_get_dpi_x display_get_dpi_y display_set_gui_size display_set_gui_maximise display_set_gui_maximize device_mouse_dbclick_enable display_set_timing_method display_get_timing_method display_set_sleep_margin display_get_sleep_margin virtual_key_add virtual_key_hide virtual_key_delete virtual_key_show draw_enable_drawevent draw_enable_swf_aa draw_set_swf_aa_level draw_get_swf_aa_level draw_texture_flush draw_flush gpu_set_blendenable gpu_set_ztestenable gpu_set_zfunc gpu_set_zwriteenable gpu_set_lightingenable gpu_set_fog gpu_set_cullmode gpu_set_blendmode gpu_set_blendmode_ext gpu_set_blendmode_ext_sepalpha gpu_set_colorwriteenable gpu_set_colourwriteenable gpu_set_alphatestenable gpu_set_alphatestref gpu_set_alphatestfunc gpu_set_texfilter gpu_set_texfilter_ext gpu_set_texrepeat gpu_set_texrepeat_ext gpu_set_tex_filter gpu_set_tex_filter_ext gpu_set_tex_repeat gpu_set_tex_repeat_ext gpu_set_tex_mip_filter gpu_set_tex_mip_filter_ext gpu_set_tex_mip_bias gpu_set_tex_mip_bias_ext gpu_set_tex_min_mip gpu_set_tex_min_mip_ext gpu_set_tex_max_mip gpu_set_tex_max_mip_ext gpu_set_tex_max_aniso gpu_set_tex_max_aniso_ext gpu_set_tex_mip_enable gpu_set_tex_mip_enable_ext gpu_get_blendenable gpu_get_ztestenable gpu_get_zfunc gpu_get_zwriteenable gpu_get_lightingenable gpu_get_fog gpu_get_cullmode gpu_get_blendmode gpu_get_blendmode_ext gpu_get_blendmode_ext_sepalpha gpu_get_blendmode_src gpu_get_blendmode_dest gpu_get_blendmode_srcalpha gpu_get_blendmode_destalpha gpu_get_colorwriteenable gpu_get_colourwriteenable gpu_get_alphatestenable gpu_get_alphatestref gpu_get_alphatestfunc gpu_get_texfilter gpu_get_texfilter_ext gpu_get_texrepeat gpu_get_texrepeat_ext gpu_get_tex_filter gpu_get_tex_filter_ext gpu_get_tex_repeat gpu_get_tex_repeat_ext gpu_get_tex_mip_filter gpu_get_tex_mip_filter_ext gpu_get_tex_mip_bias gpu_get_tex_mip_bias_ext gpu_get_tex_min_mip gpu_get_tex_min_mip_ext gpu_get_tex_max_mip gpu_get_tex_max_mip_ext gpu_get_tex_max_aniso gpu_get_tex_max_aniso_ext gpu_get_tex_mip_enable gpu_get_tex_mip_enable_ext gpu_push_state gpu_pop_state gpu_get_state gpu_set_state draw_light_define_ambient draw_light_define_direction draw_light_define_point draw_light_enable draw_set_lighting draw_light_get_ambient draw_light_get draw_get_lighting shop_leave_rating url_get_domain url_open url_open_ext url_open_full get_timer achievement_login achievement_logout achievement_post achievement_increment achievement_post_score achievement_available achievement_show_achievements achievement_show_leaderboards achievement_load_friends achievement_load_leaderboard achievement_send_challenge achievement_load_progress achievement_reset achievement_login_status achievement_get_pic achievement_show_challenge_notifications achievement_get_challenges achievement_event achievement_show achievement_get_info cloud_file_save cloud_string_save cloud_synchronise ads_enable ads_disable ads_setup ads_engagement_launch ads_engagement_available ads_engagement_active ads_event ads_event_preload ads_set_reward_callback ads_get_display_height ads_get_display_width ads_move ads_interstitial_available ads_interstitial_display device_get_tilt_x device_get_tilt_y device_get_tilt_z device_is_keypad_open device_mouse_check_button device_mouse_check_button_pressed device_mouse_check_button_released device_mouse_x device_mouse_y device_mouse_raw_x device_mouse_raw_y device_mouse_x_to_gui device_mouse_y_to_gui iap_activate iap_status iap_enumerate_products iap_restore_all iap_acquire iap_consume iap_product_details iap_purchase_details facebook_init facebook_login facebook_status facebook_graph_request facebook_dialog facebook_logout facebook_launch_offerwall facebook_post_message facebook_send_invite facebook_user_id facebook_accesstoken facebook_check_permission facebook_request_read_permissions facebook_request_publish_permissions gamepad_is_supported gamepad_get_device_count gamepad_is_connected gamepad_get_description gamepad_get_button_threshold gamepad_set_button_threshold gamepad_get_axis_deadzone gamepad_set_axis_deadzone gamepad_button_count gamepad_button_check gamepad_button_check_pressed gamepad_button_check_released gamepad_button_value gamepad_axis_count gamepad_axis_value gamepad_set_vibration gamepad_set_colour gamepad_set_color os_is_paused window_has_focus code_is_compiled http_get http_get_file http_post_string http_request json_encode json_decode zip_unzip load_csv base64_encode base64_decode md5_string_unicode md5_string_utf8 md5_file os_is_network_connected sha1_string_unicode sha1_string_utf8 sha1_file os_powersave_enable analytics_event analytics_event_ext win8_livetile_tile_notification win8_livetile_tile_clear win8_livetile_badge_notification win8_livetile_badge_clear win8_livetile_queue_enable win8_secondarytile_pin win8_secondarytile_badge_notification win8_secondarytile_delete win8_livetile_notification_begin win8_livetile_notification_secondary_begin win8_livetile_notification_expiry win8_livetile_notification_tag win8_livetile_notification_text_add win8_livetile_notification_image_add win8_livetile_notification_end win8_appbar_enable win8_appbar_add_element win8_appbar_remove_element win8_settingscharm_add_entry win8_settingscharm_add_html_entry win8_settingscharm_add_xaml_entry win8_settingscharm_set_xaml_property win8_settingscharm_get_xaml_property win8_settingscharm_remove_entry win8_share_image win8_share_screenshot win8_share_file win8_share_url win8_share_text win8_search_enable win8_search_disable win8_search_add_suggestions win8_device_touchscreen_available win8_license_initialize_sandbox win8_license_trial_version winphone_license_trial_version winphone_tile_title winphone_tile_count winphone_tile_back_title winphone_tile_back_content winphone_tile_back_content_wide winphone_tile_front_image winphone_tile_front_image_small winphone_tile_front_image_wide winphone_tile_back_image winphone_tile_back_image_wide winphone_tile_background_colour winphone_tile_background_color winphone_tile_icon_image winphone_tile_small_icon_image winphone_tile_wide_content winphone_tile_cycle_images winphone_tile_small_background_image physics_world_create physics_world_gravity physics_world_update_speed physics_world_update_iterations physics_world_draw_debug physics_pause_enable physics_fixture_create physics_fixture_set_kinematic physics_fixture_set_density physics_fixture_set_awake physics_fixture_set_restitution physics_fixture_set_friction physics_fixture_set_collision_group physics_fixture_set_sensor physics_fixture_set_linear_damping physics_fixture_set_angular_damping physics_fixture_set_circle_shape physics_fixture_set_box_shape physics_fixture_set_edge_shape physics_fixture_set_polygon_shape physics_fixture_set_chain_shape physics_fixture_add_point physics_fixture_bind physics_fixture_bind_ext physics_fixture_delete physics_apply_force physics_apply_impulse physics_apply_angular_impulse physics_apply_local_force physics_apply_local_impulse physics_apply_torque physics_mass_properties physics_draw_debug physics_test_overlap physics_remove_fixture physics_set_friction physics_set_density physics_set_restitution physics_get_friction physics_get_density physics_get_restitution physics_joint_distance_create physics_joint_rope_create physics_joint_revolute_create physics_joint_prismatic_create physics_joint_pulley_create physics_joint_wheel_create physics_joint_weld_create physics_joint_friction_create physics_joint_gear_create physics_joint_enable_motor physics_joint_get_value physics_joint_set_value physics_joint_delete physics_particle_create physics_particle_delete physics_particle_delete_region_circle physics_particle_delete_region_box physics_particle_delete_region_poly physics_particle_set_flags physics_particle_set_category_flags physics_particle_draw physics_particle_draw_ext physics_particle_count physics_particle_get_data physics_particle_get_data_particle physics_particle_group_begin physics_particle_group_circle physics_particle_group_box physics_particle_group_polygon physics_particle_group_add_point physics_particle_group_end physics_particle_group_join physics_particle_group_delete physics_particle_group_count physics_particle_group_get_data physics_particle_group_get_mass physics_particle_group_get_inertia physics_particle_group_get_centre_x physics_particle_group_get_centre_y physics_particle_group_get_vel_x physics_particle_group_get_vel_y physics_particle_group_get_ang_vel physics_particle_group_get_x physics_particle_group_get_y physics_particle_group_get_angle physics_particle_set_group_flags physics_particle_get_group_flags physics_particle_get_max_count physics_particle_get_radius physics_particle_get_density physics_particle_get_damping physics_particle_get_gravity_scale physics_particle_set_max_count physics_particle_set_radius physics_particle_set_density physics_particle_set_damping physics_particle_set_gravity_scale network_create_socket network_create_socket_ext network_create_server network_create_server_raw network_connect network_connect_raw network_send_packet network_send_raw network_send_broadcast network_send_udp network_send_udp_raw network_set_timeout network_set_config network_resolve network_destroy buffer_create buffer_write buffer_read buffer_seek buffer_get_surface buffer_set_surface buffer_delete buffer_exists buffer_get_type buffer_get_alignment buffer_poke buffer_peek buffer_save buffer_save_ext buffer_load buffer_load_ext buffer_load_partial buffer_copy buffer_fill buffer_get_size buffer_tell buffer_resize buffer_md5 buffer_sha1 buffer_base64_encode buffer_base64_decode buffer_base64_decode_ext buffer_sizeof buffer_get_address buffer_create_from_vertex_buffer buffer_create_from_vertex_buffer_ext buffer_copy_from_vertex_buffer buffer_async_group_begin buffer_async_group_option buffer_async_group_end buffer_load_async buffer_save_async gml_release_mode gml_pragma steam_activate_overlay steam_is_overlay_enabled steam_is_overlay_activated steam_get_persona_name steam_initialised steam_is_cloud_enabled_for_app steam_is_cloud_enabled_for_account steam_file_persisted steam_get_quota_total steam_get_quota_free steam_file_write steam_file_write_file steam_file_read steam_file_delete steam_file_exists steam_file_size steam_file_share steam_is_screenshot_requested steam_send_screenshot steam_is_user_logged_on steam_get_user_steam_id steam_user_owns_dlc steam_user_installed_dlc steam_set_achievement steam_get_achievement steam_clear_achievement steam_set_stat_int steam_set_stat_float steam_set_stat_avg_rate steam_get_stat_int steam_get_stat_float steam_get_stat_avg_rate steam_reset_all_stats steam_reset_all_stats_achievements steam_stats_ready steam_create_leaderboard steam_upload_score steam_upload_score_ext steam_download_scores_around_user steam_download_scores steam_download_friends_scores steam_upload_score_buffer steam_upload_score_buffer_ext steam_current_game_language steam_available_languages steam_activate_overlay_browser steam_activate_overlay_user steam_activate_overlay_store steam_get_user_persona_name steam_get_app_id steam_get_user_account_id steam_ugc_download steam_ugc_create_item steam_ugc_start_item_update steam_ugc_set_item_title steam_ugc_set_item_description steam_ugc_set_item_visibility steam_ugc_set_item_tags steam_ugc_set_item_content steam_ugc_set_item_preview steam_ugc_submit_item_update steam_ugc_get_item_update_progress steam_ugc_subscribe_item steam_ugc_unsubscribe_item steam_ugc_num_subscribed_items steam_ugc_get_subscribed_items steam_ugc_get_item_install_info steam_ugc_get_item_update_info steam_ugc_request_item_details steam_ugc_create_query_user steam_ugc_create_query_user_ex steam_ugc_create_query_all steam_ugc_create_query_all_ex steam_ugc_query_set_cloud_filename_filter steam_ugc_query_set_match_any_tag steam_ugc_query_set_search_text steam_ugc_query_set_ranked_by_trend_days steam_ugc_query_add_required_tag steam_ugc_query_add_excluded_tag steam_ugc_query_set_return_long_description steam_ugc_query_set_return_total_only steam_ugc_query_set_allow_cached_response steam_ugc_send_query shader_set shader_get_name shader_reset shader_current shader_is_compiled shader_get_sampler_index shader_get_uniform shader_set_uniform_i shader_set_uniform_i_array shader_set_uniform_f shader_set_uniform_f_array shader_set_uniform_matrix shader_set_uniform_matrix_array shader_enable_corner_id texture_set_stage texture_get_texel_width texture_get_texel_height shaders_are_supported vertex_format_begin vertex_format_end vertex_format_delete vertex_format_add_position vertex_format_add_position_3d vertex_format_add_colour vertex_format_add_color vertex_format_add_normal vertex_format_add_texcoord vertex_format_add_textcoord vertex_format_add_custom vertex_create_buffer vertex_create_buffer_ext vertex_delete_buffer vertex_begin vertex_end vertex_position vertex_position_3d vertex_colour vertex_color vertex_argb vertex_texcoord vertex_normal vertex_float1 vertex_float2 vertex_float3 vertex_float4 vertex_ubyte4 vertex_submit vertex_freeze vertex_get_number vertex_get_buffer_size vertex_create_buffer_from_buffer vertex_create_buffer_from_buffer_ext push_local_notification push_get_first_local_notification push_get_next_local_notification push_cancel_local_notification skeleton_animation_set skeleton_animation_get skeleton_animation_mix skeleton_animation_set_ext skeleton_animation_get_ext skeleton_animation_get_duration skeleton_animation_get_frames skeleton_animation_clear skeleton_skin_set skeleton_skin_get skeleton_attachment_set skeleton_attachment_get skeleton_attachment_create skeleton_collision_draw_set skeleton_bone_data_get skeleton_bone_data_set skeleton_bone_state_get skeleton_bone_state_set skeleton_get_minmax skeleton_get_num_bounds skeleton_get_bounds skeleton_animation_get_frame skeleton_animation_set_frame draw_skeleton draw_skeleton_time draw_skeleton_instance draw_skeleton_collision skeleton_animation_list skeleton_skin_list skeleton_slot_data layer_get_id layer_get_id_at_depth layer_get_depth layer_create layer_destroy layer_destroy_instances layer_add_instance layer_has_instance layer_set_visible layer_get_visible layer_exists layer_x layer_y layer_get_x layer_get_y layer_hspeed layer_vspeed layer_get_hspeed layer_get_vspeed layer_script_begin layer_script_end layer_shader layer_get_script_begin layer_get_script_end layer_get_shader layer_set_target_room layer_get_target_room layer_reset_target_room layer_get_all layer_get_all_elements layer_get_name layer_depth layer_get_element_layer layer_get_element_type layer_element_move layer_force_draw_depth layer_is_draw_depth_forced layer_get_forced_depth layer_background_get_id layer_background_exists layer_background_create layer_background_destroy layer_background_visible layer_background_change layer_background_sprite layer_background_htiled layer_background_vtiled layer_background_stretch layer_background_yscale layer_background_xscale layer_background_blend layer_background_alpha layer_background_index layer_background_speed layer_background_get_visible layer_background_get_sprite layer_background_get_htiled layer_background_get_vtiled layer_background_get_stretch layer_background_get_yscale layer_background_get_xscale layer_background_get_blend layer_background_get_alpha layer_background_get_index layer_background_get_speed layer_sprite_get_id layer_sprite_exists layer_sprite_create layer_sprite_destroy layer_sprite_change layer_sprite_index layer_sprite_speed layer_sprite_xscale layer_sprite_yscale layer_sprite_angle layer_sprite_blend layer_sprite_alpha layer_sprite_x layer_sprite_y layer_sprite_get_sprite layer_sprite_get_index layer_sprite_get_speed layer_sprite_get_xscale layer_sprite_get_yscale layer_sprite_get_angle layer_sprite_get_blend layer_sprite_get_alpha layer_sprite_get_x layer_sprite_get_y layer_tilemap_get_id layer_tilemap_exists layer_tilemap_create layer_tilemap_destroy tilemap_tileset tilemap_x tilemap_y tilemap_set tilemap_set_at_pixel tilemap_get_tileset tilemap_get_tile_width tilemap_get_tile_height tilemap_get_width tilemap_get_height tilemap_get_x tilemap_get_y tilemap_get tilemap_get_at_pixel tilemap_get_cell_x_at_pixel tilemap_get_cell_y_at_pixel tilemap_clear draw_tilemap draw_tile tilemap_set_global_mask tilemap_get_global_mask tilemap_set_mask tilemap_get_mask tilemap_get_frame tile_set_empty tile_set_index tile_set_flip tile_set_mirror tile_set_rotate tile_get_empty tile_get_index tile_get_flip tile_get_mirror tile_get_rotate layer_tile_exists layer_tile_create layer_tile_destroy layer_tile_change layer_tile_xscale layer_tile_yscale layer_tile_blend layer_tile_alpha layer_tile_x layer_tile_y layer_tile_region layer_tile_visible layer_tile_get_sprite layer_tile_get_xscale layer_tile_get_yscale layer_tile_get_blend layer_tile_get_alpha layer_tile_get_x layer_tile_get_y layer_tile_get_region layer_tile_get_visible layer_instance_get_instance instance_activate_layer instance_deactivate_layer camera_create camera_create_view camera_destroy camera_apply camera_get_active camera_get_default camera_set_default camera_set_view_mat camera_set_proj_mat camera_set_update_script camera_set_begin_script camera_set_end_script camera_set_view_pos camera_set_view_size camera_set_view_speed camera_set_view_border camera_set_view_angle camera_set_view_target camera_get_view_mat camera_get_proj_mat camera_get_update_script camera_get_begin_script camera_get_end_script camera_get_view_x camera_get_view_y camera_get_view_width camera_get_view_height camera_get_view_speed_x camera_get_view_speed_y camera_get_view_border_x camera_get_view_border_y camera_get_view_angle camera_get_view_target view_get_camera view_get_visible view_get_xport view_get_yport view_get_wport view_get_hport view_get_surface_id view_set_camera view_set_visible view_set_xport view_set_yport view_set_wport view_set_hport view_set_surface_id gesture_drag_time gesture_drag_distance gesture_flick_speed gesture_double_tap_time gesture_double_tap_distance gesture_pinch_distance gesture_pinch_angle_towards gesture_pinch_angle_away gesture_rotate_time gesture_rotate_angle gesture_tap_count gesture_get_drag_time gesture_get_drag_distance gesture_get_flick_speed gesture_get_double_tap_time gesture_get_double_tap_distance gesture_get_pinch_distance gesture_get_pinch_angle_towards gesture_get_pinch_angle_away gesture_get_rotate_time gesture_get_rotate_angle gesture_get_tap_count keyboard_virtual_show keyboard_virtual_hide keyboard_virtual_status keyboard_virtual_height",
        literal: "self other all noone global local undefined pointer_invalid pointer_null path_action_stop path_action_restart path_action_continue path_action_reverse true false pi GM_build_date GM_version GM_runtime_version  timezone_local timezone_utc gamespeed_fps gamespeed_microseconds  ev_create ev_destroy ev_step ev_alarm ev_keyboard ev_mouse ev_collision ev_other ev_draw ev_draw_begin ev_draw_end ev_draw_pre ev_draw_post ev_keypress ev_keyrelease ev_trigger ev_left_button ev_right_button ev_middle_button ev_no_button ev_left_press ev_right_press ev_middle_press ev_left_release ev_right_release ev_middle_release ev_mouse_enter ev_mouse_leave ev_mouse_wheel_up ev_mouse_wheel_down ev_global_left_button ev_global_right_button ev_global_middle_button ev_global_left_press ev_global_right_press ev_global_middle_press ev_global_left_release ev_global_right_release ev_global_middle_release ev_joystick1_left ev_joystick1_right ev_joystick1_up ev_joystick1_down ev_joystick1_button1 ev_joystick1_button2 ev_joystick1_button3 ev_joystick1_button4 ev_joystick1_button5 ev_joystick1_button6 ev_joystick1_button7 ev_joystick1_button8 ev_joystick2_left ev_joystick2_right ev_joystick2_up ev_joystick2_down ev_joystick2_button1 ev_joystick2_button2 ev_joystick2_button3 ev_joystick2_button4 ev_joystick2_button5 ev_joystick2_button6 ev_joystick2_button7 ev_joystick2_button8 ev_outside ev_boundary ev_game_start ev_game_end ev_room_start ev_room_end ev_no_more_lives ev_animation_end ev_end_of_path ev_no_more_health ev_close_button ev_user0 ev_user1 ev_user2 ev_user3 ev_user4 ev_user5 ev_user6 ev_user7 ev_user8 ev_user9 ev_user10 ev_user11 ev_user12 ev_user13 ev_user14 ev_user15 ev_step_normal ev_step_begin ev_step_end ev_gui ev_gui_begin ev_gui_end ev_cleanup ev_gesture ev_gesture_tap ev_gesture_double_tap ev_gesture_drag_start ev_gesture_dragging ev_gesture_drag_end ev_gesture_flick ev_gesture_pinch_start ev_gesture_pinch_in ev_gesture_pinch_out ev_gesture_pinch_end ev_gesture_rotate_start ev_gesture_rotating ev_gesture_rotate_end ev_global_gesture_tap ev_global_gesture_double_tap ev_global_gesture_drag_start ev_global_gesture_dragging ev_global_gesture_drag_end ev_global_gesture_flick ev_global_gesture_pinch_start ev_global_gesture_pinch_in ev_global_gesture_pinch_out ev_global_gesture_pinch_end ev_global_gesture_rotate_start ev_global_gesture_rotating ev_global_gesture_rotate_end vk_nokey vk_anykey vk_enter vk_return vk_shift vk_control vk_alt vk_escape vk_space vk_backspace vk_tab vk_pause vk_printscreen vk_left vk_right vk_up vk_down vk_home vk_end vk_delete vk_insert vk_pageup vk_pagedown vk_f1 vk_f2 vk_f3 vk_f4 vk_f5 vk_f6 vk_f7 vk_f8 vk_f9 vk_f10 vk_f11 vk_f12 vk_numpad0 vk_numpad1 vk_numpad2 vk_numpad3 vk_numpad4 vk_numpad5 vk_numpad6 vk_numpad7 vk_numpad8 vk_numpad9 vk_divide vk_multiply vk_subtract vk_add vk_decimal vk_lshift vk_lcontrol vk_lalt vk_rshift vk_rcontrol vk_ralt  mb_any mb_none mb_left mb_right mb_middle c_aqua c_black c_blue c_dkgray c_fuchsia c_gray c_green c_lime c_ltgray c_maroon c_navy c_olive c_purple c_red c_silver c_teal c_white c_yellow c_orange fa_left fa_center fa_right fa_top fa_middle fa_bottom pr_pointlist pr_linelist pr_linestrip pr_trianglelist pr_trianglestrip pr_trianglefan bm_complex bm_normal bm_add bm_max bm_subtract bm_zero bm_one bm_src_colour bm_inv_src_colour bm_src_color bm_inv_src_color bm_src_alpha bm_inv_src_alpha bm_dest_alpha bm_inv_dest_alpha bm_dest_colour bm_inv_dest_colour bm_dest_color bm_inv_dest_color bm_src_alpha_sat tf_point tf_linear tf_anisotropic mip_off mip_on mip_markedonly audio_falloff_none audio_falloff_inverse_distance audio_falloff_inverse_distance_clamped audio_falloff_linear_distance audio_falloff_linear_distance_clamped audio_falloff_exponent_distance audio_falloff_exponent_distance_clamped audio_old_system audio_new_system audio_mono audio_stereo audio_3d cr_default cr_none cr_arrow cr_cross cr_beam cr_size_nesw cr_size_ns cr_size_nwse cr_size_we cr_uparrow cr_hourglass cr_drag cr_appstart cr_handpoint cr_size_all spritespeed_framespersecond spritespeed_framespergameframe asset_object asset_unknown asset_sprite asset_sound asset_room asset_path asset_script asset_font asset_timeline asset_tiles asset_shader fa_readonly fa_hidden fa_sysfile fa_volumeid fa_directory fa_archive  ds_type_map ds_type_list ds_type_stack ds_type_queue ds_type_grid ds_type_priority ef_explosion ef_ring ef_ellipse ef_firework ef_smoke ef_smokeup ef_star ef_spark ef_flare ef_cloud ef_rain ef_snow pt_shape_pixel pt_shape_disk pt_shape_square pt_shape_line pt_shape_star pt_shape_circle pt_shape_ring pt_shape_sphere pt_shape_flare pt_shape_spark pt_shape_explosion pt_shape_cloud pt_shape_smoke pt_shape_snow ps_distr_linear ps_distr_gaussian ps_distr_invgaussian ps_shape_rectangle ps_shape_ellipse ps_shape_diamond ps_shape_line ty_real ty_string dll_cdecl dll_stdcall matrix_view matrix_projection matrix_world os_win32 os_windows os_macosx os_ios os_android os_symbian os_linux os_unknown os_winphone os_tizen os_win8native os_wiiu os_3ds  os_psvita os_bb10 os_ps4 os_xboxone os_ps3 os_xbox360 os_uwp os_tvos os_switch browser_not_a_browser browser_unknown browser_ie browser_firefox browser_chrome browser_safari browser_safari_mobile browser_opera browser_tizen browser_edge browser_windows_store browser_ie_mobile  device_ios_unknown device_ios_iphone device_ios_iphone_retina device_ios_ipad device_ios_ipad_retina device_ios_iphone5 device_ios_iphone6 device_ios_iphone6plus device_emulator device_tablet display_landscape display_landscape_flipped display_portrait display_portrait_flipped tm_sleep tm_countvsyncs of_challenge_win of_challen ge_lose of_challenge_tie leaderboard_type_number leaderboard_type_time_mins_secs cmpfunc_never cmpfunc_less cmpfunc_equal cmpfunc_lessequal cmpfunc_greater cmpfunc_notequal cmpfunc_greaterequal cmpfunc_always cull_noculling cull_clockwise cull_counterclockwise lighttype_dir lighttype_point iap_ev_storeload iap_ev_product iap_ev_purchase iap_ev_consume iap_ev_restore iap_storeload_ok iap_storeload_failed iap_status_uninitialised iap_status_unavailable iap_status_loading iap_status_available iap_status_processing iap_status_restoring iap_failed iap_unavailable iap_available iap_purchased iap_canceled iap_refunded fb_login_default fb_login_fallback_to_webview fb_login_no_fallback_to_webview fb_login_forcing_webview fb_login_use_system_account fb_login_forcing_safari  phy_joint_anchor_1_x phy_joint_anchor_1_y phy_joint_anchor_2_x phy_joint_anchor_2_y phy_joint_reaction_force_x phy_joint_reaction_force_y phy_joint_reaction_torque phy_joint_motor_speed phy_joint_angle phy_joint_motor_torque phy_joint_max_motor_torque phy_joint_translation phy_joint_speed phy_joint_motor_force phy_joint_max_motor_force phy_joint_length_1 phy_joint_length_2 phy_joint_damping_ratio phy_joint_frequency phy_joint_lower_angle_limit phy_joint_upper_angle_limit phy_joint_angle_limits phy_joint_max_length phy_joint_max_torque phy_joint_max_force phy_debug_render_aabb phy_debug_render_collision_pairs phy_debug_render_coms phy_debug_render_core_shapes phy_debug_render_joints phy_debug_render_obb phy_debug_render_shapes  phy_particle_flag_water phy_particle_flag_zombie phy_particle_flag_wall phy_particle_flag_spring phy_particle_flag_elastic phy_particle_flag_viscous phy_particle_flag_powder phy_particle_flag_tensile phy_particle_flag_colourmixing phy_particle_flag_colormixing phy_particle_group_flag_solid phy_particle_group_flag_rigid phy_particle_data_flag_typeflags phy_particle_data_flag_position phy_particle_data_flag_velocity phy_particle_data_flag_colour phy_particle_data_flag_color phy_particle_data_flag_category  achievement_our_info achievement_friends_info achievement_leaderboard_info achievement_achievement_info achievement_filter_all_players achievement_filter_friends_only achievement_filter_favorites_only achievement_type_achievement_challenge achievement_type_score_challenge achievement_pic_loaded  achievement_show_ui achievement_show_profile achievement_show_leaderboard achievement_show_achievement achievement_show_bank achievement_show_friend_picker achievement_show_purchase_prompt network_socket_tcp network_socket_udp network_socket_bluetooth network_type_connect network_type_disconnect network_type_data network_type_non_blocking_connect network_config_connect_timeout network_config_use_non_blocking_socket network_config_enable_reliable_udp network_config_disable_reliable_udp buffer_fixed buffer_grow buffer_wrap buffer_fast buffer_vbuffer buffer_network buffer_u8 buffer_s8 buffer_u16 buffer_s16 buffer_u32 buffer_s32 buffer_u64 buffer_f16 buffer_f32 buffer_f64 buffer_bool buffer_text buffer_string buffer_surface_copy buffer_seek_start buffer_seek_relative buffer_seek_end buffer_generalerror buffer_outofspace buffer_outofbounds buffer_invalidtype  text_type button_type input_type ANSI_CHARSET DEFAULT_CHARSET EASTEUROPE_CHARSET RUSSIAN_CHARSET SYMBOL_CHARSET SHIFTJIS_CHARSET HANGEUL_CHARSET GB2312_CHARSET CHINESEBIG5_CHARSET JOHAB_CHARSET HEBREW_CHARSET ARABIC_CHARSET GREEK_CHARSET TURKISH_CHARSET VIETNAMESE_CHARSET THAI_CHARSET MAC_CHARSET BALTIC_CHARSET OEM_CHARSET  gp_face1 gp_face2 gp_face3 gp_face4 gp_shoulderl gp_shoulderr gp_shoulderlb gp_shoulderrb gp_select gp_start gp_stickl gp_stickr gp_padu gp_padd gp_padl gp_padr gp_axislh gp_axislv gp_axisrh gp_axisrv ov_friends ov_community ov_players ov_settings ov_gamegroup ov_achievements lb_sort_none lb_sort_ascending lb_sort_descending lb_disp_none lb_disp_numeric lb_disp_time_sec lb_disp_time_ms ugc_result_success ugc_filetype_community ugc_filetype_microtrans ugc_visibility_public ugc_visibility_friends_only ugc_visibility_private ugc_query_RankedByVote ugc_query_RankedByPublicationDate ugc_query_AcceptedForGameRankedByAcceptanceDate ugc_query_RankedByTrend ugc_query_FavoritedByFriendsRankedByPublicationDate ugc_query_CreatedByFriendsRankedByPublicationDate ugc_query_RankedByNumTimesReported ugc_query_CreatedByFollowedUsersRankedByPublicationDate ugc_query_NotYetRated ugc_query_RankedByTotalVotesAsc ugc_query_RankedByVotesUp ugc_query_RankedByTextSearch ugc_sortorder_CreationOrderDesc ugc_sortorder_CreationOrderAsc ugc_sortorder_TitleAsc ugc_sortorder_LastUpdatedDesc ugc_sortorder_SubscriptionDateDesc ugc_sortorder_VoteScoreDesc ugc_sortorder_ForModeration ugc_list_Published ugc_list_VotedOn ugc_list_VotedUp ugc_list_VotedDown ugc_list_WillVoteLater ugc_list_Favorited ugc_list_Subscribed ugc_list_UsedOrPlayed ugc_list_Followed ugc_match_Items ugc_match_Items_Mtx ugc_match_Items_ReadyToUse ugc_match_Collections ugc_match_Artwork ugc_match_Videos ugc_match_Screenshots ugc_match_AllGuides ugc_match_WebGuides ugc_match_IntegratedGuides ugc_match_UsableInGame ugc_match_ControllerBindings  vertex_usage_position vertex_usage_colour vertex_usage_color vertex_usage_normal vertex_usage_texcoord vertex_usage_textcoord vertex_usage_blendweight vertex_usage_blendindices vertex_usage_psize vertex_usage_tangent vertex_usage_binormal vertex_usage_fog vertex_usage_depth vertex_usage_sample vertex_type_float1 vertex_type_float2 vertex_type_float3 vertex_type_float4 vertex_type_colour vertex_type_color vertex_type_ubyte4 layerelementtype_undefined layerelementtype_background layerelementtype_instance layerelementtype_oldtilemap layerelementtype_sprite layerelementtype_tilemap layerelementtype_particlesystem layerelementtype_tile tile_rotate tile_flip tile_mirror tile_index_mask kbv_type_default kbv_type_ascii kbv_type_url kbv_type_email kbv_type_numbers kbv_type_phone kbv_type_phone_name kbv_returnkey_default kbv_returnkey_go kbv_returnkey_google kbv_returnkey_join kbv_returnkey_next kbv_returnkey_route kbv_returnkey_search kbv_returnkey_send kbv_returnkey_yahoo kbv_returnkey_done kbv_returnkey_continue kbv_returnkey_emergency kbv_autocapitalize_none kbv_autocapitalize_words kbv_autocapitalize_sentences kbv_autocapitalize_characters",
        symbol: "argument_relative argument argument0 argument1 argument2 argument3 argument4 argument5 argument6 argument7 argument8 argument9 argument10 argument11 argument12 argument13 argument14 argument15 argument_count x y xprevious yprevious xstart ystart hspeed vspeed direction speed friction gravity gravity_direction path_index path_position path_positionprevious path_speed path_scale path_orientation path_endaction object_index id solid persistent mask_index instance_count instance_id room_speed fps fps_real current_time current_year current_month current_day current_weekday current_hour current_minute current_second alarm timeline_index timeline_position timeline_speed timeline_running timeline_loop room room_first room_last room_width room_height room_caption room_persistent score lives health show_score show_lives show_health caption_score caption_lives caption_health event_type event_number event_object event_action application_surface gamemaker_pro gamemaker_registered gamemaker_version error_occurred error_last debug_mode keyboard_key keyboard_lastkey keyboard_lastchar keyboard_string mouse_x mouse_y mouse_button mouse_lastbutton cursor_sprite visible sprite_index sprite_width sprite_height sprite_xoffset sprite_yoffset image_number image_index image_speed depth image_xscale image_yscale image_angle image_alpha image_blend bbox_left bbox_right bbox_top bbox_bottom layer background_colour  background_showcolour background_color background_showcolor view_enabled view_current view_visible view_xview view_yview view_wview view_hview view_xport view_yport view_wport view_hport view_angle view_hborder view_vborder view_hspeed view_vspeed view_object view_surface_id view_camera game_id game_display_name game_project_name game_save_id working_directory temp_directory program_directory browser_width browser_height os_type os_device os_browser os_version display_aa async_load delta_time webgl_enabled event_data iap_data phy_rotation phy_position_x phy_position_y phy_angular_velocity phy_linear_velocity_x phy_linear_velocity_y phy_speed_x phy_speed_y phy_speed phy_angular_damping phy_linear_damping phy_bullet phy_fixed_rotation phy_active phy_mass phy_inertia phy_com_x phy_com_y phy_dynamic phy_kinematic phy_sleeping phy_collision_points phy_collision_x phy_collision_y phy_col_normal_x phy_col_normal_y phy_position_xprevious phy_position_yprevious"
    };
    return {
        aliases: [
            "gml",
            "GML"
        ],
        case_insensitive: false,
        keywords: GML_KEYWORDS,
        contains: [
            hljs.C_LINE_COMMENT_MODE,
            hljs.C_BLOCK_COMMENT_MODE,
            hljs.APOS_STRING_MODE,
            hljs.QUOTE_STRING_MODE,
            hljs.C_NUMBER_MODE
        ]
    };
};

});

parcelRegister("eCnIO", function(module, exports) {
module.exports = function(hljs) {
    var GO_KEYWORDS = {
        keyword: "break default func interface select case map struct chan else goto package switch const fallthrough if range type continue for import return var go defer bool byte complex64 complex128 float32 float64 int8 int16 int32 int64 string uint8 uint16 uint32 uint64 int uint uintptr rune",
        literal: "true false iota nil",
        built_in: "append cap close complex copy imag len make new panic print println real recover delete"
    };
    return {
        aliases: [
            "golang"
        ],
        keywords: GO_KEYWORDS,
        illegal: "</",
        contains: [
            hljs.C_LINE_COMMENT_MODE,
            hljs.C_BLOCK_COMMENT_MODE,
            {
                className: "string",
                variants: [
                    hljs.QUOTE_STRING_MODE,
                    hljs.APOS_STRING_MODE,
                    {
                        begin: "`",
                        end: "`"
                    }
                ]
            },
            {
                className: "number",
                variants: [
                    {
                        begin: hljs.C_NUMBER_RE + "[i]",
                        relevance: 1
                    },
                    hljs.C_NUMBER_MODE
                ]
            },
            {
                begin: /:=/ // relevance booster
            },
            {
                className: "function",
                beginKeywords: "func",
                end: "\\s*(\\{|$)",
                excludeEnd: true,
                contains: [
                    hljs.TITLE_MODE,
                    {
                        className: "params",
                        begin: /\(/,
                        end: /\)/,
                        keywords: GO_KEYWORDS,
                        illegal: /["']/
                    }
                ]
            }
        ]
    };
};

});

parcelRegister("fItrr", function(module, exports) {
module.exports = function(hljs) {
    return {
        keywords: {
            keyword: "println readln print import module function local return let var while for foreach times in case when match with break continue augment augmentation each find filter reduce if then else otherwise try catch finally raise throw orIfNull DynamicObject|10 DynamicVariable struct Observable map set vector list array",
            literal: "true false null"
        },
        contains: [
            hljs.HASH_COMMENT_MODE,
            hljs.QUOTE_STRING_MODE,
            hljs.C_NUMBER_MODE,
            {
                className: "meta",
                begin: "@[A-Za-z]+"
            }
        ]
    };
};

});

parcelRegister("l8Fwd", function(module, exports) {
module.exports = function(hljs) {
    return {
        case_insensitive: true,
        keywords: {
            keyword: "task project allprojects subprojects artifacts buildscript configurations dependencies repositories sourceSets description delete from into include exclude source classpath destinationDir includes options sourceCompatibility targetCompatibility group flatDir doLast doFirst flatten todir fromdir ant def abstract break case catch continue default do else extends final finally for if implements instanceof native new private protected public return static switch synchronized throw throws transient try volatile while strictfp package import false null super this true antlrtask checkstyle codenarc copy boolean byte char class double float int interface long short void compile runTime file fileTree abs any append asList asWritable call collect compareTo count div dump each eachByte eachFile eachLine every find findAll flatten getAt getErr getIn getOut getText grep immutable inject inspect intersect invokeMethods isCase join leftShift minus multiply newInputStream newOutputStream newPrintWriter newReader newWriter next plus pop power previous print println push putAt read readBytes readLines reverse reverseEach round size sort splitEachLine step subMap times toInteger toList tokenize upto waitForOrKill withPrintWriter withReader withStream withWriter withWriterAppend write writeLine"
        },
        contains: [
            hljs.C_LINE_COMMENT_MODE,
            hljs.C_BLOCK_COMMENT_MODE,
            hljs.APOS_STRING_MODE,
            hljs.QUOTE_STRING_MODE,
            hljs.NUMBER_MODE,
            hljs.REGEXP_MODE
        ]
    };
};

});

parcelRegister("8cUJC", function(module, exports) {
module.exports = function(hljs) {
    return {
        keywords: {
            literal: "true false null",
            keyword: "byte short char int long boolean float double void def as in assert trait super this abstract static volatile transient public private protected synchronized final class interface enum if else for while switch case break default continue throw throws try catch finally implements extends new import package return instanceof"
        },
        contains: [
            hljs.COMMENT("/\\*\\*", "\\*/", {
                relevance: 0,
                contains: [
                    {
                        // eat up @'s in emails to prevent them to be recognized as doctags
                        begin: /\w+@/,
                        relevance: 0
                    },
                    {
                        className: "doctag",
                        begin: "@[A-Za-z]+"
                    }
                ]
            }),
            hljs.C_LINE_COMMENT_MODE,
            hljs.C_BLOCK_COMMENT_MODE,
            {
                className: "string",
                begin: '"""',
                end: '"""'
            },
            {
                className: "string",
                begin: "'''",
                end: "'''"
            },
            {
                className: "string",
                begin: "\\$/",
                end: "/\\$",
                relevance: 10
            },
            hljs.APOS_STRING_MODE,
            {
                className: "regexp",
                begin: /~?\/[^\/\n]+\//,
                contains: [
                    hljs.BACKSLASH_ESCAPE
                ]
            },
            hljs.QUOTE_STRING_MODE,
            {
                className: "meta",
                begin: "^#!/usr/bin/env",
                end: "$",
                illegal: "\n"
            },
            hljs.BINARY_NUMBER_MODE,
            {
                className: "class",
                beginKeywords: "class interface trait enum",
                end: "{",
                illegal: ":",
                contains: [
                    {
                        beginKeywords: "extends implements"
                    },
                    hljs.UNDERSCORE_TITLE_MODE
                ]
            },
            hljs.C_NUMBER_MODE,
            {
                className: "meta",
                begin: "@[A-Za-z]+"
            },
            {
                // highlight map keys and named parameters as strings
                className: "string",
                begin: /[^\?]{0}[A-Za-z0-9_$]+ *:/
            },
            {
                // catch middle element of the ternary operator
                // to avoid highlight it as a label, named parameter, or map key
                begin: /\?/,
                end: /\:/
            },
            {
                // highlight labeled statements
                className: "symbol",
                begin: "^\\s*[A-Za-z0-9_$]+:",
                relevance: 0
            }
        ],
        illegal: /#|<\//
    };
};

});

parcelRegister("higtC", function(module, exports) {
module.exports = function(hljs) {
    return {
        case_insensitive: true,
        contains: [
            {
                className: "meta",
                begin: "^!!!( (5|1\\.1|Strict|Frameset|Basic|Mobile|RDFa|XML\\b.*))?$",
                relevance: 10
            },
            // FIXME these comments should be allowed to span indented lines
            hljs.COMMENT("^\\s*(!=#|=#|-#|/).*$", false, {
                relevance: 0
            }),
            {
                begin: "^\\s*(-|=|!=)(?!#)",
                starts: {
                    end: "\\n",
                    subLanguage: "ruby"
                }
            },
            {
                className: "tag",
                begin: "^\\s*%",
                contains: [
                    {
                        className: "selector-tag",
                        begin: "\\w+"
                    },
                    {
                        className: "selector-id",
                        begin: "#[\\w-]+"
                    },
                    {
                        className: "selector-class",
                        begin: "\\.[\\w-]+"
                    },
                    {
                        begin: "{\\s*",
                        end: "\\s*}",
                        contains: [
                            {
                                begin: ":\\w+\\s*=>",
                                end: ",\\s+",
                                returnBegin: true,
                                endsWithParent: true,
                                contains: [
                                    {
                                        className: "attr",
                                        begin: ":\\w+"
                                    },
                                    hljs.APOS_STRING_MODE,
                                    hljs.QUOTE_STRING_MODE,
                                    {
                                        begin: "\\w+",
                                        relevance: 0
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        begin: "\\(\\s*",
                        end: "\\s*\\)",
                        excludeEnd: true,
                        contains: [
                            {
                                begin: "\\w+\\s*=",
                                end: "\\s+",
                                returnBegin: true,
                                endsWithParent: true,
                                contains: [
                                    {
                                        className: "attr",
                                        begin: "\\w+",
                                        relevance: 0
                                    },
                                    hljs.APOS_STRING_MODE,
                                    hljs.QUOTE_STRING_MODE,
                                    {
                                        begin: "\\w+",
                                        relevance: 0
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                begin: "^\\s*[=~]\\s*"
            },
            {
                begin: "#{",
                starts: {
                    end: "}",
                    subLanguage: "ruby"
                }
            }
        ]
    };
};

});

parcelRegister("hkha6", function(module, exports) {
module.exports = function(hljs) {
    var BUILT_INS = {
        "builtin-name": "each in with if else unless bindattr action collection debugger log outlet template unbound view yield lookup"
    };
    var IDENTIFIER_PLAIN_OR_QUOTED = {
        begin: /".*?"|'.*?'|\[.*?\]|\w+/
    };
    var EXPRESSION_OR_HELPER_CALL = hljs.inherit(IDENTIFIER_PLAIN_OR_QUOTED, {
        keywords: BUILT_INS,
        starts: {
            // helper params
            endsWithParent: true,
            relevance: 0,
            contains: [
                hljs.inherit(IDENTIFIER_PLAIN_OR_QUOTED, {
                    relevance: 0
                })
            ]
        }
    });
    var BLOCK_MUSTACHE_CONTENTS = hljs.inherit(EXPRESSION_OR_HELPER_CALL, {
        className: "name"
    });
    var BASIC_MUSTACHE_CONTENTS = hljs.inherit(EXPRESSION_OR_HELPER_CALL, {
        // relevance 0 for backward compatibility concerning auto-detection
        relevance: 0
    });
    var ESCAPE_MUSTACHE_WITH_PRECEEDING_BACKSLASH = {
        begin: /\\\{\{/,
        skip: true
    };
    var PREVENT_ESCAPE_WITH_ANOTHER_PRECEEDING_BACKSLASH = {
        begin: /\\\\(?=\{\{)/,
        skip: true
    };
    return {
        aliases: [
            "hbs",
            "html.hbs",
            "html.handlebars"
        ],
        case_insensitive: true,
        subLanguage: "xml",
        contains: [
            ESCAPE_MUSTACHE_WITH_PRECEEDING_BACKSLASH,
            PREVENT_ESCAPE_WITH_ANOTHER_PRECEEDING_BACKSLASH,
            hljs.COMMENT(/\{\{!--/, /--\}\}/),
            hljs.COMMENT(/\{\{!/, /\}\}/),
            {
                // open raw block "{{{{raw}}}} content not evaluated {{{{/raw}}}}"
                className: "template-tag",
                begin: /\{\{\{\{(?!\/)/,
                end: /\}\}\}\}/,
                contains: [
                    BLOCK_MUSTACHE_CONTENTS
                ],
                starts: {
                    end: /\{\{\{\{\//,
                    returnEnd: true,
                    subLanguage: "xml"
                }
            },
            {
                // close raw block
                className: "template-tag",
                begin: /\{\{\{\{\//,
                end: /\}\}\}\}/,
                contains: [
                    BLOCK_MUSTACHE_CONTENTS
                ]
            },
            {
                // open block statement
                className: "template-tag",
                begin: /\{\{[#\/]/,
                end: /\}\}/,
                contains: [
                    BLOCK_MUSTACHE_CONTENTS
                ]
            },
            {
                // template variable or helper-call that is NOT html-escaped
                className: "template-variable",
                begin: /\{\{\{/,
                end: /\}\}\}/,
                keywords: BUILT_INS,
                contains: [
                    BASIC_MUSTACHE_CONTENTS
                ]
            },
            {
                // template variable or helper-call that is html-escaped
                className: "template-variable",
                begin: /\{\{/,
                end: /\}\}/,
                keywords: BUILT_INS,
                contains: [
                    BASIC_MUSTACHE_CONTENTS
                ]
            }
        ]
    };
};

});

parcelRegister("ciB8y", function(module, exports) {
module.exports = function(hljs) {
    var COMMENT = {
        variants: [
            hljs.COMMENT("--", "$"),
            hljs.COMMENT("{-", "-}", {
                contains: [
                    "self"
                ]
            })
        ]
    };
    var PRAGMA = {
        className: "meta",
        begin: "{-#",
        end: "#-}"
    };
    var PREPROCESSOR = {
        className: "meta",
        begin: "^#",
        end: "$"
    };
    var CONSTRUCTOR = {
        className: "type",
        begin: "\\b[A-Z][\\w']*",
        relevance: 0
    };
    var LIST = {
        begin: "\\(",
        end: "\\)",
        illegal: '"',
        contains: [
            PRAGMA,
            PREPROCESSOR,
            {
                className: "type",
                begin: "\\b[A-Z][\\w]*(\\((\\.\\.|,|\\w+)\\))?"
            },
            hljs.inherit(hljs.TITLE_MODE, {
                begin: "[_a-z][\\w']*"
            }),
            COMMENT
        ]
    };
    var RECORD = {
        begin: "{",
        end: "}",
        contains: LIST.contains
    };
    return {
        aliases: [
            "hs"
        ],
        keywords: "let in if then else case of where do module import hiding qualified type data newtype deriving class instance as default infix infixl infixr foreign export ccall stdcall cplusplus jvm dotnet safe unsafe family forall mdo proc rec",
        contains: [
            // Top-level constructions.
            {
                beginKeywords: "module",
                end: "where",
                keywords: "module where",
                contains: [
                    LIST,
                    COMMENT
                ],
                illegal: "\\W\\.|;"
            },
            {
                begin: "\\bimport\\b",
                end: "$",
                keywords: "import qualified as hiding",
                contains: [
                    LIST,
                    COMMENT
                ],
                illegal: "\\W\\.|;"
            },
            {
                className: "class",
                begin: "^(\\s*)?(class|instance)\\b",
                end: "where",
                keywords: "class family instance where",
                contains: [
                    CONSTRUCTOR,
                    LIST,
                    COMMENT
                ]
            },
            {
                className: "class",
                begin: "\\b(data|(new)?type)\\b",
                end: "$",
                keywords: "data family type newtype deriving",
                contains: [
                    PRAGMA,
                    CONSTRUCTOR,
                    LIST,
                    RECORD,
                    COMMENT
                ]
            },
            {
                beginKeywords: "default",
                end: "$",
                contains: [
                    CONSTRUCTOR,
                    LIST,
                    COMMENT
                ]
            },
            {
                beginKeywords: "infix infixl infixr",
                end: "$",
                contains: [
                    hljs.C_NUMBER_MODE,
                    COMMENT
                ]
            },
            {
                begin: "\\bforeign\\b",
                end: "$",
                keywords: "foreign import export ccall stdcall cplusplus jvm dotnet safe unsafe",
                contains: [
                    CONSTRUCTOR,
                    hljs.QUOTE_STRING_MODE,
                    COMMENT
                ]
            },
            {
                className: "meta",
                begin: "#!\\/usr\\/bin\\/env runhaskell",
                end: "$"
            },
            // "Whitespaces".
            PRAGMA,
            PREPROCESSOR,
            // Literals and names.
            // TODO: characters.
            hljs.QUOTE_STRING_MODE,
            hljs.C_NUMBER_MODE,
            CONSTRUCTOR,
            hljs.inherit(hljs.TITLE_MODE, {
                begin: "^[_a-z][\\w']*"
            }),
            COMMENT,
            {
                begin: "->|<-"
            } // No markup, relevance booster
        ]
    };
};

});

parcelRegister("freT9", function(module, exports) {
module.exports = function(hljs) {
    var IDENT_RE = "[a-zA-Z_$][a-zA-Z0-9_$]*";
    var IDENT_FUNC_RETURN_TYPE_RE = "([*]|[a-zA-Z_$][a-zA-Z0-9_$]*)";
    var HAXE_BASIC_TYPES = "Int Float String Bool Dynamic Void Array ";
    return {
        aliases: [
            "hx"
        ],
        keywords: {
            keyword: "break case cast catch continue default do dynamic else enum extern for function here if import in inline never new override package private get set public return static super switch this throw trace try typedef untyped using var while " + HAXE_BASIC_TYPES,
            built_in: "trace this",
            literal: "true false null _"
        },
        contains: [
            {
                className: "string",
                begin: "'",
                end: "'",
                contains: [
                    hljs.BACKSLASH_ESCAPE,
                    {
                        className: "subst",
                        begin: "\\$\\{",
                        end: "\\}"
                    },
                    {
                        className: "subst",
                        begin: "\\$",
                        end: "\\W}"
                    }
                ]
            },
            hljs.QUOTE_STRING_MODE,
            hljs.C_LINE_COMMENT_MODE,
            hljs.C_BLOCK_COMMENT_MODE,
            hljs.C_NUMBER_MODE,
            {
                className: "meta",
                begin: "@:",
                end: "$"
            },
            {
                className: "meta",
                begin: "#",
                end: "$",
                keywords: {
                    "meta-keyword": "if else elseif end error"
                }
            },
            {
                className: "type",
                begin: ":[ 	]*",
                end: "[^A-Za-z0-9_ 	\\->]",
                excludeBegin: true,
                excludeEnd: true,
                relevance: 0
            },
            {
                className: "type",
                begin: ":[ 	]*",
                end: "\\W",
                excludeBegin: true,
                excludeEnd: true
            },
            {
                className: "type",
                begin: "new *",
                end: "\\W",
                excludeBegin: true,
                excludeEnd: true
            },
            {
                className: "class",
                beginKeywords: "enum",
                end: "\\{",
                contains: [
                    hljs.TITLE_MODE
                ]
            },
            {
                className: "class",
                beginKeywords: "abstract",
                end: "[\\{$]",
                contains: [
                    {
                        className: "type",
                        begin: "\\(",
                        end: "\\)",
                        excludeBegin: true,
                        excludeEnd: true
                    },
                    {
                        className: "type",
                        begin: "from +",
                        end: "\\W",
                        excludeBegin: true,
                        excludeEnd: true
                    },
                    {
                        className: "type",
                        begin: "to +",
                        end: "\\W",
                        excludeBegin: true,
                        excludeEnd: true
                    },
                    hljs.TITLE_MODE
                ],
                keywords: {
                    keyword: "abstract from to"
                }
            },
            {
                className: "class",
                begin: "\\b(class|interface) +",
                end: "[\\{$]",
                excludeEnd: true,
                keywords: "class interface",
                contains: [
                    {
                        className: "keyword",
                        begin: "\\b(extends|implements) +",
                        keywords: "extends implements",
                        contains: [
                            {
                                className: "type",
                                begin: hljs.IDENT_RE,
                                relevance: 0
                            }
                        ]
                    },
                    hljs.TITLE_MODE
                ]
            },
            {
                className: "function",
                beginKeywords: "function",
                end: "\\(",
                excludeEnd: true,
                illegal: "\\S",
                contains: [
                    hljs.TITLE_MODE
                ]
            }
        ],
        illegal: /<\//
    };
};

});

parcelRegister("fWLHt", function(module, exports) {
module.exports = function(hljs) {
    return {
        case_insensitive: true,
        lexemes: /[\w\._]+/,
        keywords: "goto gosub return break repeat loop continue wait await dim sdim foreach dimtype dup dupptr end stop newmod delmod mref run exgoto on mcall assert logmes newlab resume yield onexit onerror onkey onclick oncmd exist delete mkdir chdir dirlist bload bsave bcopy memfile if else poke wpoke lpoke getstr chdpm memexpand memcpy memset notesel noteadd notedel noteload notesave randomize noteunsel noteget split strrep setease button chgdisp exec dialog mmload mmplay mmstop mci pset pget syscolor mes print title pos circle cls font sysfont objsize picload color palcolor palette redraw width gsel gcopy gzoom gmode bmpsave hsvcolor getkey listbox chkbox combox input mesbox buffer screen bgscr mouse objsel groll line clrobj boxf objprm objmode stick grect grotate gsquare gradf objimage objskip objenable celload celdiv celput newcom querycom delcom cnvstow comres axobj winobj sendmsg comevent comevarg sarrayconv callfunc cnvwtos comevdisp libptr system hspstat hspver stat cnt err strsize looplev sublev iparam wparam lparam refstr refdval int rnd strlen length length2 length3 length4 vartype gettime peek wpeek lpeek varptr varuse noteinfo instr abs limit getease str strmid strf getpath strtrim sin cos tan atan sqrt double absf expf logf limitf powf geteasef mousex mousey mousew hwnd hinstance hdc ginfo objinfo dirinfo sysinfo thismod __hspver__ __hsp30__ __date__ __time__ __line__ __file__ _debug __hspdef__ and or xor not screen_normal screen_palette screen_hide screen_fixedsize screen_tool screen_frame gmode_gdi gmode_mem gmode_rgb0 gmode_alpha gmode_rgb0alpha gmode_add gmode_sub gmode_pixela ginfo_mx ginfo_my ginfo_act ginfo_sel ginfo_wx1 ginfo_wy1 ginfo_wx2 ginfo_wy2 ginfo_vx ginfo_vy ginfo_sizex ginfo_sizey ginfo_winx ginfo_winy ginfo_mesx ginfo_mesy ginfo_r ginfo_g ginfo_b ginfo_paluse ginfo_dispx ginfo_dispy ginfo_cx ginfo_cy ginfo_intid ginfo_newid ginfo_sx ginfo_sy objinfo_mode objinfo_bmscr objinfo_hwnd notemax notesize dir_cur dir_exe dir_win dir_sys dir_cmdline dir_desktop dir_mydoc dir_tv font_normal font_bold font_italic font_underline font_strikeout font_antialias objmode_normal objmode_guifont objmode_usefont gsquare_grad msgothic msmincho do until while wend for next _break _continue switch case default swbreak swend ddim ldim alloc m_pi rad2deg deg2rad ease_linear ease_quad_in ease_quad_out ease_quad_inout ease_cubic_in ease_cubic_out ease_cubic_inout ease_quartic_in ease_quartic_out ease_quartic_inout ease_bounce_in ease_bounce_out ease_bounce_inout ease_shake_in ease_shake_out ease_shake_inout ease_loop",
        contains: [
            hljs.C_LINE_COMMENT_MODE,
            hljs.C_BLOCK_COMMENT_MODE,
            hljs.QUOTE_STRING_MODE,
            hljs.APOS_STRING_MODE,
            {
                // multi-line string
                className: "string",
                begin: '{"',
                end: '"}',
                contains: [
                    hljs.BACKSLASH_ESCAPE
                ]
            },
            hljs.COMMENT(";", "$", {
                relevance: 0
            }),
            {
                // pre-processor
                className: "meta",
                begin: "#",
                end: "$",
                keywords: {
                    "meta-keyword": "addion cfunc cmd cmpopt comfunc const defcfunc deffunc define else endif enum epack func global if ifdef ifndef include modcfunc modfunc modinit modterm module pack packopt regcmd runtime undef usecom uselib"
                },
                contains: [
                    hljs.inherit(hljs.QUOTE_STRING_MODE, {
                        className: "meta-string"
                    }),
                    hljs.NUMBER_MODE,
                    hljs.C_NUMBER_MODE,
                    hljs.C_LINE_COMMENT_MODE,
                    hljs.C_BLOCK_COMMENT_MODE
                ]
            },
            {
                // label
                className: "symbol",
                begin: "^\\*(\\w+|@)"
            },
            hljs.NUMBER_MODE,
            hljs.C_NUMBER_MODE
        ]
    };
};

});

parcelRegister("3lp2P", function(module, exports) {
module.exports = function(hljs) {
    var BUILT_INS = "action collection component concat debugger each each-in else get hash if input link-to loc log mut outlet partial query-params render textarea unbound unless with yield view";
    var ATTR_ASSIGNMENT = {
        illegal: /\}\}/,
        begin: /[a-zA-Z0-9_]+=/,
        returnBegin: true,
        relevance: 0,
        contains: [
            {
                className: "attr",
                begin: /[a-zA-Z0-9_]+/
            }
        ]
    };
    var SUB_EXPR = {
        illegal: /\}\}/,
        begin: /\)/,
        end: /\)/,
        contains: [
            {
                begin: /[a-zA-Z\.\-]+/,
                keywords: {
                    built_in: BUILT_INS
                },
                starts: {
                    endsWithParent: true,
                    relevance: 0,
                    contains: [
                        hljs.QUOTE_STRING_MODE
                    ]
                }
            }
        ]
    };
    var TAG_INNARDS = {
        endsWithParent: true,
        relevance: 0,
        keywords: {
            keyword: "as",
            built_in: BUILT_INS
        },
        contains: [
            hljs.QUOTE_STRING_MODE,
            ATTR_ASSIGNMENT,
            hljs.NUMBER_MODE
        ]
    };
    return {
        case_insensitive: true,
        subLanguage: "xml",
        contains: [
            hljs.COMMENT("{{!(--)?", "(--)?}}"),
            {
                className: "template-tag",
                begin: /\{\{[#\/]/,
                end: /\}\}/,
                contains: [
                    {
                        className: "name",
                        begin: /[a-zA-Z\.\-]+/,
                        keywords: {
                            "builtin-name": BUILT_INS
                        },
                        starts: TAG_INNARDS
                    }
                ]
            },
            {
                className: "template-variable",
                begin: /\{\{[a-zA-Z][a-zA-Z\-]+/,
                end: /\}\}/,
                keywords: {
                    keyword: "as",
                    built_in: BUILT_INS
                },
                contains: [
                    hljs.QUOTE_STRING_MODE
                ]
            }
        ]
    };
};

});

parcelRegister("dFhmZ", function(module, exports) {
module.exports = function(hljs) {
    var VERSION = "HTTP/[0-9\\.]+";
    return {
        aliases: [
            "https"
        ],
        illegal: "\\S",
        contains: [
            {
                begin: "^" + VERSION,
                end: "$",
                contains: [
                    {
                        className: "number",
                        begin: "\\b\\d{3}\\b"
                    }
                ]
            },
            {
                begin: "^[A-Z]+ (.*?) " + VERSION + "$",
                returnBegin: true,
                end: "$",
                contains: [
                    {
                        className: "string",
                        begin: " ",
                        end: " ",
                        excludeBegin: true,
                        excludeEnd: true
                    },
                    {
                        begin: VERSION
                    },
                    {
                        className: "keyword",
                        begin: "[A-Z]+"
                    }
                ]
            },
            {
                className: "attribute",
                begin: "^\\w",
                end: ": ",
                excludeEnd: true,
                illegal: "\\n|\\s|=",
                starts: {
                    end: "$",
                    relevance: 0
                }
            },
            {
                begin: "\\n\\n",
                starts: {
                    subLanguage: [],
                    endsWithParent: true
                }
            }
        ]
    };
};

});

parcelRegister("43oHJ", function(module, exports) {
module.exports = function(hljs) {
    var keywords = {
        "builtin-name": // keywords
        "!= % %= & &= * ** **= *= *map + += , --build-class-- --import-- -= . / // //= /= < << <<= <= = > >= >> >>= @ @= ^ ^= abs accumulate all and any ap-compose ap-dotimes ap-each ap-each-while ap-filter ap-first ap-if ap-last ap-map ap-map-when ap-pipe ap-reduce ap-reject apply as-> ascii assert assoc bin break butlast callable calling-module-name car case cdr chain chr coll? combinations compile compress cond cons cons? continue count curry cut cycle dec def default-method defclass defmacro defmacro-alias defmacro/g! defmain defmethod defmulti defn defn-alias defnc defnr defreader defseq del delattr delete-route dict-comp dir disassemble dispatch-reader-macro distinct divmod do doto drop drop-last drop-while empty? end-sequence eval eval-and-compile eval-when-compile even? every? except exec filter first flatten float? fn fnc fnr for for* format fraction genexpr gensym get getattr global globals group-by hasattr hash hex id identity if if* if-not if-python2 import in inc input instance? integer integer-char? integer? interleave interpose is is-coll is-cons is-empty is-even is-every is-float is-instance is-integer is-integer-char is-iterable is-iterator is-keyword is-neg is-none is-not is-numeric is-odd is-pos is-string is-symbol is-zero isinstance islice issubclass iter iterable? iterate iterator? keyword keyword? lambda last len let lif lif-not list* list-comp locals loop macro-error macroexpand macroexpand-1 macroexpand-all map max merge-with method-decorator min multi-decorator multicombinations name neg? next none? nonlocal not not-in not? nth numeric? oct odd? open or ord partition permutations pos? post-route postwalk pow prewalk print product profile/calls profile/cpu put-route quasiquote quote raise range read read-str recursive-replace reduce remove repeat repeatedly repr require rest round route route-with-methods rwm second seq set-comp setattr setv some sorted string string? sum switch symbol? take take-nth take-while tee try unless unquote unquote-splicing vars walk when while with with* with-decorator with-gensyms xi xor yield yield-from zero? zip zip-longest | |= ~"
    };
    var SYMBOLSTART = "a-zA-Z_\\-!.?+*=<>&#'";
    var SYMBOL_RE = "[" + SYMBOLSTART + "][" + SYMBOLSTART + "0-9/;:]*";
    var SIMPLE_NUMBER_RE = "[-+]?\\d+(\\.\\d+)?";
    var SHEBANG = {
        className: "meta",
        begin: "^#!",
        end: "$"
    };
    var SYMBOL = {
        begin: SYMBOL_RE,
        relevance: 0
    };
    var NUMBER = {
        className: "number",
        begin: SIMPLE_NUMBER_RE,
        relevance: 0
    };
    var STRING = hljs.inherit(hljs.QUOTE_STRING_MODE, {
        illegal: null
    });
    var COMMENT = hljs.COMMENT(";", "$", {
        relevance: 0
    });
    var LITERAL = {
        className: "literal",
        begin: /\b([Tt]rue|[Ff]alse|nil|None)\b/
    };
    var COLLECTION = {
        begin: "[\\[\\{]",
        end: "[\\]\\}]"
    };
    var HINT = {
        className: "comment",
        begin: "\\^" + SYMBOL_RE
    };
    var HINT_COL = hljs.COMMENT("\\^\\{", "\\}");
    var KEY = {
        className: "symbol",
        begin: "[:]{1,2}" + SYMBOL_RE
    };
    var LIST = {
        begin: "\\(",
        end: "\\)"
    };
    var BODY = {
        endsWithParent: true,
        relevance: 0
    };
    var NAME = {
        keywords: keywords,
        lexemes: SYMBOL_RE,
        className: "name",
        begin: SYMBOL_RE,
        starts: BODY
    };
    var DEFAULT_CONTAINS = [
        LIST,
        STRING,
        HINT,
        HINT_COL,
        COMMENT,
        KEY,
        COLLECTION,
        NUMBER,
        LITERAL,
        SYMBOL
    ];
    LIST.contains = [
        hljs.COMMENT("comment", ""),
        NAME,
        BODY
    ];
    BODY.contains = DEFAULT_CONTAINS;
    COLLECTION.contains = DEFAULT_CONTAINS;
    return {
        aliases: [
            "hylang"
        ],
        illegal: /\S/,
        contains: [
            SHEBANG,
            LIST,
            STRING,
            HINT,
            HINT_COL,
            COMMENT,
            KEY,
            COLLECTION,
            NUMBER,
            LITERAL
        ]
    };
};

});

parcelRegister("c9gLT", function(module, exports) {
module.exports = function(hljs) {
    var START_BRACKET = "\\[";
    var END_BRACKET = "\\]";
    return {
        aliases: [
            "i7"
        ],
        case_insensitive: true,
        keywords: {
            // Some keywords more or less unique to I7, for relevance.
            keyword: // kind:
            "thing room person man woman animal container supporter backdrop door scenery open closed locked inside gender is are say understand kind of rule"
        },
        contains: [
            {
                className: "string",
                begin: '"',
                end: '"',
                relevance: 0,
                contains: [
                    {
                        className: "subst",
                        begin: START_BRACKET,
                        end: END_BRACKET
                    }
                ]
            },
            {
                className: "section",
                begin: /^(Volume|Book|Part|Chapter|Section|Table)\b/,
                end: "$"
            },
            {
                // Rule definition
                // This is here for relevance.
                begin: /^(Check|Carry out|Report|Instead of|To|Rule|When|Before|After)\b/,
                end: ":",
                contains: [
                    {
                        //Rule name
                        begin: "\\(This",
                        end: "\\)"
                    }
                ]
            },
            {
                className: "comment",
                begin: START_BRACKET,
                end: END_BRACKET,
                contains: [
                    "self"
                ]
            }
        ]
    };
};

});

parcelRegister("3oDqc", function(module, exports) {
module.exports = function(hljs) {
    var NUMBERS = {
        className: "number",
        relevance: 0,
        variants: [
            {
                begin: /([\+\-]+)?[\d]+_[\d_]+/
            },
            {
                begin: hljs.NUMBER_RE
            }
        ]
    };
    var COMMENTS = hljs.COMMENT();
    COMMENTS.variants = [
        {
            begin: /;/,
            end: /$/
        },
        {
            begin: /#/,
            end: /$/
        }
    ];
    var VARIABLES = {
        className: "variable",
        variants: [
            {
                begin: /\$[\w\d"][\w\d_]*/
            },
            {
                begin: /\$\{(.*?)}/
            }
        ]
    };
    var LITERALS = {
        className: "literal",
        begin: /\bon|off|true|false|yes|no\b/
    };
    var STRINGS = {
        className: "string",
        contains: [
            hljs.BACKSLASH_ESCAPE
        ],
        variants: [
            {
                begin: "'''",
                end: "'''",
                relevance: 10
            },
            {
                begin: '"""',
                end: '"""',
                relevance: 10
            },
            {
                begin: '"',
                end: '"'
            },
            {
                begin: "'",
                end: "'"
            }
        ]
    };
    var ARRAY = {
        begin: /\[/,
        end: /\]/,
        contains: [
            COMMENTS,
            LITERALS,
            VARIABLES,
            STRINGS,
            NUMBERS,
            "self"
        ],
        relevance: 0
    };
    return {
        aliases: [
            "toml"
        ],
        case_insensitive: true,
        illegal: /\S/,
        contains: [
            COMMENTS,
            {
                className: "section",
                begin: /\[+/,
                end: /\]+/
            },
            {
                begin: /^[a-z0-9\[\]_\.-]+(?=\s*=\s*)/,
                className: "attr",
                starts: {
                    end: /$/,
                    contains: [
                        COMMENTS,
                        ARRAY,
                        LITERALS,
                        VARIABLES,
                        STRINGS,
                        NUMBERS
                    ]
                }
            }
        ]
    };
};

});

parcelRegister("gM8oT", function(module, exports) {
module.exports = function(hljs) {
    var PARAMS = {
        className: "params",
        begin: "\\(",
        end: "\\)"
    };
    var F_KEYWORDS = {
        literal: ".False. .True.",
        keyword: "kind do while private call intrinsic where elsewhere type endtype endmodule endselect endinterface end enddo endif if forall endforall only contains default return stop then public subroutine|10 function program .and. .or. .not. .le. .eq. .ge. .gt. .lt. goto save else use module select case access blank direct exist file fmt form formatted iostat name named nextrec number opened rec recl sequential status unformatted unit continue format pause cycle exit c_null_char c_alert c_backspace c_form_feed flush wait decimal round iomsg synchronous nopass non_overridable pass protected volatile abstract extends import non_intrinsic value deferred generic final enumerator class associate bind enum c_int c_short c_long c_long_long c_signed_char c_size_t c_int8_t c_int16_t c_int32_t c_int64_t c_int_least8_t c_int_least16_t c_int_least32_t c_int_least64_t c_int_fast8_t c_int_fast16_t c_int_fast32_t c_int_fast64_t c_intmax_t C_intptr_t c_float c_double c_long_double c_float_complex c_double_complex c_long_double_complex c_bool c_char c_null_ptr c_null_funptr c_new_line c_carriage_return c_horizontal_tab c_vertical_tab iso_c_binding c_loc c_funloc c_associated  c_f_pointer c_ptr c_funptr iso_fortran_env character_storage_size error_unit file_storage_size input_unit iostat_end iostat_eor numeric_storage_size output_unit c_f_procpointer ieee_arithmetic ieee_support_underflow_control ieee_get_underflow_mode ieee_set_underflow_mode newunit contiguous recursive pad position action delim readwrite eor advance nml interface procedure namelist include sequence elemental pure integer real character complex logical dimension allocatable|10 parameter external implicit|10 none double precision assign intent optional pointer target in out common equivalence data begin_provider &begin_provider end_provider begin_shell end_shell begin_template end_template subst assert touch soft_touch provide no_dep free irp_if irp_else irp_endif irp_write irp_read",
        built_in: "alog alog10 amax0 amax1 amin0 amin1 amod cabs ccos cexp clog csin csqrt dabs dacos dasin datan datan2 dcos dcosh ddim dexp dint dlog dlog10 dmax1 dmin1 dmod dnint dsign dsin dsinh dsqrt dtan dtanh float iabs idim idint idnint ifix isign max0 max1 min0 min1 sngl algama cdabs cdcos cdexp cdlog cdsin cdsqrt cqabs cqcos cqexp cqlog cqsin cqsqrt dcmplx dconjg derf derfc dfloat dgamma dimag dlgama iqint qabs qacos qasin qatan qatan2 qcmplx qconjg qcos qcosh qdim qerf qerfc qexp qgamma qimag qlgama qlog qlog10 qmax1 qmin1 qmod qnint qsign qsin qsinh qsqrt qtan qtanh abs acos aimag aint anint asin atan atan2 char cmplx conjg cos cosh exp ichar index int log log10 max min nint sign sin sinh sqrt tan tanh print write dim lge lgt lle llt mod nullify allocate deallocate adjustl adjustr all allocated any associated bit_size btest ceiling count cshift date_and_time digits dot_product eoshift epsilon exponent floor fraction huge iand ibclr ibits ibset ieor ior ishft ishftc lbound len_trim matmul maxexponent maxloc maxval merge minexponent minloc minval modulo mvbits nearest pack present product radix random_number random_seed range repeat reshape rrspacing scale scan selected_int_kind selected_real_kind set_exponent shape size spacing spread sum system_clock tiny transpose trim ubound unpack verify achar iachar transfer dble entry dprod cpu_time command_argument_count get_command get_command_argument get_environment_variable is_iostat_end ieee_arithmetic ieee_support_underflow_control ieee_get_underflow_mode ieee_set_underflow_mode is_iostat_eor move_alloc new_line selected_char_kind same_type_as extends_type_ofacosh asinh atanh bessel_j0 bessel_j1 bessel_jn bessel_y0 bessel_y1 bessel_yn erf erfc erfc_scaled gamma log_gamma hypot norm2 atomic_define atomic_ref execute_command_line leadz trailz storage_size merge_bits bge bgt ble blt dshiftl dshiftr findloc iall iany iparity image_index lcobound ucobound maskl maskr num_images parity popcnt poppar shifta shiftl shiftr this_image IRP_ALIGN irp_here"
    };
    return {
        case_insensitive: true,
        keywords: F_KEYWORDS,
        illegal: /\/\*/,
        contains: [
            hljs.inherit(hljs.APOS_STRING_MODE, {
                className: "string",
                relevance: 0
            }),
            hljs.inherit(hljs.QUOTE_STRING_MODE, {
                className: "string",
                relevance: 0
            }),
            {
                className: "function",
                beginKeywords: "subroutine function program",
                illegal: "[${=\\n]",
                contains: [
                    hljs.UNDERSCORE_TITLE_MODE,
                    PARAMS
                ]
            },
            hljs.COMMENT("!", "$", {
                relevance: 0
            }),
            hljs.COMMENT("begin_doc", "end_doc", {
                relevance: 10
            }),
            {
                className: "number",
                begin: "(?=\\b|\\+|\\-|\\.)(?=\\.\\d|\\d)(?:\\d+)?(?:\\.?\\d*)(?:[de][+-]?\\d+)?\\b\\.?",
                relevance: 0
            }
        ]
    };
};

});

parcelRegister("ewc1c", function(module, exports) {
module.exports = function(hljs) {
    // Определение идентификаторов
    var UNDERSCORE_IDENT_RE = "[A-Za-z\u0410-\u042F\u0430-\u044F\u0451\u0401_!][A-Za-z\u0410-\u042F\u0430-\u044F\u0451\u0401_0-9]*";
    // Определение имен функций
    var FUNCTION_NAME_IDENT_RE = "[A-Za-z\u0410-\u042F\u0430-\u044F\u0451\u0401_][A-Za-z\u0410-\u042F\u0430-\u044F\u0451\u0401_0-9]*";
    // keyword : ключевые слова
    var KEYWORD = "and \u0438 else \u0438\u043D\u0430\u0447\u0435 endexcept endfinally endforeach \u043A\u043E\u043D\u0435\u0446\u0432\u0441\u0435 endif \u043A\u043E\u043D\u0435\u0446\u0435\u0441\u043B\u0438 endwhile \u043A\u043E\u043D\u0435\u0446\u043F\u043E\u043A\u0430 except exitfor finally foreach \u0432\u0441\u0435 if \u0435\u0441\u043B\u0438 in \u0432 not \u043D\u0435 or \u0438\u043B\u0438 try while \u043F\u043E\u043A\u0430 ";
    // SYSRES Constants
    var sysres_constants = "SYSRES_CONST_ACCES_RIGHT_TYPE_EDIT SYSRES_CONST_ACCES_RIGHT_TYPE_FULL SYSRES_CONST_ACCES_RIGHT_TYPE_VIEW SYSRES_CONST_ACCESS_MODE_REQUISITE_CODE SYSRES_CONST_ACCESS_NO_ACCESS_VIEW SYSRES_CONST_ACCESS_NO_ACCESS_VIEW_CODE SYSRES_CONST_ACCESS_RIGHTS_ADD_REQUISITE_CODE SYSRES_CONST_ACCESS_RIGHTS_ADD_REQUISITE_YES_CODE SYSRES_CONST_ACCESS_RIGHTS_CHANGE_REQUISITE_CODE SYSRES_CONST_ACCESS_RIGHTS_CHANGE_REQUISITE_YES_CODE SYSRES_CONST_ACCESS_RIGHTS_DELETE_REQUISITE_CODE SYSRES_CONST_ACCESS_RIGHTS_DELETE_REQUISITE_YES_CODE SYSRES_CONST_ACCESS_RIGHTS_EXECUTE_REQUISITE_CODE SYSRES_CONST_ACCESS_RIGHTS_EXECUTE_REQUISITE_YES_CODE SYSRES_CONST_ACCESS_RIGHTS_NO_ACCESS_REQUISITE_CODE SYSRES_CONST_ACCESS_RIGHTS_NO_ACCESS_REQUISITE_YES_CODE SYSRES_CONST_ACCESS_RIGHTS_RATIFY_REQUISITE_CODE SYSRES_CONST_ACCESS_RIGHTS_RATIFY_REQUISITE_YES_CODE SYSRES_CONST_ACCESS_RIGHTS_REQUISITE_CODE SYSRES_CONST_ACCESS_RIGHTS_VIEW SYSRES_CONST_ACCESS_RIGHTS_VIEW_CODE SYSRES_CONST_ACCESS_RIGHTS_VIEW_REQUISITE_CODE SYSRES_CONST_ACCESS_RIGHTS_VIEW_REQUISITE_YES_CODE SYSRES_CONST_ACCESS_TYPE_CHANGE SYSRES_CONST_ACCESS_TYPE_CHANGE_CODE SYSRES_CONST_ACCESS_TYPE_EXISTS SYSRES_CONST_ACCESS_TYPE_EXISTS_CODE SYSRES_CONST_ACCESS_TYPE_FULL SYSRES_CONST_ACCESS_TYPE_FULL_CODE SYSRES_CONST_ACCESS_TYPE_VIEW SYSRES_CONST_ACCESS_TYPE_VIEW_CODE SYSRES_CONST_ACTION_TYPE_ABORT SYSRES_CONST_ACTION_TYPE_ACCEPT SYSRES_CONST_ACTION_TYPE_ACCESS_RIGHTS SYSRES_CONST_ACTION_TYPE_ADD_ATTACHMENT SYSRES_CONST_ACTION_TYPE_CHANGE_CARD SYSRES_CONST_ACTION_TYPE_CHANGE_KIND SYSRES_CONST_ACTION_TYPE_CHANGE_STORAGE SYSRES_CONST_ACTION_TYPE_CONTINUE SYSRES_CONST_ACTION_TYPE_COPY SYSRES_CONST_ACTION_TYPE_CREATE SYSRES_CONST_ACTION_TYPE_CREATE_VERSION SYSRES_CONST_ACTION_TYPE_DELETE SYSRES_CONST_ACTION_TYPE_DELETE_ATTACHMENT SYSRES_CONST_ACTION_TYPE_DELETE_VERSION SYSRES_CONST_ACTION_TYPE_DISABLE_DELEGATE_ACCESS_RIGHTS SYSRES_CONST_ACTION_TYPE_ENABLE_DELEGATE_ACCESS_RIGHTS SYSRES_CONST_ACTION_TYPE_ENCRYPTION_BY_CERTIFICATE SYSRES_CONST_ACTION_TYPE_ENCRYPTION_BY_CERTIFICATE_AND_PASSWORD SYSRES_CONST_ACTION_TYPE_ENCRYPTION_BY_PASSWORD SYSRES_CONST_ACTION_TYPE_EXPORT_WITH_LOCK SYSRES_CONST_ACTION_TYPE_EXPORT_WITHOUT_LOCK SYSRES_CONST_ACTION_TYPE_IMPORT_WITH_UNLOCK SYSRES_CONST_ACTION_TYPE_IMPORT_WITHOUT_UNLOCK SYSRES_CONST_ACTION_TYPE_LIFE_CYCLE_STAGE SYSRES_CONST_ACTION_TYPE_LOCK SYSRES_CONST_ACTION_TYPE_LOCK_FOR_SERVER SYSRES_CONST_ACTION_TYPE_LOCK_MODIFY SYSRES_CONST_ACTION_TYPE_MARK_AS_READED SYSRES_CONST_ACTION_TYPE_MARK_AS_UNREADED SYSRES_CONST_ACTION_TYPE_MODIFY SYSRES_CONST_ACTION_TYPE_MODIFY_CARD SYSRES_CONST_ACTION_TYPE_MOVE_TO_ARCHIVE SYSRES_CONST_ACTION_TYPE_OFF_ENCRYPTION SYSRES_CONST_ACTION_TYPE_PASSWORD_CHANGE SYSRES_CONST_ACTION_TYPE_PERFORM SYSRES_CONST_ACTION_TYPE_RECOVER_FROM_LOCAL_COPY SYSRES_CONST_ACTION_TYPE_RESTART SYSRES_CONST_ACTION_TYPE_RESTORE_FROM_ARCHIVE SYSRES_CONST_ACTION_TYPE_REVISION SYSRES_CONST_ACTION_TYPE_SEND_BY_MAIL SYSRES_CONST_ACTION_TYPE_SIGN SYSRES_CONST_ACTION_TYPE_START SYSRES_CONST_ACTION_TYPE_UNLOCK SYSRES_CONST_ACTION_TYPE_UNLOCK_FROM_SERVER SYSRES_CONST_ACTION_TYPE_VERSION_STATE SYSRES_CONST_ACTION_TYPE_VERSION_VISIBILITY SYSRES_CONST_ACTION_TYPE_VIEW SYSRES_CONST_ACTION_TYPE_VIEW_SHADOW_COPY SYSRES_CONST_ACTION_TYPE_WORKFLOW_DESCRIPTION_MODIFY SYSRES_CONST_ACTION_TYPE_WRITE_HISTORY SYSRES_CONST_ACTIVE_VERSION_STATE_PICK_VALUE SYSRES_CONST_ADD_REFERENCE_MODE_NAME SYSRES_CONST_ADDITION_REQUISITE_CODE SYSRES_CONST_ADDITIONAL_PARAMS_REQUISITE_CODE SYSRES_CONST_ADITIONAL_JOB_END_DATE_REQUISITE_NAME SYSRES_CONST_ADITIONAL_JOB_READ_REQUISITE_NAME SYSRES_CONST_ADITIONAL_JOB_START_DATE_REQUISITE_NAME SYSRES_CONST_ADITIONAL_JOB_STATE_REQUISITE_NAME SYSRES_CONST_ADMINISTRATION_HISTORY_ADDING_USER_TO_GROUP_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_ADDING_USER_TO_GROUP_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_CREATION_COMP_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_CREATION_COMP_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_CREATION_GROUP_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_CREATION_GROUP_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_CREATION_USER_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_CREATION_USER_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_DATABASE_USER_CREATION SYSRES_CONST_ADMINISTRATION_HISTORY_DATABASE_USER_CREATION_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_DATABASE_USER_DELETION SYSRES_CONST_ADMINISTRATION_HISTORY_DATABASE_USER_DELETION_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_DELETION_COMP_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_DELETION_COMP_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_DELETION_GROUP_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_DELETION_GROUP_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_DELETION_USER_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_DELETION_USER_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_DELETION_USER_FROM_GROUP_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_DELETION_USER_FROM_GROUP_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_GRANTING_FILTERER_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_GRANTING_FILTERER_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_GRANTING_FILTERER_RESTRICTION_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_GRANTING_FILTERER_RESTRICTION_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_GRANTING_PRIVILEGE_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_GRANTING_PRIVILEGE_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_GRANTING_RIGHTS_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_GRANTING_RIGHTS_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_IS_MAIN_SERVER_CHANGED_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_IS_MAIN_SERVER_CHANGED_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_IS_PUBLIC_CHANGED_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_IS_PUBLIC_CHANGED_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_REMOVING_FILTERER_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_REMOVING_FILTERER_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_REMOVING_FILTERER_RESTRICTION_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_REMOVING_FILTERER_RESTRICTION_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_REMOVING_PRIVILEGE_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_REMOVING_PRIVILEGE_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_REMOVING_RIGHTS_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_REMOVING_RIGHTS_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_SERVER_LOGIN_CREATION SYSRES_CONST_ADMINISTRATION_HISTORY_SERVER_LOGIN_CREATION_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_SERVER_LOGIN_DELETION SYSRES_CONST_ADMINISTRATION_HISTORY_SERVER_LOGIN_DELETION_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_UPDATING_CATEGORY_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_UPDATING_CATEGORY_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_UPDATING_COMP_TITLE_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_UPDATING_COMP_TITLE_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_UPDATING_FULL_NAME_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_UPDATING_FULL_NAME_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_UPDATING_GROUP_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_UPDATING_GROUP_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_UPDATING_PARENT_GROUP_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_UPDATING_PARENT_GROUP_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_UPDATING_USER_AUTH_TYPE_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_UPDATING_USER_AUTH_TYPE_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_UPDATING_USER_LOGIN_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_UPDATING_USER_LOGIN_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_UPDATING_USER_STATUS_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_UPDATING_USER_STATUS_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_USER_PASSWORD_CHANGE SYSRES_CONST_ADMINISTRATION_HISTORY_USER_PASSWORD_CHANGE_ACTION SYSRES_CONST_ALL_ACCEPT_CONDITION_RUS SYSRES_CONST_ALL_USERS_GROUP SYSRES_CONST_ALL_USERS_GROUP_NAME SYSRES_CONST_ALL_USERS_SERVER_GROUP_NAME SYSRES_CONST_ALLOWED_ACCESS_TYPE_CODE SYSRES_CONST_ALLOWED_ACCESS_TYPE_NAME SYSRES_CONST_APP_VIEWER_TYPE_REQUISITE_CODE SYSRES_CONST_APPROVING_SIGNATURE_NAME SYSRES_CONST_APPROVING_SIGNATURE_REQUISITE_CODE SYSRES_CONST_ASSISTANT_SUBSTITUE_TYPE SYSRES_CONST_ASSISTANT_SUBSTITUE_TYPE_CODE SYSRES_CONST_ATTACH_TYPE_COMPONENT_TOKEN SYSRES_CONST_ATTACH_TYPE_DOC SYSRES_CONST_ATTACH_TYPE_EDOC SYSRES_CONST_ATTACH_TYPE_FOLDER SYSRES_CONST_ATTACH_TYPE_JOB SYSRES_CONST_ATTACH_TYPE_REFERENCE SYSRES_CONST_ATTACH_TYPE_TASK SYSRES_CONST_AUTH_ENCODED_PASSWORD SYSRES_CONST_AUTH_ENCODED_PASSWORD_CODE SYSRES_CONST_AUTH_NOVELL SYSRES_CONST_AUTH_PASSWORD SYSRES_CONST_AUTH_PASSWORD_CODE SYSRES_CONST_AUTH_WINDOWS SYSRES_CONST_AUTHENTICATING_SIGNATURE_NAME SYSRES_CONST_AUTHENTICATING_SIGNATURE_REQUISITE_CODE SYSRES_CONST_AUTO_ENUM_METHOD_FLAG SYSRES_CONST_AUTO_NUMERATION_CODE SYSRES_CONST_AUTO_STRONG_ENUM_METHOD_FLAG SYSRES_CONST_AUTOTEXT_NAME_REQUISITE_CODE SYSRES_CONST_AUTOTEXT_TEXT_REQUISITE_CODE SYSRES_CONST_AUTOTEXT_USAGE_ALL SYSRES_CONST_AUTOTEXT_USAGE_ALL_CODE SYSRES_CONST_AUTOTEXT_USAGE_SIGN SYSRES_CONST_AUTOTEXT_USAGE_SIGN_CODE SYSRES_CONST_AUTOTEXT_USAGE_WORK SYSRES_CONST_AUTOTEXT_USAGE_WORK_CODE SYSRES_CONST_AUTOTEXT_USE_ANYWHERE_CODE SYSRES_CONST_AUTOTEXT_USE_ON_SIGNING_CODE SYSRES_CONST_AUTOTEXT_USE_ON_WORK_CODE SYSRES_CONST_BEGIN_DATE_REQUISITE_CODE SYSRES_CONST_BLACK_LIFE_CYCLE_STAGE_FONT_COLOR SYSRES_CONST_BLUE_LIFE_CYCLE_STAGE_FONT_COLOR SYSRES_CONST_BTN_PART SYSRES_CONST_CALCULATED_ROLE_TYPE_CODE SYSRES_CONST_CALL_TYPE_VARIABLE_BUTTON_VALUE SYSRES_CONST_CALL_TYPE_VARIABLE_PROGRAM_VALUE SYSRES_CONST_CANCEL_MESSAGE_FUNCTION_RESULT SYSRES_CONST_CARD_PART SYSRES_CONST_CARD_REFERENCE_MODE_NAME SYSRES_CONST_CERTIFICATE_TYPE_REQUISITE_ENCRYPT_VALUE SYSRES_CONST_CERTIFICATE_TYPE_REQUISITE_SIGN_AND_ENCRYPT_VALUE SYSRES_CONST_CERTIFICATE_TYPE_REQUISITE_SIGN_VALUE SYSRES_CONST_CHECK_PARAM_VALUE_DATE_PARAM_TYPE SYSRES_CONST_CHECK_PARAM_VALUE_FLOAT_PARAM_TYPE SYSRES_CONST_CHECK_PARAM_VALUE_INTEGER_PARAM_TYPE SYSRES_CONST_CHECK_PARAM_VALUE_PICK_PARAM_TYPE SYSRES_CONST_CHECK_PARAM_VALUE_REEFRENCE_PARAM_TYPE SYSRES_CONST_CLOSED_RECORD_FLAG_VALUE_FEMININE SYSRES_CONST_CLOSED_RECORD_FLAG_VALUE_MASCULINE SYSRES_CONST_CODE_COMPONENT_TYPE_ADMIN SYSRES_CONST_CODE_COMPONENT_TYPE_DEVELOPER SYSRES_CONST_CODE_COMPONENT_TYPE_DOCS SYSRES_CONST_CODE_COMPONENT_TYPE_EDOC_CARDS SYSRES_CONST_CODE_COMPONENT_TYPE_EXTERNAL_EXECUTABLE SYSRES_CONST_CODE_COMPONENT_TYPE_OTHER SYSRES_CONST_CODE_COMPONENT_TYPE_REFERENCE SYSRES_CONST_CODE_COMPONENT_TYPE_REPORT SYSRES_CONST_CODE_COMPONENT_TYPE_SCRIPT SYSRES_CONST_CODE_COMPONENT_TYPE_URL SYSRES_CONST_CODE_REQUISITE_ACCESS SYSRES_CONST_CODE_REQUISITE_CODE SYSRES_CONST_CODE_REQUISITE_COMPONENT SYSRES_CONST_CODE_REQUISITE_DESCRIPTION SYSRES_CONST_CODE_REQUISITE_EXCLUDE_COMPONENT SYSRES_CONST_CODE_REQUISITE_RECORD SYSRES_CONST_COMMENT_REQ_CODE SYSRES_CONST_COMMON_SETTINGS_REQUISITE_CODE SYSRES_CONST_COMP_CODE_GRD SYSRES_CONST_COMPONENT_GROUP_TYPE_REQUISITE_CODE SYSRES_CONST_COMPONENT_TYPE_ADMIN_COMPONENTS SYSRES_CONST_COMPONENT_TYPE_DEVELOPER_COMPONENTS SYSRES_CONST_COMPONENT_TYPE_DOCS SYSRES_CONST_COMPONENT_TYPE_EDOC_CARDS SYSRES_CONST_COMPONENT_TYPE_EDOCS SYSRES_CONST_COMPONENT_TYPE_EXTERNAL_EXECUTABLE SYSRES_CONST_COMPONENT_TYPE_OTHER SYSRES_CONST_COMPONENT_TYPE_REFERENCE_TYPES SYSRES_CONST_COMPONENT_TYPE_REFERENCES SYSRES_CONST_COMPONENT_TYPE_REPORTS SYSRES_CONST_COMPONENT_TYPE_SCRIPTS SYSRES_CONST_COMPONENT_TYPE_URL SYSRES_CONST_COMPONENTS_REMOTE_SERVERS_VIEW_CODE SYSRES_CONST_CONDITION_BLOCK_DESCRIPTION SYSRES_CONST_CONST_FIRM_STATUS_COMMON SYSRES_CONST_CONST_FIRM_STATUS_INDIVIDUAL SYSRES_CONST_CONST_NEGATIVE_VALUE SYSRES_CONST_CONST_POSITIVE_VALUE SYSRES_CONST_CONST_SERVER_STATUS_DONT_REPLICATE SYSRES_CONST_CONST_SERVER_STATUS_REPLICATE SYSRES_CONST_CONTENTS_REQUISITE_CODE SYSRES_CONST_DATA_TYPE_BOOLEAN SYSRES_CONST_DATA_TYPE_DATE SYSRES_CONST_DATA_TYPE_FLOAT SYSRES_CONST_DATA_TYPE_INTEGER SYSRES_CONST_DATA_TYPE_PICK SYSRES_CONST_DATA_TYPE_REFERENCE SYSRES_CONST_DATA_TYPE_STRING SYSRES_CONST_DATA_TYPE_TEXT SYSRES_CONST_DATA_TYPE_VARIANT SYSRES_CONST_DATE_CLOSE_REQ_CODE SYSRES_CONST_DATE_FORMAT_DATE_ONLY_CHAR SYSRES_CONST_DATE_OPEN_REQ_CODE SYSRES_CONST_DATE_REQUISITE SYSRES_CONST_DATE_REQUISITE_CODE SYSRES_CONST_DATE_REQUISITE_NAME SYSRES_CONST_DATE_REQUISITE_TYPE SYSRES_CONST_DATE_TYPE_CHAR SYSRES_CONST_DATETIME_FORMAT_VALUE SYSRES_CONST_DEA_ACCESS_RIGHTS_ACTION_CODE SYSRES_CONST_DESCRIPTION_LOCALIZE_ID_REQUISITE_CODE SYSRES_CONST_DESCRIPTION_REQUISITE_CODE SYSRES_CONST_DET1_PART SYSRES_CONST_DET2_PART SYSRES_CONST_DET3_PART SYSRES_CONST_DET4_PART SYSRES_CONST_DET5_PART SYSRES_CONST_DET6_PART SYSRES_CONST_DETAIL_DATASET_KEY_REQUISITE_CODE SYSRES_CONST_DETAIL_PICK_REQUISITE_CODE SYSRES_CONST_DETAIL_REQ_CODE SYSRES_CONST_DO_NOT_USE_ACCESS_TYPE_CODE SYSRES_CONST_DO_NOT_USE_ACCESS_TYPE_NAME SYSRES_CONST_DO_NOT_USE_ON_VIEW_ACCESS_TYPE_CODE SYSRES_CONST_DO_NOT_USE_ON_VIEW_ACCESS_TYPE_NAME SYSRES_CONST_DOCUMENT_STORAGES_CODE SYSRES_CONST_DOCUMENT_TEMPLATES_TYPE_NAME SYSRES_CONST_DOUBLE_REQUISITE_CODE SYSRES_CONST_EDITOR_CLOSE_FILE_OBSERV_TYPE_CODE SYSRES_CONST_EDITOR_CLOSE_PROCESS_OBSERV_TYPE_CODE SYSRES_CONST_EDITOR_TYPE_REQUISITE_CODE SYSRES_CONST_EDITORS_APPLICATION_NAME_REQUISITE_CODE SYSRES_CONST_EDITORS_CREATE_SEVERAL_PROCESSES_REQUISITE_CODE SYSRES_CONST_EDITORS_EXTENSION_REQUISITE_CODE SYSRES_CONST_EDITORS_OBSERVER_BY_PROCESS_TYPE SYSRES_CONST_EDITORS_REFERENCE_CODE SYSRES_CONST_EDITORS_REPLACE_SPEC_CHARS_REQUISITE_CODE SYSRES_CONST_EDITORS_USE_PLUGINS_REQUISITE_CODE SYSRES_CONST_EDITORS_VIEW_DOCUMENT_OPENED_TO_EDIT_CODE SYSRES_CONST_EDOC_CARD_TYPE_REQUISITE_CODE SYSRES_CONST_EDOC_CARD_TYPES_LINK_REQUISITE_CODE SYSRES_CONST_EDOC_CERTIFICATE_AND_PASSWORD_ENCODE_CODE SYSRES_CONST_EDOC_CERTIFICATE_ENCODE_CODE SYSRES_CONST_EDOC_DATE_REQUISITE_CODE SYSRES_CONST_EDOC_KIND_REFERENCE_CODE SYSRES_CONST_EDOC_KINDS_BY_TEMPLATE_ACTION_CODE SYSRES_CONST_EDOC_MANAGE_ACCESS_CODE SYSRES_CONST_EDOC_NONE_ENCODE_CODE SYSRES_CONST_EDOC_NUMBER_REQUISITE_CODE SYSRES_CONST_EDOC_PASSWORD_ENCODE_CODE SYSRES_CONST_EDOC_READONLY_ACCESS_CODE SYSRES_CONST_EDOC_SHELL_LIFE_TYPE_VIEW_VALUE SYSRES_CONST_EDOC_SIZE_RESTRICTION_PRIORITY_REQUISITE_CODE SYSRES_CONST_EDOC_STORAGE_CHECK_ACCESS_RIGHTS_REQUISITE_CODE SYSRES_CONST_EDOC_STORAGE_COMPUTER_NAME_REQUISITE_CODE SYSRES_CONST_EDOC_STORAGE_DATABASE_NAME_REQUISITE_CODE SYSRES_CONST_EDOC_STORAGE_EDIT_IN_STORAGE_REQUISITE_CODE SYSRES_CONST_EDOC_STORAGE_LOCAL_PATH_REQUISITE_CODE SYSRES_CONST_EDOC_STORAGE_SHARED_SOURCE_NAME_REQUISITE_CODE SYSRES_CONST_EDOC_TEMPLATE_REQUISITE_CODE SYSRES_CONST_EDOC_TYPES_REFERENCE_CODE SYSRES_CONST_EDOC_VERSION_ACTIVE_STAGE_CODE SYSRES_CONST_EDOC_VERSION_DESIGN_STAGE_CODE SYSRES_CONST_EDOC_VERSION_OBSOLETE_STAGE_CODE SYSRES_CONST_EDOC_WRITE_ACCES_CODE SYSRES_CONST_EDOCUMENT_CARD_REQUISITES_REFERENCE_CODE_SELECTED_REQUISITE SYSRES_CONST_ENCODE_CERTIFICATE_TYPE_CODE SYSRES_CONST_END_DATE_REQUISITE_CODE SYSRES_CONST_ENUMERATION_TYPE_REQUISITE_CODE SYSRES_CONST_EXECUTE_ACCESS_RIGHTS_TYPE_CODE SYSRES_CONST_EXECUTIVE_FILE_STORAGE_TYPE SYSRES_CONST_EXIST_CONST SYSRES_CONST_EXIST_VALUE SYSRES_CONST_EXPORT_LOCK_TYPE_ASK SYSRES_CONST_EXPORT_LOCK_TYPE_WITH_LOCK SYSRES_CONST_EXPORT_LOCK_TYPE_WITHOUT_LOCK SYSRES_CONST_EXPORT_VERSION_TYPE_ASK SYSRES_CONST_EXPORT_VERSION_TYPE_LAST SYSRES_CONST_EXPORT_VERSION_TYPE_LAST_ACTIVE SYSRES_CONST_EXTENSION_REQUISITE_CODE SYSRES_CONST_FILTER_NAME_REQUISITE_CODE SYSRES_CONST_FILTER_REQUISITE_CODE SYSRES_CONST_FILTER_TYPE_COMMON_CODE SYSRES_CONST_FILTER_TYPE_COMMON_NAME SYSRES_CONST_FILTER_TYPE_USER_CODE SYSRES_CONST_FILTER_TYPE_USER_NAME SYSRES_CONST_FILTER_VALUE_REQUISITE_NAME SYSRES_CONST_FLOAT_NUMBER_FORMAT_CHAR SYSRES_CONST_FLOAT_REQUISITE_TYPE SYSRES_CONST_FOLDER_AUTHOR_VALUE SYSRES_CONST_FOLDER_KIND_ANY_OBJECTS SYSRES_CONST_FOLDER_KIND_COMPONENTS SYSRES_CONST_FOLDER_KIND_EDOCS SYSRES_CONST_FOLDER_KIND_JOBS SYSRES_CONST_FOLDER_KIND_TASKS SYSRES_CONST_FOLDER_TYPE_COMMON SYSRES_CONST_FOLDER_TYPE_COMPONENT SYSRES_CONST_FOLDER_TYPE_FAVORITES SYSRES_CONST_FOLDER_TYPE_INBOX SYSRES_CONST_FOLDER_TYPE_OUTBOX SYSRES_CONST_FOLDER_TYPE_QUICK_LAUNCH SYSRES_CONST_FOLDER_TYPE_SEARCH SYSRES_CONST_FOLDER_TYPE_SHORTCUTS SYSRES_CONST_FOLDER_TYPE_USER SYSRES_CONST_FROM_DICTIONARY_ENUM_METHOD_FLAG SYSRES_CONST_FULL_SUBSTITUTE_TYPE SYSRES_CONST_FULL_SUBSTITUTE_TYPE_CODE SYSRES_CONST_FUNCTION_CANCEL_RESULT SYSRES_CONST_FUNCTION_CATEGORY_SYSTEM SYSRES_CONST_FUNCTION_CATEGORY_USER SYSRES_CONST_FUNCTION_FAILURE_RESULT SYSRES_CONST_FUNCTION_SAVE_RESULT SYSRES_CONST_GENERATED_REQUISITE SYSRES_CONST_GREEN_LIFE_CYCLE_STAGE_FONT_COLOR SYSRES_CONST_GROUP_ACCOUNT_TYPE_VALUE_CODE SYSRES_CONST_GROUP_CATEGORY_NORMAL_CODE SYSRES_CONST_GROUP_CATEGORY_NORMAL_NAME SYSRES_CONST_GROUP_CATEGORY_SERVICE_CODE SYSRES_CONST_GROUP_CATEGORY_SERVICE_NAME SYSRES_CONST_GROUP_COMMON_CATEGORY_FIELD_VALUE SYSRES_CONST_GROUP_FULL_NAME_REQUISITE_CODE SYSRES_CONST_GROUP_NAME_REQUISITE_CODE SYSRES_CONST_GROUP_RIGHTS_T_REQUISITE_CODE SYSRES_CONST_GROUP_SERVER_CODES_REQUISITE_CODE SYSRES_CONST_GROUP_SERVER_NAME_REQUISITE_CODE SYSRES_CONST_GROUP_SERVICE_CATEGORY_FIELD_VALUE SYSRES_CONST_GROUP_USER_REQUISITE_CODE SYSRES_CONST_GROUPS_REFERENCE_CODE SYSRES_CONST_GROUPS_REQUISITE_CODE SYSRES_CONST_HIDDEN_MODE_NAME SYSRES_CONST_HIGH_LVL_REQUISITE_CODE SYSRES_CONST_HISTORY_ACTION_CREATE_CODE SYSRES_CONST_HISTORY_ACTION_DELETE_CODE SYSRES_CONST_HISTORY_ACTION_EDIT_CODE SYSRES_CONST_HOUR_CHAR SYSRES_CONST_ID_REQUISITE_CODE SYSRES_CONST_IDSPS_REQUISITE_CODE SYSRES_CONST_IMAGE_MODE_COLOR SYSRES_CONST_IMAGE_MODE_GREYSCALE SYSRES_CONST_IMAGE_MODE_MONOCHROME SYSRES_CONST_IMPORTANCE_HIGH SYSRES_CONST_IMPORTANCE_LOW SYSRES_CONST_IMPORTANCE_NORMAL SYSRES_CONST_IN_DESIGN_VERSION_STATE_PICK_VALUE SYSRES_CONST_INCOMING_WORK_RULE_TYPE_CODE SYSRES_CONST_INT_REQUISITE SYSRES_CONST_INT_REQUISITE_TYPE SYSRES_CONST_INTEGER_NUMBER_FORMAT_CHAR SYSRES_CONST_INTEGER_TYPE_CHAR SYSRES_CONST_IS_GENERATED_REQUISITE_NEGATIVE_VALUE SYSRES_CONST_IS_PUBLIC_ROLE_REQUISITE_CODE SYSRES_CONST_IS_REMOTE_USER_NEGATIVE_VALUE SYSRES_CONST_IS_REMOTE_USER_POSITIVE_VALUE SYSRES_CONST_IS_STORED_REQUISITE_NEGATIVE_VALUE SYSRES_CONST_IS_STORED_REQUISITE_STORED_VALUE SYSRES_CONST_ITALIC_LIFE_CYCLE_STAGE_DRAW_STYLE SYSRES_CONST_JOB_BLOCK_DESCRIPTION SYSRES_CONST_JOB_KIND_CONTROL_JOB SYSRES_CONST_JOB_KIND_JOB SYSRES_CONST_JOB_KIND_NOTICE SYSRES_CONST_JOB_STATE_ABORTED SYSRES_CONST_JOB_STATE_COMPLETE SYSRES_CONST_JOB_STATE_WORKING SYSRES_CONST_KIND_REQUISITE_CODE SYSRES_CONST_KIND_REQUISITE_NAME SYSRES_CONST_KINDS_CREATE_SHADOW_COPIES_REQUISITE_CODE SYSRES_CONST_KINDS_DEFAULT_EDOC_LIFE_STAGE_REQUISITE_CODE SYSRES_CONST_KINDS_EDOC_ALL_TEPLATES_ALLOWED_REQUISITE_CODE SYSRES_CONST_KINDS_EDOC_ALLOW_LIFE_CYCLE_STAGE_CHANGING_REQUISITE_CODE SYSRES_CONST_KINDS_EDOC_ALLOW_MULTIPLE_ACTIVE_VERSIONS_REQUISITE_CODE SYSRES_CONST_KINDS_EDOC_SHARE_ACCES_RIGHTS_BY_DEFAULT_CODE SYSRES_CONST_KINDS_EDOC_TEMPLATE_REQUISITE_CODE SYSRES_CONST_KINDS_EDOC_TYPE_REQUISITE_CODE SYSRES_CONST_KINDS_SIGNERS_REQUISITES_CODE SYSRES_CONST_KOD_INPUT_TYPE SYSRES_CONST_LAST_UPDATE_DATE_REQUISITE_CODE SYSRES_CONST_LIFE_CYCLE_START_STAGE_REQUISITE_CODE SYSRES_CONST_LILAC_LIFE_CYCLE_STAGE_FONT_COLOR SYSRES_CONST_LINK_OBJECT_KIND_COMPONENT SYSRES_CONST_LINK_OBJECT_KIND_DOCUMENT SYSRES_CONST_LINK_OBJECT_KIND_EDOC SYSRES_CONST_LINK_OBJECT_KIND_FOLDER SYSRES_CONST_LINK_OBJECT_KIND_JOB SYSRES_CONST_LINK_OBJECT_KIND_REFERENCE SYSRES_CONST_LINK_OBJECT_KIND_TASK SYSRES_CONST_LINK_REF_TYPE_REQUISITE_CODE SYSRES_CONST_LIST_REFERENCE_MODE_NAME SYSRES_CONST_LOCALIZATION_DICTIONARY_MAIN_VIEW_CODE SYSRES_CONST_MAIN_VIEW_CODE SYSRES_CONST_MANUAL_ENUM_METHOD_FLAG SYSRES_CONST_MASTER_COMP_TYPE_REQUISITE_CODE SYSRES_CONST_MASTER_TABLE_REC_ID_REQUISITE_CODE SYSRES_CONST_MAXIMIZED_MODE_NAME SYSRES_CONST_ME_VALUE SYSRES_CONST_MESSAGE_ATTENTION_CAPTION SYSRES_CONST_MESSAGE_CONFIRMATION_CAPTION SYSRES_CONST_MESSAGE_ERROR_CAPTION SYSRES_CONST_MESSAGE_INFORMATION_CAPTION SYSRES_CONST_MINIMIZED_MODE_NAME SYSRES_CONST_MINUTE_CHAR SYSRES_CONST_MODULE_REQUISITE_CODE SYSRES_CONST_MONITORING_BLOCK_DESCRIPTION SYSRES_CONST_MONTH_FORMAT_VALUE SYSRES_CONST_NAME_LOCALIZE_ID_REQUISITE_CODE SYSRES_CONST_NAME_REQUISITE_CODE SYSRES_CONST_NAME_SINGULAR_REQUISITE_CODE SYSRES_CONST_NAMEAN_INPUT_TYPE SYSRES_CONST_NEGATIVE_PICK_VALUE SYSRES_CONST_NEGATIVE_VALUE SYSRES_CONST_NO SYSRES_CONST_NO_PICK_VALUE SYSRES_CONST_NO_SIGNATURE_REQUISITE_CODE SYSRES_CONST_NO_VALUE SYSRES_CONST_NONE_ACCESS_RIGHTS_TYPE_CODE SYSRES_CONST_NONOPERATING_RECORD_FLAG_VALUE SYSRES_CONST_NONOPERATING_RECORD_FLAG_VALUE_MASCULINE SYSRES_CONST_NORMAL_ACCESS_RIGHTS_TYPE_CODE SYSRES_CONST_NORMAL_LIFE_CYCLE_STAGE_DRAW_STYLE SYSRES_CONST_NORMAL_MODE_NAME SYSRES_CONST_NOT_ALLOWED_ACCESS_TYPE_CODE SYSRES_CONST_NOT_ALLOWED_ACCESS_TYPE_NAME SYSRES_CONST_NOTE_REQUISITE_CODE SYSRES_CONST_NOTICE_BLOCK_DESCRIPTION SYSRES_CONST_NUM_REQUISITE SYSRES_CONST_NUM_STR_REQUISITE_CODE SYSRES_CONST_NUMERATION_AUTO_NOT_STRONG SYSRES_CONST_NUMERATION_AUTO_STRONG SYSRES_CONST_NUMERATION_FROM_DICTONARY SYSRES_CONST_NUMERATION_MANUAL SYSRES_CONST_NUMERIC_TYPE_CHAR SYSRES_CONST_NUMREQ_REQUISITE_CODE SYSRES_CONST_OBSOLETE_VERSION_STATE_PICK_VALUE SYSRES_CONST_OPERATING_RECORD_FLAG_VALUE SYSRES_CONST_OPERATING_RECORD_FLAG_VALUE_CODE SYSRES_CONST_OPERATING_RECORD_FLAG_VALUE_FEMININE SYSRES_CONST_OPERATING_RECORD_FLAG_VALUE_MASCULINE SYSRES_CONST_OPTIONAL_FORM_COMP_REQCODE_PREFIX SYSRES_CONST_ORANGE_LIFE_CYCLE_STAGE_FONT_COLOR SYSRES_CONST_ORIGINALREF_REQUISITE_CODE SYSRES_CONST_OURFIRM_REF_CODE SYSRES_CONST_OURFIRM_REQUISITE_CODE SYSRES_CONST_OURFIRM_VAR SYSRES_CONST_OUTGOING_WORK_RULE_TYPE_CODE SYSRES_CONST_PICK_NEGATIVE_RESULT SYSRES_CONST_PICK_POSITIVE_RESULT SYSRES_CONST_PICK_REQUISITE SYSRES_CONST_PICK_REQUISITE_TYPE SYSRES_CONST_PICK_TYPE_CHAR SYSRES_CONST_PLAN_STATUS_REQUISITE_CODE SYSRES_CONST_PLATFORM_VERSION_COMMENT SYSRES_CONST_PLUGINS_SETTINGS_DESCRIPTION_REQUISITE_CODE SYSRES_CONST_POSITIVE_PICK_VALUE SYSRES_CONST_POWER_TO_CREATE_ACTION_CODE SYSRES_CONST_POWER_TO_SIGN_ACTION_CODE SYSRES_CONST_PRIORITY_REQUISITE_CODE SYSRES_CONST_QUALIFIED_TASK_TYPE SYSRES_CONST_QUALIFIED_TASK_TYPE_CODE SYSRES_CONST_RECSTAT_REQUISITE_CODE SYSRES_CONST_RED_LIFE_CYCLE_STAGE_FONT_COLOR SYSRES_CONST_REF_ID_T_REF_TYPE_REQUISITE_CODE SYSRES_CONST_REF_REQUISITE SYSRES_CONST_REF_REQUISITE_TYPE SYSRES_CONST_REF_REQUISITES_REFERENCE_CODE_SELECTED_REQUISITE SYSRES_CONST_REFERENCE_RECORD_HISTORY_CREATE_ACTION_CODE SYSRES_CONST_REFERENCE_RECORD_HISTORY_DELETE_ACTION_CODE SYSRES_CONST_REFERENCE_RECORD_HISTORY_MODIFY_ACTION_CODE SYSRES_CONST_REFERENCE_TYPE_CHAR SYSRES_CONST_REFERENCE_TYPE_REQUISITE_NAME SYSRES_CONST_REFERENCES_ADD_PARAMS_REQUISITE_CODE SYSRES_CONST_REFERENCES_DISPLAY_REQUISITE_REQUISITE_CODE SYSRES_CONST_REMOTE_SERVER_STATUS_WORKING SYSRES_CONST_REMOTE_SERVER_TYPE_MAIN SYSRES_CONST_REMOTE_SERVER_TYPE_SECONDARY SYSRES_CONST_REMOTE_USER_FLAG_VALUE_CODE SYSRES_CONST_REPORT_APP_EDITOR_INTERNAL SYSRES_CONST_REPORT_BASE_REPORT_ID_REQUISITE_CODE SYSRES_CONST_REPORT_BASE_REPORT_REQUISITE_CODE SYSRES_CONST_REPORT_SCRIPT_REQUISITE_CODE SYSRES_CONST_REPORT_TEMPLATE_REQUISITE_CODE SYSRES_CONST_REPORT_VIEWER_CODE_REQUISITE_CODE SYSRES_CONST_REQ_ALLOW_COMPONENT_DEFAULT_VALUE SYSRES_CONST_REQ_ALLOW_RECORD_DEFAULT_VALUE SYSRES_CONST_REQ_ALLOW_SERVER_COMPONENT_DEFAULT_VALUE SYSRES_CONST_REQ_MODE_AVAILABLE_CODE SYSRES_CONST_REQ_MODE_EDIT_CODE SYSRES_CONST_REQ_MODE_HIDDEN_CODE SYSRES_CONST_REQ_MODE_NOT_AVAILABLE_CODE SYSRES_CONST_REQ_MODE_VIEW_CODE SYSRES_CONST_REQ_NUMBER_REQUISITE_CODE SYSRES_CONST_REQ_SECTION_VALUE SYSRES_CONST_REQ_TYPE_VALUE SYSRES_CONST_REQUISITE_FORMAT_BY_UNIT SYSRES_CONST_REQUISITE_FORMAT_DATE_FULL SYSRES_CONST_REQUISITE_FORMAT_DATE_TIME SYSRES_CONST_REQUISITE_FORMAT_LEFT SYSRES_CONST_REQUISITE_FORMAT_RIGHT SYSRES_CONST_REQUISITE_FORMAT_WITHOUT_UNIT SYSRES_CONST_REQUISITE_NUMBER_REQUISITE_CODE SYSRES_CONST_REQUISITE_SECTION_ACTIONS SYSRES_CONST_REQUISITE_SECTION_BUTTON SYSRES_CONST_REQUISITE_SECTION_BUTTONS SYSRES_CONST_REQUISITE_SECTION_CARD SYSRES_CONST_REQUISITE_SECTION_TABLE SYSRES_CONST_REQUISITE_SECTION_TABLE10 SYSRES_CONST_REQUISITE_SECTION_TABLE11 SYSRES_CONST_REQUISITE_SECTION_TABLE12 SYSRES_CONST_REQUISITE_SECTION_TABLE13 SYSRES_CONST_REQUISITE_SECTION_TABLE14 SYSRES_CONST_REQUISITE_SECTION_TABLE15 SYSRES_CONST_REQUISITE_SECTION_TABLE16 SYSRES_CONST_REQUISITE_SECTION_TABLE17 SYSRES_CONST_REQUISITE_SECTION_TABLE18 SYSRES_CONST_REQUISITE_SECTION_TABLE19 SYSRES_CONST_REQUISITE_SECTION_TABLE2 SYSRES_CONST_REQUISITE_SECTION_TABLE20 SYSRES_CONST_REQUISITE_SECTION_TABLE21 SYSRES_CONST_REQUISITE_SECTION_TABLE22 SYSRES_CONST_REQUISITE_SECTION_TABLE23 SYSRES_CONST_REQUISITE_SECTION_TABLE24 SYSRES_CONST_REQUISITE_SECTION_TABLE3 SYSRES_CONST_REQUISITE_SECTION_TABLE4 SYSRES_CONST_REQUISITE_SECTION_TABLE5 SYSRES_CONST_REQUISITE_SECTION_TABLE6 SYSRES_CONST_REQUISITE_SECTION_TABLE7 SYSRES_CONST_REQUISITE_SECTION_TABLE8 SYSRES_CONST_REQUISITE_SECTION_TABLE9 SYSRES_CONST_REQUISITES_PSEUDOREFERENCE_REQUISITE_NUMBER_REQUISITE_CODE SYSRES_CONST_RIGHT_ALIGNMENT_CODE SYSRES_CONST_ROLES_REFERENCE_CODE SYSRES_CONST_ROUTE_STEP_AFTER_RUS SYSRES_CONST_ROUTE_STEP_AND_CONDITION_RUS SYSRES_CONST_ROUTE_STEP_OR_CONDITION_RUS SYSRES_CONST_ROUTE_TYPE_COMPLEX SYSRES_CONST_ROUTE_TYPE_PARALLEL SYSRES_CONST_ROUTE_TYPE_SERIAL SYSRES_CONST_SBDATASETDESC_NEGATIVE_VALUE SYSRES_CONST_SBDATASETDESC_POSITIVE_VALUE SYSRES_CONST_SBVIEWSDESC_POSITIVE_VALUE SYSRES_CONST_SCRIPT_BLOCK_DESCRIPTION SYSRES_CONST_SEARCH_BY_TEXT_REQUISITE_CODE SYSRES_CONST_SEARCHES_COMPONENT_CONTENT SYSRES_CONST_SEARCHES_CRITERIA_ACTION_NAME SYSRES_CONST_SEARCHES_EDOC_CONTENT SYSRES_CONST_SEARCHES_FOLDER_CONTENT SYSRES_CONST_SEARCHES_JOB_CONTENT SYSRES_CONST_SEARCHES_REFERENCE_CODE SYSRES_CONST_SEARCHES_TASK_CONTENT SYSRES_CONST_SECOND_CHAR SYSRES_CONST_SECTION_REQUISITE_ACTIONS_VALUE SYSRES_CONST_SECTION_REQUISITE_CARD_VALUE SYSRES_CONST_SECTION_REQUISITE_CODE SYSRES_CONST_SECTION_REQUISITE_DETAIL_1_VALUE SYSRES_CONST_SECTION_REQUISITE_DETAIL_2_VALUE SYSRES_CONST_SECTION_REQUISITE_DETAIL_3_VALUE SYSRES_CONST_SECTION_REQUISITE_DETAIL_4_VALUE SYSRES_CONST_SECTION_REQUISITE_DETAIL_5_VALUE SYSRES_CONST_SECTION_REQUISITE_DETAIL_6_VALUE SYSRES_CONST_SELECT_REFERENCE_MODE_NAME SYSRES_CONST_SELECT_TYPE_SELECTABLE SYSRES_CONST_SELECT_TYPE_SELECTABLE_ONLY_CHILD SYSRES_CONST_SELECT_TYPE_SELECTABLE_WITH_CHILD SYSRES_CONST_SELECT_TYPE_UNSLECTABLE SYSRES_CONST_SERVER_TYPE_MAIN SYSRES_CONST_SERVICE_USER_CATEGORY_FIELD_VALUE SYSRES_CONST_SETTINGS_USER_REQUISITE_CODE SYSRES_CONST_SIGNATURE_AND_ENCODE_CERTIFICATE_TYPE_CODE SYSRES_CONST_SIGNATURE_CERTIFICATE_TYPE_CODE SYSRES_CONST_SINGULAR_TITLE_REQUISITE_CODE SYSRES_CONST_SQL_SERVER_AUTHENTIFICATION_FLAG_VALUE_CODE SYSRES_CONST_SQL_SERVER_ENCODE_AUTHENTIFICATION_FLAG_VALUE_CODE SYSRES_CONST_STANDART_ROUTE_REFERENCE_CODE SYSRES_CONST_STANDART_ROUTE_REFERENCE_COMMENT_REQUISITE_CODE SYSRES_CONST_STANDART_ROUTES_GROUPS_REFERENCE_CODE SYSRES_CONST_STATE_REQ_NAME SYSRES_CONST_STATE_REQUISITE_ACTIVE_VALUE SYSRES_CONST_STATE_REQUISITE_CLOSED_VALUE SYSRES_CONST_STATE_REQUISITE_CODE SYSRES_CONST_STATIC_ROLE_TYPE_CODE SYSRES_CONST_STATUS_PLAN_DEFAULT_VALUE SYSRES_CONST_STATUS_VALUE_AUTOCLEANING SYSRES_CONST_STATUS_VALUE_BLUE_SQUARE SYSRES_CONST_STATUS_VALUE_COMPLETE SYSRES_CONST_STATUS_VALUE_GREEN_SQUARE SYSRES_CONST_STATUS_VALUE_ORANGE_SQUARE SYSRES_CONST_STATUS_VALUE_PURPLE_SQUARE SYSRES_CONST_STATUS_VALUE_RED_SQUARE SYSRES_CONST_STATUS_VALUE_SUSPEND SYSRES_CONST_STATUS_VALUE_YELLOW_SQUARE SYSRES_CONST_STDROUTE_SHOW_TO_USERS_REQUISITE_CODE SYSRES_CONST_STORAGE_TYPE_FILE SYSRES_CONST_STORAGE_TYPE_SQL_SERVER SYSRES_CONST_STR_REQUISITE SYSRES_CONST_STRIKEOUT_LIFE_CYCLE_STAGE_DRAW_STYLE SYSRES_CONST_STRING_FORMAT_LEFT_ALIGN_CHAR SYSRES_CONST_STRING_FORMAT_RIGHT_ALIGN_CHAR SYSRES_CONST_STRING_REQUISITE_CODE SYSRES_CONST_STRING_REQUISITE_TYPE SYSRES_CONST_STRING_TYPE_CHAR SYSRES_CONST_SUBSTITUTES_PSEUDOREFERENCE_CODE SYSRES_CONST_SUBTASK_BLOCK_DESCRIPTION SYSRES_CONST_SYSTEM_SETTING_CURRENT_USER_PARAM_VALUE SYSRES_CONST_SYSTEM_SETTING_EMPTY_VALUE_PARAM_VALUE SYSRES_CONST_SYSTEM_VERSION_COMMENT SYSRES_CONST_TASK_ACCESS_TYPE_ALL SYSRES_CONST_TASK_ACCESS_TYPE_ALL_MEMBERS SYSRES_CONST_TASK_ACCESS_TYPE_MANUAL SYSRES_CONST_TASK_ENCODE_TYPE_CERTIFICATION SYSRES_CONST_TASK_ENCODE_TYPE_CERTIFICATION_AND_PASSWORD SYSRES_CONST_TASK_ENCODE_TYPE_NONE SYSRES_CONST_TASK_ENCODE_TYPE_PASSWORD SYSRES_CONST_TASK_ROUTE_ALL_CONDITION SYSRES_CONST_TASK_ROUTE_AND_CONDITION SYSRES_CONST_TASK_ROUTE_OR_CONDITION SYSRES_CONST_TASK_STATE_ABORTED SYSRES_CONST_TASK_STATE_COMPLETE SYSRES_CONST_TASK_STATE_CONTINUED SYSRES_CONST_TASK_STATE_CONTROL SYSRES_CONST_TASK_STATE_INIT SYSRES_CONST_TASK_STATE_WORKING SYSRES_CONST_TASK_TITLE SYSRES_CONST_TASK_TYPES_GROUPS_REFERENCE_CODE SYSRES_CONST_TASK_TYPES_REFERENCE_CODE SYSRES_CONST_TEMPLATES_REFERENCE_CODE SYSRES_CONST_TEST_DATE_REQUISITE_NAME SYSRES_CONST_TEST_DEV_DATABASE_NAME SYSRES_CONST_TEST_DEV_SYSTEM_CODE SYSRES_CONST_TEST_EDMS_DATABASE_NAME SYSRES_CONST_TEST_EDMS_MAIN_CODE SYSRES_CONST_TEST_EDMS_MAIN_DB_NAME SYSRES_CONST_TEST_EDMS_SECOND_CODE SYSRES_CONST_TEST_EDMS_SECOND_DB_NAME SYSRES_CONST_TEST_EDMS_SYSTEM_CODE SYSRES_CONST_TEST_NUMERIC_REQUISITE_NAME SYSRES_CONST_TEXT_REQUISITE SYSRES_CONST_TEXT_REQUISITE_CODE SYSRES_CONST_TEXT_REQUISITE_TYPE SYSRES_CONST_TEXT_TYPE_CHAR SYSRES_CONST_TYPE_CODE_REQUISITE_CODE SYSRES_CONST_TYPE_REQUISITE_CODE SYSRES_CONST_UNDEFINED_LIFE_CYCLE_STAGE_FONT_COLOR SYSRES_CONST_UNITS_SECTION_ID_REQUISITE_CODE SYSRES_CONST_UNITS_SECTION_REQUISITE_CODE SYSRES_CONST_UNOPERATING_RECORD_FLAG_VALUE_CODE SYSRES_CONST_UNSTORED_DATA_REQUISITE_CODE SYSRES_CONST_UNSTORED_DATA_REQUISITE_NAME SYSRES_CONST_USE_ACCESS_TYPE_CODE SYSRES_CONST_USE_ACCESS_TYPE_NAME SYSRES_CONST_USER_ACCOUNT_TYPE_VALUE_CODE SYSRES_CONST_USER_ADDITIONAL_INFORMATION_REQUISITE_CODE SYSRES_CONST_USER_AND_GROUP_ID_FROM_PSEUDOREFERENCE_REQUISITE_CODE SYSRES_CONST_USER_CATEGORY_NORMAL SYSRES_CONST_USER_CERTIFICATE_REQUISITE_CODE SYSRES_CONST_USER_CERTIFICATE_STATE_REQUISITE_CODE SYSRES_CONST_USER_CERTIFICATE_SUBJECT_NAME_REQUISITE_CODE SYSRES_CONST_USER_CERTIFICATE_THUMBPRINT_REQUISITE_CODE SYSRES_CONST_USER_COMMON_CATEGORY SYSRES_CONST_USER_COMMON_CATEGORY_CODE SYSRES_CONST_USER_FULL_NAME_REQUISITE_CODE SYSRES_CONST_USER_GROUP_TYPE_REQUISITE_CODE SYSRES_CONST_USER_LOGIN_REQUISITE_CODE SYSRES_CONST_USER_REMOTE_CONTROLLER_REQUISITE_CODE SYSRES_CONST_USER_REMOTE_SYSTEM_REQUISITE_CODE SYSRES_CONST_USER_RIGHTS_T_REQUISITE_CODE SYSRES_CONST_USER_SERVER_NAME_REQUISITE_CODE SYSRES_CONST_USER_SERVICE_CATEGORY SYSRES_CONST_USER_SERVICE_CATEGORY_CODE SYSRES_CONST_USER_STATUS_ADMINISTRATOR_CODE SYSRES_CONST_USER_STATUS_ADMINISTRATOR_NAME SYSRES_CONST_USER_STATUS_DEVELOPER_CODE SYSRES_CONST_USER_STATUS_DEVELOPER_NAME SYSRES_CONST_USER_STATUS_DISABLED_CODE SYSRES_CONST_USER_STATUS_DISABLED_NAME SYSRES_CONST_USER_STATUS_SYSTEM_DEVELOPER_CODE SYSRES_CONST_USER_STATUS_USER_CODE SYSRES_CONST_USER_STATUS_USER_NAME SYSRES_CONST_USER_STATUS_USER_NAME_DEPRECATED SYSRES_CONST_USER_TYPE_FIELD_VALUE_USER SYSRES_CONST_USER_TYPE_REQUISITE_CODE SYSRES_CONST_USERS_CONTROLLER_REQUISITE_CODE SYSRES_CONST_USERS_IS_MAIN_SERVER_REQUISITE_CODE SYSRES_CONST_USERS_REFERENCE_CODE SYSRES_CONST_USERS_REGISTRATION_CERTIFICATES_ACTION_NAME SYSRES_CONST_USERS_REQUISITE_CODE SYSRES_CONST_USERS_SYSTEM_REQUISITE_CODE SYSRES_CONST_USERS_USER_ACCESS_RIGHTS_TYPR_REQUISITE_CODE SYSRES_CONST_USERS_USER_AUTHENTICATION_REQUISITE_CODE SYSRES_CONST_USERS_USER_COMPONENT_REQUISITE_CODE SYSRES_CONST_USERS_USER_GROUP_REQUISITE_CODE SYSRES_CONST_USERS_VIEW_CERTIFICATES_ACTION_NAME SYSRES_CONST_VIEW_DEFAULT_CODE SYSRES_CONST_VIEW_DEFAULT_NAME SYSRES_CONST_VIEWER_REQUISITE_CODE SYSRES_CONST_WAITING_BLOCK_DESCRIPTION SYSRES_CONST_WIZARD_FORM_LABEL_TEST_STRING  SYSRES_CONST_WIZARD_QUERY_PARAM_HEIGHT_ETALON_STRING SYSRES_CONST_WIZARD_REFERENCE_COMMENT_REQUISITE_CODE SYSRES_CONST_WORK_RULES_DESCRIPTION_REQUISITE_CODE SYSRES_CONST_WORK_TIME_CALENDAR_REFERENCE_CODE SYSRES_CONST_WORK_WORKFLOW_HARD_ROUTE_TYPE_VALUE SYSRES_CONST_WORK_WORKFLOW_HARD_ROUTE_TYPE_VALUE_CODE SYSRES_CONST_WORK_WORKFLOW_HARD_ROUTE_TYPE_VALUE_CODE_RUS SYSRES_CONST_WORK_WORKFLOW_SOFT_ROUTE_TYPE_VALUE_CODE_RUS SYSRES_CONST_WORKFLOW_ROUTE_TYPR_HARD SYSRES_CONST_WORKFLOW_ROUTE_TYPR_SOFT SYSRES_CONST_XML_ENCODING SYSRES_CONST_XREC_STAT_REQUISITE_CODE SYSRES_CONST_XRECID_FIELD_NAME SYSRES_CONST_YES SYSRES_CONST_YES_NO_2_REQUISITE_CODE SYSRES_CONST_YES_NO_REQUISITE_CODE SYSRES_CONST_YES_NO_T_REF_TYPE_REQUISITE_CODE SYSRES_CONST_YES_PICK_VALUE SYSRES_CONST_YES_VALUE ";
    // Base constant
    var base_constants = "CR FALSE nil NO_VALUE NULL TAB TRUE YES_VALUE ";
    // Base group name
    var base_group_name_constants = "ADMINISTRATORS_GROUP_NAME CUSTOMIZERS_GROUP_NAME DEVELOPERS_GROUP_NAME SERVICE_USERS_GROUP_NAME ";
    // Decision block properties
    var decision_block_properties_constants = "DECISION_BLOCK_FIRST_OPERAND_PROPERTY DECISION_BLOCK_NAME_PROPERTY DECISION_BLOCK_OPERATION_PROPERTY DECISION_BLOCK_RESULT_TYPE_PROPERTY DECISION_BLOCK_SECOND_OPERAND_PROPERTY ";
    // File extension
    var file_extension_constants = "ANY_FILE_EXTENTION COMPRESSED_DOCUMENT_EXTENSION EXTENDED_DOCUMENT_EXTENSION SHORT_COMPRESSED_DOCUMENT_EXTENSION SHORT_EXTENDED_DOCUMENT_EXTENSION ";
    // Job block properties
    var job_block_properties_constants = "JOB_BLOCK_ABORT_DEADLINE_PROPERTY JOB_BLOCK_AFTER_FINISH_EVENT JOB_BLOCK_AFTER_QUERY_PARAMETERS_EVENT JOB_BLOCK_ATTACHMENT_PROPERTY JOB_BLOCK_ATTACHMENTS_RIGHTS_GROUP_PROPERTY JOB_BLOCK_ATTACHMENTS_RIGHTS_TYPE_PROPERTY JOB_BLOCK_BEFORE_QUERY_PARAMETERS_EVENT JOB_BLOCK_BEFORE_START_EVENT JOB_BLOCK_CREATED_JOBS_PROPERTY JOB_BLOCK_DEADLINE_PROPERTY JOB_BLOCK_EXECUTION_RESULTS_PROPERTY JOB_BLOCK_IS_PARALLEL_PROPERTY JOB_BLOCK_IS_RELATIVE_ABORT_DEADLINE_PROPERTY JOB_BLOCK_IS_RELATIVE_DEADLINE_PROPERTY JOB_BLOCK_JOB_TEXT_PROPERTY JOB_BLOCK_NAME_PROPERTY JOB_BLOCK_NEED_SIGN_ON_PERFORM_PROPERTY JOB_BLOCK_PERFORMER_PROPERTY JOB_BLOCK_RELATIVE_ABORT_DEADLINE_TYPE_PROPERTY JOB_BLOCK_RELATIVE_DEADLINE_TYPE_PROPERTY JOB_BLOCK_SUBJECT_PROPERTY ";
    // Language code
    var language_code_constants = "ENGLISH_LANGUAGE_CODE RUSSIAN_LANGUAGE_CODE ";
    // Launching external applications
    var launching_external_applications_constants = "smHidden smMaximized smMinimized smNormal wmNo wmYes ";
    // Link kind
    var link_kind_constants = "COMPONENT_TOKEN_LINK_KIND DOCUMENT_LINK_KIND EDOCUMENT_LINK_KIND FOLDER_LINK_KIND JOB_LINK_KIND REFERENCE_LINK_KIND TASK_LINK_KIND ";
    // Lock type
    var lock_type_constants = "COMPONENT_TOKEN_LOCK_TYPE EDOCUMENT_VERSION_LOCK_TYPE ";
    // Monitor block properties
    var monitor_block_properties_constants = "MONITOR_BLOCK_AFTER_FINISH_EVENT MONITOR_BLOCK_BEFORE_START_EVENT MONITOR_BLOCK_DEADLINE_PROPERTY MONITOR_BLOCK_INTERVAL_PROPERTY MONITOR_BLOCK_INTERVAL_TYPE_PROPERTY MONITOR_BLOCK_IS_RELATIVE_DEADLINE_PROPERTY MONITOR_BLOCK_NAME_PROPERTY MONITOR_BLOCK_RELATIVE_DEADLINE_TYPE_PROPERTY MONITOR_BLOCK_SEARCH_SCRIPT_PROPERTY ";
    // Notice block properties
    var notice_block_properties_constants = "NOTICE_BLOCK_AFTER_FINISH_EVENT NOTICE_BLOCK_ATTACHMENT_PROPERTY NOTICE_BLOCK_ATTACHMENTS_RIGHTS_GROUP_PROPERTY NOTICE_BLOCK_ATTACHMENTS_RIGHTS_TYPE_PROPERTY NOTICE_BLOCK_BEFORE_START_EVENT NOTICE_BLOCK_CREATED_NOTICES_PROPERTY NOTICE_BLOCK_DEADLINE_PROPERTY NOTICE_BLOCK_IS_RELATIVE_DEADLINE_PROPERTY NOTICE_BLOCK_NAME_PROPERTY NOTICE_BLOCK_NOTICE_TEXT_PROPERTY NOTICE_BLOCK_PERFORMER_PROPERTY NOTICE_BLOCK_RELATIVE_DEADLINE_TYPE_PROPERTY NOTICE_BLOCK_SUBJECT_PROPERTY ";
    // Object events
    var object_events_constants = "dseAfterCancel dseAfterClose dseAfterDelete dseAfterDeleteOutOfTransaction dseAfterInsert dseAfterOpen dseAfterScroll dseAfterUpdate dseAfterUpdateOutOfTransaction dseBeforeCancel dseBeforeClose dseBeforeDelete dseBeforeDetailUpdate dseBeforeInsert dseBeforeOpen dseBeforeUpdate dseOnAnyRequisiteChange dseOnCloseRecord dseOnDeleteError dseOnOpenRecord dseOnPrepareUpdate dseOnUpdateError dseOnUpdateRatifiedRecord dseOnValidDelete dseOnValidUpdate reOnChange reOnChangeValues SELECTION_BEGIN_ROUTE_EVENT SELECTION_END_ROUTE_EVENT ";
    // Object params
    var object_params_constants = "CURRENT_PERIOD_IS_REQUIRED PREVIOUS_CARD_TYPE_NAME SHOW_RECORD_PROPERTIES_FORM ";
    // Other
    var other_constants = "ACCESS_RIGHTS_SETTING_DIALOG_CODE ADMINISTRATOR_USER_CODE ANALYTIC_REPORT_TYPE asrtHideLocal asrtHideRemote CALCULATED_ROLE_TYPE_CODE COMPONENTS_REFERENCE_DEVELOPER_VIEW_CODE DCTS_TEST_PROTOCOLS_FOLDER_PATH E_EDOC_VERSION_ALREADY_APPROVINGLY_SIGNED E_EDOC_VERSION_ALREADY_APPROVINGLY_SIGNED_BY_USER E_EDOC_VERSION_ALREDY_SIGNED E_EDOC_VERSION_ALREDY_SIGNED_BY_USER EDOC_TYPES_CODE_REQUISITE_FIELD_NAME EDOCUMENTS_ALIAS_NAME FILES_FOLDER_PATH FILTER_OPERANDS_DELIMITER FILTER_OPERATIONS_DELIMITER FORMCARD_NAME FORMLIST_NAME GET_EXTENDED_DOCUMENT_EXTENSION_CREATION_MODE GET_EXTENDED_DOCUMENT_EXTENSION_IMPORT_MODE INTEGRATED_REPORT_TYPE IS_BUILDER_APPLICATION_ROLE IS_BUILDER_APPLICATION_ROLE2 IS_BUILDER_USERS ISBSYSDEV LOG_FOLDER_PATH mbCancel mbNo mbNoToAll mbOK mbYes mbYesToAll MEMORY_DATASET_DESRIPTIONS_FILENAME mrNo mrNoToAll mrYes mrYesToAll MULTIPLE_SELECT_DIALOG_CODE NONOPERATING_RECORD_FLAG_FEMININE NONOPERATING_RECORD_FLAG_MASCULINE OPERATING_RECORD_FLAG_FEMININE OPERATING_RECORD_FLAG_MASCULINE PROFILING_SETTINGS_COMMON_SETTINGS_CODE_VALUE PROGRAM_INITIATED_LOOKUP_ACTION ratDelete ratEdit ratInsert REPORT_TYPE REQUIRED_PICK_VALUES_VARIABLE rmCard rmList SBRTE_PROGID_DEV SBRTE_PROGID_RELEASE STATIC_ROLE_TYPE_CODE SUPPRESS_EMPTY_TEMPLATE_CREATION SYSTEM_USER_CODE UPDATE_DIALOG_DATASET USED_IN_OBJECT_HINT_PARAM USER_INITIATED_LOOKUP_ACTION USER_NAME_FORMAT USER_SELECTION_RESTRICTIONS WORKFLOW_TEST_PROTOCOLS_FOLDER_PATH ELS_SUBTYPE_CONTROL_NAME ELS_FOLDER_KIND_CONTROL_NAME REPEAT_PROCESS_CURRENT_OBJECT_EXCEPTION_NAME ";
    // Privileges
    var privileges_constants = "PRIVILEGE_COMPONENT_FULL_ACCESS PRIVILEGE_DEVELOPMENT_EXPORT PRIVILEGE_DEVELOPMENT_IMPORT PRIVILEGE_DOCUMENT_DELETE PRIVILEGE_ESD PRIVILEGE_FOLDER_DELETE PRIVILEGE_MANAGE_ACCESS_RIGHTS PRIVILEGE_MANAGE_REPLICATION PRIVILEGE_MANAGE_SESSION_SERVER PRIVILEGE_OBJECT_FULL_ACCESS PRIVILEGE_OBJECT_VIEW PRIVILEGE_RESERVE_LICENSE PRIVILEGE_SYSTEM_CUSTOMIZE PRIVILEGE_SYSTEM_DEVELOP PRIVILEGE_SYSTEM_INSTALL PRIVILEGE_TASK_DELETE PRIVILEGE_USER_PLUGIN_SETTINGS_CUSTOMIZE PRIVILEGES_PSEUDOREFERENCE_CODE ";
    // Pseudoreference code
    var pseudoreference_code_constants = "ACCESS_TYPES_PSEUDOREFERENCE_CODE ALL_AVAILABLE_COMPONENTS_PSEUDOREFERENCE_CODE ALL_AVAILABLE_PRIVILEGES_PSEUDOREFERENCE_CODE ALL_REPLICATE_COMPONENTS_PSEUDOREFERENCE_CODE AVAILABLE_DEVELOPERS_COMPONENTS_PSEUDOREFERENCE_CODE COMPONENTS_PSEUDOREFERENCE_CODE FILTRATER_SETTINGS_CONFLICTS_PSEUDOREFERENCE_CODE GROUPS_PSEUDOREFERENCE_CODE RECEIVE_PROTOCOL_PSEUDOREFERENCE_CODE REFERENCE_REQUISITE_PSEUDOREFERENCE_CODE REFERENCE_REQUISITES_PSEUDOREFERENCE_CODE REFTYPES_PSEUDOREFERENCE_CODE REPLICATION_SEANCES_DIARY_PSEUDOREFERENCE_CODE SEND_PROTOCOL_PSEUDOREFERENCE_CODE SUBSTITUTES_PSEUDOREFERENCE_CODE SYSTEM_SETTINGS_PSEUDOREFERENCE_CODE UNITS_PSEUDOREFERENCE_CODE USERS_PSEUDOREFERENCE_CODE VIEWERS_PSEUDOREFERENCE_CODE ";
    // Requisite ISBCertificateType values
    var requisite_ISBCertificateType_values_constants = "CERTIFICATE_TYPE_ENCRYPT CERTIFICATE_TYPE_SIGN CERTIFICATE_TYPE_SIGN_AND_ENCRYPT ";
    // Requisite ISBEDocStorageType values
    var requisite_ISBEDocStorageType_values_constants = "STORAGE_TYPE_FILE STORAGE_TYPE_NAS_CIFS STORAGE_TYPE_SAPERION STORAGE_TYPE_SQL_SERVER ";
    // Requisite CompType2 values
    var requisite_compType2_values_constants = "COMPTYPE2_REQUISITE_DOCUMENTS_VALUE COMPTYPE2_REQUISITE_TASKS_VALUE COMPTYPE2_REQUISITE_FOLDERS_VALUE COMPTYPE2_REQUISITE_REFERENCES_VALUE ";
    // Requisite name
    var requisite_name_constants = "SYSREQ_CODE SYSREQ_COMPTYPE2 SYSREQ_CONST_AVAILABLE_FOR_WEB SYSREQ_CONST_COMMON_CODE SYSREQ_CONST_COMMON_VALUE SYSREQ_CONST_FIRM_CODE SYSREQ_CONST_FIRM_STATUS SYSREQ_CONST_FIRM_VALUE SYSREQ_CONST_SERVER_STATUS SYSREQ_CONTENTS SYSREQ_DATE_OPEN SYSREQ_DATE_CLOSE SYSREQ_DESCRIPTION SYSREQ_DESCRIPTION_LOCALIZE_ID SYSREQ_DOUBLE SYSREQ_EDOC_ACCESS_TYPE SYSREQ_EDOC_AUTHOR SYSREQ_EDOC_CREATED SYSREQ_EDOC_DELEGATE_RIGHTS_REQUISITE_CODE SYSREQ_EDOC_EDITOR SYSREQ_EDOC_ENCODE_TYPE SYSREQ_EDOC_ENCRYPTION_PLUGIN_NAME SYSREQ_EDOC_ENCRYPTION_PLUGIN_VERSION SYSREQ_EDOC_EXPORT_DATE SYSREQ_EDOC_EXPORTER SYSREQ_EDOC_KIND SYSREQ_EDOC_LIFE_STAGE_NAME SYSREQ_EDOC_LOCKED_FOR_SERVER_CODE SYSREQ_EDOC_MODIFIED SYSREQ_EDOC_NAME SYSREQ_EDOC_NOTE SYSREQ_EDOC_QUALIFIED_ID SYSREQ_EDOC_SESSION_KEY SYSREQ_EDOC_SESSION_KEY_ENCRYPTION_PLUGIN_NAME SYSREQ_EDOC_SESSION_KEY_ENCRYPTION_PLUGIN_VERSION SYSREQ_EDOC_SIGNATURE_TYPE SYSREQ_EDOC_SIGNED SYSREQ_EDOC_STORAGE SYSREQ_EDOC_STORAGES_ARCHIVE_STORAGE SYSREQ_EDOC_STORAGES_CHECK_RIGHTS SYSREQ_EDOC_STORAGES_COMPUTER_NAME SYSREQ_EDOC_STORAGES_EDIT_IN_STORAGE SYSREQ_EDOC_STORAGES_EXECUTIVE_STORAGE SYSREQ_EDOC_STORAGES_FUNCTION SYSREQ_EDOC_STORAGES_INITIALIZED SYSREQ_EDOC_STORAGES_LOCAL_PATH SYSREQ_EDOC_STORAGES_SAPERION_DATABASE_NAME SYSREQ_EDOC_STORAGES_SEARCH_BY_TEXT SYSREQ_EDOC_STORAGES_SERVER_NAME SYSREQ_EDOC_STORAGES_SHARED_SOURCE_NAME SYSREQ_EDOC_STORAGES_TYPE SYSREQ_EDOC_TEXT_MODIFIED SYSREQ_EDOC_TYPE_ACT_CODE SYSREQ_EDOC_TYPE_ACT_DESCRIPTION SYSREQ_EDOC_TYPE_ACT_DESCRIPTION_LOCALIZE_ID SYSREQ_EDOC_TYPE_ACT_ON_EXECUTE SYSREQ_EDOC_TYPE_ACT_ON_EXECUTE_EXISTS SYSREQ_EDOC_TYPE_ACT_SECTION SYSREQ_EDOC_TYPE_ADD_PARAMS SYSREQ_EDOC_TYPE_COMMENT SYSREQ_EDOC_TYPE_EVENT_TEXT SYSREQ_EDOC_TYPE_NAME_IN_SINGULAR SYSREQ_EDOC_TYPE_NAME_IN_SINGULAR_LOCALIZE_ID SYSREQ_EDOC_TYPE_NAME_LOCALIZE_ID SYSREQ_EDOC_TYPE_NUMERATION_METHOD SYSREQ_EDOC_TYPE_PSEUDO_REQUISITE_CODE SYSREQ_EDOC_TYPE_REQ_CODE SYSREQ_EDOC_TYPE_REQ_DESCRIPTION SYSREQ_EDOC_TYPE_REQ_DESCRIPTION_LOCALIZE_ID SYSREQ_EDOC_TYPE_REQ_IS_LEADING SYSREQ_EDOC_TYPE_REQ_IS_REQUIRED SYSREQ_EDOC_TYPE_REQ_NUMBER SYSREQ_EDOC_TYPE_REQ_ON_CHANGE SYSREQ_EDOC_TYPE_REQ_ON_CHANGE_EXISTS SYSREQ_EDOC_TYPE_REQ_ON_SELECT SYSREQ_EDOC_TYPE_REQ_ON_SELECT_KIND SYSREQ_EDOC_TYPE_REQ_SECTION SYSREQ_EDOC_TYPE_VIEW_CARD SYSREQ_EDOC_TYPE_VIEW_CODE SYSREQ_EDOC_TYPE_VIEW_COMMENT SYSREQ_EDOC_TYPE_VIEW_IS_MAIN SYSREQ_EDOC_TYPE_VIEW_NAME SYSREQ_EDOC_TYPE_VIEW_NAME_LOCALIZE_ID SYSREQ_EDOC_VERSION_AUTHOR SYSREQ_EDOC_VERSION_CRC SYSREQ_EDOC_VERSION_DATA SYSREQ_EDOC_VERSION_EDITOR SYSREQ_EDOC_VERSION_EXPORT_DATE SYSREQ_EDOC_VERSION_EXPORTER SYSREQ_EDOC_VERSION_HIDDEN SYSREQ_EDOC_VERSION_LIFE_STAGE SYSREQ_EDOC_VERSION_MODIFIED SYSREQ_EDOC_VERSION_NOTE SYSREQ_EDOC_VERSION_SIGNATURE_TYPE SYSREQ_EDOC_VERSION_SIGNED SYSREQ_EDOC_VERSION_SIZE SYSREQ_EDOC_VERSION_SOURCE SYSREQ_EDOC_VERSION_TEXT_MODIFIED SYSREQ_EDOCKIND_DEFAULT_VERSION_STATE_CODE SYSREQ_FOLDER_KIND SYSREQ_FUNC_CATEGORY SYSREQ_FUNC_COMMENT SYSREQ_FUNC_GROUP SYSREQ_FUNC_GROUP_COMMENT SYSREQ_FUNC_GROUP_NUMBER SYSREQ_FUNC_HELP SYSREQ_FUNC_PARAM_DEF_VALUE SYSREQ_FUNC_PARAM_IDENT SYSREQ_FUNC_PARAM_NUMBER SYSREQ_FUNC_PARAM_TYPE SYSREQ_FUNC_TEXT SYSREQ_GROUP_CATEGORY SYSREQ_ID SYSREQ_LAST_UPDATE SYSREQ_LEADER_REFERENCE SYSREQ_LINE_NUMBER SYSREQ_MAIN_RECORD_ID SYSREQ_NAME SYSREQ_NAME_LOCALIZE_ID SYSREQ_NOTE SYSREQ_ORIGINAL_RECORD SYSREQ_OUR_FIRM SYSREQ_PROFILING_SETTINGS_BATCH_LOGING SYSREQ_PROFILING_SETTINGS_BATCH_SIZE SYSREQ_PROFILING_SETTINGS_PROFILING_ENABLED SYSREQ_PROFILING_SETTINGS_SQL_PROFILING_ENABLED SYSREQ_PROFILING_SETTINGS_START_LOGGED SYSREQ_RECORD_STATUS SYSREQ_REF_REQ_FIELD_NAME SYSREQ_REF_REQ_FORMAT SYSREQ_REF_REQ_GENERATED SYSREQ_REF_REQ_LENGTH SYSREQ_REF_REQ_PRECISION SYSREQ_REF_REQ_REFERENCE SYSREQ_REF_REQ_SECTION SYSREQ_REF_REQ_STORED SYSREQ_REF_REQ_TOKENS SYSREQ_REF_REQ_TYPE SYSREQ_REF_REQ_VIEW SYSREQ_REF_TYPE_ACT_CODE SYSREQ_REF_TYPE_ACT_DESCRIPTION SYSREQ_REF_TYPE_ACT_DESCRIPTION_LOCALIZE_ID SYSREQ_REF_TYPE_ACT_ON_EXECUTE SYSREQ_REF_TYPE_ACT_ON_EXECUTE_EXISTS SYSREQ_REF_TYPE_ACT_SECTION SYSREQ_REF_TYPE_ADD_PARAMS SYSREQ_REF_TYPE_COMMENT SYSREQ_REF_TYPE_COMMON_SETTINGS SYSREQ_REF_TYPE_DISPLAY_REQUISITE_NAME SYSREQ_REF_TYPE_EVENT_TEXT SYSREQ_REF_TYPE_MAIN_LEADING_REF SYSREQ_REF_TYPE_NAME_IN_SINGULAR SYSREQ_REF_TYPE_NAME_IN_SINGULAR_LOCALIZE_ID SYSREQ_REF_TYPE_NAME_LOCALIZE_ID SYSREQ_REF_TYPE_NUMERATION_METHOD SYSREQ_REF_TYPE_REQ_CODE SYSREQ_REF_TYPE_REQ_DESCRIPTION SYSREQ_REF_TYPE_REQ_DESCRIPTION_LOCALIZE_ID SYSREQ_REF_TYPE_REQ_IS_CONTROL SYSREQ_REF_TYPE_REQ_IS_FILTER SYSREQ_REF_TYPE_REQ_IS_LEADING SYSREQ_REF_TYPE_REQ_IS_REQUIRED SYSREQ_REF_TYPE_REQ_NUMBER SYSREQ_REF_TYPE_REQ_ON_CHANGE SYSREQ_REF_TYPE_REQ_ON_CHANGE_EXISTS SYSREQ_REF_TYPE_REQ_ON_SELECT SYSREQ_REF_TYPE_REQ_ON_SELECT_KIND SYSREQ_REF_TYPE_REQ_SECTION SYSREQ_REF_TYPE_VIEW_CARD SYSREQ_REF_TYPE_VIEW_CODE SYSREQ_REF_TYPE_VIEW_COMMENT SYSREQ_REF_TYPE_VIEW_IS_MAIN SYSREQ_REF_TYPE_VIEW_NAME SYSREQ_REF_TYPE_VIEW_NAME_LOCALIZE_ID SYSREQ_REFERENCE_TYPE_ID SYSREQ_STATE SYSREQ_STAT\u0415 SYSREQ_SYSTEM_SETTINGS_VALUE SYSREQ_TYPE SYSREQ_UNIT SYSREQ_UNIT_ID SYSREQ_USER_GROUPS_GROUP_FULL_NAME SYSREQ_USER_GROUPS_GROUP_NAME SYSREQ_USER_GROUPS_GROUP_SERVER_NAME SYSREQ_USERS_ACCESS_RIGHTS SYSREQ_USERS_AUTHENTICATION SYSREQ_USERS_CATEGORY SYSREQ_USERS_COMPONENT SYSREQ_USERS_COMPONENT_USER_IS_PUBLIC SYSREQ_USERS_DOMAIN SYSREQ_USERS_FULL_USER_NAME SYSREQ_USERS_GROUP SYSREQ_USERS_IS_MAIN_SERVER SYSREQ_USERS_LOGIN SYSREQ_USERS_REFERENCE_USER_IS_PUBLIC SYSREQ_USERS_STATUS SYSREQ_USERS_USER_CERTIFICATE SYSREQ_USERS_USER_CERTIFICATE_INFO SYSREQ_USERS_USER_CERTIFICATE_PLUGIN_NAME SYSREQ_USERS_USER_CERTIFICATE_PLUGIN_VERSION SYSREQ_USERS_USER_CERTIFICATE_STATE SYSREQ_USERS_USER_CERTIFICATE_SUBJECT_NAME SYSREQ_USERS_USER_CERTIFICATE_THUMBPRINT SYSREQ_USERS_USER_DEFAULT_CERTIFICATE SYSREQ_USERS_USER_DESCRIPTION SYSREQ_USERS_USER_GLOBAL_NAME SYSREQ_USERS_USER_LOGIN SYSREQ_USERS_USER_MAIN_SERVER SYSREQ_USERS_USER_TYPE SYSREQ_WORK_RULES_FOLDER_ID ";
    // Result
    var result_constants = "RESULT_VAR_NAME RESULT_VAR_NAME_ENG ";
    // Rule identification
    var rule_identification_constants = "AUTO_NUMERATION_RULE_ID CANT_CHANGE_ID_REQUISITE_RULE_ID CANT_CHANGE_OURFIRM_REQUISITE_RULE_ID CHECK_CHANGING_REFERENCE_RECORD_USE_RULE_ID CHECK_CODE_REQUISITE_RULE_ID CHECK_DELETING_REFERENCE_RECORD_USE_RULE_ID CHECK_FILTRATER_CHANGES_RULE_ID CHECK_RECORD_INTERVAL_RULE_ID CHECK_REFERENCE_INTERVAL_RULE_ID CHECK_REQUIRED_DATA_FULLNESS_RULE_ID CHECK_REQUIRED_REQUISITES_FULLNESS_RULE_ID MAKE_RECORD_UNRATIFIED_RULE_ID RESTORE_AUTO_NUMERATION_RULE_ID SET_FIRM_CONTEXT_FROM_RECORD_RULE_ID SET_FIRST_RECORD_IN_LIST_FORM_RULE_ID SET_IDSPS_VALUE_RULE_ID SET_NEXT_CODE_VALUE_RULE_ID SET_OURFIRM_BOUNDS_RULE_ID SET_OURFIRM_REQUISITE_RULE_ID ";
    // Script block properties
    var script_block_properties_constants = "SCRIPT_BLOCK_AFTER_FINISH_EVENT SCRIPT_BLOCK_BEFORE_START_EVENT SCRIPT_BLOCK_EXECUTION_RESULTS_PROPERTY SCRIPT_BLOCK_NAME_PROPERTY SCRIPT_BLOCK_SCRIPT_PROPERTY ";
    // Subtask block properties
    var subtask_block_properties_constants = "SUBTASK_BLOCK_ABORT_DEADLINE_PROPERTY SUBTASK_BLOCK_AFTER_FINISH_EVENT SUBTASK_BLOCK_ASSIGN_PARAMS_EVENT SUBTASK_BLOCK_ATTACHMENTS_PROPERTY SUBTASK_BLOCK_ATTACHMENTS_RIGHTS_GROUP_PROPERTY SUBTASK_BLOCK_ATTACHMENTS_RIGHTS_TYPE_PROPERTY SUBTASK_BLOCK_BEFORE_START_EVENT SUBTASK_BLOCK_CREATED_TASK_PROPERTY SUBTASK_BLOCK_CREATION_EVENT SUBTASK_BLOCK_DEADLINE_PROPERTY SUBTASK_BLOCK_IMPORTANCE_PROPERTY SUBTASK_BLOCK_INITIATOR_PROPERTY SUBTASK_BLOCK_IS_RELATIVE_ABORT_DEADLINE_PROPERTY SUBTASK_BLOCK_IS_RELATIVE_DEADLINE_PROPERTY SUBTASK_BLOCK_JOBS_TYPE_PROPERTY SUBTASK_BLOCK_NAME_PROPERTY SUBTASK_BLOCK_PARALLEL_ROUTE_PROPERTY SUBTASK_BLOCK_PERFORMERS_PROPERTY SUBTASK_BLOCK_RELATIVE_ABORT_DEADLINE_TYPE_PROPERTY SUBTASK_BLOCK_RELATIVE_DEADLINE_TYPE_PROPERTY SUBTASK_BLOCK_REQUIRE_SIGN_PROPERTY SUBTASK_BLOCK_STANDARD_ROUTE_PROPERTY SUBTASK_BLOCK_START_EVENT SUBTASK_BLOCK_STEP_CONTROL_PROPERTY SUBTASK_BLOCK_SUBJECT_PROPERTY SUBTASK_BLOCK_TASK_CONTROL_PROPERTY SUBTASK_BLOCK_TEXT_PROPERTY SUBTASK_BLOCK_UNLOCK_ATTACHMENTS_ON_STOP_PROPERTY SUBTASK_BLOCK_USE_STANDARD_ROUTE_PROPERTY SUBTASK_BLOCK_WAIT_FOR_TASK_COMPLETE_PROPERTY ";
    // System component
    var system_component_constants = "SYSCOMP_CONTROL_JOBS SYSCOMP_FOLDERS SYSCOMP_JOBS SYSCOMP_NOTICES SYSCOMP_TASKS ";
    // System dialogs
    var system_dialogs_constants = "SYSDLG_CREATE_EDOCUMENT SYSDLG_CREATE_EDOCUMENT_VERSION SYSDLG_CURRENT_PERIOD SYSDLG_EDIT_FUNCTION_HELP SYSDLG_EDOCUMENT_KINDS_FOR_TEMPLATE SYSDLG_EXPORT_MULTIPLE_EDOCUMENTS SYSDLG_EXPORT_SINGLE_EDOCUMENT SYSDLG_IMPORT_EDOCUMENT SYSDLG_MULTIPLE_SELECT SYSDLG_SETUP_ACCESS_RIGHTS SYSDLG_SETUP_DEFAULT_RIGHTS SYSDLG_SETUP_FILTER_CONDITION SYSDLG_SETUP_SIGN_RIGHTS SYSDLG_SETUP_TASK_OBSERVERS SYSDLG_SETUP_TASK_ROUTE SYSDLG_SETUP_USERS_LIST SYSDLG_SIGN_EDOCUMENT SYSDLG_SIGN_MULTIPLE_EDOCUMENTS ";
    // System reference names
    var system_reference_names_constants = "SYSREF_ACCESS_RIGHTS_TYPES SYSREF_ADMINISTRATION_HISTORY SYSREF_ALL_AVAILABLE_COMPONENTS SYSREF_ALL_AVAILABLE_PRIVILEGES SYSREF_ALL_REPLICATING_COMPONENTS SYSREF_AVAILABLE_DEVELOPERS_COMPONENTS SYSREF_CALENDAR_EVENTS SYSREF_COMPONENT_TOKEN_HISTORY SYSREF_COMPONENT_TOKENS SYSREF_COMPONENTS SYSREF_CONSTANTS SYSREF_DATA_RECEIVE_PROTOCOL SYSREF_DATA_SEND_PROTOCOL SYSREF_DIALOGS SYSREF_DIALOGS_REQUISITES SYSREF_EDITORS SYSREF_EDOC_CARDS SYSREF_EDOC_TYPES SYSREF_EDOCUMENT_CARD_REQUISITES SYSREF_EDOCUMENT_CARD_TYPES SYSREF_EDOCUMENT_CARD_TYPES_REFERENCE SYSREF_EDOCUMENT_CARDS SYSREF_EDOCUMENT_HISTORY SYSREF_EDOCUMENT_KINDS SYSREF_EDOCUMENT_REQUISITES SYSREF_EDOCUMENT_SIGNATURES SYSREF_EDOCUMENT_TEMPLATES SYSREF_EDOCUMENT_TEXT_STORAGES SYSREF_EDOCUMENT_VIEWS SYSREF_FILTERER_SETUP_CONFLICTS SYSREF_FILTRATER_SETTING_CONFLICTS SYSREF_FOLDER_HISTORY SYSREF_FOLDERS SYSREF_FUNCTION_GROUPS SYSREF_FUNCTION_PARAMS SYSREF_FUNCTIONS SYSREF_JOB_HISTORY SYSREF_LINKS SYSREF_LOCALIZATION_DICTIONARY SYSREF_LOCALIZATION_LANGUAGES SYSREF_MODULES SYSREF_PRIVILEGES SYSREF_RECORD_HISTORY SYSREF_REFERENCE_REQUISITES SYSREF_REFERENCE_TYPE_VIEWS SYSREF_REFERENCE_TYPES SYSREF_REFERENCES SYSREF_REFERENCES_REQUISITES SYSREF_REMOTE_SERVERS SYSREF_REPLICATION_SESSIONS_LOG SYSREF_REPLICATION_SESSIONS_PROTOCOL SYSREF_REPORTS SYSREF_ROLES SYSREF_ROUTE_BLOCK_GROUPS SYSREF_ROUTE_BLOCKS SYSREF_SCRIPTS SYSREF_SEARCHES SYSREF_SERVER_EVENTS SYSREF_SERVER_EVENTS_HISTORY SYSREF_STANDARD_ROUTE_GROUPS SYSREF_STANDARD_ROUTES SYSREF_STATUSES SYSREF_SYSTEM_SETTINGS SYSREF_TASK_HISTORY SYSREF_TASK_KIND_GROUPS SYSREF_TASK_KINDS SYSREF_TASK_RIGHTS SYSREF_TASK_SIGNATURES SYSREF_TASKS SYSREF_UNITS SYSREF_USER_GROUPS SYSREF_USER_GROUPS_REFERENCE SYSREF_USER_SUBSTITUTION SYSREF_USERS SYSREF_USERS_REFERENCE SYSREF_VIEWERS SYSREF_WORKING_TIME_CALENDARS ";
    // Table name
    var table_name_constants = "ACCESS_RIGHTS_TABLE_NAME EDMS_ACCESS_TABLE_NAME EDOC_TYPES_TABLE_NAME ";
    // Test
    var test_constants = "TEST_DEV_DB_NAME TEST_DEV_SYSTEM_CODE TEST_EDMS_DB_NAME TEST_EDMS_MAIN_CODE TEST_EDMS_MAIN_DB_NAME TEST_EDMS_SECOND_CODE TEST_EDMS_SECOND_DB_NAME TEST_EDMS_SYSTEM_CODE TEST_ISB5_MAIN_CODE TEST_ISB5_SECOND_CODE TEST_SQL_SERVER_2005_NAME TEST_SQL_SERVER_NAME ";
    // Using the dialog windows
    var using_the_dialog_windows_constants = "ATTENTION_CAPTION cbsCommandLinks cbsDefault CONFIRMATION_CAPTION ERROR_CAPTION INFORMATION_CAPTION mrCancel mrOk ";
    // Using the document
    var using_the_document_constants = "EDOC_VERSION_ACTIVE_STAGE_CODE EDOC_VERSION_DESIGN_STAGE_CODE EDOC_VERSION_OBSOLETE_STAGE_CODE ";
    // Using the EA and encryption
    var using_the_EA_and_encryption_constants = "cpDataEnciphermentEnabled cpDigitalSignatureEnabled cpID cpIssuer cpPluginVersion cpSerial cpSubjectName cpSubjSimpleName cpValidFromDate cpValidToDate ";
    // Using the ISBL-editor
    var using_the_ISBL_editor_constants = "ISBL_SYNTAX NO_SYNTAX XML_SYNTAX ";
    // Wait block properties
    var wait_block_properties_constants = "WAIT_BLOCK_AFTER_FINISH_EVENT WAIT_BLOCK_BEFORE_START_EVENT WAIT_BLOCK_DEADLINE_PROPERTY WAIT_BLOCK_IS_RELATIVE_DEADLINE_PROPERTY WAIT_BLOCK_NAME_PROPERTY WAIT_BLOCK_RELATIVE_DEADLINE_TYPE_PROPERTY ";
    // SYSRES Common
    var sysres_common_constants = "SYSRES_COMMON SYSRES_CONST SYSRES_MBFUNC SYSRES_SBDATA SYSRES_SBGUI SYSRES_SBINTF SYSRES_SBREFDSC SYSRES_SQLERRORS SYSRES_SYSCOMP ";
    // Константы ==> built_in
    var CONSTANTS = sysres_constants + base_constants + base_group_name_constants + decision_block_properties_constants + file_extension_constants + job_block_properties_constants + language_code_constants + launching_external_applications_constants + link_kind_constants + lock_type_constants + monitor_block_properties_constants + notice_block_properties_constants + object_events_constants + object_params_constants + other_constants + privileges_constants + pseudoreference_code_constants + requisite_ISBCertificateType_values_constants + requisite_ISBEDocStorageType_values_constants + requisite_compType2_values_constants + requisite_name_constants + result_constants + rule_identification_constants + script_block_properties_constants + subtask_block_properties_constants + system_component_constants + system_dialogs_constants + system_reference_names_constants + table_name_constants + test_constants + using_the_dialog_windows_constants + using_the_document_constants + using_the_EA_and_encryption_constants + using_the_ISBL_editor_constants + wait_block_properties_constants + sysres_common_constants;
    // enum TAccountType
    var TAccountType = "atUser atGroup atRole ";
    // enum TActionEnabledMode
    var TActionEnabledMode = "aemEnabledAlways aemDisabledAlways aemEnabledOnBrowse aemEnabledOnEdit aemDisabledOnBrowseEmpty ";
    // enum TAddPosition
    var TAddPosition = "apBegin apEnd ";
    // enum TAlignment
    var TAlignment = "alLeft alRight ";
    // enum TAreaShowMode
    var TAreaShowMode = "asmNever asmNoButCustomize asmAsLastTime asmYesButCustomize asmAlways ";
    // enum TCertificateInvalidationReason
    var TCertificateInvalidationReason = "cirCommon cirRevoked ";
    // enum TCertificateType
    var TCertificateType = "ctSignature ctEncode ctSignatureEncode ";
    // enum TCheckListBoxItemState
    var TCheckListBoxItemState = "clbUnchecked clbChecked clbGrayed ";
    // enum TCloseOnEsc
    var TCloseOnEsc = "ceISB ceAlways ceNever ";
    // enum TCompType
    var TCompType = "ctDocument ctReference ctScript ctUnknown ctReport ctDialog ctFunction ctFolder ctEDocument ctTask ctJob ctNotice ctControlJob ";
    // enum TConditionFormat
    var TConditionFormat = "cfInternal cfDisplay ";
    // enum TConnectionIntent
    var TConnectionIntent = "ciUnspecified ciWrite ciRead ";
    // enum TContentKind
    var TContentKind = "ckFolder ckEDocument ckTask ckJob ckComponentToken ckAny ckReference ckScript ckReport ckDialog ";
    // enum TControlType
    var TControlType = "ctISBLEditor ctBevel ctButton ctCheckListBox ctComboBox ctComboEdit ctGrid ctDBCheckBox ctDBComboBox ctDBEdit ctDBEllipsis ctDBMemo ctDBNavigator ctDBRadioGroup ctDBStatusLabel ctEdit ctGroupBox ctInplaceHint ctMemo ctPanel ctListBox ctRadioButton ctRichEdit ctTabSheet ctWebBrowser ctImage ctHyperLink ctLabel ctDBMultiEllipsis ctRibbon ctRichView ctInnerPanel ctPanelGroup ctBitButton ";
    // enum TCriterionContentType
    var TCriterionContentType = "cctDate cctInteger cctNumeric cctPick cctReference cctString cctText ";
    // enum TCultureType
    var TCultureType = "cltInternal cltPrimary cltGUI ";
    // enum TDataSetEventType
    var TDataSetEventType = "dseBeforeOpen dseAfterOpen dseBeforeClose dseAfterClose dseOnValidDelete dseBeforeDelete dseAfterDelete dseAfterDeleteOutOfTransaction dseOnDeleteError dseBeforeInsert dseAfterInsert dseOnValidUpdate dseBeforeUpdate dseOnUpdateRatifiedRecord dseAfterUpdate dseAfterUpdateOutOfTransaction dseOnUpdateError dseAfterScroll dseOnOpenRecord dseOnCloseRecord dseBeforeCancel dseAfterCancel dseOnUpdateDeadlockError dseBeforeDetailUpdate dseOnPrepareUpdate dseOnAnyRequisiteChange ";
    // enum TDataSetState
    var TDataSetState = "dssEdit dssInsert dssBrowse dssInActive ";
    // enum TDateFormatType
    var TDateFormatType = "dftDate dftShortDate dftDateTime dftTimeStamp ";
    // enum TDateOffsetType
    var TDateOffsetType = "dotDays dotHours dotMinutes dotSeconds ";
    // enum TDateTimeKind
    var TDateTimeKind = "dtkndLocal dtkndUTC ";
    // enum TDeaAccessRights
    var TDeaAccessRights = "arNone arView arEdit arFull ";
    // enum TDocumentDefaultAction
    var TDocumentDefaultAction = "ddaView ddaEdit ";
    // enum TEditMode
    var TEditMode = "emLock emEdit emSign emExportWithLock emImportWithUnlock emChangeVersionNote emOpenForModify emChangeLifeStage emDelete emCreateVersion emImport emUnlockExportedWithLock emStart emAbort emReInit emMarkAsReaded emMarkAsUnreaded emPerform emAccept emResume emChangeRights emEditRoute emEditObserver emRecoveryFromLocalCopy emChangeWorkAccessType emChangeEncodeTypeToCertificate emChangeEncodeTypeToPassword emChangeEncodeTypeToNone emChangeEncodeTypeToCertificatePassword emChangeStandardRoute emGetText emOpenForView emMoveToStorage emCreateObject emChangeVersionHidden emDeleteVersion emChangeLifeCycleStage emApprovingSign emExport emContinue emLockFromEdit emUnLockForEdit emLockForServer emUnlockFromServer emDelegateAccessRights emReEncode ";
    // enum TEditorCloseObservType
    var TEditorCloseObservType = "ecotFile ecotProcess ";
    // enum TEdmsApplicationAction
    var TEdmsApplicationAction = "eaGet eaCopy eaCreate eaCreateStandardRoute ";
    // enum TEDocumentLockType
    var TEDocumentLockType = "edltAll edltNothing edltQuery ";
    // enum TEDocumentStepShowMode
    var TEDocumentStepShowMode = "essmText essmCard ";
    // enum TEDocumentStepVersionType
    var TEDocumentStepVersionType = "esvtLast esvtLastActive esvtSpecified ";
    // enum TEDocumentStorageFunction
    var TEDocumentStorageFunction = "edsfExecutive edsfArchive ";
    // enum TEDocumentStorageType
    var TEDocumentStorageType = "edstSQLServer edstFile ";
    // enum TEDocumentVersionSourceType
    var TEDocumentVersionSourceType = "edvstNone edvstEDocumentVersionCopy edvstFile edvstTemplate edvstScannedFile ";
    // enum TEDocumentVersionState
    var TEDocumentVersionState = "vsDefault vsDesign vsActive vsObsolete ";
    // enum TEncodeType
    var TEncodeType = "etNone etCertificate etPassword etCertificatePassword ";
    // enum TExceptionCategory
    var TExceptionCategory = "ecException ecWarning ecInformation ";
    // enum TExportedSignaturesType
    var TExportedSignaturesType = "estAll estApprovingOnly ";
    // enum TExportedVersionType
    var TExportedVersionType = "evtLast evtLastActive evtQuery ";
    // enum TFieldDataType
    var TFieldDataType = "fdtString fdtNumeric fdtInteger fdtDate fdtText fdtUnknown fdtWideString fdtLargeInteger ";
    // enum TFolderType
    var TFolderType = "ftInbox ftOutbox ftFavorites ftCommonFolder ftUserFolder ftComponents ftQuickLaunch ftShortcuts ftSearch ";
    // enum TGridRowHeight
    var TGridRowHeight = "grhAuto grhX1 grhX2 grhX3 ";
    // enum THyperlinkType
    var THyperlinkType = "hltText hltRTF hltHTML ";
    // enum TImageFileFormat
    var TImageFileFormat = "iffBMP iffJPEG iffMultiPageTIFF iffSinglePageTIFF iffTIFF iffPNG ";
    // enum TImageMode
    var TImageMode = "im8bGrayscale im24bRGB im1bMonochrome ";
    // enum TImageType
    var TImageType = "itBMP itJPEG itWMF itPNG ";
    // enum TInplaceHintKind
    var TInplaceHintKind = "ikhInformation ikhWarning ikhError ikhNoIcon ";
    // enum TISBLContext
    var TISBLContext = "icUnknown icScript icFunction icIntegratedReport icAnalyticReport icDataSetEventHandler icActionHandler icFormEventHandler icLookUpEventHandler icRequisiteChangeEventHandler icBeforeSearchEventHandler icRoleCalculation icSelectRouteEventHandler icBlockPropertyCalculation icBlockQueryParamsEventHandler icChangeSearchResultEventHandler icBlockEventHandler icSubTaskInitEventHandler icEDocDataSetEventHandler icEDocLookUpEventHandler icEDocActionHandler icEDocFormEventHandler icEDocRequisiteChangeEventHandler icStructuredConversionRule icStructuredConversionEventBefore icStructuredConversionEventAfter icWizardEventHandler icWizardFinishEventHandler icWizardStepEventHandler icWizardStepFinishEventHandler icWizardActionEnableEventHandler icWizardActionExecuteEventHandler icCreateJobsHandler icCreateNoticesHandler icBeforeLookUpEventHandler icAfterLookUpEventHandler icTaskAbortEventHandler icWorkflowBlockActionHandler icDialogDataSetEventHandler icDialogActionHandler icDialogLookUpEventHandler icDialogRequisiteChangeEventHandler icDialogFormEventHandler icDialogValidCloseEventHandler icBlockFormEventHandler icTaskFormEventHandler icReferenceMethod icEDocMethod icDialogMethod icProcessMessageHandler ";
    // enum TItemShow
    var TItemShow = "isShow isHide isByUserSettings ";
    // enum TJobKind
    var TJobKind = "jkJob jkNotice jkControlJob ";
    // enum TJoinType
    var TJoinType = "jtInner jtLeft jtRight jtFull jtCross ";
    // enum TLabelPos
    var TLabelPos = "lbpAbove lbpBelow lbpLeft lbpRight ";
    // enum TLicensingType
    var TLicensingType = "eltPerConnection eltPerUser ";
    // enum TLifeCycleStageFontColor
    var TLifeCycleStageFontColor = "sfcUndefined sfcBlack sfcGreen sfcRed sfcBlue sfcOrange sfcLilac ";
    // enum TLifeCycleStageFontStyle
    var TLifeCycleStageFontStyle = "sfsItalic sfsStrikeout sfsNormal ";
    // enum TLockableDevelopmentComponentType
    var TLockableDevelopmentComponentType = "ldctStandardRoute ldctWizard ldctScript ldctFunction ldctRouteBlock ldctIntegratedReport ldctAnalyticReport ldctReferenceType ldctEDocumentType ldctDialog ldctServerEvents ";
    // enum TMaxRecordCountRestrictionType
    var TMaxRecordCountRestrictionType = "mrcrtNone mrcrtUser mrcrtMaximal mrcrtCustom ";
    // enum TRangeValueType
    var TRangeValueType = "vtEqual vtGreaterOrEqual vtLessOrEqual vtRange ";
    // enum TRelativeDate
    var TRelativeDate = "rdYesterday rdToday rdTomorrow rdThisWeek rdThisMonth rdThisYear rdNextMonth rdNextWeek rdLastWeek rdLastMonth ";
    // enum TReportDestination
    var TReportDestination = "rdWindow rdFile rdPrinter ";
    // enum TReqDataType
    var TReqDataType = "rdtString rdtNumeric rdtInteger rdtDate rdtReference rdtAccount rdtText rdtPick rdtUnknown rdtLargeInteger rdtDocument ";
    // enum TRequisiteEventType
    var TRequisiteEventType = "reOnChange reOnChangeValues ";
    // enum TSBTimeType
    var TSBTimeType = "ttGlobal ttLocal ttUser ttSystem ";
    // enum TSearchShowMode
    var TSearchShowMode = "ssmBrowse ssmSelect ssmMultiSelect ssmBrowseModal ";
    // enum TSelectMode
    var TSelectMode = "smSelect smLike smCard ";
    // enum TSignatureType
    var TSignatureType = "stNone stAuthenticating stApproving ";
    // enum TSignerContentType
    var TSignerContentType = "sctString sctStream ";
    // enum TStringsSortType
    var TStringsSortType = "sstAnsiSort sstNaturalSort ";
    // enum TStringValueType
    var TStringValueType = "svtEqual svtContain ";
    // enum TStructuredObjectAttributeType
    var TStructuredObjectAttributeType = "soatString soatNumeric soatInteger soatDatetime soatReferenceRecord soatText soatPick soatBoolean soatEDocument soatAccount soatIntegerCollection soatNumericCollection soatStringCollection soatPickCollection soatDatetimeCollection soatBooleanCollection soatReferenceRecordCollection soatEDocumentCollection soatAccountCollection soatContents soatUnknown ";
    // enum TTaskAbortReason
    var TTaskAbortReason = "tarAbortByUser tarAbortByWorkflowException ";
    // enum TTextValueType
    var TTextValueType = "tvtAllWords tvtExactPhrase tvtAnyWord ";
    // enum TUserObjectStatus
    var TUserObjectStatus = "usNone usCompleted usRedSquare usBlueSquare usYellowSquare usGreenSquare usOrangeSquare usPurpleSquare usFollowUp ";
    // enum TUserType
    var TUserType = "utUnknown utUser utDeveloper utAdministrator utSystemDeveloper utDisconnected ";
    // enum TValuesBuildType
    var TValuesBuildType = "btAnd btDetailAnd btOr btNotOr btOnly ";
    // enum TViewMode
    var TViewMode = "vmView vmSelect vmNavigation ";
    // enum TViewSelectionMode
    var TViewSelectionMode = "vsmSingle vsmMultiple vsmMultipleCheck vsmNoSelection ";
    // enum TWizardActionType
    var TWizardActionType = "wfatPrevious wfatNext wfatCancel wfatFinish ";
    // enum TWizardFormElementProperty
    var TWizardFormElementProperty = "wfepUndefined wfepText3 wfepText6 wfepText9 wfepSpinEdit wfepDropDown wfepRadioGroup wfepFlag wfepText12 wfepText15 wfepText18 wfepText21 wfepText24 wfepText27 wfepText30 wfepRadioGroupColumn1 wfepRadioGroupColumn2 wfepRadioGroupColumn3 ";
    // enum TWizardFormElementType
    var TWizardFormElementType = "wfetQueryParameter wfetText wfetDelimiter wfetLabel ";
    // enum TWizardParamType
    var TWizardParamType = "wptString wptInteger wptNumeric wptBoolean wptDateTime wptPick wptText wptUser wptUserList wptEDocumentInfo wptEDocumentInfoList wptReferenceRecordInfo wptReferenceRecordInfoList wptFolderInfo wptTaskInfo wptContents wptFileName wptDate ";
    // enum TWizardStepResult
    var TWizardStepResult = "wsrComplete wsrGoNext wsrGoPrevious wsrCustom wsrCancel wsrGoFinal ";
    // enum TWizardStepType
    var TWizardStepType = "wstForm wstEDocument wstTaskCard wstReferenceRecordCard wstFinal ";
    // enum TWorkAccessType
    var TWorkAccessType = "waAll waPerformers waManual ";
    // enum TWorkflowBlockType
    var TWorkflowBlockType = "wsbStart wsbFinish wsbNotice wsbStep wsbDecision wsbWait wsbMonitor wsbScript wsbConnector wsbSubTask wsbLifeCycleStage wsbPause ";
    // enum TWorkflowDataType
    var TWorkflowDataType = "wdtInteger wdtFloat wdtString wdtPick wdtDateTime wdtBoolean wdtTask wdtJob wdtFolder wdtEDocument wdtReferenceRecord wdtUser wdtGroup wdtRole wdtIntegerCollection wdtFloatCollection wdtStringCollection wdtPickCollection wdtDateTimeCollection wdtBooleanCollection wdtTaskCollection wdtJobCollection wdtFolderCollection wdtEDocumentCollection wdtReferenceRecordCollection wdtUserCollection wdtGroupCollection wdtRoleCollection wdtContents wdtUserList wdtSearchDescription wdtDeadLine wdtPickSet wdtAccountCollection ";
    // enum TWorkImportance
    var TWorkImportance = "wiLow wiNormal wiHigh ";
    // enum TWorkRouteType
    var TWorkRouteType = "wrtSoft wrtHard ";
    // enum TWorkState
    var TWorkState = "wsInit wsRunning wsDone wsControlled wsAborted wsContinued ";
    // enum TWorkTextBuildingMode
    var TWorkTextBuildingMode = "wtmFull wtmFromCurrent wtmOnlyCurrent ";
    // Перечисления
    var ENUMS = TAccountType + TActionEnabledMode + TAddPosition + TAlignment + TAreaShowMode + TCertificateInvalidationReason + TCertificateType + TCheckListBoxItemState + TCloseOnEsc + TCompType + TConditionFormat + TConnectionIntent + TContentKind + TControlType + TCriterionContentType + TCultureType + TDataSetEventType + TDataSetState + TDateFormatType + TDateOffsetType + TDateTimeKind + TDeaAccessRights + TDocumentDefaultAction + TEditMode + TEditorCloseObservType + TEdmsApplicationAction + TEDocumentLockType + TEDocumentStepShowMode + TEDocumentStepVersionType + TEDocumentStorageFunction + TEDocumentStorageType + TEDocumentVersionSourceType + TEDocumentVersionState + TEncodeType + TExceptionCategory + TExportedSignaturesType + TExportedVersionType + TFieldDataType + TFolderType + TGridRowHeight + THyperlinkType + TImageFileFormat + TImageMode + TImageType + TInplaceHintKind + TISBLContext + TItemShow + TJobKind + TJoinType + TLabelPos + TLicensingType + TLifeCycleStageFontColor + TLifeCycleStageFontStyle + TLockableDevelopmentComponentType + TMaxRecordCountRestrictionType + TRangeValueType + TRelativeDate + TReportDestination + TReqDataType + TRequisiteEventType + TSBTimeType + TSearchShowMode + TSelectMode + TSignatureType + TSignerContentType + TStringsSortType + TStringValueType + TStructuredObjectAttributeType + TTaskAbortReason + TTextValueType + TUserObjectStatus + TUserType + TValuesBuildType + TViewMode + TViewSelectionMode + TWizardActionType + TWizardFormElementProperty + TWizardFormElementType + TWizardParamType + TWizardStepResult + TWizardStepType + TWorkAccessType + TWorkflowBlockType + TWorkflowDataType + TWorkImportance + TWorkRouteType + TWorkState + TWorkTextBuildingMode;
    // Системные функции ==> SYSFUNCTIONS
    var system_functions = "AddSubString AdjustLineBreaks AmountInWords Analysis ArrayDimCount ArrayHighBound ArrayLowBound ArrayOf ArrayReDim Assert Assigned BeginOfMonth BeginOfPeriod BuildProfilingOperationAnalysis CallProcedure CanReadFile CArrayElement CDataSetRequisite ChangeDate ChangeReferenceDataset Char CharPos CheckParam CheckParamValue CompareStrings ConstantExists ControlState ConvertDateStr Copy CopyFile CreateArray CreateCachedReference CreateConnection CreateDialog CreateDualListDialog CreateEditor CreateException CreateFile CreateFolderDialog CreateInputDialog CreateLinkFile CreateList CreateLock CreateMemoryDataSet CreateObject CreateOpenDialog CreateProgress CreateQuery CreateReference CreateReport CreateSaveDialog CreateScript CreateSQLPivotFunction CreateStringList CreateTreeListSelectDialog CSelectSQL CSQL CSubString CurrentUserID CurrentUserName CurrentVersion DataSetLocateEx DateDiff DateTimeDiff DateToStr DayOfWeek DeleteFile DirectoryExists DisableCheckAccessRights DisableCheckFullShowingRestriction DisableMassTaskSendingRestrictions DropTable DupeString EditText EnableCheckAccessRights EnableCheckFullShowingRestriction EnableMassTaskSendingRestrictions EndOfMonth EndOfPeriod ExceptionExists ExceptionsOff ExceptionsOn Execute ExecuteProcess Exit ExpandEnvironmentVariables ExtractFileDrive ExtractFileExt ExtractFileName ExtractFilePath ExtractParams FileExists FileSize FindFile FindSubString FirmContext ForceDirectories Format FormatDate FormatNumeric FormatSQLDate FormatString FreeException GetComponent GetComponentLaunchParam GetConstant GetLastException GetReferenceRecord GetRefTypeByRefID GetTableID GetTempFolder IfThen In IndexOf InputDialog InputDialogEx InteractiveMode IsFileLocked IsGraphicFile IsNumeric Length LoadString LoadStringFmt LocalTimeToUTC LowerCase Max MessageBox MessageBoxEx MimeDecodeBinary MimeDecodeString MimeEncodeBinary MimeEncodeString Min MoneyInWords MoveFile NewID Now OpenFile Ord Precision Raise ReadCertificateFromFile ReadFile ReferenceCodeByID ReferenceNumber ReferenceRequisiteMode ReferenceRequisiteValue RegionDateSettings RegionNumberSettings RegionTimeSettings RegRead RegWrite RenameFile Replace Round SelectServerCode SelectSQL ServerDateTime SetConstant SetManagedFolderFieldsState ShowConstantsInputDialog ShowMessage Sleep Split SQL SQL2XLSTAB SQLProfilingSendReport StrToDate SubString SubStringCount SystemSetting Time TimeDiff Today Transliterate Trim UpperCase UserStatus UTCToLocalTime ValidateXML VarIsClear VarIsEmpty VarIsNull WorkTimeDiff WriteFile WriteFileEx WriteObjectHistory \u0410\u043D\u0430\u043B\u0438\u0437 \u0411\u0430\u0437\u0430\u0414\u0430\u043D\u043D\u044B\u0445 \u0411\u043B\u043E\u043A\u0415\u0441\u0442\u044C \u0411\u043B\u043E\u043A\u0415\u0441\u0442\u044C\u0420\u0430\u0441\u0448 \u0411\u043B\u043E\u043A\u0418\u043D\u0444\u043E \u0411\u043B\u043E\u043A\u0421\u043D\u044F\u0442\u044C \u0411\u043B\u043E\u043A\u0421\u043D\u044F\u0442\u044C\u0420\u0430\u0441\u0448 \u0411\u043B\u043E\u043A\u0423\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C \u0412\u0432\u043E\u0434 \u0412\u0432\u043E\u0434\u041C\u0435\u043D\u044E \u0412\u0435\u0434\u0421 \u0412\u0435\u0434\u0421\u043F\u0440 \u0412\u0435\u0440\u0445\u043D\u044F\u044F\u0413\u0440\u0430\u043D\u0438\u0446\u0430\u041C\u0430\u0441\u0441\u0438\u0432\u0430 \u0412\u043D\u0435\u0448\u041F\u0440\u043E\u0433\u0440 \u0412\u043E\u0441\u0441\u0442 \u0412\u0440\u0435\u043C\u0435\u043D\u043D\u0430\u044F\u041F\u0430\u043F\u043A\u0430 \u0412\u0440\u0435\u043C\u044F \u0412\u044B\u0431\u043E\u0440SQL \u0412\u044B\u0431\u0440\u0430\u0442\u044C\u0417\u0430\u043F\u0438\u0441\u044C \u0412\u044B\u0434\u0435\u043B\u0438\u0442\u044C\u0421\u0442\u0440 \u0412\u044B\u0437\u0432\u0430\u0442\u044C \u0412\u044B\u043F\u043E\u043B\u043D\u0438\u0442\u044C \u0412\u044B\u043F\u041F\u0440\u043E\u0433\u0440 \u0413\u0440\u0430\u0444\u0438\u0447\u0435\u0441\u043A\u0438\u0439\u0424\u0430\u0439\u043B \u0413\u0440\u0443\u043F\u043F\u0430\u0414\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0414\u0430\u0442\u0430\u0412\u0440\u0435\u043C\u044F\u0421\u0435\u0440\u0432 \u0414\u0435\u043D\u044C\u041D\u0435\u0434\u0435\u043B\u0438 \u0414\u0438\u0430\u043B\u043E\u0433\u0414\u0430\u041D\u0435\u0442 \u0414\u043B\u0438\u043D\u0430\u0421\u0442\u0440 \u0414\u043E\u0431\u041F\u043E\u0434\u0441\u0442\u0440 \u0415\u041F\u0443\u0441\u0442\u043E \u0415\u0441\u043B\u0438\u0422\u043E \u0415\u0427\u0438\u0441\u043B\u043E \u0417\u0430\u043C\u041F\u043E\u0434\u0441\u0442\u0440 \u0417\u0430\u043F\u0438\u0441\u044C\u0421\u043F\u0440\u0430\u0432\u043E\u0447\u043D\u0438\u043A\u0430 \u0417\u043D\u0430\u0447\u041F\u043E\u043B\u044F\u0421\u043F\u0440 \u0418\u0414\u0422\u0438\u043F\u0421\u043F\u0440 \u0418\u0437\u0432\u043B\u0435\u0447\u044C\u0414\u0438\u0441\u043A \u0418\u0437\u0432\u043B\u0435\u0447\u044C\u0418\u043C\u044F\u0424\u0430\u0439\u043B\u0430 \u0418\u0437\u0432\u043B\u0435\u0447\u044C\u041F\u0443\u0442\u044C \u0418\u0437\u0432\u043B\u0435\u0447\u044C\u0420\u0430\u0441\u0448\u0438\u0440\u0435\u043D\u0438\u0435 \u0418\u0437\u043C\u0414\u0430\u0442 \u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C\u0420\u0430\u0437\u043C\u0435\u0440\u041C\u0430\u0441\u0441\u0438\u0432\u0430 \u0418\u0437\u043C\u0435\u0440\u0435\u043D\u0438\u0439\u041C\u0430\u0441\u0441\u0438\u0432\u0430 \u0418\u043C\u044F\u041E\u0440\u0433 \u0418\u043C\u044F\u041F\u043E\u043B\u044F\u0421\u043F\u0440 \u0418\u043D\u0434\u0435\u043A\u0441 \u0418\u043D\u0434\u0438\u043A\u0430\u0442\u043E\u0440\u0417\u0430\u043A\u0440\u044B\u0442\u044C \u0418\u043D\u0434\u0438\u043A\u0430\u0442\u043E\u0440\u041E\u0442\u043A\u0440\u044B\u0442\u044C \u0418\u043D\u0434\u0438\u043A\u0430\u0442\u043E\u0440\u0428\u0430\u0433 \u0418\u043D\u0442\u0435\u0440\u0430\u043A\u0442\u0438\u0432\u043D\u044B\u0439\u0420\u0435\u0436\u0438\u043C \u0418\u0442\u043E\u0433\u0422\u0431\u043B\u0421\u043F\u0440 \u041A\u043E\u0434\u0412\u0438\u0434\u0412\u0435\u0434\u0421\u043F\u0440 \u041A\u043E\u0434\u0412\u0438\u0434\u0421\u043F\u0440\u041F\u043E\u0418\u0414 \u041A\u043E\u0434\u041F\u043EAnalit \u041A\u043E\u0434\u0421\u0438\u043C\u0432\u043E\u043B\u0430 \u041A\u043E\u0434\u0421\u043F\u0440 \u041A\u043E\u043B\u041F\u043E\u0434\u0441\u0442\u0440 \u041A\u043E\u043B\u041F\u0440\u043E\u043F \u041A\u043E\u043D\u041C\u0435\u0441 \u041A\u043E\u043D\u0441\u0442 \u041A\u043E\u043D\u0441\u0442\u0415\u0441\u0442\u044C \u041A\u043E\u043D\u0441\u0442\u0417\u043D\u0430\u0447 \u041A\u043E\u043D\u0422\u0440\u0430\u043D \u041A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C\u0424\u0430\u0439\u043B \u041A\u043E\u043F\u0438\u044F\u0421\u0442\u0440 \u041A\u041F\u0435\u0440\u0438\u043E\u0434 \u041A\u0421\u0442\u0440\u0422\u0431\u043B\u0421\u043F\u0440 \u041C\u0430\u043A\u0441 \u041C\u0430\u043A\u0441\u0421\u0442\u0440\u0422\u0431\u043B\u0421\u043F\u0440 \u041C\u0430\u0441\u0441\u0438\u0432 \u041C\u0435\u043D\u044E \u041C\u0435\u043D\u044E\u0420\u0430\u0441\u0448 \u041C\u0438\u043D \u041D\u0430\u0431\u043E\u0440\u0414\u0430\u043D\u043D\u044B\u0445\u041D\u0430\u0439\u0442\u0438\u0420\u0430\u0441\u0448 \u041D\u0430\u0438\u043C\u0412\u0438\u0434\u0421\u043F\u0440 \u041D\u0430\u0438\u043C\u041F\u043EAnalit \u041D\u0430\u0438\u043C\u0421\u043F\u0440 \u041D\u0430\u0441\u0442\u0440\u043E\u0438\u0442\u044C\u041F\u0435\u0440\u0435\u0432\u043E\u0434\u044B\u0421\u0442\u0440\u043E\u043A \u041D\u0430\u0447\u041C\u0435\u0441 \u041D\u0430\u0447\u0422\u0440\u0430\u043D \u041D\u0438\u0436\u043D\u044F\u044F\u0413\u0440\u0430\u043D\u0438\u0446\u0430\u041C\u0430\u0441\u0441\u0438\u0432\u0430 \u041D\u043E\u043C\u0435\u0440\u0421\u043F\u0440 \u041D\u041F\u0435\u0440\u0438\u043E\u0434 \u041E\u043A\u043D\u043E \u041E\u043A\u0440 \u041E\u043A\u0440\u0443\u0436\u0435\u043D\u0438\u0435 \u041E\u0442\u043B\u0418\u043D\u0444\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u041E\u0442\u043B\u0418\u043D\u0444\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u041E\u0442\u0447\u0435\u0442 \u041E\u0442\u0447\u0435\u0442\u0410\u043D\u0430\u043B \u041E\u0442\u0447\u0435\u0442\u0418\u043D\u0442 \u041F\u0430\u043F\u043A\u0430\u0421\u0443\u0449\u0435\u0441\u0442\u0432\u0443\u0435\u0442 \u041F\u0430\u0443\u0437\u0430 \u041F\u0412\u044B\u0431\u043E\u0440SQL \u041F\u0435\u0440\u0435\u0438\u043C\u0435\u043D\u043E\u0432\u0430\u0442\u044C\u0424\u0430\u0439\u043B \u041F\u0435\u0440\u0435\u043C\u0435\u043D\u043D\u044B\u0435 \u041F\u0435\u0440\u0435\u043C\u0435\u0441\u0442\u0438\u0442\u044C\u0424\u0430\u0439\u043B \u041F\u043E\u0434\u0441\u0442\u0440 \u041F\u043E\u0438\u0441\u043A\u041F\u043E\u0434\u0441\u0442\u0440 \u041F\u043E\u0438\u0441\u043A\u0421\u0442\u0440 \u041F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u0418\u0414\u0422\u0430\u0431\u043B\u0438\u0446\u044B \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C\u0414\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C\u0418\u0414 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C\u0418\u043C\u044F \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C\u0421\u0442\u0430\u0442\u0443\u0441 \u041F\u0440\u0435\u0440\u0432\u0430\u0442\u044C \u041F\u0440\u043E\u0432\u0435\u0440\u0438\u0442\u044C\u041F\u0430\u0440\u0430\u043C\u0435\u0442\u0440 \u041F\u0440\u043E\u0432\u0435\u0440\u0438\u0442\u044C\u041F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u0417\u043D\u0430\u0447 \u041F\u0440\u043E\u0432\u0435\u0440\u0438\u0442\u044C\u0423\u0441\u043B\u043E\u0432\u0438\u0435 \u0420\u0430\u0437\u0431\u0421\u0442\u0440 \u0420\u0430\u0437\u043D\u0412\u0440\u0435\u043C\u044F \u0420\u0430\u0437\u043D\u0414\u0430\u0442 \u0420\u0430\u0437\u043D\u0414\u0430\u0442\u0430\u0412\u0440\u0435\u043C\u044F \u0420\u0430\u0437\u043D\u0420\u0430\u0431\u0412\u0440\u0435\u043C\u044F \u0420\u0435\u0433\u0423\u0441\u0442\u0412\u0440\u0435\u043C \u0420\u0435\u0433\u0423\u0441\u0442\u0414\u0430\u0442 \u0420\u0435\u0433\u0423\u0441\u0442\u0427\u0441\u043B \u0420\u0435\u0434\u0422\u0435\u043A\u0441\u0442 \u0420\u0435\u0435\u0441\u0442\u0440\u0417\u0430\u043F\u0438\u0441\u044C \u0420\u0435\u0435\u0441\u0442\u0440\u0421\u043F\u0438\u0441\u043E\u043A\u0418\u043C\u0435\u043D\u041F\u0430\u0440\u0430\u043C \u0420\u0435\u0435\u0441\u0442\u0440\u0427\u0442\u0435\u043D\u0438\u0435 \u0420\u0435\u043A\u0432\u0421\u043F\u0440 \u0420\u0435\u043A\u0432\u0421\u043F\u0440\u041F\u0440 \u0421\u0435\u0433\u043E\u0434\u043D\u044F \u0421\u0435\u0439\u0447\u0430\u0441 \u0421\u0435\u0440\u0432\u0435\u0440 \u0421\u0435\u0440\u0432\u0435\u0440\u041F\u0440\u043E\u0446\u0435\u0441\u0441\u0418\u0414 \u0421\u0435\u0440\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u0424\u0430\u0439\u043B\u0421\u0447\u0438\u0442\u0430\u0442\u044C \u0421\u0436\u041F\u0440\u043E\u0431 \u0421\u0438\u043C\u0432\u043E\u043B \u0421\u0438\u0441\u0442\u0435\u043C\u0430\u0414\u0438\u0440\u0435\u043A\u0442\u0443\u043C\u041A\u043E\u0434 \u0421\u0438\u0441\u0442\u0435\u043C\u0430\u0418\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F \u0421\u0438\u0441\u0442\u0435\u043C\u0430\u041A\u043E\u0434 \u0421\u043E\u0434\u0435\u0440\u0436\u0438\u0442 \u0421\u043E\u0435\u0434\u0438\u043D\u0435\u043D\u0438\u0435\u0417\u0430\u043A\u0440\u044B\u0442\u044C \u0421\u043E\u0435\u0434\u0438\u043D\u0435\u043D\u0438\u0435\u041E\u0442\u043A\u0440\u044B\u0442\u044C \u0421\u043E\u0437\u0434\u0430\u0442\u044C\u0414\u0438\u0430\u043B\u043E\u0433 \u0421\u043E\u0437\u0434\u0430\u0442\u044C\u0414\u0438\u0430\u043B\u043E\u0433\u0412\u044B\u0431\u043E\u0440\u0430\u0418\u0437\u0414\u0432\u0443\u0445\u0421\u043F\u0438\u0441\u043A\u043E\u0432 \u0421\u043E\u0437\u0434\u0430\u0442\u044C\u0414\u0438\u0430\u043B\u043E\u0433\u0412\u044B\u0431\u043E\u0440\u0430\u041F\u0430\u043F\u043A\u0438 \u0421\u043E\u0437\u0434\u0430\u0442\u044C\u0414\u0438\u0430\u043B\u043E\u0433\u041E\u0442\u043A\u0440\u044B\u0442\u0438\u044F\u0424\u0430\u0439\u043B\u0430 \u0421\u043E\u0437\u0434\u0430\u0442\u044C\u0414\u0438\u0430\u043B\u043E\u0433\u0421\u043E\u0445\u0440\u0430\u043D\u0435\u043D\u0438\u044F\u0424\u0430\u0439\u043B\u0430 \u0421\u043E\u0437\u0434\u0430\u0442\u044C\u0417\u0430\u043F\u0440\u043E\u0441 \u0421\u043E\u0437\u0434\u0430\u0442\u044C\u0418\u043D\u0434\u0438\u043A\u0430\u0442\u043E\u0440 \u0421\u043E\u0437\u0434\u0430\u0442\u044C\u0418\u0441\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0435 \u0421\u043E\u0437\u0434\u0430\u0442\u044C\u041A\u044D\u0448\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u0439\u0421\u043F\u0440\u0430\u0432\u043E\u0447\u043D\u0438\u043A \u0421\u043E\u0437\u0434\u0430\u0442\u044C\u041C\u0430\u0441\u0441\u0438\u0432 \u0421\u043E\u0437\u0434\u0430\u0442\u044C\u041D\u0430\u0431\u043E\u0440\u0414\u0430\u043D\u043D\u044B\u0445 \u0421\u043E\u0437\u0434\u0430\u0442\u044C\u041E\u0431\u044A\u0435\u043A\u0442 \u0421\u043E\u0437\u0434\u0430\u0442\u044C\u041E\u0442\u0447\u0435\u0442 \u0421\u043E\u0437\u0434\u0430\u0442\u044C\u041F\u0430\u043F\u043A\u0443 \u0421\u043E\u0437\u0434\u0430\u0442\u044C\u0420\u0435\u0434\u0430\u043A\u0442\u043E\u0440 \u0421\u043E\u0437\u0434\u0430\u0442\u044C\u0421\u043E\u0435\u0434\u0438\u043D\u0435\u043D\u0438\u0435 \u0421\u043E\u0437\u0434\u0430\u0442\u044C\u0421\u043F\u0438\u0441\u043E\u043A \u0421\u043E\u0437\u0434\u0430\u0442\u044C\u0421\u043F\u0438\u0441\u043E\u043A\u0421\u0442\u0440\u043E\u043A \u0421\u043E\u0437\u0434\u0430\u0442\u044C\u0421\u043F\u0440\u0430\u0432\u043E\u0447\u043D\u0438\u043A \u0421\u043E\u0437\u0434\u0430\u0442\u044C\u0421\u0446\u0435\u043D\u0430\u0440\u0438\u0439 \u0421\u043E\u0437\u0434\u0421\u043F\u0440 \u0421\u043E\u0441\u0442\u0421\u043F\u0440 \u0421\u043E\u0445\u0440 \u0421\u043E\u0445\u0440\u0421\u043F\u0440 \u0421\u043F\u0438\u0441\u043E\u043A\u0421\u0438\u0441\u0442\u0435\u043C \u0421\u043F\u0440 \u0421\u043F\u0440\u0430\u0432\u043E\u0447\u043D\u0438\u043A \u0421\u043F\u0440\u0411\u043B\u043E\u043A\u0415\u0441\u0442\u044C \u0421\u043F\u0440\u0411\u043B\u043E\u043A\u0421\u043D\u044F\u0442\u044C \u0421\u043F\u0440\u0411\u043B\u043E\u043A\u0421\u043D\u044F\u0442\u044C\u0420\u0430\u0441\u0448 \u0421\u043F\u0440\u0411\u043B\u043E\u043A\u0423\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C \u0421\u043F\u0440\u0418\u0437\u043C\u041D\u0430\u0431\u0414\u0430\u043D \u0421\u043F\u0440\u041A\u043E\u0434 \u0421\u043F\u0440\u041D\u043E\u043C\u0435\u0440 \u0421\u043F\u0440\u041E\u0431\u043D\u043E\u0432\u0438\u0442\u044C \u0421\u043F\u0440\u041E\u0442\u043A\u0440\u044B\u0442\u044C \u0421\u043F\u0440\u041E\u0442\u043C\u0435\u043D\u0438\u0442\u044C \u0421\u043F\u0440\u041F\u0430\u0440\u0430\u043C \u0421\u043F\u0440\u041F\u043E\u043B\u0435\u0417\u043D\u0430\u0447 \u0421\u043F\u0440\u041F\u043E\u043B\u0435\u0418\u043C\u044F \u0421\u043F\u0440\u0420\u0435\u043A\u0432 \u0421\u043F\u0440\u0420\u0435\u043A\u0432\u0412\u0432\u0435\u0434\u0417\u043D \u0421\u043F\u0440\u0420\u0435\u043A\u0432\u041D\u043E\u0432\u044B\u0435 \u0421\u043F\u0440\u0420\u0435\u043A\u0432\u041F\u0440 \u0421\u043F\u0440\u0420\u0435\u043A\u0432\u041F\u0440\u0435\u0434\u0417\u043D \u0421\u043F\u0440\u0420\u0435\u043A\u0432\u0420\u0435\u0436\u0438\u043C \u0421\u043F\u0440\u0420\u0435\u043A\u0432\u0422\u0438\u043F\u0422\u0435\u043A\u0441\u0442 \u0421\u043F\u0440\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u0421\u043F\u0440\u0421\u043E\u0441\u0442 \u0421\u043F\u0440\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C \u0421\u043F\u0440\u0422\u0431\u043B\u0418\u0442\u043E\u0433 \u0421\u043F\u0440\u0422\u0431\u043B\u0421\u0442\u0440 \u0421\u043F\u0440\u0422\u0431\u043B\u0421\u0442\u0440\u041A\u043E\u043B \u0421\u043F\u0440\u0422\u0431\u043B\u0421\u0442\u0440\u041C\u0430\u043A\u0441 \u0421\u043F\u0440\u0422\u0431\u043B\u0421\u0442\u0440\u041C\u0438\u043D \u0421\u043F\u0440\u0422\u0431\u043B\u0421\u0442\u0440\u041F\u0440\u0435\u0434 \u0421\u043F\u0440\u0422\u0431\u043B\u0421\u0442\u0440\u0421\u043B\u0435\u0434 \u0421\u043F\u0440\u0422\u0431\u043B\u0421\u0442\u0440\u0421\u043E\u0437\u0434 \u0421\u043F\u0440\u0422\u0431\u043B\u0421\u0442\u0440\u0423\u0434 \u0421\u043F\u0440\u0422\u0435\u043A\u041F\u0440\u0435\u0434\u0441\u0442 \u0421\u043F\u0440\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C\u0421\u0442\u0440 \u0421\u0442\u0440\u0412\u0435\u0440\u0445\u0420\u0435\u0433\u0438\u0441\u0442\u0440 \u0421\u0442\u0440\u041D\u0438\u0436\u043D\u0420\u0435\u0433\u0438\u0441\u0442\u0440 \u0421\u0442\u0440\u0422\u0431\u043B\u0421\u043F\u0440 \u0421\u0443\u043C\u041F\u0440\u043E\u043F \u0421\u0446\u0435\u043D\u0430\u0440\u0438\u0439 \u0421\u0446\u0435\u043D\u0430\u0440\u0438\u0439\u041F\u0430\u0440\u0430\u043C \u0422\u0435\u043A\u0412\u0435\u0440\u0441\u0438\u044F \u0422\u0435\u043A\u041E\u0440\u0433 \u0422\u043E\u0447\u043D \u0422\u0440\u0430\u043D \u0422\u0440\u0430\u043D\u0441\u043B\u0438\u0442\u0435\u0440\u0430\u0446\u0438\u044F \u0423\u0434\u0430\u043B\u0438\u0442\u044C\u0422\u0430\u0431\u043B\u0438\u0446\u0443 \u0423\u0434\u0430\u043B\u0438\u0442\u044C\u0424\u0430\u0439\u043B \u0423\u0434\u0421\u043F\u0440 \u0423\u0434\u0421\u0442\u0440\u0422\u0431\u043B\u0421\u043F\u0440 \u0423\u0441\u0442 \u0423\u0441\u0442\u0430\u043D\u043E\u0432\u043A\u0438\u041A\u043E\u043D\u0441\u0442\u0430\u043D\u0442 \u0424\u0430\u0439\u043B\u0410\u0442\u0440\u0438\u0431\u0443\u0442\u0421\u0447\u0438\u0442\u0430\u0442\u044C \u0424\u0430\u0439\u043B\u0410\u0442\u0440\u0438\u0431\u0443\u0442\u0423\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C \u0424\u0430\u0439\u043B\u0412\u0440\u0435\u043C\u044F \u0424\u0430\u0439\u043B\u0412\u0440\u0435\u043C\u044F\u0423\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C \u0424\u0430\u0439\u043B\u0412\u044B\u0431\u0440\u0430\u0442\u044C \u0424\u0430\u0439\u043B\u0417\u0430\u043D\u044F\u0442 \u0424\u0430\u0439\u043B\u0417\u0430\u043F\u0438\u0441\u0430\u0442\u044C \u0424\u0430\u0439\u043B\u0418\u0441\u043A\u0430\u0442\u044C \u0424\u0430\u0439\u043B\u041A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0424\u0430\u0439\u043B\u041C\u043E\u0436\u043D\u043E\u0427\u0438\u0442\u0430\u0442\u044C \u0424\u0430\u0439\u043B\u041E\u0442\u043A\u0440\u044B\u0442\u044C \u0424\u0430\u0439\u043B\u041F\u0435\u0440\u0435\u0438\u043C\u0435\u043D\u043E\u0432\u0430\u0442\u044C \u0424\u0430\u0439\u043B\u041F\u0435\u0440\u0435\u043A\u043E\u0434\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0424\u0430\u0439\u043B\u041F\u0435\u0440\u0435\u043C\u0435\u0441\u0442\u0438\u0442\u044C \u0424\u0430\u0439\u043B\u041F\u0440\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0424\u0430\u0439\u043B\u0420\u0430\u0437\u043C\u0435\u0440 \u0424\u0430\u0439\u043B\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u0424\u0430\u0439\u043B\u0421\u0441\u044B\u043B\u043A\u0430\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u0424\u0430\u0439\u043B\u0421\u0443\u0449\u0435\u0441\u0442\u0432\u0443\u0435\u0442 \u0424\u0430\u0439\u043B\u0421\u0447\u0438\u0442\u0430\u0442\u044C \u0424\u0430\u0439\u043B\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u0424\u043C\u0442SQL\u0414\u0430\u0442 \u0424\u043C\u0442\u0414\u0430\u0442 \u0424\u043C\u0442\u0421\u0442\u0440 \u0424\u043C\u0442\u0427\u0441\u043B \u0424\u043E\u0440\u043C\u0430\u0442 \u0426\u041C\u0430\u0441\u0441\u0438\u0432\u042D\u043B\u0435\u043C\u0435\u043D\u0442 \u0426\u041D\u0430\u0431\u043E\u0440\u0414\u0430\u043D\u043D\u044B\u0445\u0420\u0435\u043A\u0432\u0438\u0437\u0438\u0442 \u0426\u041F\u043E\u0434\u0441\u0442\u0440 ";
    // Предопределенные переменные ==> built_in
    var predefined_variables = "AltState Application CallType ComponentTokens CreatedJobs CreatedNotices ControlState DialogResult Dialogs EDocuments EDocumentVersionSource Folders GlobalIDs Job Jobs InputValue LookUpReference LookUpRequisiteNames LookUpSearch Object ParentComponent Processes References Requisite ReportName Reports Result Scripts Searches SelectedAttachments SelectedItems SelectMode Sender ServerEvents ServiceFactory ShiftState SubTask SystemDialogs Tasks Wizard Wizards Work \u0412\u044B\u0437\u043E\u0432\u0421\u043F\u043E\u0441\u043E\u0431 \u0418\u043C\u044F\u041E\u0442\u0447\u0435\u0442\u0430 \u0420\u0435\u043A\u0432\u0417\u043D\u0430\u0447 ";
    // Интерфейсы ==> type
    var interfaces = "IApplication IAccessRights IAccountRepository IAccountSelectionRestrictions IAction IActionList IAdministrationHistoryDescription IAnchors IApplication IArchiveInfo IAttachment IAttachmentList ICheckListBox ICheckPointedList IColumn IComponent IComponentDescription IComponentToken IComponentTokenFactory IComponentTokenInfo ICompRecordInfo IConnection IContents IControl IControlJob IControlJobInfo IControlList ICrypto ICrypto2 ICustomJob ICustomJobInfo ICustomListBox ICustomObjectWizardStep ICustomWork ICustomWorkInfo IDataSet IDataSetAccessInfo IDataSigner IDateCriterion IDateRequisite IDateRequisiteDescription IDateValue IDeaAccessRights IDeaObjectInfo IDevelopmentComponentLock IDialog IDialogFactory IDialogPickRequisiteItems IDialogsFactory IDICSFactory IDocRequisite IDocumentInfo IDualListDialog IECertificate IECertificateInfo IECertificates IEditControl IEditorForm IEdmsExplorer IEdmsObject IEdmsObjectDescription IEdmsObjectFactory IEdmsObjectInfo IEDocument IEDocumentAccessRights IEDocumentDescription IEDocumentEditor IEDocumentFactory IEDocumentInfo IEDocumentStorage IEDocumentVersion IEDocumentVersionListDialog IEDocumentVersionSource IEDocumentWizardStep IEDocVerSignature IEDocVersionState IEnabledMode IEncodeProvider IEncrypter IEvent IEventList IException IExternalEvents IExternalHandler IFactory IField IFileDialog IFolder IFolderDescription IFolderDialog IFolderFactory IFolderInfo IForEach IForm IFormTitle IFormWizardStep IGlobalIDFactory IGlobalIDInfo IGrid IHasher IHistoryDescription IHyperLinkControl IImageButton IImageControl IInnerPanel IInplaceHint IIntegerCriterion IIntegerList IIntegerRequisite IIntegerValue IISBLEditorForm IJob IJobDescription IJobFactory IJobForm IJobInfo ILabelControl ILargeIntegerCriterion ILargeIntegerRequisite ILargeIntegerValue ILicenseInfo ILifeCycleStage IList IListBox ILocalIDInfo ILocalization ILock IMemoryDataSet IMessagingFactory IMetadataRepository INotice INoticeInfo INumericCriterion INumericRequisite INumericValue IObject IObjectDescription IObjectImporter IObjectInfo IObserver IPanelGroup IPickCriterion IPickProperty IPickRequisite IPickRequisiteDescription IPickRequisiteItem IPickRequisiteItems IPickValue IPrivilege IPrivilegeList IProcess IProcessFactory IProcessMessage IProgress IProperty IPropertyChangeEvent IQuery IReference IReferenceCriterion IReferenceEnabledMode IReferenceFactory IReferenceHistoryDescription IReferenceInfo IReferenceRecordCardWizardStep IReferenceRequisiteDescription IReferencesFactory IReferenceValue IRefRequisite IReport IReportFactory IRequisite IRequisiteDescription IRequisiteDescriptionList IRequisiteFactory IRichEdit IRouteStep IRule IRuleList ISchemeBlock IScript IScriptFactory ISearchCriteria ISearchCriterion ISearchDescription ISearchFactory ISearchFolderInfo ISearchForObjectDescription ISearchResultRestrictions ISecuredContext ISelectDialog IServerEvent IServerEventFactory IServiceDialog IServiceFactory ISignature ISignProvider ISignProvider2 ISignProvider3 ISimpleCriterion IStringCriterion IStringList IStringRequisite IStringRequisiteDescription IStringValue ISystemDialogsFactory ISystemInfo ITabSheet ITask ITaskAbortReasonInfo ITaskCardWizardStep ITaskDescription ITaskFactory ITaskInfo ITaskRoute ITextCriterion ITextRequisite ITextValue ITreeListSelectDialog IUser IUserList IValue IView IWebBrowserControl IWizard IWizardAction IWizardFactory IWizardFormElement IWizardParam IWizardPickParam IWizardReferenceParam IWizardStep IWorkAccessRights IWorkDescription IWorkflowAskableParam IWorkflowAskableParams IWorkflowBlock IWorkflowBlockResult IWorkflowEnabledMode IWorkflowParam IWorkflowPickParam IWorkflowReferenceParam IWorkState IWorkTreeCustomNode IWorkTreeJobNode IWorkTreeTaskNode IXMLEditorForm SBCrypto ";
    // built_in : встроенные или библиотечные объекты (константы, перечисления)
    var BUILTIN = CONSTANTS + ENUMS;
    // class: встроенные наборы значений, системные объекты, фабрики
    var CLASS = predefined_variables;
    // literal : примитивные типы
    var LITERAL = "null true false nil ";
    // number : числа
    var NUMBERS = {
        className: "number",
        begin: hljs.NUMBER_RE,
        relevance: 0
    };
    // string : строки
    var STRINGS = {
        className: "string",
        variants: [
            {
                begin: '"',
                end: '"'
            },
            {
                begin: "'",
                end: "'"
            }
        ]
    };
    // Токены
    var DOCTAGS = {
        className: "doctag",
        begin: "\\b(?:TODO|DONE|BEGIN|END|STUB|CHG|FIXME|NOTE|BUG|XXX)\\b",
        relevance: 0
    };
    // Однострочный комментарий
    var ISBL_LINE_COMMENT_MODE = {
        className: "comment",
        begin: "//",
        end: "$",
        relevance: 0,
        contains: [
            hljs.PHRASAL_WORDS_MODE,
            DOCTAGS
        ]
    };
    // Многострочный комментарий
    var ISBL_BLOCK_COMMENT_MODE = {
        className: "comment",
        begin: "/\\*",
        end: "\\*/",
        relevance: 0,
        contains: [
            hljs.PHRASAL_WORDS_MODE,
            DOCTAGS
        ]
    };
    // comment : комментарии
    var COMMENTS = {
        variants: [
            ISBL_LINE_COMMENT_MODE,
            ISBL_BLOCK_COMMENT_MODE
        ]
    };
    // keywords : ключевые слова
    var KEYWORDS = {
        keyword: KEYWORD,
        built_in: BUILTIN,
        class: CLASS,
        literal: LITERAL
    };
    // methods : методы
    var METHODS = {
        begin: "\\.\\s*" + hljs.UNDERSCORE_IDENT_RE,
        keywords: KEYWORDS,
        relevance: 0
    };
    // type : встроенные типы
    var TYPES = {
        className: "type",
        begin: ":[ \\t]*(" + interfaces.trim().replace(/\s/g, "|") + ")",
        end: "[ \\t]*=",
        excludeEnd: true
    };
    // variables : переменные
    var VARIABLES = {
        className: "variable",
        lexemes: UNDERSCORE_IDENT_RE,
        keywords: KEYWORDS,
        begin: UNDERSCORE_IDENT_RE,
        relevance: 0,
        contains: [
            TYPES,
            METHODS
        ]
    };
    // Имена функций
    var FUNCTION_TITLE = FUNCTION_NAME_IDENT_RE + "\\(";
    var TITLE_MODE = {
        className: "title",
        lexemes: UNDERSCORE_IDENT_RE,
        keywords: {
            built_in: system_functions
        },
        begin: FUNCTION_TITLE,
        end: "\\(",
        returnBegin: true,
        excludeEnd: true
    };
    // function : функции
    var FUNCTIONS = {
        className: "function",
        begin: FUNCTION_TITLE,
        end: "\\)$",
        returnBegin: true,
        lexemes: UNDERSCORE_IDENT_RE,
        keywords: KEYWORDS,
        illegal: "[\\[\\]\\|\\$\\?%,~#@]",
        contains: [
            TITLE_MODE,
            METHODS,
            VARIABLES,
            STRINGS,
            NUMBERS,
            COMMENTS
        ]
    };
    return {
        aliases: [
            "isbl"
        ],
        case_insensitive: true,
        lexemes: UNDERSCORE_IDENT_RE,
        keywords: KEYWORDS,
        illegal: "\\$|\\?|%|,|;$|~|#|@|</",
        contains: [
            FUNCTIONS,
            TYPES,
            METHODS,
            VARIABLES,
            STRINGS,
            NUMBERS,
            COMMENTS
        ]
    };
};

});

parcelRegister("lhbPW", function(module, exports) {
module.exports = function(hljs) {
    var JAVA_IDENT_RE = "[\xc0-\u02B8a-zA-Z_$][\xc0-\u02B8a-zA-Z_$0-9]*";
    var GENERIC_IDENT_RE = JAVA_IDENT_RE + "(<" + JAVA_IDENT_RE + "(\\s*,\\s*" + JAVA_IDENT_RE + ")*>)?";
    var KEYWORDS = "false synchronized int abstract float private char boolean var static null if const for true while long strictfp finally protected import native final void enum else break transient catch instanceof byte super volatile case assert short package default double public try this switch continue throws protected public private module requires exports do";
    // https://docs.oracle.com/javase/7/docs/technotes/guides/language/underscores-literals.html
    var JAVA_NUMBER_RE = "\\b(0[bB]([01]+[01_]+[01]+|[01]+)|0[xX]([a-fA-F0-9]+[a-fA-F0-9_]+[a-fA-F0-9]+|[a-fA-F0-9]+)|(([\\d]+[\\d_]+[\\d]+|[\\d]+)(\\.([\\d]+[\\d_]+[\\d]+|[\\d]+))?|\\.([\\d]+[\\d_]+[\\d]+|[\\d]+))([eE][-+]?\\d+)?)[lLfF]?";
    var JAVA_NUMBER_MODE = {
        className: "number",
        begin: JAVA_NUMBER_RE,
        relevance: 0
    };
    return {
        aliases: [
            "jsp"
        ],
        keywords: KEYWORDS,
        illegal: /<\/|#/,
        contains: [
            hljs.COMMENT("/\\*\\*", "\\*/", {
                relevance: 0,
                contains: [
                    {
                        // eat up @'s in emails to prevent them to be recognized as doctags
                        begin: /\w+@/,
                        relevance: 0
                    },
                    {
                        className: "doctag",
                        begin: "@[A-Za-z]+"
                    }
                ]
            }),
            hljs.C_LINE_COMMENT_MODE,
            hljs.C_BLOCK_COMMENT_MODE,
            hljs.APOS_STRING_MODE,
            hljs.QUOTE_STRING_MODE,
            {
                className: "class",
                beginKeywords: "class interface",
                end: /[{;=]/,
                excludeEnd: true,
                keywords: "class interface",
                illegal: /[:"\[\]]/,
                contains: [
                    {
                        beginKeywords: "extends implements"
                    },
                    hljs.UNDERSCORE_TITLE_MODE
                ]
            },
            {
                // Expression keywords prevent 'keyword Name(...)' from being
                // recognized as a function definition
                beginKeywords: "new throw return else",
                relevance: 0
            },
            {
                className: "function",
                begin: "(" + GENERIC_IDENT_RE + "\\s+)+" + hljs.UNDERSCORE_IDENT_RE + "\\s*\\(",
                returnBegin: true,
                end: /[{;=]/,
                excludeEnd: true,
                keywords: KEYWORDS,
                contains: [
                    {
                        begin: hljs.UNDERSCORE_IDENT_RE + "\\s*\\(",
                        returnBegin: true,
                        relevance: 0,
                        contains: [
                            hljs.UNDERSCORE_TITLE_MODE
                        ]
                    },
                    {
                        className: "params",
                        begin: /\(/,
                        end: /\)/,
                        keywords: KEYWORDS,
                        relevance: 0,
                        contains: [
                            hljs.APOS_STRING_MODE,
                            hljs.QUOTE_STRING_MODE,
                            hljs.C_NUMBER_MODE,
                            hljs.C_BLOCK_COMMENT_MODE
                        ]
                    },
                    hljs.C_LINE_COMMENT_MODE,
                    hljs.C_BLOCK_COMMENT_MODE
                ]
            },
            JAVA_NUMBER_MODE,
            {
                className: "meta",
                begin: "@[A-Za-z]+"
            }
        ]
    };
};

});

parcelRegister("hXeXQ", function(module, exports) {
module.exports = function(hljs) {
    var FRAGMENT = {
        begin: "<>",
        end: "</>"
    };
    var XML_TAG = {
        begin: /<[A-Za-z0-9\\._:-]+/,
        end: /\/[A-Za-z0-9\\._:-]+>|\/>/
    };
    var IDENT_RE = "[A-Za-z$_][0-9A-Za-z$_]*";
    var KEYWORDS = {
        keyword: "in of if for while finally var new function do return void else break catch instanceof with throw case default try this switch continue typeof delete let yield const export super debugger as async await static import from as",
        literal: "true false null undefined NaN Infinity",
        built_in: "eval isFinite isNaN parseFloat parseInt decodeURI decodeURIComponent encodeURI encodeURIComponent escape unescape Object Function Boolean Error EvalError InternalError RangeError ReferenceError StopIteration SyntaxError TypeError URIError Number Math Date String RegExp Array Float32Array Float64Array Int16Array Int32Array Int8Array Uint16Array Uint32Array Uint8Array Uint8ClampedArray ArrayBuffer DataView JSON Intl arguments require module console window document Symbol Set Map WeakSet WeakMap Proxy Reflect Promise"
    };
    var NUMBER = {
        className: "number",
        variants: [
            {
                begin: "\\b(0[bB][01]+)n?"
            },
            {
                begin: "\\b(0[oO][0-7]+)n?"
            },
            {
                begin: hljs.C_NUMBER_RE + "n?"
            }
        ],
        relevance: 0
    };
    var SUBST = {
        className: "subst",
        begin: "\\$\\{",
        end: "\\}",
        keywords: KEYWORDS,
        contains: [] // defined later
    };
    var HTML_TEMPLATE = {
        begin: "html`",
        end: "",
        starts: {
            end: "`",
            returnEnd: false,
            contains: [
                hljs.BACKSLASH_ESCAPE,
                SUBST
            ],
            subLanguage: "xml"
        }
    };
    var CSS_TEMPLATE = {
        begin: "css`",
        end: "",
        starts: {
            end: "`",
            returnEnd: false,
            contains: [
                hljs.BACKSLASH_ESCAPE,
                SUBST
            ],
            subLanguage: "css"
        }
    };
    var TEMPLATE_STRING = {
        className: "string",
        begin: "`",
        end: "`",
        contains: [
            hljs.BACKSLASH_ESCAPE,
            SUBST
        ]
    };
    SUBST.contains = [
        hljs.APOS_STRING_MODE,
        hljs.QUOTE_STRING_MODE,
        HTML_TEMPLATE,
        CSS_TEMPLATE,
        TEMPLATE_STRING,
        NUMBER,
        hljs.REGEXP_MODE
    ];
    var PARAMS_CONTAINS = SUBST.contains.concat([
        hljs.C_BLOCK_COMMENT_MODE,
        hljs.C_LINE_COMMENT_MODE
    ]);
    return {
        aliases: [
            "js",
            "jsx",
            "mjs",
            "cjs"
        ],
        keywords: KEYWORDS,
        contains: [
            {
                className: "meta",
                relevance: 10,
                begin: /^\s*['"]use (strict|asm)['"]/
            },
            {
                className: "meta",
                begin: /^#!/,
                end: /$/
            },
            hljs.APOS_STRING_MODE,
            hljs.QUOTE_STRING_MODE,
            HTML_TEMPLATE,
            CSS_TEMPLATE,
            TEMPLATE_STRING,
            hljs.C_LINE_COMMENT_MODE,
            hljs.COMMENT("/\\*\\*", "\\*/", {
                relevance: 0,
                contains: [
                    {
                        className: "doctag",
                        begin: "@[A-Za-z]+",
                        contains: [
                            {
                                className: "type",
                                begin: "\\{",
                                end: "\\}",
                                relevance: 0
                            },
                            {
                                className: "variable",
                                begin: IDENT_RE + "(?=\\s*(-)|$)",
                                endsParent: true,
                                relevance: 0
                            },
                            // eat spaces (not newlines) so we can find
                            // types or variables
                            {
                                begin: /(?=[^\n])\s/,
                                relevance: 0
                            }
                        ]
                    }
                ]
            }),
            hljs.C_BLOCK_COMMENT_MODE,
            NUMBER,
            {
                begin: /[{,\n]\s*/,
                relevance: 0,
                contains: [
                    {
                        begin: IDENT_RE + "\\s*:",
                        returnBegin: true,
                        relevance: 0,
                        contains: [
                            {
                                className: "attr",
                                begin: IDENT_RE,
                                relevance: 0
                            }
                        ]
                    }
                ]
            },
            {
                begin: "(" + hljs.RE_STARTERS_RE + "|\\b(case|return|throw)\\b)\\s*",
                keywords: "return throw case",
                contains: [
                    hljs.C_LINE_COMMENT_MODE,
                    hljs.C_BLOCK_COMMENT_MODE,
                    hljs.REGEXP_MODE,
                    {
                        className: "function",
                        begin: "(\\(.*?\\)|" + IDENT_RE + ")\\s*=>",
                        returnBegin: true,
                        end: "\\s*=>",
                        contains: [
                            {
                                className: "params",
                                variants: [
                                    {
                                        begin: IDENT_RE
                                    },
                                    {
                                        begin: /\(\s*\)/
                                    },
                                    {
                                        begin: /\(/,
                                        end: /\)/,
                                        excludeBegin: true,
                                        excludeEnd: true,
                                        keywords: KEYWORDS,
                                        contains: PARAMS_CONTAINS
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        className: "",
                        begin: /\s/,
                        end: /\s*/,
                        skip: true
                    },
                    {
                        variants: [
                            {
                                begin: FRAGMENT.begin,
                                end: FRAGMENT.end
                            },
                            {
                                begin: XML_TAG.begin,
                                end: XML_TAG.end
                            }
                        ],
                        subLanguage: "xml",
                        contains: [
                            {
                                begin: XML_TAG.begin,
                                end: XML_TAG.end,
                                skip: true,
                                contains: [
                                    "self"
                                ]
                            }
                        ]
                    }
                ],
                relevance: 0
            },
            {
                className: "function",
                beginKeywords: "function",
                end: /\{/,
                excludeEnd: true,
                contains: [
                    hljs.inherit(hljs.TITLE_MODE, {
                        begin: IDENT_RE
                    }),
                    {
                        className: "params",
                        begin: /\(/,
                        end: /\)/,
                        excludeBegin: true,
                        excludeEnd: true,
                        contains: PARAMS_CONTAINS
                    }
                ],
                illegal: /\[|%/
            },
            {
                begin: /\$[(.]/ // relevance booster for a pattern common to JS libs: `$(something)` and `$.something`
            },
            hljs.METHOD_GUARD,
            {
                className: "class",
                beginKeywords: "class",
                end: /[{;=]/,
                excludeEnd: true,
                illegal: /[:"\[\]]/,
                contains: [
                    {
                        beginKeywords: "extends"
                    },
                    hljs.UNDERSCORE_TITLE_MODE
                ]
            },
            {
                beginKeywords: "constructor get set",
                end: /\{/,
                excludeEnd: true
            }
        ],
        illegal: /#(?!!)/
    };
};

});

parcelRegister("14ZtH", function(module, exports) {
module.exports = function(hljs) {
    var PARAM = {
        begin: /[\w-]+ *=/,
        returnBegin: true,
        relevance: 0,
        contains: [
            {
                className: "attr",
                begin: /[\w-]+/
            }
        ]
    };
    var PARAMSBLOCK = {
        className: "params",
        begin: /\(/,
        end: /\)/,
        contains: [
            PARAM
        ],
        relevance: 0
    };
    var OPERATION = {
        className: "function",
        begin: /:[\w\-.]+/,
        relevance: 0
    };
    var PATH = {
        className: "string",
        begin: /\B(([\/.])[\w\-.\/=]+)+/
    };
    var COMMAND_PARAMS = {
        className: "params",
        begin: /--[\w\-=\/]+/
    };
    return {
        aliases: [
            "wildfly-cli"
        ],
        lexemes: "[a-z-]+",
        keywords: {
            keyword: "alias batch cd clear command connect connection-factory connection-info data-source deploy deployment-info deployment-overlay echo echo-dmr help history if jdbc-driver-info jms-queue|20 jms-topic|20 ls patch pwd quit read-attribute read-operation reload rollout-plan run-batch set shutdown try unalias undeploy unset version xa-data-source",
            literal: "true false"
        },
        contains: [
            hljs.HASH_COMMENT_MODE,
            hljs.QUOTE_STRING_MODE,
            COMMAND_PARAMS,
            OPERATION,
            PATH,
            PARAMSBLOCK
        ]
    };
};

});

parcelRegister("hIDeD", function(module, exports) {
module.exports = function(hljs) {
    var LITERALS = {
        literal: "true false null"
    };
    var ALLOWED_COMMENTS = [
        hljs.C_LINE_COMMENT_MODE,
        hljs.C_BLOCK_COMMENT_MODE
    ];
    var TYPES = [
        hljs.QUOTE_STRING_MODE,
        hljs.C_NUMBER_MODE
    ];
    var VALUE_CONTAINER = {
        end: ",",
        endsWithParent: true,
        excludeEnd: true,
        contains: TYPES,
        keywords: LITERALS
    };
    var OBJECT = {
        begin: "{",
        end: "}",
        contains: [
            {
                className: "attr",
                begin: /"/,
                end: /"/,
                contains: [
                    hljs.BACKSLASH_ESCAPE
                ],
                illegal: "\\n"
            },
            hljs.inherit(VALUE_CONTAINER, {
                begin: /:/
            })
        ].concat(ALLOWED_COMMENTS),
        illegal: "\\S"
    };
    var ARRAY = {
        begin: "\\[",
        end: "\\]",
        contains: [
            hljs.inherit(VALUE_CONTAINER)
        ],
        illegal: "\\S"
    };
    TYPES.push(OBJECT, ARRAY);
    ALLOWED_COMMENTS.forEach(function(rule) {
        TYPES.push(rule);
    });
    return {
        contains: TYPES,
        keywords: LITERALS,
        illegal: "\\S"
    };
};

});

parcelRegister("lMPba", function(module, exports) {
module.exports = function(hljs) {
    // Since there are numerous special names in Julia, it is too much trouble
    // to maintain them by hand. Hence these names (i.e. keywords, literals and
    // built-ins) are automatically generated from Julia v0.6 itself through
    // the following scripts for each.
    var KEYWORDS = {
        // # keyword generator, multi-word keywords handled manually below
        // foreach(println, ["in", "isa", "where"])
        // for kw in Base.REPLCompletions.complete_keyword("")
        //     if !(contains(kw, " ") || kw == "struct")
        //         println(kw)
        //     end
        // end
        keyword: "in isa where baremodule begin break catch ccall const continue do else elseif end export false finally for function global if import importall let local macro module quote return true try using while type immutable abstract bitstype typealias ",
        // # literal generator
        // println("true")
        // println("false")
        // for name in Base.REPLCompletions.completions("", 0)[1]
        //     try
        //         v = eval(Symbol(name))
        //         if !(v isa Function || v isa Type || v isa TypeVar || v isa Module || v isa Colon)
        //             println(name)
        //         end
        //     end
        // end
        literal: "true false ARGS C_NULL DevNull ENDIAN_BOM ENV I Inf Inf16 Inf32 Inf64 InsertionSort JULIA_HOME LOAD_PATH MergeSort NaN NaN16 NaN32 NaN64 PROGRAM_FILE QuickSort RoundDown RoundFromZero RoundNearest RoundNearestTiesAway RoundNearestTiesUp RoundToZero RoundUp STDERR STDIN STDOUT VERSION catalan e|0 eu|0 eulergamma golden im nothing pi \u03B3 \u03C0 \u03C6 ",
        // # built_in generator:
        // for name in Base.REPLCompletions.completions("", 0)[1]
        //     try
        //         v = eval(Symbol(name))
        //         if v isa Type || v isa TypeVar
        //             println(name)
        //         end
        //     end
        // end
        built_in: "ANY AbstractArray AbstractChannel AbstractFloat AbstractMatrix AbstractRNG AbstractSerializer AbstractSet AbstractSparseArray AbstractSparseMatrix AbstractSparseVector AbstractString AbstractUnitRange AbstractVecOrMat AbstractVector Any ArgumentError Array AssertionError Associative Base64DecodePipe Base64EncodePipe Bidiagonal BigFloat BigInt BitArray BitMatrix BitVector Bool BoundsError BufferStream CachingPool CapturedException CartesianIndex CartesianRange Cchar Cdouble Cfloat Channel Char Cint Cintmax_t Clong Clonglong ClusterManager Cmd CodeInfo Colon Complex Complex128 Complex32 Complex64 CompositeException Condition ConjArray ConjMatrix ConjVector Cptrdiff_t Cshort Csize_t Cssize_t Cstring Cuchar Cuint Cuintmax_t Culong Culonglong Cushort Cwchar_t Cwstring DataType Date DateFormat DateTime DenseArray DenseMatrix DenseVecOrMat DenseVector Diagonal Dict DimensionMismatch Dims DirectIndexString Display DivideError DomainError EOFError EachLine Enum Enumerate ErrorException Exception ExponentialBackOff Expr Factorization FileMonitor Float16 Float32 Float64 Function Future GlobalRef GotoNode HTML Hermitian IO IOBuffer IOContext IOStream IPAddr IPv4 IPv6 IndexCartesian IndexLinear IndexStyle InexactError InitError Int Int128 Int16 Int32 Int64 Int8 IntSet Integer InterruptException InvalidStateException Irrational KeyError LabelNode LinSpace LineNumberNode LoadError LowerTriangular MIME Matrix MersenneTwister Method MethodError MethodTable Module NTuple NewvarNode NullException Nullable Number ObjectIdDict OrdinalRange OutOfMemoryError OverflowError Pair ParseError PartialQuickSort PermutedDimsArray Pipe PollingFileWatcher ProcessExitedException Ptr QuoteNode RandomDevice Range RangeIndex Rational RawFD ReadOnlyMemoryError Real ReentrantLock Ref Regex RegexMatch RemoteChannel RemoteException RevString RoundingMode RowVector SSAValue SegmentationFault SerializationState Set SharedArray SharedMatrix SharedVector Signed SimpleVector Slot SlotNumber SparseMatrixCSC SparseVector StackFrame StackOverflowError StackTrace StepRange StepRangeLen StridedArray StridedMatrix StridedVecOrMat StridedVector String SubArray SubString SymTridiagonal Symbol Symmetric SystemError TCPSocket Task Text TextDisplay Timer Tridiagonal Tuple Type TypeError TypeMapEntry TypeMapLevel TypeName TypeVar TypedSlot UDPSocket UInt UInt128 UInt16 UInt32 UInt64 UInt8 UndefRefError UndefVarError UnicodeError UniformScaling Union UnionAll UnitRange Unsigned UpperTriangular Val Vararg VecElement VecOrMat Vector VersionNumber Void WeakKeyDict WeakRef WorkerConfig WorkerPool "
    };
    // ref: http://julia.readthedocs.org/en/latest/manual/variables/#allowed-variable-names
    var VARIABLE_NAME_RE = "[A-Za-z_\\u00A1-\\uFFFF][A-Za-z_0-9\\u00A1-\\uFFFF]*";
    // placeholder for recursive self-reference
    var DEFAULT = {
        lexemes: VARIABLE_NAME_RE,
        keywords: KEYWORDS,
        illegal: /<\//
    };
    // ref: http://julia.readthedocs.org/en/latest/manual/integers-and-floating-point-numbers/
    var NUMBER = {
        className: "number",
        // supported numeric literals:
        //  * binary literal (e.g. 0x10)
        //  * octal literal (e.g. 0o76543210)
        //  * hexadecimal literal (e.g. 0xfedcba876543210)
        //  * hexadecimal floating point literal (e.g. 0x1p0, 0x1.2p2)
        //  * decimal literal (e.g. 9876543210, 100_000_000)
        //  * floating pointe literal (e.g. 1.2, 1.2f, .2, 1., 1.2e10, 1.2e-10)
        begin: /(\b0x[\d_]*(\.[\d_]*)?|0x\.\d[\d_]*)p[-+]?\d+|\b0[box][a-fA-F0-9][a-fA-F0-9_]*|(\b\d[\d_]*(\.[\d_]*)?|\.\d[\d_]*)([eEfF][-+]?\d+)?/,
        relevance: 0
    };
    var CHAR = {
        className: "string",
        begin: /'(.|\\[xXuU][a-zA-Z0-9]+)'/
    };
    var INTERPOLATION = {
        className: "subst",
        begin: /\$\(/,
        end: /\)/,
        keywords: KEYWORDS
    };
    var INTERPOLATED_VARIABLE = {
        className: "variable",
        begin: "\\$" + VARIABLE_NAME_RE
    };
    // TODO: neatly escape normal code in string literal
    var STRING = {
        className: "string",
        contains: [
            hljs.BACKSLASH_ESCAPE,
            INTERPOLATION,
            INTERPOLATED_VARIABLE
        ],
        variants: [
            {
                begin: /\w*"""/,
                end: /"""\w*/,
                relevance: 10
            },
            {
                begin: /\w*"/,
                end: /"\w*/
            }
        ]
    };
    var COMMAND = {
        className: "string",
        contains: [
            hljs.BACKSLASH_ESCAPE,
            INTERPOLATION,
            INTERPOLATED_VARIABLE
        ],
        begin: "`",
        end: "`"
    };
    var MACROCALL = {
        className: "meta",
        begin: "@" + VARIABLE_NAME_RE
    };
    var COMMENT = {
        className: "comment",
        variants: [
            {
                begin: "#=",
                end: "=#",
                relevance: 10
            },
            {
                begin: "#",
                end: "$"
            }
        ]
    };
    DEFAULT.contains = [
        NUMBER,
        CHAR,
        STRING,
        COMMAND,
        MACROCALL,
        COMMENT,
        hljs.HASH_COMMENT_MODE,
        {
            className: "keyword",
            begin: "\\b(((abstract|primitive)\\s+)type|(mutable\\s+)?struct)\\b"
        },
        {
            begin: /<:/
        } // relevance booster
    ];
    INTERPOLATION.contains = DEFAULT.contains;
    return DEFAULT;
};

});

parcelRegister("b58C8", function(module, exports) {
module.exports = function(hljs) {
    return {
        contains: [
            {
                className: "meta",
                begin: /^julia>/,
                relevance: 10,
                starts: {
                    // end the highlighting if we are on a new line and the line does not have at
                    // least six spaces in the beginning
                    end: /^(?![ ]{6})/,
                    subLanguage: "julia"
                },
                // jldoctest Markdown blocks are used in the Julia manual and package docs indicate
                // code snippets that should be verified when the documentation is built. They can be
                // either REPL-like or script-like, but are usually REPL-like and therefore we apply
                // julia-repl highlighting to them. More information can be found in Documenter's
                // manual: https://juliadocs.github.io/Documenter.jl/latest/man/doctests.html
                aliases: [
                    "jldoctest"
                ]
            }
        ]
    };
};

});

parcelRegister("kJmbc", function(module, exports) {
module.exports = function(hljs) {
    var KEYWORDS = {
        keyword: "abstract as val var vararg get set class object open private protected public noinline crossinline dynamic final enum if else do while for when throw try catch finally import package is in fun override companion reified inline lateinit init interface annotation data sealed internal infix operator out by constructor super tailrec where const inner suspend typealias external expect actual trait volatile transient native default",
        built_in: "Byte Short Char Int Long Boolean Float Double Void Unit Nothing",
        literal: "true false null"
    };
    var KEYWORDS_WITH_LABEL = {
        className: "keyword",
        begin: /\b(break|continue|return|this)\b/,
        starts: {
            contains: [
                {
                    className: "symbol",
                    begin: /@\w+/
                }
            ]
        }
    };
    var LABEL = {
        className: "symbol",
        begin: hljs.UNDERSCORE_IDENT_RE + "@"
    };
    // for string templates
    var SUBST = {
        className: "subst",
        begin: "\\${",
        end: "}",
        contains: [
            hljs.C_NUMBER_MODE
        ]
    };
    var VARIABLE = {
        className: "variable",
        begin: "\\$" + hljs.UNDERSCORE_IDENT_RE
    };
    var STRING = {
        className: "string",
        variants: [
            {
                begin: '"""',
                end: '"""(?=[^"])',
                contains: [
                    VARIABLE,
                    SUBST
                ]
            },
            // Can't use built-in modes easily, as we want to use STRING in the meta
            // context as 'meta-string' and there's no syntax to remove explicitly set
            // classNames in built-in modes.
            {
                begin: "'",
                end: "'",
                illegal: /\n/,
                contains: [
                    hljs.BACKSLASH_ESCAPE
                ]
            },
            {
                begin: '"',
                end: '"',
                illegal: /\n/,
                contains: [
                    hljs.BACKSLASH_ESCAPE,
                    VARIABLE,
                    SUBST
                ]
            }
        ]
    };
    SUBST.contains.push(STRING);
    var ANNOTATION_USE_SITE = {
        className: "meta",
        begin: "@(?:file|property|field|get|set|receiver|param|setparam|delegate)\\s*:(?:\\s*" + hljs.UNDERSCORE_IDENT_RE + ")?"
    };
    var ANNOTATION = {
        className: "meta",
        begin: "@" + hljs.UNDERSCORE_IDENT_RE,
        contains: [
            {
                begin: /\(/,
                end: /\)/,
                contains: [
                    hljs.inherit(STRING, {
                        className: "meta-string"
                    })
                ]
            }
        ]
    };
    // https://kotlinlang.org/docs/reference/whatsnew11.html#underscores-in-numeric-literals
    // According to the doc above, the number mode of kotlin is the same as java 8,
    // so the code below is copied from java.js
    var KOTLIN_NUMBER_RE = "\\b(0[bB]([01]+[01_]+[01]+|[01]+)|0[xX]([a-fA-F0-9]+[a-fA-F0-9_]+[a-fA-F0-9]+|[a-fA-F0-9]+)|(([\\d]+[\\d_]+[\\d]+|[\\d]+)(\\.([\\d]+[\\d_]+[\\d]+|[\\d]+))?|\\.([\\d]+[\\d_]+[\\d]+|[\\d]+))([eE][-+]?\\d+)?)[lLfF]?";
    var KOTLIN_NUMBER_MODE = {
        className: "number",
        begin: KOTLIN_NUMBER_RE,
        relevance: 0
    };
    var KOTLIN_NESTED_COMMENT = hljs.COMMENT("/\\*", "\\*/", {
        contains: [
            hljs.C_BLOCK_COMMENT_MODE
        ]
    });
    var KOTLIN_PAREN_TYPE = {
        variants: [
            {
                className: "type",
                begin: hljs.UNDERSCORE_IDENT_RE
            },
            {
                begin: /\(/,
                end: /\)/,
                contains: [] //defined later
            }
        ]
    };
    var KOTLIN_PAREN_TYPE2 = KOTLIN_PAREN_TYPE;
    KOTLIN_PAREN_TYPE2.variants[1].contains = [
        KOTLIN_PAREN_TYPE
    ];
    KOTLIN_PAREN_TYPE.variants[1].contains = [
        KOTLIN_PAREN_TYPE2
    ];
    return {
        aliases: [
            "kt"
        ],
        keywords: KEYWORDS,
        contains: [
            hljs.COMMENT("/\\*\\*", "\\*/", {
                relevance: 0,
                contains: [
                    {
                        className: "doctag",
                        begin: "@[A-Za-z]+"
                    }
                ]
            }),
            hljs.C_LINE_COMMENT_MODE,
            KOTLIN_NESTED_COMMENT,
            KEYWORDS_WITH_LABEL,
            LABEL,
            ANNOTATION_USE_SITE,
            ANNOTATION,
            {
                className: "function",
                beginKeywords: "fun",
                end: "[(]|$",
                returnBegin: true,
                excludeEnd: true,
                keywords: KEYWORDS,
                illegal: /fun\s+(<.*>)?[^\s\(]+(\s+[^\s\(]+)\s*=/,
                relevance: 5,
                contains: [
                    {
                        begin: hljs.UNDERSCORE_IDENT_RE + "\\s*\\(",
                        returnBegin: true,
                        relevance: 0,
                        contains: [
                            hljs.UNDERSCORE_TITLE_MODE
                        ]
                    },
                    {
                        className: "type",
                        begin: /</,
                        end: />/,
                        keywords: "reified",
                        relevance: 0
                    },
                    {
                        className: "params",
                        begin: /\(/,
                        end: /\)/,
                        endsParent: true,
                        keywords: KEYWORDS,
                        relevance: 0,
                        contains: [
                            {
                                begin: /:/,
                                end: /[=,\/]/,
                                endsWithParent: true,
                                contains: [
                                    KOTLIN_PAREN_TYPE,
                                    hljs.C_LINE_COMMENT_MODE,
                                    KOTLIN_NESTED_COMMENT
                                ],
                                relevance: 0
                            },
                            hljs.C_LINE_COMMENT_MODE,
                            KOTLIN_NESTED_COMMENT,
                            ANNOTATION_USE_SITE,
                            ANNOTATION,
                            STRING,
                            hljs.C_NUMBER_MODE
                        ]
                    },
                    KOTLIN_NESTED_COMMENT
                ]
            },
            {
                className: "class",
                beginKeywords: "class interface trait",
                end: /[:\{(]|$/,
                excludeEnd: true,
                illegal: "extends implements",
                contains: [
                    {
                        beginKeywords: "public protected internal private constructor"
                    },
                    hljs.UNDERSCORE_TITLE_MODE,
                    {
                        className: "type",
                        begin: /</,
                        end: />/,
                        excludeBegin: true,
                        excludeEnd: true,
                        relevance: 0
                    },
                    {
                        className: "type",
                        begin: /[,:]\s*/,
                        end: /[<\(,]|$/,
                        excludeBegin: true,
                        returnEnd: true
                    },
                    ANNOTATION_USE_SITE,
                    ANNOTATION
                ]
            },
            STRING,
            {
                className: "meta",
                begin: "^#!/usr/bin/env",
                end: "$",
                illegal: "\n"
            },
            KOTLIN_NUMBER_MODE
        ]
    };
};

});

parcelRegister("fcj0z", function(module, exports) {
module.exports = function(hljs) {
    var LASSO_IDENT_RE = "[a-zA-Z_][\\w.]*";
    var LASSO_ANGLE_RE = "<\\?(lasso(script)?|=)";
    var LASSO_CLOSE_RE = "\\]|\\?>";
    var LASSO_KEYWORDS = {
        literal: "true false none minimal full all void and or not bw nbw ew new cn ncn lt lte gt gte eq neq rx nrx ft",
        built_in: "array date decimal duration integer map pair string tag xml null boolean bytes keyword list locale queue set stack staticarray local var variable global data self inherited currentcapture givenblock",
        keyword: "cache database_names database_schemanames database_tablenames define_tag define_type email_batch encode_set html_comment handle handle_error header if inline iterate ljax_target link link_currentaction link_currentgroup link_currentrecord link_detail link_firstgroup link_firstrecord link_lastgroup link_lastrecord link_nextgroup link_nextrecord link_prevgroup link_prevrecord log loop namespace_using output_none portal private protect records referer referrer repeating resultset rows search_args search_arguments select sort_args sort_arguments thread_atomic value_list while abort case else fail_if fail_ifnot fail if_empty if_false if_null if_true loop_abort loop_continue loop_count params params_up return return_value run_children soap_definetag soap_lastrequest soap_lastresponse tag_name ascending average by define descending do equals frozen group handle_failure import in into join let match max min on order parent protected provide public require returnhome skip split_thread sum take thread to trait type where with yield yieldhome"
    };
    var HTML_COMMENT = hljs.COMMENT("<!--", "-->", {
        relevance: 0
    });
    var LASSO_NOPROCESS = {
        className: "meta",
        begin: "\\[noprocess\\]",
        starts: {
            end: "\\[/noprocess\\]",
            returnEnd: true,
            contains: [
                HTML_COMMENT
            ]
        }
    };
    var LASSO_START = {
        className: "meta",
        begin: "\\[/noprocess|" + LASSO_ANGLE_RE
    };
    var LASSO_DATAMEMBER = {
        className: "symbol",
        begin: "'" + LASSO_IDENT_RE + "'"
    };
    var LASSO_CODE = [
        hljs.C_LINE_COMMENT_MODE,
        hljs.C_BLOCK_COMMENT_MODE,
        hljs.inherit(hljs.C_NUMBER_MODE, {
            begin: hljs.C_NUMBER_RE + "|(-?infinity|NaN)\\b"
        }),
        hljs.inherit(hljs.APOS_STRING_MODE, {
            illegal: null
        }),
        hljs.inherit(hljs.QUOTE_STRING_MODE, {
            illegal: null
        }),
        {
            className: "string",
            begin: "`",
            end: "`"
        },
        {
            variants: [
                {
                    begin: "[#$]" + LASSO_IDENT_RE
                },
                {
                    begin: "#",
                    end: "\\d+",
                    illegal: "\\W"
                }
            ]
        },
        {
            className: "type",
            begin: "::\\s*",
            end: LASSO_IDENT_RE,
            illegal: "\\W"
        },
        {
            className: "params",
            variants: [
                {
                    begin: "-(?!infinity)" + LASSO_IDENT_RE,
                    relevance: 0
                },
                {
                    begin: "(\\.\\.\\.)"
                }
            ]
        },
        {
            begin: /(->|\.)\s*/,
            relevance: 0,
            contains: [
                LASSO_DATAMEMBER
            ]
        },
        {
            className: "class",
            beginKeywords: "define",
            returnEnd: true,
            end: "\\(|=>",
            contains: [
                hljs.inherit(hljs.TITLE_MODE, {
                    begin: LASSO_IDENT_RE + "(=(?!>))?|[-+*/%](?!>)"
                })
            ]
        }
    ];
    return {
        aliases: [
            "ls",
            "lassoscript"
        ],
        case_insensitive: true,
        lexemes: LASSO_IDENT_RE + "|&[lg]t;",
        keywords: LASSO_KEYWORDS,
        contains: [
            {
                className: "meta",
                begin: LASSO_CLOSE_RE,
                relevance: 0,
                starts: {
                    end: "\\[|" + LASSO_ANGLE_RE,
                    returnEnd: true,
                    relevance: 0,
                    contains: [
                        HTML_COMMENT
                    ]
                }
            },
            LASSO_NOPROCESS,
            LASSO_START,
            {
                className: "meta",
                begin: "\\[no_square_brackets",
                starts: {
                    end: "\\[/no_square_brackets\\]",
                    lexemes: LASSO_IDENT_RE + "|&[lg]t;",
                    keywords: LASSO_KEYWORDS,
                    contains: [
                        {
                            className: "meta",
                            begin: LASSO_CLOSE_RE,
                            relevance: 0,
                            starts: {
                                end: "\\[noprocess\\]|" + LASSO_ANGLE_RE,
                                returnEnd: true,
                                contains: [
                                    HTML_COMMENT
                                ]
                            }
                        },
                        LASSO_NOPROCESS,
                        LASSO_START
                    ].concat(LASSO_CODE)
                }
            },
            {
                className: "meta",
                begin: "\\[",
                relevance: 0
            },
            {
                className: "meta",
                begin: "^#!",
                end: "lasso9$",
                relevance: 10
            }
        ].concat(LASSO_CODE)
    };
};

});

parcelRegister("e6tv5", function(module, exports) {
module.exports = function(hljs) {
    return {
        contains: [
            {
                className: "attribute",
                begin: "^dn",
                end: ": ",
                excludeEnd: true,
                starts: {
                    end: "$",
                    relevance: 0
                },
                relevance: 10
            },
            {
                className: "attribute",
                begin: "^\\w",
                end: ": ",
                excludeEnd: true,
                starts: {
                    end: "$",
                    relevance: 0
                }
            },
            {
                className: "literal",
                begin: "^-",
                end: "$"
            },
            hljs.HASH_COMMENT_MODE
        ]
    };
};

});

parcelRegister("1zfr3", function(module, exports) {
module.exports = function(hljs) {
    return {
        contains: [
            {
                className: "function",
                begin: "#+[A-Za-z_0-9]*\\(",
                end: " {",
                returnBegin: true,
                excludeEnd: true,
                contains: [
                    {
                        className: "keyword",
                        begin: "#+"
                    },
                    {
                        className: "title",
                        begin: "[A-Za-z_][A-Za-z_0-9]*"
                    },
                    {
                        className: "params",
                        begin: "\\(",
                        end: "\\)",
                        endsParent: true,
                        contains: [
                            {
                                className: "string",
                                begin: '"',
                                end: '"'
                            },
                            {
                                className: "variable",
                                begin: "[A-Za-z_][A-Za-z_0-9]*"
                            }
                        ]
                    }
                ]
            }
        ]
    };
};

});

parcelRegister("hL458", function(module, exports) {
module.exports = function(hljs) {
    var IDENT_RE = "[\\w-]+"; // yes, Less identifiers may begin with a digit
    var INTERP_IDENT_RE = "(" + IDENT_RE + "|@{" + IDENT_RE + "})";
    /* Generic Modes */ var RULES = [], VALUE = []; // forward def. for recursive modes
    var STRING_MODE = function(c) {
        return {
            // Less strings are not multiline (also include '~' for more consistent coloring of "escaped" strings)
            className: "string",
            begin: "~?" + c + ".*?" + c
        };
    };
    var IDENT_MODE = function(name, begin, relevance) {
        return {
            className: name,
            begin: begin,
            relevance: relevance
        };
    };
    var PARENS_MODE = {
        // used only to properly balance nested parens inside mixin call, def. arg list
        begin: "\\(",
        end: "\\)",
        contains: VALUE,
        relevance: 0
    };
    // generic Less highlighter (used almost everywhere except selectors):
    VALUE.push(hljs.C_LINE_COMMENT_MODE, hljs.C_BLOCK_COMMENT_MODE, STRING_MODE("'"), STRING_MODE('"'), hljs.CSS_NUMBER_MODE, {
        begin: "(url|data-uri)\\(",
        starts: {
            className: "string",
            end: "[\\)\\n]",
            excludeEnd: true
        }
    }, IDENT_MODE("number", "#[0-9A-Fa-f]+\\b"), PARENS_MODE, IDENT_MODE("variable", "@@?" + IDENT_RE, 10), IDENT_MODE("variable", "@{" + IDENT_RE + "}"), IDENT_MODE("built_in", "~?`[^`]*?`"), {
        className: "attribute",
        begin: IDENT_RE + "\\s*:",
        end: ":",
        returnBegin: true,
        excludeEnd: true
    }, {
        className: "meta",
        begin: "!important"
    });
    var VALUE_WITH_RULESETS = VALUE.concat({
        begin: "{",
        end: "}",
        contains: RULES
    });
    var MIXIN_GUARD_MODE = {
        beginKeywords: "when",
        endsWithParent: true,
        contains: [
            {
                beginKeywords: "and not"
            }
        ].concat(VALUE) // using this form to override VALUE’s 'function' match
    };
    /* Rule-Level Modes */ var RULE_MODE = {
        begin: INTERP_IDENT_RE + "\\s*:",
        returnBegin: true,
        end: "[;}]",
        relevance: 0,
        contains: [
            {
                className: "attribute",
                begin: INTERP_IDENT_RE,
                end: ":",
                excludeEnd: true,
                starts: {
                    endsWithParent: true,
                    illegal: "[<=$]",
                    relevance: 0,
                    contains: VALUE
                }
            }
        ]
    };
    var AT_RULE_MODE = {
        className: "keyword",
        begin: "@(import|media|charset|font-face|(-[a-z]+-)?keyframes|supports|document|namespace|page|viewport|host)\\b",
        starts: {
            end: "[;{}]",
            returnEnd: true,
            contains: VALUE,
            relevance: 0
        }
    };
    // variable definitions and calls
    var VAR_RULE_MODE = {
        className: "variable",
        variants: [
            // using more strict pattern for higher relevance to increase chances of Less detection.
            // this is *the only* Less specific statement used in most of the sources, so...
            // (we’ll still often loose to the css-parser unless there's '//' comment,
            // simply because 1 variable just can't beat 99 properties :)
            {
                begin: "@" + IDENT_RE + "\\s*:",
                relevance: 15
            },
            {
                begin: "@" + IDENT_RE
            }
        ],
        starts: {
            end: "[;}]",
            returnEnd: true,
            contains: VALUE_WITH_RULESETS
        }
    };
    var SELECTOR_MODE = {
        // first parse unambiguous selectors (i.e. those not starting with tag)
        // then fall into the scary lookahead-discriminator variant.
        // this mode also handles mixin definitions and calls
        variants: [
            {
                begin: "[\\.#:&\\[>]",
                end: "[;{}]" // mixin calls end with ';'
            },
            {
                begin: INTERP_IDENT_RE,
                end: "{"
            }
        ],
        returnBegin: true,
        returnEnd: true,
        illegal: "[<='$\"]",
        relevance: 0,
        contains: [
            hljs.C_LINE_COMMENT_MODE,
            hljs.C_BLOCK_COMMENT_MODE,
            MIXIN_GUARD_MODE,
            IDENT_MODE("keyword", "all\\b"),
            IDENT_MODE("variable", "@{" + IDENT_RE + "}"),
            IDENT_MODE("selector-tag", INTERP_IDENT_RE + "%?", 0),
            IDENT_MODE("selector-id", "#" + INTERP_IDENT_RE),
            IDENT_MODE("selector-class", "\\." + INTERP_IDENT_RE, 0),
            IDENT_MODE("selector-tag", "&", 0),
            {
                className: "selector-attr",
                begin: "\\[",
                end: "\\]"
            },
            {
                className: "selector-pseudo",
                begin: /:(:)?[a-zA-Z0-9\_\-\+\(\)"'.]+/
            },
            {
                begin: "\\(",
                end: "\\)",
                contains: VALUE_WITH_RULESETS
            },
            {
                begin: "!important"
            } // eat !important after mixin call or it will be colored as tag
        ]
    };
    RULES.push(hljs.C_LINE_COMMENT_MODE, hljs.C_BLOCK_COMMENT_MODE, AT_RULE_MODE, VAR_RULE_MODE, RULE_MODE, SELECTOR_MODE);
    return {
        case_insensitive: true,
        illegal: "[=>'/<($\"]",
        contains: RULES
    };
};

});

parcelRegister("atsIb", function(module, exports) {
module.exports = function(hljs) {
    var LISP_IDENT_RE = "[a-zA-Z_\\-\\+\\*\\/\\<\\=\\>\\&\\#][a-zA-Z0-9_\\-\\+\\*\\/\\<\\=\\>\\&\\#!]*";
    var MEC_RE = "\\|[^]*?\\|";
    var LISP_SIMPLE_NUMBER_RE = "(\\-|\\+)?\\d+(\\.\\d+|\\/\\d+)?((d|e|f|l|s|D|E|F|L|S)(\\+|\\-)?\\d+)?";
    var SHEBANG = {
        className: "meta",
        begin: "^#!",
        end: "$"
    };
    var LITERAL = {
        className: "literal",
        begin: "\\b(t{1}|nil)\\b"
    };
    var NUMBER = {
        className: "number",
        variants: [
            {
                begin: LISP_SIMPLE_NUMBER_RE,
                relevance: 0
            },
            {
                begin: "#(b|B)[0-1]+(/[0-1]+)?"
            },
            {
                begin: "#(o|O)[0-7]+(/[0-7]+)?"
            },
            {
                begin: "#(x|X)[0-9a-fA-F]+(/[0-9a-fA-F]+)?"
            },
            {
                begin: "#(c|C)\\(" + LISP_SIMPLE_NUMBER_RE + " +" + LISP_SIMPLE_NUMBER_RE,
                end: "\\)"
            }
        ]
    };
    var STRING = hljs.inherit(hljs.QUOTE_STRING_MODE, {
        illegal: null
    });
    var COMMENT = hljs.COMMENT(";", "$", {
        relevance: 0
    });
    var VARIABLE = {
        begin: "\\*",
        end: "\\*"
    };
    var KEYWORD = {
        className: "symbol",
        begin: "[:&]" + LISP_IDENT_RE
    };
    var IDENT = {
        begin: LISP_IDENT_RE,
        relevance: 0
    };
    var MEC = {
        begin: MEC_RE
    };
    var QUOTED_LIST = {
        begin: "\\(",
        end: "\\)",
        contains: [
            "self",
            LITERAL,
            STRING,
            NUMBER,
            IDENT
        ]
    };
    var QUOTED = {
        contains: [
            NUMBER,
            STRING,
            VARIABLE,
            KEYWORD,
            QUOTED_LIST,
            IDENT
        ],
        variants: [
            {
                begin: "['`]\\(",
                end: "\\)"
            },
            {
                begin: "\\(quote ",
                end: "\\)",
                keywords: {
                    name: "quote"
                }
            },
            {
                begin: "'" + MEC_RE
            }
        ]
    };
    var QUOTED_ATOM = {
        variants: [
            {
                begin: "'" + LISP_IDENT_RE
            },
            {
                begin: "#'" + LISP_IDENT_RE + "(::" + LISP_IDENT_RE + ")*"
            }
        ]
    };
    var LIST = {
        begin: "\\(\\s*",
        end: "\\)"
    };
    var BODY = {
        endsWithParent: true,
        relevance: 0
    };
    LIST.contains = [
        {
            className: "name",
            variants: [
                {
                    begin: LISP_IDENT_RE
                },
                {
                    begin: MEC_RE
                }
            ]
        },
        BODY
    ];
    BODY.contains = [
        QUOTED,
        QUOTED_ATOM,
        LIST,
        LITERAL,
        NUMBER,
        STRING,
        COMMENT,
        VARIABLE,
        KEYWORD,
        MEC,
        IDENT
    ];
    return {
        illegal: /\S/,
        contains: [
            NUMBER,
            SHEBANG,
            LITERAL,
            STRING,
            COMMENT,
            QUOTED,
            QUOTED_ATOM,
            LIST,
            IDENT
        ]
    };
};

});

parcelRegister("16j1K", function(module, exports) {
module.exports = function(hljs) {
    var VARIABLE = {
        className: "variable",
        variants: [
            {
                begin: "\\b([gtps][A-Z]{1}[a-zA-Z0-9]*)(\\[.+\\])?(?:\\s*?)"
            },
            {
                begin: "\\$_[A-Z]+"
            }
        ],
        relevance: 0
    };
    var COMMENT_MODES = [
        hljs.C_BLOCK_COMMENT_MODE,
        hljs.HASH_COMMENT_MODE,
        hljs.COMMENT("--", "$"),
        hljs.COMMENT("[^:]//", "$")
    ];
    var TITLE1 = hljs.inherit(hljs.TITLE_MODE, {
        variants: [
            {
                begin: "\\b_*rig[A-Z]+[A-Za-z0-9_\\-]*"
            },
            {
                begin: "\\b_[a-z0-9\\-]+"
            }
        ]
    });
    var TITLE2 = hljs.inherit(hljs.TITLE_MODE, {
        begin: "\\b([A-Za-z0-9_\\-]+)\\b"
    });
    return {
        case_insensitive: false,
        keywords: {
            keyword: "$_COOKIE $_FILES $_GET $_GET_BINARY $_GET_RAW $_POST $_POST_BINARY $_POST_RAW $_SESSION $_SERVER codepoint codepoints segment segments codeunit codeunits sentence sentences trueWord trueWords paragraph after byte bytes english the until http forever descending using line real8 with seventh for stdout finally element word words fourth before black ninth sixth characters chars stderr uInt1 uInt1s uInt2 uInt2s stdin string lines relative rel any fifth items from middle mid at else of catch then third it file milliseconds seconds second secs sec int1 int1s int4 int4s internet int2 int2s normal text item last long detailed effective uInt4 uInt4s repeat end repeat URL in try into switch to words https token binfile each tenth as ticks tick system real4 by dateItems without char character ascending eighth whole dateTime numeric short first ftp integer abbreviated abbr abbrev private case while if div mod wrap and or bitAnd bitNot bitOr bitXor among not in a an within contains ends with begins the keys of keys",
            literal: "SIX TEN FORMFEED NINE ZERO NONE SPACE FOUR FALSE COLON CRLF PI COMMA ENDOFFILE EOF EIGHT FIVE QUOTE EMPTY ONE TRUE RETURN CR LINEFEED RIGHT BACKSLASH NULL SEVEN TAB THREE TWO six ten formfeed nine zero none space four false colon crlf pi comma endoffile eof eight five quote empty one true return cr linefeed right backslash null seven tab three two RIVERSION RISTATE FILE_READ_MODE FILE_WRITE_MODE FILE_WRITE_MODE DIR_WRITE_MODE FILE_READ_UMASK FILE_WRITE_UMASK DIR_READ_UMASK DIR_WRITE_UMASK",
            built_in: "put abs acos aliasReference annuity arrayDecode arrayEncode asin atan atan2 average avg avgDev base64Decode base64Encode baseConvert binaryDecode binaryEncode byteOffset byteToNum cachedURL cachedURLs charToNum cipherNames codepointOffset codepointProperty codepointToNum codeunitOffset commandNames compound compress constantNames cos date dateFormat decompress difference directories diskSpace DNSServers exp exp1 exp2 exp10 extents files flushEvents folders format functionNames geometricMean global globals hasMemory harmonicMean hostAddress hostAddressToName hostName hostNameToAddress isNumber ISOToMac itemOffset keys len length libURLErrorData libUrlFormData libURLftpCommand libURLLastHTTPHeaders libURLLastRHHeaders libUrlMultipartFormAddPart libUrlMultipartFormData libURLVersion lineOffset ln ln1 localNames log log2 log10 longFilePath lower macToISO matchChunk matchText matrixMultiply max md5Digest median merge messageAuthenticationCode messageDigest millisec millisecs millisecond milliseconds min monthNames nativeCharToNum normalizeText num number numToByte numToChar numToCodepoint numToNativeChar offset open openfiles openProcesses openProcessIDs openSockets paragraphOffset paramCount param params peerAddress pendingMessages platform popStdDev populationStandardDeviation populationVariance popVariance processID random randomBytes replaceText result revCreateXMLTree revCreateXMLTreeFromFile revCurrentRecord revCurrentRecordIsFirst revCurrentRecordIsLast revDatabaseColumnCount revDatabaseColumnIsNull revDatabaseColumnLengths revDatabaseColumnNames revDatabaseColumnNamed revDatabaseColumnNumbered revDatabaseColumnTypes revDatabaseConnectResult revDatabaseCursors revDatabaseID revDatabaseTableNames revDatabaseType revDataFromQuery revdb_closeCursor revdb_columnbynumber revdb_columncount revdb_columnisnull revdb_columnlengths revdb_columnnames revdb_columntypes revdb_commit revdb_connect revdb_connections revdb_connectionerr revdb_currentrecord revdb_cursorconnection revdb_cursorerr revdb_cursors revdb_dbtype revdb_disconnect revdb_execute revdb_iseof revdb_isbof revdb_movefirst revdb_movelast revdb_movenext revdb_moveprev revdb_query revdb_querylist revdb_recordcount revdb_rollback revdb_tablenames revGetDatabaseDriverPath revNumberOfRecords revOpenDatabase revOpenDatabases revQueryDatabase revQueryDatabaseBlob revQueryResult revQueryIsAtStart revQueryIsAtEnd revUnixFromMacPath revXMLAttribute revXMLAttributes revXMLAttributeValues revXMLChildContents revXMLChildNames revXMLCreateTreeFromFileWithNamespaces revXMLCreateTreeWithNamespaces revXMLDataFromXPathQuery revXMLEvaluateXPath revXMLFirstChild revXMLMatchingNode revXMLNextSibling revXMLNodeContents revXMLNumberOfChildren revXMLParent revXMLPreviousSibling revXMLRootNode revXMLRPC_CreateRequest revXMLRPC_Documents revXMLRPC_Error revXMLRPC_GetHost revXMLRPC_GetMethod revXMLRPC_GetParam revXMLText revXMLRPC_Execute revXMLRPC_GetParamCount revXMLRPC_GetParamNode revXMLRPC_GetParamType revXMLRPC_GetPath revXMLRPC_GetPort revXMLRPC_GetProtocol revXMLRPC_GetRequest revXMLRPC_GetResponse revXMLRPC_GetSocket revXMLTree revXMLTrees revXMLValidateDTD revZipDescribeItem revZipEnumerateItems revZipOpenArchives round sampVariance sec secs seconds sentenceOffset sha1Digest shell shortFilePath sin specialFolderPath sqrt standardDeviation statRound stdDev sum sysError systemVersion tan tempName textDecode textEncode tick ticks time to tokenOffset toLower toUpper transpose truewordOffset trunc uniDecode uniEncode upper URLDecode URLEncode URLStatus uuid value variableNames variance version waitDepth weekdayNames wordOffset xsltApplyStylesheet xsltApplyStylesheetFromFile xsltLoadStylesheet xsltLoadStylesheetFromFile add breakpoint cancel clear local variable file word line folder directory URL close socket process combine constant convert create new alias folder directory decrypt delete variable word line folder directory URL dispatch divide do encrypt filter get include intersect kill libURLDownloadToFile libURLFollowHttpRedirects libURLftpUpload libURLftpUploadFile libURLresetAll libUrlSetAuthCallback libURLSetDriver libURLSetCustomHTTPHeaders libUrlSetExpect100 libURLSetFTPListCommand libURLSetFTPMode libURLSetFTPStopTime libURLSetStatusCallback load extension loadedExtensions multiply socket prepare process post seek rel relative read from process rename replace require resetAll resolve revAddXMLNode revAppendXML revCloseCursor revCloseDatabase revCommitDatabase revCopyFile revCopyFolder revCopyXMLNode revDeleteFolder revDeleteXMLNode revDeleteAllXMLTrees revDeleteXMLTree revExecuteSQL revGoURL revInsertXMLNode revMoveFolder revMoveToFirstRecord revMoveToLastRecord revMoveToNextRecord revMoveToPreviousRecord revMoveToRecord revMoveXMLNode revPutIntoXMLNode revRollBackDatabase revSetDatabaseDriverPath revSetXMLAttribute revXMLRPC_AddParam revXMLRPC_DeleteAllDocuments revXMLAddDTD revXMLRPC_Free revXMLRPC_FreeAll revXMLRPC_DeleteDocument revXMLRPC_DeleteParam revXMLRPC_SetHost revXMLRPC_SetMethod revXMLRPC_SetPort revXMLRPC_SetProtocol revXMLRPC_SetSocket revZipAddItemWithData revZipAddItemWithFile revZipAddUncompressedItemWithData revZipAddUncompressedItemWithFile revZipCancel revZipCloseArchive revZipDeleteItem revZipExtractItemToFile revZipExtractItemToVariable revZipSetProgressCallback revZipRenameItem revZipReplaceItemWithData revZipReplaceItemWithFile revZipOpenArchive send set sort split start stop subtract symmetric union unload vectorDotProduct wait write"
        },
        contains: [
            VARIABLE,
            {
                className: "keyword",
                begin: "\\bend\\sif\\b"
            },
            {
                className: "function",
                beginKeywords: "function",
                end: "$",
                contains: [
                    VARIABLE,
                    TITLE2,
                    hljs.APOS_STRING_MODE,
                    hljs.QUOTE_STRING_MODE,
                    hljs.BINARY_NUMBER_MODE,
                    hljs.C_NUMBER_MODE,
                    TITLE1
                ]
            },
            {
                className: "function",
                begin: "\\bend\\s+",
                end: "$",
                keywords: "end",
                contains: [
                    TITLE2,
                    TITLE1
                ],
                relevance: 0
            },
            {
                beginKeywords: "command on",
                end: "$",
                contains: [
                    VARIABLE,
                    TITLE2,
                    hljs.APOS_STRING_MODE,
                    hljs.QUOTE_STRING_MODE,
                    hljs.BINARY_NUMBER_MODE,
                    hljs.C_NUMBER_MODE,
                    TITLE1
                ]
            },
            {
                className: "meta",
                variants: [
                    {
                        begin: "<\\?(rev|lc|livecode)",
                        relevance: 10
                    },
                    {
                        begin: "<\\?"
                    },
                    {
                        begin: "\\?>"
                    }
                ]
            },
            hljs.APOS_STRING_MODE,
            hljs.QUOTE_STRING_MODE,
            hljs.BINARY_NUMBER_MODE,
            hljs.C_NUMBER_MODE,
            TITLE1
        ].concat(COMMENT_MODES),
        illegal: ";$|^\\[|^=|&|{"
    };
};

});

parcelRegister("5bJQY", function(module, exports) {
module.exports = function(hljs) {
    var KEYWORDS = {
        keyword: // JS keywords
        "in if for while finally new do return else break catch instanceof throw try this switch continue typeof delete debugger case default function var with then unless until loop of by when and or is isnt not it that otherwise from to til fallthrough super case default function var void const let enum export import native list map __hasProp __extends __slice __bind __indexOf",
        literal: // JS literals
        "true false null undefined yes no on off it that void",
        built_in: "npm require console print module global window document"
    };
    var JS_IDENT_RE = "[A-Za-z$_](?:-[0-9A-Za-z$_]|[0-9A-Za-z$_])*";
    var TITLE = hljs.inherit(hljs.TITLE_MODE, {
        begin: JS_IDENT_RE
    });
    var SUBST = {
        className: "subst",
        begin: /#\{/,
        end: /}/,
        keywords: KEYWORDS
    };
    var SUBST_SIMPLE = {
        className: "subst",
        begin: /#[A-Za-z$_]/,
        end: /(?:\-[0-9A-Za-z$_]|[0-9A-Za-z$_])*/,
        keywords: KEYWORDS
    };
    var EXPRESSIONS = [
        hljs.BINARY_NUMBER_MODE,
        {
            className: "number",
            begin: "(\\b0[xX][a-fA-F0-9_]+)|(\\b\\d(\\d|_\\d)*(\\.(\\d(\\d|_\\d)*)?)?(_*[eE]([-+]\\d(_\\d|\\d)*)?)?[_a-z]*)",
            relevance: 0,
            starts: {
                end: "(\\s*/)?",
                relevance: 0
            } // a number tries to eat the following slash to prevent treating it as a regexp
        },
        {
            className: "string",
            variants: [
                {
                    begin: /'''/,
                    end: /'''/,
                    contains: [
                        hljs.BACKSLASH_ESCAPE
                    ]
                },
                {
                    begin: /'/,
                    end: /'/,
                    contains: [
                        hljs.BACKSLASH_ESCAPE
                    ]
                },
                {
                    begin: /"""/,
                    end: /"""/,
                    contains: [
                        hljs.BACKSLASH_ESCAPE,
                        SUBST,
                        SUBST_SIMPLE
                    ]
                },
                {
                    begin: /"/,
                    end: /"/,
                    contains: [
                        hljs.BACKSLASH_ESCAPE,
                        SUBST,
                        SUBST_SIMPLE
                    ]
                },
                {
                    begin: /\\/,
                    end: /(\s|$)/,
                    excludeEnd: true
                }
            ]
        },
        {
            className: "regexp",
            variants: [
                {
                    begin: "//",
                    end: "//[gim]*",
                    contains: [
                        SUBST,
                        hljs.HASH_COMMENT_MODE
                    ]
                },
                {
                    // regex can't start with space to parse x / 2 / 3 as two divisions
                    // regex can't start with *, and it supports an "illegal" in the main mode
                    begin: /\/(?![ *])(\\.|[^\\\n])*?\/[gim]*(?=\W)/
                }
            ]
        },
        {
            begin: "@" + JS_IDENT_RE
        },
        {
            begin: "``",
            end: "``",
            excludeBegin: true,
            excludeEnd: true,
            subLanguage: "javascript"
        }
    ];
    SUBST.contains = EXPRESSIONS;
    var PARAMS = {
        className: "params",
        begin: "\\(",
        returnBegin: true,
        /* We need another contained nameless mode to not have every nested
    pair of parens to be called "params" */ contains: [
            {
                begin: /\(/,
                end: /\)/,
                keywords: KEYWORDS,
                contains: [
                    "self"
                ].concat(EXPRESSIONS)
            }
        ]
    };
    var SYMBOLS = {
        begin: "(#=>|=>|\\|>>|-?->|\\!->)"
    };
    return {
        aliases: [
            "ls"
        ],
        keywords: KEYWORDS,
        illegal: /\/\*/,
        contains: EXPRESSIONS.concat([
            hljs.COMMENT("\\/\\*", "\\*\\/"),
            hljs.HASH_COMMENT_MODE,
            SYMBOLS,
            {
                className: "function",
                contains: [
                    TITLE,
                    PARAMS
                ],
                returnBegin: true,
                variants: [
                    {
                        begin: "(" + JS_IDENT_RE + "\\s*(?:=|:=)\\s*)?(\\(.*\\))?\\s*\\B\\->\\*?",
                        end: "\\->\\*?"
                    },
                    {
                        begin: "(" + JS_IDENT_RE + "\\s*(?:=|:=)\\s*)?!?(\\(.*\\))?\\s*\\B[-~]{1,2}>\\*?",
                        end: "[-~]{1,2}>\\*?"
                    },
                    {
                        begin: "(" + JS_IDENT_RE + "\\s*(?:=|:=)\\s*)?(\\(.*\\))?\\s*\\B!?[-~]{1,2}>\\*?",
                        end: "!?[-~]{1,2}>\\*?"
                    }
                ]
            },
            {
                className: "class",
                beginKeywords: "class",
                end: "$",
                illegal: /[:="\[\]]/,
                contains: [
                    {
                        beginKeywords: "extends",
                        endsWithParent: true,
                        illegal: /[:="\[\]]/,
                        contains: [
                            TITLE
                        ]
                    },
                    TITLE
                ]
            },
            {
                begin: JS_IDENT_RE + ":",
                end: ":",
                returnBegin: true,
                returnEnd: true,
                relevance: 0
            }
        ])
    };
};

});

parcelRegister("lCRAk", function(module, exports) {
module.exports = function(hljs) {
    var identifier = "([-a-zA-Z$._][\\w\\-$.]*)";
    return {
        //lexemes: '[.%]?' + hljs.IDENT_RE,
        keywords: "begin end true false declare define global constant private linker_private internal available_externally linkonce linkonce_odr weak weak_odr appending dllimport dllexport common default hidden protected extern_weak external thread_local zeroinitializer undef null to tail target triple datalayout volatile nuw nsw nnan ninf nsz arcp fast exact inbounds align addrspace section alias module asm sideeffect gc dbg linker_private_weak attributes blockaddress initialexec localdynamic localexec prefix unnamed_addr ccc fastcc coldcc x86_stdcallcc x86_fastcallcc arm_apcscc arm_aapcscc arm_aapcs_vfpcc ptx_device ptx_kernel intel_ocl_bicc msp430_intrcc spir_func spir_kernel x86_64_sysvcc x86_64_win64cc x86_thiscallcc cc c signext zeroext inreg sret nounwind noreturn noalias nocapture byval nest readnone readonly inlinehint noinline alwaysinline optsize ssp sspreq noredzone noimplicitfloat naked builtin cold nobuiltin noduplicate nonlazybind optnone returns_twice sanitize_address sanitize_memory sanitize_thread sspstrong uwtable returned type opaque eq ne slt sgt sle sge ult ugt ule uge oeq one olt ogt ole oge ord uno ueq une x acq_rel acquire alignstack atomic catch cleanup filter inteldialect max min monotonic nand personality release seq_cst singlethread umax umin unordered xchg add fadd sub fsub mul fmul udiv sdiv fdiv urem srem frem shl lshr ashr and or xor icmp fcmp phi call trunc zext sext fptrunc fpext uitofp sitofp fptoui fptosi inttoptr ptrtoint bitcast addrspacecast select va_arg ret br switch invoke unwind unreachable indirectbr landingpad resume malloc alloca free load store getelementptr extractelement insertelement shufflevector getresult extractvalue insertvalue atomicrmw cmpxchg fence argmemonly double",
        contains: [
            {
                className: "keyword",
                begin: "i\\d+"
            },
            hljs.COMMENT(";", "\\n", {
                relevance: 0
            }),
            // Double quote string
            hljs.QUOTE_STRING_MODE,
            {
                className: "string",
                variants: [
                    // Double-quoted string
                    {
                        begin: '"',
                        end: '[^\\\\]"'
                    }
                ],
                relevance: 0
            },
            {
                className: "title",
                variants: [
                    {
                        begin: "@" + identifier
                    },
                    {
                        begin: "@\\d+"
                    },
                    {
                        begin: "!" + identifier
                    },
                    {
                        begin: "!\\d+" + identifier
                    }
                ]
            },
            {
                className: "symbol",
                variants: [
                    {
                        begin: "%" + identifier
                    },
                    {
                        begin: "%\\d+"
                    },
                    {
                        begin: "#\\d+"
                    }
                ]
            },
            {
                className: "number",
                variants: [
                    {
                        begin: "0[xX][a-fA-F0-9]+"
                    },
                    {
                        begin: "-?\\d+(?:[.]\\d+)?(?:[eE][-+]?\\d+(?:[.]\\d+)?)?"
                    }
                ],
                relevance: 0
            }
        ]
    };
};

});

parcelRegister("9Re3w", function(module, exports) {
module.exports = function(hljs) {
    var LSL_STRING_ESCAPE_CHARS = {
        className: "subst",
        begin: /\\[tn"\\]/
    };
    var LSL_STRINGS = {
        className: "string",
        begin: '"',
        end: '"',
        contains: [
            LSL_STRING_ESCAPE_CHARS
        ]
    };
    var LSL_NUMBERS = {
        className: "number",
        begin: hljs.C_NUMBER_RE
    };
    var LSL_CONSTANTS = {
        className: "literal",
        variants: [
            {
                begin: "\\b(?:PI|TWO_PI|PI_BY_TWO|DEG_TO_RAD|RAD_TO_DEG|SQRT2)\\b"
            },
            {
                begin: "\\b(?:XP_ERROR_(?:EXPERIENCES_DISABLED|EXPERIENCE_(?:DISABLED|SUSPENDED)|INVALID_(?:EXPERIENCE|PARAMETERS)|KEY_NOT_FOUND|MATURITY_EXCEEDED|NONE|NOT_(?:FOUND|PERMITTED(?:_LAND)?)|NO_EXPERIENCE|QUOTA_EXCEEDED|RETRY_UPDATE|STORAGE_EXCEPTION|STORE_DISABLED|THROTTLED|UNKNOWN_ERROR)|JSON_APPEND|STATUS_(?:PHYSICS|ROTATE_[XYZ]|PHANTOM|SANDBOX|BLOCK_GRAB(?:_OBJECT)?|(?:DIE|RETURN)_AT_EDGE|CAST_SHADOWS|OK|MALFORMED_PARAMS|TYPE_MISMATCH|BOUNDS_ERROR|NOT_(?:FOUND|SUPPORTED)|INTERNAL_ERROR|WHITELIST_FAILED)|AGENT(?:_(?:BY_(?:LEGACY_|USER)NAME|FLYING|ATTACHMENTS|SCRIPTED|MOUSELOOK|SITTING|ON_OBJECT|AWAY|WALKING|IN_AIR|TYPING|CROUCHING|BUSY|ALWAYS_RUN|AUTOPILOT|LIST_(?:PARCEL(?:_OWNER)?|REGION)))?|CAMERA_(?:PITCH|DISTANCE|BEHINDNESS_(?:ANGLE|LAG)|(?:FOCUS|POSITION)(?:_(?:THRESHOLD|LOCKED|LAG))?|FOCUS_OFFSET|ACTIVE)|ANIM_ON|LOOP|REVERSE|PING_PONG|SMOOTH|ROTATE|SCALE|ALL_SIDES|LINK_(?:ROOT|SET|ALL_(?:OTHERS|CHILDREN)|THIS)|ACTIVE|PASS(?:IVE|_(?:ALWAYS|IF_NOT_HANDLED|NEVER))|SCRIPTED|CONTROL_(?:FWD|BACK|(?:ROT_)?(?:LEFT|RIGHT)|UP|DOWN|(?:ML_)?LBUTTON)|PERMISSION_(?:RETURN_OBJECTS|DEBIT|OVERRIDE_ANIMATIONS|SILENT_ESTATE_MANAGEMENT|TAKE_CONTROLS|TRIGGER_ANIMATION|ATTACH|CHANGE_LINKS|(?:CONTROL|TRACK)_CAMERA|TELEPORT)|INVENTORY_(?:TEXTURE|SOUND|OBJECT|SCRIPT|LANDMARK|CLOTHING|NOTECARD|BODYPART|ANIMATION|GESTURE|ALL|NONE)|CHANGED_(?:INVENTORY|COLOR|SHAPE|SCALE|TEXTURE|LINK|ALLOWED_DROP|OWNER|REGION(?:_START)?|TELEPORT|MEDIA)|OBJECT_(?:CLICK_ACTION|HOVER_HEIGHT|LAST_OWNER_ID|(?:PHYSICS|SERVER|STREAMING)_COST|UNKNOWN_DETAIL|CHARACTER_TIME|PHANTOM|PHYSICS|TEMP_(?:ATTACHED|ON_REZ)|NAME|DESC|POS|PRIM_(?:COUNT|EQUIVALENCE)|RETURN_(?:PARCEL(?:_OWNER)?|REGION)|REZZER_KEY|ROO?T|VELOCITY|OMEGA|OWNER|GROUP(?:_TAG)?|CREATOR|ATTACHED_(?:POINT|SLOTS_AVAILABLE)|RENDER_WEIGHT|(?:BODY_SHAPE|PATHFINDING)_TYPE|(?:RUNNING|TOTAL)_SCRIPT_COUNT|TOTAL_INVENTORY_COUNT|SCRIPT_(?:MEMORY|TIME))|TYPE_(?:INTEGER|FLOAT|STRING|KEY|VECTOR|ROTATION|INVALID)|(?:DEBUG|PUBLIC)_CHANNEL|ATTACH_(?:AVATAR_CENTER|CHEST|HEAD|BACK|PELVIS|MOUTH|CHIN|NECK|NOSE|BELLY|[LR](?:SHOULDER|HAND|FOOT|EAR|EYE|[UL](?:ARM|LEG)|HIP)|(?:LEFT|RIGHT)_PEC|HUD_(?:CENTER_[12]|TOP_(?:RIGHT|CENTER|LEFT)|BOTTOM(?:_(?:RIGHT|LEFT))?)|[LR]HAND_RING1|TAIL_(?:BASE|TIP)|[LR]WING|FACE_(?:JAW|[LR]EAR|[LR]EYE|TOUNGE)|GROIN|HIND_[LR]FOOT)|LAND_(?:LEVEL|RAISE|LOWER|SMOOTH|NOISE|REVERT)|DATA_(?:ONLINE|NAME|BORN|SIM_(?:POS|STATUS|RATING)|PAYINFO)|PAYMENT_INFO_(?:ON_FILE|USED)|REMOTE_DATA_(?:CHANNEL|REQUEST|REPLY)|PSYS_(?:PART_(?:BF_(?:ZERO|ONE(?:_MINUS_(?:DEST_COLOR|SOURCE_(ALPHA|COLOR)))?|DEST_COLOR|SOURCE_(ALPHA|COLOR))|BLEND_FUNC_(DEST|SOURCE)|FLAGS|(?:START|END)_(?:COLOR|ALPHA|SCALE|GLOW)|MAX_AGE|(?:RIBBON|WIND|INTERP_(?:COLOR|SCALE)|BOUNCE|FOLLOW_(?:SRC|VELOCITY)|TARGET_(?:POS|LINEAR)|EMISSIVE)_MASK)|SRC_(?:MAX_AGE|PATTERN|ANGLE_(?:BEGIN|END)|BURST_(?:RATE|PART_COUNT|RADIUS|SPEED_(?:MIN|MAX))|ACCEL|TEXTURE|TARGET_KEY|OMEGA|PATTERN_(?:DROP|EXPLODE|ANGLE(?:_CONE(?:_EMPTY)?)?)))|VEHICLE_(?:REFERENCE_FRAME|TYPE_(?:NONE|SLED|CAR|BOAT|AIRPLANE|BALLOON)|(?:LINEAR|ANGULAR)_(?:FRICTION_TIMESCALE|MOTOR_DIRECTION)|LINEAR_MOTOR_OFFSET|HOVER_(?:HEIGHT|EFFICIENCY|TIMESCALE)|BUOYANCY|(?:LINEAR|ANGULAR)_(?:DEFLECTION_(?:EFFICIENCY|TIMESCALE)|MOTOR_(?:DECAY_)?TIMESCALE)|VERTICAL_ATTRACTION_(?:EFFICIENCY|TIMESCALE)|BANKING_(?:EFFICIENCY|MIX|TIMESCALE)|FLAG_(?:NO_DEFLECTION_UP|LIMIT_(?:ROLL_ONLY|MOTOR_UP)|HOVER_(?:(?:WATER|TERRAIN|UP)_ONLY|GLOBAL_HEIGHT)|MOUSELOOK_(?:STEER|BANK)|CAMERA_DECOUPLED))|PRIM_(?:ALLOW_UNSIT|ALPHA_MODE(?:_(?:BLEND|EMISSIVE|MASK|NONE))?|NORMAL|SPECULAR|TYPE(?:_(?:BOX|CYLINDER|PRISM|SPHERE|TORUS|TUBE|RING|SCULPT))?|HOLE_(?:DEFAULT|CIRCLE|SQUARE|TRIANGLE)|MATERIAL(?:_(?:STONE|METAL|GLASS|WOOD|FLESH|PLASTIC|RUBBER))?|SHINY_(?:NONE|LOW|MEDIUM|HIGH)|BUMP_(?:NONE|BRIGHT|DARK|WOOD|BARK|BRICKS|CHECKER|CONCRETE|TILE|STONE|DISKS|GRAVEL|BLOBS|SIDING|LARGETILE|STUCCO|SUCTION|WEAVE)|TEXGEN_(?:DEFAULT|PLANAR)|SCRIPTED_SIT_ONLY|SCULPT_(?:TYPE_(?:SPHERE|TORUS|PLANE|CYLINDER|MASK)|FLAG_(?:MIRROR|INVERT))|PHYSICS(?:_(?:SHAPE_(?:CONVEX|NONE|PRIM|TYPE)))?|(?:POS|ROT)_LOCAL|SLICE|TEXT|FLEXIBLE|POINT_LIGHT|TEMP_ON_REZ|PHANTOM|POSITION|SIT_TARGET|SIZE|ROTATION|TEXTURE|NAME|OMEGA|DESC|LINK_TARGET|COLOR|BUMP_SHINY|FULLBRIGHT|TEXGEN|GLOW|MEDIA_(?:ALT_IMAGE_ENABLE|CONTROLS|(?:CURRENT|HOME)_URL|AUTO_(?:LOOP|PLAY|SCALE|ZOOM)|FIRST_CLICK_INTERACT|(?:WIDTH|HEIGHT)_PIXELS|WHITELIST(?:_ENABLE)?|PERMS_(?:INTERACT|CONTROL)|PARAM_MAX|CONTROLS_(?:STANDARD|MINI)|PERM_(?:NONE|OWNER|GROUP|ANYONE)|MAX_(?:URL_LENGTH|WHITELIST_(?:SIZE|COUNT)|(?:WIDTH|HEIGHT)_PIXELS)))|MASK_(?:BASE|OWNER|GROUP|EVERYONE|NEXT)|PERM_(?:TRANSFER|MODIFY|COPY|MOVE|ALL)|PARCEL_(?:MEDIA_COMMAND_(?:STOP|PAUSE|PLAY|LOOP|TEXTURE|URL|TIME|AGENT|UNLOAD|AUTO_ALIGN|TYPE|SIZE|DESC|LOOP_SET)|FLAG_(?:ALLOW_(?:FLY|(?:GROUP_)?SCRIPTS|LANDMARK|TERRAFORM|DAMAGE|CREATE_(?:GROUP_)?OBJECTS)|USE_(?:ACCESS_(?:GROUP|LIST)|BAN_LIST|LAND_PASS_LIST)|LOCAL_SOUND_ONLY|RESTRICT_PUSHOBJECT|ALLOW_(?:GROUP|ALL)_OBJECT_ENTRY)|COUNT_(?:TOTAL|OWNER|GROUP|OTHER|SELECTED|TEMP)|DETAILS_(?:NAME|DESC|OWNER|GROUP|AREA|ID|SEE_AVATARS))|LIST_STAT_(?:MAX|MIN|MEAN|MEDIAN|STD_DEV|SUM(?:_SQUARES)?|NUM_COUNT|GEOMETRIC_MEAN|RANGE)|PAY_(?:HIDE|DEFAULT)|REGION_FLAG_(?:ALLOW_DAMAGE|FIXED_SUN|BLOCK_TERRAFORM|SANDBOX|DISABLE_(?:COLLISIONS|PHYSICS)|BLOCK_FLY|ALLOW_DIRECT_TELEPORT|RESTRICT_PUSHOBJECT)|HTTP_(?:METHOD|MIMETYPE|BODY_(?:MAXLENGTH|TRUNCATED)|CUSTOM_HEADER|PRAGMA_NO_CACHE|VERBOSE_THROTTLE|VERIFY_CERT)|SIT_(?:INVALID_(?:AGENT|LINK_OBJECT)|NO(?:T_EXPERIENCE|_(?:ACCESS|EXPERIENCE_PERMISSION|SIT_TARGET)))|STRING_(?:TRIM(?:_(?:HEAD|TAIL))?)|CLICK_ACTION_(?:NONE|TOUCH|SIT|BUY|PAY|OPEN(?:_MEDIA)?|PLAY|ZOOM)|TOUCH_INVALID_FACE|PROFILE_(?:NONE|SCRIPT_MEMORY)|RC_(?:DATA_FLAGS|DETECT_PHANTOM|GET_(?:LINK_NUM|NORMAL|ROOT_KEY)|MAX_HITS|REJECT_(?:TYPES|AGENTS|(?:NON)?PHYSICAL|LAND))|RCERR_(?:CAST_TIME_EXCEEDED|SIM_PERF_LOW|UNKNOWN)|ESTATE_ACCESS_(?:ALLOWED_(?:AGENT|GROUP)_(?:ADD|REMOVE)|BANNED_AGENT_(?:ADD|REMOVE))|DENSITY|FRICTION|RESTITUTION|GRAVITY_MULTIPLIER|KFM_(?:COMMAND|CMD_(?:PLAY|STOP|PAUSE)|MODE|FORWARD|LOOP|PING_PONG|REVERSE|DATA|ROTATION|TRANSLATION)|ERR_(?:GENERIC|PARCEL_PERMISSIONS|MALFORMED_PARAMS|RUNTIME_PERMISSIONS|THROTTLED)|CHARACTER_(?:CMD_(?:(?:SMOOTH_)?STOP|JUMP)|DESIRED_(?:TURN_)?SPEED|RADIUS|STAY_WITHIN_PARCEL|LENGTH|ORIENTATION|ACCOUNT_FOR_SKIPPED_FRAMES|AVOIDANCE_MODE|TYPE(?:_(?:[ABCD]|NONE))?|MAX_(?:DECEL|TURN_RADIUS|(?:ACCEL|SPEED)))|PURSUIT_(?:OFFSET|FUZZ_FACTOR|GOAL_TOLERANCE|INTERCEPT)|REQUIRE_LINE_OF_SIGHT|FORCE_DIRECT_PATH|VERTICAL|HORIZONTAL|AVOID_(?:CHARACTERS|DYNAMIC_OBSTACLES|NONE)|PU_(?:EVADE_(?:HIDDEN|SPOTTED)|FAILURE_(?:DYNAMIC_PATHFINDING_DISABLED|INVALID_(?:GOAL|START)|NO_(?:NAVMESH|VALID_DESTINATION)|OTHER|TARGET_GONE|(?:PARCEL_)?UNREACHABLE)|(?:GOAL|SLOWDOWN_DISTANCE)_REACHED)|TRAVERSAL_TYPE(?:_(?:FAST|NONE|SLOW))?|CONTENT_TYPE_(?:ATOM|FORM|HTML|JSON|LLSD|RSS|TEXT|XHTML|XML)|GCNP_(?:RADIUS|STATIC)|(?:PATROL|WANDER)_PAUSE_AT_WAYPOINTS|OPT_(?:AVATAR|CHARACTER|EXCLUSION_VOLUME|LEGACY_LINKSET|MATERIAL_VOLUME|OTHER|STATIC_OBSTACLE|WALKABLE)|SIM_STAT_PCT_CHARS_STEPPED)\\b"
            },
            {
                begin: "\\b(?:FALSE|TRUE)\\b"
            },
            {
                begin: "\\b(?:ZERO_ROTATION)\\b"
            },
            {
                begin: "\\b(?:EOF|JSON_(?:ARRAY|DELETE|FALSE|INVALID|NULL|NUMBER|OBJECT|STRING|TRUE)|NULL_KEY|TEXTURE_(?:BLANK|DEFAULT|MEDIA|PLYWOOD|TRANSPARENT)|URL_REQUEST_(?:GRANTED|DENIED))\\b"
            },
            {
                begin: "\\b(?:ZERO_VECTOR|TOUCH_INVALID_(?:TEXCOORD|VECTOR))\\b"
            }
        ]
    };
    var LSL_FUNCTIONS = {
        className: "built_in",
        begin: "\\b(?:ll(?:AgentInExperience|(?:Create|DataSize|Delete|KeyCount|Keys|Read|Update)KeyValue|GetExperience(?:Details|ErrorMessage)|ReturnObjectsBy(?:ID|Owner)|Json(?:2List|[GS]etValue|ValueType)|Sin|Cos|Tan|Atan2|Sqrt|Pow|Abs|Fabs|Frand|Floor|Ceil|Round|Vec(?:Mag|Norm|Dist)|Rot(?:Between|2(?:Euler|Fwd|Left|Up))|(?:Euler|Axes)2Rot|Whisper|(?:Region|Owner)?Say|Shout|Listen(?:Control|Remove)?|Sensor(?:Repeat|Remove)?|Detected(?:Name|Key|Owner|Type|Pos|Vel|Grab|Rot|Group|LinkNumber)|Die|Ground|Wind|(?:[GS]et)(?:AnimationOverride|MemoryLimit|PrimMediaParams|ParcelMusicURL|Object(?:Desc|Name)|PhysicsMaterial|Status|Scale|Color|Alpha|Texture|Pos|Rot|Force|Torque)|ResetAnimationOverride|(?:Scale|Offset|Rotate)Texture|(?:Rot)?Target(?:Remove)?|(?:Stop)?MoveToTarget|Apply(?:Rotational)?Impulse|Set(?:KeyframedMotion|ContentType|RegionPos|(?:Angular)?Velocity|Buoyancy|HoverHeight|ForceAndTorque|TimerEvent|ScriptState|Damage|TextureAnim|Sound(?:Queueing|Radius)|Vehicle(?:Type|(?:Float|Vector|Rotation)Param)|(?:Touch|Sit)?Text|Camera(?:Eye|At)Offset|PrimitiveParams|ClickAction|Link(?:Alpha|Color|PrimitiveParams(?:Fast)?|Texture(?:Anim)?|Camera|Media)|RemoteScriptAccessPin|PayPrice|LocalRot)|ScaleByFactor|Get(?:(?:Max|Min)ScaleFactor|ClosestNavPoint|StaticPath|SimStats|Env|PrimitiveParams|Link(?:PrimitiveParams|Number(?:OfSides)?|Key|Name|Media)|HTTPHeader|FreeURLs|Object(?:Details|PermMask|PrimCount)|Parcel(?:MaxPrims|Details|Prim(?:Count|Owners))|Attached(?:List)?|(?:SPMax|Free|Used)Memory|Region(?:Name|TimeDilation|FPS|Corner|AgentCount)|Root(?:Position|Rotation)|UnixTime|(?:Parcel|Region)Flags|(?:Wall|GMT)clock|SimulatorHostname|BoundingBox|GeometricCenter|Creator|NumberOf(?:Prims|NotecardLines|Sides)|Animation(?:List)?|(?:Camera|Local)(?:Pos|Rot)|Vel|Accel|Omega|Time(?:stamp|OfDay)|(?:Object|CenterOf)?Mass|MassMKS|Energy|Owner|(?:Owner)?Key|SunDirection|Texture(?:Offset|Scale|Rot)|Inventory(?:Number|Name|Key|Type|Creator|PermMask)|Permissions(?:Key)?|StartParameter|List(?:Length|EntryType)|Date|Agent(?:Size|Info|Language|List)|LandOwnerAt|NotecardLine|Script(?:Name|State))|(?:Get|Reset|GetAndReset)Time|PlaySound(?:Slave)?|LoopSound(?:Master|Slave)?|(?:Trigger|Stop|Preload)Sound|(?:(?:Get|Delete)Sub|Insert)String|To(?:Upper|Lower)|Give(?:InventoryList|Money)|RezObject|(?:Stop)?LookAt|Sleep|CollisionFilter|(?:Take|Release)Controls|DetachFromAvatar|AttachToAvatar(?:Temp)?|InstantMessage|(?:GetNext)?Email|StopHover|MinEventDelay|RotLookAt|String(?:Length|Trim)|(?:Start|Stop)Animation|TargetOmega|Request(?:Experience)?Permissions|(?:Create|Break)Link|BreakAllLinks|(?:Give|Remove)Inventory|Water|PassTouches|Request(?:Agent|Inventory)Data|TeleportAgent(?:Home|GlobalCoords)?|ModifyLand|CollisionSound|ResetScript|MessageLinked|PushObject|PassCollisions|AxisAngle2Rot|Rot2(?:Axis|Angle)|A(?:cos|sin)|AngleBetween|AllowInventoryDrop|SubStringIndex|List2(?:CSV|Integer|Json|Float|String|Key|Vector|Rot|List(?:Strided)?)|DeleteSubList|List(?:Statistics|Sort|Randomize|(?:Insert|Find|Replace)List)|EdgeOfWorld|AdjustSoundVolume|Key2Name|TriggerSoundLimited|EjectFromLand|(?:CSV|ParseString)2List|OverMyLand|SameGroup|UnSit|Ground(?:Slope|Normal|Contour)|GroundRepel|(?:Set|Remove)VehicleFlags|SitOnLink|(?:AvatarOn)?(?:Link)?SitTarget|Script(?:Danger|Profiler)|Dialog|VolumeDetect|ResetOtherScript|RemoteLoadScriptPin|(?:Open|Close)RemoteDataChannel|SendRemoteData|RemoteDataReply|(?:Integer|String)ToBase64|XorBase64|Log(?:10)?|Base64To(?:String|Integer)|ParseStringKeepNulls|RezAtRoot|RequestSimulatorData|ForceMouselook|(?:Load|Release|(?:E|Une)scape)URL|ParcelMedia(?:CommandList|Query)|ModPow|MapDestination|(?:RemoveFrom|AddTo|Reset)Land(?:Pass|Ban)List|(?:Set|Clear)CameraParams|HTTP(?:Request|Response)|TextBox|DetectedTouch(?:UV|Face|Pos|(?:N|Bin)ormal|ST)|(?:MD5|SHA1|DumpList2)String|Request(?:Secure)?URL|Clear(?:Prim|Link)Media|(?:Link)?ParticleSystem|(?:Get|Request)(?:Username|DisplayName)|RegionSayTo|CastRay|GenerateKey|TransferLindenDollars|ManageEstateAccess|(?:Create|Delete)Character|ExecCharacterCmd|Evade|FleeFrom|NavigateTo|PatrolPoints|Pursue|UpdateCharacter|WanderWithin))\\b"
    };
    return {
        illegal: ":",
        contains: [
            LSL_STRINGS,
            {
                className: "comment",
                variants: [
                    hljs.COMMENT("//", "$"),
                    hljs.COMMENT("/\\*", "\\*/")
                ],
                relevance: 0
            },
            LSL_NUMBERS,
            {
                className: "section",
                variants: [
                    {
                        begin: "\\b(?:state|default)\\b"
                    },
                    {
                        begin: "\\b(?:state_(?:entry|exit)|touch(?:_(?:start|end))?|(?:land_)?collision(?:_(?:start|end))?|timer|listen|(?:no_)?sensor|control|(?:not_)?at_(?:rot_)?target|money|email|experience_permissions(?:_denied)?|run_time_permissions|changed|attach|dataserver|moving_(?:start|end)|link_message|(?:on|object)_rez|remote_data|http_re(?:sponse|quest)|path_update|transaction_result)\\b"
                    }
                ]
            },
            LSL_FUNCTIONS,
            LSL_CONSTANTS,
            {
                className: "type",
                begin: "\\b(?:integer|float|string|key|vector|quaternion|rotation|list)\\b"
            }
        ]
    };
};

});

parcelRegister("7rY7i", function(module, exports) {
module.exports = function(hljs) {
    var OPENING_LONG_BRACKET = "\\[=*\\[";
    var CLOSING_LONG_BRACKET = "\\]=*\\]";
    var LONG_BRACKETS = {
        begin: OPENING_LONG_BRACKET,
        end: CLOSING_LONG_BRACKET,
        contains: [
            "self"
        ]
    };
    var COMMENTS = [
        hljs.COMMENT("--(?!" + OPENING_LONG_BRACKET + ")", "$"),
        hljs.COMMENT("--" + OPENING_LONG_BRACKET, CLOSING_LONG_BRACKET, {
            contains: [
                LONG_BRACKETS
            ],
            relevance: 10
        })
    ];
    return {
        lexemes: hljs.UNDERSCORE_IDENT_RE,
        keywords: {
            literal: "true false nil",
            keyword: "and break do else elseif end for goto if in local not or repeat return then until while",
            built_in: //Metatags and globals:
            "_G _ENV _VERSION __index __newindex __mode __call __metatable __tostring __len __gc __add __sub __mul __div __mod __pow __concat __unm __eq __lt __le assert collectgarbage dofile error getfenv getmetatable ipairs load loadfile loadstringmodule next pairs pcall print rawequal rawget rawset require select setfenvsetmetatable tonumber tostring type unpack xpcall arg selfcoroutine resume yield status wrap create running debug getupvalue debug sethook getmetatable gethook setmetatable setlocal traceback setfenv getinfo setupvalue getlocal getregistry getfenv io lines write close flush open output type read stderr stdin input stdout popen tmpfile math log max acos huge ldexp pi cos tanh pow deg tan cosh sinh random randomseed frexp ceil floor rad abs sqrt modf asin min mod fmod log10 atan2 exp sin atan os exit setlocale date getenv difftime remove time clock tmpname rename execute package preload loadlib loaded loaders cpath config path seeall string sub upper len gfind rep find match char dump gmatch reverse byte format gsub lower table setn insert getn foreachi maxn foreach concat sort remove"
        },
        contains: COMMENTS.concat([
            {
                className: "function",
                beginKeywords: "function",
                end: "\\)",
                contains: [
                    hljs.inherit(hljs.TITLE_MODE, {
                        begin: "([_a-zA-Z]\\w*\\.)*([_a-zA-Z]\\w*:)?[_a-zA-Z]\\w*"
                    }),
                    {
                        className: "params",
                        begin: "\\(",
                        endsWithParent: true,
                        contains: COMMENTS
                    }
                ].concat(COMMENTS)
            },
            hljs.C_NUMBER_MODE,
            hljs.APOS_STRING_MODE,
            hljs.QUOTE_STRING_MODE,
            {
                className: "string",
                begin: OPENING_LONG_BRACKET,
                end: CLOSING_LONG_BRACKET,
                contains: [
                    LONG_BRACKETS
                ],
                relevance: 5
            }
        ])
    };
};

});

parcelRegister("6YHAI", function(module, exports) {
module.exports = function(hljs) {
    /* Variables: simple (eg $(var)) and special (eg $@) */ var VARIABLE = {
        className: "variable",
        variants: [
            {
                begin: "\\$\\(" + hljs.UNDERSCORE_IDENT_RE + "\\)",
                contains: [
                    hljs.BACKSLASH_ESCAPE
                ]
            },
            {
                begin: /\$[@%<?\^\+\*]/
            }
        ]
    };
    /* Quoted string with variables inside */ var QUOTE_STRING = {
        className: "string",
        begin: /"/,
        end: /"/,
        contains: [
            hljs.BACKSLASH_ESCAPE,
            VARIABLE
        ]
    };
    /* Function: $(func arg,...) */ var FUNC = {
        className: "variable",
        begin: /\$\([\w-]+\s/,
        end: /\)/,
        keywords: {
            built_in: "subst patsubst strip findstring filter filter-out sort word wordlist firstword lastword dir notdir suffix basename addsuffix addprefix join wildcard realpath abspath error warning shell origin flavor foreach if or and call eval file value"
        },
        contains: [
            VARIABLE
        ]
    };
    /* Variable assignment */ var ASSIGNMENT = {
        begin: "^" + hljs.UNDERSCORE_IDENT_RE + "\\s*(?=[:+?]?=)"
    };
    /* Meta targets (.PHONY) */ var META = {
        className: "meta",
        begin: /^\.PHONY:/,
        end: /$/,
        keywords: {
            "meta-keyword": ".PHONY"
        },
        lexemes: /[\.\w]+/
    };
    /* Targets */ var TARGET = {
        className: "section",
        begin: /^[^\s]+:/,
        end: /$/,
        contains: [
            VARIABLE
        ]
    };
    return {
        aliases: [
            "mk",
            "mak"
        ],
        keywords: "define endef undefine ifdef ifndef ifeq ifneq else endif include -include sinclude override export unexport private vpath",
        lexemes: /[\w-]+/,
        contains: [
            hljs.HASH_COMMENT_MODE,
            VARIABLE,
            QUOTE_STRING,
            FUNC,
            ASSIGNMENT,
            META,
            TARGET
        ]
    };
};

});

parcelRegister("9e07y", function(module, exports) {
module.exports = function(hljs) {
    return {
        aliases: [
            "mma",
            "wl"
        ],
        lexemes: "(\\$|\\b)" + hljs.IDENT_RE + "\\b",
        //
        // The list of "keywords" (System` symbols) was determined by evaluating the following Wolfram Language code in Mathematica 12.0:
        //
        // StringRiffle[
        //   "'" <> StringRiffle[#, " "] <> "'" & /@
        //     Values[GroupBy[
        //       Select[Names["System`*"],
        //       StringStartsQ[#, CharacterRange["A", "Z"] | "$"] &],
        //       First[Characters[#]] &]], " +\n"]
        //
        keywords: "AASTriangle AbelianGroup Abort AbortKernels AbortProtect AbortScheduledTask Above Abs AbsArg AbsArgPlot Absolute AbsoluteCorrelation AbsoluteCorrelationFunction AbsoluteCurrentValue AbsoluteDashing AbsoluteFileName AbsoluteOptions AbsolutePointSize AbsoluteThickness AbsoluteTime AbsoluteTiming AcceptanceThreshold AccountingForm Accumulate Accuracy AccuracyGoal ActionDelay ActionMenu ActionMenuBox ActionMenuBoxOptions Activate Active ActiveClassification ActiveClassificationObject ActiveItem ActivePrediction ActivePredictionObject ActiveStyle AcyclicGraphQ AddOnHelpPath AddSides AddTo AddToSearchIndex AddUsers AdjacencyGraph AdjacencyList AdjacencyMatrix AdjustmentBox AdjustmentBoxOptions AdjustTimeSeriesForecast AdministrativeDivisionData AffineHalfSpace AffineSpace AffineStateSpaceModel AffineTransform After AggregatedEntityClass AggregationLayer AircraftData AirportData AirPressureData AirTemperatureData AiryAi AiryAiPrime AiryAiZero AiryBi AiryBiPrime AiryBiZero AlgebraicIntegerQ AlgebraicNumber AlgebraicNumberDenominator AlgebraicNumberNorm AlgebraicNumberPolynomial AlgebraicNumberTrace AlgebraicRules AlgebraicRulesData Algebraics AlgebraicUnitQ Alignment AlignmentMarker AlignmentPoint All AllowAdultContent AllowedCloudExtraParameters AllowedCloudParameterExtensions AllowedDimensions AllowedFrequencyRange AllowedHeads AllowGroupClose AllowIncomplete AllowInlineCells AllowKernelInitialization AllowLooseGrammar AllowReverseGroupClose AllowScriptLevelChange AllTrue Alphabet AlphabeticOrder AlphabeticSort AlphaChannel AlternateImage AlternatingFactorial AlternatingGroup AlternativeHypothesis Alternatives AltitudeMethod AmbientLight AmbiguityFunction AmbiguityList Analytic AnatomyData AnatomyForm AnatomyPlot3D AnatomySkinStyle AnatomyStyling AnchoredSearch And AndersonDarlingTest AngerJ AngleBisector AngleBracket AnglePath AnglePath3D AngleVector AngularGauge Animate AnimationCycleOffset AnimationCycleRepetitions AnimationDirection AnimationDisplayTime AnimationRate AnimationRepetitions AnimationRunning AnimationRunTime AnimationTimeIndex Animator AnimatorBox AnimatorBoxOptions AnimatorElements Annotate Annotation AnnotationDelete AnnotationNames AnnotationRules AnnotationValue Annuity AnnuityDue Annulus AnomalyDetection AnomalyDetectorFunction Anonymous Antialiasing AntihermitianMatrixQ Antisymmetric AntisymmetricMatrixQ Antonyms AnyOrder AnySubset AnyTrue Apart ApartSquareFree APIFunction Appearance AppearanceElements AppearanceRules AppellF1 Append AppendCheck AppendLayer AppendTo ApplicationIdentificationKey Apply ApplySides ArcCos ArcCosh ArcCot ArcCoth ArcCsc ArcCsch ArcCurvature ARCHProcess ArcLength ArcSec ArcSech ArcSin ArcSinDistribution ArcSinh ArcTan ArcTanh Area Arg ArgMax ArgMin ArgumentCountQ ARIMAProcess ArithmeticGeometricMean ARMAProcess Around AroundReplace ARProcess Array ArrayComponents ArrayDepth ArrayFilter ArrayFlatten ArrayMesh ArrayPad ArrayPlot ArrayQ ArrayResample ArrayReshape ArrayRules Arrays Arrow Arrow3DBox ArrowBox Arrowheads ASATriangle Ask AskAppend AskConfirm AskDisplay AskedQ AskedValue AskFunction AskState AskTemplateDisplay AspectRatio AspectRatioFixed Assert AssociateTo Association AssociationFormat AssociationMap AssociationQ AssociationThread AssumeDeterministic Assuming Assumptions AstronomicalData AsymptoticDSolveValue AsymptoticEqual AsymptoticEquivalent AsymptoticGreater AsymptoticGreaterEqual AsymptoticIntegrate AsymptoticLess AsymptoticLessEqual AsymptoticOutputTracker AsymptoticRSolveValue AsymptoticSolve AsymptoticSum Asynchronous AsynchronousTaskObject AsynchronousTasks Atom AtomCoordinates AtomCount AtomDiagramCoordinates AtomList AtomQ AttentionLayer Attributes Audio AudioAmplify AudioAnnotate AudioAnnotationLookup AudioBlockMap AudioCapture AudioChannelAssignment AudioChannelCombine AudioChannelMix AudioChannels AudioChannelSeparate AudioData AudioDelay AudioDelete AudioDevice AudioDistance AudioFade AudioFrequencyShift AudioGenerator AudioIdentify AudioInputDevice AudioInsert AudioIntervals AudioJoin AudioLabel AudioLength AudioLocalMeasurements AudioLooping AudioLoudness AudioMeasurements AudioNormalize AudioOutputDevice AudioOverlay AudioPad AudioPan AudioPartition AudioPause AudioPitchShift AudioPlay AudioPlot AudioQ AudioRecord AudioReplace AudioResample AudioReverb AudioSampleRate AudioSpectralMap AudioSpectralTransformation AudioSplit AudioStop AudioStream AudioStreams AudioTimeStretch AudioTrim AudioType AugmentedPolyhedron AugmentedSymmetricPolynomial Authenticate Authentication AuthenticationDialog AutoAction Autocomplete AutocompletionFunction AutoCopy AutocorrelationTest AutoDelete AutoEvaluateEvents AutoGeneratedPackage AutoIndent AutoIndentSpacings AutoItalicWords AutoloadPath AutoMatch Automatic AutomaticImageSize AutoMultiplicationSymbol AutoNumberFormatting AutoOpenNotebooks AutoOpenPalettes AutoQuoteCharacters AutoRefreshed AutoRemove AutorunSequencing AutoScaling AutoScroll AutoSpacing AutoStyleOptions AutoStyleWords AutoSubmitting Axes AxesEdge AxesLabel AxesOrigin AxesStyle AxiomaticTheory AxisBabyMonsterGroupB Back Background BackgroundAppearance BackgroundTasksSettings Backslash Backsubstitution Backward Ball Band BandpassFilter BandstopFilter BarabasiAlbertGraphDistribution BarChart BarChart3D BarcodeImage BarcodeRecognize BaringhausHenzeTest BarLegend BarlowProschanImportance BarnesG BarOrigin BarSpacing BartlettHannWindow BartlettWindow BaseDecode BaseEncode BaseForm Baseline BaselinePosition BaseStyle BasicRecurrentLayer BatchNormalizationLayer BatchSize BatesDistribution BattleLemarieWavelet BayesianMaximization BayesianMaximizationObject BayesianMinimization BayesianMinimizationObject Because BeckmannDistribution Beep Before Begin BeginDialogPacket BeginFrontEndInteractionPacket BeginPackage BellB BellY Below BenfordDistribution BeniniDistribution BenktanderGibratDistribution BenktanderWeibullDistribution BernoulliB BernoulliDistribution BernoulliGraphDistribution BernoulliProcess BernsteinBasis BesselFilterModel BesselI BesselJ BesselJZero BesselK BesselY BesselYZero Beta BetaBinomialDistribution BetaDistribution BetaNegativeBinomialDistribution BetaPrimeDistribution BetaRegularized Between BetweennessCentrality BeveledPolyhedron BezierCurve BezierCurve3DBox BezierCurve3DBoxOptions BezierCurveBox BezierCurveBoxOptions BezierFunction BilateralFilter Binarize BinaryDeserialize BinaryDistance BinaryFormat BinaryImageQ BinaryRead BinaryReadList BinarySerialize BinaryWrite BinCounts BinLists Binomial BinomialDistribution BinomialProcess BinormalDistribution BiorthogonalSplineWavelet BipartiteGraphQ BiquadraticFilterModel BirnbaumImportance BirnbaumSaundersDistribution BitAnd BitClear BitGet BitLength BitNot BitOr BitSet BitShiftLeft BitShiftRight BitXor BiweightLocation BiweightMidvariance Black BlackmanHarrisWindow BlackmanNuttallWindow BlackmanWindow Blank BlankForm BlankNullSequence BlankSequence Blend Block BlockchainAddressData BlockchainBase BlockchainBlockData BlockchainContractValue BlockchainData BlockchainGet BlockchainKeyEncode BlockchainPut BlockchainTokenData BlockchainTransaction BlockchainTransactionData BlockchainTransactionSign BlockchainTransactionSubmit BlockMap BlockRandom BlomqvistBeta BlomqvistBetaTest Blue Blur BodePlot BohmanWindow Bold Bond BondCount BondList BondQ Bookmarks Boole BooleanConsecutiveFunction BooleanConvert BooleanCountingFunction BooleanFunction BooleanGraph BooleanMaxterms BooleanMinimize BooleanMinterms BooleanQ BooleanRegion Booleans BooleanStrings BooleanTable BooleanVariables BorderDimensions BorelTannerDistribution Bottom BottomHatTransform BoundaryDiscretizeGraphics BoundaryDiscretizeRegion BoundaryMesh BoundaryMeshRegion BoundaryMeshRegionQ BoundaryStyle BoundedRegionQ BoundingRegion Bounds Box BoxBaselineShift BoxData BoxDimensions Boxed Boxes BoxForm BoxFormFormatTypes BoxFrame BoxID BoxMargins BoxMatrix BoxObject BoxRatios BoxRotation BoxRotationPoint BoxStyle BoxWhiskerChart Bra BracketingBar BraKet BrayCurtisDistance BreadthFirstScan Break BridgeData BrightnessEqualize BroadcastStationData Brown BrownForsytheTest BrownianBridgeProcess BrowserCategory BSplineBasis BSplineCurve BSplineCurve3DBox BSplineCurve3DBoxOptions BSplineCurveBox BSplineCurveBoxOptions BSplineFunction BSplineSurface BSplineSurface3DBox BSplineSurface3DBoxOptions BubbleChart BubbleChart3D BubbleScale BubbleSizes BuildingData BulletGauge BusinessDayQ ButterflyGraph ButterworthFilterModel Button ButtonBar ButtonBox ButtonBoxOptions ButtonCell ButtonContents ButtonData ButtonEvaluator ButtonExpandable ButtonFrame ButtonFunction ButtonMargins ButtonMinHeight ButtonNote ButtonNotebook ButtonSource ButtonStyle ButtonStyleMenuListing Byte ByteArray ByteArrayFormat ByteArrayQ ByteArrayToString ByteCount ByteOrderingC CachedValue CacheGraphics CachePersistence CalendarConvert CalendarData CalendarType Callout CalloutMarker CalloutStyle CallPacket CanberraDistance Cancel CancelButton CandlestickChart CanonicalGraph CanonicalizePolygon CanonicalizePolyhedron CanonicalName CanonicalWarpingCorrespondence CanonicalWarpingDistance CantorMesh CantorStaircase Cap CapForm CapitalDifferentialD Capitalize CapsuleShape CaptureRunning CardinalBSplineBasis CarlemanLinearize CarmichaelLambda CaseOrdering Cases CaseSensitive Cashflow Casoratian Catalan CatalanNumber Catch Catenate CatenateLayer CauchyDistribution CauchyWindow CayleyGraph CDF CDFDeploy CDFInformation CDFWavelet Ceiling CelestialSystem Cell CellAutoOverwrite CellBaseline CellBoundingBox CellBracketOptions CellChangeTimes CellContents CellContext CellDingbat CellDynamicExpression CellEditDuplicate CellElementsBoundingBox CellElementSpacings CellEpilog CellEvaluationDuplicate CellEvaluationFunction CellEvaluationLanguage CellEventActions CellFrame CellFrameColor CellFrameLabelMargins CellFrameLabels CellFrameMargins CellGroup CellGroupData CellGrouping CellGroupingRules CellHorizontalScrolling CellID CellLabel CellLabelAutoDelete CellLabelMargins CellLabelPositioning CellLabelStyle CellLabelTemplate CellMargins CellObject CellOpen CellPrint CellProlog Cells CellSize CellStyle CellTags CellularAutomaton CensoredDistribution Censoring Center CenterArray CenterDot CentralFeature CentralMoment CentralMomentGeneratingFunction Cepstrogram CepstrogramArray CepstrumArray CForm ChampernowneNumber ChangeOptions ChannelBase ChannelBrokerAction ChannelDatabin ChannelHistoryLength ChannelListen ChannelListener ChannelListeners ChannelListenerWait ChannelObject ChannelPreSendFunction ChannelReceiverFunction ChannelSend ChannelSubscribers ChanVeseBinarize Character CharacterCounts CharacterEncoding CharacterEncodingsPath CharacteristicFunction CharacteristicPolynomial CharacterName CharacterRange Characters ChartBaseStyle ChartElementData ChartElementDataFunction ChartElementFunction ChartElements ChartLabels ChartLayout ChartLegends ChartStyle Chebyshev1FilterModel Chebyshev2FilterModel ChebyshevDistance ChebyshevT ChebyshevU Check CheckAbort CheckAll Checkbox CheckboxBar CheckboxBox CheckboxBoxOptions ChemicalData ChessboardDistance ChiDistribution ChineseRemainder ChiSquareDistribution ChoiceButtons ChoiceDialog CholeskyDecomposition Chop ChromaticityPlot ChromaticityPlot3D ChromaticPolynomial Circle CircleBox CircleDot CircleMinus CirclePlus CirclePoints CircleThrough CircleTimes CirculantGraph CircularOrthogonalMatrixDistribution CircularQuaternionMatrixDistribution CircularRealMatrixDistribution CircularSymplecticMatrixDistribution CircularUnitaryMatrixDistribution Circumsphere CityData ClassifierFunction ClassifierInformation ClassifierMeasurements ClassifierMeasurementsObject Classify ClassPriors Clear ClearAll ClearAttributes ClearCookies ClearPermissions ClearSystemCache ClebschGordan ClickPane Clip ClipboardNotebook ClipFill ClippingStyle ClipPlanes ClipPlanesStyle ClipRange Clock ClockGauge ClockwiseContourIntegral Close Closed CloseKernels ClosenessCentrality Closing ClosingAutoSave ClosingEvent CloudAccountData CloudBase CloudConnect CloudDeploy CloudDirectory CloudDisconnect CloudEvaluate CloudExport CloudExpression CloudExpressions CloudFunction CloudGet CloudImport CloudLoggingData CloudObject CloudObjectInformation CloudObjectInformationData CloudObjectNameFormat CloudObjects CloudObjectURLType CloudPublish CloudPut CloudRenderingMethod CloudSave CloudShare CloudSubmit CloudSymbol CloudUnshare ClusterClassify ClusterDissimilarityFunction ClusteringComponents ClusteringTree CMYKColor Coarse CodeAssistOptions Coefficient CoefficientArrays CoefficientDomain CoefficientList CoefficientRules CoifletWavelet Collect Colon ColonForm ColorBalance ColorCombine ColorConvert ColorCoverage ColorData ColorDataFunction ColorDetect ColorDistance ColorFunction ColorFunctionScaling Colorize ColorNegate ColorOutput ColorProfileData ColorQ ColorQuantize ColorReplace ColorRules ColorSelectorSettings ColorSeparate ColorSetter ColorSetterBox ColorSetterBoxOptions ColorSlider ColorsNear ColorSpace ColorToneMapping Column ColumnAlignments ColumnBackgrounds ColumnForm ColumnLines ColumnsEqual ColumnSpacings ColumnWidths CombinedEntityClass CombinerFunction CometData CommonDefaultFormatTypes Commonest CommonestFilter CommonName CommonUnits CommunityBoundaryStyle CommunityGraphPlot CommunityLabels CommunityRegionStyle CompanyData CompatibleUnitQ CompilationOptions CompilationTarget Compile Compiled CompiledCodeFunction CompiledFunction CompilerOptions Complement CompleteGraph CompleteGraphQ CompleteKaryTree CompletionsListPacket Complex Complexes ComplexExpand ComplexInfinity ComplexityFunction ComplexListPlot ComplexPlot ComplexPlot3D ComponentMeasurements ComponentwiseContextMenu Compose ComposeList ComposeSeries CompositeQ Composition CompoundElement CompoundExpression CompoundPoissonDistribution CompoundPoissonProcess CompoundRenewalProcess Compress CompressedData ComputeUncertainty Condition ConditionalExpression Conditioned Cone ConeBox ConfidenceLevel ConfidenceRange ConfidenceTransform ConfigurationPath ConformAudio ConformImages Congruent ConicHullRegion ConicHullRegion3DBox ConicHullRegionBox ConicOptimization Conjugate ConjugateTranspose Conjunction Connect ConnectedComponents ConnectedGraphComponents ConnectedGraphQ ConnectedMeshComponents ConnectedMoleculeComponents ConnectedMoleculeQ ConnectionSettings ConnectLibraryCallbackFunction ConnectSystemModelComponents ConnesWindow ConoverTest ConsoleMessage ConsoleMessagePacket ConsolePrint Constant ConstantArray ConstantArrayLayer ConstantImage ConstantPlusLayer ConstantRegionQ Constants ConstantTimesLayer ConstellationData ConstrainedMax ConstrainedMin Construct Containing ContainsAll ContainsAny ContainsExactly ContainsNone ContainsOnly ContentFieldOptions ContentLocationFunction ContentObject ContentPadding ContentsBoundingBox ContentSelectable ContentSize Context ContextMenu Contexts ContextToFileName Continuation Continue ContinuedFraction ContinuedFractionK ContinuousAction ContinuousMarkovProcess ContinuousTask ContinuousTimeModelQ ContinuousWaveletData ContinuousWaveletTransform ContourDetect ContourGraphics ContourIntegral ContourLabels ContourLines ContourPlot ContourPlot3D Contours ContourShading ContourSmoothing ContourStyle ContraharmonicMean ContrastiveLossLayer Control ControlActive ControlAlignment ControlGroupContentsBox ControllabilityGramian ControllabilityMatrix ControllableDecomposition ControllableModelQ ControllerDuration ControllerInformation ControllerInformationData ControllerLinking ControllerManipulate ControllerMethod ControllerPath ControllerState ControlPlacement ControlsRendering ControlType Convergents ConversionOptions ConversionRules ConvertToBitmapPacket ConvertToPostScript ConvertToPostScriptPacket ConvexHullMesh ConvexPolygonQ ConvexPolyhedronQ ConvolutionLayer Convolve ConwayGroupCo1 ConwayGroupCo2 ConwayGroupCo3 CookieFunction Cookies CoordinateBoundingBox CoordinateBoundingBoxArray CoordinateBounds CoordinateBoundsArray CoordinateChartData CoordinatesToolOptions CoordinateTransform CoordinateTransformData CoprimeQ Coproduct CopulaDistribution Copyable CopyDatabin CopyDirectory CopyFile CopyTag CopyToClipboard CornerFilter CornerNeighbors Correlation CorrelationDistance CorrelationFunction CorrelationTest Cos Cosh CoshIntegral CosineDistance CosineWindow CosIntegral Cot Coth Count CountDistinct CountDistinctBy CounterAssignments CounterBox CounterBoxOptions CounterClockwiseContourIntegral CounterEvaluator CounterFunction CounterIncrements CounterStyle CounterStyleMenuListing CountRoots CountryData Counts CountsBy Covariance CovarianceEstimatorFunction CovarianceFunction CoxianDistribution CoxIngersollRossProcess CoxModel CoxModelFit CramerVonMisesTest CreateArchive CreateCellID CreateChannel CreateCloudExpression CreateDatabin CreateDataSystemModel CreateDialog CreateDirectory CreateDocument CreateFile CreateIntermediateDirectories CreateManagedLibraryExpression CreateNotebook CreatePalette CreatePalettePacket CreatePermissionsGroup CreateScheduledTask CreateSearchIndex CreateSystemModel CreateTemporary CreateUUID CreateWindow CriterionFunction CriticalityFailureImportance CriticalitySuccessImportance CriticalSection Cross CrossEntropyLossLayer CrossingCount CrossingDetect CrossingPolygon CrossMatrix Csc Csch CTCLossLayer Cube CubeRoot Cubics Cuboid CuboidBox Cumulant CumulantGeneratingFunction Cup CupCap Curl CurlyDoubleQuote CurlyQuote CurrencyConvert CurrentDate CurrentImage CurrentlySpeakingPacket CurrentNotebookImage CurrentScreenImage CurrentValue Curry CurvatureFlowFilter CurveClosed Cyan CycleGraph CycleIndexPolynomial Cycles CyclicGroup Cyclotomic Cylinder CylinderBox CylindricalDecompositionD DagumDistribution DamData DamerauLevenshteinDistance DampingFactor Darker Dashed Dashing DatabaseConnect DatabaseDisconnect DatabaseReference Databin DatabinAdd DatabinRemove Databins DatabinUpload DataCompression DataDistribution DataRange DataReversed Dataset Date DateBounds Dated DateDelimiters DateDifference DatedUnit DateFormat DateFunction DateHistogram DateList DateListLogPlot DateListPlot DateListStepPlot DateObject DateObjectQ DateOverlapsQ DatePattern DatePlus DateRange DateReduction DateString DateTicksFormat DateValue DateWithinQ DaubechiesWavelet DavisDistribution DawsonF DayCount DayCountConvention DayHemisphere DaylightQ DayMatchQ DayName DayNightTerminator DayPlus DayRange DayRound DeBruijnGraph DeBruijnSequence Debug DebugTag Decapitalize Decimal DecimalForm DeclareKnownSymbols DeclarePackage Decompose DeconvolutionLayer Decrement Decrypt DecryptFile DedekindEta DeepSpaceProbeData Default DefaultAxesStyle DefaultBaseStyle DefaultBoxStyle DefaultButton DefaultColor DefaultControlPlacement DefaultDuplicateCellStyle DefaultDuration DefaultElement DefaultFaceGridsStyle DefaultFieldHintStyle DefaultFont DefaultFontProperties DefaultFormatType DefaultFormatTypeForStyle DefaultFrameStyle DefaultFrameTicksStyle DefaultGridLinesStyle DefaultInlineFormatType DefaultInputFormatType DefaultLabelStyle DefaultMenuStyle DefaultNaturalLanguage DefaultNewCellStyle DefaultNewInlineCellStyle DefaultNotebook DefaultOptions DefaultOutputFormatType DefaultPrintPrecision DefaultStyle DefaultStyleDefinitions DefaultTextFormatType DefaultTextInlineFormatType DefaultTicksStyle DefaultTooltipStyle DefaultValue DefaultValues Defer DefineExternal DefineInputStreamMethod DefineOutputStreamMethod DefineResourceFunction Definition Degree DegreeCentrality DegreeGraphDistribution DegreeLexicographic DegreeReverseLexicographic DEigensystem DEigenvalues Deinitialization Del DelaunayMesh Delayed Deletable Delete DeleteAnomalies DeleteBorderComponents DeleteCases DeleteChannel DeleteCloudExpression DeleteContents DeleteDirectory DeleteDuplicates DeleteDuplicatesBy DeleteFile DeleteMissing DeleteObject DeletePermissionsKey DeleteSearchIndex DeleteSmallComponents DeleteStopwords DeleteWithContents DeletionWarning DelimitedArray DelimitedSequence Delimiter DelimiterFlashTime DelimiterMatching Delimiters DeliveryFunction Dendrogram Denominator DensityGraphics DensityHistogram DensityPlot DensityPlot3D DependentVariables Deploy Deployed Depth DepthFirstScan Derivative DerivativeFilter DerivedKey DescriptorStateSpace DesignMatrix DestroyAfterEvaluation Det DeviceClose DeviceConfigure DeviceExecute DeviceExecuteAsynchronous DeviceObject DeviceOpen DeviceOpenQ DeviceRead DeviceReadBuffer DeviceReadLatest DeviceReadList DeviceReadTimeSeries Devices DeviceStreams DeviceWrite DeviceWriteBuffer DGaussianWavelet DiacriticalPositioning Diagonal DiagonalizableMatrixQ DiagonalMatrix DiagonalMatrixQ Dialog DialogIndent DialogInput DialogLevel DialogNotebook DialogProlog DialogReturn DialogSymbols Diamond DiamondMatrix DiceDissimilarity DictionaryLookup DictionaryWordQ DifferenceDelta DifferenceOrder DifferenceQuotient DifferenceRoot DifferenceRootReduce Differences DifferentialD DifferentialRoot DifferentialRootReduce DifferentiatorFilter DigitalSignature DigitBlock DigitBlockMinimum DigitCharacter DigitCount DigitQ DihedralAngle DihedralGroup Dilation DimensionalCombinations DimensionalMeshComponents DimensionReduce DimensionReducerFunction DimensionReduction Dimensions DiracComb DiracDelta DirectedEdge DirectedEdges DirectedGraph DirectedGraphQ DirectedInfinity Direction Directive Directory DirectoryName DirectoryQ DirectoryStack DirichletBeta DirichletCharacter DirichletCondition DirichletConvolve DirichletDistribution DirichletEta DirichletL DirichletLambda DirichletTransform DirichletWindow DisableConsolePrintPacket DisableFormatting DiscreteChirpZTransform DiscreteConvolve DiscreteDelta DiscreteHadamardTransform DiscreteIndicator DiscreteLimit DiscreteLQEstimatorGains DiscreteLQRegulatorGains DiscreteLyapunovSolve DiscreteMarkovProcess DiscreteMaxLimit DiscreteMinLimit DiscretePlot DiscretePlot3D DiscreteRatio DiscreteRiccatiSolve DiscreteShift DiscreteTimeModelQ DiscreteUniformDistribution DiscreteVariables DiscreteWaveletData DiscreteWaveletPacketTransform DiscreteWaveletTransform DiscretizeGraphics DiscretizeRegion Discriminant DisjointQ Disjunction Disk DiskBox DiskMatrix DiskSegment Dispatch DispatchQ DispersionEstimatorFunction Display DisplayAllSteps DisplayEndPacket DisplayFlushImagePacket DisplayForm DisplayFunction DisplayPacket DisplayRules DisplaySetSizePacket DisplayString DisplayTemporary DisplayWith DisplayWithRef DisplayWithVariable DistanceFunction DistanceMatrix DistanceTransform Distribute Distributed DistributedContexts DistributeDefinitions DistributionChart DistributionDomain DistributionFitTest DistributionParameterAssumptions DistributionParameterQ Dithering Div Divergence Divide DivideBy Dividers DivideSides Divisible Divisors DivisorSigma DivisorSum DMSList DMSString Do DockedCells DocumentGenerator DocumentGeneratorInformation DocumentGeneratorInformationData DocumentGenerators DocumentNotebook DocumentWeightingRules Dodecahedron DomainRegistrationInformation DominantColors DOSTextFormat Dot DotDashed DotEqual DotLayer DotPlusLayer Dotted DoubleBracketingBar DoubleContourIntegral DoubleDownArrow DoubleLeftArrow DoubleLeftRightArrow DoubleLeftTee DoubleLongLeftArrow DoubleLongLeftRightArrow DoubleLongRightArrow DoubleRightArrow DoubleRightTee DoubleUpArrow DoubleUpDownArrow DoubleVerticalBar DoublyInfinite Down DownArrow DownArrowBar DownArrowUpArrow DownLeftRightVector DownLeftTeeVector DownLeftVector DownLeftVectorBar DownRightTeeVector DownRightVector DownRightVectorBar Downsample DownTee DownTeeArrow DownValues DragAndDrop DrawEdges DrawFrontFaces DrawHighlighted Drop DropoutLayer DSolve DSolveValue Dt DualLinearProgramming DualPolyhedron DualSystemsModel DumpGet DumpSave DuplicateFreeQ Duration Dynamic DynamicBox DynamicBoxOptions DynamicEvaluationTimeout DynamicGeoGraphics DynamicImage DynamicLocation DynamicModule DynamicModuleBox DynamicModuleBoxOptions DynamicModuleParent DynamicModuleValues DynamicName DynamicNamespace DynamicReference DynamicSetting DynamicUpdating DynamicWrapper DynamicWrapperBox DynamicWrapperBoxOptionsE EarthImpactData EarthquakeData EccentricityCentrality Echo EchoFunction EclipseType EdgeAdd EdgeBetweennessCentrality EdgeCapacity EdgeCapForm EdgeColor EdgeConnectivity EdgeContract EdgeCost EdgeCount EdgeCoverQ EdgeCycleMatrix EdgeDashing EdgeDelete EdgeDetect EdgeForm EdgeIndex EdgeJoinForm EdgeLabeling EdgeLabels EdgeLabelStyle EdgeList EdgeOpacity EdgeQ EdgeRenderingFunction EdgeRules EdgeShapeFunction EdgeStyle EdgeThickness EdgeWeight EdgeWeightedGraphQ Editable EditButtonSettings EditCellTagsSettings EditDistance EffectiveInterest Eigensystem Eigenvalues EigenvectorCentrality Eigenvectors Element ElementData ElementwiseLayer ElidedForms Eliminate EliminationOrder Ellipsoid EllipticE EllipticExp EllipticExpPrime EllipticF EllipticFilterModel EllipticK EllipticLog EllipticNomeQ EllipticPi EllipticReducedHalfPeriods EllipticTheta EllipticThetaPrime EmbedCode EmbeddedHTML EmbeddedService EmbeddingLayer EmbeddingObject EmitSound EmphasizeSyntaxErrors EmpiricalDistribution Empty EmptyGraphQ EmptyRegion EnableConsolePrintPacket Enabled Encode Encrypt EncryptedObject EncryptFile End EndAdd EndDialogPacket EndFrontEndInteractionPacket EndOfBuffer EndOfFile EndOfLine EndOfString EndPackage EngineEnvironment EngineeringForm Enter EnterExpressionPacket EnterTextPacket Entity EntityClass EntityClassList EntityCopies EntityFunction EntityGroup EntityInstance EntityList EntityPrefetch EntityProperties EntityProperty EntityPropertyClass EntityRegister EntityStore EntityStores EntityTypeName EntityUnregister EntityValue Entropy EntropyFilter Environment Epilog EpilogFunction Equal EqualColumns EqualRows EqualTilde EqualTo EquatedTo Equilibrium EquirippleFilterKernel Equivalent Erf Erfc Erfi ErlangB ErlangC ErlangDistribution Erosion ErrorBox ErrorBoxOptions ErrorNorm ErrorPacket ErrorsDialogSettings EscapeRadius EstimatedBackground EstimatedDistribution EstimatedProcess EstimatorGains EstimatorRegulator EuclideanDistance EulerAngles EulerCharacteristic EulerE EulerGamma EulerianGraphQ EulerMatrix EulerPhi Evaluatable Evaluate Evaluated EvaluatePacket EvaluateScheduledTask EvaluationBox EvaluationCell EvaluationCompletionAction EvaluationData EvaluationElements EvaluationEnvironment EvaluationMode EvaluationMonitor EvaluationNotebook EvaluationObject EvaluationOrder Evaluator EvaluatorNames EvenQ EventData EventEvaluator EventHandler EventHandlerTag EventLabels EventSeries ExactBlackmanWindow ExactNumberQ ExactRootIsolation ExampleData Except ExcludedForms ExcludedLines ExcludedPhysicalQuantities ExcludePods Exclusions ExclusionsStyle Exists Exit ExitDialog ExoplanetData Exp Expand ExpandAll ExpandDenominator ExpandFileName ExpandNumerator Expectation ExpectationE ExpectedValue ExpGammaDistribution ExpIntegralE ExpIntegralEi ExpirationDate Exponent ExponentFunction ExponentialDistribution ExponentialFamily ExponentialGeneratingFunction ExponentialMovingAverage ExponentialPowerDistribution ExponentPosition ExponentStep Export ExportAutoReplacements ExportByteArray ExportForm ExportPacket ExportString Expression ExpressionCell ExpressionPacket ExpressionUUID ExpToTrig ExtendedEntityClass ExtendedGCD Extension ExtentElementFunction ExtentMarkers ExtentSize ExternalBundle ExternalCall ExternalDataCharacterEncoding ExternalEvaluate ExternalFunction ExternalFunctionName ExternalObject ExternalOptions ExternalSessionObject ExternalSessions ExternalTypeSignature ExternalValue Extract ExtractArchive ExtractLayer ExtremeValueDistributionFaceForm FaceGrids FaceGridsStyle FacialFeatures Factor FactorComplete Factorial Factorial2 FactorialMoment FactorialMomentGeneratingFunction FactorialPower FactorInteger FactorList FactorSquareFree FactorSquareFreeList FactorTerms FactorTermsList Fail Failure FailureAction FailureDistribution FailureQ False FareySequence FARIMAProcess FeatureDistance FeatureExtract FeatureExtraction FeatureExtractor FeatureExtractorFunction FeatureNames FeatureNearest FeatureSpacePlot FeatureSpacePlot3D FeatureTypes FEDisableConsolePrintPacket FeedbackLinearize FeedbackSector FeedbackSectorStyle FeedbackType FEEnableConsolePrintPacket FetalGrowthData Fibonacci Fibonorial FieldCompletionFunction FieldHint FieldHintStyle FieldMasked FieldSize File FileBaseName FileByteCount FileConvert FileDate FileExistsQ FileExtension FileFormat FileHandler FileHash FileInformation FileName FileNameDepth FileNameDialogSettings FileNameDrop FileNameForms FileNameJoin FileNames FileNameSetter FileNameSplit FileNameTake FilePrint FileSize FileSystemMap FileSystemScan FileTemplate FileTemplateApply FileType FilledCurve FilledCurveBox FilledCurveBoxOptions Filling FillingStyle FillingTransform FilteredEntityClass FilterRules FinancialBond FinancialData FinancialDerivative FinancialIndicator Find FindAnomalies FindArgMax FindArgMin FindChannels FindClique FindClusters FindCookies FindCurvePath FindCycle FindDevices FindDistribution FindDistributionParameters FindDivisions FindEdgeCover FindEdgeCut FindEdgeIndependentPaths FindEquationalProof FindEulerianCycle FindExternalEvaluators FindFaces FindFile FindFit FindFormula FindFundamentalCycles FindGeneratingFunction FindGeoLocation FindGeometricConjectures FindGeometricTransform FindGraphCommunities FindGraphIsomorphism FindGraphPartition FindHamiltonianCycle FindHamiltonianPath FindHiddenMarkovStates FindIndependentEdgeSet FindIndependentVertexSet FindInstance FindIntegerNullVector FindKClan FindKClique FindKClub FindKPlex FindLibrary FindLinearRecurrence FindList FindMatchingColor FindMaximum FindMaximumFlow FindMaxValue FindMeshDefects FindMinimum FindMinimumCostFlow FindMinimumCut FindMinValue FindMoleculeSubstructure FindPath FindPeaks FindPermutation FindPostmanTour FindProcessParameters FindRepeat FindRoot FindSequenceFunction FindSettings FindShortestPath FindShortestTour FindSpanningTree FindSystemModelEquilibrium FindTextualAnswer FindThreshold FindTransientRepeat FindVertexCover FindVertexCut FindVertexIndependentPaths Fine FinishDynamic FiniteAbelianGroupCount FiniteGroupCount FiniteGroupData First FirstCase FirstPassageTimeDistribution FirstPosition FischerGroupFi22 FischerGroupFi23 FischerGroupFi24Prime FisherHypergeometricDistribution FisherRatioTest FisherZDistribution Fit FitAll FitRegularization FittedModel FixedOrder FixedPoint FixedPointList FlashSelection Flat Flatten FlattenAt FlattenLayer FlatTopWindow FlipView Floor FlowPolynomial FlushPrintOutputPacket Fold FoldList FoldPair FoldPairList FollowRedirects Font FontColor FontFamily FontForm FontName FontOpacity FontPostScriptName FontProperties FontReencoding FontSize FontSlant FontSubstitutions FontTracking FontVariations FontWeight For ForAll Format FormatRules FormatType FormatTypeAutoConvert FormatValues FormBox FormBoxOptions FormControl FormFunction FormLayoutFunction FormObject FormPage FormTheme FormulaData FormulaLookup FortranForm Forward ForwardBackward Fourier FourierCoefficient FourierCosCoefficient FourierCosSeries FourierCosTransform FourierDCT FourierDCTFilter FourierDCTMatrix FourierDST FourierDSTMatrix FourierMatrix FourierParameters FourierSequenceTransform FourierSeries FourierSinCoefficient FourierSinSeries FourierSinTransform FourierTransform FourierTrigSeries FractionalBrownianMotionProcess FractionalGaussianNoiseProcess FractionalPart FractionBox FractionBoxOptions FractionLine Frame FrameBox FrameBoxOptions Framed FrameInset FrameLabel Frameless FrameMargins FrameRate FrameStyle FrameTicks FrameTicksStyle FRatioDistribution FrechetDistribution FreeQ FrenetSerretSystem FrequencySamplingFilterKernel FresnelC FresnelF FresnelG FresnelS Friday FrobeniusNumber FrobeniusSolve FromAbsoluteTime FromCharacterCode FromCoefficientRules FromContinuedFraction FromDate FromDigits FromDMS FromEntity FromJulianDate FromLetterNumber FromPolarCoordinates FromRomanNumeral FromSphericalCoordinates FromUnixTime Front FrontEndDynamicExpression FrontEndEventActions FrontEndExecute FrontEndObject FrontEndResource FrontEndResourceString FrontEndStackSize FrontEndToken FrontEndTokenExecute FrontEndValueCache FrontEndVersion FrontFaceColor FrontFaceOpacity Full FullAxes FullDefinition FullForm FullGraphics FullInformationOutputRegulator FullOptions FullRegion FullSimplify Function FunctionCompile FunctionCompileExport FunctionCompileExportByteArray FunctionCompileExportLibrary FunctionCompileExportString FunctionDomain FunctionExpand FunctionInterpolation FunctionPeriod FunctionRange FunctionSpace FussellVeselyImportanceGaborFilter GaborMatrix GaborWavelet GainMargins GainPhaseMargins GalaxyData GalleryView Gamma GammaDistribution GammaRegularized GapPenalty GARCHProcess GatedRecurrentLayer Gather GatherBy GaugeFaceElementFunction GaugeFaceStyle GaugeFrameElementFunction GaugeFrameSize GaugeFrameStyle GaugeLabels GaugeMarkers GaugeStyle GaussianFilter GaussianIntegers GaussianMatrix GaussianOrthogonalMatrixDistribution GaussianSymplecticMatrixDistribution GaussianUnitaryMatrixDistribution GaussianWindow GCD GegenbauerC General GeneralizedLinearModelFit GenerateAsymmetricKeyPair GenerateConditions GeneratedCell GeneratedDocumentBinding GenerateDerivedKey GenerateDigitalSignature GenerateDocument GeneratedParameters GeneratedQuantityMagnitudes GenerateHTTPResponse GenerateSecuredAuthenticationKey GenerateSymmetricKey GeneratingFunction GeneratorDescription GeneratorHistoryLength GeneratorOutputType Generic GenericCylindricalDecomposition GenomeData GenomeLookup GeoAntipode GeoArea GeoArraySize GeoBackground GeoBoundingBox GeoBounds GeoBoundsRegion GeoBubbleChart GeoCenter GeoCircle GeodesicClosing GeodesicDilation GeodesicErosion GeodesicOpening GeoDestination GeodesyData GeoDirection GeoDisk GeoDisplacement GeoDistance GeoDistanceList GeoElevationData GeoEntities GeoGraphics GeogravityModelData GeoGridDirectionDifference GeoGridLines GeoGridLinesStyle GeoGridPosition GeoGridRange GeoGridRangePadding GeoGridUnitArea GeoGridUnitDistance GeoGridVector GeoGroup GeoHemisphere GeoHemisphereBoundary GeoHistogram GeoIdentify GeoImage GeoLabels GeoLength GeoListPlot GeoLocation GeologicalPeriodData GeomagneticModelData GeoMarker GeometricAssertion GeometricBrownianMotionProcess GeometricDistribution GeometricMean GeometricMeanFilter GeometricScene GeometricTransformation GeometricTransformation3DBox GeometricTransformation3DBoxOptions GeometricTransformationBox GeometricTransformationBoxOptions GeoModel GeoNearest GeoPath GeoPosition GeoPositionENU GeoPositionXYZ GeoProjection GeoProjectionData GeoRange GeoRangePadding GeoRegionValuePlot GeoResolution GeoScaleBar GeoServer GeoSmoothHistogram GeoStreamPlot GeoStyling GeoStylingImageFunction GeoVariant GeoVector GeoVectorENU GeoVectorPlot GeoVectorXYZ GeoVisibleRegion GeoVisibleRegionBoundary GeoWithinQ GeoZoomLevel GestureHandler GestureHandlerTag Get GetBoundingBoxSizePacket GetContext GetEnvironment GetFileName GetFrontEndOptionsDataPacket GetLinebreakInformationPacket GetMenusPacket GetPageBreakInformationPacket Glaisher GlobalClusteringCoefficient GlobalPreferences GlobalSession Glow GoldenAngle GoldenRatio GompertzMakehamDistribution GoodmanKruskalGamma GoodmanKruskalGammaTest Goto Grad Gradient GradientFilter GradientOrientationFilter GrammarApply GrammarRules GrammarToken Graph Graph3D GraphAssortativity GraphAutomorphismGroup GraphCenter GraphComplement GraphData GraphDensity GraphDiameter GraphDifference GraphDisjointUnion GraphDistance GraphDistanceMatrix GraphElementData GraphEmbedding GraphHighlight GraphHighlightStyle GraphHub Graphics Graphics3D Graphics3DBox Graphics3DBoxOptions GraphicsArray GraphicsBaseline GraphicsBox GraphicsBoxOptions GraphicsColor GraphicsColumn GraphicsComplex GraphicsComplex3DBox GraphicsComplex3DBoxOptions GraphicsComplexBox GraphicsComplexBoxOptions GraphicsContents GraphicsData GraphicsGrid GraphicsGridBox GraphicsGroup GraphicsGroup3DBox GraphicsGroup3DBoxOptions GraphicsGroupBox GraphicsGroupBoxOptions GraphicsGrouping GraphicsHighlightColor GraphicsRow GraphicsSpacing GraphicsStyle GraphIntersection GraphLayout GraphLinkEfficiency GraphPeriphery GraphPlot GraphPlot3D GraphPower GraphPropertyDistribution GraphQ GraphRadius GraphReciprocity GraphRoot GraphStyle GraphUnion Gray GrayLevel Greater GreaterEqual GreaterEqualLess GreaterEqualThan GreaterFullEqual GreaterGreater GreaterLess GreaterSlantEqual GreaterThan GreaterTilde Green GreenFunction Grid GridBaseline GridBox GridBoxAlignment GridBoxBackground GridBoxDividers GridBoxFrame GridBoxItemSize GridBoxItemStyle GridBoxOptions GridBoxSpacings GridCreationSettings GridDefaultElement GridElementStyleOptions GridFrame GridFrameMargins GridGraph GridLines GridLinesStyle GroebnerBasis GroupActionBase GroupBy GroupCentralizer GroupElementFromWord GroupElementPosition GroupElementQ GroupElements GroupElementToWord GroupGenerators Groupings GroupMultiplicationTable GroupOrbits GroupOrder GroupPageBreakWithin GroupSetwiseStabilizer GroupStabilizer GroupStabilizerChain GroupTogetherGrouping GroupTogetherNestedGrouping GrowCutComponents Gudermannian GuidedFilter GumbelDistributionHaarWavelet HadamardMatrix HalfLine HalfNormalDistribution HalfPlane HalfSpace HamiltonianGraphQ HammingDistance HammingWindow HandlerFunctions HandlerFunctionsKeys HankelH1 HankelH2 HankelMatrix HankelTransform HannPoissonWindow HannWindow HaradaNortonGroupHN HararyGraph HarmonicMean HarmonicMeanFilter HarmonicNumber Hash Haversine HazardFunction Head HeadCompose HeaderLines Heads HeavisideLambda HeavisidePi HeavisideTheta HeldGroupHe HeldPart HelpBrowserLookup HelpBrowserNotebook HelpBrowserSettings Here HermiteDecomposition HermiteH HermitianMatrixQ HessenbergDecomposition Hessian HexadecimalCharacter Hexahedron HexahedronBox HexahedronBoxOptions HiddenMarkovProcess HiddenSurface Highlighted HighlightGraph HighlightImage HighlightMesh HighpassFilter HigmanSimsGroupHS HilbertCurve HilbertFilter HilbertMatrix Histogram Histogram3D HistogramDistribution HistogramList HistogramTransform HistogramTransformInterpolation HistoricalPeriodData HitMissTransform HITSCentrality HjorthDistribution HodgeDual HoeffdingD HoeffdingDTest Hold HoldAll HoldAllComplete HoldComplete HoldFirst HoldForm HoldPattern HoldRest HolidayCalendar HomeDirectory HomePage Horizontal HorizontalForm HorizontalGauge HorizontalScrollPosition HornerForm HostLookup HotellingTSquareDistribution HoytDistribution HTMLSave HTTPErrorResponse HTTPRedirect HTTPRequest HTTPRequestData HTTPResponse Hue HumanGrowthData HumpDownHump HumpEqual HurwitzLerchPhi HurwitzZeta HyperbolicDistribution HypercubeGraph HyperexponentialDistribution Hyperfactorial Hypergeometric0F1 Hypergeometric0F1Regularized Hypergeometric1F1 Hypergeometric1F1Regularized Hypergeometric2F1 Hypergeometric2F1Regularized HypergeometricDistribution HypergeometricPFQ HypergeometricPFQRegularized HypergeometricU Hyperlink HyperlinkCreationSettings Hyperplane Hyphenation HyphenationOptions HypoexponentialDistribution HypothesisTestDataI IconData Iconize IconizedObject IconRules Icosahedron Identity IdentityMatrix If IgnoreCase IgnoreDiacritics IgnorePunctuation IgnoreSpellCheck IgnoringInactive Im Image Image3D Image3DProjection Image3DSlices ImageAccumulate ImageAdd ImageAdjust ImageAlign ImageApply ImageApplyIndexed ImageAspectRatio ImageAssemble ImageAugmentationLayer ImageBoundingBoxes ImageCache ImageCacheValid ImageCapture ImageCaptureFunction ImageCases ImageChannels ImageClip ImageCollage ImageColorSpace ImageCompose ImageContainsQ ImageContents ImageConvolve ImageCooccurrence ImageCorners ImageCorrelate ImageCorrespondingPoints ImageCrop ImageData ImageDeconvolve ImageDemosaic ImageDifference ImageDimensions ImageDisplacements ImageDistance ImageEffect ImageExposureCombine ImageFeatureTrack ImageFileApply ImageFileFilter ImageFileScan ImageFilter ImageFocusCombine ImageForestingComponents ImageFormattingWidth ImageForwardTransformation ImageGraphics ImageHistogram ImageIdentify ImageInstanceQ ImageKeypoints ImageLevels ImageLines ImageMargins ImageMarker ImageMarkers ImageMeasurements ImageMesh ImageMultiply ImageOffset ImagePad ImagePadding ImagePartition ImagePeriodogram ImagePerspectiveTransformation ImagePosition ImagePreviewFunction ImagePyramid ImagePyramidApply ImageQ ImageRangeCache ImageRecolor ImageReflect ImageRegion ImageResize ImageResolution ImageRestyle ImageRotate ImageRotated ImageSaliencyFilter ImageScaled ImageScan ImageSize ImageSizeAction ImageSizeCache ImageSizeMultipliers ImageSizeRaw ImageSubtract ImageTake ImageTransformation ImageTrim ImageType ImageValue ImageValuePositions ImagingDevice ImplicitRegion Implies Import ImportAutoReplacements ImportByteArray ImportOptions ImportString ImprovementImportance In Inactivate Inactive IncidenceGraph IncidenceList IncidenceMatrix IncludeAromaticBonds IncludeConstantBasis IncludeDefinitions IncludeDirectories IncludeFileExtension IncludeGeneratorTasks IncludeHydrogens IncludeInflections IncludeMetaInformation IncludePods IncludeQuantities IncludeRelatedTables IncludeSingularTerm IncludeWindowTimes Increment IndefiniteMatrixQ Indent IndentingNewlineSpacings IndentMaxFraction IndependenceTest IndependentEdgeSetQ IndependentPhysicalQuantity IndependentUnit IndependentUnitDimension IndependentVertexSetQ Indeterminate IndeterminateThreshold IndexCreationOptions Indexed IndexGraph IndexTag Inequality InexactNumberQ InexactNumbers InfiniteLine InfinitePlane Infinity Infix InflationAdjust InflationMethod Information InformationData InformationDataGrid Inherited InheritScope InhomogeneousPoissonProcess InitialEvaluationHistory Initialization InitializationCell InitializationCellEvaluation InitializationCellWarning InitializationObjects InitializationValue Initialize InitialSeeding InlineCounterAssignments InlineCounterIncrements InlineRules Inner InnerPolygon InnerPolyhedron Inpaint Input InputAliases InputAssumptions InputAutoReplacements InputField InputFieldBox InputFieldBoxOptions InputForm InputGrouping InputNamePacket InputNotebook InputPacket InputSettings InputStream InputString InputStringPacket InputToBoxFormPacket Insert InsertionFunction InsertionPointObject InsertLinebreaks InsertResults Inset Inset3DBox Inset3DBoxOptions InsetBox InsetBoxOptions Insphere Install InstallService InstanceNormalizationLayer InString Integer IntegerDigits IntegerExponent IntegerLength IntegerName IntegerPart IntegerPartitions IntegerQ IntegerReverse Integers IntegerString Integral Integrate Interactive InteractiveTradingChart Interlaced Interleaving InternallyBalancedDecomposition InterpolatingFunction InterpolatingPolynomial Interpolation InterpolationOrder InterpolationPoints InterpolationPrecision Interpretation InterpretationBox InterpretationBoxOptions InterpretationFunction Interpreter InterpretTemplate InterquartileRange Interrupt InterruptSettings IntersectingQ Intersection Interval IntervalIntersection IntervalMarkers IntervalMarkersStyle IntervalMemberQ IntervalSlider IntervalUnion Into Inverse InverseBetaRegularized InverseCDF InverseChiSquareDistribution InverseContinuousWaveletTransform InverseDistanceTransform InverseEllipticNomeQ InverseErf InverseErfc InverseFourier InverseFourierCosTransform InverseFourierSequenceTransform InverseFourierSinTransform InverseFourierTransform InverseFunction InverseFunctions InverseGammaDistribution InverseGammaRegularized InverseGaussianDistribution InverseGudermannian InverseHankelTransform InverseHaversine InverseImagePyramid InverseJacobiCD InverseJacobiCN InverseJacobiCS InverseJacobiDC InverseJacobiDN InverseJacobiDS InverseJacobiNC InverseJacobiND InverseJacobiNS InverseJacobiSC InverseJacobiSD InverseJacobiSN InverseLaplaceTransform InverseMellinTransform InversePermutation InverseRadon InverseRadonTransform InverseSeries InverseShortTimeFourier InverseSpectrogram InverseSurvivalFunction InverseTransformedRegion InverseWaveletTransform InverseWeierstrassP InverseWishartMatrixDistribution InverseZTransform Invisible InvisibleApplication InvisibleTimes IPAddress IrreduciblePolynomialQ IslandData IsolatingInterval IsomorphicGraphQ IsotopeData Italic Item ItemAspectRatio ItemBox ItemBoxOptions ItemSize ItemStyle ItoProcessJaccardDissimilarity JacobiAmplitude Jacobian JacobiCD JacobiCN JacobiCS JacobiDC JacobiDN JacobiDS JacobiNC JacobiND JacobiNS JacobiP JacobiSC JacobiSD JacobiSN JacobiSymbol JacobiZeta JankoGroupJ1 JankoGroupJ2 JankoGroupJ3 JankoGroupJ4 JarqueBeraALMTest JohnsonDistribution Join JoinAcross Joined JoinedCurve JoinedCurveBox JoinedCurveBoxOptions JoinForm JordanDecomposition JordanModelDecomposition JulianDate JuliaSetBoettcher JuliaSetIterationCount JuliaSetPlot JuliaSetPointsK KagiChart KaiserBesselWindow KaiserWindow KalmanEstimator KalmanFilter KarhunenLoeveDecomposition KaryTree KatzCentrality KCoreComponents KDistribution KEdgeConnectedComponents KEdgeConnectedGraphQ KelvinBei KelvinBer KelvinKei KelvinKer KendallTau KendallTauTest KernelExecute KernelFunction KernelMixtureDistribution Kernels Ket Key KeyCollisionFunction KeyComplement KeyDrop KeyDropFrom KeyExistsQ KeyFreeQ KeyIntersection KeyMap KeyMemberQ KeypointStrength Keys KeySelect KeySort KeySortBy KeyTake KeyUnion KeyValueMap KeyValuePattern Khinchin KillProcess KirchhoffGraph KirchhoffMatrix KleinInvariantJ KnapsackSolve KnightTourGraph KnotData KnownUnitQ KochCurve KolmogorovSmirnovTest KroneckerDelta KroneckerModelDecomposition KroneckerProduct KroneckerSymbol KuiperTest KumaraswamyDistribution Kurtosis KuwaharaFilter KVertexConnectedComponents KVertexConnectedGraphQLABColor Label Labeled LabeledSlider LabelingFunction LabelingSize LabelStyle LabelVisibility LaguerreL LakeData LambdaComponents LambertW LaminaData LanczosWindow LandauDistribution Language LanguageCategory LanguageData LanguageIdentify LanguageOptions LaplaceDistribution LaplaceTransform Laplacian LaplacianFilter LaplacianGaussianFilter Large Larger Last Latitude LatitudeLongitude LatticeData LatticeReduce Launch LaunchKernels LayeredGraphPlot LayerSizeFunction LayoutInformation LCHColor LCM LeaderSize LeafCount LeapYearQ LearnDistribution LearnedDistribution LearningRate LearningRateMultipliers LeastSquares LeastSquaresFilterKernel Left LeftArrow LeftArrowBar LeftArrowRightArrow LeftDownTeeVector LeftDownVector LeftDownVectorBar LeftRightArrow LeftRightVector LeftTee LeftTeeArrow LeftTeeVector LeftTriangle LeftTriangleBar LeftTriangleEqual LeftUpDownVector LeftUpTeeVector LeftUpVector LeftUpVectorBar LeftVector LeftVectorBar LegendAppearance Legended LegendFunction LegendLabel LegendLayout LegendMargins LegendMarkers LegendMarkerSize LegendreP LegendreQ LegendreType Length LengthWhile LerchPhi Less LessEqual LessEqualGreater LessEqualThan LessFullEqual LessGreater LessLess LessSlantEqual LessThan LessTilde LetterCharacter LetterCounts LetterNumber LetterQ Level LeveneTest LeviCivitaTensor LevyDistribution Lexicographic LibraryDataType LibraryFunction LibraryFunctionError LibraryFunctionInformation LibraryFunctionLoad LibraryFunctionUnload LibraryLoad LibraryUnload LicenseID LiftingFilterData LiftingWaveletTransform LightBlue LightBrown LightCyan Lighter LightGray LightGreen Lighting LightingAngle LightMagenta LightOrange LightPink LightPurple LightRed LightSources LightYellow Likelihood Limit LimitsPositioning LimitsPositioningTokens LindleyDistribution Line Line3DBox Line3DBoxOptions LinearFilter LinearFractionalOptimization LinearFractionalTransform LinearGradientImage LinearizingTransformationData LinearLayer LinearModelFit LinearOffsetFunction LinearOptimization LinearProgramming LinearRecurrence LinearSolve LinearSolveFunction LineBox LineBoxOptions LineBreak LinebreakAdjustments LineBreakChart LinebreakSemicolonWeighting LineBreakWithin LineColor LineGraph LineIndent LineIndentMaxFraction LineIntegralConvolutionPlot LineIntegralConvolutionScale LineLegend LineOpacity LineSpacing LineWrapParts LinkActivate LinkClose LinkConnect LinkConnectedQ LinkCreate LinkError LinkFlush LinkFunction LinkHost LinkInterrupt LinkLaunch LinkMode LinkObject LinkOpen LinkOptions LinkPatterns LinkProtocol LinkRankCentrality LinkRead LinkReadHeld LinkReadyQ Links LinkService LinkWrite LinkWriteHeld LiouvilleLambda List Listable ListAnimate ListContourPlot ListContourPlot3D ListConvolve ListCorrelate ListCurvePathPlot ListDeconvolve ListDensityPlot ListDensityPlot3D Listen ListFormat ListFourierSequenceTransform ListInterpolation ListLineIntegralConvolutionPlot ListLinePlot ListLogLinearPlot ListLogLogPlot ListLogPlot ListPicker ListPickerBox ListPickerBoxBackground ListPickerBoxOptions ListPlay ListPlot ListPlot3D ListPointPlot3D ListPolarPlot ListQ ListSliceContourPlot3D ListSliceDensityPlot3D ListSliceVectorPlot3D ListStepPlot ListStreamDensityPlot ListStreamPlot ListSurfacePlot3D ListVectorDensityPlot ListVectorPlot ListVectorPlot3D ListZTransform Literal LiteralSearch LocalAdaptiveBinarize LocalCache LocalClusteringCoefficient LocalizeDefinitions LocalizeVariables LocalObject LocalObjects LocalResponseNormalizationLayer LocalSubmit LocalSymbol LocalTime LocalTimeZone LocationEquivalenceTest LocationTest Locator LocatorAutoCreate LocatorBox LocatorBoxOptions LocatorCentering LocatorPane LocatorPaneBox LocatorPaneBoxOptions LocatorRegion Locked Log Log10 Log2 LogBarnesG LogGamma LogGammaDistribution LogicalExpand LogIntegral LogisticDistribution LogisticSigmoid LogitModelFit LogLikelihood LogLinearPlot LogLogisticDistribution LogLogPlot LogMultinormalDistribution LogNormalDistribution LogPlot LogRankTest LogSeriesDistribution LongEqual Longest LongestCommonSequence LongestCommonSequencePositions LongestCommonSubsequence LongestCommonSubsequencePositions LongestMatch LongestOrderedSequence LongForm Longitude LongLeftArrow LongLeftRightArrow LongRightArrow LongShortTermMemoryLayer Lookup Loopback LoopFreeGraphQ LossFunction LowerCaseQ LowerLeftArrow LowerRightArrow LowerTriangularize LowerTriangularMatrixQ LowpassFilter LQEstimatorGains LQGRegulator LQOutputRegulatorGains LQRegulatorGains LUBackSubstitution LucasL LuccioSamiComponents LUDecomposition LunarEclipse LUVColor LyapunovSolve LyonsGroupLyMachineID MachineName MachineNumberQ MachinePrecision MacintoshSystemPageSetup Magenta Magnification Magnify MailAddressValidation MailExecute MailFolder MailItem MailReceiverFunction MailResponseFunction MailSearch MailServerConnect MailServerConnection MailSettings MainSolve MaintainDynamicCaches Majority MakeBoxes MakeExpression MakeRules ManagedLibraryExpressionID ManagedLibraryExpressionQ MandelbrotSetBoettcher MandelbrotSetDistance MandelbrotSetIterationCount MandelbrotSetMemberQ MandelbrotSetPlot MangoldtLambda ManhattanDistance Manipulate Manipulator MannedSpaceMissionData MannWhitneyTest MantissaExponent Manual Map MapAll MapAt MapIndexed MAProcess MapThread MarchenkoPasturDistribution MarcumQ MardiaCombinedTest MardiaKurtosisTest MardiaSkewnessTest MarginalDistribution MarkovProcessProperties Masking MatchingDissimilarity MatchLocalNameQ MatchLocalNames MatchQ Material MathematicalFunctionData MathematicaNotation MathieuC MathieuCharacteristicA MathieuCharacteristicB MathieuCharacteristicExponent MathieuCPrime MathieuGroupM11 MathieuGroupM12 MathieuGroupM22 MathieuGroupM23 MathieuGroupM24 MathieuS MathieuSPrime MathMLForm MathMLText Matrices MatrixExp MatrixForm MatrixFunction MatrixLog MatrixNormalDistribution MatrixPlot MatrixPower MatrixPropertyDistribution MatrixQ MatrixRank MatrixTDistribution Max MaxBend MaxCellMeasure MaxColorDistance MaxDetect MaxDuration MaxExtraBandwidths MaxExtraConditions MaxFeatureDisplacement MaxFeatures MaxFilter MaximalBy Maximize MaxItems MaxIterations MaxLimit MaxMemoryUsed MaxMixtureKernels MaxOverlapFraction MaxPlotPoints MaxPoints MaxRecursion MaxStableDistribution MaxStepFraction MaxSteps MaxStepSize MaxTrainingRounds MaxValue MaxwellDistribution MaxWordGap McLaughlinGroupMcL Mean MeanAbsoluteLossLayer MeanAround MeanClusteringCoefficient MeanDegreeConnectivity MeanDeviation MeanFilter MeanGraphDistance MeanNeighborDegree MeanShift MeanShiftFilter MeanSquaredLossLayer Median MedianDeviation MedianFilter MedicalTestData Medium MeijerG MeijerGReduce MeixnerDistribution MellinConvolve MellinTransform MemberQ MemoryAvailable MemoryConstrained MemoryConstraint MemoryInUse MengerMesh Menu MenuAppearance MenuCommandKey MenuEvaluator MenuItem MenuList MenuPacket MenuSortingValue MenuStyle MenuView Merge MergeDifferences MergingFunction MersennePrimeExponent MersennePrimeExponentQ Mesh MeshCellCentroid MeshCellCount MeshCellHighlight MeshCellIndex MeshCellLabel MeshCellMarker MeshCellMeasure MeshCellQuality MeshCells MeshCellShapeFunction MeshCellStyle MeshCoordinates MeshFunctions MeshPrimitives MeshQualityGoal MeshRange MeshRefinementFunction MeshRegion MeshRegionQ MeshShading MeshStyle Message MessageDialog MessageList MessageName MessageObject MessageOptions MessagePacket Messages MessagesNotebook MetaCharacters MetaInformation MeteorShowerData Method MethodOptions MexicanHatWavelet MeyerWavelet Midpoint Min MinColorDistance MinDetect MineralData MinFilter MinimalBy MinimalPolynomial MinimalStateSpaceModel Minimize MinimumTimeIncrement MinIntervalSize MinkowskiQuestionMark MinLimit MinMax MinorPlanetData Minors MinRecursion MinSize MinStableDistribution Minus MinusPlus MinValue Missing MissingBehavior MissingDataMethod MissingDataRules MissingQ MissingString MissingStyle MissingValuePattern MittagLefflerE MixedFractionParts MixedGraphQ MixedMagnitude MixedRadix MixedRadixQuantity MixedUnit MixtureDistribution Mod Modal Mode Modular ModularInverse ModularLambda Module Modulus MoebiusMu Molecule MoleculeContainsQ MoleculeEquivalentQ MoleculeGraph MoleculeModify MoleculePattern MoleculePlot MoleculePlot3D MoleculeProperty MoleculeQ MoleculeValue Moment Momentary MomentConvert MomentEvaluate MomentGeneratingFunction MomentOfInertia Monday Monitor MonomialList MonomialOrder MonsterGroupM MoonPhase MoonPosition MorletWavelet MorphologicalBinarize MorphologicalBranchPoints MorphologicalComponents MorphologicalEulerNumber MorphologicalGraph MorphologicalPerimeter MorphologicalTransform MortalityData Most MountainData MouseAnnotation MouseAppearance MouseAppearanceTag MouseButtons Mouseover MousePointerNote MousePosition MovieData MovingAverage MovingMap MovingMedian MoyalDistribution Multicolumn MultiedgeStyle MultigraphQ MultilaunchWarning MultiLetterItalics MultiLetterStyle MultilineFunction Multinomial MultinomialDistribution MultinormalDistribution MultiplicativeOrder Multiplicity MultiplySides Multiselection MultivariateHypergeometricDistribution MultivariatePoissonDistribution MultivariateTDistributionN NakagamiDistribution NameQ Names NamespaceBox NamespaceBoxOptions Nand NArgMax NArgMin NBernoulliB NBodySimulation NBodySimulationData NCache NDEigensystem NDEigenvalues NDSolve NDSolveValue Nearest NearestFunction NearestNeighborGraph NearestTo NebulaData NeedCurrentFrontEndPackagePacket NeedCurrentFrontEndSymbolsPacket NeedlemanWunschSimilarity Needs Negative NegativeBinomialDistribution NegativeDefiniteMatrixQ NegativeIntegers NegativeMultinomialDistribution NegativeRationals NegativeReals NegativeSemidefiniteMatrixQ NeighborhoodData NeighborhoodGraph Nest NestedGreaterGreater NestedLessLess NestedScriptRules NestGraph NestList NestWhile NestWhileList NetAppend NetBidirectionalOperator NetChain NetDecoder NetDelete NetDrop NetEncoder NetEvaluationMode NetExtract NetFlatten NetFoldOperator NetGraph NetInformation NetInitialize NetInsert NetInsertSharedArrays NetJoin NetMapOperator NetMapThreadOperator NetMeasurements NetModel NetNestOperator NetPairEmbeddingOperator NetPort NetPortGradient NetPrepend NetRename NetReplace NetReplacePart NetSharedArray NetStateObject NetTake NetTrain NetTrainResultsObject NetworkPacketCapture NetworkPacketRecording NetworkPacketRecordingDuring NetworkPacketTrace NeumannValue NevilleThetaC NevilleThetaD NevilleThetaN NevilleThetaS NewPrimitiveStyle NExpectation Next NextCell NextDate NextPrime NextScheduledTaskTime NHoldAll NHoldFirst NHoldRest NicholsGridLines NicholsPlot NightHemisphere NIntegrate NMaximize NMaxValue NMinimize NMinValue NominalVariables NonAssociative NoncentralBetaDistribution NoncentralChiSquareDistribution NoncentralFRatioDistribution NoncentralStudentTDistribution NonCommutativeMultiply NonConstants NondimensionalizationTransform None NoneTrue NonlinearModelFit NonlinearStateSpaceModel NonlocalMeansFilter NonNegative NonNegativeIntegers NonNegativeRationals NonNegativeReals NonPositive NonPositiveIntegers NonPositiveRationals NonPositiveReals Nor NorlundB Norm Normal NormalDistribution NormalGrouping NormalizationLayer Normalize Normalized NormalizedSquaredEuclideanDistance NormalMatrixQ NormalsFunction NormFunction Not NotCongruent NotCupCap NotDoubleVerticalBar Notebook NotebookApply NotebookAutoSave NotebookClose NotebookConvertSettings NotebookCreate NotebookCreateReturnObject NotebookDefault NotebookDelete NotebookDirectory NotebookDynamicExpression NotebookEvaluate NotebookEventActions NotebookFileName NotebookFind NotebookFindReturnObject NotebookGet NotebookGetLayoutInformationPacket NotebookGetMisspellingsPacket NotebookImport NotebookInformation NotebookInterfaceObject NotebookLocate NotebookObject NotebookOpen NotebookOpenReturnObject NotebookPath NotebookPrint NotebookPut NotebookPutReturnObject NotebookRead NotebookResetGeneratedCells Notebooks NotebookSave NotebookSaveAs NotebookSelection NotebookSetupLayoutInformationPacket NotebooksMenu NotebookTemplate NotebookWrite NotElement NotEqualTilde NotExists NotGreater NotGreaterEqual NotGreaterFullEqual NotGreaterGreater NotGreaterLess NotGreaterSlantEqual NotGreaterTilde Nothing NotHumpDownHump NotHumpEqual NotificationFunction NotLeftTriangle NotLeftTriangleBar NotLeftTriangleEqual NotLess NotLessEqual NotLessFullEqual NotLessGreater NotLessLess NotLessSlantEqual NotLessTilde NotNestedGreaterGreater NotNestedLessLess NotPrecedes NotPrecedesEqual NotPrecedesSlantEqual NotPrecedesTilde NotReverseElement NotRightTriangle NotRightTriangleBar NotRightTriangleEqual NotSquareSubset NotSquareSubsetEqual NotSquareSuperset NotSquareSupersetEqual NotSubset NotSubsetEqual NotSucceeds NotSucceedsEqual NotSucceedsSlantEqual NotSucceedsTilde NotSuperset NotSupersetEqual NotTilde NotTildeEqual NotTildeFullEqual NotTildeTilde NotVerticalBar Now NoWhitespace NProbability NProduct NProductFactors NRoots NSolve NSum NSumTerms NuclearExplosionData NuclearReactorData Null NullRecords NullSpace NullWords Number NumberCompose NumberDecompose NumberExpand NumberFieldClassNumber NumberFieldDiscriminant NumberFieldFundamentalUnits NumberFieldIntegralBasis NumberFieldNormRepresentatives NumberFieldRegulator NumberFieldRootsOfUnity NumberFieldSignature NumberForm NumberFormat NumberLinePlot NumberMarks NumberMultiplier NumberPadding NumberPoint NumberQ NumberSeparator NumberSigns NumberString Numerator NumeratorDenominator NumericalOrder NumericalSort NumericArray NumericArrayQ NumericArrayType NumericFunction NumericQ NuttallWindow NValues NyquistGridLines NyquistPlotO ObservabilityGramian ObservabilityMatrix ObservableDecomposition ObservableModelQ OceanData Octahedron OddQ Off Offset OLEData On ONanGroupON Once OneIdentity Opacity OpacityFunction OpacityFunctionScaling Open OpenAppend Opener OpenerBox OpenerBoxOptions OpenerView OpenFunctionInspectorPacket Opening OpenRead OpenSpecialOptions OpenTemporary OpenWrite Operate OperatingSystem OptimumFlowData Optional OptionalElement OptionInspectorSettings OptionQ Options OptionsPacket OptionsPattern OptionValue OptionValueBox OptionValueBoxOptions Or Orange Order OrderDistribution OrderedQ Ordering OrderingBy OrderingLayer Orderless OrderlessPatternSequence OrnsteinUhlenbeckProcess Orthogonalize OrthogonalMatrixQ Out Outer OuterPolygon OuterPolyhedron OutputAutoOverwrite OutputControllabilityMatrix OutputControllableModelQ OutputForm OutputFormData OutputGrouping OutputMathEditExpression OutputNamePacket OutputResponse OutputSizeLimit OutputStream Over OverBar OverDot Overflow OverHat Overlaps Overlay OverlayBox OverlayBoxOptions Overscript OverscriptBox OverscriptBoxOptions OverTilde OverVector OverwriteTarget OwenT OwnValuesPackage PackingMethod PaddedForm Padding PaddingLayer PaddingSize PadeApproximant PadLeft PadRight PageBreakAbove PageBreakBelow PageBreakWithin PageFooterLines PageFooters PageHeaderLines PageHeaders PageHeight PageRankCentrality PageTheme PageWidth Pagination PairedBarChart PairedHistogram PairedSmoothHistogram PairedTTest PairedZTest PaletteNotebook PalettePath PalindromeQ Pane PaneBox PaneBoxOptions Panel PanelBox PanelBoxOptions Paneled PaneSelector PaneSelectorBox PaneSelectorBoxOptions PaperWidth ParabolicCylinderD ParagraphIndent ParagraphSpacing ParallelArray ParallelCombine ParallelDo Parallelepiped ParallelEvaluate Parallelization Parallelize ParallelMap ParallelNeeds Parallelogram ParallelProduct ParallelSubmit ParallelSum ParallelTable ParallelTry Parameter ParameterEstimator ParameterMixtureDistribution ParameterVariables ParametricFunction ParametricNDSolve ParametricNDSolveValue ParametricPlot ParametricPlot3D ParametricRegion ParentBox ParentCell ParentConnect ParentDirectory ParentForm Parenthesize ParentList ParentNotebook ParetoDistribution ParetoPickandsDistribution ParkData Part PartBehavior PartialCorrelationFunction PartialD ParticleAcceleratorData ParticleData Partition PartitionGranularity PartitionsP PartitionsQ PartLayer PartOfSpeech PartProtection ParzenWindow PascalDistribution PassEventsDown PassEventsUp Paste PasteAutoQuoteCharacters PasteBoxFormInlineCells PasteButton Path PathGraph PathGraphQ Pattern PatternSequence PatternTest PauliMatrix PaulWavelet Pause PausedTime PDF PeakDetect PeanoCurve PearsonChiSquareTest PearsonCorrelationTest PearsonDistribution PercentForm PerfectNumber PerfectNumberQ PerformanceGoal Perimeter PeriodicBoundaryCondition PeriodicInterpolation Periodogram PeriodogramArray Permanent Permissions PermissionsGroup PermissionsGroupMemberQ PermissionsGroups PermissionsKey PermissionsKeys PermutationCycles PermutationCyclesQ PermutationGroup PermutationLength PermutationList PermutationListQ PermutationMax PermutationMin PermutationOrder PermutationPower PermutationProduct PermutationReplace Permutations PermutationSupport Permute PeronaMalikFilter Perpendicular PerpendicularBisector PersistenceLocation PersistenceTime PersistentObject PersistentObjects PersistentValue PersonData PERTDistribution PetersenGraph PhaseMargins PhaseRange PhysicalSystemData Pi Pick PIDData PIDDerivativeFilter PIDFeedforward PIDTune Piecewise PiecewiseExpand PieChart PieChart3D PillaiTrace PillaiTraceTest PingTime Pink PitchRecognize Pivoting PixelConstrained PixelValue PixelValuePositions Placed Placeholder PlaceholderReplace Plain PlanarAngle PlanarGraph PlanarGraphQ PlanckRadiationLaw PlaneCurveData PlanetaryMoonData PlanetData PlantData Play PlayRange Plot Plot3D Plot3Matrix PlotDivision PlotJoined PlotLabel PlotLabels PlotLayout PlotLegends PlotMarkers PlotPoints PlotRange PlotRangeClipping PlotRangeClipPlanesStyle PlotRangePadding PlotRegion PlotStyle PlotTheme Pluralize Plus PlusMinus Pochhammer PodStates PodWidth Point Point3DBox Point3DBoxOptions PointBox PointBoxOptions PointFigureChart PointLegend PointSize PoissonConsulDistribution PoissonDistribution PoissonProcess PoissonWindow PolarAxes PolarAxesOrigin PolarGridLines PolarPlot PolarTicks PoleZeroMarkers PolyaAeppliDistribution PolyGamma Polygon Polygon3DBox Polygon3DBoxOptions PolygonalNumber PolygonAngle PolygonBox PolygonBoxOptions PolygonCoordinates PolygonDecomposition PolygonHoleScale PolygonIntersections PolygonScale Polyhedron PolyhedronAngle PolyhedronCoordinates PolyhedronData PolyhedronDecomposition PolyhedronGenus PolyLog PolynomialExtendedGCD PolynomialForm PolynomialGCD PolynomialLCM PolynomialMod PolynomialQ PolynomialQuotient PolynomialQuotientRemainder PolynomialReduce PolynomialRemainder Polynomials PoolingLayer PopupMenu PopupMenuBox PopupMenuBoxOptions PopupView PopupWindow Position PositionIndex Positive PositiveDefiniteMatrixQ PositiveIntegers PositiveRationals PositiveReals PositiveSemidefiniteMatrixQ PossibleZeroQ Postfix PostScript Power PowerDistribution PowerExpand PowerMod PowerModList PowerRange PowerSpectralDensity PowersRepresentations PowerSymmetricPolynomial Precedence PrecedenceForm Precedes PrecedesEqual PrecedesSlantEqual PrecedesTilde Precision PrecisionGoal PreDecrement Predict PredictionRoot PredictorFunction PredictorInformation PredictorMeasurements PredictorMeasurementsObject PreemptProtect PreferencesPath Prefix PreIncrement Prepend PrependLayer PrependTo PreprocessingRules PreserveColor PreserveImageOptions Previous PreviousCell PreviousDate PriceGraphDistribution PrimaryPlaceholder Prime PrimeNu PrimeOmega PrimePi PrimePowerQ PrimeQ Primes PrimeZetaP PrimitivePolynomialQ PrimitiveRoot PrimitiveRootList PrincipalComponents PrincipalValue Print PrintableASCIIQ PrintAction PrintForm PrintingCopies PrintingOptions PrintingPageRange PrintingStartingPageNumber PrintingStyleEnvironment Printout3D Printout3DPreviewer PrintPrecision PrintTemporary Prism PrismBox PrismBoxOptions PrivateCellOptions PrivateEvaluationOptions PrivateFontOptions PrivateFrontEndOptions PrivateKey PrivateNotebookOptions PrivatePaths Probability ProbabilityDistribution ProbabilityPlot ProbabilityPr ProbabilityScalePlot ProbitModelFit ProcessConnection ProcessDirectory ProcessEnvironment Processes ProcessEstimator ProcessInformation ProcessObject ProcessParameterAssumptions ProcessParameterQ ProcessStateDomain ProcessStatus ProcessTimeDomain Product ProductDistribution ProductLog ProgressIndicator ProgressIndicatorBox ProgressIndicatorBoxOptions Projection Prolog PromptForm ProofObject Properties Property PropertyList PropertyValue Proportion Proportional Protect Protected ProteinData Pruning PseudoInverse PsychrometricPropertyData PublicKey PublisherID PulsarData PunctuationCharacter Purple Put PutAppend Pyramid PyramidBox PyramidBoxOptionsQBinomial QFactorial QGamma QHypergeometricPFQ QnDispersion QPochhammer QPolyGamma QRDecomposition QuadraticIrrationalQ QuadraticOptimization Quantile QuantilePlot Quantity QuantityArray QuantityDistribution QuantityForm QuantityMagnitude QuantityQ QuantityUnit QuantityVariable QuantityVariableCanonicalUnit QuantityVariableDimensions QuantityVariableIdentifier QuantityVariablePhysicalQuantity Quartics QuartileDeviation Quartiles QuartileSkewness Query QueueingNetworkProcess QueueingProcess QueueProperties Quiet Quit Quotient QuotientRemainderRadialGradientImage RadialityCentrality RadicalBox RadicalBoxOptions RadioButton RadioButtonBar RadioButtonBox RadioButtonBoxOptions Radon RadonTransform RamanujanTau RamanujanTauL RamanujanTauTheta RamanujanTauZ Ramp Random RandomChoice RandomColor RandomComplex RandomEntity RandomFunction RandomGeoPosition RandomGraph RandomImage RandomInstance RandomInteger RandomPermutation RandomPoint RandomPolygon RandomPolyhedron RandomPrime RandomReal RandomSample RandomSeed RandomSeeding RandomVariate RandomWalkProcess RandomWord Range RangeFilter RangeSpecification RankedMax RankedMin RarerProbability Raster Raster3D Raster3DBox Raster3DBoxOptions RasterArray RasterBox RasterBoxOptions Rasterize RasterSize Rational RationalFunctions Rationalize Rationals Ratios RawArray RawBoxes RawData RawMedium RayleighDistribution Re Read ReadByteArray ReadLine ReadList ReadProtected ReadString Real RealAbs RealBlockDiagonalForm RealDigits RealExponent Reals RealSign Reap RecognitionPrior RecognitionThreshold Record RecordLists RecordSeparators Rectangle RectangleBox RectangleBoxOptions RectangleChart RectangleChart3D RectangularRepeatingElement RecurrenceFilter RecurrenceTable RecurringDigitsForm Red Reduce RefBox ReferenceLineStyle ReferenceMarkers ReferenceMarkerStyle Refine ReflectionMatrix ReflectionTransform Refresh RefreshRate Region RegionBinarize RegionBoundary RegionBounds RegionCentroid RegionDifference RegionDimension RegionDisjoint RegionDistance RegionDistanceFunction RegionEmbeddingDimension RegionEqual RegionFunction RegionImage RegionIntersection RegionMeasure RegionMember RegionMemberFunction RegionMoment RegionNearest RegionNearestFunction RegionPlot RegionPlot3D RegionProduct RegionQ RegionResize RegionSize RegionSymmetricDifference RegionUnion RegionWithin RegisterExternalEvaluator RegularExpression Regularization RegularlySampledQ RegularPolygon ReIm ReImLabels ReImPlot ReImStyle Reinstall RelationalDatabase RelationGraph Release ReleaseHold ReliabilityDistribution ReliefImage ReliefPlot RemoteAuthorizationCaching RemoteConnect RemoteConnectionObject RemoteFile RemoteRun RemoteRunProcess Remove RemoveAlphaChannel RemoveAsynchronousTask RemoveAudioStream RemoveBackground RemoveChannelListener RemoveChannelSubscribers Removed RemoveDiacritics RemoveInputStreamMethod RemoveOutputStreamMethod RemoveProperty RemoveScheduledTask RemoveUsers RenameDirectory RenameFile RenderAll RenderingOptions RenewalProcess RenkoChart RepairMesh Repeated RepeatedNull RepeatedString RepeatedTiming RepeatingElement Replace ReplaceAll ReplaceHeldPart ReplaceImageValue ReplaceList ReplacePart ReplacePixelValue ReplaceRepeated ReplicateLayer RequiredPhysicalQuantities Resampling ResamplingAlgorithmData ResamplingMethod Rescale RescalingTransform ResetDirectory ResetMenusPacket ResetScheduledTask ReshapeLayer Residue ResizeLayer Resolve ResourceAcquire ResourceData ResourceFunction ResourceObject ResourceRegister ResourceRemove ResourceSearch ResourceSubmissionObject ResourceSubmit ResourceSystemBase ResourceUpdate ResponseForm Rest RestartInterval Restricted Resultant ResumePacket Return ReturnEntersInput ReturnExpressionPacket ReturnInputFormPacket ReturnPacket ReturnReceiptFunction ReturnTextPacket Reverse ReverseBiorthogonalSplineWavelet ReverseElement ReverseEquilibrium ReverseGraph ReverseSort ReverseSortBy ReverseUpEquilibrium RevolutionAxis RevolutionPlot3D RGBColor RiccatiSolve RiceDistribution RidgeFilter RiemannR RiemannSiegelTheta RiemannSiegelZ RiemannXi Riffle Right RightArrow RightArrowBar RightArrowLeftArrow RightComposition RightCosetRepresentative RightDownTeeVector RightDownVector RightDownVectorBar RightTee RightTeeArrow RightTeeVector RightTriangle RightTriangleBar RightTriangleEqual RightUpDownVector RightUpTeeVector RightUpVector RightUpVectorBar RightVector RightVectorBar RiskAchievementImportance RiskReductionImportance RogersTanimotoDissimilarity RollPitchYawAngles RollPitchYawMatrix RomanNumeral Root RootApproximant RootIntervals RootLocusPlot RootMeanSquare RootOfUnityQ RootReduce Roots RootSum Rotate RotateLabel RotateLeft RotateRight RotationAction RotationBox RotationBoxOptions RotationMatrix RotationTransform Round RoundImplies RoundingRadius Row RowAlignments RowBackgrounds RowBox RowHeights RowLines RowMinHeight RowReduce RowsEqual RowSpacings RSolve RSolveValue RudinShapiro RudvalisGroupRu Rule RuleCondition RuleDelayed RuleForm RulePlot RulerUnits Run RunProcess RunScheduledTask RunThrough RuntimeAttributes RuntimeOptions RussellRaoDissimilaritySameQ SameTest SampledEntityClass SampleDepth SampledSoundFunction SampledSoundList SampleRate SamplingPeriod SARIMAProcess SARMAProcess SASTriangle SatelliteData SatisfiabilityCount SatisfiabilityInstances SatisfiableQ Saturday Save Saveable SaveAutoDelete SaveConnection SaveDefinitions SavitzkyGolayMatrix SawtoothWave Scale Scaled ScaleDivisions ScaledMousePosition ScaleOrigin ScalePadding ScaleRanges ScaleRangeStyle ScalingFunctions ScalingMatrix ScalingTransform Scan ScheduledTask ScheduledTaskActiveQ ScheduledTaskInformation ScheduledTaskInformationData ScheduledTaskObject ScheduledTasks SchurDecomposition ScientificForm ScientificNotationThreshold ScorerGi ScorerGiPrime ScorerHi ScorerHiPrime ScreenRectangle ScreenStyleEnvironment ScriptBaselineShifts ScriptForm ScriptLevel ScriptMinSize ScriptRules ScriptSizeMultipliers Scrollbars ScrollingOptions ScrollPosition SearchAdjustment SearchIndexObject SearchIndices SearchQueryString SearchResultObject Sec Sech SechDistribution SecondOrderConeOptimization SectionGrouping SectorChart SectorChart3D SectorOrigin SectorSpacing SecuredAuthenticationKey SecuredAuthenticationKeys SeedRandom Select Selectable SelectComponents SelectedCells SelectedNotebook SelectFirst Selection SelectionAnimate SelectionCell SelectionCellCreateCell SelectionCellDefaultStyle SelectionCellParentStyle SelectionCreateCell SelectionDebuggerTag SelectionDuplicateCell SelectionEvaluate SelectionEvaluateCreateCell SelectionMove SelectionPlaceholder SelectionSetStyle SelectWithContents SelfLoops SelfLoopStyle SemanticImport SemanticImportString SemanticInterpretation SemialgebraicComponentInstances SemidefiniteOptimization SendMail SendMessage Sequence SequenceAlignment SequenceAttentionLayer SequenceCases SequenceCount SequenceFold SequenceFoldList SequenceForm SequenceHold SequenceLastLayer SequenceMostLayer SequencePosition SequencePredict SequencePredictorFunction SequenceReplace SequenceRestLayer SequenceReverseLayer SequenceSplit Series SeriesCoefficient SeriesData ServiceConnect ServiceDisconnect ServiceExecute ServiceObject ServiceRequest ServiceResponse ServiceSubmit SessionSubmit SessionTime Set SetAccuracy SetAlphaChannel SetAttributes Setbacks SetBoxFormNamesPacket SetCloudDirectory SetCookies SetDelayed SetDirectory SetEnvironment SetEvaluationNotebook SetFileDate SetFileLoadingContext SetNotebookStatusLine SetOptions SetOptionsPacket SetPermissions SetPrecision SetProperty SetSecuredAuthenticationKey SetSelectedNotebook SetSharedFunction SetSharedVariable SetSpeechParametersPacket SetStreamPosition SetSystemModel SetSystemOptions Setter SetterBar SetterBox SetterBoxOptions Setting SetUsers SetValue Shading Shallow ShannonWavelet ShapiroWilkTest Share SharingList Sharpen ShearingMatrix ShearingTransform ShellRegion ShenCastanMatrix ShiftedGompertzDistribution ShiftRegisterSequence Short ShortDownArrow Shortest ShortestMatch ShortestPathFunction ShortLeftArrow ShortRightArrow ShortTimeFourier ShortTimeFourierData ShortUpArrow Show ShowAutoConvert ShowAutoSpellCheck ShowAutoStyles ShowCellBracket ShowCellLabel ShowCellTags ShowClosedCellArea ShowCodeAssist ShowContents ShowControls ShowCursorTracker ShowGroupOpenCloseIcon ShowGroupOpener ShowInvisibleCharacters ShowPageBreaks ShowPredictiveInterface ShowSelection ShowShortBoxForm ShowSpecialCharacters ShowStringCharacters ShowSyntaxStyles ShrinkingDelay ShrinkWrapBoundingBox SiderealTime SiegelTheta SiegelTukeyTest SierpinskiCurve SierpinskiMesh Sign Signature SignedRankTest SignedRegionDistance SignificanceLevel SignPadding SignTest SimilarityRules SimpleGraph SimpleGraphQ SimplePolygonQ SimplePolyhedronQ Simplex Simplify Sin Sinc SinghMaddalaDistribution SingleEvaluation SingleLetterItalics SingleLetterStyle SingularValueDecomposition SingularValueList SingularValuePlot SingularValues Sinh SinhIntegral SinIntegral SixJSymbol Skeleton SkeletonTransform SkellamDistribution Skewness SkewNormalDistribution SkinStyle Skip SliceContourPlot3D SliceDensityPlot3D SliceDistribution SliceVectorPlot3D Slider Slider2D Slider2DBox Slider2DBoxOptions SliderBox SliderBoxOptions SlideView Slot SlotSequence Small SmallCircle Smaller SmithDecomposition SmithDelayCompensator SmithWatermanSimilarity SmoothDensityHistogram SmoothHistogram SmoothHistogram3D SmoothKernelDistribution SnDispersion Snippet SnubPolyhedron SocialMediaData Socket SocketConnect SocketListen SocketListener SocketObject SocketOpen SocketReadMessage SocketReadyQ Sockets SocketWaitAll SocketWaitNext SoftmaxLayer SokalSneathDissimilarity SolarEclipse SolarSystemFeatureData SolidAngle SolidData SolidRegionQ Solve SolveAlways SolveDelayed Sort SortBy SortedBy SortedEntityClass Sound SoundAndGraphics SoundNote SoundVolume SourceLink Sow Space SpaceCurveData SpaceForm Spacer Spacings Span SpanAdjustments SpanCharacterRounding SpanFromAbove SpanFromBoth SpanFromLeft SpanLineThickness SpanMaxSize SpanMinSize SpanningCharacters SpanSymmetric SparseArray SpatialGraphDistribution SpatialMedian SpatialTransformationLayer Speak SpeakTextPacket SpearmanRankTest SpearmanRho SpeciesData SpecificityGoal SpectralLineData Spectrogram SpectrogramArray Specularity SpeechRecognize SpeechSynthesize SpellingCorrection SpellingCorrectionList SpellingDictionaries SpellingDictionariesPath SpellingOptions SpellingSuggestionsPacket Sphere SphereBox SpherePoints SphericalBesselJ SphericalBesselY SphericalHankelH1 SphericalHankelH2 SphericalHarmonicY SphericalPlot3D SphericalRegion SphericalShell SpheroidalEigenvalue SpheroidalJoiningFactor SpheroidalPS SpheroidalPSPrime SpheroidalQS SpheroidalQSPrime SpheroidalRadialFactor SpheroidalS1 SpheroidalS1Prime SpheroidalS2 SpheroidalS2Prime Splice SplicedDistribution SplineClosed SplineDegree SplineKnots SplineWeights Split SplitBy SpokenString Sqrt SqrtBox SqrtBoxOptions Square SquaredEuclideanDistance SquareFreeQ SquareIntersection SquareMatrixQ SquareRepeatingElement SquaresR SquareSubset SquareSubsetEqual SquareSuperset SquareSupersetEqual SquareUnion SquareWave SSSTriangle StabilityMargins StabilityMarginsStyle StableDistribution Stack StackBegin StackComplete StackedDateListPlot StackedListPlot StackInhibit StadiumShape StandardAtmosphereData StandardDeviation StandardDeviationFilter StandardForm Standardize Standardized StandardOceanData StandbyDistribution Star StarClusterData StarData StarGraph StartAsynchronousTask StartExternalSession StartingStepSize StartOfLine StartOfString StartProcess StartScheduledTask StartupSound StartWebSession StateDimensions StateFeedbackGains StateOutputEstimator StateResponse StateSpaceModel StateSpaceRealization StateSpaceTransform StateTransformationLinearize StationaryDistribution StationaryWaveletPacketTransform StationaryWaveletTransform StatusArea StatusCentrality StepMonitor StereochemistryElements StieltjesGamma StirlingS1 StirlingS2 StopAsynchronousTask StoppingPowerData StopScheduledTask StrataVariables StratonovichProcess StreamColorFunction StreamColorFunctionScaling StreamDensityPlot StreamMarkers StreamPlot StreamPoints StreamPosition Streams StreamScale StreamStyle String StringBreak StringByteCount StringCases StringContainsQ StringCount StringDelete StringDrop StringEndsQ StringExpression StringExtract StringForm StringFormat StringFreeQ StringInsert StringJoin StringLength StringMatchQ StringPadLeft StringPadRight StringPart StringPartition StringPosition StringQ StringRepeat StringReplace StringReplaceList StringReplacePart StringReverse StringRiffle StringRotateLeft StringRotateRight StringSkeleton StringSplit StringStartsQ StringTake StringTemplate StringToByteArray StringToStream StringTrim StripBoxes StripOnInput StripWrapperBoxes StrokeForm StructuralImportance StructuredArray StructuredSelection StruveH StruveL Stub StudentTDistribution Style StyleBox StyleBoxAutoDelete StyleData StyleDefinitions StyleForm StyleHints StyleKeyMapping StyleMenuListing StyleNameDialogSettings StyleNames StylePrint StyleSheetPath Subdivide Subfactorial Subgraph SubMinus SubPlus SubresultantPolynomialRemainders SubresultantPolynomials Subresultants Subscript SubscriptBox SubscriptBoxOptions Subscripted Subsequences Subset SubsetEqual SubsetMap SubsetQ Subsets SubStar SubstitutionSystem Subsuperscript SubsuperscriptBox SubsuperscriptBoxOptions Subtract SubtractFrom SubtractSides SubValues Succeeds SucceedsEqual SucceedsSlantEqual SucceedsTilde Success SuchThat Sum SumConvergence SummationLayer Sunday SunPosition Sunrise Sunset SuperDagger SuperMinus SupernovaData SuperPlus Superscript SuperscriptBox SuperscriptBoxOptions Superset SupersetEqual SuperStar Surd SurdForm SurfaceArea SurfaceColor SurfaceData SurfaceGraphics SurvivalDistribution SurvivalFunction SurvivalModel SurvivalModelFit SuspendPacket SuzukiDistribution SuzukiGroupSuz SwatchLegend Switch Symbol SymbolName SymletWavelet Symmetric SymmetricGroup SymmetricKey SymmetricMatrixQ SymmetricPolynomial SymmetricReduction Symmetrize SymmetrizedArray SymmetrizedArrayRules SymmetrizedDependentComponents SymmetrizedIndependentComponents SymmetrizedReplacePart SynchronousInitialization SynchronousUpdating Synonyms Syntax SyntaxForm SyntaxInformation SyntaxLength SyntaxPacket SyntaxQ SynthesizeMissingValues SystemDialogInput SystemException SystemGet SystemHelpPath SystemInformation SystemInformationData SystemInstall SystemModel SystemModeler SystemModelExamples SystemModelLinearize SystemModelParametricSimulate SystemModelPlot SystemModelProgressReporting SystemModelReliability SystemModels SystemModelSimulate SystemModelSimulateSensitivity SystemModelSimulationData SystemOpen SystemOptions SystemProcessData SystemProcesses SystemsConnectionsModel SystemsModelDelay SystemsModelDelayApproximate SystemsModelDelete SystemsModelDimensions SystemsModelExtract SystemsModelFeedbackConnect SystemsModelLabels SystemsModelLinearity SystemsModelMerge SystemsModelOrder SystemsModelParallelConnect SystemsModelSeriesConnect SystemsModelStateFeedbackConnect SystemsModelVectorRelativeOrders SystemStub SystemTestTab TabFilling Table TableAlignments TableDepth TableDirections TableForm TableHeadings TableSpacing TableView TableViewBox TableViewBoxBackground TableViewBoxOptions TabSpacings TabView TabViewBox TabViewBoxOptions TagBox TagBoxNote TagBoxOptions TaggingRules TagSet TagSetDelayed TagStyle TagUnset Take TakeDrop TakeLargest TakeLargestBy TakeList TakeSmallest TakeSmallestBy TakeWhile Tally Tan Tanh TargetDevice TargetFunctions TargetSystem TargetUnits TaskAbort TaskExecute TaskObject TaskRemove TaskResume Tasks TaskSuspend TaskWait TautologyQ TelegraphProcess TemplateApply TemplateArgBox TemplateBox TemplateBoxOptions TemplateEvaluate TemplateExpression TemplateIf TemplateObject TemplateSequence TemplateSlot TemplateSlotSequence TemplateUnevaluated TemplateVerbatim TemplateWith TemporalData TemporalRegularity Temporary TemporaryVariable TensorContract TensorDimensions TensorExpand TensorProduct TensorQ TensorRank TensorReduce TensorSymmetry TensorTranspose TensorWedge TestID TestReport TestReportObject TestResultObject Tetrahedron TetrahedronBox TetrahedronBoxOptions TeXForm TeXSave Text Text3DBox Text3DBoxOptions TextAlignment TextBand TextBoundingBox TextBox TextCases TextCell TextClipboardType TextContents TextData TextElement TextForm TextGrid TextJustification TextLine TextPacket TextParagraph TextPosition TextRecognize TextSearch TextSearchReport TextSentences TextString TextStructure TextStyle TextTranslation Texture TextureCoordinateFunction TextureCoordinateScaling TextWords Therefore ThermodynamicData ThermometerGauge Thick Thickness Thin Thinning ThisLink ThompsonGroupTh Thread ThreadingLayer ThreeJSymbol Threshold Through Throw ThueMorse Thumbnail Thursday Ticks TicksStyle TideData Tilde TildeEqual TildeFullEqual TildeTilde TimeConstrained TimeConstraint TimeDirection TimeFormat TimeGoal TimelinePlot TimeObject TimeObjectQ Times TimesBy TimeSeries TimeSeriesAggregate TimeSeriesForecast TimeSeriesInsert TimeSeriesInvertibility TimeSeriesMap TimeSeriesMapThread TimeSeriesModel TimeSeriesModelFit TimeSeriesResample TimeSeriesRescale TimeSeriesShift TimeSeriesThread TimeSeriesWindow TimeUsed TimeValue TimeWarpingCorrespondence TimeWarpingDistance TimeZone TimeZoneConvert TimeZoneOffset Timing Tiny TitleGrouping TitsGroupT ToBoxes ToCharacterCode ToColor ToContinuousTimeModel ToDate Today ToDiscreteTimeModel ToEntity ToeplitzMatrix ToExpression ToFileName Together Toggle ToggleFalse Toggler TogglerBar TogglerBox TogglerBoxOptions ToHeldExpression ToInvertibleTimeSeries TokenWords Tolerance ToLowerCase Tomorrow ToNumberField TooBig Tooltip TooltipBox TooltipBoxOptions TooltipDelay TooltipStyle Top TopHatTransform ToPolarCoordinates TopologicalSort ToRadicals ToRules ToSphericalCoordinates ToString Total TotalHeight TotalLayer TotalVariationFilter TotalWidth TouchPosition TouchscreenAutoZoom TouchscreenControlPlacement ToUpperCase Tr Trace TraceAbove TraceAction TraceBackward TraceDepth TraceDialog TraceForward TraceInternal TraceLevel TraceOff TraceOn TraceOriginal TracePrint TraceScan TrackedSymbols TrackingFunction TracyWidomDistribution TradingChart TraditionalForm TraditionalFunctionNotation TraditionalNotation TraditionalOrder TrainingProgressCheckpointing TrainingProgressFunction TrainingProgressMeasurements TrainingProgressReporting TrainingStoppingCriterion TransferFunctionCancel TransferFunctionExpand TransferFunctionFactor TransferFunctionModel TransferFunctionPoles TransferFunctionTransform TransferFunctionZeros TransformationClass TransformationFunction TransformationFunctions TransformationMatrix TransformedDistribution TransformedField TransformedProcess TransformedRegion TransitionDirection TransitionDuration TransitionEffect TransitiveClosureGraph TransitiveReductionGraph Translate TranslationOptions TranslationTransform Transliterate Transparent TransparentColor Transpose TransposeLayer TrapSelection TravelDirections TravelDirectionsData TravelDistance TravelDistanceList TravelMethod TravelTime TreeForm TreeGraph TreeGraphQ TreePlot TrendStyle Triangle TriangleCenter TriangleConstruct TriangleMeasurement TriangleWave TriangularDistribution TriangulateMesh Trig TrigExpand TrigFactor TrigFactorList Trigger TrigReduce TrigToExp TrimmedMean TrimmedVariance TropicalStormData True TrueQ TruncatedDistribution TruncatedPolyhedron TsallisQExponentialDistribution TsallisQGaussianDistribution TTest Tube TubeBezierCurveBox TubeBezierCurveBoxOptions TubeBox TubeBoxOptions TubeBSplineCurveBox TubeBSplineCurveBoxOptions Tuesday TukeyLambdaDistribution TukeyWindow TunnelData Tuples TuranGraph TuringMachine TuttePolynomial TwoWayRule Typed TypeSpecifierUnateQ Uncompress UnconstrainedParameters Undefined UnderBar Underflow Underlined Underoverscript UnderoverscriptBox UnderoverscriptBoxOptions Underscript UnderscriptBox UnderscriptBoxOptions UnderseaFeatureData UndirectedEdge UndirectedGraph UndirectedGraphQ UndoOptions UndoTrackedVariables Unequal UnequalTo Unevaluated UniformDistribution UniformGraphDistribution UniformPolyhedron UniformSumDistribution Uninstall Union UnionPlus Unique UnitaryMatrixQ UnitBox UnitConvert UnitDimensions Unitize UnitRootTest UnitSimplify UnitStep UnitSystem UnitTriangle UnitVector UnitVectorLayer UnityDimensions UniverseModelData UniversityData UnixTime Unprotect UnregisterExternalEvaluator UnsameQ UnsavedVariables Unset UnsetShared UntrackedVariables Up UpArrow UpArrowBar UpArrowDownArrow Update UpdateDynamicObjects UpdateDynamicObjectsSynchronous UpdateInterval UpdateSearchIndex UpDownArrow UpEquilibrium UpperCaseQ UpperLeftArrow UpperRightArrow UpperTriangularize UpperTriangularMatrixQ Upsample UpSet UpSetDelayed UpTee UpTeeArrow UpTo UpValues URL URLBuild URLDecode URLDispatcher URLDownload URLDownloadSubmit URLEncode URLExecute URLExpand URLFetch URLFetchAsynchronous URLParse URLQueryDecode URLQueryEncode URLRead URLResponseTime URLSave URLSaveAsynchronous URLShorten URLSubmit UseGraphicsRange UserDefinedWavelet Using UsingFrontEnd UtilityFunctionV2Get ValenceErrorHandling ValidationLength ValidationSet Value ValueBox ValueBoxOptions ValueDimensions ValueForm ValuePreprocessingFunction ValueQ Values ValuesData Variables Variance VarianceEquivalenceTest VarianceEstimatorFunction VarianceGammaDistribution VarianceTest VectorAngle VectorAround VectorColorFunction VectorColorFunctionScaling VectorDensityPlot VectorGlyphData VectorGreater VectorGreaterEqual VectorLess VectorLessEqual VectorMarkers VectorPlot VectorPlot3D VectorPoints VectorQ Vectors VectorScale VectorStyle Vee Verbatim Verbose VerboseConvertToPostScriptPacket VerificationTest VerifyConvergence VerifyDerivedKey VerifyDigitalSignature VerifyInterpretation VerifySecurityCertificates VerifySolutions VerifyTestAssumptions Version VersionNumber VertexAdd VertexCapacity VertexColors VertexComponent VertexConnectivity VertexContract VertexCoordinateRules VertexCoordinates VertexCorrelationSimilarity VertexCosineSimilarity VertexCount VertexCoverQ VertexDataCoordinates VertexDegree VertexDelete VertexDiceSimilarity VertexEccentricity VertexInComponent VertexInDegree VertexIndex VertexJaccardSimilarity VertexLabeling VertexLabels VertexLabelStyle VertexList VertexNormals VertexOutComponent VertexOutDegree VertexQ VertexRenderingFunction VertexReplace VertexShape VertexShapeFunction VertexSize VertexStyle VertexTextureCoordinates VertexWeight VertexWeightedGraphQ Vertical VerticalBar VerticalForm VerticalGauge VerticalSeparator VerticalSlider VerticalTilde ViewAngle ViewCenter ViewMatrix ViewPoint ViewPointSelectorSettings ViewPort ViewProjection ViewRange ViewVector ViewVertical VirtualGroupData Visible VisibleCell VoiceStyleData VoigtDistribution VolcanoData Volume VonMisesDistribution VoronoiMeshWaitAll WaitAsynchronousTask WaitNext WaitUntil WakebyDistribution WalleniusHypergeometricDistribution WaringYuleDistribution WarpingCorrespondence WarpingDistance WatershedComponents WatsonUSquareTest WattsStrogatzGraphDistribution WaveletBestBasis WaveletFilterCoefficients WaveletImagePlot WaveletListPlot WaveletMapIndexed WaveletMatrixPlot WaveletPhi WaveletPsi WaveletScale WaveletScalogram WaveletThreshold WeaklyConnectedComponents WeaklyConnectedGraphComponents WeaklyConnectedGraphQ WeakStationarity WeatherData WeatherForecastData WebAudioSearch WebElementObject WeberE WebExecute WebImage WebImageSearch WebSearch WebSessionObject WebSessions WebWindowObject Wedge Wednesday WeibullDistribution WeierstrassE1 WeierstrassE2 WeierstrassE3 WeierstrassEta1 WeierstrassEta2 WeierstrassEta3 WeierstrassHalfPeriods WeierstrassHalfPeriodW1 WeierstrassHalfPeriodW2 WeierstrassHalfPeriodW3 WeierstrassInvariantG2 WeierstrassInvariantG3 WeierstrassInvariants WeierstrassP WeierstrassPPrime WeierstrassSigma WeierstrassZeta WeightedAdjacencyGraph WeightedAdjacencyMatrix WeightedData WeightedGraphQ Weights WelchWindow WheelGraph WhenEvent Which While White WhiteNoiseProcess WhitePoint Whitespace WhitespaceCharacter WhittakerM WhittakerW WienerFilter WienerProcess WignerD WignerSemicircleDistribution WikipediaData WikipediaSearch WilksW WilksWTest WindDirectionData WindingCount WindingPolygon WindowClickSelect WindowElements WindowFloating WindowFrame WindowFrameElements WindowMargins WindowMovable WindowOpacity WindowPersistentStyles WindowSelected WindowSize WindowStatusArea WindowTitle WindowToolbars WindowWidth WindSpeedData WindVectorData WinsorizedMean WinsorizedVariance WishartMatrixDistribution With WolframAlpha WolframAlphaDate WolframAlphaQuantity WolframAlphaResult WolframLanguageData Word WordBoundary WordCharacter WordCloud WordCount WordCounts WordData WordDefinition WordFrequency WordFrequencyData WordList WordOrientation WordSearch WordSelectionFunction WordSeparators WordSpacings WordStem WordTranslation WorkingPrecision WrapAround Write WriteLine WriteString WronskianXMLElement XMLObject XMLTemplate Xnor Xor XYZColorYellow Yesterday YuleDissimilarityZernikeR ZeroSymmetric ZeroTest ZeroWidthTimes Zeta ZetaZero ZIPCodeData ZipfDistribution ZoomCenter ZoomFactor ZTest ZTransform$Aborted $ActivationGroupID $ActivationKey $ActivationUserRegistered $AddOnsDirectory $AllowExternalChannelFunctions $AssertFunction $Assumptions $AsynchronousTask $AudioInputDevices $AudioOutputDevices $BaseDirectory $BatchInput $BatchOutput $BlockchainBase $BoxForms $ByteOrdering $CacheBaseDirectory $Canceled $ChannelBase $CharacterEncoding $CharacterEncodings $CloudBase $CloudConnected $CloudCreditsAvailable $CloudEvaluation $CloudExpressionBase $CloudObjectNameFormat $CloudObjectURLType $CloudRootDirectory $CloudSymbolBase $CloudUserID $CloudUserUUID $CloudVersion $CloudVersionNumber $CloudWolframEngineVersionNumber $CommandLine $CompilationTarget $ConditionHold $ConfiguredKernels $Context $ContextPath $ControlActiveSetting $Cookies $CookieStore $CreationDate $CurrentLink $CurrentTask $CurrentWebSession $DateStringFormat $DefaultAudioInputDevice $DefaultAudioOutputDevice $DefaultFont $DefaultFrontEnd $DefaultImagingDevice $DefaultLocalBase $DefaultMailbox $DefaultNetworkInterface $DefaultPath $Display $DisplayFunction $DistributedContexts $DynamicEvaluation $Echo $EmbedCodeEnvironments $EmbeddableServices $EntityStores $Epilog $EvaluationCloudBase $EvaluationCloudObject $EvaluationEnvironment $ExportFormats $Failed $FinancialDataSource $FontFamilies $FormatType $FrontEnd $FrontEndSession $GeoEntityTypes $GeoLocation $GeoLocationCity $GeoLocationCountry $GeoLocationPrecision $GeoLocationSource $HistoryLength $HomeDirectory $HTMLExportRules $HTTPCookies $HTTPRequest $IgnoreEOF $ImageFormattingWidth $ImagingDevice $ImagingDevices $ImportFormats $IncomingMailSettings $InitialDirectory $Initialization $InitializationContexts $Input $InputFileName $InputStreamMethods $Inspector $InstallationDate $InstallationDirectory $InterfaceEnvironment $InterpreterTypes $IterationLimit $KernelCount $KernelID $Language $LaunchDirectory $LibraryPath $LicenseExpirationDate $LicenseID $LicenseProcesses $LicenseServer $LicenseSubprocesses $LicenseType $Line $Linked $LinkSupported $LoadedFiles $LocalBase $LocalSymbolBase $MachineAddresses $MachineDomain $MachineDomains $MachineEpsilon $MachineID $MachineName $MachinePrecision $MachineType $MaxExtraPrecision $MaxLicenseProcesses $MaxLicenseSubprocesses $MaxMachineNumber $MaxNumber $MaxPiecewiseCases $MaxPrecision $MaxRootDegree $MessageGroups $MessageList $MessagePrePrint $Messages $MinMachineNumber $MinNumber $MinorReleaseNumber $MinPrecision $MobilePhone $ModuleNumber $NetworkConnected $NetworkInterfaces $NetworkLicense $NewMessage $NewSymbol $Notebooks $NoValue $NumberMarks $Off $OperatingSystem $Output $OutputForms $OutputSizeLimit $OutputStreamMethods $Packages $ParentLink $ParentProcessID $PasswordFile $PatchLevelID $Path $PathnameSeparator $PerformanceGoal $Permissions $PermissionsGroupBase $PersistenceBase $PersistencePath $PipeSupported $PlotTheme $Post $Pre $PreferencesDirectory $PreInitialization $PrePrint $PreRead $PrintForms $PrintLiteral $Printout3DPreviewer $ProcessID $ProcessorCount $ProcessorType $ProductInformation $ProgramName $PublisherID $RandomState $RecursionLimit $RegisteredDeviceClasses $RegisteredUserName $ReleaseNumber $RequesterAddress $RequesterWolframID $RequesterWolframUUID $ResourceSystemBase $RootDirectory $ScheduledTask $ScriptCommandLine $ScriptInputString $SecuredAuthenticationKeyTokens $ServiceCreditsAvailable $Services $SessionID $SetParentLink $SharedFunctions $SharedVariables $SoundDisplay $SoundDisplayFunction $SourceLink $SSHAuthentication $SummaryBoxDataSizeLimit $SuppressInputFormHeads $SynchronousEvaluation $SyntaxHandler $System $SystemCharacterEncoding $SystemID $SystemMemory $SystemShell $SystemTimeZone $SystemWordLength $TemplatePath $TemporaryDirectory $TemporaryPrefix $TestFileName $TextStyle $TimedOut $TimeUnit $TimeZone $TimeZoneEntity $TopDirectory $TraceOff $TraceOn $TracePattern $TracePostAction $TracePreAction $UnitSystem $Urgent $UserAddOnsDirectory $UserAgentLanguages $UserAgentMachine $UserAgentName $UserAgentOperatingSystem $UserAgentString $UserAgentVersion $UserBaseDirectory $UserDocumentsDirectory $Username $UserName $UserURLBase $Version $VersionNumber $VoiceStyles $WolframID $WolframUUID",
        contains: [
            hljs.COMMENT("\\(\\*", "\\*\\)", {
                contains: [
                    "self"
                ]
            }),
            hljs.QUOTE_STRING_MODE,
            hljs.C_NUMBER_MODE
        ]
    };
};

});

parcelRegister("2DX6A", function(module, exports) {
module.exports = /*
  Formal syntax is not published, helpful link:
  https://github.com/kornilova-l/matlab-IntelliJ-plugin/blob/master/src/main/grammar/Matlab.bnf
*/ function(hljs) {
    var TRANSPOSE_RE = "('|\\.')+";
    var TRANSPOSE = {
        relevance: 0,
        contains: [
            {
                begin: TRANSPOSE_RE
            }
        ]
    };
    return {
        keywords: {
            keyword: "break case catch classdef continue else elseif end enumerated events for function global if methods otherwise parfor persistent properties return spmd switch try while",
            built_in: "sin sind sinh asin asind asinh cos cosd cosh acos acosd acosh tan tand tanh atan atand atan2 atanh sec secd sech asec asecd asech csc cscd csch acsc acscd acsch cot cotd coth acot acotd acoth hypot exp expm1 log log1p log10 log2 pow2 realpow reallog realsqrt sqrt nthroot nextpow2 abs angle complex conj imag real unwrap isreal cplxpair fix floor ceil round mod rem sign airy besselj bessely besselh besseli besselk beta betainc betaln ellipj ellipke erf erfc erfcx erfinv expint gamma gammainc gammaln psi legendre cross dot factor isprime primes gcd lcm rat rats perms nchoosek factorial cart2sph cart2pol pol2cart sph2cart hsv2rgb rgb2hsv zeros ones eye repmat rand randn linspace logspace freqspace meshgrid accumarray size length ndims numel disp isempty isequal isequalwithequalnans cat reshape diag blkdiag tril triu fliplr flipud flipdim rot90 find sub2ind ind2sub bsxfun ndgrid permute ipermute shiftdim circshift squeeze isscalar isvector ans eps realmax realmin pi i inf nan isnan isinf isfinite j why compan gallery hadamard hankel hilb invhilb magic pascal rosser toeplitz vander wilkinson max min nanmax nanmin mean nanmean type table readtable writetable sortrows sort figure plot plot3 scatter scatter3 cellfun legend intersect ismember procrustes hold num2cell "
        },
        illegal: '(//|"|#|/\\*|\\s+/\\w+)',
        contains: [
            {
                className: "function",
                beginKeywords: "function",
                end: "$",
                contains: [
                    hljs.UNDERSCORE_TITLE_MODE,
                    {
                        className: "params",
                        variants: [
                            {
                                begin: "\\(",
                                end: "\\)"
                            },
                            {
                                begin: "\\[",
                                end: "\\]"
                            }
                        ]
                    }
                ]
            },
            {
                className: "built_in",
                begin: /true|false/,
                relevance: 0,
                starts: TRANSPOSE
            },
            {
                begin: "[a-zA-Z][a-zA-Z_0-9]*" + TRANSPOSE_RE,
                relevance: 0
            },
            {
                className: "number",
                begin: hljs.C_NUMBER_RE,
                relevance: 0,
                starts: TRANSPOSE
            },
            {
                className: "string",
                begin: "'",
                end: "'",
                contains: [
                    hljs.BACKSLASH_ESCAPE,
                    {
                        begin: "''"
                    }
                ]
            },
            {
                begin: /\]|}|\)/,
                relevance: 0,
                starts: TRANSPOSE
            },
            {
                className: "string",
                begin: '"',
                end: '"',
                contains: [
                    hljs.BACKSLASH_ESCAPE,
                    {
                        begin: '""'
                    }
                ],
                starts: TRANSPOSE
            },
            hljs.COMMENT("^\\s*\\%\\{\\s*$", "^\\s*\\%\\}\\s*$"),
            hljs.COMMENT("\\%", "$")
        ]
    };
};

});

parcelRegister("aUT8O", function(module, exports) {
module.exports = function(hljs) {
    var KEYWORDS = "if then else elseif for thru do while unless step in and or not";
    var LITERALS = "true false unknown inf minf ind und %e %i %pi %phi %gamma";
    var BUILTIN_FUNCTIONS = " abasep abs absint absolute_real_time acos acosh acot acoth acsc acsch activate addcol add_edge add_edges addmatrices addrow add_vertex add_vertices adjacency_matrix adjoin adjoint af agd airy airy_ai airy_bi airy_dai airy_dbi algsys alg_type alias allroots alphacharp alphanumericp amortization %and annuity_fv annuity_pv antid antidiff AntiDifference append appendfile apply apply1 apply2 applyb1 apropos args arit_amortization arithmetic arithsum array arrayapply arrayinfo arraymake arraysetapply ascii asec asech asin asinh askinteger asksign assoc assoc_legendre_p assoc_legendre_q assume assume_external_byte_order asympa at atan atan2 atanh atensimp atom atvalue augcoefmatrix augmented_lagrangian_method av average_degree backtrace bars barsplot barsplot_description base64 base64_decode bashindices batch batchload bc2 bdvac belln benefit_cost bern bernpoly bernstein_approx bernstein_expand bernstein_poly bessel bessel_i bessel_j bessel_k bessel_simplify bessel_y beta beta_incomplete beta_incomplete_generalized beta_incomplete_regularized bezout bfallroots bffac bf_find_root bf_fmin_cobyla bfhzeta bfloat bfloatp bfpsi bfpsi0 bfzeta biconnected_components bimetric binomial bipartition block blockmatrixp bode_gain bode_phase bothcoef box boxplot boxplot_description break bug_report build_info|10 buildq build_sample burn cabs canform canten cardinality carg cartan cartesian_product catch cauchy_matrix cbffac cdf_bernoulli cdf_beta cdf_binomial cdf_cauchy cdf_chi2 cdf_continuous_uniform cdf_discrete_uniform cdf_exp cdf_f cdf_gamma cdf_general_finite_discrete cdf_geometric cdf_gumbel cdf_hypergeometric cdf_laplace cdf_logistic cdf_lognormal cdf_negative_binomial cdf_noncentral_chi2 cdf_noncentral_student_t cdf_normal cdf_pareto cdf_poisson cdf_rank_sum cdf_rayleigh cdf_signed_rank cdf_student_t cdf_weibull cdisplay ceiling central_moment cequal cequalignore cf cfdisrep cfexpand cgeodesic cgreaterp cgreaterpignore changename changevar chaosgame charat charfun charfun2 charlist charp charpoly chdir chebyshev_t chebyshev_u checkdiv check_overlaps chinese cholesky christof chromatic_index chromatic_number cint circulant_graph clear_edge_weight clear_rules clear_vertex_label clebsch_gordan clebsch_graph clessp clesspignore close closefile cmetric coeff coefmatrix cograd col collapse collectterms columnop columnspace columnswap columnvector combination combine comp2pui compare compfile compile compile_file complement_graph complete_bipartite_graph complete_graph complex_number_p components compose_functions concan concat conjugate conmetderiv connected_components connect_vertices cons constant constantp constituent constvalue cont2part content continuous_freq contortion contour_plot contract contract_edge contragrad contrib_ode convert coord copy copy_file copy_graph copylist copymatrix cor cos cosh cot coth cov cov1 covdiff covect covers crc24sum create_graph create_list csc csch csetup cspline ctaylor ct_coordsys ctransform ctranspose cube_graph cuboctahedron_graph cunlisp cv cycle_digraph cycle_graph cylindrical days360 dblint deactivate declare declare_constvalue declare_dimensions declare_fundamental_dimensions declare_fundamental_units declare_qty declare_translated declare_unit_conversion declare_units declare_weights decsym defcon define define_alt_display define_variable defint defmatch defrule defstruct deftaylor degree_sequence del delete deleten delta demo demoivre denom depends derivdegree derivlist describe desolve determinant dfloat dgauss_a dgauss_b dgeev dgemm dgeqrf dgesv dgesvd diag diagmatrix diag_matrix diagmatrixp diameter diff digitcharp dimacs_export dimacs_import dimension dimensionless dimensions dimensions_as_list direct directory discrete_freq disjoin disjointp disolate disp dispcon dispform dispfun dispJordan display disprule dispterms distrib divide divisors divsum dkummer_m dkummer_u dlange dodecahedron_graph dotproduct dotsimp dpart draw draw2d draw3d drawdf draw_file draw_graph dscalar echelon edge_coloring edge_connectivity edges eigens_by_jacobi eigenvalues eigenvectors eighth einstein eivals eivects elapsed_real_time elapsed_run_time ele2comp ele2polynome ele2pui elem elementp elevation_grid elim elim_allbut eliminate eliminate_using ellipse elliptic_e elliptic_ec elliptic_eu elliptic_f elliptic_kc elliptic_pi ematrix empty_graph emptyp endcons entermatrix entertensor entier equal equalp equiv_classes erf erfc erf_generalized erfi errcatch error errormsg errors euler ev eval_string evenp every evolution evolution2d evundiff example exp expand expandwrt expandwrt_factored expint expintegral_chi expintegral_ci expintegral_e expintegral_e1 expintegral_ei expintegral_e_simplify expintegral_li expintegral_shi expintegral_si explicit explose exponentialize express expt exsec extdiff extract_linear_equations extremal_subset ezgcd %f f90 facsum factcomb factor factorfacsum factorial factorout factorsum facts fast_central_elements fast_linsolve fasttimes featurep fernfale fft fib fibtophi fifth filename_merge file_search file_type fillarray findde find_root find_root_abs find_root_error find_root_rel first fix flatten flength float floatnump floor flower_snark flush flush1deriv flushd flushnd flush_output fmin_cobyla forget fortran fourcos fourexpand fourier fourier_elim fourint fourintcos fourintsin foursimp foursin fourth fposition frame_bracket freeof freshline fresnel_c fresnel_s from_adjacency_matrix frucht_graph full_listify fullmap fullmapl fullratsimp fullratsubst fullsetify funcsolve fundamental_dimensions fundamental_units fundef funmake funp fv g0 g1 gamma gamma_greek gamma_incomplete gamma_incomplete_generalized gamma_incomplete_regularized gauss gauss_a gauss_b gaussprob gcd gcdex gcdivide gcfac gcfactor gd generalized_lambert_w genfact gen_laguerre genmatrix gensym geo_amortization geo_annuity_fv geo_annuity_pv geomap geometric geometric_mean geosum get getcurrentdirectory get_edge_weight getenv get_lu_factors get_output_stream_string get_pixel get_plot_option get_tex_environment get_tex_environment_default get_vertex_label gfactor gfactorsum ggf girth global_variances gn gnuplot_close gnuplot_replot gnuplot_reset gnuplot_restart gnuplot_start go Gosper GosperSum gr2d gr3d gradef gramschmidt graph6_decode graph6_encode graph6_export graph6_import graph_center graph_charpoly graph_eigenvalues graph_flow graph_order graph_periphery graph_product graph_size graph_union great_rhombicosidodecahedron_graph great_rhombicuboctahedron_graph grid_graph grind grobner_basis grotzch_graph hamilton_cycle hamilton_path hankel hankel_1 hankel_2 harmonic harmonic_mean hav heawood_graph hermite hessian hgfred hilbertmap hilbert_matrix hipow histogram histogram_description hodge horner hypergeometric i0 i1 %ibes ic1 ic2 ic_convert ichr1 ichr2 icosahedron_graph icosidodecahedron_graph icurvature ident identfor identity idiff idim idummy ieqn %if ifactors iframes ifs igcdex igeodesic_coords ilt image imagpart imetric implicit implicit_derivative implicit_plot indexed_tensor indices induced_subgraph inferencep inference_result infix info_display init_atensor init_ctensor in_neighbors innerproduct inpart inprod inrt integerp integer_partitions integrate intersect intersection intervalp intopois intosum invariant1 invariant2 inverse_fft inverse_jacobi_cd inverse_jacobi_cn inverse_jacobi_cs inverse_jacobi_dc inverse_jacobi_dn inverse_jacobi_ds inverse_jacobi_nc inverse_jacobi_nd inverse_jacobi_ns inverse_jacobi_sc inverse_jacobi_sd inverse_jacobi_sn invert invert_by_adjoint invert_by_lu inv_mod irr is is_biconnected is_bipartite is_connected is_digraph is_edge_in_graph is_graph is_graph_or_digraph ishow is_isomorphic isolate isomorphism is_planar isqrt isreal_p is_sconnected is_tree is_vertex_in_graph items_inference %j j0 j1 jacobi jacobian jacobi_cd jacobi_cn jacobi_cs jacobi_dc jacobi_dn jacobi_ds jacobi_nc jacobi_nd jacobi_ns jacobi_p jacobi_sc jacobi_sd jacobi_sn JF jn join jordan julia julia_set julia_sin %k kdels kdelta kill killcontext kostka kron_delta kronecker_product kummer_m kummer_u kurtosis kurtosis_bernoulli kurtosis_beta kurtosis_binomial kurtosis_chi2 kurtosis_continuous_uniform kurtosis_discrete_uniform kurtosis_exp kurtosis_f kurtosis_gamma kurtosis_general_finite_discrete kurtosis_geometric kurtosis_gumbel kurtosis_hypergeometric kurtosis_laplace kurtosis_logistic kurtosis_lognormal kurtosis_negative_binomial kurtosis_noncentral_chi2 kurtosis_noncentral_student_t kurtosis_normal kurtosis_pareto kurtosis_poisson kurtosis_rayleigh kurtosis_student_t kurtosis_weibull label labels lagrange laguerre lambda lambert_w laplace laplacian_matrix last lbfgs lc2kdt lcharp lc_l lcm lc_u ldefint ldisp ldisplay legendre_p legendre_q leinstein length let letrules letsimp levi_civita lfreeof lgtreillis lhs li liediff limit Lindstedt linear linearinterpol linear_program linear_regression line_graph linsolve listarray list_correlations listify list_matrix_entries list_nc_monomials listoftens listofvars listp lmax lmin load loadfile local locate_matrix_entry log logcontract log_gamma lopow lorentz_gauge lowercasep lpart lratsubst lreduce lriemann lsquares_estimates lsquares_estimates_approximate lsquares_estimates_exact lsquares_mse lsquares_residual_mse lsquares_residuals lsum ltreillis lu_backsub lucas lu_factor %m macroexpand macroexpand1 make_array makebox makefact makegamma make_graph make_level_picture makelist makeOrders make_poly_continent make_poly_country make_polygon make_random_state make_rgb_picture makeset make_string_input_stream make_string_output_stream make_transform mandelbrot mandelbrot_set map mapatom maplist matchdeclare matchfix mat_cond mat_fullunblocker mat_function mathml_display mat_norm matrix matrixmap matrixp matrix_size mattrace mat_trace mat_unblocker max max_clique max_degree max_flow maximize_lp max_independent_set max_matching maybe md5sum mean mean_bernoulli mean_beta mean_binomial mean_chi2 mean_continuous_uniform mean_deviation mean_discrete_uniform mean_exp mean_f mean_gamma mean_general_finite_discrete mean_geometric mean_gumbel mean_hypergeometric mean_laplace mean_logistic mean_lognormal mean_negative_binomial mean_noncentral_chi2 mean_noncentral_student_t mean_normal mean_pareto mean_poisson mean_rayleigh mean_student_t mean_weibull median median_deviation member mesh metricexpandall mgf1_sha1 min min_degree min_edge_cut minfactorial minimalPoly minimize_lp minimum_spanning_tree minor minpack_lsquares minpack_solve min_vertex_cover min_vertex_cut mkdir mnewton mod mode_declare mode_identity ModeMatrix moebius mon2schur mono monomial_dimensions multibernstein_poly multi_display_for_texinfo multi_elem multinomial multinomial_coeff multi_orbit multiplot_mode multi_pui multsym multthru mycielski_graph nary natural_unit nc_degree ncexpt ncharpoly negative_picture neighbors new newcontext newdet new_graph newline newton new_variable next_prime nicedummies niceindices ninth nofix nonarray noncentral_moment nonmetricity nonnegintegerp nonscalarp nonzeroandfreeof notequal nounify nptetrad npv nroots nterms ntermst nthroot nullity nullspace num numbered_boundaries numberp number_to_octets num_distinct_partitions numerval numfactor num_partitions nusum nzeta nzetai nzetar octets_to_number octets_to_oid odd_girth oddp ode2 ode_check odelin oid_to_octets op opena opena_binary openr openr_binary openw openw_binary operatorp opsubst optimize %or orbit orbits ordergreat ordergreatp orderless orderlessp orthogonal_complement orthopoly_recur orthopoly_weight outermap out_neighbors outofpois pade parabolic_cylinder_d parametric parametric_surface parg parGosper parse_string parse_timedate part part2cont partfrac partition partition_set partpol path_digraph path_graph pathname_directory pathname_name pathname_type pdf_bernoulli pdf_beta pdf_binomial pdf_cauchy pdf_chi2 pdf_continuous_uniform pdf_discrete_uniform pdf_exp pdf_f pdf_gamma pdf_general_finite_discrete pdf_geometric pdf_gumbel pdf_hypergeometric pdf_laplace pdf_logistic pdf_lognormal pdf_negative_binomial pdf_noncentral_chi2 pdf_noncentral_student_t pdf_normal pdf_pareto pdf_poisson pdf_rank_sum pdf_rayleigh pdf_signed_rank pdf_student_t pdf_weibull pearson_skewness permanent permut permutation permutations petersen_graph petrov pickapart picture_equalp picturep piechart piechart_description planar_embedding playback plog plot2d plot3d plotdf ploteq plsquares pochhammer points poisdiff poisexpt poisint poismap poisplus poissimp poissubst poistimes poistrim polar polarform polartorect polar_to_xy poly_add poly_buchberger poly_buchberger_criterion poly_colon_ideal poly_content polydecomp poly_depends_p poly_elimination_ideal poly_exact_divide poly_expand poly_expt poly_gcd polygon poly_grobner poly_grobner_equal poly_grobner_member poly_grobner_subsetp poly_ideal_intersection poly_ideal_polysaturation poly_ideal_polysaturation1 poly_ideal_saturation poly_ideal_saturation1 poly_lcm poly_minimization polymod poly_multiply polynome2ele polynomialp poly_normal_form poly_normalize poly_normalize_list poly_polysaturation_extension poly_primitive_part poly_pseudo_divide poly_reduced_grobner poly_reduction poly_saturation_extension poly_s_polynomial poly_subtract polytocompanion pop postfix potential power_mod powerseries powerset prefix prev_prime primep primes principal_components print printf printfile print_graph printpois printprops prodrac product properties propvars psi psubst ptriangularize pui pui2comp pui2ele pui2polynome pui_direct puireduc push put pv qput qrange qty quad_control quad_qag quad_qagi quad_qagp quad_qags quad_qawc quad_qawf quad_qawo quad_qaws quadrilateral quantile quantile_bernoulli quantile_beta quantile_binomial quantile_cauchy quantile_chi2 quantile_continuous_uniform quantile_discrete_uniform quantile_exp quantile_f quantile_gamma quantile_general_finite_discrete quantile_geometric quantile_gumbel quantile_hypergeometric quantile_laplace quantile_logistic quantile_lognormal quantile_negative_binomial quantile_noncentral_chi2 quantile_noncentral_student_t quantile_normal quantile_pareto quantile_poisson quantile_rayleigh quantile_student_t quantile_weibull quartile_skewness quit qunit quotient racah_v racah_w radcan radius random random_bernoulli random_beta random_binomial random_bipartite_graph random_cauchy random_chi2 random_continuous_uniform random_digraph random_discrete_uniform random_exp random_f random_gamma random_general_finite_discrete random_geometric random_graph random_graph1 random_gumbel random_hypergeometric random_laplace random_logistic random_lognormal random_negative_binomial random_network random_noncentral_chi2 random_noncentral_student_t random_normal random_pareto random_permutation random_poisson random_rayleigh random_regular_graph random_student_t random_tournament random_tree random_weibull range rank rat ratcoef ratdenom ratdiff ratdisrep ratexpand ratinterpol rational rationalize ratnumer ratnump ratp ratsimp ratsubst ratvars ratweight read read_array read_binary_array read_binary_list read_binary_matrix readbyte readchar read_hashed_array readline read_list read_matrix read_nested_list readonly read_xpm real_imagpart_to_conjugate realpart realroots rearray rectangle rectform rectform_log_if_constant recttopolar rediff reduce_consts reduce_order region region_boundaries region_boundaries_plus rem remainder remarray rembox remcomps remcon remcoord remfun remfunction remlet remove remove_constvalue remove_dimensions remove_edge remove_fundamental_dimensions remove_fundamental_units remove_plot_option remove_vertex rempart remrule remsym remvalue rename rename_file reset reset_displays residue resolvante resolvante_alternee1 resolvante_bipartite resolvante_diedrale resolvante_klein resolvante_klein3 resolvante_produit_sym resolvante_unitaire resolvante_vierer rest resultant return reveal reverse revert revert2 rgb2level rhs ricci riemann rinvariant risch rk rmdir rncombine romberg room rootscontract round row rowop rowswap rreduce run_testsuite %s save saving scalarp scaled_bessel_i scaled_bessel_i0 scaled_bessel_i1 scalefactors scanmap scatterplot scatterplot_description scene schur2comp sconcat scopy scsimp scurvature sdowncase sec sech second sequal sequalignore set_alt_display setdifference set_draw_defaults set_edge_weight setelmx setequalp setify setp set_partitions set_plot_option set_prompt set_random_state set_tex_environment set_tex_environment_default setunits setup_autoload set_up_dot_simplifications set_vertex_label seventh sexplode sf sha1sum sha256sum shortest_path shortest_weighted_path show showcomps showratvars sierpinskiale sierpinskimap sign signum similaritytransform simp_inequality simplify_sum simplode simpmetderiv simtran sin sinh sinsert sinvertcase sixth skewness skewness_bernoulli skewness_beta skewness_binomial skewness_chi2 skewness_continuous_uniform skewness_discrete_uniform skewness_exp skewness_f skewness_gamma skewness_general_finite_discrete skewness_geometric skewness_gumbel skewness_hypergeometric skewness_laplace skewness_logistic skewness_lognormal skewness_negative_binomial skewness_noncentral_chi2 skewness_noncentral_student_t skewness_normal skewness_pareto skewness_poisson skewness_rayleigh skewness_student_t skewness_weibull slength smake small_rhombicosidodecahedron_graph small_rhombicuboctahedron_graph smax smin smismatch snowmap snub_cube_graph snub_dodecahedron_graph solve solve_rec solve_rec_rat some somrac sort sparse6_decode sparse6_encode sparse6_export sparse6_import specint spherical spherical_bessel_j spherical_bessel_y spherical_hankel1 spherical_hankel2 spherical_harmonic spherical_to_xyz splice split sposition sprint sqfr sqrt sqrtdenest sremove sremovefirst sreverse ssearch ssort sstatus ssubst ssubstfirst staircase standardize standardize_inverse_trig starplot starplot_description status std std1 std_bernoulli std_beta std_binomial std_chi2 std_continuous_uniform std_discrete_uniform std_exp std_f std_gamma std_general_finite_discrete std_geometric std_gumbel std_hypergeometric std_laplace std_logistic std_lognormal std_negative_binomial std_noncentral_chi2 std_noncentral_student_t std_normal std_pareto std_poisson std_rayleigh std_student_t std_weibull stemplot stirling stirling1 stirling2 strim striml strimr string stringout stringp strong_components struve_h struve_l sublis sublist sublist_indices submatrix subsample subset subsetp subst substinpart subst_parallel substpart substring subvar subvarp sum sumcontract summand_to_rec supcase supcontext symbolp symmdifference symmetricp system take_channel take_inference tan tanh taylor taylorinfo taylorp taylor_simplifier taytorat tcl_output tcontract tellrat tellsimp tellsimpafter tentex tenth test_mean test_means_difference test_normality test_proportion test_proportions_difference test_rank_sum test_sign test_signed_rank test_variance test_variance_ratio tex tex1 tex_display texput %th third throw time timedate timer timer_info tldefint tlimit todd_coxeter toeplitz tokens to_lisp topological_sort to_poly to_poly_solve totaldisrep totalfourier totient tpartpol trace tracematrix trace_options transform_sample translate translate_file transpose treefale tree_reduce treillis treinat triangle triangularize trigexpand trigrat trigreduce trigsimp trunc truncate truncated_cube_graph truncated_dodecahedron_graph truncated_icosahedron_graph truncated_tetrahedron_graph tr_warnings_get tube tutte_graph ueivects uforget ultraspherical underlying_graph undiff union unique uniteigenvectors unitp units unit_step unitvector unorder unsum untellrat untimer untrace uppercasep uricci uriemann uvect vandermonde_matrix var var1 var_bernoulli var_beta var_binomial var_chi2 var_continuous_uniform var_discrete_uniform var_exp var_f var_gamma var_general_finite_discrete var_geometric var_gumbel var_hypergeometric var_laplace var_logistic var_lognormal var_negative_binomial var_noncentral_chi2 var_noncentral_student_t var_normal var_pareto var_poisson var_rayleigh var_student_t var_weibull vector vectorpotential vectorsimp verbify vers vertex_coloring vertex_connectivity vertex_degree vertex_distance vertex_eccentricity vertex_in_degree vertex_out_degree vertices vertices_to_cycle vertices_to_path %w weyl wheel_graph wiener_index wigner_3j wigner_6j wigner_9j with_stdout write_binary_data writebyte write_data writefile wronskian xreduce xthru %y Zeilberger zeroequiv zerofor zeromatrix zeromatrixp zeta zgeev zheev zlange zn_add_table zn_carmichael_lambda zn_characteristic_factors zn_determinant zn_factor_generators zn_invert_by_lu zn_log zn_mult_table absboxchar activecontexts adapt_depth additive adim aform algebraic algepsilon algexact aliases allbut all_dotsimp_denoms allocation allsym alphabetic animation antisymmetric arrays askexp assume_pos assume_pos_pred assumescalar asymbol atomgrad atrig1 axes axis_3d axis_bottom axis_left axis_right axis_top azimuth background background_color backsubst berlefact bernstein_explicit besselexpand beta_args_sum_to_integer beta_expand bftorat bftrunc bindtest border boundaries_array box boxchar breakup %c capping cauchysum cbrange cbtics center cflength cframe_flag cnonmet_flag color color_bar color_bar_tics colorbox columns commutative complex cone context contexts contour contour_levels cosnpiflag ctaypov ctaypt ctayswitch ctayvar ct_coords ctorsion_flag ctrgsimp cube current_let_rule_package cylinder data_file_name debugmode decreasing default_let_rule_package delay dependencies derivabbrev derivsubst detout diagmetric diff dim dimensions dispflag display2d|10 display_format_internal distribute_over doallmxops domain domxexpt domxmxops domxnctimes dontfactor doscmxops doscmxplus dot0nscsimp dot0simp dot1simp dotassoc dotconstrules dotdistrib dotexptsimp dotident dotscrules draw_graph_program draw_realpart edge_color edge_coloring edge_partition edge_type edge_width %edispflag elevation %emode endphi endtheta engineering_format_floats enhanced3d %enumer epsilon_lp erfflag erf_representation errormsg error_size error_syms error_type %e_to_numlog eval even evenfun evflag evfun ev_point expandwrt_denom expintexpand expintrep expon expop exptdispflag exptisolate exptsubst facexpand facsum_combine factlim factorflag factorial_expand factors_only fb feature features file_name file_output_append file_search_demo file_search_lisp file_search_maxima|10 file_search_tests file_search_usage file_type_lisp file_type_maxima|10 fill_color fill_density filled_func fixed_vertices flipflag float2bf font font_size fortindent fortspaces fpprec fpprintprec functions gamma_expand gammalim gdet genindex gensumnum GGFCFMAX GGFINFINITY globalsolve gnuplot_command gnuplot_curve_styles gnuplot_curve_titles gnuplot_default_term_command gnuplot_dumb_term_command gnuplot_file_args gnuplot_file_name gnuplot_out_file gnuplot_pdf_term_command gnuplot_pm3d gnuplot_png_term_command gnuplot_postamble gnuplot_preamble gnuplot_ps_term_command gnuplot_svg_term_command gnuplot_term gnuplot_view_args Gosper_in_Zeilberger gradefs grid grid2d grind halfangles head_angle head_both head_length head_type height hypergeometric_representation %iargs ibase icc1 icc2 icounter idummyx ieqnprint ifb ifc1 ifc2 ifg ifgi ifr iframe_bracket_form ifri igeowedge_flag ikt1 ikt2 imaginary inchar increasing infeval infinity inflag infolists inm inmc1 inmc2 intanalysis integer integervalued integrate_use_rootsof integration_constant integration_constant_counter interpolate_color intfaclim ip_grid ip_grid_in irrational isolate_wrt_times iterations itr julia_parameter %k1 %k2 keepfloat key key_pos kinvariant kt label label_alignment label_orientation labels lassociative lbfgs_ncorrections lbfgs_nfeval_max leftjust legend letrat let_rule_packages lfg lg lhospitallim limsubst linear linear_solver linechar linel|10 linenum line_type linewidth line_width linsolve_params linsolvewarn lispdisp listarith listconstvars listdummyvars lmxchar load_pathname loadprint logabs logarc logcb logconcoeffp logexpand lognegint logsimp logx logx_secondary logy logy_secondary logz lriem m1pbranch macroexpansion macros mainvar manual_demo maperror mapprint matrix_element_add matrix_element_mult matrix_element_transpose maxapplydepth maxapplyheight maxima_tempdir|10 maxima_userdir|10 maxnegex MAX_ORD maxposex maxpsifracdenom maxpsifracnum maxpsinegint maxpsiposint maxtayorder mesh_lines_color method mod_big_prime mode_check_errorp mode_checkp mode_check_warnp mod_test mod_threshold modular_linear_solver modulus multiplicative multiplicities myoptions nary negdistrib negsumdispflag newline newtonepsilon newtonmaxiter nextlayerfactor niceindicespref nm nmc noeval nolabels nonegative_lp noninteger nonscalar noun noundisp nouns np npi nticks ntrig numer numer_pbranch obase odd oddfun opacity opproperties opsubst optimprefix optionset orientation origin orthopoly_returns_intervals outative outchar packagefile palette partswitch pdf_file pfeformat phiresolution %piargs piece pivot_count_sx pivot_max_sx plot_format plot_options plot_realpart png_file pochhammer_max_index points pointsize point_size points_joined point_type poislim poisson poly_coefficient_ring poly_elimination_order polyfactor poly_grobner_algorithm poly_grobner_debug poly_monomial_order poly_primary_elimination_order poly_return_term_list poly_secondary_elimination_order poly_top_reduction_only posfun position powerdisp pred prederror primep_number_of_tests product_use_gamma program programmode promote_float_to_bigfloat prompt proportional_axes props psexpand ps_file radexpand radius radsubstflag rassociative ratalgdenom ratchristof ratdenomdivide rateinstein ratepsilon ratfac rational ratmx ratprint ratriemann ratsimpexpons ratvarswitch ratweights ratweyl ratwtlvl real realonly redraw refcheck resolution restart resultant ric riem rmxchar %rnum_list rombergabs rombergit rombergmin rombergtol rootsconmode rootsepsilon run_viewer same_xy same_xyz savedef savefactors scalar scalarmatrixp scale scale_lp setcheck setcheckbreak setval show_edge_color show_edges show_edge_type show_edge_width show_id show_label showtime show_vertex_color show_vertex_size show_vertex_type show_vertices show_weight simp simplified_output simplify_products simpproduct simpsum sinnpiflag solvedecomposes solveexplicit solvefactors solvenullwarn solveradcan solvetrigwarn space sparse sphere spring_embedding_depth sqrtdispflag stardisp startphi starttheta stats_numer stringdisp structures style sublis_apply_lambda subnumsimp sumexpand sumsplitfact surface surface_hide svg_file symmetric tab taylordepth taylor_logexpand taylor_order_coefficients taylor_truncate_polynomials tensorkill terminal testsuite_files thetaresolution timer_devalue title tlimswitch tr track transcompile transform transform_xy translate_fast_arrays transparent transrun tr_array_as_ref tr_bound_function_applyp tr_file_tty_messagesp tr_float_can_branch_complex tr_function_call_default trigexpandplus trigexpandtimes triginverses trigsign trivial_solutions tr_numer tr_optimize_max_loop tr_semicompile tr_state_vars tr_warn_bad_function_calls tr_warn_fexpr tr_warn_meval tr_warn_mode tr_warn_undeclared tr_warn_undefined_variable tstep ttyoff tube_extremes ufg ug %unitexpand unit_vectors uric uriem use_fast_arrays user_preamble usersetunits values vect_cross verbose vertex_color vertex_coloring vertex_partition vertex_size vertex_type view warnings weyl width windowname windowtitle wired_surface wireframe xaxis xaxis_color xaxis_secondary xaxis_type xaxis_width xlabel xlabel_secondary xlength xrange xrange_secondary xtics xtics_axis xtics_rotate xtics_rotate_secondary xtics_secondary xtics_secondary_axis xu_grid x_voxel xy_file xyplane xy_scale yaxis yaxis_color yaxis_secondary yaxis_type yaxis_width ylabel ylabel_secondary ylength yrange yrange_secondary ytics ytics_axis ytics_rotate ytics_rotate_secondary ytics_secondary ytics_secondary_axis yv_grid y_voxel yx_ratio zaxis zaxis_color zaxis_type zaxis_width zeroa zerob zerobern zeta%pi zlabel zlabel_rotate zlength zmin zn_primroot_limit zn_primroot_pretest";
    var SYMBOLS = "_ __ %|0 %%|0";
    return {
        lexemes: "[A-Za-z_%][0-9A-Za-z_%]*",
        keywords: {
            keyword: KEYWORDS,
            literal: LITERALS,
            built_in: BUILTIN_FUNCTIONS,
            symbol: SYMBOLS
        },
        contains: [
            {
                className: "comment",
                begin: "/\\*",
                end: "\\*/",
                contains: [
                    "self"
                ]
            },
            hljs.QUOTE_STRING_MODE,
            {
                className: "number",
                relevance: 0,
                variants: [
                    {
                        // float number w/ exponent
                        // hmm, I wonder if we ought to include other exponent markers?
                        begin: "\\b(\\d+|\\d+\\.|\\.\\d+|\\d+\\.\\d+)[Ee][-+]?\\d+\\b"
                    },
                    {
                        // bigfloat number
                        begin: "\\b(\\d+|\\d+\\.|\\.\\d+|\\d+\\.\\d+)[Bb][-+]?\\d+\\b",
                        relevance: 10
                    },
                    {
                        // float number w/out exponent
                        // Doesn't seem to recognize floats which start with '.'
                        begin: "\\b(\\.\\d+|\\d+\\.\\d+)\\b"
                    },
                    {
                        // integer in base up to 36
                        // Doesn't seem to recognize integers which end with '.'
                        begin: "\\b(\\d+|0[0-9A-Za-z]+)\\.?\\b"
                    }
                ]
            }
        ],
        illegal: /@/
    };
};

});

parcelRegister("z4A3a", function(module, exports) {
module.exports = function(hljs) {
    return {
        keywords: "int float string vector matrix if else switch case default while do for in break continue global proc return about abs addAttr addAttributeEditorNodeHelp addDynamic addNewShelfTab addPP addPanelCategory addPrefixToName advanceToNextDrivenKey affectedNet affects aimConstraint air alias aliasAttr align alignCtx alignCurve alignSurface allViewFit ambientLight angle angleBetween animCone animCurveEditor animDisplay animView annotate appendStringArray applicationName applyAttrPreset applyTake arcLenDimContext arcLengthDimension arclen arrayMapper art3dPaintCtx artAttrCtx artAttrPaintVertexCtx artAttrSkinPaintCtx artAttrTool artBuildPaintMenu artFluidAttrCtx artPuttyCtx artSelectCtx artSetPaintCtx artUserPaintCtx assignCommand assignInputDevice assignViewportFactories attachCurve attachDeviceAttr attachSurface attrColorSliderGrp attrCompatibility attrControlGrp attrEnumOptionMenu attrEnumOptionMenuGrp attrFieldGrp attrFieldSliderGrp attrNavigationControlGrp attrPresetEditWin attributeExists attributeInfo attributeMenu attributeQuery autoKeyframe autoPlace bakeClip bakeFluidShading bakePartialHistory bakeResults bakeSimulation basename basenameEx batchRender bessel bevel bevelPlus binMembership bindSkin blend2 blendShape blendShapeEditor blendShapePanel blendTwoAttr blindDataType boneLattice boundary boxDollyCtx boxZoomCtx bufferCurve buildBookmarkMenu buildKeyframeMenu button buttonManip CBG cacheFile cacheFileCombine cacheFileMerge cacheFileTrack camera cameraView canCreateManip canvas capitalizeString catch catchQuiet ceil changeSubdivComponentDisplayLevel changeSubdivRegion channelBox character characterMap characterOutlineEditor characterize chdir checkBox checkBoxGrp checkDefaultRenderGlobals choice circle circularFillet clamp clear clearCache clip clipEditor clipEditorCurrentTimeCtx clipSchedule clipSchedulerOutliner clipTrimBefore closeCurve closeSurface cluster cmdFileOutput cmdScrollFieldExecuter cmdScrollFieldReporter cmdShell coarsenSubdivSelectionList collision color colorAtPoint colorEditor colorIndex colorIndexSliderGrp colorSliderButtonGrp colorSliderGrp columnLayout commandEcho commandLine commandPort compactHairSystem componentEditor compositingInterop computePolysetVolume condition cone confirmDialog connectAttr connectControl connectDynamic connectJoint connectionInfo constrain constrainValue constructionHistory container containsMultibyte contextInfo control convertFromOldLayers convertIffToPsd convertLightmap convertSolidTx convertTessellation convertUnit copyArray copyFlexor copyKey copySkinWeights cos cpButton cpCache cpClothSet cpCollision cpConstraint cpConvClothToMesh cpForces cpGetSolverAttr cpPanel cpProperty cpRigidCollisionFilter cpSeam cpSetEdit cpSetSolverAttr cpSolver cpSolverTypes cpTool cpUpdateClothUVs createDisplayLayer createDrawCtx createEditor createLayeredPsdFile createMotionField createNewShelf createNode createRenderLayer createSubdivRegion cross crossProduct ctxAbort ctxCompletion ctxEditMode ctxTraverse currentCtx currentTime currentTimeCtx currentUnit curve curveAddPtCtx curveCVCtx curveEPCtx curveEditorCtx curveIntersect curveMoveEPCtx curveOnSurface curveSketchCtx cutKey cycleCheck cylinder dagPose date defaultLightListCheckBox defaultNavigation defineDataServer defineVirtualDevice deformer deg_to_rad delete deleteAttr deleteShadingGroupsAndMaterials deleteShelfTab deleteUI deleteUnusedBrushes delrandstr detachCurve detachDeviceAttr detachSurface deviceEditor devicePanel dgInfo dgdirty dgeval dgtimer dimWhen directKeyCtx directionalLight dirmap dirname disable disconnectAttr disconnectJoint diskCache displacementToPoly displayAffected displayColor displayCull displayLevelOfDetail displayPref displayRGBColor displaySmoothness displayStats displayString displaySurface distanceDimContext distanceDimension doBlur dolly dollyCtx dopeSheetEditor dot dotProduct doubleProfileBirailSurface drag dragAttrContext draggerContext dropoffLocator duplicate duplicateCurve duplicateSurface dynCache dynControl dynExport dynExpression dynGlobals dynPaintEditor dynParticleCtx dynPref dynRelEdPanel dynRelEditor dynamicLoad editAttrLimits editDisplayLayerGlobals editDisplayLayerMembers editRenderLayerAdjustment editRenderLayerGlobals editRenderLayerMembers editor editorTemplate effector emit emitter enableDevice encodeString endString endsWith env equivalent equivalentTol erf error eval evalDeferred evalEcho event exactWorldBoundingBox exclusiveLightCheckBox exec executeForEachObject exists exp expression expressionEditorListen extendCurve extendSurface extrude fcheck fclose feof fflush fgetline fgetword file fileBrowserDialog fileDialog fileExtension fileInfo filetest filletCurve filter filterCurve filterExpand filterStudioImport findAllIntersections findAnimCurves findKeyframe findMenuItem findRelatedSkinCluster finder firstParentOf fitBspline flexor floatEq floatField floatFieldGrp floatScrollBar floatSlider floatSlider2 floatSliderButtonGrp floatSliderGrp floor flow fluidCacheInfo fluidEmitter fluidVoxelInfo flushUndo fmod fontDialog fopen formLayout format fprint frameLayout fread freeFormFillet frewind fromNativePath fwrite gamma gauss geometryConstraint getApplicationVersionAsFloat getAttr getClassification getDefaultBrush getFileList getFluidAttr getInputDeviceRange getMayaPanelTypes getModifiers getPanel getParticleAttr getPluginResource getenv getpid glRender glRenderEditor globalStitch gmatch goal gotoBindPose grabColor gradientControl gradientControlNoAttr graphDollyCtx graphSelectContext graphTrackCtx gravity grid gridLayout group groupObjectsByName HfAddAttractorToAS HfAssignAS HfBuildEqualMap HfBuildFurFiles HfBuildFurImages HfCancelAFR HfConnectASToHF HfCreateAttractor HfDeleteAS HfEditAS HfPerformCreateAS HfRemoveAttractorFromAS HfSelectAttached HfSelectAttractors HfUnAssignAS hardenPointCurve hardware hardwareRenderPanel headsUpDisplay headsUpMessage help helpLine hermite hide hilite hitTest hotBox hotkey hotkeyCheck hsv_to_rgb hudButton hudSlider hudSliderButton hwReflectionMap hwRender hwRenderLoad hyperGraph hyperPanel hyperShade hypot iconTextButton iconTextCheckBox iconTextRadioButton iconTextRadioCollection iconTextScrollList iconTextStaticLabel ikHandle ikHandleCtx ikHandleDisplayScale ikSolver ikSplineHandleCtx ikSystem ikSystemInfo ikfkDisplayMethod illustratorCurves image imfPlugins inheritTransform insertJoint insertJointCtx insertKeyCtx insertKnotCurve insertKnotSurface instance instanceable instancer intField intFieldGrp intScrollBar intSlider intSliderGrp interToUI internalVar intersect iprEngine isAnimCurve isConnected isDirty isParentOf isSameObject isTrue isValidObjectName isValidString isValidUiName isolateSelect itemFilter itemFilterAttr itemFilterRender itemFilterType joint jointCluster jointCtx jointDisplayScale jointLattice keyTangent keyframe keyframeOutliner keyframeRegionCurrentTimeCtx keyframeRegionDirectKeyCtx keyframeRegionDollyCtx keyframeRegionInsertKeyCtx keyframeRegionMoveKeyCtx keyframeRegionScaleKeyCtx keyframeRegionSelectKeyCtx keyframeRegionSetKeyCtx keyframeRegionTrackCtx keyframeStats lassoContext lattice latticeDeformKeyCtx launch launchImageEditor layerButton layeredShaderPort layeredTexturePort layout layoutDialog lightList lightListEditor lightListPanel lightlink lineIntersection linearPrecision linstep listAnimatable listAttr listCameras listConnections listDeviceAttachments listHistory listInputDeviceAxes listInputDeviceButtons listInputDevices listMenuAnnotation listNodeTypes listPanelCategories listRelatives listSets listTransforms listUnselected listerEditor loadFluid loadNewShelf loadPlugin loadPluginLanguageResources loadPrefObjects localizedPanelLabel lockNode loft log longNameOf lookThru ls lsThroughFilter lsType lsUI Mayatomr mag makeIdentity makeLive makePaintable makeRoll makeSingleSurface makeTubeOn makebot manipMoveContext manipMoveLimitsCtx manipOptions manipRotateContext manipRotateLimitsCtx manipScaleContext manipScaleLimitsCtx marker match max memory menu menuBarLayout menuEditor menuItem menuItemToShelf menuSet menuSetPref messageLine min minimizeApp mirrorJoint modelCurrentTimeCtx modelEditor modelPanel mouse movIn movOut move moveIKtoFK moveKeyCtx moveVertexAlongDirection multiProfileBirailSurface mute nParticle nameCommand nameField namespace namespaceInfo newPanelItems newton nodeCast nodeIconButton nodeOutliner nodePreset nodeType noise nonLinear normalConstraint normalize nurbsBoolean nurbsCopyUVSet nurbsCube nurbsEditUV nurbsPlane nurbsSelect nurbsSquare nurbsToPoly nurbsToPolygonsPref nurbsToSubdiv nurbsToSubdivPref nurbsUVSet nurbsViewDirectionVector objExists objectCenter objectLayer objectType objectTypeUI obsoleteProc oceanNurbsPreviewPlane offsetCurve offsetCurveOnSurface offsetSurface openGLExtension openMayaPref optionMenu optionMenuGrp optionVar orbit orbitCtx orientConstraint outlinerEditor outlinerPanel overrideModifier paintEffectsDisplay pairBlend palettePort paneLayout panel panelConfiguration panelHistory paramDimContext paramDimension paramLocator parent parentConstraint particle particleExists particleInstancer particleRenderInfo partition pasteKey pathAnimation pause pclose percent performanceOptions pfxstrokes pickWalk picture pixelMove planarSrf plane play playbackOptions playblast plugAttr plugNode pluginInfo pluginResourceUtil pointConstraint pointCurveConstraint pointLight pointMatrixMult pointOnCurve pointOnSurface pointPosition poleVectorConstraint polyAppend polyAppendFacetCtx polyAppendVertex polyAutoProjection polyAverageNormal polyAverageVertex polyBevel polyBlendColor polyBlindData polyBoolOp polyBridgeEdge polyCacheMonitor polyCheck polyChipOff polyClipboard polyCloseBorder polyCollapseEdge polyCollapseFacet polyColorBlindData polyColorDel polyColorPerVertex polyColorSet polyCompare polyCone polyCopyUV polyCrease polyCreaseCtx polyCreateFacet polyCreateFacetCtx polyCube polyCut polyCutCtx polyCylinder polyCylindricalProjection polyDelEdge polyDelFacet polyDelVertex polyDuplicateAndConnect polyDuplicateEdge polyEditUV polyEditUVShell polyEvaluate polyExtrudeEdge polyExtrudeFacet polyExtrudeVertex polyFlipEdge polyFlipUV polyForceUV polyGeoSampler polyHelix polyInfo polyInstallAction polyLayoutUV polyListComponentConversion polyMapCut polyMapDel polyMapSew polyMapSewMove polyMergeEdge polyMergeEdgeCtx polyMergeFacet polyMergeFacetCtx polyMergeUV polyMergeVertex polyMirrorFace polyMoveEdge polyMoveFacet polyMoveFacetUV polyMoveUV polyMoveVertex polyNormal polyNormalPerVertex polyNormalizeUV polyOptUvs polyOptions polyOutput polyPipe polyPlanarProjection polyPlane polyPlatonicSolid polyPoke polyPrimitive polyPrism polyProjection polyPyramid polyQuad polyQueryBlindData polyReduce polySelect polySelectConstraint polySelectConstraintMonitor polySelectCtx polySelectEditCtx polySeparate polySetToFaceNormal polySewEdge polyShortestPathCtx polySmooth polySoftEdge polySphere polySphericalProjection polySplit polySplitCtx polySplitEdge polySplitRing polySplitVertex polyStraightenUVBorder polySubdivideEdge polySubdivideFacet polyToSubdiv polyTorus polyTransfer polyTriangulate polyUVSet polyUnite polyWedgeFace popen popupMenu pose pow preloadRefEd print progressBar progressWindow projFileViewer projectCurve projectTangent projectionContext projectionManip promptDialog propModCtx propMove psdChannelOutliner psdEditTextureFile psdExport psdTextureFile putenv pwd python querySubdiv quit rad_to_deg radial radioButton radioButtonGrp radioCollection radioMenuItemCollection rampColorPort rand randomizeFollicles randstate rangeControl readTake rebuildCurve rebuildSurface recordAttr recordDevice redo reference referenceEdit referenceQuery refineSubdivSelectionList refresh refreshAE registerPluginResource rehash reloadImage removeJoint removeMultiInstance removePanelCategory rename renameAttr renameSelectionList renameUI render renderGlobalsNode renderInfo renderLayerButton renderLayerParent renderLayerPostProcess renderLayerUnparent renderManip renderPartition renderQualityNode renderSettings renderThumbnailUpdate renderWindowEditor renderWindowSelectContext renderer reorder reorderDeformers requires reroot resampleFluid resetAE resetPfxToPolyCamera resetTool resolutionNode retarget reverseCurve reverseSurface revolve rgb_to_hsv rigidBody rigidSolver roll rollCtx rootOf rot rotate rotationInterpolation roundConstantRadius rowColumnLayout rowLayout runTimeCommand runup sampleImage saveAllShelves saveAttrPreset saveFluid saveImage saveInitialState saveMenu savePrefObjects savePrefs saveShelf saveToolSettings scale scaleBrushBrightness scaleComponents scaleConstraint scaleKey scaleKeyCtx sceneEditor sceneUIReplacement scmh scriptCtx scriptEditorInfo scriptJob scriptNode scriptTable scriptToShelf scriptedPanel scriptedPanelType scrollField scrollLayout sculpt searchPathArray seed selLoadSettings select selectContext selectCurveCV selectKey selectKeyCtx selectKeyframeRegionCtx selectMode selectPref selectPriority selectType selectedNodes selectionConnection separator setAttr setAttrEnumResource setAttrMapping setAttrNiceNameResource setConstraintRestPosition setDefaultShadingGroup setDrivenKeyframe setDynamic setEditCtx setEditor setFluidAttr setFocus setInfinity setInputDeviceMapping setKeyCtx setKeyPath setKeyframe setKeyframeBlendshapeTargetWts setMenuMode setNodeNiceNameResource setNodeTypeFlag setParent setParticleAttr setPfxToPolyCamera setPluginResource setProject setStampDensity setStartupMessage setState setToolTo setUITemplate setXformManip sets shadingConnection shadingGeometryRelCtx shadingLightRelCtx shadingNetworkCompare shadingNode shapeCompare shelfButton shelfLayout shelfTabLayout shellField shortNameOf showHelp showHidden showManipCtx showSelectionInTitle showShadingGroupAttrEditor showWindow sign simplify sin singleProfileBirailSurface size sizeBytes skinCluster skinPercent smoothCurve smoothTangentSurface smoothstep snap2to2 snapKey snapMode snapTogetherCtx snapshot soft softMod softModCtx sort sound soundControl source spaceLocator sphere sphrand spotLight spotLightPreviewPort spreadSheetEditor spring sqrt squareSurface srtContext stackTrace startString startsWith stitchAndExplodeShell stitchSurface stitchSurfacePoints strcmp stringArrayCatenate stringArrayContains stringArrayCount stringArrayInsertAtIndex stringArrayIntersector stringArrayRemove stringArrayRemoveAtIndex stringArrayRemoveDuplicates stringArrayRemoveExact stringArrayToString stringToStringArray strip stripPrefixFromName stroke subdAutoProjection subdCleanTopology subdCollapse subdDuplicateAndConnect subdEditUV subdListComponentConversion subdMapCut subdMapSewMove subdMatchTopology subdMirror subdToBlind subdToPoly subdTransferUVsToCache subdiv subdivCrease subdivDisplaySmoothness substitute substituteAllString substituteGeometry substring surface surfaceSampler surfaceShaderList swatchDisplayPort switchTable symbolButton symbolCheckBox sysFile system tabLayout tan tangentConstraint texLatticeDeformContext texManipContext texMoveContext texMoveUVShellContext texRotateContext texScaleContext texSelectContext texSelectShortestPathCtx texSmudgeUVContext texWinToolCtx text textCurves textField textFieldButtonGrp textFieldGrp textManip textScrollList textToShelf textureDisplacePlane textureHairColor texturePlacementContext textureWindow threadCount threePointArcCtx timeControl timePort timerX toNativePath toggle toggleAxis toggleWindowVisibility tokenize tokenizeList tolerance tolower toolButton toolCollection toolDropped toolHasOptions toolPropertyWindow torus toupper trace track trackCtx transferAttributes transformCompare transformLimits translator trim trunc truncateFluidCache truncateHairCache tumble tumbleCtx turbulence twoPointArcCtx uiRes uiTemplate unassignInputDevice undo undoInfo ungroup uniform unit unloadPlugin untangleUV untitledFileName untrim upAxis updateAE userCtx uvLink uvSnapshot validateShelfName vectorize view2dToolCtx viewCamera viewClipPlane viewFit viewHeadOn viewLookAt viewManip viewPlace viewSet visor volumeAxis vortex waitCursor warning webBrowser webBrowserPrefs whatIs window windowPref wire wireContext workspace wrinkle wrinkleContext writeTake xbmLangPathList xform",
        illegal: "</",
        contains: [
            hljs.C_NUMBER_MODE,
            hljs.APOS_STRING_MODE,
            hljs.QUOTE_STRING_MODE,
            {
                className: "string",
                begin: "`",
                end: "`",
                contains: [
                    hljs.BACKSLASH_ESCAPE
                ]
            },
            {
                begin: "[\\$\\%\\@](\\^\\w\\b|#\\w+|[^\\s\\w{]|{\\w+}|\\w+)"
            },
            hljs.C_LINE_COMMENT_MODE,
            hljs.C_BLOCK_COMMENT_MODE
        ]
    };
};

});

parcelRegister("jU8Uv", function(module, exports) {
module.exports = function(hljs) {
    var KEYWORDS = {
        keyword: "module use_module import_module include_module end_module initialise mutable initialize finalize finalise interface implementation pred mode func type inst solver any_pred any_func is semidet det nondet multi erroneous failure cc_nondet cc_multi typeclass instance where pragma promise external trace atomic or_else require_complete_switch require_det require_semidet require_multi require_nondet require_cc_multi require_cc_nondet require_erroneous require_failure",
        meta: // pragma
        "inline no_inline type_spec source_file fact_table obsolete memo loop_check minimal_model terminates does_not_terminate check_termination promise_equivalent_clauses foreign_proc foreign_decl foreign_code foreign_type foreign_import_module foreign_export_enum foreign_export foreign_enum may_call_mercury will_not_call_mercury thread_safe not_thread_safe maybe_thread_safe promise_pure promise_semipure tabled_for_io local untrailed trailed attach_to_io_state can_pass_as_mercury_type stable will_not_throw_exception may_modify_trail will_not_modify_trail may_duplicate may_not_duplicate affects_liveness does_not_affect_liveness doesnt_affect_liveness no_sharing unknown_sharing sharing",
        built_in: "some all not if then else true fail false try catch catch_any semidet_true semidet_false semidet_fail impure_true impure semipure"
    };
    var COMMENT = hljs.COMMENT("%", "$");
    var NUMCODE = {
        className: "number",
        begin: "0'.\\|0[box][0-9a-fA-F]*"
    };
    var ATOM = hljs.inherit(hljs.APOS_STRING_MODE, {
        relevance: 0
    });
    var STRING = hljs.inherit(hljs.QUOTE_STRING_MODE, {
        relevance: 0
    });
    var STRING_FMT = {
        className: "subst",
        begin: "\\\\[abfnrtv]\\|\\\\x[0-9a-fA-F]*\\\\\\|%[-+# *.0-9]*[dioxXucsfeEgGp]",
        relevance: 0
    };
    STRING.contains = STRING.contains.slice() // we need our own copy of contains
    ;
    STRING.contains.push(STRING_FMT);
    var IMPLICATION = {
        className: "built_in",
        variants: [
            {
                begin: "<=>"
            },
            {
                begin: "<=",
                relevance: 0
            },
            {
                begin: "=>",
                relevance: 0
            },
            {
                begin: "/\\\\"
            },
            {
                begin: "\\\\/"
            }
        ]
    };
    var HEAD_BODY_CONJUNCTION = {
        className: "built_in",
        variants: [
            {
                begin: ":-\\|-->"
            },
            {
                begin: "=",
                relevance: 0
            }
        ]
    };
    return {
        aliases: [
            "m",
            "moo"
        ],
        keywords: KEYWORDS,
        contains: [
            IMPLICATION,
            HEAD_BODY_CONJUNCTION,
            COMMENT,
            hljs.C_BLOCK_COMMENT_MODE,
            NUMCODE,
            hljs.NUMBER_MODE,
            ATOM,
            STRING,
            {
                begin: /:-/
            },
            {
                begin: /\.$/
            } // relevance booster
        ]
    };
};

});

parcelRegister("bwGfp", function(module, exports) {
module.exports = function(hljs) {
    //local labels: %?[FB]?[AT]?\d{1,2}\w+
    return {
        case_insensitive: true,
        aliases: [
            "mips"
        ],
        lexemes: "\\.?" + hljs.IDENT_RE,
        keywords: {
            meta: //GNU preprocs
            ".2byte .4byte .align .ascii .asciz .balign .byte .code .data .else .end .endif .endm .endr .equ .err .exitm .extern .global .hword .if .ifdef .ifndef .include .irp .long .macro .rept .req .section .set .skip .space .text .word .ltorg ",
            built_in: "$0 $1 $2 $3 $4 $5 $6 $7 $8 $9 $10 $11 $12 $13 $14 $15 $16 $17 $18 $19 $20 $21 $22 $23 $24 $25 $26 $27 $28 $29 $30 $31 zero at v0 v1 a0 a1 a2 a3 a4 a5 a6 a7 t0 t1 t2 t3 t4 t5 t6 t7 t8 t9 s0 s1 s2 s3 s4 s5 s6 s7 s8 k0 k1 gp sp fp ra $f0 $f1 $f2 $f2 $f4 $f5 $f6 $f7 $f8 $f9 $f10 $f11 $f12 $f13 $f14 $f15 $f16 $f17 $f18 $f19 $f20 $f21 $f22 $f23 $f24 $f25 $f26 $f27 $f28 $f29 $f30 $f31 Context Random EntryLo0 EntryLo1 Context PageMask Wired EntryHi HWREna BadVAddr Count Compare SR IntCtl SRSCtl SRSMap Cause EPC PRId EBase Config Config1 Config2 Config3 LLAddr Debug DEPC DESAVE CacheErr ECC ErrorEPC TagLo DataLo TagHi DataHi WatchLo WatchHi PerfCtl PerfCnt " // Coprocessor 0 registers
        },
        contains: [
            {
                className: "keyword",
                begin: "\\b(addi?u?|andi?|b(al)?|beql?|bgez(al)?l?|bgtzl?|blezl?|bltz(al)?l?|bnel?|cl[oz]|divu?|ext|ins|j(al)?|jalr(.hb)?|jr(.hb)?|lbu?|lhu?|ll|lui|lw[lr]?|maddu?|mfhi|mflo|movn|movz|move|msubu?|mthi|mtlo|mul|multu?|nop|nor|ori?|rotrv?|sb|sc|se[bh]|sh|sllv?|slti?u?|srav?|srlv?|subu?|sw[lr]?|xori?|wsbh|abs.[sd]|add.[sd]|alnv.ps|bc1[ft]l?|c.(s?f|un|u?eq|[ou]lt|[ou]le|ngle?|seq|l[et]|ng[et]).[sd]|(ceil|floor|round|trunc).[lw].[sd]|cfc1|cvt.d.[lsw]|cvt.l.[dsw]|cvt.ps.s|cvt.s.[dlw]|cvt.s.p[lu]|cvt.w.[dls]|div.[ds]|ldx?c1|luxc1|lwx?c1|madd.[sd]|mfc1|mov[fntz]?.[ds]|msub.[sd]|mth?c1|mul.[ds]|neg.[ds]|nmadd.[ds]|nmsub.[ds]|p[lu][lu].ps|recip.fmt|r?sqrt.[ds]|sdx?c1|sub.[ds]|suxc1|swx?c1|break|cache|d?eret|[de]i|ehb|mfc0|mtc0|pause|prefx?|rdhwr|rdpgpr|sdbbp|ssnop|synci?|syscall|teqi?|tgei?u?|tlb(p|r|w[ir])|tlti?u?|tnei?|wait|wrpgpr)",
                end: "\\s"
            },
            // lines ending with ; or # aren't really comments, probably auto-detect fail
            hljs.COMMENT("[;#](?!s*$)", "$"),
            hljs.C_BLOCK_COMMENT_MODE,
            hljs.QUOTE_STRING_MODE,
            {
                className: "string",
                begin: "'",
                end: "[^\\\\]'",
                relevance: 0
            },
            {
                className: "title",
                begin: "\\|",
                end: "\\|",
                illegal: "\\n",
                relevance: 0
            },
            {
                className: "number",
                variants: [
                    {
                        begin: "0x[0-9a-f]+"
                    },
                    {
                        begin: "\\b-?\\d+"
                    } //bare number
                ],
                relevance: 0
            },
            {
                className: "symbol",
                variants: [
                    {
                        begin: "^\\s*[a-z_\\.\\$][a-z0-9_\\.\\$]+:"
                    },
                    {
                        begin: "^\\s*[0-9]+:"
                    },
                    {
                        begin: "[0-9]+[bf]"
                    } // number local label reference (backwards, forwards)
                ],
                relevance: 0
            }
        ],
        illegal: "/"
    };
};

});

parcelRegister("fQkZ1", function(module, exports) {
module.exports = function(hljs) {
    return {
        keywords: "environ vocabularies notations constructors definitions registrations theorems schemes requirements begin end definition registration cluster existence pred func defpred deffunc theorem proof let take assume then thus hence ex for st holds consider reconsider such that and in provided of as from be being by means equals implies iff redefine define now not or attr is mode suppose per cases set thesis contradiction scheme reserve struct correctness compatibility coherence symmetry assymetry reflexivity irreflexivity connectedness uniqueness commutativity idempotence involutiveness projectivity",
        contains: [
            hljs.COMMENT("::", "$")
        ]
    };
};

});

parcelRegister("8MPLA", function(module, exports) {
module.exports = function(hljs) {
    var PERL_KEYWORDS = "getpwent getservent quotemeta msgrcv scalar kill dbmclose undef lc ma syswrite tr send umask sysopen shmwrite vec qx utime local oct semctl localtime readpipe do return format read sprintf dbmopen pop getpgrp not getpwnam rewinddir qqfileno qw endprotoent wait sethostent bless s|0 opendir continue each sleep endgrent shutdown dump chomp connect getsockname die socketpair close flock exists index shmgetsub for endpwent redo lstat msgctl setpgrp abs exit select print ref gethostbyaddr unshift fcntl syscall goto getnetbyaddr join gmtime symlink semget splice x|0 getpeername recv log setsockopt cos last reverse gethostbyname getgrnam study formline endhostent times chop length gethostent getnetent pack getprotoent getservbyname rand mkdir pos chmod y|0 substr endnetent printf next open msgsnd readdir use unlink getsockopt getpriority rindex wantarray hex system getservbyport endservent int chr untie rmdir prototype tell listen fork shmread ucfirst setprotoent else sysseek link getgrgid shmctl waitpid unpack getnetbyname reset chdir grep split require caller lcfirst until warn while values shift telldir getpwuid my getprotobynumber delete and sort uc defined srand accept package seekdir getprotobyname semop our rename seek if q|0 chroot sysread setpwent no crypt getc chown sqrt write setnetent setpriority foreach tie sin msgget map stat getlogin unless elsif truncate exec keys glob tied closedirioctl socket readlink eval xor readline binmode setservent eof ord bind alarm pipe atan2 getgrent exp time push setgrent gt lt or ne m|0 break given say state when";
    var SUBST = {
        className: "subst",
        begin: "[$@]\\{",
        end: "\\}",
        keywords: PERL_KEYWORDS
    };
    var METHOD = {
        begin: "->{",
        end: "}"
    };
    var VAR = {
        variants: [
            {
                begin: /\$\d/
            },
            {
                begin: /[\$%@](\^\w\b|#\w+(::\w+)*|{\w+}|\w+(::\w*)*)/
            },
            {
                begin: /[\$%@][^\s\w{]/,
                relevance: 0
            }
        ]
    };
    var STRING_CONTAINS = [
        hljs.BACKSLASH_ESCAPE,
        SUBST,
        VAR
    ];
    var PERL_DEFAULT_CONTAINS = [
        VAR,
        hljs.HASH_COMMENT_MODE,
        hljs.COMMENT("^\\=\\w", "\\=cut", {
            endsWithParent: true
        }),
        METHOD,
        {
            className: "string",
            contains: STRING_CONTAINS,
            variants: [
                {
                    begin: "q[qwxr]?\\s*\\(",
                    end: "\\)",
                    relevance: 5
                },
                {
                    begin: "q[qwxr]?\\s*\\[",
                    end: "\\]",
                    relevance: 5
                },
                {
                    begin: "q[qwxr]?\\s*\\{",
                    end: "\\}",
                    relevance: 5
                },
                {
                    begin: "q[qwxr]?\\s*\\|",
                    end: "\\|",
                    relevance: 5
                },
                {
                    begin: "q[qwxr]?\\s*\\<",
                    end: "\\>",
                    relevance: 5
                },
                {
                    begin: "qw\\s+q",
                    end: "q",
                    relevance: 5
                },
                {
                    begin: "'",
                    end: "'",
                    contains: [
                        hljs.BACKSLASH_ESCAPE
                    ]
                },
                {
                    begin: '"',
                    end: '"'
                },
                {
                    begin: "`",
                    end: "`",
                    contains: [
                        hljs.BACKSLASH_ESCAPE
                    ]
                },
                {
                    begin: "{\\w+}",
                    contains: [],
                    relevance: 0
                },
                {
                    begin: "-?\\w+\\s*\\=\\>",
                    contains: [],
                    relevance: 0
                }
            ]
        },
        {
            className: "number",
            begin: "(\\b0[0-7_]+)|(\\b0x[0-9a-fA-F_]+)|(\\b[1-9][0-9_]*(\\.[0-9_]+)?)|[0_]\\b",
            relevance: 0
        },
        {
            begin: "(\\/\\/|" + hljs.RE_STARTERS_RE + "|\\b(split|return|print|reverse|grep)\\b)\\s*",
            keywords: "split return print reverse grep",
            relevance: 0,
            contains: [
                hljs.HASH_COMMENT_MODE,
                {
                    className: "regexp",
                    begin: "(s|tr|y)/(\\\\.|[^/])*/(\\\\.|[^/])*/[a-z]*",
                    relevance: 10
                },
                {
                    className: "regexp",
                    begin: "(m|qr)?/",
                    end: "/[a-z]*",
                    contains: [
                        hljs.BACKSLASH_ESCAPE
                    ],
                    relevance: 0 // allows empty "//" which is a common comment delimiter in other languages
                }
            ]
        },
        {
            className: "function",
            beginKeywords: "sub",
            end: "(\\s*\\(.*?\\))?[;{]",
            excludeEnd: true,
            relevance: 5,
            contains: [
                hljs.TITLE_MODE
            ]
        },
        {
            begin: "-\\w\\b",
            relevance: 0
        },
        {
            begin: "^__DATA__$",
            end: "^__END__$",
            subLanguage: "mojolicious",
            contains: [
                {
                    begin: "^@@.*",
                    end: "$",
                    className: "comment"
                }
            ]
        }
    ];
    SUBST.contains = PERL_DEFAULT_CONTAINS;
    METHOD.contains = PERL_DEFAULT_CONTAINS;
    return {
        aliases: [
            "pl",
            "pm"
        ],
        lexemes: /[\w\.]+/,
        keywords: PERL_KEYWORDS,
        contains: PERL_DEFAULT_CONTAINS
    };
};

});

parcelRegister("fkIyq", function(module, exports) {
module.exports = function(hljs) {
    return {
        subLanguage: "xml",
        contains: [
            {
                className: "meta",
                begin: "^__(END|DATA)__$"
            },
            // mojolicious line
            {
                begin: "^\\s*%{1,2}={0,2}",
                end: "$",
                subLanguage: "perl"
            },
            // mojolicious block
            {
                begin: "<%{1,2}={0,2}",
                end: "={0,1}%>",
                subLanguage: "perl",
                excludeBegin: true,
                excludeEnd: true
            }
        ]
    };
};

});

parcelRegister("adFFh", function(module, exports) {
module.exports = function(hljs) {
    var NUMBER = {
        className: "number",
        relevance: 0,
        variants: [
            {
                begin: "[$][a-fA-F0-9]+"
            },
            hljs.NUMBER_MODE
        ]
    };
    return {
        case_insensitive: true,
        keywords: {
            keyword: "public private property continue exit extern new try catch eachin not abstract final select case default const local global field end if then else elseif endif while wend repeat until forever for to step next return module inline throw import",
            built_in: "DebugLog DebugStop Error Print ACos ACosr ASin ASinr ATan ATan2 ATan2r ATanr Abs Abs Ceil Clamp Clamp Cos Cosr Exp Floor Log Max Max Min Min Pow Sgn Sgn Sin Sinr Sqrt Tan Tanr Seed PI HALFPI TWOPI",
            literal: "true false null and or shl shr mod"
        },
        illegal: /\/\*/,
        contains: [
            hljs.COMMENT("#rem", "#end"),
            hljs.COMMENT("'", "$", {
                relevance: 0
            }),
            {
                className: "function",
                beginKeywords: "function method",
                end: "[(=:]|$",
                illegal: /\n/,
                contains: [
                    hljs.UNDERSCORE_TITLE_MODE
                ]
            },
            {
                className: "class",
                beginKeywords: "class interface",
                end: "$",
                contains: [
                    {
                        beginKeywords: "extends implements"
                    },
                    hljs.UNDERSCORE_TITLE_MODE
                ]
            },
            {
                className: "built_in",
                begin: "\\b(self|super)\\b"
            },
            {
                className: "meta",
                begin: "\\s*#",
                end: "$",
                keywords: {
                    "meta-keyword": "if else elseif endif end then"
                }
            },
            {
                className: "meta",
                begin: "^\\s*strict\\b"
            },
            {
                beginKeywords: "alias",
                end: "=",
                contains: [
                    hljs.UNDERSCORE_TITLE_MODE
                ]
            },
            hljs.QUOTE_STRING_MODE,
            NUMBER
        ]
    };
};

});

parcelRegister("6QlzV", function(module, exports) {
module.exports = function(hljs) {
    var KEYWORDS = {
        keyword: // Moonscript keywords
        "if then not for in while do return else elseif break continue switch and or unless when class extends super local import export from using",
        literal: "true false nil",
        built_in: "_G _VERSION assert collectgarbage dofile error getfenv getmetatable ipairs load loadfile loadstring module next pairs pcall print rawequal rawget rawset require select setfenv setmetatable tonumber tostring type unpack xpcall coroutine debug io math os package string table"
    };
    var JS_IDENT_RE = "[A-Za-z$_][0-9A-Za-z$_]*";
    var SUBST = {
        className: "subst",
        begin: /#\{/,
        end: /}/,
        keywords: KEYWORDS
    };
    var EXPRESSIONS = [
        hljs.inherit(hljs.C_NUMBER_MODE, {
            starts: {
                end: "(\\s*/)?",
                relevance: 0
            }
        }),
        {
            className: "string",
            variants: [
                {
                    begin: /'/,
                    end: /'/,
                    contains: [
                        hljs.BACKSLASH_ESCAPE
                    ]
                },
                {
                    begin: /"/,
                    end: /"/,
                    contains: [
                        hljs.BACKSLASH_ESCAPE,
                        SUBST
                    ]
                }
            ]
        },
        {
            className: "built_in",
            begin: "@__" + hljs.IDENT_RE
        },
        {
            begin: "@" + hljs.IDENT_RE // relevance booster on par with CoffeeScript
        },
        {
            begin: hljs.IDENT_RE + "\\\\" + hljs.IDENT_RE // inst\method
        }
    ];
    SUBST.contains = EXPRESSIONS;
    var TITLE = hljs.inherit(hljs.TITLE_MODE, {
        begin: JS_IDENT_RE
    });
    var PARAMS_RE = "(\\(.*\\))?\\s*\\B[-=]>";
    var PARAMS = {
        className: "params",
        begin: "\\([^\\(]",
        returnBegin: true,
        /* We need another contained nameless mode to not have every nested
    pair of parens to be called "params" */ contains: [
            {
                begin: /\(/,
                end: /\)/,
                keywords: KEYWORDS,
                contains: [
                    "self"
                ].concat(EXPRESSIONS)
            }
        ]
    };
    return {
        aliases: [
            "moon"
        ],
        keywords: KEYWORDS,
        illegal: /\/\*/,
        contains: EXPRESSIONS.concat([
            hljs.COMMENT("--", "$"),
            {
                className: "function",
                begin: "^\\s*" + JS_IDENT_RE + "\\s*=\\s*" + PARAMS_RE,
                end: "[-=]>",
                returnBegin: true,
                contains: [
                    TITLE,
                    PARAMS
                ]
            },
            {
                begin: /[\(,:=]\s*/,
                relevance: 0,
                contains: [
                    {
                        className: "function",
                        begin: PARAMS_RE,
                        end: "[-=]>",
                        returnBegin: true,
                        contains: [
                            PARAMS
                        ]
                    }
                ]
            },
            {
                className: "class",
                beginKeywords: "class",
                end: "$",
                illegal: /[:="\[\]]/,
                contains: [
                    {
                        beginKeywords: "extends",
                        endsWithParent: true,
                        illegal: /[:="\[\]]/,
                        contains: [
                            TITLE
                        ]
                    },
                    TITLE
                ]
            },
            {
                className: "name",
                begin: JS_IDENT_RE + ":",
                end: ":",
                returnBegin: true,
                returnEnd: true,
                relevance: 0
            }
        ])
    };
};

});

parcelRegister("39pDl", function(module, exports) {
module.exports = function(hljs) {
    return {
        case_insensitive: true,
        contains: [
            {
                beginKeywords: "build create index delete drop explain infer|10 insert merge prepare select update upsert|10",
                end: /;/,
                endsWithParent: true,
                keywords: {
                    // Taken from http://developer.couchbase.com/documentation/server/current/n1ql/n1ql-language-reference/reservedwords.html
                    keyword: "all alter analyze and any array as asc begin between binary boolean break bucket build by call case cast cluster collate collection commit connect continue correlate cover create database dataset datastore declare decrement delete derived desc describe distinct do drop each element else end every except exclude execute exists explain fetch first flatten for force from function grant group gsi having if ignore ilike in include increment index infer inline inner insert intersect into is join key keys keyspace known last left let letting like limit lsm map mapping matched materialized merge minus namespace nest not number object offset on option or order outer over parse partition password path pool prepare primary private privilege procedure public raw realm reduce rename return returning revoke right role rollback satisfies schema select self semi set show some start statistics string system then to transaction trigger truncate under union unique unknown unnest unset update upsert use user using validate value valued values via view when where while with within work xor",
                    // Taken from http://developer.couchbase.com/documentation/server/4.5/n1ql/n1ql-language-reference/literals.html
                    literal: "true false null missing|5",
                    // Taken from http://developer.couchbase.com/documentation/server/4.5/n1ql/n1ql-language-reference/functions.html
                    built_in: "array_agg array_append array_concat array_contains array_count array_distinct array_ifnull array_length array_max array_min array_position array_prepend array_put array_range array_remove array_repeat array_replace array_reverse array_sort array_sum avg count max min sum greatest least ifmissing ifmissingornull ifnull missingif nullif ifinf ifnan ifnanorinf naninf neginfif posinfif clock_millis clock_str date_add_millis date_add_str date_diff_millis date_diff_str date_part_millis date_part_str date_trunc_millis date_trunc_str duration_to_str millis str_to_millis millis_to_str millis_to_utc millis_to_zone_name now_millis now_str str_to_duration str_to_utc str_to_zone_name decode_json encode_json encoded_size poly_length base64 base64_encode base64_decode meta uuid abs acos asin atan atan2 ceil cos degrees e exp ln log floor pi power radians random round sign sin sqrt tan trunc object_length object_names object_pairs object_inner_pairs object_values object_inner_values object_add object_put object_remove object_unwrap regexp_contains regexp_like regexp_position regexp_replace contains initcap length lower ltrim position repeat replace rtrim split substr title trim upper isarray isatom isboolean isnumber isobject isstring type toarray toatom toboolean tonumber toobject tostring"
                },
                contains: [
                    {
                        className: "string",
                        begin: "'",
                        end: "'",
                        contains: [
                            hljs.BACKSLASH_ESCAPE
                        ],
                        relevance: 0
                    },
                    {
                        className: "string",
                        begin: '"',
                        end: '"',
                        contains: [
                            hljs.BACKSLASH_ESCAPE
                        ],
                        relevance: 0
                    },
                    {
                        className: "symbol",
                        begin: "`",
                        end: "`",
                        contains: [
                            hljs.BACKSLASH_ESCAPE
                        ],
                        relevance: 2
                    },
                    hljs.C_NUMBER_MODE,
                    hljs.C_BLOCK_COMMENT_MODE
                ]
            },
            hljs.C_BLOCK_COMMENT_MODE
        ]
    };
};

});

parcelRegister("gPoTD", function(module, exports) {
module.exports = function(hljs) {
    var VAR = {
        className: "variable",
        variants: [
            {
                begin: /\$\d+/
            },
            {
                begin: /\$\{/,
                end: /}/
            },
            {
                begin: "[\\$\\@]" + hljs.UNDERSCORE_IDENT_RE
            }
        ]
    };
    var DEFAULT = {
        endsWithParent: true,
        lexemes: "[a-z/_]+",
        keywords: {
            literal: "on off yes no true false none blocked debug info notice warn error crit select break last permanent redirect kqueue rtsig epoll poll /dev/poll"
        },
        relevance: 0,
        illegal: "=>",
        contains: [
            hljs.HASH_COMMENT_MODE,
            {
                className: "string",
                contains: [
                    hljs.BACKSLASH_ESCAPE,
                    VAR
                ],
                variants: [
                    {
                        begin: /"/,
                        end: /"/
                    },
                    {
                        begin: /'/,
                        end: /'/
                    }
                ]
            },
            // this swallows entire URLs to avoid detecting numbers within
            {
                begin: "([a-z]+):/",
                end: "\\s",
                endsWithParent: true,
                excludeEnd: true,
                contains: [
                    VAR
                ]
            },
            {
                className: "regexp",
                contains: [
                    hljs.BACKSLASH_ESCAPE,
                    VAR
                ],
                variants: [
                    {
                        begin: "\\s\\^",
                        end: "\\s|{|;",
                        returnEnd: true
                    },
                    // regexp locations (~, ~*)
                    {
                        begin: "~\\*?\\s+",
                        end: "\\s|{|;",
                        returnEnd: true
                    },
                    // *.example.com
                    {
                        begin: "\\*(\\.[a-z\\-]+)+"
                    },
                    // sub.example.*
                    {
                        begin: "([a-z\\-]+\\.)+\\*"
                    }
                ]
            },
            // IP
            {
                className: "number",
                begin: "\\b\\d{1,3}\\.\\d{1,3}\\.\\d{1,3}\\.\\d{1,3}(:\\d{1,5})?\\b"
            },
            // units
            {
                className: "number",
                begin: "\\b\\d+[kKmMgGdshdwy]*\\b",
                relevance: 0
            },
            VAR
        ]
    };
    return {
        aliases: [
            "nginxconf"
        ],
        contains: [
            hljs.HASH_COMMENT_MODE,
            {
                begin: hljs.UNDERSCORE_IDENT_RE + "\\s+{",
                returnBegin: true,
                end: "{",
                contains: [
                    {
                        className: "section",
                        begin: hljs.UNDERSCORE_IDENT_RE
                    }
                ],
                relevance: 0
            },
            {
                begin: hljs.UNDERSCORE_IDENT_RE + "\\s",
                end: ";|{",
                returnBegin: true,
                contains: [
                    {
                        className: "attribute",
                        begin: hljs.UNDERSCORE_IDENT_RE,
                        starts: DEFAULT
                    }
                ],
                relevance: 0
            }
        ],
        illegal: "[^\\s\\}]"
    };
};

});

parcelRegister("YMF7L", function(module, exports) {
module.exports = function(hljs) {
    return {
        aliases: [
            "nim"
        ],
        keywords: {
            keyword: "addr and as asm bind block break case cast const continue converter discard distinct div do elif else end enum except export finally for from generic if import in include interface is isnot iterator let macro method mixin mod nil not notin object of or out proc ptr raise ref return shl shr static template try tuple type using var when while with without xor yield",
            literal: "shared guarded stdin stdout stderr result true false",
            built_in: "int int8 int16 int32 int64 uint uint8 uint16 uint32 uint64 float float32 float64 bool char string cstring pointer expr stmt void auto any range array openarray varargs seq set clong culong cchar cschar cshort cint csize clonglong cfloat cdouble clongdouble cuchar cushort cuint culonglong cstringarray semistatic"
        },
        contains: [
            {
                className: "meta",
                begin: /{\./,
                end: /\.}/,
                relevance: 10
            },
            {
                className: "string",
                begin: /[a-zA-Z]\w*"/,
                end: /"/,
                contains: [
                    {
                        begin: /""/
                    }
                ]
            },
            {
                className: "string",
                begin: /([a-zA-Z]\w*)?"""/,
                end: /"""/
            },
            hljs.QUOTE_STRING_MODE,
            {
                className: "type",
                begin: /\b[A-Z]\w+\b/,
                relevance: 0
            },
            {
                className: "number",
                relevance: 0,
                variants: [
                    {
                        begin: /\b(0[xX][0-9a-fA-F][_0-9a-fA-F]*)('?[iIuU](8|16|32|64))?/
                    },
                    {
                        begin: /\b(0o[0-7][_0-7]*)('?[iIuUfF](8|16|32|64))?/
                    },
                    {
                        begin: /\b(0(b|B)[01][_01]*)('?[iIuUfF](8|16|32|64))?/
                    },
                    {
                        begin: /\b(\d[_\d]*)('?[iIuUfF](8|16|32|64))?/
                    }
                ]
            },
            hljs.HASH_COMMENT_MODE
        ]
    };
};

});

parcelRegister("1m60g", function(module, exports) {
module.exports = function(hljs) {
    var NIX_KEYWORDS = {
        keyword: "rec with let in inherit assert if else then",
        literal: "true false or and null",
        built_in: "import abort baseNameOf dirOf isNull builtins map removeAttrs throw toString derivation"
    };
    var ANTIQUOTE = {
        className: "subst",
        begin: /\$\{/,
        end: /}/,
        keywords: NIX_KEYWORDS
    };
    var ATTRS = {
        begin: /[a-zA-Z0-9-_]+(\s*=)/,
        returnBegin: true,
        relevance: 0,
        contains: [
            {
                className: "attr",
                begin: /\S+/
            }
        ]
    };
    var STRING = {
        className: "string",
        contains: [
            ANTIQUOTE
        ],
        variants: [
            {
                begin: "''",
                end: "''"
            },
            {
                begin: '"',
                end: '"'
            }
        ]
    };
    var EXPRESSIONS = [
        hljs.NUMBER_MODE,
        hljs.HASH_COMMENT_MODE,
        hljs.C_BLOCK_COMMENT_MODE,
        STRING,
        ATTRS
    ];
    ANTIQUOTE.contains = EXPRESSIONS;
    return {
        aliases: [
            "nixos"
        ],
        keywords: NIX_KEYWORDS,
        contains: EXPRESSIONS
    };
};

});

parcelRegister("dHmDc", function(module, exports) {
module.exports = function(hljs) {
    var CONSTANTS = {
        className: "variable",
        begin: /\$(ADMINTOOLS|APPDATA|CDBURN_AREA|CMDLINE|COMMONFILES32|COMMONFILES64|COMMONFILES|COOKIES|DESKTOP|DOCUMENTS|EXEDIR|EXEFILE|EXEPATH|FAVORITES|FONTS|HISTORY|HWNDPARENT|INSTDIR|INTERNET_CACHE|LANGUAGE|LOCALAPPDATA|MUSIC|NETHOOD|OUTDIR|PICTURES|PLUGINSDIR|PRINTHOOD|PROFILE|PROGRAMFILES32|PROGRAMFILES64|PROGRAMFILES|QUICKLAUNCH|RECENT|RESOURCES_LOCALIZED|RESOURCES|SENDTO|SMPROGRAMS|SMSTARTUP|STARTMENU|SYSDIR|TEMP|TEMPLATES|VIDEOS|WINDIR)/
    };
    var DEFINES = {
        // ${defines}
        className: "variable",
        begin: /\$+{[\w\.:-]+}/
    };
    var VARIABLES = {
        // $variables
        className: "variable",
        begin: /\$+\w+/,
        illegal: /\(\){}/
    };
    var LANGUAGES = {
        // $(language_strings)
        className: "variable",
        begin: /\$+\([\w\^\.:-]+\)/
    };
    var PARAMETERS = {
        // command parameters
        className: "params",
        begin: "(ARCHIVE|FILE_ATTRIBUTE_ARCHIVE|FILE_ATTRIBUTE_NORMAL|FILE_ATTRIBUTE_OFFLINE|FILE_ATTRIBUTE_READONLY|FILE_ATTRIBUTE_SYSTEM|FILE_ATTRIBUTE_TEMPORARY|HKCR|HKCU|HKDD|HKEY_CLASSES_ROOT|HKEY_CURRENT_CONFIG|HKEY_CURRENT_USER|HKEY_DYN_DATA|HKEY_LOCAL_MACHINE|HKEY_PERFORMANCE_DATA|HKEY_USERS|HKLM|HKPD|HKU|IDABORT|IDCANCEL|IDIGNORE|IDNO|IDOK|IDRETRY|IDYES|MB_ABORTRETRYIGNORE|MB_DEFBUTTON1|MB_DEFBUTTON2|MB_DEFBUTTON3|MB_DEFBUTTON4|MB_ICONEXCLAMATION|MB_ICONINFORMATION|MB_ICONQUESTION|MB_ICONSTOP|MB_OK|MB_OKCANCEL|MB_RETRYCANCEL|MB_RIGHT|MB_RTLREADING|MB_SETFOREGROUND|MB_TOPMOST|MB_USERICON|MB_YESNO|NORMAL|OFFLINE|READONLY|SHCTX|SHELL_CONTEXT|SYSTEM|TEMPORARY)"
    };
    var COMPILER = {
        // !compiler_flags
        className: "keyword",
        begin: /\!(addincludedir|addplugindir|appendfile|cd|define|delfile|echo|else|endif|error|execute|finalize|getdllversion|gettlbversion|if|ifdef|ifmacrodef|ifmacrondef|ifndef|include|insertmacro|macro|macroend|makensis|packhdr|searchparse|searchreplace|system|tempfile|undef|verbose|warning)/
    };
    var METACHARS = {
        // $\n, $\r, $\t, $$
        className: "meta",
        begin: /\$(\\[nrt]|\$)/
    };
    var PLUGINS = {
        // plug::ins
        className: "class",
        begin: /\w+\:\:\w+/
    };
    var STRING = {
        className: "string",
        variants: [
            {
                begin: '"',
                end: '"'
            },
            {
                begin: "'",
                end: "'"
            },
            {
                begin: "`",
                end: "`"
            }
        ],
        illegal: /\n/,
        contains: [
            METACHARS,
            CONSTANTS,
            DEFINES,
            VARIABLES,
            LANGUAGES
        ]
    };
    return {
        case_insensitive: false,
        keywords: {
            keyword: "Abort AddBrandingImage AddSize AllowRootDirInstall AllowSkipFiles AutoCloseWindow BGFont BGGradient BrandingText BringToFront Call CallInstDLL Caption ChangeUI CheckBitmap ClearErrors CompletedText ComponentText CopyFiles CRCCheck CreateDirectory CreateFont CreateShortCut Delete DeleteINISec DeleteINIStr DeleteRegKey DeleteRegValue DetailPrint DetailsButtonText DirText DirVar DirVerify EnableWindow EnumRegKey EnumRegValue Exch Exec ExecShell ExecShellWait ExecWait ExpandEnvStrings File FileBufSize FileClose FileErrorText FileOpen FileRead FileReadByte FileReadUTF16LE FileReadWord FileSeek FileWrite FileWriteByte FileWriteUTF16LE FileWriteWord FindClose FindFirst FindNext FindWindow FlushINI FunctionEnd GetCurInstType GetCurrentAddress GetDlgItem GetDLLVersion GetDLLVersionLocal GetErrorLevel GetFileTime GetFileTimeLocal GetFullPathName GetFunctionAddress GetInstDirError GetLabelAddress GetTempFileName Goto HideWindow Icon IfAbort IfErrors IfFileExists IfRebootFlag IfSilent InitPluginsDir InstallButtonText InstallColors InstallDir InstallDirRegKey InstProgressFlags InstType InstTypeGetText InstTypeSetText Int64Cmp Int64CmpU Int64Fmt IntCmp IntCmpU IntFmt IntOp IntPtrCmp IntPtrCmpU IntPtrOp IsWindow LangString LicenseBkColor LicenseData LicenseForceSelection LicenseLangString LicenseText LoadLanguageFile LockWindow LogSet LogText ManifestDPIAware ManifestSupportedOS MessageBox MiscButtonText Name Nop OutFile Page PageCallbacks PageExEnd Pop Push Quit ReadEnvStr ReadINIStr ReadRegDWORD ReadRegStr Reboot RegDLL Rename RequestExecutionLevel ReserveFile Return RMDir SearchPath SectionEnd SectionGetFlags SectionGetInstTypes SectionGetSize SectionGetText SectionGroupEnd SectionIn SectionSetFlags SectionSetInstTypes SectionSetSize SectionSetText SendMessage SetAutoClose SetBrandingImage SetCompress SetCompressor SetCompressorDictSize SetCtlColors SetCurInstType SetDatablockOptimize SetDateSave SetDetailsPrint SetDetailsView SetErrorLevel SetErrors SetFileAttributes SetFont SetOutPath SetOverwrite SetRebootFlag SetRegView SetShellVarContext SetSilent ShowInstDetails ShowUninstDetails ShowWindow SilentInstall SilentUnInstall Sleep SpaceTexts StrCmp StrCmpS StrCpy StrLen SubCaption Unicode UninstallButtonText UninstallCaption UninstallIcon UninstallSubCaption UninstallText UninstPage UnRegDLL Var VIAddVersionKey VIFileVersion VIProductVersion WindowIcon WriteINIStr WriteRegBin WriteRegDWORD WriteRegExpandStr WriteRegMultiStr WriteRegNone WriteRegStr WriteUninstaller XPStyle",
            literal: "admin all auto both bottom bzip2 colored components current custom directory false force hide highest ifdiff ifnewer instfiles lastused leave left license listonly lzma nevershow none normal notset off on open print right show silent silentlog smooth textonly top true try un.components un.custom un.directory un.instfiles un.license uninstConfirm user Win10 Win7 Win8 WinVista zlib"
        },
        contains: [
            hljs.HASH_COMMENT_MODE,
            hljs.C_BLOCK_COMMENT_MODE,
            hljs.COMMENT(";", "$", {
                relevance: 0
            }),
            {
                className: "function",
                beginKeywords: "Function PageEx Section SectionGroup",
                end: "$"
            },
            STRING,
            COMPILER,
            DEFINES,
            VARIABLES,
            LANGUAGES,
            PARAMETERS,
            PLUGINS,
            hljs.NUMBER_MODE
        ]
    };
};

});

parcelRegister("dCB9T", function(module, exports) {
module.exports = function(hljs) {
    var API_CLASS = {
        className: "built_in",
        begin: "\\b(AV|CA|CF|CG|CI|CL|CM|CN|CT|MK|MP|MTK|MTL|NS|SCN|SK|UI|WK|XC)\\w+"
    };
    var OBJC_KEYWORDS = {
        keyword: "int float while char export sizeof typedef const struct for union unsigned long volatile static bool mutable if do return goto void enum else break extern asm case short default double register explicit signed typename this switch continue wchar_t inline readonly assign readwrite self @synchronized id typeof nonatomic super unichar IBOutlet IBAction strong weak copy in out inout bycopy byref oneway __strong __weak __block __autoreleasing @private @protected @public @try @property @end @throw @catch @finally @autoreleasepool @synthesize @dynamic @selector @optional @required @encode @package @import @defs @compatibility_alias __bridge __bridge_transfer __bridge_retained __bridge_retain __covariant __contravariant __kindof _Nonnull _Nullable _Null_unspecified __FUNCTION__ __PRETTY_FUNCTION__ __attribute__ getter setter retain unsafe_unretained nonnull nullable null_unspecified null_resettable class instancetype NS_DESIGNATED_INITIALIZER NS_UNAVAILABLE NS_REQUIRES_SUPER NS_RETURNS_INNER_POINTER NS_INLINE NS_AVAILABLE NS_DEPRECATED NS_ENUM NS_OPTIONS NS_SWIFT_UNAVAILABLE NS_ASSUME_NONNULL_BEGIN NS_ASSUME_NONNULL_END NS_REFINED_FOR_SWIFT NS_SWIFT_NAME NS_SWIFT_NOTHROW NS_DURING NS_HANDLER NS_ENDHANDLER NS_VALUERETURN NS_VOIDRETURN",
        literal: "false true FALSE TRUE nil YES NO NULL",
        built_in: "BOOL dispatch_once_t dispatch_queue_t dispatch_sync dispatch_async dispatch_once"
    };
    var LEXEMES = /[a-zA-Z@][a-zA-Z0-9_]*/;
    var CLASS_KEYWORDS = "@interface @class @protocol @implementation";
    return {
        aliases: [
            "mm",
            "objc",
            "obj-c"
        ],
        keywords: OBJC_KEYWORDS,
        lexemes: LEXEMES,
        illegal: "</",
        contains: [
            API_CLASS,
            hljs.C_LINE_COMMENT_MODE,
            hljs.C_BLOCK_COMMENT_MODE,
            hljs.C_NUMBER_MODE,
            hljs.QUOTE_STRING_MODE,
            hljs.APOS_STRING_MODE,
            {
                className: "string",
                variants: [
                    {
                        begin: '@"',
                        end: '"',
                        illegal: "\\n",
                        contains: [
                            hljs.BACKSLASH_ESCAPE
                        ]
                    }
                ]
            },
            {
                className: "meta",
                begin: /#\s*[a-z]+\b/,
                end: /$/,
                keywords: {
                    "meta-keyword": "if else elif endif define undef warning error line pragma ifdef ifndef include"
                },
                contains: [
                    {
                        begin: /\\\n/,
                        relevance: 0
                    },
                    hljs.inherit(hljs.QUOTE_STRING_MODE, {
                        className: "meta-string"
                    }),
                    {
                        className: "meta-string",
                        begin: /<.*?>/,
                        end: /$/,
                        illegal: "\\n"
                    },
                    hljs.C_LINE_COMMENT_MODE,
                    hljs.C_BLOCK_COMMENT_MODE
                ]
            },
            {
                className: "class",
                begin: "(" + CLASS_KEYWORDS.split(" ").join("|") + ")\\b",
                end: "({|$)",
                excludeEnd: true,
                keywords: CLASS_KEYWORDS,
                lexemes: LEXEMES,
                contains: [
                    hljs.UNDERSCORE_TITLE_MODE
                ]
            },
            {
                begin: "\\." + hljs.UNDERSCORE_IDENT_RE,
                relevance: 0
            }
        ]
    };
};

});

parcelRegister("f6CSv", function(module, exports) {
module.exports = function(hljs) {
    /* missing support for heredoc-like string (OCaml 4.0.2+) */ return {
        aliases: [
            "ml"
        ],
        keywords: {
            keyword: "and as assert asr begin class constraint do done downto else end exception external for fun function functor if in include inherit! inherit initializer land lazy let lor lsl lsr lxor match method!|10 method mod module mutable new object of open! open or private rec sig struct then to try type val! val virtual when while with parser value",
            built_in: /* built-in types */ "array bool bytes char exn|5 float int int32 int64 list lazy_t|5 nativeint|5 string unit in_channel out_channel ref",
            literal: "true false"
        },
        illegal: /\/\/|>>/,
        lexemes: "[a-z_]\\w*!?",
        contains: [
            {
                className: "literal",
                begin: "\\[(\\|\\|)?\\]|\\(\\)",
                relevance: 0
            },
            hljs.COMMENT("\\(\\*", "\\*\\)", {
                contains: [
                    "self"
                ]
            }),
            {
                className: "symbol",
                begin: "'[A-Za-z_](?!')[\\w']*"
            },
            {
                className: "type",
                begin: "`[A-Z][\\w']*"
            },
            {
                className: "type",
                begin: "\\b[A-Z][\\w']*",
                relevance: 0
            },
            {
                begin: "[a-z_]\\w*'[\\w']*",
                relevance: 0
            },
            hljs.inherit(hljs.APOS_STRING_MODE, {
                className: "string",
                relevance: 0
            }),
            hljs.inherit(hljs.QUOTE_STRING_MODE, {
                illegal: null
            }),
            {
                className: "number",
                begin: "\\b(0[xX][a-fA-F0-9_]+[Lln]?|0[oO][0-7_]+[Lln]?|0[bB][01_]+[Lln]?|[0-9][0-9_]*([Lln]|(\\.[0-9_]*)?([eE][-+]?[0-9_]+)?)?)",
                relevance: 0
            },
            {
                begin: /[-=]>/ // relevance booster
            }
        ]
    };
};

});

parcelRegister("1vj8j", function(module, exports) {
module.exports = function(hljs) {
    var SPECIAL_VARS = {
        className: "keyword",
        begin: "\\$(f[asn]|t|vp[rtd]|children)"
    }, LITERALS = {
        className: "literal",
        begin: "false|true|PI|undef"
    }, NUMBERS = {
        className: "number",
        begin: "\\b\\d+(\\.\\d+)?(e-?\\d+)?",
        relevance: 0
    }, STRING = hljs.inherit(hljs.QUOTE_STRING_MODE, {
        illegal: null
    }), PREPRO = {
        className: "meta",
        keywords: {
            "meta-keyword": "include use"
        },
        begin: "include|use <",
        end: ">"
    }, PARAMS = {
        className: "params",
        begin: "\\(",
        end: "\\)",
        contains: [
            "self",
            NUMBERS,
            STRING,
            SPECIAL_VARS,
            LITERALS
        ]
    }, MODIFIERS = {
        begin: "[*!#%]",
        relevance: 0
    }, FUNCTIONS = {
        className: "function",
        beginKeywords: "module function",
        end: "\\=|\\{",
        contains: [
            PARAMS,
            hljs.UNDERSCORE_TITLE_MODE
        ]
    };
    return {
        aliases: [
            "scad"
        ],
        keywords: {
            keyword: "function module include use for intersection_for if else \\%",
            literal: "false true PI undef",
            built_in: "circle square polygon text sphere cube cylinder polyhedron translate rotate scale resize mirror multmatrix color offset hull minkowski union difference intersection abs sign sin cos tan acos asin atan atan2 floor round ceil ln log pow sqrt exp rands min max concat lookup str chr search version version_num norm cross parent_module echo import import_dxf dxf_linear_extrude linear_extrude rotate_extrude surface projection render children dxf_cross dxf_dim let assign"
        },
        contains: [
            hljs.C_LINE_COMMENT_MODE,
            hljs.C_BLOCK_COMMENT_MODE,
            NUMBERS,
            PREPRO,
            STRING,
            SPECIAL_VARS,
            MODIFIERS,
            FUNCTIONS
        ]
    };
};

});

parcelRegister("amStw", function(module, exports) {
module.exports = function(hljs) {
    var OXYGENE_KEYWORDS = "abstract add and array as asc aspect assembly async begin break block by case class concat const copy constructor continue create default delegate desc distinct div do downto dynamic each else empty end ensure enum equals event except exit extension external false final finalize finalizer finally flags for forward from function future global group has if implementation implements implies in index inherited inline interface into invariants is iterator join locked locking loop matching method mod module namespace nested new nil not notify nullable of old on operator or order out override parallel params partial pinned private procedure property protected public queryable raise read readonly record reintroduce remove repeat require result reverse sealed select self sequence set shl shr skip static step soft take then to true try tuple type union unit unsafe until uses using var virtual raises volatile where while with write xor yield await mapped deprecated stdcall cdecl pascal register safecall overload library platform reference packed strict published autoreleasepool selector strong weak unretained";
    var CURLY_COMMENT = hljs.COMMENT("{", "}", {
        relevance: 0
    });
    var PAREN_COMMENT = hljs.COMMENT("\\(\\*", "\\*\\)", {
        relevance: 10
    });
    var STRING = {
        className: "string",
        begin: "'",
        end: "'",
        contains: [
            {
                begin: "''"
            }
        ]
    };
    var CHAR_STRING = {
        className: "string",
        begin: "(#\\d+)+"
    };
    var FUNCTION = {
        className: "function",
        beginKeywords: "function constructor destructor procedure method",
        end: "[:;]",
        keywords: "function constructor|10 destructor|10 procedure|10 method|10",
        contains: [
            hljs.TITLE_MODE,
            {
                className: "params",
                begin: "\\(",
                end: "\\)",
                keywords: OXYGENE_KEYWORDS,
                contains: [
                    STRING,
                    CHAR_STRING
                ]
            },
            CURLY_COMMENT,
            PAREN_COMMENT
        ]
    };
    return {
        case_insensitive: true,
        lexemes: /\.?\w+/,
        keywords: OXYGENE_KEYWORDS,
        illegal: '("|\\$[G-Zg-z]|\\/\\*|</|=>|->)',
        contains: [
            CURLY_COMMENT,
            PAREN_COMMENT,
            hljs.C_LINE_COMMENT_MODE,
            STRING,
            CHAR_STRING,
            hljs.NUMBER_MODE,
            FUNCTION,
            {
                className: "class",
                begin: "=\\bclass\\b",
                end: "end;",
                keywords: OXYGENE_KEYWORDS,
                contains: [
                    STRING,
                    CHAR_STRING,
                    CURLY_COMMENT,
                    PAREN_COMMENT,
                    hljs.C_LINE_COMMENT_MODE,
                    FUNCTION
                ]
            }
        ]
    };
};

});

parcelRegister("caY3R", function(module, exports) {
module.exports = function(hljs) {
    var CURLY_SUBCOMMENT = hljs.COMMENT("{", "}", {
        contains: [
            "self"
        ]
    });
    return {
        subLanguage: "xml",
        relevance: 0,
        contains: [
            hljs.COMMENT("^#", "$"),
            hljs.COMMENT("\\^rem{", "}", {
                relevance: 10,
                contains: [
                    CURLY_SUBCOMMENT
                ]
            }),
            {
                className: "meta",
                begin: "^@(?:BASE|USE|CLASS|OPTIONS)$",
                relevance: 10
            },
            {
                className: "title",
                begin: "@[\\w\\-]+\\[[\\w^;\\-]*\\](?:\\[[\\w^;\\-]*\\])?(?:.*)$"
            },
            {
                className: "variable",
                begin: "\\$\\{?[\\w\\-\\.\\:]+\\}?"
            },
            {
                className: "keyword",
                begin: "\\^[\\w\\-\\.\\:]+"
            },
            {
                className: "number",
                begin: "\\^#[0-9a-fA-F]+"
            },
            hljs.C_NUMBER_MODE
        ]
    };
};

});

parcelRegister("2YmYa", function(module, exports) {
module.exports = function(hljs) {
    var MACRO = {
        className: "variable",
        begin: /\$[\w\d#@][\w\d_]*/
    };
    var TABLE = {
        className: "variable",
        begin: /<(?!\/)/,
        end: />/
    };
    var QUOTE_STRING = {
        className: "string",
        begin: /"/,
        end: /"/
    };
    return {
        aliases: [
            "pf.conf"
        ],
        lexemes: /[a-z0-9_<>-]+/,
        keywords: {
            built_in: /* block match pass are "actions" in pf.conf(5), the rest are
                 * lexically similar top-level commands.
                 */ "block match pass load anchor|5 antispoof|10 set table",
            keyword: "in out log quick on rdomain inet inet6 proto from port os to routeallow-opts divert-packet divert-reply divert-to flags group icmp-typeicmp6-type label once probability recieved-on rtable prio queuetos tag tagged user keep fragment for os dropaf-to|10 binat-to|10 nat-to|10 rdr-to|10 bitmask least-stats random round-robinsource-hash static-portdup-to reply-to route-toparent bandwidth default min max qlimitblock-policy debug fingerprints hostid limit loginterface optimizationreassemble ruleset-optimization basic none profile skip state-defaultsstate-policy timeoutconst counters persistno modulate synproxy state|5 floating if-bound no-sync pflow|10 sloppysource-track global rule max-src-nodes max-src-states max-src-connmax-src-conn-rate overload flushscrub|5 max-mss min-ttl no-df|10 random-id",
            literal: "all any no-route self urpf-failed egress|5 unknown"
        },
        contains: [
            hljs.HASH_COMMENT_MODE,
            hljs.NUMBER_MODE,
            hljs.QUOTE_STRING_MODE,
            MACRO,
            TABLE
        ]
    };
};

});

parcelRegister("5h1Dk", function(module, exports) {
module.exports = function(hljs) {
    var COMMENT_MODE = hljs.COMMENT("--", "$");
    var UNQUOTED_IDENT = "[a-zA-Z_][a-zA-Z_0-9$]*";
    var DOLLAR_STRING = "\\$([a-zA-Z_]?|[a-zA-Z_][a-zA-Z_0-9]*)\\$";
    var LABEL = "<<\\s*" + UNQUOTED_IDENT + "\\s*>>";
    var SQL_KW = // https://www.postgresql.org/docs/11/static/sql-keywords-appendix.html
    // https://www.postgresql.org/docs/11/static/sql-commands.html
    // SQL commands (starting words)
    "ABORT ALTER ANALYZE BEGIN CALL CHECKPOINT|10 CLOSE CLUSTER COMMENT COMMIT COPY CREATE DEALLOCATE DECLARE DELETE DISCARD DO DROP END EXECUTE EXPLAIN FETCH GRANT IMPORT INSERT LISTEN LOAD LOCK MOVE NOTIFY PREPARE REASSIGN|10 REFRESH REINDEX RELEASE RESET REVOKE ROLLBACK SAVEPOINT SECURITY SELECT SET SHOW START TRUNCATE UNLISTEN|10 UPDATE VACUUM|10 VALUES AGGREGATE COLLATION CONVERSION|10 DATABASE DEFAULT PRIVILEGES DOMAIN TRIGGER EXTENSION FOREIGN WRAPPER|10 TABLE FUNCTION GROUP LANGUAGE LARGE OBJECT MATERIALIZED VIEW OPERATOR CLASS FAMILY POLICY PUBLICATION|10 ROLE RULE SCHEMA SEQUENCE SERVER STATISTICS SUBSCRIPTION SYSTEM TABLESPACE CONFIGURATION DICTIONARY PARSER TEMPLATE TYPE USER MAPPING PREPARED ACCESS METHOD CAST AS TRANSFORM TRANSACTION OWNED TO INTO SESSION AUTHORIZATION INDEX PROCEDURE ASSERTION ALL ANALYSE AND ANY ARRAY ASC ASYMMETRIC|10 BOTH CASE CHECK COLLATE COLUMN CONCURRENTLY|10 CONSTRAINT CROSS DEFERRABLE RANGE DESC DISTINCT ELSE EXCEPT FOR FREEZE|10 FROM FULL HAVING ILIKE IN INITIALLY INNER INTERSECT IS ISNULL JOIN LATERAL LEADING LIKE LIMIT NATURAL NOT NOTNULL NULL OFFSET ON ONLY OR ORDER OUTER OVERLAPS PLACING PRIMARY REFERENCES RETURNING SIMILAR SOME SYMMETRIC TABLESAMPLE THEN TRAILING UNION UNIQUE USING VARIADIC|10 VERBOSE WHEN WHERE WINDOW WITH BY RETURNS INOUT OUT SETOF|10 IF STRICT CURRENT CONTINUE OWNER LOCATION OVER PARTITION WITHIN BETWEEN ESCAPE EXTERNAL INVOKER DEFINER WORK RENAME VERSION CONNECTION CONNECT TABLES TEMP TEMPORARY FUNCTIONS SEQUENCES TYPES SCHEMAS OPTION CASCADE RESTRICT ADD ADMIN EXISTS VALID VALIDATE ENABLE DISABLE REPLICA|10 ALWAYS PASSING COLUMNS PATH REF VALUE OVERRIDING IMMUTABLE STABLE VOLATILE BEFORE AFTER EACH ROW PROCEDURAL ROUTINE NO HANDLER VALIDATOR OPTIONS STORAGE OIDS|10 WITHOUT INHERIT DEPENDS CALLED INPUT LEAKPROOF|10 COST ROWS NOWAIT SEARCH UNTIL ENCRYPTED|10 PASSWORD CONFLICT|10 INSTEAD INHERITS CHARACTERISTICS WRITE CURSOR ALSO STATEMENT SHARE EXCLUSIVE INLINE ISOLATION REPEATABLE READ COMMITTED SERIALIZABLE UNCOMMITTED LOCAL GLOBAL SQL PROCEDURES RECURSIVE SNAPSHOT ROLLUP CUBE TRUSTED|10 INCLUDE FOLLOWING PRECEDING UNBOUNDED RANGE GROUPS UNENCRYPTED|10 SYSID FORMAT DELIMITER HEADER QUOTE ENCODING FILTER OFF FORCE_QUOTE FORCE_NOT_NULL FORCE_NULL COSTS BUFFERS TIMING SUMMARY DISABLE_PAGE_SKIPPING RESTART CYCLE GENERATED IDENTITY DEFERRED IMMEDIATE LEVEL LOGGED UNLOGGED OF NOTHING NONE EXCLUDE ATTRIBUTE USAGE ROUTINES TRUE FALSE NAN INFINITY ";
    var ROLE_ATTRS = "SUPERUSER NOSUPERUSER CREATEDB NOCREATEDB CREATEROLE NOCREATEROLE INHERIT NOINHERIT LOGIN NOLOGIN REPLICATION NOREPLICATION BYPASSRLS NOBYPASSRLS ";
    var PLPGSQL_KW = "ALIAS BEGIN CONSTANT DECLARE END EXCEPTION RETURN PERFORM|10 RAISE GET DIAGNOSTICS STACKED|10 FOREACH LOOP ELSIF EXIT WHILE REVERSE SLICE DEBUG LOG INFO NOTICE WARNING ASSERT OPEN ";
    var TYPES = // https://www.postgresql.org/docs/11/static/datatype.html
    "BIGINT INT8 BIGSERIAL SERIAL8 BIT VARYING VARBIT BOOLEAN BOOL BOX BYTEA CHARACTER CHAR VARCHAR CIDR CIRCLE DATE DOUBLE PRECISION FLOAT8 FLOAT INET INTEGER INT INT4 INTERVAL JSON JSONB LINE LSEG|10 MACADDR MACADDR8 MONEY NUMERIC DEC DECIMAL PATH POINT POLYGON REAL FLOAT4 SMALLINT INT2 SMALLSERIAL|10 SERIAL2|10 SERIAL|10 SERIAL4|10 TEXT TIME ZONE TIMETZ|10 TIMESTAMP TIMESTAMPTZ|10 TSQUERY|10 TSVECTOR|10 TXID_SNAPSHOT|10 UUID XML NATIONAL NCHAR INT4RANGE|10 INT8RANGE|10 NUMRANGE|10 TSRANGE|10 TSTZRANGE|10 DATERANGE|10 ANYELEMENT ANYARRAY ANYNONARRAY ANYENUM ANYRANGE CSTRING INTERNAL RECORD PG_DDL_COMMAND VOID UNKNOWN OPAQUE REFCURSOR NAME OID REGPROC|10 REGPROCEDURE|10 REGOPER|10 REGOPERATOR|10 REGCLASS|10 REGTYPE|10 REGROLE|10 REGNAMESPACE|10 REGCONFIG|10 REGDICTIONARY|10 "; // +
    // some types from standard extensions
    "HSTORE|10 LO LTREE|10 ";
    var TYPES_RE = TYPES.trim().split(" ").map(function(val) {
        return val.split("|")[0];
    }).join("|");
    var SQL_BI = "CURRENT_TIME CURRENT_TIMESTAMP CURRENT_USER CURRENT_CATALOG|10 CURRENT_DATE LOCALTIME LOCALTIMESTAMP CURRENT_ROLE|10 CURRENT_SCHEMA|10 SESSION_USER PUBLIC ";
    var PLPGSQL_BI = "FOUND NEW OLD TG_NAME|10 TG_WHEN|10 TG_LEVEL|10 TG_OP|10 TG_RELID|10 TG_RELNAME|10 TG_TABLE_NAME|10 TG_TABLE_SCHEMA|10 TG_NARGS|10 TG_ARGV|10 TG_EVENT|10 TG_TAG|10 ROW_COUNT RESULT_OID|10 PG_CONTEXT|10 RETURNED_SQLSTATE COLUMN_NAME CONSTRAINT_NAME PG_DATATYPE_NAME|10 MESSAGE_TEXT TABLE_NAME SCHEMA_NAME PG_EXCEPTION_DETAIL|10 PG_EXCEPTION_HINT|10 PG_EXCEPTION_CONTEXT|10 ";
    var PLPGSQL_EXCEPTIONS = // exceptions https://www.postgresql.org/docs/current/static/errcodes-appendix.html
    "SQLSTATE SQLERRM|10 SUCCESSFUL_COMPLETION WARNING DYNAMIC_RESULT_SETS_RETURNED IMPLICIT_ZERO_BIT_PADDING NULL_VALUE_ELIMINATED_IN_SET_FUNCTION PRIVILEGE_NOT_GRANTED PRIVILEGE_NOT_REVOKED STRING_DATA_RIGHT_TRUNCATION DEPRECATED_FEATURE NO_DATA NO_ADDITIONAL_DYNAMIC_RESULT_SETS_RETURNED SQL_STATEMENT_NOT_YET_COMPLETE CONNECTION_EXCEPTION CONNECTION_DOES_NOT_EXIST CONNECTION_FAILURE SQLCLIENT_UNABLE_TO_ESTABLISH_SQLCONNECTION SQLSERVER_REJECTED_ESTABLISHMENT_OF_SQLCONNECTION TRANSACTION_RESOLUTION_UNKNOWN PROTOCOL_VIOLATION TRIGGERED_ACTION_EXCEPTION FEATURE_NOT_SUPPORTED INVALID_TRANSACTION_INITIATION LOCATOR_EXCEPTION INVALID_LOCATOR_SPECIFICATION INVALID_GRANTOR INVALID_GRANT_OPERATION INVALID_ROLE_SPECIFICATION DIAGNOSTICS_EXCEPTION STACKED_DIAGNOSTICS_ACCESSED_WITHOUT_ACTIVE_HANDLER CASE_NOT_FOUND CARDINALITY_VIOLATION DATA_EXCEPTION ARRAY_SUBSCRIPT_ERROR CHARACTER_NOT_IN_REPERTOIRE DATETIME_FIELD_OVERFLOW DIVISION_BY_ZERO ERROR_IN_ASSIGNMENT ESCAPE_CHARACTER_CONFLICT INDICATOR_OVERFLOW INTERVAL_FIELD_OVERFLOW INVALID_ARGUMENT_FOR_LOGARITHM INVALID_ARGUMENT_FOR_NTILE_FUNCTION INVALID_ARGUMENT_FOR_NTH_VALUE_FUNCTION INVALID_ARGUMENT_FOR_POWER_FUNCTION INVALID_ARGUMENT_FOR_WIDTH_BUCKET_FUNCTION INVALID_CHARACTER_VALUE_FOR_CAST INVALID_DATETIME_FORMAT INVALID_ESCAPE_CHARACTER INVALID_ESCAPE_OCTET INVALID_ESCAPE_SEQUENCE NONSTANDARD_USE_OF_ESCAPE_CHARACTER INVALID_INDICATOR_PARAMETER_VALUE INVALID_PARAMETER_VALUE INVALID_REGULAR_EXPRESSION INVALID_ROW_COUNT_IN_LIMIT_CLAUSE INVALID_ROW_COUNT_IN_RESULT_OFFSET_CLAUSE INVALID_TABLESAMPLE_ARGUMENT INVALID_TABLESAMPLE_REPEAT INVALID_TIME_ZONE_DISPLACEMENT_VALUE INVALID_USE_OF_ESCAPE_CHARACTER MOST_SPECIFIC_TYPE_MISMATCH NULL_VALUE_NOT_ALLOWED NULL_VALUE_NO_INDICATOR_PARAMETER NUMERIC_VALUE_OUT_OF_RANGE SEQUENCE_GENERATOR_LIMIT_EXCEEDED STRING_DATA_LENGTH_MISMATCH STRING_DATA_RIGHT_TRUNCATION SUBSTRING_ERROR TRIM_ERROR UNTERMINATED_C_STRING ZERO_LENGTH_CHARACTER_STRING FLOATING_POINT_EXCEPTION INVALID_TEXT_REPRESENTATION INVALID_BINARY_REPRESENTATION BAD_COPY_FILE_FORMAT UNTRANSLATABLE_CHARACTER NOT_AN_XML_DOCUMENT INVALID_XML_DOCUMENT INVALID_XML_CONTENT INVALID_XML_COMMENT INVALID_XML_PROCESSING_INSTRUCTION INTEGRITY_CONSTRAINT_VIOLATION RESTRICT_VIOLATION NOT_NULL_VIOLATION FOREIGN_KEY_VIOLATION UNIQUE_VIOLATION CHECK_VIOLATION EXCLUSION_VIOLATION INVALID_CURSOR_STATE INVALID_TRANSACTION_STATE ACTIVE_SQL_TRANSACTION BRANCH_TRANSACTION_ALREADY_ACTIVE HELD_CURSOR_REQUIRES_SAME_ISOLATION_LEVEL INAPPROPRIATE_ACCESS_MODE_FOR_BRANCH_TRANSACTION INAPPROPRIATE_ISOLATION_LEVEL_FOR_BRANCH_TRANSACTION NO_ACTIVE_SQL_TRANSACTION_FOR_BRANCH_TRANSACTION READ_ONLY_SQL_TRANSACTION SCHEMA_AND_DATA_STATEMENT_MIXING_NOT_SUPPORTED NO_ACTIVE_SQL_TRANSACTION IN_FAILED_SQL_TRANSACTION IDLE_IN_TRANSACTION_SESSION_TIMEOUT INVALID_SQL_STATEMENT_NAME TRIGGERED_DATA_CHANGE_VIOLATION INVALID_AUTHORIZATION_SPECIFICATION INVALID_PASSWORD DEPENDENT_PRIVILEGE_DESCRIPTORS_STILL_EXIST DEPENDENT_OBJECTS_STILL_EXIST INVALID_TRANSACTION_TERMINATION SQL_ROUTINE_EXCEPTION FUNCTION_EXECUTED_NO_RETURN_STATEMENT MODIFYING_SQL_DATA_NOT_PERMITTED PROHIBITED_SQL_STATEMENT_ATTEMPTED READING_SQL_DATA_NOT_PERMITTED INVALID_CURSOR_NAME EXTERNAL_ROUTINE_EXCEPTION CONTAINING_SQL_NOT_PERMITTED MODIFYING_SQL_DATA_NOT_PERMITTED PROHIBITED_SQL_STATEMENT_ATTEMPTED READING_SQL_DATA_NOT_PERMITTED EXTERNAL_ROUTINE_INVOCATION_EXCEPTION INVALID_SQLSTATE_RETURNED NULL_VALUE_NOT_ALLOWED TRIGGER_PROTOCOL_VIOLATED SRF_PROTOCOL_VIOLATED EVENT_TRIGGER_PROTOCOL_VIOLATED SAVEPOINT_EXCEPTION INVALID_SAVEPOINT_SPECIFICATION INVALID_CATALOG_NAME INVALID_SCHEMA_NAME TRANSACTION_ROLLBACK TRANSACTION_INTEGRITY_CONSTRAINT_VIOLATION SERIALIZATION_FAILURE STATEMENT_COMPLETION_UNKNOWN DEADLOCK_DETECTED SYNTAX_ERROR_OR_ACCESS_RULE_VIOLATION SYNTAX_ERROR INSUFFICIENT_PRIVILEGE CANNOT_COERCE GROUPING_ERROR WINDOWING_ERROR INVALID_RECURSION INVALID_FOREIGN_KEY INVALID_NAME NAME_TOO_LONG RESERVED_NAME DATATYPE_MISMATCH INDETERMINATE_DATATYPE COLLATION_MISMATCH INDETERMINATE_COLLATION WRONG_OBJECT_TYPE GENERATED_ALWAYS UNDEFINED_COLUMN UNDEFINED_FUNCTION UNDEFINED_TABLE UNDEFINED_PARAMETER UNDEFINED_OBJECT DUPLICATE_COLUMN DUPLICATE_CURSOR DUPLICATE_DATABASE DUPLICATE_FUNCTION DUPLICATE_PREPARED_STATEMENT DUPLICATE_SCHEMA DUPLICATE_TABLE DUPLICATE_ALIAS DUPLICATE_OBJECT AMBIGUOUS_COLUMN AMBIGUOUS_FUNCTION AMBIGUOUS_PARAMETER AMBIGUOUS_ALIAS INVALID_COLUMN_REFERENCE INVALID_COLUMN_DEFINITION INVALID_CURSOR_DEFINITION INVALID_DATABASE_DEFINITION INVALID_FUNCTION_DEFINITION INVALID_PREPARED_STATEMENT_DEFINITION INVALID_SCHEMA_DEFINITION INVALID_TABLE_DEFINITION INVALID_OBJECT_DEFINITION WITH_CHECK_OPTION_VIOLATION INSUFFICIENT_RESOURCES DISK_FULL OUT_OF_MEMORY TOO_MANY_CONNECTIONS CONFIGURATION_LIMIT_EXCEEDED PROGRAM_LIMIT_EXCEEDED STATEMENT_TOO_COMPLEX TOO_MANY_COLUMNS TOO_MANY_ARGUMENTS OBJECT_NOT_IN_PREREQUISITE_STATE OBJECT_IN_USE CANT_CHANGE_RUNTIME_PARAM LOCK_NOT_AVAILABLE OPERATOR_INTERVENTION QUERY_CANCELED ADMIN_SHUTDOWN CRASH_SHUTDOWN CANNOT_CONNECT_NOW DATABASE_DROPPED SYSTEM_ERROR IO_ERROR UNDEFINED_FILE DUPLICATE_FILE SNAPSHOT_TOO_OLD CONFIG_FILE_ERROR LOCK_FILE_EXISTS FDW_ERROR FDW_COLUMN_NAME_NOT_FOUND FDW_DYNAMIC_PARAMETER_VALUE_NEEDED FDW_FUNCTION_SEQUENCE_ERROR FDW_INCONSISTENT_DESCRIPTOR_INFORMATION FDW_INVALID_ATTRIBUTE_VALUE FDW_INVALID_COLUMN_NAME FDW_INVALID_COLUMN_NUMBER FDW_INVALID_DATA_TYPE FDW_INVALID_DATA_TYPE_DESCRIPTORS FDW_INVALID_DESCRIPTOR_FIELD_IDENTIFIER FDW_INVALID_HANDLE FDW_INVALID_OPTION_INDEX FDW_INVALID_OPTION_NAME FDW_INVALID_STRING_LENGTH_OR_BUFFER_LENGTH FDW_INVALID_STRING_FORMAT FDW_INVALID_USE_OF_NULL_POINTER FDW_TOO_MANY_HANDLES FDW_OUT_OF_MEMORY FDW_NO_SCHEMAS FDW_OPTION_NAME_NOT_FOUND FDW_REPLY_HANDLE FDW_SCHEMA_NOT_FOUND FDW_TABLE_NOT_FOUND FDW_UNABLE_TO_CREATE_EXECUTION FDW_UNABLE_TO_CREATE_REPLY FDW_UNABLE_TO_ESTABLISH_CONNECTION PLPGSQL_ERROR RAISE_EXCEPTION NO_DATA_FOUND TOO_MANY_ROWS ASSERT_FAILURE INTERNAL_ERROR DATA_CORRUPTED INDEX_CORRUPTED ";
    var FUNCTIONS = // https://www.postgresql.org/docs/11/static/functions-aggregate.html
    "ARRAY_AGG AVG BIT_AND BIT_OR BOOL_AND BOOL_OR COUNT EVERY JSON_AGG JSONB_AGG JSON_OBJECT_AGG JSONB_OBJECT_AGG MAX MIN MODE STRING_AGG SUM XMLAGG CORR COVAR_POP COVAR_SAMP REGR_AVGX REGR_AVGY REGR_COUNT REGR_INTERCEPT REGR_R2 REGR_SLOPE REGR_SXX REGR_SXY REGR_SYY STDDEV STDDEV_POP STDDEV_SAMP VARIANCE VAR_POP VAR_SAMP PERCENTILE_CONT PERCENTILE_DISC ROW_NUMBER RANK DENSE_RANK PERCENT_RANK CUME_DIST NTILE LAG LEAD FIRST_VALUE LAST_VALUE NTH_VALUE NUM_NONNULLS NUM_NULLS ABS CBRT CEIL CEILING DEGREES DIV EXP FLOOR LN LOG MOD PI POWER RADIANS ROUND SCALE SIGN SQRT TRUNC WIDTH_BUCKET RANDOM SETSEED ACOS ACOSD ASIN ASIND ATAN ATAND ATAN2 ATAN2D COS COSD COT COTD SIN SIND TAN TAND BIT_LENGTH CHAR_LENGTH CHARACTER_LENGTH LOWER OCTET_LENGTH OVERLAY POSITION SUBSTRING TREAT TRIM UPPER ASCII BTRIM CHR CONCAT CONCAT_WS CONVERT CONVERT_FROM CONVERT_TO DECODE ENCODE INITCAPLEFT LENGTH LPAD LTRIM MD5 PARSE_IDENT PG_CLIENT_ENCODING QUOTE_IDENT|10 QUOTE_LITERAL|10 QUOTE_NULLABLE|10 REGEXP_MATCH REGEXP_MATCHES REGEXP_REPLACE REGEXP_SPLIT_TO_ARRAY REGEXP_SPLIT_TO_TABLE REPEAT REPLACE REVERSE RIGHT RPAD RTRIM SPLIT_PART STRPOS SUBSTR TO_ASCII TO_HEX TRANSLATE OCTET_LENGTH GET_BIT GET_BYTE SET_BIT SET_BYTE TO_CHAR TO_DATE TO_NUMBER TO_TIMESTAMP AGE CLOCK_TIMESTAMP|10 DATE_PART DATE_TRUNC ISFINITE JUSTIFY_DAYS JUSTIFY_HOURS JUSTIFY_INTERVAL MAKE_DATE MAKE_INTERVAL|10 MAKE_TIME MAKE_TIMESTAMP|10 MAKE_TIMESTAMPTZ|10 NOW STATEMENT_TIMESTAMP|10 TIMEOFDAY TRANSACTION_TIMESTAMP|10 ENUM_FIRST ENUM_LAST ENUM_RANGE AREA CENTER DIAMETER HEIGHT ISCLOSED ISOPEN NPOINTS PCLOSE POPEN RADIUS WIDTH BOX BOUND_BOX CIRCLE LINE LSEG PATH POLYGON ABBREV BROADCAST HOST HOSTMASK MASKLEN NETMASK NETWORK SET_MASKLEN TEXT INET_SAME_FAMILYINET_MERGE MACADDR8_SET7BIT ARRAY_TO_TSVECTOR GET_CURRENT_TS_CONFIG NUMNODE PLAINTO_TSQUERY PHRASETO_TSQUERY WEBSEARCH_TO_TSQUERY QUERYTREE SETWEIGHT STRIP TO_TSQUERY TO_TSVECTOR JSON_TO_TSVECTOR JSONB_TO_TSVECTOR TS_DELETE TS_FILTER TS_HEADLINE TS_RANK TS_RANK_CD TS_REWRITE TSQUERY_PHRASE TSVECTOR_TO_ARRAY TSVECTOR_UPDATE_TRIGGER TSVECTOR_UPDATE_TRIGGER_COLUMN XMLCOMMENT XMLCONCAT XMLELEMENT XMLFOREST XMLPI XMLROOT XMLEXISTS XML_IS_WELL_FORMED XML_IS_WELL_FORMED_DOCUMENT XML_IS_WELL_FORMED_CONTENT XPATH XPATH_EXISTS XMLTABLE XMLNAMESPACES TABLE_TO_XML TABLE_TO_XMLSCHEMA TABLE_TO_XML_AND_XMLSCHEMA QUERY_TO_XML QUERY_TO_XMLSCHEMA QUERY_TO_XML_AND_XMLSCHEMA CURSOR_TO_XML CURSOR_TO_XMLSCHEMA SCHEMA_TO_XML SCHEMA_TO_XMLSCHEMA SCHEMA_TO_XML_AND_XMLSCHEMA DATABASE_TO_XML DATABASE_TO_XMLSCHEMA DATABASE_TO_XML_AND_XMLSCHEMA XMLATTRIBUTES TO_JSON TO_JSONB ARRAY_TO_JSON ROW_TO_JSON JSON_BUILD_ARRAY JSONB_BUILD_ARRAY JSON_BUILD_OBJECT JSONB_BUILD_OBJECT JSON_OBJECT JSONB_OBJECT JSON_ARRAY_LENGTH JSONB_ARRAY_LENGTH JSON_EACH JSONB_EACH JSON_EACH_TEXT JSONB_EACH_TEXT JSON_EXTRACT_PATH JSONB_EXTRACT_PATH JSON_OBJECT_KEYS JSONB_OBJECT_KEYS JSON_POPULATE_RECORD JSONB_POPULATE_RECORD JSON_POPULATE_RECORDSET JSONB_POPULATE_RECORDSET JSON_ARRAY_ELEMENTS JSONB_ARRAY_ELEMENTS JSON_ARRAY_ELEMENTS_TEXT JSONB_ARRAY_ELEMENTS_TEXT JSON_TYPEOF JSONB_TYPEOF JSON_TO_RECORD JSONB_TO_RECORD JSON_TO_RECORDSET JSONB_TO_RECORDSET JSON_STRIP_NULLS JSONB_STRIP_NULLS JSONB_SET JSONB_INSERT JSONB_PRETTY CURRVAL LASTVAL NEXTVAL SETVAL COALESCE NULLIF GREATEST LEAST ARRAY_APPEND ARRAY_CAT ARRAY_NDIMS ARRAY_DIMS ARRAY_FILL ARRAY_LENGTH ARRAY_LOWER ARRAY_POSITION ARRAY_POSITIONS ARRAY_PREPEND ARRAY_REMOVE ARRAY_REPLACE ARRAY_TO_STRING ARRAY_UPPER CARDINALITY STRING_TO_ARRAY UNNEST ISEMPTY LOWER_INC UPPER_INC LOWER_INF UPPER_INF RANGE_MERGE GENERATE_SERIES GENERATE_SUBSCRIPTS CURRENT_DATABASE CURRENT_QUERY CURRENT_SCHEMA|10 CURRENT_SCHEMAS|10 INET_CLIENT_ADDR INET_CLIENT_PORT INET_SERVER_ADDR INET_SERVER_PORT ROW_SECURITY_ACTIVE FORMAT_TYPE TO_REGCLASS TO_REGPROC TO_REGPROCEDURE TO_REGOPER TO_REGOPERATOR TO_REGTYPE TO_REGNAMESPACE TO_REGROLE COL_DESCRIPTION OBJ_DESCRIPTION SHOBJ_DESCRIPTION TXID_CURRENT TXID_CURRENT_IF_ASSIGNED TXID_CURRENT_SNAPSHOT TXID_SNAPSHOT_XIP TXID_SNAPSHOT_XMAX TXID_SNAPSHOT_XMIN TXID_VISIBLE_IN_SNAPSHOT TXID_STATUS CURRENT_SETTING SET_CONFIG BRIN_SUMMARIZE_NEW_VALUES BRIN_SUMMARIZE_RANGE BRIN_DESUMMARIZE_RANGE GIN_CLEAN_PENDING_LIST SUPPRESS_REDUNDANT_UPDATES_TRIGGER LO_FROM_BYTEA LO_PUT LO_GET LO_CREAT LO_CREATE LO_UNLINK LO_IMPORT LO_EXPORT LOREAD LOWRITE GROUPING CAST ";
    var FUNCTIONS_RE = FUNCTIONS.trim().split(" ").map(function(val) {
        return val.split("|")[0];
    }).join("|");
    return {
        aliases: [
            "postgres",
            "postgresql"
        ],
        case_insensitive: true,
        keywords: {
            keyword: SQL_KW + PLPGSQL_KW + ROLE_ATTRS,
            built_in: SQL_BI + PLPGSQL_BI + PLPGSQL_EXCEPTIONS
        },
        // Forbid some cunstructs from other languages to improve autodetect. In fact
        // "[a-z]:" is legal (as part of array slice), but improbabal.
        illegal: /:==|\W\s*\(\*|(^|\s)\$[a-z]|{{|[a-z]:\s*$|\.\.\.|TO:|DO:/,
        contains: [
            // special handling of some words, which are reserved only in some contexts
            {
                className: "keyword",
                variants: [
                    {
                        begin: /\bTEXT\s*SEARCH\b/
                    },
                    {
                        begin: /\b(PRIMARY|FOREIGN|FOR(\s+NO)?)\s+KEY\b/
                    },
                    {
                        begin: /\bPARALLEL\s+(UNSAFE|RESTRICTED|SAFE)\b/
                    },
                    {
                        begin: /\bSTORAGE\s+(PLAIN|EXTERNAL|EXTENDED|MAIN)\b/
                    },
                    {
                        begin: /\bMATCH\s+(FULL|PARTIAL|SIMPLE)\b/
                    },
                    {
                        begin: /\bNULLS\s+(FIRST|LAST)\b/
                    },
                    {
                        begin: /\bEVENT\s+TRIGGER\b/
                    },
                    {
                        begin: /\b(MAPPING|OR)\s+REPLACE\b/
                    },
                    {
                        begin: /\b(FROM|TO)\s+(PROGRAM|STDIN|STDOUT)\b/
                    },
                    {
                        begin: /\b(SHARE|EXCLUSIVE)\s+MODE\b/
                    },
                    {
                        begin: /\b(LEFT|RIGHT)\s+(OUTER\s+)?JOIN\b/
                    },
                    {
                        begin: /\b(FETCH|MOVE)\s+(NEXT|PRIOR|FIRST|LAST|ABSOLUTE|RELATIVE|FORWARD|BACKWARD)\b/
                    },
                    {
                        begin: /\bPRESERVE\s+ROWS\b/
                    },
                    {
                        begin: /\bDISCARD\s+PLANS\b/
                    },
                    {
                        begin: /\bREFERENCING\s+(OLD|NEW)\b/
                    },
                    {
                        begin: /\bSKIP\s+LOCKED\b/
                    },
                    {
                        begin: /\bGROUPING\s+SETS\b/
                    },
                    {
                        begin: /\b(BINARY|INSENSITIVE|SCROLL|NO\s+SCROLL)\s+(CURSOR|FOR)\b/
                    },
                    {
                        begin: /\b(WITH|WITHOUT)\s+HOLD\b/
                    },
                    {
                        begin: /\bWITH\s+(CASCADED|LOCAL)\s+CHECK\s+OPTION\b/
                    },
                    {
                        begin: /\bEXCLUDE\s+(TIES|NO\s+OTHERS)\b/
                    },
                    {
                        begin: /\bFORMAT\s+(TEXT|XML|JSON|YAML)\b/
                    },
                    {
                        begin: /\bSET\s+((SESSION|LOCAL)\s+)?NAMES\b/
                    },
                    {
                        begin: /\bIS\s+(NOT\s+)?UNKNOWN\b/
                    },
                    {
                        begin: /\bSECURITY\s+LABEL\b/
                    },
                    {
                        begin: /\bSTANDALONE\s+(YES|NO|NO\s+VALUE)\b/
                    },
                    {
                        begin: /\bWITH\s+(NO\s+)?DATA\b/
                    },
                    {
                        begin: /\b(FOREIGN|SET)\s+DATA\b/
                    },
                    {
                        begin: /\bSET\s+(CATALOG|CONSTRAINTS)\b/
                    },
                    {
                        begin: /\b(WITH|FOR)\s+ORDINALITY\b/
                    },
                    {
                        begin: /\bIS\s+(NOT\s+)?DOCUMENT\b/
                    },
                    {
                        begin: /\bXML\s+OPTION\s+(DOCUMENT|CONTENT)\b/
                    },
                    {
                        begin: /\b(STRIP|PRESERVE)\s+WHITESPACE\b/
                    },
                    {
                        begin: /\bNO\s+(ACTION|MAXVALUE|MINVALUE)\b/
                    },
                    {
                        begin: /\bPARTITION\s+BY\s+(RANGE|LIST|HASH)\b/
                    },
                    {
                        begin: /\bAT\s+TIME\s+ZONE\b/
                    },
                    {
                        begin: /\bGRANTED\s+BY\b/
                    },
                    {
                        begin: /\bRETURN\s+(QUERY|NEXT)\b/
                    },
                    {
                        begin: /\b(ATTACH|DETACH)\s+PARTITION\b/
                    },
                    {
                        begin: /\bFORCE\s+ROW\s+LEVEL\s+SECURITY\b/
                    },
                    {
                        begin: /\b(INCLUDING|EXCLUDING)\s+(COMMENTS|CONSTRAINTS|DEFAULTS|IDENTITY|INDEXES|STATISTICS|STORAGE|ALL)\b/
                    },
                    {
                        begin: /\bAS\s+(ASSIGNMENT|IMPLICIT|PERMISSIVE|RESTRICTIVE|ENUM|RANGE)\b/
                    }
                ]
            },
            // functions named as keywords, followed by '('
            {
                begin: /\b(FORMAT|FAMILY|VERSION)\s*\(/
            },
            // INCLUDE ( ... ) in index_parameters in CREATE TABLE
            {
                begin: /\bINCLUDE\s*\(/,
                keywords: "INCLUDE"
            },
            // not highlight RANGE if not in frame_clause (not 100% correct, but seems satisfactory)
            {
                begin: /\bRANGE(?!\s*(BETWEEN|UNBOUNDED|CURRENT|[-0-9]+))/
            },
            // disable highlighting in commands CREATE AGGREGATE/COLLATION/DATABASE/OPERTOR/TEXT SEARCH .../TYPE
            // and in PL/pgSQL RAISE ... USING
            {
                begin: /\b(VERSION|OWNER|TEMPLATE|TABLESPACE|CONNECTION\s+LIMIT|PROCEDURE|RESTRICT|JOIN|PARSER|COPY|START|END|COLLATION|INPUT|ANALYZE|STORAGE|LIKE|DEFAULT|DELIMITER|ENCODING|COLUMN|CONSTRAINT|TABLE|SCHEMA)\s*=/
            },
            // PG_smth; HAS_some_PRIVILEGE
            {
                //className: 'built_in',
                begin: /\b(PG_\w+?|HAS_[A-Z_]+_PRIVILEGE)\b/,
                relevance: 10
            },
            // extract
            {
                begin: /\bEXTRACT\s*\(/,
                end: /\bFROM\b/,
                returnEnd: true,
                keywords: {
                    //built_in: 'EXTRACT',
                    type: "CENTURY DAY DECADE DOW DOY EPOCH HOUR ISODOW ISOYEAR MICROSECONDS MILLENNIUM MILLISECONDS MINUTE MONTH QUARTER SECOND TIMEZONE TIMEZONE_HOUR TIMEZONE_MINUTE WEEK YEAR"
                }
            },
            // xmlelement, xmlpi - special NAME
            {
                begin: /\b(XMLELEMENT|XMLPI)\s*\(\s*NAME/,
                keywords: {
                    //built_in: 'XMLELEMENT XMLPI',
                    keyword: "NAME"
                }
            },
            // xmlparse, xmlserialize
            {
                begin: /\b(XMLPARSE|XMLSERIALIZE)\s*\(\s*(DOCUMENT|CONTENT)/,
                keywords: {
                    //built_in: 'XMLPARSE XMLSERIALIZE',
                    keyword: "DOCUMENT CONTENT"
                }
            },
            // Sequences. We actually skip everything between CACHE|INCREMENT|MAXVALUE|MINVALUE and
            // nearest following numeric constant. Without with trick we find a lot of "keywords"
            // in 'avrasm' autodetection test...
            {
                beginKeywords: "CACHE INCREMENT MAXVALUE MINVALUE",
                end: hljs.C_NUMBER_RE,
                returnEnd: true,
                keywords: "BY CACHE INCREMENT MAXVALUE MINVALUE"
            },
            // WITH|WITHOUT TIME ZONE as part of datatype
            {
                className: "type",
                begin: /\b(WITH|WITHOUT)\s+TIME\s+ZONE\b/
            },
            // INTERVAL optional fields
            {
                className: "type",
                begin: /\bINTERVAL\s+(YEAR|MONTH|DAY|HOUR|MINUTE|SECOND)(\s+TO\s+(MONTH|HOUR|MINUTE|SECOND))?\b/
            },
            // Pseudo-types which allowed only as return type
            {
                begin: /\bRETURNS\s+(LANGUAGE_HANDLER|TRIGGER|EVENT_TRIGGER|FDW_HANDLER|INDEX_AM_HANDLER|TSM_HANDLER)\b/,
                keywords: {
                    keyword: "RETURNS",
                    type: "LANGUAGE_HANDLER TRIGGER EVENT_TRIGGER FDW_HANDLER INDEX_AM_HANDLER TSM_HANDLER"
                }
            },
            // Known functions - only when followed by '('
            {
                begin: "\\b(" + FUNCTIONS_RE + ")\\s*\\("
            },
            // Types
            {
                begin: "\\.(" + TYPES_RE + ")\\b" // prevent highlight as type, say, 'oid' in 'pgclass.oid'
            },
            {
                begin: "\\b(" + TYPES_RE + ")\\s+PATH\\b",
                keywords: {
                    keyword: "PATH",
                    type: TYPES.replace("PATH ", "")
                }
            },
            {
                className: "type",
                begin: "\\b(" + TYPES_RE + ")\\b"
            },
            // Strings, see https://www.postgresql.org/docs/11/static/sql-syntax-lexical.html#SQL-SYNTAX-CONSTANTS
            {
                className: "string",
                begin: "'",
                end: "'",
                contains: [
                    {
                        begin: "''"
                    }
                ]
            },
            {
                className: "string",
                begin: "(e|E|u&|U&)'",
                end: "'",
                contains: [
                    {
                        begin: "\\\\."
                    }
                ],
                relevance: 10
            },
            {
                begin: DOLLAR_STRING,
                endSameAsBegin: true,
                contains: [
                    {
                        // actually we want them all except SQL; listed are those with known implementations
                        // and XML + JSON just in case
                        subLanguage: [
                            "pgsql",
                            "perl",
                            "python",
                            "tcl",
                            "r",
                            "lua",
                            "java",
                            "php",
                            "ruby",
                            "bash",
                            "scheme",
                            "xml",
                            "json"
                        ],
                        endsWithParent: true
                    }
                ]
            },
            // identifiers in quotes
            {
                begin: '"',
                end: '"',
                contains: [
                    {
                        begin: '""'
                    }
                ]
            },
            // numbers
            hljs.C_NUMBER_MODE,
            // comments
            hljs.C_BLOCK_COMMENT_MODE,
            COMMENT_MODE,
            // PL/pgSQL staff
            // %ROWTYPE, %TYPE, $n
            {
                className: "meta",
                variants: [
                    {
                        begin: "%(ROW)?TYPE",
                        relevance: 10
                    },
                    {
                        begin: "\\$\\d+"
                    },
                    {
                        begin: "^#\\w",
                        end: "$"
                    } // #compiler option
                ]
            },
            // <<labeles>>
            {
                className: "symbol",
                begin: LABEL,
                relevance: 10
            }
        ]
    };
};

});

parcelRegister("5CEHT", function(module, exports) {
module.exports = function(hljs) {
    var VARIABLE = {
        begin: "\\$+[a-zA-Z_\x7f-\xff][a-zA-Z0-9_\x7f-\xff]*"
    };
    var PREPROCESSOR = {
        className: "meta",
        begin: /<\?(php)?|\?>/
    };
    var STRING = {
        className: "string",
        contains: [
            hljs.BACKSLASH_ESCAPE,
            PREPROCESSOR
        ],
        variants: [
            {
                begin: 'b"',
                end: '"'
            },
            {
                begin: "b'",
                end: "'"
            },
            hljs.inherit(hljs.APOS_STRING_MODE, {
                illegal: null
            }),
            hljs.inherit(hljs.QUOTE_STRING_MODE, {
                illegal: null
            })
        ]
    };
    var NUMBER = {
        variants: [
            hljs.BINARY_NUMBER_MODE,
            hljs.C_NUMBER_MODE
        ]
    };
    return {
        aliases: [
            "php",
            "php3",
            "php4",
            "php5",
            "php6",
            "php7"
        ],
        case_insensitive: true,
        keywords: "and include_once list abstract global private echo interface as static endswitch array null if endwhile or const for endforeach self var while isset public protected exit foreach throw elseif include __FILE__ empty require_once do xor return parent clone use __CLASS__ __LINE__ else break print eval new catch __METHOD__ case exception default die require __FUNCTION__ enddeclare final try switch continue endfor endif declare unset true false trait goto instanceof insteadof __DIR__ __NAMESPACE__ yield finally",
        contains: [
            hljs.HASH_COMMENT_MODE,
            hljs.COMMENT("//", "$", {
                contains: [
                    PREPROCESSOR
                ]
            }),
            hljs.COMMENT("/\\*", "\\*/", {
                contains: [
                    {
                        className: "doctag",
                        begin: "@[A-Za-z]+"
                    }
                ]
            }),
            hljs.COMMENT("__halt_compiler.+?;", false, {
                endsWithParent: true,
                keywords: "__halt_compiler",
                lexemes: hljs.UNDERSCORE_IDENT_RE
            }),
            {
                className: "string",
                begin: /<<<['"]?\w+['"]?$/,
                end: /^\w+;?$/,
                contains: [
                    hljs.BACKSLASH_ESCAPE,
                    {
                        className: "subst",
                        variants: [
                            {
                                begin: /\$\w+/
                            },
                            {
                                begin: /\{\$/,
                                end: /\}/
                            }
                        ]
                    }
                ]
            },
            PREPROCESSOR,
            {
                className: "keyword",
                begin: /\$this\b/
            },
            VARIABLE,
            {
                // swallow composed identifiers to avoid parsing them as keywords
                begin: /(::|->)+[a-zA-Z_\x7f-\xff][a-zA-Z0-9_\x7f-\xff]*/
            },
            {
                className: "function",
                beginKeywords: "function",
                end: /[;{]/,
                excludeEnd: true,
                illegal: "\\$|\\[|%",
                contains: [
                    hljs.UNDERSCORE_TITLE_MODE,
                    {
                        className: "params",
                        begin: "\\(",
                        end: "\\)",
                        contains: [
                            "self",
                            VARIABLE,
                            hljs.C_BLOCK_COMMENT_MODE,
                            STRING,
                            NUMBER
                        ]
                    }
                ]
            },
            {
                className: "class",
                beginKeywords: "class interface",
                end: "{",
                excludeEnd: true,
                illegal: /[:\(\$"]/,
                contains: [
                    {
                        beginKeywords: "extends implements"
                    },
                    hljs.UNDERSCORE_TITLE_MODE
                ]
            },
            {
                beginKeywords: "namespace",
                end: ";",
                illegal: /[\.']/,
                contains: [
                    hljs.UNDERSCORE_TITLE_MODE
                ]
            },
            {
                beginKeywords: "use",
                end: ";",
                contains: [
                    hljs.UNDERSCORE_TITLE_MODE
                ]
            },
            {
                begin: "=>" // No markup, just a relevance booster
            },
            STRING,
            NUMBER
        ]
    };
};

});

parcelRegister("1FKm9", function(module, exports) {
module.exports = function(hljs) {
    return {
        disableAutodetect: true
    };
};

});

parcelRegister("7jCd3", function(module, exports) {
module.exports = function(hljs) {
    var KEYWORDS = {
        keyword: "actor addressof and as be break class compile_error compile_intrinsic consume continue delegate digestof do else elseif embed end error for fun if ifdef in interface is isnt lambda let match new not object or primitive recover repeat return struct then trait try type until use var where while with xor",
        meta: "iso val tag trn box ref",
        literal: "this false true"
    };
    var TRIPLE_QUOTE_STRING_MODE = {
        className: "string",
        begin: '"""',
        end: '"""',
        relevance: 10
    };
    var QUOTE_STRING_MODE = {
        className: "string",
        begin: '"',
        end: '"',
        contains: [
            hljs.BACKSLASH_ESCAPE
        ]
    };
    var SINGLE_QUOTE_CHAR_MODE = {
        className: "string",
        begin: "'",
        end: "'",
        contains: [
            hljs.BACKSLASH_ESCAPE
        ],
        relevance: 0
    };
    var TYPE_NAME = {
        className: "type",
        begin: "\\b_?[A-Z][\\w]*",
        relevance: 0
    };
    var PRIMED_NAME = {
        begin: hljs.IDENT_RE + "'",
        relevance: 0
    };
    var NUMBER_MODE = {
        className: "number",
        begin: "(-?)(\\b0[xX][a-fA-F0-9]+|\\b0[bB][01]+|(\\b\\d+(_\\d+)?(\\.\\d*)?|\\.\\d+)([eE][-+]?\\d+)?)",
        relevance: 0
    };
    /**
   * The `FUNCTION` and `CLASS` modes were intentionally removed to simplify
   * highlighting and fix cases like
   * ```
   * interface Iterator[A: A]
   *   fun has_next(): Bool
   *   fun next(): A?
   * ```
   * where it is valid to have a function head without a body
   */ return {
        keywords: KEYWORDS,
        contains: [
            TYPE_NAME,
            TRIPLE_QUOTE_STRING_MODE,
            QUOTE_STRING_MODE,
            SINGLE_QUOTE_CHAR_MODE,
            PRIMED_NAME,
            NUMBER_MODE,
            hljs.C_LINE_COMMENT_MODE,
            hljs.C_BLOCK_COMMENT_MODE
        ]
    };
};

});

parcelRegister("5SMky", function(module, exports) {
module.exports = function(hljs) {
    var TYPES = [
        "string",
        "char",
        "byte",
        "int",
        "long",
        "bool",
        "decimal",
        "single",
        "double",
        "DateTime",
        "xml",
        "array",
        "hashtable",
        "void"
    ];
    // https://msdn.microsoft.com/en-us/library/ms714428(v=vs.85).aspx
    var VALID_VERBS = "Add|Clear|Close|Copy|Enter|Exit|Find|Format|Get|Hide|Join|Lock|Move|New|Open|Optimize|Pop|Push|Redo|Remove|Rename|Reset|Resize|Search|Select|Set|Show|Skip|Split|Step|Switch|Undo|Unlock|Watch|Backup|Checkpoint|Compare|Compress|Convert|ConvertFrom|ConvertTo|Dismount|Edit|Expand|Export|Group|Import|Initialize|Limit|Merge|New|Out|Publish|Restore|Save|Sync|Unpublish|Update|Approve|Assert|Complete|Confirm|Deny|Disable|Enable|Install|Invoke|Register|Request|Restart|Resume|Start|Stop|Submit|Suspend|Uninstall|Unregister|Wait|Debug|Measure|Ping|Repair|Resolve|Test|Trace|Connect|Disconnect|Read|Receive|Send|Write|Block|Grant|Protect|Revoke|Unblock|Unprotect|Use|ForEach|Sort|Tee|Where";
    var COMPARISON_OPERATORS = "-and|-as|-band|-bnot|-bor|-bxor|-casesensitive|-ccontains|-ceq|-cge|-cgt|-cle|-clike|-clt|-cmatch|-cne|-cnotcontains|-cnotlike|-cnotmatch|-contains|-creplace|-csplit|-eq|-exact|-f|-file|-ge|-gt|-icontains|-ieq|-ige|-igt|-ile|-ilike|-ilt|-imatch|-in|-ine|-inotcontains|-inotlike|-inotmatch|-ireplace|-is|-isnot|-isplit|-join|-le|-like|-lt|-match|-ne|-not|-notcontains|-notin|-notlike|-notmatch|-or|-regex|-replace|-shl|-shr|-split|-wildcard|-xor";
    var KEYWORDS = {
        keyword: "if else foreach return do while until elseif begin for trap data dynamicparam end break throw param continue finally in switch exit filter try process catch hidden static parameter"
    };
    var TITLE_NAME_RE = /\w[\w\d]*((-)[\w\d]+)*/;
    var BACKTICK_ESCAPE = {
        begin: "`[\\s\\S]",
        relevance: 0
    };
    var VAR = {
        className: "variable",
        variants: [
            {
                begin: /\$\B/
            },
            {
                className: "keyword",
                begin: /\$this/
            },
            {
                begin: /\$[\w\d][\w\d_:]*/
            }
        ]
    };
    var LITERAL = {
        className: "literal",
        begin: /\$(null|true|false)\b/
    };
    var QUOTE_STRING = {
        className: "string",
        variants: [
            {
                begin: /"/,
                end: /"/
            },
            {
                begin: /@"/,
                end: /^"@/
            }
        ],
        contains: [
            BACKTICK_ESCAPE,
            VAR,
            {
                className: "variable",
                begin: /\$[A-z]/,
                end: /[^A-z]/
            }
        ]
    };
    var APOS_STRING = {
        className: "string",
        variants: [
            {
                begin: /'/,
                end: /'/
            },
            {
                begin: /@'/,
                end: /^'@/
            }
        ]
    };
    var PS_HELPTAGS = {
        className: "doctag",
        variants: [
            /* no paramater help tags */ {
                begin: /\.(synopsis|description|example|inputs|outputs|notes|link|component|role|functionality)/
            },
            /* one parameter help tags */ {
                begin: /\.(parameter|forwardhelptargetname|forwardhelpcategory|remotehelprunspace|externalhelp)\s+\S+/
            }
        ]
    };
    var PS_COMMENT = hljs.inherit(hljs.COMMENT(null, null), {
        variants: [
            /* single-line comment */ {
                begin: /#/,
                end: /$/
            },
            /* multi-line comment */ {
                begin: /<#/,
                end: /#>/
            }
        ],
        contains: [
            PS_HELPTAGS
        ]
    });
    var CMDLETS = {
        className: "built_in",
        variants: [
            {
                begin: "(".concat(VALID_VERBS, ")+(-)[\\w\\d]+")
            }
        ]
    };
    var PS_CLASS = {
        className: "class",
        beginKeywords: "class enum",
        end: /\s*[{]/,
        excludeEnd: true,
        relevance: 0,
        contains: [
            hljs.TITLE_MODE
        ]
    };
    var PS_FUNCTION = {
        className: "function",
        begin: /function\s+/,
        end: /\s*\{|$/,
        excludeEnd: true,
        returnBegin: true,
        relevance: 0,
        contains: [
            {
                begin: "function",
                relevance: 0,
                className: "keyword"
            },
            {
                className: "title",
                begin: TITLE_NAME_RE,
                relevance: 0
            },
            {
                begin: /\(/,
                end: /\)/,
                className: "params",
                relevance: 0,
                contains: [
                    VAR
                ]
            }
        ]
    };
    // Using statment, plus type, plus assembly name.
    var PS_USING = {
        begin: /using\s/,
        end: /$/,
        returnBegin: true,
        contains: [
            QUOTE_STRING,
            APOS_STRING,
            {
                className: "keyword",
                begin: /(using|assembly|command|module|namespace|type)/
            }
        ]
    };
    // Comperison operators & function named parameters.
    var PS_ARGUMENTS = {
        variants: [
            // PS literals are pretty verbose so it's a good idea to accent them a bit.
            {
                className: "operator",
                begin: "(".concat(COMPARISON_OPERATORS, ")\\b")
            },
            {
                className: "literal",
                begin: /(-)[\w\d]+/,
                relevance: 0
            }
        ]
    };
    var STATIC_MEMBER = {
        className: "selector-tag",
        begin: /::\w+\b/,
        end: /$/,
        returnBegin: true,
        contains: [
            {
                className: "attribute",
                begin: /\w+/,
                endsParent: true
            }
        ]
    };
    var HASH_SIGNS = {
        className: "selector-tag",
        begin: /\@\B/,
        relevance: 0
    };
    var PS_NEW_OBJECT_TYPE = {
        className: "built_in",
        begin: /New-Object\s+\w/,
        end: /$/,
        returnBegin: true,
        contains: [
            {
                begin: /New-Object\s+/,
                relevance: 0
            },
            {
                className: "meta",
                begin: /([\w\.])+/,
                endsParent: true
            }
        ]
    };
    // It's a very general rule so I'll narrow it a bit with some strict boundaries
    // to avoid any possible false-positive collisions!
    var PS_METHODS = {
        className: "function",
        begin: /\[.*\]\s*[\w]+[ ]??\(/,
        end: /$/,
        returnBegin: true,
        relevance: 0,
        contains: [
            {
                className: "keyword",
                begin: "(".concat(KEYWORDS.keyword.toString().replace(/\s/g, "|"), ")\\b"),
                endsParent: true,
                relevance: 0
            },
            hljs.inherit(hljs.TITLE_MODE, {
                endsParent: true
            })
        ]
    };
    var GENTLEMANS_SET = [
        // STATIC_MEMBER,
        PS_METHODS,
        PS_COMMENT,
        BACKTICK_ESCAPE,
        hljs.NUMBER_MODE,
        QUOTE_STRING,
        APOS_STRING,
        // PS_NEW_OBJECT_TYPE,
        CMDLETS,
        VAR,
        LITERAL,
        HASH_SIGNS
    ];
    var PS_TYPE = {
        begin: /\[/,
        end: /\]/,
        excludeBegin: true,
        excludeEnd: true,
        relevance: 0,
        contains: [].concat("self", GENTLEMANS_SET, {
            begin: "(" + TYPES.join("|") + ")",
            className: "built_in",
            relevance: 0
        }, {
            className: "type",
            begin: /[\.\w\d]+/,
            relevance: 0
        })
    };
    PS_METHODS.contains.unshift(PS_TYPE);
    return {
        aliases: [
            "ps",
            "ps1"
        ],
        lexemes: /-?[A-z\.\-]+/,
        case_insensitive: true,
        keywords: KEYWORDS,
        contains: GENTLEMANS_SET.concat(PS_CLASS, PS_FUNCTION, PS_USING, PS_ARGUMENTS, PS_TYPE)
    };
};

});

parcelRegister("8wTNK", function(module, exports) {
module.exports = function(hljs) {
    return {
        keywords: {
            keyword: "BufferedReader PVector PFont PImage PGraphics HashMap boolean byte char color double float int long String Array FloatDict FloatList IntDict IntList JSONArray JSONObject Object StringDict StringList Table TableRow XML false synchronized int abstract float private char boolean static null if const for true while long throw strictfp finally protected import native final return void enum else break transient new catch instanceof byte super volatile case assert short package default double public try this switch continue throws protected public private",
            literal: "P2D P3D HALF_PI PI QUARTER_PI TAU TWO_PI",
            title: "setup draw",
            built_in: "displayHeight displayWidth mouseY mouseX mousePressed pmouseX pmouseY key keyCode pixels focused frameCount frameRate height width size createGraphics beginDraw createShape loadShape PShape arc ellipse line point quad rect triangle bezier bezierDetail bezierPoint bezierTangent curve curveDetail curvePoint curveTangent curveTightness shape shapeMode beginContour beginShape bezierVertex curveVertex endContour endShape quadraticVertex vertex ellipseMode noSmooth rectMode smooth strokeCap strokeJoin strokeWeight mouseClicked mouseDragged mouseMoved mousePressed mouseReleased mouseWheel keyPressed keyPressedkeyReleased keyTyped print println save saveFrame day hour millis minute month second year background clear colorMode fill noFill noStroke stroke alpha blue brightness color green hue lerpColor red saturation modelX modelY modelZ screenX screenY screenZ ambient emissive shininess specular add createImage beginCamera camera endCamera frustum ortho perspective printCamera printProjection cursor frameRate noCursor exit loop noLoop popStyle pushStyle redraw binary boolean byte char float hex int str unbinary unhex join match matchAll nf nfc nfp nfs split splitTokens trim append arrayCopy concat expand reverse shorten sort splice subset box sphere sphereDetail createInput createReader loadBytes loadJSONArray loadJSONObject loadStrings loadTable loadXML open parseXML saveTable selectFolder selectInput beginRaw beginRecord createOutput createWriter endRaw endRecord PrintWritersaveBytes saveJSONArray saveJSONObject saveStream saveStrings saveXML selectOutput popMatrix printMatrix pushMatrix resetMatrix rotate rotateX rotateY rotateZ scale shearX shearY translate ambientLight directionalLight lightFalloff lights lightSpecular noLights normal pointLight spotLight image imageMode loadImage noTint requestImage tint texture textureMode textureWrap blend copy filter get loadPixels set updatePixels blendMode loadShader PShaderresetShader shader createFont loadFont text textFont textAlign textLeading textMode textSize textWidth textAscent textDescent abs ceil constrain dist exp floor lerp log mag map max min norm pow round sq sqrt acos asin atan atan2 cos degrees radians sin tan noise noiseDetail noiseSeed random randomGaussian randomSeed"
        },
        contains: [
            hljs.C_LINE_COMMENT_MODE,
            hljs.C_BLOCK_COMMENT_MODE,
            hljs.APOS_STRING_MODE,
            hljs.QUOTE_STRING_MODE,
            hljs.C_NUMBER_MODE
        ]
    };
};

});

parcelRegister("9W4AC", function(module, exports) {
module.exports = function(hljs) {
    return {
        contains: [
            hljs.C_NUMBER_MODE,
            {
                begin: "[a-zA-Z_][\\da-zA-Z_]+\\.[\\da-zA-Z_]{1,3}",
                end: ":",
                excludeEnd: true
            },
            {
                begin: "(ncalls|tottime|cumtime)",
                end: "$",
                keywords: "ncalls tottime|10 cumtime|10 filename",
                relevance: 10
            },
            {
                begin: "function calls",
                end: "$",
                contains: [
                    hljs.C_NUMBER_MODE
                ],
                relevance: 10
            },
            hljs.APOS_STRING_MODE,
            hljs.QUOTE_STRING_MODE,
            {
                className: "string",
                begin: "\\(",
                end: "\\)$",
                excludeBegin: true,
                excludeEnd: true,
                relevance: 0
            }
        ]
    };
};

});

parcelRegister("cRudC", function(module, exports) {
module.exports = function(hljs) {
    var ATOM = {
        begin: /[a-z][A-Za-z0-9_]*/,
        relevance: 0
    };
    var VAR = {
        className: "symbol",
        variants: [
            {
                begin: /[A-Z][a-zA-Z0-9_]*/
            },
            {
                begin: /_[A-Za-z0-9_]*/
            }
        ],
        relevance: 0
    };
    var PARENTED = {
        begin: /\(/,
        end: /\)/,
        relevance: 0
    };
    var LIST = {
        begin: /\[/,
        end: /\]/
    };
    var LINE_COMMENT = {
        className: "comment",
        begin: /%/,
        end: /$/,
        contains: [
            hljs.PHRASAL_WORDS_MODE
        ]
    };
    var BACKTICK_STRING = {
        className: "string",
        begin: /`/,
        end: /`/,
        contains: [
            hljs.BACKSLASH_ESCAPE
        ]
    };
    var CHAR_CODE = {
        className: "string",
        begin: /0\'(\\\'|.)/
    };
    var SPACE_CODE = {
        className: "string",
        begin: /0\'\\s/ // 0'\s
    };
    var PRED_OP = {
        begin: /:-/
    };
    var inner = [
        ATOM,
        VAR,
        PARENTED,
        PRED_OP,
        LIST,
        LINE_COMMENT,
        hljs.C_BLOCK_COMMENT_MODE,
        hljs.QUOTE_STRING_MODE,
        hljs.APOS_STRING_MODE,
        BACKTICK_STRING,
        CHAR_CODE,
        SPACE_CODE,
        hljs.C_NUMBER_MODE
    ];
    PARENTED.contains = inner;
    LIST.contains = inner;
    return {
        contains: inner.concat([
            {
                begin: /\.$/
            } // relevance booster
        ])
    };
};

});

parcelRegister("iF6qb", function(module, exports) {
module.exports = function(hljs) {
    // whitespaces: space, tab, formfeed
    var WS0 = "[ \\t\\f]*";
    var WS1 = "[ \\t\\f]+";
    // delimiter
    var DELIM = "(" + WS0 + "[:=]" + WS0 + "|" + WS1 + ")";
    var KEY_ALPHANUM = "([^\\\\\\W:= \\t\\f\\n]|\\\\.)+";
    var KEY_OTHER = "([^\\\\:= \\t\\f\\n]|\\\\.)+";
    var DELIM_AND_VALUE = {
        // skip DELIM
        end: DELIM,
        relevance: 0,
        starts: {
            // value: everything until end of line (again, taking into account backslashes)
            className: "string",
            end: /$/,
            relevance: 0,
            contains: [
                {
                    begin: "\\\\\\n"
                }
            ]
        }
    };
    return {
        case_insensitive: true,
        illegal: /\S/,
        contains: [
            hljs.COMMENT("^\\s*[!#]", "$"),
            // key: everything until whitespace or = or : (taking into account backslashes)
            // case of a "normal" key
            {
                begin: KEY_ALPHANUM + DELIM,
                returnBegin: true,
                contains: [
                    {
                        className: "attr",
                        begin: KEY_ALPHANUM,
                        endsParent: true,
                        relevance: 0
                    }
                ],
                starts: DELIM_AND_VALUE
            },
            // case of key containing non-alphanumeric chars => relevance = 0
            {
                begin: KEY_OTHER + DELIM,
                returnBegin: true,
                relevance: 0,
                contains: [
                    {
                        className: "meta",
                        begin: KEY_OTHER,
                        endsParent: true,
                        relevance: 0
                    }
                ],
                starts: DELIM_AND_VALUE
            },
            // case of an empty key
            {
                className: "attr",
                relevance: 0,
                begin: KEY_OTHER + WS0 + "$"
            }
        ]
    };
};

});

parcelRegister("6vldq", function(module, exports) {
module.exports = function(hljs) {
    return {
        keywords: {
            keyword: "package import option optional required repeated group oneof",
            built_in: "double float int32 int64 uint32 uint64 sint32 sint64 fixed32 fixed64 sfixed32 sfixed64 bool string bytes",
            literal: "true false"
        },
        contains: [
            hljs.QUOTE_STRING_MODE,
            hljs.NUMBER_MODE,
            hljs.C_LINE_COMMENT_MODE,
            {
                className: "class",
                beginKeywords: "message enum service",
                end: /\{/,
                illegal: /\n/,
                contains: [
                    hljs.inherit(hljs.TITLE_MODE, {
                        starts: {
                            endsWithParent: true,
                            excludeEnd: true
                        } // hack: eating everything after the first title
                    })
                ]
            },
            {
                className: "function",
                beginKeywords: "rpc",
                end: /;/,
                excludeEnd: true,
                keywords: "rpc returns"
            },
            {
                begin: /^\s*[A-Z_]+/,
                end: /\s*=/,
                excludeEnd: true
            }
        ]
    };
};

});

parcelRegister("3Lh4K", function(module, exports) {
module.exports = function(hljs) {
    var PUPPET_KEYWORDS = {
        keyword: /* language keywords */ "and case default else elsif false if in import enherits node or true undef unless main settings $string ",
        literal: /* metaparameters */ "alias audit before loglevel noop require subscribe tag owner ensure group mode name|0 changes context force incl lens load_path onlyif provider returns root show_diff type_check en_address ip_address realname command environment hour monute month monthday special target weekday creates cwd ogoutput refresh refreshonly tries try_sleep umask backup checksum content ctime force ignore links mtime purge recurse recurselimit replace selinux_ignore_defaults selrange selrole seltype seluser source souirce_permissions sourceselect validate_cmd validate_replacement allowdupe attribute_membership auth_membership forcelocal gid ia_load_module members system host_aliases ip allowed_trunk_vlans description device_url duplex encapsulation etherchannel native_vlan speed principals allow_root auth_class auth_type authenticate_user k_of_n mechanisms rule session_owner shared options device fstype enable hasrestart directory present absent link atboot blockdevice device dump pass remounts poller_tag use message withpath adminfile allow_virtual allowcdrom category configfiles flavor install_options instance package_settings platform responsefile status uninstall_options vendor unless_system_user unless_uid binary control flags hasstatus manifest pattern restart running start stop allowdupe auths expiry gid groups home iterations key_membership keys managehome membership password password_max_age password_min_age profile_membership profiles project purge_ssh_keys role_membership roles salt shell uid baseurl cost descr enabled enablegroups exclude failovermethod gpgcheck gpgkey http_caching include includepkgs keepalive metadata_expire metalink mirrorlist priority protect proxy proxy_password proxy_username repo_gpgcheck s3_enabled skip_if_unavailable sslcacert sslclientcert sslclientkey sslverify mounted",
        built_in: /* core facts */ "architecture augeasversion blockdevices boardmanufacturer boardproductname boardserialnumber cfkey dhcp_servers domain ec2_ ec2_userdata facterversion filesystems ldom fqdn gid hardwareisa hardwaremodel hostname id|0 interfaces ipaddress ipaddress_ ipaddress6 ipaddress6_ iphostnumber is_virtual kernel kernelmajversion kernelrelease kernelversion kernelrelease kernelversion lsbdistcodename lsbdistdescription lsbdistid lsbdistrelease lsbmajdistrelease lsbminordistrelease lsbrelease macaddress macaddress_ macosx_buildversion macosx_productname macosx_productversion macosx_productverson_major macosx_productversion_minor manufacturer memoryfree memorysize netmask metmask_ network_ operatingsystem operatingsystemmajrelease operatingsystemrelease osfamily partitions path physicalprocessorcount processor processorcount productname ps puppetversion rubysitedir rubyversion selinux selinux_config_mode selinux_config_policy selinux_current_mode selinux_current_mode selinux_enforced selinux_policyversion serialnumber sp_ sshdsakey sshecdsakey sshrsakey swapencrypted swapfree swapsize timezone type uniqueid uptime uptime_days uptime_hours uptime_seconds uuid virtual vlans xendomains zfs_version zonenae zones zpool_version"
    };
    var COMMENT = hljs.COMMENT("#", "$");
    var IDENT_RE = "([A-Za-z_]|::)(\\w|::)*";
    var TITLE = hljs.inherit(hljs.TITLE_MODE, {
        begin: IDENT_RE
    });
    var VARIABLE = {
        className: "variable",
        begin: "\\$" + IDENT_RE
    };
    var STRING = {
        className: "string",
        contains: [
            hljs.BACKSLASH_ESCAPE,
            VARIABLE
        ],
        variants: [
            {
                begin: /'/,
                end: /'/
            },
            {
                begin: /"/,
                end: /"/
            }
        ]
    };
    return {
        aliases: [
            "pp"
        ],
        contains: [
            COMMENT,
            VARIABLE,
            STRING,
            {
                beginKeywords: "class",
                end: "\\{|;",
                illegal: /=/,
                contains: [
                    TITLE,
                    COMMENT
                ]
            },
            {
                beginKeywords: "define",
                end: /\{/,
                contains: [
                    {
                        className: "section",
                        begin: hljs.IDENT_RE,
                        endsParent: true
                    }
                ]
            },
            {
                begin: hljs.IDENT_RE + "\\s+\\{",
                returnBegin: true,
                end: /\S/,
                contains: [
                    {
                        className: "keyword",
                        begin: hljs.IDENT_RE
                    },
                    {
                        begin: /\{/,
                        end: /\}/,
                        keywords: PUPPET_KEYWORDS,
                        relevance: 0,
                        contains: [
                            STRING,
                            COMMENT,
                            {
                                begin: "[a-zA-Z_]+\\s*=>",
                                returnBegin: true,
                                end: "=>",
                                contains: [
                                    {
                                        className: "attr",
                                        begin: hljs.IDENT_RE
                                    }
                                ]
                            },
                            {
                                className: "number",
                                begin: "(\\b0[0-7_]+)|(\\b0x[0-9a-fA-F_]+)|(\\b[1-9][0-9_]*(\\.[0-9_]+)?)|[0_]\\b",
                                relevance: 0
                            },
                            VARIABLE
                        ]
                    }
                ],
                relevance: 0
            }
        ]
    };
};

});

parcelRegister("5JTQt", function(module, exports) {
module.exports = function(hljs) {
    var STRINGS = {
        className: "string",
        begin: '(~)?"',
        end: '"',
        illegal: "\\n"
    };
    var CONSTANTS = {
        //  "#" + a letter or underscore + letters, digits or underscores + (optional) "$"
        className: "symbol",
        begin: "#[a-zA-Z_]\\w*\\$?"
    };
    return {
        aliases: [
            "pb",
            "pbi"
        ],
        keywords: // Keywords from all version of PureBASIC 5.00 upward ...
        "Align And Array As Break CallDebugger Case CompilerCase CompilerDefault CompilerElse CompilerElseIf CompilerEndIf CompilerEndSelect CompilerError CompilerIf CompilerSelect CompilerWarning Continue Data DataSection Debug DebugLevel Declare DeclareC DeclareCDLL DeclareDLL DeclareModule Default Define Dim DisableASM DisableDebugger DisableExplicit Else ElseIf EnableASM EnableDebugger EnableExplicit End EndDataSection EndDeclareModule EndEnumeration EndIf EndImport EndInterface EndMacro EndModule EndProcedure EndSelect EndStructure EndStructureUnion EndWith Enumeration EnumerationBinary Extends FakeReturn For ForEach ForEver Global Gosub Goto If Import ImportC IncludeBinary IncludeFile IncludePath Interface List Macro MacroExpandedCount Map Module NewList NewMap Next Not Or Procedure ProcedureC ProcedureCDLL ProcedureDLL ProcedureReturn Protected Prototype PrototypeC ReDim Read Repeat Restore Return Runtime Select Shared Static Step Structure StructureUnion Swap Threaded To UndefineMacro Until Until  UnuseModule UseModule Wend While With XIncludeFile XOr",
        contains: [
            // COMMENTS | PB IDE color: #00AAAA (Persian Green)
            hljs.COMMENT(";", "$", {
                relevance: 0
            }),
            {
                className: "function",
                begin: "\\b(Procedure|Declare)(C|CDLL|DLL)?\\b",
                end: "\\(",
                excludeEnd: true,
                returnBegin: true,
                contains: [
                    {
                        className: "keyword",
                        begin: "(Procedure|Declare)(C|CDLL|DLL)?",
                        excludeEnd: true
                    },
                    {
                        className: "type",
                        begin: "\\.\\w*"
                    },
                    hljs.UNDERSCORE_TITLE_MODE // PROCEDURE NAME | PB IDE color: #006666 (Blue Stone)
                ]
            },
            STRINGS,
            CONSTANTS
        ]
    };
} /*  ==============================================================================
                                      CHANGELOG
    ==============================================================================
    - v.1.2 (2017-05-12)
        -- BUG-FIX: Some keywords were accidentally joyned together. Now fixed.
    - v.1.1 (2017-04-30)
        -- Updated to PureBASIC 5.60.
        -- Keywords list now built by extracting them from the PureBASIC SDK's
           "SyntaxHilighting.dll" (from each PureBASIC version). Tokens from each
           version are added to the list, and renamed or removed tokens are kept
           for the sake of covering all versions of the language from PureBASIC
           v5.00 upward. (NOTE: currently, there are no renamed or deprecated
           tokens in the keywords list). For more info, see:
           -- http://www.purebasic.fr/english/viewtopic.php?&p=506269
           -- https://github.com/tajmone/purebasic-archives/tree/master/syntax-highlighting/guidelines
    - v.1.0 (April 2016)
        -- First release
        -- Keywords list taken and adapted from GuShH's (Gustavo Julio Fiorenza)
           PureBasic language file for GeSHi:
           -- https://github.com/easybook/geshi/blob/master/geshi/purebasic.php
*/ ;

});

parcelRegister("ly5Ff", function(module, exports) {
module.exports = function(hljs) {
    var KEYWORDS = {
        keyword: "and elif is global as in if from raise for except finally print import pass return exec else break not with class assert yield try while continue del or def lambda async await nonlocal|10",
        built_in: "Ellipsis NotImplemented",
        literal: "False None True"
    };
    var PROMPT = {
        className: "meta",
        begin: /^(>>>|\.\.\.) /
    };
    var SUBST = {
        className: "subst",
        begin: /\{/,
        end: /\}/,
        keywords: KEYWORDS,
        illegal: /#/
    };
    var LITERAL_BRACKET = {
        begin: /\{\{/,
        relevance: 0
    };
    var STRING = {
        className: "string",
        contains: [
            hljs.BACKSLASH_ESCAPE
        ],
        variants: [
            {
                begin: /(u|b)?r?'''/,
                end: /'''/,
                contains: [
                    hljs.BACKSLASH_ESCAPE,
                    PROMPT
                ],
                relevance: 10
            },
            {
                begin: /(u|b)?r?"""/,
                end: /"""/,
                contains: [
                    hljs.BACKSLASH_ESCAPE,
                    PROMPT
                ],
                relevance: 10
            },
            {
                begin: /(fr|rf|f)'''/,
                end: /'''/,
                contains: [
                    hljs.BACKSLASH_ESCAPE,
                    PROMPT,
                    LITERAL_BRACKET,
                    SUBST
                ]
            },
            {
                begin: /(fr|rf|f)"""/,
                end: /"""/,
                contains: [
                    hljs.BACKSLASH_ESCAPE,
                    PROMPT,
                    LITERAL_BRACKET,
                    SUBST
                ]
            },
            {
                begin: /(u|r|ur)'/,
                end: /'/,
                relevance: 10
            },
            {
                begin: /(u|r|ur)"/,
                end: /"/,
                relevance: 10
            },
            {
                begin: /(b|br)'/,
                end: /'/
            },
            {
                begin: /(b|br)"/,
                end: /"/
            },
            {
                begin: /(fr|rf|f)'/,
                end: /'/,
                contains: [
                    hljs.BACKSLASH_ESCAPE,
                    LITERAL_BRACKET,
                    SUBST
                ]
            },
            {
                begin: /(fr|rf|f)"/,
                end: /"/,
                contains: [
                    hljs.BACKSLASH_ESCAPE,
                    LITERAL_BRACKET,
                    SUBST
                ]
            },
            hljs.APOS_STRING_MODE,
            hljs.QUOTE_STRING_MODE
        ]
    };
    var NUMBER = {
        className: "number",
        relevance: 0,
        variants: [
            {
                begin: hljs.BINARY_NUMBER_RE + "[lLjJ]?"
            },
            {
                begin: "\\b(0o[0-7]+)[lLjJ]?"
            },
            {
                begin: hljs.C_NUMBER_RE + "[lLjJ]?"
            }
        ]
    };
    var PARAMS = {
        className: "params",
        begin: /\(/,
        end: /\)/,
        contains: [
            "self",
            PROMPT,
            NUMBER,
            STRING,
            hljs.HASH_COMMENT_MODE
        ]
    };
    SUBST.contains = [
        STRING,
        NUMBER,
        PROMPT
    ];
    return {
        aliases: [
            "py",
            "gyp",
            "ipython"
        ],
        keywords: KEYWORDS,
        illegal: /(<\/|->|\?)|=>/,
        contains: [
            PROMPT,
            NUMBER,
            // eat "if" prior to string so that it won't accidentally be
            // labeled as an f-string as in:
            {
                beginKeywords: "if",
                relevance: 0
            },
            STRING,
            hljs.HASH_COMMENT_MODE,
            {
                variants: [
                    {
                        className: "function",
                        beginKeywords: "def"
                    },
                    {
                        className: "class",
                        beginKeywords: "class"
                    }
                ],
                end: /:/,
                illegal: /[${=;\n,]/,
                contains: [
                    hljs.UNDERSCORE_TITLE_MODE,
                    PARAMS,
                    {
                        begin: /->/,
                        endsWithParent: true,
                        keywords: "None"
                    }
                ]
            },
            {
                className: "meta",
                begin: /^[\t ]*@/,
                end: /$/
            },
            {
                begin: /\b(print|exec)\(/ // don’t highlight keywords-turned-functions in Python 3
            }
        ]
    };
};

});

parcelRegister("bzIMw", function(module, exports) {
module.exports = function(hljs) {
    var Q_KEYWORDS = {
        keyword: "do while select delete by update from",
        literal: "0b 1b",
        built_in: "neg not null string reciprocal floor ceiling signum mod xbar xlog and or each scan over prior mmu lsq inv md5 ltime gtime count first var dev med cov cor all any rand sums prds mins maxs fills deltas ratios avgs differ prev next rank reverse iasc idesc asc desc msum mcount mavg mdev xrank mmin mmax xprev rotate distinct group where flip type key til get value attr cut set upsert raze union inter except cross sv vs sublist enlist read0 read1 hopen hclose hdel hsym hcount peach system ltrim rtrim trim lower upper ssr view tables views cols xcols keys xkey xcol xasc xdesc fkeys meta lj aj aj0 ij pj asof uj ww wj wj1 fby xgroup ungroup ej save load rsave rload show csv parse eval min max avg wavg wsum sin cos tan sum",
        type: "`float `double int `timestamp `timespan `datetime `time `boolean `symbol `char `byte `short `long `real `month `date `minute `second `guid"
    };
    return {
        aliases: [
            "k",
            "kdb"
        ],
        keywords: Q_KEYWORDS,
        lexemes: /(`?)[A-Za-z0-9_]+\b/,
        contains: [
            hljs.C_LINE_COMMENT_MODE,
            hljs.QUOTE_STRING_MODE,
            hljs.C_NUMBER_MODE
        ]
    };
};

});

parcelRegister("6fYUw", function(module, exports) {
module.exports = function(hljs) {
    var KEYWORDS = {
        keyword: "in of on if for while finally var new function do return void else break catch instanceof with throw case default try this switch continue typeof delete let yield const export super debugger as async await import",
        literal: "true false null undefined NaN Infinity",
        built_in: "eval isFinite isNaN parseFloat parseInt decodeURI decodeURIComponent encodeURI encodeURIComponent escape unescape Object Function Boolean Error EvalError InternalError RangeError ReferenceError StopIteration SyntaxError TypeError URIError Number Math Date String RegExp Array Float32Array Float64Array Int16Array Int32Array Int8Array Uint16Array Uint32Array Uint8Array Uint8ClampedArray ArrayBuffer DataView JSON Intl arguments require module console window document Symbol Set Map WeakSet WeakMap Proxy Reflect Behavior bool color coordinate date double enumeration font geocircle georectangle geoshape int list matrix4x4 parent point quaternion real rect size string url variant vector2d vector3d vector4dPromise"
    };
    var QML_IDENT_RE = "[a-zA-Z_][a-zA-Z0-9\\._]*";
    // Isolate property statements. Ends at a :, =, ;, ,, a comment or end of line.
    // Use property class.
    var PROPERTY = {
        className: "keyword",
        begin: "\\bproperty\\b",
        starts: {
            className: "string",
            end: "(:|=|;|,|//|/\\*|$)",
            returnEnd: true
        }
    };
    // Isolate signal statements. Ends at a ) a comment or end of line.
    // Use property class.
    var SIGNAL = {
        className: "keyword",
        begin: "\\bsignal\\b",
        starts: {
            className: "string",
            end: "(\\(|:|=|;|,|//|/\\*|$)",
            returnEnd: true
        }
    };
    // id: is special in QML. When we see id: we want to mark the id: as attribute and
    // emphasize the token following.
    var ID_ID = {
        className: "attribute",
        begin: "\\bid\\s*:",
        starts: {
            className: "string",
            end: QML_IDENT_RE,
            returnEnd: false
        }
    };
    // Find QML object attribute. An attribute is a QML identifier followed by :.
    // Unfortunately it's hard to know where it ends, as it may contain scalars,
    // objects, object definitions, or javascript. The true end is either when the parent
    // ends or the next attribute is detected.
    var QML_ATTRIBUTE = {
        begin: QML_IDENT_RE + "\\s*:",
        returnBegin: true,
        contains: [
            {
                className: "attribute",
                begin: QML_IDENT_RE,
                end: "\\s*:",
                excludeEnd: true,
                relevance: 0
            }
        ],
        relevance: 0
    };
    // Find QML object. A QML object is a QML identifier followed by { and ends at the matching }.
    // All we really care about is finding IDENT followed by { and just mark up the IDENT and ignore the {.
    var QML_OBJECT = {
        begin: QML_IDENT_RE + "\\s*{",
        end: "{",
        returnBegin: true,
        relevance: 0,
        contains: [
            hljs.inherit(hljs.TITLE_MODE, {
                begin: QML_IDENT_RE
            })
        ]
    };
    return {
        aliases: [
            "qt"
        ],
        case_insensitive: false,
        keywords: KEYWORDS,
        contains: [
            {
                className: "meta",
                begin: /^\s*['"]use (strict|asm)['"]/
            },
            hljs.APOS_STRING_MODE,
            hljs.QUOTE_STRING_MODE,
            {
                className: "string",
                begin: "`",
                end: "`",
                contains: [
                    hljs.BACKSLASH_ESCAPE,
                    {
                        className: "subst",
                        begin: "\\$\\{",
                        end: "\\}"
                    }
                ]
            },
            hljs.C_LINE_COMMENT_MODE,
            hljs.C_BLOCK_COMMENT_MODE,
            {
                className: "number",
                variants: [
                    {
                        begin: "\\b(0[bB][01]+)"
                    },
                    {
                        begin: "\\b(0[oO][0-7]+)"
                    },
                    {
                        begin: hljs.C_NUMBER_RE
                    }
                ],
                relevance: 0
            },
            {
                begin: "(" + hljs.RE_STARTERS_RE + "|\\b(case|return|throw)\\b)\\s*",
                keywords: "return throw case",
                contains: [
                    hljs.C_LINE_COMMENT_MODE,
                    hljs.C_BLOCK_COMMENT_MODE,
                    hljs.REGEXP_MODE,
                    {
                        begin: /</,
                        end: />\s*[);\]]/,
                        relevance: 0,
                        subLanguage: "xml"
                    }
                ],
                relevance: 0
            },
            SIGNAL,
            PROPERTY,
            {
                className: "function",
                beginKeywords: "function",
                end: /\{/,
                excludeEnd: true,
                contains: [
                    hljs.inherit(hljs.TITLE_MODE, {
                        begin: /[A-Za-z$_][0-9A-Za-z$_]*/
                    }),
                    {
                        className: "params",
                        begin: /\(/,
                        end: /\)/,
                        excludeBegin: true,
                        excludeEnd: true,
                        contains: [
                            hljs.C_LINE_COMMENT_MODE,
                            hljs.C_BLOCK_COMMENT_MODE
                        ]
                    }
                ],
                illegal: /\[|%/
            },
            {
                begin: "\\." + hljs.IDENT_RE,
                relevance: 0 // hack: prevents detection of keywords after dots
            },
            ID_ID,
            QML_ATTRIBUTE,
            QML_OBJECT
        ],
        illegal: /#/
    };
};

});

parcelRegister("bqL6M", function(module, exports) {
module.exports = function(hljs) {
    var IDENT_RE = "([a-zA-Z]|\\.[a-zA-Z.])[a-zA-Z0-9._]*";
    return {
        contains: [
            hljs.HASH_COMMENT_MODE,
            {
                begin: IDENT_RE,
                lexemes: IDENT_RE,
                keywords: {
                    keyword: "function if in break next repeat else for return switch while try tryCatch stop warning require library attach detach source setMethod setGeneric setGroupGeneric setClass ...",
                    literal: "NULL NA TRUE FALSE T F Inf NaN NA_integer_|10 NA_real_|10 NA_character_|10 NA_complex_|10"
                },
                relevance: 0
            },
            {
                // hex value
                className: "number",
                begin: "0[xX][0-9a-fA-F]+[Li]?\\b",
                relevance: 0
            },
            {
                // explicit integer
                className: "number",
                begin: "\\d+(?:[eE][+\\-]?\\d*)?L\\b",
                relevance: 0
            },
            {
                // number with trailing decimal
                className: "number",
                begin: "\\d+\\.(?!\\d)(?:i\\b)?",
                relevance: 0
            },
            {
                // number
                className: "number",
                begin: "\\d+(?:\\.\\d*)?(?:[eE][+\\-]?\\d*)?i?\\b",
                relevance: 0
            },
            {
                // number with leading decimal
                className: "number",
                begin: "\\.\\d+(?:[eE][+\\-]?\\d*)?i?\\b",
                relevance: 0
            },
            {
                // escaped identifier
                begin: "`",
                end: "`",
                relevance: 0
            },
            {
                className: "string",
                contains: [
                    hljs.BACKSLASH_ESCAPE
                ],
                variants: [
                    {
                        begin: '"',
                        end: '"'
                    },
                    {
                        begin: "'",
                        end: "'"
                    }
                ]
            }
        ]
    };
};

});

parcelRegister("fKypu", function(module, exports) {
module.exports = function(hljs) {
    function orReValues(ops) {
        return ops.map(function(op) {
            return op.split("").map(function(char) {
                return "\\" + char;
            }).join("");
        }).join("|");
    }
    var RE_IDENT = "~?[a-z$_][0-9a-zA-Z$_]*";
    var RE_MODULE_IDENT = "`?[A-Z$_][0-9a-zA-Z$_]*";
    var RE_PARAM_TYPEPARAM = "'?[a-z$_][0-9a-z$_]*";
    var RE_PARAM_TYPE = "s*:s*[a-z$_][0-9a-z$_]*((s*(" + RE_PARAM_TYPEPARAM + "s*(," + RE_PARAM_TYPEPARAM + ")*)?s*))?";
    var RE_PARAM = RE_IDENT + "(" + RE_PARAM_TYPE + ")?(" + RE_PARAM_TYPE + ")?";
    var RE_OPERATOR = "(" + orReValues([
        "||",
        "&&",
        "++",
        "**",
        "+.",
        "*",
        "/",
        "*.",
        "/.",
        "...",
        "|>"
    ]) + "|==|===)";
    var RE_OPERATOR_SPACED = "\\s+" + RE_OPERATOR + "\\s+";
    var KEYWORDS = {
        keyword: "and as asr assert begin class constraint do done downto else end exception externalfor fun function functor if in include inherit initializerland lazy let lor lsl lsr lxor match method mod module mutable new nonrecobject of open or private rec sig struct then to try type val virtual when while with",
        built_in: "array bool bytes char exn|5 float int int32 int64 list lazy_t|5 nativeint|5 ref string unit ",
        literal: "true false"
    };
    var RE_NUMBER = "\\b(0[xX][a-fA-F0-9_]+[Lln]?|0[oO][0-7_]+[Lln]?|0[bB][01_]+[Lln]?|[0-9][0-9_]*([Lln]|(\\.[0-9_]*)?([eE][-+]?[0-9_]+)?)?)";
    var NUMBER_MODE = {
        className: "number",
        relevance: 0,
        variants: [
            {
                begin: RE_NUMBER
            },
            {
                begin: "\\(\\-" + RE_NUMBER + "\\)"
            }
        ]
    };
    var OPERATOR_MODE = {
        className: "operator",
        relevance: 0,
        begin: RE_OPERATOR
    };
    var LIST_CONTENTS_MODES = [
        {
            className: "identifier",
            relevance: 0,
            begin: RE_IDENT
        },
        OPERATOR_MODE,
        NUMBER_MODE
    ];
    var MODULE_ACCESS_CONTENTS = [
        hljs.QUOTE_STRING_MODE,
        OPERATOR_MODE,
        {
            className: "module",
            begin: "\\b" + RE_MODULE_IDENT,
            returnBegin: true,
            end: ".",
            contains: [
                {
                    className: "identifier",
                    begin: RE_MODULE_IDENT,
                    relevance: 0
                }
            ]
        }
    ];
    var PARAMS_CONTENTS = [
        {
            className: "module",
            begin: "\\b" + RE_MODULE_IDENT,
            returnBegin: true,
            end: ".",
            relevance: 0,
            contains: [
                {
                    className: "identifier",
                    begin: RE_MODULE_IDENT,
                    relevance: 0
                }
            ]
        }
    ];
    var PARAMS_MODE = {
        begin: RE_IDENT,
        end: "(,|\\n|\\))",
        relevance: 0,
        contains: [
            OPERATOR_MODE,
            {
                className: "typing",
                begin: ":",
                end: "(,|\\n)",
                returnBegin: true,
                relevance: 0,
                contains: PARAMS_CONTENTS
            }
        ]
    };
    var FUNCTION_BLOCK_MODE = {
        className: "function",
        relevance: 0,
        keywords: KEYWORDS,
        variants: [
            {
                begin: "\\s(\\(\\.?.*?\\)|" + RE_IDENT + ")\\s*=>",
                end: "\\s*=>",
                returnBegin: true,
                relevance: 0,
                contains: [
                    {
                        className: "params",
                        variants: [
                            {
                                begin: RE_IDENT
                            },
                            {
                                begin: RE_PARAM
                            },
                            {
                                begin: /\(\s*\)/
                            }
                        ]
                    }
                ]
            },
            {
                begin: "\\s\\(\\.?[^;\\|]*\\)\\s*=>",
                end: "\\s=>",
                returnBegin: true,
                relevance: 0,
                contains: [
                    {
                        className: "params",
                        relevance: 0,
                        variants: [
                            PARAMS_MODE
                        ]
                    }
                ]
            },
            {
                begin: "\\(\\.\\s" + RE_IDENT + "\\)\\s*=>"
            }
        ]
    };
    MODULE_ACCESS_CONTENTS.push(FUNCTION_BLOCK_MODE);
    var CONSTRUCTOR_MODE = {
        className: "constructor",
        begin: RE_MODULE_IDENT + "\\(",
        end: "\\)",
        illegal: "\\n",
        keywords: KEYWORDS,
        contains: [
            hljs.QUOTE_STRING_MODE,
            OPERATOR_MODE,
            {
                className: "params",
                begin: "\\b" + RE_IDENT
            }
        ]
    };
    var PATTERN_MATCH_BLOCK_MODE = {
        className: "pattern-match",
        begin: "\\|",
        returnBegin: true,
        keywords: KEYWORDS,
        end: "=>",
        relevance: 0,
        contains: [
            CONSTRUCTOR_MODE,
            OPERATOR_MODE,
            {
                relevance: 0,
                className: "constructor",
                begin: RE_MODULE_IDENT
            }
        ]
    };
    var MODULE_ACCESS_MODE = {
        className: "module-access",
        keywords: KEYWORDS,
        returnBegin: true,
        variants: [
            {
                begin: "\\b(" + RE_MODULE_IDENT + "\\.)+" + RE_IDENT
            },
            {
                begin: "\\b(" + RE_MODULE_IDENT + "\\.)+\\(",
                end: "\\)",
                returnBegin: true,
                contains: [
                    FUNCTION_BLOCK_MODE,
                    {
                        begin: "\\(",
                        end: "\\)",
                        skip: true
                    }
                ].concat(MODULE_ACCESS_CONTENTS)
            },
            {
                begin: "\\b(" + RE_MODULE_IDENT + "\\.)+{",
                end: "}"
            }
        ],
        contains: MODULE_ACCESS_CONTENTS
    };
    PARAMS_CONTENTS.push(MODULE_ACCESS_MODE);
    return {
        aliases: [
            "re"
        ],
        keywords: KEYWORDS,
        illegal: "(:\\-|:=|\\${|\\+=)",
        contains: [
            hljs.COMMENT("/\\*", "\\*/", {
                illegal: "^(\\#,\\/\\/)"
            }),
            {
                className: "character",
                begin: "'(\\\\[^']+|[^'])'",
                illegal: "\\n",
                relevance: 0
            },
            hljs.QUOTE_STRING_MODE,
            {
                className: "literal",
                begin: "\\(\\)",
                relevance: 0
            },
            {
                className: "literal",
                begin: "\\[\\|",
                end: "\\|\\]",
                relevance: 0,
                contains: LIST_CONTENTS_MODES
            },
            {
                className: "literal",
                begin: "\\[",
                end: "\\]",
                relevance: 0,
                contains: LIST_CONTENTS_MODES
            },
            CONSTRUCTOR_MODE,
            {
                className: "operator",
                begin: RE_OPERATOR_SPACED,
                illegal: "\\-\\->",
                relevance: 0
            },
            NUMBER_MODE,
            hljs.C_LINE_COMMENT_MODE,
            PATTERN_MATCH_BLOCK_MODE,
            FUNCTION_BLOCK_MODE,
            {
                className: "module-def",
                begin: "\\bmodule\\s+" + RE_IDENT + "\\s+" + RE_MODULE_IDENT + "\\s+=\\s+{",
                end: "}",
                returnBegin: true,
                keywords: KEYWORDS,
                relevance: 0,
                contains: [
                    {
                        className: "module",
                        relevance: 0,
                        begin: RE_MODULE_IDENT
                    },
                    {
                        begin: "{",
                        end: "}",
                        skip: true
                    }
                ].concat(MODULE_ACCESS_CONTENTS)
            },
            MODULE_ACCESS_MODE
        ]
    };
};

});

parcelRegister("f88HE", function(module, exports) {
module.exports = function(hljs) {
    return {
        keywords: "ArchiveRecord AreaLightSource Atmosphere Attribute AttributeBegin AttributeEnd Basis Begin Blobby Bound Clipping ClippingPlane Color ColorSamples ConcatTransform Cone CoordinateSystem CoordSysTransform CropWindow Curves Cylinder DepthOfField Detail DetailRange Disk Displacement Display End ErrorHandler Exposure Exterior Format FrameAspectRatio FrameBegin FrameEnd GeneralPolygon GeometricApproximation Geometry Hider Hyperboloid Identity Illuminate Imager Interior LightSource MakeCubeFaceEnvironment MakeLatLongEnvironment MakeShadow MakeTexture Matte MotionBegin MotionEnd NuPatch ObjectBegin ObjectEnd ObjectInstance Opacity Option Orientation Paraboloid Patch PatchMesh Perspective PixelFilter PixelSamples PixelVariance Points PointsGeneralPolygons PointsPolygons Polygon Procedural Projection Quantize ReadArchive RelativeDetail ReverseOrientation Rotate Scale ScreenWindow ShadingInterpolation ShadingRate Shutter Sides Skew SolidBegin SolidEnd Sphere SubdivisionMesh Surface TextureCoordinates Torus Transform TransformBegin TransformEnd TransformPoints Translate TrimCurve WorldBegin WorldEnd",
        illegal: "</",
        contains: [
            hljs.HASH_COMMENT_MODE,
            hljs.C_NUMBER_MODE,
            hljs.APOS_STRING_MODE,
            hljs.QUOTE_STRING_MODE
        ]
    };
};

});

parcelRegister("gbKHl", function(module, exports) {
module.exports = function(hljs) {
    var IDENTIFIER = "[a-zA-Z-_][^\\n{]+\\{";
    var PROPERTY = {
        className: "attribute",
        begin: /[a-zA-Z-_]+/,
        end: /\s*:/,
        excludeEnd: true,
        starts: {
            end: ";",
            relevance: 0,
            contains: [
                {
                    className: "variable",
                    begin: /\.[a-zA-Z-_]+/
                },
                {
                    className: "keyword",
                    begin: /\(optional\)/
                }
            ]
        }
    };
    return {
        aliases: [
            "graph",
            "instances"
        ],
        case_insensitive: true,
        keywords: "import",
        contains: [
            // Facet sections
            {
                begin: "^facet " + IDENTIFIER,
                end: "}",
                keywords: "facet",
                contains: [
                    PROPERTY,
                    hljs.HASH_COMMENT_MODE
                ]
            },
            // Instance sections
            {
                begin: "^\\s*instance of " + IDENTIFIER,
                end: "}",
                keywords: "name count channels instance-data instance-state instance of",
                illegal: /\S/,
                contains: [
                    "self",
                    PROPERTY,
                    hljs.HASH_COMMENT_MODE
                ]
            },
            // Component sections
            {
                begin: "^" + IDENTIFIER,
                end: "}",
                contains: [
                    PROPERTY,
                    hljs.HASH_COMMENT_MODE
                ]
            },
            // Comments
            hljs.HASH_COMMENT_MODE
        ]
    };
};

});

parcelRegister("iQUn5", function(module, exports) {
module.exports = //   green        - #0E9A00
//   teal         - #0C9A9A
//   purple       - #99069A
//   light-brown  - #9A9900
function(hljs) {
    var STATEMENTS = "foreach do while for if from to step else on-error and or not in";
    // Global commands: Every global command should start with ":" token, otherwise it will be treated as variable.
    var GLOBAL_COMMANDS = "global local beep delay put len typeof pick log time set find environment terminal error execute parse resolve toarray tobool toid toip toip6 tonum tostr totime";
    // Common commands: Following commands available from most sub-menus:
    var COMMON_COMMANDS = "add remove enable disable set get print export edit find run debug error info warning";
    var LITERALS = "true false yes no nothing nil null";
    var OBJECTS = "traffic-flow traffic-generator firewall scheduler aaa accounting address-list address align area bandwidth-server bfd bgp bridge client clock community config connection console customer default dhcp-client dhcp-server discovery dns e-mail ethernet filter firewall firmware gps graphing group hardware health hotspot identity igmp-proxy incoming instance interface ip ipsec ipv6 irq l2tp-server lcd ldp logging mac-server mac-winbox mangle manual mirror mme mpls nat nd neighbor network note ntp ospf ospf-v3 ovpn-server page peer pim ping policy pool port ppp pppoe-client pptp-server prefix profile proposal proxy queue radius resource rip ripng route routing screen script security-profiles server service service-port settings shares smb sms sniffer snmp snooper socks sstp-server system tool tracking type upgrade upnp user-manager users user vlan secret vrrp watchdog web-access wireless pptp pppoe lan wan layer7-protocol lease simple raw";
    // print parameters
    // Several parameters are available for print command:
    // ToDo: var PARAMETERS_PRINT = 'append as-value brief detail count-only file follow follow-only from interval terse value-list without-paging where info';
    // ToDo: var OPERATORS = '&& and ! not || or in ~ ^ & << >> + - * /';
    // ToDo: var TYPES = 'num number bool boolean str string ip ip6-prefix id time array';
    // ToDo: The following tokens serve as delimiters in the grammar: ()  []  {}  :   ;   $   /
    var VAR_PREFIX = "global local set for foreach";
    var VAR = {
        className: "variable",
        variants: [
            {
                begin: /\$[\w\d#@][\w\d_]*/
            },
            {
                begin: /\$\{(.*?)}/
            }
        ]
    };
    var QUOTE_STRING = {
        className: "string",
        begin: /"/,
        end: /"/,
        contains: [
            hljs.BACKSLASH_ESCAPE,
            VAR,
            {
                className: "variable",
                begin: /\$\(/,
                end: /\)/,
                contains: [
                    hljs.BACKSLASH_ESCAPE
                ]
            }
        ]
    };
    var APOS_STRING = {
        className: "string",
        begin: /'/,
        end: /'/
    };
    var IPADDR = "((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]).){3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\\b";
    var IPADDR_wBITMASK = IPADDR + "/(3[0-2]|[1-2][0-9]|\\d)";
    //////////////////////////////////////////////////////////////////////
    return {
        aliases: [
            "routeros",
            "mikrotik"
        ],
        case_insensitive: true,
        lexemes: /:?[\w-]+/,
        keywords: {
            literal: LITERALS,
            keyword: STATEMENTS + " :" + STATEMENTS.split(" ").join(" :") + " :" + GLOBAL_COMMANDS.split(" ").join(" :")
        },
        contains: [
            {
                variants: [
                    {
                        begin: /^@/,
                        end: /$/
                    },
                    {
                        begin: /\/\*/,
                        end: /\*\//
                    },
                    {
                        begin: /%%/,
                        end: /$/
                    },
                    {
                        begin: /^'/,
                        end: /$/
                    },
                    {
                        begin: /^\s*\/[\w-]+=/,
                        end: /$/
                    },
                    {
                        begin: /\/\//,
                        end: /$/
                    },
                    {
                        begin: /^\[\</,
                        end: /\>\]$/
                    },
                    {
                        begin: /<\//,
                        end: />/
                    },
                    {
                        begin: /^facet /,
                        end: /\}/
                    },
                    {
                        begin: "^1\\.\\.(\\d+)$",
                        end: /$/
                    }
                ],
                illegal: /./
            },
            hljs.COMMENT("^#", "$"),
            QUOTE_STRING,
            APOS_STRING,
            VAR,
            {
                begin: /[\w-]+\=([^\s\{\}\[\]\(\)]+)/,
                relevance: 0,
                returnBegin: true,
                contains: [
                    {
                        className: "attribute",
                        begin: /[^=]+/
                    },
                    {
                        begin: /=/,
                        endsWithParent: true,
                        relevance: 0,
                        contains: [
                            QUOTE_STRING,
                            APOS_STRING,
                            VAR,
                            {
                                className: "literal",
                                begin: "\\b(" + LITERALS.split(" ").join("|") + ")\\b"
                            },
                            /*{
                // IPv4 addresses and subnets
                className: 'number',
                variants: [
                  {begin: IPADDR_wBITMASK+'(,'+IPADDR_wBITMASK+')*'}, //192.168.0.0/24,1.2.3.0/24
                  {begin: IPADDR+'-'+IPADDR},       // 192.168.0.1-192.168.0.3
                  {begin: IPADDR+'(,'+IPADDR+')*'}, // 192.168.0.1,192.168.0.34,192.168.24.1,192.168.0.1
                ]
              }, // */ /*{
                // MAC addresses and DHCP Client IDs
                className: 'number',
                begin: /\b(1:)?([0-9A-Fa-f]{1,2}[:-]){5}([0-9A-Fa-f]){1,2}\b/,
              }, //*/ {
                                // Не форматировать не классифицированные значения. Необходимо для исключения подсветки значений как built_in.
                                // className: 'number',
                                begin: /("[^"]*"|[^\s\{\}\[\]]+)/
                            }
                        ]
                    } //*/
                ]
            },
            {
                // HEX values
                className: "number",
                begin: /\*[0-9a-fA-F]+/
            },
            {
                begin: "\\b(" + COMMON_COMMANDS.split(" ").join("|") + ")([\\s[(]|])",
                returnBegin: true,
                contains: [
                    {
                        className: "builtin-name",
                        begin: /\w+/
                    }
                ]
            },
            {
                className: "built_in",
                variants: [
                    {
                        begin: "(\\.\\./|/|\\s)((" + OBJECTS.split(" ").join("|") + ");?\\s)+",
                        relevance: 10
                    },
                    {
                        begin: /\.\./
                    }
                ]
            }
        ]
    };
};

});

parcelRegister("2mZxq", function(module, exports) {
module.exports = function(hljs) {
    return {
        keywords: {
            keyword: "float color point normal vector matrix while for if do return else break extern continue",
            built_in: "abs acos ambient area asin atan atmosphere attribute calculatenormal ceil cellnoise clamp comp concat cos degrees depth Deriv diffuse distance Du Dv environment exp faceforward filterstep floor format fresnel incident length lightsource log match max min mod noise normalize ntransform opposite option phong pnoise pow printf ptlined radians random reflect refract renderinfo round setcomp setxcomp setycomp setzcomp shadow sign sin smoothstep specular specularbrdf spline sqrt step tan texture textureinfo trace transform vtransform xcomp ycomp zcomp"
        },
        illegal: "</",
        contains: [
            hljs.C_LINE_COMMENT_MODE,
            hljs.C_BLOCK_COMMENT_MODE,
            hljs.QUOTE_STRING_MODE,
            hljs.APOS_STRING_MODE,
            hljs.C_NUMBER_MODE,
            {
                className: "meta",
                begin: "#",
                end: "$"
            },
            {
                className: "class",
                beginKeywords: "surface displacement light volume imager",
                end: "\\("
            },
            {
                beginKeywords: "illuminate illuminance gather",
                end: "\\("
            }
        ]
    };
};

});

parcelRegister("gfBOr", function(module, exports) {
module.exports = function(hljs) {
    return {
        keywords: {
            keyword: "BILL_PERIOD BILL_START BILL_STOP RS_EFFECTIVE_START RS_EFFECTIVE_STOP RS_JURIS_CODE RS_OPCO_CODE INTDADDATTRIBUTE|5 INTDADDVMSG|5 INTDBLOCKOP|5 INTDBLOCKOPNA|5 INTDCLOSE|5 INTDCOUNT|5 INTDCOUNTSTATUSCODE|5 INTDCREATEMASK|5 INTDCREATEDAYMASK|5 INTDCREATEFACTORMASK|5 INTDCREATEHANDLE|5 INTDCREATEOVERRIDEDAYMASK|5 INTDCREATEOVERRIDEMASK|5 INTDCREATESTATUSCODEMASK|5 INTDCREATETOUPERIOD|5 INTDDELETE|5 INTDDIPTEST|5 INTDEXPORT|5 INTDGETERRORCODE|5 INTDGETERRORMESSAGE|5 INTDISEQUAL|5 INTDJOIN|5 INTDLOAD|5 INTDLOADACTUALCUT|5 INTDLOADDATES|5 INTDLOADHIST|5 INTDLOADLIST|5 INTDLOADLISTDATES|5 INTDLOADLISTENERGY|5 INTDLOADLISTHIST|5 INTDLOADRELATEDCHANNEL|5 INTDLOADSP|5 INTDLOADSTAGING|5 INTDLOADUOM|5 INTDLOADUOMDATES|5 INTDLOADUOMHIST|5 INTDLOADVERSION|5 INTDOPEN|5 INTDREADFIRST|5 INTDREADNEXT|5 INTDRECCOUNT|5 INTDRELEASE|5 INTDREPLACE|5 INTDROLLAVG|5 INTDROLLPEAK|5 INTDSCALAROP|5 INTDSCALE|5 INTDSETATTRIBUTE|5 INTDSETDSTPARTICIPANT|5 INTDSETSTRING|5 INTDSETVALUE|5 INTDSETVALUESTATUS|5 INTDSHIFTSTARTTIME|5 INTDSMOOTH|5 INTDSORT|5 INTDSPIKETEST|5 INTDSUBSET|5 INTDTOU|5 INTDTOURELEASE|5 INTDTOUVALUE|5 INTDUPDATESTATS|5 INTDVALUE|5 STDEV INTDDELETEEX|5 INTDLOADEXACTUAL|5 INTDLOADEXCUT|5 INTDLOADEXDATES|5 INTDLOADEX|5 INTDLOADEXRELATEDCHANNEL|5 INTDSAVEEX|5 MVLOAD|5 MVLOADACCT|5 MVLOADACCTDATES|5 MVLOADACCTHIST|5 MVLOADDATES|5 MVLOADHIST|5 MVLOADLIST|5 MVLOADLISTDATES|5 MVLOADLISTHIST|5 IF FOR NEXT DONE SELECT END CALL ABORT CLEAR CHANNEL FACTOR LIST NUMBER OVERRIDE SET WEEK DISTRIBUTIONNODE ELSE WHEN THEN OTHERWISE IENUM CSV INCLUDE LEAVE RIDER SAVE DELETE NOVALUE SECTION WARN SAVE_UPDATE DETERMINANT LABEL REPORT REVENUE EACH IN FROM TOTAL CHARGE BLOCK AND OR CSV_FILE RATE_CODE AUXILIARY_DEMAND UIDACCOUNT RS BILL_PERIOD_SELECT HOURS_PER_MONTH INTD_ERROR_STOP SEASON_SCHEDULE_NAME ACCOUNTFACTOR ARRAYUPPERBOUND CALLSTOREDPROC GETADOCONNECTION GETCONNECT GETDATASOURCE GETQUALIFIER GETUSERID HASVALUE LISTCOUNT LISTOP LISTUPDATE LISTVALUE PRORATEFACTOR RSPRORATE SETBINPATH SETDBMONITOR WQ_OPEN BILLINGHOURS DATE DATEFROMFLOAT DATETIMEFROMSTRING DATETIMETOSTRING DATETOFLOAT DAY DAYDIFF DAYNAME DBDATETIME HOUR MINUTE MONTH MONTHDIFF MONTHHOURS MONTHNAME ROUNDDATE SAMEWEEKDAYLASTYEAR SECOND WEEKDAY WEEKDIFF YEAR YEARDAY YEARSTR COMPSUM HISTCOUNT HISTMAX HISTMIN HISTMINNZ HISTVALUE MAXNRANGE MAXRANGE MINRANGE COMPIKVA COMPKVA COMPKVARFROMKQKW COMPLF IDATTR FLAG LF2KW LF2KWH MAXKW POWERFACTOR READING2USAGE AVGSEASON MAXSEASON MONTHLYMERGE SEASONVALUE SUMSEASON ACCTREADDATES ACCTTABLELOAD CONFIGADD CONFIGGET CREATEOBJECT CREATEREPORT EMAILCLIENT EXPBLKMDMUSAGE EXPMDMUSAGE EXPORT_USAGE FACTORINEFFECT GETUSERSPECIFIEDSTOP INEFFECT ISHOLIDAY RUNRATE SAVE_PROFILE SETREPORTTITLE USEREXIT WATFORRUNRATE TO TABLE ACOS ASIN ATAN ATAN2 BITAND CEIL COS COSECANT COSH COTANGENT DIVQUOT DIVREM EXP FABS FLOOR FMOD FREPM FREXPN LOG LOG10 MAX MAXN MIN MINNZ MODF POW ROUND ROUND2VALUE ROUNDINT SECANT SIN SINH SQROOT TAN TANH FLOAT2STRING FLOAT2STRINGNC INSTR LEFT LEN LTRIM MID RIGHT RTRIM STRING STRINGNC TOLOWER TOUPPER TRIM NUMDAYS READ_DATE STAGING",
            built_in: "IDENTIFIER OPTIONS XML_ELEMENT XML_OP XML_ELEMENT_OF DOMDOCCREATE DOMDOCLOADFILE DOMDOCLOADXML DOMDOCSAVEFILE DOMDOCGETROOT DOMDOCADDPI DOMNODEGETNAME DOMNODEGETTYPE DOMNODEGETVALUE DOMNODEGETCHILDCT DOMNODEGETFIRSTCHILD DOMNODEGETSIBLING DOMNODECREATECHILDELEMENT DOMNODESETATTRIBUTE DOMNODEGETCHILDELEMENTCT DOMNODEGETFIRSTCHILDELEMENT DOMNODEGETSIBLINGELEMENT DOMNODEGETATTRIBUTECT DOMNODEGETATTRIBUTEI DOMNODEGETATTRIBUTEBYNAME DOMNODEGETBYNAME"
        },
        contains: [
            hljs.C_LINE_COMMENT_MODE,
            hljs.C_BLOCK_COMMENT_MODE,
            hljs.APOS_STRING_MODE,
            hljs.QUOTE_STRING_MODE,
            hljs.C_NUMBER_MODE,
            {
                className: "literal",
                variants: [
                    {
                        begin: "#\\s+[a-zA-Z\\ \\.]*",
                        relevance: 0
                    },
                    {
                        begin: "#[a-zA-Z\\ \\.]+"
                    }
                ]
            }
        ]
    };
};

});

parcelRegister("bfORy", function(module, exports) {
module.exports = function(hljs) {
    var NUM_SUFFIX = "([ui](8|16|32|64|128|size)|f(32|64))?";
    var KEYWORDS = "abstract as async await become box break const continue crate do dyn else enum extern false final fn for if impl in let loop macro match mod move mut override priv pub ref return self Self static struct super trait true try type typeof unsafe unsized use virtual where while yield";
    var BUILTINS = // functions
    "drop i8 i16 i32 i64 i128 isize u8 u16 u32 u64 u128 usize f32 f64 str char bool Box Option Result String Vec Copy Send Sized Sync Drop Fn FnMut FnOnce ToOwned Clone Debug PartialEq PartialOrd Eq Ord AsRef AsMut Into From Default Iterator Extend IntoIterator DoubleEndedIterator ExactSizeIterator SliceConcatExt ToString assert! assert_eq! bitflags! bytes! cfg! col! concat! concat_idents! debug_assert! debug_assert_eq! env! panic! file! format! format_args! include_bin! include_str! line! local_data_key! module_path! option_env! print! println! select! stringify! try! unimplemented! unreachable! vec! write! writeln! macro_rules! assert_ne! debug_assert_ne!";
    return {
        aliases: [
            "rs"
        ],
        keywords: {
            keyword: KEYWORDS,
            literal: "true false Some None Ok Err",
            built_in: BUILTINS
        },
        lexemes: hljs.IDENT_RE + "!?",
        illegal: "</",
        contains: [
            hljs.C_LINE_COMMENT_MODE,
            hljs.COMMENT("/\\*", "\\*/", {
                contains: [
                    "self"
                ]
            }),
            hljs.inherit(hljs.QUOTE_STRING_MODE, {
                begin: /b?"/,
                illegal: null
            }),
            {
                className: "string",
                variants: [
                    {
                        begin: /r(#*)"(.|\n)*?"\1(?!#)/
                    },
                    {
                        begin: /b?'\\?(x\w{2}|u\w{4}|U\w{8}|.)'/
                    }
                ]
            },
            {
                className: "symbol",
                begin: /'[a-zA-Z_][a-zA-Z0-9_]*/
            },
            {
                className: "number",
                variants: [
                    {
                        begin: "\\b0b([01_]+)" + NUM_SUFFIX
                    },
                    {
                        begin: "\\b0o([0-7_]+)" + NUM_SUFFIX
                    },
                    {
                        begin: "\\b0x([A-Fa-f0-9_]+)" + NUM_SUFFIX
                    },
                    {
                        begin: "\\b(\\d[\\d_]*(\\.[0-9_]+)?([eE][+-]?[0-9_]+)?)" + NUM_SUFFIX
                    }
                ],
                relevance: 0
            },
            {
                className: "function",
                beginKeywords: "fn",
                end: "(\\(|<)",
                excludeEnd: true,
                contains: [
                    hljs.UNDERSCORE_TITLE_MODE
                ]
            },
            {
                className: "meta",
                begin: "#\\!?\\[",
                end: "\\]",
                contains: [
                    {
                        className: "meta-string",
                        begin: /"/,
                        end: /"/
                    }
                ]
            },
            {
                className: "class",
                beginKeywords: "type",
                end: ";",
                contains: [
                    hljs.inherit(hljs.UNDERSCORE_TITLE_MODE, {
                        endsParent: true
                    })
                ],
                illegal: "\\S"
            },
            {
                className: "class",
                beginKeywords: "trait enum struct union",
                end: "{",
                contains: [
                    hljs.inherit(hljs.UNDERSCORE_TITLE_MODE, {
                        endsParent: true
                    })
                ],
                illegal: "[\\w\\d]"
            },
            {
                begin: hljs.IDENT_RE + "::",
                keywords: {
                    built_in: BUILTINS
                }
            },
            {
                begin: "->"
            }
        ]
    };
};

});

parcelRegister("2bWJg", function(module, exports) {
module.exports = function(hljs) {
    // Data step and PROC SQL statements
    var SAS_KEYWORDS = "do if then else end until while abort array attrib by call cards cards4 catname continue datalines datalines4 delete delim delimiter display dm drop endsas error file filename footnote format goto in infile informat input keep label leave length libname link list lostcard merge missing modify options output out page put redirect remove rename replace retain return select set skip startsas stop title update waitsas where window x systask add and alter as cascade check create delete describe distinct drop foreign from group having index insert into in key like message modify msgtype not null on or order primary references reset restrict select set table unique update validate view where";
    // Built-in SAS functions
    var SAS_FUN = "abs|addr|airy|arcos|arsin|atan|attrc|attrn|band|betainv|blshift|bnot|bor|brshift|bxor|byte|cdf|ceil|cexist|cinv|close|cnonct|collate|compbl|compound|compress|cos|cosh|css|curobs|cv|daccdb|daccdbsl|daccsl|daccsyd|dacctab|dairy|date|datejul|datepart|datetime|day|dclose|depdb|depdbsl|depdbsl|depsl|depsl|depsyd|depsyd|deptab|deptab|dequote|dhms|dif|digamma|dim|dinfo|dnum|dopen|doptname|doptnum|dread|dropnote|dsname|erf|erfc|exist|exp|fappend|fclose|fcol|fdelete|fetch|fetchobs|fexist|fget|fileexist|filename|fileref|finfo|finv|fipname|fipnamel|fipstate|floor|fnonct|fnote|fopen|foptname|foptnum|fpoint|fpos|fput|fread|frewind|frlen|fsep|fuzz|fwrite|gaminv|gamma|getoption|getvarc|getvarn|hbound|hms|hosthelp|hour|ibessel|index|indexc|indexw|input|inputc|inputn|int|intck|intnx|intrr|irr|jbessel|juldate|kurtosis|lag|lbound|left|length|lgamma|libname|libref|log|log10|log2|logpdf|logpmf|logsdf|lowcase|max|mdy|mean|min|minute|mod|month|mopen|mort|n|netpv|nmiss|normal|note|npv|open|ordinal|pathname|pdf|peek|peekc|pmf|point|poisson|poke|probbeta|probbnml|probchi|probf|probgam|probhypr|probit|probnegb|probnorm|probt|put|putc|putn|qtr|quote|ranbin|rancau|ranexp|rangam|range|rank|rannor|ranpoi|rantbl|rantri|ranuni|repeat|resolve|reverse|rewind|right|round|saving|scan|sdf|second|sign|sin|sinh|skewness|soundex|spedis|sqrt|std|stderr|stfips|stname|stnamel|substr|sum|symget|sysget|sysmsg|sysprod|sysrc|system|tan|tanh|time|timepart|tinv|tnonct|today|translate|tranwrd|trigamma|trim|trimn|trunc|uniform|upcase|uss|var|varfmt|varinfmt|varlabel|varlen|varname|varnum|varray|varrayx|vartype|verify|vformat|vformatd|vformatdx|vformatn|vformatnx|vformatw|vformatwx|vformatx|vinarray|vinarrayx|vinformat|vinformatd|vinformatdx|vinformatn|vinformatnx|vinformatw|vinformatwx|vinformatx|vlabel|vlabelx|vlength|vlengthx|vname|vnamex|vtype|vtypex|weekday|year|yyq|zipfips|zipname|zipnamel|zipstate";
    // Built-in macro functions
    var SAS_MACRO_FUN = "bquote|nrbquote|cmpres|qcmpres|compstor|datatyp|display|do|else|end|eval|global|goto|if|index|input|keydef|label|left|length|let|local|lowcase|macro|mend|nrbquote|nrquote|nrstr|put|qcmpres|qleft|qlowcase|qscan|qsubstr|qsysfunc|qtrim|quote|qupcase|scan|str|substr|superq|syscall|sysevalf|sysexec|sysfunc|sysget|syslput|sysprod|sysrc|sysrput|then|to|trim|unquote|until|upcase|verify|while|window";
    return {
        aliases: [
            "sas",
            "SAS"
        ],
        case_insensitive: true,
        keywords: {
            literal: "null missing _all_ _automatic_ _character_ _infile_ _n_ _name_ _null_ _numeric_ _user_ _webout_",
            meta: SAS_KEYWORDS
        },
        contains: [
            {
                // Distinct highlight for proc <proc>, data, run, quit
                className: "keyword",
                begin: /^\s*(proc [\w\d_]+|data|run|quit)[\s\;]/
            },
            {
                // Macro variables
                className: "variable",
                begin: /\&[a-zA-Z_\&][a-zA-Z0-9_]*\.?/
            },
            {
                // Special emphasis for datalines|cards
                className: "emphasis",
                begin: /^\s*datalines|cards.*;/,
                end: /^\s*;\s*$/
            },
            {
                className: "built_in",
                begin: "%(" + SAS_MACRO_FUN + ")"
            },
            {
                // User-defined macro functions highlighted after
                className: "name",
                begin: /%[a-zA-Z_][a-zA-Z_0-9]*/
            },
            {
                className: "meta",
                begin: "[^%](" + SAS_FUN + ")[(]"
            },
            {
                className: "string",
                variants: [
                    hljs.APOS_STRING_MODE,
                    hljs.QUOTE_STRING_MODE
                ]
            },
            hljs.COMMENT("\\*", ";"),
            hljs.C_BLOCK_COMMENT_MODE
        ]
    };
};

});

parcelRegister("gJPco", function(module, exports) {
module.exports = function(hljs) {
    var ANNOTATION = {
        className: "meta",
        begin: "@[A-Za-z]+"
    };
    // used in strings for escaping/interpolation/substitution
    var SUBST = {
        className: "subst",
        variants: [
            {
                begin: "\\$[A-Za-z0-9_]+"
            },
            {
                begin: "\\${",
                end: "}"
            }
        ]
    };
    var STRING = {
        className: "string",
        variants: [
            {
                begin: '"',
                end: '"',
                illegal: "\\n",
                contains: [
                    hljs.BACKSLASH_ESCAPE
                ]
            },
            {
                begin: '"""',
                end: '"""',
                relevance: 10
            },
            {
                begin: '[a-z]+"',
                end: '"',
                illegal: "\\n",
                contains: [
                    hljs.BACKSLASH_ESCAPE,
                    SUBST
                ]
            },
            {
                className: "string",
                begin: '[a-z]+"""',
                end: '"""',
                contains: [
                    SUBST
                ],
                relevance: 10
            }
        ]
    };
    var SYMBOL = {
        className: "symbol",
        begin: "'\\w[\\w\\d_]*(?!')"
    };
    var TYPE = {
        className: "type",
        begin: "\\b[A-Z][A-Za-z0-9_]*",
        relevance: 0
    };
    var NAME = {
        className: "title",
        begin: /[^0-9\n\t "'(),.`{}\[\]:;][^\n\t "'(),.`{}\[\]:;]+|[^0-9\n\t "'(),.`{}\[\]:;=]/,
        relevance: 0
    };
    var CLASS = {
        className: "class",
        beginKeywords: "class object trait type",
        end: /[:={\[\n;]/,
        excludeEnd: true,
        contains: [
            {
                beginKeywords: "extends with",
                relevance: 10
            },
            {
                begin: /\[/,
                end: /\]/,
                excludeBegin: true,
                excludeEnd: true,
                relevance: 0,
                contains: [
                    TYPE
                ]
            },
            {
                className: "params",
                begin: /\(/,
                end: /\)/,
                excludeBegin: true,
                excludeEnd: true,
                relevance: 0,
                contains: [
                    TYPE
                ]
            },
            NAME
        ]
    };
    var METHOD = {
        className: "function",
        beginKeywords: "def",
        end: /[:={\[(\n;]/,
        excludeEnd: true,
        contains: [
            NAME
        ]
    };
    return {
        keywords: {
            literal: "true false null",
            keyword: "type yield lazy override def with val var sealed abstract private trait object if forSome for while throw finally protected extends import final return else break new catch super class case package default try this match continue throws implicit"
        },
        contains: [
            hljs.C_LINE_COMMENT_MODE,
            hljs.C_BLOCK_COMMENT_MODE,
            STRING,
            SYMBOL,
            TYPE,
            METHOD,
            CLASS,
            hljs.C_NUMBER_MODE,
            ANNOTATION
        ]
    };
};

});

parcelRegister("2kAZn", function(module, exports) {
module.exports = function(hljs) {
    var SCHEME_IDENT_RE = "[^\\(\\)\\[\\]\\{\\}\",'`;#|\\\\\\s]+";
    var SCHEME_SIMPLE_NUMBER_RE = "(\\-|\\+)?\\d+([./]\\d+)?";
    var SCHEME_COMPLEX_NUMBER_RE = SCHEME_SIMPLE_NUMBER_RE + "[+\\-]" + SCHEME_SIMPLE_NUMBER_RE + "i";
    var BUILTINS = {
        "builtin-name": "case-lambda call/cc class define-class exit-handler field import inherit init-field interface let*-values let-values let/ec mixin opt-lambda override protect provide public rename require require-for-syntax syntax syntax-case syntax-error unit/sig unless when with-syntax and begin call-with-current-continuation call-with-input-file call-with-output-file case cond define define-syntax delay do dynamic-wind else for-each if lambda let let* let-syntax letrec letrec-syntax map or syntax-rules ' * + , ,@ - ... / ; < <= = => > >= ` abs acos angle append apply asin assoc assq assv atan boolean? caar cadr call-with-input-file call-with-output-file call-with-values car cdddar cddddr cdr ceiling char->integer char-alphabetic? char-ci<=? char-ci<? char-ci=? char-ci>=? char-ci>? char-downcase char-lower-case? char-numeric? char-ready? char-upcase char-upper-case? char-whitespace? char<=? char<? char=? char>=? char>? char? close-input-port close-output-port complex? cons cos current-input-port current-output-port denominator display eof-object? eq? equal? eqv? eval even? exact->inexact exact? exp expt floor force gcd imag-part inexact->exact inexact? input-port? integer->char integer? interaction-environment lcm length list list->string list->vector list-ref list-tail list? load log magnitude make-polar make-rectangular make-string make-vector max member memq memv min modulo negative? newline not null-environment null? number->string number? numerator odd? open-input-file open-output-file output-port? pair? peek-char port? positive? procedure? quasiquote quote quotient rational? rationalize read read-char real-part real? remainder reverse round scheme-report-environment set! set-car! set-cdr! sin sqrt string string->list string->number string->symbol string-append string-ci<=? string-ci<? string-ci=? string-ci>=? string-ci>? string-copy string-fill! string-length string-ref string-set! string<=? string<? string=? string>=? string>? string? substring symbol->string symbol? tan transcript-off transcript-on truncate values vector vector->list vector-fill! vector-length vector-ref vector-set! with-input-from-file with-output-to-file write write-char zero?"
    };
    var SHEBANG = {
        className: "meta",
        begin: "^#!",
        end: "$"
    };
    var LITERAL = {
        className: "literal",
        begin: "(#t|#f|#\\\\" + SCHEME_IDENT_RE + "|#\\\\.)"
    };
    var NUMBER = {
        className: "number",
        variants: [
            {
                begin: SCHEME_SIMPLE_NUMBER_RE,
                relevance: 0
            },
            {
                begin: SCHEME_COMPLEX_NUMBER_RE,
                relevance: 0
            },
            {
                begin: "#b[0-1]+(/[0-1]+)?"
            },
            {
                begin: "#o[0-7]+(/[0-7]+)?"
            },
            {
                begin: "#x[0-9a-f]+(/[0-9a-f]+)?"
            }
        ]
    };
    var STRING = hljs.QUOTE_STRING_MODE;
    var REGULAR_EXPRESSION = {
        className: "regexp",
        begin: '#[pr]x"',
        end: '[^\\\\]"'
    };
    var COMMENT_MODES = [
        hljs.COMMENT(";", "$", {
            relevance: 0
        }),
        hljs.COMMENT("#\\|", "\\|#")
    ];
    var IDENT = {
        begin: SCHEME_IDENT_RE,
        relevance: 0
    };
    var QUOTED_IDENT = {
        className: "symbol",
        begin: "'" + SCHEME_IDENT_RE
    };
    var BODY = {
        endsWithParent: true,
        relevance: 0
    };
    var QUOTED_LIST = {
        variants: [
            {
                begin: /'/
            },
            {
                begin: "`"
            }
        ],
        contains: [
            {
                begin: "\\(",
                end: "\\)",
                contains: [
                    "self",
                    LITERAL,
                    STRING,
                    NUMBER,
                    IDENT,
                    QUOTED_IDENT
                ]
            }
        ]
    };
    var NAME = {
        className: "name",
        begin: SCHEME_IDENT_RE,
        lexemes: SCHEME_IDENT_RE,
        keywords: BUILTINS
    };
    var LAMBDA = {
        begin: /lambda/,
        endsWithParent: true,
        returnBegin: true,
        contains: [
            NAME,
            {
                begin: /\(/,
                end: /\)/,
                endsParent: true,
                contains: [
                    IDENT
                ]
            }
        ]
    };
    var LIST = {
        variants: [
            {
                begin: "\\(",
                end: "\\)"
            },
            {
                begin: "\\[",
                end: "\\]"
            }
        ],
        contains: [
            LAMBDA,
            NAME,
            BODY
        ]
    };
    BODY.contains = [
        LITERAL,
        NUMBER,
        STRING,
        IDENT,
        QUOTED_IDENT,
        QUOTED_LIST,
        LIST
    ].concat(COMMENT_MODES);
    return {
        illegal: /\S/,
        contains: [
            SHEBANG,
            NUMBER,
            STRING,
            QUOTED_IDENT,
            QUOTED_LIST,
            LIST
        ].concat(COMMENT_MODES)
    };
};

});

parcelRegister("k3MqZ", function(module, exports) {
module.exports = function(hljs) {
    var COMMON_CONTAINS = [
        hljs.C_NUMBER_MODE,
        {
            className: "string",
            begin: "'|\"",
            end: "'|\"",
            contains: [
                hljs.BACKSLASH_ESCAPE,
                {
                    begin: "''"
                }
            ]
        }
    ];
    return {
        aliases: [
            "sci"
        ],
        lexemes: /%?\w+/,
        keywords: {
            keyword: "abort break case clear catch continue do elseif else endfunction end for function global if pause return resume select try then while",
            literal: "%f %F %t %T %pi %eps %inf %nan %e %i %z %s",
            built_in: "abs and acos asin atan ceil cd chdir clearglobal cosh cos cumprod deff disp error exec execstr exists exp eye gettext floor fprintf fread fsolve imag isdef isempty isinfisnan isvector lasterror length load linspace list listfiles log10 log2 log max min msprintf mclose mopen ones or pathconvert poly printf prod pwd rand real round sinh sin size gsort sprintf sqrt strcat strcmps tring sum system tanh tan type typename warning zeros matrix"
        },
        illegal: '("|#|/\\*|\\s+/\\w+)',
        contains: [
            {
                className: "function",
                beginKeywords: "function",
                end: "$",
                contains: [
                    hljs.UNDERSCORE_TITLE_MODE,
                    {
                        className: "params",
                        begin: "\\(",
                        end: "\\)"
                    }
                ]
            },
            {
                begin: "[a-zA-Z_][a-zA-Z_0-9]*('+[\\.']*|[\\.']+)",
                end: "",
                relevance: 0
            },
            {
                begin: "\\[",
                end: "\\]'*[\\.']*",
                relevance: 0,
                contains: COMMON_CONTAINS
            },
            hljs.COMMENT("//", "$")
        ].concat(COMMON_CONTAINS)
    };
};

});

parcelRegister("3qcwH", function(module, exports) {
module.exports = function(hljs) {
    var AT_IDENTIFIER = "@[a-z-]+" // @font-face
    ;
    var AT_MODIFIERS = "and or not only";
    var IDENT_RE = "[a-zA-Z-][a-zA-Z0-9_-]*";
    var VARIABLE = {
        className: "variable",
        begin: "(\\$" + IDENT_RE + ")\\b"
    };
    var HEXCOLOR = {
        className: "number",
        begin: "#[0-9A-Fa-f]+"
    };
    var DEF_INTERNALS = {
        className: "attribute",
        begin: "[A-Z\\_\\.\\-]+",
        end: ":",
        excludeEnd: true,
        illegal: "[^\\s]",
        starts: {
            endsWithParent: true,
            excludeEnd: true,
            contains: [
                HEXCOLOR,
                hljs.CSS_NUMBER_MODE,
                hljs.QUOTE_STRING_MODE,
                hljs.APOS_STRING_MODE,
                hljs.C_BLOCK_COMMENT_MODE,
                {
                    className: "meta",
                    begin: "!important"
                }
            ]
        }
    };
    return {
        case_insensitive: true,
        illegal: "[=/|']",
        contains: [
            hljs.C_LINE_COMMENT_MODE,
            hljs.C_BLOCK_COMMENT_MODE,
            {
                className: "selector-id",
                begin: "\\#[A-Za-z0-9_-]+",
                relevance: 0
            },
            {
                className: "selector-class",
                begin: "\\.[A-Za-z0-9_-]+",
                relevance: 0
            },
            {
                className: "selector-attr",
                begin: "\\[",
                end: "\\]",
                illegal: "$"
            },
            {
                className: "selector-tag",
                begin: "\\b(a|abbr|acronym|address|area|article|aside|audio|b|base|big|blockquote|body|br|button|canvas|caption|cite|code|col|colgroup|command|datalist|dd|del|details|dfn|div|dl|dt|em|embed|fieldset|figcaption|figure|footer|form|frame|frameset|(h[1-6])|head|header|hgroup|hr|html|i|iframe|img|input|ins|kbd|keygen|label|legend|li|link|map|mark|meta|meter|nav|noframes|noscript|object|ol|optgroup|option|output|p|param|pre|progress|q|rp|rt|ruby|samp|script|section|select|small|span|strike|strong|style|sub|sup|table|tbody|td|textarea|tfoot|th|thead|time|title|tr|tt|ul|var|video)\\b",
                relevance: 0
            },
            {
                className: "selector-pseudo",
                begin: ":(visited|valid|root|right|required|read-write|read-only|out-range|optional|only-of-type|only-child|nth-of-type|nth-last-of-type|nth-last-child|nth-child|not|link|left|last-of-type|last-child|lang|invalid|indeterminate|in-range|hover|focus|first-of-type|first-line|first-letter|first-child|first|enabled|empty|disabled|default|checked|before|after|active)"
            },
            {
                className: "selector-pseudo",
                begin: "::(after|before|choices|first-letter|first-line|repeat-index|repeat-item|selection|value)"
            },
            VARIABLE,
            {
                className: "attribute",
                begin: "\\b(src|z-index|word-wrap|word-spacing|word-break|width|widows|white-space|visibility|vertical-align|unicode-bidi|transition-timing-function|transition-property|transition-duration|transition-delay|transition|transform-style|transform-origin|transform|top|text-underline-position|text-transform|text-shadow|text-rendering|text-overflow|text-indent|text-decoration-style|text-decoration-line|text-decoration-color|text-decoration|text-align-last|text-align|tab-size|table-layout|right|resize|quotes|position|pointer-events|perspective-origin|perspective|page-break-inside|page-break-before|page-break-after|padding-top|padding-right|padding-left|padding-bottom|padding|overflow-y|overflow-x|overflow-wrap|overflow|outline-width|outline-style|outline-offset|outline-color|outline|orphans|order|opacity|object-position|object-fit|normal|none|nav-up|nav-right|nav-left|nav-index|nav-down|min-width|min-height|max-width|max-height|mask|marks|margin-top|margin-right|margin-left|margin-bottom|margin|list-style-type|list-style-position|list-style-image|list-style|line-height|letter-spacing|left|justify-content|initial|inherit|ime-mode|image-orientation|image-resolution|image-rendering|icon|hyphens|height|font-weight|font-variant-ligatures|font-variant|font-style|font-stretch|font-size-adjust|font-size|font-language-override|font-kerning|font-feature-settings|font-family|font|float|flex-wrap|flex-shrink|flex-grow|flex-flow|flex-direction|flex-basis|flex|filter|empty-cells|display|direction|cursor|counter-reset|counter-increment|content|column-width|column-span|column-rule-width|column-rule-style|column-rule-color|column-rule|column-gap|column-fill|column-count|columns|color|clip-path|clip|clear|caption-side|break-inside|break-before|break-after|box-sizing|box-shadow|box-decoration-break|bottom|border-width|border-top-width|border-top-style|border-top-right-radius|border-top-left-radius|border-top-color|border-top|border-style|border-spacing|border-right-width|border-right-style|border-right-color|border-right|border-radius|border-left-width|border-left-style|border-left-color|border-left|border-image-width|border-image-source|border-image-slice|border-image-repeat|border-image-outset|border-image|border-color|border-collapse|border-bottom-width|border-bottom-style|border-bottom-right-radius|border-bottom-left-radius|border-bottom-color|border-bottom|border|background-size|background-repeat|background-position|background-origin|background-image|background-color|background-clip|background-attachment|background-blend-mode|background|backface-visibility|auto|animation-timing-function|animation-play-state|animation-name|animation-iteration-count|animation-fill-mode|animation-duration|animation-direction|animation-delay|animation|align-self|align-items|align-content)\\b",
                illegal: "[^\\s]"
            },
            {
                begin: "\\b(whitespace|wait|w-resize|visible|vertical-text|vertical-ideographic|uppercase|upper-roman|upper-alpha|underline|transparent|top|thin|thick|text|text-top|text-bottom|tb-rl|table-header-group|table-footer-group|sw-resize|super|strict|static|square|solid|small-caps|separate|se-resize|scroll|s-resize|rtl|row-resize|ridge|right|repeat|repeat-y|repeat-x|relative|progress|pointer|overline|outside|outset|oblique|nowrap|not-allowed|normal|none|nw-resize|no-repeat|no-drop|newspaper|ne-resize|n-resize|move|middle|medium|ltr|lr-tb|lowercase|lower-roman|lower-alpha|loose|list-item|line|line-through|line-edge|lighter|left|keep-all|justify|italic|inter-word|inter-ideograph|inside|inset|inline|inline-block|inherit|inactive|ideograph-space|ideograph-parenthesis|ideograph-numeric|ideograph-alpha|horizontal|hidden|help|hand|groove|fixed|ellipsis|e-resize|double|dotted|distribute|distribute-space|distribute-letter|distribute-all-lines|disc|disabled|default|decimal|dashed|crosshair|collapse|col-resize|circle|char|center|capitalize|break-word|break-all|bottom|both|bolder|bold|block|bidi-override|below|baseline|auto|always|all-scroll|absolute|table|table-cell)\\b"
            },
            {
                begin: ":",
                end: ";",
                contains: [
                    VARIABLE,
                    HEXCOLOR,
                    hljs.CSS_NUMBER_MODE,
                    hljs.QUOTE_STRING_MODE,
                    hljs.APOS_STRING_MODE,
                    {
                        className: "meta",
                        begin: "!important"
                    }
                ]
            },
            // matching these here allows us to treat them more like regular CSS
            // rules so everything between the {} gets regular rule highlighting,
            // which is what we want for page and font-face
            {
                begin: "@(page|font-face)",
                lexemes: AT_IDENTIFIER,
                keywords: "@page @font-face"
            },
            {
                begin: "@",
                end: "[{;]",
                returnBegin: true,
                keywords: AT_MODIFIERS,
                contains: [
                    {
                        begin: AT_IDENTIFIER,
                        className: "keyword"
                    },
                    VARIABLE,
                    hljs.QUOTE_STRING_MODE,
                    hljs.APOS_STRING_MODE,
                    HEXCOLOR,
                    hljs.CSS_NUMBER_MODE
                ]
            }
        ]
    };
};

});

parcelRegister("68ktp", function(module, exports) {
module.exports = function(hljs) {
    return {
        aliases: [
            "console"
        ],
        contains: [
            {
                className: "meta",
                begin: "^\\s{0,3}[/\\w\\d\\[\\]()@-]*[>%$#]",
                starts: {
                    end: "$",
                    subLanguage: "bash"
                }
            }
        ]
    };
};

});

parcelRegister("2htv8", function(module, exports) {
module.exports = function(hljs) {
    var smali_instr_low_prio = [
        "add",
        "and",
        "cmp",
        "cmpg",
        "cmpl",
        "const",
        "div",
        "double",
        "float",
        "goto",
        "if",
        "int",
        "long",
        "move",
        "mul",
        "neg",
        "new",
        "nop",
        "not",
        "or",
        "rem",
        "return",
        "shl",
        "shr",
        "sput",
        "sub",
        "throw",
        "ushr",
        "xor"
    ];
    var smali_instr_high_prio = [
        "aget",
        "aput",
        "array",
        "check",
        "execute",
        "fill",
        "filled",
        "goto/16",
        "goto/32",
        "iget",
        "instance",
        "invoke",
        "iput",
        "monitor",
        "packed",
        "sget",
        "sparse"
    ];
    var smali_keywords = [
        "transient",
        "constructor",
        "abstract",
        "final",
        "synthetic",
        "public",
        "private",
        "protected",
        "static",
        "bridge",
        "system"
    ];
    return {
        aliases: [
            "smali"
        ],
        contains: [
            {
                className: "string",
                begin: '"',
                end: '"',
                relevance: 0
            },
            hljs.COMMENT("#", "$", {
                relevance: 0
            }),
            {
                className: "keyword",
                variants: [
                    {
                        begin: "\\s*\\.end\\s[a-zA-Z0-9]*"
                    },
                    {
                        begin: "^[ ]*\\.[a-zA-Z]*",
                        relevance: 0
                    },
                    {
                        begin: "\\s:[a-zA-Z_0-9]*",
                        relevance: 0
                    },
                    {
                        begin: "\\s(" + smali_keywords.join("|") + ")"
                    }
                ]
            },
            {
                className: "built_in",
                variants: [
                    {
                        begin: "\\s(" + smali_instr_low_prio.join("|") + ")\\s"
                    },
                    {
                        begin: "\\s(" + smali_instr_low_prio.join("|") + ")((\\-|/)[a-zA-Z0-9]+)+\\s",
                        relevance: 10
                    },
                    {
                        begin: "\\s(" + smali_instr_high_prio.join("|") + ")((\\-|/)[a-zA-Z0-9]+)*\\s",
                        relevance: 10
                    }
                ]
            },
            {
                className: "class",
                begin: "L[^(;:\n]*;",
                relevance: 0
            },
            {
                begin: "[vp][0-9]+"
            }
        ]
    };
};

});

parcelRegister("le1df", function(module, exports) {
module.exports = function(hljs) {
    var VAR_IDENT_RE = "[a-z][a-zA-Z0-9_]*";
    var CHAR = {
        className: "string",
        begin: "\\$.{1}"
    };
    var SYMBOL = {
        className: "symbol",
        begin: "#" + hljs.UNDERSCORE_IDENT_RE
    };
    return {
        aliases: [
            "st"
        ],
        keywords: "self super nil true false thisContext",
        contains: [
            hljs.COMMENT('"', '"'),
            hljs.APOS_STRING_MODE,
            {
                className: "type",
                begin: "\\b[A-Z][A-Za-z0-9_]*",
                relevance: 0
            },
            {
                begin: VAR_IDENT_RE + ":",
                relevance: 0
            },
            hljs.C_NUMBER_MODE,
            SYMBOL,
            CHAR,
            {
                // This looks more complicated than needed to avoid combinatorial
                // explosion under V8. It effectively means `| var1 var2 ... |` with
                // whitespace adjacent to `|` being optional.
                begin: "\\|[ ]*" + VAR_IDENT_RE + "([ ]+" + VAR_IDENT_RE + ")*[ ]*\\|",
                returnBegin: true,
                end: /\|/,
                illegal: /\S/,
                contains: [
                    {
                        begin: "(\\|[ ]*)?" + VAR_IDENT_RE
                    }
                ]
            },
            {
                begin: "\\#\\(",
                end: "\\)",
                contains: [
                    hljs.APOS_STRING_MODE,
                    CHAR,
                    hljs.C_NUMBER_MODE,
                    SYMBOL
                ]
            }
        ]
    };
};

});

parcelRegister("eKuVF", function(module, exports) {
module.exports = function(hljs) {
    return {
        aliases: [
            "ml"
        ],
        keywords: {
            keyword: /* according to Definition of Standard ML 97  */ "abstype and andalso as case datatype do else end eqtype exception fn fun functor handle if in include infix infixr let local nonfix of op open orelse raise rec sharing sig signature struct structure then type val with withtype where while",
            built_in: /* built-in types according to basis library */ "array bool char exn int list option order real ref string substring vector unit word",
            literal: "true false NONE SOME LESS EQUAL GREATER nil"
        },
        illegal: /\/\/|>>/,
        lexemes: "[a-z_]\\w*!?",
        contains: [
            {
                className: "literal",
                begin: /\[(\|\|)?\]|\(\)/,
                relevance: 0
            },
            hljs.COMMENT("\\(\\*", "\\*\\)", {
                contains: [
                    "self"
                ]
            }),
            {
                className: "symbol",
                begin: "'[A-Za-z_](?!')[\\w']*"
            },
            {
                className: "type",
                begin: "`[A-Z][\\w']*"
            },
            {
                className: "type",
                begin: "\\b[A-Z][\\w']*",
                relevance: 0
            },
            {
                begin: "[a-z_]\\w*'[\\w']*"
            },
            hljs.inherit(hljs.APOS_STRING_MODE, {
                className: "string",
                relevance: 0
            }),
            hljs.inherit(hljs.QUOTE_STRING_MODE, {
                illegal: null
            }),
            {
                className: "number",
                begin: "\\b(0[xX][a-fA-F0-9_]+[Lln]?|0[oO][0-7_]+[Lln]?|0[bB][01_]+[Lln]?|[0-9][0-9_]*([Lln]|(\\.[0-9_]*)?([eE][-+]?[0-9_]+)?)?)",
                relevance: 0
            },
            {
                begin: /[-=]>/ // relevance booster
            }
        ]
    };
};

});

parcelRegister("16hNA", function(module, exports) {
module.exports = function(hljs) {
    // In SQF, a variable start with _
    var VARIABLE = {
        className: "variable",
        begin: /\b_+[a-zA-Z_]\w*/
    };
    // In SQF, a function should fit myTag_fnc_myFunction pattern
    // https://community.bistudio.com/wiki/Functions_Library_(Arma_3)#Adding_a_Function
    var FUNCTION = {
        className: "title",
        begin: /[a-zA-Z][a-zA-Z0-9]+_fnc_\w*/
    };
    // In SQF strings, quotes matching the start are escaped by adding a consecutive.
    // Example of single escaped quotes: " "" " and  ' '' '.
    var STRINGS = {
        className: "string",
        variants: [
            {
                begin: '"',
                end: '"',
                contains: [
                    {
                        begin: '""',
                        relevance: 0
                    }
                ]
            },
            {
                begin: "'",
                end: "'",
                contains: [
                    {
                        begin: "''",
                        relevance: 0
                    }
                ]
            }
        ]
    };
    // list of keywords from:
    // https://community.bistudio.com/wiki/PreProcessor_Commands
    var PREPROCESSOR = {
        className: "meta",
        begin: /#\s*[a-z]+\b/,
        end: /$/,
        keywords: {
            "meta-keyword": "define undef ifdef ifndef else endif include"
        },
        contains: [
            {
                begin: /\\\n/,
                relevance: 0
            },
            hljs.inherit(STRINGS, {
                className: "meta-string"
            }),
            {
                className: "meta-string",
                begin: /<[^\n>]*>/,
                end: /$/,
                illegal: "\\n"
            },
            hljs.C_LINE_COMMENT_MODE,
            hljs.C_BLOCK_COMMENT_MODE
        ]
    };
    return {
        aliases: [
            "sqf"
        ],
        case_insensitive: true,
        keywords: {
            keyword: "case catch default do else exit exitWith for forEach from if private switch then throw to try waitUntil while with",
            built_in: "abs accTime acos action actionIDs actionKeys actionKeysImages actionKeysNames actionKeysNamesArray actionName actionParams activateAddons activatedAddons activateKey add3DENConnection add3DENEventHandler add3DENLayer addAction addBackpack addBackpackCargo addBackpackCargoGlobal addBackpackGlobal addCamShake addCuratorAddons addCuratorCameraArea addCuratorEditableObjects addCuratorEditingArea addCuratorPoints addEditorObject addEventHandler addForce addGoggles addGroupIcon addHandgunItem addHeadgear addItem addItemCargo addItemCargoGlobal addItemPool addItemToBackpack addItemToUniform addItemToVest addLiveStats addMagazine addMagazineAmmoCargo addMagazineCargo addMagazineCargoGlobal addMagazineGlobal addMagazinePool addMagazines addMagazineTurret addMenu addMenuItem addMissionEventHandler addMPEventHandler addMusicEventHandler addOwnedMine addPlayerScores addPrimaryWeaponItem addPublicVariableEventHandler addRating addResources addScore addScoreSide addSecondaryWeaponItem addSwitchableUnit addTeamMember addToRemainsCollector addTorque addUniform addVehicle addVest addWaypoint addWeapon addWeaponCargo addWeaponCargoGlobal addWeaponGlobal addWeaponItem addWeaponPool addWeaponTurret admin agent agents AGLToASL aimedAtTarget aimPos airDensityRTD airplaneThrottle airportSide AISFinishHeal alive all3DENEntities allAirports allControls allCurators allCutLayers allDead allDeadMen allDisplays allGroups allMapMarkers allMines allMissionObjects allow3DMode allowCrewInImmobile allowCuratorLogicIgnoreAreas allowDamage allowDammage allowFileOperations allowFleeing allowGetIn allowSprint allPlayers allSimpleObjects allSites allTurrets allUnits allUnitsUAV allVariables ammo ammoOnPylon and animate animateBay animateDoor animatePylon animateSource animationNames animationPhase animationSourcePhase animationState append apply armoryPoints arrayIntersect asin ASLToAGL ASLToATL assert assignAsCargo assignAsCargoIndex assignAsCommander assignAsDriver assignAsGunner assignAsTurret assignCurator assignedCargo assignedCommander assignedDriver assignedGunner assignedItems assignedTarget assignedTeam assignedVehicle assignedVehicleRole assignItem assignTeam assignToAirport atan atan2 atg ATLToASL attachedObject attachedObjects attachedTo attachObject attachTo attackEnabled backpack backpackCargo backpackContainer backpackItems backpackMagazines backpackSpaceFor behaviour benchmark binocular boundingBox boundingBoxReal boundingCenter breakOut breakTo briefingName buildingExit buildingPos buttonAction buttonSetAction cadetMode call callExtension camCommand camCommit camCommitPrepared camCommitted camConstuctionSetParams camCreate camDestroy cameraEffect cameraEffectEnableHUD cameraInterest cameraOn cameraView campaignConfigFile camPreload camPreloaded camPrepareBank camPrepareDir camPrepareDive camPrepareFocus camPrepareFov camPrepareFovRange camPreparePos camPrepareRelPos camPrepareTarget camSetBank camSetDir camSetDive camSetFocus camSetFov camSetFovRange camSetPos camSetRelPos camSetTarget camTarget camUseNVG canAdd canAddItemToBackpack canAddItemToUniform canAddItemToVest cancelSimpleTaskDestination canFire canMove canSlingLoad canStand canSuspend canTriggerDynamicSimulation canUnloadInCombat canVehicleCargo captive captiveNum cbChecked cbSetChecked ceil channelEnabled cheatsEnabled checkAIFeature checkVisibility className clearAllItemsFromBackpack clearBackpackCargo clearBackpackCargoGlobal clearGroupIcons clearItemCargo clearItemCargoGlobal clearItemPool clearMagazineCargo clearMagazineCargoGlobal clearMagazinePool clearOverlay clearRadio clearWeaponCargo clearWeaponCargoGlobal clearWeaponPool clientOwner closeDialog closeDisplay closeOverlay collapseObjectTree collect3DENHistory collectiveRTD combatMode commandArtilleryFire commandChat commander commandFire commandFollow commandFSM commandGetOut commandingMenu commandMove commandRadio commandStop commandSuppressiveFire commandTarget commandWatch comment commitOverlay compile compileFinal completedFSM composeText configClasses configFile configHierarchy configName configProperties configSourceAddonList configSourceMod configSourceModList confirmSensorTarget connectTerminalToUAV controlsGroupCtrl copyFromClipboard copyToClipboard copyWaypoints cos count countEnemy countFriendly countSide countType countUnknown create3DENComposition create3DENEntity createAgent createCenter createDialog createDiaryLink createDiaryRecord createDiarySubject createDisplay createGearDialog createGroup createGuardedPoint createLocation createMarker createMarkerLocal createMenu createMine createMissionDisplay createMPCampaignDisplay createSimpleObject createSimpleTask createSite createSoundSource createTask createTeam createTrigger createUnit createVehicle createVehicleCrew createVehicleLocal crew ctAddHeader ctAddRow ctClear ctCurSel ctData ctFindHeaderRows ctFindRowHeader ctHeaderControls ctHeaderCount ctRemoveHeaders ctRemoveRows ctrlActivate ctrlAddEventHandler ctrlAngle ctrlAutoScrollDelay ctrlAutoScrollRewind ctrlAutoScrollSpeed ctrlChecked ctrlClassName ctrlCommit ctrlCommitted ctrlCreate ctrlDelete ctrlEnable ctrlEnabled ctrlFade ctrlHTMLLoaded ctrlIDC ctrlIDD ctrlMapAnimAdd ctrlMapAnimClear ctrlMapAnimCommit ctrlMapAnimDone ctrlMapCursor ctrlMapMouseOver ctrlMapScale ctrlMapScreenToWorld ctrlMapWorldToScreen ctrlModel ctrlModelDirAndUp ctrlModelScale ctrlParent ctrlParentControlsGroup ctrlPosition ctrlRemoveAllEventHandlers ctrlRemoveEventHandler ctrlScale ctrlSetActiveColor ctrlSetAngle ctrlSetAutoScrollDelay ctrlSetAutoScrollRewind ctrlSetAutoScrollSpeed ctrlSetBackgroundColor ctrlSetChecked ctrlSetEventHandler ctrlSetFade ctrlSetFocus ctrlSetFont ctrlSetFontH1 ctrlSetFontH1B ctrlSetFontH2 ctrlSetFontH2B ctrlSetFontH3 ctrlSetFontH3B ctrlSetFontH4 ctrlSetFontH4B ctrlSetFontH5 ctrlSetFontH5B ctrlSetFontH6 ctrlSetFontH6B ctrlSetFontHeight ctrlSetFontHeightH1 ctrlSetFontHeightH2 ctrlSetFontHeightH3 ctrlSetFontHeightH4 ctrlSetFontHeightH5 ctrlSetFontHeightH6 ctrlSetFontHeightSecondary ctrlSetFontP ctrlSetFontPB ctrlSetFontSecondary ctrlSetForegroundColor ctrlSetModel ctrlSetModelDirAndUp ctrlSetModelScale ctrlSetPixelPrecision ctrlSetPosition ctrlSetScale ctrlSetStructuredText ctrlSetText ctrlSetTextColor ctrlSetTooltip ctrlSetTooltipColorBox ctrlSetTooltipColorShade ctrlSetTooltipColorText ctrlShow ctrlShown ctrlText ctrlTextHeight ctrlTextWidth ctrlType ctrlVisible ctRowControls ctRowCount ctSetCurSel ctSetData ctSetHeaderTemplate ctSetRowTemplate ctSetValue ctValue curatorAddons curatorCamera curatorCameraArea curatorCameraAreaCeiling curatorCoef curatorEditableObjects curatorEditingArea curatorEditingAreaType curatorMouseOver curatorPoints curatorRegisteredObjects curatorSelected curatorWaypointCost current3DENOperation currentChannel currentCommand currentMagazine currentMagazineDetail currentMagazineDetailTurret currentMagazineTurret currentMuzzle currentNamespace currentTask currentTasks currentThrowable currentVisionMode currentWaypoint currentWeapon currentWeaponMode currentWeaponTurret currentZeroing cursorObject cursorTarget customChat customRadio cutFadeOut cutObj cutRsc cutText damage date dateToNumber daytime deActivateKey debriefingText debugFSM debugLog deg delete3DENEntities deleteAt deleteCenter deleteCollection deleteEditorObject deleteGroup deleteGroupWhenEmpty deleteIdentity deleteLocation deleteMarker deleteMarkerLocal deleteRange deleteResources deleteSite deleteStatus deleteTeam deleteVehicle deleteVehicleCrew deleteWaypoint detach detectedMines diag_activeMissionFSMs diag_activeScripts diag_activeSQFScripts diag_activeSQSScripts diag_captureFrame diag_captureFrameToFile diag_captureSlowFrame diag_codePerformance diag_drawMode diag_enable diag_enabled diag_fps diag_fpsMin diag_frameNo diag_lightNewLoad diag_list diag_log diag_logSlowFrame diag_mergeConfigFile diag_recordTurretLimits diag_setLightNew diag_tickTime diag_toggle dialog diarySubjectExists didJIP didJIPOwner difficulty difficultyEnabled difficultyEnabledRTD difficultyOption direction directSay disableAI disableCollisionWith disableConversation disableDebriefingStats disableMapIndicators disableNVGEquipment disableRemoteSensors disableSerialization disableTIEquipment disableUAVConnectability disableUserInput displayAddEventHandler displayCtrl displayParent displayRemoveAllEventHandlers displayRemoveEventHandler displaySetEventHandler dissolveTeam distance distance2D distanceSqr distributionRegion do3DENAction doArtilleryFire doFire doFollow doFSM doGetOut doMove doorPhase doStop doSuppressiveFire doTarget doWatch drawArrow drawEllipse drawIcon drawIcon3D drawLine drawLine3D drawLink drawLocation drawPolygon drawRectangle drawTriangle driver drop dynamicSimulationDistance dynamicSimulationDistanceCoef dynamicSimulationEnabled dynamicSimulationSystemEnabled echo edit3DENMissionAttributes editObject editorSetEventHandler effectiveCommander emptyPositions enableAI enableAIFeature enableAimPrecision enableAttack enableAudioFeature enableAutoStartUpRTD enableAutoTrimRTD enableCamShake enableCaustics enableChannel enableCollisionWith enableCopilot enableDebriefingStats enableDiagLegend enableDynamicSimulation enableDynamicSimulationSystem enableEndDialog enableEngineArtillery enableEnvironment enableFatigue enableGunLights enableInfoPanelComponent enableIRLasers enableMimics enablePersonTurret enableRadio enableReload enableRopeAttach enableSatNormalOnDetail enableSaving enableSentences enableSimulation enableSimulationGlobal enableStamina enableTeamSwitch enableTraffic enableUAVConnectability enableUAVWaypoints enableVehicleCargo enableVehicleSensor enableWeaponDisassembly endLoadingScreen endMission engineOn enginesIsOnRTD enginesRpmRTD enginesTorqueRTD entities environmentEnabled estimatedEndServerTime estimatedTimeLeft evalObjectArgument everyBackpack everyContainer exec execEditorScript execFSM execVM exp expectedDestination exportJIPMessages eyeDirection eyePos face faction fadeMusic fadeRadio fadeSound fadeSpeech failMission fillWeaponsFromPool find findCover findDisplay findEditorObject findEmptyPosition findEmptyPositionReady findIf findNearestEnemy finishMissionInit finite fire fireAtTarget firstBackpack flag flagAnimationPhase flagOwner flagSide flagTexture fleeing floor flyInHeight flyInHeightASL fog fogForecast fogParams forceAddUniform forcedMap forceEnd forceFlagTexture forceFollowRoad forceMap forceRespawn forceSpeed forceWalk forceWeaponFire forceWeatherChange forEachMember forEachMemberAgent forEachMemberTeam forgetTarget format formation formationDirection formationLeader formationMembers formationPosition formationTask formatText formLeader freeLook fromEditor fuel fullCrew gearIDCAmmoCount gearSlotAmmoCount gearSlotData get3DENActionState get3DENAttribute get3DENCamera get3DENConnections get3DENEntity get3DENEntityID get3DENGrid get3DENIconsVisible get3DENLayerEntities get3DENLinesVisible get3DENMissionAttribute get3DENMouseOver get3DENSelected getAimingCoef getAllEnvSoundControllers getAllHitPointsDamage getAllOwnedMines getAllSoundControllers getAmmoCargo getAnimAimPrecision getAnimSpeedCoef getArray getArtilleryAmmo getArtilleryComputerSettings getArtilleryETA getAssignedCuratorLogic getAssignedCuratorUnit getBackpackCargo getBleedingRemaining getBurningValue getCameraViewDirection getCargoIndex getCenterOfMass getClientState getClientStateNumber getCompatiblePylonMagazines getConnectedUAV getContainerMaxLoad getCursorObjectParams getCustomAimCoef getDammage getDescription getDir getDirVisual getDLCAssetsUsage getDLCAssetsUsageByName getDLCs getEditorCamera getEditorMode getEditorObjectScope getElevationOffset getEnvSoundController getFatigue getForcedFlagTexture getFriend getFSMVariable getFuelCargo getGroupIcon getGroupIconParams getGroupIcons getHideFrom getHit getHitIndex getHitPointDamage getItemCargo getMagazineCargo getMarkerColor getMarkerPos getMarkerSize getMarkerType getMass getMissionConfig getMissionConfigValue getMissionDLCs getMissionLayerEntities getModelInfo getMousePosition getMusicPlayedTime getNumber getObjectArgument getObjectChildren getObjectDLC getObjectMaterials getObjectProxy getObjectTextures getObjectType getObjectViewDistance getOxygenRemaining getPersonUsedDLCs getPilotCameraDirection getPilotCameraPosition getPilotCameraRotation getPilotCameraTarget getPlateNumber getPlayerChannel getPlayerScores getPlayerUID getPos getPosASL getPosASLVisual getPosASLW getPosATL getPosATLVisual getPosVisual getPosWorld getPylonMagazines getRelDir getRelPos getRemoteSensorsDisabled getRepairCargo getResolution getShadowDistance getShotParents getSlingLoad getSoundController getSoundControllerResult getSpeed getStamina getStatValue getSuppression getTerrainGrid getTerrainHeightASL getText getTotalDLCUsageTime getUnitLoadout getUnitTrait getUserMFDText getUserMFDvalue getVariable getVehicleCargo getWeaponCargo getWeaponSway getWingsOrientationRTD getWingsPositionRTD getWPPos glanceAt globalChat globalRadio goggles goto group groupChat groupFromNetId groupIconSelectable groupIconsVisible groupId groupOwner groupRadio groupSelectedUnits groupSelectUnit gunner gusts halt handgunItems handgunMagazine handgunWeapon handsHit hasInterface hasPilotCamera hasWeapon hcAllGroups hcGroupParams hcLeader hcRemoveAllGroups hcRemoveGroup hcSelected hcSelectGroup hcSetGroup hcShowBar hcShownBar headgear hideBody hideObject hideObjectGlobal hideSelection hint hintC hintCadet hintSilent hmd hostMission htmlLoad HUDMovementLevels humidity image importAllGroups importance in inArea inAreaArray incapacitatedState inflame inflamed infoPanel infoPanelComponentEnabled infoPanelComponents infoPanels inGameUISetEventHandler inheritsFrom initAmbientLife inPolygon inputAction inRangeOfArtillery insertEditorObject intersect is3DEN is3DENMultiplayer isAbleToBreathe isAgent isArray isAutoHoverOn isAutonomous isAutotest isBleeding isBurning isClass isCollisionLightOn isCopilotEnabled isDamageAllowed isDedicated isDLCAvailable isEngineOn isEqualTo isEqualType isEqualTypeAll isEqualTypeAny isEqualTypeArray isEqualTypeParams isFilePatchingEnabled isFlashlightOn isFlatEmpty isForcedWalk isFormationLeader isGroupDeletedWhenEmpty isHidden isInRemainsCollector isInstructorFigureEnabled isIRLaserOn isKeyActive isKindOf isLaserOn isLightOn isLocalized isManualFire isMarkedForCollection isMultiplayer isMultiplayerSolo isNil isNull isNumber isObjectHidden isObjectRTD isOnRoad isPipEnabled isPlayer isRealTime isRemoteExecuted isRemoteExecutedJIP isServer isShowing3DIcons isSimpleObject isSprintAllowed isStaminaEnabled isSteamMission isStreamFriendlyUIEnabled isText isTouchingGround isTurnedOut isTutHintsEnabled isUAVConnectable isUAVConnected isUIContext isUniformAllowed isVehicleCargo isVehicleRadarOn isVehicleSensorEnabled isWalking isWeaponDeployed isWeaponRested itemCargo items itemsWithMagazines join joinAs joinAsSilent joinSilent joinString kbAddDatabase kbAddDatabaseTargets kbAddTopic kbHasTopic kbReact kbRemoveTopic kbTell kbWasSaid keyImage keyName knowsAbout land landAt landResult language laserTarget lbAdd lbClear lbColor lbColorRight lbCurSel lbData lbDelete lbIsSelected lbPicture lbPictureRight lbSelection lbSetColor lbSetColorRight lbSetCurSel lbSetData lbSetPicture lbSetPictureColor lbSetPictureColorDisabled lbSetPictureColorSelected lbSetPictureRight lbSetPictureRightColor lbSetPictureRightColorDisabled lbSetPictureRightColorSelected lbSetSelectColor lbSetSelectColorRight lbSetSelected lbSetText lbSetTextRight lbSetTooltip lbSetValue lbSize lbSort lbSortByValue lbText lbTextRight lbValue leader leaderboardDeInit leaderboardGetRows leaderboardInit leaderboardRequestRowsFriends leaderboardsRequestUploadScore leaderboardsRequestUploadScoreKeepBest leaderboardState leaveVehicle libraryCredits libraryDisclaimers lifeState lightAttachObject lightDetachObject lightIsOn lightnings limitSpeed linearConversion lineIntersects lineIntersectsObjs lineIntersectsSurfaces lineIntersectsWith linkItem list listObjects listRemoteTargets listVehicleSensors ln lnbAddArray lnbAddColumn lnbAddRow lnbClear lnbColor lnbCurSelRow lnbData lnbDeleteColumn lnbDeleteRow lnbGetColumnsPosition lnbPicture lnbSetColor lnbSetColumnsPos lnbSetCurSelRow lnbSetData lnbSetPicture lnbSetText lnbSetValue lnbSize lnbSort lnbSortByValue lnbText lnbValue load loadAbs loadBackpack loadFile loadGame loadIdentity loadMagazine loadOverlay loadStatus loadUniform loadVest local localize locationPosition lock lockCameraTo lockCargo lockDriver locked lockedCargo lockedDriver lockedTurret lockIdentity lockTurret lockWP log logEntities logNetwork logNetworkTerminate lookAt lookAtPos magazineCargo magazines magazinesAllTurrets magazinesAmmo magazinesAmmoCargo magazinesAmmoFull magazinesDetail magazinesDetailBackpack magazinesDetailUniform magazinesDetailVest magazinesTurret magazineTurretAmmo mapAnimAdd mapAnimClear mapAnimCommit mapAnimDone mapCenterOnCamera mapGridPosition markAsFinishedOnSteam markerAlpha markerBrush markerColor markerDir markerPos markerShape markerSize markerText markerType max members menuAction menuAdd menuChecked menuClear menuCollapse menuData menuDelete menuEnable menuEnabled menuExpand menuHover menuPicture menuSetAction menuSetCheck menuSetData menuSetPicture menuSetValue menuShortcut menuShortcutText menuSize menuSort menuText menuURL menuValue min mineActive mineDetectedBy missionConfigFile missionDifficulty missionName missionNamespace missionStart missionVersion mod modelToWorld modelToWorldVisual modelToWorldVisualWorld modelToWorldWorld modParams moonIntensity moonPhase morale move move3DENCamera moveInAny moveInCargo moveInCommander moveInDriver moveInGunner moveInTurret moveObjectToEnd moveOut moveTime moveTo moveToCompleted moveToFailed musicVolume name nameSound nearEntities nearestBuilding nearestLocation nearestLocations nearestLocationWithDubbing nearestObject nearestObjects nearestTerrainObjects nearObjects nearObjectsReady nearRoads nearSupplies nearTargets needReload netId netObjNull newOverlay nextMenuItemIndex nextWeatherChange nMenuItems not numberOfEnginesRTD numberToDate objectCurators objectFromNetId objectParent objStatus onBriefingGroup onBriefingNotes onBriefingPlan onBriefingTeamSwitch onCommandModeChanged onDoubleClick onEachFrame onGroupIconClick onGroupIconOverEnter onGroupIconOverLeave onHCGroupSelectionChanged onMapSingleClick onPlayerConnected onPlayerDisconnected onPreloadFinished onPreloadStarted onShowNewObject onTeamSwitch openCuratorInterface openDLCPage openMap openSteamApp openYoutubeVideo or orderGetIn overcast overcastForecast owner param params parseNumber parseSimpleArray parseText parsingNamespace particlesQuality pickWeaponPool pitch pixelGrid pixelGridBase pixelGridNoUIScale pixelH pixelW playableSlotsNumber playableUnits playAction playActionNow player playerRespawnTime playerSide playersNumber playGesture playMission playMove playMoveNow playMusic playScriptedMission playSound playSound3D position positionCameraToWorld posScreenToWorld posWorldToScreen ppEffectAdjust ppEffectCommit ppEffectCommitted ppEffectCreate ppEffectDestroy ppEffectEnable ppEffectEnabled ppEffectForceInNVG precision preloadCamera preloadObject preloadSound preloadTitleObj preloadTitleRsc preprocessFile preprocessFileLineNumbers primaryWeapon primaryWeaponItems primaryWeaponMagazine priority processDiaryLink productVersion profileName profileNamespace profileNameSteam progressLoadingScreen progressPosition progressSetPosition publicVariable publicVariableClient publicVariableServer pushBack pushBackUnique putWeaponPool queryItemsPool queryMagazinePool queryWeaponPool rad radioChannelAdd radioChannelCreate radioChannelRemove radioChannelSetCallSign radioChannelSetLabel radioVolume rain rainbow random rank rankId rating rectangular registeredTasks registerTask reload reloadEnabled remoteControl remoteExec remoteExecCall remoteExecutedOwner remove3DENConnection remove3DENEventHandler remove3DENLayer removeAction removeAll3DENEventHandlers removeAllActions removeAllAssignedItems removeAllContainers removeAllCuratorAddons removeAllCuratorCameraAreas removeAllCuratorEditingAreas removeAllEventHandlers removeAllHandgunItems removeAllItems removeAllItemsWithMagazines removeAllMissionEventHandlers removeAllMPEventHandlers removeAllMusicEventHandlers removeAllOwnedMines removeAllPrimaryWeaponItems removeAllWeapons removeBackpack removeBackpackGlobal removeCuratorAddons removeCuratorCameraArea removeCuratorEditableObjects removeCuratorEditingArea removeDrawIcon removeDrawLinks removeEventHandler removeFromRemainsCollector removeGoggles removeGroupIcon removeHandgunItem removeHeadgear removeItem removeItemFromBackpack removeItemFromUniform removeItemFromVest removeItems removeMagazine removeMagazineGlobal removeMagazines removeMagazinesTurret removeMagazineTurret removeMenuItem removeMissionEventHandler removeMPEventHandler removeMusicEventHandler removeOwnedMine removePrimaryWeaponItem removeSecondaryWeaponItem removeSimpleTask removeSwitchableUnit removeTeamMember removeUniform removeVest removeWeapon removeWeaponAttachmentCargo removeWeaponCargo removeWeaponGlobal removeWeaponTurret reportRemoteTarget requiredVersion resetCamShake resetSubgroupDirection resize resources respawnVehicle restartEditorCamera reveal revealMine reverse reversedMouseY roadAt roadsConnectedTo roleDescription ropeAttachedObjects ropeAttachedTo ropeAttachEnabled ropeAttachTo ropeCreate ropeCut ropeDestroy ropeDetach ropeEndPosition ropeLength ropes ropeUnwind ropeUnwound rotorsForcesRTD rotorsRpmRTD round runInitScript safeZoneH safeZoneW safeZoneWAbs safeZoneX safeZoneXAbs safeZoneY save3DENInventory saveGame saveIdentity saveJoysticks saveOverlay saveProfileNamespace saveStatus saveVar savingEnabled say say2D say3D scopeName score scoreSide screenshot screenToWorld scriptDone scriptName scudState secondaryWeapon secondaryWeaponItems secondaryWeaponMagazine select selectBestPlaces selectDiarySubject selectedEditorObjects selectEditorObject selectionNames selectionPosition selectLeader selectMax selectMin selectNoPlayer selectPlayer selectRandom selectRandomWeighted selectWeapon selectWeaponTurret sendAUMessage sendSimpleCommand sendTask sendTaskResult sendUDPMessage serverCommand serverCommandAvailable serverCommandExecutable serverName serverTime set set3DENAttribute set3DENAttributes set3DENGrid set3DENIconsVisible set3DENLayer set3DENLinesVisible set3DENLogicType set3DENMissionAttribute set3DENMissionAttributes set3DENModelsVisible set3DENObjectType set3DENSelected setAccTime setActualCollectiveRTD setAirplaneThrottle setAirportSide setAmmo setAmmoCargo setAmmoOnPylon setAnimSpeedCoef setAperture setApertureNew setArmoryPoints setAttributes setAutonomous setBehaviour setBleedingRemaining setBrakesRTD setCameraInterest setCamShakeDefParams setCamShakeParams setCamUseTI setCaptive setCenterOfMass setCollisionLight setCombatMode setCompassOscillation setConvoySeparation setCuratorCameraAreaCeiling setCuratorCoef setCuratorEditingAreaType setCuratorWaypointCost setCurrentChannel setCurrentTask setCurrentWaypoint setCustomAimCoef setCustomWeightRTD setDamage setDammage setDate setDebriefingText setDefaultCamera setDestination setDetailMapBlendPars setDir setDirection setDrawIcon setDriveOnPath setDropInterval setDynamicSimulationDistance setDynamicSimulationDistanceCoef setEditorMode setEditorObjectScope setEffectCondition setEngineRPMRTD setFace setFaceAnimation setFatigue setFeatureType setFlagAnimationPhase setFlagOwner setFlagSide setFlagTexture setFog setFormation setFormationTask setFormDir setFriend setFromEditor setFSMVariable setFuel setFuelCargo setGroupIcon setGroupIconParams setGroupIconsSelectable setGroupIconsVisible setGroupId setGroupIdGlobal setGroupOwner setGusts setHideBehind setHit setHitIndex setHitPointDamage setHorizonParallaxCoef setHUDMovementLevels setIdentity setImportance setInfoPanel setLeader setLightAmbient setLightAttenuation setLightBrightness setLightColor setLightDayLight setLightFlareMaxDistance setLightFlareSize setLightIntensity setLightnings setLightUseFlare setLocalWindParams setMagazineTurretAmmo setMarkerAlpha setMarkerAlphaLocal setMarkerBrush setMarkerBrushLocal setMarkerColor setMarkerColorLocal setMarkerDir setMarkerDirLocal setMarkerPos setMarkerPosLocal setMarkerShape setMarkerShapeLocal setMarkerSize setMarkerSizeLocal setMarkerText setMarkerTextLocal setMarkerType setMarkerTypeLocal setMass setMimic setMousePosition setMusicEffect setMusicEventHandler setName setNameSound setObjectArguments setObjectMaterial setObjectMaterialGlobal setObjectProxy setObjectTexture setObjectTextureGlobal setObjectViewDistance setOvercast setOwner setOxygenRemaining setParticleCircle setParticleClass setParticleFire setParticleParams setParticleRandom setPilotCameraDirection setPilotCameraRotation setPilotCameraTarget setPilotLight setPiPEffect setPitch setPlateNumber setPlayable setPlayerRespawnTime setPos setPosASL setPosASL2 setPosASLW setPosATL setPosition setPosWorld setPylonLoadOut setPylonsPriority setRadioMsg setRain setRainbow setRandomLip setRank setRectangular setRepairCargo setRotorBrakeRTD setShadowDistance setShotParents setSide setSimpleTaskAlwaysVisible setSimpleTaskCustomData setSimpleTaskDescription setSimpleTaskDestination setSimpleTaskTarget setSimpleTaskType setSimulWeatherLayers setSize setSkill setSlingLoad setSoundEffect setSpeaker setSpeech setSpeedMode setStamina setStaminaScheme setStatValue setSuppression setSystemOfUnits setTargetAge setTaskMarkerOffset setTaskResult setTaskState setTerrainGrid setText setTimeMultiplier setTitleEffect setTrafficDensity setTrafficDistance setTrafficGap setTrafficSpeed setTriggerActivation setTriggerArea setTriggerStatements setTriggerText setTriggerTimeout setTriggerType setType setUnconscious setUnitAbility setUnitLoadout setUnitPos setUnitPosWeak setUnitRank setUnitRecoilCoefficient setUnitTrait setUnloadInCombat setUserActionText setUserMFDText setUserMFDvalue setVariable setVectorDir setVectorDirAndUp setVectorUp setVehicleAmmo setVehicleAmmoDef setVehicleArmor setVehicleCargo setVehicleId setVehicleLock setVehiclePosition setVehicleRadar setVehicleReceiveRemoteTargets setVehicleReportOwnPosition setVehicleReportRemoteTargets setVehicleTIPars setVehicleVarName setVelocity setVelocityModelSpace setVelocityTransformation setViewDistance setVisibleIfTreeCollapsed setWantedRPMRTD setWaves setWaypointBehaviour setWaypointCombatMode setWaypointCompletionRadius setWaypointDescription setWaypointForceBehaviour setWaypointFormation setWaypointHousePosition setWaypointLoiterRadius setWaypointLoiterType setWaypointName setWaypointPosition setWaypointScript setWaypointSpeed setWaypointStatements setWaypointTimeout setWaypointType setWaypointVisible setWeaponReloadingTime setWind setWindDir setWindForce setWindStr setWingForceScaleRTD setWPPos show3DIcons showChat showCinemaBorder showCommandingMenu showCompass showCuratorCompass showGPS showHUD showLegend showMap shownArtilleryComputer shownChat shownCompass shownCuratorCompass showNewEditorObject shownGPS shownHUD shownMap shownPad shownRadio shownScoretable shownUAVFeed shownWarrant shownWatch showPad showRadio showScoretable showSubtitles showUAVFeed showWarrant showWatch showWaypoint showWaypoints side sideChat sideEnemy sideFriendly sideRadio simpleTasks simulationEnabled simulCloudDensity simulCloudOcclusion simulInClouds simulWeatherSync sin size sizeOf skill skillFinal skipTime sleep sliderPosition sliderRange sliderSetPosition sliderSetRange sliderSetSpeed sliderSpeed slingLoadAssistantShown soldierMagazines someAmmo sort soundVolume spawn speaker speed speedMode splitString sqrt squadParams stance startLoadingScreen step stop stopEngineRTD stopped str sunOrMoon supportInfo suppressFor surfaceIsWater surfaceNormal surfaceType swimInDepth switchableUnits switchAction switchCamera switchGesture switchLight switchMove synchronizedObjects synchronizedTriggers synchronizedWaypoints synchronizeObjectsAdd synchronizeObjectsRemove synchronizeTrigger synchronizeWaypoint systemChat systemOfUnits tan targetKnowledge targets targetsAggregate targetsQuery taskAlwaysVisible taskChildren taskCompleted taskCustomData taskDescription taskDestination taskHint taskMarkerOffset taskParent taskResult taskState taskType teamMember teamName teams teamSwitch teamSwitchEnabled teamType terminate terrainIntersect terrainIntersectASL terrainIntersectAtASL text textLog textLogFormat tg time timeMultiplier titleCut titleFadeOut titleObj titleRsc titleText toArray toFixed toLower toString toUpper triggerActivated triggerActivation triggerArea triggerAttachedVehicle triggerAttachObject triggerAttachVehicle triggerDynamicSimulation triggerStatements triggerText triggerTimeout triggerTimeoutCurrent triggerType turretLocal turretOwner turretUnit tvAdd tvClear tvCollapse tvCollapseAll tvCount tvCurSel tvData tvDelete tvExpand tvExpandAll tvPicture tvSetColor tvSetCurSel tvSetData tvSetPicture tvSetPictureColor tvSetPictureColorDisabled tvSetPictureColorSelected tvSetPictureRight tvSetPictureRightColor tvSetPictureRightColorDisabled tvSetPictureRightColorSelected tvSetText tvSetTooltip tvSetValue tvSort tvSortByValue tvText tvTooltip tvValue type typeName typeOf UAVControl uiNamespace uiSleep unassignCurator unassignItem unassignTeam unassignVehicle underwater uniform uniformContainer uniformItems uniformMagazines unitAddons unitAimPosition unitAimPositionVisual unitBackpack unitIsUAV unitPos unitReady unitRecoilCoefficient units unitsBelowHeight unlinkItem unlockAchievement unregisterTask updateDrawIcon updateMenuItem updateObjectTree useAISteeringComponent useAudioTimeForMoves userInputDisabled vectorAdd vectorCos vectorCrossProduct vectorDiff vectorDir vectorDirVisual vectorDistance vectorDistanceSqr vectorDotProduct vectorFromTo vectorMagnitude vectorMagnitudeSqr vectorModelToWorld vectorModelToWorldVisual vectorMultiply vectorNormalized vectorUp vectorUpVisual vectorWorldToModel vectorWorldToModelVisual vehicle vehicleCargoEnabled vehicleChat vehicleRadio vehicleReceiveRemoteTargets vehicleReportOwnPosition vehicleReportRemoteTargets vehicles vehicleVarName velocity velocityModelSpace verifySignature vest vestContainer vestItems vestMagazines viewDistance visibleCompass visibleGPS visibleMap visiblePosition visiblePositionASL visibleScoretable visibleWatch waves waypointAttachedObject waypointAttachedVehicle waypointAttachObject waypointAttachVehicle waypointBehaviour waypointCombatMode waypointCompletionRadius waypointDescription waypointForceBehaviour waypointFormation waypointHousePosition waypointLoiterRadius waypointLoiterType waypointName waypointPosition waypoints waypointScript waypointsEnabledUAV waypointShow waypointSpeed waypointStatements waypointTimeout waypointTimeoutCurrent waypointType waypointVisible weaponAccessories weaponAccessoriesCargo weaponCargo weaponDirection weaponInertia weaponLowered weapons weaponsItems weaponsItemsCargo weaponState weaponsTurret weightRTD WFSideText wind ",
            literal: "blufor civilian configNull controlNull displayNull east endl false grpNull independent lineBreak locationNull nil objNull opfor pi resistance scriptNull sideAmbientLife sideEmpty sideLogic sideUnknown taskNull teamMemberNull true west"
        },
        contains: [
            hljs.C_LINE_COMMENT_MODE,
            hljs.C_BLOCK_COMMENT_MODE,
            hljs.NUMBER_MODE,
            VARIABLE,
            FUNCTION,
            STRINGS,
            PREPROCESSOR
        ],
        illegal: /#|^\$ /
    };
};

});

parcelRegister("5VO9I", function(module, exports) {
module.exports = function(hljs) {
    var COMMENT_MODE = hljs.COMMENT("--", "$");
    return {
        case_insensitive: true,
        illegal: /[<>{}*]/,
        contains: [
            {
                beginKeywords: "begin end start commit rollback savepoint lock alter create drop rename call delete do handler insert load replace select truncate update set show pragma grant merge describe use explain help declare prepare execute deallocate release unlock purge reset change stop analyze cache flush optimize repair kill install uninstall checksum restore check backup revoke comment values with",
                end: /;/,
                endsWithParent: true,
                lexemes: /[\w\.]+/,
                keywords: {
                    keyword: "as abort abs absolute acc acce accep accept access accessed accessible account acos action activate add addtime admin administer advanced advise aes_decrypt aes_encrypt after agent aggregate ali alia alias all allocate allow alter always analyze ancillary and anti any anydata anydataset anyschema anytype apply archive archived archivelog are as asc ascii asin assembly assertion associate asynchronous at atan atn2 attr attri attrib attribu attribut attribute attributes audit authenticated authentication authid authors auto autoallocate autodblink autoextend automatic availability avg backup badfile basicfile before begin beginning benchmark between bfile bfile_base big bigfile bin binary_double binary_float binlog bit_and bit_count bit_length bit_or bit_xor bitmap blob_base block blocksize body both bound bucket buffer_cache buffer_pool build bulk by byte byteordermark bytes cache caching call calling cancel capacity cascade cascaded case cast catalog category ceil ceiling chain change changed char_base char_length character_length characters characterset charindex charset charsetform charsetid check checksum checksum_agg child choose chr chunk class cleanup clear client clob clob_base clone close cluster_id cluster_probability cluster_set clustering coalesce coercibility col collate collation collect colu colum column column_value columns columns_updated comment commit compact compatibility compiled complete composite_limit compound compress compute concat concat_ws concurrent confirm conn connec connect connect_by_iscycle connect_by_isleaf connect_by_root connect_time connection consider consistent constant constraint constraints constructor container content contents context contributors controlfile conv convert convert_tz corr corr_k corr_s corresponding corruption cos cost count count_big counted covar_pop covar_samp cpu_per_call cpu_per_session crc32 create creation critical cross cube cume_dist curdate current current_date current_time current_timestamp current_user cursor curtime customdatum cycle data database databases datafile datafiles datalength date_add date_cache date_format date_sub dateadd datediff datefromparts datename datepart datetime2fromparts day day_to_second dayname dayofmonth dayofweek dayofyear days db_role_change dbtimezone ddl deallocate declare decode decompose decrement decrypt deduplicate def defa defau defaul default defaults deferred defi defin define degrees delayed delegate delete delete_all delimited demand dense_rank depth dequeue des_decrypt des_encrypt des_key_file desc descr descri describ describe descriptor deterministic diagnostics difference dimension direct_load directory disable disable_all disallow disassociate discardfile disconnect diskgroup distinct distinctrow distribute distributed div do document domain dotnet double downgrade drop dumpfile duplicate duration each edition editionable editions element ellipsis else elsif elt empty enable enable_all enclosed encode encoding encrypt end end-exec endian enforced engine engines enqueue enterprise entityescaping eomonth error errors escaped evalname evaluate event eventdata events except exception exceptions exchange exclude excluding execu execut execute exempt exists exit exp expire explain explode export export_set extended extent external external_1 external_2 externally extract failed failed_login_attempts failover failure far fast feature_set feature_value fetch field fields file file_name_convert filesystem_like_logging final finish first first_value fixed flash_cache flashback floor flush following follows for forall force foreign form forma format found found_rows freelist freelists freepools fresh from from_base64 from_days ftp full function general generated get get_format get_lock getdate getutcdate global global_name globally go goto grant grants greatest group group_concat group_id grouping grouping_id groups gtid_subtract guarantee guard handler hash hashkeys having hea head headi headin heading heap help hex hierarchy high high_priority hosts hour hours http id ident_current ident_incr ident_seed identified identity idle_time if ifnull ignore iif ilike ilm immediate import in include including increment index indexes indexing indextype indicator indices inet6_aton inet6_ntoa inet_aton inet_ntoa infile initial initialized initially initrans inmemory inner innodb input insert install instance instantiable instr interface interleaved intersect into invalidate invisible is is_free_lock is_ipv4 is_ipv4_compat is_not is_not_null is_used_lock isdate isnull isolation iterate java join json json_exists keep keep_duplicates key keys kill language large last last_day last_insert_id last_value lateral lax lcase lead leading least leaves left len lenght length less level levels library like like2 like4 likec limit lines link list listagg little ln load load_file lob lobs local localtime localtimestamp locate locator lock locked log log10 log2 logfile logfiles logging logical logical_reads_per_call logoff logon logs long loop low low_priority lower lpad lrtrim ltrim main make_set makedate maketime managed management manual map mapping mask master master_pos_wait match matched materialized max maxextents maximize maxinstances maxlen maxlogfiles maxloghistory maxlogmembers maxsize maxtrans md5 measures median medium member memcompress memory merge microsecond mid migration min minextents minimum mining minus minute minutes minvalue missing mod mode model modification modify module monitoring month months mount move movement multiset mutex name name_const names nan national native natural nav nchar nclob nested never new newline next nextval no no_write_to_binlog noarchivelog noaudit nobadfile nocheck nocompress nocopy nocycle nodelay nodiscardfile noentityescaping noguarantee nokeep nologfile nomapping nomaxvalue nominimize nominvalue nomonitoring none noneditionable nonschema noorder nopr nopro noprom nopromp noprompt norely noresetlogs noreverse normal norowdependencies noschemacheck noswitch not nothing notice notnull notrim novalidate now nowait nth_value nullif nulls num numb numbe nvarchar nvarchar2 object ocicoll ocidate ocidatetime ociduration ociinterval ociloblocator ocinumber ociref ocirefcursor ocirowid ocistring ocitype oct octet_length of off offline offset oid oidindex old on online only opaque open operations operator optimal optimize option optionally or oracle oracle_date oradata ord ordaudio orddicom orddoc order ordimage ordinality ordvideo organization orlany orlvary out outer outfile outline output over overflow overriding package pad parallel parallel_enable parameters parent parse partial partition partitions pascal passing password password_grace_time password_lock_time password_reuse_max password_reuse_time password_verify_function patch path patindex pctincrease pctthreshold pctused pctversion percent percent_rank percentile_cont percentile_disc performance period period_add period_diff permanent physical pi pipe pipelined pivot pluggable plugin policy position post_transaction pow power pragma prebuilt precedes preceding precision prediction prediction_cost prediction_details prediction_probability prediction_set prepare present preserve prior priority private private_sga privileges procedural procedure procedure_analyze processlist profiles project prompt protection public publishingservername purge quarter query quick quiesce quota quotename radians raise rand range rank raw read reads readsize rebuild record records recover recovery recursive recycle redo reduced ref reference referenced references referencing refresh regexp_like register regr_avgx regr_avgy regr_count regr_intercept regr_r2 regr_slope regr_sxx regr_sxy reject rekey relational relative relaylog release release_lock relies_on relocate rely rem remainder rename repair repeat replace replicate replication required reset resetlogs resize resource respect restore restricted result result_cache resumable resume retention return returning returns reuse reverse revoke right rlike role roles rollback rolling rollup round row row_count rowdependencies rowid rownum rows rtrim rules safe salt sample save savepoint sb1 sb2 sb4 scan schema schemacheck scn scope scroll sdo_georaster sdo_topo_geometry search sec_to_time second seconds section securefile security seed segment select self semi sequence sequential serializable server servererror session session_user sessions_per_user set sets settings sha sha1 sha2 share shared shared_pool short show shrink shutdown si_averagecolor si_colorhistogram si_featurelist si_positionalcolor si_stillimage si_texture siblings sid sign sin size size_t sizes skip slave sleep smalldatetimefromparts smallfile snapshot some soname sort soundex source space sparse spfile split sql sql_big_result sql_buffer_result sql_cache sql_calc_found_rows sql_small_result sql_variant_property sqlcode sqldata sqlerror sqlname sqlstate sqrt square standalone standby start starting startup statement static statistics stats_binomial_test stats_crosstab stats_ks_test stats_mode stats_mw_test stats_one_way_anova stats_t_test_ stats_t_test_indep stats_t_test_one stats_t_test_paired stats_wsr_test status std stddev stddev_pop stddev_samp stdev stop storage store stored str str_to_date straight_join strcmp strict string struct stuff style subdate subpartition subpartitions substitutable substr substring subtime subtring_index subtype success sum suspend switch switchoffset switchover sync synchronous synonym sys sys_xmlagg sysasm sysaux sysdate sysdatetimeoffset sysdba sysoper system system_user sysutcdatetime table tables tablespace tablesample tan tdo template temporary terminated tertiary_weights test than then thread through tier ties time time_format time_zone timediff timefromparts timeout timestamp timestampadd timestampdiff timezone_abbr timezone_minute timezone_region to to_base64 to_date to_days to_seconds todatetimeoffset trace tracking transaction transactional translate translation treat trigger trigger_nestlevel triggers trim truncate try_cast try_convert try_parse type ub1 ub2 ub4 ucase unarchived unbounded uncompress under undo unhex unicode uniform uninstall union unique unix_timestamp unknown unlimited unlock unnest unpivot unrecoverable unsafe unsigned until untrusted unusable unused update updated upgrade upped upper upsert url urowid usable usage use use_stored_outlines user user_data user_resources users using utc_date utc_timestamp uuid uuid_short validate validate_password_strength validation valist value values var var_samp varcharc vari varia variab variabl variable variables variance varp varraw varrawc varray verify version versions view virtual visible void wait wallet warning warnings week weekday weekofyear wellformed when whene whenev wheneve whenever where while whitespace window with within without work wrapped xdb xml xmlagg xmlattributes xmlcast xmlcolattval xmlelement xmlexists xmlforest xmlindex xmlnamespaces xmlpi xmlquery xmlroot xmlschema xmlserialize xmltable xmltype xor year year_to_month years yearweek",
                    literal: "true false null unknown",
                    built_in: "array bigint binary bit blob bool boolean char character date dec decimal float int int8 integer interval number numeric real record serial serial8 smallint text time timestamp tinyint varchar varchar2 varying void"
                },
                contains: [
                    {
                        className: "string",
                        begin: "'",
                        end: "'",
                        contains: [
                            {
                                begin: "''"
                            }
                        ]
                    },
                    {
                        className: "string",
                        begin: '"',
                        end: '"',
                        contains: [
                            {
                                begin: '""'
                            }
                        ]
                    },
                    {
                        className: "string",
                        begin: "`",
                        end: "`"
                    },
                    hljs.C_NUMBER_MODE,
                    hljs.C_BLOCK_COMMENT_MODE,
                    COMMENT_MODE,
                    hljs.HASH_COMMENT_MODE
                ]
            },
            hljs.C_BLOCK_COMMENT_MODE,
            COMMENT_MODE,
            hljs.HASH_COMMENT_MODE
        ]
    };
};

});

parcelRegister("djWDs", function(module, exports) {
module.exports = function(hljs) {
    // variable names cannot conflict with block identifiers
    var BLOCKS = [
        "functions",
        "model",
        "data",
        "parameters",
        "quantities",
        "transformed",
        "generated"
    ];
    var STATEMENTS = [
        "for",
        "in",
        "if",
        "else",
        "while",
        "break",
        "continue",
        "return"
    ];
    var SPECIAL_FUNCTIONS = [
        "print",
        "reject",
        "increment_log_prob|10",
        "integrate_ode|10",
        "integrate_ode_rk45|10",
        "integrate_ode_bdf|10",
        "algebra_solver"
    ];
    var VAR_TYPES = [
        "int",
        "real",
        "vector",
        "ordered",
        "positive_ordered",
        "simplex",
        "unit_vector",
        "row_vector",
        "matrix",
        "cholesky_factor_corr|10",
        "cholesky_factor_cov|10",
        "corr_matrix|10",
        "cov_matrix|10",
        "void"
    ];
    var FUNCTIONS = [
        "Phi",
        "Phi_approx",
        "abs",
        "acos",
        "acosh",
        "algebra_solver",
        "append_array",
        "append_col",
        "append_row",
        "asin",
        "asinh",
        "atan",
        "atan2",
        "atanh",
        "bernoulli_cdf",
        "bernoulli_lccdf",
        "bernoulli_lcdf",
        "bernoulli_logit_lpmf",
        "bernoulli_logit_rng",
        "bernoulli_lpmf",
        "bernoulli_rng",
        "bessel_first_kind",
        "bessel_second_kind",
        "beta_binomial_cdf",
        "beta_binomial_lccdf",
        "beta_binomial_lcdf",
        "beta_binomial_lpmf",
        "beta_binomial_rng",
        "beta_cdf",
        "beta_lccdf",
        "beta_lcdf",
        "beta_lpdf",
        "beta_rng",
        "binary_log_loss",
        "binomial_cdf",
        "binomial_coefficient_log",
        "binomial_lccdf",
        "binomial_lcdf",
        "binomial_logit_lpmf",
        "binomial_lpmf",
        "binomial_rng",
        "block",
        "categorical_logit_lpmf",
        "categorical_logit_rng",
        "categorical_lpmf",
        "categorical_rng",
        "cauchy_cdf",
        "cauchy_lccdf",
        "cauchy_lcdf",
        "cauchy_lpdf",
        "cauchy_rng",
        "cbrt",
        "ceil",
        "chi_square_cdf",
        "chi_square_lccdf",
        "chi_square_lcdf",
        "chi_square_lpdf",
        "chi_square_rng",
        "cholesky_decompose",
        "choose",
        "col",
        "cols",
        "columns_dot_product",
        "columns_dot_self",
        "cos",
        "cosh",
        "cov_exp_quad",
        "crossprod",
        "csr_extract_u",
        "csr_extract_v",
        "csr_extract_w",
        "csr_matrix_times_vector",
        "csr_to_dense_matrix",
        "cumulative_sum",
        "determinant",
        "diag_matrix",
        "diag_post_multiply",
        "diag_pre_multiply",
        "diagonal",
        "digamma",
        "dims",
        "dirichlet_lpdf",
        "dirichlet_rng",
        "distance",
        "dot_product",
        "dot_self",
        "double_exponential_cdf",
        "double_exponential_lccdf",
        "double_exponential_lcdf",
        "double_exponential_lpdf",
        "double_exponential_rng",
        "e",
        "eigenvalues_sym",
        "eigenvectors_sym",
        "erf",
        "erfc",
        "exp",
        "exp2",
        "exp_mod_normal_cdf",
        "exp_mod_normal_lccdf",
        "exp_mod_normal_lcdf",
        "exp_mod_normal_lpdf",
        "exp_mod_normal_rng",
        "expm1",
        "exponential_cdf",
        "exponential_lccdf",
        "exponential_lcdf",
        "exponential_lpdf",
        "exponential_rng",
        "fabs",
        "falling_factorial",
        "fdim",
        "floor",
        "fma",
        "fmax",
        "fmin",
        "fmod",
        "frechet_cdf",
        "frechet_lccdf",
        "frechet_lcdf",
        "frechet_lpdf",
        "frechet_rng",
        "gamma_cdf",
        "gamma_lccdf",
        "gamma_lcdf",
        "gamma_lpdf",
        "gamma_p",
        "gamma_q",
        "gamma_rng",
        "gaussian_dlm_obs_lpdf",
        "get_lp",
        "gumbel_cdf",
        "gumbel_lccdf",
        "gumbel_lcdf",
        "gumbel_lpdf",
        "gumbel_rng",
        "head",
        "hypergeometric_lpmf",
        "hypergeometric_rng",
        "hypot",
        "inc_beta",
        "int_step",
        "integrate_ode",
        "integrate_ode_bdf",
        "integrate_ode_rk45",
        "inv",
        "inv_Phi",
        "inv_chi_square_cdf",
        "inv_chi_square_lccdf",
        "inv_chi_square_lcdf",
        "inv_chi_square_lpdf",
        "inv_chi_square_rng",
        "inv_cloglog",
        "inv_gamma_cdf",
        "inv_gamma_lccdf",
        "inv_gamma_lcdf",
        "inv_gamma_lpdf",
        "inv_gamma_rng",
        "inv_logit",
        "inv_sqrt",
        "inv_square",
        "inv_wishart_lpdf",
        "inv_wishart_rng",
        "inverse",
        "inverse_spd",
        "is_inf",
        "is_nan",
        "lbeta",
        "lchoose",
        "lgamma",
        "lkj_corr_cholesky_lpdf",
        "lkj_corr_cholesky_rng",
        "lkj_corr_lpdf",
        "lkj_corr_rng",
        "lmgamma",
        "lmultiply",
        "log",
        "log10",
        "log1m",
        "log1m_exp",
        "log1m_inv_logit",
        "log1p",
        "log1p_exp",
        "log2",
        "log_determinant",
        "log_diff_exp",
        "log_falling_factorial",
        "log_inv_logit",
        "log_mix",
        "log_rising_factorial",
        "log_softmax",
        "log_sum_exp",
        "logistic_cdf",
        "logistic_lccdf",
        "logistic_lcdf",
        "logistic_lpdf",
        "logistic_rng",
        "logit",
        "lognormal_cdf",
        "lognormal_lccdf",
        "lognormal_lcdf",
        "lognormal_lpdf",
        "lognormal_rng",
        "machine_precision",
        "matrix_exp",
        "max",
        "mdivide_left_spd",
        "mdivide_left_tri_low",
        "mdivide_right_spd",
        "mdivide_right_tri_low",
        "mean",
        "min",
        "modified_bessel_first_kind",
        "modified_bessel_second_kind",
        "multi_gp_cholesky_lpdf",
        "multi_gp_lpdf",
        "multi_normal_cholesky_lpdf",
        "multi_normal_cholesky_rng",
        "multi_normal_lpdf",
        "multi_normal_prec_lpdf",
        "multi_normal_rng",
        "multi_student_t_lpdf",
        "multi_student_t_rng",
        "multinomial_lpmf",
        "multinomial_rng",
        "multiply_log",
        "multiply_lower_tri_self_transpose",
        "neg_binomial_2_cdf",
        "neg_binomial_2_lccdf",
        "neg_binomial_2_lcdf",
        "neg_binomial_2_log_lpmf",
        "neg_binomial_2_log_rng",
        "neg_binomial_2_lpmf",
        "neg_binomial_2_rng",
        "neg_binomial_cdf",
        "neg_binomial_lccdf",
        "neg_binomial_lcdf",
        "neg_binomial_lpmf",
        "neg_binomial_rng",
        "negative_infinity",
        "normal_cdf",
        "normal_lccdf",
        "normal_lcdf",
        "normal_lpdf",
        "normal_rng",
        "not_a_number",
        "num_elements",
        "ordered_logistic_lpmf",
        "ordered_logistic_rng",
        "owens_t",
        "pareto_cdf",
        "pareto_lccdf",
        "pareto_lcdf",
        "pareto_lpdf",
        "pareto_rng",
        "pareto_type_2_cdf",
        "pareto_type_2_lccdf",
        "pareto_type_2_lcdf",
        "pareto_type_2_lpdf",
        "pareto_type_2_rng",
        "pi",
        "poisson_cdf",
        "poisson_lccdf",
        "poisson_lcdf",
        "poisson_log_lpmf",
        "poisson_log_rng",
        "poisson_lpmf",
        "poisson_rng",
        "positive_infinity",
        "pow",
        "print",
        "prod",
        "qr_Q",
        "qr_R",
        "quad_form",
        "quad_form_diag",
        "quad_form_sym",
        "rank",
        "rayleigh_cdf",
        "rayleigh_lccdf",
        "rayleigh_lcdf",
        "rayleigh_lpdf",
        "rayleigh_rng",
        "reject",
        "rep_array",
        "rep_matrix",
        "rep_row_vector",
        "rep_vector",
        "rising_factorial",
        "round",
        "row",
        "rows",
        "rows_dot_product",
        "rows_dot_self",
        "scaled_inv_chi_square_cdf",
        "scaled_inv_chi_square_lccdf",
        "scaled_inv_chi_square_lcdf",
        "scaled_inv_chi_square_lpdf",
        "scaled_inv_chi_square_rng",
        "sd",
        "segment",
        "sin",
        "singular_values",
        "sinh",
        "size",
        "skew_normal_cdf",
        "skew_normal_lccdf",
        "skew_normal_lcdf",
        "skew_normal_lpdf",
        "skew_normal_rng",
        "softmax",
        "sort_asc",
        "sort_desc",
        "sort_indices_asc",
        "sort_indices_desc",
        "sqrt",
        "sqrt2",
        "square",
        "squared_distance",
        "step",
        "student_t_cdf",
        "student_t_lccdf",
        "student_t_lcdf",
        "student_t_lpdf",
        "student_t_rng",
        "sub_col",
        "sub_row",
        "sum",
        "tail",
        "tan",
        "tanh",
        "target",
        "tcrossprod",
        "tgamma",
        "to_array_1d",
        "to_array_2d",
        "to_matrix",
        "to_row_vector",
        "to_vector",
        "trace",
        "trace_gen_quad_form",
        "trace_quad_form",
        "trigamma",
        "trunc",
        "uniform_cdf",
        "uniform_lccdf",
        "uniform_lcdf",
        "uniform_lpdf",
        "uniform_rng",
        "variance",
        "von_mises_lpdf",
        "von_mises_rng",
        "weibull_cdf",
        "weibull_lccdf",
        "weibull_lcdf",
        "weibull_lpdf",
        "weibull_rng",
        "wiener_lpdf",
        "wishart_lpdf",
        "wishart_rng"
    ];
    var DISTRIBUTIONS = [
        "bernoulli",
        "bernoulli_logit",
        "beta",
        "beta_binomial",
        "binomial",
        "binomial_logit",
        "categorical",
        "categorical_logit",
        "cauchy",
        "chi_square",
        "dirichlet",
        "double_exponential",
        "exp_mod_normal",
        "exponential",
        "frechet",
        "gamma",
        "gaussian_dlm_obs",
        "gumbel",
        "hypergeometric",
        "inv_chi_square",
        "inv_gamma",
        "inv_wishart",
        "lkj_corr",
        "lkj_corr_cholesky",
        "logistic",
        "lognormal",
        "multi_gp",
        "multi_gp_cholesky",
        "multi_normal",
        "multi_normal_cholesky",
        "multi_normal_prec",
        "multi_student_t",
        "multinomial",
        "neg_binomial",
        "neg_binomial_2",
        "neg_binomial_2_log",
        "normal",
        "ordered_logistic",
        "pareto",
        "pareto_type_2",
        "poisson",
        "poisson_log",
        "rayleigh",
        "scaled_inv_chi_square",
        "skew_normal",
        "student_t",
        "uniform",
        "von_mises",
        "weibull",
        "wiener",
        "wishart"
    ];
    return {
        aliases: [
            "stanfuncs"
        ],
        keywords: {
            "title": BLOCKS.join(" "),
            "keyword": STATEMENTS.concat(VAR_TYPES).concat(SPECIAL_FUNCTIONS).join(" "),
            "built_in": FUNCTIONS.join(" ")
        },
        lexemes: hljs.IDENT_RE,
        contains: [
            hljs.C_LINE_COMMENT_MODE,
            hljs.COMMENT(/#/, /$/, {
                relevance: 0,
                keywords: {
                    "meta-keyword": "include"
                }
            }),
            hljs.COMMENT(/\/\*/, /\*\//, {
                relevance: 0,
                // highlight doc strings mentioned in Stan reference
                contains: [
                    {
                        className: "doctag",
                        begin: /@(return|param)/
                    }
                ]
            }),
            {
                // hack: in range constraints, lower must follow "<"
                begin: /<\s*lower\s*=/,
                keywords: "lower"
            },
            {
                // hack: in range constraints, upper must follow either , or <
                // <lower = ..., upper = ...> or <upper = ...>
                begin: /[<,]*upper\s*=/,
                keywords: "upper"
            },
            {
                className: "keyword",
                begin: /\btarget\s*\+=/,
                relevance: 10
            },
            {
                begin: "~\\s*(" + hljs.IDENT_RE + ")\\s*\\(",
                keywords: DISTRIBUTIONS.join(" ")
            },
            {
                className: "number",
                variants: [
                    {
                        begin: /\b\d+(?:\.\d*)?(?:[eE][+-]?\d+)?/
                    },
                    {
                        begin: /\.\d+(?:[eE][+-]?\d+)?\b/
                    }
                ],
                relevance: 0
            },
            {
                className: "string",
                begin: '"',
                end: '"',
                relevance: 0
            }
        ]
    };
};

});

parcelRegister("czGB8", function(module, exports) {
module.exports = /*
  This is a fork and modification of Drew McDonald's file (https://github.com/drewmcdonald/stata-highlighting). I have also included a list of builtin commands from https://bugs.kde.org/show_bug.cgi?id=135646.
*/ function(hljs) {
    return {
        aliases: [
            "do",
            "ado"
        ],
        case_insensitive: true,
        keywords: "if else in foreach for forv forva forval forvalu forvalue forvalues by bys bysort xi quietly qui capture about ac ac_7 acprplot acprplot_7 adjust ado adopath adoupdate alpha ameans an ano anov anova anova_estat anova_terms anovadef aorder ap app appe appen append arch arch_dr arch_estat arch_p archlm areg areg_p args arima arima_dr arima_estat arima_p as asmprobit asmprobit_estat asmprobit_lf asmprobit_mfx__dlg asmprobit_p ass asse asser assert avplot avplot_7 avplots avplots_7 bcskew0 bgodfrey bias binreg bip0_lf biplot bipp_lf bipr_lf bipr_p biprobit bitest bitesti bitowt blogit bmemsize boot bootsamp bootstrap bootstrap_8 boxco_l boxco_p boxcox boxcox_6 boxcox_p bprobit br break brier bro brow brows browse brr brrstat bs bs_7 bsampl_w bsample bsample_7 bsqreg bstat bstat_7 bstat_8 bstrap bstrap_7 bubble bubbleplot ca ca_estat ca_p cabiplot camat canon canon_8 canon_8_p canon_estat canon_p cap caprojection capt captu captur capture cat cc cchart cchart_7 cci cd censobs_table centile cf char chdir checkdlgfiles checkestimationsample checkhlpfiles checksum chelp ci cii cl class classutil clear cli clis clist clo clog clog_lf clog_p clogi clogi_sw clogit clogit_lf clogit_p clogitp clogl_sw cloglog clonevar clslistarray cluster cluster_measures cluster_stop cluster_tree cluster_tree_8 clustermat cmdlog cnr cnre cnreg cnreg_p cnreg_sw cnsreg codebook collaps4 collapse colormult_nb colormult_nw compare compress conf confi confir confirm conren cons const constr constra constrai constrain constraint continue contract copy copyright copysource cor corc corr corr2data corr_anti corr_kmo corr_smc corre correl correla correlat correlate corrgram cou coun count cox cox_p cox_sw coxbase coxhaz coxvar cprplot cprplot_7 crc cret cretu cretur creturn cross cs cscript cscript_log csi ct ct_is ctset ctst_5 ctst_st cttost cumsp cumsp_7 cumul cusum cusum_7 cutil d|0 datasig datasign datasigna datasignat datasignatu datasignatur datasignature datetof db dbeta de dec deco decod decode deff des desc descr descri describ describe destring dfbeta dfgls dfuller di di_g dir dirstats dis discard disp disp_res disp_s displ displa display distinct do doe doed doedi doedit dotplot dotplot_7 dprobit drawnorm drop ds ds_util dstdize duplicates durbina dwstat dydx e|0 ed edi edit egen eivreg emdef en enc enco encod encode eq erase ereg ereg_lf ereg_p ereg_sw ereghet ereghet_glf ereghet_glf_sh ereghet_gp ereghet_ilf ereghet_ilf_sh ereghet_ip eret eretu eretur ereturn err erro error esize est est_cfexist est_cfname est_clickable est_expand est_hold est_table est_unhold est_unholdok estat estat_default estat_summ estat_vce_only esti estimates etodow etof etomdy ex exi exit expand expandcl fac fact facto factor factor_estat factor_p factor_pca_rotated factor_rotate factormat fcast fcast_compute fcast_graph fdades fdadesc fdadescr fdadescri fdadescrib fdadescribe fdasav fdasave fdause fh_st file open file read file close file filefilter fillin find_hlp_file findfile findit findit_7 fit fl fli flis flist for5_0 forest forestplot form forma format fpredict frac_154 frac_adj frac_chk frac_cox frac_ddp frac_dis frac_dv frac_in frac_mun frac_pp frac_pq frac_pv frac_wgt frac_xo fracgen fracplot fracplot_7 fracpoly fracpred fron_ex fron_hn fron_p fron_tn fron_tn2 frontier ftodate ftoe ftomdy ftowdate funnel funnelplot g|0 gamhet_glf gamhet_gp gamhet_ilf gamhet_ip gamma gamma_d2 gamma_p gamma_sw gammahet gdi_hexagon gdi_spokes ge gen gene gener genera generat generate genrank genstd genvmean gettoken gl gladder gladder_7 glim_l01 glim_l02 glim_l03 glim_l04 glim_l05 glim_l06 glim_l07 glim_l08 glim_l09 glim_l10 glim_l11 glim_l12 glim_lf glim_mu glim_nw1 glim_nw2 glim_nw3 glim_p glim_v1 glim_v2 glim_v3 glim_v4 glim_v5 glim_v6 glim_v7 glm glm_6 glm_p glm_sw glmpred glo glob globa global glogit glogit_8 glogit_p gmeans gnbre_lf gnbreg gnbreg_5 gnbreg_p gomp_lf gompe_sw gomper_p gompertz gompertzhet gomphet_glf gomphet_glf_sh gomphet_gp gomphet_ilf gomphet_ilf_sh gomphet_ip gphdot gphpen gphprint gprefs gprobi_p gprobit gprobit_8 gr gr7 gr_copy gr_current gr_db gr_describe gr_dir gr_draw gr_draw_replay gr_drop gr_edit gr_editviewopts gr_example gr_example2 gr_export gr_print gr_qscheme gr_query gr_read gr_rename gr_replay gr_save gr_set gr_setscheme gr_table gr_undo gr_use graph graph7 grebar greigen greigen_7 greigen_8 grmeanby grmeanby_7 gs_fileinfo gs_filetype gs_graphinfo gs_stat gsort gwood h|0 hadimvo hareg hausman haver he heck_d2 heckma_p heckman heckp_lf heckpr_p heckprob hel help hereg hetpr_lf hetpr_p hetprob hettest hexdump hilite hist hist_7 histogram hlogit hlu hmeans hotel hotelling hprobit hreg hsearch icd9 icd9_ff icd9p iis impute imtest inbase include inf infi infil infile infix inp inpu input ins insheet insp inspe inspec inspect integ inten intreg intreg_7 intreg_p intrg2_ll intrg_ll intrg_ll2 ipolate iqreg ir irf irf_create irfm iri is_svy is_svysum isid istdize ivprob_1_lf ivprob_lf ivprobit ivprobit_p ivreg ivreg_footnote ivtob_1_lf ivtob_lf ivtobit ivtobit_p jackknife jacknife jknife jknife_6 jknife_8 jkstat joinby kalarma1 kap kap_3 kapmeier kappa kapwgt kdensity kdensity_7 keep ksm ksmirnov ktau kwallis l|0 la lab labbe labbeplot labe label labelbook ladder levels levelsof leverage lfit lfit_p li lincom line linktest lis list lloghet_glf lloghet_glf_sh lloghet_gp lloghet_ilf lloghet_ilf_sh lloghet_ip llogi_sw llogis_p llogist llogistic llogistichet lnorm_lf lnorm_sw lnorma_p lnormal lnormalhet lnormhet_glf lnormhet_glf_sh lnormhet_gp lnormhet_ilf lnormhet_ilf_sh lnormhet_ip lnskew0 loadingplot loc loca local log logi logis_lf logistic logistic_p logit logit_estat logit_p loglogs logrank loneway lookfor lookup lowess lowess_7 lpredict lrecomp lroc lroc_7 lrtest ls lsens lsens_7 lsens_x lstat ltable ltable_7 ltriang lv lvr2plot lvr2plot_7 m|0 ma mac macr macro makecns man manova manova_estat manova_p manovatest mantel mark markin markout marksample mat mat_capp mat_order mat_put_rr mat_rapp mata mata_clear mata_describe mata_drop mata_matdescribe mata_matsave mata_matuse mata_memory mata_mlib mata_mosave mata_rename mata_which matalabel matcproc matlist matname matr matri matrix matrix_input__dlg matstrik mcc mcci md0_ md1_ md1debug_ md2_ md2debug_ mds mds_estat mds_p mdsconfig mdslong mdsmat mdsshepard mdytoe mdytof me_derd mean means median memory memsize menl meqparse mer merg merge meta mfp mfx mhelp mhodds minbound mixed_ll mixed_ll_reparm mkassert mkdir mkmat mkspline ml ml_5 ml_adjs ml_bhhhs ml_c_d ml_check ml_clear ml_cnt ml_debug ml_defd ml_e0 ml_e0_bfgs ml_e0_cycle ml_e0_dfp ml_e0i ml_e1 ml_e1_bfgs ml_e1_bhhh ml_e1_cycle ml_e1_dfp ml_e2 ml_e2_cycle ml_ebfg0 ml_ebfr0 ml_ebfr1 ml_ebh0q ml_ebhh0 ml_ebhr0 ml_ebr0i ml_ecr0i ml_edfp0 ml_edfr0 ml_edfr1 ml_edr0i ml_eds ml_eer0i ml_egr0i ml_elf ml_elf_bfgs ml_elf_bhhh ml_elf_cycle ml_elf_dfp ml_elfi ml_elfs ml_enr0i ml_enrr0 ml_erdu0 ml_erdu0_bfgs ml_erdu0_bhhh ml_erdu0_bhhhq ml_erdu0_cycle ml_erdu0_dfp ml_erdu0_nrbfgs ml_exde ml_footnote ml_geqnr ml_grad0 ml_graph ml_hbhhh ml_hd0 ml_hold ml_init ml_inv ml_log ml_max ml_mlout ml_mlout_8 ml_model ml_nb0 ml_opt ml_p ml_plot ml_query ml_rdgrd ml_repor ml_s_e ml_score ml_searc ml_technique ml_unhold mleval mlf_ mlmatbysum mlmatsum mlog mlogi mlogit mlogit_footnote mlogit_p mlopts mlsum mlvecsum mnl0_ mor more mov move mprobit mprobit_lf mprobit_p mrdu0_ mrdu1_ mvdecode mvencode mvreg mvreg_estat n|0 nbreg nbreg_al nbreg_lf nbreg_p nbreg_sw nestreg net newey newey_7 newey_p news nl nl_7 nl_9 nl_9_p nl_p nl_p_7 nlcom nlcom_p nlexp2 nlexp2_7 nlexp2a nlexp2a_7 nlexp3 nlexp3_7 nlgom3 nlgom3_7 nlgom4 nlgom4_7 nlinit nllog3 nllog3_7 nllog4 nllog4_7 nlog_rd nlogit nlogit_p nlogitgen nlogittree nlpred no nobreak noi nois noisi noisil noisily note notes notes_dlg nptrend numlabel numlist odbc old_ver olo olog ologi ologi_sw ologit ologit_p ologitp on one onew onewa oneway op_colnm op_comp op_diff op_inv op_str opr opro oprob oprob_sw oprobi oprobi_p oprobit oprobitp opts_exclusive order orthog orthpoly ou out outf outfi outfil outfile outs outsh outshe outshee outsheet ovtest pac pac_7 palette parse parse_dissim pause pca pca_8 pca_display pca_estat pca_p pca_rotate pcamat pchart pchart_7 pchi pchi_7 pcorr pctile pentium pergram pergram_7 permute permute_8 personal peto_st pkcollapse pkcross pkequiv pkexamine pkexamine_7 pkshape pksumm pksumm_7 pl plo plot plugin pnorm pnorm_7 poisgof poiss_lf poiss_sw poisso_p poisson poisson_estat post postclose postfile postutil pperron pr prais prais_e prais_e2 prais_p predict predictnl preserve print pro prob probi probit probit_estat probit_p proc_time procoverlay procrustes procrustes_estat procrustes_p profiler prog progr progra program prop proportion prtest prtesti pwcorr pwd q\\s qby qbys qchi qchi_7 qladder qladder_7 qnorm qnorm_7 qqplot qqplot_7 qreg qreg_c qreg_p qreg_sw qu quadchk quantile quantile_7 que quer query range ranksum ratio rchart rchart_7 rcof recast reclink recode reg reg3 reg3_p regdw regr regre regre_p2 regres regres_p regress regress_estat regriv_p remap ren rena renam rename renpfix repeat replace report reshape restore ret retu retur return rm rmdir robvar roccomp roccomp_7 roccomp_8 rocf_lf rocfit rocfit_8 rocgold rocplot rocplot_7 roctab roctab_7 rolling rologit rologit_p rot rota rotat rotate rotatemat rreg rreg_p ru run runtest rvfplot rvfplot_7 rvpplot rvpplot_7 sa safesum sample sampsi sav save savedresults saveold sc sca scal scala scalar scatter scm_mine sco scob_lf scob_p scobi_sw scobit scor score scoreplot scoreplot_help scree screeplot screeplot_help sdtest sdtesti se search separate seperate serrbar serrbar_7 serset set set_defaults sfrancia sh she shel shell shewhart shewhart_7 signestimationsample signrank signtest simul simul_7 simulate simulate_8 sktest sleep slogit slogit_d2 slogit_p smooth snapspan so sor sort spearman spikeplot spikeplot_7 spikeplt spline_x split sqreg sqreg_p sret sretu sretur sreturn ssc st st_ct st_hc st_hcd st_hcd_sh st_is st_issys st_note st_promo st_set st_show st_smpl st_subid stack statsby statsby_8 stbase stci stci_7 stcox stcox_estat stcox_fr stcox_fr_ll stcox_p stcox_sw stcoxkm stcoxkm_7 stcstat stcurv stcurve stcurve_7 stdes stem stepwise stereg stfill stgen stir stjoin stmc stmh stphplot stphplot_7 stphtest stphtest_7 stptime strate strate_7 streg streg_sw streset sts sts_7 stset stsplit stsum sttocc sttoct stvary stweib su suest suest_8 sum summ summa summar summari summariz summarize sunflower sureg survcurv survsum svar svar_p svmat svy svy_disp svy_dreg svy_est svy_est_7 svy_estat svy_get svy_gnbreg_p svy_head svy_header svy_heckman_p svy_heckprob_p svy_intreg_p svy_ivreg_p svy_logistic_p svy_logit_p svy_mlogit_p svy_nbreg_p svy_ologit_p svy_oprobit_p svy_poisson_p svy_probit_p svy_regress_p svy_sub svy_sub_7 svy_x svy_x_7 svy_x_p svydes svydes_8 svygen svygnbreg svyheckman svyheckprob svyintreg svyintreg_7 svyintrg svyivreg svylc svylog_p svylogit svymarkout svymarkout_8 svymean svymlog svymlogit svynbreg svyolog svyologit svyoprob svyoprobit svyopts svypois svypois_7 svypoisson svyprobit svyprobt svyprop svyprop_7 svyratio svyreg svyreg_p svyregress svyset svyset_7 svyset_8 svytab svytab_7 svytest svytotal sw sw_8 swcnreg swcox swereg swilk swlogis swlogit swologit swoprbt swpois swprobit swqreg swtobit swweib symmetry symmi symplot symplot_7 syntax sysdescribe sysdir sysuse szroeter ta tab tab1 tab2 tab_or tabd tabdi tabdis tabdisp tabi table tabodds tabodds_7 tabstat tabu tabul tabula tabulat tabulate te tempfile tempname tempvar tes test testnl testparm teststd tetrachoric time_it timer tis tob tobi tobit tobit_p tobit_sw token tokeni tokeniz tokenize tostring total translate translator transmap treat_ll treatr_p treatreg trim trimfill trnb_cons trnb_mean trpoiss_d2 trunc_ll truncr_p truncreg tsappend tset tsfill tsline tsline_ex tsreport tsrevar tsrline tsset tssmooth tsunab ttest ttesti tut_chk tut_wait tutorial tw tware_st two twoway twoway__fpfit_serset twoway__function_gen twoway__histogram_gen twoway__ipoint_serset twoway__ipoints_serset twoway__kdensity_gen twoway__lfit_serset twoway__normgen_gen twoway__pci_serset twoway__qfit_serset twoway__scatteri_serset twoway__sunflower_gen twoway_ksm_serset ty typ type typeof u|0 unab unabbrev unabcmd update us use uselabel var var_mkcompanion var_p varbasic varfcast vargranger varirf varirf_add varirf_cgraph varirf_create varirf_ctable varirf_describe varirf_dir varirf_drop varirf_erase varirf_graph varirf_ograph varirf_rename varirf_set varirf_table varlist varlmar varnorm varsoc varstable varstable_w varstable_w2 varwle vce vec vec_fevd vec_mkphi vec_p vec_p_w vecirf_create veclmar veclmar_w vecnorm vecnorm_w vecrank vecstable verinst vers versi versio version view viewsource vif vwls wdatetof webdescribe webseek webuse weib1_lf weib2_lf weib_lf weib_lf0 weibhet_glf weibhet_glf_sh weibhet_glfa weibhet_glfa_sh weibhet_gp weibhet_ilf weibhet_ilf_sh weibhet_ilfa weibhet_ilfa_sh weibhet_ip weibu_sw weibul_p weibull weibull_c weibull_s weibullhet wh whelp whi which whil while wilc_st wilcoxon win wind windo window winexec wntestb wntestb_7 wntestq xchart xchart_7 xcorr xcorr_7 xi xi_6 xmlsav xmlsave xmluse xpose xsh xshe xshel xshell xt_iis xt_tis xtab_p xtabond xtbin_p xtclog xtcloglog xtcloglog_8 xtcloglog_d2 xtcloglog_pa_p xtcloglog_re_p xtcnt_p xtcorr xtdata xtdes xtfront_p xtfrontier xtgee xtgee_elink xtgee_estat xtgee_makeivar xtgee_p xtgee_plink xtgls xtgls_p xthaus xthausman xtht_p xthtaylor xtile xtint_p xtintreg xtintreg_8 xtintreg_d2 xtintreg_p xtivp_1 xtivp_2 xtivreg xtline xtline_ex xtlogit xtlogit_8 xtlogit_d2 xtlogit_fe_p xtlogit_pa_p xtlogit_re_p xtmixed xtmixed_estat xtmixed_p xtnb_fe xtnb_lf xtnbreg xtnbreg_pa_p xtnbreg_refe_p xtpcse xtpcse_p xtpois xtpoisson xtpoisson_d2 xtpoisson_pa_p xtpoisson_refe_p xtpred xtprobit xtprobit_8 xtprobit_d2 xtprobit_re_p xtps_fe xtps_lf xtps_ren xtps_ren_8 xtrar_p xtrc xtrc_p xtrchh xtrefe_p xtreg xtreg_be xtreg_fe xtreg_ml xtreg_pa_p xtreg_re xtregar xtrere_p xtset xtsf_ll xtsf_llti xtsum xttab xttest0 xttobit xttobit_8 xttobit_p xttrans yx yxview__barlike_draw yxview_area_draw yxview_bar_draw yxview_dot_draw yxview_dropline_draw yxview_function_draw yxview_iarrow_draw yxview_ilabels_draw yxview_normal_draw yxview_pcarrow_draw yxview_pcbarrow_draw yxview_pccapsym_draw yxview_pcscatter_draw yxview_pcspike_draw yxview_rarea_draw yxview_rbar_draw yxview_rbarm_draw yxview_rcap_draw yxview_rcapsym_draw yxview_rconnected_draw yxview_rline_draw yxview_rscatter_draw yxview_rspike_draw yxview_spike_draw yxview_sunflower_draw zap_s zinb zinb_llf zinb_plf zip zip_llf zip_p zip_plf zt_ct_5 zt_hc_5 zt_hcd_5 zt_is_5 zt_iss_5 zt_sho_5 zt_smp_5 ztbase_5 ztcox_5 ztdes_5 ztereg_5 ztfill_5 ztgen_5 ztir_5 ztjoin_5 ztnb ztnb_p ztp ztp_p zts_5 ztset_5 ztspli_5 ztsum_5 zttoct_5 ztvary_5 ztweib_5",
        contains: [
            {
                className: "symbol",
                begin: /`[a-zA-Z0-9_]+'/
            },
            {
                className: "variable",
                begin: /\$\{?[a-zA-Z0-9_]+\}?/
            },
            {
                className: "string",
                variants: [
                    {
                        begin: '`"[^\r\n]*?"\''
                    },
                    {
                        begin: '"[^\r\n"]*"'
                    }
                ]
            },
            {
                className: "built_in",
                variants: [
                    {
                        begin: "\\b(abs|acos|asin|atan|atan2|atanh|ceil|cloglog|comb|cos|digamma|exp|floor|invcloglog|invlogit|ln|lnfact|lnfactorial|lngamma|log|log10|max|min|mod|reldif|round|sign|sin|sqrt|sum|tan|tanh|trigamma|trunc|betaden|Binomial|binorm|binormal|chi2|chi2tail|dgammapda|dgammapdada|dgammapdadx|dgammapdx|dgammapdxdx|F|Fden|Ftail|gammaden|gammap|ibeta|invbinomial|invchi2|invchi2tail|invF|invFtail|invgammap|invibeta|invnchi2|invnFtail|invnibeta|invnorm|invnormal|invttail|nbetaden|nchi2|nFden|nFtail|nibeta|norm|normal|normalden|normd|npnchi2|tden|ttail|uniform|abbrev|char|index|indexnot|length|lower|ltrim|match|plural|proper|real|regexm|regexr|regexs|reverse|rtrim|string|strlen|strlower|strltrim|strmatch|strofreal|strpos|strproper|strreverse|strrtrim|strtrim|strupper|subinstr|subinword|substr|trim|upper|word|wordcount|_caller|autocode|byteorder|chop|clip|cond|e|epsdouble|epsfloat|group|inlist|inrange|irecode|matrix|maxbyte|maxdouble|maxfloat|maxint|maxlong|mi|minbyte|mindouble|minfloat|minint|minlong|missing|r|recode|replay|return|s|scalar|d|date|day|dow|doy|halfyear|mdy|month|quarter|week|year|d|daily|dofd|dofh|dofm|dofq|dofw|dofy|h|halfyearly|hofd|m|mofd|monthly|q|qofd|quarterly|tin|twithin|w|weekly|wofd|y|yearly|yh|ym|yofd|yq|yw|cholesky|colnumb|colsof|corr|det|diag|diag0cnt|el|get|hadamard|I|inv|invsym|issym|issymmetric|J|matmissing|matuniform|mreldif|nullmat|rownumb|rowsof|sweep|syminv|trace|vec|vecdiag)(?=\\()"
                    }
                ]
            },
            hljs.COMMENT("^[ 	]*\\*.*$", false),
            hljs.C_LINE_COMMENT_MODE,
            hljs.C_BLOCK_COMMENT_MODE
        ]
    };
};

});

parcelRegister("lsJDk", function(module, exports) {
module.exports = function(hljs) {
    var STEP21_IDENT_RE = "[A-Z_][A-Z0-9_.]*";
    var STEP21_KEYWORDS = {
        keyword: "HEADER ENDSEC DATA"
    };
    var STEP21_START = {
        className: "meta",
        begin: "ISO-10303-21;",
        relevance: 10
    };
    var STEP21_CLOSE = {
        className: "meta",
        begin: "END-ISO-10303-21;",
        relevance: 10
    };
    return {
        aliases: [
            "p21",
            "step",
            "stp"
        ],
        case_insensitive: true,
        lexemes: STEP21_IDENT_RE,
        keywords: STEP21_KEYWORDS,
        contains: [
            STEP21_START,
            STEP21_CLOSE,
            hljs.C_LINE_COMMENT_MODE,
            hljs.C_BLOCK_COMMENT_MODE,
            hljs.COMMENT("/\\*\\*!", "\\*/"),
            hljs.C_NUMBER_MODE,
            hljs.inherit(hljs.APOS_STRING_MODE, {
                illegal: null
            }),
            hljs.inherit(hljs.QUOTE_STRING_MODE, {
                illegal: null
            }),
            {
                className: "string",
                begin: "'",
                end: "'"
            },
            {
                className: "symbol",
                variants: [
                    {
                        begin: "#",
                        end: "\\d+",
                        illegal: "\\W"
                    }
                ]
            }
        ]
    };
};

});

parcelRegister("6hHNE", function(module, exports) {
module.exports = function(hljs) {
    var VARIABLE = {
        className: "variable",
        begin: "\\$" + hljs.IDENT_RE
    };
    var HEX_COLOR = {
        className: "number",
        begin: "#([a-fA-F0-9]{6}|[a-fA-F0-9]{3})"
    };
    var AT_KEYWORDS = [
        "charset",
        "css",
        "debug",
        "extend",
        "font-face",
        "for",
        "import",
        "include",
        "media",
        "mixin",
        "page",
        "warn",
        "while"
    ];
    var PSEUDO_SELECTORS = [
        "after",
        "before",
        "first-letter",
        "first-line",
        "active",
        "first-child",
        "focus",
        "hover",
        "lang",
        "link",
        "visited"
    ];
    var TAGS = [
        "a",
        "abbr",
        "address",
        "article",
        "aside",
        "audio",
        "b",
        "blockquote",
        "body",
        "button",
        "canvas",
        "caption",
        "cite",
        "code",
        "dd",
        "del",
        "details",
        "dfn",
        "div",
        "dl",
        "dt",
        "em",
        "fieldset",
        "figcaption",
        "figure",
        "footer",
        "form",
        "h1",
        "h2",
        "h3",
        "h4",
        "h5",
        "h6",
        "header",
        "hgroup",
        "html",
        "i",
        "iframe",
        "img",
        "input",
        "ins",
        "kbd",
        "label",
        "legend",
        "li",
        "mark",
        "menu",
        "nav",
        "object",
        "ol",
        "p",
        "q",
        "quote",
        "samp",
        "section",
        "span",
        "strong",
        "summary",
        "sup",
        "table",
        "tbody",
        "td",
        "textarea",
        "tfoot",
        "th",
        "thead",
        "time",
        "tr",
        "ul",
        "var",
        "video"
    ];
    var LOOKAHEAD_TAG_END = "(?=[\\.\\s\\n\\[\\:,])";
    var ATTRIBUTES = [
        "align-content",
        "align-items",
        "align-self",
        "animation",
        "animation-delay",
        "animation-direction",
        "animation-duration",
        "animation-fill-mode",
        "animation-iteration-count",
        "animation-name",
        "animation-play-state",
        "animation-timing-function",
        "auto",
        "backface-visibility",
        "background",
        "background-attachment",
        "background-clip",
        "background-color",
        "background-image",
        "background-origin",
        "background-position",
        "background-repeat",
        "background-size",
        "border",
        "border-bottom",
        "border-bottom-color",
        "border-bottom-left-radius",
        "border-bottom-right-radius",
        "border-bottom-style",
        "border-bottom-width",
        "border-collapse",
        "border-color",
        "border-image",
        "border-image-outset",
        "border-image-repeat",
        "border-image-slice",
        "border-image-source",
        "border-image-width",
        "border-left",
        "border-left-color",
        "border-left-style",
        "border-left-width",
        "border-radius",
        "border-right",
        "border-right-color",
        "border-right-style",
        "border-right-width",
        "border-spacing",
        "border-style",
        "border-top",
        "border-top-color",
        "border-top-left-radius",
        "border-top-right-radius",
        "border-top-style",
        "border-top-width",
        "border-width",
        "bottom",
        "box-decoration-break",
        "box-shadow",
        "box-sizing",
        "break-after",
        "break-before",
        "break-inside",
        "caption-side",
        "clear",
        "clip",
        "clip-path",
        "color",
        "column-count",
        "column-fill",
        "column-gap",
        "column-rule",
        "column-rule-color",
        "column-rule-style",
        "column-rule-width",
        "column-span",
        "column-width",
        "columns",
        "content",
        "counter-increment",
        "counter-reset",
        "cursor",
        "direction",
        "display",
        "empty-cells",
        "filter",
        "flex",
        "flex-basis",
        "flex-direction",
        "flex-flow",
        "flex-grow",
        "flex-shrink",
        "flex-wrap",
        "float",
        "font",
        "font-family",
        "font-feature-settings",
        "font-kerning",
        "font-language-override",
        "font-size",
        "font-size-adjust",
        "font-stretch",
        "font-style",
        "font-variant",
        "font-variant-ligatures",
        "font-weight",
        "height",
        "hyphens",
        "icon",
        "image-orientation",
        "image-rendering",
        "image-resolution",
        "ime-mode",
        "inherit",
        "initial",
        "justify-content",
        "left",
        "letter-spacing",
        "line-height",
        "list-style",
        "list-style-image",
        "list-style-position",
        "list-style-type",
        "margin",
        "margin-bottom",
        "margin-left",
        "margin-right",
        "margin-top",
        "marks",
        "mask",
        "max-height",
        "max-width",
        "min-height",
        "min-width",
        "nav-down",
        "nav-index",
        "nav-left",
        "nav-right",
        "nav-up",
        "none",
        "normal",
        "object-fit",
        "object-position",
        "opacity",
        "order",
        "orphans",
        "outline",
        "outline-color",
        "outline-offset",
        "outline-style",
        "outline-width",
        "overflow",
        "overflow-wrap",
        "overflow-x",
        "overflow-y",
        "padding",
        "padding-bottom",
        "padding-left",
        "padding-right",
        "padding-top",
        "page-break-after",
        "page-break-before",
        "page-break-inside",
        "perspective",
        "perspective-origin",
        "pointer-events",
        "position",
        "quotes",
        "resize",
        "right",
        "tab-size",
        "table-layout",
        "text-align",
        "text-align-last",
        "text-decoration",
        "text-decoration-color",
        "text-decoration-line",
        "text-decoration-style",
        "text-indent",
        "text-overflow",
        "text-rendering",
        "text-shadow",
        "text-transform",
        "text-underline-position",
        "top",
        "transform",
        "transform-origin",
        "transform-style",
        "transition",
        "transition-delay",
        "transition-duration",
        "transition-property",
        "transition-timing-function",
        "unicode-bidi",
        "vertical-align",
        "visibility",
        "white-space",
        "widows",
        "width",
        "word-break",
        "word-spacing",
        "word-wrap",
        "z-index"
    ];
    // illegals
    var ILLEGAL = [
        "\\?",
        "(\\bReturn\\b)",
        "(\\bEnd\\b)",
        "(\\bend\\b)",
        "(\\bdef\\b)",
        ";",
        "#\\s",
        "\\*\\s",
        "===\\s",
        "\\|",
        "%"
    ];
    return {
        aliases: [
            "styl"
        ],
        case_insensitive: false,
        keywords: "if else for in",
        illegal: "(" + ILLEGAL.join("|") + ")",
        contains: [
            // strings
            hljs.QUOTE_STRING_MODE,
            hljs.APOS_STRING_MODE,
            // comments
            hljs.C_LINE_COMMENT_MODE,
            hljs.C_BLOCK_COMMENT_MODE,
            // hex colors
            HEX_COLOR,
            // class tag
            {
                begin: "\\.[a-zA-Z][a-zA-Z0-9_-]*" + LOOKAHEAD_TAG_END,
                className: "selector-class"
            },
            // id tag
            {
                begin: "\\#[a-zA-Z][a-zA-Z0-9_-]*" + LOOKAHEAD_TAG_END,
                className: "selector-id"
            },
            // tags
            {
                begin: "\\b(" + TAGS.join("|") + ")" + LOOKAHEAD_TAG_END,
                className: "selector-tag"
            },
            // psuedo selectors
            {
                begin: "&?:?:\\b(" + PSEUDO_SELECTORS.join("|") + ")" + LOOKAHEAD_TAG_END
            },
            // @ keywords
            {
                begin: "@(" + AT_KEYWORDS.join("|") + ")\\b"
            },
            // variables
            VARIABLE,
            // dimension
            hljs.CSS_NUMBER_MODE,
            // number
            hljs.NUMBER_MODE,
            // functions
            //  - only from beginning of line + whitespace
            {
                className: "function",
                begin: "^[a-zA-Z][a-zA-Z0-9_-]*\\(.*\\)",
                illegal: "[\\n]",
                returnBegin: true,
                contains: [
                    {
                        className: "title",
                        begin: "\\b[a-zA-Z][a-zA-Z0-9_-]*"
                    },
                    {
                        className: "params",
                        begin: /\(/,
                        end: /\)/,
                        contains: [
                            HEX_COLOR,
                            VARIABLE,
                            hljs.APOS_STRING_MODE,
                            hljs.CSS_NUMBER_MODE,
                            hljs.NUMBER_MODE,
                            hljs.QUOTE_STRING_MODE
                        ]
                    }
                ]
            },
            // attributes
            //  - only from beginning of line + whitespace
            //  - must have whitespace after it
            {
                className: "attribute",
                begin: "\\b(" + ATTRIBUTES.reverse().join("|") + ")\\b",
                starts: {
                    // value container
                    end: /;|$/,
                    contains: [
                        HEX_COLOR,
                        VARIABLE,
                        hljs.APOS_STRING_MODE,
                        hljs.QUOTE_STRING_MODE,
                        hljs.CSS_NUMBER_MODE,
                        hljs.NUMBER_MODE,
                        hljs.C_BLOCK_COMMENT_MODE
                    ],
                    illegal: /\./,
                    relevance: 0
                }
            }
        ]
    };
};

});

parcelRegister("7JIKd", function(module, exports) {
module.exports = function(hljs) {
    var DETAILS = {
        className: "string",
        begin: "\\[\n(multipart)?",
        end: "\\]\n"
    };
    var TIME = {
        className: "string",
        begin: "\\d{4}-\\d{2}-\\d{2}(\\s+)\\d{2}:\\d{2}:\\d{2}.\\d+Z"
    };
    var PROGRESSVALUE = {
        className: "string",
        begin: "(\\+|-)\\d+"
    };
    var KEYWORDS = {
        className: "keyword",
        relevance: 10,
        variants: [
            {
                begin: "^(test|testing|success|successful|failure|error|skip|xfail|uxsuccess)(:?)\\s+(test)?"
            },
            {
                begin: "^progress(:?)(\\s+)?(pop|push)?"
            },
            {
                begin: "^tags:"
            },
            {
                begin: "^time:"
            }
        ]
    };
    return {
        case_insensitive: true,
        contains: [
            DETAILS,
            TIME,
            PROGRESSVALUE,
            KEYWORDS
        ]
    };
};

});

parcelRegister("3Vwbc", function(module, exports) {
module.exports = function(hljs) {
    var SWIFT_KEYWORDS = {
        keyword: "#available #colorLiteral #column #else #elseif #endif #file #fileLiteral #function #if #imageLiteral #line #selector #sourceLocation _ __COLUMN__ __FILE__ __FUNCTION__ __LINE__ Any as as! as? associatedtype associativity break case catch class continue convenience default defer deinit didSet do dynamic dynamicType else enum extension fallthrough false fileprivate final for func get guard if import in indirect infix init inout internal is lazy left let mutating nil none nonmutating open operator optional override postfix precedence prefix private protocol Protocol public repeat required rethrows return right self Self set static struct subscript super switch throw throws true try try! try? Type typealias unowned var weak where while willSet",
        literal: "true false nil",
        built_in: "abs advance alignof alignofValue anyGenerator assert assertionFailure bridgeFromObjectiveC bridgeFromObjectiveCUnconditional bridgeToObjectiveC bridgeToObjectiveCUnconditional c contains count countElements countLeadingZeros debugPrint debugPrintln distance dropFirst dropLast dump encodeBitsAsWords enumerate equal fatalError filter find getBridgedObjectiveCType getVaList indices insertionSort isBridgedToObjectiveC isBridgedVerbatimToObjectiveC isUniquelyReferenced isUniquelyReferencedNonObjC join lazy lexicographicalCompare map max maxElement min minElement numericCast overlaps partition posix precondition preconditionFailure print println quickSort readLine reduce reflect reinterpretCast reverse roundUpToAlignment sizeof sizeofValue sort split startsWith stride strideof strideofValue swap toString transcode underestimateCount unsafeAddressOf unsafeBitCast unsafeDowncast unsafeUnwrap unsafeReflect withExtendedLifetime withObjectAtPlusZero withUnsafePointer withUnsafePointerToObject withUnsafeMutablePointer withUnsafeMutablePointers withUnsafePointer withUnsafePointers withVaList zip"
    };
    var TYPE = {
        className: "type",
        begin: "\\b[A-Z][\\w\xc0-\u02B8']*",
        relevance: 0
    };
    // slightly more special to swift
    var OPTIONAL_USING_TYPE = {
        className: "type",
        begin: "\\b[A-Z][\\w\xc0-\u02B8']*[!?]"
    };
    var BLOCK_COMMENT = hljs.COMMENT("/\\*", "\\*/", {
        contains: [
            "self"
        ]
    });
    var SUBST = {
        className: "subst",
        begin: /\\\(/,
        end: "\\)",
        keywords: SWIFT_KEYWORDS,
        contains: [] // assigned later
    };
    var STRING = {
        className: "string",
        contains: [
            hljs.BACKSLASH_ESCAPE,
            SUBST
        ],
        variants: [
            {
                begin: /"""/,
                end: /"""/
            },
            {
                begin: /"/,
                end: /"/
            }
        ]
    };
    var NUMBERS = {
        className: "number",
        begin: "\\b([\\d_]+(\\.[\\deE_]+)?|0x[a-fA-F0-9_]+(\\.[a-fA-F0-9p_]+)?|0b[01_]+|0o[0-7_]+)\\b",
        relevance: 0
    };
    SUBST.contains = [
        NUMBERS
    ];
    return {
        keywords: SWIFT_KEYWORDS,
        contains: [
            STRING,
            hljs.C_LINE_COMMENT_MODE,
            BLOCK_COMMENT,
            OPTIONAL_USING_TYPE,
            TYPE,
            NUMBERS,
            {
                className: "function",
                beginKeywords: "func",
                end: "{",
                excludeEnd: true,
                contains: [
                    hljs.inherit(hljs.TITLE_MODE, {
                        begin: /[A-Za-z$_][0-9A-Za-z$_]*/
                    }),
                    {
                        begin: /</,
                        end: />/
                    },
                    {
                        className: "params",
                        begin: /\(/,
                        end: /\)/,
                        endsParent: true,
                        keywords: SWIFT_KEYWORDS,
                        contains: [
                            "self",
                            NUMBERS,
                            STRING,
                            hljs.C_BLOCK_COMMENT_MODE,
                            {
                                begin: ":"
                            } // relevance booster
                        ],
                        illegal: /["']/
                    }
                ],
                illegal: /\[|%/
            },
            {
                className: "class",
                beginKeywords: "struct protocol class extension enum",
                keywords: SWIFT_KEYWORDS,
                end: "\\{",
                excludeEnd: true,
                contains: [
                    hljs.inherit(hljs.TITLE_MODE, {
                        begin: /[A-Za-z$_][\u00C0-\u02B80-9A-Za-z$_]*/
                    })
                ]
            },
            {
                className: "meta",
                begin: "(@discardableResult|@warn_unused_result|@exported|@lazy|@noescape|@NSCopying|@NSManaged|@objc|@objcMembers|@convention|@required|@noreturn|@IBAction|@IBDesignable|@IBInspectable|@IBOutlet|@infix|@prefix|@postfix|@autoclosure|@testable|@available|@nonobjc|@NSApplicationMain|@UIApplicationMain|@dynamicMemberLookup|@propertyWrapper)"
            },
            {
                beginKeywords: "import",
                end: /$/,
                contains: [
                    hljs.C_LINE_COMMENT_MODE,
                    BLOCK_COMMENT
                ]
            }
        ]
    };
};

});

parcelRegister("95S8w", function(module, exports) {
module.exports = function(hljs) {
    var COMMENT = {
        className: "comment",
        begin: /\$noop\(/,
        end: /\)/,
        contains: [
            {
                begin: /\(/,
                end: /\)/,
                contains: [
                    "self",
                    {
                        begin: /\\./
                    }
                ]
            }
        ],
        relevance: 10
    };
    var FUNCTION = {
        className: "keyword",
        begin: /\$(?!noop)[a-zA-Z][_a-zA-Z0-9]*/,
        end: /\(/,
        excludeEnd: true
    };
    var VARIABLE = {
        className: "variable",
        begin: /%[_a-zA-Z0-9:]*/,
        end: "%"
    };
    var ESCAPE_SEQUENCE = {
        className: "symbol",
        begin: /\\./
    };
    return {
        contains: [
            COMMENT,
            FUNCTION,
            VARIABLE,
            ESCAPE_SEQUENCE
        ]
    };
};

});

parcelRegister("9Q3uF", function(module, exports) {
module.exports = function(hljs) {
    var LITERALS = "true false yes no null";
    // Define keys as starting with a word character
    // ...containing word chars, spaces, colons, forward-slashes, hyphens and periods
    // ...and ending with a colon followed immediately by a space, tab or newline.
    // The YAML spec allows for much more than this, but this covers most use-cases.
    var KEY = {
        className: "attr",
        variants: [
            {
                begin: "\\w[\\w :\\/.-]*:(?=[ 	]|$)"
            },
            {
                begin: '"\\w[\\w :\\/.-]*":(?=[ 	]|$)'
            },
            {
                begin: "'\\w[\\w :\\/.-]*':(?=[ 	]|$)"
            } //single quoted keys
        ]
    };
    var TEMPLATE_VARIABLES = {
        className: "template-variable",
        variants: [
            {
                begin: "{{",
                end: "}}"
            },
            {
                begin: "%{",
                end: "}"
            } // Ruby i18n
        ]
    };
    var STRING = {
        className: "string",
        relevance: 0,
        variants: [
            {
                begin: /'/,
                end: /'/
            },
            {
                begin: /"/,
                end: /"/
            },
            {
                begin: /\S+/
            }
        ],
        contains: [
            hljs.BACKSLASH_ESCAPE,
            TEMPLATE_VARIABLES
        ]
    };
    return {
        case_insensitive: true,
        aliases: [
            "yml",
            "YAML",
            "yaml"
        ],
        contains: [
            KEY,
            {
                className: "meta",
                begin: "^---s*$",
                relevance: 10
            },
            {
                // Blocks start with a | or > followed by a newline
                //
                // Indentation of subsequent lines must be the same to
                // be considered part of the block
                className: "string",
                begin: "[\\|>]([0-9]?[+-])?[ ]*\\n( *)[\\S ]+\\n(\\2[\\S ]+\\n?)*"
            },
            {
                begin: "<%[%=-]?",
                end: "[%-]?%>",
                subLanguage: "ruby",
                excludeBegin: true,
                excludeEnd: true,
                relevance: 0
            },
            {
                className: "type",
                begin: "!" + hljs.UNDERSCORE_IDENT_RE
            },
            {
                className: "type",
                begin: "!!" + hljs.UNDERSCORE_IDENT_RE
            },
            {
                className: "meta",
                begin: "&" + hljs.UNDERSCORE_IDENT_RE + "$"
            },
            {
                className: "meta",
                begin: "\\*" + hljs.UNDERSCORE_IDENT_RE + "$"
            },
            {
                className: "bullet",
                // TODO: remove |$ hack when we have proper look-ahead support
                begin: "\\-(?=[ ]|$)",
                relevance: 0
            },
            hljs.HASH_COMMENT_MODE,
            {
                beginKeywords: LITERALS,
                keywords: {
                    literal: LITERALS
                }
            },
            // numbers are any valid C-style number that
            // sit isolated from other words
            {
                className: "number",
                begin: hljs.C_NUMBER_RE + "\\b"
            },
            STRING
        ]
    };
};

});

parcelRegister("e9h52", function(module, exports) {
module.exports = function(hljs) {
    return {
        case_insensitive: true,
        contains: [
            hljs.HASH_COMMENT_MODE,
            // version of format and total amount of testcases
            {
                className: "meta",
                variants: [
                    {
                        begin: "^TAP version (\\d+)$"
                    },
                    {
                        begin: "^1\\.\\.(\\d+)$"
                    }
                ]
            },
            // YAML block
            {
                begin: "(s+)?---$",
                end: "\\.\\.\\.$",
                subLanguage: "yaml",
                relevance: 0
            },
            // testcase number
            {
                className: "number",
                begin: " (\\d+) "
            },
            // testcase status and description
            {
                className: "symbol",
                variants: [
                    {
                        begin: "^ok"
                    },
                    {
                        begin: "^not ok"
                    }
                ]
            }
        ]
    };
};

});

parcelRegister("5a08n", function(module, exports) {
module.exports = function(hljs) {
    return {
        aliases: [
            "tk"
        ],
        keywords: "after append apply array auto_execok auto_import auto_load auto_mkindex auto_mkindex_old auto_qualify auto_reset bgerror binary break catch cd chan clock close concat continue dde dict encoding eof error eval exec exit expr fblocked fconfigure fcopy file fileevent filename flush for foreach format gets glob global history http if incr info interp join lappend|10 lassign|10 lindex|10 linsert|10 list llength|10 load lrange|10 lrepeat|10 lreplace|10 lreverse|10 lsearch|10 lset|10 lsort|10 mathfunc mathop memory msgcat namespace open package parray pid pkg::create pkg_mkIndex platform platform::shell proc puts pwd read refchan regexp registry regsub|10 rename return safe scan seek set socket source split string subst switch tcl_endOfWord tcl_findLibrary tcl_startOfNextWord tcl_startOfPreviousWord tcl_wordBreakAfter tcl_wordBreakBefore tcltest tclvars tell time tm trace unknown unload unset update uplevel upvar variable vwait while",
        contains: [
            hljs.COMMENT(";[ \\t]*#", "$"),
            hljs.COMMENT("^[ \\t]*#", "$"),
            {
                beginKeywords: "proc",
                end: "[\\{]",
                excludeEnd: true,
                contains: [
                    {
                        className: "title",
                        begin: "[ \\t\\n\\r]+(::)?[a-zA-Z_]((::)?[a-zA-Z0-9_])*",
                        end: "[ \\t\\n\\r]",
                        endsWithParent: true,
                        excludeEnd: true
                    }
                ]
            },
            {
                excludeEnd: true,
                variants: [
                    {
                        begin: "\\$(\\{)?(::)?[a-zA-Z_]((::)?[a-zA-Z0-9_])*\\(([a-zA-Z0-9_])*\\)",
                        end: "[^a-zA-Z0-9_\\}\\$]"
                    },
                    {
                        begin: "\\$(\\{)?(::)?[a-zA-Z_]((::)?[a-zA-Z0-9_])*",
                        end: "(\\))?[^a-zA-Z0-9_\\}\\$]"
                    }
                ]
            },
            {
                className: "string",
                contains: [
                    hljs.BACKSLASH_ESCAPE
                ],
                variants: [
                    hljs.inherit(hljs.QUOTE_STRING_MODE, {
                        illegal: null
                    })
                ]
            },
            {
                className: "number",
                variants: [
                    hljs.BINARY_NUMBER_MODE,
                    hljs.C_NUMBER_MODE
                ]
            }
        ]
    };
};

});

parcelRegister("bjTAz", function(module, exports) {
module.exports = function(hljs) {
    var COMMAND = {
        className: "tag",
        begin: /\\/,
        relevance: 0,
        contains: [
            {
                className: "name",
                variants: [
                    {
                        begin: /[a-zA-Z\u0430-\u044f\u0410-\u042f]+[*]?/
                    },
                    {
                        begin: /[^a-zA-Z\u0430-\u044f\u0410-\u042f0-9]/
                    }
                ],
                starts: {
                    endsWithParent: true,
                    relevance: 0,
                    contains: [
                        {
                            className: "string",
                            variants: [
                                {
                                    begin: /\[/,
                                    end: /\]/
                                },
                                {
                                    begin: /\{/,
                                    end: /\}/
                                }
                            ]
                        },
                        {
                            begin: /\s*=\s*/,
                            endsWithParent: true,
                            relevance: 0,
                            contains: [
                                {
                                    className: "number",
                                    begin: /-?\d*\.?\d+(pt|pc|mm|cm|in|dd|cc|ex|em)?/
                                }
                            ]
                        }
                    ]
                }
            }
        ]
    };
    return {
        contains: [
            COMMAND,
            {
                className: "formula",
                contains: [
                    COMMAND
                ],
                relevance: 0,
                variants: [
                    {
                        begin: /\$\$/,
                        end: /\$\$/
                    },
                    {
                        begin: /\$/,
                        end: /\$/
                    }
                ]
            },
            hljs.COMMENT("%", "$", {
                relevance: 0
            })
        ]
    };
};

});

parcelRegister("7FuCM", function(module, exports) {
module.exports = function(hljs) {
    var BUILT_IN_TYPES = "bool byte i16 i32 i64 double string binary";
    return {
        keywords: {
            keyword: "namespace const typedef struct enum service exception void oneway set list map required optional",
            built_in: BUILT_IN_TYPES,
            literal: "true false"
        },
        contains: [
            hljs.QUOTE_STRING_MODE,
            hljs.NUMBER_MODE,
            hljs.C_LINE_COMMENT_MODE,
            hljs.C_BLOCK_COMMENT_MODE,
            {
                className: "class",
                beginKeywords: "struct enum service exception",
                end: /\{/,
                illegal: /\n/,
                contains: [
                    hljs.inherit(hljs.TITLE_MODE, {
                        starts: {
                            endsWithParent: true,
                            excludeEnd: true
                        } // hack: eating everything after the first title
                    })
                ]
            },
            {
                begin: "\\b(set|list|map)\\s*<",
                end: ">",
                keywords: BUILT_IN_TYPES,
                contains: [
                    "self"
                ]
            }
        ]
    };
};

});

parcelRegister("fZGmp", function(module, exports) {
module.exports = function(hljs) {
    var TPID = {
        className: "number",
        begin: "[1-9][0-9]*",
        /* no leading zeros */ relevance: 0
    };
    var TPLABEL = {
        className: "symbol",
        begin: ":[^\\]]+"
    };
    var TPDATA = {
        className: "built_in",
        begin: "(AR|P|PAYLOAD|PR|R|SR|RSR|LBL|VR|UALM|MESSAGE|UTOOL|UFRAME|TIMER|TIMER_OVERFLOW|JOINT_MAX_SPEED|RESUME_PROG|DIAG_REC)\\[",
        end: "\\]",
        contains: [
            "self",
            TPID,
            TPLABEL
        ]
    };
    var TPIO = {
        className: "built_in",
        begin: "(AI|AO|DI|DO|F|RI|RO|UI|UO|GI|GO|SI|SO)\\[",
        end: "\\]",
        contains: [
            "self",
            TPID,
            hljs.QUOTE_STRING_MODE,
            /* for pos section at bottom */ TPLABEL
        ]
    };
    return {
        keywords: {
            keyword: "ABORT ACC ADJUST AND AP_LD BREAK CALL CNT COL CONDITION CONFIG DA DB DIV DETECT ELSE END ENDFOR ERR_NUM ERROR_PROG FINE FOR GP GUARD INC IF JMP LINEAR_MAX_SPEED LOCK MOD MONITOR OFFSET Offset OR OVERRIDE PAUSE PREG PTH RT_LD RUN SELECT SKIP Skip TA TB TO TOOL_OFFSET Tool_Offset UF UT UFRAME_NUM UTOOL_NUM UNLOCK WAIT X Y Z W P R STRLEN SUBSTR FINDSTR VOFFSET PROG ATTR MN POS",
            literal: "ON OFF max_speed LPOS JPOS ENABLE DISABLE START STOP RESET"
        },
        contains: [
            TPDATA,
            TPIO,
            {
                className: "keyword",
                begin: "/(PROG|ATTR|MN|POS|END)\\b"
            },
            {
                /* this is for cases like ,CALL */ className: "keyword",
                begin: "(CALL|RUN|POINT_LOGIC|LBL)\\b"
            },
            {
                /* this is for cases like CNT100 where the default lexemes do not
         * separate the keyword and the number */ className: "keyword",
                begin: "\\b(ACC|CNT|Skip|Offset|PSPD|RT_LD|AP_LD|Tool_Offset)"
            },
            {
                /* to catch numbers that do not have a word boundary on the left */ className: "number",
                begin: "\\d+(sec|msec|mm/sec|cm/min|inch/min|deg/sec|mm|in|cm)?\\b",
                relevance: 0
            },
            hljs.COMMENT("//", "[;$]"),
            hljs.COMMENT("!", "[;$]"),
            hljs.COMMENT("--eg:", "$"),
            hljs.QUOTE_STRING_MODE,
            {
                className: "string",
                begin: "'",
                end: "'"
            },
            hljs.C_NUMBER_MODE,
            {
                className: "variable",
                begin: "\\$[A-Za-z0-9_]+"
            }
        ]
    };
};

});

parcelRegister("2NhyA", function(module, exports) {
module.exports = function(hljs) {
    var PARAMS = {
        className: "params",
        begin: "\\(",
        end: "\\)"
    };
    var FUNCTION_NAMES = "attribute block constant cycle date dump include max min parent random range source template_from_string";
    var FUNCTIONS = {
        beginKeywords: FUNCTION_NAMES,
        keywords: {
            name: FUNCTION_NAMES
        },
        relevance: 0,
        contains: [
            PARAMS
        ]
    };
    var FILTER = {
        begin: /\|[A-Za-z_]+:?/,
        keywords: "abs batch capitalize column convert_encoding date date_modify default escape filter first format inky_to_html inline_css join json_encode keys last length lower map markdown merge nl2br number_format raw reduce replace reverse round slice sort spaceless split striptags title trim upper url_encode",
        contains: [
            FUNCTIONS
        ]
    };
    var TAGS = "apply autoescape block deprecated do embed extends filter flush for from if import include macro sandbox set use verbatim with";
    TAGS = TAGS + " " + TAGS.split(" ").map(function(t) {
        return "end" + t;
    }).join(" ");
    return {
        aliases: [
            "craftcms"
        ],
        case_insensitive: true,
        subLanguage: "xml",
        contains: [
            hljs.COMMENT(/\{#/, /#}/),
            {
                className: "template-tag",
                begin: /\{%/,
                end: /%}/,
                contains: [
                    {
                        className: "name",
                        begin: /\w+/,
                        keywords: TAGS,
                        starts: {
                            endsWithParent: true,
                            contains: [
                                FILTER,
                                FUNCTIONS
                            ],
                            relevance: 0
                        }
                    }
                ]
            },
            {
                className: "template-variable",
                begin: /\{\{/,
                end: /}}/,
                contains: [
                    "self",
                    FILTER,
                    FUNCTIONS
                ]
            }
        ]
    };
};

});

parcelRegister("1loeR", function(module, exports) {
module.exports = function(hljs) {
    var JS_IDENT_RE = "[A-Za-z$_][0-9A-Za-z$_]*";
    var KEYWORDS = {
        keyword: "in if for while finally var new function do return void else break catch instanceof with throw case default try this switch continue typeof delete let yield const class public private protected get set super static implements enum export import declare type namespace abstract as from extends async await",
        literal: "true false null undefined NaN Infinity",
        built_in: "eval isFinite isNaN parseFloat parseInt decodeURI decodeURIComponent encodeURI encodeURIComponent escape unescape Object Function Boolean Error EvalError InternalError RangeError ReferenceError StopIteration SyntaxError TypeError URIError Number Math Date String RegExp Array Float32Array Float64Array Int16Array Int32Array Int8Array Uint16Array Uint32Array Uint8Array Uint8ClampedArray ArrayBuffer DataView JSON Intl arguments require module console window document any number boolean string void Promise"
    };
    var DECORATOR = {
        className: "meta",
        begin: "@" + JS_IDENT_RE
    };
    var ARGS = {
        begin: "\\(",
        end: /\)/,
        keywords: KEYWORDS,
        contains: [
            "self",
            hljs.QUOTE_STRING_MODE,
            hljs.APOS_STRING_MODE,
            hljs.NUMBER_MODE
        ]
    };
    var PARAMS = {
        className: "params",
        begin: /\(/,
        end: /\)/,
        excludeBegin: true,
        excludeEnd: true,
        keywords: KEYWORDS,
        contains: [
            hljs.C_LINE_COMMENT_MODE,
            hljs.C_BLOCK_COMMENT_MODE,
            DECORATOR,
            ARGS
        ]
    };
    var NUMBER = {
        className: "number",
        variants: [
            {
                begin: "\\b(0[bB][01]+)n?"
            },
            {
                begin: "\\b(0[oO][0-7]+)n?"
            },
            {
                begin: hljs.C_NUMBER_RE + "n?"
            }
        ],
        relevance: 0
    };
    var SUBST = {
        className: "subst",
        begin: "\\$\\{",
        end: "\\}",
        keywords: KEYWORDS,
        contains: [] // defined later
    };
    var HTML_TEMPLATE = {
        begin: "html`",
        end: "",
        starts: {
            end: "`",
            returnEnd: false,
            contains: [
                hljs.BACKSLASH_ESCAPE,
                SUBST
            ],
            subLanguage: "xml"
        }
    };
    var CSS_TEMPLATE = {
        begin: "css`",
        end: "",
        starts: {
            end: "`",
            returnEnd: false,
            contains: [
                hljs.BACKSLASH_ESCAPE,
                SUBST
            ],
            subLanguage: "css"
        }
    };
    var TEMPLATE_STRING = {
        className: "string",
        begin: "`",
        end: "`",
        contains: [
            hljs.BACKSLASH_ESCAPE,
            SUBST
        ]
    };
    SUBST.contains = [
        hljs.APOS_STRING_MODE,
        hljs.QUOTE_STRING_MODE,
        HTML_TEMPLATE,
        CSS_TEMPLATE,
        TEMPLATE_STRING,
        NUMBER,
        hljs.REGEXP_MODE
    ];
    return {
        aliases: [
            "ts"
        ],
        keywords: KEYWORDS,
        contains: [
            {
                className: "meta",
                begin: /^\s*['"]use strict['"]/
            },
            hljs.APOS_STRING_MODE,
            hljs.QUOTE_STRING_MODE,
            HTML_TEMPLATE,
            CSS_TEMPLATE,
            TEMPLATE_STRING,
            hljs.C_LINE_COMMENT_MODE,
            hljs.C_BLOCK_COMMENT_MODE,
            NUMBER,
            {
                begin: "(" + hljs.RE_STARTERS_RE + "|\\b(case|return|throw)\\b)\\s*",
                keywords: "return throw case",
                contains: [
                    hljs.C_LINE_COMMENT_MODE,
                    hljs.C_BLOCK_COMMENT_MODE,
                    hljs.REGEXP_MODE,
                    {
                        className: "function",
                        begin: "(\\(.*?\\)|" + hljs.IDENT_RE + ")\\s*=>",
                        returnBegin: true,
                        end: "\\s*=>",
                        contains: [
                            {
                                className: "params",
                                variants: [
                                    {
                                        begin: hljs.IDENT_RE
                                    },
                                    {
                                        begin: /\(\s*\)/
                                    },
                                    {
                                        begin: /\(/,
                                        end: /\)/,
                                        excludeBegin: true,
                                        excludeEnd: true,
                                        keywords: KEYWORDS,
                                        contains: [
                                            "self",
                                            hljs.C_LINE_COMMENT_MODE,
                                            hljs.C_BLOCK_COMMENT_MODE
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ],
                relevance: 0
            },
            {
                className: "function",
                beginKeywords: "function",
                end: /[\{;]/,
                excludeEnd: true,
                keywords: KEYWORDS,
                contains: [
                    "self",
                    hljs.inherit(hljs.TITLE_MODE, {
                        begin: JS_IDENT_RE
                    }),
                    PARAMS
                ],
                illegal: /%/,
                relevance: 0 // () => {} is more typical in TypeScript
            },
            {
                beginKeywords: "constructor",
                end: /[\{;]/,
                excludeEnd: true,
                contains: [
                    "self",
                    PARAMS
                ]
            },
            {
                begin: /module\./,
                keywords: {
                    built_in: "module"
                },
                relevance: 0
            },
            {
                beginKeywords: "module",
                end: /\{/,
                excludeEnd: true
            },
            {
                beginKeywords: "interface",
                end: /\{/,
                excludeEnd: true,
                keywords: "interface extends"
            },
            {
                begin: /\$[(.]/ // relevance booster for a pattern common to JS libs: `$(something)` and `$.something`
            },
            {
                begin: "\\." + hljs.IDENT_RE,
                relevance: 0 // hack: prevents detection of keywords after dots
            },
            DECORATOR,
            ARGS
        ]
    };
};

});

parcelRegister("c7YeD", function(module, exports) {
module.exports = function(hljs) {
    return {
        keywords: {
            keyword: // Value types
            "char uchar unichar int uint long ulong short ushort int8 int16 int32 int64 uint8 uint16 uint32 uint64 float double bool struct enum string void weak unowned owned async signal static abstract interface override virtual delegate if while do for foreach else switch case break default return try catch public private protected internal using new this get set const stdout stdin stderr var",
            built_in: "DBus GLib CCode Gee Object Gtk Posix",
            literal: "false true null"
        },
        contains: [
            {
                className: "class",
                beginKeywords: "class interface namespace",
                end: "{",
                excludeEnd: true,
                illegal: "[^,:\\n\\s\\.]",
                contains: [
                    hljs.UNDERSCORE_TITLE_MODE
                ]
            },
            hljs.C_LINE_COMMENT_MODE,
            hljs.C_BLOCK_COMMENT_MODE,
            {
                className: "string",
                begin: '"""',
                end: '"""',
                relevance: 5
            },
            hljs.APOS_STRING_MODE,
            hljs.QUOTE_STRING_MODE,
            hljs.C_NUMBER_MODE,
            {
                className: "meta",
                begin: "^#",
                end: "$",
                relevance: 2
            }
        ]
    };
};

});

parcelRegister("ctiKc", function(module, exports) {
module.exports = function(hljs) {
    return {
        aliases: [
            "vb"
        ],
        case_insensitive: true,
        keywords: {
            keyword: "addhandler addressof alias and andalso aggregate ansi as async assembly auto await binary by byref byval call case catch class compare const continue custom declare default delegate dim distinct do each equals else elseif end enum erase error event exit explicit finally for friend from function get global goto group handles if implements imports in inherits interface into is isfalse isnot istrue iterator join key let lib like loop me mid mod module mustinherit mustoverride mybase myclass nameof namespace narrowing new next not notinheritable notoverridable of off on operator option optional or order orelse overloads overridable overrides paramarray partial preserve private property protected public raiseevent readonly redim rem removehandler resume return select set shadows shared skip static step stop structure strict sub synclock take text then throw to try unicode until using when where while widening with withevents writeonly xor yield",
            /* t-y */ built_in: "boolean byte cbool cbyte cchar cdate cdec cdbl char cint clng cobj csbyte cshort csng cstr ctype date decimal directcast double gettype getxmlnamespace iif integer long object sbyte short single string trycast typeof uinteger ulong ushort",
            /* s-u */ literal: "true false nothing"
        },
        illegal: "//|{|}|endif|gosub|variant|wend|^\\$ ",
        /* reserved deprecated keywords */ contains: [
            hljs.inherit(hljs.QUOTE_STRING_MODE, {
                contains: [
                    {
                        begin: '""'
                    }
                ]
            }),
            hljs.COMMENT("'", "$", {
                returnBegin: true,
                contains: [
                    {
                        className: "doctag",
                        begin: "'''|<!--|-->",
                        contains: [
                            hljs.PHRASAL_WORDS_MODE
                        ]
                    },
                    {
                        className: "doctag",
                        begin: "</?",
                        end: ">",
                        contains: [
                            hljs.PHRASAL_WORDS_MODE
                        ]
                    }
                ]
            }),
            hljs.C_NUMBER_MODE,
            {
                className: "meta",
                begin: "#",
                end: "$",
                keywords: {
                    "meta-keyword": "if else elseif end region externalsource"
                }
            }
        ]
    };
};

});

parcelRegister("aCEs1", function(module, exports) {
module.exports = function(hljs) {
    return {
        aliases: [
            "vbs"
        ],
        case_insensitive: true,
        keywords: {
            keyword: "call class const dim do loop erase execute executeglobal exit for each next function if then else on error option explicit new private property let get public randomize redim rem select case set stop sub while wend with end to elseif is or xor and not class_initialize class_terminate default preserve in me byval byref step resume goto",
            built_in: "lcase month vartype instrrev ubound setlocale getobject rgb getref string weekdayname rnd dateadd monthname now day minute isarray cbool round formatcurrency conversions csng timevalue second year space abs clng timeserial fixs len asc isempty maths dateserial atn timer isobject filter weekday datevalue ccur isdate instr datediff formatdatetime replace isnull right sgn array snumeric log cdbl hex chr lbound msgbox ucase getlocale cos cdate cbyte rtrim join hour oct typename trim strcomp int createobject loadpicture tan formatnumber mid scriptenginebuildversion scriptengine split scriptengineminorversion cint sin datepart ltrim sqr scriptenginemajorversion time derived eval date formatpercent exp inputbox left ascw chrw regexp server response request cstr err",
            literal: "true false null nothing empty"
        },
        illegal: "//",
        contains: [
            hljs.inherit(hljs.QUOTE_STRING_MODE, {
                contains: [
                    {
                        begin: '""'
                    }
                ]
            }),
            hljs.COMMENT(/'/, /$/, {
                relevance: 0
            }),
            hljs.C_NUMBER_MODE
        ]
    };
};

});

parcelRegister("i3NKp", function(module, exports) {
module.exports = function(hljs) {
    return {
        subLanguage: "xml",
        contains: [
            {
                begin: "<%",
                end: "%>",
                subLanguage: "vbscript"
            }
        ]
    };
};

});

parcelRegister("e1Vbh", function(module, exports) {
module.exports = function(hljs) {
    var SV_KEYWORDS = {
        keyword: "accept_on alias always always_comb always_ff always_latch and assert assign assume automatic before begin bind bins binsof bit break buf|0 bufif0 bufif1 byte case casex casez cell chandle checker class clocking cmos config const constraint context continue cover covergroup coverpoint cross deassign default defparam design disable dist do edge else end endcase endchecker endclass endclocking endconfig endfunction endgenerate endgroup endinterface endmodule endpackage endprimitive endprogram endproperty endspecify endsequence endtable endtask enum event eventually expect export extends extern final first_match for force foreach forever fork forkjoin function generate|5 genvar global highz0 highz1 if iff ifnone ignore_bins illegal_bins implements implies import incdir include initial inout input inside instance int integer interconnect interface intersect join join_any join_none large let liblist library local localparam logic longint macromodule matches medium modport module nand negedge nettype new nexttime nmos nor noshowcancelled not notif0 notif1 or output package packed parameter pmos posedge primitive priority program property protected pull0 pull1 pulldown pullup pulsestyle_ondetect pulsestyle_onevent pure rand randc randcase randsequence rcmos real realtime ref reg reject_on release repeat restrict return rnmos rpmos rtran rtranif0 rtranif1 s_always s_eventually s_nexttime s_until s_until_with scalared sequence shortint shortreal showcancelled signed small soft solve specify specparam static string strong strong0 strong1 struct super supply0 supply1 sync_accept_on sync_reject_on table tagged task this throughout time timeprecision timeunit tran tranif0 tranif1 tri tri0 tri1 triand trior trireg type typedef union unique unique0 unsigned until until_with untyped use uwire var vectored virtual void wait wait_order wand weak weak0 weak1 while wildcard wire with within wor xnor xor",
        literal: "null",
        built_in: "$finish $stop $exit $fatal $error $warning $info $realtime $time $printtimescale $bitstoreal $bitstoshortreal $itor $signed $cast $bits $stime $timeformat $realtobits $shortrealtobits $rtoi $unsigned $asserton $assertkill $assertpasson $assertfailon $assertnonvacuouson $assertoff $assertcontrol $assertpassoff $assertfailoff $assertvacuousoff $isunbounded $sampled $fell $changed $past_gclk $fell_gclk $changed_gclk $rising_gclk $steady_gclk $coverage_control $coverage_get $coverage_save $set_coverage_db_name $rose $stable $past $rose_gclk $stable_gclk $future_gclk $falling_gclk $changing_gclk $display $coverage_get_max $coverage_merge $get_coverage $load_coverage_db $typename $unpacked_dimensions $left $low $increment $clog2 $ln $log10 $exp $sqrt $pow $floor $ceil $sin $cos $tan $countbits $onehot $isunknown $fatal $warning $dimensions $right $high $size $asin $acos $atan $atan2 $hypot $sinh $cosh $tanh $asinh $acosh $atanh $countones $onehot0 $error $info $random $dist_chi_square $dist_erlang $dist_exponential $dist_normal $dist_poisson $dist_t $dist_uniform $q_initialize $q_remove $q_exam $async$and$array $async$nand$array $async$or$array $async$nor$array $sync$and$array $sync$nand$array $sync$or$array $sync$nor$array $q_add $q_full $psprintf $async$and$plane $async$nand$plane $async$or$plane $async$nor$plane $sync$and$plane $sync$nand$plane $sync$or$plane $sync$nor$plane $system $display $displayb $displayh $displayo $strobe $strobeb $strobeh $strobeo $write $readmemb $readmemh $writememh $value$plusargs $dumpvars $dumpon $dumplimit $dumpports $dumpportson $dumpportslimit $writeb $writeh $writeo $monitor $monitorb $monitorh $monitoro $writememb $dumpfile $dumpoff $dumpall $dumpflush $dumpportsoff $dumpportsall $dumpportsflush $fclose $fdisplay $fdisplayb $fdisplayh $fdisplayo $fstrobe $fstrobeb $fstrobeh $fstrobeo $swrite $swriteb $swriteh $swriteo $fscanf $fread $fseek $fflush $feof $fopen $fwrite $fwriteb $fwriteh $fwriteo $fmonitor $fmonitorb $fmonitorh $fmonitoro $sformat $sformatf $fgetc $ungetc $fgets $sscanf $rewind $ftell $ferror"
    };
    return {
        aliases: [
            "v",
            "sv",
            "svh"
        ],
        case_insensitive: false,
        keywords: SV_KEYWORDS,
        lexemes: /[\w\$]+/,
        contains: [
            hljs.C_BLOCK_COMMENT_MODE,
            hljs.C_LINE_COMMENT_MODE,
            hljs.QUOTE_STRING_MODE,
            {
                className: "number",
                contains: [
                    hljs.BACKSLASH_ESCAPE
                ],
                variants: [
                    {
                        begin: "\\b((\\d+'(b|h|o|d|B|H|O|D))[0-9xzXZa-fA-F_]+)"
                    },
                    {
                        begin: "\\B(('(b|h|o|d|B|H|O|D))[0-9xzXZa-fA-F_]+)"
                    },
                    {
                        begin: "\\b([0-9_])+",
                        relevance: 0
                    }
                ]
            },
            /* parameters to instances */ {
                className: "variable",
                variants: [
                    {
                        begin: "#\\((?!parameter).+\\)"
                    },
                    {
                        begin: "\\.\\w+",
                        relevance: 0
                    }
                ]
            },
            {
                className: "meta",
                begin: "`",
                end: "$",
                keywords: {
                    "meta-keyword": "define __FILE__ __LINE__ begin_keywords celldefine default_nettype define else elsif end_keywords endcelldefine endif ifdef ifndef include line nounconnected_drive pragma resetall timescale unconnected_drive undef undefineall"
                },
                relevance: 0
            }
        ]
    }; // return
};

});

parcelRegister("fqQ9v", function(module, exports) {
module.exports = function(hljs) {
    // Regular expression for VHDL numeric literals.
    // Decimal literal:
    var INTEGER_RE = "\\d(_|\\d)*";
    var EXPONENT_RE = "[eE][-+]?" + INTEGER_RE;
    var DECIMAL_LITERAL_RE = INTEGER_RE + "(\\." + INTEGER_RE + ")?" + "(" + EXPONENT_RE + ")?";
    // Based literal:
    var BASED_INTEGER_RE = "\\w+";
    var BASED_LITERAL_RE = INTEGER_RE + "#" + BASED_INTEGER_RE + "(\\." + BASED_INTEGER_RE + ")?" + "#" + "(" + EXPONENT_RE + ")?";
    var NUMBER_RE = "\\b(" + BASED_LITERAL_RE + "|" + DECIMAL_LITERAL_RE + ")";
    return {
        case_insensitive: true,
        keywords: {
            keyword: "abs access after alias all and architecture array assert assume assume_guarantee attribute begin block body buffer bus case component configuration constant context cover disconnect downto default else elsif end entity exit fairness file for force function generate generic group guarded if impure in inertial inout is label library linkage literal loop map mod nand new next nor not null of on open or others out package parameter port postponed procedure process property protected pure range record register reject release rem report restrict restrict_guarantee return rol ror select sequence severity shared signal sla sll sra srl strong subtype then to transport type unaffected units until use variable view vmode vprop vunit wait when while with xnor xor",
            built_in: "boolean bit character integer time delay_length natural positive string bit_vector file_open_kind file_open_status std_logic std_logic_vector unsigned signed boolean_vector integer_vector std_ulogic std_ulogic_vector unresolved_unsigned u_unsigned unresolved_signed u_signed real_vector time_vector",
            literal: "false true note warning error failure line text side width" // textio
        },
        illegal: "{",
        contains: [
            hljs.C_BLOCK_COMMENT_MODE,
            hljs.COMMENT("--", "$"),
            hljs.QUOTE_STRING_MODE,
            {
                className: "number",
                begin: NUMBER_RE,
                relevance: 0
            },
            {
                className: "string",
                begin: "'(U|X|0|1|Z|W|L|H|-)'",
                contains: [
                    hljs.BACKSLASH_ESCAPE
                ]
            },
            {
                className: "symbol",
                begin: "'[A-Za-z](_?[A-Za-z0-9])*",
                contains: [
                    hljs.BACKSLASH_ESCAPE
                ]
            }
        ]
    };
};

});

parcelRegister("gs6c3", function(module, exports) {
module.exports = function(hljs) {
    return {
        lexemes: /[!#@\w]+/,
        keywords: {
            keyword: // express version except: ! & * < = > !! # @ @@
            "N|0 P|0 X|0 a|0 ab abc abo al am an|0 ar arga argd arge argdo argg argl argu as au aug aun b|0 bN ba bad bd be bel bf bl bm bn bo bp br brea breaka breakd breakl bro bufdo buffers bun bw c|0 cN cNf ca cabc caddb cad caddf cal cat cb cc ccl cd ce cex cf cfir cgetb cgete cg changes chd che checkt cl cla clo cm cmapc cme cn cnew cnf cno cnorea cnoreme co col colo com comc comp con conf cope cp cpf cq cr cs cst cu cuna cunme cw delm deb debugg delc delf dif diffg diffo diffp diffpu diffs diffthis dig di dl dell dj dli do doautoa dp dr ds dsp e|0 ea ec echoe echoh echom echon el elsei em en endfo endf endt endw ene ex exe exi exu f|0 files filet fin fina fini fir fix fo foldc foldd folddoc foldo for fu go gr grepa gu gv ha helpf helpg helpt hi hid his ia iabc if ij il im imapc ime ino inorea inoreme int is isp iu iuna iunme j|0 ju k|0 keepa kee keepj lN lNf l|0 lad laddb laddf la lan lat lb lc lch lcl lcs le lefta let lex lf lfir lgetb lgete lg lgr lgrepa lh ll lla lli lmak lm lmapc lne lnew lnf ln loadk lo loc lockv lol lope lp lpf lr ls lt lu lua luad luaf lv lvimgrepa lw m|0 ma mak map mapc marks mat me menut mes mk mks mksp mkv mkvie mod mz mzf nbc nb nbs new nm nmapc nme nn nnoreme noa no noh norea noreme norm nu nun nunme ol o|0 om omapc ome on ono onoreme opt ou ounme ow p|0 profd prof pro promptr pc ped pe perld po popu pp pre prev ps pt ptN ptf ptj ptl ptn ptp ptr pts pu pw py3 python3 py3d py3f py pyd pyf quita qa rec red redi redr redraws reg res ret retu rew ri rightb rub rubyd rubyf rund ru rv sN san sa sal sav sb sbN sba sbf sbl sbm sbn sbp sbr scrip scripte scs se setf setg setl sf sfir sh sim sig sil sl sla sm smap smapc sme sn sni sno snor snoreme sor so spelld spe spelli spellr spellu spellw sp spr sre st sta startg startr star stopi stj sts sun sunm sunme sus sv sw sy synti sync tN tabN tabc tabdo tabe tabf tabfir tabl tabm tabnew tabn tabo tabp tabr tabs tab ta tags tc tcld tclf te tf th tj tl tm tn to tp tr try ts tu u|0 undoj undol una unh unl unlo unm unme uns up ve verb vert vim vimgrepa vi viu vie vm vmapc vme vne vn vnoreme vs vu vunme windo w|0 wN wa wh wi winc winp wn wp wq wqa ws wu wv x|0 xa xmapc xm xme xn xnoreme xu xunme y|0 z|0 ~ Next Print append abbreviate abclear aboveleft all amenu anoremenu args argadd argdelete argedit argglobal arglocal argument ascii autocmd augroup aunmenu buffer bNext ball badd bdelete behave belowright bfirst blast bmodified bnext botright bprevious brewind break breakadd breakdel breaklist browse bunload bwipeout change cNext cNfile cabbrev cabclear caddbuffer caddexpr caddfile call catch cbuffer cclose center cexpr cfile cfirst cgetbuffer cgetexpr cgetfile chdir checkpath checktime clist clast close cmap cmapclear cmenu cnext cnewer cnfile cnoremap cnoreabbrev cnoremenu copy colder colorscheme command comclear compiler continue confirm copen cprevious cpfile cquit crewind cscope cstag cunmap cunabbrev cunmenu cwindow delete delmarks debug debuggreedy delcommand delfunction diffupdate diffget diffoff diffpatch diffput diffsplit digraphs display deletel djump dlist doautocmd doautoall deletep drop dsearch dsplit edit earlier echo echoerr echohl echomsg else elseif emenu endif endfor endfunction endtry endwhile enew execute exit exusage file filetype find finally finish first fixdel fold foldclose folddoopen folddoclosed foldopen function global goto grep grepadd gui gvim hardcopy help helpfind helpgrep helptags highlight hide history insert iabbrev iabclear ijump ilist imap imapclear imenu inoremap inoreabbrev inoremenu intro isearch isplit iunmap iunabbrev iunmenu join jumps keepalt keepmarks keepjumps lNext lNfile list laddexpr laddbuffer laddfile last language later lbuffer lcd lchdir lclose lcscope left leftabove lexpr lfile lfirst lgetbuffer lgetexpr lgetfile lgrep lgrepadd lhelpgrep llast llist lmake lmap lmapclear lnext lnewer lnfile lnoremap loadkeymap loadview lockmarks lockvar lolder lopen lprevious lpfile lrewind ltag lunmap luado luafile lvimgrep lvimgrepadd lwindow move mark make mapclear match menu menutranslate messages mkexrc mksession mkspell mkvimrc mkview mode mzscheme mzfile nbclose nbkey nbsart next nmap nmapclear nmenu nnoremap nnoremenu noautocmd noremap nohlsearch noreabbrev noremenu normal number nunmap nunmenu oldfiles open omap omapclear omenu only onoremap onoremenu options ounmap ounmenu ownsyntax print profdel profile promptfind promptrepl pclose pedit perl perldo pop popup ppop preserve previous psearch ptag ptNext ptfirst ptjump ptlast ptnext ptprevious ptrewind ptselect put pwd py3do py3file python pydo pyfile quit quitall qall read recover redo redir redraw redrawstatus registers resize retab return rewind right rightbelow ruby rubydo rubyfile rundo runtime rviminfo substitute sNext sandbox sargument sall saveas sbuffer sbNext sball sbfirst sblast sbmodified sbnext sbprevious sbrewind scriptnames scriptencoding scscope set setfiletype setglobal setlocal sfind sfirst shell simalt sign silent sleep slast smagic smapclear smenu snext sniff snomagic snoremap snoremenu sort source spelldump spellgood spellinfo spellrepall spellundo spellwrong split sprevious srewind stop stag startgreplace startreplace startinsert stopinsert stjump stselect sunhide sunmap sunmenu suspend sview swapname syntax syntime syncbind tNext tabNext tabclose tabedit tabfind tabfirst tablast tabmove tabnext tabonly tabprevious tabrewind tag tcl tcldo tclfile tearoff tfirst throw tjump tlast tmenu tnext topleft tprevious trewind tselect tunmenu undo undojoin undolist unabbreviate unhide unlet unlockvar unmap unmenu unsilent update vglobal version verbose vertical vimgrep vimgrepadd visual viusage view vmap vmapclear vmenu vnew vnoremap vnoremenu vsplit vunmap vunmenu write wNext wall while winsize wincmd winpos wnext wprevious wqall wsverb wundo wviminfo xit xall xmapclear xmap xmenu xnoremap xnoremenu xunmap xunmenu yank",
            built_in: "synIDtrans atan2 range matcharg did_filetype asin feedkeys xor argv complete_check add getwinposx getqflist getwinposy screencol clearmatches empty extend getcmdpos mzeval garbagecollect setreg ceil sqrt diff_hlID inputsecret get getfperm getpid filewritable shiftwidth max sinh isdirectory synID system inputrestore winline atan visualmode inputlist tabpagewinnr round getregtype mapcheck hasmapto histdel argidx findfile sha256 exists toupper getcmdline taglist string getmatches bufnr strftime winwidth bufexists strtrans tabpagebuflist setcmdpos remote_read printf setloclist getpos getline bufwinnr float2nr len getcmdtype diff_filler luaeval resolve libcallnr foldclosedend reverse filter has_key bufname str2float strlen setline getcharmod setbufvar index searchpos shellescape undofile foldclosed setqflist buflisted strchars str2nr virtcol floor remove undotree remote_expr winheight gettabwinvar reltime cursor tabpagenr finddir localtime acos getloclist search tanh matchend rename gettabvar strdisplaywidth type abs py3eval setwinvar tolower wildmenumode log10 spellsuggest bufloaded synconcealed nextnonblank server2client complete settabwinvar executable input wincol setmatches getftype hlID inputsave searchpair or screenrow line settabvar histadd deepcopy strpart remote_peek and eval getftime submatch screenchar winsaveview matchadd mkdir screenattr getfontname libcall reltimestr getfsize winnr invert pow getbufline byte2line soundfold repeat fnameescape tagfiles sin strwidth spellbadword trunc maparg log lispindent hostname setpos globpath remote_foreground getchar synIDattr fnamemodify cscope_connection stridx winbufnr indent min complete_add nr2char searchpairpos inputdialog values matchlist items hlexists strridx browsedir expand fmod pathshorten line2byte argc count getwinvar glob foldtextresult getreg foreground cosh matchdelete has char2nr simplify histget searchdecl iconv winrestcmd pumvisible writefile foldlevel haslocaldir keys cos matchstr foldtext histnr tan tempname getcwd byteidx getbufvar islocked escape eventhandler remote_send serverlist winrestview synstack pyeval prevnonblank readfile cindent filereadable changenr exp"
        },
        illegal: /;/,
        contains: [
            hljs.NUMBER_MODE,
            {
                className: "string",
                begin: "'",
                end: "'",
                illegal: "\\n"
            },
            /*
      A double quote can start either a string or a line comment. Strings are
      ended before the end of a line by another double quote and can contain
      escaped double-quotes and post-escaped line breaks.

      Also, any double quote at the beginning of a line is a comment but we
      don't handle that properly at the moment: any double quote inside will
      turn them into a string. Handling it properly will require a smarter
      parser.
      */ {
                className: "string",
                begin: /"(\\"|\n\\|[^"\n])*"/
            },
            hljs.COMMENT('"', "$"),
            {
                className: "variable",
                begin: /[bwtglsav]:[\w\d_]*/
            },
            {
                className: "function",
                beginKeywords: "function function!",
                end: "$",
                relevance: 0,
                contains: [
                    hljs.TITLE_MODE,
                    {
                        className: "params",
                        begin: "\\(",
                        end: "\\)"
                    }
                ]
            },
            {
                className: "symbol",
                begin: /<[\w-]+>/
            }
        ]
    };
};

});

parcelRegister("1shLC", function(module, exports) {
module.exports = function(hljs) {
    return {
        case_insensitive: true,
        lexemes: "[.%]?" + hljs.IDENT_RE,
        keywords: {
            keyword: "lock rep repe repz repne repnz xaquire xrelease bnd nobnd aaa aad aam aas adc add and arpl bb0_reset bb1_reset bound bsf bsr bswap bt btc btr bts call cbw cdq cdqe clc cld cli clts cmc cmp cmpsb cmpsd cmpsq cmpsw cmpxchg cmpxchg486 cmpxchg8b cmpxchg16b cpuid cpu_read cpu_write cqo cwd cwde daa das dec div dmint emms enter equ f2xm1 fabs fadd faddp fbld fbstp fchs fclex fcmovb fcmovbe fcmove fcmovnb fcmovnbe fcmovne fcmovnu fcmovu fcom fcomi fcomip fcomp fcompp fcos fdecstp fdisi fdiv fdivp fdivr fdivrp femms feni ffree ffreep fiadd ficom ficomp fidiv fidivr fild fimul fincstp finit fist fistp fisttp fisub fisubr fld fld1 fldcw fldenv fldl2e fldl2t fldlg2 fldln2 fldpi fldz fmul fmulp fnclex fndisi fneni fninit fnop fnsave fnstcw fnstenv fnstsw fpatan fprem fprem1 fptan frndint frstor fsave fscale fsetpm fsin fsincos fsqrt fst fstcw fstenv fstp fstsw fsub fsubp fsubr fsubrp ftst fucom fucomi fucomip fucomp fucompp fxam fxch fxtract fyl2x fyl2xp1 hlt ibts icebp idiv imul in inc incbin insb insd insw int int01 int1 int03 int3 into invd invpcid invlpg invlpga iret iretd iretq iretw jcxz jecxz jrcxz jmp jmpe lahf lar lds lea leave les lfence lfs lgdt lgs lidt lldt lmsw loadall loadall286 lodsb lodsd lodsq lodsw loop loope loopne loopnz loopz lsl lss ltr mfence monitor mov movd movq movsb movsd movsq movsw movsx movsxd movzx mul mwait neg nop not or out outsb outsd outsw packssdw packsswb packuswb paddb paddd paddsb paddsiw paddsw paddusb paddusw paddw pand pandn pause paveb pavgusb pcmpeqb pcmpeqd pcmpeqw pcmpgtb pcmpgtd pcmpgtw pdistib pf2id pfacc pfadd pfcmpeq pfcmpge pfcmpgt pfmax pfmin pfmul pfrcp pfrcpit1 pfrcpit2 pfrsqit1 pfrsqrt pfsub pfsubr pi2fd pmachriw pmaddwd pmagw pmulhriw pmulhrwa pmulhrwc pmulhw pmullw pmvgezb pmvlzb pmvnzb pmvzb pop popa popad popaw popf popfd popfq popfw por prefetch prefetchw pslld psllq psllw psrad psraw psrld psrlq psrlw psubb psubd psubsb psubsiw psubsw psubusb psubusw psubw punpckhbw punpckhdq punpckhwd punpcklbw punpckldq punpcklwd push pusha pushad pushaw pushf pushfd pushfq pushfw pxor rcl rcr rdshr rdmsr rdpmc rdtsc rdtscp ret retf retn rol ror rdm rsdc rsldt rsm rsts sahf sal salc sar sbb scasb scasd scasq scasw sfence sgdt shl shld shr shrd sidt sldt skinit smi smint smintold smsw stc std sti stosb stosd stosq stosw str sub svdc svldt svts swapgs syscall sysenter sysexit sysret test ud0 ud1 ud2b ud2 ud2a umov verr verw fwait wbinvd wrshr wrmsr xadd xbts xchg xlatb xlat xor cmove cmovz cmovne cmovnz cmova cmovnbe cmovae cmovnb cmovb cmovnae cmovbe cmovna cmovg cmovnle cmovge cmovnl cmovl cmovnge cmovle cmovng cmovc cmovnc cmovo cmovno cmovs cmovns cmovp cmovpe cmovnp cmovpo je jz jne jnz ja jnbe jae jnb jb jnae jbe jna jg jnle jge jnl jl jnge jle jng jc jnc jo jno js jns jpo jnp jpe jp sete setz setne setnz seta setnbe setae setnb setnc setb setnae setcset setbe setna setg setnle setge setnl setl setnge setle setng sets setns seto setno setpe setp setpo setnp addps addss andnps andps cmpeqps cmpeqss cmpleps cmpless cmpltps cmpltss cmpneqps cmpneqss cmpnleps cmpnless cmpnltps cmpnltss cmpordps cmpordss cmpunordps cmpunordss cmpps cmpss comiss cvtpi2ps cvtps2pi cvtsi2ss cvtss2si cvttps2pi cvttss2si divps divss ldmxcsr maxps maxss minps minss movaps movhps movlhps movlps movhlps movmskps movntps movss movups mulps mulss orps rcpps rcpss rsqrtps rsqrtss shufps sqrtps sqrtss stmxcsr subps subss ucomiss unpckhps unpcklps xorps fxrstor fxrstor64 fxsave fxsave64 xgetbv xsetbv xsave xsave64 xsaveopt xsaveopt64 xrstor xrstor64 prefetchnta prefetcht0 prefetcht1 prefetcht2 maskmovq movntq pavgb pavgw pextrw pinsrw pmaxsw pmaxub pminsw pminub pmovmskb pmulhuw psadbw pshufw pf2iw pfnacc pfpnacc pi2fw pswapd maskmovdqu clflush movntdq movnti movntpd movdqa movdqu movdq2q movq2dq paddq pmuludq pshufd pshufhw pshuflw pslldq psrldq psubq punpckhqdq punpcklqdq addpd addsd andnpd andpd cmpeqpd cmpeqsd cmplepd cmplesd cmpltpd cmpltsd cmpneqpd cmpneqsd cmpnlepd cmpnlesd cmpnltpd cmpnltsd cmpordpd cmpordsd cmpunordpd cmpunordsd cmppd comisd cvtdq2pd cvtdq2ps cvtpd2dq cvtpd2pi cvtpd2ps cvtpi2pd cvtps2dq cvtps2pd cvtsd2si cvtsd2ss cvtsi2sd cvtss2sd cvttpd2pi cvttpd2dq cvttps2dq cvttsd2si divpd divsd maxpd maxsd minpd minsd movapd movhpd movlpd movmskpd movupd mulpd mulsd orpd shufpd sqrtpd sqrtsd subpd subsd ucomisd unpckhpd unpcklpd xorpd addsubpd addsubps haddpd haddps hsubpd hsubps lddqu movddup movshdup movsldup clgi stgi vmcall vmclear vmfunc vmlaunch vmload vmmcall vmptrld vmptrst vmread vmresume vmrun vmsave vmwrite vmxoff vmxon invept invvpid pabsb pabsw pabsd palignr phaddw phaddd phaddsw phsubw phsubd phsubsw pmaddubsw pmulhrsw pshufb psignb psignw psignd extrq insertq movntsd movntss lzcnt blendpd blendps blendvpd blendvps dppd dpps extractps insertps movntdqa mpsadbw packusdw pblendvb pblendw pcmpeqq pextrb pextrd pextrq phminposuw pinsrb pinsrd pinsrq pmaxsb pmaxsd pmaxud pmaxuw pminsb pminsd pminud pminuw pmovsxbw pmovsxbd pmovsxbq pmovsxwd pmovsxwq pmovsxdq pmovzxbw pmovzxbd pmovzxbq pmovzxwd pmovzxwq pmovzxdq pmuldq pmulld ptest roundpd roundps roundsd roundss crc32 pcmpestri pcmpestrm pcmpistri pcmpistrm pcmpgtq popcnt getsec pfrcpv pfrsqrtv movbe aesenc aesenclast aesdec aesdeclast aesimc aeskeygenassist vaesenc vaesenclast vaesdec vaesdeclast vaesimc vaeskeygenassist vaddpd vaddps vaddsd vaddss vaddsubpd vaddsubps vandpd vandps vandnpd vandnps vblendpd vblendps vblendvpd vblendvps vbroadcastss vbroadcastsd vbroadcastf128 vcmpeq_ospd vcmpeqpd vcmplt_ospd vcmpltpd vcmple_ospd vcmplepd vcmpunord_qpd vcmpunordpd vcmpneq_uqpd vcmpneqpd vcmpnlt_uspd vcmpnltpd vcmpnle_uspd vcmpnlepd vcmpord_qpd vcmpordpd vcmpeq_uqpd vcmpnge_uspd vcmpngepd vcmpngt_uspd vcmpngtpd vcmpfalse_oqpd vcmpfalsepd vcmpneq_oqpd vcmpge_ospd vcmpgepd vcmpgt_ospd vcmpgtpd vcmptrue_uqpd vcmptruepd vcmplt_oqpd vcmple_oqpd vcmpunord_spd vcmpneq_uspd vcmpnlt_uqpd vcmpnle_uqpd vcmpord_spd vcmpeq_uspd vcmpnge_uqpd vcmpngt_uqpd vcmpfalse_ospd vcmpneq_ospd vcmpge_oqpd vcmpgt_oqpd vcmptrue_uspd vcmppd vcmpeq_osps vcmpeqps vcmplt_osps vcmpltps vcmple_osps vcmpleps vcmpunord_qps vcmpunordps vcmpneq_uqps vcmpneqps vcmpnlt_usps vcmpnltps vcmpnle_usps vcmpnleps vcmpord_qps vcmpordps vcmpeq_uqps vcmpnge_usps vcmpngeps vcmpngt_usps vcmpngtps vcmpfalse_oqps vcmpfalseps vcmpneq_oqps vcmpge_osps vcmpgeps vcmpgt_osps vcmpgtps vcmptrue_uqps vcmptrueps vcmplt_oqps vcmple_oqps vcmpunord_sps vcmpneq_usps vcmpnlt_uqps vcmpnle_uqps vcmpord_sps vcmpeq_usps vcmpnge_uqps vcmpngt_uqps vcmpfalse_osps vcmpneq_osps vcmpge_oqps vcmpgt_oqps vcmptrue_usps vcmpps vcmpeq_ossd vcmpeqsd vcmplt_ossd vcmpltsd vcmple_ossd vcmplesd vcmpunord_qsd vcmpunordsd vcmpneq_uqsd vcmpneqsd vcmpnlt_ussd vcmpnltsd vcmpnle_ussd vcmpnlesd vcmpord_qsd vcmpordsd vcmpeq_uqsd vcmpnge_ussd vcmpngesd vcmpngt_ussd vcmpngtsd vcmpfalse_oqsd vcmpfalsesd vcmpneq_oqsd vcmpge_ossd vcmpgesd vcmpgt_ossd vcmpgtsd vcmptrue_uqsd vcmptruesd vcmplt_oqsd vcmple_oqsd vcmpunord_ssd vcmpneq_ussd vcmpnlt_uqsd vcmpnle_uqsd vcmpord_ssd vcmpeq_ussd vcmpnge_uqsd vcmpngt_uqsd vcmpfalse_ossd vcmpneq_ossd vcmpge_oqsd vcmpgt_oqsd vcmptrue_ussd vcmpsd vcmpeq_osss vcmpeqss vcmplt_osss vcmpltss vcmple_osss vcmpless vcmpunord_qss vcmpunordss vcmpneq_uqss vcmpneqss vcmpnlt_usss vcmpnltss vcmpnle_usss vcmpnless vcmpord_qss vcmpordss vcmpeq_uqss vcmpnge_usss vcmpngess vcmpngt_usss vcmpngtss vcmpfalse_oqss vcmpfalsess vcmpneq_oqss vcmpge_osss vcmpgess vcmpgt_osss vcmpgtss vcmptrue_uqss vcmptruess vcmplt_oqss vcmple_oqss vcmpunord_sss vcmpneq_usss vcmpnlt_uqss vcmpnle_uqss vcmpord_sss vcmpeq_usss vcmpnge_uqss vcmpngt_uqss vcmpfalse_osss vcmpneq_osss vcmpge_oqss vcmpgt_oqss vcmptrue_usss vcmpss vcomisd vcomiss vcvtdq2pd vcvtdq2ps vcvtpd2dq vcvtpd2ps vcvtps2dq vcvtps2pd vcvtsd2si vcvtsd2ss vcvtsi2sd vcvtsi2ss vcvtss2sd vcvtss2si vcvttpd2dq vcvttps2dq vcvttsd2si vcvttss2si vdivpd vdivps vdivsd vdivss vdppd vdpps vextractf128 vextractps vhaddpd vhaddps vhsubpd vhsubps vinsertf128 vinsertps vlddqu vldqqu vldmxcsr vmaskmovdqu vmaskmovps vmaskmovpd vmaxpd vmaxps vmaxsd vmaxss vminpd vminps vminsd vminss vmovapd vmovaps vmovd vmovq vmovddup vmovdqa vmovqqa vmovdqu vmovqqu vmovhlps vmovhpd vmovhps vmovlhps vmovlpd vmovlps vmovmskpd vmovmskps vmovntdq vmovntqq vmovntdqa vmovntpd vmovntps vmovsd vmovshdup vmovsldup vmovss vmovupd vmovups vmpsadbw vmulpd vmulps vmulsd vmulss vorpd vorps vpabsb vpabsw vpabsd vpacksswb vpackssdw vpackuswb vpackusdw vpaddb vpaddw vpaddd vpaddq vpaddsb vpaddsw vpaddusb vpaddusw vpalignr vpand vpandn vpavgb vpavgw vpblendvb vpblendw vpcmpestri vpcmpestrm vpcmpistri vpcmpistrm vpcmpeqb vpcmpeqw vpcmpeqd vpcmpeqq vpcmpgtb vpcmpgtw vpcmpgtd vpcmpgtq vpermilpd vpermilps vperm2f128 vpextrb vpextrw vpextrd vpextrq vphaddw vphaddd vphaddsw vphminposuw vphsubw vphsubd vphsubsw vpinsrb vpinsrw vpinsrd vpinsrq vpmaddwd vpmaddubsw vpmaxsb vpmaxsw vpmaxsd vpmaxub vpmaxuw vpmaxud vpminsb vpminsw vpminsd vpminub vpminuw vpminud vpmovmskb vpmovsxbw vpmovsxbd vpmovsxbq vpmovsxwd vpmovsxwq vpmovsxdq vpmovzxbw vpmovzxbd vpmovzxbq vpmovzxwd vpmovzxwq vpmovzxdq vpmulhuw vpmulhrsw vpmulhw vpmullw vpmulld vpmuludq vpmuldq vpor vpsadbw vpshufb vpshufd vpshufhw vpshuflw vpsignb vpsignw vpsignd vpslldq vpsrldq vpsllw vpslld vpsllq vpsraw vpsrad vpsrlw vpsrld vpsrlq vptest vpsubb vpsubw vpsubd vpsubq vpsubsb vpsubsw vpsubusb vpsubusw vpunpckhbw vpunpckhwd vpunpckhdq vpunpckhqdq vpunpcklbw vpunpcklwd vpunpckldq vpunpcklqdq vpxor vrcpps vrcpss vrsqrtps vrsqrtss vroundpd vroundps vroundsd vroundss vshufpd vshufps vsqrtpd vsqrtps vsqrtsd vsqrtss vstmxcsr vsubpd vsubps vsubsd vsubss vtestps vtestpd vucomisd vucomiss vunpckhpd vunpckhps vunpcklpd vunpcklps vxorpd vxorps vzeroall vzeroupper pclmullqlqdq pclmulhqlqdq pclmullqhqdq pclmulhqhqdq pclmulqdq vpclmullqlqdq vpclmulhqlqdq vpclmullqhqdq vpclmulhqhqdq vpclmulqdq vfmadd132ps vfmadd132pd vfmadd312ps vfmadd312pd vfmadd213ps vfmadd213pd vfmadd123ps vfmadd123pd vfmadd231ps vfmadd231pd vfmadd321ps vfmadd321pd vfmaddsub132ps vfmaddsub132pd vfmaddsub312ps vfmaddsub312pd vfmaddsub213ps vfmaddsub213pd vfmaddsub123ps vfmaddsub123pd vfmaddsub231ps vfmaddsub231pd vfmaddsub321ps vfmaddsub321pd vfmsub132ps vfmsub132pd vfmsub312ps vfmsub312pd vfmsub213ps vfmsub213pd vfmsub123ps vfmsub123pd vfmsub231ps vfmsub231pd vfmsub321ps vfmsub321pd vfmsubadd132ps vfmsubadd132pd vfmsubadd312ps vfmsubadd312pd vfmsubadd213ps vfmsubadd213pd vfmsubadd123ps vfmsubadd123pd vfmsubadd231ps vfmsubadd231pd vfmsubadd321ps vfmsubadd321pd vfnmadd132ps vfnmadd132pd vfnmadd312ps vfnmadd312pd vfnmadd213ps vfnmadd213pd vfnmadd123ps vfnmadd123pd vfnmadd231ps vfnmadd231pd vfnmadd321ps vfnmadd321pd vfnmsub132ps vfnmsub132pd vfnmsub312ps vfnmsub312pd vfnmsub213ps vfnmsub213pd vfnmsub123ps vfnmsub123pd vfnmsub231ps vfnmsub231pd vfnmsub321ps vfnmsub321pd vfmadd132ss vfmadd132sd vfmadd312ss vfmadd312sd vfmadd213ss vfmadd213sd vfmadd123ss vfmadd123sd vfmadd231ss vfmadd231sd vfmadd321ss vfmadd321sd vfmsub132ss vfmsub132sd vfmsub312ss vfmsub312sd vfmsub213ss vfmsub213sd vfmsub123ss vfmsub123sd vfmsub231ss vfmsub231sd vfmsub321ss vfmsub321sd vfnmadd132ss vfnmadd132sd vfnmadd312ss vfnmadd312sd vfnmadd213ss vfnmadd213sd vfnmadd123ss vfnmadd123sd vfnmadd231ss vfnmadd231sd vfnmadd321ss vfnmadd321sd vfnmsub132ss vfnmsub132sd vfnmsub312ss vfnmsub312sd vfnmsub213ss vfnmsub213sd vfnmsub123ss vfnmsub123sd vfnmsub231ss vfnmsub231sd vfnmsub321ss vfnmsub321sd rdfsbase rdgsbase rdrand wrfsbase wrgsbase vcvtph2ps vcvtps2ph adcx adox rdseed clac stac xstore xcryptecb xcryptcbc xcryptctr xcryptcfb xcryptofb montmul xsha1 xsha256 llwpcb slwpcb lwpval lwpins vfmaddpd vfmaddps vfmaddsd vfmaddss vfmaddsubpd vfmaddsubps vfmsubaddpd vfmsubaddps vfmsubpd vfmsubps vfmsubsd vfmsubss vfnmaddpd vfnmaddps vfnmaddsd vfnmaddss vfnmsubpd vfnmsubps vfnmsubsd vfnmsubss vfrczpd vfrczps vfrczsd vfrczss vpcmov vpcomb vpcomd vpcomq vpcomub vpcomud vpcomuq vpcomuw vpcomw vphaddbd vphaddbq vphaddbw vphadddq vphaddubd vphaddubq vphaddubw vphaddudq vphadduwd vphadduwq vphaddwd vphaddwq vphsubbw vphsubdq vphsubwd vpmacsdd vpmacsdqh vpmacsdql vpmacssdd vpmacssdqh vpmacssdql vpmacsswd vpmacssww vpmacswd vpmacsww vpmadcsswd vpmadcswd vpperm vprotb vprotd vprotq vprotw vpshab vpshad vpshaq vpshaw vpshlb vpshld vpshlq vpshlw vbroadcasti128 vpblendd vpbroadcastb vpbroadcastw vpbroadcastd vpbroadcastq vpermd vpermpd vpermps vpermq vperm2i128 vextracti128 vinserti128 vpmaskmovd vpmaskmovq vpsllvd vpsllvq vpsravd vpsrlvd vpsrlvq vgatherdpd vgatherqpd vgatherdps vgatherqps vpgatherdd vpgatherqd vpgatherdq vpgatherqq xabort xbegin xend xtest andn bextr blci blcic blsi blsic blcfill blsfill blcmsk blsmsk blsr blcs bzhi mulx pdep pext rorx sarx shlx shrx tzcnt tzmsk t1mskc valignd valignq vblendmpd vblendmps vbroadcastf32x4 vbroadcastf64x4 vbroadcasti32x4 vbroadcasti64x4 vcompresspd vcompressps vcvtpd2udq vcvtps2udq vcvtsd2usi vcvtss2usi vcvttpd2udq vcvttps2udq vcvttsd2usi vcvttss2usi vcvtudq2pd vcvtudq2ps vcvtusi2sd vcvtusi2ss vexpandpd vexpandps vextractf32x4 vextractf64x4 vextracti32x4 vextracti64x4 vfixupimmpd vfixupimmps vfixupimmsd vfixupimmss vgetexppd vgetexpps vgetexpsd vgetexpss vgetmantpd vgetmantps vgetmantsd vgetmantss vinsertf32x4 vinsertf64x4 vinserti32x4 vinserti64x4 vmovdqa32 vmovdqa64 vmovdqu32 vmovdqu64 vpabsq vpandd vpandnd vpandnq vpandq vpblendmd vpblendmq vpcmpltd vpcmpled vpcmpneqd vpcmpnltd vpcmpnled vpcmpd vpcmpltq vpcmpleq vpcmpneqq vpcmpnltq vpcmpnleq vpcmpq vpcmpequd vpcmpltud vpcmpleud vpcmpnequd vpcmpnltud vpcmpnleud vpcmpud vpcmpequq vpcmpltuq vpcmpleuq vpcmpnequq vpcmpnltuq vpcmpnleuq vpcmpuq vpcompressd vpcompressq vpermi2d vpermi2pd vpermi2ps vpermi2q vpermt2d vpermt2pd vpermt2ps vpermt2q vpexpandd vpexpandq vpmaxsq vpmaxuq vpminsq vpminuq vpmovdb vpmovdw vpmovqb vpmovqd vpmovqw vpmovsdb vpmovsdw vpmovsqb vpmovsqd vpmovsqw vpmovusdb vpmovusdw vpmovusqb vpmovusqd vpmovusqw vpord vporq vprold vprolq vprolvd vprolvq vprord vprorq vprorvd vprorvq vpscatterdd vpscatterdq vpscatterqd vpscatterqq vpsraq vpsravq vpternlogd vpternlogq vptestmd vptestmq vptestnmd vptestnmq vpxord vpxorq vrcp14pd vrcp14ps vrcp14sd vrcp14ss vrndscalepd vrndscaleps vrndscalesd vrndscaless vrsqrt14pd vrsqrt14ps vrsqrt14sd vrsqrt14ss vscalefpd vscalefps vscalefsd vscalefss vscatterdpd vscatterdps vscatterqpd vscatterqps vshuff32x4 vshuff64x2 vshufi32x4 vshufi64x2 kandnw kandw kmovw knotw kortestw korw kshiftlw kshiftrw kunpckbw kxnorw kxorw vpbroadcastmb2q vpbroadcastmw2d vpconflictd vpconflictq vplzcntd vplzcntq vexp2pd vexp2ps vrcp28pd vrcp28ps vrcp28sd vrcp28ss vrsqrt28pd vrsqrt28ps vrsqrt28sd vrsqrt28ss vgatherpf0dpd vgatherpf0dps vgatherpf0qpd vgatherpf0qps vgatherpf1dpd vgatherpf1dps vgatherpf1qpd vgatherpf1qps vscatterpf0dpd vscatterpf0dps vscatterpf0qpd vscatterpf0qps vscatterpf1dpd vscatterpf1dps vscatterpf1qpd vscatterpf1qps prefetchwt1 bndmk bndcl bndcu bndcn bndmov bndldx bndstx sha1rnds4 sha1nexte sha1msg1 sha1msg2 sha256rnds2 sha256msg1 sha256msg2 hint_nop0 hint_nop1 hint_nop2 hint_nop3 hint_nop4 hint_nop5 hint_nop6 hint_nop7 hint_nop8 hint_nop9 hint_nop10 hint_nop11 hint_nop12 hint_nop13 hint_nop14 hint_nop15 hint_nop16 hint_nop17 hint_nop18 hint_nop19 hint_nop20 hint_nop21 hint_nop22 hint_nop23 hint_nop24 hint_nop25 hint_nop26 hint_nop27 hint_nop28 hint_nop29 hint_nop30 hint_nop31 hint_nop32 hint_nop33 hint_nop34 hint_nop35 hint_nop36 hint_nop37 hint_nop38 hint_nop39 hint_nop40 hint_nop41 hint_nop42 hint_nop43 hint_nop44 hint_nop45 hint_nop46 hint_nop47 hint_nop48 hint_nop49 hint_nop50 hint_nop51 hint_nop52 hint_nop53 hint_nop54 hint_nop55 hint_nop56 hint_nop57 hint_nop58 hint_nop59 hint_nop60 hint_nop61 hint_nop62 hint_nop63",
            built_in: // Instruction pointer
            "ip eip rip al ah bl bh cl ch dl dh sil dil bpl spl r8b r9b r10b r11b r12b r13b r14b r15b ax bx cx dx si di bp sp r8w r9w r10w r11w r12w r13w r14w r15w eax ebx ecx edx esi edi ebp esp eip r8d r9d r10d r11d r12d r13d r14d r15d rax rbx rcx rdx rsi rdi rbp rsp r8 r9 r10 r11 r12 r13 r14 r15 cs ds es fs gs ss st st0 st1 st2 st3 st4 st5 st6 st7 mm0 mm1 mm2 mm3 mm4 mm5 mm6 mm7 xmm0  xmm1  xmm2  xmm3  xmm4  xmm5  xmm6  xmm7  xmm8  xmm9 xmm10  xmm11 xmm12 xmm13 xmm14 xmm15 xmm16 xmm17 xmm18 xmm19 xmm20 xmm21 xmm22 xmm23 xmm24 xmm25 xmm26 xmm27 xmm28 xmm29 xmm30 xmm31 ymm0  ymm1  ymm2  ymm3  ymm4  ymm5  ymm6  ymm7  ymm8  ymm9 ymm10  ymm11 ymm12 ymm13 ymm14 ymm15 ymm16 ymm17 ymm18 ymm19 ymm20 ymm21 ymm22 ymm23 ymm24 ymm25 ymm26 ymm27 ymm28 ymm29 ymm30 ymm31 zmm0  zmm1  zmm2  zmm3  zmm4  zmm5  zmm6  zmm7  zmm8  zmm9 zmm10  zmm11 zmm12 zmm13 zmm14 zmm15 zmm16 zmm17 zmm18 zmm19 zmm20 zmm21 zmm22 zmm23 zmm24 zmm25 zmm26 zmm27 zmm28 zmm29 zmm30 zmm31 k0 k1 k2 k3 k4 k5 k6 k7 bnd0 bnd1 bnd2 bnd3 cr0 cr1 cr2 cr3 cr4 cr8 dr0 dr1 dr2 dr3 dr8 tr3 tr4 tr5 tr6 tr7 r0 r1 r2 r3 r4 r5 r6 r7 r0b r1b r2b r3b r4b r5b r6b r7b r0w r1w r2w r3w r4w r5w r6w r7w r0d r1d r2d r3d r4d r5d r6d r7d r0h r1h r2h r3h r0l r1l r2l r3l r4l r5l r6l r7l r8l r9l r10l r11l r12l r13l r14l r15l db dw dd dq dt ddq do dy dz resb resw resd resq rest resdq reso resy resz incbin equ times byte word dword qword nosplit rel abs seg wrt strict near far a32 ptr",
            meta: "%define %xdefine %+ %undef %defstr %deftok %assign %strcat %strlen %substr %rotate %elif %else %endif %if %ifmacro %ifctx %ifidn %ifidni %ifid %ifnum %ifstr %iftoken %ifempty %ifenv %error %warning %fatal %rep %endrep %include %push %pop %repl %pathsearch %depend %use %arg %stacksize %local %line %comment %endcomment .nolist __FILE__ __LINE__ __SECT__  __BITS__ __OUTPUT_FORMAT__ __DATE__ __TIME__ __DATE_NUM__ __TIME_NUM__ __UTC_DATE__ __UTC_TIME__ __UTC_DATE_NUM__ __UTC_TIME_NUM__  __PASS__ struc endstruc istruc at iend align alignb sectalign daz nodaz up down zero default option assume public bits use16 use32 use64 default section segment absolute extern global common cpu float __utf16__ __utf16le__ __utf16be__ __utf32__ __utf32le__ __utf32be__ __float8__ __float16__ __float32__ __float64__ __float80m__ __float80e__ __float128l__ __float128h__ __Infinity__ __QNaN__ __SNaN__ Inf NaN QNaN SNaN float8 float16 float32 float64 float80m float80e float128l float128h __FLOAT_DAZ__ __FLOAT_ROUND__ __FLOAT__"
        },
        contains: [
            hljs.COMMENT(";", "$", {
                relevance: 0
            }),
            {
                className: "number",
                variants: [
                    // Float number and x87 BCD
                    {
                        begin: "\\b(?:([0-9][0-9_]*)?\\.[0-9_]*(?:[eE][+-]?[0-9_]+)?|(0[Xx])?[0-9][0-9_]*\\.?[0-9_]*(?:[pP](?:[+-]?[0-9_]+)?)?)\\b",
                        relevance: 0
                    },
                    // Hex number in $
                    {
                        begin: "\\$[0-9][0-9A-Fa-f]*",
                        relevance: 0
                    },
                    // Number in H,D,T,Q,O,B,Y suffix
                    {
                        begin: "\\b(?:[0-9A-Fa-f][0-9A-Fa-f_]*[Hh]|[0-9][0-9_]*[DdTt]?|[0-7][0-7_]*[QqOo]|[0-1][0-1_]*[BbYy])\\b"
                    },
                    // Number in X,D,T,Q,O,B,Y prefix
                    {
                        begin: "\\b(?:0[Xx][0-9A-Fa-f_]+|0[DdTt][0-9_]+|0[QqOo][0-7_]+|0[BbYy][0-1_]+)\\b"
                    }
                ]
            },
            // Double quote string
            hljs.QUOTE_STRING_MODE,
            {
                className: "string",
                variants: [
                    // Single-quoted string
                    {
                        begin: "'",
                        end: "[^\\\\]'"
                    },
                    // Backquoted string
                    {
                        begin: "`",
                        end: "[^\\\\]`"
                    }
                ],
                relevance: 0
            },
            {
                className: "symbol",
                variants: [
                    // Global label and local label
                    {
                        begin: "^\\s*[A-Za-z._?][A-Za-z0-9_$#@~.?]*(:|\\s+label)"
                    },
                    // Macro-local label
                    {
                        begin: "^\\s*%%[A-Za-z0-9_$#@~.?]*:"
                    }
                ],
                relevance: 0
            },
            // Macro parameter
            {
                className: "subst",
                begin: "%[0-9]+",
                relevance: 0
            },
            // Macro parameter
            {
                className: "subst",
                begin: "%!S+",
                relevance: 0
            },
            {
                className: "meta",
                begin: /^\s*\.[\w_-]+/
            }
        ]
    };
};

});

parcelRegister("2Q6SU", function(module, exports) {
module.exports = function(hljs) {
    var BUILTIN_MODULES = "ObjectLoader Animate MovieCredits Slides Filters Shading Materials LensFlare Mapping VLCAudioVideo StereoDecoder PointCloud NetworkAccess RemoteControl RegExp ChromaKey Snowfall NodeJS Speech Charts";
    var XL_KEYWORDS = {
        keyword: "if then else do while until for loop import with is as where when by data constant integer real text name boolean symbol infix prefix postfix block tree",
        literal: "true false nil",
        built_in: "in mod rem and or xor not abs sign floor ceil sqrt sin cos tan asin acos atan exp expm1 log log2 log10 log1p pi at text_length text_range text_find text_replace contains page slide basic_slide title_slide title subtitle fade_in fade_out fade_at clear_color color line_color line_width texture_wrap texture_transform texture scale_?x scale_?y scale_?z? translate_?x translate_?y translate_?z? rotate_?x rotate_?y rotate_?z? rectangle circle ellipse sphere path line_to move_to quad_to curve_to theme background contents locally time mouse_?x mouse_?y mouse_buttons " + BUILTIN_MODULES
    };
    var DOUBLE_QUOTE_TEXT = {
        className: "string",
        begin: '"',
        end: '"',
        illegal: "\\n"
    };
    var SINGLE_QUOTE_TEXT = {
        className: "string",
        begin: "'",
        end: "'",
        illegal: "\\n"
    };
    var LONG_TEXT = {
        className: "string",
        begin: "<<",
        end: ">>"
    };
    var BASED_NUMBER = {
        className: "number",
        begin: "[0-9]+#[0-9A-Z_]+(\\.[0-9-A-Z_]+)?#?([Ee][+-]?[0-9]+)?"
    };
    var IMPORT = {
        beginKeywords: "import",
        end: "$",
        keywords: XL_KEYWORDS,
        contains: [
            DOUBLE_QUOTE_TEXT
        ]
    };
    var FUNCTION_DEFINITION = {
        className: "function",
        begin: /[a-z][^\n]*->/,
        returnBegin: true,
        end: /->/,
        contains: [
            hljs.inherit(hljs.TITLE_MODE, {
                starts: {
                    endsWithParent: true,
                    keywords: XL_KEYWORDS
                }
            })
        ]
    };
    return {
        aliases: [
            "tao"
        ],
        lexemes: /[a-zA-Z][a-zA-Z0-9_?]*/,
        keywords: XL_KEYWORDS,
        contains: [
            hljs.C_LINE_COMMENT_MODE,
            hljs.C_BLOCK_COMMENT_MODE,
            DOUBLE_QUOTE_TEXT,
            SINGLE_QUOTE_TEXT,
            LONG_TEXT,
            FUNCTION_DEFINITION,
            IMPORT,
            BASED_NUMBER,
            hljs.NUMBER_MODE
        ]
    };
};

});

parcelRegister("in7A8", function(module, exports) {
module.exports = function(hljs) {
    // see https://www.w3.org/TR/xquery/#id-terminal-delimitation
    var KEYWORDS = "module schema namespace boundary-space preserve no-preserve strip default collation base-uri ordering context decimal-format decimal-separator copy-namespaces empty-sequence except exponent-separator external grouping-separator inherit no-inherit lax minus-sign per-mille percent schema-attribute schema-element strict unordered zero-digit declare import option function validate variable for at in let where order group by return if then else tumbling sliding window start when only end previous next stable ascending descending allowing empty greatest least some every satisfies switch case typeswitch try catch and or to union intersect instance of treat as castable cast map array delete insert into replace value rename copy modify update";
    // Node Types (sorted by inheritance)
    // atomic types (sorted by inheritance)
    var TYPE = "item document-node node attribute document element comment namespace namespace-node processing-instruction text construction xs:anyAtomicType xs:untypedAtomic xs:duration xs:time xs:decimal xs:float xs:double xs:gYearMonth xs:gYear xs:gMonthDay xs:gMonth xs:gDay xs:boolean xs:base64Binary xs:hexBinary xs:anyURI xs:QName xs:NOTATION xs:dateTime xs:dateTimeStamp xs:date xs:string xs:normalizedString xs:token xs:language xs:NMTOKEN xs:Name xs:NCName xs:ID xs:IDREF xs:ENTITY xs:integer xs:nonPositiveInteger xs:negativeInteger xs:long xs:int xs:short xs:byte xs:nonNegativeInteger xs:unisignedLong xs:unsignedInt xs:unsignedShort xs:unsignedByte xs:positiveInteger xs:yearMonthDuration xs:dayTimeDuration";
    var LITERAL = "eq ne lt le gt ge is self:: child:: descendant:: descendant-or-self:: attribute:: following:: following-sibling:: parent:: ancestor:: ancestor-or-self:: preceding:: preceding-sibling:: NaN";
    // functions (TODO: find regex for op: without breaking build)
    var BUILT_IN = {
        className: "built_in",
        variants: [
            {
                begin: /\barray\:/,
                end: /(?:append|filter|flatten|fold\-(?:left|right)|for-each(?:\-pair)?|get|head|insert\-before|join|put|remove|reverse|size|sort|subarray|tail)\b/
            },
            {
                begin: /\bmap\:/,
                end: /(?:contains|entry|find|for\-each|get|keys|merge|put|remove|size)\b/
            },
            {
                begin: /\bmath\:/,
                end: /(?:a(?:cos|sin|tan[2]?)|cos|exp(?:10)?|log(?:10)?|pi|pow|sin|sqrt|tan)\b/
            },
            {
                begin: /\bop\:/,
                end: /\(/,
                excludeEnd: true
            },
            {
                begin: /\bfn\:/,
                end: /\(/,
                excludeEnd: true
            },
            // do not highlight inbuilt strings as variable or xml element names
            {
                begin: /[^<\/\$\:'"-]\b(?:abs|accumulator\-(?:after|before)|adjust\-(?:date(?:Time)?|time)\-to\-timezone|analyze\-string|apply|available\-(?:environment\-variables|system\-properties)|avg|base\-uri|boolean|ceiling|codepoints?\-(?:equal|to\-string)|collation\-key|collection|compare|concat|contains(?:\-token)?|copy\-of|count|current(?:\-)?(?:date(?:Time)?|time|group(?:ing\-key)?|output\-uri|merge\-(?:group|key))?data|dateTime|days?\-from\-(?:date(?:Time)?|duration)|deep\-equal|default\-(?:collation|language)|distinct\-values|document(?:\-uri)?|doc(?:\-available)?|element\-(?:available|with\-id)|empty|encode\-for\-uri|ends\-with|environment\-variable|error|escape\-html\-uri|exactly\-one|exists|false|filter|floor|fold\-(?:left|right)|for\-each(?:\-pair)?|format\-(?:date(?:Time)?|time|integer|number)|function\-(?:arity|available|lookup|name)|generate\-id|has\-children|head|hours\-from\-(?:dateTime|duration|time)|id(?:ref)?|implicit\-timezone|in\-scope\-prefixes|index\-of|innermost|insert\-before|iri\-to\-uri|json\-(?:doc|to\-xml)|key|lang|last|load\-xquery\-module|local\-name(?:\-from\-QName)?|(?:lower|upper)\-case|matches|max|minutes\-from\-(?:dateTime|duration|time)|min|months?\-from\-(?:date(?:Time)?|duration)|name(?:space\-uri\-?(?:for\-prefix|from\-QName)?)?|nilled|node\-name|normalize\-(?:space|unicode)|not|number|one\-or\-more|outermost|parse\-(?:ietf\-date|json)|path|position|(?:prefix\-from\-)?QName|random\-number\-generator|regex\-group|remove|replace|resolve\-(?:QName|uri)|reverse|root|round(?:\-half\-to\-even)?|seconds\-from\-(?:dateTime|duration|time)|snapshot|sort|starts\-with|static\-base\-uri|stream\-available|string\-?(?:join|length|to\-codepoints)?|subsequence|substring\-?(?:after|before)?|sum|system\-property|tail|timezone\-from\-(?:date(?:Time)?|time)|tokenize|trace|trans(?:form|late)|true|type\-available|unordered|unparsed\-(?:entity|text)?\-?(?:public\-id|uri|available|lines)?|uri\-collection|xml\-to\-json|years?\-from\-(?:date(?:Time)?|duration)|zero\-or\-one)\b/
            },
            {
                begin: /\blocal\:/,
                end: /\(/,
                excludeEnd: true
            },
            {
                begin: /\bzip\:/,
                end: /(?:zip\-file|(?:xml|html|text|binary)\-entry| (?:update\-)?entries)\b/
            },
            {
                begin: /\b(?:util|db|functx|app|xdmp|xmldb)\:/,
                end: /\(/,
                excludeEnd: true
            }
        ]
    };
    var TITLE = {
        className: "title",
        begin: /\bxquery version "[13]\.[01]"\s?(?:encoding ".+")?/,
        end: /;/
    };
    var VAR = {
        className: "variable",
        begin: /[\$][\w-:]+/
    };
    var NUMBER = {
        className: "number",
        begin: "(\\b0[0-7_]+)|(\\b0x[0-9a-fA-F_]+)|(\\b[1-9][0-9_]*(\\.[0-9_]+)?)|[0_]\\b",
        relevance: 0
    };
    var STRING = {
        className: "string",
        variants: [
            {
                begin: /"/,
                end: /"/,
                contains: [
                    {
                        begin: /""/,
                        relevance: 0
                    }
                ]
            },
            {
                begin: /'/,
                end: /'/,
                contains: [
                    {
                        begin: /''/,
                        relevance: 0
                    }
                ]
            }
        ]
    };
    var ANNOTATION = {
        className: "meta",
        begin: /%[\w-:]+/
    };
    var COMMENT = {
        className: "comment",
        begin: "\\(:",
        end: ":\\)",
        relevance: 10,
        contains: [
            {
                className: "doctag",
                begin: "@\\w+"
            }
        ]
    };
    // see https://www.w3.org/TR/xquery/#id-computedConstructors
    // mocha: computed_inbuilt
    // see https://www.regexpal.com/?fam=99749
    var COMPUTED = {
        beginKeywords: "element attribute comment document processing-instruction",
        end: "{",
        excludeEnd: true
    };
    // mocha: direct_method
    var DIRECT = {
        begin: /<([\w\._:\-]+)((\s*.*)=('|").*('|"))?>/,
        end: /(\/[\w\._:\-]+>)/,
        subLanguage: "xml",
        contains: [
            {
                begin: "{",
                end: "}",
                subLanguage: "xquery"
            },
            "self"
        ]
    };
    var CONTAINS = [
        VAR,
        BUILT_IN,
        STRING,
        NUMBER,
        COMMENT,
        ANNOTATION,
        TITLE,
        COMPUTED,
        DIRECT
    ];
    var METHOD = {
        begin: "{",
        end: "}",
        contains: CONTAINS
    };
    return {
        aliases: [
            "xpath",
            "xq"
        ],
        case_insensitive: false,
        lexemes: /[a-zA-Z\$][a-zA-Z0-9_:\-]*/,
        illegal: /(proc)|(abstract)|(extends)|(until)|(#)/,
        keywords: {
            keyword: KEYWORDS,
            type: TYPE,
            literal: LITERAL
        },
        contains: CONTAINS
    };
};

});

parcelRegister("2c2Kl", function(module, exports) {
module.exports = function(hljs) {
    var STRING = {
        className: "string",
        contains: [
            hljs.BACKSLASH_ESCAPE
        ],
        variants: [
            {
                begin: 'b"',
                end: '"'
            },
            {
                begin: "b'",
                end: "'"
            },
            hljs.inherit(hljs.APOS_STRING_MODE, {
                illegal: null
            }),
            hljs.inherit(hljs.QUOTE_STRING_MODE, {
                illegal: null
            })
        ]
    };
    var NUMBER = {
        variants: [
            hljs.BINARY_NUMBER_MODE,
            hljs.C_NUMBER_MODE
        ]
    };
    return {
        aliases: [
            "zep"
        ],
        case_insensitive: true,
        keywords: "and include_once list abstract global private echo interface as static endswitch array null if endwhile or const for endforeach self var let while isset public protected exit foreach throw elseif include __FILE__ empty require_once do xor return parent clone use __CLASS__ __LINE__ else break print eval new catch __METHOD__ case exception default die require __FUNCTION__ enddeclare final try switch continue endfor endif declare unset true false trait goto instanceof insteadof __DIR__ __NAMESPACE__ yield finally int uint long ulong char uchar double float bool boolean stringlikely unlikely",
        contains: [
            hljs.C_LINE_COMMENT_MODE,
            hljs.HASH_COMMENT_MODE,
            hljs.COMMENT("/\\*", "\\*/", {
                contains: [
                    {
                        className: "doctag",
                        begin: "@[A-Za-z]+"
                    }
                ]
            }),
            hljs.COMMENT("__halt_compiler.+?;", false, {
                endsWithParent: true,
                keywords: "__halt_compiler",
                lexemes: hljs.UNDERSCORE_IDENT_RE
            }),
            {
                className: "string",
                begin: "<<<['\"]?\\w+['\"]?$",
                end: "^\\w+;",
                contains: [
                    hljs.BACKSLASH_ESCAPE
                ]
            },
            {
                // swallow composed identifiers to avoid parsing them as keywords
                begin: /(::|->)+[a-zA-Z_\x7f-\xff][a-zA-Z0-9_\x7f-\xff]*/
            },
            {
                className: "function",
                beginKeywords: "function",
                end: /[;{]/,
                excludeEnd: true,
                illegal: "\\$|\\[|%",
                contains: [
                    hljs.UNDERSCORE_TITLE_MODE,
                    {
                        className: "params",
                        begin: "\\(",
                        end: "\\)",
                        contains: [
                            "self",
                            hljs.C_BLOCK_COMMENT_MODE,
                            STRING,
                            NUMBER
                        ]
                    }
                ]
            },
            {
                className: "class",
                beginKeywords: "class interface",
                end: "{",
                excludeEnd: true,
                illegal: /[:\(\$"]/,
                contains: [
                    {
                        beginKeywords: "extends implements"
                    },
                    hljs.UNDERSCORE_TITLE_MODE
                ]
            },
            {
                beginKeywords: "namespace",
                end: ";",
                illegal: /[\.']/,
                contains: [
                    hljs.UNDERSCORE_TITLE_MODE
                ]
            },
            {
                beginKeywords: "use",
                end: ";",
                contains: [
                    hljs.UNDERSCORE_TITLE_MODE
                ]
            },
            {
                begin: "=>" // No markup, just a relevance booster
            },
            STRING,
            NUMBER
        ]
    };
};

});


parcelRegister("31dJ8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $e7TKI = parcelRequire("e7TKI");

var $01sTD = parcelRequire("01sTD");

var $gLWqF = parcelRequire("gLWqF");

var $d4M6f = parcelRequire("d4M6f");
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $232c1cf85919176b$var$_a;
var $232c1cf85919176b$var$ERRORS = ($232c1cf85919176b$var$_a = {}, $232c1cf85919176b$var$_a["no-app" /* NO_APP */ ] = "No Firebase App '{$appName}' has been created - call Firebase App.initializeApp()", $232c1cf85919176b$var$_a["bad-app-name" /* BAD_APP_NAME */ ] = "Illegal App name: '{$appName}", $232c1cf85919176b$var$_a["duplicate-app" /* DUPLICATE_APP */ ] = "Firebase App named '{$appName}' already exists", $232c1cf85919176b$var$_a["app-deleted" /* APP_DELETED */ ] = "Firebase App named '{$appName}' already deleted", $232c1cf85919176b$var$_a["invalid-app-argument" /* INVALID_APP_ARGUMENT */ ] = "firebase.{$appName}() takes either no argument or a Firebase App instance.", $232c1cf85919176b$var$_a["invalid-log-argument" /* INVALID_LOG_ARGUMENT */ ] = "First argument to `onLog` must be null or a function.", $232c1cf85919176b$var$_a);
var $232c1cf85919176b$var$ERROR_FACTORY = new $01sTD.ErrorFactory("app", "Firebase", $232c1cf85919176b$var$ERRORS);
var $232c1cf85919176b$var$name$1 = "@firebase/app";
var $232c1cf85919176b$var$version = "0.6.11";
var $232c1cf85919176b$var$name$2 = "@firebase/analytics";
var $232c1cf85919176b$var$name$3 = "@firebase/auth";
var $232c1cf85919176b$var$name$4 = "@firebase/database";
var $232c1cf85919176b$var$name$5 = "@firebase/functions";
var $232c1cf85919176b$var$name$6 = "@firebase/installations";
var $232c1cf85919176b$var$name$7 = "@firebase/messaging";
var $232c1cf85919176b$var$name$8 = "@firebase/performance";
var $232c1cf85919176b$var$name$9 = "@firebase/remote-config";
var $232c1cf85919176b$var$name$a = "@firebase/storage";
var $232c1cf85919176b$var$name$b = "@firebase/firestore";
var $232c1cf85919176b$var$name$c = "firebase-wrapper";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $232c1cf85919176b$var$_a$1;
var $232c1cf85919176b$var$DEFAULT_ENTRY_NAME = "[DEFAULT]";
var $232c1cf85919176b$var$PLATFORM_LOG_STRING = ($232c1cf85919176b$var$_a$1 = {}, $232c1cf85919176b$var$_a$1[$232c1cf85919176b$var$name$1] = "fire-core", $232c1cf85919176b$var$_a$1[$232c1cf85919176b$var$name$2] = "fire-analytics", $232c1cf85919176b$var$_a$1[$232c1cf85919176b$var$name$3] = "fire-auth", $232c1cf85919176b$var$_a$1[$232c1cf85919176b$var$name$4] = "fire-rtdb", $232c1cf85919176b$var$_a$1[$232c1cf85919176b$var$name$5] = "fire-fn", $232c1cf85919176b$var$_a$1[$232c1cf85919176b$var$name$6] = "fire-iid", $232c1cf85919176b$var$_a$1[$232c1cf85919176b$var$name$7] = "fire-fcm", $232c1cf85919176b$var$_a$1[$232c1cf85919176b$var$name$8] = "fire-perf", $232c1cf85919176b$var$_a$1[$232c1cf85919176b$var$name$9] = "fire-rc", $232c1cf85919176b$var$_a$1[$232c1cf85919176b$var$name$a] = "fire-gcs", $232c1cf85919176b$var$_a$1[$232c1cf85919176b$var$name$b] = "fire-fst", $232c1cf85919176b$var$_a$1["fire-js"] = "fire-js", $232c1cf85919176b$var$_a$1[$232c1cf85919176b$var$name$c] = "fire-js-all", $232c1cf85919176b$var$_a$1);
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $232c1cf85919176b$var$logger = new $d4M6f.Logger("@firebase/app");
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Global context object for a collection of services using
 * a shared authentication state.
 */ var $232c1cf85919176b$var$FirebaseAppImpl = /** @class */ function() {
    function FirebaseAppImpl(options, config, firebase_) {
        var e_1, _a;
        var _this = this;
        this.firebase_ = firebase_;
        this.isDeleted_ = false;
        this.name_ = config.name;
        this.automaticDataCollectionEnabled_ = config.automaticDataCollectionEnabled || false;
        this.options_ = $01sTD.deepCopy(options);
        this.container = new $gLWqF.ComponentContainer(config.name);
        // add itself to container
        this._addComponent(new $gLWqF.Component("app", function() {
            return _this;
        }, "PUBLIC" /* PUBLIC */ ));
        try {
            // populate ComponentContainer with existing components
            for(var _b = $e7TKI.__values(this.firebase_.INTERNAL.components.values()), _c = _b.next(); !_c.done; _c = _b.next()){
                var component$1 = _c.value;
                this._addComponent(component$1);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
    }
    Object.defineProperty(FirebaseAppImpl.prototype, "automaticDataCollectionEnabled", {
        get: function() {
            this.checkDestroyed_();
            return this.automaticDataCollectionEnabled_;
        },
        set: function(val) {
            this.checkDestroyed_();
            this.automaticDataCollectionEnabled_ = val;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FirebaseAppImpl.prototype, "name", {
        get: function() {
            this.checkDestroyed_();
            return this.name_;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FirebaseAppImpl.prototype, "options", {
        get: function() {
            this.checkDestroyed_();
            return this.options_;
        },
        enumerable: false,
        configurable: true
    });
    FirebaseAppImpl.prototype.delete = function() {
        var _this = this;
        return new Promise(function(resolve) {
            _this.checkDestroyed_();
            resolve();
        }).then(function() {
            _this.firebase_.INTERNAL.removeApp(_this.name_);
            return Promise.all(_this.container.getProviders().map(function(provider) {
                return provider.delete();
            }));
        }).then(function() {
            _this.isDeleted_ = true;
        });
    };
    /**
     * Return a service instance associated with this app (creating it
     * on demand), identified by the passed instanceIdentifier.
     *
     * NOTE: Currently storage and functions are the only ones that are leveraging this
     * functionality. They invoke it by calling:
     *
     * ```javascript
     * firebase.app().storage('STORAGE BUCKET ID')
     * ```
     *
     * The service name is passed to this already
     * @internal
     */ FirebaseAppImpl.prototype._getService = function(name1, instanceIdentifier) {
        if (instanceIdentifier === void 0) instanceIdentifier = $232c1cf85919176b$var$DEFAULT_ENTRY_NAME;
        this.checkDestroyed_();
        // getImmediate will always succeed because _getService is only called for registered components.
        return this.container.getProvider(name1).getImmediate({
            identifier: instanceIdentifier
        });
    };
    /**
     * Remove a service instance from the cache, so we will create a new instance for this service
     * when people try to get this service again.
     *
     * NOTE: currently only firestore is using this functionality to support firestore shutdown.
     *
     * @param name The service name
     * @param instanceIdentifier instance identifier in case multiple instances are allowed
     * @internal
     */ FirebaseAppImpl.prototype._removeServiceInstance = function(name1, instanceIdentifier) {
        if (instanceIdentifier === void 0) instanceIdentifier = $232c1cf85919176b$var$DEFAULT_ENTRY_NAME;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.container.getProvider(name1).clearInstance(instanceIdentifier);
    };
    /**
     * @param component the component being added to this app's container
     */ FirebaseAppImpl.prototype._addComponent = function(component) {
        try {
            this.container.addComponent(component);
        } catch (e) {
            $232c1cf85919176b$var$logger.debug("Component " + component.name + " failed to register with FirebaseApp " + this.name, e);
        }
    };
    FirebaseAppImpl.prototype._addOrOverwriteComponent = function(component) {
        this.container.addOrOverwriteComponent(component);
    };
    /**
     * This function will throw an Error if the App has already been deleted -
     * use before performing API actions on the App.
     */ FirebaseAppImpl.prototype.checkDestroyed_ = function() {
        if (this.isDeleted_) throw $232c1cf85919176b$var$ERROR_FACTORY.create("app-deleted" /* APP_DELETED */ , {
            appName: this.name_
        });
    };
    return FirebaseAppImpl;
}();
// Prevent dead-code elimination of these methods w/o invalid property
// copying.
$232c1cf85919176b$var$FirebaseAppImpl.prototype.name && $232c1cf85919176b$var$FirebaseAppImpl.prototype.options || $232c1cf85919176b$var$FirebaseAppImpl.prototype.delete || console.log("dc");
var $232c1cf85919176b$var$version$1 = "7.20.0";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Because auth can't share code with other components, we attach the utility functions
 * in an internal namespace to share code.
 * This function return a firebase namespace object without
 * any utility functions, so it can be shared between the regular firebaseNamespace and
 * the lite version.
 */ function $232c1cf85919176b$var$createFirebaseNamespaceCore(firebaseAppImpl) {
    var apps = {};
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var components = new Map();
    // A namespace is a plain JavaScript Object.
    var namespace = {
        // Hack to prevent Babel from modifying the object returned
        // as the firebase namespace.
        // @ts-ignore
        __esModule: true,
        initializeApp: initializeApp,
        // @ts-ignore
        app: app,
        registerVersion: registerVersion,
        setLogLevel: $d4M6f.setLogLevel,
        onLog: onLog,
        // @ts-ignore
        apps: null,
        SDK_VERSION: $232c1cf85919176b$var$version$1,
        INTERNAL: {
            registerComponent: registerComponent,
            removeApp: removeApp,
            components: components,
            useAsService: useAsService
        }
    };
    // Inject a circular default export to allow Babel users who were previously
    // using:
    //
    //   import firebase from 'firebase';
    //   which becomes: var firebase = require('firebase').default;
    //
    // instead of
    //
    //   import * as firebase from 'firebase';
    //   which becomes: var firebase = require('firebase');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    namespace["default"] = namespace;
    // firebase.apps is a read-only getter.
    Object.defineProperty(namespace, "apps", {
        get: getApps
    });
    /**
     * Called by App.delete() - but before any services associated with the App
     * are deleted.
     */ function removeApp(name1) {
        delete apps[name1];
    }
    /**
     * Get the App object for a given name (or DEFAULT).
     */ function app(name1) {
        name1 = name1 || $232c1cf85919176b$var$DEFAULT_ENTRY_NAME;
        if (!$01sTD.contains(apps, name1)) throw $232c1cf85919176b$var$ERROR_FACTORY.create("no-app" /* NO_APP */ , {
            appName: name1
        });
        return apps[name1];
    }
    // @ts-ignore
    app["App"] = firebaseAppImpl;
    function initializeApp(options, rawConfig) {
        if (rawConfig === void 0) rawConfig = {};
        if (typeof rawConfig !== "object" || rawConfig === null) {
            var name_1 = rawConfig;
            rawConfig = {
                name: name_1
            };
        }
        var config = rawConfig;
        if (config.name === undefined) config.name = $232c1cf85919176b$var$DEFAULT_ENTRY_NAME;
        var name1 = config.name;
        if (typeof name1 !== "string" || !name1) throw $232c1cf85919176b$var$ERROR_FACTORY.create("bad-app-name" /* BAD_APP_NAME */ , {
            appName: String(name1)
        });
        if ($01sTD.contains(apps, name1)) throw $232c1cf85919176b$var$ERROR_FACTORY.create("duplicate-app" /* DUPLICATE_APP */ , {
            appName: name1
        });
        var app = new firebaseAppImpl(options, config, namespace);
        apps[name1] = app;
        return app;
    }
    /*
     * Return an array of all the non-deleted FirebaseApps.
     */ function getApps() {
        // Make a copy so caller cannot mutate the apps list.
        return Object.keys(apps).map(function(name1) {
            return apps[name1];
        });
    }
    function registerComponent(component) {
        var e_1, _a;
        var componentName = component.name;
        if (components.has(componentName)) {
            $232c1cf85919176b$var$logger.debug("There were multiple attempts to register component " + componentName + ".");
            return component.type === "PUBLIC" /* PUBLIC */  ? namespace[componentName] : null;
        }
        components.set(componentName, component);
        // create service namespace for public components
        if (component.type === "PUBLIC" /* PUBLIC */ ) {
            // The Service namespace is an accessor function ...
            var serviceNamespace = function(appArg) {
                if (appArg === void 0) appArg = app();
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                if (typeof appArg[componentName] !== "function") // Invalid argument.
                // This happens in the following case: firebase.storage('gs:/')
                throw $232c1cf85919176b$var$ERROR_FACTORY.create("invalid-app-argument" /* INVALID_APP_ARGUMENT */ , {
                    appName: componentName
                });
                // Forward service instance lookup to the FirebaseApp.
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                return appArg[componentName]();
            };
            // ... and a container for service-level properties.
            if (component.serviceProps !== undefined) $01sTD.deepExtend(serviceNamespace, component.serviceProps);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            namespace[componentName] = serviceNamespace;
            // Patch the FirebaseAppImpl prototype
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            firebaseAppImpl.prototype[componentName] = // TODO: The eslint disable can be removed and the 'ignoreRestArgs'
            // option added to the no-explicit-any rule when ESlint releases it.
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            function() {
                var args = [];
                for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                var serviceFxn = this._getService.bind(this, componentName);
                return serviceFxn.apply(this, component.multipleInstances ? args : []);
            };
        }
        try {
            // add the component to existing app instances
            for(var _b = $e7TKI.__values(Object.keys(apps)), _c = _b.next(); !_c.done; _c = _b.next()){
                var appName = _c.value;
                apps[appName]._addComponent(component);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return component.type === "PUBLIC" /* PUBLIC */  ? namespace[componentName] : null;
    }
    function registerVersion(libraryKeyOrName, version, variant) {
        var _a;
        // TODO: We can use this check to whitelist strings when/if we set up
        // a good whitelist system.
        var library = (_a = $232c1cf85919176b$var$PLATFORM_LOG_STRING[libraryKeyOrName]) !== null && _a !== void 0 ? _a : libraryKeyOrName;
        if (variant) library += "-" + variant;
        var libraryMismatch = library.match(/\s|\//);
        var versionMismatch = version.match(/\s|\//);
        if (libraryMismatch || versionMismatch) {
            var warning = [
                'Unable to register library "' + library + '" with version "' + version + '":'
            ];
            if (libraryMismatch) warning.push('library name "' + library + '" contains illegal characters (whitespace or "/")');
            if (libraryMismatch && versionMismatch) warning.push("and");
            if (versionMismatch) warning.push('version name "' + version + '" contains illegal characters (whitespace or "/")');
            $232c1cf85919176b$var$logger.warn(warning.join(" "));
            return;
        }
        registerComponent(new $gLWqF.Component(library + "-version", function() {
            return {
                library: library,
                version: version
            };
        }, "VERSION" /* VERSION */ ));
    }
    function onLog(logCallback, options) {
        if (logCallback !== null && typeof logCallback !== "function") throw $232c1cf85919176b$var$ERROR_FACTORY.create("invalid-log-argument" /* INVALID_LOG_ARGUMENT */ , {
            appName: name
        });
        $d4M6f.setUserLogHandler(logCallback, options);
    }
    // Map the requested service to a registered service name
    // (used to map auth to serverAuth service when needed).
    function useAsService(app, name1) {
        if (name1 === "serverAuth") return null;
        var useService = name1;
        return useService;
    }
    return namespace;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Return a firebase namespace object.
 *
 * In production, this will be called exactly once and the result
 * assigned to the 'firebase' global.  It may be called multiple times
 * in unit tests.
 */ function $232c1cf85919176b$var$createFirebaseNamespace() {
    var namespace = $232c1cf85919176b$var$createFirebaseNamespaceCore($232c1cf85919176b$var$FirebaseAppImpl);
    namespace.INTERNAL = $e7TKI.__assign($e7TKI.__assign({}, namespace.INTERNAL), {
        createFirebaseNamespace: $232c1cf85919176b$var$createFirebaseNamespace,
        extendNamespace: extendNamespace,
        createSubscribe: $01sTD.createSubscribe,
        ErrorFactory: $01sTD.ErrorFactory,
        deepExtend: $01sTD.deepExtend
    });
    /**
     * Patch the top-level firebase namespace with additional properties.
     *
     * firebase.INTERNAL.extendNamespace()
     */ function extendNamespace(props) {
        $01sTD.deepExtend(namespace, props);
    }
    return namespace;
}
var $232c1cf85919176b$var$firebase = $232c1cf85919176b$var$createFirebaseNamespace();
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $232c1cf85919176b$var$PlatformLoggerService = /** @class */ function() {
    function PlatformLoggerService(container) {
        this.container = container;
    }
    // In initial implementation, this will be called by installations on
    // auth token refresh, and installations will send this string.
    PlatformLoggerService.prototype.getPlatformInfoString = function() {
        var providers = this.container.getProviders();
        // Loop through providers and get library/version pairs from any that are
        // version components.
        return providers.map(function(provider) {
            if ($232c1cf85919176b$var$isVersionServiceProvider(provider)) {
                var service = provider.getImmediate();
                return service.library + "/" + service.version;
            } else return null;
        }).filter(function(logString) {
            return logString;
        }).join(" ");
    };
    return PlatformLoggerService;
}();
/**
 *
 * @param provider check if this provider provides a VersionService
 *
 * NOTE: Using Provider<'app-version'> is a hack to indicate that the provider
 * provides VersionService. The provider is not necessarily a 'app-version'
 * provider.
 */ function $232c1cf85919176b$var$isVersionServiceProvider(provider) {
    var component = provider.getComponent();
    return (component === null || component === void 0 ? void 0 : component.type) === "VERSION" /* VERSION */ ;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $232c1cf85919176b$var$registerCoreComponents(firebase, variant) {
    firebase.INTERNAL.registerComponent(new $gLWqF.Component("platform-logger", function(container) {
        return new $232c1cf85919176b$var$PlatformLoggerService(container);
    }, "PRIVATE" /* PRIVATE */ ));
    // Register `app` package.
    firebase.registerVersion($232c1cf85919176b$var$name$1, $232c1cf85919176b$var$version, variant);
    // Register platform SDK identifier (no version).
    firebase.registerVersion("fire-js", "");
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Firebase Lite detection test
// eslint-disable-next-line @typescript-eslint/no-explicit-any
if ($01sTD.isBrowser() && self.firebase !== undefined) {
    $232c1cf85919176b$var$logger.warn("\n    Warning: Firebase is already defined in the global scope. Please make sure\n    Firebase library is only loaded once.\n  ");
    // eslint-disable-next-line
    var $232c1cf85919176b$var$sdkVersion = self.firebase.SDK_VERSION;
    if ($232c1cf85919176b$var$sdkVersion && $232c1cf85919176b$var$sdkVersion.indexOf("LITE") >= 0) $232c1cf85919176b$var$logger.warn("\n    Warning: You are trying to load Firebase while using Firebase Performance standalone script.\n    You should load Firebase Performance with this instance of Firebase to avoid loading duplicate code.\n    ");
}
var $232c1cf85919176b$var$initializeApp = $232c1cf85919176b$var$firebase.initializeApp;
// TODO: This disable can be removed and the 'ignoreRestArgs' option added to
// the no-explicit-any rule when ESlint releases it.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
$232c1cf85919176b$var$firebase.initializeApp = function() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    // Environment check before initializing app
    // Do the check in initializeApp, so people have a chance to disable it by setting logLevel
    // in @firebase/logger
    if ($01sTD.isNode()) $232c1cf85919176b$var$logger.warn('\n      Warning: This is a browser-targeted Firebase bundle but it appears it is being\n      run in a Node environment.  If running in a Node environment, make sure you\n      are using the bundle specified by the "main" field in package.json.\n      \n      If you are using Webpack, you can specify "main" as the first item in\n      "resolve.mainFields":\n      https://webpack.js.org/configuration/resolve/#resolvemainfields\n      \n      If using Rollup, use the rollup-plugin-node-resolve plugin and specify "main"\n      as the first item in "mainFields", e.g. [\'main\', \'module\'].\n      https://github.com/rollup/rollup-plugin-node-resolve\n      ');
    return $232c1cf85919176b$var$initializeApp.apply(undefined, args);
};
var $232c1cf85919176b$var$firebase$1 = $232c1cf85919176b$var$firebase;
$232c1cf85919176b$var$registerCoreComponents($232c1cf85919176b$var$firebase$1);
module.exports.default = $232c1cf85919176b$var$firebase$1;
module.exports.firebase = $232c1cf85919176b$var$firebase$1;

});
parcelRegister("e7TKI", function(module, exports) {

$parcel$export(module.exports, "__assign", () => $a48cf7678b5fd9a4$export$18ce0697a983be9b);
$parcel$export(module.exports, "__values", () => $a48cf7678b5fd9a4$export$19a8beecd37a4c45);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $a48cf7678b5fd9a4$var$extendStatics = function(d, b) {
    $a48cf7678b5fd9a4$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $a48cf7678b5fd9a4$var$extendStatics(d, b);
};
function $a48cf7678b5fd9a4$export$a8ba968b8961cb8a(d, b) {
    $a48cf7678b5fd9a4$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $a48cf7678b5fd9a4$export$18ce0697a983be9b = function() {
    $a48cf7678b5fd9a4$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $a48cf7678b5fd9a4$export$18ce0697a983be9b.apply(this, arguments);
};
function $a48cf7678b5fd9a4$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $a48cf7678b5fd9a4$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $a48cf7678b5fd9a4$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $a48cf7678b5fd9a4$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $a48cf7678b5fd9a4$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $a48cf7678b5fd9a4$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $a48cf7678b5fd9a4$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $a48cf7678b5fd9a4$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $a48cf7678b5fd9a4$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $a48cf7678b5fd9a4$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $a48cf7678b5fd9a4$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($a48cf7678b5fd9a4$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $a48cf7678b5fd9a4$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $a48cf7678b5fd9a4$export$10c90e4f7922046c(v) {
    return this instanceof $a48cf7678b5fd9a4$export$10c90e4f7922046c ? (this.v = v, this) : new $a48cf7678b5fd9a4$export$10c90e4f7922046c(v);
}
function $a48cf7678b5fd9a4$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $a48cf7678b5fd9a4$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $a48cf7678b5fd9a4$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $a48cf7678b5fd9a4$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $a48cf7678b5fd9a4$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $a48cf7678b5fd9a4$export$19a8beecd37a4c45 === "function" ? $a48cf7678b5fd9a4$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $a48cf7678b5fd9a4$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $a48cf7678b5fd9a4$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $a48cf7678b5fd9a4$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $a48cf7678b5fd9a4$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $a48cf7678b5fd9a4$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

});

parcelRegister("01sTD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $hAtcO = parcelRequire("hAtcO");
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Firebase constants.  Some of these (@defines) can be overridden at compile-time.
 */ var $0046824dfaec0dac$var$CONSTANTS = {
    /**
     * @define {boolean} Whether this is the client Node.js SDK.
     */ NODE_CLIENT: false,
    /**
     * @define {boolean} Whether this is the Admin Node.js SDK.
     */ NODE_ADMIN: false,
    /**
     * Firebase SDK Version
     */ SDK_VERSION: "${JSCORE_VERSION}"
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Throws an error if the provided assertion is falsy
 */ var $0046824dfaec0dac$var$assert = function(assertion, message) {
    if (!assertion) throw $0046824dfaec0dac$var$assertionError(message);
};
/**
 * Returns an Error object suitable for throwing.
 */ var $0046824dfaec0dac$var$assertionError = function(message) {
    return new Error("Firebase Database (" + $0046824dfaec0dac$var$CONSTANTS.SDK_VERSION + ") INTERNAL ASSERT FAILED: " + message);
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $0046824dfaec0dac$var$stringToByteArray = function(str) {
    // TODO(user): Use native implementations if/when available
    var out = [];
    var p = 0;
    for(var i = 0; i < str.length; i++){
        var c = str.charCodeAt(i);
        if (c < 128) out[p++] = c;
        else if (c < 2048) {
            out[p++] = c >> 6 | 192;
            out[p++] = c & 63 | 128;
        } else if ((c & 0xfc00) === 0xd800 && i + 1 < str.length && (str.charCodeAt(i + 1) & 0xfc00) === 0xdc00) {
            // Surrogate Pair
            c = 0x10000 + ((c & 0x03ff) << 10) + (str.charCodeAt(++i) & 0x03ff);
            out[p++] = c >> 18 | 240;
            out[p++] = c >> 12 & 63 | 128;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        } else {
            out[p++] = c >> 12 | 224;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        }
    }
    return out;
};
/**
 * Turns an array of numbers into the string given by the concatenation of the
 * characters to which the numbers correspond.
 * @param bytes Array of numbers representing characters.
 * @return Stringification of the array.
 */ var $0046824dfaec0dac$var$byteArrayToString = function(bytes) {
    // TODO(user): Use native implementations if/when available
    var out = [];
    var pos = 0, c = 0;
    while(pos < bytes.length){
        var c1 = bytes[pos++];
        if (c1 < 128) out[c++] = String.fromCharCode(c1);
        else if (c1 > 191 && c1 < 224) {
            var c2 = bytes[pos++];
            out[c++] = String.fromCharCode((c1 & 31) << 6 | c2 & 63);
        } else if (c1 > 239 && c1 < 365) {
            // Surrogate Pair
            var c2 = bytes[pos++];
            var c3 = bytes[pos++];
            var c4 = bytes[pos++];
            var u = ((c1 & 7) << 18 | (c2 & 63) << 12 | (c3 & 63) << 6 | c4 & 63) - 0x10000;
            out[c++] = String.fromCharCode(0xd800 + (u >> 10));
            out[c++] = String.fromCharCode(0xdc00 + (u & 1023));
        } else {
            var c2 = bytes[pos++];
            var c3 = bytes[pos++];
            out[c++] = String.fromCharCode((c1 & 15) << 12 | (c2 & 63) << 6 | c3 & 63);
        }
    }
    return out.join("");
};
// We define it as an object literal instead of a class because a class compiled down to es5 can't
// be treeshaked. https://github.com/rollup/rollup/issues/1691
// Static lookup maps, lazily populated by init_()
var $0046824dfaec0dac$var$base64 = {
    /**
     * Maps bytes to characters.
     */ byteToCharMap_: null,
    /**
     * Maps characters to bytes.
     */ charToByteMap_: null,
    /**
     * Maps bytes to websafe characters.
     * @private
     */ byteToCharMapWebSafe_: null,
    /**
     * Maps websafe characters to bytes.
     * @private
     */ charToByteMapWebSafe_: null,
    /**
     * Our default alphabet, shared between
     * ENCODED_VALS and ENCODED_VALS_WEBSAFE
     */ ENCODED_VALS_BASE: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789",
    /**
     * Our default alphabet. Value 64 (=) is special; it means "nothing."
     */ get ENCODED_VALS () {
        return this.ENCODED_VALS_BASE + "+/=";
    },
    /**
     * Our websafe alphabet.
     */ get ENCODED_VALS_WEBSAFE () {
        return this.ENCODED_VALS_BASE + "-_.";
    },
    /**
     * Whether this browser supports the atob and btoa functions. This extension
     * started at Mozilla but is now implemented by many browsers. We use the
     * ASSUME_* variables to avoid pulling in the full useragent detection library
     * but still allowing the standard per-browser compilations.
     *
     */ HAS_NATIVE_SUPPORT: typeof atob === "function",
    /**
     * Base64-encode an array of bytes.
     *
     * @param input An array of bytes (numbers with
     *     value in [0, 255]) to encode.
     * @param webSafe Boolean indicating we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */ encodeByteArray: function(input, webSafe) {
        if (!Array.isArray(input)) throw Error("encodeByteArray takes an array as a parameter");
        this.init_();
        var byteToCharMap = webSafe ? this.byteToCharMapWebSafe_ : this.byteToCharMap_;
        var output = [];
        for(var i = 0; i < input.length; i += 3){
            var byte1 = input[i];
            var haveByte2 = i + 1 < input.length;
            var byte2 = haveByte2 ? input[i + 1] : 0;
            var haveByte3 = i + 2 < input.length;
            var byte3 = haveByte3 ? input[i + 2] : 0;
            var outByte1 = byte1 >> 2;
            var outByte2 = (byte1 & 0x03) << 4 | byte2 >> 4;
            var outByte3 = (byte2 & 0x0f) << 2 | byte3 >> 6;
            var outByte4 = byte3 & 0x3f;
            if (!haveByte3) {
                outByte4 = 64;
                if (!haveByte2) outByte3 = 64;
            }
            output.push(byteToCharMap[outByte1], byteToCharMap[outByte2], byteToCharMap[outByte3], byteToCharMap[outByte4]);
        }
        return output.join("");
    },
    /**
     * Base64-encode a string.
     *
     * @param input A string to encode.
     * @param webSafe If true, we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */ encodeString: function(input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) return btoa(input);
        return this.encodeByteArray($0046824dfaec0dac$var$stringToByteArray(input), webSafe);
    },
    /**
     * Base64-decode a string.
     *
     * @param input to decode.
     * @param webSafe True if we should use the
     *     alternative alphabet.
     * @return string representing the decoded value.
     */ decodeString: function(input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) return atob(input);
        return $0046824dfaec0dac$var$byteArrayToString(this.decodeStringToByteArray(input, webSafe));
    },
    /**
     * Base64-decode a string.
     *
     * In base-64 decoding, groups of four characters are converted into three
     * bytes.  If the encoder did not apply padding, the input length may not
     * be a multiple of 4.
     *
     * In this case, the last group will have fewer than 4 characters, and
     * padding will be inferred.  If the group has one or two characters, it decodes
     * to one byte.  If the group has three characters, it decodes to two bytes.
     *
     * @param input Input to decode.
     * @param webSafe True if we should use the web-safe alphabet.
     * @return bytes representing the decoded value.
     */ decodeStringToByteArray: function(input, webSafe) {
        this.init_();
        var charToByteMap = webSafe ? this.charToByteMapWebSafe_ : this.charToByteMap_;
        var output = [];
        for(var i = 0; i < input.length;){
            var byte1 = charToByteMap[input.charAt(i++)];
            var haveByte2 = i < input.length;
            var byte2 = haveByte2 ? charToByteMap[input.charAt(i)] : 0;
            ++i;
            var haveByte3 = i < input.length;
            var byte3 = haveByte3 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            var haveByte4 = i < input.length;
            var byte4 = haveByte4 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            if (byte1 == null || byte2 == null || byte3 == null || byte4 == null) throw Error();
            var outByte1 = byte1 << 2 | byte2 >> 4;
            output.push(outByte1);
            if (byte3 !== 64) {
                var outByte2 = byte2 << 4 & 0xf0 | byte3 >> 2;
                output.push(outByte2);
                if (byte4 !== 64) {
                    var outByte3 = byte3 << 6 & 0xc0 | byte4;
                    output.push(outByte3);
                }
            }
        }
        return output;
    },
    /**
     * Lazy static initialization function. Called before
     * accessing any of the static map variables.
     * @private
     */ init_: function() {
        if (!this.byteToCharMap_) {
            this.byteToCharMap_ = {};
            this.charToByteMap_ = {};
            this.byteToCharMapWebSafe_ = {};
            this.charToByteMapWebSafe_ = {};
            // We want quick mappings back and forth, so we precompute two maps.
            for(var i = 0; i < this.ENCODED_VALS.length; i++){
                this.byteToCharMap_[i] = this.ENCODED_VALS.charAt(i);
                this.charToByteMap_[this.byteToCharMap_[i]] = i;
                this.byteToCharMapWebSafe_[i] = this.ENCODED_VALS_WEBSAFE.charAt(i);
                this.charToByteMapWebSafe_[this.byteToCharMapWebSafe_[i]] = i;
                // Be forgiving when decoding and correctly decode both encodings.
                if (i >= this.ENCODED_VALS_BASE.length) {
                    this.charToByteMap_[this.ENCODED_VALS_WEBSAFE.charAt(i)] = i;
                    this.charToByteMapWebSafe_[this.ENCODED_VALS.charAt(i)] = i;
                }
            }
        }
    }
};
/**
 * URL-safe base64 encoding
 */ var $0046824dfaec0dac$var$base64Encode = function(str) {
    var utf8Bytes = $0046824dfaec0dac$var$stringToByteArray(str);
    return $0046824dfaec0dac$var$base64.encodeByteArray(utf8Bytes, true);
};
/**
 * URL-safe base64 decoding
 *
 * NOTE: DO NOT use the global atob() function - it does NOT support the
 * base64Url variant encoding.
 *
 * @param str To be decoded
 * @return Decoded result, if possible
 */ var $0046824dfaec0dac$var$base64Decode = function(str) {
    try {
        return $0046824dfaec0dac$var$base64.decodeString(str, true);
    } catch (e) {
        console.error("base64Decode failed: ", e);
    }
    return null;
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Do a deep-copy of basic JavaScript Objects or Arrays.
 */ function $0046824dfaec0dac$var$deepCopy(value) {
    return $0046824dfaec0dac$var$deepExtend(undefined, value);
}
/**
 * Copy properties from source to target (recursively allows extension
 * of Objects and Arrays).  Scalar values in the target are over-written.
 * If target is undefined, an object of the appropriate type will be created
 * (and returned).
 *
 * We recursively copy all child properties of plain Objects in the source- so
 * that namespace- like dictionaries are merged.
 *
 * Note that the target can be a function, in which case the properties in
 * the source Object are copied onto it as static properties of the Function.
 */ function $0046824dfaec0dac$var$deepExtend(target, source) {
    if (!(source instanceof Object)) return source;
    switch(source.constructor){
        case Date:
            // Treat Dates like scalars; if the target date object had any child
            // properties - they will be lost!
            var dateValue = source;
            return new Date(dateValue.getTime());
        case Object:
            if (target === undefined) target = {};
            break;
        case Array:
            // Always copy the array source and overwrite the target.
            target = [];
            break;
        default:
            // Not a plain Object - treat it as a scalar.
            return source;
    }
    for(var prop in source){
        if (!source.hasOwnProperty(prop)) continue;
        target[prop] = $0046824dfaec0dac$var$deepExtend(target[prop], source[prop]);
    }
    return target;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $0046824dfaec0dac$var$Deferred = /** @class */ function() {
    function Deferred() {
        var _this = this;
        this.reject = function() {};
        this.resolve = function() {};
        this.promise = new Promise(function(resolve, reject) {
            _this.resolve = resolve;
            _this.reject = reject;
        });
    }
    /**
     * Our API internals are not promiseified and cannot because our callback APIs have subtle expectations around
     * invoking promises inline, which Promises are forbidden to do. This method accepts an optional node-style callback
     * and returns a node-style callback which will resolve or reject the Deferred's promise.
     */ Deferred.prototype.wrapCallback = function(callback) {
        var _this = this;
        return function(error, value) {
            if (error) _this.reject(error);
            else _this.resolve(value);
            if (typeof callback === "function") {
                // Attaching noop handler just in case developer wasn't expecting
                // promises
                _this.promise.catch(function() {});
                // Some of our callbacks don't expect a value and our own tests
                // assert that the parameter length is 1
                if (callback.length === 1) callback(error);
                else callback(error, value);
            }
        };
    };
    return Deferred;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns navigator.userAgent string or '' if it's not defined.
 * @return user agent string
 */ function $0046824dfaec0dac$var$getUA() {
    if (typeof navigator !== "undefined" && typeof navigator["userAgent"] === "string") return navigator["userAgent"];
    else return "";
}
/**
 * Detect Cordova / PhoneGap / Ionic frameworks on a mobile device.
 *
 * Deliberately does not rely on checking `file://` URLs (as this fails PhoneGap
 * in the Ripple emulator) nor Cordova `onDeviceReady`, which would normally
 * wait for a callback.
 */ function $0046824dfaec0dac$var$isMobileCordova() {
    return typeof window !== "undefined" && // @ts-ignore Setting up an broadly applicable index signature for Window
    // just to deal with this case would probably be a bad idea.
    !!(window["cordova"] || window["phonegap"] || window["PhoneGap"]) && /ios|iphone|ipod|ipad|android|blackberry|iemobile/i.test($0046824dfaec0dac$var$getUA());
}
/**
 * Detect Node.js.
 *
 * @return true if Node.js environment is detected.
 */ // Node detection logic from: https://github.com/iliakan/detect-node/
function $0046824dfaec0dac$var$isNode() {
    try {
        return Object.prototype.toString.call($parcel$global.process) === "[object process]";
    } catch (e) {
        return false;
    }
}
/**
 * Detect Browser Environment
 */ function $0046824dfaec0dac$var$isBrowser() {
    return typeof self === "object" && self.self === self;
}
function $0046824dfaec0dac$var$isBrowserExtension() {
    var runtime = typeof chrome === "object" ? chrome.runtime : typeof browser === "object" ? browser.runtime : undefined;
    return typeof runtime === "object" && runtime.id !== undefined;
}
/**
 * Detect React Native.
 *
 * @return true if ReactNative environment is detected.
 */ function $0046824dfaec0dac$var$isReactNative() {
    return typeof navigator === "object" && navigator["product"] === "ReactNative";
}
/** Detects Electron apps. */ function $0046824dfaec0dac$var$isElectron() {
    return $0046824dfaec0dac$var$getUA().indexOf("Electron/") >= 0;
}
/** Detects Internet Explorer. */ function $0046824dfaec0dac$var$isIE() {
    var ua = $0046824dfaec0dac$var$getUA();
    return ua.indexOf("MSIE ") >= 0 || ua.indexOf("Trident/") >= 0;
}
/** Detects Universal Windows Platform apps. */ function $0046824dfaec0dac$var$isUWP() {
    return $0046824dfaec0dac$var$getUA().indexOf("MSAppHost/") >= 0;
}
/**
 * Detect whether the current SDK build is the Node version.
 *
 * @return true if it's the Node SDK build.
 */ function $0046824dfaec0dac$var$isNodeSdk() {
    return $0046824dfaec0dac$var$CONSTANTS.NODE_CLIENT === true || $0046824dfaec0dac$var$CONSTANTS.NODE_ADMIN === true;
}
/** Returns true if we are running in Safari. */ function $0046824dfaec0dac$var$isSafari() {
    return !$0046824dfaec0dac$var$isNode() && navigator.userAgent.includes("Safari") && !navigator.userAgent.includes("Chrome");
}
/**
 * This method checks if indexedDB is supported by current browser/service worker context
 * @return true if indexedDB is supported by current browser/service worker context
 */ function $0046824dfaec0dac$var$isIndexedDBAvailable() {
    return "indexedDB" in self && indexedDB != null;
}
/**
 * This method validates browser context for indexedDB by opening a dummy indexedDB database and reject
 * if errors occur during the database open operation.
 */ function $0046824dfaec0dac$var$validateIndexedDBOpenable() {
    return new Promise(function(resolve, reject) {
        try {
            var preExist_1 = true;
            var DB_CHECK_NAME_1 = "validate-browser-context-for-indexeddb-analytics-module";
            var request_1 = window.indexedDB.open(DB_CHECK_NAME_1);
            request_1.onsuccess = function() {
                request_1.result.close();
                // delete database only when it doesn't pre-exist
                if (!preExist_1) window.indexedDB.deleteDatabase(DB_CHECK_NAME_1);
                resolve(true);
            };
            request_1.onupgradeneeded = function() {
                preExist_1 = false;
            };
            request_1.onerror = function() {
                var _a;
                reject(((_a = request_1.error) === null || _a === void 0 ? void 0 : _a.message) || "");
            };
        } catch (error) {
            reject(error);
        }
    });
}
/**
 *
 * This method checks whether cookie is enabled within current browser
 * @return true if cookie is enabled within current browser
 */ function $0046824dfaec0dac$var$areCookiesEnabled() {
    if (!navigator || !navigator.cookieEnabled) return false;
    return true;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $0046824dfaec0dac$var$ERROR_NAME = "FirebaseError";
// Based on code from:
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Custom_Error_Types
var $0046824dfaec0dac$var$FirebaseError = /** @class */ function(_super) {
    $hAtcO.__extends(FirebaseError, _super);
    function FirebaseError(code, message) {
        var _this = _super.call(this, message) || this;
        _this.code = code;
        _this.name = $0046824dfaec0dac$var$ERROR_NAME;
        // Fix For ES5
        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(_this, FirebaseError.prototype);
        // Maintains proper stack trace for where our error was thrown.
        // Only available on V8.
        if (Error.captureStackTrace) Error.captureStackTrace(_this, $0046824dfaec0dac$var$ErrorFactory.prototype.create);
        return _this;
    }
    return FirebaseError;
}(Error);
var $0046824dfaec0dac$var$ErrorFactory = /** @class */ function() {
    function ErrorFactory(service, serviceName, errors) {
        this.service = service;
        this.serviceName = serviceName;
        this.errors = errors;
    }
    ErrorFactory.prototype.create = function(code) {
        var data = [];
        for(var _i = 1; _i < arguments.length; _i++)data[_i - 1] = arguments[_i];
        var customData = data[0] || {};
        var fullCode = this.service + "/" + code;
        var template = this.errors[code];
        var message = template ? $0046824dfaec0dac$var$replaceTemplate(template, customData) : "Error";
        // Service Name: Error message (service/code).
        var fullMessage = this.serviceName + ": " + message + " (" + fullCode + ").";
        var error = new $0046824dfaec0dac$var$FirebaseError(fullCode, fullMessage);
        // Keys with an underscore at the end of their name are not included in
        // error.data for some reason.
        // TODO: Replace with Object.entries when lib is updated to es2017.
        for(var _a = 0, _b = Object.keys(customData); _a < _b.length; _a++){
            var key = _b[_a];
            if (key.slice(-1) !== "_") {
                if (key in error) console.warn('Overwriting FirebaseError base field "' + key + '" can cause unexpected behavior.');
                error[key] = customData[key];
            }
        }
        return error;
    };
    return ErrorFactory;
}();
function $0046824dfaec0dac$var$replaceTemplate(template, data) {
    return template.replace($0046824dfaec0dac$var$PATTERN, function(_, key) {
        var value = data[key];
        return value != null ? String(value) : "<" + key + "?>";
    });
}
var $0046824dfaec0dac$var$PATTERN = /\{\$([^}]+)}/g;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Evaluates a JSON string into a javascript object.
 *
 * @param {string} str A string containing JSON.
 * @return {*} The javascript object representing the specified JSON.
 */ function $0046824dfaec0dac$var$jsonEval(str) {
    return JSON.parse(str);
}
/**
 * Returns JSON representing a javascript object.
 * @param {*} data Javascript object to be stringified.
 * @return {string} The JSON contents of the object.
 */ function $0046824dfaec0dac$var$stringify(data) {
    return JSON.stringify(data);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Decodes a Firebase auth. token into constituent parts.
 *
 * Notes:
 * - May return with invalid / incomplete claims if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ var $0046824dfaec0dac$var$decode = function(token) {
    var header = {}, claims = {}, data = {}, signature = "";
    try {
        var parts = token.split(".");
        header = $0046824dfaec0dac$var$jsonEval($0046824dfaec0dac$var$base64Decode(parts[0]) || "");
        claims = $0046824dfaec0dac$var$jsonEval($0046824dfaec0dac$var$base64Decode(parts[1]) || "");
        signature = parts[2];
        data = claims["d"] || {};
        delete claims["d"];
    } catch (e) {}
    return {
        header: header,
        claims: claims,
        data: data,
        signature: signature
    };
};
/**
 * Decodes a Firebase auth. token and checks the validity of its time-based claims. Will return true if the
 * token is within the time window authorized by the 'nbf' (not-before) and 'iat' (issued-at) claims.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ var $0046824dfaec0dac$var$isValidTimestamp = function(token) {
    var claims = $0046824dfaec0dac$var$decode(token).claims;
    var now = Math.floor(new Date().getTime() / 1000);
    var validSince = 0, validUntil = 0;
    if (typeof claims === "object") {
        if (claims.hasOwnProperty("nbf")) validSince = claims["nbf"];
        else if (claims.hasOwnProperty("iat")) validSince = claims["iat"];
        if (claims.hasOwnProperty("exp")) validUntil = claims["exp"];
        else // token will expire after 24h by default
        validUntil = validSince + 86400;
    }
    return !!now && !!validSince && !!validUntil && now >= validSince && now <= validUntil;
};
/**
 * Decodes a Firebase auth. token and returns its issued at time if valid, null otherwise.
 *
 * Notes:
 * - May return null if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ var $0046824dfaec0dac$var$issuedAtTime = function(token) {
    var claims = $0046824dfaec0dac$var$decode(token).claims;
    if (typeof claims === "object" && claims.hasOwnProperty("iat")) return claims["iat"];
    return null;
};
/**
 * Decodes a Firebase auth. token and checks the validity of its format. Expects a valid issued-at time.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ var $0046824dfaec0dac$var$isValidFormat = function(token) {
    var decoded = $0046824dfaec0dac$var$decode(token), claims = decoded.claims;
    return !!claims && typeof claims === "object" && claims.hasOwnProperty("iat");
};
/**
 * Attempts to peer into an auth token and determine if it's an admin auth token by looking at the claims portion.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ var $0046824dfaec0dac$var$isAdmin = function(token) {
    var claims = $0046824dfaec0dac$var$decode(token).claims;
    return typeof claims === "object" && claims["admin"] === true;
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $0046824dfaec0dac$var$contains(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
}
function $0046824dfaec0dac$var$safeGet(obj, key) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) return obj[key];
    else return undefined;
}
function $0046824dfaec0dac$var$isEmpty(obj) {
    for(var key in obj){
        if (Object.prototype.hasOwnProperty.call(obj, key)) return false;
    }
    return true;
}
function $0046824dfaec0dac$var$map(obj, fn, contextObj) {
    var res = {};
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) res[key] = fn.call(contextObj, obj[key], key, obj);
    return res;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a querystring-formatted string (e.g. &arg=val&arg2=val2) from a
 * params object (e.g. {arg: 'val', arg2: 'val2'})
 * Note: You must prepend it with ? when adding it to a URL.
 */ function $0046824dfaec0dac$var$querystring(querystringParams) {
    var params = [];
    var _loop_1 = function(key, value) {
        if (Array.isArray(value)) value.forEach(function(arrayVal) {
            params.push(encodeURIComponent(key) + "=" + encodeURIComponent(arrayVal));
        });
        else params.push(encodeURIComponent(key) + "=" + encodeURIComponent(value));
    };
    for(var _i = 0, _a = Object.entries(querystringParams); _i < _a.length; _i++){
        var _b = _a[_i], key = _b[0], value = _b[1];
        _loop_1(key, value);
    }
    return params.length ? "&" + params.join("&") : "";
}
/**
 * Decodes a querystring (e.g. ?arg=val&arg2=val2) into a params object
 * (e.g. {arg: 'val', arg2: 'val2'})
 */ function $0046824dfaec0dac$var$querystringDecode(querystring) {
    var obj = {};
    var tokens = querystring.replace(/^\?/, "").split("&");
    tokens.forEach(function(token) {
        if (token) {
            var key = token.split("=");
            obj[key[0]] = key[1];
        }
    });
    return obj;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview SHA-1 cryptographic hash.
 * Variable names follow the notation in FIPS PUB 180-3:
 * http://csrc.nist.gov/publications/fips/fips180-3/fips180-3_final.pdf.
 *
 * Usage:
 *   var sha1 = new sha1();
 *   sha1.update(bytes);
 *   var hash = sha1.digest();
 *
 * Performance:
 *   Chrome 23:   ~400 Mbit/s
 *   Firefox 16:  ~250 Mbit/s
 *
 */ /**
 * SHA-1 cryptographic hash constructor.
 *
 * The properties declared here are discussed in the above algorithm document.
 * @constructor
 * @final
 * @struct
 */ var $0046824dfaec0dac$var$Sha1 = /** @class */ function() {
    function Sha1() {
        /**
         * Holds the previous values of accumulated variables a-e in the compress_
         * function.
         * @private
         */ this.chain_ = [];
        /**
         * A buffer holding the partially computed hash result.
         * @private
         */ this.buf_ = [];
        /**
         * An array of 80 bytes, each a part of the message to be hashed.  Referred to
         * as the message schedule in the docs.
         * @private
         */ this.W_ = [];
        /**
         * Contains data needed to pad messages less than 64 bytes.
         * @private
         */ this.pad_ = [];
        /**
         * @private {number}
         */ this.inbuf_ = 0;
        /**
         * @private {number}
         */ this.total_ = 0;
        this.blockSize = 64;
        this.pad_[0] = 128;
        for(var i = 1; i < this.blockSize; ++i)this.pad_[i] = 0;
        this.reset();
    }
    Sha1.prototype.reset = function() {
        this.chain_[0] = 0x67452301;
        this.chain_[1] = 0xefcdab89;
        this.chain_[2] = 0x98badcfe;
        this.chain_[3] = 0x10325476;
        this.chain_[4] = 0xc3d2e1f0;
        this.inbuf_ = 0;
        this.total_ = 0;
    };
    /**
     * Internal compress helper function.
     * @param buf Block to compress.
     * @param offset Offset of the block in the buffer.
     * @private
     */ Sha1.prototype.compress_ = function(buf, offset) {
        if (!offset) offset = 0;
        var W = this.W_;
        // get 16 big endian words
        if (typeof buf === "string") for(var i = 0; i < 16; i++){
            // TODO(user): [bug 8140122] Recent versions of Safari for Mac OS and iOS
            // have a bug that turns the post-increment ++ operator into pre-increment
            // during JIT compilation.  We have code that depends heavily on SHA-1 for
            // correctness and which is affected by this bug, so I've removed all uses
            // of post-increment ++ in which the result value is used.  We can revert
            // this change once the Safari bug
            // (https://bugs.webkit.org/show_bug.cgi?id=109036) has been fixed and
            // most clients have been updated.
            W[i] = buf.charCodeAt(offset) << 24 | buf.charCodeAt(offset + 1) << 16 | buf.charCodeAt(offset + 2) << 8 | buf.charCodeAt(offset + 3);
            offset += 4;
        }
        else for(var i = 0; i < 16; i++){
            W[i] = buf[offset] << 24 | buf[offset + 1] << 16 | buf[offset + 2] << 8 | buf[offset + 3];
            offset += 4;
        }
        // expand to 80 words
        for(var i = 16; i < 80; i++){
            var t = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
            W[i] = (t << 1 | t >>> 31) & 0xffffffff;
        }
        var a = this.chain_[0];
        var b = this.chain_[1];
        var c = this.chain_[2];
        var d = this.chain_[3];
        var e = this.chain_[4];
        var f, k;
        // TODO(user): Try to unroll this loop to speed up the computation.
        for(var i = 0; i < 80; i++){
            if (i < 40) {
                if (i < 20) {
                    f = d ^ b & (c ^ d);
                    k = 0x5a827999;
                } else {
                    f = b ^ c ^ d;
                    k = 0x6ed9eba1;
                }
            } else if (i < 60) {
                f = b & c | d & (b | c);
                k = 0x8f1bbcdc;
            } else {
                f = b ^ c ^ d;
                k = 0xca62c1d6;
            }
            var t = (a << 5 | a >>> 27) + f + e + k + W[i] & 0xffffffff;
            e = d;
            d = c;
            c = (b << 30 | b >>> 2) & 0xffffffff;
            b = a;
            a = t;
        }
        this.chain_[0] = this.chain_[0] + a & 0xffffffff;
        this.chain_[1] = this.chain_[1] + b & 0xffffffff;
        this.chain_[2] = this.chain_[2] + c & 0xffffffff;
        this.chain_[3] = this.chain_[3] + d & 0xffffffff;
        this.chain_[4] = this.chain_[4] + e & 0xffffffff;
    };
    Sha1.prototype.update = function(bytes, length) {
        // TODO(johnlenz): tighten the function signature and remove this check
        if (bytes == null) return;
        if (length === undefined) length = bytes.length;
        var lengthMinusBlock = length - this.blockSize;
        var n = 0;
        // Using local instead of member variables gives ~5% speedup on Firefox 16.
        var buf = this.buf_;
        var inbuf = this.inbuf_;
        // The outer while loop should execute at most twice.
        while(n < length){
            // When we have no data in the block to top up, we can directly process the
            // input buffer (assuming it contains sufficient data). This gives ~25%
            // speedup on Chrome 23 and ~15% speedup on Firefox 16, but requires that
            // the data is provided in large chunks (or in multiples of 64 bytes).
            if (inbuf === 0) while(n <= lengthMinusBlock){
                this.compress_(bytes, n);
                n += this.blockSize;
            }
            if (typeof bytes === "string") while(n < length){
                buf[inbuf] = bytes.charCodeAt(n);
                ++inbuf;
                ++n;
                if (inbuf === this.blockSize) {
                    this.compress_(buf);
                    inbuf = 0;
                    break;
                }
            }
            else while(n < length){
                buf[inbuf] = bytes[n];
                ++inbuf;
                ++n;
                if (inbuf === this.blockSize) {
                    this.compress_(buf);
                    inbuf = 0;
                    break;
                }
            }
        }
        this.inbuf_ = inbuf;
        this.total_ += length;
    };
    /** @override */ Sha1.prototype.digest = function() {
        var digest = [];
        var totalBits = this.total_ * 8;
        // Add pad 0x80 0x00*.
        if (this.inbuf_ < 56) this.update(this.pad_, 56 - this.inbuf_);
        else this.update(this.pad_, this.blockSize - (this.inbuf_ - 56));
        // Add # bits.
        for(var i = this.blockSize - 1; i >= 56; i--){
            this.buf_[i] = totalBits & 255;
            totalBits /= 256; // Don't use bit-shifting here!
        }
        this.compress_(this.buf_);
        var n = 0;
        for(var i = 0; i < 5; i++)for(var j = 24; j >= 0; j -= 8){
            digest[n] = this.chain_[i] >> j & 255;
            ++n;
        }
        return digest;
    };
    return Sha1;
}();
/**
 * Helper to make a Subscribe function (just like Promise helps make a
 * Thenable).
 *
 * @param executor Function which can make calls to a single Observer
 *     as a proxy.
 * @param onNoObservers Callback when count of Observers goes to zero.
 */ function $0046824dfaec0dac$var$createSubscribe(executor, onNoObservers) {
    var proxy = new $0046824dfaec0dac$var$ObserverProxy(executor, onNoObservers);
    return proxy.subscribe.bind(proxy);
}
/**
 * Implement fan-out for any number of Observers attached via a subscribe
 * function.
 */ var $0046824dfaec0dac$var$ObserverProxy = /** @class */ function() {
    /**
     * @param executor Function which can make calls to a single Observer
     *     as a proxy.
     * @param onNoObservers Callback when count of Observers goes to zero.
     */ function ObserverProxy(executor, onNoObservers) {
        var _this = this;
        this.observers = [];
        this.unsubscribes = [];
        this.observerCount = 0;
        // Micro-task scheduling by calling task.then().
        this.task = Promise.resolve();
        this.finalized = false;
        this.onNoObservers = onNoObservers;
        // Call the executor asynchronously so subscribers that are called
        // synchronously after the creation of the subscribe function
        // can still receive the very first value generated in the executor.
        this.task.then(function() {
            executor(_this);
        }).catch(function(e) {
            _this.error(e);
        });
    }
    ObserverProxy.prototype.next = function(value) {
        this.forEachObserver(function(observer) {
            observer.next(value);
        });
    };
    ObserverProxy.prototype.error = function(error) {
        this.forEachObserver(function(observer) {
            observer.error(error);
        });
        this.close(error);
    };
    ObserverProxy.prototype.complete = function() {
        this.forEachObserver(function(observer) {
            observer.complete();
        });
        this.close();
    };
    /**
     * Subscribe function that can be used to add an Observer to the fan-out list.
     *
     * - We require that no event is sent to a subscriber sychronously to their
     *   call to subscribe().
     */ ObserverProxy.prototype.subscribe = function(nextOrObserver, error, complete) {
        var _this = this;
        var observer;
        if (nextOrObserver === undefined && error === undefined && complete === undefined) throw new Error("Missing Observer.");
        // Assemble an Observer object when passed as callback functions.
        if ($0046824dfaec0dac$var$implementsAnyMethods(nextOrObserver, [
            "next",
            "error",
            "complete"
        ])) observer = nextOrObserver;
        else observer = {
            next: nextOrObserver,
            error: error,
            complete: complete
        };
        if (observer.next === undefined) observer.next = $0046824dfaec0dac$var$noop;
        if (observer.error === undefined) observer.error = $0046824dfaec0dac$var$noop;
        if (observer.complete === undefined) observer.complete = $0046824dfaec0dac$var$noop;
        var unsub = this.unsubscribeOne.bind(this, this.observers.length);
        // Attempt to subscribe to a terminated Observable - we
        // just respond to the Observer with the final error or complete
        // event.
        if (this.finalized) // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(function() {
            try {
                if (_this.finalError) observer.error(_this.finalError);
                else observer.complete();
            } catch (e) {
            // nothing
            }
            return;
        });
        this.observers.push(observer);
        return unsub;
    };
    // Unsubscribe is synchronous - we guarantee that no events are sent to
    // any unsubscribed Observer.
    ObserverProxy.prototype.unsubscribeOne = function(i) {
        if (this.observers === undefined || this.observers[i] === undefined) return;
        delete this.observers[i];
        this.observerCount -= 1;
        if (this.observerCount === 0 && this.onNoObservers !== undefined) this.onNoObservers(this);
    };
    ObserverProxy.prototype.forEachObserver = function(fn) {
        if (this.finalized) // Already closed by previous event....just eat the additional values.
        return;
        // Since sendOne calls asynchronously - there is no chance that
        // this.observers will become undefined.
        for(var i = 0; i < this.observers.length; i++)this.sendOne(i, fn);
    };
    // Call the Observer via one of it's callback function. We are careful to
    // confirm that the observe has not been unsubscribed since this asynchronous
    // function had been queued.
    ObserverProxy.prototype.sendOne = function(i, fn) {
        var _this = this;
        // Execute the callback asynchronously
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(function() {
            if (_this.observers !== undefined && _this.observers[i] !== undefined) try {
                fn(_this.observers[i]);
            } catch (e) {
                // Ignore exceptions raised in Observers or missing methods of an
                // Observer.
                // Log error to console. b/31404806
                if (typeof console !== "undefined" && console.error) console.error(e);
            }
        });
    };
    ObserverProxy.prototype.close = function(err) {
        var _this = this;
        if (this.finalized) return;
        this.finalized = true;
        if (err !== undefined) this.finalError = err;
        // Proxy is no longer needed - garbage collect references
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(function() {
            _this.observers = undefined;
            _this.onNoObservers = undefined;
        });
    };
    return ObserverProxy;
}();
/** Turn synchronous function into one called asynchronously. */ // eslint-disable-next-line @typescript-eslint/ban-types
function $0046824dfaec0dac$var$async(fn, onError) {
    return function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        Promise.resolve(true).then(function() {
            fn.apply(void 0, args);
        }).catch(function(error) {
            if (onError) onError(error);
        });
    };
}
/**
 * Return true if the object passed in implements any of the named methods.
 */ function $0046824dfaec0dac$var$implementsAnyMethods(obj, methods) {
    if (typeof obj !== "object" || obj === null) return false;
    for(var _i = 0, methods_1 = methods; _i < methods_1.length; _i++){
        var method = methods_1[_i];
        if (method in obj && typeof obj[method] === "function") return true;
    }
    return false;
}
function $0046824dfaec0dac$var$noop() {
// do nothing
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Check to make sure the appropriate number of arguments are provided for a public function.
 * Throws an error if it fails.
 *
 * @param fnName The function name
 * @param minCount The minimum number of arguments to allow for the function call
 * @param maxCount The maximum number of argument to allow for the function call
 * @param argCount The actual number of arguments provided.
 */ var $0046824dfaec0dac$var$validateArgCount = function(fnName, minCount, maxCount, argCount) {
    var argError;
    if (argCount < minCount) argError = "at least " + minCount;
    else if (argCount > maxCount) argError = maxCount === 0 ? "none" : "no more than " + maxCount;
    if (argError) {
        var error = fnName + " failed: Was called with " + argCount + (argCount === 1 ? " argument." : " arguments.") + " Expects " + argError + ".";
        throw new Error(error);
    }
};
/**
 * Generates a string to prefix an error message about failed argument validation
 *
 * @param fnName The function name
 * @param argumentNumber The index of the argument
 * @param optional Whether or not the argument is optional
 * @return The prefix to add to the error thrown for validation.
 */ function $0046824dfaec0dac$var$errorPrefix(fnName, argumentNumber, optional) {
    var argName = "";
    switch(argumentNumber){
        case 1:
            argName = optional ? "first" : "First";
            break;
        case 2:
            argName = optional ? "second" : "Second";
            break;
        case 3:
            argName = optional ? "third" : "Third";
            break;
        case 4:
            argName = optional ? "fourth" : "Fourth";
            break;
        default:
            throw new Error("errorPrefix called with argumentNumber > 4.  Need to update it?");
    }
    var error = fnName + " failed: ";
    error += argName + " argument ";
    return error;
}
/**
 * @param fnName
 * @param argumentNumber
 * @param namespace
 * @param optional
 */ function $0046824dfaec0dac$var$validateNamespace(fnName, argumentNumber, namespace, optional) {
    if (optional && !namespace) return;
    if (typeof namespace !== "string") //TODO: I should do more validation here. We only allow certain chars in namespaces.
    throw new Error($0046824dfaec0dac$var$errorPrefix(fnName, argumentNumber, optional) + "must be a valid firebase namespace.");
}
function $0046824dfaec0dac$var$validateCallback(fnName, argumentNumber, // eslint-disable-next-line @typescript-eslint/ban-types
callback, optional) {
    if (optional && !callback) return;
    if (typeof callback !== "function") throw new Error($0046824dfaec0dac$var$errorPrefix(fnName, argumentNumber, optional) + "must be a valid function.");
}
function $0046824dfaec0dac$var$validateContextObject(fnName, argumentNumber, context, optional) {
    if (optional && !context) return;
    if (typeof context !== "object" || context === null) throw new Error($0046824dfaec0dac$var$errorPrefix(fnName, argumentNumber, optional) + "must be a valid context object.");
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Code originally came from goog.crypt.stringToUtf8ByteArray, but for some reason they
// automatically replaced '\r\n' with '\n', and they didn't handle surrogate pairs,
// so it's been modified.
// Note that not all Unicode characters appear as single characters in JavaScript strings.
// fromCharCode returns the UTF-16 encoding of a character - so some Unicode characters
// use 2 characters in Javascript.  All 4-byte UTF-8 characters begin with a first
// character in the range 0xD800 - 0xDBFF (the first character of a so-called surrogate
// pair).
// See http://www.ecma-international.org/ecma-262/5.1/#sec-15.1.3
/**
 * @param {string} str
 * @return {Array}
 */ var $0046824dfaec0dac$var$stringToByteArray$1 = function(str) {
    var out = [];
    var p = 0;
    for(var i = 0; i < str.length; i++){
        var c = str.charCodeAt(i);
        // Is this the lead surrogate in a surrogate pair?
        if (c >= 0xd800 && c <= 0xdbff) {
            var high = c - 0xd800; // the high 10 bits.
            i++;
            $0046824dfaec0dac$var$assert(i < str.length, "Surrogate pair missing trail surrogate.");
            var low = str.charCodeAt(i) - 0xdc00; // the low 10 bits.
            c = 0x10000 + (high << 10) + low;
        }
        if (c < 128) out[p++] = c;
        else if (c < 2048) {
            out[p++] = c >> 6 | 192;
            out[p++] = c & 63 | 128;
        } else if (c < 65536) {
            out[p++] = c >> 12 | 224;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        } else {
            out[p++] = c >> 18 | 240;
            out[p++] = c >> 12 & 63 | 128;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        }
    }
    return out;
};
/**
 * Calculate length without actually converting; useful for doing cheaper validation.
 * @param {string} str
 * @return {number}
 */ var $0046824dfaec0dac$var$stringLength = function(str) {
    var p = 0;
    for(var i = 0; i < str.length; i++){
        var c = str.charCodeAt(i);
        if (c < 128) p++;
        else if (c < 2048) p += 2;
        else if (c >= 0xd800 && c <= 0xdbff) {
            // Lead surrogate of a surrogate pair.  The pair together will take 4 bytes to represent.
            p += 4;
            i++; // skip trail surrogate.
        } else p += 3;
    }
    return p;
};
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The amount of milliseconds to exponentially increase.
 */ var $0046824dfaec0dac$var$DEFAULT_INTERVAL_MILLIS = 1000;
/**
 * The factor to backoff by.
 * Should be a number greater than 1.
 */ var $0046824dfaec0dac$var$DEFAULT_BACKOFF_FACTOR = 2;
/**
 * The maximum milliseconds to increase to.
 *
 * <p>Visible for testing
 */ var $0046824dfaec0dac$var$MAX_VALUE_MILLIS = 14400000; // Four hours, like iOS and Android.
/**
 * The percentage of backoff time to randomize by.
 * See
 * http://go/safe-client-behavior#step-1-determine-the-appropriate-retry-interval-to-handle-spike-traffic
 * for context.
 *
 * <p>Visible for testing
 */ var $0046824dfaec0dac$var$RANDOM_FACTOR = 0.5;
/**
 * Based on the backoff method from
 * https://github.com/google/closure-library/blob/master/closure/goog/math/exponentialbackoff.js.
 * Extracted here so we don't need to pass metadata and a stateful ExponentialBackoff object around.
 */ function $0046824dfaec0dac$var$calculateBackoffMillis(backoffCount, intervalMillis, backoffFactor) {
    if (intervalMillis === void 0) intervalMillis = $0046824dfaec0dac$var$DEFAULT_INTERVAL_MILLIS;
    if (backoffFactor === void 0) backoffFactor = $0046824dfaec0dac$var$DEFAULT_BACKOFF_FACTOR;
    // Calculates an exponentially increasing value.
    // Deviation: calculates value from count and a constant interval, so we only need to save value
    // and count to restore state.
    var currBaseValue = intervalMillis * Math.pow(backoffFactor, backoffCount);
    // A random "fuzz" to avoid waves of retries.
    // Deviation: randomFactor is required.
    var randomWait = Math.round(// A fraction of the backoff value to add/subtract.
    // Deviation: changes multiplication order to improve readability.
    $0046824dfaec0dac$var$RANDOM_FACTOR * currBaseValue * // A random float (rounded to int by Math.round above) in the range [-1, 1]. Determines
    // if we add or subtract.
    (Math.random() - 0.5) * 2);
    // Limits backoff to max to avoid effectively permanent backoff.
    return Math.min($0046824dfaec0dac$var$MAX_VALUE_MILLIS, currBaseValue + randomWait);
}
module.exports.CONSTANTS = $0046824dfaec0dac$var$CONSTANTS;
module.exports.Deferred = $0046824dfaec0dac$var$Deferred;
module.exports.ErrorFactory = $0046824dfaec0dac$var$ErrorFactory;
module.exports.FirebaseError = $0046824dfaec0dac$var$FirebaseError;
module.exports.MAX_VALUE_MILLIS = $0046824dfaec0dac$var$MAX_VALUE_MILLIS;
module.exports.RANDOM_FACTOR = $0046824dfaec0dac$var$RANDOM_FACTOR;
module.exports.Sha1 = $0046824dfaec0dac$var$Sha1;
module.exports.areCookiesEnabled = $0046824dfaec0dac$var$areCookiesEnabled;
module.exports.assert = $0046824dfaec0dac$var$assert;
module.exports.assertionError = $0046824dfaec0dac$var$assertionError;
module.exports.async = $0046824dfaec0dac$var$async;
module.exports.base64 = $0046824dfaec0dac$var$base64;
module.exports.base64Decode = $0046824dfaec0dac$var$base64Decode;
module.exports.base64Encode = $0046824dfaec0dac$var$base64Encode;
module.exports.calculateBackoffMillis = $0046824dfaec0dac$var$calculateBackoffMillis;
module.exports.contains = $0046824dfaec0dac$var$contains;
module.exports.createSubscribe = $0046824dfaec0dac$var$createSubscribe;
module.exports.decode = $0046824dfaec0dac$var$decode;
module.exports.deepCopy = $0046824dfaec0dac$var$deepCopy;
module.exports.deepExtend = $0046824dfaec0dac$var$deepExtend;
module.exports.errorPrefix = $0046824dfaec0dac$var$errorPrefix;
module.exports.getUA = $0046824dfaec0dac$var$getUA;
module.exports.isAdmin = $0046824dfaec0dac$var$isAdmin;
module.exports.isBrowser = $0046824dfaec0dac$var$isBrowser;
module.exports.isBrowserExtension = $0046824dfaec0dac$var$isBrowserExtension;
module.exports.isElectron = $0046824dfaec0dac$var$isElectron;
module.exports.isEmpty = $0046824dfaec0dac$var$isEmpty;
module.exports.isIE = $0046824dfaec0dac$var$isIE;
module.exports.isIndexedDBAvailable = $0046824dfaec0dac$var$isIndexedDBAvailable;
module.exports.isMobileCordova = $0046824dfaec0dac$var$isMobileCordova;
module.exports.isNode = $0046824dfaec0dac$var$isNode;
module.exports.isNodeSdk = $0046824dfaec0dac$var$isNodeSdk;
module.exports.isReactNative = $0046824dfaec0dac$var$isReactNative;
module.exports.isSafari = $0046824dfaec0dac$var$isSafari;
module.exports.isUWP = $0046824dfaec0dac$var$isUWP;
module.exports.isValidFormat = $0046824dfaec0dac$var$isValidFormat;
module.exports.isValidTimestamp = $0046824dfaec0dac$var$isValidTimestamp;
module.exports.issuedAtTime = $0046824dfaec0dac$var$issuedAtTime;
module.exports.jsonEval = $0046824dfaec0dac$var$jsonEval;
module.exports.map = $0046824dfaec0dac$var$map;
module.exports.querystring = $0046824dfaec0dac$var$querystring;
module.exports.querystringDecode = $0046824dfaec0dac$var$querystringDecode;
module.exports.safeGet = $0046824dfaec0dac$var$safeGet;
module.exports.stringLength = $0046824dfaec0dac$var$stringLength;
module.exports.stringToByteArray = $0046824dfaec0dac$var$stringToByteArray$1;
module.exports.stringify = $0046824dfaec0dac$var$stringify;
module.exports.validateArgCount = $0046824dfaec0dac$var$validateArgCount;
module.exports.validateCallback = $0046824dfaec0dac$var$validateCallback;
module.exports.validateContextObject = $0046824dfaec0dac$var$validateContextObject;
module.exports.validateIndexedDBOpenable = $0046824dfaec0dac$var$validateIndexedDBOpenable;
module.exports.validateNamespace = $0046824dfaec0dac$var$validateNamespace;

});
parcelRegister("hAtcO", function(module, exports) {

$parcel$export(module.exports, "__extends", () => $ccdc741b9f32c6fe$export$a8ba968b8961cb8a);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $ccdc741b9f32c6fe$var$extendStatics = function(d, b) {
    $ccdc741b9f32c6fe$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $ccdc741b9f32c6fe$var$extendStatics(d, b);
};
function $ccdc741b9f32c6fe$export$a8ba968b8961cb8a(d, b) {
    $ccdc741b9f32c6fe$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $ccdc741b9f32c6fe$export$18ce0697a983be9b = function() {
    $ccdc741b9f32c6fe$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $ccdc741b9f32c6fe$export$18ce0697a983be9b.apply(this, arguments);
};
function $ccdc741b9f32c6fe$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $ccdc741b9f32c6fe$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $ccdc741b9f32c6fe$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $ccdc741b9f32c6fe$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $ccdc741b9f32c6fe$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $ccdc741b9f32c6fe$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $ccdc741b9f32c6fe$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $ccdc741b9f32c6fe$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $ccdc741b9f32c6fe$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $ccdc741b9f32c6fe$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $ccdc741b9f32c6fe$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($ccdc741b9f32c6fe$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $ccdc741b9f32c6fe$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $ccdc741b9f32c6fe$export$10c90e4f7922046c(v) {
    return this instanceof $ccdc741b9f32c6fe$export$10c90e4f7922046c ? (this.v = v, this) : new $ccdc741b9f32c6fe$export$10c90e4f7922046c(v);
}
function $ccdc741b9f32c6fe$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $ccdc741b9f32c6fe$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $ccdc741b9f32c6fe$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $ccdc741b9f32c6fe$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $ccdc741b9f32c6fe$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $ccdc741b9f32c6fe$export$19a8beecd37a4c45 === "function" ? $ccdc741b9f32c6fe$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $ccdc741b9f32c6fe$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $ccdc741b9f32c6fe$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $ccdc741b9f32c6fe$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $ccdc741b9f32c6fe$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $ccdc741b9f32c6fe$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

});


parcelRegister("gLWqF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $3LIn2 = parcelRequire("3LIn2");

var $01sTD = parcelRequire("01sTD");
/**
 * Component for service name T, e.g. `auth`, `auth-internal`
 */ var $c35e5bf4eaf78db9$var$Component = /** @class */ function() {
    /**
     *
     * @param name The public service name, e.g. app, auth, firestore, database
     * @param instanceFactory Service factory responsible for creating the public interface
     * @param type whether the service provided by the component is public or private
     */ function Component(name, instanceFactory, type) {
        this.name = name;
        this.instanceFactory = instanceFactory;
        this.type = type;
        this.multipleInstances = false;
        /**
         * Properties to be added to the service namespace
         */ this.serviceProps = {};
        this.instantiationMode = "LAZY" /* LAZY */ ;
    }
    Component.prototype.setInstantiationMode = function(mode) {
        this.instantiationMode = mode;
        return this;
    };
    Component.prototype.setMultipleInstances = function(multipleInstances) {
        this.multipleInstances = multipleInstances;
        return this;
    };
    Component.prototype.setServiceProps = function(props) {
        this.serviceProps = props;
        return this;
    };
    return Component;
}();
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $c35e5bf4eaf78db9$var$DEFAULT_ENTRY_NAME = "[DEFAULT]";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for instance for service name T, e.g. 'auth', 'auth-internal'
 * NameServiceMapping[T] is an alias for the type of the instance
 */ var $c35e5bf4eaf78db9$var$Provider = /** @class */ function() {
    function Provider(name, container) {
        this.name = name;
        this.container = container;
        this.component = null;
        this.instances = new Map();
        this.instancesDeferred = new Map();
    }
    /**
     * @param identifier A provider can provide mulitple instances of a service
     * if this.component.multipleInstances is true.
     */ Provider.prototype.get = function(identifier) {
        if (identifier === void 0) identifier = $c35e5bf4eaf78db9$var$DEFAULT_ENTRY_NAME;
        // if multipleInstances is not supported, use the default name
        var normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
        if (!this.instancesDeferred.has(normalizedIdentifier)) {
            var deferred = new $01sTD.Deferred();
            this.instancesDeferred.set(normalizedIdentifier, deferred);
            // If the service instance is available, resolve the promise with it immediately
            try {
                var instance = this.getOrInitializeService(normalizedIdentifier);
                if (instance) deferred.resolve(instance);
            } catch (e) {
            // when the instance factory throws an exception during get(), it should not cause
            // a fatal error. We just return the unresolved promise in this case.
            }
        }
        return this.instancesDeferred.get(normalizedIdentifier).promise;
    };
    Provider.prototype.getImmediate = function(options) {
        var _a = $3LIn2.__assign({
            identifier: $c35e5bf4eaf78db9$var$DEFAULT_ENTRY_NAME,
            optional: false
        }, options), identifier = _a.identifier, optional = _a.optional;
        // if multipleInstances is not supported, use the default name
        var normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
        try {
            var instance = this.getOrInitializeService(normalizedIdentifier);
            if (!instance) {
                if (optional) return null;
                throw Error("Service " + this.name + " is not available");
            }
            return instance;
        } catch (e) {
            if (optional) return null;
            else throw e;
        }
    };
    Provider.prototype.getComponent = function() {
        return this.component;
    };
    Provider.prototype.setComponent = function(component) {
        var e_1, _a;
        if (component.name !== this.name) throw Error("Mismatching Component " + component.name + " for Provider " + this.name + ".");
        if (this.component) throw Error("Component for " + this.name + " has already been provided");
        this.component = component;
        // if the service is eager, initialize the default instance
        if ($c35e5bf4eaf78db9$var$isComponentEager(component)) try {
            this.getOrInitializeService($c35e5bf4eaf78db9$var$DEFAULT_ENTRY_NAME);
        } catch (e) {
        // when the instance factory for an eager Component throws an exception during the eager
        // initialization, it should not cause a fatal error.
        // TODO: Investigate if we need to make it configurable, because some component may want to cause
        // a fatal error in this case?
        }
        try {
            // Create service instances for the pending promises and resolve them
            // NOTE: if this.multipleInstances is false, only the default instance will be created
            // and all promises with resolve with it regardless of the identifier.
            for(var _b = $3LIn2.__values(this.instancesDeferred.entries()), _c = _b.next(); !_c.done; _c = _b.next()){
                var _d = $3LIn2.__read(_c.value, 2), instanceIdentifier = _d[0], instanceDeferred = _d[1];
                var normalizedIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);
                try {
                    // `getOrInitializeService()` should always return a valid instance since a component is guaranteed. use ! to make typescript happy.
                    var instance = this.getOrInitializeService(normalizedIdentifier);
                    instanceDeferred.resolve(instance);
                } catch (e) {
                // when the instance factory throws an exception, it should not cause
                // a fatal error. We just leave the promise unresolved.
                }
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
    };
    Provider.prototype.clearInstance = function(identifier) {
        if (identifier === void 0) identifier = $c35e5bf4eaf78db9$var$DEFAULT_ENTRY_NAME;
        this.instancesDeferred.delete(identifier);
        this.instances.delete(identifier);
    };
    // app.delete() will call this method on every provider to delete the services
    // TODO: should we mark the provider as deleted?
    Provider.prototype.delete = function() {
        return $3LIn2.__awaiter(this, void 0, void 0, function() {
            var services;
            return $3LIn2.__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        services = Array.from(this.instances.values());
                        return [
                            4 /*yield*/ ,
                            Promise.all($3LIn2.__spread(services.filter(function(service) {
                                return "INTERNAL" in service;
                            }) // legacy services
                            // eslint-disable-next-line @typescript-eslint/no-explicit-any
                            .map(function(service) {
                                return service.INTERNAL.delete();
                            }), services.filter(function(service) {
                                return "_delete" in service;
                            }) // modularized services
                            // eslint-disable-next-line @typescript-eslint/no-explicit-any
                            .map(function(service) {
                                return service._delete();
                            })))
                        ];
                    case 1:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    Provider.prototype.isComponentSet = function() {
        return this.component != null;
    };
    Provider.prototype.getOrInitializeService = function(identifier) {
        var instance = this.instances.get(identifier);
        if (!instance && this.component) {
            instance = this.component.instanceFactory(this.container, $c35e5bf4eaf78db9$var$normalizeIdentifierForFactory(identifier));
            this.instances.set(identifier, instance);
        }
        return instance || null;
    };
    Provider.prototype.normalizeInstanceIdentifier = function(identifier) {
        if (this.component) return this.component.multipleInstances ? identifier : $c35e5bf4eaf78db9$var$DEFAULT_ENTRY_NAME;
        else return identifier; // assume multiple instances are supported before the component is provided.
    };
    return Provider;
}();
// undefined should be passed to the service factory for the default instance
function $c35e5bf4eaf78db9$var$normalizeIdentifierForFactory(identifier) {
    return identifier === $c35e5bf4eaf78db9$var$DEFAULT_ENTRY_NAME ? undefined : identifier;
}
function $c35e5bf4eaf78db9$var$isComponentEager(component) {
    return component.instantiationMode === "EAGER" /* EAGER */ ;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * ComponentContainer that provides Providers for service name T, e.g. `auth`, `auth-internal`
 */ var $c35e5bf4eaf78db9$var$ComponentContainer = /** @class */ function() {
    function ComponentContainer(name) {
        this.name = name;
        this.providers = new Map();
    }
    /**
     *
     * @param component Component being added
     * @param overwrite When a component with the same name has already been registered,
     * if overwrite is true: overwrite the existing component with the new component and create a new
     * provider with the new component. It can be useful in tests where you want to use different mocks
     * for different tests.
     * if overwrite is false: throw an exception
     */ ComponentContainer.prototype.addComponent = function(component) {
        var provider = this.getProvider(component.name);
        if (provider.isComponentSet()) throw new Error("Component " + component.name + " has already been registered with " + this.name);
        provider.setComponent(component);
    };
    ComponentContainer.prototype.addOrOverwriteComponent = function(component) {
        var provider = this.getProvider(component.name);
        if (provider.isComponentSet()) // delete the existing provider from the container, so we can register the new component
        this.providers.delete(component.name);
        this.addComponent(component);
    };
    /**
     * getProvider provides a type safe interface where it can only be called with a field name
     * present in NameServiceMapping interface.
     *
     * Firebase SDKs providing services should extend NameServiceMapping interface to register
     * themselves.
     */ ComponentContainer.prototype.getProvider = function(name) {
        if (this.providers.has(name)) return this.providers.get(name);
        // create a Provider for a service that hasn't registered with Firebase
        var provider = new $c35e5bf4eaf78db9$var$Provider(name, this);
        this.providers.set(name, provider);
        return provider;
    };
    ComponentContainer.prototype.getProviders = function() {
        return Array.from(this.providers.values());
    };
    return ComponentContainer;
}();
module.exports.Component = $c35e5bf4eaf78db9$var$Component;
module.exports.ComponentContainer = $c35e5bf4eaf78db9$var$ComponentContainer;
module.exports.Provider = $c35e5bf4eaf78db9$var$Provider;

});
parcelRegister("3LIn2", function(module, exports) {

$parcel$export(module.exports, "__assign", () => $2be82def891c4cdc$export$18ce0697a983be9b);
$parcel$export(module.exports, "__awaiter", () => $2be82def891c4cdc$export$1050f835b63b671e);
$parcel$export(module.exports, "__generator", () => $2be82def891c4cdc$export$67ebef60e6f28a6);
$parcel$export(module.exports, "__values", () => $2be82def891c4cdc$export$19a8beecd37a4c45);
$parcel$export(module.exports, "__read", () => $2be82def891c4cdc$export$8d051b38c9118094);
$parcel$export(module.exports, "__spread", () => $2be82def891c4cdc$export$afc72e2116322959);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $2be82def891c4cdc$var$extendStatics = function(d, b) {
    $2be82def891c4cdc$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $2be82def891c4cdc$var$extendStatics(d, b);
};
function $2be82def891c4cdc$export$a8ba968b8961cb8a(d, b) {
    $2be82def891c4cdc$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $2be82def891c4cdc$export$18ce0697a983be9b = function() {
    $2be82def891c4cdc$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $2be82def891c4cdc$export$18ce0697a983be9b.apply(this, arguments);
};
function $2be82def891c4cdc$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $2be82def891c4cdc$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $2be82def891c4cdc$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $2be82def891c4cdc$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $2be82def891c4cdc$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $2be82def891c4cdc$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $2be82def891c4cdc$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $2be82def891c4cdc$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $2be82def891c4cdc$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $2be82def891c4cdc$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $2be82def891c4cdc$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($2be82def891c4cdc$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $2be82def891c4cdc$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $2be82def891c4cdc$export$10c90e4f7922046c(v) {
    return this instanceof $2be82def891c4cdc$export$10c90e4f7922046c ? (this.v = v, this) : new $2be82def891c4cdc$export$10c90e4f7922046c(v);
}
function $2be82def891c4cdc$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $2be82def891c4cdc$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $2be82def891c4cdc$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $2be82def891c4cdc$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $2be82def891c4cdc$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $2be82def891c4cdc$export$19a8beecd37a4c45 === "function" ? $2be82def891c4cdc$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $2be82def891c4cdc$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $2be82def891c4cdc$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $2be82def891c4cdc$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $2be82def891c4cdc$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $2be82def891c4cdc$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

});


parcelRegister("d4M6f", function(module, exports) {

$parcel$export(module.exports, "LogLevel", () => $9850f5b25d367a89$export$243e62d78d3b544d);
$parcel$export(module.exports, "Logger", () => $9850f5b25d367a89$export$efa9a398d6368992);
$parcel$export(module.exports, "setLogLevel", () => $9850f5b25d367a89$export$c622e99c0ce7b1c9);
$parcel$export(module.exports, "setUserLogHandler", () => $9850f5b25d367a89$export$29577d29c84db5f6);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */ function $9850f5b25d367a89$var$__spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $9850f5b25d367a89$var$_a;
/**
 * A container for all of the Logger instances
 */ var $9850f5b25d367a89$var$instances = [];
/**
 * The JS SDK supports 5 log levels and also allows a user the ability to
 * silence the logs altogether.
 *
 * The order is a follows:
 * DEBUG < VERBOSE < INFO < WARN < ERROR
 *
 * All of the log types above the current log level will be captured (i.e. if
 * you set the log level to `INFO`, errors will still be logged, but `DEBUG` and
 * `VERBOSE` logs will not)
 */ var $9850f5b25d367a89$export$243e62d78d3b544d;
(function(LogLevel) {
    LogLevel[LogLevel["DEBUG"] = 0] = "DEBUG";
    LogLevel[LogLevel["VERBOSE"] = 1] = "VERBOSE";
    LogLevel[LogLevel["INFO"] = 2] = "INFO";
    LogLevel[LogLevel["WARN"] = 3] = "WARN";
    LogLevel[LogLevel["ERROR"] = 4] = "ERROR";
    LogLevel[LogLevel["SILENT"] = 5] = "SILENT";
})($9850f5b25d367a89$export$243e62d78d3b544d || ($9850f5b25d367a89$export$243e62d78d3b544d = {}));
var $9850f5b25d367a89$var$levelStringToEnum = {
    "debug": $9850f5b25d367a89$export$243e62d78d3b544d.DEBUG,
    "verbose": $9850f5b25d367a89$export$243e62d78d3b544d.VERBOSE,
    "info": $9850f5b25d367a89$export$243e62d78d3b544d.INFO,
    "warn": $9850f5b25d367a89$export$243e62d78d3b544d.WARN,
    "error": $9850f5b25d367a89$export$243e62d78d3b544d.ERROR,
    "silent": $9850f5b25d367a89$export$243e62d78d3b544d.SILENT
};
/**
 * The default log level
 */ var $9850f5b25d367a89$var$defaultLogLevel = $9850f5b25d367a89$export$243e62d78d3b544d.INFO;
/**
 * By default, `console.debug` is not displayed in the developer console (in
 * chrome). To avoid forcing users to have to opt-in to these logs twice
 * (i.e. once for firebase, and once in the console), we are sending `DEBUG`
 * logs to the `console.log` function.
 */ var $9850f5b25d367a89$var$ConsoleMethod = ($9850f5b25d367a89$var$_a = {}, $9850f5b25d367a89$var$_a[$9850f5b25d367a89$export$243e62d78d3b544d.DEBUG] = "log", $9850f5b25d367a89$var$_a[$9850f5b25d367a89$export$243e62d78d3b544d.VERBOSE] = "log", $9850f5b25d367a89$var$_a[$9850f5b25d367a89$export$243e62d78d3b544d.INFO] = "info", $9850f5b25d367a89$var$_a[$9850f5b25d367a89$export$243e62d78d3b544d.WARN] = "warn", $9850f5b25d367a89$var$_a[$9850f5b25d367a89$export$243e62d78d3b544d.ERROR] = "error", $9850f5b25d367a89$var$_a);
/**
 * The default log handler will forward DEBUG, VERBOSE, INFO, WARN, and ERROR
 * messages on to their corresponding console counterparts (if the log method
 * is supported by the current log level)
 */ var $9850f5b25d367a89$var$defaultLogHandler = function(instance, logType) {
    var args = [];
    for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
    if (logType < instance.logLevel) return;
    var now = new Date().toISOString();
    var method = $9850f5b25d367a89$var$ConsoleMethod[logType];
    if (method) console[method].apply(console, $9850f5b25d367a89$var$__spreadArrays([
        "[" + now + "]  " + instance.name + ":"
    ], args));
    else throw new Error("Attempted to log a message with an invalid logType (value: " + logType + ")");
};
var $9850f5b25d367a89$export$efa9a398d6368992 = /** @class */ function() {
    /**
     * Gives you an instance of a Logger to capture messages according to
     * Firebase's logging scheme.
     *
     * @param name The name that the logs will be associated with
     */ function Logger(name) {
        this.name = name;
        /**
         * The log level of the given Logger instance.
         */ this._logLevel = $9850f5b25d367a89$var$defaultLogLevel;
        /**
         * The main (internal) log handler for the Logger instance.
         * Can be set to a new function in internal package code but not by user.
         */ this._logHandler = $9850f5b25d367a89$var$defaultLogHandler;
        /**
         * The optional, additional, user-defined log handler for the Logger instance.
         */ this._userLogHandler = null;
        /**
         * Capture the current instance for later use
         */ $9850f5b25d367a89$var$instances.push(this);
    }
    Object.defineProperty(Logger.prototype, "logLevel", {
        get: function() {
            return this._logLevel;
        },
        set: function(val) {
            if (!(val in $9850f5b25d367a89$export$243e62d78d3b544d)) throw new TypeError('Invalid value "' + val + '" assigned to `logLevel`');
            this._logLevel = val;
        },
        enumerable: false,
        configurable: true
    });
    // Workaround for setter/getter having to be the same type.
    Logger.prototype.setLogLevel = function(val) {
        this._logLevel = typeof val === "string" ? $9850f5b25d367a89$var$levelStringToEnum[val] : val;
    };
    Object.defineProperty(Logger.prototype, "logHandler", {
        get: function() {
            return this._logHandler;
        },
        set: function(val) {
            if (typeof val !== "function") throw new TypeError("Value assigned to `logHandler` must be a function");
            this._logHandler = val;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Logger.prototype, "userLogHandler", {
        get: function() {
            return this._userLogHandler;
        },
        set: function(val) {
            this._userLogHandler = val;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * The functions below are all based on the `console` interface
     */ Logger.prototype.debug = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        this._userLogHandler && this._userLogHandler.apply(this, $9850f5b25d367a89$var$__spreadArrays([
            this,
            $9850f5b25d367a89$export$243e62d78d3b544d.DEBUG
        ], args));
        this._logHandler.apply(this, $9850f5b25d367a89$var$__spreadArrays([
            this,
            $9850f5b25d367a89$export$243e62d78d3b544d.DEBUG
        ], args));
    };
    Logger.prototype.log = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        this._userLogHandler && this._userLogHandler.apply(this, $9850f5b25d367a89$var$__spreadArrays([
            this,
            $9850f5b25d367a89$export$243e62d78d3b544d.VERBOSE
        ], args));
        this._logHandler.apply(this, $9850f5b25d367a89$var$__spreadArrays([
            this,
            $9850f5b25d367a89$export$243e62d78d3b544d.VERBOSE
        ], args));
    };
    Logger.prototype.info = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        this._userLogHandler && this._userLogHandler.apply(this, $9850f5b25d367a89$var$__spreadArrays([
            this,
            $9850f5b25d367a89$export$243e62d78d3b544d.INFO
        ], args));
        this._logHandler.apply(this, $9850f5b25d367a89$var$__spreadArrays([
            this,
            $9850f5b25d367a89$export$243e62d78d3b544d.INFO
        ], args));
    };
    Logger.prototype.warn = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        this._userLogHandler && this._userLogHandler.apply(this, $9850f5b25d367a89$var$__spreadArrays([
            this,
            $9850f5b25d367a89$export$243e62d78d3b544d.WARN
        ], args));
        this._logHandler.apply(this, $9850f5b25d367a89$var$__spreadArrays([
            this,
            $9850f5b25d367a89$export$243e62d78d3b544d.WARN
        ], args));
    };
    Logger.prototype.error = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        this._userLogHandler && this._userLogHandler.apply(this, $9850f5b25d367a89$var$__spreadArrays([
            this,
            $9850f5b25d367a89$export$243e62d78d3b544d.ERROR
        ], args));
        this._logHandler.apply(this, $9850f5b25d367a89$var$__spreadArrays([
            this,
            $9850f5b25d367a89$export$243e62d78d3b544d.ERROR
        ], args));
    };
    return Logger;
}();
function $9850f5b25d367a89$export$c622e99c0ce7b1c9(level) {
    $9850f5b25d367a89$var$instances.forEach(function(inst) {
        inst.setLogLevel(level);
    });
}
function $9850f5b25d367a89$export$29577d29c84db5f6(logCallback, options) {
    var _loop_1 = function(instance) {
        var customLogLevel = null;
        if (options && options.level) customLogLevel = $9850f5b25d367a89$var$levelStringToEnum[options.level];
        if (logCallback === null) instance.userLogHandler = null;
        else instance.userLogHandler = function(instance, level) {
            var args = [];
            for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
            var message = args.map(function(arg) {
                if (arg == null) return null;
                else if (typeof arg === "string") return arg;
                else if (typeof arg === "number" || typeof arg === "boolean") return arg.toString();
                else if (arg instanceof Error) return arg.message;
                else try {
                    return JSON.stringify(arg);
                } catch (ignored) {
                    return null;
                }
            }).filter(function(arg) {
                return arg;
            }).join(" ");
            if (level >= (customLogLevel !== null && customLogLevel !== void 0 ? customLogLevel : instance.logLevel)) logCallback({
                level: $9850f5b25d367a89$export$243e62d78d3b544d[level].toLowerCase(),
                message: message,
                args: args,
                type: instance.name
            });
        };
    };
    for(var _i = 0, instances_1 = $9850f5b25d367a89$var$instances; _i < instances_1.length; _i++){
        var instance = instances_1[_i];
        _loop_1(instance);
    }
}

});


parcelRegister("czWj7", function(module, exports) {
"use strict";
var $9285fb8b82e8e259$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $9285fb8b82e8e259$var$__assign = module.exports && module.exports.__assign || function() {
    $9285fb8b82e8e259$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $9285fb8b82e8e259$var$__assign.apply(this, arguments);
};
var $9285fb8b82e8e259$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $9285fb8b82e8e259$var$react_1 = $9285fb8b82e8e259$var$__importDefault((parcelRequire("acw62")));

var $bJuL9 = parcelRequire("bJuL9");
var $9285fb8b82e8e259$var$TimerContext = $9285fb8b82e8e259$var$react_1.default.createContext({
    ms: 0,
    s: 0,
    m: 0,
    h: 0,
    d: 0,
    formatValue: function(value) {
        return String(value);
    }
});
var $9285fb8b82e8e259$var$TimerValue = function(_a) {
    var unit = _a.unit, formatValue = _a.formatValue;
    return $9285fb8b82e8e259$var$react_1.default.createElement($9285fb8b82e8e259$var$Timer.Consumer, null, function(props) {
        var format = formatValue || props.formatValue;
        return format(props[unit]) || null;
    });
};
var $9285fb8b82e8e259$var$Milliseconds = function(props) {
    return $9285fb8b82e8e259$var$react_1.default.createElement($9285fb8b82e8e259$var$TimerValue, $9285fb8b82e8e259$var$__assign({
        unit: "ms"
    }, props));
};
var $9285fb8b82e8e259$var$Seconds = function(props) {
    return $9285fb8b82e8e259$var$react_1.default.createElement($9285fb8b82e8e259$var$TimerValue, $9285fb8b82e8e259$var$__assign({
        unit: "s"
    }, props));
};
var $9285fb8b82e8e259$var$Minutes = function(props) {
    return $9285fb8b82e8e259$var$react_1.default.createElement($9285fb8b82e8e259$var$TimerValue, $9285fb8b82e8e259$var$__assign({
        unit: "m"
    }, props));
};
var $9285fb8b82e8e259$var$Hours = function(props) {
    return $9285fb8b82e8e259$var$react_1.default.createElement($9285fb8b82e8e259$var$TimerValue, $9285fb8b82e8e259$var$__assign({
        unit: "h"
    }, props));
};
var $9285fb8b82e8e259$var$Days = function(props) {
    return $9285fb8b82e8e259$var$react_1.default.createElement($9285fb8b82e8e259$var$TimerValue, $9285fb8b82e8e259$var$__assign({
        unit: "d"
    }, props));
};
var $9285fb8b82e8e259$var$Timer = /** @class */ function(_super) {
    $9285fb8b82e8e259$var$__extends(Timer, _super);
    function Timer(props) {
        var _this = _super.call(this, props) || this;
        var _a = _this.props, initialTime = _a.initialTime, direction = _a.direction, timeToUpdate = _a.timeToUpdate, lastUnit = _a.lastUnit, checkpoints = _a.checkpoints;
        _this.timer = new $bJuL9.TimerModel({
            initialTime: initialTime,
            direction: direction,
            timeToUpdate: timeToUpdate,
            lastUnit: lastUnit,
            checkpoints: checkpoints,
            onChange: _this.setState.bind(_this)
        });
        _this.state = $9285fb8b82e8e259$var$__assign({}, _this.timer.timeParts, {
            timerState: "INITED"
        });
        _this.start = _this.start.bind(_this);
        _this.pause = _this.pause.bind(_this);
        _this.resume = _this.resume.bind(_this);
        _this.stop = _this.stop.bind(_this);
        _this.reset = _this.reset.bind(_this);
        _this.setTime = _this.setTime.bind(_this);
        _this.getTime = _this.getTime.bind(_this);
        _this.getTimerState = _this.getTimerState.bind(_this);
        _this.setDirection = _this.setDirection.bind(_this);
        _this.setCheckpoints = _this.setCheckpoints.bind(_this);
        return _this;
    }
    Timer.getUI = function(children, renderProps) {
        if (children === null) return null;
        if (Array.isArray(children) || $9285fb8b82e8e259$var$react_1.default.isValidElement(children)) return children;
        if (children.prototype && children.prototype.isReactComponent) return $9285fb8b82e8e259$var$react_1.default.createElement(children, renderProps);
        if (typeof children === "function") return children(renderProps);
        throw new Error("Please use one of the supported APIs for children");
    };
    Timer.prototype.componentDidMount = function() {
        var startImmediately = this.props.startImmediately;
        startImmediately && this.timer.start();
    };
    Timer.prototype.componentWillUnmount = function() {
        this.timer.stop();
    };
    Timer.prototype.render = function() {
        var _a = this, start = _a.start, pause = _a.pause, resume = _a.resume, stop = _a.stop, reset = _a.reset, getTime = _a.getTime, getTimerState = _a.getTimerState, setTime = _a.setTime, setDirection = _a.setDirection, setCheckpoints = _a.setCheckpoints;
        var _b = this.state, ms = _b.ms, s = _b.s, m = _b.m, h = _b.h, d = _b.d, timerState = _b.timerState;
        var _c = this.props, formatValue = _c.formatValue, children = _c.children;
        return $9285fb8b82e8e259$var$react_1.default.createElement($9285fb8b82e8e259$var$TimerContext.Provider, {
            value: {
                ms: ms,
                s: s,
                m: m,
                h: h,
                d: d,
                formatValue: formatValue
            }
        }, Timer.getUI(children, {
            start: start,
            resume: resume,
            pause: pause,
            stop: stop,
            reset: reset,
            getTime: getTime,
            getTimerState: getTimerState,
            setTime: setTime,
            setDirection: setDirection,
            setCheckpoints: setCheckpoints,
            timerState: timerState
        }));
    };
    Timer.prototype.setTime = function(time) {
        this.timer.setTime(time);
    };
    Timer.prototype.getTime = function() {
        return this.timer.getTime();
    };
    Timer.prototype.getTimerState = function() {
        return this.timer.state;
    };
    Timer.prototype.setDirection = function(direction) {
        this.timer.setDirection(direction);
    };
    Timer.prototype.setCheckpoints = function(checkpoints) {
        this.timer.setCheckpoints(checkpoints);
    };
    Timer.prototype.start = function() {
        this.timer.start();
        this.props.onStart();
    };
    Timer.prototype.stop = function() {
        this.timer.stop();
        this.props.onStop();
    };
    Timer.prototype.pause = function() {
        this.timer.pause();
        this.props.onPause();
    };
    Timer.prototype.reset = function() {
        this.timer.reset();
        this.props.onReset();
    };
    Timer.prototype.resume = function() {
        this.timer.resume();
        this.props.onResume();
    };
    Timer.Consumer = $9285fb8b82e8e259$var$TimerContext.Consumer;
    Timer.Milliseconds = $9285fb8b82e8e259$var$Milliseconds;
    Timer.Seconds = $9285fb8b82e8e259$var$Seconds;
    Timer.Minutes = $9285fb8b82e8e259$var$Minutes;
    Timer.Hours = $9285fb8b82e8e259$var$Hours;
    Timer.Days = $9285fb8b82e8e259$var$Days;
    Timer.defaultProps = {
        timeToUpdate: 1000,
        direction: "forward",
        initialTime: 0,
        startImmediately: true,
        lastUnit: "d",
        checkpoints: [],
        children: null,
        formatValue: function(value) {
            return String(value);
        },
        onStart: function() {},
        onResume: function() {},
        onPause: function() {},
        onStop: function() {},
        onReset: function() {}
    };
    return Timer;
}($9285fb8b82e8e259$var$react_1.default.PureComponent);
module.exports.default = $9285fb8b82e8e259$var$Timer;

});
parcelRegister("bJuL9", function(module, exports) {
"use strict";
var $88abc1e49cb576d4$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $88abc1e49cb576d4$var$getTimeParts_1 = $88abc1e49cb576d4$var$__importDefault((parcelRequire("7KPrJ")));

var $88abc1e49cb576d4$var$now_1 = $88abc1e49cb576d4$var$__importDefault((parcelRequire("d0Wgp")));

var $88abc1e49cb576d4$var$TimerState_1 = $88abc1e49cb576d4$var$__importDefault((parcelRequire("knL12")));
var $88abc1e49cb576d4$var$TimerModel = /** @class */ function() {
    function TimerModel(_a) {
        var initialTime = _a.initialTime, direction = _a.direction, timeToUpdate = _a.timeToUpdate, lastUnit = _a.lastUnit, checkpoints = _a.checkpoints, onChange = _a.onChange;
        this.internalTime = $88abc1e49cb576d4$var$now_1.default();
        this.initialTime = initialTime;
        this.time = initialTime;
        this.direction = direction;
        this.timeToUpdate = timeToUpdate;
        this.lastUnit = lastUnit;
        this.checkpoints = checkpoints;
        this.innerState = new $88abc1e49cb576d4$var$TimerState_1.default(onChange);
        this.onChange = onChange;
        this.timerId = null;
    }
    Object.defineProperty(TimerModel.prototype, "state", {
        get: function() {
            return this.innerState.getState();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TimerModel.prototype, "timeParts", {
        get: function() {
            return this.getTimeParts(this.computeTime());
        },
        enumerable: true,
        configurable: true
    });
    TimerModel.prototype.getTimeParts = function(time) {
        return $88abc1e49cb576d4$var$getTimeParts_1.default(time, this.lastUnit);
    };
    TimerModel.prototype.setTime = function(time) {
        this.internalTime = $88abc1e49cb576d4$var$now_1.default();
        this.initialTime = time;
        this.time = this.initialTime;
        this.onChange(this.getTimeParts(this.time));
    };
    TimerModel.prototype.getTime = function() {
        return this.time;
    };
    TimerModel.prototype.setLastUnit = function(lastUnit) {
        if (this.innerState.isPlaying()) {
            this.pause();
            this.lastUnit = lastUnit;
            this.resume(true);
        } else this.lastUnit = lastUnit;
    };
    TimerModel.prototype.setTimeToUpdate = function(interval) {
        if (this.innerState.isPlaying()) {
            this.pause();
            this.timeToUpdate = interval;
            this.resume();
        } else this.timeToUpdate = interval;
    };
    TimerModel.prototype.setDirection = function(direction) {
        this.direction = direction;
    };
    TimerModel.prototype.setCheckpoints = function(checkpoints) {
        this.checkpoints = checkpoints;
    };
    TimerModel.prototype.start = function() {
        if (this.innerState.setPlaying()) this.setTimerInterval(true);
    };
    TimerModel.prototype.resume = function(callImmediately) {
        if (callImmediately === void 0) callImmediately = false;
        if (!this.innerState.isStopped() && this.innerState.setPlaying()) this.setTimerInterval(callImmediately);
    };
    TimerModel.prototype.pause = function() {
        if (this.innerState.setPaused()) clearInterval(this.timerId);
    };
    TimerModel.prototype.stop = function() {
        if (this.innerState.setStopped()) clearInterval(this.timerId);
    };
    TimerModel.prototype.reset = function() {
        this.time = this.initialTime;
        this.onChange(this.getTimeParts(this.time));
    };
    TimerModel.prototype.setTimerInterval = function(callImmediately) {
        var _this = this;
        if (callImmediately === void 0) callImmediately = false;
        if (this.timerId) clearInterval(this.timerId);
        this.internalTime = $88abc1e49cb576d4$var$now_1.default();
        var repeatedFunc = function() {
            var oldTime = _this.time;
            var updatedTime = _this.computeTime();
            _this.onChange(_this.getTimeParts(updatedTime));
            _this.checkpoints.map(function(_a) {
                var time = _a.time, callback = _a.callback;
                var checkForForward = time > oldTime && time <= updatedTime;
                var checkForBackward = time < oldTime && time >= updatedTime;
                var checkIntersection = _this.direction === "backward" ? checkForBackward : checkForForward;
                if (checkIntersection) callback();
            });
        };
        callImmediately && this.onChange(this.getTimeParts(this.time));
        this.timerId = window.setInterval(repeatedFunc, this.timeToUpdate);
    };
    TimerModel.prototype.computeTime = function() {
        if (this.innerState.isPlaying()) {
            var currentInternalTime = $88abc1e49cb576d4$var$now_1.default();
            var delta = Math.abs(currentInternalTime - this.internalTime);
            switch(this.direction){
                case "forward":
                    this.time = this.time + delta;
                    this.internalTime = currentInternalTime;
                    return this.time;
                case "backward":
                    this.time = this.time - delta;
                    this.internalTime = currentInternalTime;
                    if (this.time < 0) {
                        this.stop();
                        return 0;
                    }
                    return this.time;
                default:
                    return this.time;
            }
        }
        return this.time;
    };
    return TimerModel;
}();
module.exports.TimerModel = $88abc1e49cb576d4$var$TimerModel;

});
parcelRegister("7KPrJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
function $5a54bc7462cc0363$var$getTimeParts(time, lastUnit) {
    var units = [
        "ms",
        "s",
        "m",
        "h",
        "d"
    ];
    var lastUnitIndex = units.findIndex(function(unit) {
        return unit === lastUnit;
    });
    var dividers = [
        1000,
        60,
        60,
        24,
        1
    ];
    var dividersAcc = [
        1,
        1000,
        60000,
        3600000,
        86400000
    ];
    var startValue = {
        ms: 0,
        s: 0,
        m: 0,
        h: 0,
        d: 0
    };
    var output = units.reduce(function(obj, unit, index) {
        if (index > lastUnitIndex) obj[unit] = 0;
        else if (index === lastUnitIndex) obj[unit] = Math.floor(time / dividersAcc[index]);
        else obj[unit] = Math.floor(time / dividersAcc[index]) % dividers[index];
        return obj;
    }, startValue);
    return output;
}
module.exports.default = $5a54bc7462cc0363$var$getTimeParts;

});

parcelRegister("d0Wgp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
function $97987862d461dc67$var$now() {
    if (typeof window === "undefined" || !("performance" in window)) return Date.now();
    return performance.now();
}
module.exports.default = $97987862d461dc67$var$now;

});

parcelRegister("knL12", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.INITED = "INITED";
module.exports.PLAYING = "PLAYING";
module.exports.PAUSED = "PAUSED";
module.exports.STOPPED = "STOPPED";
var $ed6a6cf6870d0a6a$var$TimerState = /** @class */ function() {
    function TimerState(onChangeStatus) {
        var _this = this;
        if (onChangeStatus === void 0) onChangeStatus = function(obj) {};
        this.state = module.exports.INITED;
        this.onChange = function() {
            return onChangeStatus({
                state: _this.state
            });
        };
        this.state = module.exports.INITED;
    }
    TimerState.prototype.getState = function() {
        return this.state;
    };
    TimerState.prototype.setInited = function() {
        if (this.state === module.exports.INITED) return false;
        this.state = module.exports.INITED;
        this.onChange();
        return true;
    };
    TimerState.prototype.isInited = function() {
        return this.state === module.exports.INITED;
    };
    TimerState.prototype.setPlaying = function() {
        if (this.state === module.exports.PLAYING) return false;
        this.state = module.exports.PLAYING;
        this.onChange();
        return true;
    };
    TimerState.prototype.isPlaying = function() {
        return this.state === module.exports.PLAYING;
    };
    TimerState.prototype.setPaused = function() {
        if (this.state !== module.exports.PLAYING) return false;
        this.state = module.exports.PAUSED;
        this.onChange();
        return true;
    };
    TimerState.prototype.isPaused = function() {
        return this.state === module.exports.PAUSED;
    };
    TimerState.prototype.setStopped = function() {
        if (this.state === module.exports.INITED) return false;
        this.state = module.exports.STOPPED;
        this.onChange();
        return true;
    };
    TimerState.prototype.isStopped = function() {
        return this.state === module.exports.STOPPED;
    };
    return TimerState;
}();
module.exports.default = $ed6a6cf6870d0a6a$var$TimerState;

});



parcelRegister("ccDAZ", function(module, exports) {

$parcel$export(module.exports, "endianness", () => $8e2551e033e95cb5$export$edf525f30916fbb8, (v) => $8e2551e033e95cb5$export$edf525f30916fbb8 = v);
$parcel$export(module.exports, "hostname", () => $8e2551e033e95cb5$export$640106f6dc7d2706, (v) => $8e2551e033e95cb5$export$640106f6dc7d2706 = v);
$parcel$export(module.exports, "loadavg", () => $8e2551e033e95cb5$export$3ea386628068cf62, (v) => $8e2551e033e95cb5$export$3ea386628068cf62 = v);
$parcel$export(module.exports, "uptime", () => $8e2551e033e95cb5$export$749d472264fad440, (v) => $8e2551e033e95cb5$export$749d472264fad440 = v);
$parcel$export(module.exports, "freemem", () => $8e2551e033e95cb5$export$8b931a48d9488767, (v) => $8e2551e033e95cb5$export$8b931a48d9488767 = v);
$parcel$export(module.exports, "totalmem", () => $8e2551e033e95cb5$export$9123f37609399513, (v) => $8e2551e033e95cb5$export$9123f37609399513 = v);
$parcel$export(module.exports, "cpus", () => $8e2551e033e95cb5$export$9b60beb643db4d69, (v) => $8e2551e033e95cb5$export$9b60beb643db4d69 = v);
$parcel$export(module.exports, "type", () => $8e2551e033e95cb5$export$bf9fb029d174d554, (v) => $8e2551e033e95cb5$export$bf9fb029d174d554 = v);
$parcel$export(module.exports, "release", () => $8e2551e033e95cb5$export$23d3fad09dc44362, (v) => $8e2551e033e95cb5$export$23d3fad09dc44362 = v);
$parcel$export(module.exports, "networkInterfaces", () => $8e2551e033e95cb5$export$d2f3c2f7e0c7dcf5, (v) => $8e2551e033e95cb5$export$d2f3c2f7e0c7dcf5 = v);
$parcel$export(module.exports, "getNetworkInterfaces", () => $8e2551e033e95cb5$export$3bf7c33313eba0fe, (v) => $8e2551e033e95cb5$export$3bf7c33313eba0fe = v);
$parcel$export(module.exports, "arch", () => $8e2551e033e95cb5$export$7925d89f138dad5b, (v) => $8e2551e033e95cb5$export$7925d89f138dad5b = v);
$parcel$export(module.exports, "platform", () => $8e2551e033e95cb5$export$722a64dea1b767dc, (v) => $8e2551e033e95cb5$export$722a64dea1b767dc = v);
$parcel$export(module.exports, "tmpdir", () => $8e2551e033e95cb5$export$9e6c06a7d47f9af7, (v) => $8e2551e033e95cb5$export$9e6c06a7d47f9af7 = v);
$parcel$export(module.exports, "tmpDir", () => $8e2551e033e95cb5$export$6b76988456c0292f, (v) => $8e2551e033e95cb5$export$6b76988456c0292f = v);
$parcel$export(module.exports, "EOL", () => $8e2551e033e95cb5$export$266d3b9babd1fc45, (v) => $8e2551e033e95cb5$export$266d3b9babd1fc45 = v);
$parcel$export(module.exports, "homedir", () => $8e2551e033e95cb5$export$c1d46b5ea6262c0b, (v) => $8e2551e033e95cb5$export$c1d46b5ea6262c0b = v);
var $8e2551e033e95cb5$export$edf525f30916fbb8;
var $8e2551e033e95cb5$export$640106f6dc7d2706;
var $8e2551e033e95cb5$export$3ea386628068cf62;
var $8e2551e033e95cb5$export$749d472264fad440;
var $8e2551e033e95cb5$export$8b931a48d9488767;
var $8e2551e033e95cb5$export$9123f37609399513;
var $8e2551e033e95cb5$export$9b60beb643db4d69;
var $8e2551e033e95cb5$export$bf9fb029d174d554;
var $8e2551e033e95cb5$export$23d3fad09dc44362;
var $8e2551e033e95cb5$export$d2f3c2f7e0c7dcf5;
var $8e2551e033e95cb5$export$3bf7c33313eba0fe;
var $8e2551e033e95cb5$export$7925d89f138dad5b;
var $8e2551e033e95cb5$export$722a64dea1b767dc;
var $8e2551e033e95cb5$export$9e6c06a7d47f9af7;
var $8e2551e033e95cb5$export$6b76988456c0292f;
var $8e2551e033e95cb5$export$266d3b9babd1fc45;
var $8e2551e033e95cb5$export$c1d46b5ea6262c0b;
$8e2551e033e95cb5$export$edf525f30916fbb8 = function() {
    return "LE";
};
$8e2551e033e95cb5$export$640106f6dc7d2706 = function() {
    if (typeof location !== "undefined") return location.hostname;
    else return "";
};
$8e2551e033e95cb5$export$3ea386628068cf62 = function() {
    return [];
};
$8e2551e033e95cb5$export$749d472264fad440 = function() {
    return 0;
};
$8e2551e033e95cb5$export$8b931a48d9488767 = function() {
    return Number.MAX_VALUE;
};
$8e2551e033e95cb5$export$9123f37609399513 = function() {
    return Number.MAX_VALUE;
};
$8e2551e033e95cb5$export$9b60beb643db4d69 = function() {
    return [];
};
$8e2551e033e95cb5$export$bf9fb029d174d554 = function() {
    return "Browser";
};
$8e2551e033e95cb5$export$23d3fad09dc44362 = function() {
    if (typeof navigator !== "undefined") return navigator.appVersion;
    return "";
};
$8e2551e033e95cb5$export$d2f3c2f7e0c7dcf5 = $8e2551e033e95cb5$export$3bf7c33313eba0fe = function() {
    return {};
};
$8e2551e033e95cb5$export$7925d89f138dad5b = function() {
    return "javascript";
};
$8e2551e033e95cb5$export$722a64dea1b767dc = function() {
    return "browser";
};
$8e2551e033e95cb5$export$9e6c06a7d47f9af7 = $8e2551e033e95cb5$export$6b76988456c0292f = function() {
    return "/tmp";
};
$8e2551e033e95cb5$export$266d3b9babd1fc45 = "\n";
$8e2551e033e95cb5$export$c1d46b5ea6262c0b = function() {
    return "/";
};

});

parcelRegister("f4hFs", function(module, exports) {
module.exports = new URL("hacker1.c169071f.jpg", import.meta.url).toString();

});

parcelRegister("iljQ4", function(module, exports) {
module.exports = new URL("hacker2.83b562ab.jpg", import.meta.url).toString();

});

parcelRegister("cG8ML", function(module, exports) {
module.exports = new URL("hacker3.eedd591d.jpg", import.meta.url).toString();

});

parcelRegister("lPRSF", function(module, exports) {
module.exports = new URL("hacker4.0dd1e902.jpg", import.meta.url).toString();

});

parcelRegister("2lenI", function(module, exports) {
module.exports = new URL("hacker5.784874fa.jpg", import.meta.url).toString();

});

parcelRegister("bfsSE", function(module, exports) {
module.exports = new URL("games1.6ecf8289.jpg", import.meta.url).toString();

});

parcelRegister("4Rla9", function(module, exports) {
module.exports = new URL("games2.175c2a3a.jpg", import.meta.url).toString();

});

parcelRegister("lJVrR", function(module, exports) {
module.exports = new URL("games3.e28c04ce.jpg", import.meta.url).toString();

});

parcelRegister("4a7WQ", function(module, exports) {
module.exports = new URL("games4.cf1ab097.gif", import.meta.url).toString();

});

parcelRegister("43d45", function(module, exports) {
module.exports = new URL("games5.30bb9efe.jpg", import.meta.url).toString();

});

parcelRegister("cRoLX", function(module, exports) {
module.exports = new URL("websites1.a8c4e8ab.png", import.meta.url).toString();

});

parcelRegister("2arr6", function(module, exports) {
module.exports = new URL("websites2.ad0a3910.png", import.meta.url).toString();

});

parcelRegister("l4sQG", function(module, exports) {
module.exports = new URL("websites3.5e7b3816.png", import.meta.url).toString();

});

parcelRegister("94dUm", function(module, exports) {
module.exports = new URL("websites4.4a3076c4.png", import.meta.url).toString();

});

parcelRegister("lerRi", function(module, exports) {
module.exports = new URL("websites5.6cfe86c7.gif", import.meta.url).toString();

});

parcelRegister("lQ1VG", function(module, exports) {
module.exports = new URL("minecraft1.e68d8785.jpg", import.meta.url).toString();

});

parcelRegister("aldLf", function(module, exports) {
module.exports = new URL("minecraft2.46841300.png", import.meta.url).toString();

});

parcelRegister("eXNbI", function(module, exports) {
module.exports = new URL("minecraft3.f74457c0.png", import.meta.url).toString();

});

parcelRegister("5Ew7i", function(module, exports) {
module.exports = new URL("minecraft4.98bfc645.png", import.meta.url).toString();

});

parcelRegister("c450g", function(module, exports) {
module.exports = new URL("minecraft5.eaba49c9.png", import.meta.url).toString();

});

parcelRegister("fnvRB", function(module, exports) {
module.exports = new URL("unix1.406b5165.jpg", import.meta.url).toString();

});

parcelRegister("4UFcN", function(module, exports) {
module.exports = new URL("unix2.c5d4e780.jpg", import.meta.url).toString();

});

parcelRegister("63IfY", function(module, exports) {
module.exports = new URL("unix3.f848b279.gif", import.meta.url).toString();

});

parcelRegister("9hhnE", function(module, exports) {
module.exports = new URL("unix4.82bbc5ab.jpg", import.meta.url).toString();

});

parcelRegister("9N0fG", function(module, exports) {
module.exports = new URL("unix5.b1629aaa.jpg", import.meta.url).toString();

});

parcelRegister("6naD7", function(module, exports) {
module.exports = new URL("hacker_movies1.ff8310cc.jpg", import.meta.url).toString();

});

parcelRegister("1wxRH", function(module, exports) {
module.exports = new URL("hacker_movies2.d4a356b5.png", import.meta.url).toString();

});

parcelRegister("3mC8v", function(module, exports) {
module.exports = new URL("hacker_movies3.a7c4db7f.jpg", import.meta.url).toString();

});

parcelRegister("7NrCX", function(module, exports) {
module.exports = new URL("hacker_movies4.54663567.jpg", import.meta.url).toString();

});

parcelRegister("8x447", function(module, exports) {
module.exports = new URL("hacker_movies5.9fa17ae4.jpg", import.meta.url).toString();

});

parcelRegister("18e0I", function(module, exports) {
module.exports = new URL("website4.ba6d6ae5.png", import.meta.url).toString();

});

parcelRegister("dBFBN", function(module, exports) {
"use strict";
var $9e7f01a94196eb1c$var$__makeTemplateObject = module.exports && module.exports.__makeTemplateObject || function(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
};
var $9e7f01a94196eb1c$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $9e7f01a94196eb1c$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result["default"] = mod;
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

/** @jsx jsx */ var $9e7f01a94196eb1c$var$React = $9e7f01a94196eb1c$var$__importStar((parcelRequire("acw62")));

var $f5Egd = parcelRequire("f5Egd");
var $6xSYO = parcelRequire("6xSYO");

var $lFbni = parcelRequire("lFbni");
var $9e7f01a94196eb1c$var$long = $f5Egd.keyframes($9e7f01a94196eb1c$var$templateObject_1 || ($9e7f01a94196eb1c$var$templateObject_1 = $9e7f01a94196eb1c$var$__makeTemplateObject([
    "\n  0% {left: -35%;right: 100%}\n  60% {left: 100%;right: -90%}\n  100% {left: 100%;right: -90%}\n"
], [
    "\n  0% {left: -35%;right: 100%}\n  60% {left: 100%;right: -90%}\n  100% {left: 100%;right: -90%}\n"
])));
var $9e7f01a94196eb1c$var$short = $f5Egd.keyframes($9e7f01a94196eb1c$var$templateObject_2 || ($9e7f01a94196eb1c$var$templateObject_2 = $9e7f01a94196eb1c$var$__makeTemplateObject([
    "\n  0% {left: -200%;right: 100%}\n  60% {left: 107%;right: -8%}\n  100% {left: 107%;right: -8%}\n"
], [
    "\n  0% {left: -200%;right: 100%}\n  60% {left: 107%;right: -8%}\n  100% {left: 107%;right: -8%}\n"
])));
var $9e7f01a94196eb1c$var$Loader = /** @class */ function(_super) {
    $9e7f01a94196eb1c$var$__extends(Loader, _super);
    function Loader() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.style = function(i) {
            var _a = _this.props, height = _a.height, color = _a.color, heightUnit = _a.heightUnit;
            return $6xSYO.default($9e7f01a94196eb1c$var$templateObject_3 || ($9e7f01a94196eb1c$var$templateObject_3 = $9e7f01a94196eb1c$var$__makeTemplateObject([
                "\n      position: absolute;\n      height: ",
                ";\n      overflow: hidden;\n      background-color: ",
                ";\n      background-clip: padding-box;\n      display: block;\n      border-radius: 2px;\n      will-change: left, right;\n      animation-fill-mode: forwards;\n      animation: ",
                " 2.1s ",
                "\n        ",
                "\n        infinite;\n    "
            ], [
                "\n      position: absolute;\n      height: ",
                ";\n      overflow: hidden;\n      background-color: ",
                ";\n      background-clip: padding-box;\n      display: block;\n      border-radius: 2px;\n      will-change: left, right;\n      animation-fill-mode: forwards;\n      animation: ",
                " 2.1s ",
                "\n        ",
                "\n        infinite;\n    "
            ])), "" + height + heightUnit, color, i === 1 ? $9e7f01a94196eb1c$var$long : $9e7f01a94196eb1c$var$short, i === 2 ? "1.15s" : "", i === 1 ? "cubic-bezier(0.65, 0.815, 0.735, 0.395)" : "cubic-bezier(0.165, 0.84, 0.44, 1)");
        };
        _this.wrapper = function() {
            var _a = _this.props, width = _a.width, height = _a.height, color = _a.color, heightUnit = _a.heightUnit, widthUnit = _a.widthUnit;
            return $6xSYO.default($9e7f01a94196eb1c$var$templateObject_4 || ($9e7f01a94196eb1c$var$templateObject_4 = $9e7f01a94196eb1c$var$__makeTemplateObject([
                "\n      position: relative;\n      width: ",
                ";\n      height: ",
                ";\n      overflow: hidden;\n      background-color: ",
                ";\n      background-clip: padding-box;\n    "
            ], [
                "\n      position: relative;\n      width: ",
                ";\n      height: ",
                ";\n      overflow: hidden;\n      background-color: ",
                ";\n      background-clip: padding-box;\n    "
            ])), "" + width + widthUnit, "" + height + heightUnit, $lFbni.calculateRgba(color, 0.2));
        };
        return _this;
    }
    Loader.prototype.render = function() {
        var _a = this.props, loading = _a.loading, css = _a.css;
        return loading ? $f5Egd.jsx("div", {
            css: [
                this.wrapper(),
                css
            ]
        }, $f5Egd.jsx("div", {
            css: this.style(1)
        }), $f5Egd.jsx("div", {
            css: this.style(2)
        })) : null;
    };
    Loader.defaultProps = $lFbni.heightWidthDefaults(4, 100);
    return Loader;
}($9e7f01a94196eb1c$var$React.PureComponent);
module.exports.Loader = $9e7f01a94196eb1c$var$Loader;
module.exports.default = $9e7f01a94196eb1c$var$Loader;
var $9e7f01a94196eb1c$var$templateObject_1, $9e7f01a94196eb1c$var$templateObject_2, $9e7f01a94196eb1c$var$templateObject_3, $9e7f01a94196eb1c$var$templateObject_4;

});
parcelRegister("f5Egd", function(module, exports) {

$parcel$export(module.exports, "keyframes", () => $afc68d865495bec5$export$d25ddfdf17c3ad3e);
$parcel$export(module.exports, "jsx", () => $afc68d865495bec5$export$c8a8987d4410bf2d);
$parcel$export(module.exports, "css", () => (parcelRequire("6xSYO")).default);

var $g7ajw = parcelRequire("g7ajw");

var $acw62 = parcelRequire("acw62");
parcelRequire("czXz2");

var $vYtsV = parcelRequire("vYtsV");

var $boAuA = parcelRequire("boAuA");

var $cXgB3 = parcelRequire("cXgB3");

var $gGJqS = parcelRequire("gGJqS");

var $6xSYO = parcelRequire("6xSYO");
var $afc68d865495bec5$export$c8a8987d4410bf2d = function jsx(type, props) {
    var args = arguments;
    if (props == null || !(0, $vYtsV.h).call(props, "css")) // $FlowFixMe
    return (0, $acw62.createElement).apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $vYtsV.E);
    createElementArgArray[1] = (0, $vYtsV.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
     // $FlowFixMe
    return (0, $acw62.createElement).apply(null, createElementArgArray);
};
var $afc68d865495bec5$var$warnedAboutCssPropForGlobal = false;
var $afc68d865495bec5$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $vYtsV.w)(function(props, cache) {
    var styles = props.styles;
    if (typeof styles === "function") return /*#__PURE__*/ (0, $acw62.createElement)((0, $vYtsV.T).Consumer, null, function(theme) {
        var serialized = (0, $cXgB3.serializeStyles)([
            styles(theme)
        ]);
        return /*#__PURE__*/ (0, $acw62.createElement)($afc68d865495bec5$var$InnerGlobal, {
            serialized: serialized,
            cache: cache
        });
    });
    var serialized = (0, $cXgB3.serializeStyles)([
        styles
    ]);
    return /*#__PURE__*/ (0, $acw62.createElement)($afc68d865495bec5$var$InnerGlobal, {
        serialized: serialized,
        cache: cache
    });
});
// maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $afc68d865495bec5$var$InnerGlobal = /*#__PURE__*/ function(_React$Component) {
    (0, $g7ajw.default)(InnerGlobal, _React$Component);
    function InnerGlobal(props, context, updater) {
        return _React$Component.call(this, props, context, updater) || this;
    }
    var _proto = InnerGlobal.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.sheet = new (0, $gGJqS.StyleSheet)({
            key: this.props.cache.key + "-global",
            nonce: this.props.cache.sheet.nonce,
            container: this.props.cache.sheet.container
        }); // $FlowFixMe
        var node = document.querySelector("style[data-emotion-" + this.props.cache.key + '="' + this.props.serialized.name + '"]');
        if (node !== null) this.sheet.tags.push(node);
        if (this.props.cache.sheet.tags.length) this.sheet.before = this.props.cache.sheet.tags[0];
        this.insertStyles();
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (prevProps.serialized.name !== this.props.serialized.name) this.insertStyles();
    };
    _proto.insertStyles = function insertStyles$1() {
        if (this.props.serialized.next !== undefined) // insert keyframes
        (0, $boAuA.insertStyles)(this.props.cache, this.props.serialized.next, true);
        if (this.sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = this.sheet.tags[this.sheet.tags.length - 1].nextElementSibling;
            this.sheet.before = element;
            this.sheet.flush();
        }
        this.props.cache.insert("", this.props.serialized, this.sheet, false);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.sheet.flush();
    };
    _proto.render = function render() {
        return null;
    };
    return InnerGlobal;
}((0, $acw62.Component));
var $afc68d865495bec5$export$d25ddfdf17c3ad3e = function keyframes() {
    var insertable = (0, $6xSYO.default).apply(void 0, arguments);
    var name = "animation-" + insertable.name; // $FlowFixMe
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
};
var $afc68d865495bec5$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = "";
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case "boolean":
                break;
            case "object":
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = "";
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += " ");
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += " ");
            cls += toAdd;
        }
    }
    return cls;
};
function $afc68d865495bec5$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $boAuA.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $afc68d865495bec5$var$Noop = function Noop() {
    return null;
};
var $afc68d865495bec5$export$9b9c0f9d9f3552b8 = (0, $vYtsV.w)(function(props, context) {
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $vYtsV.T).Consumer, null, function(theme) {
        var hasRendered = false;
        var css = function css() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            var serialized = (0, $cXgB3.serializeStyles)(args, context.registered);
            (0, $boAuA.insertStyles)(context, serialized, false);
            return context.key + "-" + serialized.name;
        };
        var cx = function cx() {
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            return $afc68d865495bec5$var$merge(context.registered, css, $afc68d865495bec5$var$classnames(args));
        };
        var content = {
            css: css,
            cx: cx,
            theme: theme
        };
        var ele = props.children(content);
        hasRendered = true;
        var possiblyStyleElement = /*#__PURE__*/ (0, $acw62.createElement)($afc68d865495bec5$var$Noop, null);
        return /*#__PURE__*/ (0, $acw62.createElement)((0, $acw62.Fragment), null, possiblyStyleElement, ele);
    });
});

});
parcelRegister("g7ajw", function(module, exports) {

$parcel$export(module.exports, "default", () => $bbb54ce93eb94a95$export$2e2bcd8739ae039);

var $VFVve = parcelRequire("VFVve");
function $bbb54ce93eb94a95$export$2e2bcd8739ae039(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    (0, $VFVve.default)(subClass, superClass);
}

});
parcelRegister("VFVve", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ad5d8b55fe970db$export$2e2bcd8739ae039);
function $0ad5d8b55fe970db$export$2e2bcd8739ae039(o, p) {
    $0ad5d8b55fe970db$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $0ad5d8b55fe970db$export$2e2bcd8739ae039(o, p);
}

});


parcelRegister("czXz2", function(module, exports) {

$parcel$export(module.exports, "default", () => $9286f517b9779ada$export$2e2bcd8739ae039);

var $gGJqS = parcelRequire("gGJqS");

var $demXJ = parcelRequire("demXJ");
parcelRequire("55EI3");
// https://github.com/thysultan/stylis.js/tree/master/plugins/rule-sheet
// inlined to avoid umd wrapper and peerDep warnings/installing stylis
// since we use stylis after closure compiler
var $9286f517b9779ada$var$delimiter = "/*|*/";
var $9286f517b9779ada$var$needle = $9286f517b9779ada$var$delimiter + "}";
function $9286f517b9779ada$var$toSheet(block) {
    if (block) $9286f517b9779ada$var$Sheet.current.insert(block + "}");
}
var $9286f517b9779ada$var$Sheet = {
    current: null
};
var $9286f517b9779ada$var$ruleSheet = function ruleSheet(context, content, selectors, parents, line, column, length, ns, depth, at) {
    switch(context){
        // property
        case 1:
            switch(content.charCodeAt(0)){
                case 64:
                    // @import
                    $9286f517b9779ada$var$Sheet.current.insert(content + ";");
                    return "";
                // charcode for l
                case 108:
                    // charcode for b
                    // this ignores label
                    if (content.charCodeAt(2) === 98) return "";
            }
            break;
        // selector
        case 2:
            if (ns === 0) return content + $9286f517b9779ada$var$delimiter;
            break;
        // at-rule
        case 3:
            switch(ns){
                // @font-face, @page
                case 102:
                case 112:
                    $9286f517b9779ada$var$Sheet.current.insert(selectors[0] + content);
                    return "";
                default:
                    return content + (at === 0 ? $9286f517b9779ada$var$delimiter : "");
            }
        case -2:
            content.split($9286f517b9779ada$var$needle).forEach($9286f517b9779ada$var$toSheet);
    }
};
var $9286f517b9779ada$var$createCache = function createCache(options) {
    if (options === undefined) options = {};
    var key = options.key || "css";
    var stylisOptions;
    if (options.prefix !== undefined) stylisOptions = {
        prefix: options.prefix
    };
    var stylis = new (0, $demXJ.default)(stylisOptions);
    var inserted = {}; // $FlowFixMe
    var container;
    container = options.container || document.head;
    var nodes = document.querySelectorAll("style[data-emotion-" + key + "]");
    Array.prototype.forEach.call(nodes, function(node) {
        var attrib = node.getAttribute("data-emotion-" + key); // $FlowFixMe
        attrib.split(" ").forEach(function(id) {
            inserted[id] = true;
        });
        if (node.parentNode !== container) container.appendChild(node);
    });
    var _insert;
    stylis.use(options.stylisPlugins)($9286f517b9779ada$var$ruleSheet);
    _insert = function insert(selector, serialized, sheet, shouldCache) {
        var name = serialized.name;
        $9286f517b9779ada$var$Sheet.current = sheet;
        var map;
        stylis(selector, serialized.styles);
        if (shouldCache) cache.inserted[name] = true;
    };
    var commentStart, commentEnd;
    var cache = {
        key: key,
        sheet: new (0, $gGJqS.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    return cache;
};
var $9286f517b9779ada$export$2e2bcd8739ae039 = $9286f517b9779ada$var$createCache;

});
parcelRegister("gGJqS", function(module, exports) {

$parcel$export(module.exports, "StyleSheet", () => $c263cf8568d025ad$export$9d753cd7ae895cce);
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ // $FlowFixMe
function $c263cf8568d025ad$var$sheetForTag(tag) {
    if (tag.sheet) // $FlowFixMe
    return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) // $FlowFixMe
        return document.styleSheets[i];
    }
}
function $c263cf8568d025ad$var$createStyleElement(options) {
    var tag = document.createElement("style");
    tag.setAttribute("data-emotion", options.key);
    if (options.nonce !== undefined) tag.setAttribute("nonce", options.nonce);
    tag.appendChild(document.createTextNode(""));
    return tag;
}
var $c263cf8568d025ad$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    function StyleSheet(options) {
        this.isSpeedy = options.speedy === undefined ? true : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) {
            var _tag = $c263cf8568d025ad$var$createStyleElement(this);
            var before;
            if (this.tags.length === 0) before = this.before;
            else before = this.tags[this.tags.length - 1].nextSibling;
            this.container.insertBefore(_tag, before);
            this.tags.push(_tag);
        }
        var tag = this.tags[this.tags.length - 1];
        if (this.isSpeedy) {
            var sheet = $c263cf8568d025ad$var$sheetForTag(tag);
            try {
                // this is a really hot path
                // we check the second character first because having "i"
                // as the second character will happen less often than
                // having "@" as the first character
                var isImportRule = rule.charCodeAt(1) === 105 && rule.charCodeAt(0) === 64; // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, // otherwise there will be an error
                // technically this means that the @import rules will
                // _usually_(not always since there could be multiple style tags)
                // be the first ones in prod and generally later in dev
                // this shouldn't really matter in the real world though
                // @import is generally only used for font faces from google fonts and etc.
                // so while this could be technically correct then it would be slower and larger
                // for a tiny bit of correctness that won't matter in the real world
                isImportRule ? 0 : sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        // $FlowFixMe
        this.tags.forEach(function(tag) {
            return tag.parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

});

parcelRegister("demXJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $9a1e650477d9d52e$export$2e2bcd8739ae039);
function $9a1e650477d9d52e$var$stylis_min(W) {
    function M(d, c, e, h, a) {
        for(var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = "", p = "", F = "", G = "", C; l < B;){
            g = e.charCodeAt(l);
            l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);
            if (0 === b + n + v + m) {
                if (l === J && (0 < r && (f = f.replace(N, "")), 0 < f.trim().length)) {
                    switch(g){
                        case 32:
                        case 9:
                        case 59:
                        case 13:
                        case 10:
                            break;
                        default:
                            f += e.charAt(l);
                    }
                    g = 59;
                }
                switch(g){
                    case 123:
                        f = f.trim();
                        q = f.charCodeAt(0);
                        k = 1;
                        for(t = ++l; l < B;){
                            switch(g = e.charCodeAt(l)){
                                case 123:
                                    k++;
                                    break;
                                case 125:
                                    k--;
                                    break;
                                case 47:
                                    switch(g = e.charCodeAt(l + 1)){
                                        case 42:
                                        case 47:
                                            a: {
                                                for(u = l + 1; u < J; ++u)switch(e.charCodeAt(u)){
                                                    case 47:
                                                        if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
                                                            l = u + 1;
                                                            break a;
                                                        }
                                                        break;
                                                    case 10:
                                                        if (47 === g) {
                                                            l = u + 1;
                                                            break a;
                                                        }
                                                }
                                                l = u;
                                            }
                                    }
                                    break;
                                case 91:
                                    g++;
                                case 40:
                                    g++;
                                case 34:
                                case 39:
                                    for(; l++ < J && e.charCodeAt(l) !== g;);
                            }
                            if (0 === k) break;
                            l++;
                        }
                        k = e.substring(t, l);
                        0 === q && (q = (f = f.replace(ca, "").trim()).charCodeAt(0));
                        switch(q){
                            case 64:
                                0 < r && (f = f.replace(N, ""));
                                g = f.charCodeAt(1);
                                switch(g){
                                    case 100:
                                    case 109:
                                    case 115:
                                    case 45:
                                        r = c;
                                        break;
                                    default:
                                        r = O;
                                }
                                k = M(c, r, k, g, a + 1);
                                t = k.length;
                                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(""), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ""));
                                if (0 < t) switch(g){
                                    case 115:
                                        f = f.replace(da, ea);
                                    case 100:
                                    case 109:
                                    case 45:
                                        k = f + "{" + k + "}";
                                        break;
                                    case 107:
                                        f = f.replace(fa, "$1 $2");
                                        k = f + "{" + k + "}";
                                        k = 1 === w || 2 === w && L("@" + k, 3) ? "@-webkit-" + k + "@" + k : "@" + k;
                                        break;
                                    default:
                                        k = f + k, 112 === h && (k = (p += k, ""));
                                }
                                else k = "";
                                break;
                            default:
                                k = M(c, X(c, f, I), k, h, a + 1);
                        }
                        F += k;
                        k = I = r = u = q = 0;
                        f = "";
                        g = e.charCodeAt(++l);
                        break;
                    case 125:
                    case 59:
                        f = (0 < r ? f.replace(N, "") : f).trim();
                        if (1 < (t = f.length)) switch(0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(" ", ":")).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = "\x00\x00"), q = f.charCodeAt(0), g = f.charCodeAt(1), q){
                            case 0:
                                break;
                            case 64:
                                if (105 === g || 99 === g) {
                                    G += f + e.charAt(l);
                                    break;
                                }
                            default:
                                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
                        }
                        I = r = u = q = 0;
                        f = "";
                        g = e.charCodeAt(++l);
                }
            }
            switch(g){
                case 13:
                case 10:
                    47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += "\x00");
                    0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
                    z = 1;
                    D++;
                    break;
                case 59:
                case 125:
                    if (0 === b + n + v + m) {
                        z++;
                        break;
                    }
                default:
                    z++;
                    y = e.charAt(l);
                    switch(g){
                        case 9:
                        case 32:
                            if (0 === n + m + b) switch(x){
                                case 44:
                                case 58:
                                case 9:
                                case 32:
                                    y = "";
                                    break;
                                default:
                                    32 !== g && (y = " ");
                            }
                            break;
                        case 0:
                            y = "\\0";
                            break;
                        case 12:
                            y = "\\f";
                            break;
                        case 11:
                            y = "\\v";
                            break;
                        case 38:
                            0 === n + b + m && (r = I = 1, y = "\f" + y);
                            break;
                        case 108:
                            if (0 === n + b + m + E && 0 < u) switch(l - u){
                                case 2:
                                    112 === x && 58 === e.charCodeAt(l - 3) && (E = x);
                                case 8:
                                    111 === K && (E = K);
                            }
                            break;
                        case 58:
                            0 === n + b + m && (u = l);
                            break;
                        case 44:
                            0 === b + v + n + m && (r = 1, y += "\r");
                            break;
                        case 34:
                        case 39:
                            0 === b && (n = n === g ? 0 : 0 === n ? g : n);
                            break;
                        case 91:
                            0 === n + b + v && m++;
                            break;
                        case 93:
                            0 === n + b + v && m--;
                            break;
                        case 41:
                            0 === n + b + m && v--;
                            break;
                        case 40:
                            if (0 === n + b + m) {
                                if (0 === q) switch(2 * x + 3 * K){
                                    case 533:
                                        break;
                                    default:
                                        q = 1;
                                }
                                v++;
                            }
                            break;
                        case 64:
                            0 === b + v + n + m + u + k && (k = 1);
                            break;
                        case 42:
                        case 47:
                            if (!(0 < n + m + v)) switch(b){
                                case 0:
                                    switch(2 * g + 3 * e.charCodeAt(l + 1)){
                                        case 235:
                                            b = 47;
                                            break;
                                        case 220:
                                            t = l, b = 42;
                                    }
                                    break;
                                case 42:
                                    47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = "", b = 0);
                            }
                    }
                    0 === b && (f += y);
            }
            K = x;
            x = g;
            l++;
        }
        t = p.length;
        if (0 < t) {
            r = c;
            if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
            p = r.join(",") + "{" + p + "}";
            if (0 !== w * E) {
                2 !== w || L(p, 2) || (E = 0);
                switch(E){
                    case 111:
                        p = p.replace(ha, ":-moz-$1") + p;
                        break;
                    case 112:
                        p = p.replace(Q, "::-webkit-input-$1") + p.replace(Q, "::-moz-$1") + p.replace(Q, ":-ms-input-$1") + p;
                }
                E = 0;
            }
        }
        return G + p + F;
    }
    function X(d, c, e) {
        var h = c.trim().split(ia);
        c = h;
        var a = h.length, m = d.length;
        switch(m){
            case 0:
            case 1:
                var b = 0;
                for(d = 0 === m ? "" : d[0] + " "; b < a; ++b)c[b] = Z(d, c[b], e).trim();
                break;
            default:
                var v = b = 0;
                for(c = []; b < a; ++b)for(var n = 0; n < m; ++n)c[v++] = Z(d[n] + " ", h[b], e).trim();
        }
        return c;
    }
    function Z(d, c, e) {
        var h = c.charCodeAt(0);
        33 > h && (h = (c = c.trim()).charCodeAt(0));
        switch(h){
            case 38:
                return c.replace(F, "$1" + d.trim());
            case 58:
                return d.trim() + c.replace(F, "$1" + d.trim());
            default:
                if (0 < 1 * e && 0 < c.indexOf("\f")) return c.replace(F, (58 === d.charCodeAt(0) ? "" : "$1") + d.trim());
        }
        return d + c;
    }
    function P(d, c, e, h) {
        var a = d + ";", m = 2 * c + 3 * e + 4 * h;
        if (944 === m) {
            d = a.indexOf(":", 9) + 1;
            var b = a.substring(d, a.length - 1).trim();
            b = a.substring(0, d).trim() + b + ";";
            return 1 === w || 2 === w && L(b, 1) ? "-webkit-" + b + b : b;
        }
        if (0 === w || 2 === w && !L(a, 1)) return a;
        switch(m){
            case 1015:
                return 97 === a.charCodeAt(10) ? "-webkit-" + a + a : a;
            case 951:
                return 116 === a.charCodeAt(3) ? "-webkit-" + a + a : a;
            case 963:
                return 110 === a.charCodeAt(5) ? "-webkit-" + a + a : a;
            case 1009:
                if (100 !== a.charCodeAt(4)) break;
            case 969:
            case 942:
                return "-webkit-" + a + a;
            case 978:
                return "-webkit-" + a + "-moz-" + a + a;
            case 1019:
            case 983:
                return "-webkit-" + a + "-moz-" + a + "-ms-" + a + a;
            case 883:
                if (45 === a.charCodeAt(8)) return "-webkit-" + a + a;
                if (0 < a.indexOf("image-set(", 11)) return a.replace(ja, "$1-webkit-$2") + a;
                break;
            case 932:
                if (45 === a.charCodeAt(4)) switch(a.charCodeAt(5)){
                    case 103:
                        return "-webkit-box-" + a.replace("-grow", "") + "-webkit-" + a + "-ms-" + a.replace("grow", "positive") + a;
                    case 115:
                        return "-webkit-" + a + "-ms-" + a.replace("shrink", "negative") + a;
                    case 98:
                        return "-webkit-" + a + "-ms-" + a.replace("basis", "preferred-size") + a;
                }
                return "-webkit-" + a + "-ms-" + a + a;
            case 964:
                return "-webkit-" + a + "-ms-flex-" + a + a;
            case 1023:
                if (99 !== a.charCodeAt(8)) break;
                b = a.substring(a.indexOf(":", 15)).replace("flex-", "").replace("space-between", "justify");
                return "-webkit-box-pack" + b + "-webkit-" + a + "-ms-flex-pack" + b + a;
            case 1005:
                return ka.test(a) ? a.replace(aa, ":-webkit-") + a.replace(aa, ":-moz-") + a : a;
            case 1e3:
                b = a.substring(13).trim();
                c = b.indexOf("-") + 1;
                switch(b.charCodeAt(0) + b.charCodeAt(c)){
                    case 226:
                        b = a.replace(G, "tb");
                        break;
                    case 232:
                        b = a.replace(G, "tb-rl");
                        break;
                    case 220:
                        b = a.replace(G, "lr");
                        break;
                    default:
                        return a;
                }
                return "-webkit-" + a + "-ms-" + b + a;
            case 1017:
                if (-1 === a.indexOf("sticky", 9)) break;
            case 975:
                c = (a = d).length - 10;
                b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(":", 7) + 1).trim();
                switch(m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)){
                    case 203:
                        if (111 > b.charCodeAt(8)) break;
                    case 115:
                        a = a.replace(b, "-webkit-" + b) + ";" + a;
                        break;
                    case 207:
                    case 102:
                        a = a.replace(b, "-webkit-" + (102 < m ? "inline-" : "") + "box") + ";" + a.replace(b, "-webkit-" + b) + ";" + a.replace(b, "-ms-" + b + "box") + ";" + a;
                }
                return a + ";";
            case 938:
                if (45 === a.charCodeAt(5)) switch(a.charCodeAt(6)){
                    case 105:
                        return b = a.replace("-items", ""), "-webkit-" + a + "-webkit-box-" + b + "-ms-flex-" + b + a;
                    case 115:
                        return "-webkit-" + a + "-ms-flex-item-" + a.replace(ba, "") + a;
                    default:
                        return "-webkit-" + a + "-ms-flex-line-pack" + a.replace("align-content", "").replace(ba, "") + a;
                }
                break;
            case 973:
            case 989:
                if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;
            case 931:
            case 953:
                if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(":") + 1)).charCodeAt(0) ? P(d.replace("stretch", "fill-available"), c, e, h).replace(":fill-available", ":stretch") : a.replace(b, "-webkit-" + b) + a.replace(b, "-moz-" + b.replace("fill-", "")) + a;
                break;
            case 962:
                if (a = "-webkit-" + a + (102 === a.charCodeAt(5) ? "-ms-" + a : "") + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf("transform", 10)) return a.substring(0, a.indexOf(";", 27) + 1).replace(ma, "$1-webkit-$2") + a;
        }
        return a;
    }
    function L(d, c) {
        var e = d.indexOf(1 === c ? ":" : "{"), h = d.substring(0, 3 !== c ? e : 10);
        e = d.substring(e + 1, d.length - 1);
        return R(2 !== c ? h : h.replace(na, "$1"), e, c);
    }
    function ea(d, c) {
        var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
        return e !== c + ";" ? e.replace(oa, " or ($1)").substring(4) : "(" + c + ")";
    }
    function H(d, c, e, h, a, m, b, v, n, q) {
        for(var g = 0, x = c, w; g < A; ++g)switch(w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)){
            case void 0:
            case !1:
            case !0:
            case null:
                break;
            default:
                x = w;
        }
        if (x !== c) return x;
    }
    function T(d) {
        switch(d){
            case void 0:
            case null:
                A = S.length = 0;
                break;
            default:
                if ("function" === typeof d) S[A++] = d;
                else if ("object" === typeof d) for(var c = 0, e = d.length; c < e; ++c)T(d[c]);
                else Y = !!d | 0;
        }
        return T;
    }
    function U(d) {
        d = d.prefix;
        void 0 !== d && (R = null, d ? "function" !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
        return U;
    }
    function B(d, c) {
        var e = d;
        33 > e.charCodeAt(0) && (e = e.trim());
        V = e;
        e = [
            V
        ];
        if (0 < A) {
            var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
            void 0 !== h && "string" === typeof h && (c = h);
        }
        var a = M(O, e, c, 0, 0);
        0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
        V = "";
        E = 0;
        z = D = 1;
        return a;
    }
    var ca = /^\0+/g, N = /[\0\r\f]/g, aa = /: */g, ka = /zoo|gra/, ma = /([,: ])(transform)/g, ia = /,\r+?/g, F = /([\t\r\n ])*\f?&/g, fa = /@(k\w+)\s*(\S*)\s*/, Q = /::(place)/g, ha = /:(read-only)/g, G = /[svh]\w+-[tblr]{2}/, da = /\(\s*(.*)\s*\)/g, oa = /([\s\S]*?);/g, ba = /-self|flex-/g, na = /[^]*?(:[rp][el]a[\w-]+)[^]*/, la = /stretch|:\s*\w+\-(?:conte|avail)/, ja = /([^-])(image-set\()/, z = 1, D = 1, E = 0, w = 1, O = [], S = [], A = 0, R = null, Y = 0, V = "";
    B.use = T;
    B.set = U;
    void 0 !== W && U(W);
    return B;
}
var $9a1e650477d9d52e$export$2e2bcd8739ae039 = $9a1e650477d9d52e$var$stylis_min;

});

parcelRegister("55EI3", function(module, exports) {
var $3b4cff6eff59c4cb$var$weakMemoize = function weakMemoize(func) {
    // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // $FlowFixMe
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};
var $3b4cff6eff59c4cb$export$2e2bcd8739ae039 = $3b4cff6eff59c4cb$var$weakMemoize;

});


parcelRegister("vYtsV", function(module, exports) {

$parcel$export(module.exports, "h", () => $0601ce4a8a51021f$export$dda1d9f60106f0e9);
$parcel$export(module.exports, "T", () => $0601ce4a8a51021f$export$971d5caa766a69d7);
$parcel$export(module.exports, "w", () => $0601ce4a8a51021f$export$efccba1c4a2ef57b);
$parcel$export(module.exports, "c", () => $0601ce4a8a51021f$export$db3b6bfb95261072);
$parcel$export(module.exports, "E", () => $0601ce4a8a51021f$export$a9c23c6ac3fc3eca);
parcelRequire("6r4zt");

var $acw62 = parcelRequire("acw62");

var $czXz2 = parcelRequire("czXz2");

var $boAuA = parcelRequire("boAuA");

var $cXgB3 = parcelRequire("cXgB3");
var $0601ce4a8a51021f$export$dda1d9f60106f0e9 = Object.prototype.hasOwnProperty;
var $0601ce4a8a51021f$var$EmotionCacheContext = /*#__PURE__*/ (0, $acw62.createContext)(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== "undefined" ? (0, $czXz2.default)() : null);
var $0601ce4a8a51021f$export$971d5caa766a69d7 = /*#__PURE__*/ (0, $acw62.createContext)({});
var $0601ce4a8a51021f$export$e7094788287c5e9b = $0601ce4a8a51021f$var$EmotionCacheContext.Provider;
var $0601ce4a8a51021f$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    var render = function render(props, ref) {
        return /*#__PURE__*/ (0, $acw62.createElement)($0601ce4a8a51021f$var$EmotionCacheContext.Consumer, null, function(cache) {
            return func(props, cache, ref);
        });
    }; // $FlowFixMe
    return /*#__PURE__*/ (0, $acw62.forwardRef)(render);
};
// thus we only need to replace what is a valid character for JS, but not for CSS
var $0601ce4a8a51021f$var$sanitizeIdentifier = function sanitizeIdentifier(identifier) {
    return identifier.replace(/\$/g, "-");
};
var $0601ce4a8a51021f$var$typePropName = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__";
var $0601ce4a8a51021f$var$labelPropName = "__EMOTION_LABEL_PLEASE_DO_NOT_USE__";
var $0601ce4a8a51021f$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var key in props)if ($0601ce4a8a51021f$export$dda1d9f60106f0e9.call(props, key)) newProps[key] = props[key];
    newProps[$0601ce4a8a51021f$var$typePropName] = type; // TODO: check if this still works with all of those different JSX functions
    var error, match;
    return newProps;
};
var $0601ce4a8a51021f$var$Noop = function Noop() {
    return null;
};
var $0601ce4a8a51021f$var$render = function render(cache, props, theme, ref) {
    var cssProp = theme === null ? props.css : props.css(theme); // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === "string" && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var type = props[$0601ce4a8a51021f$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = "";
    if (typeof props.className === "string") className = (0, $boAuA.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $cXgB3.serializeStyles)(registeredStyles);
    var labelFromStack;
    var rules = (0, $boAuA.insertStyles)(cache, serialized, typeof type === "string");
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var key in props)if ($0601ce4a8a51021f$export$dda1d9f60106f0e9.call(props, key) && key !== "css" && key !== $0601ce4a8a51021f$var$typePropName && true) newProps[key] = props[key];
    newProps.ref = ref;
    newProps.className = className;
    var ele = /*#__PURE__*/ (0, $acw62.createElement)(type, newProps);
    var possiblyStyleElement = /*#__PURE__*/ (0, $acw62.createElement)($0601ce4a8a51021f$var$Noop, null);
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $acw62.Fragment), null, possiblyStyleElement, ele);
}; // eslint-disable-next-line no-undef
var $0601ce4a8a51021f$export$a9c23c6ac3fc3eca = /* #__PURE__ */ $0601ce4a8a51021f$export$efccba1c4a2ef57b(function(props, cache, ref) {
    if (typeof props.css === "function") return /*#__PURE__*/ (0, $acw62.createElement)($0601ce4a8a51021f$export$971d5caa766a69d7.Consumer, null, function(theme) {
        return $0601ce4a8a51021f$var$render(cache, props, theme, ref);
    });
    return $0601ce4a8a51021f$var$render(cache, props, null, ref);
});

});
parcelRegister("6r4zt", function(module, exports) {

var $aAhot = parcelRequire("aAhot");
function $4af8cf748148995c$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $aAhot(subClass, superClass);
}
module.exports = $4af8cf748148995c$var$_inheritsLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("aAhot", function(module, exports) {
function $7b4ac2338b8e8f97$var$_setPrototypeOf(o, p) {
    module.exports = $7b4ac2338b8e8f97$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    return $7b4ac2338b8e8f97$var$_setPrototypeOf(o, p);
}
module.exports = $7b4ac2338b8e8f97$var$_setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("boAuA", function(module, exports) {

$parcel$export(module.exports, "getRegisteredStyles", () => $84be3e3d8830d20e$export$95d99596f328fd52);
$parcel$export(module.exports, "insertStyles", () => $84be3e3d8830d20e$export$6f077d94b33a01aa);
var $84be3e3d8830d20e$var$isBrowser = true;
function $84be3e3d8830d20e$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = "";
    classNames.split(" ").forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className]);
        else rawClassName += className + " ";
    });
    return rawClassName;
}
var $84be3e3d8830d20e$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $84be3e3d8830d20e$var$isBrowser === false && cache.compat !== undefined) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
    if (cache.inserted[serialized.name] === undefined) {
        var current = serialized;
        do {
            var maybeStyles = cache.insert("." + className, current, cache.sheet, true);
            current = current.next;
        }while (current !== undefined);
    }
};

});

parcelRegister("cXgB3", function(module, exports) {

$parcel$export(module.exports, "serializeStyles", () => $96e7de74f086414c$export$6321afa313b251b5);

var $gz7zU = parcelRequire("gz7zU");

var $iDSBG = parcelRequire("iDSBG");

var $l7O8P = parcelRequire("l7O8P");
var $96e7de74f086414c$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $96e7de74f086414c$var$UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var $96e7de74f086414c$var$hyphenateRegex = /[A-Z]|^ms/g;
var $96e7de74f086414c$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $96e7de74f086414c$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $96e7de74f086414c$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== "boolean";
};
var $96e7de74f086414c$var$processStyleName = (0, $l7O8P.default)(function(styleName) {
    return $96e7de74f086414c$var$isCustomProperty(styleName) ? styleName : styleName.replace($96e7de74f086414c$var$hyphenateRegex, "-$&").toLowerCase();
});
var $96e7de74f086414c$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case "animation":
        case "animationName":
            if (typeof value === "string") return value.replace($96e7de74f086414c$var$animationRegex, function(match, p1, p2) {
                $96e7de74f086414c$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $96e7de74f086414c$var$cursor
                };
                return p1;
            });
    }
    if ((0, $iDSBG.default)[key] !== 1 && !$96e7de74f086414c$var$isCustomProperty(key) && typeof value === "number" && value !== 0) return value + "px";
    return value;
};
var $96e7de74f086414c$var$contentValuePattern, $96e7de74f086414c$var$contentValues, $96e7de74f086414c$var$oldProcessStyleValue, $96e7de74f086414c$var$msPattern, $96e7de74f086414c$var$hyphenPattern, $96e7de74f086414c$var$hyphenatedCache;
var $96e7de74f086414c$var$shouldWarnAboutInterpolatingClassNameFromCss = true;
function $96e7de74f086414c$var$handleInterpolation(mergedProps, registered, interpolation, couldBeSelectorInterpolation) {
    if (interpolation == null) return "";
    if (interpolation.__emotion_styles !== undefined) return interpolation;
    switch(typeof interpolation){
        case "boolean":
            return "";
        case "object":
            if (interpolation.anim === 1) {
                $96e7de74f086414c$var$cursor = {
                    name: interpolation.name,
                    styles: interpolation.styles,
                    next: $96e7de74f086414c$var$cursor
                };
                return interpolation.name;
            }
            if (interpolation.styles !== undefined) {
                var next = interpolation.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $96e7de74f086414c$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $96e7de74f086414c$var$cursor
                    };
                    next = next.next;
                }
                var styles = interpolation.styles + ";";
                return styles;
            }
            return $96e7de74f086414c$var$createStringFromObject(mergedProps, registered, interpolation);
        case "function":
            if (mergedProps !== undefined) {
                var previousCursor = $96e7de74f086414c$var$cursor;
                var result = interpolation(mergedProps);
                $96e7de74f086414c$var$cursor = previousCursor;
                return $96e7de74f086414c$var$handleInterpolation(mergedProps, registered, result, couldBeSelectorInterpolation);
            }
            break;
        case "string":
            var matched, replaced;
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    if (registered == null) return interpolation;
    var cached = registered[interpolation];
    return cached !== undefined && !couldBeSelectorInterpolation ? cached : interpolation;
}
function $96e7de74f086414c$var$createStringFromObject(mergedProps, registered, obj) {
    var string = "";
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $96e7de74f086414c$var$handleInterpolation(mergedProps, registered, obj[i], false);
    else for(var _key in obj){
        var value = obj[_key];
        if (typeof value !== "object") {
            if (registered != null && registered[value] !== undefined) string += _key + "{" + registered[value] + "}";
            else if ($96e7de74f086414c$var$isProcessableValue(value)) string += $96e7de74f086414c$var$processStyleName(_key) + ":" + $96e7de74f086414c$var$processStyleValue(_key, value) + ";";
        } else if (Array.isArray(value) && typeof value[0] === "string" && (registered == null || registered[value[0]] === undefined)) {
            for(var _i = 0; _i < value.length; _i++)if ($96e7de74f086414c$var$isProcessableValue(value[_i])) string += $96e7de74f086414c$var$processStyleName(_key) + ":" + $96e7de74f086414c$var$processStyleValue(_key, value[_i]) + ";";
        } else {
            var interpolated = $96e7de74f086414c$var$handleInterpolation(mergedProps, registered, value, false);
            switch(_key){
                case "animation":
                case "animationName":
                    string += $96e7de74f086414c$var$processStyleName(_key) + ":" + interpolated + ";";
                    break;
                default:
                    string += _key + "{" + interpolated + "}";
            }
        }
    }
    return string;
}
var $96e7de74f086414c$var$labelPattern = /label:\s*([^\s;\n{]+)\s*;/g;
var $96e7de74f086414c$var$sourceMapPattern;
// keyframes are stored on the SerializedStyles object as a linked list
var $96e7de74f086414c$var$cursor;
var $96e7de74f086414c$export$6321afa313b251b5 = function serializeStyles(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === "object" && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = "";
    $96e7de74f086414c$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $96e7de74f086414c$var$handleInterpolation(mergedProps, registered, strings, false);
    } else styles += strings[0];
     // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $96e7de74f086414c$var$handleInterpolation(mergedProps, registered, args[i], styles.charCodeAt(styles.length - 1) === 46);
        if (stringMode) styles += strings[i];
    }
    var sourceMap;
    $96e7de74f086414c$var$labelPattern.lastIndex = 0;
    var identifierName = "";
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $96e7de74f086414c$var$labelPattern.exec(styles)) !== null)identifierName += "-" + // $FlowFixMe we know it's not null
    match[1];
    var name = (0, $gz7zU.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $96e7de74f086414c$var$cursor
    };
};

});
parcelRegister("gz7zU", function(module, exports) {

$parcel$export(module.exports, "default", () => $c0f5cb12993018cc$export$2e2bcd8739ae039);
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $c0f5cb12993018cc$var$murmur2(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}
var $c0f5cb12993018cc$export$2e2bcd8739ae039 = $c0f5cb12993018cc$var$murmur2;

});

parcelRegister("iDSBG", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9263a4c6739b952$export$2e2bcd8739ae039);
var $d9263a4c6739b952$var$unitlessKeys = {
    animationIterationCount: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};
var $d9263a4c6739b952$export$2e2bcd8739ae039 = $d9263a4c6739b952$var$unitlessKeys;

});

parcelRegister("l7O8P", function(module, exports) {

$parcel$export(module.exports, "default", () => $f6112573aba91cb3$export$2e2bcd8739ae039);
function $f6112573aba91cb3$var$memoize(fn) {
    var cache = {};
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}
var $f6112573aba91cb3$export$2e2bcd8739ae039 = $f6112573aba91cb3$var$memoize;

});



parcelRegister("6xSYO", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c4078fc8d62d9b6$export$2e2bcd8739ae039);

var $cXgB3 = parcelRequire("cXgB3");
function $4c4078fc8d62d9b6$var$css() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $cXgB3.serializeStyles)(args);
}
var $4c4078fc8d62d9b6$export$2e2bcd8739ae039 = $4c4078fc8d62d9b6$var$css;

});


parcelRegister("lFbni", function(module, exports) {
"use strict";
function $fc56401c84ea1adf$var$__export(m) {
    for(var p in m)if (!module.exports.hasOwnProperty(p)) module.exports[p] = m[p];
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$fc56401c84ea1adf$var$__export((parcelRequire("7am6d")));

$fc56401c84ea1adf$var$__export((parcelRequire("9kw7K")));

});
parcelRegister("7am6d", function(module, exports) {
"use strict";
var $537a9c095294bdeb$var$_a;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/*
 * List of string constants to represent different props
 */ var $537a9c095294bdeb$var$LOADING = "loading";
var $537a9c095294bdeb$var$COLOR = "color";
var $537a9c095294bdeb$var$CSS = "css";
var $537a9c095294bdeb$var$SIZE = "size";
var $537a9c095294bdeb$var$SIZE_UNIT = "sizeUnit";
var $537a9c095294bdeb$var$WIDTH = "width";
var $537a9c095294bdeb$var$WIDTH_UNIT = "widthUnit";
var $537a9c095294bdeb$var$HEIGHT = "height";
var $537a9c095294bdeb$var$HEIGHT_UNIT = "heightUnit";
var $537a9c095294bdeb$var$RADIUS = "radius";
var $537a9c095294bdeb$var$RADIUS_UNIT = "radiusUnit";
var $537a9c095294bdeb$var$MARGIN = "margin";
var $537a9c095294bdeb$var$commonValues = ($537a9c095294bdeb$var$_a = {}, $537a9c095294bdeb$var$_a[$537a9c095294bdeb$var$LOADING] = true, $537a9c095294bdeb$var$_a[$537a9c095294bdeb$var$COLOR] = "#000000", $537a9c095294bdeb$var$_a[$537a9c095294bdeb$var$CSS] = {}, $537a9c095294bdeb$var$_a);
var $537a9c095294bdeb$var$heightWidthValues = function(height, width) {
    var _a;
    return _a = {}, _a[$537a9c095294bdeb$var$HEIGHT] = height, _a[$537a9c095294bdeb$var$HEIGHT_UNIT] = "px", _a[$537a9c095294bdeb$var$WIDTH] = width, _a[$537a9c095294bdeb$var$WIDTH_UNIT] = "px", _a;
};
var $537a9c095294bdeb$var$sizeValues = function(sizeValue) {
    var _a;
    return _a = {}, _a[$537a9c095294bdeb$var$SIZE] = sizeValue, _a[$537a9c095294bdeb$var$SIZE_UNIT] = "px", _a;
};
module.exports.sizeDefaults = function(sizeValue) {
    return Object.assign({}, $537a9c095294bdeb$var$commonValues, $537a9c095294bdeb$var$sizeValues(sizeValue));
};
module.exports.sizeMarginDefaults = function(sizeValue) {
    var _a;
    return Object.assign({}, module.exports.sizeDefaults(sizeValue), (_a = {}, _a[$537a9c095294bdeb$var$MARGIN] = "2px", _a));
};
module.exports.heightWidthDefaults = function(height, width) {
    return Object.assign({}, $537a9c095294bdeb$var$commonValues, $537a9c095294bdeb$var$heightWidthValues(height, width));
};
module.exports.heightWidthRadiusDefaults = function(height, width, radius) {
    var _a;
    if (radius === void 0) radius = 2;
    return Object.assign({}, module.exports.heightWidthDefaults(height, width), (_a = {}, _a[$537a9c095294bdeb$var$RADIUS] = radius, _a[$537a9c095294bdeb$var$RADIUS_UNIT] = "px", _a[$537a9c095294bdeb$var$MARGIN] = "2px", _a));
};

});

parcelRegister("9kw7K", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $6caee67cb8c6600a$var$BasicColors;
(function(BasicColors) {
    BasicColors["maroon"] = "#800000";
    BasicColors["red"] = "#FF0000";
    BasicColors["orange"] = "#FFA500";
    BasicColors["yellow"] = "#FFFF00";
    BasicColors["olive"] = "#808000";
    BasicColors["green"] = "#008000";
    BasicColors["purple"] = "#800080";
    BasicColors["fuchsia"] = "#FF00FF";
    BasicColors["lime"] = "#00FF00";
    BasicColors["teal"] = "#008080";
    BasicColors["aqua"] = "#00FFFF";
    BasicColors["blue"] = "#0000FF";
    BasicColors["navy"] = "#000080";
    BasicColors["black"] = "#000000";
    BasicColors["gray"] = "#808080";
    BasicColors["silver"] = "#C0C0C0";
    BasicColors["white"] = "#FFFFFF";
})($6caee67cb8c6600a$var$BasicColors || ($6caee67cb8c6600a$var$BasicColors = {}));
module.exports.calculateRgba = function(color, opacity) {
    if (Object.keys($6caee67cb8c6600a$var$BasicColors).includes(color)) color = $6caee67cb8c6600a$var$BasicColors[color];
    if (color[0] === "#") color = color.slice(1);
    if (color.length === 3) {
        var res_1 = "";
        color.split("").forEach(function(c) {
            res_1 += c;
            res_1 += c;
        });
        color = res_1;
    }
    var rgbValues = color.match(/.{2}/g).map(function(hex) {
        return parseInt(hex, 16);
    }).join(", ");
    return "rgba(" + rgbValues + ", " + opacity + ")";
};

});



parcelRegister("chQwI", function(module, exports) {
"use strict";
var $8f1fd13eb2a5102e$var$__makeTemplateObject = module.exports && module.exports.__makeTemplateObject || function(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
};
var $8f1fd13eb2a5102e$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $8f1fd13eb2a5102e$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result["default"] = mod;
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

/** @jsx jsx */ var $8f1fd13eb2a5102e$var$React = $8f1fd13eb2a5102e$var$__importStar((parcelRequire("acw62")));

var $f5Egd = parcelRequire("f5Egd");
var $6xSYO = parcelRequire("6xSYO");

var $lFbni = parcelRequire("lFbni");
var $8f1fd13eb2a5102e$var$beat = $f5Egd.keyframes($8f1fd13eb2a5102e$var$templateObject_1 || ($8f1fd13eb2a5102e$var$templateObject_1 = $8f1fd13eb2a5102e$var$__makeTemplateObject([
    "\n  50% {transform: scale(0.75);opacity: 0.2}\n  100% {transform: scale(1);opacity: 1}\n"
], [
    "\n  50% {transform: scale(0.75);opacity: 0.2}\n  100% {transform: scale(1);opacity: 1}\n"
])));
var $8f1fd13eb2a5102e$var$Loader = /** @class */ function(_super) {
    $8f1fd13eb2a5102e$var$__extends(Loader, _super);
    function Loader() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.style = function(i) {
            var _a = _this.props, color = _a.color, size = _a.size, sizeUnit = _a.sizeUnit, margin = _a.margin;
            return $6xSYO.default($8f1fd13eb2a5102e$var$templateObject_2 || ($8f1fd13eb2a5102e$var$templateObject_2 = $8f1fd13eb2a5102e$var$__makeTemplateObject([
                "\n      display: inline-block;\n      background-color: ",
                ";\n      width: ",
                ";\n      height: ",
                ";\n      margin: ",
                ";\n      border-radius: 100%;\n      animation: ",
                " 0.7s ",
                " infinite linear;\n      animation-fill-mode: both;\n    "
            ], [
                "\n      display: inline-block;\n      background-color: ",
                ";\n      width: ",
                ";\n      height: ",
                ";\n      margin: ",
                ";\n      border-radius: 100%;\n      animation: ",
                " 0.7s ",
                " infinite linear;\n      animation-fill-mode: both;\n    "
            ])), color, "" + size + sizeUnit, "" + size + sizeUnit, margin, $8f1fd13eb2a5102e$var$beat, i % 2 ? "0s" : "0.35s");
        };
        return _this;
    }
    Loader.prototype.render = function() {
        var _a = this.props, loading = _a.loading, css = _a.css;
        return loading ? $f5Egd.jsx("div", {
            css: [
                css
            ]
        }, $f5Egd.jsx("div", {
            css: this.style(1)
        }), $f5Egd.jsx("div", {
            css: this.style(2)
        }), $f5Egd.jsx("div", {
            css: this.style(3)
        })) : null;
    };
    Loader.defaultProps = $lFbni.sizeMarginDefaults(15);
    return Loader;
}($8f1fd13eb2a5102e$var$React.PureComponent);
module.exports.default = $8f1fd13eb2a5102e$var$Loader;
var $8f1fd13eb2a5102e$var$templateObject_1, $8f1fd13eb2a5102e$var$templateObject_2;

});

parcelRegister("1NdFU", function(module, exports) {
"use strict";
var $14e4f9a083d9eb39$var$__makeTemplateObject = module.exports && module.exports.__makeTemplateObject || function(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
};
var $14e4f9a083d9eb39$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $14e4f9a083d9eb39$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result["default"] = mod;
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

/** @jsx jsx */ var $14e4f9a083d9eb39$var$React = $14e4f9a083d9eb39$var$__importStar((parcelRequire("acw62")));

var $f5Egd = parcelRequire("f5Egd");
var $6xSYO = parcelRequire("6xSYO");

var $lFbni = parcelRequire("lFbni");
var $14e4f9a083d9eb39$var$bounce = $f5Egd.keyframes($14e4f9a083d9eb39$var$templateObject_1 || ($14e4f9a083d9eb39$var$templateObject_1 = $14e4f9a083d9eb39$var$__makeTemplateObject([
    "\n  0%, 100% {transform: scale(0)}\n  50% {transform: scale(1.0)}\n"
], [
    "\n  0%, 100% {transform: scale(0)}\n  50% {transform: scale(1.0)}\n"
])));
var $14e4f9a083d9eb39$var$Loader = /** @class */ function(_super) {
    $14e4f9a083d9eb39$var$__extends(Loader, _super);
    function Loader() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.style = function(i) {
            var _a = _this.props, size = _a.size, color = _a.color, sizeUnit = _a.sizeUnit;
            return $6xSYO.default($14e4f9a083d9eb39$var$templateObject_2 || ($14e4f9a083d9eb39$var$templateObject_2 = $14e4f9a083d9eb39$var$__makeTemplateObject([
                "\n      position: absolute;\n      height: ",
                ";\n      width: ",
                ";\n      background-color: ",
                ";\n      border-radius: 100%;\n      opacity: 0.6;\n      top: 0;\n      left: 0;\n      animation-fill-mode: both;\n      animation: ",
                " 2.1s ",
                " infinite ease-in-out;\n    "
            ], [
                "\n      position: absolute;\n      height: ",
                ";\n      width: ",
                ";\n      background-color: ",
                ";\n      border-radius: 100%;\n      opacity: 0.6;\n      top: 0;\n      left: 0;\n      animation-fill-mode: both;\n      animation: ",
                " 2.1s ",
                " infinite ease-in-out;\n    "
            ])), "" + size + sizeUnit, "" + size + sizeUnit, color, $14e4f9a083d9eb39$var$bounce, i === 1 ? "1s" : "0s");
        };
        _this.wrapper = function() {
            var _a = _this.props, size = _a.size, sizeUnit = _a.sizeUnit;
            return $6xSYO.default($14e4f9a083d9eb39$var$templateObject_3 || ($14e4f9a083d9eb39$var$templateObject_3 = $14e4f9a083d9eb39$var$__makeTemplateObject([
                "\n      position: relative;\n      width: ",
                ";\n      height: ",
                ";\n    "
            ], [
                "\n      position: relative;\n      width: ",
                ";\n      height: ",
                ";\n    "
            ])), "" + size + sizeUnit, "" + size + sizeUnit);
        };
        return _this;
    }
    Loader.prototype.render = function() {
        var _a = this.props, loading = _a.loading, css = _a.css;
        return loading ? $f5Egd.jsx("div", {
            css: [
                this.wrapper(),
                css
            ]
        }, $f5Egd.jsx("div", {
            css: this.style(1)
        }), $f5Egd.jsx("div", {
            css: this.style(2)
        })) : null;
    };
    Loader.defaultProps = $lFbni.sizeDefaults(60);
    return Loader;
}($14e4f9a083d9eb39$var$React.PureComponent);
module.exports.default = $14e4f9a083d9eb39$var$Loader;
var $14e4f9a083d9eb39$var$templateObject_1, $14e4f9a083d9eb39$var$templateObject_2, $14e4f9a083d9eb39$var$templateObject_3;

});

parcelRegister("gKQOa", function(module, exports) {
"use strict";
var $0325d651cee7077d$var$__makeTemplateObject = module.exports && module.exports.__makeTemplateObject || function(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
};
var $0325d651cee7077d$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $0325d651cee7077d$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result["default"] = mod;
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

/** @jsx jsx */ var $0325d651cee7077d$var$React = $0325d651cee7077d$var$__importStar((parcelRequire("acw62")));

var $f5Egd = parcelRequire("f5Egd");
var $6xSYO = parcelRequire("6xSYO");

var $lFbni = parcelRequire("lFbni");
var $0325d651cee7077d$var$circle = $f5Egd.keyframes($0325d651cee7077d$var$templateObject_1 || ($0325d651cee7077d$var$templateObject_1 = $0325d651cee7077d$var$__makeTemplateObject([
    "\n  0% {transform: rotate(0deg)}\n  50% {transform: rotate(180deg)}\n  100% {transform: rotate(360deg)}\n"
], [
    "\n  0% {transform: rotate(0deg)}\n  50% {transform: rotate(180deg)}\n  100% {transform: rotate(360deg)}\n"
])));
var $0325d651cee7077d$var$Loader = /** @class */ function(_super) {
    $0325d651cee7077d$var$__extends(Loader, _super);
    function Loader() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.style = function(i) {
            var _a = _this.props, size = _a.size, color = _a.color, sizeUnit = _a.sizeUnit;
            return $6xSYO.default($0325d651cee7077d$var$templateObject_2 || ($0325d651cee7077d$var$templateObject_2 = $0325d651cee7077d$var$__makeTemplateObject([
                "\n      position: absolute;\n      height: ",
                ";\n      width: ",
                ";\n      border: 1px solid ",
                ";\n      border-radius: 100%;\n      transition: 2s;\n      border-bottom: none;\n      border-right: none;\n      top: ",
                "%;\n      left: ",
                '%;\n      animation-fill-mode: "";\n      animation: ',
                " 1s ",
                "s infinite linear;\n    "
            ], [
                "\n      position: absolute;\n      height: ",
                ";\n      width: ",
                ";\n      border: 1px solid ",
                ";\n      border-radius: 100%;\n      transition: 2s;\n      border-bottom: none;\n      border-right: none;\n      top: ",
                "%;\n      left: ",
                '%;\n      animation-fill-mode: "";\n      animation: ',
                " 1s ",
                "s infinite linear;\n    "
            ])), "" + size * (1 - i / 10) + sizeUnit, "" + size * (1 - i / 10) + sizeUnit, color, i * 1.75, i * 0.875, $0325d651cee7077d$var$circle, i * 0.2);
        };
        _this.wrapper = function() {
            var _a = _this.props, size = _a.size, sizeUnit = _a.sizeUnit;
            return $6xSYO.default($0325d651cee7077d$var$templateObject_3 || ($0325d651cee7077d$var$templateObject_3 = $0325d651cee7077d$var$__makeTemplateObject([
                "\n      position: relative;\n      width: ",
                ";\n      height: ",
                ";\n    "
            ], [
                "\n      position: relative;\n      width: ",
                ";\n      height: ",
                ";\n    "
            ])), "" + size + sizeUnit, "" + size + sizeUnit);
        };
        return _this;
    }
    Loader.prototype.render = function() {
        var _a = this.props, loading = _a.loading, css = _a.css;
        return loading ? $f5Egd.jsx("div", {
            css: [
                this.wrapper(),
                css
            ]
        }, $f5Egd.jsx("div", {
            css: this.style(0)
        }), $f5Egd.jsx("div", {
            css: this.style(1)
        }), $f5Egd.jsx("div", {
            css: this.style(2)
        }), $f5Egd.jsx("div", {
            css: this.style(3)
        }), $f5Egd.jsx("div", {
            css: this.style(4)
        })) : null;
    };
    Loader.defaultProps = $lFbni.sizeDefaults(50);
    return Loader;
}($0325d651cee7077d$var$React.PureComponent);
module.exports.default = $0325d651cee7077d$var$Loader;
var $0325d651cee7077d$var$templateObject_1, $0325d651cee7077d$var$templateObject_2, $0325d651cee7077d$var$templateObject_3;

});

parcelRegister("3mWdt", function(module, exports) {
"use strict";
var $274095b2f656a404$var$__makeTemplateObject = module.exports && module.exports.__makeTemplateObject || function(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
};
var $274095b2f656a404$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $274095b2f656a404$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result["default"] = mod;
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

/** @jsx jsx */ var $274095b2f656a404$var$React = $274095b2f656a404$var$__importStar((parcelRequire("acw62")));

var $f5Egd = parcelRequire("f5Egd");
var $6xSYO = parcelRequire("6xSYO");

var $lFbni = parcelRequire("lFbni");
var $274095b2f656a404$var$climbingBox = $f5Egd.keyframes($274095b2f656a404$var$templateObject_1 || ($274095b2f656a404$var$templateObject_1 = $274095b2f656a404$var$__makeTemplateObject([
    "\n  0% {transform:translate(0, -1em) rotate(-45deg)}\n  5% {transform:translate(0, -1em) rotate(-50deg)}\n  20% {transform:translate(1em, -2em) rotate(47deg)}\n  25% {transform:translate(1em, -2em) rotate(45deg)}\n  30% {transform:translate(1em, -2em) rotate(40deg)}\n  45% {transform:translate(2em, -3em) rotate(137deg)}\n  50% {transform:translate(2em, -3em) rotate(135deg)}\n  55% {transform:translate(2em, -3em) rotate(130deg)}\n  70% {transform:translate(3em, -4em) rotate(217deg)}\n  75% {transform:translate(3em, -4em) rotate(220deg)}\n  100% {transform:translate(0, -1em) rotate(-225deg)}\n"
], [
    "\n  0% {transform:translate(0, -1em) rotate(-45deg)}\n  5% {transform:translate(0, -1em) rotate(-50deg)}\n  20% {transform:translate(1em, -2em) rotate(47deg)}\n  25% {transform:translate(1em, -2em) rotate(45deg)}\n  30% {transform:translate(1em, -2em) rotate(40deg)}\n  45% {transform:translate(2em, -3em) rotate(137deg)}\n  50% {transform:translate(2em, -3em) rotate(135deg)}\n  55% {transform:translate(2em, -3em) rotate(130deg)}\n  70% {transform:translate(3em, -4em) rotate(217deg)}\n  75% {transform:translate(3em, -4em) rotate(220deg)}\n  100% {transform:translate(0, -1em) rotate(-225deg)}\n"
])));
var $274095b2f656a404$var$Loader = /** @class */ function(_super) {
    $274095b2f656a404$var$__extends(Loader, _super);
    function Loader() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.style = function() {
            var color = _this.props.color;
            return $6xSYO.default($274095b2f656a404$var$templateObject_2 || ($274095b2f656a404$var$templateObject_2 = $274095b2f656a404$var$__makeTemplateObject([
                "\n      position: absolute;\n      left: 0;\n      bottom: -0.1em;\n      height: 1em;\n      width: 1em;\n      background-color: transparent;\n      border-radius: 15%;\n      border: 0.25em solid ",
                ";\n      transform: translate(0, -1em) rotate(-45deg);\n      animation-fill-mode: both;\n      animation: ",
                " 2.5s infinite cubic-bezier(0.79, 0, 0.47, 0.97);\n    "
            ], [
                "\n      position: absolute;\n      left: 0;\n      bottom: -0.1em;\n      height: 1em;\n      width: 1em;\n      background-color: transparent;\n      border-radius: 15%;\n      border: 0.25em solid ",
                ";\n      transform: translate(0, -1em) rotate(-45deg);\n      animation-fill-mode: both;\n      animation: ",
                " 2.5s infinite cubic-bezier(0.79, 0, 0.47, 0.97);\n    "
            ])), color, $274095b2f656a404$var$climbingBox);
        };
        _this.wrapper = function() {
            var _a = _this.props, size = _a.size, sizeUnit = _a.sizeUnit;
            return $6xSYO.default($274095b2f656a404$var$templateObject_3 || ($274095b2f656a404$var$templateObject_3 = $274095b2f656a404$var$__makeTemplateObject([
                "\n      position: absolute;\n      top: 50%;\n      left: 50%;\n      margin-top: -2.7em;\n      margin-left: -2.7em;\n      width: 5.4em;\n      height: 5.4em;\n      font-size: ",
                ";\n    "
            ], [
                "\n      position: absolute;\n      top: 50%;\n      left: 50%;\n      margin-top: -2.7em;\n      margin-left: -2.7em;\n      width: 5.4em;\n      height: 5.4em;\n      font-size: ",
                ";\n    "
            ])), "" + size + sizeUnit);
        };
        _this.hill = function() {
            var color = _this.props.color;
            return $6xSYO.default($274095b2f656a404$var$templateObject_4 || ($274095b2f656a404$var$templateObject_4 = $274095b2f656a404$var$__makeTemplateObject([
                "\n      position: absolute;\n      width: 7.1em;\n      height: 7.1em;\n      top: 1.7em;\n      left: 1.7em;\n      border-left: 0.25em solid ",
                ";\n      transform: rotate(45deg);\n    "
            ], [
                "\n      position: absolute;\n      width: 7.1em;\n      height: 7.1em;\n      top: 1.7em;\n      left: 1.7em;\n      border-left: 0.25em solid ",
                ";\n      transform: rotate(45deg);\n    "
            ])), color);
        };
        _this.container = function() {
            return $6xSYO.default($274095b2f656a404$var$templateObject_5 || ($274095b2f656a404$var$templateObject_5 = $274095b2f656a404$var$__makeTemplateObject([
                "\n      position: relative;\n      width: 7.1em;\n      height: 7.1em;\n    "
            ], [
                "\n      position: relative;\n      width: 7.1em;\n      height: 7.1em;\n    "
            ])));
        };
        return _this;
    }
    Loader.prototype.render = function() {
        var _a = this.props, loading = _a.loading, css = _a.css;
        return loading ? $f5Egd.jsx("div", {
            css: [
                this.container(),
                css
            ]
        }, $f5Egd.jsx("div", {
            css: this.wrapper()
        }, $f5Egd.jsx("div", {
            css: this.style()
        }), $f5Egd.jsx("div", {
            css: this.hill()
        }))) : null;
    };
    Loader.defaultProps = $lFbni.sizeDefaults(15);
    return Loader;
}($274095b2f656a404$var$React.PureComponent);
module.exports.default = $274095b2f656a404$var$Loader;
var $274095b2f656a404$var$templateObject_1, $274095b2f656a404$var$templateObject_2, $274095b2f656a404$var$templateObject_3, $274095b2f656a404$var$templateObject_4, $274095b2f656a404$var$templateObject_5;

});

parcelRegister("51o5i", function(module, exports) {
"use strict";
var $3a7fba6ee8dd0386$var$__makeTemplateObject = module.exports && module.exports.__makeTemplateObject || function(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
};
var $3a7fba6ee8dd0386$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $3a7fba6ee8dd0386$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result["default"] = mod;
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

/** @jsx jsx */ var $3a7fba6ee8dd0386$var$React = $3a7fba6ee8dd0386$var$__importStar((parcelRequire("acw62")));

var $f5Egd = parcelRequire("f5Egd");
var $6xSYO = parcelRequire("6xSYO");

var $7am6d = parcelRequire("7am6d");
var $3a7fba6ee8dd0386$var$clip = $f5Egd.keyframes($3a7fba6ee8dd0386$var$templateObject_1 || ($3a7fba6ee8dd0386$var$templateObject_1 = $3a7fba6ee8dd0386$var$__makeTemplateObject([
    "\n  0% {transform: rotate(0deg) scale(1)}\n  50% {transform: rotate(180deg) scale(0.8)}\n  100% {transform: rotate(360deg) scale(1)}\n"
], [
    "\n  0% {transform: rotate(0deg) scale(1)}\n  50% {transform: rotate(180deg) scale(0.8)}\n  100% {transform: rotate(360deg) scale(1)}\n"
])));
var $3a7fba6ee8dd0386$var$Loader = /** @class */ function(_super) {
    $3a7fba6ee8dd0386$var$__extends(Loader, _super);
    function Loader() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.style = function() {
            var _a = _this.props, size = _a.size, sizeUnit = _a.sizeUnit, color = _a.color;
            return $6xSYO.default($3a7fba6ee8dd0386$var$templateObject_2 || ($3a7fba6ee8dd0386$var$templateObject_2 = $3a7fba6ee8dd0386$var$__makeTemplateObject([
                "\n      background: transparent !important;\n      width: ",
                ";\n      height: ",
                ";\n      border-radius: 100%;\n      border: 2px solid;\n      border-color: ",
                ";\n      border-bottom-color: transparent;\n      display: inline-block;\n      animation: ",
                " 0.75s 0s infinite linear;\n      animation-fill-mode: both;\n    "
            ], [
                "\n      background: transparent !important;\n      width: ",
                ";\n      height: ",
                ";\n      border-radius: 100%;\n      border: 2px solid;\n      border-color: ",
                ";\n      border-bottom-color: transparent;\n      display: inline-block;\n      animation: ",
                " 0.75s 0s infinite linear;\n      animation-fill-mode: both;\n    "
            ])), "" + size + sizeUnit, "" + size + sizeUnit, color, $3a7fba6ee8dd0386$var$clip);
        };
        return _this;
    }
    Loader.prototype.render = function() {
        var _a = this.props, loading = _a.loading, css = _a.css;
        return loading ? $f5Egd.jsx("div", {
            css: [
                this.style(),
                css
            ]
        }) : null;
    };
    Loader.defaultProps = $7am6d.sizeDefaults(35);
    return Loader;
}($3a7fba6ee8dd0386$var$React.PureComponent);
module.exports.default = $3a7fba6ee8dd0386$var$Loader;
var $3a7fba6ee8dd0386$var$templateObject_1, $3a7fba6ee8dd0386$var$templateObject_2;

});

parcelRegister("ly5IV", function(module, exports) {
"use strict";
var $fb01368e09cfe1f7$var$__makeTemplateObject = module.exports && module.exports.__makeTemplateObject || function(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
};
var $fb01368e09cfe1f7$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $fb01368e09cfe1f7$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result["default"] = mod;
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

/** @jsx jsx */ var $fb01368e09cfe1f7$var$React = $fb01368e09cfe1f7$var$__importStar((parcelRequire("acw62")));

var $f5Egd = parcelRequire("f5Egd");
var $6xSYO = parcelRequire("6xSYO");

var $lFbni = parcelRequire("lFbni");
var $fb01368e09cfe1f7$var$rotate = $f5Egd.keyframes($fb01368e09cfe1f7$var$templateObject_1 || ($fb01368e09cfe1f7$var$templateObject_1 = $fb01368e09cfe1f7$var$__makeTemplateObject([
    "\n  100% {transform: rotate(360deg)}\n"
], [
    "\n  100% {transform: rotate(360deg)}\n"
])));
var $fb01368e09cfe1f7$var$bounce = $f5Egd.keyframes($fb01368e09cfe1f7$var$templateObject_2 || ($fb01368e09cfe1f7$var$templateObject_2 = $fb01368e09cfe1f7$var$__makeTemplateObject([
    "\n  0%, 100% {transform: scale(0)}\n  50% {transform: scale(1.0)}\n"
], [
    "\n  0%, 100% {transform: scale(0)}\n  50% {transform: scale(1.0)}\n"
])));
var $fb01368e09cfe1f7$var$Loader = /** @class */ function(_super) {
    $fb01368e09cfe1f7$var$__extends(Loader, _super);
    function Loader() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.style = function(i) {
            var _a = _this.props, size = _a.size, sizeUnit = _a.sizeUnit, color = _a.color;
            return $6xSYO.default($fb01368e09cfe1f7$var$templateObject_3 || ($fb01368e09cfe1f7$var$templateObject_3 = $fb01368e09cfe1f7$var$__makeTemplateObject([
                "\n      position: absolute;\n      top: ",
                ";\n      bottom: ",
                ";\n      height: ",
                ";\n      width: ",
                ";\n      background-color: ",
                ";\n      border-radius: 100%;\n      animation-fill-mode: forwards;\n      animation: ",
                " 2s ",
                " infinite linear;\n    "
            ], [
                "\n      position: absolute;\n      top: ",
                ";\n      bottom: ",
                ";\n      height: ",
                ";\n      width: ",
                ";\n      background-color: ",
                ";\n      border-radius: 100%;\n      animation-fill-mode: forwards;\n      animation: ",
                " 2s ",
                " infinite linear;\n    "
            ])), i % 2 ? "0" : "auto", i % 2 ? "auto" : "0", "" + size / 2 + sizeUnit, "" + size / 2 + sizeUnit, color, $fb01368e09cfe1f7$var$bounce, i === 2 ? "-1s" : "0s");
        };
        _this.wrapper = function() {
            var _a = _this.props, size = _a.size, sizeUnit = _a.sizeUnit;
            return $6xSYO.default($fb01368e09cfe1f7$var$templateObject_4 || ($fb01368e09cfe1f7$var$templateObject_4 = $fb01368e09cfe1f7$var$__makeTemplateObject([
                "\n      position: relative;\n      width: ",
                ";\n      height: ",
                ";\n      animation-fill-mode: forwards;\n      animation: ",
                " 2s 0s infinite linear;\n    "
            ], [
                "\n      position: relative;\n      width: ",
                ";\n      height: ",
                ";\n      animation-fill-mode: forwards;\n      animation: ",
                " 2s 0s infinite linear;\n    "
            ])), "" + size + sizeUnit, "" + size + sizeUnit, $fb01368e09cfe1f7$var$rotate);
        };
        return _this;
    }
    Loader.prototype.render = function() {
        var _a = this.props, loading = _a.loading, css = _a.css;
        return loading ? $f5Egd.jsx("div", {
            css: [
                this.wrapper(),
                css
            ]
        }, $f5Egd.jsx("div", {
            css: this.style(1)
        }), $f5Egd.jsx("div", {
            css: this.style(2)
        })) : null;
    };
    Loader.defaultProps = $lFbni.sizeDefaults(60);
    return Loader;
}($fb01368e09cfe1f7$var$React.PureComponent);
module.exports.default = $fb01368e09cfe1f7$var$Loader;
var $fb01368e09cfe1f7$var$templateObject_1, $fb01368e09cfe1f7$var$templateObject_2, $fb01368e09cfe1f7$var$templateObject_3, $fb01368e09cfe1f7$var$templateObject_4;

});

parcelRegister("dqSh4", function(module, exports) {
"use strict";
var $9c77cdd144e15206$var$__makeTemplateObject = module.exports && module.exports.__makeTemplateObject || function(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
};
var $9c77cdd144e15206$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $9c77cdd144e15206$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result["default"] = mod;
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

/** @jsx jsx */ var $9c77cdd144e15206$var$React = $9c77cdd144e15206$var$__importStar((parcelRequire("acw62")));

var $f5Egd = parcelRequire("f5Egd");
var $6xSYO = parcelRequire("6xSYO");

var $lFbni = parcelRequire("lFbni");
var $9c77cdd144e15206$var$fade = $f5Egd.keyframes($9c77cdd144e15206$var$templateObject_1 || ($9c77cdd144e15206$var$templateObject_1 = $9c77cdd144e15206$var$__makeTemplateObject([
    "\n  50% {opacity: 0.3}\n  100% {opacity: 1}\n"
], [
    "\n  50% {opacity: 0.3}\n  100% {opacity: 1}\n"
])));
var $9c77cdd144e15206$var$Loader = /** @class */ function(_super) {
    $9c77cdd144e15206$var$__extends(Loader, _super);
    function Loader() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.radius = 20;
        _this.quarter = _this.radius / 2 + _this.radius / 5.5;
        _this.style = function(i) {
            var _a = _this.props, height = _a.height, width = _a.width, margin = _a.margin, color = _a.color, radius = _a.radius, widthUnit = _a.widthUnit, heightUnit = _a.heightUnit, radiusUnit = _a.radiusUnit;
            return $6xSYO.default($9c77cdd144e15206$var$templateObject_2 || ($9c77cdd144e15206$var$templateObject_2 = $9c77cdd144e15206$var$__makeTemplateObject([
                "\n      position: absolute;\n      width: ",
                ";\n      height: ",
                ";\n      margin: ",
                ";\n      background-color: ",
                ";\n      border-radius: ",
                ';\n      transition: 2s;\n      animation-fill-mode: "both";\n      animation: ',
                " 1.2s ",
                "s infinite ease-in-out;\n    "
            ], [
                "\n      position: absolute;\n      width: ",
                ";\n      height: ",
                ";\n      margin: ",
                ";\n      background-color: ",
                ";\n      border-radius: ",
                ';\n      transition: 2s;\n      animation-fill-mode: "both";\n      animation: ',
                " 1.2s ",
                "s infinite ease-in-out;\n    "
            ])), "" + width + widthUnit, "" + height + heightUnit, margin, color, "" + radius + radiusUnit, $9c77cdd144e15206$var$fade, i * 0.12);
        };
        _this.wrapper = function() {
            return $6xSYO.default($9c77cdd144e15206$var$templateObject_3 || ($9c77cdd144e15206$var$templateObject_3 = $9c77cdd144e15206$var$__makeTemplateObject([
                "\n      position: relative;\n      font-size: 0;\n      top: ",
                "px;\n      left: ",
                "px;\n      width: ",
                "px;\n      height: ",
                "px;\n    "
            ], [
                "\n      position: relative;\n      font-size: 0;\n      top: ",
                "px;\n      left: ",
                "px;\n      width: ",
                "px;\n      height: ",
                "px;\n    "
            ])), _this.radius, _this.radius, _this.radius * 3, _this.radius * 3);
        };
        _this.a = function() {
            return $6xSYO.default($9c77cdd144e15206$var$templateObject_4 || ($9c77cdd144e15206$var$templateObject_4 = $9c77cdd144e15206$var$__makeTemplateObject([
                "\n    ",
                ";\n    top: ",
                "px;\n    left: 0;\n  "
            ], [
                "\n    ",
                ";\n    top: ",
                "px;\n    left: 0;\n  "
            ])), _this.style(1), _this.radius);
        };
        _this.b = function() {
            return $6xSYO.default($9c77cdd144e15206$var$templateObject_5 || ($9c77cdd144e15206$var$templateObject_5 = $9c77cdd144e15206$var$__makeTemplateObject([
                "\n    ",
                ";\n    top: ",
                "px;\n    left: ",
                "px;\n    transform: rotate(-45deg);\n  "
            ], [
                "\n    ",
                ";\n    top: ",
                "px;\n    left: ",
                "px;\n    transform: rotate(-45deg);\n  "
            ])), _this.style(2), _this.quarter, _this.quarter);
        };
        _this.c = function() {
            return $6xSYO.default($9c77cdd144e15206$var$templateObject_6 || ($9c77cdd144e15206$var$templateObject_6 = $9c77cdd144e15206$var$__makeTemplateObject([
                "\n    ",
                ";\n    top: 0;\n    left: ",
                "px;\n    transform: rotate(90deg);\n  "
            ], [
                "\n    ",
                ";\n    top: 0;\n    left: ",
                "px;\n    transform: rotate(90deg);\n  "
            ])), _this.style(3), _this.radius);
        };
        _this.d = function() {
            return $6xSYO.default($9c77cdd144e15206$var$templateObject_7 || ($9c77cdd144e15206$var$templateObject_7 = $9c77cdd144e15206$var$__makeTemplateObject([
                "\n    ",
                ";\n    top: ",
                "px;\n    left: ",
                "px;\n    transform: rotate(45deg);\n  "
            ], [
                "\n    ",
                ";\n    top: ",
                "px;\n    left: ",
                "px;\n    transform: rotate(45deg);\n  "
            ])), _this.style(4), -_this.quarter, _this.quarter);
        };
        _this.e = function() {
            return $6xSYO.default($9c77cdd144e15206$var$templateObject_8 || ($9c77cdd144e15206$var$templateObject_8 = $9c77cdd144e15206$var$__makeTemplateObject([
                "\n    ",
                ";\n    top: ",
                "px;\n    left: 0;\n  "
            ], [
                "\n    ",
                ";\n    top: ",
                "px;\n    left: 0;\n  "
            ])), _this.style(5), -_this.radius);
        };
        _this.f = function() {
            return $6xSYO.default($9c77cdd144e15206$var$templateObject_9 || ($9c77cdd144e15206$var$templateObject_9 = $9c77cdd144e15206$var$__makeTemplateObject([
                "\n    ",
                ";\n    top: ",
                "px;\n    left: ",
                "px;\n    transform: rotate(-45deg);\n  "
            ], [
                "\n    ",
                ";\n    top: ",
                "px;\n    left: ",
                "px;\n    transform: rotate(-45deg);\n  "
            ])), _this.style(6), -_this.quarter, -_this.quarter);
        };
        _this.g = function() {
            return $6xSYO.default($9c77cdd144e15206$var$templateObject_10 || ($9c77cdd144e15206$var$templateObject_10 = $9c77cdd144e15206$var$__makeTemplateObject([
                "\n    ",
                ";\n    top: 0;\n    left: ",
                "px;\n    transform: rotate(90deg);\n  "
            ], [
                "\n    ",
                ";\n    top: 0;\n    left: ",
                "px;\n    transform: rotate(90deg);\n  "
            ])), _this.style(7), -_this.radius);
        };
        _this.h = function() {
            return $6xSYO.default($9c77cdd144e15206$var$templateObject_11 || ($9c77cdd144e15206$var$templateObject_11 = $9c77cdd144e15206$var$__makeTemplateObject([
                "\n    ",
                ";\n    top: ",
                "px;\n    left: ",
                "px;\n    transform: rotate(45deg);\n  "
            ], [
                "\n    ",
                ";\n    top: ",
                "px;\n    left: ",
                "px;\n    transform: rotate(45deg);\n  "
            ])), _this.style(8), _this.quarter, -_this.quarter);
        };
        return _this;
    }
    Loader.prototype.render = function() {
        var _a = this.props, loading = _a.loading, css = _a.css;
        return loading ? $f5Egd.jsx("div", {
            css: [
                this.wrapper(),
                css
            ]
        }, $f5Egd.jsx("div", {
            css: this.a()
        }), $f5Egd.jsx("div", {
            css: this.b()
        }), $f5Egd.jsx("div", {
            css: this.c()
        }), $f5Egd.jsx("div", {
            css: this.d()
        }), $f5Egd.jsx("div", {
            css: this.e()
        }), $f5Egd.jsx("div", {
            css: this.f()
        }), $f5Egd.jsx("div", {
            css: this.g()
        }), $f5Egd.jsx("div", {
            css: this.h()
        })) : null;
    };
    Loader.defaultProps = $lFbni.heightWidthRadiusDefaults(15, 5, 2);
    return Loader;
}($9c77cdd144e15206$var$React.PureComponent);
module.exports.default = $9c77cdd144e15206$var$Loader;
var $9c77cdd144e15206$var$templateObject_1, $9c77cdd144e15206$var$templateObject_2, $9c77cdd144e15206$var$templateObject_3, $9c77cdd144e15206$var$templateObject_4, $9c77cdd144e15206$var$templateObject_5, $9c77cdd144e15206$var$templateObject_6, $9c77cdd144e15206$var$templateObject_7, $9c77cdd144e15206$var$templateObject_8, $9c77cdd144e15206$var$templateObject_9, $9c77cdd144e15206$var$templateObject_10, $9c77cdd144e15206$var$templateObject_11;

});

parcelRegister("is6Hc", function(module, exports) {
"use strict";
var $d6f00923c2dbbe55$var$__makeTemplateObject = module.exports && module.exports.__makeTemplateObject || function(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
};
var $d6f00923c2dbbe55$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $d6f00923c2dbbe55$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result["default"] = mod;
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

/** @jsx jsx */ var $d6f00923c2dbbe55$var$React = $d6f00923c2dbbe55$var$__importStar((parcelRequire("acw62")));

var $f5Egd = parcelRequire("f5Egd");
var $6xSYO = parcelRequire("6xSYO");

var $lFbni = parcelRequire("lFbni");
var $d6f00923c2dbbe55$var$grid = $f5Egd.keyframes($d6f00923c2dbbe55$var$templateObject_1 || ($d6f00923c2dbbe55$var$templateObject_1 = $d6f00923c2dbbe55$var$__makeTemplateObject([
    "\n  0% {transform: scale(1)}\n  50% {transform: scale(0.5); opacity: 0.7}\n  100% {transform: scale(1);opacity: 1}\n"
], [
    "\n  0% {transform: scale(1)}\n  50% {transform: scale(0.5); opacity: 0.7}\n  100% {transform: scale(1);opacity: 1}\n"
])));
var $d6f00923c2dbbe55$var$random = function(top) {
    return Math.random() * top;
};
var $d6f00923c2dbbe55$var$Loader = /** @class */ function(_super) {
    $d6f00923c2dbbe55$var$__extends(Loader, _super);
    function Loader() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.style = function(rand) {
            var _a = _this.props, color = _a.color, size = _a.size, sizeUnit = _a.sizeUnit, margin = _a.margin;
            return $6xSYO.default($d6f00923c2dbbe55$var$templateObject_2 || ($d6f00923c2dbbe55$var$templateObject_2 = $d6f00923c2dbbe55$var$__makeTemplateObject([
                "\n      display: inline-block;\n      background-color: ",
                ";\n      width: ",
                ";\n      height: ",
                ";\n      margin: ",
                ';\n      border-radius: 100%;\n      animation-fill-mode: "both";\n      animation: ',
                " ",
                "s ",
                "s infinite ease;\n    "
            ], [
                "\n      display: inline-block;\n      background-color: ",
                ";\n      width: ",
                ";\n      height: ",
                ";\n      margin: ",
                ';\n      border-radius: 100%;\n      animation-fill-mode: "both";\n      animation: ',
                " ",
                "s ",
                "s infinite ease;\n    "
            ])), color, "" + size + sizeUnit, "" + size + sizeUnit, margin, $d6f00923c2dbbe55$var$grid, rand / 100 + 0.6, rand / 100 - 0.2);
        };
        _this.wrapper = function() {
            var _a = _this.props, size = _a.size, sizeUnit = _a.sizeUnit, margin = _a.margin;
            return $6xSYO.default($d6f00923c2dbbe55$var$templateObject_3 || ($d6f00923c2dbbe55$var$templateObject_3 = $d6f00923c2dbbe55$var$__makeTemplateObject([
                "\n      width: ",
                ";\n      font-size: 0;\n    "
            ], [
                "\n      width: ",
                ";\n      font-size: 0;\n    "
            ])), "" + (parseFloat(size.toString()) * 3 + parseFloat(margin) * 6) + sizeUnit);
        };
        return _this;
    }
    Loader.prototype.render = function() {
        var _a = this.props, loading = _a.loading, css = _a.css;
        return loading ? $f5Egd.jsx("div", {
            css: [
                this.wrapper(),
                css
            ]
        }, $f5Egd.jsx("div", {
            css: this.style($d6f00923c2dbbe55$var$random(100))
        }), $f5Egd.jsx("div", {
            css: this.style($d6f00923c2dbbe55$var$random(100))
        }), $f5Egd.jsx("div", {
            css: this.style($d6f00923c2dbbe55$var$random(100))
        }), $f5Egd.jsx("div", {
            css: this.style($d6f00923c2dbbe55$var$random(100))
        }), $f5Egd.jsx("div", {
            css: this.style($d6f00923c2dbbe55$var$random(100))
        }), $f5Egd.jsx("div", {
            css: this.style($d6f00923c2dbbe55$var$random(100))
        }), $f5Egd.jsx("div", {
            css: this.style($d6f00923c2dbbe55$var$random(100))
        }), $f5Egd.jsx("div", {
            css: this.style($d6f00923c2dbbe55$var$random(100))
        }), $f5Egd.jsx("div", {
            css: this.style($d6f00923c2dbbe55$var$random(100))
        })) : null;
    };
    Loader.defaultProps = $lFbni.sizeMarginDefaults(15);
    return Loader;
}($d6f00923c2dbbe55$var$React.PureComponent);
module.exports.default = $d6f00923c2dbbe55$var$Loader;
var $d6f00923c2dbbe55$var$templateObject_1, $d6f00923c2dbbe55$var$templateObject_2, $d6f00923c2dbbe55$var$templateObject_3;

});

parcelRegister("2sl9j", function(module, exports) {
"use strict";
var $1c9e9a115e0b1b79$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $1c9e9a115e0b1b79$var$__makeTemplateObject = module.exports && module.exports.__makeTemplateObject || function(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
};
var $1c9e9a115e0b1b79$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result["default"] = mod;
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

/** @jsx jsx */ var $1c9e9a115e0b1b79$var$React = $1c9e9a115e0b1b79$var$__importStar((parcelRequire("acw62")));

var $f5Egd = parcelRequire("f5Egd");
var $6xSYO = parcelRequire("6xSYO");

var $lFbni = parcelRequire("lFbni");
var $1c9e9a115e0b1b79$var$Loader = /** @class */ function(_super) {
    $1c9e9a115e0b1b79$var$__extends(Loader, _super);
    function Loader() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.thickness = function() {
            var size = _this.props.size;
            return size / 5;
        };
        _this.lat = function() {
            var size = _this.props.size;
            return (size - _this.thickness()) / 2;
        };
        _this.offset = function() {
            return _this.lat() - _this.thickness();
        };
        _this.color = function() {
            var color = _this.props.color;
            return $lFbni.calculateRgba(color, 0.75);
        };
        _this.before = function() {
            var _a = _this.props, size = _a.size, sizeUnit = _a.sizeUnit;
            var color = _this.color();
            var lat = _this.lat();
            var thickness = _this.thickness();
            var offset = _this.offset();
            return $f5Egd.keyframes($1c9e9a115e0b1b79$var$templateObject_1 || ($1c9e9a115e0b1b79$var$templateObject_1 = $1c9e9a115e0b1b79$var$__makeTemplateObject([
                "\n      0% {width: ",
                "px;box-shadow: ",
                "px ",
                "px ",
                ", ",
                "px ",
                "px ",
                "}\n      35% {width: ",
                ";box-shadow: 0 ",
                "px ",
                ", 0 ",
                "px ",
                "}\n      70% {width: ",
                "px;box-shadow: ",
                "px ",
                "px ",
                ", ",
                "px ",
                "px ",
                "}\n      100% {box-shadow: ",
                "px ",
                "px ",
                ", ",
                "px ",
                "px ",
                "}\n    "
            ], [
                "\n      0% {width: ",
                "px;box-shadow: ",
                "px ",
                "px ",
                ", ",
                "px ",
                "px ",
                "}\n      35% {width: ",
                ";box-shadow: 0 ",
                "px ",
                ", 0 ",
                "px ",
                "}\n      70% {width: ",
                "px;box-shadow: ",
                "px ",
                "px ",
                ", ",
                "px ",
                "px ",
                "}\n      100% {box-shadow: ",
                "px ",
                "px ",
                ", ",
                "px ",
                "px ",
                "}\n    "
            ])), thickness, lat, -offset, color, -lat, offset, color, "" + size + sizeUnit, -offset, color, offset, color, thickness, -lat, -offset, color, lat, offset, color, lat, -offset, color, -lat, offset, color);
        };
        _this.after = function() {
            var _a = _this.props, size = _a.size, sizeUnit = _a.sizeUnit;
            var color = _this.color();
            var lat = _this.lat();
            var thickness = _this.thickness();
            var offset = _this.offset();
            return $f5Egd.keyframes($1c9e9a115e0b1b79$var$templateObject_2 || ($1c9e9a115e0b1b79$var$templateObject_2 = $1c9e9a115e0b1b79$var$__makeTemplateObject([
                "\n      0% {height: ",
                "px;box-shadow: ",
                "px ",
                "px ",
                ", ",
                "px ",
                "px ",
                "}\n      35% {height: ",
                ";box-shadow: ",
                "px 0 ",
                ", ",
                "px 0 ",
                "}\n      70% {height: ",
                "px;box-shadow: ",
                "px ",
                "px ",
                ", ",
                "px ",
                "px ",
                "}\n      100% {box-shadow: ",
                "px ",
                "px ",
                ", ",
                "px ",
                "px ",
                "}\n    "
            ], [
                "\n      0% {height: ",
                "px;box-shadow: ",
                "px ",
                "px ",
                ", ",
                "px ",
                "px ",
                "}\n      35% {height: ",
                ";box-shadow: ",
                "px 0 ",
                ", ",
                "px 0 ",
                "}\n      70% {height: ",
                "px;box-shadow: ",
                "px ",
                "px ",
                ", ",
                "px ",
                "px ",
                "}\n      100% {box-shadow: ",
                "px ",
                "px ",
                ", ",
                "px ",
                "px ",
                "}\n    "
            ])), thickness, offset, lat, color, -offset, -lat, color, "" + size + sizeUnit, offset, color, -offset, color, thickness, offset, -lat, color, -offset, lat, color, offset, lat, color, -offset, -lat, color);
        };
        _this.style = function(i) {
            var _a = _this.props, size = _a.size, sizeUnit = _a.sizeUnit;
            return $6xSYO.default($1c9e9a115e0b1b79$var$templateObject_3 || ($1c9e9a115e0b1b79$var$templateObject_3 = $1c9e9a115e0b1b79$var$__makeTemplateObject([
                '\n      position: absolute;\n      content: "";\n      top: 50%;\n      left: 50%;\n      display: block;\n      width: ',
                ";\n      height: ",
                ";\n      border-radius: ",
                ";\n      transform: translate(-50%, -50%);\n      animation-fill-mode: none;\n      animation: ",
                " 2s infinite;\n    "
            ], [
                '\n      position: absolute;\n      content: "";\n      top: 50%;\n      left: 50%;\n      display: block;\n      width: ',
                ";\n      height: ",
                ";\n      border-radius: ",
                ";\n      transform: translate(-50%, -50%);\n      animation-fill-mode: none;\n      animation: ",
                " 2s infinite;\n    "
            ])), "" + size / 5 + sizeUnit, "" + size / 5 + sizeUnit, "" + size / 10 + sizeUnit, i === 1 ? _this.before() : _this.after());
        };
        _this.wrapper = function() {
            var _a = _this.props, size = _a.size, sizeUnit = _a.sizeUnit;
            return $6xSYO.default($1c9e9a115e0b1b79$var$templateObject_4 || ($1c9e9a115e0b1b79$var$templateObject_4 = $1c9e9a115e0b1b79$var$__makeTemplateObject([
                "\n      position: relative;\n      width: ",
                ";\n      height: ",
                ";\n      transform: rotate(165deg);\n    "
            ], [
                "\n      position: relative;\n      width: ",
                ";\n      height: ",
                ";\n      transform: rotate(165deg);\n    "
            ])), "" + size + sizeUnit, "" + size + sizeUnit);
        };
        return _this;
    }
    Loader.prototype.render = function() {
        var _a = this.props, loading = _a.loading, css = _a.css;
        return loading ? $f5Egd.jsx("div", {
            css: [
                this.wrapper(),
                css
            ]
        }, $f5Egd.jsx("div", {
            css: this.style(1)
        }), $f5Egd.jsx("div", {
            css: this.style(2)
        })) : null;
    };
    Loader.defaultProps = $lFbni.sizeDefaults(50);
    return Loader;
}($1c9e9a115e0b1b79$var$React.PureComponent);
module.exports.default = $1c9e9a115e0b1b79$var$Loader;
var $1c9e9a115e0b1b79$var$templateObject_1, $1c9e9a115e0b1b79$var$templateObject_2, $1c9e9a115e0b1b79$var$templateObject_3, $1c9e9a115e0b1b79$var$templateObject_4;

});

parcelRegister("8tznc", function(module, exports) {
"use strict";
var $62bc788a83c2dbb6$var$__makeTemplateObject = module.exports && module.exports.__makeTemplateObject || function(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
};
var $62bc788a83c2dbb6$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $62bc788a83c2dbb6$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result["default"] = mod;
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

/** @jsx jsx */ var $62bc788a83c2dbb6$var$React = $62bc788a83c2dbb6$var$__importStar((parcelRequire("acw62")));

var $f5Egd = parcelRequire("f5Egd");
var $6xSYO = parcelRequire("6xSYO");

var $lFbni = parcelRequire("lFbni");
var $62bc788a83c2dbb6$var$moon = $f5Egd.keyframes($62bc788a83c2dbb6$var$templateObject_1 || ($62bc788a83c2dbb6$var$templateObject_1 = $62bc788a83c2dbb6$var$__makeTemplateObject([
    "\n  100% {transform: rotate(360deg)}\n"
], [
    "\n  100% {transform: rotate(360deg)}\n"
])));
var $62bc788a83c2dbb6$var$Loader = /** @class */ function(_super) {
    $62bc788a83c2dbb6$var$__extends(Loader, _super);
    function Loader() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.moonSize = function() {
            var size = _this.props.size;
            return size / 7;
        };
        _this.ballStyle = function(size) {
            var sizeUnit = _this.props.sizeUnit;
            return $6xSYO.default($62bc788a83c2dbb6$var$templateObject_2 || ($62bc788a83c2dbb6$var$templateObject_2 = $62bc788a83c2dbb6$var$__makeTemplateObject([
                "\n      width: ",
                ";\n      height: ",
                ";\n      border-radius: 100%;\n    "
            ], [
                "\n      width: ",
                ";\n      height: ",
                ";\n      border-radius: 100%;\n    "
            ])), "" + size + sizeUnit, "" + size + sizeUnit);
        };
        _this.wrapper = function() {
            var _a = _this.props, size = _a.size, sizeUnit = _a.sizeUnit;
            return $6xSYO.default($62bc788a83c2dbb6$var$templateObject_3 || ($62bc788a83c2dbb6$var$templateObject_3 = $62bc788a83c2dbb6$var$__makeTemplateObject([
                "\n      position: relative;\n      width: ",
                ";\n      height: ",
                ";\n      animation: ",
                " 0.6s 0s infinite linear;\n      animation-fill-mode: forwards;\n    "
            ], [
                "\n      position: relative;\n      width: ",
                ";\n      height: ",
                ";\n      animation: ",
                " 0.6s 0s infinite linear;\n      animation-fill-mode: forwards;\n    "
            ])), "" + (size + _this.moonSize() * 2) + sizeUnit, "" + (size + _this.moonSize() * 2) + sizeUnit, $62bc788a83c2dbb6$var$moon);
        };
        _this.ball = function() {
            var _a = _this.props, color = _a.color, size = _a.size, sizeUnit = _a.sizeUnit;
            return $6xSYO.default($62bc788a83c2dbb6$var$templateObject_4 || ($62bc788a83c2dbb6$var$templateObject_4 = $62bc788a83c2dbb6$var$__makeTemplateObject([
                "\n      ",
                ";\n      background-color: ",
                ";\n      opacity: 0.8;\n      position: absolute;\n      top: ",
                ";\n      animation: ",
                " 0.6s 0s infinite linear;\n      animation-fill-mode: forwards;\n    "
            ], [
                "\n      ",
                ";\n      background-color: ",
                ";\n      opacity: 0.8;\n      position: absolute;\n      top: ",
                ";\n      animation: ",
                " 0.6s 0s infinite linear;\n      animation-fill-mode: forwards;\n    "
            ])), _this.ballStyle(_this.moonSize()), color, "" + (size / 2 - _this.moonSize() / 2) + sizeUnit, $62bc788a83c2dbb6$var$moon);
        };
        _this.circle = function() {
            var _a = _this.props, size = _a.size, color = _a.color;
            return $6xSYO.default($62bc788a83c2dbb6$var$templateObject_5 || ($62bc788a83c2dbb6$var$templateObject_5 = $62bc788a83c2dbb6$var$__makeTemplateObject([
                "\n      ",
                ";\n      border: ",
                "px solid ",
                ";\n      opacity: 0.1;\n    "
            ], [
                "\n      ",
                ";\n      border: ",
                "px solid ",
                ";\n      opacity: 0.1;\n    "
            ])), _this.ballStyle(size), _this.moonSize(), color);
        };
        return _this;
    }
    Loader.prototype.render = function() {
        var _a = this.props, loading = _a.loading, css = _a.css;
        return loading ? $f5Egd.jsx("div", {
            css: [
                this.wrapper(),
                css
            ]
        }, $f5Egd.jsx("div", {
            css: this.ball()
        }), $f5Egd.jsx("div", {
            css: this.circle()
        })) : null;
    };
    Loader.defaultProps = $lFbni.sizeDefaults(60);
    return Loader;
}($62bc788a83c2dbb6$var$React.PureComponent);
module.exports.default = $62bc788a83c2dbb6$var$Loader;
var $62bc788a83c2dbb6$var$templateObject_1, $62bc788a83c2dbb6$var$templateObject_2, $62bc788a83c2dbb6$var$templateObject_3, $62bc788a83c2dbb6$var$templateObject_4, $62bc788a83c2dbb6$var$templateObject_5;

});

parcelRegister("1clyG", function(module, exports) {
"use strict";
var $0df7a27df3bc0f31$var$__makeTemplateObject = module.exports && module.exports.__makeTemplateObject || function(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
};
var $0df7a27df3bc0f31$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $0df7a27df3bc0f31$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result["default"] = mod;
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

/** @jsx jsx */ var $0df7a27df3bc0f31$var$React = $0df7a27df3bc0f31$var$__importStar((parcelRequire("acw62")));

var $f5Egd = parcelRequire("f5Egd");
var $6xSYO = parcelRequire("6xSYO");

var $lFbni = parcelRequire("lFbni");
var $0df7a27df3bc0f31$var$pacman = [
    $f5Egd.keyframes($0df7a27df3bc0f31$var$templateObject_1 || ($0df7a27df3bc0f31$var$templateObject_1 = $0df7a27df3bc0f31$var$__makeTemplateObject([
        "\n    0% {transform: rotate(0deg)}\n    50% {transform: rotate(-44deg)}\n  "
    ], [
        "\n    0% {transform: rotate(0deg)}\n    50% {transform: rotate(-44deg)}\n  "
    ]))),
    $f5Egd.keyframes($0df7a27df3bc0f31$var$templateObject_2 || ($0df7a27df3bc0f31$var$templateObject_2 = $0df7a27df3bc0f31$var$__makeTemplateObject([
        "\n    0% {transform: rotate(0deg)}\n    50% {transform: rotate(44deg)}\n  "
    ], [
        "\n    0% {transform: rotate(0deg)}\n    50% {transform: rotate(44deg)}\n  "
    ])))
];
var $0df7a27df3bc0f31$var$Loader = /** @class */ function(_super) {
    $0df7a27df3bc0f31$var$__extends(Loader, _super);
    function Loader() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.ball = function() {
            var _a = _this.props, size = _a.size, sizeUnit = _a.sizeUnit;
            return $f5Egd.keyframes($0df7a27df3bc0f31$var$templateObject_3 || ($0df7a27df3bc0f31$var$templateObject_3 = $0df7a27df3bc0f31$var$__makeTemplateObject([
                "\n      75% {opacity: 0.7}\n      100% {transform: translate(",
                ", ",
                ")}\n    "
            ], [
                "\n      75% {opacity: 0.7}\n      100% {transform: translate(",
                ", ",
                ")}\n    "
            ])), "" + -4 * size + sizeUnit, "" + -size / 4 + sizeUnit);
        };
        _this.ballStyle = function(i) {
            var _a = _this.props, color = _a.color, margin = _a.margin, size = _a.size, sizeUnit = _a.sizeUnit;
            return $6xSYO.default($0df7a27df3bc0f31$var$templateObject_4 || ($0df7a27df3bc0f31$var$templateObject_4 = $0df7a27df3bc0f31$var$__makeTemplateObject([
                "\n      width: ",
                ";\n      height: ",
                ";\n      background-color: ",
                ";\n      margin: ",
                ";\n      border-radius: 100%;\n      transform: translate(0, ",
                ");\n      position: absolute;\n      top: ",
                ";\n      left: ",
                ";\n      animation: ",
                " 1s ",
                "s infinite linear;\n      animation-fill-mode: both;\n    "
            ], [
                "\n      width: ",
                ";\n      height: ",
                ";\n      background-color: ",
                ";\n      margin: ",
                ";\n      border-radius: 100%;\n      transform: translate(0, ",
                ");\n      position: absolute;\n      top: ",
                ";\n      left: ",
                ";\n      animation: ",
                " 1s ",
                "s infinite linear;\n      animation-fill-mode: both;\n    "
            ])), "" + size / 3 + sizeUnit, "" + size / 3 + sizeUnit, color, margin, "" + -size / 4 + sizeUnit, "" + size + sizeUnit, "" + size * 4 + sizeUnit, _this.ball(), i * 0.25);
        };
        _this.s1 = function() {
            var _a = _this.props, size = _a.size, sizeUnit = _a.sizeUnit;
            return "" + size + sizeUnit + " solid transparent";
        };
        _this.s2 = function() {
            var _a = _this.props, size = _a.size, sizeUnit = _a.sizeUnit, color = _a.color;
            return "" + size + sizeUnit + " solid " + color;
        };
        _this.pacmanStyle = function(i) {
            var _a = _this.props, size = _a.size, sizeUnit = _a.sizeUnit;
            var s1 = _this.s1();
            var s2 = _this.s2();
            return $6xSYO.default($0df7a27df3bc0f31$var$templateObject_5 || ($0df7a27df3bc0f31$var$templateObject_5 = $0df7a27df3bc0f31$var$__makeTemplateObject([
                "\n      width: 0;\n      height: 0;\n      border-right: ",
                ";\n      border-top: ",
                ";\n      border-left: ",
                ";\n      border-bottom: ",
                ";\n      border-radius: ",
                ";\n      position: absolute;\n      animation: ",
                " 0.8s infinite ease-in-out;\n      animation-fill-mode: both;\n    "
            ], [
                "\n      width: 0;\n      height: 0;\n      border-right: ",
                ";\n      border-top: ",
                ";\n      border-left: ",
                ";\n      border-bottom: ",
                ";\n      border-radius: ",
                ";\n      position: absolute;\n      animation: ",
                " 0.8s infinite ease-in-out;\n      animation-fill-mode: both;\n    "
            ])), s1, i === 0 ? s1 : s2, s2, i === 0 ? s2 : s1, "" + size + sizeUnit, $0df7a27df3bc0f31$var$pacman[i]);
        };
        _this.wrapper = function() {
            var _a = _this.props, size = _a.size, sizeUnit = _a.sizeUnit;
            return $6xSYO.default($0df7a27df3bc0f31$var$templateObject_6 || ($0df7a27df3bc0f31$var$templateObject_6 = $0df7a27df3bc0f31$var$__makeTemplateObject([
                "\n      position: relative;\n      font-size: 0;\n      height: ",
                ";\n      width: ",
                ";\n    "
            ], [
                "\n      position: relative;\n      font-size: 0;\n      height: ",
                ";\n      width: ",
                ";\n    "
            ])), "" + size + sizeUnit, "" + size + sizeUnit);
        };
        _this.pac = function() {
            return _this.pacmanStyle(0);
        };
        _this.man = function() {
            return _this.pacmanStyle(1);
        };
        return _this;
    }
    Loader.prototype.render = function() {
        var _a = this.props, loading = _a.loading, css = _a.css;
        return loading ? $f5Egd.jsx("div", {
            css: [
                this.wrapper(),
                css
            ]
        }, $f5Egd.jsx("div", {
            css: this.pac()
        }), $f5Egd.jsx("div", {
            css: this.man()
        }), $f5Egd.jsx("div", {
            css: this.ballStyle(2)
        }), $f5Egd.jsx("div", {
            css: this.ballStyle(3)
        }), $f5Egd.jsx("div", {
            css: this.ballStyle(4)
        }), $f5Egd.jsx("div", {
            css: this.ballStyle(5)
        })) : null;
    };
    Loader.defaultProps = $lFbni.sizeMarginDefaults(25);
    return Loader;
}($0df7a27df3bc0f31$var$React.PureComponent);
module.exports.default = $0df7a27df3bc0f31$var$Loader;
var $0df7a27df3bc0f31$var$templateObject_1, $0df7a27df3bc0f31$var$templateObject_2, $0df7a27df3bc0f31$var$templateObject_3, $0df7a27df3bc0f31$var$templateObject_4, $0df7a27df3bc0f31$var$templateObject_5, $0df7a27df3bc0f31$var$templateObject_6;

});

parcelRegister("iVhwF", function(module, exports) {
"use strict";
var $dc6b2528a79a494e$var$__makeTemplateObject = module.exports && module.exports.__makeTemplateObject || function(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
};
var $dc6b2528a79a494e$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $dc6b2528a79a494e$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result["default"] = mod;
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

/** @jsx jsx */ var $dc6b2528a79a494e$var$React = $dc6b2528a79a494e$var$__importStar((parcelRequire("acw62")));

var $f5Egd = parcelRequire("f5Egd");
var $6xSYO = parcelRequire("6xSYO");

var $lFbni = parcelRequire("lFbni");
// 1.5 4.5 7.5
var $dc6b2528a79a494e$var$distance = [
    1,
    3,
    5
];
var $dc6b2528a79a494e$var$propagate = [
    $f5Egd.keyframes($dc6b2528a79a494e$var$templateObject_1 || ($dc6b2528a79a494e$var$templateObject_1 = $dc6b2528a79a494e$var$__makeTemplateObject([
        "\n      25% {transform: translateX(-",
        "rem) scale(0.75)}\n      50% {transform: translateX(-",
        "rem) scale(0.6)}\n      75% {transform: translateX(-",
        "rem) scale(0.5)}\n      95% {transform: translateX(0rem) scale(1)}\n    "
    ], [
        "\n      25% {transform: translateX(-",
        "rem) scale(0.75)}\n      50% {transform: translateX(-",
        "rem) scale(0.6)}\n      75% {transform: translateX(-",
        "rem) scale(0.5)}\n      95% {transform: translateX(0rem) scale(1)}\n    "
    ])), $dc6b2528a79a494e$var$distance[0], $dc6b2528a79a494e$var$distance[1], $dc6b2528a79a494e$var$distance[2]),
    $f5Egd.keyframes($dc6b2528a79a494e$var$templateObject_2 || ($dc6b2528a79a494e$var$templateObject_2 = $dc6b2528a79a494e$var$__makeTemplateObject([
        "\n      25% {transform: translateX(-",
        "rem) scale(0.75)}\n      50% {transform: translateX(-",
        "rem) scale(0.6)}\n      75% {transform: translateX(-",
        "rem) scale(0.6)}\n      95% {transform: translateX(0rem) scale(1)}\n    "
    ], [
        "\n      25% {transform: translateX(-",
        "rem) scale(0.75)}\n      50% {transform: translateX(-",
        "rem) scale(0.6)}\n      75% {transform: translateX(-",
        "rem) scale(0.6)}\n      95% {transform: translateX(0rem) scale(1)}\n    "
    ])), $dc6b2528a79a494e$var$distance[0], $dc6b2528a79a494e$var$distance[1], $dc6b2528a79a494e$var$distance[1]),
    $f5Egd.keyframes($dc6b2528a79a494e$var$templateObject_3 || ($dc6b2528a79a494e$var$templateObject_3 = $dc6b2528a79a494e$var$__makeTemplateObject([
        "\n      25% {transform: translateX(-",
        "rem) scale(0.75)}\n      75% {transform: translateX(-",
        "rem) scale(0.75)}\n      95% {transform: translateX(0rem) scale(1)}\n    "
    ], [
        "\n      25% {transform: translateX(-",
        "rem) scale(0.75)}\n      75% {transform: translateX(-",
        "rem) scale(0.75)}\n      95% {transform: translateX(0rem) scale(1)}\n    "
    ])), $dc6b2528a79a494e$var$distance[0], $dc6b2528a79a494e$var$distance[0]),
    $f5Egd.keyframes($dc6b2528a79a494e$var$templateObject_4 || ($dc6b2528a79a494e$var$templateObject_4 = $dc6b2528a79a494e$var$__makeTemplateObject([
        "\n      25% {transform: translateX(",
        "rem) scale(0.75)}\n      75% {transform: translateX(",
        "rem) scale(0.75)}\n      95% {transform: translateX(0rem) scale(1)}\n    "
    ], [
        "\n      25% {transform: translateX(",
        "rem) scale(0.75)}\n      75% {transform: translateX(",
        "rem) scale(0.75)}\n      95% {transform: translateX(0rem) scale(1)}\n    "
    ])), $dc6b2528a79a494e$var$distance[0], $dc6b2528a79a494e$var$distance[0]),
    $f5Egd.keyframes($dc6b2528a79a494e$var$templateObject_5 || ($dc6b2528a79a494e$var$templateObject_5 = $dc6b2528a79a494e$var$__makeTemplateObject([
        "\n      25% {transform: translateX(",
        "rem) scale(0.75)}\n      50% {transform: translateX(",
        "rem) scale(0.6)}\n      75% {transform: translateX(",
        "rem) scale(0.6)}\n      95% {transform: translateX(0rem) scale(1)}\n    "
    ], [
        "\n      25% {transform: translateX(",
        "rem) scale(0.75)}\n      50% {transform: translateX(",
        "rem) scale(0.6)}\n      75% {transform: translateX(",
        "rem) scale(0.6)}\n      95% {transform: translateX(0rem) scale(1)}\n    "
    ])), $dc6b2528a79a494e$var$distance[0], $dc6b2528a79a494e$var$distance[1], $dc6b2528a79a494e$var$distance[1]),
    $f5Egd.keyframes($dc6b2528a79a494e$var$templateObject_6 || ($dc6b2528a79a494e$var$templateObject_6 = $dc6b2528a79a494e$var$__makeTemplateObject([
        "\n      25% {transform: translateX(",
        "rem) scale(0.75)}\n      50% {transform: translateX(",
        "rem) scale(0.6)}\n      75% {transform: translateX(",
        "rem) scale(0.5)}\n      95% {transform: translateX(0rem) scale(1)}\n    "
    ], [
        "\n      25% {transform: translateX(",
        "rem) scale(0.75)}\n      50% {transform: translateX(",
        "rem) scale(0.6)}\n      75% {transform: translateX(",
        "rem) scale(0.5)}\n      95% {transform: translateX(0rem) scale(1)}\n    "
    ])), $dc6b2528a79a494e$var$distance[0], $dc6b2528a79a494e$var$distance[1], $dc6b2528a79a494e$var$distance[2])
];
var $dc6b2528a79a494e$var$Loader = /** @class */ function(_super) {
    $dc6b2528a79a494e$var$__extends(Loader, _super);
    function Loader() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.style = function(i) {
            var _a = _this.props, size = _a.size, sizeUnit = _a.sizeUnit, color = _a.color;
            return $6xSYO.default($dc6b2528a79a494e$var$templateObject_7 || ($dc6b2528a79a494e$var$templateObject_7 = $dc6b2528a79a494e$var$__makeTemplateObject([
                "\n      position: absolute;\n      font-size: ",
                ";\n      width: ",
                ";\n      height: ",
                ";\n      background: ",
                ";\n      border-radius: 50%;\n      animation: ",
                " 1.5s infinite;\n      animation-fill-mode: forwards;\n    "
            ], [
                "\n      position: absolute;\n      font-size: ",
                ";\n      width: ",
                ";\n      height: ",
                ";\n      background: ",
                ";\n      border-radius: 50%;\n      animation: ",
                " 1.5s infinite;\n      animation-fill-mode: forwards;\n    "
            ])), "" + size / 3 + sizeUnit, "" + size + sizeUnit, "" + size + sizeUnit, color, $dc6b2528a79a494e$var$propagate[i]);
        };
        _this.wrapper = function() {
            return $6xSYO.default($dc6b2528a79a494e$var$templateObject_8 || ($dc6b2528a79a494e$var$templateObject_8 = $dc6b2528a79a494e$var$__makeTemplateObject([
                "\n      position: relative;\n    "
            ], [
                "\n      position: relative;\n    "
            ])));
        };
        return _this;
    }
    Loader.prototype.render = function() {
        var _a = this.props, loading = _a.loading, css = _a.css;
        return loading ? $f5Egd.jsx("div", {
            css: [
                this.wrapper(),
                css
            ]
        }, $f5Egd.jsx("div", {
            css: this.style(0)
        }), $f5Egd.jsx("div", {
            css: this.style(1)
        }), $f5Egd.jsx("div", {
            css: this.style(2)
        }), $f5Egd.jsx("div", {
            css: this.style(3)
        }), $f5Egd.jsx("div", {
            css: this.style(4)
        }), $f5Egd.jsx("div", {
            css: this.style(5)
        })) : null;
    };
    Loader.defaultProps = $lFbni.sizeDefaults(15);
    return Loader;
}($dc6b2528a79a494e$var$React.PureComponent);
module.exports.default = $dc6b2528a79a494e$var$Loader;
var $dc6b2528a79a494e$var$templateObject_1, $dc6b2528a79a494e$var$templateObject_2, $dc6b2528a79a494e$var$templateObject_3, $dc6b2528a79a494e$var$templateObject_4, $dc6b2528a79a494e$var$templateObject_5, $dc6b2528a79a494e$var$templateObject_6, $dc6b2528a79a494e$var$templateObject_7, $dc6b2528a79a494e$var$templateObject_8;

});

parcelRegister("76XOu", function(module, exports) {
"use strict";
var $52d77da11e098c12$var$__makeTemplateObject = module.exports && module.exports.__makeTemplateObject || function(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
};
var $52d77da11e098c12$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $52d77da11e098c12$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result["default"] = mod;
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

/** @jsx jsx */ var $52d77da11e098c12$var$React = $52d77da11e098c12$var$__importStar((parcelRequire("acw62")));

var $f5Egd = parcelRequire("f5Egd");
var $6xSYO = parcelRequire("6xSYO");

var $lFbni = parcelRequire("lFbni");
var $52d77da11e098c12$var$pulse = $f5Egd.keyframes($52d77da11e098c12$var$templateObject_1 || ($52d77da11e098c12$var$templateObject_1 = $52d77da11e098c12$var$__makeTemplateObject([
    "\n  0% {transform: scale(1);opacity: 1}\n  45% {transform: scale(0.1);opacity: 0.7}\n  80% {transform: scale(1);opacity: 1}\n"
], [
    "\n  0% {transform: scale(1);opacity: 1}\n  45% {transform: scale(0.1);opacity: 0.7}\n  80% {transform: scale(1);opacity: 1}\n"
])));
var $52d77da11e098c12$var$Loader = /** @class */ function(_super) {
    $52d77da11e098c12$var$__extends(Loader, _super);
    function Loader() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.style = function(i) {
            var _a = _this.props, color = _a.color, size = _a.size, sizeUnit = _a.sizeUnit, margin = _a.margin;
            return $6xSYO.default($52d77da11e098c12$var$templateObject_2 || ($52d77da11e098c12$var$templateObject_2 = $52d77da11e098c12$var$__makeTemplateObject([
                "\n      background-color: ",
                ";\n      width: ",
                ";\n      height: ",
                ";\n      margin: ",
                ";\n      border-radius: 100%;\n      display: inline-block;\n      animation: ",
                " 0.75s ",
                "s infinite cubic-bezier(0.2, 0.68, 0.18, 1.08);\n      animation-fill-mode: both;\n    "
            ], [
                "\n      background-color: ",
                ";\n      width: ",
                ";\n      height: ",
                ";\n      margin: ",
                ";\n      border-radius: 100%;\n      display: inline-block;\n      animation: ",
                " 0.75s ",
                "s infinite cubic-bezier(0.2, 0.68, 0.18, 1.08);\n      animation-fill-mode: both;\n    "
            ])), color, "" + size + sizeUnit, "" + size + sizeUnit, margin, $52d77da11e098c12$var$pulse, i * 0.12);
        };
        return _this;
    }
    Loader.prototype.render = function() {
        var _a = this.props, loading = _a.loading, css = _a.css;
        return loading ? $f5Egd.jsx("div", {
            css: [
                css
            ]
        }, $f5Egd.jsx("div", {
            css: this.style(1)
        }), $f5Egd.jsx("div", {
            css: this.style(2)
        }), $f5Egd.jsx("div", {
            css: this.style(3)
        })) : null;
    };
    Loader.defaultProps = $lFbni.sizeMarginDefaults(15);
    return Loader;
}($52d77da11e098c12$var$React.PureComponent);
module.exports.default = $52d77da11e098c12$var$Loader;
var $52d77da11e098c12$var$templateObject_1, $52d77da11e098c12$var$templateObject_2;

});

parcelRegister("lFGPB", function(module, exports) {
"use strict";
var $fc6ea6b4d6d9c976$var$__makeTemplateObject = module.exports && module.exports.__makeTemplateObject || function(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
};
var $fc6ea6b4d6d9c976$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $fc6ea6b4d6d9c976$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result["default"] = mod;
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

/** @jsx jsx */ var $fc6ea6b4d6d9c976$var$React = $fc6ea6b4d6d9c976$var$__importStar((parcelRequire("acw62")));

var $f5Egd = parcelRequire("f5Egd");
var $6xSYO = parcelRequire("6xSYO");

var $lFbni = parcelRequire("lFbni");
var $fc6ea6b4d6d9c976$var$right = $f5Egd.keyframes($fc6ea6b4d6d9c976$var$templateObject_1 || ($fc6ea6b4d6d9c976$var$templateObject_1 = $fc6ea6b4d6d9c976$var$__makeTemplateObject([
    "\n  0% {transform: rotateX(0deg) rotateY(0deg) rotateZ(0deg)}\n  100% {transform: rotateX(180deg) rotateY(360deg) rotateZ(360deg)}\n"
], [
    "\n  0% {transform: rotateX(0deg) rotateY(0deg) rotateZ(0deg)}\n  100% {transform: rotateX(180deg) rotateY(360deg) rotateZ(360deg)}\n"
])));
var $fc6ea6b4d6d9c976$var$left = $f5Egd.keyframes($fc6ea6b4d6d9c976$var$templateObject_2 || ($fc6ea6b4d6d9c976$var$templateObject_2 = $fc6ea6b4d6d9c976$var$__makeTemplateObject([
    "\n  0% {transform: rotateX(0deg) rotateY(0deg) rotateZ(0deg)}\n  100% {transform: rotateX(360deg) rotateY(180deg) rotateZ(360deg)}\n"
], [
    "\n  0% {transform: rotateX(0deg) rotateY(0deg) rotateZ(0deg)}\n  100% {transform: rotateX(360deg) rotateY(180deg) rotateZ(360deg)}\n"
])));
var $fc6ea6b4d6d9c976$var$Loader = /** @class */ function(_super) {
    $fc6ea6b4d6d9c976$var$__extends(Loader, _super);
    function Loader() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.style = function(i) {
            var _a = _this.props, size = _a.size, sizeUnit = _a.sizeUnit, color = _a.color;
            return $6xSYO.default($fc6ea6b4d6d9c976$var$templateObject_3 || ($fc6ea6b4d6d9c976$var$templateObject_3 = $fc6ea6b4d6d9c976$var$__makeTemplateObject([
                "\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: ",
                ";\n      height: ",
                ";\n      border: ",
                " solid ",
                ";\n      opacity: 0.4;\n      border-radius: 100%;\n      animation-fill-mode: forwards;\n      perspective: 800px;\n      animation: ",
                " 2s 0s infinite linear;\n    "
            ], [
                "\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: ",
                ";\n      height: ",
                ";\n      border: ",
                " solid ",
                ";\n      opacity: 0.4;\n      border-radius: 100%;\n      animation-fill-mode: forwards;\n      perspective: 800px;\n      animation: ",
                " 2s 0s infinite linear;\n    "
            ])), "" + size + sizeUnit, "" + size + sizeUnit, "" + size / 10 + sizeUnit, color, i === 1 ? $fc6ea6b4d6d9c976$var$right : $fc6ea6b4d6d9c976$var$left);
        };
        _this.wrapper = function() {
            var _a = _this.props, size = _a.size, sizeUnit = _a.sizeUnit;
            return $6xSYO.default($fc6ea6b4d6d9c976$var$templateObject_4 || ($fc6ea6b4d6d9c976$var$templateObject_4 = $fc6ea6b4d6d9c976$var$__makeTemplateObject([
                "\n      width: ",
                ";\n      height: ",
                ";\n      position: relative;\n    "
            ], [
                "\n      width: ",
                ";\n      height: ",
                ";\n      position: relative;\n    "
            ])), "" + size + sizeUnit, "" + size + sizeUnit);
        };
        return _this;
    }
    Loader.prototype.render = function() {
        var _a = this.props, loading = _a.loading, css = _a.css;
        return loading ? $f5Egd.jsx("div", {
            css: [
                this.wrapper(),
                css
            ]
        }, $f5Egd.jsx("div", {
            css: this.style(1)
        }), $f5Egd.jsx("div", {
            css: this.style(2)
        })) : null;
    };
    Loader.defaultProps = $lFbni.sizeDefaults(60);
    return Loader;
}($fc6ea6b4d6d9c976$var$React.PureComponent);
module.exports.default = $fc6ea6b4d6d9c976$var$Loader;
var $fc6ea6b4d6d9c976$var$templateObject_1, $fc6ea6b4d6d9c976$var$templateObject_2, $fc6ea6b4d6d9c976$var$templateObject_3, $fc6ea6b4d6d9c976$var$templateObject_4;

});

parcelRegister("dKpu9", function(module, exports) {
"use strict";
var $a023571504bd57d8$var$__makeTemplateObject = module.exports && module.exports.__makeTemplateObject || function(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
};
var $a023571504bd57d8$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $a023571504bd57d8$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result["default"] = mod;
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

/** @jsx jsx */ var $a023571504bd57d8$var$React = $a023571504bd57d8$var$__importStar((parcelRequire("acw62")));

var $f5Egd = parcelRequire("f5Egd");
var $6xSYO = parcelRequire("6xSYO");

var $lFbni = parcelRequire("lFbni");
var $a023571504bd57d8$var$riseAmount = 30;
var $a023571504bd57d8$var$even = $f5Egd.keyframes($a023571504bd57d8$var$templateObject_1 || ($a023571504bd57d8$var$templateObject_1 = $a023571504bd57d8$var$__makeTemplateObject([
    "\n  0% {transform: scale(1.1)}\n  25% {transform: translateY(-",
    "px)}\n  50% {transform: scale(0.4)}\n  75% {transform: translateY(",
    "px)}\n  100% {transform: translateY(0) scale(1.0)}\n"
], [
    "\n  0% {transform: scale(1.1)}\n  25% {transform: translateY(-",
    "px)}\n  50% {transform: scale(0.4)}\n  75% {transform: translateY(",
    "px)}\n  100% {transform: translateY(0) scale(1.0)}\n"
])), $a023571504bd57d8$var$riseAmount, $a023571504bd57d8$var$riseAmount);
var $a023571504bd57d8$var$odd = $f5Egd.keyframes($a023571504bd57d8$var$templateObject_2 || ($a023571504bd57d8$var$templateObject_2 = $a023571504bd57d8$var$__makeTemplateObject([
    "\n  0% {transform: scale(0.4)}\n  25% {transform: translateY(",
    "px)}\n  50% {transform: scale(1.1)}\n  75% {transform: translateY(",
    "px)}\n  100% {transform: translateY(0) scale(0.75)}\n"
], [
    "\n  0% {transform: scale(0.4)}\n  25% {transform: translateY(",
    "px)}\n  50% {transform: scale(1.1)}\n  75% {transform: translateY(",
    "px)}\n  100% {transform: translateY(0) scale(0.75)}\n"
])), $a023571504bd57d8$var$riseAmount, -$a023571504bd57d8$var$riseAmount);
var $a023571504bd57d8$var$Loader = /** @class */ function(_super) {
    $a023571504bd57d8$var$__extends(Loader, _super);
    function Loader() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.style = function(i) {
            var _a = _this.props, color = _a.color, size = _a.size, sizeUnit = _a.sizeUnit, margin = _a.margin;
            return $6xSYO.default($a023571504bd57d8$var$templateObject_3 || ($a023571504bd57d8$var$templateObject_3 = $a023571504bd57d8$var$__makeTemplateObject([
                "\n      background-color: ",
                ";\n      width: ",
                ";\n      height: ",
                ";\n      margin: ",
                ";\n      border-radius: 100%;\n      display: inline-block;\n      animation: ",
                " 1s 0s infinite cubic-bezier(0.15, 0.46, 0.9, 0.6);\n      animation-fill-mode: both;\n    "
            ], [
                "\n      background-color: ",
                ";\n      width: ",
                ";\n      height: ",
                ";\n      margin: ",
                ";\n      border-radius: 100%;\n      display: inline-block;\n      animation: ",
                " 1s 0s infinite cubic-bezier(0.15, 0.46, 0.9, 0.6);\n      animation-fill-mode: both;\n    "
            ])), color, "" + size + sizeUnit, "" + size + sizeUnit, "" + margin, i % 2 === 0 ? $a023571504bd57d8$var$even : $a023571504bd57d8$var$odd);
        };
        return _this;
    }
    Loader.prototype.render = function() {
        var _a = this.props, loading = _a.loading, css = _a.css;
        return loading ? $f5Egd.jsx("div", {
            css: [
                css
            ]
        }, $f5Egd.jsx("div", {
            css: this.style(1)
        }), $f5Egd.jsx("div", {
            css: this.style(2)
        }), $f5Egd.jsx("div", {
            css: this.style(3)
        }), $f5Egd.jsx("div", {
            css: this.style(4)
        }), $f5Egd.jsx("div", {
            css: this.style(5)
        })) : null;
    };
    Loader.defaultProps = $lFbni.sizeMarginDefaults(15);
    return Loader;
}($a023571504bd57d8$var$React.PureComponent);
module.exports.default = $a023571504bd57d8$var$Loader;
var $a023571504bd57d8$var$templateObject_1, $a023571504bd57d8$var$templateObject_2, $a023571504bd57d8$var$templateObject_3;

});

parcelRegister("kp4mZ", function(module, exports) {
"use strict";
var $eda9882cf4237f8a$var$__makeTemplateObject = module.exports && module.exports.__makeTemplateObject || function(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
};
var $eda9882cf4237f8a$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $eda9882cf4237f8a$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result["default"] = mod;
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

/** @jsx jsx */ var $eda9882cf4237f8a$var$React = $eda9882cf4237f8a$var$__importStar((parcelRequire("acw62")));

var $f5Egd = parcelRequire("f5Egd");
var $6xSYO = parcelRequire("6xSYO");

var $lFbni = parcelRequire("lFbni");
var $eda9882cf4237f8a$var$rotate = $f5Egd.keyframes($eda9882cf4237f8a$var$templateObject_1 || ($eda9882cf4237f8a$var$templateObject_1 = $eda9882cf4237f8a$var$__makeTemplateObject([
    "\n  0% {transform: rotate(0deg)}\n  50% {transform: rotate(180deg)}\n  100% {transform: rotate(360deg)}\n"
], [
    "\n  0% {transform: rotate(0deg)}\n  50% {transform: rotate(180deg)}\n  100% {transform: rotate(360deg)}\n"
])));
var $eda9882cf4237f8a$var$Loader = /** @class */ function(_super) {
    $eda9882cf4237f8a$var$__extends(Loader, _super);
    function Loader() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.style = function(i) {
            return $6xSYO.default($eda9882cf4237f8a$var$templateObject_2 || ($eda9882cf4237f8a$var$templateObject_2 = $eda9882cf4237f8a$var$__makeTemplateObject([
                "\n    opacity: 0.8;\n    position: absolute;\n    top: 0;\n    left: ",
                "px;\n  "
            ], [
                "\n    opacity: 0.8;\n    position: absolute;\n    top: 0;\n    left: ",
                "px;\n  "
            ])), i % 2 ? -28 : 25);
        };
        _this.ball = function() {
            var _a = _this.props, color = _a.color, size = _a.size, sizeUnit = _a.sizeUnit, margin = _a.margin;
            return $6xSYO.default($eda9882cf4237f8a$var$templateObject_3 || ($eda9882cf4237f8a$var$templateObject_3 = $eda9882cf4237f8a$var$__makeTemplateObject([
                "\n      background-color: ",
                ";\n      width: ",
                ";\n      height: ",
                ";\n      margin: ",
                ";\n      border-radius: 100%;\n    "
            ], [
                "\n      background-color: ",
                ";\n      width: ",
                ";\n      height: ",
                ";\n      margin: ",
                ";\n      border-radius: 100%;\n    "
            ])), color, "" + size + sizeUnit, "" + size + sizeUnit, margin);
        };
        _this.wrapper = function() {
            return $6xSYO.default($eda9882cf4237f8a$var$templateObject_4 || ($eda9882cf4237f8a$var$templateObject_4 = $eda9882cf4237f8a$var$__makeTemplateObject([
                "\n      ",
                ";\n      display: inline-block;\n      position: relative;\n      animation-fill-mode: both;\n      animation: ",
                " 1s 0s infinite cubic-bezier(0.7, -0.13, 0.22, 0.86);\n    "
            ], [
                "\n      ",
                ";\n      display: inline-block;\n      position: relative;\n      animation-fill-mode: both;\n      animation: ",
                " 1s 0s infinite cubic-bezier(0.7, -0.13, 0.22, 0.86);\n    "
            ])), _this.ball(), $eda9882cf4237f8a$var$rotate);
        };
        _this.long = function() {
            return $6xSYO.default($eda9882cf4237f8a$var$templateObject_5 || ($eda9882cf4237f8a$var$templateObject_5 = $eda9882cf4237f8a$var$__makeTemplateObject([
                "\n    ",
                ";\n    ",
                ";\n  "
            ], [
                "\n    ",
                ";\n    ",
                ";\n  "
            ])), _this.ball(), _this.style(1));
        };
        _this.short = function() {
            return $6xSYO.default($eda9882cf4237f8a$var$templateObject_6 || ($eda9882cf4237f8a$var$templateObject_6 = $eda9882cf4237f8a$var$__makeTemplateObject([
                "\n    ",
                ";\n    ",
                ";\n  "
            ], [
                "\n    ",
                ";\n    ",
                ";\n  "
            ])), _this.ball(), _this.style(2));
        };
        return _this;
    }
    Loader.prototype.render = function() {
        var _a = this.props, loading = _a.loading, css = _a.css;
        return loading ? $f5Egd.jsx("div", {
            css: [
                this.wrapper(),
                css
            ]
        }, $f5Egd.jsx("div", {
            css: this.long()
        }), $f5Egd.jsx("div", {
            css: this.short()
        })) : null;
    };
    Loader.defaultProps = $lFbni.sizeMarginDefaults(15);
    return Loader;
}($eda9882cf4237f8a$var$React.PureComponent);
module.exports.default = $eda9882cf4237f8a$var$Loader;
var $eda9882cf4237f8a$var$templateObject_1, $eda9882cf4237f8a$var$templateObject_2, $eda9882cf4237f8a$var$templateObject_3, $eda9882cf4237f8a$var$templateObject_4, $eda9882cf4237f8a$var$templateObject_5, $eda9882cf4237f8a$var$templateObject_6;

});

parcelRegister("fX5sN", function(module, exports) {
"use strict";
var $b9d09a9b6edc1523$var$__makeTemplateObject = module.exports && module.exports.__makeTemplateObject || function(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
};
var $b9d09a9b6edc1523$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $b9d09a9b6edc1523$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result["default"] = mod;
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

/** @jsx jsx */ var $b9d09a9b6edc1523$var$React = $b9d09a9b6edc1523$var$__importStar((parcelRequire("acw62")));

var $f5Egd = parcelRequire("f5Egd");
var $6xSYO = parcelRequire("6xSYO");

var $lFbni = parcelRequire("lFbni");
var $b9d09a9b6edc1523$var$scale = $f5Egd.keyframes($b9d09a9b6edc1523$var$templateObject_1 || ($b9d09a9b6edc1523$var$templateObject_1 = $b9d09a9b6edc1523$var$__makeTemplateObject([
    "\n  0% {transform: scaley(1.0)}\n  50% {transform: scaley(0.4)}\n  100% {transform: scaley(1.0)}\n"
], [
    "\n  0% {transform: scaley(1.0)}\n  50% {transform: scaley(0.4)}\n  100% {transform: scaley(1.0)}\n"
])));
var $b9d09a9b6edc1523$var$Loader = /** @class */ function(_super) {
    $b9d09a9b6edc1523$var$__extends(Loader, _super);
    function Loader() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.style = function(i) {
            var _a = _this.props, color = _a.color, width = _a.width, height = _a.height, margin = _a.margin, radius = _a.radius, widthUnit = _a.widthUnit, heightUnit = _a.heightUnit, radiusUnit = _a.radiusUnit;
            return $6xSYO.default($b9d09a9b6edc1523$var$templateObject_2 || ($b9d09a9b6edc1523$var$templateObject_2 = $b9d09a9b6edc1523$var$__makeTemplateObject([
                "\n      background-color: ",
                ";\n      width: ",
                ";\n      height: ",
                ";\n      margin: ",
                ";\n      border-radius: ",
                ";\n      display: inline-block;\n      animation: ",
                " 1s ",
                "s infinite cubic-bezier(0.2, 0.68, 0.18, 1.08);\n      animation-fill-mode: both;\n    "
            ], [
                "\n      background-color: ",
                ";\n      width: ",
                ";\n      height: ",
                ";\n      margin: ",
                ";\n      border-radius: ",
                ";\n      display: inline-block;\n      animation: ",
                " 1s ",
                "s infinite cubic-bezier(0.2, 0.68, 0.18, 1.08);\n      animation-fill-mode: both;\n    "
            ])), color, "" + width + widthUnit, "" + height + heightUnit, margin, "" + radius + radiusUnit, $b9d09a9b6edc1523$var$scale, i * 0.1);
        };
        return _this;
    }
    Loader.prototype.render = function() {
        var _a = this.props, loading = _a.loading, css = _a.css;
        return loading ? $f5Egd.jsx("div", {
            css: [
                css
            ]
        }, $f5Egd.jsx("div", {
            css: this.style(1)
        }), $f5Egd.jsx("div", {
            css: this.style(2)
        }), $f5Egd.jsx("div", {
            css: this.style(3)
        }), $f5Egd.jsx("div", {
            css: this.style(4)
        }), $f5Egd.jsx("div", {
            css: this.style(5)
        })) : null;
    };
    Loader.defaultProps = $lFbni.heightWidthRadiusDefaults(35, 4, 2);
    return Loader;
}($b9d09a9b6edc1523$var$React.PureComponent);
module.exports.default = $b9d09a9b6edc1523$var$Loader;
var $b9d09a9b6edc1523$var$templateObject_1, $b9d09a9b6edc1523$var$templateObject_2;

});

parcelRegister("7NeQv", function(module, exports) {
"use strict";
var $5ac8a012808a26f9$var$__makeTemplateObject = module.exports && module.exports.__makeTemplateObject || function(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
};
var $5ac8a012808a26f9$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $5ac8a012808a26f9$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result["default"] = mod;
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

/** @jsx jsx */ var $5ac8a012808a26f9$var$React = $5ac8a012808a26f9$var$__importStar((parcelRequire("acw62")));

var $f5Egd = parcelRequire("f5Egd");
var $6xSYO = parcelRequire("6xSYO");

var $lFbni = parcelRequire("lFbni");
var $5ac8a012808a26f9$var$skew = $f5Egd.keyframes($5ac8a012808a26f9$var$templateObject_1 || ($5ac8a012808a26f9$var$templateObject_1 = $5ac8a012808a26f9$var$__makeTemplateObject([
    "\n  25% {transform: perspective(100px) rotateX(180deg) rotateY(0)}\n  50% {transform: perspective(100px) rotateX(180deg) rotateY(180deg)}\n  75% {transform: perspective(100px) rotateX(0) rotateY(180deg)}\n  100% {transform: perspective(100px) rotateX(0) rotateY(0)}\n"
], [
    "\n  25% {transform: perspective(100px) rotateX(180deg) rotateY(0)}\n  50% {transform: perspective(100px) rotateX(180deg) rotateY(180deg)}\n  75% {transform: perspective(100px) rotateX(0) rotateY(180deg)}\n  100% {transform: perspective(100px) rotateX(0) rotateY(0)}\n"
])));
var $5ac8a012808a26f9$var$Loader = /** @class */ function(_super) {
    $5ac8a012808a26f9$var$__extends(Loader, _super);
    function Loader() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.style = function() {
            var _a = _this.props, size = _a.size, sizeUnit = _a.sizeUnit, color = _a.color;
            return $6xSYO.default($5ac8a012808a26f9$var$templateObject_2 || ($5ac8a012808a26f9$var$templateObject_2 = $5ac8a012808a26f9$var$__makeTemplateObject([
                "\n      width: 0;\n      height: 0;\n      border-left: ",
                " solid transparent;\n      border-right: ",
                " solid transparent;\n      border-bottom: ",
                " solid ",
                ";\n      display: inline-block;\n      animation: ",
                " 3s 0s infinite cubic-bezier(0.09, 0.57, 0.49, 0.9);\n      animation-fill-mode: both;\n    "
            ], [
                "\n      width: 0;\n      height: 0;\n      border-left: ",
                " solid transparent;\n      border-right: ",
                " solid transparent;\n      border-bottom: ",
                " solid ",
                ";\n      display: inline-block;\n      animation: ",
                " 3s 0s infinite cubic-bezier(0.09, 0.57, 0.49, 0.9);\n      animation-fill-mode: both;\n    "
            ])), "" + size + sizeUnit, "" + size + sizeUnit, "" + size + sizeUnit, color, $5ac8a012808a26f9$var$skew);
        };
        return _this;
    }
    Loader.prototype.render = function() {
        var _a = this.props, loading = _a.loading, css = _a.css;
        return loading ? $f5Egd.jsx("div", {
            css: [
                this.style(),
                css
            ]
        }) : null;
    };
    Loader.defaultProps = $lFbni.sizeDefaults(20);
    return Loader;
}($5ac8a012808a26f9$var$React.PureComponent);
module.exports.default = $5ac8a012808a26f9$var$Loader;
var $5ac8a012808a26f9$var$templateObject_1, $5ac8a012808a26f9$var$templateObject_2;

});

parcelRegister("jpDqh", function(module, exports) {
"use strict";
var $e21eeeaeddf3f6ab$var$__makeTemplateObject = module.exports && module.exports.__makeTemplateObject || function(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
};
var $e21eeeaeddf3f6ab$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $e21eeeaeddf3f6ab$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result["default"] = mod;
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

/** @jsx jsx */ var $e21eeeaeddf3f6ab$var$React = $e21eeeaeddf3f6ab$var$__importStar((parcelRequire("acw62")));

var $f5Egd = parcelRequire("f5Egd");
var $6xSYO = parcelRequire("6xSYO");

var $lFbni = parcelRequire("lFbni");
var $e21eeeaeddf3f6ab$var$square = $f5Egd.keyframes($e21eeeaeddf3f6ab$var$templateObject_1 || ($e21eeeaeddf3f6ab$var$templateObject_1 = $e21eeeaeddf3f6ab$var$__makeTemplateObject([
    "\n  25% {transform: rotateX(180deg) rotateY(0)}\n  50% {transform: rotateX(180deg) rotateY(180deg)}\n  75% {transform: rotateX(0) rotateY(180deg)}\n  100% {transform: rotateX(0) rotateY(0)}\n"
], [
    "\n  25% {transform: rotateX(180deg) rotateY(0)}\n  50% {transform: rotateX(180deg) rotateY(180deg)}\n  75% {transform: rotateX(0) rotateY(180deg)}\n  100% {transform: rotateX(0) rotateY(0)}\n"
])));
var $e21eeeaeddf3f6ab$var$Loader = /** @class */ function(_super) {
    $e21eeeaeddf3f6ab$var$__extends(Loader, _super);
    function Loader() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.style = function() {
            var _a = _this.props, color = _a.color, size = _a.size, sizeUnit = _a.sizeUnit;
            return $6xSYO.default($e21eeeaeddf3f6ab$var$templateObject_2 || ($e21eeeaeddf3f6ab$var$templateObject_2 = $e21eeeaeddf3f6ab$var$__makeTemplateObject([
                "\n      background-color: ",
                ";\n      width: ",
                ";\n      height: ",
                ";\n      display: inline-block;\n      animation: ",
                " 3s 0s infinite cubic-bezier(0.09, 0.57, 0.49, 0.9);\n      animation-fill-mode: both;\n    "
            ], [
                "\n      background-color: ",
                ";\n      width: ",
                ";\n      height: ",
                ";\n      display: inline-block;\n      animation: ",
                " 3s 0s infinite cubic-bezier(0.09, 0.57, 0.49, 0.9);\n      animation-fill-mode: both;\n    "
            ])), color, "" + size + sizeUnit, "" + size + sizeUnit, $e21eeeaeddf3f6ab$var$square);
        };
        return _this;
    }
    Loader.prototype.render = function() {
        var _a = this.props, loading = _a.loading, css = _a.css;
        return loading ? $f5Egd.jsx("div", {
            css: [
                this.style(),
                css
            ]
        }) : null;
    };
    Loader.defaultProps = $lFbni.sizeDefaults(50);
    return Loader;
}($e21eeeaeddf3f6ab$var$React.PureComponent);
module.exports.default = $e21eeeaeddf3f6ab$var$Loader;
var $e21eeeaeddf3f6ab$var$templateObject_1, $e21eeeaeddf3f6ab$var$templateObject_2;

});

parcelRegister("byVmK", function(module, exports) {
"use strict";
var $86af5e5edf2a3443$var$__makeTemplateObject = module.exports && module.exports.__makeTemplateObject || function(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
};
var $86af5e5edf2a3443$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $86af5e5edf2a3443$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result["default"] = mod;
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

/** @jsx jsx */ var $86af5e5edf2a3443$var$React = $86af5e5edf2a3443$var$__importStar((parcelRequire("acw62")));

var $f5Egd = parcelRequire("f5Egd");
var $6xSYO = parcelRequire("6xSYO");

var $7am6d = parcelRequire("7am6d");
var $86af5e5edf2a3443$var$sync = $f5Egd.keyframes($86af5e5edf2a3443$var$templateObject_1 || ($86af5e5edf2a3443$var$templateObject_1 = $86af5e5edf2a3443$var$__makeTemplateObject([
    "\n  33% {transform: translateY(10px)}\n  66% {transform: translateY(-10px)}\n  100% {transform: translateY(0)}\n"
], [
    "\n  33% {transform: translateY(10px)}\n  66% {transform: translateY(-10px)}\n  100% {transform: translateY(0)}\n"
])));
var $86af5e5edf2a3443$var$Loader = /** @class */ function(_super) {
    $86af5e5edf2a3443$var$__extends(Loader, _super);
    function Loader() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.style = function(i) {
            var _a = _this.props, color = _a.color, size = _a.size, sizeUnit = _a.sizeUnit, margin = _a.margin;
            return $6xSYO.default($86af5e5edf2a3443$var$templateObject_2 || ($86af5e5edf2a3443$var$templateObject_2 = $86af5e5edf2a3443$var$__makeTemplateObject([
                "\n      background-color: ",
                ";\n      width: ",
                ";\n      height: ",
                ";\n      margin: ",
                ";\n      border-radius: 100%;\n      display: inline-block;\n      animation: ",
                " 0.6s ",
                "s infinite ease-in-out;\n      animation-fill-mode: both;\n    "
            ], [
                "\n      background-color: ",
                ";\n      width: ",
                ";\n      height: ",
                ";\n      margin: ",
                ";\n      border-radius: 100%;\n      display: inline-block;\n      animation: ",
                " 0.6s ",
                "s infinite ease-in-out;\n      animation-fill-mode: both;\n    "
            ])), color, "" + size + sizeUnit, "" + size + sizeUnit, margin, $86af5e5edf2a3443$var$sync, i * 0.07);
        };
        return _this;
    }
    Loader.prototype.render = function() {
        var _a = this.props, loading = _a.loading, css = _a.css;
        return loading ? $f5Egd.jsx("div", {
            css: [
                css
            ]
        }, $f5Egd.jsx("div", {
            css: this.style(1)
        }), $f5Egd.jsx("div", {
            css: this.style(2)
        }), $f5Egd.jsx("div", {
            css: this.style(3)
        })) : null;
    };
    Loader.defaultProps = $7am6d.sizeMarginDefaults(15);
    return Loader;
}($86af5e5edf2a3443$var$React.PureComponent);
module.exports.default = $86af5e5edf2a3443$var$Loader;
var $86af5e5edf2a3443$var$templateObject_1, $86af5e5edf2a3443$var$templateObject_2;

});


var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");


var $acw62 = parcelRequire("acw62");

var $768901fea8dbe440$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */ var $768901fea8dbe440$var$invariant = function(condition, format, a, b, c, d, e, f) {
    if (!condition) {
        var error;
        if (format === undefined) error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
        else {
            var args = [
                a,
                b,
                c,
                d,
                e,
                f
            ];
            var argIndex = 0;
            error = new Error(format.replace(/%s/g, function() {
                return args[argIndex++];
            }));
            error.name = "Invariant Violation";
        }
        error.framesToPop = 1; // we don't care about invariant's own frame
        throw error;
    }
};
$768901fea8dbe440$exports = $768901fea8dbe440$var$invariant;


var $3afa96475c004866$exports = {};
"use strict";
$3afa96475c004866$exports.__esModule = true;

var $acw62 = parcelRequire("acw62");
var $3afa96475c004866$var$_react2 = $3afa96475c004866$var$_interopRequireDefault($acw62);
var $292d806c8898de24$exports = {};
"use strict";
$292d806c8898de24$exports.__esModule = true;

var $acw62 = parcelRequire("acw62");
var $292d806c8898de24$var$_react2 = $292d806c8898de24$var$_interopRequireDefault($acw62);
var $8da5bfbbed271cd7$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $8da5bfbbed271cd7$var$ReactIs, $8da5bfbbed271cd7$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
$8da5bfbbed271cd7$exports = (parcelRequire("hOzOt"))();


var $292d806c8898de24$var$_propTypes2 = $292d806c8898de24$var$_interopRequireDefault($8da5bfbbed271cd7$exports);
var $92e06b8def6c7a49$exports = {};
// @flow
"use strict";
var $92e06b8def6c7a49$var$key = "__global_unique_id__";
$92e06b8def6c7a49$exports = function() {
    return $parcel$global[$92e06b8def6c7a49$var$key] = ($parcel$global[$92e06b8def6c7a49$var$key] || 0) + 1;
};


var $292d806c8898de24$var$_gud2 = $292d806c8898de24$var$_interopRequireDefault($92e06b8def6c7a49$exports);
var $ebfc6adce9fdacf8$exports = {};
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var $ebfc6adce9fdacf8$var$__DEV__ = false;
var $ebfc6adce9fdacf8$var$warning = function() {};
if ($ebfc6adce9fdacf8$var$__DEV__) {
    var $ebfc6adce9fdacf8$var$printWarning = function printWarning(format, args) {
        var len = arguments.length;
        args = new Array(len > 1 ? len - 1 : 0);
        for(var key = 1; key < len; key++)args[key - 1] = arguments[key];
        var argIndex = 0;
        var message = "Warning: " + format.replace(/%s/g, function() {
            return args[argIndex++];
        });
        if (typeof console !== "undefined") console.error(message);
        try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
        } catch (x) {}
    };
    $ebfc6adce9fdacf8$var$warning = function(condition, format, args) {
        var len = arguments.length;
        args = new Array(len > 2 ? len - 2 : 0);
        for(var key = 2; key < len; key++)args[key - 2] = arguments[key];
        if (format === undefined) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
        if (!condition) $ebfc6adce9fdacf8$var$printWarning.apply(null, [
            format
        ].concat(args));
    };
}
$ebfc6adce9fdacf8$exports = $ebfc6adce9fdacf8$var$warning;


var $292d806c8898de24$var$_warning2 = $292d806c8898de24$var$_interopRequireDefault($ebfc6adce9fdacf8$exports);
function $292d806c8898de24$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $292d806c8898de24$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $292d806c8898de24$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $292d806c8898de24$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $292d806c8898de24$var$MAX_SIGNED_31_BIT_INT = 1073741823;
// Inlined Object.is polyfill.
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
function $292d806c8898de24$var$objectIs(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $292d806c8898de24$var$createEventEmitter(value) {
    var handlers = [];
    return {
        on: function on(handler) {
            handlers.push(handler);
        },
        off: function off(handler) {
            handlers = handlers.filter(function(h) {
                return h !== handler;
            });
        },
        get: function get() {
            return value;
        },
        set: function set(newValue, changedBits) {
            value = newValue;
            handlers.forEach(function(handler) {
                return handler(value, changedBits);
            });
        }
    };
}
function $292d806c8898de24$var$onlyChild(children) {
    return Array.isArray(children) ? children[0] : children;
}
function $292d806c8898de24$var$createReactContext(defaultValue, calculateChangedBits) {
    var _Provider$childContex, _Consumer$contextType;
    var contextProp = "__create-react-context-" + (0, $292d806c8898de24$var$_gud2.default)() + "__";
    var Provider = function(_Component) {
        $292d806c8898de24$var$_inherits(Provider, _Component);
        function Provider() {
            var _temp, _this, _ret;
            $292d806c8898de24$var$_classCallCheck(this, Provider);
            for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return _ret = (_temp = (_this = $292d806c8898de24$var$_possibleConstructorReturn(this, _Component.call.apply(_Component, [
                this
            ].concat(args))), _this), _this.emitter = $292d806c8898de24$var$createEventEmitter(_this.props.value), _temp), $292d806c8898de24$var$_possibleConstructorReturn(_this, _ret);
        }
        Provider.prototype.getChildContext = function getChildContext() {
            var _ref;
            return _ref = {}, _ref[contextProp] = this.emitter, _ref;
        };
        Provider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            if (this.props.value !== nextProps.value) {
                var oldValue = this.props.value;
                var newValue = nextProps.value;
                var changedBits = void 0;
                if ($292d806c8898de24$var$objectIs(oldValue, newValue)) changedBits = 0; // No change
                else {
                    changedBits = typeof calculateChangedBits === "function" ? calculateChangedBits(oldValue, newValue) : $292d806c8898de24$var$MAX_SIGNED_31_BIT_INT;
                    changedBits |= 0;
                    if (changedBits !== 0) this.emitter.set(nextProps.value, changedBits);
                }
            }
        };
        Provider.prototype.render = function render() {
            return this.props.children;
        };
        return Provider;
    }($acw62.Component);
    Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = $292d806c8898de24$var$_propTypes2.default.object.isRequired, _Provider$childContex);
    var Consumer = function(_Component2) {
        $292d806c8898de24$var$_inherits(Consumer, _Component2);
        function Consumer() {
            var _temp2, _this2, _ret2;
            $292d806c8898de24$var$_classCallCheck(this, Consumer);
            for(var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            return _ret2 = (_temp2 = (_this2 = $292d806c8898de24$var$_possibleConstructorReturn(this, _Component2.call.apply(_Component2, [
                this
            ].concat(args))), _this2), _this2.state = {
                value: _this2.getValue()
            }, _this2.onUpdate = function(newValue, changedBits) {
                var observedBits = _this2.observedBits | 0;
                if ((observedBits & changedBits) !== 0) _this2.setState({
                    value: _this2.getValue()
                });
            }, _temp2), $292d806c8898de24$var$_possibleConstructorReturn(_this2, _ret2);
        }
        Consumer.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            var observedBits = nextProps.observedBits;
            this.observedBits = observedBits === undefined || observedBits === null ? $292d806c8898de24$var$MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
             : observedBits;
        };
        Consumer.prototype.componentDidMount = function componentDidMount() {
            if (this.context[contextProp]) this.context[contextProp].on(this.onUpdate);
            var observedBits = this.props.observedBits;
            this.observedBits = observedBits === undefined || observedBits === null ? $292d806c8898de24$var$MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
             : observedBits;
        };
        Consumer.prototype.componentWillUnmount = function componentWillUnmount() {
            if (this.context[contextProp]) this.context[contextProp].off(this.onUpdate);
        };
        Consumer.prototype.getValue = function getValue() {
            if (this.context[contextProp]) return this.context[contextProp].get();
            else return defaultValue;
        };
        Consumer.prototype.render = function render() {
            return $292d806c8898de24$var$onlyChild(this.props.children)(this.state.value);
        };
        return Consumer;
    }($acw62.Component);
    Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = $292d806c8898de24$var$_propTypes2.default.object, _Consumer$contextType);
    return {
        Provider: Provider,
        Consumer: Consumer
    };
}
$292d806c8898de24$exports.default = $292d806c8898de24$var$createReactContext;
$292d806c8898de24$exports = $292d806c8898de24$exports["default"];


var $3afa96475c004866$var$_implementation2 = $3afa96475c004866$var$_interopRequireDefault($292d806c8898de24$exports);
function $3afa96475c004866$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$3afa96475c004866$exports.default = $3afa96475c004866$var$_react2.default.createContext || $3afa96475c004866$var$_implementation2.default;
$3afa96475c004866$exports = $3afa96475c004866$exports["default"];


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ function $c8a186e1757974bb$var$componentWillMount() {
    // Call this.constructor.gDSFP to support sub-classes.
    var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
    if (state !== null && state !== undefined) this.setState(state);
}
function $c8a186e1757974bb$var$componentWillReceiveProps(nextProps) {
    // Call this.constructor.gDSFP to support sub-classes.
    // Use the setState() updater to ensure state isn't stale in certain edge cases.
    function updater(prevState) {
        var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
        return state !== null && state !== undefined ? state : null;
    }
    // Binding "this" is important for shallow renderer support.
    this.setState(updater.bind(this));
}
function $c8a186e1757974bb$var$componentWillUpdate(nextProps, nextState) {
    try {
        var prevProps = this.props;
        var prevState = this.state;
        this.props = nextProps;
        this.state = nextState;
        this.__reactInternalSnapshotFlag = true;
        this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(prevProps, prevState);
    } finally{
        this.props = prevProps;
        this.state = prevState;
    }
}
// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
$c8a186e1757974bb$var$componentWillMount.__suppressDeprecationWarning = true;
$c8a186e1757974bb$var$componentWillReceiveProps.__suppressDeprecationWarning = true;
$c8a186e1757974bb$var$componentWillUpdate.__suppressDeprecationWarning = true;
function $c8a186e1757974bb$export$cea1c58a6db52bca(Component) {
    var prototype = Component.prototype;
    if (!prototype || !prototype.isReactComponent) throw new Error("Can only polyfill class components");
    if (typeof Component.getDerivedStateFromProps !== "function" && typeof prototype.getSnapshotBeforeUpdate !== "function") return Component;
    // If new component APIs are defined, "unsafe" lifecycles won't be called.
    // Error if any of these lifecycles are present,
    // Because they would work differently between older and newer (16.3+) versions of React.
    var foundWillMountName = null;
    var foundWillReceivePropsName = null;
    var foundWillUpdateName = null;
    if (typeof prototype.componentWillMount === "function") foundWillMountName = "componentWillMount";
    else if (typeof prototype.UNSAFE_componentWillMount === "function") foundWillMountName = "UNSAFE_componentWillMount";
    if (typeof prototype.componentWillReceiveProps === "function") foundWillReceivePropsName = "componentWillReceiveProps";
    else if (typeof prototype.UNSAFE_componentWillReceiveProps === "function") foundWillReceivePropsName = "UNSAFE_componentWillReceiveProps";
    if (typeof prototype.componentWillUpdate === "function") foundWillUpdateName = "componentWillUpdate";
    else if (typeof prototype.UNSAFE_componentWillUpdate === "function") foundWillUpdateName = "UNSAFE_componentWillUpdate";
    if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
        var componentName = Component.displayName || Component.name;
        var newApiName = typeof Component.getDerivedStateFromProps === "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
        throw Error("Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n" + componentName + " uses " + newApiName + " but also contains the following legacy lifecycles:" + (foundWillMountName !== null ? "\n  " + foundWillMountName : "") + (foundWillReceivePropsName !== null ? "\n  " + foundWillReceivePropsName : "") + (foundWillUpdateName !== null ? "\n  " + foundWillUpdateName : "") + "\n\nThe above lifecycles should be removed. Learn more about this warning here:\n" + "https://fb.me/react-async-component-lifecycle-hooks");
    }
    // React <= 16.2 does not support static getDerivedStateFromProps.
    // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
    // Newer versions of React will ignore these lifecycles if gDSFP exists.
    if (typeof Component.getDerivedStateFromProps === "function") {
        prototype.componentWillMount = $c8a186e1757974bb$var$componentWillMount;
        prototype.componentWillReceiveProps = $c8a186e1757974bb$var$componentWillReceiveProps;
    }
    // React <= 16.2 does not support getSnapshotBeforeUpdate.
    // As a workaround, use cWU to invoke the new lifecycle.
    // Newer versions of React will ignore that lifecycle if gSBU exists.
    if (typeof prototype.getSnapshotBeforeUpdate === "function") {
        if (typeof prototype.componentDidUpdate !== "function") throw new Error("Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype");
        prototype.componentWillUpdate = $c8a186e1757974bb$var$componentWillUpdate;
        var componentDidUpdate = prototype.componentDidUpdate;
        prototype.componentDidUpdate = function componentDidUpdatePolyfill(prevProps, prevState, maybeSnapshot) {
            // 16.3+ will not execute our will-update method;
            // It will pass a snapshot value to did-update though.
            // Older versions will require our polyfilled will-update value.
            // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
            // Because for <= 15.x versions this might be a "prevContext" object.
            // We also can't just check "__reactInternalSnapshot",
            // Because get-snapshot might return a falsy value.
            // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
            var snapshot = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : maybeSnapshot;
            componentDidUpdate.call(this, prevProps, prevState, snapshot);
        };
    }
    return Component;
}



////////////////////////////////////////////////////////////////////////////////
// startsWith(string, search) - Check if `string` starts with `search`
var $b59fe115cc21af2d$export$68326237475e9a7d = function startsWith(string, search) {
    return string.substr(0, search.length) === search;
};
////////////////////////////////////////////////////////////////////////////////
// pick(routes, uri)
//
// Ranks and picks the best route to match. Each segment gets the highest
// amount of points, then the type of segment gets an additional amount of
// points where
//
//     static > dynamic > splat > root
//
// This way we don't have to worry about the order of our routes, let the
// computers do it.
//
// A route looks like this
//
//     { path, default, value }
//
// And a returned match looks like:
//
//     { route, params, uri }
//
// I know, I should use TypeScript not comments for these types.
var $b59fe115cc21af2d$export$357523c63a2253b9 = function pick(routes, uri) {
    var match = void 0;
    var default_ = void 0;
    var _uri$split = uri.split("?"), uriPathname = _uri$split[0];
    var uriSegments = $b59fe115cc21af2d$var$segmentize(uriPathname);
    var isRootUri = uriSegments[0] === "";
    var ranked = $b59fe115cc21af2d$var$rankRoutes(routes);
    for(var i = 0, l = ranked.length; i < l; i++){
        var missed = false;
        var route = ranked[i].route;
        if (route.default) {
            default_ = {
                route: route,
                params: {},
                uri: uri
            };
            continue;
        }
        var routeSegments = $b59fe115cc21af2d$var$segmentize(route.path);
        var params = {};
        var max = Math.max(uriSegments.length, routeSegments.length);
        var index = 0;
        for(; index < max; index++){
            var routeSegment = routeSegments[index];
            var uriSegment = uriSegments[index];
            if ($b59fe115cc21af2d$var$isSplat(routeSegment)) {
                // Hit a splat, just grab the rest, and return a match
                // uri:   /files/documents/work
                // route: /files/*
                var param = routeSegment.slice(1) || "*";
                params[param] = uriSegments.slice(index).map(decodeURIComponent).join("/");
                break;
            }
            if (uriSegment === undefined) {
                // URI is shorter than the route, no match
                // uri:   /users
                // route: /users/:userId
                missed = true;
                break;
            }
            var dynamicMatch = $b59fe115cc21af2d$var$paramRe.exec(routeSegment);
            if (dynamicMatch && !isRootUri) {
                var matchIsNotReserved = $b59fe115cc21af2d$var$reservedNames.indexOf(dynamicMatch[1]) === -1;
                !matchIsNotReserved && (0, (/*@__PURE__*/$parcel$interopDefault($768901fea8dbe440$exports)))(false);
                var value = decodeURIComponent(uriSegment);
                params[dynamicMatch[1]] = value;
            } else if (routeSegment !== uriSegment) {
                // Current segments don't match, not dynamic, not splat, so no match
                // uri:   /users/123/settings
                // route: /users/:id/profile
                missed = true;
                break;
            }
        }
        if (!missed) {
            match = {
                route: route,
                params: params,
                uri: "/" + uriSegments.slice(0, index).join("/")
            };
            break;
        }
    }
    return match || default_ || null;
};
////////////////////////////////////////////////////////////////////////////////
// match(path, uri) - Matches just one path to a uri, also lol
var $b59fe115cc21af2d$export$4659b591c19bdf3d = function match(path, uri) {
    return $b59fe115cc21af2d$export$357523c63a2253b9([
        {
            path: path
        }
    ], uri);
};
////////////////////////////////////////////////////////////////////////////////
// resolve(to, basepath)
//
// Resolves URIs as though every path is a directory, no files.  Relative URIs
// in the browser can feel awkward because not only can you be "in a directory"
// you can be "at a file", too. For example
//
//     browserSpecResolve('foo', '/bar/') => /bar/foo
//     browserSpecResolve('foo', '/bar') => /foo
//
// But on the command line of a file system, it's not as complicated, you can't
// `cd` from a file, only directories.  This way, links have to know less about
// their current path. To go deeper you can do this:
//
//     <Link to="deeper"/>
//     // instead of
//     <Link to=`{${props.uri}/deeper}`/>
//
// Just like `cd`, if you want to go deeper from the command line, you do this:
//
//     cd deeper
//     # not
//     cd $(pwd)/deeper
//
// By treating every path as a directory, linking to relative paths should
// require less contextual information and (fingers crossed) be more intuitive.
var $b59fe115cc21af2d$export$f7ad0328861e2f03 = function resolve(to, base) {
    // /foo/bar, /baz/qux => /foo/bar
    if ($b59fe115cc21af2d$export$68326237475e9a7d(to, "/")) return to;
    var _to$split = to.split("?"), toPathname = _to$split[0], toQuery = _to$split[1];
    var _base$split = base.split("?"), basePathname = _base$split[0];
    var toSegments = $b59fe115cc21af2d$var$segmentize(toPathname);
    var baseSegments = $b59fe115cc21af2d$var$segmentize(basePathname);
    // ?a=b, /users?b=c => /users?a=b
    if (toSegments[0] === "") return $b59fe115cc21af2d$var$addQuery(basePathname, toQuery);
    // profile, /users/789 => /users/789/profile
    if (!$b59fe115cc21af2d$export$68326237475e9a7d(toSegments[0], ".")) {
        var pathname = baseSegments.concat(toSegments).join("/");
        return $b59fe115cc21af2d$var$addQuery((basePathname === "/" ? "" : "/") + pathname, toQuery);
    }
    // ./         /users/123  =>  /users/123
    // ../        /users/123  =>  /users
    // ../..      /users/123  =>  /
    // ../../one  /a/b/c/d    =>  /a/b/one
    // .././one   /a/b/c/d    =>  /a/b/c/one
    var allSegments = baseSegments.concat(toSegments);
    var segments = [];
    for(var i = 0, l = allSegments.length; i < l; i++){
        var segment = allSegments[i];
        if (segment === "..") segments.pop();
        else if (segment !== ".") segments.push(segment);
    }
    return $b59fe115cc21af2d$var$addQuery("/" + segments.join("/"), toQuery);
};
////////////////////////////////////////////////////////////////////////////////
// insertParams(path, params)
var $b59fe115cc21af2d$export$2560bc9559623b9 = function insertParams(path, params) {
    var _path$split = path.split("?"), pathBase = _path$split[0], _path$split$ = _path$split[1], query = _path$split$ === undefined ? "" : _path$split$;
    var segments = $b59fe115cc21af2d$var$segmentize(pathBase);
    var constructedPath = "/" + segments.map(function(segment) {
        var match = $b59fe115cc21af2d$var$paramRe.exec(segment);
        return match ? params[match[1]] : segment;
    }).join("/");
    var _params$location = params.location;
    _params$location = _params$location === undefined ? {} : _params$location;
    var _params$location$sear = _params$location.search, search = _params$location$sear === undefined ? "" : _params$location$sear;
    var searchSplit = search.split("?")[1] || "";
    constructedPath = $b59fe115cc21af2d$var$addQuery(constructedPath, query, searchSplit);
    return constructedPath;
};
var $b59fe115cc21af2d$export$569b01c992e4a17e = function validateRedirect(from, to) {
    var filter = function filter(segment) {
        return $b59fe115cc21af2d$var$isDynamic(segment);
    };
    var fromString = $b59fe115cc21af2d$var$segmentize(from).filter(filter).sort().join("/");
    var toString = $b59fe115cc21af2d$var$segmentize(to).filter(filter).sort().join("/");
    return fromString === toString;
};
////////////////////////////////////////////////////////////////////////////////
// Junk
var $b59fe115cc21af2d$var$paramRe = /^:(.+)/;
var $b59fe115cc21af2d$var$SEGMENT_POINTS = 4;
var $b59fe115cc21af2d$var$STATIC_POINTS = 3;
var $b59fe115cc21af2d$var$DYNAMIC_POINTS = 2;
var $b59fe115cc21af2d$var$SPLAT_PENALTY = 1;
var $b59fe115cc21af2d$var$ROOT_POINTS = 1;
var $b59fe115cc21af2d$var$isRootSegment = function isRootSegment(segment) {
    return segment === "";
};
var $b59fe115cc21af2d$var$isDynamic = function isDynamic(segment) {
    return $b59fe115cc21af2d$var$paramRe.test(segment);
};
var $b59fe115cc21af2d$var$isSplat = function isSplat(segment) {
    return segment && segment[0] === "*";
};
var $b59fe115cc21af2d$var$rankRoute = function rankRoute(route, index) {
    var score = route.default ? 0 : $b59fe115cc21af2d$var$segmentize(route.path).reduce(function(score, segment) {
        score += $b59fe115cc21af2d$var$SEGMENT_POINTS;
        if ($b59fe115cc21af2d$var$isRootSegment(segment)) score += $b59fe115cc21af2d$var$ROOT_POINTS;
        else if ($b59fe115cc21af2d$var$isDynamic(segment)) score += $b59fe115cc21af2d$var$DYNAMIC_POINTS;
        else if ($b59fe115cc21af2d$var$isSplat(segment)) score -= $b59fe115cc21af2d$var$SEGMENT_POINTS + $b59fe115cc21af2d$var$SPLAT_PENALTY;
        else score += $b59fe115cc21af2d$var$STATIC_POINTS;
        return score;
    }, 0);
    return {
        route: route,
        score: score,
        index: index
    };
};
var $b59fe115cc21af2d$var$rankRoutes = function rankRoutes(routes) {
    return routes.map($b59fe115cc21af2d$var$rankRoute).sort(function(a, b) {
        return a.score < b.score ? 1 : a.score > b.score ? -1 : a.index - b.index;
    });
};
var $b59fe115cc21af2d$var$segmentize = function segmentize(uri) {
    return uri// strip starting/ending slashes
    .replace(/(^\/+|\/+$)/g, "").split("/");
};
var $b59fe115cc21af2d$var$addQuery = function addQuery(pathname) {
    for(var _len = arguments.length, query = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)query[_key - 1] = arguments[_key];
    query = query.filter(function(q) {
        return q && q.length > 0;
    });
    return pathname + (query && query.length > 0 ? "?" + query.join("&") : "");
};
var $b59fe115cc21af2d$var$reservedNames = [
    "uri",
    "path"
];
/**
 * Shallow compares two objects.
 * @param {Object} obj1 The first object to compare.
 * @param {Object} obj2 The second object to compare.
 */ var $b59fe115cc21af2d$export$90e866afbd6b9f1a = function shallowCompare(obj1, obj2) {
    var obj1Keys = Object.keys(obj1);
    return obj1Keys.length === Object.keys(obj2).length && obj1Keys.every(function(key) {
        return obj2.hasOwnProperty(key) && obj1[key] === obj2[key];
    });
};


var $f125bbca2c654db8$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $f125bbca2c654db8$var$getLocation = function getLocation(source) {
    var _source$location = source.location, search = _source$location.search, hash = _source$location.hash, href = _source$location.href, origin = _source$location.origin, protocol = _source$location.protocol, host = _source$location.host, hostname = _source$location.hostname, port = _source$location.port;
    var pathname = source.location.pathname;
    if (!pathname && href && $f125bbca2c654db8$var$canUseDOM) {
        var url = new URL(href);
        pathname = url.pathname;
    }
    return {
        pathname: encodeURI(decodeURI(pathname)),
        search: search,
        hash: hash,
        href: href,
        origin: origin,
        protocol: protocol,
        host: host,
        hostname: hostname,
        port: port,
        state: source.history.state,
        key: source.history.state && source.history.state.key || "initial"
    };
};
var $f125bbca2c654db8$export$4178d7ac16e6cf7c = function createHistory(source, options) {
    var listeners = [];
    var location = $f125bbca2c654db8$var$getLocation(source);
    var transitioning = false;
    var resolveTransition = function resolveTransition() {};
    return {
        get location () {
            return location;
        },
        get transitioning () {
            return transitioning;
        },
        _onTransitionComplete: function _onTransitionComplete() {
            transitioning = false;
            resolveTransition();
        },
        listen: function listen(listener) {
            listeners.push(listener);
            var popstateListener = function popstateListener() {
                location = $f125bbca2c654db8$var$getLocation(source);
                listener({
                    location: location,
                    action: "POP"
                });
            };
            source.addEventListener("popstate", popstateListener);
            return function() {
                source.removeEventListener("popstate", popstateListener);
                listeners = listeners.filter(function(fn) {
                    return fn !== listener;
                });
            };
        },
        navigate: function navigate(to) {
            var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, state = _ref.state, _ref$replace = _ref.replace, replace = _ref$replace === undefined ? false : _ref$replace;
            if (typeof to === "number") source.history.go(to);
            else {
                state = $f125bbca2c654db8$var$_extends({}, state, {
                    key: Date.now() + ""
                });
                // try...catch iOS Safari limits to 100 pushState calls
                try {
                    if (transitioning || replace) source.history.replaceState(state, null, to);
                    else source.history.pushState(state, null, to);
                } catch (e) {
                    source.location[replace ? "replace" : "assign"](to);
                }
            }
            location = $f125bbca2c654db8$var$getLocation(source);
            transitioning = true;
            var transition = new Promise(function(res) {
                return resolveTransition = res;
            });
            listeners.forEach(function(listener) {
                return listener({
                    location: location,
                    action: "PUSH"
                });
            });
            return transition;
        }
    };
};
////////////////////////////////////////////////////////////////////////////////
// Stores history entries in memory for testing or other platforms like Native
var $f125bbca2c654db8$export$f8892d7c0e30dbc3 = function createMemorySource() {
    var initialPath = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "/";
    var searchIndex = initialPath.indexOf("?");
    var initialLocation = {
        pathname: searchIndex > -1 ? initialPath.substr(0, searchIndex) : initialPath,
        search: searchIndex > -1 ? initialPath.substr(searchIndex) : ""
    };
    var index = 0;
    var stack = [
        initialLocation
    ];
    var states = [
        null
    ];
    return {
        get location () {
            return stack[index];
        },
        addEventListener: function addEventListener(name, fn) {},
        removeEventListener: function removeEventListener(name, fn) {},
        history: {
            get entries () {
                return stack;
            },
            get index () {
                return index;
            },
            get state () {
                return states[index];
            },
            pushState: function pushState(state, _, uri) {
                var _uri$split = uri.split("?"), pathname = _uri$split[0], _uri$split$ = _uri$split[1], search = _uri$split$ === undefined ? "" : _uri$split$;
                index++;
                stack.push({
                    pathname: pathname,
                    search: search.length ? "?" + search : search
                });
                states.push(state);
            },
            replaceState: function replaceState(state, _, uri) {
                var _uri$split2 = uri.split("?"), pathname = _uri$split2[0], _uri$split2$ = _uri$split2[1], search = _uri$split2$ === undefined ? "" : _uri$split2$;
                stack[index] = {
                    pathname: pathname,
                    search: search
                };
                states[index] = state;
            },
            go: function go(to) {
                var newIndex = index + to;
                if (newIndex < 0 || newIndex > states.length - 1) return;
                index = newIndex;
            }
        }
    };
};
////////////////////////////////////////////////////////////////////////////////
// global history - uses window.history as the source if available, otherwise a
// memory history
var $f125bbca2c654db8$var$canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
var $f125bbca2c654db8$var$getSource = function getSource() {
    return $f125bbca2c654db8$var$canUseDOM ? window : $f125bbca2c654db8$export$f8892d7c0e30dbc3();
};
var $f125bbca2c654db8$export$a2ad86361069f785 = $f125bbca2c654db8$export$4178d7ac16e6cf7c($f125bbca2c654db8$var$getSource());
var $f125bbca2c654db8$export$ff7962acd6052c28 = $f125bbca2c654db8$export$a2ad86361069f785.navigate;


var $66249767282b1118$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
function $66249767282b1118$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
function $66249767282b1118$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $66249767282b1118$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $66249767282b1118$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
////////////////////////////////////////////////////////////////////////////////
var $66249767282b1118$var$createNamedContext = function createNamedContext(name, defaultValue) {
    var Ctx = (0, (/*@__PURE__*/$parcel$interopDefault($3afa96475c004866$exports)))(defaultValue);
    Ctx.displayName = name;
    return Ctx;
};
////////////////////////////////////////////////////////////////////////////////
// Location Context/Provider
var $66249767282b1118$var$LocationContext = $66249767282b1118$var$createNamedContext("Location");
// sets up a listener if there isn't one already so apps don't need to be
// wrapped in some top level provider
var $66249767282b1118$export$18a2be9195644f38 = function Location(_ref) {
    var children = _ref.children;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($66249767282b1118$var$LocationContext.Consumer, null, function(context) {
        return context ? children(context) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($66249767282b1118$export$5af065edda80e75c, null, children);
    });
};
var $66249767282b1118$export$5af065edda80e75c = function(_React$Component) {
    $66249767282b1118$var$_inherits(LocationProvider, _React$Component);
    function LocationProvider() {
        var _temp, _this, _ret;
        $66249767282b1118$var$_classCallCheck(this, LocationProvider);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $66249767282b1118$var$_possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [
            this
        ].concat(args))), _this), _this.state = {
            context: _this.getContext(),
            refs: {
                unlisten: null
            }
        }, _temp), $66249767282b1118$var$_possibleConstructorReturn(_this, _ret);
    }
    LocationProvider.prototype.getContext = function getContext() {
        var _props$history = this.props.history, navigate = _props$history.navigate, location = _props$history.location;
        return {
            navigate: navigate,
            location: location
        };
    };
    LocationProvider.prototype.componentDidCatch = function componentDidCatch(error, info) {
        if ($66249767282b1118$export$4cb830d4f7e56898(error)) {
            var _navigate = this.props.history.navigate;
            _navigate(error.uri, {
                replace: true
            });
        } else throw error;
    };
    LocationProvider.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
        if (prevState.context.location !== this.state.context.location) this.props.history._onTransitionComplete();
    };
    LocationProvider.prototype.componentDidMount = function componentDidMount() {
        var _this2 = this;
        var refs = this.state.refs, history = this.props.history;
        history._onTransitionComplete();
        refs.unlisten = history.listen(function() {
            Promise.resolve().then(function() {
                // TODO: replace rAF with react deferred update API when it's ready https://github.com/facebook/react/issues/13306
                requestAnimationFrame(function() {
                    if (!_this2.unmounted) _this2.setState(function() {
                        return {
                            context: _this2.getContext()
                        };
                    });
                });
            });
        });
    };
    LocationProvider.prototype.componentWillUnmount = function componentWillUnmount() {
        var refs = this.state.refs;
        this.unmounted = true;
        refs.unlisten();
    };
    LocationProvider.prototype.render = function render() {
        var context = this.state.context, children = this.props.children;
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($66249767282b1118$var$LocationContext.Provider, {
            value: context
        }, typeof children === "function" ? children(context) : children || null);
    };
    return LocationProvider;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
////////////////////////////////////////////////////////////////////////////////
$66249767282b1118$export$5af065edda80e75c.defaultProps = {
    history: (0, $f125bbca2c654db8$export$a2ad86361069f785)
};
var $66249767282b1118$export$3f445d2f213f7c9 = function ServerLocation(_ref2) {
    var url = _ref2.url, children = _ref2.children;
    var searchIndex = url.indexOf("?");
    var searchExists = searchIndex > -1;
    var pathname = void 0;
    var search = "";
    var hash = "";
    if (searchExists) {
        pathname = url.substring(0, searchIndex);
        search = url.substring(searchIndex);
    } else pathname = url;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($66249767282b1118$var$LocationContext.Provider, {
        value: {
            location: {
                pathname: pathname,
                search: search,
                hash: hash
            },
            navigate: function navigate() {
                throw new Error("You can't call navigate on the server.");
            }
        }
    }, children);
};
////////////////////////////////////////////////////////////////////////////////
// Sets baseuri and basepath for nested routers and links
var $66249767282b1118$var$BaseContext = $66249767282b1118$var$createNamedContext("Base", {
    baseuri: "/",
    basepath: "/"
});
////////////////////////////////////////////////////////////////////////////////
// The main event, welcome to the show everybody.
var $66249767282b1118$export$55185c17a0fcbe46 = function Router(props) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($66249767282b1118$var$BaseContext.Consumer, null, function(baseContext) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($66249767282b1118$export$18a2be9195644f38, null, function(locationContext) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($66249767282b1118$var$RouterImpl, $66249767282b1118$var$_extends({}, baseContext, locationContext, props));
        });
    });
};
var $66249767282b1118$var$RouterImpl = function(_React$PureComponent) {
    $66249767282b1118$var$_inherits(RouterImpl, _React$PureComponent);
    function RouterImpl() {
        $66249767282b1118$var$_classCallCheck(this, RouterImpl);
        return $66249767282b1118$var$_possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
    }
    RouterImpl.prototype.render = function render() {
        var _props = this.props, location = _props.location, _navigate2 = _props.navigate, basepath = _props.basepath, primary = _props.primary, children = _props.children, baseuri = _props.baseuri, _props$component = _props.component, component = _props$component === undefined ? "div" : _props$component, domProps = $66249767282b1118$var$_objectWithoutProperties(_props, [
            "location",
            "navigate",
            "basepath",
            "primary",
            "children",
            "baseuri",
            "component"
        ]);
        var routes = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.toArray(children).reduce(function(array, child) {
            var routes = $66249767282b1118$var$createRoute(basepath)(child);
            return array.concat(routes);
        }, []);
        var pathname = location.pathname;
        var match = (0, $b59fe115cc21af2d$export$357523c63a2253b9)(routes, pathname);
        if (match) {
            var params = match.params, uri = match.uri, route = match.route, element = match.route.value;
            // remove the /* from the end for child routes relative paths
            basepath = route.default ? basepath : route.path.replace(/\*$/, "");
            var props = $66249767282b1118$var$_extends({}, params, {
                uri: uri,
                location: location,
                navigate: function navigate(to, options) {
                    return _navigate2((0, $b59fe115cc21af2d$export$f7ad0328861e2f03)(to, uri), options);
                }
            });
            var clone = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(element, props, element.props.children ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($66249767282b1118$export$55185c17a0fcbe46, {
                location: location,
                primary: primary
            }, element.props.children) : undefined);
            // using 'div' for < 16.3 support
            var FocusWrapper = primary ? $66249767282b1118$var$FocusHandler : component;
            // don't pass any props to 'div'
            var wrapperProps = primary ? $66249767282b1118$var$_extends({
                uri: uri,
                location: location,
                component: component
            }, domProps) : domProps;
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($66249767282b1118$var$BaseContext.Provider, {
                value: {
                    baseuri: uri,
                    basepath: basepath
                }
            }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(FocusWrapper, wrapperProps, clone));
        } else // Not sure if we want this, would require index routes at every level
        // warning(
        //   false,
        //   `<Router basepath="${basepath}">\n\nNothing matched:\n\t${
        //     location.pathname
        //   }\n\nPaths checked: \n\t${routes
        //     .map(route => route.path)
        //     .join(
        //       "\n\t"
        //     )}\n\nTo get rid of this warning, add a default NotFound component as child of Router:
        //   \n\tlet NotFound = () => <div>Not Found!</div>
        //   \n\t<Router>\n\t  <NotFound default/>\n\t  {/* ... */}\n\t</Router>`
        // );
        return null;
    };
    return RouterImpl;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).PureComponent);
$66249767282b1118$var$RouterImpl.defaultProps = {
    primary: true
};
var $66249767282b1118$var$FocusContext = $66249767282b1118$var$createNamedContext("Focus");
var $66249767282b1118$var$FocusHandler = function FocusHandler(_ref3) {
    var uri = _ref3.uri, location = _ref3.location, component = _ref3.component, domProps = $66249767282b1118$var$_objectWithoutProperties(_ref3, [
        "uri",
        "location",
        "component"
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($66249767282b1118$var$FocusContext.Consumer, null, function(requestFocus) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($66249767282b1118$var$FocusHandlerImpl, $66249767282b1118$var$_extends({}, domProps, {
            component: component,
            requestFocus: requestFocus,
            uri: uri,
            location: location
        }));
    });
};
// don't focus on initial render
var $66249767282b1118$var$initialRender = true;
var $66249767282b1118$var$focusHandlerCount = 0;
var $66249767282b1118$var$FocusHandlerImpl = function(_React$Component2) {
    $66249767282b1118$var$_inherits(FocusHandlerImpl, _React$Component2);
    function FocusHandlerImpl() {
        var _temp2, _this4, _ret2;
        $66249767282b1118$var$_classCallCheck(this, FocusHandlerImpl);
        for(var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return _ret2 = (_temp2 = (_this4 = $66249767282b1118$var$_possibleConstructorReturn(this, _React$Component2.call.apply(_React$Component2, [
            this
        ].concat(args))), _this4), _this4.state = {}, _this4.requestFocus = function(node) {
            if (!_this4.state.shouldFocus && node) node.focus();
        }, _temp2), $66249767282b1118$var$_possibleConstructorReturn(_this4, _ret2);
    }
    FocusHandlerImpl.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
        var initial = prevState.uri == null;
        if (initial) return $66249767282b1118$var$_extends({
            shouldFocus: true
        }, nextProps);
        else {
            var myURIChanged = nextProps.uri !== prevState.uri;
            var navigatedUpToMe = prevState.location.pathname !== nextProps.location.pathname && nextProps.location.pathname === nextProps.uri;
            return $66249767282b1118$var$_extends({
                shouldFocus: myURIChanged || navigatedUpToMe
            }, nextProps);
        }
    };
    FocusHandlerImpl.prototype.componentDidMount = function componentDidMount() {
        $66249767282b1118$var$focusHandlerCount++;
        this.focus();
    };
    FocusHandlerImpl.prototype.componentWillUnmount = function componentWillUnmount() {
        $66249767282b1118$var$focusHandlerCount--;
        if ($66249767282b1118$var$focusHandlerCount === 0) $66249767282b1118$var$initialRender = true;
    };
    FocusHandlerImpl.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
        if (prevProps.location !== this.props.location && this.state.shouldFocus) this.focus();
    };
    FocusHandlerImpl.prototype.focus = function focus() {
        var requestFocus = this.props.requestFocus;
        if (requestFocus) requestFocus(this.node);
        else {
            if ($66249767282b1118$var$initialRender) $66249767282b1118$var$initialRender = false;
            else if (this.node) // React polyfills [autofocus] and it fires earlier than cDM,
            // so we were stealing focus away, this line prevents that.
            {
                if (!this.node.contains(document.activeElement)) this.node.focus();
            }
        }
    };
    FocusHandlerImpl.prototype.render = function render() {
        var _this5 = this;
        var _props2 = this.props, children = _props2.children, style = _props2.style, requestFocus = _props2.requestFocus, _props2$component = _props2.component, Comp = _props2$component === undefined ? "div" : _props2$component, uri = _props2.uri, location = _props2.location, domProps = $66249767282b1118$var$_objectWithoutProperties(_props2, [
            "children",
            "style",
            "requestFocus",
            "component",
            "uri",
            "location"
        ]);
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Comp, $66249767282b1118$var$_extends({
            style: $66249767282b1118$var$_extends({
                outline: "none"
            }, style),
            tabIndex: "-1",
            ref: function ref(n) {
                return _this5.node = n;
            }
        }, domProps), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($66249767282b1118$var$FocusContext.Provider, {
            value: this.requestFocus
        }, this.props.children));
    };
    return FocusHandlerImpl;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
(0, $c8a186e1757974bb$export$cea1c58a6db52bca)($66249767282b1118$var$FocusHandlerImpl);
var $66249767282b1118$var$k = function k() {};
////////////////////////////////////////////////////////////////////////////////
var $66249767282b1118$var$forwardRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef;
if (typeof $66249767282b1118$var$forwardRef === "undefined") $66249767282b1118$var$forwardRef = function forwardRef(C) {
    return C;
};
var $66249767282b1118$export$a6c7ac8248d6e38a = $66249767282b1118$var$forwardRef(function(_ref4, ref) {
    var innerRef = _ref4.innerRef, props = $66249767282b1118$var$_objectWithoutProperties(_ref4, [
        "innerRef"
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($66249767282b1118$var$BaseContext.Consumer, null, function(_ref5) {
        var basepath = _ref5.basepath, baseuri = _ref5.baseuri;
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($66249767282b1118$export$18a2be9195644f38, null, function(_ref6) {
            var location = _ref6.location, navigate = _ref6.navigate;
            var to = props.to, state = props.state, replace = props.replace, _props$getProps = props.getProps, getProps = _props$getProps === undefined ? $66249767282b1118$var$k : _props$getProps, anchorProps = $66249767282b1118$var$_objectWithoutProperties(props, [
                "to",
                "state",
                "replace",
                "getProps"
            ]);
            var href = (0, $b59fe115cc21af2d$export$f7ad0328861e2f03)(to, baseuri);
            var encodedHref = encodeURI(href);
            var isCurrent = location.pathname === encodedHref;
            var isPartiallyCurrent = (0, $b59fe115cc21af2d$export$68326237475e9a7d)(location.pathname, encodedHref);
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("a", $66249767282b1118$var$_extends({
                ref: ref || innerRef,
                "aria-current": isCurrent ? "page" : undefined
            }, anchorProps, getProps({
                isCurrent: isCurrent,
                isPartiallyCurrent: isPartiallyCurrent,
                href: href,
                location: location
            }), {
                href: href,
                onClick: function onClick(event) {
                    if (anchorProps.onClick) anchorProps.onClick(event);
                    if ($66249767282b1118$var$shouldNavigate(event)) {
                        event.preventDefault();
                        var shouldReplace = replace;
                        if (typeof replace !== "boolean" && isCurrent) {
                            var _location$state = $66249767282b1118$var$_extends({}, location.state), key = _location$state.key, restState = $66249767282b1118$var$_objectWithoutProperties(_location$state, [
                                "key"
                            ]);
                            shouldReplace = (0, $b59fe115cc21af2d$export$90e866afbd6b9f1a)($66249767282b1118$var$_extends({}, state), restState);
                        }
                        navigate(href, {
                            state: state,
                            replace: shouldReplace
                        });
                    }
                }
            }));
        });
    });
});
$66249767282b1118$export$a6c7ac8248d6e38a.displayName = "Link";
////////////////////////////////////////////////////////////////////////////////
function $66249767282b1118$var$RedirectRequest(uri) {
    this.uri = uri;
}
var $66249767282b1118$export$4cb830d4f7e56898 = function isRedirect(o) {
    return o instanceof $66249767282b1118$var$RedirectRequest;
};
var $66249767282b1118$export$2d47ce6f15e624e5 = function redirectTo(to) {
    throw new $66249767282b1118$var$RedirectRequest(to);
};
var $66249767282b1118$var$RedirectImpl = function(_React$Component3) {
    $66249767282b1118$var$_inherits(RedirectImpl, _React$Component3);
    function RedirectImpl() {
        $66249767282b1118$var$_classCallCheck(this, RedirectImpl);
        return $66249767282b1118$var$_possibleConstructorReturn(this, _React$Component3.apply(this, arguments));
    }
    // Support React < 16 with this hook
    RedirectImpl.prototype.componentDidMount = function componentDidMount() {
        var _props3 = this.props, navigate = _props3.navigate, to = _props3.to, from = _props3.from, _props3$replace = _props3.replace, replace = _props3$replace === undefined ? true : _props3$replace, state = _props3.state, noThrow = _props3.noThrow, baseuri = _props3.baseuri, props = $66249767282b1118$var$_objectWithoutProperties(_props3, [
            "navigate",
            "to",
            "from",
            "replace",
            "state",
            "noThrow",
            "baseuri"
        ]);
        Promise.resolve().then(function() {
            var resolvedTo = (0, $b59fe115cc21af2d$export$f7ad0328861e2f03)(to, baseuri);
            navigate((0, $b59fe115cc21af2d$export$2560bc9559623b9)(resolvedTo, props), {
                replace: replace,
                state: state
            });
        });
    };
    RedirectImpl.prototype.render = function render() {
        var _props4 = this.props, navigate = _props4.navigate, to = _props4.to, from = _props4.from, replace = _props4.replace, state = _props4.state, noThrow = _props4.noThrow, baseuri = _props4.baseuri, props = $66249767282b1118$var$_objectWithoutProperties(_props4, [
            "navigate",
            "to",
            "from",
            "replace",
            "state",
            "noThrow",
            "baseuri"
        ]);
        var resolvedTo = (0, $b59fe115cc21af2d$export$f7ad0328861e2f03)(to, baseuri);
        if (!noThrow) $66249767282b1118$export$2d47ce6f15e624e5((0, $b59fe115cc21af2d$export$2560bc9559623b9)(resolvedTo, props));
        return null;
    };
    return RedirectImpl;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
var $66249767282b1118$export$2d8d895a0a0f636e = function Redirect(props) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($66249767282b1118$var$BaseContext.Consumer, null, function(_ref7) {
        var baseuri = _ref7.baseuri;
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($66249767282b1118$export$18a2be9195644f38, null, function(locationContext) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($66249767282b1118$var$RedirectImpl, $66249767282b1118$var$_extends({}, locationContext, {
                baseuri: baseuri
            }, props));
        });
    });
};
////////////////////////////////////////////////////////////////////////////////
var $66249767282b1118$export$f421feb8fad20413 = function Match(_ref8) {
    var path = _ref8.path, children = _ref8.children;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($66249767282b1118$var$BaseContext.Consumer, null, function(_ref9) {
        var baseuri = _ref9.baseuri;
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($66249767282b1118$export$18a2be9195644f38, null, function(_ref10) {
            var navigate = _ref10.navigate, location = _ref10.location;
            var resolvedPath = (0, $b59fe115cc21af2d$export$f7ad0328861e2f03)(path, baseuri);
            var result = (0, $b59fe115cc21af2d$export$4659b591c19bdf3d)(resolvedPath, location.pathname);
            return children({
                navigate: navigate,
                location: location,
                match: result ? $66249767282b1118$var$_extends({}, result.params, {
                    uri: result.uri,
                    path: path
                }) : null
            });
        });
    });
};
////////////////////////////////////////////////////////////////////////////////
// Hooks
var $66249767282b1118$export$45d76561a5302f2b = function useLocation() {
    var context = (0, $acw62.useContext)($66249767282b1118$var$LocationContext);
    if (!context) throw new Error("useLocation hook was used but a LocationContext.Provider was not found in the parent tree. Make sure this is used in a component that is a child of Router");
    return context.location;
};
var $66249767282b1118$export$9770f232ac06a008 = function useNavigate() {
    var context = (0, $acw62.useContext)($66249767282b1118$var$LocationContext);
    if (!context) throw new Error("useNavigate hook was used but a LocationContext.Provider was not found in the parent tree. Make sure this is used in a component that is a child of Router");
    return context.navigate;
};
var $66249767282b1118$export$99eaa27ddbbb95ef = function useParams() {
    var context = (0, $acw62.useContext)($66249767282b1118$var$BaseContext);
    if (!context) throw new Error("useParams hook was used but a LocationContext.Provider was not found in the parent tree. Make sure this is used in a component that is a child of Router");
    var location = $66249767282b1118$export$45d76561a5302f2b();
    var results = (0, $b59fe115cc21af2d$export$4659b591c19bdf3d)(context.basepath, location.pathname);
    return results ? results.params : null;
};
var $66249767282b1118$export$6c330e8992e8a295 = function useMatch(path) {
    if (!path) throw new Error("useMatch(path: string) requires an argument of a string to match against");
    var context = (0, $acw62.useContext)($66249767282b1118$var$BaseContext);
    if (!context) throw new Error("useMatch hook was used but a LocationContext.Provider was not found in the parent tree. Make sure this is used in a component that is a child of Router");
    var location = $66249767282b1118$export$45d76561a5302f2b();
    var resolvedPath = (0, $b59fe115cc21af2d$export$f7ad0328861e2f03)(path, context.baseuri);
    var result = (0, $b59fe115cc21af2d$export$4659b591c19bdf3d)(resolvedPath, location.pathname);
    return result ? $66249767282b1118$var$_extends({}, result.params, {
        uri: result.uri,
        path: path
    }) : null;
};
////////////////////////////////////////////////////////////////////////////////
// Junk
var $66249767282b1118$var$stripSlashes = function stripSlashes(str) {
    return str.replace(/(^\/+|\/+$)/g, "");
};
var $66249767282b1118$var$createRoute = function createRoute(basepath) {
    return function(element) {
        if (!element) return null;
        if (element.type === (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment && element.props.children) return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.map(element.props.children, createRoute(basepath));
        !(element.props.path || element.props.default || element.type === $66249767282b1118$export$2d8d895a0a0f636e) && (0, (/*@__PURE__*/$parcel$interopDefault($768901fea8dbe440$exports)))(false);
        !!(element.type === $66249767282b1118$export$2d8d895a0a0f636e && (!element.props.from || !element.props.to)) && (0, (/*@__PURE__*/$parcel$interopDefault($768901fea8dbe440$exports)))(false);
        !!(element.type === $66249767282b1118$export$2d8d895a0a0f636e && !(0, $b59fe115cc21af2d$export$569b01c992e4a17e)(element.props.from, element.props.to)) && (0, (/*@__PURE__*/$parcel$interopDefault($768901fea8dbe440$exports)))(false);
        if (element.props.default) return {
            value: element,
            default: true
        };
        var elementPath = element.type === $66249767282b1118$export$2d8d895a0a0f636e ? element.props.from : element.props.path;
        var path = elementPath === "/" ? basepath : $66249767282b1118$var$stripSlashes(basepath) + "/" + $66249767282b1118$var$stripSlashes(elementPath);
        return {
            value: element,
            default: element.props.default,
            path: element.props.children ? $66249767282b1118$var$stripSlashes(path) + "/*" : path
        };
    };
};
var $66249767282b1118$var$shouldNavigate = function shouldNavigate(event) {
    return !event.defaultPrevented && event.button === 0 && !(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};



var $acw62 = parcelRequire("acw62");
var $353901cfdd316a0a$export$e8e78c978b129247;
var $353901cfdd316a0a$export$c2b3f2d5308a7abd;
$353901cfdd316a0a$export$e8e78c978b129247 = `gPMrEW_root`;
$353901cfdd316a0a$export$c2b3f2d5308a7abd = `gPMrEW_routerWrapper`;


var $60313e3b9e75c852$exports = {};
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    "use strict";
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = "";
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === "string" || typeof arg === "number") return arg;
        if (typeof arg !== "object") return "";
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes("[native code]")) return arg.toString();
        var classes = "";
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + " " + newClass;
        return value + newClass;
    }
    if (0, $60313e3b9e75c852$exports) {
        classNames.default = classNames;
        $60313e3b9e75c852$exports = classNames;
    } else if (typeof define === "function" && typeof define.amd === "object" && define.amd) // register as 'classnames', consistent with npm package name
    define("classnames", [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();



var $acw62 = parcelRequire("acw62");
var $0fd3965b13b05e51$exports = {};

!function(t, e) {
    $0fd3965b13b05e51$exports = e((parcelRequire("acw62")));
}("undefined" != typeof self ? self : $0fd3965b13b05e51$exports, function(t) {
    return function(t) {
        var e = {};
        function n(r) {
            if (e[r]) return e[r].exports;
            var i = e[r] = {
                i: r,
                l: !1,
                exports: {}
            };
            return t[r].call(i.exports, i, i.exports, n), i.l = !0, i.exports;
        }
        return n.m = t, n.c = e, n.d = function(t, e, r) {
            n.o(t, e) || Object.defineProperty(t, e, {
                enumerable: !0,
                get: r
            });
        }, n.r = function(t) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(t, "__esModule", {
                value: !0
            });
        }, n.t = function(t, e) {
            if (1 & e && (t = n(t)), 8 & e) return t;
            if (4 & e && "object" == typeof t && t && t.__esModule) return t;
            var r = Object.create(null);
            if (n.r(r), Object.defineProperty(r, "default", {
                enumerable: !0,
                value: t
            }), 2 & e && "string" != typeof t) for(var i in t)n.d(r, i, (function(e) {
                return t[e];
            }).bind(null, i));
            return r;
        }, n.n = function(t) {
            var e = t && t.__esModule ? function() {
                return t.default;
            } : function() {
                return t;
            };
            return n.d(e, "a", e), e;
        }, n.o = function(t, e) {
            return Object.prototype.hasOwnProperty.call(t, e);
        }, n.p = "", n(n.s = 2);
    }([
        function(e, n) {
            e.exports = t;
        },
        function(t, e, n) {
            "use strict";
            var r = {
                linear: function(t, e, n, r) {
                    return (n - e) * t / r + e;
                },
                easeInQuad: function(t, e, n, r) {
                    return (n - e) * (t /= r) * t + e;
                },
                easeOutQuad: function(t, e, n, r) {
                    return -(n - e) * (t /= r) * (t - 2) + e;
                },
                easeInOutQuad: function(t, e, n, r) {
                    var i = n - e;
                    return (t /= r / 2) < 1 ? i / 2 * t * t + e : -i / 2 * (--t * (t - 2) - 1) + e;
                },
                easeInCubic: function(t, e, n, r) {
                    return (n - e) * (t /= r) * t * t + e;
                },
                easeOutCubic: function(t, e, n, r) {
                    return (n - e) * ((t = t / r - 1) * t * t + 1) + e;
                },
                easeInOutCubic: function(t, e, n, r) {
                    var i = n - e;
                    return (t /= r / 2) < 1 ? i / 2 * t * t * t + e : i / 2 * ((t -= 2) * t * t + 2) + e;
                },
                easeInQuart: function(t, e, n, r) {
                    return (n - e) * (t /= r) * t * t * t + e;
                },
                easeOutQuart: function(t, e, n, r) {
                    return -(n - e) * ((t = t / r - 1) * t * t * t - 1) + e;
                },
                easeInOutQuart: function(t, e, n, r) {
                    var i = n - e;
                    return (t /= r / 2) < 1 ? i / 2 * t * t * t * t + e : -i / 2 * ((t -= 2) * t * t * t - 2) + e;
                },
                easeInQuint: function(t, e, n, r) {
                    return (n - e) * (t /= r) * t * t * t * t + e;
                },
                easeOutQuint: function(t, e, n, r) {
                    return (n - e) * ((t = t / r - 1) * t * t * t * t + 1) + e;
                },
                easeInOutQuint: function(t, e, n, r) {
                    var i = n - e;
                    return (t /= r / 2) < 1 ? i / 2 * t * t * t * t * t + e : i / 2 * ((t -= 2) * t * t * t * t + 2) + e;
                },
                easeInSine: function(t, e, n, r) {
                    var i = n - e;
                    return -i * Math.cos(t / r * (Math.PI / 2)) + i + e;
                },
                easeOutSine: function(t, e, n, r) {
                    return (n - e) * Math.sin(t / r * (Math.PI / 2)) + e;
                },
                easeInOutSine: function(t, e, n, r) {
                    return -(n - e) / 2 * (Math.cos(Math.PI * t / r) - 1) + e;
                },
                easeInExpo: function(t, e, n, r) {
                    return 0 == t ? e : (n - e) * Math.pow(2, 10 * (t / r - 1)) + e;
                },
                easeOutExpo: function(t, e, n, r) {
                    var i = n - e;
                    return t == r ? e + i : i * (1 - Math.pow(2, -10 * t / r)) + e;
                },
                easeInOutExpo: function(t, e, n, r) {
                    var i = n - e;
                    return 0 === t ? e : t === r ? e + i : (t /= r / 2) < 1 ? i / 2 * Math.pow(2, 10 * (t - 1)) + e : i / 2 * (2 - Math.pow(2, -10 * --t)) + e;
                },
                easeInCirc: function(t, e, n, r) {
                    return -(n - e) * (Math.sqrt(1 - (t /= r) * t) - 1) + e;
                },
                easeOutCirc: function(t, e, n, r) {
                    return (n - e) * Math.sqrt(1 - (t = t / r - 1) * t) + e;
                },
                easeInOutCirc: function(t, e, n, r) {
                    var i = n - e;
                    return (t /= r / 2) < 1 ? -i / 2 * (Math.sqrt(1 - t * t) - 1) + e : i / 2 * (Math.sqrt(1 - (t -= 2) * t) + 1) + e;
                },
                easeInElastic: function(t, e, n, r) {
                    var i, o, a, c = n - e;
                    return a = 1.70158, 0 === t ? e : 1 == (t /= r) ? e + c : (o = 0, o = .3 * r, (i = c) < Math.abs(c) ? (i = c, a = o / 4) : a = o / (2 * Math.PI) * Math.asin(c / i), -i * Math.pow(2, 10 * (t -= 1)) * Math.sin((t * r - a) * (2 * Math.PI) / o) + e);
                },
                easeOutElastic: function(t, e, n, r) {
                    var i, o, a, c = n - e;
                    return a = 1.70158, 0 === t ? e : 1 == (t /= r) ? e + c : (o = 0, o = .3 * r, (i = c) < Math.abs(c) ? (i = c, a = o / 4) : a = o / (2 * Math.PI) * Math.asin(c / i), i * Math.pow(2, -10 * t) * Math.sin((t * r - a) * (2 * Math.PI) / o) + c + e);
                },
                easeInOutElastic: function(t, e, n, r) {
                    var i, o, a, c = n - e;
                    return a = 1.70158, 0 === t ? e : 2 == (t /= r / 2) ? e + c : (o = 0, o = r * (.3 * 1.5), (i = c) < Math.abs(c) ? (i = c, a = o / 4) : a = o / (2 * Math.PI) * Math.asin(c / i), t < 1 ? i * Math.pow(2, 10 * (t -= 1)) * Math.sin((t * r - a) * (2 * Math.PI) / o) * -0.5 + e : i * Math.pow(2, -10 * (t -= 1)) * Math.sin((t * r - a) * (2 * Math.PI) / o) * .5 + c + e);
                },
                easeInBack: function(t, e, n, r, i) {
                    return void 0 === i && (i = 1.70158), (n - e) * (t /= r) * t * ((i + 1) * t - i) + e;
                },
                easeOutBack: function(t, e, n, r, i) {
                    return void 0 === i && (i = 1.70158), (n - e) * ((t = t / r - 1) * t * ((i + 1) * t + i) + 1) + e;
                },
                easeInOutBack: function(t, e, n, r, i) {
                    var o = n - e;
                    return void 0 === i && (i = 1.70158), (t /= r / 2) < 1 ? o / 2 * (t * t * ((1 + (i *= 1.525)) * t - i)) + e : o / 2 * ((t -= 2) * t * ((1 + (i *= 1.525)) * t + i) + 2) + e;
                },
                easeInBounce: function(t, e, n, i) {
                    var o = n - e;
                    return o - r.easeOutBounce(i - t, 0, o, i) + e;
                },
                easeOutBounce: function(t, e, n, r) {
                    var i = n - e;
                    return (t /= r) < 1 / 2.75 ? i * (7.5625 * t * t) + e : t < 2 / 2.75 ? i * (7.5625 * (t -= 1.5 / 2.75) * t + .75) + e : t < 2.5 / 2.75 ? i * (7.5625 * (t -= 2.25 / 2.75) * t + .9375) + e : i * (7.5625 * (t -= 2.625 / 2.75) * t + .984375) + e;
                },
                easeInOutBounce: function(t, e, n, i) {
                    var o = n - e;
                    return t < i / 2 ? .5 * r.easeInBounce(2 * t, 0, o, i) + e : .5 * r.easeOutBounce(2 * t - i, 0, o, i) + .5 * o + e;
                }
            };
            t.exports = r;
        },
        function(t, e, n) {
            t.exports = n(3);
        },
        function(t, e, n) {
            "use strict";
            n.r(e);
            var r, i, o = n(0), a = n.n(o), c = n(1), s = n.n(c);
            function u(t, e) {
                return t + Math.random() * (e - t);
            }
            function f(t, e) {
                for(var n = 0; n < e.length; n++){
                    var r = e[n];
                    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
                }
            }
            function h(t, e, n) {
                return e in t ? Object.defineProperty(t, e, {
                    value: n,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }) : t[e] = n, t;
            }
            !function(t) {
                t[t.Circle = 0] = "Circle", t[t.Square = 1] = "Square", t[t.Strip = 2] = "Strip";
            }(r || (r = {})), function(t) {
                t[t.Positive = 1] = "Positive", t[t.Negative = -1] = "Negative";
            }(i || (i = {}));
            var l = function() {
                function t(e, n, r, o) {
                    !function(t, e) {
                        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                    }(this, t), h(this, "context", void 0), h(this, "radius", void 0), h(this, "x", void 0), h(this, "y", void 0), h(this, "w", void 0), h(this, "h", void 0), h(this, "vx", void 0), h(this, "vy", void 0), h(this, "shape", void 0), h(this, "angle", void 0), h(this, "angularSpin", void 0), h(this, "color", void 0), h(this, "rotateY", void 0), h(this, "rotationDirection", void 0), h(this, "getOptions", void 0), this.getOptions = n;
                    var a, c, s = this.getOptions(), f = s.colors, l = s.initialVelocityX, p = s.initialVelocityY;
                    this.context = e, this.x = r, this.y = o, this.w = u(5, 20), this.h = u(5, 20), this.radius = u(5, 10), this.vx = u(-l, l), this.vy = u(-p, 0), this.shape = (a = 0, c = 2, Math.floor(a + Math.random() * (c - a + 1))), this.angle = u(0, 360) * Math.PI / 180, this.angularSpin = u(-0.2, .2), this.color = f[Math.floor(Math.random() * f.length)], this.rotateY = u(0, 1), this.rotationDirection = u(0, 1) ? i.Positive : i.Negative;
                }
                var e, n, o;
                return e = t, n = [
                    {
                        key: "update",
                        value: function() {
                            var t = this.getOptions(), e = t.gravity, n = t.wind, o = t.friction, a = t.opacity, c = t.drawShape;
                            this.x += this.vx, this.y += this.vy, this.vy += e, this.vx += n, this.vx *= o, this.vy *= o, this.rotateY >= 1 && this.rotationDirection === i.Positive ? this.rotationDirection = i.Negative : this.rotateY <= -1 && this.rotationDirection === i.Negative && (this.rotationDirection = i.Positive);
                            var s = .1 * this.rotationDirection;
                            if (this.rotateY += s, this.angle += this.angularSpin, this.context.save(), this.context.translate(this.x, this.y), this.context.rotate(this.angle), this.context.scale(1, this.rotateY), this.context.rotate(this.angle), this.context.beginPath(), this.context.fillStyle = this.color, this.context.strokeStyle = this.color, this.context.globalAlpha = a, this.context.lineCap = "round", this.context.lineWidth = 2, c && "function" == typeof c) c.call(this, this.context);
                            else switch(this.shape){
                                case r.Circle:
                                    this.context.beginPath(), this.context.arc(0, 0, this.radius, 0, 2 * Math.PI), this.context.fill();
                                    break;
                                case r.Square:
                                    this.context.fillRect(-this.w / 2, -this.h / 2, this.w, this.h);
                                    break;
                                case r.Strip:
                                    this.context.fillRect(-this.w / 6, -this.h / 2, this.w / 3, this.h);
                            }
                            this.context.closePath(), this.context.restore();
                        }
                    }
                ], f(e.prototype, n), o && f(e, o), t;
            }();
            function p(t, e, n) {
                return e in t ? Object.defineProperty(t, e, {
                    value: n,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }) : t[e] = n, t;
            }
            var v = function t(e, n) {
                var r = this;
                !function(t, e) {
                    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                }(this, t), p(this, "canvas", void 0), p(this, "context", void 0), p(this, "getOptions", void 0), p(this, "x", 0), p(this, "y", 0), p(this, "w", 0), p(this, "h", 0), p(this, "lastNumberOfPieces", 0), p(this, "tweenInitTime", Date.now()), p(this, "particles", []), p(this, "particlesGenerated", 0), p(this, "removeParticleAt", function(t) {
                    r.particles.splice(t, 1);
                }), p(this, "getParticle", function() {
                    var t = u(r.x, r.w + r.x), e = u(r.y, r.h + r.y);
                    return new l(r.context, r.getOptions, t, e);
                }), p(this, "animate", function() {
                    var t = r.canvas, e = r.context, n = r.particlesGenerated, i = r.lastNumberOfPieces, o = r.getOptions(), a = o.run, c = o.recycle, s = o.numberOfPieces, u = o.debug, f = o.tweenFunction, h = o.tweenDuration;
                    if (!a) return !1;
                    var l = r.particles.length, p = c ? l : n, v = Date.now();
                    if (p < s) {
                        i !== s && (r.tweenInitTime = v, r.lastNumberOfPieces = s);
                        for(var y = r.tweenInitTime, d = f(v - y > h ? h : Math.max(0, v - y), p, s, h), b = Math.round(d - p), g = 0; g < b; g++)r.particles.push(r.getParticle());
                        r.particlesGenerated += b;
                    }
                    return u && (e.font = "12px sans-serif", e.fillStyle = "#333", e.textAlign = "right", e.fillText("Particles: ".concat(l), t.width - 10, t.height - 20)), r.particles.forEach(function(e, n) {
                        e.update(), (e.y > t.height || e.y < -100 || e.x > t.width + 100 || e.x < -100) && (c && p <= s ? r.particles[n] = r.getParticle() : r.removeParticleAt(n));
                    }), l > 0 || p < s;
                }), this.canvas = e;
                var i = this.canvas.getContext("2d");
                if (!i) throw new Error("Could not get canvas context");
                this.context = i, this.getOptions = n;
            };
            function y(t, e) {
                var n = Object.keys(t);
                if (Object.getOwnPropertySymbols) {
                    var r = Object.getOwnPropertySymbols(t);
                    e && (r = r.filter(function(e) {
                        return Object.getOwnPropertyDescriptor(t, e).enumerable;
                    })), n.push.apply(n, r);
                }
                return n;
            }
            function d(t, e) {
                for(var n = 0; n < e.length; n++){
                    var r = e[n];
                    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
                }
            }
            function b(t, e, n) {
                return e in t ? Object.defineProperty(t, e, {
                    value: n,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }) : t[e] = n, t;
            }
            var g = {
                width: "undefined" != typeof window ? window.innerWidth : 300,
                height: "undefined" != typeof window ? window.innerHeight : 200,
                numberOfPieces: 200,
                friction: .99,
                wind: 0,
                gravity: .1,
                initialVelocityX: 4,
                initialVelocityY: 10,
                colors: [
                    "#f44336",
                    "#e91e63",
                    "#9c27b0",
                    "#673ab7",
                    "#3f51b5",
                    "#2196f3",
                    "#03a9f4",
                    "#00bcd4",
                    "#009688",
                    "#4CAF50",
                    "#8BC34A",
                    "#CDDC39",
                    "#FFEB3B",
                    "#FFC107",
                    "#FF9800",
                    "#FF5722",
                    "#795548"
                ],
                opacity: 1,
                debug: !1,
                tweenFunction: s.a.easeInOutQuad,
                tweenDuration: 5e3,
                recycle: !0,
                run: !0
            }, O = function() {
                function t(e, n) {
                    var r = this;
                    !function(t, e) {
                        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                    }(this, t), b(this, "canvas", void 0), b(this, "context", void 0), b(this, "_options", void 0), b(this, "generator", void 0), b(this, "rafId", void 0), b(this, "setOptionsWithDefaults", function(t) {
                        var e = {
                            confettiSource: {
                                x: 0,
                                y: 0,
                                w: r.canvas.width,
                                h: 0
                            }
                        };
                        r._options = function(t) {
                            for(var e = 1; e < arguments.length; e++){
                                var n = null != arguments[e] ? arguments[e] : {};
                                e % 2 ? y(n, !0).forEach(function(e) {
                                    b(t, e, n[e]);
                                }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : y(n).forEach(function(e) {
                                    Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
                                });
                            }
                            return t;
                        }({}, e, {}, g, {}, t), Object.assign(r, t.confettiSource);
                    }), b(this, "update", function() {
                        var t = r.options, e = t.run, n = t.onConfettiComplete, i = r.canvas, o = r.context;
                        e && (o.fillStyle = "white", o.clearRect(0, 0, i.width, i.height)), r.generator.animate() ? r.rafId = requestAnimationFrame(r.update) : (n && "function" == typeof n && r.generator.particlesGenerated > 0 && n.call(r, r), r._options.run = !1);
                    }), b(this, "reset", function() {
                        r.generator && r.generator.particlesGenerated > 0 && (r.generator.particlesGenerated = 0, r.generator.particles = [], r.generator.lastNumberOfPieces = 0);
                    }), b(this, "stop", function() {
                        r.options = {
                            run: !1
                        }, r.rafId && (cancelAnimationFrame(r.rafId), r.rafId = void 0);
                    }), this.canvas = e;
                    var i = this.canvas.getContext("2d");
                    if (!i) throw new Error("Could not get canvas context");
                    this.context = i, this.generator = new v(this.canvas, function() {
                        return r.options;
                    }), this.options = n, this.update();
                }
                var e, n, r;
                return e = t, n = [
                    {
                        key: "options",
                        get: function() {
                            return this._options;
                        },
                        set: function(t) {
                            var e = this._options && this._options.run, n = this._options && this._options.recycle;
                            this.setOptionsWithDefaults(t), this.generator && (Object.assign(this.generator, this.options.confettiSource), "boolean" == typeof t.recycle && t.recycle && !1 === n && (this.generator.lastNumberOfPieces = this.generator.particles.length)), "boolean" == typeof t.run && t.run && !1 === e && this.update();
                        }
                    }
                ], d(e.prototype, n), r && d(e, r), t;
            }();
            function w(t) {
                return function(t) {
                    if (Array.isArray(t)) {
                        for(var e = 0, n = new Array(t.length); e < t.length; e++)n[e] = t[e];
                        return n;
                    }
                }(t) || function(t) {
                    if (Symbol.iterator in Object(t) || "[object Arguments]" === Object.prototype.toString.call(t)) return Array.from(t);
                }(t) || function() {
                    throw new TypeError("Invalid attempt to spread non-iterable instance");
                }();
            }
            function m(t) {
                return (m = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
                    return typeof t;
                } : function(t) {
                    return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                })(t);
            }
            function x() {
                return (x = Object.assign || function(t) {
                    for(var e = 1; e < arguments.length; e++){
                        var n = arguments[e];
                        for(var r in n)Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
                    }
                    return t;
                }).apply(this, arguments);
            }
            function P(t, e) {
                var n = Object.keys(t);
                if (Object.getOwnPropertySymbols) {
                    var r = Object.getOwnPropertySymbols(t);
                    e && (r = r.filter(function(e) {
                        return Object.getOwnPropertyDescriptor(t, e).enumerable;
                    })), n.push.apply(n, r);
                }
                return n;
            }
            function j(t) {
                for(var e = 1; e < arguments.length; e++){
                    var n = null != arguments[e] ? arguments[e] : {};
                    e % 2 ? P(n, !0).forEach(function(e) {
                        D(t, e, n[e]);
                    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : P(n).forEach(function(e) {
                        Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
                    });
                }
                return t;
            }
            function M(t, e) {
                return function(t) {
                    if (Array.isArray(t)) return t;
                }(t) || function(t, e) {
                    var n = [], r = !0, i = !1, o = void 0;
                    try {
                        for(var a, c = t[Symbol.iterator](); !(r = (a = c.next()).done) && (n.push(a.value), !e || n.length !== e); r = !0);
                    } catch (t) {
                        i = !0, o = t;
                    } finally{
                        try {
                            r || null == c.return || c.return();
                        } finally{
                            if (i) throw o;
                        }
                    }
                    return n;
                }(t, e) || function() {
                    throw new TypeError("Invalid attempt to destructure non-iterable instance");
                }();
            }
            function I(t, e) {
                for(var n = 0; n < e.length; n++){
                    var r = e[n];
                    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
                }
            }
            function S(t) {
                return (S = Object.setPrototypeOf ? Object.getPrototypeOf : function(t) {
                    return t.__proto__ || Object.getPrototypeOf(t);
                })(t);
            }
            function C(t) {
                if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return t;
            }
            function E(t, e) {
                return (E = Object.setPrototypeOf || function(t, e) {
                    return t.__proto__ = e, t;
                })(t, e);
            }
            function D(t, e, n) {
                return e in t ? Object.defineProperty(t, e, {
                    value: n,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }) : t[e] = n, t;
            }
            n.d(e, "ReactConfetti", function() {
                return A;
            });
            var _ = function(t) {
                function e(t) {
                    var n, r;
                    !function(t, e) {
                        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                    }(this, e);
                    for(var i = arguments.length, o = new Array(i > 1 ? i - 1 : 0), c = 1; c < i; c++)o[c - 1] = arguments[c];
                    return r = function(t, e) {
                        return !e || "object" !== m(e) && "function" != typeof e ? C(t) : e;
                    }(this, (n = S(e)).call.apply(n, [
                        this,
                        t
                    ].concat(o))), D(C(r), "canvas", a.a.createRef()), D(C(r), "confetti", void 0), r.canvas = t.canvasRef || a.a.createRef(), r;
                }
                var n, r, i;
                return function(t, e) {
                    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
                    t.prototype = Object.create(e && e.prototype, {
                        constructor: {
                            value: t,
                            writable: !0,
                            configurable: !0
                        }
                    }), e && E(t, e);
                }(e, o["Component"]), n = e, r = [
                    {
                        key: "componentDidMount",
                        value: function() {
                            if (this.canvas.current) {
                                var t = k(this.props)[0];
                                this.confetti = new O(this.canvas.current, t);
                            }
                        }
                    },
                    {
                        key: "componentWillReceiveProps",
                        value: function(t) {
                            var e = k(t)[0];
                            this.confetti && (this.confetti.options = e);
                        }
                    },
                    {
                        key: "componentWillUnmount",
                        value: function() {
                            this.confetti && this.confetti.stop(), this.confetti = void 0;
                        }
                    },
                    {
                        key: "render",
                        value: function() {
                            var t = M(k(this.props), 2), e = t[0], n = t[1], r = j({
                                zIndex: 2,
                                position: "absolute",
                                pointerEvents: "none",
                                top: 0,
                                left: 0,
                                bottom: 0,
                                right: 0
                            }, n.style);
                            return a.a.createElement("canvas", x({
                                width: e.width,
                                height: e.height,
                                ref: this.canvas
                            }, n, {
                                style: r
                            }));
                        }
                    }
                ], I(n.prototype, r), i && I(n, i), e;
            }();
            function k(t) {
                var e = {}, n = {}, r = [].concat(w(Object.keys(g)), [
                    "confettiSource",
                    "drawShape",
                    "onConfettiComplete"
                ]), i = [
                    "canvasRef"
                ];
                for(var o in t){
                    var a = t[o];
                    r.includes(o) ? e[o] = a : i.includes(o) ? i[o] = a : n[o] = a;
                }
                return [
                    e,
                    n,
                    {}
                ];
            }
            D(_, "defaultProps", j({}, g)), D(_, "displayName", "ReactConfetti");
            var A = a.a.forwardRef(function(t, e) {
                return a.a.createElement(_, x({
                    canvasRef: e
                }, t));
            });
            e.default = A;
        }
    ]).default;
});


var $c8cd6c72d9560405$exports = {};
"use strict";
Object.defineProperty($c8cd6c72d9560405$exports, "__esModule", {
    value: true
});
var $c8cd6c72d9560405$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $acw62 = parcelRequire("acw62");
var $c8cd6c72d9560405$var$_react2 = $c8cd6c72d9560405$var$_interopRequireDefault($acw62);

var $c8cd6c72d9560405$var$_propTypes2 = $c8cd6c72d9560405$var$_interopRequireDefault($8da5bfbbed271cd7$exports);
function $c8cd6c72d9560405$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $c8cd6c72d9560405$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $c8cd6c72d9560405$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $c8cd6c72d9560405$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $c8cd6c72d9560405$var$propTypes = {
    from: $c8cd6c72d9560405$var$_propTypes2.default.number,
    to: $c8cd6c72d9560405$var$_propTypes2.default.number.isRequired,
    speed: $c8cd6c72d9560405$var$_propTypes2.default.number.isRequired,
    delay: $c8cd6c72d9560405$var$_propTypes2.default.number,
    onComplete: $c8cd6c72d9560405$var$_propTypes2.default.func,
    digits: $c8cd6c72d9560405$var$_propTypes2.default.number,
    className: $c8cd6c72d9560405$var$_propTypes2.default.string,
    tagName: $c8cd6c72d9560405$var$_propTypes2.default.string,
    children: $c8cd6c72d9560405$var$_propTypes2.default.func,
    easing: $c8cd6c72d9560405$var$_propTypes2.default.func
};
var $c8cd6c72d9560405$var$defaultProps = {
    from: 0,
    delay: 100,
    digits: 0,
    tagName: "span",
    easing: function easing(t) {
        return t;
    }
};
var $c8cd6c72d9560405$var$CountTo = function(_PureComponent) {
    $c8cd6c72d9560405$var$_inherits(CountTo, _PureComponent);
    function CountTo(props) {
        $c8cd6c72d9560405$var$_classCallCheck(this, CountTo);
        var _this = $c8cd6c72d9560405$var$_possibleConstructorReturn(this, (CountTo.__proto__ || Object.getPrototypeOf(CountTo)).call(this, props));
        var from = props.from;
        _this.state = {
            counter: from
        };
        _this.start = _this.start.bind(_this);
        _this.clear = _this.clear.bind(_this);
        _this.next = _this.next.bind(_this);
        _this.updateCounter = _this.updateCounter.bind(_this);
        return _this;
    }
    $c8cd6c72d9560405$var$_createClass(CountTo, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.start();
            }
        },
        {
            key: "componentWillReceiveProps",
            value: function componentWillReceiveProps(nextProps) {
                var _props = this.props, from = _props.from, to = _props.to;
                if (nextProps.to !== to || nextProps.from !== from) this.start(nextProps);
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.clear();
            }
        },
        {
            key: "start",
            value: function start() {
                var _this2 = this;
                var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
                this.clear();
                var from = props.from;
                this.setState({
                    counter: from
                }, function() {
                    var _props2 = _this2.props, speed = _props2.speed, delay = _props2.delay;
                    var now = Date.now();
                    _this2.endDate = now + speed;
                    _this2.scheduleNextUpdate(now, delay);
                    _this2.raf = requestAnimationFrame(_this2.next);
                });
            }
        },
        {
            key: "next",
            value: function next() {
                var now = Date.now();
                var _props3 = this.props, speed = _props3.speed, onComplete = _props3.onComplete, delay = _props3.delay;
                if (now >= this.nextUpdate) {
                    var progress = Math.max(0, Math.min(1, 1 - (this.endDate - now) / speed));
                    this.updateCounter(progress);
                    this.scheduleNextUpdate(now, delay);
                }
                if (now < this.endDate) this.raf = requestAnimationFrame(this.next);
                else if (onComplete) onComplete();
            }
        },
        {
            key: "scheduleNextUpdate",
            value: function scheduleNextUpdate(now, delay) {
                this.nextUpdate = Math.min(now + delay, this.endDate);
            }
        },
        {
            key: "updateCounter",
            value: function updateCounter(progress) {
                var _props4 = this.props, from = _props4.from, to = _props4.to, easing = _props4.easing;
                var delta = to - from;
                var counter = from + delta * easing(progress);
                this.setState({
                    counter: counter
                });
            }
        },
        {
            key: "clear",
            value: function clear() {
                cancelAnimationFrame(this.raf);
            }
        },
        {
            key: "render",
            value: function render() {
                var _props5 = this.props, className = _props5.className, digits = _props5.digits, Tag = _props5.tagName, fn = _props5.children;
                var counter = this.state.counter;
                var value = counter.toFixed(digits);
                if (fn) return fn(value);
                return $c8cd6c72d9560405$var$_react2.default.createElement(Tag, {
                    className: className
                }, value);
            }
        }
    ]);
    return CountTo;
}($acw62.PureComponent);
$c8cd6c72d9560405$var$CountTo.propTypes = $c8cd6c72d9560405$var$propTypes;
$c8cd6c72d9560405$var$CountTo.defaultProps = $c8cd6c72d9560405$var$defaultProps;
$c8cd6c72d9560405$exports.default = $c8cd6c72d9560405$var$CountTo;


var $d5bf021e81f47411$export$1e511d4a378977f5;
var $d5bf021e81f47411$export$dcef8f9bb9a41431;
var $d5bf021e81f47411$export$2e2bcd8739ae039;
$d5bf021e81f47411$export$1e511d4a378977f5 = true;
$d5bf021e81f47411$export$dcef8f9bb9a41431 = undefined;
var $d5bf021e81f47411$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $d5bf021e81f47411$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $acw62 = parcelRequire("acw62");
var $d5bf021e81f47411$var$_react2 = $d5bf021e81f47411$var$_interopRequireDefault($acw62);

var $d5bf021e81f47411$var$_propTypes2 = $d5bf021e81f47411$var$_interopRequireDefault($8da5bfbbed271cd7$exports);
var $2a96cca22bca25a2$exports = {};
"use strict";
function $2a96cca22bca25a2$var$_interopDefault(ex) {
    return ex && typeof ex === "object" && "default" in ex ? ex["default"] : ex;
}

var $acw62 = parcelRequire("acw62");
var $2a96cca22bca25a2$var$React__default = $2a96cca22bca25a2$var$_interopDefault($acw62);

var $2a96cca22bca25a2$var$shallowEqual = $2a96cca22bca25a2$var$_interopDefault((parcelRequire("i5C3F")));
function $2a96cca22bca25a2$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $2a96cca22bca25a2$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $2a96cca22bca25a2$var$canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
function $2a96cca22bca25a2$var$withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
    if (typeof reducePropsToState !== "function") throw new Error("Expected reducePropsToState to be a function.");
    if (typeof handleStateChangeOnClient !== "function") throw new Error("Expected handleStateChangeOnClient to be a function.");
    if (typeof mapStateOnServer !== "undefined" && typeof mapStateOnServer !== "function") throw new Error("Expected mapStateOnServer to either be undefined or a function.");
    function getDisplayName(WrappedComponent) {
        return WrappedComponent.displayName || WrappedComponent.name || "Component";
    }
    return function wrap(WrappedComponent) {
        if (typeof WrappedComponent !== "function") throw new Error("Expected WrappedComponent to be a React component.");
        var mountedInstances = [];
        var state;
        function emitChange() {
            state = reducePropsToState(mountedInstances.map(function(instance) {
                return instance.props;
            }));
            if (SideEffect.canUseDOM) handleStateChangeOnClient(state);
            else if (mapStateOnServer) state = mapStateOnServer(state);
        }
        var SideEffect = /*#__PURE__*/ function(_Component) {
            $2a96cca22bca25a2$var$_inheritsLoose(SideEffect, _Component);
            function SideEffect() {
                return _Component.apply(this, arguments) || this;
            }
            // Try to use displayName of wrapped component
            // Expose canUseDOM so tests can monkeypatch it
            SideEffect.peek = function peek() {
                return state;
            };
            SideEffect.rewind = function rewind() {
                if (SideEffect.canUseDOM) throw new Error("You may only call rewind() on the server. Call peek() to read the current state.");
                var recordedState = state;
                state = undefined;
                mountedInstances = [];
                return recordedState;
            };
            var _proto = SideEffect.prototype;
            _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
                return !$2a96cca22bca25a2$var$shallowEqual(nextProps, this.props);
            };
            _proto.componentWillMount = function componentWillMount() {
                mountedInstances.push(this);
                emitChange();
            };
            _proto.componentDidUpdate = function componentDidUpdate() {
                emitChange();
            };
            _proto.componentWillUnmount = function componentWillUnmount() {
                var index = mountedInstances.indexOf(this);
                mountedInstances.splice(index, 1);
                emitChange();
            };
            _proto.render = function render() {
                return $2a96cca22bca25a2$var$React__default.createElement(WrappedComponent, this.props);
            };
            return SideEffect;
        }($acw62.Component);
        $2a96cca22bca25a2$var$_defineProperty(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");
        $2a96cca22bca25a2$var$_defineProperty(SideEffect, "canUseDOM", $2a96cca22bca25a2$var$canUseDOM);
        return SideEffect;
    };
}
$2a96cca22bca25a2$exports = $2a96cca22bca25a2$var$withSideEffect;


var $d5bf021e81f47411$var$_reactSideEffect2 = $d5bf021e81f47411$var$_interopRequireDefault($2a96cca22bca25a2$exports);
var $77ddc6be16b1d7de$exports = {};
"use strict";
var $77ddc6be16b1d7de$var$isArray = Array.isArray;
var $77ddc6be16b1d7de$var$keyList = Object.keys;
var $77ddc6be16b1d7de$var$hasProp = Object.prototype.hasOwnProperty;
var $77ddc6be16b1d7de$var$hasElementType = typeof Element !== "undefined";
function $77ddc6be16b1d7de$var$equal(a, b) {
    // fast-deep-equal index.js 2.0.1
    if (a === b) return true;
    if (a && b && typeof a == "object" && typeof b == "object") {
        var arrA = $77ddc6be16b1d7de$var$isArray(a), arrB = $77ddc6be16b1d7de$var$isArray(b), i, length, key;
        if (arrA && arrB) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!$77ddc6be16b1d7de$var$equal(a[i], b[i])) return false;
            return true;
        }
        if (arrA != arrB) return false;
        var dateA = a instanceof Date, dateB = b instanceof Date;
        if (dateA != dateB) return false;
        if (dateA && dateB) return a.getTime() == b.getTime();
        var regexpA = a instanceof RegExp, regexpB = b instanceof RegExp;
        if (regexpA != regexpB) return false;
        if (regexpA && regexpB) return a.toString() == b.toString();
        var keys = $77ddc6be16b1d7de$var$keyList(a);
        length = keys.length;
        if (length !== $77ddc6be16b1d7de$var$keyList(b).length) return false;
        for(i = length; i-- !== 0;)if (!$77ddc6be16b1d7de$var$hasProp.call(b, keys[i])) return false;
        // end fast-deep-equal
        // start react-fast-compare
        // custom handling for DOM elements
        if ($77ddc6be16b1d7de$var$hasElementType && a instanceof Element && b instanceof Element) return a === b;
        // custom handling for React
        for(i = length; i-- !== 0;){
            key = keys[i];
            if (key === "_owner" && a.$$typeof) continue;
            else {
                // all other properties should be traversed as usual
                if (!$77ddc6be16b1d7de$var$equal(a[key], b[key])) return false;
            }
        }
        // end react-fast-compare
        // fast-deep-equal index.js 2.0.1
        return true;
    }
    return a !== a && b !== b;
}
// end fast-deep-equal
$77ddc6be16b1d7de$exports = function exportedEqual(a, b) {
    try {
        return $77ddc6be16b1d7de$var$equal(a, b);
    } catch (error) {
        if (error.message && error.message.match(/stack|recursion/i) || error.number === -2146828260) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn("Warning: react-fast-compare does not handle circular references.", error.name, error.message);
            return false;
        }
        // some other error. we should definitely know about these
        throw error;
    }
};


var $d5bf021e81f47411$var$_reactFastCompare2 = $d5bf021e81f47411$var$_interopRequireDefault($77ddc6be16b1d7de$exports);
var $abfe7f65d53bab7d$export$1e511d4a378977f5;
var $abfe7f65d53bab7d$export$c106dd0671a0fc2d;
var $abfe7f65d53bab7d$export$6cb2c4c0a22909c0;
var $abfe7f65d53bab7d$export$bfed3b07ff81c934;
var $abfe7f65d53bab7d$export$971402543ca2bd1d;
var $abfe7f65d53bab7d$export$8e0854f6f2040fff;
var $abfe7f65d53bab7d$export$8f437c7c6568a694;
$abfe7f65d53bab7d$export$1e511d4a378977f5 = true;
$abfe7f65d53bab7d$export$c106dd0671a0fc2d = $abfe7f65d53bab7d$export$6cb2c4c0a22909c0 = $abfe7f65d53bab7d$export$bfed3b07ff81c934 = $abfe7f65d53bab7d$export$971402543ca2bd1d = $abfe7f65d53bab7d$export$8e0854f6f2040fff = $abfe7f65d53bab7d$export$8f437c7c6568a694 = undefined;
var $abfe7f65d53bab7d$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var $abfe7f65d53bab7d$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $acw62 = parcelRequire("acw62");
var $abfe7f65d53bab7d$var$_react2 = $abfe7f65d53bab7d$var$_interopRequireDefault($acw62);

var $8coUR = parcelRequire("8coUR");
var $abfe7f65d53bab7d$var$_objectAssign2 = $abfe7f65d53bab7d$var$_interopRequireDefault($8coUR);
var $888a808a9f9527b4$export$1e511d4a378977f5;
var $888a808a9f9527b4$export$8b4d23abccee6cc2;
var $888a808a9f9527b4$export$7e674a85a2656dce;
var $888a808a9f9527b4$export$7a7b396eb62fa0f9;
var $888a808a9f9527b4$export$55a55363959ee034;
var $888a808a9f9527b4$export$f5ab464b3d67ea9c;
var $888a808a9f9527b4$export$6bb0645fb3f2618c;
var $888a808a9f9527b4$export$3fedf55cd3a4e6fa;
var $888a808a9f9527b4$export$7f7c530a82f07f20;
var $888a808a9f9527b4$export$1f547d7d8e831b2b;
$888a808a9f9527b4$export$1e511d4a378977f5 = true;
var $888a808a9f9527b4$var$ATTRIBUTE_NAMES = $888a808a9f9527b4$export$8b4d23abccee6cc2 = {
    BODY: "bodyAttributes",
    HTML: "htmlAttributes",
    TITLE: "titleAttributes"
};
var $888a808a9f9527b4$var$TAG_NAMES = $888a808a9f9527b4$export$7e674a85a2656dce = {
    BASE: "base",
    BODY: "body",
    HEAD: "head",
    HTML: "html",
    LINK: "link",
    META: "meta",
    NOSCRIPT: "noscript",
    SCRIPT: "script",
    STYLE: "style",
    TITLE: "title"
};
var $888a808a9f9527b4$var$VALID_TAG_NAMES = $888a808a9f9527b4$export$7a7b396eb62fa0f9 = Object.keys($888a808a9f9527b4$var$TAG_NAMES).map(function(name) {
    return $888a808a9f9527b4$var$TAG_NAMES[name];
});
var $888a808a9f9527b4$var$TAG_PROPERTIES = $888a808a9f9527b4$export$55a55363959ee034 = {
    CHARSET: "charset",
    CSS_TEXT: "cssText",
    HREF: "href",
    HTTPEQUIV: "http-equiv",
    INNER_HTML: "innerHTML",
    ITEM_PROP: "itemprop",
    NAME: "name",
    PROPERTY: "property",
    REL: "rel",
    SRC: "src"
};
var $888a808a9f9527b4$var$REACT_TAG_MAP = $888a808a9f9527b4$export$f5ab464b3d67ea9c = {
    accesskey: "accessKey",
    charset: "charSet",
    class: "className",
    contenteditable: "contentEditable",
    contextmenu: "contextMenu",
    "http-equiv": "httpEquiv",
    itemprop: "itemProp",
    tabindex: "tabIndex"
};
var $888a808a9f9527b4$var$HELMET_PROPS = $888a808a9f9527b4$export$6bb0645fb3f2618c = {
    DEFAULT_TITLE: "defaultTitle",
    DEFER: "defer",
    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
    TITLE_TEMPLATE: "titleTemplate"
};
var $888a808a9f9527b4$var$HTML_TAG_MAP = $888a808a9f9527b4$export$3fedf55cd3a4e6fa = Object.keys($888a808a9f9527b4$var$REACT_TAG_MAP).reduce(function(obj, key) {
    obj[$888a808a9f9527b4$var$REACT_TAG_MAP[key]] = key;
    return obj;
}, {});
var $888a808a9f9527b4$var$SELF_CLOSING_TAGS = $888a808a9f9527b4$export$7f7c530a82f07f20 = [
    $888a808a9f9527b4$var$TAG_NAMES.NOSCRIPT,
    $888a808a9f9527b4$var$TAG_NAMES.SCRIPT,
    $888a808a9f9527b4$var$TAG_NAMES.STYLE
];
var $888a808a9f9527b4$var$HELMET_ATTRIBUTE = $888a808a9f9527b4$export$1f547d7d8e831b2b = "data-react-helmet";


function $abfe7f65d53bab7d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $abfe7f65d53bab7d$var$encodeSpecialCharacters = function encodeSpecialCharacters(str) {
    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    if (encode === false) return String(str);
    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
};
var $abfe7f65d53bab7d$var$getTitleFromPropsList = function getTitleFromPropsList(propsList) {
    var innermostTitle = $abfe7f65d53bab7d$var$getInnermostProperty(propsList, $888a808a9f9527b4$export$7e674a85a2656dce.TITLE);
    var innermostTemplate = $abfe7f65d53bab7d$var$getInnermostProperty(propsList, $888a808a9f9527b4$export$6bb0645fb3f2618c.TITLE_TEMPLATE);
    if (innermostTemplate && innermostTitle) // use function arg to avoid need to escape $ characters
    return innermostTemplate.replace(/%s/g, function() {
        return innermostTitle;
    });
    var innermostDefaultTitle = $abfe7f65d53bab7d$var$getInnermostProperty(propsList, $888a808a9f9527b4$export$6bb0645fb3f2618c.DEFAULT_TITLE);
    return innermostTitle || innermostDefaultTitle || undefined;
};
var $abfe7f65d53bab7d$var$getOnChangeClientState = function getOnChangeClientState(propsList) {
    return $abfe7f65d53bab7d$var$getInnermostProperty(propsList, $888a808a9f9527b4$export$6bb0645fb3f2618c.ON_CHANGE_CLIENT_STATE) || function() {};
};
var $abfe7f65d53bab7d$var$getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
    return propsList.filter(function(props) {
        return typeof props[tagType] !== "undefined";
    }).map(function(props) {
        return props[tagType];
    }).reduce(function(tagAttrs, current) {
        return $abfe7f65d53bab7d$var$_extends({}, tagAttrs, current);
    }, {});
};
var $abfe7f65d53bab7d$var$getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
    return propsList.filter(function(props) {
        return typeof props[$888a808a9f9527b4$export$7e674a85a2656dce.BASE] !== "undefined";
    }).map(function(props) {
        return props[$888a808a9f9527b4$export$7e674a85a2656dce.BASE];
    }).reverse().reduce(function(innermostBaseTag, tag) {
        if (!innermostBaseTag.length) {
            var keys = Object.keys(tag);
            for(var i = 0; i < keys.length; i++){
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) return innermostBaseTag.concat(tag);
            }
        }
        return innermostBaseTag;
    }, []);
};
var $abfe7f65d53bab7d$var$getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
    // Calculate list of tags, giving priority innermost component (end of the propslist)
    var approvedSeenTags = {};
    return propsList.filter(function(props) {
        if (Array.isArray(props[tagName])) return true;
        if (typeof props[tagName] !== "undefined") $abfe7f65d53bab7d$var$warn("Helmet: " + tagName + ' should be of type "Array". Instead found type "' + $abfe7f65d53bab7d$var$_typeof(props[tagName]) + '"');
        return false;
    }).map(function(props) {
        return props[tagName];
    }).reverse().reduce(function(approvedTags, instanceTags) {
        var instanceSeenTags = {};
        instanceTags.filter(function(tag) {
            var primaryAttributeKey = void 0;
            var keys = Object.keys(tag);
            for(var i = 0; i < keys.length; i++){
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();
                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === $888a808a9f9527b4$export$55a55363959ee034.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === $888a808a9f9527b4$export$55a55363959ee034.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) primaryAttributeKey = lowerCaseAttributeKey;
                // Special case for innerHTML which doesn't work lowercased
                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === $888a808a9f9527b4$export$55a55363959ee034.INNER_HTML || attributeKey === $888a808a9f9527b4$export$55a55363959ee034.CSS_TEXT || attributeKey === $888a808a9f9527b4$export$55a55363959ee034.ITEM_PROP)) primaryAttributeKey = attributeKey;
            }
            if (!primaryAttributeKey || !tag[primaryAttributeKey]) return false;
            var value = tag[primaryAttributeKey].toLowerCase();
            if (!approvedSeenTags[primaryAttributeKey]) approvedSeenTags[primaryAttributeKey] = {};
            if (!instanceSeenTags[primaryAttributeKey]) instanceSeenTags[primaryAttributeKey] = {};
            if (!approvedSeenTags[primaryAttributeKey][value]) {
                instanceSeenTags[primaryAttributeKey][value] = true;
                return true;
            }
            return false;
        }).reverse().forEach(function(tag) {
            return approvedTags.push(tag);
        });
        // Update seen tags with tags from this instance
        var keys = Object.keys(instanceSeenTags);
        for(var i = 0; i < keys.length; i++){
            var attributeKey = keys[i];
            var tagUnion = (0, $abfe7f65d53bab7d$var$_objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
            approvedSeenTags[attributeKey] = tagUnion;
        }
        return approvedTags;
    }, []).reverse();
};
var $abfe7f65d53bab7d$var$getInnermostProperty = function getInnermostProperty(propsList, property) {
    for(var i = propsList.length - 1; i >= 0; i--){
        var props = propsList[i];
        if (props.hasOwnProperty(property)) return props[property];
    }
    return null;
};
var $abfe7f65d53bab7d$var$reducePropsToState = function reducePropsToState(propsList) {
    return {
        baseTag: $abfe7f65d53bab7d$var$getBaseTagFromPropsList([
            $888a808a9f9527b4$export$55a55363959ee034.HREF
        ], propsList),
        bodyAttributes: $abfe7f65d53bab7d$var$getAttributesFromPropsList($888a808a9f9527b4$export$8b4d23abccee6cc2.BODY, propsList),
        defer: $abfe7f65d53bab7d$var$getInnermostProperty(propsList, $888a808a9f9527b4$export$6bb0645fb3f2618c.DEFER),
        encode: $abfe7f65d53bab7d$var$getInnermostProperty(propsList, $888a808a9f9527b4$export$6bb0645fb3f2618c.ENCODE_SPECIAL_CHARACTERS),
        htmlAttributes: $abfe7f65d53bab7d$var$getAttributesFromPropsList($888a808a9f9527b4$export$8b4d23abccee6cc2.HTML, propsList),
        linkTags: $abfe7f65d53bab7d$var$getTagsFromPropsList($888a808a9f9527b4$export$7e674a85a2656dce.LINK, [
            $888a808a9f9527b4$export$55a55363959ee034.REL,
            $888a808a9f9527b4$export$55a55363959ee034.HREF
        ], propsList),
        metaTags: $abfe7f65d53bab7d$var$getTagsFromPropsList($888a808a9f9527b4$export$7e674a85a2656dce.META, [
            $888a808a9f9527b4$export$55a55363959ee034.NAME,
            $888a808a9f9527b4$export$55a55363959ee034.CHARSET,
            $888a808a9f9527b4$export$55a55363959ee034.HTTPEQUIV,
            $888a808a9f9527b4$export$55a55363959ee034.PROPERTY,
            $888a808a9f9527b4$export$55a55363959ee034.ITEM_PROP
        ], propsList),
        noscriptTags: $abfe7f65d53bab7d$var$getTagsFromPropsList($888a808a9f9527b4$export$7e674a85a2656dce.NOSCRIPT, [
            $888a808a9f9527b4$export$55a55363959ee034.INNER_HTML
        ], propsList),
        onChangeClientState: $abfe7f65d53bab7d$var$getOnChangeClientState(propsList),
        scriptTags: $abfe7f65d53bab7d$var$getTagsFromPropsList($888a808a9f9527b4$export$7e674a85a2656dce.SCRIPT, [
            $888a808a9f9527b4$export$55a55363959ee034.SRC,
            $888a808a9f9527b4$export$55a55363959ee034.INNER_HTML
        ], propsList),
        styleTags: $abfe7f65d53bab7d$var$getTagsFromPropsList($888a808a9f9527b4$export$7e674a85a2656dce.STYLE, [
            $888a808a9f9527b4$export$55a55363959ee034.CSS_TEXT
        ], propsList),
        title: $abfe7f65d53bab7d$var$getTitleFromPropsList(propsList),
        titleAttributes: $abfe7f65d53bab7d$var$getAttributesFromPropsList($888a808a9f9527b4$export$8b4d23abccee6cc2.TITLE, propsList)
    };
};
var $abfe7f65d53bab7d$var$rafPolyfill = function() {
    var clock = Date.now();
    return function(callback) {
        var currentTime = Date.now();
        if (currentTime - clock > 16) {
            clock = currentTime;
            callback(currentTime);
        } else setTimeout(function() {
            $abfe7f65d53bab7d$var$rafPolyfill(callback);
        }, 0);
    };
}();
var $abfe7f65d53bab7d$var$cafPolyfill = function cafPolyfill(id) {
    return clearTimeout(id);
};
var $abfe7f65d53bab7d$var$requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || $abfe7f65d53bab7d$var$rafPolyfill : $parcel$global.requestAnimationFrame || $abfe7f65d53bab7d$var$rafPolyfill;
var $abfe7f65d53bab7d$var$cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || $abfe7f65d53bab7d$var$cafPolyfill : $parcel$global.cancelAnimationFrame || $abfe7f65d53bab7d$var$cafPolyfill;
var $abfe7f65d53bab7d$var$warn = function warn(msg) {
    return console && typeof console.warn === "function" && console.warn(msg);
};
var $abfe7f65d53bab7d$var$_helmetCallback = null;
var $abfe7f65d53bab7d$var$handleClientStateChange = function handleClientStateChange(newState) {
    if ($abfe7f65d53bab7d$var$_helmetCallback) $abfe7f65d53bab7d$var$cancelAnimationFrame($abfe7f65d53bab7d$var$_helmetCallback);
    if (newState.defer) $abfe7f65d53bab7d$var$_helmetCallback = $abfe7f65d53bab7d$var$requestAnimationFrame(function() {
        $abfe7f65d53bab7d$var$commitTagChanges(newState, function() {
            $abfe7f65d53bab7d$var$_helmetCallback = null;
        });
    });
    else {
        $abfe7f65d53bab7d$var$commitTagChanges(newState);
        $abfe7f65d53bab7d$var$_helmetCallback = null;
    }
};
var $abfe7f65d53bab7d$var$commitTagChanges = function commitTagChanges(newState, cb) {
    var baseTag = newState.baseTag, bodyAttributes = newState.bodyAttributes, htmlAttributes = newState.htmlAttributes, linkTags = newState.linkTags, metaTags = newState.metaTags, noscriptTags = newState.noscriptTags, onChangeClientState = newState.onChangeClientState, scriptTags = newState.scriptTags, styleTags = newState.styleTags, title = newState.title, titleAttributes = newState.titleAttributes;
    $abfe7f65d53bab7d$var$updateAttributes($888a808a9f9527b4$export$7e674a85a2656dce.BODY, bodyAttributes);
    $abfe7f65d53bab7d$var$updateAttributes($888a808a9f9527b4$export$7e674a85a2656dce.HTML, htmlAttributes);
    $abfe7f65d53bab7d$var$updateTitle(title, titleAttributes);
    var tagUpdates = {
        baseTag: $abfe7f65d53bab7d$var$updateTags($888a808a9f9527b4$export$7e674a85a2656dce.BASE, baseTag),
        linkTags: $abfe7f65d53bab7d$var$updateTags($888a808a9f9527b4$export$7e674a85a2656dce.LINK, linkTags),
        metaTags: $abfe7f65d53bab7d$var$updateTags($888a808a9f9527b4$export$7e674a85a2656dce.META, metaTags),
        noscriptTags: $abfe7f65d53bab7d$var$updateTags($888a808a9f9527b4$export$7e674a85a2656dce.NOSCRIPT, noscriptTags),
        scriptTags: $abfe7f65d53bab7d$var$updateTags($888a808a9f9527b4$export$7e674a85a2656dce.SCRIPT, scriptTags),
        styleTags: $abfe7f65d53bab7d$var$updateTags($888a808a9f9527b4$export$7e674a85a2656dce.STYLE, styleTags)
    };
    var addedTags = {};
    var removedTags = {};
    Object.keys(tagUpdates).forEach(function(tagType) {
        var _tagUpdates$tagType = tagUpdates[tagType], newTags = _tagUpdates$tagType.newTags, oldTags = _tagUpdates$tagType.oldTags;
        if (newTags.length) addedTags[tagType] = newTags;
        if (oldTags.length) removedTags[tagType] = tagUpdates[tagType].oldTags;
    });
    cb && cb();
    onChangeClientState(newState, addedTags, removedTags);
};
var $abfe7f65d53bab7d$var$flattenArray = function flattenArray(possibleArray) {
    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
};
var $abfe7f65d53bab7d$var$updateTitle = function updateTitle(title, attributes) {
    if (typeof title !== "undefined" && document.title !== title) document.title = $abfe7f65d53bab7d$var$flattenArray(title);
    $abfe7f65d53bab7d$var$updateAttributes($888a808a9f9527b4$export$7e674a85a2656dce.TITLE, attributes);
};
var $abfe7f65d53bab7d$var$updateAttributes = function updateAttributes(tagName, attributes) {
    var elementTag = document.getElementsByTagName(tagName)[0];
    if (!elementTag) return;
    var helmetAttributeString = elementTag.getAttribute($888a808a9f9527b4$export$1f547d7d8e831b2b);
    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
    var attributesToRemove = [].concat(helmetAttributes);
    var attributeKeys = Object.keys(attributes);
    for(var i = 0; i < attributeKeys.length; i++){
        var attribute = attributeKeys[i];
        var value = attributes[attribute] || "";
        if (elementTag.getAttribute(attribute) !== value) elementTag.setAttribute(attribute, value);
        if (helmetAttributes.indexOf(attribute) === -1) helmetAttributes.push(attribute);
        var indexToSave = attributesToRemove.indexOf(attribute);
        if (indexToSave !== -1) attributesToRemove.splice(indexToSave, 1);
    }
    for(var _i = attributesToRemove.length - 1; _i >= 0; _i--)elementTag.removeAttribute(attributesToRemove[_i]);
    if (helmetAttributes.length === attributesToRemove.length) elementTag.removeAttribute($888a808a9f9527b4$export$1f547d7d8e831b2b);
    else if (elementTag.getAttribute($888a808a9f9527b4$export$1f547d7d8e831b2b) !== attributeKeys.join(",")) elementTag.setAttribute($888a808a9f9527b4$export$1f547d7d8e831b2b, attributeKeys.join(","));
};
var $abfe7f65d53bab7d$var$updateTags = function updateTags(type, tags) {
    var headElement = document.head || document.querySelector($888a808a9f9527b4$export$7e674a85a2656dce.HEAD);
    var tagNodes = headElement.querySelectorAll(type + "[" + $888a808a9f9527b4$export$1f547d7d8e831b2b + "]");
    var oldTags = Array.prototype.slice.call(tagNodes);
    var newTags = [];
    var indexToDelete = void 0;
    if (tags && tags.length) tags.forEach(function(tag) {
        var newElement = document.createElement(type);
        for(var attribute in tag)if (tag.hasOwnProperty(attribute)) {
            if (attribute === $888a808a9f9527b4$export$55a55363959ee034.INNER_HTML) newElement.innerHTML = tag.innerHTML;
            else if (attribute === $888a808a9f9527b4$export$55a55363959ee034.CSS_TEXT) {
                if (newElement.styleSheet) newElement.styleSheet.cssText = tag.cssText;
                else newElement.appendChild(document.createTextNode(tag.cssText));
            } else {
                var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
                newElement.setAttribute(attribute, value);
            }
        }
        newElement.setAttribute($888a808a9f9527b4$export$1f547d7d8e831b2b, "true");
        // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
        if (oldTags.some(function(existingTag, index) {
            indexToDelete = index;
            return newElement.isEqualNode(existingTag);
        })) oldTags.splice(indexToDelete, 1);
        else newTags.push(newElement);
    });
    oldTags.forEach(function(tag) {
        return tag.parentNode.removeChild(tag);
    });
    newTags.forEach(function(tag) {
        return headElement.appendChild(tag);
    });
    return {
        oldTags: oldTags,
        newTags: newTags
    };
};
var $abfe7f65d53bab7d$var$generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
    return Object.keys(attributes).reduce(function(str, key) {
        var attr = typeof attributes[key] !== "undefined" ? key + '="' + attributes[key] + '"' : "" + key;
        return str ? str + " " + attr : attr;
    }, "");
};
var $abfe7f65d53bab7d$var$generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
    var attributeString = $abfe7f65d53bab7d$var$generateElementAttributesAsString(attributes);
    var flattenedTitle = $abfe7f65d53bab7d$var$flattenArray(title);
    return attributeString ? "<" + type + " " + $888a808a9f9527b4$export$1f547d7d8e831b2b + '="true" ' + attributeString + ">" + $abfe7f65d53bab7d$var$encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + $888a808a9f9527b4$export$1f547d7d8e831b2b + '="true">' + $abfe7f65d53bab7d$var$encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
};
var $abfe7f65d53bab7d$var$generateTagsAsString = function generateTagsAsString(type, tags, encode) {
    return tags.reduce(function(str, tag) {
        var attributeHtml = Object.keys(tag).filter(function(attribute) {
            return !(attribute === $888a808a9f9527b4$export$55a55363959ee034.INNER_HTML || attribute === $888a808a9f9527b4$export$55a55363959ee034.CSS_TEXT);
        }).reduce(function(string, attribute) {
            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + '="' + $abfe7f65d53bab7d$var$encodeSpecialCharacters(tag[attribute], encode) + '"';
            return string ? string + " " + attr : attr;
        }, "");
        var tagContent = tag.innerHTML || tag.cssText || "";
        var isSelfClosing = $888a808a9f9527b4$export$7f7c530a82f07f20.indexOf(type) === -1;
        return str + "<" + type + " " + $888a808a9f9527b4$export$1f547d7d8e831b2b + '="true" ' + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
    }, "");
};
var $abfe7f65d53bab7d$var$convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return Object.keys(attributes).reduce(function(obj, key) {
        obj[$888a808a9f9527b4$export$f5ab464b3d67ea9c[key] || key] = attributes[key];
        return obj;
    }, initProps);
};
var $abfe7f65d53bab7d$var$convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return Object.keys(props).reduce(function(obj, key) {
        obj[$888a808a9f9527b4$export$3fedf55cd3a4e6fa[key] || key] = props[key];
        return obj;
    }, initAttributes);
};
var $abfe7f65d53bab7d$var$generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
    var _initProps;
    // assigning into an array to define toString function on it
    var initProps = (_initProps = {
        key: title
    }, _initProps[$888a808a9f9527b4$export$1f547d7d8e831b2b] = true, _initProps);
    var props = $abfe7f65d53bab7d$var$convertElementAttributestoReactProps(attributes, initProps);
    return [
        $abfe7f65d53bab7d$var$_react2.default.createElement($888a808a9f9527b4$export$7e674a85a2656dce.TITLE, props, title)
    ];
};
var $abfe7f65d53bab7d$var$generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
    return tags.map(function(tag, i) {
        var _mappedTag;
        var mappedTag = (_mappedTag = {
            key: i
        }, _mappedTag[$888a808a9f9527b4$export$1f547d7d8e831b2b] = true, _mappedTag);
        Object.keys(tag).forEach(function(attribute) {
            var mappedAttribute = $888a808a9f9527b4$export$f5ab464b3d67ea9c[attribute] || attribute;
            if (mappedAttribute === $888a808a9f9527b4$export$55a55363959ee034.INNER_HTML || mappedAttribute === $888a808a9f9527b4$export$55a55363959ee034.CSS_TEXT) {
                var content = tag.innerHTML || tag.cssText;
                mappedTag.dangerouslySetInnerHTML = {
                    __html: content
                };
            } else mappedTag[mappedAttribute] = tag[attribute];
        });
        return $abfe7f65d53bab7d$var$_react2.default.createElement(type, mappedTag);
    });
};
var $abfe7f65d53bab7d$var$getMethodsForTag = function getMethodsForTag(type, tags, encode) {
    switch(type){
        case $888a808a9f9527b4$export$7e674a85a2656dce.TITLE:
            return {
                toComponent: function toComponent() {
                    return $abfe7f65d53bab7d$var$generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
                },
                toString: function toString() {
                    return $abfe7f65d53bab7d$var$generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
                }
            };
        case $888a808a9f9527b4$export$8b4d23abccee6cc2.BODY:
        case $888a808a9f9527b4$export$8b4d23abccee6cc2.HTML:
            return {
                toComponent: function toComponent() {
                    return $abfe7f65d53bab7d$var$convertElementAttributestoReactProps(tags);
                },
                toString: function toString() {
                    return $abfe7f65d53bab7d$var$generateElementAttributesAsString(tags);
                }
            };
        default:
            return {
                toComponent: function toComponent() {
                    return $abfe7f65d53bab7d$var$generateTagsAsReactComponent(type, tags);
                },
                toString: function toString() {
                    return $abfe7f65d53bab7d$var$generateTagsAsString(type, tags, encode);
                }
            };
    }
};
var $abfe7f65d53bab7d$var$mapStateOnServer = function mapStateOnServer(_ref) {
    var baseTag = _ref.baseTag, bodyAttributes = _ref.bodyAttributes, encode = _ref.encode, htmlAttributes = _ref.htmlAttributes, linkTags = _ref.linkTags, metaTags = _ref.metaTags, noscriptTags = _ref.noscriptTags, scriptTags = _ref.scriptTags, styleTags = _ref.styleTags, _ref$title = _ref.title, title = _ref$title === undefined ? "" : _ref$title, titleAttributes = _ref.titleAttributes;
    return {
        base: $abfe7f65d53bab7d$var$getMethodsForTag($888a808a9f9527b4$export$7e674a85a2656dce.BASE, baseTag, encode),
        bodyAttributes: $abfe7f65d53bab7d$var$getMethodsForTag($888a808a9f9527b4$export$8b4d23abccee6cc2.BODY, bodyAttributes, encode),
        htmlAttributes: $abfe7f65d53bab7d$var$getMethodsForTag($888a808a9f9527b4$export$8b4d23abccee6cc2.HTML, htmlAttributes, encode),
        link: $abfe7f65d53bab7d$var$getMethodsForTag($888a808a9f9527b4$export$7e674a85a2656dce.LINK, linkTags, encode),
        meta: $abfe7f65d53bab7d$var$getMethodsForTag($888a808a9f9527b4$export$7e674a85a2656dce.META, metaTags, encode),
        noscript: $abfe7f65d53bab7d$var$getMethodsForTag($888a808a9f9527b4$export$7e674a85a2656dce.NOSCRIPT, noscriptTags, encode),
        script: $abfe7f65d53bab7d$var$getMethodsForTag($888a808a9f9527b4$export$7e674a85a2656dce.SCRIPT, scriptTags, encode),
        style: $abfe7f65d53bab7d$var$getMethodsForTag($888a808a9f9527b4$export$7e674a85a2656dce.STYLE, styleTags, encode),
        title: $abfe7f65d53bab7d$var$getMethodsForTag($888a808a9f9527b4$export$7e674a85a2656dce.TITLE, {
            title: title,
            titleAttributes: titleAttributes
        }, encode)
    };
};
$abfe7f65d53bab7d$export$8f437c7c6568a694 = $abfe7f65d53bab7d$var$convertReactPropstoHtmlAttributes;
$abfe7f65d53bab7d$export$8e0854f6f2040fff = $abfe7f65d53bab7d$var$handleClientStateChange;
$abfe7f65d53bab7d$export$971402543ca2bd1d = $abfe7f65d53bab7d$var$mapStateOnServer;
$abfe7f65d53bab7d$export$bfed3b07ff81c934 = $abfe7f65d53bab7d$var$reducePropsToState;
$abfe7f65d53bab7d$export$6cb2c4c0a22909c0 = $abfe7f65d53bab7d$var$requestAnimationFrame;
$abfe7f65d53bab7d$export$c106dd0671a0fc2d = $abfe7f65d53bab7d$var$warn;



function $d5bf021e81f47411$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $d5bf021e81f47411$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
function $d5bf021e81f47411$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $d5bf021e81f47411$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $d5bf021e81f47411$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $d5bf021e81f47411$var$Helmet = function Helmet(Component) {
    var _class, _temp;
    return _temp = _class = function(_React$Component) {
        $d5bf021e81f47411$var$_inherits(HelmetWrapper, _React$Component);
        function HelmetWrapper() {
            $d5bf021e81f47411$var$_classCallCheck(this, HelmetWrapper);
            return $d5bf021e81f47411$var$_possibleConstructorReturn(this, _React$Component.apply(this, arguments));
        }
        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
            return !(0, $d5bf021e81f47411$var$_reactFastCompare2.default)(this.props, nextProps);
        };
        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
            if (!nestedChildren) return null;
            switch(child.type){
                case $888a808a9f9527b4$export$7e674a85a2656dce.SCRIPT:
                case $888a808a9f9527b4$export$7e674a85a2656dce.NOSCRIPT:
                    return {
                        innerHTML: nestedChildren
                    };
                case $888a808a9f9527b4$export$7e674a85a2656dce.STYLE:
                    return {
                        cssText: nestedChildren
                    };
            }
            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
        };
        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
            var _extends2;
            var child = _ref.child, arrayTypeChildren = _ref.arrayTypeChildren, newChildProps = _ref.newChildProps, nestedChildren = _ref.nestedChildren;
            return $d5bf021e81f47411$var$_extends({}, arrayTypeChildren, (_extends2 = {}, _extends2[child.type] = [].concat(arrayTypeChildren[child.type] || [], [
                $d5bf021e81f47411$var$_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))
            ]), _extends2));
        };
        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
            var _extends3, _extends4;
            var child = _ref2.child, newProps = _ref2.newProps, newChildProps = _ref2.newChildProps, nestedChildren = _ref2.nestedChildren;
            switch(child.type){
                case $888a808a9f9527b4$export$7e674a85a2656dce.TITLE:
                    return $d5bf021e81f47411$var$_extends({}, newProps, (_extends3 = {}, _extends3[child.type] = nestedChildren, _extends3.titleAttributes = $d5bf021e81f47411$var$_extends({}, newChildProps), _extends3));
                case $888a808a9f9527b4$export$7e674a85a2656dce.BODY:
                    return $d5bf021e81f47411$var$_extends({}, newProps, {
                        bodyAttributes: $d5bf021e81f47411$var$_extends({}, newChildProps)
                    });
                case $888a808a9f9527b4$export$7e674a85a2656dce.HTML:
                    return $d5bf021e81f47411$var$_extends({}, newProps, {
                        htmlAttributes: $d5bf021e81f47411$var$_extends({}, newChildProps)
                    });
            }
            return $d5bf021e81f47411$var$_extends({}, newProps, (_extends4 = {}, _extends4[child.type] = $d5bf021e81f47411$var$_extends({}, newChildProps), _extends4));
        };
        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
            var newFlattenedProps = $d5bf021e81f47411$var$_extends({}, newProps);
            Object.keys(arrayTypeChildren).forEach(function(arrayChildName) {
                var _extends5;
                newFlattenedProps = $d5bf021e81f47411$var$_extends({}, newFlattenedProps, (_extends5 = {}, _extends5[arrayChildName] = arrayTypeChildren[arrayChildName], _extends5));
            });
            return newFlattenedProps;
        };
        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
            return true;
        };
        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
            var _this2 = this;
            var arrayTypeChildren = {};
            $d5bf021e81f47411$var$_react2.default.Children.forEach(children, function(child) {
                if (!child || !child.props) return;
                var _child$props = child.props, nestedChildren = _child$props.children, childProps = $d5bf021e81f47411$var$_objectWithoutProperties(_child$props, [
                    "children"
                ]);
                var newChildProps = (0, $abfe7f65d53bab7d$export$8f437c7c6568a694)(childProps);
                _this2.warnOnInvalidChildren(child, nestedChildren);
                switch(child.type){
                    case $888a808a9f9527b4$export$7e674a85a2656dce.LINK:
                    case $888a808a9f9527b4$export$7e674a85a2656dce.META:
                    case $888a808a9f9527b4$export$7e674a85a2656dce.NOSCRIPT:
                    case $888a808a9f9527b4$export$7e674a85a2656dce.SCRIPT:
                    case $888a808a9f9527b4$export$7e674a85a2656dce.STYLE:
                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
                            child: child,
                            arrayTypeChildren: arrayTypeChildren,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;
                    default:
                        newProps = _this2.mapObjectTypeChildren({
                            child: child,
                            newProps: newProps,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;
                }
            });
            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
            return newProps;
        };
        HelmetWrapper.prototype.render = function render() {
            var _props = this.props, children = _props.children, props = $d5bf021e81f47411$var$_objectWithoutProperties(_props, [
                "children"
            ]);
            var newProps = $d5bf021e81f47411$var$_extends({}, props);
            if (children) newProps = this.mapChildrenToProps(children, newProps);
            return $d5bf021e81f47411$var$_react2.default.createElement(Component, newProps);
        };
        $d5bf021e81f47411$var$_createClass(HelmetWrapper, null, [
            {
                key: "canUseDOM",
                // Component.peek comes from react-side-effect:
                // For testing, you may use a static peek() method available on the returned component.
                // It lets you get the current state without resetting the mounted instance stack.
                // Don’t use it for anything other than testing.
                /**
             * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
             * @param {Object} bodyAttributes: {"className": "root"}
             * @param {String} defaultTitle: "Default Title"
             * @param {Boolean} defer: true
             * @param {Boolean} encodeSpecialCharacters: true
             * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
             * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
             * @param {Array} meta: [{"name": "description", "content": "Test description"}]
             * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
             * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
             * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
             * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
             * @param {String} title: "Title"
             * @param {Object} titleAttributes: {"itemprop": "name"}
             * @param {String} titleTemplate: "MySite.com - %s"
             */ set: function set(canUseDOM) {
                    Component.canUseDOM = canUseDOM;
                }
            }
        ]);
        return HelmetWrapper;
    }($d5bf021e81f47411$var$_react2.default.Component), _class.propTypes = {
        base: $d5bf021e81f47411$var$_propTypes2.default.object,
        bodyAttributes: $d5bf021e81f47411$var$_propTypes2.default.object,
        children: $d5bf021e81f47411$var$_propTypes2.default.oneOfType([
            $d5bf021e81f47411$var$_propTypes2.default.arrayOf($d5bf021e81f47411$var$_propTypes2.default.node),
            $d5bf021e81f47411$var$_propTypes2.default.node
        ]),
        defaultTitle: $d5bf021e81f47411$var$_propTypes2.default.string,
        defer: $d5bf021e81f47411$var$_propTypes2.default.bool,
        encodeSpecialCharacters: $d5bf021e81f47411$var$_propTypes2.default.bool,
        htmlAttributes: $d5bf021e81f47411$var$_propTypes2.default.object,
        link: $d5bf021e81f47411$var$_propTypes2.default.arrayOf($d5bf021e81f47411$var$_propTypes2.default.object),
        meta: $d5bf021e81f47411$var$_propTypes2.default.arrayOf($d5bf021e81f47411$var$_propTypes2.default.object),
        noscript: $d5bf021e81f47411$var$_propTypes2.default.arrayOf($d5bf021e81f47411$var$_propTypes2.default.object),
        onChangeClientState: $d5bf021e81f47411$var$_propTypes2.default.func,
        script: $d5bf021e81f47411$var$_propTypes2.default.arrayOf($d5bf021e81f47411$var$_propTypes2.default.object),
        style: $d5bf021e81f47411$var$_propTypes2.default.arrayOf($d5bf021e81f47411$var$_propTypes2.default.object),
        title: $d5bf021e81f47411$var$_propTypes2.default.string,
        titleAttributes: $d5bf021e81f47411$var$_propTypes2.default.object,
        titleTemplate: $d5bf021e81f47411$var$_propTypes2.default.string
    }, _class.defaultProps = {
        defer: true,
        encodeSpecialCharacters: true
    }, _class.peek = Component.peek, _class.rewind = function() {
        var mappedState = Component.rewind();
        if (!mappedState) // provide fallback if mappedState is undefined
        mappedState = (0, $abfe7f65d53bab7d$export$971402543ca2bd1d)({
            baseTag: [],
            bodyAttributes: {},
            encodeSpecialCharacters: true,
            htmlAttributes: {},
            linkTags: [],
            metaTags: [],
            noscriptTags: [],
            scriptTags: [],
            styleTags: [],
            title: "",
            titleAttributes: {}
        });
        return mappedState;
    }, _temp;
};
var $d5bf021e81f47411$var$NullComponent = function NullComponent() {
    return null;
};
var $d5bf021e81f47411$var$HelmetSideEffects = (0, $d5bf021e81f47411$var$_reactSideEffect2.default)($abfe7f65d53bab7d$export$bfed3b07ff81c934, $abfe7f65d53bab7d$export$8e0854f6f2040fff, $abfe7f65d53bab7d$export$971402543ca2bd1d)($d5bf021e81f47411$var$NullComponent);
var $d5bf021e81f47411$var$HelmetExport = $d5bf021e81f47411$var$Helmet($d5bf021e81f47411$var$HelmetSideEffects);
$d5bf021e81f47411$var$HelmetExport.renderStatic = $d5bf021e81f47411$var$HelmetExport.rewind;
$d5bf021e81f47411$export$dcef8f9bb9a41431 = $d5bf021e81f47411$var$HelmetExport;
$d5bf021e81f47411$export$2e2bcd8739ae039 = $d5bf021e81f47411$var$HelmetExport;


var $050c5bb5f8d0e70e$exports = {};



$050c5bb5f8d0e70e$exports = /******/ function(modules) {
    /******/ // The module cache
    /******/ var installedModules = {};
    /******/ /******/ // The require function
    /******/ function __webpack_require__(moduleId) {
        /******/ /******/ // Check if module is in cache
        /******/ if (installedModules[moduleId]) /******/ return installedModules[moduleId].exports;
        /******/ /******/ // Create a new module (and put it into the cache)
        /******/ var module1 = installedModules[moduleId] = {
            /******/ exports: {},
            /******/ id: moduleId,
            /******/ loaded: false
        };
        /******/ /******/ // Execute the module function
        /******/ modules[moduleId].call(module1.exports, module1, module1.exports, __webpack_require__);
        /******/ /******/ // Flag the module as loaded
        /******/ module1.loaded = true;
        /******/ /******/ // Return the exports of the module
        /******/ return module1.exports;
    /******/ }
    /******/ /******/ /******/ // expose the modules object (__webpack_modules__)
    /******/ __webpack_require__.m = modules;
    /******/ /******/ // expose the module cache
    /******/ __webpack_require__.c = installedModules;
    /******/ /******/ // __webpack_public_path__
    /******/ __webpack_require__.p = "";
    /******/ /******/ // Load entry module and return exports
    /******/ return __webpack_require__(0);
/******/ }([
    /* 0 */ /***/ function(module1, exports, __webpack_require__) {
        module1.exports = __webpack_require__(1);
    /***/ },
    /* 1 */ /***/ function(module1, exports, __webpack_require__) {
        "use strict";
        Object.defineProperty(exports, "__esModule", {
            value: true
        });
        exports.default = undefined;
        var _Highlight = __webpack_require__(2);
        var _Highlight2 = _interopRequireDefault(_Highlight);
        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                default: obj
            };
        }
        exports.default = _Highlight2.default;
    /***/ },
    /* 2 */ /***/ function(module1, exports, __webpack_require__) {
        "use strict";
        Object.defineProperty(exports, "__esModule", {
            value: true
        });
        var _createClass = function() {
            function defineProperties(target, props) {
                for(var i = 0; i < props.length; i++){
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, descriptor.key, descriptor);
                }
            }
            return function(Constructor, protoProps, staticProps) {
                if (protoProps) defineProperties(Constructor.prototype, protoProps);
                if (staticProps) defineProperties(Constructor, staticProps);
                return Constructor;
            };
        }();
        var _react = __webpack_require__(3);
        var _react2 = _interopRequireDefault(_react);
        var _propTypes = __webpack_require__(4);
        var _propTypes2 = _interopRequireDefault(_propTypes);
        var _reactDom = __webpack_require__(14);
        var _highlight = __webpack_require__(15);
        var _highlight2 = _interopRequireDefault(_highlight);
        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                default: obj
            };
        }
        function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
        }
        function _possibleConstructorReturn(self, call) {
            if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return call && (typeof call === "object" || typeof call === "function") ? call : self;
        }
        function _inherits(subClass, superClass) {
            if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
            subClass.prototype = Object.create(superClass && superClass.prototype, {
                constructor: {
                    value: subClass,
                    enumerable: false,
                    writable: true,
                    configurable: true
                }
            });
            if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
        }
        var Highlight = function(_Component) {
            _inherits(Highlight, _Component);
            function Highlight() {
                _classCallCheck(this, Highlight);
                return _possibleConstructorReturn(this, (Highlight.__proto__ || Object.getPrototypeOf(Highlight)).apply(this, arguments));
            }
            _createClass(Highlight, [
                {
                    key: "componentDidMount",
                    value: function componentDidMount() {
                        _highlight2.default.highlightBlock((0, _reactDom.findDOMNode)(this.refs.code));
                    }
                },
                {
                    key: "componentDidUpdate",
                    value: function componentDidUpdate() {
                        _highlight2.default.initHighlighting.called = false;
                        _highlight2.default.highlightBlock((0, _reactDom.findDOMNode)(this.refs.code));
                    }
                },
                {
                    key: "render",
                    value: function render() {
                        var _props = this.props, children = _props.children, className = _props.className, language = _props.language, style = _props.style;
                        return _react2.default.createElement("pre", {
                            className: className,
                            style: style
                        }, _react2.default.createElement("code", {
                            className: language,
                            ref: "code"
                        }, children));
                    }
                }
            ]);
            return Highlight;
        }(_react.Component);
        Highlight.propTypes = {
            children: _propTypes2.default.node.isRequired,
            className: _propTypes2.default.string,
            language: _propTypes2.default.string,
            style: _propTypes2.default.object
        };
        exports.default = Highlight;
    /***/ },
    /* 3 */ /***/ function(module1, exports) {
        module1.exports = (parcelRequire("acw62"));
    /***/ },
    /* 4 */ /***/ function(module1, exports, __webpack_require__) {
        /* WEBPACK VAR INJECTION */ (function(process) {
            if (process.env.NODE_ENV !== "production") {
                var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7;
                var isValidElement = function(object) {
                    return typeof object === "object" && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
                };
                // By explicitly using `prop-types` you are opting into new development behavior.
                // http://fb.me/prop-types-in-prod
                var throwOnDirectAccess = true;
                module1.exports = __webpack_require__(6)(isValidElement, throwOnDirectAccess);
            } else // By explicitly using `prop-types` you are opting into new production behavior.
            // http://fb.me/prop-types-in-prod
            module1.exports = __webpack_require__(13)();
        /* WEBPACK VAR INJECTION */ }).call(exports, __webpack_require__(5));
    /***/ },
    /* 5 */ /***/ function(module1, exports) {
        // shim for using process in browser
        var process = module1.exports = {};
        // cached from whatever global is present so that test runners that stub it
        // don't break things.  But we need to wrap it in a try catch in case it is
        // wrapped in strict mode code which doesn't define any globals.  It's inside a
        // function because try/catches deoptimize in certain engines.
        var cachedSetTimeout;
        var cachedClearTimeout;
        function defaultSetTimout() {
            throw new Error("setTimeout has not been defined");
        }
        function defaultClearTimeout() {
            throw new Error("clearTimeout has not been defined");
        }
        (function() {
            try {
                if (typeof setTimeout === "function") cachedSetTimeout = setTimeout;
                else cachedSetTimeout = defaultSetTimout;
            } catch (e) {
                cachedSetTimeout = defaultSetTimout;
            }
            try {
                if (typeof clearTimeout === "function") cachedClearTimeout = clearTimeout;
                else cachedClearTimeout = defaultClearTimeout;
            } catch (e) {
                cachedClearTimeout = defaultClearTimeout;
            }
        })();
        function runTimeout(fun) {
            if (cachedSetTimeout === setTimeout) //normal enviroments in sane situations
            return setTimeout(fun, 0);
            // if setTimeout wasn't available but was latter defined
            if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
                cachedSetTimeout = setTimeout;
                return setTimeout(fun, 0);
            }
            try {
                // when when somebody has screwed with setTimeout but no I.E. maddness
                return cachedSetTimeout(fun, 0);
            } catch (e) {
                try {
                    // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
                    return cachedSetTimeout.call(null, fun, 0);
                } catch (e) {
                    // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
                    return cachedSetTimeout.call(this, fun, 0);
                }
            }
        }
        function runClearTimeout(marker) {
            if (cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
            return clearTimeout(marker);
            // if clearTimeout wasn't available but was latter defined
            if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
                cachedClearTimeout = clearTimeout;
                return clearTimeout(marker);
            }
            try {
                // when when somebody has screwed with setTimeout but no I.E. maddness
                return cachedClearTimeout(marker);
            } catch (e) {
                try {
                    // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
                    return cachedClearTimeout.call(null, marker);
                } catch (e) {
                    // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
                    // Some versions of I.E. have different rules for clearTimeout vs setTimeout
                    return cachedClearTimeout.call(this, marker);
                }
            }
        }
        var queue = [];
        var draining = false;
        var currentQueue;
        var queueIndex = -1;
        function cleanUpNextTick() {
            if (!draining || !currentQueue) return;
            draining = false;
            if (currentQueue.length) queue = currentQueue.concat(queue);
            else queueIndex = -1;
            if (queue.length) drainQueue();
        }
        function drainQueue() {
            if (draining) return;
            var timeout = runTimeout(cleanUpNextTick);
            draining = true;
            var len = queue.length;
            while(len){
                currentQueue = queue;
                queue = [];
                while(++queueIndex < len)if (currentQueue) currentQueue[queueIndex].run();
                queueIndex = -1;
                len = queue.length;
            }
            currentQueue = null;
            draining = false;
            runClearTimeout(timeout);
        }
        process.nextTick = function(fun) {
            var args = new Array(arguments.length - 1);
            if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
            queue.push(new Item(fun, args));
            if (queue.length === 1 && !draining) runTimeout(drainQueue);
        };
        // v8 likes predictible objects
        function Item(fun, array) {
            this.fun = fun;
            this.array = array;
        }
        Item.prototype.run = function() {
            this.fun.apply(null, this.array);
        };
        process.title = "browser";
        process.browser = true;
        process.env = {};
        process.argv = [];
        process.version = ""; // empty string to avoid regexp issues
        process.versions = {};
        function noop() {}
        process.on = noop;
        process.addListener = noop;
        process.once = noop;
        process.off = noop;
        process.removeListener = noop;
        process.removeAllListeners = noop;
        process.emit = noop;
        process.prependListener = noop;
        process.prependOnceListener = noop;
        process.listeners = function(name) {
            return [];
        };
        process.binding = function(name) {
            throw new Error("process.binding is not supported");
        };
        process.cwd = function() {
            return "/";
        };
        process.chdir = function(dir) {
            throw new Error("process.chdir is not supported");
        };
        process.umask = function() {
            return 0;
        };
    /***/ },
    /* 6 */ /***/ function(module1, exports, __webpack_require__) {
        /* WEBPACK VAR INJECTION */ (function(process) {
            "use strict";
            var emptyFunction = __webpack_require__(7);
            var invariant = __webpack_require__(8);
            var warning = __webpack_require__(9);
            var assign = __webpack_require__(10);
            var ReactPropTypesSecret = __webpack_require__(11);
            var checkPropTypes = __webpack_require__(12);
            module1.exports = function(isValidElement, throwOnDirectAccess) {
                /* global Symbol */ var ITERATOR_SYMBOL = typeof Symbol === "function" && Symbol.iterator;
                var FAUX_ITERATOR_SYMBOL = "@@iterator"; // Before Symbol spec.
                /**
	   * Returns the iterator method function contained on the iterable object.
	   *
	   * Be sure to invoke the function with the iterable as context:
	   *
	   *     var iteratorFn = getIteratorFn(myIterable);
	   *     if (iteratorFn) {
	   *       var iterator = iteratorFn.call(myIterable);
	   *       ...
	   *     }
	   *
	   * @param {?object} maybeIterable
	   * @return {?function}
	   */ function getIteratorFn(maybeIterable) {
                    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
                    if (typeof iteratorFn === "function") return iteratorFn;
                }
                /**
	   * Collection of methods that allow declaration and validation of props that are
	   * supplied to React components. Example usage:
	   *
	   *   var Props = require('ReactPropTypes');
	   *   var MyArticle = React.createClass({
	   *     propTypes: {
	   *       // An optional string prop named "description".
	   *       description: Props.string,
	   *
	   *       // A required enum prop named "category".
	   *       category: Props.oneOf(['News','Photos']).isRequired,
	   *
	   *       // A prop named "dialog" that requires an instance of Dialog.
	   *       dialog: Props.instanceOf(Dialog).isRequired
	   *     },
	   *     render: function() { ... }
	   *   });
	   *
	   * A more formal specification of how these methods are used:
	   *
	   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	   *   decl := ReactPropTypes.{type}(.isRequired)?
	   *
	   * Each and every declaration produces a function with the same signature. This
	   * allows the creation of custom validation functions. For example:
	   *
	   *  var MyLink = React.createClass({
	   *    propTypes: {
	   *      // An optional string or URI prop named "href".
	   *      href: function(props, propName, componentName) {
	   *        var propValue = props[propName];
	   *        if (propValue != null && typeof propValue !== 'string' &&
	   *            !(propValue instanceof URI)) {
	   *          return new Error(
	   *            'Expected a string or an URI for ' + propName + ' in ' +
	   *            componentName
	   *          );
	   *        }
	   *      }
	   *    },
	   *    render: function() {...}
	   *  });
	   *
	   * @internal
	   */ var ANONYMOUS = "<<anonymous>>";
                // Important!
                // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
                var ReactPropTypes = {
                    array: createPrimitiveTypeChecker("array"),
                    bool: createPrimitiveTypeChecker("boolean"),
                    func: createPrimitiveTypeChecker("function"),
                    number: createPrimitiveTypeChecker("number"),
                    object: createPrimitiveTypeChecker("object"),
                    string: createPrimitiveTypeChecker("string"),
                    symbol: createPrimitiveTypeChecker("symbol"),
                    any: createAnyTypeChecker(),
                    arrayOf: createArrayOfTypeChecker,
                    element: createElementTypeChecker(),
                    instanceOf: createInstanceTypeChecker,
                    node: createNodeChecker(),
                    objectOf: createObjectOfTypeChecker,
                    oneOf: createEnumTypeChecker,
                    oneOfType: createUnionTypeChecker,
                    shape: createShapeTypeChecker,
                    exact: createStrictShapeTypeChecker
                };
                /**
	   * inlined Object.is polyfill to avoid requiring consumers ship their own
	   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	   */ /*eslint-disable no-self-compare*/ function is(x, y) {
                    // SameValue algorithm
                    if (x === y) // Steps 1-5, 7-10
                    // Steps 6.b-6.e: +0 != -0
                    return x !== 0 || 1 / x === 1 / y;
                    else // Step 6.a: NaN == NaN
                    return x !== x && y !== y;
                }
                /*eslint-enable no-self-compare*/ /**
	   * We use an Error-like object for backward compatibility as people may call
	   * PropTypes directly and inspect their output. However, we don't use real
	   * Errors anymore. We don't inspect their stack anyway, and creating them
	   * is prohibitively expensive if they are created too often, such as what
	   * happens in oneOfType() for any type before the one that matched.
	   */ function PropTypeError(message) {
                    this.message = message;
                    this.stack = "";
                }
                // Make `instanceof Error` still work for returned errors.
                PropTypeError.prototype = Error.prototype;
                function createChainableTypeChecker(validate) {
                    if (process.env.NODE_ENV !== "production") {
                        var manualPropTypeCallCache = {};
                        var manualPropTypeWarningCount = 0;
                    }
                    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
                        componentName = componentName || ANONYMOUS;
                        propFullName = propFullName || propName;
                        if (secret !== ReactPropTypesSecret) {
                            if (throwOnDirectAccess) // New behavior only for users of `prop-types` package
                            invariant(false, "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");
                            else if (process.env.NODE_ENV !== "production" && typeof console !== "undefined") {
                                // Old behavior for people using React.PropTypes
                                var cacheKey = componentName + ":" + propName;
                                if (!manualPropTypeCallCache[cacheKey] && // Avoid spamming the console because they are often not actionable except for lib authors
                                manualPropTypeWarningCount < 3) {
                                    warning(false, "You are manually calling a React.PropTypes validation function for the `%s` prop on `%s`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details.", propFullName, componentName);
                                    manualPropTypeCallCache[cacheKey] = true;
                                    manualPropTypeWarningCount++;
                                }
                            }
                        }
                        if (props[propName] == null) {
                            if (isRequired) {
                                if (props[propName] === null) return new PropTypeError("The " + location + " `" + propFullName + "` is marked as required " + ("in `" + componentName + "`, but its value is `null`."));
                                return new PropTypeError("The " + location + " `" + propFullName + "` is marked as required in " + ("`" + componentName + "`, but its value is `undefined`."));
                            }
                            return null;
                        } else return validate(props, propName, componentName, location, propFullName);
                    }
                    var chainedCheckType = checkType.bind(null, false);
                    chainedCheckType.isRequired = checkType.bind(null, true);
                    return chainedCheckType;
                }
                function createPrimitiveTypeChecker(expectedType) {
                    function validate(props, propName, componentName, location, propFullName, secret) {
                        var propValue = props[propName];
                        var propType = getPropType(propValue);
                        if (propType !== expectedType) {
                            // `propValue` being instance of, say, date/regexp, pass the 'object'
                            // check, but we can offer a more precise error message here rather than
                            // 'of type `object`'.
                            var preciseType = getPreciseType(propValue);
                            return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + preciseType + "` supplied to `" + componentName + "`, expected ") + ("`" + expectedType + "`."));
                        }
                        return null;
                    }
                    return createChainableTypeChecker(validate);
                }
                function createAnyTypeChecker() {
                    return createChainableTypeChecker(emptyFunction.thatReturnsNull);
                }
                function createArrayOfTypeChecker(typeChecker) {
                    function validate(props, propName, componentName, location, propFullName) {
                        if (typeof typeChecker !== "function") return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside arrayOf.");
                        var propValue = props[propName];
                        if (!Array.isArray(propValue)) {
                            var propType = getPropType(propValue);
                            return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an array."));
                        }
                        for(var i = 0; i < propValue.length; i++){
                            var error = typeChecker(propValue, i, componentName, location, propFullName + "[" + i + "]", ReactPropTypesSecret);
                            if (error instanceof Error) return error;
                        }
                        return null;
                    }
                    return createChainableTypeChecker(validate);
                }
                function createElementTypeChecker() {
                    function validate(props, propName, componentName, location, propFullName) {
                        var propValue = props[propName];
                        if (!isValidElement(propValue)) {
                            var propType = getPropType(propValue);
                            return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected a single ReactElement."));
                        }
                        return null;
                    }
                    return createChainableTypeChecker(validate);
                }
                function createInstanceTypeChecker(expectedClass) {
                    function validate(props, propName, componentName, location, propFullName) {
                        if (!(props[propName] instanceof expectedClass)) {
                            var expectedClassName = expectedClass.name || ANONYMOUS;
                            var actualClassName = getClassName(props[propName]);
                            return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + actualClassName + "` supplied to `" + componentName + "`, expected ") + ("instance of `" + expectedClassName + "`."));
                        }
                        return null;
                    }
                    return createChainableTypeChecker(validate);
                }
                function createEnumTypeChecker(expectedValues) {
                    if (!Array.isArray(expectedValues)) {
                        process.env.NODE_ENV !== "production" && warning(false, "Invalid argument supplied to oneOf, expected an instance of array.");
                        return emptyFunction.thatReturnsNull;
                    }
                    function validate(props, propName, componentName, location, propFullName) {
                        var propValue = props[propName];
                        for(var i = 0; i < expectedValues.length; i++){
                            if (is(propValue, expectedValues[i])) return null;
                        }
                        var valuesString = JSON.stringify(expectedValues);
                        return new PropTypeError("Invalid " + location + " `" + propFullName + "` of value `" + propValue + "` " + ("supplied to `" + componentName + "`, expected one of " + valuesString + "."));
                    }
                    return createChainableTypeChecker(validate);
                }
                function createObjectOfTypeChecker(typeChecker) {
                    function validate(props, propName, componentName, location, propFullName) {
                        if (typeof typeChecker !== "function") return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside objectOf.");
                        var propValue = props[propName];
                        var propType = getPropType(propValue);
                        if (propType !== "object") return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an object."));
                        for(var key in propValue)if (propValue.hasOwnProperty(key)) {
                            var error = typeChecker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
                            if (error instanceof Error) return error;
                        }
                        return null;
                    }
                    return createChainableTypeChecker(validate);
                }
                function createUnionTypeChecker(arrayOfTypeCheckers) {
                    if (!Array.isArray(arrayOfTypeCheckers)) {
                        process.env.NODE_ENV !== "production" && warning(false, "Invalid argument supplied to oneOfType, expected an instance of array.");
                        return emptyFunction.thatReturnsNull;
                    }
                    for(var i = 0; i < arrayOfTypeCheckers.length; i++){
                        var checker = arrayOfTypeCheckers[i];
                        if (typeof checker !== "function") {
                            warning(false, "Invalid argument supplied to oneOfType. Expected an array of check functions, but received %s at index %s.", getPostfixForTypeWarning(checker), i);
                            return emptyFunction.thatReturnsNull;
                        }
                    }
                    function validate(props, propName, componentName, location, propFullName) {
                        for(var i = 0; i < arrayOfTypeCheckers.length; i++){
                            var checker = arrayOfTypeCheckers[i];
                            if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) return null;
                        }
                        return new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to " + ("`" + componentName + "`."));
                    }
                    return createChainableTypeChecker(validate);
                }
                function createNodeChecker() {
                    function validate(props, propName, componentName, location, propFullName) {
                        if (!isNode(props[propName])) return new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to " + ("`" + componentName + "`, expected a ReactNode."));
                        return null;
                    }
                    return createChainableTypeChecker(validate);
                }
                function createShapeTypeChecker(shapeTypes) {
                    function validate(props, propName, componentName, location, propFullName) {
                        var propValue = props[propName];
                        var propType = getPropType(propValue);
                        if (propType !== "object") return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
                        for(var key in shapeTypes){
                            var checker = shapeTypes[key];
                            if (!checker) continue;
                            var error = checker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
                            if (error) return error;
                        }
                        return null;
                    }
                    return createChainableTypeChecker(validate);
                }
                function createStrictShapeTypeChecker(shapeTypes) {
                    function validate(props, propName, componentName, location, propFullName) {
                        var propValue = props[propName];
                        var propType = getPropType(propValue);
                        if (propType !== "object") return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
                        // We need to check all keys in case some are required but missing from
                        // props.
                        var allKeys = assign({}, props[propName], shapeTypes);
                        for(var key in allKeys){
                            var checker = shapeTypes[key];
                            if (!checker) return new PropTypeError("Invalid " + location + " `" + propFullName + "` key `" + key + "` supplied to `" + componentName + "`." + "\nBad object: " + JSON.stringify(props[propName], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(shapeTypes), null, "  "));
                            var error = checker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
                            if (error) return error;
                        }
                        return null;
                    }
                    return createChainableTypeChecker(validate);
                }
                function isNode(propValue) {
                    switch(typeof propValue){
                        case "number":
                        case "string":
                        case "undefined":
                            return true;
                        case "boolean":
                            return !propValue;
                        case "object":
                            if (Array.isArray(propValue)) return propValue.every(isNode);
                            if (propValue === null || isValidElement(propValue)) return true;
                            var iteratorFn = getIteratorFn(propValue);
                            if (iteratorFn) {
                                var iterator = iteratorFn.call(propValue);
                                var step;
                                if (iteratorFn !== propValue.entries) while(!(step = iterator.next()).done){
                                    if (!isNode(step.value)) return false;
                                }
                                else // Iterator will provide entry [k,v] tuples rather than values.
                                while(!(step = iterator.next()).done){
                                    var entry = step.value;
                                    if (entry) {
                                        if (!isNode(entry[1])) return false;
                                    }
                                }
                            } else return false;
                            return true;
                        default:
                            return false;
                    }
                }
                function isSymbol(propType, propValue) {
                    // Native Symbol.
                    if (propType === "symbol") return true;
                    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
                    if (propValue["@@toStringTag"] === "Symbol") return true;
                    // Fallback for non-spec compliant Symbols which are polyfilled.
                    if (typeof Symbol === "function" && propValue instanceof Symbol) return true;
                    return false;
                }
                // Equivalent of `typeof` but with special handling for array and regexp.
                function getPropType(propValue) {
                    var propType = typeof propValue;
                    if (Array.isArray(propValue)) return "array";
                    if (propValue instanceof RegExp) // Old webkits (at least until Android 4.0) return 'function' rather than
                    // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
                    // passes PropTypes.object.
                    return "object";
                    if (isSymbol(propType, propValue)) return "symbol";
                    return propType;
                }
                // This handles more types than `getPropType`. Only used for error messages.
                // See `createPrimitiveTypeChecker`.
                function getPreciseType(propValue) {
                    if (typeof propValue === "undefined" || propValue === null) return "" + propValue;
                    var propType = getPropType(propValue);
                    if (propType === "object") {
                        if (propValue instanceof Date) return "date";
                        else if (propValue instanceof RegExp) return "regexp";
                    }
                    return propType;
                }
                // Returns a string that is postfixed to a warning about an invalid type.
                // For example, "undefined" or "of type array"
                function getPostfixForTypeWarning(value) {
                    var type = getPreciseType(value);
                    switch(type){
                        case "array":
                        case "object":
                            return "an " + type;
                        case "boolean":
                        case "date":
                        case "regexp":
                            return "a " + type;
                        default:
                            return type;
                    }
                }
                // Returns class name of the object, if any.
                function getClassName(propValue) {
                    if (!propValue.constructor || !propValue.constructor.name) return ANONYMOUS;
                    return propValue.constructor.name;
                }
                ReactPropTypes.checkPropTypes = checkPropTypes;
                ReactPropTypes.PropTypes = ReactPropTypes;
                return ReactPropTypes;
            };
        /* WEBPACK VAR INJECTION */ }).call(exports, __webpack_require__(5));
    /***/ },
    /* 7 */ /***/ function(module1, exports) {
        "use strict";
        /**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */ function makeEmptyFunction(arg) {
            return function() {
                return arg;
            };
        }
        /**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */ var emptyFunction = function emptyFunction() {};
        emptyFunction.thatReturns = makeEmptyFunction;
        emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
        emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
        emptyFunction.thatReturnsNull = makeEmptyFunction(null);
        emptyFunction.thatReturnsThis = function() {
            return this;
        };
        emptyFunction.thatReturnsArgument = function(arg) {
            return arg;
        };
        module1.exports = emptyFunction;
    /***/ },
    /* 8 */ /***/ function(module1, exports, __webpack_require__) {
        /* WEBPACK VAR INJECTION */ (function(process) {
            "use strict";
            /**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */ var validateFormat = function validateFormat(format) {};
            if (process.env.NODE_ENV !== "production") validateFormat = function validateFormat(format) {
                if (format === undefined) throw new Error("invariant requires an error message argument");
            };
            function invariant(condition, format, a, b, c, d, e, f) {
                validateFormat(format);
                if (!condition) {
                    var error;
                    if (format === undefined) error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
                    else {
                        var args = [
                            a,
                            b,
                            c,
                            d,
                            e,
                            f
                        ];
                        var argIndex = 0;
                        error = new Error(format.replace(/%s/g, function() {
                            return args[argIndex++];
                        }));
                        error.name = "Invariant Violation";
                    }
                    error.framesToPop = 1; // we don't care about invariant's own frame
                    throw error;
                }
            }
            module1.exports = invariant;
        /* WEBPACK VAR INJECTION */ }).call(exports, __webpack_require__(5));
    /***/ },
    /* 9 */ /***/ function(module1, exports, __webpack_require__) {
        /* WEBPACK VAR INJECTION */ (function(process) {
            "use strict";
            var emptyFunction = __webpack_require__(7);
            /**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */ var warning = emptyFunction;
            if (process.env.NODE_ENV !== "production") {
                var printWarning = function printWarning(format) {
                    for(var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
                    var argIndex = 0;
                    var message = "Warning: " + format.replace(/%s/g, function() {
                        return args[argIndex++];
                    });
                    if (typeof console !== "undefined") console.error(message);
                    try {
                        // --- Welcome to debugging React ---
                        // This error was thrown as a convenience so that you can use this stack
                        // to find the callsite that caused this warning to fire.
                        throw new Error(message);
                    } catch (x) {}
                };
                warning = function warning(condition, format) {
                    if (format === undefined) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
                    if (format.indexOf("Failed Composite propType: ") === 0) return; // Ignore CompositeComponent proptype check.
                    if (!condition) {
                        for(var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++)args[_key2 - 2] = arguments[_key2];
                        printWarning.apply(undefined, [
                            format
                        ].concat(args));
                    }
                };
            }
            module1.exports = warning;
        /* WEBPACK VAR INJECTION */ }).call(exports, __webpack_require__(5));
    /***/ },
    /* 10 */ /***/ function(module1, exports) {
        /*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/ "use strict";
        /* eslint-disable no-unused-vars */ var getOwnPropertySymbols = Object.getOwnPropertySymbols;
        var hasOwnProperty = Object.prototype.hasOwnProperty;
        var propIsEnumerable = Object.prototype.propertyIsEnumerable;
        function toObject(val) {
            if (val === null || val === undefined) throw new TypeError("Object.assign cannot be called with null or undefined");
            return Object(val);
        }
        function shouldUseNative() {
            try {
                if (!Object.assign) return false;
                // Detect buggy property enumeration order in older V8 versions.
                // https://bugs.chromium.org/p/v8/issues/detail?id=4118
                var test1 = new String("abc"); // eslint-disable-line no-new-wrappers
                test1[5] = "de";
                if (Object.getOwnPropertyNames(test1)[0] === "5") return false;
                // https://bugs.chromium.org/p/v8/issues/detail?id=3056
                var test2 = {};
                for(var i = 0; i < 10; i++)test2["_" + String.fromCharCode(i)] = i;
                var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
                    return test2[n];
                });
                if (order2.join("") !== "0123456789") return false;
                // https://bugs.chromium.org/p/v8/issues/detail?id=3056
                var test3 = {};
                "abcdefghijklmnopqrst".split("").forEach(function(letter) {
                    test3[letter] = letter;
                });
                if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") return false;
                return true;
            } catch (err) {
                // We don't expect any of the above to throw, but better to be safe.
                return false;
            }
        }
        module1.exports = shouldUseNative() ? Object.assign : function(target, source) {
            var from;
            var to = toObject(target);
            var symbols;
            for(var s = 1; s < arguments.length; s++){
                from = Object(arguments[s]);
                for(var key in from)if (hasOwnProperty.call(from, key)) to[key] = from[key];
                if (getOwnPropertySymbols) {
                    symbols = getOwnPropertySymbols(from);
                    for(var i = 0; i < symbols.length; i++)if (propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
                }
            }
            return to;
        };
    /***/ },
    /* 11 */ /***/ function(module1, exports) {
        /**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */ "use strict";
        var ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
        module1.exports = ReactPropTypesSecret;
    /***/ },
    /* 12 */ /***/ function(module1, exports, __webpack_require__) {
        /* WEBPACK VAR INJECTION */ (function(process) {
            "use strict";
            if (process.env.NODE_ENV !== "production") {
                var invariant = __webpack_require__(8);
                var warning = __webpack_require__(9);
                var ReactPropTypesSecret = __webpack_require__(11);
                var loggedTypeFailures = {};
            }
            /**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?Function} getStack Returns the component stack.
	 * @private
	 */ function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
                if (process.env.NODE_ENV !== "production") {
                    for(var typeSpecName in typeSpecs)if (typeSpecs.hasOwnProperty(typeSpecName)) {
                        var error;
                        // Prop type validation may throw. In case they do, we don't want to
                        // fail the render phase where it didn't fail before. So we log it.
                        // After these have been cleaned up, we'll let them throw.
                        try {
                            // This is intentionally an invariant that gets caught. It's the same
                            // behavior as without this statement except with a better message.
                            invariant(typeof typeSpecs[typeSpecName] === "function", "%s: %s type `%s` is invalid; it must be a function, usually from the `prop-types` package, but received `%s`.", componentName || "React class", location, typeSpecName, typeof typeSpecs[typeSpecName]);
                            error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
                        } catch (ex) {
                            error = ex;
                        }
                        warning(!error || error instanceof Error, "%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", componentName || "React class", location, typeSpecName, typeof error);
                        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
                            // Only monitor this failure once because there tends to be a lot of the
                            // same error.
                            loggedTypeFailures[error.message] = true;
                            var stack = getStack ? getStack() : "";
                            warning(false, "Failed %s type: %s%s", location, error.message, stack != null ? stack : "");
                        }
                    }
                }
            }
            module1.exports = checkPropTypes;
        /* WEBPACK VAR INJECTION */ }).call(exports, __webpack_require__(5));
    /***/ },
    /* 13 */ /***/ function(module1, exports, __webpack_require__) {
        /**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */ "use strict";
        var emptyFunction = __webpack_require__(7);
        var invariant = __webpack_require__(8);
        var ReactPropTypesSecret = __webpack_require__(11);
        module1.exports = function() {
            function shim(props, propName, componentName, location, propFullName, secret) {
                if (secret === ReactPropTypesSecret) // It is still safe when called from React.
                return;
                invariant(false, "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
            }
            shim.isRequired = shim;
            function getShim() {
                return shim;
            }
            // Important!
            // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
            var ReactPropTypes = {
                array: shim,
                bool: shim,
                func: shim,
                number: shim,
                object: shim,
                string: shim,
                symbol: shim,
                any: shim,
                arrayOf: getShim,
                element: shim,
                instanceOf: getShim,
                node: shim,
                objectOf: getShim,
                oneOf: getShim,
                oneOfType: getShim,
                shape: getShim,
                exact: getShim
            };
            ReactPropTypes.checkPropTypes = emptyFunction;
            ReactPropTypes.PropTypes = ReactPropTypes;
            return ReactPropTypes;
        };
    /***/ },
    /* 14 */ /***/ function(module1, exports) {
        module1.exports = (parcelRequire("1u0KT"));
    /***/ },
    /* 15 */ /***/ function(module1, exports) {
        module1.exports = (parcelRequire("3WZaY"));
    /***/ }
]);


var $d62524982f22f57c$exports = {};
"use strict";

var $31dJ8 = parcelRequire("31dJ8");

(function() {
    var firebase = (parcelRequire("31dJ8")).default; /*

 Copyright The Closure Library Authors.
 SPDX-License-Identifier: Apache-2.0
*/ 
    var k, aa = "function" == typeof Object.defineProperties ? Object.defineProperty : function(a, b, c) {
        a != Array.prototype && a != Object.prototype && (a[b] = c.value);
    };
    function ba(a) {
        a = [
            "object" == typeof window && window,
            "object" == typeof self && self,
            "object" == typeof $parcel$global && $parcel$global,
            a
        ];
        for(var b = 0; b < a.length; ++b){
            var c = a[b];
            if (c && c.Math == Math) return c;
        }
        return globalThis;
    }
    var ca = ba(this);
    function da(a, b) {
        if (b) {
            var c = ca;
            a = a.split(".");
            for(var d = 0; d < a.length - 1; d++){
                var e = a[d];
                e in c || (c[e] = {});
                c = c[e];
            }
            a = a[a.length - 1];
            d = c[a];
            b = b(d);
            b != d && null != b && aa(c, a, {
                configurable: !0,
                writable: !0,
                value: b
            });
        }
    }
    function ea(a) {
        var b = 0;
        return function() {
            return b < a.length ? {
                done: !1,
                value: a[b++]
            } : {
                done: !0
            };
        };
    }
    function fa(a) {
        var b = "undefined" != typeof Symbol && Symbol.iterator && a[Symbol.iterator];
        return b ? b.call(a) : {
            next: ea(a)
        };
    }
    da("Promise", function(a) {
        function b(g) {
            this.b = 0;
            this.c = void 0;
            this.a = [];
            var h = this.f();
            try {
                g(h.resolve, h.reject);
            } catch (m) {
                h.reject(m);
            }
        }
        function c() {
            this.a = null;
        }
        function d(g) {
            return g instanceof b ? g : new b(function(h) {
                h(g);
            });
        }
        if (a) return a;
        c.prototype.b = function(g) {
            if (null == this.a) {
                this.a = [];
                var h = this;
                this.c(function() {
                    h.g();
                });
            }
            this.a.push(g);
        };
        var e = ca.setTimeout;
        c.prototype.c = function(g) {
            e(g, 0);
        };
        c.prototype.g = function() {
            for(; this.a && this.a.length;){
                var g = this.a;
                this.a = [];
                for(var h = 0; h < g.length; ++h){
                    var m = g[h];
                    g[h] = null;
                    try {
                        m();
                    } catch (p) {
                        this.f(p);
                    }
                }
            }
            this.a = null;
        };
        c.prototype.f = function(g) {
            this.c(function() {
                throw g;
            });
        };
        b.prototype.f = function() {
            function g(p) {
                return function(v) {
                    m || (m = !0, p.call(h, v));
                };
            }
            var h = this, m = !1;
            return {
                resolve: g(this.v),
                reject: g(this.g)
            };
        };
        b.prototype.v = function(g) {
            if (g === this) this.g(new TypeError("A Promise cannot resolve to itself"));
            else if (g instanceof b) this.o(g);
            else {
                a: switch(typeof g){
                    case "object":
                        var h = null != g;
                        break a;
                    case "function":
                        h = !0;
                        break a;
                    default:
                        h = !1;
                }
                h ? this.m(g) : this.h(g);
            }
        };
        b.prototype.m = function(g) {
            var h = void 0;
            try {
                h = g.then;
            } catch (m) {
                this.g(m);
                return;
            }
            "function" == typeof h ? this.u(h, g) : this.h(g);
        };
        b.prototype.g = function(g) {
            this.i(2, g);
        };
        b.prototype.h = function(g) {
            this.i(1, g);
        };
        b.prototype.i = function(g, h) {
            if (0 != this.b) throw Error("Cannot settle(" + g + ", " + h + "): Promise already settled in state" + this.b);
            this.b = g;
            this.c = h;
            this.l();
        };
        b.prototype.l = function() {
            if (null != this.a) {
                for(var g = 0; g < this.a.length; ++g)f.b(this.a[g]);
                this.a = null;
            }
        };
        var f = new c;
        b.prototype.o = function(g) {
            var h = this.f();
            g.Pa(h.resolve, h.reject);
        };
        b.prototype.u = function(g, h) {
            var m = this.f();
            try {
                g.call(h, m.resolve, m.reject);
            } catch (p) {
                m.reject(p);
            }
        };
        b.prototype.then = function(g, h) {
            function m(A, Q) {
                return "function" == typeof A ? function(xa) {
                    try {
                        p(A(xa));
                    } catch (yd) {
                        v(yd);
                    }
                } : Q;
            }
            var p, v, B = new b(function(A, Q) {
                p = A;
                v = Q;
            });
            this.Pa(m(g, p), m(h, v));
            return B;
        };
        b.prototype.catch = function(g) {
            return this.then(void 0, g);
        };
        b.prototype.Pa = function(g, h) {
            function m() {
                switch(p.b){
                    case 1:
                        g(p.c);
                        break;
                    case 2:
                        h(p.c);
                        break;
                    default:
                        throw Error("Unexpected state: " + p.b);
                }
            }
            var p = this;
            null == this.a ? f.b(m) : this.a.push(m);
        };
        b.resolve = d;
        b.reject = function(g) {
            return new b(function(h, m) {
                m(g);
            });
        };
        b.race = function(g) {
            return new b(function(h, m) {
                for(var p = fa(g), v = p.next(); !v.done; v = p.next())d(v.value).Pa(h, m);
            });
        };
        b.all = function(g) {
            var h = fa(g), m = h.next();
            return m.done ? d([]) : new b(function(p, v) {
                function B(xa) {
                    return function(yd) {
                        A[xa] = yd;
                        Q--;
                        0 == Q && p(A);
                    };
                }
                var A = [], Q = 0;
                do A.push(void 0), Q++, d(m.value).Pa(B(A.length - 1), v), m = h.next();
                while (!m.done);
            });
        };
        return b;
    });
    var ha = ha || {}, l = this || self, ia = /^[\w+/_-]+[=]{0,2}$/, ja = null;
    function ka() {}
    function la(a) {
        var b = typeof a;
        if ("object" == b) {
            if (a) {
                if (a instanceof Array) return "array";
                if (a instanceof Object) return b;
                var c = Object.prototype.toString.call(a);
                if ("[object Window]" == c) return "object";
                if ("[object Array]" == c || "number" == typeof a.length && "undefined" != typeof a.splice && "undefined" != typeof a.propertyIsEnumerable && !a.propertyIsEnumerable("splice")) return "array";
                if ("[object Function]" == c || "undefined" != typeof a.call && "undefined" != typeof a.propertyIsEnumerable && !a.propertyIsEnumerable("call")) return "function";
            } else return "null";
        } else if ("function" == b && "undefined" == typeof a.call) return "object";
        return b;
    }
    function ma(a) {
        var b = la(a);
        return "array" == b || "object" == b && "number" == typeof a.length;
    }
    function na(a) {
        return "function" == la(a);
    }
    function n(a) {
        var b = typeof a;
        return "object" == b && null != a || "function" == b;
    }
    function oa(a) {
        return Object.prototype.hasOwnProperty.call(a, pa) && a[pa] || (a[pa] = ++qa);
    }
    var pa = "closure_uid_" + (1E9 * Math.random() >>> 0), qa = 0;
    function ra(a, b, c) {
        return a.call.apply(a.bind, arguments);
    }
    function sa(a, b, c) {
        if (!a) throw Error();
        if (2 < arguments.length) {
            var d = Array.prototype.slice.call(arguments, 2);
            return function() {
                var e = Array.prototype.slice.call(arguments);
                Array.prototype.unshift.apply(e, d);
                return a.apply(b, e);
            };
        }
        return function() {
            return a.apply(b, arguments);
        };
    }
    function q(a, b, c) {
        Function.prototype.bind && -1 != Function.prototype.bind.toString().indexOf("native code") ? q = ra : q = sa;
        return q.apply(null, arguments);
    }
    function ta(a, b) {
        var c = Array.prototype.slice.call(arguments, 1);
        return function() {
            var d = c.slice();
            d.push.apply(d, arguments);
            return a.apply(this, d);
        };
    }
    var ua = Date.now || function() {
        return +new Date;
    };
    function r(a, b) {
        function c() {}
        c.prototype = b.prototype;
        a.$a = b.prototype;
        a.prototype = new c;
        a.prototype.constructor = a;
    }
    function t(a, b, c) {
        this.code = va + a;
        this.message = b || wa[a] || "";
        this.a = c || null;
    }
    r(t, Error);
    t.prototype.w = function() {
        var a = {
            code: this.code,
            message: this.message
        };
        this.a && (a.serverResponse = this.a);
        return a;
    };
    t.prototype.toJSON = function() {
        return this.w();
    };
    function ya(a) {
        var b = a && a.code;
        return b ? new t(b.substring(va.length), a.message, a.serverResponse) : null;
    }
    var va = "auth/", wa = {
        "admin-restricted-operation": "This operation is restricted to administrators only.",
        "argument-error": "",
        "app-not-authorized": "This app, identified by the domain where it's hosted, is not authorized to use Firebase Authentication with the provided API key. Review your key configuration in the Google API console.",
        "app-not-installed": "The requested mobile application corresponding to the identifier (Android package name or iOS bundle ID) provided is not installed on this device.",
        "captcha-check-failed": "The reCAPTCHA response token provided is either invalid, expired, already used or the domain associated with it does not match the list of whitelisted domains.",
        "code-expired": "The SMS code has expired. Please re-send the verification code to try again.",
        "cordova-not-ready": "Cordova framework is not ready.",
        "cors-unsupported": "This browser is not supported.",
        "credential-already-in-use": "This credential is already associated with a different user account.",
        "custom-token-mismatch": "The custom token corresponds to a different audience.",
        "requires-recent-login": "This operation is sensitive and requires recent authentication. Log in again before retrying this request.",
        "dynamic-link-not-activated": "Please activate Dynamic Links in the Firebase Console and agree to the terms and conditions.",
        "email-change-needs-verification": "Multi-factor users must always have a verified email.",
        "email-already-in-use": "The email address is already in use by another account.",
        "expired-action-code": "The action code has expired. ",
        "cancelled-popup-request": "This operation has been cancelled due to another conflicting popup being opened.",
        "internal-error": "An internal error has occurred.",
        "invalid-app-credential": "The phone verification request contains an invalid application verifier. The reCAPTCHA token response is either invalid or expired.",
        "invalid-app-id": "The mobile app identifier is not registed for the current project.",
        "invalid-user-token": "This user's credential isn't valid for this project. This can happen if the user's token has been tampered with, or if the user isn't for the project associated with this API key.",
        "invalid-auth-event": "An internal error has occurred.",
        "invalid-verification-code": "The SMS verification code used to create the phone auth credential is invalid. Please resend the verification code sms and be sure use the verification code provided by the user.",
        "invalid-continue-uri": "The continue URL provided in the request is invalid.",
        "invalid-cordova-configuration": "The following Cordova plugins must be installed to enable OAuth sign-in: cordova-plugin-buildinfo, cordova-universal-links-plugin, cordova-plugin-browsertab, cordova-plugin-inappbrowser and cordova-plugin-customurlscheme.",
        "invalid-custom-token": "The custom token format is incorrect. Please check the documentation.",
        "invalid-dynamic-link-domain": "The provided dynamic link domain is not configured or authorized for the current project.",
        "invalid-email": "The email address is badly formatted.",
        "invalid-api-key": "Your API key is invalid, please check you have copied it correctly.",
        "invalid-cert-hash": "The SHA-1 certificate hash provided is invalid.",
        "invalid-credential": "The supplied auth credential is malformed or has expired.",
        "invalid-message-payload": "The email template corresponding to this action contains invalid characters in its message. Please fix by going to the Auth email templates section in the Firebase Console.",
        "invalid-multi-factor-session": "The request does not contain a valid proof of first factor successful sign-in.",
        "invalid-oauth-provider": "EmailAuthProvider is not supported for this operation. This operation only supports OAuth providers.",
        "invalid-oauth-client-id": "The OAuth client ID provided is either invalid or does not match the specified API key.",
        "unauthorized-domain": "This domain is not authorized for OAuth operations for your Firebase project. Edit the list of authorized domains from the Firebase console.",
        "invalid-action-code": "The action code is invalid. This can happen if the code is malformed, expired, or has already been used.",
        "wrong-password": "The password is invalid or the user does not have a password.",
        "invalid-persistence-type": "The specified persistence type is invalid. It can only be local, session or none.",
        "invalid-phone-number": "The format of the phone number provided is incorrect. Please enter the phone number in a format that can be parsed into E.164 format. E.164 phone numbers are written in the format [+][country code][subscriber number including area code].",
        "invalid-provider-id": "The specified provider ID is invalid.",
        "invalid-recipient-email": "The email corresponding to this action failed to send as the provided recipient email address is invalid.",
        "invalid-sender": "The email template corresponding to this action contains an invalid sender email or name. Please fix by going to the Auth email templates section in the Firebase Console.",
        "invalid-verification-id": "The verification ID used to create the phone auth credential is invalid.",
        "invalid-tenant-id": "The Auth instance's tenant ID is invalid.",
        "multi-factor-info-not-found": "The user does not have a second factor matching the identifier provided.",
        "multi-factor-auth-required": "Proof of ownership of a second factor is required to complete sign-in.",
        "missing-android-pkg-name": "An Android Package Name must be provided if the Android App is required to be installed.",
        "auth-domain-config-required": "Be sure to include authDomain when calling firebase.initializeApp(), by following the instructions in the Firebase console.",
        "missing-app-credential": "The phone verification request is missing an application verifier assertion. A reCAPTCHA response token needs to be provided.",
        "missing-verification-code": "The phone auth credential was created with an empty SMS verification code.",
        "missing-continue-uri": "A continue URL must be provided in the request.",
        "missing-iframe-start": "An internal error has occurred.",
        "missing-ios-bundle-id": "An iOS Bundle ID must be provided if an App Store ID is provided.",
        "missing-multi-factor-info": "No second factor identifier is provided.",
        "missing-multi-factor-session": "The request is missing proof of first factor successful sign-in.",
        "missing-or-invalid-nonce": "The request does not contain a valid nonce. This can occur if the SHA-256 hash of the provided raw nonce does not match the hashed nonce in the ID token payload.",
        "missing-phone-number": "To send verification codes, provide a phone number for the recipient.",
        "missing-verification-id": "The phone auth credential was created with an empty verification ID.",
        "app-deleted": "This instance of FirebaseApp has been deleted.",
        "account-exists-with-different-credential": "An account already exists with the same email address but different sign-in credentials. Sign in using a provider associated with this email address.",
        "network-request-failed": "A network error (such as timeout, interrupted connection or unreachable host) has occurred.",
        "no-auth-event": "An internal error has occurred.",
        "no-such-provider": "User was not linked to an account with the given provider.",
        "null-user": "A null user object was provided as the argument for an operation which requires a non-null user object.",
        "operation-not-allowed": "The given sign-in provider is disabled for this Firebase project. Enable it in the Firebase console, under the sign-in method tab of the Auth section.",
        "operation-not-supported-in-this-environment": 'This operation is not supported in the environment this application is running on. "location.protocol" must be http, https or chrome-extension and web storage must be enabled.',
        "popup-blocked": "Unable to establish a connection with the popup. It may have been blocked by the browser.",
        "popup-closed-by-user": "The popup has been closed by the user before finalizing the operation.",
        "provider-already-linked": "User can only be linked to one identity for the given provider.",
        "quota-exceeded": "The project's quota for this operation has been exceeded.",
        "redirect-cancelled-by-user": "The redirect operation has been cancelled by the user before finalizing.",
        "redirect-operation-pending": "A redirect sign-in operation is already pending.",
        "rejected-credential": "The request contains malformed or mismatching credentials.",
        "second-factor-already-in-use": "The second factor is already enrolled on this account.",
        "maximum-second-factor-count-exceeded": "The maximum allowed number of second factors on a user has been exceeded.",
        "tenant-id-mismatch": "The provided tenant ID does not match the Auth instance's tenant ID",
        timeout: "The operation has timed out.",
        "user-token-expired": "The user's credential is no longer valid. The user must sign in again.",
        "too-many-requests": "We have blocked all requests from this device due to unusual activity. Try again later.",
        "unauthorized-continue-uri": "The domain of the continue URL is not whitelisted.  Please whitelist the domain in the Firebase console.",
        "unsupported-first-factor": "Enrolling a second factor or signing in with a multi-factor account requires sign-in with a supported first factor.",
        "unsupported-persistence-type": "The current environment does not support the specified persistence type.",
        "unsupported-tenant-operation": "This operation is not supported in a multi-tenant context.",
        "unverified-email": "The operation requires a verified email.",
        "user-cancelled": "The user did not grant your application the permissions it requested.",
        "user-not-found": "There is no user record corresponding to this identifier. The user may have been deleted.",
        "user-disabled": "The user account has been disabled by an administrator.",
        "user-mismatch": "The supplied credentials do not correspond to the previously signed in user.",
        "user-signed-out": "",
        "weak-password": "The password must be 6 characters long or more.",
        "web-storage-unsupported": "This browser is not supported or 3rd party cookies and data may be disabled."
    };
    var za = {
        kd: {
            Sa: "https://staging-identitytoolkit.sandbox.googleapis.com/identitytoolkit/v3/relyingparty/",
            Ya: "https://staging-securetoken.sandbox.googleapis.com/v1/token",
            Va: "https://staging-identitytoolkit.sandbox.googleapis.com/v2/",
            id: "b"
        },
        rd: {
            Sa: "https://www.googleapis.com/identitytoolkit/v3/relyingparty/",
            Ya: "https://securetoken.googleapis.com/v1/token",
            Va: "https://identitytoolkit.googleapis.com/v2/",
            id: "p"
        },
        td: {
            Sa: "https://staging-www.sandbox.googleapis.com/identitytoolkit/v3/relyingparty/",
            Ya: "https://staging-securetoken.sandbox.googleapis.com/v1/token",
            Va: "https://staging-identitytoolkit.sandbox.googleapis.com/v2/",
            id: "s"
        },
        ud: {
            Sa: "https://www-googleapis-test.sandbox.google.com/identitytoolkit/v3/relyingparty/",
            Ya: "https://test-securetoken.sandbox.googleapis.com/v1/token",
            Va: "https://test-identitytoolkit.sandbox.googleapis.com/v2/",
            id: "t"
        }
    };
    function Aa(a) {
        for(var b in za)if (za[b].id === a) return a = za[b], {
            firebaseEndpoint: a.Sa,
            secureTokenEndpoint: a.Ya,
            identityPlatformEndpoint: a.Va
        };
        return null;
    }
    var Ba;
    Ba = Aa("__EID__") ? "__EID__" : void 0;
    function Ca(a) {
        if (!a) return !1;
        try {
            return !!a.$goog_Thenable;
        } catch (b) {
            return !1;
        }
    }
    function u(a) {
        if (Error.captureStackTrace) Error.captureStackTrace(this, u);
        else {
            var b = Error().stack;
            b && (this.stack = b);
        }
        a && (this.message = String(a));
    }
    r(u, Error);
    u.prototype.name = "CustomError";
    function Da(a, b) {
        a = a.split("%s");
        for(var c = "", d = a.length - 1, e = 0; e < d; e++)c += a[e] + (e < b.length ? b[e] : "%s");
        u.call(this, c + a[d]);
    }
    r(Da, u);
    Da.prototype.name = "AssertionError";
    function Ea(a, b) {
        throw new Da("Failure" + (a ? ": " + a : ""), Array.prototype.slice.call(arguments, 1));
    }
    function Fa(a, b) {
        this.c = a;
        this.f = b;
        this.b = 0;
        this.a = null;
    }
    Fa.prototype.get = function() {
        if (0 < this.b) {
            this.b--;
            var a = this.a;
            this.a = a.next;
            a.next = null;
        } else a = this.c();
        return a;
    };
    function Ga(a, b) {
        a.f(b);
        100 > a.b && (a.b++, b.next = a.a, a.a = b);
    }
    function Ha() {
        this.b = this.a = null;
    }
    var Ja = new Fa(function() {
        return new Ia;
    }, function(a) {
        a.reset();
    });
    Ha.prototype.add = function(a, b) {
        var c = Ja.get();
        c.set(a, b);
        this.b ? this.b.next = c : this.a = c;
        this.b = c;
    };
    function Ka() {
        var a = La, b = null;
        a.a && (b = a.a, a.a = a.a.next, a.a || (a.b = null), b.next = null);
        return b;
    }
    function Ia() {
        this.next = this.b = this.a = null;
    }
    Ia.prototype.set = function(a, b) {
        this.a = a;
        this.b = b;
        this.next = null;
    };
    Ia.prototype.reset = function() {
        this.next = this.b = this.a = null;
    };
    var Ma = Array.prototype.indexOf ? function(a, b) {
        return Array.prototype.indexOf.call(a, b, void 0);
    } : function(a, b) {
        if ("string" === typeof a) return "string" !== typeof b || 1 != b.length ? -1 : a.indexOf(b, 0);
        for(var c = 0; c < a.length; c++)if (c in a && a[c] === b) return c;
        return -1;
    }, w = Array.prototype.forEach ? function(a, b, c) {
        Array.prototype.forEach.call(a, b, c);
    } : function(a, b, c) {
        for(var d = a.length, e = "string" === typeof a ? a.split("") : a, f = 0; f < d; f++)f in e && b.call(c, e[f], f, a);
    };
    function Na(a, b) {
        for(var c = "string" === typeof a ? a.split("") : a, d = a.length - 1; 0 <= d; --d)d in c && b.call(void 0, c[d], d, a);
    }
    var Oa = Array.prototype.filter ? function(a, b) {
        return Array.prototype.filter.call(a, b, void 0);
    } : function(a, b) {
        for(var c = a.length, d = [], e = 0, f = "string" === typeof a ? a.split("") : a, g = 0; g < c; g++)if (g in f) {
            var h = f[g];
            b.call(void 0, h, g, a) && (d[e++] = h);
        }
        return d;
    }, Pa = Array.prototype.map ? function(a, b) {
        return Array.prototype.map.call(a, b, void 0);
    } : function(a, b) {
        for(var c = a.length, d = Array(c), e = "string" === typeof a ? a.split("") : a, f = 0; f < c; f++)f in e && (d[f] = b.call(void 0, e[f], f, a));
        return d;
    }, Qa = Array.prototype.some ? function(a, b) {
        return Array.prototype.some.call(a, b, void 0);
    } : function(a, b) {
        for(var c = a.length, d = "string" === typeof a ? a.split("") : a, e = 0; e < c; e++)if (e in d && b.call(void 0, d[e], e, a)) return !0;
        return !1;
    };
    function Ra(a) {
        a: {
            var b = Sa;
            for(var c = a.length, d = "string" === typeof a ? a.split("") : a, e = 0; e < c; e++)if (e in d && b.call(void 0, d[e], e, a)) {
                b = e;
                break a;
            }
            b = -1;
        }
        return 0 > b ? null : "string" === typeof a ? a.charAt(b) : a[b];
    }
    function Ta(a, b) {
        return 0 <= Ma(a, b);
    }
    function Ua(a, b) {
        b = Ma(a, b);
        var c;
        (c = 0 <= b) && Array.prototype.splice.call(a, b, 1);
        return c;
    }
    function Va(a, b) {
        var c = 0;
        Na(a, function(d, e) {
            b.call(void 0, d, e, a) && 1 == Array.prototype.splice.call(a, e, 1).length && c++;
        });
    }
    function Wa(a) {
        return Array.prototype.concat.apply([], arguments);
    }
    function Xa(a) {
        var b = a.length;
        if (0 < b) {
            for(var c = Array(b), d = 0; d < b; d++)c[d] = a[d];
            return c;
        }
        return [];
    }
    var Ya = String.prototype.trim ? function(a) {
        return a.trim();
    } : function(a) {
        return /^[\s\xa0]*([\s\S]*?)[\s\xa0]*$/.exec(a)[1];
    }, Za = /&/g, $a = /</g, ab = />/g, bb = /"/g, cb = /'/g, db = /\x00/g, eb = /[\x00&<>"']/;
    function x(a, b) {
        return -1 != a.indexOf(b);
    }
    function fb(a, b) {
        return a < b ? -1 : a > b ? 1 : 0;
    }
    var gb;
    a: {
        var hb = l.navigator;
        if (hb) {
            var ib = hb.userAgent;
            if (ib) {
                gb = ib;
                break a;
            }
        }
        gb = "";
    }
    function y(a) {
        return x(gb, a);
    }
    function jb(a, b) {
        for(var c in a)b.call(void 0, a[c], c, a);
    }
    function kb(a) {
        for(var b in a)return !1;
        return !0;
    }
    function lb(a) {
        var b = {}, c;
        for(c in a)b[c] = a[c];
        return b;
    }
    var mb = "constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" ");
    function z(a, b) {
        for(var c, d, e = 1; e < arguments.length; e++){
            d = arguments[e];
            for(c in d)a[c] = d[c];
            for(var f = 0; f < mb.length; f++)c = mb[f], Object.prototype.hasOwnProperty.call(d, c) && (a[c] = d[c]);
        }
    }
    function nb(a, b) {
        a: {
            try {
                var c = a && a.ownerDocument, d = c && (c.defaultView || c.parentWindow);
                d = d || l;
                if (d.Element && d.Location) {
                    var e = d;
                    break a;
                }
            } catch (g) {}
            e = null;
        }
        if (e && "undefined" != typeof e[b] && (!a || !(a instanceof e[b]) && (a instanceof e.Location || a instanceof e.Element))) {
            if (n(a)) try {
                var f = a.constructor.displayName || a.constructor.name || Object.prototype.toString.call(a);
            } catch (g) {
                f = "<object could not be stringified>";
            }
            else f = void 0 === a ? "undefined" : null === a ? "null" : typeof a;
            Ea("Argument is not a %s (or a non-Element, non-Location mock); got: %s", b, f);
        }
    }
    function ob(a, b) {
        this.a = a === pb && b || "";
        this.b = qb;
    }
    ob.prototype.sa = !0;
    ob.prototype.ra = function() {
        return this.a;
    };
    ob.prototype.toString = function() {
        return "Const{" + this.a + "}";
    };
    function rb(a) {
        if (a instanceof ob && a.constructor === ob && a.b === qb) return a.a;
        Ea("expected object of type Const, got '" + a + "'");
        return "type_error:Const";
    }
    var qb = {}, pb = {}, sb = new ob(pb, "");
    function tb(a, b) {
        this.a = a === ub && b || "";
        this.b = vb;
    }
    tb.prototype.sa = !0;
    tb.prototype.ra = function() {
        return this.a.toString();
    };
    tb.prototype.toString = function() {
        return "TrustedResourceUrl{" + this.a + "}";
    };
    function wb(a) {
        if (a instanceof tb && a.constructor === tb && a.b === vb) return a.a;
        Ea("expected object of type TrustedResourceUrl, got '" + a + "' of type " + la(a));
        return "type_error:TrustedResourceUrl";
    }
    function xb(a, b) {
        var c = rb(a);
        if (!yb.test(c)) throw Error("Invalid TrustedResourceUrl format: " + c);
        a = c.replace(zb, function(d, e) {
            if (!Object.prototype.hasOwnProperty.call(b, e)) throw Error('Found marker, "' + e + '", in format string, "' + c + '", but no valid label mapping found in args: ' + JSON.stringify(b));
            d = b[e];
            return d instanceof ob ? rb(d) : encodeURIComponent(String(d));
        });
        return new tb(ub, a);
    }
    var zb = /%{(\w+)}/g, yb = /^((https:)?\/\/[0-9a-z.:[\]-]+\/|\/[^/\\]|[^:/\\%]+\/|[^:/\\%]*[?#]|about:blank#)/i, vb = {}, ub = {};
    function Ab(a, b) {
        this.a = a === Bb && b || "";
        this.b = Cb;
    }
    Ab.prototype.sa = !0;
    Ab.prototype.ra = function() {
        return this.a.toString();
    };
    Ab.prototype.toString = function() {
        return "SafeUrl{" + this.a + "}";
    };
    function Db(a) {
        if (a instanceof Ab && a.constructor === Ab && a.b === Cb) return a.a;
        Ea("expected object of type SafeUrl, got '" + a + "' of type " + la(a));
        return "type_error:SafeUrl";
    }
    var Eb = /^(?:(?:https?|mailto|ftp):|[^:/?#]*(?:[/?#]|$))/i;
    function Fb(a) {
        if (a instanceof Ab) return a;
        a = "object" == typeof a && a.sa ? a.ra() : String(a);
        Eb.test(a) || (a = "about:invalid#zClosurez");
        return new Ab(Bb, a);
    }
    var Cb = {}, Bb = {};
    function Gb() {
        this.a = "";
        this.b = Hb;
    }
    Gb.prototype.sa = !0;
    Gb.prototype.ra = function() {
        return this.a.toString();
    };
    Gb.prototype.toString = function() {
        return "SafeHtml{" + this.a + "}";
    };
    function Ib(a) {
        if (a instanceof Gb && a.constructor === Gb && a.b === Hb) return a.a;
        Ea("expected object of type SafeHtml, got '" + a + "' of type " + la(a));
        return "type_error:SafeHtml";
    }
    var Hb = {};
    function Jb(a) {
        var b = new Gb;
        b.a = a;
        return b;
    }
    Jb("<!DOCTYPE html>");
    var Kb = Jb("");
    Jb("<br>");
    function Lb(a) {
        var b = new tb(ub, rb(sb));
        nb(a, "HTMLIFrameElement");
        a.src = wb(b).toString();
    }
    function Mb(a, b) {
        nb(a, "HTMLScriptElement");
        a.src = wb(b);
        if (null === ja) b: {
            b = l.document;
            if ((b = b.querySelector && b.querySelector("script[nonce]")) && (b = b.nonce || b.getAttribute("nonce")) && ia.test(b)) {
                ja = b;
                break b;
            }
            ja = "";
        }
        b = ja;
        b && a.setAttribute("nonce", b);
    }
    function Nb(a, b) {
        for(var c = a.split("%s"), d = "", e = Array.prototype.slice.call(arguments, 1); e.length && 1 < c.length;)d += c.shift() + e.shift();
        return d + c.join("%s");
    }
    function Ob(a) {
        eb.test(a) && (-1 != a.indexOf("&") && (a = a.replace(Za, "&amp;")), -1 != a.indexOf("<") && (a = a.replace($a, "&lt;")), -1 != a.indexOf(">") && (a = a.replace(ab, "&gt;")), -1 != a.indexOf('"') && (a = a.replace(bb, "&quot;")), -1 != a.indexOf("'") && (a = a.replace(cb, "&#39;")), -1 != a.indexOf("\x00") && (a = a.replace(db, "&#0;")));
        return a;
    }
    function Pb(a) {
        Pb[" "](a);
        return a;
    }
    Pb[" "] = ka;
    function Qb(a, b) {
        var c = Rb;
        return Object.prototype.hasOwnProperty.call(c, a) ? c[a] : c[a] = b(a);
    }
    var Sb = y("Opera"), Tb = y("Trident") || y("MSIE"), Ub = y("Edge"), Vb = Ub || Tb, Wb = y("Gecko") && !(x(gb.toLowerCase(), "webkit") && !y("Edge")) && !(y("Trident") || y("MSIE")) && !y("Edge"), Xb = x(gb.toLowerCase(), "webkit") && !y("Edge");
    function Yb() {
        var a = l.document;
        return a ? a.documentMode : void 0;
    }
    var Zb;
    a: {
        var $b = "", ac = function() {
            var a = gb;
            if (Wb) return /rv:([^\);]+)(\)|;)/.exec(a);
            if (Ub) return /Edge\/([\d\.]+)/.exec(a);
            if (Tb) return /\b(?:MSIE|rv)[: ]([^\);]+)(\)|;)/.exec(a);
            if (Xb) return /WebKit\/(\S+)/.exec(a);
            if (Sb) return /(?:Version)[ \/]?(\S+)/.exec(a);
        }();
        ac && ($b = ac ? ac[1] : "");
        if (Tb) {
            var bc = Yb();
            if (null != bc && bc > parseFloat($b)) {
                Zb = String(bc);
                break a;
            }
        }
        Zb = $b;
    }
    var Rb = {};
    function cc(a) {
        return Qb(a, function() {
            for(var b = 0, c = Ya(String(Zb)).split("."), d = Ya(String(a)).split("."), e = Math.max(c.length, d.length), f = 0; 0 == b && f < e; f++){
                var g = c[f] || "", h = d[f] || "";
                do {
                    g = /(\d*)(\D*)(.*)/.exec(g) || [
                        "",
                        "",
                        "",
                        ""
                    ];
                    h = /(\d*)(\D*)(.*)/.exec(h) || [
                        "",
                        "",
                        "",
                        ""
                    ];
                    if (0 == g[0].length && 0 == h[0].length) break;
                    b = fb(0 == g[1].length ? 0 : parseInt(g[1], 10), 0 == h[1].length ? 0 : parseInt(h[1], 10)) || fb(0 == g[2].length, 0 == h[2].length) || fb(g[2], h[2]);
                    g = g[3];
                    h = h[3];
                }while (0 == b);
            }
            return 0 <= b;
        });
    }
    var dc;
    dc = l.document && Tb ? Yb() : void 0;
    try {
        new self.OffscreenCanvas(0, 0).getContext("2d");
    } catch (a) {}
    var ec = !Tb || 9 <= Number(dc);
    function fc(a) {
        var b = document;
        return "string" === typeof a ? b.getElementById(a) : a;
    }
    function gc(a, b) {
        jb(b, function(c, d) {
            c && "object" == typeof c && c.sa && (c = c.ra());
            "style" == d ? a.style.cssText = c : "class" == d ? a.className = c : "for" == d ? a.htmlFor = c : hc.hasOwnProperty(d) ? a.setAttribute(hc[d], c) : 0 == d.lastIndexOf("aria-", 0) || 0 == d.lastIndexOf("data-", 0) ? a.setAttribute(d, c) : a[d] = c;
        });
    }
    var hc = {
        cellpadding: "cellPadding",
        cellspacing: "cellSpacing",
        colspan: "colSpan",
        frameborder: "frameBorder",
        height: "height",
        maxlength: "maxLength",
        nonce: "nonce",
        role: "role",
        rowspan: "rowSpan",
        type: "type",
        usemap: "useMap",
        valign: "vAlign",
        width: "width"
    };
    function ic(a, b, c) {
        var d = arguments, e = document, f = String(d[0]), g = d[1];
        if (!ec && g && (g.name || g.type)) {
            f = [
                "<",
                f
            ];
            g.name && f.push(' name="', Ob(g.name), '"');
            if (g.type) {
                f.push(' type="', Ob(g.type), '"');
                var h = {};
                z(h, g);
                delete h.type;
                g = h;
            }
            f.push(">");
            f = f.join("");
        }
        f = jc(e, f);
        g && ("string" === typeof g ? f.className = g : Array.isArray(g) ? f.className = g.join(" ") : gc(f, g));
        2 < d.length && kc(e, f, d);
        return f;
    }
    function kc(a, b, c) {
        function d(g) {
            g && b.appendChild("string" === typeof g ? a.createTextNode(g) : g);
        }
        for(var e = 2; e < c.length; e++){
            var f = c[e];
            !ma(f) || n(f) && 0 < f.nodeType ? d(f) : w(lc(f) ? Xa(f) : f, d);
        }
    }
    function jc(a, b) {
        b = String(b);
        "application/xhtml+xml" === a.contentType && (b = b.toLowerCase());
        return a.createElement(b);
    }
    function lc(a) {
        if (a && "number" == typeof a.length) {
            if (n(a)) return "function" == typeof a.item || "string" == typeof a.item;
            if (na(a)) return "function" == typeof a.item;
        }
        return !1;
    }
    function mc(a) {
        l.setTimeout(function() {
            throw a;
        }, 0);
    }
    var nc;
    function oc() {
        var a = l.MessageChannel;
        "undefined" === typeof a && "undefined" !== typeof window && window.postMessage && window.addEventListener && !y("Presto") && (a = function() {
            var e = jc(document, "IFRAME");
            e.style.display = "none";
            Lb(e);
            document.documentElement.appendChild(e);
            var f = e.contentWindow;
            e = f.document;
            e.open();
            e.write(Ib(Kb));
            e.close();
            var g = "callImmediate" + Math.random(), h = "file:" == f.location.protocol ? "*" : f.location.protocol + "//" + f.location.host;
            e = q(function(m) {
                if (("*" == h || m.origin == h) && m.data == g) this.port1.onmessage();
            }, this);
            f.addEventListener("message", e, !1);
            this.port1 = {};
            this.port2 = {
                postMessage: function() {
                    f.postMessage(g, h);
                }
            };
        });
        if ("undefined" !== typeof a && !y("Trident") && !y("MSIE")) {
            var b = new a, c = {}, d = c;
            b.port1.onmessage = function() {
                if (void 0 !== c.next) {
                    c = c.next;
                    var e = c.Fb;
                    c.Fb = null;
                    e();
                }
            };
            return function(e) {
                d.next = {
                    Fb: e
                };
                d = d.next;
                b.port2.postMessage(0);
            };
        }
        return function(e) {
            l.setTimeout(e, 0);
        };
    }
    function pc(a, b) {
        qc || rc();
        sc || (qc(), sc = !0);
        La.add(a, b);
    }
    var qc;
    function rc() {
        if (l.Promise && l.Promise.resolve) {
            var a = l.Promise.resolve(void 0);
            qc = function() {
                a.then(tc);
            };
        } else qc = function() {
            var b = tc;
            !na(l.setImmediate) || l.Window && l.Window.prototype && !y("Edge") && l.Window.prototype.setImmediate == l.setImmediate ? (nc || (nc = oc()), nc(b)) : l.setImmediate(b);
        };
    }
    var sc = !1, La = new Ha;
    function tc() {
        for(var a; a = Ka();){
            try {
                a.a.call(a.b);
            } catch (b) {
                mc(b);
            }
            Ga(Ja, a);
        }
        sc = !1;
    }
    function C(a, b) {
        this.a = uc;
        this.i = void 0;
        this.f = this.b = this.c = null;
        this.g = this.h = !1;
        if (a != ka) try {
            var c = this;
            a.call(b, function(d) {
                vc(c, wc, d);
            }, function(d) {
                if (!(d instanceof xc)) try {
                    if (d instanceof Error) throw d;
                    throw Error("Promise rejected.");
                } catch (e) {}
                vc(c, yc, d);
            });
        } catch (d) {
            vc(this, yc, d);
        }
    }
    var uc = 0, wc = 2, yc = 3;
    function zc() {
        this.next = this.f = this.b = this.g = this.a = null;
        this.c = !1;
    }
    zc.prototype.reset = function() {
        this.f = this.b = this.g = this.a = null;
        this.c = !1;
    };
    var Ac = new Fa(function() {
        return new zc;
    }, function(a) {
        a.reset();
    });
    function Bc(a, b, c) {
        var d = Ac.get();
        d.g = a;
        d.b = b;
        d.f = c;
        return d;
    }
    function D(a) {
        if (a instanceof C) return a;
        var b = new C(ka);
        vc(b, wc, a);
        return b;
    }
    function E(a) {
        return new C(function(b, c) {
            c(a);
        });
    }
    function Cc(a, b, c) {
        Dc(a, b, c, null) || pc(ta(b, a));
    }
    function Ec(a) {
        return new C(function(b, c) {
            var d = a.length, e = [];
            if (d) for(var f = function(p, v) {
                d--;
                e[p] = v;
                0 == d && b(e);
            }, g = function(p) {
                c(p);
            }, h = 0, m; h < a.length; h++)m = a[h], Cc(m, ta(f, h), g);
            else b(e);
        });
    }
    function Fc(a) {
        return new C(function(b) {
            var c = a.length, d = [];
            if (c) for(var e = function(h, m, p) {
                c--;
                d[h] = m ? {
                    Ob: !0,
                    value: p
                } : {
                    Ob: !1,
                    reason: p
                };
                0 == c && b(d);
            }, f = 0, g; f < a.length; f++)g = a[f], Cc(g, ta(e, f, !0), ta(e, f, !1));
            else b(d);
        });
    }
    C.prototype.then = function(a, b, c) {
        return Gc(this, na(a) ? a : null, na(b) ? b : null, c);
    };
    C.prototype.$goog_Thenable = !0;
    k = C.prototype;
    k.na = function(a, b) {
        a = Bc(a, a, b);
        a.c = !0;
        Hc(this, a);
        return this;
    };
    k.s = function(a, b) {
        return Gc(this, null, a, b);
    };
    k.cancel = function(a) {
        if (this.a == uc) {
            var b = new xc(a);
            pc(function() {
                Ic(this, b);
            }, this);
        }
    };
    function Ic(a, b) {
        if (a.a == uc) {
            if (a.c) {
                var c = a.c;
                if (c.b) {
                    for(var d = 0, e = null, f = null, g = c.b; g && (g.c || (d++, g.a == a && (e = g), !(e && 1 < d))); g = g.next)e || (f = g);
                    e && (c.a == uc && 1 == d ? Ic(c, b) : (f ? (d = f, d.next == c.f && (c.f = d), d.next = d.next.next) : Jc(c), Kc(c, e, yc, b)));
                }
                a.c = null;
            } else vc(a, yc, b);
        }
    }
    function Hc(a, b) {
        a.b || a.a != wc && a.a != yc || Lc(a);
        a.f ? a.f.next = b : a.b = b;
        a.f = b;
    }
    function Gc(a, b, c, d) {
        var e = Bc(null, null, null);
        e.a = new C(function(f, g) {
            e.g = b ? function(h) {
                try {
                    var m = b.call(d, h);
                    f(m);
                } catch (p) {
                    g(p);
                }
            } : f;
            e.b = c ? function(h) {
                try {
                    var m = c.call(d, h);
                    void 0 === m && h instanceof xc ? g(h) : f(m);
                } catch (p) {
                    g(p);
                }
            } : g;
        });
        e.a.c = a;
        Hc(a, e);
        return e.a;
    }
    k.Zc = function(a) {
        this.a = uc;
        vc(this, wc, a);
    };
    k.$c = function(a) {
        this.a = uc;
        vc(this, yc, a);
    };
    function vc(a, b, c) {
        a.a == uc && (a === c && (b = yc, c = new TypeError("Promise cannot resolve to itself")), a.a = 1, Dc(c, a.Zc, a.$c, a) || (a.i = c, a.a = b, a.c = null, Lc(a), b != yc || c instanceof xc || Mc(a, c)));
    }
    function Dc(a, b, c, d) {
        if (a instanceof C) return Hc(a, Bc(b || ka, c || null, d)), !0;
        if (Ca(a)) return a.then(b, c, d), !0;
        if (n(a)) try {
            var e = a.then;
            if (na(e)) return Nc(a, e, b, c, d), !0;
        } catch (f) {
            return c.call(d, f), !0;
        }
        return !1;
    }
    function Nc(a, b, c, d, e) {
        function f(m) {
            h || (h = !0, d.call(e, m));
        }
        function g(m) {
            h || (h = !0, c.call(e, m));
        }
        var h = !1;
        try {
            b.call(a, g, f);
        } catch (m) {
            f(m);
        }
    }
    function Lc(a) {
        a.h || (a.h = !0, pc(a.fc, a));
    }
    function Jc(a) {
        var b = null;
        a.b && (b = a.b, a.b = b.next, b.next = null);
        a.b || (a.f = null);
        return b;
    }
    k.fc = function() {
        for(var a; a = Jc(this);)Kc(this, a, this.a, this.i);
        this.h = !1;
    };
    function Kc(a, b, c, d) {
        if (c == yc && b.b && !b.c) for(; a && a.g; a = a.c)a.g = !1;
        if (b.a) b.a.c = null, Oc(b, c, d);
        else try {
            b.c ? b.g.call(b.f) : Oc(b, c, d);
        } catch (e) {
            Pc.call(null, e);
        }
        Ga(Ac, b);
    }
    function Oc(a, b, c) {
        b == wc ? a.g.call(a.f, c) : a.b && a.b.call(a.f, c);
    }
    function Mc(a, b) {
        a.g = !0;
        pc(function() {
            a.g && Pc.call(null, b);
        });
    }
    var Pc = mc;
    function xc(a) {
        u.call(this, a);
    }
    r(xc, u);
    xc.prototype.name = "cancel";
    function Qc() {
        0 != Rc && (Sc[oa(this)] = this);
        this.xa = this.xa;
        this.oa = this.oa;
    }
    var Rc = 0, Sc = {};
    Qc.prototype.xa = !1;
    function Tc(a) {
        if (!a.xa && (a.xa = !0, a.Da(), 0 != Rc)) {
            var b = oa(a);
            if (0 != Rc && a.oa && 0 < a.oa.length) throw Error(a + " did not empty its onDisposeCallbacks queue. This probably means it overrode dispose() or disposeInternal() without calling the superclass' method.");
            delete Sc[b];
        }
    }
    Qc.prototype.Da = function() {
        if (this.oa) for(; this.oa.length;)this.oa.shift()();
    };
    var Uc = Object.freeze || function(a) {
        return a;
    };
    var Vc = !Tb || 9 <= Number(dc), Wc = Tb && !cc("9"), Xc = function() {
        if (!l.addEventListener || !Object.defineProperty) return !1;
        var a = !1, b = Object.defineProperty({}, "passive", {
            get: function() {
                a = !0;
            }
        });
        try {
            l.addEventListener("test", ka, b), l.removeEventListener("test", ka, b);
        } catch (c) {}
        return a;
    }();
    function F(a, b) {
        this.type = a;
        this.b = this.target = b;
        this.defaultPrevented = !1;
    }
    F.prototype.preventDefault = function() {
        this.defaultPrevented = !0;
    };
    function Yc(a, b) {
        F.call(this, a ? a.type : "");
        this.relatedTarget = this.b = this.target = null;
        this.button = this.screenY = this.screenX = this.clientY = this.clientX = 0;
        this.key = "";
        this.metaKey = this.shiftKey = this.altKey = this.ctrlKey = !1;
        this.pointerId = 0;
        this.pointerType = "";
        this.a = null;
        if (a) {
            var c = this.type = a.type, d = a.changedTouches && a.changedTouches.length ? a.changedTouches[0] : null;
            this.target = a.target || a.srcElement;
            this.b = b;
            if (b = a.relatedTarget) {
                if (Wb) {
                    a: {
                        try {
                            Pb(b.nodeName);
                            var e = !0;
                            break a;
                        } catch (f) {}
                        e = !1;
                    }
                    e || (b = null);
                }
            } else "mouseover" == c ? b = a.fromElement : "mouseout" == c && (b = a.toElement);
            this.relatedTarget = b;
            d ? (this.clientX = void 0 !== d.clientX ? d.clientX : d.pageX, this.clientY = void 0 !== d.clientY ? d.clientY : d.pageY, this.screenX = d.screenX || 0, this.screenY = d.screenY || 0) : (this.clientX = void 0 !== a.clientX ? a.clientX : a.pageX, this.clientY = void 0 !== a.clientY ? a.clientY : a.pageY, this.screenX = a.screenX || 0, this.screenY = a.screenY || 0);
            this.button = a.button;
            this.key = a.key || "";
            this.ctrlKey = a.ctrlKey;
            this.altKey = a.altKey;
            this.shiftKey = a.shiftKey;
            this.metaKey = a.metaKey;
            this.pointerId = a.pointerId || 0;
            this.pointerType = "string" === typeof a.pointerType ? a.pointerType : Zc[a.pointerType] || "";
            this.a = a;
            a.defaultPrevented && this.preventDefault();
        }
    }
    r(Yc, F);
    var Zc = Uc({
        2: "touch",
        3: "pen",
        4: "mouse"
    });
    Yc.prototype.preventDefault = function() {
        Yc.$a.preventDefault.call(this);
        var a = this.a;
        if (a.preventDefault) a.preventDefault();
        else if (a.returnValue = !1, Wc) try {
            if (a.ctrlKey || 112 <= a.keyCode && 123 >= a.keyCode) a.keyCode = -1;
        } catch (b) {}
    };
    Yc.prototype.g = function() {
        return this.a;
    };
    var $c = "closure_listenable_" + (1E6 * Math.random() | 0), ad = 0;
    function bd(a, b, c, d, e) {
        this.listener = a;
        this.proxy = null;
        this.src = b;
        this.type = c;
        this.capture = !!d;
        this.Ua = e;
        this.key = ++ad;
        this.va = this.Oa = !1;
    }
    function cd(a) {
        a.va = !0;
        a.listener = null;
        a.proxy = null;
        a.src = null;
        a.Ua = null;
    }
    function dd(a) {
        this.src = a;
        this.a = {};
        this.b = 0;
    }
    dd.prototype.add = function(a, b, c, d, e) {
        var f = a.toString();
        a = this.a[f];
        a || (a = this.a[f] = [], this.b++);
        var g = ed(a, b, d, e);
        -1 < g ? (b = a[g], c || (b.Oa = !1)) : (b = new bd(b, this.src, f, !!d, e), b.Oa = c, a.push(b));
        return b;
    };
    function fd(a, b) {
        var c = b.type;
        c in a.a && Ua(a.a[c], b) && (cd(b), 0 == a.a[c].length && (delete a.a[c], a.b--));
    }
    function ed(a, b, c, d) {
        for(var e = 0; e < a.length; ++e){
            var f = a[e];
            if (!f.va && f.listener == b && f.capture == !!c && f.Ua == d) return e;
        }
        return -1;
    }
    var gd = "closure_lm_" + (1E6 * Math.random() | 0), hd = {}, id = 0;
    function jd(a, b, c, d, e) {
        if (d && d.once) kd(a, b, c, d, e);
        else if (Array.isArray(b)) for(var f = 0; f < b.length; f++)jd(a, b[f], c, d, e);
        else c = ld(c), a && a[$c] ? md(a, b, c, n(d) ? !!d.capture : !!d, e) : nd(a, b, c, !1, d, e);
    }
    function nd(a, b, c, d, e, f) {
        if (!b) throw Error("Invalid event type");
        var g = n(e) ? !!e.capture : !!e, h = od(a);
        h || (a[gd] = h = new dd(a));
        c = h.add(b, c, d, g, f);
        if (!c.proxy) {
            d = pd();
            c.proxy = d;
            d.src = a;
            d.listener = c;
            if (a.addEventListener) Xc || (e = g), void 0 === e && (e = !1), a.addEventListener(b.toString(), d, e);
            else if (a.attachEvent) a.attachEvent(qd(b.toString()), d);
            else if (a.addListener && a.removeListener) a.addListener(d);
            else throw Error("addEventListener and attachEvent are unavailable.");
            id++;
        }
    }
    function pd() {
        var a = rd, b = Vc ? function(c) {
            return a.call(b.src, b.listener, c);
        } : function(c) {
            c = a.call(b.src, b.listener, c);
            if (!c) return c;
        };
        return b;
    }
    function kd(a, b, c, d, e) {
        if (Array.isArray(b)) for(var f = 0; f < b.length; f++)kd(a, b[f], c, d, e);
        else c = ld(c), a && a[$c] ? sd(a, b, c, n(d) ? !!d.capture : !!d, e) : nd(a, b, c, !0, d, e);
    }
    function G(a, b, c, d, e) {
        if (Array.isArray(b)) for(var f = 0; f < b.length; f++)G(a, b[f], c, d, e);
        else (d = n(d) ? !!d.capture : !!d, c = ld(c), a && a[$c]) ? (a = a.v, b = String(b).toString(), b in a.a && (f = a.a[b], c = ed(f, c, d, e), -1 < c && (cd(f[c]), Array.prototype.splice.call(f, c, 1), 0 == f.length && (delete a.a[b], a.b--)))) : a && (a = od(a)) && (b = a.a[b.toString()], a = -1, b && (a = ed(b, c, d, e)), (c = -1 < a ? b[a] : null) && td(c));
    }
    function td(a) {
        if ("number" !== typeof a && a && !a.va) {
            var b = a.src;
            if (b && b[$c]) fd(b.v, a);
            else {
                var c = a.type, d = a.proxy;
                b.removeEventListener ? b.removeEventListener(c, d, a.capture) : b.detachEvent ? b.detachEvent(qd(c), d) : b.addListener && b.removeListener && b.removeListener(d);
                id--;
                (c = od(b)) ? (fd(c, a), 0 == c.b && (c.src = null, b[gd] = null)) : cd(a);
            }
        }
    }
    function qd(a) {
        return a in hd ? hd[a] : hd[a] = "on" + a;
    }
    function ud(a, b, c, d) {
        var e = !0;
        if (a = od(a)) {
            if (b = a.a[b.toString()]) for(b = b.concat(), a = 0; a < b.length; a++){
                var f = b[a];
                f && f.capture == c && !f.va && (f = vd(f, d), e = e && !1 !== f);
            }
        }
        return e;
    }
    function vd(a, b) {
        var c = a.listener, d = a.Ua || a.src;
        a.Oa && td(a);
        return c.call(d, b);
    }
    function rd(a, b) {
        if (a.va) return !0;
        if (!Vc) {
            if (!b) a: {
                b = [
                    "window",
                    "event"
                ];
                for(var c = l, d = 0; d < b.length; d++)if (c = c[b[d]], null == c) {
                    b = null;
                    break a;
                }
                b = c;
            }
            d = b;
            b = new Yc(d, this);
            c = !0;
            if (!(0 > d.keyCode || void 0 != d.returnValue)) {
                a: {
                    var e = !1;
                    if (0 == d.keyCode) try {
                        d.keyCode = -1;
                        break a;
                    } catch (g) {
                        e = !0;
                    }
                    if (e || void 0 == d.returnValue) d.returnValue = !0;
                }
                d = [];
                for(e = b.b; e; e = e.parentNode)d.push(e);
                a = a.type;
                for(e = d.length - 1; 0 <= e; e--){
                    b.b = d[e];
                    var f = ud(d[e], a, !0, b);
                    c = c && f;
                }
                for(e = 0; e < d.length; e++)b.b = d[e], f = ud(d[e], a, !1, b), c = c && f;
            }
            return c;
        }
        return vd(a, new Yc(b, this));
    }
    function od(a) {
        a = a[gd];
        return a instanceof dd ? a : null;
    }
    var wd = "__closure_events_fn_" + (1E9 * Math.random() >>> 0);
    function ld(a) {
        if (na(a)) return a;
        a[wd] || (a[wd] = function(b) {
            return a.handleEvent(b);
        });
        return a[wd];
    }
    function H() {
        Qc.call(this);
        this.v = new dd(this);
        this.$b = this;
        this.fb = null;
    }
    r(H, Qc);
    H.prototype[$c] = !0;
    H.prototype.addEventListener = function(a, b, c, d) {
        jd(this, a, b, c, d);
    };
    H.prototype.removeEventListener = function(a, b, c, d) {
        G(this, a, b, c, d);
    };
    H.prototype.dispatchEvent = function(a) {
        var b, c = this.fb;
        if (c) for(b = []; c; c = c.fb)b.push(c);
        c = this.$b;
        var d = a.type || a;
        if ("string" === typeof a) a = new F(a, c);
        else if (a instanceof F) a.target = a.target || c;
        else {
            var e = a;
            a = new F(d, c);
            z(a, e);
        }
        e = !0;
        if (b) for(var f = b.length - 1; 0 <= f; f--){
            var g = a.b = b[f];
            e = xd(g, d, !0, a) && e;
        }
        g = a.b = c;
        e = xd(g, d, !0, a) && e;
        e = xd(g, d, !1, a) && e;
        if (b) for(f = 0; f < b.length; f++)g = a.b = b[f], e = xd(g, d, !1, a) && e;
        return e;
    };
    H.prototype.Da = function() {
        H.$a.Da.call(this);
        if (this.v) {
            var a = this.v, b = 0, c;
            for(c in a.a){
                for(var d = a.a[c], e = 0; e < d.length; e++)++b, cd(d[e]);
                delete a.a[c];
                a.b--;
            }
        }
        this.fb = null;
    };
    function md(a, b, c, d, e) {
        a.v.add(String(b), c, !1, d, e);
    }
    function sd(a, b, c, d, e) {
        a.v.add(String(b), c, !0, d, e);
    }
    function xd(a, b, c, d) {
        b = a.v.a[String(b)];
        if (!b) return !0;
        b = b.concat();
        for(var e = !0, f = 0; f < b.length; ++f){
            var g = b[f];
            if (g && !g.va && g.capture == c) {
                var h = g.listener, m = g.Ua || g.src;
                g.Oa && fd(a.v, g);
                e = !1 !== h.call(m, d) && e;
            }
        }
        return e && !d.defaultPrevented;
    }
    function zd(a, b, c) {
        if (na(a)) c && (a = q(a, c));
        else if (a && "function" == typeof a.handleEvent) a = q(a.handleEvent, a);
        else throw Error("Invalid listener argument");
        return 2147483647 < Number(b) ? -1 : l.setTimeout(a, b || 0);
    }
    function Ad(a) {
        var b = null;
        return new C(function(c, d) {
            b = zd(function() {
                c(void 0);
            }, a);
            -1 == b && d(Error("Failed to schedule timer."));
        }).s(function(c) {
            l.clearTimeout(b);
            throw c;
        });
    }
    function Bd(a) {
        if (a.V && "function" == typeof a.V) return a.V();
        if ("string" === typeof a) return a.split("");
        if (ma(a)) {
            for(var b = [], c = a.length, d = 0; d < c; d++)b.push(a[d]);
            return b;
        }
        b = [];
        c = 0;
        for(d in a)b[c++] = a[d];
        return b;
    }
    function Cd(a) {
        if (a.Y && "function" == typeof a.Y) return a.Y();
        if (!a.V || "function" != typeof a.V) {
            if (ma(a) || "string" === typeof a) {
                var b = [];
                a = a.length;
                for(var c = 0; c < a; c++)b.push(c);
                return b;
            }
            b = [];
            c = 0;
            for(var d in a)b[c++] = d;
            return b;
        }
    }
    function Dd(a, b) {
        if (a.forEach && "function" == typeof a.forEach) a.forEach(b, void 0);
        else if (ma(a) || "string" === typeof a) w(a, b, void 0);
        else for(var c = Cd(a), d = Bd(a), e = d.length, f = 0; f < e; f++)b.call(void 0, d[f], c && c[f], a);
    }
    function Ed(a, b) {
        this.b = {};
        this.a = [];
        this.c = 0;
        var c = arguments.length;
        if (1 < c) {
            if (c % 2) throw Error("Uneven number of arguments");
            for(var d = 0; d < c; d += 2)this.set(arguments[d], arguments[d + 1]);
        } else if (a) {
            if (a instanceof Ed) for(c = a.Y(), d = 0; d < c.length; d++)this.set(c[d], a.get(c[d]));
            else for(d in a)this.set(d, a[d]);
        }
    }
    k = Ed.prototype;
    k.V = function() {
        Fd(this);
        for(var a = [], b = 0; b < this.a.length; b++)a.push(this.b[this.a[b]]);
        return a;
    };
    k.Y = function() {
        Fd(this);
        return this.a.concat();
    };
    k.clear = function() {
        this.b = {};
        this.c = this.a.length = 0;
    };
    function Fd(a) {
        if (a.c != a.a.length) {
            for(var b = 0, c = 0; b < a.a.length;){
                var d = a.a[b];
                Gd(a.b, d) && (a.a[c++] = d);
                b++;
            }
            a.a.length = c;
        }
        if (a.c != a.a.length) {
            var e = {};
            for(c = b = 0; b < a.a.length;)d = a.a[b], Gd(e, d) || (a.a[c++] = d, e[d] = 1), b++;
            a.a.length = c;
        }
    }
    k.get = function(a, b) {
        return Gd(this.b, a) ? this.b[a] : b;
    };
    k.set = function(a, b) {
        Gd(this.b, a) || (this.c++, this.a.push(a));
        this.b[a] = b;
    };
    k.forEach = function(a, b) {
        for(var c = this.Y(), d = 0; d < c.length; d++){
            var e = c[d], f = this.get(e);
            a.call(b, f, e, this);
        }
    };
    function Gd(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }
    var Hd = /^(?:([^:/?#.]+):)?(?:\/\/(?:([^/?#]*)@)?([^/#?]*?)(?::([0-9]+))?(?=[/\\#?]|$))?([^?#]+)?(?:\?([^#]*))?(?:#([\s\S]*))?$/;
    function Id(a, b) {
        if (a) {
            a = a.split("&");
            for(var c = 0; c < a.length; c++){
                var d = a[c].indexOf("="), e = null;
                if (0 <= d) {
                    var f = a[c].substring(0, d);
                    e = a[c].substring(d + 1);
                } else f = a[c];
                b(f, e ? decodeURIComponent(e.replace(/\+/g, " ")) : "");
            }
        }
    }
    function Jd(a, b) {
        this.a = this.l = this.f = "";
        this.g = null;
        this.h = this.c = "";
        this.i = !1;
        var c;
        a instanceof Jd ? (this.i = void 0 !== b ? b : a.i, Kd(this, a.f), this.l = a.l, this.a = a.a, Ld(this, a.g), this.c = a.c, Md(this, Nd(a.b)), this.h = a.h) : a && (c = String(a).match(Hd)) ? (this.i = !!b, Kd(this, c[1] || "", !0), this.l = Od(c[2] || ""), this.a = Od(c[3] || "", !0), Ld(this, c[4]), this.c = Od(c[5] || "", !0), Md(this, c[6] || "", !0), this.h = Od(c[7] || "")) : (this.i = !!b, this.b = new Pd(null, this.i));
    }
    Jd.prototype.toString = function() {
        var a = [], b = this.f;
        b && a.push(Qd(b, Rd, !0), ":");
        var c = this.a;
        if (c || "file" == b) a.push("//"), (b = this.l) && a.push(Qd(b, Rd, !0), "@"), a.push(encodeURIComponent(String(c)).replace(/%25([0-9a-fA-F]{2})/g, "%$1")), c = this.g, null != c && a.push(":", String(c));
        if (c = this.c) this.a && "/" != c.charAt(0) && a.push("/"), a.push(Qd(c, "/" == c.charAt(0) ? Sd : Td, !0));
        (c = this.b.toString()) && a.push("?", c);
        (c = this.h) && a.push("#", Qd(c, Ud));
        return a.join("");
    };
    Jd.prototype.resolve = function(a) {
        var b = new Jd(this), c = !!a.f;
        c ? Kd(b, a.f) : c = !!a.l;
        c ? b.l = a.l : c = !!a.a;
        c ? b.a = a.a : c = null != a.g;
        var d = a.c;
        if (c) Ld(b, a.g);
        else if (c = !!a.c) {
            if ("/" != d.charAt(0)) {
                if (this.a && !this.c) d = "/" + d;
                else {
                    var e = b.c.lastIndexOf("/");
                    -1 != e && (d = b.c.substr(0, e + 1) + d);
                }
            }
            e = d;
            if (".." == e || "." == e) d = "";
            else if (x(e, "./") || x(e, "/.")) {
                d = 0 == e.lastIndexOf("/", 0);
                e = e.split("/");
                for(var f = [], g = 0; g < e.length;){
                    var h = e[g++];
                    "." == h ? d && g == e.length && f.push("") : ".." == h ? ((1 < f.length || 1 == f.length && "" != f[0]) && f.pop(), d && g == e.length && f.push("")) : (f.push(h), d = !0);
                }
                d = f.join("/");
            } else d = e;
        }
        c ? b.c = d : c = "" !== a.b.toString();
        c ? Md(b, Nd(a.b)) : c = !!a.h;
        c && (b.h = a.h);
        return b;
    };
    function Kd(a, b, c) {
        a.f = c ? Od(b, !0) : b;
        a.f && (a.f = a.f.replace(/:$/, ""));
    }
    function Ld(a, b) {
        if (b) {
            b = Number(b);
            if (isNaN(b) || 0 > b) throw Error("Bad port number " + b);
            a.g = b;
        } else a.g = null;
    }
    function Md(a, b, c) {
        b instanceof Pd ? (a.b = b, Vd(a.b, a.i)) : (c || (b = Qd(b, Wd)), a.b = new Pd(b, a.i));
    }
    function I(a, b, c) {
        a.b.set(b, c);
    }
    function Xd(a, b) {
        return a.b.get(b);
    }
    function J(a) {
        return a instanceof Jd ? new Jd(a) : new Jd(a, void 0);
    }
    function Yd(a, b, c, d) {
        var e = new Jd(null, void 0);
        a && Kd(e, a);
        b && (e.a = b);
        c && Ld(e, c);
        d && (e.c = d);
        return e;
    }
    function Od(a, b) {
        return a ? b ? decodeURI(a.replace(/%25/g, "%2525")) : decodeURIComponent(a) : "";
    }
    function Qd(a, b, c) {
        return "string" === typeof a ? (a = encodeURI(a).replace(b, Zd), c && (a = a.replace(/%25([0-9a-fA-F]{2})/g, "%$1")), a) : null;
    }
    function Zd(a) {
        a = a.charCodeAt(0);
        return "%" + (a >> 4 & 15).toString(16) + (a & 15).toString(16);
    }
    var Rd = /[#\/\?@]/g, Td = /[#\?:]/g, Sd = /[#\?]/g, Wd = /[#\?@]/g, Ud = /#/g;
    function Pd(a, b) {
        this.b = this.a = null;
        this.c = a || null;
        this.f = !!b;
    }
    function $d(a) {
        a.a || (a.a = new Ed, a.b = 0, a.c && Id(a.c, function(b, c) {
            a.add(decodeURIComponent(b.replace(/\+/g, " ")), c);
        }));
    }
    function ae(a) {
        var b = Cd(a);
        if ("undefined" == typeof b) throw Error("Keys are undefined");
        var c = new Pd(null, void 0);
        a = Bd(a);
        for(var d = 0; d < b.length; d++){
            var e = b[d], f = a[d];
            Array.isArray(f) ? be(c, e, f) : c.add(e, f);
        }
        return c;
    }
    k = Pd.prototype;
    k.add = function(a, b) {
        $d(this);
        this.c = null;
        a = ce(this, a);
        var c = this.a.get(a);
        c || this.a.set(a, c = []);
        c.push(b);
        this.b += 1;
        return this;
    };
    function de(a, b) {
        $d(a);
        b = ce(a, b);
        Gd(a.a.b, b) && (a.c = null, a.b -= a.a.get(b).length, a = a.a, Gd(a.b, b) && (delete a.b[b], a.c--, a.a.length > 2 * a.c && Fd(a)));
    }
    k.clear = function() {
        this.a = this.c = null;
        this.b = 0;
    };
    function ee(a, b) {
        $d(a);
        b = ce(a, b);
        return Gd(a.a.b, b);
    }
    k.forEach = function(a, b) {
        $d(this);
        this.a.forEach(function(c, d) {
            w(c, function(e) {
                a.call(b, e, d, this);
            }, this);
        }, this);
    };
    k.Y = function() {
        $d(this);
        for(var a = this.a.V(), b = this.a.Y(), c = [], d = 0; d < b.length; d++)for(var e = a[d], f = 0; f < e.length; f++)c.push(b[d]);
        return c;
    };
    k.V = function(a) {
        $d(this);
        var b = [];
        if ("string" === typeof a) ee(this, a) && (b = Wa(b, this.a.get(ce(this, a))));
        else {
            a = this.a.V();
            for(var c = 0; c < a.length; c++)b = Wa(b, a[c]);
        }
        return b;
    };
    k.set = function(a, b) {
        $d(this);
        this.c = null;
        a = ce(this, a);
        ee(this, a) && (this.b -= this.a.get(a).length);
        this.a.set(a, [
            b
        ]);
        this.b += 1;
        return this;
    };
    k.get = function(a, b) {
        if (!a) return b;
        a = this.V(a);
        return 0 < a.length ? String(a[0]) : b;
    };
    function be(a, b, c) {
        de(a, b);
        0 < c.length && (a.c = null, a.a.set(ce(a, b), Xa(c)), a.b += c.length);
    }
    k.toString = function() {
        if (this.c) return this.c;
        if (!this.a) return "";
        for(var a = [], b = this.a.Y(), c = 0; c < b.length; c++){
            var d = b[c], e = encodeURIComponent(String(d));
            d = this.V(d);
            for(var f = 0; f < d.length; f++){
                var g = e;
                "" !== d[f] && (g += "=" + encodeURIComponent(String(d[f])));
                a.push(g);
            }
        }
        return this.c = a.join("&");
    };
    function Nd(a) {
        var b = new Pd;
        b.c = a.c;
        a.a && (b.a = new Ed(a.a), b.b = a.b);
        return b;
    }
    function ce(a, b) {
        b = String(b);
        a.f && (b = b.toLowerCase());
        return b;
    }
    function Vd(a, b) {
        b && !a.f && ($d(a), a.c = null, a.a.forEach(function(c, d) {
            var e = d.toLowerCase();
            d != e && (de(this, d), be(this, e, c));
        }, a));
        a.f = b;
    }
    function fe(a) {
        var b = [];
        ge(new he, a, b);
        return b.join("");
    }
    function he() {}
    function ge(a, b, c) {
        if (null == b) c.push("null");
        else {
            if ("object" == typeof b) {
                if (Array.isArray(b)) {
                    var d = b;
                    b = d.length;
                    c.push("[");
                    for(var e = "", f = 0; f < b; f++)c.push(e), ge(a, d[f], c), e = ",";
                    c.push("]");
                    return;
                }
                if (b instanceof String || b instanceof Number || b instanceof Boolean) b = b.valueOf();
                else {
                    c.push("{");
                    e = "";
                    for(d in b)Object.prototype.hasOwnProperty.call(b, d) && (f = b[d], "function" != typeof f && (c.push(e), ie(d, c), c.push(":"), ge(a, f, c), e = ","));
                    c.push("}");
                    return;
                }
            }
            switch(typeof b){
                case "string":
                    ie(b, c);
                    break;
                case "number":
                    c.push(isFinite(b) && !isNaN(b) ? String(b) : "null");
                    break;
                case "boolean":
                    c.push(String(b));
                    break;
                case "function":
                    c.push("null");
                    break;
                default:
                    throw Error("Unknown type: " + typeof b);
            }
        }
    }
    var je = {
        '"': '\\"',
        "\\": "\\\\",
        "/": "\\/",
        "\b": "\\b",
        "\f": "\\f",
        "\n": "\\n",
        "\r": "\\r",
        "	": "\\t",
        "\v": "\\u000b"
    }, ke = /\uffff/.test("\uFFFF") ? /[\\"\x00-\x1f\x7f-\uffff]/g : /[\\"\x00-\x1f\x7f-\xff]/g;
    function ie(a, b) {
        b.push('"', a.replace(ke, function(c) {
            var d = je[c];
            d || (d = "\\u" + (c.charCodeAt(0) | 65536).toString(16).substr(1), je[c] = d);
            return d;
        }), '"');
    }
    function le() {
        var a = K();
        return Tb && !!dc && 11 == dc || /Edge\/\d+/.test(a);
    }
    function me() {
        return l.window && l.window.location.href || self && self.location && self.location.href || "";
    }
    function ne(a, b) {
        b = b || l.window;
        var c = "about:blank";
        a && (c = Db(Fb(a)));
        b.location.href = c;
    }
    function oe(a, b) {
        var c = [], d;
        for(d in a)d in b ? typeof a[d] != typeof b[d] ? c.push(d) : "object" == typeof a[d] && null != a[d] && null != b[d] ? 0 < oe(a[d], b[d]).length && c.push(d) : a[d] !== b[d] && c.push(d) : c.push(d);
        for(d in b)d in a || c.push(d);
        return c;
    }
    function pe() {
        var a = K();
        a = qe(a) != re ? null : (a = a.match(/\sChrome\/(\d+)/i)) && 2 == a.length ? parseInt(a[1], 10) : null;
        return a && 30 > a ? !1 : !Tb || !dc || 9 < dc;
    }
    function se(a) {
        a = (a || K()).toLowerCase();
        return a.match(/android/) || a.match(/webos/) || a.match(/iphone|ipad|ipod/) || a.match(/blackberry/) || a.match(/windows phone/) || a.match(/iemobile/) ? !0 : !1;
    }
    function te(a) {
        a = a || l.window;
        try {
            a.close();
        } catch (b) {}
    }
    function ue(a, b, c) {
        var d = Math.floor(1E9 * Math.random()).toString();
        b = b || 500;
        c = c || 600;
        var e = (window.screen.availHeight - c) / 2, f = (window.screen.availWidth - b) / 2;
        b = {
            width: b,
            height: c,
            top: 0 < e ? e : 0,
            left: 0 < f ? f : 0,
            location: !0,
            resizable: !0,
            statusbar: !0,
            toolbar: !1
        };
        c = K().toLowerCase();
        d && (b.target = d, x(c, "crios/") && (b.target = "_blank"));
        qe(K()) == ve && (a = a || "http://localhost", b.scrollbars = !0);
        c = a || "";
        (a = b) || (a = {});
        d = window;
        b = c instanceof Ab ? c : Fb("undefined" != typeof c.href ? c.href : String(c));
        c = a.target || c.target;
        e = [];
        for(g in a)switch(g){
            case "width":
            case "height":
            case "top":
            case "left":
                e.push(g + "=" + a[g]);
                break;
            case "target":
            case "noopener":
            case "noreferrer":
                break;
            default:
                e.push(g + "=" + (a[g] ? 1 : 0));
        }
        var g = e.join(",");
        if ((y("iPhone") && !y("iPod") && !y("iPad") || y("iPad") || y("iPod")) && d.navigator && d.navigator.standalone && c && "_self" != c) g = jc(document, "A"), nb(g, "HTMLAnchorElement"), b instanceof Ab || b instanceof Ab || (b = "object" == typeof b && b.sa ? b.ra() : String(b), Eb.test(b) || (b = "about:invalid#zClosurez"), b = new Ab(Bb, b)), g.href = Db(b), g.setAttribute("target", c), a.noreferrer && g.setAttribute("rel", "noreferrer"), a = document.createEvent("MouseEvent"), a.initMouseEvent("click", !0, !0, d, 1), g.dispatchEvent(a), g = {};
        else if (a.noreferrer) {
            if (g = d.open("", c, g), a = Db(b), g && (Vb && x(a, ";") && (a = "'" + a.replace(/'/g, "%27") + "'"), g.opener = null, a = Jb('<meta name="referrer" content="no-referrer"><meta http-equiv="refresh" content="0; url=' + Ob(a) + '">'), d = g.document)) d.write(Ib(a)), d.close();
        } else (g = d.open(Db(b), c, g)) && a.noopener && (g.opener = null);
        if (g) try {
            g.focus();
        } catch (h) {}
        return g;
    }
    function we(a) {
        return new C(function(b) {
            function c() {
                Ad(2E3).then(function() {
                    if (!a || a.closed) b();
                    else return c();
                });
            }
            return c();
        });
    }
    var xe = /^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/, ye = /^[^@]+@[^@]+$/;
    function ze() {
        var a = null;
        return new C(function(b) {
            "complete" == l.document.readyState ? b() : (a = function() {
                b();
            }, kd(window, "load", a));
        }).s(function(b) {
            G(window, "load", a);
            throw b;
        });
    }
    function Ae() {
        return Be(void 0) ? ze().then(function() {
            return new C(function(a, b) {
                var c = l.document, d = setTimeout(function() {
                    b(Error("Cordova framework is not ready."));
                }, 1E3);
                c.addEventListener("deviceready", function() {
                    clearTimeout(d);
                    a();
                }, !1);
            });
        }) : E(Error("Cordova must run in an Android or iOS file scheme."));
    }
    function Be(a) {
        a = a || K();
        return !("file:" !== Ce() && "ionic:" !== Ce() || !a.toLowerCase().match(/iphone|ipad|ipod|android/));
    }
    function De() {
        var a = l.window;
        try {
            return !(!a || a == a.top);
        } catch (b) {
            return !1;
        }
    }
    function Ee() {
        return "undefined" !== typeof l.WorkerGlobalScope && "function" === typeof l.importScripts;
    }
    function Fe() {
        return firebase.INTERNAL.hasOwnProperty("reactNative") ? "ReactNative" : firebase.INTERNAL.hasOwnProperty("node") ? "Node" : Ee() ? "Worker" : "Browser";
    }
    function Ge() {
        var a = Fe();
        return "ReactNative" === a || "Node" === a;
    }
    function He() {
        for(var a = 50, b = []; 0 < a;)b.push("1234567890abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ".charAt(Math.floor(62 * Math.random()))), a--;
        return b.join("");
    }
    var ve = "Firefox", re = "Chrome";
    function qe(a) {
        var b = a.toLowerCase();
        if (x(b, "opera/") || x(b, "opr/") || x(b, "opios/")) return "Opera";
        if (x(b, "iemobile")) return "IEMobile";
        if (x(b, "msie") || x(b, "trident/")) return "IE";
        if (x(b, "edge/")) return "Edge";
        if (x(b, "firefox/")) return ve;
        if (x(b, "silk/")) return "Silk";
        if (x(b, "blackberry")) return "Blackberry";
        if (x(b, "webos")) return "Webos";
        if (!x(b, "safari/") || x(b, "chrome/") || x(b, "crios/") || x(b, "android")) {
            if (!x(b, "chrome/") && !x(b, "crios/") || x(b, "edge/")) {
                if (x(b, "android")) return "Android";
                if ((a = a.match(/([a-zA-Z\d\.]+)\/[a-zA-Z\d\.]*$/)) && 2 == a.length) return a[1];
            } else return re;
        } else return "Safari";
        return "Other";
    }
    var Ie = {
        ld: "FirebaseCore-web",
        nd: "FirebaseUI-web"
    };
    function Je(a, b) {
        b = b || [];
        var c = [], d = {}, e;
        for(e in Ie)d[Ie[e]] = !0;
        for(e = 0; e < b.length; e++)"undefined" !== typeof d[b[e]] && (delete d[b[e]], c.push(b[e]));
        c.sort();
        b = c;
        b.length || (b = [
            "FirebaseCore-web"
        ]);
        c = Fe();
        "Browser" === c ? (d = K(), c = qe(d)) : "Worker" === c && (d = K(), c = qe(d) + "-" + c);
        return c + "/JsCore/" + a + "/" + b.join(",");
    }
    function K() {
        return l.navigator && l.navigator.userAgent || "";
    }
    function L(a, b) {
        a = a.split(".");
        b = b || l;
        for(var c = 0; c < a.length && "object" == typeof b && null != b; c++)b = b[a[c]];
        c != a.length && (b = void 0);
        return b;
    }
    function Ke() {
        try {
            var a = l.localStorage, b = Le();
            if (a) return a.setItem(b, "1"), a.removeItem(b), le() ? !!l.indexedDB : !0;
        } catch (c) {
            return Ee() && !!l.indexedDB;
        }
        return !1;
    }
    function Me() {
        return (Ne() || "chrome-extension:" === Ce() || Be()) && !Ge() && Ke() && !Ee();
    }
    function Ne() {
        return "http:" === Ce() || "https:" === Ce();
    }
    function Ce() {
        return l.location && l.location.protocol || null;
    }
    function Oe(a) {
        a = a || K();
        return se(a) || qe(a) == ve ? !1 : !0;
    }
    function Pe(a) {
        return "undefined" === typeof a ? null : fe(a);
    }
    function Qe(a) {
        var b = {}, c;
        for(c in a)a.hasOwnProperty(c) && null !== a[c] && void 0 !== a[c] && (b[c] = a[c]);
        return b;
    }
    function Re(a) {
        if (null !== a) return JSON.parse(a);
    }
    function Le(a) {
        return a ? a : Math.floor(1E9 * Math.random()).toString();
    }
    function Se(a) {
        a = a || K();
        return "Safari" == qe(a) || a.toLowerCase().match(/iphone|ipad|ipod/) ? !1 : !0;
    }
    function Te() {
        var a = l.___jsl;
        if (a && a.H) {
            for(var b in a.H)if (a.H[b].r = a.H[b].r || [], a.H[b].L = a.H[b].L || [], a.H[b].r = a.H[b].L.concat(), a.CP) for(var c = 0; c < a.CP.length; c++)a.CP[c] = null;
        }
    }
    function Ue(a, b) {
        if (a > b) throw Error("Short delay should be less than long delay!");
        this.a = a;
        this.c = b;
        a = K();
        b = Fe();
        this.b = se(a) || "ReactNative" === b;
    }
    Ue.prototype.get = function() {
        var a = l.navigator;
        return (a && "boolean" === typeof a.onLine && (Ne() || "chrome-extension:" === Ce() || "undefined" !== typeof a.connection) ? a.onLine : 1) ? this.b ? this.c : this.a : Math.min(5E3, this.a);
    };
    function Ve() {
        var a = l.document;
        return a && "undefined" !== typeof a.visibilityState ? "visible" == a.visibilityState : !0;
    }
    function We() {
        var a = l.document, b = null;
        return Ve() || !a ? D() : new C(function(c) {
            b = function() {
                Ve() && (a.removeEventListener("visibilitychange", b, !1), c());
            };
            a.addEventListener("visibilitychange", b, !1);
        }).s(function(c) {
            a.removeEventListener("visibilitychange", b, !1);
            throw c;
        });
    }
    function Xe(a) {
        "undefined" !== typeof console && "function" === typeof console.warn && console.warn(a);
    }
    function Ye(a) {
        try {
            var b = new Date(parseInt(a, 10));
            if (!isNaN(b.getTime()) && !/[^0-9]/.test(a)) return b.toUTCString();
        } catch (c) {}
        return null;
    }
    function Ze() {
        return !(!L("fireauth.oauthhelper", l) && !L("fireauth.iframe", l));
    }
    function $e() {
        var a = l.navigator;
        return a && a.serviceWorker && a.serviceWorker.controller || null;
    }
    function af() {
        var a = l.navigator;
        return a && a.serviceWorker ? D().then(function() {
            return a.serviceWorker.ready;
        }).then(function(b) {
            return b.active || null;
        }).s(function() {
            return null;
        }) : D(null);
    }
    var bf = {};
    function cf(a) {
        bf[a] || (bf[a] = !0, Xe(a));
    }
    var df;
    try {
        var ef = {};
        Object.defineProperty(ef, "abcd", {
            configurable: !0,
            enumerable: !0,
            value: 1
        });
        Object.defineProperty(ef, "abcd", {
            configurable: !0,
            enumerable: !0,
            value: 2
        });
        df = 2 == ef.abcd;
    } catch (a) {
        df = !1;
    }
    function M(a, b, c) {
        df ? Object.defineProperty(a, b, {
            configurable: !0,
            enumerable: !0,
            value: c
        }) : a[b] = c;
    }
    function N(a, b) {
        if (b) for(var c in b)b.hasOwnProperty(c) && M(a, c, b[c]);
    }
    function ff(a) {
        var b = {};
        N(b, a);
        return b;
    }
    function gf(a) {
        var b = {}, c;
        for(c in a)a.hasOwnProperty(c) && (b[c] = a[c]);
        return b;
    }
    function hf(a, b) {
        if (!b || !b.length) return !0;
        if (!a) return !1;
        for(var c = 0; c < b.length; c++){
            var d = a[b[c]];
            if (void 0 === d || null === d || "" === d) return !1;
        }
        return !0;
    }
    function jf(a) {
        var b = a;
        if ("object" == typeof a && null != a) {
            b = "length" in a ? [] : {};
            for(var c in a)M(b, c, jf(a[c]));
        }
        return b;
    }
    function kf(a) {
        var b = a && (a[lf] ? "phone" : null);
        if (b && a && a[mf]) {
            M(this, "uid", a[mf]);
            M(this, "displayName", a[nf] || null);
            var c = null;
            a[of] && (c = new Date(a[of]).toUTCString());
            M(this, "enrollmentTime", c);
            M(this, "factorId", b);
        } else throw new t("internal-error", "Internal assert: invalid MultiFactorInfo object");
    }
    kf.prototype.w = function() {
        return {
            uid: this.uid,
            displayName: this.displayName,
            factorId: this.factorId,
            enrollmentTime: this.enrollmentTime
        };
    };
    function pf(a) {
        try {
            var b = new qf(a);
        } catch (c) {
            b = null;
        }
        return b;
    }
    var nf = "displayName", of = "enrolledAt", mf = "mfaEnrollmentId", lf = "phoneInfo";
    function qf(a) {
        kf.call(this, a);
        M(this, "phoneNumber", a[lf]);
    }
    r(qf, kf);
    qf.prototype.w = function() {
        var a = qf.$a.w.call(this);
        a.phoneNumber = this.phoneNumber;
        return a;
    };
    function rf(a) {
        var b = {}, c = a[sf], d = a[tf], e = a[uf];
        a = pf(a[vf]);
        if (!e || e != wf && e != xf && !c || e == xf && !d || e == yf && !a) throw Error("Invalid checkActionCode response!");
        e == xf ? (b[zf] = c || null, b[Af] = c || null, b[Bf] = d) : (b[zf] = d || null, b[Af] = d || null, b[Bf] = c || null);
        b[Cf] = a || null;
        M(this, Df, e);
        M(this, Ef, jf(b));
    }
    var yf = "REVERT_SECOND_FACTOR_ADDITION", wf = "EMAIL_SIGNIN", xf = "VERIFY_AND_CHANGE_EMAIL", sf = "email", vf = "mfaInfo", tf = "newEmail", uf = "requestType", Bf = "email", zf = "fromEmail", Cf = "multiFactorInfo", Af = "previousEmail", Ef = "data", Df = "operation";
    function Ff(a) {
        a = J(a);
        var b = Xd(a, Gf) || null, c = Xd(a, Hf) || null, d = Xd(a, If) || null;
        d = d ? Jf[d] || null : null;
        if (!b || !c || !d) throw new t("argument-error", Gf + ", " + Hf + "and " + If + " are required in a valid action code URL.");
        N(this, {
            apiKey: b,
            operation: d,
            code: c,
            continueUrl: Xd(a, Kf) || null,
            languageCode: Xd(a, Lf) || null,
            tenantId: Xd(a, Mf) || null
        });
    }
    var Gf = "apiKey", Hf = "oobCode", Kf = "continueUrl", Lf = "languageCode", If = "mode", Mf = "tenantId", Jf = {
        recoverEmail: "RECOVER_EMAIL",
        resetPassword: "PASSWORD_RESET",
        revertSecondFactorAddition: yf,
        signIn: wf,
        verifyAndChangeEmail: xf,
        verifyEmail: "VERIFY_EMAIL"
    };
    function Nf(a) {
        try {
            return new Ff(a);
        } catch (b) {
            return null;
        }
    }
    function Of(a) {
        var b = a[Pf];
        if ("undefined" === typeof b) throw new t("missing-continue-uri");
        if ("string" !== typeof b || "string" === typeof b && !b.length) throw new t("invalid-continue-uri");
        this.h = b;
        this.b = this.a = null;
        this.g = !1;
        var c = a[Qf];
        if (c && "object" === typeof c) {
            b = c[Rf];
            var d = c[Sf];
            c = c[Tf];
            if ("string" === typeof b && b.length) {
                this.a = b;
                if ("undefined" !== typeof d && "boolean" !== typeof d) throw new t("argument-error", Sf + " property must be a boolean when specified.");
                this.g = !!d;
                if ("undefined" !== typeof c && ("string" !== typeof c || "string" === typeof c && !c.length)) throw new t("argument-error", Tf + " property must be a non empty string when specified.");
                this.b = c || null;
            } else {
                if ("undefined" !== typeof b) throw new t("argument-error", Rf + " property must be a non empty string when specified.");
                if ("undefined" !== typeof d || "undefined" !== typeof c) throw new t("missing-android-pkg-name");
            }
        } else if ("undefined" !== typeof c) throw new t("argument-error", Qf + " property must be a non null object when specified.");
        this.f = null;
        if ((b = a[Uf]) && "object" === typeof b) {
            if (b = b[Vf], "string" === typeof b && b.length) this.f = b;
            else {
                if ("undefined" !== typeof b) throw new t("argument-error", Vf + " property must be a non empty string when specified.");
            }
        } else if ("undefined" !== typeof b) throw new t("argument-error", Uf + " property must be a non null object when specified.");
        b = a[Wf];
        if ("undefined" !== typeof b && "boolean" !== typeof b) throw new t("argument-error", Wf + " property must be a boolean when specified.");
        this.c = !!b;
        a = a[Xf];
        if ("undefined" !== typeof a && ("string" !== typeof a || "string" === typeof a && !a.length)) throw new t("argument-error", Xf + " property must be a non empty string when specified.");
        this.i = a || null;
    }
    var Qf = "android", Xf = "dynamicLinkDomain", Wf = "handleCodeInApp", Uf = "iOS", Pf = "url", Sf = "installApp", Tf = "minimumVersion", Rf = "packageName", Vf = "bundleId";
    function Yf(a) {
        var b = {};
        b.continueUrl = a.h;
        b.canHandleCodeInApp = a.c;
        if (b.androidPackageName = a.a) b.androidMinimumVersion = a.b, b.androidInstallApp = a.g;
        b.iOSBundleId = a.f;
        b.dynamicLinkDomain = a.i;
        for(var c in b)null === b[c] && delete b[c];
        return b;
    }
    function Zf(a) {
        return Pa(a, function(b) {
            b = b.toString(16);
            return 1 < b.length ? b : "0" + b;
        }).join("");
    }
    var $f = null;
    function ag(a) {
        var b = "";
        bg(a, function(c) {
            b += String.fromCharCode(c);
        });
        return b;
    }
    function bg(a, b) {
        function c(m) {
            for(; d < a.length;){
                var p = a.charAt(d++), v = $f[p];
                if (null != v) return v;
                if (!/^[\s\xa0]*$/.test(p)) throw Error("Unknown base64 encoding at char: " + p);
            }
            return m;
        }
        cg();
        for(var d = 0;;){
            var e = c(-1), f = c(0), g = c(64), h = c(64);
            if (64 === h && -1 === e) break;
            b(e << 2 | f >> 4);
            64 != g && (b(f << 4 & 240 | g >> 2), 64 != h && b(g << 6 & 192 | h));
        }
    }
    function cg() {
        if (!$f) {
            $f = {};
            for(var a = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789".split(""), b = [
                "+/=",
                "+/",
                "-_=",
                "-_.",
                "-_"
            ], c = 0; 5 > c; c++)for(var d = a.concat(b[c].split("")), e = 0; e < d.length; e++){
                var f = d[e];
                void 0 === $f[f] && ($f[f] = e);
            }
        }
    }
    function dg(a) {
        var b = eg(a);
        if (!(b && b.sub && b.iss && b.aud && b.exp)) throw Error("Invalid JWT");
        this.g = a;
        this.c = b.exp;
        this.h = b.sub;
        ua();
        this.a = b.provider_id || b.firebase && b.firebase.sign_in_provider || null;
        this.f = b.firebase && b.firebase.tenant || null;
        this.b = !!b.is_anonymous || "anonymous" == this.a;
    }
    dg.prototype.S = function() {
        return this.f;
    };
    dg.prototype.i = function() {
        return this.b;
    };
    dg.prototype.toString = function() {
        return this.g;
    };
    function fg(a) {
        try {
            return new dg(a);
        } catch (b) {
            return null;
        }
    }
    function eg(a) {
        if (!a) return null;
        a = a.split(".");
        if (3 != a.length) return null;
        a = a[1];
        for(var b = (4 - a.length % 4) % 4, c = 0; c < b; c++)a += ".";
        try {
            return JSON.parse(ag(a));
        } catch (d) {}
        return null;
    }
    var gg = "oauth_consumer_key oauth_nonce oauth_signature oauth_signature_method oauth_timestamp oauth_token oauth_version".split(" "), hg = [
        "client_id",
        "response_type",
        "scope",
        "redirect_uri",
        "state"
    ], ig = {
        md: {
            Ja: "locale",
            ua: 700,
            ta: 600,
            fa: "facebook.com",
            Wa: hg
        },
        od: {
            Ja: null,
            ua: 500,
            ta: 750,
            fa: "github.com",
            Wa: hg
        },
        pd: {
            Ja: "hl",
            ua: 515,
            ta: 680,
            fa: "google.com",
            Wa: hg
        },
        vd: {
            Ja: "lang",
            ua: 485,
            ta: 705,
            fa: "twitter.com",
            Wa: gg
        },
        jd: {
            Ja: "locale",
            ua: 640,
            ta: 600,
            fa: "apple.com",
            Wa: []
        }
    };
    function jg(a) {
        for(var b in ig)if (ig[b].fa == a) return ig[b];
        return null;
    }
    function kg(a) {
        var b = {};
        b["facebook.com"] = lg;
        b["google.com"] = mg;
        b["github.com"] = ng;
        b["twitter.com"] = og;
        var c = a && a[pg];
        try {
            if (c) return b[c] ? new b[c](a) : new qg(a);
            if ("undefined" !== typeof a[rg]) return new sg(a);
        } catch (d) {}
        return null;
    }
    var rg = "idToken", pg = "providerId";
    function sg(a) {
        var b = a[pg];
        if (!b && a[rg]) {
            var c = fg(a[rg]);
            c && c.a && (b = c.a);
        }
        if (!b) throw Error("Invalid additional user info!");
        if ("anonymous" == b || "custom" == b) b = null;
        c = !1;
        "undefined" !== typeof a.isNewUser ? c = !!a.isNewUser : "identitytoolkit#SignupNewUserResponse" === a.kind && (c = !0);
        M(this, "providerId", b);
        M(this, "isNewUser", c);
    }
    function qg(a) {
        sg.call(this, a);
        a = Re(a.rawUserInfo || "{}");
        M(this, "profile", jf(a || {}));
    }
    r(qg, sg);
    function lg(a) {
        qg.call(this, a);
        if ("facebook.com" != this.providerId) throw Error("Invalid provider ID!");
    }
    r(lg, qg);
    function ng(a) {
        qg.call(this, a);
        if ("github.com" != this.providerId) throw Error("Invalid provider ID!");
        M(this, "username", this.profile && this.profile.login || null);
    }
    r(ng, qg);
    function mg(a) {
        qg.call(this, a);
        if ("google.com" != this.providerId) throw Error("Invalid provider ID!");
    }
    r(mg, qg);
    function og(a) {
        qg.call(this, a);
        if ("twitter.com" != this.providerId) throw Error("Invalid provider ID!");
        M(this, "username", a.screenName || null);
    }
    r(og, qg);
    function tg(a) {
        var b = J(a), c = Xd(b, "link"), d = Xd(J(c), "link");
        b = Xd(b, "deep_link_id");
        return Xd(J(b), "link") || b || d || c || a;
    }
    function ug(a, b) {
        if (!a && !b) throw new t("internal-error", "Internal assert: no raw session string available");
        if (a && b) throw new t("internal-error", "Internal assert: unable to determine the session type");
        this.a = a || null;
        this.b = b || null;
        this.type = this.a ? vg : wg;
    }
    var vg = "enroll", wg = "signin";
    ug.prototype.Ha = function() {
        return this.a ? D(this.a) : D(this.b);
    };
    ug.prototype.w = function() {
        return this.type == vg ? {
            multiFactorSession: {
                idToken: this.a
            }
        } : {
            multiFactorSession: {
                pendingCredential: this.b
            }
        };
    };
    function xg() {}
    xg.prototype.ja = function() {};
    xg.prototype.b = function() {};
    xg.prototype.c = function() {};
    xg.prototype.w = function() {};
    function yg(a, b) {
        return a.then(function(c) {
            if (c[zg]) {
                var d = fg(c[zg]);
                if (!d || b != d.h) throw new t("user-mismatch");
                return c;
            }
            throw new t("user-mismatch");
        }).s(function(c) {
            throw c && c.code && c.code == va + "user-not-found" ? new t("user-mismatch") : c;
        });
    }
    function Ag(a, b) {
        if (b) this.a = b;
        else throw new t("internal-error", "failed to construct a credential");
        M(this, "providerId", a);
        M(this, "signInMethod", a);
    }
    Ag.prototype.ja = function(a) {
        return Bg(a, Cg(this));
    };
    Ag.prototype.b = function(a, b) {
        var c = Cg(this);
        c.idToken = b;
        return Dg(a, c);
    };
    Ag.prototype.c = function(a, b) {
        return yg(Eg(a, Cg(this)), b);
    };
    function Cg(a) {
        return {
            pendingToken: a.a,
            requestUri: "http://localhost"
        };
    }
    Ag.prototype.w = function() {
        return {
            providerId: this.providerId,
            signInMethod: this.signInMethod,
            pendingToken: this.a
        };
    };
    function Fg(a) {
        if (a && a.providerId && a.signInMethod && 0 == a.providerId.indexOf("saml.") && a.pendingToken) try {
            return new Ag(a.providerId, a.pendingToken);
        } catch (b) {}
        return null;
    }
    function Gg(a, b, c) {
        this.a = null;
        if (b.idToken || b.accessToken) b.idToken && M(this, "idToken", b.idToken), b.accessToken && M(this, "accessToken", b.accessToken), b.nonce && !b.pendingToken && M(this, "nonce", b.nonce), b.pendingToken && (this.a = b.pendingToken);
        else if (b.oauthToken && b.oauthTokenSecret) M(this, "accessToken", b.oauthToken), M(this, "secret", b.oauthTokenSecret);
        else throw new t("internal-error", "failed to construct a credential");
        M(this, "providerId", a);
        M(this, "signInMethod", c);
    }
    Gg.prototype.ja = function(a) {
        return Bg(a, Hg(this));
    };
    Gg.prototype.b = function(a, b) {
        var c = Hg(this);
        c.idToken = b;
        return Dg(a, c);
    };
    Gg.prototype.c = function(a, b) {
        var c = Hg(this);
        return yg(Eg(a, c), b);
    };
    function Hg(a) {
        var b = {};
        a.idToken && (b.id_token = a.idToken);
        a.accessToken && (b.access_token = a.accessToken);
        a.secret && (b.oauth_token_secret = a.secret);
        b.providerId = a.providerId;
        a.nonce && !a.a && (b.nonce = a.nonce);
        b = {
            postBody: ae(b).toString(),
            requestUri: "http://localhost"
        };
        a.a && (delete b.postBody, b.pendingToken = a.a);
        return b;
    }
    Gg.prototype.w = function() {
        var a = {
            providerId: this.providerId,
            signInMethod: this.signInMethod
        };
        this.idToken && (a.oauthIdToken = this.idToken);
        this.accessToken && (a.oauthAccessToken = this.accessToken);
        this.secret && (a.oauthTokenSecret = this.secret);
        this.nonce && (a.nonce = this.nonce);
        this.a && (a.pendingToken = this.a);
        return a;
    };
    function Ig(a) {
        if (a && a.providerId && a.signInMethod) {
            var b = {
                idToken: a.oauthIdToken,
                accessToken: a.oauthTokenSecret ? null : a.oauthAccessToken,
                oauthTokenSecret: a.oauthTokenSecret,
                oauthToken: a.oauthTokenSecret && a.oauthAccessToken,
                nonce: a.nonce,
                pendingToken: a.pendingToken
            };
            try {
                return new Gg(a.providerId, b, a.signInMethod);
            } catch (c) {}
        }
        return null;
    }
    function Jg(a, b) {
        this.Pc = b || [];
        N(this, {
            providerId: a,
            isOAuthProvider: !0
        });
        this.Hb = {};
        this.ob = (jg(a) || {}).Ja || null;
        this.nb = null;
    }
    Jg.prototype.Ka = function(a) {
        this.Hb = lb(a);
        return this;
    };
    function Kg(a) {
        if ("string" !== typeof a || 0 != a.indexOf("saml.")) throw new t("argument-error", 'SAML provider IDs must be prefixed with "saml."');
        Jg.call(this, a, []);
    }
    r(Kg, Jg);
    function Lg(a) {
        Jg.call(this, a, hg);
        this.a = [];
    }
    r(Lg, Jg);
    Lg.prototype.Ca = function(a) {
        Ta(this.a, a) || this.a.push(a);
        return this;
    };
    Lg.prototype.Pb = function() {
        return Xa(this.a);
    };
    Lg.prototype.credential = function(a, b) {
        var c;
        n(a) ? c = {
            idToken: a.idToken || null,
            accessToken: a.accessToken || null,
            nonce: a.rawNonce || null
        } : c = {
            idToken: a || null,
            accessToken: b || null
        };
        if (!c.idToken && !c.accessToken) throw new t("argument-error", "credential failed: must provide the ID token and/or the access token.");
        return new Gg(this.providerId, c, this.providerId);
    };
    function Mg() {
        Lg.call(this, "facebook.com");
    }
    r(Mg, Lg);
    M(Mg, "PROVIDER_ID", "facebook.com");
    M(Mg, "FACEBOOK_SIGN_IN_METHOD", "facebook.com");
    function Ng(a) {
        if (!a) throw new t("argument-error", "credential failed: expected 1 argument (the OAuth access token).");
        var b = a;
        n(a) && (b = a.accessToken);
        return (new Mg).credential({
            accessToken: b
        });
    }
    function Og() {
        Lg.call(this, "github.com");
    }
    r(Og, Lg);
    M(Og, "PROVIDER_ID", "github.com");
    M(Og, "GITHUB_SIGN_IN_METHOD", "github.com");
    function Pg(a) {
        if (!a) throw new t("argument-error", "credential failed: expected 1 argument (the OAuth access token).");
        var b = a;
        n(a) && (b = a.accessToken);
        return (new Og).credential({
            accessToken: b
        });
    }
    function Qg() {
        Lg.call(this, "google.com");
        this.Ca("profile");
    }
    r(Qg, Lg);
    M(Qg, "PROVIDER_ID", "google.com");
    M(Qg, "GOOGLE_SIGN_IN_METHOD", "google.com");
    function Rg(a, b) {
        var c = a;
        n(a) && (c = a.idToken, b = a.accessToken);
        return (new Qg).credential({
            idToken: c,
            accessToken: b
        });
    }
    function Sg() {
        Jg.call(this, "twitter.com", gg);
    }
    r(Sg, Jg);
    M(Sg, "PROVIDER_ID", "twitter.com");
    M(Sg, "TWITTER_SIGN_IN_METHOD", "twitter.com");
    function Tg(a, b) {
        var c = a;
        n(c) || (c = {
            oauthToken: a,
            oauthTokenSecret: b
        });
        if (!c.oauthToken || !c.oauthTokenSecret) throw new t("argument-error", "credential failed: expected 2 arguments (the OAuth access token and secret).");
        return new Gg("twitter.com", c, "twitter.com");
    }
    function Ug(a, b, c) {
        this.a = a;
        this.f = b;
        M(this, "providerId", "password");
        M(this, "signInMethod", c === Vg.EMAIL_LINK_SIGN_IN_METHOD ? Vg.EMAIL_LINK_SIGN_IN_METHOD : Vg.EMAIL_PASSWORD_SIGN_IN_METHOD);
    }
    Ug.prototype.ja = function(a) {
        return this.signInMethod == Vg.EMAIL_LINK_SIGN_IN_METHOD ? O(a, Wg, {
            email: this.a,
            oobCode: this.f
        }) : O(a, Xg, {
            email: this.a,
            password: this.f
        });
    };
    Ug.prototype.b = function(a, b) {
        return this.signInMethod == Vg.EMAIL_LINK_SIGN_IN_METHOD ? O(a, Yg, {
            idToken: b,
            email: this.a,
            oobCode: this.f
        }) : O(a, Zg, {
            idToken: b,
            email: this.a,
            password: this.f
        });
    };
    Ug.prototype.c = function(a, b) {
        return yg(this.ja(a), b);
    };
    Ug.prototype.w = function() {
        return {
            email: this.a,
            password: this.f,
            signInMethod: this.signInMethod
        };
    };
    function $g(a) {
        return a && a.email && a.password ? new Ug(a.email, a.password, a.signInMethod) : null;
    }
    function Vg() {
        N(this, {
            providerId: "password",
            isOAuthProvider: !1
        });
    }
    function ah(a, b) {
        b = bh(b);
        if (!b) throw new t("argument-error", "Invalid email link!");
        return new Ug(a, b.code, Vg.EMAIL_LINK_SIGN_IN_METHOD);
    }
    function bh(a) {
        a = tg(a);
        return (a = Nf(a)) && a.operation === wf ? a : null;
    }
    N(Vg, {
        PROVIDER_ID: "password"
    });
    N(Vg, {
        EMAIL_LINK_SIGN_IN_METHOD: "emailLink"
    });
    N(Vg, {
        EMAIL_PASSWORD_SIGN_IN_METHOD: "password"
    });
    function ch(a) {
        if (!(a.cb && a.bb || a.La && a.ea)) throw new t("internal-error");
        this.a = a;
        M(this, "providerId", "phone");
        this.fa = "phone";
        M(this, "signInMethod", "phone");
    }
    ch.prototype.ja = function(a) {
        return a.eb(dh(this));
    };
    ch.prototype.b = function(a, b) {
        var c = dh(this);
        c.idToken = b;
        return O(a, eh, c);
    };
    ch.prototype.c = function(a, b) {
        var c = dh(this);
        c.operation = "REAUTH";
        a = O(a, fh, c);
        return yg(a, b);
    };
    ch.prototype.w = function() {
        var a = {
            providerId: "phone"
        };
        this.a.cb && (a.verificationId = this.a.cb);
        this.a.bb && (a.verificationCode = this.a.bb);
        this.a.La && (a.temporaryProof = this.a.La);
        this.a.ea && (a.phoneNumber = this.a.ea);
        return a;
    };
    function gh(a) {
        if (a && "phone" === a.providerId && (a.verificationId && a.verificationCode || a.temporaryProof && a.phoneNumber)) {
            var b = {};
            w([
                "verificationId",
                "verificationCode",
                "temporaryProof",
                "phoneNumber"
            ], function(c) {
                a[c] && (b[c] = a[c]);
            });
            return new ch(b);
        }
        return null;
    }
    function dh(a) {
        return a.a.La && a.a.ea ? {
            temporaryProof: a.a.La,
            phoneNumber: a.a.ea
        } : {
            sessionInfo: a.a.cb,
            code: a.a.bb
        };
    }
    function hh(a) {
        try {
            this.a = a || firebase.auth();
        } catch (b) {
            throw new t("argument-error", "Either an instance of firebase.auth.Auth must be passed as an argument to the firebase.auth.PhoneAuthProvider constructor, or the default firebase App instance must be initialized via firebase.initializeApp().");
        }
        N(this, {
            providerId: "phone",
            isOAuthProvider: !1
        });
    }
    hh.prototype.eb = function(a, b) {
        var c = this.a.a;
        return D(b.verify()).then(function(d) {
            if ("string" !== typeof d) throw new t("argument-error", "An implementation of firebase.auth.ApplicationVerifier.prototype.verify() must return a firebase.Promise that resolves with a string.");
            switch(b.type){
                case "recaptcha":
                    var e = n(a) ? a.session : null, f = n(a) ? a.phoneNumber : a, g;
                    e && e.type == vg ? g = e.Ha().then(function(h) {
                        return ih(c, {
                            idToken: h,
                            phoneEnrollmentInfo: {
                                phoneNumber: f,
                                recaptchaToken: d
                            }
                        });
                    }) : e && e.type == wg ? g = e.Ha().then(function(h) {
                        return jh(c, {
                            mfaPendingCredential: h,
                            mfaEnrollmentId: a.multiFactorHint && a.multiFactorHint.uid || a.multiFactorUid,
                            phoneSignInInfo: {
                                recaptchaToken: d
                            }
                        });
                    }) : g = kh(c, {
                        phoneNumber: f,
                        recaptchaToken: d
                    });
                    return g.then(function(h) {
                        "function" === typeof b.reset && b.reset();
                        return h;
                    }, function(h) {
                        "function" === typeof b.reset && b.reset();
                        throw h;
                    });
                default:
                    throw new t("argument-error", 'Only firebase.auth.ApplicationVerifiers with type="recaptcha" are currently supported.');
            }
        });
    };
    function lh(a, b) {
        if (!a) throw new t("missing-verification-id");
        if (!b) throw new t("missing-verification-code");
        return new ch({
            cb: a,
            bb: b
        });
    }
    N(hh, {
        PROVIDER_ID: "phone"
    });
    N(hh, {
        PHONE_SIGN_IN_METHOD: "phone"
    });
    function mh(a) {
        if (a.temporaryProof && a.phoneNumber) return new ch({
            La: a.temporaryProof,
            ea: a.phoneNumber
        });
        var b = a && a.providerId;
        if (!b || "password" === b) return null;
        var c = a && a.oauthAccessToken, d = a && a.oauthTokenSecret, e = a && a.nonce, f = a && a.oauthIdToken, g = a && a.pendingToken;
        try {
            switch(b){
                case "google.com":
                    return Rg(f, c);
                case "facebook.com":
                    return Ng(c);
                case "github.com":
                    return Pg(c);
                case "twitter.com":
                    return Tg(c, d);
                default:
                    return c || d || f || g ? g ? 0 == b.indexOf("saml.") ? new Ag(b, g) : new Gg(b, {
                        pendingToken: g,
                        idToken: a.oauthIdToken,
                        accessToken: a.oauthAccessToken
                    }, b) : new Lg(b).credential({
                        idToken: f,
                        accessToken: c,
                        rawNonce: e
                    }) : null;
            }
        } catch (h) {
            return null;
        }
    }
    function nh(a) {
        if (!a.isOAuthProvider) throw new t("invalid-oauth-provider");
    }
    function oh(a, b, c, d, e, f, g) {
        this.c = a;
        this.b = b || null;
        this.g = c || null;
        this.f = d || null;
        this.i = f || null;
        this.h = g || null;
        this.a = e || null;
        if (this.g || this.a) {
            if (this.g && this.a) throw new t("invalid-auth-event");
            if (this.g && !this.f) throw new t("invalid-auth-event");
        } else throw new t("invalid-auth-event");
    }
    oh.prototype.getUid = function() {
        var a = [];
        a.push(this.c);
        this.b && a.push(this.b);
        this.f && a.push(this.f);
        this.h && a.push(this.h);
        return a.join("-");
    };
    oh.prototype.S = function() {
        return this.h;
    };
    oh.prototype.w = function() {
        return {
            type: this.c,
            eventId: this.b,
            urlResponse: this.g,
            sessionId: this.f,
            postBody: this.i,
            tenantId: this.h,
            error: this.a && this.a.w()
        };
    };
    function ph(a) {
        a = a || {};
        return a.type ? new oh(a.type, a.eventId, a.urlResponse, a.sessionId, a.error && ya(a.error), a.postBody, a.tenantId) : null;
    }
    function qh() {
        this.b = null;
        this.a = [];
    }
    var rh = null;
    function sh(a) {
        var b = rh;
        b.a.push(a);
        b.b || (b.b = function(c) {
            for(var d = 0; d < b.a.length; d++)b.a[d](c);
        }, a = L("universalLinks.subscribe", l), "function" === typeof a && a(null, b.b));
    }
    function th(a) {
        var b = "unauthorized-domain", c = void 0, d = J(a);
        a = d.a;
        d = d.f;
        "chrome-extension" == d ? c = Nb("This chrome extension ID (chrome-extension://%s) is not authorized to run this operation. Add it to the OAuth redirect domains list in the Firebase console -> Auth section -> Sign in method tab.", a) : "http" == d || "https" == d ? c = Nb("This domain (%s) is not authorized to run this operation. Add it to the OAuth redirect domains list in the Firebase console -> Auth section -> Sign in method tab.", a) : b = "operation-not-supported-in-this-environment";
        t.call(this, b, c);
    }
    r(th, t);
    function uh(a, b, c) {
        t.call(this, a, c);
        a = b || {};
        a.Ib && M(this, "email", a.Ib);
        a.ea && M(this, "phoneNumber", a.ea);
        a.credential && M(this, "credential", a.credential);
        a.Yb && M(this, "tenantId", a.Yb);
    }
    r(uh, t);
    uh.prototype.w = function() {
        var a = {
            code: this.code,
            message: this.message
        };
        this.email && (a.email = this.email);
        this.phoneNumber && (a.phoneNumber = this.phoneNumber);
        this.tenantId && (a.tenantId = this.tenantId);
        var b = this.credential && this.credential.w();
        b && z(a, b);
        return a;
    };
    uh.prototype.toJSON = function() {
        return this.w();
    };
    function vh(a) {
        if (a.code) {
            var b = a.code || "";
            0 == b.indexOf(va) && (b = b.substring(va.length));
            var c = {
                credential: mh(a),
                Yb: a.tenantId
            };
            if (a.email) c.Ib = a.email;
            else if (a.phoneNumber) c.ea = a.phoneNumber;
            else if (!c.credential) return new t(b, a.message || void 0);
            return new uh(b, c, a.message);
        }
        return null;
    }
    function wh() {}
    wh.prototype.c = null;
    function xh(a) {
        return a.c || (a.c = a.b());
    }
    var yh;
    function zh() {}
    r(zh, wh);
    zh.prototype.a = function() {
        var a = Ah(this);
        return a ? new ActiveXObject(a) : new XMLHttpRequest;
    };
    zh.prototype.b = function() {
        var a = {};
        Ah(this) && (a[0] = !0, a[1] = !0);
        return a;
    };
    function Ah(a) {
        if (!a.f && "undefined" == typeof XMLHttpRequest && "undefined" != typeof ActiveXObject) {
            for(var b = [
                "MSXML2.XMLHTTP.6.0",
                "MSXML2.XMLHTTP.3.0",
                "MSXML2.XMLHTTP",
                "Microsoft.XMLHTTP"
            ], c = 0; c < b.length; c++){
                var d = b[c];
                try {
                    return new ActiveXObject(d), a.f = d;
                } catch (e) {}
            }
            throw Error("Could not create ActiveXObject. ActiveX might be disabled, or MSXML might not be installed");
        }
        return a.f;
    }
    yh = new zh;
    function Bh() {}
    r(Bh, wh);
    Bh.prototype.a = function() {
        var a = new XMLHttpRequest;
        if ("withCredentials" in a) return a;
        if ("undefined" != typeof XDomainRequest) return new Ch;
        throw Error("Unsupported browser");
    };
    Bh.prototype.b = function() {
        return {};
    };
    function Ch() {
        this.a = new XDomainRequest;
        this.readyState = 0;
        this.onreadystatechange = null;
        this.responseType = this.responseText = this.response = "";
        this.status = -1;
        this.statusText = "";
        this.a.onload = q(this.pc, this);
        this.a.onerror = q(this.Rb, this);
        this.a.onprogress = q(this.qc, this);
        this.a.ontimeout = q(this.uc, this);
    }
    k = Ch.prototype;
    k.open = function(a, b, c) {
        if (null != c && !c) throw Error("Only async requests are supported.");
        this.a.open(a, b);
    };
    k.send = function(a) {
        if (a) {
            if ("string" == typeof a) this.a.send(a);
            else throw Error("Only string data is supported");
        } else this.a.send();
    };
    k.abort = function() {
        this.a.abort();
    };
    k.setRequestHeader = function() {};
    k.getResponseHeader = function(a) {
        return "content-type" == a.toLowerCase() ? this.a.contentType : "";
    };
    k.pc = function() {
        this.status = 200;
        this.response = this.responseText = this.a.responseText;
        Dh(this, 4);
    };
    k.Rb = function() {
        this.status = 500;
        this.response = this.responseText = "";
        Dh(this, 4);
    };
    k.uc = function() {
        this.Rb();
    };
    k.qc = function() {
        this.status = 200;
        Dh(this, 1);
    };
    function Dh(a, b) {
        a.readyState = b;
        if (a.onreadystatechange) a.onreadystatechange();
    }
    k.getAllResponseHeaders = function() {
        return "content-type: " + this.a.contentType;
    };
    function Eh(a, b, c) {
        this.reset(a, b, c, void 0, void 0);
    }
    Eh.prototype.a = null;
    var Fh = 0;
    Eh.prototype.reset = function(a, b, c, d, e) {
        "number" == typeof e || Fh++;
        d || ua();
        delete this.a;
    };
    function Gh(a) {
        this.f = a;
        this.b = this.c = this.a = null;
    }
    function Hh(a, b) {
        this.name = a;
        this.value = b;
    }
    Hh.prototype.toString = function() {
        return this.name;
    };
    var Ih = new Hh("SEVERE", 1E3), Jh = new Hh("WARNING", 900), Kh = new Hh("CONFIG", 700), Lh = new Hh("FINE", 500);
    function Mh(a) {
        if (a.c) return a.c;
        if (a.a) return Mh(a.a);
        Ea("Root logger has no level set.");
        return null;
    }
    Gh.prototype.log = function(a, b, c) {
        if (a.value >= Mh(this).value) for(na(b) && (b = b()), a = new Eh(a, String(b), this.f), c && (a.a = c), c = this; c;)c = c.a;
    };
    var Nh = {}, Oh = null;
    function Ph(a) {
        Oh || (Oh = new Gh(""), Nh[""] = Oh, Oh.c = Kh);
        var b;
        if (!(b = Nh[a])) {
            b = new Gh(a);
            var c = a.lastIndexOf("."), d = a.substr(c + 1);
            c = Ph(a.substr(0, c));
            c.b || (c.b = {});
            c.b[d] = b;
            b.a = c;
            Nh[a] = b;
        }
        return b;
    }
    function Qh(a, b) {
        a && a.log(Lh, b, void 0);
    }
    function Rh(a) {
        this.f = a;
    }
    r(Rh, wh);
    Rh.prototype.a = function() {
        return new Sh(this.f);
    };
    Rh.prototype.b = function(a) {
        return function() {
            return a;
        };
    }({});
    function Sh(a) {
        H.call(this);
        this.o = a;
        this.readyState = Th;
        this.status = 0;
        this.responseType = this.responseText = this.response = this.statusText = "";
        this.onreadystatechange = null;
        this.i = new Headers;
        this.b = null;
        this.m = "GET";
        this.g = "";
        this.a = !1;
        this.h = Ph("goog.net.FetchXmlHttp");
        this.l = this.c = this.f = null;
    }
    r(Sh, H);
    var Th = 0;
    k = Sh.prototype;
    k.open = function(a, b) {
        if (this.readyState != Th) throw this.abort(), Error("Error reopening a connection");
        this.m = a;
        this.g = b;
        this.readyState = 1;
        Uh(this);
    };
    k.send = function(a) {
        if (1 != this.readyState) throw this.abort(), Error("need to call open() first. ");
        this.a = !0;
        var b = {
            headers: this.i,
            method: this.m,
            credentials: void 0,
            cache: void 0
        };
        a && (b.body = a);
        this.o.fetch(new Request(this.g, b)).then(this.tc.bind(this), this.Ta.bind(this));
    };
    k.abort = function() {
        this.response = this.responseText = "";
        this.i = new Headers;
        this.status = 0;
        this.c && this.c.cancel("Request was aborted.");
        1 <= this.readyState && this.a && 4 != this.readyState && (this.a = !1, Vh(this, !1));
        this.readyState = Th;
    };
    k.tc = function(a) {
        this.a && (this.f = a, this.b || (this.b = a.headers, this.readyState = 2, Uh(this)), this.a && (this.readyState = 3, Uh(this), this.a && ("arraybuffer" === this.responseType ? a.arrayBuffer().then(this.rc.bind(this), this.Ta.bind(this)) : "undefined" !== typeof l.ReadableStream && "body" in a ? (this.response = this.responseText = "", this.c = a.body.getReader(), this.l = new TextDecoder, Wh(this)) : a.text().then(this.sc.bind(this), this.Ta.bind(this)))));
    };
    function Wh(a) {
        a.c.read().then(a.oc.bind(a)).catch(a.Ta.bind(a));
    }
    k.oc = function(a) {
        if (this.a) {
            var b = this.l.decode(a.value ? a.value : new Uint8Array(0), {
                stream: !a.done
            });
            b && (this.response = this.responseText += b);
            a.done ? Vh(this, !0) : Uh(this);
            3 == this.readyState && Wh(this);
        }
    };
    k.sc = function(a) {
        this.a && (this.response = this.responseText = a, Vh(this, !0));
    };
    k.rc = function(a) {
        this.a && (this.response = a, Vh(this, !0));
    };
    k.Ta = function(a) {
        var b = this.h;
        b && b.log(Jh, "Failed to fetch url " + this.g, a instanceof Error ? a : Error(a));
        this.a && Vh(this, !0);
    };
    function Vh(a, b) {
        b && a.f && (a.status = a.f.status, a.statusText = a.f.statusText);
        a.readyState = 4;
        a.f = null;
        a.c = null;
        a.l = null;
        Uh(a);
    }
    k.setRequestHeader = function(a, b) {
        this.i.append(a, b);
    };
    k.getResponseHeader = function(a) {
        return this.b ? this.b.get(a.toLowerCase()) || "" : ((a = this.h) && a.log(Jh, "Attempting to get response header but no headers have been received for url: " + this.g, void 0), "");
    };
    k.getAllResponseHeaders = function() {
        if (!this.b) {
            var a = this.h;
            a && a.log(Jh, "Attempting to get all response headers but no headers have been received for url: " + this.g, void 0);
            return "";
        }
        a = [];
        for(var b = this.b.entries(), c = b.next(); !c.done;)c = c.value, a.push(c[0] + ": " + c[1]), c = b.next();
        return a.join("\r\n");
    };
    function Uh(a) {
        a.onreadystatechange && a.onreadystatechange.call(a);
    }
    function Xh(a) {
        H.call(this);
        this.headers = new Ed;
        this.O = a || null;
        this.c = !1;
        this.A = this.a = null;
        this.h = this.P = this.l = "";
        this.f = this.N = this.i = this.G = !1;
        this.g = 0;
        this.o = null;
        this.m = Yh;
        this.u = this.R = !1;
    }
    r(Xh, H);
    var Yh = "";
    Xh.prototype.b = Ph("goog.net.XhrIo");
    var Zh = /^https?$/i, $h = [
        "POST",
        "PUT"
    ];
    function ai(a, b, c, d, e) {
        if (a.a) throw Error("[goog.net.XhrIo] Object is active with another request=" + a.l + "; newUri=" + b);
        c = c ? c.toUpperCase() : "GET";
        a.l = b;
        a.h = "";
        a.P = c;
        a.G = !1;
        a.c = !0;
        a.a = a.O ? a.O.a() : yh.a();
        a.A = a.O ? xh(a.O) : xh(yh);
        a.a.onreadystatechange = q(a.Ub, a);
        try {
            Qh(a.b, bi(a, "Opening Xhr")), a.N = !0, a.a.open(c, String(b), !0), a.N = !1;
        } catch (g) {
            Qh(a.b, bi(a, "Error opening Xhr: " + g.message));
            ci(a, g);
            return;
        }
        b = d || "";
        var f = new Ed(a.headers);
        e && Dd(e, function(g, h) {
            f.set(h, g);
        });
        e = Ra(f.Y());
        d = l.FormData && b instanceof l.FormData;
        !Ta($h, c) || e || d || f.set("Content-Type", "application/x-www-form-urlencoded;charset=utf-8");
        f.forEach(function(g, h) {
            this.a.setRequestHeader(h, g);
        }, a);
        a.m && (a.a.responseType = a.m);
        "withCredentials" in a.a && a.a.withCredentials !== a.R && (a.a.withCredentials = a.R);
        try {
            di(a), 0 < a.g && (a.u = ei(a.a), Qh(a.b, bi(a, "Will abort after " + a.g + "ms if incomplete, xhr2 " + a.u)), a.u ? (a.a.timeout = a.g, a.a.ontimeout = q(a.Ma, a)) : a.o = zd(a.Ma, a.g, a)), Qh(a.b, bi(a, "Sending request")), a.i = !0, a.a.send(b), a.i = !1;
        } catch (g) {
            Qh(a.b, bi(a, "Send error: " + g.message)), ci(a, g);
        }
    }
    function ei(a) {
        return Tb && cc(9) && "number" === typeof a.timeout && void 0 !== a.ontimeout;
    }
    function Sa(a) {
        return "content-type" == a.toLowerCase();
    }
    k = Xh.prototype;
    k.Ma = function() {
        "undefined" != typeof ha && this.a && (this.h = "Timed out after " + this.g + "ms, aborting", Qh(this.b, bi(this, this.h)), this.dispatchEvent("timeout"), this.abort(8));
    };
    function ci(a, b) {
        a.c = !1;
        a.a && (a.f = !0, a.a.abort(), a.f = !1);
        a.h = b;
        fi(a);
        gi(a);
    }
    function fi(a) {
        a.G || (a.G = !0, a.dispatchEvent("complete"), a.dispatchEvent("error"));
    }
    k.abort = function() {
        this.a && this.c && (Qh(this.b, bi(this, "Aborting")), this.c = !1, this.f = !0, this.a.abort(), this.f = !1, this.dispatchEvent("complete"), this.dispatchEvent("abort"), gi(this));
    };
    k.Da = function() {
        this.a && (this.c && (this.c = !1, this.f = !0, this.a.abort(), this.f = !1), gi(this, !0));
        Xh.$a.Da.call(this);
    };
    k.Ub = function() {
        this.xa || (this.N || this.i || this.f ? hi(this) : this.Ic());
    };
    k.Ic = function() {
        hi(this);
    };
    function hi(a) {
        if (a.c && "undefined" != typeof ha) {
            if (a.A[1] && 4 == ii(a) && 2 == ji(a)) Qh(a.b, bi(a, "Local request error detected and ignored"));
            else if (a.i && 4 == ii(a)) zd(a.Ub, 0, a);
            else if (a.dispatchEvent("readystatechange"), 4 == ii(a)) {
                Qh(a.b, bi(a, "Request complete"));
                a.c = !1;
                try {
                    var b = ji(a);
                    a: switch(b){
                        case 200:
                        case 201:
                        case 202:
                        case 204:
                        case 206:
                        case 304:
                        case 1223:
                            var c = !0;
                            break a;
                        default:
                            c = !1;
                    }
                    var d;
                    if (!(d = c)) {
                        var e;
                        if (e = 0 === b) {
                            var f = String(a.l).match(Hd)[1] || null;
                            if (!f && l.self && l.self.location) {
                                var g = l.self.location.protocol;
                                f = g.substr(0, g.length - 1);
                            }
                            e = !Zh.test(f ? f.toLowerCase() : "");
                        }
                        d = e;
                    }
                    if (d) a.dispatchEvent("complete"), a.dispatchEvent("success");
                    else {
                        try {
                            var h = 2 < ii(a) ? a.a.statusText : "";
                        } catch (m) {
                            Qh(a.b, "Can not get status: " + m.message), h = "";
                        }
                        a.h = h + " [" + ji(a) + "]";
                        fi(a);
                    }
                } finally{
                    gi(a);
                }
            }
        }
    }
    function gi(a, b) {
        if (a.a) {
            di(a);
            var c = a.a, d = a.A[0] ? ka : null;
            a.a = null;
            a.A = null;
            b || a.dispatchEvent("ready");
            try {
                c.onreadystatechange = d;
            } catch (e) {
                (a = a.b) && a.log(Ih, "Problem encountered resetting onreadystatechange: " + e.message, void 0);
            }
        }
    }
    function di(a) {
        a.a && a.u && (a.a.ontimeout = null);
        a.o && (l.clearTimeout(a.o), a.o = null);
    }
    function ii(a) {
        return a.a ? a.a.readyState : 0;
    }
    function ji(a) {
        try {
            return 2 < ii(a) ? a.a.status : -1;
        } catch (b) {
            return -1;
        }
    }
    function ki(a) {
        try {
            return a.a ? a.a.responseText : "";
        } catch (b) {
            return Qh(a.b, "Can not get responseText: " + b.message), "";
        }
    }
    k.getResponse = function() {
        try {
            if (!this.a) return null;
            if ("response" in this.a) return this.a.response;
            switch(this.m){
                case Yh:
                case "text":
                    return this.a.responseText;
                case "arraybuffer":
                    if ("mozResponseArrayBuffer" in this.a) return this.a.mozResponseArrayBuffer;
            }
            var a = this.b;
            a && a.log(Ih, "Response type " + this.m + " is not supported on this browser", void 0);
            return null;
        } catch (b) {
            return Qh(this.b, "Can not get response: " + b.message), null;
        }
    };
    function bi(a, b) {
        return b + " [" + a.P + " " + a.l + " " + ji(a) + "]";
    }
    function li(a) {
        var b = mi;
        this.g = [];
        this.u = b;
        this.o = a || null;
        this.f = this.a = !1;
        this.c = void 0;
        this.m = this.A = this.i = !1;
        this.h = 0;
        this.b = null;
        this.l = 0;
    }
    li.prototype.cancel = function(a) {
        if (this.a) this.c instanceof li && this.c.cancel();
        else {
            if (this.b) {
                var b = this.b;
                delete this.b;
                a ? b.cancel(a) : (b.l--, 0 >= b.l && b.cancel());
            }
            this.u ? this.u.call(this.o, this) : this.m = !0;
            this.a || (a = new ni(this), oi(this), pi(this, !1, a));
        }
    };
    li.prototype.v = function(a, b) {
        this.i = !1;
        pi(this, a, b);
    };
    function pi(a, b, c) {
        a.a = !0;
        a.c = c;
        a.f = !b;
        qi(a);
    }
    function oi(a) {
        if (a.a) {
            if (!a.m) throw new ri(a);
            a.m = !1;
        }
    }
    function si(a, b) {
        ti(a, null, b, void 0);
    }
    function ti(a, b, c, d) {
        a.g.push([
            b,
            c,
            d
        ]);
        a.a && qi(a);
    }
    li.prototype.then = function(a, b, c) {
        var d, e, f = new C(function(g, h) {
            d = g;
            e = h;
        });
        ti(this, d, function(g) {
            g instanceof ni ? f.cancel() : e(g);
        });
        return f.then(a, b, c);
    };
    li.prototype.$goog_Thenable = !0;
    function ui(a) {
        return Qa(a.g, function(b) {
            return na(b[1]);
        });
    }
    function qi(a) {
        if (a.h && a.a && ui(a)) {
            var b = a.h, c = vi[b];
            c && (l.clearTimeout(c.a), delete vi[b]);
            a.h = 0;
        }
        a.b && (a.b.l--, delete a.b);
        b = a.c;
        for(var d = c = !1; a.g.length && !a.i;){
            var e = a.g.shift(), f = e[0], g = e[1];
            e = e[2];
            if (f = a.f ? g : f) try {
                var h = f.call(e || a.o, b);
                void 0 !== h && (a.f = a.f && (h == b || h instanceof Error), a.c = b = h);
                if (Ca(b) || "function" === typeof l.Promise && b instanceof l.Promise) d = !0, a.i = !0;
            } catch (m) {
                b = m, a.f = !0, ui(a) || (c = !0);
            }
        }
        a.c = b;
        d && (h = q(a.v, a, !0), d = q(a.v, a, !1), b instanceof li ? (ti(b, h, d), b.A = !0) : b.then(h, d));
        c && (b = new wi(b), vi[b.a] = b, a.h = b.a);
    }
    function ri() {
        u.call(this);
    }
    r(ri, u);
    ri.prototype.message = "Deferred has already fired";
    ri.prototype.name = "AlreadyCalledError";
    function ni() {
        u.call(this);
    }
    r(ni, u);
    ni.prototype.message = "Deferred was canceled";
    ni.prototype.name = "CanceledError";
    function wi(a) {
        this.a = l.setTimeout(q(this.c, this), 0);
        this.b = a;
    }
    wi.prototype.c = function() {
        delete vi[this.a];
        throw this.b;
    };
    var vi = {};
    function xi(a) {
        var b = {}, c = b.document || document, d = wb(a).toString(), e = jc(document, "SCRIPT"), f = {
            Vb: e,
            Ma: void 0
        }, g = new li(f), h = null, m = null != b.timeout ? b.timeout : 5E3;
        0 < m && (h = window.setTimeout(function() {
            yi(e, !0);
            var p = new zi(Ai, "Timeout reached for loading script " + d);
            oi(g);
            pi(g, !1, p);
        }, m), f.Ma = h);
        e.onload = e.onreadystatechange = function() {
            e.readyState && "loaded" != e.readyState && "complete" != e.readyState || (yi(e, b.wd || !1, h), oi(g), pi(g, !0, null));
        };
        e.onerror = function() {
            yi(e, !0, h);
            var p = new zi(Bi, "Error while loading script " + d);
            oi(g);
            pi(g, !1, p);
        };
        f = b.attributes || {};
        z(f, {
            type: "text/javascript",
            charset: "UTF-8"
        });
        gc(e, f);
        Mb(e, a);
        Ci(c).appendChild(e);
        return g;
    }
    function Ci(a) {
        var b;
        return (b = (a || document).getElementsByTagName("HEAD")) && 0 != b.length ? b[0] : a.documentElement;
    }
    function mi() {
        if (this && this.Vb) {
            var a = this.Vb;
            a && "SCRIPT" == a.tagName && yi(a, !0, this.Ma);
        }
    }
    function yi(a, b, c) {
        null != c && l.clearTimeout(c);
        a.onload = ka;
        a.onerror = ka;
        a.onreadystatechange = ka;
        b && window.setTimeout(function() {
            a && a.parentNode && a.parentNode.removeChild(a);
        }, 0);
    }
    var Bi = 0, Ai = 1;
    function zi(a, b) {
        var c = "Jsloader error (code #" + a + ")";
        b && (c += ": " + b);
        u.call(this, c);
        this.code = a;
    }
    r(zi, u);
    function Di(a) {
        this.f = a;
    }
    r(Di, wh);
    Di.prototype.a = function() {
        return new this.f;
    };
    Di.prototype.b = function() {
        return {};
    };
    function Ei(a, b, c) {
        this.c = a;
        a = b || {};
        this.l = a.secureTokenEndpoint || "https://securetoken.googleapis.com/v1/token";
        this.v = a.secureTokenTimeout || Fi;
        this.g = lb(a.secureTokenHeaders || Gi);
        this.h = a.firebaseEndpoint || "https://www.googleapis.com/identitytoolkit/v3/relyingparty/";
        this.i = a.identityPlatformEndpoint || "https://identitytoolkit.googleapis.com/v2/";
        this.m = a.firebaseTimeout || Hi;
        this.a = lb(a.firebaseHeaders || Ii);
        c && (this.a["X-Client-Version"] = c, this.g["X-Client-Version"] = c);
        c = "Node" == Fe();
        c = l.XMLHttpRequest || c && firebase.INTERNAL.node && firebase.INTERNAL.node.XMLHttpRequest;
        if (!c && !Ee()) throw new t("internal-error", "The XMLHttpRequest compatibility library was not found.");
        this.f = void 0;
        Ee() ? this.f = new Rh(self) : Ge() ? this.f = new Di(c) : this.f = new Bh;
        this.b = null;
    }
    var Ji, zg = "idToken", Fi = new Ue(3E4, 6E4), Gi = {
        "Content-Type": "application/x-www-form-urlencoded"
    }, Hi = new Ue(3E4, 6E4), Ii = {
        "Content-Type": "application/json"
    };
    function Ki(a, b) {
        b ? a.a["X-Firebase-Locale"] = b : delete a.a["X-Firebase-Locale"];
    }
    function Li(a, b) {
        b && (a.l = Mi("https://securetoken.googleapis.com/v1/token", b), a.h = Mi("https://www.googleapis.com/identitytoolkit/v3/relyingparty/", b), a.i = Mi("https://identitytoolkit.googleapis.com/v2/", b));
    }
    function Mi(a, b) {
        a = J(a);
        b = J(b.url);
        a.c = a.a + a.c;
        Kd(a, b.f);
        a.a = b.a;
        Ld(a, b.g);
        return a.toString();
    }
    function Ni(a, b) {
        b ? (a.a["X-Client-Version"] = b, a.g["X-Client-Version"] = b) : (delete a.a["X-Client-Version"], delete a.g["X-Client-Version"]);
    }
    Ei.prototype.S = function() {
        return this.b;
    };
    function Oi(a, b, c, d, e, f, g) {
        pe() || Ee() ? a = q(a.u, a) : (Ji || (Ji = new C(function(h, m) {
            Pi(h, m);
        })), a = q(a.o, a));
        a(b, c, d, e, f, g);
    }
    Ei.prototype.u = function(a, b, c, d, e, f) {
        if (Ee() && ("undefined" === typeof l.fetch || "undefined" === typeof l.Headers || "undefined" === typeof l.Request)) throw new t("operation-not-supported-in-this-environment", "fetch, Headers and Request native APIs or equivalent Polyfills must be available to support HTTP requests from a Worker environment.");
        var g = new Xh(this.f);
        if (f) {
            g.g = Math.max(0, f);
            var h = setTimeout(function() {
                g.dispatchEvent("timeout");
            }, f);
        }
        md(g, "complete", function() {
            h && clearTimeout(h);
            var m = null;
            try {
                m = JSON.parse(ki(this)) || null;
            } catch (p) {
                m = null;
            }
            b && b(m);
        });
        sd(g, "ready", function() {
            h && clearTimeout(h);
            Tc(this);
        });
        sd(g, "timeout", function() {
            h && clearTimeout(h);
            Tc(this);
            b && b(null);
        });
        ai(g, a, c, d, e);
    };
    var Qi = new ob(pb, "https://apis.google.com/js/client.js?onload=%{onload}"), Ri = "__fcb" + Math.floor(1E6 * Math.random()).toString();
    function Pi(a, b) {
        if (((window.gapi || {}).client || {}).request) a();
        else {
            l[Ri] = function() {
                ((window.gapi || {}).client || {}).request ? a() : b(Error("CORS_UNSUPPORTED"));
            };
            var c = xb(Qi, {
                onload: Ri
            });
            si(xi(c), function() {
                b(Error("CORS_UNSUPPORTED"));
            });
        }
    }
    Ei.prototype.o = function(a, b, c, d, e) {
        var f = this;
        Ji.then(function() {
            window.gapi.client.setApiKey(f.c);
            var g = window.gapi.auth.getToken();
            window.gapi.auth.setToken(null);
            window.gapi.client.request({
                path: a,
                method: c,
                body: d,
                headers: e,
                authType: "none",
                callback: function(h) {
                    window.gapi.auth.setToken(g);
                    b && b(h);
                }
            });
        }).s(function(g) {
            b && b({
                error: {
                    message: g && g.message || "CORS_UNSUPPORTED"
                }
            });
        });
    };
    function Si(a, b) {
        return new C(function(c, d) {
            "refresh_token" == b.grant_type && b.refresh_token || "authorization_code" == b.grant_type && b.code ? Oi(a, a.l + "?key=" + encodeURIComponent(a.c), function(e) {
                e ? e.error ? d(Ti(e)) : e.access_token && e.refresh_token ? c(e) : d(new t("internal-error")) : d(new t("network-request-failed"));
            }, "POST", ae(b).toString(), a.g, a.v.get()) : d(new t("internal-error"));
        });
    }
    function Ui(a, b, c, d, e, f, g) {
        var h = J(b + c);
        I(h, "key", a.c);
        g && I(h, "cb", ua().toString());
        var m = "GET" == d;
        if (m) for(var p in e)e.hasOwnProperty(p) && I(h, p, e[p]);
        return new C(function(v, B) {
            Oi(a, h.toString(), function(A) {
                A ? A.error ? B(Ti(A, f || {})) : v(A) : B(new t("network-request-failed"));
            }, d, m ? void 0 : fe(Qe(e)), a.a, a.m.get());
        });
    }
    function Vi(a) {
        a = a.email;
        if ("string" !== typeof a || !ye.test(a)) throw new t("invalid-email");
    }
    function Wi(a) {
        "email" in a && Vi(a);
    }
    function Xi(a, b) {
        return O(a, Yi, {
            identifier: b,
            continueUri: Ne() ? me() : "http://localhost"
        }).then(function(c) {
            return c.signinMethods || [];
        });
    }
    function Zi(a) {
        return O(a, $i, {}).then(function(b) {
            return b.authorizedDomains || [];
        });
    }
    function P(a) {
        if (!a[zg]) {
            if (a.mfaPendingCredential) throw new t("multi-factor-auth-required", null, lb(a));
            throw new t("internal-error");
        }
    }
    function aj(a) {
        if (a.phoneNumber || a.temporaryProof) {
            if (!a.phoneNumber || !a.temporaryProof) throw new t("internal-error");
        } else {
            if (!a.sessionInfo) throw new t("missing-verification-id");
            if (!a.code) throw new t("missing-verification-code");
        }
    }
    Ei.prototype.yb = function() {
        return O(this, bj, {});
    };
    Ei.prototype.Ab = function(a, b) {
        return O(this, cj, {
            idToken: a,
            email: b
        });
    };
    Ei.prototype.Bb = function(a, b) {
        return O(this, Zg, {
            idToken: a,
            password: b
        });
    };
    var dj = {
        displayName: "DISPLAY_NAME",
        photoUrl: "PHOTO_URL"
    };
    k = Ei.prototype;
    k.Cb = function(a, b) {
        var c = {
            idToken: a
        }, d = [];
        jb(dj, function(e, f) {
            var g = b[f];
            null === g ? d.push(e) : f in b && (c[f] = g);
        });
        d.length && (c.deleteAttribute = d);
        return O(this, cj, c);
    };
    k.ub = function(a, b) {
        a = {
            requestType: "PASSWORD_RESET",
            email: a
        };
        z(a, b);
        return O(this, ej, a);
    };
    k.vb = function(a, b) {
        a = {
            requestType: "EMAIL_SIGNIN",
            email: a
        };
        z(a, b);
        return O(this, fj, a);
    };
    k.tb = function(a, b) {
        a = {
            requestType: "VERIFY_EMAIL",
            idToken: a
        };
        z(a, b);
        return O(this, gj, a);
    };
    k.Db = function(a, b, c) {
        a = {
            requestType: "VERIFY_AND_CHANGE_EMAIL",
            idToken: a,
            newEmail: b
        };
        z(a, c);
        return O(this, hj, a);
    };
    function kh(a, b) {
        return O(a, ij, b);
    }
    k.eb = function(a) {
        return O(this, jj, a);
    };
    function ih(a, b) {
        return O(a, kj, b).then(function(c) {
            return c.phoneSessionInfo.sessionInfo;
        });
    }
    function lj(a) {
        if (!a.phoneVerificationInfo) throw new t("internal-error");
        if (!a.phoneVerificationInfo.sessionInfo) throw new t("missing-verification-id");
        if (!a.phoneVerificationInfo.code) throw new t("missing-verification-code");
    }
    function jh(a, b) {
        return O(a, mj, b).then(function(c) {
            return c.phoneResponseInfo.sessionInfo;
        });
    }
    function nj(a, b, c) {
        return O(a, oj, {
            idToken: b,
            deleteProvider: c
        });
    }
    function pj(a) {
        if (!a.requestUri || !a.sessionId && !a.postBody && !a.pendingToken) throw new t("internal-error");
    }
    function qj(a, b) {
        b.oauthIdToken && b.providerId && 0 == b.providerId.indexOf("oidc.") && !b.pendingToken && (a.sessionId ? b.nonce = a.sessionId : a.postBody && (a = new Pd(a.postBody), ee(a, "nonce") && (b.nonce = a.get("nonce"))));
        return b;
    }
    function rj(a) {
        var b = null;
        a.needConfirmation ? (a.code = "account-exists-with-different-credential", b = vh(a)) : "FEDERATED_USER_ID_ALREADY_LINKED" == a.errorMessage ? (a.code = "credential-already-in-use", b = vh(a)) : "EMAIL_EXISTS" == a.errorMessage ? (a.code = "email-already-in-use", b = vh(a)) : a.errorMessage && (b = sj(a.errorMessage));
        if (b) throw b;
        P(a);
    }
    function Bg(a, b) {
        b.returnIdpCredential = !0;
        return O(a, tj, b);
    }
    function Dg(a, b) {
        b.returnIdpCredential = !0;
        return O(a, uj, b);
    }
    function Eg(a, b) {
        b.returnIdpCredential = !0;
        b.autoCreate = !1;
        return O(a, vj, b);
    }
    function wj(a) {
        if (!a.oobCode) throw new t("invalid-action-code");
    }
    k.mb = function(a, b) {
        return O(this, xj, {
            oobCode: a,
            newPassword: b
        });
    };
    k.Qa = function(a) {
        return O(this, yj, {
            oobCode: a
        });
    };
    k.ib = function(a) {
        return O(this, zj, {
            oobCode: a
        });
    };
    var zj = {
        endpoint: "setAccountInfo",
        B: wj,
        Z: "email",
        C: !0
    }, yj = {
        endpoint: "resetPassword",
        B: wj,
        F: function(a) {
            var b = a.requestType;
            if (!b || !a.email && "EMAIL_SIGNIN" != b && "VERIFY_AND_CHANGE_EMAIL" != b) throw new t("internal-error");
        },
        C: !0
    }, Aj = {
        endpoint: "signupNewUser",
        B: function(a) {
            Vi(a);
            if (!a.password) throw new t("weak-password");
        },
        F: P,
        U: !0,
        C: !0
    }, Yi = {
        endpoint: "createAuthUri",
        C: !0
    }, Bj = {
        endpoint: "deleteAccount",
        M: [
            "idToken"
        ]
    }, oj = {
        endpoint: "setAccountInfo",
        M: [
            "idToken",
            "deleteProvider"
        ],
        B: function(a) {
            if ("array" != la(a.deleteProvider)) throw new t("internal-error");
        }
    }, Wg = {
        endpoint: "emailLinkSignin",
        M: [
            "email",
            "oobCode"
        ],
        B: Vi,
        F: P,
        U: !0,
        C: !0
    }, Yg = {
        endpoint: "emailLinkSignin",
        M: [
            "idToken",
            "email",
            "oobCode"
        ],
        B: Vi,
        F: P,
        U: !0
    }, Cj = {
        endpoint: "accounts/mfaEnrollment:finalize",
        M: [
            "idToken",
            "phoneVerificationInfo"
        ],
        B: lj,
        F: P,
        C: !0,
        Na: !0
    }, Dj = {
        endpoint: "accounts/mfaSignIn:finalize",
        M: [
            "mfaPendingCredential",
            "phoneVerificationInfo"
        ],
        B: lj,
        F: P,
        C: !0,
        Na: !0
    }, Ej = {
        endpoint: "getAccountInfo"
    }, fj = {
        endpoint: "getOobConfirmationCode",
        M: [
            "requestType"
        ],
        B: function(a) {
            if ("EMAIL_SIGNIN" != a.requestType) throw new t("internal-error");
            Vi(a);
        },
        Z: "email",
        C: !0
    }, gj = {
        endpoint: "getOobConfirmationCode",
        M: [
            "idToken",
            "requestType"
        ],
        B: function(a) {
            if ("VERIFY_EMAIL" != a.requestType) throw new t("internal-error");
        },
        Z: "email",
        C: !0
    }, hj = {
        endpoint: "getOobConfirmationCode",
        M: [
            "idToken",
            "newEmail",
            "requestType"
        ],
        B: function(a) {
            if ("VERIFY_AND_CHANGE_EMAIL" != a.requestType) throw new t("internal-error");
        },
        Z: "email",
        C: !0
    }, ej = {
        endpoint: "getOobConfirmationCode",
        M: [
            "requestType"
        ],
        B: function(a) {
            if ("PASSWORD_RESET" != a.requestType) throw new t("internal-error");
            Vi(a);
        },
        Z: "email",
        C: !0
    }, $i = {
        kb: !0,
        endpoint: "getProjectConfig",
        Tb: "GET"
    }, Fj = {
        kb: !0,
        endpoint: "getRecaptchaParam",
        Tb: "GET",
        F: function(a) {
            if (!a.recaptchaSiteKey) throw new t("internal-error");
        }
    }, xj = {
        endpoint: "resetPassword",
        B: wj,
        Z: "email",
        C: !0
    }, ij = {
        endpoint: "sendVerificationCode",
        M: [
            "phoneNumber",
            "recaptchaToken"
        ],
        Z: "sessionInfo",
        C: !0
    }, cj = {
        endpoint: "setAccountInfo",
        M: [
            "idToken"
        ],
        B: Wi,
        U: !0
    }, Zg = {
        endpoint: "setAccountInfo",
        M: [
            "idToken"
        ],
        B: function(a) {
            Wi(a);
            if (!a.password) throw new t("weak-password");
        },
        F: P,
        U: !0
    }, bj = {
        endpoint: "signupNewUser",
        F: P,
        U: !0,
        C: !0
    }, kj = {
        endpoint: "accounts/mfaEnrollment:start",
        M: [
            "idToken",
            "phoneEnrollmentInfo"
        ],
        B: function(a) {
            if (!a.phoneEnrollmentInfo) throw new t("internal-error");
            if (!a.phoneEnrollmentInfo.phoneNumber) throw new t("missing-phone-number");
            if (!a.phoneEnrollmentInfo.recaptchaToken) throw new t("missing-app-credential");
        },
        F: function(a) {
            if (!a.phoneSessionInfo || !a.phoneSessionInfo.sessionInfo) throw new t("internal-error");
        },
        C: !0,
        Na: !0
    }, mj = {
        endpoint: "accounts/mfaSignIn:start",
        M: [
            "mfaPendingCredential",
            "mfaEnrollmentId",
            "phoneSignInInfo"
        ],
        B: function(a) {
            if (!a.phoneSignInInfo || !a.phoneSignInInfo.recaptchaToken) throw new t("missing-app-credential");
        },
        F: function(a) {
            if (!a.phoneResponseInfo || !a.phoneResponseInfo.sessionInfo) throw new t("internal-error");
        },
        C: !0,
        Na: !0
    }, tj = {
        endpoint: "verifyAssertion",
        B: pj,
        Xa: qj,
        F: rj,
        U: !0,
        C: !0
    }, vj = {
        endpoint: "verifyAssertion",
        B: pj,
        Xa: qj,
        F: function(a) {
            if (a.errorMessage && "USER_NOT_FOUND" == a.errorMessage) throw new t("user-not-found");
            if (a.errorMessage) throw sj(a.errorMessage);
            P(a);
        },
        U: !0,
        C: !0
    }, uj = {
        endpoint: "verifyAssertion",
        B: function(a) {
            pj(a);
            if (!a.idToken) throw new t("internal-error");
        },
        Xa: qj,
        F: rj,
        U: !0
    }, Gj = {
        endpoint: "verifyCustomToken",
        B: function(a) {
            if (!a.token) throw new t("invalid-custom-token");
        },
        F: P,
        U: !0,
        C: !0
    }, Xg = {
        endpoint: "verifyPassword",
        B: function(a) {
            Vi(a);
            if (!a.password) throw new t("wrong-password");
        },
        F: P,
        U: !0,
        C: !0
    }, jj = {
        endpoint: "verifyPhoneNumber",
        B: aj,
        F: P,
        C: !0
    }, eh = {
        endpoint: "verifyPhoneNumber",
        B: function(a) {
            if (!a.idToken) throw new t("internal-error");
            aj(a);
        },
        F: function(a) {
            if (a.temporaryProof) throw a.code = "credential-already-in-use", vh(a);
            P(a);
        }
    }, fh = {
        Gb: {
            USER_NOT_FOUND: "user-not-found"
        },
        endpoint: "verifyPhoneNumber",
        B: aj,
        F: P,
        C: !0
    }, Hj = {
        endpoint: "accounts/mfaEnrollment:withdraw",
        M: [
            "idToken",
            "mfaEnrollmentId"
        ],
        F: function(a) {
            if (!!a[zg] ^ !!a.refreshToken) throw new t("internal-error");
        },
        C: !0,
        Na: !0
    };
    function O(a, b, c) {
        if (!hf(c, b.M)) return E(new t("internal-error"));
        var d = !!b.Na, e = b.Tb || "POST", f;
        return D(c).then(b.B).then(function() {
            b.U && (c.returnSecureToken = !0);
            b.C && a.b && "undefined" === typeof c.tenantId && (c.tenantId = a.b);
            return d ? Ui(a, a.i, b.endpoint, e, c, b.Gb, b.kb || !1) : Ui(a, a.h, b.endpoint, e, c, b.Gb, b.kb || !1);
        }).then(function(g) {
            f = g;
            return b.Xa ? b.Xa(c, f) : f;
        }).then(b.F).then(function() {
            if (!b.Z) return f;
            if (!(b.Z in f)) throw new t("internal-error");
            return f[b.Z];
        });
    }
    function sj(a) {
        return Ti({
            error: {
                errors: [
                    {
                        message: a
                    }
                ],
                code: 400,
                message: a
            }
        });
    }
    function Ti(a, b) {
        var c = (a.error && a.error.errors && a.error.errors[0] || {}).reason || "";
        var d = {
            keyInvalid: "invalid-api-key",
            ipRefererBlocked: "app-not-authorized"
        };
        if (c = d[c] ? new t(d[c]) : null) return c;
        c = a.error && a.error.message || "";
        d = {
            INVALID_CUSTOM_TOKEN: "invalid-custom-token",
            CREDENTIAL_MISMATCH: "custom-token-mismatch",
            MISSING_CUSTOM_TOKEN: "internal-error",
            INVALID_IDENTIFIER: "invalid-email",
            MISSING_CONTINUE_URI: "internal-error",
            INVALID_EMAIL: "invalid-email",
            INVALID_PASSWORD: "wrong-password",
            USER_DISABLED: "user-disabled",
            MISSING_PASSWORD: "internal-error",
            EMAIL_EXISTS: "email-already-in-use",
            PASSWORD_LOGIN_DISABLED: "operation-not-allowed",
            INVALID_IDP_RESPONSE: "invalid-credential",
            INVALID_PENDING_TOKEN: "invalid-credential",
            FEDERATED_USER_ID_ALREADY_LINKED: "credential-already-in-use",
            MISSING_OR_INVALID_NONCE: "missing-or-invalid-nonce",
            INVALID_MESSAGE_PAYLOAD: "invalid-message-payload",
            INVALID_RECIPIENT_EMAIL: "invalid-recipient-email",
            INVALID_SENDER: "invalid-sender",
            EMAIL_NOT_FOUND: "user-not-found",
            RESET_PASSWORD_EXCEED_LIMIT: "too-many-requests",
            EXPIRED_OOB_CODE: "expired-action-code",
            INVALID_OOB_CODE: "invalid-action-code",
            MISSING_OOB_CODE: "internal-error",
            INVALID_PROVIDER_ID: "invalid-provider-id",
            CREDENTIAL_TOO_OLD_LOGIN_AGAIN: "requires-recent-login",
            INVALID_ID_TOKEN: "invalid-user-token",
            TOKEN_EXPIRED: "user-token-expired",
            USER_NOT_FOUND: "user-token-expired",
            CORS_UNSUPPORTED: "cors-unsupported",
            DYNAMIC_LINK_NOT_ACTIVATED: "dynamic-link-not-activated",
            INVALID_APP_ID: "invalid-app-id",
            TOO_MANY_ATTEMPTS_TRY_LATER: "too-many-requests",
            WEAK_PASSWORD: "weak-password",
            OPERATION_NOT_ALLOWED: "operation-not-allowed",
            USER_CANCELLED: "user-cancelled",
            CAPTCHA_CHECK_FAILED: "captcha-check-failed",
            INVALID_APP_CREDENTIAL: "invalid-app-credential",
            INVALID_CODE: "invalid-verification-code",
            INVALID_PHONE_NUMBER: "invalid-phone-number",
            INVALID_SESSION_INFO: "invalid-verification-id",
            INVALID_TEMPORARY_PROOF: "invalid-credential",
            MISSING_APP_CREDENTIAL: "missing-app-credential",
            MISSING_CODE: "missing-verification-code",
            MISSING_PHONE_NUMBER: "missing-phone-number",
            MISSING_SESSION_INFO: "missing-verification-id",
            QUOTA_EXCEEDED: "quota-exceeded",
            SESSION_EXPIRED: "code-expired",
            REJECTED_CREDENTIAL: "rejected-credential",
            INVALID_CONTINUE_URI: "invalid-continue-uri",
            MISSING_ANDROID_PACKAGE_NAME: "missing-android-pkg-name",
            MISSING_IOS_BUNDLE_ID: "missing-ios-bundle-id",
            UNAUTHORIZED_DOMAIN: "unauthorized-continue-uri",
            INVALID_DYNAMIC_LINK_DOMAIN: "invalid-dynamic-link-domain",
            INVALID_OAUTH_CLIENT_ID: "invalid-oauth-client-id",
            INVALID_CERT_HASH: "invalid-cert-hash",
            UNSUPPORTED_TENANT_OPERATION: "unsupported-tenant-operation",
            INVALID_TENANT_ID: "invalid-tenant-id",
            TENANT_ID_MISMATCH: "tenant-id-mismatch",
            ADMIN_ONLY_OPERATION: "admin-restricted-operation",
            INVALID_MFA_PENDING_CREDENTIAL: "invalid-multi-factor-session",
            MFA_ENROLLMENT_NOT_FOUND: "multi-factor-info-not-found",
            MISSING_MFA_PENDING_CREDENTIAL: "missing-multi-factor-session",
            MISSING_MFA_ENROLLMENT_ID: "missing-multi-factor-info",
            EMAIL_CHANGE_NEEDS_VERIFICATION: "email-change-needs-verification",
            SECOND_FACTOR_EXISTS: "second-factor-already-in-use",
            SECOND_FACTOR_LIMIT_EXCEEDED: "maximum-second-factor-count-exceeded",
            UNSUPPORTED_FIRST_FACTOR: "unsupported-first-factor",
            UNVERIFIED_EMAIL: "unverified-email"
        };
        z(d, b || {});
        b = (b = c.match(/^[^\s]+\s*:\s*([\s\S]*)$/)) && 1 < b.length ? b[1] : void 0;
        for(var e in d)if (0 === c.indexOf(e)) return new t(d[e], b);
        !b && a && (b = Pe(a));
        return new t("internal-error", b);
    }
    function Ij(a) {
        this.b = a;
        this.a = null;
        this.qb = Jj(this);
    }
    function Jj(a) {
        return Kj().then(function() {
            return new C(function(b, c) {
                L("gapi.iframes.getContext")().open({
                    where: document.body,
                    url: a.b,
                    messageHandlersFilter: L("gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER"),
                    attributes: {
                        style: {
                            position: "absolute",
                            top: "-100px",
                            width: "1px",
                            height: "1px"
                        }
                    },
                    dontclear: !0
                }, function(d) {
                    function e() {
                        clearTimeout(f);
                        b();
                    }
                    a.a = d;
                    a.a.restyle({
                        setHideOnLeave: !1
                    });
                    var f = setTimeout(function() {
                        c(Error("Network Error"));
                    }, Lj.get());
                    d.ping(e).then(e, function() {
                        c(Error("Network Error"));
                    });
                });
            });
        });
    }
    function Mj(a, b) {
        return a.qb.then(function() {
            return new C(function(c) {
                a.a.send(b.type, b, c, L("gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER"));
            });
        });
    }
    function Nj(a, b) {
        a.qb.then(function() {
            a.a.register("authEvent", b, L("gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER"));
        });
    }
    var Oj = new ob(pb, "https://apis.google.com/js/api.js?onload=%{onload}"), Pj = new Ue(3E4, 6E4), Lj = new Ue(5E3, 15E3), Qj = null;
    function Kj() {
        return Qj ? Qj : Qj = new C(function(a, b) {
            function c() {
                Te();
                L("gapi.load")("gapi.iframes", {
                    callback: a,
                    ontimeout: function() {
                        Te();
                        b(Error("Network Error"));
                    },
                    timeout: Pj.get()
                });
            }
            if (L("gapi.iframes.Iframe")) a();
            else if (L("gapi.load")) c();
            else {
                var d = "__iframefcb" + Math.floor(1E6 * Math.random()).toString();
                l[d] = function() {
                    L("gapi.load") ? c() : b(Error("Network Error"));
                };
                d = xb(Oj, {
                    onload: d
                });
                D(xi(d)).s(function() {
                    b(Error("Network Error"));
                });
            }
        }).s(function(a) {
            Qj = null;
            throw a;
        });
    }
    function Rj(a, b, c, d) {
        this.l = a;
        this.h = b;
        this.i = c;
        this.g = d;
        this.f = null;
        this.g ? (a = J(this.g.url), a = Yd(a.f, a.a, a.g, "/emulator/auth/iframe")) : a = Yd("https", this.l, null, "/__/auth/iframe");
        this.a = a;
        I(this.a, "apiKey", this.h);
        I(this.a, "appName", this.i);
        this.b = null;
        this.c = [];
    }
    Rj.prototype.toString = function() {
        this.f ? I(this.a, "v", this.f) : de(this.a.b, "v");
        this.b ? I(this.a, "eid", this.b) : de(this.a.b, "eid");
        this.c.length ? I(this.a, "fw", this.c.join(",")) : de(this.a.b, "fw");
        return this.a.toString();
    };
    function Sj(a, b, c, d, e, f) {
        this.u = a;
        this.o = b;
        this.c = c;
        this.v = d;
        this.m = f;
        this.i = this.g = this.l = null;
        this.a = e;
        this.h = this.f = null;
    }
    Sj.prototype.xb = function(a) {
        this.h = a;
        return this;
    };
    Sj.prototype.toString = function() {
        if (this.m) {
            var a = J(this.m.url);
            a = Yd(a.f, a.a, a.g, "/emulator/auth/handler");
        } else a = Yd("https", this.u, null, "/__/auth/handler");
        I(a, "apiKey", this.o);
        I(a, "appName", this.c);
        I(a, "authType", this.v);
        if (this.a.isOAuthProvider) {
            var b = this.a;
            try {
                var c = firebase.app(this.c).auth().ka();
            } catch (h) {
                c = null;
            }
            b.nb = c;
            I(a, "providerId", this.a.providerId);
            c = this.a;
            b = Qe(c.Hb);
            for(var d in b)b[d] = b[d].toString();
            d = c.Pc;
            b = lb(b);
            for(var e = 0; e < d.length; e++){
                var f = d[e];
                f in b && delete b[f];
            }
            c.ob && c.nb && !b[c.ob] && (b[c.ob] = c.nb);
            kb(b) || I(a, "customParameters", Pe(b));
        }
        "function" === typeof this.a.Pb && (c = this.a.Pb(), c.length && I(a, "scopes", c.join(",")));
        this.l ? I(a, "redirectUrl", this.l) : de(a.b, "redirectUrl");
        this.g ? I(a, "eventId", this.g) : de(a.b, "eventId");
        this.i ? I(a, "v", this.i) : de(a.b, "v");
        if (this.b) for(var g in this.b)this.b.hasOwnProperty(g) && !Xd(a, g) && I(a, g, this.b[g]);
        this.h ? I(a, "tid", this.h) : de(a.b, "tid");
        this.f ? I(a, "eid", this.f) : de(a.b, "eid");
        g = Tj(this.c);
        g.length && I(a, "fw", g.join(","));
        return a.toString();
    };
    function Tj(a) {
        try {
            return firebase.app(a).auth().Ga();
        } catch (b) {
            return [];
        }
    }
    function Uj(a, b, c, d, e, f) {
        this.o = a;
        this.g = b;
        this.b = c;
        this.f = f;
        this.c = d || null;
        this.i = e || null;
        this.l = this.u = this.A = null;
        this.h = [];
        this.v = this.a = null;
    }
    function Vj(a) {
        var b = me();
        return Zi(a).then(function(c) {
            a: {
                var d = J(b), e = d.f;
                d = d.a;
                for(var f = 0; f < c.length; f++){
                    var g = c[f];
                    var h = d;
                    var m = e;
                    0 == g.indexOf("chrome-extension://") ? h = J(g).a == h && "chrome-extension" == m : "http" != m && "https" != m ? h = !1 : xe.test(g) ? h = h == g : (g = g.split(".").join("\\."), h = new RegExp("^(.+\\." + g + "|" + g + ")$", "i").test(h));
                    if (h) {
                        c = !0;
                        break a;
                    }
                }
                c = !1;
            }
            if (!c) throw new th(me());
        });
    }
    function Wj(a) {
        if (a.v) return a.v;
        a.v = ze().then(function() {
            if (!a.u) {
                var b = a.c, c = a.i, d = Tj(a.b), e = new Rj(a.o, a.g, a.b, a.f);
                e.f = b;
                e.b = c;
                e.c = Xa(d || []);
                a.u = e.toString();
            }
            a.m = new Ij(a.u);
            Xj(a);
        });
        return a.v;
    }
    k = Uj.prototype;
    k.Nb = function(a, b, c) {
        var d = new t("popup-closed-by-user"), e = new t("web-storage-unsupported"), f = this, g = !1;
        return this.la().then(function() {
            Yj(f).then(function(h) {
                h || (a && te(a), b(e), g = !0);
            });
        }).s(function() {}).then(function() {
            if (!g) return we(a);
        }).then(function() {
            if (!g) return Ad(c).then(function() {
                b(d);
            });
        });
    };
    k.Wb = function() {
        var a = K();
        return !Oe(a) && !Se(a);
    };
    k.Sb = function() {
        return !1;
    };
    k.Lb = function(a, b, c, d, e, f, g, h) {
        if (!a) return E(new t("popup-blocked"));
        if (g && !Oe()) return this.la().s(function(p) {
            te(a);
            e(p);
        }), d(), D();
        this.a || (this.a = Vj(Zj(this)));
        var m = this;
        return this.a.then(function() {
            var p = m.la().s(function(v) {
                te(a);
                e(v);
                throw v;
            });
            d();
            return p;
        }).then(function() {
            nh(c);
            if (!g) {
                var p = ak(m.o, m.g, m.b, b, c, null, f, m.c, void 0, m.i, h, m.f);
                ne(p, a);
            }
        }).s(function(p) {
            "auth/network-request-failed" == p.code && (m.a = null);
            throw p;
        });
    };
    function Zj(a) {
        a.l || (a.A = a.c ? Je(a.c, Tj(a.b)) : null, a.l = new Ei(a.g, Aa(a.i), a.A), a.f && Li(a.l, a.f));
        return a.l;
    }
    k.Mb = function(a, b, c, d) {
        this.a || (this.a = Vj(Zj(this)));
        var e = this;
        return this.a.then(function() {
            nh(b);
            var f = ak(e.o, e.g, e.b, a, b, me(), c, e.c, void 0, e.i, d, e.f);
            ne(f);
        }).s(function(f) {
            "auth/network-request-failed" == f.code && (e.a = null);
            throw f;
        });
    };
    k.la = function() {
        var a = this;
        return Wj(this).then(function() {
            return a.m.qb;
        }).s(function() {
            a.a = null;
            throw new t("network-request-failed");
        });
    };
    k.Zb = function() {
        return !0;
    };
    function ak(a, b, c, d, e, f, g, h, m, p, v, B) {
        a = new Sj(a, b, c, d, e, B);
        a.l = f;
        a.g = g;
        a.i = h;
        a.b = lb(m || null);
        a.f = p;
        return a.xb(v).toString();
    }
    function Xj(a) {
        if (!a.m) throw Error("IfcHandler must be initialized!");
        Nj(a.m, function(b) {
            var c = {};
            if (b && b.authEvent) {
                var d = !1;
                b = ph(b.authEvent);
                for(c = 0; c < a.h.length; c++)d = a.h[c](b) || d;
                c = {};
                c.status = d ? "ACK" : "ERROR";
                return D(c);
            }
            c.status = "ERROR";
            return D(c);
        });
    }
    function Yj(a) {
        var b = {
            type: "webStorageSupport"
        };
        return Wj(a).then(function() {
            return Mj(a.m, b);
        }).then(function(c) {
            if (c && c.length && "undefined" !== typeof c[0].webStorageSupport) return c[0].webStorageSupport;
            throw Error();
        });
    }
    k.Ea = function(a) {
        this.h.push(a);
    };
    k.Ra = function(a) {
        Va(this.h, function(b) {
            return b == a;
        });
    };
    function bk(a) {
        this.a = a || firebase.INTERNAL.reactNative && firebase.INTERNAL.reactNative.AsyncStorage;
        if (!this.a) throw new t("internal-error", "The React Native compatibility library was not found.");
        this.type = "asyncStorage";
    }
    k = bk.prototype;
    k.get = function(a) {
        return D(this.a.getItem(a)).then(function(b) {
            return b && Re(b);
        });
    };
    k.set = function(a, b) {
        return D(this.a.setItem(a, Pe(b)));
    };
    k.T = function(a) {
        return D(this.a.removeItem(a));
    };
    k.ca = function() {};
    k.ia = function() {};
    function ck(a) {
        this.b = a;
        this.a = {};
        this.f = q(this.c, this);
    }
    var dk = [];
    function ek() {
        var a = Ee() ? self : null;
        w(dk, function(c) {
            c.b == a && (b = c);
        });
        if (!b) {
            var b = new ck(a);
            dk.push(b);
        }
        return b;
    }
    ck.prototype.c = function(a) {
        var b = a.data.eventType, c = a.data.eventId, d = this.a[b];
        if (d && 0 < d.length) {
            a.ports[0].postMessage({
                status: "ack",
                eventId: c,
                eventType: b,
                response: null
            });
            var e = [];
            w(d, function(f) {
                e.push(D().then(function() {
                    return f(a.origin, a.data.data);
                }));
            });
            Fc(e).then(function(f) {
                var g = [];
                w(f, function(h) {
                    g.push({
                        fulfilled: h.Ob,
                        value: h.value,
                        reason: h.reason ? h.reason.message : void 0
                    });
                });
                w(g, function(h) {
                    for(var m in h)"undefined" === typeof h[m] && delete h[m];
                });
                a.ports[0].postMessage({
                    status: "done",
                    eventId: c,
                    eventType: b,
                    response: g
                });
            });
        }
    };
    function fk(a, b, c) {
        kb(a.a) && a.b.addEventListener("message", a.f);
        "undefined" === typeof a.a[b] && (a.a[b] = []);
        a.a[b].push(c);
    }
    function gk(a) {
        this.a = a;
    }
    gk.prototype.postMessage = function(a, b) {
        this.a.postMessage(a, b);
    };
    function hk(a) {
        this.c = a;
        this.b = !1;
        this.a = [];
    }
    function ik(a, b, c, d) {
        var e, f = c || {}, g, h, m, p = null;
        if (a.b) return E(Error("connection_unavailable"));
        var v = d ? 800 : 50, B = "undefined" !== typeof MessageChannel ? new MessageChannel : null;
        return new C(function(A, Q) {
            B ? (e = Math.floor(Math.random() * Math.pow(10, 20)).toString(), B.port1.start(), h = setTimeout(function() {
                Q(Error("unsupported_event"));
            }, v), g = function(xa) {
                xa.data.eventId === e && ("ack" === xa.data.status ? (clearTimeout(h), m = setTimeout(function() {
                    Q(Error("timeout"));
                }, 3E3)) : "done" === xa.data.status ? (clearTimeout(m), "undefined" !== typeof xa.data.response ? A(xa.data.response) : Q(Error("unknown_error"))) : (clearTimeout(h), clearTimeout(m), Q(Error("invalid_response"))));
            }, p = {
                messageChannel: B,
                onMessage: g
            }, a.a.push(p), B.port1.addEventListener("message", g), a.c.postMessage({
                eventType: b,
                eventId: e,
                data: f
            }, [
                B.port2
            ])) : Q(Error("connection_unavailable"));
        }).then(function(A) {
            jk(a, p);
            return A;
        }).s(function(A) {
            jk(a, p);
            throw A;
        });
    }
    function jk(a, b) {
        if (b) {
            var c = b.messageChannel, d = b.onMessage;
            c && (c.port1.removeEventListener("message", d), c.port1.close());
            Va(a.a, function(e) {
                return e == b;
            });
        }
    }
    hk.prototype.close = function() {
        for(; 0 < this.a.length;)jk(this, this.a[0]);
        this.b = !0;
    };
    function kk() {
        if (!lk()) throw new t("web-storage-unsupported");
        this.c = {};
        this.a = [];
        this.b = 0;
        this.m = l.indexedDB;
        this.type = "indexedDB";
        this.g = this.l = this.f = this.i = null;
        this.o = !1;
        this.h = null;
        var a = this;
        Ee() && self ? (this.l = ek(), fk(this.l, "keyChanged", function(b, c) {
            return mk(a).then(function(d) {
                0 < d.length && w(a.a, function(e) {
                    e(d);
                });
                return {
                    keyProcessed: Ta(d, c.key)
                };
            });
        }), fk(this.l, "ping", function() {
            return D([
                "keyChanged"
            ]);
        })) : af().then(function(b) {
            if (a.h = b) a.g = new hk(new gk(b)), ik(a.g, "ping", null, !0).then(function(c) {
                c[0].fulfilled && Ta(c[0].value, "keyChanged") && (a.o = !0);
            }).s(function() {});
        });
    }
    var nk;
    function ok(a) {
        return new C(function(b, c) {
            var d = a.m.deleteDatabase("firebaseLocalStorageDb");
            d.onsuccess = function() {
                b();
            };
            d.onerror = function(e) {
                c(Error(e.target.error));
            };
        });
    }
    function pk(a) {
        return new C(function(b, c) {
            var d = a.m.open("firebaseLocalStorageDb", 1);
            d.onerror = function(e) {
                try {
                    e.preventDefault();
                } catch (f) {}
                c(Error(e.target.error));
            };
            d.onupgradeneeded = function(e) {
                e = e.target.result;
                try {
                    e.createObjectStore("firebaseLocalStorage", {
                        keyPath: "fbase_key"
                    });
                } catch (f) {
                    c(f);
                }
            };
            d.onsuccess = function(e) {
                e = e.target.result;
                e.objectStoreNames.contains("firebaseLocalStorage") ? b(e) : ok(a).then(function() {
                    return pk(a);
                }).then(function(f) {
                    b(f);
                }).s(function(f) {
                    c(f);
                });
            };
        });
    }
    function qk(a) {
        a.v || (a.v = pk(a));
        return a.v;
    }
    function lk() {
        try {
            return !!l.indexedDB;
        } catch (a) {
            return !1;
        }
    }
    function rk(a) {
        return a.objectStore("firebaseLocalStorage");
    }
    function sk(a, b) {
        return a.transaction([
            "firebaseLocalStorage"
        ], b ? "readwrite" : "readonly");
    }
    function tk(a) {
        return new C(function(b, c) {
            a.onsuccess = function(d) {
                d && d.target ? b(d.target.result) : b();
            };
            a.onerror = function(d) {
                c(d.target.error);
            };
        });
    }
    k = kk.prototype;
    k.set = function(a, b) {
        var c = !1, d, e = this;
        return qk(this).then(function(f) {
            d = f;
            f = rk(sk(d, !0));
            return tk(f.get(a));
        }).then(function(f) {
            var g = rk(sk(d, !0));
            if (f) return f.value = b, tk(g.put(f));
            e.b++;
            c = !0;
            f = {};
            f.fbase_key = a;
            f.value = b;
            return tk(g.add(f));
        }).then(function() {
            e.c[a] = b;
            return uk(e, a);
        }).na(function() {
            c && e.b--;
        });
    };
    function uk(a, b) {
        return a.g && a.h && $e() === a.h ? ik(a.g, "keyChanged", {
            key: b
        }, a.o).then(function() {}).s(function() {}) : D();
    }
    k.get = function(a) {
        return qk(this).then(function(b) {
            return tk(rk(sk(b, !1)).get(a));
        }).then(function(b) {
            return b && b.value;
        });
    };
    k.T = function(a) {
        var b = !1, c = this;
        return qk(this).then(function(d) {
            b = !0;
            c.b++;
            return tk(rk(sk(d, !0))["delete"](a));
        }).then(function() {
            delete c.c[a];
            return uk(c, a);
        }).na(function() {
            b && c.b--;
        });
    };
    function mk(a) {
        return qk(a).then(function(b) {
            var c = rk(sk(b, !1));
            return c.getAll ? tk(c.getAll()) : new C(function(d, e) {
                var f = [], g = c.openCursor();
                g.onsuccess = function(h) {
                    (h = h.target.result) ? (f.push(h.value), h["continue"]()) : d(f);
                };
                g.onerror = function(h) {
                    e(h.target.error);
                };
            });
        }).then(function(b) {
            var c = {}, d = [];
            if (0 == a.b) {
                for(d = 0; d < b.length; d++)c[b[d].fbase_key] = b[d].value;
                d = oe(a.c, c);
                a.c = c;
            }
            return d;
        });
    }
    k.ca = function(a) {
        0 == this.a.length && vk(this);
        this.a.push(a);
    };
    k.ia = function(a) {
        Va(this.a, function(b) {
            return b == a;
        });
        0 == this.a.length && wk(this);
    };
    function vk(a) {
        function b() {
            a.f = setTimeout(function() {
                a.i = mk(a).then(function(c) {
                    0 < c.length && w(a.a, function(d) {
                        d(c);
                    });
                }).then(function() {
                    b();
                }).s(function(c) {
                    "STOP_EVENT" != c.message && b();
                });
            }, 800);
        }
        wk(a);
        b();
    }
    function wk(a) {
        a.i && a.i.cancel("STOP_EVENT");
        a.f && (clearTimeout(a.f), a.f = null);
    }
    function xk(a) {
        var b = this, c = null;
        this.a = [];
        this.type = "indexedDB";
        this.c = a;
        this.b = D().then(function() {
            if (lk()) {
                var d = Le(), e = "__sak" + d;
                nk || (nk = new kk);
                c = nk;
                return c.set(e, d).then(function() {
                    return c.get(e);
                }).then(function(f) {
                    if (f !== d) throw Error("indexedDB not supported!");
                    return c.T(e);
                }).then(function() {
                    return c;
                }).s(function() {
                    return b.c;
                });
            }
            return b.c;
        }).then(function(d) {
            b.type = d.type;
            d.ca(function(e) {
                w(b.a, function(f) {
                    f(e);
                });
            });
            return d;
        });
    }
    k = xk.prototype;
    k.get = function(a) {
        return this.b.then(function(b) {
            return b.get(a);
        });
    };
    k.set = function(a, b) {
        return this.b.then(function(c) {
            return c.set(a, b);
        });
    };
    k.T = function(a) {
        return this.b.then(function(b) {
            return b.T(a);
        });
    };
    k.ca = function(a) {
        this.a.push(a);
    };
    k.ia = function(a) {
        Va(this.a, function(b) {
            return b == a;
        });
    };
    function yk() {
        this.a = {};
        this.type = "inMemory";
    }
    k = yk.prototype;
    k.get = function(a) {
        return D(this.a[a]);
    };
    k.set = function(a, b) {
        this.a[a] = b;
        return D();
    };
    k.T = function(a) {
        delete this.a[a];
        return D();
    };
    k.ca = function() {};
    k.ia = function() {};
    function zk() {
        if (!Ak()) {
            if ("Node" == Fe()) throw new t("internal-error", "The LocalStorage compatibility library was not found.");
            throw new t("web-storage-unsupported");
        }
        this.a = Bk() || firebase.INTERNAL.node.localStorage;
        this.type = "localStorage";
    }
    function Bk() {
        try {
            var a = l.localStorage, b = Le();
            a && (a.setItem(b, "1"), a.removeItem(b));
            return a;
        } catch (c) {
            return null;
        }
    }
    function Ak() {
        var a = "Node" == Fe();
        a = Bk() || a && firebase.INTERNAL.node && firebase.INTERNAL.node.localStorage;
        if (!a) return !1;
        try {
            return a.setItem("__sak", "1"), a.removeItem("__sak"), !0;
        } catch (b) {
            return !1;
        }
    }
    k = zk.prototype;
    k.get = function(a) {
        var b = this;
        return D().then(function() {
            var c = b.a.getItem(a);
            return Re(c);
        });
    };
    k.set = function(a, b) {
        var c = this;
        return D().then(function() {
            var d = Pe(b);
            null === d ? c.T(a) : c.a.setItem(a, d);
        });
    };
    k.T = function(a) {
        var b = this;
        return D().then(function() {
            b.a.removeItem(a);
        });
    };
    k.ca = function(a) {
        l.window && jd(l.window, "storage", a);
    };
    k.ia = function(a) {
        l.window && G(l.window, "storage", a);
    };
    function Ck() {
        this.type = "nullStorage";
    }
    k = Ck.prototype;
    k.get = function() {
        return D(null);
    };
    k.set = function() {
        return D();
    };
    k.T = function() {
        return D();
    };
    k.ca = function() {};
    k.ia = function() {};
    function Dk() {
        if (!Ek()) {
            if ("Node" == Fe()) throw new t("internal-error", "The SessionStorage compatibility library was not found.");
            throw new t("web-storage-unsupported");
        }
        this.a = Fk() || firebase.INTERNAL.node.sessionStorage;
        this.type = "sessionStorage";
    }
    function Fk() {
        try {
            var a = l.sessionStorage, b = Le();
            a && (a.setItem(b, "1"), a.removeItem(b));
            return a;
        } catch (c) {
            return null;
        }
    }
    function Ek() {
        var a = "Node" == Fe();
        a = Fk() || a && firebase.INTERNAL.node && firebase.INTERNAL.node.sessionStorage;
        if (!a) return !1;
        try {
            return a.setItem("__sak", "1"), a.removeItem("__sak"), !0;
        } catch (b) {
            return !1;
        }
    }
    k = Dk.prototype;
    k.get = function(a) {
        var b = this;
        return D().then(function() {
            var c = b.a.getItem(a);
            return Re(c);
        });
    };
    k.set = function(a, b) {
        var c = this;
        return D().then(function() {
            var d = Pe(b);
            null === d ? c.T(a) : c.a.setItem(a, d);
        });
    };
    k.T = function(a) {
        var b = this;
        return D().then(function() {
            b.a.removeItem(a);
        });
    };
    k.ca = function() {};
    k.ia = function() {};
    function Gk() {
        var a = {};
        a.Browser = Hk;
        a.Node = Ik;
        a.ReactNative = Jk;
        a.Worker = Kk;
        this.a = a[Fe()];
    }
    var Lk, Hk = {
        D: zk,
        ab: Dk
    }, Ik = {
        D: zk,
        ab: Dk
    }, Jk = {
        D: bk,
        ab: Ck
    }, Kk = {
        D: zk,
        ab: Ck
    }; /*

 Copyright 2017 Google LLC

 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

   http://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
*/ 
    var Mk = {
        qd: "local",
        NONE: "none",
        sd: "session"
    };
    function Nk(a) {
        var b = new t("invalid-persistence-type"), c = new t("unsupported-persistence-type");
        a: {
            for(d in Mk)if (Mk[d] == a) {
                var d = !0;
                break a;
            }
            d = !1;
        }
        if (!d || "string" !== typeof a) throw b;
        switch(Fe()){
            case "ReactNative":
                if ("session" === a) throw c;
                break;
            case "Node":
                if ("none" !== a) throw c;
                break;
            case "Worker":
                if ("session" === a || !lk() && "none" !== a) throw c;
                break;
            default:
                if (!Ke() && "none" !== a) throw c;
        }
    }
    function Ok() {
        var a = !Se(K()) && De() ? !0 : !1, b = Oe(), c = Ke();
        this.v = a;
        this.h = b;
        this.l = c;
        this.a = {};
        Lk || (Lk = new Gk);
        a = Lk;
        try {
            this.g = !le() && Ze() || !l.indexedDB ? new a.a.D : new xk(Ee() ? new yk : new a.a.D);
        } catch (d) {
            this.g = new yk, this.h = !0;
        }
        try {
            this.i = new a.a.ab;
        } catch (d) {
            this.i = new yk;
        }
        this.m = new yk;
        this.f = q(this.Xb, this);
        this.b = {};
    }
    var Pk;
    function Qk() {
        Pk || (Pk = new Ok);
        return Pk;
    }
    function Rk(a, b) {
        switch(b){
            case "session":
                return a.i;
            case "none":
                return a.m;
            default:
                return a.g;
        }
    }
    function Sk(a, b) {
        return "firebase:" + a.name + (b ? ":" + b : "");
    }
    function Tk(a, b, c) {
        var d = Sk(b, c), e = Rk(a, b.D);
        return a.get(b, c).then(function(f) {
            var g = null;
            try {
                g = Re(l.localStorage.getItem(d));
            } catch (h) {}
            if (g && !f) return l.localStorage.removeItem(d), a.set(b, g, c);
            g && f && "localStorage" != e.type && l.localStorage.removeItem(d);
        });
    }
    k = Ok.prototype;
    k.get = function(a, b) {
        return Rk(this, a.D).get(Sk(a, b));
    };
    function Uk(a, b, c) {
        c = Sk(b, c);
        "local" == b.D && (a.b[c] = null);
        return Rk(a, b.D).T(c);
    }
    k.set = function(a, b, c) {
        var d = Sk(a, c), e = this, f = Rk(this, a.D);
        return f.set(d, b).then(function() {
            return f.get(d);
        }).then(function(g) {
            "local" == a.D && (e.b[d] = g);
        });
    };
    k.addListener = function(a, b, c) {
        a = Sk(a, b);
        this.l && (this.b[a] = l.localStorage.getItem(a));
        kb(this.a) && (Rk(this, "local").ca(this.f), this.h || (le() || !Ze()) && l.indexedDB || !this.l || Vk(this));
        this.a[a] || (this.a[a] = []);
        this.a[a].push(c);
    };
    k.removeListener = function(a, b, c) {
        a = Sk(a, b);
        this.a[a] && (Va(this.a[a], function(d) {
            return d == c;
        }), 0 == this.a[a].length && delete this.a[a]);
        kb(this.a) && (Rk(this, "local").ia(this.f), Wk(this));
    };
    function Vk(a) {
        Wk(a);
        a.c = setInterval(function() {
            for(var b in a.a){
                var c = l.localStorage.getItem(b), d = a.b[b];
                c != d && (a.b[b] = c, c = new Yc({
                    type: "storage",
                    key: b,
                    target: window,
                    oldValue: d,
                    newValue: c,
                    a: !0
                }), a.Xb(c));
            }
        }, 1E3);
    }
    function Wk(a) {
        a.c && (clearInterval(a.c), a.c = null);
    }
    k.Xb = function(a) {
        if (a && a.g) {
            var b = a.a.key;
            if (null == b) for(var c in this.a){
                var d = this.b[c];
                "undefined" === typeof d && (d = null);
                var e = l.localStorage.getItem(c);
                e !== d && (this.b[c] = e, this.lb(c));
            }
            else if (0 == b.indexOf("firebase:") && this.a[b]) {
                "undefined" !== typeof a.a.a ? Rk(this, "local").ia(this.f) : Wk(this);
                if (this.v) {
                    if (c = l.localStorage.getItem(b), d = a.a.newValue, d !== c) null !== d ? l.localStorage.setItem(b, d) : l.localStorage.removeItem(b);
                    else if (this.b[b] === d && "undefined" === typeof a.a.a) return;
                }
                var f = this;
                c = function() {
                    if ("undefined" !== typeof a.a.a || f.b[b] !== l.localStorage.getItem(b)) f.b[b] = l.localStorage.getItem(b), f.lb(b);
                };
                Tb && dc && 10 == dc && l.localStorage.getItem(b) !== a.a.newValue && a.a.newValue !== a.a.oldValue ? setTimeout(c, 10) : c();
            }
        } else w(a, q(this.lb, this));
    };
    k.lb = function(a) {
        this.a[a] && w(this.a[a], function(b) {
            b();
        });
    };
    function Xk(a) {
        this.a = a;
        this.b = Qk();
    }
    var Yk = {
        name: "authEvent",
        D: "local"
    };
    function Zk(a) {
        return a.b.get(Yk, a.a).then(function(b) {
            return ph(b);
        });
    }
    function $k() {
        this.a = Qk();
    }
    function al() {
        this.b = -1;
    }
    function bl(a, b) {
        this.b = cl;
        this.f = l.Uint8Array ? new Uint8Array(this.b) : Array(this.b);
        this.g = this.c = 0;
        this.a = [];
        this.i = a;
        this.h = b;
        this.l = l.Int32Array ? new Int32Array(64) : Array(64);
        void 0 === dl && (l.Int32Array ? dl = new Int32Array(el) : dl = el);
        this.reset();
    }
    var dl;
    r(bl, al);
    for(var cl = 64, fl = cl - 1, gl = [], hl = 0; hl < fl; hl++)gl[hl] = 0;
    var il = Wa(128, gl);
    bl.prototype.reset = function() {
        this.g = this.c = 0;
        this.a = l.Int32Array ? new Int32Array(this.h) : Xa(this.h);
    };
    function jl(a) {
        for(var b = a.f, c = a.l, d = 0, e = 0; e < b.length;)c[d++] = b[e] << 24 | b[e + 1] << 16 | b[e + 2] << 8 | b[e + 3], e = 4 * d;
        for(b = 16; 64 > b; b++){
            e = c[b - 15] | 0;
            d = c[b - 2] | 0;
            var f = (c[b - 16] | 0) + ((e >>> 7 | e << 25) ^ (e >>> 18 | e << 14) ^ e >>> 3) | 0, g = (c[b - 7] | 0) + ((d >>> 17 | d << 15) ^ (d >>> 19 | d << 13) ^ d >>> 10) | 0;
            c[b] = f + g | 0;
        }
        d = a.a[0] | 0;
        e = a.a[1] | 0;
        var h = a.a[2] | 0, m = a.a[3] | 0, p = a.a[4] | 0, v = a.a[5] | 0, B = a.a[6] | 0;
        f = a.a[7] | 0;
        for(b = 0; 64 > b; b++){
            var A = ((d >>> 2 | d << 30) ^ (d >>> 13 | d << 19) ^ (d >>> 22 | d << 10)) + (d & e ^ d & h ^ e & h) | 0;
            g = p & v ^ ~p & B;
            f = f + ((p >>> 6 | p << 26) ^ (p >>> 11 | p << 21) ^ (p >>> 25 | p << 7)) | 0;
            g = g + (dl[b] | 0) | 0;
            g = f + (g + (c[b] | 0) | 0) | 0;
            f = B;
            B = v;
            v = p;
            p = m + g | 0;
            m = h;
            h = e;
            e = d;
            d = g + A | 0;
        }
        a.a[0] = a.a[0] + d | 0;
        a.a[1] = a.a[1] + e | 0;
        a.a[2] = a.a[2] + h | 0;
        a.a[3] = a.a[3] + m | 0;
        a.a[4] = a.a[4] + p | 0;
        a.a[5] = a.a[5] + v | 0;
        a.a[6] = a.a[6] + B | 0;
        a.a[7] = a.a[7] + f | 0;
    }
    function kl(a, b, c) {
        void 0 === c && (c = b.length);
        var d = 0, e = a.c;
        if ("string" === typeof b) for(; d < c;)a.f[e++] = b.charCodeAt(d++), e == a.b && (jl(a), e = 0);
        else if (ma(b)) for(; d < c;){
            var f = b[d++];
            if (!("number" == typeof f && 0 <= f && 255 >= f && f == (f | 0))) throw Error("message must be a byte array");
            a.f[e++] = f;
            e == a.b && (jl(a), e = 0);
        }
        else throw Error("message must be string or array");
        a.c = e;
        a.g += c;
    }
    var el = [
        1116352408,
        1899447441,
        3049323471,
        3921009573,
        961987163,
        1508970993,
        2453635748,
        2870763221,
        3624381080,
        310598401,
        607225278,
        1426881987,
        1925078388,
        2162078206,
        2614888103,
        3248222580,
        3835390401,
        4022224774,
        264347078,
        604807628,
        770255983,
        1249150122,
        1555081692,
        1996064986,
        2554220882,
        2821834349,
        2952996808,
        3210313671,
        3336571891,
        3584528711,
        113926993,
        338241895,
        666307205,
        773529912,
        1294757372,
        1396182291,
        1695183700,
        1986661051,
        2177026350,
        2456956037,
        2730485921,
        2820302411,
        3259730800,
        3345764771,
        3516065817,
        3600352804,
        4094571909,
        275423344,
        430227734,
        506948616,
        659060556,
        883997877,
        958139571,
        1322822218,
        1537002063,
        1747873779,
        1955562222,
        2024104815,
        2227730452,
        2361852424,
        2428436474,
        2756734187,
        3204031479,
        3329325298
    ];
    function ll() {
        bl.call(this, 8, ml);
    }
    r(ll, bl);
    var ml = [
        1779033703,
        3144134277,
        1013904242,
        2773480762,
        1359893119,
        2600822924,
        528734635,
        1541459225
    ];
    function nl(a, b, c, d, e, f) {
        this.m = a;
        this.i = b;
        this.l = c;
        this.v = d || null;
        this.u = e || null;
        this.o = f;
        this.h = b + ":" + c;
        this.A = new $k;
        this.g = new Xk(this.h);
        this.f = null;
        this.b = [];
        this.a = this.c = null;
    }
    function ol(a) {
        return new t("invalid-cordova-configuration", a);
    }
    k = nl.prototype;
    k.la = function() {
        return this.Ia ? this.Ia : this.Ia = Ae().then(function() {
            if ("function" !== typeof L("universalLinks.subscribe", l)) throw ol("cordova-universal-links-plugin-fix is not installed");
            if ("undefined" === typeof L("BuildInfo.packageName", l)) throw ol("cordova-plugin-buildinfo is not installed");
            if ("function" !== typeof L("cordova.plugins.browsertab.openUrl", l)) throw ol("cordova-plugin-browsertab is not installed");
            if ("function" !== typeof L("cordova.InAppBrowser.open", l)) throw ol("cordova-plugin-inappbrowser is not installed");
        }, function() {
            throw new t("cordova-not-ready");
        });
    };
    function pl() {
        for(var a = 20, b = []; 0 < a;)b.push("1234567890abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ".charAt(Math.floor(62 * Math.random()))), a--;
        return b.join("");
    }
    function ql(a) {
        var b = new ll;
        kl(b, a);
        a = [];
        var c = 8 * b.g;
        56 > b.c ? kl(b, il, 56 - b.c) : kl(b, il, b.b - (b.c - 56));
        for(var d = 63; 56 <= d; d--)b.f[d] = c & 255, c /= 256;
        jl(b);
        for(d = c = 0; d < b.i; d++)for(var e = 24; 0 <= e; e -= 8)a[c++] = b.a[d] >> e & 255;
        return Zf(a);
    }
    k.Nb = function(a, b) {
        b(new t("operation-not-supported-in-this-environment"));
        return D();
    };
    k.Lb = function() {
        return E(new t("operation-not-supported-in-this-environment"));
    };
    k.Zb = function() {
        return !1;
    };
    k.Wb = function() {
        return !0;
    };
    k.Sb = function() {
        return !0;
    };
    k.Mb = function(a, b, c, d) {
        if (this.c) return E(new t("redirect-operation-pending"));
        var e = this, f = l.document, g = null, h = null, m = null, p = null;
        return this.c = D().then(function() {
            nh(b);
            return rl(e);
        }).then(function() {
            return sl(e, a, b, c, d);
        }).then(function() {
            return new C(function(v, B) {
                h = function() {
                    var A = L("cordova.plugins.browsertab.close", l);
                    v();
                    "function" === typeof A && A();
                    e.a && "function" === typeof e.a.close && (e.a.close(), e.a = null);
                    return !1;
                };
                e.Ea(h);
                m = function() {
                    g || (g = Ad(2E3).then(function() {
                        B(new t("redirect-cancelled-by-user"));
                    }));
                };
                p = function() {
                    Ve() && m();
                };
                f.addEventListener("resume", m, !1);
                K().toLowerCase().match(/android/) || f.addEventListener("visibilitychange", p, !1);
            }).s(function(v) {
                return tl(e).then(function() {
                    throw v;
                });
            });
        }).na(function() {
            m && f.removeEventListener("resume", m, !1);
            p && f.removeEventListener("visibilitychange", p, !1);
            g && g.cancel();
            h && e.Ra(h);
            e.c = null;
        });
    };
    function sl(a, b, c, d, e) {
        var f = pl(), g = new oh(b, d, null, f, new t("no-auth-event"), null, e), h = L("BuildInfo.packageName", l);
        if ("string" !== typeof h) throw new t("invalid-cordova-configuration");
        var m = L("BuildInfo.displayName", l), p = {};
        if (K().toLowerCase().match(/iphone|ipad|ipod/)) p.ibi = h;
        else if (K().toLowerCase().match(/android/)) p.apn = h;
        else return E(new t("operation-not-supported-in-this-environment"));
        m && (p.appDisplayName = m);
        f = ql(f);
        p.sessionId = f;
        var v = ak(a.m, a.i, a.l, b, c, null, d, a.v, p, a.u, e, a.o);
        return a.la().then(function() {
            var B = a.h;
            return a.A.a.set(Yk, g.w(), B);
        }).then(function() {
            var B = L("cordova.plugins.browsertab.isAvailable", l);
            if ("function" !== typeof B) throw new t("invalid-cordova-configuration");
            var A = null;
            B(function(Q) {
                if (Q) {
                    A = L("cordova.plugins.browsertab.openUrl", l);
                    if ("function" !== typeof A) throw new t("invalid-cordova-configuration");
                    A(v);
                } else {
                    A = L("cordova.InAppBrowser.open", l);
                    if ("function" !== typeof A) throw new t("invalid-cordova-configuration");
                    Q = K();
                    a.a = A(v, Q.match(/(iPad|iPhone|iPod).*OS 7_\d/i) || Q.match(/(iPad|iPhone|iPod).*OS 8_\d/i) ? "_blank" : "_system", "location=yes");
                }
            });
        });
    }
    function ul(a, b) {
        for(var c = 0; c < a.b.length; c++)try {
            a.b[c](b);
        } catch (d) {}
    }
    function rl(a) {
        a.f || (a.f = a.la().then(function() {
            return new C(function(b) {
                function c(d) {
                    b(d);
                    a.Ra(c);
                    return !1;
                }
                a.Ea(c);
                vl(a);
            });
        }));
        return a.f;
    }
    function tl(a) {
        var b = null;
        return Zk(a.g).then(function(c) {
            b = c;
            c = a.g;
            return Uk(c.b, Yk, c.a);
        }).then(function() {
            return b;
        });
    }
    function vl(a) {
        function b(g) {
            d = !0;
            e && e.cancel();
            tl(a).then(function(h) {
                var m = c;
                if (h && g && g.url) {
                    var p = null;
                    m = tg(g.url);
                    -1 != m.indexOf("/__/auth/callback") && (p = J(m), p = Re(Xd(p, "firebaseError") || null), p = (p = "object" === typeof p ? ya(p) : null) ? new oh(h.c, h.b, null, null, p, null, h.S()) : new oh(h.c, h.b, m, h.f, null, null, h.S()));
                    m = p || c;
                }
                ul(a, m);
            });
        }
        var c = new oh("unknown", null, null, null, new t("no-auth-event")), d = !1, e = Ad(500).then(function() {
            return tl(a).then(function() {
                d || ul(a, c);
            });
        }), f = l.handleOpenURL;
        l.handleOpenURL = function(g) {
            0 == g.toLowerCase().indexOf(L("BuildInfo.packageName", l).toLowerCase() + "://") && b({
                url: g
            });
            if ("function" === typeof f) try {
                f(g);
            } catch (h) {
                console.error(h);
            }
        };
        rh || (rh = new qh);
        sh(b);
    }
    k.Ea = function(a) {
        this.b.push(a);
        rl(this).s(function(b) {
            "auth/invalid-cordova-configuration" === b.code && (b = new oh("unknown", null, null, null, new t("no-auth-event")), a(b));
        });
    };
    k.Ra = function(a) {
        Va(this.b, function(b) {
            return b == a;
        });
    };
    function wl(a) {
        this.a = a;
        this.b = Qk();
    }
    var xl = {
        name: "pendingRedirect",
        D: "session"
    };
    function yl(a) {
        return a.b.set(xl, "pending", a.a);
    }
    function zl(a) {
        return Uk(a.b, xl, a.a);
    }
    function Al(a) {
        return a.b.get(xl, a.a).then(function(b) {
            return "pending" == b;
        });
    }
    function Bl(a, b, c, d) {
        this.i = {};
        this.u = 0;
        this.O = a;
        this.m = b;
        this.v = c;
        this.G = d;
        this.h = [];
        this.f = !1;
        this.l = q(this.o, this);
        this.b = new Cl;
        this.A = new Dl;
        this.g = new wl(El(this.m, this.v));
        this.c = {};
        this.c.unknown = this.b;
        this.c.signInViaRedirect = this.b;
        this.c.linkViaRedirect = this.b;
        this.c.reauthViaRedirect = this.b;
        this.c.signInViaPopup = this.A;
        this.c.linkViaPopup = this.A;
        this.c.reauthViaPopup = this.A;
        this.a = Fl(this.O, this.m, this.v, Ba, this.G);
    }
    function Fl(a, b, c, d, e) {
        var f = firebase.SDK_VERSION || null;
        return Be() ? new nl(a, b, c, f, d, e) : new Uj(a, b, c, f, d, e);
    }
    Bl.prototype.reset = function() {
        this.f = !1;
        this.a.Ra(this.l);
        this.a = Fl(this.O, this.m, this.v, null, this.G);
        this.i = {};
    };
    function Gl(a) {
        a.f || (a.f = !0, a.a.Ea(a.l));
        var b = a.a;
        return a.a.la().s(function(c) {
            a.a == b && a.reset();
            throw c;
        });
    }
    function Hl(a) {
        a.a.Wb() && Gl(a).s(function(b) {
            var c = new oh("unknown", null, null, null, new t("operation-not-supported-in-this-environment"));
            Il(b) && a.o(c);
        });
        a.a.Sb() || Jl(a.b);
    }
    function Kl(a, b) {
        Ta(a.h, b) || a.h.push(b);
        a.f || Al(a.g).then(function(c) {
            c ? zl(a.g).then(function() {
                Gl(a).s(function(d) {
                    var e = new oh("unknown", null, null, null, new t("operation-not-supported-in-this-environment"));
                    Il(d) && a.o(e);
                });
            }) : Hl(a);
        }).s(function() {
            Hl(a);
        });
    }
    function Ll(a, b) {
        Va(a.h, function(c) {
            return c == b;
        });
    }
    Bl.prototype.o = function(a) {
        if (!a) throw new t("invalid-auth-event");
        6E5 <= ua() - this.u && (this.i = {}, this.u = 0);
        if (a && a.getUid() && this.i.hasOwnProperty(a.getUid())) return !1;
        for(var b = !1, c = 0; c < this.h.length; c++){
            var d = this.h[c];
            if (d.Eb(a.c, a.b)) {
                if (b = this.c[a.c]) b.h(a, d), a && (a.f || a.b) && (this.i[a.getUid()] = !0, this.u = ua());
                b = !0;
                break;
            }
        }
        Jl(this.b);
        return b;
    };
    var Ml = new Ue(2E3, 1E4), Nl = new Ue(3E4, 6E4);
    Bl.prototype.qa = function() {
        return this.b.qa();
    };
    function Ol(a, b, c, d, e, f, g) {
        return a.a.Lb(b, c, d, function() {
            a.f || (a.f = !0, a.a.Ea(a.l));
        }, function() {
            a.reset();
        }, e, f, g);
    }
    function Il(a) {
        return a && "auth/cordova-not-ready" == a.code ? !0 : !1;
    }
    function Pl(a, b, c, d, e) {
        var f;
        return yl(a.g).then(function() {
            return a.a.Mb(b, c, d, e).s(function(g) {
                if (Il(g)) throw new t("operation-not-supported-in-this-environment");
                f = g;
                return zl(a.g).then(function() {
                    throw f;
                });
            }).then(function() {
                return a.a.Zb() ? new C(function() {}) : zl(a.g).then(function() {
                    return a.qa();
                }).then(function() {}).s(function() {});
            });
        });
    }
    function Ql(a, b, c, d, e) {
        return a.a.Nb(d, function(f) {
            b.ma(c, null, f, e);
        }, Ml.get());
    }
    var Rl = {};
    function El(a, b, c) {
        a = a + ":" + b;
        c && (a = a + ":" + c.url);
        return a;
    }
    function Sl(a, b, c, d) {
        var e = El(b, c, d);
        Rl[e] || (Rl[e] = new Bl(a, b, c, d));
        return Rl[e];
    }
    function Cl() {
        this.b = null;
        this.f = [];
        this.c = [];
        this.a = null;
        this.i = this.g = !1;
    }
    Cl.prototype.reset = function() {
        this.b = null;
        this.a && (this.a.cancel(), this.a = null);
    };
    Cl.prototype.h = function(a, b) {
        if (a) {
            this.reset();
            this.g = !0;
            var c = a.c, d = a.b, e = a.a && "auth/web-storage-unsupported" == a.a.code, f = a.a && "auth/operation-not-supported-in-this-environment" == a.a.code;
            this.i = !(!e && !f);
            "unknown" != c || e || f ? a.a ? (Tl(this, !0, null, a.a), D()) : b.Fa(c, d) ? Ul(this, a, b) : E(new t("invalid-auth-event")) : (Tl(this, !1, null, null), D());
        } else E(new t("invalid-auth-event"));
    };
    function Jl(a) {
        a.g || (a.g = !0, Tl(a, !1, null, null));
    }
    function Vl(a) {
        a.g && !a.i && Tl(a, !1, null, null);
    }
    function Ul(a, b, c) {
        c = c.Fa(b.c, b.b);
        var d = b.g, e = b.f, f = b.i, g = b.S(), h = !!b.c.match(/Redirect$/);
        c(d, e, g, f).then(function(m) {
            Tl(a, h, m, null);
        }).s(function(m) {
            Tl(a, h, null, m);
        });
    }
    function Wl(a, b) {
        a.b = function() {
            return E(b);
        };
        if (a.c.length) for(var c = 0; c < a.c.length; c++)a.c[c](b);
    }
    function Xl(a, b) {
        a.b = function() {
            return D(b);
        };
        if (a.f.length) for(var c = 0; c < a.f.length; c++)a.f[c](b);
    }
    function Tl(a, b, c, d) {
        b ? d ? Wl(a, d) : Xl(a, c) : Xl(a, {
            user: null
        });
        a.f = [];
        a.c = [];
    }
    Cl.prototype.qa = function() {
        var a = this;
        return new C(function(b, c) {
            a.b ? a.b().then(b, c) : (a.f.push(b), a.c.push(c), Yl(a));
        });
    };
    function Yl(a) {
        var b = new t("timeout");
        a.a && a.a.cancel();
        a.a = Ad(Nl.get()).then(function() {
            a.b || (a.g = !0, Tl(a, !0, null, b));
        });
    }
    function Dl() {}
    Dl.prototype.h = function(a, b) {
        if (a) {
            var c = a.c, d = a.b;
            a.a ? (b.ma(a.c, null, a.a, a.b), D()) : b.Fa(c, d) ? Zl(a, b) : E(new t("invalid-auth-event"));
        } else E(new t("invalid-auth-event"));
    };
    function Zl(a, b) {
        var c = a.b, d = a.c;
        b.Fa(d, c)(a.g, a.f, a.S(), a.i).then(function(e) {
            b.ma(d, e, null, c);
        }).s(function(e) {
            b.ma(d, null, e, c);
        });
    }
    function $l() {
        this.hb = !1;
        Object.defineProperty(this, "appVerificationDisabled", {
            get: function() {
                return this.hb;
            },
            set: function(a) {
                this.hb = a;
            },
            enumerable: !1
        });
    }
    function am(a, b) {
        this.a = b;
        M(this, "verificationId", a);
    }
    am.prototype.confirm = function(a) {
        a = lh(this.verificationId, a);
        return this.a(a);
    };
    function bm(a, b, c, d) {
        return new hh(a).eb(b, c).then(function(e) {
            return new am(e, d);
        });
    }
    function cm(a) {
        var b = eg(a);
        if (!(b && b.exp && b.auth_time && b.iat)) throw new t("internal-error", "An internal error occurred. The token obtained by Firebase appears to be malformed. Please retry the operation.");
        N(this, {
            token: a,
            expirationTime: Ye(1E3 * b.exp),
            authTime: Ye(1E3 * b.auth_time),
            issuedAtTime: Ye(1E3 * b.iat),
            signInProvider: b.firebase && b.firebase.sign_in_provider ? b.firebase.sign_in_provider : null,
            signInSecondFactor: b.firebase && b.firebase.sign_in_second_factor ? b.firebase.sign_in_second_factor : null,
            claims: b
        });
    }
    function dm(a, b, c) {
        var d = b && b[em];
        if (!d) throw new t("argument-error", "Internal assert: Invalid MultiFactorResolver");
        this.a = a;
        this.f = lb(b);
        this.g = c;
        this.c = new ug(null, d);
        this.b = [];
        var e = this;
        w(b[fm] || [], function(f) {
            (f = pf(f)) && e.b.push(f);
        });
        M(this, "auth", this.a);
        M(this, "session", this.c);
        M(this, "hints", this.b);
    }
    var fm = "mfaInfo", em = "mfaPendingCredential";
    dm.prototype.Qc = function(a) {
        var b = this;
        return a.rb(this.a.a, this.c).then(function(c) {
            var d = lb(b.f);
            delete d[fm];
            delete d[em];
            z(d, c);
            return b.g(d);
        });
    };
    function gm(a, b, c, d) {
        t.call(this, "multi-factor-auth-required", d, b);
        this.b = new dm(a, b, c);
        M(this, "resolver", this.b);
    }
    r(gm, t);
    function hm(a, b, c) {
        if (a && n(a.serverResponse) && "auth/multi-factor-auth-required" === a.code) try {
            return new gm(b, a.serverResponse, c, a.message);
        } catch (d) {}
        return null;
    }
    function im() {}
    im.prototype.rb = function(a, b, c) {
        return b.type == vg ? jm(this, a, b, c) : km(this, a, b);
    };
    function jm(a, b, c, d) {
        return c.Ha().then(function(e) {
            e = {
                idToken: e
            };
            "undefined" !== typeof d && (e.displayName = d);
            z(e, {
                phoneVerificationInfo: dh(a.a)
            });
            return O(b, Cj, e);
        });
    }
    function km(a, b, c) {
        return c.Ha().then(function(d) {
            d = {
                mfaPendingCredential: d
            };
            z(d, {
                phoneVerificationInfo: dh(a.a)
            });
            return O(b, Dj, d);
        });
    }
    function lm(a) {
        M(this, "factorId", a.fa);
        this.a = a;
    }
    r(lm, im);
    function mm(a) {
        lm.call(this, a);
        if (this.a.fa != hh.PROVIDER_ID) throw new t("argument-error", "firebase.auth.PhoneMultiFactorAssertion requires a valid firebase.auth.PhoneAuthCredential");
    }
    r(mm, lm);
    function nm(a, b) {
        F.call(this, a);
        for(var c in b)this[c] = b[c];
    }
    r(nm, F);
    function om(a, b) {
        this.a = a;
        this.b = [];
        this.c = q(this.xc, this);
        jd(this.a, "userReloaded", this.c);
        var c = [];
        b && b.multiFactor && b.multiFactor.enrolledFactors && w(b.multiFactor.enrolledFactors, function(d) {
            var e = null, f = {};
            if (d) {
                d.uid && (f[mf] = d.uid);
                d.displayName && (f[nf] = d.displayName);
                d.enrollmentTime && (f[of] = new Date(d.enrollmentTime).toISOString());
                d.phoneNumber && (f[lf] = d.phoneNumber);
                try {
                    e = new qf(f);
                } catch (g) {}
                d = e;
            } else d = null;
            d && c.push(d);
        });
        pm(this, c);
    }
    function qm(a) {
        var b = [];
        w(a.mfaInfo || [], function(c) {
            (c = pf(c)) && b.push(c);
        });
        return b;
    }
    k = om.prototype;
    k.xc = function(a) {
        pm(this, qm(a.gd));
    };
    function pm(a, b) {
        a.b = b;
        M(a, "enrolledFactors", b);
    }
    k.Qb = function() {
        return this.a.I().then(function(a) {
            return new ug(a, null);
        });
    };
    k.ec = function(a, b) {
        var c = this, d = this.a.a;
        return this.Qb().then(function(e) {
            return a.rb(d, e, b);
        }).then(function(e) {
            rm(c.a, e);
            return c.a.reload();
        });
    };
    k.ad = function(a) {
        var b = this, c = "string" === typeof a ? a : a.uid, d = this.a.a;
        return this.a.I().then(function(e) {
            return O(d, Hj, {
                idToken: e,
                mfaEnrollmentId: c
            });
        }).then(function(e) {
            var f = Oa(b.b, function(g) {
                return g.uid != c;
            });
            pm(b, f);
            rm(b.a, e);
            return b.a.reload().s(function(g) {
                if ("auth/user-token-expired" != g.code) throw g;
            });
        });
    };
    k.w = function() {
        return {
            multiFactor: {
                enrolledFactors: Pa(this.b, function(a) {
                    return a.w();
                })
            }
        };
    };
    function sm(a, b, c) {
        this.h = a;
        this.i = b;
        this.g = c;
        this.c = 3E4;
        this.f = 96E4;
        this.b = null;
        this.a = this.c;
        if (this.f < this.c) throw Error("Proactive refresh lower bound greater than upper bound!");
    }
    sm.prototype.start = function() {
        this.a = this.c;
        tm(this, !0);
    };
    function um(a, b) {
        if (b) return a.a = a.c, a.g();
        b = a.a;
        a.a *= 2;
        a.a > a.f && (a.a = a.f);
        return b;
    }
    function tm(a, b) {
        a.stop();
        a.b = Ad(um(a, b)).then(function() {
            return We();
        }).then(function() {
            return a.h();
        }).then(function() {
            tm(a, !0);
        }).s(function(c) {
            a.i(c) && tm(a, !1);
        });
    }
    sm.prototype.stop = function() {
        this.b && (this.b.cancel(), this.b = null);
    };
    function vm(a) {
        this.c = a;
        this.b = this.a = null;
    }
    vm.prototype.w = function() {
        return {
            apiKey: this.c.c,
            refreshToken: this.a,
            accessToken: this.b && this.b.toString(),
            expirationTime: wm(this)
        };
    };
    function wm(a) {
        return a.b && 1E3 * a.b.c || 0;
    }
    function xm(a, b) {
        var c = b.refreshToken;
        a.b = fg(b[zg] || "");
        a.a = c;
    }
    function ym(a, b) {
        a.b = b.b;
        a.a = b.a;
    }
    function zm(a, b) {
        return Si(a.c, b).then(function(c) {
            a.b = fg(c.access_token);
            a.a = c.refresh_token;
            return {
                accessToken: a.b.toString(),
                refreshToken: a.a
            };
        }).s(function(c) {
            "auth/user-token-expired" == c.code && (a.a = null);
            throw c;
        });
    }
    vm.prototype.getToken = function(a) {
        a = !!a;
        return this.b && !this.a ? E(new t("user-token-expired")) : a || !this.b || ua() > wm(this) - 3E4 ? this.a ? zm(this, {
            grant_type: "refresh_token",
            refresh_token: this.a
        }) : D(null) : D({
            accessToken: this.b.toString(),
            refreshToken: this.a
        });
    };
    function Am(a, b) {
        this.a = a || null;
        this.b = b || null;
        N(this, {
            lastSignInTime: Ye(b || null),
            creationTime: Ye(a || null)
        });
    }
    function Bm(a) {
        return new Am(a.a, a.b);
    }
    Am.prototype.w = function() {
        return {
            lastLoginAt: this.b,
            createdAt: this.a
        };
    };
    function Cm(a, b, c, d, e, f) {
        N(this, {
            uid: a,
            displayName: d || null,
            photoURL: e || null,
            email: c || null,
            phoneNumber: f || null,
            providerId: b
        });
    }
    function Dm(a, b, c) {
        this.G = [];
        this.l = a.apiKey;
        this.m = a.appName;
        this.o = a.authDomain || null;
        var d = firebase.SDK_VERSION ? Je(firebase.SDK_VERSION) : null;
        this.a = new Ei(this.l, Aa(Ba), d);
        a.emulatorConfig && Li(this.a, a.emulatorConfig);
        this.b = new vm(this.a);
        Em(this, b[zg]);
        xm(this.b, b);
        M(this, "refreshToken", this.b.a);
        Fm(this, c || {});
        H.call(this);
        this.P = !1;
        this.o && Me() && (this.i = Sl(this.o, this.l, this.m));
        this.R = [];
        this.f = null;
        this.u = Gm(this);
        this.$ = q(this.gb, this);
        var e = this;
        this.pa = null;
        this.Ba = function(f) {
            e.wa(f.h);
        };
        this.ba = null;
        this.za = function(f) {
            Li(e.a, f.c);
        };
        this.W = null;
        this.X = [];
        this.Aa = function(f) {
            Hm(e, f.f);
        };
        this.aa = null;
        this.N = new om(this, c);
        M(this, "multiFactor", this.N);
    }
    r(Dm, H);
    Dm.prototype.wa = function(a) {
        this.pa = a;
        Ki(this.a, a);
    };
    Dm.prototype.ka = function() {
        return this.pa;
    };
    function Im(a, b) {
        a.ba && G(a.ba, "languageCodeChanged", a.Ba);
        (a.ba = b) && jd(b, "languageCodeChanged", a.Ba);
    }
    function Jm(a, b) {
        a.W && G(a.W, "emulatorConfigChanged", a.za);
        (a.W = b) && jd(b, "emulatorConfigChanged", a.za);
    }
    function Hm(a, b) {
        a.X = b;
        Ni(a.a, firebase.SDK_VERSION ? Je(firebase.SDK_VERSION, a.X) : null);
    }
    Dm.prototype.Ga = function() {
        return Xa(this.X);
    };
    function Km(a, b) {
        a.aa && G(a.aa, "frameworkChanged", a.Aa);
        (a.aa = b) && jd(b, "frameworkChanged", a.Aa);
    }
    Dm.prototype.gb = function() {
        this.u.b && (this.u.stop(), this.u.start());
    };
    function Lm(a) {
        try {
            return firebase.app(a.m).auth();
        } catch (b) {
            throw new t("internal-error", "No firebase.auth.Auth instance is available for the Firebase App '" + a.m + "'!");
        }
    }
    function Gm(a) {
        return new sm(function() {
            return a.I(!0);
        }, function(b) {
            return b && "auth/network-request-failed" == b.code ? !0 : !1;
        }, function() {
            var b = wm(a.b) - ua() - 3E5;
            return 0 < b ? b : 0;
        });
    }
    function Mm(a) {
        a.A || a.u.b || (a.u.start(), G(a, "tokenChanged", a.$), jd(a, "tokenChanged", a.$));
    }
    function Nm(a) {
        G(a, "tokenChanged", a.$);
        a.u.stop();
    }
    function Em(a, b) {
        a.ya = b;
        M(a, "_lat", b);
    }
    function Om(a, b) {
        Va(a.R, function(c) {
            return c == b;
        });
    }
    function Pm(a) {
        for(var b = [], c = 0; c < a.R.length; c++)b.push(a.R[c](a));
        return Fc(b).then(function() {
            return a;
        });
    }
    function Qm(a) {
        a.i && !a.P && (a.P = !0, Kl(a.i, a));
    }
    function Fm(a, b) {
        N(a, {
            uid: b.uid,
            displayName: b.displayName || null,
            photoURL: b.photoURL || null,
            email: b.email || null,
            emailVerified: b.emailVerified || !1,
            phoneNumber: b.phoneNumber || null,
            isAnonymous: b.isAnonymous || !1,
            tenantId: b.tenantId || null,
            metadata: new Am(b.createdAt, b.lastLoginAt),
            providerData: []
        });
        a.a.b = a.tenantId;
    }
    M(Dm.prototype, "providerId", "firebase");
    function Rm() {}
    function Sm(a) {
        return D().then(function() {
            if (a.A) throw new t("app-deleted");
        });
    }
    function Tm(a) {
        return Pa(a.providerData, function(b) {
            return b.providerId;
        });
    }
    function Um(a, b) {
        b && (Vm(a, b.providerId), a.providerData.push(b));
    }
    function Vm(a, b) {
        Va(a.providerData, function(c) {
            return c.providerId == b;
        });
    }
    function Wm(a, b, c) {
        ("uid" != b || c) && a.hasOwnProperty(b) && M(a, b, c);
    }
    function Xm(a, b) {
        a != b && (N(a, {
            uid: b.uid,
            displayName: b.displayName,
            photoURL: b.photoURL,
            email: b.email,
            emailVerified: b.emailVerified,
            phoneNumber: b.phoneNumber,
            isAnonymous: b.isAnonymous,
            tenantId: b.tenantId,
            providerData: []
        }), b.metadata ? M(a, "metadata", Bm(b.metadata)) : M(a, "metadata", new Am), w(b.providerData, function(c) {
            Um(a, c);
        }), ym(a.b, b.b), M(a, "refreshToken", a.b.a), pm(a.N, b.N.b));
    }
    k = Dm.prototype;
    k.reload = function() {
        var a = this;
        return R(this, Sm(this).then(function() {
            return Ym(a).then(function() {
                return Pm(a);
            }).then(Rm);
        }));
    };
    function Ym(a) {
        return a.I().then(function(b) {
            var c = a.isAnonymous;
            return Zm(a, b).then(function() {
                c || Wm(a, "isAnonymous", !1);
                return b;
            });
        });
    }
    k.nc = function(a) {
        return this.I(a).then(function(b) {
            return new cm(b);
        });
    };
    k.I = function(a) {
        var b = this;
        return R(this, Sm(this).then(function() {
            return b.b.getToken(a);
        }).then(function(c) {
            if (!c) throw new t("internal-error");
            c.accessToken != b.ya && (Em(b, c.accessToken), b.dispatchEvent(new nm("tokenChanged")));
            Wm(b, "refreshToken", c.refreshToken);
            return c.accessToken;
        }));
    };
    function rm(a, b) {
        b[zg] && a.ya != b[zg] && (xm(a.b, b), a.dispatchEvent(new nm("tokenChanged")), Em(a, b[zg]), Wm(a, "refreshToken", a.b.a));
    }
    function Zm(a, b) {
        return O(a.a, Ej, {
            idToken: b
        }).then(q(a.Jc, a));
    }
    k.Jc = function(a) {
        a = a.users;
        if (!a || !a.length) throw new t("internal-error");
        a = a[0];
        Fm(this, {
            uid: a.localId,
            displayName: a.displayName,
            photoURL: a.photoUrl,
            email: a.email,
            emailVerified: !!a.emailVerified,
            phoneNumber: a.phoneNumber,
            lastLoginAt: a.lastLoginAt,
            createdAt: a.createdAt,
            tenantId: a.tenantId
        });
        for(var b = $m(a), c = 0; c < b.length; c++)Um(this, b[c]);
        Wm(this, "isAnonymous", !(this.email && a.passwordHash) && !(this.providerData && this.providerData.length));
        this.dispatchEvent(new nm("userReloaded", {
            gd: a
        }));
    };
    function $m(a) {
        return (a = a.providerUserInfo) && a.length ? Pa(a, function(b) {
            return new Cm(b.rawId, b.providerId, b.email, b.displayName, b.photoUrl, b.phoneNumber);
        }) : [];
    }
    k.Kc = function(a) {
        cf("firebase.User.prototype.reauthenticateAndRetrieveDataWithCredential is deprecated. Please use firebase.User.prototype.reauthenticateWithCredential instead.");
        return this.sb(a);
    };
    k.sb = function(a) {
        var b = this, c = null;
        return R(this, a.c(this.a, this.uid).then(function(d) {
            rm(b, d);
            c = an(b, d, "reauthenticate");
            b.f = null;
            return b.reload();
        }).then(function() {
            return c;
        }), !0);
    };
    function bn(a, b) {
        return Ym(a).then(function() {
            if (Ta(Tm(a), b)) return Pm(a).then(function() {
                throw new t("provider-already-linked");
            });
        });
    }
    k.Bc = function(a) {
        cf("firebase.User.prototype.linkAndRetrieveDataWithCredential is deprecated. Please use firebase.User.prototype.linkWithCredential instead.");
        return this.pb(a);
    };
    k.pb = function(a) {
        var b = this, c = null;
        return R(this, bn(this, a.providerId).then(function() {
            return b.I();
        }).then(function(d) {
            return a.b(b.a, d);
        }).then(function(d) {
            c = an(b, d, "link");
            return cn(b, d);
        }).then(function() {
            return c;
        }));
    };
    k.Cc = function(a, b) {
        var c = this;
        return R(this, bn(this, "phone").then(function() {
            return bm(Lm(c), a, b, q(c.pb, c));
        }));
    };
    k.Lc = function(a, b) {
        var c = this;
        return R(this, D().then(function() {
            return bm(Lm(c), a, b, q(c.sb, c));
        }), !0);
    };
    function an(a, b, c) {
        var d = mh(b);
        b = kg(b);
        return ff({
            user: a,
            credential: d,
            additionalUserInfo: b,
            operationType: c
        });
    }
    function cn(a, b) {
        rm(a, b);
        return a.reload().then(function() {
            return a;
        });
    }
    k.Ab = function(a) {
        var b = this;
        return R(this, this.I().then(function(c) {
            return b.a.Ab(c, a);
        }).then(function(c) {
            rm(b, c);
            return b.reload();
        }));
    };
    k.dd = function(a) {
        var b = this;
        return R(this, this.I().then(function(c) {
            return a.b(b.a, c);
        }).then(function(c) {
            rm(b, c);
            return b.reload();
        }));
    };
    k.Bb = function(a) {
        var b = this;
        return R(this, this.I().then(function(c) {
            return b.a.Bb(c, a);
        }).then(function(c) {
            rm(b, c);
            return b.reload();
        }));
    };
    k.Cb = function(a) {
        if (void 0 === a.displayName && void 0 === a.photoURL) return Sm(this);
        var b = this;
        return R(this, this.I().then(function(c) {
            return b.a.Cb(c, {
                displayName: a.displayName,
                photoUrl: a.photoURL
            });
        }).then(function(c) {
            rm(b, c);
            Wm(b, "displayName", c.displayName || null);
            Wm(b, "photoURL", c.photoUrl || null);
            w(b.providerData, function(d) {
                "password" === d.providerId && (M(d, "displayName", b.displayName), M(d, "photoURL", b.photoURL));
            });
            return Pm(b);
        }).then(Rm));
    };
    k.bd = function(a) {
        var b = this;
        return R(this, Ym(this).then(function(c) {
            return Ta(Tm(b), a) ? nj(b.a, c, [
                a
            ]).then(function(d) {
                var e = {};
                w(d.providerUserInfo || [], function(f) {
                    e[f.providerId] = !0;
                });
                w(Tm(b), function(f) {
                    e[f] || Vm(b, f);
                });
                e[hh.PROVIDER_ID] || M(b, "phoneNumber", null);
                return Pm(b);
            }) : Pm(b).then(function() {
                throw new t("no-such-provider");
            });
        }));
    };
    k.delete = function() {
        var a = this;
        return R(this, this.I().then(function(b) {
            return O(a.a, Bj, {
                idToken: b
            });
        }).then(function() {
            a.dispatchEvent(new nm("userDeleted"));
        })).then(function() {
            for(var b = 0; b < a.G.length; b++)a.G[b].cancel("app-deleted");
            Im(a, null);
            Jm(a, null);
            Km(a, null);
            a.G = [];
            a.A = !0;
            Nm(a);
            M(a, "refreshToken", null);
            a.i && Ll(a.i, a);
        });
    };
    k.Eb = function(a, b) {
        return "linkViaPopup" == a && (this.h || null) == b && this.g || "reauthViaPopup" == a && (this.h || null) == b && this.g || "linkViaRedirect" == a && (this.ga || null) == b || "reauthViaRedirect" == a && (this.ga || null) == b ? !0 : !1;
    };
    k.ma = function(a, b, c, d) {
        "linkViaPopup" != a && "reauthViaPopup" != a || d != (this.h || null) || (c && this.O ? this.O(c) : b && !c && this.g && this.g(b), this.c && (this.c.cancel(), this.c = null), delete this.g, delete this.O);
    };
    k.Fa = function(a, b) {
        return "linkViaPopup" == a && b == (this.h || null) ? q(this.Jb, this) : "reauthViaPopup" == a && b == (this.h || null) ? q(this.Kb, this) : "linkViaRedirect" == a && (this.ga || null) == b ? q(this.Jb, this) : "reauthViaRedirect" == a && (this.ga || null) == b ? q(this.Kb, this) : null;
    };
    k.Dc = function(a) {
        var b = this;
        return dn(this, "linkViaPopup", a, function() {
            return bn(b, a.providerId).then(function() {
                return Pm(b);
            });
        }, !1);
    };
    k.Mc = function(a) {
        return dn(this, "reauthViaPopup", a, function() {
            return D();
        }, !0);
    };
    function dn(a, b, c, d, e) {
        if (!Me()) return E(new t("operation-not-supported-in-this-environment"));
        if (a.f && !e) return E(a.f);
        var f = jg(c.providerId), g = Le(a.uid + ":::"), h = null;
        (!Oe() || De()) && a.o && c.isOAuthProvider && (h = ak(a.o, a.l, a.m, b, c, null, g, firebase.SDK_VERSION || null, null, null, a.tenantId));
        var m = ue(h, f && f.ua, f && f.ta);
        d = d().then(function() {
            en(a);
            if (!e) return a.I().then(function() {});
        }).then(function() {
            return Ol(a.i, m, b, c, g, !!h, a.tenantId);
        }).then(function() {
            return new C(function(p, v) {
                a.ma(b, null, new t("cancelled-popup-request"), a.h || null);
                a.g = p;
                a.O = v;
                a.h = g;
                a.c = Ql(a.i, a, b, m, g);
            });
        }).then(function(p) {
            m && te(m);
            return p ? ff(p) : null;
        }).s(function(p) {
            m && te(m);
            throw p;
        });
        return R(a, d, e);
    }
    k.Ec = function(a) {
        var b = this;
        return fn(this, "linkViaRedirect", a, function() {
            return bn(b, a.providerId);
        }, !1);
    };
    k.Nc = function(a) {
        return fn(this, "reauthViaRedirect", a, function() {
            return D();
        }, !0);
    };
    function fn(a, b, c, d, e) {
        if (!Me()) return E(new t("operation-not-supported-in-this-environment"));
        if (a.f && !e) return E(a.f);
        var f = null, g = Le(a.uid + ":::");
        d = d().then(function() {
            en(a);
            if (!e) return a.I().then(function() {});
        }).then(function() {
            a.ga = g;
            return Pm(a);
        }).then(function(h) {
            a.ha && (h = a.ha, h = h.b.set(gn, a.w(), h.a));
            return h;
        }).then(function() {
            return Pl(a.i, b, c, g, a.tenantId);
        }).s(function(h) {
            f = h;
            if (a.ha) return hn(a.ha);
            throw f;
        }).then(function() {
            if (f) throw f;
        });
        return R(a, d, e);
    }
    function en(a) {
        if (!a.i || !a.P) {
            if (a.i && !a.P) throw new t("internal-error");
            throw new t("auth-domain-config-required");
        }
    }
    k.Jb = function(a, b, c, d) {
        var e = this;
        this.c && (this.c.cancel(), this.c = null);
        var f = null;
        c = this.I().then(function(g) {
            return Dg(e.a, {
                requestUri: a,
                postBody: d,
                sessionId: b,
                idToken: g
            });
        }).then(function(g) {
            f = an(e, g, "link");
            return cn(e, g);
        }).then(function() {
            return f;
        });
        return R(this, c);
    };
    k.Kb = function(a, b, c, d) {
        var e = this;
        this.c && (this.c.cancel(), this.c = null);
        var f = null, g = D().then(function() {
            return yg(Eg(e.a, {
                requestUri: a,
                sessionId: b,
                postBody: d,
                tenantId: c
            }), e.uid);
        }).then(function(h) {
            f = an(e, h, "reauthenticate");
            rm(e, h);
            e.f = null;
            return e.reload();
        }).then(function() {
            return f;
        });
        return R(this, g, !0);
    };
    k.tb = function(a) {
        var b = this, c = null;
        return R(this, this.I().then(function(d) {
            c = d;
            return "undefined" === typeof a || kb(a) ? {} : Yf(new Of(a));
        }).then(function(d) {
            return b.a.tb(c, d);
        }).then(function(d) {
            if (b.email != d) return b.reload();
        }).then(function() {}));
    };
    k.Db = function(a, b) {
        var c = this, d = null;
        return R(this, this.I().then(function(e) {
            d = e;
            return "undefined" === typeof b || kb(b) ? {} : Yf(new Of(b));
        }).then(function(e) {
            return c.a.Db(d, a, e);
        }).then(function(e) {
            if (c.email != e) return c.reload();
        }).then(function() {}));
    };
    function R(a, b, c) {
        var d = jn(a, b, c);
        a.G.push(d);
        d.na(function() {
            Ua(a.G, d);
        });
        return d.s(function(e) {
            var f = null;
            e && "auth/multi-factor-auth-required" === e.code && (f = hm(e.w(), Lm(a), q(a.ic, a)));
            throw f || e;
        });
    }
    k.ic = function(a) {
        var b = null, c = this;
        a = yg(D(a), c.uid).then(function(d) {
            b = an(c, d, "reauthenticate");
            rm(c, d);
            c.f = null;
            return c.reload();
        }).then(function() {
            return b;
        });
        return R(this, a, !0);
    };
    function jn(a, b, c) {
        return a.f && !c ? (b.cancel(), E(a.f)) : b.s(function(d) {
            !d || "auth/user-disabled" != d.code && "auth/user-token-expired" != d.code || (a.f || a.dispatchEvent(new nm("userInvalidated")), a.f = d);
            throw d;
        });
    }
    k.toJSON = function() {
        return this.w();
    };
    k.w = function() {
        var a = {
            uid: this.uid,
            displayName: this.displayName,
            photoURL: this.photoURL,
            email: this.email,
            emailVerified: this.emailVerified,
            phoneNumber: this.phoneNumber,
            isAnonymous: this.isAnonymous,
            tenantId: this.tenantId,
            providerData: [],
            apiKey: this.l,
            appName: this.m,
            authDomain: this.o,
            stsTokenManager: this.b.w(),
            redirectEventId: this.ga || null
        };
        this.metadata && z(a, this.metadata.w());
        w(this.providerData, function(b) {
            a.providerData.push(gf(b));
        });
        z(a, this.N.w());
        return a;
    };
    function kn(a) {
        if (!a.apiKey) return null;
        var b = {
            apiKey: a.apiKey,
            authDomain: a.authDomain,
            appName: a.appName,
            emulatorConfig: a.emulatorConfig
        }, c = {};
        if (a.stsTokenManager && a.stsTokenManager.accessToken) c[zg] = a.stsTokenManager.accessToken, c.refreshToken = a.stsTokenManager.refreshToken || null;
        else return null;
        var d = new Dm(b, c, a);
        a.providerData && w(a.providerData, function(e) {
            e && Um(d, ff(e));
        });
        a.redirectEventId && (d.ga = a.redirectEventId);
        return d;
    }
    function ln(a, b, c, d) {
        var e = new Dm(a, b);
        c && (e.ha = c);
        d && Hm(e, d);
        return e.reload().then(function() {
            return e;
        });
    }
    function mn(a, b, c, d) {
        var e = a.b, f = {};
        f[zg] = e.b && e.b.toString();
        f.refreshToken = e.a;
        b = new Dm(b || {
            apiKey: a.l,
            authDomain: a.o,
            appName: a.m
        }, f);
        c && (b.ha = c);
        d && Hm(b, d);
        Xm(b, a);
        return b;
    }
    function nn(a) {
        this.a = a;
        this.b = Qk();
    }
    var gn = {
        name: "redirectUser",
        D: "session"
    };
    function hn(a) {
        return Uk(a.b, gn, a.a);
    }
    function on(a, b) {
        return a.b.get(gn, a.a).then(function(c) {
            c && b && (c.authDomain = b);
            return kn(c || {});
        });
    }
    function pn(a) {
        this.a = a;
        this.b = Qk();
        this.c = null;
        this.f = qn(this);
        this.b.addListener(rn("local"), this.a, q(this.g, this));
    }
    pn.prototype.g = function() {
        var a = this, b = rn("local");
        sn(this, function() {
            return D().then(function() {
                return a.c && "local" != a.c.D ? a.b.get(b, a.a) : null;
            }).then(function(c) {
                if (c) return tn(a, "local").then(function() {
                    a.c = b;
                });
            });
        });
    };
    function tn(a, b) {
        var c = [], d;
        for(d in Mk)Mk[d] !== b && c.push(Uk(a.b, rn(Mk[d]), a.a));
        c.push(Uk(a.b, un, a.a));
        return Ec(c);
    }
    function qn(a) {
        var b = rn("local"), c = rn("session"), d = rn("none");
        return Tk(a.b, b, a.a).then(function() {
            return a.b.get(c, a.a);
        }).then(function(e) {
            return e ? c : a.b.get(d, a.a).then(function(f) {
                return f ? d : a.b.get(b, a.a).then(function(g) {
                    return g ? b : a.b.get(un, a.a).then(function(h) {
                        return h ? rn(h) : b;
                    });
                });
            });
        }).then(function(e) {
            a.c = e;
            return tn(a, e.D);
        }).s(function() {
            a.c || (a.c = b);
        });
    }
    var un = {
        name: "persistence",
        D: "session"
    };
    function rn(a) {
        return {
            name: "authUser",
            D: a
        };
    }
    pn.prototype.wb = function(a) {
        var b = null, c = this;
        Nk(a);
        return sn(this, function() {
            return a != c.c.D ? c.b.get(c.c, c.a).then(function(d) {
                b = d;
                return tn(c, a);
            }).then(function() {
                c.c = rn(a);
                if (b) return c.b.set(c.c, b, c.a);
            }) : D();
        });
    };
    function vn(a) {
        return sn(a, function() {
            return a.b.set(un, a.c.D, a.a);
        });
    }
    function wn(a, b) {
        return sn(a, function() {
            return a.b.set(a.c, b.w(), a.a);
        });
    }
    function xn(a) {
        return sn(a, function() {
            return Uk(a.b, a.c, a.a);
        });
    }
    function yn(a, b, c) {
        return sn(a, function() {
            return a.b.get(a.c, a.a).then(function(d) {
                d && b && (d.authDomain = b);
                d && c && (d.emulatorConfig = c);
                return kn(d || {});
            });
        });
    }
    function sn(a, b) {
        a.f = a.f.then(b, b);
        return a.f;
    }
    function zn(a) {
        this.m = !1;
        M(this, "settings", new $l);
        M(this, "app", a);
        if (S(this).options && S(this).options.apiKey) a = firebase.SDK_VERSION ? Je(firebase.SDK_VERSION) : null, this.a = new Ei(S(this).options && S(this).options.apiKey, Aa(Ba), a);
        else throw new t("invalid-api-key");
        this.R = [];
        this.u = [];
        this.P = [];
        this.ac = firebase.INTERNAL.createSubscribe(q(this.yc, this));
        this.X = void 0;
        this.bc = firebase.INTERNAL.createSubscribe(q(this.zc, this));
        An(this, null);
        this.l = new pn(S(this).options.apiKey + ":" + S(this).name);
        this.G = new nn(S(this).options.apiKey + ":" + S(this).name);
        this.$ = T(this, Bn(this));
        this.i = T(this, Cn(this));
        this.ba = !1;
        this.pa = q(this.Yc, this);
        this.Ba = q(this.da, this);
        this.ya = q(this.kc, this);
        this.za = q(this.vc, this);
        this.Aa = q(this.wc, this);
        this.b = null;
        Dn(this);
        this.INTERNAL = {};
        this.INTERNAL["delete"] = q(this.delete, this);
        this.INTERNAL.logFramework = q(this.Fc, this);
        this.A = 0;
        H.call(this);
        En(this);
        this.N = [];
        this.f = null;
    }
    r(zn, H);
    function Fn(a) {
        F.call(this, "languageCodeChanged");
        this.h = a;
    }
    r(Fn, F);
    function Gn(a) {
        F.call(this, "emulatorConfigChanged");
        this.c = a;
    }
    r(Gn, F);
    function Hn(a) {
        F.call(this, "frameworkChanged");
        this.f = a;
    }
    r(Hn, F);
    k = zn.prototype;
    k.wb = function(a) {
        a = this.l.wb(a);
        return T(this, a);
    };
    k.wa = function(a) {
        this.aa === a || this.m || (this.aa = a, Ki(this.a, this.aa), this.dispatchEvent(new Fn(this.ka())));
    };
    k.ka = function() {
        return this.aa;
    };
    k.ed = function() {
        var a = l.navigator;
        this.wa(a ? a.languages && a.languages[0] || a.language || a.userLanguage || null : null);
    };
    k.fd = function(a) {
        if (!this.f) {
            if (!/^https?:\/\//.test(a)) throw new t("argument-error", "Emulator URL must start with a valid scheme (http:// or https://).");
            In();
            this.f = {
                url: a
            };
            this.settings.hb = !0;
            Li(this.a, this.f);
            this.dispatchEvent(new Gn(this.f));
        }
    };
    function In() {
        Xe("WARNING: You are using the Auth Emulator, which is intended for local testing only.  Do not use with production credentials.");
        l.document && ze().then(function() {
            var a = l.document.createElement("div");
            a.innerText = "Running in emulator mode. Do not use with production credentials.";
            a.style.position = "fixed";
            a.style.width = "100%";
            a.style.backgroundColor = "#ffffff";
            a.style.border = ".1em solid #000000";
            a.style.color = "#ff0000";
            a.style.bottom = "0px";
            a.style.left = "0px";
            a.style.margin = "0px";
            a.style.zIndex = 1E4;
            a.style.textAlign = "center";
            a.classList.add("firebase-emulator-warning");
            l.document.body.appendChild(a);
        });
    }
    k.Fc = function(a) {
        this.N.push(a);
        Ni(this.a, firebase.SDK_VERSION ? Je(firebase.SDK_VERSION, this.N) : null);
        this.dispatchEvent(new Hn(this.N));
    };
    k.Ga = function() {
        return Xa(this.N);
    };
    k.xb = function(a) {
        this.W === a || this.m || (this.W = a, this.a.b = this.W);
    };
    k.S = function() {
        return this.W;
    };
    function En(a) {
        Object.defineProperty(a, "lc", {
            get: function() {
                return this.ka();
            },
            set: function(b) {
                this.wa(b);
            },
            enumerable: !1
        });
        a.aa = null;
        Object.defineProperty(a, "ti", {
            get: function() {
                return this.S();
            },
            set: function(b) {
                this.xb(b);
            },
            enumerable: !1
        });
        a.W = null;
    }
    k.toJSON = function() {
        return {
            apiKey: S(this).options.apiKey,
            authDomain: S(this).options.authDomain,
            appName: S(this).name,
            currentUser: U(this) && U(this).w()
        };
    };
    function Jn(a) {
        return a.gb || E(new t("auth-domain-config-required"));
    }
    function Dn(a) {
        var b = S(a).options.authDomain, c = S(a).options.apiKey;
        b && Me() && (a.gb = a.$.then(function() {
            if (!a.m) {
                a.b = Sl(b, c, S(a).name, a.f);
                Kl(a.b, a);
                U(a) && Qm(U(a));
                if (a.o) {
                    Qm(a.o);
                    var d = a.o;
                    d.wa(a.ka());
                    Im(d, a);
                    d = a.o;
                    Hm(d, a.N);
                    Km(d, a);
                    d = a.o;
                    Li(d.a, a.f);
                    Jm(d, a);
                    a.o = null;
                }
                return a.b;
            }
        }));
    }
    k.Eb = function(a, b) {
        switch(a){
            case "unknown":
            case "signInViaRedirect":
                return !0;
            case "signInViaPopup":
                return this.h == b && !!this.g;
            default:
                return !1;
        }
    };
    k.ma = function(a, b, c, d) {
        "signInViaPopup" == a && this.h == d && (c && this.O ? this.O(c) : b && !c && this.g && this.g(b), this.c && (this.c.cancel(), this.c = null), delete this.g, delete this.O);
    };
    k.Fa = function(a, b) {
        return "signInViaRedirect" == a || "signInViaPopup" == a && this.h == b && this.g ? q(this.hc, this) : null;
    };
    k.hc = function(a, b, c, d) {
        var e = this, f = {
            requestUri: a,
            postBody: d,
            sessionId: b,
            tenantId: c
        };
        this.c && (this.c.cancel(), this.c = null);
        return e.$.then(function() {
            return Kn(e, Bg(e.a, f));
        });
    };
    k.Wc = function(a) {
        if (!Me()) return E(new t("operation-not-supported-in-this-environment"));
        var b = this, c = jg(a.providerId), d = Le(), e = null;
        (!Oe() || De()) && S(this).options.authDomain && a.isOAuthProvider && (e = ak(S(this).options.authDomain, S(this).options.apiKey, S(this).name, "signInViaPopup", a, null, d, firebase.SDK_VERSION || null, null, null, this.S(), this.f));
        var f = ue(e, c && c.ua, c && c.ta);
        c = Jn(this).then(function(g) {
            return Ol(g, f, "signInViaPopup", a, d, !!e, b.S());
        }).then(function() {
            return new C(function(g, h) {
                b.ma("signInViaPopup", null, new t("cancelled-popup-request"), b.h);
                b.g = g;
                b.O = h;
                b.h = d;
                b.c = Ql(b.b, b, "signInViaPopup", f, d);
            });
        }).then(function(g) {
            f && te(f);
            return g ? ff(g) : null;
        }).s(function(g) {
            f && te(f);
            throw g;
        });
        return T(this, c);
    };
    k.Xc = function(a) {
        if (!Me()) return E(new t("operation-not-supported-in-this-environment"));
        var b = this, c = Jn(this).then(function() {
            return vn(b.l);
        }).then(function() {
            return Pl(b.b, "signInViaRedirect", a, void 0, b.S());
        });
        return T(this, c);
    };
    function Ln(a) {
        if (!Me()) return E(new t("operation-not-supported-in-this-environment"));
        var b = Jn(a).then(function() {
            return a.b.qa();
        }).then(function(c) {
            return c ? ff(c) : null;
        });
        return T(a, b);
    }
    k.qa = function() {
        var a = this;
        return Ln(this).then(function(b) {
            a.b && Vl(a.b.b);
            return b;
        }).s(function(b) {
            a.b && Vl(a.b.b);
            throw b;
        });
    };
    k.cd = function(a) {
        if (!a) return E(new t("null-user"));
        if (this.W != a.tenantId) return E(new t("tenant-id-mismatch"));
        var b = this, c = {};
        c.apiKey = S(this).options.apiKey;
        c.authDomain = S(this).options.authDomain;
        c.appName = S(this).name;
        var d = mn(a, c, b.G, b.Ga());
        return T(this, this.i.then(function() {
            if (S(b).options.apiKey != a.l) return d.reload();
        }).then(function() {
            if (U(b) && a.uid == U(b).uid) return Xm(U(b), a), b.da(a);
            An(b, d);
            Qm(d);
            return b.da(d);
        }).then(function() {
            Mn(b);
        }));
    };
    function Nn(a, b) {
        var c = {};
        c.apiKey = S(a).options.apiKey;
        c.authDomain = S(a).options.authDomain;
        c.appName = S(a).name;
        a.f && (c.emulatorConfig = a.f);
        return a.$.then(function() {
            return ln(c, b, a.G, a.Ga());
        }).then(function(d) {
            if (U(a) && d.uid == U(a).uid) return Xm(U(a), d), a.da(d);
            An(a, d);
            Qm(d);
            return a.da(d);
        }).then(function() {
            Mn(a);
        });
    }
    function An(a, b) {
        U(a) && (Om(U(a), a.Ba), G(U(a), "tokenChanged", a.ya), G(U(a), "userDeleted", a.za), G(U(a), "userInvalidated", a.Aa), Nm(U(a)));
        b && (b.R.push(a.Ba), jd(b, "tokenChanged", a.ya), jd(b, "userDeleted", a.za), jd(b, "userInvalidated", a.Aa), 0 < a.A && Mm(b));
        M(a, "currentUser", b);
        b && (b.wa(a.ka()), Im(b, a), Hm(b, a.N), Km(b, a), Li(b.a, a.f), Jm(b, a));
    }
    k.zb = function() {
        var a = this, b = this.i.then(function() {
            a.b && Vl(a.b.b);
            if (!U(a)) return D();
            An(a, null);
            return xn(a.l).then(function() {
                Mn(a);
            });
        });
        return T(this, b);
    };
    function On(a) {
        var b = on(a.G, S(a).options.authDomain).then(function(c) {
            if (a.o = c) c.ha = a.G;
            return hn(a.G);
        });
        return T(a, b);
    }
    function Bn(a) {
        var b = S(a).options.authDomain, c = On(a).then(function() {
            return yn(a.l, b, a.f);
        }).then(function(d) {
            return d ? (d.ha = a.G, a.o && (a.o.ga || null) == (d.ga || null) ? d : d.reload().then(function() {
                return wn(a.l, d).then(function() {
                    return d;
                });
            }).s(function(e) {
                return "auth/network-request-failed" == e.code ? d : xn(a.l);
            })) : null;
        }).then(function(d) {
            An(a, d || null);
        });
        return T(a, c);
    }
    function Cn(a) {
        return a.$.then(function() {
            return Ln(a);
        }).s(function() {}).then(function() {
            if (!a.m) return a.pa();
        }).s(function() {}).then(function() {
            if (!a.m) {
                a.ba = !0;
                var b = a.l;
                b.b.addListener(rn("local"), b.a, a.pa);
            }
        });
    }
    k.Yc = function() {
        var a = this;
        return yn(this.l, S(this).options.authDomain).then(function(b) {
            if (!a.m) {
                var c;
                if (c = U(a) && b) {
                    c = U(a).uid;
                    var d = b.uid;
                    c = void 0 === c || null === c || "" === c || void 0 === d || null === d || "" === d ? !1 : c == d;
                }
                if (c) return Xm(U(a), b), U(a).I();
                if (U(a) || b) An(a, b), b && (Qm(b), b.ha = a.G), a.b && Kl(a.b, a), Mn(a);
            }
        });
    };
    k.da = function(a) {
        return wn(this.l, a);
    };
    k.kc = function() {
        Mn(this);
        this.da(U(this));
    };
    k.vc = function() {
        this.zb();
    };
    k.wc = function() {
        this.zb();
    };
    function Kn(a, b) {
        var c = null, d = null;
        return T(a, b.then(function(e) {
            c = mh(e);
            d = kg(e);
            return Nn(a, e);
        }, function(e) {
            var f = null;
            e && "auth/multi-factor-auth-required" === e.code && (f = hm(e.w(), a, q(a.jc, a)));
            throw f || e;
        }).then(function() {
            return ff({
                user: U(a),
                credential: c,
                additionalUserInfo: d,
                operationType: "signIn"
            });
        }));
    }
    k.jc = function(a) {
        var b = this;
        return this.i.then(function() {
            return Kn(b, D(a));
        });
    };
    k.yc = function(a) {
        var b = this;
        this.addAuthTokenListener(function() {
            a.next(U(b));
        });
    };
    k.zc = function(a) {
        var b = this;
        Pn(this, function() {
            a.next(U(b));
        });
    };
    k.Hc = function(a, b, c) {
        var d = this;
        this.ba && Promise.resolve().then(function() {
            "function" === typeof a ? a(U(d)) : "function" === typeof a.next && a.next(U(d));
        });
        return this.ac(a, b, c);
    };
    k.Gc = function(a, b, c) {
        var d = this;
        this.ba && Promise.resolve().then(function() {
            d.X = d.getUid();
            "function" === typeof a ? a(U(d)) : "function" === typeof a.next && a.next(U(d));
        });
        return this.bc(a, b, c);
    };
    k.mc = function(a) {
        var b = this, c = this.i.then(function() {
            return U(b) ? U(b).I(a).then(function(d) {
                return {
                    accessToken: d
                };
            }) : null;
        });
        return T(this, c);
    };
    k.Sc = function(a) {
        var b = this;
        return this.i.then(function() {
            return Kn(b, O(b.a, Gj, {
                token: a
            }));
        }).then(function(c) {
            var d = c.user;
            Wm(d, "isAnonymous", !1);
            b.da(d);
            return c;
        });
    };
    k.Tc = function(a, b) {
        var c = this;
        return this.i.then(function() {
            return Kn(c, O(c.a, Xg, {
                email: a,
                password: b
            }));
        });
    };
    k.dc = function(a, b) {
        var c = this;
        return this.i.then(function() {
            return Kn(c, O(c.a, Aj, {
                email: a,
                password: b
            }));
        });
    };
    k.Za = function(a) {
        var b = this;
        return this.i.then(function() {
            return Kn(b, a.ja(b.a));
        });
    };
    k.Rc = function(a) {
        cf("firebase.auth.Auth.prototype.signInAndRetrieveDataWithCredential is deprecated. Please use firebase.auth.Auth.prototype.signInWithCredential instead.");
        return this.Za(a);
    };
    k.yb = function() {
        var a = this;
        return this.i.then(function() {
            var b = U(a);
            if (b && b.isAnonymous) {
                var c = ff({
                    providerId: null,
                    isNewUser: !1
                });
                return ff({
                    user: b,
                    credential: null,
                    additionalUserInfo: c,
                    operationType: "signIn"
                });
            }
            return Kn(a, a.a.yb()).then(function(d) {
                var e = d.user;
                Wm(e, "isAnonymous", !0);
                a.da(e);
                return d;
            });
        });
    };
    function S(a) {
        return a.app;
    }
    function U(a) {
        return a.currentUser;
    }
    k.getUid = function() {
        return U(this) && U(this).uid || null;
    };
    function Qn(a) {
        return U(a) && U(a)._lat || null;
    }
    function Mn(a) {
        if (a.ba) {
            for(var b = 0; b < a.u.length; b++)if (a.u[b]) a.u[b](Qn(a));
            if (a.X !== a.getUid() && a.P.length) {
                for(a.X = a.getUid(), b = 0; b < a.P.length; b++)if (a.P[b]) a.P[b](Qn(a));
            }
        }
    }
    k.cc = function(a) {
        this.addAuthTokenListener(a);
        this.A++;
        0 < this.A && U(this) && Mm(U(this));
    };
    k.Oc = function(a) {
        var b = this;
        w(this.u, function(c) {
            c == a && b.A--;
        });
        0 > this.A && (this.A = 0);
        0 == this.A && U(this) && Nm(U(this));
        this.removeAuthTokenListener(a);
    };
    k.addAuthTokenListener = function(a) {
        var b = this;
        this.u.push(a);
        T(this, this.i.then(function() {
            b.m || Ta(b.u, a) && a(Qn(b));
        }));
    };
    k.removeAuthTokenListener = function(a) {
        Va(this.u, function(b) {
            return b == a;
        });
    };
    function Pn(a, b) {
        a.P.push(b);
        T(a, a.i.then(function() {
            !a.m && Ta(a.P, b) && a.X !== a.getUid() && (a.X = a.getUid(), b(Qn(a)));
        }));
    }
    k.delete = function() {
        this.m = !0;
        for(var a = 0; a < this.R.length; a++)this.R[a].cancel("app-deleted");
        this.R = [];
        this.l && (a = this.l, a.b.removeListener(rn("local"), a.a, this.pa));
        this.b && (Ll(this.b, this), Vl(this.b.b));
        return Promise.resolve();
    };
    function T(a, b) {
        a.R.push(b);
        b.na(function() {
            Ua(a.R, b);
        });
        return b;
    }
    k.gc = function(a) {
        return T(this, Xi(this.a, a));
    };
    k.Ac = function(a) {
        return !!bh(a);
    };
    k.vb = function(a, b) {
        var c = this;
        return T(this, D().then(function() {
            var d = new Of(b);
            if (!d.c) throw new t("argument-error", Wf + " must be true when sending sign in link to email");
            return Yf(d);
        }).then(function(d) {
            return c.a.vb(a, d);
        }).then(function() {}));
    };
    k.hd = function(a) {
        return this.Qa(a).then(function(b) {
            return b.data.email;
        });
    };
    k.mb = function(a, b) {
        return T(this, this.a.mb(a, b).then(function() {}));
    };
    k.Qa = function(a) {
        return T(this, this.a.Qa(a).then(function(b) {
            return new rf(b);
        }));
    };
    k.ib = function(a) {
        return T(this, this.a.ib(a).then(function() {}));
    };
    k.ub = function(a, b) {
        var c = this;
        return T(this, D().then(function() {
            return "undefined" === typeof b || kb(b) ? {} : Yf(new Of(b));
        }).then(function(d) {
            return c.a.ub(a, d);
        }).then(function() {}));
    };
    k.Vc = function(a, b) {
        return T(this, bm(this, a, b, q(this.Za, this)));
    };
    k.Uc = function(a, b) {
        var c = this;
        return T(this, D().then(function() {
            var d = b || me(), e = ah(a, d);
            d = bh(d);
            if (!d) throw new t("argument-error", "Invalid email link!");
            if (d.tenantId !== c.S()) throw new t("tenant-id-mismatch");
            return c.Za(e);
        }));
    };
    function Rn() {}
    Rn.prototype.render = function() {};
    Rn.prototype.reset = function() {};
    Rn.prototype.getResponse = function() {};
    Rn.prototype.execute = function() {};
    function Sn() {
        this.a = {};
        this.b = 1E12;
    }
    var Tn = null;
    Sn.prototype.render = function(a, b) {
        this.a[this.b.toString()] = new Un(a, b);
        return this.b++;
    };
    Sn.prototype.reset = function(a) {
        var b = Vn(this, a);
        a = Wn(a);
        b && a && (b.delete(), delete this.a[a]);
    };
    Sn.prototype.getResponse = function(a) {
        return (a = Vn(this, a)) ? a.getResponse() : null;
    };
    Sn.prototype.execute = function(a) {
        (a = Vn(this, a)) && a.execute();
    };
    function Vn(a, b) {
        return (b = Wn(b)) ? a.a[b] || null : null;
    }
    function Wn(a) {
        return (a = "undefined" === typeof a ? 1E12 : a) ? a.toString() : null;
    }
    function Un(a, b) {
        this.g = !1;
        this.c = b;
        this.a = this.b = null;
        this.h = "invisible" !== this.c.size;
        this.f = fc(a);
        var c = this;
        this.i = function() {
            c.execute();
        };
        this.h ? this.execute() : jd(this.f, "click", this.i);
    }
    Un.prototype.getResponse = function() {
        Xn(this);
        return this.b;
    };
    Un.prototype.execute = function() {
        Xn(this);
        var a = this;
        this.a || (this.a = setTimeout(function() {
            a.b = He();
            var b = a.c.callback, c = a.c["expired-callback"];
            if (b) try {
                b(a.b);
            } catch (d) {}
            a.a = setTimeout(function() {
                a.a = null;
                a.b = null;
                if (c) try {
                    c();
                } catch (d) {}
                a.h && a.execute();
            }, 6E4);
        }, 500));
    };
    Un.prototype.delete = function() {
        Xn(this);
        this.g = !0;
        clearTimeout(this.a);
        this.a = null;
        G(this.f, "click", this.i);
    };
    function Xn(a) {
        if (a.g) throw Error("reCAPTCHA mock was already deleted!");
    }
    function Yn() {}
    M(Yn, "FACTOR_ID", "phone");
    function Zn() {}
    Zn.prototype.g = function() {
        Tn || (Tn = new Sn);
        return D(Tn);
    };
    Zn.prototype.c = function() {};
    var $n = null;
    function ao() {
        this.b = l.grecaptcha ? Infinity : 0;
        this.f = null;
        this.a = "__rcb" + Math.floor(1E6 * Math.random()).toString();
    }
    var bo = new ob(pb, "https://www.google.com/recaptcha/api.js?onload=%{onload}&render=explicit&hl=%{hl}"), co = new Ue(3E4, 6E4);
    ao.prototype.g = function(a) {
        var b = this;
        return new C(function(c, d) {
            var e = setTimeout(function() {
                d(new t("network-request-failed"));
            }, co.get());
            if (!l.grecaptcha || a !== b.f && !b.b) {
                l[b.a] = function() {
                    if (l.grecaptcha) {
                        b.f = a;
                        var g = l.grecaptcha.render;
                        l.grecaptcha.render = function(h, m) {
                            h = g(h, m);
                            b.b++;
                            return h;
                        };
                        clearTimeout(e);
                        c(l.grecaptcha);
                    } else clearTimeout(e), d(new t("internal-error"));
                    delete l[b.a];
                };
                var f = xb(bo, {
                    onload: b.a,
                    hl: a || ""
                });
                D(xi(f)).s(function() {
                    clearTimeout(e);
                    d(new t("internal-error", "Unable to load external reCAPTCHA dependencies!"));
                });
            } else clearTimeout(e), c(l.grecaptcha);
        });
    };
    ao.prototype.c = function() {
        this.b--;
    };
    var eo = null;
    function fo(a, b, c, d, e, f, g) {
        M(this, "type", "recaptcha");
        this.c = this.f = null;
        this.A = !1;
        this.m = b;
        this.g = null;
        g ? ($n || ($n = new Zn), g = $n) : (eo || (eo = new ao), g = eo);
        this.v = g;
        this.a = c || {
            theme: "light",
            type: "image"
        };
        this.h = [];
        if (this.a[go]) throw new t("argument-error", "sitekey should not be provided for reCAPTCHA as one is automatically provisioned for the current project.");
        this.i = "invisible" === this.a[ho];
        if (!l.document) throw new t("operation-not-supported-in-this-environment", "RecaptchaVerifier is only supported in a browser HTTP/HTTPS environment with DOM support.");
        if (!fc(b) || !this.i && fc(b).hasChildNodes()) throw new t("argument-error", "reCAPTCHA container is either not found or already contains inner elements!");
        this.o = new Ei(a, f || null, e || null);
        this.u = d || function() {
            return null;
        };
        var h = this;
        this.l = [];
        var m = this.a[io];
        this.a[io] = function(v) {
            jo(h, v);
            if ("function" === typeof m) m(v);
            else if ("string" === typeof m) {
                var B = L(m, l);
                "function" === typeof B && B(v);
            }
        };
        var p = this.a[ko];
        this.a[ko] = function() {
            jo(h, null);
            if ("function" === typeof p) p();
            else if ("string" === typeof p) {
                var v = L(p, l);
                "function" === typeof v && v();
            }
        };
    }
    var io = "callback", ko = "expired-callback", go = "sitekey", ho = "size";
    function jo(a, b) {
        for(var c = 0; c < a.l.length; c++)try {
            a.l[c](b);
        } catch (d) {}
    }
    function lo(a, b) {
        Va(a.l, function(c) {
            return c == b;
        });
    }
    function mo(a, b) {
        a.h.push(b);
        b.na(function() {
            Ua(a.h, b);
        });
        return b;
    }
    k = fo.prototype;
    k.Ia = function() {
        var a = this;
        return this.f ? this.f : this.f = mo(this, D().then(function() {
            if (Ne() && !Ee()) return ze();
            throw new t("operation-not-supported-in-this-environment", "RecaptchaVerifier is only supported in a browser HTTP/HTTPS environment.");
        }).then(function() {
            return a.v.g(a.u());
        }).then(function(b) {
            a.g = b;
            return O(a.o, Fj, {});
        }).then(function(b) {
            a.a[go] = b.recaptchaSiteKey;
        }).s(function(b) {
            a.f = null;
            throw b;
        }));
    };
    k.render = function() {
        no(this);
        var a = this;
        return mo(this, this.Ia().then(function() {
            if (null === a.c) {
                var b = a.m;
                if (!a.i) {
                    var c = fc(b);
                    b = ic("DIV");
                    c.appendChild(b);
                }
                a.c = a.g.render(b, a.a);
            }
            return a.c;
        }));
    };
    k.verify = function() {
        no(this);
        var a = this;
        return mo(this, this.render().then(function(b) {
            return new C(function(c) {
                var d = a.g.getResponse(b);
                if (d) c(d);
                else {
                    var e = function(f) {
                        f && (lo(a, e), c(f));
                    };
                    a.l.push(e);
                    a.i && a.g.execute(a.c);
                }
            });
        }));
    };
    k.reset = function() {
        no(this);
        null !== this.c && this.g.reset(this.c);
    };
    function no(a) {
        if (a.A) throw new t("internal-error", "RecaptchaVerifier instance has been destroyed.");
    }
    k.clear = function() {
        no(this);
        this.A = !0;
        this.v.c();
        for(var a = 0; a < this.h.length; a++)this.h[a].cancel("RecaptchaVerifier instance has been destroyed.");
        if (!this.i) {
            a = fc(this.m);
            for(var b; b = a.firstChild;)a.removeChild(b);
        }
    };
    function oo(a, b, c) {
        var d = !1;
        try {
            this.b = c || firebase.app();
        } catch (g) {
            throw new t("argument-error", "No firebase.app.App instance is currently initialized.");
        }
        if (this.b.options && this.b.options.apiKey) c = this.b.options.apiKey;
        else throw new t("invalid-api-key");
        var e = this, f = null;
        try {
            f = this.b.auth().Ga();
        } catch (g) {}
        try {
            d = this.b.auth().settings.appVerificationDisabledForTesting;
        } catch (g) {}
        f = firebase.SDK_VERSION ? Je(firebase.SDK_VERSION, f) : null;
        fo.call(this, c, a, b, function() {
            try {
                var g = e.b.auth().ka();
            } catch (h) {
                g = null;
            }
            return g;
        }, f, Aa(Ba), d);
    }
    r(oo, fo);
    function po(a, b, c, d) {
        a: {
            c = Array.prototype.slice.call(c);
            var e = 0;
            for(var f = !1, g = 0; g < b.length; g++)if (b[g].optional) f = !0;
            else {
                if (f) throw new t("internal-error", "Argument validator encountered a required argument after an optional argument.");
                e++;
            }
            f = b.length;
            if (c.length < e || f < c.length) d = "Expected " + (e == f ? 1 == e ? "1 argument" : e + " arguments" : e + "-" + f + " arguments") + " but got " + c.length + ".";
            else {
                for(e = 0; e < c.length; e++)if (f = b[e].optional && void 0 === c[e], !b[e].K(c[e]) && !f) {
                    b = b[e];
                    if (0 > e || e >= qo.length) throw new t("internal-error", "Argument validator received an unsupported number of arguments.");
                    c = qo[e];
                    d = (d ? "" : c + " argument ") + (b.name ? '"' + b.name + '" ' : "") + "must be " + b.J + ".";
                    break a;
                }
                d = null;
            }
        }
        if (d) throw new t("argument-error", a + " failed: " + d);
    }
    var qo = "First Second Third Fourth Fifth Sixth Seventh Eighth Ninth".split(" ");
    function V(a, b) {
        return {
            name: a || "",
            J: "a valid string",
            optional: !!b,
            K: function(c) {
                return "string" === typeof c;
            }
        };
    }
    function ro(a, b) {
        return {
            name: a || "",
            J: "a boolean",
            optional: !!b,
            K: function(c) {
                return "boolean" === typeof c;
            }
        };
    }
    function W(a, b) {
        return {
            name: a || "",
            J: "a valid object",
            optional: !!b,
            K: n
        };
    }
    function so(a, b) {
        return {
            name: a || "",
            J: "a function",
            optional: !!b,
            K: function(c) {
                return "function" === typeof c;
            }
        };
    }
    function to(a, b) {
        return {
            name: a || "",
            J: "null",
            optional: !!b,
            K: function(c) {
                return null === c;
            }
        };
    }
    function uo() {
        return {
            name: "",
            J: "an HTML element",
            optional: !1,
            K: function(a) {
                return !!(a && a instanceof Element);
            }
        };
    }
    function vo() {
        return {
            name: "auth",
            J: "an instance of Firebase Auth",
            optional: !0,
            K: function(a) {
                return !!(a && a instanceof zn);
            }
        };
    }
    function wo() {
        return {
            name: "app",
            J: "an instance of Firebase App",
            optional: !0,
            K: function(a) {
                return !!(a && a instanceof firebase.app.App);
            }
        };
    }
    function xo(a) {
        return {
            name: a ? a + "Credential" : "credential",
            J: a ? "a valid " + a + " credential" : "a valid credential",
            optional: !1,
            K: function(b) {
                if (!b) return !1;
                var c = !a || b.providerId === a;
                return !(!b.ja || !c);
            }
        };
    }
    function yo() {
        return {
            name: "multiFactorAssertion",
            J: "a valid multiFactorAssertion",
            optional: !1,
            K: function(a) {
                return a ? !!a.rb : !1;
            }
        };
    }
    function zo() {
        return {
            name: "authProvider",
            J: "a valid Auth provider",
            optional: !1,
            K: function(a) {
                return !!(a && a.providerId && a.hasOwnProperty && a.hasOwnProperty("isOAuthProvider"));
            }
        };
    }
    function Ao(a, b) {
        return n(a) && "string" === typeof a.type && a.type === b && "function" === typeof a.Ha;
    }
    function Bo(a) {
        return n(a) && "string" === typeof a.uid;
    }
    function Co() {
        return {
            name: "applicationVerifier",
            J: "an implementation of firebase.auth.ApplicationVerifier",
            optional: !1,
            K: function(a) {
                return !(!a || "string" !== typeof a.type || "function" !== typeof a.verify);
            }
        };
    }
    function X(a, b, c, d) {
        return {
            name: c || "",
            J: a.J + " or " + b.J,
            optional: !!d,
            K: function(e) {
                return a.K(e) || b.K(e);
            }
        };
    }
    function Y(a, b) {
        for(var c in b){
            var d = b[c].name;
            a[d] = Do(d, a[c], b[c].j);
        }
    }
    function Eo(a, b) {
        for(var c in b){
            var d = b[c].name;
            d !== c && Object.defineProperty(a, d, {
                get: ta(function(e) {
                    return this[e];
                }, c),
                set: ta(function(e, f, g, h) {
                    po(e, [
                        g
                    ], [
                        h
                    ], !0);
                    this[f] = h;
                }, d, c, b[c].jb),
                enumerable: !0
            });
        }
    }
    function Z(a, b, c, d) {
        a[b] = Do(b, c, d);
    }
    function Do(a, b, c) {
        function d() {
            var g = Array.prototype.slice.call(arguments);
            po(e, c, g);
            return b.apply(this, g);
        }
        if (!c) return b;
        var e = Fo(a), f;
        for(f in b)d[f] = b[f];
        for(f in b.prototype)d.prototype[f] = b.prototype[f];
        return d;
    }
    function Fo(a) {
        a = a.split(".");
        return a[a.length - 1];
    }
    Y(zn.prototype, {
        ib: {
            name: "applyActionCode",
            j: [
                V("code")
            ]
        },
        Qa: {
            name: "checkActionCode",
            j: [
                V("code")
            ]
        },
        mb: {
            name: "confirmPasswordReset",
            j: [
                V("code"),
                V("newPassword")
            ]
        },
        dc: {
            name: "createUserWithEmailAndPassword",
            j: [
                V("email"),
                V("password")
            ]
        },
        gc: {
            name: "fetchSignInMethodsForEmail",
            j: [
                V("email")
            ]
        },
        qa: {
            name: "getRedirectResult",
            j: []
        },
        Ac: {
            name: "isSignInWithEmailLink",
            j: [
                V("emailLink")
            ]
        },
        Gc: {
            name: "onAuthStateChanged",
            j: [
                X(W(), so(), "nextOrObserver"),
                so("opt_error", !0),
                so("opt_completed", !0)
            ]
        },
        Hc: {
            name: "onIdTokenChanged",
            j: [
                X(W(), so(), "nextOrObserver"),
                so("opt_error", !0),
                so("opt_completed", !0)
            ]
        },
        ub: {
            name: "sendPasswordResetEmail",
            j: [
                V("email"),
                X(W("opt_actionCodeSettings", !0), to(null, !0), "opt_actionCodeSettings", !0)
            ]
        },
        vb: {
            name: "sendSignInLinkToEmail",
            j: [
                V("email"),
                W("actionCodeSettings")
            ]
        },
        wb: {
            name: "setPersistence",
            j: [
                V("persistence")
            ]
        },
        Rc: {
            name: "signInAndRetrieveDataWithCredential",
            j: [
                xo()
            ]
        },
        yb: {
            name: "signInAnonymously",
            j: []
        },
        Za: {
            name: "signInWithCredential",
            j: [
                xo()
            ]
        },
        Sc: {
            name: "signInWithCustomToken",
            j: [
                V("token")
            ]
        },
        Tc: {
            name: "signInWithEmailAndPassword",
            j: [
                V("email"),
                V("password")
            ]
        },
        Uc: {
            name: "signInWithEmailLink",
            j: [
                V("email"),
                V("emailLink", !0)
            ]
        },
        Vc: {
            name: "signInWithPhoneNumber",
            j: [
                V("phoneNumber"),
                Co()
            ]
        },
        Wc: {
            name: "signInWithPopup",
            j: [
                zo()
            ]
        },
        Xc: {
            name: "signInWithRedirect",
            j: [
                zo()
            ]
        },
        cd: {
            name: "updateCurrentUser",
            j: [
                X(function(a) {
                    return {
                        name: "user",
                        J: "an instance of Firebase User",
                        optional: !!a,
                        K: function(b) {
                            return !!(b && b instanceof Dm);
                        }
                    };
                }(), to(), "user")
            ]
        },
        zb: {
            name: "signOut",
            j: []
        },
        toJSON: {
            name: "toJSON",
            j: [
                V(null, !0)
            ]
        },
        ed: {
            name: "useDeviceLanguage",
            j: []
        },
        fd: {
            name: "useEmulator",
            j: [
                V("url")
            ]
        },
        hd: {
            name: "verifyPasswordResetCode",
            j: [
                V("code")
            ]
        }
    });
    Eo(zn.prototype, {
        lc: {
            name: "languageCode",
            jb: X(V(), to(), "languageCode")
        },
        ti: {
            name: "tenantId",
            jb: X(V(), to(), "tenantId")
        }
    });
    zn.Persistence = Mk;
    zn.Persistence.LOCAL = "local";
    zn.Persistence.SESSION = "session";
    zn.Persistence.NONE = "none";
    Y(Dm.prototype, {
        "delete": {
            name: "delete",
            j: []
        },
        nc: {
            name: "getIdTokenResult",
            j: [
                ro("opt_forceRefresh", !0)
            ]
        },
        I: {
            name: "getIdToken",
            j: [
                ro("opt_forceRefresh", !0)
            ]
        },
        Bc: {
            name: "linkAndRetrieveDataWithCredential",
            j: [
                xo()
            ]
        },
        pb: {
            name: "linkWithCredential",
            j: [
                xo()
            ]
        },
        Cc: {
            name: "linkWithPhoneNumber",
            j: [
                V("phoneNumber"),
                Co()
            ]
        },
        Dc: {
            name: "linkWithPopup",
            j: [
                zo()
            ]
        },
        Ec: {
            name: "linkWithRedirect",
            j: [
                zo()
            ]
        },
        Kc: {
            name: "reauthenticateAndRetrieveDataWithCredential",
            j: [
                xo()
            ]
        },
        sb: {
            name: "reauthenticateWithCredential",
            j: [
                xo()
            ]
        },
        Lc: {
            name: "reauthenticateWithPhoneNumber",
            j: [
                V("phoneNumber"),
                Co()
            ]
        },
        Mc: {
            name: "reauthenticateWithPopup",
            j: [
                zo()
            ]
        },
        Nc: {
            name: "reauthenticateWithRedirect",
            j: [
                zo()
            ]
        },
        reload: {
            name: "reload",
            j: []
        },
        tb: {
            name: "sendEmailVerification",
            j: [
                X(W("opt_actionCodeSettings", !0), to(null, !0), "opt_actionCodeSettings", !0)
            ]
        },
        toJSON: {
            name: "toJSON",
            j: [
                V(null, !0)
            ]
        },
        bd: {
            name: "unlink",
            j: [
                V("provider")
            ]
        },
        Ab: {
            name: "updateEmail",
            j: [
                V("email")
            ]
        },
        Bb: {
            name: "updatePassword",
            j: [
                V("password")
            ]
        },
        dd: {
            name: "updatePhoneNumber",
            j: [
                xo("phone")
            ]
        },
        Cb: {
            name: "updateProfile",
            j: [
                W("profile")
            ]
        },
        Db: {
            name: "verifyBeforeUpdateEmail",
            j: [
                V("email"),
                X(W("opt_actionCodeSettings", !0), to(null, !0), "opt_actionCodeSettings", !0)
            ]
        }
    });
    Y(Sn.prototype, {
        execute: {
            name: "execute"
        },
        render: {
            name: "render"
        },
        reset: {
            name: "reset"
        },
        getResponse: {
            name: "getResponse"
        }
    });
    Y(Rn.prototype, {
        execute: {
            name: "execute"
        },
        render: {
            name: "render"
        },
        reset: {
            name: "reset"
        },
        getResponse: {
            name: "getResponse"
        }
    });
    Y(C.prototype, {
        na: {
            name: "finally"
        },
        s: {
            name: "catch"
        },
        then: {
            name: "then"
        }
    });
    Eo($l.prototype, {
        appVerificationDisabled: {
            name: "appVerificationDisabledForTesting",
            jb: ro("appVerificationDisabledForTesting")
        }
    });
    Y(am.prototype, {
        confirm: {
            name: "confirm",
            j: [
                V("verificationCode")
            ]
        }
    });
    Z(xg, "fromJSON", function(a) {
        a = "string" === typeof a ? JSON.parse(a) : a;
        for(var b, c = [
            Ig,
            $g,
            gh,
            Fg
        ], d = 0; d < c.length; d++)if (b = c[d](a)) return b;
        return null;
    }, [
        X(V(), W(), "json")
    ]);
    Z(Vg, "credential", function(a, b) {
        return new Ug(a, b);
    }, [
        V("email"),
        V("password")
    ]);
    Y(Ug.prototype, {
        w: {
            name: "toJSON",
            j: [
                V(null, !0)
            ]
        }
    });
    Y(Mg.prototype, {
        Ca: {
            name: "addScope",
            j: [
                V("scope")
            ]
        },
        Ka: {
            name: "setCustomParameters",
            j: [
                W("customOAuthParameters")
            ]
        }
    });
    Z(Mg, "credential", Ng, [
        X(V(), W(), "token")
    ]);
    Z(Vg, "credentialWithLink", ah, [
        V("email"),
        V("emailLink")
    ]);
    Y(Og.prototype, {
        Ca: {
            name: "addScope",
            j: [
                V("scope")
            ]
        },
        Ka: {
            name: "setCustomParameters",
            j: [
                W("customOAuthParameters")
            ]
        }
    });
    Z(Og, "credential", Pg, [
        X(V(), W(), "token")
    ]);
    Y(Qg.prototype, {
        Ca: {
            name: "addScope",
            j: [
                V("scope")
            ]
        },
        Ka: {
            name: "setCustomParameters",
            j: [
                W("customOAuthParameters")
            ]
        }
    });
    Z(Qg, "credential", Rg, [
        X(V(), X(W(), to()), "idToken"),
        X(V(), to(), "accessToken", !0)
    ]);
    Y(Sg.prototype, {
        Ka: {
            name: "setCustomParameters",
            j: [
                W("customOAuthParameters")
            ]
        }
    });
    Z(Sg, "credential", Tg, [
        X(V(), W(), "token"),
        V("secret", !0)
    ]);
    Y(Lg.prototype, {
        Ca: {
            name: "addScope",
            j: [
                V("scope")
            ]
        },
        credential: {
            name: "credential",
            j: [
                X(V(), X(W(), to()), "optionsOrIdToken"),
                X(V(), to(), "accessToken", !0)
            ]
        },
        Ka: {
            name: "setCustomParameters",
            j: [
                W("customOAuthParameters")
            ]
        }
    });
    Y(Gg.prototype, {
        w: {
            name: "toJSON",
            j: [
                V(null, !0)
            ]
        }
    });
    Y(Ag.prototype, {
        w: {
            name: "toJSON",
            j: [
                V(null, !0)
            ]
        }
    });
    Z(hh, "credential", lh, [
        V("verificationId"),
        V("verificationCode")
    ]);
    Y(hh.prototype, {
        eb: {
            name: "verifyPhoneNumber",
            j: [
                X(V(), function(a, b) {
                    return {
                        name: a || "phoneInfoOptions",
                        J: "valid phone info options",
                        optional: !!b,
                        K: function(c) {
                            return c ? c.session && c.phoneNumber ? Ao(c.session, vg) && "string" === typeof c.phoneNumber : c.session && c.multiFactorHint ? Ao(c.session, wg) && Bo(c.multiFactorHint) : c.session && c.multiFactorUid ? Ao(c.session, wg) && "string" === typeof c.multiFactorUid : c.phoneNumber ? "string" === typeof c.phoneNumber : !1 : !1;
                        }
                    };
                }(), "phoneInfoOptions"),
                Co()
            ]
        }
    });
    Y(ch.prototype, {
        w: {
            name: "toJSON",
            j: [
                V(null, !0)
            ]
        }
    });
    Y(t.prototype, {
        toJSON: {
            name: "toJSON",
            j: [
                V(null, !0)
            ]
        }
    });
    Y(uh.prototype, {
        toJSON: {
            name: "toJSON",
            j: [
                V(null, !0)
            ]
        }
    });
    Y(th.prototype, {
        toJSON: {
            name: "toJSON",
            j: [
                V(null, !0)
            ]
        }
    });
    Y(gm.prototype, {
        toJSON: {
            name: "toJSON",
            j: [
                V(null, !0)
            ]
        }
    });
    Y(dm.prototype, {
        Qc: {
            name: "resolveSignIn",
            j: [
                yo()
            ]
        }
    });
    Y(om.prototype, {
        Qb: {
            name: "getSession",
            j: []
        },
        ec: {
            name: "enroll",
            j: [
                yo(),
                V("displayName", !0)
            ]
        },
        ad: {
            name: "unenroll",
            j: [
                X({
                    name: "multiFactorInfo",
                    J: "a valid multiFactorInfo",
                    optional: !1,
                    K: Bo
                }, V(), "multiFactorInfoIdentifier")
            ]
        }
    });
    Y(oo.prototype, {
        clear: {
            name: "clear",
            j: []
        },
        render: {
            name: "render",
            j: []
        },
        verify: {
            name: "verify",
            j: []
        }
    });
    Z(Ff, "parseLink", Nf, [
        V("link")
    ]);
    Z(Yn, "assertion", function(a) {
        return new mm(a);
    }, [
        xo("phone")
    ]);
    (function() {
        if ("undefined" !== typeof firebase && firebase.INTERNAL && firebase.INTERNAL.registerComponent) {
            var a = {
                ActionCodeInfo: {
                    Operation: {
                        EMAIL_SIGNIN: wf,
                        PASSWORD_RESET: "PASSWORD_RESET",
                        RECOVER_EMAIL: "RECOVER_EMAIL",
                        REVERT_SECOND_FACTOR_ADDITION: yf,
                        VERIFY_AND_CHANGE_EMAIL: xf,
                        VERIFY_EMAIL: "VERIFY_EMAIL"
                    }
                },
                Auth: zn,
                AuthCredential: xg,
                Error: t
            };
            Z(a, "EmailAuthProvider", Vg, []);
            Z(a, "FacebookAuthProvider", Mg, []);
            Z(a, "GithubAuthProvider", Og, []);
            Z(a, "GoogleAuthProvider", Qg, []);
            Z(a, "TwitterAuthProvider", Sg, []);
            Z(a, "OAuthProvider", Lg, [
                V("providerId")
            ]);
            Z(a, "SAMLAuthProvider", Kg, [
                V("providerId")
            ]);
            Z(a, "PhoneAuthProvider", hh, [
                vo()
            ]);
            Z(a, "RecaptchaVerifier", oo, [
                X(V(), uo(), "recaptchaContainer"),
                W("recaptchaParameters", !0),
                wo()
            ]);
            Z(a, "ActionCodeURL", Ff, []);
            Z(a, "PhoneMultiFactorGenerator", Yn, []);
            firebase.INTERNAL.registerComponent({
                name: "auth",
                instanceFactory: function(b) {
                    b = b.getProvider("app").getImmediate();
                    return new zn(b);
                },
                multipleInstances: !1,
                serviceProps: a,
                instantiationMode: "LAZY",
                type: "PUBLIC"
            });
            firebase.INTERNAL.registerComponent({
                name: "auth-internal",
                instanceFactory: function(b) {
                    b = b.getProvider("auth").getImmediate();
                    return {
                        getUid: q(b.getUid, b),
                        getToken: q(b.mc, b),
                        addAuthTokenListener: q(b.cc, b),
                        removeAuthTokenListener: q(b.Oc, b)
                    };
                },
                multipleInstances: !1,
                instantiationMode: "LAZY",
                type: "PRIVATE"
            });
            firebase.registerVersion("@firebase/auth", "0.15.0");
            firebase.INTERNAL.extendNamespace({
                User: Dm
            });
        } else throw Error("Cannot find the firebase namespace; be sure to include firebase-app.js before this library.");
    })();
}).apply(typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {});


var $d1f87d24500ab009$exports = {};

var $hPtJY = parcelRequire("hPtJY");
"use strict";
Object.defineProperty($d1f87d24500ab009$exports, "__esModule", {
    value: true
});

var $31dJ8 = parcelRequire("31dJ8");
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $a92b69d2447c208d$var$extendStatics = function(d, b) {
    $a92b69d2447c208d$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $a92b69d2447c208d$var$extendStatics(d, b);
};
function $a92b69d2447c208d$export$a8ba968b8961cb8a(d, b) {
    $a92b69d2447c208d$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $a92b69d2447c208d$export$18ce0697a983be9b = function() {
    $a92b69d2447c208d$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $a92b69d2447c208d$export$18ce0697a983be9b.apply(this, arguments);
};
function $a92b69d2447c208d$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $a92b69d2447c208d$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $a92b69d2447c208d$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $a92b69d2447c208d$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $a92b69d2447c208d$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $a92b69d2447c208d$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $a92b69d2447c208d$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $a92b69d2447c208d$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $a92b69d2447c208d$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $a92b69d2447c208d$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $a92b69d2447c208d$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($a92b69d2447c208d$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $a92b69d2447c208d$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $a92b69d2447c208d$export$10c90e4f7922046c(v) {
    return this instanceof $a92b69d2447c208d$export$10c90e4f7922046c ? (this.v = v, this) : new $a92b69d2447c208d$export$10c90e4f7922046c(v);
}
function $a92b69d2447c208d$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $a92b69d2447c208d$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $a92b69d2447c208d$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $a92b69d2447c208d$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $a92b69d2447c208d$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $a92b69d2447c208d$export$19a8beecd37a4c45 === "function" ? $a92b69d2447c208d$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $a92b69d2447c208d$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $a92b69d2447c208d$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $a92b69d2447c208d$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $a92b69d2447c208d$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $a92b69d2447c208d$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}



var $01sTD = parcelRequire("01sTD");

var $d4M6f = parcelRequire("d4M6f");

var $gLWqF = parcelRequire("gLWqF");
function $d1f87d24500ab009$var$_interopDefaultLegacy(e) {
    return e && typeof e === "object" && "default" in e ? e : {
        "default": e
    };
}
var $d1f87d24500ab009$var$firebase__default = /*#__PURE__*/ $d1f87d24500ab009$var$_interopDefaultLegacy($31dJ8);
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Wraps a DOM Storage object and:
 * - automatically encode objects as JSON strings before storing them to allow us to store arbitrary types.
 * - prefixes names with "firebase:" to avoid collisions with app data.
 *
 * We automatically (see storage.js) create two such wrappers, one for sessionStorage,
 * and one for localStorage.
 *
 * @constructor
 */ var $d1f87d24500ab009$var$DOMStorageWrapper = /** @class */ function() {
    /**
     * @param {Storage} domStorage_ The underlying storage object (e.g. localStorage or sessionStorage)
     */ function DOMStorageWrapper(domStorage_) {
        this.domStorage_ = domStorage_;
        // Use a prefix to avoid collisions with other stuff saved by the app.
        this.prefix_ = "firebase:";
    }
    /**
     * @param {string} key The key to save the value under
     * @param {?Object} value The value being stored, or null to remove the key.
     */ DOMStorageWrapper.prototype.set = function(key, value) {
        if (value == null) this.domStorage_.removeItem(this.prefixedName_(key));
        else this.domStorage_.setItem(this.prefixedName_(key), $01sTD.stringify(value));
    };
    /**
     * @param {string} key
     * @return {*} The value that was stored under this key, or null
     */ DOMStorageWrapper.prototype.get = function(key) {
        var storedVal = this.domStorage_.getItem(this.prefixedName_(key));
        if (storedVal == null) return null;
        else return $01sTD.jsonEval(storedVal);
    };
    /**
     * @param {string} key
     */ DOMStorageWrapper.prototype.remove = function(key) {
        this.domStorage_.removeItem(this.prefixedName_(key));
    };
    /**
     * @param {string} name
     * @return {string}
     */ DOMStorageWrapper.prototype.prefixedName_ = function(name) {
        return this.prefix_ + name;
    };
    DOMStorageWrapper.prototype.toString = function() {
        return this.domStorage_.toString();
    };
    return DOMStorageWrapper;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An in-memory storage implementation that matches the API of DOMStorageWrapper
 * (TODO: create interface for both to implement).
 *
 * @constructor
 */ var $d1f87d24500ab009$var$MemoryStorage = /** @class */ function() {
    function MemoryStorage() {
        this.cache_ = {};
        this.isInMemoryStorage = true;
    }
    MemoryStorage.prototype.set = function(key, value) {
        if (value == null) delete this.cache_[key];
        else this.cache_[key] = value;
    };
    MemoryStorage.prototype.get = function(key) {
        if ($01sTD.contains(this.cache_, key)) return this.cache_[key];
        return null;
    };
    MemoryStorage.prototype.remove = function(key) {
        delete this.cache_[key];
    };
    return MemoryStorage;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Helper to create a DOMStorageWrapper or else fall back to MemoryStorage.
 * TODO: Once MemoryStorage and DOMStorageWrapper have a shared interface this method annotation should change
 * to reflect this type
 *
 * @param {string} domStorageName Name of the underlying storage object
 *   (e.g. 'localStorage' or 'sessionStorage').
 * @return {?} Turning off type information until a common interface is defined.
 */ var $d1f87d24500ab009$var$createStoragefor = function(domStorageName) {
    try {
        // NOTE: just accessing "localStorage" or "window['localStorage']" may throw a security exception,
        // so it must be inside the try/catch.
        if (typeof window !== "undefined" && typeof window[domStorageName] !== "undefined") {
            // Need to test cache. Just because it's here doesn't mean it works
            var domStorage = window[domStorageName];
            domStorage.setItem("firebase:sentinel", "cache");
            domStorage.removeItem("firebase:sentinel");
            return new $d1f87d24500ab009$var$DOMStorageWrapper(domStorage);
        }
    } catch (e) {}
    // Failed to create wrapper.  Just return in-memory storage.
    // TODO: log?
    return new $d1f87d24500ab009$var$MemoryStorage();
};
/** A storage object that lasts across sessions */ var $d1f87d24500ab009$var$PersistentStorage = $d1f87d24500ab009$var$createStoragefor("localStorage");
/** A storage object that only lasts one session */ var $d1f87d24500ab009$var$SessionStorage = $d1f87d24500ab009$var$createStoragefor("sessionStorage");
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $d1f87d24500ab009$var$logClient = new $d4M6f.Logger("@firebase/database");
/**
 * Returns a locally-unique ID (generated by just incrementing up from 0 each time its called).
 * @type {function(): number} Generated ID.
 */ var $d1f87d24500ab009$var$LUIDGenerator = function() {
    var id = 1;
    return function() {
        return id++;
    };
}();
/**
 * Sha1 hash of the input string
 * @param {!string} str The string to hash
 * @return {!string} The resulting hash
 */ var $d1f87d24500ab009$var$sha1 = function(str) {
    var utf8Bytes = $01sTD.stringToByteArray(str);
    var sha1 = new $01sTD.Sha1();
    sha1.update(utf8Bytes);
    var sha1Bytes = sha1.digest();
    return $01sTD.base64.encodeByteArray(sha1Bytes);
};
/**
 * @param {...*} varArgs
 * @return {string}
 * @private
 */ var $d1f87d24500ab009$var$buildLogMessage_ = function() {
    var varArgs = [];
    for(var _i = 0; _i < arguments.length; _i++)varArgs[_i] = arguments[_i];
    var message = "";
    for(var i = 0; i < varArgs.length; i++){
        var arg = varArgs[i];
        if (Array.isArray(arg) || arg && typeof arg === "object" && // eslint-disable-next-line @typescript-eslint/no-explicit-any
        typeof arg.length === "number") message += $d1f87d24500ab009$var$buildLogMessage_.apply(null, arg);
        else if (typeof arg === "object") message += $01sTD.stringify(arg);
        else message += arg;
        message += " ";
    }
    return message;
};
/**
 * Use this for all debug messages in Firebase.
 * @type {?function(string)}
 */ var $d1f87d24500ab009$var$logger = null;
/**
 * Flag to check for log availability on first log message
 * @type {boolean}
 * @private
 */ var $d1f87d24500ab009$var$firstLog_ = true;
/**
 * The implementation of Firebase.enableLogging (defined here to break dependencies)
 * @param {boolean|?function(string)} logger_ A flag to turn on logging, or a custom logger
 * @param {boolean=} persistent Whether or not to persist logging settings across refreshes
 */ var $d1f87d24500ab009$var$enableLogging = function(logger_, persistent) {
    $01sTD.assert(!persistent || logger_ === true || logger_ === false, "Can't turn on custom loggers persistently.");
    if (logger_ === true) {
        $d1f87d24500ab009$var$logClient.logLevel = $d4M6f.LogLevel.VERBOSE;
        $d1f87d24500ab009$var$logger = $d1f87d24500ab009$var$logClient.log.bind($d1f87d24500ab009$var$logClient);
        if (persistent) $d1f87d24500ab009$var$SessionStorage.set("logging_enabled", true);
    } else if (typeof logger_ === "function") $d1f87d24500ab009$var$logger = logger_;
    else {
        $d1f87d24500ab009$var$logger = null;
        $d1f87d24500ab009$var$SessionStorage.remove("logging_enabled");
    }
};
/**
 *
 * @param {...(string|Arguments)} varArgs
 */ var $d1f87d24500ab009$var$log = function() {
    var varArgs = [];
    for(var _i = 0; _i < arguments.length; _i++)varArgs[_i] = arguments[_i];
    if ($d1f87d24500ab009$var$firstLog_ === true) {
        $d1f87d24500ab009$var$firstLog_ = false;
        if ($d1f87d24500ab009$var$logger === null && $d1f87d24500ab009$var$SessionStorage.get("logging_enabled") === true) $d1f87d24500ab009$var$enableLogging(true);
    }
    if ($d1f87d24500ab009$var$logger) {
        var message = $d1f87d24500ab009$var$buildLogMessage_.apply(null, varArgs);
        $d1f87d24500ab009$var$logger(message);
    }
};
/**
 * @param {!string} prefix
 * @return {function(...[*])}
 */ var $d1f87d24500ab009$var$logWrapper = function(prefix) {
    return function() {
        var varArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)varArgs[_i] = arguments[_i];
        $d1f87d24500ab009$var$log.apply(void 0, $a92b69d2447c208d$export$afc72e2116322959([
            prefix
        ], varArgs));
    };
};
/**
 * @param {...string} varArgs
 */ var $d1f87d24500ab009$var$error = function() {
    var varArgs = [];
    for(var _i = 0; _i < arguments.length; _i++)varArgs[_i] = arguments[_i];
    var message = "FIREBASE INTERNAL ERROR: " + $d1f87d24500ab009$var$buildLogMessage_.apply(void 0, $a92b69d2447c208d$export$afc72e2116322959(varArgs));
    $d1f87d24500ab009$var$logClient.error(message);
};
/**
 * @param {...string} varArgs
 */ var $d1f87d24500ab009$var$fatal = function() {
    var varArgs = [];
    for(var _i = 0; _i < arguments.length; _i++)varArgs[_i] = arguments[_i];
    var message = "FIREBASE FATAL ERROR: " + $d1f87d24500ab009$var$buildLogMessage_.apply(void 0, $a92b69d2447c208d$export$afc72e2116322959(varArgs));
    $d1f87d24500ab009$var$logClient.error(message);
    throw new Error(message);
};
/**
 * @param {...*} varArgs
 */ var $d1f87d24500ab009$var$warn = function() {
    var varArgs = [];
    for(var _i = 0; _i < arguments.length; _i++)varArgs[_i] = arguments[_i];
    var message = "FIREBASE WARNING: " + $d1f87d24500ab009$var$buildLogMessage_.apply(void 0, $a92b69d2447c208d$export$afc72e2116322959(varArgs));
    $d1f87d24500ab009$var$logClient.warn(message);
};
/**
 * Logs a warning if the containing page uses https. Called when a call to new Firebase
 * does not use https.
 */ var $d1f87d24500ab009$var$warnIfPageIsSecure = function() {
    // Be very careful accessing browser globals. Who knows what may or may not exist.
    if (typeof window !== "undefined" && window.location && window.location.protocol && window.location.protocol.indexOf("https:") !== -1) $d1f87d24500ab009$var$warn("Insecure Firebase access from a secure page. Please use https in calls to new Firebase().");
};
/**
 * Returns true if data is NaN, or +/- Infinity.
 * @param {*} data
 * @return {boolean}
 */ var $d1f87d24500ab009$var$isInvalidJSONNumber = function(data) {
    return typeof data === "number" && (data !== data || // NaN
    data === Number.POSITIVE_INFINITY || data === Number.NEGATIVE_INFINITY);
};
/**
 * @param {function()} fn
 */ var $d1f87d24500ab009$var$executeWhenDOMReady = function(fn) {
    if ($01sTD.isNodeSdk() || document.readyState === "complete") fn();
    else {
        // Modeled after jQuery. Try DOMContentLoaded and onreadystatechange (which
        // fire before onload), but fall back to onload.
        var called_1 = false;
        var wrappedFn_1 = function() {
            if (!document.body) {
                setTimeout(wrappedFn_1, Math.floor(10));
                return;
            }
            if (!called_1) {
                called_1 = true;
                fn();
            }
        };
        if (document.addEventListener) {
            document.addEventListener("DOMContentLoaded", wrappedFn_1, false);
            // fallback to onload.
            window.addEventListener("load", wrappedFn_1, false);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } else if (document.attachEvent) {
            // IE.
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            document.attachEvent("onreadystatechange", function() {
                if (document.readyState === "complete") wrappedFn_1();
            });
            // fallback to onload.
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            window.attachEvent("onload", wrappedFn_1);
        // jQuery has an extra hack for IE that we could employ (based on
        // http://javascript.nwbox.com/IEContentLoaded/) But it looks really old.
        // I'm hoping we don't need it.
        }
    }
};
/**
 * Minimum key name. Invalid for actual data, used as a marker to sort before any valid names
 * @type {!string}
 */ var $d1f87d24500ab009$var$MIN_NAME = "[MIN_NAME]";
/**
 * Maximum key name. Invalid for actual data, used as a marker to sort above any valid names
 * @type {!string}
 */ var $d1f87d24500ab009$var$MAX_NAME = "[MAX_NAME]";
/**
 * Compares valid Firebase key names, plus min and max name
 * @param {!string} a
 * @param {!string} b
 * @return {!number}
 */ var $d1f87d24500ab009$var$nameCompare = function(a, b) {
    if (a === b) return 0;
    else if (a === $d1f87d24500ab009$var$MIN_NAME || b === $d1f87d24500ab009$var$MAX_NAME) return -1;
    else if (b === $d1f87d24500ab009$var$MIN_NAME || a === $d1f87d24500ab009$var$MAX_NAME) return 1;
    else {
        var aAsInt = $d1f87d24500ab009$var$tryParseInt(a), bAsInt = $d1f87d24500ab009$var$tryParseInt(b);
        if (aAsInt !== null) {
            if (bAsInt !== null) return aAsInt - bAsInt === 0 ? a.length - b.length : aAsInt - bAsInt;
            else return -1;
        } else if (bAsInt !== null) return 1;
        else return a < b ? -1 : 1;
    }
};
/**
 * @param {!string} a
 * @param {!string} b
 * @return {!number} comparison result.
 */ var $d1f87d24500ab009$var$stringCompare = function(a, b) {
    if (a === b) return 0;
    else if (a < b) return -1;
    else return 1;
};
/**
 * @param {string} key
 * @param {Object} obj
 * @return {*}
 */ var $d1f87d24500ab009$var$requireKey = function(key, obj) {
    if (obj && key in obj) return obj[key];
    else throw new Error("Missing required key (" + key + ") in object: " + $01sTD.stringify(obj));
};
/**
 * @param {*} obj
 * @return {string}
 */ var $d1f87d24500ab009$var$ObjectToUniqueKey = function(obj) {
    if (typeof obj !== "object" || obj === null) return $01sTD.stringify(obj);
    var keys = [];
    // eslint-disable-next-line guard-for-in
    for(var k in obj)keys.push(k);
    // Export as json, but with the keys sorted.
    keys.sort();
    var key = "{";
    for(var i = 0; i < keys.length; i++){
        if (i !== 0) key += ",";
        key += $01sTD.stringify(keys[i]);
        key += ":";
        key += $d1f87d24500ab009$var$ObjectToUniqueKey(obj[keys[i]]);
    }
    key += "}";
    return key;
};
/**
 * Splits a string into a number of smaller segments of maximum size
 * @param {!string} str The string
 * @param {!number} segsize The maximum number of chars in the string.
 * @return {Array.<string>} The string, split into appropriately-sized chunks
 */ var $d1f87d24500ab009$var$splitStringBySize = function(str, segsize) {
    var len = str.length;
    if (len <= segsize) return [
        str
    ];
    var dataSegs = [];
    for(var c = 0; c < len; c += segsize)if (c + segsize > len) dataSegs.push(str.substring(c, len));
    else dataSegs.push(str.substring(c, c + segsize));
    return dataSegs;
};
/**
 * Apply a function to each (key, value) pair in an object or
 * apply a function to each (index, value) pair in an array
 * @param obj The object or array to iterate over
 * @param fn The function to apply
 */ function $d1f87d24500ab009$var$each(obj, fn) {
    for(var key in obj)if (obj.hasOwnProperty(key)) fn(key, obj[key]);
}
/**
 * Borrowed from http://hg.secondlife.com/llsd/src/tip/js/typedarray.js (MIT License)
 * I made one modification at the end and removed the NaN / Infinity
 * handling (since it seemed broken [caused an overflow] and we don't need it).  See MJL comments.
 * @param {!number} v A double
 * @return {string}
 */ var $d1f87d24500ab009$var$doubleToIEEE754String = function(v) {
    $01sTD.assert(!$d1f87d24500ab009$var$isInvalidJSONNumber(v), "Invalid JSON number"); // MJL
    var ebits = 11, fbits = 52;
    var bias = (1 << ebits - 1) - 1;
    var s, e, f, ln, i;
    // Compute sign, exponent, fraction
    // Skip NaN / Infinity handling --MJL.
    if (v === 0) {
        e = 0;
        f = 0;
        s = 1 / v === -Infinity ? 1 : 0;
    } else {
        s = v < 0;
        v = Math.abs(v);
        if (v >= Math.pow(2, 1 - bias)) {
            // Normalized
            ln = Math.min(Math.floor(Math.log(v) / Math.LN2), bias);
            e = ln + bias;
            f = Math.round(v * Math.pow(2, fbits - ln) - Math.pow(2, fbits));
        } else {
            // Denormalized
            e = 0;
            f = Math.round(v / Math.pow(2, 1 - bias - fbits));
        }
    }
    // Pack sign, exponent, fraction
    var bits = [];
    for(i = fbits; i; i -= 1){
        bits.push(f % 2 ? 1 : 0);
        f = Math.floor(f / 2);
    }
    for(i = ebits; i; i -= 1){
        bits.push(e % 2 ? 1 : 0);
        e = Math.floor(e / 2);
    }
    bits.push(s ? 1 : 0);
    bits.reverse();
    var str = bits.join("");
    // Return the data as a hex string. --MJL
    var hexByteString = "";
    for(i = 0; i < 64; i += 8){
        var hexByte = parseInt(str.substr(i, 8), 2).toString(16);
        if (hexByte.length === 1) hexByte = "0" + hexByte;
        hexByteString = hexByteString + hexByte;
    }
    return hexByteString.toLowerCase();
};
/**
 * Used to detect if we're in a Chrome content script (which executes in an
 * isolated environment where long-polling doesn't work).
 * @return {boolean}
 */ var $d1f87d24500ab009$var$isChromeExtensionContentScript = function() {
    return !!(typeof window === "object" && window["chrome"] && window["chrome"]["extension"] && !/^chrome/.test(window.location.href));
};
/**
 * Used to detect if we're in a Windows 8 Store app.
 * @return {boolean}
 */ var $d1f87d24500ab009$var$isWindowsStoreApp = function() {
    // Check for the presence of a couple WinRT globals
    return typeof Windows === "object" && typeof Windows.UI === "object";
};
/**
 * Converts a server error code to a Javascript Error
 * @param {!string} code
 * @param {!Query} query
 * @return {Error}
 */ var $d1f87d24500ab009$var$errorForServerCode = function(code, query) {
    var reason = "Unknown Error";
    if (code === "too_big") reason = "The data requested exceeds the maximum size that can be accessed with a single request.";
    else if (code === "permission_denied") reason = "Client doesn't have permission to access the desired data.";
    else if (code === "unavailable") reason = "The service is unavailable";
    var error = new Error(code + " at " + query.path.toString() + ": " + reason);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    error.code = code.toUpperCase();
    return error;
};
/**
 * Used to test for integer-looking strings
 * @type {RegExp}
 * @private
 */ var $d1f87d24500ab009$var$INTEGER_REGEXP_ = new RegExp("^-?(0*)\\d{1,10}$");
/**
 * If the string contains a 32-bit integer, return it.  Else return null.
 * @param {!string} str
 * @return {?number}
 */ var $d1f87d24500ab009$var$tryParseInt = function(str) {
    if ($d1f87d24500ab009$var$INTEGER_REGEXP_.test(str)) {
        var intVal = Number(str);
        if (intVal >= -2147483648 && intVal <= 2147483647) return intVal;
    }
    return null;
};
/**
 * Helper to run some code but catch any exceptions and re-throw them later.
 * Useful for preventing user callbacks from breaking internal code.
 *
 * Re-throwing the exception from a setTimeout is a little evil, but it's very
 * convenient (we don't have to try to figure out when is a safe point to
 * re-throw it), and the behavior seems reasonable:
 *
 * * If you aren't pausing on exceptions, you get an error in the console with
 *   the correct stack trace.
 * * If you're pausing on all exceptions, the debugger will pause on your
 *   exception and then again when we rethrow it.
 * * If you're only pausing on uncaught exceptions, the debugger will only pause
 *   on us re-throwing it.
 *
 * @param {!function()} fn The code to guard.
 */ var $d1f87d24500ab009$var$exceptionGuard = function(fn) {
    try {
        fn();
    } catch (e) {
        // Re-throw exception when it's safe.
        setTimeout(function() {
            // It used to be that "throw e" would result in a good console error with
            // relevant context, but as of Chrome 39, you just get the firebase.js
            // file/line number where we re-throw it, which is useless. So we log
            // e.stack explicitly.
            var stack = e.stack || "";
            $d1f87d24500ab009$var$warn("Exception was thrown by user callback.", stack);
            throw e;
        }, Math.floor(0));
    }
};
/**
 * @return {boolean} true if we think we're currently being crawled.
 */ var $d1f87d24500ab009$var$beingCrawled = function() {
    var userAgent = typeof window === "object" && window["navigator"] && window["navigator"]["userAgent"] || "";
    // For now we whitelist the most popular crawlers.  We should refine this to be the set of crawlers we
    // believe to support JavaScript/AJAX rendering.
    // NOTE: Google Webmaster Tools doesn't really belong, but their "This is how a visitor to your website
    // would have seen the page" is flaky if we don't treat it as a crawler.
    return userAgent.search(/googlebot|google webmaster tools|bingbot|yahoo! slurp|baiduspider|yandexbot|duckduckbot/i) >= 0;
};
/**
 * Same as setTimeout() except on Node.JS it will /not/ prevent the process from exiting.
 *
 * It is removed with clearTimeout() as normal.
 *
 * @param {Function} fn Function to run.
 * @param {number} time Milliseconds to wait before running.
 * @return {number|Object} The setTimeout() return value.
 */ var $d1f87d24500ab009$var$setTimeoutNonBlocking = function(fn, time) {
    var timeout = setTimeout(fn, time);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if (typeof timeout === "object" && timeout["unref"]) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    timeout["unref"]();
    return timeout;
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An immutable object representing a parsed path.  It's immutable so that you
 * can pass them around to other functions without worrying about them changing
 * it.
 */ var $d1f87d24500ab009$var$Path = /** @class */ function() {
    /**
     * @param {string|Array.<string>} pathOrString Path string to parse,
     *      or another path, or the raw tokens array
     * @param {number=} pieceNum
     */ function Path(pathOrString, pieceNum) {
        if (pieceNum === void 0) {
            this.pieces_ = pathOrString.split("/");
            // Remove empty pieces.
            var copyTo = 0;
            for(var i = 0; i < this.pieces_.length; i++)if (this.pieces_[i].length > 0) {
                this.pieces_[copyTo] = this.pieces_[i];
                copyTo++;
            }
            this.pieces_.length = copyTo;
            this.pieceNum_ = 0;
        } else {
            this.pieces_ = pathOrString;
            this.pieceNum_ = pieceNum;
        }
    }
    Object.defineProperty(Path, "Empty", {
        /**
         * Singleton to represent an empty path
         *
         * @const
         */ get: function() {
            return new Path("");
        },
        enumerable: false,
        configurable: true
    });
    Path.prototype.getFront = function() {
        if (this.pieceNum_ >= this.pieces_.length) return null;
        return this.pieces_[this.pieceNum_];
    };
    /**
     * @return {number} The number of segments in this path
     */ Path.prototype.getLength = function() {
        return this.pieces_.length - this.pieceNum_;
    };
    /**
     * @return {!Path}
     */ Path.prototype.popFront = function() {
        var pieceNum = this.pieceNum_;
        if (pieceNum < this.pieces_.length) pieceNum++;
        return new Path(this.pieces_, pieceNum);
    };
    /**
     * @return {?string}
     */ Path.prototype.getBack = function() {
        if (this.pieceNum_ < this.pieces_.length) return this.pieces_[this.pieces_.length - 1];
        return null;
    };
    Path.prototype.toString = function() {
        var pathString = "";
        for(var i = this.pieceNum_; i < this.pieces_.length; i++)if (this.pieces_[i] !== "") pathString += "/" + this.pieces_[i];
        return pathString || "/";
    };
    Path.prototype.toUrlEncodedString = function() {
        var pathString = "";
        for(var i = this.pieceNum_; i < this.pieces_.length; i++)if (this.pieces_[i] !== "") pathString += "/" + encodeURIComponent(String(this.pieces_[i]));
        return pathString || "/";
    };
    /**
     * Shallow copy of the parts of the path.
     *
     * @param {number=} begin
     * @return {!Array<string>}
     */ Path.prototype.slice = function(begin) {
        if (begin === void 0) begin = 0;
        return this.pieces_.slice(this.pieceNum_ + begin);
    };
    /**
     * @return {?Path}
     */ Path.prototype.parent = function() {
        if (this.pieceNum_ >= this.pieces_.length) return null;
        var pieces = [];
        for(var i = this.pieceNum_; i < this.pieces_.length - 1; i++)pieces.push(this.pieces_[i]);
        return new Path(pieces, 0);
    };
    /**
     * @param {string|!Path} childPathObj
     * @return {!Path}
     */ Path.prototype.child = function(childPathObj) {
        var pieces = [];
        for(var i = this.pieceNum_; i < this.pieces_.length; i++)pieces.push(this.pieces_[i]);
        if (childPathObj instanceof Path) for(var i = childPathObj.pieceNum_; i < childPathObj.pieces_.length; i++)pieces.push(childPathObj.pieces_[i]);
        else {
            var childPieces = childPathObj.split("/");
            for(var i = 0; i < childPieces.length; i++)if (childPieces[i].length > 0) pieces.push(childPieces[i]);
        }
        return new Path(pieces, 0);
    };
    /**
     * @return {boolean} True if there are no segments in this path
     */ Path.prototype.isEmpty = function() {
        return this.pieceNum_ >= this.pieces_.length;
    };
    /**
     * @param {!Path} outerPath
     * @param {!Path} innerPath
     * @return {!Path} The path from outerPath to innerPath
     */ Path.relativePath = function(outerPath, innerPath) {
        var outer = outerPath.getFront(), inner = innerPath.getFront();
        if (outer === null) return innerPath;
        else if (outer === inner) return Path.relativePath(outerPath.popFront(), innerPath.popFront());
        else throw new Error("INTERNAL ERROR: innerPath (" + innerPath + ") is not within " + "outerPath (" + outerPath + ")");
    };
    /**
     * @param {!Path} left
     * @param {!Path} right
     * @return {number} -1, 0, 1 if left is less, equal, or greater than the right.
     */ Path.comparePaths = function(left, right) {
        var leftKeys = left.slice();
        var rightKeys = right.slice();
        for(var i = 0; i < leftKeys.length && i < rightKeys.length; i++){
            var cmp = $d1f87d24500ab009$var$nameCompare(leftKeys[i], rightKeys[i]);
            if (cmp !== 0) return cmp;
        }
        if (leftKeys.length === rightKeys.length) return 0;
        return leftKeys.length < rightKeys.length ? -1 : 1;
    };
    /**
     *
     * @param {Path} other
     * @return {boolean} true if paths are the same.
     */ Path.prototype.equals = function(other) {
        if (this.getLength() !== other.getLength()) return false;
        for(var i = this.pieceNum_, j = other.pieceNum_; i <= this.pieces_.length; i++, j++){
            if (this.pieces_[i] !== other.pieces_[j]) return false;
        }
        return true;
    };
    /**
     *
     * @param {!Path} other
     * @return {boolean} True if this path is a parent (or the same as) other
     */ Path.prototype.contains = function(other) {
        var i = this.pieceNum_;
        var j = other.pieceNum_;
        if (this.getLength() > other.getLength()) return false;
        while(i < this.pieces_.length){
            if (this.pieces_[i] !== other.pieces_[j]) return false;
            ++i;
            ++j;
        }
        return true;
    };
    return Path;
}(); // end Path
/**
 * Dynamic (mutable) path used to count path lengths.
 *
 * This class is used to efficiently check paths for valid
 * length (in UTF8 bytes) and depth (used in path validation).
 *
 * Throws Error exception if path is ever invalid.
 *
 * The definition of a path always begins with '/'.
 */ var $d1f87d24500ab009$var$ValidationPath = /** @class */ function() {
    /**
     * @param {!Path} path Initial Path.
     * @param {string} errorPrefix_ Prefix for any error messages.
     */ function ValidationPath(path, errorPrefix_) {
        this.errorPrefix_ = errorPrefix_;
        /** @type {!Array<string>} */ this.parts_ = path.slice();
        /** @type {number} Initialize to number of '/' chars needed in path. */ this.byteLength_ = Math.max(1, this.parts_.length);
        for(var i = 0; i < this.parts_.length; i++)this.byteLength_ += $01sTD.stringLength(this.parts_[i]);
        this.checkValid_();
    }
    Object.defineProperty(ValidationPath, "MAX_PATH_DEPTH", {
        /** @const {number} Maximum key depth. */ get: function() {
            return 32;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ValidationPath, "MAX_PATH_LENGTH_BYTES", {
        /** @const {number} Maximum number of (UTF8) bytes in a Firebase path. */ get: function() {
            return 768;
        },
        enumerable: false,
        configurable: true
    });
    /** @param {string} child */ ValidationPath.prototype.push = function(child) {
        // Count the needed '/'
        if (this.parts_.length > 0) this.byteLength_ += 1;
        this.parts_.push(child);
        this.byteLength_ += $01sTD.stringLength(child);
        this.checkValid_();
    };
    ValidationPath.prototype.pop = function() {
        var last = this.parts_.pop();
        this.byteLength_ -= $01sTD.stringLength(last);
        // Un-count the previous '/'
        if (this.parts_.length > 0) this.byteLength_ -= 1;
    };
    ValidationPath.prototype.checkValid_ = function() {
        if (this.byteLength_ > ValidationPath.MAX_PATH_LENGTH_BYTES) throw new Error(this.errorPrefix_ + "has a key path longer than " + ValidationPath.MAX_PATH_LENGTH_BYTES + " bytes (" + this.byteLength_ + ").");
        if (this.parts_.length > ValidationPath.MAX_PATH_DEPTH) throw new Error(this.errorPrefix_ + "path specified exceeds the maximum depth that can be written (" + ValidationPath.MAX_PATH_DEPTH + ") or object contains a cycle " + this.toErrorString());
    };
    /**
     * String for use in error messages - uses '.' notation for path.
     *
     * @return {string}
     */ ValidationPath.prototype.toErrorString = function() {
        if (this.parts_.length === 0) return "";
        return "in property '" + this.parts_.join(".") + "'";
    };
    return ValidationPath;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $d1f87d24500ab009$var$PROTOCOL_VERSION = "5";
var $d1f87d24500ab009$var$VERSION_PARAM = "v";
var $d1f87d24500ab009$var$TRANSPORT_SESSION_PARAM = "s";
var $d1f87d24500ab009$var$REFERER_PARAM = "r";
var $d1f87d24500ab009$var$FORGE_REF = "f";
var $d1f87d24500ab009$var$FORGE_DOMAIN = "firebaseio.com";
var $d1f87d24500ab009$var$LAST_SESSION_PARAM = "ls";
var $d1f87d24500ab009$var$APPLICATION_ID_PARAM = "p";
var $d1f87d24500ab009$var$WEBSOCKET = "websocket";
var $d1f87d24500ab009$var$LONG_POLLING = "long_polling";
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A class that holds metadata about a Repo object
 *
 * @constructor
 */ var $d1f87d24500ab009$var$RepoInfo = /** @class */ function() {
    /**
     * @param host Hostname portion of the url for the repo
     * @param secure Whether or not this repo is accessed over ssl
     * @param namespace The namespace represented by the repo
     * @param webSocketOnly Whether to prefer websockets over all other transports (used by Nest).
     * @param nodeAdmin Whether this instance uses Admin SDK credentials
     * @param persistenceKey Override the default session persistence storage key
     */ function RepoInfo(host, secure, namespace, webSocketOnly, nodeAdmin, persistenceKey, includeNamespaceInQueryParams) {
        if (nodeAdmin === void 0) nodeAdmin = false;
        if (persistenceKey === void 0) persistenceKey = "";
        if (includeNamespaceInQueryParams === void 0) includeNamespaceInQueryParams = false;
        this.secure = secure;
        this.namespace = namespace;
        this.webSocketOnly = webSocketOnly;
        this.nodeAdmin = nodeAdmin;
        this.persistenceKey = persistenceKey;
        this.includeNamespaceInQueryParams = includeNamespaceInQueryParams;
        this.host = host.toLowerCase();
        this.domain = this.host.substr(this.host.indexOf(".") + 1);
        this.internalHost = $d1f87d24500ab009$var$PersistentStorage.get("host:" + host) || this.host;
    }
    RepoInfo.prototype.needsQueryParam = function() {
        return this.host !== this.internalHost || this.isCustomHost() || this.includeNamespaceInQueryParams;
    };
    RepoInfo.prototype.isCacheableHost = function() {
        return this.internalHost.substr(0, 2) === "s-";
    };
    RepoInfo.prototype.isDemoHost = function() {
        return this.domain === "firebaseio-demo.com";
    };
    RepoInfo.prototype.isCustomHost = function() {
        return this.domain !== "firebaseio.com" && this.domain !== "firebaseio-demo.com";
    };
    RepoInfo.prototype.updateHost = function(newHost) {
        if (newHost !== this.internalHost) {
            this.internalHost = newHost;
            if (this.isCacheableHost()) $d1f87d24500ab009$var$PersistentStorage.set("host:" + this.host, this.internalHost);
        }
    };
    /**
     * Returns the websocket URL for this repo
     * @param {string} type of connection
     * @param {Object} params list
     * @return {string} The URL for this repo
     */ RepoInfo.prototype.connectionURL = function(type, params) {
        $01sTD.assert(typeof type === "string", "typeof type must == string");
        $01sTD.assert(typeof params === "object", "typeof params must == object");
        var connURL;
        if (type === $d1f87d24500ab009$var$WEBSOCKET) connURL = (this.secure ? "wss://" : "ws://") + this.internalHost + "/.ws?";
        else if (type === $d1f87d24500ab009$var$LONG_POLLING) connURL = (this.secure ? "https://" : "http://") + this.internalHost + "/.lp?";
        else throw new Error("Unknown connection type: " + type);
        if (this.needsQueryParam()) params["ns"] = this.namespace;
        var pairs = [];
        $d1f87d24500ab009$var$each(params, function(key, value) {
            pairs.push(key + "=" + value);
        });
        return connURL + pairs.join("&");
    };
    /** @return {string} */ RepoInfo.prototype.toString = function() {
        var str = this.toURLString();
        if (this.persistenceKey) str += "<" + this.persistenceKey + ">";
        return str;
    };
    /** @return {string} */ RepoInfo.prototype.toURLString = function() {
        return (this.secure ? "https://" : "http://") + this.host;
    };
    return RepoInfo;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @param {!string} pathString
 * @return {string}
 */ function $d1f87d24500ab009$var$decodePath(pathString) {
    var pathStringDecoded = "";
    var pieces = pathString.split("/");
    for(var i = 0; i < pieces.length; i++)if (pieces[i].length > 0) {
        var piece = pieces[i];
        try {
            piece = decodeURIComponent(piece.replace(/\+/g, " "));
        } catch (e) {}
        pathStringDecoded += "/" + piece;
    }
    return pathStringDecoded;
}
/**
 * @param {!string} queryString
 * @return {!{[key:string]:string}} key value hash
 */ function $d1f87d24500ab009$var$decodeQuery(queryString) {
    var e_1, _a;
    var results = {};
    if (queryString.charAt(0) === "?") queryString = queryString.substring(1);
    try {
        for(var _b = $a92b69d2447c208d$export$19a8beecd37a4c45(queryString.split("&")), _c = _b.next(); !_c.done; _c = _b.next()){
            var segment = _c.value;
            if (segment.length === 0) continue;
            var kv = segment.split("=");
            if (kv.length === 2) results[decodeURIComponent(kv[0])] = decodeURIComponent(kv[1]);
            else $d1f87d24500ab009$var$warn("Invalid query segment '" + segment + "' in query '" + queryString + "'");
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return results;
}
var $d1f87d24500ab009$var$parseRepoInfo = function(dataURL, nodeAdmin) {
    var parsedUrl = $d1f87d24500ab009$var$parseDatabaseURL(dataURL), namespace = parsedUrl.namespace;
    if (parsedUrl.domain === "firebase.com") $d1f87d24500ab009$var$fatal(parsedUrl.host + " is no longer supported. " + "Please use <YOUR FIREBASE>.firebaseio.com instead");
    // Catch common error of uninitialized namespace value.
    if ((!namespace || namespace === "undefined") && parsedUrl.domain !== "localhost") $d1f87d24500ab009$var$fatal("Cannot parse Firebase url. Please use https://<YOUR FIREBASE>.firebaseio.com");
    if (!parsedUrl.secure) $d1f87d24500ab009$var$warnIfPageIsSecure();
    var webSocketOnly = parsedUrl.scheme === "ws" || parsedUrl.scheme === "wss";
    return {
        repoInfo: new $d1f87d24500ab009$var$RepoInfo(parsedUrl.host, parsedUrl.secure, namespace, nodeAdmin, webSocketOnly, /*persistenceKey=*/ "", /*includeNamespaceInQueryParams=*/ namespace !== parsedUrl.subdomain),
        path: new $d1f87d24500ab009$var$Path(parsedUrl.pathString)
    };
};
/**
 *
 * @param {!string} dataURL
 * @return {{host: string, port: number, domain: string, subdomain: string, secure: boolean, scheme: string, pathString: string, namespace: string}}
 */ var $d1f87d24500ab009$var$parseDatabaseURL = function(dataURL) {
    // Default to empty strings in the event of a malformed string.
    var host = "", domain = "", subdomain = "", pathString = "", namespace = "";
    // Always default to SSL, unless otherwise specified.
    var secure = true, scheme = "https", port = 443;
    // Don't do any validation here. The caller is responsible for validating the result of parsing.
    if (typeof dataURL === "string") {
        // Parse scheme.
        var colonInd = dataURL.indexOf("//");
        if (colonInd >= 0) {
            scheme = dataURL.substring(0, colonInd - 1);
            dataURL = dataURL.substring(colonInd + 2);
        }
        // Parse host, path, and query string.
        var slashInd = dataURL.indexOf("/");
        if (slashInd === -1) slashInd = dataURL.length;
        var questionMarkInd = dataURL.indexOf("?");
        if (questionMarkInd === -1) questionMarkInd = dataURL.length;
        host = dataURL.substring(0, Math.min(slashInd, questionMarkInd));
        if (slashInd < questionMarkInd) // For pathString, questionMarkInd will always come after slashInd
        pathString = $d1f87d24500ab009$var$decodePath(dataURL.substring(slashInd, questionMarkInd));
        var queryParams = $d1f87d24500ab009$var$decodeQuery(dataURL.substring(Math.min(dataURL.length, questionMarkInd)));
        // If we have a port, use scheme for determining if it's secure.
        colonInd = host.indexOf(":");
        if (colonInd >= 0) {
            secure = scheme === "https" || scheme === "wss";
            port = parseInt(host.substring(colonInd + 1), 10);
        } else colonInd = host.length;
        var hostWithoutPort = host.slice(0, colonInd);
        if (hostWithoutPort.toLowerCase() === "localhost") domain = "localhost";
        else if (hostWithoutPort.split(".").length <= 2) domain = hostWithoutPort;
        else {
            // Interpret the subdomain of a 3 or more component URL as the namespace name.
            var dotInd = host.indexOf(".");
            subdomain = host.substring(0, dotInd).toLowerCase();
            domain = host.substring(dotInd + 1);
            // Normalize namespaces to lowercase to share storage / connection.
            namespace = subdomain;
        }
        // Always treat the value of the `ns` as the namespace name if it is present.
        if ("ns" in queryParams) namespace = queryParams["ns"];
    }
    return {
        host: host,
        port: port,
        domain: domain,
        subdomain: subdomain,
        secure: secure,
        scheme: scheme,
        pathString: pathString,
        namespace: namespace
    };
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * True for invalid Firebase keys
 * @type {RegExp}
 * @private
 */ var $d1f87d24500ab009$var$INVALID_KEY_REGEX_ = /[\[\].#$\/\u0000-\u001F\u007F]/;
/**
 * True for invalid Firebase paths.
 * Allows '/' in paths.
 * @type {RegExp}
 * @private
 */ var $d1f87d24500ab009$var$INVALID_PATH_REGEX_ = /[\[\].#$\u0000-\u001F\u007F]/;
/**
 * Maximum number of characters to allow in leaf value
 * @type {number}
 * @private
 */ var $d1f87d24500ab009$var$MAX_LEAF_SIZE_ = 10485760;
/**
 * @param {*} key
 * @return {boolean}
 */ var $d1f87d24500ab009$var$isValidKey = function(key) {
    return typeof key === "string" && key.length !== 0 && !$d1f87d24500ab009$var$INVALID_KEY_REGEX_.test(key);
};
/**
 * @param {string} pathString
 * @return {boolean}
 */ var $d1f87d24500ab009$var$isValidPathString = function(pathString) {
    return typeof pathString === "string" && pathString.length !== 0 && !$d1f87d24500ab009$var$INVALID_PATH_REGEX_.test(pathString);
};
/**
 * @param {string} pathString
 * @return {boolean}
 */ var $d1f87d24500ab009$var$isValidRootPathString = function(pathString) {
    if (pathString) // Allow '/.info/' at the beginning.
    pathString = pathString.replace(/^\/*\.info(\/|$)/, "/");
    return $d1f87d24500ab009$var$isValidPathString(pathString);
};
/**
 * @param {*} priority
 * @return {boolean}
 */ var $d1f87d24500ab009$var$isValidPriority = function(priority) {
    return priority === null || typeof priority === "string" || typeof priority === "number" && !$d1f87d24500ab009$var$isInvalidJSONNumber(priority) || priority && typeof priority === "object" && // eslint-disable-next-line @typescript-eslint/no-explicit-any
    $01sTD.contains(priority, ".sv");
};
/**
 * Pre-validate a datum passed as an argument to Firebase function.
 *
 * @param {string} fnName
 * @param {number} argumentNumber
 * @param {*} data
 * @param {!Path} path
 * @param {boolean} optional
 */ var $d1f87d24500ab009$var$validateFirebaseDataArg = function(fnName, argumentNumber, data, path, optional) {
    if (optional && data === undefined) return;
    $d1f87d24500ab009$var$validateFirebaseData($01sTD.errorPrefix(fnName, argumentNumber, optional), data, path);
};
/**
 * Validate a data object client-side before sending to server.
 *
 * @param {string} errorPrefix
 * @param {*} data
 * @param {!Path|!ValidationPath} path_
 */ var $d1f87d24500ab009$var$validateFirebaseData = function(errorPrefix, data, path_) {
    var path = path_ instanceof $d1f87d24500ab009$var$Path ? new $d1f87d24500ab009$var$ValidationPath(path_, errorPrefix) : path_;
    if (data === undefined) throw new Error(errorPrefix + "contains undefined " + path.toErrorString());
    if (typeof data === "function") throw new Error(errorPrefix + "contains a function " + path.toErrorString() + " with contents = " + data.toString());
    if ($d1f87d24500ab009$var$isInvalidJSONNumber(data)) throw new Error(errorPrefix + "contains " + data.toString() + " " + path.toErrorString());
    // Check max leaf size, but try to avoid the utf8 conversion if we can.
    if (typeof data === "string" && data.length > $d1f87d24500ab009$var$MAX_LEAF_SIZE_ / 3 && $01sTD.stringLength(data) > $d1f87d24500ab009$var$MAX_LEAF_SIZE_) throw new Error(errorPrefix + "contains a string greater than " + $d1f87d24500ab009$var$MAX_LEAF_SIZE_ + " utf8 bytes " + path.toErrorString() + " ('" + data.substring(0, 50) + "...')");
    // TODO = Perf = Consider combining the recursive validation of keys into NodeFromJSON
    // to save extra walking of large objects.
    if (data && typeof data === "object") {
        var hasDotValue_1 = false;
        var hasActualChild_1 = false;
        $d1f87d24500ab009$var$each(data, function(key, value) {
            if (key === ".value") hasDotValue_1 = true;
            else if (key !== ".priority" && key !== ".sv") {
                hasActualChild_1 = true;
                if (!$d1f87d24500ab009$var$isValidKey(key)) throw new Error(errorPrefix + " contains an invalid key (" + key + ") " + path.toErrorString() + ".  Keys must be non-empty strings " + 'and can\'t contain ".", "#", "$", "/", "[", or "]"');
            }
            path.push(key);
            $d1f87d24500ab009$var$validateFirebaseData(errorPrefix, value, path);
            path.pop();
        });
        if (hasDotValue_1 && hasActualChild_1) throw new Error(errorPrefix + ' contains ".value" child ' + path.toErrorString() + " in addition to actual children.");
    }
};
/**
 * Pre-validate paths passed in the firebase function.
 *
 * @param {string} errorPrefix
 * @param {Array<!Path>} mergePaths
 */ var $d1f87d24500ab009$var$validateFirebaseMergePaths = function(errorPrefix, mergePaths) {
    var i, curPath;
    for(i = 0; i < mergePaths.length; i++){
        curPath = mergePaths[i];
        var keys = curPath.slice();
        for(var j = 0; j < keys.length; j++){
            if (keys[j] === ".priority" && j === keys.length - 1) ;
            else if (!$d1f87d24500ab009$var$isValidKey(keys[j])) throw new Error(errorPrefix + "contains an invalid key (" + keys[j] + ") in path " + curPath.toString() + ". Keys must be non-empty strings " + 'and can\'t contain ".", "#", "$", "/", "[", or "]"');
        }
    }
    // Check that update keys are not descendants of each other.
    // We rely on the property that sorting guarantees that ancestors come
    // right before descendants.
    mergePaths.sort($d1f87d24500ab009$var$Path.comparePaths);
    var prevPath = null;
    for(i = 0; i < mergePaths.length; i++){
        curPath = mergePaths[i];
        if (prevPath !== null && prevPath.contains(curPath)) throw new Error(errorPrefix + "contains a path " + prevPath.toString() + " that is ancestor of another path " + curPath.toString());
        prevPath = curPath;
    }
};
/**
 * pre-validate an object passed as an argument to firebase function (
 * must be an object - e.g. for firebase.update()).
 *
 * @param {string} fnName
 * @param {number} argumentNumber
 * @param {*} data
 * @param {!Path} path
 * @param {boolean} optional
 */ var $d1f87d24500ab009$var$validateFirebaseMergeDataArg = function(fnName, argumentNumber, data, path, optional) {
    if (optional && data === undefined) return;
    var errorPrefix = $01sTD.errorPrefix(fnName, argumentNumber, optional);
    if (!(data && typeof data === "object") || Array.isArray(data)) throw new Error(errorPrefix + " must be an object containing the children to replace.");
    var mergePaths = [];
    $d1f87d24500ab009$var$each(data, function(key, value) {
        var curPath = new $d1f87d24500ab009$var$Path(key);
        $d1f87d24500ab009$var$validateFirebaseData(errorPrefix, value, path.child(curPath));
        if (curPath.getBack() === ".priority") {
            if (!$d1f87d24500ab009$var$isValidPriority(value)) throw new Error(errorPrefix + "contains an invalid value for '" + curPath.toString() + "', which must be a valid " + "Firebase priority (a string, finite number, server value, or null).");
        }
        mergePaths.push(curPath);
    });
    $d1f87d24500ab009$var$validateFirebaseMergePaths(errorPrefix, mergePaths);
};
var $d1f87d24500ab009$var$validatePriority = function(fnName, argumentNumber, priority, optional) {
    if (optional && priority === undefined) return;
    if ($d1f87d24500ab009$var$isInvalidJSONNumber(priority)) throw new Error($01sTD.errorPrefix(fnName, argumentNumber, optional) + "is " + priority.toString() + ", but must be a valid Firebase priority (a string, finite number, " + "server value, or null).");
    // Special case to allow importing data with a .sv.
    if (!$d1f87d24500ab009$var$isValidPriority(priority)) throw new Error($01sTD.errorPrefix(fnName, argumentNumber, optional) + "must be a valid Firebase priority " + "(a string, finite number, server value, or null).");
};
var $d1f87d24500ab009$var$validateEventType = function(fnName, argumentNumber, eventType, optional) {
    if (optional && eventType === undefined) return;
    switch(eventType){
        case "value":
        case "child_added":
        case "child_removed":
        case "child_changed":
        case "child_moved":
            break;
        default:
            throw new Error($01sTD.errorPrefix(fnName, argumentNumber, optional) + 'must be a valid event type = "value", "child_added", "child_removed", ' + '"child_changed", or "child_moved".');
    }
};
var $d1f87d24500ab009$var$validateKey = function(fnName, argumentNumber, key, optional) {
    if (optional && key === undefined) return;
    if (!$d1f87d24500ab009$var$isValidKey(key)) throw new Error($01sTD.errorPrefix(fnName, argumentNumber, optional) + 'was an invalid key = "' + key + '".  Firebase keys must be non-empty strings and ' + 'can\'t contain ".", "#", "$", "/", "[", or "]").');
};
var $d1f87d24500ab009$var$validatePathString = function(fnName, argumentNumber, pathString, optional) {
    if (optional && pathString === undefined) return;
    if (!$d1f87d24500ab009$var$isValidPathString(pathString)) throw new Error($01sTD.errorPrefix(fnName, argumentNumber, optional) + 'was an invalid path = "' + pathString + '". Paths must be non-empty strings and ' + 'can\'t contain ".", "#", "$", "[", or "]"');
};
var $d1f87d24500ab009$var$validateRootPathString = function(fnName, argumentNumber, pathString, optional) {
    if (pathString) // Allow '/.info/' at the beginning.
    pathString = pathString.replace(/^\/*\.info(\/|$)/, "/");
    $d1f87d24500ab009$var$validatePathString(fnName, argumentNumber, pathString, optional);
};
var $d1f87d24500ab009$var$validateWritablePath = function(fnName, path) {
    if (path.getFront() === ".info") throw new Error(fnName + " failed = Can't modify data under /.info/");
};
var $d1f87d24500ab009$var$validateUrl = function(fnName, argumentNumber, parsedUrl) {
    // TODO = Validate server better.
    var pathString = parsedUrl.path.toString();
    if (!(typeof parsedUrl.repoInfo.host === "string") || parsedUrl.repoInfo.host.length === 0 || !$d1f87d24500ab009$var$isValidKey(parsedUrl.repoInfo.namespace) && parsedUrl.repoInfo.host.split(":")[0] !== "localhost" || pathString.length !== 0 && !$d1f87d24500ab009$var$isValidRootPathString(pathString)) throw new Error($01sTD.errorPrefix(fnName, argumentNumber, false) + "must be a valid firebase URL and " + 'the path can\'t contain ".", "#", "$", "[", or "]".');
};
var $d1f87d24500ab009$var$validateBoolean = function(fnName, argumentNumber, bool, optional) {
    if (optional && bool === undefined) return;
    if (typeof bool !== "boolean") throw new Error($01sTD.errorPrefix(fnName, argumentNumber, optional) + "must be a boolean.");
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @constructor
 */ var $d1f87d24500ab009$var$OnDisconnect = /** @class */ function() {
    /**
     * @param {!Repo} repo_
     * @param {!Path} path_
     */ function OnDisconnect(repo_, path_) {
        this.repo_ = repo_;
        this.path_ = path_;
    }
    /**
     * @param {function(?Error)=} onComplete
     * @return {!firebase.Promise}
     */ OnDisconnect.prototype.cancel = function(onComplete) {
        $01sTD.validateArgCount("OnDisconnect.cancel", 0, 1, arguments.length);
        $01sTD.validateCallback("OnDisconnect.cancel", 1, onComplete, true);
        var deferred = new $01sTD.Deferred();
        this.repo_.onDisconnectCancel(this.path_, deferred.wrapCallback(onComplete));
        return deferred.promise;
    };
    /**
     * @param {function(?Error)=} onComplete
     * @return {!firebase.Promise}
     */ OnDisconnect.prototype.remove = function(onComplete) {
        $01sTD.validateArgCount("OnDisconnect.remove", 0, 1, arguments.length);
        $d1f87d24500ab009$var$validateWritablePath("OnDisconnect.remove", this.path_);
        $01sTD.validateCallback("OnDisconnect.remove", 1, onComplete, true);
        var deferred = new $01sTD.Deferred();
        this.repo_.onDisconnectSet(this.path_, null, deferred.wrapCallback(onComplete));
        return deferred.promise;
    };
    /**
     * @param {*} value
     * @param {function(?Error)=} onComplete
     * @return {!firebase.Promise}
     */ OnDisconnect.prototype.set = function(value, onComplete) {
        $01sTD.validateArgCount("OnDisconnect.set", 1, 2, arguments.length);
        $d1f87d24500ab009$var$validateWritablePath("OnDisconnect.set", this.path_);
        $d1f87d24500ab009$var$validateFirebaseDataArg("OnDisconnect.set", 1, value, this.path_, false);
        $01sTD.validateCallback("OnDisconnect.set", 2, onComplete, true);
        var deferred = new $01sTD.Deferred();
        this.repo_.onDisconnectSet(this.path_, value, deferred.wrapCallback(onComplete));
        return deferred.promise;
    };
    /**
     * @param {*} value
     * @param {number|string|null} priority
     * @param {function(?Error)=} onComplete
     * @return {!firebase.Promise}
     */ OnDisconnect.prototype.setWithPriority = function(value, priority, onComplete) {
        $01sTD.validateArgCount("OnDisconnect.setWithPriority", 2, 3, arguments.length);
        $d1f87d24500ab009$var$validateWritablePath("OnDisconnect.setWithPriority", this.path_);
        $d1f87d24500ab009$var$validateFirebaseDataArg("OnDisconnect.setWithPriority", 1, value, this.path_, false);
        $d1f87d24500ab009$var$validatePriority("OnDisconnect.setWithPriority", 2, priority, false);
        $01sTD.validateCallback("OnDisconnect.setWithPriority", 3, onComplete, true);
        var deferred = new $01sTD.Deferred();
        this.repo_.onDisconnectSetWithPriority(this.path_, value, priority, deferred.wrapCallback(onComplete));
        return deferred.promise;
    };
    /**
     * @param {!Object} objectToMerge
     * @param {function(?Error)=} onComplete
     * @return {!firebase.Promise}
     */ OnDisconnect.prototype.update = function(objectToMerge, onComplete) {
        $01sTD.validateArgCount("OnDisconnect.update", 1, 2, arguments.length);
        $d1f87d24500ab009$var$validateWritablePath("OnDisconnect.update", this.path_);
        if (Array.isArray(objectToMerge)) {
            var newObjectToMerge = {};
            for(var i = 0; i < objectToMerge.length; ++i)newObjectToMerge["" + i] = objectToMerge[i];
            objectToMerge = newObjectToMerge;
            $d1f87d24500ab009$var$warn("Passing an Array to firebase.database.onDisconnect().update() is deprecated. Use set() if you want to overwrite the existing data, or an Object with integer keys if you really do want to only update some of the children.");
        }
        $d1f87d24500ab009$var$validateFirebaseMergeDataArg("OnDisconnect.update", 1, objectToMerge, this.path_, false);
        $01sTD.validateCallback("OnDisconnect.update", 2, onComplete, true);
        var deferred = new $01sTD.Deferred();
        this.repo_.onDisconnectUpdate(this.path_, objectToMerge, deferred.wrapCallback(onComplete));
        return deferred.promise;
    };
    return OnDisconnect;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $d1f87d24500ab009$var$TransactionResult = /** @class */ function() {
    /**
     * A type for the resolve value of Firebase.transaction.
     * @constructor
     * @dict
     * @param {boolean} committed
     * @param {DataSnapshot} snapshot
     */ function TransactionResult(committed, snapshot) {
        this.committed = committed;
        this.snapshot = snapshot;
    }
    // Do not create public documentation. This is intended to make JSON serialization work but is otherwise unnecessary
    // for end-users
    TransactionResult.prototype.toJSON = function() {
        $01sTD.validateArgCount("TransactionResult.toJSON", 0, 1, arguments.length);
        return {
            committed: this.committed,
            snapshot: this.snapshot.toJSON()
        };
    };
    return TransactionResult;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Fancy ID generator that creates 20-character string identifiers with the
 * following properties:
 *
 * 1. They're based on timestamp so that they sort *after* any existing ids.
 * 2. They contain 72-bits of random data after the timestamp so that IDs won't
 *    collide with other clients' IDs.
 * 3. They sort *lexicographically* (so the timestamp is converted to characters
 *    that will sort properly).
 * 4. They're monotonically increasing. Even if you generate more than one in
 *    the same timestamp, the latter ones will sort after the former ones. We do
 *    this by using the previous random bits but "incrementing" them by 1 (only
 *    in the case of a timestamp collision).
 */ var $d1f87d24500ab009$var$nextPushId = function() {
    // Modeled after base64 web-safe chars, but ordered by ASCII.
    var PUSH_CHARS = "-0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ_abcdefghijklmnopqrstuvwxyz";
    // Timestamp of last push, used to prevent local collisions if you push twice
    // in one ms.
    var lastPushTime = 0;
    // We generate 72-bits of randomness which get turned into 12 characters and
    // appended to the timestamp to prevent collisions with other clients. We
    // store the last characters we generated because in the event of a collision,
    // we'll use those same characters except "incremented" by one.
    var lastRandChars = [];
    return function(now) {
        var duplicateTime = now === lastPushTime;
        lastPushTime = now;
        var i;
        var timeStampChars = new Array(8);
        for(i = 7; i >= 0; i--){
            timeStampChars[i] = PUSH_CHARS.charAt(now % 64);
            // NOTE: Can't use << here because javascript will convert to int and lose
            // the upper bits.
            now = Math.floor(now / 64);
        }
        $01sTD.assert(now === 0, "Cannot push at time == 0");
        var id = timeStampChars.join("");
        if (!duplicateTime) for(i = 0; i < 12; i++)lastRandChars[i] = Math.floor(Math.random() * 64);
        else {
            // If the timestamp hasn't changed since last push, use the same random
            // number, except incremented by 1.
            for(i = 11; i >= 0 && lastRandChars[i] === 63; i--)lastRandChars[i] = 0;
            lastRandChars[i]++;
        }
        for(i = 0; i < 12; i++)id += PUSH_CHARS.charAt(lastRandChars[i]);
        $01sTD.assert(id.length === 20, "nextPushId: Length should be 20.");
        return id;
    };
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 *
 * @param {!string} name
 * @param {!Node} node
 * @constructor
 * @struct
 */ var $d1f87d24500ab009$var$NamedNode = /** @class */ function() {
    function NamedNode(name, node) {
        this.name = name;
        this.node = node;
    }
    /**
     *
     * @param {!string} name
     * @param {!Node} node
     * @return {NamedNode}
     */ NamedNode.Wrap = function(name, node) {
        return new NamedNode(name, node);
    };
    return NamedNode;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 *
 * @constructor
 */ var $d1f87d24500ab009$var$Index = /** @class */ function() {
    function Index() {}
    /**
     * @return {function(!NamedNode, !NamedNode):number} A standalone comparison function for
     * this index
     */ Index.prototype.getCompare = function() {
        return this.compare.bind(this);
    };
    /**
     * Given a before and after value for a node, determine if the indexed value has changed. Even if they are different,
     * it's possible that the changes are isolated to parts of the snapshot that are not indexed.
     *
     * @param {!Node} oldNode
     * @param {!Node} newNode
     * @return {boolean} True if the portion of the snapshot being indexed changed between oldNode and newNode
     */ Index.prototype.indexedValueChanged = function(oldNode, newNode) {
        var oldWrapped = new $d1f87d24500ab009$var$NamedNode($d1f87d24500ab009$var$MIN_NAME, oldNode);
        var newWrapped = new $d1f87d24500ab009$var$NamedNode($d1f87d24500ab009$var$MIN_NAME, newNode);
        return this.compare(oldWrapped, newWrapped) !== 0;
    };
    /**
     * @return {!NamedNode} a node wrapper that will sort equal to or less than
     * any other node wrapper, using this index
     */ Index.prototype.minPost = function() {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return $d1f87d24500ab009$var$NamedNode.MIN;
    };
    return Index;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $d1f87d24500ab009$var$__EMPTY_NODE;
var $d1f87d24500ab009$var$KeyIndex = /** @class */ function(_super) {
    $a92b69d2447c208d$export$a8ba968b8961cb8a(KeyIndex, _super);
    function KeyIndex() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(KeyIndex, "__EMPTY_NODE", {
        get: function() {
            return $d1f87d24500ab009$var$__EMPTY_NODE;
        },
        set: function(val) {
            $d1f87d24500ab009$var$__EMPTY_NODE = val;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * @inheritDoc
     */ KeyIndex.prototype.compare = function(a, b) {
        return $d1f87d24500ab009$var$nameCompare(a.name, b.name);
    };
    /**
     * @inheritDoc
     */ KeyIndex.prototype.isDefinedOn = function(node) {
        // We could probably return true here (since every node has a key), but it's never called
        // so just leaving unimplemented for now.
        throw $01sTD.assertionError("KeyIndex.isDefinedOn not expected to be called.");
    };
    /**
     * @inheritDoc
     */ KeyIndex.prototype.indexedValueChanged = function(oldNode, newNode) {
        return false; // The key for a node never changes.
    };
    /**
     * @inheritDoc
     */ KeyIndex.prototype.minPost = function() {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return $d1f87d24500ab009$var$NamedNode.MIN;
    };
    /**
     * @inheritDoc
     */ KeyIndex.prototype.maxPost = function() {
        // TODO: This should really be created once and cached in a static property, but
        // NamedNode isn't defined yet, so I can't use it in a static.  Bleh.
        return new $d1f87d24500ab009$var$NamedNode($d1f87d24500ab009$var$MAX_NAME, $d1f87d24500ab009$var$__EMPTY_NODE);
    };
    /**
     * @param {*} indexValue
     * @param {string} name
     * @return {!NamedNode}
     */ KeyIndex.prototype.makePost = function(indexValue, name) {
        $01sTD.assert(typeof indexValue === "string", "KeyIndex indexValue must always be a string.");
        // We just use empty node, but it'll never be compared, since our comparator only looks at name.
        return new $d1f87d24500ab009$var$NamedNode(indexValue, $d1f87d24500ab009$var$__EMPTY_NODE);
    };
    /**
     * @return {!string} String representation for inclusion in a query spec
     */ KeyIndex.prototype.toString = function() {
        return ".key";
    };
    return KeyIndex;
}($d1f87d24500ab009$var$Index);
var $d1f87d24500ab009$var$KEY_INDEX = new $d1f87d24500ab009$var$KeyIndex();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $d1f87d24500ab009$var$MAX_NODE;
function $d1f87d24500ab009$var$setMaxNode(val) {
    $d1f87d24500ab009$var$MAX_NODE = val;
}
/**
 * @param {(!string|!number)} priority
 * @return {!string}
 */ var $d1f87d24500ab009$var$priorityHashText = function(priority) {
    if (typeof priority === "number") return "number:" + $d1f87d24500ab009$var$doubleToIEEE754String(priority);
    else return "string:" + priority;
};
/**
 * Validates that a priority snapshot Node is valid.
 *
 * @param {!Node} priorityNode
 */ var $d1f87d24500ab009$var$validatePriorityNode = function(priorityNode) {
    if (priorityNode.isLeafNode()) {
        var val = priorityNode.val();
        $01sTD.assert(typeof val === "string" || typeof val === "number" || typeof val === "object" && $01sTD.contains(val, ".sv"), "Priority must be a string or number.");
    } else $01sTD.assert(priorityNode === $d1f87d24500ab009$var$MAX_NODE || priorityNode.isEmpty(), "priority of unexpected type.");
    // Don't call getPriority() on MAX_NODE to avoid hitting assertion.
    $01sTD.assert(priorityNode === $d1f87d24500ab009$var$MAX_NODE || priorityNode.getPriority().isEmpty(), "Priority nodes can't have a priority of their own.");
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $d1f87d24500ab009$var$__childrenNodeConstructor;
/**
 * LeafNode is a class for storing leaf nodes in a DataSnapshot.  It
 * implements Node and stores the value of the node (a string,
 * number, or boolean) accessible via getValue().
 */ var $d1f87d24500ab009$var$LeafNode = /** @class */ function() {
    /**
     * @implements {Node}
     * @param {!(string|number|boolean|Object)} value_ The value to store in this leaf node.
     *                                         The object type is possible in the event of a deferred value
     * @param {!Node=} priorityNode_ The priority of this node.
     */ function LeafNode(value_, priorityNode_) {
        if (priorityNode_ === void 0) priorityNode_ = LeafNode.__childrenNodeConstructor.EMPTY_NODE;
        this.value_ = value_;
        this.priorityNode_ = priorityNode_;
        this.lazyHash_ = null;
        $01sTD.assert(this.value_ !== undefined && this.value_ !== null, "LeafNode shouldn't be created with null/undefined value.");
        $d1f87d24500ab009$var$validatePriorityNode(this.priorityNode_);
    }
    Object.defineProperty(LeafNode, "__childrenNodeConstructor", {
        get: function() {
            return $d1f87d24500ab009$var$__childrenNodeConstructor;
        },
        set: function(val) {
            $d1f87d24500ab009$var$__childrenNodeConstructor = val;
        },
        enumerable: false,
        configurable: true
    });
    /** @inheritDoc */ LeafNode.prototype.isLeafNode = function() {
        return true;
    };
    /** @inheritDoc */ LeafNode.prototype.getPriority = function() {
        return this.priorityNode_;
    };
    /** @inheritDoc */ LeafNode.prototype.updatePriority = function(newPriorityNode) {
        return new LeafNode(this.value_, newPriorityNode);
    };
    /** @inheritDoc */ LeafNode.prototype.getImmediateChild = function(childName) {
        // Hack to treat priority as a regular child
        if (childName === ".priority") return this.priorityNode_;
        else return LeafNode.__childrenNodeConstructor.EMPTY_NODE;
    };
    /** @inheritDoc */ LeafNode.prototype.getChild = function(path) {
        if (path.isEmpty()) return this;
        else if (path.getFront() === ".priority") return this.priorityNode_;
        else return LeafNode.__childrenNodeConstructor.EMPTY_NODE;
    };
    /**
     * @inheritDoc
     */ LeafNode.prototype.hasChild = function() {
        return false;
    };
    /** @inheritDoc */ LeafNode.prototype.getPredecessorChildName = function(childName, childNode) {
        return null;
    };
    /** @inheritDoc */ LeafNode.prototype.updateImmediateChild = function(childName, newChildNode) {
        if (childName === ".priority") return this.updatePriority(newChildNode);
        else if (newChildNode.isEmpty() && childName !== ".priority") return this;
        else return LeafNode.__childrenNodeConstructor.EMPTY_NODE.updateImmediateChild(childName, newChildNode).updatePriority(this.priorityNode_);
    };
    /** @inheritDoc */ LeafNode.prototype.updateChild = function(path, newChildNode) {
        var front = path.getFront();
        if (front === null) return newChildNode;
        else if (newChildNode.isEmpty() && front !== ".priority") return this;
        else {
            $01sTD.assert(front !== ".priority" || path.getLength() === 1, ".priority must be the last token in a path");
            return this.updateImmediateChild(front, LeafNode.__childrenNodeConstructor.EMPTY_NODE.updateChild(path.popFront(), newChildNode));
        }
    };
    /** @inheritDoc */ LeafNode.prototype.isEmpty = function() {
        return false;
    };
    /** @inheritDoc */ LeafNode.prototype.numChildren = function() {
        return 0;
    };
    /** @inheritDoc */ LeafNode.prototype.forEachChild = function(index, action) {
        return false;
    };
    /**
     * @inheritDoc
     */ LeafNode.prototype.val = function(exportFormat) {
        if (exportFormat && !this.getPriority().isEmpty()) return {
            ".value": this.getValue(),
            ".priority": this.getPriority().val()
        };
        else return this.getValue();
    };
    /** @inheritDoc */ LeafNode.prototype.hash = function() {
        if (this.lazyHash_ === null) {
            var toHash = "";
            if (!this.priorityNode_.isEmpty()) toHash += "priority:" + $d1f87d24500ab009$var$priorityHashText(this.priorityNode_.val()) + ":";
            var type = typeof this.value_;
            toHash += type + ":";
            if (type === "number") toHash += $d1f87d24500ab009$var$doubleToIEEE754String(this.value_);
            else toHash += this.value_;
            this.lazyHash_ = $d1f87d24500ab009$var$sha1(toHash);
        }
        return this.lazyHash_;
    };
    /**
     * Returns the value of the leaf node.
     * @return {Object|string|number|boolean} The value of the node.
     */ LeafNode.prototype.getValue = function() {
        return this.value_;
    };
    /**
     * @inheritDoc
     */ LeafNode.prototype.compareTo = function(other) {
        if (other === LeafNode.__childrenNodeConstructor.EMPTY_NODE) return 1;
        else if (other instanceof LeafNode.__childrenNodeConstructor) return -1;
        else {
            $01sTD.assert(other.isLeafNode(), "Unknown node type");
            return this.compareToLeafNode_(other);
        }
    };
    /**
     * Comparison specifically for two leaf nodes
     * @param {!LeafNode} otherLeaf
     * @return {!number}
     * @private
     */ LeafNode.prototype.compareToLeafNode_ = function(otherLeaf) {
        var otherLeafType = typeof otherLeaf.value_;
        var thisLeafType = typeof this.value_;
        var otherIndex = LeafNode.VALUE_TYPE_ORDER.indexOf(otherLeafType);
        var thisIndex = LeafNode.VALUE_TYPE_ORDER.indexOf(thisLeafType);
        $01sTD.assert(otherIndex >= 0, "Unknown leaf type: " + otherLeafType);
        $01sTD.assert(thisIndex >= 0, "Unknown leaf type: " + thisLeafType);
        if (otherIndex === thisIndex) {
            // Same type, compare values
            if (thisLeafType === "object") // Deferred value nodes are all equal, but we should also never get to this point...
            return 0;
            else {
                // Note that this works because true > false, all others are number or string comparisons
                if (this.value_ < otherLeaf.value_) return -1;
                else if (this.value_ === otherLeaf.value_) return 0;
                else return 1;
            }
        } else return thisIndex - otherIndex;
    };
    /**
     * @inheritDoc
     */ LeafNode.prototype.withIndex = function() {
        return this;
    };
    /**
     * @inheritDoc
     */ LeafNode.prototype.isIndexed = function() {
        return true;
    };
    /**
     * @inheritDoc
     */ LeafNode.prototype.equals = function(other) {
        /**
         * @inheritDoc
         */ if (other === this) return true;
        else if (other.isLeafNode()) {
            var otherLeaf = other;
            return this.value_ === otherLeaf.value_ && this.priorityNode_.equals(otherLeaf.priorityNode_);
        } else return false;
    };
    /**
     * The sort order for comparing leaf nodes of different types. If two leaf nodes have
     * the same type, the comparison falls back to their value
     * @type {Array.<!string>}
     * @const
     */ LeafNode.VALUE_TYPE_ORDER = [
        "object",
        "boolean",
        "number",
        "string"
    ];
    return LeafNode;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $d1f87d24500ab009$var$nodeFromJSON;
var $d1f87d24500ab009$var$MAX_NODE$1;
function $d1f87d24500ab009$var$setNodeFromJSON(val) {
    $d1f87d24500ab009$var$nodeFromJSON = val;
}
function $d1f87d24500ab009$var$setMaxNode$1(val) {
    $d1f87d24500ab009$var$MAX_NODE$1 = val;
}
/**
 * @constructor
 * @extends {Index}
 * @private
 */ var $d1f87d24500ab009$var$PriorityIndex = /** @class */ function(_super) {
    $a92b69d2447c208d$export$a8ba968b8961cb8a(PriorityIndex, _super);
    function PriorityIndex() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @inheritDoc
     */ PriorityIndex.prototype.compare = function(a, b) {
        var aPriority = a.node.getPriority();
        var bPriority = b.node.getPriority();
        var indexCmp = aPriority.compareTo(bPriority);
        if (indexCmp === 0) return $d1f87d24500ab009$var$nameCompare(a.name, b.name);
        else return indexCmp;
    };
    /**
     * @inheritDoc
     */ PriorityIndex.prototype.isDefinedOn = function(node) {
        return !node.getPriority().isEmpty();
    };
    /**
     * @inheritDoc
     */ PriorityIndex.prototype.indexedValueChanged = function(oldNode, newNode) {
        return !oldNode.getPriority().equals(newNode.getPriority());
    };
    /**
     * @inheritDoc
     */ PriorityIndex.prototype.minPost = function() {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return $d1f87d24500ab009$var$NamedNode.MIN;
    };
    /**
     * @inheritDoc
     */ PriorityIndex.prototype.maxPost = function() {
        return new $d1f87d24500ab009$var$NamedNode($d1f87d24500ab009$var$MAX_NAME, new $d1f87d24500ab009$var$LeafNode("[PRIORITY-POST]", $d1f87d24500ab009$var$MAX_NODE$1));
    };
    /**
     * @param {*} indexValue
     * @param {string} name
     * @return {!NamedNode}
     */ PriorityIndex.prototype.makePost = function(indexValue, name) {
        var priorityNode = $d1f87d24500ab009$var$nodeFromJSON(indexValue);
        return new $d1f87d24500ab009$var$NamedNode(name, new $d1f87d24500ab009$var$LeafNode("[PRIORITY-POST]", priorityNode));
    };
    /**
     * @return {!string} String representation for inclusion in a query spec
     */ PriorityIndex.prototype.toString = function() {
        return ".priority";
    };
    return PriorityIndex;
}($d1f87d24500ab009$var$Index);
var $d1f87d24500ab009$var$PRIORITY_INDEX = new $d1f87d24500ab009$var$PriorityIndex();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An iterator over an LLRBNode.
 */ var $d1f87d24500ab009$var$SortedMapIterator = /** @class */ function() {
    /**
     * @template K, V, T
     * @param {LLRBNode|LLRBEmptyNode} node Node to iterate.
     * @param {?K} startKey
     * @param {function(K, K): number} comparator
     * @param {boolean} isReverse_ Whether or not to iterate in reverse
     * @param {(function(K, V):T)=} resultGenerator_
     */ function SortedMapIterator(node, startKey, comparator, isReverse_, resultGenerator_) {
        if (resultGenerator_ === void 0) resultGenerator_ = null;
        this.isReverse_ = isReverse_;
        this.resultGenerator_ = resultGenerator_;
        /** @private
         * @type {Array.<!LLRBNode>}
         */ this.nodeStack_ = [];
        var cmp = 1;
        while(!node.isEmpty()){
            node;
            cmp = startKey ? comparator(node.key, startKey) : 1;
            // flip the comparison if we're going in reverse
            if (isReverse_) cmp *= -1;
            if (cmp < 0) {
                // This node is less than our start key. ignore it
                if (this.isReverse_) node = node.left;
                else node = node.right;
            } else if (cmp === 0) {
                // This node is exactly equal to our start key. Push it on the stack, but stop iterating;
                this.nodeStack_.push(node);
                break;
            } else {
                // This node is greater than our start key, add it to the stack and move to the next one
                this.nodeStack_.push(node);
                if (this.isReverse_) node = node.right;
                else node = node.left;
            }
        }
    }
    SortedMapIterator.prototype.getNext = function() {
        if (this.nodeStack_.length === 0) return null;
        var node = this.nodeStack_.pop();
        var result;
        if (this.resultGenerator_) result = this.resultGenerator_(node.key, node.value);
        else result = {
            key: node.key,
            value: node.value
        };
        if (this.isReverse_) {
            node = node.left;
            while(!node.isEmpty()){
                this.nodeStack_.push(node);
                node = node.right;
            }
        } else {
            node = node.right;
            while(!node.isEmpty()){
                this.nodeStack_.push(node);
                node = node.left;
            }
        }
        return result;
    };
    SortedMapIterator.prototype.hasNext = function() {
        return this.nodeStack_.length > 0;
    };
    SortedMapIterator.prototype.peek = function() {
        if (this.nodeStack_.length === 0) return null;
        var node = this.nodeStack_[this.nodeStack_.length - 1];
        if (this.resultGenerator_) return this.resultGenerator_(node.key, node.value);
        else return {
            key: node.key,
            value: node.value
        };
    };
    return SortedMapIterator;
}();
/**
 * Represents a node in a Left-leaning Red-Black tree.
 */ var $d1f87d24500ab009$var$LLRBNode = /** @class */ function() {
    /**
     * @template K, V
     * @param {!K} key Key associated with this node.
     * @param {!V} value Value associated with this node.
     * @param {?boolean} color Whether this node is red.
     * @param {?(LLRBNode|LLRBEmptyNode)=} left Left child.
     * @param {?(LLRBNode|LLRBEmptyNode)=} right Right child.
     */ function LLRBNode(key, value, color, left, right) {
        this.key = key;
        this.value = value;
        this.color = color != null ? color : LLRBNode.RED;
        this.left = left != null ? left : $d1f87d24500ab009$var$SortedMap.EMPTY_NODE;
        this.right = right != null ? right : $d1f87d24500ab009$var$SortedMap.EMPTY_NODE;
    }
    /**
     * Returns a copy of the current node, optionally replacing pieces of it.
     *
     * @param {?K} key New key for the node, or null.
     * @param {?V} value New value for the node, or null.
     * @param {?boolean} color New color for the node, or null.
     * @param {?LLRBNode|LLRBEmptyNode} left New left child for the node, or null.
     * @param {?LLRBNode|LLRBEmptyNode} right New right child for the node, or null.
     * @return {!LLRBNode} The node copy.
     */ LLRBNode.prototype.copy = function(key, value, color, left, right) {
        return new LLRBNode(key != null ? key : this.key, value != null ? value : this.value, color != null ? color : this.color, left != null ? left : this.left, right != null ? right : this.right);
    };
    /**
     * @return {number} The total number of nodes in the tree.
     */ LLRBNode.prototype.count = function() {
        return this.left.count() + 1 + this.right.count();
    };
    /**
     * @return {boolean} True if the tree is empty.
     */ LLRBNode.prototype.isEmpty = function() {
        return false;
    };
    /**
     * Traverses the tree in key order and calls the specified action function
     * for each node.
     *
     * @param {function(!K, !V):*} action Callback function to be called for each
     *   node.  If it returns true, traversal is aborted.
     * @return {*} The first truthy value returned by action, or the last falsey
     *   value returned by action
     */ LLRBNode.prototype.inorderTraversal = function(action) {
        return this.left.inorderTraversal(action) || !!action(this.key, this.value) || this.right.inorderTraversal(action);
    };
    /**
     * Traverses the tree in reverse key order and calls the specified action function
     * for each node.
     *
     * @param {function(!Object, !Object)} action Callback function to be called for each
     * node.  If it returns true, traversal is aborted.
     * @return {*} True if traversal was aborted.
     */ LLRBNode.prototype.reverseTraversal = function(action) {
        return this.right.reverseTraversal(action) || action(this.key, this.value) || this.left.reverseTraversal(action);
    };
    /**
     * @return {!Object} The minimum node in the tree.
     * @private
     */ LLRBNode.prototype.min_ = function() {
        if (this.left.isEmpty()) return this;
        else return this.left.min_();
    };
    /**
     * @return {!K} The maximum key in the tree.
     */ LLRBNode.prototype.minKey = function() {
        return this.min_().key;
    };
    /**
     * @return {!K} The maximum key in the tree.
     */ LLRBNode.prototype.maxKey = function() {
        if (this.right.isEmpty()) return this.key;
        else return this.right.maxKey();
    };
    /**
     *
     * @param {!Object} key Key to insert.
     * @param {!Object} value Value to insert.
     * @param {Comparator} comparator Comparator.
     * @return {!LLRBNode} New tree, with the key/value added.
     */ LLRBNode.prototype.insert = function(key, value, comparator) {
        var n = this;
        var cmp = comparator(key, n.key);
        if (cmp < 0) n = n.copy(null, null, null, n.left.insert(key, value, comparator), null);
        else if (cmp === 0) n = n.copy(null, value, null, null, null);
        else n = n.copy(null, null, null, null, n.right.insert(key, value, comparator));
        return n.fixUp_();
    };
    /**
     * @private
     * @return {!LLRBNode|LLRBEmptyNode} New tree, with the minimum key removed.
     */ LLRBNode.prototype.removeMin_ = function() {
        if (this.left.isEmpty()) return $d1f87d24500ab009$var$SortedMap.EMPTY_NODE;
        var n = this;
        if (!n.left.isRed_() && !n.left.left.isRed_()) n = n.moveRedLeft_();
        n = n.copy(null, null, null, n.left.removeMin_(), null);
        return n.fixUp_();
    };
    /**
     * @param {!Object} key The key of the item to remove.
     * @param {Comparator} comparator Comparator.
     * @return {!LLRBNode|LLRBEmptyNode} New tree, with the specified item removed.
     */ LLRBNode.prototype.remove = function(key, comparator) {
        var n, smallest;
        n = this;
        if (comparator(key, n.key) < 0) {
            if (!n.left.isEmpty() && !n.left.isRed_() && !n.left.left.isRed_()) n = n.moveRedLeft_();
            n = n.copy(null, null, null, n.left.remove(key, comparator), null);
        } else {
            if (n.left.isRed_()) n = n.rotateRight_();
            if (!n.right.isEmpty() && !n.right.isRed_() && !n.right.left.isRed_()) n = n.moveRedRight_();
            if (comparator(key, n.key) === 0) {
                if (n.right.isEmpty()) return $d1f87d24500ab009$var$SortedMap.EMPTY_NODE;
                else {
                    smallest = n.right.min_();
                    n = n.copy(smallest.key, smallest.value, null, null, n.right.removeMin_());
                }
            }
            n = n.copy(null, null, null, null, n.right.remove(key, comparator));
        }
        return n.fixUp_();
    };
    /**
     * @private
     * @return {boolean} Whether this is a RED node.
     */ LLRBNode.prototype.isRed_ = function() {
        return this.color;
    };
    /**
     * @private
     * @return {!LLRBNode} New tree after performing any needed rotations.
     */ LLRBNode.prototype.fixUp_ = function() {
        var n = this;
        if (n.right.isRed_() && !n.left.isRed_()) n = n.rotateLeft_();
        if (n.left.isRed_() && n.left.left.isRed_()) n = n.rotateRight_();
        if (n.left.isRed_() && n.right.isRed_()) n = n.colorFlip_();
        return n;
    };
    /**
     * @private
     * @return {!LLRBNode} New tree, after moveRedLeft.
     */ LLRBNode.prototype.moveRedLeft_ = function() {
        var n = this.colorFlip_();
        if (n.right.left.isRed_()) {
            n = n.copy(null, null, null, null, n.right.rotateRight_());
            n = n.rotateLeft_();
            n = n.colorFlip_();
        }
        return n;
    };
    /**
     * @private
     * @return {!LLRBNode} New tree, after moveRedRight.
     */ LLRBNode.prototype.moveRedRight_ = function() {
        var n = this.colorFlip_();
        if (n.left.left.isRed_()) {
            n = n.rotateRight_();
            n = n.colorFlip_();
        }
        return n;
    };
    /**
     * @private
     * @return {!LLRBNode} New tree, after rotateLeft.
     */ LLRBNode.prototype.rotateLeft_ = function() {
        var nl = this.copy(null, null, LLRBNode.RED, null, this.right.left);
        return this.right.copy(null, null, this.color, nl, null);
    };
    /**
     * @private
     * @return {!LLRBNode} New tree, after rotateRight.
     */ LLRBNode.prototype.rotateRight_ = function() {
        var nr = this.copy(null, null, LLRBNode.RED, this.left.right, null);
        return this.left.copy(null, null, this.color, null, nr);
    };
    /**
     * @private
     * @return {!LLRBNode} New tree, after colorFlip.
     */ LLRBNode.prototype.colorFlip_ = function() {
        var left = this.left.copy(null, null, !this.left.color, null, null);
        var right = this.right.copy(null, null, !this.right.color, null, null);
        return this.copy(null, null, !this.color, left, right);
    };
    /**
     * For testing.
     *
     * @private
     * @return {boolean} True if all is well.
     */ LLRBNode.prototype.checkMaxDepth_ = function() {
        var blackDepth = this.check_();
        return Math.pow(2.0, blackDepth) <= this.count() + 1;
    };
    /**
     * @private
     * @return {number} Not sure what this returns exactly. :-).
     */ LLRBNode.prototype.check_ = function() {
        if (this.isRed_() && this.left.isRed_()) throw new Error("Red node has red child(" + this.key + "," + this.value + ")");
        if (this.right.isRed_()) throw new Error("Right child of (" + this.key + "," + this.value + ") is red");
        var blackDepth = this.left.check_();
        if (blackDepth !== this.right.check_()) throw new Error("Black depths differ");
        else return blackDepth + (this.isRed_() ? 0 : 1);
    };
    LLRBNode.RED = true;
    LLRBNode.BLACK = false;
    return LLRBNode;
}();
/**
 * Represents an empty node (a leaf node in the Red-Black Tree).
 */ var $d1f87d24500ab009$var$LLRBEmptyNode = /** @class */ function() {
    function LLRBEmptyNode() {}
    /**
     * Returns a copy of the current node.
     *
     * @return {!LLRBEmptyNode} The node copy.
     */ LLRBEmptyNode.prototype.copy = function(key, value, color, left, right) {
        return this;
    };
    /**
     * Returns a copy of the tree, with the specified key/value added.
     *
     * @param {!K} key Key to be added.
     * @param {!V} value Value to be added.
     * @param {Comparator} comparator Comparator.
     * @return {!LLRBNode} New tree, with item added.
     */ LLRBEmptyNode.prototype.insert = function(key, value, comparator) {
        return new $d1f87d24500ab009$var$LLRBNode(key, value, null);
    };
    /**
     * Returns a copy of the tree, with the specified key removed.
     *
     * @param {!K} key The key to remove.
     * @param {Comparator} comparator Comparator.
     * @return {!LLRBEmptyNode} New tree, with item removed.
     */ LLRBEmptyNode.prototype.remove = function(key, comparator) {
        return this;
    };
    /**
     * @return {number} The total number of nodes in the tree.
     */ LLRBEmptyNode.prototype.count = function() {
        return 0;
    };
    /**
     * @return {boolean} True if the tree is empty.
     */ LLRBEmptyNode.prototype.isEmpty = function() {
        return true;
    };
    /**
     * Traverses the tree in key order and calls the specified action function
     * for each node.
     *
     * @param {function(!K, !V):*} action Callback function to be called for each
     * node.  If it returns true, traversal is aborted.
     * @return {boolean} True if traversal was aborted.
     */ LLRBEmptyNode.prototype.inorderTraversal = function(action) {
        return false;
    };
    /**
     * Traverses the tree in reverse key order and calls the specified action function
     * for each node.
     *
     * @param {function(!K, !V)} action Callback function to be called for each
     * node.  If it returns true, traversal is aborted.
     * @return {boolean} True if traversal was aborted.
     */ LLRBEmptyNode.prototype.reverseTraversal = function(action) {
        return false;
    };
    /**
     * @return {null}
     */ LLRBEmptyNode.prototype.minKey = function() {
        return null;
    };
    /**
     * @return {null}
     */ LLRBEmptyNode.prototype.maxKey = function() {
        return null;
    };
    /**
     * @private
     * @return {number} Not sure what this returns exactly. :-).
     */ LLRBEmptyNode.prototype.check_ = function() {
        return 0;
    };
    /**
     * @private
     * @return {boolean} Whether this node is red.
     */ LLRBEmptyNode.prototype.isRed_ = function() {
        return false;
    };
    return LLRBEmptyNode;
}();
/**
 * An immutable sorted map implementation, based on a Left-leaning Red-Black
 * tree.
 */ var $d1f87d24500ab009$var$SortedMap = /** @class */ function() {
    /**
     * @template K, V
     * @param {function(K, K):number} comparator_ Key comparator.
     * @param {LLRBNode=} root_ (Optional) Root node for the map.
     */ function SortedMap(comparator_, root_) {
        if (root_ === void 0) root_ = SortedMap.EMPTY_NODE;
        this.comparator_ = comparator_;
        this.root_ = root_;
    }
    /**
     * Returns a copy of the map, with the specified key/value added or replaced.
     * (TODO: We should perhaps rename this method to 'put')
     *
     * @param {!K} key Key to be added.
     * @param {!V} value Value to be added.
     * @return {!SortedMap.<K, V>} New map, with item added.
     */ SortedMap.prototype.insert = function(key, value) {
        return new SortedMap(this.comparator_, this.root_.insert(key, value, this.comparator_).copy(null, null, $d1f87d24500ab009$var$LLRBNode.BLACK, null, null));
    };
    /**
     * Returns a copy of the map, with the specified key removed.
     *
     * @param {!K} key The key to remove.
     * @return {!SortedMap.<K, V>} New map, with item removed.
     */ SortedMap.prototype.remove = function(key) {
        return new SortedMap(this.comparator_, this.root_.remove(key, this.comparator_).copy(null, null, $d1f87d24500ab009$var$LLRBNode.BLACK, null, null));
    };
    /**
     * Returns the value of the node with the given key, or null.
     *
     * @param {!K} key The key to look up.
     * @return {?V} The value of the node with the given key, or null if the
     * key doesn't exist.
     */ SortedMap.prototype.get = function(key) {
        var cmp;
        var node = this.root_;
        while(!node.isEmpty()){
            cmp = this.comparator_(key, node.key);
            if (cmp === 0) return node.value;
            else if (cmp < 0) node = node.left;
            else if (cmp > 0) node = node.right;
        }
        return null;
    };
    /**
     * Returns the key of the item *before* the specified key, or null if key is the first item.
     * @param {K} key The key to find the predecessor of
     * @return {?K} The predecessor key.
     */ SortedMap.prototype.getPredecessorKey = function(key) {
        var cmp, node = this.root_, rightParent = null;
        while(!node.isEmpty()){
            cmp = this.comparator_(key, node.key);
            if (cmp === 0) {
                if (!node.left.isEmpty()) {
                    node = node.left;
                    while(!node.right.isEmpty())node = node.right;
                    return node.key;
                } else if (rightParent) return rightParent.key;
                else return null; // first item.
            } else if (cmp < 0) node = node.left;
            else if (cmp > 0) {
                rightParent = node;
                node = node.right;
            }
        }
        throw new Error("Attempted to find predecessor key for a nonexistent key.  What gives?");
    };
    /**
     * @return {boolean} True if the map is empty.
     */ SortedMap.prototype.isEmpty = function() {
        return this.root_.isEmpty();
    };
    /**
     * @return {number} The total number of nodes in the map.
     */ SortedMap.prototype.count = function() {
        return this.root_.count();
    };
    /**
     * @return {?K} The minimum key in the map.
     */ SortedMap.prototype.minKey = function() {
        return this.root_.minKey();
    };
    /**
     * @return {?K} The maximum key in the map.
     */ SortedMap.prototype.maxKey = function() {
        return this.root_.maxKey();
    };
    /**
     * Traverses the map in key order and calls the specified action function
     * for each key/value pair.
     *
     * @param {function(!K, !V):*} action Callback function to be called
     * for each key/value pair.  If action returns true, traversal is aborted.
     * @return {*} The first truthy value returned by action, or the last falsey
     *   value returned by action
     */ SortedMap.prototype.inorderTraversal = function(action) {
        return this.root_.inorderTraversal(action);
    };
    /**
     * Traverses the map in reverse key order and calls the specified action function
     * for each key/value pair.
     *
     * @param {function(!Object, !Object)} action Callback function to be called
     * for each key/value pair.  If action returns true, traversal is aborted.
     * @return {*} True if the traversal was aborted.
     */ SortedMap.prototype.reverseTraversal = function(action) {
        return this.root_.reverseTraversal(action);
    };
    /**
     * Returns an iterator over the SortedMap.
     * @template T
     * @param {(function(K, V):T)=} resultGenerator
     * @return {SortedMapIterator.<K, V, T>} The iterator.
     */ SortedMap.prototype.getIterator = function(resultGenerator) {
        return new $d1f87d24500ab009$var$SortedMapIterator(this.root_, null, this.comparator_, false, resultGenerator);
    };
    SortedMap.prototype.getIteratorFrom = function(key, resultGenerator) {
        return new $d1f87d24500ab009$var$SortedMapIterator(this.root_, key, this.comparator_, false, resultGenerator);
    };
    SortedMap.prototype.getReverseIteratorFrom = function(key, resultGenerator) {
        return new $d1f87d24500ab009$var$SortedMapIterator(this.root_, key, this.comparator_, true, resultGenerator);
    };
    SortedMap.prototype.getReverseIterator = function(resultGenerator) {
        return new $d1f87d24500ab009$var$SortedMapIterator(this.root_, null, this.comparator_, true, resultGenerator);
    };
    /**
     * Always use the same empty node, to reduce memory.
     * @const
     */ SortedMap.EMPTY_NODE = new $d1f87d24500ab009$var$LLRBEmptyNode();
    return SortedMap;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $d1f87d24500ab009$var$LOG_2 = Math.log(2);
/**
 * @constructor
 */ var $d1f87d24500ab009$var$Base12Num = /** @class */ function() {
    /**
     * @param {number} length
     */ function Base12Num(length) {
        var logBase2 = function(num) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return parseInt(Math.log(num) / $d1f87d24500ab009$var$LOG_2, 10);
        };
        var bitMask = function(bits) {
            return parseInt(Array(bits + 1).join("1"), 2);
        };
        this.count = logBase2(length + 1);
        this.current_ = this.count - 1;
        var mask = bitMask(this.count);
        this.bits_ = length + 1 & mask;
    }
    /**
     * @return {boolean}
     */ Base12Num.prototype.nextBitIsOne = function() {
        //noinspection JSBitwiseOperatorUsage
        var result = !(this.bits_ & 0x1 << this.current_);
        this.current_--;
        return result;
    };
    return Base12Num;
}();
/**
 * Takes a list of child nodes and constructs a SortedSet using the given comparison
 * function
 *
 * Uses the algorithm described in the paper linked here:
 * http://citeseerx.ist.psu.edu/viewdoc/summary?doi=10.1.1.46.1458
 *
 * @template K, V
 * @param {Array.<!NamedNode>} childList Unsorted list of children
 * @param {function(!NamedNode, !NamedNode):number} cmp The comparison method to be used
 * @param {(function(NamedNode):K)=} keyFn An optional function to extract K from a node wrapper, if K's
 *                                                        type is not NamedNode
 * @param {(function(K, K):number)=} mapSortFn An optional override for comparator used by the generated sorted map
 * @return {SortedMap.<K, V>}
 */ var $d1f87d24500ab009$var$buildChildSet = function(childList, cmp, keyFn, mapSortFn) {
    childList.sort(cmp);
    var buildBalancedTree = function(low, high) {
        var length = high - low;
        var namedNode;
        var key;
        if (length === 0) return null;
        else if (length === 1) {
            namedNode = childList[low];
            key = keyFn ? keyFn(namedNode) : namedNode;
            return new $d1f87d24500ab009$var$LLRBNode(key, namedNode.node, $d1f87d24500ab009$var$LLRBNode.BLACK, null, null);
        } else {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var middle = parseInt(length / 2, 10) + low;
            var left = buildBalancedTree(low, middle);
            var right = buildBalancedTree(middle + 1, high);
            namedNode = childList[middle];
            key = keyFn ? keyFn(namedNode) : namedNode;
            return new $d1f87d24500ab009$var$LLRBNode(key, namedNode.node, $d1f87d24500ab009$var$LLRBNode.BLACK, left, right);
        }
    };
    var buildFrom12Array = function(base12) {
        var node = null;
        var root = null;
        var index = childList.length;
        var buildPennant = function(chunkSize, color) {
            var low = index - chunkSize;
            var high = index;
            index -= chunkSize;
            var childTree = buildBalancedTree(low + 1, high);
            var namedNode = childList[low];
            var key = keyFn ? keyFn(namedNode) : namedNode;
            attachPennant(new $d1f87d24500ab009$var$LLRBNode(key, namedNode.node, color, null, childTree));
        };
        var attachPennant = function(pennant) {
            if (node) {
                node.left = pennant;
                node = pennant;
            } else {
                root = pennant;
                node = pennant;
            }
        };
        for(var i = 0; i < base12.count; ++i){
            var isOne = base12.nextBitIsOne();
            // The number of nodes taken in each slice is 2^(arr.length - (i + 1))
            var chunkSize = Math.pow(2, base12.count - (i + 1));
            if (isOne) buildPennant(chunkSize, $d1f87d24500ab009$var$LLRBNode.BLACK);
            else {
                // current == 2
                buildPennant(chunkSize, $d1f87d24500ab009$var$LLRBNode.BLACK);
                buildPennant(chunkSize, $d1f87d24500ab009$var$LLRBNode.RED);
            }
        }
        return root;
    };
    var base12 = new $d1f87d24500ab009$var$Base12Num(childList.length);
    var root = buildFrom12Array(base12);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return new $d1f87d24500ab009$var$SortedMap(mapSortFn || cmp, root);
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $d1f87d24500ab009$var$_defaultIndexMap;
var $d1f87d24500ab009$var$fallbackObject = {};
var $d1f87d24500ab009$var$IndexMap = /** @class */ function() {
    function IndexMap(indexes_, indexSet_) {
        this.indexes_ = indexes_;
        this.indexSet_ = indexSet_;
    }
    Object.defineProperty(IndexMap, "Default", {
        /**
         * The default IndexMap for nodes without a priority
         */ get: function() {
            $01sTD.assert($d1f87d24500ab009$var$fallbackObject && $d1f87d24500ab009$var$PRIORITY_INDEX, "ChildrenNode.ts has not been loaded");
            $d1f87d24500ab009$var$_defaultIndexMap = $d1f87d24500ab009$var$_defaultIndexMap || new IndexMap({
                ".priority": $d1f87d24500ab009$var$fallbackObject
            }, {
                ".priority": $d1f87d24500ab009$var$PRIORITY_INDEX
            });
            return $d1f87d24500ab009$var$_defaultIndexMap;
        },
        enumerable: false,
        configurable: true
    });
    IndexMap.prototype.get = function(indexKey) {
        var sortedMap = $01sTD.safeGet(this.indexes_, indexKey);
        if (!sortedMap) throw new Error("No index defined for " + indexKey);
        if (sortedMap instanceof $d1f87d24500ab009$var$SortedMap) return sortedMap;
        else // The index exists, but it falls back to just name comparison. Return null so that the calling code uses the
        // regular child map
        return null;
    };
    IndexMap.prototype.hasIndex = function(indexDefinition) {
        return $01sTD.contains(this.indexSet_, indexDefinition.toString());
    };
    IndexMap.prototype.addIndex = function(indexDefinition, existingChildren) {
        $01sTD.assert(indexDefinition !== $d1f87d24500ab009$var$KEY_INDEX, "KeyIndex always exists and isn't meant to be added to the IndexMap.");
        var childList = [];
        var sawIndexedValue = false;
        var iter = existingChildren.getIterator($d1f87d24500ab009$var$NamedNode.Wrap);
        var next = iter.getNext();
        while(next){
            sawIndexedValue = sawIndexedValue || indexDefinition.isDefinedOn(next.node);
            childList.push(next);
            next = iter.getNext();
        }
        var newIndex;
        if (sawIndexedValue) newIndex = $d1f87d24500ab009$var$buildChildSet(childList, indexDefinition.getCompare());
        else newIndex = $d1f87d24500ab009$var$fallbackObject;
        var indexName = indexDefinition.toString();
        var newIndexSet = $a92b69d2447c208d$export$18ce0697a983be9b({}, this.indexSet_);
        newIndexSet[indexName] = indexDefinition;
        var newIndexes = $a92b69d2447c208d$export$18ce0697a983be9b({}, this.indexes_);
        newIndexes[indexName] = newIndex;
        return new IndexMap(newIndexes, newIndexSet);
    };
    /**
     * Ensure that this node is properly tracked in any indexes that we're maintaining
     */ IndexMap.prototype.addToIndexes = function(namedNode, existingChildren) {
        var _this = this;
        var newIndexes = $01sTD.map(this.indexes_, function(indexedChildren, indexName) {
            var index = $01sTD.safeGet(_this.indexSet_, indexName);
            $01sTD.assert(index, "Missing index implementation for " + indexName);
            if (indexedChildren === $d1f87d24500ab009$var$fallbackObject) {
                // Check to see if we need to index everything
                if (index.isDefinedOn(namedNode.node)) {
                    // We need to build this index
                    var childList = [];
                    var iter = existingChildren.getIterator($d1f87d24500ab009$var$NamedNode.Wrap);
                    var next = iter.getNext();
                    while(next){
                        if (next.name !== namedNode.name) childList.push(next);
                        next = iter.getNext();
                    }
                    childList.push(namedNode);
                    return $d1f87d24500ab009$var$buildChildSet(childList, index.getCompare());
                } else // No change, this remains a fallback
                return $d1f87d24500ab009$var$fallbackObject;
            } else {
                var existingSnap = existingChildren.get(namedNode.name);
                var newChildren = indexedChildren;
                if (existingSnap) newChildren = newChildren.remove(new $d1f87d24500ab009$var$NamedNode(namedNode.name, existingSnap));
                return newChildren.insert(namedNode, namedNode.node);
            }
        });
        return new IndexMap(newIndexes, this.indexSet_);
    };
    /**
     * Create a new IndexMap instance with the given value removed
     */ IndexMap.prototype.removeFromIndexes = function(namedNode, existingChildren) {
        var newIndexes = $01sTD.map(this.indexes_, function(indexedChildren) {
            if (indexedChildren === $d1f87d24500ab009$var$fallbackObject) // This is the fallback. Just return it, nothing to do in this case
            return indexedChildren;
            else {
                var existingSnap = existingChildren.get(namedNode.name);
                if (existingSnap) return indexedChildren.remove(new $d1f87d24500ab009$var$NamedNode(namedNode.name, existingSnap));
                else // No record of this child
                return indexedChildren;
            }
        });
        return new IndexMap(newIndexes, this.indexSet_);
    };
    return IndexMap;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $d1f87d24500ab009$var$NAME_ONLY_COMPARATOR(left, right) {
    return $d1f87d24500ab009$var$nameCompare(left.name, right.name);
}
function $d1f87d24500ab009$var$NAME_COMPARATOR(left, right) {
    return $d1f87d24500ab009$var$nameCompare(left, right);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // TODO: For memory savings, don't store priorityNode_ if it's empty.
var $d1f87d24500ab009$var$EMPTY_NODE;
/**
 * ChildrenNode is a class for storing internal nodes in a DataSnapshot
 * (i.e. nodes with children).  It implements Node and stores the
 * list of children in the children property, sorted by child name.
 *
 * @constructor
 * @implements {Node}
 */ var $d1f87d24500ab009$var$ChildrenNode = /** @class */ function() {
    /**
     *
     * @param {!SortedMap.<string, !Node>} children_ List of children
     * of this node..
     * @param {?Node} priorityNode_ The priority of this node (as a snapshot node).
     * @param {!IndexMap} indexMap_
     */ function ChildrenNode(children_, priorityNode_, indexMap_) {
        this.children_ = children_;
        this.priorityNode_ = priorityNode_;
        this.indexMap_ = indexMap_;
        this.lazyHash_ = null;
        /**
         * Note: The only reason we allow null priority is for EMPTY_NODE, since we can't use
         * EMPTY_NODE as the priority of EMPTY_NODE.  We might want to consider making EMPTY_NODE its own
         * class instead of an empty ChildrenNode.
         */ if (this.priorityNode_) $d1f87d24500ab009$var$validatePriorityNode(this.priorityNode_);
        if (this.children_.isEmpty()) $01sTD.assert(!this.priorityNode_ || this.priorityNode_.isEmpty(), "An empty node cannot have a priority");
    }
    Object.defineProperty(ChildrenNode, "EMPTY_NODE", {
        get: function() {
            return $d1f87d24500ab009$var$EMPTY_NODE || ($d1f87d24500ab009$var$EMPTY_NODE = new ChildrenNode(new $d1f87d24500ab009$var$SortedMap($d1f87d24500ab009$var$NAME_COMPARATOR), null, $d1f87d24500ab009$var$IndexMap.Default));
        },
        enumerable: false,
        configurable: true
    });
    /** @inheritDoc */ ChildrenNode.prototype.isLeafNode = function() {
        return false;
    };
    /** @inheritDoc */ ChildrenNode.prototype.getPriority = function() {
        return this.priorityNode_ || $d1f87d24500ab009$var$EMPTY_NODE;
    };
    /** @inheritDoc */ ChildrenNode.prototype.updatePriority = function(newPriorityNode) {
        if (this.children_.isEmpty()) // Don't allow priorities on empty nodes
        return this;
        else return new ChildrenNode(this.children_, newPriorityNode, this.indexMap_);
    };
    /** @inheritDoc */ ChildrenNode.prototype.getImmediateChild = function(childName) {
        // Hack to treat priority as a regular child
        if (childName === ".priority") return this.getPriority();
        else {
            var child = this.children_.get(childName);
            return child === null ? $d1f87d24500ab009$var$EMPTY_NODE : child;
        }
    };
    /** @inheritDoc */ ChildrenNode.prototype.getChild = function(path) {
        var front = path.getFront();
        if (front === null) return this;
        return this.getImmediateChild(front).getChild(path.popFront());
    };
    /** @inheritDoc */ ChildrenNode.prototype.hasChild = function(childName) {
        return this.children_.get(childName) !== null;
    };
    /** @inheritDoc */ ChildrenNode.prototype.updateImmediateChild = function(childName, newChildNode) {
        $01sTD.assert(newChildNode, "We should always be passing snapshot nodes");
        if (childName === ".priority") return this.updatePriority(newChildNode);
        else {
            var namedNode = new $d1f87d24500ab009$var$NamedNode(childName, newChildNode);
            var newChildren = void 0, newIndexMap = void 0;
            if (newChildNode.isEmpty()) {
                newChildren = this.children_.remove(childName);
                newIndexMap = this.indexMap_.removeFromIndexes(namedNode, this.children_);
            } else {
                newChildren = this.children_.insert(childName, newChildNode);
                newIndexMap = this.indexMap_.addToIndexes(namedNode, this.children_);
            }
            var newPriority = newChildren.isEmpty() ? $d1f87d24500ab009$var$EMPTY_NODE : this.priorityNode_;
            return new ChildrenNode(newChildren, newPriority, newIndexMap);
        }
    };
    /** @inheritDoc */ ChildrenNode.prototype.updateChild = function(path, newChildNode) {
        var front = path.getFront();
        if (front === null) return newChildNode;
        else {
            $01sTD.assert(path.getFront() !== ".priority" || path.getLength() === 1, ".priority must be the last token in a path");
            var newImmediateChild = this.getImmediateChild(front).updateChild(path.popFront(), newChildNode);
            return this.updateImmediateChild(front, newImmediateChild);
        }
    };
    /** @inheritDoc */ ChildrenNode.prototype.isEmpty = function() {
        return this.children_.isEmpty();
    };
    /** @inheritDoc */ ChildrenNode.prototype.numChildren = function() {
        return this.children_.count();
    };
    /** @inheritDoc */ ChildrenNode.prototype.val = function(exportFormat) {
        if (this.isEmpty()) return null;
        var obj = {};
        var numKeys = 0, maxKey = 0, allIntegerKeys = true;
        this.forEachChild($d1f87d24500ab009$var$PRIORITY_INDEX, function(key, childNode) {
            obj[key] = childNode.val(exportFormat);
            numKeys++;
            if (allIntegerKeys && ChildrenNode.INTEGER_REGEXP_.test(key)) maxKey = Math.max(maxKey, Number(key));
            else allIntegerKeys = false;
        });
        if (!exportFormat && allIntegerKeys && maxKey < 2 * numKeys) {
            // convert to array.
            var array = [];
            // eslint-disable-next-line guard-for-in
            for(var key in obj)array[key] = obj[key];
            return array;
        } else {
            if (exportFormat && !this.getPriority().isEmpty()) obj[".priority"] = this.getPriority().val();
            return obj;
        }
    };
    /** @inheritDoc */ ChildrenNode.prototype.hash = function() {
        if (this.lazyHash_ === null) {
            var toHash_1 = "";
            if (!this.getPriority().isEmpty()) toHash_1 += "priority:" + $d1f87d24500ab009$var$priorityHashText(this.getPriority().val()) + ":";
            this.forEachChild($d1f87d24500ab009$var$PRIORITY_INDEX, function(key, childNode) {
                var childHash = childNode.hash();
                if (childHash !== "") toHash_1 += ":" + key + ":" + childHash;
            });
            this.lazyHash_ = toHash_1 === "" ? "" : $d1f87d24500ab009$var$sha1(toHash_1);
        }
        return this.lazyHash_;
    };
    /** @inheritDoc */ ChildrenNode.prototype.getPredecessorChildName = function(childName, childNode, index) {
        var idx = this.resolveIndex_(index);
        if (idx) {
            var predecessor = idx.getPredecessorKey(new $d1f87d24500ab009$var$NamedNode(childName, childNode));
            return predecessor ? predecessor.name : null;
        } else return this.children_.getPredecessorKey(childName);
    };
    /**
     * @param {!Index} indexDefinition
     * @return {?string}
     */ ChildrenNode.prototype.getFirstChildName = function(indexDefinition) {
        var idx = this.resolveIndex_(indexDefinition);
        if (idx) {
            var minKey = idx.minKey();
            return minKey && minKey.name;
        } else return this.children_.minKey();
    };
    /**
     * @param {!Index} indexDefinition
     * @return {?NamedNode}
     */ ChildrenNode.prototype.getFirstChild = function(indexDefinition) {
        var minKey = this.getFirstChildName(indexDefinition);
        if (minKey) return new $d1f87d24500ab009$var$NamedNode(minKey, this.children_.get(minKey));
        else return null;
    };
    /**
     * Given an index, return the key name of the largest value we have, according to that index
     * @param {!Index} indexDefinition
     * @return {?string}
     */ ChildrenNode.prototype.getLastChildName = function(indexDefinition) {
        var idx = this.resolveIndex_(indexDefinition);
        if (idx) {
            var maxKey = idx.maxKey();
            return maxKey && maxKey.name;
        } else return this.children_.maxKey();
    };
    /**
     * @param {!Index} indexDefinition
     * @return {?NamedNode}
     */ ChildrenNode.prototype.getLastChild = function(indexDefinition) {
        var maxKey = this.getLastChildName(indexDefinition);
        if (maxKey) return new $d1f87d24500ab009$var$NamedNode(maxKey, this.children_.get(maxKey));
        else return null;
    };
    /**
     * @inheritDoc
     */ ChildrenNode.prototype.forEachChild = function(index, action) {
        var idx = this.resolveIndex_(index);
        if (idx) return idx.inorderTraversal(function(wrappedNode) {
            return action(wrappedNode.name, wrappedNode.node);
        });
        else return this.children_.inorderTraversal(action);
    };
    /**
     * @param {!Index} indexDefinition
     * @return {SortedMapIterator}
     */ ChildrenNode.prototype.getIterator = function(indexDefinition) {
        return this.getIteratorFrom(indexDefinition.minPost(), indexDefinition);
    };
    /**
     *
     * @param {!NamedNode} startPost
     * @param {!Index} indexDefinition
     * @return {!SortedMapIterator}
     */ ChildrenNode.prototype.getIteratorFrom = function(startPost, indexDefinition) {
        var idx = this.resolveIndex_(indexDefinition);
        if (idx) return idx.getIteratorFrom(startPost, function(key) {
            return key;
        });
        else {
            var iterator = this.children_.getIteratorFrom(startPost.name, $d1f87d24500ab009$var$NamedNode.Wrap);
            var next = iterator.peek();
            while(next != null && indexDefinition.compare(next, startPost) < 0){
                iterator.getNext();
                next = iterator.peek();
            }
            return iterator;
        }
    };
    /**
     * @param {!Index} indexDefinition
     * @return {!SortedMapIterator}
     */ ChildrenNode.prototype.getReverseIterator = function(indexDefinition) {
        return this.getReverseIteratorFrom(indexDefinition.maxPost(), indexDefinition);
    };
    /**
     * @param {!NamedNode} endPost
     * @param {!Index} indexDefinition
     * @return {!SortedMapIterator}
     */ ChildrenNode.prototype.getReverseIteratorFrom = function(endPost, indexDefinition) {
        var idx = this.resolveIndex_(indexDefinition);
        if (idx) return idx.getReverseIteratorFrom(endPost, function(key) {
            return key;
        });
        else {
            var iterator = this.children_.getReverseIteratorFrom(endPost.name, $d1f87d24500ab009$var$NamedNode.Wrap);
            var next = iterator.peek();
            while(next != null && indexDefinition.compare(next, endPost) > 0){
                iterator.getNext();
                next = iterator.peek();
            }
            return iterator;
        }
    };
    /**
     * @inheritDoc
     */ ChildrenNode.prototype.compareTo = function(other) {
        if (this.isEmpty()) {
            if (other.isEmpty()) return 0;
            else return -1;
        } else if (other.isLeafNode() || other.isEmpty()) return 1;
        else if (other === $d1f87d24500ab009$var$MAX_NODE$2) return -1;
        else // Must be another node with children.
        return 0;
    };
    /**
     * @inheritDoc
     */ ChildrenNode.prototype.withIndex = function(indexDefinition) {
        if (indexDefinition === $d1f87d24500ab009$var$KEY_INDEX || this.indexMap_.hasIndex(indexDefinition)) return this;
        else {
            var newIndexMap = this.indexMap_.addIndex(indexDefinition, this.children_);
            return new ChildrenNode(this.children_, this.priorityNode_, newIndexMap);
        }
    };
    /**
     * @inheritDoc
     */ ChildrenNode.prototype.isIndexed = function(index) {
        return index === $d1f87d24500ab009$var$KEY_INDEX || this.indexMap_.hasIndex(index);
    };
    /**
     * @inheritDoc
     */ ChildrenNode.prototype.equals = function(other) {
        if (other === this) return true;
        else if (other.isLeafNode()) return false;
        else {
            var otherChildrenNode = other;
            if (!this.getPriority().equals(otherChildrenNode.getPriority())) return false;
            else if (this.children_.count() === otherChildrenNode.children_.count()) {
                var thisIter = this.getIterator($d1f87d24500ab009$var$PRIORITY_INDEX);
                var otherIter = otherChildrenNode.getIterator($d1f87d24500ab009$var$PRIORITY_INDEX);
                var thisCurrent = thisIter.getNext();
                var otherCurrent = otherIter.getNext();
                while(thisCurrent && otherCurrent){
                    if (thisCurrent.name !== otherCurrent.name || !thisCurrent.node.equals(otherCurrent.node)) return false;
                    thisCurrent = thisIter.getNext();
                    otherCurrent = otherIter.getNext();
                }
                return thisCurrent === null && otherCurrent === null;
            } else return false;
        }
    };
    /**
     * Returns a SortedMap ordered by index, or null if the default (by-key) ordering can be used
     * instead.
     *
     * @private
     * @param {!Index} indexDefinition
     * @return {?SortedMap.<NamedNode, Node>}
     */ ChildrenNode.prototype.resolveIndex_ = function(indexDefinition) {
        if (indexDefinition === $d1f87d24500ab009$var$KEY_INDEX) return null;
        else return this.indexMap_.get(indexDefinition.toString());
    };
    /**
     * @private
     * @type {RegExp}
     */ ChildrenNode.INTEGER_REGEXP_ = /^(0|[1-9]\d*)$/;
    return ChildrenNode;
}();
/**
 * @constructor
 * @extends {ChildrenNode}
 * @private
 */ var $d1f87d24500ab009$var$MaxNode = /** @class */ function(_super) {
    $a92b69d2447c208d$export$a8ba968b8961cb8a(MaxNode, _super);
    function MaxNode() {
        return _super.call(this, new $d1f87d24500ab009$var$SortedMap($d1f87d24500ab009$var$NAME_COMPARATOR), $d1f87d24500ab009$var$ChildrenNode.EMPTY_NODE, $d1f87d24500ab009$var$IndexMap.Default) || this;
    }
    MaxNode.prototype.compareTo = function(other) {
        if (other === this) return 0;
        else return 1;
    };
    MaxNode.prototype.equals = function(other) {
        // Not that we every compare it, but MAX_NODE is only ever equal to itself
        return other === this;
    };
    MaxNode.prototype.getPriority = function() {
        return this;
    };
    MaxNode.prototype.getImmediateChild = function(childName) {
        return $d1f87d24500ab009$var$ChildrenNode.EMPTY_NODE;
    };
    MaxNode.prototype.isEmpty = function() {
        return false;
    };
    return MaxNode;
}($d1f87d24500ab009$var$ChildrenNode);
/**
 * Marker that will sort higher than any other snapshot.
 * @type {!MAX_NODE}
 * @const
 */ var $d1f87d24500ab009$var$MAX_NODE$2 = new $d1f87d24500ab009$var$MaxNode();
Object.defineProperties($d1f87d24500ab009$var$NamedNode, {
    MIN: {
        value: new $d1f87d24500ab009$var$NamedNode($d1f87d24500ab009$var$MIN_NAME, $d1f87d24500ab009$var$ChildrenNode.EMPTY_NODE)
    },
    MAX: {
        value: new $d1f87d24500ab009$var$NamedNode($d1f87d24500ab009$var$MAX_NAME, $d1f87d24500ab009$var$MAX_NODE$2)
    }
});
/**
 * Reference Extensions
 */ $d1f87d24500ab009$var$KeyIndex.__EMPTY_NODE = $d1f87d24500ab009$var$ChildrenNode.EMPTY_NODE;
$d1f87d24500ab009$var$LeafNode.__childrenNodeConstructor = $d1f87d24500ab009$var$ChildrenNode;
$d1f87d24500ab009$var$setMaxNode($d1f87d24500ab009$var$MAX_NODE$2);
$d1f87d24500ab009$var$setMaxNode$1($d1f87d24500ab009$var$MAX_NODE$2);
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $d1f87d24500ab009$var$USE_HINZE = true;
/**
 * Constructs a snapshot node representing the passed JSON and returns it.
 * @param {*} json JSON to create a node for.
 * @param {?string|?number=} priority Optional priority to use.  This will be ignored if the
 * passed JSON contains a .priority property.
 * @return {!Node}
 */ function $d1f87d24500ab009$var$nodeFromJSON$1(json, priority) {
    if (priority === void 0) priority = null;
    if (json === null) return $d1f87d24500ab009$var$ChildrenNode.EMPTY_NODE;
    if (typeof json === "object" && ".priority" in json) priority = json[".priority"];
    $01sTD.assert(priority === null || typeof priority === "string" || typeof priority === "number" || typeof priority === "object" && ".sv" in priority, "Invalid priority type found: " + typeof priority);
    if (typeof json === "object" && ".value" in json && json[".value"] !== null) json = json[".value"];
    // Valid leaf nodes include non-objects or server-value wrapper objects
    if (typeof json !== "object" || ".sv" in json) {
        var jsonLeaf = json;
        return new $d1f87d24500ab009$var$LeafNode(jsonLeaf, $d1f87d24500ab009$var$nodeFromJSON$1(priority));
    }
    if (!(json instanceof Array) && $d1f87d24500ab009$var$USE_HINZE) {
        var children_1 = [];
        var childrenHavePriority_1 = false;
        var hinzeJsonObj = json;
        $d1f87d24500ab009$var$each(hinzeJsonObj, function(key, child) {
            if (key.substring(0, 1) !== ".") {
                // Ignore metadata nodes
                var childNode = $d1f87d24500ab009$var$nodeFromJSON$1(child);
                if (!childNode.isEmpty()) {
                    childrenHavePriority_1 = childrenHavePriority_1 || !childNode.getPriority().isEmpty();
                    children_1.push(new $d1f87d24500ab009$var$NamedNode(key, childNode));
                }
            }
        });
        if (children_1.length === 0) return $d1f87d24500ab009$var$ChildrenNode.EMPTY_NODE;
        var childSet = $d1f87d24500ab009$var$buildChildSet(children_1, $d1f87d24500ab009$var$NAME_ONLY_COMPARATOR, function(namedNode) {
            return namedNode.name;
        }, $d1f87d24500ab009$var$NAME_COMPARATOR);
        if (childrenHavePriority_1) {
            var sortedChildSet = $d1f87d24500ab009$var$buildChildSet(children_1, $d1f87d24500ab009$var$PRIORITY_INDEX.getCompare());
            return new $d1f87d24500ab009$var$ChildrenNode(childSet, $d1f87d24500ab009$var$nodeFromJSON$1(priority), new $d1f87d24500ab009$var$IndexMap({
                ".priority": sortedChildSet
            }, {
                ".priority": $d1f87d24500ab009$var$PRIORITY_INDEX
            }));
        } else return new $d1f87d24500ab009$var$ChildrenNode(childSet, $d1f87d24500ab009$var$nodeFromJSON$1(priority), $d1f87d24500ab009$var$IndexMap.Default);
    } else {
        var node_1 = $d1f87d24500ab009$var$ChildrenNode.EMPTY_NODE;
        $d1f87d24500ab009$var$each(json, function(key, childData) {
            if ($01sTD.contains(json, key)) {
                if (key.substring(0, 1) !== ".") {
                    // ignore metadata nodes.
                    var childNode = $d1f87d24500ab009$var$nodeFromJSON$1(childData);
                    if (childNode.isLeafNode() || !childNode.isEmpty()) node_1 = node_1.updateImmediateChild(key, childNode);
                }
            }
        });
        return node_1.updatePriority($d1f87d24500ab009$var$nodeFromJSON$1(priority));
    }
}
$d1f87d24500ab009$var$setNodeFromJSON($d1f87d24500ab009$var$nodeFromJSON$1);
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @constructor
 * @extends {Index}
 * @private
 */ var $d1f87d24500ab009$var$ValueIndex = /** @class */ function(_super) {
    $a92b69d2447c208d$export$a8ba968b8961cb8a(ValueIndex, _super);
    function ValueIndex() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @inheritDoc
     */ ValueIndex.prototype.compare = function(a, b) {
        var indexCmp = a.node.compareTo(b.node);
        if (indexCmp === 0) return $d1f87d24500ab009$var$nameCompare(a.name, b.name);
        else return indexCmp;
    };
    /**
     * @inheritDoc
     */ ValueIndex.prototype.isDefinedOn = function(node) {
        return true;
    };
    /**
     * @inheritDoc
     */ ValueIndex.prototype.indexedValueChanged = function(oldNode, newNode) {
        return !oldNode.equals(newNode);
    };
    /**
     * @inheritDoc
     */ ValueIndex.prototype.minPost = function() {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return $d1f87d24500ab009$var$NamedNode.MIN;
    };
    /**
     * @inheritDoc
     */ ValueIndex.prototype.maxPost = function() {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return $d1f87d24500ab009$var$NamedNode.MAX;
    };
    /**
     * @param {*} indexValue
     * @param {string} name
     * @return {!NamedNode}
     */ ValueIndex.prototype.makePost = function(indexValue, name) {
        var valueNode = $d1f87d24500ab009$var$nodeFromJSON$1(indexValue);
        return new $d1f87d24500ab009$var$NamedNode(name, valueNode);
    };
    /**
     * @return {!string} String representation for inclusion in a query spec
     */ ValueIndex.prototype.toString = function() {
        return ".value";
    };
    return ValueIndex;
}($d1f87d24500ab009$var$Index);
var $d1f87d24500ab009$var$VALUE_INDEX = new $d1f87d24500ab009$var$ValueIndex();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @param {!Path} indexPath
 * @constructor
 * @extends {Index}
 */ var $d1f87d24500ab009$var$PathIndex = /** @class */ function(_super) {
    $a92b69d2447c208d$export$a8ba968b8961cb8a(PathIndex, _super);
    function PathIndex(indexPath_) {
        var _this = _super.call(this) || this;
        _this.indexPath_ = indexPath_;
        $01sTD.assert(!indexPath_.isEmpty() && indexPath_.getFront() !== ".priority", "Can't create PathIndex with empty path or .priority key");
        return _this;
    }
    /**
     * @param {!Node} snap
     * @return {!Node}
     * @protected
     */ PathIndex.prototype.extractChild = function(snap) {
        return snap.getChild(this.indexPath_);
    };
    /**
     * @inheritDoc
     */ PathIndex.prototype.isDefinedOn = function(node) {
        return !node.getChild(this.indexPath_).isEmpty();
    };
    /**
     * @inheritDoc
     */ PathIndex.prototype.compare = function(a, b) {
        var aChild = this.extractChild(a.node);
        var bChild = this.extractChild(b.node);
        var indexCmp = aChild.compareTo(bChild);
        if (indexCmp === 0) return $d1f87d24500ab009$var$nameCompare(a.name, b.name);
        else return indexCmp;
    };
    /**
     * @inheritDoc
     */ PathIndex.prototype.makePost = function(indexValue, name) {
        var valueNode = $d1f87d24500ab009$var$nodeFromJSON$1(indexValue);
        var node = $d1f87d24500ab009$var$ChildrenNode.EMPTY_NODE.updateChild(this.indexPath_, valueNode);
        return new $d1f87d24500ab009$var$NamedNode(name, node);
    };
    /**
     * @inheritDoc
     */ PathIndex.prototype.maxPost = function() {
        var node = $d1f87d24500ab009$var$ChildrenNode.EMPTY_NODE.updateChild(this.indexPath_, $d1f87d24500ab009$var$MAX_NODE$2);
        return new $d1f87d24500ab009$var$NamedNode($d1f87d24500ab009$var$MAX_NAME, node);
    };
    /**
     * @inheritDoc
     */ PathIndex.prototype.toString = function() {
        return this.indexPath_.slice().join("/");
    };
    return PathIndex;
}($d1f87d24500ab009$var$Index);
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Class representing a firebase data snapshot.  It wraps a SnapshotNode and
 * surfaces the public methods (val, forEach, etc.) we want to expose.
 */ var $d1f87d24500ab009$var$DataSnapshot = /** @class */ function() {
    /**
     * @param {!Node} node_ A SnapshotNode to wrap.
     * @param {!Reference} ref_ The ref of the location this snapshot came from.
     * @param {!Index} index_ The iteration order for this snapshot
     */ function DataSnapshot(node_, ref_, index_) {
        this.node_ = node_;
        this.ref_ = ref_;
        this.index_ = index_;
    }
    /**
     * Retrieves the snapshot contents as JSON.  Returns null if the snapshot is
     * empty.
     *
     * @return {*} JSON representation of the DataSnapshot contents, or null if empty.
     */ DataSnapshot.prototype.val = function() {
        $01sTD.validateArgCount("DataSnapshot.val", 0, 0, arguments.length);
        return this.node_.val();
    };
    /**
     * Returns the snapshot contents as JSON, including priorities of node.  Suitable for exporting
     * the entire node contents.
     * @return {*} JSON representation of the DataSnapshot contents, or null if empty.
     */ DataSnapshot.prototype.exportVal = function() {
        $01sTD.validateArgCount("DataSnapshot.exportVal", 0, 0, arguments.length);
        return this.node_.val(true);
    };
    // Do not create public documentation. This is intended to make JSON serialization work but is otherwise unnecessary
    // for end-users
    DataSnapshot.prototype.toJSON = function() {
        // Optional spacer argument is unnecessary because we're depending on recursion rather than stringifying the content
        $01sTD.validateArgCount("DataSnapshot.toJSON", 0, 1, arguments.length);
        return this.exportVal();
    };
    /**
     * Returns whether the snapshot contains a non-null value.
     *
     * @return {boolean} Whether the snapshot contains a non-null value, or is empty.
     */ DataSnapshot.prototype.exists = function() {
        $01sTD.validateArgCount("DataSnapshot.exists", 0, 0, arguments.length);
        return !this.node_.isEmpty();
    };
    /**
     * Returns a DataSnapshot of the specified child node's contents.
     *
     * @param {!string} childPathString Path to a child.
     * @return {!DataSnapshot} DataSnapshot for child node.
     */ DataSnapshot.prototype.child = function(childPathString) {
        $01sTD.validateArgCount("DataSnapshot.child", 0, 1, arguments.length);
        // Ensure the childPath is a string (can be a number)
        childPathString = String(childPathString);
        $d1f87d24500ab009$var$validatePathString("DataSnapshot.child", 1, childPathString, false);
        var childPath = new $d1f87d24500ab009$var$Path(childPathString);
        var childRef = this.ref_.child(childPath);
        return new DataSnapshot(this.node_.getChild(childPath), childRef, $d1f87d24500ab009$var$PRIORITY_INDEX);
    };
    /**
     * Returns whether the snapshot contains a child at the specified path.
     *
     * @param {!string} childPathString Path to a child.
     * @return {boolean} Whether the child exists.
     */ DataSnapshot.prototype.hasChild = function(childPathString) {
        $01sTD.validateArgCount("DataSnapshot.hasChild", 1, 1, arguments.length);
        $d1f87d24500ab009$var$validatePathString("DataSnapshot.hasChild", 1, childPathString, false);
        var childPath = new $d1f87d24500ab009$var$Path(childPathString);
        return !this.node_.getChild(childPath).isEmpty();
    };
    /**
     * Returns the priority of the object, or null if no priority was set.
     *
     * @return {string|number|null} The priority.
     */ DataSnapshot.prototype.getPriority = function() {
        $01sTD.validateArgCount("DataSnapshot.getPriority", 0, 0, arguments.length);
        // typecast here because we never return deferred values or internal priorities (MAX_PRIORITY)
        return this.node_.getPriority().val();
    };
    /**
     * Iterates through child nodes and calls the specified action for each one.
     *
     * @param {function(!DataSnapshot)} action Callback function to be called
     * for each child.
     * @return {boolean} True if forEach was canceled by action returning true for
     * one of the child nodes.
     */ DataSnapshot.prototype.forEach = function(action) {
        var _this = this;
        $01sTD.validateArgCount("DataSnapshot.forEach", 1, 1, arguments.length);
        $01sTD.validateCallback("DataSnapshot.forEach", 1, action, false);
        if (this.node_.isLeafNode()) return false;
        var childrenNode = this.node_;
        // Sanitize the return value to a boolean. ChildrenNode.forEachChild has a weird return type...
        return !!childrenNode.forEachChild(this.index_, function(key, node) {
            return action(new DataSnapshot(node, _this.ref_.child(key), $d1f87d24500ab009$var$PRIORITY_INDEX));
        });
    };
    /**
     * Returns whether this DataSnapshot has children.
     * @return {boolean} True if the DataSnapshot contains 1 or more child nodes.
     */ DataSnapshot.prototype.hasChildren = function() {
        $01sTD.validateArgCount("DataSnapshot.hasChildren", 0, 0, arguments.length);
        if (this.node_.isLeafNode()) return false;
        else return !this.node_.isEmpty();
    };
    Object.defineProperty(DataSnapshot.prototype, "key", {
        get: function() {
            return this.ref_.getKey();
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Returns the number of children for this DataSnapshot.
     * @return {number} The number of children that this DataSnapshot contains.
     */ DataSnapshot.prototype.numChildren = function() {
        $01sTD.validateArgCount("DataSnapshot.numChildren", 0, 0, arguments.length);
        return this.node_.numChildren();
    };
    /**
     * @return {Reference} The Firebase reference for the location this snapshot's data came from.
     */ DataSnapshot.prototype.getRef = function() {
        $01sTD.validateArgCount("DataSnapshot.ref", 0, 0, arguments.length);
        return this.ref_;
    };
    Object.defineProperty(DataSnapshot.prototype, "ref", {
        get: function() {
            return this.getRef();
        },
        enumerable: false,
        configurable: true
    });
    return DataSnapshot;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Encapsulates the data needed to raise an event
 * @implements {Event}
 */ var $d1f87d24500ab009$var$DataEvent = /** @class */ function() {
    /**
     * @param {!string} eventType One of: value, child_added, child_changed, child_moved, child_removed
     * @param {!EventRegistration} eventRegistration The function to call to with the event data. User provided
     * @param {!DataSnapshot} snapshot The data backing the event
     * @param {?string=} prevName Optional, the name of the previous child for child_* events.
     */ function DataEvent(eventType, eventRegistration, snapshot, prevName) {
        this.eventType = eventType;
        this.eventRegistration = eventRegistration;
        this.snapshot = snapshot;
        this.prevName = prevName;
    }
    /**
     * @inheritDoc
     */ DataEvent.prototype.getPath = function() {
        var ref = this.snapshot.getRef();
        if (this.eventType === "value") return ref.path;
        else return ref.getParent().path;
    };
    /**
     * @inheritDoc
     */ DataEvent.prototype.getEventType = function() {
        return this.eventType;
    };
    /**
     * @inheritDoc
     */ DataEvent.prototype.getEventRunner = function() {
        return this.eventRegistration.getEventRunner(this);
    };
    /**
     * @inheritDoc
     */ DataEvent.prototype.toString = function() {
        return this.getPath().toString() + ":" + this.eventType + ":" + $01sTD.stringify(this.snapshot.exportVal());
    };
    return DataEvent;
}();
var $d1f87d24500ab009$var$CancelEvent = /** @class */ function() {
    /**
     * @param {EventRegistration} eventRegistration
     * @param {Error} error
     * @param {!Path} path
     */ function CancelEvent(eventRegistration, error, path) {
        this.eventRegistration = eventRegistration;
        this.error = error;
        this.path = path;
    }
    /**
     * @inheritDoc
     */ CancelEvent.prototype.getPath = function() {
        return this.path;
    };
    /**
     * @inheritDoc
     */ CancelEvent.prototype.getEventType = function() {
        return "cancel";
    };
    /**
     * @inheritDoc
     */ CancelEvent.prototype.getEventRunner = function() {
        return this.eventRegistration.getEventRunner(this);
    };
    /**
     * @inheritDoc
     */ CancelEvent.prototype.toString = function() {
        return this.path.toString() + ":cancel";
    };
    return CancelEvent;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents registration for 'value' events.
 */ var $d1f87d24500ab009$var$ValueEventRegistration = /** @class */ function() {
    /**
     * @param {?function(!DataSnapshot)} callback_
     * @param {?function(Error)} cancelCallback_
     * @param {?Object} context_
     */ function ValueEventRegistration(callback_, cancelCallback_, context_) {
        this.callback_ = callback_;
        this.cancelCallback_ = cancelCallback_;
        this.context_ = context_;
    }
    /**
     * @inheritDoc
     */ ValueEventRegistration.prototype.respondsTo = function(eventType) {
        return eventType === "value";
    };
    /**
     * @inheritDoc
     */ ValueEventRegistration.prototype.createEvent = function(change, query) {
        var index = query.getQueryParams().getIndex();
        return new $d1f87d24500ab009$var$DataEvent("value", this, new $d1f87d24500ab009$var$DataSnapshot(change.snapshotNode, query.getRef(), index));
    };
    /**
     * @inheritDoc
     */ ValueEventRegistration.prototype.getEventRunner = function(eventData) {
        var ctx = this.context_;
        if (eventData.getEventType() === "cancel") {
            $01sTD.assert(this.cancelCallback_, "Raising a cancel event on a listener with no cancel callback");
            var cancelCB_1 = this.cancelCallback_;
            return function() {
                // We know that error exists, we checked above that this is a cancel event
                cancelCB_1.call(ctx, eventData.error);
            };
        } else {
            var cb_1 = this.callback_;
            return function() {
                cb_1.call(ctx, eventData.snapshot);
            };
        }
    };
    /**
     * @inheritDoc
     */ ValueEventRegistration.prototype.createCancelEvent = function(error, path) {
        if (this.cancelCallback_) return new $d1f87d24500ab009$var$CancelEvent(this, error, path);
        else return null;
    };
    /**
     * @inheritDoc
     */ ValueEventRegistration.prototype.matches = function(other) {
        if (!(other instanceof ValueEventRegistration)) return false;
        else if (!other.callback_ || !this.callback_) // If no callback specified, we consider it to match any callback.
        return true;
        else return other.callback_ === this.callback_ && other.context_ === this.context_;
    };
    /**
     * @inheritDoc
     */ ValueEventRegistration.prototype.hasAnyCallback = function() {
        return this.callback_ !== null;
    };
    return ValueEventRegistration;
}();
/**
 * Represents the registration of 1 or more child_xxx events.
 *
 * Currently, it is always exactly 1 child_xxx event, but the idea is we might let you
 * register a group of callbacks together in the future.
 *
 * @constructor
 * @implements {EventRegistration}
 */ var $d1f87d24500ab009$var$ChildEventRegistration = /** @class */ function() {
    /**
     * @param {?Object.<string, function(!DataSnapshot, ?string=)>} callbacks_
     * @param {?function(Error)} cancelCallback_
     * @param {Object=} context_
     */ function ChildEventRegistration(callbacks_, cancelCallback_, context_) {
        this.callbacks_ = callbacks_;
        this.cancelCallback_ = cancelCallback_;
        this.context_ = context_;
    }
    /**
     * @inheritDoc
     */ ChildEventRegistration.prototype.respondsTo = function(eventType) {
        var eventToCheck = eventType === "children_added" ? "child_added" : eventType;
        eventToCheck = eventToCheck === "children_removed" ? "child_removed" : eventToCheck;
        return $01sTD.contains(this.callbacks_, eventToCheck);
    };
    /**
     * @inheritDoc
     */ ChildEventRegistration.prototype.createCancelEvent = function(error, path) {
        if (this.cancelCallback_) return new $d1f87d24500ab009$var$CancelEvent(this, error, path);
        else return null;
    };
    /**
     * @inheritDoc
     */ ChildEventRegistration.prototype.createEvent = function(change, query) {
        $01sTD.assert(change.childName != null, "Child events should have a childName.");
        var ref = query.getRef().child(/** @type {!string} */ change.childName);
        var index = query.getQueryParams().getIndex();
        return new $d1f87d24500ab009$var$DataEvent(change.type, this, new $d1f87d24500ab009$var$DataSnapshot(change.snapshotNode, ref, index), change.prevName);
    };
    /**
     * @inheritDoc
     */ ChildEventRegistration.prototype.getEventRunner = function(eventData) {
        var ctx = this.context_;
        if (eventData.getEventType() === "cancel") {
            $01sTD.assert(this.cancelCallback_, "Raising a cancel event on a listener with no cancel callback");
            var cancelCB_2 = this.cancelCallback_;
            return function() {
                // We know that error exists, we checked above that this is a cancel event
                cancelCB_2.call(ctx, eventData.error);
            };
        } else {
            var cb_2 = this.callbacks_[eventData.eventType];
            return function() {
                cb_2.call(ctx, eventData.snapshot, eventData.prevName);
            };
        }
    };
    /**
     * @inheritDoc
     */ ChildEventRegistration.prototype.matches = function(other) {
        var _this = this;
        if (other instanceof ChildEventRegistration) {
            if (!this.callbacks_ || !other.callbacks_) return true;
            else if (this.context_ === other.context_) {
                var otherKeys = Object.keys(other.callbacks_);
                var thisKeys = Object.keys(this.callbacks_);
                var otherCount = otherKeys.length;
                var thisCount = thisKeys.length;
                if (otherCount === thisCount) {
                    // If count is 1, do an exact match on eventType, if either is defined but null, it's a match.
                    // If event types don't match, not a match
                    // If count is not 1, exact match across all
                    if (otherCount === 1) {
                        var otherKey = otherKeys[0];
                        var thisKey = thisKeys[0];
                        return thisKey === otherKey && (!other.callbacks_[otherKey] || !this.callbacks_[thisKey] || other.callbacks_[otherKey] === this.callbacks_[thisKey]);
                    } else // Exact match on each key.
                    return thisKeys.every(function(eventType) {
                        return other.callbacks_[eventType] === _this.callbacks_[eventType];
                    });
                }
            }
        }
        return false;
    };
    /**
     * @inheritDoc
     */ ChildEventRegistration.prototype.hasAnyCallback = function() {
        return this.callbacks_ !== null;
    };
    return ChildEventRegistration;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $d1f87d24500ab009$var$__referenceConstructor;
/**
 * A Query represents a filter to be applied to a firebase location.  This object purely represents the
 * query expression (and exposes our public API to build the query).  The actual query logic is in ViewBase.js.
 *
 * Since every Firebase reference is a query, Firebase inherits from this object.
 */ var $d1f87d24500ab009$var$Query = /** @class */ function() {
    function Query(repo, path, queryParams_, orderByCalled_) {
        this.repo = repo;
        this.path = path;
        this.queryParams_ = queryParams_;
        this.orderByCalled_ = orderByCalled_;
    }
    Object.defineProperty(Query, "__referenceConstructor", {
        get: function() {
            $01sTD.assert($d1f87d24500ab009$var$__referenceConstructor, "Reference.ts has not been loaded");
            return $d1f87d24500ab009$var$__referenceConstructor;
        },
        set: function(val) {
            $d1f87d24500ab009$var$__referenceConstructor = val;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Validates start/end values for queries.
     * @param {!QueryParams} params
     * @private
     */ Query.validateQueryEndpoints_ = function(params) {
        var startNode = null;
        var endNode = null;
        if (params.hasStart()) startNode = params.getIndexStartValue();
        if (params.hasEnd()) endNode = params.getIndexEndValue();
        if (params.getIndex() === $d1f87d24500ab009$var$KEY_INDEX) {
            var tooManyArgsError = "Query: When ordering by key, you may only pass one argument to startAt(), endAt(), or equalTo().";
            var wrongArgTypeError = "Query: When ordering by key, the argument passed to startAt(), endAt(),or equalTo() must be a string.";
            if (params.hasStart()) {
                var startName = params.getIndexStartName();
                if (startName !== $d1f87d24500ab009$var$MIN_NAME) throw new Error(tooManyArgsError);
                else if (typeof startNode !== "string") throw new Error(wrongArgTypeError);
            }
            if (params.hasEnd()) {
                var endName = params.getIndexEndName();
                if (endName !== $d1f87d24500ab009$var$MAX_NAME) throw new Error(tooManyArgsError);
                else if (typeof endNode !== "string") throw new Error(wrongArgTypeError);
            }
        } else if (params.getIndex() === $d1f87d24500ab009$var$PRIORITY_INDEX) {
            if (startNode != null && !$d1f87d24500ab009$var$isValidPriority(startNode) || endNode != null && !$d1f87d24500ab009$var$isValidPriority(endNode)) throw new Error("Query: When ordering by priority, the first argument passed to startAt(), endAt(), or equalTo() must be a valid priority value (null, a number, or a string).");
        } else {
            $01sTD.assert(params.getIndex() instanceof $d1f87d24500ab009$var$PathIndex || params.getIndex() === $d1f87d24500ab009$var$VALUE_INDEX, "unknown index type.");
            if (startNode != null && typeof startNode === "object" || endNode != null && typeof endNode === "object") throw new Error("Query: First argument passed to startAt(), endAt(), or equalTo() cannot be an object.");
        }
    };
    /**
     * Validates that limit* has been called with the correct combination of parameters
     * @param {!QueryParams} params
     * @private
     */ Query.validateLimit_ = function(params) {
        if (params.hasStart() && params.hasEnd() && params.hasLimit() && !params.hasAnchoredLimit()) throw new Error("Query: Can't combine startAt(), endAt(), and limit(). Use limitToFirst() or limitToLast() instead.");
    };
    /**
     * Validates that no other order by call has been made
     * @param {!string} fnName
     * @private
     */ Query.prototype.validateNoPreviousOrderByCall_ = function(fnName) {
        if (this.orderByCalled_ === true) throw new Error(fnName + ": You can't combine multiple orderBy calls.");
    };
    /**
     * @return {!QueryParams}
     */ Query.prototype.getQueryParams = function() {
        return this.queryParams_;
    };
    /**
     * @return {!Reference}
     */ Query.prototype.getRef = function() {
        $01sTD.validateArgCount("Query.ref", 0, 0, arguments.length);
        // This is a slight hack. We cannot goog.require('fb.api.Firebase'), since Firebase requires fb.api.Query.
        // However, we will always export 'Firebase' to the global namespace, so it's guaranteed to exist by the time this
        // method gets called.
        return new Query.__referenceConstructor(this.repo, this.path);
    };
    /**
     * @param {!string} eventType
     * @param {!function(DataSnapshot, string=)} callback
     * @param {(function(Error)|Object)=} cancelCallbackOrContext
     * @param {Object=} context
     * @return {!function(DataSnapshot, string=)}
     */ Query.prototype.on = function(eventType, callback, cancelCallbackOrContext, context) {
        $01sTD.validateArgCount("Query.on", 2, 4, arguments.length);
        $d1f87d24500ab009$var$validateEventType("Query.on", 1, eventType, false);
        $01sTD.validateCallback("Query.on", 2, callback, false);
        var ret = Query.getCancelAndContextArgs_("Query.on", cancelCallbackOrContext, context);
        if (eventType === "value") this.onValueEvent(callback, ret.cancel, ret.context);
        else {
            var callbacks = {};
            callbacks[eventType] = callback;
            this.onChildEvent(callbacks, ret.cancel, ret.context);
        }
        return callback;
    };
    /**
     * @param {!function(!DataSnapshot)} callback
     * @param {?function(Error)} cancelCallback
     * @param {?Object} context
     * @protected
     */ Query.prototype.onValueEvent = function(callback, cancelCallback, context) {
        var container = new $d1f87d24500ab009$var$ValueEventRegistration(callback, cancelCallback || null, context || null);
        this.repo.addEventCallbackForQuery(this, container);
    };
    /**
     * @param {!Object.<string, !function(!DataSnapshot, ?string)>} callbacks
     * @param {?function(Error)} cancelCallback
     * @param {?Object} context
     * @protected
     */ Query.prototype.onChildEvent = function(callbacks, cancelCallback, context) {
        var container = new $d1f87d24500ab009$var$ChildEventRegistration(callbacks, cancelCallback, context);
        this.repo.addEventCallbackForQuery(this, container);
    };
    /**
     * @param {string=} eventType
     * @param {(function(!DataSnapshot, ?string=))=} callback
     * @param {Object=} context
     */ Query.prototype.off = function(eventType, callback, context) {
        $01sTD.validateArgCount("Query.off", 0, 3, arguments.length);
        $d1f87d24500ab009$var$validateEventType("Query.off", 1, eventType, true);
        $01sTD.validateCallback("Query.off", 2, callback, true);
        $01sTD.validateContextObject("Query.off", 3, context, true);
        var container = null;
        var callbacks = null;
        if (eventType === "value") {
            var valueCallback = callback || null;
            container = new $d1f87d24500ab009$var$ValueEventRegistration(valueCallback, null, context || null);
        } else if (eventType) {
            if (callback) {
                callbacks = {};
                callbacks[eventType] = callback;
            }
            container = new $d1f87d24500ab009$var$ChildEventRegistration(callbacks, null, context || null);
        }
        this.repo.removeEventCallbackForQuery(this, container);
    };
    /**
     * Attaches a listener, waits for the first event, and then removes the listener
     * @param {!string} eventType
     * @param {!function(!DataSnapshot, string=)} userCallback
     * @param failureCallbackOrContext
     * @param context
     * @return {!firebase.Promise}
     */ Query.prototype.once = function(eventType, userCallback, failureCallbackOrContext, context) {
        var _this = this;
        $01sTD.validateArgCount("Query.once", 1, 4, arguments.length);
        $d1f87d24500ab009$var$validateEventType("Query.once", 1, eventType, false);
        $01sTD.validateCallback("Query.once", 2, userCallback, true);
        var ret = Query.getCancelAndContextArgs_("Query.once", failureCallbackOrContext, context);
        // TODO: Implement this more efficiently (in particular, use 'get' wire protocol for 'value' event)
        // TODO: consider actually wiring the callbacks into the promise. We cannot do this without a breaking change
        // because the API currently expects callbacks will be called synchronously if the data is cached, but this is
        // against the Promise specification.
        var firstCall = true;
        var deferred = new $01sTD.Deferred();
        // A dummy error handler in case a user wasn't expecting promises
        deferred.promise.catch(function() {});
        var onceCallback = function(snapshot) {
            // NOTE: Even though we unsubscribe, we may get called multiple times if a single action (e.g. set() with JSON)
            // triggers multiple events (e.g. child_added or child_changed).
            if (firstCall) {
                firstCall = false;
                _this.off(eventType, onceCallback);
                if (userCallback) userCallback.bind(ret.context)(snapshot);
                deferred.resolve(snapshot);
            }
        };
        this.on(eventType, onceCallback, /*cancel=*/ function(err) {
            _this.off(eventType, onceCallback);
            if (ret.cancel) ret.cancel.bind(ret.context)(err);
            deferred.reject(err);
        });
        return deferred.promise;
    };
    /**
     * Set a limit and anchor it to the start of the window.
     * @param {!number} limit
     * @return {!Query}
     */ Query.prototype.limitToFirst = function(limit) {
        $01sTD.validateArgCount("Query.limitToFirst", 1, 1, arguments.length);
        if (typeof limit !== "number" || Math.floor(limit) !== limit || limit <= 0) throw new Error("Query.limitToFirst: First argument must be a positive integer.");
        if (this.queryParams_.hasLimit()) throw new Error("Query.limitToFirst: Limit was already set (by another call to limit, limitToFirst, or limitToLast).");
        return new Query(this.repo, this.path, this.queryParams_.limitToFirst(limit), this.orderByCalled_);
    };
    /**
     * Set a limit and anchor it to the end of the window.
     * @param {!number} limit
     * @return {!Query}
     */ Query.prototype.limitToLast = function(limit) {
        $01sTD.validateArgCount("Query.limitToLast", 1, 1, arguments.length);
        if (typeof limit !== "number" || Math.floor(limit) !== limit || limit <= 0) throw new Error("Query.limitToLast: First argument must be a positive integer.");
        if (this.queryParams_.hasLimit()) throw new Error("Query.limitToLast: Limit was already set (by another call to limit, limitToFirst, or limitToLast).");
        return new Query(this.repo, this.path, this.queryParams_.limitToLast(limit), this.orderByCalled_);
    };
    /**
     * Given a child path, return a new query ordered by the specified grandchild path.
     * @param {!string} path
     * @return {!Query}
     */ Query.prototype.orderByChild = function(path) {
        $01sTD.validateArgCount("Query.orderByChild", 1, 1, arguments.length);
        if (path === "$key") throw new Error('Query.orderByChild: "$key" is invalid.  Use Query.orderByKey() instead.');
        else if (path === "$priority") throw new Error('Query.orderByChild: "$priority" is invalid.  Use Query.orderByPriority() instead.');
        else if (path === "$value") throw new Error('Query.orderByChild: "$value" is invalid.  Use Query.orderByValue() instead.');
        $d1f87d24500ab009$var$validatePathString("Query.orderByChild", 1, path, false);
        this.validateNoPreviousOrderByCall_("Query.orderByChild");
        var parsedPath = new $d1f87d24500ab009$var$Path(path);
        if (parsedPath.isEmpty()) throw new Error("Query.orderByChild: cannot pass in empty path.  Use Query.orderByValue() instead.");
        var index = new $d1f87d24500ab009$var$PathIndex(parsedPath);
        var newParams = this.queryParams_.orderBy(index);
        Query.validateQueryEndpoints_(newParams);
        return new Query(this.repo, this.path, newParams, /*orderByCalled=*/ true);
    };
    /**
     * Return a new query ordered by the KeyIndex
     * @return {!Query}
     */ Query.prototype.orderByKey = function() {
        $01sTD.validateArgCount("Query.orderByKey", 0, 0, arguments.length);
        this.validateNoPreviousOrderByCall_("Query.orderByKey");
        var newParams = this.queryParams_.orderBy($d1f87d24500ab009$var$KEY_INDEX);
        Query.validateQueryEndpoints_(newParams);
        return new Query(this.repo, this.path, newParams, /*orderByCalled=*/ true);
    };
    /**
     * Return a new query ordered by the PriorityIndex
     * @return {!Query}
     */ Query.prototype.orderByPriority = function() {
        $01sTD.validateArgCount("Query.orderByPriority", 0, 0, arguments.length);
        this.validateNoPreviousOrderByCall_("Query.orderByPriority");
        var newParams = this.queryParams_.orderBy($d1f87d24500ab009$var$PRIORITY_INDEX);
        Query.validateQueryEndpoints_(newParams);
        return new Query(this.repo, this.path, newParams, /*orderByCalled=*/ true);
    };
    /**
     * Return a new query ordered by the ValueIndex
     * @return {!Query}
     */ Query.prototype.orderByValue = function() {
        $01sTD.validateArgCount("Query.orderByValue", 0, 0, arguments.length);
        this.validateNoPreviousOrderByCall_("Query.orderByValue");
        var newParams = this.queryParams_.orderBy($d1f87d24500ab009$var$VALUE_INDEX);
        Query.validateQueryEndpoints_(newParams);
        return new Query(this.repo, this.path, newParams, /*orderByCalled=*/ true);
    };
    /**
     * @param {number|string|boolean|null} value
     * @param {?string=} name
     * @return {!Query}
     */ Query.prototype.startAt = function(value, name) {
        if (value === void 0) value = null;
        $01sTD.validateArgCount("Query.startAt", 0, 2, arguments.length);
        $d1f87d24500ab009$var$validateFirebaseDataArg("Query.startAt", 1, value, this.path, true);
        $d1f87d24500ab009$var$validateKey("Query.startAt", 2, name, true);
        var newParams = this.queryParams_.startAt(value, name);
        Query.validateLimit_(newParams);
        Query.validateQueryEndpoints_(newParams);
        if (this.queryParams_.hasStart()) throw new Error("Query.startAt: Starting point was already set (by another call to startAt or equalTo).");
        // Calling with no params tells us to start at the beginning.
        if (value === undefined) {
            value = null;
            name = null;
        }
        return new Query(this.repo, this.path, newParams, this.orderByCalled_);
    };
    /**
     * @param {number|string|boolean|null} value
     * @param {?string=} name
     * @return {!Query}
     */ Query.prototype.endAt = function(value, name) {
        if (value === void 0) value = null;
        $01sTD.validateArgCount("Query.endAt", 0, 2, arguments.length);
        $d1f87d24500ab009$var$validateFirebaseDataArg("Query.endAt", 1, value, this.path, true);
        $d1f87d24500ab009$var$validateKey("Query.endAt", 2, name, true);
        var newParams = this.queryParams_.endAt(value, name);
        Query.validateLimit_(newParams);
        Query.validateQueryEndpoints_(newParams);
        if (this.queryParams_.hasEnd()) throw new Error("Query.endAt: Ending point was already set (by another call to endAt or equalTo).");
        return new Query(this.repo, this.path, newParams, this.orderByCalled_);
    };
    /**
     * Load the selection of children with exactly the specified value, and, optionally,
     * the specified name.
     * @param {number|string|boolean|null} value
     * @param {string=} name
     * @return {!Query}
     */ Query.prototype.equalTo = function(value, name) {
        $01sTD.validateArgCount("Query.equalTo", 1, 2, arguments.length);
        $d1f87d24500ab009$var$validateFirebaseDataArg("Query.equalTo", 1, value, this.path, false);
        $d1f87d24500ab009$var$validateKey("Query.equalTo", 2, name, true);
        if (this.queryParams_.hasStart()) throw new Error("Query.equalTo: Starting point was already set (by another call to startAt or equalTo).");
        if (this.queryParams_.hasEnd()) throw new Error("Query.equalTo: Ending point was already set (by another call to endAt or equalTo).");
        return this.startAt(value, name).endAt(value, name);
    };
    /**
     * @return {!string} URL for this location.
     */ Query.prototype.toString = function() {
        $01sTD.validateArgCount("Query.toString", 0, 0, arguments.length);
        return this.repo.toString() + this.path.toUrlEncodedString();
    };
    // Do not create public documentation. This is intended to make JSON serialization work but is otherwise unnecessary
    // for end-users.
    Query.prototype.toJSON = function() {
        // An optional spacer argument is unnecessary for a string.
        $01sTD.validateArgCount("Query.toJSON", 0, 1, arguments.length);
        return this.toString();
    };
    /**
     * An object representation of the query parameters used by this Query.
     * @return {!Object}
     */ Query.prototype.queryObject = function() {
        return this.queryParams_.getQueryObject();
    };
    /**
     * @return {!string}
     */ Query.prototype.queryIdentifier = function() {
        var obj = this.queryObject();
        var id = $d1f87d24500ab009$var$ObjectToUniqueKey(obj);
        return id === "{}" ? "default" : id;
    };
    /**
     * Return true if this query and the provided query are equivalent; otherwise, return false.
     * @param {Query} other
     * @return {boolean}
     */ Query.prototype.isEqual = function(other) {
        $01sTD.validateArgCount("Query.isEqual", 1, 1, arguments.length);
        if (!(other instanceof Query)) {
            var error = "Query.isEqual failed: First argument must be an instance of firebase.database.Query.";
            throw new Error(error);
        }
        var sameRepo = this.repo === other.repo;
        var samePath = this.path.equals(other.path);
        var sameQueryIdentifier = this.queryIdentifier() === other.queryIdentifier();
        return sameRepo && samePath && sameQueryIdentifier;
    };
    /**
     * Helper used by .on and .once to extract the context and or cancel arguments.
     * @param {!string} fnName The function name (on or once)
     * @param {(function(Error)|Object)=} cancelOrContext
     * @param {Object=} context
     * @return {{cancel: ?function(Error), context: ?Object}}
     * @private
     */ Query.getCancelAndContextArgs_ = function(fnName, cancelOrContext, context) {
        var ret = {
            cancel: null,
            context: null
        };
        if (cancelOrContext && context) {
            ret.cancel = cancelOrContext;
            $01sTD.validateCallback(fnName, 3, ret.cancel, true);
            ret.context = context;
            $01sTD.validateContextObject(fnName, 4, ret.context, true);
        } else if (cancelOrContext) {
            // we have either a cancel callback or a context.
            if (typeof cancelOrContext === "object" && cancelOrContext !== null) // it's a context!
            ret.context = cancelOrContext;
            else if (typeof cancelOrContext === "function") ret.cancel = cancelOrContext;
            else throw new Error($01sTD.errorPrefix(fnName, 3, true) + " must either be a cancel callback or a context object.");
        }
        return ret;
    };
    Object.defineProperty(Query.prototype, "ref", {
        get: function() {
            return this.getRef();
        },
        enumerable: false,
        configurable: true
    });
    return Query;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $d1f87d24500ab009$var$ExistingValueProvider = /** @class */ function() {
    function ExistingValueProvider(node_) {
        this.node_ = node_;
    }
    ExistingValueProvider.prototype.getImmediateChild = function(childName) {
        var child = this.node_.getImmediateChild(childName);
        return new ExistingValueProvider(child);
    };
    ExistingValueProvider.prototype.node = function() {
        return this.node_;
    };
    return ExistingValueProvider;
}();
var $d1f87d24500ab009$var$DeferredValueProvider = /** @class */ function() {
    function DeferredValueProvider(syncTree, path) {
        this.syncTree_ = syncTree;
        this.path_ = path;
    }
    DeferredValueProvider.prototype.getImmediateChild = function(childName) {
        var childPath = this.path_.child(childName);
        return new DeferredValueProvider(this.syncTree_, childPath);
    };
    DeferredValueProvider.prototype.node = function() {
        return this.syncTree_.calcCompleteEventCache(this.path_);
    };
    return DeferredValueProvider;
}();
/**
 * Generate placeholders for deferred values.
 * @param {?Object} values
 * @return {!Object}
 */ var $d1f87d24500ab009$var$generateWithValues = function(values) {
    values = values || {};
    values["timestamp"] = values["timestamp"] || new Date().getTime();
    return values;
};
/**
 * Value to use when firing local events. When writing server values, fire
 * local events with an approximate value, otherwise return value as-is.
 * @param {(Object|string|number|boolean)} value
 * @param {!Object} serverValues
 * @return {!(string|number|boolean)}
 */ var $d1f87d24500ab009$var$resolveDeferredLeafValue = function(value, existingVal, serverValues) {
    if (!value || typeof value !== "object") return value;
    $01sTD.assert(".sv" in value, "Unexpected leaf node or priority contents");
    if (typeof value[".sv"] === "string") return $d1f87d24500ab009$var$resolveScalarDeferredValue(value[".sv"], existingVal, serverValues);
    else if (typeof value[".sv"] === "object") return $d1f87d24500ab009$var$resolveComplexDeferredValue(value[".sv"], existingVal);
    else $01sTD.assert(false, "Unexpected server value: " + JSON.stringify(value, null, 2));
};
var $d1f87d24500ab009$var$resolveScalarDeferredValue = function(op, existing, serverValues) {
    switch(op){
        case "timestamp":
            return serverValues["timestamp"];
        default:
            $01sTD.assert(false, "Unexpected server value: " + op);
    }
};
var $d1f87d24500ab009$var$resolveComplexDeferredValue = function(op, existing, unused) {
    if (!op.hasOwnProperty("increment")) $01sTD.assert(false, "Unexpected server value: " + JSON.stringify(op, null, 2));
    var delta = op["increment"];
    if (typeof delta !== "number") $01sTD.assert(false, "Unexpected increment value: " + delta);
    var existingNode = existing.node();
    $01sTD.assert(existingNode !== null && typeof existingNode !== "undefined", "Expected ChildrenNode.EMPTY_NODE for nulls");
    // Incrementing a non-number sets the value to the incremented amount
    if (!existingNode.isLeafNode()) return delta;
    var leaf = existingNode;
    var existingVal = leaf.getValue();
    if (typeof existingVal !== "number") return delta;
    // No need to do over/underflow arithmetic here because JS only handles floats under the covers
    return existingVal + delta;
};
/**
 * Recursively replace all deferred values and priorities in the tree with the
 * specified generated replacement values.
 * @param {!Path} path path to which write is relative
 * @param {!Node} node new data written at path
 * @param {!SyncTree} syncTree current data
 * @param {!Object} serverValues
 * @return {!SparseSnapshotTree}
 */ var $d1f87d24500ab009$var$resolveDeferredValueTree = function(path, node, syncTree, serverValues) {
    return $d1f87d24500ab009$var$resolveDeferredValue(node, new $d1f87d24500ab009$var$DeferredValueProvider(syncTree, path), serverValues);
};
/**
 * Recursively replace all deferred values and priorities in the node with the
 * specified generated replacement values.  If there are no server values in the node,
 * it'll be returned as-is.
 * @param {!Node} node
 * @param {!Object} serverValues
 * @return {!Node}
 */ var $d1f87d24500ab009$var$resolveDeferredValueSnapshot = function(node, existing, serverValues) {
    return $d1f87d24500ab009$var$resolveDeferredValue(node, new $d1f87d24500ab009$var$ExistingValueProvider(existing), serverValues);
};
function $d1f87d24500ab009$var$resolveDeferredValue(node, existingVal, serverValues) {
    var rawPri = node.getPriority().val();
    var priority = $d1f87d24500ab009$var$resolveDeferredLeafValue(rawPri, existingVal.getImmediateChild(".priority"), serverValues);
    var newNode;
    if (node.isLeafNode()) {
        var leafNode = node;
        var value = $d1f87d24500ab009$var$resolveDeferredLeafValue(leafNode.getValue(), existingVal, serverValues);
        if (value !== leafNode.getValue() || priority !== leafNode.getPriority().val()) return new $d1f87d24500ab009$var$LeafNode(value, $d1f87d24500ab009$var$nodeFromJSON$1(priority));
        else return node;
    } else {
        var childrenNode = node;
        newNode = childrenNode;
        if (priority !== childrenNode.getPriority().val()) newNode = newNode.updatePriority(new $d1f87d24500ab009$var$LeafNode(priority));
        childrenNode.forEachChild($d1f87d24500ab009$var$PRIORITY_INDEX, function(childName, childNode) {
            var newChildNode = $d1f87d24500ab009$var$resolveDeferredValue(childNode, existingVal.getImmediateChild(childName), serverValues);
            if (newChildNode !== childNode) newNode = newNode.updateImmediateChild(childName, newChildNode);
        });
        return newNode;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Helper class to store a sparse set of snapshots.
 */ var $d1f87d24500ab009$var$SparseSnapshotTree = /** @class */ function() {
    function SparseSnapshotTree() {
        this.value = null;
        this.children = new Map();
    }
    /**
     * Gets the node stored at the given path if one exists.
     *
     * @param path Path to look up snapshot for.
     * @return The retrieved node, or null.
     */ SparseSnapshotTree.prototype.find = function(path) {
        if (this.value != null) return this.value.getChild(path);
        else if (!path.isEmpty() && this.children.size > 0) {
            var childKey = path.getFront();
            path = path.popFront();
            if (this.children.has(childKey)) {
                var childTree = this.children.get(childKey);
                return childTree.find(path);
            } else return null;
        } else return null;
    };
    /**
     * Stores the given node at the specified path. If there is already a node
     * at a shallower path, it merges the new data into that snapshot node.
     *
     * @param path Path to look up snapshot for.
     * @param data The new data, or null.
     */ SparseSnapshotTree.prototype.remember = function(path, data) {
        if (path.isEmpty()) {
            this.value = data;
            this.children.clear();
        } else if (this.value !== null) this.value = this.value.updateChild(path, data);
        else {
            var childKey = path.getFront();
            if (!this.children.has(childKey)) this.children.set(childKey, new SparseSnapshotTree());
            var child = this.children.get(childKey);
            path = path.popFront();
            child.remember(path, data);
        }
    };
    /**
     * Purge the data at path from the cache.
     *
     * @param path Path to look up snapshot for.
     * @return True if this node should now be removed.
     */ SparseSnapshotTree.prototype.forget = function(path) {
        if (path.isEmpty()) {
            this.value = null;
            this.children.clear();
            return true;
        } else {
            if (this.value !== null) {
                if (this.value.isLeafNode()) // We're trying to forget a node that doesn't exist
                return false;
                else {
                    var value = this.value;
                    this.value = null;
                    var self_1 = this;
                    value.forEachChild($d1f87d24500ab009$var$PRIORITY_INDEX, function(key, tree) {
                        self_1.remember(new $d1f87d24500ab009$var$Path(key), tree);
                    });
                    return this.forget(path);
                }
            } else if (this.children.size > 0) {
                var childKey = path.getFront();
                path = path.popFront();
                if (this.children.has(childKey)) {
                    var safeToRemove = this.children.get(childKey).forget(path);
                    if (safeToRemove) this.children.delete(childKey);
                }
                return this.children.size === 0;
            } else return true;
        }
    };
    /**
     * Recursively iterates through all of the stored tree and calls the
     * callback on each one.
     *
     * @param prefixPath Path to look up node for.
     * @param func The function to invoke for each tree.
     */ SparseSnapshotTree.prototype.forEachTree = function(prefixPath, func) {
        if (this.value !== null) func(prefixPath, this.value);
        else this.forEachChild(function(key, tree) {
            var path = new $d1f87d24500ab009$var$Path(prefixPath.toString() + "/" + key);
            tree.forEachTree(path, func);
        });
    };
    /**
     * Iterates through each immediate child and triggers the callback.
     *
     * @param func The function to invoke for each child.
     */ SparseSnapshotTree.prototype.forEachChild = function(func) {
        this.children.forEach(function(tree, key) {
            func(key, tree);
        });
    };
    return SparseSnapshotTree;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 *
 * @enum
 */ var $d1f87d24500ab009$var$OperationType;
(function(OperationType) {
    OperationType[OperationType["OVERWRITE"] = 0] = "OVERWRITE";
    OperationType[OperationType["MERGE"] = 1] = "MERGE";
    OperationType[OperationType["ACK_USER_WRITE"] = 2] = "ACK_USER_WRITE";
    OperationType[OperationType["LISTEN_COMPLETE"] = 3] = "LISTEN_COMPLETE";
})($d1f87d24500ab009$var$OperationType || ($d1f87d24500ab009$var$OperationType = {}));
/**
 * @param {boolean} fromUser
 * @param {boolean} fromServer
 * @param {?string} queryId
 * @param {boolean} tagged
 * @constructor
 */ var $d1f87d24500ab009$var$OperationSource = /** @class */ function() {
    function OperationSource(fromUser, fromServer, queryId, tagged) {
        this.fromUser = fromUser;
        this.fromServer = fromServer;
        this.queryId = queryId;
        this.tagged = tagged;
        $01sTD.assert(!tagged || fromServer, "Tagged queries must be from server.");
    }
    /**
     * @const
     * @type {!OperationSource}
     */ OperationSource.User = new OperationSource(/*fromUser=*/ true, false, null, /*tagged=*/ false);
    /**
     * @const
     * @type {!OperationSource}
     */ OperationSource.Server = new OperationSource(false, /*fromServer=*/ true, null, /*tagged=*/ false);
    /**
     * @param {string} queryId
     * @return {!OperationSource}
     */ OperationSource.forServerTaggedQuery = function(queryId) {
        return new OperationSource(false, /*fromServer=*/ true, queryId, /*tagged=*/ true);
    };
    return OperationSource;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $d1f87d24500ab009$var$AckUserWrite = /** @class */ function() {
    /**
     *
     * @param {!Path} path
     * @param {!ImmutableTree<!boolean>} affectedTree A tree containing true for each affected path. Affected paths can't overlap.
     * @param {!boolean} revert
     */ function AckUserWrite(/** @inheritDoc */ path, /** @inheritDoc */ affectedTree, /** @inheritDoc */ revert) {
        this.path = path;
        this.affectedTree = affectedTree;
        this.revert = revert;
        /** @inheritDoc */ this.type = $d1f87d24500ab009$var$OperationType.ACK_USER_WRITE;
        /** @inheritDoc */ this.source = $d1f87d24500ab009$var$OperationSource.User;
    }
    /**
     * @inheritDoc
     */ AckUserWrite.prototype.operationForChild = function(childName) {
        if (!this.path.isEmpty()) {
            $01sTD.assert(this.path.getFront() === childName, "operationForChild called for unrelated child.");
            return new AckUserWrite(this.path.popFront(), this.affectedTree, this.revert);
        } else if (this.affectedTree.value != null) {
            $01sTD.assert(this.affectedTree.children.isEmpty(), "affectedTree should not have overlapping affected paths.");
            // All child locations are affected as well; just return same operation.
            return this;
        } else {
            var childTree = this.affectedTree.subtree(new $d1f87d24500ab009$var$Path(childName));
            return new AckUserWrite($d1f87d24500ab009$var$Path.Empty, childTree, this.revert);
        }
    };
    return AckUserWrite;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $d1f87d24500ab009$var$emptyChildrenSingleton;
/**
 * Singleton empty children collection.
 *
 * @const
 * @type {!SortedMap.<string, !ImmutableTree.<?>>}
 */ var $d1f87d24500ab009$var$EmptyChildren = function() {
    if (!$d1f87d24500ab009$var$emptyChildrenSingleton) $d1f87d24500ab009$var$emptyChildrenSingleton = new $d1f87d24500ab009$var$SortedMap($d1f87d24500ab009$var$stringCompare);
    return $d1f87d24500ab009$var$emptyChildrenSingleton;
};
/**
 * A tree with immutable elements.
 */ var $d1f87d24500ab009$var$ImmutableTree = /** @class */ function() {
    /**
     * @template T
     * @param {?T} value
     * @param {SortedMap.<string, !ImmutableTree.<T>>=} children
     */ function ImmutableTree(value, children) {
        if (children === void 0) children = $d1f87d24500ab009$var$EmptyChildren();
        this.value = value;
        this.children = children;
    }
    /**
     * @template T
     * @param {!Object.<string, !T>} obj
     * @return {!ImmutableTree.<!T>}
     */ ImmutableTree.fromObject = function(obj) {
        var tree = ImmutableTree.Empty;
        $d1f87d24500ab009$var$each(obj, function(childPath, childSnap) {
            tree = tree.set(new $d1f87d24500ab009$var$Path(childPath), childSnap);
        });
        return tree;
    };
    /**
     * True if the value is empty and there are no children
     * @return {boolean}
     */ ImmutableTree.prototype.isEmpty = function() {
        return this.value === null && this.children.isEmpty();
    };
    /**
     * Given a path and predicate, return the first node and the path to that node
     * where the predicate returns true.
     *
     * TODO Do a perf test -- If we're creating a bunch of {path: value:} objects
     * on the way back out, it may be better to pass down a pathSoFar obj.
     *
     * @param {!Path} relativePath The remainder of the path
     * @param {function(T):boolean} predicate The predicate to satisfy to return a
     *   node
     * @return {?{path:!Path, value:!T}}
     */ ImmutableTree.prototype.findRootMostMatchingPathAndValue = function(relativePath, predicate) {
        if (this.value != null && predicate(this.value)) return {
            path: $d1f87d24500ab009$var$Path.Empty,
            value: this.value
        };
        else {
            if (relativePath.isEmpty()) return null;
            else {
                var front = relativePath.getFront();
                var child = this.children.get(front);
                if (child !== null) {
                    var childExistingPathAndValue = child.findRootMostMatchingPathAndValue(relativePath.popFront(), predicate);
                    if (childExistingPathAndValue != null) {
                        var fullPath = new $d1f87d24500ab009$var$Path(front).child(childExistingPathAndValue.path);
                        return {
                            path: fullPath,
                            value: childExistingPathAndValue.value
                        };
                    } else return null;
                } else return null;
            }
        }
    };
    /**
     * Find, if it exists, the shortest subpath of the given path that points a defined
     * value in the tree
     * @param {!Path} relativePath
     * @return {?{path: !Path, value: !T}}
     */ ImmutableTree.prototype.findRootMostValueAndPath = function(relativePath) {
        return this.findRootMostMatchingPathAndValue(relativePath, function() {
            return true;
        });
    };
    /**
     * @param {!Path} relativePath
     * @return {!ImmutableTree.<T>} The subtree at the given path
     */ ImmutableTree.prototype.subtree = function(relativePath) {
        if (relativePath.isEmpty()) return this;
        else {
            var front = relativePath.getFront();
            var childTree = this.children.get(front);
            if (childTree !== null) return childTree.subtree(relativePath.popFront());
            else return ImmutableTree.Empty;
        }
    };
    /**
     * Sets a value at the specified path.
     *
     * @param {!Path} relativePath Path to set value at.
     * @param {?T} toSet Value to set.
     * @return {!ImmutableTree.<T>} Resulting tree.
     */ ImmutableTree.prototype.set = function(relativePath, toSet) {
        if (relativePath.isEmpty()) return new ImmutableTree(toSet, this.children);
        else {
            var front = relativePath.getFront();
            var child = this.children.get(front) || ImmutableTree.Empty;
            var newChild = child.set(relativePath.popFront(), toSet);
            var newChildren = this.children.insert(front, newChild);
            return new ImmutableTree(this.value, newChildren);
        }
    };
    /**
     * Removes the value at the specified path.
     *
     * @param {!Path} relativePath Path to value to remove.
     * @return {!ImmutableTree.<T>} Resulting tree.
     */ ImmutableTree.prototype.remove = function(relativePath) {
        if (relativePath.isEmpty()) {
            if (this.children.isEmpty()) return ImmutableTree.Empty;
            else return new ImmutableTree(null, this.children);
        } else {
            var front = relativePath.getFront();
            var child = this.children.get(front);
            if (child) {
                var newChild = child.remove(relativePath.popFront());
                var newChildren = void 0;
                if (newChild.isEmpty()) newChildren = this.children.remove(front);
                else newChildren = this.children.insert(front, newChild);
                if (this.value === null && newChildren.isEmpty()) return ImmutableTree.Empty;
                else return new ImmutableTree(this.value, newChildren);
            } else return this;
        }
    };
    /**
     * Gets a value from the tree.
     *
     * @param {!Path} relativePath Path to get value for.
     * @return {?T} Value at path, or null.
     */ ImmutableTree.prototype.get = function(relativePath) {
        if (relativePath.isEmpty()) return this.value;
        else {
            var front = relativePath.getFront();
            var child = this.children.get(front);
            if (child) return child.get(relativePath.popFront());
            else return null;
        }
    };
    /**
     * Replace the subtree at the specified path with the given new tree.
     *
     * @param {!Path} relativePath Path to replace subtree for.
     * @param {!ImmutableTree} newTree New tree.
     * @return {!ImmutableTree} Resulting tree.
     */ ImmutableTree.prototype.setTree = function(relativePath, newTree) {
        if (relativePath.isEmpty()) return newTree;
        else {
            var front = relativePath.getFront();
            var child = this.children.get(front) || ImmutableTree.Empty;
            var newChild = child.setTree(relativePath.popFront(), newTree);
            var newChildren = void 0;
            if (newChild.isEmpty()) newChildren = this.children.remove(front);
            else newChildren = this.children.insert(front, newChild);
            return new ImmutableTree(this.value, newChildren);
        }
    };
    /**
     * Performs a depth first fold on this tree. Transforms a tree into a single
     * value, given a function that operates on the path to a node, an optional
     * current value, and a map of child names to folded subtrees
     * @template V
     * @param {function(Path, ?T, Object.<string, V>):V} fn
     * @return {V}
     */ ImmutableTree.prototype.fold = function(fn) {
        return this.fold_($d1f87d24500ab009$var$Path.Empty, fn);
    };
    /**
     * Recursive helper for public-facing fold() method
     * @template V
     * @param {!Path} pathSoFar
     * @param {function(Path, ?T, Object.<string, V>):V} fn
     * @return {V}
     * @private
     */ ImmutableTree.prototype.fold_ = function(pathSoFar, fn) {
        var accum = {};
        this.children.inorderTraversal(function(childKey, childTree) {
            accum[childKey] = childTree.fold_(pathSoFar.child(childKey), fn);
        });
        return fn(pathSoFar, this.value, accum);
    };
    /**
     * Find the first matching value on the given path. Return the result of applying f to it.
     * @template V
     * @param {!Path} path
     * @param {!function(!Path, !T):?V} f
     * @return {?V}
     */ ImmutableTree.prototype.findOnPath = function(path, f) {
        return this.findOnPath_(path, $d1f87d24500ab009$var$Path.Empty, f);
    };
    ImmutableTree.prototype.findOnPath_ = function(pathToFollow, pathSoFar, f) {
        var result = this.value ? f(pathSoFar, this.value) : false;
        if (result) return result;
        else {
            if (pathToFollow.isEmpty()) return null;
            else {
                var front = pathToFollow.getFront();
                var nextChild = this.children.get(front);
                if (nextChild) return nextChild.findOnPath_(pathToFollow.popFront(), pathSoFar.child(front), f);
                else return null;
            }
        }
    };
    /**
     *
     * @param {!Path} path
     * @param {!function(!Path, !T)} f
     * @returns {!ImmutableTree.<T>}
     */ ImmutableTree.prototype.foreachOnPath = function(path, f) {
        return this.foreachOnPath_(path, $d1f87d24500ab009$var$Path.Empty, f);
    };
    ImmutableTree.prototype.foreachOnPath_ = function(pathToFollow, currentRelativePath, f) {
        if (pathToFollow.isEmpty()) return this;
        else {
            if (this.value) f(currentRelativePath, this.value);
            var front = pathToFollow.getFront();
            var nextChild = this.children.get(front);
            if (nextChild) return nextChild.foreachOnPath_(pathToFollow.popFront(), currentRelativePath.child(front), f);
            else return ImmutableTree.Empty;
        }
    };
    /**
     * Calls the given function for each node in the tree that has a value.
     *
     * @param {function(!Path, !T)} f A function to be called with
     *   the path from the root of the tree to a node, and the value at that node.
     *   Called in depth-first order.
     */ ImmutableTree.prototype.foreach = function(f) {
        this.foreach_($d1f87d24500ab009$var$Path.Empty, f);
    };
    ImmutableTree.prototype.foreach_ = function(currentRelativePath, f) {
        this.children.inorderTraversal(function(childName, childTree) {
            childTree.foreach_(currentRelativePath.child(childName), f);
        });
        if (this.value) f(currentRelativePath, this.value);
    };
    /**
     *
     * @param {function(string, !T)} f
     */ ImmutableTree.prototype.foreachChild = function(f) {
        this.children.inorderTraversal(function(childName, childTree) {
            if (childTree.value) f(childName, childTree.value);
        });
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ImmutableTree.Empty = new ImmutableTree(null);
    return ImmutableTree;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @param {!OperationSource} source
 * @param {!Path} path
 * @constructor
 * @implements {Operation}
 */ var $d1f87d24500ab009$var$ListenComplete = /** @class */ function() {
    function ListenComplete(source, path) {
        this.source = source;
        this.path = path;
        /** @inheritDoc */ this.type = $d1f87d24500ab009$var$OperationType.LISTEN_COMPLETE;
    }
    ListenComplete.prototype.operationForChild = function(childName) {
        if (this.path.isEmpty()) return new ListenComplete(this.source, $d1f87d24500ab009$var$Path.Empty);
        else return new ListenComplete(this.source, this.path.popFront());
    };
    return ListenComplete;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @param {!OperationSource} source
 * @param {!Path} path
 * @param {!Node} snap
 * @constructor
 * @implements {Operation}
 */ var $d1f87d24500ab009$var$Overwrite = /** @class */ function() {
    function Overwrite(source, path, snap) {
        this.source = source;
        this.path = path;
        this.snap = snap;
        /** @inheritDoc */ this.type = $d1f87d24500ab009$var$OperationType.OVERWRITE;
    }
    Overwrite.prototype.operationForChild = function(childName) {
        if (this.path.isEmpty()) return new Overwrite(this.source, $d1f87d24500ab009$var$Path.Empty, this.snap.getImmediateChild(childName));
        else return new Overwrite(this.source, this.path.popFront(), this.snap);
    };
    return Overwrite;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @param {!OperationSource} source
 * @param {!Path} path
 * @param {!ImmutableTree.<!Node>} children
 * @constructor
 * @implements {Operation}
 */ var $d1f87d24500ab009$var$Merge = /** @class */ function() {
    function Merge(/** @inheritDoc */ source, /** @inheritDoc */ path, /** @inheritDoc */ children) {
        this.source = source;
        this.path = path;
        this.children = children;
        /** @inheritDoc */ this.type = $d1f87d24500ab009$var$OperationType.MERGE;
    }
    /**
     * @inheritDoc
     */ Merge.prototype.operationForChild = function(childName) {
        if (this.path.isEmpty()) {
            var childTree = this.children.subtree(new $d1f87d24500ab009$var$Path(childName));
            if (childTree.isEmpty()) // This child is unaffected
            return null;
            else if (childTree.value) // We have a snapshot for the child in question.  This becomes an overwrite of the child.
            return new $d1f87d24500ab009$var$Overwrite(this.source, $d1f87d24500ab009$var$Path.Empty, childTree.value);
            else // This is a merge at a deeper level
            return new Merge(this.source, $d1f87d24500ab009$var$Path.Empty, childTree);
        } else {
            $01sTD.assert(this.path.getFront() === childName, "Can't get a merge for a child not on the path of the operation");
            return new Merge(this.source, this.path.popFront(), this.children);
        }
    };
    /**
     * @inheritDoc
     */ Merge.prototype.toString = function() {
        return "Operation(" + this.path + ": " + this.source.toString() + " merge: " + this.children.toString() + ")";
    };
    return Merge;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A cache node only stores complete children. Additionally it holds a flag whether the node can be considered fully
 * initialized in the sense that we know at one point in time this represented a valid state of the world, e.g.
 * initialized with data from the server, or a complete overwrite by the client. The filtered flag also tracks
 * whether a node potentially had children removed due to a filter.
 */ var $d1f87d24500ab009$var$CacheNode = /** @class */ function() {
    /**
     * @param {!Node} node_
     * @param {boolean} fullyInitialized_
     * @param {boolean} filtered_
     */ function CacheNode(node_, fullyInitialized_, filtered_) {
        this.node_ = node_;
        this.fullyInitialized_ = fullyInitialized_;
        this.filtered_ = filtered_;
    }
    /**
     * Returns whether this node was fully initialized with either server data or a complete overwrite by the client
     * @return {boolean}
     */ CacheNode.prototype.isFullyInitialized = function() {
        return this.fullyInitialized_;
    };
    /**
     * Returns whether this node is potentially missing children due to a filter applied to the node
     * @return {boolean}
     */ CacheNode.prototype.isFiltered = function() {
        return this.filtered_;
    };
    /**
     * @param {!Path} path
     * @return {boolean}
     */ CacheNode.prototype.isCompleteForPath = function(path) {
        if (path.isEmpty()) return this.isFullyInitialized() && !this.filtered_;
        var childKey = path.getFront();
        return this.isCompleteForChild(childKey);
    };
    /**
     * @param {!string} key
     * @return {boolean}
     */ CacheNode.prototype.isCompleteForChild = function(key) {
        return this.isFullyInitialized() && !this.filtered_ || this.node_.hasChild(key);
    };
    /**
     * @return {!Node}
     */ CacheNode.prototype.getNode = function() {
        return this.node_;
    };
    return CacheNode;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Stores the data we have cached for a view.
 *
 * serverSnap is the cached server data, eventSnap is the cached event data (server data plus any local writes).
 *
 * @constructor
 */ var $d1f87d24500ab009$var$ViewCache = /** @class */ function() {
    /**
     *
     * @param {!CacheNode} eventCache_
     * @param {!CacheNode} serverCache_
     */ function ViewCache(eventCache_, serverCache_) {
        this.eventCache_ = eventCache_;
        this.serverCache_ = serverCache_;
    }
    /**
     * @param {!Node} eventSnap
     * @param {boolean} complete
     * @param {boolean} filtered
     * @return {!ViewCache}
     */ ViewCache.prototype.updateEventSnap = function(eventSnap, complete, filtered) {
        return new ViewCache(new $d1f87d24500ab009$var$CacheNode(eventSnap, complete, filtered), this.serverCache_);
    };
    /**
     * @param {!Node} serverSnap
     * @param {boolean} complete
     * @param {boolean} filtered
     * @return {!ViewCache}
     */ ViewCache.prototype.updateServerSnap = function(serverSnap, complete, filtered) {
        return new ViewCache(this.eventCache_, new $d1f87d24500ab009$var$CacheNode(serverSnap, complete, filtered));
    };
    /**
     * @return {!CacheNode}
     */ ViewCache.prototype.getEventCache = function() {
        return this.eventCache_;
    };
    /**
     * @return {?Node}
     */ ViewCache.prototype.getCompleteEventSnap = function() {
        return this.eventCache_.isFullyInitialized() ? this.eventCache_.getNode() : null;
    };
    /**
     * @return {!CacheNode}
     */ ViewCache.prototype.getServerCache = function() {
        return this.serverCache_;
    };
    /**
     * @return {?Node}
     */ ViewCache.prototype.getCompleteServerSnap = function() {
        return this.serverCache_.isFullyInitialized() ? this.serverCache_.getNode() : null;
    };
    /**
     * @const
     * @type {ViewCache}
     */ ViewCache.Empty = new ViewCache(new $d1f87d24500ab009$var$CacheNode($d1f87d24500ab009$var$ChildrenNode.EMPTY_NODE, /*fullyInitialized=*/ false, /*filtered=*/ false), new $d1f87d24500ab009$var$CacheNode($d1f87d24500ab009$var$ChildrenNode.EMPTY_NODE, /*fullyInitialized=*/ false, /*filtered=*/ false));
    return ViewCache;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @constructor
 * @struct
 * @param {!string} type The event type
 * @param {!Node} snapshotNode The data
 * @param {string=} childName The name for this child, if it's a child event
 * @param {Node=} oldSnap Used for intermediate processing of child changed events
 * @param {string=} prevName The name for the previous child, if applicable
 */ var $d1f87d24500ab009$var$Change = /** @class */ function() {
    function Change(type, snapshotNode, childName, oldSnap, prevName) {
        this.type = type;
        this.snapshotNode = snapshotNode;
        this.childName = childName;
        this.oldSnap = oldSnap;
        this.prevName = prevName;
    }
    /**
     * @param {!Node} snapshot
     * @return {!Change}
     */ Change.valueChange = function(snapshot) {
        return new Change(Change.VALUE, snapshot);
    };
    /**
     * @param {string} childKey
     * @param {!Node} snapshot
     * @return {!Change}
     */ Change.childAddedChange = function(childKey, snapshot) {
        return new Change(Change.CHILD_ADDED, snapshot, childKey);
    };
    /**
     * @param {string} childKey
     * @param {!Node} snapshot
     * @return {!Change}
     */ Change.childRemovedChange = function(childKey, snapshot) {
        return new Change(Change.CHILD_REMOVED, snapshot, childKey);
    };
    /**
     * @param {string} childKey
     * @param {!Node} newSnapshot
     * @param {!Node} oldSnapshot
     * @return {!Change}
     */ Change.childChangedChange = function(childKey, newSnapshot, oldSnapshot) {
        return new Change(Change.CHILD_CHANGED, newSnapshot, childKey, oldSnapshot);
    };
    /**
     * @param {string} childKey
     * @param {!Node} snapshot
     * @return {!Change}
     */ Change.childMovedChange = function(childKey, snapshot) {
        return new Change(Change.CHILD_MOVED, snapshot, childKey);
    };
    //event types
    /** Event type for a child added */ Change.CHILD_ADDED = "child_added";
    /** Event type for a child removed */ Change.CHILD_REMOVED = "child_removed";
    /** Event type for a child changed */ Change.CHILD_CHANGED = "child_changed";
    /** Event type for a child moved */ Change.CHILD_MOVED = "child_moved";
    /** Event type for a value change */ Change.VALUE = "value";
    return Change;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Doesn't really filter nodes but applies an index to the node and keeps track of any changes
 *
 * @constructor
 * @implements {NodeFilter}
 * @param {!Index} index
 */ var $d1f87d24500ab009$var$IndexedFilter = /** @class */ function() {
    function IndexedFilter(index_) {
        this.index_ = index_;
    }
    IndexedFilter.prototype.updateChild = function(snap, key, newChild, affectedPath, source, optChangeAccumulator) {
        $01sTD.assert(snap.isIndexed(this.index_), "A node must be indexed if only a child is updated");
        var oldChild = snap.getImmediateChild(key);
        // Check if anything actually changed.
        if (oldChild.getChild(affectedPath).equals(newChild.getChild(affectedPath))) {
            // There's an edge case where a child can enter or leave the view because affectedPath was set to null.
            // In this case, affectedPath will appear null in both the old and new snapshots.  So we need
            // to avoid treating these cases as "nothing changed."
            if (oldChild.isEmpty() === newChild.isEmpty()) // Nothing changed.
            // This assert should be valid, but it's expensive (can dominate perf testing) so don't actually do it.
            //assert(oldChild.equals(newChild), 'Old and new snapshots should be equal.');
            return snap;
        }
        if (optChangeAccumulator != null) {
            if (newChild.isEmpty()) {
                if (snap.hasChild(key)) optChangeAccumulator.trackChildChange($d1f87d24500ab009$var$Change.childRemovedChange(key, oldChild));
                else $01sTD.assert(snap.isLeafNode(), "A child remove without an old child only makes sense on a leaf node");
            } else if (oldChild.isEmpty()) optChangeAccumulator.trackChildChange($d1f87d24500ab009$var$Change.childAddedChange(key, newChild));
            else optChangeAccumulator.trackChildChange($d1f87d24500ab009$var$Change.childChangedChange(key, newChild, oldChild));
        }
        if (snap.isLeafNode() && newChild.isEmpty()) return snap;
        else // Make sure the node is indexed
        return snap.updateImmediateChild(key, newChild).withIndex(this.index_);
    };
    /**
     * @inheritDoc
     */ IndexedFilter.prototype.updateFullNode = function(oldSnap, newSnap, optChangeAccumulator) {
        if (optChangeAccumulator != null) {
            if (!oldSnap.isLeafNode()) oldSnap.forEachChild($d1f87d24500ab009$var$PRIORITY_INDEX, function(key, childNode) {
                if (!newSnap.hasChild(key)) optChangeAccumulator.trackChildChange($d1f87d24500ab009$var$Change.childRemovedChange(key, childNode));
            });
            if (!newSnap.isLeafNode()) newSnap.forEachChild($d1f87d24500ab009$var$PRIORITY_INDEX, function(key, childNode) {
                if (oldSnap.hasChild(key)) {
                    var oldChild = oldSnap.getImmediateChild(key);
                    if (!oldChild.equals(childNode)) optChangeAccumulator.trackChildChange($d1f87d24500ab009$var$Change.childChangedChange(key, childNode, oldChild));
                } else optChangeAccumulator.trackChildChange($d1f87d24500ab009$var$Change.childAddedChange(key, childNode));
            });
        }
        return newSnap.withIndex(this.index_);
    };
    /**
     * @inheritDoc
     */ IndexedFilter.prototype.updatePriority = function(oldSnap, newPriority) {
        if (oldSnap.isEmpty()) return $d1f87d24500ab009$var$ChildrenNode.EMPTY_NODE;
        else return oldSnap.updatePriority(newPriority);
    };
    /**
     * @inheritDoc
     */ IndexedFilter.prototype.filtersNodes = function() {
        return false;
    };
    /**
     * @inheritDoc
     */ IndexedFilter.prototype.getIndexedFilter = function() {
        return this;
    };
    /**
     * @inheritDoc
     */ IndexedFilter.prototype.getIndex = function() {
        return this.index_;
    };
    return IndexedFilter;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $d1f87d24500ab009$var$ChildChangeAccumulator = /** @class */ function() {
    function ChildChangeAccumulator() {
        this.changeMap = new Map();
    }
    ChildChangeAccumulator.prototype.trackChildChange = function(change) {
        var type = change.type;
        var childKey = change.childName;
        $01sTD.assert(type === $d1f87d24500ab009$var$Change.CHILD_ADDED || type === $d1f87d24500ab009$var$Change.CHILD_CHANGED || type === $d1f87d24500ab009$var$Change.CHILD_REMOVED, "Only child changes supported for tracking");
        $01sTD.assert(childKey !== ".priority", "Only non-priority child changes can be tracked.");
        var oldChange = this.changeMap.get(childKey);
        if (oldChange) {
            var oldType = oldChange.type;
            if (type === $d1f87d24500ab009$var$Change.CHILD_ADDED && oldType === $d1f87d24500ab009$var$Change.CHILD_REMOVED) this.changeMap.set(childKey, $d1f87d24500ab009$var$Change.childChangedChange(childKey, change.snapshotNode, oldChange.snapshotNode));
            else if (type === $d1f87d24500ab009$var$Change.CHILD_REMOVED && oldType === $d1f87d24500ab009$var$Change.CHILD_ADDED) this.changeMap.delete(childKey);
            else if (type === $d1f87d24500ab009$var$Change.CHILD_REMOVED && oldType === $d1f87d24500ab009$var$Change.CHILD_CHANGED) this.changeMap.set(childKey, $d1f87d24500ab009$var$Change.childRemovedChange(childKey, oldChange.oldSnap));
            else if (type === $d1f87d24500ab009$var$Change.CHILD_CHANGED && oldType === $d1f87d24500ab009$var$Change.CHILD_ADDED) this.changeMap.set(childKey, $d1f87d24500ab009$var$Change.childAddedChange(childKey, change.snapshotNode));
            else if (type === $d1f87d24500ab009$var$Change.CHILD_CHANGED && oldType === $d1f87d24500ab009$var$Change.CHILD_CHANGED) this.changeMap.set(childKey, $d1f87d24500ab009$var$Change.childChangedChange(childKey, change.snapshotNode, oldChange.oldSnap));
            else throw $01sTD.assertionError("Illegal combination of changes: " + change + " occurred after " + oldChange);
        } else this.changeMap.set(childKey, change);
    };
    ChildChangeAccumulator.prototype.getChanges = function() {
        return Array.from(this.changeMap.values());
    };
    return ChildChangeAccumulator;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An implementation of CompleteChildSource that never returns any additional children
 *
 * @private
 * @constructor
 * @implements CompleteChildSource
 */ // eslint-disable-next-line @typescript-eslint/naming-convention
var $d1f87d24500ab009$var$NoCompleteChildSource_ = /** @class */ function() {
    function NoCompleteChildSource_() {}
    /**
     * @inheritDoc
     */ NoCompleteChildSource_.prototype.getCompleteChild = function(childKey) {
        return null;
    };
    /**
     * @inheritDoc
     */ NoCompleteChildSource_.prototype.getChildAfterChild = function(index, child, reverse) {
        return null;
    };
    return NoCompleteChildSource_;
}();
/**
 * Singleton instance.
 * @const
 * @type {!CompleteChildSource}
 */ var $d1f87d24500ab009$var$NO_COMPLETE_CHILD_SOURCE = new $d1f87d24500ab009$var$NoCompleteChildSource_();
/**
 * An implementation of CompleteChildSource that uses a WriteTree in addition to any other server data or
 * old event caches available to calculate complete children.
 *
 *
 * @implements CompleteChildSource
 */ var $d1f87d24500ab009$var$WriteTreeCompleteChildSource = /** @class */ function() {
    /**
     * @param {!WriteTreeRef} writes_
     * @param {!ViewCache} viewCache_
     * @param {?Node} optCompleteServerCache_
     */ function WriteTreeCompleteChildSource(writes_, viewCache_, optCompleteServerCache_) {
        if (optCompleteServerCache_ === void 0) optCompleteServerCache_ = null;
        this.writes_ = writes_;
        this.viewCache_ = viewCache_;
        this.optCompleteServerCache_ = optCompleteServerCache_;
    }
    /**
     * @inheritDoc
     */ WriteTreeCompleteChildSource.prototype.getCompleteChild = function(childKey) {
        var node = this.viewCache_.getEventCache();
        if (node.isCompleteForChild(childKey)) return node.getNode().getImmediateChild(childKey);
        else {
            var serverNode = this.optCompleteServerCache_ != null ? new $d1f87d24500ab009$var$CacheNode(this.optCompleteServerCache_, true, false) : this.viewCache_.getServerCache();
            return this.writes_.calcCompleteChild(childKey, serverNode);
        }
    };
    /**
     * @inheritDoc
     */ WriteTreeCompleteChildSource.prototype.getChildAfterChild = function(index, child, reverse) {
        var completeServerData = this.optCompleteServerCache_ != null ? this.optCompleteServerCache_ : this.viewCache_.getCompleteServerSnap();
        var nodes = this.writes_.calcIndexedSlice(completeServerData, child, 1, reverse, index);
        if (nodes.length === 0) return null;
        else return nodes[0];
    };
    return WriteTreeCompleteChildSource;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @constructor
 * @struct
 */ var $d1f87d24500ab009$var$ProcessorResult = /** @class */ function() {
    /**
     * @param {!ViewCache} viewCache
     * @param {!Array.<!Change>} changes
     */ function ProcessorResult(viewCache, changes) {
        this.viewCache = viewCache;
        this.changes = changes;
    }
    return ProcessorResult;
}();
/**
 * @constructor
 */ var $d1f87d24500ab009$var$ViewProcessor = /** @class */ function() {
    /**
     * @param {!NodeFilter} filter_
     */ function ViewProcessor(filter_) {
        this.filter_ = filter_;
    }
    /**
     * @param {!ViewCache} viewCache
     */ ViewProcessor.prototype.assertIndexed = function(viewCache) {
        $01sTD.assert(viewCache.getEventCache().getNode().isIndexed(this.filter_.getIndex()), "Event snap not indexed");
        $01sTD.assert(viewCache.getServerCache().getNode().isIndexed(this.filter_.getIndex()), "Server snap not indexed");
    };
    /**
     * @param {!ViewCache} oldViewCache
     * @param {!Operation} operation
     * @param {!WriteTreeRef} writesCache
     * @param {?Node} completeCache
     * @return {!ProcessorResult}
     */ ViewProcessor.prototype.applyOperation = function(oldViewCache, operation, writesCache, completeCache) {
        var accumulator = new $d1f87d24500ab009$var$ChildChangeAccumulator();
        var newViewCache, filterServerNode;
        if (operation.type === $d1f87d24500ab009$var$OperationType.OVERWRITE) {
            var overwrite = operation;
            if (overwrite.source.fromUser) newViewCache = this.applyUserOverwrite_(oldViewCache, overwrite.path, overwrite.snap, writesCache, completeCache, accumulator);
            else {
                $01sTD.assert(overwrite.source.fromServer, "Unknown source.");
                // We filter the node if it's a tagged update or the node has been previously filtered  and the
                // update is not at the root in which case it is ok (and necessary) to mark the node unfiltered
                // again
                filterServerNode = overwrite.source.tagged || oldViewCache.getServerCache().isFiltered() && !overwrite.path.isEmpty();
                newViewCache = this.applyServerOverwrite_(oldViewCache, overwrite.path, overwrite.snap, writesCache, completeCache, filterServerNode, accumulator);
            }
        } else if (operation.type === $d1f87d24500ab009$var$OperationType.MERGE) {
            var merge = operation;
            if (merge.source.fromUser) newViewCache = this.applyUserMerge_(oldViewCache, merge.path, merge.children, writesCache, completeCache, accumulator);
            else {
                $01sTD.assert(merge.source.fromServer, "Unknown source.");
                // We filter the node if it's a tagged update or the node has been previously filtered
                filterServerNode = merge.source.tagged || oldViewCache.getServerCache().isFiltered();
                newViewCache = this.applyServerMerge_(oldViewCache, merge.path, merge.children, writesCache, completeCache, filterServerNode, accumulator);
            }
        } else if (operation.type === $d1f87d24500ab009$var$OperationType.ACK_USER_WRITE) {
            var ackUserWrite = operation;
            if (!ackUserWrite.revert) newViewCache = this.ackUserWrite_(oldViewCache, ackUserWrite.path, ackUserWrite.affectedTree, writesCache, completeCache, accumulator);
            else newViewCache = this.revertUserWrite_(oldViewCache, ackUserWrite.path, writesCache, completeCache, accumulator);
        } else if (operation.type === $d1f87d24500ab009$var$OperationType.LISTEN_COMPLETE) newViewCache = this.listenComplete_(oldViewCache, operation.path, writesCache, accumulator);
        else throw $01sTD.assertionError("Unknown operation type: " + operation.type);
        var changes = accumulator.getChanges();
        ViewProcessor.maybeAddValueEvent_(oldViewCache, newViewCache, changes);
        return new $d1f87d24500ab009$var$ProcessorResult(newViewCache, changes);
    };
    /**
     * @param {!ViewCache} oldViewCache
     * @param {!ViewCache} newViewCache
     * @param {!Array.<!Change>} accumulator
     * @private
     */ ViewProcessor.maybeAddValueEvent_ = function(oldViewCache, newViewCache, accumulator) {
        var eventSnap = newViewCache.getEventCache();
        if (eventSnap.isFullyInitialized()) {
            var isLeafOrEmpty = eventSnap.getNode().isLeafNode() || eventSnap.getNode().isEmpty();
            var oldCompleteSnap = oldViewCache.getCompleteEventSnap();
            if (accumulator.length > 0 || !oldViewCache.getEventCache().isFullyInitialized() || isLeafOrEmpty && !eventSnap.getNode().equals(/** @type {!Node} */ oldCompleteSnap) || !eventSnap.getNode().getPriority().equals(oldCompleteSnap.getPriority())) accumulator.push($d1f87d24500ab009$var$Change.valueChange(/** @type {!Node} */ newViewCache.getCompleteEventSnap()));
        }
    };
    /**
     * @param {!ViewCache} viewCache
     * @param {!Path} changePath
     * @param {!WriteTreeRef} writesCache
     * @param {!CompleteChildSource} source
     * @param {!ChildChangeAccumulator} accumulator
     * @return {!ViewCache}
     * @private
     */ ViewProcessor.prototype.generateEventCacheAfterServerEvent_ = function(viewCache, changePath, writesCache, source, accumulator) {
        var oldEventSnap = viewCache.getEventCache();
        if (writesCache.shadowingWrite(changePath) != null) // we have a shadowing write, ignore changes
        return viewCache;
        else {
            var newEventCache = void 0, serverNode = void 0;
            if (changePath.isEmpty()) {
                // TODO: figure out how this plays with "sliding ack windows"
                $01sTD.assert(viewCache.getServerCache().isFullyInitialized(), "If change path is empty, we must have complete server data");
                if (viewCache.getServerCache().isFiltered()) {
                    // We need to special case this, because we need to only apply writes to complete children, or
                    // we might end up raising events for incomplete children. If the server data is filtered deep
                    // writes cannot be guaranteed to be complete
                    var serverCache = viewCache.getCompleteServerSnap();
                    var completeChildren = serverCache instanceof $d1f87d24500ab009$var$ChildrenNode ? serverCache : $d1f87d24500ab009$var$ChildrenNode.EMPTY_NODE;
                    var completeEventChildren = writesCache.calcCompleteEventChildren(completeChildren);
                    newEventCache = this.filter_.updateFullNode(viewCache.getEventCache().getNode(), completeEventChildren, accumulator);
                } else {
                    var completeNode = writesCache.calcCompleteEventCache(viewCache.getCompleteServerSnap());
                    newEventCache = this.filter_.updateFullNode(viewCache.getEventCache().getNode(), completeNode, accumulator);
                }
            } else {
                var childKey = changePath.getFront();
                if (childKey === ".priority") {
                    $01sTD.assert(changePath.getLength() === 1, "Can't have a priority with additional path components");
                    var oldEventNode = oldEventSnap.getNode();
                    serverNode = viewCache.getServerCache().getNode();
                    // we might have overwrites for this priority
                    var updatedPriority = writesCache.calcEventCacheAfterServerOverwrite(changePath, oldEventNode, serverNode);
                    if (updatedPriority != null) newEventCache = this.filter_.updatePriority(oldEventNode, updatedPriority);
                    else // priority didn't change, keep old node
                    newEventCache = oldEventSnap.getNode();
                } else {
                    var childChangePath = changePath.popFront();
                    // update child
                    var newEventChild = void 0;
                    if (oldEventSnap.isCompleteForChild(childKey)) {
                        serverNode = viewCache.getServerCache().getNode();
                        var eventChildUpdate = writesCache.calcEventCacheAfterServerOverwrite(changePath, oldEventSnap.getNode(), serverNode);
                        if (eventChildUpdate != null) newEventChild = oldEventSnap.getNode().getImmediateChild(childKey).updateChild(childChangePath, eventChildUpdate);
                        else // Nothing changed, just keep the old child
                        newEventChild = oldEventSnap.getNode().getImmediateChild(childKey);
                    } else newEventChild = writesCache.calcCompleteChild(childKey, viewCache.getServerCache());
                    if (newEventChild != null) newEventCache = this.filter_.updateChild(oldEventSnap.getNode(), childKey, newEventChild, childChangePath, source, accumulator);
                    else // no complete child available or no change
                    newEventCache = oldEventSnap.getNode();
                }
            }
            return viewCache.updateEventSnap(newEventCache, oldEventSnap.isFullyInitialized() || changePath.isEmpty(), this.filter_.filtersNodes());
        }
    };
    /**
     * @param {!ViewCache} oldViewCache
     * @param {!Path} changePath
     * @param {!Node} changedSnap
     * @param {!WriteTreeRef} writesCache
     * @param {?Node} completeCache
     * @param {boolean} filterServerNode
     * @param {!ChildChangeAccumulator} accumulator
     * @return {!ViewCache}
     * @private
     */ ViewProcessor.prototype.applyServerOverwrite_ = function(oldViewCache, changePath, changedSnap, writesCache, completeCache, filterServerNode, accumulator) {
        var oldServerSnap = oldViewCache.getServerCache();
        var newServerCache;
        var serverFilter = filterServerNode ? this.filter_ : this.filter_.getIndexedFilter();
        if (changePath.isEmpty()) newServerCache = serverFilter.updateFullNode(oldServerSnap.getNode(), changedSnap, null);
        else if (serverFilter.filtersNodes() && !oldServerSnap.isFiltered()) {
            // we want to filter the server node, but we didn't filter the server node yet, so simulate a full update
            var newServerNode = oldServerSnap.getNode().updateChild(changePath, changedSnap);
            newServerCache = serverFilter.updateFullNode(oldServerSnap.getNode(), newServerNode, null);
        } else {
            var childKey = changePath.getFront();
            if (!oldServerSnap.isCompleteForPath(changePath) && changePath.getLength() > 1) // We don't update incomplete nodes with updates intended for other listeners
            return oldViewCache;
            var childChangePath = changePath.popFront();
            var childNode = oldServerSnap.getNode().getImmediateChild(childKey);
            var newChildNode = childNode.updateChild(childChangePath, changedSnap);
            if (childKey === ".priority") newServerCache = serverFilter.updatePriority(oldServerSnap.getNode(), newChildNode);
            else newServerCache = serverFilter.updateChild(oldServerSnap.getNode(), childKey, newChildNode, childChangePath, $d1f87d24500ab009$var$NO_COMPLETE_CHILD_SOURCE, null);
        }
        var newViewCache = oldViewCache.updateServerSnap(newServerCache, oldServerSnap.isFullyInitialized() || changePath.isEmpty(), serverFilter.filtersNodes());
        var source = new $d1f87d24500ab009$var$WriteTreeCompleteChildSource(writesCache, newViewCache, completeCache);
        return this.generateEventCacheAfterServerEvent_(newViewCache, changePath, writesCache, source, accumulator);
    };
    /**
     * @param {!ViewCache} oldViewCache
     * @param {!Path} changePath
     * @param {!Node} changedSnap
     * @param {!WriteTreeRef} writesCache
     * @param {?Node} completeCache
     * @param {!ChildChangeAccumulator} accumulator
     * @return {!ViewCache}
     * @private
     */ ViewProcessor.prototype.applyUserOverwrite_ = function(oldViewCache, changePath, changedSnap, writesCache, completeCache, accumulator) {
        var oldEventSnap = oldViewCache.getEventCache();
        var newViewCache, newEventCache;
        var source = new $d1f87d24500ab009$var$WriteTreeCompleteChildSource(writesCache, oldViewCache, completeCache);
        if (changePath.isEmpty()) {
            newEventCache = this.filter_.updateFullNode(oldViewCache.getEventCache().getNode(), changedSnap, accumulator);
            newViewCache = oldViewCache.updateEventSnap(newEventCache, true, this.filter_.filtersNodes());
        } else {
            var childKey = changePath.getFront();
            if (childKey === ".priority") {
                newEventCache = this.filter_.updatePriority(oldViewCache.getEventCache().getNode(), changedSnap);
                newViewCache = oldViewCache.updateEventSnap(newEventCache, oldEventSnap.isFullyInitialized(), oldEventSnap.isFiltered());
            } else {
                var childChangePath = changePath.popFront();
                var oldChild = oldEventSnap.getNode().getImmediateChild(childKey);
                var newChild = void 0;
                if (childChangePath.isEmpty()) // Child overwrite, we can replace the child
                newChild = changedSnap;
                else {
                    var childNode = source.getCompleteChild(childKey);
                    if (childNode != null) {
                        if (childChangePath.getBack() === ".priority" && childNode.getChild(childChangePath.parent()).isEmpty()) // This is a priority update on an empty node. If this node exists on the server, the
                        // server will send down the priority in the update, so ignore for now
                        newChild = childNode;
                        else newChild = childNode.updateChild(childChangePath, changedSnap);
                    } else // There is no complete child node available
                    newChild = $d1f87d24500ab009$var$ChildrenNode.EMPTY_NODE;
                }
                if (!oldChild.equals(newChild)) {
                    var newEventSnap = this.filter_.updateChild(oldEventSnap.getNode(), childKey, newChild, childChangePath, source, accumulator);
                    newViewCache = oldViewCache.updateEventSnap(newEventSnap, oldEventSnap.isFullyInitialized(), this.filter_.filtersNodes());
                } else newViewCache = oldViewCache;
            }
        }
        return newViewCache;
    };
    /**
     * @param {!ViewCache} viewCache
     * @param {string} childKey
     * @return {boolean}
     * @private
     */ ViewProcessor.cacheHasChild_ = function(viewCache, childKey) {
        return viewCache.getEventCache().isCompleteForChild(childKey);
    };
    /**
     * @param {!ViewCache} viewCache
     * @param {!Path} path
     * @param {ImmutableTree.<!Node>} changedChildren
     * @param {!WriteTreeRef} writesCache
     * @param {?Node} serverCache
     * @param {!ChildChangeAccumulator} accumulator
     * @return {!ViewCache}
     * @private
     */ ViewProcessor.prototype.applyUserMerge_ = function(viewCache, path, changedChildren, writesCache, serverCache, accumulator) {
        var _this = this;
        // HACK: In the case of a limit query, there may be some changes that bump things out of the
        // window leaving room for new items.  It's important we process these changes first, so we
        // iterate the changes twice, first processing any that affect items currently in view.
        // TODO: I consider an item "in view" if cacheHasChild is true, which checks both the server
        // and event snap.  I'm not sure if this will result in edge cases when a child is in one but
        // not the other.
        var curViewCache = viewCache;
        changedChildren.foreach(function(relativePath, childNode) {
            var writePath = path.child(relativePath);
            if (ViewProcessor.cacheHasChild_(viewCache, writePath.getFront())) curViewCache = _this.applyUserOverwrite_(curViewCache, writePath, childNode, writesCache, serverCache, accumulator);
        });
        changedChildren.foreach(function(relativePath, childNode) {
            var writePath = path.child(relativePath);
            if (!ViewProcessor.cacheHasChild_(viewCache, writePath.getFront())) curViewCache = _this.applyUserOverwrite_(curViewCache, writePath, childNode, writesCache, serverCache, accumulator);
        });
        return curViewCache;
    };
    /**
     * @param {!Node} node
     * @param {ImmutableTree.<!Node>} merge
     * @return {!Node}
     * @private
     */ ViewProcessor.prototype.applyMerge_ = function(node, merge) {
        merge.foreach(function(relativePath, childNode) {
            node = node.updateChild(relativePath, childNode);
        });
        return node;
    };
    /**
     * @param {!ViewCache} viewCache
     * @param {!Path} path
     * @param {!ImmutableTree.<!Node>} changedChildren
     * @param {!WriteTreeRef} writesCache
     * @param {?Node} serverCache
     * @param {boolean} filterServerNode
     * @param {!ChildChangeAccumulator} accumulator
     * @return {!ViewCache}
     * @private
     */ ViewProcessor.prototype.applyServerMerge_ = function(viewCache, path, changedChildren, writesCache, serverCache, filterServerNode, accumulator) {
        var _this = this;
        // If we don't have a cache yet, this merge was intended for a previously listen in the same location. Ignore it and
        // wait for the complete data update coming soon.
        if (viewCache.getServerCache().getNode().isEmpty() && !viewCache.getServerCache().isFullyInitialized()) return viewCache;
        // HACK: In the case of a limit query, there may be some changes that bump things out of the
        // window leaving room for new items.  It's important we process these changes first, so we
        // iterate the changes twice, first processing any that affect items currently in view.
        // TODO: I consider an item "in view" if cacheHasChild is true, which checks both the server
        // and event snap.  I'm not sure if this will result in edge cases when a child is in one but
        // not the other.
        var curViewCache = viewCache;
        var viewMergeTree;
        if (path.isEmpty()) viewMergeTree = changedChildren;
        else viewMergeTree = $d1f87d24500ab009$var$ImmutableTree.Empty.setTree(path, changedChildren);
        var serverNode = viewCache.getServerCache().getNode();
        viewMergeTree.children.inorderTraversal(function(childKey, childTree) {
            if (serverNode.hasChild(childKey)) {
                var serverChild = viewCache.getServerCache().getNode().getImmediateChild(childKey);
                var newChild = _this.applyMerge_(serverChild, childTree);
                curViewCache = _this.applyServerOverwrite_(curViewCache, new $d1f87d24500ab009$var$Path(childKey), newChild, writesCache, serverCache, filterServerNode, accumulator);
            }
        });
        viewMergeTree.children.inorderTraversal(function(childKey, childMergeTree) {
            var isUnknownDeepMerge = !viewCache.getServerCache().isCompleteForChild(childKey) && childMergeTree.value == null;
            if (!serverNode.hasChild(childKey) && !isUnknownDeepMerge) {
                var serverChild = viewCache.getServerCache().getNode().getImmediateChild(childKey);
                var newChild = _this.applyMerge_(serverChild, childMergeTree);
                curViewCache = _this.applyServerOverwrite_(curViewCache, new $d1f87d24500ab009$var$Path(childKey), newChild, writesCache, serverCache, filterServerNode, accumulator);
            }
        });
        return curViewCache;
    };
    /**
     * @param {!ViewCache} viewCache
     * @param {!Path} ackPath
     * @param {!ImmutableTree<!boolean>} affectedTree
     * @param {!WriteTreeRef} writesCache
     * @param {?Node} completeCache
     * @param {!ChildChangeAccumulator} accumulator
     * @return {!ViewCache}
     * @private
     */ ViewProcessor.prototype.ackUserWrite_ = function(viewCache, ackPath, affectedTree, writesCache, completeCache, accumulator) {
        if (writesCache.shadowingWrite(ackPath) != null) return viewCache;
        // Only filter server node if it is currently filtered
        var filterServerNode = viewCache.getServerCache().isFiltered();
        // Essentially we'll just get our existing server cache for the affected paths and re-apply it as a server update
        // now that it won't be shadowed.
        var serverCache = viewCache.getServerCache();
        if (affectedTree.value != null) {
            // This is an overwrite.
            if (ackPath.isEmpty() && serverCache.isFullyInitialized() || serverCache.isCompleteForPath(ackPath)) return this.applyServerOverwrite_(viewCache, ackPath, serverCache.getNode().getChild(ackPath), writesCache, completeCache, filterServerNode, accumulator);
            else if (ackPath.isEmpty()) {
                // This is a goofy edge case where we are acking data at this location but don't have full data.  We
                // should just re-apply whatever we have in our cache as a merge.
                var changedChildren_1 = $d1f87d24500ab009$var$ImmutableTree.Empty;
                serverCache.getNode().forEachChild($d1f87d24500ab009$var$KEY_INDEX, function(name, node) {
                    changedChildren_1 = changedChildren_1.set(new $d1f87d24500ab009$var$Path(name), node);
                });
                return this.applyServerMerge_(viewCache, ackPath, changedChildren_1, writesCache, completeCache, filterServerNode, accumulator);
            } else return viewCache;
        } else {
            // This is a merge.
            var changedChildren_2 = $d1f87d24500ab009$var$ImmutableTree.Empty;
            affectedTree.foreach(function(mergePath, value) {
                var serverCachePath = ackPath.child(mergePath);
                if (serverCache.isCompleteForPath(serverCachePath)) changedChildren_2 = changedChildren_2.set(mergePath, serverCache.getNode().getChild(serverCachePath));
            });
            return this.applyServerMerge_(viewCache, ackPath, changedChildren_2, writesCache, completeCache, filterServerNode, accumulator);
        }
    };
    /**
     * @param {!ViewCache} viewCache
     * @param {!Path} path
     * @param {!WriteTreeRef} writesCache
     * @param {!ChildChangeAccumulator} accumulator
     * @return {!ViewCache}
     * @private
     */ ViewProcessor.prototype.listenComplete_ = function(viewCache, path, writesCache, accumulator) {
        var oldServerNode = viewCache.getServerCache();
        var newViewCache = viewCache.updateServerSnap(oldServerNode.getNode(), oldServerNode.isFullyInitialized() || path.isEmpty(), oldServerNode.isFiltered());
        return this.generateEventCacheAfterServerEvent_(newViewCache, path, writesCache, $d1f87d24500ab009$var$NO_COMPLETE_CHILD_SOURCE, accumulator);
    };
    /**
     * @param {!ViewCache} viewCache
     * @param {!Path} path
     * @param {!WriteTreeRef} writesCache
     * @param {?Node} completeServerCache
     * @param {!ChildChangeAccumulator} accumulator
     * @return {!ViewCache}
     * @private
     */ ViewProcessor.prototype.revertUserWrite_ = function(viewCache, path, writesCache, completeServerCache, accumulator) {
        var complete;
        if (writesCache.shadowingWrite(path) != null) return viewCache;
        else {
            var source = new $d1f87d24500ab009$var$WriteTreeCompleteChildSource(writesCache, viewCache, completeServerCache);
            var oldEventCache = viewCache.getEventCache().getNode();
            var newEventCache = void 0;
            if (path.isEmpty() || path.getFront() === ".priority") {
                var newNode = void 0;
                if (viewCache.getServerCache().isFullyInitialized()) newNode = writesCache.calcCompleteEventCache(viewCache.getCompleteServerSnap());
                else {
                    var serverChildren = viewCache.getServerCache().getNode();
                    $01sTD.assert(serverChildren instanceof $d1f87d24500ab009$var$ChildrenNode, "serverChildren would be complete if leaf node");
                    newNode = writesCache.calcCompleteEventChildren(serverChildren);
                }
                newNode;
                newEventCache = this.filter_.updateFullNode(oldEventCache, newNode, accumulator);
            } else {
                var childKey = path.getFront();
                var newChild = writesCache.calcCompleteChild(childKey, viewCache.getServerCache());
                if (newChild == null && viewCache.getServerCache().isCompleteForChild(childKey)) newChild = oldEventCache.getImmediateChild(childKey);
                if (newChild != null) newEventCache = this.filter_.updateChild(oldEventCache, childKey, newChild, path.popFront(), source, accumulator);
                else if (viewCache.getEventCache().getNode().hasChild(childKey)) // No complete child available, delete the existing one, if any
                newEventCache = this.filter_.updateChild(oldEventCache, childKey, $d1f87d24500ab009$var$ChildrenNode.EMPTY_NODE, path.popFront(), source, accumulator);
                else newEventCache = oldEventCache;
                if (newEventCache.isEmpty() && viewCache.getServerCache().isFullyInitialized()) {
                    // We might have reverted all child writes. Maybe the old event was a leaf node
                    complete = writesCache.calcCompleteEventCache(viewCache.getCompleteServerSnap());
                    if (complete.isLeafNode()) newEventCache = this.filter_.updateFullNode(newEventCache, complete, accumulator);
                }
            }
            complete = viewCache.getServerCache().isFullyInitialized() || writesCache.shadowingWrite($d1f87d24500ab009$var$Path.Empty) != null;
            return viewCache.updateEventSnap(newEventCache, complete, this.filter_.filtersNodes());
        }
    };
    return ViewProcessor;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An EventGenerator is used to convert "raw" changes (Change) as computed by the
 * CacheDiffer into actual events (Event) that can be raised.  See generateEventsForChanges()
 * for details.
 *
 * @constructor
 */ var $d1f87d24500ab009$var$EventGenerator = /** @class */ function() {
    /**
     *
     * @param {!Query} query_
     */ function EventGenerator(query_) {
        this.query_ = query_;
        /**
         * @private
         * @type {!Index}
         */ this.index_ = this.query_.getQueryParams().getIndex();
    }
    /**
     * Given a set of raw changes (no moved events and prevName not specified yet), and a set of
     * EventRegistrations that should be notified of these changes, generate the actual events to be raised.
     *
     * Notes:
     *  - child_moved events will be synthesized at this time for any child_changed events that affect
     *    our index.
     *  - prevName will be calculated based on the index ordering.
     *
     * @param {!Array.<!Change>} changes
     * @param {!Node} eventCache
     * @param {!Array.<!EventRegistration>} eventRegistrations
     * @return {!Array.<!Event>}
     */ EventGenerator.prototype.generateEventsForChanges = function(changes, eventCache, eventRegistrations) {
        var _this = this;
        var events = [];
        var moves = [];
        changes.forEach(function(change) {
            if (change.type === $d1f87d24500ab009$var$Change.CHILD_CHANGED && _this.index_.indexedValueChanged(change.oldSnap, change.snapshotNode)) moves.push($d1f87d24500ab009$var$Change.childMovedChange(change.childName, change.snapshotNode));
        });
        this.generateEventsForType_(events, $d1f87d24500ab009$var$Change.CHILD_REMOVED, changes, eventRegistrations, eventCache);
        this.generateEventsForType_(events, $d1f87d24500ab009$var$Change.CHILD_ADDED, changes, eventRegistrations, eventCache);
        this.generateEventsForType_(events, $d1f87d24500ab009$var$Change.CHILD_MOVED, moves, eventRegistrations, eventCache);
        this.generateEventsForType_(events, $d1f87d24500ab009$var$Change.CHILD_CHANGED, changes, eventRegistrations, eventCache);
        this.generateEventsForType_(events, $d1f87d24500ab009$var$Change.VALUE, changes, eventRegistrations, eventCache);
        return events;
    };
    /**
     * Given changes of a single change type, generate the corresponding events.
     *
     * @param {!Array.<!Event>} events
     * @param {!string} eventType
     * @param {!Array.<!Change>} changes
     * @param {!Array.<!EventRegistration>} registrations
     * @param {!Node} eventCache
     * @private
     */ EventGenerator.prototype.generateEventsForType_ = function(events, eventType, changes, registrations, eventCache) {
        var _this = this;
        var filteredChanges = changes.filter(function(change) {
            return change.type === eventType;
        });
        filteredChanges.sort(this.compareChanges_.bind(this));
        filteredChanges.forEach(function(change) {
            var materializedChange = _this.materializeSingleChange_(change, eventCache);
            registrations.forEach(function(registration) {
                if (registration.respondsTo(change.type)) events.push(registration.createEvent(materializedChange, _this.query_));
            });
        });
    };
    /**
     * @param {!Change} change
     * @param {!Node} eventCache
     * @return {!Change}
     * @private
     */ EventGenerator.prototype.materializeSingleChange_ = function(change, eventCache) {
        if (change.type === "value" || change.type === "child_removed") return change;
        else {
            change.prevName = eventCache.getPredecessorChildName(/** @type {!string} */ change.childName, change.snapshotNode, this.index_);
            return change;
        }
    };
    /**
     * @param {!Change} a
     * @param {!Change} b
     * @return {number}
     * @private
     */ EventGenerator.prototype.compareChanges_ = function(a, b) {
        if (a.childName == null || b.childName == null) throw $01sTD.assertionError("Should only compare child_ events.");
        var aWrapped = new $d1f87d24500ab009$var$NamedNode(a.childName, a.snapshotNode);
        var bWrapped = new $d1f87d24500ab009$var$NamedNode(b.childName, b.snapshotNode);
        return this.index_.compare(aWrapped, bWrapped);
    };
    return EventGenerator;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A view represents a specific location and query that has 1 or more event registrations.
 *
 * It does several things:
 *  - Maintains the list of event registrations for this location/query.
 *  - Maintains a cache of the data visible for this location/query.
 *  - Applies new operations (via applyOperation), updates the cache, and based on the event
 *    registrations returns the set of events to be raised.
 * @constructor
 */ var $d1f87d24500ab009$var$View = /** @class */ function() {
    /**
     *
     * @param {!Query} query_
     * @param {!ViewCache} initialViewCache
     */ function View(query_, initialViewCache) {
        this.query_ = query_;
        this.eventRegistrations_ = [];
        var params = this.query_.getQueryParams();
        var indexFilter = new $d1f87d24500ab009$var$IndexedFilter(params.getIndex());
        var filter = params.getNodeFilter();
        /**
         * @type {ViewProcessor}
         * @private
         */ this.processor_ = new $d1f87d24500ab009$var$ViewProcessor(filter);
        var initialServerCache = initialViewCache.getServerCache();
        var initialEventCache = initialViewCache.getEventCache();
        // Don't filter server node with other filter than index, wait for tagged listen
        var serverSnap = indexFilter.updateFullNode($d1f87d24500ab009$var$ChildrenNode.EMPTY_NODE, initialServerCache.getNode(), null);
        var eventSnap = filter.updateFullNode($d1f87d24500ab009$var$ChildrenNode.EMPTY_NODE, initialEventCache.getNode(), null);
        var newServerCache = new $d1f87d24500ab009$var$CacheNode(serverSnap, initialServerCache.isFullyInitialized(), indexFilter.filtersNodes());
        var newEventCache = new $d1f87d24500ab009$var$CacheNode(eventSnap, initialEventCache.isFullyInitialized(), filter.filtersNodes());
        /**
         * @type {!ViewCache}
         * @private
         */ this.viewCache_ = new $d1f87d24500ab009$var$ViewCache(newEventCache, newServerCache);
        /**
         * @type {!EventGenerator}
         * @private
         */ this.eventGenerator_ = new $d1f87d24500ab009$var$EventGenerator(this.query_);
    }
    /**
     * @return {!Query}
     */ View.prototype.getQuery = function() {
        return this.query_;
    };
    /**
     * @return {?Node}
     */ View.prototype.getServerCache = function() {
        return this.viewCache_.getServerCache().getNode();
    };
    /**
     * @param {!Path} path
     * @return {?Node}
     */ View.prototype.getCompleteServerCache = function(path) {
        var cache = this.viewCache_.getCompleteServerSnap();
        if (cache) {
            // If this isn't a "loadsAllData" view, then cache isn't actually a complete cache and
            // we need to see if it contains the child we're interested in.
            if (this.query_.getQueryParams().loadsAllData() || !path.isEmpty() && !cache.getImmediateChild(path.getFront()).isEmpty()) return cache.getChild(path);
        }
        return null;
    };
    /**
     * @return {boolean}
     */ View.prototype.isEmpty = function() {
        return this.eventRegistrations_.length === 0;
    };
    /**
     * @param {!EventRegistration} eventRegistration
     */ View.prototype.addEventRegistration = function(eventRegistration) {
        this.eventRegistrations_.push(eventRegistration);
    };
    /**
     * @param {?EventRegistration} eventRegistration If null, remove all callbacks.
     * @param {Error=} cancelError If a cancelError is provided, appropriate cancel events will be returned.
     * @return {!Array.<!Event>} Cancel events, if cancelError was provided.
     */ View.prototype.removeEventRegistration = function(eventRegistration, cancelError) {
        var cancelEvents = [];
        if (cancelError) {
            $01sTD.assert(eventRegistration == null, "A cancel should cancel all event registrations.");
            var path_1 = this.query_.path;
            this.eventRegistrations_.forEach(function(registration) {
                cancelError;
                var maybeEvent = registration.createCancelEvent(cancelError, path_1);
                if (maybeEvent) cancelEvents.push(maybeEvent);
            });
        }
        if (eventRegistration) {
            var remaining = [];
            for(var i = 0; i < this.eventRegistrations_.length; ++i){
                var existing = this.eventRegistrations_[i];
                if (!existing.matches(eventRegistration)) remaining.push(existing);
                else if (eventRegistration.hasAnyCallback()) {
                    // We're removing just this one
                    remaining = remaining.concat(this.eventRegistrations_.slice(i + 1));
                    break;
                }
            }
            this.eventRegistrations_ = remaining;
        } else this.eventRegistrations_ = [];
        return cancelEvents;
    };
    /**
     * Applies the given Operation, updates our cache, and returns the appropriate events.
     *
     * @param {!Operation} operation
     * @param {!WriteTreeRef} writesCache
     * @param {?Node} completeServerCache
     * @return {!Array.<!Event>}
     */ View.prototype.applyOperation = function(operation, writesCache, completeServerCache) {
        if (operation.type === $d1f87d24500ab009$var$OperationType.MERGE && operation.source.queryId !== null) {
            $01sTD.assert(this.viewCache_.getCompleteServerSnap(), "We should always have a full cache before handling merges");
            $01sTD.assert(this.viewCache_.getCompleteEventSnap(), "Missing event cache, even though we have a server cache");
        }
        var oldViewCache = this.viewCache_;
        var result = this.processor_.applyOperation(oldViewCache, operation, writesCache, completeServerCache);
        this.processor_.assertIndexed(result.viewCache);
        $01sTD.assert(result.viewCache.getServerCache().isFullyInitialized() || !oldViewCache.getServerCache().isFullyInitialized(), "Once a server snap is complete, it should never go back");
        this.viewCache_ = result.viewCache;
        return this.generateEventsForChanges_(result.changes, result.viewCache.getEventCache().getNode(), null);
    };
    /**
     * @param {!EventRegistration} registration
     * @return {!Array.<!Event>}
     */ View.prototype.getInitialEvents = function(registration) {
        var eventSnap = this.viewCache_.getEventCache();
        var initialChanges = [];
        if (!eventSnap.getNode().isLeafNode()) {
            var eventNode = eventSnap.getNode();
            eventNode.forEachChild($d1f87d24500ab009$var$PRIORITY_INDEX, function(key, childNode) {
                initialChanges.push($d1f87d24500ab009$var$Change.childAddedChange(key, childNode));
            });
        }
        if (eventSnap.isFullyInitialized()) initialChanges.push($d1f87d24500ab009$var$Change.valueChange(eventSnap.getNode()));
        return this.generateEventsForChanges_(initialChanges, eventSnap.getNode(), registration);
    };
    /**
     * @private
     * @param {!Array.<!Change>} changes
     * @param {!Node} eventCache
     * @param {EventRegistration=} eventRegistration
     * @return {!Array.<!Event>}
     */ View.prototype.generateEventsForChanges_ = function(changes, eventCache, eventRegistration) {
        var registrations = eventRegistration ? [
            eventRegistration
        ] : this.eventRegistrations_;
        return this.eventGenerator_.generateEventsForChanges(changes, eventCache, registrations);
    };
    return View;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $d1f87d24500ab009$var$__referenceConstructor$1;
/**
 * SyncPoint represents a single location in a SyncTree with 1 or more event registrations, meaning we need to
 * maintain 1 or more Views at this location to cache server data and raise appropriate events for server changes
 * and user writes (set, transaction, update).
 *
 * It's responsible for:
 *  - Maintaining the set of 1 or more views necessary at this location (a SyncPoint with 0 views should be removed).
 *  - Proxying user / server operations to the views as appropriate (i.e. applyServerOverwrite,
 *    applyUserOverwrite, etc.)
 */ var $d1f87d24500ab009$var$SyncPoint = /** @class */ function() {
    function SyncPoint() {
        /**
         * The Views being tracked at this location in the tree, stored as a map where the key is a
         * queryId and the value is the View for that query.
         *
         * NOTE: This list will be quite small (usually 1, but perhaps 2 or 3; any more is an odd use case).
         */ this.views = new Map();
    }
    Object.defineProperty(SyncPoint, "__referenceConstructor", {
        get: function() {
            $01sTD.assert($d1f87d24500ab009$var$__referenceConstructor$1, "Reference.ts has not been loaded");
            return $d1f87d24500ab009$var$__referenceConstructor$1;
        },
        set: function(val) {
            $01sTD.assert(!$d1f87d24500ab009$var$__referenceConstructor$1, "__referenceConstructor has already been defined");
            $d1f87d24500ab009$var$__referenceConstructor$1 = val;
        },
        enumerable: false,
        configurable: true
    });
    SyncPoint.prototype.isEmpty = function() {
        return this.views.size === 0;
    };
    SyncPoint.prototype.applyOperation = function(operation, writesCache, optCompleteServerCache) {
        var e_1, _a;
        var queryId = operation.source.queryId;
        if (queryId !== null) {
            var view = this.views.get(queryId);
            $01sTD.assert(view != null, "SyncTree gave us an op for an invalid query.");
            return view.applyOperation(operation, writesCache, optCompleteServerCache);
        } else {
            var events = [];
            try {
                for(var _b = $a92b69d2447c208d$export$19a8beecd37a4c45(this.views.values()), _c = _b.next(); !_c.done; _c = _b.next()){
                    var view = _c.value;
                    events = events.concat(view.applyOperation(operation, writesCache, optCompleteServerCache));
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
            return events;
        }
    };
    /**
     * Add an event callback for the specified query.
     *
     * @param {!Query} query
     * @param {!EventRegistration} eventRegistration
     * @param {!WriteTreeRef} writesCache
     * @param {?Node} serverCache Complete server cache, if we have it.
     * @param {boolean} serverCacheComplete
     * @return {!Array.<!Event>} Events to raise.
     */ SyncPoint.prototype.addEventRegistration = function(query, eventRegistration, writesCache, serverCache, serverCacheComplete) {
        var queryId = query.queryIdentifier();
        var view = this.views.get(queryId);
        if (!view) {
            // TODO: make writesCache take flag for complete server node
            var eventCache = writesCache.calcCompleteEventCache(serverCacheComplete ? serverCache : null);
            var eventCacheComplete = false;
            if (eventCache) eventCacheComplete = true;
            else if (serverCache instanceof $d1f87d24500ab009$var$ChildrenNode) {
                eventCache = writesCache.calcCompleteEventChildren(serverCache);
                eventCacheComplete = false;
            } else {
                eventCache = $d1f87d24500ab009$var$ChildrenNode.EMPTY_NODE;
                eventCacheComplete = false;
            }
            var viewCache = new $d1f87d24500ab009$var$ViewCache(new $d1f87d24500ab009$var$CacheNode(/** @type {!Node} */ eventCache, eventCacheComplete, false), new $d1f87d24500ab009$var$CacheNode(/** @type {!Node} */ serverCache, serverCacheComplete, false));
            view = new $d1f87d24500ab009$var$View(query, viewCache);
            this.views.set(queryId, view);
        }
        // This is guaranteed to exist now, we just created anything that was missing
        view.addEventRegistration(eventRegistration);
        return view.getInitialEvents(eventRegistration);
    };
    /**
     * Remove event callback(s).  Return cancelEvents if a cancelError is specified.
     *
     * If query is the default query, we'll check all views for the specified eventRegistration.
     * If eventRegistration is null, we'll remove all callbacks for the specified view(s).
     *
     * @param {!Query} query
     * @param {?EventRegistration} eventRegistration If null, remove all callbacks.
     * @param {Error=} cancelError If a cancelError is provided, appropriate cancel events will be returned.
     * @return {{removed:!Array.<!Query>, events:!Array.<!Event>}} removed queries and any cancel events
     */ SyncPoint.prototype.removeEventRegistration = function(query, eventRegistration, cancelError) {
        var e_2, _a;
        var queryId = query.queryIdentifier();
        var removed = [];
        var cancelEvents = [];
        var hadCompleteView = this.hasCompleteView();
        if (queryId === "default") try {
            // When you do ref.off(...), we search all views for the registration to remove.
            for(var _b = $a92b69d2447c208d$export$19a8beecd37a4c45(this.views.entries()), _c = _b.next(); !_c.done; _c = _b.next()){
                var _d = $a92b69d2447c208d$export$8d051b38c9118094(_c.value, 2), viewQueryId = _d[0], view = _d[1];
                cancelEvents = cancelEvents.concat(view.removeEventRegistration(eventRegistration, cancelError));
                if (view.isEmpty()) {
                    this.views.delete(viewQueryId);
                    // We'll deal with complete views later.
                    if (!view.getQuery().getQueryParams().loadsAllData()) removed.push(view.getQuery());
                }
            }
        } catch (e_2_1) {
            e_2 = {
                error: e_2_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_2) throw e_2.error;
            }
        }
        else {
            // remove the callback from the specific view.
            var view = this.views.get(queryId);
            if (view) {
                cancelEvents = cancelEvents.concat(view.removeEventRegistration(eventRegistration, cancelError));
                if (view.isEmpty()) {
                    this.views.delete(queryId);
                    // We'll deal with complete views later.
                    if (!view.getQuery().getQueryParams().loadsAllData()) removed.push(view.getQuery());
                }
            }
        }
        if (hadCompleteView && !this.hasCompleteView()) // We removed our last complete view.
        removed.push(new SyncPoint.__referenceConstructor(query.repo, query.path));
        return {
            removed: removed,
            events: cancelEvents
        };
    };
    SyncPoint.prototype.getQueryViews = function() {
        var e_3, _a;
        var result = [];
        try {
            for(var _b = $a92b69d2447c208d$export$19a8beecd37a4c45(this.views.values()), _c = _b.next(); !_c.done; _c = _b.next()){
                var view = _c.value;
                if (!view.getQuery().getQueryParams().loadsAllData()) result.push(view);
            }
        } catch (e_3_1) {
            e_3 = {
                error: e_3_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_3) throw e_3.error;
            }
        }
        return result;
    };
    /**
     * @param path The path to the desired complete snapshot
     * @return A complete cache, if it exists
     */ SyncPoint.prototype.getCompleteServerCache = function(path) {
        var e_4, _a;
        var serverCache = null;
        try {
            for(var _b = $a92b69d2447c208d$export$19a8beecd37a4c45(this.views.values()), _c = _b.next(); !_c.done; _c = _b.next()){
                var view = _c.value;
                serverCache = serverCache || view.getCompleteServerCache(path);
            }
        } catch (e_4_1) {
            e_4 = {
                error: e_4_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_4) throw e_4.error;
            }
        }
        return serverCache;
    };
    SyncPoint.prototype.viewForQuery = function(query) {
        var params = query.getQueryParams();
        if (params.loadsAllData()) return this.getCompleteView();
        else {
            var queryId = query.queryIdentifier();
            return this.views.get(queryId);
        }
    };
    SyncPoint.prototype.viewExistsForQuery = function(query) {
        return this.viewForQuery(query) != null;
    };
    SyncPoint.prototype.hasCompleteView = function() {
        return this.getCompleteView() != null;
    };
    SyncPoint.prototype.getCompleteView = function() {
        var e_5, _a;
        try {
            for(var _b = $a92b69d2447c208d$export$19a8beecd37a4c45(this.views.values()), _c = _b.next(); !_c.done; _c = _b.next()){
                var view = _c.value;
                if (view.getQuery().getQueryParams().loadsAllData()) return view;
            }
        } catch (e_5_1) {
            e_5 = {
                error: e_5_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_5) throw e_5.error;
            }
        }
        return null;
    };
    return SyncPoint;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * This class holds a collection of writes that can be applied to nodes in unison. It abstracts away the logic with
 * dealing with priority writes and multiple nested writes. At any given path there is only allowed to be one write
 * modifying that path. Any write to an existing path or shadowing an existing path will modify that existing write
 * to reflect the write added.
 */ var $d1f87d24500ab009$var$CompoundWrite = /** @class */ function() {
    function CompoundWrite(writeTree_) {
        this.writeTree_ = writeTree_;
    }
    CompoundWrite.prototype.addWrite = function(path, node) {
        if (path.isEmpty()) return new CompoundWrite(new $d1f87d24500ab009$var$ImmutableTree(node));
        else {
            var rootmost = this.writeTree_.findRootMostValueAndPath(path);
            if (rootmost != null) {
                var rootMostPath = rootmost.path;
                var value = rootmost.value;
                var relativePath = $d1f87d24500ab009$var$Path.relativePath(rootMostPath, path);
                value = value.updateChild(relativePath, node);
                return new CompoundWrite(this.writeTree_.set(rootMostPath, value));
            } else {
                var subtree = new $d1f87d24500ab009$var$ImmutableTree(node);
                var newWriteTree = this.writeTree_.setTree(path, subtree);
                return new CompoundWrite(newWriteTree);
            }
        }
    };
    CompoundWrite.prototype.addWrites = function(path, updates) {
        var newWrite = this;
        $d1f87d24500ab009$var$each(updates, function(childKey, node) {
            newWrite = newWrite.addWrite(path.child(childKey), node);
        });
        return newWrite;
    };
    /**
     * Will remove a write at the given path and deeper paths. This will <em>not</em> modify a write at a higher
     * location, which must be removed by calling this method with that path.
     *
     * @param path The path at which a write and all deeper writes should be removed
     * @return {!CompoundWrite} The new CompoundWrite with the removed path
     */ CompoundWrite.prototype.removeWrite = function(path) {
        if (path.isEmpty()) return CompoundWrite.Empty;
        else {
            var newWriteTree = this.writeTree_.setTree(path, $d1f87d24500ab009$var$ImmutableTree.Empty);
            return new CompoundWrite(newWriteTree);
        }
    };
    /**
     * Returns whether this CompoundWrite will fully overwrite a node at a given location and can therefore be
     * considered "complete".
     *
     * @param path The path to check for
     * @return Whether there is a complete write at that path
     */ CompoundWrite.prototype.hasCompleteWrite = function(path) {
        return this.getCompleteNode(path) != null;
    };
    /**
     * Returns a node for a path if and only if the node is a "complete" overwrite at that path. This will not aggregate
     * writes from deeper paths, but will return child nodes from a more shallow path.
     *
     * @param path The path to get a complete write
     * @return The node if complete at that path, or null otherwise.
     */ CompoundWrite.prototype.getCompleteNode = function(path) {
        var rootmost = this.writeTree_.findRootMostValueAndPath(path);
        if (rootmost != null) return this.writeTree_.get(rootmost.path).getChild($d1f87d24500ab009$var$Path.relativePath(rootmost.path, path));
        else return null;
    };
    /**
     * Returns all children that are guaranteed to be a complete overwrite.
     *
     * @return A list of all complete children.
     */ CompoundWrite.prototype.getCompleteChildren = function() {
        var children = [];
        var node = this.writeTree_.value;
        if (node != null) // If it's a leaf node, it has no children; so nothing to do.
        {
            if (!node.isLeafNode()) node.forEachChild($d1f87d24500ab009$var$PRIORITY_INDEX, function(childName, childNode) {
                children.push(new $d1f87d24500ab009$var$NamedNode(childName, childNode));
            });
        } else this.writeTree_.children.inorderTraversal(function(childName, childTree) {
            if (childTree.value != null) children.push(new $d1f87d24500ab009$var$NamedNode(childName, childTree.value));
        });
        return children;
    };
    CompoundWrite.prototype.childCompoundWrite = function(path) {
        if (path.isEmpty()) return this;
        else {
            var shadowingNode = this.getCompleteNode(path);
            if (shadowingNode != null) return new CompoundWrite(new $d1f87d24500ab009$var$ImmutableTree(shadowingNode));
            else return new CompoundWrite(this.writeTree_.subtree(path));
        }
    };
    /**
     * Returns true if this CompoundWrite is empty and therefore does not modify any nodes.
     * @return Whether this CompoundWrite is empty
     */ CompoundWrite.prototype.isEmpty = function() {
        return this.writeTree_.isEmpty();
    };
    /**
     * Applies this CompoundWrite to a node. The node is returned with all writes from this CompoundWrite applied to the
     * node
     * @param node The node to apply this CompoundWrite to
     * @return The node with all writes applied
     */ CompoundWrite.prototype.apply = function(node) {
        return $d1f87d24500ab009$var$applySubtreeWrite($d1f87d24500ab009$var$Path.Empty, this.writeTree_, node);
    };
    CompoundWrite.Empty = new CompoundWrite(new $d1f87d24500ab009$var$ImmutableTree(null));
    return CompoundWrite;
}();
function $d1f87d24500ab009$var$applySubtreeWrite(relativePath, writeTree, node) {
    if (writeTree.value != null) // Since there a write is always a leaf, we're done here
    return node.updateChild(relativePath, writeTree.value);
    else {
        var priorityWrite_1 = null;
        writeTree.children.inorderTraversal(function(childKey, childTree) {
            if (childKey === ".priority") {
                // Apply priorities at the end so we don't update priorities for either empty nodes or forget
                // to apply priorities to empty nodes that are later filled
                $01sTD.assert(childTree.value !== null, "Priority writes must always be leaf nodes");
                priorityWrite_1 = childTree.value;
            } else node = $d1f87d24500ab009$var$applySubtreeWrite(relativePath.child(childKey), childTree, node);
        });
        // If there was a priority write, we only apply it if the node is not empty
        if (!node.getChild(relativePath).isEmpty() && priorityWrite_1 !== null) node = node.updateChild(relativePath.child(".priority"), priorityWrite_1);
        return node;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * WriteTree tracks all pending user-initiated writes and has methods to calculate the result of merging them
 * with underlying server data (to create "event cache" data).  Pending writes are added with addOverwrite()
 * and addMerge(), and removed with removeWrite().
 *
 * @constructor
 */ var $d1f87d24500ab009$var$WriteTree = /** @class */ function() {
    function WriteTree() {
        /**
         * A tree tracking the result of applying all visible writes.  This does not include transactions with
         * applyLocally=false or writes that are completely shadowed by other writes.
         *
         * @type {!CompoundWrite}
         * @private
         */ this.visibleWrites_ = $d1f87d24500ab009$var$CompoundWrite.Empty;
        /**
         * A list of all pending writes, regardless of visibility and shadowed-ness.  Used to calculate arbitrary
         * sets of the changed data, such as hidden writes (from transactions) or changes with certain writes excluded (also
         * used by transactions).
         *
         * @type {!Array.<!WriteRecord>}
         * @private
         */ this.allWrites_ = [];
        this.lastWriteId_ = -1;
    }
    /**
     * Create a new WriteTreeRef for the given path. For use with a new sync point at the given path.
     *
     * @param {!Path} path
     * @return {!WriteTreeRef}
     */ WriteTree.prototype.childWrites = function(path) {
        return new $d1f87d24500ab009$var$WriteTreeRef(path, this);
    };
    /**
     * Record a new overwrite from user code.
     *
     * @param {!Path} path
     * @param {!Node} snap
     * @param {!number} writeId
     * @param {boolean=} visible This is set to false by some transactions. It should be excluded from event caches
     */ WriteTree.prototype.addOverwrite = function(path, snap, writeId, visible) {
        $01sTD.assert(writeId > this.lastWriteId_, "Stacking an older write on top of newer ones");
        if (visible === undefined) visible = true;
        this.allWrites_.push({
            path: path,
            snap: snap,
            writeId: writeId,
            visible: visible
        });
        if (visible) this.visibleWrites_ = this.visibleWrites_.addWrite(path, snap);
        this.lastWriteId_ = writeId;
    };
    /**
     * Record a new merge from user code.
     *
     * @param {!Path} path
     * @param {!Object.<string, !Node>} changedChildren
     * @param {!number} writeId
     */ WriteTree.prototype.addMerge = function(path, changedChildren, writeId) {
        $01sTD.assert(writeId > this.lastWriteId_, "Stacking an older merge on top of newer ones");
        this.allWrites_.push({
            path: path,
            children: changedChildren,
            writeId: writeId,
            visible: true
        });
        this.visibleWrites_ = this.visibleWrites_.addWrites(path, changedChildren);
        this.lastWriteId_ = writeId;
    };
    /**
     * @param {!number} writeId
     * @return {?WriteRecord}
     */ WriteTree.prototype.getWrite = function(writeId) {
        for(var i = 0; i < this.allWrites_.length; i++){
            var record = this.allWrites_[i];
            if (record.writeId === writeId) return record;
        }
        return null;
    };
    /**
     * Remove a write (either an overwrite or merge) that has been successfully acknowledge by the server. Recalculates
     * the tree if necessary.  We return true if it may have been visible, meaning views need to reevaluate.
     *
     * @param {!number} writeId
     * @return {boolean} true if the write may have been visible (meaning we'll need to reevaluate / raise
     * events as a result).
     */ WriteTree.prototype.removeWrite = function(writeId) {
        // Note: disabling this check. It could be a transaction that preempted another transaction, and thus was applied
        // out of order.
        //const validClear = revert || this.allWrites_.length === 0 || writeId <= this.allWrites_[0].writeId;
        //assert(validClear, "Either we don't have this write, or it's the first one in the queue");
        var _this = this;
        var idx = this.allWrites_.findIndex(function(s) {
            return s.writeId === writeId;
        });
        $01sTD.assert(idx >= 0, "removeWrite called with nonexistent writeId.");
        var writeToRemove = this.allWrites_[idx];
        this.allWrites_.splice(idx, 1);
        var removedWriteWasVisible = writeToRemove.visible;
        var removedWriteOverlapsWithOtherWrites = false;
        var i = this.allWrites_.length - 1;
        while(removedWriteWasVisible && i >= 0){
            var currentWrite = this.allWrites_[i];
            if (currentWrite.visible) {
                if (i >= idx && this.recordContainsPath_(currentWrite, writeToRemove.path)) // The removed write was completely shadowed by a subsequent write.
                removedWriteWasVisible = false;
                else if (writeToRemove.path.contains(currentWrite.path)) // Either we're covering some writes or they're covering part of us (depending on which came first).
                removedWriteOverlapsWithOtherWrites = true;
            }
            i--;
        }
        if (!removedWriteWasVisible) return false;
        else if (removedWriteOverlapsWithOtherWrites) {
            // There's some shadowing going on. Just rebuild the visible writes from scratch.
            this.resetTree_();
            return true;
        } else {
            // There's no shadowing.  We can safely just remove the write(s) from visibleWrites.
            if (writeToRemove.snap) this.visibleWrites_ = this.visibleWrites_.removeWrite(writeToRemove.path);
            else {
                var children = writeToRemove.children;
                $d1f87d24500ab009$var$each(children, function(childName) {
                    _this.visibleWrites_ = _this.visibleWrites_.removeWrite(writeToRemove.path.child(childName));
                });
            }
            return true;
        }
    };
    /**
     * Return a complete snapshot for the given path if there's visible write data at that path, else null.
     * No server data is considered.
     *
     * @param {!Path} path
     * @return {?Node}
     */ WriteTree.prototype.getCompleteWriteData = function(path) {
        return this.visibleWrites_.getCompleteNode(path);
    };
    /**
     * Given optional, underlying server data, and an optional set of constraints (exclude some sets, include hidden
     * writes), attempt to calculate a complete snapshot for the given path
     *
     * @param {!Path} treePath
     * @param {?Node} completeServerCache
     * @param {Array.<number>=} writeIdsToExclude An optional set to be excluded
     * @param {boolean=} includeHiddenWrites Defaults to false, whether or not to layer on writes with visible set to false
     * @return {?Node}
     */ WriteTree.prototype.calcCompleteEventCache = function(treePath, completeServerCache, writeIdsToExclude, includeHiddenWrites) {
        if (!writeIdsToExclude && !includeHiddenWrites) {
            var shadowingNode = this.visibleWrites_.getCompleteNode(treePath);
            if (shadowingNode != null) return shadowingNode;
            else {
                var subMerge = this.visibleWrites_.childCompoundWrite(treePath);
                if (subMerge.isEmpty()) return completeServerCache;
                else if (completeServerCache == null && !subMerge.hasCompleteWrite($d1f87d24500ab009$var$Path.Empty)) // We wouldn't have a complete snapshot, since there's no underlying data and no complete shadow
                return null;
                else {
                    var layeredCache = completeServerCache || $d1f87d24500ab009$var$ChildrenNode.EMPTY_NODE;
                    return subMerge.apply(layeredCache);
                }
            }
        } else {
            var merge = this.visibleWrites_.childCompoundWrite(treePath);
            if (!includeHiddenWrites && merge.isEmpty()) return completeServerCache;
            else {
                // If the server cache is null, and we don't have a complete cache, we need to return null
                if (!includeHiddenWrites && completeServerCache == null && !merge.hasCompleteWrite($d1f87d24500ab009$var$Path.Empty)) return null;
                else {
                    var filter = function(write) {
                        return (write.visible || includeHiddenWrites) && (!writeIdsToExclude || !~writeIdsToExclude.indexOf(write.writeId)) && (write.path.contains(treePath) || treePath.contains(write.path));
                    };
                    var mergeAtPath = WriteTree.layerTree_(this.allWrites_, filter, treePath);
                    var layeredCache = completeServerCache || $d1f87d24500ab009$var$ChildrenNode.EMPTY_NODE;
                    return mergeAtPath.apply(layeredCache);
                }
            }
        }
    };
    /**
     * With optional, underlying server data, attempt to return a children node of children that we have complete data for.
     * Used when creating new views, to pre-fill their complete event children snapshot.
     *
     * @param {!Path} treePath
     * @param {?ChildrenNode} completeServerChildren
     * @return {!ChildrenNode}
     */ WriteTree.prototype.calcCompleteEventChildren = function(treePath, completeServerChildren) {
        var completeChildren = $d1f87d24500ab009$var$ChildrenNode.EMPTY_NODE;
        var topLevelSet = this.visibleWrites_.getCompleteNode(treePath);
        if (topLevelSet) {
            if (!topLevelSet.isLeafNode()) // we're shadowing everything. Return the children.
            topLevelSet.forEachChild($d1f87d24500ab009$var$PRIORITY_INDEX, function(childName, childSnap) {
                completeChildren = completeChildren.updateImmediateChild(childName, childSnap);
            });
            return completeChildren;
        } else if (completeServerChildren) {
            // Layer any children we have on top of this
            // We know we don't have a top-level set, so just enumerate existing children
            var merge_1 = this.visibleWrites_.childCompoundWrite(treePath);
            completeServerChildren.forEachChild($d1f87d24500ab009$var$PRIORITY_INDEX, function(childName, childNode) {
                var node = merge_1.childCompoundWrite(new $d1f87d24500ab009$var$Path(childName)).apply(childNode);
                completeChildren = completeChildren.updateImmediateChild(childName, node);
            });
            // Add any complete children we have from the set
            merge_1.getCompleteChildren().forEach(function(namedNode) {
                completeChildren = completeChildren.updateImmediateChild(namedNode.name, namedNode.node);
            });
            return completeChildren;
        } else {
            // We don't have anything to layer on top of. Layer on any children we have
            // Note that we can return an empty snap if we have a defined delete
            var merge = this.visibleWrites_.childCompoundWrite(treePath);
            merge.getCompleteChildren().forEach(function(namedNode) {
                completeChildren = completeChildren.updateImmediateChild(namedNode.name, namedNode.node);
            });
            return completeChildren;
        }
    };
    /**
     * Given that the underlying server data has updated, determine what, if anything, needs to be
     * applied to the event cache.
     *
     * Possibilities:
     *
     * 1. No writes are shadowing. Events should be raised, the snap to be applied comes from the server data
     *
     * 2. Some write is completely shadowing. No events to be raised
     *
     * 3. Is partially shadowed. Events
     *
     * Either existingEventSnap or existingServerSnap must exist
     *
     * @param {!Path} treePath
     * @param {!Path} childPath
     * @param {?Node} existingEventSnap
     * @param {?Node} existingServerSnap
     * @return {?Node}
     */ WriteTree.prototype.calcEventCacheAfterServerOverwrite = function(treePath, childPath, existingEventSnap, existingServerSnap) {
        $01sTD.assert(existingEventSnap || existingServerSnap, "Either existingEventSnap or existingServerSnap must exist");
        var path = treePath.child(childPath);
        if (this.visibleWrites_.hasCompleteWrite(path)) // At this point we can probably guarantee that we're in case 2, meaning no events
        // May need to check visibility while doing the findRootMostValueAndPath call
        return null;
        else {
            // No complete shadowing. We're either partially shadowing or not shadowing at all.
            var childMerge = this.visibleWrites_.childCompoundWrite(path);
            if (childMerge.isEmpty()) // We're not shadowing at all. Case 1
            return existingServerSnap.getChild(childPath);
            else // This could be more efficient if the serverNode + updates doesn't change the eventSnap
            // However this is tricky to find out, since user updates don't necessary change the server
            // snap, e.g. priority updates on empty nodes, or deep deletes. Another special case is if the server
            // adds nodes, but doesn't change any existing writes. It is therefore not enough to
            // only check if the updates change the serverNode.
            // Maybe check if the merge tree contains these special cases and only do a full overwrite in that case?
            return childMerge.apply(existingServerSnap.getChild(childPath));
        }
    };
    /**
     * Returns a complete child for a given server snap after applying all user writes or null if there is no
     * complete child for this ChildKey.
     *
     * @param {!Path} treePath
     * @param {!string} childKey
     * @param {!CacheNode} existingServerSnap
     * @return {?Node}
     */ WriteTree.prototype.calcCompleteChild = function(treePath, childKey, existingServerSnap) {
        var path = treePath.child(childKey);
        var shadowingNode = this.visibleWrites_.getCompleteNode(path);
        if (shadowingNode != null) return shadowingNode;
        else {
            if (existingServerSnap.isCompleteForChild(childKey)) {
                var childMerge = this.visibleWrites_.childCompoundWrite(path);
                return childMerge.apply(existingServerSnap.getNode().getImmediateChild(childKey));
            } else return null;
        }
    };
    /**
     * Returns a node if there is a complete overwrite for this path. More specifically, if there is a write at
     * a higher path, this will return the child of that write relative to the write and this path.
     * Returns null if there is no write at this path.
     */ WriteTree.prototype.shadowingWrite = function(path) {
        return this.visibleWrites_.getCompleteNode(path);
    };
    /**
     * This method is used when processing child remove events on a query. If we can, we pull in children that were outside
     * the window, but may now be in the window.
     */ WriteTree.prototype.calcIndexedSlice = function(treePath, completeServerData, startPost, count, reverse, index) {
        var toIterate;
        var merge = this.visibleWrites_.childCompoundWrite(treePath);
        var shadowingNode = merge.getCompleteNode($d1f87d24500ab009$var$Path.Empty);
        if (shadowingNode != null) toIterate = shadowingNode;
        else if (completeServerData != null) toIterate = merge.apply(completeServerData);
        else // no children to iterate on
        return [];
        toIterate = toIterate.withIndex(index);
        if (!toIterate.isEmpty() && !toIterate.isLeafNode()) {
            var nodes = [];
            var cmp = index.getCompare();
            var iter = reverse ? toIterate.getReverseIteratorFrom(startPost, index) : toIterate.getIteratorFrom(startPost, index);
            var next = iter.getNext();
            while(next && nodes.length < count){
                if (cmp(next, startPost) !== 0) nodes.push(next);
                next = iter.getNext();
            }
            return nodes;
        } else return [];
    };
    WriteTree.prototype.recordContainsPath_ = function(writeRecord, path) {
        if (writeRecord.snap) return writeRecord.path.contains(path);
        else {
            for(var childName in writeRecord.children){
                if (writeRecord.children.hasOwnProperty(childName) && writeRecord.path.child(childName).contains(path)) return true;
            }
            return false;
        }
    };
    /**
     * Re-layer the writes and merges into a tree so we can efficiently calculate event snapshots
     */ WriteTree.prototype.resetTree_ = function() {
        this.visibleWrites_ = WriteTree.layerTree_(this.allWrites_, WriteTree.DefaultFilter_, $d1f87d24500ab009$var$Path.Empty);
        if (this.allWrites_.length > 0) this.lastWriteId_ = this.allWrites_[this.allWrites_.length - 1].writeId;
        else this.lastWriteId_ = -1;
    };
    /**
     * The default filter used when constructing the tree. Keep everything that's visible.
     */ WriteTree.DefaultFilter_ = function(write) {
        return write.visible;
    };
    /**
     * Static method. Given an array of WriteRecords, a filter for which ones to include, and a path, construct the tree of
     * event data at that path.
     */ WriteTree.layerTree_ = function(writes, filter, treeRoot) {
        var compoundWrite = $d1f87d24500ab009$var$CompoundWrite.Empty;
        for(var i = 0; i < writes.length; ++i){
            var write = writes[i];
            // Theory, a later set will either:
            // a) abort a relevant transaction, so no need to worry about excluding it from calculating that transaction
            // b) not be relevant to a transaction (separate branch), so again will not affect the data for that transaction
            if (filter(write)) {
                var writePath = write.path;
                var relativePath = void 0;
                if (write.snap) {
                    if (treeRoot.contains(writePath)) {
                        relativePath = $d1f87d24500ab009$var$Path.relativePath(treeRoot, writePath);
                        compoundWrite = compoundWrite.addWrite(relativePath, write.snap);
                    } else if (writePath.contains(treeRoot)) {
                        relativePath = $d1f87d24500ab009$var$Path.relativePath(writePath, treeRoot);
                        compoundWrite = compoundWrite.addWrite($d1f87d24500ab009$var$Path.Empty, write.snap.getChild(relativePath));
                    }
                } else if (write.children) {
                    if (treeRoot.contains(writePath)) {
                        relativePath = $d1f87d24500ab009$var$Path.relativePath(treeRoot, writePath);
                        compoundWrite = compoundWrite.addWrites(relativePath, write.children);
                    } else if (writePath.contains(treeRoot)) {
                        relativePath = $d1f87d24500ab009$var$Path.relativePath(writePath, treeRoot);
                        if (relativePath.isEmpty()) compoundWrite = compoundWrite.addWrites($d1f87d24500ab009$var$Path.Empty, write.children);
                        else {
                            var child = $01sTD.safeGet(write.children, relativePath.getFront());
                            if (child) {
                                // There exists a child in this node that matches the root path
                                var deepNode = child.getChild(relativePath.popFront());
                                compoundWrite = compoundWrite.addWrite($d1f87d24500ab009$var$Path.Empty, deepNode);
                            }
                        }
                    }
                } else throw $01sTD.assertionError("WriteRecord should have .snap or .children");
            }
        }
        return compoundWrite;
    };
    return WriteTree;
}();
/**
 * A WriteTreeRef wraps a WriteTree and a path, for convenient access to a particular subtree.  All of the methods
 * just proxy to the underlying WriteTree.
 *
 * @constructor
 */ var $d1f87d24500ab009$var$WriteTreeRef = /** @class */ function() {
    /**
     * @param {!Path} path
     * @param {!WriteTree} writeTree
     */ function WriteTreeRef(path, writeTree) {
        this.treePath_ = path;
        this.writeTree_ = writeTree;
    }
    /**
     * If possible, returns a complete event cache, using the underlying server data if possible. In addition, can be used
     * to get a cache that includes hidden writes, and excludes arbitrary writes. Note that customizing the returned node
     * can lead to a more expensive calculation.
     *
     * @param {?Node} completeServerCache
     * @param {Array.<number>=} writeIdsToExclude Optional writes to exclude.
     * @param {boolean=} includeHiddenWrites Defaults to false, whether or not to layer on writes with visible set to false
     * @return {?Node}
     */ WriteTreeRef.prototype.calcCompleteEventCache = function(completeServerCache, writeIdsToExclude, includeHiddenWrites) {
        return this.writeTree_.calcCompleteEventCache(this.treePath_, completeServerCache, writeIdsToExclude, includeHiddenWrites);
    };
    /**
     * If possible, returns a children node containing all of the complete children we have data for. The returned data is a
     * mix of the given server data and write data.
     *
     * @param {?ChildrenNode} completeServerChildren
     * @return {!ChildrenNode}
     */ WriteTreeRef.prototype.calcCompleteEventChildren = function(completeServerChildren) {
        return this.writeTree_.calcCompleteEventChildren(this.treePath_, completeServerChildren);
    };
    /**
     * Given that either the underlying server data has updated or the outstanding writes have updated, determine what,
     * if anything, needs to be applied to the event cache.
     *
     * Possibilities:
     *
     * 1. No writes are shadowing. Events should be raised, the snap to be applied comes from the server data
     *
     * 2. Some write is completely shadowing. No events to be raised
     *
     * 3. Is partially shadowed. Events should be raised
     *
     * Either existingEventSnap or existingServerSnap must exist, this is validated via an assert
     *
     * @param {!Path} path
     * @param {?Node} existingEventSnap
     * @param {?Node} existingServerSnap
     * @return {?Node}
     */ WriteTreeRef.prototype.calcEventCacheAfterServerOverwrite = function(path, existingEventSnap, existingServerSnap) {
        return this.writeTree_.calcEventCacheAfterServerOverwrite(this.treePath_, path, existingEventSnap, existingServerSnap);
    };
    /**
     * Returns a node if there is a complete overwrite for this path. More specifically, if there is a write at
     * a higher path, this will return the child of that write relative to the write and this path.
     * Returns null if there is no write at this path.
     *
     * @param {!Path} path
     * @return {?Node}
     */ WriteTreeRef.prototype.shadowingWrite = function(path) {
        return this.writeTree_.shadowingWrite(this.treePath_.child(path));
    };
    /**
     * This method is used when processing child remove events on a query. If we can, we pull in children that were outside
     * the window, but may now be in the window
     *
     * @param {?Node} completeServerData
     * @param {!NamedNode} startPost
     * @param {!number} count
     * @param {boolean} reverse
     * @param {!Index} index
     * @return {!Array.<!NamedNode>}
     */ WriteTreeRef.prototype.calcIndexedSlice = function(completeServerData, startPost, count, reverse, index) {
        return this.writeTree_.calcIndexedSlice(this.treePath_, completeServerData, startPost, count, reverse, index);
    };
    /**
     * Returns a complete child for a given server snap after applying all user writes or null if there is no
     * complete child for this ChildKey.
     *
     * @param {!string} childKey
     * @param {!CacheNode} existingServerCache
     * @return {?Node}
     */ WriteTreeRef.prototype.calcCompleteChild = function(childKey, existingServerCache) {
        return this.writeTree_.calcCompleteChild(this.treePath_, childKey, existingServerCache);
    };
    /**
     * Return a WriteTreeRef for a child.
     *
     * @param {string} childName
     * @return {!WriteTreeRef}
     */ WriteTreeRef.prototype.child = function(childName) {
        return new WriteTreeRef(this.treePath_.child(childName), this.writeTree_);
    };
    return WriteTreeRef;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * SyncTree is the central class for managing event callback registration, data caching, views
 * (query processing), and event generation.  There are typically two SyncTree instances for
 * each Repo, one for the normal Firebase data, and one for the .info data.
 *
 * It has a number of responsibilities, including:
 *  - Tracking all user event callbacks (registered via addEventRegistration() and removeEventRegistration()).
 *  - Applying and caching data changes for user set(), transaction(), and update() calls
 *    (applyUserOverwrite(), applyUserMerge()).
 *  - Applying and caching data changes for server data changes (applyServerOverwrite(),
 *    applyServerMerge()).
 *  - Generating user-facing events for server and user changes (all of the apply* methods
 *    return the set of events that need to be raised as a result).
 *  - Maintaining the appropriate set of server listens to ensure we are always subscribed
 *    to the correct set of paths and queries to satisfy the current set of user event
 *    callbacks (listens are started/stopped using the provided listenProvider).
 *
 * NOTE: Although SyncTree tracks event callbacks and calculates events to raise, the actual
 * events are returned to the caller rather than raised synchronously.
 *
 * @constructor
 */ var $d1f87d24500ab009$var$SyncTree = /** @class */ function() {
    /**
     * @param {!ListenProvider} listenProvider_ Used by SyncTree to start / stop listening
     *   to server data.
     */ function SyncTree(listenProvider_) {
        this.listenProvider_ = listenProvider_;
        /**
         * Tree of SyncPoints.  There's a SyncPoint at any location that has 1 or more views.
         */ this.syncPointTree_ = $d1f87d24500ab009$var$ImmutableTree.Empty;
        /**
         * A tree of all pending user writes (user-initiated set()'s, transaction()'s, update()'s, etc.).
         */ this.pendingWriteTree_ = new $d1f87d24500ab009$var$WriteTree();
        this.tagToQueryMap = new Map();
        this.queryToTagMap = new Map();
    }
    /**
     * Apply the data changes for a user-generated set() or transaction() call.
     *
     * @return Events to raise.
     */ SyncTree.prototype.applyUserOverwrite = function(path, newData, writeId, visible) {
        // Record pending write.
        this.pendingWriteTree_.addOverwrite(path, newData, writeId, visible);
        if (!visible) return [];
        else return this.applyOperationToSyncPoints_(new $d1f87d24500ab009$var$Overwrite($d1f87d24500ab009$var$OperationSource.User, path, newData));
    };
    /**
     * Apply the data from a user-generated update() call
     *
     * @return Events to raise.
     */ SyncTree.prototype.applyUserMerge = function(path, changedChildren, writeId) {
        // Record pending merge.
        this.pendingWriteTree_.addMerge(path, changedChildren, writeId);
        var changeTree = $d1f87d24500ab009$var$ImmutableTree.fromObject(changedChildren);
        return this.applyOperationToSyncPoints_(new $d1f87d24500ab009$var$Merge($d1f87d24500ab009$var$OperationSource.User, path, changeTree));
    };
    /**
     * Acknowledge a pending user write that was previously registered with applyUserOverwrite() or applyUserMerge().
     *
     * @param revert True if the given write failed and needs to be reverted
     * @return Events to raise.
     */ SyncTree.prototype.ackUserWrite = function(writeId, revert) {
        if (revert === void 0) revert = false;
        var write = this.pendingWriteTree_.getWrite(writeId);
        var needToReevaluate = this.pendingWriteTree_.removeWrite(writeId);
        if (!needToReevaluate) return [];
        else {
            var affectedTree_1 = $d1f87d24500ab009$var$ImmutableTree.Empty;
            if (write.snap != null) // overwrite
            affectedTree_1 = affectedTree_1.set($d1f87d24500ab009$var$Path.Empty, true);
            else $d1f87d24500ab009$var$each(write.children, function(pathString, node) {
                affectedTree_1 = affectedTree_1.set(new $d1f87d24500ab009$var$Path(pathString), node);
            });
            return this.applyOperationToSyncPoints_(new $d1f87d24500ab009$var$AckUserWrite(write.path, affectedTree_1, revert));
        }
    };
    /**
     * Apply new server data for the specified path..
     *
     * @return Events to raise.
     */ SyncTree.prototype.applyServerOverwrite = function(path, newData) {
        return this.applyOperationToSyncPoints_(new $d1f87d24500ab009$var$Overwrite($d1f87d24500ab009$var$OperationSource.Server, path, newData));
    };
    /**
     * Apply new server data to be merged in at the specified path.
     *
     * @return Events to raise.
     */ SyncTree.prototype.applyServerMerge = function(path, changedChildren) {
        var changeTree = $d1f87d24500ab009$var$ImmutableTree.fromObject(changedChildren);
        return this.applyOperationToSyncPoints_(new $d1f87d24500ab009$var$Merge($d1f87d24500ab009$var$OperationSource.Server, path, changeTree));
    };
    /**
     * Apply a listen complete for a query
     *
     * @return Events to raise.
     */ SyncTree.prototype.applyListenComplete = function(path) {
        return this.applyOperationToSyncPoints_(new $d1f87d24500ab009$var$ListenComplete($d1f87d24500ab009$var$OperationSource.Server, path));
    };
    /**
     * Apply new server data for the specified tagged query.
     *
     * @return Events to raise.
     */ SyncTree.prototype.applyTaggedQueryOverwrite = function(path, snap, tag) {
        var queryKey = this.queryKeyForTag_(tag);
        if (queryKey != null) {
            var r = SyncTree.parseQueryKey_(queryKey);
            var queryPath = r.path, queryId = r.queryId;
            var relativePath = $d1f87d24500ab009$var$Path.relativePath(queryPath, path);
            var op = new $d1f87d24500ab009$var$Overwrite($d1f87d24500ab009$var$OperationSource.forServerTaggedQuery(queryId), relativePath, snap);
            return this.applyTaggedOperation_(queryPath, op);
        } else // Query must have been removed already
        return [];
    };
    /**
     * Apply server data to be merged in for the specified tagged query.
     *
     * @return Events to raise.
     */ SyncTree.prototype.applyTaggedQueryMerge = function(path, changedChildren, tag) {
        var queryKey = this.queryKeyForTag_(tag);
        if (queryKey) {
            var r = SyncTree.parseQueryKey_(queryKey);
            var queryPath = r.path, queryId = r.queryId;
            var relativePath = $d1f87d24500ab009$var$Path.relativePath(queryPath, path);
            var changeTree = $d1f87d24500ab009$var$ImmutableTree.fromObject(changedChildren);
            var op = new $d1f87d24500ab009$var$Merge($d1f87d24500ab009$var$OperationSource.forServerTaggedQuery(queryId), relativePath, changeTree);
            return this.applyTaggedOperation_(queryPath, op);
        } else // We've already removed the query. No big deal, ignore the update
        return [];
    };
    /**
     * Apply a listen complete for a tagged query
     *
     * @return Events to raise.
     */ SyncTree.prototype.applyTaggedListenComplete = function(path, tag) {
        var queryKey = this.queryKeyForTag_(tag);
        if (queryKey) {
            var r = SyncTree.parseQueryKey_(queryKey);
            var queryPath = r.path, queryId = r.queryId;
            var relativePath = $d1f87d24500ab009$var$Path.relativePath(queryPath, path);
            var op = new $d1f87d24500ab009$var$ListenComplete($d1f87d24500ab009$var$OperationSource.forServerTaggedQuery(queryId), relativePath);
            return this.applyTaggedOperation_(queryPath, op);
        } else // We've already removed the query. No big deal, ignore the update
        return [];
    };
    /**
     * Add an event callback for the specified query.
     *
     * @return Events to raise.
     */ SyncTree.prototype.addEventRegistration = function(query, eventRegistration) {
        var path = query.path;
        var serverCache = null;
        var foundAncestorDefaultView = false;
        // Any covering writes will necessarily be at the root, so really all we need to find is the server cache.
        // Consider optimizing this once there's a better understanding of what actual behavior will be.
        this.syncPointTree_.foreachOnPath(path, function(pathToSyncPoint, sp) {
            var relativePath = $d1f87d24500ab009$var$Path.relativePath(pathToSyncPoint, path);
            serverCache = serverCache || sp.getCompleteServerCache(relativePath);
            foundAncestorDefaultView = foundAncestorDefaultView || sp.hasCompleteView();
        });
        var syncPoint = this.syncPointTree_.get(path);
        if (!syncPoint) {
            syncPoint = new $d1f87d24500ab009$var$SyncPoint();
            this.syncPointTree_ = this.syncPointTree_.set(path, syncPoint);
        } else {
            foundAncestorDefaultView = foundAncestorDefaultView || syncPoint.hasCompleteView();
            serverCache = serverCache || syncPoint.getCompleteServerCache($d1f87d24500ab009$var$Path.Empty);
        }
        var serverCacheComplete;
        if (serverCache != null) serverCacheComplete = true;
        else {
            serverCacheComplete = false;
            serverCache = $d1f87d24500ab009$var$ChildrenNode.EMPTY_NODE;
            var subtree = this.syncPointTree_.subtree(path);
            subtree.foreachChild(function(childName, childSyncPoint) {
                var completeCache = childSyncPoint.getCompleteServerCache($d1f87d24500ab009$var$Path.Empty);
                if (completeCache) serverCache = serverCache.updateImmediateChild(childName, completeCache);
            });
        }
        var viewAlreadyExists = syncPoint.viewExistsForQuery(query);
        if (!viewAlreadyExists && !query.getQueryParams().loadsAllData()) {
            // We need to track a tag for this query
            var queryKey = SyncTree.makeQueryKey_(query);
            $01sTD.assert(!this.queryToTagMap.has(queryKey), "View does not exist, but we have a tag");
            var tag = SyncTree.getNextQueryTag_();
            this.queryToTagMap.set(queryKey, tag);
            this.tagToQueryMap.set(tag, queryKey);
        }
        var writesCache = this.pendingWriteTree_.childWrites(path);
        var events = syncPoint.addEventRegistration(query, eventRegistration, writesCache, serverCache, serverCacheComplete);
        if (!viewAlreadyExists && !foundAncestorDefaultView) {
            var view /** @type !View */  = syncPoint.viewForQuery(query);
            events = events.concat(this.setupListener_(query, view));
        }
        return events;
    };
    /**
     * Remove event callback(s).
     *
     * If query is the default query, we'll check all queries for the specified eventRegistration.
     * If eventRegistration is null, we'll remove all callbacks for the specified query/queries.
     *
     * @param eventRegistration If null, all callbacks are removed.
     * @param cancelError If a cancelError is provided, appropriate cancel events will be returned.
     * @return Cancel events, if cancelError was provided.
     */ SyncTree.prototype.removeEventRegistration = function(query, eventRegistration, cancelError) {
        var _this = this;
        // Find the syncPoint first. Then deal with whether or not it has matching listeners
        var path = query.path;
        var maybeSyncPoint = this.syncPointTree_.get(path);
        var cancelEvents = [];
        // A removal on a default query affects all queries at that location. A removal on an indexed query, even one without
        // other query constraints, does *not* affect all queries at that location. So this check must be for 'default', and
        // not loadsAllData().
        if (maybeSyncPoint && (query.queryIdentifier() === "default" || maybeSyncPoint.viewExistsForQuery(query))) {
            /**
             * @type {{removed: !Array.<!Query>, events: !Array.<!Event>}}
             */ var removedAndEvents = maybeSyncPoint.removeEventRegistration(query, eventRegistration, cancelError);
            if (maybeSyncPoint.isEmpty()) this.syncPointTree_ = this.syncPointTree_.remove(path);
            var removed = removedAndEvents.removed;
            cancelEvents = removedAndEvents.events;
            // We may have just removed one of many listeners and can short-circuit this whole process
            // We may also not have removed a default listener, in which case all of the descendant listeners should already be
            // properly set up.
            //
            // Since indexed queries can shadow if they don't have other query constraints, check for loadsAllData(), instead of
            // queryId === 'default'
            var removingDefault = -1 !== removed.findIndex(function(query) {
                return query.getQueryParams().loadsAllData();
            });
            var covered = this.syncPointTree_.findOnPath(path, function(relativePath, parentSyncPoint) {
                return parentSyncPoint.hasCompleteView();
            });
            if (removingDefault && !covered) {
                var subtree = this.syncPointTree_.subtree(path);
                // There are potentially child listeners. Determine what if any listens we need to send before executing the
                // removal
                if (!subtree.isEmpty()) {
                    // We need to fold over our subtree and collect the listeners to send
                    var newViews = this.collectDistinctViewsForSubTree_(subtree);
                    // Ok, we've collected all the listens we need. Set them up.
                    for(var i = 0; i < newViews.length; ++i){
                        var view = newViews[i], newQuery = view.getQuery();
                        var listener = this.createListenerForView_(view);
                        this.listenProvider_.startListening(SyncTree.queryForListening_(newQuery), this.tagForQuery_(newQuery), listener.hashFn, listener.onComplete);
                    }
                }
            }
            // If we removed anything and we're not covered by a higher up listen, we need to stop listening on this query
            // The above block has us covered in terms of making sure we're set up on listens lower in the tree.
            // Also, note that if we have a cancelError, it's already been removed at the provider level.
            if (!covered && removed.length > 0 && !cancelError) {
                // If we removed a default, then we weren't listening on any of the other queries here. Just cancel the one
                // default. Otherwise, we need to iterate through and cancel each individual query
                if (removingDefault) {
                    // We don't tag default listeners
                    var defaultTag = null;
                    this.listenProvider_.stopListening(SyncTree.queryForListening_(query), defaultTag);
                } else removed.forEach(function(queryToRemove) {
                    var tagToRemove = _this.queryToTagMap.get(SyncTree.makeQueryKey_(queryToRemove));
                    _this.listenProvider_.stopListening(SyncTree.queryForListening_(queryToRemove), tagToRemove);
                });
            }
            // Now, clear all of the tags we're tracking for the removed listens
            this.removeTags_(removed);
        }
        return cancelEvents;
    };
    /**
     * Returns a complete cache, if we have one, of the data at a particular path. If the location does not have a
     * listener above it, we will get a false "null". This shouldn't be a problem because transactions will always
     * have a listener above, and atomic operations would correctly show a jitter of <increment value> ->
     *     <incremented total> as the write is applied locally and then acknowledged at the server.
     *
     * Note: this method will *include* hidden writes from transaction with applyLocally set to false.
     *
     * @param path The path to the data we want
     * @param writeIdsToExclude A specific set to be excluded
     */ SyncTree.prototype.calcCompleteEventCache = function(path, writeIdsToExclude) {
        var includeHiddenSets = true;
        var writeTree = this.pendingWriteTree_;
        var serverCache = this.syncPointTree_.findOnPath(path, function(pathSoFar, syncPoint) {
            var relativePath = $d1f87d24500ab009$var$Path.relativePath(pathSoFar, path);
            var serverCache = syncPoint.getCompleteServerCache(relativePath);
            if (serverCache) return serverCache;
        });
        return writeTree.calcCompleteEventCache(path, serverCache, writeIdsToExclude, includeHiddenSets);
    };
    /**
     * This collapses multiple unfiltered views into a single view, since we only need a single
     * listener for them.
     */ SyncTree.prototype.collectDistinctViewsForSubTree_ = function(subtree) {
        return subtree.fold(function(relativePath, maybeChildSyncPoint, childMap) {
            if (maybeChildSyncPoint && maybeChildSyncPoint.hasCompleteView()) {
                var completeView = maybeChildSyncPoint.getCompleteView();
                return [
                    completeView
                ];
            } else {
                // No complete view here, flatten any deeper listens into an array
                var views_1 = [];
                if (maybeChildSyncPoint) views_1 = maybeChildSyncPoint.getQueryViews();
                $d1f87d24500ab009$var$each(childMap, function(_key, childViews) {
                    views_1 = views_1.concat(childViews);
                });
                return views_1;
            }
        });
    };
    SyncTree.prototype.removeTags_ = function(queries) {
        for(var j = 0; j < queries.length; ++j){
            var removedQuery = queries[j];
            if (!removedQuery.getQueryParams().loadsAllData()) {
                // We should have a tag for this
                var removedQueryKey = SyncTree.makeQueryKey_(removedQuery);
                var removedQueryTag = this.queryToTagMap.get(removedQueryKey);
                this.queryToTagMap.delete(removedQueryKey);
                this.tagToQueryMap.delete(removedQueryTag);
            }
        }
    };
    /**
     * Normalizes a query to a query we send the server for listening
     *
     * @return The normalized query
     */ SyncTree.queryForListening_ = function(query) {
        if (query.getQueryParams().loadsAllData() && !query.getQueryParams().isDefault()) // We treat queries that load all data as default queries
        // Cast is necessary because ref() technically returns Firebase which is actually fb.api.Firebase which inherits
        // from Query
        return query.getRef();
        else return query;
    };
    /**
     * For a given new listen, manage the de-duplication of outstanding subscriptions.
     *
     * @return This method can return events to support synchronous data sources
     */ SyncTree.prototype.setupListener_ = function(query, view) {
        var path = query.path;
        var tag = this.tagForQuery_(query);
        var listener = this.createListenerForView_(view);
        var events = this.listenProvider_.startListening(SyncTree.queryForListening_(query), tag, listener.hashFn, listener.onComplete);
        var subtree = this.syncPointTree_.subtree(path);
        // The root of this subtree has our query. We're here because we definitely need to send a listen for that, but we
        // may need to shadow other listens as well.
        if (tag) $01sTD.assert(!subtree.value.hasCompleteView(), "If we're adding a query, it shouldn't be shadowed");
        else {
            // Shadow everything at or below this location, this is a default listener.
            var queriesToStop = subtree.fold(function(relativePath, maybeChildSyncPoint, childMap) {
                if (!relativePath.isEmpty() && maybeChildSyncPoint && maybeChildSyncPoint.hasCompleteView()) return [
                    maybeChildSyncPoint.getCompleteView().getQuery()
                ];
                else {
                    // No default listener here, flatten any deeper queries into an array
                    var queries_1 = [];
                    if (maybeChildSyncPoint) queries_1 = queries_1.concat(maybeChildSyncPoint.getQueryViews().map(function(view) {
                        return view.getQuery();
                    }));
                    $d1f87d24500ab009$var$each(childMap, function(_key, childQueries) {
                        queries_1 = queries_1.concat(childQueries);
                    });
                    return queries_1;
                }
            });
            for(var i = 0; i < queriesToStop.length; ++i){
                var queryToStop = queriesToStop[i];
                this.listenProvider_.stopListening(SyncTree.queryForListening_(queryToStop), this.tagForQuery_(queryToStop));
            }
        }
        return events;
    };
    SyncTree.prototype.createListenerForView_ = function(view) {
        var _this = this;
        var query = view.getQuery();
        var tag = this.tagForQuery_(query);
        return {
            hashFn: function() {
                var cache = view.getServerCache() || $d1f87d24500ab009$var$ChildrenNode.EMPTY_NODE;
                return cache.hash();
            },
            onComplete: function(status) {
                if (status === "ok") {
                    if (tag) return _this.applyTaggedListenComplete(query.path, tag);
                    else return _this.applyListenComplete(query.path);
                } else {
                    // If a listen failed, kill all of the listeners here, not just the one that triggered the error.
                    // Note that this may need to be scoped to just this listener if we change permissions on filtered children
                    var error = $d1f87d24500ab009$var$errorForServerCode(status, query);
                    return _this.removeEventRegistration(query, /*eventRegistration*/ null, error);
                }
            }
        };
    };
    /**
     * Given a query, computes a "queryKey" suitable for use in our queryToTagMap_.
     */ SyncTree.makeQueryKey_ = function(query) {
        return query.path.toString() + "$" + query.queryIdentifier();
    };
    /**
     * Given a queryKey (created by makeQueryKey), parse it back into a path and queryId.
     */ SyncTree.parseQueryKey_ = function(queryKey) {
        var splitIndex = queryKey.indexOf("$");
        $01sTD.assert(splitIndex !== -1 && splitIndex < queryKey.length - 1, "Bad queryKey.");
        return {
            queryId: queryKey.substr(splitIndex + 1),
            path: new $d1f87d24500ab009$var$Path(queryKey.substr(0, splitIndex))
        };
    };
    /**
     * Return the query associated with the given tag, if we have one
     */ SyncTree.prototype.queryKeyForTag_ = function(tag) {
        return this.tagToQueryMap.get(tag);
    };
    /**
     * Return the tag associated with the given query.
     */ SyncTree.prototype.tagForQuery_ = function(query) {
        var queryKey = SyncTree.makeQueryKey_(query);
        return this.queryToTagMap.get(queryKey);
    };
    /**
     * Static accessor for query tags.
     */ SyncTree.getNextQueryTag_ = function() {
        return SyncTree.nextQueryTag_++;
    };
    /**
     * A helper method to apply tagged operations
     */ SyncTree.prototype.applyTaggedOperation_ = function(queryPath, operation) {
        var syncPoint = this.syncPointTree_.get(queryPath);
        $01sTD.assert(syncPoint, "Missing sync point for query tag that we're tracking");
        var writesCache = this.pendingWriteTree_.childWrites(queryPath);
        return syncPoint.applyOperation(operation, writesCache, /*serverCache=*/ null);
    };
    /**
     * A helper method that visits all descendant and ancestor SyncPoints, applying the operation.
     *
     * NOTES:
     * - Descendant SyncPoints will be visited first (since we raise events depth-first).
     *
     * - We call applyOperation() on each SyncPoint passing three things:
     *   1. A version of the Operation that has been made relative to the SyncPoint location.
     *   2. A WriteTreeRef of any writes we have cached at the SyncPoint location.
     *   3. A snapshot Node with cached server data, if we have it.
     *
     * - We concatenate all of the events returned by each SyncPoint and return the result.
     */ SyncTree.prototype.applyOperationToSyncPoints_ = function(operation) {
        return this.applyOperationHelper_(operation, this.syncPointTree_, /*serverCache=*/ null, this.pendingWriteTree_.childWrites($d1f87d24500ab009$var$Path.Empty));
    };
    /**
     * Recursive helper for applyOperationToSyncPoints_
     */ SyncTree.prototype.applyOperationHelper_ = function(operation, syncPointTree, serverCache, writesCache) {
        if (operation.path.isEmpty()) return this.applyOperationDescendantsHelper_(operation, syncPointTree, serverCache, writesCache);
        else {
            var syncPoint = syncPointTree.get($d1f87d24500ab009$var$Path.Empty);
            // If we don't have cached server data, see if we can get it from this SyncPoint.
            if (serverCache == null && syncPoint != null) serverCache = syncPoint.getCompleteServerCache($d1f87d24500ab009$var$Path.Empty);
            var events = [];
            var childName = operation.path.getFront();
            var childOperation = operation.operationForChild(childName);
            var childTree = syncPointTree.children.get(childName);
            if (childTree && childOperation) {
                var childServerCache = serverCache ? serverCache.getImmediateChild(childName) : null;
                var childWritesCache = writesCache.child(childName);
                events = events.concat(this.applyOperationHelper_(childOperation, childTree, childServerCache, childWritesCache));
            }
            if (syncPoint) events = events.concat(syncPoint.applyOperation(operation, writesCache, serverCache));
            return events;
        }
    };
    /**
     * Recursive helper for applyOperationToSyncPoints_
     */ SyncTree.prototype.applyOperationDescendantsHelper_ = function(operation, syncPointTree, serverCache, writesCache) {
        var _this = this;
        var syncPoint = syncPointTree.get($d1f87d24500ab009$var$Path.Empty);
        // If we don't have cached server data, see if we can get it from this SyncPoint.
        if (serverCache == null && syncPoint != null) serverCache = syncPoint.getCompleteServerCache($d1f87d24500ab009$var$Path.Empty);
        var events = [];
        syncPointTree.children.inorderTraversal(function(childName, childTree) {
            var childServerCache = serverCache ? serverCache.getImmediateChild(childName) : null;
            var childWritesCache = writesCache.child(childName);
            var childOperation = operation.operationForChild(childName);
            if (childOperation) events = events.concat(_this.applyOperationDescendantsHelper_(childOperation, childTree, childServerCache, childWritesCache));
        });
        if (syncPoint) events = events.concat(syncPoint.applyOperation(operation, writesCache, serverCache));
        return events;
    };
    /**
     * Static tracker for next query tag.
     */ SyncTree.nextQueryTag_ = 1;
    return SyncTree;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Mutable object which basically just stores a reference to the "latest" immutable snapshot.
 *
 * @constructor
 */ var $d1f87d24500ab009$var$SnapshotHolder = /** @class */ function() {
    function SnapshotHolder() {
        this.rootNode_ = $d1f87d24500ab009$var$ChildrenNode.EMPTY_NODE;
    }
    SnapshotHolder.prototype.getNode = function(path) {
        return this.rootNode_.getChild(path);
    };
    SnapshotHolder.prototype.updateSnapshot = function(path, newSnapshotNode) {
        this.rootNode_ = this.rootNode_.updateChild(path, newSnapshotNode);
    };
    return SnapshotHolder;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Tracks a collection of stats.
 *
 * @constructor
 */ var $d1f87d24500ab009$var$StatsCollection = /** @class */ function() {
    function StatsCollection() {
        this.counters_ = {};
    }
    StatsCollection.prototype.incrementCounter = function(name, amount) {
        if (amount === void 0) amount = 1;
        if (!$01sTD.contains(this.counters_, name)) this.counters_[name] = 0;
        this.counters_[name] += amount;
    };
    StatsCollection.prototype.get = function() {
        return $01sTD.deepCopy(this.counters_);
    };
    return StatsCollection;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $d1f87d24500ab009$var$StatsManager = /** @class */ function() {
    function StatsManager() {}
    StatsManager.getCollection = function(repoInfo) {
        var hashString = repoInfo.toString();
        if (!this.collections_[hashString]) this.collections_[hashString] = new $d1f87d24500ab009$var$StatsCollection();
        return this.collections_[hashString];
    };
    StatsManager.getOrCreateReporter = function(repoInfo, creatorFunction) {
        var hashString = repoInfo.toString();
        if (!this.reporters_[hashString]) this.reporters_[hashString] = creatorFunction();
        return this.reporters_[hashString];
    };
    StatsManager.collections_ = {};
    StatsManager.reporters_ = {};
    return StatsManager;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns the delta from the previous call to get stats.
 *
 * @param collection_ The collection to "listen" to.
 * @constructor
 */ var $d1f87d24500ab009$var$StatsListener = /** @class */ function() {
    function StatsListener(collection_) {
        this.collection_ = collection_;
        this.last_ = null;
    }
    StatsListener.prototype.get = function() {
        var newStats = this.collection_.get();
        var delta = $a92b69d2447c208d$export$18ce0697a983be9b({}, newStats);
        if (this.last_) $d1f87d24500ab009$var$each(this.last_, function(stat, value) {
            delta[stat] = delta[stat] - value;
        });
        this.last_ = newStats;
        return delta;
    };
    return StatsListener;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Assuming some apps may have a short amount of time on page, and a bulk of firebase operations probably
// happen on page load, we try to report our first set of stats pretty quickly, but we wait at least 10
// seconds to try to ensure the Firebase connection is established / settled.
var $d1f87d24500ab009$var$FIRST_STATS_MIN_TIME = 10000;
var $d1f87d24500ab009$var$FIRST_STATS_MAX_TIME = 30000;
// We'll continue to report stats on average every 5 minutes.
var $d1f87d24500ab009$var$REPORT_STATS_INTERVAL = 300000;
/**
 * @constructor
 */ var $d1f87d24500ab009$var$StatsReporter = /** @class */ function() {
    /**
     * @param collection
     * @param server_
     */ function StatsReporter(collection, server_) {
        this.server_ = server_;
        this.statsToReport_ = {};
        this.statsListener_ = new $d1f87d24500ab009$var$StatsListener(collection);
        var timeout = $d1f87d24500ab009$var$FIRST_STATS_MIN_TIME + ($d1f87d24500ab009$var$FIRST_STATS_MAX_TIME - $d1f87d24500ab009$var$FIRST_STATS_MIN_TIME) * Math.random();
        $d1f87d24500ab009$var$setTimeoutNonBlocking(this.reportStats_.bind(this), Math.floor(timeout));
    }
    StatsReporter.prototype.includeStat = function(stat) {
        this.statsToReport_[stat] = true;
    };
    StatsReporter.prototype.reportStats_ = function() {
        var _this = this;
        var stats = this.statsListener_.get();
        var reportedStats = {};
        var haveStatsToReport = false;
        $d1f87d24500ab009$var$each(stats, function(stat, value) {
            if (value > 0 && $01sTD.contains(_this.statsToReport_, stat)) {
                reportedStats[stat] = value;
                haveStatsToReport = true;
            }
        });
        if (haveStatsToReport) this.server_.reportStats(reportedStats);
        // queue our next run.
        $d1f87d24500ab009$var$setTimeoutNonBlocking(this.reportStats_.bind(this), Math.floor(Math.random() * 2 * $d1f87d24500ab009$var$REPORT_STATS_INTERVAL));
    };
    return StatsReporter;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The event queue serves a few purposes:
 * 1. It ensures we maintain event order in the face of event callbacks doing operations that result in more
 *    events being queued.
 * 2. raiseQueuedEvents() handles being called reentrantly nicely.  That is, if in the course of raising events,
 *    raiseQueuedEvents() is called again, the "inner" call will pick up raising events where the "outer" call
 *    left off, ensuring that the events are still raised synchronously and in order.
 * 3. You can use raiseEventsAtPath and raiseEventsForChangedPath to ensure only relevant previously-queued
 *    events are raised synchronously.
 *
 * NOTE: This can all go away if/when we move to async events.
 *
 * @constructor
 */ var $d1f87d24500ab009$var$EventQueue = /** @class */ function() {
    function EventQueue() {
        /**
         * @private
         * @type {!Array.<EventList>}
         */ this.eventLists_ = [];
        /**
         * Tracks recursion depth of raiseQueuedEvents_, for debugging purposes.
         * @private
         * @type {!number}
         */ this.recursionDepth_ = 0;
    }
    /**
     * @param {!Array.<Event>} eventDataList The new events to queue.
     */ EventQueue.prototype.queueEvents = function(eventDataList) {
        // We group events by path, storing them in a single EventList, to make it easier to skip over them quickly.
        var currList = null;
        for(var i = 0; i < eventDataList.length; i++){
            var eventData = eventDataList[i];
            var eventPath = eventData.getPath();
            if (currList !== null && !eventPath.equals(currList.getPath())) {
                this.eventLists_.push(currList);
                currList = null;
            }
            if (currList === null) currList = new $d1f87d24500ab009$var$EventList(eventPath);
            currList.add(eventData);
        }
        if (currList) this.eventLists_.push(currList);
    };
    /**
     * Queues the specified events and synchronously raises all events (including previously queued ones)
     * for the specified path.
     *
     * It is assumed that the new events are all for the specified path.
     *
     * @param {!Path} path The path to raise events for.
     * @param {!Array.<Event>} eventDataList The new events to raise.
     */ EventQueue.prototype.raiseEventsAtPath = function(path, eventDataList) {
        this.queueEvents(eventDataList);
        this.raiseQueuedEventsMatchingPredicate_(function(eventPath) {
            return eventPath.equals(path);
        });
    };
    /**
     * Queues the specified events and synchronously raises all events (including previously queued ones) for
     * locations related to the specified change path (i.e. all ancestors and descendants).
     *
     * It is assumed that the new events are all related (ancestor or descendant) to the specified path.
     *
     * @param {!Path} changedPath The path to raise events for.
     * @param {!Array.<!Event>} eventDataList The events to raise
     */ EventQueue.prototype.raiseEventsForChangedPath = function(changedPath, eventDataList) {
        this.queueEvents(eventDataList);
        this.raiseQueuedEventsMatchingPredicate_(function(eventPath) {
            return eventPath.contains(changedPath) || changedPath.contains(eventPath);
        });
    };
    /**
     * @param {!function(!Path):boolean} predicate
     * @private
     */ EventQueue.prototype.raiseQueuedEventsMatchingPredicate_ = function(predicate) {
        this.recursionDepth_++;
        var sentAll = true;
        for(var i = 0; i < this.eventLists_.length; i++){
            var eventList = this.eventLists_[i];
            if (eventList) {
                var eventPath = eventList.getPath();
                if (predicate(eventPath)) {
                    this.eventLists_[i].raise();
                    this.eventLists_[i] = null;
                } else sentAll = false;
            }
        }
        if (sentAll) this.eventLists_ = [];
        this.recursionDepth_--;
    };
    return EventQueue;
}();
/**
 * @param {!Path} path
 * @constructor
 */ var $d1f87d24500ab009$var$EventList = /** @class */ function() {
    function EventList(path_) {
        this.path_ = path_;
        /**
         * @type {!Array.<Event>}
         * @private
         */ this.events_ = [];
    }
    /**
     * @param {!Event} eventData
     */ EventList.prototype.add = function(eventData) {
        this.events_.push(eventData);
    };
    /**
     * Iterates through the list and raises each event
     */ EventList.prototype.raise = function() {
        for(var i = 0; i < this.events_.length; i++){
            var eventData = this.events_[i];
            if (eventData !== null) {
                this.events_[i] = null;
                var eventFn = eventData.getEventRunner();
                if ($d1f87d24500ab009$var$logger) $d1f87d24500ab009$var$log("event: " + eventData.toString());
                $d1f87d24500ab009$var$exceptionGuard(eventFn);
            }
        }
    };
    /**
     * @return {!Path}
     */ EventList.prototype.getPath = function() {
        return this.path_;
    };
    return EventList;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Base class to be used if you want to emit events. Call the constructor with
 * the set of allowed event names.
 */ var $d1f87d24500ab009$var$EventEmitter = /** @class */ function() {
    /**
     * @param {!Array.<string>} allowedEvents_
     */ function EventEmitter(allowedEvents_) {
        this.allowedEvents_ = allowedEvents_;
        this.listeners_ = {};
        $01sTD.assert(Array.isArray(allowedEvents_) && allowedEvents_.length > 0, "Requires a non-empty array");
    }
    /**
     * To be called by derived classes to trigger events.
     * @param {!string} eventType
     * @param {...*} varArgs
     */ EventEmitter.prototype.trigger = function(eventType) {
        var varArgs = [];
        for(var _i = 1; _i < arguments.length; _i++)varArgs[_i - 1] = arguments[_i];
        if (Array.isArray(this.listeners_[eventType])) {
            // Clone the list, since callbacks could add/remove listeners.
            var listeners = $a92b69d2447c208d$export$afc72e2116322959(this.listeners_[eventType]);
            for(var i = 0; i < listeners.length; i++)listeners[i].callback.apply(listeners[i].context, varArgs);
        }
    };
    EventEmitter.prototype.on = function(eventType, callback, context) {
        this.validateEventType_(eventType);
        this.listeners_[eventType] = this.listeners_[eventType] || [];
        this.listeners_[eventType].push({
            callback: callback,
            context: context
        });
        var eventData = this.getInitialEvent(eventType);
        if (eventData) callback.apply(context, eventData);
    };
    EventEmitter.prototype.off = function(eventType, callback, context) {
        this.validateEventType_(eventType);
        var listeners = this.listeners_[eventType] || [];
        for(var i = 0; i < listeners.length; i++)if (listeners[i].callback === callback && (!context || context === listeners[i].context)) {
            listeners.splice(i, 1);
            return;
        }
    };
    EventEmitter.prototype.validateEventType_ = function(eventType) {
        $01sTD.assert(this.allowedEvents_.find(function(et) {
            return et === eventType;
        }), "Unknown event: " + eventType);
    };
    return EventEmitter;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @extends {EventEmitter}
 */ var $d1f87d24500ab009$var$VisibilityMonitor = /** @class */ function(_super) {
    $a92b69d2447c208d$export$a8ba968b8961cb8a(VisibilityMonitor, _super);
    function VisibilityMonitor() {
        var _this = _super.call(this, [
            "visible"
        ]) || this;
        var hidden;
        var visibilityChange;
        if (typeof document !== "undefined" && typeof document.addEventListener !== "undefined") {
            if (typeof document["hidden"] !== "undefined") {
                // Opera 12.10 and Firefox 18 and later support
                visibilityChange = "visibilitychange";
                hidden = "hidden";
            } else if (typeof document["mozHidden"] !== "undefined") {
                visibilityChange = "mozvisibilitychange";
                hidden = "mozHidden";
            } else if (typeof document["msHidden"] !== "undefined") {
                visibilityChange = "msvisibilitychange";
                hidden = "msHidden";
            } else if (typeof document["webkitHidden"] !== "undefined") {
                visibilityChange = "webkitvisibilitychange";
                hidden = "webkitHidden";
            }
        }
        // Initially, we always assume we are visible. This ensures that in browsers
        // without page visibility support or in cases where we are never visible
        // (e.g. chrome extension), we act as if we are visible, i.e. don't delay
        // reconnects
        _this.visible_ = true;
        if (visibilityChange) document.addEventListener(visibilityChange, function() {
            var visible = !document[hidden];
            if (visible !== _this.visible_) {
                _this.visible_ = visible;
                _this.trigger("visible", visible);
            }
        }, false);
        return _this;
    }
    VisibilityMonitor.getInstance = function() {
        return new VisibilityMonitor();
    };
    /**
     * @param {!string} eventType
     * @return {Array.<boolean>}
     */ VisibilityMonitor.prototype.getInitialEvent = function(eventType) {
        $01sTD.assert(eventType === "visible", "Unknown event type: " + eventType);
        return [
            this.visible_
        ];
    };
    return VisibilityMonitor;
}($d1f87d24500ab009$var$EventEmitter);
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Monitors online state (as reported by window.online/offline events).
 *
 * The expectation is that this could have many false positives (thinks we are online
 * when we're not), but no false negatives.  So we can safely use it to determine when
 * we definitely cannot reach the internet.
 *
 * @extends {EventEmitter}
 */ var $d1f87d24500ab009$var$OnlineMonitor = /** @class */ function(_super) {
    $a92b69d2447c208d$export$a8ba968b8961cb8a(OnlineMonitor, _super);
    function OnlineMonitor() {
        var _this = _super.call(this, [
            "online"
        ]) || this;
        _this.online_ = true;
        // We've had repeated complaints that Cordova apps can get stuck "offline", e.g.
        // https://forum.ionicframework.com/t/firebase-connection-is-lost-and-never-come-back/43810
        // It would seem that the 'online' event does not always fire consistently. So we disable it
        // for Cordova.
        if (typeof window !== "undefined" && typeof window.addEventListener !== "undefined" && !$01sTD.isMobileCordova()) {
            window.addEventListener("online", function() {
                if (!_this.online_) {
                    _this.online_ = true;
                    _this.trigger("online", true);
                }
            }, false);
            window.addEventListener("offline", function() {
                if (_this.online_) {
                    _this.online_ = false;
                    _this.trigger("online", false);
                }
            }, false);
        }
        return _this;
    }
    OnlineMonitor.getInstance = function() {
        return new OnlineMonitor();
    };
    /**
     * @param {!string} eventType
     * @return {Array.<boolean>}
     */ OnlineMonitor.prototype.getInitialEvent = function(eventType) {
        $01sTD.assert(eventType === "online", "Unknown event type: " + eventType);
        return [
            this.online_
        ];
    };
    /**
     * @return {boolean}
     */ OnlineMonitor.prototype.currentlyOnline = function() {
        return this.online_;
    };
    return OnlineMonitor;
}($d1f87d24500ab009$var$EventEmitter);
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * This class ensures the packets from the server arrive in order
 * This class takes data from the server and ensures it gets passed into the callbacks in order.
 * @constructor
 */ var $d1f87d24500ab009$var$PacketReceiver = /** @class */ function() {
    /**
     * @param onMessage_
     */ function PacketReceiver(onMessage_) {
        this.onMessage_ = onMessage_;
        this.pendingResponses = [];
        this.currentResponseNum = 0;
        this.closeAfterResponse = -1;
        this.onClose = null;
    }
    PacketReceiver.prototype.closeAfter = function(responseNum, callback) {
        this.closeAfterResponse = responseNum;
        this.onClose = callback;
        if (this.closeAfterResponse < this.currentResponseNum) {
            this.onClose();
            this.onClose = null;
        }
    };
    /**
     * Each message from the server comes with a response number, and an array of data. The responseNumber
     * allows us to ensure that we process them in the right order, since we can't be guaranteed that all
     * browsers will respond in the same order as the requests we sent
     * @param {number} requestNum
     * @param {Array} data
     */ PacketReceiver.prototype.handleResponse = function(requestNum, data) {
        var _this = this;
        this.pendingResponses[requestNum] = data;
        var _loop_1 = function() {
            var toProcess = this_1.pendingResponses[this_1.currentResponseNum];
            delete this_1.pendingResponses[this_1.currentResponseNum];
            var _loop_2 = function(i) {
                if (toProcess[i]) $d1f87d24500ab009$var$exceptionGuard(function() {
                    _this.onMessage_(toProcess[i]);
                });
            };
            for(var i = 0; i < toProcess.length; ++i)_loop_2(i);
            if (this_1.currentResponseNum === this_1.closeAfterResponse) {
                if (this_1.onClose) {
                    this_1.onClose();
                    this_1.onClose = null;
                }
                return "break";
            }
            this_1.currentResponseNum++;
        };
        var this_1 = this;
        while(this.pendingResponses[this.currentResponseNum]){
            var state_1 = _loop_1();
            if (state_1 === "break") break;
        }
    };
    return PacketReceiver;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // URL query parameters associated with longpolling
var $d1f87d24500ab009$var$FIREBASE_LONGPOLL_START_PARAM = "start";
var $d1f87d24500ab009$var$FIREBASE_LONGPOLL_CLOSE_COMMAND = "close";
var $d1f87d24500ab009$var$FIREBASE_LONGPOLL_COMMAND_CB_NAME = "pLPCommand";
var $d1f87d24500ab009$var$FIREBASE_LONGPOLL_DATA_CB_NAME = "pRTLPCB";
var $d1f87d24500ab009$var$FIREBASE_LONGPOLL_ID_PARAM = "id";
var $d1f87d24500ab009$var$FIREBASE_LONGPOLL_PW_PARAM = "pw";
var $d1f87d24500ab009$var$FIREBASE_LONGPOLL_SERIAL_PARAM = "ser";
var $d1f87d24500ab009$var$FIREBASE_LONGPOLL_CALLBACK_ID_PARAM = "cb";
var $d1f87d24500ab009$var$FIREBASE_LONGPOLL_SEGMENT_NUM_PARAM = "seg";
var $d1f87d24500ab009$var$FIREBASE_LONGPOLL_SEGMENTS_IN_PACKET = "ts";
var $d1f87d24500ab009$var$FIREBASE_LONGPOLL_DATA_PARAM = "d";
var $d1f87d24500ab009$var$FIREBASE_LONGPOLL_DISCONN_FRAME_REQUEST_PARAM = "dframe";
//Data size constants.
//TODO: Perf: the maximum length actually differs from browser to browser.
// We should check what browser we're on and set accordingly.
var $d1f87d24500ab009$var$MAX_URL_DATA_SIZE = 1870;
var $d1f87d24500ab009$var$SEG_HEADER_SIZE = 30; //ie: &seg=8299234&ts=982389123&d=
var $d1f87d24500ab009$var$MAX_PAYLOAD_SIZE = $d1f87d24500ab009$var$MAX_URL_DATA_SIZE - $d1f87d24500ab009$var$SEG_HEADER_SIZE;
/**
 * Keepalive period
 * send a fresh request at minimum every 25 seconds. Opera has a maximum request
 * length of 30 seconds that we can't exceed.
 * @const
 * @type {number}
 */ var $d1f87d24500ab009$var$KEEPALIVE_REQUEST_INTERVAL = 25000;
/**
 * How long to wait before aborting a long-polling connection attempt.
 * @const
 * @type {number}
 */ var $d1f87d24500ab009$var$LP_CONNECT_TIMEOUT = 30000;
/**
 * This class manages a single long-polling connection.
 *
 * @constructor
 * @implements {Transport}
 */ var $d1f87d24500ab009$var$BrowserPollConnection = /** @class */ function() {
    /**
     * @param connId An identifier for this connection, used for logging
     * @param repoInfo The info for the endpoint to send data to.
     * @param applicationId The Firebase App ID for this project.
     * @param transportSessionId Optional transportSessionid if we are reconnecting for an existing
     *                                         transport session
     * @param lastSessionId Optional lastSessionId if the PersistentConnection has already created a
     *                                     connection previously
     */ function BrowserPollConnection(connId, repoInfo, applicationId, transportSessionId, lastSessionId) {
        this.connId = connId;
        this.repoInfo = repoInfo;
        this.applicationId = applicationId;
        this.transportSessionId = transportSessionId;
        this.lastSessionId = lastSessionId;
        this.bytesSent = 0;
        this.bytesReceived = 0;
        this.everConnected_ = false;
        this.log_ = $d1f87d24500ab009$var$logWrapper(connId);
        this.stats_ = $d1f87d24500ab009$var$StatsManager.getCollection(repoInfo);
        this.urlFn = function(params) {
            return repoInfo.connectionURL($d1f87d24500ab009$var$LONG_POLLING, params);
        };
    }
    /**
     *
     * @param {function(Object)} onMessage Callback when messages arrive
     * @param {function()} onDisconnect Callback with connection lost.
     */ BrowserPollConnection.prototype.open = function(onMessage, onDisconnect) {
        var _this = this;
        this.curSegmentNum = 0;
        this.onDisconnect_ = onDisconnect;
        this.myPacketOrderer = new $d1f87d24500ab009$var$PacketReceiver(onMessage);
        this.isClosed_ = false;
        this.connectTimeoutTimer_ = setTimeout(function() {
            _this.log_("Timed out trying to connect.");
            // Make sure we clear the host cache
            _this.onClosed_();
            _this.connectTimeoutTimer_ = null;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        }, Math.floor($d1f87d24500ab009$var$LP_CONNECT_TIMEOUT));
        // Ensure we delay the creation of the iframe until the DOM is loaded.
        $d1f87d24500ab009$var$executeWhenDOMReady(function() {
            if (_this.isClosed_) return;
            //Set up a callback that gets triggered once a connection is set up.
            _this.scriptTagHolder = new $d1f87d24500ab009$var$FirebaseIFrameScriptHolder(function() {
                var args = [];
                for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                var _a = $a92b69d2447c208d$export$8d051b38c9118094(args, 5), command = _a[0], arg1 = _a[1], arg2 = _a[2], arg3 = _a[3], arg4 = _a[4];
                _this.incrementIncomingBytes_(args);
                if (!_this.scriptTagHolder) return; // we closed the connection.
                if (_this.connectTimeoutTimer_) {
                    clearTimeout(_this.connectTimeoutTimer_);
                    _this.connectTimeoutTimer_ = null;
                }
                _this.everConnected_ = true;
                if (command === $d1f87d24500ab009$var$FIREBASE_LONGPOLL_START_PARAM) {
                    _this.id = arg1;
                    _this.password = arg2;
                } else if (command === $d1f87d24500ab009$var$FIREBASE_LONGPOLL_CLOSE_COMMAND) {
                    // Don't clear the host cache. We got a response from the server, so we know it's reachable
                    if (arg1) {
                        // We aren't expecting any more data (other than what the server's already in the process of sending us
                        // through our already open polls), so don't send any more.
                        _this.scriptTagHolder.sendNewPolls = false;
                        // arg1 in this case is the last response number sent by the server. We should try to receive
                        // all of the responses up to this one before closing
                        _this.myPacketOrderer.closeAfter(arg1, function() {
                            _this.onClosed_();
                        });
                    } else _this.onClosed_();
                } else throw new Error("Unrecognized command received: " + command);
            }, function() {
                var args = [];
                for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                var _a = $a92b69d2447c208d$export$8d051b38c9118094(args, 2), pN = _a[0], data = _a[1];
                _this.incrementIncomingBytes_(args);
                _this.myPacketOrderer.handleResponse(pN, data);
            }, function() {
                _this.onClosed_();
            }, _this.urlFn);
            //Send the initial request to connect. The serial number is simply to keep the browser from pulling previous results
            //from cache.
            var urlParams = {};
            urlParams[$d1f87d24500ab009$var$FIREBASE_LONGPOLL_START_PARAM] = "t";
            urlParams[$d1f87d24500ab009$var$FIREBASE_LONGPOLL_SERIAL_PARAM] = Math.floor(Math.random() * 100000000);
            if (_this.scriptTagHolder.uniqueCallbackIdentifier) urlParams[$d1f87d24500ab009$var$FIREBASE_LONGPOLL_CALLBACK_ID_PARAM] = _this.scriptTagHolder.uniqueCallbackIdentifier;
            urlParams[$d1f87d24500ab009$var$VERSION_PARAM] = $d1f87d24500ab009$var$PROTOCOL_VERSION;
            if (_this.transportSessionId) urlParams[$d1f87d24500ab009$var$TRANSPORT_SESSION_PARAM] = _this.transportSessionId;
            if (_this.lastSessionId) urlParams[$d1f87d24500ab009$var$LAST_SESSION_PARAM] = _this.lastSessionId;
            if (_this.applicationId) urlParams[$d1f87d24500ab009$var$APPLICATION_ID_PARAM] = _this.applicationId;
            if (typeof location !== "undefined" && location.href && location.href.indexOf($d1f87d24500ab009$var$FORGE_DOMAIN) !== -1) urlParams[$d1f87d24500ab009$var$REFERER_PARAM] = $d1f87d24500ab009$var$FORGE_REF;
            var connectURL = _this.urlFn(urlParams);
            _this.log_("Connecting via long-poll to " + connectURL);
            _this.scriptTagHolder.addTag(connectURL, function() {
            /* do nothing */ });
        });
    };
    /**
     * Call this when a handshake has completed successfully and we want to consider the connection established
     */ BrowserPollConnection.prototype.start = function() {
        this.scriptTagHolder.startLongPoll(this.id, this.password);
        this.addDisconnectPingFrame(this.id, this.password);
    };
    /**
     * Forces long polling to be considered as a potential transport
     */ BrowserPollConnection.forceAllow = function() {
        BrowserPollConnection.forceAllow_ = true;
    };
    /**
     * Forces longpolling to not be considered as a potential transport
     */ BrowserPollConnection.forceDisallow = function() {
        BrowserPollConnection.forceDisallow_ = true;
    };
    // Static method, use string literal so it can be accessed in a generic way
    BrowserPollConnection.isAvailable = function() {
        if ($01sTD.isNodeSdk()) return false;
        else if (BrowserPollConnection.forceAllow_) return true;
        else // NOTE: In React-Native there's normally no 'document', but if you debug a React-Native app in
        // the Chrome debugger, 'document' is defined, but document.createElement is null (2015/06/08).
        return !BrowserPollConnection.forceDisallow_ && typeof document !== "undefined" && document.createElement != null && !$d1f87d24500ab009$var$isChromeExtensionContentScript() && !$d1f87d24500ab009$var$isWindowsStoreApp();
    };
    /**
     * No-op for polling
     */ BrowserPollConnection.prototype.markConnectionHealthy = function() {};
    /**
     * Stops polling and cleans up the iframe
     * @private
     */ BrowserPollConnection.prototype.shutdown_ = function() {
        this.isClosed_ = true;
        if (this.scriptTagHolder) {
            this.scriptTagHolder.close();
            this.scriptTagHolder = null;
        }
        //remove the disconnect frame, which will trigger an XHR call to the server to tell it we're leaving.
        if (this.myDisconnFrame) {
            document.body.removeChild(this.myDisconnFrame);
            this.myDisconnFrame = null;
        }
        if (this.connectTimeoutTimer_) {
            clearTimeout(this.connectTimeoutTimer_);
            this.connectTimeoutTimer_ = null;
        }
    };
    /**
     * Triggered when this transport is closed
     * @private
     */ BrowserPollConnection.prototype.onClosed_ = function() {
        if (!this.isClosed_) {
            this.log_("Longpoll is closing itself");
            this.shutdown_();
            if (this.onDisconnect_) {
                this.onDisconnect_(this.everConnected_);
                this.onDisconnect_ = null;
            }
        }
    };
    /**
     * External-facing close handler. RealTime has requested we shut down. Kill our connection and tell the server
     * that we've left.
     */ BrowserPollConnection.prototype.close = function() {
        if (!this.isClosed_) {
            this.log_("Longpoll is being closed.");
            this.shutdown_();
        }
    };
    /**
     * Send the JSON object down to the server. It will need to be stringified, base64 encoded, and then
     * broken into chunks (since URLs have a small maximum length).
     * @param {!Object} data The JSON data to transmit.
     */ BrowserPollConnection.prototype.send = function(data) {
        var dataStr = $01sTD.stringify(data);
        this.bytesSent += dataStr.length;
        this.stats_.incrementCounter("bytes_sent", dataStr.length);
        //first, lets get the base64-encoded data
        var base64data = $01sTD.base64Encode(dataStr);
        //We can only fit a certain amount in each URL, so we need to split this request
        //up into multiple pieces if it doesn't fit in one request.
        var dataSegs = $d1f87d24500ab009$var$splitStringBySize(base64data, $d1f87d24500ab009$var$MAX_PAYLOAD_SIZE);
        //Enqueue each segment for transmission. We assign each chunk a sequential ID and a total number
        //of segments so that we can reassemble the packet on the server.
        for(var i = 0; i < dataSegs.length; i++){
            this.scriptTagHolder.enqueueSegment(this.curSegmentNum, dataSegs.length, dataSegs[i]);
            this.curSegmentNum++;
        }
    };
    /**
     * This is how we notify the server that we're leaving.
     * We aren't able to send requests with DHTML on a window close event, but we can
     * trigger XHR requests in some browsers (everything but Opera basically).
     * @param {!string} id
     * @param {!string} pw
     */ BrowserPollConnection.prototype.addDisconnectPingFrame = function(id, pw) {
        if ($01sTD.isNodeSdk()) return;
        this.myDisconnFrame = document.createElement("iframe");
        var urlParams = {};
        urlParams[$d1f87d24500ab009$var$FIREBASE_LONGPOLL_DISCONN_FRAME_REQUEST_PARAM] = "t";
        urlParams[$d1f87d24500ab009$var$FIREBASE_LONGPOLL_ID_PARAM] = id;
        urlParams[$d1f87d24500ab009$var$FIREBASE_LONGPOLL_PW_PARAM] = pw;
        this.myDisconnFrame.src = this.urlFn(urlParams);
        this.myDisconnFrame.style.display = "none";
        document.body.appendChild(this.myDisconnFrame);
    };
    /**
     * Used to track the bytes received by this client
     * @param {*} args
     * @private
     */ BrowserPollConnection.prototype.incrementIncomingBytes_ = function(args) {
        // TODO: This is an annoying perf hit just to track the number of incoming bytes.  Maybe it should be opt-in.
        var bytesReceived = $01sTD.stringify(args).length;
        this.bytesReceived += bytesReceived;
        this.stats_.incrementCounter("bytes_received", bytesReceived);
    };
    return BrowserPollConnection;
}();
/*********************************************************************************************
 * A wrapper around an iframe that is used as a long-polling script holder.
 * @constructor
 *********************************************************************************************/ var $d1f87d24500ab009$var$FirebaseIFrameScriptHolder = /** @class */ function() {
    /**
     * @param commandCB - The callback to be called when control commands are recevied from the server.
     * @param onMessageCB - The callback to be triggered when responses arrive from the server.
     * @param onDisconnect - The callback to be triggered when this tag holder is closed
     * @param urlFn - A function that provides the URL of the endpoint to send data to.
     */ function FirebaseIFrameScriptHolder(commandCB, onMessageCB, onDisconnect, urlFn) {
        this.onDisconnect = onDisconnect;
        this.urlFn = urlFn;
        //We maintain a count of all of the outstanding requests, because if we have too many active at once it can cause
        //problems in some browsers.
        this.outstandingRequests = new Set();
        //A queue of the pending segments waiting for transmission to the server.
        this.pendingSegs = [];
        //A serial number. We use this for two things:
        // 1) A way to ensure the browser doesn't cache responses to polls
        // 2) A way to make the server aware when long-polls arrive in a different order than we started them. The
        //    server needs to release both polls in this case or it will cause problems in Opera since Opera can only execute
        //    JSONP code in the order it was added to the iframe.
        this.currentSerial = Math.floor(Math.random() * 100000000);
        // This gets set to false when we're "closing down" the connection (e.g. we're switching transports but there's still
        // incoming data from the server that we're waiting for).
        this.sendNewPolls = true;
        if (!$01sTD.isNodeSdk()) {
            //Each script holder registers a couple of uniquely named callbacks with the window. These are called from the
            //iframes where we put the long-polling script tags. We have two callbacks:
            //   1) Command Callback - Triggered for control issues, like starting a connection.
            //   2) Message Callback - Triggered when new data arrives.
            this.uniqueCallbackIdentifier = $d1f87d24500ab009$var$LUIDGenerator();
            window[$d1f87d24500ab009$var$FIREBASE_LONGPOLL_COMMAND_CB_NAME + this.uniqueCallbackIdentifier] = commandCB;
            window[$d1f87d24500ab009$var$FIREBASE_LONGPOLL_DATA_CB_NAME + this.uniqueCallbackIdentifier] = onMessageCB;
            //Create an iframe for us to add script tags to.
            this.myIFrame = FirebaseIFrameScriptHolder.createIFrame_();
            // Set the iframe's contents.
            var script = "";
            // if we set a javascript url, it's IE and we need to set the document domain. The javascript url is sufficient
            // for ie9, but ie8 needs to do it again in the document itself.
            if (this.myIFrame.src && this.myIFrame.src.substr(0, 11) === "javascript:") {
                var currentDomain = document.domain;
                script = '<script>document.domain="' + currentDomain + '";</script>';
            }
            var iframeContents = "<html><body>" + script + "</body></html>";
            try {
                this.myIFrame.doc.open();
                this.myIFrame.doc.write(iframeContents);
                this.myIFrame.doc.close();
            } catch (e) {
                $d1f87d24500ab009$var$log("frame writing exception");
                if (e.stack) $d1f87d24500ab009$var$log(e.stack);
                $d1f87d24500ab009$var$log(e);
            }
        } else {
            this.commandCB = commandCB;
            this.onMessageCB = onMessageCB;
        }
    }
    /**
     * Each browser has its own funny way to handle iframes. Here we mush them all together into one object that I can
     * actually use.
     * @private
     * @return {Element}
     */ FirebaseIFrameScriptHolder.createIFrame_ = function() {
        var iframe = document.createElement("iframe");
        iframe.style.display = "none";
        // This is necessary in order to initialize the document inside the iframe
        if (document.body) {
            document.body.appendChild(iframe);
            try {
                // If document.domain has been modified in IE, this will throw an error, and we need to set the
                // domain of the iframe's document manually. We can do this via a javascript: url as the src attribute
                // Also note that we must do this *after* the iframe has been appended to the page. Otherwise it doesn't work.
                var a = iframe.contentWindow.document;
                if (!a) // Apologies for the log-spam, I need to do something to keep closure from optimizing out the assignment above.
                $d1f87d24500ab009$var$log("No IE domain setting required");
            } catch (e) {
                var domain = document.domain;
                iframe.src = "javascript:void((function(){document.open();document.domain='" + domain + "';document.close();})())";
            }
        } else // LongPollConnection attempts to delay initialization until the document is ready, so hopefully this
        // never gets hit.
        throw "Document body has not initialized. Wait to initialize Firebase until after the document is ready.";
        // Get the document of the iframe in a browser-specific way.
        if (iframe.contentDocument) iframe.doc = iframe.contentDocument; // Firefox, Opera, Safari
        else if (iframe.contentWindow) iframe.doc = iframe.contentWindow.document; // Internet Explorer
        else if (iframe.document) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        iframe.doc = iframe.document; //others?
        return iframe;
    };
    /**
     * Cancel all outstanding queries and remove the frame.
     */ FirebaseIFrameScriptHolder.prototype.close = function() {
        var _this = this;
        //Mark this iframe as dead, so no new requests are sent.
        this.alive = false;
        if (this.myIFrame) {
            //We have to actually remove all of the html inside this iframe before removing it from the
            //window, or IE will continue loading and executing the script tags we've already added, which
            //can lead to some errors being thrown. Setting innerHTML seems to be the easiest way to do this.
            this.myIFrame.doc.body.innerHTML = "";
            setTimeout(function() {
                if (_this.myIFrame !== null) {
                    document.body.removeChild(_this.myIFrame);
                    _this.myIFrame = null;
                }
            }, Math.floor(0));
        }
        // Protect from being called recursively.
        var onDisconnect = this.onDisconnect;
        if (onDisconnect) {
            this.onDisconnect = null;
            onDisconnect();
        }
    };
    /**
     * Actually start the long-polling session by adding the first script tag(s) to the iframe.
     * @param {!string} id - The ID of this connection
     * @param {!string} pw - The password for this connection
     */ FirebaseIFrameScriptHolder.prototype.startLongPoll = function(id, pw) {
        this.myID = id;
        this.myPW = pw;
        this.alive = true;
        //send the initial request. If there are requests queued, make sure that we transmit as many as we are currently able to.
        while(this.newRequest_());
    };
    /**
     * This is called any time someone might want a script tag to be added. It adds a script tag when there aren't
     * too many outstanding requests and we are still alive.
     *
     * If there are outstanding packet segments to send, it sends one. If there aren't, it sends a long-poll anyways if
     * needed.
     */ FirebaseIFrameScriptHolder.prototype.newRequest_ = function() {
        // We keep one outstanding request open all the time to receive data, but if we need to send data
        // (pendingSegs.length > 0) then we create a new request to send the data.  The server will automatically
        // close the old request.
        if (this.alive && this.sendNewPolls && this.outstandingRequests.size < (this.pendingSegs.length > 0 ? 2 : 1)) {
            //construct our url
            this.currentSerial++;
            var urlParams = {};
            urlParams[$d1f87d24500ab009$var$FIREBASE_LONGPOLL_ID_PARAM] = this.myID;
            urlParams[$d1f87d24500ab009$var$FIREBASE_LONGPOLL_PW_PARAM] = this.myPW;
            urlParams[$d1f87d24500ab009$var$FIREBASE_LONGPOLL_SERIAL_PARAM] = this.currentSerial;
            var theURL = this.urlFn(urlParams);
            //Now add as much data as we can.
            var curDataString = "";
            var i = 0;
            while(this.pendingSegs.length > 0){
                //first, lets see if the next segment will fit.
                var nextSeg = this.pendingSegs[0];
                if (nextSeg.d.length + $d1f87d24500ab009$var$SEG_HEADER_SIZE + curDataString.length <= $d1f87d24500ab009$var$MAX_URL_DATA_SIZE) {
                    //great, the segment will fit. Lets append it.
                    var theSeg = this.pendingSegs.shift();
                    curDataString = curDataString + "&" + $d1f87d24500ab009$var$FIREBASE_LONGPOLL_SEGMENT_NUM_PARAM + i + "=" + theSeg.seg + "&" + $d1f87d24500ab009$var$FIREBASE_LONGPOLL_SEGMENTS_IN_PACKET + i + "=" + theSeg.ts + "&" + $d1f87d24500ab009$var$FIREBASE_LONGPOLL_DATA_PARAM + i + "=" + theSeg.d;
                    i++;
                } else break;
            }
            theURL = theURL + curDataString;
            this.addLongPollTag_(theURL, this.currentSerial);
            return true;
        } else return false;
    };
    /**
     * Queue a packet for transmission to the server.
     * @param segnum - A sequential id for this packet segment used for reassembly
     * @param totalsegs - The total number of segments in this packet
     * @param data - The data for this segment.
     */ FirebaseIFrameScriptHolder.prototype.enqueueSegment = function(segnum, totalsegs, data) {
        //add this to the queue of segments to send.
        this.pendingSegs.push({
            seg: segnum,
            ts: totalsegs,
            d: data
        });
        //send the data immediately if there isn't already data being transmitted, unless
        //startLongPoll hasn't been called yet.
        if (this.alive) this.newRequest_();
    };
    /**
     * Add a script tag for a regular long-poll request.
     * @param {!string} url - The URL of the script tag.
     * @param {!number} serial - The serial number of the request.
     * @private
     */ FirebaseIFrameScriptHolder.prototype.addLongPollTag_ = function(url, serial) {
        var _this = this;
        //remember that we sent this request.
        this.outstandingRequests.add(serial);
        var doNewRequest = function() {
            _this.outstandingRequests.delete(serial);
            _this.newRequest_();
        };
        // If this request doesn't return on its own accord (by the server sending us some data), we'll
        // create a new one after the KEEPALIVE interval to make sure we always keep a fresh request open.
        var keepaliveTimeout = setTimeout(doNewRequest, Math.floor($d1f87d24500ab009$var$KEEPALIVE_REQUEST_INTERVAL));
        var readyStateCB = function() {
            // Request completed.  Cancel the keepalive.
            clearTimeout(keepaliveTimeout);
            // Trigger a new request so we can continue receiving data.
            doNewRequest();
        };
        this.addTag(url, readyStateCB);
    };
    /**
     * Add an arbitrary script tag to the iframe.
     * @param {!string} url - The URL for the script tag source.
     * @param {!function()} loadCB - A callback to be triggered once the script has loaded.
     */ FirebaseIFrameScriptHolder.prototype.addTag = function(url, loadCB) {
        var _this = this;
        if ($01sTD.isNodeSdk()) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.doNodeLongPoll(url, loadCB);
        else setTimeout(function() {
            try {
                // if we're already closed, don't add this poll
                if (!_this.sendNewPolls) return;
                var newScript_1 = _this.myIFrame.doc.createElement("script");
                newScript_1.type = "text/javascript";
                newScript_1.async = true;
                newScript_1.src = url;
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                newScript_1.onload = newScript_1.onreadystatechange = function() {
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    var rstate = newScript_1.readyState;
                    if (!rstate || rstate === "loaded" || rstate === "complete") {
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        newScript_1.onload = newScript_1.onreadystatechange = null;
                        if (newScript_1.parentNode) newScript_1.parentNode.removeChild(newScript_1);
                        loadCB();
                    }
                };
                newScript_1.onerror = function() {
                    $d1f87d24500ab009$var$log("Long-poll script failed to load: " + url);
                    _this.sendNewPolls = false;
                    _this.close();
                };
                _this.myIFrame.doc.body.appendChild(newScript_1);
            } catch (e) {
            // TODO: we should make this error visible somehow
            }
        }, Math.floor(1));
    };
    return FirebaseIFrameScriptHolder;
}();
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** The semver (www.semver.org) version of the SDK. */ var $d1f87d24500ab009$var$SDK_VERSION = "";
// SDK_VERSION should be set before any database instance is created
function $d1f87d24500ab009$var$setSDKVersion(version) {
    $d1f87d24500ab009$var$SDK_VERSION = version;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $d1f87d24500ab009$var$WEBSOCKET_MAX_FRAME_SIZE = 16384;
var $d1f87d24500ab009$var$WEBSOCKET_KEEPALIVE_INTERVAL = 45000;
var $d1f87d24500ab009$var$WebSocketImpl = null;
if (typeof MozWebSocket !== "undefined") $d1f87d24500ab009$var$WebSocketImpl = MozWebSocket;
else if (typeof WebSocket !== "undefined") $d1f87d24500ab009$var$WebSocketImpl = WebSocket;
/**
 * Create a new websocket connection with the given callbacks.
 * @constructor
 * @implements {Transport}
 */ var $d1f87d24500ab009$var$WebSocketConnection = /** @class */ function() {
    /**
     * @param connId identifier for this transport
     * @param repoInfo The info for the websocket endpoint.
     * @param applicationId The Firebase App ID for this project.
     * @param transportSessionId Optional transportSessionId if this is connecting to an existing transport
     *                                         session
     * @param lastSessionId Optional lastSessionId if there was a previous connection
     */ function WebSocketConnection(connId, repoInfo, applicationId, transportSessionId, lastSessionId) {
        this.connId = connId;
        this.applicationId = applicationId;
        this.keepaliveTimer = null;
        this.frames = null;
        this.totalFrames = 0;
        this.bytesSent = 0;
        this.bytesReceived = 0;
        this.log_ = $d1f87d24500ab009$var$logWrapper(this.connId);
        this.stats_ = $d1f87d24500ab009$var$StatsManager.getCollection(repoInfo);
        this.connURL = WebSocketConnection.connectionURL_(repoInfo, transportSessionId, lastSessionId);
        this.nodeAdmin = repoInfo.nodeAdmin;
    }
    /**
     * @param {RepoInfo} repoInfo The info for the websocket endpoint.
     * @param {string=} transportSessionId Optional transportSessionId if this is connecting to an existing transport
     *                                         session
     * @param {string=} lastSessionId Optional lastSessionId if there was a previous connection
     * @return {string} connection url
     * @private
     */ WebSocketConnection.connectionURL_ = function(repoInfo, transportSessionId, lastSessionId) {
        var urlParams = {};
        urlParams[$d1f87d24500ab009$var$VERSION_PARAM] = $d1f87d24500ab009$var$PROTOCOL_VERSION;
        if (!$01sTD.isNodeSdk() && typeof location !== "undefined" && location.href && location.href.indexOf($d1f87d24500ab009$var$FORGE_DOMAIN) !== -1) urlParams[$d1f87d24500ab009$var$REFERER_PARAM] = $d1f87d24500ab009$var$FORGE_REF;
        if (transportSessionId) urlParams[$d1f87d24500ab009$var$TRANSPORT_SESSION_PARAM] = transportSessionId;
        if (lastSessionId) urlParams[$d1f87d24500ab009$var$LAST_SESSION_PARAM] = lastSessionId;
        return repoInfo.connectionURL($d1f87d24500ab009$var$WEBSOCKET, urlParams);
    };
    /**
     *
     * @param onMessage Callback when messages arrive
     * @param onDisconnect Callback with connection lost.
     */ WebSocketConnection.prototype.open = function(onMessage, onDisconnect) {
        var _this = this;
        this.onDisconnect = onDisconnect;
        this.onMessage = onMessage;
        this.log_("Websocket connecting to " + this.connURL);
        this.everConnected_ = false;
        // Assume failure until proven otherwise.
        $d1f87d24500ab009$var$PersistentStorage.set("previous_websocket_failure", true);
        try {
            if ($01sTD.isNodeSdk()) {
                var device = this.nodeAdmin ? "AdminNode" : "Node";
                // UA Format: Firebase/<wire_protocol>/<sdk_version>/<platform>/<device>
                var options = {
                    headers: {
                        "User-Agent": "Firebase/" + $d1f87d24500ab009$var$PROTOCOL_VERSION + "/" + $d1f87d24500ab009$var$SDK_VERSION + "/" + $hPtJY.platform + "/" + device,
                        "X-Firebase-GMPID": this.applicationId || ""
                    }
                };
                // Plumb appropriate http_proxy environment variable into faye-websocket if it exists.
                var env = {};
                var proxy = this.connURL.indexOf("wss://") === 0 ? env["HTTPS_PROXY"] || env["https_proxy"] : env["HTTP_PROXY"] || env["http_proxy"];
                if (proxy) options["proxy"] = {
                    origin: proxy
                };
                this.mySock = new $d1f87d24500ab009$var$WebSocketImpl(this.connURL, [], options);
            } else {
                var options = {
                    headers: {
                        "X-Firebase-GMPID": this.applicationId || ""
                    }
                };
                this.mySock = new $d1f87d24500ab009$var$WebSocketImpl(this.connURL, [], options);
            }
        } catch (e) {
            this.log_("Error instantiating WebSocket.");
            var error = e.message || e.data;
            if (error) this.log_(error);
            this.onClosed_();
            return;
        }
        this.mySock.onopen = function() {
            _this.log_("Websocket connected.");
            _this.everConnected_ = true;
        };
        this.mySock.onclose = function() {
            _this.log_("Websocket connection was disconnected.");
            _this.mySock = null;
            _this.onClosed_();
        };
        this.mySock.onmessage = function(m) {
            _this.handleIncomingFrame(m);
        };
        this.mySock.onerror = function(e) {
            _this.log_("WebSocket error.  Closing connection.");
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var error = e.message || e.data;
            if (error) _this.log_(error);
            _this.onClosed_();
        };
    };
    /**
     * No-op for websockets, we don't need to do anything once the connection is confirmed as open
     */ WebSocketConnection.prototype.start = function() {};
    WebSocketConnection.forceDisallow = function() {
        WebSocketConnection.forceDisallow_ = true;
    };
    WebSocketConnection.isAvailable = function() {
        var isOldAndroid = false;
        if (typeof navigator !== "undefined" && navigator.userAgent) {
            var oldAndroidRegex = /Android ([0-9]{0,}\.[0-9]{0,})/;
            var oldAndroidMatch = navigator.userAgent.match(oldAndroidRegex);
            if (oldAndroidMatch && oldAndroidMatch.length > 1) {
                if (parseFloat(oldAndroidMatch[1]) < 4.4) isOldAndroid = true;
            }
        }
        return !isOldAndroid && $d1f87d24500ab009$var$WebSocketImpl !== null && !WebSocketConnection.forceDisallow_;
    };
    /**
     * Returns true if we previously failed to connect with this transport.
     * @return {boolean}
     */ WebSocketConnection.previouslyFailed = function() {
        // If our persistent storage is actually only in-memory storage,
        // we default to assuming that it previously failed to be safe.
        return $d1f87d24500ab009$var$PersistentStorage.isInMemoryStorage || $d1f87d24500ab009$var$PersistentStorage.get("previous_websocket_failure") === true;
    };
    WebSocketConnection.prototype.markConnectionHealthy = function() {
        $d1f87d24500ab009$var$PersistentStorage.remove("previous_websocket_failure");
    };
    WebSocketConnection.prototype.appendFrame_ = function(data) {
        this.frames.push(data);
        if (this.frames.length === this.totalFrames) {
            var fullMess = this.frames.join("");
            this.frames = null;
            var jsonMess = $01sTD.jsonEval(fullMess);
            //handle the message
            this.onMessage(jsonMess);
        }
    };
    /**
     * @param {number} frameCount The number of frames we are expecting from the server
     * @private
     */ WebSocketConnection.prototype.handleNewFrameCount_ = function(frameCount) {
        this.totalFrames = frameCount;
        this.frames = [];
    };
    /**
     * Attempts to parse a frame count out of some text. If it can't, assumes a value of 1
     * @param {!String} data
     * @return {?String} Any remaining data to be process, or null if there is none
     * @private
     */ WebSocketConnection.prototype.extractFrameCount_ = function(data) {
        $01sTD.assert(this.frames === null, "We already have a frame buffer");
        // TODO: The server is only supposed to send up to 9999 frames (i.e. length <= 4), but that isn't being enforced
        // currently.  So allowing larger frame counts (length <= 6).  See https://app.asana.com/0/search/8688598998380/8237608042508
        if (data.length <= 6) {
            var frameCount = Number(data);
            if (!isNaN(frameCount)) {
                this.handleNewFrameCount_(frameCount);
                return null;
            }
        }
        this.handleNewFrameCount_(1);
        return data;
    };
    /**
     * Process a websocket frame that has arrived from the server.
     * @param mess The frame data
     */ WebSocketConnection.prototype.handleIncomingFrame = function(mess) {
        if (this.mySock === null) return; // Chrome apparently delivers incoming packets even after we .close() the connection sometimes.
        var data = mess["data"];
        this.bytesReceived += data.length;
        this.stats_.incrementCounter("bytes_received", data.length);
        this.resetKeepAlive();
        if (this.frames !== null) // we're buffering
        this.appendFrame_(data);
        else {
            // try to parse out a frame count, otherwise, assume 1 and process it
            var remainingData = this.extractFrameCount_(data);
            if (remainingData !== null) this.appendFrame_(remainingData);
        }
    };
    /**
     * Send a message to the server
     * @param {Object} data The JSON object to transmit
     */ WebSocketConnection.prototype.send = function(data) {
        this.resetKeepAlive();
        var dataStr = $01sTD.stringify(data);
        this.bytesSent += dataStr.length;
        this.stats_.incrementCounter("bytes_sent", dataStr.length);
        //We can only fit a certain amount in each websocket frame, so we need to split this request
        //up into multiple pieces if it doesn't fit in one request.
        var dataSegs = $d1f87d24500ab009$var$splitStringBySize(dataStr, $d1f87d24500ab009$var$WEBSOCKET_MAX_FRAME_SIZE);
        //Send the length header
        if (dataSegs.length > 1) this.sendString_(String(dataSegs.length));
        //Send the actual data in segments.
        for(var i = 0; i < dataSegs.length; i++)this.sendString_(dataSegs[i]);
    };
    WebSocketConnection.prototype.shutdown_ = function() {
        this.isClosed_ = true;
        if (this.keepaliveTimer) {
            clearInterval(this.keepaliveTimer);
            this.keepaliveTimer = null;
        }
        if (this.mySock) {
            this.mySock.close();
            this.mySock = null;
        }
    };
    WebSocketConnection.prototype.onClosed_ = function() {
        if (!this.isClosed_) {
            this.log_("WebSocket is closing itself");
            this.shutdown_();
            // since this is an internal close, trigger the close listener
            if (this.onDisconnect) {
                this.onDisconnect(this.everConnected_);
                this.onDisconnect = null;
            }
        }
    };
    /**
     * External-facing close handler.
     * Close the websocket and kill the connection.
     */ WebSocketConnection.prototype.close = function() {
        if (!this.isClosed_) {
            this.log_("WebSocket is being closed");
            this.shutdown_();
        }
    };
    /**
     * Kill the current keepalive timer and start a new one, to ensure that it always fires N seconds after
     * the last activity.
     */ WebSocketConnection.prototype.resetKeepAlive = function() {
        var _this = this;
        clearInterval(this.keepaliveTimer);
        this.keepaliveTimer = setInterval(function() {
            //If there has been no websocket activity for a while, send a no-op
            if (_this.mySock) _this.sendString_("0");
            _this.resetKeepAlive();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        }, Math.floor($d1f87d24500ab009$var$WEBSOCKET_KEEPALIVE_INTERVAL));
    };
    /**
     * Send a string over the websocket.
     *
     * @param {string} str String to send.
     * @private
     */ WebSocketConnection.prototype.sendString_ = function(str) {
        // Firefox seems to sometimes throw exceptions (NS_ERROR_UNEXPECTED) from websocket .send()
        // calls for some unknown reason.  We treat these as an error and disconnect.
        // See https://app.asana.com/0/58926111402292/68021340250410
        try {
            this.mySock.send(str);
        } catch (e) {
            this.log_("Exception thrown from WebSocket.send():", e.message || e.data, "Closing connection.");
            setTimeout(this.onClosed_.bind(this), 0);
        }
    };
    /**
     * Number of response before we consider the connection "healthy."
     * @type {number}
     */ WebSocketConnection.responsesRequiredToBeHealthy = 2;
    /**
     * Time to wait for the connection te become healthy before giving up.
     * @type {number}
     */ WebSocketConnection.healthyTimeout = 30000;
    return WebSocketConnection;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Currently simplistic, this class manages what transport a Connection should use at various stages of its
 * lifecycle.
 *
 * It starts with longpolling in a browser, and httppolling on node. It then upgrades to websockets if
 * they are available.
 * @constructor
 */ var $d1f87d24500ab009$var$TransportManager = /** @class */ function() {
    /**
     * @param {!RepoInfo} repoInfo Metadata around the namespace we're connecting to
     */ function TransportManager(repoInfo) {
        this.initTransports_(repoInfo);
    }
    Object.defineProperty(TransportManager, "ALL_TRANSPORTS", {
        /**
         * @const
         * @type {!Array.<function(new:Transport, string, RepoInfo, string=)>}
         */ get: function() {
            return [
                $d1f87d24500ab009$var$BrowserPollConnection,
                $d1f87d24500ab009$var$WebSocketConnection
            ];
        },
        enumerable: false,
        configurable: true
    });
    /**
     * @param {!RepoInfo} repoInfo
     * @private
     */ TransportManager.prototype.initTransports_ = function(repoInfo) {
        var e_1, _a;
        var isWebSocketsAvailable = $d1f87d24500ab009$var$WebSocketConnection && $d1f87d24500ab009$var$WebSocketConnection["isAvailable"]();
        var isSkipPollConnection = isWebSocketsAvailable && !$d1f87d24500ab009$var$WebSocketConnection.previouslyFailed();
        if (repoInfo.webSocketOnly) {
            if (!isWebSocketsAvailable) $d1f87d24500ab009$var$warn("wss:// URL used, but browser isn't known to support websockets.  Trying anyway.");
            isSkipPollConnection = true;
        }
        if (isSkipPollConnection) this.transports_ = [
            $d1f87d24500ab009$var$WebSocketConnection
        ];
        else {
            var transports = this.transports_ = [];
            try {
                for(var _b = $a92b69d2447c208d$export$19a8beecd37a4c45(TransportManager.ALL_TRANSPORTS), _c = _b.next(); !_c.done; _c = _b.next()){
                    var transport = _c.value;
                    if (transport && transport["isAvailable"]()) transports.push(transport);
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
        }
    };
    /**
     * @return {function(new:Transport, !string, !RepoInfo, string=, string=)} The constructor for the
     * initial transport to use
     */ TransportManager.prototype.initialTransport = function() {
        if (this.transports_.length > 0) return this.transports_[0];
        else throw new Error("No transports available");
    };
    /**
     * @return {?function(new:Transport, function(),function(), string=)} The constructor for the next
     * transport, or null
     */ TransportManager.prototype.upgradeTransport = function() {
        if (this.transports_.length > 1) return this.transports_[1];
        else return null;
    };
    return TransportManager;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Abort upgrade attempt if it takes longer than 60s.
var $d1f87d24500ab009$var$UPGRADE_TIMEOUT = 60000;
// For some transports (WebSockets), we need to "validate" the transport by exchanging a few requests and responses.
// If we haven't sent enough requests within 5s, we'll start sending noop ping requests.
var $d1f87d24500ab009$var$DELAY_BEFORE_SENDING_EXTRA_REQUESTS = 5000;
// If the initial data sent triggers a lot of bandwidth (i.e. it's a large put or a listen for a large amount of data)
// then we may not be able to exchange our ping/pong requests within the healthy timeout.  So if we reach the timeout
// but we've sent/received enough bytes, we don't cancel the connection.
var $d1f87d24500ab009$var$BYTES_SENT_HEALTHY_OVERRIDE = 10240;
var $d1f87d24500ab009$var$BYTES_RECEIVED_HEALTHY_OVERRIDE = 102400;
var $d1f87d24500ab009$var$MESSAGE_TYPE = "t";
var $d1f87d24500ab009$var$MESSAGE_DATA = "d";
var $d1f87d24500ab009$var$CONTROL_SHUTDOWN = "s";
var $d1f87d24500ab009$var$CONTROL_RESET = "r";
var $d1f87d24500ab009$var$CONTROL_ERROR = "e";
var $d1f87d24500ab009$var$CONTROL_PONG = "o";
var $d1f87d24500ab009$var$SWITCH_ACK = "a";
var $d1f87d24500ab009$var$END_TRANSMISSION = "n";
var $d1f87d24500ab009$var$PING = "p";
var $d1f87d24500ab009$var$SERVER_HELLO = "h";
/**
 * Creates a new real-time connection to the server using whichever method works
 * best in the current browser.
 *
 * @constructor
 */ var $d1f87d24500ab009$var$Connection = /** @class */ function() {
    /**
     * @param id - an id for this connection
     * @param repoInfo_ - the info for the endpoint to connect to
     * @param applicationId_ - the Firebase App ID for this project
     * @param onMessage_ - the callback to be triggered when a server-push message arrives
     * @param onReady_ - the callback to be triggered when this connection is ready to send messages.
     * @param onDisconnect_ - the callback to be triggered when a connection was lost
     * @param onKill_ - the callback to be triggered when this connection has permanently shut down.
     * @param lastSessionId - last session id in persistent connection. is used to clean up old session in real-time server
     */ function Connection(id, repoInfo_, applicationId_, onMessage_, onReady_, onDisconnect_, onKill_, lastSessionId) {
        this.id = id;
        this.repoInfo_ = repoInfo_;
        this.applicationId_ = applicationId_;
        this.onMessage_ = onMessage_;
        this.onReady_ = onReady_;
        this.onDisconnect_ = onDisconnect_;
        this.onKill_ = onKill_;
        this.lastSessionId = lastSessionId;
        this.connectionCount = 0;
        this.pendingDataMessages = [];
        this.state_ = 0 /* CONNECTING */ ;
        this.log_ = $d1f87d24500ab009$var$logWrapper("c:" + this.id + ":");
        this.transportManager_ = new $d1f87d24500ab009$var$TransportManager(repoInfo_);
        this.log_("Connection created");
        this.start_();
    }
    /**
     * Starts a connection attempt
     * @private
     */ Connection.prototype.start_ = function() {
        var _this = this;
        var conn = this.transportManager_.initialTransport();
        this.conn_ = new conn(this.nextTransportId_(), this.repoInfo_, this.applicationId_, undefined, this.lastSessionId);
        // For certain transports (WebSockets), we need to send and receive several messages back and forth before we
        // can consider the transport healthy.
        this.primaryResponsesRequired_ = conn["responsesRequiredToBeHealthy"] || 0;
        var onMessageReceived = this.connReceiver_(this.conn_);
        var onConnectionLost = this.disconnReceiver_(this.conn_);
        this.tx_ = this.conn_;
        this.rx_ = this.conn_;
        this.secondaryConn_ = null;
        this.isHealthy_ = false;
        /*
         * Firefox doesn't like when code from one iframe tries to create another iframe by way of the parent frame.
         * This can occur in the case of a redirect, i.e. we guessed wrong on what server to connect to and received a reset.
         * Somehow, setTimeout seems to make this ok. That doesn't make sense from a security perspective, since you should
         * still have the context of your originating frame.
         */ setTimeout(function() {
            // this.conn_ gets set to null in some of the tests. Check to make sure it still exists before using it
            _this.conn_ && _this.conn_.open(onMessageReceived, onConnectionLost);
        }, Math.floor(0));
        var healthyTimeoutMS = conn["healthyTimeout"] || 0;
        if (healthyTimeoutMS > 0) this.healthyTimeout_ = $d1f87d24500ab009$var$setTimeoutNonBlocking(function() {
            _this.healthyTimeout_ = null;
            if (!_this.isHealthy_) {
                if (_this.conn_ && _this.conn_.bytesReceived > $d1f87d24500ab009$var$BYTES_RECEIVED_HEALTHY_OVERRIDE) {
                    _this.log_("Connection exceeded healthy timeout but has received " + _this.conn_.bytesReceived + " bytes.  Marking connection healthy.");
                    _this.isHealthy_ = true;
                    _this.conn_.markConnectionHealthy();
                } else if (_this.conn_ && _this.conn_.bytesSent > $d1f87d24500ab009$var$BYTES_SENT_HEALTHY_OVERRIDE) _this.log_("Connection exceeded healthy timeout but has sent " + _this.conn_.bytesSent + " bytes.  Leaving connection alive.");
                else {
                    _this.log_("Closing unhealthy connection after timeout.");
                    _this.close();
                }
            }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        }, Math.floor(healthyTimeoutMS));
    };
    /**
     * @return {!string}
     * @private
     */ Connection.prototype.nextTransportId_ = function() {
        return "c:" + this.id + ":" + this.connectionCount++;
    };
    Connection.prototype.disconnReceiver_ = function(conn) {
        var _this = this;
        return function(everConnected) {
            if (conn === _this.conn_) _this.onConnectionLost_(everConnected);
            else if (conn === _this.secondaryConn_) {
                _this.log_("Secondary connection lost.");
                _this.onSecondaryConnectionLost_();
            } else _this.log_("closing an old connection");
        };
    };
    Connection.prototype.connReceiver_ = function(conn) {
        var _this = this;
        return function(message) {
            if (_this.state_ !== 2 /* DISCONNECTED */ ) {
                if (conn === _this.rx_) _this.onPrimaryMessageReceived_(message);
                else if (conn === _this.secondaryConn_) _this.onSecondaryMessageReceived_(message);
                else _this.log_("message on old connection");
            }
        };
    };
    /**
     *
     * @param {Object} dataMsg An arbitrary data message to be sent to the server
     */ Connection.prototype.sendRequest = function(dataMsg) {
        // wrap in a data message envelope and send it on
        var msg = {
            t: "d",
            d: dataMsg
        };
        this.sendData_(msg);
    };
    Connection.prototype.tryCleanupConnection = function() {
        if (this.tx_ === this.secondaryConn_ && this.rx_ === this.secondaryConn_) {
            this.log_("cleaning up and promoting a connection: " + this.secondaryConn_.connId);
            this.conn_ = this.secondaryConn_;
            this.secondaryConn_ = null;
        // the server will shutdown the old connection
        }
    };
    Connection.prototype.onSecondaryControl_ = function(controlData) {
        if ($d1f87d24500ab009$var$MESSAGE_TYPE in controlData) {
            var cmd = controlData[$d1f87d24500ab009$var$MESSAGE_TYPE];
            if (cmd === $d1f87d24500ab009$var$SWITCH_ACK) this.upgradeIfSecondaryHealthy_();
            else if (cmd === $d1f87d24500ab009$var$CONTROL_RESET) {
                // Most likely the session wasn't valid. Abandon the switch attempt
                this.log_("Got a reset on secondary, closing it");
                this.secondaryConn_.close();
                // If we were already using this connection for something, than we need to fully close
                if (this.tx_ === this.secondaryConn_ || this.rx_ === this.secondaryConn_) this.close();
            } else if (cmd === $d1f87d24500ab009$var$CONTROL_PONG) {
                this.log_("got pong on secondary.");
                this.secondaryResponsesRequired_--;
                this.upgradeIfSecondaryHealthy_();
            }
        }
    };
    Connection.prototype.onSecondaryMessageReceived_ = function(parsedData) {
        var layer = $d1f87d24500ab009$var$requireKey("t", parsedData);
        var data = $d1f87d24500ab009$var$requireKey("d", parsedData);
        if (layer === "c") this.onSecondaryControl_(data);
        else if (layer === "d") // got a data message, but we're still second connection. Need to buffer it up
        this.pendingDataMessages.push(data);
        else throw new Error("Unknown protocol layer: " + layer);
    };
    Connection.prototype.upgradeIfSecondaryHealthy_ = function() {
        if (this.secondaryResponsesRequired_ <= 0) {
            this.log_("Secondary connection is healthy.");
            this.isHealthy_ = true;
            this.secondaryConn_.markConnectionHealthy();
            this.proceedWithUpgrade_();
        } else {
            // Send a ping to make sure the connection is healthy.
            this.log_("sending ping on secondary.");
            this.secondaryConn_.send({
                t: "c",
                d: {
                    t: $d1f87d24500ab009$var$PING,
                    d: {}
                }
            });
        }
    };
    Connection.prototype.proceedWithUpgrade_ = function() {
        // tell this connection to consider itself open
        this.secondaryConn_.start();
        // send ack
        this.log_("sending client ack on secondary");
        this.secondaryConn_.send({
            t: "c",
            d: {
                t: $d1f87d24500ab009$var$SWITCH_ACK,
                d: {}
            }
        });
        // send end packet on primary transport, switch to sending on this one
        // can receive on this one, buffer responses until end received on primary transport
        this.log_("Ending transmission on primary");
        this.conn_.send({
            t: "c",
            d: {
                t: $d1f87d24500ab009$var$END_TRANSMISSION,
                d: {}
            }
        });
        this.tx_ = this.secondaryConn_;
        this.tryCleanupConnection();
    };
    Connection.prototype.onPrimaryMessageReceived_ = function(parsedData) {
        // Must refer to parsedData properties in quotes, so closure doesn't touch them.
        var layer = $d1f87d24500ab009$var$requireKey("t", parsedData);
        var data = $d1f87d24500ab009$var$requireKey("d", parsedData);
        if (layer === "c") this.onControl_(data);
        else if (layer === "d") this.onDataMessage_(data);
    };
    Connection.prototype.onDataMessage_ = function(message) {
        this.onPrimaryResponse_();
        // We don't do anything with data messages, just kick them up a level
        this.onMessage_(message);
    };
    Connection.prototype.onPrimaryResponse_ = function() {
        if (!this.isHealthy_) {
            this.primaryResponsesRequired_--;
            if (this.primaryResponsesRequired_ <= 0) {
                this.log_("Primary connection is healthy.");
                this.isHealthy_ = true;
                this.conn_.markConnectionHealthy();
            }
        }
    };
    Connection.prototype.onControl_ = function(controlData) {
        var cmd = $d1f87d24500ab009$var$requireKey($d1f87d24500ab009$var$MESSAGE_TYPE, controlData);
        if ($d1f87d24500ab009$var$MESSAGE_DATA in controlData) {
            var payload = controlData[$d1f87d24500ab009$var$MESSAGE_DATA];
            if (cmd === $d1f87d24500ab009$var$SERVER_HELLO) this.onHandshake_(payload);
            else if (cmd === $d1f87d24500ab009$var$END_TRANSMISSION) {
                this.log_("recvd end transmission on primary");
                this.rx_ = this.secondaryConn_;
                for(var i = 0; i < this.pendingDataMessages.length; ++i)this.onDataMessage_(this.pendingDataMessages[i]);
                this.pendingDataMessages = [];
                this.tryCleanupConnection();
            } else if (cmd === $d1f87d24500ab009$var$CONTROL_SHUTDOWN) // This was previously the 'onKill' callback passed to the lower-level connection
            // payload in this case is the reason for the shutdown. Generally a human-readable error
            this.onConnectionShutdown_(payload);
            else if (cmd === $d1f87d24500ab009$var$CONTROL_RESET) // payload in this case is the host we should contact
            this.onReset_(payload);
            else if (cmd === $d1f87d24500ab009$var$CONTROL_ERROR) $d1f87d24500ab009$var$error("Server Error: " + payload);
            else if (cmd === $d1f87d24500ab009$var$CONTROL_PONG) {
                this.log_("got pong on primary.");
                this.onPrimaryResponse_();
                this.sendPingOnPrimaryIfNecessary_();
            } else $d1f87d24500ab009$var$error("Unknown control packet command: " + cmd);
        }
    };
    /**
     *
     * @param {Object} handshake The handshake data returned from the server
     * @private
     */ Connection.prototype.onHandshake_ = function(handshake) {
        var timestamp = handshake.ts;
        var version = handshake.v;
        var host = handshake.h;
        this.sessionId = handshake.s;
        this.repoInfo_.updateHost(host);
        // if we've already closed the connection, then don't bother trying to progress further
        if (this.state_ === 0 /* CONNECTING */ ) {
            this.conn_.start();
            this.onConnectionEstablished_(this.conn_, timestamp);
            if ($d1f87d24500ab009$var$PROTOCOL_VERSION !== version) $d1f87d24500ab009$var$warn("Protocol version mismatch detected");
            // TODO: do we want to upgrade? when? maybe a delay?
            this.tryStartUpgrade_();
        }
    };
    Connection.prototype.tryStartUpgrade_ = function() {
        var conn = this.transportManager_.upgradeTransport();
        if (conn) this.startUpgrade_(conn);
    };
    Connection.prototype.startUpgrade_ = function(conn) {
        var _this = this;
        this.secondaryConn_ = new conn(this.nextTransportId_(), this.repoInfo_, this.applicationId_, this.sessionId);
        // For certain transports (WebSockets), we need to send and receive several messages back and forth before we
        // can consider the transport healthy.
        this.secondaryResponsesRequired_ = conn["responsesRequiredToBeHealthy"] || 0;
        var onMessage = this.connReceiver_(this.secondaryConn_);
        var onDisconnect = this.disconnReceiver_(this.secondaryConn_);
        this.secondaryConn_.open(onMessage, onDisconnect);
        // If we haven't successfully upgraded after UPGRADE_TIMEOUT, give up and kill the secondary.
        $d1f87d24500ab009$var$setTimeoutNonBlocking(function() {
            if (_this.secondaryConn_) {
                _this.log_("Timed out trying to upgrade.");
                _this.secondaryConn_.close();
            }
        }, Math.floor($d1f87d24500ab009$var$UPGRADE_TIMEOUT));
    };
    Connection.prototype.onReset_ = function(host) {
        this.log_("Reset packet received.  New host: " + host);
        this.repoInfo_.updateHost(host);
        // TODO: if we're already "connected", we need to trigger a disconnect at the next layer up.
        // We don't currently support resets after the connection has already been established
        if (this.state_ === 1 /* CONNECTED */ ) this.close();
        else {
            // Close whatever connections we have open and start again.
            this.closeConnections_();
            this.start_();
        }
    };
    Connection.prototype.onConnectionEstablished_ = function(conn, timestamp) {
        var _this = this;
        this.log_("Realtime connection established.");
        this.conn_ = conn;
        this.state_ = 1 /* CONNECTED */ ;
        if (this.onReady_) {
            this.onReady_(timestamp, this.sessionId);
            this.onReady_ = null;
        }
        // If after 5 seconds we haven't sent enough requests to the server to get the connection healthy,
        // send some pings.
        if (this.primaryResponsesRequired_ === 0) {
            this.log_("Primary connection is healthy.");
            this.isHealthy_ = true;
        } else $d1f87d24500ab009$var$setTimeoutNonBlocking(function() {
            _this.sendPingOnPrimaryIfNecessary_();
        }, Math.floor($d1f87d24500ab009$var$DELAY_BEFORE_SENDING_EXTRA_REQUESTS));
    };
    Connection.prototype.sendPingOnPrimaryIfNecessary_ = function() {
        // If the connection isn't considered healthy yet, we'll send a noop ping packet request.
        if (!this.isHealthy_ && this.state_ === 1 /* CONNECTED */ ) {
            this.log_("sending ping on primary.");
            this.sendData_({
                t: "c",
                d: {
                    t: $d1f87d24500ab009$var$PING,
                    d: {}
                }
            });
        }
    };
    Connection.prototype.onSecondaryConnectionLost_ = function() {
        var conn = this.secondaryConn_;
        this.secondaryConn_ = null;
        if (this.tx_ === conn || this.rx_ === conn) // we are relying on this connection already in some capacity. Therefore, a failure is real
        this.close();
    };
    /**
     *
     * @param {boolean} everConnected Whether or not the connection ever reached a server. Used to determine if
     * we should flush the host cache
     * @private
     */ Connection.prototype.onConnectionLost_ = function(everConnected) {
        this.conn_ = null;
        // NOTE: IF you're seeing a Firefox error for this line, I think it might be because it's getting
        // called on window close and RealtimeState.CONNECTING is no longer defined.  Just a guess.
        if (!everConnected && this.state_ === 0 /* CONNECTING */ ) {
            this.log_("Realtime connection failed.");
            // Since we failed to connect at all, clear any cached entry for this namespace in case the machine went away
            if (this.repoInfo_.isCacheableHost()) {
                $d1f87d24500ab009$var$PersistentStorage.remove("host:" + this.repoInfo_.host);
                // reset the internal host to what we would show the user, i.e. <ns>.firebaseio.com
                this.repoInfo_.internalHost = this.repoInfo_.host;
            }
        } else if (this.state_ === 1 /* CONNECTED */ ) this.log_("Realtime connection lost.");
        this.close();
    };
    /**
     *
     * @param {string} reason
     * @private
     */ Connection.prototype.onConnectionShutdown_ = function(reason) {
        this.log_("Connection shutdown command received. Shutting down...");
        if (this.onKill_) {
            this.onKill_(reason);
            this.onKill_ = null;
        }
        // We intentionally don't want to fire onDisconnect (kill is a different case),
        // so clear the callback.
        this.onDisconnect_ = null;
        this.close();
    };
    Connection.prototype.sendData_ = function(data) {
        if (this.state_ !== 1 /* CONNECTED */ ) throw "Connection is not connected";
        else this.tx_.send(data);
    };
    /**
     * Cleans up this connection, calling the appropriate callbacks
     */ Connection.prototype.close = function() {
        if (this.state_ !== 2 /* DISCONNECTED */ ) {
            this.log_("Closing realtime connection.");
            this.state_ = 2 /* DISCONNECTED */ ;
            this.closeConnections_();
            if (this.onDisconnect_) {
                this.onDisconnect_();
                this.onDisconnect_ = null;
            }
        }
    };
    /**
     *
     * @private
     */ Connection.prototype.closeConnections_ = function() {
        this.log_("Shutting down all connections");
        if (this.conn_) {
            this.conn_.close();
            this.conn_ = null;
        }
        if (this.secondaryConn_) {
            this.secondaryConn_.close();
            this.secondaryConn_ = null;
        }
        if (this.healthyTimeout_) {
            clearTimeout(this.healthyTimeout_);
            this.healthyTimeout_ = null;
        }
    };
    return Connection;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface defining the set of actions that can be performed against the Firebase server
 * (basically corresponds to our wire protocol).
 *
 * @interface
 */ var $d1f87d24500ab009$var$ServerActions = /** @class */ function() {
    function ServerActions() {}
    /**
     * @param {string} pathString
     * @param {*} data
     * @param {function(string, string)=} onComplete
     * @param {string=} hash
     */ ServerActions.prototype.put = function(pathString, data, onComplete, hash) {};
    /**
     * @param {string} pathString
     * @param {*} data
     * @param {function(string, ?string)} onComplete
     * @param {string=} hash
     */ ServerActions.prototype.merge = function(pathString, data, onComplete, hash) {};
    /**
     * Refreshes the auth token for the current connection.
     * @param {string} token The authentication token
     */ ServerActions.prototype.refreshAuthToken = function(token) {};
    /**
     * @param {string} pathString
     * @param {*} data
     * @param {function(string, string)=} onComplete
     */ ServerActions.prototype.onDisconnectPut = function(pathString, data, onComplete) {};
    /**
     * @param {string} pathString
     * @param {*} data
     * @param {function(string, string)=} onComplete
     */ ServerActions.prototype.onDisconnectMerge = function(pathString, data, onComplete) {};
    /**
     * @param {string} pathString
     * @param {function(string, string)=} onComplete
     */ ServerActions.prototype.onDisconnectCancel = function(pathString, onComplete) {};
    /**
     * @param {Object.<string, *>} stats
     */ ServerActions.prototype.reportStats = function(stats) {};
    return ServerActions;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $d1f87d24500ab009$var$RECONNECT_MIN_DELAY = 1000;
var $d1f87d24500ab009$var$RECONNECT_MAX_DELAY_DEFAULT = 300000; // 5 minutes in milliseconds (Case: 1858)
var $d1f87d24500ab009$var$RECONNECT_MAX_DELAY_FOR_ADMINS = 30000; // 30 seconds for admin clients (likely to be a backend server)
var $d1f87d24500ab009$var$RECONNECT_DELAY_MULTIPLIER = 1.3;
var $d1f87d24500ab009$var$RECONNECT_DELAY_RESET_TIMEOUT = 30000; // Reset delay back to MIN_DELAY after being connected for 30sec.
var $d1f87d24500ab009$var$SERVER_KILL_INTERRUPT_REASON = "server_kill";
// If auth fails repeatedly, we'll assume something is wrong and log a warning / back off.
var $d1f87d24500ab009$var$INVALID_AUTH_TOKEN_THRESHOLD = 3;
/**
 * Firebase connection.  Abstracts wire protocol and handles reconnecting.
 *
 * NOTE: All JSON objects sent to the realtime connection must have property names enclosed
 * in quotes to make sure the closure compiler does not minify them.
 */ var $d1f87d24500ab009$var$PersistentConnection = /** @class */ function(_super) {
    $a92b69d2447c208d$export$a8ba968b8961cb8a(PersistentConnection, _super);
    /**
     * @implements {ServerActions}
     * @param repoInfo_ Data about the namespace we are connecting to
     * @param applicationId_ The Firebase App ID for this project
     * @param onDataUpdate_ A callback for new data from the server
     */ function PersistentConnection(repoInfo_, applicationId_, onDataUpdate_, onConnectStatus_, onServerInfoUpdate_, authTokenProvider_, authOverride_) {
        var _this = _super.call(this) || this;
        _this.repoInfo_ = repoInfo_;
        _this.applicationId_ = applicationId_;
        _this.onDataUpdate_ = onDataUpdate_;
        _this.onConnectStatus_ = onConnectStatus_;
        _this.onServerInfoUpdate_ = onServerInfoUpdate_;
        _this.authTokenProvider_ = authTokenProvider_;
        _this.authOverride_ = authOverride_;
        // Used for diagnostic logging.
        _this.id = PersistentConnection.nextPersistentConnectionId_++;
        _this.log_ = $d1f87d24500ab009$var$logWrapper("p:" + _this.id + ":");
        _this.interruptReasons_ = {};
        /** Map<path, Map<queryId, ListenSpec>> */ _this.listens = new Map();
        _this.outstandingPuts_ = [];
        _this.outstandingPutCount_ = 0;
        _this.onDisconnectRequestQueue_ = [];
        _this.connected_ = false;
        _this.reconnectDelay_ = $d1f87d24500ab009$var$RECONNECT_MIN_DELAY;
        _this.maxReconnectDelay_ = $d1f87d24500ab009$var$RECONNECT_MAX_DELAY_DEFAULT;
        _this.securityDebugCallback_ = null;
        _this.lastSessionId = null;
        _this.establishConnectionTimer_ = null;
        _this.visible_ = false;
        // Before we get connected, we keep a queue of pending messages to send.
        _this.requestCBHash_ = {};
        _this.requestNumber_ = 0;
        _this.realtime_ = null;
        _this.authToken_ = null;
        _this.forceTokenRefresh_ = false;
        _this.invalidAuthTokenCount_ = 0;
        _this.firstConnection_ = true;
        _this.lastConnectionAttemptTime_ = null;
        _this.lastConnectionEstablishedTime_ = null;
        if (authOverride_ && !$01sTD.isNodeSdk()) throw new Error("Auth override specified in options, but not supported on non Node.js platforms");
        _this.scheduleConnect_(0);
        $d1f87d24500ab009$var$VisibilityMonitor.getInstance().on("visible", _this.onVisible_, _this);
        if (repoInfo_.host.indexOf("fblocal") === -1) $d1f87d24500ab009$var$OnlineMonitor.getInstance().on("online", _this.onOnline_, _this);
        return _this;
    }
    PersistentConnection.prototype.sendRequest = function(action, body, onResponse) {
        var curReqNum = ++this.requestNumber_;
        var msg = {
            r: curReqNum,
            a: action,
            b: body
        };
        this.log_($01sTD.stringify(msg));
        $01sTD.assert(this.connected_, "sendRequest call when we're not connected not allowed.");
        this.realtime_.sendRequest(msg);
        if (onResponse) this.requestCBHash_[curReqNum] = onResponse;
    };
    /**
     * @inheritDoc
     */ PersistentConnection.prototype.listen = function(query, currentHashFn, tag, onComplete) {
        var queryId = query.queryIdentifier();
        var pathString = query.path.toString();
        this.log_("Listen called for " + pathString + " " + queryId);
        if (!this.listens.has(pathString)) this.listens.set(pathString, new Map());
        $01sTD.assert(query.getQueryParams().isDefault() || !query.getQueryParams().loadsAllData(), "listen() called for non-default but complete query");
        $01sTD.assert(!this.listens.get(pathString).has(queryId), "listen() called twice for same path/queryId.");
        var listenSpec = {
            onComplete: onComplete,
            hashFn: currentHashFn,
            query: query,
            tag: tag
        };
        this.listens.get(pathString).set(queryId, listenSpec);
        if (this.connected_) this.sendListen_(listenSpec);
    };
    PersistentConnection.prototype.sendListen_ = function(listenSpec) {
        var _this = this;
        var query = listenSpec.query;
        var pathString = query.path.toString();
        var queryId = query.queryIdentifier();
        this.log_("Listen on " + pathString + " for " + queryId);
        var req = {
            p: pathString
        };
        var action = "q";
        // Only bother to send query if it's non-default.
        if (listenSpec.tag) {
            req["q"] = query.queryObject();
            req["t"] = listenSpec.tag;
        }
        req[/*hash*/ "h"] = listenSpec.hashFn();
        this.sendRequest(action, req, function(message) {
            var payload = message[/*data*/ "d"];
            var status = message[/*status*/ "s"];
            // print warnings in any case...
            PersistentConnection.warnOnListenWarnings_(payload, query);
            var currentListenSpec = _this.listens.get(pathString) && _this.listens.get(pathString).get(queryId);
            // only trigger actions if the listen hasn't been removed and readded
            if (currentListenSpec === listenSpec) {
                _this.log_("listen response", message);
                if (status !== "ok") _this.removeListen_(pathString, queryId);
                if (listenSpec.onComplete) listenSpec.onComplete(status, payload);
            }
        });
    };
    PersistentConnection.warnOnListenWarnings_ = function(payload, query) {
        if (payload && typeof payload === "object" && $01sTD.contains(payload, "w")) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var warnings = $01sTD.safeGet(payload, "w");
            if (Array.isArray(warnings) && ~warnings.indexOf("no_index")) {
                var indexSpec = '".indexOn": "' + query.getQueryParams().getIndex().toString() + '"';
                var indexPath = query.path.toString();
                $d1f87d24500ab009$var$warn("Using an unspecified index. Your data will be downloaded and " + ("filtered on the client. Consider adding " + indexSpec + " at ") + (indexPath + " to your security rules for better performance."));
            }
        }
    };
    /**
     * @inheritDoc
     */ PersistentConnection.prototype.refreshAuthToken = function(token) {
        this.authToken_ = token;
        this.log_("Auth token refreshed");
        if (this.authToken_) this.tryAuth();
        else //If we're connected we want to let the server know to unauthenticate us. If we're not connected, simply delete
        //the credential so we dont become authenticated next time we connect.
        if (this.connected_) this.sendRequest("unauth", {}, function() {});
        this.reduceReconnectDelayIfAdminCredential_(token);
    };
    PersistentConnection.prototype.reduceReconnectDelayIfAdminCredential_ = function(credential) {
        // NOTE: This isn't intended to be bulletproof (a malicious developer can always just modify the client).
        // Additionally, we don't bother resetting the max delay back to the default if auth fails / expires.
        var isFirebaseSecret = credential && credential.length === 40;
        if (isFirebaseSecret || $01sTD.isAdmin(credential)) {
            this.log_("Admin auth credential detected.  Reducing max reconnect time.");
            this.maxReconnectDelay_ = $d1f87d24500ab009$var$RECONNECT_MAX_DELAY_FOR_ADMINS;
        }
    };
    /**
     * Attempts to authenticate with the given credentials. If the authentication attempt fails, it's triggered like
     * a auth revoked (the connection is closed).
     */ PersistentConnection.prototype.tryAuth = function() {
        var _this = this;
        if (this.connected_ && this.authToken_) {
            var token_1 = this.authToken_;
            var authMethod = $01sTD.isValidFormat(token_1) ? "auth" : "gauth";
            var requestData = {
                cred: token_1
            };
            if (this.authOverride_ === null) requestData["noauth"] = true;
            else if (typeof this.authOverride_ === "object") requestData["authvar"] = this.authOverride_;
            this.sendRequest(authMethod, requestData, function(res) {
                var status = res[/*status*/ "s"];
                var data = res[/*data*/ "d"] || "error";
                if (_this.authToken_ === token_1) {
                    if (status === "ok") _this.invalidAuthTokenCount_ = 0;
                    else // Triggers reconnect and force refresh for auth token
                    _this.onAuthRevoked_(status, data);
                }
            });
        }
    };
    /**
     * @inheritDoc
     */ PersistentConnection.prototype.unlisten = function(query, tag) {
        var pathString = query.path.toString();
        var queryId = query.queryIdentifier();
        this.log_("Unlisten called for " + pathString + " " + queryId);
        $01sTD.assert(query.getQueryParams().isDefault() || !query.getQueryParams().loadsAllData(), "unlisten() called for non-default but complete query");
        var listen = this.removeListen_(pathString, queryId);
        if (listen && this.connected_) this.sendUnlisten_(pathString, queryId, query.queryObject(), tag);
    };
    PersistentConnection.prototype.sendUnlisten_ = function(pathString, queryId, queryObj, tag) {
        this.log_("Unlisten on " + pathString + " for " + queryId);
        var req = {
            p: pathString
        };
        var action = "n";
        // Only bother sending queryId if it's non-default.
        if (tag) {
            req["q"] = queryObj;
            req["t"] = tag;
        }
        this.sendRequest(action, req);
    };
    /**
     * @inheritDoc
     */ PersistentConnection.prototype.onDisconnectPut = function(pathString, data, onComplete) {
        if (this.connected_) this.sendOnDisconnect_("o", pathString, data, onComplete);
        else this.onDisconnectRequestQueue_.push({
            pathString: pathString,
            action: "o",
            data: data,
            onComplete: onComplete
        });
    };
    /**
     * @inheritDoc
     */ PersistentConnection.prototype.onDisconnectMerge = function(pathString, data, onComplete) {
        if (this.connected_) this.sendOnDisconnect_("om", pathString, data, onComplete);
        else this.onDisconnectRequestQueue_.push({
            pathString: pathString,
            action: "om",
            data: data,
            onComplete: onComplete
        });
    };
    /**
     * @inheritDoc
     */ PersistentConnection.prototype.onDisconnectCancel = function(pathString, onComplete) {
        if (this.connected_) this.sendOnDisconnect_("oc", pathString, null, onComplete);
        else this.onDisconnectRequestQueue_.push({
            pathString: pathString,
            action: "oc",
            data: null,
            onComplete: onComplete
        });
    };
    PersistentConnection.prototype.sendOnDisconnect_ = function(action, pathString, data, onComplete) {
        var request = {
            p: pathString,
            /*data*/ d: data
        };
        this.log_("onDisconnect " + action, request);
        this.sendRequest(action, request, function(response) {
            if (onComplete) setTimeout(function() {
                onComplete(response[/*status*/ "s"], response[/* data */ "d"]);
            }, Math.floor(0));
        });
    };
    /**
     * @inheritDoc
     */ PersistentConnection.prototype.put = function(pathString, data, onComplete, hash) {
        this.putInternal("p", pathString, data, onComplete, hash);
    };
    /**
     * @inheritDoc
     */ PersistentConnection.prototype.merge = function(pathString, data, onComplete, hash) {
        this.putInternal("m", pathString, data, onComplete, hash);
    };
    PersistentConnection.prototype.putInternal = function(action, pathString, data, onComplete, hash) {
        var request = {
            /*path*/ p: pathString,
            /*data*/ d: data
        };
        if (hash !== undefined) request[/*hash*/ "h"] = hash;
        // TODO: Only keep track of the most recent put for a given path?
        this.outstandingPuts_.push({
            action: action,
            request: request,
            onComplete: onComplete
        });
        this.outstandingPutCount_++;
        var index = this.outstandingPuts_.length - 1;
        if (this.connected_) this.sendPut_(index);
        else this.log_("Buffering put: " + pathString);
    };
    PersistentConnection.prototype.sendPut_ = function(index) {
        var _this = this;
        var action = this.outstandingPuts_[index].action;
        var request = this.outstandingPuts_[index].request;
        var onComplete = this.outstandingPuts_[index].onComplete;
        this.outstandingPuts_[index].queued = this.connected_;
        this.sendRequest(action, request, function(message) {
            _this.log_(action + " response", message);
            delete _this.outstandingPuts_[index];
            _this.outstandingPutCount_--;
            // Clean up array occasionally.
            if (_this.outstandingPutCount_ === 0) _this.outstandingPuts_ = [];
            if (onComplete) onComplete(message[/*status*/ "s"], message[/* data */ "d"]);
        });
    };
    /**
     * @inheritDoc
     */ PersistentConnection.prototype.reportStats = function(stats) {
        var _this = this;
        // If we're not connected, we just drop the stats.
        if (this.connected_) {
            var request = {
                c: stats
            };
            this.log_("reportStats", request);
            this.sendRequest(/*stats*/ "s", request, function(result) {
                var status = result[/*status*/ "s"];
                if (status !== "ok") {
                    var errorReason = result[/* data */ "d"];
                    _this.log_("reportStats", "Error sending stats: " + errorReason);
                }
            });
        }
    };
    PersistentConnection.prototype.onDataMessage_ = function(message) {
        if ("r" in message) {
            // this is a response
            this.log_("from server: " + $01sTD.stringify(message));
            var reqNum = message["r"];
            var onResponse = this.requestCBHash_[reqNum];
            if (onResponse) {
                delete this.requestCBHash_[reqNum];
                onResponse(message[/*body*/ "b"]);
            }
        } else if ("error" in message) throw "A server-side error has occurred: " + message["error"];
        else if ("a" in message) // a and b are action and body, respectively
        this.onDataPush_(message["a"], message["b"]);
    };
    PersistentConnection.prototype.onDataPush_ = function(action, body) {
        this.log_("handleServerMessage", action, body);
        if (action === "d") this.onDataUpdate_(body[/*path*/ "p"], body[/*data*/ "d"], /*isMerge*/ false, body["t"]);
        else if (action === "m") this.onDataUpdate_(body[/*path*/ "p"], body[/*data*/ "d"], /*isMerge=*/ true, body["t"]);
        else if (action === "c") this.onListenRevoked_(body[/*path*/ "p"], body[/*query*/ "q"]);
        else if (action === "ac") this.onAuthRevoked_(body[/*status code*/ "s"], body[/* explanation */ "d"]);
        else if (action === "sd") this.onSecurityDebugPacket_(body);
        else $d1f87d24500ab009$var$error("Unrecognized action received from server: " + $01sTD.stringify(action) + "\nAre you using the latest client?");
    };
    PersistentConnection.prototype.onReady_ = function(timestamp, sessionId) {
        this.log_("connection ready");
        this.connected_ = true;
        this.lastConnectionEstablishedTime_ = new Date().getTime();
        this.handleTimestamp_(timestamp);
        this.lastSessionId = sessionId;
        if (this.firstConnection_) this.sendConnectStats_();
        this.restoreState_();
        this.firstConnection_ = false;
        this.onConnectStatus_(true);
    };
    PersistentConnection.prototype.scheduleConnect_ = function(timeout) {
        var _this = this;
        $01sTD.assert(!this.realtime_, "Scheduling a connect when we're already connected/ing?");
        if (this.establishConnectionTimer_) clearTimeout(this.establishConnectionTimer_);
        // NOTE: Even when timeout is 0, it's important to do a setTimeout to work around an infuriating "Security Error" in
        // Firefox when trying to write to our long-polling iframe in some scenarios (e.g. Forge or our unit tests).
        this.establishConnectionTimer_ = setTimeout(function() {
            _this.establishConnectionTimer_ = null;
            _this.establishConnection_();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        }, Math.floor(timeout));
    };
    PersistentConnection.prototype.onVisible_ = function(visible) {
        // NOTE: Tabbing away and back to a window will defeat our reconnect backoff, but I think that's fine.
        if (visible && !this.visible_ && this.reconnectDelay_ === this.maxReconnectDelay_) {
            this.log_("Window became visible.  Reducing delay.");
            this.reconnectDelay_ = $d1f87d24500ab009$var$RECONNECT_MIN_DELAY;
            if (!this.realtime_) this.scheduleConnect_(0);
        }
        this.visible_ = visible;
    };
    PersistentConnection.prototype.onOnline_ = function(online) {
        if (online) {
            this.log_("Browser went online.");
            this.reconnectDelay_ = $d1f87d24500ab009$var$RECONNECT_MIN_DELAY;
            if (!this.realtime_) this.scheduleConnect_(0);
        } else {
            this.log_("Browser went offline.  Killing connection.");
            if (this.realtime_) this.realtime_.close();
        }
    };
    PersistentConnection.prototype.onRealtimeDisconnect_ = function() {
        this.log_("data client disconnected");
        this.connected_ = false;
        this.realtime_ = null;
        // Since we don't know if our sent transactions succeeded or not, we need to cancel them.
        this.cancelSentTransactions_();
        // Clear out the pending requests.
        this.requestCBHash_ = {};
        if (this.shouldReconnect_()) {
            if (!this.visible_) {
                this.log_("Window isn't visible.  Delaying reconnect.");
                this.reconnectDelay_ = this.maxReconnectDelay_;
                this.lastConnectionAttemptTime_ = new Date().getTime();
            } else if (this.lastConnectionEstablishedTime_) {
                // If we've been connected long enough, reset reconnect delay to minimum.
                var timeSinceLastConnectSucceeded = new Date().getTime() - this.lastConnectionEstablishedTime_;
                if (timeSinceLastConnectSucceeded > $d1f87d24500ab009$var$RECONNECT_DELAY_RESET_TIMEOUT) this.reconnectDelay_ = $d1f87d24500ab009$var$RECONNECT_MIN_DELAY;
                this.lastConnectionEstablishedTime_ = null;
            }
            var timeSinceLastConnectAttempt = new Date().getTime() - this.lastConnectionAttemptTime_;
            var reconnectDelay = Math.max(0, this.reconnectDelay_ - timeSinceLastConnectAttempt);
            reconnectDelay = Math.random() * reconnectDelay;
            this.log_("Trying to reconnect in " + reconnectDelay + "ms");
            this.scheduleConnect_(reconnectDelay);
            // Adjust reconnect delay for next time.
            this.reconnectDelay_ = Math.min(this.maxReconnectDelay_, this.reconnectDelay_ * $d1f87d24500ab009$var$RECONNECT_DELAY_MULTIPLIER);
        }
        this.onConnectStatus_(false);
    };
    PersistentConnection.prototype.establishConnection_ = function() {
        var _this = this;
        if (this.shouldReconnect_()) {
            this.log_("Making a connection attempt");
            this.lastConnectionAttemptTime_ = new Date().getTime();
            this.lastConnectionEstablishedTime_ = null;
            var onDataMessage_1 = this.onDataMessage_.bind(this);
            var onReady_1 = this.onReady_.bind(this);
            var onDisconnect_1 = this.onRealtimeDisconnect_.bind(this);
            var connId_1 = this.id + ":" + PersistentConnection.nextConnectionId_++;
            var self_1 = this;
            var lastSessionId_1 = this.lastSessionId;
            var canceled_1 = false;
            var connection_1 = null;
            var closeFn_1 = function() {
                if (connection_1) connection_1.close();
                else {
                    canceled_1 = true;
                    onDisconnect_1();
                }
            };
            var sendRequestFn = function(msg) {
                $01sTD.assert(connection_1, "sendRequest call when we're not connected not allowed.");
                connection_1.sendRequest(msg);
            };
            this.realtime_ = {
                close: closeFn_1,
                sendRequest: sendRequestFn
            };
            var forceRefresh = this.forceTokenRefresh_;
            this.forceTokenRefresh_ = false;
            // First fetch auth token, and establish connection after fetching the token was successful
            this.authTokenProvider_.getToken(forceRefresh).then(function(result) {
                if (!canceled_1) {
                    $d1f87d24500ab009$var$log("getToken() completed. Creating connection.");
                    self_1.authToken_ = result && result.accessToken;
                    connection_1 = new $d1f87d24500ab009$var$Connection(connId_1, self_1.repoInfo_, self_1.applicationId_, onDataMessage_1, onReady_1, onDisconnect_1, /* onKill= */ function(reason) {
                        $d1f87d24500ab009$var$warn(reason + " (" + self_1.repoInfo_.toString() + ")");
                        self_1.interrupt($d1f87d24500ab009$var$SERVER_KILL_INTERRUPT_REASON);
                    }, lastSessionId_1);
                } else $d1f87d24500ab009$var$log("getToken() completed but was canceled");
            }).then(null, function(error) {
                self_1.log_("Failed to get token: " + error);
                if (!canceled_1) {
                    if (_this.repoInfo_.nodeAdmin) // This may be a critical error for the Admin Node.js SDK, so log a warning.
                    // But getToken() may also just have temporarily failed, so we still want to
                    // continue retrying.
                    $d1f87d24500ab009$var$warn(error);
                    closeFn_1();
                }
            });
        }
    };
    PersistentConnection.prototype.interrupt = function(reason) {
        $d1f87d24500ab009$var$log("Interrupting connection for reason: " + reason);
        this.interruptReasons_[reason] = true;
        if (this.realtime_) this.realtime_.close();
        else {
            if (this.establishConnectionTimer_) {
                clearTimeout(this.establishConnectionTimer_);
                this.establishConnectionTimer_ = null;
            }
            if (this.connected_) this.onRealtimeDisconnect_();
        }
    };
    PersistentConnection.prototype.resume = function(reason) {
        $d1f87d24500ab009$var$log("Resuming connection for reason: " + reason);
        delete this.interruptReasons_[reason];
        if ($01sTD.isEmpty(this.interruptReasons_)) {
            this.reconnectDelay_ = $d1f87d24500ab009$var$RECONNECT_MIN_DELAY;
            if (!this.realtime_) this.scheduleConnect_(0);
        }
    };
    PersistentConnection.prototype.handleTimestamp_ = function(timestamp) {
        var delta = timestamp - new Date().getTime();
        this.onServerInfoUpdate_({
            serverTimeOffset: delta
        });
    };
    PersistentConnection.prototype.cancelSentTransactions_ = function() {
        for(var i = 0; i < this.outstandingPuts_.length; i++){
            var put = this.outstandingPuts_[i];
            if (put && /*hash*/ "h" in put.request && put.queued) {
                if (put.onComplete) put.onComplete("disconnect");
                delete this.outstandingPuts_[i];
                this.outstandingPutCount_--;
            }
        }
        // Clean up array occasionally.
        if (this.outstandingPutCount_ === 0) this.outstandingPuts_ = [];
    };
    PersistentConnection.prototype.onListenRevoked_ = function(pathString, query) {
        // Remove the listen and manufacture a "permission_denied" error for the failed listen.
        var queryId;
        if (!query) queryId = "default";
        else queryId = query.map(function(q) {
            return $d1f87d24500ab009$var$ObjectToUniqueKey(q);
        }).join("$");
        var listen = this.removeListen_(pathString, queryId);
        if (listen && listen.onComplete) listen.onComplete("permission_denied");
    };
    PersistentConnection.prototype.removeListen_ = function(pathString, queryId) {
        var normalizedPathString = new $d1f87d24500ab009$var$Path(pathString).toString(); // normalize path.
        var listen;
        if (this.listens.has(normalizedPathString)) {
            var map = this.listens.get(normalizedPathString);
            listen = map.get(queryId);
            map.delete(queryId);
            if (map.size === 0) this.listens.delete(normalizedPathString);
        } else // all listens for this path has already been removed
        listen = undefined;
        return listen;
    };
    PersistentConnection.prototype.onAuthRevoked_ = function(statusCode, explanation) {
        $d1f87d24500ab009$var$log("Auth token revoked: " + statusCode + "/" + explanation);
        this.authToken_ = null;
        this.forceTokenRefresh_ = true;
        this.realtime_.close();
        if (statusCode === "invalid_token" || statusCode === "permission_denied") {
            // We'll wait a couple times before logging the warning / increasing the
            // retry period since oauth tokens will report as "invalid" if they're
            // just expired. Plus there may be transient issues that resolve themselves.
            this.invalidAuthTokenCount_++;
            if (this.invalidAuthTokenCount_ >= $d1f87d24500ab009$var$INVALID_AUTH_TOKEN_THRESHOLD) {
                // Set a long reconnect delay because recovery is unlikely
                this.reconnectDelay_ = $d1f87d24500ab009$var$RECONNECT_MAX_DELAY_FOR_ADMINS;
                // Notify the auth token provider that the token is invalid, which will log
                // a warning
                this.authTokenProvider_.notifyForInvalidToken();
            }
        }
    };
    PersistentConnection.prototype.onSecurityDebugPacket_ = function(body) {
        if (this.securityDebugCallback_) this.securityDebugCallback_(body);
        else if ("msg" in body) console.log("FIREBASE: " + body["msg"].replace("\n", "\nFIREBASE: "));
    };
    PersistentConnection.prototype.restoreState_ = function() {
        var e_1, _a, e_2, _b;
        //Re-authenticate ourselves if we have a credential stored.
        this.tryAuth();
        try {
            // Puts depend on having received the corresponding data update from the server before they complete, so we must
            // make sure to send listens before puts.
            for(var _c = $a92b69d2447c208d$export$19a8beecd37a4c45(this.listens.values()), _d = _c.next(); !_d.done; _d = _c.next()){
                var queries = _d.value;
                try {
                    for(var _e = (e_2 = void 0, $a92b69d2447c208d$export$19a8beecd37a4c45(queries.values())), _f = _e.next(); !_f.done; _f = _e.next()){
                        var listenSpec = _f.value;
                        this.sendListen_(listenSpec);
                    }
                } catch (e_2_1) {
                    e_2 = {
                        error: e_2_1
                    };
                } finally{
                    try {
                        if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                    } finally{
                        if (e_2) throw e_2.error;
                    }
                }
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        for(var i = 0; i < this.outstandingPuts_.length; i++)if (this.outstandingPuts_[i]) this.sendPut_(i);
        while(this.onDisconnectRequestQueue_.length){
            var request = this.onDisconnectRequestQueue_.shift();
            this.sendOnDisconnect_(request.action, request.pathString, request.data, request.onComplete);
        }
    };
    /**
     * Sends client stats for first connection
     */ PersistentConnection.prototype.sendConnectStats_ = function() {
        var stats = {};
        var clientName = "js";
        if ($01sTD.isNodeSdk()) {
            if (this.repoInfo_.nodeAdmin) clientName = "admin_node";
            else clientName = "node";
        }
        stats["sdk." + clientName + "." + $d1f87d24500ab009$var$SDK_VERSION.replace(/\./g, "-")] = 1;
        if ($01sTD.isMobileCordova()) stats["framework.cordova"] = 1;
        else if ($01sTD.isReactNative()) stats["framework.reactnative"] = 1;
        this.reportStats(stats);
    };
    PersistentConnection.prototype.shouldReconnect_ = function() {
        var online = $d1f87d24500ab009$var$OnlineMonitor.getInstance().currentlyOnline();
        return $01sTD.isEmpty(this.interruptReasons_) && online;
    };
    PersistentConnection.nextPersistentConnectionId_ = 0;
    /**
     * Counter for number of connections created. Mainly used for tagging in the logs
     */ PersistentConnection.nextConnectionId_ = 0;
    return PersistentConnection;
}($d1f87d24500ab009$var$ServerActions);
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An implementation of ServerActions that communicates with the server via REST requests.
 * This is mostly useful for compatibility with crawlers, where we don't want to spin up a full
 * persistent connection (using WebSockets or long-polling)
 */ var $d1f87d24500ab009$var$ReadonlyRestClient = /** @class */ function(_super) {
    $a92b69d2447c208d$export$a8ba968b8961cb8a(ReadonlyRestClient, _super);
    /**
     * @param {!RepoInfo} repoInfo_ Data about the namespace we are connecting to
     * @param {function(string, *, boolean, ?number)} onDataUpdate_ A callback for new data from the server
     * @param {AuthTokenProvider} authTokenProvider_
     * @implements {ServerActions}
     */ function ReadonlyRestClient(repoInfo_, onDataUpdate_, authTokenProvider_) {
        var _this = _super.call(this) || this;
        _this.repoInfo_ = repoInfo_;
        _this.onDataUpdate_ = onDataUpdate_;
        _this.authTokenProvider_ = authTokenProvider_;
        /** @private {function(...[*])} */ _this.log_ = $d1f87d24500ab009$var$logWrapper("p:rest:");
        /**
         * We don't actually need to track listens, except to prevent us calling an onComplete for a listen
         * that's been removed. :-/
         *
         * @private {!Object.<string, !Object>}
         */ _this.listens_ = {};
        return _this;
    }
    ReadonlyRestClient.prototype.reportStats = function(stats) {
        throw new Error("Method not implemented.");
    };
    /**
     * @param {!Query} query
     * @param {?number=} tag
     * @return {string}
     * @private
     */ ReadonlyRestClient.getListenId_ = function(query, tag) {
        if (tag !== undefined) return "tag$" + tag;
        else {
            $01sTD.assert(query.getQueryParams().isDefault(), "should have a tag if it's not a default query.");
            return query.path.toString();
        }
    };
    /** @inheritDoc */ ReadonlyRestClient.prototype.listen = function(query, currentHashFn, tag, onComplete) {
        var _this = this;
        var pathString = query.path.toString();
        this.log_("Listen called for " + pathString + " " + query.queryIdentifier());
        // Mark this listener so we can tell if it's removed.
        var listenId = ReadonlyRestClient.getListenId_(query, tag);
        var thisListen = {};
        this.listens_[listenId] = thisListen;
        var queryStringParameters = query.getQueryParams().toRestQueryStringParameters();
        this.restRequest_(pathString + ".json", queryStringParameters, function(error, result) {
            var data = result;
            if (error === 404) {
                data = null;
                error = null;
            }
            if (error === null) _this.onDataUpdate_(pathString, data, /*isMerge=*/ false, tag);
            if ($01sTD.safeGet(_this.listens_, listenId) === thisListen) {
                var status_1;
                if (!error) status_1 = "ok";
                else if (error === 401) status_1 = "permission_denied";
                else status_1 = "rest_error:" + error;
                onComplete(status_1, null);
            }
        });
    };
    /** @inheritDoc */ ReadonlyRestClient.prototype.unlisten = function(query, tag) {
        var listenId = ReadonlyRestClient.getListenId_(query, tag);
        delete this.listens_[listenId];
    };
    /** @inheritDoc */ ReadonlyRestClient.prototype.refreshAuthToken = function(token) {
    // no-op since we just always call getToken.
    };
    /**
     * Performs a REST request to the given path, with the provided query string parameters,
     * and any auth credentials we have.
     *
     * @param {!string} pathString
     * @param {!Object.<string, *>} queryStringParameters
     * @param {?function(?number, *=)} callback
     * @private
     */ ReadonlyRestClient.prototype.restRequest_ = function(pathString, queryStringParameters, callback) {
        var _this = this;
        if (queryStringParameters === void 0) queryStringParameters = {};
        queryStringParameters["format"] = "export";
        this.authTokenProvider_.getToken(/*forceRefresh=*/ false).then(function(authTokenData) {
            var authToken = authTokenData && authTokenData.accessToken;
            if (authToken) queryStringParameters["auth"] = authToken;
            var url = (_this.repoInfo_.secure ? "https://" : "http://") + _this.repoInfo_.host + pathString + "?" + "ns=" + _this.repoInfo_.namespace + $01sTD.querystring(queryStringParameters);
            _this.log_("Sending REST request for " + url);
            var xhr = new XMLHttpRequest();
            xhr.onreadystatechange = function() {
                if (callback && xhr.readyState === 4) {
                    _this.log_("REST Response for " + url + " received. status:", xhr.status, "response:", xhr.responseText);
                    var res = null;
                    if (xhr.status >= 200 && xhr.status < 300) {
                        try {
                            res = $01sTD.jsonEval(xhr.responseText);
                        } catch (e) {
                            $d1f87d24500ab009$var$warn("Failed to parse JSON response for " + url + ": " + xhr.responseText);
                        }
                        callback(null, res);
                    } else {
                        // 401 and 404 are expected.
                        if (xhr.status !== 401 && xhr.status !== 404) $d1f87d24500ab009$var$warn("Got unsuccessful REST response for " + url + " Status: " + xhr.status);
                        callback(xhr.status);
                    }
                    callback = null;
                }
            };
            xhr.open("GET", url, /*asynchronous=*/ true);
            xhr.send();
        });
    };
    return ReadonlyRestClient;
}($d1f87d24500ab009$var$ServerActions);
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $d1f87d24500ab009$var$INTERRUPT_REASON = "repo_interrupt";
/**
 * A connection to a single data repository.
 */ var $d1f87d24500ab009$var$Repo = /** @class */ function() {
    function Repo(repoInfo_, forceRestClient, app, authTokenProvider) {
        var _this = this;
        this.repoInfo_ = repoInfo_;
        this.app = app;
        this.dataUpdateCount = 0;
        this.statsListener_ = null;
        this.eventQueue_ = new $d1f87d24500ab009$var$EventQueue();
        this.nextWriteId_ = 1;
        this.interceptServerDataCallback_ = null;
        /** A list of data pieces and paths to be set when this client disconnects. */ this.onDisconnect_ = new $d1f87d24500ab009$var$SparseSnapshotTree();
        // TODO: This should be @private but it's used by test_access.js and internal.js
        this.persistentConnection_ = null;
        this.stats_ = $d1f87d24500ab009$var$StatsManager.getCollection(repoInfo_);
        if (forceRestClient || $d1f87d24500ab009$var$beingCrawled()) {
            this.server_ = new $d1f87d24500ab009$var$ReadonlyRestClient(this.repoInfo_, this.onDataUpdate_.bind(this), authTokenProvider);
            // Minor hack: Fire onConnect immediately, since there's no actual connection.
            setTimeout(this.onConnectStatus_.bind(this, true), 0);
        } else {
            var authOverride = app.options["databaseAuthVariableOverride"];
            // Validate authOverride
            if (typeof authOverride !== "undefined" && authOverride !== null) {
                if (typeof authOverride !== "object") throw new Error("Only objects are supported for option databaseAuthVariableOverride");
                try {
                    $01sTD.stringify(authOverride);
                } catch (e) {
                    throw new Error("Invalid authOverride provided: " + e);
                }
            }
            this.persistentConnection_ = new $d1f87d24500ab009$var$PersistentConnection(this.repoInfo_, app.options.appId, this.onDataUpdate_.bind(this), this.onConnectStatus_.bind(this), this.onServerInfoUpdate_.bind(this), authTokenProvider, authOverride);
            this.server_ = this.persistentConnection_;
        }
        authTokenProvider.addTokenChangeListener(function(token) {
            _this.server_.refreshAuthToken(token);
        });
        // In the case of multiple Repos for the same repoInfo (i.e. there are multiple Firebase.Contexts being used),
        // we only want to create one StatsReporter.  As such, we'll report stats over the first Repo created.
        this.statsReporter_ = $d1f87d24500ab009$var$StatsManager.getOrCreateReporter(repoInfo_, function() {
            return new $d1f87d24500ab009$var$StatsReporter(_this.stats_, _this.server_);
        });
        this.transactionsInit_();
        // Used for .info.
        this.infoData_ = new $d1f87d24500ab009$var$SnapshotHolder();
        this.infoSyncTree_ = new $d1f87d24500ab009$var$SyncTree({
            startListening: function(query, tag, currentHashFn, onComplete) {
                var infoEvents = [];
                var node = _this.infoData_.getNode(query.path);
                // This is possibly a hack, but we have different semantics for .info endpoints. We don't raise null events
                // on initial data...
                if (!node.isEmpty()) {
                    infoEvents = _this.infoSyncTree_.applyServerOverwrite(query.path, node);
                    setTimeout(function() {
                        onComplete("ok");
                    }, 0);
                }
                return infoEvents;
            },
            stopListening: function() {}
        });
        this.updateInfo_("connected", false);
        this.serverSyncTree_ = new $d1f87d24500ab009$var$SyncTree({
            startListening: function(query, tag, currentHashFn, onComplete) {
                _this.server_.listen(query, currentHashFn, tag, function(status, data) {
                    var events = onComplete(status, data);
                    _this.eventQueue_.raiseEventsForChangedPath(query.path, events);
                });
                // No synchronous events for network-backed sync trees
                return [];
            },
            stopListening: function(query, tag) {
                _this.server_.unlisten(query, tag);
            }
        });
    }
    /**
     * @return The URL corresponding to the root of this Firebase.
     */ Repo.prototype.toString = function() {
        return (this.repoInfo_.secure ? "https://" : "http://") + this.repoInfo_.host;
    };
    /**
     * @return The namespace represented by the repo.
     */ Repo.prototype.name = function() {
        return this.repoInfo_.namespace;
    };
    /**
     * @return The time in milliseconds, taking the server offset into account if we have one.
     */ Repo.prototype.serverTime = function() {
        var offsetNode = this.infoData_.getNode(new $d1f87d24500ab009$var$Path(".info/serverTimeOffset"));
        var offset = offsetNode.val() || 0;
        return new Date().getTime() + offset;
    };
    /**
     * Generate ServerValues using some variables from the repo object.
     */ Repo.prototype.generateServerValues = function() {
        return $d1f87d24500ab009$var$generateWithValues({
            timestamp: this.serverTime()
        });
    };
    /**
     * Called by realtime when we get new messages from the server.
     */ Repo.prototype.onDataUpdate_ = function(pathString, data, isMerge, tag) {
        // For testing.
        this.dataUpdateCount++;
        var path = new $d1f87d24500ab009$var$Path(pathString);
        data = this.interceptServerDataCallback_ ? this.interceptServerDataCallback_(pathString, data) : data;
        var events = [];
        if (tag) {
            if (isMerge) {
                var taggedChildren = $01sTD.map(data, function(raw) {
                    return $d1f87d24500ab009$var$nodeFromJSON$1(raw);
                });
                events = this.serverSyncTree_.applyTaggedQueryMerge(path, taggedChildren, tag);
            } else {
                var taggedSnap = $d1f87d24500ab009$var$nodeFromJSON$1(data);
                events = this.serverSyncTree_.applyTaggedQueryOverwrite(path, taggedSnap, tag);
            }
        } else if (isMerge) {
            var changedChildren = $01sTD.map(data, function(raw) {
                return $d1f87d24500ab009$var$nodeFromJSON$1(raw);
            });
            events = this.serverSyncTree_.applyServerMerge(path, changedChildren);
        } else {
            var snap = $d1f87d24500ab009$var$nodeFromJSON$1(data);
            events = this.serverSyncTree_.applyServerOverwrite(path, snap);
        }
        var affectedPath = path;
        if (events.length > 0) // Since we have a listener outstanding for each transaction, receiving any events
        // is a proxy for some change having occurred.
        affectedPath = this.rerunTransactions_(path);
        this.eventQueue_.raiseEventsForChangedPath(affectedPath, events);
    };
    // TODO: This should be @private but it's used by test_access.js and internal.js
    Repo.prototype.interceptServerData_ = function(callback) {
        this.interceptServerDataCallback_ = callback;
    };
    Repo.prototype.onConnectStatus_ = function(connectStatus) {
        this.updateInfo_("connected", connectStatus);
        if (connectStatus === false) this.runOnDisconnectEvents_();
    };
    Repo.prototype.onServerInfoUpdate_ = function(updates) {
        var _this = this;
        $d1f87d24500ab009$var$each(updates, function(key, value) {
            _this.updateInfo_(key, value);
        });
    };
    Repo.prototype.updateInfo_ = function(pathString, value) {
        var path = new $d1f87d24500ab009$var$Path("/.info/" + pathString);
        var newNode = $d1f87d24500ab009$var$nodeFromJSON$1(value);
        this.infoData_.updateSnapshot(path, newNode);
        var events = this.infoSyncTree_.applyServerOverwrite(path, newNode);
        this.eventQueue_.raiseEventsForChangedPath(path, events);
    };
    Repo.prototype.getNextWriteId_ = function() {
        return this.nextWriteId_++;
    };
    Repo.prototype.setWithPriority = function(path, newVal, newPriority, onComplete) {
        var _this = this;
        this.log_("set", {
            path: path.toString(),
            value: newVal,
            priority: newPriority
        });
        // TODO: Optimize this behavior to either (a) store flag to skip resolving where possible and / or
        // (b) store unresolved paths on JSON parse
        var serverValues = this.generateServerValues();
        var newNodeUnresolved = $d1f87d24500ab009$var$nodeFromJSON$1(newVal, newPriority);
        var existing = this.serverSyncTree_.calcCompleteEventCache(path);
        var newNode = $d1f87d24500ab009$var$resolveDeferredValueSnapshot(newNodeUnresolved, existing, serverValues);
        var writeId = this.getNextWriteId_();
        var events = this.serverSyncTree_.applyUserOverwrite(path, newNode, writeId, true);
        this.eventQueue_.queueEvents(events);
        this.server_.put(path.toString(), newNodeUnresolved.val(/*export=*/ true), function(status, errorReason) {
            var success = status === "ok";
            if (!success) $d1f87d24500ab009$var$warn("set at " + path + " failed: " + status);
            var clearEvents = _this.serverSyncTree_.ackUserWrite(writeId, !success);
            _this.eventQueue_.raiseEventsForChangedPath(path, clearEvents);
            _this.callOnCompleteCallback(onComplete, status, errorReason);
        });
        var affectedPath = this.abortTransactions_(path);
        this.rerunTransactions_(affectedPath);
        // We queued the events above, so just flush the queue here
        this.eventQueue_.raiseEventsForChangedPath(affectedPath, []);
    };
    Repo.prototype.update = function(path, childrenToMerge, onComplete) {
        var _this = this;
        this.log_("update", {
            path: path.toString(),
            value: childrenToMerge
        });
        // Start with our existing data and merge each child into it.
        var empty = true;
        var serverValues = this.generateServerValues();
        var changedChildren = {};
        $d1f87d24500ab009$var$each(childrenToMerge, function(changedKey, changedValue) {
            empty = false;
            changedChildren[changedKey] = $d1f87d24500ab009$var$resolveDeferredValueTree(path.child(changedKey), $d1f87d24500ab009$var$nodeFromJSON$1(changedValue), _this.serverSyncTree_, serverValues);
        });
        if (!empty) {
            var writeId_1 = this.getNextWriteId_();
            var events = this.serverSyncTree_.applyUserMerge(path, changedChildren, writeId_1);
            this.eventQueue_.queueEvents(events);
            this.server_.merge(path.toString(), childrenToMerge, function(status, errorReason) {
                var success = status === "ok";
                if (!success) $d1f87d24500ab009$var$warn("update at " + path + " failed: " + status);
                var clearEvents = _this.serverSyncTree_.ackUserWrite(writeId_1, !success);
                var affectedPath = clearEvents.length > 0 ? _this.rerunTransactions_(path) : path;
                _this.eventQueue_.raiseEventsForChangedPath(affectedPath, clearEvents);
                _this.callOnCompleteCallback(onComplete, status, errorReason);
            });
            $d1f87d24500ab009$var$each(childrenToMerge, function(changedPath) {
                var affectedPath = _this.abortTransactions_(path.child(changedPath));
                _this.rerunTransactions_(affectedPath);
            });
            // We queued the events above, so just flush the queue here
            this.eventQueue_.raiseEventsForChangedPath(path, []);
        } else {
            $d1f87d24500ab009$var$log("update() called with empty data.  Don't do anything.");
            this.callOnCompleteCallback(onComplete, "ok");
        }
    };
    /**
     * Applies all of the changes stored up in the onDisconnect_ tree.
     */ Repo.prototype.runOnDisconnectEvents_ = function() {
        var _this = this;
        this.log_("onDisconnectEvents");
        var serverValues = this.generateServerValues();
        var resolvedOnDisconnectTree = new $d1f87d24500ab009$var$SparseSnapshotTree();
        this.onDisconnect_.forEachTree($d1f87d24500ab009$var$Path.Empty, function(path, node) {
            var resolved = $d1f87d24500ab009$var$resolveDeferredValueTree(path, node, _this.serverSyncTree_, serverValues);
            resolvedOnDisconnectTree.remember(path, resolved);
        });
        var events = [];
        resolvedOnDisconnectTree.forEachTree($d1f87d24500ab009$var$Path.Empty, function(path, snap) {
            events = events.concat(_this.serverSyncTree_.applyServerOverwrite(path, snap));
            var affectedPath = _this.abortTransactions_(path);
            _this.rerunTransactions_(affectedPath);
        });
        this.onDisconnect_ = new $d1f87d24500ab009$var$SparseSnapshotTree();
        this.eventQueue_.raiseEventsForChangedPath($d1f87d24500ab009$var$Path.Empty, events);
    };
    Repo.prototype.onDisconnectCancel = function(path, onComplete) {
        var _this = this;
        this.server_.onDisconnectCancel(path.toString(), function(status, errorReason) {
            if (status === "ok") _this.onDisconnect_.forget(path);
            _this.callOnCompleteCallback(onComplete, status, errorReason);
        });
    };
    Repo.prototype.onDisconnectSet = function(path, value, onComplete) {
        var _this = this;
        var newNode = $d1f87d24500ab009$var$nodeFromJSON$1(value);
        this.server_.onDisconnectPut(path.toString(), newNode.val(/*export=*/ true), function(status, errorReason) {
            if (status === "ok") _this.onDisconnect_.remember(path, newNode);
            _this.callOnCompleteCallback(onComplete, status, errorReason);
        });
    };
    Repo.prototype.onDisconnectSetWithPriority = function(path, value, priority, onComplete) {
        var _this = this;
        var newNode = $d1f87d24500ab009$var$nodeFromJSON$1(value, priority);
        this.server_.onDisconnectPut(path.toString(), newNode.val(/*export=*/ true), function(status, errorReason) {
            if (status === "ok") _this.onDisconnect_.remember(path, newNode);
            _this.callOnCompleteCallback(onComplete, status, errorReason);
        });
    };
    Repo.prototype.onDisconnectUpdate = function(path, childrenToMerge, onComplete) {
        var _this = this;
        if ($01sTD.isEmpty(childrenToMerge)) {
            $d1f87d24500ab009$var$log("onDisconnect().update() called with empty data.  Don't do anything.");
            this.callOnCompleteCallback(onComplete, "ok");
            return;
        }
        this.server_.onDisconnectMerge(path.toString(), childrenToMerge, function(status, errorReason) {
            if (status === "ok") $d1f87d24500ab009$var$each(childrenToMerge, function(childName, childNode) {
                var newChildNode = $d1f87d24500ab009$var$nodeFromJSON$1(childNode);
                _this.onDisconnect_.remember(path.child(childName), newChildNode);
            });
            _this.callOnCompleteCallback(onComplete, status, errorReason);
        });
    };
    Repo.prototype.addEventCallbackForQuery = function(query, eventRegistration) {
        var events;
        if (query.path.getFront() === ".info") events = this.infoSyncTree_.addEventRegistration(query, eventRegistration);
        else events = this.serverSyncTree_.addEventRegistration(query, eventRegistration);
        this.eventQueue_.raiseEventsAtPath(query.path, events);
    };
    Repo.prototype.removeEventCallbackForQuery = function(query, eventRegistration) {
        // These are guaranteed not to raise events, since we're not passing in a cancelError. However, we can future-proof
        // a little bit by handling the return values anyways.
        var events;
        if (query.path.getFront() === ".info") events = this.infoSyncTree_.removeEventRegistration(query, eventRegistration);
        else events = this.serverSyncTree_.removeEventRegistration(query, eventRegistration);
        this.eventQueue_.raiseEventsAtPath(query.path, events);
    };
    Repo.prototype.interrupt = function() {
        if (this.persistentConnection_) this.persistentConnection_.interrupt($d1f87d24500ab009$var$INTERRUPT_REASON);
    };
    Repo.prototype.resume = function() {
        if (this.persistentConnection_) this.persistentConnection_.resume($d1f87d24500ab009$var$INTERRUPT_REASON);
    };
    Repo.prototype.stats = function(showDelta) {
        if (showDelta === void 0) showDelta = false;
        if (typeof console === "undefined") return;
        var stats;
        if (showDelta) {
            if (!this.statsListener_) this.statsListener_ = new $d1f87d24500ab009$var$StatsListener(this.stats_);
            stats = this.statsListener_.get();
        } else stats = this.stats_.get();
        var longestName = Object.keys(stats).reduce(function(previousValue, currentValue) {
            return Math.max(currentValue.length, previousValue);
        }, 0);
        $d1f87d24500ab009$var$each(stats, function(stat, value) {
            var paddedStat = stat;
            // pad stat names to be the same length (plus 2 extra spaces).
            for(var i = stat.length; i < longestName + 2; i++)paddedStat += " ";
            console.log(paddedStat + value);
        });
    };
    Repo.prototype.statsIncrementCounter = function(metric) {
        this.stats_.incrementCounter(metric);
        this.statsReporter_.includeStat(metric);
    };
    Repo.prototype.log_ = function() {
        var varArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)varArgs[_i] = arguments[_i];
        var prefix = "";
        if (this.persistentConnection_) prefix = this.persistentConnection_.id + ":";
        $d1f87d24500ab009$var$log.apply(void 0, $a92b69d2447c208d$export$afc72e2116322959([
            prefix
        ], varArgs));
    };
    Repo.prototype.callOnCompleteCallback = function(callback, status, errorReason) {
        if (callback) $d1f87d24500ab009$var$exceptionGuard(function() {
            if (status === "ok") callback(null);
            else {
                var code = (status || "error").toUpperCase();
                var message = code;
                if (errorReason) message += ": " + errorReason;
                var error = new Error(message);
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                error.code = code;
                callback(error);
            }
        });
    };
    Object.defineProperty(Repo.prototype, "database", {
        get: function() {
            return this.__database || (this.__database = new $d1f87d24500ab009$var$Database(this));
        },
        enumerable: false,
        configurable: true
    });
    return Repo;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Filters nodes by range and uses an IndexFilter to track any changes after filtering the node
 *
 * @constructor
 * @implements {NodeFilter}
 */ var $d1f87d24500ab009$var$RangedFilter = /** @class */ function() {
    /**
     * @param {!QueryParams} params
     */ function RangedFilter(params) {
        this.indexedFilter_ = new $d1f87d24500ab009$var$IndexedFilter(params.getIndex());
        this.index_ = params.getIndex();
        this.startPost_ = RangedFilter.getStartPost_(params);
        this.endPost_ = RangedFilter.getEndPost_(params);
    }
    /**
     * @return {!NamedNode}
     */ RangedFilter.prototype.getStartPost = function() {
        return this.startPost_;
    };
    /**
     * @return {!NamedNode}
     */ RangedFilter.prototype.getEndPost = function() {
        return this.endPost_;
    };
    /**
     * @param {!NamedNode} node
     * @return {boolean}
     */ RangedFilter.prototype.matches = function(node) {
        return this.index_.compare(this.getStartPost(), node) <= 0 && this.index_.compare(node, this.getEndPost()) <= 0;
    };
    /**
     * @inheritDoc
     */ RangedFilter.prototype.updateChild = function(snap, key, newChild, affectedPath, source, optChangeAccumulator) {
        if (!this.matches(new $d1f87d24500ab009$var$NamedNode(key, newChild))) newChild = $d1f87d24500ab009$var$ChildrenNode.EMPTY_NODE;
        return this.indexedFilter_.updateChild(snap, key, newChild, affectedPath, source, optChangeAccumulator);
    };
    /**
     * @inheritDoc
     */ RangedFilter.prototype.updateFullNode = function(oldSnap, newSnap, optChangeAccumulator) {
        if (newSnap.isLeafNode()) // Make sure we have a children node with the correct index, not a leaf node;
        newSnap = $d1f87d24500ab009$var$ChildrenNode.EMPTY_NODE;
        var filtered = newSnap.withIndex(this.index_);
        // Don't support priorities on queries
        filtered = filtered.updatePriority($d1f87d24500ab009$var$ChildrenNode.EMPTY_NODE);
        var self = this;
        newSnap.forEachChild($d1f87d24500ab009$var$PRIORITY_INDEX, function(key, childNode) {
            if (!self.matches(new $d1f87d24500ab009$var$NamedNode(key, childNode))) filtered = filtered.updateImmediateChild(key, $d1f87d24500ab009$var$ChildrenNode.EMPTY_NODE);
        });
        return this.indexedFilter_.updateFullNode(oldSnap, filtered, optChangeAccumulator);
    };
    /**
     * @inheritDoc
     */ RangedFilter.prototype.updatePriority = function(oldSnap, newPriority) {
        // Don't support priorities on queries
        return oldSnap;
    };
    /**
     * @inheritDoc
     */ RangedFilter.prototype.filtersNodes = function() {
        return true;
    };
    /**
     * @inheritDoc
     */ RangedFilter.prototype.getIndexedFilter = function() {
        return this.indexedFilter_;
    };
    /**
     * @inheritDoc
     */ RangedFilter.prototype.getIndex = function() {
        return this.index_;
    };
    /**
     * @param {!QueryParams} params
     * @return {!NamedNode}
     * @private
     */ RangedFilter.getStartPost_ = function(params) {
        if (params.hasStart()) {
            var startName = params.getIndexStartName();
            return params.getIndex().makePost(params.getIndexStartValue(), startName);
        } else return params.getIndex().minPost();
    };
    /**
     * @param {!QueryParams} params
     * @return {!NamedNode}
     * @private
     */ RangedFilter.getEndPost_ = function(params) {
        if (params.hasEnd()) {
            var endName = params.getIndexEndName();
            return params.getIndex().makePost(params.getIndexEndValue(), endName);
        } else return params.getIndex().maxPost();
    };
    return RangedFilter;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Applies a limit and a range to a node and uses RangedFilter to do the heavy lifting where possible
 *
 * @constructor
 * @implements {NodeFilter}
 */ var $d1f87d24500ab009$var$LimitedFilter = /** @class */ function() {
    /**
     * @param {!QueryParams} params
     */ function LimitedFilter(params) {
        this.rangedFilter_ = new $d1f87d24500ab009$var$RangedFilter(params);
        this.index_ = params.getIndex();
        this.limit_ = params.getLimit();
        this.reverse_ = !params.isViewFromLeft();
    }
    /**
     * @inheritDoc
     */ LimitedFilter.prototype.updateChild = function(snap, key, newChild, affectedPath, source, optChangeAccumulator) {
        if (!this.rangedFilter_.matches(new $d1f87d24500ab009$var$NamedNode(key, newChild))) newChild = $d1f87d24500ab009$var$ChildrenNode.EMPTY_NODE;
        if (snap.getImmediateChild(key).equals(newChild)) // No change
        return snap;
        else if (snap.numChildren() < this.limit_) return this.rangedFilter_.getIndexedFilter().updateChild(snap, key, newChild, affectedPath, source, optChangeAccumulator);
        else return this.fullLimitUpdateChild_(snap, key, newChild, source, optChangeAccumulator);
    };
    /**
     * @inheritDoc
     */ LimitedFilter.prototype.updateFullNode = function(oldSnap, newSnap, optChangeAccumulator) {
        var filtered;
        if (newSnap.isLeafNode() || newSnap.isEmpty()) // Make sure we have a children node with the correct index, not a leaf node;
        filtered = $d1f87d24500ab009$var$ChildrenNode.EMPTY_NODE.withIndex(this.index_);
        else if (this.limit_ * 2 < newSnap.numChildren() && newSnap.isIndexed(this.index_)) {
            // Easier to build up a snapshot, since what we're given has more than twice the elements we want
            filtered = $d1f87d24500ab009$var$ChildrenNode.EMPTY_NODE.withIndex(this.index_);
            // anchor to the startPost, endPost, or last element as appropriate
            var iterator = void 0;
            if (this.reverse_) iterator = newSnap.getReverseIteratorFrom(this.rangedFilter_.getEndPost(), this.index_);
            else iterator = newSnap.getIteratorFrom(this.rangedFilter_.getStartPost(), this.index_);
            var count = 0;
            while(iterator.hasNext() && count < this.limit_){
                var next = iterator.getNext();
                var inRange = void 0;
                if (this.reverse_) inRange = this.index_.compare(this.rangedFilter_.getStartPost(), next) <= 0;
                else inRange = this.index_.compare(next, this.rangedFilter_.getEndPost()) <= 0;
                if (inRange) {
                    filtered = filtered.updateImmediateChild(next.name, next.node);
                    count++;
                } else break;
            }
        } else {
            // The snap contains less than twice the limit. Faster to delete from the snap than build up a new one
            filtered = newSnap.withIndex(this.index_);
            // Don't support priorities on queries
            filtered = filtered.updatePriority($d1f87d24500ab009$var$ChildrenNode.EMPTY_NODE);
            var startPost = void 0;
            var endPost = void 0;
            var cmp = void 0;
            var iterator = void 0;
            if (this.reverse_) {
                iterator = filtered.getReverseIterator(this.index_);
                startPost = this.rangedFilter_.getEndPost();
                endPost = this.rangedFilter_.getStartPost();
                var indexCompare_1 = this.index_.getCompare();
                cmp = function(a, b) {
                    return indexCompare_1(b, a);
                };
            } else {
                iterator = filtered.getIterator(this.index_);
                startPost = this.rangedFilter_.getStartPost();
                endPost = this.rangedFilter_.getEndPost();
                cmp = this.index_.getCompare();
            }
            var count = 0;
            var foundStartPost = false;
            while(iterator.hasNext()){
                var next = iterator.getNext();
                if (!foundStartPost && cmp(startPost, next) <= 0) // start adding
                foundStartPost = true;
                var inRange = foundStartPost && count < this.limit_ && cmp(next, endPost) <= 0;
                if (inRange) count++;
                else filtered = filtered.updateImmediateChild(next.name, $d1f87d24500ab009$var$ChildrenNode.EMPTY_NODE);
            }
        }
        return this.rangedFilter_.getIndexedFilter().updateFullNode(oldSnap, filtered, optChangeAccumulator);
    };
    /**
     * @inheritDoc
     */ LimitedFilter.prototype.updatePriority = function(oldSnap, newPriority) {
        // Don't support priorities on queries
        return oldSnap;
    };
    /**
     * @inheritDoc
     */ LimitedFilter.prototype.filtersNodes = function() {
        return true;
    };
    /**
     * @inheritDoc
     */ LimitedFilter.prototype.getIndexedFilter = function() {
        return this.rangedFilter_.getIndexedFilter();
    };
    /**
     * @inheritDoc
     */ LimitedFilter.prototype.getIndex = function() {
        return this.index_;
    };
    /**
     * @param {!Node} snap
     * @param {string} childKey
     * @param {!Node} childSnap
     * @param {!CompleteChildSource} source
     * @param {?ChildChangeAccumulator} changeAccumulator
     * @return {!Node}
     * @private
     */ LimitedFilter.prototype.fullLimitUpdateChild_ = function(snap, childKey, childSnap, source, changeAccumulator) {
        // TODO: rename all cache stuff etc to general snap terminology
        var cmp;
        if (this.reverse_) {
            var indexCmp_1 = this.index_.getCompare();
            cmp = function(a, b) {
                return indexCmp_1(b, a);
            };
        } else cmp = this.index_.getCompare();
        var oldEventCache = snap;
        $01sTD.assert(oldEventCache.numChildren() === this.limit_, "");
        var newChildNamedNode = new $d1f87d24500ab009$var$NamedNode(childKey, childSnap);
        var windowBoundary = this.reverse_ ? oldEventCache.getFirstChild(this.index_) : oldEventCache.getLastChild(this.index_);
        var inRange = this.rangedFilter_.matches(newChildNamedNode);
        if (oldEventCache.hasChild(childKey)) {
            var oldChildSnap = oldEventCache.getImmediateChild(childKey);
            var nextChild = source.getChildAfterChild(this.index_, windowBoundary, this.reverse_);
            while(nextChild != null && (nextChild.name === childKey || oldEventCache.hasChild(nextChild.name)))// There is a weird edge case where a node is updated as part of a merge in the write tree, but hasn't
            // been applied to the limited filter yet. Ignore this next child which will be updated later in
            // the limited filter...
            nextChild = source.getChildAfterChild(this.index_, nextChild, this.reverse_);
            var compareNext = nextChild == null ? 1 : cmp(nextChild, newChildNamedNode);
            var remainsInWindow = inRange && !childSnap.isEmpty() && compareNext >= 0;
            if (remainsInWindow) {
                if (changeAccumulator != null) changeAccumulator.trackChildChange($d1f87d24500ab009$var$Change.childChangedChange(childKey, childSnap, oldChildSnap));
                return oldEventCache.updateImmediateChild(childKey, childSnap);
            } else {
                if (changeAccumulator != null) changeAccumulator.trackChildChange($d1f87d24500ab009$var$Change.childRemovedChange(childKey, oldChildSnap));
                var newEventCache = oldEventCache.updateImmediateChild(childKey, $d1f87d24500ab009$var$ChildrenNode.EMPTY_NODE);
                var nextChildInRange = nextChild != null && this.rangedFilter_.matches(nextChild);
                if (nextChildInRange) {
                    if (changeAccumulator != null) changeAccumulator.trackChildChange($d1f87d24500ab009$var$Change.childAddedChange(nextChild.name, nextChild.node));
                    return newEventCache.updateImmediateChild(nextChild.name, nextChild.node);
                } else return newEventCache;
            }
        } else if (childSnap.isEmpty()) // we're deleting a node, but it was not in the window, so ignore it
        return snap;
        else if (inRange) {
            if (cmp(windowBoundary, newChildNamedNode) >= 0) {
                if (changeAccumulator != null) {
                    changeAccumulator.trackChildChange($d1f87d24500ab009$var$Change.childRemovedChange(windowBoundary.name, windowBoundary.node));
                    changeAccumulator.trackChildChange($d1f87d24500ab009$var$Change.childAddedChange(childKey, childSnap));
                }
                return oldEventCache.updateImmediateChild(childKey, childSnap).updateImmediateChild(windowBoundary.name, $d1f87d24500ab009$var$ChildrenNode.EMPTY_NODE);
            } else return snap;
        } else return snap;
    };
    return LimitedFilter;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * This class is an immutable-from-the-public-api struct containing a set of query parameters defining a
 * range to be returned for a particular location. It is assumed that validation of parameters is done at the
 * user-facing API level, so it is not done here.
 * @constructor
 */ var $d1f87d24500ab009$var$QueryParams = /** @class */ function() {
    function QueryParams() {
        this.limitSet_ = false;
        this.startSet_ = false;
        this.startNameSet_ = false;
        this.endSet_ = false;
        this.endNameSet_ = false;
        this.limit_ = 0;
        this.viewFrom_ = "";
        this.indexStartValue_ = null;
        this.indexStartName_ = "";
        this.indexEndValue_ = null;
        this.indexEndName_ = "";
        this.index_ = $d1f87d24500ab009$var$PRIORITY_INDEX;
    }
    /**
     * @return {boolean}
     */ QueryParams.prototype.hasStart = function() {
        return this.startSet_;
    };
    /**
     * @return {boolean} True if it would return from left.
     */ QueryParams.prototype.isViewFromLeft = function() {
        if (this.viewFrom_ === "") // limit(), rather than limitToFirst or limitToLast was called.
        // This means that only one of startSet_ and endSet_ is true. Use them
        // to calculate which side of the view to anchor to. If neither is set,
        // anchor to the end.
        return this.startSet_;
        else return this.viewFrom_ === QueryParams.WIRE_PROTOCOL_CONSTANTS_.VIEW_FROM_LEFT;
    };
    /**
     * Only valid to call if hasStart() returns true
     * @return {*}
     */ QueryParams.prototype.getIndexStartValue = function() {
        $01sTD.assert(this.startSet_, "Only valid if start has been set");
        return this.indexStartValue_;
    };
    /**
     * Only valid to call if hasStart() returns true.
     * Returns the starting key name for the range defined by these query parameters
     * @return {!string}
     */ QueryParams.prototype.getIndexStartName = function() {
        $01sTD.assert(this.startSet_, "Only valid if start has been set");
        if (this.startNameSet_) return this.indexStartName_;
        else return $d1f87d24500ab009$var$MIN_NAME;
    };
    /**
     * @return {boolean}
     */ QueryParams.prototype.hasEnd = function() {
        return this.endSet_;
    };
    /**
     * Only valid to call if hasEnd() returns true.
     * @return {*}
     */ QueryParams.prototype.getIndexEndValue = function() {
        $01sTD.assert(this.endSet_, "Only valid if end has been set");
        return this.indexEndValue_;
    };
    /**
     * Only valid to call if hasEnd() returns true.
     * Returns the end key name for the range defined by these query parameters
     * @return {!string}
     */ QueryParams.prototype.getIndexEndName = function() {
        $01sTD.assert(this.endSet_, "Only valid if end has been set");
        if (this.endNameSet_) return this.indexEndName_;
        else return $d1f87d24500ab009$var$MAX_NAME;
    };
    /**
     * @return {boolean}
     */ QueryParams.prototype.hasLimit = function() {
        return this.limitSet_;
    };
    /**
     * @return {boolean} True if a limit has been set and it has been explicitly anchored
     */ QueryParams.prototype.hasAnchoredLimit = function() {
        return this.limitSet_ && this.viewFrom_ !== "";
    };
    /**
     * Only valid to call if hasLimit() returns true
     * @return {!number}
     */ QueryParams.prototype.getLimit = function() {
        $01sTD.assert(this.limitSet_, "Only valid if limit has been set");
        return this.limit_;
    };
    /**
     * @return {!Index}
     */ QueryParams.prototype.getIndex = function() {
        return this.index_;
    };
    /**
     * @return {!QueryParams}
     * @private
     */ QueryParams.prototype.copy_ = function() {
        var copy = new QueryParams();
        copy.limitSet_ = this.limitSet_;
        copy.limit_ = this.limit_;
        copy.startSet_ = this.startSet_;
        copy.indexStartValue_ = this.indexStartValue_;
        copy.startNameSet_ = this.startNameSet_;
        copy.indexStartName_ = this.indexStartName_;
        copy.endSet_ = this.endSet_;
        copy.indexEndValue_ = this.indexEndValue_;
        copy.endNameSet_ = this.endNameSet_;
        copy.indexEndName_ = this.indexEndName_;
        copy.index_ = this.index_;
        copy.viewFrom_ = this.viewFrom_;
        return copy;
    };
    /**
     * @param {!number} newLimit
     * @return {!QueryParams}
     */ QueryParams.prototype.limit = function(newLimit) {
        var newParams = this.copy_();
        newParams.limitSet_ = true;
        newParams.limit_ = newLimit;
        newParams.viewFrom_ = "";
        return newParams;
    };
    /**
     * @param {!number} newLimit
     * @return {!QueryParams}
     */ QueryParams.prototype.limitToFirst = function(newLimit) {
        var newParams = this.copy_();
        newParams.limitSet_ = true;
        newParams.limit_ = newLimit;
        newParams.viewFrom_ = QueryParams.WIRE_PROTOCOL_CONSTANTS_.VIEW_FROM_LEFT;
        return newParams;
    };
    /**
     * @param {!number} newLimit
     * @return {!QueryParams}
     */ QueryParams.prototype.limitToLast = function(newLimit) {
        var newParams = this.copy_();
        newParams.limitSet_ = true;
        newParams.limit_ = newLimit;
        newParams.viewFrom_ = QueryParams.WIRE_PROTOCOL_CONSTANTS_.VIEW_FROM_RIGHT;
        return newParams;
    };
    /**
     * @param {*} indexValue
     * @param {?string=} key
     * @return {!QueryParams}
     */ QueryParams.prototype.startAt = function(indexValue, key) {
        var newParams = this.copy_();
        newParams.startSet_ = true;
        if (indexValue === undefined) indexValue = null;
        newParams.indexStartValue_ = indexValue;
        if (key != null) {
            newParams.startNameSet_ = true;
            newParams.indexStartName_ = key;
        } else {
            newParams.startNameSet_ = false;
            newParams.indexStartName_ = "";
        }
        return newParams;
    };
    /**
     * @param {*} indexValue
     * @param {?string=} key
     * @return {!QueryParams}
     */ QueryParams.prototype.endAt = function(indexValue, key) {
        var newParams = this.copy_();
        newParams.endSet_ = true;
        if (indexValue === undefined) indexValue = null;
        newParams.indexEndValue_ = indexValue;
        if (key !== undefined) {
            newParams.endNameSet_ = true;
            newParams.indexEndName_ = key;
        } else {
            newParams.endNameSet_ = false;
            newParams.indexEndName_ = "";
        }
        return newParams;
    };
    /**
     * @param {!Index} index
     * @return {!QueryParams}
     */ QueryParams.prototype.orderBy = function(index) {
        var newParams = this.copy_();
        newParams.index_ = index;
        return newParams;
    };
    /**
     * @return {!Object}
     */ QueryParams.prototype.getQueryObject = function() {
        var WIRE_PROTOCOL_CONSTANTS = QueryParams.WIRE_PROTOCOL_CONSTANTS_;
        var obj = {};
        if (this.startSet_) {
            obj[WIRE_PROTOCOL_CONSTANTS.INDEX_START_VALUE] = this.indexStartValue_;
            if (this.startNameSet_) obj[WIRE_PROTOCOL_CONSTANTS.INDEX_START_NAME] = this.indexStartName_;
        }
        if (this.endSet_) {
            obj[WIRE_PROTOCOL_CONSTANTS.INDEX_END_VALUE] = this.indexEndValue_;
            if (this.endNameSet_) obj[WIRE_PROTOCOL_CONSTANTS.INDEX_END_NAME] = this.indexEndName_;
        }
        if (this.limitSet_) {
            obj[WIRE_PROTOCOL_CONSTANTS.LIMIT] = this.limit_;
            var viewFrom = this.viewFrom_;
            if (viewFrom === "") {
                if (this.isViewFromLeft()) viewFrom = WIRE_PROTOCOL_CONSTANTS.VIEW_FROM_LEFT;
                else viewFrom = WIRE_PROTOCOL_CONSTANTS.VIEW_FROM_RIGHT;
            }
            obj[WIRE_PROTOCOL_CONSTANTS.VIEW_FROM] = viewFrom;
        }
        // For now, priority index is the default, so we only specify if it's some other index
        if (this.index_ !== $d1f87d24500ab009$var$PRIORITY_INDEX) obj[WIRE_PROTOCOL_CONSTANTS.INDEX] = this.index_.toString();
        return obj;
    };
    /**
     * @return {boolean}
     */ QueryParams.prototype.loadsAllData = function() {
        return !(this.startSet_ || this.endSet_ || this.limitSet_);
    };
    /**
     * @return {boolean}
     */ QueryParams.prototype.isDefault = function() {
        return this.loadsAllData() && this.index_ === $d1f87d24500ab009$var$PRIORITY_INDEX;
    };
    /**
     * @return {!NodeFilter}
     */ QueryParams.prototype.getNodeFilter = function() {
        if (this.loadsAllData()) return new $d1f87d24500ab009$var$IndexedFilter(this.getIndex());
        else if (this.hasLimit()) return new $d1f87d24500ab009$var$LimitedFilter(this);
        else return new $d1f87d24500ab009$var$RangedFilter(this);
    };
    /**
     * Returns a set of REST query string parameters representing this query.
     *
     * @return {!Object.<string,*>} query string parameters
     */ QueryParams.prototype.toRestQueryStringParameters = function() {
        var REST_CONSTANTS = QueryParams.REST_QUERY_CONSTANTS_;
        var qs = {};
        if (this.isDefault()) return qs;
        var orderBy;
        if (this.index_ === $d1f87d24500ab009$var$PRIORITY_INDEX) orderBy = REST_CONSTANTS.PRIORITY_INDEX;
        else if (this.index_ === $d1f87d24500ab009$var$VALUE_INDEX) orderBy = REST_CONSTANTS.VALUE_INDEX;
        else if (this.index_ === $d1f87d24500ab009$var$KEY_INDEX) orderBy = REST_CONSTANTS.KEY_INDEX;
        else {
            $01sTD.assert(this.index_ instanceof $d1f87d24500ab009$var$PathIndex, "Unrecognized index type!");
            orderBy = this.index_.toString();
        }
        qs[REST_CONSTANTS.ORDER_BY] = $01sTD.stringify(orderBy);
        if (this.startSet_) {
            qs[REST_CONSTANTS.START_AT] = $01sTD.stringify(this.indexStartValue_);
            if (this.startNameSet_) qs[REST_CONSTANTS.START_AT] += "," + $01sTD.stringify(this.indexStartName_);
        }
        if (this.endSet_) {
            qs[REST_CONSTANTS.END_AT] = $01sTD.stringify(this.indexEndValue_);
            if (this.endNameSet_) qs[REST_CONSTANTS.END_AT] += "," + $01sTD.stringify(this.indexEndName_);
        }
        if (this.limitSet_) {
            if (this.isViewFromLeft()) qs[REST_CONSTANTS.LIMIT_TO_FIRST] = this.limit_;
            else qs[REST_CONSTANTS.LIMIT_TO_LAST] = this.limit_;
        }
        return qs;
    };
    /**
     * Wire Protocol Constants
     * @const
     * @enum {string}
     * @private
     */ QueryParams.WIRE_PROTOCOL_CONSTANTS_ = {
        INDEX_START_VALUE: "sp",
        INDEX_START_NAME: "sn",
        INDEX_END_VALUE: "ep",
        INDEX_END_NAME: "en",
        LIMIT: "l",
        VIEW_FROM: "vf",
        VIEW_FROM_LEFT: "l",
        VIEW_FROM_RIGHT: "r",
        INDEX: "i"
    };
    /**
     * REST Query Constants
     * @const
     * @enum {string}
     * @private
     */ QueryParams.REST_QUERY_CONSTANTS_ = {
        ORDER_BY: "orderBy",
        PRIORITY_INDEX: "$priority",
        VALUE_INDEX: "$value",
        KEY_INDEX: "$key",
        START_AT: "startAt",
        END_AT: "endAt",
        LIMIT_TO_FIRST: "limitToFirst",
        LIMIT_TO_LAST: "limitToLast"
    };
    /**
     * Default, empty query parameters
     * @type {!QueryParams}
     * @const
     */ QueryParams.DEFAULT = new QueryParams();
    return QueryParams;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $d1f87d24500ab009$var$Reference = /** @class */ function(_super) {
    $a92b69d2447c208d$export$a8ba968b8961cb8a(Reference, _super);
    /**
     * Call options:
     *   new Reference(Repo, Path) or
     *   new Reference(url: string, string|RepoManager)
     *
     * Externally - this is the firebase.database.Reference type.
     *
     * @param {!Repo} repo
     * @param {(!Path)} path
     * @extends {Query}
     */ function Reference(repo, path) {
        var _this = this;
        if (!(repo instanceof $d1f87d24500ab009$var$Repo)) throw new Error("new Reference() no longer supported - use app.database().");
        // call Query's constructor, passing in the repo and path.
        _this = _super.call(this, repo, path, $d1f87d24500ab009$var$QueryParams.DEFAULT, false) || this;
        return _this;
    }
    /** @return {?string} */ Reference.prototype.getKey = function() {
        $01sTD.validateArgCount("Reference.key", 0, 0, arguments.length);
        if (this.path.isEmpty()) return null;
        else return this.path.getBack();
    };
    /**
     * @param {!(string|Path)} pathString
     * @return {!Reference}
     */ Reference.prototype.child = function(pathString) {
        $01sTD.validateArgCount("Reference.child", 1, 1, arguments.length);
        if (typeof pathString === "number") pathString = String(pathString);
        else if (!(pathString instanceof $d1f87d24500ab009$var$Path)) {
            if (this.path.getFront() === null) $d1f87d24500ab009$var$validateRootPathString("Reference.child", 1, pathString, false);
            else $d1f87d24500ab009$var$validatePathString("Reference.child", 1, pathString, false);
        }
        return new Reference(this.repo, this.path.child(pathString));
    };
    /** @return {?Reference} */ Reference.prototype.getParent = function() {
        $01sTD.validateArgCount("Reference.parent", 0, 0, arguments.length);
        var parentPath = this.path.parent();
        return parentPath === null ? null : new Reference(this.repo, parentPath);
    };
    /** @return {!Reference} */ Reference.prototype.getRoot = function() {
        $01sTD.validateArgCount("Reference.root", 0, 0, arguments.length);
        var ref = this;
        while(ref.getParent() !== null)ref = ref.getParent();
        return ref;
    };
    /** @return {!Database} */ Reference.prototype.databaseProp = function() {
        return this.repo.database;
    };
    /**
     * @param {*} newVal
     * @param {function(?Error)=} onComplete
     * @return {!Promise}
     */ Reference.prototype.set = function(newVal, onComplete) {
        $01sTD.validateArgCount("Reference.set", 1, 2, arguments.length);
        $d1f87d24500ab009$var$validateWritablePath("Reference.set", this.path);
        $d1f87d24500ab009$var$validateFirebaseDataArg("Reference.set", 1, newVal, this.path, false);
        $01sTD.validateCallback("Reference.set", 2, onComplete, true);
        var deferred = new $01sTD.Deferred();
        this.repo.setWithPriority(this.path, newVal, /*priority=*/ null, deferred.wrapCallback(onComplete));
        return deferred.promise;
    };
    /**
     * @param {!Object} objectToMerge
     * @param {function(?Error)=} onComplete
     * @return {!Promise}
     */ Reference.prototype.update = function(objectToMerge, onComplete) {
        $01sTD.validateArgCount("Reference.update", 1, 2, arguments.length);
        $d1f87d24500ab009$var$validateWritablePath("Reference.update", this.path);
        if (Array.isArray(objectToMerge)) {
            var newObjectToMerge = {};
            for(var i = 0; i < objectToMerge.length; ++i)newObjectToMerge["" + i] = objectToMerge[i];
            objectToMerge = newObjectToMerge;
            $d1f87d24500ab009$var$warn("Passing an Array to Firebase.update() is deprecated. Use set() if you want to overwrite the existing data, or an Object with integer keys if you really do want to only update some of the children.");
        }
        $d1f87d24500ab009$var$validateFirebaseMergeDataArg("Reference.update", 1, objectToMerge, this.path, false);
        $01sTD.validateCallback("Reference.update", 2, onComplete, true);
        var deferred = new $01sTD.Deferred();
        this.repo.update(this.path, objectToMerge, deferred.wrapCallback(onComplete));
        return deferred.promise;
    };
    /**
     * @param {*} newVal
     * @param {string|number|null} newPriority
     * @param {function(?Error)=} onComplete
     * @return {!Promise}
     */ Reference.prototype.setWithPriority = function(newVal, newPriority, onComplete) {
        $01sTD.validateArgCount("Reference.setWithPriority", 2, 3, arguments.length);
        $d1f87d24500ab009$var$validateWritablePath("Reference.setWithPriority", this.path);
        $d1f87d24500ab009$var$validateFirebaseDataArg("Reference.setWithPriority", 1, newVal, this.path, false);
        $d1f87d24500ab009$var$validatePriority("Reference.setWithPriority", 2, newPriority, false);
        $01sTD.validateCallback("Reference.setWithPriority", 3, onComplete, true);
        if (this.getKey() === ".length" || this.getKey() === ".keys") throw "Reference.setWithPriority failed: " + this.getKey() + " is a read-only object.";
        var deferred = new $01sTD.Deferred();
        this.repo.setWithPriority(this.path, newVal, newPriority, deferred.wrapCallback(onComplete));
        return deferred.promise;
    };
    /**
     * @param {function(?Error)=} onComplete
     * @return {!Promise}
     */ Reference.prototype.remove = function(onComplete) {
        $01sTD.validateArgCount("Reference.remove", 0, 1, arguments.length);
        $d1f87d24500ab009$var$validateWritablePath("Reference.remove", this.path);
        $01sTD.validateCallback("Reference.remove", 1, onComplete, true);
        return this.set(null, onComplete);
    };
    /**
     * @param {function(*):*} transactionUpdate
     * @param {(function(?Error, boolean, ?DataSnapshot))=} onComplete
     * @param {boolean=} applyLocally
     * @return {!Promise}
     */ Reference.prototype.transaction = function(transactionUpdate, onComplete, applyLocally) {
        $01sTD.validateArgCount("Reference.transaction", 1, 3, arguments.length);
        $d1f87d24500ab009$var$validateWritablePath("Reference.transaction", this.path);
        $01sTD.validateCallback("Reference.transaction", 1, transactionUpdate, false);
        $01sTD.validateCallback("Reference.transaction", 2, onComplete, true);
        // NOTE: applyLocally is an internal-only option for now.  We need to decide if we want to keep it and how
        // to expose it.
        $d1f87d24500ab009$var$validateBoolean("Reference.transaction", 3, applyLocally, true);
        if (this.getKey() === ".length" || this.getKey() === ".keys") throw "Reference.transaction failed: " + this.getKey() + " is a read-only object.";
        if (applyLocally === undefined) applyLocally = true;
        var deferred = new $01sTD.Deferred();
        if (typeof onComplete === "function") deferred.promise.catch(function() {});
        var promiseComplete = function(error, committed, snapshot) {
            if (error) deferred.reject(error);
            else deferred.resolve(new $d1f87d24500ab009$var$TransactionResult(committed, snapshot));
            if (typeof onComplete === "function") onComplete(error, committed, snapshot);
        };
        this.repo.startTransaction(this.path, transactionUpdate, promiseComplete, applyLocally);
        return deferred.promise;
    };
    /**
     * @param {string|number|null} priority
     * @param {function(?Error)=} onComplete
     * @return {!Promise}
     */ Reference.prototype.setPriority = function(priority, onComplete) {
        $01sTD.validateArgCount("Reference.setPriority", 1, 2, arguments.length);
        $d1f87d24500ab009$var$validateWritablePath("Reference.setPriority", this.path);
        $d1f87d24500ab009$var$validatePriority("Reference.setPriority", 1, priority, false);
        $01sTD.validateCallback("Reference.setPriority", 2, onComplete, true);
        var deferred = new $01sTD.Deferred();
        this.repo.setWithPriority(this.path.child(".priority"), priority, null, deferred.wrapCallback(onComplete));
        return deferred.promise;
    };
    /**
     * @param {*=} value
     * @param {function(?Error)=} onComplete
     * @return {!Reference}
     */ Reference.prototype.push = function(value, onComplete) {
        $01sTD.validateArgCount("Reference.push", 0, 2, arguments.length);
        $d1f87d24500ab009$var$validateWritablePath("Reference.push", this.path);
        $d1f87d24500ab009$var$validateFirebaseDataArg("Reference.push", 1, value, this.path, true);
        $01sTD.validateCallback("Reference.push", 2, onComplete, true);
        var now = this.repo.serverTime();
        var name = $d1f87d24500ab009$var$nextPushId(now);
        // push() returns a ThennableReference whose promise is fulfilled with a regular Reference.
        // We use child() to create handles to two different references. The first is turned into a
        // ThennableReference below by adding then() and catch() methods and is used as the
        // return value of push(). The second remains a regular Reference and is used as the fulfilled
        // value of the first ThennableReference.
        var thennablePushRef = this.child(name);
        var pushRef = this.child(name);
        var promise;
        if (value != null) promise = thennablePushRef.set(value, onComplete).then(function() {
            return pushRef;
        });
        else promise = Promise.resolve(pushRef);
        thennablePushRef.then = promise.then.bind(promise);
        thennablePushRef.catch = promise.then.bind(promise, undefined);
        if (typeof onComplete === "function") promise.catch(function() {});
        return thennablePushRef;
    };
    /**
     * @return {!OnDisconnect}
     */ Reference.prototype.onDisconnect = function() {
        $d1f87d24500ab009$var$validateWritablePath("Reference.onDisconnect", this.path);
        return new $d1f87d24500ab009$var$OnDisconnect(this.repo, this.path);
    };
    Object.defineProperty(Reference.prototype, "database", {
        get: function() {
            return this.databaseProp();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Reference.prototype, "key", {
        get: function() {
            return this.getKey();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Reference.prototype, "parent", {
        get: function() {
            return this.getParent();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Reference.prototype, "root", {
        get: function() {
            return this.getRoot();
        },
        enumerable: false,
        configurable: true
    });
    return Reference;
}($d1f87d24500ab009$var$Query);
/**
 * Define reference constructor in various modules
 *
 * We are doing this here to avoid several circular
 * dependency issues
 */ $d1f87d24500ab009$var$Query.__referenceConstructor = $d1f87d24500ab009$var$Reference;
$d1f87d24500ab009$var$SyncPoint.__referenceConstructor = $d1f87d24500ab009$var$Reference;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Node in a Tree.
 */ var $d1f87d24500ab009$var$TreeNode = /** @class */ function() {
    function TreeNode() {
        // TODO: Consider making accessors that create children and value lazily or
        // separate Internal / Leaf 'types'.
        this.children = {};
        this.childCount = 0;
        this.value = null;
    }
    return TreeNode;
}();
/**
 * A light-weight tree, traversable by path.  Nodes can have both values and children.
 * Nodes are not enumerated (by forEachChild) unless they have a value or non-empty
 * children.
 */ var $d1f87d24500ab009$var$Tree = /** @class */ function() {
    /**
     * @template T
     * @param {string=} name_ Optional name of the node.
     * @param {Tree=} parent_ Optional parent node.
     * @param {TreeNode=} node_ Optional node to wrap.
     */ function Tree(name_, parent_, node_) {
        if (name_ === void 0) name_ = "";
        if (parent_ === void 0) parent_ = null;
        if (node_ === void 0) node_ = new $d1f87d24500ab009$var$TreeNode();
        this.name_ = name_;
        this.parent_ = parent_;
        this.node_ = node_;
    }
    /**
     * Returns a sub-Tree for the given path.
     *
     * @param {!(string|Path)} pathObj Path to look up.
     * @return {!Tree.<T>} Tree for path.
     */ Tree.prototype.subTree = function(pathObj) {
        // TODO: Require pathObj to be Path?
        var path = pathObj instanceof $d1f87d24500ab009$var$Path ? pathObj : new $d1f87d24500ab009$var$Path(pathObj);
        var child = this, next = path.getFront();
        while(next !== null){
            var childNode = $01sTD.safeGet(child.node_.children, next) || new $d1f87d24500ab009$var$TreeNode();
            child = new Tree(next, child, childNode);
            path = path.popFront();
            next = path.getFront();
        }
        return child;
    };
    /**
     * Returns the data associated with this tree node.
     *
     * @return {?T} The data or null if no data exists.
     */ Tree.prototype.getValue = function() {
        return this.node_.value;
    };
    /**
     * Sets data to this tree node.
     *
     * @param {!T} value Value to set.
     */ Tree.prototype.setValue = function(value) {
        $01sTD.assert(typeof value !== "undefined", "Cannot set value to undefined");
        this.node_.value = value;
        this.updateParents_();
    };
    /**
     * Clears the contents of the tree node (its value and all children).
     */ Tree.prototype.clear = function() {
        this.node_.value = null;
        this.node_.children = {};
        this.node_.childCount = 0;
        this.updateParents_();
    };
    /**
     * @return {boolean} Whether the tree has any children.
     */ Tree.prototype.hasChildren = function() {
        return this.node_.childCount > 0;
    };
    /**
     * @return {boolean} Whether the tree is empty (no value or children).
     */ Tree.prototype.isEmpty = function() {
        return this.getValue() === null && !this.hasChildren();
    };
    /**
     * Calls action for each child of this tree node.
     *
     * @param {function(!Tree.<T>)} action Action to be called for each child.
     */ Tree.prototype.forEachChild = function(action) {
        var _this = this;
        $d1f87d24500ab009$var$each(this.node_.children, function(child, childTree) {
            action(new Tree(child, _this, childTree));
        });
    };
    /**
     * Does a depth-first traversal of this node's descendants, calling action for each one.
     *
     * @param {function(!Tree.<T>)} action Action to be called for each child.
     * @param {boolean=} includeSelf Whether to call action on this node as well. Defaults to
     *   false.
     * @param {boolean=} childrenFirst Whether to call action on children before calling it on
     *   parent.
     */ Tree.prototype.forEachDescendant = function(action, includeSelf, childrenFirst) {
        if (includeSelf && !childrenFirst) action(this);
        this.forEachChild(function(child) {
            child.forEachDescendant(action, /*includeSelf=*/ true, childrenFirst);
        });
        if (includeSelf && childrenFirst) action(this);
    };
    /**
     * Calls action on each ancestor node.
     *
     * @param {function(!Tree.<T>)} action Action to be called on each parent; return
     *   true to abort.
     * @param {boolean=} includeSelf Whether to call action on this node as well.
     * @return {boolean} true if the action callback returned true.
     */ Tree.prototype.forEachAncestor = function(action, includeSelf) {
        var node = includeSelf ? this : this.parent();
        while(node !== null){
            if (action(node)) return true;
            node = node.parent();
        }
        return false;
    };
    /**
     * Does a depth-first traversal of this node's descendants.  When a descendant with a value
     * is found, action is called on it and traversal does not continue inside the node.
     * Action is *not* called on this node.
     *
     * @param {function(!Tree.<T>)} action Action to be called for each child.
     */ Tree.prototype.forEachImmediateDescendantWithValue = function(action) {
        this.forEachChild(function(child) {
            if (child.getValue() !== null) action(child);
            else child.forEachImmediateDescendantWithValue(action);
        });
    };
    /**
     * @return {!Path} The path of this tree node, as a Path.
     */ Tree.prototype.path = function() {
        return new $d1f87d24500ab009$var$Path(this.parent_ === null ? this.name_ : this.parent_.path() + "/" + this.name_);
    };
    /**
     * @return {string} The name of the tree node.
     */ Tree.prototype.name = function() {
        return this.name_;
    };
    /**
     * @return {?Tree} The parent tree node, or null if this is the root of the tree.
     */ Tree.prototype.parent = function() {
        return this.parent_;
    };
    /**
     * Adds or removes this child from its parent based on whether it's empty or not.
     *
     * @private
     */ Tree.prototype.updateParents_ = function() {
        if (this.parent_ !== null) this.parent_.updateChild_(this.name_, this);
    };
    /**
     * Adds or removes the passed child to this tree node, depending on whether it's empty.
     *
     * @param {string} childName The name of the child to update.
     * @param {!Tree.<T>} child The child to update.
     * @private
     */ Tree.prototype.updateChild_ = function(childName, child) {
        var childEmpty = child.isEmpty();
        var childExists = $01sTD.contains(this.node_.children, childName);
        if (childEmpty && childExists) {
            delete this.node_.children[childName];
            this.node_.childCount--;
            this.updateParents_();
        } else if (!childEmpty && !childExists) {
            this.node_.children[childName] = child.node_;
            this.node_.childCount++;
            this.updateParents_();
        }
    };
    return Tree;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // TODO: This is pretty messy.  Ideally, a lot of this would move into FirebaseData, or a transaction-specific
// component used by FirebaseData, but it has ties to user callbacks (transaction update and onComplete) as well
// as the realtime connection (to send transactions to the server).  So that all needs to be decoupled first.
// For now it's part of Repo, but in its own file.
/**
 * @enum {number}
 */ var $d1f87d24500ab009$var$TransactionStatus;
(function(TransactionStatus) {
    // We've run the transaction and updated transactionResultData_ with the result, but it isn't currently sent to the
    // server. A transaction will go from RUN -> SENT -> RUN if it comes back from the server as rejected due to
    // mismatched hash.
    TransactionStatus[TransactionStatus["RUN"] = 0] = "RUN";
    // We've run the transaction and sent it to the server and it's currently outstanding (hasn't come back as accepted
    // or rejected yet).
    TransactionStatus[TransactionStatus["SENT"] = 1] = "SENT";
    // Temporary state used to mark completed transactions (whether successful or aborted).  The transaction will be
    // removed when we get a chance to prune completed ones.
    TransactionStatus[TransactionStatus["COMPLETED"] = 2] = "COMPLETED";
    // Used when an already-sent transaction needs to be aborted (e.g. due to a conflicting set() call that was made).
    // If it comes back as unsuccessful, we'll abort it.
    TransactionStatus[TransactionStatus["SENT_NEEDS_ABORT"] = 3] = "SENT_NEEDS_ABORT";
    // Temporary state used to mark transactions that need to be aborted.
    TransactionStatus[TransactionStatus["NEEDS_ABORT"] = 4] = "NEEDS_ABORT";
})($d1f87d24500ab009$var$TransactionStatus || ($d1f87d24500ab009$var$TransactionStatus = {}));
/**
 * If a transaction does not succeed after 25 retries, we abort it.  Among other things this ensure that if there's
 * ever a bug causing a mismatch between client / server hashes for some data, we won't retry indefinitely.
 * @type {number}
 * @const
 * @private
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
$d1f87d24500ab009$var$Repo.MAX_TRANSACTION_RETRIES_ = 25;
/**
 * Setup the transaction data structures
 * @private
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
$d1f87d24500ab009$var$Repo.prototype.transactionsInit_ = function() {
    /**
     * Stores queues of outstanding transactions for Firebase locations.
     *
     * @type {!Tree.<Array.<!Transaction>>}
     * @private
     */ this.transactionQueueTree_ = new $d1f87d24500ab009$var$Tree();
};
/**
 * Creates a new transaction, adds it to the transactions we're tracking, and sends it to the server if possible.
 *
 * @param {!Path} path Path at which to do transaction.
 * @param {function(*):*} transactionUpdate Update callback.
 * @param {?function(?Error, boolean, ?DataSnapshot)} onComplete Completion callback.
 * @param {boolean} applyLocally Whether or not to make intermediate results visible
 */ $d1f87d24500ab009$var$Repo.prototype.startTransaction = function(path, transactionUpdate, onComplete, applyLocally) {
    this.log_("transaction on " + path);
    // Add a watch to make sure we get server updates.
    var valueCallback = function() {};
    var watchRef = new $d1f87d24500ab009$var$Reference(this, path);
    watchRef.on("value", valueCallback);
    var unwatcher = function() {
        watchRef.off("value", valueCallback);
    };
    // Initialize transaction.
    var transaction = {
        path: path,
        update: transactionUpdate,
        onComplete: onComplete,
        // One of TransactionStatus enums.
        status: null,
        // Used when combining transactions at different locations to figure out which one goes first.
        order: $d1f87d24500ab009$var$LUIDGenerator(),
        // Whether to raise local events for this transaction.
        applyLocally: applyLocally,
        // Count of how many times we've retried the transaction.
        retryCount: 0,
        // Function to call to clean up our .on() listener.
        unwatcher: unwatcher,
        // Stores why a transaction was aborted.
        abortReason: null,
        currentWriteId: null,
        currentInputSnapshot: null,
        currentOutputSnapshotRaw: null,
        currentOutputSnapshotResolved: null
    };
    // Run transaction initially.
    var currentState = this.getLatestState_(path);
    transaction.currentInputSnapshot = currentState;
    var newVal = transaction.update(currentState.val());
    if (newVal === undefined) {
        // Abort transaction.
        transaction.unwatcher();
        transaction.currentOutputSnapshotRaw = null;
        transaction.currentOutputSnapshotResolved = null;
        if (transaction.onComplete) {
            // We just set the input snapshot, so this cast should be safe
            var snapshot = new $d1f87d24500ab009$var$DataSnapshot(transaction.currentInputSnapshot, new $d1f87d24500ab009$var$Reference(this, transaction.path), $d1f87d24500ab009$var$PRIORITY_INDEX);
            transaction.onComplete(null, false, snapshot);
        }
    } else {
        $d1f87d24500ab009$var$validateFirebaseData("transaction failed: Data returned ", newVal, transaction.path);
        // Mark as run and add to our queue.
        transaction.status = $d1f87d24500ab009$var$TransactionStatus.RUN;
        var queueNode = this.transactionQueueTree_.subTree(path);
        var nodeQueue = queueNode.getValue() || [];
        nodeQueue.push(transaction);
        queueNode.setValue(nodeQueue);
        // Update visibleData and raise events
        // Note: We intentionally raise events after updating all of our transaction state, since the user could
        // start new transactions from the event callbacks.
        var priorityForNode = void 0;
        if (typeof newVal === "object" && newVal !== null && $01sTD.contains(newVal, ".priority")) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            priorityForNode = $01sTD.safeGet(newVal, ".priority");
            $01sTD.assert($d1f87d24500ab009$var$isValidPriority(priorityForNode), "Invalid priority returned by transaction. Priority must be a valid string, finite number, server value, or null.");
        } else {
            var currentNode = this.serverSyncTree_.calcCompleteEventCache(path) || $d1f87d24500ab009$var$ChildrenNode.EMPTY_NODE;
            priorityForNode = currentNode.getPriority().val();
        }
        priorityForNode;
        var serverValues = this.generateServerValues();
        var newNodeUnresolved = $d1f87d24500ab009$var$nodeFromJSON$1(newVal, priorityForNode);
        var newNode = $d1f87d24500ab009$var$resolveDeferredValueSnapshot(newNodeUnresolved, currentState, serverValues);
        transaction.currentOutputSnapshotRaw = newNodeUnresolved;
        transaction.currentOutputSnapshotResolved = newNode;
        transaction.currentWriteId = this.getNextWriteId_();
        var events = this.serverSyncTree_.applyUserOverwrite(path, newNode, transaction.currentWriteId, transaction.applyLocally);
        this.eventQueue_.raiseEventsForChangedPath(path, events);
        this.sendReadyTransactions_();
    }
};
/**
 * @param {!Path} path
 * @param {Array.<number>=} excludeSets A specific set to exclude
 * @return {Node}
 * @private
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
$d1f87d24500ab009$var$Repo.prototype.getLatestState_ = function(path, excludeSets) {
    return this.serverSyncTree_.calcCompleteEventCache(path, excludeSets) || $d1f87d24500ab009$var$ChildrenNode.EMPTY_NODE;
};
/**
 * Sends any already-run transactions that aren't waiting for outstanding transactions to
 * complete.
 *
 * Externally it's called with no arguments, but it calls itself recursively with a particular
 * transactionQueueTree node to recurse through the tree.
 *
 * @param {Tree.<Array.<Transaction>>=} node  transactionQueueTree node to start at.
 * @private
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
$d1f87d24500ab009$var$Repo.prototype.sendReadyTransactions_ = function(node) {
    var _this = this;
    if (node === void 0) node = this.transactionQueueTree_;
    // Before recursing, make sure any completed transactions are removed.
    if (!node) this.pruneCompletedTransactionsBelowNode_(node);
    if (node.getValue() !== null) {
        var queue = this.buildTransactionQueue_(node);
        $01sTD.assert(queue.length > 0, "Sending zero length transaction queue");
        var allRun = queue.every(function(transaction) {
            return transaction.status === $d1f87d24500ab009$var$TransactionStatus.RUN;
        });
        // If they're all run (and not sent), we can send them.  Else, we must wait.
        if (allRun) this.sendTransactionQueue_(node.path(), queue);
    } else if (node.hasChildren()) node.forEachChild(function(childNode) {
        _this.sendReadyTransactions_(childNode);
    });
};
/**
 * Given a list of run transactions, send them to the server and then handle the result (success or failure).
 *
 * @param {!Path} path The location of the queue.
 * @param {!Array.<Transaction>} queue Queue of transactions under the specified location.
 * @private
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
$d1f87d24500ab009$var$Repo.prototype.sendTransactionQueue_ = function(path, queue) {
    var _this = this;
    // Mark transactions as sent and increment retry count!
    var setsToIgnore = queue.map(function(txn) {
        return txn.currentWriteId;
    });
    var latestState = this.getLatestState_(path, setsToIgnore);
    var snapToSend = latestState;
    var latestHash = latestState.hash();
    for(var i = 0; i < queue.length; i++){
        var txn = queue[i];
        $01sTD.assert(txn.status === $d1f87d24500ab009$var$TransactionStatus.RUN, "tryToSendTransactionQueue_: items in queue should all be run.");
        txn.status = $d1f87d24500ab009$var$TransactionStatus.SENT;
        txn.retryCount++;
        var relativePath = $d1f87d24500ab009$var$Path.relativePath(path, txn.path);
        // If we've gotten to this point, the output snapshot must be defined.
        snapToSend = snapToSend.updateChild(relativePath /** @type {!Node} */ , txn.currentOutputSnapshotRaw);
    }
    var dataToSend = snapToSend.val(true);
    var pathToSend = path;
    // Send the put.
    this.server_.put(pathToSend.toString(), dataToSend, function(status) {
        _this.log_("transaction put response", {
            path: pathToSend.toString(),
            status: status
        });
        var events = [];
        if (status === "ok") {
            // Queue up the callbacks and fire them after cleaning up all of our transaction state, since
            // the callback could trigger more transactions or sets.
            var callbacks = [];
            for(var i = 0; i < queue.length; i++){
                queue[i].status = $d1f87d24500ab009$var$TransactionStatus.COMPLETED;
                events = events.concat(_this.serverSyncTree_.ackUserWrite(queue[i].currentWriteId));
                if (queue[i].onComplete) {
                    // We never unset the output snapshot, and given that this transaction is complete, it should be set
                    var node = queue[i].currentOutputSnapshotResolved;
                    var ref = new $d1f87d24500ab009$var$Reference(_this, queue[i].path);
                    var snapshot = new $d1f87d24500ab009$var$DataSnapshot(node, ref, $d1f87d24500ab009$var$PRIORITY_INDEX);
                    callbacks.push(queue[i].onComplete.bind(null, null, true, snapshot));
                }
                queue[i].unwatcher();
            }
            // Now remove the completed transactions.
            _this.pruneCompletedTransactionsBelowNode_(_this.transactionQueueTree_.subTree(path));
            // There may be pending transactions that we can now send.
            _this.sendReadyTransactions_();
            _this.eventQueue_.raiseEventsForChangedPath(path, events);
            // Finally, trigger onComplete callbacks.
            for(var i = 0; i < callbacks.length; i++)$d1f87d24500ab009$var$exceptionGuard(callbacks[i]);
        } else {
            // transactions are no longer sent.  Update their status appropriately.
            if (status === "datastale") {
                for(var i = 0; i < queue.length; i++)if (queue[i].status === $d1f87d24500ab009$var$TransactionStatus.SENT_NEEDS_ABORT) queue[i].status = $d1f87d24500ab009$var$TransactionStatus.NEEDS_ABORT;
                else queue[i].status = $d1f87d24500ab009$var$TransactionStatus.RUN;
            } else {
                $d1f87d24500ab009$var$warn("transaction at " + pathToSend.toString() + " failed: " + status);
                for(var i = 0; i < queue.length; i++){
                    queue[i].status = $d1f87d24500ab009$var$TransactionStatus.NEEDS_ABORT;
                    queue[i].abortReason = status;
                }
            }
            _this.rerunTransactions_(path);
        }
    }, latestHash);
};
/**
 * Finds all transactions dependent on the data at changedPath and reruns them.
 *
 * Should be called any time cached data changes.
 *
 * Return the highest path that was affected by rerunning transactions.  This is the path at which events need to
 * be raised for.
 *
 * @param {!Path} changedPath The path in mergedData that changed.
 * @return {!Path} The rootmost path that was affected by rerunning transactions.
 * @private
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
$d1f87d24500ab009$var$Repo.prototype.rerunTransactions_ = function(changedPath) {
    var rootMostTransactionNode = this.getAncestorTransactionNode_(changedPath);
    var path = rootMostTransactionNode.path();
    var queue = this.buildTransactionQueue_(rootMostTransactionNode);
    this.rerunTransactionQueue_(queue, path);
    return path;
};
/**
 * Does all the work of rerunning transactions (as well as cleans up aborted transactions and whatnot).
 *
 * @param {Array.<Transaction>} queue The queue of transactions to run.
 * @param {!Path} path The path the queue is for.
 * @private
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
$d1f87d24500ab009$var$Repo.prototype.rerunTransactionQueue_ = function(queue, path) {
    if (queue.length === 0) return; // Nothing to do!
    // Queue up the callbacks and fire them after cleaning up all of our transaction state, since
    // the callback could trigger more transactions or sets.
    var callbacks = [];
    var events = [];
    // Ignore all of the sets we're going to re-run.
    var txnsToRerun = queue.filter(function(q) {
        return q.status === $d1f87d24500ab009$var$TransactionStatus.RUN;
    });
    var setsToIgnore = txnsToRerun.map(function(q) {
        return q.currentWriteId;
    });
    for(var i = 0; i < queue.length; i++){
        var transaction = queue[i];
        var relativePath = $d1f87d24500ab009$var$Path.relativePath(path, transaction.path);
        var abortTransaction = false, abortReason = void 0;
        $01sTD.assert(relativePath !== null, "rerunTransactionsUnderNode_: relativePath should not be null.");
        if (transaction.status === $d1f87d24500ab009$var$TransactionStatus.NEEDS_ABORT) {
            abortTransaction = true;
            abortReason = transaction.abortReason;
            events = events.concat(this.serverSyncTree_.ackUserWrite(transaction.currentWriteId, true));
        } else if (transaction.status === $d1f87d24500ab009$var$TransactionStatus.RUN) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            if (transaction.retryCount >= $d1f87d24500ab009$var$Repo.MAX_TRANSACTION_RETRIES_) {
                abortTransaction = true;
                abortReason = "maxretry";
                events = events.concat(this.serverSyncTree_.ackUserWrite(transaction.currentWriteId, true));
            } else {
                // This code reruns a transaction
                var currentNode = this.getLatestState_(transaction.path, setsToIgnore);
                transaction.currentInputSnapshot = currentNode;
                var newData = queue[i].update(currentNode.val());
                if (newData !== undefined) {
                    $d1f87d24500ab009$var$validateFirebaseData("transaction failed: Data returned ", newData, transaction.path);
                    var newDataNode = $d1f87d24500ab009$var$nodeFromJSON$1(newData);
                    var hasExplicitPriority = typeof newData === "object" && newData != null && $01sTD.contains(newData, ".priority");
                    if (!hasExplicitPriority) // Keep the old priority if there wasn't a priority explicitly specified.
                    newDataNode = newDataNode.updatePriority(currentNode.getPriority());
                    var oldWriteId = transaction.currentWriteId;
                    var serverValues = this.generateServerValues();
                    var newNodeResolved = $d1f87d24500ab009$var$resolveDeferredValueSnapshot(newDataNode, currentNode, serverValues);
                    transaction.currentOutputSnapshotRaw = newDataNode;
                    transaction.currentOutputSnapshotResolved = newNodeResolved;
                    transaction.currentWriteId = this.getNextWriteId_();
                    // Mutates setsToIgnore in place
                    setsToIgnore.splice(setsToIgnore.indexOf(oldWriteId), 1);
                    events = events.concat(this.serverSyncTree_.applyUserOverwrite(transaction.path, newNodeResolved, transaction.currentWriteId, transaction.applyLocally));
                    events = events.concat(this.serverSyncTree_.ackUserWrite(oldWriteId, true));
                } else {
                    abortTransaction = true;
                    abortReason = "nodata";
                    events = events.concat(this.serverSyncTree_.ackUserWrite(transaction.currentWriteId, true));
                }
            }
        }
        this.eventQueue_.raiseEventsForChangedPath(path, events);
        events = [];
        if (abortTransaction) {
            // Abort.
            queue[i].status = $d1f87d24500ab009$var$TransactionStatus.COMPLETED;
            // Removing a listener can trigger pruning which can muck with mergedData/visibleData (as it prunes data).
            // So defer the unwatcher until we're done.
            (function(unwatcher) {
                setTimeout(unwatcher, Math.floor(0));
            })(queue[i].unwatcher);
            if (queue[i].onComplete) {
                if (abortReason === "nodata") {
                    var ref = new $d1f87d24500ab009$var$Reference(this, queue[i].path);
                    // We set this field immediately, so it's safe to cast to an actual snapshot
                    var lastInput /** @type {!Node} */  = queue[i].currentInputSnapshot;
                    var snapshot = new $d1f87d24500ab009$var$DataSnapshot(lastInput, ref, $d1f87d24500ab009$var$PRIORITY_INDEX);
                    callbacks.push(queue[i].onComplete.bind(null, null, false, snapshot));
                } else callbacks.push(queue[i].onComplete.bind(null, new Error(abortReason), false, null));
            }
        }
    }
    // Clean up completed transactions.
    this.pruneCompletedTransactionsBelowNode_(this.transactionQueueTree_);
    // Now fire callbacks, now that we're in a good, known state.
    for(var i = 0; i < callbacks.length; i++)$d1f87d24500ab009$var$exceptionGuard(callbacks[i]);
    // Try to send the transaction result to the server.
    this.sendReadyTransactions_();
};
/**
 * Returns the rootmost ancestor node of the specified path that has a pending transaction on it, or just returns
 * the node for the given path if there are no pending transactions on any ancestor.
 *
 * @param {!Path} path The location to start at.
 * @return {!Tree.<Array.<!Transaction>>} The rootmost node with a transaction.
 * @private
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
$d1f87d24500ab009$var$Repo.prototype.getAncestorTransactionNode_ = function(path) {
    var front;
    // Start at the root and walk deeper into the tree towards path until we find a node with pending transactions.
    var transactionNode = this.transactionQueueTree_;
    front = path.getFront();
    while(front !== null && transactionNode.getValue() === null){
        transactionNode = transactionNode.subTree(front);
        path = path.popFront();
        front = path.getFront();
    }
    return transactionNode;
};
/**
 * Builds the queue of all transactions at or below the specified transactionNode.
 *
 * @param {!Tree.<Array.<Transaction>>} transactionNode
 * @return {Array.<Transaction>} The generated queue.
 * @private
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
$d1f87d24500ab009$var$Repo.prototype.buildTransactionQueue_ = function(transactionNode) {
    // Walk any child transaction queues and aggregate them into a single queue.
    var transactionQueue = [];
    this.aggregateTransactionQueuesForNode_(transactionNode, transactionQueue);
    // Sort them by the order the transactions were created.
    transactionQueue.sort(function(a, b) {
        return a.order - b.order;
    });
    return transactionQueue;
};
/**
 * @param {!Tree.<Array.<Transaction>>} node
 * @param {Array.<Transaction>} queue
 * @private
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
$d1f87d24500ab009$var$Repo.prototype.aggregateTransactionQueuesForNode_ = function(node, queue) {
    var _this = this;
    var nodeQueue = node.getValue();
    if (nodeQueue !== null) for(var i = 0; i < nodeQueue.length; i++)queue.push(nodeQueue[i]);
    node.forEachChild(function(child) {
        _this.aggregateTransactionQueuesForNode_(child, queue);
    });
};
/**
 * Remove COMPLETED transactions at or below this node in the transactionQueueTree_.
 *
 * @param {!Tree.<Array.<!Transaction>>} node
 * @private
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
$d1f87d24500ab009$var$Repo.prototype.pruneCompletedTransactionsBelowNode_ = function(node) {
    var _this = this;
    var queue = node.getValue();
    if (queue) {
        var to = 0;
        for(var from = 0; from < queue.length; from++)if (queue[from].status !== $d1f87d24500ab009$var$TransactionStatus.COMPLETED) {
            queue[to] = queue[from];
            to++;
        }
        queue.length = to;
        node.setValue(queue.length > 0 ? queue : null);
    }
    node.forEachChild(function(childNode) {
        _this.pruneCompletedTransactionsBelowNode_(childNode);
    });
};
/**
 * Aborts all transactions on ancestors or descendants of the specified path.  Called when doing a set() or update()
 * since we consider them incompatible with transactions.
 *
 * @param {!Path} path Path for which we want to abort related transactions.
 * @return {!Path}
 * @private
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
$d1f87d24500ab009$var$Repo.prototype.abortTransactions_ = function(path) {
    var _this = this;
    var affectedPath = this.getAncestorTransactionNode_(path).path();
    var transactionNode = this.transactionQueueTree_.subTree(path);
    transactionNode.forEachAncestor(function(node) {
        _this.abortTransactionsOnNode_(node);
    });
    this.abortTransactionsOnNode_(transactionNode);
    transactionNode.forEachDescendant(function(node) {
        _this.abortTransactionsOnNode_(node);
    });
    return affectedPath;
};
/**
 * Abort transactions stored in this transaction queue node.
 *
 * @param {!Tree.<Array.<Transaction>>} node Node to abort transactions for.
 * @private
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
$d1f87d24500ab009$var$Repo.prototype.abortTransactionsOnNode_ = function(node) {
    var queue = node.getValue();
    if (queue !== null) {
        // Queue up the callbacks and fire them after cleaning up all of our transaction state, since
        // the callback could trigger more transactions or sets.
        var callbacks = [];
        // Go through queue.  Any already-sent transactions must be marked for abort, while the unsent ones
        // can be immediately aborted and removed.
        var events = [];
        var lastSent = -1;
        for(var i = 0; i < queue.length; i++){
            if (queue[i].status === $d1f87d24500ab009$var$TransactionStatus.SENT_NEEDS_ABORT) ;
            else if (queue[i].status === $d1f87d24500ab009$var$TransactionStatus.SENT) {
                $01sTD.assert(lastSent === i - 1, "All SENT items should be at beginning of queue.");
                lastSent = i;
                // Mark transaction for abort when it comes back.
                queue[i].status = $d1f87d24500ab009$var$TransactionStatus.SENT_NEEDS_ABORT;
                queue[i].abortReason = "set";
            } else {
                $01sTD.assert(queue[i].status === $d1f87d24500ab009$var$TransactionStatus.RUN, "Unexpected transaction status in abort");
                // We can abort it immediately.
                queue[i].unwatcher();
                events = events.concat(this.serverSyncTree_.ackUserWrite(queue[i].currentWriteId, true));
                if (queue[i].onComplete) {
                    var snapshot = null;
                    callbacks.push(queue[i].onComplete.bind(null, new Error("set"), false, snapshot));
                }
            }
        }
        if (lastSent === -1) // We're not waiting for any sent transactions.  We can clear the queue.
        node.setValue(null);
        else // Remove the transactions we aborted.
        queue.length = lastSent + 1;
        // Now fire the callbacks.
        this.eventQueue_.raiseEventsForChangedPath(node.path(), events);
        for(var i = 0; i < callbacks.length; i++)$d1f87d24500ab009$var$exceptionGuard(callbacks[i]);
    }
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Abstraction around FirebaseApp's token fetching capabilities.
 */ var $d1f87d24500ab009$var$FirebaseAuthTokenProvider = /** @class */ function() {
    function FirebaseAuthTokenProvider(app_, authProvider_) {
        var _this = this;
        this.app_ = app_;
        this.authProvider_ = authProvider_;
        this.auth_ = null;
        this.auth_ = authProvider_.getImmediate({
            optional: true
        });
        if (!this.auth_) authProvider_.get().then(function(auth) {
            return _this.auth_ = auth;
        });
    }
    /**
     * @param {boolean} forceRefresh
     * @return {!Promise<FirebaseAuthTokenData>}
     */ FirebaseAuthTokenProvider.prototype.getToken = function(forceRefresh) {
        if (!this.auth_) return Promise.resolve(null);
        return this.auth_.getToken(forceRefresh).catch(function(error) {
            // TODO: Need to figure out all the cases this is raised and whether
            // this makes sense.
            if (error && error.code === "auth/token-not-initialized") {
                $d1f87d24500ab009$var$log("Got auth/token-not-initialized error.  Treating as null token.");
                return null;
            } else return Promise.reject(error);
        });
    };
    FirebaseAuthTokenProvider.prototype.addTokenChangeListener = function(listener) {
        // TODO: We might want to wrap the listener and call it with no args to
        // avoid a leaky abstraction, but that makes removing the listener harder.
        if (this.auth_) this.auth_.addAuthTokenListener(listener);
        else {
            setTimeout(function() {
                return listener(null);
            }, 0);
            this.authProvider_.get().then(function(auth) {
                return auth.addAuthTokenListener(listener);
            });
        }
    };
    FirebaseAuthTokenProvider.prototype.removeTokenChangeListener = function(listener) {
        this.authProvider_.get().then(function(auth) {
            return auth.removeAuthTokenListener(listener);
        });
    };
    FirebaseAuthTokenProvider.prototype.notifyForInvalidToken = function() {
        var errorMessage = 'Provided authentication credentials for the app named "' + this.app_.name + '" are invalid. This usually indicates your app was not ' + "initialized correctly. ";
        if ("credential" in this.app_.options) errorMessage += 'Make sure the "credential" property provided to initializeApp() is authorized to access the specified "databaseURL" and is from the correct project.';
        else if ("serviceAccount" in this.app_.options) errorMessage += 'Make sure the "serviceAccount" property provided to initializeApp() is authorized to access the specified "databaseURL" and is from the correct project.';
        else errorMessage += 'Make sure the "apiKey" and "databaseURL" properties provided to initializeApp() match the values provided for your app at https://console.firebase.google.com/.';
        $d1f87d24500ab009$var$warn(errorMessage);
    };
    return FirebaseAuthTokenProvider;
}();
/* Auth token provider that the Admin SDK uses to connect to the Emulator. */ var $d1f87d24500ab009$var$EmulatorAdminTokenProvider = /** @class */ function() {
    function EmulatorAdminTokenProvider() {}
    EmulatorAdminTokenProvider.prototype.getToken = function(forceRefresh) {
        return Promise.resolve({
            accessToken: EmulatorAdminTokenProvider.EMULATOR_AUTH_TOKEN
        });
    };
    EmulatorAdminTokenProvider.prototype.addTokenChangeListener = function(listener) {
        // Invoke the listener immediately to match the behavior in Firebase Auth
        // (see packages/auth/src/auth.js#L1807)
        listener(EmulatorAdminTokenProvider.EMULATOR_AUTH_TOKEN);
    };
    EmulatorAdminTokenProvider.prototype.removeTokenChangeListener = function(listener) {};
    EmulatorAdminTokenProvider.prototype.notifyForInvalidToken = function() {};
    EmulatorAdminTokenProvider.EMULATOR_AUTH_TOKEN = "owner";
    return EmulatorAdminTokenProvider;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * This variable is also defined in the firebase node.js admin SDK. Before
 * modifying this definition, consult the definition in:
 *
 * https://github.com/firebase/firebase-admin-node
 *
 * and make sure the two are consistent.
 */ var $d1f87d24500ab009$var$FIREBASE_DATABASE_EMULATOR_HOST_VAR = "FIREBASE_DATABASE_EMULATOR_HOST";
var $d1f87d24500ab009$var$_staticInstance;
/**
 * Creates and caches Repo instances.
 */ var $d1f87d24500ab009$var$RepoManager = /** @class */ function() {
    function RepoManager() {
        /**
         * @private {!Object.<string, Object<string, !fb.core.Repo>>}
         */ this.repos_ = {};
        /**
         * If true, new Repos will be created to use ReadonlyRestClient (for testing purposes).
         * @private {boolean}
         */ this.useRestClient_ = false;
    }
    RepoManager.getInstance = function() {
        if (!$d1f87d24500ab009$var$_staticInstance) $d1f87d24500ab009$var$_staticInstance = new RepoManager();
        return $d1f87d24500ab009$var$_staticInstance;
    };
    // TODO(koss): Remove these functions unless used in tests?
    RepoManager.prototype.interrupt = function() {
        var e_1, _a, e_2, _b;
        try {
            for(var _c = $a92b69d2447c208d$export$19a8beecd37a4c45(Object.keys(this.repos_)), _d = _c.next(); !_d.done; _d = _c.next()){
                var appName = _d.value;
                try {
                    for(var _e = (e_2 = void 0, $a92b69d2447c208d$export$19a8beecd37a4c45(Object.keys(this.repos_[appName]))), _f = _e.next(); !_f.done; _f = _e.next()){
                        var dbUrl = _f.value;
                        this.repos_[appName][dbUrl].interrupt();
                    }
                } catch (e_2_1) {
                    e_2 = {
                        error: e_2_1
                    };
                } finally{
                    try {
                        if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                    } finally{
                        if (e_2) throw e_2.error;
                    }
                }
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
    };
    RepoManager.prototype.resume = function() {
        var e_3, _a, e_4, _b;
        try {
            for(var _c = $a92b69d2447c208d$export$19a8beecd37a4c45(Object.keys(this.repos_)), _d = _c.next(); !_d.done; _d = _c.next()){
                var appName = _d.value;
                try {
                    for(var _e = (e_4 = void 0, $a92b69d2447c208d$export$19a8beecd37a4c45(Object.keys(this.repos_[appName]))), _f = _e.next(); !_f.done; _f = _e.next()){
                        var dbUrl = _f.value;
                        this.repos_[appName][dbUrl].resume();
                    }
                } catch (e_4_1) {
                    e_4 = {
                        error: e_4_1
                    };
                } finally{
                    try {
                        if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                    } finally{
                        if (e_4) throw e_4.error;
                    }
                }
            }
        } catch (e_3_1) {
            e_3 = {
                error: e_3_1
            };
        } finally{
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            } finally{
                if (e_3) throw e_3.error;
            }
        }
    };
    /**
     * This function should only ever be called to CREATE a new database instance.
     *
     * @param {!FirebaseApp} app
     * @return {!Database}
     */ RepoManager.prototype.databaseFromApp = function(app, authProvider, url, nodeAdmin) {
        var dbUrl = url || app.options.databaseURL;
        if (dbUrl === undefined) {
            if (!app.options.projectId) $d1f87d24500ab009$var$fatal("Can't determine Firebase Database URL. Be sure to include  a Project ID when calling firebase.initializeApp().");
            $d1f87d24500ab009$var$log("Using default host for project ", app.options.projectId);
            dbUrl = app.options.projectId + "-default-rtdb.firebaseio.com";
        }
        var parsedUrl = $d1f87d24500ab009$var$parseRepoInfo(dbUrl, nodeAdmin);
        var repoInfo = parsedUrl.repoInfo;
        var isEmulator;
        var dbEmulatorHost = undefined;
        if (typeof $hPtJY !== "undefined") dbEmulatorHost = $hPtJY.env[$d1f87d24500ab009$var$FIREBASE_DATABASE_EMULATOR_HOST_VAR];
        if (dbEmulatorHost) {
            isEmulator = true;
            dbUrl = "http://" + dbEmulatorHost + "?ns=" + repoInfo.namespace;
            parsedUrl = $d1f87d24500ab009$var$parseRepoInfo(dbUrl, nodeAdmin);
            repoInfo = parsedUrl.repoInfo;
        } else isEmulator = !parsedUrl.repoInfo.secure;
        var authTokenProvider = nodeAdmin && isEmulator ? new $d1f87d24500ab009$var$EmulatorAdminTokenProvider() : new $d1f87d24500ab009$var$FirebaseAuthTokenProvider(app, authProvider);
        $d1f87d24500ab009$var$validateUrl("Invalid Firebase Database URL", 1, parsedUrl);
        if (!parsedUrl.path.isEmpty()) $d1f87d24500ab009$var$fatal("Database URL must point to the root of a Firebase Database (not including a child path).");
        var repo = this.createRepo(repoInfo, app, authTokenProvider);
        return repo.database;
    };
    /**
     * Remove the repo and make sure it is disconnected.
     *
     * @param {!Repo} repo
     */ RepoManager.prototype.deleteRepo = function(repo) {
        var appRepos = $01sTD.safeGet(this.repos_, repo.app.name);
        // This should never happen...
        if (!appRepos || $01sTD.safeGet(appRepos, repo.repoInfo_.toURLString()) !== repo) $d1f87d24500ab009$var$fatal("Database " + repo.app.name + "(" + repo.repoInfo_ + ") has already been deleted.");
        repo.interrupt();
        delete appRepos[repo.repoInfo_.toURLString()];
    };
    /**
     * Ensures a repo doesn't already exist and then creates one using the
     * provided app.
     *
     * @param {!RepoInfo} repoInfo The metadata about the Repo
     * @param {!FirebaseApp} app
     * @return {!Repo} The Repo object for the specified server / repoName.
     */ RepoManager.prototype.createRepo = function(repoInfo, app, authTokenProvider) {
        var appRepos = $01sTD.safeGet(this.repos_, app.name);
        if (!appRepos) {
            appRepos = {};
            this.repos_[app.name] = appRepos;
        }
        var repo = $01sTD.safeGet(appRepos, repoInfo.toURLString());
        if (repo) $d1f87d24500ab009$var$fatal("Database initialized multiple times. Please make sure the format of the database URL matches with each database() call.");
        repo = new $d1f87d24500ab009$var$Repo(repoInfo, this.useRestClient_, app, authTokenProvider);
        appRepos[repoInfo.toURLString()] = repo;
        return repo;
    };
    /**
     * Forces us to use ReadonlyRestClient instead of PersistentConnection for new Repos.
     * @param {boolean} forceRestClient
     */ RepoManager.prototype.forceRestClient = function(forceRestClient) {
        this.useRestClient_ = forceRestClient;
    };
    return RepoManager;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Class representing a firebase database.
 * @implements {FirebaseService}
 */ var $d1f87d24500ab009$var$Database = /** @class */ function() {
    /**
     * The constructor should not be called by users of our public API.
     * @param {!Repo} repo_
     */ function Database(repo_) {
        this.repo_ = repo_;
        if (!(repo_ instanceof $d1f87d24500ab009$var$Repo)) $d1f87d24500ab009$var$fatal("Don't call new Database() directly - please use firebase.database().");
        /** @type {Reference} */ this.root_ = new $d1f87d24500ab009$var$Reference(repo_, $d1f87d24500ab009$var$Path.Empty);
        this.INTERNAL = new $d1f87d24500ab009$var$DatabaseInternals(this);
    }
    Object.defineProperty(Database.prototype, "app", {
        get: function() {
            return this.repo_.app;
        },
        enumerable: false,
        configurable: true
    });
    Database.prototype.ref = function(path) {
        this.checkDeleted_("ref");
        $01sTD.validateArgCount("database.ref", 0, 1, arguments.length);
        if (path instanceof $d1f87d24500ab009$var$Reference) return this.refFromURL(path.toString());
        return path !== undefined ? this.root_.child(path) : this.root_;
    };
    /**
     * Returns a reference to the root or the path specified in url.
     * We throw a exception if the url is not in the same domain as the
     * current repo.
     * @param {string} url
     * @return {!Reference} Firebase reference.
     */ Database.prototype.refFromURL = function(url) {
        /** @const {string} */ var apiName = "database.refFromURL";
        this.checkDeleted_(apiName);
        $01sTD.validateArgCount(apiName, 1, 1, arguments.length);
        var parsedURL = $d1f87d24500ab009$var$parseRepoInfo(url, this.repo_.repoInfo_.nodeAdmin);
        $d1f87d24500ab009$var$validateUrl(apiName, 1, parsedURL);
        var repoInfo = parsedURL.repoInfo;
        if (repoInfo.host !== this.repo_.repoInfo_.host) $d1f87d24500ab009$var$fatal(apiName + ": Host name does not match the current database: " + "(found " + repoInfo.host + " but expected " + this.repo_.repoInfo_.host + ")");
        return this.ref(parsedURL.path.toString());
    };
    /**
     * @param {string} apiName
     */ Database.prototype.checkDeleted_ = function(apiName) {
        if (this.repo_ === null) $d1f87d24500ab009$var$fatal("Cannot call " + apiName + " on a deleted database.");
    };
    // Make individual repo go offline.
    Database.prototype.goOffline = function() {
        $01sTD.validateArgCount("database.goOffline", 0, 0, arguments.length);
        this.checkDeleted_("goOffline");
        this.repo_.interrupt();
    };
    Database.prototype.goOnline = function() {
        $01sTD.validateArgCount("database.goOnline", 0, 0, arguments.length);
        this.checkDeleted_("goOnline");
        this.repo_.resume();
    };
    Database.ServerValue = {
        TIMESTAMP: {
            ".sv": "timestamp"
        },
        increment: function(delta) {
            return {
                ".sv": {
                    "increment": delta
                }
            };
        }
    };
    return Database;
}();
var $d1f87d24500ab009$var$DatabaseInternals = /** @class */ function() {
    /** @param {!Database} database */ function DatabaseInternals(database) {
        this.database = database;
    }
    /** @return {Promise<void>} */ DatabaseInternals.prototype.delete = function() {
        return $a92b69d2447c208d$export$1050f835b63b671e(this, void 0, void 0, function() {
            return $a92b69d2447c208d$export$67ebef60e6f28a6(this, function(_a) {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                this.database.checkDeleted_("delete");
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                $d1f87d24500ab009$var$RepoManager.getInstance().deleteRepo(this.database.repo_);
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                this.database.repo_ = null;
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                this.database.root_ = null;
                this.database.INTERNAL = null;
                this.database = null;
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    return DatabaseInternals;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * INTERNAL methods for internal-use only (tests, etc.).
 *
 * Customers shouldn't use these or else should be aware that they could break at any time.
 *
 * @const
 */ var $d1f87d24500ab009$var$forceLongPolling = function() {
    $d1f87d24500ab009$var$WebSocketConnection.forceDisallow();
    $d1f87d24500ab009$var$BrowserPollConnection.forceAllow();
};
var $d1f87d24500ab009$var$forceWebSockets = function() {
    $d1f87d24500ab009$var$BrowserPollConnection.forceDisallow();
};
/* Used by App Manager */ var $d1f87d24500ab009$var$isWebSocketsAvailable = function() {
    return $d1f87d24500ab009$var$WebSocketConnection["isAvailable"]();
};
var $d1f87d24500ab009$var$setSecurityDebugCallback = function(ref, callback) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ref.repo.persistentConnection_.securityDebugCallback_ = callback;
};
var $d1f87d24500ab009$var$stats = function(ref, showDelta) {
    ref.repo.stats(showDelta);
};
var $d1f87d24500ab009$var$statsIncrementCounter = function(ref, metric) {
    ref.repo.statsIncrementCounter(metric);
};
var $d1f87d24500ab009$var$dataUpdateCount = function(ref) {
    return ref.repo.dataUpdateCount;
};
var $d1f87d24500ab009$var$interceptServerData = function(ref, callback) {
    return ref.repo.interceptServerData_(callback);
};
var $d1f87d24500ab009$var$INTERNAL = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    forceLongPolling: $d1f87d24500ab009$var$forceLongPolling,
    forceWebSockets: $d1f87d24500ab009$var$forceWebSockets,
    isWebSocketsAvailable: $d1f87d24500ab009$var$isWebSocketsAvailable,
    setSecurityDebugCallback: $d1f87d24500ab009$var$setSecurityDebugCallback,
    stats: $d1f87d24500ab009$var$stats,
    statsIncrementCounter: $d1f87d24500ab009$var$statsIncrementCounter,
    dataUpdateCount: $d1f87d24500ab009$var$dataUpdateCount,
    interceptServerData: $d1f87d24500ab009$var$interceptServerData
});
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $d1f87d24500ab009$var$DataConnection = $d1f87d24500ab009$var$PersistentConnection;
/**
 * @param {!string} pathString
 * @param {function(*)} onComplete
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
$d1f87d24500ab009$var$PersistentConnection.prototype.simpleListen = function(pathString, onComplete) {
    this.sendRequest("q", {
        p: pathString
    }, onComplete);
};
/**
 * @param {*} data
 * @param {function(*)} onEcho
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
$d1f87d24500ab009$var$PersistentConnection.prototype.echo = function(data, onEcho) {
    this.sendRequest("echo", {
        d: data
    }, onEcho);
};
// RealTimeConnection properties that we use in tests.
var $d1f87d24500ab009$var$RealTimeConnection = $d1f87d24500ab009$var$Connection;
/**
 * @param {function(): string} newHash
 * @return {function()}
 */ var $d1f87d24500ab009$var$hijackHash = function(newHash) {
    var oldPut = $d1f87d24500ab009$var$PersistentConnection.prototype.put;
    $d1f87d24500ab009$var$PersistentConnection.prototype.put = function(pathString, data, onComplete, hash) {
        if (hash !== undefined) hash = newHash();
        oldPut.call(this, pathString, data, onComplete, hash);
    };
    return function() {
        $d1f87d24500ab009$var$PersistentConnection.prototype.put = oldPut;
    };
};
/**
 * @type {function(new:RepoInfo, !string, boolean, !string, boolean): undefined}
 */ var $d1f87d24500ab009$var$ConnectionTarget = $d1f87d24500ab009$var$RepoInfo;
/**
 * @param {!Query} query
 * @return {!string}
 */ var $d1f87d24500ab009$var$queryIdentifier = function(query) {
    return query.queryIdentifier();
};
/**
 * Forces the RepoManager to create Repos that use ReadonlyRestClient instead of PersistentConnection.
 *
 * @param {boolean} forceRestClient
 */ var $d1f87d24500ab009$var$forceRestClient = function(forceRestClient) {
    $d1f87d24500ab009$var$RepoManager.getInstance().forceRestClient(forceRestClient);
};
var $d1f87d24500ab009$var$TEST_ACCESS = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    DataConnection: $d1f87d24500ab009$var$DataConnection,
    RealTimeConnection: $d1f87d24500ab009$var$RealTimeConnection,
    hijackHash: $d1f87d24500ab009$var$hijackHash,
    ConnectionTarget: $d1f87d24500ab009$var$ConnectionTarget,
    queryIdentifier: $d1f87d24500ab009$var$queryIdentifier,
    forceRestClient: $d1f87d24500ab009$var$forceRestClient
});
var $d1f87d24500ab009$var$name = "@firebase/database";
var $d1f87d24500ab009$var$version = "0.6.13";
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $d1f87d24500ab009$var$ServerValue = $d1f87d24500ab009$var$Database.ServerValue;
function $d1f87d24500ab009$var$registerDatabase(instance) {
    // set SDK_VERSION
    $d1f87d24500ab009$var$setSDKVersion(instance.SDK_VERSION);
    // Register the Database Service with the 'firebase' namespace.
    var namespace = instance.INTERNAL.registerComponent(new $gLWqF.Component("database", function(container, url) {
        /* Dependencies */ // getImmediate for FirebaseApp will always succeed
        var app = container.getProvider("app").getImmediate();
        var authProvider = container.getProvider("auth-internal");
        return $d1f87d24500ab009$var$RepoManager.getInstance().databaseFromApp(app, authProvider, url);
    }, "PUBLIC" /* PUBLIC */ ).setServiceProps(// firebase.database namespace properties
    {
        Reference: $d1f87d24500ab009$var$Reference,
        Query: $d1f87d24500ab009$var$Query,
        Database: $d1f87d24500ab009$var$Database,
        DataSnapshot: $d1f87d24500ab009$var$DataSnapshot,
        enableLogging: $d1f87d24500ab009$var$enableLogging,
        INTERNAL: $d1f87d24500ab009$var$INTERNAL,
        ServerValue: $d1f87d24500ab009$var$ServerValue,
        TEST_ACCESS: $d1f87d24500ab009$var$TEST_ACCESS
    }).setMultipleInstances(true));
    instance.registerVersion($d1f87d24500ab009$var$name, $d1f87d24500ab009$var$version);
    if ($01sTD.isNodeSdk()) $d1f87d24500ab009$exports = namespace;
}
$d1f87d24500ab009$var$registerDatabase($d1f87d24500ab009$var$firebase__default["default"]);
$d1f87d24500ab009$exports.DataSnapshot = $d1f87d24500ab009$var$DataSnapshot;
$d1f87d24500ab009$exports.Database = $d1f87d24500ab009$var$Database;
$d1f87d24500ab009$exports.OnDisconnect = $d1f87d24500ab009$var$OnDisconnect;
$d1f87d24500ab009$exports.Query = $d1f87d24500ab009$var$Query;
$d1f87d24500ab009$exports.Reference = $d1f87d24500ab009$var$Reference;
$d1f87d24500ab009$exports.ServerValue = $d1f87d24500ab009$var$ServerValue;
$d1f87d24500ab009$exports.enableLogging = $d1f87d24500ab009$var$enableLogging;
$d1f87d24500ab009$exports.registerDatabase = $d1f87d24500ab009$var$registerDatabase;


var $6c8154472dd99012$exports = {};

var $hPtJY = parcelRequire("hPtJY");
"use strict";
Object.defineProperty($6c8154472dd99012$exports, "__esModule", {
    value: !0
});
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $876a70688d8d7977$var$extendStatics = function(d, b) {
    $876a70688d8d7977$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $876a70688d8d7977$var$extendStatics(d, b);
};
function $876a70688d8d7977$export$a8ba968b8961cb8a(d, b) {
    $876a70688d8d7977$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $876a70688d8d7977$export$18ce0697a983be9b = function() {
    $876a70688d8d7977$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $876a70688d8d7977$export$18ce0697a983be9b.apply(this, arguments);
};
function $876a70688d8d7977$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $876a70688d8d7977$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $876a70688d8d7977$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $876a70688d8d7977$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $876a70688d8d7977$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $876a70688d8d7977$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $876a70688d8d7977$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $876a70688d8d7977$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $876a70688d8d7977$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $876a70688d8d7977$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $876a70688d8d7977$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($876a70688d8d7977$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $876a70688d8d7977$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $876a70688d8d7977$export$10c90e4f7922046c(v) {
    return this instanceof $876a70688d8d7977$export$10c90e4f7922046c ? (this.v = v, this) : new $876a70688d8d7977$export$10c90e4f7922046c(v);
}
function $876a70688d8d7977$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $876a70688d8d7977$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $876a70688d8d7977$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $876a70688d8d7977$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $876a70688d8d7977$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $876a70688d8d7977$export$19a8beecd37a4c45 === "function" ? $876a70688d8d7977$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $876a70688d8d7977$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $876a70688d8d7977$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $876a70688d8d7977$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $876a70688d8d7977$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $876a70688d8d7977$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}



var $31dJ8 = parcelRequire("31dJ8");

var $d4M6f = parcelRequire("d4M6f");

var $01sTD = parcelRequire("01sTD");
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $babc33424e560749$var$extendStatics = function(d, b) {
    $babc33424e560749$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $babc33424e560749$var$extendStatics(d, b);
};
function $babc33424e560749$var$__extends(d, b) {
    $babc33424e560749$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
function $babc33424e560749$var$__values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
var $babc33424e560749$var$commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : {};
var $babc33424e560749$var$g, $babc33424e560749$var$goog = $babc33424e560749$var$goog || {}, $babc33424e560749$var$k = $babc33424e560749$var$commonjsGlobal || self;
function $babc33424e560749$var$aa() {}
function $babc33424e560749$var$ba(a) {
    var b = typeof a;
    return "object" != b ? b : a ? Array.isArray(a) ? "array" : b : "null";
}
function $babc33424e560749$var$ca(a) {
    var b = $babc33424e560749$var$ba(a);
    return "array" == b || "object" == b && "number" == typeof a.length;
}
function $babc33424e560749$var$n(a) {
    var b = typeof a;
    return "object" == b && null != a || "function" == b;
}
function $babc33424e560749$var$da(a) {
    return Object.prototype.hasOwnProperty.call(a, $babc33424e560749$var$ea) && a[$babc33424e560749$var$ea] || (a[$babc33424e560749$var$ea] = ++$babc33424e560749$var$fa);
}
var $babc33424e560749$var$ea = "closure_uid_" + (1E9 * Math.random() >>> 0), $babc33424e560749$var$fa = 0;
function $babc33424e560749$var$ha(a, b, c) {
    return a.call.apply(a.bind, arguments);
}
function $babc33424e560749$var$ja(a, b, c) {
    if (!a) throw Error();
    if (2 < arguments.length) {
        var d = Array.prototype.slice.call(arguments, 2);
        return function() {
            var e = Array.prototype.slice.call(arguments);
            Array.prototype.unshift.apply(e, d);
            return a.apply(b, e);
        };
    }
    return function() {
        return a.apply(b, arguments);
    };
}
function $babc33424e560749$var$p(a, b, c) {
    Function.prototype.bind && -1 != Function.prototype.bind.toString().indexOf("native code") ? $babc33424e560749$var$p = $babc33424e560749$var$ha : $babc33424e560749$var$p = $babc33424e560749$var$ja;
    return $babc33424e560749$var$p.apply(null, arguments);
}
function $babc33424e560749$var$ka(a, b) {
    var c = Array.prototype.slice.call(arguments, 1);
    return function() {
        var d = c.slice();
        d.push.apply(d, arguments);
        return a.apply(this, d);
    };
}
var $babc33424e560749$var$q = Date.now;
function $babc33424e560749$var$r(a, b) {
    function c() {}
    c.prototype = b.prototype;
    a.S = b.prototype;
    a.prototype = new c;
    a.prototype.constructor = a;
}
function $babc33424e560749$var$u() {
    this.j = this.j;
    this.i = this.i;
}
var $babc33424e560749$var$la = 0;
$babc33424e560749$var$u.prototype.j = !1;
$babc33424e560749$var$u.prototype.ja = function() {
    if (!this.j && (this.j = !0, this.G(), 0 != $babc33424e560749$var$la)) var a = $babc33424e560749$var$da(this);
};
$babc33424e560749$var$u.prototype.G = function() {
    if (this.i) for(; this.i.length;)this.i.shift()();
};
var $babc33424e560749$var$na = Array.prototype.indexOf ? function(a, b) {
    return Array.prototype.indexOf.call(a, b, void 0);
} : function(a, b) {
    if ("string" === typeof a) return "string" !== typeof b || 1 != b.length ? -1 : a.indexOf(b, 0);
    for(var c = 0; c < a.length; c++)if (c in a && a[c] === b) return c;
    return -1;
}, $babc33424e560749$var$oa = Array.prototype.forEach ? function(a, b, c) {
    Array.prototype.forEach.call(a, b, c);
} : function(a, b, c) {
    for(var d = a.length, e = "string" === typeof a ? a.split("") : a, f = 0; f < d; f++)f in e && b.call(c, e[f], f, a);
};
function $babc33424e560749$var$pa(a) {
    a: {
        var b = $babc33424e560749$var$qa;
        for(var c = a.length, d = "string" === typeof a ? a.split("") : a, e = 0; e < c; e++)if (e in d && b.call(void 0, d[e], e, a)) {
            b = e;
            break a;
        }
        b = -1;
    }
    return 0 > b ? null : "string" === typeof a ? a.charAt(b) : a[b];
}
function $babc33424e560749$var$ra(a) {
    return Array.prototype.concat.apply([], arguments);
}
function $babc33424e560749$var$sa(a) {
    var b = a.length;
    if (0 < b) {
        for(var c = Array(b), d = 0; d < b; d++)c[d] = a[d];
        return c;
    }
    return [];
}
function $babc33424e560749$var$ta(a) {
    return /^[\s\xa0]*$/.test(a);
}
var $babc33424e560749$var$ua = String.prototype.trim ? function(a) {
    return a.trim();
} : function(a) {
    return /^[\s\xa0]*([\s\S]*?)[\s\xa0]*$/.exec(a)[1];
};
function $babc33424e560749$var$v(a, b) {
    return -1 != a.indexOf(b);
}
function $babc33424e560749$var$xa(a, b) {
    return a < b ? -1 : a > b ? 1 : 0;
}
var $babc33424e560749$var$w;
a: {
    var $babc33424e560749$var$ya = $babc33424e560749$var$k.navigator;
    if ($babc33424e560749$var$ya) {
        var $babc33424e560749$var$za = $babc33424e560749$var$ya.userAgent;
        if ($babc33424e560749$var$za) {
            $babc33424e560749$var$w = $babc33424e560749$var$za;
            break a;
        }
    }
    $babc33424e560749$var$w = "";
}
function $babc33424e560749$var$Aa(a, b, c) {
    for(var d in a)b.call(c, a[d], d, a);
}
function $babc33424e560749$var$Ba(a) {
    var b = {};
    for(var c in a)b[c] = a[c];
    return b;
}
var $babc33424e560749$var$Ca = "constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" ");
function $babc33424e560749$var$Da(a, b) {
    var c, d;
    for(var e = 1; e < arguments.length; e++){
        d = arguments[e];
        for(c in d)a[c] = d[c];
        for(var f = 0; f < $babc33424e560749$var$Ca.length; f++)c = $babc33424e560749$var$Ca[f], Object.prototype.hasOwnProperty.call(d, c) && (a[c] = d[c]);
    }
}
function $babc33424e560749$var$Ea(a) {
    $babc33424e560749$var$Ea[" "](a);
    return a;
}
$babc33424e560749$var$Ea[" "] = $babc33424e560749$var$aa;
function $babc33424e560749$var$Fa(a, b) {
    var c = $babc33424e560749$var$Ga;
    return Object.prototype.hasOwnProperty.call(c, a) ? c[a] : c[a] = b(a);
}
var $babc33424e560749$var$Ha = $babc33424e560749$var$v($babc33424e560749$var$w, "Opera"), $babc33424e560749$var$x = $babc33424e560749$var$v($babc33424e560749$var$w, "Trident") || $babc33424e560749$var$v($babc33424e560749$var$w, "MSIE"), $babc33424e560749$var$Ia = $babc33424e560749$var$v($babc33424e560749$var$w, "Edge"), $babc33424e560749$var$Ja = $babc33424e560749$var$Ia || $babc33424e560749$var$x, $babc33424e560749$var$Ka = $babc33424e560749$var$v($babc33424e560749$var$w, "Gecko") && !($babc33424e560749$var$v($babc33424e560749$var$w.toLowerCase(), "webkit") && !$babc33424e560749$var$v($babc33424e560749$var$w, "Edge")) && !($babc33424e560749$var$v($babc33424e560749$var$w, "Trident") || $babc33424e560749$var$v($babc33424e560749$var$w, "MSIE")) && !$babc33424e560749$var$v($babc33424e560749$var$w, "Edge"), $babc33424e560749$var$La = $babc33424e560749$var$v($babc33424e560749$var$w.toLowerCase(), "webkit") && !$babc33424e560749$var$v($babc33424e560749$var$w, "Edge");
function $babc33424e560749$var$Ma() {
    var a = $babc33424e560749$var$k.document;
    return a ? a.documentMode : void 0;
}
var $babc33424e560749$var$Na;
a: {
    var $babc33424e560749$var$Oa = "", $babc33424e560749$var$Pa = function() {
        var a = $babc33424e560749$var$w;
        if ($babc33424e560749$var$Ka) return /rv:([^\);]+)(\)|;)/.exec(a);
        if ($babc33424e560749$var$Ia) return /Edge\/([\d\.]+)/.exec(a);
        if ($babc33424e560749$var$x) return /\b(?:MSIE|rv)[: ]([^\);]+)(\)|;)/.exec(a);
        if ($babc33424e560749$var$La) return /WebKit\/(\S+)/.exec(a);
        if ($babc33424e560749$var$Ha) return /(?:Version)[ \/]?(\S+)/.exec(a);
    }();
    $babc33424e560749$var$Pa && ($babc33424e560749$var$Oa = $babc33424e560749$var$Pa ? $babc33424e560749$var$Pa[1] : "");
    if ($babc33424e560749$var$x) {
        var $babc33424e560749$var$Qa = $babc33424e560749$var$Ma();
        if (null != $babc33424e560749$var$Qa && $babc33424e560749$var$Qa > parseFloat($babc33424e560749$var$Oa)) {
            $babc33424e560749$var$Na = String($babc33424e560749$var$Qa);
            break a;
        }
    }
    $babc33424e560749$var$Na = $babc33424e560749$var$Oa;
}
var $babc33424e560749$var$Ga = {};
function $babc33424e560749$var$Ra(a) {
    return $babc33424e560749$var$Fa(a, function() {
        var b = 0;
        var e = $babc33424e560749$var$ua(String($babc33424e560749$var$Na)).split("."), f = $babc33424e560749$var$ua(String(a)).split("."), h = Math.max(e.length, f.length);
        for(var m = 0; 0 == b && m < h; m++){
            var c = e[m] || "", d = f[m] || "";
            do {
                c = /(\d*)(\D*)(.*)/.exec(c) || [
                    "",
                    "",
                    "",
                    ""
                ];
                d = /(\d*)(\D*)(.*)/.exec(d) || [
                    "",
                    "",
                    "",
                    ""
                ];
                if (0 == c[0].length && 0 == d[0].length) break;
                b = $babc33424e560749$var$xa(0 == c[1].length ? 0 : parseInt(c[1], 10), 0 == d[1].length ? 0 : parseInt(d[1], 10)) || $babc33424e560749$var$xa(0 == c[2].length, 0 == d[2].length) || $babc33424e560749$var$xa(c[2], d[2]);
                c = c[3];
                d = d[3];
            }while (0 == b);
        }
        return 0 <= b;
    });
}
var $babc33424e560749$var$Sa;
if ($babc33424e560749$var$k.document && $babc33424e560749$var$x) {
    var $babc33424e560749$var$Ta = $babc33424e560749$var$Ma();
    $babc33424e560749$var$Sa = $babc33424e560749$var$Ta ? $babc33424e560749$var$Ta : parseInt($babc33424e560749$var$Na, 10) || void 0;
} else $babc33424e560749$var$Sa = void 0;
var $babc33424e560749$var$Ua = $babc33424e560749$var$Sa;
var $babc33424e560749$var$Va = !$babc33424e560749$var$x || 9 <= Number($babc33424e560749$var$Ua), $babc33424e560749$var$Wa = $babc33424e560749$var$x && !$babc33424e560749$var$Ra("9"), $babc33424e560749$var$Xa = function() {
    if (!$babc33424e560749$var$k.addEventListener || !Object.defineProperty) return !1;
    var a = !1, b = Object.defineProperty({}, "passive", {
        get: function() {
            a = !0;
        }
    });
    try {
        $babc33424e560749$var$k.addEventListener("test", $babc33424e560749$var$aa, b), $babc33424e560749$var$k.removeEventListener("test", $babc33424e560749$var$aa, b);
    } catch (c) {}
    return a;
}();
function $babc33424e560749$var$y(a, b) {
    this.type = a;
    this.a = this.target = b;
    this.defaultPrevented = !1;
}
$babc33424e560749$var$y.prototype.b = function() {
    this.defaultPrevented = !0;
};
function $babc33424e560749$var$A(a, b) {
    $babc33424e560749$var$y.call(this, a ? a.type : "");
    this.relatedTarget = this.a = this.target = null;
    this.button = this.screenY = this.screenX = this.clientY = this.clientX = 0;
    this.key = "";
    this.metaKey = this.shiftKey = this.altKey = this.ctrlKey = !1;
    this.pointerId = 0;
    this.pointerType = "";
    this.c = null;
    if (a) {
        var c = this.type = a.type, d = a.changedTouches && a.changedTouches.length ? a.changedTouches[0] : null;
        this.target = a.target || a.srcElement;
        this.a = b;
        if (b = a.relatedTarget) {
            if ($babc33424e560749$var$Ka) {
                a: {
                    try {
                        $babc33424e560749$var$Ea(b.nodeName);
                        var e = !0;
                        break a;
                    } catch (f) {}
                    e = !1;
                }
                e || (b = null);
            }
        } else "mouseover" == c ? b = a.fromElement : "mouseout" == c && (b = a.toElement);
        this.relatedTarget = b;
        d ? (this.clientX = void 0 !== d.clientX ? d.clientX : d.pageX, this.clientY = void 0 !== d.clientY ? d.clientY : d.pageY, this.screenX = d.screenX || 0, this.screenY = d.screenY || 0) : (this.clientX = void 0 !== a.clientX ? a.clientX : a.pageX, this.clientY = void 0 !== a.clientY ? a.clientY : a.pageY, this.screenX = a.screenX || 0, this.screenY = a.screenY || 0);
        this.button = a.button;
        this.key = a.key || "";
        this.ctrlKey = a.ctrlKey;
        this.altKey = a.altKey;
        this.shiftKey = a.shiftKey;
        this.metaKey = a.metaKey;
        this.pointerId = a.pointerId || 0;
        this.pointerType = "string" === typeof a.pointerType ? a.pointerType : $babc33424e560749$var$Ya[a.pointerType] || "";
        this.c = a;
        a.defaultPrevented && this.b();
    }
}
$babc33424e560749$var$r($babc33424e560749$var$A, $babc33424e560749$var$y);
var $babc33424e560749$var$Ya = {
    2: "touch",
    3: "pen",
    4: "mouse"
};
$babc33424e560749$var$A.prototype.b = function() {
    $babc33424e560749$var$A.S.b.call(this);
    var a = this.c;
    if (a.preventDefault) a.preventDefault();
    else if (a.returnValue = !1, $babc33424e560749$var$Wa) try {
        if (a.ctrlKey || 112 <= a.keyCode && 123 >= a.keyCode) a.keyCode = -1;
    } catch (b) {}
};
var $babc33424e560749$var$C = "closure_listenable_" + (1E6 * Math.random() | 0), $babc33424e560749$var$Za = 0;
function $babc33424e560749$var$$a(a, b, c, d, e) {
    this.listener = a;
    this.proxy = null;
    this.src = b;
    this.type = c;
    this.capture = !!d;
    this.ca = e;
    this.key = ++$babc33424e560749$var$Za;
    this.Y = this.Z = !1;
}
function $babc33424e560749$var$ab(a) {
    a.Y = !0;
    a.listener = null;
    a.proxy = null;
    a.src = null;
    a.ca = null;
}
function $babc33424e560749$var$bb(a) {
    this.src = a;
    this.a = {};
    this.b = 0;
}
$babc33424e560749$var$bb.prototype.add = function(a, b, c, d, e) {
    var f = a.toString();
    a = this.a[f];
    a || (a = this.a[f] = [], this.b++);
    var h = $babc33424e560749$var$cb(a, b, d, e);
    -1 < h ? (b = a[h], c || (b.Z = !1)) : (b = new $babc33424e560749$var$$a(b, this.src, f, !!d, e), b.Z = c, a.push(b));
    return b;
};
function $babc33424e560749$var$db(a, b) {
    var c = b.type;
    if (c in a.a) {
        var d = a.a[c], e = $babc33424e560749$var$na(d, b), f;
        (f = 0 <= e) && Array.prototype.splice.call(d, e, 1);
        f && ($babc33424e560749$var$ab(b), 0 == a.a[c].length && (delete a.a[c], a.b--));
    }
}
function $babc33424e560749$var$cb(a, b, c, d) {
    for(var e = 0; e < a.length; ++e){
        var f = a[e];
        if (!f.Y && f.listener == b && f.capture == !!c && f.ca == d) return e;
    }
    return -1;
}
var $babc33424e560749$var$eb = "closure_lm_" + (1E6 * Math.random() | 0), $babc33424e560749$var$fb = {};
function $babc33424e560749$var$hb(a, b, c, d, e) {
    if (d && d.once) return $babc33424e560749$var$ib(a, b, c, d, e);
    if (Array.isArray(b)) {
        for(var f = 0; f < b.length; f++)$babc33424e560749$var$hb(a, b[f], c, d, e);
        return null;
    }
    c = $babc33424e560749$var$jb(c);
    return a && a[$babc33424e560749$var$C] ? a.va(b, c, $babc33424e560749$var$n(d) ? !!d.capture : !!d, e) : $babc33424e560749$var$kb(a, b, c, !1, d, e);
}
function $babc33424e560749$var$kb(a, b, c, d, e, f) {
    if (!b) throw Error("Invalid event type");
    var h = $babc33424e560749$var$n(e) ? !!e.capture : !!e;
    if (h && !$babc33424e560749$var$Va) return null;
    var m = $babc33424e560749$var$lb(a);
    m || (a[$babc33424e560749$var$eb] = m = new $babc33424e560749$var$bb(a));
    c = m.add(b, c, d, h, f);
    if (c.proxy) return c;
    d = $babc33424e560749$var$mb();
    c.proxy = d;
    d.src = a;
    d.listener = c;
    if (a.addEventListener) $babc33424e560749$var$Xa || (e = h), void 0 === e && (e = !1), a.addEventListener(b.toString(), d, e);
    else if (a.attachEvent) a.attachEvent($babc33424e560749$var$nb(b.toString()), d);
    else if (a.addListener && a.removeListener) a.addListener(d);
    else throw Error("addEventListener and attachEvent are unavailable.");
    return c;
}
function $babc33424e560749$var$mb() {
    var a = $babc33424e560749$var$ob, b = $babc33424e560749$var$Va ? function(c) {
        return a.call(b.src, b.listener, c);
    } : function(c) {
        c = a.call(b.src, b.listener, c);
        if (!c) return c;
    };
    return b;
}
function $babc33424e560749$var$ib(a, b, c, d, e) {
    if (Array.isArray(b)) {
        for(var f = 0; f < b.length; f++)$babc33424e560749$var$ib(a, b[f], c, d, e);
        return null;
    }
    c = $babc33424e560749$var$jb(c);
    return a && a[$babc33424e560749$var$C] ? a.wa(b, c, $babc33424e560749$var$n(d) ? !!d.capture : !!d, e) : $babc33424e560749$var$kb(a, b, c, !0, d, e);
}
function $babc33424e560749$var$pb(a, b, c, d, e) {
    if (Array.isArray(b)) for(var f = 0; f < b.length; f++)$babc33424e560749$var$pb(a, b[f], c, d, e);
    else (d = $babc33424e560749$var$n(d) ? !!d.capture : !!d, c = $babc33424e560749$var$jb(c), a && a[$babc33424e560749$var$C]) ? (a = a.c, b = String(b).toString(), b in a.a && (f = a.a[b], c = $babc33424e560749$var$cb(f, c, d, e), -1 < c && ($babc33424e560749$var$ab(f[c]), Array.prototype.splice.call(f, c, 1), 0 == f.length && (delete a.a[b], a.b--)))) : a && (a = $babc33424e560749$var$lb(a)) && (b = a.a[b.toString()], a = -1, b && (a = $babc33424e560749$var$cb(b, c, d, e)), (c = -1 < a ? b[a] : null) && $babc33424e560749$var$rb(c));
}
function $babc33424e560749$var$rb(a) {
    if ("number" !== typeof a && a && !a.Y) {
        var b = a.src;
        if (b && b[$babc33424e560749$var$C]) $babc33424e560749$var$db(b.c, a);
        else {
            var c = a.type, d = a.proxy;
            b.removeEventListener ? b.removeEventListener(c, d, a.capture) : b.detachEvent ? b.detachEvent($babc33424e560749$var$nb(c), d) : b.addListener && b.removeListener && b.removeListener(d);
            (c = $babc33424e560749$var$lb(b)) ? ($babc33424e560749$var$db(c, a), 0 == c.b && (c.src = null, b[$babc33424e560749$var$eb] = null)) : $babc33424e560749$var$ab(a);
        }
    }
}
function $babc33424e560749$var$nb(a) {
    return a in $babc33424e560749$var$fb ? $babc33424e560749$var$fb[a] : $babc33424e560749$var$fb[a] = "on" + a;
}
function $babc33424e560749$var$sb(a, b) {
    var c = a.listener, d = a.ca || a.src;
    a.Z && $babc33424e560749$var$rb(a);
    return c.call(d, b);
}
function $babc33424e560749$var$ob(a, b) {
    if (a.Y) return !0;
    if (!$babc33424e560749$var$Va) {
        if (!b) a: {
            b = [
                "window",
                "event"
            ];
            for(var c = $babc33424e560749$var$k, d = 0; d < b.length; d++)if (c = c[b[d]], null == c) {
                b = null;
                break a;
            }
            b = c;
        }
        b = new $babc33424e560749$var$A(b, this);
        return $babc33424e560749$var$sb(a, b);
    }
    return $babc33424e560749$var$sb(a, new $babc33424e560749$var$A(b, this));
}
function $babc33424e560749$var$lb(a) {
    a = a[$babc33424e560749$var$eb];
    return a instanceof $babc33424e560749$var$bb ? a : null;
}
var $babc33424e560749$var$tb = "__closure_events_fn_" + (1E9 * Math.random() >>> 0);
function $babc33424e560749$var$jb(a) {
    if ("function" == $babc33424e560749$var$ba(a)) return a;
    a[$babc33424e560749$var$tb] || (a[$babc33424e560749$var$tb] = function(b) {
        return a.handleEvent(b);
    });
    return a[$babc33424e560749$var$tb];
}
function $babc33424e560749$var$D() {
    $babc33424e560749$var$u.call(this);
    this.c = new $babc33424e560749$var$bb(this);
    this.J = this;
    this.C = null;
}
$babc33424e560749$var$r($babc33424e560749$var$D, $babc33424e560749$var$u);
$babc33424e560749$var$D.prototype[$babc33424e560749$var$C] = !0;
$babc33424e560749$var$g = $babc33424e560749$var$D.prototype;
$babc33424e560749$var$g.addEventListener = function(a, b, c, d) {
    $babc33424e560749$var$hb(this, a, b, c, d);
};
$babc33424e560749$var$g.removeEventListener = function(a, b, c, d) {
    $babc33424e560749$var$pb(this, a, b, c, d);
};
$babc33424e560749$var$g.dispatchEvent = function(a) {
    var b, c = this.C;
    if (c) for(b = []; c; c = c.C)b.push(c);
    c = this.J;
    var d = a.type || a;
    if ("string" === typeof a) a = new $babc33424e560749$var$y(a, c);
    else if (a instanceof $babc33424e560749$var$y) a.target = a.target || c;
    else {
        var e = a;
        a = new $babc33424e560749$var$y(d, c);
        $babc33424e560749$var$Da(a, e);
    }
    e = !0;
    if (b) for(var f = b.length - 1; 0 <= f; f--){
        var h = a.a = b[f];
        e = $babc33424e560749$var$ub(h, d, !0, a) && e;
    }
    h = a.a = c;
    e = $babc33424e560749$var$ub(h, d, !0, a) && e;
    e = $babc33424e560749$var$ub(h, d, !1, a) && e;
    if (b) for(f = 0; f < b.length; f++)h = a.a = b[f], e = $babc33424e560749$var$ub(h, d, !1, a) && e;
    return e;
};
$babc33424e560749$var$g.G = function() {
    $babc33424e560749$var$D.S.G.call(this);
    if (this.c) {
        var a = this.c, c;
        for(c in a.a){
            for(var d = a.a[c], e = 0; e < d.length; e++)$babc33424e560749$var$ab(d[e]);
            delete a.a[c];
            a.b--;
        }
    }
    this.C = null;
};
$babc33424e560749$var$g.va = function(a, b, c, d) {
    return this.c.add(String(a), b, !1, c, d);
};
$babc33424e560749$var$g.wa = function(a, b, c, d) {
    return this.c.add(String(a), b, !0, c, d);
};
function $babc33424e560749$var$ub(a, b, c, d) {
    b = a.c.a[String(b)];
    if (!b) return !0;
    b = b.concat();
    for(var e = !0, f = 0; f < b.length; ++f){
        var h = b[f];
        if (h && !h.Y && h.capture == c) {
            var m = h.listener, l = h.ca || h.src;
            h.Z && $babc33424e560749$var$db(a.c, h);
            e = !1 !== m.call(l, d) && e;
        }
    }
    return e && !d.defaultPrevented;
}
var $babc33424e560749$var$vb = $babc33424e560749$var$k.JSON.stringify;
function $babc33424e560749$var$wb() {
    this.b = this.a = null;
}
var $babc33424e560749$var$yb = new /** @class */ (function() {
    function class_1(a, b, c) {
        this.f = c;
        this.c = a;
        this.g = b;
        this.b = 0;
        this.a = null;
    }
    class_1.prototype.get = function() {
        var a;
        0 < this.b ? (this.b--, a = this.a, this.a = a.next, a.next = null) : a = this.c();
        return a;
    };
    return class_1;
}())(function() {
    return new $babc33424e560749$var$xb;
}, function(a) {
    a.reset();
}, 100);
$babc33424e560749$var$wb.prototype.add = function(a, b) {
    var c = $babc33424e560749$var$yb.get();
    c.set(a, b);
    this.b ? this.b.next = c : this.a = c;
    this.b = c;
};
function $babc33424e560749$var$zb() {
    var a = $babc33424e560749$var$Ab, b = null;
    a.a && (b = a.a, a.a = a.a.next, a.a || (a.b = null), b.next = null);
    return b;
}
function $babc33424e560749$var$xb() {
    this.next = this.b = this.a = null;
}
$babc33424e560749$var$xb.prototype.set = function(a, b) {
    this.a = a;
    this.b = b;
    this.next = null;
};
$babc33424e560749$var$xb.prototype.reset = function() {
    this.next = this.b = this.a = null;
};
function $babc33424e560749$var$Bb(a) {
    $babc33424e560749$var$k.setTimeout(function() {
        throw a;
    }, 0);
}
function $babc33424e560749$var$Cb(a, b) {
    $babc33424e560749$var$Db || $babc33424e560749$var$Eb();
    $babc33424e560749$var$Fb || ($babc33424e560749$var$Db(), $babc33424e560749$var$Fb = !0);
    $babc33424e560749$var$Ab.add(a, b);
}
var $babc33424e560749$var$Db;
function $babc33424e560749$var$Eb() {
    var a = $babc33424e560749$var$k.Promise.resolve(void 0);
    $babc33424e560749$var$Db = function() {
        a.then($babc33424e560749$var$Gb);
    };
}
var $babc33424e560749$var$Fb = !1, $babc33424e560749$var$Ab = new $babc33424e560749$var$wb;
function $babc33424e560749$var$Gb() {
    for(var a; a = $babc33424e560749$var$zb();){
        try {
            a.a.call(a.b);
        } catch (c) {
            $babc33424e560749$var$Bb(c);
        }
        var b = $babc33424e560749$var$yb;
        b.g(a);
        b.b < b.f && (b.b++, a.next = b.a, b.a = a);
    }
    $babc33424e560749$var$Fb = !1;
}
function $babc33424e560749$var$Hb(a, b) {
    $babc33424e560749$var$D.call(this);
    this.b = a || 1;
    this.a = b || $babc33424e560749$var$k;
    this.f = $babc33424e560749$var$p(this.Ya, this);
    this.g = $babc33424e560749$var$q();
}
$babc33424e560749$var$r($babc33424e560749$var$Hb, $babc33424e560749$var$D);
$babc33424e560749$var$g = $babc33424e560749$var$Hb.prototype;
$babc33424e560749$var$g.aa = !1;
$babc33424e560749$var$g.M = null;
$babc33424e560749$var$g.Ya = function() {
    if (this.aa) {
        var a = $babc33424e560749$var$q() - this.g;
        0 < a && a < .8 * this.b ? this.M = this.a.setTimeout(this.f, this.b - a) : (this.M && (this.a.clearTimeout(this.M), this.M = null), this.dispatchEvent("tick"), this.aa && ($babc33424e560749$var$Ib(this), this.start()));
    }
};
$babc33424e560749$var$g.start = function() {
    this.aa = !0;
    this.M || (this.M = this.a.setTimeout(this.f, this.b), this.g = $babc33424e560749$var$q());
};
function $babc33424e560749$var$Ib(a) {
    a.aa = !1;
    a.M && (a.a.clearTimeout(a.M), a.M = null);
}
$babc33424e560749$var$g.G = function() {
    $babc33424e560749$var$Hb.S.G.call(this);
    $babc33424e560749$var$Ib(this);
    delete this.a;
};
function $babc33424e560749$var$Jb(a, b, c) {
    if ("function" == $babc33424e560749$var$ba(a)) c && (a = $babc33424e560749$var$p(a, c));
    else if (a && "function" == typeof a.handleEvent) a = $babc33424e560749$var$p(a.handleEvent, a);
    else throw Error("Invalid listener argument");
    return 2147483647 < Number(b) ? -1 : $babc33424e560749$var$k.setTimeout(a, b || 0);
}
function $babc33424e560749$var$Kb(a) {
    a.a = $babc33424e560749$var$Jb(function() {
        a.a = null;
        a.c && (a.c = !1, $babc33424e560749$var$Kb(a));
    }, a.h);
    var b = a.b;
    a.b = null;
    a.g.apply(null, b);
}
var $babc33424e560749$var$Lb = /** @class */ function(_super) {
    $babc33424e560749$var$__extends(Lb, _super);
    function Lb(a, b, c) {
        var _this = _super.call(this) || this;
        _this.g = null != c ? a.bind(c) : a;
        _this.h = b;
        _this.b = null;
        _this.c = !1;
        _this.a = null;
        return _this;
    }
    Lb.prototype.f = function(a) {
        this.b = arguments;
        this.a ? this.c = !0 : $babc33424e560749$var$Kb(this);
    };
    Lb.prototype.G = function() {
        _super.prototype.G.call(this);
        this.a && ($babc33424e560749$var$k.clearTimeout(this.a), this.a = null, this.c = !1, this.b = null);
    };
    return Lb;
}($babc33424e560749$var$u);
function $babc33424e560749$var$E(a) {
    $babc33424e560749$var$u.call(this);
    this.b = a;
    this.a = {};
}
$babc33424e560749$var$r($babc33424e560749$var$E, $babc33424e560749$var$u);
var $babc33424e560749$var$Mb = [];
function $babc33424e560749$var$Nb(a, b, c, d) {
    Array.isArray(c) || (c && ($babc33424e560749$var$Mb[0] = c.toString()), c = $babc33424e560749$var$Mb);
    for(var e = 0; e < c.length; e++){
        var f = $babc33424e560749$var$hb(b, c[e], d || a.handleEvent, !1, a.b || a);
        if (!f) break;
        a.a[f.key] = f;
    }
}
function $babc33424e560749$var$Ob(a) {
    $babc33424e560749$var$Aa(a.a, function(b, c) {
        this.a.hasOwnProperty(c) && $babc33424e560749$var$rb(b);
    }, a);
    a.a = {};
}
$babc33424e560749$var$E.prototype.G = function() {
    $babc33424e560749$var$E.S.G.call(this);
    $babc33424e560749$var$Ob(this);
};
$babc33424e560749$var$E.prototype.handleEvent = function() {
    throw Error("EventHandler.handleEvent not implemented");
};
function $babc33424e560749$var$Pb() {
    this.a = !0;
}
function $babc33424e560749$var$Qb(a, b, c, d, e, f) {
    a.info(function() {
        if (a.a) {
            if (f) {
                var h = "";
                for(var m = f.split("&"), l = 0; l < m.length; l++){
                    var t = m[l].split("=");
                    if (1 < t.length) {
                        var B = t[0];
                        t = t[1];
                        var z = B.split("_");
                        h = 2 <= z.length && "type" == z[1] ? h + (B + "=" + t + "&") : h + (B + "=redacted&");
                    }
                }
            } else h = null;
        } else h = f;
        return "XMLHTTP REQ (" + d + ") [attempt " + e + "]: " + b + "\n" + c + "\n" + h;
    });
}
function $babc33424e560749$var$Rb(a, b, c, d, e, f, h) {
    a.info(function() {
        return "XMLHTTP RESP (" + d + ") [ attempt " + e + "]: " + b + "\n" + c + "\n" + f + " " + h;
    });
}
function $babc33424e560749$var$F(a, b, c, d) {
    a.info(function() {
        return "XMLHTTP TEXT (" + b + "): " + $babc33424e560749$var$Sb(a, c) + (d ? " " + d : "");
    });
}
function $babc33424e560749$var$Tb(a, b) {
    a.info(function() {
        return "TIMEOUT: " + b;
    });
}
$babc33424e560749$var$Pb.prototype.info = function() {};
function $babc33424e560749$var$Sb(a, b) {
    if (!a.a) return b;
    if (!b) return null;
    try {
        var c = JSON.parse(b);
        if (c) {
            for(a = 0; a < c.length; a++)if (Array.isArray(c[a])) {
                var d = c[a];
                if (!(2 > d.length)) {
                    var e = d[1];
                    if (Array.isArray(e) && !(1 > e.length)) {
                        var f = e[0];
                        if ("noop" != f && "stop" != f && "close" != f) for(var h = 1; h < e.length; h++)e[h] = "";
                    }
                }
            }
        }
        return $babc33424e560749$var$vb(c);
    } catch (m) {
        return b;
    }
}
var $babc33424e560749$var$Ub = null;
function $babc33424e560749$var$Vb() {
    return $babc33424e560749$var$Ub = $babc33424e560749$var$Ub || new $babc33424e560749$var$D;
}
function $babc33424e560749$var$Wb(a) {
    $babc33424e560749$var$y.call(this, "serverreachability", a);
}
$babc33424e560749$var$r($babc33424e560749$var$Wb, $babc33424e560749$var$y);
function $babc33424e560749$var$G(a) {
    var b = $babc33424e560749$var$Vb();
    b.dispatchEvent(new $babc33424e560749$var$Wb(b, a));
}
function $babc33424e560749$var$Xb(a) {
    $babc33424e560749$var$y.call(this, "statevent", a);
}
$babc33424e560749$var$r($babc33424e560749$var$Xb, $babc33424e560749$var$y);
function $babc33424e560749$var$H(a) {
    var b = $babc33424e560749$var$Vb();
    b.dispatchEvent(new $babc33424e560749$var$Xb(b, a));
}
function $babc33424e560749$var$Yb(a) {
    $babc33424e560749$var$y.call(this, "timingevent", a);
}
$babc33424e560749$var$r($babc33424e560749$var$Yb, $babc33424e560749$var$y);
function $babc33424e560749$var$I(a, b) {
    if ("function" != $babc33424e560749$var$ba(a)) throw Error("Fn must not be null and must be a function");
    return $babc33424e560749$var$k.setTimeout(function() {
        a();
    }, b);
}
var $babc33424e560749$var$Zb = {
    NO_ERROR: 0,
    Za: 1,
    gb: 2,
    fb: 3,
    bb: 4,
    eb: 5,
    hb: 6,
    Da: 7,
    TIMEOUT: 8,
    kb: 9
};
var $babc33424e560749$var$$b = {
    ab: "complete",
    ob: "success",
    Ea: "error",
    Da: "abort",
    mb: "ready",
    nb: "readystatechange",
    TIMEOUT: "timeout",
    ib: "incrementaldata",
    lb: "progress",
    cb: "downloadprogress",
    pb: "uploadprogress"
};
function $babc33424e560749$var$ac() {}
$babc33424e560749$var$ac.prototype.a = null;
function $babc33424e560749$var$bc(a) {
    var b;
    (b = a.a) || (b = a.a = {});
    return b;
}
function $babc33424e560749$var$cc() {}
var $babc33424e560749$var$J = {
    OPEN: "a",
    $a: "b",
    Ea: "c",
    jb: "d"
};
function $babc33424e560749$var$dc() {
    $babc33424e560749$var$y.call(this, "d");
}
$babc33424e560749$var$r($babc33424e560749$var$dc, $babc33424e560749$var$y);
function $babc33424e560749$var$ec() {
    $babc33424e560749$var$y.call(this, "c");
}
$babc33424e560749$var$r($babc33424e560749$var$ec, $babc33424e560749$var$y);
var $babc33424e560749$var$fc;
function $babc33424e560749$var$gc() {}
$babc33424e560749$var$r($babc33424e560749$var$gc, $babc33424e560749$var$ac);
$babc33424e560749$var$fc = new $babc33424e560749$var$gc;
function $babc33424e560749$var$K(a, b, c, d) {
    this.g = a;
    this.c = b;
    this.f = c;
    this.T = d || 1;
    this.J = new $babc33424e560749$var$E(this);
    this.P = $babc33424e560749$var$hc;
    a = $babc33424e560749$var$Ja ? 125 : void 0;
    this.R = new $babc33424e560749$var$Hb(a);
    this.B = null;
    this.b = !1;
    this.j = this.l = this.i = this.H = this.u = this.U = this.o = null;
    this.s = [];
    this.a = null;
    this.D = 0;
    this.h = this.m = null;
    this.N = -1;
    this.A = !1;
    this.O = 0;
    this.F = null;
    this.W = this.C = this.V = this.I = !1;
}
var $babc33424e560749$var$hc = 45E3, $babc33424e560749$var$ic = {}, $babc33424e560749$var$jc = {};
$babc33424e560749$var$g = $babc33424e560749$var$K.prototype;
$babc33424e560749$var$g.setTimeout = function(a) {
    this.P = a;
};
function $babc33424e560749$var$kc(a, b, c) {
    a.H = 1;
    a.i = $babc33424e560749$var$lc($babc33424e560749$var$L(b));
    a.j = c;
    a.I = !0;
    $babc33424e560749$var$mc(a, null);
}
function $babc33424e560749$var$mc(a, b) {
    a.u = $babc33424e560749$var$q();
    $babc33424e560749$var$M(a);
    a.l = $babc33424e560749$var$L(a.i);
    var c = a.l, d = a.T;
    Array.isArray(d) || (d = [
        String(d)
    ]);
    $babc33424e560749$var$nc(c.b, "t", d);
    a.D = 0;
    a.a = $babc33424e560749$var$oc(a.g, a.g.C ? b : null);
    0 < a.O && (a.F = new $babc33424e560749$var$Lb($babc33424e560749$var$p(a.Ca, a, a.a), a.O));
    $babc33424e560749$var$Nb(a.J, a.a, "readystatechange", a.Wa);
    b = a.B ? $babc33424e560749$var$Ba(a.B) : {};
    a.j ? (a.m || (a.m = "POST"), b["Content-Type"] = "application/x-www-form-urlencoded", a.a.ba(a.l, a.m, a.j, b)) : (a.m = "GET", a.a.ba(a.l, a.m, null, b));
    $babc33424e560749$var$G(1);
    $babc33424e560749$var$Qb(a.c, a.m, a.l, a.f, a.T, a.j);
}
$babc33424e560749$var$g.Wa = function(a) {
    a = a.target;
    var b = this.F;
    b && 3 == $babc33424e560749$var$N(a) ? b.f() : this.Ca(a);
};
$babc33424e560749$var$g.Ca = function(a) {
    try {
        if (a == this.a) a: {
            var b = $babc33424e560749$var$N(this.a), c = this.a.ua(), d = this.a.X();
            if (!(3 > b || 3 == b && !$babc33424e560749$var$Ja && !this.a.$())) {
                this.A || 4 != b || 7 == c || (8 == c || 0 >= d ? $babc33424e560749$var$G(3) : $babc33424e560749$var$G(2));
                $babc33424e560749$var$pc(this);
                var e = this.a.X();
                this.N = e;
                var f = this.a.$();
                this.b = 200 == e;
                $babc33424e560749$var$Rb(this.c, this.m, this.l, this.f, this.T, b, e);
                if (this.b) {
                    if (this.V && !this.C) {
                        b: {
                            if (this.a) {
                                var h, m = this.a;
                                if ((h = m.a ? m.a.getResponseHeader("X-HTTP-Initial-Response") : null) && !$babc33424e560749$var$ta(h)) {
                                    var l = h;
                                    break b;
                                }
                            }
                            l = null;
                        }
                        if (l) $babc33424e560749$var$F(this.c, this.f, l, "Initial handshake response via X-HTTP-Initial-Response"), this.C = !0, $babc33424e560749$var$qc(this, l);
                        else {
                            this.b = !1;
                            this.h = 3;
                            $babc33424e560749$var$H(12);
                            $babc33424e560749$var$O(this);
                            $babc33424e560749$var$rc(this);
                            break a;
                        }
                    }
                    this.I ? ($babc33424e560749$var$tc(this, b, f), $babc33424e560749$var$Ja && this.b && 3 == b && ($babc33424e560749$var$Nb(this.J, this.R, "tick", this.Va), this.R.start())) : ($babc33424e560749$var$F(this.c, this.f, f, null), $babc33424e560749$var$qc(this, f));
                    4 == b && $babc33424e560749$var$O(this);
                    this.b && !this.A && (4 == b ? $babc33424e560749$var$uc(this.g, this) : (this.b = !1, $babc33424e560749$var$M(this)));
                } else 400 == e && 0 < f.indexOf("Unknown SID") ? (this.h = 3, $babc33424e560749$var$H(12)) : (this.h = 0, $babc33424e560749$var$H(13)), $babc33424e560749$var$O(this), $babc33424e560749$var$rc(this);
            }
        }
    } catch (t) {} finally{}
};
function $babc33424e560749$var$tc(a, b, c) {
    for(var d = !0; !a.A && a.D < c.length;){
        var e = $babc33424e560749$var$vc(a, c);
        if (e == $babc33424e560749$var$jc) {
            4 == b && (a.h = 4, $babc33424e560749$var$H(14), d = !1);
            $babc33424e560749$var$F(a.c, a.f, null, "[Incomplete Response]");
            break;
        } else if (e == $babc33424e560749$var$ic) {
            a.h = 4;
            $babc33424e560749$var$H(15);
            $babc33424e560749$var$F(a.c, a.f, c, "[Invalid Chunk]");
            d = !1;
            break;
        } else $babc33424e560749$var$F(a.c, a.f, e, null), $babc33424e560749$var$qc(a, e);
    }
    4 == b && 0 == c.length && (a.h = 1, $babc33424e560749$var$H(16), d = !1);
    a.b = a.b && d;
    d ? 0 < c.length && !a.W && (a.W = !0, b = a.g, b.a == a && b.V && !b.F && (b.c.info("Great, no buffering proxy detected. Bytes received: " + c.length), $babc33424e560749$var$xc(b), b.F = !0)) : ($babc33424e560749$var$F(a.c, a.f, c, "[Invalid Chunked Response]"), $babc33424e560749$var$O(a), $babc33424e560749$var$rc(a));
}
$babc33424e560749$var$g.Va = function() {
    if (this.a) {
        var a = $babc33424e560749$var$N(this.a), b = this.a.$();
        this.D < b.length && ($babc33424e560749$var$pc(this), $babc33424e560749$var$tc(this, a, b), this.b && 4 != a && $babc33424e560749$var$M(this));
    }
};
function $babc33424e560749$var$vc(a, b) {
    var c = a.D, d = b.indexOf("\n", c);
    if (-1 == d) return $babc33424e560749$var$jc;
    c = Number(b.substring(c, d));
    if (isNaN(c)) return $babc33424e560749$var$ic;
    d += 1;
    if (d + c > b.length) return $babc33424e560749$var$jc;
    b = b.substr(d, c);
    a.D = d + c;
    return b;
}
$babc33424e560749$var$g.cancel = function() {
    this.A = !0;
    $babc33424e560749$var$O(this);
};
function $babc33424e560749$var$M(a) {
    a.U = $babc33424e560749$var$q() + a.P;
    $babc33424e560749$var$yc(a, a.P);
}
function $babc33424e560749$var$yc(a, b) {
    if (null != a.o) throw Error("WatchDog timer not null");
    a.o = $babc33424e560749$var$I($babc33424e560749$var$p(a.Ua, a), b);
}
function $babc33424e560749$var$pc(a) {
    a.o && ($babc33424e560749$var$k.clearTimeout(a.o), a.o = null);
}
$babc33424e560749$var$g.Ua = function() {
    this.o = null;
    var a = $babc33424e560749$var$q();
    0 <= a - this.U ? ($babc33424e560749$var$Tb(this.c, this.l), 2 != this.H && ($babc33424e560749$var$G(3), $babc33424e560749$var$H(17)), $babc33424e560749$var$O(this), this.h = 2, $babc33424e560749$var$rc(this)) : $babc33424e560749$var$yc(this, this.U - a);
};
function $babc33424e560749$var$rc(a) {
    0 == a.g.v || a.A || $babc33424e560749$var$uc(a.g, a);
}
function $babc33424e560749$var$O(a) {
    $babc33424e560749$var$pc(a);
    var b = a.F;
    b && "function" == typeof b.ja && b.ja();
    a.F = null;
    $babc33424e560749$var$Ib(a.R);
    $babc33424e560749$var$Ob(a.J);
    a.a && (b = a.a, a.a = null, b.abort(), b.ja());
}
function $babc33424e560749$var$qc(a, b) {
    try {
        var c = a.g;
        if (0 != c.v && (c.a == a || $babc33424e560749$var$zc(c.b, a))) {
            if (c.I = a.N, !a.C && $babc33424e560749$var$zc(c.b, a) && 3 == c.v) {
                try {
                    var d = c.ka.a.parse(b);
                } catch (sc) {
                    d = null;
                }
                if (Array.isArray(d) && 3 == d.length) {
                    var e = d;
                    if (0 == e[0]) {
                        a: if (!c.j) {
                            if (c.a) {
                                if (c.a.u + 3E3 < a.u) $babc33424e560749$var$Ac(c), $babc33424e560749$var$Bc(c);
                                else break a;
                            }
                            $babc33424e560749$var$Cc(c);
                            $babc33424e560749$var$H(18);
                        }
                    } else c.oa = e[1], 0 < c.oa - c.P && 37500 > e[2] && c.H && 0 == c.o && !c.m && (c.m = $babc33424e560749$var$I($babc33424e560749$var$p(c.Ra, c), 6E3));
                    if (1 >= $babc33424e560749$var$Dc(c.b) && c.ea) {
                        try {
                            c.ea();
                        } catch (sc) {}
                        c.ea = void 0;
                    }
                } else $babc33424e560749$var$P(c, 11);
            } else if ((a.C || c.a == a) && $babc33424e560749$var$Ac(c), !$babc33424e560749$var$ta(b)) for(b = d = c.ka.a.parse(b), d = 0; d < b.length; d++)if (e = b[d], c.P = e[0], e = e[1], 2 == c.v) {
                if ("c" == e[0]) {
                    c.J = e[1];
                    c.ga = e[2];
                    var f = e[3];
                    null != f && (c.ha = f, c.c.info("VER=" + c.ha));
                    var h = e[4];
                    null != h && (c.pa = h, c.c.info("SVER=" + c.pa));
                    var m = e[5];
                    if (null != m && "number" === typeof m && 0 < m) {
                        var l = 1.5 * m;
                        c.D = l;
                        c.c.info("backChannelRequestTimeoutMs_=" + l);
                    }
                    l = c;
                    var t = a.a;
                    if (t) {
                        var B = t.a ? t.a.getResponseHeader("X-Client-Wire-Protocol") : null;
                        if (B) {
                            var z = l.b;
                            !z.a && ($babc33424e560749$var$v(B, "spdy") || $babc33424e560749$var$v(B, "quic") || $babc33424e560749$var$v(B, "h2")) && (z.f = z.g, z.a = new Set, z.b && ($babc33424e560749$var$Ec(z, z.b), z.b = null));
                        }
                        if (l.A) {
                            var qb = t.a ? t.a.getResponseHeader("X-HTTP-Session-Id") : null;
                            qb && (l.na = qb, $babc33424e560749$var$Q(l.B, l.A, qb));
                        }
                    }
                    c.v = 3;
                    c.f && c.f.ta();
                    c.V && (c.N = $babc33424e560749$var$q() - a.u, c.c.info("Handshake RTT: " + c.N + "ms"));
                    l = c;
                    var va = a;
                    l.la = $babc33424e560749$var$Fc(l, l.C ? l.ga : null, l.fa);
                    if (va.C) {
                        $babc33424e560749$var$Gc(l.b, va);
                        var wa = va, wc = l.D;
                        wc && wa.setTimeout(wc);
                        wa.o && ($babc33424e560749$var$pc(wa), $babc33424e560749$var$M(wa));
                        l.a = va;
                    } else $babc33424e560749$var$Hc(l);
                    0 < c.g.length && $babc33424e560749$var$Ic(c);
                } else "stop" != e[0] && "close" != e[0] || $babc33424e560749$var$P(c, 7);
            } else 3 == c.v && ("stop" == e[0] || "close" == e[0] ? "stop" == e[0] ? $babc33424e560749$var$P(c, 7) : $babc33424e560749$var$Jc(c) : "noop" != e[0] && c.f && c.f.sa(e), c.o = 0);
        }
        $babc33424e560749$var$G(4);
    } catch (sc) {}
}
function $babc33424e560749$var$Kc(a) {
    if (a.K && "function" == typeof a.K) return a.K();
    if ("string" === typeof a) return a.split("");
    if ($babc33424e560749$var$ca(a)) {
        for(var b = [], c = a.length, d = 0; d < c; d++)b.push(a[d]);
        return b;
    }
    b = [];
    c = 0;
    for(d in a)b[c++] = a[d];
    return a = b;
}
function $babc33424e560749$var$Lc(a, b) {
    if (a.forEach && "function" == typeof a.forEach) a.forEach(b, void 0);
    else if ($babc33424e560749$var$ca(a) || "string" === typeof a) $babc33424e560749$var$oa(a, b, void 0);
    else {
        if (a.L && "function" == typeof a.L) var c = a.L();
        else if (a.K && "function" == typeof a.K) c = void 0;
        else if ($babc33424e560749$var$ca(a) || "string" === typeof a) {
            c = [];
            for(var d = a.length, e = 0; e < d; e++)c.push(e);
        } else for(e in c = [], d = 0, a)c[d++] = e;
        d = $babc33424e560749$var$Kc(a);
        e = d.length;
        for(var f = 0; f < e; f++)b.call(void 0, d[f], c && c[f], a);
    }
}
function $babc33424e560749$var$R(a, b) {
    this.b = {};
    this.a = [];
    this.c = 0;
    var c = arguments.length;
    if (1 < c) {
        if (c % 2) throw Error("Uneven number of arguments");
        for(var d = 0; d < c; d += 2)this.set(arguments[d], arguments[d + 1]);
    } else if (a) {
        if (a instanceof $babc33424e560749$var$R) for(c = a.L(), d = 0; d < c.length; d++)this.set(c[d], a.get(c[d]));
        else for(d in a)this.set(d, a[d]);
    }
}
$babc33424e560749$var$g = $babc33424e560749$var$R.prototype;
$babc33424e560749$var$g.K = function() {
    $babc33424e560749$var$Mc(this);
    for(var a = [], b = 0; b < this.a.length; b++)a.push(this.b[this.a[b]]);
    return a;
};
$babc33424e560749$var$g.L = function() {
    $babc33424e560749$var$Mc(this);
    return this.a.concat();
};
function $babc33424e560749$var$Mc(a) {
    if (a.c != a.a.length) {
        for(var b = 0, c = 0; b < a.a.length;){
            var d = a.a[b];
            $babc33424e560749$var$S(a.b, d) && (a.a[c++] = d);
            b++;
        }
        a.a.length = c;
    }
    if (a.c != a.a.length) {
        var e = {};
        for(c = b = 0; b < a.a.length;)d = a.a[b], $babc33424e560749$var$S(e, d) || (a.a[c++] = d, e[d] = 1), b++;
        a.a.length = c;
    }
}
$babc33424e560749$var$g.get = function(a, b) {
    return $babc33424e560749$var$S(this.b, a) ? this.b[a] : b;
};
$babc33424e560749$var$g.set = function(a, b) {
    $babc33424e560749$var$S(this.b, a) || (this.c++, this.a.push(a));
    this.b[a] = b;
};
$babc33424e560749$var$g.forEach = function(a, b) {
    for(var c = this.L(), d = 0; d < c.length; d++){
        var e = c[d], f = this.get(e);
        a.call(b, f, e, this);
    }
};
function $babc33424e560749$var$S(a, b) {
    return Object.prototype.hasOwnProperty.call(a, b);
}
var $babc33424e560749$var$Nc = /^(?:([^:/?#.]+):)?(?:\/\/(?:([^\\/?#]*)@)?([^\\/?#]*?)(?::([0-9]+))?(?=[\\/?#]|$))?([^?#]+)?(?:\?([^#]*))?(?:#([\s\S]*))?$/;
function $babc33424e560749$var$Oc(a, b) {
    if (a) {
        a = a.split("&");
        for(var c = 0; c < a.length; c++){
            var d = a[c].indexOf("="), e = null;
            if (0 <= d) {
                var f = a[c].substring(0, d);
                e = a[c].substring(d + 1);
            } else f = a[c];
            b(f, e ? decodeURIComponent(e.replace(/\+/g, " ")) : "");
        }
    }
}
function $babc33424e560749$var$T(a, b) {
    this.c = this.j = this.f = "";
    this.h = null;
    this.i = this.g = "";
    this.a = !1;
    if (a instanceof $babc33424e560749$var$T) {
        this.a = void 0 !== b ? b : a.a;
        $babc33424e560749$var$Pc(this, a.f);
        this.j = a.j;
        $babc33424e560749$var$Qc(this, a.c);
        $babc33424e560749$var$Rc(this, a.h);
        this.g = a.g;
        b = a.b;
        var c = new $babc33424e560749$var$U;
        c.c = b.c;
        b.a && (c.a = new $babc33424e560749$var$R(b.a), c.b = b.b);
        $babc33424e560749$var$Sc(this, c);
        this.i = a.i;
    } else a && (c = String(a).match($babc33424e560749$var$Nc)) ? (this.a = !!b, $babc33424e560749$var$Pc(this, c[1] || "", !0), this.j = $babc33424e560749$var$Tc(c[2] || ""), $babc33424e560749$var$Qc(this, c[3] || "", !0), $babc33424e560749$var$Rc(this, c[4]), this.g = $babc33424e560749$var$Tc(c[5] || "", !0), $babc33424e560749$var$Sc(this, c[6] || "", !0), this.i = $babc33424e560749$var$Tc(c[7] || "")) : (this.a = !!b, this.b = new $babc33424e560749$var$U(null, this.a));
}
$babc33424e560749$var$T.prototype.toString = function() {
    var a = [], b = this.f;
    b && a.push($babc33424e560749$var$Uc(b, $babc33424e560749$var$Vc, !0), ":");
    var c = this.c;
    if (c || "file" == b) a.push("//"), (b = this.j) && a.push($babc33424e560749$var$Uc(b, $babc33424e560749$var$Vc, !0), "@"), a.push(encodeURIComponent(String(c)).replace(/%25([0-9a-fA-F]{2})/g, "%$1")), c = this.h, null != c && a.push(":", String(c));
    if (c = this.g) this.c && "/" != c.charAt(0) && a.push("/"), a.push($babc33424e560749$var$Uc(c, "/" == c.charAt(0) ? $babc33424e560749$var$Wc : $babc33424e560749$var$Xc, !0));
    (c = this.b.toString()) && a.push("?", c);
    (c = this.i) && a.push("#", $babc33424e560749$var$Uc(c, $babc33424e560749$var$Yc));
    return a.join("");
};
function $babc33424e560749$var$L(a) {
    return new $babc33424e560749$var$T(a);
}
function $babc33424e560749$var$Pc(a, b, c) {
    a.f = c ? $babc33424e560749$var$Tc(b, !0) : b;
    a.f && (a.f = a.f.replace(/:$/, ""));
}
function $babc33424e560749$var$Qc(a, b, c) {
    a.c = c ? $babc33424e560749$var$Tc(b, !0) : b;
}
function $babc33424e560749$var$Rc(a, b) {
    if (b) {
        b = Number(b);
        if (isNaN(b) || 0 > b) throw Error("Bad port number " + b);
        a.h = b;
    } else a.h = null;
}
function $babc33424e560749$var$Sc(a, b, c) {
    b instanceof $babc33424e560749$var$U ? (a.b = b, $babc33424e560749$var$Zc(a.b, a.a)) : (c || (b = $babc33424e560749$var$Uc(b, $babc33424e560749$var$$c)), a.b = new $babc33424e560749$var$U(b, a.a));
}
function $babc33424e560749$var$Q(a, b, c) {
    a.b.set(b, c);
}
function $babc33424e560749$var$lc(a) {
    $babc33424e560749$var$Q(a, "zx", Math.floor(2147483648 * Math.random()).toString(36) + Math.abs(Math.floor(2147483648 * Math.random()) ^ $babc33424e560749$var$q()).toString(36));
    return a;
}
function $babc33424e560749$var$ad(a) {
    return a instanceof $babc33424e560749$var$T ? $babc33424e560749$var$L(a) : new $babc33424e560749$var$T(a, void 0);
}
function $babc33424e560749$var$bd(a, b, c, d) {
    var e = new $babc33424e560749$var$T(null, void 0);
    a && $babc33424e560749$var$Pc(e, a);
    b && $babc33424e560749$var$Qc(e, b);
    c && $babc33424e560749$var$Rc(e, c);
    d && (e.g = d);
    return e;
}
function $babc33424e560749$var$Tc(a, b) {
    return a ? b ? decodeURI(a.replace(/%25/g, "%2525")) : decodeURIComponent(a) : "";
}
function $babc33424e560749$var$Uc(a, b, c) {
    return "string" === typeof a ? (a = encodeURI(a).replace(b, $babc33424e560749$var$cd), c && (a = a.replace(/%25([0-9a-fA-F]{2})/g, "%$1")), a) : null;
}
function $babc33424e560749$var$cd(a) {
    a = a.charCodeAt(0);
    return "%" + (a >> 4 & 15).toString(16) + (a & 15).toString(16);
}
var $babc33424e560749$var$Vc = /[#\/\?@]/g, $babc33424e560749$var$Xc = /[#\?:]/g, $babc33424e560749$var$Wc = /[#\?]/g, $babc33424e560749$var$$c = /[#\?@]/g, $babc33424e560749$var$Yc = /#/g;
function $babc33424e560749$var$U(a, b) {
    this.b = this.a = null;
    this.c = a || null;
    this.f = !!b;
}
function $babc33424e560749$var$V(a) {
    a.a || (a.a = new $babc33424e560749$var$R, a.b = 0, a.c && $babc33424e560749$var$Oc(a.c, function(b, c) {
        a.add(decodeURIComponent(b.replace(/\+/g, " ")), c);
    }));
}
$babc33424e560749$var$g = $babc33424e560749$var$U.prototype;
$babc33424e560749$var$g.add = function(a, b) {
    $babc33424e560749$var$V(this);
    this.c = null;
    a = $babc33424e560749$var$W(this, a);
    var c = this.a.get(a);
    c || this.a.set(a, c = []);
    c.push(b);
    this.b += 1;
    return this;
};
function $babc33424e560749$var$dd(a, b) {
    $babc33424e560749$var$V(a);
    b = $babc33424e560749$var$W(a, b);
    $babc33424e560749$var$S(a.a.b, b) && (a.c = null, a.b -= a.a.get(b).length, a = a.a, $babc33424e560749$var$S(a.b, b) && (delete a.b[b], a.c--, a.a.length > 2 * a.c && $babc33424e560749$var$Mc(a)));
}
function $babc33424e560749$var$ed(a, b) {
    $babc33424e560749$var$V(a);
    b = $babc33424e560749$var$W(a, b);
    return $babc33424e560749$var$S(a.a.b, b);
}
$babc33424e560749$var$g.forEach = function(a, b) {
    $babc33424e560749$var$V(this);
    this.a.forEach(function(c, d) {
        $babc33424e560749$var$oa(c, function(e) {
            a.call(b, e, d, this);
        }, this);
    }, this);
};
$babc33424e560749$var$g.L = function() {
    $babc33424e560749$var$V(this);
    for(var a = this.a.K(), b = this.a.L(), c = [], d = 0; d < b.length; d++)for(var e = a[d], f = 0; f < e.length; f++)c.push(b[d]);
    return c;
};
$babc33424e560749$var$g.K = function(a) {
    $babc33424e560749$var$V(this);
    var b = [];
    if ("string" === typeof a) $babc33424e560749$var$ed(this, a) && (b = $babc33424e560749$var$ra(b, this.a.get($babc33424e560749$var$W(this, a))));
    else {
        a = this.a.K();
        for(var c = 0; c < a.length; c++)b = $babc33424e560749$var$ra(b, a[c]);
    }
    return b;
};
$babc33424e560749$var$g.set = function(a, b) {
    $babc33424e560749$var$V(this);
    this.c = null;
    a = $babc33424e560749$var$W(this, a);
    $babc33424e560749$var$ed(this, a) && (this.b -= this.a.get(a).length);
    this.a.set(a, [
        b
    ]);
    this.b += 1;
    return this;
};
$babc33424e560749$var$g.get = function(a, b) {
    if (!a) return b;
    a = this.K(a);
    return 0 < a.length ? String(a[0]) : b;
};
function $babc33424e560749$var$nc(a, b, c) {
    $babc33424e560749$var$dd(a, b);
    0 < c.length && (a.c = null, a.a.set($babc33424e560749$var$W(a, b), $babc33424e560749$var$sa(c)), a.b += c.length);
}
$babc33424e560749$var$g.toString = function() {
    if (this.c) return this.c;
    if (!this.a) return "";
    for(var a = [], b = this.a.L(), c = 0; c < b.length; c++){
        var d = b[c], e = encodeURIComponent(String(d));
        d = this.K(d);
        for(var f = 0; f < d.length; f++){
            var h = e;
            "" !== d[f] && (h += "=" + encodeURIComponent(String(d[f])));
            a.push(h);
        }
    }
    return this.c = a.join("&");
};
function $babc33424e560749$var$W(a, b) {
    b = String(b);
    a.f && (b = b.toLowerCase());
    return b;
}
function $babc33424e560749$var$Zc(a, b) {
    b && !a.f && ($babc33424e560749$var$V(a), a.c = null, a.a.forEach(function(c, d) {
        var e = d.toLowerCase();
        d != e && ($babc33424e560749$var$dd(this, d), $babc33424e560749$var$nc(this, e, c));
    }, a));
    a.f = b;
}
function $babc33424e560749$var$fd(a, b) {
    this.b = a;
    this.a = b;
}
function $babc33424e560749$var$gd(a) {
    this.g = a || $babc33424e560749$var$hd;
    $babc33424e560749$var$k.PerformanceNavigationTiming ? (a = $babc33424e560749$var$k.performance.getEntriesByType("navigation"), a = 0 < a.length && ("hq" == a[0].nextHopProtocol || "h2" == a[0].nextHopProtocol)) : a = !!($babc33424e560749$var$k.ia && $babc33424e560749$var$k.ia.ya && $babc33424e560749$var$k.ia.ya() && $babc33424e560749$var$k.ia.ya().qb);
    this.f = a ? this.g : 1;
    this.a = null;
    1 < this.f && (this.a = new Set);
    this.b = null;
    this.c = [];
}
var $babc33424e560749$var$hd = 10;
function $babc33424e560749$var$id(a) {
    return a.b ? !0 : a.a ? a.a.size >= a.f : !1;
}
function $babc33424e560749$var$Dc(a) {
    return a.b ? 1 : a.a ? a.a.size : 0;
}
function $babc33424e560749$var$zc(a, b) {
    return a.b ? a.b == b : a.a ? a.a.has(b) : !1;
}
function $babc33424e560749$var$Ec(a, b) {
    a.a ? a.a.add(b) : a.b = b;
}
function $babc33424e560749$var$Gc(a, b) {
    a.b && a.b == b ? a.b = null : a.a && a.a.has(b) && a.a.delete(b);
}
$babc33424e560749$var$gd.prototype.cancel = function() {
    var e_1, _a;
    this.c = $babc33424e560749$var$jd(this);
    if (this.b) this.b.cancel(), this.b = null;
    else if (this.a && 0 !== this.a.size) {
        try {
            for(var _b = $babc33424e560749$var$__values(this.a.values()), _c = _b.next(); !_c.done; _c = _b.next()){
                var a = _c.value;
                a.cancel();
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        this.a.clear();
    }
};
function $babc33424e560749$var$jd(a) {
    var e_2, _a;
    if (null != a.b) return a.c.concat(a.b.s);
    if (null != a.a && 0 !== a.a.size) {
        var b = a.c;
        try {
            for(var _b = $babc33424e560749$var$__values(a.a.values()), _c = _b.next(); !_c.done; _c = _b.next()){
                var c = _c.value;
                b = b.concat(c.s);
            }
        } catch (e_2_1) {
            e_2 = {
                error: e_2_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_2) throw e_2.error;
            }
        }
        return b;
    }
    return $babc33424e560749$var$sa(a.c);
}
function $babc33424e560749$var$kd() {}
$babc33424e560749$var$kd.prototype.stringify = function(a) {
    return $babc33424e560749$var$k.JSON.stringify(a, void 0);
};
$babc33424e560749$var$kd.prototype.parse = function(a) {
    return $babc33424e560749$var$k.JSON.parse(a, void 0);
};
function $babc33424e560749$var$ld() {
    this.a = new $babc33424e560749$var$kd;
}
function $babc33424e560749$var$md(a, b, c) {
    var d = c || "";
    try {
        $babc33424e560749$var$Lc(a, function(e, f) {
            var h = e;
            $babc33424e560749$var$n(e) && (h = $babc33424e560749$var$vb(e));
            b.push(d + f + "=" + encodeURIComponent(h));
        });
    } catch (e) {
        throw b.push(d + "type=" + encodeURIComponent("_badmap")), e;
    }
}
function $babc33424e560749$var$nd(a, b) {
    var c = new $babc33424e560749$var$Pb;
    if ($babc33424e560749$var$k.Image) {
        var d = new Image;
        d.onload = $babc33424e560749$var$ka($babc33424e560749$var$od, c, d, "TestLoadImage: loaded", !0, b);
        d.onerror = $babc33424e560749$var$ka($babc33424e560749$var$od, c, d, "TestLoadImage: error", !1, b);
        d.onabort = $babc33424e560749$var$ka($babc33424e560749$var$od, c, d, "TestLoadImage: abort", !1, b);
        d.ontimeout = $babc33424e560749$var$ka($babc33424e560749$var$od, c, d, "TestLoadImage: timeout", !1, b);
        $babc33424e560749$var$k.setTimeout(function() {
            if (d.ontimeout) d.ontimeout();
        }, 1E4);
        d.src = a;
    } else b(!1);
}
function $babc33424e560749$var$od(a, b, c, d, e) {
    try {
        b.onload = null, b.onerror = null, b.onabort = null, b.ontimeout = null, e(d);
    } catch (f) {}
}
var $babc33424e560749$var$pd = $babc33424e560749$var$k.JSON.parse;
function $babc33424e560749$var$X(a) {
    $babc33424e560749$var$D.call(this);
    this.headers = new $babc33424e560749$var$R;
    this.H = a || null;
    this.b = !1;
    this.s = this.a = null;
    this.B = "";
    this.h = 0;
    this.f = "";
    this.g = this.A = this.l = this.u = !1;
    this.o = 0;
    this.m = null;
    this.I = $babc33424e560749$var$qd;
    this.D = this.F = !1;
}
$babc33424e560749$var$r($babc33424e560749$var$X, $babc33424e560749$var$D);
var $babc33424e560749$var$qd = "", $babc33424e560749$var$rd = /^https?$/i, $babc33424e560749$var$sd = [
    "POST",
    "PUT"
];
$babc33424e560749$var$g = $babc33424e560749$var$X.prototype;
$babc33424e560749$var$g.ba = function(a, b, c, d) {
    if (this.a) throw Error("[goog.net.XhrIo] Object is active with another request=" + this.B + "; newUri=" + a);
    b = b ? b.toUpperCase() : "GET";
    this.B = a;
    this.f = "";
    this.h = 0;
    this.u = !1;
    this.b = !0;
    this.a = new XMLHttpRequest;
    this.s = this.H ? $babc33424e560749$var$bc(this.H) : $babc33424e560749$var$bc($babc33424e560749$var$fc);
    this.a.onreadystatechange = $babc33424e560749$var$p(this.za, this);
    try {
        this.A = !0, this.a.open(b, String(a), !0), this.A = !1;
    } catch (f) {
        $babc33424e560749$var$td(this, f);
        return;
    }
    a = c || "";
    var e = new $babc33424e560749$var$R(this.headers);
    d && $babc33424e560749$var$Lc(d, function(f, h) {
        e.set(h, f);
    });
    d = $babc33424e560749$var$pa(e.L());
    c = $babc33424e560749$var$k.FormData && a instanceof $babc33424e560749$var$k.FormData;
    !(0 <= $babc33424e560749$var$na($babc33424e560749$var$sd, b)) || d || c || e.set("Content-Type", "application/x-www-form-urlencoded;charset=utf-8");
    e.forEach(function(f, h) {
        this.a.setRequestHeader(h, f);
    }, this);
    this.I && (this.a.responseType = this.I);
    "withCredentials" in this.a && this.a.withCredentials !== this.F && (this.a.withCredentials = this.F);
    try {
        $babc33424e560749$var$ud(this), 0 < this.o && ((this.D = $babc33424e560749$var$vd(this.a)) ? (this.a.timeout = this.o, this.a.ontimeout = $babc33424e560749$var$p(this.xa, this)) : this.m = $babc33424e560749$var$Jb(this.xa, this.o, this)), this.l = !0, this.a.send(a), this.l = !1;
    } catch (f) {
        $babc33424e560749$var$td(this, f);
    }
};
function $babc33424e560749$var$vd(a) {
    return $babc33424e560749$var$x && $babc33424e560749$var$Ra(9) && "number" === typeof a.timeout && void 0 !== a.ontimeout;
}
function $babc33424e560749$var$qa(a) {
    return "content-type" == a.toLowerCase();
}
$babc33424e560749$var$g.xa = function() {
    "undefined" != typeof $babc33424e560749$var$goog && this.a && (this.f = "Timed out after " + this.o + "ms, aborting", this.h = 8, this.dispatchEvent("timeout"), this.abort(8));
};
function $babc33424e560749$var$td(a, b) {
    a.b = !1;
    a.a && (a.g = !0, a.a.abort(), a.g = !1);
    a.f = b;
    a.h = 5;
    $babc33424e560749$var$wd(a);
    $babc33424e560749$var$xd(a);
}
function $babc33424e560749$var$wd(a) {
    a.u || (a.u = !0, a.dispatchEvent("complete"), a.dispatchEvent("error"));
}
$babc33424e560749$var$g.abort = function(a) {
    this.a && this.b && (this.b = !1, this.g = !0, this.a.abort(), this.g = !1, this.h = a || 7, this.dispatchEvent("complete"), this.dispatchEvent("abort"), $babc33424e560749$var$xd(this));
};
$babc33424e560749$var$g.G = function() {
    this.a && (this.b && (this.b = !1, this.g = !0, this.a.abort(), this.g = !1), $babc33424e560749$var$xd(this, !0));
    $babc33424e560749$var$X.S.G.call(this);
};
$babc33424e560749$var$g.za = function() {
    this.j || (this.A || this.l || this.g ? $babc33424e560749$var$yd(this) : this.Ta());
};
$babc33424e560749$var$g.Ta = function() {
    $babc33424e560749$var$yd(this);
};
function $babc33424e560749$var$yd(a) {
    if (a.b && "undefined" != typeof $babc33424e560749$var$goog && (!a.s[1] || 4 != $babc33424e560749$var$N(a) || 2 != a.X())) {
        if (a.l && 4 == $babc33424e560749$var$N(a)) $babc33424e560749$var$Jb(a.za, 0, a);
        else if (a.dispatchEvent("readystatechange"), 4 == $babc33424e560749$var$N(a)) {
            a.b = !1;
            try {
                var b = a.X();
                a: switch(b){
                    case 200:
                    case 201:
                    case 202:
                    case 204:
                    case 206:
                    case 304:
                    case 1223:
                        var c = !0;
                        break a;
                    default:
                        c = !1;
                }
                var d;
                if (!(d = c)) {
                    var e;
                    if (e = 0 === b) {
                        var f = String(a.B).match($babc33424e560749$var$Nc)[1] || null;
                        if (!f && $babc33424e560749$var$k.self && $babc33424e560749$var$k.self.location) {
                            var h = $babc33424e560749$var$k.self.location.protocol;
                            f = h.substr(0, h.length - 1);
                        }
                        e = !$babc33424e560749$var$rd.test(f ? f.toLowerCase() : "");
                    }
                    d = e;
                }
                if (d) a.dispatchEvent("complete"), a.dispatchEvent("success");
                else {
                    a.h = 6;
                    try {
                        var m = 2 < $babc33424e560749$var$N(a) ? a.a.statusText : "";
                    } catch (l) {
                        m = "";
                    }
                    a.f = m + " [" + a.X() + "]";
                    $babc33424e560749$var$wd(a);
                }
            } finally{
                $babc33424e560749$var$xd(a);
            }
        }
    }
}
function $babc33424e560749$var$xd(a, b) {
    if (a.a) {
        $babc33424e560749$var$ud(a);
        var c = a.a, d = a.s[0] ? $babc33424e560749$var$aa : null;
        a.a = null;
        a.s = null;
        b || a.dispatchEvent("ready");
        try {
            c.onreadystatechange = d;
        } catch (e) {}
    }
}
function $babc33424e560749$var$ud(a) {
    a.a && a.D && (a.a.ontimeout = null);
    a.m && ($babc33424e560749$var$k.clearTimeout(a.m), a.m = null);
}
function $babc33424e560749$var$N(a) {
    return a.a ? a.a.readyState : 0;
}
$babc33424e560749$var$g.X = function() {
    try {
        return 2 < $babc33424e560749$var$N(this) ? this.a.status : -1;
    } catch (a) {
        return -1;
    }
};
$babc33424e560749$var$g.$ = function() {
    try {
        return this.a ? this.a.responseText : "";
    } catch (a) {
        return "";
    }
};
$babc33424e560749$var$g.Na = function(a) {
    if (this.a) {
        var b = this.a.responseText;
        a && 0 == b.indexOf(a) && (b = b.substring(a.length));
        return $babc33424e560749$var$pd(b);
    }
};
$babc33424e560749$var$g.ua = function() {
    return this.h;
};
$babc33424e560749$var$g.Qa = function() {
    return "string" === typeof this.f ? this.f : String(this.f);
};
function $babc33424e560749$var$zd(a) {
    var b = "";
    $babc33424e560749$var$Aa(a, function(c, d) {
        b += d;
        b += ":";
        b += c;
        b += "\r\n";
    });
    return b;
}
function $babc33424e560749$var$Ad(a, b, c) {
    a: {
        for(d in c){
            var d = !1;
            break a;
        }
        d = !0;
    }
    d || (c = $babc33424e560749$var$zd(c), "string" === typeof a ? null != c && encodeURIComponent(String(c)) : $babc33424e560749$var$Q(a, b, c));
}
function $babc33424e560749$var$Bd(a, b, c) {
    return c && c.internalChannelParams ? c.internalChannelParams[a] || b : b;
}
function $babc33424e560749$var$Cd(a) {
    this.pa = 0;
    this.g = [];
    this.c = new $babc33424e560749$var$Pb;
    this.ga = this.la = this.B = this.fa = this.a = this.na = this.A = this.W = this.i = this.O = this.l = null;
    this.La = this.R = 0;
    this.Ia = $babc33424e560749$var$Bd("failFast", !1, a);
    this.H = this.m = this.j = this.h = this.f = null;
    this.T = !0;
    this.I = this.oa = this.P = -1;
    this.U = this.o = this.u = 0;
    this.Fa = $babc33424e560749$var$Bd("baseRetryDelayMs", 5E3, a);
    this.Ma = $babc33424e560749$var$Bd("retryDelaySeedMs", 1E4, a);
    this.Ja = $babc33424e560749$var$Bd("forwardChannelMaxRetries", 2, a);
    this.ma = $babc33424e560749$var$Bd("forwardChannelRequestTimeoutMs", 2E4, a);
    this.Ka = a && a.g || void 0;
    this.D = void 0;
    this.C = a && a.supportsCrossDomainXhr || !1;
    this.J = "";
    this.b = new $babc33424e560749$var$gd(a && a.concurrentRequestLimit);
    this.ka = new $babc33424e560749$var$ld;
    this.da = a && a.fastHandshake || !1;
    this.Ga = a && a.b || !1;
    a && a.f && (this.c.a = !1);
    a && a.forceLongPolling && (this.T = !1);
    this.V = !this.da && this.T && a && a.c || !1;
    this.ea = void 0;
    this.N = 0;
    this.F = !1;
    this.s = null;
}
$babc33424e560749$var$g = $babc33424e560749$var$Cd.prototype;
$babc33424e560749$var$g.ha = 8;
$babc33424e560749$var$g.v = 1;
function $babc33424e560749$var$Jc(a) {
    $babc33424e560749$var$Dd(a);
    if (3 == a.v) {
        var b = a.R++, c = $babc33424e560749$var$L(a.B);
        $babc33424e560749$var$Q(c, "SID", a.J);
        $babc33424e560749$var$Q(c, "RID", b);
        $babc33424e560749$var$Q(c, "TYPE", "terminate");
        $babc33424e560749$var$Ed(a, c);
        b = new $babc33424e560749$var$K(a, a.c, b, void 0);
        b.H = 2;
        b.i = $babc33424e560749$var$lc($babc33424e560749$var$L(c));
        c = !1;
        $babc33424e560749$var$k.navigator && $babc33424e560749$var$k.navigator.sendBeacon && (c = $babc33424e560749$var$k.navigator.sendBeacon(b.i.toString(), ""));
        !c && $babc33424e560749$var$k.Image && ((new Image).src = b.i, c = !0);
        c || (b.a = $babc33424e560749$var$oc(b.g, null), b.a.ba(b.i));
        b.u = $babc33424e560749$var$q();
        $babc33424e560749$var$M(b);
    }
    $babc33424e560749$var$Fd(a);
}
function $babc33424e560749$var$Bc(a) {
    a.a && ($babc33424e560749$var$xc(a), a.a.cancel(), a.a = null);
}
function $babc33424e560749$var$Dd(a) {
    $babc33424e560749$var$Bc(a);
    a.j && ($babc33424e560749$var$k.clearTimeout(a.j), a.j = null);
    $babc33424e560749$var$Ac(a);
    a.b.cancel();
    a.h && ("number" === typeof a.h && $babc33424e560749$var$k.clearTimeout(a.h), a.h = null);
}
function $babc33424e560749$var$Gd(a, b) {
    a.g.push(new $babc33424e560749$var$fd(a.La++, b));
    3 == a.v && $babc33424e560749$var$Ic(a);
}
function $babc33424e560749$var$Ic(a) {
    $babc33424e560749$var$id(a.b) || a.h || (a.h = !0, $babc33424e560749$var$Cb(a.Ba, a), a.u = 0);
}
function $babc33424e560749$var$Hd(a, b) {
    if ($babc33424e560749$var$Dc(a.b) >= a.b.f - (a.h ? 1 : 0)) return !1;
    if (a.h) return a.g = b.s.concat(a.g), !0;
    if (1 == a.v || 2 == a.v || a.u >= (a.Ia ? 0 : a.Ja)) return !1;
    a.h = $babc33424e560749$var$I($babc33424e560749$var$p(a.Ba, a, b), $babc33424e560749$var$Id(a, a.u));
    a.u++;
    return !0;
}
$babc33424e560749$var$g.Ba = function(a) {
    if (this.h) {
        if (this.h = null, 1 == this.v) {
            if (!a) {
                this.R = Math.floor(1E5 * Math.random());
                a = this.R++;
                var b = new $babc33424e560749$var$K(this, this.c, a, void 0), c = this.l;
                this.O && (c ? (c = $babc33424e560749$var$Ba(c), $babc33424e560749$var$Da(c, this.O)) : c = this.O);
                null === this.i && (b.B = c);
                var d;
                if (this.da) a: {
                    for(var e = d = 0; e < this.g.length; e++){
                        b: {
                            var f = this.g[e];
                            if ("__data__" in f.a && (f = f.a.__data__, "string" === typeof f)) {
                                f = f.length;
                                break b;
                            }
                            f = void 0;
                        }
                        if (void 0 === f) break;
                        d += f;
                        if (4096 < d) {
                            d = e;
                            break a;
                        }
                        if (4096 === d || e === this.g.length - 1) {
                            d = e + 1;
                            break a;
                        }
                    }
                    d = 1E3;
                }
                else d = 1E3;
                d = $babc33424e560749$var$Jd(this, b, d);
                e = $babc33424e560749$var$L(this.B);
                $babc33424e560749$var$Q(e, "RID", a);
                $babc33424e560749$var$Q(e, "CVER", 22);
                this.A && $babc33424e560749$var$Q(e, "X-HTTP-Session-Id", this.A);
                $babc33424e560749$var$Ed(this, e);
                this.i && c && $babc33424e560749$var$Ad(e, this.i, c);
                $babc33424e560749$var$Ec(this.b, b);
                this.Ga && $babc33424e560749$var$Q(e, "TYPE", "init");
                this.da ? ($babc33424e560749$var$Q(e, "$req", d), $babc33424e560749$var$Q(e, "SID", "null"), b.V = !0, $babc33424e560749$var$kc(b, e, null)) : $babc33424e560749$var$kc(b, e, d);
                this.v = 2;
            }
        } else 3 == this.v && (a ? $babc33424e560749$var$Kd(this, a) : 0 == this.g.length || $babc33424e560749$var$id(this.b) || $babc33424e560749$var$Kd(this));
    }
};
function $babc33424e560749$var$Kd(a, b) {
    var c;
    b ? c = b.f : c = a.R++;
    var d = $babc33424e560749$var$L(a.B);
    $babc33424e560749$var$Q(d, "SID", a.J);
    $babc33424e560749$var$Q(d, "RID", c);
    $babc33424e560749$var$Q(d, "AID", a.P);
    $babc33424e560749$var$Ed(a, d);
    a.i && a.l && $babc33424e560749$var$Ad(d, a.i, a.l);
    c = new $babc33424e560749$var$K(a, a.c, c, a.u + 1);
    null === a.i && (c.B = a.l);
    b && (a.g = b.s.concat(a.g));
    b = $babc33424e560749$var$Jd(a, c, 1E3);
    c.setTimeout(Math.round(.5 * a.ma) + Math.round(.5 * a.ma * Math.random()));
    $babc33424e560749$var$Ec(a.b, c);
    $babc33424e560749$var$kc(c, d, b);
}
function $babc33424e560749$var$Ed(a, b) {
    a.f && $babc33424e560749$var$Lc({}, function(c, d) {
        $babc33424e560749$var$Q(b, d, c);
    });
}
function $babc33424e560749$var$Jd(a, b, c) {
    c = Math.min(a.g.length, c);
    var d = a.f ? $babc33424e560749$var$p(a.f.Ha, a.f, a) : null;
    a: for(var e = a.g, f = -1;;){
        var h = [
            "count=" + c
        ];
        -1 == f ? 0 < c ? (f = e[0].b, h.push("ofs=" + f)) : f = 0 : h.push("ofs=" + f);
        for(var m = !0, l = 0; l < c; l++){
            var t = e[l].b, B = e[l].a;
            t -= f;
            if (0 > t) f = Math.max(0, e[l].b - 100), m = !1;
            else try {
                $babc33424e560749$var$md(B, h, "req" + t + "_");
            } catch (z) {
                d && d(B);
            }
        }
        if (m) {
            d = h.join("&");
            break a;
        }
    }
    a = a.g.splice(0, c);
    b.s = a;
    return d;
}
function $babc33424e560749$var$Hc(a) {
    a.a || a.j || (a.U = 1, $babc33424e560749$var$Cb(a.Aa, a), a.o = 0);
}
function $babc33424e560749$var$Cc(a) {
    if (a.a || a.j || 3 <= a.o) return !1;
    a.U++;
    a.j = $babc33424e560749$var$I($babc33424e560749$var$p(a.Aa, a), $babc33424e560749$var$Id(a, a.o));
    a.o++;
    return !0;
}
$babc33424e560749$var$g.Aa = function() {
    this.j = null;
    $babc33424e560749$var$Ld(this);
    if (this.V && !(this.F || null == this.a || 0 >= this.N)) {
        var a = 2 * this.N;
        this.c.info("BP detection timer enabled: " + a);
        this.s = $babc33424e560749$var$I($babc33424e560749$var$p(this.Sa, this), a);
    }
};
$babc33424e560749$var$g.Sa = function() {
    this.s && (this.s = null, this.c.info("BP detection timeout reached."), this.c.info("Buffering proxy detected and switch to long-polling!"), this.H = !1, this.F = !0, $babc33424e560749$var$Bc(this), $babc33424e560749$var$Ld(this));
};
function $babc33424e560749$var$xc(a) {
    null != a.s && ($babc33424e560749$var$k.clearTimeout(a.s), a.s = null);
}
function $babc33424e560749$var$Ld(a) {
    a.a = new $babc33424e560749$var$K(a, a.c, "rpc", a.U);
    null === a.i && (a.a.B = a.l);
    a.a.O = 0;
    var b = $babc33424e560749$var$L(a.la);
    $babc33424e560749$var$Q(b, "RID", "rpc");
    $babc33424e560749$var$Q(b, "SID", a.J);
    $babc33424e560749$var$Q(b, "CI", a.H ? "0" : "1");
    $babc33424e560749$var$Q(b, "AID", a.P);
    $babc33424e560749$var$Ed(a, b);
    $babc33424e560749$var$Q(b, "TYPE", "xmlhttp");
    a.i && a.l && $babc33424e560749$var$Ad(b, a.i, a.l);
    a.D && a.a.setTimeout(a.D);
    var c = a.a;
    a = a.ga;
    c.H = 1;
    c.i = $babc33424e560749$var$lc($babc33424e560749$var$L(b));
    c.j = null;
    c.I = !0;
    $babc33424e560749$var$mc(c, a);
}
$babc33424e560749$var$g.Ra = function() {
    null != this.m && (this.m = null, $babc33424e560749$var$Bc(this), $babc33424e560749$var$Cc(this), $babc33424e560749$var$H(19));
};
function $babc33424e560749$var$Ac(a) {
    null != a.m && ($babc33424e560749$var$k.clearTimeout(a.m), a.m = null);
}
function $babc33424e560749$var$uc(a, b) {
    var c = null;
    if (a.a == b) {
        $babc33424e560749$var$Ac(a);
        $babc33424e560749$var$xc(a);
        a.a = null;
        var d = 2;
    } else if ($babc33424e560749$var$zc(a.b, b)) c = b.s, $babc33424e560749$var$Gc(a.b, b), d = 1;
    else return;
    a.I = b.N;
    if (0 != a.v) {
        if (b.b) {
            if (1 == d) {
                c = b.j ? b.j.length : 0;
                b = $babc33424e560749$var$q() - b.u;
                var e = a.u;
                d = $babc33424e560749$var$Vb();
                d.dispatchEvent(new $babc33424e560749$var$Yb(d, c, b, e));
                $babc33424e560749$var$Ic(a);
            } else $babc33424e560749$var$Hc(a);
        } else if (e = b.h, 3 == e || 0 == e && 0 < a.I || !(1 == d && $babc33424e560749$var$Hd(a, b) || 2 == d && $babc33424e560749$var$Cc(a))) switch(c && 0 < c.length && (b = a.b, b.c = b.c.concat(c)), e){
            case 1:
                $babc33424e560749$var$P(a, 5);
                break;
            case 4:
                $babc33424e560749$var$P(a, 10);
                break;
            case 3:
                $babc33424e560749$var$P(a, 6);
                break;
            default:
                $babc33424e560749$var$P(a, 2);
        }
    }
}
function $babc33424e560749$var$Id(a, b) {
    var c = a.Fa + Math.floor(Math.random() * a.Ma);
    a.f || (c *= 2);
    return c * b;
}
function $babc33424e560749$var$P(a, b) {
    a.c.info("Error code " + b);
    if (2 == b) {
        var c = null;
        a.f && (c = null);
        var d = $babc33424e560749$var$p(a.Xa, a);
        c || (c = new $babc33424e560749$var$T("//www.google.com/images/cleardot.gif"), $babc33424e560749$var$k.location && "http" == $babc33424e560749$var$k.location.protocol || $babc33424e560749$var$Pc(c, "https"), $babc33424e560749$var$lc(c));
        $babc33424e560749$var$nd(c.toString(), d);
    } else $babc33424e560749$var$H(2);
    a.v = 0;
    a.f && a.f.ra(b);
    $babc33424e560749$var$Fd(a);
    $babc33424e560749$var$Dd(a);
}
$babc33424e560749$var$g.Xa = function(a) {
    a ? (this.c.info("Successfully pinged google.com"), $babc33424e560749$var$H(2)) : (this.c.info("Failed to ping google.com"), $babc33424e560749$var$H(1));
};
function $babc33424e560749$var$Fd(a) {
    a.v = 0;
    a.I = -1;
    if (a.f) {
        if (0 != $babc33424e560749$var$jd(a.b).length || 0 != a.g.length) a.b.c.length = 0, $babc33424e560749$var$sa(a.g), a.g.length = 0;
        a.f.qa();
    }
}
function $babc33424e560749$var$Fc(a, b, c) {
    var d = $babc33424e560749$var$ad(c);
    if ("" != d.c) b && $babc33424e560749$var$Qc(d, b + "." + d.c), $babc33424e560749$var$Rc(d, d.h);
    else {
        var e = $babc33424e560749$var$k.location;
        d = $babc33424e560749$var$bd(e.protocol, b ? b + "." + e.hostname : e.hostname, +e.port, c);
    }
    a.W && $babc33424e560749$var$Aa(a.W, function(f, h) {
        $babc33424e560749$var$Q(d, h, f);
    });
    b = a.A;
    c = a.na;
    b && c && $babc33424e560749$var$Q(d, b, c);
    $babc33424e560749$var$Q(d, "VER", a.ha);
    $babc33424e560749$var$Ed(a, d);
    return d;
}
function $babc33424e560749$var$oc(a, b) {
    if (b && !a.C) throw Error("Can't create secondary domain capable XhrIo object.");
    b = new $babc33424e560749$var$X(a.Ka);
    b.F = a.C;
    return b;
}
function $babc33424e560749$var$Md() {}
$babc33424e560749$var$g = $babc33424e560749$var$Md.prototype;
$babc33424e560749$var$g.ta = function() {};
$babc33424e560749$var$g.sa = function() {};
$babc33424e560749$var$g.ra = function() {};
$babc33424e560749$var$g.qa = function() {};
$babc33424e560749$var$g.Ha = function() {};
function $babc33424e560749$var$Nd() {
    if ($babc33424e560749$var$x && !(10 <= Number($babc33424e560749$var$Ua))) throw Error("Environmental error: no available transport.");
}
$babc33424e560749$var$Nd.prototype.a = function(a, b) {
    return new $babc33424e560749$var$Y(a, b);
};
function $babc33424e560749$var$Y(a, b) {
    $babc33424e560749$var$D.call(this);
    this.a = new $babc33424e560749$var$Cd(b);
    this.l = a;
    this.b = b && b.messageUrlParams || null;
    a = b && b.messageHeaders || null;
    b && b.clientProtocolHeaderRequired && (a ? a["X-Client-Protocol"] = "webchannel" : a = {
        "X-Client-Protocol": "webchannel"
    });
    this.a.l = a;
    a = b && b.initMessageHeaders || null;
    b && b.messageContentType && (a ? a["X-WebChannel-Content-Type"] = b.messageContentType : a = {
        "X-WebChannel-Content-Type": b.messageContentType
    });
    b && b.a && (a ? a["X-WebChannel-Client-Profile"] = b.a : a = {
        "X-WebChannel-Client-Profile": b.a
    });
    this.a.O = a;
    (a = b && b.httpHeadersOverwriteParam) && !$babc33424e560749$var$ta(a) && (this.a.i = a);
    this.h = b && b.supportsCrossDomainXhr || !1;
    this.g = b && b.sendRawJson || !1;
    (b = b && b.httpSessionIdParam) && !$babc33424e560749$var$ta(b) && (this.a.A = b, a = this.b, null !== a && b in a && (a = this.b, b in a && delete a[b]));
    this.f = new $babc33424e560749$var$Z(this);
}
$babc33424e560749$var$r($babc33424e560749$var$Y, $babc33424e560749$var$D);
$babc33424e560749$var$g = $babc33424e560749$var$Y.prototype;
$babc33424e560749$var$g.addEventListener = function(a, b, c, d) {
    $babc33424e560749$var$Y.S.addEventListener.call(this, a, b, c, d);
};
$babc33424e560749$var$g.removeEventListener = function(a, b, c, d) {
    $babc33424e560749$var$Y.S.removeEventListener.call(this, a, b, c, d);
};
$babc33424e560749$var$g.Oa = function() {
    this.a.f = this.f;
    this.h && (this.a.C = !0);
    var a = this.a, b = this.l, c = this.b || void 0;
    $babc33424e560749$var$H(0);
    a.fa = b;
    a.W = c || {};
    a.H = a.T;
    a.B = $babc33424e560749$var$Fc(a, null, a.fa);
    $babc33424e560749$var$Ic(a);
};
$babc33424e560749$var$g.close = function() {
    $babc33424e560749$var$Jc(this.a);
};
$babc33424e560749$var$g.Pa = function(a) {
    if ("string" === typeof a) {
        var b = {};
        b.__data__ = a;
        $babc33424e560749$var$Gd(this.a, b);
    } else this.g ? (b = {}, b.__data__ = $babc33424e560749$var$vb(a), $babc33424e560749$var$Gd(this.a, b)) : $babc33424e560749$var$Gd(this.a, a);
};
$babc33424e560749$var$g.G = function() {
    this.a.f = null;
    delete this.f;
    $babc33424e560749$var$Jc(this.a);
    delete this.a;
    $babc33424e560749$var$Y.S.G.call(this);
};
function $babc33424e560749$var$Od(a) {
    $babc33424e560749$var$dc.call(this);
    var b = a.__sm__;
    if (b) {
        a: {
            for(var c in b){
                a = c;
                break a;
            }
            a = void 0;
        }
        (this.c = a) ? (a = this.c, this.data = null !== b && a in b ? b[a] : void 0) : this.data = b;
    } else this.data = a;
}
$babc33424e560749$var$r($babc33424e560749$var$Od, $babc33424e560749$var$dc);
function $babc33424e560749$var$Pd() {
    $babc33424e560749$var$ec.call(this);
    this.status = 1;
}
$babc33424e560749$var$r($babc33424e560749$var$Pd, $babc33424e560749$var$ec);
function $babc33424e560749$var$Z(a) {
    this.a = a;
}
$babc33424e560749$var$r($babc33424e560749$var$Z, $babc33424e560749$var$Md);
$babc33424e560749$var$Z.prototype.ta = function() {
    this.a.dispatchEvent("a");
};
$babc33424e560749$var$Z.prototype.sa = function(a) {
    this.a.dispatchEvent(new $babc33424e560749$var$Od(a));
};
$babc33424e560749$var$Z.prototype.ra = function(a) {
    this.a.dispatchEvent(new $babc33424e560749$var$Pd(a));
};
$babc33424e560749$var$Z.prototype.qa = function() {
    this.a.dispatchEvent("b");
}; /*

 Copyright 2017 Google LLC

 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

   http://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
*/ 
$babc33424e560749$var$Nd.prototype.createWebChannel = $babc33424e560749$var$Nd.prototype.a;
$babc33424e560749$var$Y.prototype.send = $babc33424e560749$var$Y.prototype.Pa;
$babc33424e560749$var$Y.prototype.open = $babc33424e560749$var$Y.prototype.Oa;
$babc33424e560749$var$Y.prototype.close = $babc33424e560749$var$Y.prototype.close;
$babc33424e560749$var$Zb.NO_ERROR = 0;
$babc33424e560749$var$Zb.TIMEOUT = 8;
$babc33424e560749$var$Zb.HTTP_ERROR = 6;
$babc33424e560749$var$$b.COMPLETE = "complete";
$babc33424e560749$var$cc.EventType = $babc33424e560749$var$J;
$babc33424e560749$var$J.OPEN = "a";
$babc33424e560749$var$J.CLOSE = "b";
$babc33424e560749$var$J.ERROR = "c";
$babc33424e560749$var$J.MESSAGE = "d";
$babc33424e560749$var$D.prototype.listen = $babc33424e560749$var$D.prototype.va;
$babc33424e560749$var$X.prototype.listenOnce = $babc33424e560749$var$X.prototype.wa;
$babc33424e560749$var$X.prototype.getLastError = $babc33424e560749$var$X.prototype.Qa;
$babc33424e560749$var$X.prototype.getLastErrorCode = $babc33424e560749$var$X.prototype.ua;
$babc33424e560749$var$X.prototype.getStatus = $babc33424e560749$var$X.prototype.X;
$babc33424e560749$var$X.prototype.getResponseJson = $babc33424e560749$var$X.prototype.Na;
$babc33424e560749$var$X.prototype.getResponseText = $babc33424e560749$var$X.prototype.$;
$babc33424e560749$var$X.prototype.send = $babc33424e560749$var$X.prototype.ba;
var $babc33424e560749$export$66869136fc133c3a = function() {
    return new $babc33424e560749$var$Nd;
};
var $babc33424e560749$export$d4e71bc0b80dc0fb = $babc33424e560749$var$Zb;
var $babc33424e560749$export$3d7865934588d77e = $babc33424e560749$var$$b;
var $babc33424e560749$export$aa726fb96ad3e039 = $babc33424e560749$var$cc;
var $babc33424e560749$export$26404658cda3ee02 = $babc33424e560749$var$X;
var $babc33424e560749$var$esm = {
    createWebChannelTransport: $babc33424e560749$export$66869136fc133c3a,
    ErrorCode: $babc33424e560749$export$d4e71bc0b80dc0fb,
    EventType: $babc33424e560749$export$3d7865934588d77e,
    WebChannel: $babc33424e560749$export$aa726fb96ad3e039,
    XhrIo: $babc33424e560749$export$26404658cda3ee02
};
var $babc33424e560749$export$2e2bcd8739ae039 = $babc33424e560749$var$esm;



var $gLWqF = parcelRequire("gLWqF");
function $6c8154472dd99012$var$s(t) {
    return t && "object" == typeof t && "default" in t ? t : {
        default: t
    };
}
var $6c8154472dd99012$var$u = $6c8154472dd99012$var$s($31dJ8), $6c8154472dd99012$var$a = {
    // Causes are copied from:
    // https://github.com/grpc/grpc/blob/bceec94ea4fc5f0085d81235d8e1c06798dc341a/include/grpc%2B%2B/impl/codegen/status_code_enum.h
    /** Not an error; returned on success. */ OK: "ok",
    /** The operation was cancelled (typically by the caller). */ CANCELLED: "cancelled",
    /** Unknown error or an error from a different error domain. */ UNKNOWN: "unknown",
    /**
     * Client specified an invalid argument. Note that this differs from
     * FAILED_PRECONDITION. INVALID_ARGUMENT indicates arguments that are
     * problematic regardless of the state of the system (e.g., a malformed file
     * name).
     */ INVALID_ARGUMENT: "invalid-argument",
    /**
     * Deadline expired before operation could complete. For operations that
     * change the state of the system, this error may be returned even if the
     * operation has completed successfully. For example, a successful response
     * from a server could have been delayed long enough for the deadline to
     * expire.
     */ DEADLINE_EXCEEDED: "deadline-exceeded",
    /** Some requested entity (e.g., file or directory) was not found. */ NOT_FOUND: "not-found",
    /**
     * Some entity that we attempted to create (e.g., file or directory) already
     * exists.
     */ ALREADY_EXISTS: "already-exists",
    /**
     * The caller does not have permission to execute the specified operation.
     * PERMISSION_DENIED must not be used for rejections caused by exhausting
     * some resource (use RESOURCE_EXHAUSTED instead for those errors).
     * PERMISSION_DENIED must not be used if the caller can not be identified
     * (use UNAUTHENTICATED instead for those errors).
     */ PERMISSION_DENIED: "permission-denied",
    /**
     * The request does not have valid authentication credentials for the
     * operation.
     */ UNAUTHENTICATED: "unauthenticated",
    /**
     * Some resource has been exhausted, perhaps a per-user quota, or perhaps the
     * entire file system is out of space.
     */ RESOURCE_EXHAUSTED: "resource-exhausted",
    /**
     * Operation was rejected because the system is not in a state required for
     * the operation's execution. For example, directory to be deleted may be
     * non-empty, an rmdir operation is applied to a non-directory, etc.
     *
     * A litmus test that may help a service implementor in deciding
     * between FAILED_PRECONDITION, ABORTED, and UNAVAILABLE:
     *  (a) Use UNAVAILABLE if the client can retry just the failing call.
     *  (b) Use ABORTED if the client should retry at a higher-level
     *      (e.g., restarting a read-modify-write sequence).
     *  (c) Use FAILED_PRECONDITION if the client should not retry until
     *      the system state has been explicitly fixed. E.g., if an "rmdir"
     *      fails because the directory is non-empty, FAILED_PRECONDITION
     *      should be returned since the client should not retry unless
     *      they have first fixed up the directory by deleting files from it.
     *  (d) Use FAILED_PRECONDITION if the client performs conditional
     *      REST Get/Update/Delete on a resource and the resource on the
     *      server does not match the condition. E.g., conflicting
     *      read-modify-write on the same resource.
     */ FAILED_PRECONDITION: "failed-precondition",
    /**
     * The operation was aborted, typically due to a concurrency issue like
     * sequencer check failures, transaction aborts, etc.
     *
     * See litmus test above for deciding between FAILED_PRECONDITION, ABORTED,
     * and UNAVAILABLE.
     */ ABORTED: "aborted",
    /**
     * Operation was attempted past the valid range. E.g., seeking or reading
     * past end of file.
     *
     * Unlike INVALID_ARGUMENT, this error indicates a problem that may be fixed
     * if the system state changes. For example, a 32-bit file system will
     * generate INVALID_ARGUMENT if asked to read at an offset that is not in the
     * range [0,2^32-1], but it will generate OUT_OF_RANGE if asked to read from
     * an offset past the current file size.
     *
     * There is a fair bit of overlap between FAILED_PRECONDITION and
     * OUT_OF_RANGE. We recommend using OUT_OF_RANGE (the more specific error)
     * when it applies so that callers who are iterating through a space can
     * easily look for an OUT_OF_RANGE error to detect when they are done.
     */ OUT_OF_RANGE: "out-of-range",
    /** Operation is not implemented or not supported/enabled in this service. */ UNIMPLEMENTED: "unimplemented",
    /**
     * Internal errors. Means some invariants expected by underlying System has
     * been broken. If you see one of these errors, Something is very broken.
     */ INTERNAL: "internal",
    /**
     * The service is currently unavailable. This is a most likely a transient
     * condition and may be corrected by retrying with a backoff.
     *
     * See litmus test above for deciding between FAILED_PRECONDITION, ABORTED,
     * and UNAVAILABLE.
     */ UNAVAILABLE: "unavailable",
    /** Unrecoverable data loss or corruption. */ DATA_LOSS: "data-loss"
}, $6c8154472dd99012$var$c = /** @class */ function(e) {
    function n(t, n) {
        var r = this;
        return (r = e.call(this, n) || this).code = t, r.message = n, r.name = "FirebaseError", // HACK: We write a toString property directly because Error is not a real
        // class and so inheritance does not work correctly. We could alternatively
        // do the same "back-door inheritance" trick that FirebaseError does.
        r.toString = function() {
            return r.name + ": [code=" + r.code + "]: " + r.message;
        }, r;
    }
    return $876a70688d8d7977$export$a8ba968b8961cb8a(n, e), n;
}(Error), $6c8154472dd99012$var$h = new $d4M6f.Logger("@firebase/firestore");
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Converts a Base64 encoded string to a binary string. */ /**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Helper methods are needed because variables can't be exported as read/write
function $6c8154472dd99012$var$f() {
    return $6c8154472dd99012$var$h.logLevel;
}
/**
 * Sets the verbosity of Cloud Firestore logs (debug, error, or silent).
 *
 * @param logLevel
 *   The verbosity you set for activity and error logging. Can be any of
 *   the following values:
 *
 *   <ul>
 *     <li>`debug` for the most verbose logging level, primarily for
 *     debugging.</li>
 *     <li>`error` to log errors only.</li>
 *     <li><code>`silent` to turn off logging.</li>
 *   </ul>
 */ function $6c8154472dd99012$var$l(e) {
    for(var r = [], i = 1; i < arguments.length; i++)r[i - 1] = arguments[i];
    if ($6c8154472dd99012$var$h.logLevel <= $d4M6f.LogLevel.DEBUG) {
        var o = r.map($6c8154472dd99012$var$v);
        $6c8154472dd99012$var$h.debug.apply($6c8154472dd99012$var$h, $876a70688d8d7977$export$6388937ca91ccae8([
            "Firestore (7.24.0): " + e
        ], o));
    }
}
function $6c8154472dd99012$var$p(e) {
    for(var r = [], i = 1; i < arguments.length; i++)r[i - 1] = arguments[i];
    if ($6c8154472dd99012$var$h.logLevel <= $d4M6f.LogLevel.ERROR) {
        var o = r.map($6c8154472dd99012$var$v);
        $6c8154472dd99012$var$h.error.apply($6c8154472dd99012$var$h, $876a70688d8d7977$export$6388937ca91ccae8([
            "Firestore (7.24.0): " + e
        ], o));
    }
}
function $6c8154472dd99012$var$d(e) {
    for(var r = [], i = 1; i < arguments.length; i++)r[i - 1] = arguments[i];
    if ($6c8154472dd99012$var$h.logLevel <= $d4M6f.LogLevel.WARN) {
        var o = r.map($6c8154472dd99012$var$v);
        $6c8154472dd99012$var$h.warn.apply($6c8154472dd99012$var$h, $876a70688d8d7977$export$6388937ca91ccae8([
            "Firestore (7.24.0): " + e
        ], o));
    }
}
/**
 * Converts an additional log parameter to a string representation.
 */ function $6c8154472dd99012$var$v(t) {
    if ("string" == typeof t) return t;
    try {
        return e = t, JSON.stringify(e);
    } catch (e) {
        // Converting to JSON failed, just log the object directly
        return t;
    }
    /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Formats an object as a JSON string, suitable for logging. */ var e;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Unconditionally fails, throwing an Error with the given message.
 * Messages are stripped in production builds.
 *
 * Returns `never` and can be used in expressions:
 * @example
 * let futureVar = fail('not implemented yet');
 */ function $6c8154472dd99012$var$y(t) {
    void 0 === t && (t = "Unexpected state");
    // Log the failure in addition to throw an exception, just in case the
    // exception is swallowed.
    var e = "FIRESTORE (7.24.0) INTERNAL ASSERTION FAILED: " + t;
    // NOTE: We don't use FirestoreError here because these are internal failures
    // that cannot be handled by the user. (Also it would create a circular
    // dependency between the error and assert modules which doesn't work.)
    throw $6c8154472dd99012$var$p(e), new Error(e) /**
 * Fails if the given assertion condition is false, throwing an Error with the
 * given message if it did.
 *
 * Messages are stripped in production builds.
 */ ;
}
function $6c8154472dd99012$var$g(t, e) {
    t || $6c8154472dd99012$var$y();
}
/**
 * Casts `obj` to `T`. In non-production builds, verifies that `obj` is an
 * instance of `T` before casting.
 */ function $6c8154472dd99012$var$m(t, // eslint-disable-next-line @typescript-eslint/no-explicit-any
e) {
    return t;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $6c8154472dd99012$var$w(t) {
    var e = 0;
    for(var n in t)Object.prototype.hasOwnProperty.call(t, n) && e++;
    return e;
}
function $6c8154472dd99012$var$_(t, e) {
    for(var n in t)Object.prototype.hasOwnProperty.call(t, n) && e(n, t[n]);
}
function $6c8154472dd99012$var$b(t) {
    for(var e in t)if (Object.prototype.hasOwnProperty.call(t, e)) return !1;
    return !0;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Path represents an ordered sequence of string segments.
 */ var $6c8154472dd99012$var$I = /** @class */ function() {
    function t(t, e, n) {
        void 0 === e ? e = 0 : e > t.length && $6c8154472dd99012$var$y(), void 0 === n ? n = t.length - e : n > t.length - e && $6c8154472dd99012$var$y(), this.segments = t, this.offset = e, this.t = n;
    }
    return Object.defineProperty(t.prototype, "length", {
        get: function() {
            return this.t;
        },
        enumerable: !1,
        configurable: !0
    }), t.prototype.isEqual = function(e) {
        return 0 === t.i(this, e);
    }, t.prototype.child = function(e) {
        var n = this.segments.slice(this.offset, this.limit());
        return e instanceof t ? e.forEach(function(t) {
            n.push(t);
        }) : n.push(e), this.o(n);
    }, /** The index of one past the last segment of the path. */ t.prototype.limit = function() {
        return this.offset + this.length;
    }, t.prototype.u = function(t) {
        return t = void 0 === t ? 1 : t, this.o(this.segments, this.offset + t, this.length - t);
    }, t.prototype.h = function() {
        return this.o(this.segments, this.offset, this.length - 1);
    }, t.prototype.l = function() {
        return this.segments[this.offset];
    }, t.prototype._ = function() {
        return this.get(this.length - 1);
    }, t.prototype.get = function(t) {
        return this.segments[this.offset + t];
    }, t.prototype.m = function() {
        return 0 === this.length;
    }, t.prototype.T = function(t) {
        if (t.length < this.length) return !1;
        for(var e = 0; e < this.length; e++)if (this.get(e) !== t.get(e)) return !1;
        return !0;
    }, t.prototype.I = function(t) {
        if (this.length + 1 !== t.length) return !1;
        for(var e = 0; e < this.length; e++)if (this.get(e) !== t.get(e)) return !1;
        return !0;
    }, t.prototype.forEach = function(t) {
        for(var e = this.offset, n = this.limit(); e < n; e++)t(this.segments[e]);
    }, t.prototype.A = function() {
        return this.segments.slice(this.offset, this.limit());
    }, t.i = function(t, e) {
        for(var n = Math.min(t.length, e.length), r = 0; r < n; r++){
            var i = t.get(r), o = e.get(r);
            if (i < o) return -1;
            if (i > o) return 1;
        }
        return t.length < e.length ? -1 : t.length > e.length ? 1 : 0;
    }, t;
}(), $6c8154472dd99012$var$E = /** @class */ function(e) {
    function n() {
        return null !== e && e.apply(this, arguments) || this;
    }
    return $876a70688d8d7977$export$a8ba968b8961cb8a(n, e), n.prototype.o = function(t, e, r) {
        return new n(t, e, r);
    }, n.prototype.R = function() {
        // NOTE: The client is ignorant of any path segments containing escape
        // sequences (e.g. __id123__) and just passes them through raw (they exist
        // for legacy reasons and should not be used frequently).
        return this.A().join("/");
    }, n.prototype.toString = function() {
        return this.R();
    }, /**
     * Creates a resource path from the given slash-delimited string. If multiple
     * arguments are provided, all components are combined. Leading and trailing
     * slashes from all components are ignored.
     */ n.g = function() {
        for(var t = [], e = 0; e < arguments.length; e++)t[e] = arguments[e];
        // NOTE: The client is ignorant of any path segments containing escape
        // sequences (e.g. __id123__) and just passes them through raw (they exist
        // for legacy reasons and should not be used frequently).
        for(var r = [], i = 0, o = t; i < o.length; i++){
            var s = o[i];
            if (s.indexOf("//") >= 0) throw new $6c8154472dd99012$var$c($6c8154472dd99012$var$a.INVALID_ARGUMENT, "Invalid segment (" + s + "). Paths must not contain // in them.");
            // Strip leading and traling slashed.
            r.push.apply(r, s.split("/").filter(function(t) {
                return t.length > 0;
            }));
        }
        return new n(r);
    }, n.P = function() {
        return new n([]);
    }, n;
}($6c8154472dd99012$var$I), $6c8154472dd99012$var$T = /^[_a-zA-Z][_a-zA-Z0-9]*$/, $6c8154472dd99012$var$N = /** @class */ function(e) {
    function n() {
        return null !== e && e.apply(this, arguments) || this;
    }
    return $876a70688d8d7977$export$a8ba968b8961cb8a(n, e), n.prototype.o = function(t, e, r) {
        return new n(t, e, r);
    }, /**
     * Returns true if the string could be used as a segment in a field path
     * without escaping.
     */ n.V = function(t) {
        return $6c8154472dd99012$var$T.test(t);
    }, n.prototype.R = function() {
        return this.A().map(function(t) {
            return t = t.replace("\\", "\\\\").replace("`", "\\`"), n.V(t) || (t = "`" + t + "`"), t;
        }).join(".");
    }, n.prototype.toString = function() {
        return this.R();
    }, /**
     * Returns true if this field references the key of a document.
     */ n.prototype.p = function() {
        return 1 === this.length && "__name__" === this.get(0);
    }, /**
     * The field designating the key of a document.
     */ n.v = function() {
        return new n([
            "__name__"
        ]);
    }, /**
     * Parses a field string from the given server-formatted string.
     *
     * - Splitting the empty string is not allowed (for now at least).
     * - Empty segments within the string (e.g. if there are two consecutive
     *   separators) are not allowed.
     *
     * TODO(b/37244157): we should make this more strict. Right now, it allows
     * non-identifier path components, even if they aren't escaped.
     */ n.S = function(t) {
        for(var e = [], r = "", i = 0, o = function() {
            if (0 === r.length) throw new $6c8154472dd99012$var$c($6c8154472dd99012$var$a.INVALID_ARGUMENT, "Invalid field path (" + t + "). Paths must not be empty, begin with '.', end with '.', or contain '..'");
            e.push(r), r = "";
        }, s = !1; i < t.length;){
            var u = t[i];
            if ("\\" === u) {
                if (i + 1 === t.length) throw new $6c8154472dd99012$var$c($6c8154472dd99012$var$a.INVALID_ARGUMENT, "Path has trailing escape character: " + t);
                var h = t[i + 1];
                if ("\\" !== h && "." !== h && "`" !== h) throw new $6c8154472dd99012$var$c($6c8154472dd99012$var$a.INVALID_ARGUMENT, "Path has invalid escape sequence: " + t);
                r += h, i += 2;
            } else "`" === u ? (s = !s, i++) : "." !== u || s ? (r += u, i++) : (o(), i++);
        }
        if (o(), s) throw new $6c8154472dd99012$var$c($6c8154472dd99012$var$a.INVALID_ARGUMENT, "Unterminated ` in path: " + t);
        return new n(e);
    }, n.P = function() {
        return new n([]);
    }, n;
}($6c8154472dd99012$var$I), $6c8154472dd99012$var$A = /** @class */ function() {
    function t(t) {
        this.path = t;
    }
    return t.D = function(e) {
        return new t($6c8154472dd99012$var$E.g(e));
    }, t.C = function(e) {
        return new t($6c8154472dd99012$var$E.g(e).u(5));
    }, /** Returns true if the document is in the specified collectionId. */ t.prototype.N = function(t) {
        return this.path.length >= 2 && this.path.get(this.path.length - 2) === t;
    }, t.prototype.isEqual = function(t) {
        return null !== t && 0 === $6c8154472dd99012$var$E.i(this.path, t.path);
    }, t.prototype.toString = function() {
        return this.path.toString();
    }, t.i = function(t, e) {
        return $6c8154472dd99012$var$E.i(t.path, e.path);
    }, t.F = function(t) {
        return t.length % 2 == 0;
    }, /**
     * Creates and returns a new document key with the given segments.
     *
     * @param segments The segments of the path to the document
     * @return A new instance of DocumentKey
     */ t.$ = function(e) {
        return new t(new $6c8154472dd99012$var$E(e.slice()));
    }, t;
}();
/**
 * A slash-separated path for navigating resources (documents and collections)
 * within Firestore.
 */ /**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Validates that no arguments were passed in the invocation of functionName.
 *
 * Forward the magic "arguments" variable as second parameter on which the
 * parameter validation is performed:
 * validateNoArgs('myFunction', arguments);
 */ function $6c8154472dd99012$var$S(t, e) {
    if (0 !== e.length) throw new $6c8154472dd99012$var$c($6c8154472dd99012$var$a.INVALID_ARGUMENT, "Function " + t + "() does not support arguments, but was called with " + $6c8154472dd99012$var$W(e.length, "argument") + ".");
}
/**
 * Validates the invocation of functionName has the exact number of arguments.
 *
 * Forward the magic "arguments" variable as second parameter on which the
 * parameter validation is performed:
 * validateExactNumberOfArgs('myFunction', arguments, 2);
 */ function $6c8154472dd99012$var$D(t, e, n) {
    if (e.length !== n) throw new $6c8154472dd99012$var$c($6c8154472dd99012$var$a.INVALID_ARGUMENT, "Function " + t + "() requires " + $6c8154472dd99012$var$W(n, "argument") + ", but was called with " + $6c8154472dd99012$var$W(e.length, "argument") + ".");
}
/**
 * Validates the invocation of functionName has at least the provided number of
 * arguments (but can have many more).
 *
 * Forward the magic "arguments" variable as second parameter on which the
 * parameter validation is performed:
 * validateAtLeastNumberOfArgs('myFunction', arguments, 2);
 */ function $6c8154472dd99012$var$x(t, e, n) {
    if (e.length < n) throw new $6c8154472dd99012$var$c($6c8154472dd99012$var$a.INVALID_ARGUMENT, "Function " + t + "() requires at least " + $6c8154472dd99012$var$W(n, "argument") + ", but was called with " + $6c8154472dd99012$var$W(e.length, "argument") + ".");
}
/**
 * Validates the invocation of functionName has number of arguments between
 * the values provided.
 *
 * Forward the magic "arguments" variable as second parameter on which the
 * parameter validation is performed:
 * validateBetweenNumberOfArgs('myFunction', arguments, 2, 3);
 */ function $6c8154472dd99012$var$L(t, e, n, r) {
    if (e.length < n || e.length > r) throw new $6c8154472dd99012$var$c($6c8154472dd99012$var$a.INVALID_ARGUMENT, "Function " + t + "() requires between " + n + " and " + r + " arguments, but was called with " + $6c8154472dd99012$var$W(e.length, "argument") + ".");
}
/**
 * Validates the provided argument is an array and has as least the expected
 * number of elements.
 */ /**
 * Validates the provided positional argument has the native JavaScript type
 * using typeof checks.
 */ function $6c8154472dd99012$var$k(t, e, n, r) {
    $6c8154472dd99012$var$C(t, e, $6c8154472dd99012$var$B(n) + " argument", r);
}
/**
 * Validates the provided argument has the native JavaScript type using
 * typeof checks or is undefined.
 */ function $6c8154472dd99012$var$R(t, e, n, r) {
    void 0 !== r && $6c8154472dd99012$var$k(t, e, n, r);
}
/**
 * Validates the provided named option has the native JavaScript type using
 * typeof checks.
 */ function $6c8154472dd99012$var$O(t, e, n, r) {
    $6c8154472dd99012$var$C(t, e, n + " option", r);
}
/**
 * Validates the provided named option has the native JavaScript type using
 * typeof checks or is undefined.
 */ function $6c8154472dd99012$var$P(t, e, n, r) {
    void 0 !== r && $6c8154472dd99012$var$O(t, e, n, r);
}
/**
 * Validates that two boolean options are not set at the same time.
 */ /**
 * Validates that the provided named option equals one of the expected values.
 */ /**
 * Validates that the provided named option equals one of the expected values or
 * is undefined.
 */ function $6c8154472dd99012$var$V(t, e, n, r, i) {
    void 0 !== r && function(t, e, n, r, i) {
        for(var o = [], s = 0, u = i; s < u.length; s++){
            var h = u[s];
            if (h === r) return;
            o.push($6c8154472dd99012$var$M(h));
        }
        var f = $6c8154472dd99012$var$M(r);
        throw new $6c8154472dd99012$var$c($6c8154472dd99012$var$a.INVALID_ARGUMENT, "Invalid value " + f + " provided to function " + t + '() for option "' + n + '". Acceptable values: ' + o.join(", "));
    }(t, 0, n, r, i);
}
/**
 * Validates that the provided argument is a valid enum.
 *
 * @param functionName Function making the validation call.
 * @param enums Array containing all possible values for the enum.
 * @param position Position of the argument in `functionName`.
 * @param argument Argument to validate.
 * @return The value as T if the argument can be converted.
 */ function $6c8154472dd99012$var$U(t, e, n, r) {
    if (!e.some(function(t) {
        return t === r;
    })) throw new $6c8154472dd99012$var$c($6c8154472dd99012$var$a.INVALID_ARGUMENT, "Invalid value " + $6c8154472dd99012$var$M(r) + " provided to function " + t + "() for its " + $6c8154472dd99012$var$B(n) + " argument. Acceptable values: " + e.join(", "));
    return r;
}
/** Helper to validate the type of a provided input. */ function $6c8154472dd99012$var$C(t, e, n, r) {
    if (!("object" === e ? $6c8154472dd99012$var$F(r) : "non-empty string" === e ? "string" == typeof r && "" !== r : typeof r === e)) {
        var i = $6c8154472dd99012$var$M(r);
        throw new $6c8154472dd99012$var$c($6c8154472dd99012$var$a.INVALID_ARGUMENT, "Function " + t + "() requires its " + n + " to be of type " + e + ", but it was: " + i);
    }
}
/**
 * Returns true if it's a non-null object without a custom prototype
 * (i.e. excludes Array, Date, etc.).
 */ function $6c8154472dd99012$var$F(t) {
    return "object" == typeof t && null !== t && (Object.getPrototypeOf(t) === Object.prototype || null === Object.getPrototypeOf(t));
}
/** Returns a string describing the type / value of the provided input. */ function $6c8154472dd99012$var$M(t) {
    if (void 0 === t) return "undefined";
    if (null === t) return "null";
    if ("string" == typeof t) return t.length > 20 && (t = t.substring(0, 20) + "..."), JSON.stringify(t);
    if ("number" == typeof t || "boolean" == typeof t) return "" + t;
    if ("object" == typeof t) {
        if (t instanceof Array) return "an array";
        var e = /** Hacky method to try to get the constructor name for an object. */ function(t) {
            if (t.constructor) {
                var e = /function\s+([^\s(]+)\s*\(/.exec(t.constructor.toString());
                if (e && e.length > 1) return e[1];
            }
            return null;
        }(t);
        return e ? "a custom " + e + " object" : "an object";
    }
    return "function" == typeof t ? "a function" : $6c8154472dd99012$var$y();
}
function $6c8154472dd99012$var$q(t, e, n) {
    if (void 0 === n) throw new $6c8154472dd99012$var$c($6c8154472dd99012$var$a.INVALID_ARGUMENT, "Function " + t + "() requires a valid " + $6c8154472dd99012$var$B(e) + " argument, but it was undefined.");
}
/**
 * Validates the provided positional argument is an object, and its keys and
 * values match the expected keys and types provided in optionTypes.
 */ function $6c8154472dd99012$var$j(t, e, n) {
    $6c8154472dd99012$var$_(e, function(e, r) {
        if (n.indexOf(e) < 0) throw new $6c8154472dd99012$var$c($6c8154472dd99012$var$a.INVALID_ARGUMENT, "Unknown option '" + e + "' passed to function " + t + "(). Available options: " + n.join(", "));
    });
}
/**
 * Helper method to throw an error that the provided argument did not pass
 * an instanceof check.
 */ function $6c8154472dd99012$var$G(t, e, n, r) {
    var i = $6c8154472dd99012$var$M(r);
    return new $6c8154472dd99012$var$c($6c8154472dd99012$var$a.INVALID_ARGUMENT, "Function " + t + "() requires its " + $6c8154472dd99012$var$B(n) + " argument to be a " + e + ", but it was: " + i);
}
function $6c8154472dd99012$var$z(t, e, n) {
    if (n <= 0) throw new $6c8154472dd99012$var$c($6c8154472dd99012$var$a.INVALID_ARGUMENT, "Function " + t + "() requires its " + $6c8154472dd99012$var$B(e) + " argument to be a positive number, but it was: " + n + ".");
}
/** Converts a number to its english word representation */ function $6c8154472dd99012$var$B(t) {
    switch(t){
        case 1:
            return "first";
        case 2:
            return "second";
        case 3:
            return "third";
        default:
            return t + "th";
    }
}
/**
 * Formats the given word as plural conditionally given the preceding number.
 */ function $6c8154472dd99012$var$W(t, e) {
    return t + " " + e + (1 === t ? "" : "s");
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Generates `nBytes` of random bytes.
 *
 * If `nBytes < 0` , an error will be thrown.
 */ function $6c8154472dd99012$var$K(t) {
    // Polyfills for IE and WebWorker by using `self` and `msCrypto` when `crypto` is not available.
    var e = // eslint-disable-next-line @typescript-eslint/no-explicit-any
    "undefined" != typeof self && (self.crypto || self.msCrypto), n = new Uint8Array(t);
    if (e && "function" == typeof e.getRandomValues) e.getRandomValues(n);
    else // Falls back to Math.random
    for(var r = 0; r < t; r++)n[r] = Math.floor(256 * Math.random());
    return n;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $6c8154472dd99012$var$Q = /** @class */ function() {
    function t() {}
    return t.k = function() {
        for(// Alphanumeric characters
        var t = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789", e = Math.floor(256 / t.length) * t.length, n = ""; n.length < 20;)for(var r = $6c8154472dd99012$var$K(40), i = 0; i < r.length; ++i)// Only accept values that are [0, maxMultiple), this ensures they can
        // be evenly mapped to indices of `chars` via a modulo operation.
        n.length < 20 && r[i] < e && (n += t.charAt(r[i] % t.length));
        return n;
    }, t;
}();
function $6c8154472dd99012$var$H(t, e) {
    return t < e ? -1 : t > e ? 1 : 0;
}
/** Helper to compare arrays using isEqual(). */ function $6c8154472dd99012$var$Y(t, e, n) {
    return t.length === e.length && t.every(function(t, r) {
        return n(t, e[r]);
    });
}
/**
 * Returns the immediate lexicographically-following string. This is useful to
 * construct an inclusive range for indexeddb iterators.
 */ function $6c8154472dd99012$var$$(t) {
    // Return the input string, with an additional NUL byte appended.
    return t + "\x00";
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Immutable class that represents a "proto" byte string.
 *
 * Proto byte strings can either be Base64-encoded strings or Uint8Arrays when
 * sent on the wire. This class abstracts away this differentiation by holding
 * the proto byte string in a common class that must be converted into a string
 * before being sent as a proto.
 */ var $6c8154472dd99012$var$X = /** @class */ function() {
    function t(t) {
        this.M = t;
    }
    return t.fromBase64String = function(e) {
        return new t(atob(e));
    }, t.fromUint8Array = function(e) {
        return new t(/**
 * Helper function to convert an Uint8array to a binary string.
 */ function(t) {
            for(var e = "", n = 0; n < t.length; ++n)e += String.fromCharCode(t[n]);
            return e;
        }(e));
    }, t.prototype.toBase64 = function() {
        var t;
        return t = this.M, btoa(t);
    /** True if and only if the Base64 conversion functions are available. */ }, t.prototype.toUint8Array = function() {
        return function(t) {
            for(var e = new Uint8Array(t.length), n = 0; n < t.length; n++)e[n] = t.charCodeAt(n);
            return e;
        }(this.M);
    }, t.prototype.O = function() {
        return 2 * this.M.length;
    }, t.prototype.L = function(t) {
        return $6c8154472dd99012$var$H(this.M, t.M);
    }, t.prototype.isEqual = function(t) {
        return this.M === t.M;
    }, t;
}();
$6c8154472dd99012$var$X.B = new $6c8154472dd99012$var$X("");
var $6c8154472dd99012$var$J = /** @class */ function() {
    function t(t) {
        this.q = t;
    }
    /**
     * Creates a new `Bytes` object from the given Base64 string, converting it to
     * bytes.
     *
     * @param base64 The Base64 string used to create the `Bytes` object.
     */ return t.fromBase64String = function(e) {
        try {
            return new t($6c8154472dd99012$var$X.fromBase64String(e));
        } catch (e) {
            throw new $6c8154472dd99012$var$c($6c8154472dd99012$var$a.INVALID_ARGUMENT, "Failed to construct Bytes from Base64 string: " + e);
        }
    }, /**
     * Creates a new `Bytes` object from the given Uint8Array.
     *
     * @param array The Uint8Array used to create the `Bytes` object.
     */ t.fromUint8Array = function(e) {
        return new t($6c8154472dd99012$var$X.fromUint8Array(e));
    }, /**
     * Returns the underlying bytes as a Base64-encoded string.
     *
     * @return The Base64-encoded string created from the `Bytes` object.
     */ t.prototype.toBase64 = function() {
        return this.q.toBase64();
    }, /**
     * Returns the underlying bytes in a new `Uint8Array`.
     *
     * @return The Uint8Array created from the `Bytes` object.
     */ t.prototype.toUint8Array = function() {
        return this.q.toUint8Array();
    }, /**
     * Returns a string representation of the `Bytes` object.
     *
     * @return A string representation of the `Bytes` object.
     */ t.prototype.toString = function() {
        return "Bytes(base64: " + this.toBase64() + ")";
    }, /**
     * Returns true if this `Bytes` object is equal to the provided one.
     *
     * @param other The `Bytes` object to compare against.
     * @return true if this `Bytes` object is equal to the provided one.
     */ t.prototype.isEqual = function(t) {
        return this.q.isEqual(t.q);
    }, t;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Helper function to assert Uint8Array is available at runtime. */ function $6c8154472dd99012$var$Z() {
    if ("undefined" == typeof Uint8Array) throw new $6c8154472dd99012$var$c($6c8154472dd99012$var$a.UNIMPLEMENTED, "Uint8Arrays are not available in this environment.");
}
/** Helper function to assert Base64 functions are available at runtime. */ function $6c8154472dd99012$var$tt() {
    if ("undefined" == typeof atob) throw new $6c8154472dd99012$var$c($6c8154472dd99012$var$a.UNIMPLEMENTED, "Blobs are unavailable in Firestore in this environment.");
}
/**
 * Immutable class holding a blob (binary data).
 *
 * This class is directly exposed in the public API. It extends the Bytes class
 * of the firestore-exp API to support `instanceof Bytes` checks during user
 * data conversion.
 *
 * Note that while you can't hide the constructor in JavaScript code, we are
 * using the hack above to make sure no-one outside this module can call it.
 */ var $6c8154472dd99012$var$et = /** @class */ function(e) {
    function n() {
        return null !== e && e.apply(this, arguments) || this;
    }
    return $876a70688d8d7977$export$a8ba968b8961cb8a(n, e), n.fromBase64String = function(t) {
        $6c8154472dd99012$var$D("Blob.fromBase64String", arguments, 1), $6c8154472dd99012$var$k("Blob.fromBase64String", "string", 1, t), $6c8154472dd99012$var$tt();
        try {
            return new n($6c8154472dd99012$var$X.fromBase64String(t));
        } catch (t) {
            throw new $6c8154472dd99012$var$c($6c8154472dd99012$var$a.INVALID_ARGUMENT, "Failed to construct Blob from Base64 string: " + t);
        }
    }, n.fromUint8Array = function(t) {
        if ($6c8154472dd99012$var$D("Blob.fromUint8Array", arguments, 1), $6c8154472dd99012$var$Z(), !(t instanceof Uint8Array)) throw $6c8154472dd99012$var$G("Blob.fromUint8Array", "Uint8Array", 1, t);
        return new n($6c8154472dd99012$var$X.fromUint8Array(t));
    }, n.prototype.toBase64 = function() {
        return $6c8154472dd99012$var$D("Blob.toBase64", arguments, 0), $6c8154472dd99012$var$tt(), e.prototype.toBase64.call(this);
    }, n.prototype.toUint8Array = function() {
        return $6c8154472dd99012$var$D("Blob.toUint8Array", arguments, 0), $6c8154472dd99012$var$Z(), e.prototype.toUint8Array.call(this);
    }, n.prototype.toString = function() {
        return "Blob(base64: " + this.toBase64() + ")";
    }, n;
}($6c8154472dd99012$var$J), $6c8154472dd99012$var$nt = /**
     * Constructs a DatabaseInfo using the provided host, databaseId and
     * persistenceKey.
     *
     * @param databaseId The database to use.
     * @param persistenceKey A unique identifier for this Firestore's local
     * storage (used in conjunction with the databaseId).
     * @param host The Firestore backend host to connect to.
     * @param ssl Whether to use SSL when connecting.
     * @param forceLongPolling Whether to use the forceLongPolling option
     * when using WebChannel as the network transport.
     * @param autoDetectLongPolling Whether to use the detectBufferingProxy
     * option when using WebChannel as the network transport.
     */ function(t, e, n, r, i, o) {
    this.U = t, this.persistenceKey = e, this.host = n, this.ssl = r, this.forceLongPolling = i, this.W = o;
}, $6c8154472dd99012$var$rt = /** @class */ function() {
    function t(t, e) {
        this.projectId = t, this.database = e || "(default)";
    }
    return Object.defineProperty(t.prototype, "j", {
        get: function() {
            return "(default)" === this.database;
        },
        enumerable: !1,
        configurable: !0
    }), t.prototype.isEqual = function(e) {
        return e instanceof t && e.projectId === this.projectId && e.database === this.database;
    }, t.prototype.L = function(t) {
        return $6c8154472dd99012$var$H(this.projectId, t.projectId) || $6c8154472dd99012$var$H(this.database, t.database);
    }, t;
}(), $6c8154472dd99012$var$it = /** @class */ function() {
    function t(t, e) {
        this.K = t, this.G = e, /**
             * The inner map for a key -> value pair. Due to the possibility of
             * collisions we keep a list of entries that we do a linear search through
             * to find an actual match. Note that collisions should be rare, so we still
             * expect near constant time lookups in practice.
             */ this.H = {} /** Get a value for this key, or undefined if it does not exist. */ ;
    }
    return t.prototype.get = function(t) {
        var e = this.K(t), n = this.H[e];
        if (void 0 !== n) for(var r = 0, i = n; r < i.length; r++){
            var o = i[r], s = o[0], u = o[1];
            if (this.G(s, t)) return u;
        }
    }, t.prototype.has = function(t) {
        return void 0 !== this.get(t);
    }, /** Put this key and value in the map. */ t.prototype.set = function(t, e) {
        var n = this.K(t), r = this.H[n];
        if (void 0 !== r) {
            for(var i = 0; i < r.length; i++)if (this.G(r[i][0], t)) return void (r[i] = [
                t,
                e
            ]);
            r.push([
                t,
                e
            ]);
        } else this.H[n] = [
            [
                t,
                e
            ]
        ];
    }, /**
     * Remove this key from the map. Returns a boolean if anything was deleted.
     */ t.prototype.delete = function(t) {
        var e = this.K(t), n = this.H[e];
        if (void 0 === n) return !1;
        for(var r = 0; r < n.length; r++)if (this.G(n[r][0], t)) return 1 === n.length ? delete this.H[e] : n.splice(r, 1), !0;
        return !1;
    }, t.prototype.forEach = function(t) {
        $6c8154472dd99012$var$_(this.H, function(e, n) {
            for(var r = 0, i = n; r < i.length; r++){
                var o = i[r], s = o[0], u = o[1];
                t(s, u);
            }
        });
    }, t.prototype.m = function() {
        return $6c8154472dd99012$var$b(this.H);
    }, t;
}(), $6c8154472dd99012$var$ot = /** @class */ function() {
    /**
     * Creates a new timestamp.
     *
     * @param seconds The number of seconds of UTC time since Unix epoch
     *     1970-01-01T00:00:00Z. Must be from 0001-01-01T00:00:00Z to
     *     9999-12-31T23:59:59Z inclusive.
     * @param nanoseconds The non-negative fractions of a second at nanosecond
     *     resolution. Negative second values with fractions must still have
     *     non-negative nanoseconds values that count forward in time. Must be
     *     from 0 to 999,999,999 inclusive.
     */ function t(t, e) {
        if (this.seconds = t, this.nanoseconds = e, e < 0) throw new $6c8154472dd99012$var$c($6c8154472dd99012$var$a.INVALID_ARGUMENT, "Timestamp nanoseconds out of range: " + e);
        if (e >= 1e9) throw new $6c8154472dd99012$var$c($6c8154472dd99012$var$a.INVALID_ARGUMENT, "Timestamp nanoseconds out of range: " + e);
        if (t < -62135596800) throw new $6c8154472dd99012$var$c($6c8154472dd99012$var$a.INVALID_ARGUMENT, "Timestamp seconds out of range: " + t);
        // This will break in the year 10,000.
        if (t >= 253402300800) throw new $6c8154472dd99012$var$c($6c8154472dd99012$var$a.INVALID_ARGUMENT, "Timestamp seconds out of range: " + t);
    }
    /**
     * Creates a new timestamp with the current date, with millisecond precision.
     *
     * @return a new timestamp representing the current date.
     */ return t.now = function() {
        return t.fromMillis(Date.now());
    }, /**
     * Creates a new timestamp from the given date.
     *
     * @param date The date to initialize the `Timestamp` from.
     * @return A new `Timestamp` representing the same point in time as the given
     *     date.
     */ t.fromDate = function(e) {
        return t.fromMillis(e.getTime());
    }, /**
     * Creates a new timestamp from the given number of milliseconds.
     *
     * @param milliseconds Number of milliseconds since Unix epoch
     *     1970-01-01T00:00:00Z.
     * @return A new `Timestamp` representing the same point in time as the given
     *     number of milliseconds.
     */ t.fromMillis = function(e) {
        var n = Math.floor(e / 1e3);
        return new t(n, 1e6 * (e - 1e3 * n));
    }, /**
     * Converts a `Timestamp` to a JavaScript `Date` object. This conversion causes
     * a loss of precision since `Date` objects only support millisecond precision.
     *
     * @return JavaScript `Date` object representing the same point in time as
     *     this `Timestamp`, with millisecond precision.
     */ t.prototype.toDate = function() {
        return new Date(this.toMillis());
    }, /**
     * Converts a `Timestamp` to a numeric timestamp (in milliseconds since
     * epoch). This operation causes a loss of precision.
     *
     * @return The point in time corresponding to this timestamp, represented as
     *     the number of milliseconds since Unix epoch 1970-01-01T00:00:00Z.
     */ t.prototype.toMillis = function() {
        return 1e3 * this.seconds + this.nanoseconds / 1e6;
    }, t.prototype.Y = function(t) {
        return this.seconds === t.seconds ? $6c8154472dd99012$var$H(this.nanoseconds, t.nanoseconds) : $6c8154472dd99012$var$H(this.seconds, t.seconds);
    }, /**
     * Returns true if this `Timestamp` is equal to the provided one.
     *
     * @param other The `Timestamp` to compare against.
     * @return true if this `Timestamp` is equal to the provided one.
     */ t.prototype.isEqual = function(t) {
        return t.seconds === this.seconds && t.nanoseconds === this.nanoseconds;
    }, t.prototype.toString = function() {
        return "Timestamp(seconds=" + this.seconds + ", nanoseconds=" + this.nanoseconds + ")";
    }, t.prototype.toJSON = function() {
        return {
            seconds: this.seconds,
            nanoseconds: this.nanoseconds
        };
    }, /**
     * Converts this object to a primitive string, which allows Timestamp objects to be compared
     * using the `>`, `<=`, `>=` and `>` operators.
     */ t.prototype.valueOf = function() {
        // This method returns a string of the form <seconds>.<nanoseconds> where <seconds> is
        // translated to have a non-negative value and both <seconds> and <nanoseconds> are left-padded
        // with zeroes to be a consistent length. Strings with this format then have a lexiographical
        // ordering that matches the expected ordering. The <seconds> translation is done to avoid
        // having a leading negative sign (i.e. a leading '-' character) in its string representation,
        // which would affect its lexiographical ordering.
        var t = this.seconds - -62135596800;
        // Note: Up to 12 decimal digits are required to represent all valid 'seconds' values.
        return String(t).padStart(12, "0") + "." + String(this.nanoseconds).padStart(9, "0");
    }, t;
}(), $6c8154472dd99012$var$st = /** @class */ function() {
    function t(t) {
        this.timestamp = t;
    }
    return t.J = function(e) {
        return new t(e);
    }, t.min = function() {
        return new t(new $6c8154472dd99012$var$ot(0, 0));
    }, t.prototype.L = function(t) {
        return this.timestamp.Y(t.timestamp);
    }, t.prototype.isEqual = function(t) {
        return this.timestamp.isEqual(t.timestamp);
    }, /** Returns a number representation of the version for use in spec tests. */ t.prototype.X = function() {
        // Convert to microseconds.
        return 1e6 * this.timestamp.seconds + this.timestamp.nanoseconds / 1e3;
    }, t.prototype.toString = function() {
        return "SnapshotVersion(" + this.timestamp.toString() + ")";
    }, t.prototype.Z = function() {
        return this.timestamp;
    }, t;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns whether a variable is either undefined or null.
 */ function $6c8154472dd99012$var$ut(t) {
    return null == t;
}
/** Returns whether the value represents -0. */ function $6c8154472dd99012$var$at(t) {
    // Detect if the value is -0.0. Based on polyfill from
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
    return 0 === t && 1 / t == -1 / 0;
}
/**
 * Returns whether a value is an integer and in the safe integer range
 * @param value The value to test for being an integer and in the safe range
 */ function $6c8154472dd99012$var$ct(t) {
    return "number" == typeof t && Number.isInteger(t) && !$6c8154472dd99012$var$at(t) && t <= Number.MAX_SAFE_INTEGER && t >= Number.MIN_SAFE_INTEGER;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Visible for testing
var $6c8154472dd99012$var$ht = function(t, e, n, r, i, o, s) {
    void 0 === e && (e = null), void 0 === n && (n = []), void 0 === r && (r = []), void 0 === i && (i = null), void 0 === o && (o = null), void 0 === s && (s = null), this.path = t, this.collectionGroup = e, this.orderBy = n, this.filters = r, this.limit = i, this.startAt = o, this.endAt = s, this.tt = null;
};
/**
 * Initializes a Target with a path and optional additional query constraints.
 * Path must currently be empty if this is a collection group query.
 *
 * NOTE: you should always construct `Target` from `Query.toTarget` instead of
 * using this factory method, because `Query` provides an implicit `orderBy`
 * property.
 */ function $6c8154472dd99012$var$ft(t, e, n, r, i, o, s) {
    return void 0 === e && (e = null), void 0 === n && (n = []), void 0 === r && (r = []), void 0 === i && (i = null), void 0 === o && (o = null), void 0 === s && (s = null), new $6c8154472dd99012$var$ht(t, e, n, r, i, o, s);
}
function $6c8154472dd99012$var$lt(t) {
    var e = $6c8154472dd99012$var$m(t);
    if (null === e.tt) {
        var n = e.path.R();
        null !== e.collectionGroup && (n += "|cg:" + e.collectionGroup), n += "|f:", n += e.filters.map(function(t) {
            return function(t) {
                // TODO(b/29183165): Technically, this won't be unique if two values have
                // the same description, such as the int 3 and the string "3". So we should
                // add the types in here somehow, too.
                return t.field.R() + t.op.toString() + $6c8154472dd99012$var$re(t.value);
            }(t);
        }).join(","), n += "|ob:", n += e.orderBy.map(function(t) {
            var e;
            return (e = t).field.R() + e.dir;
        }).join(","), $6c8154472dd99012$var$ut(e.limit) || (n += "|l:", n += e.limit), e.startAt && (n += "|lb:", n += $6c8154472dd99012$var$ar(e.startAt)), e.endAt && (n += "|ub:", n += $6c8154472dd99012$var$ar(e.endAt)), e.tt = n;
    }
    return e.tt;
}
function $6c8154472dd99012$var$pt(t, e) {
    if (t.limit !== e.limit) return !1;
    if (t.orderBy.length !== e.orderBy.length) return !1;
    for(var n = 0; n < t.orderBy.length; n++)if (!$6c8154472dd99012$var$pr(t.orderBy[n], e.orderBy[n])) return !1;
    if (t.filters.length !== e.filters.length) return !1;
    for(var r = 0; r < t.filters.length; r++)if (i = t.filters[r], o = e.filters[r], i.op !== o.op || !i.field.isEqual(o.field) || !$6c8154472dd99012$var$Zt(i.value, o.value)) return !1;
    var i, o;
    return t.collectionGroup === e.collectionGroup && !!t.path.isEqual(e.path) && !!$6c8154472dd99012$var$hr(t.startAt, e.startAt) && $6c8154472dd99012$var$hr(t.endAt, e.endAt);
}
function $6c8154472dd99012$var$dt(t) {
    return $6c8154472dd99012$var$A.F(t.path) && null === t.collectionGroup && 0 === t.filters.length;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An immutable set of metadata that the local store tracks for each target.
 */ var $6c8154472dd99012$var$vt, $6c8154472dd99012$var$yt, $6c8154472dd99012$var$gt = /** @class */ function() {
    function t(/** The target being listened to. */ t, /**
     * The target ID to which the target corresponds; Assigned by the
     * LocalStore for user listens and by the SyncEngine for limbo watches.
     */ e, /** The purpose of the target. */ n, /**
     * The sequence number of the last transaction during which this target data
     * was modified.
     */ r, /** The latest snapshot version seen for this target. */ i, o, s) {
        void 0 === i && (i = $6c8154472dd99012$var$st.min()), void 0 === o && (o = $6c8154472dd99012$var$st.min()), void 0 === s && (s = $6c8154472dd99012$var$X.B), this.target = t, this.targetId = e, this.et = n, this.sequenceNumber = r, this.nt = i, this.lastLimboFreeSnapshotVersion = o, this.resumeToken = s;
    }
    /** Creates a new target data instance with an updated sequence number. */ return t.prototype.st = function(e) {
        return new t(this.target, this.targetId, this.et, e, this.nt, this.lastLimboFreeSnapshotVersion, this.resumeToken);
    }, /**
     * Creates a new target data instance with an updated resume token and
     * snapshot version.
     */ t.prototype.it = function(e, n) {
        return new t(this.target, this.targetId, this.et, this.sequenceNumber, n, this.lastLimboFreeSnapshotVersion, e);
    }, /**
     * Creates a new target data instance with an updated last limbo free
     * snapshot version number.
     */ t.prototype.rt = function(e) {
        return new t(this.target, this.targetId, this.et, this.sequenceNumber, this.nt, e, this.resumeToken);
    }, t;
}(), $6c8154472dd99012$var$mt = // TODO(b/33078163): just use simplest form of existence filter for now
function(t) {
    this.count = t;
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Determines whether an error code represents a permanent error when received
 * in response to a non-write operation.
 *
 * See isPermanentWriteError for classifying write errors.
 */ function $6c8154472dd99012$var$wt(t) {
    switch(t){
        case $6c8154472dd99012$var$a.OK:
            return $6c8154472dd99012$var$y();
        case $6c8154472dd99012$var$a.CANCELLED:
        case $6c8154472dd99012$var$a.UNKNOWN:
        case $6c8154472dd99012$var$a.DEADLINE_EXCEEDED:
        case $6c8154472dd99012$var$a.RESOURCE_EXHAUSTED:
        case $6c8154472dd99012$var$a.INTERNAL:
        case $6c8154472dd99012$var$a.UNAVAILABLE:
        // Unauthenticated means something went wrong with our token and we need
        // to retry with new credentials which will happen automatically.
        case $6c8154472dd99012$var$a.UNAUTHENTICATED:
            return !1;
        case $6c8154472dd99012$var$a.INVALID_ARGUMENT:
        case $6c8154472dd99012$var$a.NOT_FOUND:
        case $6c8154472dd99012$var$a.ALREADY_EXISTS:
        case $6c8154472dd99012$var$a.PERMISSION_DENIED:
        case $6c8154472dd99012$var$a.FAILED_PRECONDITION:
        // Aborted might be retried in some scenarios, but that is dependant on
        // the context and should handled individually by the calling code.
        // See https://cloud.google.com/apis/design/errors.
        case $6c8154472dd99012$var$a.ABORTED:
        case $6c8154472dd99012$var$a.OUT_OF_RANGE:
        case $6c8154472dd99012$var$a.UNIMPLEMENTED:
        case $6c8154472dd99012$var$a.DATA_LOSS:
            return !0;
        default:
            return $6c8154472dd99012$var$y();
    }
}
/**
 * Determines whether an error code represents a permanent error when received
 * in response to a write operation.
 *
 * Write operations must be handled specially because as of b/119437764, ABORTED
 * errors on the write stream should be retried too (even though ABORTED errors
 * are not generally retryable).
 *
 * Note that during the initial handshake on the write stream an ABORTED error
 * signals that we should discard our stream token (i.e. it is permanent). This
 * means a handshake error should be classified with isPermanentError, above.
 */ /**
 * Maps an error Code from GRPC status code number, like 0, 1, or 14. These
 * are not the same as HTTP status codes.
 *
 * @returns The Code equivalent to the given GRPC status code. Fails if there
 *     is no match.
 */ function $6c8154472dd99012$var$_t(t) {
    if (void 0 === t) // This shouldn't normally happen, but in certain error cases (like trying
    // to send invalid proto messages) we may get an error with no GRPC code.
    return $6c8154472dd99012$var$p("GRPC error has no .code"), $6c8154472dd99012$var$a.UNKNOWN;
    switch(t){
        case $6c8154472dd99012$var$vt.OK:
            return $6c8154472dd99012$var$a.OK;
        case $6c8154472dd99012$var$vt.CANCELLED:
            return $6c8154472dd99012$var$a.CANCELLED;
        case $6c8154472dd99012$var$vt.UNKNOWN:
            return $6c8154472dd99012$var$a.UNKNOWN;
        case $6c8154472dd99012$var$vt.DEADLINE_EXCEEDED:
            return $6c8154472dd99012$var$a.DEADLINE_EXCEEDED;
        case $6c8154472dd99012$var$vt.RESOURCE_EXHAUSTED:
            return $6c8154472dd99012$var$a.RESOURCE_EXHAUSTED;
        case $6c8154472dd99012$var$vt.INTERNAL:
            return $6c8154472dd99012$var$a.INTERNAL;
        case $6c8154472dd99012$var$vt.UNAVAILABLE:
            return $6c8154472dd99012$var$a.UNAVAILABLE;
        case $6c8154472dd99012$var$vt.UNAUTHENTICATED:
            return $6c8154472dd99012$var$a.UNAUTHENTICATED;
        case $6c8154472dd99012$var$vt.INVALID_ARGUMENT:
            return $6c8154472dd99012$var$a.INVALID_ARGUMENT;
        case $6c8154472dd99012$var$vt.NOT_FOUND:
            return $6c8154472dd99012$var$a.NOT_FOUND;
        case $6c8154472dd99012$var$vt.ALREADY_EXISTS:
            return $6c8154472dd99012$var$a.ALREADY_EXISTS;
        case $6c8154472dd99012$var$vt.PERMISSION_DENIED:
            return $6c8154472dd99012$var$a.PERMISSION_DENIED;
        case $6c8154472dd99012$var$vt.FAILED_PRECONDITION:
            return $6c8154472dd99012$var$a.FAILED_PRECONDITION;
        case $6c8154472dd99012$var$vt.ABORTED:
            return $6c8154472dd99012$var$a.ABORTED;
        case $6c8154472dd99012$var$vt.OUT_OF_RANGE:
            return $6c8154472dd99012$var$a.OUT_OF_RANGE;
        case $6c8154472dd99012$var$vt.UNIMPLEMENTED:
            return $6c8154472dd99012$var$a.UNIMPLEMENTED;
        case $6c8154472dd99012$var$vt.DATA_LOSS:
            return $6c8154472dd99012$var$a.DATA_LOSS;
        default:
            return $6c8154472dd99012$var$y();
    }
}
/**
 * Converts an HTTP response's error status to the equivalent error code.
 *
 * @param status An HTTP error response status ("FAILED_PRECONDITION",
 * "UNKNOWN", etc.)
 * @returns The equivalent Code. Non-matching responses are mapped to
 *     Code.UNKNOWN.
 */ ($6c8154472dd99012$var$yt = $6c8154472dd99012$var$vt || ($6c8154472dd99012$var$vt = {}))[$6c8154472dd99012$var$yt.OK = 0] = "OK", $6c8154472dd99012$var$yt[$6c8154472dd99012$var$yt.CANCELLED = 1] = "CANCELLED", $6c8154472dd99012$var$yt[$6c8154472dd99012$var$yt.UNKNOWN = 2] = "UNKNOWN", $6c8154472dd99012$var$yt[$6c8154472dd99012$var$yt.INVALID_ARGUMENT = 3] = "INVALID_ARGUMENT", $6c8154472dd99012$var$yt[$6c8154472dd99012$var$yt.DEADLINE_EXCEEDED = 4] = "DEADLINE_EXCEEDED", $6c8154472dd99012$var$yt[$6c8154472dd99012$var$yt.NOT_FOUND = 5] = "NOT_FOUND", $6c8154472dd99012$var$yt[$6c8154472dd99012$var$yt.ALREADY_EXISTS = 6] = "ALREADY_EXISTS", $6c8154472dd99012$var$yt[$6c8154472dd99012$var$yt.PERMISSION_DENIED = 7] = "PERMISSION_DENIED", $6c8154472dd99012$var$yt[$6c8154472dd99012$var$yt.UNAUTHENTICATED = 16] = "UNAUTHENTICATED", $6c8154472dd99012$var$yt[$6c8154472dd99012$var$yt.RESOURCE_EXHAUSTED = 8] = "RESOURCE_EXHAUSTED", $6c8154472dd99012$var$yt[$6c8154472dd99012$var$yt.FAILED_PRECONDITION = 9] = "FAILED_PRECONDITION", $6c8154472dd99012$var$yt[$6c8154472dd99012$var$yt.ABORTED = 10] = "ABORTED", $6c8154472dd99012$var$yt[$6c8154472dd99012$var$yt.OUT_OF_RANGE = 11] = "OUT_OF_RANGE", $6c8154472dd99012$var$yt[$6c8154472dd99012$var$yt.UNIMPLEMENTED = 12] = "UNIMPLEMENTED", $6c8154472dd99012$var$yt[$6c8154472dd99012$var$yt.INTERNAL = 13] = "INTERNAL", $6c8154472dd99012$var$yt[$6c8154472dd99012$var$yt.UNAVAILABLE = 14] = "UNAVAILABLE", $6c8154472dd99012$var$yt[$6c8154472dd99012$var$yt.DATA_LOSS = 15] = "DATA_LOSS";
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // An immutable sorted map implementation, based on a Left-leaning Red-Black
// tree.
var $6c8154472dd99012$var$bt = /** @class */ function() {
    function t(t, e) {
        this.i = t, this.root = e || $6c8154472dd99012$var$Et.EMPTY;
    }
    // Returns a copy of the map, with the specified key/value added or replaced.
    return t.prototype.ot = function(e, n) {
        return new t(this.i, this.root.ot(e, n, this.i).copy(null, null, $6c8154472dd99012$var$Et.at, null, null));
    }, // Returns a copy of the map, with the specified key removed.
    t.prototype.remove = function(e) {
        return new t(this.i, this.root.remove(e, this.i).copy(null, null, $6c8154472dd99012$var$Et.at, null, null));
    }, // Returns the value of the node with the given key, or null.
    t.prototype.get = function(t) {
        for(var e = this.root; !e.m();){
            var n = this.i(t, e.key);
            if (0 === n) return e.value;
            n < 0 ? e = e.left : n > 0 && (e = e.right);
        }
        return null;
    }, // Returns the index of the element in this sorted map, or -1 if it doesn't
    // exist.
    t.prototype.indexOf = function(t) {
        for(// Number of nodes that were pruned when descending right
        var e = 0, n = this.root; !n.m();){
            var r = this.i(t, n.key);
            if (0 === r) return e + n.left.size;
            r < 0 ? n = n.left : // Count all nodes left of the node plus the node itself
            (e += n.left.size + 1, n = n.right);
        }
        // Node not found
        return -1;
    }, t.prototype.m = function() {
        return this.root.m();
    }, Object.defineProperty(t.prototype, "size", {
        // Returns the total number of nodes in the map.
        get: function() {
            return this.root.size;
        },
        enumerable: !1,
        configurable: !0
    }), // Returns the minimum key in the map.
    t.prototype.ct = function() {
        return this.root.ct();
    }, // Returns the maximum key in the map.
    t.prototype.ut = function() {
        return this.root.ut();
    }, // Traverses the map in key order and calls the specified action function
    // for each key/value pair. If action returns true, traversal is aborted.
    // Returns the first truthy value returned by action, or the last falsey
    // value returned by action.
    t.prototype.ht = function(t) {
        return this.root.ht(t);
    }, t.prototype.forEach = function(t) {
        this.ht(function(e, n) {
            return t(e, n), !1;
        });
    }, t.prototype.toString = function() {
        var t = [];
        return this.ht(function(e, n) {
            return t.push(e + ":" + n), !1;
        }), "{" + t.join(", ") + "}";
    }, // Traverses the map in reverse key order and calls the specified action
    // function for each key/value pair. If action returns true, traversal is
    // aborted.
    // Returns the first truthy value returned by action, or the last falsey
    // value returned by action.
    t.prototype.lt = function(t) {
        return this.root.lt(t);
    }, // Returns an iterator over the SortedMap.
    t.prototype._t = function() {
        return new $6c8154472dd99012$var$It(this.root, null, this.i, !1);
    }, t.prototype.ft = function(t) {
        return new $6c8154472dd99012$var$It(this.root, t, this.i, !1);
    }, t.prototype.dt = function() {
        return new $6c8154472dd99012$var$It(this.root, null, this.i, !0);
    }, t.prototype.wt = function(t) {
        return new $6c8154472dd99012$var$It(this.root, t, this.i, !0);
    }, t;
}(), $6c8154472dd99012$var$It = /** @class */ function() {
    function t(t, e, n, r) {
        this.Tt = r, this.Et = [];
        for(var i = 1; !t.m();)if (i = e ? n(t.key, e) : 1, // flip the comparison if we're going in reverse
        r && (i *= -1), i < 0) // This node is less than our start key. ignore it
        t = this.Tt ? t.left : t.right;
        else {
            if (0 === i) {
                // This node is exactly equal to our start key. Push it on the stack,
                // but stop iterating;
                this.Et.push(t);
                break;
            }
            // This node is greater than our start key, add it to the stack and move
            // to the next one
            this.Et.push(t), t = this.Tt ? t.right : t.left;
        }
    }
    return t.prototype.It = function() {
        var t = this.Et.pop(), e = {
            key: t.key,
            value: t.value
        };
        if (this.Tt) for(t = t.left; !t.m();)this.Et.push(t), t = t.right;
        else for(t = t.right; !t.m();)this.Et.push(t), t = t.left;
        return e;
    }, t.prototype.At = function() {
        return this.Et.length > 0;
    }, t.prototype.Rt = function() {
        if (0 === this.Et.length) return null;
        var t = this.Et[this.Et.length - 1];
        return {
            key: t.key,
            value: t.value
        };
    }, t;
}(), $6c8154472dd99012$var$Et = /** @class */ function() {
    function t(e, n, r, i, o) {
        this.key = e, this.value = n, this.color = null != r ? r : t.RED, this.left = null != i ? i : t.EMPTY, this.right = null != o ? o : t.EMPTY, this.size = this.left.size + 1 + this.right.size;
    }
    // Returns a copy of the current node, optionally replacing pieces of it.
    return t.prototype.copy = function(e, n, r, i, o) {
        return new t(null != e ? e : this.key, null != n ? n : this.value, null != r ? r : this.color, null != i ? i : this.left, null != o ? o : this.right);
    }, t.prototype.m = function() {
        return !1;
    }, // Traverses the tree in key order and calls the specified action function
    // for each node. If action returns true, traversal is aborted.
    // Returns the first truthy value returned by action, or the last falsey
    // value returned by action.
    t.prototype.ht = function(t) {
        return this.left.ht(t) || t(this.key, this.value) || this.right.ht(t);
    }, // Traverses the tree in reverse key order and calls the specified action
    // function for each node. If action returns true, traversal is aborted.
    // Returns the first truthy value returned by action, or the last falsey
    // value returned by action.
    t.prototype.lt = function(t) {
        return this.right.lt(t) || t(this.key, this.value) || this.left.lt(t);
    }, // Returns the minimum node in the tree.
    t.prototype.min = function() {
        return this.left.m() ? this : this.left.min();
    }, // Returns the maximum key in the tree.
    t.prototype.ct = function() {
        return this.min().key;
    }, // Returns the maximum key in the tree.
    t.prototype.ut = function() {
        return this.right.m() ? this.key : this.right.ut();
    }, // Returns new tree, with the key/value added.
    t.prototype.ot = function(t, e, n) {
        var r = this, i = n(t, r.key);
        return (r = i < 0 ? r.copy(null, null, null, r.left.ot(t, e, n), null) : 0 === i ? r.copy(null, e, null, null, null) : r.copy(null, null, null, null, r.right.ot(t, e, n))).gt();
    }, t.prototype.Pt = function() {
        if (this.left.m()) return t.EMPTY;
        var e = this;
        return e.left.yt() || e.left.left.yt() || (e = e.Vt()), (e = e.copy(null, null, null, e.left.Pt(), null)).gt();
    }, // Returns new tree, with the specified item removed.
    t.prototype.remove = function(e, n) {
        var r, i = this;
        if (n(e, i.key) < 0) i.left.m() || i.left.yt() || i.left.left.yt() || (i = i.Vt()), i = i.copy(null, null, null, i.left.remove(e, n), null);
        else {
            if (i.left.yt() && (i = i.bt()), i.right.m() || i.right.yt() || i.right.left.yt() || (i = i.vt()), 0 === n(e, i.key)) {
                if (i.right.m()) return t.EMPTY;
                r = i.right.min(), i = i.copy(r.key, r.value, null, null, i.right.Pt());
            }
            i = i.copy(null, null, null, null, i.right.remove(e, n));
        }
        return i.gt();
    }, t.prototype.yt = function() {
        return this.color;
    }, // Returns new tree after performing any needed rotations.
    t.prototype.gt = function() {
        var t = this;
        return t.right.yt() && !t.left.yt() && (t = t.St()), t.left.yt() && t.left.left.yt() && (t = t.bt()), t.left.yt() && t.right.yt() && (t = t.Dt()), t;
    }, t.prototype.Vt = function() {
        var t = this.Dt();
        return t.right.left.yt() && (t = (t = (t = t.copy(null, null, null, null, t.right.bt())).St()).Dt()), t;
    }, t.prototype.vt = function() {
        var t = this.Dt();
        return t.left.left.yt() && (t = (t = t.bt()).Dt()), t;
    }, t.prototype.St = function() {
        var e = this.copy(null, null, t.RED, null, this.right.left);
        return this.right.copy(null, null, this.color, e, null);
    }, t.prototype.bt = function() {
        var e = this.copy(null, null, t.RED, this.left.right, null);
        return this.left.copy(null, null, this.color, null, e);
    }, t.prototype.Dt = function() {
        var t = this.left.copy(null, null, !this.left.color, null, null), e = this.right.copy(null, null, !this.right.color, null, null);
        return this.copy(null, null, !this.color, t, e);
    }, // For testing.
    t.prototype.Ct = function() {
        var t = this.Nt();
        return Math.pow(2, t) <= this.size + 1;
    }, // In a balanced RB tree, the black-depth (number of black nodes) from root to
    // leaves is equal on both sides.  This function verifies that or asserts.
    t.prototype.Nt = function() {
        if (this.yt() && this.left.yt()) throw $6c8154472dd99012$var$y();
        if (this.right.yt()) throw $6c8154472dd99012$var$y();
        var t = this.left.Nt();
        if (t !== this.right.Nt()) throw $6c8154472dd99012$var$y();
        return t + (this.yt() ? 0 : 1);
    }, t;
}();
// end SortedMap
// An iterator over an LLRBNode.
// end LLRBNode
// Empty node is shared between all LLRB trees.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
$6c8154472dd99012$var$Et.EMPTY = null, $6c8154472dd99012$var$Et.RED = !0, $6c8154472dd99012$var$Et.at = !1, // end LLRBEmptyNode
$6c8154472dd99012$var$Et.EMPTY = new /** @class */ (function() {
    function t() {
        this.size = 0;
    }
    return Object.defineProperty(t.prototype, "key", {
        get: function() {
            throw $6c8154472dd99012$var$y();
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "value", {
        get: function() {
            throw $6c8154472dd99012$var$y();
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "color", {
        get: function() {
            throw $6c8154472dd99012$var$y();
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "left", {
        get: function() {
            throw $6c8154472dd99012$var$y();
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "right", {
        get: function() {
            throw $6c8154472dd99012$var$y();
        },
        enumerable: !1,
        configurable: !0
    }), // Returns a copy of the current node.
    t.prototype.copy = function(t, e, n, r, i) {
        return this;
    }, // Returns a copy of the tree, with the specified key/value added.
    t.prototype.ot = function(t, e, n) {
        return new $6c8154472dd99012$var$Et(t, e);
    }, // Returns a copy of the tree, with the specified key removed.
    t.prototype.remove = function(t, e) {
        return this;
    }, t.prototype.m = function() {
        return !0;
    }, t.prototype.ht = function(t) {
        return !1;
    }, t.prototype.lt = function(t) {
        return !1;
    }, t.prototype.ct = function() {
        return null;
    }, t.prototype.ut = function() {
        return null;
    }, t.prototype.yt = function() {
        return !1;
    }, // For testing.
    t.prototype.Ct = function() {
        return !0;
    }, t.prototype.Nt = function() {
        return 0;
    }, t;
}());
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * SortedSet is an immutable (copy-on-write) collection that holds elements
 * in order specified by the provided comparator.
 *
 * NOTE: if provided comparator returns 0 for two elements, we consider them to
 * be equal!
 */ var $6c8154472dd99012$var$Tt = /** @class */ function() {
    function t(t) {
        this.i = t, this.data = new $6c8154472dd99012$var$bt(this.i);
    }
    return t.prototype.has = function(t) {
        return null !== this.data.get(t);
    }, t.prototype.first = function() {
        return this.data.ct();
    }, t.prototype.last = function() {
        return this.data.ut();
    }, Object.defineProperty(t.prototype, "size", {
        get: function() {
            return this.data.size;
        },
        enumerable: !1,
        configurable: !0
    }), t.prototype.indexOf = function(t) {
        return this.data.indexOf(t);
    }, /** Iterates elements in order defined by "comparator" */ t.prototype.forEach = function(t) {
        this.data.ht(function(e, n) {
            return t(e), !1;
        });
    }, /** Iterates over `elem`s such that: range[0] <= elem < range[1]. */ t.prototype.Ft = function(t, e) {
        for(var n = this.data.ft(t[0]); n.At();){
            var r = n.It();
            if (this.i(r.key, t[1]) >= 0) return;
            e(r.key);
        }
    }, /**
     * Iterates over `elem`s such that: start <= elem until false is returned.
     */ t.prototype.xt = function(t, e) {
        var n;
        for(n = void 0 !== e ? this.data.ft(e) : this.data._t(); n.At();)if (!t(n.It().key)) return;
    }, /** Finds the least element greater than or equal to `elem`. */ t.prototype.$t = function(t) {
        var e = this.data.ft(t);
        return e.At() ? e.It().key : null;
    }, t.prototype._t = function() {
        return new $6c8154472dd99012$var$Nt(this.data._t());
    }, t.prototype.ft = function(t) {
        return new $6c8154472dd99012$var$Nt(this.data.ft(t));
    }, /** Inserts or updates an element */ t.prototype.add = function(t) {
        return this.copy(this.data.remove(t).ot(t, !0));
    }, /** Deletes an element */ t.prototype.delete = function(t) {
        return this.has(t) ? this.copy(this.data.remove(t)) : this;
    }, t.prototype.m = function() {
        return this.data.m();
    }, t.prototype.kt = function(t) {
        var e = this;
        // Make sure `result` always refers to the larger one of the two sets.
        return e.size < t.size && (e = t, t = this), t.forEach(function(t) {
            e = e.add(t);
        }), e;
    }, t.prototype.isEqual = function(e) {
        if (!(e instanceof t)) return !1;
        if (this.size !== e.size) return !1;
        for(var n = this.data._t(), r = e.data._t(); n.At();){
            var i = n.It().key, o = r.It().key;
            if (0 !== this.i(i, o)) return !1;
        }
        return !0;
    }, t.prototype.A = function() {
        var t = [];
        return this.forEach(function(e) {
            t.push(e);
        }), t;
    }, t.prototype.toString = function() {
        var t = [];
        return this.forEach(function(e) {
            return t.push(e);
        }), "SortedSet(" + t.toString() + ")";
    }, t.prototype.copy = function(e) {
        var n = new t(this.i);
        return n.data = e, n;
    }, t;
}(), $6c8154472dd99012$var$Nt = /** @class */ function() {
    function t(t) {
        this.Mt = t;
    }
    return t.prototype.It = function() {
        return this.Mt.It().key;
    }, t.prototype.At = function() {
        return this.Mt.At();
    }, t;
}(), $6c8154472dd99012$var$At = new $6c8154472dd99012$var$bt($6c8154472dd99012$var$A.i);
function $6c8154472dd99012$var$St() {
    return $6c8154472dd99012$var$At;
}
function $6c8154472dd99012$var$Dt() {
    return $6c8154472dd99012$var$St();
}
var $6c8154472dd99012$var$xt = new $6c8154472dd99012$var$bt($6c8154472dd99012$var$A.i);
function $6c8154472dd99012$var$Lt() {
    return $6c8154472dd99012$var$xt;
}
var $6c8154472dd99012$var$kt = new $6c8154472dd99012$var$bt($6c8154472dd99012$var$A.i), $6c8154472dd99012$var$Rt = new $6c8154472dd99012$var$Tt($6c8154472dd99012$var$A.i);
function $6c8154472dd99012$var$Ot() {
    for(var t = [], e = 0; e < arguments.length; e++)t[e] = arguments[e];
    for(var n = $6c8154472dd99012$var$Rt, r = 0, i = t; r < i.length; r++){
        var o = i[r];
        n = n.add(o);
    }
    return n;
}
var $6c8154472dd99012$var$Pt = new $6c8154472dd99012$var$Tt($6c8154472dd99012$var$H);
function $6c8154472dd99012$var$Vt() {
    return $6c8154472dd99012$var$Pt;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * DocumentSet is an immutable (copy-on-write) collection that holds documents
 * in order specified by the provided comparator. We always add a document key
 * comparator on top of what is provided to guarantee document equality based on
 * the key.
 */ var $6c8154472dd99012$var$Ut = /** @class */ function() {
    /** The default ordering is by key if the comparator is omitted */ function t(t) {
        // We are adding document key comparator to the end as it's the only
        // guaranteed unique property of a document.
        this.i = t ? function(e, n) {
            return t(e, n) || $6c8154472dd99012$var$A.i(e.key, n.key);
        } : function(t, e) {
            return $6c8154472dd99012$var$A.i(t.key, e.key);
        }, this.Ot = $6c8154472dd99012$var$Lt(), this.Lt = new $6c8154472dd99012$var$bt(this.i) /**
     * Returns an empty copy of the existing DocumentSet, using the same
     * comparator.
     */ ;
    }
    return t.Bt = function(e) {
        return new t(e.i);
    }, t.prototype.has = function(t) {
        return null != this.Ot.get(t);
    }, t.prototype.get = function(t) {
        return this.Ot.get(t);
    }, t.prototype.first = function() {
        return this.Lt.ct();
    }, t.prototype.last = function() {
        return this.Lt.ut();
    }, t.prototype.m = function() {
        return this.Lt.m();
    }, /**
     * Returns the index of the provided key in the document set, or -1 if the
     * document key is not present in the set;
     */ t.prototype.indexOf = function(t) {
        var e = this.Ot.get(t);
        return e ? this.Lt.indexOf(e) : -1;
    }, Object.defineProperty(t.prototype, "size", {
        get: function() {
            return this.Lt.size;
        },
        enumerable: !1,
        configurable: !0
    }), /** Iterates documents in order defined by "comparator" */ t.prototype.forEach = function(t) {
        this.Lt.ht(function(e, n) {
            return t(e), !1;
        });
    }, /** Inserts or updates a document with the same key */ t.prototype.add = function(t) {
        // First remove the element if we have it.
        var e = this.delete(t.key);
        return e.copy(e.Ot.ot(t.key, t), e.Lt.ot(t, null));
    }, /** Deletes a document with a given key */ t.prototype.delete = function(t) {
        var e = this.get(t);
        return e ? this.copy(this.Ot.remove(t), this.Lt.remove(e)) : this;
    }, t.prototype.isEqual = function(e) {
        if (!(e instanceof t)) return !1;
        if (this.size !== e.size) return !1;
        for(var n = this.Lt._t(), r = e.Lt._t(); n.At();){
            var i = n.It().key, o = r.It().key;
            if (!i.isEqual(o)) return !1;
        }
        return !0;
    }, t.prototype.toString = function() {
        var t = [];
        return this.forEach(function(e) {
            t.push(e.toString());
        }), 0 === t.length ? "DocumentSet ()" : "DocumentSet (\n  " + t.join("  \n") + "\n)";
    }, t.prototype.copy = function(e, n) {
        var r = new t;
        return r.i = this.i, r.Ot = e, r.Lt = n, r;
    }, t;
}(), $6c8154472dd99012$var$Ct = /** @class */ function() {
    function t() {
        this.qt = new $6c8154472dd99012$var$bt($6c8154472dd99012$var$A.i);
    }
    return t.prototype.track = function(t) {
        var e = t.doc.key, n = this.qt.get(e);
        n ? // Merge the new change with the existing change.
        0 /* Added */  !== t.type && 3 /* Metadata */  === n.type ? this.qt = this.qt.ot(e, t) : 3 /* Metadata */  === t.type && 1 /* Removed */  !== n.type ? this.qt = this.qt.ot(e, {
            type: n.type,
            doc: t.doc
        }) : 2 /* Modified */  === t.type && 2 /* Modified */  === n.type ? this.qt = this.qt.ot(e, {
            type: 2 /* Modified */ ,
            doc: t.doc
        }) : 2 /* Modified */  === t.type && 0 /* Added */  === n.type ? this.qt = this.qt.ot(e, {
            type: 0 /* Added */ ,
            doc: t.doc
        }) : 1 /* Removed */  === t.type && 0 /* Added */  === n.type ? this.qt = this.qt.remove(e) : 1 /* Removed */  === t.type && 2 /* Modified */  === n.type ? this.qt = this.qt.ot(e, {
            type: 1 /* Removed */ ,
            doc: n.doc
        }) : 0 /* Added */  === t.type && 1 /* Removed */  === n.type ? this.qt = this.qt.ot(e, {
            type: 2 /* Modified */ ,
            doc: t.doc
        }) : // This includes these cases, which don't make sense:
        // Added->Added
        // Removed->Removed
        // Modified->Added
        // Removed->Modified
        // Metadata->Added
        // Removed->Metadata
        $6c8154472dd99012$var$y() : this.qt = this.qt.ot(e, t);
    }, t.prototype.Ut = function() {
        var t = [];
        return this.qt.ht(function(e, n) {
            t.push(n);
        }), t;
    }, t;
}(), $6c8154472dd99012$var$Ft = /** @class */ function() {
    function t(t, e, n, r, i, o, s, u) {
        this.query = t, this.docs = e, this.Qt = n, this.docChanges = r, this.Wt = i, this.fromCache = o, this.jt = s, this.Kt = u /** Returns a view snapshot as if all documents in the snapshot were added. */ ;
    }
    return t.Gt = function(e, n, r, i) {
        var o = [];
        return n.forEach(function(t) {
            o.push({
                type: 0 /* Added */ ,
                doc: t
            });
        }), new t(e, n, $6c8154472dd99012$var$Ut.Bt(n), o, r, i, /* syncStateChanged= */ !0, /* excludesMetadataChanges= */ !1);
    }, Object.defineProperty(t.prototype, "hasPendingWrites", {
        get: function() {
            return !this.Wt.m();
        },
        enumerable: !1,
        configurable: !0
    }), t.prototype.isEqual = function(t) {
        if (!(this.fromCache === t.fromCache && this.jt === t.jt && this.Wt.isEqual(t.Wt) && $6c8154472dd99012$var$Qn(this.query, t.query) && this.docs.isEqual(t.docs) && this.Qt.isEqual(t.Qt))) return !1;
        var e = this.docChanges, n = t.docChanges;
        if (e.length !== n.length) return !1;
        for(var r = 0; r < e.length; r++)if (e[r].type !== n[r].type || !e[r].doc.isEqual(n[r].doc)) return !1;
        return !0;
    }, t;
}(), $6c8154472dd99012$var$Mt = /** @class */ function() {
    function t(/**
     * The snapshot version this event brings us up to, or MIN if not set.
     */ t, /**
     * A map from target to changes to the target. See TargetChange.
     */ e, /**
     * A set of targets that is known to be inconsistent. Listens for these
     * targets should be re-established without resume tokens.
     */ n, /**
     * A set of which documents have changed or been deleted, along with the
     * doc's new values (if not deleted).
     */ r, /**
     * A set of which document updates are due only to limbo resolution targets.
     */ i) {
        this.nt = t, this.zt = e, this.Ht = n, this.Yt = r, this.Jt = i;
    }
    /**
     * HACK: Views require RemoteEvents in order to determine whether the view is
     * CURRENT, but secondary tabs don't receive remote events. So this method is
     * used to create a synthesized RemoteEvent that can be used to apply a
     * CURRENT status change to a View, for queries executed in a different tab.
     */ // PORTING NOTE: Multi-tab only
    return t.Xt = function(e, n) {
        var r = new Map;
        return r.set(e, $6c8154472dd99012$var$qt.Zt(e, n)), new t($6c8154472dd99012$var$st.min(), r, $6c8154472dd99012$var$Vt(), $6c8154472dd99012$var$St(), $6c8154472dd99012$var$Ot());
    }, t;
}(), $6c8154472dd99012$var$qt = /** @class */ function() {
    function t(/**
     * An opaque, server-assigned token that allows watching a query to be resumed
     * after disconnecting without retransmitting all the data that matches the
     * query. The resume token essentially identifies a point in time from which
     * the server should resume sending results.
     */ t, /**
     * The "current" (synced) status of this target. Note that "current"
     * has special meaning in the RPC protocol that implies that a target is
     * both up-to-date and consistent with the rest of the watch stream.
     */ e, /**
     * The set of documents that were newly assigned to this target as part of
     * this remote event.
     */ n, /**
     * The set of documents that were already assigned to this target but received
     * an update during this remote event.
     */ r, /**
     * The set of documents that were removed from this target as part of this
     * remote event.
     */ i) {
        this.resumeToken = t, this.te = e, this.ee = n, this.ne = r, this.se = i /**
     * This method is used to create a synthesized TargetChanges that can be used to
     * apply a CURRENT status change to a View (for queries executed in a different
     * tab) or for new queries (to raise snapshots with correct CURRENT status).
     */ ;
    }
    return t.Zt = function(e, n) {
        return new t($6c8154472dd99012$var$X.B, n, $6c8154472dd99012$var$Ot(), $6c8154472dd99012$var$Ot(), $6c8154472dd99012$var$Ot());
    }, t;
}(), $6c8154472dd99012$var$jt = function(/** The new document applies to all of these targets. */ t, /** The new document is removed from all of these targets. */ e, /** The key of the document for this change. */ n, /**
     * The new document or NoDocument if it was deleted. Is null if the
     * document went out of view without the server sending a new document.
     */ r) {
    this.ie = t, this.removedTargetIds = e, this.key = n, this.re = r;
}, $6c8154472dd99012$var$Gt = function(t, e) {
    this.targetId = t, this.oe = e;
}, $6c8154472dd99012$var$zt = function(/** What kind of change occurred to the watch target. */ t, /** The target IDs that were added/removed/set. */ e, /**
     * An opaque, server-assigned token that allows watching a target to be
     * resumed after disconnecting without retransmitting all the data that
     * matches the target. The resume token essentially identifies a point in
     * time from which the server should resume sending results.
     */ n, r) {
    void 0 === n && (n = $6c8154472dd99012$var$X.B), void 0 === r && (r = null), this.state = t, this.targetIds = e, this.resumeToken = n, this.cause = r;
}, $6c8154472dd99012$var$Bt = /** @class */ function() {
    function t() {
        /**
         * The number of pending responses (adds or removes) that we are waiting on.
         * We only consider targets active that have no pending responses.
         */ this.ae = 0, /**
             * Keeps track of the document changes since the last raised snapshot.
             *
             * These changes are continuously updated as we receive document updates and
             * always reflect the current set of changes against the last issued snapshot.
             */ this.ce = $6c8154472dd99012$var$Qt(), /** See public getters for explanations of these fields. */ this.ue = $6c8154472dd99012$var$X.B, this.he = !1, /**
             * Whether this target state should be included in the next snapshot. We
             * initialize to true so that newly-added targets are included in the next
             * RemoteEvent.
             */ this.le = !0;
    }
    return Object.defineProperty(t.prototype, "te", {
        /**
         * Whether this target has been marked 'current'.
         *
         * 'Current' has special meaning in the RPC protocol: It implies that the
         * Watch backend has sent us all changes up to the point at which the target
         * was added and that the target is consistent with the rest of the watch
         * stream.
         */ get: function() {
            return this.he;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "resumeToken", {
        /** The last resume token sent to us for this target. */ get: function() {
            return this.ue;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "_e", {
        /** Whether this target has pending target adds or target removes. */ get: function() {
            return 0 !== this.ae;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "fe", {
        /** Whether we have modified any state that should trigger a snapshot. */ get: function() {
            return this.le;
        },
        enumerable: !1,
        configurable: !0
    }), /**
     * Applies the resume token to the TargetChange, but only when it has a new
     * value. Empty resumeTokens are discarded.
     */ t.prototype.de = function(t) {
        t.O() > 0 && (this.le = !0, this.ue = t);
    }, /**
     * Creates a target change from the current set of changes.
     *
     * To reset the document changes after raising this snapshot, call
     * `clearPendingChanges()`.
     */ t.prototype.we = function() {
        var t = $6c8154472dd99012$var$Ot(), e = $6c8154472dd99012$var$Ot(), n = $6c8154472dd99012$var$Ot();
        return this.ce.forEach(function(r, i) {
            switch(i){
                case 0 /* Added */ :
                    t = t.add(r);
                    break;
                case 2 /* Modified */ :
                    e = e.add(r);
                    break;
                case 1 /* Removed */ :
                    n = n.add(r);
                    break;
                default:
                    $6c8154472dd99012$var$y();
            }
        }), new $6c8154472dd99012$var$qt(this.ue, this.he, t, e, n);
    }, /**
     * Resets the document changes and sets `hasPendingChanges` to false.
     */ t.prototype.me = function() {
        this.le = !1, this.ce = $6c8154472dd99012$var$Qt();
    }, t.prototype.Te = function(t, e) {
        this.le = !0, this.ce = this.ce.ot(t, e);
    }, t.prototype.Ee = function(t) {
        this.le = !0, this.ce = this.ce.remove(t);
    }, t.prototype.Ie = function() {
        this.ae += 1;
    }, t.prototype.Ae = function() {
        this.ae -= 1;
    }, t.prototype.Re = function() {
        this.le = !0, this.he = !0;
    }, t;
}(), $6c8154472dd99012$var$Wt = /** @class */ function() {
    function t(t) {
        this.ge = t, /** The internal state of all tracked targets. */ this.Pe = new Map, /** Keeps track of the documents to update since the last raised snapshot. */ this.ye = $6c8154472dd99012$var$St(), /** A mapping of document keys to their set of target IDs. */ this.Ve = $6c8154472dd99012$var$Kt(), /**
             * A list of targets with existence filter mismatches. These targets are
             * known to be inconsistent and their listens needs to be re-established by
             * RemoteStore.
             */ this.pe = new $6c8154472dd99012$var$Tt($6c8154472dd99012$var$H) /**
     * Processes and adds the DocumentWatchChange to the current set of changes.
     */ ;
    }
    return t.prototype.be = function(t) {
        for(var e = 0, n = t.ie; e < n.length; e++){
            var r = n[e];
            t.re instanceof $6c8154472dd99012$var$kn ? this.ve(r, t.re) : t.re instanceof $6c8154472dd99012$var$Rn && this.Se(r, t.key, t.re);
        }
        for(var i = 0, o = t.removedTargetIds; i < o.length; i++){
            var s = o[i];
            this.Se(s, t.key, t.re);
        }
    }, /** Processes and adds the WatchTargetChange to the current set of changes. */ t.prototype.De = function(t) {
        var e = this;
        this.Ce(t, function(n) {
            var r = e.Ne(n);
            switch(t.state){
                case 0 /* NoChange */ :
                    e.Fe(n) && r.de(t.resumeToken);
                    break;
                case 1 /* Added */ :
                    // We need to decrement the number of pending acks needed from watch
                    // for this targetId.
                    r.Ae(), r._e || // We have a freshly added target, so we need to reset any state
                    // that we had previously. This can happen e.g. when remove and add
                    // back a target for existence filter mismatches.
                    r.me(), r.de(t.resumeToken);
                    break;
                case 2 /* Removed */ :
                    // We need to keep track of removed targets to we can post-filter and
                    // remove any target changes.
                    // We need to decrement the number of pending acks needed from watch
                    // for this targetId.
                    r.Ae(), r._e || e.removeTarget(n);
                    break;
                case 3 /* Current */ :
                    e.Fe(n) && (r.Re(), r.de(t.resumeToken));
                    break;
                case 4 /* Reset */ :
                    e.Fe(n) && // Reset the target and synthesizes removes for all existing
                    // documents. The backend will re-add any documents that still
                    // match the target before it sends the next global snapshot.
                    (e.xe(n), r.de(t.resumeToken));
                    break;
                default:
                    $6c8154472dd99012$var$y();
            }
        });
    }, /**
     * Iterates over all targetIds that the watch change applies to: either the
     * targetIds explicitly listed in the change or the targetIds of all currently
     * active targets.
     */ t.prototype.Ce = function(t, e) {
        var n = this;
        t.targetIds.length > 0 ? t.targetIds.forEach(e) : this.Pe.forEach(function(t, r) {
            n.Fe(r) && e(r);
        });
    }, /**
     * Handles existence filters and synthesizes deletes for filter mismatches.
     * Targets that are invalidated by filter mismatches are added to
     * `pendingTargetResets`.
     */ t.prototype.$e = function(t) {
        var e = t.targetId, n = t.oe.count, r = this.ke(e);
        if (r) {
            var i = r.target;
            if ($6c8154472dd99012$var$dt(i)) {
                if (0 === n) {
                    // The existence filter told us the document does not exist. We deduce
                    // that this document does not exist and apply a deleted document to
                    // our updates. Without applying this deleted document there might be
                    // another query that will raise this document as part of a snapshot
                    // until it is resolved, essentially exposing inconsistency between
                    // queries.
                    var o = new $6c8154472dd99012$var$A(i.path);
                    this.Se(e, o, new $6c8154472dd99012$var$Rn(o, $6c8154472dd99012$var$st.min()));
                } else $6c8154472dd99012$var$g(1 === n);
            } else this.Me(e) !== n && // Existence filter mismatch: We reset the mapping and raise a new
            // snapshot with `isFromCache:true`.
            (this.xe(e), this.pe = this.pe.add(e));
        }
    }, /**
     * Converts the currently accumulated state into a remote event at the
     * provided snapshot version. Resets the accumulated changes before returning.
     */ t.prototype.Oe = function(t) {
        var e = this, n = new Map;
        this.Pe.forEach(function(r, i) {
            var o = e.ke(i);
            if (o) {
                if (r.te && $6c8154472dd99012$var$dt(o.target)) {
                    // Document queries for document that don't exist can produce an empty
                    // result set. To update our local cache, we synthesize a document
                    // delete if we have not previously received the document. This
                    // resolves the limbo state of the document, removing it from
                    // limboDocumentRefs.
                    // TODO(dimond): Ideally we would have an explicit lookup target
                    // instead resulting in an explicit delete message and we could
                    // remove this special logic.
                    var s = new $6c8154472dd99012$var$A(o.target.path);
                    null !== e.ye.get(s) || e.Le(i, s) || e.Se(i, s, new $6c8154472dd99012$var$Rn(s, t));
                }
                r.fe && (n.set(i, r.we()), r.me());
            }
        });
        var r = $6c8154472dd99012$var$Ot();
        // We extract the set of limbo-only document updates as the GC logic
        // special-cases documents that do not appear in the target cache.
        // TODO(gsoltis): Expand on this comment once GC is available in the JS
        // client.
        this.Ve.forEach(function(t, n) {
            var i = !0;
            n.xt(function(t) {
                var n = e.ke(t);
                return !n || 2 /* LimboResolution */  === n.et || (i = !1, !1);
            }), i && (r = r.add(t));
        });
        var i = new $6c8154472dd99012$var$Mt(t, n, this.pe, this.ye, r);
        return this.ye = $6c8154472dd99012$var$St(), this.Ve = $6c8154472dd99012$var$Kt(), this.pe = new $6c8154472dd99012$var$Tt($6c8154472dd99012$var$H), i;
    }, /**
     * Adds the provided document to the internal list of document updates and
     * its document key to the given target's mapping.
     */ // Visible for testing.
    t.prototype.ve = function(t, e) {
        if (this.Fe(t)) {
            var n = this.Le(t, e.key) ? 2 /* Modified */  : 0 /* Added */ ;
            this.Ne(t).Te(e.key, n), this.ye = this.ye.ot(e.key, e), this.Ve = this.Ve.ot(e.key, this.Be(e.key).add(t));
        }
    }, /**
     * Removes the provided document from the target mapping. If the
     * document no longer matches the target, but the document's state is still
     * known (e.g. we know that the document was deleted or we received the change
     * that caused the filter mismatch), the new document can be provided
     * to update the remote document cache.
     */ // Visible for testing.
    t.prototype.Se = function(t, e, n) {
        if (this.Fe(t)) {
            var r = this.Ne(t);
            this.Le(t, e) ? r.Te(e, 1 /* Removed */ ) : // The document may have entered and left the target before we raised a
            // snapshot, so we can just ignore the change.
            r.Ee(e), this.Ve = this.Ve.ot(e, this.Be(e).delete(t)), n && (this.ye = this.ye.ot(e, n));
        }
    }, t.prototype.removeTarget = function(t) {
        this.Pe.delete(t);
    }, /**
     * Returns the current count of documents in the target. This includes both
     * the number of documents that the LocalStore considers to be part of the
     * target as well as any accumulated changes.
     */ t.prototype.Me = function(t) {
        var e = this.Ne(t).we();
        return this.ge.qe(t).size + e.ee.size - e.se.size;
    }, /**
     * Increment the number of acks needed from watch before we can consider the
     * server to be 'in-sync' with the client's active targets.
     */ t.prototype.Ie = function(t) {
        this.Ne(t).Ie();
    }, t.prototype.Ne = function(t) {
        var e = this.Pe.get(t);
        return e || (e = new $6c8154472dd99012$var$Bt, this.Pe.set(t, e)), e;
    }, t.prototype.Be = function(t) {
        var e = this.Ve.get(t);
        return e || (e = new $6c8154472dd99012$var$Tt($6c8154472dd99012$var$H), this.Ve = this.Ve.ot(t, e)), e;
    }, /**
     * Verifies that the user is still interested in this target (by calling
     * `getTargetDataForTarget()`) and that we are not waiting for pending ADDs
     * from watch.
     */ t.prototype.Fe = function(t) {
        var e = null !== this.ke(t);
        return e || $6c8154472dd99012$var$l("WatchChangeAggregator", "Detected inactive target", t), e;
    }, /**
     * Returns the TargetData for an active target (i.e. a target that the user
     * is still interested in that has no outstanding target change requests).
     */ t.prototype.ke = function(t) {
        var e = this.Pe.get(t);
        return e && e._e ? null : this.ge.Ue(t);
    }, /**
     * Resets the state of a Watch target to its initial state (e.g. sets
     * 'current' to false, clears the resume token and removes its target mapping
     * from all documents).
     */ t.prototype.xe = function(t) {
        var e = this;
        this.Pe.set(t, new $6c8154472dd99012$var$Bt), this.ge.qe(t).forEach(function(n) {
            e.Se(t, n, /*updatedDocument=*/ null);
        });
    }, /**
     * Returns whether the LocalStore considers the document to be part of the
     * specified target.
     */ t.prototype.Le = function(t, e) {
        return this.ge.qe(t).has(e);
    }, t;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * DocumentChangeSet keeps track of a set of changes to docs in a query, merging
 * duplicate events for the same doc.
 */ function $6c8154472dd99012$var$Kt() {
    return new $6c8154472dd99012$var$bt($6c8154472dd99012$var$A.i);
}
function $6c8154472dd99012$var$Qt() {
    return new $6c8154472dd99012$var$bt($6c8154472dd99012$var$A.i);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents a locally-applied ServerTimestamp.
 *
 * Server Timestamps are backed by MapValues that contain an internal field
 * `__type__` with a value of `server_timestamp`. The previous value and local
 * write time are stored in its `__previous_value__` and `__local_write_time__`
 * fields respectively.
 *
 * Notes:
 * - ServerTimestampValue instances are created as the result of applying a
 *   TransformMutation (see TransformMutation.applyTo()). They can only exist in
 *   the local view of a document. Therefore they do not need to be parsed or
 *   serialized.
 * - When evaluated locally (e.g. for snapshot.data()), they by default
 *   evaluate to `null`. This behavior can be configured by passing custom
 *   FieldValueOptions to value().
 * - With respect to other ServerTimestampValues, they sort by their
 *   localWriteTime.
 */ function $6c8154472dd99012$var$Ht(t) {
    var e, n;
    return "server_timestamp" === (null === (n = ((null === (e = null == t ? void 0 : t.mapValue) || void 0 === e ? void 0 : e.fields) || {}).__type__) || void 0 === n ? void 0 : n.stringValue);
}
/**
 * Creates a new ServerTimestamp proto value (using the internal format).
 */ /**
 * Returns the value of the field before this ServerTimestamp was set.
 *
 * Preserving the previous values allows the user to display the last resoled
 * value until the backend responds with the timestamp.
 */ function $6c8154472dd99012$var$Yt(t) {
    var e = t.mapValue.fields.__previous_value__;
    return $6c8154472dd99012$var$Ht(e) ? $6c8154472dd99012$var$Yt(e) : e;
}
/**
 * Returns the local time at which this timestamp was first set.
 */ function $6c8154472dd99012$var$$t(t) {
    var e = $6c8154472dd99012$var$oe(t.mapValue.fields.__local_write_time__.timestampValue);
    return new $6c8154472dd99012$var$ot(e.seconds, e.nanos);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // A RegExp matching ISO 8601 UTC timestamps with optional fraction.
var $6c8154472dd99012$var$Xt = new RegExp(/^\d{4}-\d\d-\d\dT\d\d:\d\d:\d\d(?:\.(\d+))?Z$/);
/** Extracts the backend's type order for the provided value. */ function $6c8154472dd99012$var$Jt(t) {
    return "nullValue" in t ? 0 /* NullValue */  : "booleanValue" in t ? 1 /* BooleanValue */  : "integerValue" in t || "doubleValue" in t ? 2 /* NumberValue */  : "timestampValue" in t ? 3 /* TimestampValue */  : "stringValue" in t ? 5 /* StringValue */  : "bytesValue" in t ? 6 /* BlobValue */  : "referenceValue" in t ? 7 /* RefValue */  : "geoPointValue" in t ? 8 /* GeoPointValue */  : "arrayValue" in t ? 9 /* ArrayValue */  : "mapValue" in t ? $6c8154472dd99012$var$Ht(t) ? 4 /* ServerTimestampValue */  : 10 /* ObjectValue */  : $6c8154472dd99012$var$y();
}
/** Tests `left` and `right` for equality based on the backend semantics. */ function $6c8154472dd99012$var$Zt(t, e) {
    var n = $6c8154472dd99012$var$Jt(t);
    if (n !== $6c8154472dd99012$var$Jt(e)) return !1;
    switch(n){
        case 0 /* NullValue */ :
            return !0;
        case 1 /* BooleanValue */ :
            return t.booleanValue === e.booleanValue;
        case 4 /* ServerTimestampValue */ :
            return $6c8154472dd99012$var$$t(t).isEqual($6c8154472dd99012$var$$t(e));
        case 3 /* TimestampValue */ :
            return function(t, e) {
                if ("string" == typeof t.timestampValue && "string" == typeof e.timestampValue && t.timestampValue.length === e.timestampValue.length) // Use string equality for ISO 8601 timestamps
                return t.timestampValue === e.timestampValue;
                var n = $6c8154472dd99012$var$oe(t.timestampValue), r = $6c8154472dd99012$var$oe(e.timestampValue);
                return n.seconds === r.seconds && n.nanos === r.nanos;
            }(t, e);
        case 5 /* StringValue */ :
            return t.stringValue === e.stringValue;
        case 6 /* BlobValue */ :
            return function(t, e) {
                return $6c8154472dd99012$var$ue(t.bytesValue).isEqual($6c8154472dd99012$var$ue(e.bytesValue));
            }(t, e);
        case 7 /* RefValue */ :
            return t.referenceValue === e.referenceValue;
        case 8 /* GeoPointValue */ :
            return function(t, e) {
                return $6c8154472dd99012$var$se(t.geoPointValue.latitude) === $6c8154472dd99012$var$se(e.geoPointValue.latitude) && $6c8154472dd99012$var$se(t.geoPointValue.longitude) === $6c8154472dd99012$var$se(e.geoPointValue.longitude);
            }(t, e);
        case 2 /* NumberValue */ :
            return function(t, e) {
                if ("integerValue" in t && "integerValue" in e) return $6c8154472dd99012$var$se(t.integerValue) === $6c8154472dd99012$var$se(e.integerValue);
                if ("doubleValue" in t && "doubleValue" in e) {
                    var n = $6c8154472dd99012$var$se(t.doubleValue), r = $6c8154472dd99012$var$se(e.doubleValue);
                    return n === r ? $6c8154472dd99012$var$at(n) === $6c8154472dd99012$var$at(r) : isNaN(n) && isNaN(r);
                }
                return !1;
            }(t, e);
        case 9 /* ArrayValue */ :
            return $6c8154472dd99012$var$Y(t.arrayValue.values || [], e.arrayValue.values || [], $6c8154472dd99012$var$Zt);
        case 10 /* ObjectValue */ :
            return function(t, e) {
                var n = t.mapValue.fields || {}, r = e.mapValue.fields || {};
                if ($6c8154472dd99012$var$w(n) !== $6c8154472dd99012$var$w(r)) return !1;
                for(var i in n)if (n.hasOwnProperty(i) && (void 0 === r[i] || !$6c8154472dd99012$var$Zt(n[i], r[i]))) return !1;
                return !0;
            }(t, e);
        default:
            return $6c8154472dd99012$var$y();
    }
}
function $6c8154472dd99012$var$te(t, e) {
    return void 0 !== (t.values || []).find(function(t) {
        return $6c8154472dd99012$var$Zt(t, e);
    });
}
function $6c8154472dd99012$var$ee(t, e) {
    var n = $6c8154472dd99012$var$Jt(t), r = $6c8154472dd99012$var$Jt(e);
    if (n !== r) return $6c8154472dd99012$var$H(n, r);
    switch(n){
        case 0 /* NullValue */ :
            return 0;
        case 1 /* BooleanValue */ :
            return $6c8154472dd99012$var$H(t.booleanValue, e.booleanValue);
        case 2 /* NumberValue */ :
            return function(t, e) {
                var n = $6c8154472dd99012$var$se(t.integerValue || t.doubleValue), r = $6c8154472dd99012$var$se(e.integerValue || e.doubleValue);
                return n < r ? -1 : n > r ? 1 : n === r ? 0 : // one or both are NaN.
                isNaN(n) ? isNaN(r) ? 0 : -1 : 1;
            }(t, e);
        case 3 /* TimestampValue */ :
            return $6c8154472dd99012$var$ne(t.timestampValue, e.timestampValue);
        case 4 /* ServerTimestampValue */ :
            return $6c8154472dd99012$var$ne($6c8154472dd99012$var$$t(t), $6c8154472dd99012$var$$t(e));
        case 5 /* StringValue */ :
            return $6c8154472dd99012$var$H(t.stringValue, e.stringValue);
        case 6 /* BlobValue */ :
            return function(t, e) {
                var n = $6c8154472dd99012$var$ue(t), r = $6c8154472dd99012$var$ue(e);
                return n.L(r);
            }(t.bytesValue, e.bytesValue);
        case 7 /* RefValue */ :
            return function(t, e) {
                for(var n = t.split("/"), r = e.split("/"), i = 0; i < n.length && i < r.length; i++){
                    var o = $6c8154472dd99012$var$H(n[i], r[i]);
                    if (0 !== o) return o;
                }
                return $6c8154472dd99012$var$H(n.length, r.length);
            }(t.referenceValue, e.referenceValue);
        case 8 /* GeoPointValue */ :
            return function(t, e) {
                var n = $6c8154472dd99012$var$H($6c8154472dd99012$var$se(t.latitude), $6c8154472dd99012$var$se(e.latitude));
                return 0 !== n ? n : $6c8154472dd99012$var$H($6c8154472dd99012$var$se(t.longitude), $6c8154472dd99012$var$se(e.longitude));
            }(t.geoPointValue, e.geoPointValue);
        case 9 /* ArrayValue */ :
            return function(t, e) {
                for(var n = t.values || [], r = e.values || [], i = 0; i < n.length && i < r.length; ++i){
                    var o = $6c8154472dd99012$var$ee(n[i], r[i]);
                    if (o) return o;
                }
                return $6c8154472dd99012$var$H(n.length, r.length);
            }(t.arrayValue, e.arrayValue);
        case 10 /* ObjectValue */ :
            return function(t, e) {
                var n = t.fields || {}, r = Object.keys(n), i = e.fields || {}, o = Object.keys(i);
                // Even though MapValues are likely sorted correctly based on their insertion
                // order (e.g. when received from the backend), local modifications can bring
                // elements out of order. We need to re-sort the elements to ensure that
                // canonical IDs are independent of insertion order.
                r.sort(), o.sort();
                for(var s = 0; s < r.length && s < o.length; ++s){
                    var u = $6c8154472dd99012$var$H(r[s], o[s]);
                    if (0 !== u) return u;
                    var a = $6c8154472dd99012$var$ee(n[r[s]], i[o[s]]);
                    if (0 !== a) return a;
                }
                return $6c8154472dd99012$var$H(r.length, o.length);
            }(t.mapValue, e.mapValue);
        default:
            throw $6c8154472dd99012$var$y();
    }
}
function $6c8154472dd99012$var$ne(t, e) {
    if ("string" == typeof t && "string" == typeof e && t.length === e.length) return $6c8154472dd99012$var$H(t, e);
    var n = $6c8154472dd99012$var$oe(t), r = $6c8154472dd99012$var$oe(e), i = $6c8154472dd99012$var$H(n.seconds, r.seconds);
    return 0 !== i ? i : $6c8154472dd99012$var$H(n.nanos, r.nanos);
}
function $6c8154472dd99012$var$re(t) {
    return $6c8154472dd99012$var$ie(t);
}
function $6c8154472dd99012$var$ie(t) {
    var e, n;
    return "nullValue" in t ? "null" : "booleanValue" in t ? "" + t.booleanValue : "integerValue" in t ? "" + t.integerValue : "doubleValue" in t ? "" + t.doubleValue : "timestampValue" in t ? function(t) {
        var e = $6c8154472dd99012$var$oe(t);
        return "time(" + e.seconds + "," + e.nanos + ")";
    }(t.timestampValue) : "stringValue" in t ? t.stringValue : "bytesValue" in t ? $6c8154472dd99012$var$ue(t.bytesValue).toBase64() : "referenceValue" in t ? (n = t.referenceValue, $6c8154472dd99012$var$A.C(n).toString()) : "geoPointValue" in t ? "geo(" + (e = t.geoPointValue).latitude + "," + e.longitude + ")" : "arrayValue" in t ? function(t) {
        for(var e = "[", n = !0, r = 0, i = t.values || []; r < i.length; r++)n ? n = !1 : e += ",", e += $6c8154472dd99012$var$ie(i[r]);
        return e + "]";
    }(t.arrayValue) : "mapValue" in t ? function(t) {
        for(// Iteration order in JavaScript is not guaranteed. To ensure that we generate
        // matching canonical IDs for identical maps, we need to sort the keys.
        var e = "{", n = !0, r = 0, i = Object.keys(t.fields || {}).sort(); r < i.length; r++){
            var o = i[r];
            n ? n = !1 : e += ",", e += o + ":" + $6c8154472dd99012$var$ie(t.fields[o]);
        }
        return e + "}";
    }(t.mapValue) : $6c8154472dd99012$var$y();
}
function $6c8154472dd99012$var$oe(t) {
    // The json interface (for the browser) will return an iso timestamp string,
    // while the proto js library (for node) will return a
    // google.protobuf.Timestamp instance.
    if ($6c8154472dd99012$var$g(!!t), "string" == typeof t) {
        // The date string can have higher precision (nanos) than the Date class
        // (millis), so we do some custom parsing here.
        // Parse the nanos right out of the string.
        var e = 0, n = $6c8154472dd99012$var$Xt.exec(t);
        if ($6c8154472dd99012$var$g(!!n), n[1]) {
            // Pad the fraction out to 9 digits (nanos).
            var r = n[1];
            r = (r + "000000000").substr(0, 9), e = Number(r);
        }
        // Parse the date to get the seconds.
        var i = new Date(t);
        return {
            seconds: Math.floor(i.getTime() / 1e3),
            nanos: e
        };
    }
    return {
        seconds: $6c8154472dd99012$var$se(t.seconds),
        nanos: $6c8154472dd99012$var$se(t.nanos)
    };
}
/**
 * Converts the possible Proto types for numbers into a JavaScript number.
 * Returns 0 if the value is not numeric.
 */ function $6c8154472dd99012$var$se(t) {
    // TODO(bjornick): Handle int64 greater than 53 bits.
    return "number" == typeof t ? t : "string" == typeof t ? Number(t) : 0;
}
/** Converts the possible Proto types for Blobs into a ByteString. */ function $6c8154472dd99012$var$ue(t) {
    return "string" == typeof t ? $6c8154472dd99012$var$X.fromBase64String(t) : $6c8154472dd99012$var$X.fromUint8Array(t);
}
/** Returns a reference value for the provided database and key. */ function $6c8154472dd99012$var$ae(t, e) {
    return {
        referenceValue: "projects/" + t.projectId + "/databases/" + t.database + "/documents/" + e.path.R()
    };
}
/** Returns true if `value` is an IntegerValue . */ function $6c8154472dd99012$var$ce(t) {
    return !!t && "integerValue" in t;
}
/** Returns true if `value` is a DoubleValue. */ /** Returns true if `value` is an ArrayValue. */ function $6c8154472dd99012$var$he(t) {
    return !!t && "arrayValue" in t;
}
/** Returns true if `value` is a NullValue. */ function $6c8154472dd99012$var$fe(t) {
    return !!t && "nullValue" in t;
}
/** Returns true if `value` is NaN. */ function $6c8154472dd99012$var$le(t) {
    return !!t && "doubleValue" in t && isNaN(Number(t.doubleValue));
}
/** Returns true if `value` is a MapValue. */ function $6c8154472dd99012$var$pe(t) {
    return !!t && "mapValue" in t;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $6c8154472dd99012$var$de = {
    asc: "ASCENDING",
    desc: "DESCENDING"
}, $6c8154472dd99012$var$ve = {
    "<": "LESS_THAN",
    "<=": "LESS_THAN_OR_EQUAL",
    ">": "GREATER_THAN",
    ">=": "GREATER_THAN_OR_EQUAL",
    "==": "EQUAL",
    "!=": "NOT_EQUAL",
    "array-contains": "ARRAY_CONTAINS",
    in: "IN",
    "not-in": "NOT_IN",
    "array-contains-any": "ARRAY_CONTAINS_ANY"
}, $6c8154472dd99012$var$ye = function(t, e) {
    this.U = t, this.Qe = e;
};
/**
 * This class generates JsonObject values for the Datastore API suitable for
 * sending to either GRPC stub methods or via the JSON/HTTP REST API.
 *
 * The serializer supports both Protobuf.js and Proto3 JSON formats. By
 * setting `useProto3Json` to true, the serializer will use the Proto3 JSON
 * format.
 *
 * For a description of the Proto3 JSON format check
 * https://developers.google.com/protocol-buffers/docs/proto3#json
 *
 * TODO(klimt): We can remove the databaseId argument if we keep the full
 * resource name in documents.
 */ /**
 * Returns an IntegerValue for `value`.
 */ function $6c8154472dd99012$var$ge(t) {
    return {
        integerValue: "" + t
    };
}
/**
 * Returns an DoubleValue for `value` that is encoded based the serializer's
 * `useProto3Json` setting.
 */ function $6c8154472dd99012$var$me(t, e) {
    if (t.Qe) {
        if (isNaN(e)) return {
            doubleValue: "NaN"
        };
        if (e === 1 / 0) return {
            doubleValue: "Infinity"
        };
        if (e === -1 / 0) return {
            doubleValue: "-Infinity"
        };
    }
    return {
        doubleValue: $6c8154472dd99012$var$at(e) ? "-0" : e
    };
}
/**
 * Returns a value for a number that's appropriate to put into a proto.
 * The return value is an IntegerValue if it can safely represent the value,
 * otherwise a DoubleValue is returned.
 */ function $6c8154472dd99012$var$we(t, e) {
    return $6c8154472dd99012$var$ct(e) ? $6c8154472dd99012$var$ge(e) : $6c8154472dd99012$var$me(t, e);
}
/**
 * Returns a value for a Date that's appropriate to put into a proto.
 */ function $6c8154472dd99012$var$_e(t, e) {
    return t.Qe ? new Date(1e3 * e.seconds).toISOString().replace(/\.\d*/, "").replace("Z", "") + "." + ("000000000" + e.nanoseconds).slice(-9) + "Z" : {
        seconds: "" + e.seconds,
        nanos: e.nanoseconds
    };
}
/**
 * Returns a value for bytes that's appropriate to put in a proto.
 *
 * Visible for testing.
 */ function $6c8154472dd99012$var$be(t, e) {
    return t.Qe ? e.toBase64() : e.toUint8Array();
}
/**
 * Returns a ByteString based on the proto string value.
 */ function $6c8154472dd99012$var$Ie(t, e) {
    return $6c8154472dd99012$var$_e(t, e.Z());
}
function $6c8154472dd99012$var$Ee(t) {
    return $6c8154472dd99012$var$g(!!t), $6c8154472dd99012$var$st.J(function(t) {
        var e = $6c8154472dd99012$var$oe(t);
        return new $6c8154472dd99012$var$ot(e.seconds, e.nanos);
    }(t));
}
function $6c8154472dd99012$var$Te(t, e) {
    return (function(t) {
        return new $6c8154472dd99012$var$E([
            "projects",
            t.projectId,
            "databases",
            t.database
        ]);
    })(t).child("documents").child(e).R();
}
function $6c8154472dd99012$var$Ne(t) {
    var e = $6c8154472dd99012$var$E.g(t);
    return $6c8154472dd99012$var$g($6c8154472dd99012$var$He(e)), e;
}
function $6c8154472dd99012$var$Ae(t, e) {
    return $6c8154472dd99012$var$Te(t.U, e.path);
}
function $6c8154472dd99012$var$Se(t, e) {
    var n = $6c8154472dd99012$var$Ne(e);
    return $6c8154472dd99012$var$g(n.get(1) === t.U.projectId), $6c8154472dd99012$var$g(!n.get(3) && !t.U.database || n.get(3) === t.U.database), new $6c8154472dd99012$var$A($6c8154472dd99012$var$ke(n));
}
function $6c8154472dd99012$var$De(t, e) {
    return $6c8154472dd99012$var$Te(t.U, e);
}
function $6c8154472dd99012$var$xe(t) {
    var e = $6c8154472dd99012$var$Ne(t);
    // In v1beta1 queries for collections at the root did not have a trailing
    // "/documents". In v1 all resource paths contain "/documents". Preserve the
    // ability to read the v1beta1 form for compatibility with queries persisted
    // in the local target cache.
    return 4 === e.length ? $6c8154472dd99012$var$E.P() : $6c8154472dd99012$var$ke(e);
}
function $6c8154472dd99012$var$Le(t) {
    return new $6c8154472dd99012$var$E([
        "projects",
        t.U.projectId,
        "databases",
        t.U.database
    ]).R();
}
function $6c8154472dd99012$var$ke(t) {
    return $6c8154472dd99012$var$g(t.length > 4 && "documents" === t.get(4)), t.u(5) /** Creates a Document proto from key and fields (but no create/update time) */ ;
}
function $6c8154472dd99012$var$Re(t, e, n) {
    return {
        name: $6c8154472dd99012$var$Ae(t, e),
        fields: n.proto.mapValue.fields
    };
}
function $6c8154472dd99012$var$Oe(t, e) {
    var n;
    if (e instanceof $6c8154472dd99012$var$wn) n = {
        update: $6c8154472dd99012$var$Re(t, e.key, e.value)
    };
    else if (e instanceof $6c8154472dd99012$var$Nn) n = {
        delete: $6c8154472dd99012$var$Ae(t, e.key)
    };
    else if (e instanceof $6c8154472dd99012$var$_n) n = {
        update: $6c8154472dd99012$var$Re(t, e.key, e.data),
        updateMask: $6c8154472dd99012$var$Qe(e.We)
    };
    else if (e instanceof $6c8154472dd99012$var$In) n = {
        transform: {
            document: $6c8154472dd99012$var$Ae(t, e.key),
            fieldTransforms: e.fieldTransforms.map(function(t) {
                return function(t, e) {
                    var n = e.transform;
                    if (n instanceof $6c8154472dd99012$var$Ze) return {
                        fieldPath: e.field.R(),
                        setToServerValue: "REQUEST_TIME"
                    };
                    if (n instanceof $6c8154472dd99012$var$tn) return {
                        fieldPath: e.field.R(),
                        appendMissingElements: {
                            values: n.elements
                        }
                    };
                    if (n instanceof $6c8154472dd99012$var$nn) return {
                        fieldPath: e.field.R(),
                        removeAllFromArray: {
                            values: n.elements
                        }
                    };
                    if (n instanceof $6c8154472dd99012$var$on) return {
                        fieldPath: e.field.R(),
                        increment: n.je
                    };
                    throw $6c8154472dd99012$var$y();
                }(0, t);
            })
        }
    };
    else {
        if (!(e instanceof $6c8154472dd99012$var$An)) return $6c8154472dd99012$var$y();
        n = {
            verify: $6c8154472dd99012$var$Ae(t, e.key)
        };
    }
    return e.Ge.Ke || (n.currentDocument = function(t, e) {
        return void 0 !== e.updateTime ? {
            updateTime: $6c8154472dd99012$var$Ie(t, e.updateTime)
        } : void 0 !== e.exists ? {
            exists: e.exists
        } : $6c8154472dd99012$var$y();
    }(t, e.Ge)), n;
}
function $6c8154472dd99012$var$Pe(t, e) {
    var n = e.currentDocument ? function(t) {
        return void 0 !== t.updateTime ? $6c8154472dd99012$var$fn.updateTime($6c8154472dd99012$var$Ee(t.updateTime)) : void 0 !== t.exists ? $6c8154472dd99012$var$fn.exists(t.exists) : $6c8154472dd99012$var$fn.ze();
    }(e.currentDocument) : $6c8154472dd99012$var$fn.ze();
    if (e.update) {
        e.update.name;
        var r = $6c8154472dd99012$var$Se(t, e.update.name), i = new $6c8154472dd99012$var$Sn({
            mapValue: {
                fields: e.update.fields
            }
        });
        if (e.updateMask) {
            var o = function(t) {
                var e = t.fieldPaths || [];
                return new $6c8154472dd99012$var$an(e.map(function(t) {
                    return $6c8154472dd99012$var$N.S(t);
                }));
            }(e.updateMask);
            return new $6c8154472dd99012$var$_n(r, i, o, n);
        }
        return new $6c8154472dd99012$var$wn(r, i, n);
    }
    if (e.delete) {
        var s = $6c8154472dd99012$var$Se(t, e.delete);
        return new $6c8154472dd99012$var$Nn(s, n);
    }
    if (e.transform) {
        var u = $6c8154472dd99012$var$Se(t, e.transform.document), a = e.transform.fieldTransforms.map(function(e) {
            return function(t, e) {
                var n = null;
                if ("setToServerValue" in e) $6c8154472dd99012$var$g("REQUEST_TIME" === e.setToServerValue), n = new $6c8154472dd99012$var$Ze;
                else if ("appendMissingElements" in e) {
                    var r = e.appendMissingElements.values || [];
                    n = new $6c8154472dd99012$var$tn(r);
                } else if ("removeAllFromArray" in e) {
                    var i = e.removeAllFromArray.values || [];
                    n = new $6c8154472dd99012$var$nn(i);
                } else "increment" in e ? n = new $6c8154472dd99012$var$on(t, e.increment) : $6c8154472dd99012$var$y();
                var o = $6c8154472dd99012$var$N.S(e.fieldPath);
                return new $6c8154472dd99012$var$cn(o, n);
            }(t, e);
        });
        return $6c8154472dd99012$var$g(!0 === n.exists), new $6c8154472dd99012$var$In(u, a);
    }
    if (e.verify) {
        var c = $6c8154472dd99012$var$Se(t, e.verify);
        return new $6c8154472dd99012$var$An(c, n);
    }
    return $6c8154472dd99012$var$y();
}
function $6c8154472dd99012$var$Ve(t, e) {
    return {
        documents: [
            $6c8154472dd99012$var$De(t, e.path)
        ]
    };
}
function $6c8154472dd99012$var$Ue(t, e) {
    // Dissect the path into parent, collectionId, and optional key filter.
    var n = {
        structuredQuery: {}
    }, r = e.path;
    null !== e.collectionGroup ? (n.parent = $6c8154472dd99012$var$De(t, r), n.structuredQuery.from = [
        {
            collectionId: e.collectionGroup,
            allDescendants: !0
        }
    ]) : (n.parent = $6c8154472dd99012$var$De(t, r.h()), n.structuredQuery.from = [
        {
            collectionId: r._()
        }
    ]);
    var i = function(t) {
        if (0 !== t.length) {
            var e = t.map(function(t) {
                // visible for testing
                return function(t) {
                    if ("==" /* EQUAL */  === t.op) {
                        if ($6c8154472dd99012$var$le(t.value)) return {
                            unaryFilter: {
                                field: $6c8154472dd99012$var$ze(t.field),
                                op: "IS_NAN"
                            }
                        };
                        if ($6c8154472dd99012$var$fe(t.value)) return {
                            unaryFilter: {
                                field: $6c8154472dd99012$var$ze(t.field),
                                op: "IS_NULL"
                            }
                        };
                    } else if ("!=" /* NOT_EQUAL */  === t.op) {
                        if ($6c8154472dd99012$var$le(t.value)) return {
                            unaryFilter: {
                                field: $6c8154472dd99012$var$ze(t.field),
                                op: "IS_NOT_NAN"
                            }
                        };
                        if ($6c8154472dd99012$var$fe(t.value)) return {
                            unaryFilter: {
                                field: $6c8154472dd99012$var$ze(t.field),
                                op: "IS_NOT_NULL"
                            }
                        };
                    }
                    return {
                        fieldFilter: {
                            field: $6c8154472dd99012$var$ze(t.field),
                            op: $6c8154472dd99012$var$Ge(t.op),
                            value: t.value
                        }
                    };
                }(t);
            });
            return 1 === e.length ? e[0] : {
                compositeFilter: {
                    op: "AND",
                    filters: e
                }
            };
        }
    }(e.filters);
    i && (n.structuredQuery.where = i);
    var o = function(t) {
        if (0 !== t.length) return t.map(function(t) {
            // visible for testing
            return function(t) {
                return {
                    field: $6c8154472dd99012$var$ze(t.field),
                    direction: $6c8154472dd99012$var$je(t.dir)
                };
            }(t);
        });
    }(e.orderBy);
    o && (n.structuredQuery.orderBy = o);
    var s = function(t, e) {
        return t.Qe || $6c8154472dd99012$var$ut(e) ? e : {
            value: e
        };
    }(t, e.limit);
    return null !== s && (n.structuredQuery.limit = s), e.startAt && (n.structuredQuery.startAt = $6c8154472dd99012$var$Me(e.startAt)), e.endAt && (n.structuredQuery.endAt = $6c8154472dd99012$var$Me(e.endAt)), n;
}
function $6c8154472dd99012$var$Ce(t) {
    var e = $6c8154472dd99012$var$xe(t.parent), n = t.structuredQuery, r = n.from ? n.from.length : 0, i = null;
    if (r > 0) {
        $6c8154472dd99012$var$g(1 === r);
        var o = n.from[0];
        o.allDescendants ? i = o.collectionId : e = e.child(o.collectionId);
    }
    var s = [];
    n.where && (s = $6c8154472dd99012$var$Fe(n.where));
    var u = [];
    n.orderBy && (u = n.orderBy.map(function(t) {
        return function(t) {
            return new $6c8154472dd99012$var$fr($6c8154472dd99012$var$Be(t.field), // visible for testing
            function(t) {
                switch(t){
                    case "ASCENDING":
                        return "asc" /* ASCENDING */ ;
                    case "DESCENDING":
                        return "desc" /* DESCENDING */ ;
                    default:
                        return;
                }
            }(t.direction));
        }(t);
    }));
    var a = null;
    n.limit && (a = function(t) {
        var e;
        return $6c8154472dd99012$var$ut(e = "object" == typeof t ? t.value : t) ? null : e;
    }(n.limit));
    var c = null;
    n.startAt && (c = $6c8154472dd99012$var$qe(n.startAt));
    var h = null;
    return n.endAt && (h = $6c8154472dd99012$var$qe(n.endAt)), $6c8154472dd99012$var$zn($6c8154472dd99012$var$Vn(e, i, u, s, a, "F" /* First */ , c, h));
}
function $6c8154472dd99012$var$Fe(t) {
    return t ? void 0 !== t.unaryFilter ? [
        $6c8154472dd99012$var$Ke(t)
    ] : void 0 !== t.fieldFilter ? [
        $6c8154472dd99012$var$We(t)
    ] : void 0 !== t.compositeFilter ? t.compositeFilter.filters.map(function(t) {
        return $6c8154472dd99012$var$Fe(t);
    }).reduce(function(t, e) {
        return t.concat(e);
    }) : $6c8154472dd99012$var$y() : [];
}
function $6c8154472dd99012$var$Me(t) {
    return {
        before: t.before,
        values: t.position
    };
}
function $6c8154472dd99012$var$qe(t) {
    var e = !!t.before, n = t.values || [];
    return new $6c8154472dd99012$var$ur(n, e);
}
// visible for testing
function $6c8154472dd99012$var$je(t) {
    return $6c8154472dd99012$var$de[t];
}
function $6c8154472dd99012$var$Ge(t) {
    return $6c8154472dd99012$var$ve[t];
}
function $6c8154472dd99012$var$ze(t) {
    return {
        fieldPath: t.R()
    };
}
function $6c8154472dd99012$var$Be(t) {
    return $6c8154472dd99012$var$N.S(t.fieldPath);
}
function $6c8154472dd99012$var$We(t) {
    return $6c8154472dd99012$var$Jn.create($6c8154472dd99012$var$Be(t.fieldFilter.field), function(t) {
        switch(t){
            case "EQUAL":
                return "==" /* EQUAL */ ;
            case "NOT_EQUAL":
                return "!=" /* NOT_EQUAL */ ;
            case "GREATER_THAN":
                return ">" /* GREATER_THAN */ ;
            case "GREATER_THAN_OR_EQUAL":
                return ">=" /* GREATER_THAN_OR_EQUAL */ ;
            case "LESS_THAN":
                return "<" /* LESS_THAN */ ;
            case "LESS_THAN_OR_EQUAL":
                return "<=" /* LESS_THAN_OR_EQUAL */ ;
            case "ARRAY_CONTAINS":
                return "array-contains" /* ARRAY_CONTAINS */ ;
            case "IN":
                return "in" /* IN */ ;
            case "NOT_IN":
                return "not-in" /* NOT_IN */ ;
            case "ARRAY_CONTAINS_ANY":
                return "array-contains-any" /* ARRAY_CONTAINS_ANY */ ;
            case "OPERATOR_UNSPECIFIED":
            default:
                return $6c8154472dd99012$var$y();
        }
    }(t.fieldFilter.op), t.fieldFilter.value);
}
function $6c8154472dd99012$var$Ke(t) {
    switch(t.unaryFilter.op){
        case "IS_NAN":
            var e = $6c8154472dd99012$var$Be(t.unaryFilter.field);
            return $6c8154472dd99012$var$Jn.create(e, "==" /* EQUAL */ , {
                doubleValue: NaN
            });
        case "IS_NULL":
            var n = $6c8154472dd99012$var$Be(t.unaryFilter.field);
            return $6c8154472dd99012$var$Jn.create(n, "==" /* EQUAL */ , {
                nullValue: "NULL_VALUE"
            });
        case "IS_NOT_NAN":
            var r = $6c8154472dd99012$var$Be(t.unaryFilter.field);
            return $6c8154472dd99012$var$Jn.create(r, "!=" /* NOT_EQUAL */ , {
                doubleValue: NaN
            });
        case "IS_NOT_NULL":
            var i = $6c8154472dd99012$var$Be(t.unaryFilter.field);
            return $6c8154472dd99012$var$Jn.create(i, "!=" /* NOT_EQUAL */ , {
                nullValue: "NULL_VALUE"
            });
        case "OPERATOR_UNSPECIFIED":
        default:
            return $6c8154472dd99012$var$y();
    }
}
function $6c8154472dd99012$var$Qe(t) {
    var e = [];
    return t.fields.forEach(function(t) {
        return e.push(t.R());
    }), {
        fieldPaths: e
    };
}
function $6c8154472dd99012$var$He(t) {
    // Resource names have at least 4 components (project ID, database ID)
    return t.length >= 4 && "projects" === t.get(0) && "databases" === t.get(2);
}
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Represents a transform within a TransformMutation. */ var $6c8154472dd99012$var$Ye = function() {
    // Make sure that the structural type of `TransformOperation` is unique.
    // See https://github.com/microsoft/TypeScript/issues/5451
    this.He = void 0;
};
/**
 * Computes the local transform result against the provided `previousValue`,
 * optionally using the provided localWriteTime.
 */ function $6c8154472dd99012$var$$e(t, e, n) {
    return t instanceof $6c8154472dd99012$var$Ze ? function(t, e) {
        var n = {
            fields: {
                __type__: {
                    stringValue: "server_timestamp"
                },
                __local_write_time__: {
                    timestampValue: {
                        seconds: t.seconds,
                        nanos: t.nanoseconds
                    }
                }
            }
        };
        return e && (n.fields.__previous_value__ = e), {
            mapValue: n
        };
    }(n, e) : t instanceof $6c8154472dd99012$var$tn ? $6c8154472dd99012$var$en(t, e) : t instanceof $6c8154472dd99012$var$nn ? $6c8154472dd99012$var$rn(t, e) : function(t, e) {
        // PORTING NOTE: Since JavaScript's integer arithmetic is limited to 53 bit
        // precision and resolves overflows by reducing precision, we do not
        // manually cap overflows at 2^63.
        var n = $6c8154472dd99012$var$Je(t, e), r = $6c8154472dd99012$var$sn(n) + $6c8154472dd99012$var$sn(t.je);
        return $6c8154472dd99012$var$ce(n) && $6c8154472dd99012$var$ce(t.je) ? $6c8154472dd99012$var$ge(r) : $6c8154472dd99012$var$me(t.serializer, r);
    }(t, e);
}
/**
 * Computes a final transform result after the transform has been acknowledged
 * by the server, potentially using the server-provided transformResult.
 */ function $6c8154472dd99012$var$Xe(t, e, n) {
    // The server just sends null as the transform result for array operations,
    // so we have to calculate a result the same as we do for local
    // applications.
    return t instanceof $6c8154472dd99012$var$tn ? $6c8154472dd99012$var$en(t, e) : t instanceof $6c8154472dd99012$var$nn ? $6c8154472dd99012$var$rn(t, e) : n;
}
/**
 * If this transform operation is not idempotent, returns the base value to
 * persist for this transform. If a base value is returned, the transform
 * operation is always applied to this base value, even if document has
 * already been updated.
 *
 * Base values provide consistent behavior for non-idempotent transforms and
 * allow us to return the same latency-compensated value even if the backend
 * has already applied the transform operation. The base value is null for
 * idempotent transforms, as they can be re-played even if the backend has
 * already applied them.
 *
 * @return a base value to store along with the mutation, or null for
 * idempotent transforms.
 */ function $6c8154472dd99012$var$Je(t, e) {
    var n;
    return t instanceof $6c8154472dd99012$var$on ? $6c8154472dd99012$var$ce(n = e) || function(t) {
        return !!t && "doubleValue" in t;
    }(n) ? e : {
        integerValue: 0
    } : null;
}
/** Transforms a value into a server-generated timestamp. */ var $6c8154472dd99012$var$Ze = /** @class */ function(e) {
    function n() {
        return null !== e && e.apply(this, arguments) || this;
    }
    return $876a70688d8d7977$export$a8ba968b8961cb8a(n, e), n;
}($6c8154472dd99012$var$Ye), $6c8154472dd99012$var$tn = /** @class */ function(e) {
    function n(t) {
        var n = this;
        return (n = e.call(this) || this).elements = t, n;
    }
    return $876a70688d8d7977$export$a8ba968b8961cb8a(n, e), n;
}($6c8154472dd99012$var$Ye);
/** Transforms an array value via a union operation. */ function $6c8154472dd99012$var$en(t, e) {
    for(var n = $6c8154472dd99012$var$un(e), r = function(t) {
        n.some(function(e) {
            return $6c8154472dd99012$var$Zt(e, t);
        }) || n.push(t);
    }, i = 0, o = t.elements; i < o.length; i++)r(o[i]);
    return {
        arrayValue: {
            values: n
        }
    };
}
/** Transforms an array value via a remove operation. */ var $6c8154472dd99012$var$nn = /** @class */ function(e) {
    function n(t) {
        var n = this;
        return (n = e.call(this) || this).elements = t, n;
    }
    return $876a70688d8d7977$export$a8ba968b8961cb8a(n, e), n;
}($6c8154472dd99012$var$Ye);
function $6c8154472dd99012$var$rn(t, e) {
    for(var n = $6c8154472dd99012$var$un(e), r = function(t) {
        n = n.filter(function(e) {
            return !$6c8154472dd99012$var$Zt(e, t);
        });
    }, i = 0, o = t.elements; i < o.length; i++)r(o[i]);
    return {
        arrayValue: {
            values: n
        }
    };
}
/**
 * Implements the backend semantics for locally computed NUMERIC_ADD (increment)
 * transforms. Converts all field values to integers or doubles, but unlike the
 * backend does not cap integer values at 2^63. Instead, JavaScript number
 * arithmetic is used and precision loss can occur for values greater than 2^53.
 */ var $6c8154472dd99012$var$on = /** @class */ function(e) {
    function n(t, n) {
        var r = this;
        return (r = e.call(this) || this).serializer = t, r.je = n, r;
    }
    return $876a70688d8d7977$export$a8ba968b8961cb8a(n, e), n;
}($6c8154472dd99012$var$Ye);
function $6c8154472dd99012$var$sn(t) {
    return $6c8154472dd99012$var$se(t.integerValue || t.doubleValue);
}
function $6c8154472dd99012$var$un(t) {
    return $6c8154472dd99012$var$he(t) && t.arrayValue.values ? t.arrayValue.values.slice() : [];
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provides a set of fields that can be used to partially patch a document.
 * FieldMask is used in conjunction with ObjectValue.
 * Examples:
 *   foo - Overwrites foo entirely with the provided value. If foo is not
 *         present in the companion ObjectValue, the field is deleted.
 *   foo.bar - Overwrites only the field bar of the object foo.
 *             If foo is not an object, foo is replaced with an object
 *             containing foo
 */ var $6c8154472dd99012$var$an = /** @class */ function() {
    function t(t) {
        this.fields = t, // TODO(dimond): validation of FieldMask
        // Sort the field mask to support `FieldMask.isEqual()` and assert below.
        t.sort($6c8154472dd99012$var$N.i) /**
     * Verifies that `fieldPath` is included by at least one field in this field
     * mask.
     *
     * This is an O(n) operation, where `n` is the size of the field mask.
     */ ;
    }
    return t.prototype.Ye = function(t) {
        for(var e = 0, n = this.fields; e < n.length; e++){
            if (n[e].T(t)) return !0;
        }
        return !1;
    }, t.prototype.isEqual = function(t) {
        return $6c8154472dd99012$var$Y(this.fields, t.fields, function(t, e) {
            return t.isEqual(e);
        });
    }, t;
}(), $6c8154472dd99012$var$cn = function(t, e) {
    this.field = t, this.transform = e;
};
/** A field path and the TransformOperation to perform upon it. */ /** The result of successfully applying a mutation to the backend. */ var $6c8154472dd99012$var$hn = function(/**
     * The version at which the mutation was committed:
     *
     * - For most operations, this is the updateTime in the WriteResult.
     * - For deletes, the commitTime of the WriteResponse (because deletes are
     *   not stored and have no updateTime).
     *
     * Note that these versions can be different: No-op writes will not change
     * the updateTime even though the commitTime advances.
     */ t, /**
     * The resulting fields returned from the backend after a
     * TransformMutation has been committed. Contains one FieldValue for each
     * FieldTransform that was in the mutation.
     *
     * Will be null if the mutation was not a TransformMutation.
     */ e) {
    this.version = t, this.transformResults = e;
}, $6c8154472dd99012$var$fn = /** @class */ function() {
    function t(t, e) {
        this.updateTime = t, this.exists = e /** Creates a new empty Precondition. */ ;
    }
    return t.ze = function() {
        return new t;
    }, /** Creates a new Precondition with an exists flag. */ t.exists = function(e) {
        return new t(void 0, e);
    }, /** Creates a new Precondition based on a version a document exists at. */ t.updateTime = function(e) {
        return new t(e);
    }, Object.defineProperty(t.prototype, "Ke", {
        /** Returns whether this Precondition is empty. */ get: function() {
            return void 0 === this.updateTime && void 0 === this.exists;
        },
        enumerable: !1,
        configurable: !0
    }), t.prototype.isEqual = function(t) {
        return this.exists === t.exists && (this.updateTime ? !!t.updateTime && this.updateTime.isEqual(t.updateTime) : !t.updateTime);
    }, t;
}();
/**
 * Encodes a precondition for a mutation. This follows the model that the
 * backend accepts with the special case of an explicit "empty" precondition
 * (meaning no precondition).
 */ /**
 * Returns true if the preconditions is valid for the given document
 * (or null if no document is available).
 */ function $6c8154472dd99012$var$ln(t, e) {
    return void 0 !== t.updateTime ? e instanceof $6c8154472dd99012$var$kn && e.version.isEqual(t.updateTime) : void 0 === t.exists || t.exists === e instanceof $6c8154472dd99012$var$kn;
}
/**
 * A mutation describes a self-contained change to a document. Mutations can
 * create, replace, delete, and update subsets of documents.
 *
 * Mutations not only act on the value of the document but also its version.
 *
 * For local mutations (mutations that haven't been committed yet), we preserve
 * the existing version for Set, Patch, and Transform mutations. For Delete
 * mutations, we reset the version to 0.
 *
 * Here's the expected transition table.
 *
 * MUTATION           APPLIED TO            RESULTS IN
 *
 * SetMutation        Document(v3)          Document(v3)
 * SetMutation        NoDocument(v3)        Document(v0)
 * SetMutation        null                  Document(v0)
 * PatchMutation      Document(v3)          Document(v3)
 * PatchMutation      NoDocument(v3)        NoDocument(v3)
 * PatchMutation      null                  null
 * TransformMutation  Document(v3)          Document(v3)
 * TransformMutation  NoDocument(v3)        NoDocument(v3)
 * TransformMutation  null                  null
 * DeleteMutation     Document(v3)          NoDocument(v0)
 * DeleteMutation     NoDocument(v3)        NoDocument(v0)
 * DeleteMutation     null                  NoDocument(v0)
 *
 * For acknowledged mutations, we use the updateTime of the WriteResponse as
 * the resulting version for Set, Patch, and Transform mutations. As deletes
 * have no explicit update time, we use the commitTime of the WriteResponse for
 * Delete mutations.
 *
 * If a mutation is acknowledged by the backend but fails the precondition check
 * locally, we return an `UnknownDocument` and rely on Watch to send us the
 * updated version.
 *
 * Note that TransformMutations don't create Documents (in the case of being
 * applied to a NoDocument), even though they would on the backend. This is
 * because the client always combines the TransformMutation with a SetMutation
 * or PatchMutation and we only want to apply the transform if the prior
 * mutation resulted in a Document (always true for a SetMutation, but not
 * necessarily for a PatchMutation).
 *
 * ## Subclassing Notes
 *
 * Subclasses of Mutation need to implement applyToRemoteDocument() and
 * applyToLocalView() to implement the actual behavior of applying the mutation
 * to some source document.
 */ var $6c8154472dd99012$var$pn = function() {};
/**
 * Applies this mutation to the given MaybeDocument or null for the purposes
 * of computing a new remote document. If the input document doesn't match the
 * expected state (e.g. it is null or outdated), an `UnknownDocument` can be
 * returned.
 *
 * @param mutation The mutation to apply.
 * @param maybeDoc The document to mutate. The input document can be null if
 *     the client has no knowledge of the pre-mutation state of the document.
 * @param mutationResult The result of applying the mutation from the backend.
 * @return The mutated document. The returned document may be an
 *     UnknownDocument if the mutation could not be applied to the locally
 *     cached base document.
 */ function $6c8154472dd99012$var$dn(t, e, n) {
    return t instanceof $6c8154472dd99012$var$wn ? function(t, e, n) {
        // Unlike applySetMutationToLocalView, if we're applying a mutation to a
        // remote document the server has accepted the mutation so the precondition
        // must have held.
        return new $6c8154472dd99012$var$kn(t.key, n.version, t.value, {
            hasCommittedMutations: !0
        });
    }(t, 0, n) : t instanceof $6c8154472dd99012$var$_n ? function(t, e, n) {
        if (!$6c8154472dd99012$var$ln(t.Ge, e)) // Since the mutation was not rejected, we know that the  precondition
        // matched on the backend. We therefore must not have the expected version
        // of the document in our cache and return an UnknownDocument with the
        // known updateTime.
        return new $6c8154472dd99012$var$On(t.key, n.version);
        var r = $6c8154472dd99012$var$bn(t, e);
        return new $6c8154472dd99012$var$kn(t.key, n.version, r, {
            hasCommittedMutations: !0
        });
    }(t, e, n) : t instanceof $6c8154472dd99012$var$In ? function(t, e, n) {
        if ($6c8154472dd99012$var$g(null != n.transformResults), !$6c8154472dd99012$var$ln(t.Ge, e)) // Since the mutation was not rejected, we know that the  precondition
        // matched on the backend. We therefore must not have the expected version
        // of the document in our cache and return an UnknownDocument with the
        // known updateTime.
        return new $6c8154472dd99012$var$On(t.key, n.version);
        var r = $6c8154472dd99012$var$En(t, e), i = /**
 * Creates a list of "transform results" (a transform result is a field value
 * representing the result of applying a transform) for use after a
 * TransformMutation has been acknowledged by the server.
 *
 * @param fieldTransforms The field transforms to apply the result to.
 * @param baseDoc The document prior to applying this mutation batch.
 * @param serverTransformResults The transform results received by the server.
 * @return The transform results list.
 */ function(t, e, n) {
            var r = [];
            $6c8154472dd99012$var$g(t.length === n.length);
            for(var i = 0; i < n.length; i++){
                var o = t[i], s = o.transform, u = null;
                e instanceof $6c8154472dd99012$var$kn && (u = e.field(o.field)), r.push($6c8154472dd99012$var$Xe(s, u, n[i]));
            }
            return r;
        }(t.fieldTransforms, e, n.transformResults), o = n.version, s = $6c8154472dd99012$var$Tn(t, r.data(), i);
        return new $6c8154472dd99012$var$kn(t.key, o, s, {
            hasCommittedMutations: !0
        });
    }(t, e, n) : function(t, e, n) {
        // Unlike applyToLocalView, if we're applying a mutation to a remote
        // document the server has accepted the mutation so the precondition must
        // have held.
        return new $6c8154472dd99012$var$Rn(t.key, n.version, {
            hasCommittedMutations: !0
        });
    }(t, 0, n);
}
/**
 * Applies this mutation to the given MaybeDocument or null for the purposes
 * of computing the new local view of a document. Both the input and returned
 * documents can be null.
 *
 * @param mutation The mutation to apply.
 * @param maybeDoc The document to mutate. The input document can be null if
 *     the client has no knowledge of the pre-mutation state of the document.
 * @param baseDoc The state of the document prior to this mutation batch. The
 *     input document can be null if the client has no knowledge of the
 *     pre-mutation state of the document.
 * @param localWriteTime A timestamp indicating the local write time of the
 *     batch this mutation is a part of.
 * @return The mutated document. The returned document may be null, but only
 *     if maybeDoc was null and the mutation would not create a new document.
 */ function $6c8154472dd99012$var$vn(t, e, n, r) {
    return t instanceof $6c8154472dd99012$var$wn ? function(t, e) {
        if (!$6c8154472dd99012$var$ln(t.Ge, e)) return e;
        var n = $6c8154472dd99012$var$mn(e);
        return new $6c8154472dd99012$var$kn(t.key, n, t.value, {
            Je: !0
        });
    }(t, e) : t instanceof $6c8154472dd99012$var$_n ? function(t, e) {
        if (!$6c8154472dd99012$var$ln(t.Ge, e)) return e;
        var n = $6c8154472dd99012$var$mn(e), r = $6c8154472dd99012$var$bn(t, e);
        return new $6c8154472dd99012$var$kn(t.key, n, r, {
            Je: !0
        });
    }(t, e) : t instanceof $6c8154472dd99012$var$In ? function(t, e, n, r) {
        if (!$6c8154472dd99012$var$ln(t.Ge, e)) return e;
        var i = $6c8154472dd99012$var$En(t, e), o = function(t, e, n, r) {
            for(var i = [], o = 0, s = t; o < s.length; o++){
                var u = s[o], a = u.transform, c = null;
                n instanceof $6c8154472dd99012$var$kn && (c = n.field(u.field)), null === c && r instanceof $6c8154472dd99012$var$kn && // If the current document does not contain a value for the mutated
                // field, use the value that existed before applying this mutation
                // batch. This solves an edge case where a PatchMutation clears the
                // values in a nested map before the TransformMutation is applied.
                (c = r.field(u.field)), i.push($6c8154472dd99012$var$$e(a, c, e));
            }
            return i;
        }(t.fieldTransforms, n, e, r), s = $6c8154472dd99012$var$Tn(t, i.data(), o);
        return new $6c8154472dd99012$var$kn(t.key, i.version, s, {
            Je: !0
        });
    }(t, e, r, n) : function(t, e) {
        return $6c8154472dd99012$var$ln(t.Ge, e) ? new $6c8154472dd99012$var$Rn(t.key, $6c8154472dd99012$var$st.min()) : e;
    }(t, e);
}
/**
 * If this mutation is not idempotent, returns the base value to persist with
 * this mutation. If a base value is returned, the mutation is always applied
 * to this base value, even if document has already been updated.
 *
 * The base value is a sparse object that consists of only the document
 * fields for which this mutation contains a non-idempotent transformation
 * (e.g. a numeric increment). The provided value guarantees consistent
 * behavior for non-idempotent transforms and allow us to return the same
 * latency-compensated value even if the backend has already applied the
 * mutation. The base value is null for idempotent mutations, as they can be
 * re-played even if the backend has already applied them.
 *
 * @return a base value to store along with the mutation, or null for
 * idempotent mutations.
 */ function $6c8154472dd99012$var$yn(t, e) {
    return t instanceof $6c8154472dd99012$var$In ? function(t, e) {
        for(var n = null, r = 0, i = t.fieldTransforms; r < i.length; r++){
            var o = i[r], s = e instanceof $6c8154472dd99012$var$kn ? e.field(o.field) : void 0, u = $6c8154472dd99012$var$Je(o.transform, s || null);
            null != u && (n = null == n ? (new $6c8154472dd99012$var$Dn).set(o.field, u) : n.set(o.field, u));
        }
        return n ? n.Xe() : null;
    }(t, e) : null;
}
function $6c8154472dd99012$var$gn(t, e) {
    return t.type === e.type && !!t.key.isEqual(e.key) && !!t.Ge.isEqual(e.Ge) && (0 /* Set */  === t.type ? t.value.isEqual(e.value) : 1 /* Patch */  === t.type ? t.data.isEqual(e.data) && t.We.isEqual(e.We) : 2 /* Transform */  !== t.type || $6c8154472dd99012$var$Y(t.fieldTransforms, t.fieldTransforms, function(t, e) {
        return function(t, e) {
            return t.field.isEqual(e.field) && function(t, e) {
                return t instanceof $6c8154472dd99012$var$tn && e instanceof $6c8154472dd99012$var$tn || t instanceof $6c8154472dd99012$var$nn && e instanceof $6c8154472dd99012$var$nn ? $6c8154472dd99012$var$Y(t.elements, e.elements, $6c8154472dd99012$var$Zt) : t instanceof $6c8154472dd99012$var$on && e instanceof $6c8154472dd99012$var$on ? $6c8154472dd99012$var$Zt(t.je, e.je) : t instanceof $6c8154472dd99012$var$Ze && e instanceof $6c8154472dd99012$var$Ze;
            }(t.transform, e.transform);
        }(t, e);
    }));
}
/**
 * Returns the version from the given document for use as the result of a
 * mutation. Mutations are defined to return the version of the base document
 * only if it is an existing document. Deleted and unknown documents have a
 * post-mutation version of SnapshotVersion.min().
 */ function $6c8154472dd99012$var$mn(t) {
    return t instanceof $6c8154472dd99012$var$kn ? t.version : $6c8154472dd99012$var$st.min();
}
/**
 * A mutation that creates or replaces the document at the given key with the
 * object value contents.
 */ var $6c8154472dd99012$var$wn = /** @class */ function(e) {
    function n(t, n, r) {
        var i = this;
        return (i = e.call(this) || this).key = t, i.value = n, i.Ge = r, i.type = 0 /* Set */ , i;
    }
    return $876a70688d8d7977$export$a8ba968b8961cb8a(n, e), n;
}($6c8154472dd99012$var$pn), $6c8154472dd99012$var$_n = /** @class */ function(e) {
    function n(t, n, r, i) {
        var o = this;
        return (o = e.call(this) || this).key = t, o.data = n, o.We = r, o.Ge = i, o.type = 1 /* Patch */ , o;
    }
    return $876a70688d8d7977$export$a8ba968b8961cb8a(n, e), n;
}($6c8154472dd99012$var$pn);
function $6c8154472dd99012$var$bn(t, e) {
    return function(t, e) {
        var n = new $6c8154472dd99012$var$Dn(e);
        return t.We.fields.forEach(function(e) {
            if (!e.m()) {
                var r = t.data.field(e);
                null !== r ? n.set(e, r) : n.delete(e);
            }
        }), n.Xe();
    }(t, e instanceof $6c8154472dd99012$var$kn ? e.data() : $6c8154472dd99012$var$Sn.empty());
}
var $6c8154472dd99012$var$In = /** @class */ function(e) {
    function n(t, n) {
        var r = this;
        return (r = e.call(this) || this).key = t, r.fieldTransforms = n, r.type = 2 /* Transform */ , // NOTE: We set a precondition of exists: true as a safety-check, since we
        // always combine TransformMutations with a SetMutation or PatchMutation which
        // (if successful) should end up with an existing document.
        r.Ge = $6c8154472dd99012$var$fn.exists(!0), r;
    }
    return $876a70688d8d7977$export$a8ba968b8961cb8a(n, e), n;
}($6c8154472dd99012$var$pn);
function $6c8154472dd99012$var$En(t, e) {
    return e;
}
function $6c8154472dd99012$var$Tn(t, e, n) {
    for(var r = new $6c8154472dd99012$var$Dn(e), i = 0; i < t.fieldTransforms.length; i++){
        var o = t.fieldTransforms[i];
        r.set(o.field, n[i]);
    }
    return r.Xe();
}
/** A mutation that deletes the document at the given key. */ var $6c8154472dd99012$var$Nn = /** @class */ function(e) {
    function n(t, n) {
        var r = this;
        return (r = e.call(this) || this).key = t, r.Ge = n, r.type = 3 /* Delete */ , r;
    }
    return $876a70688d8d7977$export$a8ba968b8961cb8a(n, e), n;
}($6c8154472dd99012$var$pn), $6c8154472dd99012$var$An = /** @class */ function(e) {
    function n(t, n) {
        var r = this;
        return (r = e.call(this) || this).key = t, r.Ge = n, r.type = 4 /* Verify */ , r;
    }
    return $876a70688d8d7977$export$a8ba968b8961cb8a(n, e), n;
}($6c8154472dd99012$var$pn), $6c8154472dd99012$var$Sn = /** @class */ function() {
    function t(t) {
        this.proto = t;
    }
    return t.empty = function() {
        return new t({
            mapValue: {}
        });
    }, /**
     * Returns the value at the given path or null.
     *
     * @param path the path to search
     * @return The value at the path or if there it doesn't exist.
     */ t.prototype.field = function(t) {
        if (t.m()) return this.proto;
        for(var e = this.proto, n = 0; n < t.length - 1; ++n){
            if (!e.mapValue.fields) return null;
            if (!$6c8154472dd99012$var$pe(e = e.mapValue.fields[t.get(n)])) return null;
        }
        return (e = (e.mapValue.fields || {})[t._()]) || null;
    }, t.prototype.isEqual = function(t) {
        return $6c8154472dd99012$var$Zt(this.proto, t.proto);
    }, t;
}(), $6c8154472dd99012$var$Dn = /** @class */ function() {
    /**
     * @param baseObject The object to mutate.
     */ function t(t) {
        void 0 === t && (t = $6c8154472dd99012$var$Sn.empty()), this.Ze = t, /** A map that contains the accumulated changes in this builder. */ this.tn = new Map;
    }
    /**
     * Sets the field to the provided value.
     *
     * @param path The field path to set.
     * @param value The value to set.
     * @return The current Builder instance.
     */ return t.prototype.set = function(t, e) {
        return this.en(t, e), this;
    }, /**
     * Removes the field at the specified path. If there is no field at the
     * specified path, nothing is changed.
     *
     * @param path The field path to remove.
     * @return The current Builder instance.
     */ t.prototype.delete = function(t) {
        return this.en(t, null), this;
    }, /**
     * Adds `value` to the overlay map at `path`. Creates nested map entries if
     * needed.
     */ t.prototype.en = function(t, e) {
        for(var n = this.tn, r = 0; r < t.length - 1; ++r){
            var i = t.get(r), o = n.get(i);
            o instanceof Map ? // Re-use a previously created map
            n = o : o && 10 /* ObjectValue */  === $6c8154472dd99012$var$Jt(o) ? // Convert the existing Protobuf MapValue into a map
            (o = new Map(Object.entries(o.mapValue.fields || {})), n.set(i, o), n = o) : // Create an empty map to represent the current nesting level
            (o = new Map, n.set(i, o), n = o);
        }
        n.set(t._(), e);
    }, /** Returns an ObjectValue with all mutations applied. */ t.prototype.Xe = function() {
        var t = this.nn($6c8154472dd99012$var$N.P(), this.tn);
        return null != t ? new $6c8154472dd99012$var$Sn(t) : this.Ze;
    }, /**
     * Applies any overlays from `currentOverlays` that exist at `currentPath`
     * and returns the merged data at `currentPath` (or null if there were no
     * changes).
     *
     * @param currentPath The path at the current nesting level. Can be set to
     * FieldValue.emptyPath() to represent the root.
     * @param currentOverlays The overlays at the current nesting level in the
     * same format as `overlayMap`.
     * @return The merged data at `currentPath` or null if no modifications
     * were applied.
     */ t.prototype.nn = function(t, e) {
        var n = this, r = !1, i = this.Ze.field(t), o = $6c8154472dd99012$var$pe(i) ? Object.assign({}, i.mapValue.fields) : {};
        return e.forEach(function(e, i) {
            if (e instanceof Map) {
                var s = n.nn(t.child(i), e);
                null != s && (o[i] = s, r = !0);
            } else null !== e ? (o[i] = e, r = !0) : o.hasOwnProperty(i) && (delete o[i], r = !0);
        }), r ? {
            mapValue: {
                fields: o
            }
        } : null;
    }, t;
}();
/**
 * Returns a FieldMask built from all fields in a MapValue.
 */ function $6c8154472dd99012$var$xn(t) {
    var e = [];
    return $6c8154472dd99012$var$_(t.fields || {}, function(t, n) {
        var r = new $6c8154472dd99012$var$N([
            t
        ]);
        if ($6c8154472dd99012$var$pe(n)) {
            var i = $6c8154472dd99012$var$xn(n.mapValue).fields;
            if (0 === i.length) // Preserve the empty map by adding it to the FieldMask.
            e.push(r);
            else // For nested and non-empty ObjectValues, add the FieldPath of the
            // leaf nodes.
            for(var o = 0, s = i; o < s.length; o++){
                var u = s[o];
                e.push(r.child(u));
            }
        } else // For nested and non-empty ObjectValues, add the FieldPath of the leaf
        // nodes.
        e.push(r);
    }), new $6c8154472dd99012$var$an(e) /**
 * The result of a lookup for a given path may be an existing document or a
 * marker that this document does not exist at a given version.
 */ ;
}
var $6c8154472dd99012$var$Ln = function(t, e) {
    this.key = t, this.version = e;
}, $6c8154472dd99012$var$kn = /** @class */ function(e) {
    function n(t, n, r, i) {
        var o = this;
        return (o = e.call(this, t, n) || this).sn = r, o.Je = !!i.Je, o.hasCommittedMutations = !!i.hasCommittedMutations, o;
    }
    return $876a70688d8d7977$export$a8ba968b8961cb8a(n, e), n.prototype.field = function(t) {
        return this.sn.field(t);
    }, n.prototype.data = function() {
        return this.sn;
    }, n.prototype.rn = function() {
        return this.sn.proto;
    }, n.prototype.isEqual = function(t) {
        return t instanceof n && this.key.isEqual(t.key) && this.version.isEqual(t.version) && this.Je === t.Je && this.hasCommittedMutations === t.hasCommittedMutations && this.sn.isEqual(t.sn);
    }, n.prototype.toString = function() {
        return "Document(" + this.key + ", " + this.version + ", " + this.sn.toString() + ", {hasLocalMutations: " + this.Je + "}), {hasCommittedMutations: " + this.hasCommittedMutations + "})";
    }, Object.defineProperty(n.prototype, "hasPendingWrites", {
        get: function() {
            return this.Je || this.hasCommittedMutations;
        },
        enumerable: !1,
        configurable: !0
    }), n;
}($6c8154472dd99012$var$Ln), $6c8154472dd99012$var$Rn = /** @class */ function(e) {
    function n(t, n, r) {
        var i = this;
        return (i = e.call(this, t, n) || this).hasCommittedMutations = !(!r || !r.hasCommittedMutations), i;
    }
    return $876a70688d8d7977$export$a8ba968b8961cb8a(n, e), n.prototype.toString = function() {
        return "NoDocument(" + this.key + ", " + this.version + ")";
    }, Object.defineProperty(n.prototype, "hasPendingWrites", {
        get: function() {
            return this.hasCommittedMutations;
        },
        enumerable: !1,
        configurable: !0
    }), n.prototype.isEqual = function(t) {
        return t instanceof n && t.hasCommittedMutations === this.hasCommittedMutations && t.version.isEqual(this.version) && t.key.isEqual(this.key);
    }, n;
}($6c8154472dd99012$var$Ln), $6c8154472dd99012$var$On = /** @class */ function(e) {
    function n() {
        return null !== e && e.apply(this, arguments) || this;
    }
    return $876a70688d8d7977$export$a8ba968b8961cb8a(n, e), n.prototype.toString = function() {
        return "UnknownDocument(" + this.key + ", " + this.version + ")";
    }, Object.defineProperty(n.prototype, "hasPendingWrites", {
        get: function() {
            return !0;
        },
        enumerable: !1,
        configurable: !0
    }), n.prototype.isEqual = function(t) {
        return t instanceof n && t.version.isEqual(this.version) && t.key.isEqual(this.key);
    }, n;
}($6c8154472dd99012$var$Ln), $6c8154472dd99012$var$Pn = /**
     * Initializes a Query with a path and optional additional query constraints.
     * Path must currently be empty if this is a collection group query.
     */ function(t, e, n, r, i, o /* First */ , s, u) {
    void 0 === e && (e = null), void 0 === n && (n = []), void 0 === r && (r = []), void 0 === i && (i = null), void 0 === o && (o = "F"), void 0 === s && (s = null), void 0 === u && (u = null), this.path = t, this.collectionGroup = e, this.on = n, this.filters = r, this.limit = i, this.an = o, this.startAt = s, this.endAt = u, this.cn = null, // The corresponding `Target` of this `Query` instance.
    this.un = null, this.startAt, this.endAt;
};
/**
 * Represents a document in Firestore with a key, version, data and whether the
 * data has local mutations applied to it.
 */ /** Creates a new Query instance with the options provided. */ function $6c8154472dd99012$var$Vn(t, e, n, r, i, o, s, u) {
    return new $6c8154472dd99012$var$Pn(t, e, n, r, i, o, s, u);
}
/** Creates a new Query for a query that matches all documents at `path` */ function $6c8154472dd99012$var$Un(t) {
    return new $6c8154472dd99012$var$Pn(t);
}
/**
 * Helper to convert a collection group query into a collection query at a
 * specific path. This is used when executing collection group queries, since
 * we have to split the query into a set of collection queries at multiple
 * paths.
 */ function $6c8154472dd99012$var$Cn(t) {
    return !$6c8154472dd99012$var$ut(t.limit) && "F" /* First */  === t.an;
}
function $6c8154472dd99012$var$Fn(t) {
    return !$6c8154472dd99012$var$ut(t.limit) && "L" /* Last */  === t.an;
}
function $6c8154472dd99012$var$Mn(t) {
    return t.on.length > 0 ? t.on[0].field : null;
}
function $6c8154472dd99012$var$qn(t) {
    for(var e = 0, n = t.filters; e < n.length; e++){
        var r = n[e];
        if (r.hn()) return r.field;
    }
    return null;
}
/**
 * Checks if any of the provided Operators are included in the query and
 * returns the first one that is, or null if none are.
 */ /**
 * Returns whether the query matches a collection group rather than a specific
 * collection.
 */ function $6c8154472dd99012$var$jn(t) {
    return null !== t.collectionGroup;
}
/**
 * Returns the implicit order by constraint that is used to execute the Query,
 * which can be different from the order by constraints the user provided (e.g.
 * the SDK and backend always orders by `__name__`).
 */ function $6c8154472dd99012$var$Gn(t) {
    var e = $6c8154472dd99012$var$m(t);
    if (null === e.cn) {
        e.cn = [];
        var n = $6c8154472dd99012$var$qn(e), r = $6c8154472dd99012$var$Mn(e);
        if (null !== n && null === r) // In order to implicitly add key ordering, we must also add the
        // inequality filter field for it to be a valid query.
        // Note that the default inequality field and key ordering is ascending.
        n.p() || e.cn.push(new $6c8154472dd99012$var$fr(n)), e.cn.push(new $6c8154472dd99012$var$fr($6c8154472dd99012$var$N.v(), "asc" /* ASCENDING */ ));
        else {
            for(var i = !1, o = 0, s = e.on; o < s.length; o++){
                var u = s[o];
                e.cn.push(u), u.field.p() && (i = !0);
            }
            if (!i) {
                // The order of the implicit key ordering always matches the last
                // explicit order by
                var a = e.on.length > 0 ? e.on[e.on.length - 1].dir : "asc" /* ASCENDING */ ;
                e.cn.push(new $6c8154472dd99012$var$fr($6c8154472dd99012$var$N.v(), a));
            }
        }
    }
    return e.cn;
}
/**
 * Converts this `Query` instance to it's corresponding `Target` representation.
 */ function $6c8154472dd99012$var$zn(t) {
    var e = $6c8154472dd99012$var$m(t);
    if (!e.un) {
        if ("F" /* First */  === e.an) e.un = $6c8154472dd99012$var$ft(e.path, e.collectionGroup, $6c8154472dd99012$var$Gn(e), e.filters, e.limit, e.startAt, e.endAt);
        else {
            for(// Flip the orderBy directions since we want the last results
            var n = [], r = 0, i = $6c8154472dd99012$var$Gn(e); r < i.length; r++){
                var o = i[r], s = "desc" /* DESCENDING */  === o.dir ? "asc" /* ASCENDING */  : "desc" /* DESCENDING */ ;
                n.push(new $6c8154472dd99012$var$fr(o.field, s));
            }
            // We need to swap the cursors to match the now-flipped query ordering.
            var u = e.endAt ? new $6c8154472dd99012$var$ur(e.endAt.position, !e.endAt.before) : null, a = e.startAt ? new $6c8154472dd99012$var$ur(e.startAt.position, !e.startAt.before) : null;
            // Now return as a LimitType.First query.
            e.un = $6c8154472dd99012$var$ft(e.path, e.collectionGroup, n, e.filters, e.limit, u, a);
        }
    }
    return e.un;
}
function $6c8154472dd99012$var$Bn(t, e, n) {
    return new $6c8154472dd99012$var$Pn(t.path, t.collectionGroup, t.on.slice(), t.filters.slice(), e, n, t.startAt, t.endAt);
}
function $6c8154472dd99012$var$Wn(t, e) {
    return new $6c8154472dd99012$var$Pn(t.path, t.collectionGroup, t.on.slice(), t.filters.slice(), t.limit, t.an, e, t.endAt);
}
function $6c8154472dd99012$var$Kn(t, e) {
    return new $6c8154472dd99012$var$Pn(t.path, t.collectionGroup, t.on.slice(), t.filters.slice(), t.limit, t.an, t.startAt, e);
}
function $6c8154472dd99012$var$Qn(t, e) {
    return $6c8154472dd99012$var$pt($6c8154472dd99012$var$zn(t), $6c8154472dd99012$var$zn(e)) && t.an === e.an;
}
// TODO(b/29183165): This is used to get a unique string from a query to, for
// example, use as a dictionary key, but the implementation is subject to
// collisions. Make it collision-free.
function $6c8154472dd99012$var$Hn(t) {
    return $6c8154472dd99012$var$lt($6c8154472dd99012$var$zn(t)) + "|lt:" + t.an;
}
function $6c8154472dd99012$var$Yn(t) {
    return "Query(target=" + function(t) {
        var e = t.path.R();
        return null !== t.collectionGroup && (e += " collectionGroup=" + t.collectionGroup), t.filters.length > 0 && (e += ", filters: [" + t.filters.map(function(t) {
            var e;
            return (e = t).field.R() + " " + e.op + " " + $6c8154472dd99012$var$re(e.value);
        /** Filter that matches on key fields (i.e. '__name__'). */ }).join(", ") + "]"), $6c8154472dd99012$var$ut(t.limit) || (e += ", limit: " + t.limit), t.orderBy.length > 0 && (e += ", orderBy: [" + t.orderBy.map(function(t) {
            var e;
            return (e = t).field.R() + " (" + e.dir + ")";
        }).join(", ") + "]"), t.startAt && (e += ", startAt: " + $6c8154472dd99012$var$ar(t.startAt)), t.endAt && (e += ", endAt: " + $6c8154472dd99012$var$ar(t.endAt)), "Target(" + e + ")";
    }($6c8154472dd99012$var$zn(t)) + "; limitType=" + t.an + ")";
}
/** Returns whether `doc` matches the constraints of `query`. */ function $6c8154472dd99012$var$$n(t, e) {
    return function(t, e) {
        var n = e.key.path;
        return null !== t.collectionGroup ? e.key.N(t.collectionGroup) && t.path.T(n) : $6c8154472dd99012$var$A.F(t.path) ? t.path.isEqual(n) : t.path.I(n);
    }(t, e) && function(t, e) {
        for(var n = 0, r = t.on; n < r.length; n++){
            var i = r[n];
            // order by key always matches
            if (!i.field.p() && null === e.field(i.field)) return !1;
        }
        return !0;
    }(t, e) && function(t, e) {
        for(var n = 0, r = t.filters; n < r.length; n++){
            if (!r[n].matches(e)) return !1;
        }
        return !0;
    }(t, e) && function(t, e) {
        return !(t.startAt && !$6c8154472dd99012$var$cr(t.startAt, $6c8154472dd99012$var$Gn(t), e)) && (!t.endAt || !$6c8154472dd99012$var$cr(t.endAt, $6c8154472dd99012$var$Gn(t), e));
    }(t, e);
}
function $6c8154472dd99012$var$Xn(t) {
    return function(e, n) {
        for(var r = !1, i = 0, o = $6c8154472dd99012$var$Gn(t); i < o.length; i++){
            var s = o[i], u = $6c8154472dd99012$var$lr(s, e, n);
            if (0 !== u) return u;
            r = r || s.field.p();
        }
        return 0;
    };
}
var $6c8154472dd99012$var$Jn = /** @class */ function(e) {
    function n(t, n, r) {
        var i = this;
        return (i = e.call(this) || this).field = t, i.op = n, i.value = r, i;
    }
    /**
     * Creates a filter based on the provided arguments.
     */ return $876a70688d8d7977$export$a8ba968b8961cb8a(n, e), n.create = function(t, e, r) {
        if (t.p()) return "in" /* IN */  === e || "not-in" /* NOT_IN */  === e ? this.ln(t, e, r) : new $6c8154472dd99012$var$Zn(t, e, r);
        if ($6c8154472dd99012$var$fe(r)) {
            if ("==" /* EQUAL */  !== e && "!=" /* NOT_EQUAL */  !== e) throw new $6c8154472dd99012$var$c($6c8154472dd99012$var$a.INVALID_ARGUMENT, "Invalid query. Null only supports '==' and '!=' comparisons.");
            return new n(t, e, r);
        }
        if ($6c8154472dd99012$var$le(r)) {
            if ("==" /* EQUAL */  !== e && "!=" /* NOT_EQUAL */  !== e) throw new $6c8154472dd99012$var$c($6c8154472dd99012$var$a.INVALID_ARGUMENT, "Invalid query. NaN only supports '==' and '!=' comparisons.");
            return new n(t, e, r);
        }
        return "array-contains" /* ARRAY_CONTAINS */  === e ? new $6c8154472dd99012$var$rr(t, r) : "in" /* IN */  === e ? new $6c8154472dd99012$var$ir(t, r) : "not-in" /* NOT_IN */  === e ? new $6c8154472dd99012$var$or(t, r) : "array-contains-any" /* ARRAY_CONTAINS_ANY */  === e ? new $6c8154472dd99012$var$sr(t, r) : new n(t, e, r);
    }, n.ln = function(t, e, n) {
        return "in" /* IN */  === e ? new $6c8154472dd99012$var$tr(t, n) : new $6c8154472dd99012$var$er(t, n);
    }, n.prototype.matches = function(t) {
        var e = t.field(this.field);
        // Types do not have to match in NOT_EQUAL filters.
        return "!=" /* NOT_EQUAL */  === this.op ? null !== e && this._n($6c8154472dd99012$var$ee(e, this.value)) : null !== e && $6c8154472dd99012$var$Jt(this.value) === $6c8154472dd99012$var$Jt(e) && this._n($6c8154472dd99012$var$ee(e, this.value));
    // Only compare types with matching backend order (such as double and int).
    }, n.prototype._n = function(t) {
        switch(this.op){
            case "<" /* LESS_THAN */ :
                return t < 0;
            case "<=" /* LESS_THAN_OR_EQUAL */ :
                return t <= 0;
            case "==" /* EQUAL */ :
                return 0 === t;
            case "!=" /* NOT_EQUAL */ :
                return 0 !== t;
            case ">" /* GREATER_THAN */ :
                return t > 0;
            case ">=" /* GREATER_THAN_OR_EQUAL */ :
                return t >= 0;
            default:
                return $6c8154472dd99012$var$y();
        }
    }, n.prototype.hn = function() {
        return [
            "<" /* LESS_THAN */ ,
            "<=" /* LESS_THAN_OR_EQUAL */ ,
            ">" /* GREATER_THAN */ ,
            ">=" /* GREATER_THAN_OR_EQUAL */ ,
            "!=" /* NOT_EQUAL */ ,
            "not-in" /* NOT_IN */ 
        ].indexOf(this.op) >= 0;
    }, n;
}(function() {});
var $6c8154472dd99012$var$Zn = /** @class */ function(e) {
    function n(t, n, r) {
        var i = this;
        return (i = e.call(this, t, n, r) || this).key = $6c8154472dd99012$var$A.C(r.referenceValue), i;
    }
    return $876a70688d8d7977$export$a8ba968b8961cb8a(n, e), n.prototype.matches = function(t) {
        var e = $6c8154472dd99012$var$A.i(t.key, this.key);
        return this._n(e);
    }, n;
}($6c8154472dd99012$var$Jn), $6c8154472dd99012$var$tr = /** @class */ function(e) {
    function n(t, n) {
        var r = this;
        return (r = e.call(this, t, "in" /* IN */ , n) || this).keys = $6c8154472dd99012$var$nr("in" /* IN */ , n), r;
    }
    return $876a70688d8d7977$export$a8ba968b8961cb8a(n, e), n.prototype.matches = function(t) {
        return this.keys.some(function(e) {
            return e.isEqual(t.key);
        });
    }, n;
}($6c8154472dd99012$var$Jn), $6c8154472dd99012$var$er = /** @class */ function(e) {
    function n(t, n) {
        var r = this;
        return (r = e.call(this, t, "not-in" /* NOT_IN */ , n) || this).keys = $6c8154472dd99012$var$nr("not-in" /* NOT_IN */ , n), r;
    }
    return $876a70688d8d7977$export$a8ba968b8961cb8a(n, e), n.prototype.matches = function(t) {
        return !this.keys.some(function(e) {
            return e.isEqual(t.key);
        });
    }, n;
}($6c8154472dd99012$var$Jn);
/** Filter that matches on key fields within an array. */ function $6c8154472dd99012$var$nr(t, e) {
    var n;
    return ((null === (n = e.arrayValue) || void 0 === n ? void 0 : n.values) || []).map(function(t) {
        return $6c8154472dd99012$var$A.C(t.referenceValue);
    });
}
/** A Filter that implements the array-contains operator. */ var $6c8154472dd99012$var$rr = /** @class */ function(e) {
    function n(t, n) {
        return e.call(this, t, "array-contains" /* ARRAY_CONTAINS */ , n) || this;
    }
    return $876a70688d8d7977$export$a8ba968b8961cb8a(n, e), n.prototype.matches = function(t) {
        var e = t.field(this.field);
        return $6c8154472dd99012$var$he(e) && $6c8154472dd99012$var$te(e.arrayValue, this.value);
    }, n;
}($6c8154472dd99012$var$Jn), $6c8154472dd99012$var$ir = /** @class */ function(e) {
    function n(t, n) {
        return e.call(this, t, "in" /* IN */ , n) || this;
    }
    return $876a70688d8d7977$export$a8ba968b8961cb8a(n, e), n.prototype.matches = function(t) {
        var e = t.field(this.field);
        return null !== e && $6c8154472dd99012$var$te(this.value.arrayValue, e);
    }, n;
}($6c8154472dd99012$var$Jn), $6c8154472dd99012$var$or = /** @class */ function(e) {
    function n(t, n) {
        return e.call(this, t, "not-in" /* NOT_IN */ , n) || this;
    }
    return $876a70688d8d7977$export$a8ba968b8961cb8a(n, e), n.prototype.matches = function(t) {
        if ($6c8154472dd99012$var$te(this.value.arrayValue, {
            nullValue: "NULL_VALUE"
        })) return !1;
        var e = t.field(this.field);
        return null !== e && !$6c8154472dd99012$var$te(this.value.arrayValue, e);
    }, n;
}($6c8154472dd99012$var$Jn), $6c8154472dd99012$var$sr = /** @class */ function(e) {
    function n(t, n) {
        return e.call(this, t, "array-contains-any" /* ARRAY_CONTAINS_ANY */ , n) || this;
    }
    return $876a70688d8d7977$export$a8ba968b8961cb8a(n, e), n.prototype.matches = function(t) {
        var e = this, n = t.field(this.field);
        return !(!$6c8154472dd99012$var$he(n) || !n.arrayValue.values) && n.arrayValue.values.some(function(t) {
            return $6c8154472dd99012$var$te(e.value.arrayValue, t);
        });
    }, n;
}($6c8154472dd99012$var$Jn), $6c8154472dd99012$var$ur = function(t, e) {
    this.position = t, this.before = e;
};
/** A Filter that implements the IN operator. */ function $6c8154472dd99012$var$ar(t) {
    // TODO(b/29183165): Make this collision robust.
    return (t.before ? "b" : "a") + ":" + t.position.map(function(t) {
        return $6c8154472dd99012$var$re(t);
    }).join(",");
}
/**
 * Returns true if a document sorts before a bound using the provided sort
 * order.
 */ function $6c8154472dd99012$var$cr(t, e, n) {
    for(var r = 0, i = 0; i < t.position.length; i++){
        var o = e[i], s = t.position[i];
        if (r = o.field.p() ? $6c8154472dd99012$var$A.i($6c8154472dd99012$var$A.C(s.referenceValue), n.key) : $6c8154472dd99012$var$ee(s, n.field(o.field)), "desc" /* DESCENDING */  === o.dir && (r *= -1), 0 !== r) break;
    }
    return t.before ? r <= 0 : r < 0;
}
function $6c8154472dd99012$var$hr(t, e) {
    if (null === t) return null === e;
    if (null === e) return !1;
    if (t.before !== e.before || t.position.length !== e.position.length) return !1;
    for(var n = 0; n < t.position.length; n++)if (!$6c8154472dd99012$var$Zt(t.position[n], e.position[n])) return !1;
    return !0;
}
/**
 * An ordering on a field, in some Direction. Direction defaults to ASCENDING.
 */ var $6c8154472dd99012$var$fr = function(t, e /* ASCENDING */ ) {
    void 0 === e && (e = "asc"), this.field = t, this.dir = e;
};
function $6c8154472dd99012$var$lr(t, e, n) {
    var r = t.field.p() ? $6c8154472dd99012$var$A.i(e.key, n.key) : function(t, e, n) {
        var r = e.field(t), i = n.field(t);
        return null !== r && null !== i ? $6c8154472dd99012$var$ee(r, i) : $6c8154472dd99012$var$y();
    }(t.field, e, n);
    switch(t.dir){
        case "asc" /* ASCENDING */ :
            return r;
        case "desc" /* DESCENDING */ :
            return -1 * r;
        default:
            return $6c8154472dd99012$var$y();
    }
}
function $6c8154472dd99012$var$pr(t, e) {
    return t.dir === e.dir && t.field.isEqual(e.field);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $6c8154472dd99012$var$dr = function() {
    var t = this;
    this.promise = new Promise(function(e, n) {
        t.resolve = e, t.reject = n;
    });
}, $6c8154472dd99012$var$vr = /** @class */ function() {
    function t(/**
     * The AsyncQueue to run backoff operations on.
     */ t, /**
     * The ID to use when scheduling backoff operations on the AsyncQueue.
     */ e, /**
     * The initial delay (used as the base delay on the first retry attempt).
     * Note that jitter will still be applied, so the actual delay could be as
     * little as 0.5*initialDelayMs.
     */ n, r, i) {
        void 0 === n && (n = 1e3), void 0 === r && (r = 1.5), void 0 === i && (i = 6e4), this.fn = t, this.dn = e, this.wn = n, this.mn = r, this.Tn = i, this.En = 0, this.In = null, /** The last backoff attempt, as epoch milliseconds. */ this.An = Date.now(), this.reset();
    }
    /**
     * Resets the backoff delay.
     *
     * The very next backoffAndWait() will have no delay. If it is called again
     * (i.e. due to an error), initialDelayMs (plus jitter) will be used, and
     * subsequent ones will increase according to the backoffFactor.
     */ return t.prototype.reset = function() {
        this.En = 0;
    }, /**
     * Resets the backoff delay to the maximum delay (e.g. for use after a
     * RESOURCE_EXHAUSTED error).
     */ t.prototype.Rn = function() {
        this.En = this.Tn;
    }, /**
     * Returns a promise that resolves after currentDelayMs, and increases the
     * delay for any subsequent attempts. If there was a pending backoff operation
     * already, it will be canceled.
     */ t.prototype.gn = function(t) {
        var e = this;
        // Cancel any pending backoff operation.
        this.cancel();
        // First schedule using the current base (which may be 0 and should be
        // honored as such).
        var n = Math.floor(this.En + this.Pn()), r = Math.max(0, Date.now() - this.An), i = Math.max(0, n - r);
        // Guard against lastAttemptTime being in the future due to a clock change.
        i > 0 && $6c8154472dd99012$var$l("ExponentialBackoff", "Backing off for " + i + " ms (base delay: " + this.En + " ms, delay with jitter: " + n + " ms, last attempt: " + r + " ms ago)"), this.In = this.fn.yn(this.dn, i, function() {
            return e.An = Date.now(), t();
        }), // Apply backoff factor to determine next delay and ensure it is within
        // bounds.
        this.En *= this.mn, this.En < this.wn && (this.En = this.wn), this.En > this.Tn && (this.En = this.Tn);
    }, t.prototype.Vn = function() {
        null !== this.In && (this.In.pn(), this.In = null);
    }, t.prototype.cancel = function() {
        null !== this.In && (this.In.cancel(), this.In = null);
    }, /** Returns a random value in the range [-currentBaseMs/2, currentBaseMs/2] */ t.prototype.Pn = function() {
        return (Math.random() - .5) * this.En;
    }, t;
}(), $6c8154472dd99012$var$yr = /** @class */ function() {
    function t(t) {
        var e = this;
        // NOTE: next/catchCallback will always point to our own wrapper functions,
        // not the user's raw next() or catch() callbacks.
        this.bn = null, this.vn = null, // When the operation resolves, we'll set result or error and mark isDone.
        this.result = void 0, this.error = void 0, this.Sn = !1, // Set to true when .then() or .catch() are called and prevents additional
        // chaining.
        this.Dn = !1, t(function(t) {
            e.Sn = !0, e.result = t, e.bn && // value should be defined unless T is Void, but we can't express
            // that in the type system.
            e.bn(t);
        }, function(t) {
            e.Sn = !0, e.error = t, e.vn && e.vn(t);
        });
    }
    return t.prototype.catch = function(t) {
        return this.next(void 0, t);
    }, t.prototype.next = function(e, n) {
        var r = this;
        return this.Dn && $6c8154472dd99012$var$y(), this.Dn = !0, this.Sn ? this.error ? this.Cn(n, this.error) : this.Nn(e, this.result) : new t(function(t, i) {
            r.bn = function(n) {
                r.Nn(e, n).next(t, i);
            }, r.vn = function(e) {
                r.Cn(n, e).next(t, i);
            };
        });
    }, t.prototype.Fn = function() {
        var t = this;
        return new Promise(function(e, n) {
            t.next(e, n);
        });
    }, t.prototype.xn = function(e) {
        try {
            var n = e();
            return n instanceof t ? n : t.resolve(n);
        } catch (e) {
            return t.reject(e);
        }
    }, t.prototype.Nn = function(e, n) {
        return e ? this.xn(function() {
            return e(n);
        }) : t.resolve(n);
    }, t.prototype.Cn = function(e, n) {
        return e ? this.xn(function() {
            return e(n);
        }) : t.reject(n);
    }, t.resolve = function(e) {
        return new t(function(t, n) {
            t(e);
        });
    }, t.reject = function(e) {
        return new t(function(t, n) {
            n(e);
        });
    }, t.$n = function(// Accept all Promise types in waitFor().
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    e) {
        return new t(function(t, n) {
            var r = 0, i = 0, o = !1;
            e.forEach(function(e) {
                ++r, e.next(function() {
                    ++i, o && i === r && t();
                }, function(t) {
                    return n(t);
                });
            }), o = !0, i === r && t();
        });
    }, /**
     * Given an array of predicate functions that asynchronously evaluate to a
     * boolean, implements a short-circuiting `or` between the results. Predicates
     * will be evaluated until one of them returns `true`, then stop. The final
     * result will be whether any of them returned `true`.
     */ t.kn = function(e) {
        for(var n = t.resolve(!1), r = function(e) {
            n = n.next(function(n) {
                return n ? t.resolve(n) : e();
            });
        }, i = 0, o = e; i < o.length; i++)r(o[i]);
        return n;
    }, t.forEach = function(t, e) {
        var n = this, r = [];
        return t.forEach(function(t, i) {
            r.push(e.call(n, t, i));
        }), this.$n(r);
    }, t;
}(), $6c8154472dd99012$var$gr = /** @class */ function() {
    /*
     * Creates a new SimpleDb wrapper for IndexedDb database `name`.
     *
     * Note that `version` must not be a downgrade. IndexedDB does not support
     * downgrading the schema version. We currently do not support any way to do
     * versioning outside of IndexedDB's versioning mechanism, as only
     * version-upgrade transactions are allowed to do things like create
     * objectstores.
     */ function e(t, n, i) {
        this.name = t, this.version = n, this.Mn = i, // NOTE: According to https://bugs.webkit.org/show_bug.cgi?id=197050, the
        // bug we're checking for should exist in iOS >= 12.2 and < 13, but for
        // whatever reason it's much harder to hit after 12.2 so we only proactively
        // log on 12.2.
        12.2 === e.On($01sTD.getUA()) && $6c8154472dd99012$var$p("Firestore persistence suffers from a bug in iOS 12.2 Safari that may cause your app to stop working. See https://stackoverflow.com/q/56496296/110915 for details and a potential workaround.");
    }
    /** Deletes the specified database. */ return e.delete = function(t) {
        return $6c8154472dd99012$var$l("SimpleDb", "Removing database:", t), $6c8154472dd99012$var$Er(window.indexedDB.deleteDatabase(t)).Fn();
    }, /** Returns true if IndexedDB is available in the current environment. */ e.Ln = function() {
        if ("undefined" == typeof indexedDB) return !1;
        if (e.Bn()) return !0;
        // We extensively use indexed array values and compound keys,
        // which IE and Edge do not support. However, they still have indexedDB
        // defined on the window, so we need to check for them here and make sure
        // to return that persistence is not enabled for those browsers.
        // For tracking support of this feature, see here:
        // https://developer.microsoft.com/en-us/microsoft-edge/platform/status/indexeddbarraysandmultientrysupport/
        // Check the UA string to find out the browser.
        var t = $01sTD.getUA(), n = e.On(t), i = 0 < n && n < 10, o = e.qn(t), s = 0 < o && o < 4.5;
        // IE 10
        // ua = 'Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)';
        // IE 11
        // ua = 'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko';
        // Edge
        // ua = 'Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML,
        // like Gecko) Chrome/39.0.2171.71 Safari/537.36 Edge/12.0';
        // iOS Safari: Disable for users running iOS version < 10.
        return !(t.indexOf("MSIE ") > 0 || t.indexOf("Trident/") > 0 || t.indexOf("Edge/") > 0 || i || s);
    }, /**
     * Returns true if the backing IndexedDB store is the Node IndexedDBShim
     * (see https://github.com/axemclion/IndexedDBShim).
     */ e.Bn = function() {
        var t;
        return "undefined" != typeof $hPtJY && "YES" === ((t = {}, void 0 === t) ? void 0 : t.Un);
    }, /** Helper to get a typed SimpleDbStore from a transaction. */ e.Qn = function(t, e) {
        return t.store(e);
    }, // visible for testing
    /** Parse User Agent to determine iOS version. Returns -1 if not found. */ e.On = function(t) {
        var e = t.match(/i(?:phone|pad|pod) os ([\d_]+)/i), n = e ? e[1].split("_").slice(0, 2).join(".") : "-1";
        return Number(n);
    }, // visible for testing
    /** Parse User Agent to determine Android version. Returns -1 if not found. */ e.qn = function(t) {
        var e = t.match(/Android ([\d.]+)/i), n = e ? e[1].split(".").slice(0, 2).join(".") : "-1";
        return Number(n);
    }, /**
     * Opens the specified database, creating or upgrading it if necessary.
     */ e.prototype.Wn = function(e) {
        return $876a70688d8d7977$export$1050f835b63b671e(this, void 0, void 0, function() {
            var n, r = this;
            return $876a70688d8d7977$export$67ebef60e6f28a6(this, function(t) {
                switch(t.label){
                    case 0:
                        return this.db ? [
                            3 /*break*/ ,
                            2
                        ] : ($6c8154472dd99012$var$l("SimpleDb", "Opening database:", this.name), n = this, [
                            4 /*yield*/ ,
                            new Promise(function(t, n) {
                                // TODO(mikelehen): Investigate browser compatibility.
                                // https://developer.mozilla.org/en-US/docs/Web/API/IndexedDB_API/Using_IndexedDB
                                // suggests IE9 and older WebKit browsers handle upgrade
                                // differently. They expect setVersion, as described here:
                                // https://developer.mozilla.org/en-US/docs/Web/API/IDBVersionChangeRequest/setVersion
                                var i = indexedDB.open(r.name, r.version);
                                i.onsuccess = function(e) {
                                    var n = e.target.result;
                                    t(n);
                                }, i.onblocked = function() {
                                    n(new $6c8154472dd99012$var$wr(e, "Cannot upgrade IndexedDB schema while another tab is open. Close all tabs that access Firestore and reload this page to proceed."));
                                }, i.onerror = function(t) {
                                    var r = t.target.error;
                                    "VersionError" === r.name ? n(new $6c8154472dd99012$var$c($6c8154472dd99012$var$a.FAILED_PRECONDITION, "A newer version of the Firestore SDK was previously used and so the persisted data is not compatible with the version of the SDK you are now using. The SDK will operate with persistence disabled. If you need persistence, please re-upgrade to a newer version of the SDK or else clear the persisted IndexedDB data for your app to start fresh.")) : n(new $6c8154472dd99012$var$wr(e, r));
                                }, i.onupgradeneeded = function(t) {
                                    $6c8154472dd99012$var$l("SimpleDb", 'Database "' + r.name + '" requires upgrade from version:', t.oldVersion);
                                    var e = t.target.result;
                                    r.Mn.createOrUpgrade(e, i.transaction, t.oldVersion, r.version).next(function() {
                                        $6c8154472dd99012$var$l("SimpleDb", "Database upgrade to version " + r.version + " complete");
                                    });
                                };
                            })
                        ]);
                    case 1:
                        n.db = t.sent(), t.label = 2;
                    case 2:
                        return [
                            2 /*return*/ ,
                            (this.jn && (this.db.onversionchange = function(t) {
                                return r.jn(t);
                            }), this.db)
                        ];
                }
            });
        });
    }, e.prototype.Kn = function(t) {
        this.jn = t, this.db && (this.db.onversionchange = function(e) {
            return t(e);
        });
    }, e.prototype.runTransaction = function(e, n, r, i) {
        return $876a70688d8d7977$export$1050f835b63b671e(this, void 0, void 0, function() {
            var o, s, u, a, c;
            return $876a70688d8d7977$export$67ebef60e6f28a6(this, function(h) {
                switch(h.label){
                    case 0:
                        o = "readonly" === n, s = 0, u = function() {
                            var n, u, c, h, f;
                            return $876a70688d8d7977$export$67ebef60e6f28a6(this, function(t) {
                                switch(t.label){
                                    case 0:
                                        ++s, t.label = 1;
                                    case 1:
                                        return t.trys.push([
                                            1,
                                            4,
                                            ,
                                            5
                                        ]), [
                                            4 /*yield*/ ,
                                            a.Wn(e)
                                        ];
                                    case 2:
                                        // Wait for the transaction to complete (i.e. IndexedDb's onsuccess event to
                                        // fire), but still return the original transactionFnResult back to the
                                        // caller.
                                        return a.db = t.sent(), n = $6c8154472dd99012$var$br.open(a.db, e, o ? "readonly" : "readwrite", r), u = i(n).catch(function(t) {
                                            // Abort the transaction if there was an error.
                                            return n.abort(t), $6c8154472dd99012$var$yr.reject(t);
                                        }).Fn(), c = {}, u.catch(function() {}), [
                                            4 /*yield*/ ,
                                            n.Gn
                                        ];
                                    case 3:
                                        return [
                                            2 /*return*/ ,
                                            (c.value = // Wait for the transaction to complete (i.e. IndexedDb's onsuccess event to
                                            // fire), but still return the original transactionFnResult back to the
                                            // caller.
                                            (t.sent(), u), c)
                                        ];
                                    case 4:
                                        return h = t.sent(), f = "FirebaseError" !== h.name && s < 3, $6c8154472dd99012$var$l("SimpleDb", "Transaction failed with error:", h.message, "Retrying:", f), a.close(), f ? [
                                            3 /*break*/ ,
                                            5
                                        ] : [
                                            2 /*return*/ ,
                                            {
                                                value: Promise.reject(h)
                                            }
                                        ];
                                    case 5:
                                        return [
                                            2 /*return*/ 
                                        ];
                                }
                            });
                        }, a = this, h.label = 1;
                    case 1:
                        return [
                            5 /*yield**/ ,
                            u()
                        ];
                    case 2:
                        if ("object" == typeof (c = h.sent())) return [
                            2 /*return*/ ,
                            c.value
                        ];
                        h.label = 3;
                    case 3:
                        return [
                            3 /*break*/ ,
                            1
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    }, e.prototype.close = function() {
        this.db && this.db.close(), this.db = void 0;
    }, e;
}(), $6c8154472dd99012$var$mr = /** @class */ function() {
    function t(t) {
        this.zn = t, this.Hn = !1, this.Yn = null;
    }
    return Object.defineProperty(t.prototype, "Sn", {
        get: function() {
            return this.Hn;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "Jn", {
        get: function() {
            return this.Yn;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "cursor", {
        set: function(t) {
            this.zn = t;
        },
        enumerable: !1,
        configurable: !0
    }), /**
     * This function can be called to stop iteration at any point.
     */ t.prototype.done = function() {
        this.Hn = !0;
    }, /**
     * This function can be called to skip to that next key, which could be
     * an index or a primary key.
     */ t.prototype.Xn = function(t) {
        this.Yn = t;
    }, /**
     * Delete the current cursor value from the object store.
     *
     * NOTE: You CANNOT do this with a keysOnly query.
     */ t.prototype.delete = function() {
        return $6c8154472dd99012$var$Er(this.zn.delete());
    }, t;
}(), $6c8154472dd99012$var$wr = /** @class */ function(e) {
    function n(t, n) {
        var r = this;
        return (r = e.call(this, $6c8154472dd99012$var$a.UNAVAILABLE, "IndexedDB transaction '" + t + "' failed: " + n) || this).name = "IndexedDbTransactionError", r;
    }
    return $876a70688d8d7977$export$a8ba968b8961cb8a(n, e), n;
}($6c8154472dd99012$var$c);
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A helper for running delayed tasks following an exponential backoff curve
 * between attempts.
 *
 * Each delay is made up of a "base" delay which follows the exponential
 * backoff curve, and a +/- 50% "jitter" that is calculated and added to the
 * base delay. This prevents clients from accidentally synchronizing their
 * delays causing spikes of load to the backend.
 */ /** Verifies whether `e` is an IndexedDbTransactionError. */ function $6c8154472dd99012$var$_r(t) {
    // Use name equality, as instanceof checks on errors don't work with errors
    // that wrap other errors.
    return "IndexedDbTransactionError" === t.name;
}
/**
 * Wraps an IDBTransaction and exposes a store() method to get a handle to a
 * specific object store.
 */ var $6c8154472dd99012$var$br = /** @class */ function() {
    function t(t, e) {
        var n = this;
        this.action = t, this.transaction = e, this.aborted = !1, /**
             * A promise that resolves with the result of the IndexedDb transaction.
             */ this.Zn = new $6c8154472dd99012$var$dr, this.transaction.oncomplete = function() {
            n.Zn.resolve();
        }, this.transaction.onabort = function() {
            e.error ? n.Zn.reject(new $6c8154472dd99012$var$wr(t, e.error)) : n.Zn.resolve();
        }, this.transaction.onerror = function(e) {
            var r = $6c8154472dd99012$var$Nr(e.target.error);
            n.Zn.reject(new $6c8154472dd99012$var$wr(t, r));
        };
    }
    return t.open = function(e, n, r, i) {
        try {
            return new t(n, e.transaction(i, r));
        } catch (e) {
            throw new $6c8154472dd99012$var$wr(n, e);
        }
    }, Object.defineProperty(t.prototype, "Gn", {
        get: function() {
            return this.Zn.promise;
        },
        enumerable: !1,
        configurable: !0
    }), t.prototype.abort = function(t) {
        t && this.Zn.reject(t), this.aborted || ($6c8154472dd99012$var$l("SimpleDb", "Aborting transaction:", t ? t.message : "Client-initiated abort"), this.aborted = !0, this.transaction.abort());
    }, /**
     * Returns a SimpleDbStore<KeyType, ValueType> for the specified store. All
     * operations performed on the SimpleDbStore happen within the context of this
     * transaction and it cannot be used anymore once the transaction is
     * completed.
     *
     * Note that we can't actually enforce that the KeyType and ValueType are
     * correct, but they allow type safety through the rest of the consuming code.
     */ t.prototype.store = function(t) {
        var e = this.transaction.objectStore(t);
        return new $6c8154472dd99012$var$Ir(e);
    }, t;
}(), $6c8154472dd99012$var$Ir = /** @class */ function() {
    function t(t) {
        this.store = t;
    }
    return t.prototype.put = function(t, e) {
        var n;
        return void 0 !== e ? ($6c8154472dd99012$var$l("SimpleDb", "PUT", this.store.name, t, e), n = this.store.put(e, t)) : ($6c8154472dd99012$var$l("SimpleDb", "PUT", this.store.name, "<auto-key>", t), n = this.store.put(t)), $6c8154472dd99012$var$Er(n);
    }, /**
     * Adds a new value into an Object Store and returns the new key. Similar to
     * IndexedDb's `add()`, this method will fail on primary key collisions.
     *
     * @param value The object to write.
     * @return The key of the value to add.
     */ t.prototype.add = function(t) {
        return $6c8154472dd99012$var$l("SimpleDb", "ADD", this.store.name, t, t), $6c8154472dd99012$var$Er(this.store.add(t));
    }, /**
     * Gets the object with the specified key from the specified store, or null
     * if no object exists with the specified key.
     *
     * @key The key of the object to get.
     * @return The object with the specified key or null if no object exists.
     */ t.prototype.get = function(t) {
        var e = this;
        // We're doing an unsafe cast to ValueType.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return $6c8154472dd99012$var$Er(this.store.get(t)).next(function(n) {
            // Normalize nonexistence to null.
            return void 0 === n && (n = null), $6c8154472dd99012$var$l("SimpleDb", "GET", e.store.name, t, n), n;
        });
    }, t.prototype.delete = function(t) {
        return $6c8154472dd99012$var$l("SimpleDb", "DELETE", this.store.name, t), $6c8154472dd99012$var$Er(this.store.delete(t));
    }, /**
     * If we ever need more of the count variants, we can add overloads. For now,
     * all we need is to count everything in a store.
     *
     * Returns the number of rows in the store.
     */ t.prototype.count = function() {
        return $6c8154472dd99012$var$l("SimpleDb", "COUNT", this.store.name), $6c8154472dd99012$var$Er(this.store.count());
    }, t.prototype.ts = function(t, e) {
        var n = this.cursor(this.options(t, e)), r = [];
        return this.es(n, function(t, e) {
            r.push(e);
        }).next(function() {
            return r;
        });
    }, t.prototype.ns = function(t, e) {
        $6c8154472dd99012$var$l("SimpleDb", "DELETE ALL", this.store.name);
        var n = this.options(t, e);
        n.ss = !1;
        var r = this.cursor(n);
        return this.es(r, function(t, e, n) {
            return n.delete();
        });
    }, t.prototype.rs = function(t, e) {
        var n;
        e ? n = t : (n = {}, e = t);
        var r = this.cursor(n);
        return this.es(r, e);
    }, /**
     * Iterates over a store, but waits for the given callback to complete for
     * each entry before iterating the next entry. This allows the callback to do
     * asynchronous work to determine if this iteration should continue.
     *
     * The provided callback should return `true` to continue iteration, and
     * `false` otherwise.
     */ t.prototype.os = function(t) {
        var e = this.cursor({});
        return new $6c8154472dd99012$var$yr(function(n, r) {
            e.onerror = function(t) {
                var e = $6c8154472dd99012$var$Nr(t.target.error);
                r(e);
            }, e.onsuccess = function(e) {
                var r = e.target.result;
                r ? t(r.primaryKey, r.value).next(function(t) {
                    t ? r.continue() : n();
                }) : n();
            };
        });
    }, t.prototype.es = function(t, e) {
        var n = [];
        return new $6c8154472dd99012$var$yr(function(r, i) {
            t.onerror = function(t) {
                i(t.target.error);
            }, t.onsuccess = function(t) {
                var i = t.target.result;
                if (i) {
                    var o = new $6c8154472dd99012$var$mr(i), s = e(i.primaryKey, i.value, o);
                    if (s instanceof $6c8154472dd99012$var$yr) {
                        var u = s.catch(function(t) {
                            return o.done(), $6c8154472dd99012$var$yr.reject(t);
                        });
                        n.push(u);
                    }
                    o.Sn ? r() : null === o.Jn ? i.continue() : i.continue(o.Jn);
                } else r();
            };
        }).next(function() {
            return $6c8154472dd99012$var$yr.$n(n);
        });
    }, t.prototype.options = function(t, e) {
        var n = void 0;
        return void 0 !== t && ("string" == typeof t ? n = t : e = t), {
            index: n,
            range: e
        };
    }, t.prototype.cursor = function(t) {
        var e = "next";
        if (t.reverse && (e = "prev"), t.index) {
            var n = this.store.index(t.index);
            return t.ss ? n.openKeyCursor(t.range, e) : n.openCursor(t.range, e);
        }
        return this.store.openCursor(t.range, e);
    }, t;
}();
/**
 * A wrapper around an IDBObjectStore providing an API that:
 *
 * 1) Has generic KeyType / ValueType parameters to provide strongly-typed
 * methods for acting against the object store.
 * 2) Deals with IndexedDB's onsuccess / onerror event callbacks, making every
 * method return a PersistencePromise instead.
 * 3) Provides a higher-level API to avoid needing to do excessive wrapping of
 * intermediate IndexedDB types (IDBCursorWithValue, etc.)
 */ /**
 * Wraps an IDBRequest in a PersistencePromise, using the onsuccess / onerror
 * handlers to resolve / reject the PersistencePromise as appropriate.
 */ function $6c8154472dd99012$var$Er(t) {
    return new $6c8154472dd99012$var$yr(function(e, n) {
        t.onsuccess = function(t) {
            var n = t.target.result;
            e(n);
        }, t.onerror = function(t) {
            var e = $6c8154472dd99012$var$Nr(t.target.error);
            n(e);
        };
    });
}
// Guard so we only report the error once.
var $6c8154472dd99012$var$Tr = !1;
function $6c8154472dd99012$var$Nr(t) {
    var e = $6c8154472dd99012$var$gr.On($01sTD.getUA());
    if (e >= 12.2 && e < 13) {
        var n = "An internal error was encountered in the Indexed Database server";
        if (t.message.indexOf(n) >= 0) {
            // Wrap error in a more descriptive one.
            var i = new $6c8154472dd99012$var$c("internal", "IOS_INDEXEDDB_BUG1: IndexedDb has thrown '" + n + "'. This is likely due to an unavoidable bug in iOS. See https://stackoverflow.com/q/56496296/110915 for details and a potential workaround.");
            return $6c8154472dd99012$var$Tr || ($6c8154472dd99012$var$Tr = !0, // Throw a global exception outside of this promise chain, for the user to
            // potentially catch.
            setTimeout(function() {
                throw i;
            }, 0)), i;
        }
    }
    return t;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** The Platform's 'window' implementation or null if not available. */ function $6c8154472dd99012$var$Ar() {
    // `window` is not always available, e.g. in ReactNative and WebWorkers.
    // eslint-disable-next-line no-restricted-globals
    return "undefined" != typeof window ? window : null;
}
/** The Platform's 'document' implementation or null if not available. */ function $6c8154472dd99012$var$Sr() {
    // `document` is not always available, e.g. in ReactNative and WebWorkers.
    // eslint-disable-next-line no-restricted-globals
    return "undefined" != typeof document ? document : null;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents an operation scheduled to be run in the future on an AsyncQueue.
 *
 * It is created via DelayedOperation.createAndSchedule().
 *
 * Supports cancellation (via cancel()) and early execution (via skipDelay()).
 *
 * Note: We implement `PromiseLike` instead of `Promise`, as the `Promise` type
 * in newer versions of TypeScript defines `finally`, which is not available in
 * IE.
 */ var $6c8154472dd99012$var$Dr = /** @class */ function() {
    function t(t, e, n, r, i) {
        this.cs = t, this.dn = e, this.us = n, this.op = r, this.hs = i, this.ls = new $6c8154472dd99012$var$dr, this.then = this.ls.promise.then.bind(this.ls.promise), // It's normal for the deferred promise to be canceled (due to cancellation)
        // and so we attach a dummy catch callback to avoid
        // 'UnhandledPromiseRejectionWarning' log spam.
        this.ls.promise.catch(function(t) {}) /**
     * Creates and returns a DelayedOperation that has been scheduled to be
     * executed on the provided asyncQueue after the provided delayMs.
     *
     * @param asyncQueue The queue to schedule the operation on.
     * @param id A Timer ID identifying the type of operation this is.
     * @param delayMs The delay (ms) before the operation should be scheduled.
     * @param op The operation to run.
     * @param removalCallback A callback to be called synchronously once the
     *   operation is executed or canceled, notifying the AsyncQueue to remove it
     *   from its delayedOperations list.
     *   PORTING NOTE: This exists to prevent making removeDelayedOperation() and
     *   the DelayedOperation class public.
     */ ;
    }
    return t._s = function(e, n, r, i, o) {
        var s = new t(e, n, Date.now() + r, i, o);
        return s.start(r), s;
    }, /**
     * Starts the timer. This is called immediately after construction by
     * createAndSchedule().
     */ t.prototype.start = function(t) {
        var e = this;
        this.fs = setTimeout(function() {
            return e.ds();
        }, t);
    }, /**
     * Queues the operation to run immediately (if it hasn't already been run or
     * canceled).
     */ t.prototype.pn = function() {
        return this.ds();
    }, /**
     * Cancels the operation if it hasn't already been executed or canceled. The
     * promise will be rejected.
     *
     * As long as the operation has not yet been run, calling cancel() provides a
     * guarantee that the operation will not be run.
     */ t.prototype.cancel = function(t) {
        null !== this.fs && (this.clearTimeout(), this.ls.reject(new $6c8154472dd99012$var$c($6c8154472dd99012$var$a.CANCELLED, "Operation cancelled" + (t ? ": " + t : ""))));
    }, t.prototype.ds = function() {
        var t = this;
        this.cs.ws(function() {
            return null !== t.fs ? (t.clearTimeout(), t.op().then(function(e) {
                return t.ls.resolve(e);
            })) : Promise.resolve();
        });
    }, t.prototype.clearTimeout = function() {
        null !== this.fs && (this.hs(this), clearTimeout(this.fs), this.fs = null);
    }, t;
}(), $6c8154472dd99012$var$xr = /** @class */ function() {
    function e() {
        var t = this;
        // The last promise in the queue.
        this.Ts = Promise.resolve(), // A list of retryable operations. Retryable operations are run in order and
        // retried with backoff.
        this.Es = [], // Is this AsyncQueue being shut down? Once it is set to true, it will not
        // be changed again.
        this.Is = !1, // Operations scheduled to be queued in the future. Operations are
        // automatically removed after they are run or canceled.
        this.As = [], // visible for testing
        this.Rs = null, // Flag set while there's an outstanding AsyncQueue operation, used for
        // assertion sanity-checks.
        this.gs = !1, // List of TimerIds to fast-forward delays for.
        this.Ps = [], // Backoff timer used to schedule retries for retryable operations
        this.ys = new $6c8154472dd99012$var$vr(this, "async_queue_retry" /* AsyncQueueRetry */ ), // Visibility handler that triggers an immediate retry of all retryable
        // operations. Meant to speed up recovery when we regain file system access
        // after page comes into foreground.
        this.Vs = function() {
            var e = $6c8154472dd99012$var$Sr();
            e && $6c8154472dd99012$var$l("AsyncQueue", "Visibility state changed to  ", e.visibilityState), t.ys.Vn();
        };
        var e = $6c8154472dd99012$var$Sr();
        e && "function" == typeof e.addEventListener && e.addEventListener("visibilitychange", this.Vs);
    }
    return Object.defineProperty(e.prototype, "ps", {
        // Is this AsyncQueue being shut down? If true, this instance will not enqueue
        // any new operations, Promises from enqueue requests will not resolve.
        get: function() {
            return this.Is;
        },
        enumerable: !1,
        configurable: !0
    }), /**
     * Adds a new operation to the queue without waiting for it to complete (i.e.
     * we ignore the Promise result).
     */ e.prototype.ws = function(t) {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.enqueue(t);
    }, /**
     * Regardless if the queue has initialized shutdown, adds a new operation to the
     * queue without waiting for it to complete (i.e. we ignore the Promise result).
     */ e.prototype.bs = function(t) {
        this.vs(), // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.Ss(t);
    }, /**
     * Initialize the shutdown of this queue. Once this method is called, the
     * only possible way to request running an operation is through
     * `enqueueEvenWhileRestricted()`.
     */ e.prototype.Ds = function() {
        if (!this.Is) {
            this.Is = !0;
            var t = $6c8154472dd99012$var$Sr();
            t && "function" == typeof t.removeEventListener && t.removeEventListener("visibilitychange", this.Vs);
        }
    }, /**
     * Adds a new operation to the queue. Returns a promise that will be resolved
     * when the promise returned by the new operation is (with its value).
     */ e.prototype.enqueue = function(t) {
        return this.vs(), this.Is ? new Promise(function(t) {}) : this.Ss(t);
    }, /**
     * Enqueue a retryable operation.
     *
     * A retryable operation is rescheduled with backoff if it fails with a
     * IndexedDbTransactionError (the error type used by SimpleDb). All
     * retryable operations are executed in order and only run if all prior
     * operations were retried successfully.
     */ e.prototype.Cs = function(t) {
        var e = this;
        this.ws(function() {
            return e.Es.push(t), e.Ns();
        });
    }, /**
     * Runs the next operation from the retryable queue. If the operation fails,
     * reschedules with backoff.
     */ e.prototype.Ns = function() {
        return $876a70688d8d7977$export$1050f835b63b671e(this, void 0, void 0, function() {
            var e, n = this;
            return $876a70688d8d7977$export$67ebef60e6f28a6(this, function(t) {
                switch(t.label){
                    case 0:
                        if (0 === this.Es.length) return [
                            3 /*break*/ ,
                            5
                        ];
                        t.label = 1;
                    case 1:
                        return t.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]), [
                            4 /*yield*/ ,
                            this.Es[0]()
                        ];
                    case 2:
                        return t.sent(), this.Es.shift(), this.ys.reset(), [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        if (!$6c8154472dd99012$var$_r(e = t.sent())) throw e;
                        // Failure will be handled by AsyncQueue
                        return $6c8154472dd99012$var$l("AsyncQueue", "Operation failed with retryable error: " + e), [
                            3 /*break*/ ,
                            4
                        ];
                    case 4:
                        this.Es.length > 0 && // If there are additional operations, we re-schedule `retryNextOp()`.
                        // This is necessary to run retryable operations that failed during
                        // their initial attempt since we don't know whether they are already
                        // enqueued. If, for example, `op1`, `op2`, `op3` are enqueued and `op1`
                        // needs to  be re-run, we will run `op1`, `op1`, `op2` using the
                        // already enqueued calls to `retryNextOp()`. `op3()` will then run in the
                        // call scheduled here.
                        // Since `backoffAndRun()` cancels an existing backoff and schedules a
                        // new backoff on every call, there is only ever a single additional
                        // operation in the queue.
                        this.ys.gn(function() {
                            return n.Ns();
                        }), t.label = 5;
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    }, e.prototype.Ss = function(t) {
        var e = this, n = this.Ts.then(function() {
            return e.gs = !0, t().catch(function(t) {
                // Re-throw the error so that this.tail becomes a rejected Promise and
                // all further attempts to chain (via .then) will just short-circuit
                // and return the rejected Promise.
                throw e.Rs = t, e.gs = !1, $6c8154472dd99012$var$p("INTERNAL UNHANDLED ERROR: ", /**
 * Chrome includes Error.message in Error.stack. Other browsers do not.
 * This returns expected output of message + stack when available.
 * @param error Error or FirestoreError
 */ function(t) {
                    var e = t.message || "";
                    return t.stack && (e = t.stack.includes(t.message) ? t.stack : t.message + "\n" + t.stack), e;
                }(t)), t;
            }).then(function(t) {
                return e.gs = !1, t;
            });
        });
        return this.Ts = n, n;
    }, /**
     * Schedules an operation to be queued on the AsyncQueue once the specified
     * `delayMs` has elapsed. The returned DelayedOperation can be used to cancel
     * or fast-forward the operation prior to its running.
     */ e.prototype.yn = function(t, e, n) {
        var r = this;
        this.vs(), // Fast-forward delays for timerIds that have been overriden.
        this.Ps.indexOf(t) > -1 && (e = 0);
        var i = $6c8154472dd99012$var$Dr._s(this, t, e, n, function(t) {
            return r.Fs(t);
        });
        return this.As.push(i), i;
    }, e.prototype.vs = function() {
        this.Rs && $6c8154472dd99012$var$y();
    }, /**
     * Verifies there's an operation currently in-progress on the AsyncQueue.
     * Unfortunately we can't verify that the running code is in the promise chain
     * of that operation, so this isn't a foolproof check, but it should be enough
     * to catch some bugs.
     */ e.prototype.xs = function() {}, /**
     * Waits until all currently queued tasks are finished executing. Delayed
     * operations are not run.
     */ e.prototype.$s = function() {
        return $876a70688d8d7977$export$1050f835b63b671e(this, void 0, void 0, function() {
            var e;
            return $876a70688d8d7977$export$67ebef60e6f28a6(this, function(t) {
                switch(t.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            e = this.Ts
                        ];
                    case 1:
                        t.sent(), t.label = 2;
                    case 2:
                        if (e !== this.Ts) return [
                            3 /*break*/ ,
                            0
                        ];
                        t.label = 3;
                    case 3:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    }, /**
     * For Tests: Determine if a delayed operation with a particular TimerId
     * exists.
     */ e.prototype.ks = function(t) {
        for(var e = 0, n = this.As; e < n.length; e++){
            if (n[e].dn === t) return !0;
        }
        return !1;
    }, /**
     * For Tests: Runs some or all delayed operations early.
     *
     * @param lastTimerId Delayed operations up to and including this TimerId will
     *  be drained. Pass TimerId.All to run all delayed operations.
     * @returns a Promise that resolves once all operations have been run.
     */ e.prototype.Ms = function(t) {
        var e = this;
        // Note that draining may generate more delayed ops, so we do that first.
        return this.$s().then(function() {
            // Run ops in the same order they'd run if they ran naturally.
            e.As.sort(function(t, e) {
                return t.us - e.us;
            });
            for(var n = 0, r = e.As; n < r.length; n++){
                var i = r[n];
                if (i.pn(), "all" /* All */  !== t && i.dn === t) break;
            }
            return e.$s();
        });
    }, /**
     * For Tests: Skip all subsequent delays for a timer id.
     */ e.prototype.Os = function(t) {
        this.Ps.push(t);
    }, /** Called once a DelayedOperation is run or canceled. */ e.prototype.Fs = function(t) {
        // NOTE: indexOf / slice are O(n), but delayedOperations is expected to be small.
        var e = this.As.indexOf(t);
        this.As.splice(e, 1);
    }, e;
}();
/**
 * Returns a FirestoreError that can be surfaced to the user if the provided
 * error is an IndexedDbTransactionError. Re-throws the error otherwise.
 */ function $6c8154472dd99012$var$Lr(t, e) {
    if ($6c8154472dd99012$var$p("AsyncQueue", e + ": " + t), $6c8154472dd99012$var$_r(t)) return new $6c8154472dd99012$var$c($6c8154472dd99012$var$a.UNAVAILABLE, e + ": " + t);
    throw t;
}
var $6c8154472dd99012$var$kr = function() {
    this.Ls = void 0, this.listeners = [];
}, $6c8154472dd99012$var$Rr = function() {
    this.Bs = new $6c8154472dd99012$var$it(function(t) {
        return $6c8154472dd99012$var$Hn(t);
    }, $6c8154472dd99012$var$Qn), this.onlineState = "Unknown" /* Unknown */ , this.qs = new Set;
};
function $6c8154472dd99012$var$Or(e, n) {
    return $876a70688d8d7977$export$1050f835b63b671e(this, void 0, void 0, function() {
        var r, i, o, s, u, a, c;
        return $876a70688d8d7977$export$67ebef60e6f28a6(this, function(t) {
            switch(t.label){
                case 0:
                    if (r = $6c8154472dd99012$var$m(e), i = n.query, o = !1, (s = r.Bs.get(i)) || (o = !0, s = new $6c8154472dd99012$var$kr), !o) return [
                        3 /*break*/ ,
                        4
                    ];
                    t.label = 1;
                case 1:
                    return t.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]), u = s, [
                        4 /*yield*/ ,
                        r.Us(i)
                    ];
                case 2:
                    return u.Ls = t.sent(), [
                        3 /*break*/ ,
                        4
                    ];
                case 3:
                    return a = t.sent(), c = $6c8154472dd99012$var$Lr(a, "Initialization of query '" + $6c8154472dd99012$var$Yn(n.query) + "' failed"), [
                        2 /*return*/ ,
                        void n.onError(c)
                    ];
                case 4:
                    return r.Bs.set(i, s), s.listeners.push(n), // Run global snapshot listeners if a consistent snapshot has been emitted.
                    n.Qs(r.onlineState), s.Ls && n.Ws(s.Ls) && $6c8154472dd99012$var$Cr(r), [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
function $6c8154472dd99012$var$Pr(e, n) {
    return $876a70688d8d7977$export$1050f835b63b671e(this, void 0, void 0, function() {
        var r, i, o, s, u;
        return $876a70688d8d7977$export$67ebef60e6f28a6(this, function(t) {
            return r = $6c8154472dd99012$var$m(e), i = n.query, o = !1, (s = r.Bs.get(i)) && (u = s.listeners.indexOf(n)) >= 0 && (s.listeners.splice(u, 1), o = 0 === s.listeners.length), o ? [
                2 /*return*/ ,
                (r.Bs.delete(i), r.js(i))
            ] : [
                2 /*return*/ 
            ];
        });
    });
}
function $6c8154472dd99012$var$Vr(t, e) {
    for(var n = $6c8154472dd99012$var$m(t), r = !1, i = 0, o = e; i < o.length; i++){
        var s = o[i], u = s.query, a = n.Bs.get(u);
        if (a) {
            for(var c = 0, h = a.listeners; c < h.length; c++)h[c].Ws(s) && (r = !0);
            a.Ls = s;
        }
    }
    r && $6c8154472dd99012$var$Cr(n);
}
function $6c8154472dd99012$var$Ur(t, e, n) {
    var r = $6c8154472dd99012$var$m(t), i = r.Bs.get(e);
    if (i) for(var o = 0, s = i.listeners; o < s.length; o++)s[o].onError(n);
    // Remove all listeners. NOTE: We don't need to call syncEngine.unlisten()
    // after an error.
    r.Bs.delete(e);
}
// Call all global snapshot listeners that have been set.
function $6c8154472dd99012$var$Cr(t) {
    t.qs.forEach(function(t) {
        t.next();
    });
}
/**
 * QueryListener takes a series of internal view snapshots and determines
 * when to raise the event.
 *
 * It uses an Observer to dispatch events.
 */ var $6c8154472dd99012$var$Fr = /** @class */ function() {
    function t(t, e, n) {
        this.query = t, this.Ks = e, /**
             * Initial snapshots (e.g. from cache) may not be propagated to the wrapped
             * observer. This flag is set to true once we've actually raised an event.
             */ this.Gs = !1, this.zs = null, this.onlineState = "Unknown" /* Unknown */ , this.options = n || {} /**
     * Applies the new ViewSnapshot to this listener, raising a user-facing event
     * if applicable (depending on what changed, whether the user has opted into
     * metadata-only changes, etc.). Returns true if a user-facing event was
     * indeed raised.
     */ ;
    }
    return t.prototype.Ws = function(t) {
        if (!this.options.includeMetadataChanges) {
            for(// Remove the metadata only changes.
            var e = [], n = 0, r = t.docChanges; n < r.length; n++){
                var i = r[n];
                3 /* Metadata */  !== i.type && e.push(i);
            }
            t = new $6c8154472dd99012$var$Ft(t.query, t.docs, t.Qt, e, t.Wt, t.fromCache, t.jt, /* excludesMetadataChanges= */ !0);
        }
        var o = !1;
        return this.Gs ? this.Hs(t) && (this.Ks.next(t), o = !0) : this.Ys(t, this.onlineState) && (this.Js(t), o = !0), this.zs = t, o;
    }, t.prototype.onError = function(t) {
        this.Ks.error(t);
    }, /** Returns whether a snapshot was raised. */ t.prototype.Qs = function(t) {
        this.onlineState = t;
        var e = !1;
        return this.zs && !this.Gs && this.Ys(this.zs, t) && (this.Js(this.zs), e = !0), e;
    }, t.prototype.Ys = function(t, e) {
        // Always raise the first event when we're synced
        if (!t.fromCache) return !0;
        // NOTE: We consider OnlineState.Unknown as online (it should become Offline
        // or Online if we wait long enough).
        var n = "Offline" /* Offline */  !== e;
        // Don't raise the event if we're online, aren't synced yet (checked
        // above) and are waiting for a sync.
        return !(this.options.Xs && n || t.docs.m() && "Offline" /* Offline */  !== e);
    // Raise data from cache if we have any documents or we are offline
    }, t.prototype.Hs = function(t) {
        // We don't need to handle includeDocumentMetadataChanges here because
        // the Metadata only changes have already been stripped out if needed.
        // At this point the only changes we will see are the ones we should
        // propagate.
        if (t.docChanges.length > 0) return !0;
        var e = this.zs && this.zs.hasPendingWrites !== t.hasPendingWrites;
        return !(!t.jt && !e) && !0 === this.options.includeMetadataChanges;
    // Generally we should have hit one of the cases above, but it's possible
    // to get here if there were only metadata docChanges and they got
    // stripped out.
    }, t.prototype.Js = function(t) {
        t = $6c8154472dd99012$var$Ft.Gt(t.query, t.docs, t.Wt, t.fromCache), this.Gs = !0, this.Ks.next(t);
    }, t;
}(), $6c8154472dd99012$var$Mr = /** @class */ function() {
    function t(t) {
        this.uid = t;
    }
    return t.prototype.Zs = function() {
        return null != this.uid;
    }, /**
     * Returns a key representing this user, suitable for inclusion in a
     * dictionary.
     */ t.prototype.ti = function() {
        return this.Zs() ? "uid:" + this.uid : "anonymous-user";
    }, t.prototype.isEqual = function(t) {
        return t.uid === this.uid;
    }, t;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Simple wrapper around a nullable UID. Mostly exists to make code more
 * readable.
 */ /** A user with a null UID. */ $6c8154472dd99012$var$Mr.UNAUTHENTICATED = new $6c8154472dd99012$var$Mr(null), // TODO(mikelehen): Look into getting a proper uid-equivalent for
// non-FirebaseAuth providers.
$6c8154472dd99012$var$Mr.ei = new $6c8154472dd99012$var$Mr("google-credentials-uid"), $6c8154472dd99012$var$Mr.ni = new $6c8154472dd99012$var$Mr("first-party-uid");
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * `ListenSequence` is a monotonic sequence. It is initialized with a minimum value to
 * exceed. All subsequent calls to next will return increasing values. If provided with a
 * `SequenceNumberSyncer`, it will additionally bump its next value when told of a new value, as
 * well as write out sequence numbers that it produces via `next()`.
 */ var $6c8154472dd99012$var$qr = /** @class */ function() {
    function t(t, e) {
        var n = this;
        this.previousValue = t, e && (e.si = function(t) {
            return n.ii(t);
        }, this.ri = function(t) {
            return e.oi(t);
        });
    }
    return t.prototype.ii = function(t) {
        return this.previousValue = Math.max(t, this.previousValue), this.previousValue;
    }, t.prototype.next = function() {
        var t = ++this.previousValue;
        return this.ri && this.ri(t), t;
    }, t;
}();
/** Assembles the key for a client state in WebStorage */ function $6c8154472dd99012$var$jr(t, e) {
    return "firestore_clients_" + t + "_" + e;
}
// The format of the WebStorage key that stores the mutation state is:
//     firestore_mutations_<persistence_prefix>_<batch_id>
//     (for unauthenticated users)
// or: firestore_mutations_<persistence_prefix>_<batch_id>_<user_uid>
// 'user_uid' is last to avoid needing to escape '_' characters that it might
// contain.
/** Assembles the key for a mutation batch in WebStorage */ function $6c8154472dd99012$var$Gr(t, e, n) {
    var r = "firestore_mutations_" + t + "_" + n;
    return e.Zs() && (r += "_" + e.uid), r;
}
// The format of the WebStorage key that stores a query target's metadata is:
//     firestore_targets_<persistence_prefix>_<target_id>
/** Assembles the key for a query state in WebStorage */ function $6c8154472dd99012$var$zr(t, e) {
    return "firestore_targets_" + t + "_" + e;
}
// The WebStorage prefix that stores the primary tab's online state. The
// format of the key is:
//     firestore_online_state_<persistence_prefix>
/**
 * Holds the state of a mutation batch, including its user ID, batch ID and
 * whether the batch is 'pending', 'acknowledged' or 'rejected'.
 */ // Visible for testing
$6c8154472dd99012$var$qr.ai = -1;
var $6c8154472dd99012$var$Br = /** @class */ function() {
    function t(t, e, n, r) {
        this.user = t, this.batchId = e, this.state = n, this.error = r /**
     * Parses a MutationMetadata from its JSON representation in WebStorage.
     * Logs a warning and returns null if the format of the data is not valid.
     */ ;
    }
    return t.ci = function(e, n, r) {
        var i = JSON.parse(r), o = "object" == typeof i && -1 !== [
            "pending",
            "acknowledged",
            "rejected"
        ].indexOf(i.state) && (void 0 === i.error || "object" == typeof i.error), s = void 0;
        return o && i.error && (o = "string" == typeof i.error.message && "string" == typeof i.error.code) && (s = new $6c8154472dd99012$var$c(i.error.code, i.error.message)), o ? new t(e, n, i.state, s) : ($6c8154472dd99012$var$p("SharedClientState", "Failed to parse mutation state for ID '" + n + "': " + r), null);
    }, t.prototype.ui = function() {
        var t = {
            state: this.state,
            updateTimeMs: Date.now()
        };
        return this.error && (t.error = {
            code: this.error.code,
            message: this.error.message
        }), JSON.stringify(t);
    }, t;
}(), $6c8154472dd99012$var$Wr = /** @class */ function() {
    function t(t, e, n) {
        this.targetId = t, this.state = e, this.error = n /**
     * Parses a QueryTargetMetadata from its JSON representation in WebStorage.
     * Logs a warning and returns null if the format of the data is not valid.
     */ ;
    }
    return t.ci = function(e, n) {
        var r = JSON.parse(n), i = "object" == typeof r && -1 !== [
            "not-current",
            "current",
            "rejected"
        ].indexOf(r.state) && (void 0 === r.error || "object" == typeof r.error), o = void 0;
        return i && r.error && (i = "string" == typeof r.error.message && "string" == typeof r.error.code) && (o = new $6c8154472dd99012$var$c(r.error.code, r.error.message)), i ? new t(e, r.state, o) : ($6c8154472dd99012$var$p("SharedClientState", "Failed to parse target state for ID '" + e + "': " + n), null);
    }, t.prototype.ui = function() {
        var t = {
            state: this.state,
            updateTimeMs: Date.now()
        };
        return this.error && (t.error = {
            code: this.error.code,
            message: this.error.message
        }), JSON.stringify(t);
    }, t;
}(), $6c8154472dd99012$var$Kr = /** @class */ function() {
    function t(t, e) {
        this.clientId = t, this.activeTargetIds = e /**
     * Parses a RemoteClientState from the JSON representation in WebStorage.
     * Logs a warning and returns null if the format of the data is not valid.
     */ ;
    }
    return t.ci = function(e, n) {
        for(var r = JSON.parse(n), i = "object" == typeof r && r.activeTargetIds instanceof Array, o = $6c8154472dd99012$var$Vt(), s = 0; i && s < r.activeTargetIds.length; ++s)i = $6c8154472dd99012$var$ct(r.activeTargetIds[s]), o = o.add(r.activeTargetIds[s]);
        return i ? new t(e, o) : ($6c8154472dd99012$var$p("SharedClientState", "Failed to parse client data for instance '" + e + "': " + n), null);
    }, t;
}(), $6c8154472dd99012$var$Qr = /** @class */ function() {
    function t(t, e) {
        this.clientId = t, this.onlineState = e /**
     * Parses a SharedOnlineState from its JSON representation in WebStorage.
     * Logs a warning and returns null if the format of the data is not valid.
     */ ;
    }
    return t.ci = function(e) {
        var n = JSON.parse(e);
        return "object" == typeof n && -1 !== [
            "Unknown",
            "Online",
            "Offline"
        ].indexOf(n.onlineState) && "string" == typeof n.clientId ? new t(n.clientId, n.onlineState) : ($6c8154472dd99012$var$p("SharedClientState", "Failed to parse online state: " + e), null);
    }, t;
}(), $6c8154472dd99012$var$Hr = /** @class */ function() {
    function t() {
        this.activeTargetIds = $6c8154472dd99012$var$Vt();
    }
    return t.prototype.hi = function(t) {
        this.activeTargetIds = this.activeTargetIds.add(t);
    }, t.prototype.li = function(t) {
        this.activeTargetIds = this.activeTargetIds.delete(t);
    }, /**
     * Converts this entry into a JSON-encoded format we can use for WebStorage.
     * Does not encode `clientId` as it is part of the key in WebStorage.
     */ t.prototype.ui = function() {
        var t = {
            activeTargetIds: this.activeTargetIds.A(),
            updateTimeMs: Date.now()
        };
        return JSON.stringify(t);
    }, t;
}(), $6c8154472dd99012$var$Yr = /** @class */ function() {
    function e(t, e, n, r, i) {
        this.window = t, this.fn = e, this.persistenceKey = n, this._i = r, this.fi = null, this.di = null, this.si = null, this.wi = this.mi.bind(this), this.Ti = new $6c8154472dd99012$var$bt($6c8154472dd99012$var$H), this.Ei = !1, /**
             * Captures WebStorage events that occur before `start()` is called. These
             * events are replayed once `WebStorageSharedClientState` is started.
             */ this.Ii = [];
        // Escape the special characters mentioned here:
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions
        var o = n.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
        this.storage = this.window.localStorage, this.currentUser = i, this.Ai = $6c8154472dd99012$var$jr(this.persistenceKey, this._i), this.Ri = /** Assembles the key for the current sequence number. */ function(t) {
            return "firestore_sequence_number_" + t;
        }(this.persistenceKey), this.Ti = this.Ti.ot(this._i, new $6c8154472dd99012$var$Hr), this.gi = new RegExp("^firestore_clients_" + o + "_([^_]*)$"), this.Pi = new RegExp("^firestore_mutations_" + o + "_(\\d+)(?:_(.*))?$"), this.yi = new RegExp("^firestore_targets_" + o + "_(\\d+)$"), this.Vi = /** Assembles the key for the online state of the primary tab. */ function(t) {
            return "firestore_online_state_" + t;
        }(this.persistenceKey), // Rather than adding the storage observer during start(), we add the
        // storage observer during initialization. This ensures that we collect
        // events before other components populate their initial state (during their
        // respective start() calls). Otherwise, we might for example miss a
        // mutation that is added after LocalStore's start() processed the existing
        // mutations but before we observe WebStorage events.
        this.window.addEventListener("storage", this.wi);
    }
    /** Returns 'true' if WebStorage is available in the current environment. */ return e.Ln = function(t) {
        return !(!t || !t.localStorage);
    }, e.prototype.start = function() {
        return $876a70688d8d7977$export$1050f835b63b671e(this, void 0, void 0, function() {
            var e, n, r, i, o, s, u, a, c, h, f, l = this;
            return $876a70688d8d7977$export$67ebef60e6f28a6(this, function(t) {
                switch(t.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.fi.pi()
                        ];
                    case 1:
                        for(e = t.sent(), n = 0, r = e; n < r.length; n++)(i = r[n]) !== this._i && (o = this.getItem($6c8154472dd99012$var$jr(this.persistenceKey, i))) && (s = $6c8154472dd99012$var$Kr.ci(i, o)) && (this.Ti = this.Ti.ot(s.clientId, s));
                        for(this.bi(), (u = this.storage.getItem(this.Vi)) && (a = this.vi(u)) && this.Si(a), c = 0, h = this.Ii; c < h.length; c++)f = h[c], this.mi(f);
                        return this.Ii = [], // Register a window unload hook to remove the client metadata entry from
                        // WebStorage even if `shutdown()` was not called.
                        this.window.addEventListener("unload", function() {
                            return l.Di();
                        }), this.Ei = !0, [
                            2 /*return*/ 
                        ];
                }
            });
        });
    }, e.prototype.oi = function(t) {
        this.setItem(this.Ri, JSON.stringify(t));
    }, e.prototype.Ci = function() {
        return this.Ni(this.Ti);
    }, e.prototype.Fi = function(t) {
        var e = !1;
        return this.Ti.forEach(function(n, r) {
            r.activeTargetIds.has(t) && (e = !0);
        }), e;
    }, e.prototype.xi = function(t) {
        this.$i(t, "pending");
    }, e.prototype.ki = function(t, e, n) {
        this.$i(t, e, n), // Once a final mutation result is observed by other clients, they no longer
        // access the mutation's metadata entry. Since WebStorage replays events
        // in order, it is safe to delete the entry right after updating it.
        this.Mi(t);
    }, e.prototype.Oi = function(t) {
        var e = "not-current";
        // Lookup an existing query state if the target ID was already registered
        // by another tab
        if (this.Fi(t)) {
            var n = this.storage.getItem($6c8154472dd99012$var$zr(this.persistenceKey, t));
            if (n) {
                var r = $6c8154472dd99012$var$Wr.ci(t, n);
                r && (e = r.state);
            }
        }
        return this.Li.hi(t), this.bi(), e;
    }, e.prototype.Bi = function(t) {
        this.Li.li(t), this.bi();
    }, e.prototype.qi = function(t) {
        return this.Li.activeTargetIds.has(t);
    }, e.prototype.Ui = function(t) {
        this.removeItem($6c8154472dd99012$var$zr(this.persistenceKey, t));
    }, e.prototype.Qi = function(t, e, n) {
        this.Wi(t, e, n);
    }, e.prototype.ji = function(t, e, n) {
        var r = this;
        e.forEach(function(t) {
            r.Mi(t);
        }), this.currentUser = t, n.forEach(function(t) {
            r.xi(t);
        });
    }, e.prototype.Ki = function(t) {
        this.Gi(t);
    }, e.prototype.Di = function() {
        this.Ei && (this.window.removeEventListener("storage", this.wi), this.removeItem(this.Ai), this.Ei = !1);
    }, e.prototype.getItem = function(t) {
        var e = this.storage.getItem(t);
        return $6c8154472dd99012$var$l("SharedClientState", "READ", t, e), e;
    }, e.prototype.setItem = function(t, e) {
        $6c8154472dd99012$var$l("SharedClientState", "SET", t, e), this.storage.setItem(t, e);
    }, e.prototype.removeItem = function(t) {
        $6c8154472dd99012$var$l("SharedClientState", "REMOVE", t), this.storage.removeItem(t);
    }, e.prototype.mi = function(e) {
        var n = this, r = e;
        // Note: The function is typed to take Event to be interface-compatible with
        // `Window.addEventListener`.
        if (r.storageArea === this.storage) {
            if ($6c8154472dd99012$var$l("SharedClientState", "EVENT", r.key, r.newValue), r.key === this.Ai) return void $6c8154472dd99012$var$p("Received WebStorage notification for local change. Another client might have garbage-collected our state");
            this.fn.Cs(function() {
                return $876a70688d8d7977$export$1050f835b63b671e(n, void 0, void 0, function() {
                    var e, n, i, o, s, u;
                    return $876a70688d8d7977$export$67ebef60e6f28a6(this, function(t) {
                        if (this.Ei) {
                            if (null !== r.key) {
                                if (this.gi.test(r.key)) {
                                    if (null == r.newValue) return e = this.zi(r.key), [
                                        2 /*return*/ ,
                                        this.Hi(e, null)
                                    ];
                                    if (n = this.Yi(r.key, r.newValue)) return [
                                        2 /*return*/ ,
                                        this.Hi(n.clientId, n)
                                    ];
                                } else if (this.Pi.test(r.key)) {
                                    if (null !== r.newValue && (i = this.Ji(r.key, r.newValue))) return [
                                        2 /*return*/ ,
                                        this.Xi(i)
                                    ];
                                } else if (this.yi.test(r.key)) {
                                    if (null !== r.newValue && (o = this.Zi(r.key, r.newValue))) return [
                                        2 /*return*/ ,
                                        this.tr(o)
                                    ];
                                } else if (r.key === this.Vi) {
                                    if (null !== r.newValue && (s = this.vi(r.newValue))) return [
                                        2 /*return*/ ,
                                        this.Si(s)
                                    ];
                                } else r.key === this.Ri && (u = function(t) {
                                    var e = $6c8154472dd99012$var$qr.ai;
                                    if (null != t) try {
                                        var n = JSON.parse(t);
                                        $6c8154472dd99012$var$g("number" == typeof n), e = n;
                                    } catch (t) {
                                        $6c8154472dd99012$var$p("SharedClientState", "Failed to read sequence number from WebStorage", t);
                                    }
                                    return e;
                                }(r.newValue)) !== $6c8154472dd99012$var$qr.ai && this.si(u);
                            }
                        } else this.Ii.push(r);
                        return [
                            2 /*return*/ 
                        ];
                    });
                });
            });
        }
    }, Object.defineProperty(e.prototype, "Li", {
        get: function() {
            return this.Ti.get(this._i);
        },
        enumerable: !1,
        configurable: !0
    }), e.prototype.bi = function() {
        this.setItem(this.Ai, this.Li.ui());
    }, e.prototype.$i = function(t, e, n) {
        var r = new $6c8154472dd99012$var$Br(this.currentUser, t, e, n), i = $6c8154472dd99012$var$Gr(this.persistenceKey, this.currentUser, t);
        this.setItem(i, r.ui());
    }, e.prototype.Mi = function(t) {
        var e = $6c8154472dd99012$var$Gr(this.persistenceKey, this.currentUser, t);
        this.removeItem(e);
    }, e.prototype.Gi = function(t) {
        var e = {
            clientId: this._i,
            onlineState: t
        };
        this.storage.setItem(this.Vi, JSON.stringify(e));
    }, e.prototype.Wi = function(t, e, n) {
        var r = $6c8154472dd99012$var$zr(this.persistenceKey, t), i = new $6c8154472dd99012$var$Wr(t, e, n);
        this.setItem(r, i.ui());
    }, /**
     * Parses a client state key in WebStorage. Returns null if the key does not
     * match the expected key format.
     */ e.prototype.zi = function(t) {
        var e = this.gi.exec(t);
        return e ? e[1] : null;
    }, /**
     * Parses a client state in WebStorage. Returns 'null' if the value could not
     * be parsed.
     */ e.prototype.Yi = function(t, e) {
        var n = this.zi(t);
        return $6c8154472dd99012$var$Kr.ci(n, e);
    }, /**
     * Parses a mutation batch state in WebStorage. Returns 'null' if the value
     * could not be parsed.
     */ e.prototype.Ji = function(t, e) {
        var n = this.Pi.exec(t), r = Number(n[1]), i = void 0 !== n[2] ? n[2] : null;
        return $6c8154472dd99012$var$Br.ci(new $6c8154472dd99012$var$Mr(i), r, e);
    }, /**
     * Parses a query target state from WebStorage. Returns 'null' if the value
     * could not be parsed.
     */ e.prototype.Zi = function(t, e) {
        var n = this.yi.exec(t), r = Number(n[1]);
        return $6c8154472dd99012$var$Wr.ci(r, e);
    }, /**
     * Parses an online state from WebStorage. Returns 'null' if the value
     * could not be parsed.
     */ e.prototype.vi = function(t) {
        return $6c8154472dd99012$var$Qr.ci(t);
    }, e.prototype.Xi = function(e) {
        return $876a70688d8d7977$export$1050f835b63b671e(this, void 0, void 0, function() {
            return $876a70688d8d7977$export$67ebef60e6f28a6(this, function(t) {
                return e.user.uid === this.currentUser.uid ? [
                    2 /*return*/ ,
                    this.fi.er(e.batchId, e.state, e.error)
                ] : ($6c8154472dd99012$var$l("SharedClientState", "Ignoring mutation for non-active user " + e.user.uid), [
                    2 /*return*/ 
                ]);
            });
        });
    }, e.prototype.tr = function(t) {
        return this.fi.nr(t.targetId, t.state, t.error);
    }, e.prototype.Hi = function(t, e) {
        var n = this, r = e ? this.Ti.ot(t, e) : this.Ti.remove(t), i = this.Ni(this.Ti), o = this.Ni(r), s = [], u = [];
        return o.forEach(function(t) {
            i.has(t) || s.push(t);
        }), i.forEach(function(t) {
            o.has(t) || u.push(t);
        }), this.fi.sr(s, u).then(function() {
            n.Ti = r;
        });
    }, e.prototype.Si = function(t) {
        // We check whether the client that wrote this online state is still active
        // by comparing its client ID to the list of clients kept active in
        // IndexedDb. If a client does not update their IndexedDb client state
        // within 5 seconds, it is considered inactive and we don't emit an online
        // state event.
        this.Ti.get(t.clientId) && this.di(t.onlineState);
    }, e.prototype.Ni = function(t) {
        var e = $6c8154472dd99012$var$Vt();
        return t.forEach(function(t, n) {
            e = e.kt(n.activeTargetIds);
        }), e;
    }, e;
}(), $6c8154472dd99012$var$$r = /** @class */ function() {
    function t() {
        this.ir = new $6c8154472dd99012$var$Hr, this.rr = {}, this.di = null, this.si = null;
    }
    return t.prototype.xi = function(t) {
    // No op.
    }, t.prototype.ki = function(t, e, n) {
    // No op.
    }, t.prototype.Oi = function(t) {
        return this.ir.hi(t), this.rr[t] || "not-current";
    }, t.prototype.Qi = function(t, e, n) {
        this.rr[t] = e;
    }, t.prototype.Bi = function(t) {
        this.ir.li(t);
    }, t.prototype.qi = function(t) {
        return this.ir.activeTargetIds.has(t);
    }, t.prototype.Ui = function(t) {
        delete this.rr[t];
    }, t.prototype.Ci = function() {
        return this.ir.activeTargetIds;
    }, t.prototype.Fi = function(t) {
        return this.ir.activeTargetIds.has(t);
    }, t.prototype.start = function() {
        return this.ir = new $6c8154472dd99012$var$Hr, Promise.resolve();
    }, t.prototype.ji = function(t, e, n) {
    // No op.
    }, t.prototype.Ki = function(t) {
    // No op.
    }, t.prototype.Di = function() {}, t.prototype.oi = function(t) {}, t;
}(), $6c8154472dd99012$var$Xr = /** @class */ function() {
    /**
     * @param batchId The unique ID of this mutation batch.
     * @param localWriteTime The original write time of this mutation.
     * @param baseMutations Mutations that are used to populate the base
     * values when this mutation is applied locally. This can be used to locally
     * overwrite values that are persisted in the remote document cache. Base
     * mutations are never sent to the backend.
     * @param mutations The user-provided mutations in this mutation batch.
     * User-provided mutations are applied both locally and remotely on the
     * backend.
     */ function t(t, e, n, r) {
        this.batchId = t, this.ar = e, this.baseMutations = n, this.mutations = r /**
     * Applies all the mutations in this MutationBatch to the specified document
     * to create a new remote document
     *
     * @param docKey The key of the document to apply mutations to.
     * @param maybeDoc The document to apply mutations to.
     * @param batchResult The result of applying the MutationBatch to the
     * backend.
     */ ;
    }
    return t.prototype.cr = function(t, e, n) {
        for(var r = n.ur, i = 0; i < this.mutations.length; i++){
            var o = this.mutations[i];
            o.key.isEqual(t) && (e = $6c8154472dd99012$var$dn(o, e, r[i]));
        }
        return e;
    }, /**
     * Computes the local view of a document given all the mutations in this
     * batch.
     *
     * @param docKey The key of the document to apply mutations to.
     * @param maybeDoc The document to apply mutations to.
     */ t.prototype.hr = function(t, e) {
        // First, apply the base state. This allows us to apply non-idempotent
        // transform against a consistent set of values.
        for(var n = 0, r = this.baseMutations; n < r.length; n++){
            var i = r[n];
            i.key.isEqual(t) && (e = $6c8154472dd99012$var$vn(i, e, e, this.ar));
        }
        // Second, apply all user-provided mutations.
        for(var o = e, s = 0, u = this.mutations; s < u.length; s++){
            var a = u[s];
            a.key.isEqual(t) && (e = $6c8154472dd99012$var$vn(a, e, o, this.ar));
        }
        return e;
    }, /**
     * Computes the local view for all provided documents given the mutations in
     * this batch.
     */ t.prototype.lr = function(t) {
        var e = this, n = t;
        // TODO(mrschmidt): This implementation is O(n^2). If we apply the mutations
        // directly (as done in `applyToLocalView()`), we can reduce the complexity
        // to O(n).
        return this.mutations.forEach(function(r) {
            var i = e.hr(r.key, t.get(r.key));
            i && (n = n.ot(r.key, i));
        }), n;
    }, t.prototype.keys = function() {
        return this.mutations.reduce(function(t, e) {
            return t.add(e.key);
        }, $6c8154472dd99012$var$Ot());
    }, t.prototype.isEqual = function(t) {
        return this.batchId === t.batchId && $6c8154472dd99012$var$Y(this.mutations, t.mutations, function(t, e) {
            return $6c8154472dd99012$var$gn(t, e);
        }) && $6c8154472dd99012$var$Y(this.baseMutations, t.baseMutations, function(t, e) {
            return $6c8154472dd99012$var$gn(t, e);
        });
    }, t;
}(), $6c8154472dd99012$var$Jr = /** @class */ function() {
    function t(t, e, n, /**
     * A pre-computed mapping from each mutated document to the resulting
     * version.
     */ r) {
        this.batch = t, this._r = e, this.ur = n, this.dr = r /**
     * Creates a new MutationBatchResult for the given batch and results. There
     * must be one result for each mutation in the batch. This static factory
     * caches a document=>version mapping (docVersions).
     */ ;
    }
    return t.from = function(e, n, r) {
        $6c8154472dd99012$var$g(e.mutations.length === r.length);
        for(var i = $6c8154472dd99012$var$kt, o = e.mutations, s = 0; s < o.length; s++)i = i.ot(o[s].key, r[s].version);
        return new t(e, n, r, i);
    }, t;
}(), $6c8154472dd99012$var$Zr = /** @class */ function() {
    function t() {
        // A mapping of document key to the new cache entry that should be written (or null if any
        // existing cache entry should be removed).
        this.wr = new $6c8154472dd99012$var$it(function(t) {
            return t.toString();
        }, function(t, e) {
            return t.isEqual(e);
        }), this.mr = !1;
    }
    return Object.defineProperty(t.prototype, "readTime", {
        get: function() {
            return this.Tr;
        },
        set: function(t) {
            this.Tr = t;
        },
        enumerable: !1,
        configurable: !0
    }), /**
     * Buffers a `RemoteDocumentCache.addEntry()` call.
     *
     * You can only modify documents that have already been retrieved via
     * `getEntry()/getEntries()` (enforced via IndexedDbs `apply()`).
     */ t.prototype.Er = function(t, e) {
        this.Ir(), this.readTime = e, this.wr.set(t.key, t);
    }, /**
     * Buffers a `RemoteDocumentCache.removeEntry()` call.
     *
     * You can only remove documents that have already been retrieved via
     * `getEntry()/getEntries()` (enforced via IndexedDbs `apply()`).
     */ t.prototype.Ar = function(t, e) {
        this.Ir(), e && (this.readTime = e), this.wr.set(t, null);
    }, /**
     * Looks up an entry in the cache. The buffered changes will first be checked,
     * and if no buffered change applies, this will forward to
     * `RemoteDocumentCache.getEntry()`.
     *
     * @param transaction The transaction in which to perform any persistence
     *     operations.
     * @param documentKey The key of the entry to look up.
     * @return The cached Document or NoDocument entry, or null if we have nothing
     * cached.
     */ t.prototype.Rr = function(t, e) {
        this.Ir();
        var n = this.wr.get(e);
        return void 0 !== n ? $6c8154472dd99012$var$yr.resolve(n) : this.gr(t, e);
    }, /**
     * Looks up several entries in the cache, forwarding to
     * `RemoteDocumentCache.getEntry()`.
     *
     * @param transaction The transaction in which to perform any persistence
     *     operations.
     * @param documentKeys The keys of the entries to look up.
     * @return A map of cached `Document`s or `NoDocument`s, indexed by key. If an
     *     entry cannot be found, the corresponding key will be mapped to a null
     *     value.
     */ t.prototype.getEntries = function(t, e) {
        return this.Pr(t, e);
    }, /**
     * Applies buffered changes to the underlying RemoteDocumentCache, using
     * the provided transaction.
     */ t.prototype.apply = function(t) {
        return this.Ir(), this.mr = !0, this.yr(t);
    }, /** Helper to assert this.changes is not null  */ t.prototype.Ir = function() {}, t;
}(), $6c8154472dd99012$var$ti = "The current tab is not in the required state to perform this operation. It might be necessary to refresh the browser tab.", $6c8154472dd99012$var$ei = /** @class */ function() {
    function t() {
        this.Vr = [];
    }
    return t.prototype.pr = function(t) {
        this.Vr.push(t);
    }, t.prototype.br = function() {
        this.Vr.forEach(function(t) {
            return t();
        });
    }, t;
}(), $6c8154472dd99012$var$ni = /** @class */ function() {
    function t(t, e, n) {
        this.vr = t, this.Sr = e, this.Dr = n /**
     * Get the local view of the document identified by `key`.
     *
     * @return Local view of the document or null if we don't have any cached
     * state for it.
     */ ;
    }
    return t.prototype.Cr = function(t, e) {
        var n = this;
        return this.Sr.Nr(t, e).next(function(r) {
            return n.Fr(t, e, r);
        });
    }, /** Internal version of `getDocument` that allows reusing batches. */ t.prototype.Fr = function(t, e, n) {
        return this.vr.Rr(t, e).next(function(t) {
            for(var r = 0, i = n; r < i.length; r++)t = i[r].hr(e, t);
            return t;
        });
    }, // Returns the view of the given `docs` as they would appear after applying
    // all mutations in the given `batches`.
    t.prototype.$r = function(t, e, n) {
        var r = $6c8154472dd99012$var$Dt();
        return e.forEach(function(t, e) {
            for(var i = 0, o = n; i < o.length; i++)e = o[i].hr(t, e);
            r = r.ot(t, e);
        }), r;
    }, /**
     * Gets the local view of the documents identified by `keys`.
     *
     * If we don't have cached state for a document in `keys`, a NoDocument will
     * be stored for that key in the resulting set.
     */ t.prototype.kr = function(t, e) {
        var n = this;
        return this.vr.getEntries(t, e).next(function(e) {
            return n.Mr(t, e);
        });
    }, /**
     * Similar to `getDocuments`, but creates the local view from the given
     * `baseDocs` without retrieving documents from the local store.
     */ t.prototype.Mr = function(t, e) {
        var n = this;
        return this.Sr.Or(t, e).next(function(r) {
            var i = n.$r(t, e, r), o = $6c8154472dd99012$var$St();
            return i.forEach(function(t, e) {
                // TODO(http://b/32275378): Don't conflate missing / deleted.
                e || (e = new $6c8154472dd99012$var$Rn(t, $6c8154472dd99012$var$st.min())), o = o.ot(t, e);
            }), o;
        });
    }, /**
     * Performs a query against the local view of all documents.
     *
     * @param transaction The persistence transaction.
     * @param query The query to match documents against.
     * @param sinceReadTime If not set to SnapshotVersion.min(), return only
     *     documents that have been read since this snapshot version (exclusive).
     */ t.prototype.Lr = function(t, e, n) {
        /**
 * Returns whether the query matches a single document by path (rather than a
 * collection).
 */ return function(t) {
            return $6c8154472dd99012$var$A.F(t.path) && null === t.collectionGroup && 0 === t.filters.length;
        }(e) ? this.Br(t, e.path) : $6c8154472dd99012$var$jn(e) ? this.qr(t, e, n) : this.Ur(t, e, n);
    }, t.prototype.Br = function(t, e) {
        // Just do a simple document lookup.
        return this.Cr(t, new $6c8154472dd99012$var$A(e)).next(function(t) {
            var e = $6c8154472dd99012$var$Lt();
            return t instanceof $6c8154472dd99012$var$kn && (e = e.ot(t.key, t)), e;
        });
    }, t.prototype.qr = function(t, e, n) {
        var r = this, i = e.collectionGroup, o = $6c8154472dd99012$var$Lt();
        return this.Dr.Qr(t, i).next(function(s) {
            return $6c8154472dd99012$var$yr.forEach(s, function(s) {
                var u = function(t, e) {
                    return new $6c8154472dd99012$var$Pn(e, /*collectionGroup=*/ null, t.on.slice(), t.filters.slice(), t.limit, t.an, t.startAt, t.endAt);
                }(e, s.child(i));
                return r.Ur(t, u, n).next(function(t) {
                    t.forEach(function(t, e) {
                        o = o.ot(t, e);
                    });
                });
            }).next(function() {
                return o;
            });
        });
    }, t.prototype.Ur = function(t, e, n) {
        var r, i, o = this;
        // Query the remote documents and overlay mutations.
        return this.vr.Lr(t, e, n).next(function(n) {
            return r = n, o.Sr.Wr(t, e);
        }).next(function(e) {
            return i = e, o.jr(t, i, r).next(function(t) {
                r = t;
                for(var e = 0, n = i; e < n.length; e++)for(var o = n[e], s = 0, u = o.mutations; s < u.length; s++){
                    var a = u[s], c = a.key, h = r.get(c), f = $6c8154472dd99012$var$vn(a, h, h, o.ar);
                    r = f instanceof $6c8154472dd99012$var$kn ? r.ot(c, f) : r.remove(c);
                }
            });
        }).next(function() {
            // Finally, filter out any documents that don't actually match
            // the query.
            return r.forEach(function(t, n) {
                $6c8154472dd99012$var$$n(e, n) || (r = r.remove(t));
            }), r;
        });
    }, t.prototype.jr = function(t, e, n) {
        for(var r = $6c8154472dd99012$var$Ot(), i = 0, o = e; i < o.length; i++)for(var s = 0, u = o[i].mutations; s < u.length; s++){
            var a = u[s];
            a instanceof $6c8154472dd99012$var$_n && null === n.get(a.key) && (r = r.add(a.key));
        }
        var c = n;
        return this.vr.getEntries(t, r).next(function(t) {
            return t.forEach(function(t, e) {
                null !== e && e instanceof $6c8154472dd99012$var$kn && (c = c.ot(t, e));
            }), c;
        });
    }, t;
}(), $6c8154472dd99012$var$ri = /** @class */ function() {
    function t(t, e, n, r) {
        this.targetId = t, this.fromCache = e, this.Kr = n, this.Gr = r;
    }
    return t.zr = function(e, n) {
        for(var r = $6c8154472dd99012$var$Ot(), i = $6c8154472dd99012$var$Ot(), o = 0, s = n.docChanges; o < s.length; o++){
            var u = s[o];
            switch(u.type){
                case 0 /* Added */ :
                    r = r.add(u.doc.key);
                    break;
                case 1 /* Removed */ :
                    i = i.add(u.doc.key);
            }
        }
        return new t(e, n.fromCache, r, i);
    }, t;
}();
/**
 * Holds the state of a query target, including its target ID and whether the
 * target is 'not-current', 'current' or 'rejected'.
 */ // Visible for testing
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $6c8154472dd99012$var$ii(t, e) {
    var n = t[0], r = t[1], i = e[0], o = e[1], s = $6c8154472dd99012$var$H(n, i);
    return 0 === s ? $6c8154472dd99012$var$H(r, o) : s;
}
/**
 * Used to calculate the nth sequence number. Keeps a rolling buffer of the
 * lowest n values passed to `addElement`, and finally reports the largest of
 * them in `maxValue`.
 */ var $6c8154472dd99012$var$oi = /** @class */ function() {
    function t(t) {
        this.Hr = t, this.buffer = new $6c8154472dd99012$var$Tt($6c8154472dd99012$var$ii), this.Yr = 0;
    }
    return t.prototype.Jr = function() {
        return ++this.Yr;
    }, t.prototype.Xr = function(t) {
        var e = [
            t,
            this.Jr()
        ];
        if (this.buffer.size < this.Hr) this.buffer = this.buffer.add(e);
        else {
            var n = this.buffer.last();
            $6c8154472dd99012$var$ii(e, n) < 0 && (this.buffer = this.buffer.delete(n).add(e));
        }
    }, Object.defineProperty(t.prototype, "maxValue", {
        get: function() {
            // Guaranteed to be non-empty. If we decide we are not collecting any
            // sequence numbers, nthSequenceNumber below short-circuits. If we have
            // decided that we are collecting n sequence numbers, it's because n is some
            // percentage of the existing sequence numbers. That means we should never
            // be in a situation where we are collecting sequence numbers but don't
            // actually have any.
            return this.buffer.last()[0];
        },
        enumerable: !1,
        configurable: !0
    }), t;
}(), $6c8154472dd99012$var$si = {
    Zr: !1,
    eo: 0,
    no: 0,
    so: 0
}, $6c8154472dd99012$var$ui = /** @class */ function() {
    function t(// When we attempt to collect, we will only do so if the cache size is greater than this
    // threshold. Passing `COLLECTION_DISABLED` here will cause collection to always be skipped.
    t, // The percentage of sequence numbers that we will attempt to collect
    e, // A cap on the total number of sequence numbers that will be collected. This prevents
    // us from collecting a huge number of sequence numbers if the cache has grown very large.
    n) {
        this.io = t, this.ro = e, this.oo = n;
    }
    return t.ao = function(e) {
        return new t(e, t.co, t.uo);
    }, t;
}();
$6c8154472dd99012$var$ui.ho = -1, $6c8154472dd99012$var$ui.lo = 1048576, $6c8154472dd99012$var$ui._o = 41943040, $6c8154472dd99012$var$ui.co = 10, $6c8154472dd99012$var$ui.uo = 1e3, $6c8154472dd99012$var$ui.fo = new $6c8154472dd99012$var$ui($6c8154472dd99012$var$ui._o, $6c8154472dd99012$var$ui.co, $6c8154472dd99012$var$ui.uo), $6c8154472dd99012$var$ui.do = new $6c8154472dd99012$var$ui($6c8154472dd99012$var$ui.ho, 0, 0);
/**
 * This class is responsible for the scheduling of LRU garbage collection. It handles checking
 * whether or not GC is enabled, as well as which delay to use before the next run.
 */ var $6c8154472dd99012$var$ai = /** @class */ function() {
    function e(t, e) {
        this.wo = t, this.cs = e, this.mo = !1, this.To = null;
    }
    return e.prototype.start = function(t) {
        this.wo.params.io !== $6c8154472dd99012$var$ui.ho && this.Eo(t);
    }, e.prototype.stop = function() {
        this.To && (this.To.cancel(), this.To = null);
    }, Object.defineProperty(e.prototype, "Ei", {
        get: function() {
            return null !== this.To;
        },
        enumerable: !1,
        configurable: !0
    }), e.prototype.Eo = function(e) {
        var n = this, r = this.mo ? 3e5 : 6e4;
        $6c8154472dd99012$var$l("LruGarbageCollector", "Garbage collection scheduled in " + r + "ms"), this.To = this.cs.yn("lru_garbage_collection" /* LruGarbageCollection */ , r, function() {
            return $876a70688d8d7977$export$1050f835b63b671e(n, void 0, void 0, function() {
                var n;
                return $876a70688d8d7977$export$67ebef60e6f28a6(this, function(t) {
                    switch(t.label){
                        case 0:
                            this.To = null, this.mo = !0, t.label = 1;
                        case 1:
                            return t.trys.push([
                                1,
                                3,
                                ,
                                7
                            ]), [
                                4 /*yield*/ ,
                                e.Io(this.wo)
                            ];
                        case 2:
                            return t.sent(), [
                                3 /*break*/ ,
                                7
                            ];
                        case 3:
                            return $6c8154472dd99012$var$_r(n = t.sent()) ? ($6c8154472dd99012$var$l("LruGarbageCollector", "Ignoring IndexedDB error during garbage collection: ", n), [
                                3 /*break*/ ,
                                6
                            ]) : [
                                3 /*break*/ ,
                                4
                            ];
                        case 4:
                            return [
                                4 /*yield*/ ,
                                $6c8154472dd99012$var$Do(n)
                            ];
                        case 5:
                            t.sent(), t.label = 6;
                        case 6:
                            return [
                                3 /*break*/ ,
                                7
                            ];
                        case 7:
                            return [
                                4 /*yield*/ ,
                                this.Eo(e)
                            ];
                        case 8:
                            return t.sent(), [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        });
    }, e;
}(), $6c8154472dd99012$var$ci = /** @class */ function() {
    function t(t, e) {
        this.Ao = t, this.params = e /** Given a percentile of target to collect, returns the number of targets to collect. */ ;
    }
    return t.prototype.Ro = function(t, e) {
        return this.Ao.Po(t).next(function(t) {
            return Math.floor(e / 100 * t);
        });
    }, /** Returns the nth sequence number, counting in order from the smallest. */ t.prototype.yo = function(t, e) {
        var n = this;
        if (0 === e) return $6c8154472dd99012$var$yr.resolve($6c8154472dd99012$var$qr.ai);
        var r = new $6c8154472dd99012$var$oi(e);
        return this.Ao.Ce(t, function(t) {
            return r.Xr(t.sequenceNumber);
        }).next(function() {
            return n.Ao.Vo(t, function(t) {
                return r.Xr(t);
            });
        }).next(function() {
            return r.maxValue;
        });
    }, /**
     * Removes targets with a sequence number equal to or less than the given upper bound, and removes
     * document associations with those targets.
     */ t.prototype.po = function(t, e, n) {
        return this.Ao.po(t, e, n);
    }, /**
     * Removes documents that have a sequence number equal to or less than the upper bound and are not
     * otherwise pinned.
     */ t.prototype.bo = function(t, e) {
        return this.Ao.bo(t, e);
    }, t.prototype.vo = function(t, e) {
        var n = this;
        return this.params.io === $6c8154472dd99012$var$ui.ho ? ($6c8154472dd99012$var$l("LruGarbageCollector", "Garbage collection skipped; disabled"), $6c8154472dd99012$var$yr.resolve($6c8154472dd99012$var$si)) : this.So(t).next(function(r) {
            return r < n.params.io ? ($6c8154472dd99012$var$l("LruGarbageCollector", "Garbage collection skipped; Cache size " + r + " is lower than threshold " + n.params.io), $6c8154472dd99012$var$si) : n.Do(t, e);
        });
    }, t.prototype.So = function(t) {
        return this.Ao.So(t);
    }, t.prototype.Do = function(t, e) {
        var r, i, o, s, u, a, c, h = this, p = Date.now();
        return this.Ro(t, this.params.ro).next(function(e) {
            // Cap at the configured max
            return e > h.params.oo ? ($6c8154472dd99012$var$l("LruGarbageCollector", "Capping sequence numbers to collect down to the maximum of " + h.params.oo + " from " + e), i = h.params.oo) : i = e, s = Date.now(), h.yo(t, i);
        }).next(function(n) {
            return r = n, u = Date.now(), h.po(t, r, e);
        }).next(function(e) {
            return o = e, a = Date.now(), h.bo(t, r);
        }).next(function(t) {
            return c = Date.now(), $6c8154472dd99012$var$f() <= $d4M6f.LogLevel.DEBUG && $6c8154472dd99012$var$l("LruGarbageCollector", "LRU Garbage Collection\n	Counted targets in " + (s - p) + "ms\n	Determined least recently used " + i + " in " + (u - s) + "ms\n	Removed " + o + " targets in " + (a - u) + "ms\n	Removed " + t + " documents in " + (c - a) + "ms\nTotal Duration: " + (c - p) + "ms"), $6c8154472dd99012$var$yr.resolve({
                Zr: !0,
                eo: i,
                no: o,
                so: t
            });
        });
    }, t;
}();
/** Implements the steps for LRU garbage collection. */ /**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Encodes a resource path into a IndexedDb-compatible string form.
 */ function $6c8154472dd99012$var$hi(t) {
    for(var e = "", n = 0; n < t.length; n++)e.length > 0 && (e = $6c8154472dd99012$var$li(e)), e = $6c8154472dd99012$var$fi(t.get(n), e);
    return $6c8154472dd99012$var$li(e);
}
/** Encodes a single segment of a resource path into the given result */ function $6c8154472dd99012$var$fi(t, e) {
    for(var n = e, r = t.length, i = 0; i < r; i++){
        var o = t.charAt(i);
        switch(o){
            case "\x00":
                n += "\x01\x10";
                break;
            case "\x01":
                n += "\x01\x11";
                break;
            default:
                n += o;
        }
    }
    return n;
}
/** Encodes a path separator into the given result */ function $6c8154472dd99012$var$li(t) {
    return t + "\x01\x01";
}
/**
 * Decodes the given IndexedDb-compatible string form of a resource path into
 * a ResourcePath instance. Note that this method is not suitable for use with
 * decoding resource names from the server; those are One Platform format
 * strings.
 */ function $6c8154472dd99012$var$pi(t) {
    // Event the empty path must encode as a path of at least length 2. A path
    // with exactly 2 must be the empty path.
    var e = t.length;
    if ($6c8154472dd99012$var$g(e >= 2), 2 === e) return $6c8154472dd99012$var$g("\x01" === t.charAt(0) && "\x01" === t.charAt(1)), $6c8154472dd99012$var$E.P();
    // Escape characters cannot exist past the second-to-last position in the
    // source value.
    for(var n = e - 2, r = [], i = "", o = 0; o < e;){
        // The last two characters of a valid encoded path must be a separator, so
        // there must be an end to this segment.
        var s = t.indexOf("\x01", o);
        switch((s < 0 || s > n) && $6c8154472dd99012$var$y(), t.charAt(s + 1)){
            case "\x01":
                var u = t.substring(o, s), a = void 0;
                0 === i.length ? // Avoid copying for the common case of a segment that excludes \0
                // and \001
                a = u : (a = i += u, i = ""), r.push(a);
                break;
            case "\x10":
                i += t.substring(o, s), i += "\x00";
                break;
            case "\x11":
                // The escape character can be used in the output to encode itself.
                i += t.substring(o, s + 1);
                break;
            default:
                $6c8154472dd99012$var$y();
        }
        o = s + 2;
    }
    return new $6c8154472dd99012$var$E(r);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Serializer for values stored in the LocalStore. */ var $6c8154472dd99012$var$di = function(t) {
    this.Co = t;
};
/** Decodes a remote document from storage locally to a Document. */ function $6c8154472dd99012$var$vi(t, e) {
    if (e.document) return function(t, e, n) {
        var r = $6c8154472dd99012$var$Se(t, e.name), i = $6c8154472dd99012$var$Ee(e.updateTime), o = new $6c8154472dd99012$var$Sn({
            mapValue: {
                fields: e.fields
            }
        });
        return new $6c8154472dd99012$var$kn(r, i, o, {
            hasCommittedMutations: !!n
        });
    }(t.Co, e.document, !!e.hasCommittedMutations);
    if (e.noDocument) {
        var n = $6c8154472dd99012$var$A.$(e.noDocument.path), r = $6c8154472dd99012$var$_i(e.noDocument.readTime);
        return new $6c8154472dd99012$var$Rn(n, r, {
            hasCommittedMutations: !!e.hasCommittedMutations
        });
    }
    if (e.unknownDocument) {
        var i = $6c8154472dd99012$var$A.$(e.unknownDocument.path), o = $6c8154472dd99012$var$_i(e.unknownDocument.version);
        return new $6c8154472dd99012$var$On(i, o);
    }
    return $6c8154472dd99012$var$y();
}
/** Encodes a document for storage locally. */ function $6c8154472dd99012$var$yi(t, e, n) {
    var r = $6c8154472dd99012$var$gi(n), i = e.key.path.h().A();
    if (e instanceof $6c8154472dd99012$var$kn) {
        var o = function(t, e) {
            return {
                name: $6c8154472dd99012$var$Ae(t, e.key),
                fields: e.rn().mapValue.fields,
                updateTime: $6c8154472dd99012$var$_e(t, e.version.Z())
            };
        }(t.Co, e), s = e.hasCommittedMutations;
        return new $6c8154472dd99012$var$Ki(/* unknownDocument= */ null, /* noDocument= */ null, o, s, r, i);
    }
    if (e instanceof $6c8154472dd99012$var$Rn) {
        var u = e.key.path.A(), a = $6c8154472dd99012$var$wi(e.version), c = e.hasCommittedMutations;
        return new $6c8154472dd99012$var$Ki(/* unknownDocument= */ null, new $6c8154472dd99012$var$Bi(u, a), /* document= */ null, c, r, i);
    }
    if (e instanceof $6c8154472dd99012$var$On) {
        var h = e.key.path.A(), f = $6c8154472dd99012$var$wi(e.version);
        return new $6c8154472dd99012$var$Ki(new $6c8154472dd99012$var$Wi(h, f), /* noDocument= */ null, /* document= */ null, /* hasCommittedMutations= */ !0, r, i);
    }
    return $6c8154472dd99012$var$y();
}
function $6c8154472dd99012$var$gi(t) {
    var e = t.Z();
    return [
        e.seconds,
        e.nanoseconds
    ];
}
function $6c8154472dd99012$var$mi(t) {
    var e = new $6c8154472dd99012$var$ot(t[0], t[1]);
    return $6c8154472dd99012$var$st.J(e);
}
function $6c8154472dd99012$var$wi(t) {
    var e = t.Z();
    return new $6c8154472dd99012$var$Mi(e.seconds, e.nanoseconds);
}
function $6c8154472dd99012$var$_i(t) {
    var e = new $6c8154472dd99012$var$ot(t.seconds, t.nanoseconds);
    return $6c8154472dd99012$var$st.J(e);
}
/** Encodes a batch of mutations into a DbMutationBatch for local storage. */ /** Decodes a DbMutationBatch into a MutationBatch */ function $6c8154472dd99012$var$bi(t, e) {
    var n = (e.baseMutations || []).map(function(e) {
        return $6c8154472dd99012$var$Pe(t.Co, e);
    }), r = e.mutations.map(function(e) {
        return $6c8154472dd99012$var$Pe(t.Co, e);
    }), i = $6c8154472dd99012$var$ot.fromMillis(e.localWriteTimeMs);
    return new $6c8154472dd99012$var$Xr(e.batchId, i, n, r);
}
/** Decodes a DbTarget into TargetData */ function $6c8154472dd99012$var$Ii(t) {
    var e, n, r = $6c8154472dd99012$var$_i(t.readTime), i = void 0 !== t.lastLimboFreeSnapshotVersion ? $6c8154472dd99012$var$_i(t.lastLimboFreeSnapshotVersion) : $6c8154472dd99012$var$st.min();
    return void 0 !== t.query.documents ? ($6c8154472dd99012$var$g(1 === (n = t.query).documents.length), e = $6c8154472dd99012$var$zn($6c8154472dd99012$var$Un($6c8154472dd99012$var$xe(n.documents[0])))) : e = $6c8154472dd99012$var$Ce(t.query), new $6c8154472dd99012$var$gt(e, t.targetId, 0 /* Listen */ , t.lastListenSequenceNumber, r, i, $6c8154472dd99012$var$X.fromBase64String(t.resumeToken)) /** Encodes TargetData into a DbTarget for storage locally. */ ;
}
function $6c8154472dd99012$var$Ei(t, e) {
    var n, r = $6c8154472dd99012$var$wi(e.nt), i = $6c8154472dd99012$var$wi(e.lastLimboFreeSnapshotVersion);
    n = $6c8154472dd99012$var$dt(e.target) ? $6c8154472dd99012$var$Ve(t.Co, e.target) : $6c8154472dd99012$var$Ue(t.Co, e.target);
    // We can't store the resumeToken as a ByteString in IndexedDb, so we
    // convert it to a base64 string for storage.
    var o = e.resumeToken.toBase64();
    // lastListenSequenceNumber is always 0 until we do real GC.
    return new $6c8154472dd99012$var$Hi(e.targetId, $6c8154472dd99012$var$lt(e.target), r, o, e.sequenceNumber, i, n);
}
/**
 * A helper function for figuring out what kind of query has been stored.
 */ /**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** A mutation queue for a specific user, backed by IndexedDB. */ var $6c8154472dd99012$var$Ti = /** @class */ function() {
    function t(/**
     * The normalized userId (e.g. null UID => "" userId) used to store /
     * retrieve mutations.
     */ t, e, n, r) {
        this.userId = t, this.serializer = e, this.Dr = n, this.No = r, /**
             * Caches the document keys for pending mutation batches. If the mutation
             * has been removed from IndexedDb, the cached value may continue to
             * be used to retrieve the batch's document keys. To remove a cached value
             * locally, `removeCachedMutationKeys()` should be invoked either directly
             * or through `removeMutationBatches()`.
             *
             * With multi-tab, when the primary client acknowledges or rejects a mutation,
             * this cache is used by secondary clients to invalidate the local
             * view of the documents that were previously affected by the mutation.
             */ // PORTING NOTE: Multi-tab only.
        this.Fo = {} /**
     * Creates a new mutation queue for the given user.
     * @param user The user for which to create a mutation queue.
     * @param serializer The serializer to use when persisting to IndexedDb.
     */ ;
    }
    return t.xo = function(e, n, r, i) {
        // TODO(mcg): Figure out what constraints there are on userIDs
        // In particular, are there any reserved characters? are empty ids allowed?
        // For the moment store these together in the same mutations table assuming
        // that empty userIDs aren't allowed.
        return $6c8154472dd99012$var$g("" !== e.uid), new t(e.Zs() ? e.uid : "", n, r, i);
    }, t.prototype.$o = function(t) {
        var e = !0, n = IDBKeyRange.bound([
            this.userId,
            Number.NEGATIVE_INFINITY
        ], [
            this.userId,
            Number.POSITIVE_INFINITY
        ]);
        return $6c8154472dd99012$var$Si(t).rs({
            index: $6c8154472dd99012$var$Gi.userMutationsIndex,
            range: n
        }, function(t, n, r) {
            e = !1, r.done();
        }).next(function() {
            return e;
        });
    }, t.prototype.ko = function(t, e, n, r) {
        var i = this, o = $6c8154472dd99012$var$Di(t), s = $6c8154472dd99012$var$Si(t);
        // The IndexedDb implementation in Chrome (and Firefox) does not handle
        // compound indices that include auto-generated keys correctly. To ensure
        // that the index entry is added correctly in all browsers, we perform two
        // writes: The first write is used to retrieve the next auto-generated Batch
        // ID, and the second write populates the index and stores the actual
        // mutation batch.
        // See: https://bugs.chromium.org/p/chromium/issues/detail?id=701972
        // We write an empty object to obtain key
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return s.add({}).next(function(u) {
            $6c8154472dd99012$var$g("number" == typeof u);
            for(var a = new $6c8154472dd99012$var$Xr(u, e, n, r), c = function(t, e, n) {
                var r = n.baseMutations.map(function(e) {
                    return $6c8154472dd99012$var$Oe(t.Co, e);
                }), i = n.mutations.map(function(e) {
                    return $6c8154472dd99012$var$Oe(t.Co, e);
                });
                return new $6c8154472dd99012$var$Gi(e, n.batchId, n.ar.toMillis(), r, i);
            }(i.serializer, i.userId, a), h = [], f = new $6c8154472dd99012$var$Tt(function(t, e) {
                return $6c8154472dd99012$var$H(t.R(), e.R());
            }), l = 0, p = r; l < p.length; l++){
                var d = p[l], v = $6c8154472dd99012$var$zi.key(i.userId, d.key.path, u);
                f = f.add(d.key.path.h()), h.push(s.put(c)), h.push(o.put(v, $6c8154472dd99012$var$zi.PLACEHOLDER));
            }
            return f.forEach(function(e) {
                h.push(i.Dr.Mo(t, e));
            }), t.pr(function() {
                i.Fo[u] = a.keys();
            }), $6c8154472dd99012$var$yr.$n(h).next(function() {
                return a;
            });
        });
    }, t.prototype.Oo = function(t, e) {
        var n = this;
        return $6c8154472dd99012$var$Si(t).get(e).next(function(t) {
            return t ? ($6c8154472dd99012$var$g(t.userId === n.userId), $6c8154472dd99012$var$bi(n.serializer, t)) : null;
        });
    }, /**
     * Returns the document keys for the mutation batch with the given batchId.
     * For primary clients, this method returns `null` after
     * `removeMutationBatches()` has been called. Secondary clients return a
     * cached result until `removeCachedMutationKeys()` is invoked.
     */ // PORTING NOTE: Multi-tab only.
    t.prototype.Lo = function(t, e) {
        var n = this;
        return this.Fo[e] ? $6c8154472dd99012$var$yr.resolve(this.Fo[e]) : this.Oo(t, e).next(function(t) {
            if (t) {
                var r = t.keys();
                return n.Fo[e] = r, r;
            }
            return null;
        });
    }, t.prototype.Bo = function(t, e) {
        var n = this, r = e + 1, i = IDBKeyRange.lowerBound([
            this.userId,
            r
        ]), o = null;
        return $6c8154472dd99012$var$Si(t).rs({
            index: $6c8154472dd99012$var$Gi.userMutationsIndex,
            range: i
        }, function(t, e, i) {
            e.userId === n.userId && ($6c8154472dd99012$var$g(e.batchId >= r), o = $6c8154472dd99012$var$bi(n.serializer, e)), i.done();
        }).next(function() {
            return o;
        });
    }, t.prototype.qo = function(t) {
        var e = IDBKeyRange.upperBound([
            this.userId,
            Number.POSITIVE_INFINITY
        ]), n = -1;
        return $6c8154472dd99012$var$Si(t).rs({
            index: $6c8154472dd99012$var$Gi.userMutationsIndex,
            range: e,
            reverse: !0
        }, function(t, e, r) {
            n = e.batchId, r.done();
        }).next(function() {
            return n;
        });
    }, t.prototype.Uo = function(t) {
        var e = this, n = IDBKeyRange.bound([
            this.userId,
            -1
        ], [
            this.userId,
            Number.POSITIVE_INFINITY
        ]);
        return $6c8154472dd99012$var$Si(t).ts($6c8154472dd99012$var$Gi.userMutationsIndex, n).next(function(t) {
            return t.map(function(t) {
                return $6c8154472dd99012$var$bi(e.serializer, t);
            });
        });
    }, t.prototype.Nr = function(t, e) {
        var n = this, r = $6c8154472dd99012$var$zi.prefixForPath(this.userId, e.path), i = IDBKeyRange.lowerBound(r), o = [];
        // Scan the document-mutation index starting with a prefix starting with
        // the given documentKey.
        return $6c8154472dd99012$var$Di(t).rs({
            range: i
        }, function(r, i, s) {
            var u = r[0], a = r[1], c = r[2], h = $6c8154472dd99012$var$pi(a);
            // Only consider rows matching exactly the specific key of
            // interest. Note that because we order by path first, and we
            // order terminators before path separators, we'll encounter all
            // the index rows for documentKey contiguously. In particular, all
            // the rows for documentKey will occur before any rows for
            // documents nested in a subcollection beneath documentKey so we
            // can stop as soon as we hit any such row.
            if (u === n.userId && e.path.isEqual(h)) // Look up the mutation batch in the store.
            return $6c8154472dd99012$var$Si(t).get(c).next(function(t) {
                if (!t) throw $6c8154472dd99012$var$y();
                $6c8154472dd99012$var$g(t.userId === n.userId), o.push($6c8154472dd99012$var$bi(n.serializer, t));
            });
            s.done();
        }).next(function() {
            return o;
        });
    }, t.prototype.Or = function(t, e) {
        var n = this, r = new $6c8154472dd99012$var$Tt($6c8154472dd99012$var$H), i = [];
        return e.forEach(function(e) {
            var o = $6c8154472dd99012$var$zi.prefixForPath(n.userId, e.path), s = IDBKeyRange.lowerBound(o), u = $6c8154472dd99012$var$Di(t).rs({
                range: s
            }, function(t, i, o) {
                var s = t[0], u = t[1], a = t[2], c = $6c8154472dd99012$var$pi(u);
                // Only consider rows matching exactly the specific key of
                // interest. Note that because we order by path first, and we
                // order terminators before path separators, we'll encounter all
                // the index rows for documentKey contiguously. In particular, all
                // the rows for documentKey will occur before any rows for
                // documents nested in a subcollection beneath documentKey so we
                // can stop as soon as we hit any such row.
                s === n.userId && e.path.isEqual(c) ? r = r.add(a) : o.done();
            });
            i.push(u);
        }), $6c8154472dd99012$var$yr.$n(i).next(function() {
            return n.Qo(t, r);
        });
    }, t.prototype.Wr = function(t, e) {
        var n = this, r = e.path, i = r.length + 1, o = $6c8154472dd99012$var$zi.prefixForPath(this.userId, r), s = IDBKeyRange.lowerBound(o), u = new $6c8154472dd99012$var$Tt($6c8154472dd99012$var$H);
        return $6c8154472dd99012$var$Di(t).rs({
            range: s
        }, function(t, e, o) {
            var s = t[0], a = t[1], c = t[2], h = $6c8154472dd99012$var$pi(a);
            s === n.userId && r.T(h) ? // Rows with document keys more than one segment longer than the
            // query path can't be matches. For example, a query on 'rooms'
            // can't match the document /rooms/abc/messages/xyx.
            // TODO(mcg): we'll need a different scanner when we implement
            // ancestor queries.
            h.length === i && (u = u.add(c)) : o.done();
        }).next(function() {
            return n.Qo(t, u);
        });
    }, t.prototype.Qo = function(t, e) {
        var n = this, r = [], i = [];
        // TODO(rockwood): Implement this using iterate.
        return e.forEach(function(e) {
            i.push($6c8154472dd99012$var$Si(t).get(e).next(function(t) {
                if (null === t) throw $6c8154472dd99012$var$y();
                $6c8154472dd99012$var$g(t.userId === n.userId), r.push($6c8154472dd99012$var$bi(n.serializer, t));
            }));
        }), $6c8154472dd99012$var$yr.$n(i).next(function() {
            return r;
        });
    }, t.prototype.Wo = function(t, e) {
        var n = this;
        return $6c8154472dd99012$var$Ai(t.jo, this.userId, e).next(function(r) {
            return t.pr(function() {
                n.Ko(e.batchId);
            }), $6c8154472dd99012$var$yr.forEach(r, function(e) {
                return n.No.Go(t, e);
            });
        });
    }, /**
     * Clears the cached keys for a mutation batch. This method should be
     * called by secondary clients after they process mutation updates.
     *
     * Note that this method does not have to be called from primary clients as
     * the corresponding cache entries are cleared when an acknowledged or
     * rejected batch is removed from the mutation queue.
     */ // PORTING NOTE: Multi-tab only
    t.prototype.Ko = function(t) {
        delete this.Fo[t];
    }, t.prototype.zo = function(t) {
        var e = this;
        return this.$o(t).next(function(n) {
            if (!n) return $6c8154472dd99012$var$yr.resolve();
            // Verify that there are no entries in the documentMutations index if
            // the queue is empty.
            var r = IDBKeyRange.lowerBound($6c8154472dd99012$var$zi.prefixForUser(e.userId)), i = [];
            return $6c8154472dd99012$var$Di(t).rs({
                range: r
            }, function(t, n, r) {
                if (t[0] === e.userId) {
                    var o = $6c8154472dd99012$var$pi(t[1]);
                    i.push(o);
                } else r.done();
            }).next(function() {
                $6c8154472dd99012$var$g(0 === i.length);
            });
        });
    }, t.prototype.Ho = function(t, e) {
        return $6c8154472dd99012$var$Ni(t, this.userId, e);
    }, // PORTING NOTE: Multi-tab only (state is held in memory in other clients).
    /** Returns the mutation queue's metadata from IndexedDb. */ t.prototype.Yo = function(t) {
        var e = this;
        return $6c8154472dd99012$var$xi(t).get(this.userId).next(function(t) {
            return t || new $6c8154472dd99012$var$ji(e.userId, -1, /*lastStreamToken=*/ "");
        });
    }, t;
}();
/**
 * @return true if the mutation queue for the given user contains a pending
 *         mutation for the given key.
 */ function $6c8154472dd99012$var$Ni(t, e, n) {
    var r = $6c8154472dd99012$var$zi.prefixForPath(e, n.path), i = r[1], o = IDBKeyRange.lowerBound(r), s = !1;
    return $6c8154472dd99012$var$Di(t).rs({
        range: o,
        ss: !0
    }, function(t, n, r) {
        var o = t[0], u = t[1];
        t[2];
        o === e && u === i && (s = !0), r.done();
    }).next(function() {
        return s;
    });
}
/** Returns true if any mutation queue contains the given document. */ /**
 * Delete a mutation batch and the associated document mutations.
 * @return A PersistencePromise of the document mutations that were removed.
 */ function $6c8154472dd99012$var$Ai(t, e, n) {
    var r = t.store($6c8154472dd99012$var$Gi.store), i = t.store($6c8154472dd99012$var$zi.store), o = [], s = IDBKeyRange.only(n.batchId), u = 0, a = r.rs({
        range: s
    }, function(t, e, n) {
        return u++, n.delete();
    });
    o.push(a.next(function() {
        $6c8154472dd99012$var$g(1 === u);
    }));
    for(var c = [], h = 0, f = n.mutations; h < f.length; h++){
        var l = f[h], p = $6c8154472dd99012$var$zi.key(e, l.key.path, n.batchId);
        o.push(i.delete(p)), c.push(l.key);
    }
    return $6c8154472dd99012$var$yr.$n(o).next(function() {
        return c;
    });
}
/**
 * Helper to get a typed SimpleDbStore for the mutations object store.
 */ function $6c8154472dd99012$var$Si(t) {
    return $6c8154472dd99012$var$ho.Qn(t, $6c8154472dd99012$var$Gi.store);
}
/**
 * Helper to get a typed SimpleDbStore for the mutationQueues object store.
 */ function $6c8154472dd99012$var$Di(t) {
    return $6c8154472dd99012$var$ho.Qn(t, $6c8154472dd99012$var$zi.store);
}
/**
 * Helper to get a typed SimpleDbStore for the mutationQueues object store.
 */ function $6c8154472dd99012$var$xi(t) {
    return $6c8154472dd99012$var$ho.Qn(t, $6c8154472dd99012$var$ji.store);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The RemoteDocumentCache for IndexedDb. To construct, invoke
 * `newIndexedDbRemoteDocumentCache()`.
 */ var $6c8154472dd99012$var$Li = /** @class */ function() {
    /**
     * @param serializer The document serializer.
     * @param indexManager The query indexes that need to be maintained.
     */ function t(t, e) {
        this.serializer = t, this.Dr = e /**
     * Adds the supplied entries to the cache.
     *
     * All calls of `addEntry` are required to go through the RemoteDocumentChangeBuffer
     * returned by `newChangeBuffer()` to ensure proper accounting of metadata.
     */ ;
    }
    return t.prototype.Er = function(t, e, n) {
        return $6c8154472dd99012$var$Oi(t).put($6c8154472dd99012$var$Pi(e), n);
    }, /**
     * Removes a document from the cache.
     *
     * All calls of `removeEntry`  are required to go through the RemoteDocumentChangeBuffer
     * returned by `newChangeBuffer()` to ensure proper accounting of metadata.
     */ t.prototype.Ar = function(t, e) {
        var n = $6c8154472dd99012$var$Oi(t), r = $6c8154472dd99012$var$Pi(e);
        return n.delete(r);
    }, /**
     * Updates the current cache size.
     *
     * Callers to `addEntry()` and `removeEntry()` *must* call this afterwards to update the
     * cache's metadata.
     */ t.prototype.updateMetadata = function(t, e) {
        var n = this;
        return this.getMetadata(t).next(function(r) {
            return r.byteSize += e, n.Jo(t, r);
        });
    }, t.prototype.Rr = function(t, e) {
        var n = this;
        return $6c8154472dd99012$var$Oi(t).get($6c8154472dd99012$var$Pi(e)).next(function(t) {
            return n.Xo(t);
        });
    }, /**
     * Looks up an entry in the cache.
     *
     * @param documentKey The key of the entry to look up.
     * @return The cached MaybeDocument entry and its size, or null if we have nothing cached.
     */ t.prototype.Zo = function(t, e) {
        var n = this;
        return $6c8154472dd99012$var$Oi(t).get($6c8154472dd99012$var$Pi(e)).next(function(t) {
            var e = n.Xo(t);
            return e ? {
                ta: e,
                size: $6c8154472dd99012$var$Vi(t)
            } : null;
        });
    }, t.prototype.getEntries = function(t, e) {
        var n = this, r = $6c8154472dd99012$var$Dt();
        return this.ea(t, e, function(t, e) {
            var i = n.Xo(e);
            r = r.ot(t, i);
        }).next(function() {
            return r;
        });
    }, /**
     * Looks up several entries in the cache.
     *
     * @param documentKeys The set of keys entries to look up.
     * @return A map of MaybeDocuments indexed by key (if a document cannot be
     *     found, the key will be mapped to null) and a map of sizes indexed by
     *     key (zero if the key cannot be found).
     */ t.prototype.na = function(t, e) {
        var n = this, r = $6c8154472dd99012$var$Dt(), i = new $6c8154472dd99012$var$bt($6c8154472dd99012$var$A.i);
        return this.ea(t, e, function(t, e) {
            var o = n.Xo(e);
            o ? (r = r.ot(t, o), i = i.ot(t, $6c8154472dd99012$var$Vi(e))) : (r = r.ot(t, null), i = i.ot(t, 0));
        }).next(function() {
            return {
                sa: r,
                ia: i
            };
        });
    }, t.prototype.ea = function(t, e, n) {
        if (e.m()) return $6c8154472dd99012$var$yr.resolve();
        var r = IDBKeyRange.bound(e.first().path.A(), e.last().path.A()), i = e._t(), o = i.It();
        return $6c8154472dd99012$var$Oi(t).rs({
            range: r
        }, function(t, e, r) {
            // Go through keys not found in cache.
            for(var s = $6c8154472dd99012$var$A.$(t); o && $6c8154472dd99012$var$A.i(o, s) < 0;)n(o, null), o = i.It();
            o && o.isEqual(s) && // Key found in cache.
            (n(o, e), o = i.At() ? i.It() : null), // Skip to the next key (if there is one).
            o ? r.Xn(o.path.A()) : r.done();
        }).next(function() {
            // The rest of the keys are not in the cache. One case where `iterate`
            // above won't go through them is when the cache is empty.
            for(; o;)n(o, null), o = i.At() ? i.It() : null;
        });
    }, t.prototype.Lr = function(t, e, n) {
        var r = this, i = $6c8154472dd99012$var$Lt(), o = e.path.length + 1, s = {};
        if (n.isEqual($6c8154472dd99012$var$st.min())) {
            // Documents are ordered by key, so we can use a prefix scan to narrow
            // down the documents we need to match the query against.
            var u = e.path.A();
            s.range = IDBKeyRange.lowerBound(u);
        } else {
            // Execute an index-free query and filter by read time. This is safe
            // since all document changes to queries that have a
            // lastLimboFreeSnapshotVersion (`sinceReadTime`) have a read time set.
            var a = e.path.A(), c = $6c8154472dd99012$var$gi(n);
            s.range = IDBKeyRange.lowerBound([
                a,
                c
            ], /* open= */ !0), s.index = $6c8154472dd99012$var$Ki.collectionReadTimeIndex;
        }
        return $6c8154472dd99012$var$Oi(t).rs(s, function(t, n, s) {
            // The query is actually returning any path that starts with the query
            // path prefix which may include documents in subcollections. For
            // example, a query on 'rooms' will return rooms/abc/messages/xyx but we
            // shouldn't match it. Fix this by discarding rows with document keys
            // more than one segment longer than the query path.
            if (t.length === o) {
                var u = $6c8154472dd99012$var$vi(r.serializer, n);
                e.path.T(u.key.path) ? u instanceof $6c8154472dd99012$var$kn && $6c8154472dd99012$var$$n(e, u) && (i = i.ot(u.key, u)) : s.done();
            }
        }).next(function() {
            return i;
        });
    }, t.prototype.ra = function(t) {
        return new $6c8154472dd99012$var$ki(this, !!t && t.oa);
    }, t.prototype.aa = function(t) {
        return this.getMetadata(t).next(function(t) {
            return t.byteSize;
        });
    }, t.prototype.getMetadata = function(t) {
        return $6c8154472dd99012$var$Ri(t).get($6c8154472dd99012$var$Qi.key).next(function(t) {
            return $6c8154472dd99012$var$g(!!t), t;
        });
    }, t.prototype.Jo = function(t, e) {
        return $6c8154472dd99012$var$Ri(t).put($6c8154472dd99012$var$Qi.key, e);
    }, /**
     * Decodes `remoteDoc` and returns the document (or null, if the document
     * corresponds to the format used for sentinel deletes).
     */ t.prototype.Xo = function(t) {
        if (t) {
            var e = $6c8154472dd99012$var$vi(this.serializer, t);
            return e instanceof $6c8154472dd99012$var$Rn && e.version.isEqual($6c8154472dd99012$var$st.min()) ? null : e;
        }
        return null;
    }, t;
}(), $6c8154472dd99012$var$ki = /** @class */ function(e) {
    /**
     * @param documentCache The IndexedDbRemoteDocumentCache to apply the changes to.
     * @param trackRemovals Whether to create sentinel deletes that can be tracked by
     * `getNewDocumentChanges()`.
     */ function n(t, n) {
        var r = this;
        return (r = e.call(this) || this).ca = t, r.oa = n, // A map of document sizes prior to applying the changes in this buffer.
        r.ua = new $6c8154472dd99012$var$it(function(t) {
            return t.toString();
        }, function(t, e) {
            return t.isEqual(e);
        }), r;
    }
    return $876a70688d8d7977$export$a8ba968b8961cb8a(n, e), n.prototype.yr = function(t) {
        var e = this, n = [], r = 0, i = new $6c8154472dd99012$var$Tt(function(t, e) {
            return $6c8154472dd99012$var$H(t.R(), e.R());
        });
        return this.wr.forEach(function(o, s) {
            var u = e.ua.get(o);
            if (s) {
                var a = $6c8154472dd99012$var$yi(e.ca.serializer, s, e.readTime);
                i = i.add(o.path.h());
                var c = $6c8154472dd99012$var$Vi(a);
                r += c - u, n.push(e.ca.Er(t, o, a));
            } else if (r -= u, e.oa) {
                // In order to track removals, we store a "sentinel delete" in the
                // RemoteDocumentCache. This entry is represented by a NoDocument
                // with a version of 0 and ignored by `maybeDecodeDocument()` but
                // preserved in `getNewDocumentChanges()`.
                var h = $6c8154472dd99012$var$yi(e.ca.serializer, new $6c8154472dd99012$var$Rn(o, $6c8154472dd99012$var$st.min()), e.readTime);
                n.push(e.ca.Er(t, o, h));
            } else n.push(e.ca.Ar(t, o));
        }), i.forEach(function(r) {
            n.push(e.ca.Dr.Mo(t, r));
        }), n.push(this.ca.updateMetadata(t, r)), $6c8154472dd99012$var$yr.$n(n);
    }, n.prototype.gr = function(t, e) {
        var n = this;
        // Record the size of everything we load from the cache so we can compute a delta later.
        return this.ca.Zo(t, e).next(function(t) {
            return null === t ? (n.ua.set(e, 0), null) : (n.ua.set(e, t.size), t.ta);
        });
    }, n.prototype.Pr = function(t, e) {
        var n = this;
        // Record the size of everything we load from the cache so we can compute
        // a delta later.
        return this.ca.na(t, e).next(function(t) {
            var e = t.sa;
            // Note: `getAllFromCache` returns two maps instead of a single map from
            // keys to `DocumentSizeEntry`s. This is to allow returning the
            // `NullableMaybeDocumentMap` directly, without a conversion.
            return t.ia.forEach(function(t, e) {
                n.ua.set(t, e);
            }), e;
        });
    }, n;
}($6c8154472dd99012$var$Zr);
/**
 * Creates a new IndexedDbRemoteDocumentCache.
 *
 * @param serializer The document serializer.
 * @param indexManager The query indexes that need to be maintained.
 */ /**
 * Handles the details of adding and updating documents in the IndexedDbRemoteDocumentCache.
 *
 * Unlike the MemoryRemoteDocumentChangeBuffer, the IndexedDb implementation computes the size
 * delta for all submitted changes. This avoids having to re-read all documents from IndexedDb
 * when we apply the changes.
 */ function $6c8154472dd99012$var$Ri(t) {
    return $6c8154472dd99012$var$ho.Qn(t, $6c8154472dd99012$var$Qi.store);
}
/**
 * Helper to get a typed SimpleDbStore for the remoteDocuments object store.
 */ function $6c8154472dd99012$var$Oi(t) {
    return $6c8154472dd99012$var$ho.Qn(t, $6c8154472dd99012$var$Ki.store);
}
function $6c8154472dd99012$var$Pi(t) {
    return t.path.A();
}
/**
 * Retrusn an approximate size for the given document.
 */ function $6c8154472dd99012$var$Vi(t) {
    var e;
    if (t.document) e = t.document;
    else if (t.unknownDocument) e = t.unknownDocument;
    else {
        if (!t.noDocument) throw $6c8154472dd99012$var$y();
        e = t.noDocument;
    }
    return JSON.stringify(e).length;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An in-memory implementation of IndexManager.
 */ var $6c8154472dd99012$var$Ui = /** @class */ function() {
    function t() {
        this.ha = new $6c8154472dd99012$var$Ci;
    }
    return t.prototype.Mo = function(t, e) {
        return this.ha.add(e), $6c8154472dd99012$var$yr.resolve();
    }, t.prototype.Qr = function(t, e) {
        return $6c8154472dd99012$var$yr.resolve(this.ha.getEntries(e));
    }, t;
}(), $6c8154472dd99012$var$Ci = /** @class */ function() {
    function t() {
        this.index = {};
    }
    // Returns false if the entry already existed.
    return t.prototype.add = function(t) {
        var e = t._(), n = t.h(), r = this.index[e] || new $6c8154472dd99012$var$Tt($6c8154472dd99012$var$E.i), i = !r.has(n);
        return this.index[e] = r.add(n), i;
    }, t.prototype.has = function(t) {
        var e = t._(), n = t.h(), r = this.index[e];
        return r && r.has(n);
    }, t.prototype.getEntries = function(t) {
        return (this.index[t] || new $6c8154472dd99012$var$Tt($6c8154472dd99012$var$E.i)).A();
    }, t;
}(), $6c8154472dd99012$var$Fi = /** @class */ function() {
    function t(t) {
        this.serializer = t;
    }
    /**
     * Performs database creation and schema upgrades.
     *
     * Note that in production, this method is only ever used to upgrade the schema
     * to SCHEMA_VERSION. Different values of toVersion are only used for testing
     * and local feature development.
     */ return t.prototype.createOrUpgrade = function(t, e, n, r) {
        var i = this;
        $6c8154472dd99012$var$g(n < r && n >= 0 && r <= 10);
        var o = new $6c8154472dd99012$var$br("createOrUpgrade", e);
        n < 1 && r >= 1 && (function(t) {
            t.createObjectStore($6c8154472dd99012$var$qi.store);
        }(t), function(t) {
            t.createObjectStore($6c8154472dd99012$var$ji.store, {
                keyPath: $6c8154472dd99012$var$ji.keyPath
            }), t.createObjectStore($6c8154472dd99012$var$Gi.store, {
                keyPath: $6c8154472dd99012$var$Gi.keyPath,
                autoIncrement: !0
            }).createIndex($6c8154472dd99012$var$Gi.userMutationsIndex, $6c8154472dd99012$var$Gi.userMutationsKeyPath, {
                unique: !0
            }), t.createObjectStore($6c8154472dd99012$var$zi.store);
        }(t), $6c8154472dd99012$var$Ji(t), function(t) {
            t.createObjectStore($6c8154472dd99012$var$Ki.store);
        }(t));
        // Migration 2 to populate the targetGlobal object no longer needed since
        // migration 3 unconditionally clears it.
        var s = $6c8154472dd99012$var$yr.resolve();
        return n < 3 && r >= 3 && // Brand new clients don't need to drop and recreate--only clients that
        // potentially have corrupt data.
        (0 !== n && (function(t) {
            t.deleteObjectStore($6c8154472dd99012$var$Yi.store), t.deleteObjectStore($6c8154472dd99012$var$Hi.store), t.deleteObjectStore($6c8154472dd99012$var$$i.store);
        }(t), $6c8154472dd99012$var$Ji(t)), s = s.next(function() {
            /**
     * Creates the target global singleton row.
     *
     * @param {IDBTransaction} txn The version upgrade transaction for indexeddb
     */ return function(t) {
                var e = t.store($6c8154472dd99012$var$$i.store), n = new $6c8154472dd99012$var$$i(/*highestTargetId=*/ 0, /*lastListenSequenceNumber=*/ 0, $6c8154472dd99012$var$st.min().Z(), /*targetCount=*/ 0);
                return e.put($6c8154472dd99012$var$$i.key, n);
            }(o);
        })), n < 4 && r >= 4 && (0 !== n && // Schema version 3 uses auto-generated keys to generate globally unique
        // mutation batch IDs (this was previously ensured internally by the
        // client). To migrate to the new schema, we have to read all mutations
        // and write them back out. We preserve the existing batch IDs to guarantee
        // consistency with other object stores. Any further mutation batch IDs will
        // be auto-generated.
        (s = s.next(function() {
            return function(t, e) {
                return e.store($6c8154472dd99012$var$Gi.store).ts().next(function(n) {
                    t.deleteObjectStore($6c8154472dd99012$var$Gi.store), t.createObjectStore($6c8154472dd99012$var$Gi.store, {
                        keyPath: $6c8154472dd99012$var$Gi.keyPath,
                        autoIncrement: !0
                    }).createIndex($6c8154472dd99012$var$Gi.userMutationsIndex, $6c8154472dd99012$var$Gi.userMutationsKeyPath, {
                        unique: !0
                    });
                    var r = e.store($6c8154472dd99012$var$Gi.store), i = n.map(function(t) {
                        return r.put(t);
                    });
                    return $6c8154472dd99012$var$yr.$n(i);
                });
            }(t, o);
        })), s = s.next(function() {
            !function(t) {
                t.createObjectStore($6c8154472dd99012$var$Zi.store, {
                    keyPath: $6c8154472dd99012$var$Zi.keyPath
                });
            }(t);
        })), n < 5 && r >= 5 && (s = s.next(function() {
            return i.removeAcknowledgedMutations(o);
        })), n < 6 && r >= 6 && (s = s.next(function() {
            return function(t) {
                t.createObjectStore($6c8154472dd99012$var$Qi.store);
            }(t), i.addDocumentGlobal(o);
        })), n < 7 && r >= 7 && (s = s.next(function() {
            return i.ensureSequenceNumbers(o);
        })), n < 8 && r >= 8 && (s = s.next(function() {
            return i.createCollectionParentIndex(t, o);
        })), n < 9 && r >= 9 && (s = s.next(function() {
            // Multi-Tab used to manage its own changelog, but this has been moved
            // to the DbRemoteDocument object store itself. Since the previous change
            // log only contained transient data, we can drop its object store.
            !function(t) {
                t.objectStoreNames.contains("remoteDocumentChanges") && t.deleteObjectStore("remoteDocumentChanges");
            }(t), function(t) {
                var e = t.objectStore($6c8154472dd99012$var$Ki.store);
                e.createIndex($6c8154472dd99012$var$Ki.readTimeIndex, $6c8154472dd99012$var$Ki.readTimeIndexPath, {
                    unique: !1
                }), e.createIndex($6c8154472dd99012$var$Ki.collectionReadTimeIndex, $6c8154472dd99012$var$Ki.collectionReadTimeIndexPath, {
                    unique: !1
                });
            }(e);
        })), n < 10 && r >= 10 && (s = s.next(function() {
            return i.rewriteCanonicalIds(o);
        })), s;
    }, t.prototype.addDocumentGlobal = function(t) {
        var e = 0;
        return t.store($6c8154472dd99012$var$Ki.store).rs(function(t, n) {
            e += $6c8154472dd99012$var$Vi(n);
        }).next(function() {
            var n = new $6c8154472dd99012$var$Qi(e);
            return t.store($6c8154472dd99012$var$Qi.store).put($6c8154472dd99012$var$Qi.key, n);
        });
    }, t.prototype.removeAcknowledgedMutations = function(t) {
        var e = this, n = t.store($6c8154472dd99012$var$ji.store), r = t.store($6c8154472dd99012$var$Gi.store);
        return n.ts().next(function(n) {
            return $6c8154472dd99012$var$yr.forEach(n, function(n) {
                var i = IDBKeyRange.bound([
                    n.userId,
                    -1
                ], [
                    n.userId,
                    n.lastAcknowledgedBatchId
                ]);
                return r.ts($6c8154472dd99012$var$Gi.userMutationsIndex, i).next(function(r) {
                    return $6c8154472dd99012$var$yr.forEach(r, function(r) {
                        $6c8154472dd99012$var$g(r.userId === n.userId);
                        var i = $6c8154472dd99012$var$bi(e.serializer, r);
                        return $6c8154472dd99012$var$Ai(t, n.userId, i).next(function() {});
                    });
                });
            });
        });
    }, /**
     * Ensures that every document in the remote document cache has a corresponding sentinel row
     * with a sequence number. Missing rows are given the most recently used sequence number.
     */ t.prototype.ensureSequenceNumbers = function(t) {
        var e = t.store($6c8154472dd99012$var$Yi.store), n = t.store($6c8154472dd99012$var$Ki.store);
        return t.store($6c8154472dd99012$var$$i.store).get($6c8154472dd99012$var$$i.key).next(function(t) {
            var r = [];
            return n.rs(function(n, i) {
                var o = new $6c8154472dd99012$var$E(n), s = function(t) {
                    return [
                        0,
                        $6c8154472dd99012$var$hi(t)
                    ];
                }(o);
                r.push(e.get(s).next(function(n) {
                    return n ? $6c8154472dd99012$var$yr.resolve() : function(n) {
                        return e.put(new $6c8154472dd99012$var$Yi(0, $6c8154472dd99012$var$hi(n), t.highestListenSequenceNumber));
                    }(o);
                }));
            }).next(function() {
                return $6c8154472dd99012$var$yr.$n(r);
            });
        });
    }, t.prototype.createCollectionParentIndex = function(t, e) {
        // Create the index.
        t.createObjectStore($6c8154472dd99012$var$Xi.store, {
            keyPath: $6c8154472dd99012$var$Xi.keyPath
        });
        var n = e.store($6c8154472dd99012$var$Xi.store), r = new $6c8154472dd99012$var$Ci, i = function(t) {
            if (r.add(t)) {
                var e = t._(), i = t.h();
                return n.put({
                    collectionId: e,
                    parent: $6c8154472dd99012$var$hi(i)
                });
            }
        };
        // Helper to add an index entry iff we haven't already written it.
        // Index existing remote documents.
        return e.store($6c8154472dd99012$var$Ki.store).rs({
            ss: !0
        }, function(t, e) {
            var n = new $6c8154472dd99012$var$E(t);
            return i(n.h());
        }).next(function() {
            return e.store($6c8154472dd99012$var$zi.store).rs({
                ss: !0
            }, function(t, e) {
                t[0];
                var n = t[1], r = (t[2], $6c8154472dd99012$var$pi(n));
                return i(r.h());
            });
        });
    }, t.prototype.rewriteCanonicalIds = function(t) {
        var e = this, n = t.store($6c8154472dd99012$var$Hi.store);
        return n.rs(function(t, r) {
            var i = $6c8154472dd99012$var$Ii(r), o = $6c8154472dd99012$var$Ei(e.serializer, i);
            return n.put(o);
        });
    }, t;
}(), $6c8154472dd99012$var$Mi = function(t, e) {
    this.seconds = t, this.nanoseconds = e;
}, $6c8154472dd99012$var$qi = function(t, /** Whether to allow shared access from multiple tabs. */ e, n) {
    this.ownerId = t, this.allowTabSynchronization = e, this.leaseTimestampMs = n;
};
/**
 * Internal implementation of the collection-parent index exposed by MemoryIndexManager.
 * Also used for in-memory caching by IndexedDbIndexManager and initial index population
 * in indexeddb_schema.ts
 */ /**
 * Name of the IndexedDb object store.
 *
 * Note that the name 'owner' is chosen to ensure backwards compatibility with
 * older clients that only supported single locked access to the persistence
 * layer.
 */ $6c8154472dd99012$var$qi.store = "owner", /**
     * The key string used for the single object that exists in the
     * DbPrimaryClient store.
     */ $6c8154472dd99012$var$qi.key = "owner";
var $6c8154472dd99012$var$ji = function(/**
     * The normalized user ID to which this queue belongs.
     */ t, /**
     * An identifier for the highest numbered batch that has been acknowledged
     * by the server. All MutationBatches in this queue with batchIds less
     * than or equal to this value are considered to have been acknowledged by
     * the server.
     *
     * NOTE: this is deprecated and no longer used by the code.
     */ e, /**
     * A stream token that was previously sent by the server.
     *
     * See StreamingWriteRequest in datastore.proto for more details about
     * usage.
     *
     * After sending this token, earlier tokens may not be used anymore so
     * only a single stream token is retained.
     *
     * NOTE: this is deprecated and no longer used by the code.
     */ n) {
    this.userId = t, this.lastAcknowledgedBatchId = e, this.lastStreamToken = n;
};
/** Name of the IndexedDb object store.  */ $6c8154472dd99012$var$ji.store = "mutationQueues", /** Keys are automatically assigned via the userId property. */ $6c8154472dd99012$var$ji.keyPath = "userId";
/**
 * An object to be stored in the 'mutations' store in IndexedDb.
 *
 * Represents a batch of user-level mutations intended to be sent to the server
 * in a single write. Each user-level batch gets a separate DbMutationBatch
 * with a new batchId.
 */ var $6c8154472dd99012$var$Gi = function(/**
     * The normalized user ID to which this batch belongs.
     */ t, /**
     * An identifier for this batch, allocated using an auto-generated key.
     */ e, /**
     * The local write time of the batch, stored as milliseconds since the
     * epoch.
     */ n, /**
     * A list of "mutations" that represent a partial base state from when this
     * write batch was initially created. During local application of the write
     * batch, these baseMutations are applied prior to the real writes in order
     * to override certain document fields from the remote document cache. This
     * is necessary in the case of non-idempotent writes (e.g. `increment()`
     * transforms) to make sure that the local view of the modified documents
     * doesn't flicker if the remote document cache receives the result of the
     * non-idempotent write before the write is removed from the queue.
     *
     * These mutations are never sent to the backend.
     */ r, /**
     * A list of mutations to apply. All mutations will be applied atomically.
     *
     * Mutations are serialized via toMutation().
     */ i) {
    this.userId = t, this.batchId = e, this.localWriteTimeMs = n, this.baseMutations = r, this.mutations = i;
};
/** Name of the IndexedDb object store.  */ $6c8154472dd99012$var$Gi.store = "mutations", /** Keys are automatically assigned via the userId, batchId properties. */ $6c8154472dd99012$var$Gi.keyPath = "batchId", /** The index name for lookup of mutations by user. */ $6c8154472dd99012$var$Gi.userMutationsIndex = "userMutationsIndex", /** The user mutations index is keyed by [userId, batchId] pairs. */ $6c8154472dd99012$var$Gi.userMutationsKeyPath = [
    "userId",
    "batchId"
];
var $6c8154472dd99012$var$zi = /** @class */ function() {
    function t() {}
    /**
     * Creates a [userId] key for use in the DbDocumentMutations index to iterate
     * over all of a user's document mutations.
     */ return t.prefixForUser = function(t) {
        return [
            t
        ];
    }, /**
     * Creates a [userId, encodedPath] key for use in the DbDocumentMutations
     * index to iterate over all at document mutations for a given path or lower.
     */ t.prefixForPath = function(t, e) {
        return [
            t,
            $6c8154472dd99012$var$hi(e)
        ];
    }, /**
     * Creates a full index key of [userId, encodedPath, batchId] for inserting
     * and deleting into the DbDocumentMutations index.
     */ t.key = function(t, e, n) {
        return [
            t,
            $6c8154472dd99012$var$hi(e),
            n
        ];
    }, t;
}();
$6c8154472dd99012$var$zi.store = "documentMutations", /**
     * Because we store all the useful information for this store in the key,
     * there is no useful information to store as the value. The raw (unencoded)
     * path cannot be stored because IndexedDb doesn't store prototype
     * information.
     */ $6c8154472dd99012$var$zi.PLACEHOLDER = new $6c8154472dd99012$var$zi;
var $6c8154472dd99012$var$Bi = function(t, e) {
    this.path = t, this.readTime = e;
}, $6c8154472dd99012$var$Wi = function(t, e) {
    this.path = t, this.version = e;
}, $6c8154472dd99012$var$Ki = // TODO: We are currently storing full document keys almost three times
// (once as part of the primary key, once - partly - as `parentPath` and once
// inside the encoded documents). During our next migration, we should
// rewrite the primary key as parentPath + document ID which would allow us
// to drop one value.
function(/**
     * Set to an instance of DbUnknownDocument if the data for a document is
     * not known, but it is known that a document exists at the specified
     * version (e.g. it had a successful update applied to it)
     */ t, /**
     * Set to an instance of a DbNoDocument if it is known that no document
     * exists.
     */ e, /**
     * Set to an instance of a Document if there's a cached version of the
     * document.
     */ n, /**
     * Documents that were written to the remote document store based on
     * a write acknowledgment are marked with `hasCommittedMutations`. These
     * documents are potentially inconsistent with the backend's copy and use
     * the write's commit version as their document version.
     */ r, /**
     * When the document was read from the backend. Undefined for data written
     * prior to schema version 9.
     */ i, /**
     * The path of the collection this document is part of. Undefined for data
     * written prior to schema version 9.
     */ o) {
    this.unknownDocument = t, this.noDocument = e, this.document = n, this.hasCommittedMutations = r, this.readTime = i, this.parentPath = o;
};
/**
 * Represents a document that is known to exist but whose data is unknown.
 * Stored in IndexedDb as part of a DbRemoteDocument object.
 */ $6c8154472dd99012$var$Ki.store = "remoteDocuments", /**
     * An index that provides access to all entries sorted by read time (which
     * corresponds to the last modification time of each row).
     *
     * This index is used to provide a changelog for Multi-Tab.
     */ $6c8154472dd99012$var$Ki.readTimeIndex = "readTimeIndex", $6c8154472dd99012$var$Ki.readTimeIndexPath = "readTime", /**
     * An index that provides access to documents in a collection sorted by read
     * time.
     *
     * This index is used to allow the RemoteDocumentCache to fetch newly changed
     * documents in a collection.
     */ $6c8154472dd99012$var$Ki.collectionReadTimeIndex = "collectionReadTimeIndex", $6c8154472dd99012$var$Ki.collectionReadTimeIndexPath = [
    "parentPath",
    "readTime"
];
/**
 * Contains a single entry that has metadata about the remote document cache.
 */ var $6c8154472dd99012$var$Qi = /**
     * @param byteSize Approximately the total size in bytes of all the documents in the document
     * cache.
     */ function(t) {
    this.byteSize = t;
};
$6c8154472dd99012$var$Qi.store = "remoteDocumentGlobal", $6c8154472dd99012$var$Qi.key = "remoteDocumentGlobalKey";
var $6c8154472dd99012$var$Hi = function(/**
     * An auto-generated sequential numeric identifier for the query.
     *
     * Queries are stored using their canonicalId as the key, but these
     * canonicalIds can be quite long so we additionally assign a unique
     * queryId which can be used by referenced data structures (e.g.
     * indexes) to minimize the on-disk cost.
     */ t, /**
     * The canonical string representing this query. This is not unique.
     */ e, /**
     * The last readTime received from the Watch Service for this query.
     *
     * This is the same value as TargetChange.read_time in the protos.
     */ n, /**
     * An opaque, server-assigned token that allows watching a query to be
     * resumed after disconnecting without retransmitting all the data
     * that matches the query. The resume token essentially identifies a
     * point in time from which the server should resume sending results.
     *
     * This is related to the snapshotVersion in that the resumeToken
     * effectively also encodes that value, but the resumeToken is opaque
     * and sometimes encodes additional information.
     *
     * A consequence of this is that the resumeToken should be used when
     * asking the server to reason about where this client is in the watch
     * stream, but the client should use the snapshotVersion for its own
     * purposes.
     *
     * This is the same value as TargetChange.resume_token in the protos.
     */ r, /**
     * A sequence number representing the last time this query was
     * listened to, used for garbage collection purposes.
     *
     * Conventionally this would be a timestamp value, but device-local
     * clocks are unreliable and they must be able to create new listens
     * even while disconnected. Instead this should be a monotonically
     * increasing number that's incremented on each listen call.
     *
     * This is different from the queryId since the queryId is an
     * immutable identifier assigned to the Query on first use while
     * lastListenSequenceNumber is updated every time the query is
     * listened to.
     */ i, /**
     * Denotes the maximum snapshot version at which the associated query view
     * contained no limbo documents.  Undefined for data written prior to
     * schema version 9.
     */ o, /**
     * The query for this target.
     *
     * Because canonical ids are not unique we must store the actual query. We
     * use the proto to have an object we can persist without having to
     * duplicate translation logic to and from a `Query` object.
     */ s) {
    this.targetId = t, this.canonicalId = e, this.readTime = n, this.resumeToken = r, this.lastListenSequenceNumber = i, this.lastLimboFreeSnapshotVersion = o, this.query = s;
};
$6c8154472dd99012$var$Hi.store = "targets", /** Keys are automatically assigned via the targetId property. */ $6c8154472dd99012$var$Hi.keyPath = "targetId", /** The name of the queryTargets index. */ $6c8154472dd99012$var$Hi.queryTargetsIndexName = "queryTargetsIndex", /**
     * The index of all canonicalIds to the targets that they match. This is not
     * a unique mapping because canonicalId does not promise a unique name for all
     * possible queries, so we append the targetId to make the mapping unique.
     */ $6c8154472dd99012$var$Hi.queryTargetsKeyPath = [
    "canonicalId",
    "targetId"
];
/**
 * An object representing an association between a target and a document, or a
 * sentinel row marking the last sequence number at which a document was used.
 * Each document cached must have a corresponding sentinel row before lru
 * garbage collection is enabled.
 *
 * The target associations and sentinel rows are co-located so that orphaned
 * documents and their sequence numbers can be identified efficiently via a scan
 * of this store.
 */ var $6c8154472dd99012$var$Yi = function(/**
     * The targetId identifying a target or 0 for a sentinel row.
     */ t, /**
     * The path to the document, as encoded in the key.
     */ e, /**
     * If this is a sentinel row, this should be the sequence number of the last
     * time the document specified by `path` was used. Otherwise, it should be
     * `undefined`.
     */ n) {
    this.targetId = t, this.path = e, this.sequenceNumber = n;
};
/** Name of the IndexedDb object store.  */ $6c8154472dd99012$var$Yi.store = "targetDocuments", /** Keys are automatically assigned via the targetId, path properties. */ $6c8154472dd99012$var$Yi.keyPath = [
    "targetId",
    "path"
], /** The index name for the reverse index. */ $6c8154472dd99012$var$Yi.documentTargetsIndex = "documentTargetsIndex", /** We also need to create the reverse index for these properties. */ $6c8154472dd99012$var$Yi.documentTargetsKeyPath = [
    "path",
    "targetId"
];
/**
 * A record of global state tracked across all Targets, tracked separately
 * to avoid the need for extra indexes.
 *
 * This should be kept in-sync with the proto used in the iOS client.
 */ var $6c8154472dd99012$var$$i = function(/**
     * The highest numbered target id across all targets.
     *
     * See DbTarget.targetId.
     */ t, /**
     * The highest numbered lastListenSequenceNumber across all targets.
     *
     * See DbTarget.lastListenSequenceNumber.
     */ e, /**
     * A global snapshot version representing the last consistent snapshot we
     * received from the backend. This is monotonically increasing and any
     * snapshots received from the backend prior to this version (e.g. for
     * targets resumed with a resumeToken) should be suppressed (buffered)
     * until the backend has caught up to this snapshot version again. This
     * prevents our cache from ever going backwards in time.
     */ n, /**
     * The number of targets persisted.
     */ r) {
    this.highestTargetId = t, this.highestListenSequenceNumber = e, this.lastRemoteSnapshotVersion = n, this.targetCount = r;
};
/**
 * The key string used for the single object that exists in the
 * DbTargetGlobal store.
 */ $6c8154472dd99012$var$$i.key = "targetGlobalKey", $6c8154472dd99012$var$$i.store = "targetGlobal";
/**
 * An object representing an association between a Collection id (e.g. 'messages')
 * to a parent path (e.g. '/chats/123') that contains it as a (sub)collection.
 * This is used to efficiently find all collections to query when performing
 * a Collection Group query.
 */ var $6c8154472dd99012$var$Xi = function(/**
     * The collectionId (e.g. 'messages')
     */ t, /**
     * The path to the parent (either a document location or an empty path for
     * a root-level collection).
     */ e) {
    this.collectionId = t, this.parent = e;
};
/** Name of the IndexedDb object store. */ function $6c8154472dd99012$var$Ji(t) {
    t.createObjectStore($6c8154472dd99012$var$Yi.store, {
        keyPath: $6c8154472dd99012$var$Yi.keyPath
    }).createIndex($6c8154472dd99012$var$Yi.documentTargetsIndex, $6c8154472dd99012$var$Yi.documentTargetsKeyPath, {
        unique: !0
    }), // NOTE: This is unique only because the TargetId is the suffix.
    t.createObjectStore($6c8154472dd99012$var$Hi.store, {
        keyPath: $6c8154472dd99012$var$Hi.keyPath
    }).createIndex($6c8154472dd99012$var$Hi.queryTargetsIndexName, $6c8154472dd99012$var$Hi.queryTargetsKeyPath, {
        unique: !0
    }), t.createObjectStore($6c8154472dd99012$var$$i.store);
}
$6c8154472dd99012$var$Xi.store = "collectionParents", /** Keys are automatically assigned via the collectionId, parent properties. */ $6c8154472dd99012$var$Xi.keyPath = [
    "collectionId",
    "parent"
];
var $6c8154472dd99012$var$Zi = function(// Note: Previous schema versions included a field
// "lastProcessedDocumentChangeId". Don't use anymore.
/** The auto-generated client id assigned at client startup. */ t, /** The last time this state was updated. */ e, /** Whether the client's network connection is enabled. */ n, /** Whether this client is running in a foreground tab. */ r) {
    this.clientId = t, this.updateTimeMs = e, this.networkEnabled = n, this.inForeground = r;
};
/** Name of the IndexedDb object store. */ $6c8154472dd99012$var$Zi.store = "clientMetadata", /** Keys are automatically assigned via the clientId properties. */ $6c8154472dd99012$var$Zi.keyPath = "clientId";
var $6c8154472dd99012$var$to = $876a70688d8d7977$export$6388937ca91ccae8($876a70688d8d7977$export$6388937ca91ccae8($876a70688d8d7977$export$6388937ca91ccae8([
    $6c8154472dd99012$var$ji.store,
    $6c8154472dd99012$var$Gi.store,
    $6c8154472dd99012$var$zi.store,
    $6c8154472dd99012$var$Ki.store,
    $6c8154472dd99012$var$Hi.store,
    $6c8154472dd99012$var$qi.store,
    $6c8154472dd99012$var$$i.store,
    $6c8154472dd99012$var$Yi.store
], [
    $6c8154472dd99012$var$Zi.store
]), [
    $6c8154472dd99012$var$Qi.store
]), [
    $6c8154472dd99012$var$Xi.store
]), $6c8154472dd99012$var$eo = /** @class */ function() {
    function t() {
        /**
         * An in-memory copy of the index entries we've already written since the SDK
         * launched. Used to avoid re-writing the same entry repeatedly.
         *
         * This is *NOT* a complete cache of what's in persistence and so can never be used to
         * satisfy reads.
         */ this.la = new $6c8154472dd99012$var$Ci;
    }
    /**
     * Adds a new entry to the collection parent index.
     *
     * Repeated calls for the same collectionPath should be avoided within a
     * transaction as IndexedDbIndexManager only caches writes once a transaction
     * has been committed.
     */ return t.prototype.Mo = function(t, e) {
        var n = this;
        if (!this.la.has(e)) {
            var r = e._(), i = e.h();
            t.pr(function() {
                // Add the collection to the in memory cache only if the transaction was
                // successfully committed.
                n.la.add(e);
            });
            var o = {
                collectionId: r,
                parent: $6c8154472dd99012$var$hi(i)
            };
            return $6c8154472dd99012$var$no(t).put(o);
        }
        return $6c8154472dd99012$var$yr.resolve();
    }, t.prototype.Qr = function(t, e) {
        var n = [], r = IDBKeyRange.bound([
            e,
            ""
        ], [
            $6c8154472dd99012$var$$(e),
            ""
        ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0);
        return $6c8154472dd99012$var$no(t).ts(r).next(function(t) {
            for(var r = 0, i = t; r < i.length; r++){
                var o = i[r];
                // This collectionId guard shouldn't be necessary (and isn't as long
                // as we're running in a real browser), but there's a bug in
                // indexeddbshim that breaks our range in our tests running in node:
                // https://github.com/axemclion/IndexedDBShim/issues/334
                if (o.collectionId !== e) break;
                n.push($6c8154472dd99012$var$pi(o.parent));
            }
            return n;
        });
    }, t;
}();
// V2 is no longer usable (see comment at top of file)
// Visible for testing
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A persisted implementation of IndexManager.
 */ /**
 * Helper to get a typed SimpleDbStore for the collectionParents
 * document store.
 */ function $6c8154472dd99012$var$no(t) {
    return $6c8154472dd99012$var$ho.Qn(t, $6c8154472dd99012$var$Xi.store);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Offset to ensure non-overlapping target ids. */ /**
 * Generates monotonically increasing target IDs for sending targets to the
 * watch stream.
 *
 * The client constructs two generators, one for the target cache, and one for
 * for the sync engine (to generate limbo documents targets). These
 * generators produce non-overlapping IDs (by using even and odd IDs
 * respectively).
 *
 * By separating the target ID space, the query cache can generate target IDs
 * that persist across client restarts, while sync engine can independently
 * generate in-memory target IDs that are transient and can be reused after a
 * restart.
 */ var $6c8154472dd99012$var$ro = /** @class */ function() {
    function t(t) {
        this._a = t;
    }
    return t.prototype.next = function() {
        return this._a += 2, this._a;
    }, t.fa = function() {
        // The target cache generator must return '2' in its first call to `next()`
        // as there is no differentiation in the protocol layer between an unset
        // number and the number '0'. If we were to sent a target with target ID
        // '0', the backend would consider it unset and replace it with its own ID.
        return new t(0);
    }, t.da = function() {
        // Sync engine assigns target IDs for limbo document detection.
        return new t(-1);
    }, t;
}(), $6c8154472dd99012$var$io = /** @class */ function() {
    function t(t, e) {
        this.No = t, this.serializer = e;
    }
    // PORTING NOTE: We don't cache global metadata for the target cache, since
    // some of it (in particular `highestTargetId`) can be modified by secondary
    // tabs. We could perhaps be more granular (and e.g. still cache
    // `lastRemoteSnapshotVersion` in memory) but for simplicity we currently go
    // to IndexedDb whenever we need to read metadata. We can revisit if it turns
    // out to have a meaningful performance impact.
    return t.prototype.wa = function(t) {
        var e = this;
        return this.ma(t).next(function(n) {
            var r = new $6c8154472dd99012$var$ro(n.highestTargetId);
            return n.highestTargetId = r.next(), e.Ta(t, n).next(function() {
                return n.highestTargetId;
            });
        });
    }, t.prototype.Ea = function(t) {
        return this.ma(t).next(function(t) {
            return $6c8154472dd99012$var$st.J(new $6c8154472dd99012$var$ot(t.lastRemoteSnapshotVersion.seconds, t.lastRemoteSnapshotVersion.nanoseconds));
        });
    }, t.prototype.Ia = function(t) {
        return this.ma(t).next(function(t) {
            return t.highestListenSequenceNumber;
        });
    }, t.prototype.Aa = function(t, e, n) {
        var r = this;
        return this.ma(t).next(function(i) {
            return i.highestListenSequenceNumber = e, n && (i.lastRemoteSnapshotVersion = n.Z()), e > i.highestListenSequenceNumber && (i.highestListenSequenceNumber = e), r.Ta(t, i);
        });
    }, t.prototype.Ra = function(t, e) {
        var n = this;
        return this.ga(t, e).next(function() {
            return n.ma(t).next(function(r) {
                return r.targetCount += 1, n.Pa(e, r), n.Ta(t, r);
            });
        });
    }, t.prototype.ya = function(t, e) {
        return this.ga(t, e);
    }, t.prototype.Va = function(t, e) {
        var n = this;
        return this.pa(t, e.targetId).next(function() {
            return $6c8154472dd99012$var$oo(t).delete(e.targetId);
        }).next(function() {
            return n.ma(t);
        }).next(function(e) {
            return $6c8154472dd99012$var$g(e.targetCount > 0), e.targetCount -= 1, n.Ta(t, e);
        });
    }, /**
     * Drops any targets with sequence number less than or equal to the upper bound, excepting those
     * present in `activeTargetIds`. Document associations for the removed targets are also removed.
     * Returns the number of targets removed.
     */ t.prototype.po = function(t, e, n) {
        var r = this, i = 0, o = [];
        return $6c8154472dd99012$var$oo(t).rs(function(s, u) {
            var a = $6c8154472dd99012$var$Ii(u);
            a.sequenceNumber <= e && null === n.get(a.targetId) && (i++, o.push(r.Va(t, a)));
        }).next(function() {
            return $6c8154472dd99012$var$yr.$n(o);
        }).next(function() {
            return i;
        });
    }, /**
     * Call provided function with each `TargetData` that we have cached.
     */ t.prototype.Ce = function(t, e) {
        return $6c8154472dd99012$var$oo(t).rs(function(t, n) {
            var r = $6c8154472dd99012$var$Ii(n);
            e(r);
        });
    }, t.prototype.ma = function(t) {
        return $6c8154472dd99012$var$so(t).get($6c8154472dd99012$var$$i.key).next(function(t) {
            return $6c8154472dd99012$var$g(null !== t), t;
        });
    }, t.prototype.Ta = function(t, e) {
        return $6c8154472dd99012$var$so(t).put($6c8154472dd99012$var$$i.key, e);
    }, t.prototype.ga = function(t, e) {
        return $6c8154472dd99012$var$oo(t).put($6c8154472dd99012$var$Ei(this.serializer, e));
    }, /**
     * In-place updates the provided metadata to account for values in the given
     * TargetData. Saving is done separately. Returns true if there were any
     * changes to the metadata.
     */ t.prototype.Pa = function(t, e) {
        var n = !1;
        return t.targetId > e.highestTargetId && (e.highestTargetId = t.targetId, n = !0), t.sequenceNumber > e.highestListenSequenceNumber && (e.highestListenSequenceNumber = t.sequenceNumber, n = !0), n;
    }, t.prototype.ba = function(t) {
        return this.ma(t).next(function(t) {
            return t.targetCount;
        });
    }, t.prototype.va = function(t, e) {
        // Iterating by the canonicalId may yield more than one result because
        // canonicalId values are not required to be unique per target. This query
        // depends on the queryTargets index to be efficient.
        var n = $6c8154472dd99012$var$lt(e), r = IDBKeyRange.bound([
            n,
            Number.NEGATIVE_INFINITY
        ], [
            n,
            Number.POSITIVE_INFINITY
        ]), i = null;
        return $6c8154472dd99012$var$oo(t).rs({
            range: r,
            index: $6c8154472dd99012$var$Hi.queryTargetsIndexName
        }, function(t, n, r) {
            var o = $6c8154472dd99012$var$Ii(n);
            // After finding a potential match, check that the target is
            // actually equal to the requested target.
            $6c8154472dd99012$var$pt(e, o.target) && (i = o, r.done());
        }).next(function() {
            return i;
        });
    }, t.prototype.Sa = function(t, e, n) {
        var r = this, i = [], o = $6c8154472dd99012$var$uo(t);
        // PORTING NOTE: The reverse index (documentsTargets) is maintained by
        // IndexedDb.
        return e.forEach(function(e) {
            var s = $6c8154472dd99012$var$hi(e.path);
            i.push(o.put(new $6c8154472dd99012$var$Yi(n, s))), i.push(r.No.Da(t, n, e));
        }), $6c8154472dd99012$var$yr.$n(i);
    }, t.prototype.Ca = function(t, e, n) {
        var r = this, i = $6c8154472dd99012$var$uo(t);
        // PORTING NOTE: The reverse index (documentsTargets) is maintained by
        // IndexedDb.
        return $6c8154472dd99012$var$yr.forEach(e, function(e) {
            var o = $6c8154472dd99012$var$hi(e.path);
            return $6c8154472dd99012$var$yr.$n([
                i.delete([
                    n,
                    o
                ]),
                r.No.Na(t, n, e)
            ]);
        });
    }, t.prototype.pa = function(t, e) {
        var n = $6c8154472dd99012$var$uo(t), r = IDBKeyRange.bound([
            e
        ], [
            e + 1
        ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0);
        return n.delete(r);
    }, t.prototype.Fa = function(t, e) {
        var n = IDBKeyRange.bound([
            e
        ], [
            e + 1
        ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0), r = $6c8154472dd99012$var$uo(t), i = $6c8154472dd99012$var$Ot();
        return r.rs({
            range: n,
            ss: !0
        }, function(t, e, n) {
            var r = $6c8154472dd99012$var$pi(t[1]), o = new $6c8154472dd99012$var$A(r);
            i = i.add(o);
        }).next(function() {
            return i;
        });
    }, t.prototype.Ho = function(t, e) {
        var n = $6c8154472dd99012$var$hi(e.path), r = IDBKeyRange.bound([
            n
        ], [
            $6c8154472dd99012$var$$(n)
        ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0), i = 0;
        return $6c8154472dd99012$var$uo(t).rs({
            index: $6c8154472dd99012$var$Yi.documentTargetsIndex,
            ss: !0,
            range: r
        }, function(t, e, n) {
            var r = t[0];
            // Having a sentinel row for a document does not count as containing that document;
            // For the target cache, containing the document means the document is part of some
            // target.
            t[1];
            0 !== r && (i++, n.done());
        }).next(function() {
            return i > 0;
        });
    }, /**
     * Looks up a TargetData entry by target ID.
     *
     * @param targetId The target ID of the TargetData entry to look up.
     * @return The cached TargetData entry, or null if the cache has no entry for
     * the target.
     */ // PORTING NOTE: Multi-tab only.
    t.prototype.Ue = function(t, e) {
        return $6c8154472dd99012$var$oo(t).get(e).next(function(t) {
            return t ? $6c8154472dd99012$var$Ii(t) : null;
        });
    }, t;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Helper to get a typed SimpleDbStore for the queries object store.
 */ function $6c8154472dd99012$var$oo(t) {
    return $6c8154472dd99012$var$ho.Qn(t, $6c8154472dd99012$var$Hi.store);
}
/**
 * Helper to get a typed SimpleDbStore for the target globals object store.
 */ function $6c8154472dd99012$var$so(t) {
    return $6c8154472dd99012$var$ho.Qn(t, $6c8154472dd99012$var$$i.store);
}
/**
 * Helper to get a typed SimpleDbStore for the document target object store.
 */ function $6c8154472dd99012$var$uo(t) {
    return $6c8154472dd99012$var$ho.Qn(t, $6c8154472dd99012$var$Yi.store);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $6c8154472dd99012$var$ao = "Failed to obtain exclusive access to the persistence layer. To allow shared access, make sure to invoke `enablePersistence()` with `synchronizeTabs:true` in all tabs. If you are using `experimentalForceOwningTab:true`, make sure that only one tab has persistence enabled at any given time.", $6c8154472dd99012$var$co = /** @class */ function(e) {
    function n(t, n) {
        var r = this;
        return (r = e.call(this) || this).jo = t, r.xa = n, r;
    }
    return $876a70688d8d7977$export$a8ba968b8961cb8a(n, e), n;
}($6c8154472dd99012$var$ei), $6c8154472dd99012$var$ho = /** @class */ function() {
    function e(/**
     * Whether to synchronize the in-memory state of multiple tabs and share
     * access to local persistence.
     */ t, n, r, i, o, s, u, h, f, /**
     * If set to true, forcefully obtains database access. Existing tabs will
     * no longer be able to access IndexedDB.
     */ l) {
        if (this.allowTabSynchronization = t, this.persistenceKey = n, this.clientId = r, this.fn = o, this.window = s, this.document = u, this.$a = f, this.ka = l, this.Ma = null, this.Oa = !1, this.isPrimary = !1, this.networkEnabled = !0, /** Our window.unload handler, if registered. */ this.La = null, this.inForeground = !1, /** Our 'visibilitychange' listener if registered. */ this.Ba = null, /** The client metadata refresh task. */ this.qa = null, /** The last time we garbage collected the client metadata object store. */ this.Ua = Number.NEGATIVE_INFINITY, /** A listener to notify on primary state changes. */ this.Qa = function(t) {
            return Promise.resolve();
        }, !e.Ln()) throw new $6c8154472dd99012$var$c($6c8154472dd99012$var$a.UNIMPLEMENTED, "This platform is either missing IndexedDB or is known to have an incomplete implementation. Offline persistence has been disabled.");
        this.No = new $6c8154472dd99012$var$po(this, i), this.Wa = n + "main", this.serializer = new $6c8154472dd99012$var$di(h), this.ja = new $6c8154472dd99012$var$gr(this.Wa, 10, new $6c8154472dd99012$var$Fi(this.serializer)), this.Ka = new $6c8154472dd99012$var$io(this.No, this.serializer), this.Dr = new $6c8154472dd99012$var$eo, this.vr = function(t, e) {
            return new $6c8154472dd99012$var$Li(t, e);
        }(this.serializer, this.Dr), this.window && this.window.localStorage ? this.Ga = this.window.localStorage : (this.Ga = null, !1 === l && $6c8154472dd99012$var$p("IndexedDbPersistence", "LocalStorage is unavailable. As a result, persistence may not work reliably. In particular enablePersistence() could fail immediately after refreshing the page."));
    }
    return e.Qn = function(t, e) {
        if (t instanceof $6c8154472dd99012$var$co) return $6c8154472dd99012$var$gr.Qn(t.jo, e);
        throw $6c8154472dd99012$var$y();
    }, /**
     * Attempt to start IndexedDb persistence.
     *
     * @return {Promise<void>} Whether persistence was enabled.
     */ e.prototype.start = function() {
        var t = this;
        // NOTE: This is expected to fail sometimes (in the case of another tab
        // already having the persistence lock), so it's the first thing we should
        // do.
        return this.za().then(function() {
            if (!t.isPrimary && !t.allowTabSynchronization) // Fail `start()` if `synchronizeTabs` is disabled and we cannot
            // obtain the primary lease.
            throw new $6c8154472dd99012$var$c($6c8154472dd99012$var$a.FAILED_PRECONDITION, $6c8154472dd99012$var$ao);
            return t.Ha(), t.Ya(), t.Ja(), t.runTransaction("getHighestListenSequenceNumber", "readonly", function(e) {
                return t.Ka.Ia(e);
            });
        }).then(function(e) {
            t.Ma = new $6c8154472dd99012$var$qr(e, t.$a);
        }).then(function() {
            t.Oa = !0;
        }).catch(function(e) {
            return t.ja && t.ja.close(), Promise.reject(e);
        });
    }, /**
     * Registers a listener that gets called when the primary state of the
     * instance changes. Upon registering, this listener is invoked immediately
     * with the current primary state.
     *
     * PORTING NOTE: This is only used for Web multi-tab.
     */ e.prototype.Xa = function(e) {
        var n = this;
        return this.Qa = function(r) {
            return $876a70688d8d7977$export$1050f835b63b671e(n, void 0, void 0, function() {
                return $876a70688d8d7977$export$67ebef60e6f28a6(this, function(t) {
                    return this.Ei ? [
                        2 /*return*/ ,
                        e(r)
                    ] : [
                        2 /*return*/ 
                    ];
                });
            });
        }, e(this.isPrimary);
    }, /**
     * Registers a listener that gets called when the database receives a
     * version change event indicating that it has deleted.
     *
     * PORTING NOTE: This is only used for Web multi-tab.
     */ e.prototype.Za = function(e) {
        var n = this;
        this.ja.Kn(function(r) {
            return $876a70688d8d7977$export$1050f835b63b671e(n, void 0, void 0, function() {
                return $876a70688d8d7977$export$67ebef60e6f28a6(this, function(t) {
                    switch(t.label){
                        case 0:
                            return null === r.newVersion ? [
                                4 /*yield*/ ,
                                e()
                            ] : [
                                3 /*break*/ ,
                                2
                            ];
                        case 1:
                            t.sent(), t.label = 2;
                        case 2:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        });
    }, /**
     * Adjusts the current network state in the client's metadata, potentially
     * affecting the primary lease.
     *
     * PORTING NOTE: This is only used for Web multi-tab.
     */ e.prototype.tc = function(e) {
        var n = this;
        this.networkEnabled !== e && (this.networkEnabled = e, // Schedule a primary lease refresh for immediate execution. The eventual
        // lease update will be propagated via `primaryStateListener`.
        this.fn.ws(function() {
            return $876a70688d8d7977$export$1050f835b63b671e(n, void 0, void 0, function() {
                return $876a70688d8d7977$export$67ebef60e6f28a6(this, function(t) {
                    switch(t.label){
                        case 0:
                            return this.Ei ? [
                                4 /*yield*/ ,
                                this.za()
                            ] : [
                                3 /*break*/ ,
                                2
                            ];
                        case 1:
                            t.sent(), t.label = 2;
                        case 2:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        }));
    }, /**
     * Updates the client metadata in IndexedDb and attempts to either obtain or
     * extend the primary lease for the local client. Asynchronously notifies the
     * primary state listener if the client either newly obtained or released its
     * primary lease.
     */ e.prototype.za = function() {
        var t = this;
        return this.runTransaction("updateClientMetadataAndTryBecomePrimary", "readwrite", function(e) {
            return $6c8154472dd99012$var$lo(e).put(new $6c8154472dd99012$var$Zi(t.clientId, Date.now(), t.networkEnabled, t.inForeground)).next(function() {
                if (t.isPrimary) return t.ec(e).next(function(e) {
                    e || (t.isPrimary = !1, t.fn.Cs(function() {
                        return t.Qa(!1);
                    }));
                });
            }).next(function() {
                return t.nc(e);
            }).next(function(n) {
                return t.isPrimary && !n ? t.sc(e).next(function() {
                    return !1;
                }) : !!n && t.ic(e).next(function() {
                    return !0;
                });
            });
        }).catch(function(e) {
            if ($6c8154472dd99012$var$_r(e)) // Proceed with the existing state. Any subsequent access to
            // IndexedDB will verify the lease.
            return $6c8154472dd99012$var$l("IndexedDbPersistence", "Failed to extend owner lease: ", e), t.isPrimary;
            if (!t.allowTabSynchronization) throw e;
            return $6c8154472dd99012$var$l("IndexedDbPersistence", "Releasing owner lease after error during lease refresh", e), /* isPrimary= */ !1;
        }).then(function(e) {
            t.isPrimary !== e && t.fn.Cs(function() {
                return t.Qa(e);
            }), t.isPrimary = e;
        });
    }, e.prototype.ec = function(t) {
        var e = this;
        return $6c8154472dd99012$var$fo(t).get($6c8154472dd99012$var$qi.key).next(function(t) {
            return $6c8154472dd99012$var$yr.resolve(e.rc(t));
        });
    }, e.prototype.oc = function(t) {
        return $6c8154472dd99012$var$lo(t).delete(this.clientId);
    }, /**
     * If the garbage collection threshold has passed, prunes the
     * RemoteDocumentChanges and the ClientMetadata store based on the last update
     * time of all clients.
     */ e.prototype.ac = function() {
        return $876a70688d8d7977$export$1050f835b63b671e(this, void 0, void 0, function() {
            var n, r, i, o, s = this;
            return $876a70688d8d7977$export$67ebef60e6f28a6(this, function(t) {
                switch(t.label){
                    case 0:
                        return !this.isPrimary || this.cc(this.Ua, 18e5) ? [
                            3 /*break*/ ,
                            2
                        ] : (this.Ua = Date.now(), [
                            4 /*yield*/ ,
                            this.runTransaction("maybeGarbageCollectMultiClientState", "readwrite-primary", function(t) {
                                var n = e.Qn(t, $6c8154472dd99012$var$Zi.store);
                                return n.ts().next(function(t) {
                                    var e = s.uc(t, 18e5), r = t.filter(function(t) {
                                        return -1 === e.indexOf(t);
                                    });
                                    // Delete metadata for clients that are no longer considered active.
                                    return $6c8154472dd99012$var$yr.forEach(r, function(t) {
                                        return n.delete(t.clientId);
                                    }).next(function() {
                                        return r;
                                    });
                                });
                            }).catch(function() {
                                return [];
                            })
                        ]);
                    case 1:
                        // Delete potential leftover entries that may continue to mark the
                        // inactive clients as zombied in LocalStorage.
                        // Ideally we'd delete the IndexedDb and LocalStorage zombie entries for
                        // the client atomically, but we can't. So we opt to delete the IndexedDb
                        // entries first to avoid potentially reviving a zombied client.
                        if (n = t.sent(), this.Ga) for(r = 0, i = n; r < i.length; r++)o = i[r], this.Ga.removeItem(this.hc(o.clientId));
                        t.label = 2;
                    case 2:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    }, /**
     * Schedules a recurring timer to update the client metadata and to either
     * extend or acquire the primary lease if the client is eligible.
     */ e.prototype.Ja = function() {
        var t = this;
        this.qa = this.fn.yn("client_metadata_refresh" /* ClientMetadataRefresh */ , 4e3, function() {
            return t.za().then(function() {
                return t.ac();
            }).then(function() {
                return t.Ja();
            });
        });
    }, /** Checks whether `client` is the local client. */ e.prototype.rc = function(t) {
        return !!t && t.ownerId === this.clientId;
    }, /**
     * Evaluate the state of all active clients and determine whether the local
     * client is or can act as the holder of the primary lease. Returns whether
     * the client is eligible for the lease, but does not actually acquire it.
     * May return 'false' even if there is no active leaseholder and another
     * (foreground) client should become leaseholder instead.
     */ e.prototype.nc = function(t) {
        var e = this;
        return this.ka ? $6c8154472dd99012$var$yr.resolve(!0) : $6c8154472dd99012$var$fo(t).get($6c8154472dd99012$var$qi.key).next(function(n) {
            // A client is eligible for the primary lease if:
            // - its network is enabled and the client's tab is in the foreground.
            // - its network is enabled and no other client's tab is in the
            //   foreground.
            // - every clients network is disabled and the client's tab is in the
            //   foreground.
            // - every clients network is disabled and no other client's tab is in
            //   the foreground.
            // - the `forceOwningTab` setting was passed in.
            if (null !== n && e.cc(n.leaseTimestampMs, 5e3) && !e.lc(n.ownerId)) {
                if (e.rc(n) && e.networkEnabled) return !0;
                if (!e.rc(n)) {
                    if (!n.allowTabSynchronization) // Fail the `canActAsPrimary` check if the current leaseholder has
                    // not opted into multi-tab synchronization. If this happens at
                    // client startup, we reject the Promise returned by
                    // `enablePersistence()` and the user can continue to use Firestore
                    // with in-memory persistence.
                    // If this fails during a lease refresh, we will instead block the
                    // AsyncQueue from executing further operations. Note that this is
                    // acceptable since mixing & matching different `synchronizeTabs`
                    // settings is not supported.
                    // TODO(b/114226234): Remove this check when `synchronizeTabs` can
                    // no longer be turned off.
                    throw new $6c8154472dd99012$var$c($6c8154472dd99012$var$a.FAILED_PRECONDITION, $6c8154472dd99012$var$ao);
                    return !1;
                }
            }
            return !(!e.networkEnabled || !e.inForeground) || $6c8154472dd99012$var$lo(t).ts().next(function(t) {
                return void 0 === e.uc(t, 5e3).find(function(t) {
                    if (e.clientId !== t.clientId) {
                        var n = !e.networkEnabled && t.networkEnabled, r = !e.inForeground && t.inForeground, i = e.networkEnabled === t.networkEnabled;
                        if (n || r && i) return !0;
                    }
                    return !1;
                });
            });
        }).next(function(t) {
            return e.isPrimary !== t && $6c8154472dd99012$var$l("IndexedDbPersistence", "Client " + (t ? "is" : "is not") + " eligible for a primary lease."), t;
        });
    }, e.prototype.Di = function() {
        return $876a70688d8d7977$export$1050f835b63b671e(this, void 0, void 0, function() {
            var e = this;
            return $876a70688d8d7977$export$67ebef60e6f28a6(this, function(t) {
                switch(t.label){
                    case 0:
                        // Use `SimpleDb.runTransaction` directly to avoid failing if another tab
                        // has obtained the primary lease.
                        // The shutdown() operations are idempotent and can be called even when
                        // start() aborted (e.g. because it couldn't acquire the persistence lease).
                        return this.Oa = !1, this._c(), this.qa && (this.qa.cancel(), this.qa = null), this.fc(), this.dc(), [
                            4 /*yield*/ ,
                            this.ja.runTransaction("shutdown", "readwrite", [
                                $6c8154472dd99012$var$qi.store,
                                $6c8154472dd99012$var$Zi.store
                            ], function(t) {
                                var n = new $6c8154472dd99012$var$co(t, $6c8154472dd99012$var$qr.ai);
                                return e.sc(n).next(function() {
                                    return e.oc(n);
                                });
                            })
                        ];
                    case 1:
                        // The shutdown() operations are idempotent and can be called even when
                        // start() aborted (e.g. because it couldn't acquire the persistence lease).
                        // Use `SimpleDb.runTransaction` directly to avoid failing if another tab
                        // has obtained the primary lease.
                        return t.sent(), this.ja.close(), // Remove the entry marking the client as zombied from LocalStorage since
                        // we successfully deleted its metadata from IndexedDb.
                        this.wc(), [
                            2 /*return*/ 
                        ];
                }
            });
        });
    }, /**
     * Returns clients that are not zombied and have an updateTime within the
     * provided threshold.
     */ e.prototype.uc = function(t, e) {
        var n = this;
        return t.filter(function(t) {
            return n.cc(t.updateTimeMs, e) && !n.lc(t.clientId);
        });
    }, /**
     * Returns the IDs of the clients that are currently active. If multi-tab
     * is not supported, returns an array that only contains the local client's
     * ID.
     *
     * PORTING NOTE: This is only used for Web multi-tab.
     */ e.prototype.pi = function() {
        var t = this;
        return this.runTransaction("getActiveClients", "readonly", function(e) {
            return $6c8154472dd99012$var$lo(e).ts().next(function(e) {
                return t.uc(e, 18e5).map(function(t) {
                    return t.clientId;
                });
            });
        });
    }, Object.defineProperty(e.prototype, "Ei", {
        get: function() {
            return this.Oa;
        },
        enumerable: !1,
        configurable: !0
    }), e.prototype.mc = function(t) {
        return $6c8154472dd99012$var$Ti.xo(t, this.serializer, this.Dr, this.No);
    }, e.prototype.Tc = function() {
        return this.Ka;
    }, e.prototype.Ec = function() {
        return this.vr;
    }, e.prototype.Ic = function() {
        return this.Dr;
    }, e.prototype.runTransaction = function(t, e, n) {
        var r = this;
        $6c8154472dd99012$var$l("IndexedDbPersistence", "Starting transaction:", t);
        var i, o = "readonly" === e ? "readonly" : "readwrite";
        // Do all transactions as readwrite against all object stores, since we
        // are the only reader/writer.
        return this.ja.runTransaction(t, o, $6c8154472dd99012$var$to, function(o) {
            return i = new $6c8154472dd99012$var$co(o, r.Ma ? r.Ma.next() : $6c8154472dd99012$var$qr.ai), "readwrite-primary" === e ? r.ec(i).next(function(t) {
                return !!t || r.nc(i);
            }).next(function(e) {
                if (!e) throw $6c8154472dd99012$var$p("Failed to obtain primary lease for action '" + t + "'."), r.isPrimary = !1, r.fn.Cs(function() {
                    return r.Qa(!1);
                }), new $6c8154472dd99012$var$c($6c8154472dd99012$var$a.FAILED_PRECONDITION, $6c8154472dd99012$var$ti);
                return n(i);
            }).next(function(t) {
                return r.ic(i).next(function() {
                    return t;
                });
            }) : r.Ac(i).next(function() {
                return n(i);
            });
        }).then(function(t) {
            return i.br(), t;
        });
    }, /**
     * Verifies that the current tab is the primary leaseholder or alternatively
     * that the leaseholder has opted into multi-tab synchronization.
     */ // TODO(b/114226234): Remove this check when `synchronizeTabs` can no longer
    // be turned off.
    e.prototype.Ac = function(t) {
        var e = this;
        return $6c8154472dd99012$var$fo(t).get($6c8154472dd99012$var$qi.key).next(function(t) {
            if (null !== t && e.cc(t.leaseTimestampMs, 5e3) && !e.lc(t.ownerId) && !e.rc(t) && !(e.ka || e.allowTabSynchronization && t.allowTabSynchronization)) throw new $6c8154472dd99012$var$c($6c8154472dd99012$var$a.FAILED_PRECONDITION, $6c8154472dd99012$var$ao);
        });
    }, /**
     * Obtains or extends the new primary lease for the local client. This
     * method does not verify that the client is eligible for this lease.
     */ e.prototype.ic = function(t) {
        var e = new $6c8154472dd99012$var$qi(this.clientId, this.allowTabSynchronization, Date.now());
        return $6c8154472dd99012$var$fo(t).put($6c8154472dd99012$var$qi.key, e);
    }, e.Ln = function() {
        return $6c8154472dd99012$var$gr.Ln();
    }, /** Checks the primary lease and removes it if we are the current primary. */ e.prototype.sc = function(t) {
        var e = this, n = $6c8154472dd99012$var$fo(t);
        return n.get($6c8154472dd99012$var$qi.key).next(function(t) {
            return e.rc(t) ? ($6c8154472dd99012$var$l("IndexedDbPersistence", "Releasing primary lease."), n.delete($6c8154472dd99012$var$qi.key)) : $6c8154472dd99012$var$yr.resolve();
        });
    }, /** Verifies that `updateTimeMs` is within `maxAgeMs`. */ e.prototype.cc = function(t, e) {
        var n = Date.now();
        return !(t < n - e || t > n && ($6c8154472dd99012$var$p("Detected an update time that is in the future: " + t + " > " + n), 1));
    }, e.prototype.Ha = function() {
        var t = this;
        null !== this.document && "function" == typeof this.document.addEventListener && (this.Ba = function() {
            t.fn.ws(function() {
                return t.inForeground = "visible" === t.document.visibilityState, t.za();
            });
        }, this.document.addEventListener("visibilitychange", this.Ba), this.inForeground = "visible" === this.document.visibilityState);
    }, e.prototype.fc = function() {
        this.Ba && (this.document.removeEventListener("visibilitychange", this.Ba), this.Ba = null);
    }, /**
     * Attaches a window.unload handler that will synchronously write our
     * clientId to a "zombie client id" location in LocalStorage. This can be used
     * by tabs trying to acquire the primary lease to determine that the lease
     * is no longer valid even if the timestamp is recent. This is particularly
     * important for the refresh case (so the tab correctly re-acquires the
     * primary lease). LocalStorage is used for this rather than IndexedDb because
     * it is a synchronous API and so can be used reliably from  an unload
     * handler.
     */ e.prototype.Ya = function() {
        var t, e = this;
        "function" == typeof (null === (t = this.window) || void 0 === t ? void 0 : t.addEventListener) && (this.La = function() {
            // Note: In theory, this should be scheduled on the AsyncQueue since it
            // accesses internal state. We execute this code directly during shutdown
            // to make sure it gets a chance to run.
            e._c(), e.fn.ws(function() {
                return e.Di();
            });
        }, this.window.addEventListener("unload", this.La));
    }, e.prototype.dc = function() {
        this.La && (this.window.removeEventListener("unload", this.La), this.La = null);
    }, /**
     * Returns whether a client is "zombied" based on its LocalStorage entry.
     * Clients become zombied when their tab closes without running all of the
     * cleanup logic in `shutdown()`.
     */ e.prototype.lc = function(t) {
        var e;
        try {
            var n = null !== (null === (e = this.Ga) || void 0 === e ? void 0 : e.getItem(this.hc(t)));
            return $6c8154472dd99012$var$l("IndexedDbPersistence", "Client '" + t + "' " + (n ? "is" : "is not") + " zombied in LocalStorage"), n;
        } catch (t) {
            // Gracefully handle if LocalStorage isn't working.
            return $6c8154472dd99012$var$p("IndexedDbPersistence", "Failed to get zombied client id.", t), !1;
        }
    }, /**
     * Record client as zombied (a client that had its tab closed). Zombied
     * clients are ignored during primary tab selection.
     */ e.prototype._c = function() {
        if (this.Ga) try {
            this.Ga.setItem(this.hc(this.clientId), String(Date.now()));
        } catch (t) {
            // Gracefully handle if LocalStorage isn't available / working.
            $6c8154472dd99012$var$p("Failed to set zombie client id.", t);
        }
    }, /** Removes the zombied client entry if it exists. */ e.prototype.wc = function() {
        if (this.Ga) try {
            this.Ga.removeItem(this.hc(this.clientId));
        } catch (t) {
        // Ignore
        }
    }, e.prototype.hc = function(t) {
        return "firestore_zombie_" + this.persistenceKey + "_" + t;
    }, e;
}();
/**
 * Oldest acceptable age in milliseconds for client metadata before the client
 * is considered inactive and its associated data is garbage collected.
 */ /**
 * Helper to get a typed SimpleDbStore for the primary client object store.
 */ function $6c8154472dd99012$var$fo(t) {
    return $6c8154472dd99012$var$ho.Qn(t, $6c8154472dd99012$var$qi.store);
}
/**
 * Helper to get a typed SimpleDbStore for the client metadata object store.
 */ function $6c8154472dd99012$var$lo(t) {
    return $6c8154472dd99012$var$ho.Qn(t, $6c8154472dd99012$var$Zi.store);
}
/** Provides LRU functionality for IndexedDB persistence. */ var $6c8154472dd99012$var$po = /** @class */ function() {
    function t(t, e) {
        this.db = t, this.wo = new $6c8154472dd99012$var$ci(this, e);
    }
    return t.prototype.Po = function(t) {
        var e = this.Rc(t);
        return this.db.Tc().ba(t).next(function(t) {
            return e.next(function(e) {
                return t + e;
            });
        });
    }, t.prototype.Rc = function(t) {
        var e = 0;
        return this.Vo(t, function(t) {
            e++;
        }).next(function() {
            return e;
        });
    }, t.prototype.Ce = function(t, e) {
        return this.db.Tc().Ce(t, e);
    }, t.prototype.Vo = function(t, e) {
        return this.gc(t, function(t, n) {
            return e(n);
        });
    }, t.prototype.Da = function(t, e, n) {
        return $6c8154472dd99012$var$vo(t, n);
    }, t.prototype.Na = function(t, e, n) {
        return $6c8154472dd99012$var$vo(t, n);
    }, t.prototype.po = function(t, e, n) {
        return this.db.Tc().po(t, e, n);
    }, t.prototype.Go = function(t, e) {
        return $6c8154472dd99012$var$vo(t, e);
    }, /**
     * Returns true if anything would prevent this document from being garbage
     * collected, given that the document in question is not present in any
     * targets and has a sequence number less than or equal to the upper bound for
     * the collection run.
     */ t.prototype.Pc = function(t, e) {
        return function(t, e) {
            var n = !1;
            return $6c8154472dd99012$var$xi(t).os(function(r) {
                return $6c8154472dd99012$var$Ni(t, r, e).next(function(t) {
                    return t && (n = !0), $6c8154472dd99012$var$yr.resolve(!t);
                });
            }).next(function() {
                return n;
            });
        }(t, e);
    }, t.prototype.bo = function(t, e) {
        var n = this, r = this.db.Ec().ra(), i = [], o = 0;
        return this.gc(t, function(s, u) {
            if (u <= e) {
                var a = n.Pc(t, s).next(function(e) {
                    if (!e) // Our size accounting requires us to read all documents before
                    // removing them.
                    return o++, r.Rr(t, s).next(function() {
                        return r.Ar(s), $6c8154472dd99012$var$uo(t).delete([
                            0,
                            $6c8154472dd99012$var$hi(s.path)
                        ]);
                    });
                });
                i.push(a);
            }
        }).next(function() {
            return $6c8154472dd99012$var$yr.$n(i);
        }).next(function() {
            return r.apply(t);
        }).next(function() {
            return o;
        });
    }, t.prototype.removeTarget = function(t, e) {
        var n = e.st(t.xa);
        return this.db.Tc().ya(t, n);
    }, t.prototype.yc = function(t, e) {
        return $6c8154472dd99012$var$vo(t, e);
    }, /**
     * Call provided function for each document in the cache that is 'orphaned'. Orphaned
     * means not a part of any target, so the only entry in the target-document index for
     * that document will be the sentinel row (targetId 0), which will also have the sequence
     * number for the last time the document was accessed.
     */ t.prototype.gc = function(t, e) {
        var n, r = $6c8154472dd99012$var$uo(t), i = $6c8154472dd99012$var$qr.ai;
        return r.rs({
            index: $6c8154472dd99012$var$Yi.documentTargetsIndex
        }, function(t, r) {
            var o = t[0], s = (t[1], r.path), u = r.sequenceNumber;
            0 === o ? // if nextToReport is valid, report it, this is a new key so the
            // last one must not be a member of any targets.
            (i !== $6c8154472dd99012$var$qr.ai && e(new $6c8154472dd99012$var$A($6c8154472dd99012$var$pi(n)), i), // set nextToReport to be this sequence number. It's the next one we
            // might report, if we don't find any targets for this document.
            // Note that the sequence number must be defined when the targetId
            // is 0.
            i = u, n = s) : // set nextToReport to be invalid, we know we don't need to report
            // this one since we found a target for it.
            i = $6c8154472dd99012$var$qr.ai;
        }).next(function() {
            // Since we report sequence numbers after getting to the next key, we
            // need to check if the last key we iterated over was an orphaned
            // document and report it.
            i !== $6c8154472dd99012$var$qr.ai && e(new $6c8154472dd99012$var$A($6c8154472dd99012$var$pi(n)), i);
        });
    }, t.prototype.So = function(t) {
        return this.db.Ec().aa(t);
    }, t;
}();
function $6c8154472dd99012$var$vo(t, e) {
    return $6c8154472dd99012$var$uo(t).put(/**
 * @return A value suitable for writing a sentinel row in the target-document
 * store.
 */ function(t, e) {
        return new $6c8154472dd99012$var$Yi(0, $6c8154472dd99012$var$hi(t.path), e);
    }(e, t.xa));
}
/**
 * Generates a string used as a prefix when storing data in IndexedDB and
 * LocalStorage.
 */ function $6c8154472dd99012$var$yo(t, e) {
    // Use two different prefix formats:
    //   * firestore / persistenceKey / projectID . databaseID / ...
    //   * firestore / persistenceKey / projectID / ...
    // projectIDs are DNS-compatible names and cannot contain dots
    // so there's no danger of collisions.
    var n = t.projectId;
    return t.j || (n += "." + t.database), "firestore/" + e + "/" + n + "/" /**
 * Implements `LocalStore` interface.
 *
 * Note: some field defined in this class might have public access level, but
 * the class is not exported so they are only accessible from this module.
 * This is useful to implement optional features (like bundles) in free
 * functions, such that they are tree-shakeable.
 */ ;
}
var $6c8154472dd99012$var$go = /** @class */ function() {
    function t(/** Manages our in-memory or durable persistence. */ t, e, n) {
        this.persistence = t, this.Vc = e, /**
             * Maps a targetID to data about its target.
             *
             * PORTING NOTE: We are using an immutable data structure on Web to make re-runs
             * of `applyRemoteEvent()` idempotent.
             */ this.bc = new $6c8154472dd99012$var$bt($6c8154472dd99012$var$H), /** Maps a target to its targetID. */ // TODO(wuandy): Evaluate if TargetId can be part of Target.
        this.vc = new $6c8154472dd99012$var$it(function(t) {
            return $6c8154472dd99012$var$lt(t);
        }, $6c8154472dd99012$var$pt), /**
             * The read time of the last entry processed by `getNewDocumentChanges()`.
             *
             * PORTING NOTE: This is only used for multi-tab synchronization.
             */ this.Sc = $6c8154472dd99012$var$st.min(), this.Sr = t.mc(n), this.Dc = t.Ec(), this.Ka = t.Tc(), this.Cc = new $6c8154472dd99012$var$ni(this.Dc, this.Sr, this.persistence.Ic()), this.Vc.Nc(this.Cc);
    }
    return t.prototype.Io = function(t) {
        var e = this;
        return this.persistence.runTransaction("Collect garbage", "readwrite-primary", function(n) {
            return t.vo(n, e.bc);
        });
    }, t;
}();
/**
 * Acknowledges the given batch.
 *
 * On the happy path when a batch is acknowledged, the local store will
 *
 *  + remove the batch from the mutation queue;
 *  + apply the changes to the remote document cache;
 *  + recalculate the latency compensated view implied by those changes (there
 *    may be mutations in the queue that affect the documents but haven't been
 *    acknowledged yet); and
 *  + give the changed documents back the sync engine
 *
 * @returns The resulting (modified) documents.
 */ function $6c8154472dd99012$var$mo(t, e) {
    var n = $6c8154472dd99012$var$m(t);
    return n.persistence.runTransaction("Acknowledge batch", "readwrite-primary", function(t) {
        var r = e.batch.keys(), i = n.Dc.ra({
            oa: !0
        });
        return (function(t, e, n, r) {
            var i = n.batch, o = i.keys(), s = $6c8154472dd99012$var$yr.resolve();
            return o.forEach(function(t) {
                s = s.next(function() {
                    return r.Rr(e, t);
                }).next(function(e) {
                    var o = e, s = n.dr.get(t);
                    $6c8154472dd99012$var$g(null !== s), (!o || o.version.L(s) < 0) && (o = i.cr(t, o, n)) && // We use the commitVersion as the readTime rather than the
                    // document's updateTime since the updateTime is not advanced
                    // for updates that do not modify the underlying document.
                    r.Er(o, n._r);
                });
            }), s.next(function() {
                return t.Sr.Wo(e, i);
            });
        })(n, t, e, i).next(function() {
            return i.apply(t);
        }).next(function() {
            return n.Sr.zo(t);
        }).next(function() {
            return n.Cc.kr(t, r);
        });
    });
}
/**
 * Removes mutations from the MutationQueue for the specified batch;
 * LocalDocuments will be recalculated.
 *
 * @returns The resulting modified documents.
 */ /**
 * Returns the last consistent snapshot processed (used by the RemoteStore to
 * determine whether to buffer incoming snapshots from the backend).
 */ function $6c8154472dd99012$var$wo(t) {
    var e = $6c8154472dd99012$var$m(t);
    return e.persistence.runTransaction("Get last remote snapshot version", "readonly", function(t) {
        return e.Ka.Ea(t);
    });
}
/**
 * Updates the "ground-state" (remote) documents. We assume that the remote
 * event reflects any write batches that have been acknowledged or rejected
 * (i.e. we do not re-apply local mutations to updates from this event).
 *
 * LocalDocuments are re-calculated if there are remaining mutations in the
 * queue.
 */ function $6c8154472dd99012$var$_o(t, e) {
    var n = $6c8154472dd99012$var$m(t), r = e.nt, i = n.bc;
    return n.persistence.runTransaction("Apply remote event", "readwrite-primary", function(t) {
        var o = n.Dc.ra({
            oa: !0
        });
        // Reset newTargetDataByTargetMap in case this transaction gets re-run.
        i = n.bc;
        var s = [];
        e.zt.forEach(function(e, o) {
            var u = i.get(o);
            if (u) {
                // Only update the remote keys if the target is still active. This
                // ensures that we can persist the updated target data along with
                // the updated assignment.
                s.push(n.Ka.Ca(t, e.se, o).next(function() {
                    return n.Ka.Sa(t, e.ee, o);
                }));
                var a = e.resumeToken;
                // Update the resume token if the change includes one.
                if (a.O() > 0) {
                    var c = u.it(a, r).st(t.xa);
                    i = i.ot(o, c), // Update the target data if there are target changes (or if
                    // sufficient time has passed since the last update).
                    /**
     * Returns true if the newTargetData should be persisted during an update of
     * an active target. TargetData should always be persisted when a target is
     * being released and should not call this function.
     *
     * While the target is active, TargetData updates can be omitted when nothing
     * about the target has changed except metadata like the resume token or
     * snapshot version. Occasionally it's worth the extra write to prevent these
     * values from getting too stale after a crash, but this doesn't have to be
     * too frequent.
     */ function(t, e, n) {
                        // Always persist target data if we don't already have a resume token.
                        return $6c8154472dd99012$var$g(e.resumeToken.O() > 0), 0 === t.resumeToken.O() || // Don't allow resume token changes to be buffered indefinitely. This
                        // allows us to be reasonably up-to-date after a crash and avoids needing
                        // to loop over all active queries on shutdown. Especially in the browser
                        // we may not get time to do anything interesting while the current tab is
                        // closing.
                        e.nt.X() - t.nt.X() >= 3e8 || n.ee.size + n.ne.size + n.se.size > 0;
                    }(u, c, e) && s.push(n.Ka.ya(t, c));
                }
            }
        });
        var u = $6c8154472dd99012$var$St(), a = $6c8154472dd99012$var$Ot();
        // HACK: The only reason we allow a null snapshot version is so that we
        // can synthesize remote events when we get permission denied errors while
        // trying to resolve the state of a locally cached document that is in
        // limbo.
        if (e.Yt.forEach(function(t, e) {
            a = a.add(t);
        }), // Each loop iteration only affects its "own" doc, so it's safe to get all the remote
        // documents in advance in a single call.
        s.push(o.getEntries(t, a).next(function(i) {
            e.Yt.forEach(function(a, c) {
                var h = i.get(a);
                // Note: The order of the steps below is important, since we want
                // to ensure that rejected limbo resolutions (which fabricate
                // NoDocuments with SnapshotVersion.min()) never add documents to
                // cache.
                c instanceof $6c8154472dd99012$var$Rn && c.version.isEqual($6c8154472dd99012$var$st.min()) ? // NoDocuments with SnapshotVersion.min() are used in manufactured
                // events. We remove these documents from cache since we lost
                // access.
                (o.Ar(a, r), u = u.ot(a, c)) : null == h || c.version.L(h.version) > 0 || 0 === c.version.L(h.version) && h.hasPendingWrites ? (o.Er(c, r), u = u.ot(a, c)) : $6c8154472dd99012$var$l("LocalStore", "Ignoring outdated watch update for ", a, ". Current version:", h.version, " Watch version:", c.version), e.Jt.has(a) && s.push(n.persistence.No.yc(t, a));
            });
        })), !r.isEqual($6c8154472dd99012$var$st.min())) {
            var c = n.Ka.Ea(t).next(function(e) {
                return n.Ka.Aa(t, t.xa, r);
            });
            s.push(c);
        }
        return $6c8154472dd99012$var$yr.$n(s).next(function() {
            return o.apply(t);
        }).next(function() {
            return n.Cc.Mr(t, u);
        });
    }).then(function(t) {
        return n.bc = i, t;
    });
}
/**
 * Gets the mutation batch after the passed in batchId in the mutation queue
 * or null if empty.
 * @param afterBatchId If provided, the batch to search after.
 * @returns The next mutation or null if there wasn't one.
 */ function $6c8154472dd99012$var$bo(t, e) {
    var n = $6c8154472dd99012$var$m(t);
    return n.persistence.runTransaction("Get next mutation batch", "readonly", function(t) {
        return void 0 === e && (e = -1), n.Sr.Bo(t, e);
    });
}
/**
 * Reads the current value of a Document with a given key or null if not
 * found - used for testing.
 */ /**
 * Assigns the given target an internal ID so that its results can be pinned so
 * they don't get GC'd. A target must be allocated in the local store before
 * the store can be used to manage its view.
 *
 * Allocating an already allocated `Target` will return the existing `TargetData`
 * for that `Target`.
 */ function $6c8154472dd99012$var$Io(t, e) {
    var n = $6c8154472dd99012$var$m(t);
    return n.persistence.runTransaction("Allocate target", "readwrite", function(t) {
        var r;
        return n.Ka.va(t, e).next(function(i) {
            return i ? // This target has been listened to previously, so reuse the
            // previous targetID.
            // TODO(mcg): freshen last accessed date?
            (r = i, $6c8154472dd99012$var$yr.resolve(r)) : n.Ka.wa(t).next(function(i) {
                return r = new $6c8154472dd99012$var$gt(e, i, 0 /* Listen */ , t.xa), n.Ka.Ra(t, r).next(function() {
                    return r;
                });
            });
        });
    }).then(function(t) {
        // If Multi-Tab is enabled, the existing target data may be newer than
        // the in-memory data
        var r = n.bc.get(t.targetId);
        return (null === r || t.nt.L(r.nt) > 0) && (n.bc = n.bc.ot(t.targetId, t), n.vc.set(e, t.targetId)), t;
    });
}
/**
 * Returns the TargetData as seen by the LocalStore, including updates that may
 * have not yet been persisted to the TargetCache.
 */ // Visible for testing.
/**
 * Unpins all the documents associated with the given target. If
 * `keepPersistedTargetData` is set to false and Eager GC enabled, the method
 * directly removes the associated target data from the target cache.
 *
 * Releasing a non-existing `Target` is a no-op.
 */ // PORTING NOTE: `keepPersistedTargetData` is multi-tab only.
function $6c8154472dd99012$var$Eo(e, n, r) {
    return $876a70688d8d7977$export$1050f835b63b671e(this, void 0, void 0, function() {
        var i, o, s, u;
        return $876a70688d8d7977$export$67ebef60e6f28a6(this, function(t) {
            switch(t.label){
                case 0:
                    i = $6c8154472dd99012$var$m(e), o = i.bc.get(n), s = r ? "readwrite" : "readwrite-primary", t.label = 1;
                case 1:
                    return t.trys.push([
                        1,
                        4,
                        ,
                        5
                    ]), r ? [
                        3 /*break*/ ,
                        3
                    ] : [
                        4 /*yield*/ ,
                        i.persistence.runTransaction("Release target", s, function(t) {
                            return i.persistence.No.removeTarget(t, o);
                        })
                    ];
                case 2:
                    t.sent(), t.label = 3;
                case 3:
                    return [
                        3 /*break*/ ,
                        5
                    ];
                case 4:
                    if (!$6c8154472dd99012$var$_r(u = t.sent())) throw u;
                    // All `releaseTarget` does is record the final metadata state for the
                    // target, but we've been recording this periodically during target
                    // activity. If we lose this write this could cause a very slight
                    // difference in the order of target deletion during GC, but we
                    // don't define exact LRU semantics so this is acceptable.
                    return $6c8154472dd99012$var$l("LocalStore", "Failed to update sequence numbers for target " + n + ": " + u), [
                        3 /*break*/ ,
                        5
                    ];
                case 5:
                    return i.bc = i.bc.remove(n), i.vc.delete(o.target), [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
/**
 * Runs the specified query against the local store and returns the results,
 * potentially taking advantage of query data from previous executions (such
 * as the set of remote keys).
 *
 * @param usePreviousResults Whether results from previous executions can
 * be used to optimize this query execution.
 */ function $6c8154472dd99012$var$To(t, e, n) {
    var r = $6c8154472dd99012$var$m(t), i = $6c8154472dd99012$var$st.min(), o = $6c8154472dd99012$var$Ot();
    return r.persistence.runTransaction("Execute query", "readonly", function(t) {
        return (function(t, e, n) {
            var r = $6c8154472dd99012$var$m(t), i = r.vc.get(n);
            return void 0 !== i ? $6c8154472dd99012$var$yr.resolve(r.bc.get(i)) : r.Ka.va(e, n);
        })(r, t, $6c8154472dd99012$var$zn(e)).next(function(e) {
            if (e) return i = e.lastLimboFreeSnapshotVersion, r.Ka.Fa(t, e.targetId).next(function(t) {
                o = t;
            });
        }).next(function() {
            return r.Vc.Lr(t, e, n ? i : $6c8154472dd99012$var$st.min(), n ? o : $6c8154472dd99012$var$Ot());
        }).next(function(t) {
            return {
                documents: t,
                Fc: o
            };
        });
    });
}
// PORTING NOTE: Multi-Tab only.
function $6c8154472dd99012$var$No(t, e) {
    var n = $6c8154472dd99012$var$m(t), r = $6c8154472dd99012$var$m(n.Ka), i = n.bc.get(e);
    return i ? Promise.resolve(i.target) : n.persistence.runTransaction("Get target data", "readonly", function(t) {
        return r.Ue(t, e).next(function(t) {
            return t ? t.target : null;
        });
    });
}
/**
 * Returns the set of documents that have been updated since the last call.
 * If this is the first call, returns the set of changes since client
 * initialization. Further invocations will return document that have changed
 * since the prior call.
 */ // PORTING NOTE: Multi-Tab only.
function $6c8154472dd99012$var$Ao(t) {
    var e = $6c8154472dd99012$var$m(t);
    return e.persistence.runTransaction("Get new document changes", "readonly", function(t) {
        return function(t, e, n) {
            var r = $6c8154472dd99012$var$m(t), i = $6c8154472dd99012$var$St(), o = $6c8154472dd99012$var$gi(n), s = $6c8154472dd99012$var$Oi(e), u = IDBKeyRange.lowerBound(o, !0);
            return s.rs({
                index: $6c8154472dd99012$var$Ki.readTimeIndex,
                range: u
            }, function(t, e) {
                // Unlike `getEntry()` and others, `getNewDocumentChanges()` parses
                // the documents directly since we want to keep sentinel deletes.
                var n = $6c8154472dd99012$var$vi(r.serializer, e);
                i = i.ot(n.key, n), o = e.readTime;
            }).next(function() {
                return {
                    xc: i,
                    readTime: $6c8154472dd99012$var$mi(o)
                };
            });
        }(e.Dc, t, e.Sc);
    }).then(function(t) {
        var n = t.xc, r = t.readTime;
        return e.Sc = r, n;
    });
}
/**
 * Reads the newest document change from persistence and moves the internal
 * synchronization marker forward so that calls to `getNewDocumentChanges()`
 * only return changes that happened after client initialization.
 */ // PORTING NOTE: Multi-Tab only.
function $6c8154472dd99012$var$So(e) {
    return $876a70688d8d7977$export$1050f835b63b671e(this, void 0, void 0, function() {
        var n;
        return $876a70688d8d7977$export$67ebef60e6f28a6(this, function(t) {
            return [
                2 /*return*/ ,
                (n = $6c8154472dd99012$var$m(e)).persistence.runTransaction("Synchronize last document change read time", "readonly", function(t) {
                    return function(t) {
                        var e = $6c8154472dd99012$var$Oi(t), n = $6c8154472dd99012$var$st.min();
                        // If there are no existing entries, we return SnapshotVersion.min().
                        return e.rs({
                            index: $6c8154472dd99012$var$Ki.readTimeIndex,
                            reverse: !0
                        }, function(t, e, r) {
                            e.readTime && (n = $6c8154472dd99012$var$mi(e.readTime)), r.done();
                        }).next(function() {
                            return n;
                        });
                    }(t);
                }).then(function(t) {
                    n.Sc = t;
                })
            ];
        });
    });
}
/**
 * Verifies the error thrown by a LocalStore operation. If a LocalStore
 * operation fails because the primary lease has been taken by another client,
 * we ignore the error (the persistence layer will immediately call
 * `applyPrimaryLease` to propagate the primary state change). All other errors
 * are re-thrown.
 *
 * @param err An error returned by a LocalStore operation.
 * @return A Promise that resolves after we recovered, or the original error.
 */ function $6c8154472dd99012$var$Do(e) {
    return $876a70688d8d7977$export$1050f835b63b671e(this, void 0, void 0, function() {
        return $876a70688d8d7977$export$67ebef60e6f28a6(this, function(t) {
            if (e.code !== $6c8154472dd99012$var$a.FAILED_PRECONDITION || e.message !== $6c8154472dd99012$var$ti) throw e;
            return $6c8154472dd99012$var$l("LocalStore", "Unexpectedly lost primary lease"), [
                2 /*return*/ 
            ];
        });
    });
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A collection of references to a document from some kind of numbered entity
 * (either a target ID or batch ID). As references are added to or removed from
 * the set corresponding events are emitted to a registered garbage collector.
 *
 * Each reference is represented by a DocumentReference object. Each of them
 * contains enough information to uniquely identify the reference. They are all
 * stored primarily in a set sorted by key. A document is considered garbage if
 * there's no references in that set (this can be efficiently checked thanks to
 * sorting by key).
 *
 * ReferenceSet also keeps a secondary set that contains references sorted by
 * IDs. This one is used to efficiently implement removal of all references by
 * some target ID.
 */ var $6c8154472dd99012$var$xo = /** @class */ function() {
    function t() {
        // A set of outstanding references to a document sorted by key.
        this.$c = new $6c8154472dd99012$var$Tt($6c8154472dd99012$var$Lo.kc), // A set of outstanding references to a document sorted by target id.
        this.Mc = new $6c8154472dd99012$var$Tt($6c8154472dd99012$var$Lo.Oc) /** Returns true if the reference set contains no references. */ ;
    }
    return t.prototype.m = function() {
        return this.$c.m();
    }, /** Adds a reference to the given document key for the given ID. */ t.prototype.Da = function(t, e) {
        var n = new $6c8154472dd99012$var$Lo(t, e);
        this.$c = this.$c.add(n), this.Mc = this.Mc.add(n);
    }, /** Add references to the given document keys for the given ID. */ t.prototype.Lc = function(t, e) {
        var n = this;
        t.forEach(function(t) {
            return n.Da(t, e);
        });
    }, /**
     * Removes a reference to the given document key for the given
     * ID.
     */ t.prototype.Na = function(t, e) {
        this.Bc(new $6c8154472dd99012$var$Lo(t, e));
    }, t.prototype.qc = function(t, e) {
        var n = this;
        t.forEach(function(t) {
            return n.Na(t, e);
        });
    }, /**
     * Clears all references with a given ID. Calls removeRef() for each key
     * removed.
     */ t.prototype.Uc = function(t) {
        var e = this, n = new $6c8154472dd99012$var$A(new $6c8154472dd99012$var$E([])), r = new $6c8154472dd99012$var$Lo(n, t), i = new $6c8154472dd99012$var$Lo(n, t + 1), o = [];
        return this.Mc.Ft([
            r,
            i
        ], function(t) {
            e.Bc(t), o.push(t.key);
        }), o;
    }, t.prototype.Qc = function() {
        var t = this;
        this.$c.forEach(function(e) {
            return t.Bc(e);
        });
    }, t.prototype.Bc = function(t) {
        this.$c = this.$c.delete(t), this.Mc = this.Mc.delete(t);
    }, t.prototype.Wc = function(t) {
        var e = new $6c8154472dd99012$var$A(new $6c8154472dd99012$var$E([])), n = new $6c8154472dd99012$var$Lo(e, t), r = new $6c8154472dd99012$var$Lo(e, t + 1), i = $6c8154472dd99012$var$Ot();
        return this.Mc.Ft([
            n,
            r
        ], function(t) {
            i = i.add(t.key);
        }), i;
    }, t.prototype.Ho = function(t) {
        var e = new $6c8154472dd99012$var$Lo(t, 0), n = this.$c.$t(e);
        return null !== n && t.isEqual(n.key);
    }, t;
}(), $6c8154472dd99012$var$Lo = /** @class */ function() {
    function t(t, e) {
        this.key = t, this.jc = e /** Compare by key then by ID */ ;
    }
    return t.kc = function(t, e) {
        return $6c8154472dd99012$var$A.i(t.key, e.key) || $6c8154472dd99012$var$H(t.jc, e.jc);
    }, /** Compare by ID then by key */ t.Oc = function(t, e) {
        return $6c8154472dd99012$var$H(t.jc, e.jc) || $6c8154472dd99012$var$A.i(t.key, e.key);
    }, t;
}(), $6c8154472dd99012$var$ko = function(t, e) {
    this.user = e, this.type = "OAuth", this.Kc = {}, // Set the headers using Object Literal notation to avoid minification
    this.Kc.Authorization = "Bearer " + t;
}, $6c8154472dd99012$var$Ro = /** @class */ function() {
    function t() {
        /**
         * Stores the listener registered with setChangeListener()
         * This isn't actually necessary since the UID never changes, but we use this
         * to verify the listen contract is adhered to in tests.
         */ this.Gc = null;
    }
    return t.prototype.getToken = function() {
        return Promise.resolve(null);
    }, t.prototype.zc = function() {}, t.prototype.Hc = function(t) {
        this.Gc = t, // Fire with initial user.
        t($6c8154472dd99012$var$Mr.UNAUTHENTICATED);
    }, t.prototype.Yc = function() {
        this.Gc = null;
    }, t;
}(), $6c8154472dd99012$var$Oo = /** @class */ function() {
    function t(t) {
        var e = this;
        /**
         * The auth token listener registered with FirebaseApp, retained here so we
         * can unregister it.
         */ this.Jc = null, /** Tracks the current User. */ this.currentUser = $6c8154472dd99012$var$Mr.UNAUTHENTICATED, this.Xc = !1, /**
             * Counter used to detect if the token changed while a getToken request was
             * outstanding.
             */ this.Zc = 0, /** The listener registered with setChangeListener(). */ this.Gc = null, this.forceRefresh = !1, this.Jc = function() {
            e.Zc++, e.currentUser = e.tu(), e.Xc = !0, e.Gc && e.Gc(e.currentUser);
        }, this.Zc = 0, this.auth = t.getImmediate({
            optional: !0
        }), this.auth ? this.auth.addAuthTokenListener(this.Jc) : // if auth is not available, invoke tokenListener once with null token
        (this.Jc(null), t.get().then(function(t) {
            e.auth = t, e.Jc && // tokenListener can be removed by removeChangeListener()
            e.auth.addAuthTokenListener(e.Jc);
        }, function() {}));
    }
    return t.prototype.getToken = function() {
        var t = this, e = this.Zc, n = this.forceRefresh;
        // Take note of the current value of the tokenCounter so that this method
        // can fail (with an ABORTED error) if there is a token change while the
        // request is outstanding.
        return this.forceRefresh = !1, this.auth ? this.auth.getToken(n).then(function(n) {
            // Cancel the request since the token changed while the request was
            // outstanding so the response is potentially for a previous user (which
            // user, we can't be sure).
            return t.Zc !== e ? ($6c8154472dd99012$var$l("FirebaseCredentialsProvider", "getToken aborted due to token change."), t.getToken()) : n ? ($6c8154472dd99012$var$g("string" == typeof n.accessToken), new $6c8154472dd99012$var$ko(n.accessToken, t.currentUser)) : null;
        }) : Promise.resolve(null);
    }, t.prototype.zc = function() {
        this.forceRefresh = !0;
    }, t.prototype.Hc = function(t) {
        this.Gc = t, // Fire the initial event
        this.Xc && t(this.currentUser);
    }, t.prototype.Yc = function() {
        this.auth && this.auth.removeAuthTokenListener(this.Jc), this.Jc = null, this.Gc = null;
    }, // Auth.getUid() can return null even with a user logged in. It is because
    // getUid() is synchronous, but the auth code populating Uid is asynchronous.
    // This method should only be called in the AuthTokenListener callback
    // to guarantee to get the actual user.
    t.prototype.tu = function() {
        var t = this.auth && this.auth.getUid();
        return $6c8154472dd99012$var$g(null === t || "string" == typeof t), new $6c8154472dd99012$var$Mr(t);
    }, t;
}(), $6c8154472dd99012$var$Po = /** @class */ function() {
    function t(t, e) {
        this.eu = t, this.nu = e, this.type = "FirstParty", this.user = $6c8154472dd99012$var$Mr.ni;
    }
    return Object.defineProperty(t.prototype, "Kc", {
        get: function() {
            var t = {
                "X-Goog-AuthUser": this.nu
            }, e = this.eu.auth.getAuthHeaderValueForFirstParty([]);
            // Use array notation to prevent minification
            return e && (t.Authorization = e), t;
        },
        enumerable: !1,
        configurable: !0
    }), t;
}(), $6c8154472dd99012$var$Vo = /** @class */ function() {
    function t(t, e) {
        this.eu = t, this.nu = e;
    }
    return t.prototype.getToken = function() {
        return Promise.resolve(new $6c8154472dd99012$var$Po(this.eu, this.nu));
    }, t.prototype.Hc = function(t) {
        // Fire with initial uid.
        t($6c8154472dd99012$var$Mr.ni);
    }, t.prototype.Yc = function() {}, t.prototype.zc = function() {}, t;
}(), $6c8154472dd99012$var$Uo = /** @class */ function() {
    function e(t, e, n, r, i, o) {
        this.fn = t, this.su = n, this.iu = r, this.ru = i, this.listener = o, this.state = 0 /* Initial */ , /**
             * A close count that's incremented every time the stream is closed; used by
             * getCloseGuardedDispatcher() to invalidate callbacks that happen after
             * close.
             */ this.ou = 0, this.au = null, this.stream = null, this.ys = new $6c8154472dd99012$var$vr(t, e) /**
     * Returns true if start() has been called and no error has occurred. True
     * indicates the stream is open or in the process of opening (which
     * encompasses respecting backoff, getting auth tokens, and starting the
     * actual RPC). Use isOpen() to determine if the stream is open and ready for
     * outbound requests.
     */ ;
    }
    return e.prototype.cu = function() {
        return 1 /* Starting */  === this.state || 2 /* Open */  === this.state || 4 /* Backoff */  === this.state;
    }, /**
     * Returns true if the underlying RPC is open (the onOpen() listener has been
     * called) and the stream is ready for outbound requests.
     */ e.prototype.uu = function() {
        return 2 /* Open */  === this.state;
    }, /**
     * Starts the RPC. Only allowed if isStarted() returns false. The stream is
     * not immediately ready for use: onOpen() will be invoked when the RPC is
     * ready for outbound requests, at which point isOpen() will return true.
     *
     * When start returns, isStarted() will return true.
     */ e.prototype.start = function() {
        3 /* Error */  !== this.state ? this.auth() : this.hu();
    }, /**
     * Stops the RPC. This call is idempotent and allowed regardless of the
     * current isStarted() state.
     *
     * When stop returns, isStarted() and isOpen() will both return false.
     */ e.prototype.stop = function() {
        return $876a70688d8d7977$export$1050f835b63b671e(this, void 0, void 0, function() {
            return $876a70688d8d7977$export$67ebef60e6f28a6(this, function(t) {
                switch(t.label){
                    case 0:
                        return this.cu() ? [
                            4 /*yield*/ ,
                            this.close(0 /* Initial */ )
                        ] : [
                            3 /*break*/ ,
                            2
                        ];
                    case 1:
                        t.sent(), t.label = 2;
                    case 2:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    }, /**
     * After an error the stream will usually back off on the next attempt to
     * start it. If the error warrants an immediate restart of the stream, the
     * sender can use this to indicate that the receiver should not back off.
     *
     * Each error will call the onClose() listener. That function can decide to
     * inhibit backoff if required.
     */ e.prototype.lu = function() {
        this.state = 0 /* Initial */ , this.ys.reset();
    }, /**
     * Marks this stream as idle. If no further actions are performed on the
     * stream for one minute, the stream will automatically close itself and
     * notify the stream's onClose() handler with Status.OK. The stream will then
     * be in a !isStarted() state, requiring the caller to start the stream again
     * before further use.
     *
     * Only streams that are in state 'Open' can be marked idle, as all other
     * states imply pending network operations.
     */ e.prototype._u = function() {
        var t = this;
        // Starts the idle time if we are in state 'Open' and are not yet already
        // running a timer (in which case the previous idle timeout still applies).
        this.uu() && null === this.au && (this.au = this.fn.yn(this.su, 6e4, function() {
            return t.fu();
        }));
    }, /** Sends a message to the underlying stream. */ e.prototype.du = function(t) {
        this.wu(), this.stream.send(t);
    }, /** Called by the idle timer when the stream should close due to inactivity. */ e.prototype.fu = function() {
        return $876a70688d8d7977$export$1050f835b63b671e(this, void 0, void 0, function() {
            return $876a70688d8d7977$export$67ebef60e6f28a6(this, function(t) {
                return this.uu() ? [
                    2 /*return*/ ,
                    this.close(0 /* Initial */ )
                ] : [
                    2 /*return*/ 
                ];
            });
        });
    }, /** Marks the stream as active again. */ e.prototype.wu = function() {
        this.au && (this.au.cancel(), this.au = null);
    }, /**
     * Closes the stream and cleans up as necessary:
     *
     * * closes the underlying GRPC stream;
     * * calls the onClose handler with the given 'error';
     * * sets internal stream state to 'finalState';
     * * adjusts the backoff timer based on the error
     *
     * A new stream can be opened by calling start().
     *
     * @param finalState the intended state of the stream after closing.
     * @param error the error the connection was closed with.
     */ e.prototype.close = function(e, n) {
        return $876a70688d8d7977$export$1050f835b63b671e(this, void 0, void 0, function() {
            return $876a70688d8d7977$export$67ebef60e6f28a6(this, function(t) {
                switch(t.label){
                    case 0:
                        // Notify the listener that the stream closed.
                        // Cancel any outstanding timers (they're guaranteed not to execute).
                        return this.wu(), this.ys.cancel(), // Invalidates any stream-related callbacks (e.g. from auth or the
                        // underlying stream), guaranteeing they won't execute.
                        this.ou++, 3 /* Error */  !== e ? // If this is an intentional close ensure we don't delay our next connection attempt.
                        this.ys.reset() : n && n.code === $6c8154472dd99012$var$a.RESOURCE_EXHAUSTED ? // Log the error. (Probably either 'quota exceeded' or 'max queue length reached'.)
                        ($6c8154472dd99012$var$p(n.toString()), $6c8154472dd99012$var$p("Using maximum backoff delay to prevent overloading the backend."), this.ys.Rn()) : n && n.code === $6c8154472dd99012$var$a.UNAUTHENTICATED && // "unauthenticated" error means the token was rejected. Try force refreshing it in case it
                        // just expired.
                        this.ru.zc(), // Clean up the underlying stream because we are no longer interested in events.
                        null !== this.stream && (this.mu(), this.stream.close(), this.stream = null), // This state must be assigned before calling onClose() to allow the callback to
                        // inhibit backoff or otherwise manipulate the state in its non-started state.
                        this.state = e, [
                            4 /*yield*/ ,
                            this.listener.Tu(n)
                        ];
                    case 1:
                        // Cancel any outstanding timers (they're guaranteed not to execute).
                        // Notify the listener that the stream closed.
                        return t.sent(), [
                            2 /*return*/ 
                        ];
                }
            });
        });
    }, /**
     * Can be overridden to perform additional cleanup before the stream is closed.
     * Calling super.tearDown() is not required.
     */ e.prototype.mu = function() {}, e.prototype.auth = function() {
        var t = this;
        this.state = 1 /* Starting */ ;
        var e = this.Eu(this.ou), n = this.ou;
        // TODO(mikelehen): Just use dispatchIfNotClosed, but see TODO below.
        this.ru.getToken().then(function(e) {
            // Stream can be stopped while waiting for authentication.
            // TODO(mikelehen): We really should just use dispatchIfNotClosed
            // and let this dispatch onto the queue, but that opened a spec test can
            // of worms that I don't want to deal with in this PR.
            t.ou === n && // Normally we'd have to schedule the callback on the AsyncQueue.
            // However, the following calls are safe to be called outside the
            // AsyncQueue since they don't chain asynchronous calls
            t.Iu(e);
        }, function(n) {
            e(function() {
                var e = new $6c8154472dd99012$var$c($6c8154472dd99012$var$a.UNKNOWN, "Fetching auth token failed: " + n.message);
                return t.Au(e);
            });
        });
    }, e.prototype.Iu = function(t) {
        var e = this, n = this.Eu(this.ou);
        this.stream = this.Ru(t), this.stream.gu(function() {
            n(function() {
                return e.state = 2 /* Open */ , e.listener.gu();
            });
        }), this.stream.Tu(function(t) {
            n(function() {
                return e.Au(t);
            });
        }), this.stream.onMessage(function(t) {
            n(function() {
                return e.onMessage(t);
            });
        });
    }, e.prototype.hu = function() {
        var e = this;
        this.state = 4 /* Backoff */ , this.ys.gn(function() {
            return $876a70688d8d7977$export$1050f835b63b671e(e, void 0, void 0, function() {
                return $876a70688d8d7977$export$67ebef60e6f28a6(this, function(t) {
                    return this.state = 0 /* Initial */ , this.start(), [
                        2 /*return*/ 
                    ];
                });
            });
        });
    }, // Visible for tests
    e.prototype.Au = function(t) {
        // In theory the stream could close cleanly, however, in our current model
        // we never expect this to happen because if we stop a stream ourselves,
        // this callback will never be called. To prevent cases where we retry
        // without a backoff accidentally, we set the stream to error in all cases.
        return $6c8154472dd99012$var$l("PersistentStream", "close with error: " + t), this.stream = null, this.close(3 /* Error */ , t);
    }, /**
     * Returns a "dispatcher" function that dispatches operations onto the
     * AsyncQueue but only runs them if closeCount remains unchanged. This allows
     * us to turn auth / stream callbacks into no-ops if the stream is closed /
     * re-opened, etc.
     */ e.prototype.Eu = function(t) {
        var e = this;
        return function(n) {
            e.fn.ws(function() {
                return e.ou === t ? n() : ($6c8154472dd99012$var$l("PersistentStream", "stream callback skipped by getCloseGuardedDispatcher."), Promise.resolve());
            });
        };
    }, e;
}(), $6c8154472dd99012$var$Co = /** @class */ function(e) {
    function n(t, n, r, i, o) {
        var s = this;
        return (s = e.call(this, t, "listen_stream_connection_backoff" /* ListenStreamConnectionBackoff */ , "listen_stream_idle" /* ListenStreamIdle */ , n, r, o) || this).serializer = i, s;
    }
    return $876a70688d8d7977$export$a8ba968b8961cb8a(n, e), n.prototype.Ru = function(t) {
        return this.iu.Pu("Listen", t);
    }, n.prototype.onMessage = function(t) {
        // A successful response means the stream is healthy
        this.ys.reset();
        var e = function(t, e) {
            var n;
            if ("targetChange" in e) {
                e.targetChange;
                // proto3 default value is unset in JSON (undefined), so use 'NO_CHANGE'
                // if unset
                var r = function(t) {
                    return "NO_CHANGE" === t ? 0 /* NoChange */  : "ADD" === t ? 1 /* Added */  : "REMOVE" === t ? 2 /* Removed */  : "CURRENT" === t ? 3 /* Current */  : "RESET" === t ? 4 /* Reset */  : $6c8154472dd99012$var$y();
                }(e.targetChange.targetChangeType || "NO_CHANGE"), i = e.targetChange.targetIds || [], o = function(t, e) {
                    return t.Qe ? ($6c8154472dd99012$var$g(void 0 === e || "string" == typeof e), $6c8154472dd99012$var$X.fromBase64String(e || "")) : ($6c8154472dd99012$var$g(void 0 === e || e instanceof Uint8Array), $6c8154472dd99012$var$X.fromUint8Array(e || new Uint8Array));
                }(t, e.targetChange.resumeToken), s = e.targetChange.cause, u = s && function(t) {
                    var e = void 0 === t.code ? $6c8154472dd99012$var$a.UNKNOWN : $6c8154472dd99012$var$_t(t.code);
                    return new $6c8154472dd99012$var$c(e, t.message || "");
                }(s);
                n = new $6c8154472dd99012$var$zt(r, i, o, u || null);
            } else if ("documentChange" in e) {
                e.documentChange;
                var h = e.documentChange;
                h.document, h.document.name, h.document.updateTime;
                var f = $6c8154472dd99012$var$Se(t, h.document.name), l = $6c8154472dd99012$var$Ee(h.document.updateTime), p = new $6c8154472dd99012$var$Sn({
                    mapValue: {
                        fields: h.document.fields
                    }
                }), d = new $6c8154472dd99012$var$kn(f, l, p, {}), v = h.targetIds || [], m = h.removedTargetIds || [];
                n = new $6c8154472dd99012$var$jt(v, m, d.key, d);
            } else if ("documentDelete" in e) {
                e.documentDelete;
                var w = e.documentDelete;
                w.document;
                var _ = $6c8154472dd99012$var$Se(t, w.document), b = w.readTime ? $6c8154472dd99012$var$Ee(w.readTime) : $6c8154472dd99012$var$st.min(), I = new $6c8154472dd99012$var$Rn(_, b), E = w.removedTargetIds || [];
                n = new $6c8154472dd99012$var$jt([], E, I.key, I);
            } else if ("documentRemove" in e) {
                e.documentRemove;
                var T = e.documentRemove;
                T.document;
                var N = $6c8154472dd99012$var$Se(t, T.document), A = T.removedTargetIds || [];
                n = new $6c8154472dd99012$var$jt([], A, N, null);
            } else {
                if (!("filter" in e)) return $6c8154472dd99012$var$y();
                e.filter;
                var S = e.filter;
                S.targetId;
                var D = S.count || 0, x = new $6c8154472dd99012$var$mt(D), L = S.targetId;
                n = new $6c8154472dd99012$var$Gt(L, x);
            }
            return n;
        }(this.serializer, t), n = function(t) {
            // We have only reached a consistent snapshot for the entire stream if there
            // is a read_time set and it applies to all targets (i.e. the list of
            // targets is empty). The backend is guaranteed to send such responses.
            if (!("targetChange" in t)) return $6c8154472dd99012$var$st.min();
            var e = t.targetChange;
            return e.targetIds && e.targetIds.length ? $6c8154472dd99012$var$st.min() : e.readTime ? $6c8154472dd99012$var$Ee(e.readTime) : $6c8154472dd99012$var$st.min();
        }(t);
        return this.listener.yu(e, n);
    }, /**
     * Registers interest in the results of the given target. If the target
     * includes a resumeToken it will be included in the request. Results that
     * affect the target will be streamed back as WatchChange messages that
     * reference the targetId.
     */ n.prototype.Vu = function(t) {
        var e = {};
        e.database = $6c8154472dd99012$var$Le(this.serializer), e.addTarget = function(t, e) {
            var n, r = e.target;
            return (n = $6c8154472dd99012$var$dt(r) ? {
                documents: $6c8154472dd99012$var$Ve(t, r)
            } : {
                query: $6c8154472dd99012$var$Ue(t, r)
            }).targetId = e.targetId, e.resumeToken.O() > 0 && (n.resumeToken = $6c8154472dd99012$var$be(t, e.resumeToken)), n;
        }(this.serializer, t);
        var n = function(t, e) {
            var n = function(t, e) {
                switch(e){
                    case 0 /* Listen */ :
                        return null;
                    case 1 /* ExistenceFilterMismatch */ :
                        return "existence-filter-mismatch";
                    case 2 /* LimboResolution */ :
                        return "limbo-document";
                    default:
                        return $6c8154472dd99012$var$y();
                }
            }(0, e.et);
            return null == n ? null : {
                "goog-listen-tags": n
            };
        }(this.serializer, t);
        n && (e.labels = n), this.du(e);
    }, /**
     * Unregisters interest in the results of the target associated with the
     * given targetId.
     */ n.prototype.pu = function(t) {
        var e = {};
        e.database = $6c8154472dd99012$var$Le(this.serializer), e.removeTarget = t, this.du(e);
    }, n;
}($6c8154472dd99012$var$Uo), $6c8154472dd99012$var$Fo = /** @class */ function(e) {
    function n(t, n, r, i, o) {
        var s = this;
        return (s = e.call(this, t, "write_stream_connection_backoff" /* WriteStreamConnectionBackoff */ , "write_stream_idle" /* WriteStreamIdle */ , n, r, o) || this).serializer = i, s.bu = !1, s;
    }
    return $876a70688d8d7977$export$a8ba968b8961cb8a(n, e), Object.defineProperty(n.prototype, "vu", {
        /**
         * Tracks whether or not a handshake has been successfully exchanged and
         * the stream is ready to accept mutations.
         */ get: function() {
            return this.bu;
        },
        enumerable: !1,
        configurable: !0
    }), // Override of PersistentStream.start
    n.prototype.start = function() {
        this.bu = !1, this.lastStreamToken = void 0, e.prototype.start.call(this);
    }, n.prototype.mu = function() {
        this.bu && this.Su([]);
    }, n.prototype.Ru = function(t) {
        return this.iu.Pu("Write", t);
    }, n.prototype.onMessage = function(t) {
        if (// Always capture the last stream token.
        $6c8154472dd99012$var$g(!!t.streamToken), this.lastStreamToken = t.streamToken, this.bu) {
            // A successful first write response means the stream is healthy,
            // Note, that we could consider a successful handshake healthy, however,
            // the write itself might be causing an error we want to back off from.
            this.ys.reset();
            var e = function(t, e) {
                return t && t.length > 0 ? ($6c8154472dd99012$var$g(void 0 !== e), t.map(function(t) {
                    return function(t, e) {
                        // NOTE: Deletes don't have an updateTime.
                        var n = t.updateTime ? $6c8154472dd99012$var$Ee(t.updateTime) : $6c8154472dd99012$var$Ee(e);
                        n.isEqual($6c8154472dd99012$var$st.min()) && // The Firestore Emulator currently returns an update time of 0 for
                        // deletes of non-existing documents (rather than null). This breaks the
                        // test "get deleted doc while offline with source=cache" as NoDocuments
                        // with version 0 are filtered by IndexedDb's RemoteDocumentCache.
                        // TODO(#2149): Remove this when Emulator is fixed
                        (n = $6c8154472dd99012$var$Ee(e));
                        var r = null;
                        return t.transformResults && t.transformResults.length > 0 && (r = t.transformResults), new $6c8154472dd99012$var$hn(n, r);
                    }(t, e);
                })) : [];
            }(t.writeResults, t.commitTime), n = $6c8154472dd99012$var$Ee(t.commitTime);
            return this.listener.Du(n, e);
        }
        // The first response is always the handshake response
        return $6c8154472dd99012$var$g(!t.writeResults || 0 === t.writeResults.length), this.bu = !0, this.listener.Cu();
    }, /**
     * Sends an initial streamToken to the server, performing the handshake
     * required to make the StreamingWrite RPC work. Subsequent
     * calls should wait until onHandshakeComplete was called.
     */ n.prototype.Nu = function() {
        // TODO(dimond): Support stream resumption. We intentionally do not set the
        // stream token on the handshake, ignoring any stream token we might have.
        var t = {};
        t.database = $6c8154472dd99012$var$Le(this.serializer), this.du(t);
    }, /** Sends a group of mutations to the Firestore backend to apply. */ n.prototype.Su = function(t) {
        var e = this, n = {
            streamToken: this.lastStreamToken,
            writes: t.map(function(t) {
                return $6c8154472dd99012$var$Oe(e.serializer, t);
            })
        };
        this.du(n);
    }, n;
}($6c8154472dd99012$var$Uo), $6c8154472dd99012$var$Mo = /** @class */ function(e) {
    function n(t, n, r) {
        var i = this;
        return (i = e.call(this) || this).credentials = t, i.iu = n, i.serializer = r, i.Fu = !1, i;
    }
    return $876a70688d8d7977$export$a8ba968b8961cb8a(n, e), n.prototype.xu = function() {
        if (this.Fu) throw new $6c8154472dd99012$var$c($6c8154472dd99012$var$a.FAILED_PRECONDITION, "The client has already been terminated.");
    }, /** Gets an auth token and invokes the provided RPC. */ n.prototype.$u = function(t, e, n) {
        var r = this;
        return this.xu(), this.credentials.getToken().then(function(i) {
            return r.iu.$u(t, e, n, i);
        }).catch(function(t) {
            throw t.code === $6c8154472dd99012$var$a.UNAUTHENTICATED && r.credentials.zc(), t;
        });
    }, /** Gets an auth token and invokes the provided RPC with streamed results. */ n.prototype.ku = function(t, e, n) {
        var r = this;
        return this.xu(), this.credentials.getToken().then(function(i) {
            return r.iu.ku(t, e, n, i);
        }).catch(function(t) {
            throw t.code === $6c8154472dd99012$var$a.UNAUTHENTICATED && r.credentials.zc(), t;
        });
    }, n.prototype.terminate = function() {
        this.Fu = !1;
    }, n;
}(function() {}), $6c8154472dd99012$var$qo = /** @class */ function() {
    function t(t, e) {
        this.cs = t, this.di = e, /** The current OnlineState. */ this.state = "Unknown" /* Unknown */ , /**
             * A count of consecutive failures to open the stream. If it reaches the
             * maximum defined by MAX_WATCH_STREAM_FAILURES, we'll set the OnlineState to
             * Offline.
             */ this.Mu = 0, /**
             * A timer that elapses after ONLINE_STATE_TIMEOUT_MS, at which point we
             * transition from OnlineState.Unknown to OnlineState.Offline without waiting
             * for the stream to actually fail (MAX_WATCH_STREAM_FAILURES times).
             */ this.Ou = null, /**
             * Whether the client should log a warning message if it fails to connect to
             * the backend (initially true, cleared after a successful stream, or if we've
             * logged the message already).
             */ this.Lu = !0 /**
     * Called by RemoteStore when a watch stream is started (including on each
     * backoff attempt).
     *
     * If this is the first attempt, it sets the OnlineState to Unknown and starts
     * the onlineStateTimer.
     */ ;
    }
    return t.prototype.Bu = function() {
        var t = this;
        0 === this.Mu && (this.qu("Unknown" /* Unknown */ ), this.Ou = this.cs.yn("online_state_timeout" /* OnlineStateTimeout */ , 1e4, function() {
            return t.Ou = null, t.Uu("Backend didn't respond within 10 seconds."), t.qu("Offline" /* Offline */ ), Promise.resolve();
        }));
    }, /**
     * Updates our OnlineState as appropriate after the watch stream reports a
     * failure. The first failure moves us to the 'Unknown' state. We then may
     * allow multiple failures (based on MAX_WATCH_STREAM_FAILURES) before we
     * actually transition to the 'Offline' state.
     */ t.prototype.Qu = function(t) {
        "Online" /* Online */  === this.state ? this.qu("Unknown" /* Unknown */ ) : (this.Mu++, this.Mu >= 1 && (this.Wu(), this.Uu("Connection failed 1 times. Most recent error: " + t.toString()), this.qu("Offline" /* Offline */ )));
    }, /**
     * Explicitly sets the OnlineState to the specified state.
     *
     * Note that this resets our timers / failure counters, etc. used by our
     * Offline heuristics, so must not be used in place of
     * handleWatchStreamStart() and handleWatchStreamFailure().
     */ t.prototype.set = function(t) {
        this.Wu(), this.Mu = 0, "Online" /* Online */  === t && // We've connected to watch at least once. Don't warn the developer
        // about being offline going forward.
        (this.Lu = !1), this.qu(t);
    }, t.prototype.qu = function(t) {
        t !== this.state && (this.state = t, this.di(t));
    }, t.prototype.Uu = function(t) {
        var e = "Could not reach Cloud Firestore backend. " + t + "\nThis typically indicates that your device does not have a healthy Internet connection at the moment. The client will operate in offline mode until it is able to successfully connect to the backend.";
        this.Lu ? ($6c8154472dd99012$var$p(e), this.Lu = !1) : $6c8154472dd99012$var$l("OnlineStateTracker", e);
    }, t.prototype.Wu = function() {
        null !== this.Ou && (this.Ou.cancel(), this.Ou = null);
    }, t;
}(), $6c8154472dd99012$var$jo = function(/**
     * The local store, used to fill the write pipeline with outbound mutations.
     */ e, /** The client-side proxy for interacting with the backend. */ n, r, i, o) {
    var s = this;
    this.ju = e, this.Ku = n, this.cs = r, this.Gu = {}, /**
             * A list of up to MAX_PENDING_WRITES writes that we have fetched from the
             * LocalStore via fillWritePipeline() and have or will send to the write
             * stream.
             *
             * Whenever writePipeline.length > 0 the RemoteStore will attempt to start or
             * restart the write stream. When the stream is established the writes in the
             * pipeline will be sent in order.
             *
             * Writes remain in writePipeline until they are acknowledged by the backend
             * and thus will automatically be re-sent if the stream is interrupted /
             * restarted before they're acknowledged.
             *
             * Write responses from the backend are linked to their originating request
             * purely based on order, and so we can just shift() writes from the front of
             * the writePipeline as we receive responses.
             */ this.zu = [], /**
             * A mapping of watched targets that the client cares about tracking and the
             * user has explicitly called a 'listen' for this target.
             *
             * These targets may or may not have been sent to or acknowledged by the
             * server. On re-establishing the listen stream, these targets should be sent
             * to the server. The targets removed with unlistens are removed eagerly
             * without waiting for confirmation from the listen stream.
             */ this.Hu = new Map, /**
             * A set of reasons for why the RemoteStore may be offline. If empty, the
             * RemoteStore may start its network connections.
             */ this.Yu = new Set, /**
             * Event handlers that get called when the network is disabled or enabled.
             *
             * PORTING NOTE: These functions are used on the Web client to create the
             * underlying streams (to support tree-shakeable streams). On Android and iOS,
             * the streams are created during construction of RemoteStore.
             */ this.Ju = [], this.Xu = o, this.Xu.Zu(function(e) {
        r.ws(function() {
            return $876a70688d8d7977$export$1050f835b63b671e(s, void 0, void 0, function() {
                return $876a70688d8d7977$export$67ebef60e6f28a6(this, function(e) {
                    switch(e.label){
                        case 0:
                            return $6c8154472dd99012$var$Xo(this) ? ($6c8154472dd99012$var$l("RemoteStore", "Restarting streams for network reachability change."), [
                                4 /*yield*/ ,
                                function(e) {
                                    return $876a70688d8d7977$export$1050f835b63b671e(this, void 0, void 0, function() {
                                        var n;
                                        return $876a70688d8d7977$export$67ebef60e6f28a6(this, function(t) {
                                            switch(t.label){
                                                case 0:
                                                    return (n = $6c8154472dd99012$var$m(e)).Yu.add(4 /* ConnectivityChange */ ), [
                                                        4 /*yield*/ ,
                                                        $6c8154472dd99012$var$zo(n)
                                                    ];
                                                case 1:
                                                    return t.sent(), n.th.set("Unknown" /* Unknown */ ), n.Yu.delete(4 /* ConnectivityChange */ ), [
                                                        4 /*yield*/ ,
                                                        $6c8154472dd99012$var$Go(n)
                                                    ];
                                                case 2:
                                                    return t.sent(), [
                                                        2 /*return*/ 
                                                    ];
                                            }
                                        });
                                    });
                                }(this)
                            ]) : [
                                3 /*break*/ ,
                                2
                            ];
                        case 1:
                            e.sent(), e.label = 2;
                        case 2:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        });
    }), this.th = new $6c8154472dd99012$var$qo(r, i);
};
function $6c8154472dd99012$var$Go(e) {
    return $876a70688d8d7977$export$1050f835b63b671e(this, void 0, void 0, function() {
        var n, r;
        return $876a70688d8d7977$export$67ebef60e6f28a6(this, function(t) {
            switch(t.label){
                case 0:
                    if (!$6c8154472dd99012$var$Xo(e)) return [
                        3 /*break*/ ,
                        4
                    ];
                    n = 0, r = e.Ju, t.label = 1;
                case 1:
                    return n < r.length ? [
                        4 /*yield*/ ,
                        (0, r[n])(/* enabled= */ !0)
                    ] : [
                        3 /*break*/ ,
                        4
                    ];
                case 2:
                    t.sent(), t.label = 3;
                case 3:
                    return n++, [
                        3 /*break*/ ,
                        1
                    ];
                case 4:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
/**
 * Temporarily disables the network. The network can be re-enabled using
 * enableNetwork().
 */ function $6c8154472dd99012$var$zo(e) {
    return $876a70688d8d7977$export$1050f835b63b671e(this, void 0, void 0, function() {
        var n, r;
        return $876a70688d8d7977$export$67ebef60e6f28a6(this, function(t) {
            switch(t.label){
                case 0:
                    n = 0, r = e.Ju, t.label = 1;
                case 1:
                    return n < r.length ? [
                        4 /*yield*/ ,
                        (0, r[n])(/* enabled= */ !1)
                    ] : [
                        3 /*break*/ ,
                        4
                    ];
                case 2:
                    t.sent(), t.label = 3;
                case 3:
                    return n++, [
                        3 /*break*/ ,
                        1
                    ];
                case 4:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
function $6c8154472dd99012$var$Bo(e) {
    return $876a70688d8d7977$export$1050f835b63b671e(this, void 0, void 0, function() {
        var n;
        return $876a70688d8d7977$export$67ebef60e6f28a6(this, function(t) {
            switch(t.label){
                case 0:
                    return n = $6c8154472dd99012$var$m(e), $6c8154472dd99012$var$l("RemoteStore", "RemoteStore shutting down."), n.Yu.add(5 /* Shutdown */ ), [
                        4 /*yield*/ ,
                        $6c8154472dd99012$var$zo(n)
                    ];
                case 1:
                    return t.sent(), n.Xu.Di(), // Set the OnlineState to Unknown (rather than Offline) to avoid potentially
                    // triggering spurious listener events with cached data, etc.
                    n.th.set("Unknown" /* Unknown */ ), [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
/**
 * Starts new listen for the given target. Uses resume token if provided. It
 * is a no-op if the target of given `TargetData` is already being listened to.
 */ function $6c8154472dd99012$var$Wo(t, e) {
    var n = $6c8154472dd99012$var$m(t);
    n.Hu.has(e.targetId) || // Mark this as something the client is currently listening for.
    (n.Hu.set(e.targetId, e), $6c8154472dd99012$var$$o(n) ? // The listen will be sent in onWatchStreamOpen
    $6c8154472dd99012$var$Yo(n) : $6c8154472dd99012$var$ls(n).uu() && $6c8154472dd99012$var$Qo(n, e));
}
/**
 * Removes the listen from server. It is a no-op if the given target id is
 * not being listened to.
 */ function $6c8154472dd99012$var$Ko(t, e) {
    var n = $6c8154472dd99012$var$m(t), r = $6c8154472dd99012$var$ls(n);
    n.Hu.delete(e), r.uu() && $6c8154472dd99012$var$Ho(n, e), 0 === n.Hu.size && (r.uu() ? r._u() : $6c8154472dd99012$var$Xo(n) && // Revert to OnlineState.Unknown if the watch stream is not open and we
    // have no listeners, since without any listens to send we cannot
    // confirm if the stream is healthy and upgrade to OnlineState.Online.
    n.th.set("Unknown" /* Unknown */ ));
}
/**
 * We need to increment the the expected number of pending responses we're due
 * from watch so we wait for the ack to process any messages from this target.
 */ function $6c8154472dd99012$var$Qo(t, e) {
    t.eh.Ie(e.targetId), $6c8154472dd99012$var$ls(t).Vu(e) /**
 * We need to increment the expected number of pending responses we're due
 * from watch so we wait for the removal on the server before we process any
 * messages from this target.
 */ ;
}
function $6c8154472dd99012$var$Ho(t, e) {
    t.eh.Ie(e), $6c8154472dd99012$var$ls(t).pu(e);
}
function $6c8154472dd99012$var$Yo(t) {
    t.eh = new $6c8154472dd99012$var$Wt({
        qe: function(e) {
            return t.Gu.qe(e);
        },
        Ue: function(e) {
            return t.Hu.get(e) || null;
        }
    }), $6c8154472dd99012$var$ls(t).start(), t.th.Bu() /**
 * Returns whether the watch stream should be started because it's necessary
 * and has not yet been started.
 */ ;
}
function $6c8154472dd99012$var$$o(t) {
    return $6c8154472dd99012$var$Xo(t) && !$6c8154472dd99012$var$ls(t).cu() && t.Hu.size > 0;
}
function $6c8154472dd99012$var$Xo(t) {
    return 0 === $6c8154472dd99012$var$m(t).Yu.size;
}
function $6c8154472dd99012$var$Jo(t) {
    t.eh = void 0;
}
function $6c8154472dd99012$var$Zo(e) {
    return $876a70688d8d7977$export$1050f835b63b671e(this, void 0, void 0, function() {
        return $876a70688d8d7977$export$67ebef60e6f28a6(this, function(t) {
            return e.Hu.forEach(function(t, n) {
                $6c8154472dd99012$var$Qo(e, t);
            }), [
                2 /*return*/ 
            ];
        });
    });
}
function $6c8154472dd99012$var$ts(e, n) {
    return $876a70688d8d7977$export$1050f835b63b671e(this, void 0, void 0, function() {
        return $876a70688d8d7977$export$67ebef60e6f28a6(this, function(t) {
            return $6c8154472dd99012$var$Jo(e), // If we still need the watch stream, retry the connection.
            $6c8154472dd99012$var$$o(e) ? (e.th.Qu(n), $6c8154472dd99012$var$Yo(e)) : // No need to restart watch stream because there are no active targets.
            // The online state is set to unknown because there is no active attempt
            // at establishing a connection
            e.th.set("Unknown" /* Unknown */ ), [
                2 /*return*/ 
            ];
        });
    });
}
function $6c8154472dd99012$var$es(e, n, r) {
    return $876a70688d8d7977$export$1050f835b63b671e(this, void 0, void 0, function() {
        var i, o, s;
        return $876a70688d8d7977$export$67ebef60e6f28a6(this, function(u) {
            switch(u.label){
                case 0:
                    if (e.th.set("Online" /* Online */ ), !(n instanceof $6c8154472dd99012$var$zt && 2 /* Removed */  === n.state && n.cause)) // Mark the client as online since we got a message from the server
                    return [
                        3 /*break*/ ,
                        6
                    ];
                    u.label = 1;
                case 1:
                    return u.trys.push([
                        1,
                        3,
                        ,
                        5
                    ]), [
                        4 /*yield*/ ,
                        /** Handles an error on a target */ function(e, n) {
                            return $876a70688d8d7977$export$1050f835b63b671e(this, void 0, void 0, function() {
                                var r, i, o, s;
                                return $876a70688d8d7977$export$67ebef60e6f28a6(this, function(t) {
                                    switch(t.label){
                                        case 0:
                                            r = n.cause, i = 0, o = n.targetIds, t.label = 1;
                                        case 1:
                                            return i < o.length ? (s = o[i], e.Hu.has(s) ? [
                                                4 /*yield*/ ,
                                                e.Gu.nh(s, r)
                                            ] : [
                                                3 /*break*/ ,
                                                3
                                            ]) : [
                                                3 /*break*/ ,
                                                5
                                            ];
                                        case 2:
                                            t.sent(), e.Hu.delete(s), e.eh.removeTarget(s), t.label = 3;
                                        case 3:
                                            t.label = 4;
                                        case 4:
                                            return i++, [
                                                3 /*break*/ ,
                                                1
                                            ];
                                        case 5:
                                            return [
                                                2 /*return*/ 
                                            ];
                                    }
                                });
                            });
                        }(e, n)
                    ];
                case 2:
                    return u.sent(), [
                        3 /*break*/ ,
                        5
                    ];
                case 3:
                    return i = u.sent(), $6c8154472dd99012$var$l("RemoteStore", "Failed to remove targets %s: %s ", n.targetIds.join(","), i), [
                        4 /*yield*/ ,
                        $6c8154472dd99012$var$ns(e, i)
                    ];
                case 4:
                    return u.sent(), [
                        3 /*break*/ ,
                        5
                    ];
                case 5:
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 6:
                    if (n instanceof $6c8154472dd99012$var$jt ? e.eh.be(n) : n instanceof $6c8154472dd99012$var$Gt ? e.eh.$e(n) : e.eh.De(n), r.isEqual($6c8154472dd99012$var$st.min())) return [
                        3 /*break*/ ,
                        13
                    ];
                    u.label = 7;
                case 7:
                    return u.trys.push([
                        7,
                        11,
                        ,
                        13
                    ]), [
                        4 /*yield*/ ,
                        $6c8154472dd99012$var$wo(e.ju)
                    ];
                case 8:
                    return o = u.sent(), r.L(o) >= 0 ? [
                        4 /*yield*/ ,
                        /**
                 * Takes a batch of changes from the Datastore, repackages them as a
                 * RemoteEvent, and passes that on to the listener, which is typically the
                 * SyncEngine.
                 */ function(t, e) {
                            var n = t.eh.Oe(e);
                            // Update in-memory resume tokens. LocalStore will update the
                            // persistent view of these when applying the completed RemoteEvent.
                            return n.zt.forEach(function(n, r) {
                                if (n.resumeToken.O() > 0) {
                                    var i = t.Hu.get(r);
                                    // A watched target might have been removed already.
                                    i && t.Hu.set(r, i.it(n.resumeToken, e));
                                }
                            }), // Re-establish listens for the targets that have been invalidated by
                            // existence filter mismatches.
                            n.Ht.forEach(function(e) {
                                var n = t.Hu.get(e);
                                if (n) {
                                    // Clear the resume token for the target, since we're in a known mismatch
                                    // state.
                                    t.Hu.set(e, n.it($6c8154472dd99012$var$X.B, n.nt)), // Cause a hard reset by unwatching and rewatching immediately, but
                                    // deliberately don't send a resume token so that we get a full update.
                                    $6c8154472dd99012$var$Ho(t, e);
                                    // Mark the target we send as being on behalf of an existence filter
                                    // mismatch, but don't actually retain that in listenTargets. This ensures
                                    // that we flag the first re-listen this way without impacting future
                                    // listens of this target (that might happen e.g. on reconnect).
                                    var r = new $6c8154472dd99012$var$gt(n.target, e, 1 /* ExistenceFilterMismatch */ , n.sequenceNumber);
                                    $6c8154472dd99012$var$Qo(t, r);
                                }
                            }), t.Gu.sh(n);
                        }(e, r)
                    ] : [
                        3 /*break*/ ,
                        10
                    ];
                // We have received a target change with a global snapshot if the snapshot
                // version is not equal to SnapshotVersion.min().
                case 9:
                    // We have received a target change with a global snapshot if the snapshot
                    // version is not equal to SnapshotVersion.min().
                    u.sent(), u.label = 10;
                case 10:
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 11:
                    return $6c8154472dd99012$var$l("RemoteStore", "Failed to raise snapshot:", s = u.sent()), [
                        4 /*yield*/ ,
                        $6c8154472dd99012$var$ns(e, s)
                    ];
                case 12:
                    return u.sent(), [
                        3 /*break*/ ,
                        13
                    ];
                case 13:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
/**
 * Recovery logic for IndexedDB errors that takes the network offline until
 * `op` succeeds. Retries are scheduled with backoff using
 * `enqueueRetryable()`. If `op()` is not provided, IndexedDB access is
 * validated via a generic operation.
 *
 * The returned Promise is resolved once the network is disabled and before
 * any retry attempt.
 */ function $6c8154472dd99012$var$ns(e, n, r) {
    return $876a70688d8d7977$export$1050f835b63b671e(this, void 0, void 0, function() {
        var i = this;
        return $876a70688d8d7977$export$67ebef60e6f28a6(this, function(o) {
            switch(o.label){
                case 0:
                    if (!$6c8154472dd99012$var$_r(n)) throw n;
                    // Disable network and raise offline snapshots
                    return e.Yu.add(1 /* IndexedDbFailed */ ), [
                        4 /*yield*/ ,
                        $6c8154472dd99012$var$zo(e)
                    ];
                case 1:
                    // Disable network and raise offline snapshots
                    return o.sent(), e.th.set("Offline" /* Offline */ ), r || // Use a simple read operation to determine if IndexedDB recovered.
                    // Ideally, we would expose a health check directly on SimpleDb, but
                    // RemoteStore only has access to persistence through LocalStore.
                    (r = function() {
                        return $6c8154472dd99012$var$wo(e.ju);
                    }), // Probe IndexedDB periodically and re-enable network
                    e.cs.Cs(function() {
                        return $876a70688d8d7977$export$1050f835b63b671e(i, void 0, void 0, function() {
                            return $876a70688d8d7977$export$67ebef60e6f28a6(this, function(t) {
                                switch(t.label){
                                    case 0:
                                        return $6c8154472dd99012$var$l("RemoteStore", "Retrying IndexedDB access"), [
                                            4 /*yield*/ ,
                                            r()
                                        ];
                                    case 1:
                                        return t.sent(), e.Yu.delete(1 /* IndexedDbFailed */ ), [
                                            4 /*yield*/ ,
                                            $6c8154472dd99012$var$Go(e)
                                        ];
                                    case 2:
                                        return t.sent(), [
                                            2 /*return*/ 
                                        ];
                                }
                            });
                        });
                    }), [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
/**
 * Executes `op`. If `op` fails, takes the network offline until `op`
 * succeeds. Returns after the first attempt.
 */ function $6c8154472dd99012$var$rs(t, e) {
    return e().catch(function(n) {
        return $6c8154472dd99012$var$ns(t, n, e);
    });
}
function $6c8154472dd99012$var$is(e) {
    return $876a70688d8d7977$export$1050f835b63b671e(this, void 0, void 0, function() {
        var n, r, i, o, s;
        return $876a70688d8d7977$export$67ebef60e6f28a6(this, function(t) {
            switch(t.label){
                case 0:
                    n = $6c8154472dd99012$var$m(e), r = $6c8154472dd99012$var$ps(n), i = n.zu.length > 0 ? n.zu[n.zu.length - 1].batchId : -1, t.label = 1;
                case 1:
                    if (!/**
 * Returns true if we can add to the write pipeline (i.e. the network is
 * enabled and the write pipeline is not full).
 */ function(t) {
                        return $6c8154472dd99012$var$Xo(t) && t.zu.length < 10;
                    }(n)) return [
                        3 /*break*/ ,
                        7
                    ];
                    t.label = 2;
                case 2:
                    return t.trys.push([
                        2,
                        4,
                        ,
                        6
                    ]), [
                        4 /*yield*/ ,
                        $6c8154472dd99012$var$bo(n.ju, i)
                    ];
                case 3:
                    return null === (o = t.sent()) ? (0 === n.zu.length && r._u(), [
                        3 /*break*/ ,
                        7
                    ]) : (i = o.batchId, function(t, e) {
                        t.zu.push(e);
                        var n = $6c8154472dd99012$var$ps(t);
                        n.uu() && n.vu && n.Su(e.mutations);
                    }(n, o), [
                        3 /*break*/ ,
                        6
                    ]);
                case 4:
                    return s = t.sent(), [
                        4 /*yield*/ ,
                        $6c8154472dd99012$var$ns(n, s)
                    ];
                case 5:
                    return t.sent(), [
                        3 /*break*/ ,
                        6
                    ];
                case 6:
                    return [
                        3 /*break*/ ,
                        1
                    ];
                case 7:
                    return $6c8154472dd99012$var$os(n) && $6c8154472dd99012$var$ss(n), [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
function $6c8154472dd99012$var$os(t) {
    return $6c8154472dd99012$var$Xo(t) && !$6c8154472dd99012$var$ps(t).cu() && t.zu.length > 0;
}
function $6c8154472dd99012$var$ss(t) {
    $6c8154472dd99012$var$ps(t).start();
}
function $6c8154472dd99012$var$us(e) {
    return $876a70688d8d7977$export$1050f835b63b671e(this, void 0, void 0, function() {
        return $876a70688d8d7977$export$67ebef60e6f28a6(this, function(t) {
            return $6c8154472dd99012$var$ps(e).Nu(), [
                2 /*return*/ 
            ];
        });
    });
}
function $6c8154472dd99012$var$as(e) {
    return $876a70688d8d7977$export$1050f835b63b671e(this, void 0, void 0, function() {
        var n, r, i, o;
        return $876a70688d8d7977$export$67ebef60e6f28a6(this, function(t) {
            // Send the write pipeline now that the stream is established.
            for(n = $6c8154472dd99012$var$ps(e), r = 0, i = e.zu; r < i.length; r++)o = i[r], n.Su(o.mutations);
            return [
                2 /*return*/ 
            ];
        });
    });
}
function $6c8154472dd99012$var$cs(e, n, r) {
    return $876a70688d8d7977$export$1050f835b63b671e(this, void 0, void 0, function() {
        var i, o;
        return $876a70688d8d7977$export$67ebef60e6f28a6(this, function(t) {
            switch(t.label){
                case 0:
                    return i = e.zu.shift(), o = $6c8154472dd99012$var$Jr.from(i, n, r), [
                        4 /*yield*/ ,
                        $6c8154472dd99012$var$rs(e, function() {
                            return e.Gu.ih(o);
                        })
                    ];
                case 1:
                    // It's possible that with the completion of this mutation another
                    // slot has freed up.
                    return t.sent(), [
                        4 /*yield*/ ,
                        $6c8154472dd99012$var$is(e)
                    ];
                case 2:
                    // It's possible that with the completion of this mutation another
                    // slot has freed up.
                    return t.sent(), [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
function $6c8154472dd99012$var$hs(e, n) {
    return $876a70688d8d7977$export$1050f835b63b671e(this, void 0, void 0, function() {
        return $876a70688d8d7977$export$67ebef60e6f28a6(this, function(r) {
            switch(r.label){
                case 0:
                    return n && $6c8154472dd99012$var$ps(e).vu ? [
                        4 /*yield*/ ,
                        function(e, n) {
                            return $876a70688d8d7977$export$1050f835b63b671e(this, void 0, void 0, function() {
                                var r, i;
                                return $876a70688d8d7977$export$67ebef60e6f28a6(this, function(t) {
                                    switch(t.label){
                                        case 0:
                                            return $6c8154472dd99012$var$wt(i = n.code) && i !== $6c8154472dd99012$var$a.ABORTED ? (r = e.zu.shift(), // In this case it's also unlikely that the server itself is melting
                                            // down -- this was just a bad request so inhibit backoff on the next
                                            // restart.
                                            $6c8154472dd99012$var$ps(e).lu(), [
                                                4 /*yield*/ ,
                                                $6c8154472dd99012$var$rs(e, function() {
                                                    return e.Gu.rh(r.batchId, n);
                                                })
                                            ]) : [
                                                3 /*break*/ ,
                                                3
                                            ];
                                        case 1:
                                            // It's possible that with the completion of this mutation
                                            // another slot has freed up.
                                            return t.sent(), [
                                                4 /*yield*/ ,
                                                $6c8154472dd99012$var$is(e)
                                            ];
                                        case 2:
                                            // In this case it's also unlikely that the server itself is melting
                                            // down -- this was just a bad request so inhibit backoff on the next
                                            // restart.
                                            // It's possible that with the completion of this mutation
                                            // another slot has freed up.
                                            t.sent(), t.label = 3;
                                        case 3:
                                            return [
                                                2 /*return*/ 
                                            ];
                                    }
                                });
                            });
                        }(e, n)
                    ] : [
                        3 /*break*/ ,
                        2
                    ];
                // This error affects the actual write.
                case 1:
                    // This error affects the actual write.
                    r.sent(), r.label = 2;
                case 2:
                    // If the write stream closed after the write handshake completes, a write
                    // operation failed and we fail the pending operation.
                    // The write stream might have been started by refilling the write
                    // pipeline for failed writes
                    return $6c8154472dd99012$var$os(e) && $6c8154472dd99012$var$ss(e), [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
/**
 * Toggles the network state when the client gains or loses its primary lease.
 */ function $6c8154472dd99012$var$fs(e, n) {
    return $876a70688d8d7977$export$1050f835b63b671e(this, void 0, void 0, function() {
        var r, i;
        return $876a70688d8d7977$export$67ebef60e6f28a6(this, function(t) {
            switch(t.label){
                case 0:
                    return r = $6c8154472dd99012$var$m(e), n ? (r.Yu.delete(2 /* IsSecondary */ ), [
                        4 /*yield*/ ,
                        $6c8154472dd99012$var$Go(r)
                    ]) : [
                        3 /*break*/ ,
                        2
                    ];
                case 1:
                    return t.sent(), [
                        3 /*break*/ ,
                        5
                    ];
                case 2:
                    return (i = n) ? [
                        3 /*break*/ ,
                        4
                    ] : (r.Yu.add(2 /* IsSecondary */ ), [
                        4 /*yield*/ ,
                        $6c8154472dd99012$var$zo(r)
                    ]);
                case 3:
                    t.sent(), i = r.th.set("Unknown" /* Unknown */ ), t.label = 4;
                case 4:
                    i, t.label = 5;
                case 5:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
/**
 * If not yet initialized, registers the WatchStream and its network state
 * callback with `remoteStoreImpl`. Returns the existing stream if one is
 * already available.
 *
 * PORTING NOTE: On iOS and Android, the WatchStream gets registered on startup.
 * This is not done on Web to allow it to be tree-shaken.
 */ function $6c8154472dd99012$var$ls(e) {
    var n = this;
    return e.oh || // Create stream (but note that it is not started yet).
    (e.oh = function(t, e, n) {
        var r = $6c8154472dd99012$var$m(t);
        return r.xu(), new $6c8154472dd99012$var$Co(e, r.iu, r.credentials, r.serializer, n);
    }(e.Ku, e.cs, {
        gu: $6c8154472dd99012$var$Zo.bind(null, e),
        Tu: $6c8154472dd99012$var$ts.bind(null, e),
        yu: $6c8154472dd99012$var$es.bind(null, e)
    }), e.Ju.push(function(r) {
        return $876a70688d8d7977$export$1050f835b63b671e(n, void 0, void 0, function() {
            return $876a70688d8d7977$export$67ebef60e6f28a6(this, function(t) {
                switch(t.label){
                    case 0:
                        return r ? (e.oh.lu(), $6c8154472dd99012$var$$o(e) ? $6c8154472dd99012$var$Yo(e) : e.th.set("Unknown" /* Unknown */ ), [
                            3 /*break*/ ,
                            3
                        ]) : [
                            3 /*break*/ ,
                            1
                        ];
                    case 1:
                        return [
                            4 /*yield*/ ,
                            e.oh.stop()
                        ];
                    case 2:
                        t.sent(), $6c8154472dd99012$var$Jo(e), t.label = 3;
                    case 3:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    })), e.oh /**
 * If not yet initialized, registers the WriteStream and its network state
 * callback with `remoteStoreImpl`. Returns the existing stream if one is
 * already available.
 *
 * PORTING NOTE: On iOS and Android, the WriteStream gets registered on startup.
 * This is not done on Web to allow it to be tree-shaken.
 */ ;
}
function $6c8154472dd99012$var$ps(e) {
    var n = this;
    return e.ah || // Create stream (but note that it is not started yet).
    (e.ah = function(t, e, n) {
        var r = $6c8154472dd99012$var$m(t);
        return r.xu(), new $6c8154472dd99012$var$Fo(e, r.iu, r.credentials, r.serializer, n);
    }(e.Ku, e.cs, {
        gu: $6c8154472dd99012$var$us.bind(null, e),
        Tu: $6c8154472dd99012$var$hs.bind(null, e),
        Cu: $6c8154472dd99012$var$as.bind(null, e),
        Du: $6c8154472dd99012$var$cs.bind(null, e)
    }), e.Ju.push(function(r) {
        return $876a70688d8d7977$export$1050f835b63b671e(n, void 0, void 0, function() {
            return $876a70688d8d7977$export$67ebef60e6f28a6(this, function(t) {
                switch(t.label){
                    case 0:
                        return r ? (e.ah.lu(), [
                            4 /*yield*/ ,
                            $6c8154472dd99012$var$is(e)
                        ]) : [
                            3 /*break*/ ,
                            2
                        ];
                    case 1:
                        // This will start the write stream if necessary.
                        return t.sent(), [
                            3 /*break*/ ,
                            4
                        ];
                    case 2:
                        return [
                            4 /*yield*/ ,
                            e.ah.stop()
                        ];
                    case 3:
                        t.sent(), e.zu.length > 0 && ($6c8154472dd99012$var$l("RemoteStore", "Stopping write stream with " + e.zu.length + " pending writes"), e.zu = []), t.label = 4;
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    })), e.ah /**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ ;
}
var $6c8154472dd99012$var$ds = function(t) {
    this.key = t;
}, $6c8154472dd99012$var$vs = function(t) {
    this.key = t;
}, $6c8154472dd99012$var$ys = /** @class */ function() {
    function t(t, /** Documents included in the remote target */ e) {
        this.query = t, this.uh = e, this.hh = null, /**
             * A flag whether the view is current with the backend. A view is considered
             * current after it has seen the current flag from the backend and did not
             * lose consistency within the watch stream (e.g. because of an existence
             * filter mismatch).
             */ this.te = !1, /** Documents in the view but not in the remote target */ this.lh = $6c8154472dd99012$var$Ot(), /** Document Keys that have local changes */ this.Wt = $6c8154472dd99012$var$Ot(), this._h = $6c8154472dd99012$var$Xn(t), this.fh = new $6c8154472dd99012$var$Ut(this._h);
    }
    return Object.defineProperty(t.prototype, "dh", {
        /**
         * The set of remote documents that the server has told us belongs to the target associated with
         * this view.
         */ get: function() {
            return this.uh;
        },
        enumerable: !1,
        configurable: !0
    }), /**
     * Iterates over a set of doc changes, applies the query limit, and computes
     * what the new results should be, what the changes were, and whether we may
     * need to go back to the local cache for more results. Does not make any
     * changes to the view.
     * @param docChanges The doc changes to apply to this view.
     * @param previousChanges If this is being called with a refill, then start
     *        with this set of docs and changes instead of the current view.
     * @return a new set of docs, changes, and refill flag.
     */ t.prototype.wh = function(t, e) {
        var n = this, r = e ? e.mh : new $6c8154472dd99012$var$Ct, i = e ? e.fh : this.fh, o = e ? e.Wt : this.Wt, s = i, u = !1, a = $6c8154472dd99012$var$Cn(this.query) && i.size === this.query.limit ? i.last() : null, c = $6c8154472dd99012$var$Fn(this.query) && i.size === this.query.limit ? i.first() : null;
        // Drop documents out to meet limit/limitToLast requirement.
        if (t.ht(function(t, e) {
            var h = i.get(t), f = e instanceof $6c8154472dd99012$var$kn ? e : null;
            f && (f = $6c8154472dd99012$var$$n(n.query, f) ? f : null);
            var l = !!h && n.Wt.has(h.key), p = !!f && (f.Je || // We only consider committed mutations for documents that were
            // mutated during the lifetime of the view.
            n.Wt.has(f.key) && f.hasCommittedMutations), d = !1;
            // Calculate change
            h && f ? h.data().isEqual(f.data()) ? l !== p && (r.track({
                type: 3 /* Metadata */ ,
                doc: f
            }), d = !0) : n.Th(h, f) || (r.track({
                type: 2 /* Modified */ ,
                doc: f
            }), d = !0, (a && n._h(f, a) > 0 || c && n._h(f, c) < 0) && // This doc moved from inside the limit to outside the limit.
            // That means there may be some other doc in the local cache
            // that should be included instead.
            (u = !0)) : !h && f ? (r.track({
                type: 0 /* Added */ ,
                doc: f
            }), d = !0) : h && !f && (r.track({
                type: 1 /* Removed */ ,
                doc: h
            }), d = !0, (a || c) && // A doc was removed from a full limit query. We'll need to
            // requery from the local cache to see if we know about some other
            // doc that should be in the results.
            (u = !0)), d && (f ? (s = s.add(f), o = p ? o.add(t) : o.delete(t)) : (s = s.delete(t), o = o.delete(t)));
        }), $6c8154472dd99012$var$Cn(this.query) || $6c8154472dd99012$var$Fn(this.query)) for(; s.size > this.query.limit;){
            var h = $6c8154472dd99012$var$Cn(this.query) ? s.last() : s.first();
            s = s.delete(h.key), o = o.delete(h.key), r.track({
                type: 1 /* Removed */ ,
                doc: h
            });
        }
        return {
            fh: s,
            mh: r,
            Eh: u,
            Wt: o
        };
    }, t.prototype.Th = function(t, e) {
        // We suppress the initial change event for documents that were modified as
        // part of a write acknowledgment (e.g. when the value of a server transform
        // is applied) as Watch will send us the same document again.
        // By suppressing the event, we only raise two user visible events (one with
        // `hasPendingWrites` and the final state of the document) instead of three
        // (one with `hasPendingWrites`, the modified document with
        // `hasPendingWrites` and the final state of the document).
        return t.Je && e.hasCommittedMutations && !e.Je;
    }, /**
     * Updates the view with the given ViewDocumentChanges and optionally updates
     * limbo docs and sync state from the provided target change.
     * @param docChanges The set of changes to make to the view's docs.
     * @param updateLimboDocuments Whether to update limbo documents based on this
     *        change.
     * @param targetChange A target change to apply for computing limbo docs and
     *        sync state.
     * @return A new ViewChange with the given docs, changes, and sync state.
     */ // PORTING NOTE: The iOS/Android clients always compute limbo document changes.
    t.prototype.yr = function(t, e, n) {
        var r = this, i = this.fh;
        this.fh = t.fh, this.Wt = t.Wt;
        // Sort changes based on type and query comparator
        var o = t.mh.Ut();
        o.sort(function(t, e) {
            return function(t, e) {
                var n = function(t) {
                    switch(t){
                        case 0 /* Added */ :
                            return 1;
                        case 2 /* Modified */ :
                        case 3 /* Metadata */ :
                            // A metadata change is converted to a modified change at the public
                            // api layer.  Since we sort by document key and then change type,
                            // metadata and modified changes must be sorted equivalently.
                            return 2;
                        case 1 /* Removed */ :
                            return 0;
                        default:
                            return $6c8154472dd99012$var$y();
                    }
                };
                return n(t) - n(e);
            }(t.type, e.type) || r._h(t.doc, e.doc);
        }), this.Ih(n);
        var s = e ? this.Ah() : [], u = 0 === this.lh.size && this.te ? 1 /* Synced */  : 0 /* Local */ , a = u !== this.hh;
        return this.hh = u, 0 !== o.length || a ? {
            snapshot: new $6c8154472dd99012$var$Ft(this.query, t.fh, i, o, t.Wt, 0 /* Local */  === u, a, /* excludesMetadataChanges= */ !1),
            Rh: s
        } : {
            Rh: s
        };
    // no changes
    }, /**
     * Applies an OnlineState change to the view, potentially generating a
     * ViewChange if the view's syncState changes as a result.
     */ t.prototype.Qs = function(t) {
        return this.te && "Offline" /* Offline */  === t ? // If we're offline, set `current` to false and then call applyChanges()
        // to refresh our syncState and generate a ViewChange as appropriate. We
        // are guaranteed to get a new TargetChange that sets `current` back to
        // true once the client is back online.
        (this.te = !1, this.yr({
            fh: this.fh,
            mh: new $6c8154472dd99012$var$Ct,
            Wt: this.Wt,
            Eh: !1
        }, /* updateLimboDocuments= */ !1)) : {
            Rh: []
        };
    }, /**
     * Returns whether the doc for the given key should be in limbo.
     */ t.prototype.gh = function(t) {
        // If the remote end says it's part of this query, it's not in limbo.
        return !this.uh.has(t) && // The local store doesn't think it's a result, so it shouldn't be in limbo.
        !!this.fh.has(t) && !this.fh.get(t).Je;
    }, /**
     * Updates syncedDocuments, current, and limbo docs based on the given change.
     * Returns the list of changes to which docs are in limbo.
     */ t.prototype.Ih = function(t) {
        var e = this;
        t && (t.ee.forEach(function(t) {
            return e.uh = e.uh.add(t);
        }), t.ne.forEach(function(t) {}), t.se.forEach(function(t) {
            return e.uh = e.uh.delete(t);
        }), this.te = t.te);
    }, t.prototype.Ah = function() {
        var t = this;
        // We can only determine limbo documents when we're in-sync with the server.
        if (!this.te) return [];
        // TODO(klimt): Do this incrementally so that it's not quadratic when
        // updating many documents.
        var e = this.lh;
        this.lh = $6c8154472dd99012$var$Ot(), this.fh.forEach(function(e) {
            t.gh(e.key) && (t.lh = t.lh.add(e.key));
        });
        // Diff the new limbo docs with the old limbo docs.
        var n = [];
        return e.forEach(function(e) {
            t.lh.has(e) || n.push(new $6c8154472dd99012$var$vs(e));
        }), this.lh.forEach(function(t) {
            e.has(t) || n.push(new $6c8154472dd99012$var$ds(t));
        }), n;
    }, /**
     * Update the in-memory state of the current view with the state read from
     * persistence.
     *
     * We update the query view whenever a client's primary status changes:
     * - When a client transitions from primary to secondary, it can miss
     *   LocalStorage updates and its query views may temporarily not be
     *   synchronized with the state on disk.
     * - For secondary to primary transitions, the client needs to update the list
     *   of `syncedDocuments` since secondary clients update their query views
     *   based purely on synthesized RemoteEvents.
     *
     * @param queryResult.documents - The documents that match the query according
     * to the LocalStore.
     * @param queryResult.remoteKeys - The keys of the documents that match the
     * query according to the backend.
     *
     * @return The ViewChange that resulted from this synchronization.
     */ // PORTING NOTE: Multi-tab only.
    t.prototype.Ph = function(t) {
        this.uh = t.Fc, this.lh = $6c8154472dd99012$var$Ot();
        var e = this.wh(t.documents);
        return this.yr(e, /*updateLimboDocuments=*/ !0);
    }, /**
     * Returns a view snapshot as if this query was just listened to. Contains
     * a document add for every existing document and the `fromCache` and
     * `hasPendingWrites` status of the already established view.
     */ // PORTING NOTE: Multi-tab only.
    t.prototype.yh = function() {
        return $6c8154472dd99012$var$Ft.Gt(this.query, this.fh, this.Wt, 0 /* Local */  === this.hh);
    }, t;
}(), $6c8154472dd99012$var$gs = function(/**
     * The query itself.
     */ t, /**
     * The target number created by the client that is used in the watch
     * stream to identify this query.
     */ e, /**
     * The view is responsible for computing the final merged truth of what
     * docs are in the query. It gets notified of local and remote changes,
     * and applies the query filters and limits to determine the most correct
     * possible results.
     */ n) {
    this.query = t, this.targetId = e, this.view = n;
}, $6c8154472dd99012$var$ms = function(t) {
    this.key = t, /**
             * Set to true once we've received a document. This is used in
             * getRemoteKeysForTarget() and ultimately used by WatchChangeAggregator to
             * decide whether it needs to manufacture a delete event for the target once
             * the target is CURRENT.
             */ this.Vh = !1;
}, $6c8154472dd99012$var$ws = /** @class */ function() {
    function t(t, e, n, // PORTING NOTE: Manages state synchronization in multi-tab environments.
    r, i, o) {
        this.ju = t, this.ph = e, this.bh = n, this.Sh = r, this.currentUser = i, this.Dh = o, this.Ch = {}, this.Nh = new $6c8154472dd99012$var$it(function(t) {
            return $6c8154472dd99012$var$Hn(t);
        }, $6c8154472dd99012$var$Qn), this.Fh = new Map, /**
             * The keys of documents that are in limbo for which we haven't yet started a
             * limbo resolution query.
             */ this.xh = [], /**
             * Keeps track of the target ID for each document that is in limbo with an
             * active target.
             */ this.$h = new $6c8154472dd99012$var$bt($6c8154472dd99012$var$A.i), /**
             * Keeps track of the information about an active limbo resolution for each
             * active target ID that was started for the purpose of limbo resolution.
             */ this.kh = new Map, this.Mh = new $6c8154472dd99012$var$xo, /** Stores user completion handlers, indexed by User and BatchId. */ this.Oh = {}, /** Stores user callbacks waiting for all pending writes to be acknowledged. */ this.Lh = new Map, this.Bh = $6c8154472dd99012$var$ro.da(), this.onlineState = "Unknown" /* Unknown */ , // The primary state is set to `true` or `false` immediately after Firestore
        // startup. In the interim, a client should only be considered primary if
        // `isPrimary` is true.
        this.qh = void 0;
    }
    return Object.defineProperty(t.prototype, "Uh", {
        get: function() {
            return !0 === this.qh;
        },
        enumerable: !1,
        configurable: !0
    }), t;
}();
/**
 * Initiates the new listen, resolves promise when listen enqueued to the
 * server. All the subsequent view snapshots or errors are sent to the
 * subscribed handlers. Returns the initial snapshot.
 */ function $6c8154472dd99012$var$_s(e, n) {
    return $876a70688d8d7977$export$1050f835b63b671e(this, void 0, void 0, function() {
        var r, i, o, s, u, a;
        return $876a70688d8d7977$export$67ebef60e6f28a6(this, function(t) {
            switch(t.label){
                case 0:
                    return r = $6c8154472dd99012$var$Ks(e), (s = r.Nh.get(n)) ? // PORTING NOTE: With Multi-Tab Web, it is possible that a query view
                    // already exists when EventManager calls us for the first time. This
                    // happens when the primary tab is already listening to this query on
                    // behalf of another tab and the user of the primary also starts listening
                    // to the query. EventManager will not have an assigned target ID in this
                    // case and calls `listen` to obtain this ID.
                    (i = s.targetId, r.Sh.Oi(i), o = s.view.yh(), [
                        3 /*break*/ ,
                        4
                    ]) : [
                        3 /*break*/ ,
                        1
                    ];
                case 1:
                    return [
                        4 /*yield*/ ,
                        $6c8154472dd99012$var$Io(r.ju, $6c8154472dd99012$var$zn(n))
                    ];
                case 2:
                    return u = t.sent(), a = r.Sh.Oi(u.targetId), i = u.targetId, [
                        4 /*yield*/ ,
                        $6c8154472dd99012$var$bs(r, n, i, "current" === a)
                    ];
                case 3:
                    o = t.sent(), r.Uh && $6c8154472dd99012$var$Wo(r.ph, u), t.label = 4;
                case 4:
                    return [
                        2 /*return*/ ,
                        o
                    ];
            }
        });
    });
}
/**
 * Registers a view for a previously unknown query and computes its initial
 * snapshot.
 */ function $6c8154472dd99012$var$bs(e, n, r, i) {
    return $876a70688d8d7977$export$1050f835b63b671e(this, void 0, void 0, function() {
        var o, s, u, a, c, h;
        return $876a70688d8d7977$export$67ebef60e6f28a6(this, function(f) {
            switch(f.label){
                case 0:
                    // PORTING NOTE: On Web only, we inject the code that registers new Limbo
                    // targets based on view changes. This allows us to only depend on Limbo
                    // changes when user code includes queries.
                    return e.Qh = function(n, r, i) {
                        return function(e, n, r, i) {
                            return $876a70688d8d7977$export$1050f835b63b671e(this, void 0, void 0, function() {
                                var o, s, u;
                                return $876a70688d8d7977$export$67ebef60e6f28a6(this, function(t) {
                                    switch(t.label){
                                        case 0:
                                            return o = n.view.wh(r), o.Eh ? [
                                                4 /*yield*/ ,
                                                $6c8154472dd99012$var$To(e.ju, n.query, /* usePreviousResults= */ !1).then(function(t) {
                                                    var e = t.documents;
                                                    return n.view.wh(e, o);
                                                })
                                            ] : [
                                                3 /*break*/ ,
                                                2
                                            ];
                                        case 1:
                                            // The query has a limit and some docs were removed, so we need
                                            // to re-run the query against the local store to make sure we
                                            // didn't lose any good docs that had been past the limit.
                                            o = t.sent(), t.label = 2;
                                        case 2:
                                            return s = i && i.zt.get(n.targetId), u = n.view.yr(o, /* updateLimboDocuments= */ e.Uh, s), [
                                                2 /*return*/ ,
                                                ($6c8154472dd99012$var$Rs(e, n.targetId, u.Rh), u.snapshot)
                                            ];
                                    }
                                });
                            });
                        }(e, n, r, i);
                    }, [
                        4 /*yield*/ ,
                        $6c8154472dd99012$var$To(e.ju, n, /* usePreviousResults= */ !0)
                    ];
                case 1:
                    return o = f.sent(), s = new $6c8154472dd99012$var$ys(n, o.Fc), u = s.wh(o.documents), a = $6c8154472dd99012$var$qt.Zt(r, i && "Offline" /* Offline */  !== e.onlineState), c = s.yr(u, /* updateLimboDocuments= */ e.Uh, a), $6c8154472dd99012$var$Rs(e, r, c.Rh), h = new $6c8154472dd99012$var$gs(n, r, s), [
                        2 /*return*/ ,
                        (e.Nh.set(n, h), e.Fh.has(r) ? e.Fh.get(r).push(n) : e.Fh.set(r, [
                            n
                        ]), c.snapshot)
                    ];
            }
        });
    });
}
/** Stops listening to the query. */ function $6c8154472dd99012$var$Is(e, n) {
    return $876a70688d8d7977$export$1050f835b63b671e(this, void 0, void 0, function() {
        var r, i, o;
        return $876a70688d8d7977$export$67ebef60e6f28a6(this, function(t) {
            switch(t.label){
                case 0:
                    return r = $6c8154472dd99012$var$m(e), i = r.Nh.get(n), (o = r.Fh.get(i.targetId)).length > 1 ? [
                        2 /*return*/ ,
                        (r.Fh.set(i.targetId, o.filter(function(t) {
                            return !$6c8154472dd99012$var$Qn(t, n);
                        })), void r.Nh.delete(n))
                    ] : r.Uh ? // We need to remove the local query target first to allow us to verify
                    // whether any other client is still interested in this target.
                    (r.Sh.Bi(i.targetId), r.Sh.Fi(i.targetId) ? [
                        3 /*break*/ ,
                        2
                    ] : [
                        4 /*yield*/ ,
                        $6c8154472dd99012$var$Eo(r.ju, i.targetId, /*keepPersistedTargetData=*/ !1).then(function() {
                            r.Sh.Ui(i.targetId), $6c8154472dd99012$var$Ko(r.ph, i.targetId), $6c8154472dd99012$var$Ls(r, i.targetId);
                        }).catch($6c8154472dd99012$var$Do)
                    ]) : [
                        3 /*break*/ ,
                        3
                    ];
                case 1:
                    t.sent(), t.label = 2;
                case 2:
                    return [
                        3 /*break*/ ,
                        5
                    ];
                case 3:
                    return $6c8154472dd99012$var$Ls(r, i.targetId), [
                        4 /*yield*/ ,
                        $6c8154472dd99012$var$Eo(r.ju, i.targetId, /*keepPersistedTargetData=*/ !0)
                    ];
                case 4:
                    t.sent(), t.label = 5;
                case 5:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
/**
 * Initiates the write of local mutation batch which involves adding the
 * writes to the mutation queue, notifying the remote store about new
 * mutations and raising events for any changes this write caused.
 *
 * The promise returned by this call is resolved when the above steps
 * have completed, *not* when the write was acked by the backend. The
 * userCallback is resolved once the write was acked/rejected by the
 * backend (or failed locally for any other reason).
 */ /**
 * Applies one remote event to the sync engine, notifying any views of the
 * changes, and releasing any pending mutation batches that would become
 * visible because of the snapshot version the remote event contains.
 */ function $6c8154472dd99012$var$Es(e, n) {
    return $876a70688d8d7977$export$1050f835b63b671e(this, void 0, void 0, function() {
        var r, i;
        return $876a70688d8d7977$export$67ebef60e6f28a6(this, function(t) {
            switch(t.label){
                case 0:
                    r = $6c8154472dd99012$var$m(e), t.label = 1;
                case 1:
                    return t.trys.push([
                        1,
                        4,
                        ,
                        6
                    ]), [
                        4 /*yield*/ ,
                        $6c8154472dd99012$var$_o(r.ju, n)
                    ];
                case 2:
                    return i = t.sent(), // Update `receivedDocument` as appropriate for any limbo targets.
                    n.zt.forEach(function(t, e) {
                        var n = r.kh.get(e);
                        n && // Since this is a limbo resolution lookup, it's for a single document
                        // and it could be added, modified, or removed, but not a combination.
                        ($6c8154472dd99012$var$g(t.ee.size + t.ne.size + t.se.size <= 1), t.ee.size > 0 ? n.Vh = !0 : t.ne.size > 0 ? $6c8154472dd99012$var$g(n.Vh) : t.se.size > 0 && ($6c8154472dd99012$var$g(n.Vh), n.Vh = !1));
                    }), [
                        4 /*yield*/ ,
                        $6c8154472dd99012$var$Vs(r, i, n)
                    ];
                case 3:
                    // Update `receivedDocument` as appropriate for any limbo targets.
                    return t.sent(), [
                        3 /*break*/ ,
                        6
                    ];
                case 4:
                    return [
                        4 /*yield*/ ,
                        $6c8154472dd99012$var$Do(t.sent())
                    ];
                case 5:
                    return t.sent(), [
                        3 /*break*/ ,
                        6
                    ];
                case 6:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
/**
 * Applies an OnlineState change to the sync engine and notifies any views of
 * the change.
 */ function $6c8154472dd99012$var$Ts(t, e, n) {
    var r = $6c8154472dd99012$var$m(t);
    // If we are the secondary client, we explicitly ignore the remote store's
    // online state (the local client may go offline, even though the primary
    // tab remains online) and only apply the primary tab's online state from
    // SharedClientState.
    if (r.Uh && 0 /* RemoteStore */  === n || !r.Uh && 1 /* SharedClientState */  === n) {
        var i = [];
        r.Nh.forEach(function(t, n) {
            var r = n.view.Qs(e);
            r.snapshot && i.push(r.snapshot);
        }), function(t, e) {
            var n = $6c8154472dd99012$var$m(t);
            n.onlineState = e;
            var r = !1;
            n.Bs.forEach(function(t, n) {
                for(var i = 0, o = n.listeners; i < o.length; i++)// Run global snapshot listeners if a consistent snapshot has been emitted.
                o[i].Qs(e) && (r = !0);
            }), r && $6c8154472dd99012$var$Cr(n);
        }(r.bh, e), i.length && r.Ch.yu(i), r.onlineState = e, r.Uh && r.Sh.Ki(e);
    }
}
/**
 * Rejects the listen for the given targetID. This can be triggered by the
 * backend for any active target.
 *
 * @param syncEngine The sync engine implementation.
 * @param targetId The targetID corresponds to one previously initiated by the
 * user as part of TargetData passed to listen() on RemoteStore.
 * @param err A description of the condition that has forced the rejection.
 * Nearly always this will be an indication that the user is no longer
 * authorized to see the data matching the target.
 */ function $6c8154472dd99012$var$Ns(e, n, r) {
    return $876a70688d8d7977$export$1050f835b63b671e(this, void 0, void 0, function() {
        var i, o, s, u, a, c;
        return $876a70688d8d7977$export$67ebef60e6f28a6(this, function(t) {
            switch(t.label){
                case 0:
                    // PORTING NOTE: Multi-tab only.
                    return (i = $6c8154472dd99012$var$m(e)).Sh.Qi(n, "rejected", r), o = i.kh.get(n), (s = o && o.key) ? (u = (u = new $6c8154472dd99012$var$bt($6c8154472dd99012$var$A.i)).ot(s, new $6c8154472dd99012$var$Rn(s, $6c8154472dd99012$var$st.min())), a = $6c8154472dd99012$var$Ot().add(s), c = new $6c8154472dd99012$var$Mt($6c8154472dd99012$var$st.min(), /* targetChanges= */ new Map, /* targetMismatches= */ new $6c8154472dd99012$var$Tt($6c8154472dd99012$var$H), u, a), [
                        4 /*yield*/ ,
                        $6c8154472dd99012$var$Es(i, c)
                    ]) : [
                        3 /*break*/ ,
                        2
                    ];
                case 1:
                    return t.sent(), // Since this query failed, we won't want to manually unlisten to it.
                    // We only remove it from bookkeeping after we successfully applied the
                    // RemoteEvent. If `applyRemoteEvent()` throws, we want to re-listen to
                    // this query when the RemoteStore restarts the Watch stream, which should
                    // re-trigger the target failure.
                    i.$h = i.$h.remove(s), i.kh.delete(n), $6c8154472dd99012$var$Ps(i), [
                        3 /*break*/ ,
                        4
                    ];
                case 2:
                    return [
                        4 /*yield*/ ,
                        $6c8154472dd99012$var$Eo(i.ju, n, /* keepPersistedTargetData */ !1).then(function() {
                            return $6c8154472dd99012$var$Ls(i, n, r);
                        }).catch($6c8154472dd99012$var$Do)
                    ];
                case 3:
                    t.sent(), t.label = 4;
                case 4:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
function $6c8154472dd99012$var$As(e, n) {
    return $876a70688d8d7977$export$1050f835b63b671e(this, void 0, void 0, function() {
        var r, i, o;
        return $876a70688d8d7977$export$67ebef60e6f28a6(this, function(t) {
            switch(t.label){
                case 0:
                    r = $6c8154472dd99012$var$m(e), i = n.batch.batchId, t.label = 1;
                case 1:
                    return t.trys.push([
                        1,
                        4,
                        ,
                        6
                    ]), [
                        4 /*yield*/ ,
                        $6c8154472dd99012$var$mo(r.ju, n)
                    ];
                case 2:
                    return o = t.sent(), // The local store may or may not be able to apply the write result and
                    // raise events immediately (depending on whether the watcher is caught
                    // up), so we raise user callbacks first so that they consistently happen
                    // before listen events.
                    $6c8154472dd99012$var$xs(r, i, /*error=*/ null), $6c8154472dd99012$var$Ds(r, i), r.Sh.ki(i, "acknowledged"), [
                        4 /*yield*/ ,
                        $6c8154472dd99012$var$Vs(r, o)
                    ];
                case 3:
                    // The local store may or may not be able to apply the write result and
                    // raise events immediately (depending on whether the watcher is caught
                    // up), so we raise user callbacks first so that they consistently happen
                    // before listen events.
                    return t.sent(), [
                        3 /*break*/ ,
                        6
                    ];
                case 4:
                    return [
                        4 /*yield*/ ,
                        $6c8154472dd99012$var$Do(t.sent())
                    ];
                case 5:
                    return t.sent(), [
                        3 /*break*/ ,
                        6
                    ];
                case 6:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
function $6c8154472dd99012$var$Ss(e, n, r) {
    return $876a70688d8d7977$export$1050f835b63b671e(this, void 0, void 0, function() {
        var i, o;
        return $876a70688d8d7977$export$67ebef60e6f28a6(this, function(t) {
            switch(t.label){
                case 0:
                    i = $6c8154472dd99012$var$m(e), t.label = 1;
                case 1:
                    return t.trys.push([
                        1,
                        4,
                        ,
                        6
                    ]), [
                        4 /*yield*/ ,
                        function(t, e) {
                            var n = $6c8154472dd99012$var$m(t);
                            return n.persistence.runTransaction("Reject batch", "readwrite-primary", function(t) {
                                var r;
                                return n.Sr.Oo(t, e).next(function(e) {
                                    return $6c8154472dd99012$var$g(null !== e), r = e.keys(), n.Sr.Wo(t, e);
                                }).next(function() {
                                    return n.Sr.zo(t);
                                }).next(function() {
                                    return n.Cc.kr(t, r);
                                });
                            });
                        }(i.ju, n)
                    ];
                case 2:
                    return o = t.sent(), // The local store may or may not be able to apply the write result and
                    // raise events immediately (depending on whether the watcher is caught up),
                    // so we raise user callbacks first so that they consistently happen before
                    // listen events.
                    $6c8154472dd99012$var$xs(i, n, r), $6c8154472dd99012$var$Ds(i, n), i.Sh.ki(n, "rejected", r), [
                        4 /*yield*/ ,
                        $6c8154472dd99012$var$Vs(i, o)
                    ];
                case 3:
                    // The local store may or may not be able to apply the write result and
                    // raise events immediately (depending on whether the watcher is caught up),
                    // so we raise user callbacks first so that they consistently happen before
                    // listen events.
                    return t.sent(), [
                        3 /*break*/ ,
                        6
                    ];
                case 4:
                    return [
                        4 /*yield*/ ,
                        $6c8154472dd99012$var$Do(t.sent())
                    ];
                case 5:
                    return t.sent(), [
                        3 /*break*/ ,
                        6
                    ];
                case 6:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
/**
 * Registers a user callback that resolves when all pending mutations at the moment of calling
 * are acknowledged .
 */ /**
 * Triggers the callbacks that are waiting for this batch id to get acknowledged by server,
 * if there are any.
 */ function $6c8154472dd99012$var$Ds(t, e) {
    (t.Lh.get(e) || []).forEach(function(t) {
        t.resolve();
    }), t.Lh.delete(e) /** Reject all outstanding callbacks waiting for pending writes to complete. */ ;
}
function $6c8154472dd99012$var$xs(t, e, n) {
    var r = $6c8154472dd99012$var$m(t), i = r.Oh[r.currentUser.ti()];
    // NOTE: Mutations restored from persistence won't have callbacks, so it's
    // okay for there to be no callback for this ID.
    if (i) {
        var o = i.get(e);
        o && (n ? o.reject(n) : o.resolve(), i = i.remove(e)), r.Oh[r.currentUser.ti()] = i;
    }
}
function $6c8154472dd99012$var$Ls(t, e, n) {
    void 0 === n && (n = null), t.Sh.Bi(e);
    for(var r = 0, i = t.Fh.get(e); r < i.length; r++){
        var o = i[r];
        t.Nh.delete(o), n && t.Ch.Wh(o, n);
    }
    t.Fh.delete(e), t.Uh && t.Mh.Uc(e).forEach(function(e) {
        t.Mh.Ho(e) || // We removed the last reference for this key
        $6c8154472dd99012$var$ks(t, e);
    });
}
function $6c8154472dd99012$var$ks(t, e) {
    // It's possible that the target already got removed because the query failed. In that case,
    // the key won't exist in `limboTargetsByKey`. Only do the cleanup if we still have the target.
    var n = t.$h.get(e);
    null !== n && ($6c8154472dd99012$var$Ko(t.ph, n), t.$h = t.$h.remove(e), t.kh.delete(n), $6c8154472dd99012$var$Ps(t));
}
function $6c8154472dd99012$var$Rs(t, e, n) {
    for(var r = 0, i = n; r < i.length; r++){
        var o = i[r];
        o instanceof $6c8154472dd99012$var$ds ? (t.Mh.Da(o.key, e), $6c8154472dd99012$var$Os(t, o)) : o instanceof $6c8154472dd99012$var$vs ? ($6c8154472dd99012$var$l("SyncEngine", "Document no longer in limbo: " + o.key), t.Mh.Na(o.key, e), t.Mh.Ho(o.key) || // We removed the last reference for this key
        $6c8154472dd99012$var$ks(t, o.key)) : $6c8154472dd99012$var$y();
    }
}
function $6c8154472dd99012$var$Os(t, e) {
    var n = e.key;
    t.$h.get(n) || ($6c8154472dd99012$var$l("SyncEngine", "New document in limbo: " + n), t.xh.push(n), $6c8154472dd99012$var$Ps(t));
}
/**
 * Starts listens for documents in limbo that are enqueued for resolution,
 * subject to a maximum number of concurrent resolutions.
 *
 * Without bounding the number of concurrent resolutions, the server can fail
 * with "resource exhausted" errors which can lead to pathological client
 * behavior as seen in https://github.com/firebase/firebase-js-sdk/issues/2683.
 */ function $6c8154472dd99012$var$Ps(t) {
    for(; t.xh.length > 0 && t.$h.size < t.Dh;){
        var e = t.xh.shift(), n = t.Bh.next();
        t.kh.set(n, new $6c8154472dd99012$var$ms(e)), t.$h = t.$h.ot(e, n), $6c8154472dd99012$var$Wo(t.ph, new $6c8154472dd99012$var$gt($6c8154472dd99012$var$zn($6c8154472dd99012$var$Un(e.path)), n, 2 /* LimboResolution */ , $6c8154472dd99012$var$qr.ai));
    }
}
function $6c8154472dd99012$var$Vs(e, n, r) {
    return $876a70688d8d7977$export$1050f835b63b671e(this, void 0, void 0, function() {
        var i, o, s, u;
        return $876a70688d8d7977$export$67ebef60e6f28a6(this, function(a) {
            switch(a.label){
                case 0:
                    return i = $6c8154472dd99012$var$m(e), o = [], s = [], u = [], i.Nh.m() ? [
                        3 /*break*/ ,
                        3
                    ] : (i.Nh.forEach(function(t, e) {
                        u.push(i.Qh(e, n, r).then(function(t) {
                            if (t) {
                                i.Uh && i.Sh.Qi(e.targetId, t.fromCache ? "not-current" : "current"), o.push(t);
                                var n = $6c8154472dd99012$var$ri.zr(e.targetId, t);
                                s.push(n);
                            }
                        }));
                    }), [
                        4 /*yield*/ ,
                        Promise.all(u)
                    ]);
                case 1:
                    return a.sent(), i.Ch.yu(o), [
                        4 /*yield*/ ,
                        function(e, n) {
                            return $876a70688d8d7977$export$1050f835b63b671e(this, void 0, void 0, function() {
                                var r, i, o, s, u, a, c, h, f;
                                return $876a70688d8d7977$export$67ebef60e6f28a6(this, function(t) {
                                    switch(t.label){
                                        case 0:
                                            r = $6c8154472dd99012$var$m(e), t.label = 1;
                                        case 1:
                                            return t.trys.push([
                                                1,
                                                3,
                                                ,
                                                4
                                            ]), [
                                                4 /*yield*/ ,
                                                r.persistence.runTransaction("notifyLocalViewChanges", "readwrite", function(t) {
                                                    return $6c8154472dd99012$var$yr.forEach(n, function(e) {
                                                        return $6c8154472dd99012$var$yr.forEach(e.Kr, function(n) {
                                                            return r.persistence.No.Da(t, e.targetId, n);
                                                        }).next(function() {
                                                            return $6c8154472dd99012$var$yr.forEach(e.Gr, function(n) {
                                                                return r.persistence.No.Na(t, e.targetId, n);
                                                            });
                                                        });
                                                    });
                                                })
                                            ];
                                        case 2:
                                            return t.sent(), [
                                                3 /*break*/ ,
                                                4
                                            ];
                                        case 3:
                                            if (!$6c8154472dd99012$var$_r(i = t.sent())) throw i;
                                            // If `notifyLocalViewChanges` fails, we did not advance the sequence
                                            // number for the documents that were included in this transaction.
                                            // This might trigger them to be deleted earlier than they otherwise
                                            // would have, but it should not invalidate the integrity of the data.
                                            return $6c8154472dd99012$var$l("LocalStore", "Failed to update sequence numbers: " + i), [
                                                3 /*break*/ ,
                                                4
                                            ];
                                        case 4:
                                            for(o = 0, s = n; o < s.length; o++)u = s[o], a = u.targetId, u.fromCache || (c = r.bc.get(a), h = c.nt, f = c.rt(h), // Advance the last limbo free snapshot version
                                            r.bc = r.bc.ot(a, f));
                                            return [
                                                2 /*return*/ 
                                            ];
                                    }
                                });
                            });
                        }(i.ju, s)
                    ];
                case 2:
                    a.sent(), a.label = 3;
                case 3:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
function $6c8154472dd99012$var$Us(e, n) {
    return $876a70688d8d7977$export$1050f835b63b671e(this, void 0, void 0, function() {
        var r, i;
        return $876a70688d8d7977$export$67ebef60e6f28a6(this, function(o) {
            switch(o.label){
                case 0:
                    return (r = $6c8154472dd99012$var$m(e)).currentUser.isEqual(n) ? [
                        3 /*break*/ ,
                        3
                    ] : ($6c8154472dd99012$var$l("SyncEngine", "User change. New user:", n.ti()), [
                        4 /*yield*/ ,
                        /**
                 * Tells the LocalStore that the currently authenticated user has changed.
                 *
                 * In response the local store switches the mutation queue to the new user and
                 * returns any resulting document changes.
                 */ // PORTING NOTE: Android and iOS only return the documents affected by the
                        // change.
                        function(e, n) {
                            return $876a70688d8d7977$export$1050f835b63b671e(this, void 0, void 0, function() {
                                var r, i, o, s;
                                return $876a70688d8d7977$export$67ebef60e6f28a6(this, function(t) {
                                    switch(t.label){
                                        case 0:
                                            return r = $6c8154472dd99012$var$m(e), i = r.Sr, o = r.Cc, [
                                                4 /*yield*/ ,
                                                r.persistence.runTransaction("Handle user change", "readonly", function(t) {
                                                    // Swap out the mutation queue, grabbing the pending mutation batches
                                                    // before and after.
                                                    var e;
                                                    return r.Sr.Uo(t).next(function(s) {
                                                        return e = s, i = r.persistence.mc(n), // Recreate our LocalDocumentsView using the new
                                                        // MutationQueue.
                                                        o = new $6c8154472dd99012$var$ni(r.Dc, i, r.persistence.Ic()), i.Uo(t);
                                                    }).next(function(n) {
                                                        for(var r = [], i = [], s = $6c8154472dd99012$var$Ot(), u = 0, a = e; u < a.length; u++){
                                                            var c = a[u];
                                                            r.push(c.batchId);
                                                            for(var h = 0, f = c.mutations; h < f.length; h++){
                                                                var l = f[h];
                                                                s = s.add(l.key);
                                                            }
                                                        }
                                                        for(var p = 0, d = n; p < d.length; p++){
                                                            var v = d[p];
                                                            i.push(v.batchId);
                                                            for(var y = 0, g = v.mutations; y < g.length; y++){
                                                                var m = g[y];
                                                                s = s.add(m.key);
                                                            }
                                                        }
                                                        // Return the set of all (potentially) changed documents and the list
                                                        // of mutation batch IDs that were affected by change.
                                                        return o.kr(t, s).next(function(t) {
                                                            return {
                                                                jh: t,
                                                                Kh: r,
                                                                Gh: i
                                                            };
                                                        });
                                                    });
                                                })
                                            ];
                                        case 1:
                                            return s = t.sent(), [
                                                2 /*return*/ ,
                                                (r.Sr = i, r.Cc = o, r.Vc.Nc(r.Cc), s)
                                            ];
                                    }
                                });
                            });
                        }(r.ju, n)
                    ]);
                case 1:
                    return i = o.sent(), r.currentUser = n, // Fails tasks waiting for pending writes requested by previous user.
                    function(t, e) {
                        t.Lh.forEach(function(t) {
                            t.forEach(function(t) {
                                t.reject(new $6c8154472dd99012$var$c($6c8154472dd99012$var$a.CANCELLED, "'waitForPendingWrites' promise is rejected due to a user change."));
                            });
                        }), t.Lh.clear();
                    }(r), // TODO(b/114226417): Consider calling this only in the primary tab.
                    r.Sh.ji(n, i.Kh, i.Gh), [
                        4 /*yield*/ ,
                        $6c8154472dd99012$var$Vs(r, i.jh)
                    ];
                case 2:
                    o.sent(), o.label = 3;
                case 3:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
function $6c8154472dd99012$var$Cs(t, e) {
    var n = $6c8154472dd99012$var$m(t), r = n.kh.get(e);
    if (r && r.Vh) return $6c8154472dd99012$var$Ot().add(r.key);
    var i = $6c8154472dd99012$var$Ot(), o = n.Fh.get(e);
    if (!o) return i;
    for(var s = 0, u = o; s < u.length; s++){
        var a = u[s], c = n.Nh.get(a);
        i = i.kt(c.view.dh);
    }
    return i;
}
/**
 * Reconcile the list of synced documents in an existing view with those
 * from persistence.
 */ function $6c8154472dd99012$var$Fs(e, n) {
    return $876a70688d8d7977$export$1050f835b63b671e(this, void 0, void 0, function() {
        var r, i, o;
        return $876a70688d8d7977$export$67ebef60e6f28a6(this, function(t) {
            switch(t.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        $6c8154472dd99012$var$To((r = $6c8154472dd99012$var$m(e)).ju, n.query, /* usePreviousResults= */ !0)
                    ];
                case 1:
                    return i = t.sent(), o = n.view.Ph(i), [
                        2 /*return*/ ,
                        (r.Uh && $6c8154472dd99012$var$Rs(r, n.targetId, o.Rh), o)
                    ];
            }
        });
    });
}
/** Applies a mutation state to an existing batch.  */ // PORTING NOTE: Multi-Tab only.
function $6c8154472dd99012$var$Ms(e, n, r, i) {
    return $876a70688d8d7977$export$1050f835b63b671e(this, void 0, void 0, function() {
        var o, s;
        return $876a70688d8d7977$export$67ebef60e6f28a6(this, function(t) {
            switch(t.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        function(t, e) {
                            var n = $6c8154472dd99012$var$m(t), r = $6c8154472dd99012$var$m(n.Sr);
                            return n.persistence.runTransaction("Lookup mutation documents", "readonly", function(t) {
                                return r.Lo(t, e).next(function(e) {
                                    return e ? n.Cc.kr(t, e) : $6c8154472dd99012$var$yr.resolve(null);
                                });
                            });
                        }((o = $6c8154472dd99012$var$m(e)).ju, n)
                    ];
                case 1:
                    return null === (s = t.sent()) ? [
                        3 /*break*/ ,
                        6
                    ] : "pending" !== r ? [
                        3 /*break*/ ,
                        3
                    ] : [
                        4 /*yield*/ ,
                        $6c8154472dd99012$var$is(o.ph)
                    ];
                case 2:
                    // If we are the primary client, we need to send this write to the
                    // backend. Secondary clients will ignore these writes since their remote
                    // connection is disabled.
                    return t.sent(), [
                        3 /*break*/ ,
                        4
                    ];
                case 3:
                    "acknowledged" === r || "rejected" === r ? // NOTE: Both these methods are no-ops for batches that originated from
                    // other clients.
                    ($6c8154472dd99012$var$xs(o, n, i || null), $6c8154472dd99012$var$Ds(o, n), function(t, e) {
                        $6c8154472dd99012$var$m($6c8154472dd99012$var$m(t).Sr).Ko(e);
                    }(o.ju, n)) : $6c8154472dd99012$var$y(), t.label = 4;
                case 4:
                    return [
                        4 /*yield*/ ,
                        $6c8154472dd99012$var$Vs(o, s)
                    ];
                case 5:
                    return t.sent(), [
                        3 /*break*/ ,
                        7
                    ];
                case 6:
                    // A throttled tab may not have seen the mutation before it was completed
                    // and removed from the mutation queue, in which case we won't have cached
                    // the affected documents. In this case we can safely ignore the update
                    // since that means we didn't apply the mutation locally at all (if we
                    // had, we would have cached the affected documents), and so we will just
                    // see any resulting document changes via normal remote document updates
                    // as applicable.
                    $6c8154472dd99012$var$l("SyncEngine", "Cannot apply mutation batch with id: " + n), t.label = 7;
                case 7:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
/** Applies a query target change from a different tab. */ // PORTING NOTE: Multi-Tab only.
function $6c8154472dd99012$var$qs(e, n) {
    return $876a70688d8d7977$export$1050f835b63b671e(this, void 0, void 0, function() {
        var r, i, o, s, u, a, c, h;
        return $876a70688d8d7977$export$67ebef60e6f28a6(this, function(t) {
            switch(t.label){
                case 0:
                    return $6c8154472dd99012$var$Ks(r = $6c8154472dd99012$var$m(e)), $6c8154472dd99012$var$Qs(r), !0 !== n || !0 === r.qh ? [
                        3 /*break*/ ,
                        3
                    ] : (i = r.Sh.Ci(), [
                        4 /*yield*/ ,
                        $6c8154472dd99012$var$js(r, i.A())
                    ]);
                case 1:
                    return o = t.sent(), r.qh = !0, [
                        4 /*yield*/ ,
                        $6c8154472dd99012$var$fs(r.ph, !0)
                    ];
                case 2:
                    for(t.sent(), s = 0, u = o; s < u.length; s++)a = u[s], $6c8154472dd99012$var$Wo(r.ph, a);
                    return [
                        3 /*break*/ ,
                        7
                    ];
                case 3:
                    return !1 !== n || !1 === r.qh ? [
                        3 /*break*/ ,
                        7
                    ] : (c = [], h = Promise.resolve(), r.Fh.forEach(function(t, e) {
                        r.Sh.qi(e) ? c.push(e) : h = h.then(function() {
                            return $6c8154472dd99012$var$Ls(r, e), $6c8154472dd99012$var$Eo(r.ju, e, /*keepPersistedTargetData=*/ !0);
                        }), $6c8154472dd99012$var$Ko(r.ph, e);
                    }), [
                        4 /*yield*/ ,
                        h
                    ]);
                case 4:
                    return t.sent(), [
                        4 /*yield*/ ,
                        $6c8154472dd99012$var$js(r, c)
                    ];
                case 5:
                    return t.sent(), // PORTING NOTE: Multi-Tab only.
                    function(t) {
                        var e = $6c8154472dd99012$var$m(t);
                        e.kh.forEach(function(t, n) {
                            $6c8154472dd99012$var$Ko(e.ph, n);
                        }), e.Mh.Qc(), e.kh = new Map, e.$h = new $6c8154472dd99012$var$bt($6c8154472dd99012$var$A.i);
                    }(r), r.qh = !1, [
                        4 /*yield*/ ,
                        $6c8154472dd99012$var$fs(r.ph, !1)
                    ];
                case 6:
                    t.sent(), t.label = 7;
                case 7:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
function $6c8154472dd99012$var$js(e, n, r) {
    return $876a70688d8d7977$export$1050f835b63b671e(this, void 0, void 0, function() {
        var r, i, o, s, u, a, c, h, f, l, p, d, v, y;
        return $876a70688d8d7977$export$67ebef60e6f28a6(this, function(t) {
            switch(t.label){
                case 0:
                    r = $6c8154472dd99012$var$m(e), i = [], o = [], s = 0, u = n, t.label = 1;
                case 1:
                    return s < u.length ? (a = u[s], c = void 0, (h = r.Fh.get(a)) && 0 !== h.length ? [
                        4 /*yield*/ ,
                        $6c8154472dd99012$var$Io(r.ju, $6c8154472dd99012$var$zn(h[0]))
                    ] : [
                        3 /*break*/ ,
                        7
                    ]) : [
                        3 /*break*/ ,
                        13
                    ];
                case 2:
                    // For queries that have a local View, we fetch their current state
                    // from LocalStore (as the resume token and the snapshot version
                    // might have changed) and reconcile their views with the persisted
                    // state (the list of syncedDocuments may have gotten out of sync).
                    c = t.sent(), f = 0, l = h, t.label = 3;
                case 3:
                    return f < l.length ? (p = l[f], d = r.Nh.get(p), [
                        4 /*yield*/ ,
                        $6c8154472dd99012$var$Fs(r, d)
                    ]) : [
                        3 /*break*/ ,
                        6
                    ];
                case 4:
                    (v = t.sent()).snapshot && o.push(v.snapshot), t.label = 5;
                case 5:
                    return f++, [
                        3 /*break*/ ,
                        3
                    ];
                case 6:
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 7:
                    return [
                        4 /*yield*/ ,
                        $6c8154472dd99012$var$No(r.ju, a)
                    ];
                case 8:
                    return y = t.sent(), [
                        4 /*yield*/ ,
                        $6c8154472dd99012$var$Io(r.ju, y)
                    ];
                case 9:
                    return c = t.sent(), [
                        4 /*yield*/ ,
                        $6c8154472dd99012$var$bs(r, $6c8154472dd99012$var$Gs(y), a, /*current=*/ !1)
                    ];
                case 10:
                    t.sent(), t.label = 11;
                case 11:
                    i.push(c), t.label = 12;
                case 12:
                    return s++, [
                        3 /*break*/ ,
                        1
                    ];
                case 13:
                    return [
                        2 /*return*/ ,
                        (r.Ch.yu(o), i)
                    ];
            }
        });
    });
}
/**
 * Creates a `Query` object from the specified `Target`. There is no way to
 * obtain the original `Query`, so we synthesize a `Query` from the `Target`
 * object.
 *
 * The synthesized result might be different from the original `Query`, but
 * since the synthesized `Query` should return the same results as the
 * original one (only the presentation of results might differ), the potential
 * difference will not cause issues.
 */ // PORTING NOTE: Multi-Tab only.
function $6c8154472dd99012$var$Gs(t) {
    return $6c8154472dd99012$var$Vn(t.path, t.collectionGroup, t.orderBy, t.filters, t.limit, "F" /* First */ , t.startAt, t.endAt);
}
/** Returns the IDs of the clients that are currently active. */ // PORTING NOTE: Multi-Tab only.
function $6c8154472dd99012$var$zs(t) {
    var e = $6c8154472dd99012$var$m(t);
    return $6c8154472dd99012$var$m($6c8154472dd99012$var$m(e.ju).persistence).pi();
}
/** Applies a query target change from a different tab. */ // PORTING NOTE: Multi-Tab only.
function $6c8154472dd99012$var$Bs(e, n, r, i) {
    return $876a70688d8d7977$export$1050f835b63b671e(this, void 0, void 0, function() {
        var o, s, u;
        return $876a70688d8d7977$export$67ebef60e6f28a6(this, function(t) {
            switch(t.label){
                case 0:
                    return (o = $6c8154472dd99012$var$m(e)).qh ? // If we receive a target state notification via WebStorage, we are
                    // either already secondary or another tab has taken the primary lease.
                    ($6c8154472dd99012$var$l("SyncEngine", "Ignoring unexpected query state notification."), [
                        3 /*break*/ ,
                        8
                    ]) : [
                        3 /*break*/ ,
                        1
                    ];
                case 1:
                    if (!o.Fh.has(n)) return [
                        3 /*break*/ ,
                        8
                    ];
                    switch(r){
                        case "current":
                        case "not-current":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "rejected":
                            return [
                                3 /*break*/ ,
                                5
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        7
                    ];
                case 2:
                    return [
                        4 /*yield*/ ,
                        $6c8154472dd99012$var$Ao(o.ju)
                    ];
                case 3:
                    return s = t.sent(), u = $6c8154472dd99012$var$Mt.Xt(n, "current" === r), [
                        4 /*yield*/ ,
                        $6c8154472dd99012$var$Vs(o, s, u)
                    ];
                case 4:
                    return t.sent(), [
                        3 /*break*/ ,
                        8
                    ];
                case 5:
                    return [
                        4 /*yield*/ ,
                        $6c8154472dd99012$var$Eo(o.ju, n, /* keepPersistedTargetData */ !0)
                    ];
                case 6:
                    return t.sent(), $6c8154472dd99012$var$Ls(o, n, i), [
                        3 /*break*/ ,
                        8
                    ];
                case 7:
                    $6c8154472dd99012$var$y(), t.label = 8;
                case 8:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
/** Adds or removes Watch targets for queries from different tabs. */ function $6c8154472dd99012$var$Ws(e, n, r) {
    return $876a70688d8d7977$export$1050f835b63b671e(this, void 0, void 0, function() {
        var i, o, s, u, a, c, h, f, p, d;
        return $876a70688d8d7977$export$67ebef60e6f28a6(this, function(v) {
            switch(v.label){
                case 0:
                    if (!(i = $6c8154472dd99012$var$Ks(e)).qh) return [
                        3 /*break*/ ,
                        10
                    ];
                    o = 0, s = n, v.label = 1;
                case 1:
                    return o < s.length ? (u = s[o], i.Fh.has(u) ? // A target might have been added in a previous attempt
                    ($6c8154472dd99012$var$l("SyncEngine", "Adding an already active target " + u), [
                        3 /*break*/ ,
                        5
                    ]) : [
                        4 /*yield*/ ,
                        $6c8154472dd99012$var$No(i.ju, u)
                    ]) : [
                        3 /*break*/ ,
                        6
                    ];
                case 2:
                    return a = v.sent(), [
                        4 /*yield*/ ,
                        $6c8154472dd99012$var$Io(i.ju, a)
                    ];
                case 3:
                    return c = v.sent(), [
                        4 /*yield*/ ,
                        $6c8154472dd99012$var$bs(i, $6c8154472dd99012$var$Gs(a), c.targetId, /*current=*/ !1)
                    ];
                case 4:
                    v.sent(), $6c8154472dd99012$var$Wo(i.ph, c), v.label = 5;
                case 5:
                    return o++, [
                        3 /*break*/ ,
                        1
                    ];
                case 6:
                    h = function(e) {
                        return $876a70688d8d7977$export$67ebef60e6f28a6(this, function(t) {
                            switch(t.label){
                                case 0:
                                    return i.Fh.has(e) ? [
                                        4 /*yield*/ ,
                                        $6c8154472dd99012$var$Eo(i.ju, e, /* keepPersistedTargetData */ !1).then(function() {
                                            $6c8154472dd99012$var$Ko(i.ph, e), $6c8154472dd99012$var$Ls(i, e);
                                        }).catch($6c8154472dd99012$var$Do)
                                    ] : [
                                        3 /*break*/ ,
                                        2
                                    ];
                                // Release queries that are still active.
                                case 1:
                                    // Release queries that are still active.
                                    t.sent(), t.label = 2;
                                case 2:
                                    return [
                                        2 /*return*/ 
                                    ];
                            }
                        });
                    }, f = 0, p = r, v.label = 7;
                case 7:
                    return f < p.length ? (d = p[f], [
                        5 /*yield**/ ,
                        h(d)
                    ]) : [
                        3 /*break*/ ,
                        10
                    ];
                case 8:
                    v.sent(), v.label = 9;
                case 9:
                    return f++, [
                        3 /*break*/ ,
                        7
                    ];
                case 10:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
function $6c8154472dd99012$var$Ks(t) {
    var e = $6c8154472dd99012$var$m(t);
    return e.ph.Gu.sh = $6c8154472dd99012$var$Es.bind(null, e), e.ph.Gu.qe = $6c8154472dd99012$var$Cs.bind(null, e), e.ph.Gu.nh = $6c8154472dd99012$var$Ns.bind(null, e), e.Ch.yu = $6c8154472dd99012$var$Vr.bind(null, e.bh), e.Ch.Wh = $6c8154472dd99012$var$Ur.bind(null, e.bh), e;
}
function $6c8154472dd99012$var$Qs(t) {
    var e = $6c8154472dd99012$var$m(t);
    return e.ph.Gu.ih = $6c8154472dd99012$var$As.bind(null, e), e.ph.Gu.rh = $6c8154472dd99012$var$Ss.bind(null, e), e;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // TOOD(b/140938512): Drop SimpleQueryEngine and rename IndexFreeQueryEngine.
/**
 * A query engine that takes advantage of the target document mapping in the
 * QueryCache. The IndexFreeQueryEngine optimizes query execution by only
 * reading the documents that previously matched a query plus any documents that were
 * edited after the query was last listened to.
 *
 * There are some cases where Index-Free queries are not guaranteed to produce
 * the same results as full collection scans. In these cases, the
 * IndexFreeQueryEngine falls back to full query processing. These cases are:
 *
 * - Limit queries where a document that matched the query previously no longer
 *   matches the query.
 *
 * - Limit queries where a document edit may cause the document to sort below
 *   another document that is in the local cache.
 *
 * - Queries that have never been CURRENT or free of Limbo documents.
 */ var $6c8154472dd99012$var$Hs = /** @class */ function() {
    function t() {}
    return t.prototype.Nc = function(t) {
        this.zh = t;
    }, t.prototype.Lr = function(t, e, r, i) {
        var o = this;
        // Queries that match all documents don't benefit from using
        // IndexFreeQueries. It is more efficient to scan all documents in a
        // collection, rather than to perform individual lookups.
        return function(t) {
            return 0 === t.filters.length && null === t.limit && null == t.startAt && null == t.endAt && (0 === t.on.length || 1 === t.on.length && t.on[0].field.p());
        }(e) || r.isEqual($6c8154472dd99012$var$st.min()) ? this.Hh(t, e) : this.zh.kr(t, i).next(function(s) {
            var u = o.Yh(e, s);
            return ($6c8154472dd99012$var$Cn(e) || $6c8154472dd99012$var$Fn(e)) && o.Eh(e.an, u, i, r) ? o.Hh(t, e) : ($6c8154472dd99012$var$f() <= $d4M6f.LogLevel.DEBUG && $6c8154472dd99012$var$l("IndexFreeQueryEngine", "Re-using previous result from %s to execute query: %s", r.toString(), $6c8154472dd99012$var$Yn(e)), o.zh.Lr(t, e, r).next(function(t) {
                // We merge `previousResults` into `updateResults`, since
                // `updateResults` is already a DocumentMap. If a document is
                // contained in both lists, then its contents are the same.
                return u.forEach(function(e) {
                    t = t.ot(e.key, e);
                }), t;
            }));
        });
    // Queries that have never seen a snapshot without limbo free documents
    // should also be run as a full collection scan.
    }, /** Applies the query filter and sorting to the provided documents.  */ t.prototype.Yh = function(t, e) {
        // Sort the documents and re-apply the query filter since previously
        // matching documents do not necessarily still match the query.
        var n = new $6c8154472dd99012$var$Tt($6c8154472dd99012$var$Xn(t));
        return e.forEach(function(e, r) {
            r instanceof $6c8154472dd99012$var$kn && $6c8154472dd99012$var$$n(t, r) && (n = n.add(r));
        }), n;
    }, /**
     * Determines if a limit query needs to be refilled from cache, making it
     * ineligible for index-free execution.
     *
     * @param sortedPreviousResults The documents that matched the query when it
     * was last synchronized, sorted by the query's comparator.
     * @param remoteKeys The document keys that matched the query at the last
     * snapshot.
     * @param limboFreeSnapshotVersion The version of the snapshot when the query
     * was last synchronized.
     */ t.prototype.Eh = function(t, e, n, r) {
        // The query needs to be refilled if a previously matching document no
        // longer matches.
        if (n.size !== e.size) return !0;
        // Limit queries are not eligible for index-free query execution if there is
        // a potential that an older document from cache now sorts before a document
        // that was previously part of the limit. This, however, can only happen if
        // the document at the edge of the limit goes out of limit.
        // If a document that is not the limit boundary sorts differently,
        // the boundary of the limit itself did not change and documents from cache
        // will continue to be "rejected" by this boundary. Therefore, we can ignore
        // any modifications that don't affect the last document.
        var i = "F" /* First */  === t ? e.last() : e.first();
        return !!i && (i.hasPendingWrites || i.version.L(r) > 0);
    }, t.prototype.Hh = function(t, e) {
        return $6c8154472dd99012$var$f() <= $d4M6f.LogLevel.DEBUG && $6c8154472dd99012$var$l("IndexFreeQueryEngine", "Using full collection scan to execute query:", $6c8154472dd99012$var$Yn(e)), this.zh.Lr(t, e, $6c8154472dd99012$var$st.min());
    }, t;
}(), $6c8154472dd99012$var$Ys = /** @class */ function() {
    function t(t, e) {
        this.Dr = t, this.No = e, /**
             * The set of all mutations that have been sent but not yet been applied to
             * the backend.
             */ this.Sr = [], /** Next value to use when assigning sequential IDs to each mutation batch. */ this.Jh = 1, /** An ordered mapping between documents and the mutations batch IDs. */ this.Xh = new $6c8154472dd99012$var$Tt($6c8154472dd99012$var$Lo.kc);
    }
    return t.prototype.$o = function(t) {
        return $6c8154472dd99012$var$yr.resolve(0 === this.Sr.length);
    }, t.prototype.ko = function(t, e, n, r) {
        var i = this.Jh;
        this.Jh++, this.Sr.length > 0 && this.Sr[this.Sr.length - 1];
        var o = new $6c8154472dd99012$var$Xr(i, e, n, r);
        this.Sr.push(o);
        // Track references by document key and index collection parents.
        for(var s = 0, u = r; s < u.length; s++){
            var a = u[s];
            this.Xh = this.Xh.add(new $6c8154472dd99012$var$Lo(a.key, i)), this.Dr.Mo(t, a.key.path.h());
        }
        return $6c8154472dd99012$var$yr.resolve(o);
    }, t.prototype.Oo = function(t, e) {
        return $6c8154472dd99012$var$yr.resolve(this.Zh(e));
    }, t.prototype.Bo = function(t, e) {
        var n = e + 1, r = this.tl(n), i = r < 0 ? 0 : r;
        // The requested batchId may still be out of range so normalize it to the
        // start of the queue.
        return $6c8154472dd99012$var$yr.resolve(this.Sr.length > i ? this.Sr[i] : null);
    }, t.prototype.qo = function() {
        return $6c8154472dd99012$var$yr.resolve(0 === this.Sr.length ? -1 : this.Jh - 1);
    }, t.prototype.Uo = function(t) {
        return $6c8154472dd99012$var$yr.resolve(this.Sr.slice());
    }, t.prototype.Nr = function(t, e) {
        var n = this, r = new $6c8154472dd99012$var$Lo(e, 0), i = new $6c8154472dd99012$var$Lo(e, Number.POSITIVE_INFINITY), o = [];
        return this.Xh.Ft([
            r,
            i
        ], function(t) {
            var e = n.Zh(t.jc);
            o.push(e);
        }), $6c8154472dd99012$var$yr.resolve(o);
    }, t.prototype.Or = function(t, e) {
        var n = this, r = new $6c8154472dd99012$var$Tt($6c8154472dd99012$var$H);
        return e.forEach(function(t) {
            var e = new $6c8154472dd99012$var$Lo(t, 0), i = new $6c8154472dd99012$var$Lo(t, Number.POSITIVE_INFINITY);
            n.Xh.Ft([
                e,
                i
            ], function(t) {
                r = r.add(t.jc);
            });
        }), $6c8154472dd99012$var$yr.resolve(this.el(r));
    }, t.prototype.Wr = function(t, e) {
        // Use the query path as a prefix for testing if a document matches the
        // query.
        var n = e.path, r = n.length + 1, i = n;
        // Construct a document reference for actually scanning the index. Unlike
        // the prefix the document key in this reference must have an even number of
        // segments. The empty segment can be used a suffix of the query path
        // because it precedes all other segments in an ordered traversal.
        $6c8154472dd99012$var$A.F(i) || (i = i.child(""));
        var o = new $6c8154472dd99012$var$Lo(new $6c8154472dd99012$var$A(i), 0), s = new $6c8154472dd99012$var$Tt($6c8154472dd99012$var$H);
        // Find unique batchIDs referenced by all documents potentially matching the
        // query.
        return this.Xh.xt(function(t) {
            var e = t.key.path;
            return !!n.T(e) && // Rows with document keys more than one segment longer than the query
            // path can't be matches. For example, a query on 'rooms' can't match
            // the document /rooms/abc/messages/xyx.
            // TODO(mcg): we'll need a different scanner when we implement
            // ancestor queries.
            (e.length === r && (s = s.add(t.jc)), !0);
        }, o), $6c8154472dd99012$var$yr.resolve(this.el(s));
    }, t.prototype.el = function(t) {
        var e = this, n = [];
        // Construct an array of matching batches, sorted by batchID to ensure that
        // multiple mutations affecting the same document key are applied in order.
        return t.forEach(function(t) {
            var r = e.Zh(t);
            null !== r && n.push(r);
        }), n;
    }, t.prototype.Wo = function(t, e) {
        var n = this;
        $6c8154472dd99012$var$g(0 === this.nl(e.batchId, "removed")), this.Sr.shift();
        var r = this.Xh;
        return $6c8154472dd99012$var$yr.forEach(e.mutations, function(i) {
            var o = new $6c8154472dd99012$var$Lo(i.key, e.batchId);
            return r = r.delete(o), n.No.Go(t, i.key);
        }).next(function() {
            n.Xh = r;
        });
    }, t.prototype.Ko = function(t) {
    // No-op since the memory mutation queue does not maintain a separate cache.
    }, t.prototype.Ho = function(t, e) {
        var n = new $6c8154472dd99012$var$Lo(e, 0), r = this.Xh.$t(n);
        return $6c8154472dd99012$var$yr.resolve(e.isEqual(r && r.key));
    }, t.prototype.zo = function(t) {
        return this.Sr.length, $6c8154472dd99012$var$yr.resolve();
    }, /**
     * Finds the index of the given batchId in the mutation queue and asserts that
     * the resulting index is within the bounds of the queue.
     *
     * @param batchId The batchId to search for
     * @param action A description of what the caller is doing, phrased in passive
     * form (e.g. "acknowledged" in a routine that acknowledges batches).
     */ t.prototype.nl = function(t, e) {
        return this.tl(t);
    }, /**
     * Finds the index of the given batchId in the mutation queue. This operation
     * is O(1).
     *
     * @return The computed index of the batch with the given batchId, based on
     * the state of the queue. Note this index can be negative if the requested
     * batchId has already been remvoed from the queue or past the end of the
     * queue if the batchId is larger than the last added batch.
     */ t.prototype.tl = function(t) {
        return 0 === this.Sr.length ? 0 : t - this.Sr[0].batchId;
    // Examine the front of the queue to figure out the difference between the
    // batchId and indexes in the array. Note that since the queue is ordered
    // by batchId, if the first batch has a larger batchId then the requested
    // batchId doesn't exist in the queue.
    }, /**
     * A version of lookupMutationBatch that doesn't return a promise, this makes
     * other functions that uses this code easier to read and more efficent.
     */ t.prototype.Zh = function(t) {
        var e = this.tl(t);
        return e < 0 || e >= this.Sr.length ? null : this.Sr[e];
    }, t;
}(), $6c8154472dd99012$var$$s = /** @class */ function() {
    /**
     * @param sizer Used to assess the size of a document. For eager GC, this is expected to just
     * return 0 to avoid unnecessarily doing the work of calculating the size.
     */ function t(t, e) {
        this.Dr = t, this.sl = e, /** Underlying cache of documents and their read times. */ this.docs = new $6c8154472dd99012$var$bt($6c8154472dd99012$var$A.i), /** Size of all cached documents. */ this.size = 0 /**
     * Adds the supplied entry to the cache and updates the cache size as appropriate.
     *
     * All calls of `addEntry`  are required to go through the RemoteDocumentChangeBuffer
     * returned by `newChangeBuffer()`.
     */ ;
    }
    return t.prototype.Er = function(t, e, n) {
        var r = e.key, i = this.docs.get(r), o = i ? i.size : 0, s = this.sl(e);
        return this.docs = this.docs.ot(r, {
            ta: e,
            size: s,
            readTime: n
        }), this.size += s - o, this.Dr.Mo(t, r.path.h());
    }, /**
     * Removes the specified entry from the cache and updates the cache size as appropriate.
     *
     * All calls of `removeEntry` are required to go through the RemoteDocumentChangeBuffer
     * returned by `newChangeBuffer()`.
     */ t.prototype.Ar = function(t) {
        var e = this.docs.get(t);
        e && (this.docs = this.docs.remove(t), this.size -= e.size);
    }, t.prototype.Rr = function(t, e) {
        var n = this.docs.get(e);
        return $6c8154472dd99012$var$yr.resolve(n ? n.ta : null);
    }, t.prototype.getEntries = function(t, e) {
        var n = this, r = $6c8154472dd99012$var$Dt();
        return e.forEach(function(t) {
            var e = n.docs.get(t);
            r = r.ot(t, e ? e.ta : null);
        }), $6c8154472dd99012$var$yr.resolve(r);
    }, t.prototype.Lr = function(t, e, n) {
        for(var r = $6c8154472dd99012$var$Lt(), i = new $6c8154472dd99012$var$A(e.path.child("")), o = this.docs.ft(i); o.At();){
            var s = o.It(), u = s.key, a = s.value, c = a.ta, h = a.readTime;
            if (!e.path.T(u.path)) break;
            h.L(n) <= 0 || c instanceof $6c8154472dd99012$var$kn && $6c8154472dd99012$var$$n(e, c) && (r = r.ot(c.key, c));
        }
        return $6c8154472dd99012$var$yr.resolve(r);
    }, t.prototype.il = function(t, e) {
        return $6c8154472dd99012$var$yr.forEach(this.docs, function(t) {
            return e(t);
        });
    }, t.prototype.ra = function(t) {
        // `trackRemovals` is ignores since the MemoryRemoteDocumentCache keeps
        // a separate changelog and does not need special handling for removals.
        return new $6c8154472dd99012$var$Xs(this);
    }, t.prototype.aa = function(t) {
        return $6c8154472dd99012$var$yr.resolve(this.size);
    }, t;
}(), $6c8154472dd99012$var$Xs = /** @class */ function(e) {
    function n(t) {
        var n = this;
        return (n = e.call(this) || this).ca = t, n;
    }
    return $876a70688d8d7977$export$a8ba968b8961cb8a(n, e), n.prototype.yr = function(t) {
        var e = this, n = [];
        return this.wr.forEach(function(r, i) {
            i ? n.push(e.ca.Er(t, i, e.readTime)) : e.ca.Ar(r);
        }), $6c8154472dd99012$var$yr.$n(n);
    }, n.prototype.gr = function(t, e) {
        return this.ca.Rr(t, e);
    }, n.prototype.Pr = function(t, e) {
        return this.ca.getEntries(t, e);
    }, n;
}($6c8154472dd99012$var$Zr), $6c8154472dd99012$var$Js = /** @class */ function() {
    function t(t) {
        this.persistence = t, /**
             * Maps a target to the data about that target
             */ this.rl = new $6c8154472dd99012$var$it(function(t) {
            return $6c8154472dd99012$var$lt(t);
        }, $6c8154472dd99012$var$pt), /** The last received snapshot version. */ this.lastRemoteSnapshotVersion = $6c8154472dd99012$var$st.min(), /** The highest numbered target ID encountered. */ this.highestTargetId = 0, /** The highest sequence number encountered. */ this.ol = 0, /**
             * A ordered bidirectional mapping between documents and the remote target
             * IDs.
             */ this.al = new $6c8154472dd99012$var$xo, this.targetCount = 0, this.cl = $6c8154472dd99012$var$ro.fa();
    }
    return t.prototype.Ce = function(t, e) {
        return this.rl.forEach(function(t, n) {
            return e(n);
        }), $6c8154472dd99012$var$yr.resolve();
    }, t.prototype.Ea = function(t) {
        return $6c8154472dd99012$var$yr.resolve(this.lastRemoteSnapshotVersion);
    }, t.prototype.Ia = function(t) {
        return $6c8154472dd99012$var$yr.resolve(this.ol);
    }, t.prototype.wa = function(t) {
        return this.highestTargetId = this.cl.next(), $6c8154472dd99012$var$yr.resolve(this.highestTargetId);
    }, t.prototype.Aa = function(t, e, n) {
        return n && (this.lastRemoteSnapshotVersion = n), e > this.ol && (this.ol = e), $6c8154472dd99012$var$yr.resolve();
    }, t.prototype.ga = function(t) {
        this.rl.set(t.target, t);
        var e = t.targetId;
        e > this.highestTargetId && (this.cl = new $6c8154472dd99012$var$ro(e), this.highestTargetId = e), t.sequenceNumber > this.ol && (this.ol = t.sequenceNumber);
    }, t.prototype.Ra = function(t, e) {
        return this.ga(e), this.targetCount += 1, $6c8154472dd99012$var$yr.resolve();
    }, t.prototype.ya = function(t, e) {
        return this.ga(e), $6c8154472dd99012$var$yr.resolve();
    }, t.prototype.Va = function(t, e) {
        return this.rl.delete(e.target), this.al.Uc(e.targetId), this.targetCount -= 1, $6c8154472dd99012$var$yr.resolve();
    }, t.prototype.po = function(t, e, n) {
        var r = this, i = 0, o = [];
        return this.rl.forEach(function(s, u) {
            u.sequenceNumber <= e && null === n.get(u.targetId) && (r.rl.delete(s), o.push(r.pa(t, u.targetId)), i++);
        }), $6c8154472dd99012$var$yr.$n(o).next(function() {
            return i;
        });
    }, t.prototype.ba = function(t) {
        return $6c8154472dd99012$var$yr.resolve(this.targetCount);
    }, t.prototype.va = function(t, e) {
        var n = this.rl.get(e) || null;
        return $6c8154472dd99012$var$yr.resolve(n);
    }, t.prototype.Sa = function(t, e, n) {
        return this.al.Lc(e, n), $6c8154472dd99012$var$yr.resolve();
    }, t.prototype.Ca = function(t, e, n) {
        this.al.qc(e, n);
        var r = this.persistence.No, i = [];
        return r && e.forEach(function(e) {
            i.push(r.Go(t, e));
        }), $6c8154472dd99012$var$yr.$n(i);
    }, t.prototype.pa = function(t, e) {
        return this.al.Uc(e), $6c8154472dd99012$var$yr.resolve();
    }, t.prototype.Fa = function(t, e) {
        var n = this.al.Wc(e);
        return $6c8154472dd99012$var$yr.resolve(n);
    }, t.prototype.Ho = function(t, e) {
        return $6c8154472dd99012$var$yr.resolve(this.al.Ho(e));
    }, t;
}(), $6c8154472dd99012$var$Zs = /** @class */ function() {
    /**
     * The constructor accepts a factory for creating a reference delegate. This
     * allows both the delegate and this instance to have strong references to
     * each other without having nullable fields that would then need to be
     * checked or asserted on every access.
     */ function t(t) {
        var e = this;
        this.ul = {}, this.Ma = new $6c8154472dd99012$var$qr(0), this.Oa = !1, this.Oa = !0, this.No = t(this), this.Ka = new $6c8154472dd99012$var$Js(this), this.Dr = new $6c8154472dd99012$var$Ui, this.vr = function(t, n) {
            return new $6c8154472dd99012$var$$s(t, function(t) {
                return e.No.hl(t);
            });
        }(this.Dr);
    }
    return t.prototype.start = function() {
        return Promise.resolve();
    }, t.prototype.Di = function() {
        // No durable state to ensure is closed on shutdown.
        return this.Oa = !1, Promise.resolve();
    }, Object.defineProperty(t.prototype, "Ei", {
        get: function() {
            return this.Oa;
        },
        enumerable: !1,
        configurable: !0
    }), t.prototype.Za = function() {
    // No op.
    }, t.prototype.tc = function() {
    // No op.
    }, t.prototype.Ic = function() {
        return this.Dr;
    }, t.prototype.mc = function(t) {
        var e = this.ul[t.ti()];
        return e || (e = new $6c8154472dd99012$var$Ys(this.Dr, this.No), this.ul[t.ti()] = e), e;
    }, t.prototype.Tc = function() {
        return this.Ka;
    }, t.prototype.Ec = function() {
        return this.vr;
    }, t.prototype.runTransaction = function(t, e, n) {
        var r = this;
        $6c8154472dd99012$var$l("MemoryPersistence", "Starting transaction:", t);
        var i = new $6c8154472dd99012$var$tu(this.Ma.next());
        return this.No.ll(), n(i).next(function(t) {
            return r.No._l(i).next(function() {
                return t;
            });
        }).Fn().then(function(t) {
            return i.br(), t;
        });
    }, t.prototype.fl = function(t, e) {
        return $6c8154472dd99012$var$yr.kn(Object.values(this.ul).map(function(n) {
            return function() {
                return n.Ho(t, e);
            };
        }));
    }, t;
}(), $6c8154472dd99012$var$tu = /** @class */ function(e) {
    function n(t) {
        var n = this;
        return (n = e.call(this) || this).xa = t, n;
    }
    return $876a70688d8d7977$export$a8ba968b8961cb8a(n, e), n;
}($6c8154472dd99012$var$ei), $6c8154472dd99012$var$eu = /** @class */ function() {
    function t(t) {
        this.persistence = t, /** Tracks all documents that are active in Query views. */ this.dl = new $6c8154472dd99012$var$xo, /** The list of documents that are potentially GCed after each transaction. */ this.wl = null;
    }
    return t.ml = function(e) {
        return new t(e);
    }, Object.defineProperty(t.prototype, "Tl", {
        get: function() {
            if (this.wl) return this.wl;
            throw $6c8154472dd99012$var$y();
        },
        enumerable: !1,
        configurable: !0
    }), t.prototype.Da = function(t, e, n) {
        return this.dl.Da(n, e), this.Tl.delete(n.toString()), $6c8154472dd99012$var$yr.resolve();
    }, t.prototype.Na = function(t, e, n) {
        return this.dl.Na(n, e), this.Tl.add(n.toString()), $6c8154472dd99012$var$yr.resolve();
    }, t.prototype.Go = function(t, e) {
        return this.Tl.add(e.toString()), $6c8154472dd99012$var$yr.resolve();
    }, t.prototype.removeTarget = function(t, e) {
        var n = this;
        this.dl.Uc(e.targetId).forEach(function(t) {
            return n.Tl.add(t.toString());
        });
        var r = this.persistence.Tc();
        return r.Fa(t, e.targetId).next(function(t) {
            t.forEach(function(t) {
                return n.Tl.add(t.toString());
            });
        }).next(function() {
            return r.Va(t, e);
        });
    }, t.prototype.ll = function() {
        this.wl = new Set;
    }, t.prototype._l = function(t) {
        var e = this, n = this.persistence.Ec().ra();
        // Remove newly orphaned documents.
        return $6c8154472dd99012$var$yr.forEach(this.Tl, function(r) {
            var i = $6c8154472dd99012$var$A.D(r);
            return e.El(t, i).next(function(t) {
                t || n.Ar(i);
            });
        }).next(function() {
            return e.wl = null, n.apply(t);
        });
    }, t.prototype.yc = function(t, e) {
        var n = this;
        return this.El(t, e).next(function(t) {
            t ? n.Tl.delete(e.toString()) : n.Tl.add(e.toString());
        });
    }, t.prototype.hl = function(t) {
        // For eager GC, we don't care about the document size, there are no size thresholds.
        return 0;
    }, t.prototype.El = function(t, e) {
        var n = this;
        return $6c8154472dd99012$var$yr.kn([
            function() {
                return $6c8154472dd99012$var$yr.resolve(n.dl.Ho(e));
            },
            function() {
                return n.persistence.Tc().Ho(t, e);
            },
            function() {
                return n.persistence.fl(t, e);
            }
        ]);
    }, t;
}(), $6c8154472dd99012$var$nu = /** @class */ function() {
    function t(t) {
        this.Il = t.Il, this.Al = t.Al;
    }
    return t.prototype.gu = function(t) {
        this.Rl = t;
    }, t.prototype.Tu = function(t) {
        this.gl = t;
    }, t.prototype.onMessage = function(t) {
        this.Pl = t;
    }, t.prototype.close = function() {
        this.Al();
    }, t.prototype.send = function(t) {
        this.Il(t);
    }, t.prototype.yl = function() {
        this.Rl();
    }, t.prototype.Vl = function(t) {
        this.gl(t);
    }, t.prototype.pl = function(t) {
        this.Pl(t);
    }, t;
}(), $6c8154472dd99012$var$ru = {
    BatchGetDocuments: "batchGet",
    Commit: "commit",
    RunQuery: "runQuery"
}, $6c8154472dd99012$var$iu = /** @class */ function(e) {
    function n(t) {
        var n = this;
        return (n = e.call(this, t) || this).forceLongPolling = t.forceLongPolling, n.W = t.W, n;
    }
    /**
     * Base class for all Rest-based connections to the backend (WebChannel and
     * HTTP).
     */ return $876a70688d8d7977$export$a8ba968b8961cb8a(n, e), n.prototype.Nl = function(t, e, n, r) {
        return new Promise(function(o, s) {
            var u = new $babc33424e560749$export$26404658cda3ee02;
            u.listenOnce($babc33424e560749$export$3d7865934588d77e.COMPLETE, function() {
                try {
                    switch(u.getLastErrorCode()){
                        case $babc33424e560749$export$d4e71bc0b80dc0fb.NO_ERROR:
                            var e = u.getResponseJson();
                            $6c8154472dd99012$var$l("Connection", "XHR received:", JSON.stringify(e)), o(e);
                            break;
                        case $babc33424e560749$export$d4e71bc0b80dc0fb.TIMEOUT:
                            $6c8154472dd99012$var$l("Connection", 'RPC "' + t + '" timed out'), s(new $6c8154472dd99012$var$c($6c8154472dd99012$var$a.DEADLINE_EXCEEDED, "Request time out"));
                            break;
                        case $babc33424e560749$export$d4e71bc0b80dc0fb.HTTP_ERROR:
                            var n = u.getStatus();
                            if ($6c8154472dd99012$var$l("Connection", 'RPC "' + t + '" failed with status:', n, "response text:", u.getResponseText()), n > 0) {
                                var r = u.getResponseJson().error;
                                if (r && r.status && r.message) {
                                    var h = function(t) {
                                        var e = t.toLowerCase().replace("_", "-");
                                        return Object.values($6c8154472dd99012$var$a).indexOf(e) >= 0 ? e : $6c8154472dd99012$var$a.UNKNOWN;
                                    }(r.status);
                                    s(new $6c8154472dd99012$var$c(h, r.message));
                                } else s(new $6c8154472dd99012$var$c($6c8154472dd99012$var$a.UNKNOWN, "Server responded with status " + u.getStatus()));
                            } else // If we received an HTTP_ERROR but there's no status code,
                            // it's most probably a connection issue
                            s(new $6c8154472dd99012$var$c($6c8154472dd99012$var$a.UNAVAILABLE, "Connection failed."));
                            break;
                        default:
                            $6c8154472dd99012$var$y();
                    }
                } finally{
                    $6c8154472dd99012$var$l("Connection", 'RPC "' + t + '" completed.');
                }
            });
            var h = JSON.stringify(r);
            u.send(e, "POST", h, n, 15);
        });
    }, n.prototype.Pu = function(t, e) {
        var n = [
            this.vl,
            "/",
            "google.firestore.v1.Firestore",
            "/",
            t,
            "/channel"
        ], o = $babc33424e560749$export$66869136fc133c3a(), s = {
            // Required for backend stickiness, routing behavior is based on this
            // parameter.
            httpSessionIdParam: "gsessionid",
            initMessageHeaders: {},
            messageUrlParams: {
                // This param is used to improve routing and project isolation by the
                // backend and must be included in every request.
                database: "projects/" + this.U.projectId + "/databases/" + this.U.database
            },
            sendRawJson: !0,
            supportsCrossDomainXhr: !0,
            internalChannelParams: {
                // Override the default timeout (randomized between 10-20 seconds) since
                // a large write batch on a slow internet connection may take a long
                // time to send to the backend. Rather than have WebChannel impose a
                // tight timeout which could lead to infinite timeouts and retries, we
                // set it very large (5-10 minutes) and rely on the browser's builtin
                // timeouts to kick in if the request isn't working.
                forwardChannelRequestTimeoutMs: 6e5
            },
            forceLongPolling: this.forceLongPolling,
            detectBufferingProxy: this.W
        };
        this.Cl(s.initMessageHeaders, e), // Sending the custom headers we just added to request.initMessageHeaders
        // (Authorization, etc.) will trigger the browser to make a CORS preflight
        // request because the XHR will no longer meet the criteria for a "simple"
        // CORS request:
        // https://developer.mozilla.org/en-US/docs/Web/HTTP/CORS#Simple_requests
        // Therefore to avoid the CORS preflight request (an extra network
        // roundtrip), we use the httpHeadersOverwriteParam option to specify that
        // the headers should instead be encoded into a special "$httpHeaders" query
        // parameter, which is recognized by the webchannel backend. This is
        // formally defined here:
        // https://github.com/google/closure-library/blob/b0e1815b13fb92a46d7c9b3c30de5d6a396a3245/closure/goog/net/rpc/httpcors.js#L32
        // TODO(b/145624756): There is a backend bug where $httpHeaders isn't respected if the request
        // doesn't have an Origin header. So we have to exclude a few browser environments that are
        // known to (sometimes) not include an Origin. See
        // https://github.com/firebase/firebase-js-sdk/issues/1491.
        $01sTD.isMobileCordova() || $01sTD.isReactNative() || $01sTD.isElectron() || $01sTD.isIE() || $01sTD.isUWP() || $01sTD.isBrowserExtension() || (s.httpHeadersOverwriteParam = "$httpHeaders");
        var u = n.join("");
        $6c8154472dd99012$var$l("Connection", "Creating WebChannel: " + u, s);
        var h = o.createWebChannel(u, s), f = !1, p = !1, v = new $6c8154472dd99012$var$nu({
            Il: function(t) {
                p ? $6c8154472dd99012$var$l("Connection", "Not sending because WebChannel is closed:", t) : (f || ($6c8154472dd99012$var$l("Connection", "Opening WebChannel transport."), h.open(), f = !0), $6c8154472dd99012$var$l("Connection", "WebChannel sending:", t), h.send(t));
            },
            Al: function() {
                return h.close();
            }
        }), y = function(t, e) {
            // TODO(dimond): closure typing seems broken because WebChannel does
            // not implement goog.events.Listenable
            h.listen(t, function(t) {
                try {
                    e(t);
                } catch (t) {
                    setTimeout(function() {
                        throw t;
                    }, 0);
                }
            });
        };
        // WebChannel supports sending the first message with the handshake - saving
        // a network round trip. However, it will have to call send in the same
        // JS event loop as open. In order to enforce this, we delay actually
        // opening the WebChannel until send is called. Whether we have called
        // open is tracked with this variable.
        // Closure events are guarded and exceptions are swallowed, so catch any
        // exception and rethrow using a setTimeout so they become visible again.
        // Note that eventually this function could go away if we are confident
        // enough the code is exception free.
        return y($babc33424e560749$export$aa726fb96ad3e039.EventType.OPEN, function() {
            p || $6c8154472dd99012$var$l("Connection", "WebChannel transport opened.");
        }), y($babc33424e560749$export$aa726fb96ad3e039.EventType.CLOSE, function() {
            p || (p = !0, $6c8154472dd99012$var$l("Connection", "WebChannel transport closed"), v.Vl());
        }), y($babc33424e560749$export$aa726fb96ad3e039.EventType.ERROR, function(t) {
            p || (p = !0, $6c8154472dd99012$var$d("Connection", "WebChannel transport errored:", t), v.Vl(new $6c8154472dd99012$var$c($6c8154472dd99012$var$a.UNAVAILABLE, "The operation could not be completed")));
        }), y($babc33424e560749$export$aa726fb96ad3e039.EventType.MESSAGE, function(t) {
            var e;
            if (!p) {
                var n = t.data[0];
                $6c8154472dd99012$var$g(!!n);
                // TODO(b/35143891): There is a bug in One Platform that caused errors
                // (and only errors) to be wrapped in an extra array. To be forward
                // compatible with the bug we need to check either condition. The latter
                // can be removed once the fix has been rolled out.
                // Use any because msgData.error is not typed.
                var r = n, i = r.error || (null === (e = r[0]) || void 0 === e ? void 0 : e.error);
                if (i) {
                    $6c8154472dd99012$var$l("Connection", "WebChannel received error:", i);
                    // error.status will be a string like 'OK' or 'NOT_FOUND'.
                    var o = i.status, s = function(t) {
                        // lookup by string
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        var e = $6c8154472dd99012$var$vt[t];
                        if (void 0 !== e) return $6c8154472dd99012$var$_t(e);
                    }(o), u = i.message;
                    void 0 === s && (s = $6c8154472dd99012$var$a.INTERNAL, u = "Unknown error status: " + o + " with message " + i.message), // Mark closed so no further events are propagated
                    p = !0, v.Vl(new $6c8154472dd99012$var$c(s, u)), h.close();
                } else $6c8154472dd99012$var$l("Connection", "WebChannel received:", n), v.pl(n);
            }
        }), setTimeout(function() {
            // Technically we could/should wait for the WebChannel opened event,
            // but because we want to send the first message with the WebChannel
            // handshake we pretend the channel opened here (asynchronously), and
            // then delay the actual open until the first message is sent.
            v.yl();
        }, 0), v;
    }, n;
}(/** @class */ function() {
    function t(t) {
        this.bl = t, this.U = t.U;
        var e = t.ssl ? "https" : "http";
        this.vl = e + "://" + t.host, this.Sl = "projects/" + this.U.projectId + "/databases/" + this.U.database + "/documents";
    }
    return t.prototype.$u = function(t, e, n, r) {
        var i = this.Dl(t, e);
        $6c8154472dd99012$var$l("RestConnection", "Sending: ", i, n);
        var o = {};
        return this.Cl(o, r), this.Nl(t, i, o, n).then(function(t) {
            return $6c8154472dd99012$var$l("RestConnection", "Received: ", t), t;
        }, function(e) {
            throw $6c8154472dd99012$var$d("RestConnection", t + " failed with error: ", e, "url: ", i, "request:", n), e;
        });
    }, t.prototype.ku = function(t, e, n, r) {
        // The REST API automatically aggregates all of the streamed results, so we
        // can just use the normal invoke() method.
        return this.$u(t, e, n, r);
    }, /**
     * Modifies the headers for a request, adding any authorization token if
     * present and any additional headers for the request.
     */ t.prototype.Cl = function(t, e) {
        if (t["X-Goog-Api-Client"] = "gl-js/ fire/7.24.0", // Content-Type: text/plain will avoid preflight requests which might
        // mess with CORS and redirects by proxies. If we add custom headers
        // we will need to change this code to potentially use the $httpOverwrite
        // parameter supported by ESF to avoid triggering preflight requests.
        t["Content-Type"] = "text/plain", e) for(var n in e.Kc)e.Kc.hasOwnProperty(n) && (t[n] = e.Kc[n]);
    }, t.prototype.Dl = function(t, e) {
        var n = $6c8154472dd99012$var$ru[t];
        return this.vl + "/v1/" + e + ":" + n;
    }, t;
}()), $6c8154472dd99012$var$ou = /** @class */ function() {
    function t() {
        var t = this;
        this.Fl = function() {
            return t.xl();
        }, this.$l = function() {
            return t.kl();
        }, this.Ml = [], this.Ol();
    }
    return t.prototype.Zu = function(t) {
        this.Ml.push(t);
    }, t.prototype.Di = function() {
        window.removeEventListener("online", this.Fl), window.removeEventListener("offline", this.$l);
    }, t.prototype.Ol = function() {
        window.addEventListener("online", this.Fl), window.addEventListener("offline", this.$l);
    }, t.prototype.xl = function() {
        $6c8154472dd99012$var$l("ConnectivityMonitor", "Network connectivity changed: AVAILABLE");
        for(var t = 0, e = this.Ml; t < e.length; t++)(0, e[t])(0 /* AVAILABLE */ );
    }, t.prototype.kl = function() {
        $6c8154472dd99012$var$l("ConnectivityMonitor", "Network connectivity changed: UNAVAILABLE");
        for(var t = 0, e = this.Ml; t < e.length; t++)(0, e[t])(1 /* UNAVAILABLE */ );
    }, // TODO(chenbrian): Consider passing in window either into this component or
    // here for testing via FakeWindow.
    /** Checks that all used attributes of window are available. */ t.Ln = function() {
        return "undefined" != typeof window && void 0 !== window.addEventListener && void 0 !== window.removeEventListener;
    }, t;
}(), $6c8154472dd99012$var$su = /** @class */ function() {
    function t() {}
    return t.prototype.Zu = function(t) {
    // No-op.
    }, t.prototype.Di = function() {
    // No-op.
    }, t;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Initializes the WebChannelConnection for the browser. */ /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $6c8154472dd99012$var$uu(t) {
    return new $6c8154472dd99012$var$ye(t, /* useProto3Json= */ !0);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $6c8154472dd99012$var$au = "You are using the memory-only build of Firestore. Persistence support is only available via the @firebase/firestore bundle or the firebase-firestore.js build.", $6c8154472dd99012$var$cu = /** @class */ function() {
    function e() {}
    return e.prototype.initialize = function(e) {
        return $876a70688d8d7977$export$1050f835b63b671e(this, void 0, void 0, function() {
            return $876a70688d8d7977$export$67ebef60e6f28a6(this, function(t) {
                switch(t.label){
                    case 0:
                        return this.Sh = this.Ll(e), this.persistence = this.Bl(e), [
                            4 /*yield*/ ,
                            this.persistence.start()
                        ];
                    case 1:
                        return t.sent(), this.ql = this.Ul(e), this.ju = this.Ql(e), [
                            2 /*return*/ 
                        ];
                }
            });
        });
    }, e.prototype.Ul = function(t) {
        return null;
    }, e.prototype.Ql = function(t) {
        var e, n, r;
        /** Manages our in-memory or durable persistence. */ return e = this.persistence, n = new $6c8154472dd99012$var$Hs, r = t.Wl, new $6c8154472dd99012$var$go(e, n, r);
    }, e.prototype.Bl = function(t) {
        if (t.persistenceSettings.jl) throw new $6c8154472dd99012$var$c($6c8154472dd99012$var$a.FAILED_PRECONDITION, $6c8154472dd99012$var$au);
        return new $6c8154472dd99012$var$Zs($6c8154472dd99012$var$eu.ml);
    }, e.prototype.Ll = function(t) {
        return new $6c8154472dd99012$var$$r;
    }, e.prototype.terminate = function() {
        return $876a70688d8d7977$export$1050f835b63b671e(this, void 0, void 0, function() {
            return $876a70688d8d7977$export$67ebef60e6f28a6(this, function(t) {
                switch(t.label){
                    case 0:
                        return this.ql && this.ql.stop(), [
                            4 /*yield*/ ,
                            this.Sh.Di()
                        ];
                    case 1:
                        return t.sent(), [
                            4 /*yield*/ ,
                            this.persistence.Di()
                        ];
                    case 2:
                        return t.sent(), [
                            2 /*return*/ 
                        ];
                }
            });
        });
    }, e.prototype.clearPersistence = function(t, e) {
        throw new $6c8154472dd99012$var$c($6c8154472dd99012$var$a.FAILED_PRECONDITION, $6c8154472dd99012$var$au);
    }, e;
}(), $6c8154472dd99012$var$hu = /** @class */ function(e) {
    function n() {
        return null !== e && e.apply(this, arguments) || this;
    }
    return $876a70688d8d7977$export$a8ba968b8961cb8a(n, e), n.prototype.initialize = function(n) {
        return $876a70688d8d7977$export$1050f835b63b671e(this, void 0, void 0, function() {
            var r, i = this;
            return $876a70688d8d7977$export$67ebef60e6f28a6(this, function(o) {
                switch(o.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            e.prototype.initialize.call(this, n)
                        ];
                    case 1:
                        return o.sent(), r = this.Kl.fi, this.Sh instanceof $6c8154472dd99012$var$Yr ? (this.Sh.fi = {
                            er: $6c8154472dd99012$var$Ms.bind(null, r),
                            nr: $6c8154472dd99012$var$Bs.bind(null, r),
                            sr: $6c8154472dd99012$var$Ws.bind(null, r),
                            pi: $6c8154472dd99012$var$zs.bind(null, r)
                        }, [
                            4 /*yield*/ ,
                            this.Sh.start()
                        ]) : [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        o.sent(), o.label = 3;
                    case 3:
                        // NOTE: This will immediately call the listener, so we make sure to
                        // set it after localStore / remoteStore are started.
                        return [
                            4 /*yield*/ ,
                            this.persistence.Xa(function(e) {
                                return $876a70688d8d7977$export$1050f835b63b671e(i, void 0, void 0, function() {
                                    return $876a70688d8d7977$export$67ebef60e6f28a6(this, function(t) {
                                        switch(t.label){
                                            case 0:
                                                return [
                                                    4 /*yield*/ ,
                                                    $6c8154472dd99012$var$qs(this.Kl.fi, e)
                                                ];
                                            case 1:
                                                return t.sent(), this.ql && (e && !this.ql.Ei ? this.ql.start(this.ju) : e || this.ql.stop()), [
                                                    2 /*return*/ 
                                                ];
                                        }
                                    });
                                });
                            })
                        ];
                    case 4:
                        // NOTE: This will immediately call the listener, so we make sure to
                        // set it after localStore / remoteStore are started.
                        return o.sent(), [
                            2 /*return*/ 
                        ];
                }
            });
        });
    }, n.prototype.Ll = function(t) {
        if (t.persistenceSettings.jl && t.persistenceSettings.synchronizeTabs) {
            var e = $6c8154472dd99012$var$Ar();
            if (!$6c8154472dd99012$var$Yr.Ln(e)) throw new $6c8154472dd99012$var$c($6c8154472dd99012$var$a.UNIMPLEMENTED, "IndexedDB persistence is only available on platforms that support LocalStorage.");
            var n = $6c8154472dd99012$var$yo(t.bl.U, t.bl.persistenceKey);
            return new $6c8154472dd99012$var$Yr(e, t.cs, n, t.clientId, t.Wl);
        }
        return new $6c8154472dd99012$var$$r;
    }, n;
}(/** @class */ function(e) {
    function n(t) {
        var n = this;
        return (n = e.call(this) || this).Kl = t, n;
    }
    return $876a70688d8d7977$export$a8ba968b8961cb8a(n, e), n.prototype.initialize = function(n) {
        return $876a70688d8d7977$export$1050f835b63b671e(this, void 0, void 0, function() {
            return $876a70688d8d7977$export$67ebef60e6f28a6(this, function(t) {
                switch(t.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            e.prototype.initialize.call(this, n)
                        ];
                    case 1:
                        return t.sent(), [
                            4 /*yield*/ ,
                            $6c8154472dd99012$var$So(this.ju)
                        ];
                    case 2:
                        return t.sent(), [
                            4 /*yield*/ ,
                            this.Kl.initialize(this, n)
                        ];
                    case 3:
                        // Enqueue writes from a previous session
                        return t.sent(), [
                            4 /*yield*/ ,
                            $6c8154472dd99012$var$Qs(this.Kl.fi)
                        ];
                    case 4:
                        // Enqueue writes from a previous session
                        return t.sent(), [
                            4 /*yield*/ ,
                            $6c8154472dd99012$var$is(this.Kl.ph)
                        ];
                    case 5:
                        return t.sent(), [
                            2 /*return*/ 
                        ];
                }
            });
        });
    }, n.prototype.Ul = function(t) {
        var e = this.persistence.No.wo;
        return new $6c8154472dd99012$var$ai(e, t.cs);
    }, n.prototype.Bl = function(t) {
        var e = $6c8154472dd99012$var$yo(t.bl.U, t.bl.persistenceKey), n = $6c8154472dd99012$var$uu(t.bl.U);
        return new $6c8154472dd99012$var$ho(t.persistenceSettings.synchronizeTabs, e, t.clientId, $6c8154472dd99012$var$ui.ao(t.persistenceSettings.cacheSizeBytes), t.cs, $6c8154472dd99012$var$Ar(), $6c8154472dd99012$var$Sr(), n, this.Sh, t.persistenceSettings.ka);
    }, n.prototype.Ll = function(t) {
        return new $6c8154472dd99012$var$$r;
    }, n.prototype.clearPersistence = function(e, n) {
        return function(e) {
            return $876a70688d8d7977$export$1050f835b63b671e(this, void 0, void 0, function() {
                var n;
                return $876a70688d8d7977$export$67ebef60e6f28a6(this, function(t) {
                    switch(t.label){
                        case 0:
                            return $6c8154472dd99012$var$gr.Ln() ? (n = e + "main", [
                                4 /*yield*/ ,
                                $6c8154472dd99012$var$gr.delete(n)
                            ]) : [
                                2 /*return*/ ,
                                Promise.resolve()
                            ];
                        case 1:
                            return t.sent(), [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        }($6c8154472dd99012$var$yo(e, n));
    }, n;
}($6c8154472dd99012$var$cu)), $6c8154472dd99012$var$fu = /** @class */ function() {
    function e() {}
    return e.prototype.initialize = function(e, n) {
        return $876a70688d8d7977$export$1050f835b63b671e(this, void 0, void 0, function() {
            var r = this;
            return $876a70688d8d7977$export$67ebef60e6f28a6(this, function(t) {
                switch(t.label){
                    case 0:
                        return this.ju ? [
                            3 /*break*/ ,
                            2
                        ] : (this.ju = e.ju, this.Sh = e.Sh, this.Ku = this.Gl(n), this.ph = this.zl(n), this.bh = this.Hl(n), this.fi = this.Yl(n), this.Sh.di = function(t) {
                            return $6c8154472dd99012$var$Ts(r.fi, t, 1 /* SharedClientState */ );
                        }, this.ph.Gu.Jl = $6c8154472dd99012$var$Us.bind(null, this.fi), [
                            4 /*yield*/ ,
                            $6c8154472dd99012$var$fs(this.ph, this.fi.Uh)
                        ]);
                    case 1:
                        t.sent(), t.label = 2;
                    case 2:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    }, e.prototype.Hl = function(t) {
        return new $6c8154472dd99012$var$Rr;
    }, e.prototype.Gl = function(t) {
        var e, n = $6c8154472dd99012$var$uu(t.bl.U), r = (e = t.bl, new $6c8154472dd99012$var$iu(e));
        /** Return the Platform-specific connectivity monitor. */ return function(t, e, n) {
            return new $6c8154472dd99012$var$Mo(t, e, n);
        }(t.credentials, r, n);
    }, e.prototype.zl = function(t) {
        var e, n, r, i, o, s = this;
        return e = this.ju, n = this.Ku, r = t.cs, i = function(t) {
            return $6c8154472dd99012$var$Ts(s.fi, t, 0 /* RemoteStore */ );
        }, o = $6c8154472dd99012$var$ou.Ln() ? new $6c8154472dd99012$var$ou : new $6c8154472dd99012$var$su, new $6c8154472dd99012$var$jo(e, n, r, i, o);
    }, e.prototype.Yl = function(t) {
        return function(t, e, n, // PORTING NOTE: Manages state synchronization in multi-tab environments.
        r, i, o, s) {
            var u = new $6c8154472dd99012$var$ws(t, e, n, r, i, o);
            return s && (u.qh = !0), u;
        }(this.ju, this.ph, this.bh, this.Sh, t.Wl, t.Dh, !t.persistenceSettings.jl || !t.persistenceSettings.synchronizeTabs);
    }, e.prototype.terminate = function() {
        return $6c8154472dd99012$var$Bo(this.ph);
    }, e;
}(), $6c8154472dd99012$var$lu = /** @class */ function() {
    function t(t) {
        this.observer = t, /**
             * When set to true, will not raise future events. Necessary to deal with
             * async detachment of listener.
             */ this.muted = !1;
    }
    return t.prototype.next = function(t) {
        this.observer.next && this.Xl(this.observer.next, t);
    }, t.prototype.error = function(t) {
        this.observer.error ? this.Xl(this.observer.error, t) : console.error("Uncaught Error in snapshot listener:", t);
    }, t.prototype.Zl = function() {
        this.muted = !0;
    }, t.prototype.Xl = function(t, e) {
        var n = this;
        this.muted || setTimeout(function() {
            n.muted || t(e);
        }, 0);
    }, t;
}(), $6c8154472dd99012$var$pu = function(t) {
    !function(t, e, n, r) {
        if (!(e instanceof Array) || e.length < 1) throw new $6c8154472dd99012$var$c($6c8154472dd99012$var$a.INVALID_ARGUMENT, "Function FieldPath() requires its fieldNames argument to be an array with at least " + $6c8154472dd99012$var$W(1, "element") + ".");
    }(0, t);
    for(var e = 0; e < t.length; ++e)if ($6c8154472dd99012$var$k("FieldPath", "string", e, t[e]), 0 === t[e].length) throw new $6c8154472dd99012$var$c($6c8154472dd99012$var$a.INVALID_ARGUMENT, "Invalid field name at argument $(i + 1). Field names must not be empty.");
    this.t_ = new $6c8154472dd99012$var$N(t);
}, $6c8154472dd99012$var$du = /** @class */ function(e) {
    /**
     * Creates a FieldPath from the provided field names. If more than one field
     * name is provided, the path will point to a nested field in a document.
     *
     * @param fieldNames A list of field names.
     */ function n() {
        for(var t = [], n = 0; n < arguments.length; n++)t[n] = arguments[n];
        return e.call(this, t) || this;
    }
    return $876a70688d8d7977$export$a8ba968b8961cb8a(n, e), n.documentId = function() {
        /**
         * Internal Note: The backend doesn't technically support querying by
         * document ID. Instead it queries by the entire document name (full path
         * included), but in the cases we currently support documentId(), the net
         * effect is the same.
         */ return new n($6c8154472dd99012$var$N.v().R());
    }, n.prototype.isEqual = function(t) {
        if (!(t instanceof n)) throw $6c8154472dd99012$var$G("isEqual", "FieldPath", 1, t);
        return this.t_.isEqual(t.t_);
    }, n;
}($6c8154472dd99012$var$pu), $6c8154472dd99012$var$vu = new RegExp("[~\\*/\\[\\]]"), $6c8154472dd99012$var$yu = /**
     * @param _methodName The public API endpoint that returns this class.
     */ function(t) {
    this.e_ = t;
}, $6c8154472dd99012$var$gu = /** @class */ function(e) {
    function n() {
        return null !== e && e.apply(this, arguments) || this;
    }
    return $876a70688d8d7977$export$a8ba968b8961cb8a(n, e), n.prototype.n_ = function(t) {
        if (2 /* MergeSet */  !== t.s_) throw 1 /* Update */  === t.s_ ? t.i_(this.e_ + "() can only appear at the top level of your update data") : t.i_(this.e_ + "() cannot be used with set() unless you pass {merge:true}");
        // No transform to add for a delete, but we need to add it to our
        // fieldMask so it gets deleted.
        return t.We.push(t.path), null;
    }, n.prototype.isEqual = function(t) {
        return t instanceof n;
    }, n;
}($6c8154472dd99012$var$yu);
/**
 * Provides all components needed for Firestore with in-memory persistence.
 * Uses EagerGC garbage collection.
 */ /**
 * Creates a child context for parsing SerializableFieldValues.
 *
 * This is different than calling `ParseContext.contextWith` because it keeps
 * the fieldTransforms and fieldMask separate.
 *
 * The created context has its `dataSource` set to `UserDataSource.Argument`.
 * Although these values are used with writes, any elements in these FieldValues
 * are not considered writes since they cannot contain any FieldValue sentinels,
 * etc.
 *
 * @param fieldValue The sentinel FieldValue for which to create a child
 *     context.
 * @param context The parent context.
 * @param arrayElement Whether or not the FieldValue has an array.
 */ function $6c8154472dd99012$var$mu(t, e, n) {
    return new $6c8154472dd99012$var$Lu({
        s_: 3 /* Argument */ ,
        r_: e.settings.r_,
        methodName: t.e_,
        o_: n
    }, e.U, e.serializer, e.ignoreUndefinedProperties);
}
var $6c8154472dd99012$var$wu = /** @class */ function(e) {
    function n() {
        return null !== e && e.apply(this, arguments) || this;
    }
    return $876a70688d8d7977$export$a8ba968b8961cb8a(n, e), n.prototype.n_ = function(t) {
        return new $6c8154472dd99012$var$cn(t.path, new $6c8154472dd99012$var$Ze);
    }, n.prototype.isEqual = function(t) {
        return t instanceof n;
    }, n;
}($6c8154472dd99012$var$yu), $6c8154472dd99012$var$_u = /** @class */ function(e) {
    function n(t, n) {
        var r = this;
        return (r = e.call(this, t) || this).a_ = n, r;
    }
    return $876a70688d8d7977$export$a8ba968b8961cb8a(n, e), n.prototype.n_ = function(t) {
        var e = $6c8154472dd99012$var$mu(this, t, /*array=*/ !0), n = this.a_.map(function(t) {
            return $6c8154472dd99012$var$Uu(t, e);
        }), r = new $6c8154472dd99012$var$tn(n);
        return new $6c8154472dd99012$var$cn(t.path, r);
    }, n.prototype.isEqual = function(t) {
        // TODO(mrschmidt): Implement isEquals
        return this === t;
    }, n;
}($6c8154472dd99012$var$yu), $6c8154472dd99012$var$bu = /** @class */ function(e) {
    function n(t, n) {
        var r = this;
        return (r = e.call(this, t) || this).a_ = n, r;
    }
    return $876a70688d8d7977$export$a8ba968b8961cb8a(n, e), n.prototype.n_ = function(t) {
        var e = $6c8154472dd99012$var$mu(this, t, /*array=*/ !0), n = this.a_.map(function(t) {
            return $6c8154472dd99012$var$Uu(t, e);
        }), r = new $6c8154472dd99012$var$nn(n);
        return new $6c8154472dd99012$var$cn(t.path, r);
    }, n.prototype.isEqual = function(t) {
        // TODO(mrschmidt): Implement isEquals
        return this === t;
    }, n;
}($6c8154472dd99012$var$yu), $6c8154472dd99012$var$Iu = /** @class */ function(e) {
    function n(t, n) {
        var r = this;
        return (r = e.call(this, t) || this).c_ = n, r;
    }
    return $876a70688d8d7977$export$a8ba968b8961cb8a(n, e), n.prototype.n_ = function(t) {
        var e = new $6c8154472dd99012$var$on(t.serializer, $6c8154472dd99012$var$we(t.serializer, this.c_));
        return new $6c8154472dd99012$var$cn(t.path, e);
    }, n.prototype.isEqual = function(t) {
        // TODO(mrschmidt): Implement isEquals
        return this === t;
    }, n;
}($6c8154472dd99012$var$yu), $6c8154472dd99012$var$Eu = /** @class */ function() {
    /**
     * Creates a new immutable `GeoPoint` object with the provided latitude and
     * longitude values.
     * @param latitude The latitude as number between -90 and 90.
     * @param longitude The longitude as number between -180 and 180.
     */ function t(t, e) {
        if ($6c8154472dd99012$var$D("GeoPoint", arguments, 2), $6c8154472dd99012$var$k("GeoPoint", "number", 1, t), $6c8154472dd99012$var$k("GeoPoint", "number", 2, e), !isFinite(t) || t < -90 || t > 90) throw new $6c8154472dd99012$var$c($6c8154472dd99012$var$a.INVALID_ARGUMENT, "Latitude must be a number between -90 and 90, but was: " + t);
        if (!isFinite(e) || e < -180 || e > 180) throw new $6c8154472dd99012$var$c($6c8154472dd99012$var$a.INVALID_ARGUMENT, "Longitude must be a number between -180 and 180, but was: " + e);
        this.u_ = t, this.h_ = e;
    }
    return Object.defineProperty(t.prototype, "latitude", {
        /**
         * The latitude of this `GeoPoint` instance.
         */ get: function() {
            return this.u_;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "longitude", {
        /**
         * The longitude of this `GeoPoint` instance.
         */ get: function() {
            return this.h_;
        },
        enumerable: !1,
        configurable: !0
    }), /**
     * Returns true if this `GeoPoint` is equal to the provided one.
     *
     * @param other The `GeoPoint` to compare against.
     * @return true if this `GeoPoint` is equal to the provided one.
     */ t.prototype.isEqual = function(t) {
        return this.u_ === t.u_ && this.h_ === t.h_;
    }, t.prototype.toJSON = function() {
        return {
            latitude: this.u_,
            longitude: this.h_
        };
    }, /**
     * Actually private to JS consumers of our API, so this function is prefixed
     * with an underscore.
     */ t.prototype.Y = function(t) {
        return $6c8154472dd99012$var$H(this.u_, t.u_) || $6c8154472dd99012$var$H(this.h_, t.h_);
    }, t;
}(), $6c8154472dd99012$var$Tu = function(t) {
    this.l_ = t;
}, $6c8154472dd99012$var$Nu = /^__.*__$/, $6c8154472dd99012$var$Au = function(t, e, n) {
    this.__ = t, this.f_ = e, this.d_ = n;
}, $6c8154472dd99012$var$Su = /** @class */ function() {
    function t(t, e, n) {
        this.data = t, this.We = e, this.fieldTransforms = n;
    }
    return t.prototype.w_ = function(t, e) {
        var n = [];
        return null !== this.We ? n.push(new $6c8154472dd99012$var$_n(t, this.data, this.We, e)) : n.push(new $6c8154472dd99012$var$wn(t, this.data, e)), this.fieldTransforms.length > 0 && n.push(new $6c8154472dd99012$var$In(t, this.fieldTransforms)), n;
    }, t;
}(), $6c8154472dd99012$var$Du = /** @class */ function() {
    function t(t, e, n) {
        this.data = t, this.We = e, this.fieldTransforms = n;
    }
    return t.prototype.w_ = function(t, e) {
        var n = [
            new $6c8154472dd99012$var$_n(t, this.data, this.We, e)
        ];
        return this.fieldTransforms.length > 0 && n.push(new $6c8154472dd99012$var$In(t, this.fieldTransforms)), n;
    }, t;
}();
function $6c8154472dd99012$var$xu(t) {
    switch(t){
        case 0 /* Set */ :
        // fall through
        case 2 /* MergeSet */ :
        // fall through
        case 1 /* Update */ :
            return !0;
        case 3 /* Argument */ :
        case 4 /* ArrayArgument */ :
            return !1;
        default:
            throw $6c8154472dd99012$var$y();
    }
}
/** A "context" object passed around while parsing user data. */ var $6c8154472dd99012$var$Lu = /** @class */ function() {
    /**
     * Initializes a ParseContext with the given source and path.
     *
     * @param settings The settings for the parser.
     * @param databaseId The database ID of the Firestore instance.
     * @param serializer The serializer to use to generate the Value proto.
     * @param ignoreUndefinedProperties Whether to ignore undefined properties
     * rather than throw.
     * @param fieldTransforms A mutable list of field transforms encountered while
     *     parsing the data.
     * @param fieldMask A mutable list of field paths encountered while parsing
     *     the data.
     *
     * TODO(b/34871131): We don't support array paths right now, so path can be
     * null to indicate the context represents any location within an array (in
     * which case certain features will not work and errors will be somewhat
     * compromised).
     */ function t(t, e, n, r, i, o) {
        this.settings = t, this.U = e, this.serializer = n, this.ignoreUndefinedProperties = r, // Minor hack: If fieldTransforms is undefined, we assume this is an
        // external call and we need to validate the entire path.
        void 0 === i && this.m_(), this.fieldTransforms = i || [], this.We = o || [];
    }
    return Object.defineProperty(t.prototype, "path", {
        get: function() {
            return this.settings.path;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "s_", {
        get: function() {
            return this.settings.s_;
        },
        enumerable: !1,
        configurable: !0
    }), /** Returns a new context with the specified settings overwritten. */ t.prototype.T_ = function(e) {
        return new t(Object.assign(Object.assign({}, this.settings), e), this.U, this.serializer, this.ignoreUndefinedProperties, this.fieldTransforms, this.We);
    }, t.prototype.E_ = function(t) {
        var e, n = null === (e = this.path) || void 0 === e ? void 0 : e.child(t), r = this.T_({
            path: n,
            o_: !1
        });
        return r.I_(t), r;
    }, t.prototype.A_ = function(t) {
        var e, n = null === (e = this.path) || void 0 === e ? void 0 : e.child(t), r = this.T_({
            path: n,
            o_: !1
        });
        return r.m_(), r;
    }, t.prototype.R_ = function(t) {
        // TODO(b/34871131): We don't support array paths right now; so make path
        // undefined.
        return this.T_({
            path: void 0,
            o_: !0
        });
    }, t.prototype.i_ = function(t) {
        return $6c8154472dd99012$var$Gu(t, this.settings.methodName, this.settings.g_ || !1, this.path, this.settings.r_);
    }, /** Returns 'true' if 'fieldPath' was traversed when creating this context. */ t.prototype.contains = function(t) {
        return void 0 !== this.We.find(function(e) {
            return t.T(e);
        }) || void 0 !== this.fieldTransforms.find(function(e) {
            return t.T(e.field);
        });
    }, t.prototype.m_ = function() {
        // TODO(b/34871131): Remove null check once we have proper paths for fields
        // within arrays.
        if (this.path) for(var t = 0; t < this.path.length; t++)this.I_(this.path.get(t));
    }, t.prototype.I_ = function(t) {
        if (0 === t.length) throw this.i_("Document fields must not be empty");
        if ($6c8154472dd99012$var$xu(this.s_) && $6c8154472dd99012$var$Nu.test(t)) throw this.i_('Document fields cannot begin and end with "__"');
    }, t;
}(), $6c8154472dd99012$var$ku = /** @class */ function() {
    function t(t, e, n) {
        this.U = t, this.ignoreUndefinedProperties = e, this.serializer = n || $6c8154472dd99012$var$uu(t) /** Creates a new top-level parse context. */ ;
    }
    return t.prototype.P_ = function(t, e, n, r) {
        return void 0 === r && (r = !1), new $6c8154472dd99012$var$Lu({
            s_: t,
            methodName: e,
            r_: n,
            path: $6c8154472dd99012$var$N.P(),
            o_: !1,
            g_: r
        }, this.U, this.serializer, this.ignoreUndefinedProperties);
    }, t;
}();
/**
 * Helper for parsing raw user input (provided via the API) into internal model
 * classes.
 */ /** Parse document data from a set() call. */ function $6c8154472dd99012$var$Ru(t, e, n, r, i, o) {
    void 0 === o && (o = {});
    var s = t.P_(o.merge || o.mergeFields ? 2 /* MergeSet */  : 0 /* Set */ , e, n, i);
    $6c8154472dd99012$var$Mu("Data must be an object, but it was:", s, r);
    var u, h, f = $6c8154472dd99012$var$Cu(r, s);
    if (o.merge) u = new $6c8154472dd99012$var$an(s.We), h = s.fieldTransforms;
    else if (o.mergeFields) {
        for(var l = [], p = 0, d = o.mergeFields; p < d.length; p++){
            var v = d[p], g = void 0;
            if (v instanceof $6c8154472dd99012$var$pu) g = v.t_;
            else {
                if ("string" != typeof v) throw $6c8154472dd99012$var$y();
                g = $6c8154472dd99012$var$ju(e, v, n);
            }
            if (!s.contains(g)) throw new $6c8154472dd99012$var$c($6c8154472dd99012$var$a.INVALID_ARGUMENT, "Field '" + g + "' is specified in your field mask but missing from your input data.");
            $6c8154472dd99012$var$zu(l, g) || l.push(g);
        }
        u = new $6c8154472dd99012$var$an(l), h = s.fieldTransforms.filter(function(t) {
            return u.Ye(t.field);
        });
    } else u = null, h = s.fieldTransforms;
    return new $6c8154472dd99012$var$Su(new $6c8154472dd99012$var$Sn(f), u, h);
}
/** Parse update data from an update() call. */ function $6c8154472dd99012$var$Ou(t, e, n, r) {
    var i = t.P_(1 /* Update */ , e, n);
    $6c8154472dd99012$var$Mu("Data must be an object, but it was:", i, r);
    var o = [], s = new $6c8154472dd99012$var$Dn;
    $6c8154472dd99012$var$_(r, function(t, r) {
        var u = $6c8154472dd99012$var$ju(e, t, n), a = i.A_(u);
        if (r instanceof $6c8154472dd99012$var$gu || r instanceof $6c8154472dd99012$var$Tu && r.l_ instanceof $6c8154472dd99012$var$gu) // Add it to the field mask, but don't add anything to updateData.
        o.push(u);
        else {
            var c = $6c8154472dd99012$var$Uu(r, a);
            null != c && (o.push(u), s.set(u, c));
        }
    });
    var u = new $6c8154472dd99012$var$an(o);
    return new $6c8154472dd99012$var$Du(s.Xe(), u, i.fieldTransforms);
}
/** Parse update data from a list of field/value arguments. */ function $6c8154472dd99012$var$Pu(t, e, n, r, i, o) {
    var s = t.P_(1 /* Update */ , e, n), u = [
        $6c8154472dd99012$var$qu(e, r, n)
    ], h = [
        i
    ];
    if (o.length % 2 != 0) throw new $6c8154472dd99012$var$c($6c8154472dd99012$var$a.INVALID_ARGUMENT, "Function " + e + "() needs to be called with an even number of arguments that alternate between field names and values.");
    for(var f = 0; f < o.length; f += 2)u.push($6c8154472dd99012$var$qu(e, o[f])), h.push(o[f + 1]);
    // We iterate in reverse order to pick the last value for a field if the
    // user specified the field multiple times.
    for(var l = [], p = new $6c8154472dd99012$var$Dn, d = u.length - 1; d >= 0; --d)if (!$6c8154472dd99012$var$zu(l, u[d])) {
        var v = u[d], y = h[d], g = s.A_(v);
        if (y instanceof $6c8154472dd99012$var$gu || y instanceof $6c8154472dd99012$var$Tu && y.l_ instanceof $6c8154472dd99012$var$gu) // Add it to the field mask, but don't add anything to updateData.
        l.push(v);
        else {
            var m = $6c8154472dd99012$var$Uu(y, g);
            null != m && (l.push(v), p.set(v, m));
        }
    }
    var w = new $6c8154472dd99012$var$an(l);
    return new $6c8154472dd99012$var$Du(p.Xe(), w, s.fieldTransforms);
}
/**
 * Parse a "query value" (e.g. value in a where filter or a value in a cursor
 * bound).
 *
 * @param allowArrays Whether the query value is an array that may directly
 * contain additional arrays (e.g. the operand of an `in` query).
 */ function $6c8154472dd99012$var$Vu(t, e, n, r) {
    return void 0 === r && (r = !1), $6c8154472dd99012$var$Uu(n, t.P_(r ? 4 /* ArrayArgument */  : 3 /* Argument */ , e));
}
/**
 * Parses user data to Protobuf Values.
 *
 * @param input Data to be parsed.
 * @param context A context object representing the current path being parsed,
 * the source of the data being parsed, etc.
 * @return The parsed value, or null if the value was a FieldValue sentinel
 * that should not be included in the resulting parsed data.
 */ function $6c8154472dd99012$var$Uu(t, e) {
    if (// Unwrap the API type from the Compat SDK. This will return the API type
    // from firestore-exp.
    t instanceof $6c8154472dd99012$var$Tu && (t = t.l_), $6c8154472dd99012$var$Fu(t)) return $6c8154472dd99012$var$Mu("Unsupported field value:", e, t), $6c8154472dd99012$var$Cu(t, e);
    if (t instanceof $6c8154472dd99012$var$yu) // FieldValues usually parse into transforms (except FieldValue.delete())
    // in which case we do not want to include this field in our parsed data
    // (as doing so will overwrite the field directly prior to the transform
    // trying to transform it). So we don't add this location to
    // context.fieldMask and we return null as our parsing result.
    /**
     * "Parses" the provided FieldValueImpl, adding any necessary transforms to
     * context.fieldTransforms.
     */ return function(t, e) {
        // Sentinels are only supported with writes, and not within arrays.
        if (!$6c8154472dd99012$var$xu(e.s_)) throw e.i_(t.e_ + "() can only be used with update() and set()");
        if (!e.path) throw e.i_(t.e_ + "() is not currently supported inside arrays");
        var n = t.n_(e);
        n && e.fieldTransforms.push(n);
    }(t, e), null;
    if (// If context.path is null we are inside an array and we don't support
    // field mask paths more granular than the top-level array.
    e.path && e.We.push(e.path), t instanceof Array) {
        // TODO(b/34871131): Include the path containing the array in the error
        // message.
        // In the case of IN queries, the parsed data is an array (representing
        // the set of values to be included for the IN query) that may directly
        // contain additional arrays (each representing an individual field
        // value), so we disable this validation.
        if (e.settings.o_ && 4 /* ArrayArgument */  !== e.s_) throw e.i_("Nested arrays are not supported");
        return function(t, e) {
            for(var n = [], r = 0, i = 0, o = t; i < o.length; i++){
                var s = $6c8154472dd99012$var$Uu(o[i], e.R_(r));
                null == s && // Just include nulls in the array for fields being replaced with a
                // sentinel.
                (s = {
                    nullValue: "NULL_VALUE"
                }), n.push(s), r++;
            }
            return {
                arrayValue: {
                    values: n
                }
            };
        }(t, e);
    }
    return function(t, e) {
        if (null === t) return {
            nullValue: "NULL_VALUE"
        };
        if ("number" == typeof t) return $6c8154472dd99012$var$we(e.serializer, t);
        if ("boolean" == typeof t) return {
            booleanValue: t
        };
        if ("string" == typeof t) return {
            stringValue: t
        };
        if (t instanceof Date) {
            var n = $6c8154472dd99012$var$ot.fromDate(t);
            return {
                timestampValue: $6c8154472dd99012$var$_e(e.serializer, n)
            };
        }
        if (t instanceof $6c8154472dd99012$var$ot) {
            // Firestore backend truncates precision down to microseconds. To ensure
            // offline mode works the same with regards to truncation, perform the
            // truncation immediately without waiting for the backend to do that.
            var r = new $6c8154472dd99012$var$ot(t.seconds, 1e3 * Math.floor(t.nanoseconds / 1e3));
            return {
                timestampValue: $6c8154472dd99012$var$_e(e.serializer, r)
            };
        }
        if (t instanceof $6c8154472dd99012$var$Eu) return {
            geoPointValue: {
                latitude: t.latitude,
                longitude: t.longitude
            }
        };
        if (t instanceof $6c8154472dd99012$var$J) return {
            bytesValue: $6c8154472dd99012$var$be(e.serializer, t.q)
        };
        if (t instanceof $6c8154472dd99012$var$Au) {
            var i = e.U, o = t.__;
            if (!o.isEqual(i)) throw e.i_("Document reference is for database " + o.projectId + "/" + o.database + " but should be for database " + i.projectId + "/" + i.database);
            return {
                referenceValue: $6c8154472dd99012$var$Te(t.__ || e.U, t.f_.path)
            };
        }
        if (void 0 === t && e.ignoreUndefinedProperties) return null;
        throw e.i_("Unsupported field value: " + $6c8154472dd99012$var$M(t));
    }(t, e);
}
function $6c8154472dd99012$var$Cu(t, e) {
    var n = {};
    return $6c8154472dd99012$var$b(t) ? // If we encounter an empty object, we explicitly add it to the update
    // mask to ensure that the server creates a map entry.
    e.path && e.path.length > 0 && e.We.push(e.path) : $6c8154472dd99012$var$_(t, function(t, r) {
        var i = $6c8154472dd99012$var$Uu(r, e.E_(t));
        null != i && (n[t] = i);
    }), {
        mapValue: {
            fields: n
        }
    };
}
function $6c8154472dd99012$var$Fu(t) {
    return !("object" != typeof t || null === t || t instanceof Array || t instanceof Date || t instanceof $6c8154472dd99012$var$ot || t instanceof $6c8154472dd99012$var$Eu || t instanceof $6c8154472dd99012$var$J || t instanceof $6c8154472dd99012$var$Au || t instanceof $6c8154472dd99012$var$yu);
}
function $6c8154472dd99012$var$Mu(t, e, n) {
    if (!$6c8154472dd99012$var$Fu(n) || !$6c8154472dd99012$var$F(n)) {
        var r = $6c8154472dd99012$var$M(n);
        throw "an object" === r ? e.i_(t + " a custom object") : e.i_(t + " " + r);
    }
}
/**
 * Helper that calls fromDotSeparatedString() but wraps any error thrown.
 */ function $6c8154472dd99012$var$qu(t, e, n) {
    if (e instanceof $6c8154472dd99012$var$pu) return e.t_;
    if ("string" == typeof e) return $6c8154472dd99012$var$ju(t, e);
    throw $6c8154472dd99012$var$Gu("Field path arguments must be of type string or FieldPath.", t, /* hasConverter= */ !1, /* path= */ void 0, n);
}
/**
 * Wraps fromDotSeparatedString with an error message about the method that
 * was thrown.
 * @param methodName The publicly visible method name
 * @param path The dot-separated string form of a field path which will be split
 * on dots.
 * @param targetDoc The document against which the field path will be evaluated.
 */ function $6c8154472dd99012$var$ju(e, n, r) {
    try {
        return function(e) {
            if (e.search($6c8154472dd99012$var$vu) >= 0) throw new $6c8154472dd99012$var$c($6c8154472dd99012$var$a.INVALID_ARGUMENT, "Invalid field path (" + e + "). Paths must not contain '~', '*', '/', '[', or ']'");
            try {
                return new ($6c8154472dd99012$var$du.bind.apply($6c8154472dd99012$var$du, $876a70688d8d7977$export$6388937ca91ccae8([
                    void 0
                ], e.split("."))));
            } catch (t) {
                throw new $6c8154472dd99012$var$c($6c8154472dd99012$var$a.INVALID_ARGUMENT, "Invalid field path (" + e + "). Paths must not be empty, begin with '.', end with '.', or contain '..'");
            }
        }(n).t_;
    } catch (n) {
        throw $6c8154472dd99012$var$Gu((i = n) instanceof Error ? i.message : i.toString(), e, /* hasConverter= */ !1, /* path= */ void 0, r);
    }
    /**
 * Extracts the message from a caught exception, which should be an Error object
 * though JS doesn't guarantee that.
 */ var i;
/** Checks `haystack` if FieldPath `needle` is present. Runs in O(n). */ }
function $6c8154472dd99012$var$Gu(t, e, n, r, i) {
    var o = r && !r.m(), s = void 0 !== i, u = "Function " + e + "() called with invalid data";
    n && (u += " (via `toFirestore()`)");
    var h = "";
    return (o || s) && (h += " (found", o && (h += " in field " + r), s && (h += " in document " + i), h += ")"), new $6c8154472dd99012$var$c($6c8154472dd99012$var$a.INVALID_ARGUMENT, (u += ". ") + t + h);
}
function $6c8154472dd99012$var$zu(t, e) {
    return t.some(function(t) {
        return t.isEqual(e);
    });
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Internal transaction object responsible for accumulating the mutations to
 * perform and the base versions for any documents read.
 */ var $6c8154472dd99012$var$Bu = /** @class */ function() {
    function e(t) {
        this.Ku = t, // The version of each document that was read during this transaction.
        this.y_ = new Map, this.mutations = [], this.V_ = !1, /**
             * A deferred usage error that occurred previously in this transaction that
             * will cause the transaction to fail once it actually commits.
             */ this.p_ = null, /**
             * Set of documents that have been written in the transaction.
             *
             * When there's more than one write to the same key in a transaction, any
             * writes after the first are handled differently.
             */ this.b_ = new Set;
    }
    return e.prototype.v_ = function(e) {
        return $876a70688d8d7977$export$1050f835b63b671e(this, void 0, void 0, function() {
            var n, r = this;
            return $876a70688d8d7977$export$67ebef60e6f28a6(this, function(i) {
                switch(i.label){
                    case 0:
                        if (this.S_(), this.mutations.length > 0) throw new $6c8154472dd99012$var$c($6c8154472dd99012$var$a.INVALID_ARGUMENT, "Firestore transactions require all reads to be executed before all writes.");
                        return [
                            4 /*yield*/ ,
                            function(e, n) {
                                return $876a70688d8d7977$export$1050f835b63b671e(this, void 0, void 0, function() {
                                    var r, i, o, s, u, a;
                                    return $876a70688d8d7977$export$67ebef60e6f28a6(this, function(t) {
                                        switch(t.label){
                                            case 0:
                                                return r = $6c8154472dd99012$var$m(e), i = $6c8154472dd99012$var$Le(r.serializer) + "/documents", o = {
                                                    documents: n.map(function(t) {
                                                        return $6c8154472dd99012$var$Ae(r.serializer, t);
                                                    })
                                                }, [
                                                    4 /*yield*/ ,
                                                    r.ku("BatchGetDocuments", i, o)
                                                ];
                                            case 1:
                                                return s = t.sent(), u = new Map, s.forEach(function(t) {
                                                    var e = function(t, e) {
                                                        return "found" in e ? function(t, e) {
                                                            $6c8154472dd99012$var$g(!!e.found), e.found.name, e.found.updateTime;
                                                            var n = $6c8154472dd99012$var$Se(t, e.found.name), r = $6c8154472dd99012$var$Ee(e.found.updateTime), i = new $6c8154472dd99012$var$Sn({
                                                                mapValue: {
                                                                    fields: e.found.fields
                                                                }
                                                            });
                                                            return new $6c8154472dd99012$var$kn(n, r, i, {});
                                                        }(t, e) : "missing" in e ? function(t, e) {
                                                            $6c8154472dd99012$var$g(!!e.missing), $6c8154472dd99012$var$g(!!e.readTime);
                                                            var n = $6c8154472dd99012$var$Se(t, e.missing), r = $6c8154472dd99012$var$Ee(e.readTime);
                                                            return new $6c8154472dd99012$var$Rn(n, r);
                                                        }(t, e) : $6c8154472dd99012$var$y();
                                                    }(r.serializer, t);
                                                    u.set(e.key.toString(), e);
                                                }), a = [], [
                                                    2 /*return*/ ,
                                                    (n.forEach(function(t) {
                                                        var e = u.get(t.toString());
                                                        $6c8154472dd99012$var$g(!!e), a.push(e);
                                                    }), a)
                                                ];
                                        }
                                    });
                                });
                            }(this.Ku, e)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            ((n = i.sent()).forEach(function(t) {
                                t instanceof $6c8154472dd99012$var$Rn || t instanceof $6c8154472dd99012$var$kn ? r.D_(t) : $6c8154472dd99012$var$y();
                            }), n)
                        ];
                }
            });
        });
    }, e.prototype.set = function(t, e) {
        this.write(e.w_(t, this.Ge(t))), this.b_.add(t.toString());
    }, e.prototype.update = function(t, e) {
        try {
            this.write(e.w_(t, this.C_(t)));
        } catch (t) {
            this.p_ = t;
        }
        this.b_.add(t.toString());
    }, e.prototype.delete = function(t) {
        this.write([
            new $6c8154472dd99012$var$Nn(t, this.Ge(t))
        ]), this.b_.add(t.toString());
    }, e.prototype.commit = function() {
        return $876a70688d8d7977$export$1050f835b63b671e(this, void 0, void 0, function() {
            var e, n = this;
            return $876a70688d8d7977$export$67ebef60e6f28a6(this, function(r) {
                switch(r.label){
                    case 0:
                        if (this.S_(), this.p_) throw this.p_;
                        return e = this.y_, // For each mutation, note that the doc was written.
                        this.mutations.forEach(function(t) {
                            e.delete(t.key.toString());
                        }), // For each document that was read but not written to, we want to perform
                        // a `verify` operation.
                        e.forEach(function(t, e) {
                            var r = $6c8154472dd99012$var$A.D(e);
                            n.mutations.push(new $6c8154472dd99012$var$An(r, n.Ge(r)));
                        }), [
                            4 /*yield*/ ,
                            function(e, n) {
                                return $876a70688d8d7977$export$1050f835b63b671e(this, void 0, void 0, function() {
                                    var r, i, o;
                                    return $876a70688d8d7977$export$67ebef60e6f28a6(this, function(t) {
                                        switch(t.label){
                                            case 0:
                                                return r = $6c8154472dd99012$var$m(e), i = $6c8154472dd99012$var$Le(r.serializer) + "/documents", o = {
                                                    writes: n.map(function(t) {
                                                        return $6c8154472dd99012$var$Oe(r.serializer, t);
                                                    })
                                                }, [
                                                    4 /*yield*/ ,
                                                    r.$u("Commit", i, o)
                                                ];
                                            case 1:
                                                return t.sent(), [
                                                    2 /*return*/ 
                                                ];
                                        }
                                    });
                                });
                            }(this.Ku, this.mutations)
                        ];
                    case 1:
                        // For each mutation, note that the doc was written.
                        return r.sent(), this.V_ = !0, [
                            2 /*return*/ 
                        ];
                }
            });
        });
    }, e.prototype.D_ = function(t) {
        var e;
        if (t instanceof $6c8154472dd99012$var$kn) e = t.version;
        else {
            if (!(t instanceof $6c8154472dd99012$var$Rn)) throw $6c8154472dd99012$var$y();
            // For deleted docs, we must use baseVersion 0 when we overwrite them.
            e = $6c8154472dd99012$var$st.min();
        }
        var n = this.y_.get(t.key.toString());
        if (n) {
            if (!e.isEqual(n)) // This transaction will fail no matter what.
            throw new $6c8154472dd99012$var$c($6c8154472dd99012$var$a.ABORTED, "Document version changed between two reads.");
        } else this.y_.set(t.key.toString(), e);
    }, /**
     * Returns the version of this document when it was read in this transaction,
     * as a precondition, or no precondition if it was not read.
     */ e.prototype.Ge = function(t) {
        var e = this.y_.get(t.toString());
        return !this.b_.has(t.toString()) && e ? $6c8154472dd99012$var$fn.updateTime(e) : $6c8154472dd99012$var$fn.ze();
    }, /**
     * Returns the precondition for a document if the operation is an update.
     */ e.prototype.C_ = function(t) {
        var e = this.y_.get(t.toString());
        // The first time a document is written, we want to take into account the
        // read time and existence
        if (!this.b_.has(t.toString()) && e) {
            if (e.isEqual($6c8154472dd99012$var$st.min())) // The document doesn't exist, so fail the transaction.
            // This has to be validated locally because you can't send a
            // precondition that a document does not exist without changing the
            // semantics of the backend write to be an insert. This is the reverse
            // of what we want, since we want to assert that the document doesn't
            // exist but then send the update and have it fail. Since we can't
            // express that to the backend, we have to validate locally.
            // Note: this can change once we can send separate verify writes in the
            // transaction.
            throw new $6c8154472dd99012$var$c($6c8154472dd99012$var$a.INVALID_ARGUMENT, "Can't update a document that doesn't exist.");
            // Document exists, base precondition on document update time.
            return $6c8154472dd99012$var$fn.updateTime(e);
        }
        // Document was not read, so we just use the preconditions for a blind
        // update.
        return $6c8154472dd99012$var$fn.exists(!0);
    }, e.prototype.write = function(t) {
        this.S_(), this.mutations = this.mutations.concat(t);
    }, e.prototype.S_ = function() {}, e;
}(), $6c8154472dd99012$var$Wu = /** @class */ function() {
    function e(t, e, n, r) {
        this.cs = t, this.Ku = e, this.updateFunction = n, this.ls = r, this.N_ = 5, this.ys = new $6c8154472dd99012$var$vr(this.cs, "transaction_retry" /* TransactionRetry */ ) /** Runs the transaction and sets the result on deferred. */ ;
    }
    return e.prototype.run = function() {
        this.F_();
    }, e.prototype.F_ = function() {
        var e = this;
        this.ys.gn(function() {
            return $876a70688d8d7977$export$1050f835b63b671e(e, void 0, void 0, function() {
                var e, n, r = this;
                return $876a70688d8d7977$export$67ebef60e6f28a6(this, function(t) {
                    return e = new $6c8154472dd99012$var$Bu(this.Ku), (n = this.x_(e)) && n.then(function(t) {
                        r.cs.ws(function() {
                            return e.commit().then(function() {
                                r.ls.resolve(t);
                            }).catch(function(t) {
                                r.k_(t);
                            });
                        });
                    }).catch(function(t) {
                        r.k_(t);
                    }), [
                        2 /*return*/ 
                    ];
                });
            });
        });
    }, e.prototype.x_ = function(t) {
        try {
            var e = this.updateFunction(t);
            return !$6c8154472dd99012$var$ut(e) && e.catch && e.then ? e : (this.ls.reject(Error("Transaction callback must return a Promise")), null);
        } catch (t) {
            // Do not retry errors thrown by user provided updateFunction.
            return this.ls.reject(t), null;
        }
    }, e.prototype.k_ = function(t) {
        var e = this;
        this.N_ > 0 && this.M_(t) ? (this.N_ -= 1, this.cs.ws(function() {
            return e.F_(), Promise.resolve();
        })) : this.ls.reject(t);
    }, e.prototype.M_ = function(t) {
        if ("FirebaseError" === t.name) {
            // In transactions, the backend will fail outdated reads with FAILED_PRECONDITION and
            // non-matching document versions with ABORTED. These errors should be retried.
            var e = t.code;
            return "aborted" === e || "failed-precondition" === e || !$6c8154472dd99012$var$wt(e);
        }
        return !1;
    }, e;
}(), $6c8154472dd99012$var$Ku = /** @class */ function() {
    function e(t, /**
     * Asynchronous queue responsible for all of our internal processing. When
     * we get incoming work from the user (via public API) or the network
     * (incoming GRPC messages), we should always schedule onto this queue.
     * This ensures all of our work is properly serialized (e.g. we don't
     * start processing a new operation while the previous one is waiting for
     * an async I/O to complete).
     */ e) {
        this.credentials = t, this.cs = e, this.clientId = $6c8154472dd99012$var$Q.k(), // We defer our initialization until we get the current user from
        // setChangeListener(). We block the async queue until we got the initial
        // user and the initialization is completed. This will prevent any scheduled
        // work from happening before initialization is completed.
        // If initializationDone resolved then the FirestoreClient is in a usable
        // state.
        this.O_ = new $6c8154472dd99012$var$dr /**
     * Starts up the FirestoreClient, returning only whether or not enabling
     * persistence succeeded.
     *
     * The intent here is to "do the right thing" as far as users are concerned.
     * Namely, in cases where offline persistence is requested and possible,
     * enable it, but otherwise fall back to persistence disabled. For the most
     * part we expect this to succeed one way or the other so we don't expect our
     * users to actually wait on the firestore.enablePersistence Promise since
     * they generally won't care.
     *
     * Of course some users actually do care about whether or not persistence
     * was successfully enabled, so the Promise returned from this method
     * indicates this outcome.
     *
     * This presents a problem though: even before enablePersistence resolves or
     * rejects, users may have made calls to e.g. firestore.collection() which
     * means that the FirestoreClient in there will be available and will be
     * enqueuing actions on the async queue.
     *
     * Meanwhile any failure of an operation on the async queue causes it to
     * panic and reject any further work, on the premise that unhandled errors
     * are fatal.
     *
     * Consequently the fallback is handled internally here in start, and if the
     * fallback succeeds we signal success to the async queue even though the
     * start() itself signals failure.
     *
     * @param databaseInfo The connection information for the current instance.
     * @param offlineComponentProvider Provider that returns all components
     * required for memory-only or IndexedDB persistence.
     * @param onlineComponentProvider Provider that returns all components
     * required for online support.
     * @param persistenceSettings Settings object to configure offline
     *     persistence.
     * @returns A deferred result indicating the user-visible result of enabling
     *     offline persistence. This method will reject this if IndexedDB fails to
     *     start for any reason. If usePersistence is false this is
     *     unconditionally resolved.
     */ ;
    }
    return e.prototype.start = function(e, n, r, i) {
        var o = this;
        this.L_(), this.bl = e;
        // If usePersistence is true, certain classes of errors while starting are
        // recoverable but only by falling back to persistence disabled.
        // If there's an error in the first case but not in recovery we cannot
        // reject the promise blocking the async queue because this will cause the
        // async queue to panic.
        var s = new $6c8154472dd99012$var$dr, u = !1;
        // Return only the result of enabling persistence. Note that this does not
        // need to await the completion of initializationDone because the result of
        // this method should not reflect any other kind of failure to start.
        return this.credentials.Hc(function(e) {
            if (!u) return u = !0, $6c8154472dd99012$var$l("FirestoreClient", "Initializing. user=", e.uid), o.B_(n, r, i, e, s).then(o.O_.resolve, o.O_.reject);
            o.cs.Cs(function() {
                return function(e, n) {
                    return $876a70688d8d7977$export$1050f835b63b671e(this, void 0, void 0, function() {
                        var r, i;
                        return $876a70688d8d7977$export$67ebef60e6f28a6(this, function(t) {
                            switch(t.label){
                                case 0:
                                    return (r = $6c8154472dd99012$var$m(e)).cs.xs(), $6c8154472dd99012$var$l("RemoteStore", "RemoteStore received new credentials"), i = $6c8154472dd99012$var$Xo(r), // Tear down and re-create our network streams. This will ensure we get a
                                    // fresh auth token for the new user and re-fill the write pipeline with
                                    // new mutations from the LocalStore (since mutations are per-user).
                                    r.Yu.add(3 /* CredentialChange */ ), [
                                        4 /*yield*/ ,
                                        $6c8154472dd99012$var$zo(r)
                                    ];
                                case 1:
                                    return t.sent(), i && // Don't set the network status to Unknown if we are offline.
                                    r.th.set("Unknown" /* Unknown */ ), [
                                        4 /*yield*/ ,
                                        r.Gu.Jl(n)
                                    ];
                                case 2:
                                    return t.sent(), r.Yu.delete(3 /* CredentialChange */ ), [
                                        4 /*yield*/ ,
                                        $6c8154472dd99012$var$Go(r)
                                    ];
                                case 3:
                                    // Tear down and re-create our network streams. This will ensure we get a
                                    // fresh auth token for the new user and re-fill the write pipeline with
                                    // new mutations from the LocalStore (since mutations are per-user).
                                    return t.sent(), [
                                        2 /*return*/ 
                                    ];
                            }
                        });
                    });
                }(o.ph, e);
            });
        }), // Block the async queue until initialization is done
        this.cs.ws(function() {
            return o.O_.promise;
        }), s.promise;
    }, /** Enables the network connection and requeues all pending operations. */ e.prototype.enableNetwork = function() {
        var t = this;
        return this.L_(), this.cs.enqueue(function() {
            return t.persistence.tc(!0), function(t) {
                var e = $6c8154472dd99012$var$m(t);
                return e.Yu.delete(0 /* UserDisabled */ ), $6c8154472dd99012$var$Go(e);
            }(t.ph);
        });
    }, /**
     * Initializes persistent storage, attempting to use IndexedDB if
     * usePersistence is true or memory-only if false.
     *
     * If IndexedDB fails because it's already open in another tab or because the
     * platform can't possibly support our implementation then this method rejects
     * the persistenceResult and falls back on memory-only persistence.
     *
     * @param offlineComponentProvider Provider that returns all components
     * required for memory-only or IndexedDB persistence.
     * @param onlineComponentProvider Provider that returns all components
     * required for online support.
     * @param persistenceSettings Settings object to configure offline persistence
     * @param user The initial user
     * @param persistenceResult A deferred result indicating the user-visible
     *     result of enabling offline persistence. This method will reject this if
     *     IndexedDB fails to start for any reason. If usePersistence is false
     *     this is unconditionally resolved.
     * @returns a Promise indicating whether or not initialization should
     *     continue, i.e. that one of the persistence implementations actually
     *     succeeded.
     */ e.prototype.B_ = function(e, n, r, i, o) {
        return $876a70688d8d7977$export$1050f835b63b671e(this, void 0, void 0, function() {
            var s, u, a = this;
            return $876a70688d8d7977$export$67ebef60e6f28a6(this, function(c) {
                switch(c.label){
                    case 0:
                        return c.trys.push([
                            0,
                            3,
                            ,
                            4
                        ]), s = {
                            cs: this.cs,
                            bl: this.bl,
                            clientId: this.clientId,
                            credentials: this.credentials,
                            Wl: i,
                            Dh: 100,
                            persistenceSettings: r
                        }, [
                            4 /*yield*/ ,
                            e.initialize(s)
                        ];
                    case 1:
                        return c.sent(), [
                            4 /*yield*/ ,
                            n.initialize(e, s)
                        ];
                    case 2:
                        return c.sent(), this.persistence = e.persistence, this.Sh = e.Sh, this.ju = e.ju, this.ql = e.ql, this.Ku = n.Ku, this.ph = n.ph, this.fi = n.fi, this.q_ = n.bh, this.q_.Us = $6c8154472dd99012$var$_s.bind(null, this.fi), this.q_.js = $6c8154472dd99012$var$Is.bind(null, this.fi), // When a user calls clearPersistence() in one client, all other clients
                        // need to be terminated to allow the delete to succeed.
                        this.persistence.Za(function() {
                            return $876a70688d8d7977$export$1050f835b63b671e(a, void 0, void 0, function() {
                                return $876a70688d8d7977$export$67ebef60e6f28a6(this, function(t) {
                                    switch(t.label){
                                        case 0:
                                            return [
                                                4 /*yield*/ ,
                                                this.terminate()
                                            ];
                                        case 1:
                                            return t.sent(), [
                                                2 /*return*/ 
                                            ];
                                    }
                                });
                            });
                        }), o.resolve(), [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        // An unknown failure on the first stage shuts everything down.
                        if (u = c.sent(), // Regardless of whether or not the retry succeeds, from an user
                        // perspective, offline persistence has failed.
                        o.reject(u), !this.U_(u)) throw u;
                        return [
                            2 /*return*/ ,
                            (console.warn("Error enabling offline persistence. Falling back to persistence disabled: " + u), this.B_(new $6c8154472dd99012$var$cu, new $6c8154472dd99012$var$fu, {
                                jl: !1
                            }, i, o))
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    }, /**
     * Decides whether the provided error allows us to gracefully disable
     * persistence (as opposed to crashing the client).
     */ e.prototype.U_ = function(t) {
        return "FirebaseError" === t.name ? t.code === $6c8154472dd99012$var$a.FAILED_PRECONDITION || t.code === $6c8154472dd99012$var$a.UNIMPLEMENTED : !("undefined" != typeof DOMException && t instanceof DOMException) || // When the browser is out of quota we could get either quota exceeded
        // or an aborted error depending on whether the error happened during
        // schema migration.
        22 === t.code || 20 === t.code || // Firefox Private Browsing mode disables IndexedDb and returns
        // INVALID_STATE for any usage.
        11 === t.code;
    }, /**
     * Checks that the client has not been terminated. Ensures that other methods on
     * this class cannot be called after the client is terminated.
     */ e.prototype.L_ = function() {
        if (this.cs.ps) throw new $6c8154472dd99012$var$c($6c8154472dd99012$var$a.FAILED_PRECONDITION, "The client has already been terminated.");
    }, /** Disables the network connection. Pending operations will not complete. */ e.prototype.disableNetwork = function() {
        var e = this;
        return this.L_(), this.cs.enqueue(function() {
            return e.persistence.tc(!1), function(e) {
                return $876a70688d8d7977$export$1050f835b63b671e(this, void 0, void 0, function() {
                    var n;
                    return $876a70688d8d7977$export$67ebef60e6f28a6(this, function(t) {
                        switch(t.label){
                            case 0:
                                return (n = $6c8154472dd99012$var$m(e)).Yu.add(0 /* UserDisabled */ ), [
                                    4 /*yield*/ ,
                                    $6c8154472dd99012$var$zo(n)
                                ];
                            case 1:
                                return t.sent(), // Set the OnlineState to Offline so get()s return from cache, etc.
                                n.th.set("Offline" /* Offline */ ), [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            }(e.ph);
        });
    }, e.prototype.terminate = function() {
        var e = this;
        this.cs.Ds();
        var n = new $6c8154472dd99012$var$dr;
        return this.cs.bs(function() {
            return $876a70688d8d7977$export$1050f835b63b671e(e, void 0, void 0, function() {
                var e, r;
                return $876a70688d8d7977$export$67ebef60e6f28a6(this, function(t) {
                    switch(t.label){
                        case 0:
                            return t.trys.push([
                                0,
                                4,
                                ,
                                5
                            ]), // PORTING NOTE: LocalStore does not need an explicit shutdown on web.
                            this.ql && this.ql.stop(), [
                                4 /*yield*/ ,
                                $6c8154472dd99012$var$Bo(this.ph)
                            ];
                        case 1:
                            return t.sent(), [
                                4 /*yield*/ ,
                                this.Sh.Di()
                            ];
                        case 2:
                            return t.sent(), [
                                4 /*yield*/ ,
                                this.persistence.Di()
                            ];
                        case 3:
                            // PORTING NOTE: LocalStore does not need an explicit shutdown on web.
                            return t.sent(), // `removeChangeListener` must be called after shutting down the
                            // RemoteStore as it will prevent the RemoteStore from retrieving
                            // auth tokens.
                            this.credentials.Yc(), n.resolve(), [
                                3 /*break*/ ,
                                5
                            ];
                        case 4:
                            return e = t.sent(), r = $6c8154472dd99012$var$Lr(e, "Failed to shutdown persistence"), n.reject(r), [
                                3 /*break*/ ,
                                5
                            ];
                        case 5:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        }), n.promise;
    }, /**
     * Returns a Promise that resolves when all writes that were pending at the time this
     * method was called received server acknowledgement. An acknowledgement can be either acceptance
     * or rejection.
     */ e.prototype.waitForPendingWrites = function() {
        var e = this;
        this.L_();
        var n = new $6c8154472dd99012$var$dr;
        return this.cs.ws(function() {
            return function(e, n) {
                return $876a70688d8d7977$export$1050f835b63b671e(this, void 0, void 0, function() {
                    var r, i, o, s, u;
                    return $876a70688d8d7977$export$67ebef60e6f28a6(this, function(t) {
                        switch(t.label){
                            case 0:
                                $6c8154472dd99012$var$Xo((r = $6c8154472dd99012$var$m(e)).ph) || $6c8154472dd99012$var$l("SyncEngine", "The network is disabled. The task returned by 'awaitPendingWrites()' will not complete until the network is enabled."), t.label = 1;
                            case 1:
                                return t.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]), [
                                    4 /*yield*/ ,
                                    function(t) {
                                        var e = $6c8154472dd99012$var$m(t);
                                        return e.persistence.runTransaction("Get highest unacknowledged batch id", "readonly", function(t) {
                                            return e.Sr.qo(t);
                                        });
                                    }(r.ju)
                                ];
                            case 2:
                                return -1 === (i = t.sent()) ? [
                                    2 /*return*/ ,
                                    void n.resolve()
                                ] : ((o = r.Lh.get(i) || []).push(n), r.Lh.set(i, o), [
                                    3 /*break*/ ,
                                    4
                                ]);
                            case 3:
                                return s = t.sent(), u = $6c8154472dd99012$var$Lr(s, "Initialization of waitForPendingWrites() operation failed"), n.reject(u), [
                                    3 /*break*/ ,
                                    4
                                ];
                            case 4:
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            }(e.fi, n);
        }), n.promise;
    }, e.prototype.listen = function(t, e, n) {
        var r = this;
        this.L_();
        var i = new $6c8154472dd99012$var$lu(n), o = new $6c8154472dd99012$var$Fr(t, i, e);
        return this.cs.ws(function() {
            return $6c8154472dd99012$var$Or(r.q_, o);
        }), function() {
            i.Zl(), r.cs.ws(function() {
                return $6c8154472dd99012$var$Pr(r.q_, o);
            });
        };
    }, e.prototype.Q_ = function(e) {
        return $876a70688d8d7977$export$1050f835b63b671e(this, void 0, void 0, function() {
            var n, r = this;
            return $876a70688d8d7977$export$67ebef60e6f28a6(this, function(i) {
                switch(i.label){
                    case 0:
                        return this.L_(), [
                            4 /*yield*/ ,
                            this.O_.promise
                        ];
                    case 1:
                        return i.sent(), n = new $6c8154472dd99012$var$dr, [
                            2 /*return*/ ,
                            (this.cs.ws(function() {
                                return function(e, n, r) {
                                    return $876a70688d8d7977$export$1050f835b63b671e(this, void 0, void 0, function() {
                                        var i, o, s;
                                        return $876a70688d8d7977$export$67ebef60e6f28a6(this, function(t) {
                                            switch(t.label){
                                                case 0:
                                                    return t.trys.push([
                                                        0,
                                                        2,
                                                        ,
                                                        3
                                                    ]), [
                                                        4 /*yield*/ ,
                                                        function(t, e) {
                                                            var n = $6c8154472dd99012$var$m(t);
                                                            return n.persistence.runTransaction("read document", "readonly", function(t) {
                                                                return n.Cc.Cr(t, e);
                                                            });
                                                        }(e, n)
                                                    ];
                                                case 1:
                                                    return (i = t.sent()) instanceof $6c8154472dd99012$var$kn ? r.resolve(i) : i instanceof $6c8154472dd99012$var$Rn ? r.resolve(null) : r.reject(new $6c8154472dd99012$var$c($6c8154472dd99012$var$a.UNAVAILABLE, "Failed to get document from cache. (However, this document may exist on the server. Run again without setting 'source' in the GetOptions to attempt to retrieve the document from the server.)")), [
                                                        3 /*break*/ ,
                                                        3
                                                    ];
                                                case 2:
                                                    return o = t.sent(), s = $6c8154472dd99012$var$Lr(o, "Failed to get document '" + n + " from cache"), r.reject(s), [
                                                        3 /*break*/ ,
                                                        3
                                                    ];
                                                case 3:
                                                    return [
                                                        2 /*return*/ 
                                                    ];
                                            }
                                        });
                                    });
                                }(r.ju, e, n);
                            }), n.promise)
                        ];
                }
            });
        });
    }, e.prototype.W_ = function(e, n) {
        return void 0 === n && (n = {}), $876a70688d8d7977$export$1050f835b63b671e(this, void 0, void 0, function() {
            var r, i = this;
            return $876a70688d8d7977$export$67ebef60e6f28a6(this, function(t) {
                switch(t.label){
                    case 0:
                        return this.L_(), [
                            4 /*yield*/ ,
                            this.O_.promise
                        ];
                    case 1:
                        return t.sent(), r = new $6c8154472dd99012$var$dr, [
                            2 /*return*/ ,
                            (this.cs.ws(function() {
                                return function(t, e, n, r, i) {
                                    var o = new $6c8154472dd99012$var$lu({
                                        next: function(o) {
                                            // Remove query first before passing event to user to avoid
                                            // user actions affecting the now stale query.
                                            e.ws(function() {
                                                return $6c8154472dd99012$var$Pr(t, s);
                                            });
                                            var u = o.docs.has(n);
                                            !u && o.fromCache ? // TODO(dimond): If we're online and the document doesn't
                                            // exist then we resolve with a doc.exists set to false. If
                                            // we're offline however, we reject the Promise in this
                                            // case. Two options: 1) Cache the negative response from
                                            // the server so we can deliver that even when you're
                                            // offline 2) Actually reject the Promise in the online case
                                            // if the document doesn't exist.
                                            i.reject(new $6c8154472dd99012$var$c($6c8154472dd99012$var$a.UNAVAILABLE, "Failed to get document because the client is offline.")) : u && o.fromCache && r && "server" === r.source ? i.reject(new $6c8154472dd99012$var$c($6c8154472dd99012$var$a.UNAVAILABLE, 'Failed to get document from server. (However, this document does exist in the local cache. Run again without setting source to "server" to retrieve the cached document.)')) : i.resolve(o);
                                        },
                                        error: function(t) {
                                            return i.reject(t);
                                        }
                                    }), s = new $6c8154472dd99012$var$Fr($6c8154472dd99012$var$Un(n.path), o, {
                                        includeMetadataChanges: !0,
                                        Xs: !0
                                    });
                                    return $6c8154472dd99012$var$Or(t, s);
                                }(i.q_, i.cs, e, n, r);
                            }), r.promise)
                        ];
                }
            });
        });
    }, e.prototype.j_ = function(e) {
        return $876a70688d8d7977$export$1050f835b63b671e(this, void 0, void 0, function() {
            var n, r = this;
            return $876a70688d8d7977$export$67ebef60e6f28a6(this, function(i) {
                switch(i.label){
                    case 0:
                        return this.L_(), [
                            4 /*yield*/ ,
                            this.O_.promise
                        ];
                    case 1:
                        return i.sent(), n = new $6c8154472dd99012$var$dr, [
                            2 /*return*/ ,
                            (this.cs.ws(function() {
                                return function(e, n, r) {
                                    return $876a70688d8d7977$export$1050f835b63b671e(this, void 0, void 0, function() {
                                        var i, o, s, u, a, c;
                                        return $876a70688d8d7977$export$67ebef60e6f28a6(this, function(t) {
                                            switch(t.label){
                                                case 0:
                                                    return t.trys.push([
                                                        0,
                                                        2,
                                                        ,
                                                        3
                                                    ]), [
                                                        4 /*yield*/ ,
                                                        $6c8154472dd99012$var$To(e, n, /* usePreviousResults= */ !0)
                                                    ];
                                                case 1:
                                                    return i = t.sent(), o = new $6c8154472dd99012$var$ys(n, i.Fc), s = o.wh(i.documents), u = o.yr(s, /* updateLimboDocuments= */ !1), r.resolve(u.snapshot), [
                                                        3 /*break*/ ,
                                                        3
                                                    ];
                                                case 2:
                                                    return a = t.sent(), c = $6c8154472dd99012$var$Lr(a, "Failed to execute query '" + n + " against cache"), r.reject(c), [
                                                        3 /*break*/ ,
                                                        3
                                                    ];
                                                case 3:
                                                    return [
                                                        2 /*return*/ 
                                                    ];
                                            }
                                        });
                                    });
                                }(r.ju, e, n);
                            }), n.promise)
                        ];
                }
            });
        });
    }, e.prototype.K_ = function(e, n) {
        return void 0 === n && (n = {}), $876a70688d8d7977$export$1050f835b63b671e(this, void 0, void 0, function() {
            var r, i = this;
            return $876a70688d8d7977$export$67ebef60e6f28a6(this, function(t) {
                switch(t.label){
                    case 0:
                        return this.L_(), [
                            4 /*yield*/ ,
                            this.O_.promise
                        ];
                    case 1:
                        return t.sent(), r = new $6c8154472dd99012$var$dr, [
                            2 /*return*/ ,
                            (this.cs.ws(function() {
                                return function(t, e, n, r, i) {
                                    var o = new $6c8154472dd99012$var$lu({
                                        next: function(n) {
                                            // Remove query first before passing event to user to avoid
                                            // user actions affecting the now stale query.
                                            e.ws(function() {
                                                return $6c8154472dd99012$var$Pr(t, s);
                                            }), n.fromCache && "server" === r.source ? i.reject(new $6c8154472dd99012$var$c($6c8154472dd99012$var$a.UNAVAILABLE, 'Failed to get documents from server. (However, these documents may exist in the local cache. Run again without setting source to "server" to retrieve the cached documents.)')) : i.resolve(n);
                                        },
                                        error: function(t) {
                                            return i.reject(t);
                                        }
                                    }), s = new $6c8154472dd99012$var$Fr(n, o, {
                                        includeMetadataChanges: !0,
                                        Xs: !0
                                    });
                                    return $6c8154472dd99012$var$Or(t, s);
                                }(i.q_, i.cs, e, n, r);
                            }), r.promise)
                        ];
                }
            });
        });
    }, e.prototype.write = function(e) {
        var n = this;
        this.L_();
        var r = new $6c8154472dd99012$var$dr;
        return this.cs.ws(function() {
            return function(e, n, r) {
                return $876a70688d8d7977$export$1050f835b63b671e(this, void 0, void 0, function() {
                    var i, o, s, u;
                    return $876a70688d8d7977$export$67ebef60e6f28a6(this, function(t) {
                        switch(t.label){
                            case 0:
                                i = $6c8154472dd99012$var$Qs(e), t.label = 1;
                            case 1:
                                return t.trys.push([
                                    1,
                                    5,
                                    ,
                                    6
                                ]), [
                                    4 /*yield*/ ,
                                    /* Accepts locally generated Mutations and commit them to storage. */ function(t, e) {
                                        var n, r = $6c8154472dd99012$var$m(t), i = $6c8154472dd99012$var$ot.now(), o = e.reduce(function(t, e) {
                                            return t.add(e.key);
                                        }, $6c8154472dd99012$var$Ot());
                                        return r.persistence.runTransaction("Locally write mutations", "readwrite", function(t) {
                                            return r.Cc.kr(t, o).next(function(o) {
                                                n = o;
                                                for(// For non-idempotent mutations (such as `FieldValue.increment()`),
                                                // we record the base state in a separate patch mutation. This is
                                                // later used to guarantee consistent values and prevents flicker
                                                // even if the backend sends us an update that already includes our
                                                // transform.
                                                var s = [], u = 0, a = e; u < a.length; u++){
                                                    var c = a[u], h = $6c8154472dd99012$var$yn(c, n.get(c.key));
                                                    null != h && // NOTE: The base state should only be applied if there's some
                                                    // existing document to override, so use a Precondition of
                                                    // exists=true
                                                    s.push(new $6c8154472dd99012$var$_n(c.key, h, $6c8154472dd99012$var$xn(h.proto.mapValue), $6c8154472dd99012$var$fn.exists(!0)));
                                                }
                                                return r.Sr.ko(t, i, s, e);
                                            });
                                        }).then(function(t) {
                                            var e = t.lr(n);
                                            return {
                                                batchId: t.batchId,
                                                wr: e
                                            };
                                        });
                                    }(i.ju, n)
                                ];
                            case 2:
                                return o = t.sent(), i.Sh.xi(o.batchId), function(t, e, n) {
                                    var r = t.Oh[t.currentUser.ti()];
                                    r || (r = new $6c8154472dd99012$var$bt($6c8154472dd99012$var$H)), r = r.ot(e, n), t.Oh[t.currentUser.ti()] = r;
                                }(i, o.batchId, r), [
                                    4 /*yield*/ ,
                                    $6c8154472dd99012$var$Vs(i, o.wr)
                                ];
                            case 3:
                                return t.sent(), [
                                    4 /*yield*/ ,
                                    $6c8154472dd99012$var$is(i.ph)
                                ];
                            case 4:
                                return t.sent(), [
                                    3 /*break*/ ,
                                    6
                                ];
                            case 5:
                                return s = t.sent(), u = $6c8154472dd99012$var$Lr(s, "Failed to persist write"), r.reject(u), [
                                    3 /*break*/ ,
                                    6
                                ];
                            case 6:
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            }(n.fi, e, r);
        }), r.promise;
    }, e.prototype.U = function() {
        return this.bl.U;
    }, e.prototype.G_ = function(e) {
        var n = this;
        this.L_();
        var r = new $6c8154472dd99012$var$lu(e);
        return this.cs.ws(function() {
            return $876a70688d8d7977$export$1050f835b63b671e(n, void 0, void 0, function() {
                return $876a70688d8d7977$export$67ebef60e6f28a6(this, function(t) {
                    return [
                        2 /*return*/ ,
                        function(t, e) {
                            $6c8154472dd99012$var$m(t).qs.add(e), // Immediately fire an initial event, indicating all existing listeners
                            // are in-sync.
                            e.next();
                        }(this.q_, r)
                    ];
                });
            });
        }), function() {
            r.Zl(), n.cs.ws(function() {
                return $876a70688d8d7977$export$1050f835b63b671e(n, void 0, void 0, function() {
                    return $876a70688d8d7977$export$67ebef60e6f28a6(this, function(t) {
                        return [
                            2 /*return*/ ,
                            function(t, e) {
                                $6c8154472dd99012$var$m(t).qs.delete(e);
                            }(this.q_, r)
                        ];
                    });
                });
            });
        };
    }, Object.defineProperty(e.prototype, "z_", {
        get: function() {
            // Technically, the asyncQueue is still running, but only accepting operations
            // related to termination or supposed to be run after termination. It is effectively
            // terminated to the eyes of users.
            return this.cs.ps;
        },
        enumerable: !1,
        configurable: !0
    }), /**
     * Takes an updateFunction in which a set of reads and writes can be performed
     * atomically. In the updateFunction, the client can read and write values
     * using the supplied transaction object. After the updateFunction, all
     * changes will be committed. If a retryable error occurs (ex: some other
     * client has changed any of the data referenced), then the updateFunction
     * will be called again after a backoff. If the updateFunction still fails
     * after all retries, then the transaction will be rejected.
     *
     * The transaction object passed to the updateFunction contains methods for
     * accessing documents and collections. Unlike other datastore access, data
     * accessed with the transaction will not reflect local changes that have not
     * been committed. For this reason, it is required that all reads are
     * performed before any writes. Transactions must be performed while online.
     */ e.prototype.transaction = function(t) {
        var e = this;
        this.L_();
        var n = new $6c8154472dd99012$var$dr;
        return this.cs.ws(function() {
            return new $6c8154472dd99012$var$Wu(e.cs, e.Ku, t, n).run(), Promise.resolve();
        }), n.promise;
    }, e;
}();
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * TransactionRunner encapsulates the logic needed to run and retry transactions
 * with backoff.
 */ function $6c8154472dd99012$var$Qu(t) {
    /**
 * Returns true if obj is an object and contains at least one of the specified
 * methods.
 */ return function(t, e) {
        if ("object" != typeof t || null === t) return !1;
        for(var n = t, r = 0, i = [
            "next",
            "error",
            "complete"
        ]; r < i.length; r++){
            var o = i[r];
            if (o in n && "function" == typeof n[o]) return !0;
        }
        return !1;
    }(t);
}
var $6c8154472dd99012$var$Hu = /** @class */ function() {
    function t(t, e, n, r, i) {
        this.U = t, this.timestampsInSnapshots = e, this.H_ = n, this.Y_ = r, this.J_ = i;
    }
    return t.prototype.X_ = function(t) {
        switch($6c8154472dd99012$var$Jt(t)){
            case 0 /* NullValue */ :
                return null;
            case 1 /* BooleanValue */ :
                return t.booleanValue;
            case 2 /* NumberValue */ :
                return $6c8154472dd99012$var$se(t.integerValue || t.doubleValue);
            case 3 /* TimestampValue */ :
                return this.Z_(t.timestampValue);
            case 4 /* ServerTimestampValue */ :
                return this.tf(t);
            case 5 /* StringValue */ :
                return t.stringValue;
            case 6 /* BlobValue */ :
                return this.J_($6c8154472dd99012$var$ue(t.bytesValue));
            case 7 /* RefValue */ :
                return this.ef(t.referenceValue);
            case 8 /* GeoPointValue */ :
                return this.nf(t.geoPointValue);
            case 9 /* ArrayValue */ :
                return this.sf(t.arrayValue);
            case 10 /* ObjectValue */ :
                return this.if(t.mapValue);
            default:
                throw $6c8154472dd99012$var$y();
        }
    }, t.prototype.if = function(t) {
        var e = this, n = {};
        return $6c8154472dd99012$var$_(t.fields || {}, function(t, r) {
            n[t] = e.X_(r);
        }), n;
    }, t.prototype.nf = function(t) {
        return new $6c8154472dd99012$var$Eu($6c8154472dd99012$var$se(t.latitude), $6c8154472dd99012$var$se(t.longitude));
    }, t.prototype.sf = function(t) {
        var e = this;
        return (t.values || []).map(function(t) {
            return e.X_(t);
        });
    }, t.prototype.tf = function(t) {
        switch(this.H_){
            case "previous":
                var e = $6c8154472dd99012$var$Yt(t);
                return null == e ? null : this.X_(e);
            case "estimate":
                return this.Z_($6c8154472dd99012$var$$t(t));
            default:
                return null;
        }
    }, t.prototype.Z_ = function(t) {
        var e = $6c8154472dd99012$var$oe(t), n = new $6c8154472dd99012$var$ot(e.seconds, e.nanos);
        return this.timestampsInSnapshots ? n : n.toDate();
    }, t.prototype.ef = function(t) {
        var e = $6c8154472dd99012$var$E.g(t);
        $6c8154472dd99012$var$g($6c8154472dd99012$var$He(e));
        var n = new $6c8154472dd99012$var$rt(e.get(1), e.get(3)), r = new $6c8154472dd99012$var$A(e.u(5));
        return n.isEqual(this.U) || // TODO(b/64130202): Somehow support foreign references.
        $6c8154472dd99012$var$p("Document " + r + " contains a document reference within a different database (" + n.projectId + "/" + n.database + ") which is not supported. It will be treated as a reference in the current database (" + this.U.projectId + "/" + this.U.database + ") instead."), this.Y_(r);
    }, t;
}(), $6c8154472dd99012$var$Yu = $6c8154472dd99012$var$ui.ho, $6c8154472dd99012$var$$u = /** @class */ function() {
    function t(t) {
        var e, n, r, i, o;
        if (void 0 === t.host) {
            if (void 0 !== t.ssl) throw new $6c8154472dd99012$var$c($6c8154472dd99012$var$a.INVALID_ARGUMENT, "Can't provide ssl option if host option is not set");
            this.host = "firestore.googleapis.com", this.ssl = !0;
        } else $6c8154472dd99012$var$O("settings", "non-empty string", "host", t.host), this.host = t.host, $6c8154472dd99012$var$P("settings", "boolean", "ssl", t.ssl), this.ssl = null === (e = t.ssl) || void 0 === e || e;
        if ($6c8154472dd99012$var$j("settings", t, [
            "host",
            "ssl",
            "credentials",
            "timestampsInSnapshots",
            "cacheSizeBytes",
            "experimentalForceLongPolling",
            "experimentalAutoDetectLongPolling",
            "ignoreUndefinedProperties"
        ]), $6c8154472dd99012$var$P("settings", "object", "credentials", t.credentials), this.credentials = t.credentials, $6c8154472dd99012$var$P("settings", "boolean", "timestampsInSnapshots", t.timestampsInSnapshots), $6c8154472dd99012$var$P("settings", "boolean", "ignoreUndefinedProperties", t.ignoreUndefinedProperties), // Nobody should set timestampsInSnapshots anymore, but the error depends on
        // whether they set it to true or false...
        !0 === t.timestampsInSnapshots ? $6c8154472dd99012$var$p("The setting 'timestampsInSnapshots: true' is no longer required and should be removed.") : !1 === t.timestampsInSnapshots && $6c8154472dd99012$var$p("Support for 'timestampsInSnapshots: false' will be removed soon. You must update your code to handle Timestamp objects."), this.timestampsInSnapshots = null === (n = t.timestampsInSnapshots) || void 0 === n || n, this.ignoreUndefinedProperties = null !== (r = t.ignoreUndefinedProperties) && void 0 !== r && r, $6c8154472dd99012$var$P("settings", "number", "cacheSizeBytes", t.cacheSizeBytes), void 0 === t.cacheSizeBytes) this.cacheSizeBytes = $6c8154472dd99012$var$ui._o;
        else {
            if (t.cacheSizeBytes !== $6c8154472dd99012$var$Yu && t.cacheSizeBytes < $6c8154472dd99012$var$ui.lo) throw new $6c8154472dd99012$var$c($6c8154472dd99012$var$a.INVALID_ARGUMENT, "cacheSizeBytes must be at least " + $6c8154472dd99012$var$ui.lo);
            this.cacheSizeBytes = t.cacheSizeBytes;
        }
        $6c8154472dd99012$var$P("settings", "boolean", "experimentalForceLongPolling", t.experimentalForceLongPolling), this.experimentalForceLongPolling = null !== (i = t.experimentalForceLongPolling) && void 0 !== i && i, $6c8154472dd99012$var$P("settings", "boolean", "experimentalAutoDetectLongPolling", t.experimentalAutoDetectLongPolling), this.experimentalAutoDetectLongPolling = null !== (o = t.experimentalAutoDetectLongPolling) && void 0 !== o && o, function(t, e, n, r) {
            if (!0 === e && !0 === r) throw new $6c8154472dd99012$var$c($6c8154472dd99012$var$a.INVALID_ARGUMENT, "experimentalForceLongPolling and experimentalAutoDetectLongPolling cannot be used together.");
        }(0, t.experimentalForceLongPolling, 0, t.experimentalAutoDetectLongPolling);
    }
    return t.prototype.isEqual = function(t) {
        return this.host === t.host && this.ssl === t.ssl && this.timestampsInSnapshots === t.timestampsInSnapshots && this.credentials === t.credentials && this.cacheSizeBytes === t.cacheSizeBytes && this.experimentalForceLongPolling === t.experimentalForceLongPolling && this.experimentalAutoDetectLongPolling === t.experimentalAutoDetectLongPolling && this.ignoreUndefinedProperties === t.ignoreUndefinedProperties;
    }, t;
}(), $6c8154472dd99012$var$Xu = /** @class */ function() {
    // Note: We are using `MemoryComponentProvider` as a default
    // ComponentProvider to ensure backwards compatibility with the format
    // expected by the console build.
    function e(n, r, i, o) {
        var s = this;
        if (void 0 === i && (i = new $6c8154472dd99012$var$cu), void 0 === o && (o = new $6c8154472dd99012$var$fu), this.rf = i, this.af = o, this.cf = null, // Public for use in tests.
        // TODO(mikelehen): Use modularized initialization instead.
        this.uf = new $6c8154472dd99012$var$xr, this.INTERNAL = {
            delete: function() {
                return $876a70688d8d7977$export$1050f835b63b671e(s, void 0, void 0, function() {
                    return $876a70688d8d7977$export$67ebef60e6f28a6(this, function(t) {
                        switch(t.label){
                            case 0:
                                // The client must be initalized to ensure that all subsequent API usage
                                // throws an exception.
                                return this.hf(), [
                                    4 /*yield*/ ,
                                    this.lf.terminate()
                                ];
                            case 1:
                                // The client must be initalized to ensure that all subsequent API usage
                                // throws an exception.
                                return t.sent(), [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            }
        }, "object" == typeof n.options) {
            // This is very likely a Firebase app object
            // TODO(b/34177605): Can we somehow use instanceof?
            var u = n;
            this.cf = u, this.__ = e._f(u), this.ff = u.name, this.df = new $6c8154472dd99012$var$Oo(r);
        } else {
            var h = n;
            if (!h.projectId) throw new $6c8154472dd99012$var$c($6c8154472dd99012$var$a.INVALID_ARGUMENT, "Must provide projectId");
            this.__ = new $6c8154472dd99012$var$rt(h.projectId, h.database), // Use a default persistenceKey that lines up with FirebaseApp.
            this.ff = "[DEFAULT]", this.df = new $6c8154472dd99012$var$Ro;
        }
        this.wf = new $6c8154472dd99012$var$$u({});
    }
    return Object.defineProperty(e.prototype, "mf", {
        get: function() {
            return this.Tf || // Lazy initialize UserDataReader once the settings are frozen
            (this.Tf = new $6c8154472dd99012$var$ku(this.__, this.wf.ignoreUndefinedProperties)), this.Tf;
        },
        enumerable: !1,
        configurable: !0
    }), e.prototype.settings = function(t) {
        $6c8154472dd99012$var$D("Firestore.settings", arguments, 1), $6c8154472dd99012$var$k("Firestore.settings", "object", 1, t), t.merge && // Remove the property from the settings once the merge is completed
        delete (t = Object.assign(Object.assign({}, this.wf), t)).merge;
        var e = new $6c8154472dd99012$var$$u(t);
        if (this.lf && !this.wf.isEqual(e)) throw new $6c8154472dd99012$var$c($6c8154472dd99012$var$a.FAILED_PRECONDITION, "Firestore has already been started and its settings can no longer be changed. You can only call settings() before calling any other methods on a Firestore object.");
        this.wf = e, void 0 !== e.credentials && (this.df = function(t) {
            if (!t) return new $6c8154472dd99012$var$Ro;
            switch(t.type){
                case "gapi":
                    var e = t.client;
                    // Make sure this really is a Gapi client.
                    return $6c8154472dd99012$var$g(!("object" != typeof e || null === e || !e.auth || !e.auth.getAuthHeaderValueForFirstParty)), new $6c8154472dd99012$var$Vo(e, t.sessionIndex || "0");
                case "provider":
                    return t.client;
                default:
                    throw new $6c8154472dd99012$var$c($6c8154472dd99012$var$a.INVALID_ARGUMENT, "makeCredentialsProvider failed due to invalid credential type");
            }
        }(e.credentials));
    }, e.prototype.enableNetwork = function() {
        return this.hf(), this.lf.enableNetwork();
    }, e.prototype.disableNetwork = function() {
        return this.hf(), this.lf.disableNetwork();
    }, e.prototype.enablePersistence = function(t) {
        var e, n;
        if (this.lf) throw new $6c8154472dd99012$var$c($6c8154472dd99012$var$a.FAILED_PRECONDITION, "Firestore has already been started and persistence can no longer be enabled. You can only call enablePersistence() before calling any other methods on a Firestore object.");
        var r = !1, i = !1;
        if (t && (void 0 !== t.experimentalTabSynchronization && $6c8154472dd99012$var$p("The 'experimentalTabSynchronization' setting will be removed. Use 'synchronizeTabs' instead."), r = null !== (n = null !== (e = t.synchronizeTabs) && void 0 !== e ? e : t.experimentalTabSynchronization) && void 0 !== n && n, i = !!t.experimentalForceOwningTab && t.experimentalForceOwningTab, r && i)) throw new $6c8154472dd99012$var$c($6c8154472dd99012$var$a.INVALID_ARGUMENT, "The 'experimentalForceOwningTab' setting cannot be used with 'synchronizeTabs'.");
        return this.Ef(this.rf, this.af, {
            jl: !0,
            cacheSizeBytes: this.wf.cacheSizeBytes,
            synchronizeTabs: r,
            ka: i
        });
    }, e.prototype.clearPersistence = function() {
        return $876a70688d8d7977$export$1050f835b63b671e(this, void 0, void 0, function() {
            var e, n = this;
            return $876a70688d8d7977$export$67ebef60e6f28a6(this, function(r) {
                if (void 0 !== this.lf && !this.lf.z_) throw new $6c8154472dd99012$var$c($6c8154472dd99012$var$a.FAILED_PRECONDITION, "Persistence can only be cleared before a Firestore instance is initialized or after it is terminated.");
                return e = new $6c8154472dd99012$var$dr, [
                    2 /*return*/ ,
                    (this.uf.bs(function() {
                        return $876a70688d8d7977$export$1050f835b63b671e(n, void 0, void 0, function() {
                            var n;
                            return $876a70688d8d7977$export$67ebef60e6f28a6(this, function(t) {
                                switch(t.label){
                                    case 0:
                                        return t.trys.push([
                                            0,
                                            2,
                                            ,
                                            3
                                        ]), [
                                            4 /*yield*/ ,
                                            this.rf.clearPersistence(this.__, this.ff)
                                        ];
                                    case 1:
                                        return t.sent(), e.resolve(), [
                                            3 /*break*/ ,
                                            3
                                        ];
                                    case 2:
                                        return n = t.sent(), e.reject(n), [
                                            3 /*break*/ ,
                                            3
                                        ];
                                    case 3:
                                        return [
                                            2 /*return*/ 
                                        ];
                                }
                            });
                        });
                    }), e.promise)
                ];
            });
        });
    }, e.prototype.terminate = function() {
        return this.app._removeServiceInstance("firestore"), this.INTERNAL.delete();
    }, Object.defineProperty(e.prototype, "If", {
        get: function() {
            return this.hf(), this.lf.z_;
        },
        enumerable: !1,
        configurable: !0
    }), e.prototype.waitForPendingWrites = function() {
        return this.hf(), this.lf.waitForPendingWrites();
    }, e.prototype.onSnapshotsInSync = function(t) {
        if (this.hf(), $6c8154472dd99012$var$Qu(t)) return this.lf.G_(t);
        $6c8154472dd99012$var$k("Firestore.onSnapshotsInSync", "function", 1, t);
        var e = {
            next: t
        };
        return this.lf.G_(e);
    }, e.prototype.hf = function() {
        return this.lf || // Kick off starting the client but don't actually wait for it.
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.Ef(new $6c8154472dd99012$var$cu, new $6c8154472dd99012$var$fu, {
            jl: !1
        }), this.lf;
    }, e.prototype.Af = function() {
        return new $6c8154472dd99012$var$nt(this.__, this.ff, this.wf.host, this.wf.ssl, this.wf.experimentalForceLongPolling, this.wf.experimentalAutoDetectLongPolling);
    }, e.prototype.Ef = function(t, e, n) {
        var r = this.Af();
        return this.lf = new $6c8154472dd99012$var$Ku(this.df, this.uf), this.lf.start(r, t, e, n);
    }, e._f = function(t) {
        if (e = t.options, !Object.prototype.hasOwnProperty.call(e, "projectId")) throw new $6c8154472dd99012$var$c($6c8154472dd99012$var$a.INVALID_ARGUMENT, '"projectId" not provided in firebase.initializeApp.');
        var e, n = t.options.projectId;
        if (!n || "string" != typeof n) throw new $6c8154472dd99012$var$c($6c8154472dd99012$var$a.INVALID_ARGUMENT, "projectId must be a string in FirebaseApp.options");
        return new $6c8154472dd99012$var$rt(n);
    }, Object.defineProperty(e.prototype, "app", {
        get: function() {
            if (!this.cf) throw new $6c8154472dd99012$var$c($6c8154472dd99012$var$a.FAILED_PRECONDITION, "Firestore was not initialized using the Firebase SDK. 'app' is not available");
            return this.cf;
        },
        enumerable: !1,
        configurable: !0
    }), e.prototype.collection = function(t) {
        return $6c8154472dd99012$var$D("Firestore.collection", arguments, 1), $6c8154472dd99012$var$k("Firestore.collection", "non-empty string", 1, t), this.hf(), new $6c8154472dd99012$var$la($6c8154472dd99012$var$E.g(t), this, /* converter= */ null);
    }, e.prototype.doc = function(t) {
        return $6c8154472dd99012$var$D("Firestore.doc", arguments, 1), $6c8154472dd99012$var$k("Firestore.doc", "non-empty string", 1, t), this.hf(), $6c8154472dd99012$var$ta.Rf($6c8154472dd99012$var$E.g(t), this, /* converter= */ null);
    }, e.prototype.collectionGroup = function(t) {
        if ($6c8154472dd99012$var$D("Firestore.collectionGroup", arguments, 1), $6c8154472dd99012$var$k("Firestore.collectionGroup", "non-empty string", 1, t), t.indexOf("/") >= 0) throw new $6c8154472dd99012$var$c($6c8154472dd99012$var$a.INVALID_ARGUMENT, "Invalid collection ID '" + t + "' passed to function Firestore.collectionGroup(). Collection IDs must not contain '/'.");
        return this.hf(), new $6c8154472dd99012$var$ha(/**
 * Creates a new Query for a collection group query that matches all documents
 * within the provided collection group.
 */ function(t) {
            return new $6c8154472dd99012$var$Pn($6c8154472dd99012$var$E.P(), t);
        }(t), this, /* converter= */ null);
    }, e.prototype.runTransaction = function(t) {
        var e = this;
        return $6c8154472dd99012$var$D("Firestore.runTransaction", arguments, 1), $6c8154472dd99012$var$k("Firestore.runTransaction", "function", 1, t), this.hf().transaction(function(n) {
            return t(new $6c8154472dd99012$var$Ju(e, n));
        });
    }, e.prototype.batch = function() {
        return this.hf(), new $6c8154472dd99012$var$Zu(this);
    }, Object.defineProperty(e, "logLevel", {
        get: function() {
            switch($6c8154472dd99012$var$f()){
                case $d4M6f.LogLevel.DEBUG:
                    return "debug";
                case $d4M6f.LogLevel.ERROR:
                    return "error";
                case $d4M6f.LogLevel.SILENT:
                    return "silent";
                case $d4M6f.LogLevel.WARN:
                    return "warn";
                case $d4M6f.LogLevel.INFO:
                    return "info";
                case $d4M6f.LogLevel.VERBOSE:
                    return "verbose";
                default:
                    // The default log level is error
                    return "error";
            }
        },
        enumerable: !1,
        configurable: !0
    }), e.setLogLevel = function(t) {
        var e;
        $6c8154472dd99012$var$D("Firestore.setLogLevel", arguments, 1), $6c8154472dd99012$var$U("setLogLevel", [
            "debug",
            "error",
            "silent",
            "warn",
            "info",
            "verbose"
        ], 1, t), e = t, $6c8154472dd99012$var$h.setLogLevel(e);
    }, // Note: this is not a property because the minifier can't work correctly with
    // the way TypeScript compiler outputs properties.
    e.prototype.gf = function() {
        return this.wf.timestampsInSnapshots;
    }, // Visible for testing.
    e.prototype.Pf = function() {
        return this.wf;
    }, e;
}(), $6c8154472dd99012$var$Ju = /** @class */ function() {
    function t(t, e) {
        this.yf = t, this.Vf = e;
    }
    return t.prototype.get = function(t) {
        var e = this;
        $6c8154472dd99012$var$D("Transaction.get", arguments, 1);
        var n = $6c8154472dd99012$var$ya("Transaction.get", t, this.yf);
        return this.Vf.v_([
            n.f_
        ]).then(function(t) {
            if (!t || 1 !== t.length) return $6c8154472dd99012$var$y();
            var r = t[0];
            if (r instanceof $6c8154472dd99012$var$Rn) return new $6c8154472dd99012$var$na(e.yf, n.f_, null, /* fromCache= */ !1, /* hasPendingWrites= */ !1, n.d_);
            if (r instanceof $6c8154472dd99012$var$kn) return new $6c8154472dd99012$var$na(e.yf, n.f_, r, /* fromCache= */ !1, /* hasPendingWrites= */ !1, n.d_);
            throw $6c8154472dd99012$var$y();
        });
    }, t.prototype.set = function(t, e, n) {
        $6c8154472dd99012$var$L("Transaction.set", arguments, 2, 3);
        var r = $6c8154472dd99012$var$ya("Transaction.set", t, this.yf);
        n = $6c8154472dd99012$var$pa("Transaction.set", n);
        var i = $6c8154472dd99012$var$ma(r.d_, e, n), o = $6c8154472dd99012$var$Ru(this.yf.mf, "Transaction.set", r.f_, i, null !== r.d_, n);
        return this.Vf.set(r.f_, o), this;
    }, t.prototype.update = function(t, e, n) {
        for(var r, i, o = [], s = 3; s < arguments.length; s++)o[s - 3] = arguments[s];
        return "string" == typeof e || e instanceof $6c8154472dd99012$var$du ? ($6c8154472dd99012$var$x("Transaction.update", arguments, 3), r = $6c8154472dd99012$var$ya("Transaction.update", t, this.yf), i = $6c8154472dd99012$var$Pu(this.yf.mf, "Transaction.update", r.f_, e, n, o)) : ($6c8154472dd99012$var$D("Transaction.update", arguments, 2), r = $6c8154472dd99012$var$ya("Transaction.update", t, this.yf), i = $6c8154472dd99012$var$Ou(this.yf.mf, "Transaction.update", r.f_, e)), this.Vf.update(r.f_, i), this;
    }, t.prototype.delete = function(t) {
        $6c8154472dd99012$var$D("Transaction.delete", arguments, 1);
        var e = $6c8154472dd99012$var$ya("Transaction.delete", t, this.yf);
        return this.Vf.delete(e.f_), this;
    }, t;
}(), $6c8154472dd99012$var$Zu = /** @class */ function() {
    function t(t) {
        this.yf = t, this.pf = [], this.bf = !1;
    }
    return t.prototype.set = function(t, e, n) {
        $6c8154472dd99012$var$L("WriteBatch.set", arguments, 2, 3), this.vf();
        var r = $6c8154472dd99012$var$ya("WriteBatch.set", t, this.yf);
        n = $6c8154472dd99012$var$pa("WriteBatch.set", n);
        var i = $6c8154472dd99012$var$ma(r.d_, e, n), o = $6c8154472dd99012$var$Ru(this.yf.mf, "WriteBatch.set", r.f_, i, null !== r.d_, n);
        return this.pf = this.pf.concat(o.w_(r.f_, $6c8154472dd99012$var$fn.ze())), this;
    }, t.prototype.update = function(t, e, n) {
        for(var r, i, o = [], s = 3; s < arguments.length; s++)o[s - 3] = arguments[s];
        return this.vf(), "string" == typeof e || e instanceof $6c8154472dd99012$var$du ? ($6c8154472dd99012$var$x("WriteBatch.update", arguments, 3), r = $6c8154472dd99012$var$ya("WriteBatch.update", t, this.yf), i = $6c8154472dd99012$var$Pu(this.yf.mf, "WriteBatch.update", r.f_, e, n, o)) : ($6c8154472dd99012$var$D("WriteBatch.update", arguments, 2), r = $6c8154472dd99012$var$ya("WriteBatch.update", t, this.yf), i = $6c8154472dd99012$var$Ou(this.yf.mf, "WriteBatch.update", r.f_, e)), this.pf = this.pf.concat(i.w_(r.f_, $6c8154472dd99012$var$fn.exists(!0))), this;
    }, t.prototype.delete = function(t) {
        $6c8154472dd99012$var$D("WriteBatch.delete", arguments, 1), this.vf();
        var e = $6c8154472dd99012$var$ya("WriteBatch.delete", t, this.yf);
        return this.pf = this.pf.concat(new $6c8154472dd99012$var$Nn(e.f_, $6c8154472dd99012$var$fn.ze())), this;
    }, t.prototype.commit = function() {
        return this.vf(), this.bf = !0, this.pf.length > 0 ? this.yf.hf().write(this.pf) : Promise.resolve();
    }, t.prototype.vf = function() {
        if (this.bf) throw new $6c8154472dd99012$var$c($6c8154472dd99012$var$a.FAILED_PRECONDITION, "A write batch can no longer be used after commit() has been called.");
    }, t;
}(), $6c8154472dd99012$var$ta = /** @class */ function(e) {
    function n(t, n, r) {
        var i = this;
        return (i = e.call(this, n.__, t, r) || this).f_ = t, i.firestore = n, i.d_ = r, i.lf = i.firestore.hf(), i;
    }
    return $876a70688d8d7977$export$a8ba968b8961cb8a(n, e), n.Rf = function(t, e, r) {
        if (t.length % 2 != 0) throw new $6c8154472dd99012$var$c($6c8154472dd99012$var$a.INVALID_ARGUMENT, "Invalid document reference. Document references must have an even number of segments, but " + t.R() + " has " + t.length);
        return new n(new $6c8154472dd99012$var$A(t), e, r);
    }, Object.defineProperty(n.prototype, "id", {
        get: function() {
            return this.f_.path._();
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(n.prototype, "parent", {
        get: function() {
            return new $6c8154472dd99012$var$la(this.f_.path.h(), this.firestore, this.d_);
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(n.prototype, "path", {
        get: function() {
            return this.f_.path.R();
        },
        enumerable: !1,
        configurable: !0
    }), n.prototype.collection = function(t) {
        if ($6c8154472dd99012$var$D("DocumentReference.collection", arguments, 1), $6c8154472dd99012$var$k("DocumentReference.collection", "non-empty string", 1, t), !t) throw new $6c8154472dd99012$var$c($6c8154472dd99012$var$a.INVALID_ARGUMENT, "Must provide a non-empty collection name to collection()");
        var e = $6c8154472dd99012$var$E.g(t);
        return new $6c8154472dd99012$var$la(this.f_.path.child(e), this.firestore, /* converter= */ null);
    }, n.prototype.isEqual = function(t) {
        if (!(t instanceof n)) throw $6c8154472dd99012$var$G("isEqual", "DocumentReference", 1, t);
        return this.firestore === t.firestore && this.f_.isEqual(t.f_) && this.d_ === t.d_;
    }, n.prototype.set = function(t, e) {
        $6c8154472dd99012$var$L("DocumentReference.set", arguments, 1, 2), e = $6c8154472dd99012$var$pa("DocumentReference.set", e);
        var n = $6c8154472dd99012$var$ma(this.d_, t, e), r = $6c8154472dd99012$var$Ru(this.firestore.mf, "DocumentReference.set", this.f_, n, null !== this.d_, e);
        return this.lf.write(r.w_(this.f_, $6c8154472dd99012$var$fn.ze()));
    }, n.prototype.update = function(t, e) {
        for(var n, r = [], i = 2; i < arguments.length; i++)r[i - 2] = arguments[i];
        return "string" == typeof t || t instanceof $6c8154472dd99012$var$du ? ($6c8154472dd99012$var$x("DocumentReference.update", arguments, 2), n = $6c8154472dd99012$var$Pu(this.firestore.mf, "DocumentReference.update", this.f_, t, e, r)) : ($6c8154472dd99012$var$D("DocumentReference.update", arguments, 1), n = $6c8154472dd99012$var$Ou(this.firestore.mf, "DocumentReference.update", this.f_, t)), this.lf.write(n.w_(this.f_, $6c8154472dd99012$var$fn.exists(!0)));
    }, n.prototype.delete = function() {
        return $6c8154472dd99012$var$D("DocumentReference.delete", arguments, 0), this.lf.write([
            new $6c8154472dd99012$var$Nn(this.f_, $6c8154472dd99012$var$fn.ze())
        ]);
    }, n.prototype.onSnapshot = function() {
        for(var t, e, n, r = this, i = [], o = 0; o < arguments.length; o++)i[o] = arguments[o];
        $6c8154472dd99012$var$L("DocumentReference.onSnapshot", arguments, 1, 4);
        var s = {
            includeMetadataChanges: !1
        }, u = 0;
        "object" != typeof i[u] || $6c8154472dd99012$var$Qu(i[u]) || ($6c8154472dd99012$var$j("DocumentReference.onSnapshot", s = i[u], [
            "includeMetadataChanges"
        ]), $6c8154472dd99012$var$P("DocumentReference.onSnapshot", "boolean", "includeMetadataChanges", s.includeMetadataChanges), u++);
        var a = {
            includeMetadataChanges: s.includeMetadataChanges
        };
        if ($6c8154472dd99012$var$Qu(i[u])) {
            var c = i[u];
            i[u] = null === (t = c.next) || void 0 === t ? void 0 : t.bind(c), i[u + 1] = null === (e = c.error) || void 0 === e ? void 0 : e.bind(c), i[u + 2] = null === (n = c.complete) || void 0 === n ? void 0 : n.bind(c);
        } else $6c8154472dd99012$var$k("DocumentReference.onSnapshot", "function", u, i[u]), $6c8154472dd99012$var$R("DocumentReference.onSnapshot", "function", u + 1, i[u + 1]), $6c8154472dd99012$var$R("DocumentReference.onSnapshot", "function", u + 2, i[u + 2]);
        var h = {
            next: function(t) {
                i[u] && i[u](r.Sf(t));
            },
            error: i[u + 1],
            complete: i[u + 2]
        };
        return this.lf.listen($6c8154472dd99012$var$Un(this.f_.path), a, h);
    }, n.prototype.get = function(t) {
        var e = this;
        $6c8154472dd99012$var$L("DocumentReference.get", arguments, 0, 1), $6c8154472dd99012$var$va("DocumentReference.get", t);
        var n = this.firestore.hf();
        return t && "cache" === t.source ? n.Q_(this.f_).then(function(t) {
            return new $6c8154472dd99012$var$na(e.firestore, e.f_, t, /*fromCache=*/ !0, t instanceof $6c8154472dd99012$var$kn && t.Je, e.d_);
        }) : n.W_(this.f_, t).then(function(t) {
            return e.Sf(t);
        });
    }, n.prototype.withConverter = function(t) {
        return new n(this.f_, this.firestore, t);
    }, /**
     * Converts a ViewSnapshot that contains the current document to a
     * DocumentSnapshot.
     */ n.prototype.Sf = function(t) {
        var e = t.docs.get(this.f_);
        return new $6c8154472dd99012$var$na(this.firestore, this.f_, e, t.fromCache, t.hasPendingWrites, this.d_);
    }, n;
}($6c8154472dd99012$var$Au), $6c8154472dd99012$var$ea = /** @class */ function() {
    function t(t, e) {
        this.hasPendingWrites = t, this.fromCache = e /**
     * Returns true if this `SnapshotMetadata` is equal to the provided one.
     *
     * @param other The `SnapshotMetadata` to compare against.
     * @return true if this `SnapshotMetadata` is equal to the provided one.
     */ ;
    }
    return t.prototype.isEqual = function(t) {
        return this.hasPendingWrites === t.hasPendingWrites && this.fromCache === t.fromCache;
    }, t;
}(), $6c8154472dd99012$var$na = /** @class */ function() {
    function t(t, e, n, r, i, o) {
        this.yf = t, this.f_ = e, this.Df = n, this.Cf = r, this.Nf = i, this.d_ = o;
    }
    return t.prototype.data = function(t) {
        var e = this;
        if ($6c8154472dd99012$var$L("DocumentSnapshot.data", arguments, 0, 1), t = $6c8154472dd99012$var$da("DocumentSnapshot.data", t), this.Df) {
            // We only want to use the converter and create a new DocumentSnapshot
            // if a converter has been provided.
            if (this.d_) {
                var n = new $6c8154472dd99012$var$ra(this.yf, this.f_, this.Df, this.Cf, this.Nf, /* converter= */ null);
                return this.d_.fromFirestore(n, t);
            }
            return new $6c8154472dd99012$var$Hu(this.yf.__, this.yf.gf(), t.serverTimestamps || "none", function(t) {
                return new $6c8154472dd99012$var$ta(t, e.yf, /* converter= */ null);
            }, function(t) {
                return new $6c8154472dd99012$var$et(t);
            }).X_(this.Df.rn());
        }
    }, t.prototype.get = function(t, e) {
        var n = this;
        if ($6c8154472dd99012$var$L("DocumentSnapshot.get", arguments, 1, 2), e = $6c8154472dd99012$var$da("DocumentSnapshot.get", e), this.Df) {
            var r = this.Df.data().field($6c8154472dd99012$var$qu("DocumentSnapshot.get", t, this.f_));
            if (null !== r) return new $6c8154472dd99012$var$Hu(this.yf.__, this.yf.gf(), e.serverTimestamps || "none", function(t) {
                return new $6c8154472dd99012$var$ta(t, n.yf, n.d_);
            }, function(t) {
                return new $6c8154472dd99012$var$et(t);
            }).X_(r);
        }
    }, Object.defineProperty(t.prototype, "id", {
        get: function() {
            return this.f_.path._();
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "ref", {
        get: function() {
            return new $6c8154472dd99012$var$ta(this.f_, this.yf, this.d_);
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "exists", {
        get: function() {
            return null !== this.Df;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "metadata", {
        get: function() {
            return new $6c8154472dd99012$var$ea(this.Nf, this.Cf);
        },
        enumerable: !1,
        configurable: !0
    }), t.prototype.isEqual = function(e) {
        if (!(e instanceof t)) throw $6c8154472dd99012$var$G("isEqual", "DocumentSnapshot", 1, e);
        return this.yf === e.yf && this.Cf === e.Cf && this.f_.isEqual(e.f_) && (null === this.Df ? null === e.Df : this.Df.isEqual(e.Df)) && this.d_ === e.d_;
    }, t;
}(), $6c8154472dd99012$var$ra = /** @class */ function(e) {
    function n() {
        return null !== e && e.apply(this, arguments) || this;
    }
    return $876a70688d8d7977$export$a8ba968b8961cb8a(n, e), n.prototype.data = function(t) {
        return e.prototype.data.call(this, t);
    }, n;
}($6c8154472dd99012$var$na);
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // settings() defaults:
function $6c8154472dd99012$var$ia(t, e, n, r, i, o, s) {
    var u;
    if (i.p()) {
        if ("array-contains" /* ARRAY_CONTAINS */  === o || "array-contains-any" /* ARRAY_CONTAINS_ANY */  === o) throw new $6c8154472dd99012$var$c($6c8154472dd99012$var$a.INVALID_ARGUMENT, "Invalid Query. You can't perform '" + o + "' queries on FieldPath.documentId().");
        if ("in" /* IN */  === o || "not-in" /* NOT_IN */  === o) {
            $6c8154472dd99012$var$ua(s, o);
            for(var h = [], f = 0, l = s; f < l.length; f++){
                var p = l[f];
                h.push($6c8154472dd99012$var$sa(r, t, p));
            }
            u = {
                arrayValue: {
                    values: h
                }
            };
        } else u = $6c8154472dd99012$var$sa(r, t, s);
    } else "in" /* IN */  !== o && "not-in" /* NOT_IN */  !== o && "array-contains-any" /* ARRAY_CONTAINS_ANY */  !== o || $6c8154472dd99012$var$ua(s, o), u = $6c8154472dd99012$var$Vu(n, e, s, /* allowArrays= */ "in" /* IN */  === o || "not-in" /* NOT_IN */  === o);
    var d = $6c8154472dd99012$var$Jn.create(i, o, u);
    return function(t, e) {
        if (e.hn()) {
            var n = $6c8154472dd99012$var$qn(t);
            if (null !== n && !n.isEqual(e.field)) throw new $6c8154472dd99012$var$c($6c8154472dd99012$var$a.INVALID_ARGUMENT, "Invalid query. All where filters with an inequality (<, <=, >, or >=) must be on the same field. But you have inequality filters on '" + n.toString() + "' and '" + e.field.toString() + "'");
            var r = $6c8154472dd99012$var$Mn(t);
            null !== r && $6c8154472dd99012$var$aa(t, e.field, r);
        }
        var i = function(t, e) {
            for(var n = 0, r = t.filters; n < r.length; n++){
                var i = r[n];
                if (e.indexOf(i.op) >= 0) return i.op;
            }
            return null;
        }(t, /**
 * Given an operator, returns the set of operators that cannot be used with it.
 *
 * Operators in a query must adhere to the following set of rules:
 * 1. Only one array operator is allowed.
 * 2. Only one disjunctive operator is allowed.
 * 3. NOT_EQUAL cannot be used with another NOT_EQUAL operator.
 * 4. NOT_IN cannot be used with array, disjunctive, or NOT_EQUAL operators.
 *
 * Array operators: ARRAY_CONTAINS, ARRAY_CONTAINS_ANY
 * Disjunctive operators: IN, ARRAY_CONTAINS_ANY, NOT_IN
 */ function(t) {
            switch(t){
                case "!=" /* NOT_EQUAL */ :
                    return [
                        "!=" /* NOT_EQUAL */ ,
                        "not-in" /* NOT_IN */ 
                    ];
                case "array-contains" /* ARRAY_CONTAINS */ :
                    return [
                        "array-contains" /* ARRAY_CONTAINS */ ,
                        "array-contains-any" /* ARRAY_CONTAINS_ANY */ ,
                        "not-in" /* NOT_IN */ 
                    ];
                case "in" /* IN */ :
                    return [
                        "array-contains-any" /* ARRAY_CONTAINS_ANY */ ,
                        "in" /* IN */ ,
                        "not-in" /* NOT_IN */ 
                    ];
                case "array-contains-any" /* ARRAY_CONTAINS_ANY */ :
                    return [
                        "array-contains" /* ARRAY_CONTAINS */ ,
                        "array-contains-any" /* ARRAY_CONTAINS_ANY */ ,
                        "in" /* IN */ ,
                        "not-in" /* NOT_IN */ 
                    ];
                case "not-in" /* NOT_IN */ :
                    return [
                        "array-contains" /* ARRAY_CONTAINS */ ,
                        "array-contains-any" /* ARRAY_CONTAINS_ANY */ ,
                        "in" /* IN */ ,
                        "not-in" /* NOT_IN */ ,
                        "!=" /* NOT_EQUAL */ 
                    ];
                default:
                    return [];
            }
        }(e.op));
        if (null !== i) // Special case when it's a duplicate op to give a slightly clearer error message.
        throw i === e.op ? new $6c8154472dd99012$var$c($6c8154472dd99012$var$a.INVALID_ARGUMENT, "Invalid query. You cannot use more than one '" + e.op.toString() + "' filter.") : new $6c8154472dd99012$var$c($6c8154472dd99012$var$a.INVALID_ARGUMENT, "Invalid query. You cannot use '" + e.op.toString() + "' filters with '" + i.toString() + "' filters.");
    }(t, d), d;
}
function $6c8154472dd99012$var$oa(t, e, n) {
    if (null !== t.startAt) throw new $6c8154472dd99012$var$c($6c8154472dd99012$var$a.INVALID_ARGUMENT, "Invalid query. You must not call startAt() or startAfter() before calling orderBy().");
    if (null !== t.endAt) throw new $6c8154472dd99012$var$c($6c8154472dd99012$var$a.INVALID_ARGUMENT, "Invalid query. You must not call endAt() or endBefore() before calling orderBy().");
    var r = new $6c8154472dd99012$var$fr(e, n);
    return function(t, e) {
        if (null === $6c8154472dd99012$var$Mn(t)) {
            // This is the first order by. It must match any inequality.
            var n = $6c8154472dd99012$var$qn(t);
            null !== n && $6c8154472dd99012$var$aa(t, n, e.field);
        }
    }(t, r), r /**
 * Parses the given documentIdValue into a ReferenceValue, throwing
 * appropriate errors if the value is anything other than a DocumentReference
 * or String, or if the string is malformed.
 */ ;
}
function $6c8154472dd99012$var$sa(t, e, n) {
    if ("string" == typeof n) {
        if ("" === n) throw new $6c8154472dd99012$var$c($6c8154472dd99012$var$a.INVALID_ARGUMENT, "Invalid query. When querying with FieldPath.documentId(), you must provide a valid document ID, but it was an empty string.");
        if (!$6c8154472dd99012$var$jn(e) && -1 !== n.indexOf("/")) throw new $6c8154472dd99012$var$c($6c8154472dd99012$var$a.INVALID_ARGUMENT, "Invalid query. When querying a collection by FieldPath.documentId(), you must provide a plain document ID, but '" + n + "' contains a '/' character.");
        var r = e.path.child($6c8154472dd99012$var$E.g(n));
        if (!$6c8154472dd99012$var$A.F(r)) throw new $6c8154472dd99012$var$c($6c8154472dd99012$var$a.INVALID_ARGUMENT, "Invalid query. When querying a collection group by FieldPath.documentId(), the value provided must result in a valid document path, but '" + r + "' is not because it has an odd number of segments (" + r.length + ").");
        return $6c8154472dd99012$var$ae(t, new $6c8154472dd99012$var$A(r));
    }
    if (n instanceof $6c8154472dd99012$var$Au) return $6c8154472dd99012$var$ae(t, n.f_);
    throw new $6c8154472dd99012$var$c($6c8154472dd99012$var$a.INVALID_ARGUMENT, "Invalid query. When querying with FieldPath.documentId(), you must provide a valid string or a DocumentReference, but it was: " + $6c8154472dd99012$var$M(n) + ".");
}
/**
 * Validates that the value passed into a disjunctive filter satisfies all
 * array requirements.
 */ function $6c8154472dd99012$var$ua(t, e) {
    if (!Array.isArray(t) || 0 === t.length) throw new $6c8154472dd99012$var$c($6c8154472dd99012$var$a.INVALID_ARGUMENT, "Invalid Query. A non-empty array is required for '" + e.toString() + "' filters.");
    if (t.length > 10) throw new $6c8154472dd99012$var$c($6c8154472dd99012$var$a.INVALID_ARGUMENT, "Invalid Query. '" + e.toString() + "' filters support a maximum of 10 elements in the value array.");
    if ("in" /* IN */  === e || "array-contains-any" /* ARRAY_CONTAINS_ANY */  === e) {
        if (t.indexOf(null) >= 0) throw new $6c8154472dd99012$var$c($6c8154472dd99012$var$a.INVALID_ARGUMENT, "Invalid Query. '" + e.toString() + "' filters cannot contain 'null' in the value array.");
        if (t.filter(function(t) {
            return Number.isNaN(t);
        }).length > 0) throw new $6c8154472dd99012$var$c($6c8154472dd99012$var$a.INVALID_ARGUMENT, "Invalid Query. '" + e.toString() + "' filters cannot contain 'NaN' in the value array.");
    }
}
function $6c8154472dd99012$var$aa(t, e, n) {
    if (!n.isEqual(e)) throw new $6c8154472dd99012$var$c($6c8154472dd99012$var$a.INVALID_ARGUMENT, "Invalid query. You have a where filter with an inequality (<, <=, >, or >=) on field '" + e.toString() + "' and so you must also use '" + e.toString() + "' as your first orderBy(), but your first orderBy() is on field '" + n.toString() + "' instead.");
}
function $6c8154472dd99012$var$ca(t) {
    if ($6c8154472dd99012$var$Fn(t) && 0 === t.on.length) throw new $6c8154472dd99012$var$c($6c8154472dd99012$var$a.UNIMPLEMENTED, "limitToLast() queries require specifying at least one orderBy() clause");
}
var $6c8154472dd99012$var$ha = /** @class */ function() {
    function e(t, e, n) {
        this.Ff = t, this.firestore = e, this.d_ = n;
    }
    return e.prototype.where = function(t, n, r) {
        $6c8154472dd99012$var$D("Query.where", arguments, 3), $6c8154472dd99012$var$q("Query.where", 3, r);
        // Enumerated from the WhereFilterOp type in index.d.ts.
        var i = $6c8154472dd99012$var$U("Query.where", [
            "<" /* LESS_THAN */ ,
            "<=" /* LESS_THAN_OR_EQUAL */ ,
            "==" /* EQUAL */ ,
            "!=" /* NOT_EQUAL */ ,
            ">=" /* GREATER_THAN_OR_EQUAL */ ,
            ">" /* GREATER_THAN */ ,
            "array-contains" /* ARRAY_CONTAINS */ ,
            "in" /* IN */ ,
            "array-contains-any" /* ARRAY_CONTAINS_ANY */ ,
            "not-in" /* NOT_IN */ 
        ], 2, n), o = $6c8154472dd99012$var$qu("Query.where", t), s = $6c8154472dd99012$var$ia(this.Ff, "Query.where", this.firestore.mf, this.firestore.__, o, i, r);
        return new e(function(t, e) {
            var n = t.filters.concat([
                e
            ]);
            return new $6c8154472dd99012$var$Pn(t.path, t.collectionGroup, t.on.slice(), n, t.limit, t.an, t.startAt, t.endAt);
        }(this.Ff, s), this.firestore, this.d_);
    }, e.prototype.orderBy = function(t, n) {
        var r;
        if ($6c8154472dd99012$var$L("Query.orderBy", arguments, 1, 2), $6c8154472dd99012$var$R("Query.orderBy", "non-empty string", 2, n), void 0 === n || "asc" === n) r = "asc" /* ASCENDING */ ;
        else {
            if ("desc" !== n) throw new $6c8154472dd99012$var$c($6c8154472dd99012$var$a.INVALID_ARGUMENT, "Function Query.orderBy() has unknown direction '" + n + "', expected 'asc' or 'desc'.");
            r = "desc" /* DESCENDING */ ;
        }
        var i = $6c8154472dd99012$var$qu("Query.orderBy", t), o = $6c8154472dd99012$var$oa(this.Ff, i, r);
        return new e(function(t, e) {
            // TODO(dimond): validate that orderBy does not list the same key twice.
            var n = t.on.concat([
                e
            ]);
            return new $6c8154472dd99012$var$Pn(t.path, t.collectionGroup, n, t.filters.slice(), t.limit, t.an, t.startAt, t.endAt);
        }(this.Ff, o), this.firestore, this.d_);
    }, e.prototype.limit = function(t) {
        return $6c8154472dd99012$var$D("Query.limit", arguments, 1), $6c8154472dd99012$var$k("Query.limit", "number", 1, t), $6c8154472dd99012$var$z("Query.limit", 1, t), new e($6c8154472dd99012$var$Bn(this.Ff, t, "F" /* First */ ), this.firestore, this.d_);
    }, e.prototype.limitToLast = function(t) {
        return $6c8154472dd99012$var$D("Query.limitToLast", arguments, 1), $6c8154472dd99012$var$k("Query.limitToLast", "number", 1, t), $6c8154472dd99012$var$z("Query.limitToLast", 1, t), new e($6c8154472dd99012$var$Bn(this.Ff, t, "L" /* Last */ ), this.firestore, this.d_);
    }, e.prototype.startAt = function(t) {
        for(var n = [], r = 1; r < arguments.length; r++)n[r - 1] = arguments[r];
        $6c8154472dd99012$var$x("Query.startAt", arguments, 1);
        var i = this.xf("Query.startAt", t, n, /*before=*/ !0);
        return new e($6c8154472dd99012$var$Wn(this.Ff, i), this.firestore, this.d_);
    }, e.prototype.startAfter = function(t) {
        for(var n = [], r = 1; r < arguments.length; r++)n[r - 1] = arguments[r];
        $6c8154472dd99012$var$x("Query.startAfter", arguments, 1);
        var i = this.xf("Query.startAfter", t, n, /*before=*/ !1);
        return new e($6c8154472dd99012$var$Wn(this.Ff, i), this.firestore, this.d_);
    }, e.prototype.endBefore = function(t) {
        for(var n = [], r = 1; r < arguments.length; r++)n[r - 1] = arguments[r];
        $6c8154472dd99012$var$x("Query.endBefore", arguments, 1);
        var i = this.xf("Query.endBefore", t, n, /*before=*/ !0);
        return new e($6c8154472dd99012$var$Kn(this.Ff, i), this.firestore, this.d_);
    }, e.prototype.endAt = function(t) {
        for(var n = [], r = 1; r < arguments.length; r++)n[r - 1] = arguments[r];
        $6c8154472dd99012$var$x("Query.endAt", arguments, 1);
        var i = this.xf("Query.endAt", t, n, /*before=*/ !1);
        return new e($6c8154472dd99012$var$Kn(this.Ff, i), this.firestore, this.d_);
    }, e.prototype.isEqual = function(t) {
        if (!(t instanceof e)) throw $6c8154472dd99012$var$G("isEqual", "Query", 1, t);
        return this.firestore === t.firestore && $6c8154472dd99012$var$Qn(this.Ff, t.Ff) && this.d_ === t.d_;
    }, e.prototype.withConverter = function(t) {
        return new e(this.Ff, this.firestore, t);
    }, /** Helper function to create a bound from a document or fields */ e.prototype.xf = function(e, n, r, i) {
        if ($6c8154472dd99012$var$q(e, 1, n), n instanceof $6c8154472dd99012$var$na) return $6c8154472dd99012$var$D(e, $876a70688d8d7977$export$6388937ca91ccae8([
            n
        ], r), 1), function(t, e, n, r, i) {
            if (!r) throw new $6c8154472dd99012$var$c($6c8154472dd99012$var$a.NOT_FOUND, "Can't use a DocumentSnapshot that doesn't exist for " + n + "().");
            // Because people expect to continue/end a query at the exact document
            // provided, we need to use the implicit sort order rather than the explicit
            // sort order, because it's guaranteed to contain the document key. That way
            // the position becomes unambiguous and the query continues/ends exactly at
            // the provided document. Without the key (by using the explicit sort
            // orders), multiple documents could match the position, yielding duplicate
            // results.
            for(var o = [], s = 0, u = $6c8154472dd99012$var$Gn(t); s < u.length; s++){
                var h = u[s];
                if (h.field.p()) o.push($6c8154472dd99012$var$ae(e, r.key));
                else {
                    var f = r.field(h.field);
                    if ($6c8154472dd99012$var$Ht(f)) throw new $6c8154472dd99012$var$c($6c8154472dd99012$var$a.INVALID_ARGUMENT, 'Invalid query. You are trying to start or end a query using a document for which the field "' + h.field + '" is an uncommitted server timestamp. (Since the value of this field is unknown, you cannot start/end a query with it.)');
                    if (null === f) {
                        var l = h.field.R();
                        throw new $6c8154472dd99012$var$c($6c8154472dd99012$var$a.INVALID_ARGUMENT, "Invalid query. You are trying to start or end a query using a document for which the field '" + l + "' (used as the orderBy) does not exist.");
                    }
                    o.push(f);
                }
            }
            return new $6c8154472dd99012$var$ur(o, i);
        }(this.Ff, this.firestore.__, e, n.Df, i);
        var o = [
            n
        ].concat(r);
        return function(t, e, n, r, i, o) {
            // Use explicit order by's because it has to match the query the user made
            var s = t.on;
            if (i.length > s.length) throw new $6c8154472dd99012$var$c($6c8154472dd99012$var$a.INVALID_ARGUMENT, "Too many arguments provided to " + r + "(). The number of arguments must be less than or equal to the number of orderBy() clauses");
            for(var u = [], h = 0; h < i.length; h++){
                var f = i[h];
                if (s[h].field.p()) {
                    if ("string" != typeof f) throw new $6c8154472dd99012$var$c($6c8154472dd99012$var$a.INVALID_ARGUMENT, "Invalid query. Expected a string for document ID in " + r + "(), but got a " + typeof f);
                    if (!$6c8154472dd99012$var$jn(t) && -1 !== f.indexOf("/")) throw new $6c8154472dd99012$var$c($6c8154472dd99012$var$a.INVALID_ARGUMENT, "Invalid query. When querying a collection and ordering by FieldPath.documentId(), the value passed to " + r + "() must be a plain document ID, but '" + f + "' contains a slash.");
                    var l = t.path.child($6c8154472dd99012$var$E.g(f));
                    if (!$6c8154472dd99012$var$A.F(l)) throw new $6c8154472dd99012$var$c($6c8154472dd99012$var$a.INVALID_ARGUMENT, "Invalid query. When querying a collection group and ordering by FieldPath.documentId(), the value passed to " + r + "() must result in a valid document path, but '" + l + "' is not because it contains an odd number of segments.");
                    var p = new $6c8154472dd99012$var$A(l);
                    u.push($6c8154472dd99012$var$ae(e, p));
                } else {
                    var d = $6c8154472dd99012$var$Vu(n, r, f);
                    u.push(d);
                }
            }
            return new $6c8154472dd99012$var$ur(u, o);
        }(this.Ff, this.firestore.__, this.firestore.mf, e, o, i);
    }, e.prototype.onSnapshot = function() {
        for(var t, e, n, r = this, i = [], o = 0; o < arguments.length; o++)i[o] = arguments[o];
        $6c8154472dd99012$var$L("Query.onSnapshot", arguments, 1, 4);
        var s = {}, u = 0;
        if ("object" != typeof i[u] || $6c8154472dd99012$var$Qu(i[u]) || ($6c8154472dd99012$var$j("Query.onSnapshot", s = i[u], [
            "includeMetadataChanges"
        ]), $6c8154472dd99012$var$P("Query.onSnapshot", "boolean", "includeMetadataChanges", s.includeMetadataChanges), u++), $6c8154472dd99012$var$Qu(i[u])) {
            var a = i[u];
            i[u] = null === (t = a.next) || void 0 === t ? void 0 : t.bind(a), i[u + 1] = null === (e = a.error) || void 0 === e ? void 0 : e.bind(a), i[u + 2] = null === (n = a.complete) || void 0 === n ? void 0 : n.bind(a);
        } else $6c8154472dd99012$var$k("Query.onSnapshot", "function", u, i[u]), $6c8154472dd99012$var$R("Query.onSnapshot", "function", u + 1, i[u + 1]), $6c8154472dd99012$var$R("Query.onSnapshot", "function", u + 2, i[u + 2]);
        var c = {
            next: function(t) {
                i[u] && i[u](new $6c8154472dd99012$var$fa(r.firestore, r.Ff, t, r.d_));
            },
            error: i[u + 1],
            complete: i[u + 2]
        };
        return $6c8154472dd99012$var$ca(this.Ff), this.firestore.hf().listen(this.Ff, s, c);
    }, e.prototype.get = function(t) {
        var e = this;
        $6c8154472dd99012$var$L("Query.get", arguments, 0, 1), $6c8154472dd99012$var$va("Query.get", t), $6c8154472dd99012$var$ca(this.Ff);
        var n = this.firestore.hf();
        return (t && "cache" === t.source ? n.j_(this.Ff) : n.K_(this.Ff, t)).then(function(t) {
            return new $6c8154472dd99012$var$fa(e.firestore, e.Ff, t, e.d_);
        });
    }, e;
}(), $6c8154472dd99012$var$fa = /** @class */ function() {
    function t(t, e, n, r) {
        this.yf = t, this.$f = e, this.kf = n, this.d_ = r, this.Mf = null, this.Of = null, this.metadata = new $6c8154472dd99012$var$ea(n.hasPendingWrites, n.fromCache);
    }
    return Object.defineProperty(t.prototype, "docs", {
        get: function() {
            var t = [];
            return this.forEach(function(e) {
                return t.push(e);
            }), t;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "empty", {
        get: function() {
            return this.kf.docs.m();
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "size", {
        get: function() {
            return this.kf.docs.size;
        },
        enumerable: !1,
        configurable: !0
    }), t.prototype.forEach = function(t, e) {
        var n = this;
        $6c8154472dd99012$var$L("QuerySnapshot.forEach", arguments, 1, 2), $6c8154472dd99012$var$k("QuerySnapshot.forEach", "function", 1, t), this.kf.docs.forEach(function(r) {
            t.call(e, n.Lf(r, n.metadata.fromCache, n.kf.Wt.has(r.key)));
        });
    }, Object.defineProperty(t.prototype, "query", {
        get: function() {
            return new $6c8154472dd99012$var$ha(this.$f, this.yf, this.d_);
        },
        enumerable: !1,
        configurable: !0
    }), t.prototype.docChanges = function(t) {
        t && ($6c8154472dd99012$var$j("QuerySnapshot.docChanges", t, [
            "includeMetadataChanges"
        ]), $6c8154472dd99012$var$P("QuerySnapshot.docChanges", "boolean", "includeMetadataChanges", t.includeMetadataChanges));
        var e = !(!t || !t.includeMetadataChanges);
        if (e && this.kf.Kt) throw new $6c8154472dd99012$var$c($6c8154472dd99012$var$a.INVALID_ARGUMENT, "To include metadata changes with your document changes, you must also pass { includeMetadataChanges:true } to onSnapshot().");
        return this.Mf && this.Of === e || (this.Mf = /**
     * Calculates the array of DocumentChanges for a given ViewSnapshot.
     *
     * Exported for testing.
     *
     * @param snapshot The ViewSnapshot that represents the expected state.
     * @param includeMetadataChanges Whether to include metadata changes.
     * @param converter A factory function that returns a QueryDocumentSnapshot.
     * @return An object that matches the DocumentChange API.
     */ function(t, e, n) {
            if (t.Qt.m()) {
                // Special case the first snapshot because index calculation is easy and
                // fast
                var r = 0;
                return t.docChanges.map(function(e) {
                    var i = n(e.doc, t.fromCache, t.Wt.has(e.doc.key));
                    return e.doc, {
                        type: "added",
                        doc: i,
                        oldIndex: -1,
                        newIndex: r++
                    };
                });
            }
            // A DocumentSet that is updated incrementally as changes are applied to use
            // to lookup the index of a document.
            var i = t.Qt;
            return t.docChanges.filter(function(t) {
                return e || 3 /* Metadata */  !== t.type;
            }).map(function(e) {
                var r = n(e.doc, t.fromCache, t.Wt.has(e.doc.key)), o = -1, s = -1;
                return 0 /* Added */  !== e.type && (o = i.indexOf(e.doc.key), i = i.delete(e.doc.key)), 1 /* Removed */  !== e.type && (s = (i = i.add(e.doc)).indexOf(e.doc.key)), {
                    type: $6c8154472dd99012$var$ga(e.type),
                    doc: r,
                    oldIndex: o,
                    newIndex: s
                };
            });
        }(this.kf, e, this.Lf.bind(this)), this.Of = e), this.Mf;
    }, /** Check the equality. The call can be very expensive. */ t.prototype.isEqual = function(e) {
        if (!(e instanceof t)) throw $6c8154472dd99012$var$G("isEqual", "QuerySnapshot", 1, e);
        return this.yf === e.yf && $6c8154472dd99012$var$Qn(this.$f, e.$f) && this.kf.isEqual(e.kf) && this.d_ === e.d_;
    }, t.prototype.Lf = function(t, e, n) {
        return new $6c8154472dd99012$var$ra(this.yf, t.key, t, e, n, this.d_);
    }, t;
}(), $6c8154472dd99012$var$la = /** @class */ function(e) {
    function n(t, n, r) {
        var i = this;
        if ((i = e.call(this, $6c8154472dd99012$var$Un(t), n, r) || this).Bf = t, t.length % 2 != 1) throw new $6c8154472dd99012$var$c($6c8154472dd99012$var$a.INVALID_ARGUMENT, "Invalid collection reference. Collection references must have an odd number of segments, but " + t.R() + " has " + t.length);
        return i;
    }
    return $876a70688d8d7977$export$a8ba968b8961cb8a(n, e), Object.defineProperty(n.prototype, "id", {
        get: function() {
            return this.Ff.path._();
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(n.prototype, "parent", {
        get: function() {
            var t = this.Ff.path.h();
            return t.m() ? null : new $6c8154472dd99012$var$ta(new $6c8154472dd99012$var$A(t), this.firestore, /* converter= */ null);
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(n.prototype, "path", {
        get: function() {
            return this.Ff.path.R();
        },
        enumerable: !1,
        configurable: !0
    }), n.prototype.doc = function(t) {
        $6c8154472dd99012$var$L("CollectionReference.doc", arguments, 0, 1), // We allow omission of 'pathString' but explicitly prohibit passing in both
        // 'undefined' and 'null'.
        0 === arguments.length && (t = $6c8154472dd99012$var$Q.k()), $6c8154472dd99012$var$k("CollectionReference.doc", "non-empty string", 1, t);
        var e = $6c8154472dd99012$var$E.g(t);
        return $6c8154472dd99012$var$ta.Rf(this.Ff.path.child(e), this.firestore, this.d_);
    }, n.prototype.add = function(t) {
        $6c8154472dd99012$var$D("CollectionReference.add", arguments, 1);
        var e = this.d_ ? this.d_.toFirestore(t) : t;
        $6c8154472dd99012$var$k("CollectionReference.add", "object", 1, e);
        var n = this.doc();
        // Call set() with the converted value directly to avoid calling toFirestore() a second time.
        return new $6c8154472dd99012$var$ta(n.f_, this.firestore, null).set(e).then(function() {
            return n;
        });
    }, n.prototype.withConverter = function(t) {
        return new n(this.Bf, this.firestore, t);
    }, n;
}($6c8154472dd99012$var$ha);
function $6c8154472dd99012$var$pa(t, e) {
    if (void 0 === e) return {
        merge: !1
    };
    if ($6c8154472dd99012$var$j(t, e, [
        "merge",
        "mergeFields"
    ]), $6c8154472dd99012$var$P(t, "boolean", "merge", e.merge), function(t, e, n, r, i) {
        void 0 !== r && function(t, e, n, r, i) {
            if (!(r instanceof Array)) throw new $6c8154472dd99012$var$c($6c8154472dd99012$var$a.INVALID_ARGUMENT, "Function " + t + "() requires its " + e + " option to be an array, but it was: " + $6c8154472dd99012$var$M(r));
            for(var o = 0; o < r.length; ++o)if (!i(r[o])) throw new $6c8154472dd99012$var$c($6c8154472dd99012$var$a.INVALID_ARGUMENT, "Function " + t + "() requires all " + e + " elements to be " + n + ", but the value at index " + o + " was: " + $6c8154472dd99012$var$M(r[o]));
        }(t, e, n, r, i);
    }(t, "mergeFields", "a string or a FieldPath", e.mergeFields, function(t) {
        return "string" == typeof t || t instanceof $6c8154472dd99012$var$du;
    }), void 0 !== e.mergeFields && void 0 !== e.merge) throw new $6c8154472dd99012$var$c($6c8154472dd99012$var$a.INVALID_ARGUMENT, "Invalid options passed to function " + t + '(): You cannot specify both "merge" and "mergeFields".');
    return e;
}
function $6c8154472dd99012$var$da(t, e) {
    return void 0 === e ? {} : ($6c8154472dd99012$var$j(t, e, [
        "serverTimestamps"
    ]), $6c8154472dd99012$var$V(t, 0, "serverTimestamps", e.serverTimestamps, [
        "estimate",
        "previous",
        "none"
    ]), e);
}
function $6c8154472dd99012$var$va(t, e) {
    $6c8154472dd99012$var$R(t, "object", 1, e), e && ($6c8154472dd99012$var$j(t, e, [
        "source"
    ]), $6c8154472dd99012$var$V(t, 0, "source", e.source, [
        "default",
        "server",
        "cache"
    ]));
}
function $6c8154472dd99012$var$ya(t, e, n) {
    if (e instanceof $6c8154472dd99012$var$Au) {
        if (e.firestore !== n) throw new $6c8154472dd99012$var$c($6c8154472dd99012$var$a.INVALID_ARGUMENT, "Provided document reference is from a different Firestore instance.");
        return e;
    }
    throw $6c8154472dd99012$var$G(t, "DocumentReference", 1, e);
}
function $6c8154472dd99012$var$ga(t) {
    switch(t){
        case 0 /* Added */ :
            return "added";
        case 2 /* Modified */ :
        case 3 /* Metadata */ :
            return "modified";
        case 1 /* Removed */ :
            return "removed";
        default:
            return $6c8154472dd99012$var$y();
    }
}
/**
 * Converts custom model object of type T into DocumentData by applying the
 * converter if it exists.
 *
 * This function is used when converting user objects to DocumentData
 * because we want to provide the user with a more specific error message if
 * their set() or fails due to invalid data originating from a toFirestore()
 * call.
 */ function $6c8154472dd99012$var$ma(t, e, n) {
    // Cast to `any` in order to satisfy the union type constraint on
    // toFirestore().
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return t ? n && (n.merge || n.mergeFields) ? t.toFirestore(e, n) : t.toFirestore(e) : e;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $6c8154472dd99012$var$wa = /** @class */ function(e) {
    function n() {
        return null !== e && e.apply(this, arguments) || this;
    }
    return $876a70688d8d7977$export$a8ba968b8961cb8a(n, e), n.serverTimestamp = function() {
        $6c8154472dd99012$var$S("FieldValue.serverTimestamp", arguments);
        var t = new $6c8154472dd99012$var$wu("serverTimestamp");
        return t.e_ = "FieldValue.serverTimestamp", new n(t);
    }, n.delete = function() {
        $6c8154472dd99012$var$S("FieldValue.delete", arguments);
        var t = new $6c8154472dd99012$var$gu("deleteField");
        return t.e_ = "FieldValue.delete", new n(t);
    }, n.arrayUnion = function() {
        for(var t = [], e = 0; e < arguments.length; e++)t[e] = arguments[e];
        $6c8154472dd99012$var$x("FieldValue.arrayUnion", arguments, 1);
        var r = /**
 * Returns a special value that can be used with {@link setDoc()} or {@link
 * updateDoc()} that tells the server to union the given elements with any array
 * value that already exists on the server. Each specified element that doesn't
 * already exist in the array will be added to the end. If the field being
 * modified is not already an array it will be overwritten with an array
 * containing exactly the specified elements.
 *
 * @param elements The elements to union into the array.
 * @return The `FieldValue` sentinel for use in a call to `setDoc()` or
 * `updateDoc()`.
 */ (function() {
            for(var t = [], e = 0; e < arguments.length; e++)t[e] = arguments[e];
            // NOTE: We don't actually parse the data until it's used in set() or
            // update() since we'd need the Firestore instance to do this.
            return $6c8154472dd99012$var$x("arrayUnion()", arguments, 1), new $6c8154472dd99012$var$_u("arrayUnion", t);
        }).apply(void 0, t);
        return r.e_ = "FieldValue.arrayUnion", new n(r);
    }, n.arrayRemove = function() {
        for(var t = [], e = 0; e < arguments.length; e++)t[e] = arguments[e];
        $6c8154472dd99012$var$x("FieldValue.arrayRemove", arguments, 1);
        var r = (function() {
            for(var t = [], e = 0; e < arguments.length; e++)t[e] = arguments[e];
            // NOTE: We don't actually parse the data until it's used in set() or
            // update() since we'd need the Firestore instance to do this.
            return $6c8154472dd99012$var$x("arrayRemove()", arguments, 1), new $6c8154472dd99012$var$bu("arrayRemove", t);
        }).apply(void 0, t);
        return r.e_ = "FieldValue.arrayRemove", new n(r);
    }, n.increment = function(t) {
        $6c8154472dd99012$var$k("FieldValue.increment", "number", 1, t), $6c8154472dd99012$var$D("FieldValue.increment", arguments, 1);
        var e = function(t) {
            return new $6c8154472dd99012$var$Iu("increment", t);
        }(t);
        return e.e_ = "FieldValue.increment", new n(e);
    }, n.prototype.isEqual = function(t) {
        return this.l_.isEqual(t.l_);
    }, n;
}($6c8154472dd99012$var$Tu), $6c8154472dd99012$var$_a = {
    Firestore: $6c8154472dd99012$var$Xu,
    GeoPoint: $6c8154472dd99012$var$Eu,
    Timestamp: $6c8154472dd99012$var$ot,
    Blob: $6c8154472dd99012$var$et,
    Transaction: $6c8154472dd99012$var$Ju,
    WriteBatch: $6c8154472dd99012$var$Zu,
    DocumentReference: $6c8154472dd99012$var$ta,
    DocumentSnapshot: $6c8154472dd99012$var$na,
    Query: $6c8154472dd99012$var$ha,
    QueryDocumentSnapshot: $6c8154472dd99012$var$ra,
    QuerySnapshot: $6c8154472dd99012$var$fa,
    CollectionReference: $6c8154472dd99012$var$la,
    FieldPath: $6c8154472dd99012$var$du,
    FieldValue: $6c8154472dd99012$var$wa,
    setLogLevel: $6c8154472dd99012$var$Xu.setLogLevel,
    CACHE_SIZE_UNLIMITED: $6c8154472dd99012$var$Yu
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Configures Firestore as part of the Firebase SDK by calling registerService.
 *
 * @param firebase The FirebaseNamespace to register Firestore with
 * @param firestoreFactory A factory function that returns a new Firestore
 *    instance.
 */ /**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Registers the main Firestore build with the components framework.
 * Persistence can be enabled via `firebase.firestore().enablePersistence()`.
 */ function $6c8154472dd99012$var$ba(t) {
    !function(t, e) {
        t.INTERNAL.registerComponent(new $gLWqF.Component("firestore", function(t) {
            return function(t, e) {
                var n = new $6c8154472dd99012$var$fu, r = new $6c8154472dd99012$var$hu(n);
                return new $6c8154472dd99012$var$Xu(t, e, r, n);
            }(t.getProvider("app").getImmediate(), t.getProvider("auth-internal"));
        }, "PUBLIC" /* PUBLIC */ ).setServiceProps(Object.assign({}, $6c8154472dd99012$var$_a)));
    }(t), t.registerVersion("@firebase/firestore", "1.18.0");
}
$6c8154472dd99012$var$ba($6c8154472dd99012$var$u.default), $6c8154472dd99012$exports.__PRIVATE_registerFirestore = $6c8154472dd99012$var$ba;


"use strict";

var $31dJ8 = parcelRequire("31dJ8");
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $30f0aded86216ad5$var$extendStatics = function(d, b) {
    $30f0aded86216ad5$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $30f0aded86216ad5$var$extendStatics(d, b);
};
function $30f0aded86216ad5$export$a8ba968b8961cb8a(d, b) {
    $30f0aded86216ad5$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $30f0aded86216ad5$export$18ce0697a983be9b = function() {
    $30f0aded86216ad5$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $30f0aded86216ad5$export$18ce0697a983be9b.apply(this, arguments);
};
function $30f0aded86216ad5$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $30f0aded86216ad5$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $30f0aded86216ad5$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $30f0aded86216ad5$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $30f0aded86216ad5$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $30f0aded86216ad5$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $30f0aded86216ad5$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $30f0aded86216ad5$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $30f0aded86216ad5$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $30f0aded86216ad5$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $30f0aded86216ad5$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($30f0aded86216ad5$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $30f0aded86216ad5$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $30f0aded86216ad5$export$10c90e4f7922046c(v) {
    return this instanceof $30f0aded86216ad5$export$10c90e4f7922046c ? (this.v = v, this) : new $30f0aded86216ad5$export$10c90e4f7922046c(v);
}
function $30f0aded86216ad5$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $30f0aded86216ad5$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $30f0aded86216ad5$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $30f0aded86216ad5$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $30f0aded86216ad5$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $30f0aded86216ad5$export$19a8beecd37a4c45 === "function" ? $30f0aded86216ad5$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $30f0aded86216ad5$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $30f0aded86216ad5$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $30f0aded86216ad5$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $30f0aded86216ad5$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $30f0aded86216ad5$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}



var $gLWqF = parcelRequire("gLWqF");
function $ef01953ee5efc889$var$_interopDefaultLegacy(e) {
    return e && typeof e === "object" && "default" in e ? e : {
        "default": e
    };
}
var $ef01953ee5efc889$var$firebase__default = /*#__PURE__*/ $ef01953ee5efc889$var$_interopDefaultLegacy($31dJ8);
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Standard error codes for different ways a request can fail, as defined by:
 * https://github.com/googleapis/googleapis/blob/master/google/rpc/code.proto
 *
 * This map is used primarily to convert from a backend error code string to
 * a client SDK error code string, and make sure it's in the supported set.
 */ var $ef01953ee5efc889$var$errorCodeMap = {
    OK: "ok",
    CANCELLED: "cancelled",
    UNKNOWN: "unknown",
    INVALID_ARGUMENT: "invalid-argument",
    DEADLINE_EXCEEDED: "deadline-exceeded",
    NOT_FOUND: "not-found",
    ALREADY_EXISTS: "already-exists",
    PERMISSION_DENIED: "permission-denied",
    UNAUTHENTICATED: "unauthenticated",
    RESOURCE_EXHAUSTED: "resource-exhausted",
    FAILED_PRECONDITION: "failed-precondition",
    ABORTED: "aborted",
    OUT_OF_RANGE: "out-of-range",
    UNIMPLEMENTED: "unimplemented",
    INTERNAL: "internal",
    UNAVAILABLE: "unavailable",
    DATA_LOSS: "data-loss"
};
/**
 * An explicit error that can be thrown from a handler to send an error to the
 * client that called the function.
 */ var $ef01953ee5efc889$var$HttpsErrorImpl = /** @class */ function(_super) {
    $30f0aded86216ad5$export$a8ba968b8961cb8a(HttpsErrorImpl, _super);
    function HttpsErrorImpl(code, message, details) {
        var _this = _super.call(this, message) || this;
        // This is a workaround for a bug in TypeScript when extending Error:
        // tslint:disable-next-line
        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(_this, HttpsErrorImpl.prototype);
        _this.code = code;
        _this.details = details;
        return _this;
    }
    return HttpsErrorImpl;
}(Error);
/**
 * Takes an HTTP status code and returns the corresponding ErrorCode.
 * This is the standard HTTP status code -> error mapping defined in:
 * https://github.com/googleapis/googleapis/blob/master/google/rpc/code.proto
 *
 * @param status An HTTP status code.
 * @return The corresponding ErrorCode, or ErrorCode.UNKNOWN if none.
 */ function $ef01953ee5efc889$var$codeForHTTPStatus(status) {
    // Make sure any successful status is OK.
    if (status >= 200 && status < 300) return "ok";
    switch(status){
        case 0:
            // This can happen if the server returns 500.
            return "internal";
        case 400:
            return "invalid-argument";
        case 401:
            return "unauthenticated";
        case 403:
            return "permission-denied";
        case 404:
            return "not-found";
        case 409:
            return "aborted";
        case 429:
            return "resource-exhausted";
        case 499:
            return "cancelled";
        case 500:
            return "internal";
        case 501:
            return "unimplemented";
        case 503:
            return "unavailable";
        case 504:
            return "deadline-exceeded";
    }
    return "unknown";
}
/**
 * Takes an HTTP response and returns the corresponding Error, if any.
 */ function $ef01953ee5efc889$var$_errorForResponse(status, bodyJSON, serializer) {
    var code = $ef01953ee5efc889$var$codeForHTTPStatus(status);
    // Start with reasonable defaults from the status code.
    var description = code;
    var details = undefined;
    // Then look through the body for explicit details.
    try {
        var errorJSON = bodyJSON && bodyJSON.error;
        if (errorJSON) {
            var status_1 = errorJSON.status;
            if (typeof status_1 === "string") {
                if (!$ef01953ee5efc889$var$errorCodeMap[status_1]) // They must've included an unknown error code in the body.
                return new $ef01953ee5efc889$var$HttpsErrorImpl("internal", "internal");
                code = $ef01953ee5efc889$var$errorCodeMap[status_1];
                // TODO(klimt): Add better default descriptions for error enums.
                // The default description needs to be updated for the new code.
                description = status_1;
            }
            var message = errorJSON.message;
            if (typeof message === "string") description = message;
            details = errorJSON.details;
            if (details !== undefined) details = serializer.decode(details);
        }
    } catch (e) {
    // If we couldn't parse explicit error data, that's fine.
    }
    if (code === "ok") // Technically, there's an edge case where a developer could explicitly
    // return an error code of OK, and we will treat it as success, but that
    // seems reasonable.
    return null;
    return new $ef01953ee5efc889$var$HttpsErrorImpl(code, description, details);
}
/**
 * Helper class to get metadata that should be included with a function call.
 */ var $ef01953ee5efc889$var$ContextProvider = /** @class */ function() {
    function ContextProvider(authProvider, messagingProvider) {
        var _this = this;
        this.auth = null;
        this.messaging = null;
        this.auth = authProvider.getImmediate({
            optional: true
        });
        this.messaging = messagingProvider.getImmediate({
            optional: true
        });
        if (!this.auth) authProvider.get().then(function(auth) {
            return _this.auth = auth;
        }, function() {
        /* get() never rejects */ });
        if (!this.messaging) messagingProvider.get().then(function(messaging) {
            return _this.messaging = messaging;
        }, function() {
        /* get() never rejects */ });
    }
    ContextProvider.prototype.getAuthToken = function() {
        return $30f0aded86216ad5$export$1050f835b63b671e(this, void 0, void 0, function() {
            var token, e_1;
            return $30f0aded86216ad5$export$67ebef60e6f28a6(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!this.auth) return [
                            2 /*return*/ ,
                            undefined
                        ];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.auth.getToken()
                        ];
                    case 2:
                        token = _a.sent();
                        if (!token) return [
                            2 /*return*/ ,
                            undefined
                        ];
                        return [
                            2 /*return*/ ,
                            token.accessToken
                        ];
                    case 3:
                        e_1 = _a.sent();
                        // If there's any error when trying to get the auth token, leave it off.
                        return [
                            2 /*return*/ ,
                            undefined
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    ContextProvider.prototype.getInstanceIdToken = function() {
        return $30f0aded86216ad5$export$1050f835b63b671e(this, void 0, void 0, function() {
            return $30f0aded86216ad5$export$67ebef60e6f28a6(this, function(_a) {
                if (!this.messaging || !("Notification" in self) || Notification.permission !== "granted") return [
                    2 /*return*/ ,
                    undefined
                ];
                try {
                    return [
                        2 /*return*/ ,
                        this.messaging.getToken()
                    ];
                } catch (e) {
                    // We don't warn on this, because it usually means messaging isn't set up.
                    // console.warn('Failed to retrieve instance id token.', e);
                    // If there's any error when trying to get the token, leave it off.
                    return [
                        2 /*return*/ ,
                        undefined
                    ];
                }
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    ContextProvider.prototype.getContext = function() {
        return $30f0aded86216ad5$export$1050f835b63b671e(this, void 0, void 0, function() {
            var authToken, instanceIdToken;
            return $30f0aded86216ad5$export$67ebef60e6f28a6(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.getAuthToken()
                        ];
                    case 1:
                        authToken = _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.getInstanceIdToken()
                        ];
                    case 2:
                        instanceIdToken = _a.sent();
                        return [
                            2 /*return*/ ,
                            {
                                authToken: authToken,
                                instanceIdToken: instanceIdToken
                            }
                        ];
                }
            });
        });
    };
    return ContextProvider;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $ef01953ee5efc889$var$LONG_TYPE = "type.googleapis.com/google.protobuf.Int64Value";
var $ef01953ee5efc889$var$UNSIGNED_LONG_TYPE = "type.googleapis.com/google.protobuf.UInt64Value";
function $ef01953ee5efc889$var$mapValues(// { [k: string]: unknown } is no longer a wildcard assignment target after typescript 3.5
// eslint-disable-next-line @typescript-eslint/no-explicit-any
o, f) {
    var result = {};
    for(var key in o)if (o.hasOwnProperty(key)) result[key] = f(o[key]);
    return result;
}
var $ef01953ee5efc889$var$Serializer = /** @class */ function() {
    function Serializer() {}
    // Takes data and encodes it in a JSON-friendly way, such that types such as
    // Date are preserved.
    Serializer.prototype.encode = function(data) {
        var _this = this;
        if (data == null) return null;
        if (data instanceof Number) data = data.valueOf();
        if (typeof data === "number" && isFinite(data)) // Any number in JS is safe to put directly in JSON and parse as a double
        // without any loss of precision.
        return data;
        if (data === true || data === false) return data;
        if (Object.prototype.toString.call(data) === "[object String]") return data;
        if (Array.isArray(data)) return data.map(function(x) {
            return _this.encode(x);
        });
        if (typeof data === "function" || typeof data === "object") return $ef01953ee5efc889$var$mapValues(data, function(x) {
            return _this.encode(x);
        });
        // If we got this far, the data is not encodable.
        throw new Error("Data cannot be encoded in JSON: " + data);
    };
    // Takes data that's been encoded in a JSON-friendly form and returns a form
    // with richer datatypes, such as Dates, etc.
    Serializer.prototype.decode = function(json) {
        var _this = this;
        if (json == null) return json;
        if (json["@type"]) switch(json["@type"]){
            case $ef01953ee5efc889$var$LONG_TYPE:
            // Fall through and handle this the same as unsigned.
            case $ef01953ee5efc889$var$UNSIGNED_LONG_TYPE:
                // Technically, this could work return a valid number for malformed
                // data if there was a number followed by garbage. But it's just not
                // worth all the extra code to detect that case.
                var value = Number(json["value"]);
                if (isNaN(value)) throw new Error("Data cannot be decoded from JSON: " + json);
                return value;
            default:
                throw new Error("Data cannot be decoded from JSON: " + json);
        }
        if (Array.isArray(json)) return json.map(function(x) {
            return _this.decode(x);
        });
        if (typeof json === "function" || typeof json === "object") return $ef01953ee5efc889$var$mapValues(json, function(x) {
            return _this.decode(x);
        });
        // Anything else is safe to return.
        return json;
    };
    return Serializer;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a Promise that will be rejected after the given duration.
 * The error will be of type HttpsErrorImpl.
 *
 * @param millis Number of milliseconds to wait before rejecting.
 */ function $ef01953ee5efc889$var$failAfter(millis) {
    var timer;
    var promise = new Promise(function(_, reject) {
        timer = setTimeout(function() {
            reject(new $ef01953ee5efc889$var$HttpsErrorImpl("deadline-exceeded", "deadline-exceeded"));
        }, millis);
    });
    return {
        timer: timer,
        promise: promise
    };
}
/**
 * The main class for the Firebase Functions SDK.
 */ var $ef01953ee5efc889$var$Service = /** @class */ function() {
    /**
     * Creates a new Functions service for the given app and (optional) region or custom domain.
     * @param app_ The FirebaseApp to use.
     * @param regionOrCustomDomain_ one of:
     *   a) A region to call functions from, such as us-central1
     *   b) A custom domain to use as a functions prefix, such as https://mydomain.com
     */ function Service(app_, authProvider, messagingProvider, regionOrCustomDomain_, fetchImpl) {
        var _this = this;
        if (regionOrCustomDomain_ === void 0) regionOrCustomDomain_ = "us-central1";
        this.app_ = app_;
        this.fetchImpl = fetchImpl;
        this.serializer = new $ef01953ee5efc889$var$Serializer();
        this.emulatorOrigin = null;
        this.INTERNAL = {
            delete: function() {
                return Promise.resolve(_this.deleteService());
            }
        };
        this.contextProvider = new $ef01953ee5efc889$var$ContextProvider(authProvider, messagingProvider);
        // Cancels all ongoing requests when resolved.
        this.cancelAllRequests = new Promise(function(resolve) {
            _this.deleteService = function() {
                return resolve();
            };
        });
        // Resolve the region or custom domain overload by attempting to parse it.
        try {
            var url = new URL(regionOrCustomDomain_);
            this.customDomain = url.origin;
            this.region = "us-central1";
        } catch (e) {
            this.customDomain = null;
            this.region = regionOrCustomDomain_;
        }
    }
    Object.defineProperty(Service.prototype, "app", {
        get: function() {
            return this.app_;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Returns the URL for a callable with the given name.
     * @param name The name of the callable.
     */ Service.prototype._url = function(name) {
        var projectId = this.app_.options.projectId;
        if (this.emulatorOrigin !== null) {
            var origin_1 = this.emulatorOrigin;
            return origin_1 + "/" + projectId + "/" + this.region + "/" + name;
        }
        if (this.customDomain !== null) return this.customDomain + "/" + name;
        return "https://" + this.region + "-" + projectId + ".cloudfunctions.net/" + name;
    };
    /**
     * Changes this instance to point to a Cloud Functions emulator running
     * locally. See https://firebase.google.com/docs/functions/local-emulator
     *
     * @param origin The origin of the local emulator, such as
     * "http://localhost:5005".
     */ Service.prototype.useFunctionsEmulator = function(origin) {
        this.emulatorOrigin = origin;
    };
    /**
     * Returns a reference to the callable https trigger with the given name.
     * @param name The name of the trigger.
     */ Service.prototype.httpsCallable = function(name, options) {
        var _this = this;
        return function(data) {
            return _this.call(name, data, options || {});
        };
    };
    /**
     * Does an HTTP POST and returns the completed response.
     * @param url The url to post to.
     * @param body The JSON body of the post.
     * @param headers The HTTP headers to include in the request.
     * @return A Promise that will succeed when the request finishes.
     */ Service.prototype.postJSON = function(url, body, headers) {
        return $30f0aded86216ad5$export$1050f835b63b671e(this, void 0, void 0, function() {
            var response, e_1, json, e_2;
            return $30f0aded86216ad5$export$67ebef60e6f28a6(this, function(_a) {
                switch(_a.label){
                    case 0:
                        headers["Content-Type"] = "application/json";
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.fetchImpl(url, {
                                method: "POST",
                                body: JSON.stringify(body),
                                headers: headers
                            })
                        ];
                    case 2:
                        response = _a.sent();
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        e_1 = _a.sent();
                        // This could be an unhandled error on the backend, or it could be a
                        // network error. There's no way to know, since an unhandled error on the
                        // backend will fail to set the proper CORS header, and thus will be
                        // treated as a network error by fetch.
                        return [
                            2 /*return*/ ,
                            {
                                status: 0,
                                json: null
                            }
                        ];
                    case 4:
                        json = null;
                        _a.label = 5;
                    case 5:
                        _a.trys.push([
                            5,
                            7,
                            ,
                            8
                        ]);
                        return [
                            4 /*yield*/ ,
                            response.json()
                        ];
                    case 6:
                        json = _a.sent();
                        return [
                            3 /*break*/ ,
                            8
                        ];
                    case 7:
                        e_2 = _a.sent();
                        return [
                            3 /*break*/ ,
                            8
                        ];
                    case 8:
                        return [
                            2 /*return*/ ,
                            {
                                status: response.status,
                                json: json
                            }
                        ];
                }
            });
        });
    };
    /**
     * Calls a callable function asynchronously and returns the result.
     * @param name The name of the callable trigger.
     * @param data The data to pass as params to the function.s
     */ Service.prototype.call = function(name, data, options) {
        return $30f0aded86216ad5$export$1050f835b63b671e(this, void 0, void 0, function() {
            var url, body, headers, context, timeout, _a, timer, failAfterPromise, response, error, responseData, decodedData;
            return $30f0aded86216ad5$export$67ebef60e6f28a6(this, function(_b) {
                switch(_b.label){
                    case 0:
                        url = this._url(name);
                        // Encode any special types, such as dates, in the input data.
                        data = this.serializer.encode(data);
                        body = {
                            data: data
                        };
                        headers = {};
                        return [
                            4 /*yield*/ ,
                            this.contextProvider.getContext()
                        ];
                    case 1:
                        context = _b.sent();
                        if (context.authToken) headers["Authorization"] = "Bearer " + context.authToken;
                        if (context.instanceIdToken) headers["Firebase-Instance-ID-Token"] = context.instanceIdToken;
                        timeout = options.timeout || 70000;
                        _a = $ef01953ee5efc889$var$failAfter(timeout), timer = _a.timer, failAfterPromise = _a.promise;
                        return [
                            4 /*yield*/ ,
                            Promise.race([
                                $ef01953ee5efc889$var$clearTimeoutWrapper(timer, this.postJSON(url, body, headers)),
                                failAfterPromise,
                                $ef01953ee5efc889$var$clearTimeoutWrapper(timer, this.cancelAllRequests)
                            ])
                        ];
                    case 2:
                        response = _b.sent();
                        // If service was deleted, interrupted response throws an error.
                        if (!response) throw new $ef01953ee5efc889$var$HttpsErrorImpl("cancelled", "Firebase Functions instance was deleted.");
                        error = $ef01953ee5efc889$var$_errorForResponse(response.status, response.json, this.serializer);
                        if (error) throw error;
                        if (!response.json) throw new $ef01953ee5efc889$var$HttpsErrorImpl("internal", "Response is not valid JSON object.");
                        responseData = response.json.data;
                        // TODO(klimt): For right now, allow "result" instead of "data", for
                        // backwards compatibility.
                        if (typeof responseData === "undefined") responseData = response.json.result;
                        if (typeof responseData === "undefined") // Consider the response malformed.
                        throw new $ef01953ee5efc889$var$HttpsErrorImpl("internal", "Response is missing data field.");
                        decodedData = this.serializer.decode(responseData);
                        return [
                            2 /*return*/ ,
                            {
                                data: decodedData
                            }
                        ];
                }
            });
        });
    };
    return Service;
}();
function $ef01953ee5efc889$var$clearTimeoutWrapper(timer, promise) {
    return $30f0aded86216ad5$export$1050f835b63b671e(this, void 0, void 0, function() {
        var result;
        return $30f0aded86216ad5$export$67ebef60e6f28a6(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        promise
                    ];
                case 1:
                    result = _a.sent();
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    clearTimeout(timer);
                    return [
                        2 /*return*/ ,
                        result
                    ];
            }
        });
    });
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Type constant for Firebase Functions.
 */ var $ef01953ee5efc889$var$FUNCTIONS_TYPE = "functions";
function $ef01953ee5efc889$var$registerFunctions(instance, fetchImpl) {
    var namespaceExports = {
        // no-inline
        Functions: $ef01953ee5efc889$var$Service
    };
    function factory(container, regionOrCustomDomain) {
        // Dependencies
        var app = container.getProvider("app").getImmediate();
        var authProvider = container.getProvider("auth-internal");
        var messagingProvider = container.getProvider("messaging");
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return new $ef01953ee5efc889$var$Service(app, authProvider, messagingProvider, regionOrCustomDomain, fetchImpl);
    }
    instance.INTERNAL.registerComponent(new $gLWqF.Component($ef01953ee5efc889$var$FUNCTIONS_TYPE, factory, "PUBLIC" /* PUBLIC */ ).setServiceProps(namespaceExports).setMultipleInstances(true));
}
var $ef01953ee5efc889$var$name = "@firebase/functions";
var $ef01953ee5efc889$var$version = "0.5.1";
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ $ef01953ee5efc889$var$registerFunctions($ef01953ee5efc889$var$firebase__default["default"], fetch.bind(self));
$ef01953ee5efc889$var$firebase__default["default"].registerVersion($ef01953ee5efc889$var$name, $ef01953ee5efc889$var$version);



var $31dJ8 = parcelRequire("31dJ8");

var $gLWqF = parcelRequire("gLWqF");
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $4e72214060a8a819$var$extendStatics = function(d, b) {
    $4e72214060a8a819$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $4e72214060a8a819$var$extendStatics(d, b);
};
function $4e72214060a8a819$export$a8ba968b8961cb8a(d, b) {
    $4e72214060a8a819$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $4e72214060a8a819$export$18ce0697a983be9b = function() {
    $4e72214060a8a819$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $4e72214060a8a819$export$18ce0697a983be9b.apply(this, arguments);
};
function $4e72214060a8a819$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $4e72214060a8a819$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $4e72214060a8a819$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $4e72214060a8a819$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $4e72214060a8a819$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $4e72214060a8a819$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $4e72214060a8a819$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $4e72214060a8a819$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $4e72214060a8a819$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $4e72214060a8a819$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $4e72214060a8a819$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($4e72214060a8a819$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $4e72214060a8a819$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $4e72214060a8a819$export$10c90e4f7922046c(v) {
    return this instanceof $4e72214060a8a819$export$10c90e4f7922046c ? (this.v = v, this) : new $4e72214060a8a819$export$10c90e4f7922046c(v);
}
function $4e72214060a8a819$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $4e72214060a8a819$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $4e72214060a8a819$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $4e72214060a8a819$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $4e72214060a8a819$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $4e72214060a8a819$export$19a8beecd37a4c45 === "function" ? $4e72214060a8a819$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $4e72214060a8a819$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $4e72214060a8a819$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $4e72214060a8a819$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $4e72214060a8a819$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $4e72214060a8a819$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}



var $01sTD = parcelRequire("01sTD");
var $51f7971b764ad640$exports = {};
(function(global, factory) {
    factory($51f7971b764ad640$exports);
})($51f7971b764ad640$exports, function(exports1) {
    "use strict";
    function toArray(arr) {
        return Array.prototype.slice.call(arr);
    }
    function promisifyRequest(request) {
        return new Promise(function(resolve, reject) {
            request.onsuccess = function() {
                resolve(request.result);
            };
            request.onerror = function() {
                reject(request.error);
            };
        });
    }
    function promisifyRequestCall(obj, method, args) {
        var request;
        var p = new Promise(function(resolve, reject) {
            request = obj[method].apply(obj, args);
            promisifyRequest(request).then(resolve, reject);
        });
        p.request = request;
        return p;
    }
    function promisifyCursorRequestCall(obj, method, args) {
        var p = promisifyRequestCall(obj, method, args);
        return p.then(function(value) {
            if (!value) return;
            return new Cursor(value, p.request);
        });
    }
    function proxyProperties(ProxyClass, targetProp, properties) {
        properties.forEach(function(prop) {
            Object.defineProperty(ProxyClass.prototype, prop, {
                get: function() {
                    return this[targetProp][prop];
                },
                set: function(val) {
                    this[targetProp][prop] = val;
                }
            });
        });
    }
    function proxyRequestMethods(ProxyClass, targetProp, Constructor, properties) {
        properties.forEach(function(prop) {
            if (!(prop in Constructor.prototype)) return;
            ProxyClass.prototype[prop] = function() {
                return promisifyRequestCall(this[targetProp], prop, arguments);
            };
        });
    }
    function proxyMethods(ProxyClass, targetProp, Constructor, properties) {
        properties.forEach(function(prop) {
            if (!(prop in Constructor.prototype)) return;
            ProxyClass.prototype[prop] = function() {
                return this[targetProp][prop].apply(this[targetProp], arguments);
            };
        });
    }
    function proxyCursorRequestMethods(ProxyClass, targetProp, Constructor, properties) {
        properties.forEach(function(prop) {
            if (!(prop in Constructor.prototype)) return;
            ProxyClass.prototype[prop] = function() {
                return promisifyCursorRequestCall(this[targetProp], prop, arguments);
            };
        });
    }
    function Index(index) {
        this._index = index;
    }
    proxyProperties(Index, "_index", [
        "name",
        "keyPath",
        "multiEntry",
        "unique"
    ]);
    proxyRequestMethods(Index, "_index", IDBIndex, [
        "get",
        "getKey",
        "getAll",
        "getAllKeys",
        "count"
    ]);
    proxyCursorRequestMethods(Index, "_index", IDBIndex, [
        "openCursor",
        "openKeyCursor"
    ]);
    function Cursor(cursor, request) {
        this._cursor = cursor;
        this._request = request;
    }
    proxyProperties(Cursor, "_cursor", [
        "direction",
        "key",
        "primaryKey",
        "value"
    ]);
    proxyRequestMethods(Cursor, "_cursor", IDBCursor, [
        "update",
        "delete"
    ]);
    // proxy 'next' methods
    [
        "advance",
        "continue",
        "continuePrimaryKey"
    ].forEach(function(methodName) {
        if (!(methodName in IDBCursor.prototype)) return;
        Cursor.prototype[methodName] = function() {
            var cursor = this;
            var args = arguments;
            return Promise.resolve().then(function() {
                cursor._cursor[methodName].apply(cursor._cursor, args);
                return promisifyRequest(cursor._request).then(function(value) {
                    if (!value) return;
                    return new Cursor(value, cursor._request);
                });
            });
        };
    });
    function ObjectStore(store) {
        this._store = store;
    }
    ObjectStore.prototype.createIndex = function() {
        return new Index(this._store.createIndex.apply(this._store, arguments));
    };
    ObjectStore.prototype.index = function() {
        return new Index(this._store.index.apply(this._store, arguments));
    };
    proxyProperties(ObjectStore, "_store", [
        "name",
        "keyPath",
        "indexNames",
        "autoIncrement"
    ]);
    proxyRequestMethods(ObjectStore, "_store", IDBObjectStore, [
        "put",
        "add",
        "delete",
        "clear",
        "get",
        "getAll",
        "getKey",
        "getAllKeys",
        "count"
    ]);
    proxyCursorRequestMethods(ObjectStore, "_store", IDBObjectStore, [
        "openCursor",
        "openKeyCursor"
    ]);
    proxyMethods(ObjectStore, "_store", IDBObjectStore, [
        "deleteIndex"
    ]);
    function Transaction(idbTransaction) {
        this._tx = idbTransaction;
        this.complete = new Promise(function(resolve, reject) {
            idbTransaction.oncomplete = function() {
                resolve();
            };
            idbTransaction.onerror = function() {
                reject(idbTransaction.error);
            };
            idbTransaction.onabort = function() {
                reject(idbTransaction.error);
            };
        });
    }
    Transaction.prototype.objectStore = function() {
        return new ObjectStore(this._tx.objectStore.apply(this._tx, arguments));
    };
    proxyProperties(Transaction, "_tx", [
        "objectStoreNames",
        "mode"
    ]);
    proxyMethods(Transaction, "_tx", IDBTransaction, [
        "abort"
    ]);
    function UpgradeDB(db, oldVersion, transaction) {
        this._db = db;
        this.oldVersion = oldVersion;
        this.transaction = new Transaction(transaction);
    }
    UpgradeDB.prototype.createObjectStore = function() {
        return new ObjectStore(this._db.createObjectStore.apply(this._db, arguments));
    };
    proxyProperties(UpgradeDB, "_db", [
        "name",
        "version",
        "objectStoreNames"
    ]);
    proxyMethods(UpgradeDB, "_db", IDBDatabase, [
        "deleteObjectStore",
        "close"
    ]);
    function DB(db) {
        this._db = db;
    }
    DB.prototype.transaction = function() {
        return new Transaction(this._db.transaction.apply(this._db, arguments));
    };
    proxyProperties(DB, "_db", [
        "name",
        "version",
        "objectStoreNames"
    ]);
    proxyMethods(DB, "_db", IDBDatabase, [
        "close"
    ]);
    // Add cursor iterators
    // TODO: remove this once browsers do the right thing with promises
    [
        "openCursor",
        "openKeyCursor"
    ].forEach(function(funcName) {
        [
            ObjectStore,
            Index
        ].forEach(function(Constructor) {
            // Don't create iterateKeyCursor if openKeyCursor doesn't exist.
            if (!(funcName in Constructor.prototype)) return;
            Constructor.prototype[funcName.replace("open", "iterate")] = function() {
                var args = toArray(arguments);
                var callback = args[args.length - 1];
                var nativeObject = this._store || this._index;
                var request = nativeObject[funcName].apply(nativeObject, args.slice(0, -1));
                request.onsuccess = function() {
                    callback(request.result);
                };
            };
        });
    });
    // polyfill getAll
    [
        Index,
        ObjectStore
    ].forEach(function(Constructor) {
        if (Constructor.prototype.getAll) return;
        Constructor.prototype.getAll = function(query, count) {
            var instance = this;
            var items = [];
            return new Promise(function(resolve) {
                instance.iterateCursor(query, function(cursor) {
                    if (!cursor) {
                        resolve(items);
                        return;
                    }
                    items.push(cursor.value);
                    if (count !== undefined && items.length == count) {
                        resolve(items);
                        return;
                    }
                    cursor.continue();
                });
            });
        };
    });
    function openDb(name, version, upgradeCallback) {
        var p = promisifyRequestCall(indexedDB, "open", [
            name,
            version
        ]);
        var request = p.request;
        if (request) request.onupgradeneeded = function(event) {
            if (upgradeCallback) upgradeCallback(new UpgradeDB(request.result, event.oldVersion, request.transaction));
        };
        return p.then(function(db) {
            return new DB(db);
        });
    }
    function deleteDb(name) {
        return promisifyRequestCall(indexedDB, "deleteDatabase", [
            name
        ]);
    }
    exports1.openDb = openDb;
    exports1.deleteDb = deleteDb;
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
});


var $5379e25dedbacb82$var$name = "@firebase/installations";
var $5379e25dedbacb82$var$version = "0.4.17";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $5379e25dedbacb82$var$PENDING_TIMEOUT_MS = 10000;
var $5379e25dedbacb82$var$PACKAGE_VERSION = "w:" + $5379e25dedbacb82$var$version;
var $5379e25dedbacb82$var$INTERNAL_AUTH_VERSION = "FIS_v2";
var $5379e25dedbacb82$var$INSTALLATIONS_API_URL = "https://firebaseinstallations.googleapis.com/v1";
var $5379e25dedbacb82$var$TOKEN_EXPIRATION_BUFFER = 3600000; // One hour
var $5379e25dedbacb82$var$SERVICE = "installations";
var $5379e25dedbacb82$var$SERVICE_NAME = "Installations";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $5379e25dedbacb82$var$_a;
var $5379e25dedbacb82$var$ERROR_DESCRIPTION_MAP = ($5379e25dedbacb82$var$_a = {}, $5379e25dedbacb82$var$_a["missing-app-config-values" /* MISSING_APP_CONFIG_VALUES */ ] = 'Missing App configuration value: "{$valueName}"', $5379e25dedbacb82$var$_a["not-registered" /* NOT_REGISTERED */ ] = "Firebase Installation is not registered.", $5379e25dedbacb82$var$_a["installation-not-found" /* INSTALLATION_NOT_FOUND */ ] = "Firebase Installation not found.", $5379e25dedbacb82$var$_a["request-failed" /* REQUEST_FAILED */ ] = '{$requestName} request failed with error "{$serverCode} {$serverStatus}: {$serverMessage}"', $5379e25dedbacb82$var$_a["app-offline" /* APP_OFFLINE */ ] = "Could not process request. Application offline.", $5379e25dedbacb82$var$_a["delete-pending-registration" /* DELETE_PENDING_REGISTRATION */ ] = "Can't delete installation while there is a pending registration request.", $5379e25dedbacb82$var$_a);
var $5379e25dedbacb82$var$ERROR_FACTORY = new (0, $01sTD.ErrorFactory)($5379e25dedbacb82$var$SERVICE, $5379e25dedbacb82$var$SERVICE_NAME, $5379e25dedbacb82$var$ERROR_DESCRIPTION_MAP);
/** Returns true if error is a FirebaseError that is based on an error from the server. */ function $5379e25dedbacb82$var$isServerError(error) {
    return error instanceof (0, $01sTD.FirebaseError) && error.code.includes("request-failed" /* REQUEST_FAILED */ );
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $5379e25dedbacb82$var$getInstallationsEndpoint(_a) {
    var projectId = _a.projectId;
    return $5379e25dedbacb82$var$INSTALLATIONS_API_URL + "/projects/" + projectId + "/installations";
}
function $5379e25dedbacb82$var$extractAuthTokenInfoFromResponse(response) {
    return {
        token: response.token,
        requestStatus: 2 /* COMPLETED */ ,
        expiresIn: $5379e25dedbacb82$var$getExpiresInFromResponseExpiresIn(response.expiresIn),
        creationTime: Date.now()
    };
}
function $5379e25dedbacb82$var$getErrorFromResponse(requestName, response) {
    return (0, $4e72214060a8a819$export$1050f835b63b671e)(this, void 0, void 0, function() {
        var responseJson, errorData;
        return (0, $4e72214060a8a819$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        response.json()
                    ];
                case 1:
                    responseJson = _a.sent();
                    errorData = responseJson.error;
                    return [
                        2 /*return*/ ,
                        $5379e25dedbacb82$var$ERROR_FACTORY.create("request-failed" /* REQUEST_FAILED */ , {
                            requestName: requestName,
                            serverCode: errorData.code,
                            serverMessage: errorData.message,
                            serverStatus: errorData.status
                        })
                    ];
            }
        });
    });
}
function $5379e25dedbacb82$var$getHeaders(_a) {
    var apiKey = _a.apiKey;
    return new Headers({
        "Content-Type": "application/json",
        Accept: "application/json",
        "x-goog-api-key": apiKey
    });
}
function $5379e25dedbacb82$var$getHeadersWithAuth(appConfig, _a) {
    var refreshToken = _a.refreshToken;
    var headers = $5379e25dedbacb82$var$getHeaders(appConfig);
    headers.append("Authorization", $5379e25dedbacb82$var$getAuthorizationHeader(refreshToken));
    return headers;
}
/**
 * Calls the passed in fetch wrapper and returns the response.
 * If the returned response has a status of 5xx, re-runs the function once and
 * returns the response.
 */ function $5379e25dedbacb82$var$retryIfServerError(fn) {
    return (0, $4e72214060a8a819$export$1050f835b63b671e)(this, void 0, void 0, function() {
        var result;
        return (0, $4e72214060a8a819$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        fn()
                    ];
                case 1:
                    result = _a.sent();
                    if (result.status >= 500 && result.status < 600) // Internal Server Error. Retry request.
                    return [
                        2 /*return*/ ,
                        fn()
                    ];
                    return [
                        2 /*return*/ ,
                        result
                    ];
            }
        });
    });
}
function $5379e25dedbacb82$var$getExpiresInFromResponseExpiresIn(responseExpiresIn) {
    // This works because the server will never respond with fractions of a second.
    return Number(responseExpiresIn.replace("s", "000"));
}
function $5379e25dedbacb82$var$getAuthorizationHeader(refreshToken) {
    return $5379e25dedbacb82$var$INTERNAL_AUTH_VERSION + " " + refreshToken;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $5379e25dedbacb82$var$createInstallationRequest(appConfig, _a) {
    var fid = _a.fid;
    return (0, $4e72214060a8a819$export$1050f835b63b671e)(this, void 0, void 0, function() {
        var endpoint, headers, body, request, response, responseValue, registeredInstallationEntry;
        return (0, $4e72214060a8a819$export$67ebef60e6f28a6)(this, function(_b) {
            switch(_b.label){
                case 0:
                    endpoint = $5379e25dedbacb82$var$getInstallationsEndpoint(appConfig);
                    headers = $5379e25dedbacb82$var$getHeaders(appConfig);
                    body = {
                        fid: fid,
                        authVersion: $5379e25dedbacb82$var$INTERNAL_AUTH_VERSION,
                        appId: appConfig.appId,
                        sdkVersion: $5379e25dedbacb82$var$PACKAGE_VERSION
                    };
                    request = {
                        method: "POST",
                        headers: headers,
                        body: JSON.stringify(body)
                    };
                    return [
                        4 /*yield*/ ,
                        $5379e25dedbacb82$var$retryIfServerError(function() {
                            return fetch(endpoint, request);
                        })
                    ];
                case 1:
                    response = _b.sent();
                    if (!response.ok) return [
                        3 /*break*/ ,
                        3
                    ];
                    return [
                        4 /*yield*/ ,
                        response.json()
                    ];
                case 2:
                    responseValue = _b.sent();
                    registeredInstallationEntry = {
                        fid: responseValue.fid || fid,
                        registrationStatus: 2 /* COMPLETED */ ,
                        refreshToken: responseValue.refreshToken,
                        authToken: $5379e25dedbacb82$var$extractAuthTokenInfoFromResponse(responseValue.authToken)
                    };
                    return [
                        2 /*return*/ ,
                        registeredInstallationEntry
                    ];
                case 3:
                    return [
                        4 /*yield*/ ,
                        $5379e25dedbacb82$var$getErrorFromResponse("Create Installation", response)
                    ];
                case 4:
                    throw _b.sent();
            }
        });
    });
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Returns a promise that resolves after given time passes. */ function $5379e25dedbacb82$var$sleep(ms) {
    return new Promise(function(resolve) {
        setTimeout(resolve, ms);
    });
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $5379e25dedbacb82$var$bufferToBase64UrlSafe(array) {
    var b64 = btoa(String.fromCharCode.apply(String, (0, $4e72214060a8a819$export$afc72e2116322959)(array)));
    return b64.replace(/\+/g, "-").replace(/\//g, "_");
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $5379e25dedbacb82$var$VALID_FID_PATTERN = /^[cdef][\w-]{21}$/;
var $5379e25dedbacb82$var$INVALID_FID = "";
/**
 * Generates a new FID using random values from Web Crypto API.
 * Returns an empty string if FID generation fails for any reason.
 */ function $5379e25dedbacb82$var$generateFid() {
    try {
        // A valid FID has exactly 22 base64 characters, which is 132 bits, or 16.5
        // bytes. our implementation generates a 17 byte array instead.
        var fidByteArray = new Uint8Array(17);
        var crypto_1 = self.crypto || self.msCrypto;
        crypto_1.getRandomValues(fidByteArray);
        // Replace the first 4 random bits with the constant FID header of 0b0111.
        fidByteArray[0] = 112 + fidByteArray[0] % 16;
        var fid = $5379e25dedbacb82$var$encode(fidByteArray);
        return $5379e25dedbacb82$var$VALID_FID_PATTERN.test(fid) ? fid : $5379e25dedbacb82$var$INVALID_FID;
    } catch (_a) {
        // FID generation errored
        return $5379e25dedbacb82$var$INVALID_FID;
    }
}
/** Converts a FID Uint8Array to a base64 string representation. */ function $5379e25dedbacb82$var$encode(fidByteArray) {
    var b64String = $5379e25dedbacb82$var$bufferToBase64UrlSafe(fidByteArray);
    // Remove the 23rd character that was added because of the extra 4 bits at the
    // end of our 17 byte array, and the '=' padding.
    return b64String.substr(0, 22);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Returns a string key that can be used to identify the app. */ function $5379e25dedbacb82$var$getKey(appConfig) {
    return appConfig.appName + "!" + appConfig.appId;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $5379e25dedbacb82$var$fidChangeCallbacks = new Map();
/**
 * Calls the onIdChange callbacks with the new FID value, and broadcasts the
 * change to other tabs.
 */ function $5379e25dedbacb82$var$fidChanged(appConfig, fid) {
    var key = $5379e25dedbacb82$var$getKey(appConfig);
    $5379e25dedbacb82$var$callFidChangeCallbacks(key, fid);
    $5379e25dedbacb82$var$broadcastFidChange(key, fid);
}
function $5379e25dedbacb82$var$addCallback(appConfig, callback) {
    // Open the broadcast channel if it's not already open,
    // to be able to listen to change events from other tabs.
    $5379e25dedbacb82$var$getBroadcastChannel();
    var key = $5379e25dedbacb82$var$getKey(appConfig);
    var callbackSet = $5379e25dedbacb82$var$fidChangeCallbacks.get(key);
    if (!callbackSet) {
        callbackSet = new Set();
        $5379e25dedbacb82$var$fidChangeCallbacks.set(key, callbackSet);
    }
    callbackSet.add(callback);
}
function $5379e25dedbacb82$var$removeCallback(appConfig, callback) {
    var key = $5379e25dedbacb82$var$getKey(appConfig);
    var callbackSet = $5379e25dedbacb82$var$fidChangeCallbacks.get(key);
    if (!callbackSet) return;
    callbackSet.delete(callback);
    if (callbackSet.size === 0) $5379e25dedbacb82$var$fidChangeCallbacks.delete(key);
    // Close broadcast channel if there are no more callbacks.
    $5379e25dedbacb82$var$closeBroadcastChannel();
}
function $5379e25dedbacb82$var$callFidChangeCallbacks(key, fid) {
    var e_1, _a;
    var callbacks = $5379e25dedbacb82$var$fidChangeCallbacks.get(key);
    if (!callbacks) return;
    try {
        for(var callbacks_1 = (0, $4e72214060a8a819$export$19a8beecd37a4c45)(callbacks), callbacks_1_1 = callbacks_1.next(); !callbacks_1_1.done; callbacks_1_1 = callbacks_1.next()){
            var callback = callbacks_1_1.value;
            callback(fid);
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (callbacks_1_1 && !callbacks_1_1.done && (_a = callbacks_1.return)) _a.call(callbacks_1);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
}
function $5379e25dedbacb82$var$broadcastFidChange(key, fid) {
    var channel = $5379e25dedbacb82$var$getBroadcastChannel();
    if (channel) channel.postMessage({
        key: key,
        fid: fid
    });
    $5379e25dedbacb82$var$closeBroadcastChannel();
}
var $5379e25dedbacb82$var$broadcastChannel = null;
/** Opens and returns a BroadcastChannel if it is supported by the browser. */ function $5379e25dedbacb82$var$getBroadcastChannel() {
    if (!$5379e25dedbacb82$var$broadcastChannel && "BroadcastChannel" in self) {
        $5379e25dedbacb82$var$broadcastChannel = new BroadcastChannel("[Firebase] FID Change");
        $5379e25dedbacb82$var$broadcastChannel.onmessage = function(e) {
            $5379e25dedbacb82$var$callFidChangeCallbacks(e.data.key, e.data.fid);
        };
    }
    return $5379e25dedbacb82$var$broadcastChannel;
}
function $5379e25dedbacb82$var$closeBroadcastChannel() {
    if ($5379e25dedbacb82$var$fidChangeCallbacks.size === 0 && $5379e25dedbacb82$var$broadcastChannel) {
        $5379e25dedbacb82$var$broadcastChannel.close();
        $5379e25dedbacb82$var$broadcastChannel = null;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $5379e25dedbacb82$var$DATABASE_NAME = "firebase-installations-database";
var $5379e25dedbacb82$var$DATABASE_VERSION = 1;
var $5379e25dedbacb82$var$OBJECT_STORE_NAME = "firebase-installations-store";
var $5379e25dedbacb82$var$dbPromise = null;
function $5379e25dedbacb82$var$getDbPromise() {
    if (!$5379e25dedbacb82$var$dbPromise) $5379e25dedbacb82$var$dbPromise = (0, $51f7971b764ad640$exports.openDb)($5379e25dedbacb82$var$DATABASE_NAME, $5379e25dedbacb82$var$DATABASE_VERSION, function(upgradeDB) {
        // We don't use 'break' in this switch statement, the fall-through
        // behavior is what we want, because if there are multiple versions between
        // the old version and the current version, we want ALL the migrations
        // that correspond to those versions to run, not only the last one.
        // eslint-disable-next-line default-case
        switch(upgradeDB.oldVersion){
            case 0:
                upgradeDB.createObjectStore($5379e25dedbacb82$var$OBJECT_STORE_NAME);
        }
    });
    return $5379e25dedbacb82$var$dbPromise;
}
/** Assigns or overwrites the record for the given key with the given value. */ function $5379e25dedbacb82$var$set(appConfig, value) {
    return (0, $4e72214060a8a819$export$1050f835b63b671e)(this, void 0, void 0, function() {
        var key, db, tx, objectStore, oldValue;
        return (0, $4e72214060a8a819$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    key = $5379e25dedbacb82$var$getKey(appConfig);
                    return [
                        4 /*yield*/ ,
                        $5379e25dedbacb82$var$getDbPromise()
                    ];
                case 1:
                    db = _a.sent();
                    tx = db.transaction($5379e25dedbacb82$var$OBJECT_STORE_NAME, "readwrite");
                    objectStore = tx.objectStore($5379e25dedbacb82$var$OBJECT_STORE_NAME);
                    return [
                        4 /*yield*/ ,
                        objectStore.get(key)
                    ];
                case 2:
                    oldValue = _a.sent();
                    return [
                        4 /*yield*/ ,
                        objectStore.put(value, key)
                    ];
                case 3:
                    _a.sent();
                    return [
                        4 /*yield*/ ,
                        tx.complete
                    ];
                case 4:
                    _a.sent();
                    if (!oldValue || oldValue.fid !== value.fid) $5379e25dedbacb82$var$fidChanged(appConfig, value.fid);
                    return [
                        2 /*return*/ ,
                        value
                    ];
            }
        });
    });
}
/** Removes record(s) from the objectStore that match the given key. */ function $5379e25dedbacb82$var$remove(appConfig) {
    return (0, $4e72214060a8a819$export$1050f835b63b671e)(this, void 0, void 0, function() {
        var key, db, tx;
        return (0, $4e72214060a8a819$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    key = $5379e25dedbacb82$var$getKey(appConfig);
                    return [
                        4 /*yield*/ ,
                        $5379e25dedbacb82$var$getDbPromise()
                    ];
                case 1:
                    db = _a.sent();
                    tx = db.transaction($5379e25dedbacb82$var$OBJECT_STORE_NAME, "readwrite");
                    return [
                        4 /*yield*/ ,
                        tx.objectStore($5379e25dedbacb82$var$OBJECT_STORE_NAME).delete(key)
                    ];
                case 2:
                    _a.sent();
                    return [
                        4 /*yield*/ ,
                        tx.complete
                    ];
                case 3:
                    _a.sent();
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
/**
 * Atomically updates a record with the result of updateFn, which gets
 * called with the current value. If newValue is undefined, the record is
 * deleted instead.
 * @return Updated value
 */ function $5379e25dedbacb82$var$update(appConfig, updateFn) {
    return (0, $4e72214060a8a819$export$1050f835b63b671e)(this, void 0, void 0, function() {
        var key, db, tx, store, oldValue, newValue;
        return (0, $4e72214060a8a819$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    key = $5379e25dedbacb82$var$getKey(appConfig);
                    return [
                        4 /*yield*/ ,
                        $5379e25dedbacb82$var$getDbPromise()
                    ];
                case 1:
                    db = _a.sent();
                    tx = db.transaction($5379e25dedbacb82$var$OBJECT_STORE_NAME, "readwrite");
                    store = tx.objectStore($5379e25dedbacb82$var$OBJECT_STORE_NAME);
                    return [
                        4 /*yield*/ ,
                        store.get(key)
                    ];
                case 2:
                    oldValue = _a.sent();
                    newValue = updateFn(oldValue);
                    if (!(newValue === undefined)) return [
                        3 /*break*/ ,
                        4
                    ];
                    return [
                        4 /*yield*/ ,
                        store.delete(key)
                    ];
                case 3:
                    _a.sent();
                    return [
                        3 /*break*/ ,
                        6
                    ];
                case 4:
                    return [
                        4 /*yield*/ ,
                        store.put(newValue, key)
                    ];
                case 5:
                    _a.sent();
                    _a.label = 6;
                case 6:
                    return [
                        4 /*yield*/ ,
                        tx.complete
                    ];
                case 7:
                    _a.sent();
                    if (newValue && (!oldValue || oldValue.fid !== newValue.fid)) $5379e25dedbacb82$var$fidChanged(appConfig, newValue.fid);
                    return [
                        2 /*return*/ ,
                        newValue
                    ];
            }
        });
    });
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Updates and returns the InstallationEntry from the database.
 * Also triggers a registration request if it is necessary and possible.
 */ function $5379e25dedbacb82$var$getInstallationEntry(appConfig) {
    return (0, $4e72214060a8a819$export$1050f835b63b671e)(this, void 0, void 0, function() {
        var registrationPromise, installationEntry;
        var _a;
        return (0, $4e72214060a8a819$export$67ebef60e6f28a6)(this, function(_b) {
            switch(_b.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        $5379e25dedbacb82$var$update(appConfig, function(oldEntry) {
                            var installationEntry = $5379e25dedbacb82$var$updateOrCreateInstallationEntry(oldEntry);
                            var entryWithPromise = $5379e25dedbacb82$var$triggerRegistrationIfNecessary(appConfig, installationEntry);
                            registrationPromise = entryWithPromise.registrationPromise;
                            return entryWithPromise.installationEntry;
                        })
                    ];
                case 1:
                    installationEntry = _b.sent();
                    if (!(installationEntry.fid === $5379e25dedbacb82$var$INVALID_FID)) return [
                        3 /*break*/ ,
                        3
                    ];
                    _a = {};
                    return [
                        4 /*yield*/ ,
                        registrationPromise
                    ];
                case 2:
                    // FID generation failed. Waiting for the FID from the server.
                    return [
                        2 /*return*/ ,
                        (_a.installationEntry = _b.sent(), _a)
                    ];
                case 3:
                    return [
                        2 /*return*/ ,
                        {
                            installationEntry: installationEntry,
                            registrationPromise: registrationPromise
                        }
                    ];
            }
        });
    });
}
/**
 * Creates a new Installation Entry if one does not exist.
 * Also clears timed out pending requests.
 */ function $5379e25dedbacb82$var$updateOrCreateInstallationEntry(oldEntry) {
    var entry = oldEntry || {
        fid: $5379e25dedbacb82$var$generateFid(),
        registrationStatus: 0 /* NOT_STARTED */ 
    };
    return $5379e25dedbacb82$var$clearTimedOutRequest(entry);
}
/**
 * If the Firebase Installation is not registered yet, this will trigger the
 * registration and return an InProgressInstallationEntry.
 *
 * If registrationPromise does not exist, the installationEntry is guaranteed
 * to be registered.
 */ function $5379e25dedbacb82$var$triggerRegistrationIfNecessary(appConfig, installationEntry) {
    if (installationEntry.registrationStatus === 0 /* NOT_STARTED */ ) {
        if (!navigator.onLine) {
            // Registration required but app is offline.
            var registrationPromiseWithError = Promise.reject($5379e25dedbacb82$var$ERROR_FACTORY.create("app-offline" /* APP_OFFLINE */ ));
            return {
                installationEntry: installationEntry,
                registrationPromise: registrationPromiseWithError
            };
        }
        // Try registering. Change status to IN_PROGRESS.
        var inProgressEntry = {
            fid: installationEntry.fid,
            registrationStatus: 1 /* IN_PROGRESS */ ,
            registrationTime: Date.now()
        };
        var registrationPromise = $5379e25dedbacb82$var$registerInstallation(appConfig, inProgressEntry);
        return {
            installationEntry: inProgressEntry,
            registrationPromise: registrationPromise
        };
    } else if (installationEntry.registrationStatus === 1 /* IN_PROGRESS */ ) return {
        installationEntry: installationEntry,
        registrationPromise: $5379e25dedbacb82$var$waitUntilFidRegistration(appConfig)
    };
    else return {
        installationEntry: installationEntry
    };
}
/** This will be executed only once for each new Firebase Installation. */ function $5379e25dedbacb82$var$registerInstallation(appConfig, installationEntry) {
    return (0, $4e72214060a8a819$export$1050f835b63b671e)(this, void 0, void 0, function() {
        var registeredInstallationEntry, e_1;
        return (0, $4e72214060a8a819$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    _a.trys.push([
                        0,
                        2,
                        ,
                        7
                    ]);
                    return [
                        4 /*yield*/ ,
                        $5379e25dedbacb82$var$createInstallationRequest(appConfig, installationEntry)
                    ];
                case 1:
                    registeredInstallationEntry = _a.sent();
                    return [
                        2 /*return*/ ,
                        $5379e25dedbacb82$var$set(appConfig, registeredInstallationEntry)
                    ];
                case 2:
                    e_1 = _a.sent();
                    if (!($5379e25dedbacb82$var$isServerError(e_1) && e_1.serverCode === 409)) return [
                        3 /*break*/ ,
                        4
                    ];
                    // Server returned a "FID can not be used" error.
                    // Generate a new ID next time.
                    return [
                        4 /*yield*/ ,
                        $5379e25dedbacb82$var$remove(appConfig)
                    ];
                case 3:
                    // Server returned a "FID can not be used" error.
                    // Generate a new ID next time.
                    _a.sent();
                    return [
                        3 /*break*/ ,
                        6
                    ];
                case 4:
                    // Registration failed. Set FID as not registered.
                    return [
                        4 /*yield*/ ,
                        $5379e25dedbacb82$var$set(appConfig, {
                            fid: installationEntry.fid,
                            registrationStatus: 0 /* NOT_STARTED */ 
                        })
                    ];
                case 5:
                    // Registration failed. Set FID as not registered.
                    _a.sent();
                    _a.label = 6;
                case 6:
                    throw e_1;
                case 7:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
/** Call if FID registration is pending in another request. */ function $5379e25dedbacb82$var$waitUntilFidRegistration(appConfig) {
    return (0, $4e72214060a8a819$export$1050f835b63b671e)(this, void 0, void 0, function() {
        var entry, _a, installationEntry, registrationPromise;
        return (0, $4e72214060a8a819$export$67ebef60e6f28a6)(this, function(_b) {
            switch(_b.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        $5379e25dedbacb82$var$updateInstallationRequest(appConfig)
                    ];
                case 1:
                    entry = _b.sent();
                    _b.label = 2;
                case 2:
                    if (!(entry.registrationStatus === 1 /* IN_PROGRESS */ )) return [
                        3 /*break*/ ,
                        5
                    ];
                    // createInstallation request still in progress.
                    return [
                        4 /*yield*/ ,
                        $5379e25dedbacb82$var$sleep(100)
                    ];
                case 3:
                    // createInstallation request still in progress.
                    _b.sent();
                    return [
                        4 /*yield*/ ,
                        $5379e25dedbacb82$var$updateInstallationRequest(appConfig)
                    ];
                case 4:
                    entry = _b.sent();
                    return [
                        3 /*break*/ ,
                        2
                    ];
                case 5:
                    if (!(entry.registrationStatus === 0 /* NOT_STARTED */ )) return [
                        3 /*break*/ ,
                        7
                    ];
                    return [
                        4 /*yield*/ ,
                        $5379e25dedbacb82$var$getInstallationEntry(appConfig)
                    ];
                case 6:
                    _a = _b.sent(), installationEntry = _a.installationEntry, registrationPromise = _a.registrationPromise;
                    if (registrationPromise) return [
                        2 /*return*/ ,
                        registrationPromise
                    ];
                    else // if there is no registrationPromise, entry is registered.
                    return [
                        2 /*return*/ ,
                        installationEntry
                    ];
                case 7:
                    return [
                        2 /*return*/ ,
                        entry
                    ];
            }
        });
    });
}
/**
 * Called only if there is a CreateInstallation request in progress.
 *
 * Updates the InstallationEntry in the DB based on the status of the
 * CreateInstallation request.
 *
 * Returns the updated InstallationEntry.
 */ function $5379e25dedbacb82$var$updateInstallationRequest(appConfig) {
    return $5379e25dedbacb82$var$update(appConfig, function(oldEntry) {
        if (!oldEntry) throw $5379e25dedbacb82$var$ERROR_FACTORY.create("installation-not-found" /* INSTALLATION_NOT_FOUND */ );
        return $5379e25dedbacb82$var$clearTimedOutRequest(oldEntry);
    });
}
function $5379e25dedbacb82$var$clearTimedOutRequest(entry) {
    if ($5379e25dedbacb82$var$hasInstallationRequestTimedOut(entry)) return {
        fid: entry.fid,
        registrationStatus: 0 /* NOT_STARTED */ 
    };
    return entry;
}
function $5379e25dedbacb82$var$hasInstallationRequestTimedOut(installationEntry) {
    return installationEntry.registrationStatus === 1 /* IN_PROGRESS */  && installationEntry.registrationTime + $5379e25dedbacb82$var$PENDING_TIMEOUT_MS < Date.now();
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $5379e25dedbacb82$var$generateAuthTokenRequest(_a, installationEntry) {
    var appConfig = _a.appConfig, platformLoggerProvider = _a.platformLoggerProvider;
    return (0, $4e72214060a8a819$export$1050f835b63b671e)(this, void 0, void 0, function() {
        var endpoint, headers, platformLogger, body, request, response, responseValue, completedAuthToken;
        return (0, $4e72214060a8a819$export$67ebef60e6f28a6)(this, function(_b) {
            switch(_b.label){
                case 0:
                    endpoint = $5379e25dedbacb82$var$getGenerateAuthTokenEndpoint(appConfig, installationEntry);
                    headers = $5379e25dedbacb82$var$getHeadersWithAuth(appConfig, installationEntry);
                    platformLogger = platformLoggerProvider.getImmediate({
                        optional: true
                    });
                    if (platformLogger) headers.append("x-firebase-client", platformLogger.getPlatformInfoString());
                    body = {
                        installation: {
                            sdkVersion: $5379e25dedbacb82$var$PACKAGE_VERSION
                        }
                    };
                    request = {
                        method: "POST",
                        headers: headers,
                        body: JSON.stringify(body)
                    };
                    return [
                        4 /*yield*/ ,
                        $5379e25dedbacb82$var$retryIfServerError(function() {
                            return fetch(endpoint, request);
                        })
                    ];
                case 1:
                    response = _b.sent();
                    if (!response.ok) return [
                        3 /*break*/ ,
                        3
                    ];
                    return [
                        4 /*yield*/ ,
                        response.json()
                    ];
                case 2:
                    responseValue = _b.sent();
                    completedAuthToken = $5379e25dedbacb82$var$extractAuthTokenInfoFromResponse(responseValue);
                    return [
                        2 /*return*/ ,
                        completedAuthToken
                    ];
                case 3:
                    return [
                        4 /*yield*/ ,
                        $5379e25dedbacb82$var$getErrorFromResponse("Generate Auth Token", response)
                    ];
                case 4:
                    throw _b.sent();
            }
        });
    });
}
function $5379e25dedbacb82$var$getGenerateAuthTokenEndpoint(appConfig, _a) {
    var fid = _a.fid;
    return $5379e25dedbacb82$var$getInstallationsEndpoint(appConfig) + "/" + fid + "/authTokens:generate";
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a valid authentication token for the installation. Generates a new
 * token if one doesn't exist, is expired or about to expire.
 *
 * Should only be called if the Firebase Installation is registered.
 */ function $5379e25dedbacb82$var$refreshAuthToken(dependencies, forceRefresh) {
    if (forceRefresh === void 0) forceRefresh = false;
    return (0, $4e72214060a8a819$export$1050f835b63b671e)(this, void 0, void 0, function() {
        var tokenPromise, entry, authToken, _a;
        return (0, $4e72214060a8a819$export$67ebef60e6f28a6)(this, function(_b) {
            switch(_b.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        $5379e25dedbacb82$var$update(dependencies.appConfig, function(oldEntry) {
                            if (!$5379e25dedbacb82$var$isEntryRegistered(oldEntry)) throw $5379e25dedbacb82$var$ERROR_FACTORY.create("not-registered" /* NOT_REGISTERED */ );
                            var oldAuthToken = oldEntry.authToken;
                            if (!forceRefresh && $5379e25dedbacb82$var$isAuthTokenValid(oldAuthToken)) // There is a valid token in the DB.
                            return oldEntry;
                            else if (oldAuthToken.requestStatus === 1 /* IN_PROGRESS */ ) {
                                // There already is a token request in progress.
                                tokenPromise = $5379e25dedbacb82$var$waitUntilAuthTokenRequest(dependencies, forceRefresh);
                                return oldEntry;
                            } else {
                                // No token or token expired.
                                if (!navigator.onLine) throw $5379e25dedbacb82$var$ERROR_FACTORY.create("app-offline" /* APP_OFFLINE */ );
                                var inProgressEntry = $5379e25dedbacb82$var$makeAuthTokenRequestInProgressEntry(oldEntry);
                                tokenPromise = $5379e25dedbacb82$var$fetchAuthTokenFromServer(dependencies, inProgressEntry);
                                return inProgressEntry;
                            }
                        })
                    ];
                case 1:
                    entry = _b.sent();
                    if (!tokenPromise) return [
                        3 /*break*/ ,
                        3
                    ];
                    return [
                        4 /*yield*/ ,
                        tokenPromise
                    ];
                case 2:
                    _a = _b.sent();
                    return [
                        3 /*break*/ ,
                        4
                    ];
                case 3:
                    _a = entry.authToken;
                    _b.label = 4;
                case 4:
                    authToken = _a;
                    return [
                        2 /*return*/ ,
                        authToken
                    ];
            }
        });
    });
}
/**
 * Call only if FID is registered and Auth Token request is in progress.
 *
 * Waits until the current pending request finishes. If the request times out,
 * tries once in this thread as well.
 */ function $5379e25dedbacb82$var$waitUntilAuthTokenRequest(dependencies, forceRefresh) {
    return (0, $4e72214060a8a819$export$1050f835b63b671e)(this, void 0, void 0, function() {
        var entry, authToken;
        return (0, $4e72214060a8a819$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        $5379e25dedbacb82$var$updateAuthTokenRequest(dependencies.appConfig)
                    ];
                case 1:
                    entry = _a.sent();
                    _a.label = 2;
                case 2:
                    if (!(entry.authToken.requestStatus === 1 /* IN_PROGRESS */ )) return [
                        3 /*break*/ ,
                        5
                    ];
                    // generateAuthToken still in progress.
                    return [
                        4 /*yield*/ ,
                        $5379e25dedbacb82$var$sleep(100)
                    ];
                case 3:
                    // generateAuthToken still in progress.
                    _a.sent();
                    return [
                        4 /*yield*/ ,
                        $5379e25dedbacb82$var$updateAuthTokenRequest(dependencies.appConfig)
                    ];
                case 4:
                    entry = _a.sent();
                    return [
                        3 /*break*/ ,
                        2
                    ];
                case 5:
                    authToken = entry.authToken;
                    if (authToken.requestStatus === 0 /* NOT_STARTED */ ) // The request timed out or failed in a different call. Try again.
                    return [
                        2 /*return*/ ,
                        $5379e25dedbacb82$var$refreshAuthToken(dependencies, forceRefresh)
                    ];
                    else return [
                        2 /*return*/ ,
                        authToken
                    ];
            }
        });
    });
}
/**
 * Called only if there is a GenerateAuthToken request in progress.
 *
 * Updates the InstallationEntry in the DB based on the status of the
 * GenerateAuthToken request.
 *
 * Returns the updated InstallationEntry.
 */ function $5379e25dedbacb82$var$updateAuthTokenRequest(appConfig) {
    return $5379e25dedbacb82$var$update(appConfig, function(oldEntry) {
        if (!$5379e25dedbacb82$var$isEntryRegistered(oldEntry)) throw $5379e25dedbacb82$var$ERROR_FACTORY.create("not-registered" /* NOT_REGISTERED */ );
        var oldAuthToken = oldEntry.authToken;
        if ($5379e25dedbacb82$var$hasAuthTokenRequestTimedOut(oldAuthToken)) return (0, $4e72214060a8a819$export$18ce0697a983be9b)((0, $4e72214060a8a819$export$18ce0697a983be9b)({}, oldEntry), {
            authToken: {
                requestStatus: 0 /* NOT_STARTED */ 
            }
        });
        return oldEntry;
    });
}
function $5379e25dedbacb82$var$fetchAuthTokenFromServer(dependencies, installationEntry) {
    return (0, $4e72214060a8a819$export$1050f835b63b671e)(this, void 0, void 0, function() {
        var authToken, updatedInstallationEntry, e_1, updatedInstallationEntry;
        return (0, $4e72214060a8a819$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    _a.trys.push([
                        0,
                        3,
                        ,
                        8
                    ]);
                    return [
                        4 /*yield*/ ,
                        $5379e25dedbacb82$var$generateAuthTokenRequest(dependencies, installationEntry)
                    ];
                case 1:
                    authToken = _a.sent();
                    updatedInstallationEntry = (0, $4e72214060a8a819$export$18ce0697a983be9b)((0, $4e72214060a8a819$export$18ce0697a983be9b)({}, installationEntry), {
                        authToken: authToken
                    });
                    return [
                        4 /*yield*/ ,
                        $5379e25dedbacb82$var$set(dependencies.appConfig, updatedInstallationEntry)
                    ];
                case 2:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        authToken
                    ];
                case 3:
                    e_1 = _a.sent();
                    if (!($5379e25dedbacb82$var$isServerError(e_1) && (e_1.serverCode === 401 || e_1.serverCode === 404))) return [
                        3 /*break*/ ,
                        5
                    ];
                    // Server returned a "FID not found" or a "Invalid authentication" error.
                    // Generate a new ID next time.
                    return [
                        4 /*yield*/ ,
                        $5379e25dedbacb82$var$remove(dependencies.appConfig)
                    ];
                case 4:
                    // Server returned a "FID not found" or a "Invalid authentication" error.
                    // Generate a new ID next time.
                    _a.sent();
                    return [
                        3 /*break*/ ,
                        7
                    ];
                case 5:
                    updatedInstallationEntry = (0, $4e72214060a8a819$export$18ce0697a983be9b)((0, $4e72214060a8a819$export$18ce0697a983be9b)({}, installationEntry), {
                        authToken: {
                            requestStatus: 0 /* NOT_STARTED */ 
                        }
                    });
                    return [
                        4 /*yield*/ ,
                        $5379e25dedbacb82$var$set(dependencies.appConfig, updatedInstallationEntry)
                    ];
                case 6:
                    _a.sent();
                    _a.label = 7;
                case 7:
                    throw e_1;
                case 8:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
function $5379e25dedbacb82$var$isEntryRegistered(installationEntry) {
    return installationEntry !== undefined && installationEntry.registrationStatus === 2 /* COMPLETED */ ;
}
function $5379e25dedbacb82$var$isAuthTokenValid(authToken) {
    return authToken.requestStatus === 2 /* COMPLETED */  && !$5379e25dedbacb82$var$isAuthTokenExpired(authToken);
}
function $5379e25dedbacb82$var$isAuthTokenExpired(authToken) {
    var now = Date.now();
    return now < authToken.creationTime || authToken.creationTime + authToken.expiresIn < now + $5379e25dedbacb82$var$TOKEN_EXPIRATION_BUFFER;
}
/** Returns an updated InstallationEntry with an InProgressAuthToken. */ function $5379e25dedbacb82$var$makeAuthTokenRequestInProgressEntry(oldEntry) {
    var inProgressAuthToken = {
        requestStatus: 1 /* IN_PROGRESS */ ,
        requestTime: Date.now()
    };
    return (0, $4e72214060a8a819$export$18ce0697a983be9b)((0, $4e72214060a8a819$export$18ce0697a983be9b)({}, oldEntry), {
        authToken: inProgressAuthToken
    });
}
function $5379e25dedbacb82$var$hasAuthTokenRequestTimedOut(authToken) {
    return authToken.requestStatus === 1 /* IN_PROGRESS */  && authToken.requestTime + $5379e25dedbacb82$var$PENDING_TIMEOUT_MS < Date.now();
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $5379e25dedbacb82$var$getId(dependencies) {
    return (0, $4e72214060a8a819$export$1050f835b63b671e)(this, void 0, void 0, function() {
        var _a, installationEntry, registrationPromise;
        return (0, $4e72214060a8a819$export$67ebef60e6f28a6)(this, function(_b) {
            switch(_b.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        $5379e25dedbacb82$var$getInstallationEntry(dependencies.appConfig)
                    ];
                case 1:
                    _a = _b.sent(), installationEntry = _a.installationEntry, registrationPromise = _a.registrationPromise;
                    if (registrationPromise) registrationPromise.catch(console.error);
                    else // If the installation is already registered, update the authentication
                    // token if needed.
                    $5379e25dedbacb82$var$refreshAuthToken(dependencies).catch(console.error);
                    return [
                        2 /*return*/ ,
                        installationEntry.fid
                    ];
            }
        });
    });
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $5379e25dedbacb82$var$getToken(dependencies, forceRefresh) {
    if (forceRefresh === void 0) forceRefresh = false;
    return (0, $4e72214060a8a819$export$1050f835b63b671e)(this, void 0, void 0, function() {
        var authToken;
        return (0, $4e72214060a8a819$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        $5379e25dedbacb82$var$completeInstallationRegistration(dependencies.appConfig)
                    ];
                case 1:
                    _a.sent();
                    return [
                        4 /*yield*/ ,
                        $5379e25dedbacb82$var$refreshAuthToken(dependencies, forceRefresh)
                    ];
                case 2:
                    authToken = _a.sent();
                    return [
                        2 /*return*/ ,
                        authToken.token
                    ];
            }
        });
    });
}
function $5379e25dedbacb82$var$completeInstallationRegistration(appConfig) {
    return (0, $4e72214060a8a819$export$1050f835b63b671e)(this, void 0, void 0, function() {
        var registrationPromise;
        return (0, $4e72214060a8a819$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        $5379e25dedbacb82$var$getInstallationEntry(appConfig)
                    ];
                case 1:
                    registrationPromise = _a.sent().registrationPromise;
                    if (!registrationPromise) return [
                        3 /*break*/ ,
                        3
                    ];
                    // A createInstallation request is in progress. Wait until it finishes.
                    return [
                        4 /*yield*/ ,
                        registrationPromise
                    ];
                case 2:
                    // A createInstallation request is in progress. Wait until it finishes.
                    _a.sent();
                    _a.label = 3;
                case 3:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $5379e25dedbacb82$var$deleteInstallationRequest(appConfig, installationEntry) {
    return (0, $4e72214060a8a819$export$1050f835b63b671e)(this, void 0, void 0, function() {
        var endpoint, headers, request, response;
        return (0, $4e72214060a8a819$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    endpoint = $5379e25dedbacb82$var$getDeleteEndpoint(appConfig, installationEntry);
                    headers = $5379e25dedbacb82$var$getHeadersWithAuth(appConfig, installationEntry);
                    request = {
                        method: "DELETE",
                        headers: headers
                    };
                    return [
                        4 /*yield*/ ,
                        $5379e25dedbacb82$var$retryIfServerError(function() {
                            return fetch(endpoint, request);
                        })
                    ];
                case 1:
                    response = _a.sent();
                    if (!!response.ok) return [
                        3 /*break*/ ,
                        3
                    ];
                    return [
                        4 /*yield*/ ,
                        $5379e25dedbacb82$var$getErrorFromResponse("Delete Installation", response)
                    ];
                case 2:
                    throw _a.sent();
                case 3:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
function $5379e25dedbacb82$var$getDeleteEndpoint(appConfig, _a) {
    var fid = _a.fid;
    return $5379e25dedbacb82$var$getInstallationsEndpoint(appConfig) + "/" + fid;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $5379e25dedbacb82$var$deleteInstallation(dependencies) {
    return (0, $4e72214060a8a819$export$1050f835b63b671e)(this, void 0, void 0, function() {
        var appConfig, entry;
        return (0, $4e72214060a8a819$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    appConfig = dependencies.appConfig;
                    return [
                        4 /*yield*/ ,
                        $5379e25dedbacb82$var$update(appConfig, function(oldEntry) {
                            if (oldEntry && oldEntry.registrationStatus === 0 /* NOT_STARTED */ ) // Delete the unregistered entry without sending a deleteInstallation request.
                            return undefined;
                            return oldEntry;
                        })
                    ];
                case 1:
                    entry = _a.sent();
                    if (!entry) return [
                        3 /*break*/ ,
                        6
                    ];
                    if (!(entry.registrationStatus === 1 /* IN_PROGRESS */ )) return [
                        3 /*break*/ ,
                        2
                    ];
                    // Can't delete while trying to register.
                    throw $5379e25dedbacb82$var$ERROR_FACTORY.create("delete-pending-registration" /* DELETE_PENDING_REGISTRATION */ );
                case 2:
                    if (!(entry.registrationStatus === 2 /* COMPLETED */ )) return [
                        3 /*break*/ ,
                        6
                    ];
                    if (!!navigator.onLine) return [
                        3 /*break*/ ,
                        3
                    ];
                    throw $5379e25dedbacb82$var$ERROR_FACTORY.create("app-offline" /* APP_OFFLINE */ );
                case 3:
                    return [
                        4 /*yield*/ ,
                        $5379e25dedbacb82$var$deleteInstallationRequest(appConfig, entry)
                    ];
                case 4:
                    _a.sent();
                    return [
                        4 /*yield*/ ,
                        $5379e25dedbacb82$var$remove(appConfig)
                    ];
                case 5:
                    _a.sent();
                    _a.label = 6;
                case 6:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Sets a new callback that will get called when Installation ID changes.
 * Returns an unsubscribe function that will remove the callback when called.
 */ function $5379e25dedbacb82$var$onIdChange(_a, callback) {
    var appConfig = _a.appConfig;
    $5379e25dedbacb82$var$addCallback(appConfig, callback);
    return function() {
        $5379e25dedbacb82$var$removeCallback(appConfig, callback);
    };
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $5379e25dedbacb82$var$extractAppConfig(app) {
    var e_1, _a;
    if (!app || !app.options) throw $5379e25dedbacb82$var$getMissingValueError("App Configuration");
    if (!app.name) throw $5379e25dedbacb82$var$getMissingValueError("App Name");
    // Required app config keys
    var configKeys = [
        "projectId",
        "apiKey",
        "appId"
    ];
    try {
        for(var configKeys_1 = (0, $4e72214060a8a819$export$19a8beecd37a4c45)(configKeys), configKeys_1_1 = configKeys_1.next(); !configKeys_1_1.done; configKeys_1_1 = configKeys_1.next()){
            var keyName = configKeys_1_1.value;
            if (!app.options[keyName]) throw $5379e25dedbacb82$var$getMissingValueError(keyName);
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (configKeys_1_1 && !configKeys_1_1.done && (_a = configKeys_1.return)) _a.call(configKeys_1);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return {
        appName: app.name,
        projectId: app.options.projectId,
        apiKey: app.options.apiKey,
        appId: app.options.appId
    };
}
function $5379e25dedbacb82$var$getMissingValueError(valueName) {
    return $5379e25dedbacb82$var$ERROR_FACTORY.create("missing-app-config-values" /* MISSING_APP_CONFIG_VALUES */ , {
        valueName: valueName
    });
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $5379e25dedbacb82$export$6e695021ec3e22d4(instance) {
    var installationsName = "installations";
    instance.INTERNAL.registerComponent(new (0, $gLWqF.Component)(installationsName, function(container) {
        var app = container.getProvider("app").getImmediate();
        // Throws if app isn't configured properly.
        var appConfig = $5379e25dedbacb82$var$extractAppConfig(app);
        var platformLoggerProvider = container.getProvider("platform-logger");
        var dependencies = {
            appConfig: appConfig,
            platformLoggerProvider: platformLoggerProvider
        };
        var installations = {
            app: app,
            getId: function() {
                return $5379e25dedbacb82$var$getId(dependencies);
            },
            getToken: function(forceRefresh) {
                return $5379e25dedbacb82$var$getToken(dependencies, forceRefresh);
            },
            delete: function() {
                return $5379e25dedbacb82$var$deleteInstallation(dependencies);
            },
            onIdChange: function(callback) {
                return $5379e25dedbacb82$var$onIdChange(dependencies, callback);
            }
        };
        return installations;
    }, "PUBLIC" /* PUBLIC */ ));
    instance.registerVersion($5379e25dedbacb82$var$name, $5379e25dedbacb82$var$version);
}
$5379e25dedbacb82$export$6e695021ec3e22d4((0, (/*@__PURE__*/$parcel$interopDefault($31dJ8))));



var $gLWqF = parcelRequire("gLWqF");

var $01sTD = parcelRequire("01sTD");
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $a4f7799f913082c5$var$extendStatics = function(d, b) {
    $a4f7799f913082c5$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $a4f7799f913082c5$var$extendStatics(d, b);
};
function $a4f7799f913082c5$export$a8ba968b8961cb8a(d, b) {
    $a4f7799f913082c5$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $a4f7799f913082c5$export$18ce0697a983be9b = function() {
    $a4f7799f913082c5$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $a4f7799f913082c5$export$18ce0697a983be9b.apply(this, arguments);
};
function $a4f7799f913082c5$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $a4f7799f913082c5$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $a4f7799f913082c5$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $a4f7799f913082c5$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $a4f7799f913082c5$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $a4f7799f913082c5$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $a4f7799f913082c5$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $a4f7799f913082c5$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $a4f7799f913082c5$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $a4f7799f913082c5$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $a4f7799f913082c5$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($a4f7799f913082c5$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $a4f7799f913082c5$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $a4f7799f913082c5$export$10c90e4f7922046c(v) {
    return this instanceof $a4f7799f913082c5$export$10c90e4f7922046c ? (this.v = v, this) : new $a4f7799f913082c5$export$10c90e4f7922046c(v);
}
function $a4f7799f913082c5$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $a4f7799f913082c5$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $a4f7799f913082c5$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $a4f7799f913082c5$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $a4f7799f913082c5$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $a4f7799f913082c5$export$19a8beecd37a4c45 === "function" ? $a4f7799f913082c5$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $a4f7799f913082c5$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $a4f7799f913082c5$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $a4f7799f913082c5$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $a4f7799f913082c5$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $a4f7799f913082c5$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}




var $31dJ8 = parcelRequire("31dJ8");
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $b111d04a6cba8e67$var$_a;
var $b111d04a6cba8e67$var$ERROR_MAP = ($b111d04a6cba8e67$var$_a = {}, $b111d04a6cba8e67$var$_a["missing-app-config-values" /* MISSING_APP_CONFIG_VALUES */ ] = 'Missing App configuration value: "{$valueName}"', $b111d04a6cba8e67$var$_a["only-available-in-window" /* AVAILABLE_IN_WINDOW */ ] = "This method is available in a Window context.", $b111d04a6cba8e67$var$_a["only-available-in-sw" /* AVAILABLE_IN_SW */ ] = "This method is available in a service worker context.", $b111d04a6cba8e67$var$_a["permission-default" /* PERMISSION_DEFAULT */ ] = "The notification permission was not granted and dismissed instead.", $b111d04a6cba8e67$var$_a["permission-blocked" /* PERMISSION_BLOCKED */ ] = "The notification permission was not granted and blocked instead.", $b111d04a6cba8e67$var$_a["unsupported-browser" /* UNSUPPORTED_BROWSER */ ] = "This browser doesn't support the API's required to use the firebase SDK.", $b111d04a6cba8e67$var$_a["failed-service-worker-registration" /* FAILED_DEFAULT_REGISTRATION */ ] = "We are unable to register the default service worker. {$browserErrorMessage}", $b111d04a6cba8e67$var$_a["token-subscribe-failed" /* TOKEN_SUBSCRIBE_FAILED */ ] = "A problem occurred while subscribing the user to FCM: {$errorInfo}", $b111d04a6cba8e67$var$_a["token-subscribe-no-token" /* TOKEN_SUBSCRIBE_NO_TOKEN */ ] = "FCM returned no token when subscribing the user to push.", $b111d04a6cba8e67$var$_a["token-unsubscribe-failed" /* TOKEN_UNSUBSCRIBE_FAILED */ ] = "A problem occurred while unsubscribing the user from FCM: {$errorInfo}", $b111d04a6cba8e67$var$_a["token-update-failed" /* TOKEN_UPDATE_FAILED */ ] = "A problem occurred while updating the user from FCM: {$errorInfo}", $b111d04a6cba8e67$var$_a["token-update-no-token" /* TOKEN_UPDATE_NO_TOKEN */ ] = "FCM returned no token when updating the user to push.", $b111d04a6cba8e67$var$_a["use-sw-after-get-token" /* USE_SW_AFTER_GET_TOKEN */ ] = "The useServiceWorker() method may only be called once and must be called before calling getToken() to ensure your service worker is used.", $b111d04a6cba8e67$var$_a["invalid-sw-registration" /* INVALID_SW_REGISTRATION */ ] = "The input to useServiceWorker() must be a ServiceWorkerRegistration.", $b111d04a6cba8e67$var$_a["invalid-bg-handler" /* INVALID_BG_HANDLER */ ] = "The input to setBackgroundMessageHandler() must be a function.", $b111d04a6cba8e67$var$_a["invalid-vapid-key" /* INVALID_VAPID_KEY */ ] = "The public VAPID key must be a string.", $b111d04a6cba8e67$var$_a["use-vapid-key-after-get-token" /* USE_VAPID_KEY_AFTER_GET_TOKEN */ ] = "The usePublicVapidKey() method may only be called once and must be called before calling getToken() to ensure your VAPID key is used.", $b111d04a6cba8e67$var$_a);
var $b111d04a6cba8e67$var$ERROR_FACTORY = new (0, $01sTD.ErrorFactory)("messaging", "Messaging", $b111d04a6cba8e67$var$ERROR_MAP);
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $b111d04a6cba8e67$var$DEFAULT_SW_PATH = "/firebase-messaging-sw.js";
var $b111d04a6cba8e67$var$DEFAULT_SW_SCOPE = "/firebase-cloud-messaging-push-scope";
var $b111d04a6cba8e67$var$DEFAULT_VAPID_KEY = "BDOU99-h67HcA6JeFXHbSNMu7e2yNNu3RzoMj8TM4W88jITfq7ZmPvIM1Iv-4_l2LxQcYwhqby2xGpWwzjfAnG4";
var $b111d04a6cba8e67$var$ENDPOINT = "https://fcmregistrations.googleapis.com/v1";
/** Key of FCM Payload in Notification's data field. */ var $b111d04a6cba8e67$var$FCM_MSG = "FCM_MSG";
var $b111d04a6cba8e67$var$CONSOLE_CAMPAIGN_ID = "google.c.a.c_id";
var $b111d04a6cba8e67$var$CONSOLE_CAMPAIGN_NAME = "google.c.a.c_l";
var $b111d04a6cba8e67$var$CONSOLE_CAMPAIGN_TIME = "google.c.a.ts";
/** Set to '1' if Analytics is enabled for the campaign */ var $b111d04a6cba8e67$var$CONSOLE_CAMPAIGN_ANALYTICS_ENABLED = "google.c.a.e";
var $b111d04a6cba8e67$var$TAG = "FirebaseMessaging: ";
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License"); you may not use this file except
 * in compliance with the License. You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under the License
 * is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express
 * or implied. See the License for the specific language governing permissions and limitations under
 * the License.
 */ var $b111d04a6cba8e67$var$MessageType;
(function(MessageType) {
    MessageType["PUSH_RECEIVED"] = "push-received";
    MessageType["NOTIFICATION_CLICKED"] = "notification-clicked";
})($b111d04a6cba8e67$var$MessageType || ($b111d04a6cba8e67$var$MessageType = {}));
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $b111d04a6cba8e67$var$arrayToBase64(array) {
    var uint8Array = new Uint8Array(array);
    var base64String = btoa(String.fromCharCode.apply(String, (0, $a4f7799f913082c5$export$afc72e2116322959)(uint8Array)));
    return base64String.replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_");
}
function $b111d04a6cba8e67$var$base64ToArray(base64String) {
    var padding = "=".repeat((4 - base64String.length % 4) % 4);
    var base64 = (base64String + padding).replace(/\-/g, "+").replace(/_/g, "/");
    var rawData = atob(base64);
    var outputArray = new Uint8Array(rawData.length);
    for(var i = 0; i < rawData.length; ++i)outputArray[i] = rawData.charCodeAt(i);
    return outputArray;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $b111d04a6cba8e67$var$OLD_DB_NAME = "fcm_token_details_db";
/**
 * The last DB version of 'fcm_token_details_db' was 4. This is one higher, so that the upgrade
 * callback is called for all versions of the old DB.
 */ var $b111d04a6cba8e67$var$OLD_DB_VERSION = 5;
var $b111d04a6cba8e67$var$OLD_OBJECT_STORE_NAME = "fcm_token_object_Store";
function $b111d04a6cba8e67$var$migrateOldDatabase(senderId) {
    return (0, $a4f7799f913082c5$export$1050f835b63b671e)(this, void 0, void 0, function() {
        var databases, dbNames, tokenDetails, db;
        var _this = this;
        return (0, $a4f7799f913082c5$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (!("databases" in indexedDB)) return [
                        3 /*break*/ ,
                        2
                    ];
                    return [
                        4 /*yield*/ ,
                        indexedDB.databases()
                    ];
                case 1:
                    databases = _a.sent();
                    dbNames = databases.map(function(db) {
                        return db.name;
                    });
                    if (!dbNames.includes($b111d04a6cba8e67$var$OLD_DB_NAME)) // old DB didn't exist, no need to open.
                    return [
                        2 /*return*/ ,
                        null
                    ];
                    _a.label = 2;
                case 2:
                    tokenDetails = null;
                    return [
                        4 /*yield*/ ,
                        (0, $51f7971b764ad640$exports.openDb)($b111d04a6cba8e67$var$OLD_DB_NAME, $b111d04a6cba8e67$var$OLD_DB_VERSION, function(db) {
                            return (0, $a4f7799f913082c5$export$1050f835b63b671e)(_this, void 0, void 0, function() {
                                var objectStore, value, oldDetails, oldDetails, oldDetails;
                                var _a;
                                return (0, $a4f7799f913082c5$export$67ebef60e6f28a6)(this, function(_b) {
                                    switch(_b.label){
                                        case 0:
                                            if (db.oldVersion < 2) // Database too old, skip migration.
                                            return [
                                                2 /*return*/ 
                                            ];
                                            if (!db.objectStoreNames.contains($b111d04a6cba8e67$var$OLD_OBJECT_STORE_NAME)) // Database did not exist. Nothing to do.
                                            return [
                                                2 /*return*/ 
                                            ];
                                            objectStore = db.transaction.objectStore($b111d04a6cba8e67$var$OLD_OBJECT_STORE_NAME);
                                            return [
                                                4 /*yield*/ ,
                                                objectStore.index("fcmSenderId").get(senderId)
                                            ];
                                        case 1:
                                            value = _b.sent();
                                            return [
                                                4 /*yield*/ ,
                                                objectStore.clear()
                                            ];
                                        case 2:
                                            _b.sent();
                                            if (!value) // No entry in the database, nothing to migrate.
                                            return [
                                                2 /*return*/ 
                                            ];
                                            if (db.oldVersion === 2) {
                                                oldDetails = value;
                                                if (!oldDetails.auth || !oldDetails.p256dh || !oldDetails.endpoint) return [
                                                    2 /*return*/ 
                                                ];
                                                tokenDetails = {
                                                    token: oldDetails.fcmToken,
                                                    createTime: (_a = oldDetails.createTime) !== null && _a !== void 0 ? _a : Date.now(),
                                                    subscriptionOptions: {
                                                        auth: oldDetails.auth,
                                                        p256dh: oldDetails.p256dh,
                                                        endpoint: oldDetails.endpoint,
                                                        swScope: oldDetails.swScope,
                                                        vapidKey: typeof oldDetails.vapidKey === "string" ? oldDetails.vapidKey : $b111d04a6cba8e67$var$arrayToBase64(oldDetails.vapidKey)
                                                    }
                                                };
                                            } else if (db.oldVersion === 3) {
                                                oldDetails = value;
                                                tokenDetails = {
                                                    token: oldDetails.fcmToken,
                                                    createTime: oldDetails.createTime,
                                                    subscriptionOptions: {
                                                        auth: $b111d04a6cba8e67$var$arrayToBase64(oldDetails.auth),
                                                        p256dh: $b111d04a6cba8e67$var$arrayToBase64(oldDetails.p256dh),
                                                        endpoint: oldDetails.endpoint,
                                                        swScope: oldDetails.swScope,
                                                        vapidKey: $b111d04a6cba8e67$var$arrayToBase64(oldDetails.vapidKey)
                                                    }
                                                };
                                            } else if (db.oldVersion === 4) {
                                                oldDetails = value;
                                                tokenDetails = {
                                                    token: oldDetails.fcmToken,
                                                    createTime: oldDetails.createTime,
                                                    subscriptionOptions: {
                                                        auth: $b111d04a6cba8e67$var$arrayToBase64(oldDetails.auth),
                                                        p256dh: $b111d04a6cba8e67$var$arrayToBase64(oldDetails.p256dh),
                                                        endpoint: oldDetails.endpoint,
                                                        swScope: oldDetails.swScope,
                                                        vapidKey: $b111d04a6cba8e67$var$arrayToBase64(oldDetails.vapidKey)
                                                    }
                                                };
                                            }
                                            return [
                                                2 /*return*/ 
                                            ];
                                    }
                                });
                            });
                        })
                    ];
                case 3:
                    db = _a.sent();
                    db.close();
                    // Delete all old databases.
                    return [
                        4 /*yield*/ ,
                        (0, $51f7971b764ad640$exports.deleteDb)($b111d04a6cba8e67$var$OLD_DB_NAME)
                    ];
                case 4:
                    // Delete all old databases.
                    _a.sent();
                    return [
                        4 /*yield*/ ,
                        (0, $51f7971b764ad640$exports.deleteDb)("fcm_vapid_details_db")
                    ];
                case 5:
                    _a.sent();
                    return [
                        4 /*yield*/ ,
                        (0, $51f7971b764ad640$exports.deleteDb)("undefined")
                    ];
                case 6:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        $b111d04a6cba8e67$var$checkTokenDetails(tokenDetails) ? tokenDetails : null
                    ];
            }
        });
    });
}
function $b111d04a6cba8e67$var$checkTokenDetails(tokenDetails) {
    if (!tokenDetails || !tokenDetails.subscriptionOptions) return false;
    var subscriptionOptions = tokenDetails.subscriptionOptions;
    return typeof tokenDetails.createTime === "number" && tokenDetails.createTime > 0 && typeof tokenDetails.token === "string" && tokenDetails.token.length > 0 && typeof subscriptionOptions.auth === "string" && subscriptionOptions.auth.length > 0 && typeof subscriptionOptions.p256dh === "string" && subscriptionOptions.p256dh.length > 0 && typeof subscriptionOptions.endpoint === "string" && subscriptionOptions.endpoint.length > 0 && typeof subscriptionOptions.swScope === "string" && subscriptionOptions.swScope.length > 0 && typeof subscriptionOptions.vapidKey === "string" && subscriptionOptions.vapidKey.length > 0;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Exported for tests.
var $b111d04a6cba8e67$var$DATABASE_NAME = "firebase-messaging-database";
var $b111d04a6cba8e67$var$DATABASE_VERSION = 1;
var $b111d04a6cba8e67$var$OBJECT_STORE_NAME = "firebase-messaging-store";
var $b111d04a6cba8e67$var$dbPromise = null;
function $b111d04a6cba8e67$var$getDbPromise() {
    if (!$b111d04a6cba8e67$var$dbPromise) $b111d04a6cba8e67$var$dbPromise = (0, $51f7971b764ad640$exports.openDb)($b111d04a6cba8e67$var$DATABASE_NAME, $b111d04a6cba8e67$var$DATABASE_VERSION, function(upgradeDb) {
        // We don't use 'break' in this switch statement, the fall-through behavior is what we want,
        // because if there are multiple versions between the old version and the current version, we
        // want ALL the migrations that correspond to those versions to run, not only the last one.
        // eslint-disable-next-line default-case
        switch(upgradeDb.oldVersion){
            case 0:
                upgradeDb.createObjectStore($b111d04a6cba8e67$var$OBJECT_STORE_NAME);
        }
    });
    return $b111d04a6cba8e67$var$dbPromise;
}
/** Gets record(s) from the objectStore that match the given key. */ function $b111d04a6cba8e67$var$dbGet(firebaseDependencies) {
    return (0, $a4f7799f913082c5$export$1050f835b63b671e)(this, void 0, void 0, function() {
        var key, db, tokenDetails, oldTokenDetails;
        return (0, $a4f7799f913082c5$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    key = $b111d04a6cba8e67$var$getKey(firebaseDependencies);
                    return [
                        4 /*yield*/ ,
                        $b111d04a6cba8e67$var$getDbPromise()
                    ];
                case 1:
                    db = _a.sent();
                    return [
                        4 /*yield*/ ,
                        db.transaction($b111d04a6cba8e67$var$OBJECT_STORE_NAME).objectStore($b111d04a6cba8e67$var$OBJECT_STORE_NAME).get(key)
                    ];
                case 2:
                    tokenDetails = _a.sent();
                    if (!tokenDetails) return [
                        3 /*break*/ ,
                        3
                    ];
                    return [
                        2 /*return*/ ,
                        tokenDetails
                    ];
                case 3:
                    return [
                        4 /*yield*/ ,
                        $b111d04a6cba8e67$var$migrateOldDatabase(firebaseDependencies.appConfig.senderId)
                    ];
                case 4:
                    oldTokenDetails = _a.sent();
                    if (!oldTokenDetails) return [
                        3 /*break*/ ,
                        6
                    ];
                    return [
                        4 /*yield*/ ,
                        $b111d04a6cba8e67$var$dbSet(firebaseDependencies, oldTokenDetails)
                    ];
                case 5:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        oldTokenDetails
                    ];
                case 6:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
/** Assigns or overwrites the record for the given key with the given value. */ function $b111d04a6cba8e67$var$dbSet(firebaseDependencies, tokenDetails) {
    return (0, $a4f7799f913082c5$export$1050f835b63b671e)(this, void 0, void 0, function() {
        var key, db, tx;
        return (0, $a4f7799f913082c5$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    key = $b111d04a6cba8e67$var$getKey(firebaseDependencies);
                    return [
                        4 /*yield*/ ,
                        $b111d04a6cba8e67$var$getDbPromise()
                    ];
                case 1:
                    db = _a.sent();
                    tx = db.transaction($b111d04a6cba8e67$var$OBJECT_STORE_NAME, "readwrite");
                    return [
                        4 /*yield*/ ,
                        tx.objectStore($b111d04a6cba8e67$var$OBJECT_STORE_NAME).put(tokenDetails, key)
                    ];
                case 2:
                    _a.sent();
                    return [
                        4 /*yield*/ ,
                        tx.complete
                    ];
                case 3:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        tokenDetails
                    ];
            }
        });
    });
}
/** Removes record(s) from the objectStore that match the given key. */ function $b111d04a6cba8e67$var$dbRemove(firebaseDependencies) {
    return (0, $a4f7799f913082c5$export$1050f835b63b671e)(this, void 0, void 0, function() {
        var key, db, tx;
        return (0, $a4f7799f913082c5$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    key = $b111d04a6cba8e67$var$getKey(firebaseDependencies);
                    return [
                        4 /*yield*/ ,
                        $b111d04a6cba8e67$var$getDbPromise()
                    ];
                case 1:
                    db = _a.sent();
                    tx = db.transaction($b111d04a6cba8e67$var$OBJECT_STORE_NAME, "readwrite");
                    return [
                        4 /*yield*/ ,
                        tx.objectStore($b111d04a6cba8e67$var$OBJECT_STORE_NAME).delete(key)
                    ];
                case 2:
                    _a.sent();
                    return [
                        4 /*yield*/ ,
                        tx.complete
                    ];
                case 3:
                    _a.sent();
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
function $b111d04a6cba8e67$var$getKey(_a) {
    var appConfig = _a.appConfig;
    return appConfig.appId;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $b111d04a6cba8e67$var$requestGetToken(firebaseDependencies, subscriptionOptions) {
    return (0, $a4f7799f913082c5$export$1050f835b63b671e)(this, void 0, void 0, function() {
        var headers, body, subscribeOptions, responseData, response, err_1, message;
        return (0, $a4f7799f913082c5$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        $b111d04a6cba8e67$var$getHeaders(firebaseDependencies)
                    ];
                case 1:
                    headers = _a.sent();
                    body = $b111d04a6cba8e67$var$getBody(subscriptionOptions);
                    subscribeOptions = {
                        method: "POST",
                        headers: headers,
                        body: JSON.stringify(body)
                    };
                    _a.label = 2;
                case 2:
                    _a.trys.push([
                        2,
                        5,
                        ,
                        6
                    ]);
                    return [
                        4 /*yield*/ ,
                        fetch($b111d04a6cba8e67$var$getEndpoint(firebaseDependencies.appConfig), subscribeOptions)
                    ];
                case 3:
                    response = _a.sent();
                    return [
                        4 /*yield*/ ,
                        response.json()
                    ];
                case 4:
                    responseData = _a.sent();
                    return [
                        3 /*break*/ ,
                        6
                    ];
                case 5:
                    err_1 = _a.sent();
                    throw $b111d04a6cba8e67$var$ERROR_FACTORY.create("token-subscribe-failed" /* TOKEN_SUBSCRIBE_FAILED */ , {
                        errorInfo: err_1
                    });
                case 6:
                    if (responseData.error) {
                        message = responseData.error.message;
                        throw $b111d04a6cba8e67$var$ERROR_FACTORY.create("token-subscribe-failed" /* TOKEN_SUBSCRIBE_FAILED */ , {
                            errorInfo: message
                        });
                    }
                    if (!responseData.token) throw $b111d04a6cba8e67$var$ERROR_FACTORY.create("token-subscribe-no-token" /* TOKEN_SUBSCRIBE_NO_TOKEN */ );
                    return [
                        2 /*return*/ ,
                        responseData.token
                    ];
            }
        });
    });
}
function $b111d04a6cba8e67$var$requestUpdateToken(firebaseDependencies, tokenDetails) {
    return (0, $a4f7799f913082c5$export$1050f835b63b671e)(this, void 0, void 0, function() {
        var headers, body, updateOptions, responseData, response, err_2, message;
        return (0, $a4f7799f913082c5$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        $b111d04a6cba8e67$var$getHeaders(firebaseDependencies)
                    ];
                case 1:
                    headers = _a.sent();
                    body = $b111d04a6cba8e67$var$getBody(tokenDetails.subscriptionOptions);
                    updateOptions = {
                        method: "PATCH",
                        headers: headers,
                        body: JSON.stringify(body)
                    };
                    _a.label = 2;
                case 2:
                    _a.trys.push([
                        2,
                        5,
                        ,
                        6
                    ]);
                    return [
                        4 /*yield*/ ,
                        fetch($b111d04a6cba8e67$var$getEndpoint(firebaseDependencies.appConfig) + "/" + tokenDetails.token, updateOptions)
                    ];
                case 3:
                    response = _a.sent();
                    return [
                        4 /*yield*/ ,
                        response.json()
                    ];
                case 4:
                    responseData = _a.sent();
                    return [
                        3 /*break*/ ,
                        6
                    ];
                case 5:
                    err_2 = _a.sent();
                    throw $b111d04a6cba8e67$var$ERROR_FACTORY.create("token-update-failed" /* TOKEN_UPDATE_FAILED */ , {
                        errorInfo: err_2
                    });
                case 6:
                    if (responseData.error) {
                        message = responseData.error.message;
                        throw $b111d04a6cba8e67$var$ERROR_FACTORY.create("token-update-failed" /* TOKEN_UPDATE_FAILED */ , {
                            errorInfo: message
                        });
                    }
                    if (!responseData.token) throw $b111d04a6cba8e67$var$ERROR_FACTORY.create("token-update-no-token" /* TOKEN_UPDATE_NO_TOKEN */ );
                    return [
                        2 /*return*/ ,
                        responseData.token
                    ];
            }
        });
    });
}
function $b111d04a6cba8e67$var$requestDeleteToken(firebaseDependencies, token) {
    return (0, $a4f7799f913082c5$export$1050f835b63b671e)(this, void 0, void 0, function() {
        var headers, unsubscribeOptions, response, responseData, message, err_3;
        return (0, $a4f7799f913082c5$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        $b111d04a6cba8e67$var$getHeaders(firebaseDependencies)
                    ];
                case 1:
                    headers = _a.sent();
                    unsubscribeOptions = {
                        method: "DELETE",
                        headers: headers
                    };
                    _a.label = 2;
                case 2:
                    _a.trys.push([
                        2,
                        5,
                        ,
                        6
                    ]);
                    return [
                        4 /*yield*/ ,
                        fetch($b111d04a6cba8e67$var$getEndpoint(firebaseDependencies.appConfig) + "/" + token, unsubscribeOptions)
                    ];
                case 3:
                    response = _a.sent();
                    return [
                        4 /*yield*/ ,
                        response.json()
                    ];
                case 4:
                    responseData = _a.sent();
                    if (responseData.error) {
                        message = responseData.error.message;
                        throw $b111d04a6cba8e67$var$ERROR_FACTORY.create("token-unsubscribe-failed" /* TOKEN_UNSUBSCRIBE_FAILED */ , {
                            errorInfo: message
                        });
                    }
                    return [
                        3 /*break*/ ,
                        6
                    ];
                case 5:
                    err_3 = _a.sent();
                    throw $b111d04a6cba8e67$var$ERROR_FACTORY.create("token-unsubscribe-failed" /* TOKEN_UNSUBSCRIBE_FAILED */ , {
                        errorInfo: err_3
                    });
                case 6:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
function $b111d04a6cba8e67$var$getEndpoint(_a) {
    var projectId = _a.projectId;
    return $b111d04a6cba8e67$var$ENDPOINT + "/projects/" + projectId + "/registrations";
}
function $b111d04a6cba8e67$var$getHeaders(_a) {
    var appConfig = _a.appConfig, installations = _a.installations;
    return (0, $a4f7799f913082c5$export$1050f835b63b671e)(this, void 0, void 0, function() {
        var authToken;
        return (0, $a4f7799f913082c5$export$67ebef60e6f28a6)(this, function(_b) {
            switch(_b.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        installations.getToken()
                    ];
                case 1:
                    authToken = _b.sent();
                    return [
                        2 /*return*/ ,
                        new Headers({
                            "Content-Type": "application/json",
                            Accept: "application/json",
                            "x-goog-api-key": appConfig.apiKey,
                            "x-goog-firebase-installations-auth": "FIS " + authToken
                        })
                    ];
            }
        });
    });
}
function $b111d04a6cba8e67$var$getBody(_a) {
    var p256dh = _a.p256dh, auth = _a.auth, endpoint = _a.endpoint, vapidKey = _a.vapidKey;
    var body = {
        web: {
            endpoint: endpoint,
            auth: auth,
            p256dh: p256dh
        }
    };
    if (vapidKey !== $b111d04a6cba8e67$var$DEFAULT_VAPID_KEY) body.web.applicationPubKey = vapidKey;
    return body;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** UpdateRegistration will be called once every week. */ var $b111d04a6cba8e67$var$TOKEN_EXPIRATION_MS = 604800000; // 7 days
function $b111d04a6cba8e67$var$getToken(firebaseDependencies, swRegistration, vapidKey) {
    return (0, $a4f7799f913082c5$export$1050f835b63b671e)(this, void 0, void 0, function() {
        var pushSubscription, tokenDetails, subscriptionOptions, e_1;
        return (0, $a4f7799f913082c5$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (Notification.permission !== "granted") throw $b111d04a6cba8e67$var$ERROR_FACTORY.create("permission-blocked" /* PERMISSION_BLOCKED */ );
                    return [
                        4 /*yield*/ ,
                        $b111d04a6cba8e67$var$getPushSubscription(swRegistration, vapidKey)
                    ];
                case 1:
                    pushSubscription = _a.sent();
                    return [
                        4 /*yield*/ ,
                        $b111d04a6cba8e67$var$dbGet(firebaseDependencies)
                    ];
                case 2:
                    tokenDetails = _a.sent();
                    subscriptionOptions = {
                        vapidKey: vapidKey,
                        swScope: swRegistration.scope,
                        endpoint: pushSubscription.endpoint,
                        auth: $b111d04a6cba8e67$var$arrayToBase64(pushSubscription.getKey("auth")),
                        p256dh: $b111d04a6cba8e67$var$arrayToBase64(pushSubscription.getKey("p256dh"))
                    };
                    if (!!tokenDetails) return [
                        3 /*break*/ ,
                        3
                    ];
                    // No token, get a new one.
                    return [
                        2 /*return*/ ,
                        $b111d04a6cba8e67$var$getNewToken(firebaseDependencies, subscriptionOptions)
                    ];
                case 3:
                    if (!!$b111d04a6cba8e67$var$isTokenValid(tokenDetails.subscriptionOptions, subscriptionOptions)) return [
                        3 /*break*/ ,
                        8
                    ];
                    _a.label = 4;
                case 4:
                    _a.trys.push([
                        4,
                        6,
                        ,
                        7
                    ]);
                    return [
                        4 /*yield*/ ,
                        $b111d04a6cba8e67$var$requestDeleteToken(firebaseDependencies, tokenDetails.token)
                    ];
                case 5:
                    _a.sent();
                    return [
                        3 /*break*/ ,
                        7
                    ];
                case 6:
                    e_1 = _a.sent();
                    // Suppress errors because of #2364
                    console.warn(e_1);
                    return [
                        3 /*break*/ ,
                        7
                    ];
                case 7:
                    return [
                        2 /*return*/ ,
                        $b111d04a6cba8e67$var$getNewToken(firebaseDependencies, subscriptionOptions)
                    ];
                case 8:
                    if (Date.now() >= tokenDetails.createTime + $b111d04a6cba8e67$var$TOKEN_EXPIRATION_MS) // Weekly token refresh
                    return [
                        2 /*return*/ ,
                        $b111d04a6cba8e67$var$updateToken({
                            token: tokenDetails.token,
                            createTime: Date.now(),
                            subscriptionOptions: subscriptionOptions
                        }, firebaseDependencies, swRegistration)
                    ];
                    else // Valid token, nothing to do.
                    return [
                        2 /*return*/ ,
                        tokenDetails.token
                    ];
                case 9:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
/**
 * This method deletes the token from the database, unsubscribes the token from FCM, and unregisters
 * the push subscription if it exists.
 */ function $b111d04a6cba8e67$var$deleteToken(firebaseDependencies, swRegistration) {
    return (0, $a4f7799f913082c5$export$1050f835b63b671e)(this, void 0, void 0, function() {
        var tokenDetails, pushSubscription;
        return (0, $a4f7799f913082c5$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        $b111d04a6cba8e67$var$dbGet(firebaseDependencies)
                    ];
                case 1:
                    tokenDetails = _a.sent();
                    if (!tokenDetails) return [
                        3 /*break*/ ,
                        4
                    ];
                    return [
                        4 /*yield*/ ,
                        $b111d04a6cba8e67$var$requestDeleteToken(firebaseDependencies, tokenDetails.token)
                    ];
                case 2:
                    _a.sent();
                    return [
                        4 /*yield*/ ,
                        $b111d04a6cba8e67$var$dbRemove(firebaseDependencies)
                    ];
                case 3:
                    _a.sent();
                    _a.label = 4;
                case 4:
                    return [
                        4 /*yield*/ ,
                        swRegistration.pushManager.getSubscription()
                    ];
                case 5:
                    pushSubscription = _a.sent();
                    if (pushSubscription) return [
                        2 /*return*/ ,
                        pushSubscription.unsubscribe()
                    ];
                    // If there's no SW, consider it a success.
                    return [
                        2 /*return*/ ,
                        true
                    ];
            }
        });
    });
}
function $b111d04a6cba8e67$var$updateToken(tokenDetails, firebaseDependencies, swRegistration) {
    return (0, $a4f7799f913082c5$export$1050f835b63b671e)(this, void 0, void 0, function() {
        var updatedToken, updatedTokenDetails, e_2;
        return (0, $a4f7799f913082c5$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    _a.trys.push([
                        0,
                        3,
                        ,
                        5
                    ]);
                    return [
                        4 /*yield*/ ,
                        $b111d04a6cba8e67$var$requestUpdateToken(firebaseDependencies, tokenDetails)
                    ];
                case 1:
                    updatedToken = _a.sent();
                    updatedTokenDetails = (0, $a4f7799f913082c5$export$18ce0697a983be9b)((0, $a4f7799f913082c5$export$18ce0697a983be9b)({}, tokenDetails), {
                        token: updatedToken,
                        createTime: Date.now()
                    });
                    return [
                        4 /*yield*/ ,
                        $b111d04a6cba8e67$var$dbSet(firebaseDependencies, updatedTokenDetails)
                    ];
                case 2:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        updatedToken
                    ];
                case 3:
                    e_2 = _a.sent();
                    return [
                        4 /*yield*/ ,
                        $b111d04a6cba8e67$var$deleteToken(firebaseDependencies, swRegistration)
                    ];
                case 4:
                    _a.sent();
                    throw e_2;
                case 5:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
function $b111d04a6cba8e67$var$getNewToken(firebaseDependencies, subscriptionOptions) {
    return (0, $a4f7799f913082c5$export$1050f835b63b671e)(this, void 0, void 0, function() {
        var token, tokenDetails;
        return (0, $a4f7799f913082c5$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        $b111d04a6cba8e67$var$requestGetToken(firebaseDependencies, subscriptionOptions)
                    ];
                case 1:
                    token = _a.sent();
                    tokenDetails = {
                        token: token,
                        createTime: Date.now(),
                        subscriptionOptions: subscriptionOptions
                    };
                    return [
                        4 /*yield*/ ,
                        $b111d04a6cba8e67$var$dbSet(firebaseDependencies, tokenDetails)
                    ];
                case 2:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        tokenDetails.token
                    ];
            }
        });
    });
}
/**
 * Gets a PushSubscription for the current user.
 */ function $b111d04a6cba8e67$var$getPushSubscription(swRegistration, vapidKey) {
    return (0, $a4f7799f913082c5$export$1050f835b63b671e)(this, void 0, void 0, function() {
        var subscription;
        return (0, $a4f7799f913082c5$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        swRegistration.pushManager.getSubscription()
                    ];
                case 1:
                    subscription = _a.sent();
                    if (subscription) return [
                        2 /*return*/ ,
                        subscription
                    ];
                    return [
                        2 /*return*/ ,
                        swRegistration.pushManager.subscribe({
                            userVisibleOnly: true,
                            // Chrome <= 75 doesn't support base64-encoded VAPID key. For backward compatibility, VAPID key
                            // submitted to pushManager#subscribe must be of type Uint8Array.
                            applicationServerKey: $b111d04a6cba8e67$var$base64ToArray(vapidKey)
                        })
                    ];
            }
        });
    });
}
/**
 * Checks if the saved tokenDetails object matches the configuration provided.
 */ function $b111d04a6cba8e67$var$isTokenValid(dbOptions, currentOptions) {
    var isVapidKeyEqual = currentOptions.vapidKey === dbOptions.vapidKey;
    var isEndpointEqual = currentOptions.endpoint === dbOptions.endpoint;
    var isAuthEqual = currentOptions.auth === dbOptions.auth;
    var isP256dhEqual = currentOptions.p256dh === dbOptions.p256dh;
    return isVapidKeyEqual && isEndpointEqual && isAuthEqual && isP256dhEqual;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $b111d04a6cba8e67$var$externalizePayload(internalPayload) {
    var payload = {
        from: internalPayload.from,
        // eslint-disable-next-line camelcase
        collapseKey: internalPayload.collapse_key
    };
    $b111d04a6cba8e67$var$propagateNotificationPayload(payload, internalPayload);
    $b111d04a6cba8e67$var$propagateDataPayload(payload, internalPayload);
    $b111d04a6cba8e67$var$propagateFcmOptions(payload, internalPayload);
    return payload;
}
function $b111d04a6cba8e67$var$propagateNotificationPayload(payload, messagePayloadInternal) {
    if (!messagePayloadInternal.notification) return;
    payload.notification = {};
    var title = messagePayloadInternal.notification.title;
    if (!!title) payload.notification.title = title;
    var body = messagePayloadInternal.notification.body;
    if (!!body) payload.notification.body = body;
    var image = messagePayloadInternal.notification.image;
    if (!!image) payload.notification.image = image;
}
function $b111d04a6cba8e67$var$propagateDataPayload(payload, messagePayloadInternal) {
    if (!messagePayloadInternal.data) return;
    payload.data = messagePayloadInternal.data;
}
function $b111d04a6cba8e67$var$propagateFcmOptions(payload, messagePayloadInternal) {
    if (!messagePayloadInternal.fcmOptions) return;
    payload.fcmOptions = {};
    var link = messagePayloadInternal.fcmOptions.link;
    if (!!link) payload.fcmOptions.link = link;
    // eslint-disable-next-line camelcase
    var analyticsLabel = messagePayloadInternal.fcmOptions.analytics_label;
    if (!!analyticsLabel) payload.fcmOptions.analyticsLabel = analyticsLabel;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $b111d04a6cba8e67$var$isConsoleMessage(data) {
    // This message has a campaign ID, meaning it was sent using the Firebase Console.
    return typeof data === "object" && !!data && $b111d04a6cba8e67$var$CONSOLE_CAMPAIGN_ID in data;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Returns a promise that resolves after given time passes. */ function $b111d04a6cba8e67$var$sleep(ms) {
    return new Promise(function(resolve) {
        setTimeout(resolve, ms);
    });
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $b111d04a6cba8e67$var$SwController = /** @class */ function() {
    function SwController(firebaseDependencies) {
        var _this = this;
        this.firebaseDependencies = firebaseDependencies;
        // A boolean flag to determine wether an app is using onBackgroundMessage or
        // setBackgroundMessageHandler. onBackgroundMessage will receive a MessagePayload regardless of if
        // a notification is displayed. Whereas, setBackgroundMessageHandler will swallow the
        // MessagePayload if a NotificationPayload is included.
        this.isOnBackgroundMessageUsed = null;
        this.vapidKey = null;
        this.bgMessageHandler = null;
        self.addEventListener("push", function(e) {
            e.waitUntil(_this.onPush(e));
        });
        self.addEventListener("pushsubscriptionchange", function(e) {
            e.waitUntil(_this.onSubChange(e));
        });
        self.addEventListener("notificationclick", function(e) {
            e.waitUntil(_this.onNotificationClick(e));
        });
    }
    Object.defineProperty(SwController.prototype, "app", {
        get: function() {
            return this.firebaseDependencies.app;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * @deprecated. Use onBackgroundMessage(nextOrObserver: NextFn<object> | Observer<object>):
     * Unsubscribe instead.
     *
     * Calling setBackgroundMessageHandler will opt in to some specific behaviors.
     *
     * 1.) If a notification doesn't need to be shown due to a window already being visible, then push
     * messages will be sent to the page. 2.) If a notification needs to be shown, and the message
     * contains no notification data this method will be called and the promise it returns will be
     * passed to event.waitUntil. If you do not set this callback then all push messages will let and
     * the developer can handle them in a their own 'push' event callback
     *
     * @param callback The callback to be called when a push message is received and a notification
     * must be shown. The callback will be given the data from the push message.
     */ SwController.prototype.setBackgroundMessageHandler = function(callback) {
        this.isOnBackgroundMessageUsed = false;
        if (!callback || typeof callback !== "function") throw $b111d04a6cba8e67$var$ERROR_FACTORY.create("invalid-bg-handler" /* INVALID_BG_HANDLER */ );
        this.bgMessageHandler = callback;
    };
    SwController.prototype.onBackgroundMessage = function(nextOrObserver) {
        var _this = this;
        this.isOnBackgroundMessageUsed = true;
        this.bgMessageHandler = nextOrObserver;
        return function() {
            _this.bgMessageHandler = null;
        };
    };
    // TODO: Remove getToken from SW Controller. Calling this from an old SW can cause all kinds of
    // trouble.
    SwController.prototype.getToken = function() {
        var _a, _b;
        return (0, $a4f7799f913082c5$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var tokenDetails;
            return (0, $a4f7799f913082c5$export$67ebef60e6f28a6)(this, function(_c) {
                switch(_c.label){
                    case 0:
                        if (!!this.vapidKey) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            $b111d04a6cba8e67$var$dbGet(this.firebaseDependencies)
                        ];
                    case 1:
                        tokenDetails = _c.sent();
                        this.vapidKey = (_b = (_a = tokenDetails === null || tokenDetails === void 0 ? void 0 : tokenDetails.subscriptionOptions) === null || _a === void 0 ? void 0 : _a.vapidKey) !== null && _b !== void 0 ? _b : $b111d04a6cba8e67$var$DEFAULT_VAPID_KEY;
                        _c.label = 2;
                    case 2:
                        return [
                            2 /*return*/ ,
                            $b111d04a6cba8e67$var$getToken(this.firebaseDependencies, self.registration, this.vapidKey)
                        ];
                }
            });
        });
    };
    // TODO: Remove deleteToken from SW Controller. Calling this from an old SW can cause all kinds of
    // trouble.
    SwController.prototype.deleteToken = function() {
        return $b111d04a6cba8e67$var$deleteToken(this.firebaseDependencies, self.registration);
    };
    SwController.prototype.requestPermission = function() {
        throw $b111d04a6cba8e67$var$ERROR_FACTORY.create("only-available-in-window" /* AVAILABLE_IN_WINDOW */ );
    };
    // TODO: Remove this together with getToken from SW Controller.
    SwController.prototype.usePublicVapidKey = function(vapidKey) {
        if (this.vapidKey !== null) throw $b111d04a6cba8e67$var$ERROR_FACTORY.create("use-vapid-key-after-get-token" /* USE_VAPID_KEY_AFTER_GET_TOKEN */ );
        if (typeof vapidKey !== "string" || vapidKey.length === 0) throw $b111d04a6cba8e67$var$ERROR_FACTORY.create("invalid-vapid-key" /* INVALID_VAPID_KEY */ );
        this.vapidKey = vapidKey;
    };
    SwController.prototype.useServiceWorker = function() {
        throw $b111d04a6cba8e67$var$ERROR_FACTORY.create("only-available-in-window" /* AVAILABLE_IN_WINDOW */ );
    };
    SwController.prototype.onMessage = function() {
        throw $b111d04a6cba8e67$var$ERROR_FACTORY.create("only-available-in-window" /* AVAILABLE_IN_WINDOW */ );
    };
    SwController.prototype.onTokenRefresh = function() {
        throw $b111d04a6cba8e67$var$ERROR_FACTORY.create("only-available-in-window" /* AVAILABLE_IN_WINDOW */ );
    };
    /**
     * A handler for push events that shows notifications based on the content of the payload.
     *
     * The payload must be a JSON-encoded Object with a `notification` key. The value of the
     * `notification` property will be used as the NotificationOptions object passed to
     * showNotification. Additionally, the `title` property of the notification object will be used as
     * the title.
     *
     * If there is no notification data in the payload then no notification will be shown.
     */ SwController.prototype.onPush = function(event) {
        return (0, $a4f7799f913082c5$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var internalPayload, clientList, isNotificationShown, payload;
            return (0, $a4f7799f913082c5$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        internalPayload = $b111d04a6cba8e67$var$getMessagePayloadInternal(event);
                        if (!internalPayload) {
                            console.debug($b111d04a6cba8e67$var$TAG + "failed to get parsed MessagePayload from the PushEvent. Skip handling the push.");
                            return [
                                2 /*return*/ 
                            ];
                        }
                        return [
                            4 /*yield*/ ,
                            $b111d04a6cba8e67$var$getClientList()
                        ];
                    case 1:
                        clientList = _a.sent();
                        if ($b111d04a6cba8e67$var$hasVisibleClients(clientList)) return [
                            2 /*return*/ ,
                            $b111d04a6cba8e67$var$sendMessagePayloadInternalToWindows(clientList, internalPayload)
                        ];
                        isNotificationShown = false;
                        if (!!!internalPayload.notification) return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            4 /*yield*/ ,
                            $b111d04a6cba8e67$var$showNotification($b111d04a6cba8e67$var$wrapInternalPayload(internalPayload))
                        ];
                    case 2:
                        _a.sent();
                        isNotificationShown = true;
                        _a.label = 3;
                    case 3:
                        // MessagePayload is only passed to `onBackgroundMessage`. Skip passing MessagePayload for
                        // the legacy `setBackgroundMessageHandler` to preserve the SDK behaviors.
                        if (isNotificationShown === true && this.isOnBackgroundMessageUsed === false) return [
                            2 /*return*/ 
                        ];
                        if (!!this.bgMessageHandler) {
                            payload = $b111d04a6cba8e67$var$externalizePayload(internalPayload);
                            if (typeof this.bgMessageHandler === "function") this.bgMessageHandler(payload);
                            else this.bgMessageHandler.next(payload);
                        }
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    SwController.prototype.onSubChange = function(event) {
        var _a, _b;
        return (0, $a4f7799f913082c5$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var newSubscription, tokenDetails;
            return (0, $a4f7799f913082c5$export$67ebef60e6f28a6)(this, function(_c) {
                switch(_c.label){
                    case 0:
                        newSubscription = event.newSubscription;
                        if (!!newSubscription) return [
                            3 /*break*/ ,
                            2
                        ];
                        // Subscription revoked, delete token
                        return [
                            4 /*yield*/ ,
                            $b111d04a6cba8e67$var$deleteToken(this.firebaseDependencies, self.registration)
                        ];
                    case 1:
                        // Subscription revoked, delete token
                        _c.sent();
                        return [
                            2 /*return*/ 
                        ];
                    case 2:
                        return [
                            4 /*yield*/ ,
                            $b111d04a6cba8e67$var$dbGet(this.firebaseDependencies)
                        ];
                    case 3:
                        tokenDetails = _c.sent();
                        return [
                            4 /*yield*/ ,
                            $b111d04a6cba8e67$var$deleteToken(this.firebaseDependencies, self.registration)
                        ];
                    case 4:
                        _c.sent();
                        return [
                            4 /*yield*/ ,
                            $b111d04a6cba8e67$var$getToken(this.firebaseDependencies, self.registration, (_b = (_a = tokenDetails === null || tokenDetails === void 0 ? void 0 : tokenDetails.subscriptionOptions) === null || _a === void 0 ? void 0 : _a.vapidKey) !== null && _b !== void 0 ? _b : $b111d04a6cba8e67$var$DEFAULT_VAPID_KEY)
                        ];
                    case 5:
                        _c.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    SwController.prototype.onNotificationClick = function(event) {
        var _a, _b;
        return (0, $a4f7799f913082c5$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var internalPayload, link, url, originUrl, client;
            return (0, $a4f7799f913082c5$export$67ebef60e6f28a6)(this, function(_c) {
                switch(_c.label){
                    case 0:
                        internalPayload = (_b = (_a = event.notification) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b[$b111d04a6cba8e67$var$FCM_MSG];
                        if (!internalPayload) return [
                            2 /*return*/ 
                        ];
                        else if (event.action) // User clicked on an action button. This will allow developers to act on action button clicks
                        // by using a custom onNotificationClick listener that they define.
                        return [
                            2 /*return*/ 
                        ];
                        // Prevent other listeners from receiving the event
                        event.stopImmediatePropagation();
                        event.notification.close();
                        link = $b111d04a6cba8e67$var$getLink(internalPayload);
                        if (!link) return [
                            2 /*return*/ 
                        ];
                        url = new URL(link, self.location.href);
                        originUrl = new URL(self.location.origin);
                        if (url.host !== originUrl.host) return [
                            2 /*return*/ 
                        ];
                        return [
                            4 /*yield*/ ,
                            $b111d04a6cba8e67$var$getWindowClient(url)
                        ];
                    case 1:
                        client = _c.sent();
                        if (!!client) return [
                            3 /*break*/ ,
                            4
                        ];
                        return [
                            4 /*yield*/ ,
                            self.clients.openWindow(link)
                        ];
                    case 2:
                        client = _c.sent();
                        // Wait three seconds for the client to initialize and set up the message handler so that it
                        // can receive the message.
                        return [
                            4 /*yield*/ ,
                            $b111d04a6cba8e67$var$sleep(3000)
                        ];
                    case 3:
                        // Wait three seconds for the client to initialize and set up the message handler so that it
                        // can receive the message.
                        _c.sent();
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 4:
                        return [
                            4 /*yield*/ ,
                            client.focus()
                        ];
                    case 5:
                        client = _c.sent();
                        _c.label = 6;
                    case 6:
                        if (!client) // Window Client will not be returned if it's for a third party origin.
                        return [
                            2 /*return*/ 
                        ];
                        internalPayload.messageType = $b111d04a6cba8e67$var$MessageType.NOTIFICATION_CLICKED;
                        internalPayload.isFirebaseMessaging = true;
                        return [
                            2 /*return*/ ,
                            client.postMessage(internalPayload)
                        ];
                }
            });
        });
    };
    return SwController;
}();
function $b111d04a6cba8e67$var$wrapInternalPayload(internalPayload) {
    var _a;
    var wrappedInternalPayload = (0, $a4f7799f913082c5$export$18ce0697a983be9b)({}, internalPayload.notification);
    // Put the message payload under FCM_MSG name so we can identify the notification as being an FCM
    // notification vs a notification from somewhere else (i.e. normal web push or developer generated
    // notification).
    wrappedInternalPayload.data = (_a = {}, _a[$b111d04a6cba8e67$var$FCM_MSG] = internalPayload, _a);
    return wrappedInternalPayload;
}
function $b111d04a6cba8e67$var$getMessagePayloadInternal(_a) {
    var data = _a.data;
    if (!data) return null;
    try {
        return data.json();
    } catch (err) {
        // Not JSON so not an FCM message.
        return null;
    }
}
/**
 * @param url The URL to look for when focusing a client.
 * @return Returns an existing window client or a newly opened WindowClient.
 */ function $b111d04a6cba8e67$var$getWindowClient(url) {
    return (0, $a4f7799f913082c5$export$1050f835b63b671e)(this, void 0, void 0, function() {
        var clientList, clientList_1, clientList_1_1, client, clientUrl;
        var e_1, _a;
        return (0, $a4f7799f913082c5$export$67ebef60e6f28a6)(this, function(_b) {
            switch(_b.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        $b111d04a6cba8e67$var$getClientList()
                    ];
                case 1:
                    clientList = _b.sent();
                    try {
                        for(clientList_1 = (0, $a4f7799f913082c5$export$19a8beecd37a4c45)(clientList), clientList_1_1 = clientList_1.next(); !clientList_1_1.done; clientList_1_1 = clientList_1.next()){
                            client = clientList_1_1.value;
                            clientUrl = new URL(client.url, self.location.href);
                            if (url.host === clientUrl.host) return [
                                2 /*return*/ ,
                                client
                            ];
                        }
                    } catch (e_1_1) {
                        e_1 = {
                            error: e_1_1
                        };
                    } finally{
                        try {
                            if (clientList_1_1 && !clientList_1_1.done && (_a = clientList_1.return)) _a.call(clientList_1);
                        } finally{
                            if (e_1) throw e_1.error;
                        }
                    }
                    return [
                        2 /*return*/ ,
                        null
                    ];
            }
        });
    });
}
/**
 * @returns If there is currently a visible WindowClient, this method will resolve to true,
 * otherwise false.
 */ function $b111d04a6cba8e67$var$hasVisibleClients(clientList) {
    return clientList.some(function(client) {
        return client.visibilityState === "visible" && // Ignore chrome-extension clients as that matches the background pages of extensions, which
        // are always considered visible for some reason.
        !client.url.startsWith("chrome-extension://");
    });
}
function $b111d04a6cba8e67$var$sendMessagePayloadInternalToWindows(clientList, internalPayload) {
    var e_2, _a;
    internalPayload.isFirebaseMessaging = true;
    internalPayload.messageType = $b111d04a6cba8e67$var$MessageType.PUSH_RECEIVED;
    try {
        for(var clientList_2 = (0, $a4f7799f913082c5$export$19a8beecd37a4c45)(clientList), clientList_2_1 = clientList_2.next(); !clientList_2_1.done; clientList_2_1 = clientList_2.next()){
            var client = clientList_2_1.value;
            client.postMessage(internalPayload);
        }
    } catch (e_2_1) {
        e_2 = {
            error: e_2_1
        };
    } finally{
        try {
            if (clientList_2_1 && !clientList_2_1.done && (_a = clientList_2.return)) _a.call(clientList_2);
        } finally{
            if (e_2) throw e_2.error;
        }
    }
}
function $b111d04a6cba8e67$var$getClientList() {
    return self.clients.matchAll({
        type: "window",
        includeUncontrolled: true
    });
}
function $b111d04a6cba8e67$var$showNotification(notificationPayloadInternal) {
    var _a;
    // Note: Firefox does not support the maxActions property.
    // https://developer.mozilla.org/en-US/docs/Web/API/notification/maxActions
    var actions = notificationPayloadInternal.actions;
    var maxActions = Notification.maxActions;
    if (actions && maxActions && actions.length > maxActions) console.warn("This browser only supports " + maxActions + " actions. The remaining actions will not be displayed.");
    return self.registration.showNotification((_a = /* title= */ notificationPayloadInternal.title) !== null && _a !== void 0 ? _a : "", notificationPayloadInternal);
}
function $b111d04a6cba8e67$var$getLink(payload) {
    var _a, _b, _c;
    // eslint-disable-next-line camelcase
    var link = (_b = (_a = payload.fcmOptions) === null || _a === void 0 ? void 0 : _a.link) !== null && _b !== void 0 ? _b : (_c = payload.notification) === null || _c === void 0 ? void 0 : _c.click_action;
    if (link) return link;
    if ($b111d04a6cba8e67$var$isConsoleMessage(payload.data)) // Notification created in the Firebase Console. Redirect to origin.
    return self.location.origin;
    else return null;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $b111d04a6cba8e67$var$WindowController = /** @class */ function() {
    function WindowController(firebaseDependencies) {
        var _this = this;
        this.firebaseDependencies = firebaseDependencies;
        this.vapidKey = null;
        this.onMessageCallback = null;
        navigator.serviceWorker.addEventListener("message", function(e) {
            return _this.messageEventListener(e);
        });
    }
    Object.defineProperty(WindowController.prototype, "app", {
        get: function() {
            return this.firebaseDependencies.app;
        },
        enumerable: false,
        configurable: true
    });
    WindowController.prototype.messageEventListener = function(event) {
        return (0, $a4f7799f913082c5$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var internalPayload, dataPayload;
            return (0, $a4f7799f913082c5$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        internalPayload = event.data;
                        if (!internalPayload.isFirebaseMessaging) return [
                            2 /*return*/ 
                        ];
                        // onMessageCallback is either a function or observer/subscriber.
                        // TODO: in the modularization release, have onMessage handle type MessagePayload as supposed to
                        // the legacy payload where some fields are in snake cases.
                        if (this.onMessageCallback && internalPayload.messageType === $b111d04a6cba8e67$var$MessageType.PUSH_RECEIVED) {
                            if (typeof this.onMessageCallback === "function") this.onMessageCallback($b111d04a6cba8e67$var$stripInternalFields(Object.assign({}, internalPayload)));
                            else this.onMessageCallback.next(Object.assign({}, internalPayload));
                        }
                        dataPayload = internalPayload.data;
                        if (!($b111d04a6cba8e67$var$isConsoleMessage(dataPayload) && dataPayload[$b111d04a6cba8e67$var$CONSOLE_CAMPAIGN_ANALYTICS_ENABLED] === "1")) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this.logEvent(internalPayload.messageType, dataPayload)
                        ];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    WindowController.prototype.getVapidKey = function() {
        return this.vapidKey;
    };
    WindowController.prototype.getSwReg = function() {
        return this.swRegistration;
    };
    WindowController.prototype.getToken = function(options) {
        return (0, $a4f7799f913082c5$export$1050f835b63b671e)(this, void 0, void 0, function() {
            return (0, $a4f7799f913082c5$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!(Notification.permission === "default")) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            Notification.requestPermission()
                        ];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        if (Notification.permission !== "granted") throw $b111d04a6cba8e67$var$ERROR_FACTORY.create("permission-blocked" /* PERMISSION_BLOCKED */ );
                        return [
                            4 /*yield*/ ,
                            this.updateVapidKey(options === null || options === void 0 ? void 0 : options.vapidKey)
                        ];
                    case 3:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.updateSwReg(options === null || options === void 0 ? void 0 : options.serviceWorkerRegistration)
                        ];
                    case 4:
                        _a.sent();
                        return [
                            2 /*return*/ ,
                            $b111d04a6cba8e67$var$getToken(this.firebaseDependencies, this.swRegistration, this.vapidKey)
                        ];
                }
            });
        });
    };
    WindowController.prototype.updateVapidKey = function(vapidKey) {
        return (0, $a4f7799f913082c5$export$1050f835b63b671e)(this, void 0, void 0, function() {
            return (0, $a4f7799f913082c5$export$67ebef60e6f28a6)(this, function(_a) {
                if (!!vapidKey) this.vapidKey = vapidKey;
                else if (!this.vapidKey) this.vapidKey = $b111d04a6cba8e67$var$DEFAULT_VAPID_KEY;
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    WindowController.prototype.updateSwReg = function(swRegistration) {
        return (0, $a4f7799f913082c5$export$1050f835b63b671e)(this, void 0, void 0, function() {
            return (0, $a4f7799f913082c5$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!(!swRegistration && !this.swRegistration)) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this.registerDefaultSw()
                        ];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        if (!swRegistration && !!this.swRegistration) return [
                            2 /*return*/ 
                        ];
                        if (!(swRegistration instanceof ServiceWorkerRegistration)) throw $b111d04a6cba8e67$var$ERROR_FACTORY.create("invalid-sw-registration" /* INVALID_SW_REGISTRATION */ );
                        this.swRegistration = swRegistration;
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    WindowController.prototype.registerDefaultSw = function() {
        return (0, $a4f7799f913082c5$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var _a, e_1;
            return (0, $a4f7799f913082c5$export$67ebef60e6f28a6)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        _b.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        _a = this;
                        return [
                            4 /*yield*/ ,
                            navigator.serviceWorker.register($b111d04a6cba8e67$var$DEFAULT_SW_PATH, {
                                scope: $b111d04a6cba8e67$var$DEFAULT_SW_SCOPE
                            })
                        ];
                    case 1:
                        _a.swRegistration = _b.sent();
                        // The timing when browser updates sw when sw has an update is unreliable by my experiment. It
                        // leads to version conflict when the SDK upgrades to a newer version in the main page, but sw
                        // is stuck with the old version. For example,
                        // https://github.com/firebase/firebase-js-sdk/issues/2590 The following line reliably updates
                        // sw if there was an update.
                        this.swRegistration.update().catch(function() {
                        /* it is non blocking and we don't care if it failed */ });
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        e_1 = _b.sent();
                        throw $b111d04a6cba8e67$var$ERROR_FACTORY.create("failed-service-worker-registration" /* FAILED_DEFAULT_REGISTRATION */ , {
                            browserErrorMessage: e_1.message
                        });
                    case 3:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    WindowController.prototype.deleteToken = function() {
        return (0, $a4f7799f913082c5$export$1050f835b63b671e)(this, void 0, void 0, function() {
            return (0, $a4f7799f913082c5$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!!this.swRegistration) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this.registerDefaultSw()
                        ];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        return [
                            2 /*return*/ ,
                            $b111d04a6cba8e67$var$deleteToken(this.firebaseDependencies, this.swRegistration)
                        ];
                }
            });
        });
    };
    /**
     * Request permission if it is not currently granted.
     *
     * @return Resolves if the permission was granted, rejects otherwise.
     *
     * @deprecated Use Notification.requestPermission() instead.
     * https://developer.mozilla.org/en-US/docs/Web/API/Notification/requestPermission
     */ WindowController.prototype.requestPermission = function() {
        return (0, $a4f7799f913082c5$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var permissionResult;
            return (0, $a4f7799f913082c5$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (Notification.permission === "granted") return [
                            2 /*return*/ 
                        ];
                        return [
                            4 /*yield*/ ,
                            Notification.requestPermission()
                        ];
                    case 1:
                        permissionResult = _a.sent();
                        if (permissionResult === "granted") return [
                            2 /*return*/ 
                        ];
                        else if (permissionResult === "denied") throw $b111d04a6cba8e67$var$ERROR_FACTORY.create("permission-blocked" /* PERMISSION_BLOCKED */ );
                        else throw $b111d04a6cba8e67$var$ERROR_FACTORY.create("permission-default" /* PERMISSION_DEFAULT */ );
                }
            });
        });
    };
    /**
     * @deprecated. Use getToken(options?: {vapidKey?: string; serviceWorkerRegistration?:
     * ServiceWorkerRegistration;}): Promise<string> instead.
     */ WindowController.prototype.usePublicVapidKey = function(vapidKey) {
        if (this.vapidKey !== null) throw $b111d04a6cba8e67$var$ERROR_FACTORY.create("use-vapid-key-after-get-token" /* USE_VAPID_KEY_AFTER_GET_TOKEN */ );
        if (typeof vapidKey !== "string" || vapidKey.length === 0) throw $b111d04a6cba8e67$var$ERROR_FACTORY.create("invalid-vapid-key" /* INVALID_VAPID_KEY */ );
        this.vapidKey = vapidKey;
    };
    /**
     * @deprecated. Use getToken(options?: {vapidKey?: string; serviceWorkerRegistration?:
     * ServiceWorkerRegistration;}): Promise<string> instead.
     */ WindowController.prototype.useServiceWorker = function(swRegistration) {
        if (!(swRegistration instanceof ServiceWorkerRegistration)) throw $b111d04a6cba8e67$var$ERROR_FACTORY.create("invalid-sw-registration" /* INVALID_SW_REGISTRATION */ );
        if (this.swRegistration) throw $b111d04a6cba8e67$var$ERROR_FACTORY.create("use-sw-after-get-token" /* USE_SW_AFTER_GET_TOKEN */ );
        this.swRegistration = swRegistration;
    };
    /**
     * @param nextOrObserver An observer object or a function triggered on message.
     *
     * @return The unsubscribe function for the observer.
     */ WindowController.prototype.onMessage = function(nextOrObserver) {
        var _this = this;
        this.onMessageCallback = nextOrObserver;
        return function() {
            _this.onMessageCallback = null;
        };
    };
    WindowController.prototype.setBackgroundMessageHandler = function() {
        throw $b111d04a6cba8e67$var$ERROR_FACTORY.create("only-available-in-sw" /* AVAILABLE_IN_SW */ );
    };
    WindowController.prototype.onBackgroundMessage = function() {
        throw $b111d04a6cba8e67$var$ERROR_FACTORY.create("only-available-in-sw" /* AVAILABLE_IN_SW */ );
    };
    /**
     * @deprecated No-op. It was initially designed with token rotation requests from server in mind.
     * However, the plan to implement such feature was abandoned.
     */ WindowController.prototype.onTokenRefresh = function() {
        return function() {};
    };
    WindowController.prototype.logEvent = function(messageType, data) {
        return (0, $a4f7799f913082c5$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var eventType, analytics;
            return (0, $a4f7799f913082c5$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        eventType = $b111d04a6cba8e67$var$getEventType(messageType);
                        return [
                            4 /*yield*/ ,
                            this.firebaseDependencies.analyticsProvider.get()
                        ];
                    case 1:
                        analytics = _a.sent();
                        analytics.logEvent(eventType, {
                            /* eslint-disable camelcase */ message_id: data[$b111d04a6cba8e67$var$CONSOLE_CAMPAIGN_ID],
                            message_name: data[$b111d04a6cba8e67$var$CONSOLE_CAMPAIGN_NAME],
                            message_time: data[$b111d04a6cba8e67$var$CONSOLE_CAMPAIGN_TIME],
                            message_device_time: Math.floor(Date.now() / 1000)
                        });
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return WindowController;
}();
function $b111d04a6cba8e67$var$getEventType(messageType) {
    switch(messageType){
        case $b111d04a6cba8e67$var$MessageType.NOTIFICATION_CLICKED:
            return "notification_open";
        case $b111d04a6cba8e67$var$MessageType.PUSH_RECEIVED:
            return "notification_foreground";
        default:
            throw new Error();
    }
}
function $b111d04a6cba8e67$var$stripInternalFields(internalPayload) {
    delete internalPayload.messageType;
    delete internalPayload.isFirebaseMessaging;
    return internalPayload;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $b111d04a6cba8e67$var$extractAppConfig(app) {
    var e_1, _a;
    if (!app || !app.options) throw $b111d04a6cba8e67$var$getMissingValueError("App Configuration Object");
    if (!app.name) throw $b111d04a6cba8e67$var$getMissingValueError("App Name");
    // Required app config keys
    var configKeys = [
        "projectId",
        "apiKey",
        "appId",
        "messagingSenderId"
    ];
    var options = app.options;
    try {
        for(var configKeys_1 = (0, $a4f7799f913082c5$export$19a8beecd37a4c45)(configKeys), configKeys_1_1 = configKeys_1.next(); !configKeys_1_1.done; configKeys_1_1 = configKeys_1.next()){
            var keyName = configKeys_1_1.value;
            if (!options[keyName]) throw $b111d04a6cba8e67$var$getMissingValueError(keyName);
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (configKeys_1_1 && !configKeys_1_1.done && (_a = configKeys_1.return)) _a.call(configKeys_1);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return {
        appName: app.name,
        projectId: options.projectId,
        apiKey: options.apiKey,
        appId: options.appId,
        senderId: options.messagingSenderId
    };
}
function $b111d04a6cba8e67$var$getMissingValueError(valueName) {
    return $b111d04a6cba8e67$var$ERROR_FACTORY.create("missing-app-config-values" /* MISSING_APP_CONFIG_VALUES */ , {
        valueName: valueName
    });
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $b111d04a6cba8e67$var$MESSAGING_NAME = "messaging";
function $b111d04a6cba8e67$var$factoryMethod(container) {
    // Dependencies.
    var app = container.getProvider("app").getImmediate();
    var appConfig = $b111d04a6cba8e67$var$extractAppConfig(app);
    var installations = container.getProvider("installations").getImmediate();
    var analyticsProvider = container.getProvider("analytics-internal");
    var firebaseDependencies = {
        app: app,
        appConfig: appConfig,
        installations: installations,
        analyticsProvider: analyticsProvider
    };
    if (!$b111d04a6cba8e67$var$isSupported()) throw $b111d04a6cba8e67$var$ERROR_FACTORY.create("unsupported-browser" /* UNSUPPORTED_BROWSER */ );
    if (self && "ServiceWorkerGlobalScope" in self) // Running in ServiceWorker context
    return new $b111d04a6cba8e67$var$SwController(firebaseDependencies);
    else // Assume we are in the window context.
    return new $b111d04a6cba8e67$var$WindowController(firebaseDependencies);
}
var $b111d04a6cba8e67$var$NAMESPACE_EXPORTS = {
    isSupported: $b111d04a6cba8e67$var$isSupported
};
(0, (/*@__PURE__*/$parcel$interopDefault($31dJ8))).INTERNAL.registerComponent(new (0, $gLWqF.Component)($b111d04a6cba8e67$var$MESSAGING_NAME, $b111d04a6cba8e67$var$factoryMethod, "PUBLIC" /* PUBLIC */ ).setServiceProps($b111d04a6cba8e67$var$NAMESPACE_EXPORTS));
function $b111d04a6cba8e67$var$isSupported() {
    if (self && "ServiceWorkerGlobalScope" in self) // Running in ServiceWorker context
    return $b111d04a6cba8e67$var$isSWControllerSupported();
    else // Assume we are in the window context.
    return $b111d04a6cba8e67$var$isWindowControllerSupported();
}
/**
 * Checks to see if the required APIs exist.
 */ function $b111d04a6cba8e67$var$isWindowControllerSupported() {
    return "indexedDB" in window && indexedDB !== null && navigator.cookieEnabled && "serviceWorker" in navigator && "PushManager" in window && "Notification" in window && "fetch" in window && ServiceWorkerRegistration.prototype.hasOwnProperty("showNotification") && PushSubscription.prototype.hasOwnProperty("getKey");
}
/**
 * Checks to see if the required APIs exist within SW Context.
 */ function $b111d04a6cba8e67$var$isSWControllerSupported() {
    return "indexedDB" in self && indexedDB !== null && "PushManager" in self && "Notification" in self && ServiceWorkerRegistration.prototype.hasOwnProperty("showNotification") && PushSubscription.prototype.hasOwnProperty("getKey");
}



var $31dJ8 = parcelRequire("31dJ8");
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $e365b0be30642692$var$extendStatics = function(d, b) {
    $e365b0be30642692$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $e365b0be30642692$var$extendStatics(d, b);
};
function $e365b0be30642692$export$a8ba968b8961cb8a(d, b) {
    $e365b0be30642692$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $e365b0be30642692$export$18ce0697a983be9b = function() {
    $e365b0be30642692$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $e365b0be30642692$export$18ce0697a983be9b.apply(this, arguments);
};
function $e365b0be30642692$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $e365b0be30642692$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $e365b0be30642692$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $e365b0be30642692$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $e365b0be30642692$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $e365b0be30642692$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $e365b0be30642692$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $e365b0be30642692$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $e365b0be30642692$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $e365b0be30642692$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $e365b0be30642692$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($e365b0be30642692$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $e365b0be30642692$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $e365b0be30642692$export$10c90e4f7922046c(v) {
    return this instanceof $e365b0be30642692$export$10c90e4f7922046c ? (this.v = v, this) : new $e365b0be30642692$export$10c90e4f7922046c(v);
}
function $e365b0be30642692$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $e365b0be30642692$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $e365b0be30642692$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $e365b0be30642692$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $e365b0be30642692$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $e365b0be30642692$export$19a8beecd37a4c45 === "function" ? $e365b0be30642692$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $e365b0be30642692$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $e365b0be30642692$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $e365b0be30642692$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $e365b0be30642692$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $e365b0be30642692$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}



var $gLWqF = parcelRequire("gLWqF");
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Constants used in the Firebase Storage library.
 */ /**
 * Domain name for firebase storage.
 */ var $63c1f7f3542429ef$var$DEFAULT_HOST = "firebasestorage.googleapis.com";
/**
 * The key in Firebase config json for the storage bucket.
 */ var $63c1f7f3542429ef$var$CONFIG_STORAGE_BUCKET_KEY = "storageBucket";
/**
 * 2 minutes
 *
 * The timeout for all operations except upload.
 */ var $63c1f7f3542429ef$var$DEFAULT_MAX_OPERATION_RETRY_TIME = 120000;
/**
 * 10 minutes
 *
 * The timeout for upload.
 */ var $63c1f7f3542429ef$var$DEFAULT_MAX_UPLOAD_RETRY_TIME = 600000;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $63c1f7f3542429ef$var$FirebaseStorageError = /** @class */ function() {
    function FirebaseStorageError(code, message) {
        this.code_ = $63c1f7f3542429ef$var$prependCode(code);
        this.message_ = "Firebase Storage: " + message;
        this.serverResponse_ = null;
        this.name_ = "FirebaseError";
    }
    FirebaseStorageError.prototype.codeProp = function() {
        return this.code;
    };
    FirebaseStorageError.prototype.codeEquals = function(code) {
        return $63c1f7f3542429ef$var$prependCode(code) === this.codeProp();
    };
    FirebaseStorageError.prototype.serverResponseProp = function() {
        return this.serverResponse_;
    };
    FirebaseStorageError.prototype.setServerResponseProp = function(serverResponse) {
        this.serverResponse_ = serverResponse;
    };
    Object.defineProperty(FirebaseStorageError.prototype, "name", {
        get: function() {
            return this.name_;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FirebaseStorageError.prototype, "code", {
        get: function() {
            return this.code_;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FirebaseStorageError.prototype, "message", {
        get: function() {
            if (this.serverResponse_) return this.message_ + "\n" + this.serverResponse_;
            else return this.message_;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FirebaseStorageError.prototype, "serverResponse", {
        get: function() {
            return this.serverResponse_;
        },
        enumerable: false,
        configurable: true
    });
    return FirebaseStorageError;
}();
var $63c1f7f3542429ef$var$Code = {
    // Shared between all platforms
    UNKNOWN: "unknown",
    OBJECT_NOT_FOUND: "object-not-found",
    BUCKET_NOT_FOUND: "bucket-not-found",
    PROJECT_NOT_FOUND: "project-not-found",
    QUOTA_EXCEEDED: "quota-exceeded",
    UNAUTHENTICATED: "unauthenticated",
    UNAUTHORIZED: "unauthorized",
    RETRY_LIMIT_EXCEEDED: "retry-limit-exceeded",
    INVALID_CHECKSUM: "invalid-checksum",
    CANCELED: "canceled",
    // JS specific
    INVALID_EVENT_NAME: "invalid-event-name",
    INVALID_URL: "invalid-url",
    INVALID_DEFAULT_BUCKET: "invalid-default-bucket",
    NO_DEFAULT_BUCKET: "no-default-bucket",
    CANNOT_SLICE_BLOB: "cannot-slice-blob",
    SERVER_FILE_WRONG_SIZE: "server-file-wrong-size",
    NO_DOWNLOAD_URL: "no-download-url",
    INVALID_ARGUMENT: "invalid-argument",
    INVALID_ARGUMENT_COUNT: "invalid-argument-count",
    APP_DELETED: "app-deleted",
    INVALID_ROOT_OPERATION: "invalid-root-operation",
    INVALID_FORMAT: "invalid-format",
    INTERNAL_ERROR: "internal-error"
};
function $63c1f7f3542429ef$var$prependCode(code) {
    return "storage/" + code;
}
function $63c1f7f3542429ef$var$unknown() {
    var message = "An unknown error occurred, please check the error payload for server response.";
    return new $63c1f7f3542429ef$var$FirebaseStorageError($63c1f7f3542429ef$var$Code.UNKNOWN, message);
}
function $63c1f7f3542429ef$var$objectNotFound(path) {
    return new $63c1f7f3542429ef$var$FirebaseStorageError($63c1f7f3542429ef$var$Code.OBJECT_NOT_FOUND, "Object '" + path + "' does not exist.");
}
function $63c1f7f3542429ef$var$quotaExceeded(bucket) {
    return new $63c1f7f3542429ef$var$FirebaseStorageError($63c1f7f3542429ef$var$Code.QUOTA_EXCEEDED, "Quota for bucket '" + bucket + "' exceeded, please view quota on " + "https://firebase.google.com/pricing/.");
}
function $63c1f7f3542429ef$var$unauthenticated() {
    var message = "User is not authenticated, please authenticate using Firebase Authentication and try again.";
    return new $63c1f7f3542429ef$var$FirebaseStorageError($63c1f7f3542429ef$var$Code.UNAUTHENTICATED, message);
}
function $63c1f7f3542429ef$var$unauthorized(path) {
    return new $63c1f7f3542429ef$var$FirebaseStorageError($63c1f7f3542429ef$var$Code.UNAUTHORIZED, "User does not have permission to access '" + path + "'.");
}
function $63c1f7f3542429ef$var$retryLimitExceeded() {
    return new $63c1f7f3542429ef$var$FirebaseStorageError($63c1f7f3542429ef$var$Code.RETRY_LIMIT_EXCEEDED, "Max retry time for operation exceeded, please try again.");
}
function $63c1f7f3542429ef$var$canceled() {
    return new $63c1f7f3542429ef$var$FirebaseStorageError($63c1f7f3542429ef$var$Code.CANCELED, "User canceled the upload/download.");
}
function $63c1f7f3542429ef$var$invalidUrl(url) {
    return new $63c1f7f3542429ef$var$FirebaseStorageError($63c1f7f3542429ef$var$Code.INVALID_URL, "Invalid URL '" + url + "'.");
}
function $63c1f7f3542429ef$var$invalidDefaultBucket(bucket) {
    return new $63c1f7f3542429ef$var$FirebaseStorageError($63c1f7f3542429ef$var$Code.INVALID_DEFAULT_BUCKET, "Invalid default bucket '" + bucket + "'.");
}
function $63c1f7f3542429ef$var$cannotSliceBlob() {
    return new $63c1f7f3542429ef$var$FirebaseStorageError($63c1f7f3542429ef$var$Code.CANNOT_SLICE_BLOB, "Cannot slice blob for upload. Please retry the upload.");
}
function $63c1f7f3542429ef$var$serverFileWrongSize() {
    return new $63c1f7f3542429ef$var$FirebaseStorageError($63c1f7f3542429ef$var$Code.SERVER_FILE_WRONG_SIZE, "Server recorded incorrect upload file size, please retry the upload.");
}
function $63c1f7f3542429ef$var$noDownloadURL() {
    return new $63c1f7f3542429ef$var$FirebaseStorageError($63c1f7f3542429ef$var$Code.NO_DOWNLOAD_URL, "The given file does not have any download URLs.");
}
function $63c1f7f3542429ef$var$invalidArgument(index, fnName, message) {
    return new $63c1f7f3542429ef$var$FirebaseStorageError($63c1f7f3542429ef$var$Code.INVALID_ARGUMENT, "Invalid argument in `" + fnName + "` at index " + index + ": " + message);
}
function $63c1f7f3542429ef$var$invalidArgumentCount(argMin, argMax, fnName, real) {
    var countPart;
    var plural;
    if (argMin === argMax) {
        countPart = argMin;
        plural = argMin === 1 ? "argument" : "arguments";
    } else {
        countPart = "between " + argMin + " and " + argMax;
        plural = "arguments";
    }
    return new $63c1f7f3542429ef$var$FirebaseStorageError($63c1f7f3542429ef$var$Code.INVALID_ARGUMENT_COUNT, "Invalid argument count in `" + fnName + "`: Expected " + countPart + " " + plural + ", received " + real + ".");
}
function $63c1f7f3542429ef$var$appDeleted() {
    return new $63c1f7f3542429ef$var$FirebaseStorageError($63c1f7f3542429ef$var$Code.APP_DELETED, "The Firebase app was deleted.");
}
/**
 * @param name The name of the operation that was invalid.
 */ function $63c1f7f3542429ef$var$invalidRootOperation(name) {
    return new $63c1f7f3542429ef$var$FirebaseStorageError($63c1f7f3542429ef$var$Code.INVALID_ROOT_OPERATION, "The operation '" + name + "' cannot be performed on a root reference, create a non-root " + "reference using child, such as .child('file.png').");
}
/**
 * @param format The format that was not valid.
 * @param message A message describing the format violation.
 */ function $63c1f7f3542429ef$var$invalidFormat(format, message) {
    return new $63c1f7f3542429ef$var$FirebaseStorageError($63c1f7f3542429ef$var$Code.INVALID_FORMAT, "String does not match format '" + format + "': " + message);
}
/**
 * @param message A message describing the internal error.
 */ function $63c1f7f3542429ef$var$internalError(message) {
    throw new $63c1f7f3542429ef$var$FirebaseStorageError($63c1f7f3542429ef$var$Code.INTERNAL_ERROR, "Internal error: " + message);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $63c1f7f3542429ef$var$StringFormat = {
    RAW: "raw",
    BASE64: "base64",
    BASE64URL: "base64url",
    DATA_URL: "data_url"
};
function $63c1f7f3542429ef$var$formatValidator(stringFormat) {
    switch(stringFormat){
        case $63c1f7f3542429ef$var$StringFormat.RAW:
        case $63c1f7f3542429ef$var$StringFormat.BASE64:
        case $63c1f7f3542429ef$var$StringFormat.BASE64URL:
        case $63c1f7f3542429ef$var$StringFormat.DATA_URL:
            return;
        default:
            throw "Expected one of the event types: [" + $63c1f7f3542429ef$var$StringFormat.RAW + ", " + $63c1f7f3542429ef$var$StringFormat.BASE64 + ", " + $63c1f7f3542429ef$var$StringFormat.BASE64URL + ", " + $63c1f7f3542429ef$var$StringFormat.DATA_URL + "].";
    }
}
/**
 * @struct
 */ var $63c1f7f3542429ef$var$StringData = /** @class */ function() {
    function StringData(data, contentType) {
        this.data = data;
        this.contentType = contentType || null;
    }
    return StringData;
}();
function $63c1f7f3542429ef$var$dataFromString(format, stringData) {
    switch(format){
        case $63c1f7f3542429ef$var$StringFormat.RAW:
            return new $63c1f7f3542429ef$var$StringData($63c1f7f3542429ef$var$utf8Bytes_(stringData));
        case $63c1f7f3542429ef$var$StringFormat.BASE64:
        case $63c1f7f3542429ef$var$StringFormat.BASE64URL:
            return new $63c1f7f3542429ef$var$StringData($63c1f7f3542429ef$var$base64Bytes_(format, stringData));
        case $63c1f7f3542429ef$var$StringFormat.DATA_URL:
            return new $63c1f7f3542429ef$var$StringData($63c1f7f3542429ef$var$dataURLBytes_(stringData), $63c1f7f3542429ef$var$dataURLContentType_(stringData));
    }
    // assert(false);
    throw $63c1f7f3542429ef$var$unknown();
}
function $63c1f7f3542429ef$var$utf8Bytes_(value) {
    var b = [];
    for(var i = 0; i < value.length; i++){
        var c = value.charCodeAt(i);
        if (c <= 127) b.push(c);
        else if (c <= 2047) b.push(192 | c >> 6, 128 | c & 63);
        else {
            if ((c & 64512) === 55296) {
                // The start of a surrogate pair.
                var valid = i < value.length - 1 && (value.charCodeAt(i + 1) & 64512) === 56320;
                if (!valid) // The second surrogate wasn't there.
                b.push(239, 191, 189);
                else {
                    var hi = c;
                    var lo = value.charCodeAt(++i);
                    c = 65536 | (hi & 1023) << 10 | lo & 1023;
                    b.push(240 | c >> 18, 128 | c >> 12 & 63, 128 | c >> 6 & 63, 128 | c & 63);
                }
            } else if ((c & 64512) === 56320) // Invalid low surrogate.
            b.push(239, 191, 189);
            else b.push(224 | c >> 12, 128 | c >> 6 & 63, 128 | c & 63);
        }
    }
    return new Uint8Array(b);
}
function $63c1f7f3542429ef$var$percentEncodedBytes_(value) {
    var decoded;
    try {
        decoded = decodeURIComponent(value);
    } catch (e) {
        throw $63c1f7f3542429ef$var$invalidFormat($63c1f7f3542429ef$var$StringFormat.DATA_URL, "Malformed data URL.");
    }
    return $63c1f7f3542429ef$var$utf8Bytes_(decoded);
}
function $63c1f7f3542429ef$var$base64Bytes_(format, value) {
    switch(format){
        case $63c1f7f3542429ef$var$StringFormat.BASE64:
            var hasMinus = value.indexOf("-") !== -1;
            var hasUnder = value.indexOf("_") !== -1;
            if (hasMinus || hasUnder) {
                var invalidChar = hasMinus ? "-" : "_";
                throw $63c1f7f3542429ef$var$invalidFormat(format, "Invalid character '" + invalidChar + "' found: is it base64url encoded?");
            }
            break;
        case $63c1f7f3542429ef$var$StringFormat.BASE64URL:
            var hasPlus = value.indexOf("+") !== -1;
            var hasSlash = value.indexOf("/") !== -1;
            if (hasPlus || hasSlash) {
                var invalidChar = hasPlus ? "+" : "/";
                throw $63c1f7f3542429ef$var$invalidFormat(format, "Invalid character '" + invalidChar + "' found: is it base64 encoded?");
            }
            value = value.replace(/-/g, "+").replace(/_/g, "/");
            break;
    }
    var bytes;
    try {
        bytes = atob(value);
    } catch (e) {
        throw $63c1f7f3542429ef$var$invalidFormat(format, "Invalid character found");
    }
    var array = new Uint8Array(bytes.length);
    for(var i = 0; i < bytes.length; i++)array[i] = bytes.charCodeAt(i);
    return array;
}
/**
 * @struct
 */ var $63c1f7f3542429ef$var$DataURLParts = /** @class */ function() {
    function DataURLParts(dataURL) {
        this.base64 = false;
        this.contentType = null;
        var matches = dataURL.match(/^data:([^,]+)?,/);
        if (matches === null) throw $63c1f7f3542429ef$var$invalidFormat($63c1f7f3542429ef$var$StringFormat.DATA_URL, "Must be formatted 'data:[<mediatype>][;base64],<data>");
        var middle = matches[1] || null;
        if (middle != null) {
            this.base64 = $63c1f7f3542429ef$var$endsWith(middle, ";base64");
            this.contentType = this.base64 ? middle.substring(0, middle.length - 7) : middle;
        }
        this.rest = dataURL.substring(dataURL.indexOf(",") + 1);
    }
    return DataURLParts;
}();
function $63c1f7f3542429ef$var$dataURLBytes_(dataUrl) {
    var parts = new $63c1f7f3542429ef$var$DataURLParts(dataUrl);
    if (parts.base64) return $63c1f7f3542429ef$var$base64Bytes_($63c1f7f3542429ef$var$StringFormat.BASE64, parts.rest);
    else return $63c1f7f3542429ef$var$percentEncodedBytes_(parts.rest);
}
function $63c1f7f3542429ef$var$dataURLContentType_(dataUrl) {
    var parts = new $63c1f7f3542429ef$var$DataURLParts(dataUrl);
    return parts.contentType;
}
function $63c1f7f3542429ef$var$endsWith(s, end) {
    var longEnough = s.length >= end.length;
    if (!longEnough) return false;
    return s.substring(s.length - end.length) === end;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $63c1f7f3542429ef$var$TaskEvent = {
    /** Triggered whenever the task changes or progress is updated. */ STATE_CHANGED: "state_changed"
};
var $63c1f7f3542429ef$var$InternalTaskState = {
    RUNNING: "running",
    PAUSING: "pausing",
    PAUSED: "paused",
    SUCCESS: "success",
    CANCELING: "canceling",
    CANCELED: "canceled",
    ERROR: "error"
};
var $63c1f7f3542429ef$var$TaskState = {
    /** The task is currently transferring data. */ RUNNING: "running",
    /** The task was paused by the user. */ PAUSED: "paused",
    /** The task completed successfully. */ SUCCESS: "success",
    /** The task was canceled. */ CANCELED: "canceled",
    /** The task failed with an error. */ ERROR: "error"
};
function $63c1f7f3542429ef$var$taskStateFromInternalTaskState(state) {
    switch(state){
        case $63c1f7f3542429ef$var$InternalTaskState.RUNNING:
        case $63c1f7f3542429ef$var$InternalTaskState.PAUSING:
        case $63c1f7f3542429ef$var$InternalTaskState.CANCELING:
            return $63c1f7f3542429ef$var$TaskState.RUNNING;
        case $63c1f7f3542429ef$var$InternalTaskState.PAUSED:
            return $63c1f7f3542429ef$var$TaskState.PAUSED;
        case $63c1f7f3542429ef$var$InternalTaskState.SUCCESS:
            return $63c1f7f3542429ef$var$TaskState.SUCCESS;
        case $63c1f7f3542429ef$var$InternalTaskState.CANCELED:
            return $63c1f7f3542429ef$var$TaskState.CANCELED;
        case $63c1f7f3542429ef$var$InternalTaskState.ERROR:
            return $63c1f7f3542429ef$var$TaskState.ERROR;
        default:
            // TODO(andysoto): assert(false);
            return $63c1f7f3542429ef$var$TaskState.ERROR;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @return False if the object is undefined or null, true otherwise.
 */ function $63c1f7f3542429ef$var$isDef(p) {
    return p != null;
}
function $63c1f7f3542429ef$var$isJustDef(p) {
    return p !== void 0;
}
// eslint-disable-next-line @typescript-eslint/ban-types
function $63c1f7f3542429ef$var$isFunction(p) {
    return typeof p === "function";
}
function $63c1f7f3542429ef$var$isObject(p) {
    return typeof p === "object";
}
function $63c1f7f3542429ef$var$isNonNullObject(p) {
    return $63c1f7f3542429ef$var$isObject(p) && p !== null;
}
function $63c1f7f3542429ef$var$isNonArrayObject(p) {
    return $63c1f7f3542429ef$var$isObject(p) && !Array.isArray(p);
}
function $63c1f7f3542429ef$var$isString(p) {
    return typeof p === "string" || p instanceof String;
}
function $63c1f7f3542429ef$var$isInteger(p) {
    return $63c1f7f3542429ef$var$isNumber(p) && Number.isInteger(p);
}
function $63c1f7f3542429ef$var$isNumber(p) {
    return typeof p === "number" || p instanceof Number;
}
function $63c1f7f3542429ef$var$isNativeBlob(p) {
    return $63c1f7f3542429ef$var$isNativeBlobDefined() && p instanceof Blob;
}
function $63c1f7f3542429ef$var$isNativeBlobDefined() {
    return typeof Blob !== "undefined";
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @enum{number}
 */ var $63c1f7f3542429ef$var$ErrorCode;
(function(ErrorCode) {
    ErrorCode[ErrorCode["NO_ERROR"] = 0] = "NO_ERROR";
    ErrorCode[ErrorCode["NETWORK_ERROR"] = 1] = "NETWORK_ERROR";
    ErrorCode[ErrorCode["ABORT"] = 2] = "ABORT";
})($63c1f7f3542429ef$var$ErrorCode || ($63c1f7f3542429ef$var$ErrorCode = {}));
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * We use this instead of goog.net.XhrIo because goog.net.XhrIo is hyuuuuge and
 * doesn't work in React Native on Android.
 */ var $63c1f7f3542429ef$var$NetworkXhrIo = /** @class */ function() {
    function NetworkXhrIo() {
        var _this = this;
        this.sent_ = false;
        this.xhr_ = new XMLHttpRequest();
        this.errorCode_ = $63c1f7f3542429ef$var$ErrorCode.NO_ERROR;
        this.sendPromise_ = new Promise(function(resolve) {
            _this.xhr_.addEventListener("abort", function() {
                _this.errorCode_ = $63c1f7f3542429ef$var$ErrorCode.ABORT;
                resolve(_this);
            });
            _this.xhr_.addEventListener("error", function() {
                _this.errorCode_ = $63c1f7f3542429ef$var$ErrorCode.NETWORK_ERROR;
                resolve(_this);
            });
            _this.xhr_.addEventListener("load", function() {
                resolve(_this);
            });
        });
    }
    /**
     * @override
     */ NetworkXhrIo.prototype.send = function(url, method, body, headers) {
        if (this.sent_) throw $63c1f7f3542429ef$var$internalError("cannot .send() more than once");
        this.sent_ = true;
        this.xhr_.open(method, url, true);
        if ($63c1f7f3542429ef$var$isDef(headers)) {
            for(var key in headers)if (headers.hasOwnProperty(key)) this.xhr_.setRequestHeader(key, headers[key].toString());
        }
        if ($63c1f7f3542429ef$var$isDef(body)) this.xhr_.send(body);
        else this.xhr_.send();
        return this.sendPromise_;
    };
    /**
     * @override
     */ NetworkXhrIo.prototype.getErrorCode = function() {
        if (!this.sent_) throw $63c1f7f3542429ef$var$internalError("cannot .getErrorCode() before sending");
        return this.errorCode_;
    };
    /**
     * @override
     */ NetworkXhrIo.prototype.getStatus = function() {
        if (!this.sent_) throw $63c1f7f3542429ef$var$internalError("cannot .getStatus() before sending");
        try {
            return this.xhr_.status;
        } catch (e) {
            return -1;
        }
    };
    /**
     * @override
     */ NetworkXhrIo.prototype.getResponseText = function() {
        if (!this.sent_) throw $63c1f7f3542429ef$var$internalError("cannot .getResponseText() before sending");
        return this.xhr_.responseText;
    };
    /**
     * Aborts the request.
     * @override
     */ NetworkXhrIo.prototype.abort = function() {
        this.xhr_.abort();
    };
    /**
     * @override
     */ NetworkXhrIo.prototype.getResponseHeader = function(header) {
        return this.xhr_.getResponseHeader(header);
    };
    /**
     * @override
     */ NetworkXhrIo.prototype.addUploadProgressListener = function(listener) {
        if ($63c1f7f3542429ef$var$isDef(this.xhr_.upload)) this.xhr_.upload.addEventListener("progress", listener);
    };
    /**
     * @override
     */ NetworkXhrIo.prototype.removeUploadProgressListener = function(listener) {
        if ($63c1f7f3542429ef$var$isDef(this.xhr_.upload)) this.xhr_.upload.removeEventListener("progress", listener);
    };
    return NetworkXhrIo;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Factory-like class for creating XhrIo instances.
 */ var $63c1f7f3542429ef$var$XhrIoPool = /** @class */ function() {
    function XhrIoPool() {}
    XhrIoPool.prototype.createXhrIo = function() {
        return new $63c1f7f3542429ef$var$NetworkXhrIo();
    };
    return XhrIoPool;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $63c1f7f3542429ef$var$getBlobBuilder() {
    if (typeof BlobBuilder !== "undefined") return BlobBuilder;
    else if (typeof WebKitBlobBuilder !== "undefined") return WebKitBlobBuilder;
    else return undefined;
}
/**
 * Concatenates one or more values together and converts them to a Blob.
 *
 * @param args The values that will make up the resulting blob.
 * @return The blob.
 */ function $63c1f7f3542429ef$var$getBlob() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var BlobBuilder1 = $63c1f7f3542429ef$var$getBlobBuilder();
    if (BlobBuilder1 !== undefined) {
        var bb = new BlobBuilder1();
        for(var i = 0; i < args.length; i++)bb.append(args[i]);
        return bb.getBlob();
    } else {
        if ($63c1f7f3542429ef$var$isNativeBlobDefined()) return new Blob(args);
        else throw Error("This browser doesn't seem to support creating Blobs");
    }
}
/**
 * Slices the blob. The returned blob contains data from the start byte
 * (inclusive) till the end byte (exclusive). Negative indices cannot be used.
 *
 * @param blob The blob to be sliced.
 * @param start Index of the starting byte.
 * @param end Index of the ending byte.
 * @return The blob slice or null if not supported.
 */ function $63c1f7f3542429ef$var$sliceBlob(blob, start, end) {
    if (blob.webkitSlice) return blob.webkitSlice(start, end);
    else if (blob.mozSlice) return blob.mozSlice(start, end);
    else if (blob.slice) return blob.slice(start, end);
    return null;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @param opt_elideCopy If true, doesn't copy mutable input data
 *     (e.g. Uint8Arrays). Pass true only if you know the objects will not be
 *     modified after this blob's construction.
 */ var $63c1f7f3542429ef$var$FbsBlob = /** @class */ function() {
    function FbsBlob(data, elideCopy) {
        var size = 0;
        var blobType = "";
        if ($63c1f7f3542429ef$var$isNativeBlob(data)) {
            this.data_ = data;
            size = data.size;
            blobType = data.type;
        } else if (data instanceof ArrayBuffer) {
            if (elideCopy) this.data_ = new Uint8Array(data);
            else {
                this.data_ = new Uint8Array(data.byteLength);
                this.data_.set(new Uint8Array(data));
            }
            size = this.data_.length;
        } else if (data instanceof Uint8Array) {
            if (elideCopy) this.data_ = data;
            else {
                this.data_ = new Uint8Array(data.length);
                this.data_.set(data);
            }
            size = data.length;
        }
        this.size_ = size;
        this.type_ = blobType;
    }
    FbsBlob.prototype.size = function() {
        return this.size_;
    };
    FbsBlob.prototype.type = function() {
        return this.type_;
    };
    FbsBlob.prototype.slice = function(startByte, endByte) {
        if ($63c1f7f3542429ef$var$isNativeBlob(this.data_)) {
            var realBlob = this.data_;
            var sliced = $63c1f7f3542429ef$var$sliceBlob(realBlob, startByte, endByte);
            if (sliced === null) return null;
            return new FbsBlob(sliced);
        } else {
            var slice = new Uint8Array(this.data_.buffer, startByte, endByte - startByte);
            return new FbsBlob(slice, true);
        }
    };
    FbsBlob.getBlob = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        if ($63c1f7f3542429ef$var$isNativeBlobDefined()) {
            var blobby = args.map(function(val) {
                if (val instanceof FbsBlob) return val.data_;
                else return val;
            });
            return new FbsBlob($63c1f7f3542429ef$var$getBlob.apply(null, blobby));
        } else {
            var uint8Arrays = args.map(function(val) {
                if ($63c1f7f3542429ef$var$isString(val)) return $63c1f7f3542429ef$var$dataFromString($63c1f7f3542429ef$var$StringFormat.RAW, val).data;
                else // Blobs don't exist, so this has to be a Uint8Array.
                return val.data_;
            });
            var finalLength_1 = 0;
            uint8Arrays.forEach(function(array) {
                finalLength_1 += array.byteLength;
            });
            var merged_1 = new Uint8Array(finalLength_1);
            var index_1 = 0;
            uint8Arrays.forEach(function(array) {
                for(var i = 0; i < array.length; i++)merged_1[index_1++] = array[i];
            });
            return new FbsBlob(merged_1, true);
        }
    };
    FbsBlob.prototype.uploadData = function() {
        return this.data_;
    };
    return FbsBlob;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @struct
 */ var $63c1f7f3542429ef$var$Location = /** @class */ function() {
    function Location(bucket, path) {
        this.bucket = bucket;
        this.path_ = path;
    }
    Object.defineProperty(Location.prototype, "path", {
        get: function() {
            return this.path_;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Location.prototype, "isRoot", {
        get: function() {
            return this.path.length === 0;
        },
        enumerable: false,
        configurable: true
    });
    Location.prototype.fullServerUrl = function() {
        var encode = encodeURIComponent;
        return "/b/" + encode(this.bucket) + "/o/" + encode(this.path);
    };
    Location.prototype.bucketOnlyServerUrl = function() {
        var encode = encodeURIComponent;
        return "/b/" + encode(this.bucket) + "/o";
    };
    Location.makeFromBucketSpec = function(bucketString) {
        var bucketLocation;
        try {
            bucketLocation = Location.makeFromUrl(bucketString);
        } catch (e) {
            // Not valid URL, use as-is. This lets you put bare bucket names in
            // config.
            return new Location(bucketString, "");
        }
        if (bucketLocation.path === "") return bucketLocation;
        else throw $63c1f7f3542429ef$var$invalidDefaultBucket(bucketString);
    };
    Location.makeFromUrl = function(url) {
        var location = null;
        var bucketDomain = "([A-Za-z0-9.\\-_]+)";
        function gsModify(loc) {
            if (loc.path.charAt(loc.path.length - 1) === "/") loc.path_ = loc.path_.slice(0, -1);
        }
        var gsPath = "(/(.*))?$";
        var gsRegex = new RegExp("^gs://" + bucketDomain + gsPath, "i");
        var gsIndices = {
            bucket: 1,
            path: 3
        };
        function httpModify(loc) {
            loc.path_ = decodeURIComponent(loc.path);
        }
        var version = "v[A-Za-z0-9_]+";
        var firebaseStorageHost = $63c1f7f3542429ef$var$DEFAULT_HOST.replace(/[.]/g, "\\.");
        var firebaseStoragePath = "(/([^?#]*).*)?$";
        var firebaseStorageRegExp = new RegExp("^https?://" + firebaseStorageHost + "/" + version + "/b/" + bucketDomain + "/o" + firebaseStoragePath, "i");
        var firebaseStorageIndices = {
            bucket: 1,
            path: 3
        };
        var cloudStorageHost = "(?:storage.googleapis.com|storage.cloud.google.com)";
        var cloudStoragePath = "([^?#]*)";
        var cloudStorageRegExp = new RegExp("^https?://" + cloudStorageHost + "/" + bucketDomain + "/" + cloudStoragePath, "i");
        var cloudStorageIndices = {
            bucket: 1,
            path: 2
        };
        var groups = [
            {
                regex: gsRegex,
                indices: gsIndices,
                postModify: gsModify
            },
            {
                regex: firebaseStorageRegExp,
                indices: firebaseStorageIndices,
                postModify: httpModify
            },
            {
                regex: cloudStorageRegExp,
                indices: cloudStorageIndices,
                postModify: httpModify
            }
        ];
        for(var i = 0; i < groups.length; i++){
            var group = groups[i];
            var captures = group.regex.exec(url);
            if (captures) {
                var bucketValue = captures[group.indices.bucket];
                var pathValue = captures[group.indices.path];
                if (!pathValue) pathValue = "";
                location = new Location(bucketValue, pathValue);
                group.postModify(location);
                break;
            }
        }
        if (location == null) throw $63c1f7f3542429ef$var$invalidUrl(url);
        return location;
    };
    return Location;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns the Object resulting from parsing the given JSON, or null if the
 * given string does not represent a JSON object.
 */ function $63c1f7f3542429ef$var$jsonObjectOrNull(s) {
    var obj;
    try {
        obj = JSON.parse(s);
    } catch (e) {
        return null;
    }
    if ($63c1f7f3542429ef$var$isNonArrayObject(obj)) return obj;
    else return null;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Contains helper methods for manipulating paths.
 */ /**
 * @return Null if the path is already at the root.
 */ function $63c1f7f3542429ef$var$parent(path) {
    if (path.length === 0) return null;
    var index = path.lastIndexOf("/");
    if (index === -1) return "";
    var newPath = path.slice(0, index);
    return newPath;
}
function $63c1f7f3542429ef$var$child(path, childPath) {
    var canonicalChildPath = childPath.split("/").filter(function(component) {
        return component.length > 0;
    }).join("/");
    if (path.length === 0) return canonicalChildPath;
    else return path + "/" + canonicalChildPath;
}
/**
 * Returns the last component of a path.
 * '/foo/bar' -> 'bar'
 * '/foo/bar/baz/' -> 'baz/'
 * '/a' -> 'a'
 */ function $63c1f7f3542429ef$var$lastComponent(path) {
    var index = path.lastIndexOf("/", path.length - 2);
    if (index === -1) return path;
    else return path.slice(index + 1);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $63c1f7f3542429ef$var$makeUrl(urlPart) {
    return "https://" + $63c1f7f3542429ef$var$DEFAULT_HOST + "/v0" + urlPart;
}
function $63c1f7f3542429ef$var$makeQueryString(params) {
    var encode = encodeURIComponent;
    var queryPart = "?";
    for(var key in params)if (params.hasOwnProperty(key)) {
        // @ts-ignore TODO: remove once typescript is upgraded to 3.5.x
        var nextPart = encode(key) + "=" + encode(params[key]);
        queryPart = queryPart + nextPart + "&";
    }
    // Chop off the extra '&' or '?' on the end
    queryPart = queryPart.slice(0, -1);
    return queryPart;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $63c1f7f3542429ef$var$noXform_(metadata, value) {
    return value;
}
/**
 * @struct
 */ var $63c1f7f3542429ef$var$Mapping = /** @class */ function() {
    function Mapping(server, local, writable, xform) {
        this.server = server;
        this.local = local || server;
        this.writable = !!writable;
        this.xform = xform || $63c1f7f3542429ef$var$noXform_;
    }
    return Mapping;
}();
var $63c1f7f3542429ef$var$mappings_ = null;
function $63c1f7f3542429ef$var$xformPath(fullPath) {
    if (!$63c1f7f3542429ef$var$isString(fullPath) || fullPath.length < 2) return fullPath;
    else return $63c1f7f3542429ef$var$lastComponent(fullPath);
}
function $63c1f7f3542429ef$var$getMappings() {
    if ($63c1f7f3542429ef$var$mappings_) return $63c1f7f3542429ef$var$mappings_;
    var mappings = [];
    mappings.push(new $63c1f7f3542429ef$var$Mapping("bucket"));
    mappings.push(new $63c1f7f3542429ef$var$Mapping("generation"));
    mappings.push(new $63c1f7f3542429ef$var$Mapping("metageneration"));
    mappings.push(new $63c1f7f3542429ef$var$Mapping("name", "fullPath", true));
    function mappingsXformPath(_metadata, fullPath) {
        return $63c1f7f3542429ef$var$xformPath(fullPath);
    }
    var nameMapping = new $63c1f7f3542429ef$var$Mapping("name");
    nameMapping.xform = mappingsXformPath;
    mappings.push(nameMapping);
    /**
     * Coerces the second param to a number, if it is defined.
     */ function xformSize(_metadata, size) {
        if ($63c1f7f3542429ef$var$isDef(size)) return Number(size);
        else return size;
    }
    var sizeMapping = new $63c1f7f3542429ef$var$Mapping("size");
    sizeMapping.xform = xformSize;
    mappings.push(sizeMapping);
    mappings.push(new $63c1f7f3542429ef$var$Mapping("timeCreated"));
    mappings.push(new $63c1f7f3542429ef$var$Mapping("updated"));
    mappings.push(new $63c1f7f3542429ef$var$Mapping("md5Hash", null, true));
    mappings.push(new $63c1f7f3542429ef$var$Mapping("cacheControl", null, true));
    mappings.push(new $63c1f7f3542429ef$var$Mapping("contentDisposition", null, true));
    mappings.push(new $63c1f7f3542429ef$var$Mapping("contentEncoding", null, true));
    mappings.push(new $63c1f7f3542429ef$var$Mapping("contentLanguage", null, true));
    mappings.push(new $63c1f7f3542429ef$var$Mapping("contentType", null, true));
    mappings.push(new $63c1f7f3542429ef$var$Mapping("metadata", "customMetadata", true));
    $63c1f7f3542429ef$var$mappings_ = mappings;
    return $63c1f7f3542429ef$var$mappings_;
}
function $63c1f7f3542429ef$var$addRef(metadata, service) {
    function generateRef() {
        var bucket = metadata["bucket"];
        var path = metadata["fullPath"];
        var loc = new $63c1f7f3542429ef$var$Location(bucket, path);
        return service.makeStorageReference(loc);
    }
    Object.defineProperty(metadata, "ref", {
        get: generateRef
    });
}
function $63c1f7f3542429ef$var$fromResource(service, resource, mappings) {
    var metadata = {};
    metadata["type"] = "file";
    var len = mappings.length;
    for(var i = 0; i < len; i++){
        var mapping = mappings[i];
        metadata[mapping.local] = mapping.xform(metadata, resource[mapping.server]);
    }
    $63c1f7f3542429ef$var$addRef(metadata, service);
    return metadata;
}
function $63c1f7f3542429ef$var$fromResourceString(service, resourceString, mappings) {
    var obj = $63c1f7f3542429ef$var$jsonObjectOrNull(resourceString);
    if (obj === null) return null;
    var resource = obj;
    return $63c1f7f3542429ef$var$fromResource(service, resource, mappings);
}
function $63c1f7f3542429ef$var$downloadUrlFromResourceString(metadata, resourceString) {
    var obj = $63c1f7f3542429ef$var$jsonObjectOrNull(resourceString);
    if (obj === null) return null;
    if (!$63c1f7f3542429ef$var$isString(obj["downloadTokens"])) // This can happen if objects are uploaded through GCS and retrieved
    // through list, so we don't want to throw an Error.
    return null;
    var tokens = obj["downloadTokens"];
    if (tokens.length === 0) return null;
    var encode = encodeURIComponent;
    var tokensList = tokens.split(",");
    var urls = tokensList.map(function(token) {
        var bucket = metadata["bucket"];
        var path = metadata["fullPath"];
        var urlPart = "/b/" + encode(bucket) + "/o/" + encode(path);
        var base = $63c1f7f3542429ef$var$makeUrl(urlPart);
        var queryString = $63c1f7f3542429ef$var$makeQueryString({
            alt: "media",
            token: token
        });
        return base + queryString;
    });
    return urls[0];
}
function $63c1f7f3542429ef$var$toResourceString(metadata, mappings) {
    var resource = {};
    var len = mappings.length;
    for(var i = 0; i < len; i++){
        var mapping = mappings[i];
        if (mapping.writable) resource[mapping.server] = metadata[mapping.local];
    }
    return JSON.stringify(resource);
}
function $63c1f7f3542429ef$var$metadataValidator(p) {
    if (!$63c1f7f3542429ef$var$isObject(p) || !p) throw "Expected Metadata object.";
    for(var key in p)if (p.hasOwnProperty(key)) {
        var val = p[key];
        if (key === "customMetadata") {
            if (!$63c1f7f3542429ef$var$isObject(val)) throw "Expected object for 'customMetadata' mapping.";
        } else {
            if ($63c1f7f3542429ef$var$isNonNullObject(val)) throw "Mapping for '" + key + "' cannot be an object.";
        }
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $63c1f7f3542429ef$var$MAX_RESULTS_KEY = "maxResults";
var $63c1f7f3542429ef$var$MAX_MAX_RESULTS = 1000;
var $63c1f7f3542429ef$var$PAGE_TOKEN_KEY = "pageToken";
var $63c1f7f3542429ef$var$PREFIXES_KEY = "prefixes";
var $63c1f7f3542429ef$var$ITEMS_KEY = "items";
function $63c1f7f3542429ef$var$fromBackendResponse(service, bucket, resource) {
    var listResult = {
        prefixes: [],
        items: [],
        nextPageToken: resource["nextPageToken"]
    };
    if (resource[$63c1f7f3542429ef$var$PREFIXES_KEY]) for(var _i = 0, _a = resource[$63c1f7f3542429ef$var$PREFIXES_KEY]; _i < _a.length; _i++){
        var path = _a[_i];
        var pathWithoutTrailingSlash = path.replace(/\/$/, "");
        var reference = service.makeStorageReference(new $63c1f7f3542429ef$var$Location(bucket, pathWithoutTrailingSlash));
        listResult.prefixes.push(reference);
    }
    if (resource[$63c1f7f3542429ef$var$ITEMS_KEY]) for(var _b = 0, _c = resource[$63c1f7f3542429ef$var$ITEMS_KEY]; _b < _c.length; _b++){
        var item = _c[_b];
        var reference = service.makeStorageReference(new $63c1f7f3542429ef$var$Location(bucket, item["name"]));
        listResult.items.push(reference);
    }
    return listResult;
}
function $63c1f7f3542429ef$var$fromResponseString(service, bucket, resourceString) {
    var obj = $63c1f7f3542429ef$var$jsonObjectOrNull(resourceString);
    if (obj === null) return null;
    var resource = obj;
    return $63c1f7f3542429ef$var$fromBackendResponse(service, bucket, resource);
}
function $63c1f7f3542429ef$var$listOptionsValidator(p) {
    if (!$63c1f7f3542429ef$var$isObject(p) || !p) throw "Expected ListOptions object.";
    for(var key in p){
        if (key === $63c1f7f3542429ef$var$MAX_RESULTS_KEY) {
            if (!$63c1f7f3542429ef$var$isInteger(p[$63c1f7f3542429ef$var$MAX_RESULTS_KEY]) || p[$63c1f7f3542429ef$var$MAX_RESULTS_KEY] <= 0) throw "Expected maxResults to be a positive number.";
            if (p[$63c1f7f3542429ef$var$MAX_RESULTS_KEY] > 1000) throw "Expected maxResults to be less than or equal to " + $63c1f7f3542429ef$var$MAX_MAX_RESULTS + ".";
        } else if (key === $63c1f7f3542429ef$var$PAGE_TOKEN_KEY) {
            if (p[$63c1f7f3542429ef$var$PAGE_TOKEN_KEY] && !$63c1f7f3542429ef$var$isString(p[$63c1f7f3542429ef$var$PAGE_TOKEN_KEY])) throw "Expected pageToken to be string.";
        } else throw "Unknown option: " + key;
    }
}
var $63c1f7f3542429ef$var$RequestInfo = /** @class */ function() {
    function RequestInfo(url, method, /**
     * Returns the value with which to resolve the request's promise. Only called
     * if the request is successful. Throw from this function to reject the
     * returned Request's promise with the thrown error.
     * Note: The XhrIo passed to this function may be reused after this callback
     * returns. Do not keep a reference to it in any way.
     */ handler, timeout) {
        this.url = url;
        this.method = method;
        this.handler = handler;
        this.timeout = timeout;
        this.urlParams = {};
        this.headers = {};
        this.body = null;
        this.errorHandler = null;
        /**
         * Called with the current number of bytes uploaded and total size (-1 if not
         * computable) of the request body (i.e. used to report upload progress).
         */ this.progressCallback = null;
        this.successCodes = [
            200
        ];
        this.additionalRetryCodes = [];
    }
    return RequestInfo;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Throws the UNKNOWN FirebaseStorageError if cndn is false.
 */ function $63c1f7f3542429ef$var$handlerCheck(cndn) {
    if (!cndn) throw $63c1f7f3542429ef$var$unknown();
}
function $63c1f7f3542429ef$var$metadataHandler(service, mappings) {
    function handler(xhr, text) {
        var metadata = $63c1f7f3542429ef$var$fromResourceString(service, text, mappings);
        $63c1f7f3542429ef$var$handlerCheck(metadata !== null);
        return metadata;
    }
    return handler;
}
function $63c1f7f3542429ef$var$listHandler(service, bucket) {
    function handler(xhr, text) {
        var listResult = $63c1f7f3542429ef$var$fromResponseString(service, bucket, text);
        $63c1f7f3542429ef$var$handlerCheck(listResult !== null);
        return listResult;
    }
    return handler;
}
function $63c1f7f3542429ef$var$downloadUrlHandler(service, mappings) {
    function handler(xhr, text) {
        var metadata = $63c1f7f3542429ef$var$fromResourceString(service, text, mappings);
        $63c1f7f3542429ef$var$handlerCheck(metadata !== null);
        return $63c1f7f3542429ef$var$downloadUrlFromResourceString(metadata, text);
    }
    return handler;
}
function $63c1f7f3542429ef$var$sharedErrorHandler(location) {
    function errorHandler(xhr, err) {
        var newErr;
        if (xhr.getStatus() === 401) newErr = $63c1f7f3542429ef$var$unauthenticated();
        else {
            if (xhr.getStatus() === 402) newErr = $63c1f7f3542429ef$var$quotaExceeded(location.bucket);
            else if (xhr.getStatus() === 403) newErr = $63c1f7f3542429ef$var$unauthorized(location.path);
            else newErr = err;
        }
        newErr.setServerResponseProp(err.serverResponseProp());
        return newErr;
    }
    return errorHandler;
}
function $63c1f7f3542429ef$var$objectErrorHandler(location) {
    var shared = $63c1f7f3542429ef$var$sharedErrorHandler(location);
    function errorHandler(xhr, err) {
        var newErr = shared(xhr, err);
        if (xhr.getStatus() === 404) newErr = $63c1f7f3542429ef$var$objectNotFound(location.path);
        newErr.setServerResponseProp(err.serverResponseProp());
        return newErr;
    }
    return errorHandler;
}
function $63c1f7f3542429ef$var$getMetadata(service, location, mappings) {
    var urlPart = location.fullServerUrl();
    var url = $63c1f7f3542429ef$var$makeUrl(urlPart);
    var method = "GET";
    var timeout = service.maxOperationRetryTime;
    var requestInfo = new $63c1f7f3542429ef$var$RequestInfo(url, method, $63c1f7f3542429ef$var$metadataHandler(service, mappings), timeout);
    requestInfo.errorHandler = $63c1f7f3542429ef$var$objectErrorHandler(location);
    return requestInfo;
}
function $63c1f7f3542429ef$var$list(service, location, delimiter, pageToken, maxResults) {
    var urlParams = {};
    if (location.isRoot) urlParams["prefix"] = "";
    else urlParams["prefix"] = location.path + "/";
    if (delimiter && delimiter.length > 0) urlParams["delimiter"] = delimiter;
    if (pageToken) urlParams["pageToken"] = pageToken;
    if (maxResults) urlParams["maxResults"] = maxResults;
    var urlPart = location.bucketOnlyServerUrl();
    var url = $63c1f7f3542429ef$var$makeUrl(urlPart);
    var method = "GET";
    var timeout = service.maxOperationRetryTime;
    var requestInfo = new $63c1f7f3542429ef$var$RequestInfo(url, method, $63c1f7f3542429ef$var$listHandler(service, location.bucket), timeout);
    requestInfo.urlParams = urlParams;
    requestInfo.errorHandler = $63c1f7f3542429ef$var$sharedErrorHandler(location);
    return requestInfo;
}
function $63c1f7f3542429ef$var$getDownloadUrl(service, location, mappings) {
    var urlPart = location.fullServerUrl();
    var url = $63c1f7f3542429ef$var$makeUrl(urlPart);
    var method = "GET";
    var timeout = service.maxOperationRetryTime;
    var requestInfo = new $63c1f7f3542429ef$var$RequestInfo(url, method, $63c1f7f3542429ef$var$downloadUrlHandler(service, mappings), timeout);
    requestInfo.errorHandler = $63c1f7f3542429ef$var$objectErrorHandler(location);
    return requestInfo;
}
function $63c1f7f3542429ef$var$updateMetadata(service, location, metadata, mappings) {
    var urlPart = location.fullServerUrl();
    var url = $63c1f7f3542429ef$var$makeUrl(urlPart);
    var method = "PATCH";
    var body = $63c1f7f3542429ef$var$toResourceString(metadata, mappings);
    var headers = {
        "Content-Type": "application/json; charset=utf-8"
    };
    var timeout = service.maxOperationRetryTime;
    var requestInfo = new $63c1f7f3542429ef$var$RequestInfo(url, method, $63c1f7f3542429ef$var$metadataHandler(service, mappings), timeout);
    requestInfo.headers = headers;
    requestInfo.body = body;
    requestInfo.errorHandler = $63c1f7f3542429ef$var$objectErrorHandler(location);
    return requestInfo;
}
function $63c1f7f3542429ef$var$deleteObject(service, location) {
    var urlPart = location.fullServerUrl();
    var url = $63c1f7f3542429ef$var$makeUrl(urlPart);
    var method = "DELETE";
    var timeout = service.maxOperationRetryTime;
    function handler(_xhr, _text) {}
    var requestInfo = new $63c1f7f3542429ef$var$RequestInfo(url, method, handler, timeout);
    requestInfo.successCodes = [
        200,
        204
    ];
    requestInfo.errorHandler = $63c1f7f3542429ef$var$objectErrorHandler(location);
    return requestInfo;
}
function $63c1f7f3542429ef$var$determineContentType_(metadata, blob) {
    return metadata && metadata["contentType"] || blob && blob.type() || "application/octet-stream";
}
function $63c1f7f3542429ef$var$metadataForUpload_(location, blob, metadata) {
    var metadataClone = Object.assign({}, metadata);
    metadataClone["fullPath"] = location.path;
    metadataClone["size"] = blob.size();
    if (!metadataClone["contentType"]) metadataClone["contentType"] = $63c1f7f3542429ef$var$determineContentType_(null, blob);
    return metadataClone;
}
function $63c1f7f3542429ef$var$multipartUpload(service, location, mappings, blob, metadata) {
    var urlPart = location.bucketOnlyServerUrl();
    var headers = {
        "X-Goog-Upload-Protocol": "multipart"
    };
    function genBoundary() {
        var str = "";
        for(var i = 0; i < 2; i++)str = str + Math.random().toString().slice(2);
        return str;
    }
    var boundary = genBoundary();
    headers["Content-Type"] = "multipart/related; boundary=" + boundary;
    var metadata_ = $63c1f7f3542429ef$var$metadataForUpload_(location, blob, metadata);
    var metadataString = $63c1f7f3542429ef$var$toResourceString(metadata_, mappings);
    var preBlobPart = "--" + boundary + "\r\n" + "Content-Type: application/json; charset=utf-8\r\n\r\n" + metadataString + "\r\n--" + boundary + "\r\n" + "Content-Type: " + metadata_["contentType"] + "\r\n\r\n";
    var postBlobPart = "\r\n--" + boundary + "--";
    var body = $63c1f7f3542429ef$var$FbsBlob.getBlob(preBlobPart, blob, postBlobPart);
    if (body === null) throw $63c1f7f3542429ef$var$cannotSliceBlob();
    var urlParams = {
        name: metadata_["fullPath"]
    };
    var url = $63c1f7f3542429ef$var$makeUrl(urlPart);
    var method = "POST";
    var timeout = service.maxUploadRetryTime;
    var requestInfo = new $63c1f7f3542429ef$var$RequestInfo(url, method, $63c1f7f3542429ef$var$metadataHandler(service, mappings), timeout);
    requestInfo.urlParams = urlParams;
    requestInfo.headers = headers;
    requestInfo.body = body.uploadData();
    requestInfo.errorHandler = $63c1f7f3542429ef$var$sharedErrorHandler(location);
    return requestInfo;
}
/**
 * @param current The number of bytes that have been uploaded so far.
 * @param total The total number of bytes in the upload.
 * @param opt_finalized True if the server has finished the upload.
 * @param opt_metadata The upload metadata, should
 *     only be passed if opt_finalized is true.
 * @struct
 */ var $63c1f7f3542429ef$var$ResumableUploadStatus = /** @class */ function() {
    function ResumableUploadStatus(current, total, finalized, metadata) {
        this.current = current;
        this.total = total;
        this.finalized = !!finalized;
        this.metadata = metadata || null;
    }
    return ResumableUploadStatus;
}();
function $63c1f7f3542429ef$var$checkResumeHeader_(xhr, allowed) {
    var status = null;
    try {
        status = xhr.getResponseHeader("X-Goog-Upload-Status");
    } catch (e) {
        $63c1f7f3542429ef$var$handlerCheck(false);
    }
    var allowedStatus = allowed || [
        "active"
    ];
    $63c1f7f3542429ef$var$handlerCheck(!!status && allowedStatus.indexOf(status) !== -1);
    return status;
}
function $63c1f7f3542429ef$var$createResumableUpload(service, location, mappings, blob, metadata) {
    var urlPart = location.bucketOnlyServerUrl();
    var metadataForUpload = $63c1f7f3542429ef$var$metadataForUpload_(location, blob, metadata);
    var urlParams = {
        name: metadataForUpload["fullPath"]
    };
    var url = $63c1f7f3542429ef$var$makeUrl(urlPart);
    var method = "POST";
    var headers = {
        "X-Goog-Upload-Protocol": "resumable",
        "X-Goog-Upload-Command": "start",
        "X-Goog-Upload-Header-Content-Length": blob.size(),
        "X-Goog-Upload-Header-Content-Type": metadataForUpload["contentType"],
        "Content-Type": "application/json; charset=utf-8"
    };
    var body = $63c1f7f3542429ef$var$toResourceString(metadataForUpload, mappings);
    var timeout = service.maxUploadRetryTime;
    function handler(xhr) {
        $63c1f7f3542429ef$var$checkResumeHeader_(xhr);
        var url;
        try {
            url = xhr.getResponseHeader("X-Goog-Upload-URL");
        } catch (e) {
            $63c1f7f3542429ef$var$handlerCheck(false);
        }
        $63c1f7f3542429ef$var$handlerCheck($63c1f7f3542429ef$var$isString(url));
        return url;
    }
    var requestInfo = new $63c1f7f3542429ef$var$RequestInfo(url, method, handler, timeout);
    requestInfo.urlParams = urlParams;
    requestInfo.headers = headers;
    requestInfo.body = body;
    requestInfo.errorHandler = $63c1f7f3542429ef$var$sharedErrorHandler(location);
    return requestInfo;
}
/**
 * @param url From a call to fbs.requests.createResumableUpload.
 */ function $63c1f7f3542429ef$var$getResumableUploadStatus(service, location, url, blob) {
    var headers = {
        "X-Goog-Upload-Command": "query"
    };
    function handler(xhr) {
        var status = $63c1f7f3542429ef$var$checkResumeHeader_(xhr, [
            "active",
            "final"
        ]);
        var sizeString = null;
        try {
            sizeString = xhr.getResponseHeader("X-Goog-Upload-Size-Received");
        } catch (e) {
            $63c1f7f3542429ef$var$handlerCheck(false);
        }
        if (!sizeString) // null or empty string
        $63c1f7f3542429ef$var$handlerCheck(false);
        var size = Number(sizeString);
        $63c1f7f3542429ef$var$handlerCheck(!isNaN(size));
        return new $63c1f7f3542429ef$var$ResumableUploadStatus(size, blob.size(), status === "final");
    }
    var method = "POST";
    var timeout = service.maxUploadRetryTime;
    var requestInfo = new $63c1f7f3542429ef$var$RequestInfo(url, method, handler, timeout);
    requestInfo.headers = headers;
    requestInfo.errorHandler = $63c1f7f3542429ef$var$sharedErrorHandler(location);
    return requestInfo;
}
/**
 * Any uploads via the resumable upload API must transfer a number of bytes
 * that is a multiple of this number.
 */ var $63c1f7f3542429ef$var$resumableUploadChunkSize = 262144;
/**
 * @param url From a call to fbs.requests.createResumableUpload.
 * @param chunkSize Number of bytes to upload.
 * @param status The previous status.
 *     If not passed or null, we start from the beginning.
 * @throws fbs.Error If the upload is already complete, the passed in status
 *     has a final size inconsistent with the blob, or the blob cannot be sliced
 *     for upload.
 */ function $63c1f7f3542429ef$var$continueResumableUpload(location, service, url, blob, chunkSize, mappings, status, progressCallback) {
    // TODO(andysoto): standardize on internal asserts
    // assert(!(opt_status && opt_status.finalized));
    var status_ = new $63c1f7f3542429ef$var$ResumableUploadStatus(0, 0);
    if (status) {
        status_.current = status.current;
        status_.total = status.total;
    } else {
        status_.current = 0;
        status_.total = blob.size();
    }
    if (blob.size() !== status_.total) throw $63c1f7f3542429ef$var$serverFileWrongSize();
    var bytesLeft = status_.total - status_.current;
    var bytesToUpload = bytesLeft;
    if (chunkSize > 0) bytesToUpload = Math.min(bytesToUpload, chunkSize);
    var startByte = status_.current;
    var endByte = startByte + bytesToUpload;
    var uploadCommand = bytesToUpload === bytesLeft ? "upload, finalize" : "upload";
    var headers = {
        "X-Goog-Upload-Command": uploadCommand,
        "X-Goog-Upload-Offset": status_.current
    };
    var body = blob.slice(startByte, endByte);
    if (body === null) throw $63c1f7f3542429ef$var$cannotSliceBlob();
    function handler(xhr, text) {
        // TODO(andysoto): Verify the MD5 of each uploaded range:
        // the 'x-range-md5' header comes back with status code 308 responses.
        // We'll only be able to bail out though, because you can't re-upload a
        // range that you previously uploaded.
        var uploadStatus = $63c1f7f3542429ef$var$checkResumeHeader_(xhr, [
            "active",
            "final"
        ]);
        var newCurrent = status_.current + bytesToUpload;
        var size = blob.size();
        var metadata;
        if (uploadStatus === "final") metadata = $63c1f7f3542429ef$var$metadataHandler(service, mappings)(xhr, text);
        else metadata = null;
        return new $63c1f7f3542429ef$var$ResumableUploadStatus(newCurrent, size, uploadStatus === "final", metadata);
    }
    var method = "POST";
    var timeout = service.maxUploadRetryTime;
    var requestInfo = new $63c1f7f3542429ef$var$RequestInfo(url, method, handler, timeout);
    requestInfo.headers = headers;
    requestInfo.body = body.uploadData();
    requestInfo.progressCallback = progressCallback || null;
    requestInfo.errorHandler = $63c1f7f3542429ef$var$sharedErrorHandler(location);
    return requestInfo;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @struct
 */ var $63c1f7f3542429ef$var$Observer = /** @class */ function() {
    function Observer(nextOrObserver, error, complete) {
        var asFunctions = $63c1f7f3542429ef$var$isFunction(nextOrObserver) || $63c1f7f3542429ef$var$isDef(error) || $63c1f7f3542429ef$var$isDef(complete);
        if (asFunctions) {
            this.next = nextOrObserver;
            this.error = error || null;
            this.complete = complete || null;
        } else {
            var observer = nextOrObserver;
            this.next = observer.next || null;
            this.error = observer.error || null;
            this.complete = observer.complete || null;
        }
    }
    return Observer;
}();
var $63c1f7f3542429ef$var$UploadTaskSnapshot = /** @class */ function() {
    function UploadTaskSnapshot(bytesTransferred, totalBytes, state, metadata, task, ref) {
        this.bytesTransferred = bytesTransferred;
        this.totalBytes = totalBytes;
        this.state = state;
        this.metadata = metadata;
        this.task = task;
        this.ref = ref;
    }
    return UploadTaskSnapshot;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @param name Name of the function.
 * @param specs Argument specs.
 * @param passed The actual arguments passed to the function.
 * @throws {fbs.Error} If the arguments are invalid.
 */ function $63c1f7f3542429ef$var$validate(name, specs, passed) {
    var minArgs = specs.length;
    var maxArgs = specs.length;
    for(var i = 0; i < specs.length; i++)if (specs[i].optional) {
        minArgs = i;
        break;
    }
    var validLength = minArgs <= passed.length && passed.length <= maxArgs;
    if (!validLength) throw $63c1f7f3542429ef$var$invalidArgumentCount(minArgs, maxArgs, name, passed.length);
    for(var i = 0; i < passed.length; i++)try {
        specs[i].validator(passed[i]);
    } catch (e) {
        if (e instanceof Error) throw $63c1f7f3542429ef$var$invalidArgument(i, name, e.message);
        else throw $63c1f7f3542429ef$var$invalidArgument(i, name, e);
    }
}
/**
 * @struct
 */ var $63c1f7f3542429ef$var$ArgSpec = /** @class */ function() {
    function ArgSpec(validator, optional) {
        var self = this;
        this.validator = function(p) {
            if (self.optional && !$63c1f7f3542429ef$var$isJustDef(p)) return;
            validator(p);
        };
        this.optional = !!optional;
    }
    return ArgSpec;
}();
function $63c1f7f3542429ef$var$and_(v1, v2) {
    return function(p) {
        v1(p);
        v2(p);
    };
}
function $63c1f7f3542429ef$var$stringSpec(validator, optional) {
    function stringValidator(p) {
        if (!$63c1f7f3542429ef$var$isString(p)) throw "Expected string.";
    }
    var chainedValidator;
    if (validator) chainedValidator = $63c1f7f3542429ef$var$and_(stringValidator, validator);
    else chainedValidator = stringValidator;
    return new $63c1f7f3542429ef$var$ArgSpec(chainedValidator, optional);
}
function $63c1f7f3542429ef$var$uploadDataSpec() {
    function validator(p) {
        var valid = p instanceof Uint8Array || p instanceof ArrayBuffer || $63c1f7f3542429ef$var$isNativeBlobDefined() && p instanceof Blob;
        if (!valid) throw "Expected Blob or File.";
    }
    return new $63c1f7f3542429ef$var$ArgSpec(validator);
}
function $63c1f7f3542429ef$var$metadataSpec(optional) {
    return new $63c1f7f3542429ef$var$ArgSpec($63c1f7f3542429ef$var$metadataValidator, optional);
}
function $63c1f7f3542429ef$var$listOptionSpec(optional) {
    return new $63c1f7f3542429ef$var$ArgSpec($63c1f7f3542429ef$var$listOptionsValidator, optional);
}
function $63c1f7f3542429ef$var$nonNegativeNumberSpec() {
    function validator(p) {
        var valid = $63c1f7f3542429ef$var$isNumber(p) && p >= 0;
        if (!valid) throw "Expected a number 0 or greater.";
    }
    return new $63c1f7f3542429ef$var$ArgSpec(validator);
}
function $63c1f7f3542429ef$var$looseObjectSpec(validator, optional) {
    function isLooseObjectValidator(p) {
        var isLooseObject = p === null || $63c1f7f3542429ef$var$isDef(p) && p instanceof Object;
        if (!isLooseObject) throw "Expected an Object.";
        if (validator !== undefined && validator !== null) validator(p);
    }
    return new $63c1f7f3542429ef$var$ArgSpec(isLooseObjectValidator, optional);
}
function $63c1f7f3542429ef$var$nullFunctionSpec(optional) {
    function validator(p) {
        var valid = p === null || $63c1f7f3542429ef$var$isFunction(p);
        if (!valid) throw "Expected a Function.";
    }
    return new $63c1f7f3542429ef$var$ArgSpec(validator, optional);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a function that invokes f with its arguments asynchronously as a
 * microtask, i.e. as soon as possible after the current script returns back
 * into browser code.
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $63c1f7f3542429ef$var$async(f) {
    return function() {
        var argsToForward = [];
        for(var _i = 0; _i < arguments.length; _i++)argsToForward[_i] = arguments[_i];
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        Promise.resolve().then(function() {
            return f.apply(void 0, argsToForward);
        });
    };
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents a blob being uploaded. Can be used to pause/resume/cancel the
 * upload and manage callbacks for various events.
 */ var $63c1f7f3542429ef$var$UploadTask = /** @class */ function() {
    /**
     * @param ref The firebaseStorage.Reference object this task came
     *     from, untyped to avoid cyclic dependencies.
     * @param blob The blob to upload.
     */ function UploadTask(ref, service, location, mappings, blob, metadata) {
        var _this = this;
        if (metadata === void 0) metadata = null;
        this.transferred_ = 0;
        this.needToFetchStatus_ = false;
        this.needToFetchMetadata_ = false;
        this.observers_ = [];
        this.error_ = null;
        this.uploadUrl_ = null;
        this.request_ = null;
        this.chunkMultiplier_ = 1;
        this.resolve_ = null;
        this.reject_ = null;
        this.ref_ = ref;
        this.service_ = service;
        this.location_ = location;
        this.blob_ = blob;
        this.metadata_ = metadata;
        this.mappings_ = mappings;
        this.resumable_ = this.shouldDoResumable_(this.blob_);
        this.state_ = $63c1f7f3542429ef$var$InternalTaskState.RUNNING;
        this.errorHandler_ = function(error) {
            _this.request_ = null;
            _this.chunkMultiplier_ = 1;
            if (error.codeEquals($63c1f7f3542429ef$var$Code.CANCELED)) {
                _this.needToFetchStatus_ = true;
                _this.completeTransitions_();
            } else {
                _this.error_ = error;
                _this.transition_($63c1f7f3542429ef$var$InternalTaskState.ERROR);
            }
        };
        this.metadataErrorHandler_ = function(error) {
            _this.request_ = null;
            if (error.codeEquals($63c1f7f3542429ef$var$Code.CANCELED)) _this.completeTransitions_();
            else {
                _this.error_ = error;
                _this.transition_($63c1f7f3542429ef$var$InternalTaskState.ERROR);
            }
        };
        this.promise_ = new Promise(function(resolve, reject) {
            _this.resolve_ = resolve;
            _this.reject_ = reject;
            _this.start_();
        });
        // Prevent uncaught rejections on the internal promise from bubbling out
        // to the top level with a dummy handler.
        this.promise_.then(null, function() {});
    }
    UploadTask.prototype.makeProgressCallback_ = function() {
        var _this = this;
        var sizeBefore = this.transferred_;
        return function(loaded) {
            return _this.updateProgress_(sizeBefore + loaded);
        };
    };
    UploadTask.prototype.shouldDoResumable_ = function(blob) {
        return blob.size() > 262144;
    };
    UploadTask.prototype.start_ = function() {
        if (this.state_ !== $63c1f7f3542429ef$var$InternalTaskState.RUNNING) // This can happen if someone pauses us in a resume callback, for example.
        return;
        if (this.request_ !== null) return;
        if (this.resumable_) {
            if (this.uploadUrl_ === null) this.createResumable_();
            else {
                if (this.needToFetchStatus_) this.fetchStatus_();
                else if (this.needToFetchMetadata_) // Happens if we miss the metadata on upload completion.
                this.fetchMetadata_();
                else this.continueUpload_();
            }
        } else this.oneShotUpload_();
    };
    UploadTask.prototype.resolveToken_ = function(callback) {
        var _this = this;
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.service_.getAuthToken().then(function(authToken) {
            switch(_this.state_){
                case $63c1f7f3542429ef$var$InternalTaskState.RUNNING:
                    callback(authToken);
                    break;
                case $63c1f7f3542429ef$var$InternalTaskState.CANCELING:
                    _this.transition_($63c1f7f3542429ef$var$InternalTaskState.CANCELED);
                    break;
                case $63c1f7f3542429ef$var$InternalTaskState.PAUSING:
                    _this.transition_($63c1f7f3542429ef$var$InternalTaskState.PAUSED);
                    break;
            }
        });
    };
    // TODO(andysoto): assert false
    UploadTask.prototype.createResumable_ = function() {
        var _this = this;
        this.resolveToken_(function(authToken) {
            var requestInfo = $63c1f7f3542429ef$var$createResumableUpload(_this.service_, _this.location_, _this.mappings_, _this.blob_, _this.metadata_);
            var createRequest = _this.service_.makeRequest(requestInfo, authToken);
            _this.request_ = createRequest;
            createRequest.getPromise().then(function(url) {
                _this.request_ = null;
                _this.uploadUrl_ = url;
                _this.needToFetchStatus_ = false;
                _this.completeTransitions_();
            }, _this.errorHandler_);
        });
    };
    UploadTask.prototype.fetchStatus_ = function() {
        var _this = this;
        // TODO(andysoto): assert(this.uploadUrl_ !== null);
        var url = this.uploadUrl_;
        this.resolveToken_(function(authToken) {
            var requestInfo = $63c1f7f3542429ef$var$getResumableUploadStatus(_this.service_, _this.location_, url, _this.blob_);
            var statusRequest = _this.service_.makeRequest(requestInfo, authToken);
            _this.request_ = statusRequest;
            statusRequest.getPromise().then(function(status) {
                status;
                _this.request_ = null;
                _this.updateProgress_(status.current);
                _this.needToFetchStatus_ = false;
                if (status.finalized) _this.needToFetchMetadata_ = true;
                _this.completeTransitions_();
            }, _this.errorHandler_);
        });
    };
    UploadTask.prototype.continueUpload_ = function() {
        var _this = this;
        var chunkSize = $63c1f7f3542429ef$var$resumableUploadChunkSize * this.chunkMultiplier_;
        var status = new $63c1f7f3542429ef$var$ResumableUploadStatus(this.transferred_, this.blob_.size());
        // TODO(andysoto): assert(this.uploadUrl_ !== null);
        var url = this.uploadUrl_;
        this.resolveToken_(function(authToken) {
            var requestInfo;
            try {
                requestInfo = $63c1f7f3542429ef$var$continueResumableUpload(_this.location_, _this.service_, url, _this.blob_, chunkSize, _this.mappings_, status, _this.makeProgressCallback_());
            } catch (e) {
                _this.error_ = e;
                _this.transition_($63c1f7f3542429ef$var$InternalTaskState.ERROR);
                return;
            }
            var uploadRequest = _this.service_.makeRequest(requestInfo, authToken);
            _this.request_ = uploadRequest;
            uploadRequest.getPromise().then(function(newStatus) {
                _this.increaseMultiplier_();
                _this.request_ = null;
                _this.updateProgress_(newStatus.current);
                if (newStatus.finalized) {
                    _this.metadata_ = newStatus.metadata;
                    _this.transition_($63c1f7f3542429ef$var$InternalTaskState.SUCCESS);
                } else _this.completeTransitions_();
            }, _this.errorHandler_);
        });
    };
    UploadTask.prototype.increaseMultiplier_ = function() {
        var currentSize = $63c1f7f3542429ef$var$resumableUploadChunkSize * this.chunkMultiplier_;
        // Max chunk size is 32M.
        if (currentSize < 33554432) this.chunkMultiplier_ *= 2;
    };
    UploadTask.prototype.fetchMetadata_ = function() {
        var _this = this;
        this.resolveToken_(function(authToken) {
            var requestInfo = $63c1f7f3542429ef$var$getMetadata(_this.service_, _this.location_, _this.mappings_);
            var metadataRequest = _this.service_.makeRequest(requestInfo, authToken);
            _this.request_ = metadataRequest;
            metadataRequest.getPromise().then(function(metadata) {
                _this.request_ = null;
                _this.metadata_ = metadata;
                _this.transition_($63c1f7f3542429ef$var$InternalTaskState.SUCCESS);
            }, _this.metadataErrorHandler_);
        });
    };
    UploadTask.prototype.oneShotUpload_ = function() {
        var _this = this;
        this.resolveToken_(function(authToken) {
            var requestInfo = $63c1f7f3542429ef$var$multipartUpload(_this.service_, _this.location_, _this.mappings_, _this.blob_, _this.metadata_);
            var multipartRequest = _this.service_.makeRequest(requestInfo, authToken);
            _this.request_ = multipartRequest;
            multipartRequest.getPromise().then(function(metadata) {
                _this.request_ = null;
                _this.metadata_ = metadata;
                _this.updateProgress_(_this.blob_.size());
                _this.transition_($63c1f7f3542429ef$var$InternalTaskState.SUCCESS);
            }, _this.errorHandler_);
        });
    };
    UploadTask.prototype.updateProgress_ = function(transferred) {
        var old = this.transferred_;
        this.transferred_ = transferred;
        // A progress update can make the "transferred" value smaller (e.g. a
        // partial upload not completed by server, after which the "transferred"
        // value may reset to the value at the beginning of the request).
        if (this.transferred_ !== old) this.notifyObservers_();
    };
    UploadTask.prototype.transition_ = function(state) {
        if (this.state_ === state) return;
        switch(state){
            case $63c1f7f3542429ef$var$InternalTaskState.CANCELING:
                // TODO(andysoto):
                // assert(this.state_ === InternalTaskState.RUNNING ||
                //        this.state_ === InternalTaskState.PAUSING);
                this.state_ = state;
                if (this.request_ !== null) this.request_.cancel();
                break;
            case $63c1f7f3542429ef$var$InternalTaskState.PAUSING:
                // TODO(andysoto):
                // assert(this.state_ === InternalTaskState.RUNNING);
                this.state_ = state;
                if (this.request_ !== null) this.request_.cancel();
                break;
            case $63c1f7f3542429ef$var$InternalTaskState.RUNNING:
                // TODO(andysoto):
                // assert(this.state_ === InternalTaskState.PAUSED ||
                //        this.state_ === InternalTaskState.PAUSING);
                var wasPaused = this.state_ === $63c1f7f3542429ef$var$InternalTaskState.PAUSED;
                this.state_ = state;
                if (wasPaused) {
                    this.notifyObservers_();
                    this.start_();
                }
                break;
            case $63c1f7f3542429ef$var$InternalTaskState.PAUSED:
                // TODO(andysoto):
                // assert(this.state_ === InternalTaskState.PAUSING);
                this.state_ = state;
                this.notifyObservers_();
                break;
            case $63c1f7f3542429ef$var$InternalTaskState.CANCELED:
                // TODO(andysoto):
                // assert(this.state_ === InternalTaskState.PAUSED ||
                //        this.state_ === InternalTaskState.CANCELING);
                this.error_ = $63c1f7f3542429ef$var$canceled();
                this.state_ = state;
                this.notifyObservers_();
                break;
            case $63c1f7f3542429ef$var$InternalTaskState.ERROR:
                // TODO(andysoto):
                // assert(this.state_ === InternalTaskState.RUNNING ||
                //        this.state_ === InternalTaskState.PAUSING ||
                //        this.state_ === InternalTaskState.CANCELING);
                this.state_ = state;
                this.notifyObservers_();
                break;
            case $63c1f7f3542429ef$var$InternalTaskState.SUCCESS:
                // TODO(andysoto):
                // assert(this.state_ === InternalTaskState.RUNNING ||
                //        this.state_ === InternalTaskState.PAUSING ||
                //        this.state_ === InternalTaskState.CANCELING);
                this.state_ = state;
                this.notifyObservers_();
                break;
        }
    };
    UploadTask.prototype.completeTransitions_ = function() {
        switch(this.state_){
            case $63c1f7f3542429ef$var$InternalTaskState.PAUSING:
                this.transition_($63c1f7f3542429ef$var$InternalTaskState.PAUSED);
                break;
            case $63c1f7f3542429ef$var$InternalTaskState.CANCELING:
                this.transition_($63c1f7f3542429ef$var$InternalTaskState.CANCELED);
                break;
            case $63c1f7f3542429ef$var$InternalTaskState.RUNNING:
                this.start_();
                break;
        }
    };
    Object.defineProperty(UploadTask.prototype, "snapshot", {
        get: function() {
            var externalState = $63c1f7f3542429ef$var$taskStateFromInternalTaskState(this.state_);
            return new $63c1f7f3542429ef$var$UploadTaskSnapshot(this.transferred_, this.blob_.size(), externalState, this.metadata_, this, this.ref_);
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Adds a callback for an event.
     * @param type The type of event to listen for.
     */ UploadTask.prototype.on = function(type, nextOrObserver, error, completed) {
        function typeValidator() {
            if (type !== $63c1f7f3542429ef$var$TaskEvent.STATE_CHANGED) throw "Expected one of the event types: [" + $63c1f7f3542429ef$var$TaskEvent.STATE_CHANGED + "].";
        }
        var nextOrObserverMessage = "Expected a function or an Object with one of `next`, `error`, `complete` properties.";
        var nextValidator = $63c1f7f3542429ef$var$nullFunctionSpec(true).validator;
        var observerValidator = $63c1f7f3542429ef$var$looseObjectSpec(null, true).validator;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        function nextOrObserverValidator(p) {
            try {
                nextValidator(p);
                return;
            } catch (e) {}
            try {
                observerValidator(p);
                var anyDefined = $63c1f7f3542429ef$var$isJustDef(p["next"]) || $63c1f7f3542429ef$var$isJustDef(p["error"]) || $63c1f7f3542429ef$var$isJustDef(p["complete"]);
                if (!anyDefined) throw "";
                return;
            } catch (e) {
                throw nextOrObserverMessage;
            }
        }
        var specs = [
            $63c1f7f3542429ef$var$stringSpec(typeValidator),
            $63c1f7f3542429ef$var$looseObjectSpec(nextOrObserverValidator, true),
            $63c1f7f3542429ef$var$nullFunctionSpec(true),
            $63c1f7f3542429ef$var$nullFunctionSpec(true)
        ];
        $63c1f7f3542429ef$var$validate("on", specs, arguments);
        var self = this;
        function makeBinder(specs) {
            function binder(nextOrObserver, error, complete) {
                if (specs !== null) $63c1f7f3542429ef$var$validate("on", specs, arguments);
                var observer = new $63c1f7f3542429ef$var$Observer(nextOrObserver, error, completed);
                self.addObserver_(observer);
                return function() {
                    self.removeObserver_(observer);
                };
            }
            return binder;
        }
        function binderNextOrObserverValidator(p) {
            if (p === null) throw nextOrObserverMessage;
            nextOrObserverValidator(p);
        }
        var binderSpecs = [
            $63c1f7f3542429ef$var$looseObjectSpec(binderNextOrObserverValidator),
            $63c1f7f3542429ef$var$nullFunctionSpec(true),
            $63c1f7f3542429ef$var$nullFunctionSpec(true)
        ];
        var typeOnly = !($63c1f7f3542429ef$var$isJustDef(nextOrObserver) || $63c1f7f3542429ef$var$isJustDef(error) || $63c1f7f3542429ef$var$isJustDef(completed));
        if (typeOnly) return makeBinder(binderSpecs);
        else return makeBinder(null)(nextOrObserver, error, completed);
    };
    /**
     * This object behaves like a Promise, and resolves with its snapshot data
     * when the upload completes.
     * @param onFulfilled The fulfillment callback. Promise chaining works as normal.
     * @param onRejected The rejection callback.
     */ UploadTask.prototype.then = function(onFulfilled, onRejected) {
        // These casts are needed so that TypeScript can infer the types of the
        // resulting Promise.
        return this.promise_.then(onFulfilled, onRejected);
    };
    /**
     * Equivalent to calling `then(null, onRejected)`.
     */ UploadTask.prototype.catch = function(onRejected) {
        return this.then(null, onRejected);
    };
    /**
     * Adds the given observer.
     */ UploadTask.prototype.addObserver_ = function(observer) {
        this.observers_.push(observer);
        this.notifyObserver_(observer);
    };
    /**
     * Removes the given observer.
     */ UploadTask.prototype.removeObserver_ = function(observer) {
        var i = this.observers_.indexOf(observer);
        if (i !== -1) this.observers_.splice(i, 1);
    };
    UploadTask.prototype.notifyObservers_ = function() {
        var _this = this;
        this.finishPromise_();
        var observers = this.observers_.slice();
        observers.forEach(function(observer) {
            _this.notifyObserver_(observer);
        });
    };
    UploadTask.prototype.finishPromise_ = function() {
        if (this.resolve_ !== null) {
            var triggered = true;
            switch($63c1f7f3542429ef$var$taskStateFromInternalTaskState(this.state_)){
                case $63c1f7f3542429ef$var$TaskState.SUCCESS:
                    $63c1f7f3542429ef$var$async(this.resolve_.bind(null, this.snapshot))();
                    break;
                case $63c1f7f3542429ef$var$TaskState.CANCELED:
                case $63c1f7f3542429ef$var$TaskState.ERROR:
                    var toCall = this.reject_;
                    $63c1f7f3542429ef$var$async(toCall.bind(null, this.error_))();
                    break;
                default:
                    triggered = false;
                    break;
            }
            if (triggered) {
                this.resolve_ = null;
                this.reject_ = null;
            }
        }
    };
    UploadTask.prototype.notifyObserver_ = function(observer) {
        var externalState = $63c1f7f3542429ef$var$taskStateFromInternalTaskState(this.state_);
        switch(externalState){
            case $63c1f7f3542429ef$var$TaskState.RUNNING:
            case $63c1f7f3542429ef$var$TaskState.PAUSED:
                if (observer.next) $63c1f7f3542429ef$var$async(observer.next.bind(observer, this.snapshot))();
                break;
            case $63c1f7f3542429ef$var$TaskState.SUCCESS:
                if (observer.complete) $63c1f7f3542429ef$var$async(observer.complete.bind(observer))();
                break;
            case $63c1f7f3542429ef$var$TaskState.CANCELED:
            case $63c1f7f3542429ef$var$TaskState.ERROR:
                if (observer.error) $63c1f7f3542429ef$var$async(observer.error.bind(observer, this.error_))();
                break;
            default:
                // TODO(andysoto): assert(false);
                if (observer.error) $63c1f7f3542429ef$var$async(observer.error.bind(observer, this.error_))();
        }
    };
    /**
     * Resumes a paused task. Has no effect on a currently running or failed task.
     * @return True if the operation took effect, false if ignored.
     */ UploadTask.prototype.resume = function() {
        $63c1f7f3542429ef$var$validate("resume", [], arguments);
        var valid = this.state_ === $63c1f7f3542429ef$var$InternalTaskState.PAUSED || this.state_ === $63c1f7f3542429ef$var$InternalTaskState.PAUSING;
        if (valid) this.transition_($63c1f7f3542429ef$var$InternalTaskState.RUNNING);
        return valid;
    };
    /**
     * Pauses a currently running task. Has no effect on a paused or failed task.
     * @return True if the operation took effect, false if ignored.
     */ UploadTask.prototype.pause = function() {
        $63c1f7f3542429ef$var$validate("pause", [], arguments);
        var valid = this.state_ === $63c1f7f3542429ef$var$InternalTaskState.RUNNING;
        if (valid) this.transition_($63c1f7f3542429ef$var$InternalTaskState.PAUSING);
        return valid;
    };
    /**
     * Cancels a currently running or paused task. Has no effect on a complete or
     * failed task.
     * @return True if the operation took effect, false if ignored.
     */ UploadTask.prototype.cancel = function() {
        $63c1f7f3542429ef$var$validate("cancel", [], arguments);
        var valid = this.state_ === $63c1f7f3542429ef$var$InternalTaskState.RUNNING || this.state_ === $63c1f7f3542429ef$var$InternalTaskState.PAUSING;
        if (valid) this.transition_($63c1f7f3542429ef$var$InternalTaskState.CANCELING);
        return valid;
    };
    return UploadTask;
}();
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provides methods to interact with a bucket in the Firebase Storage service.
 * @param location An fbs.location, or the URL at
 *     which to base this object, in one of the following forms:
 *         gs://<bucket>/<object-path>
 *         http[s]://firebasestorage.googleapis.com/
 *                     <api-version>/b/<bucket>/o/<object-path>
 *     Any query or fragment strings will be ignored in the http[s]
 *     format. If no value is passed, the storage object will use a URL based on
 *     the project ID of the base firebase.App instance.
 */ var $63c1f7f3542429ef$var$Reference = /** @class */ function() {
    function Reference(service, location) {
        this.service = service;
        if (location instanceof $63c1f7f3542429ef$var$Location) this.location = location;
        else this.location = $63c1f7f3542429ef$var$Location.makeFromUrl(location);
    }
    /**
     * @return The URL for the bucket and path this object references,
     *     in the form gs://<bucket>/<object-path>
     * @override
     */ Reference.prototype.toString = function() {
        $63c1f7f3542429ef$var$validate("toString", [], arguments);
        return "gs://" + this.location.bucket + "/" + this.location.path;
    };
    Reference.prototype.newRef = function(service, location) {
        return new Reference(service, location);
    };
    Reference.prototype.mappings = function() {
        return $63c1f7f3542429ef$var$getMappings();
    };
    /**
     * @return A reference to the object obtained by
     *     appending childPath, removing any duplicate, beginning, or trailing
     *     slashes.
     */ Reference.prototype.child = function(childPath) {
        $63c1f7f3542429ef$var$validate("child", [
            $63c1f7f3542429ef$var$stringSpec()
        ], arguments);
        var newPath = $63c1f7f3542429ef$var$child(this.location.path, childPath);
        var location = new $63c1f7f3542429ef$var$Location(this.location.bucket, newPath);
        return this.newRef(this.service, location);
    };
    Object.defineProperty(Reference.prototype, "parent", {
        /**
         * @return A reference to the parent of the
         *     current object, or null if the current object is the root.
         */ get: function() {
            var newPath = $63c1f7f3542429ef$var$parent(this.location.path);
            if (newPath === null) return null;
            var location = new $63c1f7f3542429ef$var$Location(this.location.bucket, newPath);
            return this.newRef(this.service, location);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Reference.prototype, "root", {
        /**
         * @return An reference to the root of this
         *     object's bucket.
         */ get: function() {
            var location = new $63c1f7f3542429ef$var$Location(this.location.bucket, "");
            return this.newRef(this.service, location);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Reference.prototype, "bucket", {
        get: function() {
            return this.location.bucket;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Reference.prototype, "fullPath", {
        get: function() {
            return this.location.path;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Reference.prototype, "name", {
        get: function() {
            return $63c1f7f3542429ef$var$lastComponent(this.location.path);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Reference.prototype, "storage", {
        get: function() {
            return this.service;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Uploads a blob to this object's location.
     * @param data The blob to upload.
     * @return An UploadTask that lets you control and
     *     observe the upload.
     */ Reference.prototype.put = function(data, metadata) {
        if (metadata === void 0) metadata = null;
        $63c1f7f3542429ef$var$validate("put", [
            $63c1f7f3542429ef$var$uploadDataSpec(),
            $63c1f7f3542429ef$var$metadataSpec(true)
        ], arguments);
        this.throwIfRoot_("put");
        return new $63c1f7f3542429ef$var$UploadTask(this, this.service, this.location, this.mappings(), new $63c1f7f3542429ef$var$FbsBlob(data), metadata);
    };
    /**
     * Uploads a string to this object's location.
     * @param value The string to upload.
     * @param format The format of the string to upload.
     * @return An UploadTask that lets you control and
     *     observe the upload.
     */ Reference.prototype.putString = function(value, format, metadata) {
        if (format === void 0) format = $63c1f7f3542429ef$var$StringFormat.RAW;
        $63c1f7f3542429ef$var$validate("putString", [
            $63c1f7f3542429ef$var$stringSpec(),
            $63c1f7f3542429ef$var$stringSpec($63c1f7f3542429ef$var$formatValidator, true),
            $63c1f7f3542429ef$var$metadataSpec(true)
        ], arguments);
        this.throwIfRoot_("putString");
        var data = $63c1f7f3542429ef$var$dataFromString(format, value);
        var metadataClone = Object.assign({}, metadata);
        if (!$63c1f7f3542429ef$var$isDef(metadataClone["contentType"]) && $63c1f7f3542429ef$var$isDef(data.contentType)) metadataClone["contentType"] = data.contentType;
        return new $63c1f7f3542429ef$var$UploadTask(this, this.service, this.location, this.mappings(), new $63c1f7f3542429ef$var$FbsBlob(data.data, true), metadataClone);
    };
    /**
     * Deletes the object at this location.
     * @return A promise that resolves if the deletion succeeds.
     */ Reference.prototype.delete = function() {
        var _this = this;
        $63c1f7f3542429ef$var$validate("delete", [], arguments);
        this.throwIfRoot_("delete");
        return this.service.getAuthToken().then(function(authToken) {
            var requestInfo = $63c1f7f3542429ef$var$deleteObject(_this.service, _this.location);
            return _this.service.makeRequest(requestInfo, authToken).getPromise();
        });
    };
    /**
     * List all items (files) and prefixes (folders) under this storage reference.
     *
     * This is a helper method for calling list() repeatedly until there are
     * no more results. The default pagination size is 1000.
     *
     * Note: The results may not be consistent if objects are changed while this
     * operation is running.
     *
     * Warning: listAll may potentially consume too many resources if there are
     * too many results.
     *
     * @return A Promise that resolves with all the items and prefixes under
     *      the current storage reference. `prefixes` contains references to
     *      sub-directories and `items` contains references to objects in this
     *      folder. `nextPageToken` is never returned.
     */ Reference.prototype.listAll = function() {
        $63c1f7f3542429ef$var$validate("listAll", [], arguments);
        var accumulator = {
            prefixes: [],
            items: []
        };
        return this.listAllHelper(accumulator).then(function() {
            return accumulator;
        });
    };
    Reference.prototype.listAllHelper = function(accumulator, pageToken) {
        return (0, $e365b0be30642692$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var opt, nextPage;
            var _a, _b;
            return (0, $e365b0be30642692$export$67ebef60e6f28a6)(this, function(_c) {
                switch(_c.label){
                    case 0:
                        opt = {
                            // maxResults is 1000 by default.
                            pageToken: pageToken
                        };
                        return [
                            4 /*yield*/ ,
                            this.list(opt)
                        ];
                    case 1:
                        nextPage = _c.sent();
                        (_a = accumulator.prefixes).push.apply(_a, nextPage.prefixes);
                        (_b = accumulator.items).push.apply(_b, nextPage.items);
                        if (!(nextPage.nextPageToken != null)) return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            4 /*yield*/ ,
                            this.listAllHelper(accumulator, nextPage.nextPageToken)
                        ];
                    case 2:
                        _c.sent();
                        _c.label = 3;
                    case 3:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * List items (files) and prefixes (folders) under this storage reference.
     *
     * List API is only available for Firebase Rules Version 2.
     *
     * GCS is a key-blob store. Firebase Storage imposes the semantic of '/'
     * delimited folder structure.
     * Refer to GCS's List API if you want to learn more.
     *
     * To adhere to Firebase Rules's Semantics, Firebase Storage does not
     * support objects whose paths end with "/" or contain two consecutive
     * "/"s. Firebase Storage List API will filter these unsupported objects.
     * list() may fail if there are too many unsupported objects in the bucket.
     *
     * @param options See ListOptions for details.
     * @return A Promise that resolves with the items and prefixes.
     *      `prefixes` contains references to sub-folders and `items`
     *      contains references to objects in this folder. `nextPageToken`
     *      can be used to get the rest of the results.
     */ Reference.prototype.list = function(options) {
        $63c1f7f3542429ef$var$validate("list", [
            $63c1f7f3542429ef$var$listOptionSpec(true)
        ], arguments);
        var self = this;
        return this.service.getAuthToken().then(function(authToken) {
            var op = options || {};
            var requestInfo = $63c1f7f3542429ef$var$list(self.service, self.location, /*delimiter= */ "/", op.pageToken, op.maxResults);
            return self.service.makeRequest(requestInfo, authToken).getPromise();
        });
    };
    /**
     *     A promise that resolves with the metadata for this object. If this
     *     object doesn't exist or metadata cannot be retreived, the promise is
     *     rejected.
     */ Reference.prototype.getMetadata = function() {
        var _this = this;
        $63c1f7f3542429ef$var$validate("getMetadata", [], arguments);
        this.throwIfRoot_("getMetadata");
        return this.service.getAuthToken().then(function(authToken) {
            var requestInfo = $63c1f7f3542429ef$var$getMetadata(_this.service, _this.location, _this.mappings());
            return _this.service.makeRequest(requestInfo, authToken).getPromise();
        });
    };
    /**
     * Updates the metadata for this object.
     * @param metadata The new metadata for the object.
     *     Only values that have been explicitly set will be changed. Explicitly
     *     setting a value to null will remove the metadata.
     * @return A promise that resolves
     *     with the new metadata for this object.
     *     @see firebaseStorage.Reference.prototype.getMetadata
     */ Reference.prototype.updateMetadata = function(metadata) {
        var _this = this;
        $63c1f7f3542429ef$var$validate("updateMetadata", [
            $63c1f7f3542429ef$var$metadataSpec()
        ], arguments);
        this.throwIfRoot_("updateMetadata");
        return this.service.getAuthToken().then(function(authToken) {
            var requestInfo = $63c1f7f3542429ef$var$updateMetadata(_this.service, _this.location, metadata, _this.mappings());
            return _this.service.makeRequest(requestInfo, authToken).getPromise();
        });
    };
    /**
     * @return A promise that resolves with the download
     *     URL for this object.
     */ Reference.prototype.getDownloadURL = function() {
        var _this = this;
        $63c1f7f3542429ef$var$validate("getDownloadURL", [], arguments);
        this.throwIfRoot_("getDownloadURL");
        return this.service.getAuthToken().then(function(authToken) {
            var requestInfo = $63c1f7f3542429ef$var$getDownloadUrl(_this.service, _this.location, _this.mappings());
            return _this.service.makeRequest(requestInfo, authToken).getPromise().then(function(url) {
                if (url === null) throw $63c1f7f3542429ef$var$noDownloadURL();
                return url;
            });
        });
    };
    Reference.prototype.throwIfRoot_ = function(name) {
        if (this.location.path === "") throw $63c1f7f3542429ef$var$invalidRootOperation(name);
    };
    return Reference;
}();
/**
 * A request whose promise always fails.
 * @struct
 * @template T
 */ var $63c1f7f3542429ef$var$FailRequest = /** @class */ function() {
    function FailRequest(error) {
        this.promise_ = Promise.reject(error);
    }
    /** @inheritDoc */ FailRequest.prototype.getPromise = function() {
        return this.promise_;
    };
    /** @inheritDoc */ FailRequest.prototype.cancel = function(_appDelete) {};
    return FailRequest;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @param f May be invoked
 *     before the function returns.
 * @param callback Get all the arguments passed to the function
 *     passed to f, including the initial boolean.
 */ function $63c1f7f3542429ef$var$start(f, // eslint-disable-next-line @typescript-eslint/no-explicit-any
callback, timeout) {
    // TODO(andysoto): make this code cleaner (probably refactor into an actual
    // type instead of a bunch of functions with state shared in the closure)
    var waitSeconds = 1;
    // Would type this as "number" but that doesn't work for Node so ¯\_(ツ)_/¯
    // TODO: find a way to exclude Node type definition for storage because storage only works in browser
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var timeoutId = null;
    var hitTimeout = false;
    var cancelState = 0;
    function canceled() {
        return cancelState === 2;
    }
    var triggeredCallback = false;
    // TODO: This disable can be removed and the 'ignoreRestArgs' option added to
    // the no-explicit-any rule when ESlint releases it.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function triggerCallback() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        if (!triggeredCallback) {
            triggeredCallback = true;
            callback.apply(null, args);
        }
    }
    function callWithDelay(millis) {
        timeoutId = setTimeout(function() {
            timeoutId = null;
            f(handler, canceled());
        }, millis);
    }
    // TODO: This disable can be removed and the 'ignoreRestArgs' option added to
    // the no-explicit-any rule when ESlint releases it.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function handler(success) {
        var args = [];
        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
        if (triggeredCallback) return;
        if (success) {
            triggerCallback.call.apply(triggerCallback, (0, $e365b0be30642692$export$6388937ca91ccae8)([
                null,
                success
            ], args));
            return;
        }
        var mustStop = canceled() || hitTimeout;
        if (mustStop) {
            triggerCallback.call.apply(triggerCallback, (0, $e365b0be30642692$export$6388937ca91ccae8)([
                null,
                success
            ], args));
            return;
        }
        if (waitSeconds < 64) /* TODO(andysoto): don't back off so quickly if we know we're offline. */ waitSeconds *= 2;
        var waitMillis;
        if (cancelState === 1) {
            cancelState = 2;
            waitMillis = 0;
        } else waitMillis = (waitSeconds + Math.random()) * 1000;
        callWithDelay(waitMillis);
    }
    var stopped = false;
    function stop(wasTimeout) {
        if (stopped) return;
        stopped = true;
        if (triggeredCallback) return;
        if (timeoutId !== null) {
            if (!wasTimeout) cancelState = 2;
            clearTimeout(timeoutId);
            callWithDelay(0);
        } else if (!wasTimeout) cancelState = 1;
    }
    callWithDelay(0);
    setTimeout(function() {
        hitTimeout = true;
        stop(true);
    }, timeout);
    return stop;
}
/**
 * Stops the retry loop from repeating.
 * If the function is currently "in between" retries, it is invoked immediately
 * with the second parameter as "true". Otherwise, it will be invoked once more
 * after the current invocation finishes iff the current invocation would have
 * triggered another retry.
 */ function $63c1f7f3542429ef$var$stop(id) {
    id(false);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @struct
 * @template T
 */ var $63c1f7f3542429ef$var$NetworkRequest = /** @class */ function() {
    function NetworkRequest(url, method, headers, body, successCodes, additionalRetryCodes, callback, errorCallback, timeout, progressCallback, pool) {
        var _this = this;
        this.pendingXhr_ = null;
        this.backoffId_ = null;
        this.canceled_ = false;
        this.appDelete_ = false;
        this.url_ = url;
        this.method_ = method;
        this.headers_ = headers;
        this.body_ = body;
        this.successCodes_ = successCodes.slice();
        this.additionalRetryCodes_ = additionalRetryCodes.slice();
        this.callback_ = callback;
        this.errorCallback_ = errorCallback;
        this.progressCallback_ = progressCallback;
        this.timeout_ = timeout;
        this.pool_ = pool;
        this.promise_ = new Promise(function(resolve, reject) {
            _this.resolve_ = resolve;
            _this.reject_ = reject;
            _this.start_();
        });
    }
    /**
     * Actually starts the retry loop.
     */ NetworkRequest.prototype.start_ = function() {
        var self = this;
        function doTheRequest(backoffCallback, canceled) {
            if (canceled) {
                backoffCallback(false, new $63c1f7f3542429ef$var$RequestEndStatus(false, null, true));
                return;
            }
            var xhr = self.pool_.createXhrIo();
            self.pendingXhr_ = xhr;
            function progressListener(progressEvent) {
                var loaded = progressEvent.loaded;
                var total = progressEvent.lengthComputable ? progressEvent.total : -1;
                if (self.progressCallback_ !== null) self.progressCallback_(loaded, total);
            }
            if (self.progressCallback_ !== null) xhr.addUploadProgressListener(progressListener);
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            xhr.send(self.url_, self.method_, self.body_, self.headers_).then(function(xhr) {
                if (self.progressCallback_ !== null) xhr.removeUploadProgressListener(progressListener);
                self.pendingXhr_ = null;
                xhr;
                var hitServer = xhr.getErrorCode() === $63c1f7f3542429ef$var$ErrorCode.NO_ERROR;
                var status = xhr.getStatus();
                if (!hitServer || self.isRetryStatusCode_(status)) {
                    var wasCanceled = xhr.getErrorCode() === $63c1f7f3542429ef$var$ErrorCode.ABORT;
                    backoffCallback(false, new $63c1f7f3542429ef$var$RequestEndStatus(false, null, wasCanceled));
                    return;
                }
                var successCode = self.successCodes_.indexOf(status) !== -1;
                backoffCallback(true, new $63c1f7f3542429ef$var$RequestEndStatus(successCode, xhr));
            });
        }
        /**
         * @param requestWentThrough True if the request eventually went
         *     through, false if it hit the retry limit or was canceled.
         */ function backoffDone(requestWentThrough, status) {
            var resolve = self.resolve_;
            var reject = self.reject_;
            var xhr = status.xhr;
            if (status.wasSuccessCode) try {
                var result = self.callback_(xhr, xhr.getResponseText());
                if ($63c1f7f3542429ef$var$isJustDef(result)) resolve(result);
                else resolve();
            } catch (e) {
                reject(e);
            }
            else {
                if (xhr !== null) {
                    var err = $63c1f7f3542429ef$var$unknown();
                    err.setServerResponseProp(xhr.getResponseText());
                    if (self.errorCallback_) reject(self.errorCallback_(xhr, err));
                    else reject(err);
                } else if (status.canceled) {
                    var err = self.appDelete_ ? $63c1f7f3542429ef$var$appDeleted() : $63c1f7f3542429ef$var$canceled();
                    reject(err);
                } else {
                    var err = $63c1f7f3542429ef$var$retryLimitExceeded();
                    reject(err);
                }
            }
        }
        if (this.canceled_) backoffDone(false, new $63c1f7f3542429ef$var$RequestEndStatus(false, null, true));
        else this.backoffId_ = $63c1f7f3542429ef$var$start(doTheRequest, backoffDone, this.timeout_);
    };
    /** @inheritDoc */ NetworkRequest.prototype.getPromise = function() {
        return this.promise_;
    };
    /** @inheritDoc */ NetworkRequest.prototype.cancel = function(appDelete) {
        this.canceled_ = true;
        this.appDelete_ = appDelete || false;
        if (this.backoffId_ !== null) $63c1f7f3542429ef$var$stop(this.backoffId_);
        if (this.pendingXhr_ !== null) this.pendingXhr_.abort();
    };
    NetworkRequest.prototype.isRetryStatusCode_ = function(status) {
        // The codes for which to retry came from this page:
        // https://cloud.google.com/storage/docs/exponential-backoff
        var isFiveHundredCode = status >= 500 && status < 600;
        var extraRetryCodes = [
            // Request Timeout: web server didn't receive full request in time.
            408,
            // Too Many Requests: you're getting rate-limited, basically.
            429
        ];
        var isExtraRetryCode = extraRetryCodes.indexOf(status) !== -1;
        var isRequestSpecificRetryCode = this.additionalRetryCodes_.indexOf(status) !== -1;
        return isFiveHundredCode || isExtraRetryCode || isRequestSpecificRetryCode;
    };
    return NetworkRequest;
}();
/**
 * A collection of information about the result of a network request.
 * @param opt_canceled Defaults to false.
 * @struct
 */ var $63c1f7f3542429ef$var$RequestEndStatus = /** @class */ function() {
    function RequestEndStatus(wasSuccessCode, xhr, canceled) {
        this.wasSuccessCode = wasSuccessCode;
        this.xhr = xhr;
        this.canceled = !!canceled;
    }
    return RequestEndStatus;
}();
function $63c1f7f3542429ef$var$addAuthHeader_(headers, authToken) {
    if (authToken !== null && authToken.length > 0) headers["Authorization"] = "Firebase " + authToken;
}
function $63c1f7f3542429ef$var$addVersionHeader_(headers) {
    var version = typeof (0, (/*@__PURE__*/$parcel$interopDefault($31dJ8))) !== "undefined" ? (0, (/*@__PURE__*/$parcel$interopDefault($31dJ8))).SDK_VERSION : "AppManager";
    headers["X-Firebase-Storage-Version"] = "webjs/" + version;
}
function $63c1f7f3542429ef$var$addGmpidHeader_(headers, appId) {
    if (appId) headers["X-Firebase-GMPID"] = appId;
}
/**
 * @template T
 */ function $63c1f7f3542429ef$var$makeRequest(requestInfo, appId, authToken, pool) {
    var queryPart = $63c1f7f3542429ef$var$makeQueryString(requestInfo.urlParams);
    var url = requestInfo.url + queryPart;
    var headers = Object.assign({}, requestInfo.headers);
    $63c1f7f3542429ef$var$addGmpidHeader_(headers, appId);
    $63c1f7f3542429ef$var$addAuthHeader_(headers, authToken);
    $63c1f7f3542429ef$var$addVersionHeader_(headers);
    return new $63c1f7f3542429ef$var$NetworkRequest(url, requestInfo.method, headers, requestInfo.body, requestInfo.successCodes, requestInfo.additionalRetryCodes, requestInfo.handler, requestInfo.errorHandler, requestInfo.timeout, requestInfo.progressCallback, pool);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A service that provides firebaseStorage.Reference instances.
 * @param opt_url gs:// url to a custom Storage Bucket
 *
 * @struct
 */ var $63c1f7f3542429ef$var$StorageService = /** @class */ function() {
    function StorageService(app, authProvider, pool, url) {
        var _a;
        this.bucket_ = null;
        this.appId_ = null;
        this.deleted_ = false;
        this.app_ = app;
        this.authProvider_ = authProvider;
        this.maxOperationRetryTime_ = $63c1f7f3542429ef$var$DEFAULT_MAX_OPERATION_RETRY_TIME;
        this.maxUploadRetryTime_ = $63c1f7f3542429ef$var$DEFAULT_MAX_UPLOAD_RETRY_TIME;
        this.requests_ = new Set();
        this.pool_ = pool;
        if (url != null) this.bucket_ = $63c1f7f3542429ef$var$Location.makeFromBucketSpec(url);
        else this.bucket_ = StorageService.extractBucket_((_a = this.app_) === null || _a === void 0 ? void 0 : _a.options);
        this.internals_ = new $63c1f7f3542429ef$var$ServiceInternals(this);
    }
    StorageService.extractBucket_ = function(config) {
        var bucketString = config === null || config === void 0 ? void 0 : config[$63c1f7f3542429ef$var$CONFIG_STORAGE_BUCKET_KEY];
        if (bucketString == null) return null;
        return $63c1f7f3542429ef$var$Location.makeFromBucketSpec(bucketString);
    };
    StorageService.prototype.getAuthToken = function() {
        return (0, $e365b0be30642692$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var auth, tokenData;
            return (0, $e365b0be30642692$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        auth = this.authProvider_.getImmediate({
                            optional: true
                        });
                        if (!auth) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            auth.getToken()
                        ];
                    case 1:
                        tokenData = _a.sent();
                        if (tokenData !== null) return [
                            2 /*return*/ ,
                            tokenData.accessToken
                        ];
                        _a.label = 2;
                    case 2:
                        return [
                            2 /*return*/ ,
                            null
                        ];
                }
            });
        });
    };
    /**
     * Stop running requests and prevent more from being created.
     */ StorageService.prototype.deleteApp = function() {
        this.deleted_ = true;
        this.app_ = null;
        this.requests_.forEach(function(request) {
            return request.cancel();
        });
        this.requests_.clear();
    };
    /**
     * Returns a new firebaseStorage.Reference object referencing this StorageService
     * at the given Location.
     * @param loc The Location.
     * @return A firebaseStorage.Reference.
     */ StorageService.prototype.makeStorageReference = function(loc) {
        return new $63c1f7f3542429ef$var$Reference(this, loc);
    };
    StorageService.prototype.makeRequest = function(requestInfo, authToken) {
        var _this = this;
        if (!this.deleted_) {
            var request_1 = $63c1f7f3542429ef$var$makeRequest(requestInfo, this.appId_, authToken, this.pool_);
            this.requests_.add(request_1);
            // Request removes itself from set when complete.
            request_1.getPromise().then(function() {
                return _this.requests_.delete(request_1);
            }, function() {
                return _this.requests_.delete(request_1);
            });
            return request_1;
        } else return new $63c1f7f3542429ef$var$FailRequest($63c1f7f3542429ef$var$appDeleted());
    };
    /**
     * Returns a firebaseStorage.Reference for the given path in the default
     * bucket.
     */ StorageService.prototype.ref = function(path) {
        function validator(path) {
            if (typeof path !== "string") throw "Path is not a string.";
            if (/^[A-Za-z]+:\/\//.test(path)) throw "Expected child path but got a URL, use refFromURL instead.";
        }
        $63c1f7f3542429ef$var$validate("ref", [
            $63c1f7f3542429ef$var$stringSpec(validator, true)
        ], arguments);
        if (this.bucket_ == null) throw new Error("No Storage Bucket defined in Firebase Options.");
        var ref = new $63c1f7f3542429ef$var$Reference(this, this.bucket_);
        if (path != null) return ref.child(path);
        else return ref;
    };
    /**
     * Returns a firebaseStorage.Reference object for the given absolute URL,
     * which must be a gs:// or http[s]:// URL.
     */ StorageService.prototype.refFromURL = function(url) {
        function validator(p) {
            if (typeof p !== "string") throw "Path is not a string.";
            if (!/^[A-Za-z]+:\/\//.test(p)) throw "Expected full URL but got a child path, use ref instead.";
            try {
                $63c1f7f3542429ef$var$Location.makeFromUrl(p);
            } catch (e) {
                throw "Expected valid full URL but got an invalid one.";
            }
        }
        $63c1f7f3542429ef$var$validate("refFromURL", [
            $63c1f7f3542429ef$var$stringSpec(validator, false)
        ], arguments);
        return new $63c1f7f3542429ef$var$Reference(this, url);
    };
    Object.defineProperty(StorageService.prototype, "maxUploadRetryTime", {
        get: function() {
            return this.maxUploadRetryTime_;
        },
        enumerable: false,
        configurable: true
    });
    StorageService.prototype.setMaxUploadRetryTime = function(time) {
        $63c1f7f3542429ef$var$validate("setMaxUploadRetryTime", [
            $63c1f7f3542429ef$var$nonNegativeNumberSpec()
        ], arguments);
        this.maxUploadRetryTime_ = time;
    };
    Object.defineProperty(StorageService.prototype, "maxOperationRetryTime", {
        get: function() {
            return this.maxOperationRetryTime_;
        },
        enumerable: false,
        configurable: true
    });
    StorageService.prototype.setMaxOperationRetryTime = function(time) {
        $63c1f7f3542429ef$var$validate("setMaxOperationRetryTime", [
            $63c1f7f3542429ef$var$nonNegativeNumberSpec()
        ], arguments);
        this.maxOperationRetryTime_ = time;
    };
    Object.defineProperty(StorageService.prototype, "app", {
        get: function() {
            return this.app_;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StorageService.prototype, "INTERNAL", {
        get: function() {
            return this.internals_;
        },
        enumerable: false,
        configurable: true
    });
    return StorageService;
}();
/**
 * @struct
 */ var $63c1f7f3542429ef$var$ServiceInternals = /** @class */ function() {
    function ServiceInternals(service) {
        this.service_ = service;
    }
    /**
     * Called when the associated app is deleted.
     */ ServiceInternals.prototype.delete = function() {
        this.service_.deleteApp();
        return Promise.resolve();
    };
    return ServiceInternals;
}();
var $63c1f7f3542429ef$var$name = "@firebase/storage";
var $63c1f7f3542429ef$var$version = "0.3.43";
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Type constant for Firebase Storage.
 */ var $63c1f7f3542429ef$var$STORAGE_TYPE = "storage";
function $63c1f7f3542429ef$var$factory(container, url) {
    // Dependencies
    var app = container.getProvider("app").getImmediate();
    var authProvider = container.getProvider("auth-internal");
    return new $63c1f7f3542429ef$var$StorageService(app, authProvider, new $63c1f7f3542429ef$var$XhrIoPool(), url);
}
function $63c1f7f3542429ef$export$ba90a1fa1905b39e(instance) {
    var namespaceExports = {
        // no-inline
        TaskState: $63c1f7f3542429ef$var$TaskState,
        TaskEvent: $63c1f7f3542429ef$var$TaskEvent,
        StringFormat: $63c1f7f3542429ef$var$StringFormat,
        Storage: $63c1f7f3542429ef$var$StorageService,
        Reference: $63c1f7f3542429ef$var$Reference
    };
    instance.INTERNAL.registerComponent(new (0, $gLWqF.Component)($63c1f7f3542429ef$var$STORAGE_TYPE, $63c1f7f3542429ef$var$factory, "PUBLIC" /* PUBLIC */ ).setServiceProps(namespaceExports).setMultipleInstances(true));
    instance.registerVersion($63c1f7f3542429ef$var$name, $63c1f7f3542429ef$var$version);
}
$63c1f7f3542429ef$export$ba90a1fa1905b39e((0, (/*@__PURE__*/$parcel$interopDefault($31dJ8))));


var $46bd46ed2ea54c2d$exports = {};
"use strict";
Object.defineProperty($46bd46ed2ea54c2d$exports, "__esModule", {
    value: true
});

var $31dJ8 = parcelRequire("31dJ8");

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $28a9b6f9306ab557$var$extendStatics = function(d, b) {
    $28a9b6f9306ab557$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $28a9b6f9306ab557$var$extendStatics(d, b);
};
function $28a9b6f9306ab557$export$a8ba968b8961cb8a(d, b) {
    $28a9b6f9306ab557$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $28a9b6f9306ab557$export$18ce0697a983be9b = function() {
    $28a9b6f9306ab557$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $28a9b6f9306ab557$export$18ce0697a983be9b.apply(this, arguments);
};
function $28a9b6f9306ab557$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $28a9b6f9306ab557$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $28a9b6f9306ab557$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $28a9b6f9306ab557$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $28a9b6f9306ab557$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $28a9b6f9306ab557$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $28a9b6f9306ab557$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $28a9b6f9306ab557$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $28a9b6f9306ab557$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $28a9b6f9306ab557$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $28a9b6f9306ab557$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($28a9b6f9306ab557$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $28a9b6f9306ab557$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $28a9b6f9306ab557$export$10c90e4f7922046c(v) {
    return this instanceof $28a9b6f9306ab557$export$10c90e4f7922046c ? (this.v = v, this) : new $28a9b6f9306ab557$export$10c90e4f7922046c(v);
}
function $28a9b6f9306ab557$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $28a9b6f9306ab557$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $28a9b6f9306ab557$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $28a9b6f9306ab557$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $28a9b6f9306ab557$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $28a9b6f9306ab557$export$19a8beecd37a4c45 === "function" ? $28a9b6f9306ab557$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $28a9b6f9306ab557$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $28a9b6f9306ab557$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $28a9b6f9306ab557$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $28a9b6f9306ab557$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $28a9b6f9306ab557$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}



var $01sTD = parcelRequire("01sTD");

var $d4M6f = parcelRequire("d4M6f");

var $gLWqF = parcelRequire("gLWqF");
function $46bd46ed2ea54c2d$var$_interopDefaultLegacy(e) {
    return e && typeof e === "object" && "default" in e ? e : {
        "default": e
    };
}
var $46bd46ed2ea54c2d$var$firebase__default = /*#__PURE__*/ $46bd46ed2ea54c2d$var$_interopDefaultLegacy($31dJ8);
var $46bd46ed2ea54c2d$var$name = "@firebase/performance";
var $46bd46ed2ea54c2d$var$version = "0.4.2";
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $46bd46ed2ea54c2d$var$SDK_VERSION = $46bd46ed2ea54c2d$var$version;
/** The prefix for start User Timing marks used for creating Traces. */ var $46bd46ed2ea54c2d$var$TRACE_START_MARK_PREFIX = "FB-PERF-TRACE-START";
/** The prefix for stop User Timing marks used for creating Traces. */ var $46bd46ed2ea54c2d$var$TRACE_STOP_MARK_PREFIX = "FB-PERF-TRACE-STOP";
/** The prefix for User Timing measure used for creating Traces. */ var $46bd46ed2ea54c2d$var$TRACE_MEASURE_PREFIX = "FB-PERF-TRACE-MEASURE";
/** The prefix for out of the box page load Trace name. */ var $46bd46ed2ea54c2d$var$OOB_TRACE_PAGE_LOAD_PREFIX = "_wt_";
var $46bd46ed2ea54c2d$var$FIRST_PAINT_COUNTER_NAME = "_fp";
var $46bd46ed2ea54c2d$var$FIRST_CONTENTFUL_PAINT_COUNTER_NAME = "_fcp";
var $46bd46ed2ea54c2d$var$FIRST_INPUT_DELAY_COUNTER_NAME = "_fid";
var $46bd46ed2ea54c2d$var$CONFIG_LOCAL_STORAGE_KEY = "@firebase/performance/config";
var $46bd46ed2ea54c2d$var$CONFIG_EXPIRY_LOCAL_STORAGE_KEY = "@firebase/performance/configexpire";
var $46bd46ed2ea54c2d$var$SERVICE = "performance";
var $46bd46ed2ea54c2d$var$SERVICE_NAME = "Performance";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $46bd46ed2ea54c2d$var$_a;
var $46bd46ed2ea54c2d$var$ERROR_DESCRIPTION_MAP = ($46bd46ed2ea54c2d$var$_a = {}, $46bd46ed2ea54c2d$var$_a["trace started" /* TRACE_STARTED_BEFORE */ ] = "Trace {$traceName} was started before.", $46bd46ed2ea54c2d$var$_a["trace stopped" /* TRACE_STOPPED_BEFORE */ ] = "Trace {$traceName} is not running.", $46bd46ed2ea54c2d$var$_a["nonpositive trace startTime" /* NONPOSITIVE_TRACE_START_TIME */ ] = "Trace {$traceName} startTime should be positive.", $46bd46ed2ea54c2d$var$_a["nonpositive trace duration" /* NONPOSITIVE_TRACE_DURATION */ ] = "Trace {$traceName} duration should be positive.", $46bd46ed2ea54c2d$var$_a["no window" /* NO_WINDOW */ ] = "Window is not available.", $46bd46ed2ea54c2d$var$_a["no app id" /* NO_APP_ID */ ] = "App id is not available.", $46bd46ed2ea54c2d$var$_a["no project id" /* NO_PROJECT_ID */ ] = "Project id is not available.", $46bd46ed2ea54c2d$var$_a["no api key" /* NO_API_KEY */ ] = "Api key is not available.", $46bd46ed2ea54c2d$var$_a["invalid cc log" /* INVALID_CC_LOG */ ] = "Attempted to queue invalid cc event", $46bd46ed2ea54c2d$var$_a["FB not default" /* FB_NOT_DEFAULT */ ] = "Performance can only start when Firebase app instance is the default one.", $46bd46ed2ea54c2d$var$_a["RC response not ok" /* RC_NOT_OK */ ] = "RC response is not ok", $46bd46ed2ea54c2d$var$_a["invalid attribute name" /* INVALID_ATTRIBUTE_NAME */ ] = "Attribute name {$attributeName} is invalid.", $46bd46ed2ea54c2d$var$_a["invalid attribute value" /* INVALID_ATTRIBUTE_VALUE */ ] = "Attribute value {$attributeValue} is invalid.", $46bd46ed2ea54c2d$var$_a["invalid custom metric name" /* INVALID_CUSTOM_METRIC_NAME */ ] = "Custom metric name {$customMetricName} is invalid", $46bd46ed2ea54c2d$var$_a["invalid String merger input" /* INVALID_STRING_MERGER_PARAMETER */ ] = "Input for String merger is invalid, contact support team to resolve.", $46bd46ed2ea54c2d$var$_a);
var $46bd46ed2ea54c2d$var$ERROR_FACTORY = new $01sTD.ErrorFactory($46bd46ed2ea54c2d$var$SERVICE, $46bd46ed2ea54c2d$var$SERVICE_NAME, $46bd46ed2ea54c2d$var$ERROR_DESCRIPTION_MAP);
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $46bd46ed2ea54c2d$var$consoleLogger = new $d4M6f.Logger($46bd46ed2ea54c2d$var$SERVICE_NAME);
$46bd46ed2ea54c2d$var$consoleLogger.logLevel = $d4M6f.LogLevel.INFO;
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $46bd46ed2ea54c2d$var$apiInstance;
var $46bd46ed2ea54c2d$var$windowInstance;
/**
 * This class holds a reference to various browser related objects injected by
 * set methods.
 */ var $46bd46ed2ea54c2d$var$Api = /** @class */ function() {
    function Api(window1) {
        this.window = window1;
        if (!window1) throw $46bd46ed2ea54c2d$var$ERROR_FACTORY.create("no window" /* NO_WINDOW */ );
        this.performance = window1.performance;
        this.PerformanceObserver = window1.PerformanceObserver;
        this.windowLocation = window1.location;
        this.navigator = window1.navigator;
        this.document = window1.document;
        if (this.navigator && this.navigator.cookieEnabled) // If user blocks cookies on the browser, accessing localStorage will
        // throw an exception.
        this.localStorage = window1.localStorage;
        if (window1.perfMetrics && window1.perfMetrics.onFirstInputDelay) this.onFirstInputDelay = window1.perfMetrics.onFirstInputDelay;
    }
    Api.prototype.getUrl = function() {
        // Do not capture the string query part of url.
        return this.windowLocation.href.split("?")[0];
    };
    Api.prototype.mark = function(name) {
        if (!this.performance || !this.performance.mark) return;
        this.performance.mark(name);
    };
    Api.prototype.measure = function(measureName, mark1, mark2) {
        if (!this.performance || !this.performance.measure) return;
        this.performance.measure(measureName, mark1, mark2);
    };
    Api.prototype.getEntriesByType = function(type) {
        if (!this.performance || !this.performance.getEntriesByType) return [];
        return this.performance.getEntriesByType(type);
    };
    Api.prototype.getEntriesByName = function(name) {
        if (!this.performance || !this.performance.getEntriesByName) return [];
        return this.performance.getEntriesByName(name);
    };
    Api.prototype.getTimeOrigin = function() {
        // Polyfill the time origin with performance.timing.navigationStart.
        return this.performance && (this.performance.timeOrigin || this.performance.timing.navigationStart);
    };
    Api.prototype.requiredApisAvailable = function() {
        if (!fetch || !Promise || !this.navigator || !this.navigator.cookieEnabled) {
            $46bd46ed2ea54c2d$var$consoleLogger.info("Firebase Performance cannot start if browser does not support fetch and Promise or cookie is disabled.");
            return false;
        }
        if (!$01sTD.isIndexedDBAvailable()) {
            $46bd46ed2ea54c2d$var$consoleLogger.info("IndexedDB is not supported by current browswer");
            return false;
        }
        return true;
    };
    Api.prototype.setupObserver = function(entryType, callback) {
        if (!this.PerformanceObserver) return;
        var observer = new this.PerformanceObserver(function(list) {
            for(var _i = 0, _a = list.getEntries(); _i < _a.length; _i++){
                var entry = _a[_i];
                // `entry` is a PerformanceEntry instance.
                callback(entry);
            }
        });
        // Start observing the entry types you care about.
        observer.observe({
            entryTypes: [
                entryType
            ]
        });
    };
    Api.getInstance = function() {
        if ($46bd46ed2ea54c2d$var$apiInstance === undefined) $46bd46ed2ea54c2d$var$apiInstance = new Api($46bd46ed2ea54c2d$var$windowInstance);
        return $46bd46ed2ea54c2d$var$apiInstance;
    };
    return Api;
}();
function $46bd46ed2ea54c2d$var$setupApi(window1) {
    $46bd46ed2ea54c2d$var$windowInstance = window1;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $46bd46ed2ea54c2d$var$mergeStrings(part1, part2) {
    var sizeDiff = part1.length - part2.length;
    if (sizeDiff < 0 || sizeDiff > 1) throw $46bd46ed2ea54c2d$var$ERROR_FACTORY.create("invalid String merger input" /* INVALID_STRING_MERGER_PARAMETER */ );
    var resultArray = [];
    for(var i = 0; i < part1.length; i++){
        resultArray.push(part1.charAt(i));
        if (part2.length > i) resultArray.push(part2.charAt(i));
    }
    return resultArray.join("");
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $46bd46ed2ea54c2d$var$settingsServiceInstance;
var $46bd46ed2ea54c2d$var$SettingsService = /** @class */ function() {
    function SettingsService() {
        // The variable which controls logging of automatic traces and HTTP/S network monitoring.
        this.instrumentationEnabled = true;
        // The variable which controls logging of custom traces.
        this.dataCollectionEnabled = true;
        // Configuration flags set through remote config.
        this.loggingEnabled = false;
        // Sampling rate between 0 and 1.
        this.tracesSamplingRate = 1;
        this.networkRequestsSamplingRate = 1;
        // Address of logging service.
        this.logEndPointUrl = "https://firebaselogging.googleapis.com/v0cc/log?format=json_proto";
        // Performance event transport endpoint URL which should be compatible with proto3.
        // New Address for transport service, not configurable via Remote Config.
        this.flTransportEndpointUrl = $46bd46ed2ea54c2d$var$mergeStrings("hts/frbslgigp.ogepscmv/ieo/eaylg", "tp:/ieaeogn-agolai.o/1frlglgc/o");
        this.transportKey = $46bd46ed2ea54c2d$var$mergeStrings("AzSC8r6ReiGqFMyfvgow", "Iayx0u-XT3vksVM-pIV");
        // Source type for performance event logs.
        this.logSource = 462;
        // Flags which control per session logging of traces and network requests.
        this.logTraceAfterSampling = false;
        this.logNetworkAfterSampling = false;
        // TTL of config retrieved from remote config in hours.
        this.configTimeToLive = 12;
    }
    SettingsService.prototype.getAppId = function() {
        var appId = this.firebaseAppInstance && this.firebaseAppInstance.options && this.firebaseAppInstance.options.appId;
        if (!appId) throw $46bd46ed2ea54c2d$var$ERROR_FACTORY.create("no app id" /* NO_APP_ID */ );
        return appId;
    };
    SettingsService.prototype.getProjectId = function() {
        var projectId = this.firebaseAppInstance && this.firebaseAppInstance.options && this.firebaseAppInstance.options.projectId;
        if (!projectId) throw $46bd46ed2ea54c2d$var$ERROR_FACTORY.create("no project id" /* NO_PROJECT_ID */ );
        return projectId;
    };
    SettingsService.prototype.getApiKey = function() {
        var apiKey = this.firebaseAppInstance && this.firebaseAppInstance.options && this.firebaseAppInstance.options.apiKey;
        if (!apiKey) throw $46bd46ed2ea54c2d$var$ERROR_FACTORY.create("no api key" /* NO_API_KEY */ );
        return apiKey;
    };
    SettingsService.prototype.getFlTransportFullUrl = function() {
        return this.flTransportEndpointUrl.concat("?key=", this.transportKey);
    };
    SettingsService.getInstance = function() {
        if ($46bd46ed2ea54c2d$var$settingsServiceInstance === undefined) $46bd46ed2ea54c2d$var$settingsServiceInstance = new SettingsService();
        return $46bd46ed2ea54c2d$var$settingsServiceInstance;
    };
    return SettingsService;
}();
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $46bd46ed2ea54c2d$var$iid;
function $46bd46ed2ea54c2d$var$getIidPromise() {
    var iidPromise = $46bd46ed2ea54c2d$var$SettingsService.getInstance().installationsService.getId();
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    iidPromise.then(function(iidVal) {
        $46bd46ed2ea54c2d$var$iid = iidVal;
    });
    return iidPromise;
}
// This method should be used after the iid is retrieved by getIidPromise method.
function $46bd46ed2ea54c2d$var$getIid() {
    return $46bd46ed2ea54c2d$var$iid;
}
function $46bd46ed2ea54c2d$var$getAuthTokenPromise() {
    var authTokenPromise = $46bd46ed2ea54c2d$var$SettingsService.getInstance().installationsService.getToken();
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    authTokenPromise.then(function(authTokenVal) {});
    return authTokenPromise;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $46bd46ed2ea54c2d$var$VisibilityState;
(function(VisibilityState) {
    VisibilityState[VisibilityState["UNKNOWN"] = 0] = "UNKNOWN";
    VisibilityState[VisibilityState["VISIBLE"] = 1] = "VISIBLE";
    VisibilityState[VisibilityState["HIDDEN"] = 2] = "HIDDEN";
})($46bd46ed2ea54c2d$var$VisibilityState || ($46bd46ed2ea54c2d$var$VisibilityState = {}));
var $46bd46ed2ea54c2d$var$RESERVED_ATTRIBUTE_PREFIXES = [
    "firebase_",
    "google_",
    "ga_"
];
var $46bd46ed2ea54c2d$var$ATTRIBUTE_FORMAT_REGEX = new RegExp("^[a-zA-Z]\\w*$");
var $46bd46ed2ea54c2d$var$MAX_ATTRIBUTE_NAME_LENGTH = 40;
var $46bd46ed2ea54c2d$var$MAX_ATTRIBUTE_VALUE_LENGTH = 100;
function $46bd46ed2ea54c2d$var$getServiceWorkerStatus() {
    var navigator = $46bd46ed2ea54c2d$var$Api.getInstance().navigator;
    if ("serviceWorker" in navigator) {
        if (navigator.serviceWorker.controller) return 2 /* CONTROLLED */ ;
        else return 3 /* UNCONTROLLED */ ;
    } else return 1 /* UNSUPPORTED */ ;
}
function $46bd46ed2ea54c2d$var$getVisibilityState() {
    var document = $46bd46ed2ea54c2d$var$Api.getInstance().document;
    var visibilityState = document.visibilityState;
    switch(visibilityState){
        case "visible":
            return $46bd46ed2ea54c2d$var$VisibilityState.VISIBLE;
        case "hidden":
            return $46bd46ed2ea54c2d$var$VisibilityState.HIDDEN;
        default:
            return $46bd46ed2ea54c2d$var$VisibilityState.UNKNOWN;
    }
}
function $46bd46ed2ea54c2d$var$getEffectiveConnectionType() {
    var navigator = $46bd46ed2ea54c2d$var$Api.getInstance().navigator;
    var navigatorConnection = navigator.connection;
    var effectiveType = navigatorConnection && navigatorConnection.effectiveType;
    switch(effectiveType){
        case "slow-2g":
            return 1 /* CONNECTION_SLOW_2G */ ;
        case "2g":
            return 2 /* CONNECTION_2G */ ;
        case "3g":
            return 3 /* CONNECTION_3G */ ;
        case "4g":
            return 4 /* CONNECTION_4G */ ;
        default:
            return 0 /* UNKNOWN */ ;
    }
}
function $46bd46ed2ea54c2d$var$isValidCustomAttributeName(name) {
    if (name.length === 0 || name.length > $46bd46ed2ea54c2d$var$MAX_ATTRIBUTE_NAME_LENGTH) return false;
    var matchesReservedPrefix = $46bd46ed2ea54c2d$var$RESERVED_ATTRIBUTE_PREFIXES.some(function(prefix) {
        return name.startsWith(prefix);
    });
    return !matchesReservedPrefix && !!name.match($46bd46ed2ea54c2d$var$ATTRIBUTE_FORMAT_REGEX);
}
function $46bd46ed2ea54c2d$var$isValidCustomAttributeValue(value) {
    return value.length !== 0 && value.length <= $46bd46ed2ea54c2d$var$MAX_ATTRIBUTE_VALUE_LENGTH;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $46bd46ed2ea54c2d$var$REMOTE_CONFIG_SDK_VERSION = "0.0.1";
// These values will be used if the remote config object is successfully
// retrieved, but the template does not have these fields.
var $46bd46ed2ea54c2d$var$DEFAULT_CONFIGS = {
    loggingEnabled: true
};
var $46bd46ed2ea54c2d$var$FIS_AUTH_PREFIX = "FIREBASE_INSTALLATIONS_AUTH";
function $46bd46ed2ea54c2d$var$getConfig(iid) {
    var config = $46bd46ed2ea54c2d$var$getStoredConfig();
    if (config) {
        $46bd46ed2ea54c2d$var$processConfig(config);
        return Promise.resolve();
    }
    return $46bd46ed2ea54c2d$var$getRemoteConfig(iid).then($46bd46ed2ea54c2d$var$processConfig).then(function(config) {
        return $46bd46ed2ea54c2d$var$storeConfig(config);
    }, /** Do nothing for error, use defaults set in settings service. */ function() {});
}
function $46bd46ed2ea54c2d$var$getStoredConfig() {
    var localStorage = $46bd46ed2ea54c2d$var$Api.getInstance().localStorage;
    if (!localStorage) return;
    var expiryString = localStorage.getItem($46bd46ed2ea54c2d$var$CONFIG_EXPIRY_LOCAL_STORAGE_KEY);
    if (!expiryString || !$46bd46ed2ea54c2d$var$configValid(expiryString)) return;
    var configStringified = localStorage.getItem($46bd46ed2ea54c2d$var$CONFIG_LOCAL_STORAGE_KEY);
    if (!configStringified) return;
    try {
        var configResponse = JSON.parse(configStringified);
        return configResponse;
    } catch (_a) {
        return;
    }
}
function $46bd46ed2ea54c2d$var$storeConfig(config) {
    var localStorage = $46bd46ed2ea54c2d$var$Api.getInstance().localStorage;
    if (!config || !localStorage) return;
    localStorage.setItem($46bd46ed2ea54c2d$var$CONFIG_LOCAL_STORAGE_KEY, JSON.stringify(config));
    localStorage.setItem($46bd46ed2ea54c2d$var$CONFIG_EXPIRY_LOCAL_STORAGE_KEY, String(Date.now() + $46bd46ed2ea54c2d$var$SettingsService.getInstance().configTimeToLive * 3600000));
}
var $46bd46ed2ea54c2d$var$COULD_NOT_GET_CONFIG_MSG = "Could not fetch config, will use default configs";
function $46bd46ed2ea54c2d$var$getRemoteConfig(iid) {
    // Perf needs auth token only to retrieve remote config.
    return $46bd46ed2ea54c2d$var$getAuthTokenPromise().then(function(authToken) {
        var projectId = $46bd46ed2ea54c2d$var$SettingsService.getInstance().getProjectId();
        var configEndPoint = "https://firebaseremoteconfig.googleapis.com/v1/projects/" + projectId + "/namespaces/fireperf:fetch?key=" + $46bd46ed2ea54c2d$var$SettingsService.getInstance().getApiKey();
        var request = new Request(configEndPoint, {
            method: "POST",
            headers: {
                Authorization: $46bd46ed2ea54c2d$var$FIS_AUTH_PREFIX + " " + authToken
            },
            /* eslint-disable camelcase */ body: JSON.stringify({
                app_instance_id: iid,
                app_instance_id_token: authToken,
                app_id: $46bd46ed2ea54c2d$var$SettingsService.getInstance().getAppId(),
                app_version: $46bd46ed2ea54c2d$var$SDK_VERSION,
                sdk_version: $46bd46ed2ea54c2d$var$REMOTE_CONFIG_SDK_VERSION
            })
        });
        return fetch(request).then(function(response) {
            if (response.ok) return response.json();
            // In case response is not ok. This will be caught by catch.
            throw $46bd46ed2ea54c2d$var$ERROR_FACTORY.create("RC response not ok" /* RC_NOT_OK */ );
        });
    }).catch(function() {
        $46bd46ed2ea54c2d$var$consoleLogger.info($46bd46ed2ea54c2d$var$COULD_NOT_GET_CONFIG_MSG);
        return undefined;
    });
}
/**
 * Processes config coming either from calling RC or from local storage.
 * This method only runs if call is successful or config in storage
 * is valid.
 */ function $46bd46ed2ea54c2d$var$processConfig(config) {
    if (!config) return config;
    var settingsServiceInstance = $46bd46ed2ea54c2d$var$SettingsService.getInstance();
    var entries = config.entries || {};
    if (entries.fpr_enabled !== undefined) // TODO: Change the assignment of loggingEnabled once the received type is
    // known.
    settingsServiceInstance.loggingEnabled = String(entries.fpr_enabled) === "true";
    else // Config retrieved successfully, but there is no fpr_enabled in template.
    // Use secondary configs value.
    settingsServiceInstance.loggingEnabled = $46bd46ed2ea54c2d$var$DEFAULT_CONFIGS.loggingEnabled;
    if (entries.fpr_log_source) settingsServiceInstance.logSource = Number(entries.fpr_log_source);
    if (entries.fpr_log_endpoint_url) settingsServiceInstance.logEndPointUrl = entries.fpr_log_endpoint_url;
    // Key from Remote Config has to be non-empty string, otherwsie use local value.
    if (entries.fpr_log_transport_key) settingsServiceInstance.transportKey = entries.fpr_log_transport_key;
    if (entries.fpr_vc_network_request_sampling_rate !== undefined) settingsServiceInstance.networkRequestsSamplingRate = Number(entries.fpr_vc_network_request_sampling_rate);
    if (entries.fpr_vc_trace_sampling_rate !== undefined) settingsServiceInstance.tracesSamplingRate = Number(entries.fpr_vc_trace_sampling_rate);
    // Set the per session trace and network logging flags.
    settingsServiceInstance.logTraceAfterSampling = $46bd46ed2ea54c2d$var$shouldLogAfterSampling(settingsServiceInstance.tracesSamplingRate);
    settingsServiceInstance.logNetworkAfterSampling = $46bd46ed2ea54c2d$var$shouldLogAfterSampling(settingsServiceInstance.networkRequestsSamplingRate);
    return config;
}
function $46bd46ed2ea54c2d$var$configValid(expiry) {
    return Number(expiry) > Date.now();
}
function $46bd46ed2ea54c2d$var$shouldLogAfterSampling(samplingRate) {
    return Math.random() <= samplingRate;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $46bd46ed2ea54c2d$var$initializationStatus = 1 /* notInitialized */ ;
var $46bd46ed2ea54c2d$var$initializationPromise;
function $46bd46ed2ea54c2d$var$getInitializationPromise() {
    $46bd46ed2ea54c2d$var$initializationStatus = 2 /* initializationPending */ ;
    $46bd46ed2ea54c2d$var$initializationPromise = $46bd46ed2ea54c2d$var$initializationPromise || $46bd46ed2ea54c2d$var$initializePerf();
    return $46bd46ed2ea54c2d$var$initializationPromise;
}
function $46bd46ed2ea54c2d$var$isPerfInitialized() {
    return $46bd46ed2ea54c2d$var$initializationStatus === 3 /* initialized */ ;
}
function $46bd46ed2ea54c2d$var$initializePerf() {
    return $46bd46ed2ea54c2d$var$getDocumentReadyComplete().then(function() {
        return $46bd46ed2ea54c2d$var$getIidPromise();
    }).then(function(iid) {
        return $46bd46ed2ea54c2d$var$getConfig(iid);
    }).then(function() {
        return $46bd46ed2ea54c2d$var$changeInitializationStatus();
    }, function() {
        return $46bd46ed2ea54c2d$var$changeInitializationStatus();
    });
}
/**
 * Returns a promise which resolves whenever the document readystate is complete or
 * immediately if it is called after page load complete.
 */ function $46bd46ed2ea54c2d$var$getDocumentReadyComplete() {
    var document = $46bd46ed2ea54c2d$var$Api.getInstance().document;
    return new Promise(function(resolve) {
        if (document && document.readyState !== "complete") {
            var handler_1 = function() {
                if (document.readyState === "complete") {
                    document.removeEventListener("readystatechange", handler_1);
                    resolve();
                }
            };
            document.addEventListener("readystatechange", handler_1);
        } else resolve();
    });
}
function $46bd46ed2ea54c2d$var$changeInitializationStatus() {
    $46bd46ed2ea54c2d$var$initializationStatus = 3 /* initialized */ ;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $46bd46ed2ea54c2d$var$DEFAULT_SEND_INTERVAL_MS = 10000;
var $46bd46ed2ea54c2d$var$INITIAL_SEND_TIME_DELAY_MS = 5500;
// If end point does not work, the call will be tried for these many times.
var $46bd46ed2ea54c2d$var$DEFAULT_REMAINING_TRIES = 3;
var $46bd46ed2ea54c2d$var$remainingTries = $46bd46ed2ea54c2d$var$DEFAULT_REMAINING_TRIES;
/* eslint-enable camelcase */ var $46bd46ed2ea54c2d$var$queue = [];
var $46bd46ed2ea54c2d$var$isTransportSetup = false;
function $46bd46ed2ea54c2d$var$setupTransportService() {
    if (!$46bd46ed2ea54c2d$var$isTransportSetup) {
        $46bd46ed2ea54c2d$var$processQueue($46bd46ed2ea54c2d$var$INITIAL_SEND_TIME_DELAY_MS);
        $46bd46ed2ea54c2d$var$isTransportSetup = true;
    }
}
function $46bd46ed2ea54c2d$var$processQueue(timeOffset) {
    setTimeout(function() {
        // If there is no remainingTries left, stop retrying.
        if ($46bd46ed2ea54c2d$var$remainingTries === 0) return;
        // If there are no events to process, wait for DEFAULT_SEND_INTERVAL_MS and try again.
        if (!$46bd46ed2ea54c2d$var$queue.length) return $46bd46ed2ea54c2d$var$processQueue($46bd46ed2ea54c2d$var$DEFAULT_SEND_INTERVAL_MS);
        $46bd46ed2ea54c2d$var$dispatchQueueEvents();
    }, timeOffset);
}
function $46bd46ed2ea54c2d$var$dispatchQueueEvents() {
    // Capture a snapshot of the queue and empty the "official queue".
    var staged = $28a9b6f9306ab557$export$6388937ca91ccae8($46bd46ed2ea54c2d$var$queue);
    $46bd46ed2ea54c2d$var$queue = [];
    /* eslint-disable camelcase */ // We will pass the JSON serialized event to the backend.
    var log_event = staged.map(function(evt) {
        return {
            source_extension_json_proto3: evt.message,
            event_time_ms: String(evt.eventTime)
        };
    });
    var data = {
        request_time_ms: String(Date.now()),
        client_info: {
            client_type: 1,
            js_client_info: {}
        },
        log_source: $46bd46ed2ea54c2d$var$SettingsService.getInstance().logSource,
        log_event: log_event
    };
    /* eslint-enable camelcase */ $46bd46ed2ea54c2d$var$sendEventsToFl(data, staged).catch(function() {
        // If the request fails for some reason, add the events that were attempted
        // back to the primary queue to retry later.
        $46bd46ed2ea54c2d$var$queue = $28a9b6f9306ab557$export$6388937ca91ccae8(staged, $46bd46ed2ea54c2d$var$queue);
        $46bd46ed2ea54c2d$var$remainingTries--;
        $46bd46ed2ea54c2d$var$consoleLogger.info("Tries left: " + $46bd46ed2ea54c2d$var$remainingTries + ".");
        $46bd46ed2ea54c2d$var$processQueue($46bd46ed2ea54c2d$var$DEFAULT_SEND_INTERVAL_MS);
    });
}
function $46bd46ed2ea54c2d$var$sendEventsToFl(data, staged) {
    return $46bd46ed2ea54c2d$var$postToFlEndpoint(data).then(function(res) {
        if (!res.ok) $46bd46ed2ea54c2d$var$consoleLogger.info("Call to Firebase backend failed.");
        return res.json();
    }).then(function(res) {
        // Find the next call wait time from the response.
        var transportWait = Number(res.nextRequestWaitMillis);
        var requestOffset = $46bd46ed2ea54c2d$var$DEFAULT_SEND_INTERVAL_MS;
        if (!isNaN(transportWait)) requestOffset = Math.max(transportWait, requestOffset);
        // Delete request if response include RESPONSE_ACTION_UNKNOWN or DELETE_REQUEST action.
        // Otherwise, retry request using normal scheduling if response include RETRY_REQUEST_LATER.
        var logResponseDetails = res.logResponseDetails;
        if (Array.isArray(logResponseDetails) && logResponseDetails.length > 0 && logResponseDetails[0].responseAction === "RETRY_REQUEST_LATER") {
            $46bd46ed2ea54c2d$var$queue = $28a9b6f9306ab557$export$6388937ca91ccae8(staged, $46bd46ed2ea54c2d$var$queue);
            $46bd46ed2ea54c2d$var$consoleLogger.info("Retry transport request later.");
        }
        $46bd46ed2ea54c2d$var$remainingTries = $46bd46ed2ea54c2d$var$DEFAULT_REMAINING_TRIES;
        // Schedule the next process.
        $46bd46ed2ea54c2d$var$processQueue(requestOffset);
    });
}
function $46bd46ed2ea54c2d$var$postToFlEndpoint(data) {
    var flTransportFullUrl = $46bd46ed2ea54c2d$var$SettingsService.getInstance().getFlTransportFullUrl();
    return fetch(flTransportFullUrl, {
        method: "POST",
        body: JSON.stringify(data)
    });
}
function $46bd46ed2ea54c2d$var$addToQueue(evt) {
    if (!evt.eventTime || !evt.message) throw $46bd46ed2ea54c2d$var$ERROR_FACTORY.create("invalid cc log" /* INVALID_CC_LOG */ );
    // Add the new event to the queue.
    $46bd46ed2ea54c2d$var$queue = $28a9b6f9306ab557$export$6388937ca91ccae8($46bd46ed2ea54c2d$var$queue, [
        evt
    ]);
}
/** Log handler for cc service to send the performance logs to the server. */ function $46bd46ed2ea54c2d$var$transportHandler(// eslint-disable-next-line @typescript-eslint/no-explicit-any
serializer) {
    return function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var message = serializer.apply(void 0, args);
        $46bd46ed2ea54c2d$var$addToQueue({
            message: message,
            eventTime: Date.now()
        });
    };
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /* eslint-enble camelcase */ var $46bd46ed2ea54c2d$var$logger;
// This method is not called before initialization.
function $46bd46ed2ea54c2d$var$sendLog(resource, resourceType) {
    if (!$46bd46ed2ea54c2d$var$logger) $46bd46ed2ea54c2d$var$logger = $46bd46ed2ea54c2d$var$transportHandler($46bd46ed2ea54c2d$var$serializer);
    $46bd46ed2ea54c2d$var$logger(resource, resourceType);
}
function $46bd46ed2ea54c2d$var$logTrace(trace) {
    var settingsService = $46bd46ed2ea54c2d$var$SettingsService.getInstance();
    // Do not log if trace is auto generated and instrumentation is disabled.
    if (!settingsService.instrumentationEnabled && trace.isAuto) return;
    // Do not log if trace is custom and data collection is disabled.
    if (!settingsService.dataCollectionEnabled && !trace.isAuto) return;
    // Do not log if required apis are not available.
    if (!$46bd46ed2ea54c2d$var$Api.getInstance().requiredApisAvailable()) return;
    // Only log the page load auto traces if page is visible.
    if (trace.isAuto && $46bd46ed2ea54c2d$var$getVisibilityState() !== $46bd46ed2ea54c2d$var$VisibilityState.VISIBLE) return;
    if ($46bd46ed2ea54c2d$var$isPerfInitialized()) $46bd46ed2ea54c2d$var$sendTraceLog(trace);
    else // Custom traces can be used before the initialization but logging
    // should wait until after.
    $46bd46ed2ea54c2d$var$getInitializationPromise().then(function() {
        return $46bd46ed2ea54c2d$var$sendTraceLog(trace);
    }, function() {
        return $46bd46ed2ea54c2d$var$sendTraceLog(trace);
    });
}
function $46bd46ed2ea54c2d$var$sendTraceLog(trace) {
    if (!$46bd46ed2ea54c2d$var$getIid()) return;
    var settingsService = $46bd46ed2ea54c2d$var$SettingsService.getInstance();
    if (!settingsService.loggingEnabled || !settingsService.logTraceAfterSampling) return;
    setTimeout(function() {
        return $46bd46ed2ea54c2d$var$sendLog(trace, 1 /* Trace */ );
    }, 0);
}
function $46bd46ed2ea54c2d$var$logNetworkRequest(networkRequest) {
    var settingsService = $46bd46ed2ea54c2d$var$SettingsService.getInstance();
    // Do not log network requests if instrumentation is disabled.
    if (!settingsService.instrumentationEnabled) return;
    // Do not log the js sdk's call to transport service domain to avoid unnecessary cycle.
    // Need to blacklist both old and new endpoints to avoid migration gap.
    var networkRequestUrl = networkRequest.url;
    // Blacklist old log endpoint and new transport endpoint.
    // Because Performance SDK doesn't instrument requests sent from SDK itself.
    var logEndpointUrl = settingsService.logEndPointUrl.split("?")[0];
    var flEndpointUrl = settingsService.flTransportEndpointUrl.split("?")[0];
    if (networkRequestUrl === logEndpointUrl || networkRequestUrl === flEndpointUrl) return;
    if (!settingsService.loggingEnabled || !settingsService.logNetworkAfterSampling) return;
    setTimeout(function() {
        return $46bd46ed2ea54c2d$var$sendLog(networkRequest, 0 /* NetworkRequest */ );
    }, 0);
}
function $46bd46ed2ea54c2d$var$serializer(resource, resourceType) {
    if (resourceType === 0 /* NetworkRequest */ ) return $46bd46ed2ea54c2d$var$serializeNetworkRequest(resource);
    return $46bd46ed2ea54c2d$var$serializeTrace(resource);
}
function $46bd46ed2ea54c2d$var$serializeNetworkRequest(networkRequest) {
    var networkRequestMetric = {
        url: networkRequest.url,
        http_method: networkRequest.httpMethod || 0,
        http_response_code: 200,
        response_payload_bytes: networkRequest.responsePayloadBytes,
        client_start_time_us: networkRequest.startTimeUs,
        time_to_response_initiated_us: networkRequest.timeToResponseInitiatedUs,
        time_to_response_completed_us: networkRequest.timeToResponseCompletedUs
    };
    var perfMetric = {
        application_info: $46bd46ed2ea54c2d$var$getApplicationInfo(),
        network_request_metric: networkRequestMetric
    };
    return JSON.stringify(perfMetric);
}
function $46bd46ed2ea54c2d$var$serializeTrace(trace) {
    var traceMetric = {
        name: trace.name,
        is_auto: trace.isAuto,
        client_start_time_us: trace.startTimeUs,
        duration_us: trace.durationUs
    };
    if (Object.keys(trace.counters).length !== 0) traceMetric.counters = trace.counters;
    var customAttributes = trace.getAttributes();
    if (Object.keys(customAttributes).length !== 0) traceMetric.custom_attributes = customAttributes;
    var perfMetric = {
        application_info: $46bd46ed2ea54c2d$var$getApplicationInfo(),
        trace_metric: traceMetric
    };
    return JSON.stringify(perfMetric);
}
function $46bd46ed2ea54c2d$var$getApplicationInfo() {
    return {
        google_app_id: $46bd46ed2ea54c2d$var$SettingsService.getInstance().getAppId(),
        app_instance_id: $46bd46ed2ea54c2d$var$getIid(),
        web_app_info: {
            sdk_version: $46bd46ed2ea54c2d$var$SDK_VERSION,
            page_url: $46bd46ed2ea54c2d$var$Api.getInstance().getUrl(),
            service_worker_status: $46bd46ed2ea54c2d$var$getServiceWorkerStatus(),
            visibility_state: $46bd46ed2ea54c2d$var$getVisibilityState(),
            effective_connection_type: $46bd46ed2ea54c2d$var$getEffectiveConnectionType()
        },
        application_process_state: 0
    };
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $46bd46ed2ea54c2d$var$MAX_METRIC_NAME_LENGTH = 100;
var $46bd46ed2ea54c2d$var$RESERVED_AUTO_PREFIX = "_";
var $46bd46ed2ea54c2d$var$oobMetrics = [
    $46bd46ed2ea54c2d$var$FIRST_PAINT_COUNTER_NAME,
    $46bd46ed2ea54c2d$var$FIRST_CONTENTFUL_PAINT_COUNTER_NAME,
    $46bd46ed2ea54c2d$var$FIRST_INPUT_DELAY_COUNTER_NAME
];
/**
 * Returns true if the metric is custom and does not start with reserved prefix, or if
 * the metric is one of out of the box page load trace metrics.
 */ function $46bd46ed2ea54c2d$var$isValidMetricName(name, traceName) {
    if (name.length === 0 || name.length > $46bd46ed2ea54c2d$var$MAX_METRIC_NAME_LENGTH) return false;
    return traceName && traceName.startsWith($46bd46ed2ea54c2d$var$OOB_TRACE_PAGE_LOAD_PREFIX) && $46bd46ed2ea54c2d$var$oobMetrics.indexOf(name) > -1 || !name.startsWith($46bd46ed2ea54c2d$var$RESERVED_AUTO_PREFIX);
}
/**
 * Converts the provided value to an integer value to be used in case of a metric.
 * @param providedValue Provided number value of the metric that needs to be converted to an integer.
 *
 * @returns Converted integer number to be set for the metric.
 */ function $46bd46ed2ea54c2d$var$convertMetricValueToInteger(providedValue) {
    var valueAsInteger = Math.floor(providedValue);
    if (valueAsInteger < providedValue) $46bd46ed2ea54c2d$var$consoleLogger.info("Metric value should be an Integer, setting the value as : " + valueAsInteger + ".");
    return valueAsInteger;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $46bd46ed2ea54c2d$var$Trace = /** @class */ function() {
    /**
     * @param name The name of the trace.
     * @param isAuto If the trace is auto-instrumented.
     * @param traceMeasureName The name of the measure marker in user timing specification. This field
     * is only set when the trace is built for logging when the user directly uses the user timing
     * api (performance.mark and performance.measure).
     */ function Trace(name, isAuto, traceMeasureName) {
        if (isAuto === void 0) isAuto = false;
        this.name = name;
        this.isAuto = isAuto;
        this.state = 1 /* UNINITIALIZED */ ;
        this.customAttributes = {};
        this.counters = {};
        this.api = $46bd46ed2ea54c2d$var$Api.getInstance();
        this.randomId = Math.floor(Math.random() * 1000000);
        if (!this.isAuto) {
            this.traceStartMark = $46bd46ed2ea54c2d$var$TRACE_START_MARK_PREFIX + "-" + this.randomId + "-" + this.name;
            this.traceStopMark = $46bd46ed2ea54c2d$var$TRACE_STOP_MARK_PREFIX + "-" + this.randomId + "-" + this.name;
            this.traceMeasure = traceMeasureName || $46bd46ed2ea54c2d$var$TRACE_MEASURE_PREFIX + "-" + this.randomId + "-" + this.name;
            if (traceMeasureName) // For the case of direct user timing traces, no start stop will happen. The measure object
            // is already available.
            this.calculateTraceMetrics();
        }
    }
    /**
     * Starts a trace. The measurement of the duration starts at this point.
     */ Trace.prototype.start = function() {
        if (this.state !== 1 /* UNINITIALIZED */ ) throw $46bd46ed2ea54c2d$var$ERROR_FACTORY.create("trace started" /* TRACE_STARTED_BEFORE */ , {
            traceName: this.name
        });
        this.api.mark(this.traceStartMark);
        this.state = 2 /* RUNNING */ ;
    };
    /**
     * Stops the trace. The measurement of the duration of the trace stops at this point and trace
     * is logged.
     */ Trace.prototype.stop = function() {
        if (this.state !== 2 /* RUNNING */ ) throw $46bd46ed2ea54c2d$var$ERROR_FACTORY.create("trace stopped" /* TRACE_STOPPED_BEFORE */ , {
            traceName: this.name
        });
        this.state = 3 /* TERMINATED */ ;
        this.api.mark(this.traceStopMark);
        this.api.measure(this.traceMeasure, this.traceStartMark, this.traceStopMark);
        this.calculateTraceMetrics();
        $46bd46ed2ea54c2d$var$logTrace(this);
    };
    /**
     * Records a trace with predetermined values. If this method is used a trace is created and logged
     * directly. No need to use start and stop methods.
     * @param startTime Trace start time since epoch in millisec
     * @param duration The duraction of the trace in millisec
     * @param options An object which can optionally hold maps of custom metrics and custom attributes
     */ Trace.prototype.record = function(startTime, duration, options) {
        if (startTime <= 0) throw $46bd46ed2ea54c2d$var$ERROR_FACTORY.create("nonpositive trace startTime" /* NONPOSITIVE_TRACE_START_TIME */ , {
            traceName: this.name
        });
        if (duration <= 0) throw $46bd46ed2ea54c2d$var$ERROR_FACTORY.create("nonpositive trace duration" /* NONPOSITIVE_TRACE_DURATION */ , {
            traceName: this.name
        });
        this.durationUs = Math.floor(duration * 1000);
        this.startTimeUs = Math.floor(startTime * 1000);
        if (options && options.attributes) this.customAttributes = $28a9b6f9306ab557$export$18ce0697a983be9b({}, options.attributes);
        if (options && options.metrics) for(var _i = 0, _a = Object.keys(options.metrics); _i < _a.length; _i++){
            var metric = _a[_i];
            if (!isNaN(Number(options.metrics[metric]))) this.counters[metric] = Number(Math.floor(options.metrics[metric]));
        }
        $46bd46ed2ea54c2d$var$logTrace(this);
    };
    /**
     * Increments a custom metric by a certain number or 1 if number not specified. Will create a new
     * custom metric if one with the given name does not exist. The value will be floored down to an
     * integer.
     * @param counter Name of the custom metric
     * @param numAsInteger Increment by value
     */ Trace.prototype.incrementMetric = function(counter, numAsInteger) {
        if (numAsInteger === void 0) numAsInteger = 1;
        if (this.counters[counter] === undefined) this.putMetric(counter, numAsInteger);
        else this.putMetric(counter, this.counters[counter] + numAsInteger);
    };
    /**
     * Sets a custom metric to a specified value. Will create a new custom metric if one with the
     * given name does not exist. The value will be floored down to an integer.
     * @param counter Name of the custom metric
     * @param numAsInteger Set custom metric to this value
     */ Trace.prototype.putMetric = function(counter, numAsInteger) {
        if ($46bd46ed2ea54c2d$var$isValidMetricName(counter, this.name)) this.counters[counter] = $46bd46ed2ea54c2d$var$convertMetricValueToInteger(numAsInteger);
        else throw $46bd46ed2ea54c2d$var$ERROR_FACTORY.create("invalid custom metric name" /* INVALID_CUSTOM_METRIC_NAME */ , {
            customMetricName: counter
        });
    };
    /**
     * Returns the value of the custom metric by that name. If a custom metric with that name does
     * not exist will return zero.
     * @param counter
     */ Trace.prototype.getMetric = function(counter) {
        return this.counters[counter] || 0;
    };
    /**
     * Sets a custom attribute of a trace to a certain value.
     * @param attr
     * @param value
     */ Trace.prototype.putAttribute = function(attr, value) {
        var isValidName = $46bd46ed2ea54c2d$var$isValidCustomAttributeName(attr);
        var isValidValue = $46bd46ed2ea54c2d$var$isValidCustomAttributeValue(value);
        if (isValidName && isValidValue) {
            this.customAttributes[attr] = value;
            return;
        }
        // Throw appropriate error when the attribute name or value is invalid.
        if (!isValidName) throw $46bd46ed2ea54c2d$var$ERROR_FACTORY.create("invalid attribute name" /* INVALID_ATTRIBUTE_NAME */ , {
            attributeName: attr
        });
        if (!isValidValue) throw $46bd46ed2ea54c2d$var$ERROR_FACTORY.create("invalid attribute value" /* INVALID_ATTRIBUTE_VALUE */ , {
            attributeValue: value
        });
    };
    /**
     * Retrieves the value a custom attribute of a trace is set to.
     * @param attr
     */ Trace.prototype.getAttribute = function(attr) {
        return this.customAttributes[attr];
    };
    Trace.prototype.removeAttribute = function(attr) {
        if (this.customAttributes[attr] === undefined) return;
        delete this.customAttributes[attr];
    };
    Trace.prototype.getAttributes = function() {
        return $28a9b6f9306ab557$export$18ce0697a983be9b({}, this.customAttributes);
    };
    Trace.prototype.setStartTime = function(startTime) {
        this.startTimeUs = startTime;
    };
    Trace.prototype.setDuration = function(duration) {
        this.durationUs = duration;
    };
    /**
     * Calculates and assigns the duration and start time of the trace using the measure performance
     * entry.
     */ Trace.prototype.calculateTraceMetrics = function() {
        var perfMeasureEntries = this.api.getEntriesByName(this.traceMeasure);
        var perfMeasureEntry = perfMeasureEntries && perfMeasureEntries[0];
        if (perfMeasureEntry) {
            this.durationUs = Math.floor(perfMeasureEntry.duration * 1000);
            this.startTimeUs = Math.floor((perfMeasureEntry.startTime + this.api.getTimeOrigin()) * 1000);
        }
    };
    /**
     * @param navigationTimings A single element array which contains the navigationTIming object of
     * the page load
     * @param paintTimings A array which contains paintTiming object of the page load
     * @param firstInputDelay First input delay in millisec
     */ Trace.createOobTrace = function(navigationTimings, paintTimings, firstInputDelay) {
        var route = $46bd46ed2ea54c2d$var$Api.getInstance().getUrl();
        if (!route) return;
        var trace = new Trace($46bd46ed2ea54c2d$var$OOB_TRACE_PAGE_LOAD_PREFIX + route, true);
        var timeOriginUs = Math.floor($46bd46ed2ea54c2d$var$Api.getInstance().getTimeOrigin() * 1000);
        trace.setStartTime(timeOriginUs);
        // navigationTimings includes only one element.
        if (navigationTimings && navigationTimings[0]) {
            trace.setDuration(Math.floor(navigationTimings[0].duration * 1000));
            trace.putMetric("domInteractive", Math.floor(navigationTimings[0].domInteractive * 1000));
            trace.putMetric("domContentLoadedEventEnd", Math.floor(navigationTimings[0].domContentLoadedEventEnd * 1000));
            trace.putMetric("loadEventEnd", Math.floor(navigationTimings[0].loadEventEnd * 1000));
        }
        var FIRST_PAINT = "first-paint";
        var FIRST_CONTENTFUL_PAINT = "first-contentful-paint";
        if (paintTimings) {
            var firstPaint = paintTimings.find(function(paintObject) {
                return paintObject.name === FIRST_PAINT;
            });
            if (firstPaint && firstPaint.startTime) trace.putMetric($46bd46ed2ea54c2d$var$FIRST_PAINT_COUNTER_NAME, Math.floor(firstPaint.startTime * 1000));
            var firstContentfulPaint = paintTimings.find(function(paintObject) {
                return paintObject.name === FIRST_CONTENTFUL_PAINT;
            });
            if (firstContentfulPaint && firstContentfulPaint.startTime) trace.putMetric($46bd46ed2ea54c2d$var$FIRST_CONTENTFUL_PAINT_COUNTER_NAME, Math.floor(firstContentfulPaint.startTime * 1000));
            if (firstInputDelay) trace.putMetric($46bd46ed2ea54c2d$var$FIRST_INPUT_DELAY_COUNTER_NAME, Math.floor(firstInputDelay * 1000));
        }
        $46bd46ed2ea54c2d$var$logTrace(trace);
    };
    Trace.createUserTimingTrace = function(measureName) {
        var trace = new Trace(measureName, false, measureName);
        $46bd46ed2ea54c2d$var$logTrace(trace);
    };
    return Trace;
}();
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $46bd46ed2ea54c2d$var$createNetworkRequestEntry(entry) {
    var performanceEntry = entry;
    if (!performanceEntry || performanceEntry.responseStart === undefined) return;
    var timeOrigin = $46bd46ed2ea54c2d$var$Api.getInstance().getTimeOrigin();
    var startTimeUs = Math.floor((performanceEntry.startTime + timeOrigin) * 1000);
    var timeToResponseInitiatedUs = performanceEntry.responseStart ? Math.floor((performanceEntry.responseStart - performanceEntry.startTime) * 1000) : undefined;
    var timeToResponseCompletedUs = Math.floor((performanceEntry.responseEnd - performanceEntry.startTime) * 1000);
    // Remove the query params from logged network request url.
    var url = performanceEntry.name && performanceEntry.name.split("?")[0];
    var networkRequest = {
        url: url,
        responsePayloadBytes: performanceEntry.transferSize,
        startTimeUs: startTimeUs,
        timeToResponseInitiatedUs: timeToResponseInitiatedUs,
        timeToResponseCompletedUs: timeToResponseCompletedUs
    };
    $46bd46ed2ea54c2d$var$logNetworkRequest(networkRequest);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $46bd46ed2ea54c2d$var$FID_WAIT_TIME_MS = 5000;
function $46bd46ed2ea54c2d$var$setupOobResources() {
    // Do not initialize unless iid is available.
    if (!$46bd46ed2ea54c2d$var$getIid()) return;
    // The load event might not have fired yet, and that means performance navigation timing
    // object has a duration of 0. The setup should run after all current tasks in js queue.
    setTimeout(function() {
        return $46bd46ed2ea54c2d$var$setupOobTraces();
    }, 0);
    setTimeout(function() {
        return $46bd46ed2ea54c2d$var$setupNetworkRequests();
    }, 0);
    setTimeout(function() {
        return $46bd46ed2ea54c2d$var$setupUserTimingTraces();
    }, 0);
}
function $46bd46ed2ea54c2d$var$setupNetworkRequests() {
    var api = $46bd46ed2ea54c2d$var$Api.getInstance();
    var resources = api.getEntriesByType("resource");
    for(var _i = 0, resources_1 = resources; _i < resources_1.length; _i++){
        var resource = resources_1[_i];
        $46bd46ed2ea54c2d$var$createNetworkRequestEntry(resource);
    }
    api.setupObserver("resource", $46bd46ed2ea54c2d$var$createNetworkRequestEntry);
}
function $46bd46ed2ea54c2d$var$setupOobTraces() {
    var api = $46bd46ed2ea54c2d$var$Api.getInstance();
    var navigationTimings = api.getEntriesByType("navigation");
    var paintTimings = api.getEntriesByType("paint");
    // If First Input Desly polyfill is added to the page, report the fid value.
    // https://github.com/GoogleChromeLabs/first-input-delay
    if (api.onFirstInputDelay) {
        // If the fid call back is not called for certain time, continue without it.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var timeoutId_1 = setTimeout(function() {
            $46bd46ed2ea54c2d$var$Trace.createOobTrace(navigationTimings, paintTimings);
            timeoutId_1 = undefined;
        }, $46bd46ed2ea54c2d$var$FID_WAIT_TIME_MS);
        api.onFirstInputDelay(function(fid) {
            if (timeoutId_1) {
                clearTimeout(timeoutId_1);
                $46bd46ed2ea54c2d$var$Trace.createOobTrace(navigationTimings, paintTimings, fid);
            }
        });
    } else $46bd46ed2ea54c2d$var$Trace.createOobTrace(navigationTimings, paintTimings);
}
function $46bd46ed2ea54c2d$var$setupUserTimingTraces() {
    var api = $46bd46ed2ea54c2d$var$Api.getInstance();
    // Run through the measure performance entries collected up to this point.
    var measures = api.getEntriesByType("measure");
    for(var _i = 0, measures_1 = measures; _i < measures_1.length; _i++){
        var measure = measures_1[_i];
        $46bd46ed2ea54c2d$var$createUserTimingTrace(measure);
    }
    // Setup an observer to capture the measures from this point on.
    api.setupObserver("measure", $46bd46ed2ea54c2d$var$createUserTimingTrace);
}
function $46bd46ed2ea54c2d$var$createUserTimingTrace(measure) {
    var measureName = measure.name;
    // Do not create a trace, if the user timing marks and measures are created by the sdk itself.
    if (measureName.substring(0, $46bd46ed2ea54c2d$var$TRACE_MEASURE_PREFIX.length) === $46bd46ed2ea54c2d$var$TRACE_MEASURE_PREFIX) return;
    $46bd46ed2ea54c2d$var$Trace.createUserTimingTrace(measureName);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $46bd46ed2ea54c2d$var$PerformanceController = /** @class */ function() {
    function PerformanceController(app) {
        this.app = app;
        if ($46bd46ed2ea54c2d$var$Api.getInstance().requiredApisAvailable()) $01sTD.validateIndexedDBOpenable().then(function(isAvailable) {
            if (isAvailable) {
                $46bd46ed2ea54c2d$var$setupTransportService();
                $46bd46ed2ea54c2d$var$getInitializationPromise().then($46bd46ed2ea54c2d$var$setupOobResources, $46bd46ed2ea54c2d$var$setupOobResources);
            }
        }).catch(function(error) {
            $46bd46ed2ea54c2d$var$consoleLogger.info("Environment doesn't support IndexedDB: " + error);
        });
    }
    PerformanceController.prototype.trace = function(name) {
        return new $46bd46ed2ea54c2d$var$Trace(name);
    };
    Object.defineProperty(PerformanceController.prototype, "instrumentationEnabled", {
        get: function() {
            return $46bd46ed2ea54c2d$var$SettingsService.getInstance().instrumentationEnabled;
        },
        set: function(val) {
            $46bd46ed2ea54c2d$var$SettingsService.getInstance().instrumentationEnabled = val;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PerformanceController.prototype, "dataCollectionEnabled", {
        get: function() {
            return $46bd46ed2ea54c2d$var$SettingsService.getInstance().dataCollectionEnabled;
        },
        set: function(val) {
            $46bd46ed2ea54c2d$var$SettingsService.getInstance().dataCollectionEnabled = val;
        },
        enumerable: false,
        configurable: true
    });
    return PerformanceController;
}();
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $46bd46ed2ea54c2d$var$DEFAULT_ENTRY_NAME = "[DEFAULT]";
function $46bd46ed2ea54c2d$var$registerPerformance(instance) {
    var factoryMethod = function(app, installations) {
        if (app.name !== $46bd46ed2ea54c2d$var$DEFAULT_ENTRY_NAME) throw $46bd46ed2ea54c2d$var$ERROR_FACTORY.create("FB not default" /* FB_NOT_DEFAULT */ );
        if (typeof window === "undefined") throw $46bd46ed2ea54c2d$var$ERROR_FACTORY.create("no window" /* NO_WINDOW */ );
        $46bd46ed2ea54c2d$var$setupApi(window);
        $46bd46ed2ea54c2d$var$SettingsService.getInstance().firebaseAppInstance = app;
        $46bd46ed2ea54c2d$var$SettingsService.getInstance().installationsService = installations;
        return new $46bd46ed2ea54c2d$var$PerformanceController(app);
    };
    // Register performance with firebase-app.
    instance.INTERNAL.registerComponent(new $gLWqF.Component("performance", function(container) {
        /* Dependencies */ // getImmediate for FirebaseApp will always succeed
        var app = container.getProvider("app").getImmediate();
        // The following call will always succeed because perf has `import '@firebase/installations'`
        var installations = container.getProvider("installations").getImmediate();
        return factoryMethod(app, installations);
    }, "PUBLIC" /* PUBLIC */ ));
    instance.registerVersion($46bd46ed2ea54c2d$var$name, $46bd46ed2ea54c2d$var$version);
}
$46bd46ed2ea54c2d$var$registerPerformance($46bd46ed2ea54c2d$var$firebase__default["default"]);
$46bd46ed2ea54c2d$exports.registerPerformance = $46bd46ed2ea54c2d$var$registerPerformance;


/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $32b319a9aeeb1338$var$extendStatics = function(d, b) {
    $32b319a9aeeb1338$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $32b319a9aeeb1338$var$extendStatics(d, b);
};
function $32b319a9aeeb1338$export$a8ba968b8961cb8a(d, b) {
    $32b319a9aeeb1338$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $32b319a9aeeb1338$export$18ce0697a983be9b = function() {
    $32b319a9aeeb1338$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $32b319a9aeeb1338$export$18ce0697a983be9b.apply(this, arguments);
};
function $32b319a9aeeb1338$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $32b319a9aeeb1338$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $32b319a9aeeb1338$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $32b319a9aeeb1338$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $32b319a9aeeb1338$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $32b319a9aeeb1338$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $32b319a9aeeb1338$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $32b319a9aeeb1338$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $32b319a9aeeb1338$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $32b319a9aeeb1338$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $32b319a9aeeb1338$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($32b319a9aeeb1338$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $32b319a9aeeb1338$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $32b319a9aeeb1338$export$10c90e4f7922046c(v) {
    return this instanceof $32b319a9aeeb1338$export$10c90e4f7922046c ? (this.v = v, this) : new $32b319a9aeeb1338$export$10c90e4f7922046c(v);
}
function $32b319a9aeeb1338$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $32b319a9aeeb1338$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $32b319a9aeeb1338$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $32b319a9aeeb1338$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $32b319a9aeeb1338$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $32b319a9aeeb1338$export$19a8beecd37a4c45 === "function" ? $32b319a9aeeb1338$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $32b319a9aeeb1338$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $32b319a9aeeb1338$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $32b319a9aeeb1338$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $32b319a9aeeb1338$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $32b319a9aeeb1338$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}



var $31dJ8 = parcelRequire("31dJ8");


var $d4M6f = parcelRequire("d4M6f");

var $01sTD = parcelRequire("01sTD");

var $gLWqF = parcelRequire("gLWqF");
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Key to attach FID to in gtag params.
var $4e360e3617ed619f$var$GA_FID_KEY = "firebase_id";
var $4e360e3617ed619f$var$ORIGIN_KEY = "origin";
var $4e360e3617ed619f$var$FETCH_TIMEOUT_MILLIS = 60000;
var $4e360e3617ed619f$var$DYNAMIC_CONFIG_URL = "https://firebase.googleapis.com/v1alpha/projects/-/apps/{app-id}/webConfig";
var $4e360e3617ed619f$var$GTAG_URL = "https://www.googletagmanager.com/gtag/js";
var $4e360e3617ed619f$var$GtagCommand;
(function(GtagCommand) {
    GtagCommand["EVENT"] = "event";
    GtagCommand["SET"] = "set";
    GtagCommand["CONFIG"] = "config";
})($4e360e3617ed619f$var$GtagCommand || ($4e360e3617ed619f$var$GtagCommand = {}));
/*
 * Officially recommended event names for gtag.js
 * Any other string is also allowed.
 */ var $4e360e3617ed619f$var$EventName;
(function(EventName) {
    EventName["ADD_SHIPPING_INFO"] = "add_shipping_info";
    EventName["ADD_PAYMENT_INFO"] = "add_payment_info";
    EventName["ADD_TO_CART"] = "add_to_cart";
    EventName["ADD_TO_WISHLIST"] = "add_to_wishlist";
    EventName["BEGIN_CHECKOUT"] = "begin_checkout";
    /** @deprecated */ EventName["CHECKOUT_PROGRESS"] = "checkout_progress";
    EventName["EXCEPTION"] = "exception";
    EventName["GENERATE_LEAD"] = "generate_lead";
    EventName["LOGIN"] = "login";
    EventName["PAGE_VIEW"] = "page_view";
    EventName["PURCHASE"] = "purchase";
    EventName["REFUND"] = "refund";
    EventName["REMOVE_FROM_CART"] = "remove_from_cart";
    EventName["SCREEN_VIEW"] = "screen_view";
    EventName["SEARCH"] = "search";
    EventName["SELECT_CONTENT"] = "select_content";
    EventName["SELECT_ITEM"] = "select_item";
    EventName["SELECT_PROMOTION"] = "select_promotion";
    /** @deprecated */ EventName["SET_CHECKOUT_OPTION"] = "set_checkout_option";
    EventName["SHARE"] = "share";
    EventName["SIGN_UP"] = "sign_up";
    EventName["TIMING_COMPLETE"] = "timing_complete";
    EventName["VIEW_CART"] = "view_cart";
    EventName["VIEW_ITEM"] = "view_item";
    EventName["VIEW_ITEM_LIST"] = "view_item_list";
    EventName["VIEW_PROMOTION"] = "view_promotion";
    EventName["VIEW_SEARCH_RESULTS"] = "view_search_results";
})($4e360e3617ed619f$var$EventName || ($4e360e3617ed619f$var$EventName = {}));
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Logs an analytics event through the Firebase SDK.
 *
 * @param gtagFunction Wrapped gtag function that waits for fid to be set before sending an event
 * @param eventName Google Analytics event name, choose from standard list or use a custom string.
 * @param eventParams Analytics event parameters.
 */ function $4e360e3617ed619f$var$logEvent(gtagFunction, initializationPromise, eventName, eventParams, options) {
    return (0, $32b319a9aeeb1338$export$1050f835b63b671e)(this, void 0, void 0, function() {
        var measurementId, params;
        return (0, $32b319a9aeeb1338$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (!(options && options.global)) return [
                        3 /*break*/ ,
                        1
                    ];
                    gtagFunction($4e360e3617ed619f$var$GtagCommand.EVENT, eventName, eventParams);
                    return [
                        2 /*return*/ 
                    ];
                case 1:
                    return [
                        4 /*yield*/ ,
                        initializationPromise
                    ];
                case 2:
                    measurementId = _a.sent();
                    params = (0, $32b319a9aeeb1338$export$18ce0697a983be9b)((0, $32b319a9aeeb1338$export$18ce0697a983be9b)({}, eventParams), {
                        "send_to": measurementId
                    });
                    gtagFunction($4e360e3617ed619f$var$GtagCommand.EVENT, eventName, params);
                    _a.label = 3;
                case 3:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
/**
 * Set screen_name parameter for this Google Analytics ID.
 *
 * @param gtagFunction Wrapped gtag function that waits for fid to be set before sending an event
 * @param screenName Screen name string to set.
 */ function $4e360e3617ed619f$var$setCurrentScreen(gtagFunction, initializationPromise, screenName, options) {
    return (0, $32b319a9aeeb1338$export$1050f835b63b671e)(this, void 0, void 0, function() {
        var measurementId;
        return (0, $32b319a9aeeb1338$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (!(options && options.global)) return [
                        3 /*break*/ ,
                        1
                    ];
                    gtagFunction($4e360e3617ed619f$var$GtagCommand.SET, {
                        "screen_name": screenName
                    });
                    return [
                        2 /*return*/ ,
                        Promise.resolve()
                    ];
                case 1:
                    return [
                        4 /*yield*/ ,
                        initializationPromise
                    ];
                case 2:
                    measurementId = _a.sent();
                    gtagFunction($4e360e3617ed619f$var$GtagCommand.CONFIG, measurementId, {
                        update: true,
                        "screen_name": screenName
                    });
                    _a.label = 3;
                case 3:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
/**
 * Set user_id parameter for this Google Analytics ID.
 *
 * @param gtagFunction Wrapped gtag function that waits for fid to be set before sending an event
 * @param id User ID string to set
 */ function $4e360e3617ed619f$var$setUserId(gtagFunction, initializationPromise, id, options) {
    return (0, $32b319a9aeeb1338$export$1050f835b63b671e)(this, void 0, void 0, function() {
        var measurementId;
        return (0, $32b319a9aeeb1338$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (!(options && options.global)) return [
                        3 /*break*/ ,
                        1
                    ];
                    gtagFunction($4e360e3617ed619f$var$GtagCommand.SET, {
                        "user_id": id
                    });
                    return [
                        2 /*return*/ ,
                        Promise.resolve()
                    ];
                case 1:
                    return [
                        4 /*yield*/ ,
                        initializationPromise
                    ];
                case 2:
                    measurementId = _a.sent();
                    gtagFunction($4e360e3617ed619f$var$GtagCommand.CONFIG, measurementId, {
                        update: true,
                        "user_id": id
                    });
                    _a.label = 3;
                case 3:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
/**
 * Set all other user properties other than user_id and screen_name.
 *
 * @param gtagFunction Wrapped gtag function that waits for fid to be set before sending an event
 * @param properties Map of user properties to set
 */ function $4e360e3617ed619f$var$setUserProperties(gtagFunction, initializationPromise, properties, options) {
    return (0, $32b319a9aeeb1338$export$1050f835b63b671e)(this, void 0, void 0, function() {
        var flatProperties, _i, _a, key, measurementId;
        return (0, $32b319a9aeeb1338$export$67ebef60e6f28a6)(this, function(_b) {
            switch(_b.label){
                case 0:
                    if (!(options && options.global)) return [
                        3 /*break*/ ,
                        1
                    ];
                    flatProperties = {};
                    for(_i = 0, _a = Object.keys(properties); _i < _a.length; _i++){
                        key = _a[_i];
                        // use dot notation for merge behavior in gtag.js
                        flatProperties["user_properties." + key] = properties[key];
                    }
                    gtagFunction($4e360e3617ed619f$var$GtagCommand.SET, flatProperties);
                    return [
                        2 /*return*/ ,
                        Promise.resolve()
                    ];
                case 1:
                    return [
                        4 /*yield*/ ,
                        initializationPromise
                    ];
                case 2:
                    measurementId = _b.sent();
                    gtagFunction($4e360e3617ed619f$var$GtagCommand.CONFIG, measurementId, {
                        update: true,
                        "user_properties": properties
                    });
                    _b.label = 3;
                case 3:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
/**
 * Set whether collection is enabled for this ID.
 *
 * @param enabled If true, collection is enabled for this ID.
 */ function $4e360e3617ed619f$var$setAnalyticsCollectionEnabled(initializationPromise, enabled) {
    return (0, $32b319a9aeeb1338$export$1050f835b63b671e)(this, void 0, void 0, function() {
        var measurementId;
        return (0, $32b319a9aeeb1338$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        initializationPromise
                    ];
                case 1:
                    measurementId = _a.sent();
                    window["ga-disable-" + measurementId] = !enabled;
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $4e360e3617ed619f$var$logger = new (0, $d4M6f.Logger)("@firebase/analytics");
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Inserts gtag script tag into the page to asynchronously download gtag.
 * @param dataLayerName Name of datalayer (most often the default, "_dataLayer").
 */ function $4e360e3617ed619f$var$insertScriptTag(dataLayerName) {
    var script = document.createElement("script");
    // We are not providing an analyticsId in the URL because it would trigger a `page_view`
    // without fid. We will initialize ga-id using gtag (config) command together with fid.
    script.src = $4e360e3617ed619f$var$GTAG_URL + "?l=" + dataLayerName;
    script.async = true;
    document.head.appendChild(script);
}
/**
 * Get reference to, or create, global datalayer.
 * @param dataLayerName Name of datalayer (most often the default, "_dataLayer").
 */ function $4e360e3617ed619f$var$getOrCreateDataLayer(dataLayerName) {
    // Check for existing dataLayer and create if needed.
    var dataLayer = [];
    if (Array.isArray(window[dataLayerName])) dataLayer = window[dataLayerName];
    else window[dataLayerName] = dataLayer;
    return dataLayer;
}
/**
 * Wrapped gtag logic when gtag is called with 'config' command.
 *
 * @param gtagCore Basic gtag function that just appends to dataLayer.
 * @param initializationPromisesMap Map of appIds to their initialization promises.
 * @param dynamicConfigPromisesList Array of dynamic config fetch promises.
 * @param measurementIdToAppId Map of GA measurementIDs to corresponding Firebase appId.
 * @param measurementId GA Measurement ID to set config for.
 * @param gtagParams Gtag config params to set.
 */ function $4e360e3617ed619f$var$gtagOnConfig(gtagCore, initializationPromisesMap, dynamicConfigPromisesList, measurementIdToAppId, measurementId, gtagParams) {
    return (0, $32b319a9aeeb1338$export$1050f835b63b671e)(this, void 0, void 0, function() {
        var correspondingAppId, dynamicConfigResults, foundConfig, e_1;
        return (0, $32b319a9aeeb1338$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    correspondingAppId = measurementIdToAppId[measurementId];
                    _a.label = 1;
                case 1:
                    _a.trys.push([
                        1,
                        7,
                        ,
                        8
                    ]);
                    if (!correspondingAppId) return [
                        3 /*break*/ ,
                        3
                    ];
                    return [
                        4 /*yield*/ ,
                        initializationPromisesMap[correspondingAppId]
                    ];
                case 2:
                    _a.sent();
                    return [
                        3 /*break*/ ,
                        6
                    ];
                case 3:
                    return [
                        4 /*yield*/ ,
                        Promise.all(dynamicConfigPromisesList)
                    ];
                case 4:
                    dynamicConfigResults = _a.sent();
                    foundConfig = dynamicConfigResults.find(function(config) {
                        return config.measurementId === measurementId;
                    });
                    if (!foundConfig) return [
                        3 /*break*/ ,
                        6
                    ];
                    return [
                        4 /*yield*/ ,
                        initializationPromisesMap[foundConfig.appId]
                    ];
                case 5:
                    _a.sent();
                    _a.label = 6;
                case 6:
                    return [
                        3 /*break*/ ,
                        8
                    ];
                case 7:
                    e_1 = _a.sent();
                    $4e360e3617ed619f$var$logger.error(e_1);
                    return [
                        3 /*break*/ ,
                        8
                    ];
                case 8:
                    gtagCore($4e360e3617ed619f$var$GtagCommand.CONFIG, measurementId, gtagParams);
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
/**
 * Wrapped gtag logic when gtag is called with 'event' command.
 *
 * @param gtagCore Basic gtag function that just appends to dataLayer.
 * @param initializationPromisesMap Map of appIds to their initialization promises.
 * @param dynamicConfigPromisesList Array of dynamic config fetch promises.
 * @param measurementId GA Measurement ID to log event to.
 * @param gtagParams Params to log with this event.
 */ function $4e360e3617ed619f$var$gtagOnEvent(gtagCore, initializationPromisesMap, dynamicConfigPromisesList, measurementId, gtagParams) {
    return (0, $32b319a9aeeb1338$export$1050f835b63b671e)(this, void 0, void 0, function() {
        var initializationPromisesToWaitFor, gaSendToList, dynamicConfigResults, _loop_1, _i, gaSendToList_1, sendToId, state_1, e_2;
        return (0, $32b319a9aeeb1338$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    _a.trys.push([
                        0,
                        4,
                        ,
                        5
                    ]);
                    initializationPromisesToWaitFor = [];
                    if (!(gtagParams && gtagParams["send_to"])) return [
                        3 /*break*/ ,
                        2
                    ];
                    gaSendToList = gtagParams["send_to"];
                    // Make it an array if is isn't, so it can be dealt with the same way.
                    if (!Array.isArray(gaSendToList)) gaSendToList = [
                        gaSendToList
                    ];
                    return [
                        4 /*yield*/ ,
                        Promise.all(dynamicConfigPromisesList)
                    ];
                case 1:
                    dynamicConfigResults = _a.sent();
                    _loop_1 = function(sendToId) {
                        // Any fetched dynamic measurement ID that matches this 'send_to' ID
                        var foundConfig = dynamicConfigResults.find(function(config) {
                            return config.measurementId === sendToId;
                        });
                        var initializationPromise = foundConfig && initializationPromisesMap[foundConfig.appId];
                        if (initializationPromise) initializationPromisesToWaitFor.push(initializationPromise);
                        else {
                            // Found an item in 'send_to' that is not associated
                            // directly with an FID, possibly a group.  Empty this array,
                            // exit the loop early, and let it get populated below.
                            initializationPromisesToWaitFor = [];
                            return "break";
                        }
                    };
                    for(_i = 0, gaSendToList_1 = gaSendToList; _i < gaSendToList_1.length; _i++){
                        sendToId = gaSendToList_1[_i];
                        state_1 = _loop_1(sendToId);
                        if (state_1 === "break") break;
                    }
                    _a.label = 2;
                case 2:
                    // This will be unpopulated if there was no 'send_to' field , or
                    // if not all entries in the 'send_to' field could be mapped to
                    // a FID. In these cases, wait on all pending initialization promises.
                    if (initializationPromisesToWaitFor.length === 0) initializationPromisesToWaitFor = Object.values(initializationPromisesMap);
                    // Run core gtag function with args after all relevant initialization
                    // promises have been resolved.
                    return [
                        4 /*yield*/ ,
                        Promise.all(initializationPromisesToWaitFor)
                    ];
                case 3:
                    // Run core gtag function with args after all relevant initialization
                    // promises have been resolved.
                    _a.sent();
                    // Workaround for http://b/141370449 - third argument cannot be undefined.
                    gtagCore($4e360e3617ed619f$var$GtagCommand.EVENT, measurementId, gtagParams || {});
                    return [
                        3 /*break*/ ,
                        5
                    ];
                case 4:
                    e_2 = _a.sent();
                    $4e360e3617ed619f$var$logger.error(e_2);
                    return [
                        3 /*break*/ ,
                        5
                    ];
                case 5:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
/**
 * Wraps a standard gtag function with extra code to wait for completion of
 * relevant initialization promises before sending requests.
 *
 * @param gtagCore Basic gtag function that just appends to dataLayer.
 * @param initializationPromisesMap Map of appIds to their initialization promises.
 * @param dynamicConfigPromisesList Array of dynamic config fetch promises.
 * @param measurementIdToAppId Map of GA measurementIDs to corresponding Firebase appId.
 */ function $4e360e3617ed619f$var$wrapGtag(gtagCore, /**
 * Allows wrapped gtag calls to wait on whichever intialization promises are required,
 * depending on the contents of the gtag params' `send_to` field, if any.
 */ initializationPromisesMap, /**
 * Wrapped gtag calls sometimes require all dynamic config fetches to have returned
 * before determining what initialization promises (which include FIDs) to wait for.
 */ dynamicConfigPromisesList, /**
 * Wrapped gtag config calls can narrow down which initialization promise (with FID)
 * to wait for if the measurementId is already fetched, by getting the corresponding appId,
 * which is the key for the initialization promises map.
 */ measurementIdToAppId) {
    /**
     * Wrapper around gtag that ensures FID is sent with gtag calls.
     * @param command Gtag command type.
     * @param idOrNameOrParams Measurement ID if command is EVENT/CONFIG, params if command is SET.
     * @param gtagParams Params if event is EVENT/CONFIG.
     */ function gtagWrapper(command, idOrNameOrParams, gtagParams) {
        return (0, $32b319a9aeeb1338$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var e_3;
            return (0, $32b319a9aeeb1338$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            6,
                            ,
                            7
                        ]);
                        if (!(command === $4e360e3617ed619f$var$GtagCommand.EVENT)) return [
                            3 /*break*/ ,
                            2
                        ];
                        // If EVENT, second arg must be measurementId.
                        return [
                            4 /*yield*/ ,
                            $4e360e3617ed619f$var$gtagOnEvent(gtagCore, initializationPromisesMap, dynamicConfigPromisesList, idOrNameOrParams, gtagParams)
                        ];
                    case 1:
                        // If EVENT, second arg must be measurementId.
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 2:
                        if (!(command === $4e360e3617ed619f$var$GtagCommand.CONFIG)) return [
                            3 /*break*/ ,
                            4
                        ];
                        // If CONFIG, second arg must be measurementId.
                        return [
                            4 /*yield*/ ,
                            $4e360e3617ed619f$var$gtagOnConfig(gtagCore, initializationPromisesMap, dynamicConfigPromisesList, measurementIdToAppId, idOrNameOrParams, gtagParams)
                        ];
                    case 3:
                        // If CONFIG, second arg must be measurementId.
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 4:
                        // If SET, second arg must be params.
                        gtagCore($4e360e3617ed619f$var$GtagCommand.SET, idOrNameOrParams);
                        _a.label = 5;
                    case 5:
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 6:
                        e_3 = _a.sent();
                        $4e360e3617ed619f$var$logger.error(e_3);
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 7:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    }
    return gtagWrapper;
}
/**
 * Creates global gtag function or wraps existing one if found.
 * This wrapped function attaches Firebase instance ID (FID) to gtag 'config' and
 * 'event' calls that belong to the GAID associated with this Firebase instance.
 *
 * @param initializationPromisesMap Map of appIds to their initialization promises.
 * @param dynamicConfigPromisesList Array of dynamic config fetch promises.
 * @param measurementIdToAppId Map of GA measurementIDs to corresponding Firebase appId.
 * @param dataLayerName Name of global GA datalayer array.
 * @param gtagFunctionName Name of global gtag function ("gtag" if not user-specified).
 */ function $4e360e3617ed619f$var$wrapOrCreateGtag(initializationPromisesMap, dynamicConfigPromisesList, measurementIdToAppId, dataLayerName, gtagFunctionName) {
    // Create a basic core gtag function
    var gtagCore = function() {
        var _args = [];
        for(var _i = 0; _i < arguments.length; _i++)_args[_i] = arguments[_i];
        // Must push IArguments object, not an array.
        window[dataLayerName].push(arguments);
    };
    // Replace it with existing one if found
    if (window[gtagFunctionName] && typeof window[gtagFunctionName] === "function") // @ts-ignore
    gtagCore = window[gtagFunctionName];
    window[gtagFunctionName] = $4e360e3617ed619f$var$wrapGtag(gtagCore, initializationPromisesMap, dynamicConfigPromisesList, measurementIdToAppId);
    return {
        gtagCore: gtagCore,
        wrappedGtag: window[gtagFunctionName]
    };
}
/**
 * Returns first script tag in DOM matching our gtag url pattern.
 */ function $4e360e3617ed619f$var$findGtagScriptOnPage() {
    var scriptTags = window.document.getElementsByTagName("script");
    for(var _i = 0, _a = Object.values(scriptTags); _i < _a.length; _i++){
        var tag = _a[_i];
        if (tag.src && tag.src.includes($4e360e3617ed619f$var$GTAG_URL)) return tag;
    }
    return null;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $4e360e3617ed619f$var$_a;
var $4e360e3617ed619f$var$ERRORS = ($4e360e3617ed619f$var$_a = {}, $4e360e3617ed619f$var$_a["already-exists" /* ALREADY_EXISTS */ ] = "A Firebase Analytics instance with the appId {$id}  already exists. Only one Firebase Analytics instance can be created for each appId.", $4e360e3617ed619f$var$_a["already-initialized" /* ALREADY_INITIALIZED */ ] = "Firebase Analytics has already been initialized.settings() must be called before initializing any Analytics instanceor it will have no effect.", $4e360e3617ed619f$var$_a["interop-component-reg-failed" /* INTEROP_COMPONENT_REG_FAILED */ ] = "Firebase Analytics Interop Component failed to instantiate: {$reason}", $4e360e3617ed619f$var$_a["invalid-analytics-context" /* INVALID_ANALYTICS_CONTEXT */ ] = "Firebase Analytics is not supported in this environment. Wrap initialization of analytics in analytics.isSupported() to prevent initialization in unsupported environments. Details: {$errorInfo}", $4e360e3617ed619f$var$_a["indexeddb-unavailable" /* INDEXEDDB_UNAVAILABLE */ ] = "IndexedDB unavailable or restricted in this environment. Wrap initialization of analytics in analytics.isSupported() to prevent initialization in unsupported environments. Details: {$errorInfo}", $4e360e3617ed619f$var$_a["fetch-throttle" /* FETCH_THROTTLE */ ] = "The config fetch request timed out while in an exponential backoff state. Unix timestamp in milliseconds when fetch request throttling ends: {$throttleEndTimeMillis}.", $4e360e3617ed619f$var$_a["config-fetch-failed" /* CONFIG_FETCH_FAILED */ ] = "Dynamic config fetch failed: [{$httpStatus}] {$responseMessage}", $4e360e3617ed619f$var$_a["no-api-key" /* NO_API_KEY */ ] = 'The "apiKey" field is empty in the local Firebase config. Firebase Analytics requires this field tocontain a valid API key.', $4e360e3617ed619f$var$_a["no-app-id" /* NO_APP_ID */ ] = 'The "appId" field is empty in the local Firebase config. Firebase Analytics requires this field tocontain a valid app ID.', $4e360e3617ed619f$var$_a);
var $4e360e3617ed619f$var$ERROR_FACTORY = new (0, $01sTD.ErrorFactory)("analytics", "Analytics", $4e360e3617ed619f$var$ERRORS);
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Backoff factor for 503 errors, which we want to be conservative about
 * to avoid overloading servers. Each retry interval will be
 * BASE_INTERVAL_MILLIS * LONG_RETRY_FACTOR ^ retryCount, so the second one
 * will be ~30 seconds (with fuzzing).
 */ var $4e360e3617ed619f$var$LONG_RETRY_FACTOR = 30;
/**
 * Base wait interval to multiplied by backoffFactor^backoffCount.
 */ var $4e360e3617ed619f$var$BASE_INTERVAL_MILLIS = 1000;
/**
 * Stubbable retry data storage class.
 */ var $4e360e3617ed619f$var$RetryData = /** @class */ function() {
    function RetryData(throttleMetadata, intervalMillis) {
        if (throttleMetadata === void 0) throttleMetadata = {};
        if (intervalMillis === void 0) intervalMillis = $4e360e3617ed619f$var$BASE_INTERVAL_MILLIS;
        this.throttleMetadata = throttleMetadata;
        this.intervalMillis = intervalMillis;
    }
    RetryData.prototype.getThrottleMetadata = function(appId) {
        return this.throttleMetadata[appId];
    };
    RetryData.prototype.setThrottleMetadata = function(appId, metadata) {
        this.throttleMetadata[appId] = metadata;
    };
    RetryData.prototype.deleteThrottleMetadata = function(appId) {
        delete this.throttleMetadata[appId];
    };
    return RetryData;
}();
var $4e360e3617ed619f$var$defaultRetryData = new $4e360e3617ed619f$var$RetryData();
/**
 * Set GET request headers.
 * @param apiKey App API key.
 */ function $4e360e3617ed619f$var$getHeaders(apiKey) {
    return new Headers({
        Accept: "application/json",
        "x-goog-api-key": apiKey
    });
}
/**
 * Fetches dynamic config from backend.
 * @param app Firebase app to fetch config for.
 */ function $4e360e3617ed619f$var$fetchDynamicConfig(appFields) {
    var _a;
    return (0, $32b319a9aeeb1338$export$1050f835b63b671e)(this, void 0, void 0, function() {
        var appId, apiKey, request, appUrl, response, errorMessage, jsonResponse, _ignored_1;
        return (0, $32b319a9aeeb1338$export$67ebef60e6f28a6)(this, function(_b) {
            switch(_b.label){
                case 0:
                    appId = appFields.appId, apiKey = appFields.apiKey;
                    request = {
                        method: "GET",
                        headers: $4e360e3617ed619f$var$getHeaders(apiKey)
                    };
                    appUrl = $4e360e3617ed619f$var$DYNAMIC_CONFIG_URL.replace("{app-id}", appId);
                    return [
                        4 /*yield*/ ,
                        fetch(appUrl, request)
                    ];
                case 1:
                    response = _b.sent();
                    if (!(response.status !== 200 && response.status !== 304)) return [
                        3 /*break*/ ,
                        6
                    ];
                    errorMessage = "";
                    _b.label = 2;
                case 2:
                    _b.trys.push([
                        2,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4 /*yield*/ ,
                        response.json()
                    ];
                case 3:
                    jsonResponse = _b.sent();
                    if ((_a = jsonResponse.error) === null || _a === void 0 ? void 0 : _a.message) errorMessage = jsonResponse.error.message;
                    return [
                        3 /*break*/ ,
                        5
                    ];
                case 4:
                    _ignored_1 = _b.sent();
                    return [
                        3 /*break*/ ,
                        5
                    ];
                case 5:
                    throw $4e360e3617ed619f$var$ERROR_FACTORY.create("config-fetch-failed" /* CONFIG_FETCH_FAILED */ , {
                        httpStatus: response.status,
                        responseMessage: errorMessage
                    });
                case 6:
                    return [
                        2 /*return*/ ,
                        response.json()
                    ];
            }
        });
    });
}
/**
 * Fetches dynamic config from backend, retrying if failed.
 * @param app Firebase app to fetch config for.
 */ function $4e360e3617ed619f$var$fetchDynamicConfigWithRetry(app, // retryData and timeoutMillis are parameterized to allow passing a different value for testing.
retryData, timeoutMillis) {
    if (retryData === void 0) retryData = $4e360e3617ed619f$var$defaultRetryData;
    return (0, $32b319a9aeeb1338$export$1050f835b63b671e)(this, void 0, void 0, function() {
        var _a, appId, apiKey, measurementId, throttleMetadata, signal;
        var _this = this;
        return (0, $32b319a9aeeb1338$export$67ebef60e6f28a6)(this, function(_b) {
            _a = app.options, appId = _a.appId, apiKey = _a.apiKey, measurementId = _a.measurementId;
            if (!appId) throw $4e360e3617ed619f$var$ERROR_FACTORY.create("no-app-id" /* NO_APP_ID */ );
            if (!apiKey) {
                if (measurementId) return [
                    2 /*return*/ ,
                    {
                        measurementId: measurementId,
                        appId: appId
                    }
                ];
                throw $4e360e3617ed619f$var$ERROR_FACTORY.create("no-api-key" /* NO_API_KEY */ );
            }
            throttleMetadata = retryData.getThrottleMetadata(appId) || {
                backoffCount: 0,
                throttleEndTimeMillis: Date.now()
            };
            signal = new $4e360e3617ed619f$var$AnalyticsAbortSignal();
            setTimeout(function() {
                return (0, $32b319a9aeeb1338$export$1050f835b63b671e)(_this, void 0, void 0, function() {
                    return (0, $32b319a9aeeb1338$export$67ebef60e6f28a6)(this, function(_a) {
                        // Note a very low delay, eg < 10ms, can elapse before listeners are initialized.
                        signal.abort();
                        return [
                            2 /*return*/ 
                        ];
                    });
                });
            }, timeoutMillis !== undefined ? timeoutMillis : $4e360e3617ed619f$var$FETCH_TIMEOUT_MILLIS);
            return [
                2 /*return*/ ,
                $4e360e3617ed619f$var$attemptFetchDynamicConfigWithRetry({
                    appId: appId,
                    apiKey: apiKey,
                    measurementId: measurementId
                }, throttleMetadata, signal, retryData)
            ];
        });
    });
}
/**
 * Runs one retry attempt.
 * @param appFields Necessary app config fields.
 * @param throttleMetadata Ongoing metadata to determine throttling times.
 * @param signal Abort signal.
 */ function $4e360e3617ed619f$var$attemptFetchDynamicConfigWithRetry(appFields, _a, signal, retryData // for testing
) {
    var throttleEndTimeMillis = _a.throttleEndTimeMillis, backoffCount = _a.backoffCount;
    if (retryData === void 0) retryData = $4e360e3617ed619f$var$defaultRetryData;
    return (0, $32b319a9aeeb1338$export$1050f835b63b671e)(this, void 0, void 0, function() {
        var appId, measurementId, e_1, response, e_2, backoffMillis, throttleMetadata;
        return (0, $32b319a9aeeb1338$export$67ebef60e6f28a6)(this, function(_b) {
            switch(_b.label){
                case 0:
                    appId = appFields.appId, measurementId = appFields.measurementId;
                    _b.label = 1;
                case 1:
                    _b.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4 /*yield*/ ,
                        $4e360e3617ed619f$var$setAbortableTimeout(signal, throttleEndTimeMillis)
                    ];
                case 2:
                    _b.sent();
                    return [
                        3 /*break*/ ,
                        4
                    ];
                case 3:
                    e_1 = _b.sent();
                    if (measurementId) {
                        $4e360e3617ed619f$var$logger.warn("Timed out fetching this Firebase app's measurement ID from the server." + (" Falling back to the measurement ID " + measurementId) + (' provided in the "measurementId" field in the local Firebase config. [' + e_1.message + "]"));
                        return [
                            2 /*return*/ ,
                            {
                                appId: appId,
                                measurementId: measurementId
                            }
                        ];
                    }
                    throw e_1;
                case 4:
                    _b.trys.push([
                        4,
                        6,
                        ,
                        7
                    ]);
                    return [
                        4 /*yield*/ ,
                        $4e360e3617ed619f$var$fetchDynamicConfig(appFields)
                    ];
                case 5:
                    response = _b.sent();
                    // Note the SDK only clears throttle state if response is success or non-retriable.
                    retryData.deleteThrottleMetadata(appId);
                    return [
                        2 /*return*/ ,
                        response
                    ];
                case 6:
                    e_2 = _b.sent();
                    if (!$4e360e3617ed619f$var$isRetriableError(e_2)) {
                        retryData.deleteThrottleMetadata(appId);
                        if (measurementId) {
                            $4e360e3617ed619f$var$logger.warn("Failed to fetch this Firebase app's measurement ID from the server." + (" Falling back to the measurement ID " + measurementId) + (' provided in the "measurementId" field in the local Firebase config. [' + e_2.message + "]"));
                            return [
                                2 /*return*/ ,
                                {
                                    appId: appId,
                                    measurementId: measurementId
                                }
                            ];
                        } else throw e_2;
                    }
                    backoffMillis = Number(e_2.httpStatus) === 503 ? (0, $01sTD.calculateBackoffMillis)(backoffCount, retryData.intervalMillis, $4e360e3617ed619f$var$LONG_RETRY_FACTOR) : (0, $01sTD.calculateBackoffMillis)(backoffCount, retryData.intervalMillis);
                    throttleMetadata = {
                        throttleEndTimeMillis: Date.now() + backoffMillis,
                        backoffCount: backoffCount + 1
                    };
                    // Persists state.
                    retryData.setThrottleMetadata(appId, throttleMetadata);
                    $4e360e3617ed619f$var$logger.debug("Calling attemptFetch again in " + backoffMillis + " millis");
                    return [
                        2 /*return*/ ,
                        $4e360e3617ed619f$var$attemptFetchDynamicConfigWithRetry(appFields, throttleMetadata, signal, retryData)
                    ];
                case 7:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
/**
 * Supports waiting on a backoff by:
 *
 * <ul>
 *   <li>Promisifying setTimeout, so we can set a timeout in our Promise chain</li>
 *   <li>Listening on a signal bus for abort events, just like the Fetch API</li>
 *   <li>Failing in the same way the Fetch API fails, so timing out a live request and a throttled
 *       request appear the same.</li>
 * </ul>
 *
 * <p>Visible for testing.
 */ function $4e360e3617ed619f$var$setAbortableTimeout(signal, throttleEndTimeMillis) {
    return new Promise(function(resolve, reject) {
        // Derives backoff from given end time, normalizing negative numbers to zero.
        var backoffMillis = Math.max(throttleEndTimeMillis - Date.now(), 0);
        var timeout = setTimeout(resolve, backoffMillis);
        // Adds listener, rather than sets onabort, because signal is a shared object.
        signal.addEventListener(function() {
            clearTimeout(timeout);
            // If the request completes before this timeout, the rejection has no effect.
            reject($4e360e3617ed619f$var$ERROR_FACTORY.create("fetch-throttle" /* FETCH_THROTTLE */ , {
                throttleEndTimeMillis: throttleEndTimeMillis
            }));
        });
    });
}
/**
 * Returns true if the {@link Error} indicates a fetch request may succeed later.
 */ function $4e360e3617ed619f$var$isRetriableError(e) {
    if (!(e instanceof (0, $01sTD.FirebaseError))) return false;
    // Uses string index defined by ErrorData, which FirebaseError implements.
    var httpStatus = Number(e["httpStatus"]);
    return httpStatus === 429 || httpStatus === 500 || httpStatus === 503 || httpStatus === 504;
}
/**
 * Shims a minimal AbortSignal (copied from Remote Config).
 *
 * <p>AbortController's AbortSignal conveniently decouples fetch timeout logic from other aspects
 * of networking, such as retries. Firebase doesn't use AbortController enough to justify a
 * polyfill recommendation, like we do with the Fetch API, but this minimal shim can easily be
 * swapped out if/when we do.
 */ var $4e360e3617ed619f$var$AnalyticsAbortSignal = /** @class */ function() {
    function AnalyticsAbortSignal() {
        this.listeners = [];
    }
    AnalyticsAbortSignal.prototype.addEventListener = function(listener) {
        this.listeners.push(listener);
    };
    AnalyticsAbortSignal.prototype.abort = function() {
        this.listeners.forEach(function(listener) {
            return listener();
        });
    };
    return AnalyticsAbortSignal;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $4e360e3617ed619f$var$validateIndexedDB() {
    return (0, $32b319a9aeeb1338$export$1050f835b63b671e)(this, void 0, void 0, function() {
        var e_1;
        return (0, $32b319a9aeeb1338$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (!!(0, $01sTD.isIndexedDBAvailable)()) return [
                        3 /*break*/ ,
                        1
                    ];
                    $4e360e3617ed619f$var$logger.warn($4e360e3617ed619f$var$ERROR_FACTORY.create("indexeddb-unavailable" /* INDEXEDDB_UNAVAILABLE */ , {
                        errorInfo: "IndexedDB is not available in this environment."
                    }).message);
                    return [
                        2 /*return*/ ,
                        false
                    ];
                case 1:
                    _a.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4 /*yield*/ ,
                        (0, $01sTD.validateIndexedDBOpenable)()
                    ];
                case 2:
                    _a.sent();
                    return [
                        3 /*break*/ ,
                        4
                    ];
                case 3:
                    e_1 = _a.sent();
                    $4e360e3617ed619f$var$logger.warn($4e360e3617ed619f$var$ERROR_FACTORY.create("indexeddb-unavailable" /* INDEXEDDB_UNAVAILABLE */ , {
                        errorInfo: e_1
                    }).message);
                    return [
                        2 /*return*/ ,
                        false
                    ];
                case 4:
                    return [
                        2 /*return*/ ,
                        true
                    ];
            }
        });
    });
}
/**
 * Initialize the analytics instance in gtag.js by calling config command with fid.
 *
 * NOTE: We combine analytics initialization and setting fid together because we want fid to be
 * part of the `page_view` event that's sent during the initialization
 * @param app Firebase app
 * @param gtagCore The gtag function that's not wrapped.
 * @param dynamicConfigPromisesList Array of all dynamic config promises.
 * @param measurementIdToAppId Maps measurementID to appID.
 * @param installations FirebaseInstallations instance.
 *
 * @returns Measurement ID.
 */ function $4e360e3617ed619f$var$initializeIds(app, dynamicConfigPromisesList, measurementIdToAppId, installations, gtagCore) {
    return (0, $32b319a9aeeb1338$export$1050f835b63b671e)(this, void 0, void 0, function() {
        var dynamicConfigPromise, fidPromise, _a, dynamicConfig, fid, configProperties;
        var _b;
        return (0, $32b319a9aeeb1338$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    dynamicConfigPromise = $4e360e3617ed619f$var$fetchDynamicConfigWithRetry(app);
                    // Once fetched, map measurementIds to appId, for ease of lookup in wrapped gtag function.
                    dynamicConfigPromise.then(function(config) {
                        measurementIdToAppId[config.measurementId] = config.appId;
                        if (app.options.measurementId && config.measurementId !== app.options.measurementId) $4e360e3617ed619f$var$logger.warn("The measurement ID in the local Firebase config (" + app.options.measurementId + ")" + (" does not match the measurement ID fetched from the server (" + config.measurementId + ").") + " To ensure analytics events are always sent to the correct Analytics property," + " update the" + " measurement ID field in the local config or remove it from the local config.");
                    }).catch(function(e) {
                        return $4e360e3617ed619f$var$logger.error(e);
                    });
                    // Add to list to track state of all dynamic config promises.
                    dynamicConfigPromisesList.push(dynamicConfigPromise);
                    fidPromise = $4e360e3617ed619f$var$validateIndexedDB().then(function(envIsValid) {
                        if (envIsValid) return installations.getId();
                        else return undefined;
                    });
                    return [
                        4 /*yield*/ ,
                        Promise.all([
                            dynamicConfigPromise,
                            fidPromise
                        ])
                    ];
                case 1:
                    _a = _c.sent(), dynamicConfig = _a[0], fid = _a[1];
                    // This command initializes gtag.js and only needs to be called once for the entire web app,
                    // but since it is idempotent, we can call it multiple times.
                    // We keep it together with other initialization logic for better code structure.
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    gtagCore("js", new Date());
                    configProperties = (_b = {}, // guard against developers accidentally setting properties with prefix `firebase_`
                    _b[$4e360e3617ed619f$var$ORIGIN_KEY] = "firebase", _b.update = true, _b);
                    if (fid != null) configProperties[$4e360e3617ed619f$var$GA_FID_KEY] = fid;
                    // It should be the first config command called on this GA-ID
                    // Initialize this GA-ID and set FID on it using the gtag config API.
                    gtagCore($4e360e3617ed619f$var$GtagCommand.CONFIG, dynamicConfig.measurementId, configProperties);
                    return [
                        2 /*return*/ ,
                        dynamicConfig.measurementId
                    ];
            }
        });
    });
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Maps appId to full initialization promise. Wrapped gtag calls must wait on
 * all or some of these, depending on the call's `send_to` param and the status
 * of the dynamic config fetches (see below).
 */ var $4e360e3617ed619f$var$initializationPromisesMap = {};
/**
 * List of dynamic config fetch promises. In certain cases, wrapped gtag calls
 * wait on all these to be complete in order to determine if it can selectively
 * wait for only certain initialization (FID) promises or if it must wait for all.
 */ var $4e360e3617ed619f$var$dynamicConfigPromisesList = [];
/**
 * Maps fetched measurementIds to appId. Populated when the app's dynamic config
 * fetch completes. If already populated, gtag config calls can use this to
 * selectively wait for only this app's initialization promise (FID) instead of all
 * initialization promises.
 */ var $4e360e3617ed619f$var$measurementIdToAppId = {};
/**
 * Name for window global data layer array used by GA: defaults to 'dataLayer'.
 */ var $4e360e3617ed619f$var$dataLayerName = "dataLayer";
/**
 * Name for window global gtag function used by GA: defaults to 'gtag'.
 */ var $4e360e3617ed619f$var$gtagName = "gtag";
/**
 * Reproduction of standard gtag function or reference to existing
 * gtag function on window object.
 */ var $4e360e3617ed619f$var$gtagCoreFunction;
/**
 * Wrapper around gtag function that ensures FID is sent with all
 * relevant event and config calls.
 */ var $4e360e3617ed619f$var$wrappedGtagFunction;
/**
 * Flag to ensure page initialization steps (creation or wrapping of
 * dataLayer and gtag script) are only run once per page load.
 */ var $4e360e3617ed619f$var$globalInitDone = false;
/**
 * For testing
 */ function $4e360e3617ed619f$export$779c8e482cefabc0(newGlobalInitDone, newInitializationPromisesMap, newDynamicPromises) {
    if (newGlobalInitDone === void 0) newGlobalInitDone = false;
    if (newInitializationPromisesMap === void 0) newInitializationPromisesMap = {};
    if (newDynamicPromises === void 0) newDynamicPromises = [];
    $4e360e3617ed619f$var$globalInitDone = newGlobalInitDone;
    $4e360e3617ed619f$var$initializationPromisesMap = newInitializationPromisesMap;
    $4e360e3617ed619f$var$dynamicConfigPromisesList = newDynamicPromises;
    $4e360e3617ed619f$var$dataLayerName = "dataLayer";
    $4e360e3617ed619f$var$gtagName = "gtag";
}
/**
 * For testing
 */ function $4e360e3617ed619f$export$8ff36dd5b0c87ca7() {
    return {
        initializationPromisesMap: $4e360e3617ed619f$var$initializationPromisesMap,
        dynamicConfigPromisesList: $4e360e3617ed619f$var$dynamicConfigPromisesList
    };
}
/**
 * This must be run before calling firebase.analytics() or it won't
 * have any effect.
 * @param options Custom gtag and dataLayer names.
 */ function $4e360e3617ed619f$export$a5a6e0b888b2c992(options) {
    if ($4e360e3617ed619f$var$globalInitDone) throw $4e360e3617ed619f$var$ERROR_FACTORY.create("already-initialized" /* ALREADY_INITIALIZED */ );
    if (options.dataLayerName) $4e360e3617ed619f$var$dataLayerName = options.dataLayerName;
    if (options.gtagName) $4e360e3617ed619f$var$gtagName = options.gtagName;
}
/**
 * Returns true if no environment mismatch is found.
 * If environment mismatches are found, throws an INVALID_ANALYTICS_CONTEXT
 * error that also lists details for each mismatch found.
 */ function $4e360e3617ed619f$var$warnOnBrowserContextMismatch() {
    var mismatchedEnvMessages = [];
    if ((0, $01sTD.isBrowserExtension)()) mismatchedEnvMessages.push("This is a browser extension environment.");
    if (!(0, $01sTD.areCookiesEnabled)()) mismatchedEnvMessages.push("Cookies are not available.");
    if (mismatchedEnvMessages.length > 0) {
        var details = mismatchedEnvMessages.map(function(message, index) {
            return "(" + (index + 1) + ") " + message;
        }).join(" ");
        var err = $4e360e3617ed619f$var$ERROR_FACTORY.create("invalid-analytics-context" /* INVALID_ANALYTICS_CONTEXT */ , {
            errorInfo: details
        });
        $4e360e3617ed619f$var$logger.warn(err.message);
    }
}
function $4e360e3617ed619f$export$e9008f2713103c6c(app, installations) {
    $4e360e3617ed619f$var$warnOnBrowserContextMismatch();
    var appId = app.options.appId;
    if (!appId) throw $4e360e3617ed619f$var$ERROR_FACTORY.create("no-app-id" /* NO_APP_ID */ );
    if (!app.options.apiKey) {
        if (app.options.measurementId) $4e360e3617ed619f$var$logger.warn('The "apiKey" field is empty in the local Firebase config. This is needed to fetch the latest' + (" measurement ID for this Firebase app. Falling back to the measurement ID " + app.options.measurementId) + ' provided in the "measurementId" field in the local Firebase config.');
        else throw $4e360e3617ed619f$var$ERROR_FACTORY.create("no-api-key" /* NO_API_KEY */ );
    }
    if ($4e360e3617ed619f$var$initializationPromisesMap[appId] != null) throw $4e360e3617ed619f$var$ERROR_FACTORY.create("already-exists" /* ALREADY_EXISTS */ , {
        id: appId
    });
    if (!$4e360e3617ed619f$var$globalInitDone) {
        // Steps here should only be done once per page: creation or wrapping
        // of dataLayer and global gtag function.
        // Detect if user has already put the gtag <script> tag on this page.
        if (!$4e360e3617ed619f$var$findGtagScriptOnPage()) $4e360e3617ed619f$var$insertScriptTag($4e360e3617ed619f$var$dataLayerName);
        $4e360e3617ed619f$var$getOrCreateDataLayer($4e360e3617ed619f$var$dataLayerName);
        var _a = $4e360e3617ed619f$var$wrapOrCreateGtag($4e360e3617ed619f$var$initializationPromisesMap, $4e360e3617ed619f$var$dynamicConfigPromisesList, $4e360e3617ed619f$var$measurementIdToAppId, $4e360e3617ed619f$var$dataLayerName, $4e360e3617ed619f$var$gtagName), wrappedGtag = _a.wrappedGtag, gtagCore = _a.gtagCore;
        $4e360e3617ed619f$var$wrappedGtagFunction = wrappedGtag;
        $4e360e3617ed619f$var$gtagCoreFunction = gtagCore;
        $4e360e3617ed619f$var$globalInitDone = true;
    }
    // Async but non-blocking.
    // This map reflects the completion state of all promises for each appId.
    $4e360e3617ed619f$var$initializationPromisesMap[appId] = $4e360e3617ed619f$var$initializeIds(app, $4e360e3617ed619f$var$dynamicConfigPromisesList, $4e360e3617ed619f$var$measurementIdToAppId, installations, $4e360e3617ed619f$var$gtagCoreFunction);
    var analyticsInstance = {
        app: app,
        // Public methods return void for API simplicity and to better match gtag,
        // while internal implementations return promises.
        logEvent: function(eventName, eventParams, options) {
            $4e360e3617ed619f$var$logEvent($4e360e3617ed619f$var$wrappedGtagFunction, $4e360e3617ed619f$var$initializationPromisesMap[appId], eventName, eventParams, options).catch(function(e) {
                return $4e360e3617ed619f$var$logger.error(e);
            });
        },
        setCurrentScreen: function(screenName, options) {
            $4e360e3617ed619f$var$setCurrentScreen($4e360e3617ed619f$var$wrappedGtagFunction, $4e360e3617ed619f$var$initializationPromisesMap[appId], screenName, options).catch(function(e) {
                return $4e360e3617ed619f$var$logger.error(e);
            });
        },
        setUserId: function(id, options) {
            $4e360e3617ed619f$var$setUserId($4e360e3617ed619f$var$wrappedGtagFunction, $4e360e3617ed619f$var$initializationPromisesMap[appId], id, options).catch(function(e) {
                return $4e360e3617ed619f$var$logger.error(e);
            });
        },
        setUserProperties: function(properties, options) {
            $4e360e3617ed619f$var$setUserProperties($4e360e3617ed619f$var$wrappedGtagFunction, $4e360e3617ed619f$var$initializationPromisesMap[appId], properties, options).catch(function(e) {
                return $4e360e3617ed619f$var$logger.error(e);
            });
        },
        setAnalyticsCollectionEnabled: function(enabled) {
            $4e360e3617ed619f$var$setAnalyticsCollectionEnabled($4e360e3617ed619f$var$initializationPromisesMap[appId], enabled).catch(function(e) {
                return $4e360e3617ed619f$var$logger.error(e);
            });
        },
        INTERNAL: {
            delete: function() {
                delete $4e360e3617ed619f$var$initializationPromisesMap[appId];
                return Promise.resolve();
            }
        }
    };
    return analyticsInstance;
}
var $4e360e3617ed619f$var$name = "@firebase/analytics";
var $4e360e3617ed619f$var$version = "0.6.0";
/**
 * Type constant for Firebase Analytics.
 */ var $4e360e3617ed619f$var$ANALYTICS_TYPE = "analytics";
function $4e360e3617ed619f$export$7c804eebd0c1f2e0(instance) {
    instance.INTERNAL.registerComponent(new (0, $gLWqF.Component)($4e360e3617ed619f$var$ANALYTICS_TYPE, function(container) {
        // getImmediate for FirebaseApp will always succeed
        var app = container.getProvider("app").getImmediate();
        var installations = container.getProvider("installations").getImmediate();
        return $4e360e3617ed619f$export$e9008f2713103c6c(app, installations);
    }, "PUBLIC" /* PUBLIC */ ).setServiceProps({
        settings: $4e360e3617ed619f$export$a5a6e0b888b2c992,
        EventName: $4e360e3617ed619f$var$EventName,
        isSupported: $4e360e3617ed619f$var$isSupported
    }));
    instance.INTERNAL.registerComponent(new (0, $gLWqF.Component)("analytics-internal", internalFactory, "PRIVATE" /* PRIVATE */ ));
    instance.registerVersion($4e360e3617ed619f$var$name, $4e360e3617ed619f$var$version);
    function internalFactory(container) {
        try {
            var analytics = container.getProvider($4e360e3617ed619f$var$ANALYTICS_TYPE).getImmediate();
            return {
                logEvent: analytics.logEvent
            };
        } catch (e) {
            throw $4e360e3617ed619f$var$ERROR_FACTORY.create("interop-component-reg-failed" /* INTEROP_COMPONENT_REG_FAILED */ , {
                reason: e
            });
        }
    }
}
$4e360e3617ed619f$export$7c804eebd0c1f2e0((0, (/*@__PURE__*/$parcel$interopDefault($31dJ8))));
/**
 * this is a public static method provided to users that wraps four different checks:
 *
 * 1. check if it's not a browser extension environment.
 * 1. check if cookie is enabled in current browser.
 * 3. check if IndexedDB is supported by the browser environment.
 * 4. check if the current browser context is valid for using IndexedDB.
 *
 */ function $4e360e3617ed619f$var$isSupported() {
    return (0, $32b319a9aeeb1338$export$1050f835b63b671e)(this, void 0, void 0, function() {
        var isDBOpenable, error_1;
        return (0, $32b319a9aeeb1338$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if ((0, $01sTD.isBrowserExtension)()) return [
                        2 /*return*/ ,
                        false
                    ];
                    if (!(0, $01sTD.areCookiesEnabled)()) return [
                        2 /*return*/ ,
                        false
                    ];
                    if (!(0, $01sTD.isIndexedDBAvailable)()) return [
                        2 /*return*/ ,
                        false
                    ];
                    _a.label = 1;
                case 1:
                    _a.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4 /*yield*/ ,
                        (0, $01sTD.validateIndexedDBOpenable)()
                    ];
                case 2:
                    isDBOpenable = _a.sent();
                    return [
                        2 /*return*/ ,
                        isDBOpenable
                    ];
                case 3:
                    error_1 = _a.sent();
                    return [
                        2 /*return*/ ,
                        false
                    ];
                case 4:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}


var $9cb4abf729180141$exports = {};
"use strict";
Object.defineProperty($9cb4abf729180141$exports, "__esModule", {
    value: true
});

var $31dJ8 = parcelRequire("31dJ8");

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $d1c2b3d4871c1de3$var$extendStatics = function(d, b) {
    $d1c2b3d4871c1de3$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $d1c2b3d4871c1de3$var$extendStatics(d, b);
};
function $d1c2b3d4871c1de3$export$a8ba968b8961cb8a(d, b) {
    $d1c2b3d4871c1de3$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $d1c2b3d4871c1de3$export$18ce0697a983be9b = function() {
    $d1c2b3d4871c1de3$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $d1c2b3d4871c1de3$export$18ce0697a983be9b.apply(this, arguments);
};
function $d1c2b3d4871c1de3$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $d1c2b3d4871c1de3$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $d1c2b3d4871c1de3$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $d1c2b3d4871c1de3$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $d1c2b3d4871c1de3$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $d1c2b3d4871c1de3$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $d1c2b3d4871c1de3$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $d1c2b3d4871c1de3$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $d1c2b3d4871c1de3$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $d1c2b3d4871c1de3$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $d1c2b3d4871c1de3$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($d1c2b3d4871c1de3$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $d1c2b3d4871c1de3$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $d1c2b3d4871c1de3$export$10c90e4f7922046c(v) {
    return this instanceof $d1c2b3d4871c1de3$export$10c90e4f7922046c ? (this.v = v, this) : new $d1c2b3d4871c1de3$export$10c90e4f7922046c(v);
}
function $d1c2b3d4871c1de3$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $d1c2b3d4871c1de3$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $d1c2b3d4871c1de3$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $d1c2b3d4871c1de3$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $d1c2b3d4871c1de3$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $d1c2b3d4871c1de3$export$19a8beecd37a4c45 === "function" ? $d1c2b3d4871c1de3$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $d1c2b3d4871c1de3$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $d1c2b3d4871c1de3$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $d1c2b3d4871c1de3$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $d1c2b3d4871c1de3$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $d1c2b3d4871c1de3$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}



var $01sTD = parcelRequire("01sTD");

var $d4M6f = parcelRequire("d4M6f");

var $gLWqF = parcelRequire("gLWqF");
function $9cb4abf729180141$var$_interopDefaultLegacy(e) {
    return e && typeof e === "object" && "default" in e ? e : {
        "default": e
    };
}
var $9cb4abf729180141$var$firebase__default = /*#__PURE__*/ $9cb4abf729180141$var$_interopDefaultLegacy($31dJ8);
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Implements the {@link RemoteConfigClient} abstraction with success response caching.
 *
 * <p>Comparable to the browser's Cache API for responses, but the Cache API requires a Service
 * Worker, which requires HTTPS, which would significantly complicate SDK installation. Also, the
 * Cache API doesn't support matching entries by time.
 */ var $9cb4abf729180141$var$CachingClient = /** @class */ function() {
    function CachingClient(client, storage, storageCache, logger) {
        this.client = client;
        this.storage = storage;
        this.storageCache = storageCache;
        this.logger = logger;
    }
    /**
     * Returns true if the age of the cached fetched configs is less than or equal to
     * {@link Settings#minimumFetchIntervalInSeconds}.
     *
     * <p>This is comparable to passing `headers = { 'Cache-Control': max-age <maxAge> }` to the
     * native Fetch API.
     *
     * <p>Visible for testing.
     */ CachingClient.prototype.isCachedDataFresh = function(cacheMaxAgeMillis, lastSuccessfulFetchTimestampMillis) {
        // Cache can only be fresh if it's populated.
        if (!lastSuccessfulFetchTimestampMillis) {
            this.logger.debug("Config fetch cache check. Cache unpopulated.");
            return false;
        }
        // Calculates age of cache entry.
        var cacheAgeMillis = Date.now() - lastSuccessfulFetchTimestampMillis;
        var isCachedDataFresh = cacheAgeMillis <= cacheMaxAgeMillis;
        this.logger.debug("Config fetch cache check." + (" Cache age millis: " + cacheAgeMillis + ".") + (" Cache max age millis (minimumFetchIntervalMillis setting): " + cacheMaxAgeMillis + ".") + (" Is cache hit: " + isCachedDataFresh + "."));
        return isCachedDataFresh;
    };
    CachingClient.prototype.fetch = function(request) {
        return $d1c2b3d4871c1de3$export$1050f835b63b671e(this, void 0, void 0, function() {
            var _a, lastSuccessfulFetchTimestampMillis, lastSuccessfulFetchResponse, response, storageOperations;
            return $d1c2b3d4871c1de3$export$67ebef60e6f28a6(this, function(_b) {
                switch(_b.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            Promise.all([
                                this.storage.getLastSuccessfulFetchTimestampMillis(),
                                this.storage.getLastSuccessfulFetchResponse()
                            ])
                        ];
                    case 1:
                        _a = _b.sent(), lastSuccessfulFetchTimestampMillis = _a[0], lastSuccessfulFetchResponse = _a[1];
                        // Exits early on cache hit.
                        if (lastSuccessfulFetchResponse && this.isCachedDataFresh(request.cacheMaxAgeMillis, lastSuccessfulFetchTimestampMillis)) return [
                            2 /*return*/ ,
                            lastSuccessfulFetchResponse
                        ];
                        // Deviates from pure decorator by not honoring a passed ETag since we don't have a public API
                        // that allows the caller to pass an ETag.
                        request.eTag = lastSuccessfulFetchResponse && lastSuccessfulFetchResponse.eTag;
                        return [
                            4 /*yield*/ ,
                            this.client.fetch(request)
                        ];
                    case 2:
                        response = _b.sent();
                        storageOperations = [
                            // Uses write-through cache for consistency with synchronous public API.
                            this.storageCache.setLastSuccessfulFetchTimestampMillis(Date.now())
                        ];
                        if (response.status === 200) // Caches response only if it has changed, ie non-304 responses.
                        storageOperations.push(this.storage.setLastSuccessfulFetchResponse(response));
                        return [
                            4 /*yield*/ ,
                            Promise.all(storageOperations)
                        ];
                    case 3:
                        _b.sent();
                        return [
                            2 /*return*/ ,
                            response
                        ];
                }
            });
        });
    };
    return CachingClient;
}();
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $9cb4abf729180141$var$_a;
var $9cb4abf729180141$var$ERROR_DESCRIPTION_MAP = ($9cb4abf729180141$var$_a = {}, $9cb4abf729180141$var$_a["registration-window" /* REGISTRATION_WINDOW */ ] = "Undefined window object. This SDK only supports usage in a browser environment.", $9cb4abf729180141$var$_a["registration-project-id" /* REGISTRATION_PROJECT_ID */ ] = "Undefined project identifier. Check Firebase app initialization.", $9cb4abf729180141$var$_a["registration-api-key" /* REGISTRATION_API_KEY */ ] = "Undefined API key. Check Firebase app initialization.", $9cb4abf729180141$var$_a["registration-app-id" /* REGISTRATION_APP_ID */ ] = "Undefined app identifier. Check Firebase app initialization.", $9cb4abf729180141$var$_a["storage-open" /* STORAGE_OPEN */ ] = "Error thrown when opening storage. Original error: {$originalErrorMessage}.", $9cb4abf729180141$var$_a["storage-get" /* STORAGE_GET */ ] = "Error thrown when reading from storage. Original error: {$originalErrorMessage}.", $9cb4abf729180141$var$_a["storage-set" /* STORAGE_SET */ ] = "Error thrown when writing to storage. Original error: {$originalErrorMessage}.", $9cb4abf729180141$var$_a["storage-delete" /* STORAGE_DELETE */ ] = "Error thrown when deleting from storage. Original error: {$originalErrorMessage}.", $9cb4abf729180141$var$_a["fetch-client-network" /* FETCH_NETWORK */ ] = "Fetch client failed to connect to a network. Check Internet connection. Original error: {$originalErrorMessage}.", $9cb4abf729180141$var$_a["fetch-timeout" /* FETCH_TIMEOUT */ ] = 'The config fetch request timed out.  Configure timeout using "fetchTimeoutMillis" SDK setting.', $9cb4abf729180141$var$_a["fetch-throttle" /* FETCH_THROTTLE */ ] = 'The config fetch request timed out while in an exponential backoff state. Configure timeout using "fetchTimeoutMillis" SDK setting. Unix timestamp in milliseconds when fetch request throttling ends: {$throttleEndTimeMillis}.', $9cb4abf729180141$var$_a["fetch-client-parse" /* FETCH_PARSE */ ] = "Fetch client could not parse response. Original error: {$originalErrorMessage}.", $9cb4abf729180141$var$_a["fetch-status" /* FETCH_STATUS */ ] = "Fetch server returned an HTTP error status. HTTP status: {$httpStatus}.", $9cb4abf729180141$var$_a);
var $9cb4abf729180141$var$ERROR_FACTORY = new $01sTD.ErrorFactory("remoteconfig" /* service */ , "Remote Config" /* service name */ , $9cb4abf729180141$var$ERROR_DESCRIPTION_MAP);
// Note how this is like typeof/instanceof, but for ErrorCode.
function $9cb4abf729180141$var$hasErrorCode(e, errorCode) {
    return e instanceof $01sTD.FirebaseError && e.code.indexOf(errorCode) !== -1;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Attempts to get the most accurate browser language setting.
 *
 * <p>Adapted from getUserLanguage in packages/auth/src/utils.js for TypeScript.
 *
 * <p>Defers default language specification to server logic for consistency.
 *
 * @param navigatorLanguage Enables tests to override read-only {@link NavigatorLanguage}.
 */ function $9cb4abf729180141$var$getUserLanguage(navigatorLanguage) {
    if (navigatorLanguage === void 0) navigatorLanguage = navigator;
    return(// Most reliable, but only supported in Chrome/Firefox.
    navigatorLanguage.languages && navigatorLanguage.languages[0] || // Supported in most browsers, but returns the language of the browser
    // UI, not the language set in browser settings.
    navigatorLanguage.language);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Implements the Client abstraction for the Remote Config REST API.
 */ var $9cb4abf729180141$var$RestClient = /** @class */ function() {
    function RestClient(firebaseInstallations, sdkVersion, namespace, projectId, apiKey, appId) {
        this.firebaseInstallations = firebaseInstallations;
        this.sdkVersion = sdkVersion;
        this.namespace = namespace;
        this.projectId = projectId;
        this.apiKey = apiKey;
        this.appId = appId;
    }
    /**
     * Fetches from the Remote Config REST API.
     *
     * @throws a {@link ErrorCode.FETCH_NETWORK} error if {@link GlobalFetch#fetch} can't
     * connect to the network.
     * @throws a {@link ErrorCode.FETCH_PARSE} error if {@link Response#json} can't parse the
     * fetch response.
     * @throws a {@link ErrorCode.FETCH_STATUS} error if the service returns an HTTP error status.
     */ RestClient.prototype.fetch = function(request) {
        return $d1c2b3d4871c1de3$export$1050f835b63b671e(this, void 0, void 0, function() {
            var _a, installationId, installationToken, urlBase, url, headers, requestBody, options, fetchPromise, timeoutPromise, response, originalError_1, errorCode, status, responseEtag, config, state, responseBody, originalError_2;
            return $d1c2b3d4871c1de3$export$67ebef60e6f28a6(this, function(_b) {
                switch(_b.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            Promise.all([
                                this.firebaseInstallations.getId(),
                                this.firebaseInstallations.getToken()
                            ])
                        ];
                    case 1:
                        _a = _b.sent(), installationId = _a[0], installationToken = _a[1];
                        urlBase = window.FIREBASE_REMOTE_CONFIG_URL_BASE || "https://firebaseremoteconfig.googleapis.com";
                        url = urlBase + "/v1/projects/" + this.projectId + "/namespaces/" + this.namespace + ":fetch?key=" + this.apiKey;
                        headers = {
                            "Content-Type": "application/json",
                            "Content-Encoding": "gzip",
                            // Deviates from pure decorator by not passing max-age header since we don't currently have
                            // service behavior using that header.
                            "If-None-Match": request.eTag || "*"
                        };
                        requestBody = {
                            /* eslint-disable camelcase */ sdk_version: this.sdkVersion,
                            app_instance_id: installationId,
                            app_instance_id_token: installationToken,
                            app_id: this.appId,
                            language_code: $9cb4abf729180141$var$getUserLanguage()
                        };
                        options = {
                            method: "POST",
                            headers: headers,
                            body: JSON.stringify(requestBody)
                        };
                        fetchPromise = fetch(url, options);
                        timeoutPromise = new Promise(function(_resolve, reject) {
                            // Maps async event listener to Promise API.
                            request.signal.addEventListener(function() {
                                // Emulates https://heycam.github.io/webidl/#aborterror
                                var error = new Error("The operation was aborted.");
                                error.name = "AbortError";
                                reject(error);
                            });
                        });
                        _b.label = 2;
                    case 2:
                        _b.trys.push([
                            2,
                            5,
                            ,
                            6
                        ]);
                        return [
                            4 /*yield*/ ,
                            Promise.race([
                                fetchPromise,
                                timeoutPromise
                            ])
                        ];
                    case 3:
                        _b.sent();
                        return [
                            4 /*yield*/ ,
                            fetchPromise
                        ];
                    case 4:
                        response = _b.sent();
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 5:
                        originalError_1 = _b.sent();
                        errorCode = "fetch-client-network" /* FETCH_NETWORK */ ;
                        if (originalError_1.name === "AbortError") errorCode = "fetch-timeout" /* FETCH_TIMEOUT */ ;
                        throw $9cb4abf729180141$var$ERROR_FACTORY.create(errorCode, {
                            originalErrorMessage: originalError_1.message
                        });
                    case 6:
                        status = response.status;
                        responseEtag = response.headers.get("ETag") || undefined;
                        if (!(response.status === 200)) return [
                            3 /*break*/ ,
                            11
                        ];
                        responseBody = void 0;
                        _b.label = 7;
                    case 7:
                        _b.trys.push([
                            7,
                            9,
                            ,
                            10
                        ]);
                        return [
                            4 /*yield*/ ,
                            response.json()
                        ];
                    case 8:
                        responseBody = _b.sent();
                        return [
                            3 /*break*/ ,
                            10
                        ];
                    case 9:
                        originalError_2 = _b.sent();
                        throw $9cb4abf729180141$var$ERROR_FACTORY.create("fetch-client-parse" /* FETCH_PARSE */ , {
                            originalErrorMessage: originalError_2.message
                        });
                    case 10:
                        config = responseBody["entries"];
                        state = responseBody["state"];
                        _b.label = 11;
                    case 11:
                        // Normalizes based on legacy state.
                        if (state === "INSTANCE_STATE_UNSPECIFIED") status = 500;
                        else if (state === "NO_CHANGE") status = 304;
                        else if (state === "NO_TEMPLATE" || state === "EMPTY_CONFIG") // These cases can be fixed remotely, so normalize to safe value.
                        config = {};
                        // Normalize to exception-based control flow for non-success cases.
                        // Encapsulates HTTP specifics in this class as much as possible. Status is still the best for
                        // differentiating success states (200 from 304; the state body param is undefined in a
                        // standard 304).
                        if (status !== 304 && status !== 200) throw $9cb4abf729180141$var$ERROR_FACTORY.create("fetch-status" /* FETCH_STATUS */ , {
                            httpStatus: status
                        });
                        return [
                            2 /*return*/ ,
                            {
                                status: status,
                                eTag: responseEtag,
                                config: config
                            }
                        ];
                }
            });
        });
    };
    return RestClient;
}();
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Shims a minimal AbortSignal.
 *
 * <p>AbortController's AbortSignal conveniently decouples fetch timeout logic from other aspects
 * of networking, such as retries. Firebase doesn't use AbortController enough to justify a
 * polyfill recommendation, like we do with the Fetch API, but this minimal shim can easily be
 * swapped out if/when we do.
 */ var $9cb4abf729180141$var$RemoteConfigAbortSignal = /** @class */ function() {
    function RemoteConfigAbortSignal() {
        this.listeners = [];
    }
    RemoteConfigAbortSignal.prototype.addEventListener = function(listener) {
        this.listeners.push(listener);
    };
    RemoteConfigAbortSignal.prototype.abort = function() {
        this.listeners.forEach(function(listener) {
            return listener();
        });
    };
    return RemoteConfigAbortSignal;
}();
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $9cb4abf729180141$var$DEFAULT_VALUE_FOR_BOOLEAN = false;
var $9cb4abf729180141$var$DEFAULT_VALUE_FOR_STRING = "";
var $9cb4abf729180141$var$DEFAULT_VALUE_FOR_NUMBER = 0;
var $9cb4abf729180141$var$BOOLEAN_TRUTHY_VALUES = [
    "1",
    "true",
    "t",
    "yes",
    "y",
    "on"
];
var $9cb4abf729180141$var$Value = /** @class */ function() {
    function Value(_source, _value) {
        if (_value === void 0) _value = $9cb4abf729180141$var$DEFAULT_VALUE_FOR_STRING;
        this._source = _source;
        this._value = _value;
    }
    Value.prototype.asString = function() {
        return this._value;
    };
    Value.prototype.asBoolean = function() {
        if (this._source === "static") return $9cb4abf729180141$var$DEFAULT_VALUE_FOR_BOOLEAN;
        return $9cb4abf729180141$var$BOOLEAN_TRUTHY_VALUES.indexOf(this._value.toLowerCase()) >= 0;
    };
    Value.prototype.asNumber = function() {
        if (this._source === "static") return $9cb4abf729180141$var$DEFAULT_VALUE_FOR_NUMBER;
        var num = Number(this._value);
        if (isNaN(num)) num = $9cb4abf729180141$var$DEFAULT_VALUE_FOR_NUMBER;
        return num;
    };
    Value.prototype.getSource = function() {
        return this._source;
    };
    return Value;
}();
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $9cb4abf729180141$var$DEFAULT_FETCH_TIMEOUT_MILLIS = 60000; // One minute
var $9cb4abf729180141$var$DEFAULT_CACHE_MAX_AGE_MILLIS = 43200000; // Twelve hours.
/**
 * Encapsulates business logic mapping network and storage dependencies to the public SDK API.
 *
 * See {@link https://github.com/FirebasePrivate/firebase-js-sdk/blob/master/packages/firebase/index.d.ts|interface documentation} for method descriptions.
 */ var $9cb4abf729180141$var$RemoteConfig = /** @class */ function() {
    function RemoteConfig(// Required by FirebaseServiceFactory interface.
    app, // JS doesn't support private yet
    // (https://github.com/tc39/proposal-class-fields#private-fields), so we hint using an
    // underscore prefix.
    _client, _storageCache, _storage, _logger) {
        this.app = app;
        this._client = _client;
        this._storageCache = _storageCache;
        this._storage = _storage;
        this._logger = _logger;
        // Tracks completion of initialization promise.
        this._isInitializationComplete = false;
        this.settings = {
            fetchTimeoutMillis: $9cb4abf729180141$var$DEFAULT_FETCH_TIMEOUT_MILLIS,
            minimumFetchIntervalMillis: $9cb4abf729180141$var$DEFAULT_CACHE_MAX_AGE_MILLIS
        };
        this.defaultConfig = {};
    }
    // Based on packages/firestore/src/util/log.ts but not static because we need per-instance levels
    // to differentiate 2p and 3p use-cases.
    RemoteConfig.prototype.setLogLevel = function(logLevel) {
        switch(logLevel){
            case "debug":
                this._logger.logLevel = $d4M6f.LogLevel.DEBUG;
                break;
            case "silent":
                this._logger.logLevel = $d4M6f.LogLevel.SILENT;
                break;
            default:
                this._logger.logLevel = $d4M6f.LogLevel.ERROR;
        }
    };
    Object.defineProperty(RemoteConfig.prototype, "fetchTimeMillis", {
        get: function() {
            return this._storageCache.getLastSuccessfulFetchTimestampMillis() || -1;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RemoteConfig.prototype, "lastFetchStatus", {
        get: function() {
            return this._storageCache.getLastFetchStatus() || "no-fetch-yet";
        },
        enumerable: false,
        configurable: true
    });
    RemoteConfig.prototype.activate = function() {
        return $d1c2b3d4871c1de3$export$1050f835b63b671e(this, void 0, void 0, function() {
            var _a, lastSuccessfulFetchResponse, activeConfigEtag;
            return $d1c2b3d4871c1de3$export$67ebef60e6f28a6(this, function(_b) {
                switch(_b.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            Promise.all([
                                this._storage.getLastSuccessfulFetchResponse(),
                                this._storage.getActiveConfigEtag()
                            ])
                        ];
                    case 1:
                        _a = _b.sent(), lastSuccessfulFetchResponse = _a[0], activeConfigEtag = _a[1];
                        if (!lastSuccessfulFetchResponse || !lastSuccessfulFetchResponse.config || !lastSuccessfulFetchResponse.eTag || lastSuccessfulFetchResponse.eTag === activeConfigEtag) // Either there is no successful fetched config, or is the same as current active
                        // config.
                        return [
                            2 /*return*/ ,
                            false
                        ];
                        return [
                            4 /*yield*/ ,
                            Promise.all([
                                this._storageCache.setActiveConfig(lastSuccessfulFetchResponse.config),
                                this._storage.setActiveConfigEtag(lastSuccessfulFetchResponse.eTag)
                            ])
                        ];
                    case 2:
                        _b.sent();
                        return [
                            2 /*return*/ ,
                            true
                        ];
                }
            });
        });
    };
    RemoteConfig.prototype.ensureInitialized = function() {
        var _this = this;
        if (!this._initializePromise) this._initializePromise = this._storageCache.loadFromStorage().then(function() {
            _this._isInitializationComplete = true;
        });
        return this._initializePromise;
    };
    /**
     * @throws a {@link ErrorCode.FETCH_CLIENT_TIMEOUT} if the request takes longer than
     * {@link Settings.fetchTimeoutInSeconds} or
     * {@link DEFAULT_FETCH_TIMEOUT_SECONDS}.
     */ RemoteConfig.prototype.fetch = function() {
        return $d1c2b3d4871c1de3$export$1050f835b63b671e(this, void 0, void 0, function() {
            var abortSignal, e_1, lastFetchStatus;
            var _this = this;
            return $d1c2b3d4871c1de3$export$67ebef60e6f28a6(this, function(_a) {
                switch(_a.label){
                    case 0:
                        abortSignal = new $9cb4abf729180141$var$RemoteConfigAbortSignal();
                        setTimeout(function() {
                            return $d1c2b3d4871c1de3$export$1050f835b63b671e(_this, void 0, void 0, function() {
                                return $d1c2b3d4871c1de3$export$67ebef60e6f28a6(this, function(_a) {
                                    // Note a very low delay, eg < 10ms, can elapse before listeners are initialized.
                                    abortSignal.abort();
                                    return [
                                        2 /*return*/ 
                                    ];
                                });
                            });
                        }, this.settings.fetchTimeoutMillis);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            4,
                            ,
                            6
                        ]);
                        return [
                            4 /*yield*/ ,
                            this._client.fetch({
                                cacheMaxAgeMillis: this.settings.minimumFetchIntervalMillis,
                                signal: abortSignal
                            })
                        ];
                    case 2:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            this._storageCache.setLastFetchStatus("success")
                        ];
                    case 3:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 4:
                        e_1 = _a.sent();
                        lastFetchStatus = $9cb4abf729180141$var$hasErrorCode(e_1, "fetch-throttle" /* FETCH_THROTTLE */ ) ? "throttle" : "failure";
                        return [
                            4 /*yield*/ ,
                            this._storageCache.setLastFetchStatus(lastFetchStatus)
                        ];
                    case 5:
                        _a.sent();
                        throw e_1;
                    case 6:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    RemoteConfig.prototype.fetchAndActivate = function() {
        return $d1c2b3d4871c1de3$export$1050f835b63b671e(this, void 0, void 0, function() {
            return $d1c2b3d4871c1de3$export$67ebef60e6f28a6(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.fetch()
                        ];
                    case 1:
                        _a.sent();
                        return [
                            2 /*return*/ ,
                            this.activate()
                        ];
                }
            });
        });
    };
    RemoteConfig.prototype.getAll = function() {
        var _this = this;
        return $9cb4abf729180141$var$getAllKeys(this._storageCache.getActiveConfig(), this.defaultConfig).reduce(function(allConfigs, key) {
            allConfigs[key] = _this.getValue(key);
            return allConfigs;
        }, {});
    };
    RemoteConfig.prototype.getBoolean = function(key) {
        return this.getValue(key).asBoolean();
    };
    RemoteConfig.prototype.getNumber = function(key) {
        return this.getValue(key).asNumber();
    };
    RemoteConfig.prototype.getString = function(key) {
        return this.getValue(key).asString();
    };
    RemoteConfig.prototype.getValue = function(key) {
        if (!this._isInitializationComplete) this._logger.debug('A value was requested for key "' + key + '" before SDK initialization completed.' + " Await on ensureInitialized if the intent was to get a previously activated value.");
        var activeConfig = this._storageCache.getActiveConfig();
        if (activeConfig && activeConfig[key] !== undefined) return new $9cb4abf729180141$var$Value("remote", activeConfig[key]);
        else if (this.defaultConfig && this.defaultConfig[key] !== undefined) return new $9cb4abf729180141$var$Value("default", String(this.defaultConfig[key]));
        this._logger.debug('Returning static value for key "' + key + '".' + " Define a default or remote value if this is unintentional.");
        return new $9cb4abf729180141$var$Value("static");
    };
    return RemoteConfig;
}();
/**
 * Dedupes and returns an array of all the keys of the received objects.
 */ function $9cb4abf729180141$var$getAllKeys(obj1, obj2) {
    if (obj1 === void 0) obj1 = {};
    if (obj2 === void 0) obj2 = {};
    return Object.keys($d1c2b3d4871c1de3$export$18ce0697a983be9b($d1c2b3d4871c1de3$export$18ce0697a983be9b({}, obj1), obj2));
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Converts an error event associated with a {@link IDBRequest} to a {@link FirebaseError}.
 */ function $9cb4abf729180141$var$toFirebaseError(event, errorCode) {
    var originalError = event.target.error || undefined;
    return $9cb4abf729180141$var$ERROR_FACTORY.create(errorCode, {
        originalErrorMessage: originalError && originalError.message
    });
}
/**
 * A general-purpose store keyed by app + namespace + {@link
 * ProjectNamespaceKeyFieldValue}.
 *
 * <p>The Remote Config SDK can be used with multiple app installations, and each app can interact
 * with multiple namespaces, so this store uses app (ID + name) and namespace as common parent keys
 * for a set of key-value pairs. See {@link Storage#createCompositeKey}.
 *
 * <p>Visible for testing.
 */ var $9cb4abf729180141$var$APP_NAMESPACE_STORE = "app_namespace_store";
var $9cb4abf729180141$var$DB_NAME = "firebase_remote_config";
var $9cb4abf729180141$var$DB_VERSION = 1;
// Visible for testing.
function $9cb4abf729180141$var$openDatabase() {
    return new Promise(function(resolve, reject) {
        var request = indexedDB.open($9cb4abf729180141$var$DB_NAME, $9cb4abf729180141$var$DB_VERSION);
        request.onerror = function(event) {
            reject($9cb4abf729180141$var$toFirebaseError(event, "storage-open" /* STORAGE_OPEN */ ));
        };
        request.onsuccess = function(event) {
            resolve(event.target.result);
        };
        request.onupgradeneeded = function(event) {
            var db = event.target.result;
            // We don't use 'break' in this switch statement, the fall-through
            // behavior is what we want, because if there are multiple versions between
            // the old version and the current version, we want ALL the migrations
            // that correspond to those versions to run, not only the last one.
            // eslint-disable-next-line default-case
            switch(event.oldVersion){
                case 0:
                    db.createObjectStore($9cb4abf729180141$var$APP_NAMESPACE_STORE, {
                        keyPath: "compositeKey"
                    });
            }
        };
    });
}
/**
 * Abstracts data persistence.
 */ var $9cb4abf729180141$var$Storage = /** @class */ function() {
    /**
     * @param appId enables storage segmentation by app (ID + name).
     * @param appName enables storage segmentation by app (ID + name).
     * @param namespace enables storage segmentation by namespace.
     */ function Storage(appId, appName, namespace, openDbPromise) {
        if (openDbPromise === void 0) openDbPromise = $9cb4abf729180141$var$openDatabase();
        this.appId = appId;
        this.appName = appName;
        this.namespace = namespace;
        this.openDbPromise = openDbPromise;
    }
    Storage.prototype.getLastFetchStatus = function() {
        return this.get("last_fetch_status");
    };
    Storage.prototype.setLastFetchStatus = function(status) {
        return this.set("last_fetch_status", status);
    };
    // This is comparable to a cache entry timestamp. If we need to expire other data, we could
    // consider adding timestamp to all storage records and an optional max age arg to getters.
    Storage.prototype.getLastSuccessfulFetchTimestampMillis = function() {
        return this.get("last_successful_fetch_timestamp_millis");
    };
    Storage.prototype.setLastSuccessfulFetchTimestampMillis = function(timestamp) {
        return this.set("last_successful_fetch_timestamp_millis", timestamp);
    };
    Storage.prototype.getLastSuccessfulFetchResponse = function() {
        return this.get("last_successful_fetch_response");
    };
    Storage.prototype.setLastSuccessfulFetchResponse = function(response) {
        return this.set("last_successful_fetch_response", response);
    };
    Storage.prototype.getActiveConfig = function() {
        return this.get("active_config");
    };
    Storage.prototype.setActiveConfig = function(config) {
        return this.set("active_config", config);
    };
    Storage.prototype.getActiveConfigEtag = function() {
        return this.get("active_config_etag");
    };
    Storage.prototype.setActiveConfigEtag = function(etag) {
        return this.set("active_config_etag", etag);
    };
    Storage.prototype.getThrottleMetadata = function() {
        return this.get("throttle_metadata");
    };
    Storage.prototype.setThrottleMetadata = function(metadata) {
        return this.set("throttle_metadata", metadata);
    };
    Storage.prototype.deleteThrottleMetadata = function() {
        return this.delete("throttle_metadata");
    };
    Storage.prototype.get = function(key) {
        return $d1c2b3d4871c1de3$export$1050f835b63b671e(this, void 0, void 0, function() {
            var db;
            var _this = this;
            return $d1c2b3d4871c1de3$export$67ebef60e6f28a6(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.openDbPromise
                        ];
                    case 1:
                        db = _a.sent();
                        return [
                            2 /*return*/ ,
                            new Promise(function(resolve, reject) {
                                var transaction = db.transaction([
                                    $9cb4abf729180141$var$APP_NAMESPACE_STORE
                                ], "readonly");
                                var objectStore = transaction.objectStore($9cb4abf729180141$var$APP_NAMESPACE_STORE);
                                var compositeKey = _this.createCompositeKey(key);
                                try {
                                    var request = objectStore.get(compositeKey);
                                    request.onerror = function(event) {
                                        reject($9cb4abf729180141$var$toFirebaseError(event, "storage-get" /* STORAGE_GET */ ));
                                    };
                                    request.onsuccess = function(event) {
                                        var result = event.target.result;
                                        if (result) resolve(result.value);
                                        else resolve(undefined);
                                    };
                                } catch (e) {
                                    reject($9cb4abf729180141$var$ERROR_FACTORY.create("storage-get" /* STORAGE_GET */ , {
                                        originalErrorMessage: e && e.message
                                    }));
                                }
                            })
                        ];
                }
            });
        });
    };
    Storage.prototype.set = function(key, value) {
        return $d1c2b3d4871c1de3$export$1050f835b63b671e(this, void 0, void 0, function() {
            var db;
            var _this = this;
            return $d1c2b3d4871c1de3$export$67ebef60e6f28a6(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.openDbPromise
                        ];
                    case 1:
                        db = _a.sent();
                        return [
                            2 /*return*/ ,
                            new Promise(function(resolve, reject) {
                                var transaction = db.transaction([
                                    $9cb4abf729180141$var$APP_NAMESPACE_STORE
                                ], "readwrite");
                                var objectStore = transaction.objectStore($9cb4abf729180141$var$APP_NAMESPACE_STORE);
                                var compositeKey = _this.createCompositeKey(key);
                                try {
                                    var request = objectStore.put({
                                        compositeKey: compositeKey,
                                        value: value
                                    });
                                    request.onerror = function(event) {
                                        reject($9cb4abf729180141$var$toFirebaseError(event, "storage-set" /* STORAGE_SET */ ));
                                    };
                                    request.onsuccess = function() {
                                        resolve();
                                    };
                                } catch (e) {
                                    reject($9cb4abf729180141$var$ERROR_FACTORY.create("storage-set" /* STORAGE_SET */ , {
                                        originalErrorMessage: e && e.message
                                    }));
                                }
                            })
                        ];
                }
            });
        });
    };
    Storage.prototype.delete = function(key) {
        return $d1c2b3d4871c1de3$export$1050f835b63b671e(this, void 0, void 0, function() {
            var db;
            var _this = this;
            return $d1c2b3d4871c1de3$export$67ebef60e6f28a6(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.openDbPromise
                        ];
                    case 1:
                        db = _a.sent();
                        return [
                            2 /*return*/ ,
                            new Promise(function(resolve, reject) {
                                var transaction = db.transaction([
                                    $9cb4abf729180141$var$APP_NAMESPACE_STORE
                                ], "readwrite");
                                var objectStore = transaction.objectStore($9cb4abf729180141$var$APP_NAMESPACE_STORE);
                                var compositeKey = _this.createCompositeKey(key);
                                try {
                                    var request = objectStore.delete(compositeKey);
                                    request.onerror = function(event) {
                                        reject($9cb4abf729180141$var$toFirebaseError(event, "storage-delete" /* STORAGE_DELETE */ ));
                                    };
                                    request.onsuccess = function() {
                                        resolve();
                                    };
                                } catch (e) {
                                    reject($9cb4abf729180141$var$ERROR_FACTORY.create("storage-delete" /* STORAGE_DELETE */ , {
                                        originalErrorMessage: e && e.message
                                    }));
                                }
                            })
                        ];
                }
            });
        });
    };
    // Facilitates composite key functionality (which is unsupported in IE).
    Storage.prototype.createCompositeKey = function(key) {
        return [
            this.appId,
            this.appName,
            this.namespace,
            key
        ].join();
    };
    return Storage;
}();
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A memory cache layer over storage to support the SDK's synchronous read requirements.
 */ var $9cb4abf729180141$var$StorageCache = /** @class */ function() {
    function StorageCache(storage) {
        this.storage = storage;
    }
    /**
     * Memory-only getters
     */ StorageCache.prototype.getLastFetchStatus = function() {
        return this.lastFetchStatus;
    };
    StorageCache.prototype.getLastSuccessfulFetchTimestampMillis = function() {
        return this.lastSuccessfulFetchTimestampMillis;
    };
    StorageCache.prototype.getActiveConfig = function() {
        return this.activeConfig;
    };
    /**
     * Read-ahead getter
     */ StorageCache.prototype.loadFromStorage = function() {
        return $d1c2b3d4871c1de3$export$1050f835b63b671e(this, void 0, void 0, function() {
            var lastFetchStatusPromise, lastSuccessfulFetchTimestampMillisPromise, activeConfigPromise, lastFetchStatus, lastSuccessfulFetchTimestampMillis, activeConfig;
            return $d1c2b3d4871c1de3$export$67ebef60e6f28a6(this, function(_a) {
                switch(_a.label){
                    case 0:
                        lastFetchStatusPromise = this.storage.getLastFetchStatus();
                        lastSuccessfulFetchTimestampMillisPromise = this.storage.getLastSuccessfulFetchTimestampMillis();
                        activeConfigPromise = this.storage.getActiveConfig();
                        return [
                            4 /*yield*/ ,
                            lastFetchStatusPromise
                        ];
                    case 1:
                        lastFetchStatus = _a.sent();
                        if (lastFetchStatus) this.lastFetchStatus = lastFetchStatus;
                        return [
                            4 /*yield*/ ,
                            lastSuccessfulFetchTimestampMillisPromise
                        ];
                    case 2:
                        lastSuccessfulFetchTimestampMillis = _a.sent();
                        if (lastSuccessfulFetchTimestampMillis) this.lastSuccessfulFetchTimestampMillis = lastSuccessfulFetchTimestampMillis;
                        return [
                            4 /*yield*/ ,
                            activeConfigPromise
                        ];
                    case 3:
                        activeConfig = _a.sent();
                        if (activeConfig) this.activeConfig = activeConfig;
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Write-through setters
     */ StorageCache.prototype.setLastFetchStatus = function(status) {
        this.lastFetchStatus = status;
        return this.storage.setLastFetchStatus(status);
    };
    StorageCache.prototype.setLastSuccessfulFetchTimestampMillis = function(timestampMillis) {
        this.lastSuccessfulFetchTimestampMillis = timestampMillis;
        return this.storage.setLastSuccessfulFetchTimestampMillis(timestampMillis);
    };
    StorageCache.prototype.setActiveConfig = function(activeConfig) {
        this.activeConfig = activeConfig;
        return this.storage.setActiveConfig(activeConfig);
    };
    return StorageCache;
}();
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Supports waiting on a backoff by:
 *
 * <ul>
 *   <li>Promisifying setTimeout, so we can set a timeout in our Promise chain</li>
 *   <li>Listening on a signal bus for abort events, just like the Fetch API</li>
 *   <li>Failing in the same way the Fetch API fails, so timing out a live request and a throttled
 *       request appear the same.</li>
 * </ul>
 *
 * <p>Visible for testing.
 */ function $9cb4abf729180141$var$setAbortableTimeout(signal, throttleEndTimeMillis) {
    return new Promise(function(resolve, reject) {
        // Derives backoff from given end time, normalizing negative numbers to zero.
        var backoffMillis = Math.max(throttleEndTimeMillis - Date.now(), 0);
        var timeout = setTimeout(resolve, backoffMillis);
        // Adds listener, rather than sets onabort, because signal is a shared object.
        signal.addEventListener(function() {
            clearTimeout(timeout);
            // If the request completes before this timeout, the rejection has no effect.
            reject($9cb4abf729180141$var$ERROR_FACTORY.create("fetch-throttle" /* FETCH_THROTTLE */ , {
                throttleEndTimeMillis: throttleEndTimeMillis
            }));
        });
    });
}
/**
 * Returns true if the {@link Error} indicates a fetch request may succeed later.
 */ function $9cb4abf729180141$var$isRetriableError(e) {
    if (!(e instanceof $01sTD.FirebaseError)) return false;
    // Uses string index defined by ErrorData, which FirebaseError implements.
    var httpStatus = Number(e["httpStatus"]);
    return httpStatus === 429 || httpStatus === 500 || httpStatus === 503 || httpStatus === 504;
}
/**
 * Decorates a Client with retry logic.
 *
 * <p>Comparable to CachingClient, but uses backoff logic instead of cache max age and doesn't cache
 * responses (because the SDK has no use for error responses).
 */ var $9cb4abf729180141$var$RetryingClient = /** @class */ function() {
    function RetryingClient(client, storage) {
        this.client = client;
        this.storage = storage;
    }
    RetryingClient.prototype.fetch = function(request) {
        return $d1c2b3d4871c1de3$export$1050f835b63b671e(this, void 0, void 0, function() {
            var throttleMetadata;
            return $d1c2b3d4871c1de3$export$67ebef60e6f28a6(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.storage.getThrottleMetadata()
                        ];
                    case 1:
                        throttleMetadata = _a.sent() || {
                            backoffCount: 0,
                            throttleEndTimeMillis: Date.now()
                        };
                        return [
                            2 /*return*/ ,
                            this.attemptFetch(request, throttleMetadata)
                        ];
                }
            });
        });
    };
    /**
     * A recursive helper for attempting a fetch request repeatedly.
     *
     * @throws any non-retriable errors.
     */ RetryingClient.prototype.attemptFetch = function(request, _a) {
        var throttleEndTimeMillis = _a.throttleEndTimeMillis, backoffCount = _a.backoffCount;
        return $d1c2b3d4871c1de3$export$1050f835b63b671e(this, void 0, void 0, function() {
            var response, e_1, throttleMetadata;
            return $d1c2b3d4871c1de3$export$67ebef60e6f28a6(this, function(_b) {
                switch(_b.label){
                    case 0:
                        // Starts with a (potentially zero) timeout to support resumption from stored state.
                        // Ensures the throttle end time is honored if the last attempt timed out.
                        // Note the SDK will never make a request if the fetch timeout expires at this point.
                        return [
                            4 /*yield*/ ,
                            $9cb4abf729180141$var$setAbortableTimeout(request.signal, throttleEndTimeMillis)
                        ];
                    case 1:
                        // Starts with a (potentially zero) timeout to support resumption from stored state.
                        // Ensures the throttle end time is honored if the last attempt timed out.
                        // Note the SDK will never make a request if the fetch timeout expires at this point.
                        _b.sent();
                        _b.label = 2;
                    case 2:
                        _b.trys.push([
                            2,
                            5,
                            ,
                            7
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.client.fetch(request)
                        ];
                    case 3:
                        response = _b.sent();
                        // Note the SDK only clears throttle state if response is success or non-retriable.
                        return [
                            4 /*yield*/ ,
                            this.storage.deleteThrottleMetadata()
                        ];
                    case 4:
                        // Note the SDK only clears throttle state if response is success or non-retriable.
                        _b.sent();
                        return [
                            2 /*return*/ ,
                            response
                        ];
                    case 5:
                        e_1 = _b.sent();
                        if (!$9cb4abf729180141$var$isRetriableError(e_1)) throw e_1;
                        throttleMetadata = {
                            throttleEndTimeMillis: Date.now() + $01sTD.calculateBackoffMillis(backoffCount),
                            backoffCount: backoffCount + 1
                        };
                        // Persists state.
                        return [
                            4 /*yield*/ ,
                            this.storage.setThrottleMetadata(throttleMetadata)
                        ];
                    case 6:
                        // Persists state.
                        _b.sent();
                        return [
                            2 /*return*/ ,
                            this.attemptFetch(request, throttleMetadata)
                        ];
                    case 7:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return RetryingClient;
}();
var $9cb4abf729180141$var$name = "@firebase/remote-config";
var $9cb4abf729180141$var$version = "0.1.28";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $9cb4abf729180141$var$registerRemoteConfig(firebaseInstance) {
    firebaseInstance.INTERNAL.registerComponent(new $gLWqF.Component("remoteConfig", remoteConfigFactory, "PUBLIC" /* PUBLIC */ ).setMultipleInstances(true));
    firebaseInstance.registerVersion($9cb4abf729180141$var$name, $9cb4abf729180141$var$version);
    function remoteConfigFactory(container, namespace) {
        /* Dependencies */ // getImmediate for FirebaseApp will always succeed
        var app = container.getProvider("app").getImmediate();
        // The following call will always succeed because rc has `import '@firebase/installations'`
        var installations = container.getProvider("installations").getImmediate();
        // Guards against the SDK being used in non-browser environments.
        if (typeof window === "undefined") throw $9cb4abf729180141$var$ERROR_FACTORY.create("registration-window" /* REGISTRATION_WINDOW */ );
        // Normalizes optional inputs.
        var _a = app.options, projectId = _a.projectId, apiKey = _a.apiKey, appId = _a.appId;
        if (!projectId) throw $9cb4abf729180141$var$ERROR_FACTORY.create("registration-project-id" /* REGISTRATION_PROJECT_ID */ );
        if (!apiKey) throw $9cb4abf729180141$var$ERROR_FACTORY.create("registration-api-key" /* REGISTRATION_API_KEY */ );
        if (!appId) throw $9cb4abf729180141$var$ERROR_FACTORY.create("registration-app-id" /* REGISTRATION_APP_ID */ );
        namespace = namespace || "firebase";
        var storage = new $9cb4abf729180141$var$Storage(appId, app.name, namespace);
        var storageCache = new $9cb4abf729180141$var$StorageCache(storage);
        var logger$1 = new $d4M6f.Logger($9cb4abf729180141$var$name);
        // Sets ERROR as the default log level.
        // See RemoteConfig#setLogLevel for corresponding normalization to ERROR log level.
        logger$1.logLevel = $d4M6f.LogLevel.ERROR;
        var restClient = new $9cb4abf729180141$var$RestClient(installations, // Uses the JS SDK version, by which the RC package version can be deduced, if necessary.
        firebaseInstance.SDK_VERSION, namespace, projectId, apiKey, appId);
        var retryingClient = new $9cb4abf729180141$var$RetryingClient(restClient, storage);
        var cachingClient = new $9cb4abf729180141$var$CachingClient(retryingClient, storage, storageCache, logger$1);
        var remoteConfigInstance = new $9cb4abf729180141$var$RemoteConfig(app, cachingClient, storageCache, storage, logger$1);
        // Starts warming cache.
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        remoteConfigInstance.ensureInitialized();
        return remoteConfigInstance;
    }
}
$9cb4abf729180141$var$registerRemoteConfig($9cb4abf729180141$var$firebase__default["default"]);
$9cb4abf729180141$exports.registerRemoteConfig = $9cb4abf729180141$var$registerRemoteConfig;


function $d62524982f22f57c$var$_interopDefaultLegacy(e) {
    return e && typeof e === "object" && "default" in e ? e : {
        "default": e
    };
}
var $d62524982f22f57c$var$firebase__default = /*#__PURE__*/ $d62524982f22f57c$var$_interopDefaultLegacy($31dJ8);
var $d62524982f22f57c$var$name = "firebase";
var $d62524982f22f57c$var$version = "7.24.0";
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ $d62524982f22f57c$var$firebase__default["default"].registerVersion($d62524982f22f57c$var$name, $d62524982f22f57c$var$version, "app");
var $d62524982f22f57c$var$name$1 = "firebase";
var $d62524982f22f57c$var$version$1 = "7.24.0";
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ console.warn("\nIt looks like you're using the development build of the Firebase JS SDK.\nWhen deploying Firebase apps to production, it is advisable to only import\nthe individual SDK components you intend to use.\n\nFor the module builds, these are available in the following manner\n(replace <PACKAGE> with the name of a component - i.e. auth, database, etc):\n\nCommonJS Modules:\nconst firebase = require('firebase/app');\nrequire('firebase/<PACKAGE>');\n\nES Modules:\nimport firebase from 'firebase/app';\nimport 'firebase/<PACKAGE>';\n\nTypescript:\nimport * as firebase from 'firebase/app';\nimport 'firebase/<PACKAGE>';\n");
$d62524982f22f57c$var$firebase__default["default"].registerVersion($d62524982f22f57c$var$name$1, $d62524982f22f57c$var$version$1);
$d62524982f22f57c$exports = $d62524982f22f57c$var$firebase__default["default"];


var $41cc883dcc596d2f$exports = {};
"use strict";

var $31dJ8 = parcelRequire("31dJ8");
function $41cc883dcc596d2f$var$_interopDefaultLegacy(e) {
    return e && typeof e === "object" && "default" in e ? e : {
        "default": e
    };
}
var $41cc883dcc596d2f$var$firebase__default = /*#__PURE__*/ $41cc883dcc596d2f$var$_interopDefaultLegacy($31dJ8);
var $41cc883dcc596d2f$var$name = "firebase";
var $41cc883dcc596d2f$var$version = "7.24.0";
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ $41cc883dcc596d2f$var$firebase__default["default"].registerVersion($41cc883dcc596d2f$var$name, $41cc883dcc596d2f$var$version, "app");
$41cc883dcc596d2f$exports = $41cc883dcc596d2f$var$firebase__default["default"];






var $acw62 = parcelRequire("acw62");
const $b090720bc1d5aaf4$var$config = {
    apiKey: "AIzaSyCg2wjqCUKFfGl_Qp5xWe9e0jdtALIeMAw",
    authDomain: "jeopardy-reborn.firebaseapp.com",
    projectId: "jeopardy-reborn",
    storageBucket: "jeopardy-reborn.appspot.com",
    messagingSenderId: "55588891239",
    appId: "1:55588891239:web:7377e908a2541948ee02c2"
};
(0, (/*@__PURE__*/$parcel$interopDefault($d62524982f22f57c$exports))).initializeApp($b090720bc1d5aaf4$var$config);
(0, $41cc883dcc596d2f$exports.firestore)().enablePersistence().catch((err)=>{
    console.log("Persistence disabled: ", err.code);
    if (err.code === "failed-precondition") ;
    else err.code;
});
const $b090720bc1d5aaf4$export$c38b5ab6cd57b371 = async (userId, teamId)=>{
    await (0, $41cc883dcc596d2f$exports.firestore)().collection("teams").doc(teamId).update("members", (0, $41cc883dcc596d2f$exports.firestore).FieldValue.arrayUnion(userId));
};
const $b090720bc1d5aaf4$export$6bccf8bd051c9fb9 = async (questionId, teamId)=>{
    await (0, $41cc883dcc596d2f$exports.firestore)().collection("requestedAnswers").add({
        questionId: questionId,
        teamId: teamId,
        time: new Date()
    });
};
const $b090720bc1d5aaf4$export$a3db87856234ba81 = (questionId)=>{
    const [team, setTeam] = (0, $acw62.useState)(null);
    (0, $acw62.useEffect)(()=>{
        return (0, $41cc883dcc596d2f$exports.firestore)().collection("requestedAnswers").where("questionId", "==", questionId).orderBy("time").limit(1).onSnapshot(({ docs: docs })=>{
            const doc = docs.find(()=>true);
            setTeam(doc ? doc.data().teamId : null);
        });
    }, [
        questionId
    ]);
    return team;
};
const $b090720bc1d5aaf4$export$6fe02dcc2001dcb0 = ()=>{
    const [teams, setTeams] = (0, $acw62.useState)([]);
    (0, $acw62.useEffect)(()=>{
        return (0, $41cc883dcc596d2f$exports.firestore)().collection("teams").onSnapshot(({ docs: docs })=>{
            setTeams(docs.map((doc)=>{
                const { color: color, name: name, members: members, points: points } = doc.data();
                return {
                    id: doc.id,
                    color: color,
                    name: name,
                    members: members,
                    points: points
                };
            }));
        });
    }, []);
    return teams;
};
const $b090720bc1d5aaf4$export$17897f9a67d1488d = ()=>{
    const [categories, setCategories] = (0, $acw62.useState)([]);
    (0, $acw62.useEffect)(()=>{
        return (0, $41cc883dcc596d2f$exports.firestore)().collection("categories").onSnapshot(({ docs: docs })=>{
            setCategories(docs.map((doc)=>{
                const data = doc.data();
                return data;
            }));
        });
    }, []);
    return categories;
};
const $b090720bc1d5aaf4$export$87047dea94a3085d = (category, answer)=>{
    const categoryCopy = {
        ...category,
        answers: category.answers.map((a)=>a.id === answer.id ? {
                ...a,
                show: true
            } : a)
    };
    (0, $41cc883dcc596d2f$exports.firestore)().doc(`categories/${category.id}`).set(categoryCopy);
};
const $b090720bc1d5aaf4$export$e28ecfba58fd26a5 = (category)=>{
    const categoryCopy = {
        ...category,
        answers: category.answers.map((a)=>({
                ...a,
                show: false
            }))
    };
    (0, $41cc883dcc596d2f$exports.firestore)().doc(`categories/${category.id}`).set(categoryCopy);
};
const $b090720bc1d5aaf4$export$78c218f605358a7b = (category, answer)=>{
    const categoryCopy = {
        ...category,
        answers: category.answers.map((a)=>({
                ...a,
                show: false,
                answered: a.answered || answer.id === a.id
            }))
    };
    (0, $41cc883dcc596d2f$exports.firestore)().doc(`categories/${category.id}`).set(categoryCopy);
};
const $b090720bc1d5aaf4$export$8fb12bb94807cc02 = (category, answer)=>{
    const categoryCopy = {
        ...category,
        answers: category.answers.map((a)=>{
            const answered = answer.id === a.id ? !a.answered : a.answered;
            return {
                ...a,
                show: false,
                answered: answered
            };
        })
    };
    (0, $41cc883dcc596d2f$exports.firestore)().doc(`categories/${category.id}`).set(categoryCopy);
};
const $b090720bc1d5aaf4$export$19a46c6b349da83c = (team, answer)=>{
    (0, $41cc883dcc596d2f$exports.firestore)().doc(`teams/${team.id}`).set({
        ...team,
        points: team.points + answer.points
    });
};
const $b090720bc1d5aaf4$export$b832e015df3341da = (team, answer)=>{
    (0, $41cc883dcc596d2f$exports.firestore)().doc(`teams/${team.id}`).set({
        ...team,
        points: team.points - answer.points
    });
};
const $b090720bc1d5aaf4$export$e443b07e0f79518c = (team, points)=>{
    (0, $41cc883dcc596d2f$exports.firestore)().doc(`teams/${team.id}`).set({
        ...team,
        points: points
    });
};
const $b090720bc1d5aaf4$export$da394805d8e49f9a = async ()=>{
    if (window.confirm("Really?")) {
        const query = await (0, $41cc883dcc596d2f$exports.firestore)().collection("teams").get();
        for (const item of query.docs)await (0, $41cc883dcc596d2f$exports.firestore)().doc(`teams/${item.id}`).set({
            ...item.data(),
            points: 0
        });
    }
};
const $b090720bc1d5aaf4$export$fb2663b0d18a4508 = async (userId, team)=>{
    const teamQuery = await (0, $41cc883dcc596d2f$exports.firestore)().doc(`teams/${team.id}`).get();
    const data = teamQuery.data();
    await (0, $41cc883dcc596d2f$exports.firestore)().doc(`teams/${team.id}`).set({
        ...data,
        members: data.members.filter((m)=>m !== userId)
    });
};
const $b090720bc1d5aaf4$export$fbde73a70fe9ce62 = async ()=>{
    const query = await (0, $41cc883dcc596d2f$exports.firestore)().collection("requestedAnswers").get();
    for (const item of query.docs)await (0, $41cc883dcc596d2f$exports.firestore)().doc(`requestedAnswers/${item.id}`).delete();
};


var $c01512cbc56e2fb8$export$44e2388b3736c907;
(function(AnswerType) {
    AnswerType["TEXT"] = "TEXT";
    AnswerType["IMAGE"] = "IMAGE";
    AnswerType["CODE"] = "CODE";
})($c01512cbc56e2fb8$export$44e2388b3736c907 || ($c01512cbc56e2fb8$export$44e2388b3736c907 = {}));


var $1fd7493ee1dd339a$export$50a780d71cf22a88;
var $1fd7493ee1dd339a$export$c679af4b31478a3b;
var $1fd7493ee1dd339a$export$2c76aca27257bcfa;
var $1fd7493ee1dd339a$export$657ee1858213601f;
var $1fd7493ee1dd339a$export$fc6e89e9bf9f348b;
var $1fd7493ee1dd339a$export$6565f9f03506010b;
var $1fd7493ee1dd339a$export$20b0b894882a17b1;
var $1fd7493ee1dd339a$export$5c452ff88e35e47d;
var $1fd7493ee1dd339a$export$e8e78c978b129247;
var $1fd7493ee1dd339a$export$ff2ef852591a05fa;
var $1fd7493ee1dd339a$export$f1add72443bb9dac;
var $1fd7493ee1dd339a$export$1c154f0569c28262;
var $1fd7493ee1dd339a$export$605860f44dd1c140;
var $1fd7493ee1dd339a$export$9f98a8d796affec6;
var $1fd7493ee1dd339a$export$f1a349420f18addd;
var $1fd7493ee1dd339a$export$6f093cfa640b7166;
var $1fd7493ee1dd339a$export$fb184b623420d9be;
var $1fd7493ee1dd339a$export$8a75a0b708204d8f;
var $1fd7493ee1dd339a$export$7b11cb19589d9734;
var $1fd7493ee1dd339a$export$318bb85fd83e5f1a;
$1fd7493ee1dd339a$export$50a780d71cf22a88 = `w9iSfa_answer`;
$1fd7493ee1dd339a$export$c679af4b31478a3b = `w9iSfa_answerTitle`;
$1fd7493ee1dd339a$export$2c76aca27257bcfa = `w9iSfa_categories`;
$1fd7493ee1dd339a$export$657ee1858213601f = `w9iSfa_category`;
$1fd7493ee1dd339a$export$fc6e89e9bf9f348b = `w9iSfa_categoryTitle`;
$1fd7493ee1dd339a$export$6565f9f03506010b = `w9iSfa_code`;
$1fd7493ee1dd339a$export$20b0b894882a17b1 = `w9iSfa_confettiWrapper`;
$1fd7493ee1dd339a$export$5c452ff88e35e47d = `w9iSfa_image`;
$1fd7493ee1dd339a$export$e8e78c978b129247 = `w9iSfa_root`;
$1fd7493ee1dd339a$export$ff2ef852591a05fa = `w9iSfa_shadow-pulse`;
$1fd7493ee1dd339a$export$ff2ef852591a05fa;
$1fd7493ee1dd339a$export$f1add72443bb9dac = `w9iSfa_teamFooter`;
$1fd7493ee1dd339a$export$1c154f0569c28262 = `w9iSfa_teamItem`;
$1fd7493ee1dd339a$export$605860f44dd1c140 = `w9iSfa_teamItemActive`;
$1fd7493ee1dd339a$export$9f98a8d796affec6 = `w9iSfa_teamName`;
$1fd7493ee1dd339a$export$f1a349420f18addd = `w9iSfa_teamPoints`;
$1fd7493ee1dd339a$export$6f093cfa640b7166 = `w9iSfa_text`;
$1fd7493ee1dd339a$export$fb184b623420d9be = `w9iSfa_title`;
$1fd7493ee1dd339a$export$8a75a0b708204d8f = `w9iSfa_titleFirst`;
$1fd7493ee1dd339a$export$7b11cb19589d9734 = `w9iSfa_titleName`;
$1fd7493ee1dd339a$export$318bb85fd83e5f1a = `w9iSfa_titleText`;


const $b85c06db64fa360d$var$renderAnswerByType = ({ type: type, answer: answer, answerDe: answerDe })=>{
    switch(type){
        case (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                className: $1fd7493ee1dd339a$export$6f093cfa640b7166
            }, answerDe || answer);
        case (0, $c01512cbc56e2fb8$export$44e2388b3736c907).IMAGE:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("img", {
                className: $1fd7493ee1dd339a$export$5c452ff88e35e47d,
                src: answer,
                alt: "",
                title: ""
            });
        case (0, $c01512cbc56e2fb8$export$44e2388b3736c907).CODE:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($050c5bb5f8d0e70e$exports))), {
                className: $1fd7493ee1dd339a$export$6565f9f03506010b
            }, answer);
        default:
            break;
    }
};
const $b85c06db64fa360d$var$Answer = ({ category: category, answer: answer })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: $1fd7493ee1dd339a$export$c679af4b31478a3b
    }, category.name, " (", answer.points, ")"), $b85c06db64fa360d$var$renderAnswerByType(answer));
};
const $b85c06db64fa360d$var$AnswerElement = ({ points: points, answered: answered })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: $1fd7493ee1dd339a$export$50a780d71cf22a88
    }, answered ? "" : points);
};
const $b85c06db64fa360d$var$Category = ({ category: category })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: $1fd7493ee1dd339a$export$657ee1858213601f
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: $1fd7493ee1dd339a$export$fc6e89e9bf9f348b
    }, category.name), category.answers.map((a)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b85c06db64fa360d$var$AnswerElement, {
            key: a.id,
            ...a
        })));
};
const $b85c06db64fa360d$export$dc9708c613b75ef5 = ()=>{
    const categories = (0, $b090720bc1d5aaf4$export$17897f9a67d1488d)();
    const teams = (0, $b090720bc1d5aaf4$export$6fe02dcc2001dcb0)();
    const currentCategory = categories.find((category)=>category.answers.some((answer)=>answer.show));
    const currentAnswer = categories.flatMap((category)=>category.answers).find((answer)=>answer.show);
    const activeTeam = (0, $b090720bc1d5aaf4$export$a3db87856234ba81)(currentAnswer ? currentAnswer.id : "");
    const allAnswered = categories.flatMap((category)=>category.answers).map((a)=>a.answered).reduce((accumulator, currentValue)=>accumulator && currentValue, true);
    console.log({
        allAnswered: allAnswered
    });
    const gameContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, currentCategory && currentAnswer ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b85c06db64fa360d$var$Answer, {
        category: currentCategory,
        answer: currentAnswer
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: $1fd7493ee1dd339a$export$2c76aca27257bcfa
    }, categories.map((c)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b85c06db64fa360d$var$Category, {
            key: c.id,
            category: c
        }))));
    const canvasRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createRef();
    const finishContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: $1fd7493ee1dd339a$export$20b0b894882a17b1
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("canvas", {
        ref: canvasRef
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($0fd3965b13b05e51$exports))), {
        width: window.innerWidth,
        height: window.innerHeight,
        canvasRef: canvasRef
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: $1fd7493ee1dd339a$export$e8e78c978b129247
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d5bf021e81f47411$export$dcef8f9bb9a41431), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, "Jeopardy!")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: $1fd7493ee1dd339a$export$fb184b623420d9be
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: $1fd7493ee1dd339a$export$318bb85fd83e5f1a
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: $1fd7493ee1dd339a$export$8a75a0b708204d8f
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: $1fd7493ee1dd339a$export$7b11cb19589d9734
    }, "Jeopardy"), " by engineeringontap"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, "jeopardy.sipgate.beer"))), allAnswered ? finishContent : gameContent, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: $1fd7493ee1dd339a$export$f1add72443bb9dac
    }, teams.map((t)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: t.id,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))($1fd7493ee1dd339a$export$1c154f0569c28262, {
                [$1fd7493ee1dd339a$export$605860f44dd1c140]: t.id === activeTeam
            }),
            style: {
                backgroundColor: t.color
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: $1fd7493ee1dd339a$export$9f98a8d796affec6
        }, t.name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: $1fd7493ee1dd339a$export$f1a349420f18addd
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c8cd6c72d9560405$exports))), {
            to: t.points,
            speed: 1000
        }))))));
};



var $acw62 = parcelRequire("acw62");
var $061e5e865be64174$exports = {};
"use strict";
var $061e5e865be64174$var$__importDefault = $061e5e865be64174$exports && $061e5e865be64174$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($061e5e865be64174$exports, "__esModule", {
    value: true
});

var $061e5e865be64174$var$Timer_1 = $061e5e865be64174$var$__importDefault((parcelRequire("czWj7")));

var $061e5e865be64174$var$getTimeParts_1 = $061e5e865be64174$var$__importDefault((parcelRequire("7KPrJ")));
$061e5e865be64174$exports.getTimeParts = $061e5e865be64174$var$getTimeParts_1.default;
var $97c2531952b2f27b$exports = {};
"use strict";
var $97c2531952b2f27b$var$__assign = $97c2531952b2f27b$exports && $97c2531952b2f27b$exports.__assign || function() {
    $97c2531952b2f27b$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $97c2531952b2f27b$var$__assign.apply(this, arguments);
};
var $97c2531952b2f27b$var$__importDefault = $97c2531952b2f27b$exports && $97c2531952b2f27b$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($97c2531952b2f27b$exports, "__esModule", {
    value: true
});

var $acw62 = parcelRequire("acw62");

var $bJuL9 = parcelRequire("bJuL9");

var $97c2531952b2f27b$var$getTimeParts_1 = $97c2531952b2f27b$var$__importDefault((parcelRequire("7KPrJ")));
function $97c2531952b2f27b$var$useTimer(_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.initialTime, initialTime = _c === void 0 ? 0 : _c, _d = _b.direction, direction = _d === void 0 ? "forward" : _d, _e = _b.timeToUpdate, timeToUpdate = _e === void 0 ? 1000 : _e, _f = _b.startImmediately, startImmediately = _f === void 0 ? true : _f, _g = _b.lastUnit, lastUnit = _g === void 0 ? "d" : _g, _h = _b.checkpoints, checkpoints = _h === void 0 ? [] : _h, onStart = _b.onStart, onResume = _b.onResume, onPause = _b.onPause, onStop = _b.onStop, onReset = _b.onReset;
    var _j = $acw62.useState($97c2531952b2f27b$var$__assign({}, $97c2531952b2f27b$var$getTimeParts_1.default(initialTime < 0 ? 0 : initialTime, lastUnit), {
        state: "INITED"
    })), timerValues = _j[0], setTimerValues = _j[1];
    var timer = $acw62.useMemo(function() {
        return new $bJuL9.TimerModel({
            initialTime: initialTime,
            direction: direction,
            timeToUpdate: timeToUpdate,
            lastUnit: lastUnit,
            checkpoints: checkpoints,
            onChange: function(timerValue) {
                return setTimerValues(function(state) {
                    return $97c2531952b2f27b$var$__assign({}, state, timerValue);
                });
            }
        });
    }, []);
    var setTime = $acw62.useCallback(function(time) {
        return timer.setTime(time);
    }, [
        timer
    ]);
    var getTime = $acw62.useCallback(function() {
        return timer.getTime();
    }, [
        timer
    ]);
    var getTimerState = $acw62.useCallback(function() {
        return timer.state;
    }, [
        timer
    ]);
    var setDirection = $acw62.useCallback(function(direction) {
        return timer.setDirection(direction);
    }, [
        timer
    ]);
    var setLastUnit = $acw62.useCallback(function(lastUnit) {
        return timer.setLastUnit(lastUnit);
    }, [
        timer
    ]);
    var setCheckpoints = $acw62.useCallback(function(checkpoints) {
        return timer.setCheckpoints(checkpoints);
    }, [
        timer
    ]);
    var setTimeToUpdate = $acw62.useCallback(function(interval) {
        return timer.setTimeToUpdate(interval);
    }, [
        timer
    ]);
    var start = $acw62.useCallback(function() {
        timer.start();
        onStart && onStart();
    }, [
        timer,
        onStart
    ]);
    var stop = $acw62.useCallback(function() {
        timer.stop();
        onStop && onStop();
    }, [
        timer,
        onStop
    ]);
    var pause = $acw62.useCallback(function() {
        timer.pause();
        onPause && onPause();
    }, [
        timer,
        onPause
    ]);
    var reset = $acw62.useCallback(function() {
        timer.reset();
        onReset && onReset();
    }, [
        timer,
        onReset
    ]);
    var resume = $acw62.useCallback(function() {
        timer.resume();
        onResume && onResume();
    }, [
        timer,
        onResume
    ]);
    var controls = $acw62.useMemo(function() {
        return {
            start: start,
            stop: stop,
            pause: pause,
            reset: reset,
            resume: resume,
            setTime: setTime,
            getTime: getTime,
            getTimerState: getTimerState,
            setDirection: setDirection,
            setLastUnit: setLastUnit,
            setTimeToUpdate: setTimeToUpdate,
            setCheckpoints: setCheckpoints
        };
    }, [
        start,
        stop,
        pause,
        reset,
        resume,
        setTime,
        getTime,
        getTimerState,
        setDirection,
        setLastUnit,
        setTimeToUpdate,
        setCheckpoints
    ]);
    $acw62.useEffect(function() {
        if (startImmediately) start();
        return function() {
            stop();
        };
    }, []);
    return {
        controls: controls,
        value: timerValues
    };
}
$97c2531952b2f27b$exports.useTimer = $97c2531952b2f27b$var$useTimer;


$061e5e865be64174$exports.useTimer = $97c2531952b2f27b$exports.useTimer;
$061e5e865be64174$exports.default = $061e5e865be64174$var$Timer_1.default;







var $bd60dbe7bfada5b5$exports = {};
/* 
(The MIT License)
Copyright (c) 2014-2021 Halász Ádám <adam@aimform.com>
Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:
The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
*/ //  Unique Hexatridecimal ID Generator
// ================================================
//  Dependencies
// ================================================

var $hPtJY = parcelRequire("hPtJY");
var $bd60dbe7bfada5b5$var$pid = typeof $hPtJY !== "undefined" && $hPtJY.pid ? $hPtJY.pid.toString(36) : "";
var $bd60dbe7bfada5b5$var$address = "";

if (typeof __webpack_require__ !== "function" && true) {
    var $bd60dbe7bfada5b5$var$mac = "", $bd60dbe7bfada5b5$var$os = (parcelRequire("ccDAZ"));
    if ($bd60dbe7bfada5b5$var$os.networkInterfaces) var $bd60dbe7bfada5b5$var$networkInterfaces = $bd60dbe7bfada5b5$var$os.networkInterfaces();
    if ($bd60dbe7bfada5b5$var$networkInterfaces) {
        loop: for(let interface_key in $bd60dbe7bfada5b5$var$networkInterfaces){
            const networkInterface = $bd60dbe7bfada5b5$var$networkInterfaces[interface_key];
            const length = networkInterface.length;
            for(var $bd60dbe7bfada5b5$var$i = 0; $bd60dbe7bfada5b5$var$i < length; $bd60dbe7bfada5b5$var$i++)if (networkInterface[$bd60dbe7bfada5b5$var$i] !== undefined && networkInterface[$bd60dbe7bfada5b5$var$i].mac && networkInterface[$bd60dbe7bfada5b5$var$i].mac != "00:00:00:00:00:00") {
                $bd60dbe7bfada5b5$var$mac = networkInterface[$bd60dbe7bfada5b5$var$i].mac;
                break loop;
            }
        }
        $bd60dbe7bfada5b5$var$address = $bd60dbe7bfada5b5$var$mac ? parseInt($bd60dbe7bfada5b5$var$mac.replace(/\:|\D+/gi, "")).toString(36) : "";
    }
}
//  Exports
// ================================================
$bd60dbe7bfada5b5$exports = $bd60dbe7bfada5b5$exports.default = function(prefix, suffix) {
    return (prefix ? prefix : "") + $bd60dbe7bfada5b5$var$address + $bd60dbe7bfada5b5$var$pid + $bd60dbe7bfada5b5$var$now().toString(36) + (suffix ? suffix : "");
};
$bd60dbe7bfada5b5$exports.process = function(prefix, suffix) {
    return (prefix ? prefix : "") + $bd60dbe7bfada5b5$var$pid + $bd60dbe7bfada5b5$var$now().toString(36) + (suffix ? suffix : "");
};
$bd60dbe7bfada5b5$exports.time = function(prefix, suffix) {
    return (prefix ? prefix : "") + $bd60dbe7bfada5b5$var$now().toString(36) + (suffix ? suffix : "");
};
//  Helpers
// ================================================
function $bd60dbe7bfada5b5$var$now() {
    var time = Date.now();
    var last = $bd60dbe7bfada5b5$var$now.last || time;
    return $bd60dbe7bfada5b5$var$now.last = time > last ? time : last + 1;
}


















const $7988e610dd9b56c5$export$19676ab5cb1de150 = [
    {
        id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
        name: "Hacker",
        answers: [
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).IMAGE,
                answer: (parcelRequire("f4hFs")),
                question: "Edward Snowden",
                explanation: "Dieser Herr hat einen der gr\xf6\xdften Geheimdienste blo\xdfgestellt.",
                points: 200,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).IMAGE,
                answer: (parcelRequire("iljQ4")),
                question: "Aaron Swartz",
                explanation: "Dieser Herr hat die sog. Frontpage des Internet mitbegr\xfcndet.",
                points: 400,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).IMAGE,
                answer: (parcelRequire("cG8ML")),
                question: "George Hotz",
                explanation: "Dieser Herr ist hat iPhones aus dem Gef\xe4ngnis befreit",
                points: 600,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).IMAGE,
                answer: (parcelRequire("lPRSF")),
                question: "Tsutomu Shimomura",
                explanation: "Er half dem FBI Kevin Mitnik zu finden und schrieb sp\xe4ter das Buch Takedown dar\xfcber.",
                points: 800,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).IMAGE,
                answer: (parcelRequire("2lenI")),
                question: "John Draper (Captain Crunch)",
                explanation: "Er ist ein legend\xe4rer Phone Phreak und tr\xe4gt den Spitznamen eines Cornflakes Maskottchens",
                points: 1000,
                show: false,
                answered: false
            }
        ]
    },
    {
        id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
        name: "TLDs",
        answers: [
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: ".gov",
                question: "Goverment",
                explanation: "Wird \xfcberwiegend von der Amerikanischen Regierung eingesetzt",
                points: 200,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: ".to",
                question: "Tonga",
                explanation: "Die Inselgruppe wurde fr\xfcher auch Freundschaftsinseln genannt.",
                points: 400,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: ".tv",
                question: "Tuvalu",
                explanation: "Bis zur Unabh\xe4ngigkeit am 1. Oktober 1978 hie\xdf das Territorium Ellice Islands.",
                points: 600,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: ".mc",
                question: "Monaco",
                explanation: "Heute ist das F\xfcrstentum vornehmlich bei den Reichen der Welt als Wohnsitz begehrt",
                points: 800,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: ".za",
                question: "Zuid Afrika",
                explanation: "Es ist der am weitesten entwickelte Wirtschaftsraum des afrikanischen Kontinents",
                points: 1000,
                show: false,
                answered: false
            }
        ]
    },
    {
        id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
        name: "Hello World",
        answers: [
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).CODE,
                answer: '#include <stdio.h>\n#include <stdlib.h>\n\nint main(void)\n{\n        printf("hello, world");\n        return EXIT_SUCCESS;\n}',
                question: "C",
                explanation: "Zahlreiche Sprachen orientieren sich an der Syntax und anderen Eigenschaften von dieser Sprache",
                points: 200,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).CODE,
                answer: 'require "sinatra"\nget "/hi" do\n        "Hello World!"\nend',
                question: "Ruby",
                explanation: "Diese h\xf6here Programmiersprache wurde Mitte der 1990er Jahre vom Japaner Yukihiro Matsumoto entworfen",
                points: 400,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).CODE,
                answer: 'tell application "Microsoft Word"\n        quit\nend tell',
                question: "Apple Script",
                explanation: "Die erste Version dieser Sprache basierte auf dem HyperCard-Projekt",
                points: 600,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).CODE,
                answer: "print join ' ', reverse split ' ', reverse join ' ', q/teY rehtona lreP .rekcah/;",
                question: "Perl",
                explanation: "Der Linguist Larry Wall entwarf sie 1987 als Synthese aus C, awk, den Unix-Befehlen und anderen Einfl\xfcssen",
                points: 800,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).CODE,
                answer: "",
                question: "Whitespace",
                explanation: "",
                points: 1000,
                show: false,
                answered: false
            }
        ]
    },
    {
        id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
        name: "Games",
        answers: [
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).IMAGE,
                answer: (parcelRequire("bfsSE")),
                question: "Pacman",
                explanation: "",
                points: 200,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).IMAGE,
                answer: (parcelRequire("4Rla9")),
                question: "Monkey Island",
                explanation: "",
                points: 400,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).IMAGE,
                answer: (parcelRequire("lJVrR")),
                question: "Pong",
                explanation: "",
                points: 600,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).IMAGE,
                answer: (parcelRequire("4a7WQ")),
                question: "Game of Life",
                explanation: "",
                points: 800,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).IMAGE,
                answer: (parcelRequire("43d45")),
                question: "Zork",
                explanation: "",
                points: 1000,
                show: false,
                answered: false
            }
        ]
    },
    {
        id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
        name: "Websites",
        answers: [
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).IMAGE,
                answer: (parcelRequire("cRoLX")),
                question: "PornHub",
                explanation: "",
                points: 200,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).IMAGE,
                answer: (parcelRequire("2arr6")),
                question: "GitHub",
                explanation: "",
                points: 400,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).IMAGE,
                answer: (parcelRequire("l4sQG")),
                question: "StackOverflow",
                explanation: "",
                points: 600,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).IMAGE,
                answer: (parcelRequire("94dUm")),
                question: "AWS",
                explanation: "",
                points: 800,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).IMAGE,
                answer: (parcelRequire("lerRi")),
                question: "Coderanch",
                explanation: "",
                points: 1000,
                show: false,
                answered: false
            }
        ]
    },
    {
        id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
        name: "Bugs",
        answers: [
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "Tritt auf, wenn das Ergebnis einer Berechnung f\xfcr den g\xfcltigen Zahlenbereich zu gro\xdf ist, um noch richtig interpretiert werden zu k\xf6nnen",
                question: "Integer overflow / Arithmetischer \xdcberlauf",
                explanation: "",
                points: 200,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "Dieser Fehler verschwindet, wenn man ihn n\xe4her beobachten will",
                question: "Heisenbug",
                explanation: "",
                points: 400,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "bla bla bla",
                question: "indexoutofbounds",
                explanation: "",
                points: 600,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "bla bla bla",
                question: "Nullpointer",
                explanation: "",
                points: 800,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "bla bla bla",
                question: "Kernel panic",
                explanation: "",
                points: 1000,
                show: false,
                answered: false
            }
        ]
    }
];















const $7988e610dd9b56c5$export$4b9672654250d8bc = [
    {
        id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
        name: "Minecraft",
        answers: [
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).IMAGE,
                answer: (parcelRequire("lQ1VG")),
                question: "Clock/Uhr",
                explanation: "",
                points: 200,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).IMAGE,
                answer: (parcelRequire("aldLf")),
                question: "Beacon/Leuchtfeuer",
                explanation: "",
                points: 400,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).IMAGE,
                answer: (parcelRequire("eXNbI")),
                question: "Hopper/Trichter",
                explanation: "",
                points: 600,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).IMAGE,
                question: "Repeater/Redstone-Verst\xe4rker",
                answer: (parcelRequire("5Ew7i")),
                explanation: "",
                points: 800,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).IMAGE,
                question: "Observer/Beobachter",
                answer: (parcelRequire("c450g")),
                explanation: "",
                points: 1000,
                show: false,
                answered: false
            }
        ]
    },
    {
        id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
        name: "Secret Identities",
        answers: [
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "Wonder Woman",
                question: "Diana Prince",
                explanation: "",
                points: 200,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "Captain Marvel",
                question: "Carol Danvers",
                explanation: "",
                points: 400,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "Harley Quinn",
                question: "Harleen Quinzel",
                explanation: "",
                points: 600,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "Spider-Woman",
                question: "Jessica Drew",
                explanation: "",
                points: 800,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "Supergirl",
                question: "Kara Zor-El",
                explanation: "",
                points: 1000,
                show: false,
                answered: false
            }
        ]
    },
    {
        id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
        name: "Movies",
        answers: [
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).IMAGE,
                answer: (parcelRequire("6naD7")),
                question: "Jurassic Park",
                explanation: "",
                points: 200,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).IMAGE,
                answer: (parcelRequire("1wxRH")),
                question: "Iron Man 2",
                explanation: "",
                points: 400,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).IMAGE,
                answer: (parcelRequire("3mC8v")),
                question: "WarGames",
                explanation: "",
                points: 600,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).IMAGE,
                answer: (parcelRequire("7NrCX")),
                question: "TRON: Legacy",
                explanation: "",
                points: 800,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).IMAGE,
                answer: (parcelRequire("8x447")),
                question: "Matrix 2",
                explanation: "",
                points: 1000,
                show: false,
                answered: false
            }
        ]
    },
    {
        id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
        name: "Ports",
        answers: [
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "ssh + ftp",
                question: "22 + 21 = 43",
                explanation: "",
                points: 200,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "mysql + http",
                question: "3306 + 80 = 3386",
                explanation: "",
                points: 400,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "telnet + smtp",
                question: "23 + 25 = 48",
                explanation: "",
                points: 600,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "dns + redis",
                question: "53 + 6379 = 6432",
                explanation: "",
                points: 800,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "sip + git",
                question: "5060 + 9418 = 14478",
                explanation: "",
                points: 1000,
                show: false,
                answered: false
            }
        ]
    },
    {
        id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
        name: "STDOUT",
        answers: [
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).CODE,
                answer: 'function foo() {\n  var bar = ["t", "o", "e"].reverse().join("");\n  console.log("hello " + bar);\n}\n\nfoo();',
                question: "hello eot",
                explanation: "",
                points: 200,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).CODE,
                answer: 'function foo() {\n  var eot = "hello eot";\n  setTimeout(() => {\n    console.log(eot);\n  }, 100);\n  this.eot = "cheers!";\n}\n\nfoo();',
                question: "hello eot",
                explanation: "",
                points: 400,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).CODE,
                answer: 'function foo() {\n  var beers = 2;\n  setTimeout(() => {\n    console.log(beers + " beers");\n  }, 1000);\n\n  for (let beers = 10; beers < 10; beers++) {}\n}\n\nfoo();',
                question: "2 beers (new scope using let)",
                explanation: "",
                points: 600,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).CODE,
                answer: 'class Person {\n  drink = "nothing";\n\n  constructor(drink) {\n    this.drink = drink;\n\n    Person.print = function() {\n      console.log("beer");\n    };\n  }\n\n  print() {\n    console.log(this.drink);\n  }\n}\n\nconst person = new Person("water");\nperson.print();',
                question: "water",
                explanation: "",
                points: 800,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).CODE,
                answer: 'const debug = console.log;\nconst warn = console.warn;\n\nfunction eat(snack, logger) {\n  // TODO: use logger\n  debug(snack);\n\n  if (snack) {\n    logger(snack);\n  } else if (snack === "cookie") {\n    logger("cookie");\n  }\n\n  return snack;\n}\n\nconsole.log(eat("cookie", warn));',
                question: "2x cookie",
                explanation: "",
                points: 1000,
                show: false,
                answered: false
            }
        ]
    },
    {
        id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
        name: "Unix",
        answers: [
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).IMAGE,
                answer: (parcelRequire("fnvRB")),
                question: "cat",
                explanation: "",
                points: 200,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).IMAGE,
                answer: (parcelRequire("4UFcN")),
                question: "tail",
                explanation: "",
                points: 400,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).IMAGE,
                answer: (parcelRequire("63IfY")),
                question: "ping",
                explanation: "",
                points: 600,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).IMAGE,
                answer: (parcelRequire("9hhnE")),
                question: "netcat",
                explanation: "",
                points: 800,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).IMAGE,
                answer: (parcelRequire("9N0fG")),
                question: "socat",
                explanation: "",
                points: 1000,
                show: false,
                answered: false
            }
        ]
    }
];
const $7988e610dd9b56c5$var$teamsSeed = [
    {
        id: "4242",
        color: "#81d4fa",
        name: "Blau",
        members: [],
        points: 0
    },
    {
        id: "1337",
        color: "#4caf50",
        name: "Gr\xfcn",
        members: [],
        points: 0
    },
    {
        id: "1235",
        color: "#f44336",
        name: "Rot",
        members: [],
        points: 0
    },
    {
        id: "4096",
        color: "#e91e63",
        name: "Pink",
        members: [],
        points: 0
    }
];
const $7988e610dd9b56c5$export$683dea5642c18ced = async ()=>{
    const query = await (0, $41cc883dcc596d2f$exports.firestore)().collection("categories").get();
    for (const item of query.docs)await (0, $41cc883dcc596d2f$exports.firestore)().doc(`categories/${item.id}`).delete();
    $7988e610dd9b56c5$export$5efbf14c3292beb6($7988e610dd9b56c5$export$19676ab5cb1de150)();
};
const $7988e610dd9b56c5$export$5efbf14c3292beb6 = (categories)=>async ()=>{
        const query = await (0, $41cc883dcc596d2f$exports.firestore)().collection("categories").get();
        if (query.docs.length > 0) {
            if (window.confirm("Cancel running game?")) for (const item of query.docs)await (0, $41cc883dcc596d2f$exports.firestore)().doc(`categories/${item.id}`).delete();
            else return;
        }
        for (const category of categories)await (0, $41cc883dcc596d2f$exports.firestore)().collection("/categories").doc(category.id).set(category);
    };
const $7988e610dd9b56c5$export$1a87823f19ef51a6 = async ()=>{
    if (window.confirm("Really?")) {
        const query = await (0, $41cc883dcc596d2f$exports.firestore)().collection("teams").get();
        for (const item of query.docs)await (0, $41cc883dcc596d2f$exports.firestore)().doc(`teams/${item.id}`).delete();
        for (const team of $7988e610dd9b56c5$var$teamsSeed)await (0, $41cc883dcc596d2f$exports.firestore)().collection("teams").doc(team.id).set(team);
    }
};














const $22d91a75a96a3f18$export$2d5f1f9b3ff97efe = [
    {
        id: "sktwiyw5k1tjf6ni",
        name: "Most popular games",
        answers: [
            {
                id: "sktwiyw5k1tjf6nn",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: 'This game features a man named "Drake" who searches for treasure around the world',
                answerDe: 'In diesem Spiel wird ein Mann namens "Drake" gespielt, der auf der ganzen Welt nach Sch\xe4tzen sucht.',
                question: "What is Uncharted 4",
                explanation: "",
                points: 200,
                show: false,
                answered: false
            },
            {
                id: "sktwiyw5k1tjf6ns",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "This game takes place in 2287 and a nuke goes off as you are going down an elevator",
                answerDe: "Dieses Spiel findet im Jahr 2287 statt und eine Atombombe geht los, w\xe4hrend man mit einem Aufzug f\xe4hrt.",
                question: "What is Fallout 4",
                explanation: "",
                points: 400,
                show: false,
                answered: false
            },
            {
                id: "sktwiyw5k1tjf6nx",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "This game allows you to be a criminal mastermind and run in the city of Los Santos",
                answerDe: "Dieses Spiel erlaubt es dir, ein kriminelles Superhirn zu sein und in der Stadt Los Santos zu laufen.",
                question: "What is GTA V",
                explanation: "",
                points: 600,
                show: false,
                answered: false
            },
            {
                id: "sktwiyw5k1tjf6o2",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "This game takes place in London England in the time of 1868",
                answerDe: "Dieses Spiel findet in London England in der Zeit von 1868 statt",
                question: "What is Assassin's Creed Syndicate",
                explanation: "",
                points: 800,
                show: false,
                answered: false
            },
            {
                id: "sktwiyw5k1tjf6o7",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: 'You play this game as a man named "Joel" and a little girl named "Ellie"',
                answerDe: 'Du spielst dieses Spiel als ein Mann namens "Joel" und ein kleines M\xe4dchen namens "Ellie".',
                question: "What is The Last of Us",
                explanation: "",
                points: 1000,
                show: false,
                answered: false
            }
        ]
    },
    {
        id: "1qxjj0ek1sccaif",
        name: "Popular Board games",
        answers: [
            {
                id: "1qxjj0ek1sccaik",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "A game in which you are a entrepreneur buying properties in order to expand your wealth. ",
                answerDe: "Ein Spiel, in dem Sie als Unternehmer Immobilien kaufen, um Ihr Verm\xf6gen zu erweitern.",
                question: "What is Monopoly? ",
                explanation: "",
                points: 200,
                show: false,
                answered: false
            },
            {
                id: "1qxjj0ek1sccaip",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "A game about bringing all your pawns home,it is remembered for its iconic saying when you screw someone over. ",
                answerDe: "Ein Spiel, bei dem es darum geht, alle P\xfcppchen nach Hause zu bringen",
                question: "What is Sorry? / Mensch \xe4rger dich nicht",
                explanation: "",
                points: 400,
                show: false,
                answered: false
            },
            {
                id: "1qxjj0ek1sccaiu",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "A game about losing all your cards by playing the same number or color down on a discard pile.",
                answerDe: "Ein Spiel um den Verlust aller Ihrer Karten, indem Sie die gleiche Zahl oder Farbe auf einem Ablagestapel spielen.",
                question: "What is Uno?",
                explanation: "",
                points: 600,
                show: false,
                answered: false
            },
            {
                id: "1qxjj0ek1sccaiz",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "A classic game about finding a murderer through searching a house.",
                answerDe: "Ein klassisches Spiel \xfcber die Suche nach einem M\xf6rder in einem Haus.",
                question: "What is Clue?",
                explanation: "",
                points: 800,
                show: false,
                answered: false
            },
            {
                id: "1qxjj0ek1sccaj4",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "A game about through the process of elimination finding out which character your opponent is",
                answerDe: "Ein Spiel \xfcber den Prozess der Eliminierung, um herauszufinden, welcher Charakter dein Gegner ist.",
                question: "What is Guess Who?",
                explanation: "",
                points: 1000,
                show: false,
                answered: false
            }
        ]
    },
    {
        id: "1qxjj0ek1sccaii",
        name: "Video Game Characters",
        answers: [
            {
                id: "1qxjj0ek1sccain",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "A fat Italian plumber's pet.",
                answerDe: "Das Haustier von einem fetten italienischen Klempner.",
                question: "What is Yoshi?",
                explanation: "",
                points: 200,
                show: false,
                answered: false
            },
            {
                id: "1qxjj0ek1sccais",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "A famous hero who wears green, A.K.A the Hero of Time.",
                answerDe: "Ein ber\xfchmter Held, der gr\xfcn tr\xe4gt, A.K.A. der Hero of Time.",
                question: "Who is Link?",
                explanation: "",
                points: 400,
                show: false,
                answered: false
            },
            {
                id: "1qxjj0ek1sccaj2",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "A pink character who can suck enemies up and gain their abilities.",
                answerDe: "Ein rosa Charakter, der Feinde aufsaugen und ihre F\xe4higkeiten annehmen kann.",
                question: "Who is Kirby?",
                explanation: "",
                points: 600,
                show: false,
                answered: false
            },
            {
                id: "1qxjj0ek1sccaix",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "A Female character genetically modified with bird D.N.A welding a charge up ion cannon.",
                answerDe: "Ein weiblicher Charakter, der mit Vogel D.N.A. genetisch ver\xe4ndert wurde und eine aufgeladene lonenkanone hat.",
                question: "Who is Samus Aran?",
                explanation: "",
                points: 800,
                show: false,
                answered: false
            },
            {
                id: "1qxjj0ek1sccaj7",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "A Humanoid robot wearing blue fighting an insane doctor.",
                answerDe: "Ein blauer, humanoider Roboter k\xe4mpft gegen einen verr\xfcckten Arzt.",
                question: "Who is Megaman?",
                explanation: "",
                points: 1000,
                show: false,
                answered: false
            }
        ]
    },
    {
        id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
        name: "Guess the game",
        answers: [
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).IMAGE,
                answer: (parcelRequire("bfsSE")),
                question: "Pacman",
                explanation: "",
                points: 200,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).IMAGE,
                answer: (parcelRequire("4Rla9")),
                question: "Monkey Island",
                explanation: "",
                points: 400,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).IMAGE,
                answer: (parcelRequire("lJVrR")),
                question: "Pong",
                explanation: "",
                points: 600,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).IMAGE,
                answer: (parcelRequire("4a7WQ")),
                question: "Game of Life",
                explanation: "",
                points: 800,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).IMAGE,
                answer: (parcelRequire("43d45")),
                question: "Zork",
                explanation: "",
                points: 1000,
                show: false,
                answered: false
            }
        ]
    },
    {
        id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
        name: "Minecraft",
        answers: [
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).IMAGE,
                answer: (parcelRequire("lQ1VG")),
                question: "Clock/Uhr",
                explanation: "Was bekommt man, wenn man dieses Rezept benutzt?",
                points: 200,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).IMAGE,
                answer: (parcelRequire("aldLf")),
                question: "Beacon/Leuchtfeuer",
                explanation: "Was bekommt man, wenn man dieses Rezept benutzt?",
                points: 400,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).IMAGE,
                answer: (parcelRequire("eXNbI")),
                question: "Hopper/Trichter",
                explanation: "Was bekommt man, wenn man dieses Rezept benutzt?",
                points: 600,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).IMAGE,
                question: "Repeater/Redstone-Verst\xe4rker",
                answer: (parcelRequire("5Ew7i")),
                explanation: "Was bekommt man, wenn man dieses Rezept benutzt?",
                points: 800,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).IMAGE,
                question: "Observer/Beobachter",
                answer: (parcelRequire("c450g")),
                explanation: "Was bekommt man, wenn man dieses Rezept benutzt?",
                points: 1000,
                show: false,
                answered: false
            }
        ]
    }
];














const $e2f35130ea26a340$export$ce04b748dc62c7ea = [
    {
        id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
        name: "Ports",
        answers: [
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "ssh + ftp",
                question: "22 + 21 = 43",
                explanation: "",
                points: 200,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "mysql + http",
                question: "3306 + 80 = 3386",
                explanation: "",
                points: 400,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "telnet + smtp",
                question: "23 + 25 = 48",
                explanation: "",
                points: 600,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "dns + redis",
                question: "53 + 6379 = 6432",
                explanation: "",
                points: 800,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "sip + git",
                question: "5060 + 9418 = 14478",
                explanation: "",
                points: 1000,
                show: false,
                answered: false
            }
        ]
    },
    {
        id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
        name: "Famous Hackers",
        answers: [
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).IMAGE,
                answer: (parcelRequire("f4hFs")),
                question: "Edward Snowden",
                explanation: "Dieser Herr hat einen der gr\xf6\xdften Geheimdienste blo\xdfgestellt.",
                points: 200,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).IMAGE,
                answer: (parcelRequire("iljQ4")),
                question: "Aaron Swartz",
                explanation: "Dieser Herr hat die sog. Frontpage des Internet mitbegr\xfcndet und RSS geschrieben.",
                points: 400,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).IMAGE,
                answer: (parcelRequire("cG8ML")),
                question: "George Hotz",
                explanation: "Dieser Herr hat iPhones aus dem Gef\xe4ngnis befreit. Und Playstations.",
                points: 600,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).IMAGE,
                answer: (parcelRequire("lPRSF")),
                question: "Tsutomu Shimomura",
                explanation: "Er half dem FBI Kevin Mitnik zu finden und schrieb sp\xe4ter das Buch Takedown dar\xfcber.",
                points: 800,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).IMAGE,
                answer: (parcelRequire("2lenI")),
                question: "John Draper (Captain Crunch)",
                explanation: "Er ist ein legend\xe4rer Phone Phreak und tr\xe4gt den Spitznamen eines Cornflakes Maskottchens",
                points: 1000,
                show: false,
                answered: false
            }
        ]
    },
    {
        id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
        name: "JavaScript > STDOUT",
        answers: [
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).CODE,
                answer: 'function foo() {\n  var bar = ["t", "o", "e"].reverse().join("");\n  console.log("hello " + bar);\n}\n\nfoo();',
                question: "hello eot",
                explanation: "",
                points: 200,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).CODE,
                answer: 'function foo() {\n  var eot = "hello eot";\n  setTimeout(() => {\n    console.log(eot);\n  }, 100);\n  this.eot = "cheers!";\n}\n\nfoo();',
                question: "hello eot",
                explanation: "",
                points: 400,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).CODE,
                answer: 'function foo() {\n  var beers = 2;\n  setTimeout(() => {\n    console.log(beers + " beers");\n  }, 1000);\n\n  for (let beers = 10; beers < 10; beers++) {}\n}\n\nfoo();',
                question: "2 beers (new scope using let)",
                explanation: "",
                points: 600,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).CODE,
                answer: 'class Person {\n  drink = "nothing";\n  constructor(drink) {\n    this.drink = drink;\n    Person.print = function() {\n      console.log("beer");\n    };\n  }\n  print() {\n    console.log(this.drink);\n  }\n}\nconst person = new Person("water");\nperson.print();',
                question: "water",
                explanation: "",
                points: 800,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).CODE,
                answer: 'const debug = console.log;\nconst warn = console.warn;\nfunction eat(snack, logger) {\n  // TODO: use logger\n  debug(snack);\n  if (snack) {\n    logger(snack);\n  } else if (snack === "cookie") {\n    logger("cookie");\n  }\n  return snack;\n}\nconsole.log(eat("cookie", warn));',
                question: "2x cookie",
                explanation: "",
                points: 1000,
                show: false,
                answered: false
            }
        ]
    },
    {
        id: "1qxjh6uk1sbd7yg",
        name: "IPs and Networks",
        answers: [
            {
                id: "1qxjh6uk1sbd7yn",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "The number of bytes in an IPv4 address",
                answerDe: "Die Anzahl der Bytes in einer IPv4-Adresse",
                question: "What is 4",
                explanation: "",
                points: 200,
                show: false,
                answered: false
            },
            {
                id: "1qxjh6uk1sbd7yu",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "Private IPv4 addresses were set as a standard in this RFC.",
                answerDe: "Private IPv4-Adressen wurden in diesem RFC als Standard festgelegt.",
                question: "What is RFC 1918",
                explanation: "",
                points: 400,
                show: false,
                answered: false
            },
            {
                id: "1qxjh6uk1sbd7z1",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "A netmask of 255.255.255.240 (or /28) has this many usable hosts",
                answerDe: "Eine Netzmaske von 255.255.255.255.240.240 (oder /28) hat so viele brauchbare Hosts.",
                question: "What is 14",
                explanation: "",
                points: 600,
                show: false,
                answered: false
            },
            {
                id: "1qxjh6uk1sbd7z8",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "This technology is known for securing Internet Protocol (IP) communications by authenticating and/or encrypting each IP packet of a communication session",
                answerDe: "Diese Technologie ist bekannt f\xfcr die Sicherung der Internet Protocol (IP)-Kommunikation durch Authentifizierung und/oder Verschl\xfcsselung jedes IP-Pakets einer Kommunikationssitzung.",
                question: "What is IPSec",
                explanation: "",
                points: 800,
                show: false,
                answered: false
            },
            {
                id: "1qxjh6uk1sbd7zf",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "The subnet 224.0.0.0/4 is reserved for this use",
                answerDe: "Das Subnetz 224.0.0.0.0.0/4 ist f\xfcr diese Nutzung reserviert.",
                question: "What is IP Multicast",
                explanation: "",
                points: 1000,
                show: false,
                answered: false
            }
        ]
    },
    {
        id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
        name: "Hacker Movies",
        answers: [
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).IMAGE,
                answer: (parcelRequire("6naD7")),
                question: "Jurassic Park",
                explanation: "Samuel L. Jackson ist dabei und sagt: Ich hasse dieser Hacker scheisse!",
                points: 200,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).IMAGE,
                answer: (parcelRequire("1wxRH")),
                question: "Iron Man 2",
                explanation: "Es ist ein Marvel Film und <spoiler>Justin Hammer</spoiler> sieht hier ganz schlecht aus...",
                points: 400,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).IMAGE,
                answer: (parcelRequire("3mC8v")),
                question: "WarGames",
                explanation: "Ein uralter Film in dem es um den Atomkrieg geht",
                points: 600,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).IMAGE,
                answer: (parcelRequire("7NrCX")),
                question: "TRON: Legacy",
                explanation: "Jeder von euch hat ihn gesehen und h\xf6rt die Musik auch ziemlich gern",
                points: 800,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).IMAGE,
                answer: (parcelRequire("8x447")),
                question: "Matrix 2",
                explanation: "Hier sehen wir einen echten SSH-Nuke Exploit. Es wird ein Kraftwerk herunter gefahren.",
                points: 1000,
                show: false,
                answered: false
            }
        ]
    }
];



const $b9c5086c63572426$export$d1ee0e46c42d7e17 = [
    {
        id: "1qxjjd4k1scs3a1",
        name: "Star Wars and Marvel",
        answers: [
            {
                id: "1qxjjd4k1scs3a6",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "This is the name of the new Avengers movie",
                answerDe: "So hei\xdft der neue Avengers-Film?",
                question: "Avengers: Endgame",
                explanation: "",
                points: 200,
                show: false,
                answered: false
            },
            {
                id: "1qxjjd4k1scs3ag",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "This is the name of Han Solo's ship",
                answerDe: "So hei\xdft das Schiff von Han Solo",
                question: "Millennium Falcon",
                explanation: "",
                points: 400,
                show: false,
                answered: false
            },
            {
                id: "1qxjjd4k1scs3al",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "This young Jedi Knight becomes Darth Vader in Star Wars",
                answerDe: "Dieser junge Jedi-Ritter wird Darth Vader in Star Wars",
                question: "Anakin Skywalker",
                explanation: "",
                points: 600,
                show: false,
                answered: false
            },
            {
                id: "1qxjjd4k1scs3ab",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "This is the name of Star-Lord's ship in Guardians of the Galaxy",
                answerDe: "So hei\xdft das Schiff von Star-Lord in Guardians of the Galaxy",
                question: "Milano",
                explanation: "",
                points: 800,
                show: false,
                answered: false
            },
            {
                id: "1qxjjd4k1scs3aq",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "Here Iron Man fought Whiplash for the first time",
                answerDe: "Hier hat Iron Man zum ersten Mal gegen Whiplash gek\xe4mpft",
                question: "Monaco",
                explanation: "",
                points: 1000,
                show: false,
                answered: false
            }
        ]
    },
    {
        id: "1qxjjd4k1scs3a2",
        name: "Pixar Movies",
        answers: [
            {
                id: "1qxjjd4k1scs3a7",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "This animated feature film was Pixar's first release in 1995",
                answerDe: "Dieser Animationsfilm war die erste Ver\xf6ffentlichung von Pixar im Jahr 1995",
                question: "Toy Story",
                explanation: "",
                points: 200,
                show: false,
                answered: false
            },
            {
                id: "1qxjjd4k1scs3ac",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: 'The movie "WALL-E" features a robot of the same name. This is his job.',
                answerDe: 'Der Film "WALL-E" zeigt einen gleichnamigen Roboter. Das ist sein Job.',
                question: "Trash Collector",
                explanation: "",
                points: 400,
                show: false,
                answered: false
            },
            {
                id: "1qxjjd4k1scs3am",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: 'This European city is the setting for the 2007 movie "Ratatouille"',
                answerDe: 'In dieser europ\xe4ischen Stadt spielt der Film "Ratatouille" von 2007',
                question: "Paris",
                explanation: "",
                points: 600,
                show: false,
                answered: false
            },
            {
                id: "1qxjjd4k1scs3ah",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: 'This Pixar character says, "No matter how many times you save the world, it always manages to get back in jeopardy again?"',
                answerDe: 'Dieser Pixar-Charakter sagt: "Ganz egal wie oft man die Welt rettet, sie schafft es immer wieder sich in Gefahr zu bringen?"',
                question: "Mr. Incredible",
                explanation: "",
                points: 800,
                show: false,
                answered: false
            },
            {
                id: "1qxjjd4k1scs3ar",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: 'This is where the character Carl Fredricksen moves in in the Oscar-winning film "Up"',
                answerDe: 'Hierhin zieht der Charakter Carl Fredricksen in dem Oscar-pr\xe4mierten Film "Oben"',
                question: "Paradise Falls / Paradiesf\xe4lle",
                explanation: "",
                points: 1000,
                show: false,
                answered: false
            }
        ]
    },
    {
        id: "1qxjjd4k1scs3a3",
        name: "Princesses",
        answers: [
            {
                id: "1qxjjd4k1scs3an",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "Name the 2 Disney Princesses who have red hair.",
                answerDe: "Die 2 Disney-Prinzessinnen, die rotes Haar haben.",
                question: "Princess Merida, Ariel (The Little Mermaid)",
                explanation: "",
                points: 200,
                show: false,
                answered: false
            },
            {
                id: "1qxjjd4k1scs3a8",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "Name the only Disney Princess based on a real life person. ",
                answerDe: "Die einzige Disney-Prinzessin, die auf einer echten Person basiert.",
                question: "Pocahontas ",
                explanation: "",
                points: 400,
                show: false,
                answered: false
            },
            {
                id: "1qxjjd4k1scs3ai",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "Who are three princesses who had evil stepmothers?",
                answerDe: "Nenne drei Prinzessinnen, die b\xf6se Stiefm\xfctter hatten",
                question: "Snow White, Cinderella, Rapunzel ",
                explanation: "",
                points: 600,
                show: false,
                answered: false
            },
            {
                id: "1qxjjd4k1scs3as",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "This Disney princess movie was the first to show war",
                answerDe: "Dieser Disney-Prinzessinnenfilm war der erste, der den Krieg zeigte.",
                question: "Mulan",
                explanation: "",
                points: 800,
                show: false,
                answered: false
            },
            {
                id: "1qxjjd4k1scs3ad",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "Name the only Disney Princess with hazel eyes. ",
                answerDe: "Die einzige Disney-Prinzessin mit braunen Augen.",
                question: "Belle ",
                explanation: "",
                points: 1000,
                show: false,
                answered: false
            }
        ]
    },
    {
        id: "1qxjj0ek1sccaie",
        name: "Cartons",
        answers: [
            {
                id: "1qxjj0ek1sccaij",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "A cartoon about a sponge in the ocean.",
                answerDe: "Ein Cartoon \xfcber einen Schwamm im Meer.",
                question: "What is SpongeBob SquarePants?",
                explanation: "",
                points: 200,
                show: false,
                answered: false
            },
            {
                id: "1qxjj0ek1sccait",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "A show about ponies and friendship. ",
                answerDe: "Eine Show \xfcber Ponys und Freundschaft.",
                question: "What is My Little Pony Friendship is Magic?",
                explanation: "",
                points: 400,
                show: false,
                answered: false
            },
            {
                id: "1qxjj0ek1sccaiy",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "A show about 3 super powered girls fighting crime.",
                answerDe: "Eine Show \xfcber 3 superstarke M\xe4dchen, die Verbrechen bek\xe4mpfen.",
                question: "What is The Power Puff Girls?",
                explanation: "",
                points: 600,
                show: false,
                answered: false
            },
            {
                id: "1qxjj0ek1sccaio",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "A show about a little boy who has fairy godparents.",
                answerDe: "Eine Show \xfcber einen kleinen Jungen, der Elfen als Eltern hat.",
                question: "What is The Fairly Odd Parents? / Cosmo und Wanda",
                explanation: "",
                points: 800,
                show: false,
                answered: false
            },
            {
                id: "1qxjj0ek1sccaj3",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "An older show about a Samurai fighting to save the world from robots.",
                answerDe: "Eine \xe4ltere Show \xfcber einen Samurai, der darum k\xe4mpft, die Welt vor Robotern zu retten.",
                question: "What is Samurai Jack?",
                explanation: "",
                points: 1000,
                show: false,
                answered: false
            }
        ]
    },
    {
        id: "1qxjiv9k1sca3q8",
        name: "Lord of the Rings",
        answers: [
            {
                id: "1qxjiv9k1sca3qd",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "This character started the series under a different color designation, but finishes the series as \u201Cthe White.\u201D ",
                answerDe: 'Dieser Charakter begann die Serie unter einer anderen Farbbezeichnung, beendet die Serie aber als "der Wei\xdfe".',
                question: "Who is Gandalf?",
                explanation: "",
                points: 200,
                show: false,
                answered: false
            },
            {
                id: "1qxjiv9k1sca3qi",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "This director brought the Lord of the Rings trilogy into the new millennium with an award-winning series of films based on these novels. ",
                answerDe: 'Dieser Regisseur brachte die Trilogie "Herr der Ringe" mit einer preisgekr\xf6nten Filmreihe, die auf diesen Romanen basiert, ins neue Jahrtausend."',
                question: "Who is Peter Jackson?",
                explanation: "",
                points: 400,
                show: false,
                answered: false
            },
            {
                id: "1qxjiv9k1sca3qn",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "This prequel to the Lord of the Rings trilogy includes the story of the creation of Ea, the fictional setting for these books. ",
                answerDe: "Diese Vorgeschichte zur Trilogie Herr der Ringe beinhaltet die Geschichte der Entstehung von Ea, dem fiktiven Schauplatz dieser B\xfccher.",
                question: "What is\xa0The Silmarillion?",
                explanation: "",
                points: 600,
                show: false,
                answered: false
            },
            {
                id: "1qxjiv9k1sca3qs",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "This ring of power was wielded by Galadriel, and lent it\u2019s preservative powers to her domain, Lorien. ",
                answerDe: "Dieser Ring der Macht wurde von Galadriel getragen und verlieh seine Kr\xe4fte ihrem Reich Lorien.",
                question: "What is Nenya?",
                explanation: "",
                points: 800,
                show: false,
                answered: false
            },
            {
                id: "1qxjiv9k1sca3qx",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "With it\u2019s counterpart Quenya, Tolkien invented this language, spoken by the \u201CGray Elves\u201D of Middle-Earth. ",
                answerDe: "Mit seinem Gegenst\xfcck Quenya erfand Tolkien diese Sprache, die von den Grauelben Mittelerdes gesprochen wird.",
                question: "What is Sindarin?",
                explanation: "",
                points: 1000,
                show: false,
                answered: false
            }
        ]
    }
];














const $dc9bcadf2cfc8d53$export$edcfc84d7147b770 = [
    {
        id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
        name: "TLDs",
        answers: [
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: ".gov",
                question: "Goverment",
                explanation: "Wird \xfcberwiegend von der Amerikanischen Regierung eingesetzt",
                points: 200,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: ".to",
                question: "Tonga",
                explanation: "Die Inselgruppe wurde fr\xfcher auch Freundschaftsinseln genannt.",
                points: 400,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: ".tv",
                question: "Tuvalu",
                explanation: "Bis zur Unabh\xe4ngigkeit am 1. Oktober 1978 hie\xdf das Territorium Ellice Islands.",
                points: 600,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: ".mc",
                question: "Monaco",
                explanation: "Heute ist das F\xfcrstentum vornehmlich bei den Reichen der Welt als Wohnsitz begehrt",
                points: 800,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: ".za",
                question: "Zuid Afrika",
                explanation: "Es ist der am weitesten entwickelte Wirtschaftsraum des afrikanischen Kontinents",
                points: 1000,
                show: false,
                answered: false
            }
        ]
    },
    {
        id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
        name: "Hello World",
        answers: [
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).CODE,
                answer: '#include <stdio.h>\n#include <stdlib.h>\n\nint main(void)\n{\n        printf("hello, world");\n        return EXIT_SUCCESS;\n}',
                question: "C",
                explanation: "Zahlreiche Sprachen orientieren sich an der Syntax und anderen Eigenschaften von dieser Sprache",
                points: 200,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).CODE,
                answer: 'require "sinatra"\nget "/hi" do\n        "Hello World!"\nend',
                question: "Ruby",
                explanation: "Diese h\xf6here Programmiersprache wurde Mitte der 1990er Jahre vom Japaner Yukihiro Matsumoto entworfen",
                points: 400,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).CODE,
                answer: 'tell application "Microsoft Word"\n        quit\nend tell',
                question: "Apple Script",
                explanation: "Die erste Version dieser Sprache basierte auf dem HyperCard-Projekt",
                points: 600,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).CODE,
                answer: "print join ' ', reverse split ' ', reverse join ' ', q/teY rehtona lreP .rekcah/;",
                question: "Perl",
                explanation: "Der Linguist Larry Wall entwarf sie 1987 als Synthese aus C, awk, den Unix-Befehlen und anderen Einfl\xfcssen",
                points: 800,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).CODE,
                answer: "",
                question: "Whitespace",
                explanation: "Der Code hier ist syntaktisch korrekt und gibt auch wirklich hello world aus",
                points: 1000,
                show: false,
                answered: false
            }
        ]
    },
    {
        id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
        name: "Websites",
        answers: [
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).IMAGE,
                answer: (parcelRequire("cRoLX")),
                question: "PornHub",
                explanation: "2018 hatte diese Platform 33 Milliarden Visits",
                points: 200,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).IMAGE,
                answer: (parcelRequire("2arr6")),
                question: "GitHub",
                explanation: "Diese Platform wurde in ruby on rails und elixir geschrieben",
                points: 400,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).IMAGE,
                answer: (parcelRequire("18e0I")),
                question: "StackOverflow",
                explanation: "250 Leute schmei\xdfen diese Webseite",
                points: 600,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).IMAGE,
                answer: (parcelRequire("94dUm")),
                question: "SpaceX",
                explanation: "Irgendwo auf der Website steht, dass ihr nur max. 64 Tonnen mitnehmen k\xf6nnt.",
                points: 800,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).IMAGE,
                answer: (parcelRequire("lerRi")),
                question: "Coderanch",
                explanation: "Wenn Stackoverflow mal down ist, kommt ihr meistens hier raus",
                points: 1000,
                show: false,
                answered: false
            }
        ]
    },
    {
        id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
        name: "Unix",
        answers: [
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).IMAGE,
                answer: (parcelRequire("fnvRB")),
                question: "cat",
                explanation: "Wie hei\xdft das UNIX Kommando?",
                points: 200,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).IMAGE,
                answer: (parcelRequire("4UFcN")),
                question: "tail",
                explanation: "Wir suchen ein UNIX Kommando zu diesem Bild",
                points: 400,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).IMAGE,
                answer: (parcelRequire("63IfY")),
                question: "ping",
                explanation: "Ich wei\xdf ja nicht wie ihr eure Infrastruktur monitored aber wir machen das mit dem Tool",
                points: 600,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).IMAGE,
                answer: (parcelRequire("9hhnE")),
                question: "netcat",
                explanation: "Die meisten benutzen es mit -tulpen",
                points: 800,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).IMAGE,
                answer: (parcelRequire("9N0fG")),
                question: "socat",
                explanation: "Wer von euch hatte noch ein Modem oder ist ein UNIX Opa?",
                points: 1000,
                show: false,
                answered: false
            }
        ]
    },
    {
        id: "1qxjj4uk1scgk0c",
        name: "Hacker Crews",
        answers: [
            {
                id: "1qxjj4uk1scgk0h",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "Cyper, Tank, Switch, Trinity, Morpheus, Neo",
                question: "What is 'The Matrix'?",
                explanation: "Die Sonnenbrille f\xfcr jeden Charakter wurde individuell gestaltet.",
                hint: "Bugs wurden hier nett mit Deja vu umschrieben",
                points: 200,
                show: false,
                answered: false
            },
            {
                id: "1qxjj4uk1scgk0m",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "Eliot Anderson, Darlene, Tyrell Wellick, fsociety",
                question: "What is 'Mr. Robot'?",
                explanation: "",
                points: 400,
                show: false,
                answered: false
            },
            {
                id: "1qxjj4uk1scgk0r",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "The Plague, Phantom Phreak, Crash Override, Zero Cool, Acid Burn",
                question: "What is 'Hackers'?",
                explanation: "",
                points: 600,
                show: false,
                answered: false
            },
            {
                id: "1qxjj4uk1scgk0w",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "Batou, Togusa, Saito, Ishikawa, Motoko ('The Major')",
                question: "What is 'Ghost in the Shell'?",
                explanation: "",
                hint: "Puppeteer hochgehen lassen, Anime, Realverfilmung",
                points: 800,
                show: false,
                answered: false
            },
            {
                id: "1qxjj4uk1scgk11",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "Count Zero, Brian Oblivion, Space Rogue, Kingpin, Mudge",
                question: "What is L0pht?",
                explanation: "Die Pioniere des responsible disclosure, Passwort brute force tool geschrieben",
                points: 1000,
                show: false,
                answered: false
            }
        ]
    }
];



















const $83714b806b972e5a$export$19676ab5cb1de150 = [
    {
        id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
        name: "Hacker",
        answers: [
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).IMAGE,
                answer: (parcelRequire("f4hFs")),
                question: "Edward Snowden",
                explanation: "Dieser Herr hat einen der gr\xf6\xdften Geheimdienste blo\xdfgestellt.",
                points: 200,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).IMAGE,
                answer: (parcelRequire("iljQ4")),
                question: "Aaron Swartz",
                explanation: "Dieser Herr hat die sog. Frontpage des Internet mitbegr\xfcndet.",
                points: 400,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).IMAGE,
                answer: (parcelRequire("cG8ML")),
                question: "George Hotz",
                explanation: "Dieser Herr ist hat iPhones aus dem Gef\xe4ngnis befreit",
                points: 600,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).IMAGE,
                answer: (parcelRequire("lPRSF")),
                question: "Tsutomu Shimomura",
                explanation: "Er half dem FBI Kevin Mitnik zu finden und schrieb sp\xe4ter das Buch Takedown dar\xfcber.",
                points: 800,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).IMAGE,
                answer: (parcelRequire("2lenI")),
                question: "John Draper (Captain Crunch)",
                explanation: "Er ist ein legend\xe4rer Phone Phreak und tr\xe4gt den Spitznamen eines Cornflakes Maskottchens",
                points: 1000,
                show: false,
                answered: false
            }
        ]
    },
    {
        id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
        name: "TLDs",
        answers: [
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: ".gov",
                question: "Goverment",
                explanation: "Wird \xfcberwiegend von der Amerikanischen Regierung eingesetzt",
                points: 200,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: ".to",
                question: "Tonga",
                explanation: "Die Inselgruppe wurde fr\xfcher auch Freundschaftsinseln genannt.",
                points: 400,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: ".tv",
                question: "Tuvalu",
                explanation: "Bis zur Unabh\xe4ngigkeit am 1. Oktober 1978 hie\xdf das Territorium Ellice Islands.",
                points: 600,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: ".mc",
                question: "Monaco",
                explanation: "Heute ist das F\xfcrstentum vornehmlich bei den Reichen der Welt als Wohnsitz begehrt",
                points: 800,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: ".za",
                question: "Zuid Afrika",
                explanation: "Es ist der am weitesten entwickelte Wirtschaftsraum des afrikanischen Kontinents",
                points: 1000,
                show: false,
                answered: false
            }
        ]
    },
    {
        id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
        name: "Hello World",
        answers: [
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).CODE,
                answer: '#include <stdio.h>\n#include <stdlib.h>\n\nint main(void)\n{\n        printf("hello, world");\n        return EXIT_SUCCESS;\n}',
                question: "C",
                explanation: "Zahlreiche Sprachen orientieren sich an der Syntax und anderen Eigenschaften von dieser Sprache",
                points: 200,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).CODE,
                answer: 'require "sinatra"\nget "/hi" do\n        "Hello World!"\nend',
                question: "Ruby",
                explanation: "Diese h\xf6here Programmiersprache wurde Mitte der 1990er Jahre vom Japaner Yukihiro Matsumoto entworfen",
                points: 400,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).CODE,
                answer: 'tell application "Microsoft Word"\n        quit\nend tell',
                question: "Apple Script",
                explanation: "Die erste Version dieser Sprache basierte auf dem HyperCard-Projekt",
                points: 600,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).CODE,
                answer: "print join ' ', reverse split ' ', reverse join ' ', q/teY rehtona lreP .rekcah/;",
                question: "Perl",
                explanation: "Der Linguist Larry Wall entwarf sie 1987 als Synthese aus C, awk, den Unix-Befehlen und anderen Einfl\xfcssen",
                points: 800,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).CODE,
                answer: "",
                question: "Whitespace",
                explanation: "",
                points: 1000,
                show: false,
                answered: false
            }
        ]
    },
    {
        id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
        name: "Games",
        answers: [
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).IMAGE,
                answer: (parcelRequire("bfsSE")),
                question: "Pacman",
                explanation: "",
                points: 200,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).IMAGE,
                answer: (parcelRequire("4Rla9")),
                question: "Monkey Island",
                explanation: "",
                points: 400,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).IMAGE,
                answer: (parcelRequire("lJVrR")),
                question: "Pong",
                explanation: "",
                points: 600,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).IMAGE,
                answer: (parcelRequire("4a7WQ")),
                question: "Game of Life",
                explanation: "",
                points: 800,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).IMAGE,
                answer: (parcelRequire("43d45")),
                question: "Zork",
                explanation: "",
                points: 1000,
                show: false,
                answered: false
            }
        ]
    },
    {
        id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
        name: "Websites",
        answers: [
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).IMAGE,
                answer: (parcelRequire("cRoLX")),
                question: "PornHub",
                explanation: "",
                points: 200,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).IMAGE,
                answer: (parcelRequire("2arr6")),
                question: "GitHub",
                explanation: "",
                points: 400,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).IMAGE,
                answer: (parcelRequire("l4sQG")),
                question: "StackOverflow",
                explanation: "",
                points: 600,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).IMAGE,
                answer: (parcelRequire("94dUm")),
                question: "AWS",
                explanation: "",
                points: 800,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).IMAGE,
                answer: (parcelRequire("lerRi")),
                question: "Coderanch",
                explanation: "",
                points: 1000,
                show: false,
                answered: false
            }
        ]
    },
    {
        id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
        name: "Bugs",
        answers: [
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "bla bla bla",
                question: "Integer overflow",
                explanation: "",
                points: 200,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "bla bla bla",
                question: "Heisenbug",
                explanation: "",
                points: 400,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "bla bla bla",
                question: "indexoutofbounds",
                explanation: "",
                points: 600,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "bla bla bla",
                question: "Nullpointer",
                explanation: "",
                points: 800,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "bla bla bla",
                question: "Kernel panic",
                explanation: "",
                points: 1000,
                show: false,
                answered: false
            }
        ]
    }
];



















const $987d0bf9046bb824$export$4b9672654250d8bc = [
    {
        id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
        name: "Minecraft",
        answers: [
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).IMAGE,
                answer: (parcelRequire("lQ1VG")),
                question: "Clock/Uhr",
                explanation: "",
                points: 200,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).IMAGE,
                answer: (parcelRequire("aldLf")),
                question: "Beacon/Leuchtfeuer",
                explanation: "",
                points: 400,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).IMAGE,
                answer: (parcelRequire("eXNbI")),
                question: "Hopper/Trichter",
                explanation: "",
                points: 600,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).IMAGE,
                question: "Repeater/Redstone-Verst\xe4rker",
                answer: (parcelRequire("5Ew7i")),
                explanation: "",
                points: 800,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).IMAGE,
                question: "Observer/Beobachter",
                answer: (parcelRequire("c450g")),
                explanation: "",
                points: 1000,
                show: false,
                answered: false
            }
        ]
    },
    {
        id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
        name: "Secret Identities",
        answers: [
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "Wonder Woman",
                question: "Diana Prince",
                explanation: "",
                points: 200,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "Captain Marvel",
                question: "Carol Danvers",
                explanation: "",
                points: 400,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "Harley Quinn",
                question: "Harleen Quinzel",
                explanation: "",
                points: 600,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "Spider-Woman",
                question: "Jessica Drew",
                explanation: "",
                points: 800,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "Supergirl",
                question: "Kara Zor-El",
                explanation: "",
                points: 1000,
                show: false,
                answered: false
            }
        ]
    },
    {
        id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
        name: "Movies",
        answers: [
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).IMAGE,
                answer: (parcelRequire("6naD7")),
                question: "Jurassic Park",
                explanation: "",
                points: 200,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).IMAGE,
                answer: (parcelRequire("1wxRH")),
                question: "Iron Man 2",
                explanation: "",
                points: 400,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).IMAGE,
                answer: (parcelRequire("3mC8v")),
                question: "WarGames",
                explanation: "",
                points: 600,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).IMAGE,
                answer: (parcelRequire("7NrCX")),
                question: "TRON: Legacy",
                explanation: "",
                points: 800,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).IMAGE,
                answer: (parcelRequire("8x447")),
                question: "Matrix 2",
                explanation: "",
                points: 1000,
                show: false,
                answered: false
            }
        ]
    },
    {
        id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
        name: "Ports",
        answers: [
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "ssh + ftp",
                question: "22 + 21 = 43",
                explanation: "",
                points: 200,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "mysql + http",
                question: "3306 + 80 = 3386",
                explanation: "",
                points: 400,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "telnet + smtp",
                question: "23 + 25 = 48",
                explanation: "",
                points: 600,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "dns + redis",
                question: "53 + 6379 = 6432",
                explanation: "",
                points: 800,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "sip + git",
                question: "5060 + 9418 = 14478",
                explanation: "",
                points: 1000,
                show: false,
                answered: false
            }
        ]
    },
    {
        id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
        name: "STDOUT",
        answers: [
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).CODE,
                answer: 'function foo() {\n  var bar = ["t", "o", "e"].reverse().join("");\n  console.log("hello " + bar);\n}\n\nfoo();',
                question: "hello eot",
                explanation: "",
                points: 200,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).CODE,
                answer: 'function foo() {\n  var eot = "hello eot";\n  setTimeout(() => {\n    console.log(eot);\n  }, 100);\n  this.eot = "cheers!";\n}\n\nfoo();',
                question: "hello eot",
                explanation: "",
                points: 400,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).CODE,
                answer: 'function foo() {\n  var beers = 2;\n  setTimeout(() => {\n    console.log(beers + " beers");\n  }, 1000);\n\n  for (let beers = 10; beers < 10; beers++) {}\n}\n\nfoo();',
                question: "2 beers (new scope using let)",
                explanation: "",
                points: 600,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).CODE,
                answer: 'class Person {\n  drink = "nothing";\n\n  constructor(drink) {\n    this.drink = drink;\n\n    Person.print = function() {\n      console.log("beer");\n    };\n  }\n\n  print() {\n    console.log(this.drink);\n  }\n}\n\nconst person = new Person("water");\nperson.print();',
                question: "water",
                explanation: "",
                points: 800,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).CODE,
                answer: 'const debug = console.log;\nconst warn = console.warn;\n\nfunction eat(snack, logger) {\n  // TODO: use logger\n  debug(snack);\n\n  if (snack) {\n    logger(snack);\n  } else if (snack === "cookie") {\n    logger("cookie");\n  }\n\n  return snack;\n}\n\nconsole.log(eat("cookie", warn));',
                question: "2x cookie",
                explanation: "",
                points: 1000,
                show: false,
                answered: false
            }
        ]
    },
    {
        id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
        name: "Unix",
        answers: [
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).IMAGE,
                answer: (parcelRequire("fnvRB")),
                question: "cat",
                explanation: "",
                points: 200,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).IMAGE,
                answer: (parcelRequire("4UFcN")),
                question: "tail",
                explanation: "",
                points: 400,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).IMAGE,
                answer: (parcelRequire("63IfY")),
                question: "ping",
                explanation: "",
                points: 600,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).IMAGE,
                answer: (parcelRequire("9hhnE")),
                question: "netcat",
                explanation: "",
                points: 800,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).IMAGE,
                answer: (parcelRequire("9N0fG")),
                question: "socat",
                explanation: "",
                points: 1000,
                show: false,
                answered: false
            }
        ]
    }
];



const $c7217db90e5a56e8$export$4b9074ac37ee5a23 = [
    {
        id: "1qxjdh4k1s9ik45",
        name: "Doctor Who",
        answers: [
            {
                id: "1qxjdh4k1s9ik4a",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "Because he left the brakes on...",
                question: "The Tardis wheezes and groans upon landing.",
                explanation: "",
                points: 100,
                show: false,
                answered: false
            },
            {
                id: "1qxjdh4k1s9ik4f",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "Because it has a broken chameleon circuit...",
                question: "The Tardis is stuck as a Police Phone Box",
                explanation: "",
                points: 200,
                show: false,
                answered: false
            },
            {
                id: "1qxjdh4k1s9ik4k",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "The anagram used in 2005 when the show was revived...",
                question: "What is Torchwood",
                explanation: "",
                points: 300,
                show: false,
                answered: false
            },
            {
                id: "1qxjdh4k1s9ik4p",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "First used by the second doctor...",
                question: "What is Sonic Screwdriver",
                explanation: "",
                points: 400,
                show: false,
                answered: false
            },
            {
                id: "1qxjdh4k1s9ik4u",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "In which episode did both Peter Capaldi and Karen Gillan appear as guest stars before being cast as the 12th Doctor and Amy Pond?",
                question: "What is The Fires Pompaii",
                explanation: "",
                points: 500,
                show: false,
                answered: false
            }
        ]
    },
    {
        id: "1qxjdh4k1s9ik46",
        name: "Super Heroes",
        answers: [
            {
                id: "1qxjdh4k1s9ik4b",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "He created Spider-Man...",
                question: "Who is Stan Lee",
                explanation: "",
                points: 100,
                show: false,
                answered: false
            },
            {
                id: "1qxjdh4k1s9ik4g",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "The year was Batman introduced...",
                question: "What is 1939?",
                explanation: "",
                points: 200,
                show: false,
                answered: false
            },
            {
                id: "1qxjdh4k1s9ik4l",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "The creators of the original superhero...",
                question: "Who is Joe Shuster and Jerry Siegel",
                explanation: "",
                points: 300,
                show: false,
                answered: false
            },
            {
                id: "1qxjdh4k1s9ik4q",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "After the death of Steve Rogers this man took up the mantel of Captain America",
                question: "Who is Bucky Barns",
                explanation: "",
                points: 400,
                show: false,
                answered: false
            },
            {
                id: "1qxjdh4k1s9ik4v",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "The only person that Batman reputedly ever killed...",
                question: "Who is the Joker",
                explanation: "",
                points: 500,
                show: false,
                answered: false
            }
        ]
    },
    {
        id: "1qxjdh4k1s9ik47",
        name: "Star Trek",
        answers: [
            {
                id: "1qxjdh4k1s9ik4c",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "An alter ego for professor Xavier?",
                question: "Who is Jean Luc Picard",
                explanation: "",
                points: 100,
                show: false,
                answered: false
            },
            {
                id: "1qxjdh4k1s9ik4h",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "The only person to play himself on the show",
                question: "Who is Stephen Hawking ",
                explanation: "",
                points: 200,
                show: false,
                answered: false
            },
            {
                id: "1qxjdh4k1s9ik4m",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "The power source for a romulan warp core...",
                question: "What is an artificial blackhole.",
                explanation: "",
                points: 300,
                show: false,
                answered: false
            },
            {
                id: "1qxjdh4k1s9ik4r",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "She's dead, but it didn't happen how we all thought.",
                question: "Who is Tasha Yar",
                explanation: "",
                points: 400,
                show: false,
                answered: false
            },
            {
                id: "1qxjdh4k1s9ik4w",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: 'He said "The fear of death is what keeps us alive."',
                question: "Who is Dr. Mccoy",
                explanation: "",
                points: 500,
                show: false,
                answered: false
            }
        ]
    },
    {
        id: "1qxjdh4k1s9ik48",
        name: "Hobbit Stuff",
        answers: [
            {
                id: "1qxjdh4k1s9ik4d",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "The name Bilbo went by when talking to the dragon...",
                question: "What is Barelridder",
                explanation: "",
                points: 100,
                show: false,
                answered: false
            },
            {
                id: "1qxjdh4k1s9ik4i",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: 'He said "One does not simply walk into Mordor"',
                question: "Who is Boromir ",
                explanation: "",
                points: 200,
                show: false,
                answered: false
            },
            {
                id: "1qxjdh4k1s9ik4n",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "He's not a hobbit but he often went without shoes...",
                question: "Who is Peter Jackson",
                explanation: "",
                points: 300,
                show: false,
                answered: false
            },
            {
                id: "1qxjdh4k1s9ik4s",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "In the movie Sam was given rope from Galadriel, but in the books he given...",
                question: "What is Sam's garden box. It contained dirt from Galadriel's orchard and a Mallorn seed.",
                explanation: "",
                points: 400,
                show: false,
                answered: false
            },
            {
                id: "1qxjdh4k1s9ik4x",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: '"Ive quite forgotten their names"',
                question: "Who is Alatar and Pallando. (They are Maiar of the Vala Orome)",
                explanation: "",
                points: 500,
                show: false,
                answered: false
            }
        ]
    },
    {
        id: "1qxjdh4k1s9ik49",
        name: "Star Wars",
        answers: [
            {
                id: "1qxjdh4k1s9ik4e",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "He shot first.",
                question: "who is Han Solo",
                explanation: "",
                points: 100,
                show: false,
                answered: false
            },
            {
                id: "1qxjdh4k1s9ik4j",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "So far he has appeared in every movie.",
                question: "Who is R2-D2",
                explanation: "",
                points: 200,
                show: false,
                answered: false
            },
            {
                id: "1qxjdh4k1s9ik4o",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "This man threaten to ruin the saga...",
                question: "Who is Jar-Jar Binks",
                explanation: "",
                points: 300,
                show: false,
                answered: false
            },
            {
                id: "1qxjdh4k1s9ik4t",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "Luke Skywalker's alter ego...",
                question: "Who is the Joker",
                explanation: "",
                points: 400,
                show: false,
                answered: false
            },
            {
                id: "1qxjdh4k1s9ik4y",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "May 21st, 1980",
                question: "What is the release date of The Empire Strikes Back",
                explanation: "",
                points: 500,
                show: false,
                answered: false
            }
        ]
    }
];



const $5255c4ce04c9baea$export$4e93de6c22889f23 = [
    {
        id: "17a00v148yk1v36xtd",
        name: "Beer Countries",
        answers: [
            {
                id: "17a00v148yk1v36xti",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "Sales of 'craft beer' now out pace sales of 'domestic' beer in this country?",
                answerDe: "Sales of 'craft beer' now out pace sales of 'domestic' beer in this country?",
                question: "What is the United States.",
                explanation: "",
                points: 100,
                show: false,
                answered: false
            },
            {
                id: "17a00v148yk1v36xtn",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "In the capital city of this country you can visit St. James Gate, home of a famous stout and records.",
                answerDe: "In the capital city of this country you can visit St. James Gate, home of a famous stout and records.",
                question: "What is Ireland",
                explanation: "",
                points: 200,
                show: false,
                answered: false
            },
            {
                id: "17a00v148yk1v36xts",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "In this country you will find animals full of hop but not the beer that is marketed to be from here",
                answerDe: "In this country you will find animals full of hop but not the beer that is marketed to be from here",
                question: "What is Australia",
                explanation: "",
                points: 300,
                show: false,
                answered: false
            },
            {
                id: "17a00v148yk1v36xtx",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "This country requires brewers to abide by a set of 'purity laws' known as the Reinheitsgebot ",
                answerDe: "This country requires brewers to abide by a set of 'purity laws' known as the Reinheitsgebot ",
                question: "What is Germany",
                explanation: "",
                points: 400,
                show: false,
                answered: false
            },
            {
                id: "17a00v148yk1v36xu2",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "This European country is home to lambics, trippels and monks! ",
                answerDe: "This European country is home to lambics, trippels and monks! ",
                question: "What is Belguim",
                explanation: "",
                points: 500,
                show: false,
                answered: false
            }
        ]
    },
    {
        id: "17a00v148yk1v36xte",
        name: "Beer States",
        answers: [
            {
                id: "17a00v148yk1v36xtj",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "This state is home to nearly a 100 active breweries including the pre-prohibition brewery in the little town of Shiner.",
                answerDe: "This state is home to nearly a 100 active breweries including the pre-prohibition brewery in the little town of Shiner.",
                question: "What is Texas",
                explanation: "",
                points: 100,
                show: false,
                answered: false
            },
            {
                id: "17a00v148yk1v36xto",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "Visitors to this state can be lost in a 'Purple Haze' of beignets and beads",
                answerDe: "Visitors to this state can be lost in a 'Purple Haze' of beignets and beads",
                question: "What is Louisiana.",
                explanation: "",
                points: 200,
                show: false,
                answered: false
            },
            {
                id: "17a00v148yk1v36xtt",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "You can take part in bike tours to such breweries at Odells and Ft Collins Brewery in this state.",
                answerDe: "You can take part in bike tours to such breweries at Odells and Ft Collins Brewery in this state.",
                question: "What is Colorado",
                explanation: "",
                points: 300,
                show: false,
                answered: false
            },
            {
                id: "17a00v148yk1v36xty",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "A pioneer of the craft scene, use the PCH to explore this states brews and scenic views.",
                answerDe: "A pioneer of the craft scene, use the PCH to explore this states brews and scenic views.",
                question: "What is California.",
                explanation: "",
                points: 400,
                show: false,
                answered: false
            },
            {
                id: "17a00v148yk1v36xu3",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "This state also known for Pinot Noir and cherries, has people going 'full sail' to try the areas' hop heavy beers.",
                answerDe: "This state also known for Pinot Noir and cherries, has people going 'full sail' to try the areas' hop heavy beers.",
                question: "What is Oregon",
                explanation: "",
                points: 500,
                show: false,
                answered: false
            }
        ]
    },
    {
        id: "17a00v148yk1v36xtf",
        name: "Beer Styles",
        answers: [
            {
                id: "17a00v148yk1v36xtk",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "All beer can be categorized into two types of beer",
                answerDe: "All beer can be categorized into two types of beer",
                question: "What are Ales and Lagers",
                explanation: "",
                points: 100,
                show: false,
                answered: false
            },
            {
                id: "17a00v148yk1v36xtp",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "The style was said to have been created to survive the long ship voyages around the British Empire",
                answerDe: "The style was said to have been created to survive the long ship voyages around the British Empire",
                question: "What are IPAs.",
                explanation: "",
                points: 200,
                show: false,
                answered: false
            },
            {
                id: "17a00v148yk1v36xtu",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "This style, popular on St Patricks Day, often uses nitrogen instead of carbon dioxide to create a smooth creamy texture to offset its coffee-like bitterness",
                answerDe: "This style, popular on St Patricks Day, often uses nitrogen instead of carbon dioxide to create a smooth creamy texture to offset its coffee-like bitterness",
                question: "What is an Irish Stout",
                explanation: "",
                points: 300,
                show: false,
                answered: false
            },
            {
                id: "17a00v148yk1v36xtz",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "The style, popular with mass-produced beer was first created in the Czech Republic town of Pilsen. ",
                answerDe: "The style, popular with mass-produced beer was first created in the Czech Republic town of Pilsen. ",
                question: "What is a Pilsner.",
                explanation: "",
                points: 400,
                show: false,
                answered: false
            },
            {
                id: "17a00v148yk1v36xu4",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "this fruit beer originating in Belgium can either be sweet or sour.",
                answerDe: "this fruit beer originating in Belgium can either be sweet or sour.",
                question: "What is a lambic",
                explanation: "",
                points: 500,
                show: false,
                answered: false
            }
        ]
    },
    {
        id: "17a00v148yk1v36xtg",
        name: "Beer Slogans",
        answers: [
            {
                id: "17a00v148yk1v36xtl",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "I don't always drink beer but when I do..",
                answerDe: "I don't always drink beer but when I do..",
                question: "What is Dos Equis",
                explanation: "",
                points: 100,
                show: false,
                answered: false
            },
            {
                id: "17a00v148yk1v36xtq",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "It's Australian for beer",
                answerDe: "It's Australian for beer",
                question: "What is Fosters",
                explanation: "",
                points: 200,
                show: false,
                answered: false
            },
            {
                id: "17a00v148yk1v36xtv",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "Taste Great! Less Filing!",
                answerDe: "Taste Great! Less Filing!",
                question: "What is Miller Lite",
                explanation: "",
                points: 300,
                show: false,
                answered: false
            },
            {
                id: "17a00v148yk1v36xu0",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "Off centered ales for off centered people",
                answerDe: "Off centered ales for off centered people",
                question: "What is Dogfish Head",
                explanation: "",
                points: 400,
                show: false,
                answered: false
            },
            {
                id: "17a00v148yk1v36xu5",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "This Texas claims their blonde ale 'Goes Down Easy'",
                answerDe: "This Texas claims their blonde ale 'Goes Down Easy'",
                question: "What is Deep Ellum",
                explanation: "",
                points: 500,
                show: false,
                answered: false
            }
        ]
    },
    {
        id: "17a00v148yk1v36xth",
        name: "Potent Potables",
        answers: [
            {
                id: "17a00v148yk1v36xtm",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "Temptress, Rock Ryder, Punkel",
                answerDe: "Temptress, Rock Ryder, Punkel",
                question: "What is Lakewood",
                explanation: "",
                points: 100,
                show: false,
                answered: false
            },
            {
                id: "17a00v148yk1v36xtr",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "Lawnmower, Elissa, Spring Bock",
                answerDe: "Lawnmower, Elissa, Spring Bock",
                question: "What is St. Arnold",
                explanation: "",
                points: 200,
                show: false,
                answered: false
            },
            {
                id: "17a00v148yk1v36xtw",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "Great Scot!, Velvet Hammer, Wintervention",
                answerDe: "Great Scot!, Velvet Hammer, Wintervention",
                question: "What is Peticolas",
                explanation: "",
                points: 300,
                show: false,
                answered: false
            },
            {
                id: "17a00v148yk1v36xu1",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "Atrial Rubicite, Wytchmaker, Le Petite Prince",
                answerDe: "Atrial Rubicite, Wytchmaker, Le Petite Prince",
                question: "What is Jester King",
                explanation: "",
                points: 400,
                show: false,
                answered: false
            },
            {
                id: "17a00v148yk1v36xu6",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "Sculpin, Victory at sea, Dorado",
                answerDe: "Sculpin, Victory at sea, Dorado",
                question: "What is Ballast Point",
                explanation: "",
                points: 500,
                show: false,
                answered: false
            }
        ]
    }
];



const $fa3ddbeec3b8c08b$export$dadfe880f6d33e7c = [
    {
        id: "1qxjjkwk1sczm22",
        name: "History of the Internet",
        answers: [
            {
                id: "1qxjjkwk1sczm27",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "The amount of computers on the earliest form of the internet",
                question: "What is 4?",
                explanation: "",
                points: 100,
                show: false,
                answered: false
            },
            {
                id: "1qxjjkwk1sczm2c",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "The original name for the internet",
                question: "What is ARPANET?",
                explanation: "",
                points: 200,
                show: false,
                answered: false
            },
            {
                id: "1qxjjkwk1sczm2h",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "To make the internet more accessible, a swiss corp., called CERN, created this language",
                question: "What is HTTP?",
                explanation: "",
                points: 300,
                show: false,
                answered: false
            },
            {
                id: "1qxjjkwk1sczm2m",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "The first internet browser",
                question: "What is NetScape Navigator?",
                explanation: "",
                points: 400,
                show: false,
                answered: false
            },
            {
                id: "1qxjjkwk1sczm2r",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "A company that was originally made for illegally downloading music",
                question: "What is Napster?",
                explanation: "",
                points: 500,
                show: false,
                answered: false
            }
        ]
    },
    {
        id: "1qxjjkwk1sczm23",
        name: "The Olden Days",
        answers: [
            {
                id: "1qxjjkwk1sczm28",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "A method of saving your work from your computer",
                question: "What is a floppy disk?",
                explanation: "",
                points: 100,
                show: false,
                answered: false
            },
            {
                id: "1qxjjkwk1sczm2d",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "An item music was saved on",
                question: "What is a cassette tape?",
                explanation: "",
                points: 200,
                show: false,
                answered: false
            },
            {
                id: "1qxjjkwk1sczm2i",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "A piece of your entertainment system that plays VHS tapes",
                question: "What is a VCR?",
                explanation: "",
                points: 300,
                show: false,
                answered: false
            },
            {
                id: "1qxjjkwk1sczm2n",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "A portable cassette player",
                question: "What is a walkman?",
                explanation: "",
                points: 400,
                show: false,
                answered: false
            },
            {
                id: "1qxjjkwk1sczm2s",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "The storage capacity of a floppy disk",
                question: "What is 1.44 mb?",
                explanation: "",
                points: 500,
                show: false,
                answered: false
            }
        ]
    },
    {
        id: "1qxjjkwk1sczm24",
        name: "Websites",
        answers: [
            {
                id: "1qxjjkwk1sczm29",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                question: "YouTube",
                answer: "A website to watch popular videos on",
                explanation: "",
                points: 100,
                show: false,
                answered: false
            },
            {
                id: "1qxjjkwk1sczm2e",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "A social media that includes a body part in the title",
                question: "What is Facebook?",
                explanation: "",
                points: 200,
                show: false,
                answered: false
            },
            {
                id: "1qxjjkwk1sczm2j",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "The most common search engine among men",
                question: "What is Google?",
                explanation: "",
                points: 300,
                show: false,
                answered: false
            },
            {
                id: "1qxjjkwk1sczm2o",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "The most pirated website in America",
                question: "What is Wikipedia?",
                explanation: "",
                points: 400,
                show: false,
                answered: false
            },
            {
                id: "1qxjjkwk1sczm2t",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "A place where you can find the things that you've missed, lost, or haven't done.",
                question: "What is your teacher's homepage?",
                explanation: "",
                points: 500,
                show: false,
                answered: false
            }
        ]
    },
    {
        id: "1qxjjkwk1sczm25",
        name: "Movie Quotes",
        answers: [
            {
                id: "1qxjjkwk1sczm2a",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: '"Just keep swimming!"',
                question: "What is nemo",
                explanation: "",
                points: 100,
                show: false,
                answered: false
            },
            {
                id: "1qxjjkwk1sczm2f",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: '"You\'re killing me, smalls."',
                question: "What is sand lot.",
                explanation: "",
                points: 200,
                show: false,
                answered: false
            },
            {
                id: "1qxjjkwk1sczm2k",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "\"It's so fluffy I'm gonna die!\"",
                question: "What is despicable me",
                explanation: "",
                points: 300,
                show: false,
                answered: false
            },
            {
                id: "1qxjjkwk1sczm2p",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: '"I\'ll Be back."',
                question: "What is Terminator",
                explanation: "",
                points: 400,
                show: false,
                answered: false
            },
            {
                id: "1qxjjkwk1sczm2u",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: '"Don\'t get cocky, kid."',
                question: 'What is Star Wars "A New Hope"',
                explanation: "",
                points: 500,
                show: false,
                answered: false
            }
        ]
    },
    {
        id: "1qxjjkwk1sczm26",
        name: "Grab Bag",
        answers: [
            {
                id: "1qxjjkwk1sczm2b",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "An item that sounds like it can be eaten but is destroyed when let go.",
                question: "What is Apple",
                explanation: "",
                points: 100,
                show: false,
                answered: false
            },
            {
                id: "1qxjjkwk1sczm2g",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "You have three doors and you must choose one to go through. Door one is a group of assassins waiting to kill you in door two is a lion whom hasn't eaten for three months and in door three is a fire that has consumed the room. which door do you go through?",
                question: "What is door two. Because the lion is dead it hasn't eaten for three months.",
                explanation: "",
                points: 200,
                show: false,
                answered: false
            },
            {
                id: "1qxjjkwk1sczm2l",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "Mary\u2019s father has 5 daughters \u2013 Nana, Nene, Nini, Nono. What is the fifth daughters name?",
                question: "If you answered Nunu, you are wrong. It\u2019s Mary!",
                explanation: "",
                points: 300,
                show: false,
                answered: false
            },
            {
                id: "1qxjjkwk1sczm2q",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "what's hi in the middle and round on both ends?",
                question: "What is Ohio",
                explanation: "",
                points: 400,
                show: false,
                answered: false
            },
            {
                id: "1qxjjkwk1sczm2v",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: " What is so delicate that saying its name breaks it?\n",
                question: "What is Silence.",
                explanation: "",
                points: 500,
                show: false,
                answered: false
            }
        ]
    }
];



const $f4cabcbd96daf858$export$c4e4b485d6643fb4 = [
    {
        id: "1qxjjd4k1scs3a0",
        name: "Sing-a-long",
        answers: [
            {
                id: "1qxjjd4k1scs3a5",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: 'Which movie does this lyric come from-- "And then i\'ll brush and brush and brush and brush my hair"?',
                question: "Rapunzel",
                explanation: "",
                points: 100,
                show: false,
                answered: false
            },
            {
                id: "1qxjjd4k1scs3aa",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "Name a song from the Lion King",
                question: "Circle of Life, I Just Can't Wait to be King, Hakuna Matata, Can You Feel the Love Tonight, Be Prepared",
                explanation: "",
                points: 200,
                show: false,
                answered: false
            },
            {
                id: "1qxjjd4k1scs3af",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "Song that Meg sings in Hercules when she is confused about her feelings.",
                question: "What is I won't say I'm in love?",
                explanation: "",
                points: 300,
                show: false,
                answered: false
            },
            {
                id: "1qxjjd4k1scs3ak",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "What is the Song that Jasmine and Aladdin sing together?",
                question: "What is A Whole New World?",
                explanation: "",
                points: 400,
                show: false,
                answered: false
            },
            {
                id: "1qxjjd4k1scs3ap",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "What is the name of the main song in Zootopia?",
                question: "Try Everything",
                explanation: "",
                points: 500,
                show: false,
                answered: false
            }
        ]
    },
    {
        id: "1qxjjd4k1scs3a1",
        name: "Star Wars and Marvel",
        answers: [
            {
                id: "1qxjjd4k1scs3a6",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "What is the name of the new Avengers movie?",
                question: "Avengers: Endgame",
                explanation: "",
                points: 100,
                show: false,
                answered: false
            },
            {
                id: "1qxjjd4k1scs3ab",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "What is the name of Star-Lord's ship in Guardians of the Galaxy?",
                question: "Milano",
                explanation: "",
                points: 200,
                show: false,
                answered: false
            },
            {
                id: "1qxjjd4k1scs3ag",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "What is the name of Han Solo's ship?",
                question: "Millennium Falcon",
                explanation: "",
                points: 300,
                show: false,
                answered: false
            },
            {
                id: "1qxjjd4k1scs3al",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "What young Jedi Knight becomes Darth Vader in Star Wards?",
                question: "Anakin Skywalker",
                explanation: "",
                points: 400,
                show: false,
                answered: false
            },
            {
                id: "1qxjjd4k1scs3aq",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "Where did Iron Man first face off against Whiplash? ",
                question: "Monaco",
                explanation: "",
                points: 500,
                show: false,
                answered: false
            }
        ]
    },
    {
        id: "1qxjjd4k1scs3a2",
        name: "Pixar Movies",
        answers: [
            {
                id: "1qxjjd4k1scs3a7",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "What animated feature film was Pixar's first release in 1995?",
                question: "Toy Story",
                explanation: "",
                points: 100,
                show: false,
                answered: false
            },
            {
                id: "1qxjjd4k1scs3ac",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: 'The movie "WALL-E" features a robot of the same name. What is his job?',
                question: "Trash Collector",
                explanation: "",
                points: 200,
                show: false,
                answered: false
            },
            {
                id: "1qxjjd4k1scs3ah",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: 'What Pixar character says, "No matter how many times you save the world, it always manages to get back in jeopardy again?"',
                question: "Mr. Incredible",
                explanation: "",
                points: 300,
                show: false,
                answered: false
            },
            {
                id: "1qxjjd4k1scs3am",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: 'What European city is the setting for the 2007 movie "Ratatouille?" ',
                question: "Paris",
                explanation: "",
                points: 400,
                show: false,
                answered: false
            },
            {
                id: "1qxjjd4k1scs3ar",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: 'In the Oscar-winning movie "Up," where does character Carl Fredricksen move his house? ',
                question: "Paradise Falls",
                explanation: "",
                points: 500,
                show: false,
                answered: false
            }
        ]
    },
    {
        id: "1qxjjd4k1scs3a3",
        name: "Princesses",
        answers: [
            {
                id: "1qxjjd4k1scs3a8",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "Name the only Disney Princess based on a real life person. ",
                question: "Pocahontas ",
                explanation: "",
                points: 100,
                show: false,
                answered: false
            },
            {
                id: "1qxjjd4k1scs3ad",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "Name the only Disney Princess with hazel eyes. ",
                question: "Belle ",
                explanation: "",
                points: 200,
                show: false,
                answered: false
            },
            {
                id: "1qxjjd4k1scs3ai",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "Who are three princesses who had evil stepmothers? ",
                question: "Snow White, Cinderella, Rapunzel ",
                explanation: "",
                points: 300,
                show: false,
                answered: false
            },
            {
                id: "1qxjjd4k1scs3an",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "Name the 2 Disney Princesses who have red hair.",
                question: "Princess Merida, Ariel (The Little Mermaid)",
                explanation: "",
                points: 400,
                show: false,
                answered: false
            },
            {
                id: "1qxjjd4k1scs3as",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "What Disney princess movie was the first to show war?",
                question: "Mulan",
                explanation: "",
                points: 500,
                show: false,
                answered: false
            }
        ]
    },
    {
        id: "1qxjjd4k1scs3a4",
        name: "Movies",
        answers: [
            {
                id: "1qxjjd4k1scs3a9",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "What is the only Disney animated feature film that has a title character who doesn't speak?",
                question: "Dumbo",
                explanation: "",
                points: 100,
                show: false,
                answered: false
            },
            {
                id: "1qxjjd4k1scs3ae",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "Who was the first Disney princess?",
                question: "Snow White",
                explanation: "",
                points: 200,
                show: false,
                answered: false
            },
            {
                id: "1qxjjd4k1scs3aj",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "Which character in Frozen likes warm hugs?",
                question: "Olaf",
                explanation: "",
                points: 300,
                show: false,
                answered: false
            },
            {
                id: "1qxjjd4k1scs3ao",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "Where do the lions live in the Lion King? ",
                question: "Pride Rock",
                explanation: "",
                points: 400,
                show: false,
                answered: false
            },
            {
                id: "1qxjjd4k1scs3at",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "Name the 7 dwarfs",
                question: "Doc, Sleepy, Grumpy, Happy, Dopey, Sneezy, Bashful\xa0",
                explanation: "",
                points: 500,
                show: false,
                answered: false
            }
        ]
    }
];



const $c75538985e94d2d7$export$aadba46dd1628141 = [
    {
        id: "1qxjj4uk1scgk09",
        name: "Name That Port",
        answers: [
            {
                id: "1qxjj4uk1scgk0e",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "443",
                question: "What is HTTPS?",
                explanation: "",
                points: 100,
                show: false,
                answered: false
            },
            {
                id: "1qxjj4uk1scgk0j",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "22",
                question: "What is SSH?",
                explanation: "",
                points: 200,
                show: false,
                answered: false
            },
            {
                id: "1qxjj4uk1scgk0o",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "3306",
                question: "What is MySQL?",
                explanation: "",
                points: 300,
                show: false,
                answered: false
            },
            {
                id: "1qxjj4uk1scgk0t",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "445",
                question: "What is SMB (or CIFS)?",
                explanation: "",
                points: 400,
                show: false,
                answered: false
            },
            {
                id: "1qxjj4uk1scgk0y",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "3389",
                question: "What is Remote Desktop Protocol (RDP)?",
                explanation: "",
                points: 500,
                show: false,
                answered: false
            }
        ]
    },
    {
        id: "1qxjj4uk1scgk0a",
        name: "Hello World",
        answers: [
            {
                id: "1qxjj4uk1scgk0f",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "",
                question: "What is Python?",
                explanation: "",
                points: 100,
                show: false,
                answered: false
            },
            {
                id: "1qxjj4uk1scgk0k",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "",
                question: "What is Java?",
                explanation: "",
                points: 200,
                show: false,
                answered: false
            },
            {
                id: "1qxjj4uk1scgk0p",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "",
                question: "What is JavaScript?",
                explanation: "",
                points: 300,
                show: false,
                answered: false
            },
            {
                id: "1qxjj4uk1scgk0u",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "",
                question: "What is Go?",
                explanation: "",
                points: 400,
                show: false,
                answered: false
            },
            {
                id: "1qxjj4uk1scgk0z",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "",
                question: "What is C#?",
                explanation: "",
                points: 500,
                show: false,
                answered: false
            }
        ]
    },
    {
        id: "1qxjj4uk1scgk0b",
        name: "Web Acroynms",
        answers: [
            {
                id: "1qxjj4uk1scgk0g",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "WWW",
                question: "What is 'World Wide Web'?",
                explanation: "",
                points: 100,
                show: false,
                answered: false
            },
            {
                id: "1qxjj4uk1scgk0l",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "HTTP",
                question: "What is 'Hypertext Transfer Protocol'?",
                explanation: "",
                points: 200,
                show: false,
                answered: false
            },
            {
                id: "1qxjj4uk1scgk0q",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "CSS",
                question: "What is 'Cascading Style Sheets'?",
                explanation: "",
                points: 300,
                show: false,
                answered: false
            },
            {
                id: "1qxjj4uk1scgk0v",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "TLS",
                question: "What is 'Transport Layer Security'?",
                explanation: "",
                points: 400,
                show: false,
                answered: false
            },
            {
                id: "1qxjj4uk1scgk10",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "CORS",
                question: "What is 'Cross Origin Resource Sharing'?",
                explanation: "",
                points: 500,
                show: false,
                answered: false
            }
        ]
    },
    {
        id: "1qxjj4uk1scgk0c",
        name: "Hacker Crews",
        answers: [
            {
                id: "1qxjj4uk1scgk0h",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "Cyper, Thank, Switch, Trinity, Morpheus, Neo",
                question: "What is 'The Matrix'?",
                explanation: "",
                points: 100,
                show: false,
                answered: false
            },
            {
                id: "1qxjj4uk1scgk0m",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "Eliot Anderson, Darlene, Tyrell Wellick, fsociety",
                question: "What is 'Mr. Robot'?",
                explanation: "",
                points: 200,
                show: false,
                answered: false
            },
            {
                id: "1qxjj4uk1scgk0r",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "The Plague, Phantom Phreak, Crash Override, Zero Cool, Acid Burn",
                question: "What is 'Hackers'?",
                explanation: "",
                points: 300,
                show: false,
                answered: false
            },
            {
                id: "1qxjj4uk1scgk0w",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "Batou, Togusa, Saito, Ishikawa, Motoko ('The Major')",
                question: "What is 'Ghost in the Shell'?",
                explanation: "",
                points: 400,
                show: false,
                answered: false
            },
            {
                id: "1qxjj4uk1scgk11",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "Count Zero, Brian Oblivion, Space Rogue, Kingpin, Mudge",
                question: "What is L0pht?",
                explanation: "",
                points: 500,
                show: false,
                answered: false
            }
        ]
    },
    {
        id: "1qxjj4uk1scgk0d",
        name: "Famous Hacks",
        answers: [
            {
                id: "1qxjj4uk1scgk0i",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "Film studio that was allegedly hacked for making a movie about North Korean leader Kim Jong-Un",
                question: "What is Sony?",
                explanation: "",
                points: 100,
                show: false,
                answered: false
            },
            {
                id: "1qxjj4uk1scgk0n",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "This adult infidelity site had its user list released after refusing to shut down.",
                question: "What is Ashley Madison?",
                explanation: "",
                points: 200,
                show: false,
                answered: false
            },
            {
                id: "1qxjj4uk1scgk0s",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "This credit agency was hacked and 149 million Americans' personal information was leaked",
                question: "What is Equifax?",
                explanation: "",
                points: 300,
                show: false,
                answered: false
            },
            {
                id: "1qxjj4uk1scgk0x",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "This retail chain was breached through a 3rd party HVAC system's credentials and lost 41 million customers' credit card information",
                question: "What is Target?",
                explanation: "",
                points: 400,
                show: false,
                answered: false
            },
            {
                id: "1qxjj4uk1scgk12",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "Probably the most publicized nation state cyberattack, this worm was designed to destroy nuclear reactors and was unleashed against Iran",
                question: "What is Stuxnet?",
                explanation: "",
                points: 500,
                show: false,
                answered: false
            }
        ]
    }
];



const $6db06f3ec958f9bb$export$5c8983c1806c510f = [
    {
        id: "1qxjj0ek1sccaie",
        name: "Cartons",
        answers: [
            {
                id: "1qxjj0ek1sccaij",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "A cartoon about a sponge in the ocean.",
                question: "What is SpongeBob SquarePants?",
                explanation: "",
                points: 100,
                show: false,
                answered: false
            },
            {
                id: "1qxjj0ek1sccaio",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "A show about a little boy who has Fairy God parents.",
                question: "What is The Fairly Odd Parents?",
                explanation: "",
                points: 200,
                show: false,
                answered: false
            },
            {
                id: "1qxjj0ek1sccait",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "A show about ponies and friendship. ",
                question: "What is My Little Pony Friendship is Magic?",
                explanation: "",
                points: 300,
                show: false,
                answered: false
            },
            {
                id: "1qxjj0ek1sccaiy",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "A show about 3 super powered girls fighting crime.",
                question: "What is The Power Puff Girls?",
                explanation: "",
                points: 400,
                show: false,
                answered: false
            },
            {
                id: "1qxjj0ek1sccaj3",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "An older show about a Samurai fighting to save the world from robots.",
                question: "What is Samurai Jack?",
                explanation: "",
                points: 500,
                show: false,
                answered: false
            }
        ]
    },
    {
        id: "1qxjj0ek1sccaif",
        name: "Popular Board games",
        answers: [
            {
                id: "1qxjj0ek1sccaik",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "A game in which you are a entrepreneur buying properties in order to expand your wealth. ",
                question: "What is Monopoly? ",
                explanation: "",
                points: 100,
                show: false,
                answered: false
            },
            {
                id: "1qxjj0ek1sccaip",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "A game about bringing all your pawns home,it is remembered for its iconic saying when you screw someone over. ",
                question: "What is Sorry?",
                explanation: "",
                points: 200,
                show: false,
                answered: false
            },
            {
                id: "1qxjj0ek1sccaiu",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "A game about losing all your cards by playing the same number or color down on a discard pile.",
                question: "What is Uno?",
                explanation: "",
                points: 300,
                show: false,
                answered: false
            },
            {
                id: "1qxjj0ek1sccaiz",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "A classic game about finding a murderer through searching a house.",
                question: "What is Clue?",
                explanation: "",
                points: 400,
                show: false,
                answered: false
            },
            {
                id: "1qxjj0ek1sccaj4",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "A game about through the process of elimination finding out which character your opponent is",
                question: "What is Guess Who?",
                explanation: "",
                points: 500,
                show: false,
                answered: false
            }
        ]
    },
    {
        id: "1qxjj0ek1sccaig",
        name: "Minecraft",
        answers: [
            {
                id: "1qxjj0ek1sccail",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "A famous mod due to its green skin and explosive property.\n ",
                question: "What is the Creeper?",
                explanation: "",
                points: 100,
                show: false,
                answered: false
            },
            {
                id: "1qxjj0ek1sccaiq",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "The bosses in vanilla minecraft. ",
                question: "What is the ender dragon and the wither?",
                explanation: "",
                points: 200,
                show: false,
                answered: false
            },
            {
                id: "1qxjj0ek1sccaiv",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "A mineral used to carry electric charge.",
                question: "What is Redstone?",
                explanation: "",
                points: 300,
                show: false,
                answered: false
            },
            {
                id: "1qxjj0ek1sccaj0",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "The rarest mineral found underground.",
                question: "What is Emerald? ",
                explanation: "",
                points: 400,
                show: false,
                answered: false
            },
            {
                id: "1qxjj0ek1sccaj5",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "DOUBLE JEPORDY!!!The CURRANT CEO of minecraft.",
                question: "Who is Jeb or Jens?",
                explanation: "",
                points: 500,
                show: false,
                answered: false
            }
        ]
    },
    {
        id: "1qxjj0ek1sccaih",
        name: "Food",
        answers: [
            {
                id: "1qxjj0ek1sccaim",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "A Main food group including meat and beans.",
                question: "What is Protein? ",
                explanation: "",
                points: 100,
                show: false,
                answered: false
            },
            {
                id: "1qxjj0ek1sccair",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "A item baked in a oven normally round by itself.",
                question: "What is Cake?",
                explanation: "",
                points: 200,
                show: false,
                answered: false
            },
            {
                id: "1qxjj0ek1sccaiw",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "Comes from the inside of trees then is turned into this through heating. ",
                question: "What is Maple syrup?\n",
                explanation: "",
                points: 300,
                show: false,
                answered: false
            },
            {
                id: "1qxjj0ek1sccaj1",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "A food made by obtaining this bean and adding hot water.",
                question: "What is Coffee?",
                explanation: "",
                points: 400,
                show: false,
                answered: false
            },
            {
                id: "1qxjj0ek1sccaj6",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "A Grow able type of food with a hard outside and the edible portion on the inside. ",
                question: "What is Goren.",
                explanation: "",
                points: 500,
                show: false,
                answered: false
            }
        ]
    },
    {
        id: "1qxjj0ek1sccaii",
        name: "Video Game Characters",
        answers: [
            {
                id: "1qxjj0ek1sccain",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "A fat Italian plumber's pet.  ",
                question: "What is Yoshi?",
                explanation: "",
                points: 100,
                show: false,
                answered: false
            },
            {
                id: "1qxjj0ek1sccais",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "A famous hero who wears green, A.K.A the Hero of Time.",
                question: "Who is Link?",
                explanation: "",
                points: 200,
                show: false,
                answered: false
            },
            {
                id: "1qxjj0ek1sccaix",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "A Female character genitally modified with bird D.N.A  welding a charge up ion cannon.",
                question: "Who is Samus Aran?",
                explanation: "",
                points: 300,
                show: false,
                answered: false
            },
            {
                id: "1qxjj0ek1sccaj2",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "A pink character who can suck enemies up and gain their abilities.  ",
                question: "Who is Kirby?",
                explanation: "",
                points: 400,
                show: false,
                answered: false
            },
            {
                id: "1qxjj0ek1sccaj7",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "A Humanoid robot wearing blue fighting an insane doctor.  ",
                question: "Who is Megaman? ",
                explanation: "",
                points: 500,
                show: false,
                answered: false
            }
        ]
    }
];



const $bb377d18fc64e5cf$export$5a36437df7ef175a = [
    {
        id: "1qxjiv9k1sca3q6",
        name: "Dungeons and Dragons",
        answers: [
            {
                id: "1qxjiv9k1sca3qb",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "This game mechanic dictates whom makes the first move in a combat scenario.",
                question: 'What is "Initiative"?',
                explanation: "",
                points: 100,
                show: false,
                answered: false
            },
            {
                id: "1qxjiv9k1sca3qg",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "This player class first debuted in 2004 as an alternative to the edition\u2019s core magic classes, but has since been included as a core class itself in both 4th and 5th editions ",
                question: "What is the Warlock?",
                explanation: "",
                points: 200,
                show: false,
                answered: false
            },
            {
                id: "1qxjiv9k1sca3ql",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "These monsters are typically subdivided into \u201Cchromatic\u201D and \u201Cmetallic\u201D versions, but other variants have been widely published. ",
                question: "What are dragons?",
                explanation: "",
                points: 300,
                show: false,
                answered: false
            },
            {
                id: "1qxjiv9k1sca3qq",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "Casting this iconic spell requires a tiny amount of excrement from a nocturnal flying mammal. ",
                question: "What is Fireball?",
                explanation: "",
                points: 400,
                show: false,
                answered: false
            },
            {
                id: "1qxjiv9k1sca3qv",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "This author won Wizards of the Coast\u2019s Fantasy Setting Search in 2002, bringing his Eberron campaign setting to D&D players around the world. ",
                question: "Who is Keith Baker?",
                explanation: "",
                points: 500,
                show: false,
                answered: false
            }
        ]
    },
    {
        id: "1qxjiv9k1sca3q7",
        name: "Disney Films",
        answers: [
            {
                id: "1qxjiv9k1sca3qc",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "This animated film, based on a book of the same name by Rudyard Kipling, was the last Walt Disney produced before his death in 1966. ",
                question: "What is The Jungle Book?",
                explanation: "",
                points: 100,
                show: false,
                answered: false
            },
            {
                id: "1qxjiv9k1sca3qh",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "This song, which was the third duet sung by a Disney Prince and Princess, was also the only Disney song to win a Grammy award for Song of the Year. ",
                question: 'What is "A Whole New World"?',
                explanation: "",
                points: 200,
                show: false,
                answered: false
            },
            {
                id: "1qxjiv9k1sca3qm",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "Tony Jay supplied the voice for this character, the villain of an animated film set in historic Paris. ",
                question: "Who is Judge Claude Frollo?",
                explanation: "",
                points: 300,
                show: false,
                answered: false
            },
            {
                id: "1qxjiv9k1sca3qr",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "This 1940 animated film was released in only 14 theaters worldwide, due to its complicated sound system designed to simulate a live symphony orchestra. ",
                question: "What is Fantasia?",
                explanation: "",
                points: 400,
                show: false,
                answered: false
            },
            {
                id: "1qxjiv9k1sca3qw",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "Walt Disney originally considered producing this full-length animated feature as a live action film with Mary Martin playing the lead role. ",
                question: "What is\xa0Peter Pan?",
                explanation: "",
                points: 500,
                show: false,
                answered: false
            }
        ]
    },
    {
        id: "1qxjiv9k1sca3q8",
        name: "Lord of the Rings",
        answers: [
            {
                id: "1qxjiv9k1sca3qd",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "This character started the series under a different color designation, but finishes the series as \u201Cthe White.\u201D ",
                question: "Who is Gandalf?",
                explanation: "",
                points: 100,
                show: false,
                answered: false
            },
            {
                id: "1qxjiv9k1sca3qi",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: 'This "hobbit-y" director brought the Lord of the Rings trilogy into the new millennium with an award-winning series of films based on these novels. ',
                question: "Who is Peter Jackson?",
                explanation: "",
                points: 200,
                show: false,
                answered: false
            },
            {
                id: "1qxjiv9k1sca3qn",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "This prequel to the Lord of the Rings trilogy includes the story of the creation of Ea, the fictional setting for these books. ",
                question: "What is\xa0The Silmarillion?",
                explanation: "",
                points: 300,
                show: false,
                answered: false
            },
            {
                id: "1qxjiv9k1sca3qs",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "This ring of power was wielded by Galadriel, and lent it\u2019s preservative powers to her domain, Lorien. ",
                question: "What is Nenya?",
                explanation: "",
                points: 400,
                show: false,
                answered: false
            },
            {
                id: "1qxjiv9k1sca3qx",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "With it\u2019s counterpart Quenya, Tolkien invented this language, spoken by the \u201CGray Elves\u201D of Middle-Earth. ",
                question: "What is Sindarin?",
                explanation: "",
                points: 500,
                show: false,
                answered: false
            }
        ]
    },
    {
        id: "1qxjiv9k1sca3q9",
        name: "Harry Potter",
        answers: [
            {
                id: "1qxjiv9k1sca3qe",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "This magical location in London is the first place Harry and Hagrid go to while retrieving Harry\u2019s school supplies in Harry Potter and the Philosopher\u2019s Stone. ",
                question: "What is the Leaky Cauldron?",
                explanation: "",
                points: 100,
                show: false,
                answered: false
            },
            {
                id: "1qxjiv9k1sca3qj",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "This character, who shares a dorm room with Hermione Granger and Lavender Brown, has a twin sister in a different Hogwarts house. ",
                question: "Who is Pavarti Patil?",
                explanation: "",
                points: 200,
                show: false,
                answered: false
            },
            {
                id: "1qxjiv9k1sca3qo",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "Nosebleed Nougat and Fever Fudge are two varieties of this joke-store product invented and produced by the Weasley twins. ",
                question: "What are Skiving Snackboxes?",
                explanation: "",
                points: 300,
                show: false,
                answered: false
            },
            {
                id: "1qxjiv9k1sca3qt",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "This incantation can be used to magically lock a door, and prevents it being unlocked by non-magical methods. ",
                question: "What is Colloportus?",
                explanation: "",
                points: 400,
                show: false,
                answered: false
            },
            {
                id: "1qxjiv9k1sca3qy",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "Albus Dumbledore enjoys this sport, according to his Chocolate Frog Card. ",
                question: "What is Ten-pin Bowling?",
                explanation: "",
                points: 500,
                show: false,
                answered: false
            }
        ]
    },
    {
        id: "1qxjiv9k1sca3qa",
        name: "Marvel Cinematic Universe",
        answers: [
            {
                id: "1qxjiv9k1sca3qf",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "\xa0This main character of the feature film Black Panther is the king of the fictional nation of Wakanda. ",
                question: "Who is T'Challa?",
                explanation: "",
                points: 100,
                show: false,
                answered: false
            },
            {
                id: "1qxjiv9k1sca3qk",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "The All-Seeing Asgardian Heimdall stands over this multicolored interdimensional bridge.\xa0",
                question: "What is Bifrost?",
                explanation: "",
                points: 200,
                show: false,
                answered: false
            },
            {
                id: "1qxjiv9k1sca3qp",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "While many Marvel superhero-themed movies were produced prior, this move debuted the current \u201CMarvel Cinematic Universe\u201D shared media universe of Marvel intellectual properties with a cohesive story arc in 2008. ",
                question: "What is\xa0Ironman?",
                explanation: "",
                points: 300,
                show: false,
                answered: false
            },
            {
                id: "1qxjiv9k1sca3qu",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "In the 2017 movie Thor: Ragnarok, the character Hela (played by Cate Blanchett) is a child of this recurrent character. ",
                question: "Who is Odin?",
                explanation: "",
                points: 400,
                show: false,
                answered: false
            },
            {
                id: "1qxjiv9k1sca3qz",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "One of the \u201CInfinity Stones\u201D was introduced as a time-bending magical artifact in 2016\u2019s Dr. Strange under this eponymous moniker. ",
                question: "What is the Eye of Agamotto?",
                explanation: "",
                points: 500,
                show: false,
                answered: false
            }
        ]
    }
];



const $be23e17c7319b52f$export$38117332247deace = [
    {
        id: "1qxjhsok1sby64a",
        name: "Ghibli females",
        answers: [
            {
                id: "1qxjhsok1sby64f",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "This female lead glides around and was first for doing so",
                question: "What is Nausciaa",
                explanation: "",
                points: 100,
                show: false,
                answered: false
            },
            {
                id: "1qxjhsok1sby64k",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "A character who works to save her family after a detour gone wrong",
                question: "What is Chihiro",
                explanation: "",
                points: 200,
                show: false,
                answered: false
            },
            {
                id: "1qxjhsok1sby64p",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "These two girls try to adjust to country living",
                question: "What is Mei and satsuki",
                explanation: "",
                points: 300,
                show: false,
                answered: false
            },
            {
                id: "1qxjhsok1sby64u",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "This Girl was adapted from the novel which shares this name",
                question: "What is Kiki",
                explanation: "",
                points: 400,
                show: false,
                answered: false
            },
            {
                id: "1qxjhsok1sby64z",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "One of the few films not to be directed by Mizayaki. The story follows this Princess",
                question: "What is Kaguya",
                explanation: "",
                points: 500,
                show: false,
                answered: false
            }
        ]
    },
    {
        id: "1qxjhsok1sby64b",
        name: "Pompadorable",
        answers: [
            {
                id: "1qxjhsok1sby64g",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "This character can be found at the local Boobies",
                question: "What is dandy",
                explanation: "",
                points: 100,
                show: false,
                answered: false
            },
            {
                id: "1qxjhsok1sby64l",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "This character may be Crazy. But he shines like a diamond",
                question: "What is Jojosuke",
                explanation: "",
                points: 200,
                show: false,
                answered: false
            },
            {
                id: "1qxjhsok1sby64q",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "This character from 'Danganronpa' has had their hair compared to a corn cob",
                question: "What is Mondo oowada",
                explanation: "",
                points: 300,
                show: false,
                answered: false
            },
            {
                id: "1qxjhsok1sby64v",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "His name is his weapon in 'One Punch man'",
                question: "What is metal bat",
                explanation: "",
                points: 400,
                show: false,
                answered: false
            },
            {
                id: "1qxjhsok1sby650",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "This character was part of the awakening lab in mob psycho 100",
                question: "What is Hoshino",
                explanation: "",
                points: 500,
                show: false,
                answered: false
            }
        ]
    },
    {
        id: "1qxjhsok1sby64c",
        name: "Jojo Parts",
        answers: [
            {
                id: "1qxjhsok1sby64h",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "Steel ball run is a re-imagining of this part",
                question: "What is Phantom blood",
                explanation: "",
                points: 100,
                show: false,
                answered: false
            },
            {
                id: "1qxjhsok1sby64m",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "The only jojo part to have a female lead",
                question: "What is stone ocean",
                explanation: "",
                points: 200,
                show: false,
                answered: false
            },
            {
                id: "1qxjhsok1sby64r",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "'It just works' is a joke originating from this part",
                question: "What is vento aureo",
                explanation: "",
                points: 300,
                show: false,
                answered: false
            },
            {
                id: "1qxjhsok1sby64w",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "This part was only officially announced as part of jojo when it switched magazines",
                question: "What is steel ball run",
                explanation: "",
                points: 400,
                show: false,
                answered: false
            },
            {
                id: "1qxjhsok1sby651",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "This part features a jojo who was part of the army, only for them to be murdered",
                question: "What is battle tendency",
                explanation: "",
                points: 500,
                show: false,
                answered: false
            }
        ]
    },
    {
        id: "1qxjhsok1sby64d",
        name: "short and sweet",
        answers: [
            {
                id: "1qxjhsok1sby64i",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "This series follows a cop in 3 minute episodes",
                question: "What is inferno cop",
                explanation: "",
                points: 100,
                show: false,
                answered: false
            },
            {
                id: "1qxjhsok1sby64n",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "Nova-kun is a key character in this show",
                question: "What is space patrol luluco",
                explanation: "",
                points: 200,
                show: false,
                answered: false
            },
            {
                id: "1qxjhsok1sby64s",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "this short series follows a shinobi during feudal japan",
                question: "What is Nobunaga no shinobi",
                explanation: "",
                points: 300,
                show: false,
                answered: false
            },
            {
                id: "1qxjhsok1sby64x",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "Sealand is featured in this series",
                question: "What is Hetalia",
                explanation: "",
                points: 400,
                show: false,
                answered: false
            },
            {
                id: "1qxjhsok1sby652",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "This shows features statues as the main characters",
                question: "What is Sekkou boys",
                explanation: "",
                points: 500,
                show: false,
                answered: false
            }
        ]
    },
    {
        id: "1qxjhsok1sby64e",
        name: "shoujo is Mahou",
        answers: [
            {
                id: "1qxjhsok1sby64j",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "The first series of sailor moon is this many episodes",
                question: "What is 46",
                explanation: "",
                points: 100,
                show: false,
                answered: false
            },
            {
                id: "1qxjhsok1sby64o",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "Madoka magica is written by this unexpected writer",
                question: "What is Gen urobuchi",
                explanation: "",
                points: 200,
                show: false,
                answered: false
            },
            {
                id: "1qxjhsok1sby64t",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "This show is a spin off of the 'fate' series",
                question: "What is Fate/kaleid liner Prisma Illya",
                explanation: "",
                points: 300,
                show: false,
                answered: false
            },
            {
                id: "1qxjhsok1sby64y",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "This mahou shouojo show was made into a movie by hideaki anno",
                question: "What is cutie honey",
                explanation: "",
                points: 400,
                show: false,
                answered: false
            },
            {
                id: "1qxjhsok1sby653",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "Little witch academia's 'Akko' shares her name from this manga",
                question: "What is himitsu no akko-chan",
                explanation: "",
                points: 500,
                show: false,
                answered: false
            }
        ]
    }
];



const $0a54af1ae5987a97$export$e6b0144278681479 = [
    {
        id: "1qxjh6uk1sbd7yc",
        name: "Famous Hackers",
        answers: [
            {
                id: "1qxjh6uk1sbd7yj",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: 'This individual spent 8 months in solitary confinement, because law enforcement officials convinced a judge that he had the ability to "start a nuclear war by whistling into a pay phone"',
                question: "Who is Kevin Mitnick",
                explanation: "",
                points: 100,
                show: false,
                answered: false
            },
            {
                id: "1qxjh6uk1sbd7yq",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "This scientist was tasked to track down a .75 cent discrepancy on a dial up phone bill and subsequently discovered the largest cyber attack against the United States. He also wrote a book about it.",
                question: "Who is Cliff (Clifford) Stoll\xa0(Cuckoo's Nest)",
                explanation: "",
                points: 200,
                show: false,
                answered: false
            },
            {
                id: "1qxjh6uk1sbd7yx",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: 'This individual released an XSS Worm which became the fastest spreading virus of all time, run by over 1 million users within 20 hours, carrying a payload which read \u201Cbut most of all, ___ is my hero"',
                question: "Who is Samy Kamkar",
                explanation: "",
                points: 300,
                show: false,
                answered: false
            },
            {
                id: "1qxjh6uk1sbd7z4",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "The creator of metasploit.",
                question: "Who is H.D. Moore",
                explanation: "",
                points: 400,
                show: false,
                answered: false
            },
            {
                id: "1qxjh6uk1sbd7zb",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: 'This family social engineer said "I have been offered 3 pardons from 3 different standing Presidents and I refused them all because I do not believe that a piece of paper excuses what I did.\u201D',
                question: "Who is Frank Abagnale",
                explanation: "",
                points: 500,
                show: false,
                answered: false
            },
            {
                id: "1qxjh6uk1sbd7zi",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: 'A legendary phone phreak, this individual became known as "Captain Crunch" after learning that a toy whistle packaged in boxes of Cap\'n Crunch cereal emitted a tone of precisely 2600 hertz',
                question: "Who is John Draper",
                explanation: "",
                points: 600,
                show: false,
                answered: false
            }
        ]
    },
    {
        id: "1qxjh6uk1sbd7yd",
        name: "Protocols",
        answers: [
            {
                id: "1qxjh6uk1sbd7yk",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "Residing on the transport layer, this protocol features reliable, ordered, error-checked delivery of a stream of octets between programs running on computers connected to a local area network, intranet or the public Internet",
                question: "What is Transmission Control Protocol (TCP)",
                explanation: "",
                points: 100,
                show: false,
                answered: false
            },
            {
                id: "1qxjh6uk1sbd7yr",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "This protocol uses a simple connectionless communication mode, with no handshaking dialogues.",
                question: "What is User Datagram Protocol (UDP)",
                explanation: "",
                points: 200,
                show: false,
                answered: false
            },
            {
                id: "1qxjh6uk1sbd7yy",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "This protocol is used for resolution of network layer addresses into link layer addresses",
                question: "What is Address Resolution Protocol (ARP)",
                explanation: "",
                points: 300,
                show: false,
                answered: false
            },
            {
                id: "1qxjh6uk1sbd7z5",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "This network protocol was designed as a replacement for unsecured remote shell protocols",
                question: "What is Secure Shell (SSH)",
                explanation: "",
                points: 400,
                show: false,
                answered: false
            },
            {
                id: "1qxjh6uk1sbd7zc",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "This computer networking protocol provides shared access to files, printers, and serial ports, and was later renamed to CIFS.",
                question: "What is Server Message Block (SMB)",
                explanation: "",
                points: 500,
                show: false,
                answered: false
            },
            {
                id: "1qxjh6uk1sbd7zj",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "This IPv6 protocol operates at the link layer and is responsible for address autoconfiguration of nodes.",
                question: "What is Neighbor Discovery Protocol",
                explanation: "",
                points: 600,
                show: false,
                answered: false
            }
        ]
    },
    {
        id: "1qxjh6uk1sbd7ye",
        name: "Big Numbers",
        answers: [
            {
                id: "1qxjh6uk1sbd7yl",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "One billion has this many zeroes.",
                question: "What is nine?",
                explanation: "",
                points: 100,
                show: false,
                answered: false
            },
            {
                id: "1qxjh6uk1sbd7ys",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "This is equal to just under 10 trillion kilometers (or about 6 trillion miles).",
                question: "What is a light year?",
                explanation: "",
                points: 200,
                show: false,
                answered: false
            },
            {
                id: "1qxjh6uk1sbd7yz",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "Kilo, mega, giga, tera; this is the next consecutive unit in measuring bytes.",
                question: "What is a petabyte",
                explanation: "",
                points: 300,
                show: false,
                answered: false
            },
            {
                id: "1qxjh6uk1sbd7z6",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "A human being's functional memory is estimated to be this large.",
                question: "What is 1.25 Terabytes",
                explanation: "",
                points: 400,
                show: false,
                answered: false
            },
            {
                id: "1qxjh6uk1sbd7zd",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "This measurement unit is equal to 1000 zettabytes.",
                question: "What is a Yottabyte",
                explanation: "",
                points: 500,
                show: false,
                answered: false
            },
            {
                id: "1qxjh6uk1sbd7zk",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "Written in decimal form, this amount looks like this: 1,208,925,819,614,629,174,706,176 , and is equal to 1024 zebibytes",
                question: "What is a Yobibyte.",
                explanation: "",
                points: 600,
                show: false,
                answered: false
            }
        ]
    },
    {
        id: "1qxjh6uk1sbd7yf",
        name: "P - Words",
        answers: [
            {
                id: "1qxjh6uk1sbd7ym",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "Unencrypted information is said to be stored in this format",
                question: "What is plaintext",
                explanation: "",
                points: 100,
                show: false,
                answered: false
            },
            {
                id: "1qxjh6uk1sbd7yt",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "This attack technique involves fraudulent attempts to obtain sensitive information via email",
                question: "What is Phishing",
                explanation: "",
                points: 200,
                show: false,
                answered: false
            },
            {
                id: "1qxjh6uk1sbd7z0",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "This slag term describes the culture of people who experimented, exposed, and compromised the telephone system",
                question: "What is Phreaking",
                explanation: "",
                points: 300,
                show: false,
                answered: false
            },
            {
                id: "1qxjh6uk1sbd7z7",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "This attack technique results in the redirection of legitimate website traffic to another fake website",
                question: "What is Pharming",
                explanation: "",
                points: 400,
                show: false,
                answered: false
            },
            {
                id: "1qxjh6uk1sbd7ze",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "This packet has a protocol of 1 and a type of 8",
                question: "What is ICMP (or Ping)",
                explanation: "",
                points: 500,
                show: false,
                answered: false
            },
            {
                id: "1qxjh6uk1sbd7zl",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: 'This popular network attack is (ab)used by the "Circle with Disney" network device for parental control purposes',
                question: "What is ARP Poisoning (or ARP Spoofing).\xa0",
                explanation: "",
                points: 600,
                show: false,
                answered: false
            }
        ]
    },
    {
        id: "1qxjh6uk1sbd7yg",
        name: "IPs and Networks",
        answers: [
            {
                id: "1qxjh6uk1sbd7yn",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "The number of bytes in an IPv4 address",
                question: "What is 4",
                explanation: "",
                points: 100,
                show: false,
                answered: false
            },
            {
                id: "1qxjh6uk1sbd7yu",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "Private IPv4 addresses were set as a standard in this RFC.",
                question: "What is RFC 1918",
                explanation: "",
                points: 200,
                show: false,
                answered: false
            },
            {
                id: "1qxjh6uk1sbd7z1",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "A netmask of 255.255.255.240 (or /28) has how many usable hosts?",
                question: "What is 14",
                explanation: "",
                points: 300,
                show: false,
                answered: false
            },
            {
                id: "1qxjh6uk1sbd7z8",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "A technology for securing Internet Protocol (IP) communications by authenticating and/or encrypting each IP packet of a communication session is known as what?",
                question: "What is IPSec",
                explanation: "",
                points: 400,
                show: false,
                answered: false
            },
            {
                id: "1qxjh6uk1sbd7zf",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "The subnet 224.0.0.0/4 is reserved for what use?",
                question: "What is IP Multicast",
                explanation: "",
                points: 500,
                show: false,
                answered: false
            },
            {
                id: "1qxjh6uk1sbd7zm",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "This Internet Protocol, written and released on April 1, 1990 in RFC 1149, transmits large amounts of data with high latency and packet loss.",
                question: "What is Internet Protocol over Avian Carrier (IPoAC)",
                explanation: "",
                points: 600,
                show: false,
                answered: false
            }
        ]
    },
    {
        id: "1qxjh6uk1sbd7yh",
        name: "Crypto",
        answers: [
            {
                id: "1qxjh6uk1sbd7yo",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "This simple cipher shifts each character by a given value\xa0 \xa0 \xa0",
                question: "What is a Caesar cipher (substitution cipher, rotation cipher)",
                explanation: "",
                points: 100,
                show: false,
                answered: false
            },
            {
                id: "1qxjh6uk1sbd7yv",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "This is the effective keysize of the DES cipher",
                question: "What is 56 bits (7 bytes)",
                explanation: "",
                points: 200,
                show: false,
                answered: false
            },
            {
                id: "1qxjh6uk1sbd7z2",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "This cipher was used incorrectly, creating a weakness in the security of WEP",
                question: "What is RC4",
                explanation: "",
                points: 300,
                show: false,
                answered: false
            },
            {
                id: "1qxjh6uk1sbd7z9",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "The two fish and three fish ciphers were invented by this crytographer",
                question: "Who is Bruce Schneier",
                explanation: "",
                points: 400,
                show: false,
                answered: false
            },
            {
                id: "1qxjh6uk1sbd7zg",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "This now defunct chipset, utilizing the Skipjack algorithm, was developed promoted by the NSA from 1993-1996 to allow Federal, State, and local law enforcement officials the ability to decode intercepted voice and data transmissions.",
                question: 'What is the "Clipper chip"',
                explanation: "",
                points: 500,
                show: false,
                answered: false
            },
            {
                id: "1qxjh6uk1sbd7zn",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "This attack occurs when",
                question: "What is a collision",
                explanation: "",
                points: 600,
                show: false,
                answered: false
            }
        ]
    },
    {
        id: "1qxjh6uk1sbd7yi",
        name: "Windows Commands",
        answers: [
            {
                id: "1qxjh6uk1sbd7yp",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "This command displays active TCP connections, ports on which the computer is listening, does not resolve IP addresses and lists the processes that opened the connections.",
                question: "What is netstat -ano",
                explanation: "",
                points: 100,
                show: false,
                answered: false
            },
            {
                id: "1qxjh6uk1sbd7yw",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "This command displays environment variables in a command shell.",
                question: "What is set",
                explanation: "",
                points: 200,
                show: false,
                answered: false
            },
            {
                id: "1qxjh6uk1sbd7z3",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "This is the command used to remove the hidden attribute from a file or directory. (Please provide correct switch syntax in your response)",
                question: "What is attrib -h",
                explanation: "",
                points: 300,
                show: false,
                answered: false
            },
            {
                id: "1qxjh6uk1sbd7za",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "This command communicates with the service controller and installed services.",
                question: "What is sc",
                explanation: "",
                points: 400,
                show: false,
                answered: false
            },
            {
                id: "1qxjh6uk1sbd7zh",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "This is Microsoft's task automation framework, consisting of a command line shell and associated scripting language built on the .NET framework.",
                question: "What is PowerShell",
                explanation: "",
                points: 500,
                show: false,
                answered: false
            },
            {
                id: "1qxjh6uk1sbd7zo",
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "Which command allows for you to display all file associations from the command-line?",
                question: "What is assoc",
                explanation: "",
                points: 600,
                show: false,
                answered: false
            }
        ]
    }
];





const $c64d1422d04530a0$var$teamsSeed = [
    {
        id: "4242",
        color: "#ffeb3b",
        name: "Yellow",
        members: [],
        points: 0
    },
    {
        id: "1337",
        color: "#4caf50",
        name: "Green",
        members: [],
        points: 0
    },
    {
        id: "1235",
        color: "#f44336",
        name: "Red",
        members: [],
        points: 0
    },
    {
        id: "4096",
        color: "#e91e63",
        name: "Pink",
        members: [],
        points: 0
    }
];
const $c64d1422d04530a0$export$683dea5642c18ced = async ()=>{
    const query = await (0, $41cc883dcc596d2f$exports.firestore)().collection("categories").get();
    for (const item of query.docs)await (0, $41cc883dcc596d2f$exports.firestore)().doc(`categories/${item.id}`).delete();
    $c64d1422d04530a0$export$5efbf14c3292beb6((0, $83714b806b972e5a$export$19676ab5cb1de150))();
};
const $c64d1422d04530a0$export$5efbf14c3292beb6 = (categories)=>async ()=>{
        const query = await (0, $41cc883dcc596d2f$exports.firestore)().collection("categories").get();
        if (query.docs.length > 0) {
            if (window.confirm("Cancel running game?")) for (const item of query.docs)await (0, $41cc883dcc596d2f$exports.firestore)().doc(`categories/${item.id}`).delete();
            else return;
        }
        for (const category of categories)await (0, $41cc883dcc596d2f$exports.firestore)().collection("/categories").doc(category.id).set(category);
    };
const $c64d1422d04530a0$export$1a87823f19ef51a6 = async ()=>{
    const query = await (0, $41cc883dcc596d2f$exports.firestore)().collection("teams").get();
    for (const item of query.docs)await (0, $41cc883dcc596d2f$exports.firestore)().doc(`teams/${item.id}`).delete();
    for (const team of $c64d1422d04530a0$var$teamsSeed)await (0, $41cc883dcc596d2f$exports.firestore)().collection("teams").doc(team.id).set(team);
};



var $acw62 = parcelRequire("acw62");
var $00832a1987cec94b$exports = {};
$00832a1987cec94b$exports = new URL("theme.ab80896f.mp3", import.meta.url).toString();


let $f9d1d48009476e2a$var$isPlaying = false;
const $f9d1d48009476e2a$var$audio = new Audio($00832a1987cec94b$exports);
$f9d1d48009476e2a$var$audio.currentTime = 1;
$f9d1d48009476e2a$var$audio.loop = true;
async function $f9d1d48009476e2a$export$3436bda8a09ed0ee() {
    const leVar = $f9d1d48009476e2a$export$809af548198681a4();
    if (!leVar) return;
    $f9d1d48009476e2a$var$isPlaying = true;
    try {
        await $f9d1d48009476e2a$var$audio.play();
    } catch (error) {
        $f9d1d48009476e2a$var$isPlaying = false;
        console.error("Could not play audio", error);
    }
}
function $f9d1d48009476e2a$export$c7d2365daeb67cbc() {
    $f9d1d48009476e2a$var$isPlaying = false;
    if ($f9d1d48009476e2a$var$audio) {
        $f9d1d48009476e2a$var$audio.pause();
        $f9d1d48009476e2a$var$audio.currentTime = 1;
    }
}
async function $f9d1d48009476e2a$export$f543642fc33c1018() {
    if (!$f9d1d48009476e2a$var$isPlaying) $f9d1d48009476e2a$export$3436bda8a09ed0ee();
    else $f9d1d48009476e2a$export$c7d2365daeb67cbc();
}
const $f9d1d48009476e2a$export$809af548198681a4 = ()=>{
    const sv = localStorage.getItem("theme");
    if (sv === null) return true;
    return Boolean(sv === "true");
};
const $f9d1d48009476e2a$export$21b6365147580583 = (enabled)=>{
    localStorage.setItem("theme", String(enabled));
};
const $f9d1d48009476e2a$export$7984f64747fff63e = ()=>{
    const [enabled, setEnabled] = (0, $acw62.useState)($f9d1d48009476e2a$export$809af548198681a4());
    const toggleThemeState = ()=>{
        if (enabled) {
            $f9d1d48009476e2a$export$21b6365147580583(false);
            setEnabled(false);
            $f9d1d48009476e2a$export$c7d2365daeb67cbc();
        } else {
            $f9d1d48009476e2a$export$21b6365147580583(true);
            setEnabled(true);
        }
    };
    return {
        enabled: enabled,
        toggleThemeState: toggleThemeState
    };
};


var $ce19da54055e516d$export$3ff52d0e0476cd64;
var $ce19da54055e516d$export$80b771e7f62cff3f;
var $ce19da54055e516d$export$2c76aca27257bcfa;
var $ce19da54055e516d$export$a7db06668cad9adb;
var $ce19da54055e516d$export$a03e0670d952aa2;
var $ce19da54055e516d$export$f4ce94000b680c68;
var $ce19da54055e516d$export$abb264cd6e316bc6;
var $ce19da54055e516d$export$9f048bf86ee2e9d2;
var $ce19da54055e516d$export$d4ef5cb3017aef40;
var $ce19da54055e516d$export$da58def7a499ea5b;
var $ce19da54055e516d$export$e8e78c978b129247;
var $ce19da54055e516d$export$8d64293bd263e87;
var $ce19da54055e516d$export$9f98a8d796affec6;
var $ce19da54055e516d$export$c957e9dafc0b7f8f;
var $ce19da54055e516d$export$9dc4ecf953986f04;
$ce19da54055e516d$export$3ff52d0e0476cd64 = `wXAiPW_answerRow`;
$ce19da54055e516d$export$80b771e7f62cff3f = `wXAiPW_awardings`;
$ce19da54055e516d$export$2c76aca27257bcfa = `wXAiPW_categories`;
$ce19da54055e516d$export$a7db06668cad9adb = `wXAiPW_content`;
$ce19da54055e516d$export$a03e0670d952aa2 = `wXAiPW_controlBar`;
$ce19da54055e516d$export$f4ce94000b680c68 = `wXAiPW_currentAnswer`;
$ce19da54055e516d$export$abb264cd6e316bc6 = `wXAiPW_currentAnswerTitle`;
$ce19da54055e516d$export$9f048bf86ee2e9d2 = `wXAiPW_points`;
$ce19da54055e516d$export$d4ef5cb3017aef40 = `wXAiPW_pointsbutton`;
$ce19da54055e516d$export$da58def7a499ea5b = `wXAiPW_rightColumn`;
$ce19da54055e516d$export$e8e78c978b129247 = `wXAiPW_root`;
$ce19da54055e516d$export$8d64293bd263e87 = `wXAiPW_team`;
$ce19da54055e516d$export$9f98a8d796affec6 = `wXAiPW_teamName`;
$ce19da54055e516d$export$c957e9dafc0b7f8f = `wXAiPW_teams`;
$ce19da54055e516d$export$9dc4ecf953986f04 = `wXAiPW_timer`;




const $3a23af11867b24ee$export$af9636465690942f = [
    {
        id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
        name: "sipgate Kunst",
        answers: [
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "Diese Katze h\xe4ngt dank Lin May Saeed bei vielen sipgatys zu Hause",
                question: "Was ist der Serval?",
                explanation: "",
                points: 200,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: 'Dieses "Reittier" ist aktuell im Eingangsbereich des B\xfcros zu finden',
                question: "Was ist eine Wurst?",
                explanation: "",
                points: 400,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "Dieses Material ziert die Oberkante des gr\xf6\xdften Gem\xe4ldes in der sipgate-Sammlung",
                question: "Was ist Paket-/Klebeband",
                explanation: "",
                points: 600,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "Dieses ungew\xf6hnliche Material macht die Werke von Sofie Reinhold extrem glatt",
                question: "Was ist Marmormehl?",
                explanation: "",
                points: 800,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: 'Dieser K\xfcnstler erf\xfcllt mit seinen Fotografien bei sipgate gewisserma\xdfen eine "Aufsichtspflicht"',
                question: "Wer ist Andreas Gefeller?",
                explanation: "",
                points: 1000,
                show: false,
                answered: false
            }
        ]
    },
    {
        id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
        name: "sipgate Teams",
        answers: [
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "Dieser Frau legt gerne alles auf die Goldwaage und tr\xe4gt trotz mangelndem Sehverm\xf6gen scharfkantige Gegenst\xe4nde bei sich",
                question: "Wer ist Justizia?",
                explanation: "",
                points: 200,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "Dieses Team ist quasi das Mitochondrium von sipgate",
                question: "Was ist Kraftwerk 3000?",
                explanation: "",
                points: 400,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "Diese Zwillingsschwestern sind die T\xf6chter von Jacqueline and Clancy Bouvier",
                question: "Wer sind Patty und Selma?",
                explanation: "",
                points: 600,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "Dieses Team verdankt seinen Namen indirekt dem einer Audiodatei",
                question: "Wer sind die Monkeys ohne Namen?",
                explanation: "",
                points: 800,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "Dieses schwarz-wei\xdfe Tier ist nicht, was sein Name vermuten l\xe4sst",
                question: "Was ist der Honigdachs/Honey Badger?",
                explanation: "",
                points: 1000,
                show: false,
                answered: false
            }
        ]
    },
    {
        id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
        name: "Gemischtes aus dem sipgate",
        answers: [
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "Danach waren zwischenzeitlich die Cubes auf dem Parkplatz benannt",
                question: "Was sind Museen?",
                explanation: "",
                points: 200,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "Dieser Meeress\xe4uger ziert das Banner von sipgates erfolgreichster Karaoke-Veranstaltung",
                question: "Was ist der Orka?",
                explanation: "",
                points: 400,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "Auf dieser Stra\xdfe lag das vorherige B\xfcro von sipgate",
                question: "Was ist die Ronsdorfer Stra\xdfe?",
                explanation: "",
                points: 600,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "Dieser sipgate-Gesellschaft geh\xf6rt ein Flugzeug",
                question: "Was ist die Cloud Digger?",
                explanation: "",
                points: 800,
                show: false,
                answered: false
            },
            {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($bd60dbe7bfada5b5$exports)))(),
                type: (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT,
                answer: "Diesen Effekt bewirbt Stefan Lange-Hegermann im meistegesehenen sipgate-Video bei YouTube",
                question: "Was ist der WOW-Effekt?",
                explanation: "",
                points: 1000,
                show: false,
                answered: false
            }
        ]
    }
];


const $32ce01693f31f064$var$dismiss = (category)=>()=>{
        if (!category) return;
        (0, $b090720bc1d5aaf4$export$e28ecfba58fd26a5)(category);
        (0, $f9d1d48009476e2a$export$c7d2365daeb67cbc)();
        (0, $b090720bc1d5aaf4$export$fbde73a70fe9ce62)();
    };
const $32ce01693f31f064$var$toggleAnswered = (answer, category)=>()=>{
        if (!category) return;
        (0, $b090720bc1d5aaf4$export$8fb12bb94807cc02)(category, answer);
    };
const $32ce01693f31f064$var$awardPoints = (team, answer, category)=>()=>{
        (0, $b090720bc1d5aaf4$export$19a46c6b349da83c)(team, answer);
        (0, $b090720bc1d5aaf4$export$78c218f605358a7b)(category, answer);
        (0, $f9d1d48009476e2a$export$c7d2365daeb67cbc)();
        (0, $b090720bc1d5aaf4$export$fbde73a70fe9ce62)();
    };
const $32ce01693f31f064$var$penalizePoints = (team, answer, category)=>()=>{
        (0, $b090720bc1d5aaf4$export$b832e015df3341da)(team, answer);
        (0, $b090720bc1d5aaf4$export$78c218f605358a7b)(category, answer);
        (0, $f9d1d48009476e2a$export$c7d2365daeb67cbc)();
        (0, $b090720bc1d5aaf4$export$fbde73a70fe9ce62)();
    };
const $32ce01693f31f064$var$setRandomAnswer = (categories)=>()=>{
        const unanswered = categories.flatMap((category)=>category.answers).filter((answer)=>!answer.answered);
        const randomAnswer = unanswered[Math.floor(Math.random() * unanswered.length)];
        const cat = categories.find((c)=>c.answers.find((a)=>a.id === randomAnswer?.id));
        (0, $b090720bc1d5aaf4$export$87047dea94a3085d)(cat, randomAnswer);
        (0, $f9d1d48009476e2a$export$3436bda8a09ed0ee)();
    };
const $32ce01693f31f064$var$CurrentAnswer = ({ currentAnswer: currentAnswer, currentCategory: currentCategory })=>{
    const teams = (0, $b090720bc1d5aaf4$export$6fe02dcc2001dcb0)();
    const categories = (0, $b090720bc1d5aaf4$export$17897f9a67d1488d)();
    const activeTeamId = (0, $b090720bc1d5aaf4$export$a3db87856234ba81)(currentAnswer ? currentAnswer.id : "");
    const activeTeam = teams.find((team)=>team.id === activeTeamId);
    if (!currentAnswer || !currentCategory) {
        (0, $f9d1d48009476e2a$export$c7d2365daeb67cbc)();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, "No Answer selected", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
            onClick: $32ce01693f31f064$var$setRandomAnswer(categories)
        }, "Select random answer"));
    }
    let answerImageOrText = "";
    switch(currentAnswer.type){
        case (0, $c01512cbc56e2fb8$export$44e2388b3736c907).IMAGE:
            answerImageOrText = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("img", {
                width: 100,
                src: currentAnswer.answer,
                alt: ""
            });
            break;
        case (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT:
            answerImageOrText = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, currentAnswer.answer);
    }
    if (activeTeam) (0, $f9d1d48009476e2a$export$c7d2365daeb67cbc)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, answerImageOrText), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, "Points: ", currentAnswer.points), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, "Hint: ", currentAnswer.question), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, "Explanation: ", currentAnswer.explanation), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        onClick: $32ce01693f31f064$var$dismiss(currentCategory)
    }, "Dismiss"), activeTeam && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        key: `${activeTeam.id}_award`,
        className: $ce19da54055e516d$export$d4ef5cb3017aef40,
        style: {
            backgroundColor: activeTeam.color
        },
        onClick: $32ce01693f31f064$var$awardPoints(activeTeam, currentAnswer, currentCategory)
    }, "Award ", activeTeam.name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        key: `${activeTeam.id}_penalty`,
        className: $ce19da54055e516d$export$d4ef5cb3017aef40,
        style: {
            backgroundColor: activeTeam.color
        },
        onClick: $32ce01693f31f064$var$penalizePoints(activeTeam, currentAnswer, currentCategory)
    }, "penalize ", activeTeam.name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: $ce19da54055e516d$export$9dc4ecf953986f04
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($061e5e865be64174$exports))), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($061e5e865be64174$exports))).Seconds, null), "s"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: $ce19da54055e516d$export$80b771e7f62cff3f
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, teams.map((t)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
            key: t.id,
            style: {
                backgroundColor: t.color
            },
            onClick: $32ce01693f31f064$var$awardPoints(t, currentAnswer, currentCategory)
        }, "Award ", t.name))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, teams.map((t)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
            key: t.id,
            style: {
                backgroundColor: t.color
            },
            onClick: $32ce01693f31f064$var$penalizePoints(t, currentAnswer, currentCategory)
        }, "penalize ", t.name)))));
};
const $32ce01693f31f064$export$1860a93e5e8ebd61 = ()=>{
    const categories = (0, $b090720bc1d5aaf4$export$17897f9a67d1488d)();
    const teams = (0, $b090720bc1d5aaf4$export$6fe02dcc2001dcb0)();
    const { enabled: enabled, toggleThemeState: toggleThemeState } = (0, $f9d1d48009476e2a$export$7984f64747fff63e)();
    const isModerator = Boolean(localStorage.getItem("moderator") === "true");
    if (!isModerator) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null);
    // const reset = () => {
    // 	if (window.confirm("Really reset game?")) {
    // 		if (window.confirm("Really????")) {
    // 			resetRounds();
    // 			resetTeams();
    // 			resetAnswerRequests();
    // 		}
    // 	}
    // };
    const choose = (category, answer)=>()=>{
            (0, $b090720bc1d5aaf4$export$87047dea94a3085d)(category, answer);
            (0, $f9d1d48009476e2a$export$3436bda8a09ed0ee)();
        };
    const currentCategory = categories.find((category)=>category.answers.some((answer)=>answer.show));
    const currentAnswer = categories.flatMap((category)=>category.answers).find((answer)=>answer.show);
    const removePlayerFromTeam = (userId, team)=>()=>{
            if (window.confirm(`Remove user ${userId} from team ${team.id}?`)) (0, $b090720bc1d5aaf4$export$fb2663b0d18a4508)(userId, team);
        };
    const handleThemeToggleChange = ()=>{
        toggleThemeState();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: $ce19da54055e516d$export$e8e78c978b129247
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d5bf021e81f47411$export$dcef8f9bb9a41431), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, "Moderator")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: $ce19da54055e516d$export$a03e0670d952aa2
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        onClick: (0, $c64d1422d04530a0$export$5efbf14c3292beb6)((0, $3a23af11867b24ee$export$af9636465690942f))
    }, "Bootstrap sipgate Round"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        onClick: (0, $c64d1422d04530a0$export$5efbf14c3292beb6)((0, $dc9bcadf2cfc8d53$export$edcfc84d7147b770))
    }, "Bootstrap Tech Round"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        onClick: (0, $c64d1422d04530a0$export$5efbf14c3292beb6)((0, $22d91a75a96a3f18$export$2d5f1f9b3ff97efe))
    }, "Bootstrap Games Round"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        onClick: (0, $c64d1422d04530a0$export$5efbf14c3292beb6)((0, $b9c5086c63572426$export$d1ee0e46c42d7e17))
    }, "Bootstrap Movies Round"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        onClick: (0, $c64d1422d04530a0$export$5efbf14c3292beb6)((0, $e2f35130ea26a340$export$ce04b748dc62c7ea))
    }, "Bootstrap Hardcore Round"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        onClick: (0, $c64d1422d04530a0$export$5efbf14c3292beb6)((0, $83714b806b972e5a$export$19676ab5cb1de150))
    }, "Bootstrap Round 1"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        onClick: (0, $c64d1422d04530a0$export$5efbf14c3292beb6)((0, $83714b806b972e5a$export$19676ab5cb1de150))
    }, "Bootstrap Round 1"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        onClick: (0, $c64d1422d04530a0$export$5efbf14c3292beb6)((0, $987d0bf9046bb824$export$4b9672654250d8bc))
    }, "Bootstrap Round 2"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        onClick: (0, $c64d1422d04530a0$export$5efbf14c3292beb6)((0, $c7217db90e5a56e8$export$4b9074ac37ee5a23))
    }, "Bootstrap Round 3"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        onClick: (0, $c64d1422d04530a0$export$5efbf14c3292beb6)((0, $5255c4ce04c9baea$export$4e93de6c22889f23))
    }, "Bootstrap Round Beer"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        onClick: (0, $c64d1422d04530a0$export$5efbf14c3292beb6)((0, $fa3ddbeec3b8c08b$export$dadfe880f6d33e7c))
    }, "Bootstrap Round 93"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        onClick: (0, $c64d1422d04530a0$export$5efbf14c3292beb6)((0, $f4cabcbd96daf858$export$c4e4b485d6643fb4))
    }, "Bootstrap Round 94"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        onClick: (0, $c64d1422d04530a0$export$5efbf14c3292beb6)((0, $c75538985e94d2d7$export$aadba46dd1628141))
    }, "Bootstrap Round 95"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        onClick: (0, $c64d1422d04530a0$export$5efbf14c3292beb6)((0, $6db06f3ec958f9bb$export$5c8983c1806c510f))
    }, "Bootstrap Round 96"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        onClick: (0, $c64d1422d04530a0$export$5efbf14c3292beb6)((0, $bb377d18fc64e5cf$export$5a36437df7ef175a))
    }, "Bootstrap Round 97"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        onClick: (0, $c64d1422d04530a0$export$5efbf14c3292beb6)((0, $be23e17c7319b52f$export$38117332247deace))
    }, "Bootstrap Round 98"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        onClick: (0, $c64d1422d04530a0$export$5efbf14c3292beb6)((0, $0a54af1ae5987a97$export$e6b0144278681479))
    }, "Bootstrap Round 99")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: $ce19da54055e516d$export$a03e0670d952aa2
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        onClick: (0, $b090720bc1d5aaf4$export$da394805d8e49f9a)
    }, "Reset team points"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        onClick: (0, $b090720bc1d5aaf4$export$fbde73a70fe9ce62)
    }, "Reset answer requests"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        onClick: (0, $7988e610dd9b56c5$export$1a87823f19ef51a6)
    }, "Reset teams"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        onClick: (0, $f9d1d48009476e2a$export$f543642fc33c1018)
    }, "Toggle theme song"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
        type: "checkbox",
        name: "theme-toggle",
        checked: enabled,
        onChange: handleThemeToggleChange
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: $ce19da54055e516d$export$a7db06668cad9adb
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: $ce19da54055e516d$export$2c76aca27257bcfa
    }, categories.map((category)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: category.id
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("h1", null, category.name), category.answers.map((answer)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                key: answer.id,
                className: $ce19da54055e516d$export$3ff52d0e0476cd64,
                style: {
                    textDecoration: answer.answered ? "line-through" : "none"
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                className: $ce19da54055e516d$export$9f048bf86ee2e9d2
            }, answer.points), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
                onClick: choose(category, answer)
            }, "Show"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
                onClick: $32ce01693f31f064$var$dismiss(category)
            }, "Dismiss"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
                onClick: $32ce01693f31f064$var$toggleAnswered(answer, category)
            }, "toggle Answered")))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: $ce19da54055e516d$export$da58def7a499ea5b
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: $ce19da54055e516d$export$f4ce94000b680c68
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: $ce19da54055e516d$export$abb264cd6e316bc6
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, "Current Jeopardy")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($32ce01693f31f064$var$CurrentAnswer, {
        currentAnswer: currentAnswer,
        currentCategory: currentCategory
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: $ce19da54055e516d$export$c957e9dafc0b7f8f
    }, teams.map((team)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                backgroundColor: team.color
            },
            className: $ce19da54055e516d$export$8d64293bd263e87,
            key: team.id
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: $ce19da54055e516d$export$9f98a8d796affec6
        }, team.name, " - ID: ", team.id, " - Points: ", team.points), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, "Set points"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
            defaultValue: team.points,
            type: "number",
            onKeyDown: (e)=>{
                if (e.key === "Enter") (0, $b090720bc1d5aaf4$export$e443b07e0f79518c)(team, Number(e.currentTarget.value));
            }
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, "Members:", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", null, team.members.map((m)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
                key: m
            }, m, " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
                onClick: removePlayerFromTeam(m, team)
            }, "Remove")))))))))));
};


var $50e735a1de9ac006$exports = {};
var $bbf04ce6ad0d5805$exports = {};
$bbf04ce6ad0d5805$exports = {
    webm: "data:video/webm;base64,GkXfo0AgQoaBAUL3gQFC8oEEQvOBCEKCQAR3ZWJtQoeBAkKFgQIYU4BnQI0VSalmQCgq17FAAw9CQE2AQAZ3aGFtbXlXQUAGd2hhbW15RIlACECPQAAAAAAAFlSua0AxrkAu14EBY8WBAZyBACK1nEADdW5khkAFVl9WUDglhohAA1ZQOIOBAeBABrCBCLqBCB9DtnVAIueBAKNAHIEAAIAwAQCdASoIAAgAAUAmJaQAA3AA/vz0AAA=",
    mp4: "data:video/mp4;base64,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"
};


var $50e735a1de9ac006$require$webm = $bbf04ce6ad0d5805$exports.webm;
var $50e735a1de9ac006$require$mp4 = $bbf04ce6ad0d5805$exports.mp4;
// Detect iOS browsers < version 10
const $50e735a1de9ac006$var$oldIOS = typeof navigator !== "undefined" && parseFloat(("" + (/CPU.*OS ([0-9_]{3,4})[0-9_]{0,1}|(CPU like).*AppleWebKit.*Mobile/i.exec(navigator.userAgent) || [
    0,
    ""
])[1]).replace("undefined", "3_2").replace("_", ".").replace("_", "")) < 10 && !window.MSStream;
class $50e735a1de9ac006$var$NoSleep {
    constructor(){
        if ($50e735a1de9ac006$var$oldIOS) this.noSleepTimer = null;
        else {
            // Set up no sleep video element
            this.noSleepVideo = document.createElement("video");
            this.noSleepVideo.setAttribute("muted", "");
            this.noSleepVideo.setAttribute("title", "No Sleep");
            this.noSleepVideo.setAttribute("playsinline", "");
            this._addSourceToVideo(this.noSleepVideo, "webm", $50e735a1de9ac006$require$webm);
            this._addSourceToVideo(this.noSleepVideo, "mp4", $50e735a1de9ac006$require$mp4);
            this.noSleepVideo.addEventListener("loadedmetadata", ()=>{
                if (this.noSleepVideo.duration <= 1) this.noSleepVideo.setAttribute("loop", "");
                else this.noSleepVideo.addEventListener("timeupdate", ()=>{
                    if (this.noSleepVideo.currentTime > 0.5) this.noSleepVideo.currentTime = Math.random();
                });
            });
        }
    }
    _addSourceToVideo(element, type, dataURI) {
        var source = document.createElement("source");
        source.src = dataURI;
        source.type = `video/${type}`;
        element.appendChild(source);
    }
    enable() {
        if ($50e735a1de9ac006$var$oldIOS) {
            this.disable();
            console.warn(`
        NoSleep enabled for older iOS devices. This can interrupt
        active or long-running network requests from completing successfully.
        See https://github.com/richtr/NoSleep.js/issues/15 for more details.
      `);
            this.noSleepTimer = window.setInterval(()=>{
                if (!document.hidden) {
                    window.location.href = window.location.href.split("#")[0];
                    window.setTimeout(window.stop, 0);
                }
            }, 15000);
        } else this.noSleepVideo.play();
    }
    disable() {
        if ($50e735a1de9ac006$var$oldIOS) {
            if (this.noSleepTimer) {
                console.warn(`
          NoSleep now disabled for older iOS devices.
        `);
                window.clearInterval(this.noSleepTimer);
                this.noSleepTimer = null;
            }
        } else this.noSleepVideo.pause();
    }
}
$50e735a1de9ac006$exports = $50e735a1de9ac006$var$NoSleep;



var $acw62 = parcelRequire("acw62");

var $f9e25097e7c59d91$exports = {};
"use strict";
var $f9e25097e7c59d91$var$__importDefault = $f9e25097e7c59d91$exports && $f9e25097e7c59d91$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($f9e25097e7c59d91$exports, "__esModule", {
    value: true
});

var $f9e25097e7c59d91$var$BarLoader_1 = $f9e25097e7c59d91$var$__importDefault((parcelRequire("dBFBN")));

var $f9e25097e7c59d91$var$BeatLoader_1 = $f9e25097e7c59d91$var$__importDefault((parcelRequire("chQwI")));

var $f9e25097e7c59d91$var$BounceLoader_1 = $f9e25097e7c59d91$var$__importDefault((parcelRequire("1NdFU")));

var $f9e25097e7c59d91$var$CircleLoader_1 = $f9e25097e7c59d91$var$__importDefault((parcelRequire("gKQOa")));

var $f9e25097e7c59d91$var$ClimbingBoxLoader_1 = $f9e25097e7c59d91$var$__importDefault((parcelRequire("3mWdt")));

var $f9e25097e7c59d91$var$ClipLoader_1 = $f9e25097e7c59d91$var$__importDefault((parcelRequire("51o5i")));

var $f9e25097e7c59d91$var$DotLoader_1 = $f9e25097e7c59d91$var$__importDefault((parcelRequire("ly5IV")));

var $f9e25097e7c59d91$var$FadeLoader_1 = $f9e25097e7c59d91$var$__importDefault((parcelRequire("dqSh4")));

var $f9e25097e7c59d91$var$GridLoader_1 = $f9e25097e7c59d91$var$__importDefault((parcelRequire("is6Hc")));

var $f9e25097e7c59d91$var$HashLoader_1 = $f9e25097e7c59d91$var$__importDefault((parcelRequire("2sl9j")));

var $f9e25097e7c59d91$var$MoonLoader_1 = $f9e25097e7c59d91$var$__importDefault((parcelRequire("8tznc")));

var $f9e25097e7c59d91$var$PacmanLoader_1 = $f9e25097e7c59d91$var$__importDefault((parcelRequire("1clyG")));

var $f9e25097e7c59d91$var$PropagateLoader_1 = $f9e25097e7c59d91$var$__importDefault((parcelRequire("iVhwF")));

var $f9e25097e7c59d91$var$PulseLoader_1 = $f9e25097e7c59d91$var$__importDefault((parcelRequire("76XOu")));

var $f9e25097e7c59d91$var$RingLoader_1 = $f9e25097e7c59d91$var$__importDefault((parcelRequire("lFGPB")));

var $f9e25097e7c59d91$var$RiseLoader_1 = $f9e25097e7c59d91$var$__importDefault((parcelRequire("dKpu9")));

var $f9e25097e7c59d91$var$RotateLoader_1 = $f9e25097e7c59d91$var$__importDefault((parcelRequire("kp4mZ")));

var $f9e25097e7c59d91$var$ScaleLoader_1 = $f9e25097e7c59d91$var$__importDefault((parcelRequire("fX5sN")));

var $f9e25097e7c59d91$var$SkewLoader_1 = $f9e25097e7c59d91$var$__importDefault((parcelRequire("7NeQv")));

var $f9e25097e7c59d91$var$SquareLoader_1 = $f9e25097e7c59d91$var$__importDefault((parcelRequire("jpDqh")));

var $f9e25097e7c59d91$var$SyncLoader_1 = $f9e25097e7c59d91$var$__importDefault((parcelRequire("byVmK")));
$f9e25097e7c59d91$exports.BarLoader = $f9e25097e7c59d91$var$BarLoader_1.default;
$f9e25097e7c59d91$exports.BeatLoader = $f9e25097e7c59d91$var$BeatLoader_1.default;
$f9e25097e7c59d91$exports.BounceLoader = $f9e25097e7c59d91$var$BounceLoader_1.default;
$f9e25097e7c59d91$exports.CircleLoader = $f9e25097e7c59d91$var$CircleLoader_1.default;
$f9e25097e7c59d91$exports.ClimbingBoxLoader = $f9e25097e7c59d91$var$ClimbingBoxLoader_1.default;
$f9e25097e7c59d91$exports.ClipLoader = $f9e25097e7c59d91$var$ClipLoader_1.default;
$f9e25097e7c59d91$exports.DotLoader = $f9e25097e7c59d91$var$DotLoader_1.default;
$f9e25097e7c59d91$exports.FadeLoader = $f9e25097e7c59d91$var$FadeLoader_1.default;
$f9e25097e7c59d91$exports.GridLoader = $f9e25097e7c59d91$var$GridLoader_1.default;
$f9e25097e7c59d91$exports.HashLoader = $f9e25097e7c59d91$var$HashLoader_1.default;
$f9e25097e7c59d91$exports.MoonLoader = $f9e25097e7c59d91$var$MoonLoader_1.default;
$f9e25097e7c59d91$exports.PacmanLoader = $f9e25097e7c59d91$var$PacmanLoader_1.default;
$f9e25097e7c59d91$exports.PropagateLoader = $f9e25097e7c59d91$var$PropagateLoader_1.default;
$f9e25097e7c59d91$exports.PulseLoader = $f9e25097e7c59d91$var$PulseLoader_1.default;
$f9e25097e7c59d91$exports.RingLoader = $f9e25097e7c59d91$var$RingLoader_1.default;
$f9e25097e7c59d91$exports.RiseLoader = $f9e25097e7c59d91$var$RiseLoader_1.default;
$f9e25097e7c59d91$exports.RotateLoader = $f9e25097e7c59d91$var$RotateLoader_1.default;
$f9e25097e7c59d91$exports.ScaleLoader = $f9e25097e7c59d91$var$ScaleLoader_1.default;
$f9e25097e7c59d91$exports.SkewLoader = $f9e25097e7c59d91$var$SkewLoader_1.default;
$f9e25097e7c59d91$exports.SquareLoader = $f9e25097e7c59d91$var$SquareLoader_1.default;
$f9e25097e7c59d91$exports.SyncLoader = $f9e25097e7c59d91$var$SyncLoader_1.default;





var $acw62 = parcelRequire("acw62");
var $d82da40f8ecfe37f$exports = {};
/*
 * JavaScript MD5
 * https://github.com/blueimp/JavaScript-MD5
 *
 * Copyright 2011, Sebastian Tschan
 * https://blueimp.net
 *
 * Licensed under the MIT license:
 * https://opensource.org/licenses/MIT
 *
 * Based on
 * A JavaScript implementation of the RSA Data Security, Inc. MD5 Message
 * Digest Algorithm, as defined in RFC 1321.
 * Version 2.2 Copyright (C) Paul Johnston 1999 - 2009
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for more info.
 */ /* global define */ (function($) {
    "use strict";
    /**
   * Add integers, wrapping at 2^32.
   * This uses 16-bit operations internally to work around bugs in interpreters.
   *
   * @param {number} x First integer
   * @param {number} y Second integer
   * @returns {number} Sum
   */ function safeAdd(x, y) {
        var lsw = (x & 0xffff) + (y & 0xffff);
        var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
        return msw << 16 | lsw & 0xffff;
    }
    /**
   * Bitwise rotate a 32-bit number to the left.
   *
   * @param {number} num 32-bit number
   * @param {number} cnt Rotation count
   * @returns {number} Rotated number
   */ function bitRotateLeft(num, cnt) {
        return num << cnt | num >>> 32 - cnt;
    }
    /**
   * Basic operation the algorithm uses.
   *
   * @param {number} q q
   * @param {number} a a
   * @param {number} b b
   * @param {number} x x
   * @param {number} s s
   * @param {number} t t
   * @returns {number} Result
   */ function md5cmn(q, a, b, x, s, t) {
        return safeAdd(bitRotateLeft(safeAdd(safeAdd(a, q), safeAdd(x, t)), s), b);
    }
    /**
   * Basic operation the algorithm uses.
   *
   * @param {number} a a
   * @param {number} b b
   * @param {number} c c
   * @param {number} d d
   * @param {number} x x
   * @param {number} s s
   * @param {number} t t
   * @returns {number} Result
   */ function md5ff(a, b, c, d, x, s, t) {
        return md5cmn(b & c | ~b & d, a, b, x, s, t);
    }
    /**
   * Basic operation the algorithm uses.
   *
   * @param {number} a a
   * @param {number} b b
   * @param {number} c c
   * @param {number} d d
   * @param {number} x x
   * @param {number} s s
   * @param {number} t t
   * @returns {number} Result
   */ function md5gg(a, b, c, d, x, s, t) {
        return md5cmn(b & d | c & ~d, a, b, x, s, t);
    }
    /**
   * Basic operation the algorithm uses.
   *
   * @param {number} a a
   * @param {number} b b
   * @param {number} c c
   * @param {number} d d
   * @param {number} x x
   * @param {number} s s
   * @param {number} t t
   * @returns {number} Result
   */ function md5hh(a, b, c, d, x, s, t) {
        return md5cmn(b ^ c ^ d, a, b, x, s, t);
    }
    /**
   * Basic operation the algorithm uses.
   *
   * @param {number} a a
   * @param {number} b b
   * @param {number} c c
   * @param {number} d d
   * @param {number} x x
   * @param {number} s s
   * @param {number} t t
   * @returns {number} Result
   */ function md5ii(a, b, c, d, x, s, t) {
        return md5cmn(c ^ (b | ~d), a, b, x, s, t);
    }
    /**
   * Calculate the MD5 of an array of little-endian words, and a bit length.
   *
   * @param {Array} x Array of little-endian words
   * @param {number} len Bit length
   * @returns {Array<number>} MD5 Array
   */ function binlMD5(x, len) {
        /* append padding */ x[len >> 5] |= 0x80 << len % 32;
        x[(len + 64 >>> 9 << 4) + 14] = len;
        var i;
        var olda;
        var oldb;
        var oldc;
        var oldd;
        var a = 1732584193;
        var b = -271733879;
        var c = -1732584194;
        var d = 271733878;
        for(i = 0; i < x.length; i += 16){
            olda = a;
            oldb = b;
            oldc = c;
            oldd = d;
            a = md5ff(a, b, c, d, x[i], 7, -680876936);
            d = md5ff(d, a, b, c, x[i + 1], 12, -389564586);
            c = md5ff(c, d, a, b, x[i + 2], 17, 606105819);
            b = md5ff(b, c, d, a, x[i + 3], 22, -1044525330);
            a = md5ff(a, b, c, d, x[i + 4], 7, -176418897);
            d = md5ff(d, a, b, c, x[i + 5], 12, 1200080426);
            c = md5ff(c, d, a, b, x[i + 6], 17, -1473231341);
            b = md5ff(b, c, d, a, x[i + 7], 22, -45705983);
            a = md5ff(a, b, c, d, x[i + 8], 7, 1770035416);
            d = md5ff(d, a, b, c, x[i + 9], 12, -1958414417);
            c = md5ff(c, d, a, b, x[i + 10], 17, -42063);
            b = md5ff(b, c, d, a, x[i + 11], 22, -1990404162);
            a = md5ff(a, b, c, d, x[i + 12], 7, 1804603682);
            d = md5ff(d, a, b, c, x[i + 13], 12, -40341101);
            c = md5ff(c, d, a, b, x[i + 14], 17, -1502002290);
            b = md5ff(b, c, d, a, x[i + 15], 22, 1236535329);
            a = md5gg(a, b, c, d, x[i + 1], 5, -165796510);
            d = md5gg(d, a, b, c, x[i + 6], 9, -1069501632);
            c = md5gg(c, d, a, b, x[i + 11], 14, 643717713);
            b = md5gg(b, c, d, a, x[i], 20, -373897302);
            a = md5gg(a, b, c, d, x[i + 5], 5, -701558691);
            d = md5gg(d, a, b, c, x[i + 10], 9, 38016083);
            c = md5gg(c, d, a, b, x[i + 15], 14, -660478335);
            b = md5gg(b, c, d, a, x[i + 4], 20, -405537848);
            a = md5gg(a, b, c, d, x[i + 9], 5, 568446438);
            d = md5gg(d, a, b, c, x[i + 14], 9, -1019803690);
            c = md5gg(c, d, a, b, x[i + 3], 14, -187363961);
            b = md5gg(b, c, d, a, x[i + 8], 20, 1163531501);
            a = md5gg(a, b, c, d, x[i + 13], 5, -1444681467);
            d = md5gg(d, a, b, c, x[i + 2], 9, -51403784);
            c = md5gg(c, d, a, b, x[i + 7], 14, 1735328473);
            b = md5gg(b, c, d, a, x[i + 12], 20, -1926607734);
            a = md5hh(a, b, c, d, x[i + 5], 4, -378558);
            d = md5hh(d, a, b, c, x[i + 8], 11, -2022574463);
            c = md5hh(c, d, a, b, x[i + 11], 16, 1839030562);
            b = md5hh(b, c, d, a, x[i + 14], 23, -35309556);
            a = md5hh(a, b, c, d, x[i + 1], 4, -1530992060);
            d = md5hh(d, a, b, c, x[i + 4], 11, 1272893353);
            c = md5hh(c, d, a, b, x[i + 7], 16, -155497632);
            b = md5hh(b, c, d, a, x[i + 10], 23, -1094730640);
            a = md5hh(a, b, c, d, x[i + 13], 4, 681279174);
            d = md5hh(d, a, b, c, x[i], 11, -358537222);
            c = md5hh(c, d, a, b, x[i + 3], 16, -722521979);
            b = md5hh(b, c, d, a, x[i + 6], 23, 76029189);
            a = md5hh(a, b, c, d, x[i + 9], 4, -640364487);
            d = md5hh(d, a, b, c, x[i + 12], 11, -421815835);
            c = md5hh(c, d, a, b, x[i + 15], 16, 530742520);
            b = md5hh(b, c, d, a, x[i + 2], 23, -995338651);
            a = md5ii(a, b, c, d, x[i], 6, -198630844);
            d = md5ii(d, a, b, c, x[i + 7], 10, 1126891415);
            c = md5ii(c, d, a, b, x[i + 14], 15, -1416354905);
            b = md5ii(b, c, d, a, x[i + 5], 21, -57434055);
            a = md5ii(a, b, c, d, x[i + 12], 6, 1700485571);
            d = md5ii(d, a, b, c, x[i + 3], 10, -1894986606);
            c = md5ii(c, d, a, b, x[i + 10], 15, -1051523);
            b = md5ii(b, c, d, a, x[i + 1], 21, -2054922799);
            a = md5ii(a, b, c, d, x[i + 8], 6, 1873313359);
            d = md5ii(d, a, b, c, x[i + 15], 10, -30611744);
            c = md5ii(c, d, a, b, x[i + 6], 15, -1560198380);
            b = md5ii(b, c, d, a, x[i + 13], 21, 1309151649);
            a = md5ii(a, b, c, d, x[i + 4], 6, -145523070);
            d = md5ii(d, a, b, c, x[i + 11], 10, -1120210379);
            c = md5ii(c, d, a, b, x[i + 2], 15, 718787259);
            b = md5ii(b, c, d, a, x[i + 9], 21, -343485551);
            a = safeAdd(a, olda);
            b = safeAdd(b, oldb);
            c = safeAdd(c, oldc);
            d = safeAdd(d, oldd);
        }
        return [
            a,
            b,
            c,
            d
        ];
    }
    /**
   * Convert an array of little-endian words to a string
   *
   * @param {Array<number>} input MD5 Array
   * @returns {string} MD5 string
   */ function binl2rstr(input) {
        var i;
        var output = "";
        var length32 = input.length * 32;
        for(i = 0; i < length32; i += 8)output += String.fromCharCode(input[i >> 5] >>> i % 32 & 0xff);
        return output;
    }
    /**
   * Convert a raw string to an array of little-endian words
   * Characters >255 have their high-byte silently ignored.
   *
   * @param {string} input Raw input string
   * @returns {Array<number>} Array of little-endian words
   */ function rstr2binl(input) {
        var i;
        var output = [];
        output[(input.length >> 2) - 1] = undefined;
        for(i = 0; i < output.length; i += 1)output[i] = 0;
        var length8 = input.length * 8;
        for(i = 0; i < length8; i += 8)output[i >> 5] |= (input.charCodeAt(i / 8) & 0xff) << i % 32;
        return output;
    }
    /**
   * Calculate the MD5 of a raw string
   *
   * @param {string} s Input string
   * @returns {string} Raw MD5 string
   */ function rstrMD5(s) {
        return binl2rstr(binlMD5(rstr2binl(s), s.length * 8));
    }
    /**
   * Calculates the HMAC-MD5 of a key and some data (raw strings)
   *
   * @param {string} key HMAC key
   * @param {string} data Raw input string
   * @returns {string} Raw MD5 string
   */ function rstrHMACMD5(key, data) {
        var i;
        var bkey = rstr2binl(key);
        var ipad = [];
        var opad = [];
        var hash;
        ipad[15] = opad[15] = undefined;
        if (bkey.length > 16) bkey = binlMD5(bkey, key.length * 8);
        for(i = 0; i < 16; i += 1){
            ipad[i] = bkey[i] ^ 0x36363636;
            opad[i] = bkey[i] ^ 0x5c5c5c5c;
        }
        hash = binlMD5(ipad.concat(rstr2binl(data)), 512 + data.length * 8);
        return binl2rstr(binlMD5(opad.concat(hash), 640));
    }
    /**
   * Convert a raw string to a hex string
   *
   * @param {string} input Raw input string
   * @returns {string} Hex encoded string
   */ function rstr2hex(input) {
        var hexTab = "0123456789abcdef";
        var output = "";
        var x;
        var i;
        for(i = 0; i < input.length; i += 1){
            x = input.charCodeAt(i);
            output += hexTab.charAt(x >>> 4 & 0x0f) + hexTab.charAt(x & 0x0f);
        }
        return output;
    }
    /**
   * Encode a string as UTF-8
   *
   * @param {string} input Input string
   * @returns {string} UTF8 string
   */ function str2rstrUTF8(input) {
        return unescape(encodeURIComponent(input));
    }
    /**
   * Encodes input string as raw MD5 string
   *
   * @param {string} s Input string
   * @returns {string} Raw MD5 string
   */ function rawMD5(s) {
        return rstrMD5(str2rstrUTF8(s));
    }
    /**
   * Encodes input string as Hex encoded string
   *
   * @param {string} s Input string
   * @returns {string} Hex encoded string
   */ function hexMD5(s) {
        return rstr2hex(rawMD5(s));
    }
    /**
   * Calculates the raw HMAC-MD5 for the given key and data
   *
   * @param {string} k HMAC key
   * @param {string} d Input string
   * @returns {string} Raw MD5 string
   */ function rawHMACMD5(k, d) {
        return rstrHMACMD5(str2rstrUTF8(k), str2rstrUTF8(d));
    }
    /**
   * Calculates the Hex encoded HMAC-MD5 for the given key and data
   *
   * @param {string} k HMAC key
   * @param {string} d Input string
   * @returns {string} Raw MD5 string
   */ function hexHMACMD5(k, d) {
        return rstr2hex(rawHMACMD5(k, d));
    }
    /**
   * Calculates MD5 value for a given string.
   * If a key is provided, calculates the HMAC-MD5 value.
   * Returns a Hex encoded string unless the raw argument is given.
   *
   * @param {string} string Input string
   * @param {string} [key] HMAC key
   * @param {boolean} [raw] Raw output switch
   * @returns {string} MD5 output
   */ function md5(string, key, raw) {
        if (!key) {
            if (!raw) return hexMD5(string);
            return rawMD5(string);
        }
        if (!raw) return hexHMACMD5(key, string);
        return rawHMACMD5(key, string);
    }
    if (typeof define === "function" && define.amd) define(function() {
        return md5;
    });
    else if (0, $d82da40f8ecfe37f$exports) $d82da40f8ecfe37f$exports = md5;
    else $.md5 = md5;
})($d82da40f8ecfe37f$exports);


/**
 * FingerprintJS v4.2.1 - Copyright (c) FingerprintJS, Inc, 2023 (https://fingerprint.com)
 *
 * Licensed under Business Source License 1.1 https://mariadb.com/bsl11/
 * Licensor: FingerprintJS, Inc.
 * Licensed Work: FingerprintJS browser fingerprinting library
 * Additional Use Grant: None
 * Change Date: Four years from first release for the specific version.
 * Change License: MIT, text at https://opensource.org/license/mit/ with the following copyright notice:
 * Copyright 2015-present FingerprintJS, Inc.
 */ /******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $5c96a02c592fcff1$var$extendStatics = function(d, b) {
    $5c96a02c592fcff1$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $5c96a02c592fcff1$var$extendStatics(d, b);
};
function $5c96a02c592fcff1$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $5c96a02c592fcff1$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $5c96a02c592fcff1$export$18ce0697a983be9b = function() {
    $5c96a02c592fcff1$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5c96a02c592fcff1$export$18ce0697a983be9b.apply(this, arguments);
};
function $5c96a02c592fcff1$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $5c96a02c592fcff1$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $5c96a02c592fcff1$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $5c96a02c592fcff1$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $5c96a02c592fcff1$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $5c96a02c592fcff1$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $5c96a02c592fcff1$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $5c96a02c592fcff1$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $5c96a02c592fcff1$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $5c96a02c592fcff1$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $5c96a02c592fcff1$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $5c96a02c592fcff1$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $5c96a02c592fcff1$export$45d3717a4c69092e(o, m, p);
}
function $5c96a02c592fcff1$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $5c96a02c592fcff1$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $5c96a02c592fcff1$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($5c96a02c592fcff1$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $5c96a02c592fcff1$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $5c96a02c592fcff1$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $5c96a02c592fcff1$export$10c90e4f7922046c(v) {
    return this instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? (this.v = v, this) : new $5c96a02c592fcff1$export$10c90e4f7922046c(v);
}
function $5c96a02c592fcff1$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $5c96a02c592fcff1$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $5c96a02c592fcff1$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $5c96a02c592fcff1$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $5c96a02c592fcff1$export$19a8beecd37a4c45 === "function" ? $5c96a02c592fcff1$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $5c96a02c592fcff1$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $5c96a02c592fcff1$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $5c96a02c592fcff1$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $5c96a02c592fcff1$export$45d3717a4c69092e(result, mod, k);
    }
    $5c96a02c592fcff1$var$__setModuleDefault(result, mod);
    return result;
}
function $5c96a02c592fcff1$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $5c96a02c592fcff1$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $5c96a02c592fcff1$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $5c96a02c592fcff1$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $5c96a02c592fcff1$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $5c96a02c592fcff1$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $5c96a02c592fcff1$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $5c96a02c592fcff1$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $5c96a02c592fcff1$export$2e2bcd8739ae039 = {
    __extends: $5c96a02c592fcff1$export$a8ba968b8961cb8a,
    __assign: $5c96a02c592fcff1$export$18ce0697a983be9b,
    __rest: $5c96a02c592fcff1$export$3c9a16f847548506,
    __decorate: $5c96a02c592fcff1$export$29e00dfd3077644b,
    __param: $5c96a02c592fcff1$export$d5ad3fd78186038f,
    __metadata: $5c96a02c592fcff1$export$f1db080c865becb9,
    __awaiter: $5c96a02c592fcff1$export$1050f835b63b671e,
    __generator: $5c96a02c592fcff1$export$67ebef60e6f28a6,
    __createBinding: $5c96a02c592fcff1$export$45d3717a4c69092e,
    __exportStar: $5c96a02c592fcff1$export$f33643c0debef087,
    __values: $5c96a02c592fcff1$export$19a8beecd37a4c45,
    __read: $5c96a02c592fcff1$export$8d051b38c9118094,
    __spread: $5c96a02c592fcff1$export$afc72e2116322959,
    __spreadArrays: $5c96a02c592fcff1$export$6388937ca91ccae8,
    __spreadArray: $5c96a02c592fcff1$export$1216008129fb82ed,
    __await: $5c96a02c592fcff1$export$10c90e4f7922046c,
    __asyncGenerator: $5c96a02c592fcff1$export$e427f37a30a4de9b,
    __asyncDelegator: $5c96a02c592fcff1$export$bbd80228419bb833,
    __asyncValues: $5c96a02c592fcff1$export$e3b29a3d6162315f,
    __makeTemplateObject: $5c96a02c592fcff1$export$4fb47efe1390b86f,
    __importStar: $5c96a02c592fcff1$export$c21735bcef00d192,
    __importDefault: $5c96a02c592fcff1$export$da59b14a69baef04,
    __classPrivateFieldGet: $5c96a02c592fcff1$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $5c96a02c592fcff1$export$d40a35129aaff81f,
    __classPrivateFieldIn: $5c96a02c592fcff1$export$81fdc39f203e4e04,
    __addDisposableResource: $5c96a02c592fcff1$export$88ac25d8e944e405,
    __disposeResources: $5c96a02c592fcff1$export$8f076105dc360e92
};


var $6c22f100bb55ca27$var$version = "4.2.1";
function $6c22f100bb55ca27$var$wait(durationMs, resolveWith) {
    return new Promise(function(resolve) {
        return setTimeout(resolve, durationMs, resolveWith);
    });
}
/**
 * Allows asynchronous actions and microtasks to happen.
 */ function $6c22f100bb55ca27$var$releaseEventLoop() {
    return $6c22f100bb55ca27$var$wait(0);
}
function $6c22f100bb55ca27$var$requestIdleCallbackIfAvailable(fallbackTimeout, deadlineTimeout) {
    if (deadlineTimeout === void 0) deadlineTimeout = Infinity;
    var requestIdleCallback = window.requestIdleCallback;
    if (requestIdleCallback) // The function `requestIdleCallback` loses the binding to `window` here.
    // `globalThis` isn't always equal `window` (see https://github.com/fingerprintjs/fingerprintjs/issues/683).
    // Therefore, an error can occur. `call(window,` prevents the error.
    return new Promise(function(resolve) {
        return requestIdleCallback.call(window, function() {
            return resolve();
        }, {
            timeout: deadlineTimeout
        });
    });
    else return $6c22f100bb55ca27$var$wait(Math.min(fallbackTimeout, deadlineTimeout));
}
function $6c22f100bb55ca27$var$isPromise(value) {
    return !!value && typeof value.then === "function";
}
/**
 * Calls a maybe asynchronous function without creating microtasks when the function is synchronous.
 * Catches errors in both cases.
 *
 * If just you run a code like this:
 * ```
 * console.time('Action duration')
 * await action()
 * console.timeEnd('Action duration')
 * ```
 * The synchronous function time can be measured incorrectly because another microtask may run before the `await`
 * returns the control back to the code.
 */ function $6c22f100bb55ca27$var$awaitIfAsync(action, callback) {
    try {
        var returnedValue = action();
        if ($6c22f100bb55ca27$var$isPromise(returnedValue)) returnedValue.then(function(result) {
            return callback(true, result);
        }, function(error) {
            return callback(false, error);
        });
        else callback(true, returnedValue);
    } catch (error) {
        callback(false, error);
    }
}
/**
 * If you run many synchronous tasks without using this function, the JS main loop will be busy and asynchronous tasks
 * (e.g. completing a network request, rendering the page) won't be able to happen.
 * This function allows running many synchronous tasks such way that asynchronous tasks can run too in background.
 */ function $6c22f100bb55ca27$var$mapWithBreaks(items, callback, loopReleaseInterval) {
    if (loopReleaseInterval === void 0) loopReleaseInterval = 16;
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, void 0, void 0, function() {
        var results, lastLoopReleaseTime, i, now;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    results = Array(items.length);
                    lastLoopReleaseTime = Date.now();
                    i = 0;
                    _a.label = 1;
                case 1:
                    if (!(i < items.length)) return [
                        3 /*break*/ ,
                        4
                    ];
                    results[i] = callback(items[i], i);
                    now = Date.now();
                    if (!(now >= lastLoopReleaseTime + loopReleaseInterval)) return [
                        3 /*break*/ ,
                        3
                    ];
                    lastLoopReleaseTime = now;
                    // Allows asynchronous actions and microtasks to happen
                    return [
                        4 /*yield*/ ,
                        $6c22f100bb55ca27$var$wait(0)
                    ];
                case 2:
                    // Allows asynchronous actions and microtasks to happen
                    _a.sent();
                    _a.label = 3;
                case 3:
                    ++i;
                    return [
                        3 /*break*/ ,
                        1
                    ];
                case 4:
                    return [
                        2 /*return*/ ,
                        results
                    ];
            }
        });
    });
}
/**
 * Makes the given promise never emit an unhandled promise rejection console warning.
 * The promise will still pass errors to the next promises.
 *
 * Otherwise, promise emits a console warning unless it has a `catch` listener.
 */ function $6c22f100bb55ca27$var$suppressUnhandledRejectionWarning(promise) {
    promise.then(undefined, function() {
        return undefined;
    });
}
/*
 * This file contains functions to work with pure data only (no browser features, DOM, side effects, etc).
 */ /**
 * Does the same as Array.prototype.includes but has better typing
 */ function $6c22f100bb55ca27$var$includes(haystack, needle) {
    for(var i = 0, l = haystack.length; i < l; ++i){
        if (haystack[i] === needle) return true;
    }
    return false;
}
/**
 * Like `!includes()` but with proper typing
 */ function $6c22f100bb55ca27$var$excludes(haystack, needle) {
    return !$6c22f100bb55ca27$var$includes(haystack, needle);
}
/**
 * Be careful, NaN can return
 */ function $6c22f100bb55ca27$var$toInt(value) {
    return parseInt(value);
}
/**
 * Be careful, NaN can return
 */ function $6c22f100bb55ca27$var$toFloat(value) {
    return parseFloat(value);
}
function $6c22f100bb55ca27$var$replaceNaN(value, replacement) {
    return typeof value === "number" && isNaN(value) ? replacement : value;
}
function $6c22f100bb55ca27$var$countTruthy(values) {
    return values.reduce(function(sum, value) {
        return sum + (value ? 1 : 0);
    }, 0);
}
function $6c22f100bb55ca27$var$round(value, base) {
    if (base === void 0) base = 1;
    if (Math.abs(base) >= 1) return Math.round(value / base) * base;
    else {
        // Sometimes when a number is multiplied by a small number, precision is lost,
        // for example 1234 * 0.0001 === 0.12340000000000001, and it's more precise divide: 1234 / (1 / 0.0001) === 0.1234.
        var counterBase = 1 / base;
        return Math.round(value * counterBase) / counterBase;
    }
}
/**
 * Parses a CSS selector into tag name with HTML attributes.
 * Only single element selector are supported (without operators like space, +, >, etc).
 *
 * Multiple values can be returned for each attribute. You decide how to handle them.
 */ function $6c22f100bb55ca27$var$parseSimpleCssSelector(selector) {
    var _a, _b;
    var errorMessage = "Unexpected syntax '".concat(selector, "'");
    var tagMatch = /^\s*([a-z-]*)(.*)$/i.exec(selector);
    var tag = tagMatch[1] || undefined;
    var attributes = {};
    var partsRegex = /([.:#][\w-]+|\[.+?\])/gi;
    var addAttribute = function(name, value) {
        attributes[name] = attributes[name] || [];
        attributes[name].push(value);
    };
    for(;;){
        var match = partsRegex.exec(tagMatch[2]);
        if (!match) break;
        var part = match[0];
        switch(part[0]){
            case ".":
                addAttribute("class", part.slice(1));
                break;
            case "#":
                addAttribute("id", part.slice(1));
                break;
            case "[":
                var attributeMatch = /^\[([\w-]+)([~|^$*]?=("(.*?)"|([\w-]+)))?(\s+[is])?\]$/.exec(part);
                if (attributeMatch) addAttribute(attributeMatch[1], (_b = (_a = attributeMatch[4]) !== null && _a !== void 0 ? _a : attributeMatch[5]) !== null && _b !== void 0 ? _b : "");
                else throw new Error(errorMessage);
                break;
            default:
                throw new Error(errorMessage);
        }
    }
    return [
        tag,
        attributes
    ];
}
/**
 * Converts a string to UTF8 bytes
 */ function $6c22f100bb55ca27$var$getUTF8Bytes(input) {
    // Benchmark: https://jsbench.me/b6klaaxgwq/1
    // If you want to just count bytes, see solutions at https://jsbench.me/ehklab415e/1
    var result = new Uint8Array(input.length);
    for(var i = 0; i < input.length; i++){
        // `charCode` is faster than encoding, so we prefer that when it's possible
        var charCode = input.charCodeAt(i);
        // In case of non-ASCII symbols we use proper encoding
        if (charCode > 127) return new TextEncoder().encode(input);
        result[i] = charCode;
    }
    return result;
}
/*
 * Based on https://github.com/karanlyons/murmurHash3.js/blob/a33d0723127e2e5415056c455f8aed2451ace208/murmurHash3.js
 */ /**
 * Adds two 64-bit values (provided as tuples of 32-bit values)
 * and updates (mutates) first value to write the result
 */ function $6c22f100bb55ca27$var$x64Add(m, n) {
    var m0 = m[0] >>> 16, m1 = m[0] & 0xffff, m2 = m[1] >>> 16, m3 = m[1] & 0xffff;
    var n0 = n[0] >>> 16, n1 = n[0] & 0xffff, n2 = n[1] >>> 16, n3 = n[1] & 0xffff;
    var o0 = 0, o1 = 0, o2 = 0, o3 = 0;
    o3 += m3 + n3;
    o2 += o3 >>> 16;
    o3 &= 0xffff;
    o2 += m2 + n2;
    o1 += o2 >>> 16;
    o2 &= 0xffff;
    o1 += m1 + n1;
    o0 += o1 >>> 16;
    o1 &= 0xffff;
    o0 += m0 + n0;
    o0 &= 0xffff;
    m[0] = o0 << 16 | o1;
    m[1] = o2 << 16 | o3;
}
/**
 * Multiplies two 64-bit values (provided as tuples of 32-bit values)
 * and updates (mutates) first value to write the result
 */ function $6c22f100bb55ca27$var$x64Multiply(m, n) {
    var m0 = m[0] >>> 16, m1 = m[0] & 0xffff, m2 = m[1] >>> 16, m3 = m[1] & 0xffff;
    var n0 = n[0] >>> 16, n1 = n[0] & 0xffff, n2 = n[1] >>> 16, n3 = n[1] & 0xffff;
    var o0 = 0, o1 = 0, o2 = 0, o3 = 0;
    o3 += m3 * n3;
    o2 += o3 >>> 16;
    o3 &= 0xffff;
    o2 += m2 * n3;
    o1 += o2 >>> 16;
    o2 &= 0xffff;
    o2 += m3 * n2;
    o1 += o2 >>> 16;
    o2 &= 0xffff;
    o1 += m1 * n3;
    o0 += o1 >>> 16;
    o1 &= 0xffff;
    o1 += m2 * n2;
    o0 += o1 >>> 16;
    o1 &= 0xffff;
    o1 += m3 * n1;
    o0 += o1 >>> 16;
    o1 &= 0xffff;
    o0 += m0 * n3 + m1 * n2 + m2 * n1 + m3 * n0;
    o0 &= 0xffff;
    m[0] = o0 << 16 | o1;
    m[1] = o2 << 16 | o3;
}
/**
 * Provides left rotation of the given int64 value (provided as tuple of two int32)
 * by given number of bits. Result is written back to the value
 */ function $6c22f100bb55ca27$var$x64Rotl(m, bits) {
    var m0 = m[0];
    bits %= 64;
    if (bits === 32) {
        m[0] = m[1];
        m[1] = m0;
    } else if (bits < 32) {
        m[0] = m0 << bits | m[1] >>> 32 - bits;
        m[1] = m[1] << bits | m0 >>> 32 - bits;
    } else {
        bits -= 32;
        m[0] = m[1] << bits | m0 >>> 32 - bits;
        m[1] = m0 << bits | m[1] >>> 32 - bits;
    }
}
/**
 * Provides a left shift of the given int32 value (provided as tuple of [0, int32])
 * by given number of bits. Result is written back to the value
 */ function $6c22f100bb55ca27$var$x64LeftShift(m, bits) {
    bits %= 64;
    if (bits === 0) return;
    else if (bits < 32) {
        m[0] = m[1] >>> 32 - bits;
        m[1] = m[1] << bits;
    } else {
        m[0] = m[1] << bits - 32;
        m[1] = 0;
    }
}
/**
 * Provides a XOR of the given int64 values(provided as tuple of two int32).
 * Result is written back to the first value
 */ function $6c22f100bb55ca27$var$x64Xor(m, n) {
    m[0] ^= n[0];
    m[1] ^= n[1];
}
var $6c22f100bb55ca27$var$F1 = [
    0xff51afd7,
    0xed558ccd
];
var $6c22f100bb55ca27$var$F2 = [
    0xc4ceb9fe,
    0x1a85ec53
];
/**
 * Calculates murmurHash3's final x64 mix of that block and writes result back to the input value.
 * (`[0, h[0] >>> 1]` is a 33 bit unsigned right shift. This is the
 * only place where we need to right shift 64bit ints.)
 */ function $6c22f100bb55ca27$var$x64Fmix(h) {
    var shifted = [
        0,
        h[0] >>> 1
    ];
    $6c22f100bb55ca27$var$x64Xor(h, shifted);
    $6c22f100bb55ca27$var$x64Multiply(h, $6c22f100bb55ca27$var$F1);
    shifted[1] = h[0] >>> 1;
    $6c22f100bb55ca27$var$x64Xor(h, shifted);
    $6c22f100bb55ca27$var$x64Multiply(h, $6c22f100bb55ca27$var$F2);
    shifted[1] = h[0] >>> 1;
    $6c22f100bb55ca27$var$x64Xor(h, shifted);
}
var $6c22f100bb55ca27$var$C1 = [
    0x87c37b91,
    0x114253d5
];
var $6c22f100bb55ca27$var$C2 = [
    0x4cf5ad43,
    0x2745937f
];
var $6c22f100bb55ca27$var$M$1 = [
    0,
    5
];
var $6c22f100bb55ca27$var$N1 = [
    0,
    0x52dce729
];
var $6c22f100bb55ca27$var$N2 = [
    0,
    0x38495ab5
];
/**
 * Given a string and an optional seed as an int, returns a 128 bit
 * hash using the x64 flavor of MurmurHash3, as an unsigned hex.
 * All internal functions mutates passed value to achieve minimal memory allocations and GC load
 *
 * Benchmark https://jsbench.me/p4lkpaoabi/1
 */ function $6c22f100bb55ca27$var$x64hash128(input, seed) {
    var key = $6c22f100bb55ca27$var$getUTF8Bytes(input);
    seed = seed || 0;
    var length = [
        0,
        key.length
    ];
    var remainder = length[1] % 16;
    var bytes = length[1] - remainder;
    var h1 = [
        0,
        seed
    ];
    var h2 = [
        0,
        seed
    ];
    var k1 = [
        0,
        0
    ];
    var k2 = [
        0,
        0
    ];
    var i;
    for(i = 0; i < bytes; i = i + 16){
        k1[0] = key[i + 4] | key[i + 5] << 8 | key[i + 6] << 16 | key[i + 7] << 24;
        k1[1] = key[i] | key[i + 1] << 8 | key[i + 2] << 16 | key[i + 3] << 24;
        k2[0] = key[i + 12] | key[i + 13] << 8 | key[i + 14] << 16 | key[i + 15] << 24;
        k2[1] = key[i + 8] | key[i + 9] << 8 | key[i + 10] << 16 | key[i + 11] << 24;
        $6c22f100bb55ca27$var$x64Multiply(k1, $6c22f100bb55ca27$var$C1);
        $6c22f100bb55ca27$var$x64Rotl(k1, 31);
        $6c22f100bb55ca27$var$x64Multiply(k1, $6c22f100bb55ca27$var$C2);
        $6c22f100bb55ca27$var$x64Xor(h1, k1);
        $6c22f100bb55ca27$var$x64Rotl(h1, 27);
        $6c22f100bb55ca27$var$x64Add(h1, h2);
        $6c22f100bb55ca27$var$x64Multiply(h1, $6c22f100bb55ca27$var$M$1);
        $6c22f100bb55ca27$var$x64Add(h1, $6c22f100bb55ca27$var$N1);
        $6c22f100bb55ca27$var$x64Multiply(k2, $6c22f100bb55ca27$var$C2);
        $6c22f100bb55ca27$var$x64Rotl(k2, 33);
        $6c22f100bb55ca27$var$x64Multiply(k2, $6c22f100bb55ca27$var$C1);
        $6c22f100bb55ca27$var$x64Xor(h2, k2);
        $6c22f100bb55ca27$var$x64Rotl(h2, 31);
        $6c22f100bb55ca27$var$x64Add(h2, h1);
        $6c22f100bb55ca27$var$x64Multiply(h2, $6c22f100bb55ca27$var$M$1);
        $6c22f100bb55ca27$var$x64Add(h2, $6c22f100bb55ca27$var$N2);
    }
    k1[0] = 0;
    k1[1] = 0;
    k2[0] = 0;
    k2[1] = 0;
    var val = [
        0,
        0
    ];
    switch(remainder){
        case 15:
            val[1] = key[i + 14];
            $6c22f100bb55ca27$var$x64LeftShift(val, 48);
            $6c22f100bb55ca27$var$x64Xor(k2, val);
        // fallthrough
        case 14:
            val[1] = key[i + 13];
            $6c22f100bb55ca27$var$x64LeftShift(val, 40);
            $6c22f100bb55ca27$var$x64Xor(k2, val);
        // fallthrough
        case 13:
            val[1] = key[i + 12];
            $6c22f100bb55ca27$var$x64LeftShift(val, 32);
            $6c22f100bb55ca27$var$x64Xor(k2, val);
        // fallthrough
        case 12:
            val[1] = key[i + 11];
            $6c22f100bb55ca27$var$x64LeftShift(val, 24);
            $6c22f100bb55ca27$var$x64Xor(k2, val);
        // fallthrough
        case 11:
            val[1] = key[i + 10];
            $6c22f100bb55ca27$var$x64LeftShift(val, 16);
            $6c22f100bb55ca27$var$x64Xor(k2, val);
        // fallthrough
        case 10:
            val[1] = key[i + 9];
            $6c22f100bb55ca27$var$x64LeftShift(val, 8);
            $6c22f100bb55ca27$var$x64Xor(k2, val);
        // fallthrough
        case 9:
            val[1] = key[i + 8];
            $6c22f100bb55ca27$var$x64Xor(k2, val);
            $6c22f100bb55ca27$var$x64Multiply(k2, $6c22f100bb55ca27$var$C2);
            $6c22f100bb55ca27$var$x64Rotl(k2, 33);
            $6c22f100bb55ca27$var$x64Multiply(k2, $6c22f100bb55ca27$var$C1);
            $6c22f100bb55ca27$var$x64Xor(h2, k2);
        // fallthrough
        case 8:
            val[1] = key[i + 7];
            $6c22f100bb55ca27$var$x64LeftShift(val, 56);
            $6c22f100bb55ca27$var$x64Xor(k1, val);
        // fallthrough
        case 7:
            val[1] = key[i + 6];
            $6c22f100bb55ca27$var$x64LeftShift(val, 48);
            $6c22f100bb55ca27$var$x64Xor(k1, val);
        // fallthrough
        case 6:
            val[1] = key[i + 5];
            $6c22f100bb55ca27$var$x64LeftShift(val, 40);
            $6c22f100bb55ca27$var$x64Xor(k1, val);
        // fallthrough
        case 5:
            val[1] = key[i + 4];
            $6c22f100bb55ca27$var$x64LeftShift(val, 32);
            $6c22f100bb55ca27$var$x64Xor(k1, val);
        // fallthrough
        case 4:
            val[1] = key[i + 3];
            $6c22f100bb55ca27$var$x64LeftShift(val, 24);
            $6c22f100bb55ca27$var$x64Xor(k1, val);
        // fallthrough
        case 3:
            val[1] = key[i + 2];
            $6c22f100bb55ca27$var$x64LeftShift(val, 16);
            $6c22f100bb55ca27$var$x64Xor(k1, val);
        // fallthrough
        case 2:
            val[1] = key[i + 1];
            $6c22f100bb55ca27$var$x64LeftShift(val, 8);
            $6c22f100bb55ca27$var$x64Xor(k1, val);
        // fallthrough
        case 1:
            val[1] = key[i];
            $6c22f100bb55ca27$var$x64Xor(k1, val);
            $6c22f100bb55ca27$var$x64Multiply(k1, $6c22f100bb55ca27$var$C1);
            $6c22f100bb55ca27$var$x64Rotl(k1, 31);
            $6c22f100bb55ca27$var$x64Multiply(k1, $6c22f100bb55ca27$var$C2);
            $6c22f100bb55ca27$var$x64Xor(h1, k1);
    }
    $6c22f100bb55ca27$var$x64Xor(h1, length);
    $6c22f100bb55ca27$var$x64Xor(h2, length);
    $6c22f100bb55ca27$var$x64Add(h1, h2);
    $6c22f100bb55ca27$var$x64Add(h2, h1);
    $6c22f100bb55ca27$var$x64Fmix(h1);
    $6c22f100bb55ca27$var$x64Fmix(h2);
    $6c22f100bb55ca27$var$x64Add(h1, h2);
    $6c22f100bb55ca27$var$x64Add(h2, h1);
    return ("00000000" + (h1[0] >>> 0).toString(16)).slice(-8) + ("00000000" + (h1[1] >>> 0).toString(16)).slice(-8) + ("00000000" + (h2[0] >>> 0).toString(16)).slice(-8) + ("00000000" + (h2[1] >>> 0).toString(16)).slice(-8);
}
/**
 * Converts an error object to a plain object that can be used with `JSON.stringify`.
 * If you just run `JSON.stringify(error)`, you'll get `'{}'`.
 */ function $6c22f100bb55ca27$var$errorToObject(error) {
    var _a;
    return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
        name: error.name,
        message: error.message,
        stack: (_a = error.stack) === null || _a === void 0 ? void 0 : _a.split("\n")
    }, error);
}
function $6c22f100bb55ca27$var$isFunctionNative(func) {
    return /^function\s.*?\{\s*\[native code]\s*}$/.test(String(func));
}
function $6c22f100bb55ca27$var$isFinalResultLoaded(loadResult) {
    return typeof loadResult !== "function";
}
/**
 * Loads the given entropy source. Returns a function that gets an entropy component from the source.
 *
 * The result is returned synchronously to prevent `loadSources` from
 * waiting for one source to load before getting the components from the other sources.
 */ function $6c22f100bb55ca27$var$loadSource(source, sourceOptions) {
    var sourceLoadPromise = new Promise(function(resolveLoad) {
        var loadStartTime = Date.now();
        // `awaitIfAsync` is used instead of just `await` in order to measure the duration of synchronous sources
        // correctly (other microtasks won't affect the duration).
        $6c22f100bb55ca27$var$awaitIfAsync(source.bind(null, sourceOptions), function() {
            var loadArgs = [];
            for(var _i = 0; _i < arguments.length; _i++)loadArgs[_i] = arguments[_i];
            var loadDuration = Date.now() - loadStartTime;
            // Source loading failed
            if (!loadArgs[0]) return resolveLoad(function() {
                return {
                    error: loadArgs[1],
                    duration: loadDuration
                };
            });
            var loadResult = loadArgs[1];
            // Source loaded with the final result
            if ($6c22f100bb55ca27$var$isFinalResultLoaded(loadResult)) return resolveLoad(function() {
                return {
                    value: loadResult,
                    duration: loadDuration
                };
            });
            // Source loaded with "get" stage
            resolveLoad(function() {
                return new Promise(function(resolveGet) {
                    var getStartTime = Date.now();
                    $6c22f100bb55ca27$var$awaitIfAsync(loadResult, function() {
                        var getArgs = [];
                        for(var _i = 0; _i < arguments.length; _i++)getArgs[_i] = arguments[_i];
                        var duration = loadDuration + Date.now() - getStartTime;
                        // Source getting failed
                        if (!getArgs[0]) return resolveGet({
                            error: getArgs[1],
                            duration: duration
                        });
                        // Source getting succeeded
                        resolveGet({
                            value: getArgs[1],
                            duration: duration
                        });
                    });
                });
            });
        });
    });
    $6c22f100bb55ca27$var$suppressUnhandledRejectionWarning(sourceLoadPromise);
    return function getComponent() {
        return sourceLoadPromise.then(function(finalizeSource) {
            return finalizeSource();
        });
    };
}
/**
 * Loads the given entropy sources. Returns a function that collects the entropy components.
 *
 * The result is returned synchronously in order to allow start getting the components
 * before the sources are loaded completely.
 *
 * Warning for package users:
 * This function is out of Semantic Versioning, i.e. can change unexpectedly. Usage is at your own risk.
 */ function $6c22f100bb55ca27$export$3c5f4c9f15eeb5cb(sources, sourceOptions, excludeSources) {
    var includedSources = Object.keys(sources).filter(function(sourceKey) {
        return $6c22f100bb55ca27$var$excludes(excludeSources, sourceKey);
    });
    // Using `mapWithBreaks` allows asynchronous sources to complete between synchronous sources
    // and measure the duration correctly
    var sourceGettersPromise = $6c22f100bb55ca27$var$mapWithBreaks(includedSources, function(sourceKey) {
        return $6c22f100bb55ca27$var$loadSource(sources[sourceKey], sourceOptions);
    });
    $6c22f100bb55ca27$var$suppressUnhandledRejectionWarning(sourceGettersPromise);
    return function getComponents() {
        return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var sourceGetters, componentPromises, componentArray, components, index;
            return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            sourceGettersPromise
                        ];
                    case 1:
                        sourceGetters = _a.sent();
                        return [
                            4 /*yield*/ ,
                            $6c22f100bb55ca27$var$mapWithBreaks(sourceGetters, function(sourceGetter) {
                                var componentPromise = sourceGetter();
                                $6c22f100bb55ca27$var$suppressUnhandledRejectionWarning(componentPromise);
                                return componentPromise;
                            })
                        ];
                    case 2:
                        componentPromises = _a.sent();
                        return [
                            4 /*yield*/ ,
                            Promise.all(componentPromises)
                        ];
                    case 3:
                        componentArray = _a.sent();
                        components = {};
                        for(index = 0; index < includedSources.length; ++index)components[includedSources[index]] = componentArray[index];
                        return [
                            2 /*return*/ ,
                            components
                        ];
                }
            });
        });
    };
}
/**
 * Modifies an entropy source by transforming its returned value with the given function.
 * Keeps the source properties: sync/async, 1/2 stages.
 *
 * Warning for package users:
 * This function is out of Semantic Versioning, i.e. can change unexpectedly. Usage is at your own risk.
 */ function $6c22f100bb55ca27$export$258739ac4e431f7e(source, transformValue) {
    var transformLoadResult = function(loadResult) {
        if ($6c22f100bb55ca27$var$isFinalResultLoaded(loadResult)) return transformValue(loadResult);
        return function() {
            var getResult = loadResult();
            if ($6c22f100bb55ca27$var$isPromise(getResult)) return getResult.then(transformValue);
            return transformValue(getResult);
        };
    };
    return function(options) {
        var loadResult = source(options);
        if ($6c22f100bb55ca27$var$isPromise(loadResult)) return loadResult.then(transformLoadResult);
        return transformLoadResult(loadResult);
    };
}
/*
 * Functions to help with features that vary through browsers
 */ /**
 * Checks whether the browser is based on Trident (the Internet Explorer engine) without using user-agent.
 *
 * Warning for package users:
 * This function is out of Semantic Versioning, i.e. can change unexpectedly. Usage is at your own risk.
 */ function $6c22f100bb55ca27$export$5aba6d4fec9b366c() {
    var w = window;
    var n = navigator;
    // The properties are checked to be in IE 10, IE 11 and not to be in other browsers in October 2020
    return $6c22f100bb55ca27$var$countTruthy([
        "MSCSSMatrix" in w,
        "msSetImmediate" in w,
        "msIndexedDB" in w,
        "msMaxTouchPoints" in n,
        "msPointerEnabled" in n
    ]) >= 4;
}
/**
 * Checks whether the browser is based on EdgeHTML (the pre-Chromium Edge engine) without using user-agent.
 *
 * Warning for package users:
 * This function is out of Semantic Versioning, i.e. can change unexpectedly. Usage is at your own risk.
 */ function $6c22f100bb55ca27$export$13c899a793cdf73d() {
    // Based on research in October 2020
    var w = window;
    var n = navigator;
    return $6c22f100bb55ca27$var$countTruthy([
        "msWriteProfilerMark" in w,
        "MSStream" in w,
        "msLaunchUri" in n,
        "msSaveBlob" in n
    ]) >= 3 && !$6c22f100bb55ca27$export$5aba6d4fec9b366c();
}
/**
 * Checks whether the browser is based on Chromium without using user-agent.
 *
 * Warning for package users:
 * This function is out of Semantic Versioning, i.e. can change unexpectedly. Usage is at your own risk.
 */ function $6c22f100bb55ca27$export$dd401a4677e99039() {
    // Based on research in October 2020. Tested to detect Chromium 42-86.
    var w = window;
    var n = navigator;
    return $6c22f100bb55ca27$var$countTruthy([
        "webkitPersistentStorage" in n,
        "webkitTemporaryStorage" in n,
        n.vendor.indexOf("Google") === 0,
        "webkitResolveLocalFileSystemURL" in w,
        "BatteryManager" in w,
        "webkitMediaStream" in w,
        "webkitSpeechGrammar" in w
    ]) >= 5;
}
/**
 * Checks whether the browser is based on mobile or desktop Safari without using user-agent.
 * All iOS browsers use WebKit (the Safari engine).
 *
 * Warning for package users:
 * This function is out of Semantic Versioning, i.e. can change unexpectedly. Usage is at your own risk.
 */ function $6c22f100bb55ca27$export$78551043582a6a98() {
    // Based on research in September 2020
    var w = window;
    var n = navigator;
    return $6c22f100bb55ca27$var$countTruthy([
        "ApplePayError" in w,
        "CSSPrimitiveValue" in w,
        "Counter" in w,
        n.vendor.indexOf("Apple") === 0,
        "getStorageUpdates" in n,
        "WebKitMediaKeys" in w
    ]) >= 4;
}
/**
 * Checks whether this WebKit browser is a desktop browser.
 * It doesn't check that the browser is based on WebKit, there is a separate function for this.
 *
 * Warning for package users:
 * This function is out of Semantic Versioning, i.e. can change unexpectedly. Usage is at your own risk.
 */ function $6c22f100bb55ca27$export$4949e6bd5097eae9() {
    // Checked in Safari and DuckDuckGo
    var w = window;
    var HTMLElement = w.HTMLElement, Document = w.Document;
    return $6c22f100bb55ca27$var$countTruthy([
        "safari" in w,
        !("ongestureend" in w),
        !("TouchEvent" in w),
        !("orientation" in w),
        HTMLElement && !("autocapitalize" in HTMLElement.prototype),
        Document && "pointerLockElement" in Document.prototype
    ]) >= 4;
}
/**
 * Checks whether this WebKit browser is Safari.
 * It doesn't check that the browser is based on WebKit, there is a separate function for this.
 *
 * Warning! The function works properly only for Safari version 15 and newer.
 */ function $6c22f100bb55ca27$var$isSafariWebKit() {
    // Checked in Safari, Chrome, Firefox, Yandex, UC Browser, Opera, Edge and DuckDuckGo.
    // iOS Safari and Chrome were checked on iOS 11-17. DuckDuckGo was checked on iOS 17 and macOS 14.
    // Desktop Safari versions 12-17 were checked.
    // The other browsers were checked on iOS 17; there was no chance to check them on the other OS versions.
    var w = window;
    if (!$6c22f100bb55ca27$var$isFunctionNative(w.print)) return false; // Chrome, Firefox, Yandex, DuckDuckGo macOS, Edge
    return $6c22f100bb55ca27$var$countTruthy([
        // Incorrect in Safari <= 14 (iOS and macOS)
        String(w.browser) === "[object WebPageNamespace]",
        // Incorrect in desktop Safari and iOS Safari <= 15
        "MicrodataExtractor" in w
    ]) >= 1;
}
/**
 * Checks whether the browser is based on Gecko (Firefox engine) without using user-agent.
 *
 * Warning for package users:
 * This function is out of Semantic Versioning, i.e. can change unexpectedly. Usage is at your own risk.
 */ function $6c22f100bb55ca27$export$1127c7d1b8731973() {
    var _a, _b;
    var w = window;
    // Based on research in September 2020
    return $6c22f100bb55ca27$var$countTruthy([
        "buildID" in navigator,
        "MozAppearance" in ((_b = (_a = document.documentElement) === null || _a === void 0 ? void 0 : _a.style) !== null && _b !== void 0 ? _b : {}),
        "onmozfullscreenchange" in w,
        "mozInnerScreenX" in w,
        "CSSMozDocumentRule" in w,
        "CanvasCaptureMediaStream" in w
    ]) >= 4;
}
/**
 * Checks whether the browser is based on Chromium version ≥86 without using user-agent.
 * It doesn't check that the browser is based on Chromium, there is a separate function for this.
 */ function $6c22f100bb55ca27$var$isChromium86OrNewer() {
    // Checked in Chrome 85 vs Chrome 86 both on desktop and Android
    var w = window;
    return $6c22f100bb55ca27$var$countTruthy([
        !("MediaSettingsRange" in w),
        "RTCEncodedAudioFrame" in w,
        "" + w.Intl === "[object Intl]",
        "" + w.Reflect === "[object Reflect]"
    ]) >= 3;
}
/**
 * Checks whether the browser is based on WebKit version ≥606 (Safari ≥12) without using user-agent.
 * It doesn't check that the browser is based on WebKit, there is a separate function for this.
 *
 * @see https://en.wikipedia.org/wiki/Safari_version_history#Release_history Safari-WebKit versions map
 */ function $6c22f100bb55ca27$var$isWebKit606OrNewer() {
    // Checked in Safari 9–17
    var w = window;
    return $6c22f100bb55ca27$var$countTruthy([
        "DOMRectList" in w,
        "RTCPeerConnectionIceEvent" in w,
        "SVGGeometryElement" in w,
        "ontransitioncancel" in w
    ]) >= 3;
}
/**
 * Checks whether the browser is based on WebKit version ≥616 (Safari ≥17) without using user-agent.
 * It doesn't check that the browser is based on WebKit, there is a separate function for this.
 *
 * @see https://developer.apple.com/documentation/safari-release-notes/safari-17-release-notes Safari 17 release notes
 * @see https://tauri.app/v1/references/webview-versions/#webkit-versions-in-safari Safari-WebKit versions map
 */ function $6c22f100bb55ca27$var$isWebKit616OrNewer() {
    var w = window;
    var n = navigator;
    var CSS = w.CSS, HTMLButtonElement = w.HTMLButtonElement;
    return $6c22f100bb55ca27$var$countTruthy([
        !("getStorageUpdates" in n),
        HTMLButtonElement && "popover" in HTMLButtonElement.prototype,
        "CSSCounterStyleRule" in w,
        CSS.supports("font-size-adjust: ex-height 0.5"),
        CSS.supports("text-transform: full-width")
    ]) >= 4;
}
/**
 * Checks whether the device is an iPad.
 * It doesn't check that the engine is WebKit and that the WebKit isn't desktop.
 */ function $6c22f100bb55ca27$var$isIPad() {
    // Checked on:
    // Safari on iPadOS (both mobile and desktop modes): 8, 11-17
    // Chrome on iPadOS (both mobile and desktop modes): 11-17
    // Safari on iOS (both mobile and desktop modes): 9-17
    // Chrome on iOS (both mobile and desktop modes): 9-17
    // Before iOS 13. Safari tampers the value in "request desktop site" mode since iOS 13.
    if (navigator.platform === "iPad") return true;
    var s = screen;
    var screenRatio = s.width / s.height;
    return $6c22f100bb55ca27$var$countTruthy([
        "MediaSource" in window,
        !!Element.prototype.webkitRequestFullscreen,
        // iPhone 4S that runs iOS 9 matches this, but it is not supported
        screenRatio > 0.65 && screenRatio < 1.53
    ]) >= 2;
}
/**
 * Warning for package users:
 * This function is out of Semantic Versioning, i.e. can change unexpectedly. Usage is at your own risk.
 */ function $6c22f100bb55ca27$export$a095f8af1f7b5580() {
    var d = document;
    return d.fullscreenElement || d.msFullscreenElement || d.mozFullScreenElement || d.webkitFullscreenElement || null;
}
function $6c22f100bb55ca27$var$exitFullscreen() {
    var d = document;
    // `call` is required because the function throws an error without a proper "this" context
    return (d.exitFullscreen || d.msExitFullscreen || d.mozCancelFullScreen || d.webkitExitFullscreen).call(d);
}
/**
 * Checks whether the device runs on Android without using user-agent.
 *
 * Warning for package users:
 * This function is out of Semantic Versioning, i.e. can change unexpectedly. Usage is at your own risk.
 */ function $6c22f100bb55ca27$export$a11b0059900ceec8() {
    var isItChromium = $6c22f100bb55ca27$export$dd401a4677e99039();
    var isItGecko = $6c22f100bb55ca27$export$1127c7d1b8731973();
    var w = window;
    var n = navigator;
    var c = "connection";
    // Chrome removes all words "Android" from `navigator` when desktop version is requested
    // Firefox keeps "Android" in `navigator.appVersion` when desktop version is requested
    if (isItChromium) return $6c22f100bb55ca27$var$countTruthy([
        !("SharedWorker" in w),
        // `typechange` is deprecated, but it's still present on Android (tested on Chrome Mobile 117)
        // Removal proposal https://bugs.chromium.org/p/chromium/issues/detail?id=699892
        // Note: this expression returns true on ChromeOS, so additional detectors are required to avoid false-positives
        n[c] && "ontypechange" in n[c],
        !("sinkId" in new window.Audio())
    ]) >= 2;
    else if (isItGecko) return $6c22f100bb55ca27$var$countTruthy([
        "onorientationchange" in w,
        "orientation" in w,
        /android/i.test(navigator.appVersion)
    ]) >= 2;
    else // Only 2 browser engines are presented on Android.
    // Actually, there is also Android 4.1 browser, but it's not worth detecting it at the moment.
    return false;
}
/**
 * Creates and keeps an invisible iframe while the given function runs.
 * The given function is called when the iframe is loaded and has a body.
 * The iframe allows to measure DOM sizes inside itself.
 *
 * Notice: passing an initial HTML code doesn't work in IE.
 *
 * Warning for package users:
 * This function is out of Semantic Versioning, i.e. can change unexpectedly. Usage is at your own risk.
 */ function $6c22f100bb55ca27$export$8b65e2577b8ab46d(action, initialHtml, domPollInterval) {
    var _a, _b, _c;
    if (domPollInterval === void 0) domPollInterval = 50;
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, void 0, void 0, function() {
        var d, iframe;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_d) {
            switch(_d.label){
                case 0:
                    d = document;
                    _d.label = 1;
                case 1:
                    if (!!d.body) return [
                        3 /*break*/ ,
                        3
                    ];
                    return [
                        4 /*yield*/ ,
                        $6c22f100bb55ca27$var$wait(domPollInterval)
                    ];
                case 2:
                    _d.sent();
                    return [
                        3 /*break*/ ,
                        1
                    ];
                case 3:
                    iframe = d.createElement("iframe");
                    _d.label = 4;
                case 4:
                    _d.trys.push([
                        4,
                        ,
                        10,
                        11
                    ]);
                    return [
                        4 /*yield*/ ,
                        new Promise(function(_resolve, _reject) {
                            var isComplete = false;
                            var resolve = function() {
                                isComplete = true;
                                _resolve();
                            };
                            var reject = function(error) {
                                isComplete = true;
                                _reject(error);
                            };
                            iframe.onload = resolve;
                            iframe.onerror = reject;
                            var style = iframe.style;
                            style.setProperty("display", "block", "important"); // Required for browsers to calculate the layout
                            style.position = "absolute";
                            style.top = "0";
                            style.left = "0";
                            style.visibility = "hidden";
                            if (initialHtml && "srcdoc" in iframe) iframe.srcdoc = initialHtml;
                            else iframe.src = "about:blank";
                            d.body.appendChild(iframe);
                            // WebKit in WeChat doesn't fire the iframe's `onload` for some reason.
                            // This code checks for the loading state manually.
                            // See https://github.com/fingerprintjs/fingerprintjs/issues/645
                            var checkReadyState = function() {
                                var _a, _b;
                                // The ready state may never become 'complete' in Firefox despite the 'load' event being fired.
                                // So an infinite setTimeout loop can happen without this check.
                                // See https://github.com/fingerprintjs/fingerprintjs/pull/716#issuecomment-986898796
                                if (isComplete) return;
                                // Make sure iframe.contentWindow and iframe.contentWindow.document are both loaded
                                // The contentWindow.document can miss in JSDOM (https://github.com/jsdom/jsdom).
                                if (((_b = (_a = iframe.contentWindow) === null || _a === void 0 ? void 0 : _a.document) === null || _b === void 0 ? void 0 : _b.readyState) === "complete") resolve();
                                else setTimeout(checkReadyState, 10);
                            };
                            checkReadyState();
                        })
                    ];
                case 5:
                    _d.sent();
                    _d.label = 6;
                case 6:
                    if (!!((_b = (_a = iframe.contentWindow) === null || _a === void 0 ? void 0 : _a.document) === null || _b === void 0 ? void 0 : _b.body)) return [
                        3 /*break*/ ,
                        8
                    ];
                    return [
                        4 /*yield*/ ,
                        $6c22f100bb55ca27$var$wait(domPollInterval)
                    ];
                case 7:
                    _d.sent();
                    return [
                        3 /*break*/ ,
                        6
                    ];
                case 8:
                    return [
                        4 /*yield*/ ,
                        action(iframe, iframe.contentWindow)
                    ];
                case 9:
                    return [
                        2 /*return*/ ,
                        _d.sent()
                    ];
                case 10:
                    (_c = iframe.parentNode) === null || _c === void 0 || _c.removeChild(iframe);
                    return [
                        7 /*endfinally*/ 
                    ];
                case 11:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
/**
 * Creates a DOM element that matches the given selector.
 * Only single element selector are supported (without operators like space, +, >, etc).
 */ function $6c22f100bb55ca27$var$selectorToElement(selector) {
    var _a = $6c22f100bb55ca27$var$parseSimpleCssSelector(selector), tag = _a[0], attributes = _a[1];
    var element = document.createElement(tag !== null && tag !== void 0 ? tag : "div");
    for(var _i = 0, _b = Object.keys(attributes); _i < _b.length; _i++){
        var name_1 = _b[_i];
        var value = attributes[name_1].join(" ");
        // Changing the `style` attribute can cause a CSP error, therefore we change the `style.cssText` property.
        // https://github.com/fingerprintjs/fingerprintjs/issues/733
        if (name_1 === "style") $6c22f100bb55ca27$var$addStyleString(element.style, value);
        else element.setAttribute(name_1, value);
    }
    return element;
}
/**
 * Adds CSS styles from a string in such a way that doesn't trigger a CSP warning (unsafe-inline or unsafe-eval)
 */ function $6c22f100bb55ca27$var$addStyleString(style, source) {
    // We don't use `style.cssText` because browsers must block it when no `unsafe-eval` CSP is presented: https://csplite.com/csp145/#w3c_note
    // Even though the browsers ignore this standard, we don't use `cssText` just in case.
    for(var _i = 0, _a = source.split(";"); _i < _a.length; _i++){
        var property = _a[_i];
        var match = /^\s*([\w-]+)\s*:\s*(.+?)(\s*!([\w-]+))?\s*$/.exec(property);
        if (match) {
            var name_2 = match[1], value = match[2], priority = match[4];
            style.setProperty(name_2, value, priority || ""); // The last argument can't be undefined in IE11
        }
    }
}
/**
 * The returned promise resolves when the tab becomes visible (in foreground).
 * If the tab is already visible, resolves immediately.
 */ function $6c22f100bb55ca27$var$whenDocumentVisible() {
    return new Promise(function(resolve) {
        var d = document;
        var eventName = "visibilitychange";
        var handleVisibilityChange = function() {
            if (!d.hidden) {
                d.removeEventListener(eventName, handleVisibilityChange);
                resolve();
            }
        };
        d.addEventListener(eventName, handleVisibilityChange);
        handleVisibilityChange();
    });
}
var $6c22f100bb55ca27$var$sampleRate = 44100;
var $6c22f100bb55ca27$var$cloneCount = 40000;
var $6c22f100bb55ca27$var$stabilizationPrecision = 6.2;
/**
 * A version of the entropy source with stabilization to make it suitable for static fingerprinting.
 * Audio signal is noised in private mode of Safari 17.
 */ function $6c22f100bb55ca27$var$getAudioFingerprint() {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, void 0, void 0, function() {
        var finish;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        $6c22f100bb55ca27$export$ed8a5b1e45927d11()
                    ];
                case 1:
                    finish = _a.sent();
                    return [
                        2 /*return*/ ,
                        function() {
                            var rawFingerprint = finish();
                            return $6c22f100bb55ca27$var$stabilize(rawFingerprint, $6c22f100bb55ca27$var$stabilizationPrecision);
                        }
                    ];
            }
        });
    });
}
/**
 * A version of the entropy source without stabilization.
 *
 * Warning for package users:
 * This function is out of Semantic Versioning, i.e. can change unexpectedly. Usage is at your own risk.
 */ function $6c22f100bb55ca27$export$ed8a5b1e45927d11() {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, void 0, void 0, function() {
        var fingerprintResult, timeoutPromise, fingerprintPromise;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    timeoutPromise = $6c22f100bb55ca27$var$whenDocumentVisible().then(function() {
                        return $6c22f100bb55ca27$var$wait(500);
                    });
                    fingerprintPromise = $6c22f100bb55ca27$var$getBaseAudioFingerprint().then(function(result) {
                        return fingerprintResult = [
                            true,
                            result
                        ];
                    }, function(error) {
                        return fingerprintResult = [
                            false,
                            error
                        ];
                    });
                    return [
                        4 /*yield*/ ,
                        Promise.race([
                            timeoutPromise,
                            fingerprintPromise
                        ])
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        function() {
                            if (!fingerprintResult) return -3 /* SpecialFingerprint.Timeout */ ;
                            if (!fingerprintResult[0]) throw fingerprintResult[1];
                            return fingerprintResult[1];
                        }
                    ];
            }
        });
    });
}
function $6c22f100bb55ca27$var$getBaseAudioFingerprint() {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, void 0, void 0, function() {
        var w, AudioContext, baseSignal, context, sourceNode, clonedSignal, fingerprint;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    w = window;
                    AudioContext = w.OfflineAudioContext || w.webkitOfflineAudioContext;
                    if (!AudioContext) return [
                        2 /*return*/ ,
                        -2 /* SpecialFingerprint.NotSupported */ 
                    ];
                    // In some browsers, audio context always stays suspended unless the context is started in response to a user action
                    // (e.g. a click or a tap). It prevents audio fingerprint from being taken at an arbitrary moment of time.
                    // Such browsers are old and unpopular, so the audio fingerprinting is just skipped in them.
                    // See a similar case explanation at https://stackoverflow.com/questions/46363048/onaudioprocess-not-called-on-ios11#46534088
                    if ($6c22f100bb55ca27$export$f63230b793acc9e7()) return [
                        2 /*return*/ ,
                        -1 /* SpecialFingerprint.KnownForSuspending */ 
                    ];
                    return [
                        4 /*yield*/ ,
                        $6c22f100bb55ca27$var$getBaseSignal(AudioContext)
                    ];
                case 1:
                    baseSignal = _a.sent();
                    if (!baseSignal) return [
                        2 /*return*/ ,
                        -3 /* SpecialFingerprint.Timeout */ 
                    ];
                    context = new AudioContext(1, baseSignal.length - 1 + $6c22f100bb55ca27$var$cloneCount, $6c22f100bb55ca27$var$sampleRate);
                    sourceNode = context.createBufferSource();
                    sourceNode.buffer = baseSignal;
                    sourceNode.loop = true;
                    sourceNode.loopStart = (baseSignal.length - 1) / $6c22f100bb55ca27$var$sampleRate;
                    sourceNode.loopEnd = baseSignal.length / $6c22f100bb55ca27$var$sampleRate;
                    sourceNode.connect(context.destination);
                    sourceNode.start();
                    return [
                        4 /*yield*/ ,
                        $6c22f100bb55ca27$export$16d121048d213eda(context)
                    ];
                case 2:
                    clonedSignal = _a.sent();
                    if (!clonedSignal) return [
                        2 /*return*/ ,
                        -3 /* SpecialFingerprint.Timeout */ 
                    ];
                    fingerprint = $6c22f100bb55ca27$var$extractFingerprint(baseSignal, clonedSignal.getChannelData(0).subarray(baseSignal.length - 1));
                    return [
                        2 /*return*/ ,
                        Math.abs(fingerprint)
                    ]; // The fingerprint is made positive to avoid confusion with the special fingerprints
            }
        });
    });
}
/**
 * Checks if the current browser is known for always suspending audio context.
 *
 * Warning for package users:
 * This function is out of Semantic Versioning, i.e. can change unexpectedly. Usage is at your own risk.
 */ function $6c22f100bb55ca27$export$f63230b793acc9e7() {
    // Mobile Safari 11 and older
    return $6c22f100bb55ca27$export$78551043582a6a98() && !$6c22f100bb55ca27$export$4949e6bd5097eae9() && !$6c22f100bb55ca27$var$isWebKit606OrNewer();
}
/**
 * Produces an arbitrary audio signal
 */ function $6c22f100bb55ca27$var$getBaseSignal(AudioContext) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, void 0, void 0, function() {
        var targetSampleIndex, context, oscillator, compressor, filter;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    targetSampleIndex = 3395;
                    context = new AudioContext(1, targetSampleIndex + 1, $6c22f100bb55ca27$var$sampleRate);
                    oscillator = context.createOscillator();
                    oscillator.type = "square";
                    oscillator.frequency.value = 1000;
                    compressor = context.createDynamicsCompressor();
                    compressor.threshold.value = -70;
                    compressor.knee.value = 40;
                    compressor.ratio.value = 12;
                    compressor.attack.value = 0;
                    compressor.release.value = 0.25;
                    filter = context.createBiquadFilter();
                    filter.type = "allpass";
                    filter.frequency.value = 5.239622852977861;
                    filter.Q.value = 0.1;
                    oscillator.connect(compressor);
                    compressor.connect(filter);
                    filter.connect(context.destination);
                    oscillator.start(0);
                    return [
                        4 /*yield*/ ,
                        $6c22f100bb55ca27$export$16d121048d213eda(context)
                    ];
                case 1:
                    return [
                        2 /*return*/ ,
                        _a.sent()
                    ];
            }
        });
    });
}
/**
 * Renders the given audio context with configured nodes.
 * Returns `null` when the rendering runs out of attempts.
 *
 * Warning for package users:
 * This function is out of Semantic Versioning, i.e. can change unexpectedly. Usage is at your own risk.
 */ function $6c22f100bb55ca27$export$16d121048d213eda(context) {
    return new Promise(function(resolve, reject) {
        var retryDelay = 200;
        var attemptsLeft = 25;
        context.oncomplete = function(event) {
            return resolve(event.renderedBuffer);
        };
        var tryRender = function() {
            try {
                var renderingPromise = context.startRendering();
                // `context.startRendering` has two APIs: Promise and callback, we check that it's really a promise just in case
                if ($6c22f100bb55ca27$var$isPromise(renderingPromise)) // Suppresses all unhandled rejections in case of scheduled redundant retries after successful rendering
                $6c22f100bb55ca27$var$suppressUnhandledRejectionWarning(renderingPromise);
                // Sometimes the audio context doesn't start after calling `startRendering` (in addition to the cases where
                // audio context doesn't start at all). A known case is starting an audio context when the browser tab is in
                // background on iPhone. Retries usually help in this case.
                if (context.state === "suspended") {
                    // The audio context can reject starting until the tab is in foreground. Long fingerprint duration
                    // in background isn't a problem, therefore the retry attempts don't count in background. It can lead to
                    // a situation when a fingerprint takes very long time and finishes successfully. FYI, the audio context
                    // can be suspended when `document.hidden === false` and start running after a retry.
                    if (!document.hidden) attemptsLeft--;
                    if (attemptsLeft > 0) setTimeout(tryRender, retryDelay);
                    else resolve(null);
                }
            } catch (error) {
                reject(error);
            }
        };
        tryRender();
    });
}
function $6c22f100bb55ca27$var$extractFingerprint(baseSignal, clonedSample) {
    var fingerprint = undefined;
    var needsDenoising = false;
    for(var i = 0; i < clonedSample.length; i += Math.floor(clonedSample.length / 10)){
        if (clonedSample[i] === 0) ;
        else if (fingerprint === undefined) fingerprint = clonedSample[i];
        else if (fingerprint !== clonedSample[i]) {
            needsDenoising = true;
            break;
        }
    }
    // The looped buffer source works incorrectly in old Safari versions (>14 desktop, >15 mobile).
    // The looped signal contains only 0s. To fix it, the loop start should be `baseSignal.length - 1.00000000001` and
    // the loop end should be `baseSignal.length + 0.00000000001` (there can be 10 or 11 0s after the point). But this
    // solution breaks the looped signal in other browsers. Instead of checking the browser version, we check that the
    // looped signals comprises only 0s, and if it does, we return the last value of the base signal, because old Safari
    // versions don't add noise that we want to cancel.
    if (fingerprint === undefined) fingerprint = baseSignal.getChannelData(0)[baseSignal.length - 1];
    else if (needsDenoising) fingerprint = $6c22f100bb55ca27$var$getMiddle(clonedSample);
    return fingerprint;
}
/**
 * Calculates the middle between the minimum and the maximum array item
 */ function $6c22f100bb55ca27$var$getMiddle(signal) {
    var min = Infinity;
    var max = -Infinity;
    for(var i = 0; i < signal.length; i++){
        var value = signal[i];
        // In very rare cases the signal is 0 on a short range for some reason. Ignoring such samples.
        if (value === 0) continue;
        if (value < min) min = value;
        if (value > max) max = value;
    }
    return (min + max) / 2;
}
/**
 * Truncates some digits of the number to make it stable.
 * `precision` is the number of significant digits to keep. The number may be not integer:
 *  - If it ends with `.2`, the last digit is rounded to the nearest multiple of 5;
 *  - If it ends with `.5`, the last digit is rounded to the nearest even number;
 */ function $6c22f100bb55ca27$var$stabilize(value, precision) {
    if (value === 0) return value;
    var power = Math.floor(Math.log10(Math.abs(value)));
    var precisionPower = power - Math.floor(precision) + 1;
    var precisionBase = Math.pow(10, -precisionPower) * (precision * 10 % 10 || 1);
    return Math.round(value * precisionBase) / precisionBase;
}
// We use m or w because these two characters take up the maximum width.
// And we use a LLi so that the same matching fonts can get separated.
var $6c22f100bb55ca27$var$testString = "mmMwWLliI0O&1";
// We test using 48px font size, we may use any size. I guess larger the better.
var $6c22f100bb55ca27$var$textSize = "48px";
// A font will be compared against all the three default fonts.
// And if for any default fonts it doesn't match, then that font is available.
var $6c22f100bb55ca27$var$baseFonts = [
    "monospace",
    "sans-serif",
    "serif"
];
var $6c22f100bb55ca27$var$fontList = [
    // This is android-specific font from "Roboto" family
    "sans-serif-thin",
    "ARNO PRO",
    "Agency FB",
    "Arabic Typesetting",
    "Arial Unicode MS",
    "AvantGarde Bk BT",
    "BankGothic Md BT",
    "Batang",
    "Bitstream Vera Sans Mono",
    "Calibri",
    "Century",
    "Century Gothic",
    "Clarendon",
    "EUROSTILE",
    "Franklin Gothic",
    "Futura Bk BT",
    "Futura Md BT",
    "GOTHAM",
    "Gill Sans",
    "HELV",
    "Haettenschweiler",
    "Helvetica Neue",
    "Humanst521 BT",
    "Leelawadee",
    "Letter Gothic",
    "Levenim MT",
    "Lucida Bright",
    "Lucida Sans",
    "Menlo",
    "MS Mincho",
    "MS Outlook",
    "MS Reference Specialty",
    "MS UI Gothic",
    "MT Extra",
    "MYRIAD PRO",
    "Marlett",
    "Meiryo UI",
    "Microsoft Uighur",
    "Minion Pro",
    "Monotype Corsiva",
    "PMingLiU",
    "Pristina",
    "SCRIPTINA",
    "Segoe UI Light",
    "Serifa",
    "SimHei",
    "Small Fonts",
    "Staccato222 BT",
    "TRAJAN PRO",
    "Univers CE 55 Medium",
    "Vrinda",
    "ZWAdobeF"
];
// kudos to http://www.lalit.org/lab/javascript-css-font-detect/
function $6c22f100bb55ca27$var$getFonts() {
    var _this = this;
    // Running the script in an iframe makes it not affect the page look and not be affected by the page CSS. See:
    // https://github.com/fingerprintjs/fingerprintjs/issues/592
    // https://github.com/fingerprintjs/fingerprintjs/issues/628
    return $6c22f100bb55ca27$export$8b65e2577b8ab46d(function(_, _a) {
        var document1 = _a.document;
        return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(_this, void 0, void 0, function() {
            var holder, spansContainer, defaultWidth, defaultHeight, createSpan, createSpanWithFonts, initializeBaseFontsSpans, initializeFontsSpans, isFontAvailable, baseFontsSpans, fontsSpans, index;
            return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        holder = document1.body;
                        holder.style.fontSize = $6c22f100bb55ca27$var$textSize;
                        spansContainer = document1.createElement("div");
                        spansContainer.style.setProperty("visibility", "hidden", "important");
                        defaultWidth = {};
                        defaultHeight = {};
                        createSpan = function(fontFamily) {
                            var span = document1.createElement("span");
                            var style = span.style;
                            style.position = "absolute";
                            style.top = "0";
                            style.left = "0";
                            style.fontFamily = fontFamily;
                            span.textContent = $6c22f100bb55ca27$var$testString;
                            spansContainer.appendChild(span);
                            return span;
                        };
                        createSpanWithFonts = function(fontToDetect, baseFont) {
                            return createSpan("'".concat(fontToDetect, "',").concat(baseFont));
                        };
                        initializeBaseFontsSpans = function() {
                            return $6c22f100bb55ca27$var$baseFonts.map(createSpan);
                        };
                        initializeFontsSpans = function() {
                            // Stores {fontName : [spans for that font]}
                            var spans = {};
                            var _loop_1 = function(font) {
                                spans[font] = $6c22f100bb55ca27$var$baseFonts.map(function(baseFont) {
                                    return createSpanWithFonts(font, baseFont);
                                });
                            };
                            for(var _i = 0, fontList_1 = $6c22f100bb55ca27$var$fontList; _i < fontList_1.length; _i++){
                                var font = fontList_1[_i];
                                _loop_1(font);
                            }
                            return spans;
                        };
                        isFontAvailable = function(fontSpans) {
                            return $6c22f100bb55ca27$var$baseFonts.some(function(baseFont, baseFontIndex) {
                                return fontSpans[baseFontIndex].offsetWidth !== defaultWidth[baseFont] || fontSpans[baseFontIndex].offsetHeight !== defaultHeight[baseFont];
                            });
                        };
                        baseFontsSpans = initializeBaseFontsSpans();
                        fontsSpans = initializeFontsSpans();
                        // add all the spans to the DOM
                        holder.appendChild(spansContainer);
                        return [
                            4 /*yield*/ ,
                            $6c22f100bb55ca27$var$releaseEventLoop()
                        ];
                    case 1:
                        _b.sent();
                        // get the default width for the three base fonts
                        for(index = 0; index < $6c22f100bb55ca27$var$baseFonts.length; index++){
                            defaultWidth[$6c22f100bb55ca27$var$baseFonts[index]] = baseFontsSpans[index].offsetWidth; // width for the default font
                            defaultHeight[$6c22f100bb55ca27$var$baseFonts[index]] = baseFontsSpans[index].offsetHeight; // height for the default font
                        }
                        // check available fonts
                        return [
                            2 /*return*/ ,
                            $6c22f100bb55ca27$var$fontList.filter(function(font) {
                                return isFontAvailable(fontsSpans[font]);
                            })
                        ];
                }
            });
        });
    });
}
function $6c22f100bb55ca27$var$getPlugins() {
    var rawPlugins = navigator.plugins;
    if (!rawPlugins) return undefined;
    var plugins = [];
    // Safari 10 doesn't support iterating navigator.plugins with for...of
    for(var i = 0; i < rawPlugins.length; ++i){
        var plugin = rawPlugins[i];
        if (!plugin) continue;
        var mimeTypes = [];
        for(var j = 0; j < plugin.length; ++j){
            var mimeType = plugin[j];
            mimeTypes.push({
                type: mimeType.type,
                suffixes: mimeType.suffixes
            });
        }
        plugins.push({
            name: plugin.name,
            description: plugin.description,
            mimeTypes: mimeTypes
        });
    }
    return plugins;
}
/**
 * @see https://www.browserleaks.com/canvas#how-does-it-work
 *
 * A version of the entropy source with stabilization to make it suitable for static fingerprinting.
 * Canvas image is noised in private mode of Safari 17, so image rendering is skipped in Safari 17.
 */ function $6c22f100bb55ca27$var$getCanvasFingerprint() {
    return $6c22f100bb55ca27$export$8ae13959fff0d124($6c22f100bb55ca27$var$doesBrowserPerformAntifingerprinting());
}
/**
 * A version of the entropy source without stabilization.
 *
 * Warning for package users:
 * This function is out of Semantic Versioning, i.e. can change unexpectedly. Usage is at your own risk.
 */ function $6c22f100bb55ca27$export$8ae13959fff0d124(skipImages) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, void 0, void 0, function() {
        var winding, geometry, text, _a, canvas, context;
        var _b;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    winding = false;
                    _a = $6c22f100bb55ca27$var$makeCanvasContext(), canvas = _a[0], context = _a[1];
                    if (!!$6c22f100bb55ca27$var$isSupported(canvas, context)) return [
                        3 /*break*/ ,
                        1
                    ];
                    geometry = text = "unsupported" /* ImageStatus.Unsupported */ ;
                    return [
                        3 /*break*/ ,
                        4
                    ];
                case 1:
                    winding = $6c22f100bb55ca27$var$doesSupportWinding(context);
                    if (!skipImages) return [
                        3 /*break*/ ,
                        2
                    ];
                    geometry = text = "skipped" /* ImageStatus.Skipped */ ;
                    return [
                        3 /*break*/ ,
                        4
                    ];
                case 2:
                    return [
                        4 /*yield*/ ,
                        $6c22f100bb55ca27$var$renderImages(canvas, context)
                    ];
                case 3:
                    _b = _c.sent(), geometry = _b[0], text = _b[1];
                    _c.label = 4;
                case 4:
                    return [
                        2 /*return*/ ,
                        {
                            winding: winding,
                            geometry: geometry,
                            text: text
                        }
                    ];
            }
        });
    });
}
function $6c22f100bb55ca27$var$makeCanvasContext() {
    var canvas = document.createElement("canvas");
    canvas.width = 1;
    canvas.height = 1;
    return [
        canvas,
        canvas.getContext("2d")
    ];
}
function $6c22f100bb55ca27$var$isSupported(canvas, context) {
    return !!(context && canvas.toDataURL);
}
function $6c22f100bb55ca27$var$doesSupportWinding(context) {
    // https://web.archive.org/web/20170825024655/http://blogs.adobe.com/webplatform/2013/01/30/winding-rules-in-canvas/
    // https://github.com/Modernizr/Modernizr/blob/master/feature-detects/canvas/winding.js
    context.rect(0, 0, 10, 10);
    context.rect(2, 2, 6, 6);
    return !context.isPointInPath(5, 5, "evenodd");
}
function $6c22f100bb55ca27$var$renderImages(canvas, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, void 0, void 0, function() {
        var textImage1, textImage2, geometryImage;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    $6c22f100bb55ca27$var$renderTextImage(canvas, context);
                    return [
                        4 /*yield*/ ,
                        $6c22f100bb55ca27$var$releaseEventLoop()
                    ];
                case 1:
                    _a.sent();
                    textImage1 = $6c22f100bb55ca27$var$canvasToString(canvas);
                    textImage2 = $6c22f100bb55ca27$var$canvasToString(canvas) // It's slightly faster to double-encode the text image
                    ;
                    // Some browsers add a noise to the canvas: https://github.com/fingerprintjs/fingerprintjs/issues/791
                    // The canvas is excluded from the fingerprint in this case
                    if (textImage1 !== textImage2) return [
                        2 /*return*/ ,
                        [
                            "unstable" /* ImageStatus.Unstable */ ,
                            "unstable" /* ImageStatus.Unstable */ 
                        ]
                    ];
                    // Text is unstable:
                    // https://github.com/fingerprintjs/fingerprintjs/issues/583
                    // https://github.com/fingerprintjs/fingerprintjs/issues/103
                    // Therefore it's extracted into a separate image.
                    $6c22f100bb55ca27$var$renderGeometryImage(canvas, context);
                    return [
                        4 /*yield*/ ,
                        $6c22f100bb55ca27$var$releaseEventLoop()
                    ];
                case 2:
                    _a.sent();
                    geometryImage = $6c22f100bb55ca27$var$canvasToString(canvas);
                    return [
                        2 /*return*/ ,
                        [
                            textImage1,
                            geometryImage
                        ]
                    ];
            }
        });
    });
}
function $6c22f100bb55ca27$var$renderTextImage(canvas, context) {
    // Resizing the canvas cleans it
    canvas.width = 240;
    canvas.height = 60;
    context.textBaseline = "alphabetic";
    context.fillStyle = "#f60";
    context.fillRect(100, 1, 62, 20);
    context.fillStyle = "#069";
    // It's important to use explicit built-in fonts in order to exclude the affect of font preferences
    // (there is a separate entropy source for them).
    context.font = '11pt "Times New Roman"';
    // The choice of emojis has a gigantic impact on rendering performance (especially in FF).
    // Some newer emojis cause it to slow down 50-200 times.
    // There must be no text to the right of the emoji, see https://github.com/fingerprintjs/fingerprintjs/issues/574
    // A bare emoji shouldn't be used because the canvas will change depending on the script encoding:
    // https://github.com/fingerprintjs/fingerprintjs/issues/66
    // Escape sequence shouldn't be used too because Terser will turn it into a bare unicode.
    var printedText = "Cwm fjordbank gly ".concat(String.fromCharCode(55357, 56835));
    context.fillText(printedText, 2, 15);
    context.fillStyle = "rgba(102, 204, 0, 0.2)";
    context.font = "18pt Arial";
    context.fillText(printedText, 4, 45);
}
function $6c22f100bb55ca27$var$renderGeometryImage(canvas, context) {
    // Resizing the canvas cleans it
    canvas.width = 122;
    canvas.height = 110;
    // Canvas blending
    // https://web.archive.org/web/20170826194121/http://blogs.adobe.com/webplatform/2013/01/28/blending-features-in-canvas/
    // http://jsfiddle.net/NDYV8/16/
    context.globalCompositeOperation = "multiply";
    for(var _i = 0, _a = [
        [
            "#f2f",
            40,
            40
        ],
        [
            "#2ff",
            80,
            40
        ],
        [
            "#ff2",
            60,
            80
        ]
    ]; _i < _a.length; _i++){
        var _b = _a[_i], color = _b[0], x = _b[1], y = _b[2];
        context.fillStyle = color;
        context.beginPath();
        context.arc(x, y, 40, 0, Math.PI * 2, true);
        context.closePath();
        context.fill();
    }
    // Canvas winding
    // https://web.archive.org/web/20130913061632/http://blogs.adobe.com/webplatform/2013/01/30/winding-rules-in-canvas/
    // http://jsfiddle.net/NDYV8/19/
    context.fillStyle = "#f9c";
    context.arc(60, 60, 60, 0, Math.PI * 2, true);
    context.arc(60, 60, 20, 0, Math.PI * 2, true);
    context.fill("evenodd");
}
function $6c22f100bb55ca27$var$canvasToString(canvas) {
    return canvas.toDataURL();
}
/**
 * Checks if the current browser is known for applying anti-fingerprinting measures in all or some critical modes
 */ function $6c22f100bb55ca27$var$doesBrowserPerformAntifingerprinting() {
    // Safari 17
    return $6c22f100bb55ca27$export$78551043582a6a98() && $6c22f100bb55ca27$var$isWebKit616OrNewer() && $6c22f100bb55ca27$var$isSafariWebKit();
}
/**
 * This is a crude and primitive touch screen detection. It's not possible to currently reliably detect the availability
 * of a touch screen with a JS, without actually subscribing to a touch event.
 *
 * @see http://www.stucox.com/blog/you-cant-detect-a-touchscreen/
 * @see https://github.com/Modernizr/Modernizr/issues/548
 */ function $6c22f100bb55ca27$var$getTouchSupport() {
    var n = navigator;
    var maxTouchPoints = 0;
    var touchEvent;
    if (n.maxTouchPoints !== undefined) maxTouchPoints = $6c22f100bb55ca27$var$toInt(n.maxTouchPoints);
    else if (n.msMaxTouchPoints !== undefined) maxTouchPoints = n.msMaxTouchPoints;
    try {
        document.createEvent("TouchEvent");
        touchEvent = true;
    } catch (_a) {
        touchEvent = false;
    }
    var touchStart = "ontouchstart" in window;
    return {
        maxTouchPoints: maxTouchPoints,
        touchEvent: touchEvent,
        touchStart: touchStart
    };
}
function $6c22f100bb55ca27$var$getOsCpu() {
    return navigator.oscpu;
}
function $6c22f100bb55ca27$var$getLanguages() {
    var n = navigator;
    var result = [];
    var language = n.language || n.userLanguage || n.browserLanguage || n.systemLanguage;
    if (language !== undefined) result.push([
        language
    ]);
    if (Array.isArray(n.languages)) // Starting from Chromium 86, there is only a single value in `navigator.language` in Incognito mode:
    // the value of `navigator.language`. Therefore the value is ignored in this browser.
    {
        if (!($6c22f100bb55ca27$export$dd401a4677e99039() && $6c22f100bb55ca27$var$isChromium86OrNewer())) result.push(n.languages);
    } else if (typeof n.languages === "string") {
        var languages = n.languages;
        if (languages) result.push(languages.split(","));
    }
    return result;
}
function $6c22f100bb55ca27$var$getColorDepth() {
    return window.screen.colorDepth;
}
function $6c22f100bb55ca27$var$getDeviceMemory() {
    // `navigator.deviceMemory` is a string containing a number in some unidentified cases
    return $6c22f100bb55ca27$var$replaceNaN($6c22f100bb55ca27$var$toFloat(navigator.deviceMemory), undefined);
}
/**
 * A version of the entropy source with stabilization to make it suitable for static fingerprinting.
 * The window resolution is always the document size in private mode of Safari 17,
 * so the window resolution is not used in Safari 17.
 */ function $6c22f100bb55ca27$var$getScreenResolution() {
    if ($6c22f100bb55ca27$export$78551043582a6a98() && $6c22f100bb55ca27$var$isWebKit616OrNewer() && $6c22f100bb55ca27$var$isSafariWebKit()) return undefined;
    return $6c22f100bb55ca27$export$f3fa51f8ac20bc2f();
}
/**
 * A version of the entropy source without stabilization.
 *
 * Warning for package users:
 * This function is out of Semantic Versioning, i.e. can change unexpectedly. Usage is at your own risk.
 */ function $6c22f100bb55ca27$export$f3fa51f8ac20bc2f() {
    var s = screen;
    // Some browsers return screen resolution as strings, e.g. "1200", instead of a number, e.g. 1200.
    // I suspect it's done by certain plugins that randomize browser properties to prevent fingerprinting.
    // Some browsers even return  screen resolution as not numbers.
    var parseDimension = function(value) {
        return $6c22f100bb55ca27$var$replaceNaN($6c22f100bb55ca27$var$toInt(value), null);
    };
    var dimensions = [
        parseDimension(s.width),
        parseDimension(s.height)
    ];
    dimensions.sort().reverse();
    return dimensions;
}
var $6c22f100bb55ca27$var$screenFrameCheckInterval = 2500;
var $6c22f100bb55ca27$var$roundingPrecision = 10;
// The type is readonly to protect from unwanted mutations
var $6c22f100bb55ca27$var$screenFrameBackup;
var $6c22f100bb55ca27$var$screenFrameSizeTimeoutId;
/**
 * Starts watching the screen frame size. When a non-zero size appears, the size is saved and the watch is stopped.
 * Later, when `getScreenFrame` runs, it will return the saved non-zero size if the current size is null.
 *
 * This trick is required to mitigate the fact that the screen frame turns null in some cases.
 * See more on this at https://github.com/fingerprintjs/fingerprintjs/issues/568
 */ function $6c22f100bb55ca27$var$watchScreenFrame() {
    if ($6c22f100bb55ca27$var$screenFrameSizeTimeoutId !== undefined) return;
    var checkScreenFrame = function() {
        var frameSize = $6c22f100bb55ca27$var$getCurrentScreenFrame();
        if ($6c22f100bb55ca27$var$isFrameSizeNull(frameSize)) $6c22f100bb55ca27$var$screenFrameSizeTimeoutId = setTimeout(checkScreenFrame, $6c22f100bb55ca27$var$screenFrameCheckInterval);
        else {
            $6c22f100bb55ca27$var$screenFrameBackup = frameSize;
            $6c22f100bb55ca27$var$screenFrameSizeTimeoutId = undefined;
        }
    };
    checkScreenFrame();
}
/**
 * A version of the entropy source without stabilization.
 *
 * Warning for package users:
 * This function is out of Semantic Versioning, i.e. can change unexpectedly. Usage is at your own risk.
 */ function $6c22f100bb55ca27$export$39dba64e17958038() {
    var _this = this;
    $6c22f100bb55ca27$var$watchScreenFrame();
    return function() {
        return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(_this, void 0, void 0, function() {
            var frameSize;
            return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        frameSize = $6c22f100bb55ca27$var$getCurrentScreenFrame();
                        if (!$6c22f100bb55ca27$var$isFrameSizeNull(frameSize)) return [
                            3 /*break*/ ,
                            2
                        ];
                        if ($6c22f100bb55ca27$var$screenFrameBackup) return [
                            2 /*return*/ ,
                            (0, $5c96a02c592fcff1$export$1216008129fb82ed)([], $6c22f100bb55ca27$var$screenFrameBackup, true)
                        ];
                        if (!$6c22f100bb55ca27$export$a095f8af1f7b5580()) return [
                            3 /*break*/ ,
                            2
                        ];
                        // Some browsers set the screen frame to zero when programmatic fullscreen is on.
                        // There is a chance of getting a non-zero frame after exiting the fullscreen.
                        // See more on this at https://github.com/fingerprintjs/fingerprintjs/issues/568
                        return [
                            4 /*yield*/ ,
                            $6c22f100bb55ca27$var$exitFullscreen()
                        ];
                    case 1:
                        // Some browsers set the screen frame to zero when programmatic fullscreen is on.
                        // There is a chance of getting a non-zero frame after exiting the fullscreen.
                        // See more on this at https://github.com/fingerprintjs/fingerprintjs/issues/568
                        _a.sent();
                        frameSize = $6c22f100bb55ca27$var$getCurrentScreenFrame();
                        _a.label = 2;
                    case 2:
                        if (!$6c22f100bb55ca27$var$isFrameSizeNull(frameSize)) $6c22f100bb55ca27$var$screenFrameBackup = frameSize;
                        return [
                            2 /*return*/ ,
                            frameSize
                        ];
                }
            });
        });
    };
}
/**
 * A version of the entropy source with stabilization to make it suitable for static fingerprinting.
 *
 * Sometimes the available screen resolution changes a bit, e.g. 1900x1440 → 1900x1439. A possible reason: macOS Dock
 * shrinks to fit more icons when there is too little space. The rounding is used to mitigate the difference.
 *
 * The frame width is always 0 in private mode of Safari 17, so the frame is not used in Safari 17.
 */ function $6c22f100bb55ca27$var$getScreenFrame() {
    var _this = this;
    if ($6c22f100bb55ca27$export$78551043582a6a98() && $6c22f100bb55ca27$var$isWebKit616OrNewer() && $6c22f100bb55ca27$var$isSafariWebKit()) return function() {
        return Promise.resolve(undefined);
    };
    var screenFrameGetter = $6c22f100bb55ca27$export$39dba64e17958038();
    return function() {
        return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(_this, void 0, void 0, function() {
            var frameSize, processSize;
            return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            screenFrameGetter()
                        ];
                    case 1:
                        frameSize = _a.sent();
                        processSize = function(sideSize) {
                            return sideSize === null ? null : $6c22f100bb55ca27$var$round(sideSize, $6c22f100bb55ca27$var$roundingPrecision);
                        };
                        // It might look like I don't know about `for` and `map`.
                        // In fact, such code is used to avoid TypeScript issues without using `as`.
                        return [
                            2 /*return*/ ,
                            [
                                processSize(frameSize[0]),
                                processSize(frameSize[1]),
                                processSize(frameSize[2]),
                                processSize(frameSize[3])
                            ]
                        ];
                }
            });
        });
    };
}
function $6c22f100bb55ca27$var$getCurrentScreenFrame() {
    var s = screen;
    // Some browsers return screen resolution as strings, e.g. "1200", instead of a number, e.g. 1200.
    // I suspect it's done by certain plugins that randomize browser properties to prevent fingerprinting.
    //
    // Some browsers (IE, Edge ≤18) don't provide `screen.availLeft` and `screen.availTop`. The property values are
    // replaced with 0 in such cases to not lose the entropy from `screen.availWidth` and `screen.availHeight`.
    return [
        $6c22f100bb55ca27$var$replaceNaN($6c22f100bb55ca27$var$toFloat(s.availTop), null),
        $6c22f100bb55ca27$var$replaceNaN($6c22f100bb55ca27$var$toFloat(s.width) - $6c22f100bb55ca27$var$toFloat(s.availWidth) - $6c22f100bb55ca27$var$replaceNaN($6c22f100bb55ca27$var$toFloat(s.availLeft), 0), null),
        $6c22f100bb55ca27$var$replaceNaN($6c22f100bb55ca27$var$toFloat(s.height) - $6c22f100bb55ca27$var$toFloat(s.availHeight) - $6c22f100bb55ca27$var$replaceNaN($6c22f100bb55ca27$var$toFloat(s.availTop), 0), null),
        $6c22f100bb55ca27$var$replaceNaN($6c22f100bb55ca27$var$toFloat(s.availLeft), null)
    ];
}
function $6c22f100bb55ca27$var$isFrameSizeNull(frameSize) {
    for(var i = 0; i < 4; ++i){
        if (frameSize[i]) return false;
    }
    return true;
}
function $6c22f100bb55ca27$var$getHardwareConcurrency() {
    // sometimes hardware concurrency is a string
    return $6c22f100bb55ca27$var$replaceNaN($6c22f100bb55ca27$var$toInt(navigator.hardwareConcurrency), undefined);
}
function $6c22f100bb55ca27$var$getTimezone() {
    var _a;
    var DateTimeFormat = (_a = window.Intl) === null || _a === void 0 ? void 0 : _a.DateTimeFormat;
    if (DateTimeFormat) {
        var timezone = new DateTimeFormat().resolvedOptions().timeZone;
        if (timezone) return timezone;
    }
    // For browsers that don't support timezone names
    // The minus is intentional because the JS offset is opposite to the real offset
    var offset = -$6c22f100bb55ca27$var$getTimezoneOffset();
    return "UTC".concat(offset >= 0 ? "+" : "").concat(Math.abs(offset));
}
function $6c22f100bb55ca27$var$getTimezoneOffset() {
    var currentYear = new Date().getFullYear();
    // The timezone offset may change over time due to daylight saving time (DST) shifts.
    // The non-DST timezone offset is used as the result timezone offset.
    // Since the DST season differs in the northern and the southern hemispheres,
    // both January and July timezones offsets are considered.
    return Math.max(// `getTimezoneOffset` returns a number as a string in some unidentified cases
    $6c22f100bb55ca27$var$toFloat(new Date(currentYear, 0, 1).getTimezoneOffset()), $6c22f100bb55ca27$var$toFloat(new Date(currentYear, 6, 1).getTimezoneOffset()));
}
function $6c22f100bb55ca27$var$getSessionStorage() {
    try {
        return !!window.sessionStorage;
    } catch (error) {
        /* SecurityError when referencing it means it exists */ return true;
    }
}
// https://bugzilla.mozilla.org/show_bug.cgi?id=781447
function $6c22f100bb55ca27$var$getLocalStorage() {
    try {
        return !!window.localStorage;
    } catch (e) {
        /* SecurityError when referencing it means it exists */ return true;
    }
}
function $6c22f100bb55ca27$var$getIndexedDB() {
    // IE and Edge don't allow accessing indexedDB in private mode, therefore IE and Edge will have different
    // visitor identifier in normal and private modes.
    if ($6c22f100bb55ca27$export$5aba6d4fec9b366c() || $6c22f100bb55ca27$export$13c899a793cdf73d()) return undefined;
    try {
        return !!window.indexedDB;
    } catch (e) {
        /* SecurityError when referencing it means it exists */ return true;
    }
}
function $6c22f100bb55ca27$var$getOpenDatabase() {
    return !!window.openDatabase;
}
function $6c22f100bb55ca27$var$getCpuClass() {
    return navigator.cpuClass;
}
function $6c22f100bb55ca27$var$getPlatform() {
    // Android Chrome 86 and 87 and Android Firefox 80 and 84 don't mock the platform value when desktop mode is requested
    var platform = navigator.platform;
    // iOS mocks the platform value when desktop version is requested: https://github.com/fingerprintjs/fingerprintjs/issues/514
    // iPad uses desktop mode by default since iOS 13
    // The value is 'MacIntel' on M1 Macs
    // The value is 'iPhone' on iPod Touch
    if (platform === "MacIntel") {
        if ($6c22f100bb55ca27$export$78551043582a6a98() && !$6c22f100bb55ca27$export$4949e6bd5097eae9()) return $6c22f100bb55ca27$var$isIPad() ? "iPad" : "iPhone";
    }
    return platform;
}
function $6c22f100bb55ca27$var$getVendor() {
    return navigator.vendor || "";
}
/**
 * Checks for browser-specific (not engine specific) global variables to tell browsers with the same engine apart.
 * Only somewhat popular browsers are considered.
 */ function $6c22f100bb55ca27$var$getVendorFlavors() {
    var flavors = [];
    for(var _i = 0, _a = [
        // Blink and some browsers on iOS
        "chrome",
        // Safari on macOS
        "safari",
        // Chrome on iOS (checked in 85 on 13 and 87 on 14)
        "__crWeb",
        "__gCrWeb",
        // Yandex Browser on iOS, macOS and Android (checked in 21.2 on iOS 14, macOS and Android)
        "yandex",
        // Yandex Browser on iOS (checked in 21.2 on 14)
        "__yb",
        "__ybro",
        // Firefox on iOS (checked in 32 on 14)
        "__firefox__",
        // Edge on iOS (checked in 46 on 14)
        "__edgeTrackingPreventionStatistics",
        "webkit",
        // Opera Touch on iOS (checked in 2.6 on 14)
        "oprt",
        // Samsung Internet on Android (checked in 11.1)
        "samsungAr",
        // UC Browser on Android (checked in 12.10 and 13.0)
        "ucweb",
        "UCShellJava",
        // Puffin on Android (checked in 9.0)
        "puffinDevice"
    ]; _i < _a.length; _i++){
        var key = _a[_i];
        var value = window[key];
        if (value && typeof value === "object") flavors.push(key);
    }
    return flavors.sort();
}
/**
 * navigator.cookieEnabled cannot detect custom or nuanced cookie blocking configurations. For example, when blocking
 * cookies via the Advanced Privacy Settings in IE9, it always returns true. And there have been issues in the past with
 * site-specific exceptions. Don't rely on it.
 *
 * @see https://github.com/Modernizr/Modernizr/blob/master/feature-detects/cookies.js Taken from here
 */ function $6c22f100bb55ca27$var$areCookiesEnabled() {
    var d = document;
    // Taken from here: https://github.com/Modernizr/Modernizr/blob/master/feature-detects/cookies.js
    // navigator.cookieEnabled cannot detect custom or nuanced cookie blocking configurations. For example, when blocking
    // cookies via the Advanced Privacy Settings in IE9, it always returns true. And there have been issues in the past
    // with site-specific exceptions. Don't rely on it.
    // try..catch because some in situations `document.cookie` is exposed but throws a
    // SecurityError if you try to access it; e.g. documents created from data URIs
    // or in sandboxed iframes (depending on flags/context)
    try {
        // Create cookie
        d.cookie = "cookietest=1; SameSite=Strict;";
        var result = d.cookie.indexOf("cookietest=") !== -1;
        // Delete cookie
        d.cookie = "cookietest=1; SameSite=Strict; expires=Thu, 01-Jan-1970 00:00:01 GMT";
        return result;
    } catch (e) {
        return false;
    }
}
/**
 * Only single element selector are supported (no operators like space, +, >, etc).
 * `embed` and `position: fixed;` will be considered as blocked anyway because it always has no offsetParent.
 * Avoid `iframe` and anything with `[src=]` because they produce excess HTTP requests.
 *
 * The "inappropriate" selectors are obfuscated. See https://github.com/fingerprintjs/fingerprintjs/issues/734.
 * A function is used instead of a plain object to help tree-shaking.
 *
 * The function code is generated automatically. See docs/content_blockers.md to learn how to make the list.
 */ function $6c22f100bb55ca27$var$getFilters() {
    var fromB64 = atob; // Just for better minification
    return {
        abpIndo: [
            "#Iklan-Melayang",
            "#Kolom-Iklan-728",
            "#SidebarIklan-wrapper",
            '[title="ALIENBOLA" i]',
            fromB64("I0JveC1CYW5uZXItYWRz")
        ],
        abpvn: [
            ".quangcao",
            "#mobileCatfish",
            fromB64("LmNsb3NlLWFkcw=="),
            '[id^="bn_bottom_fixed_"]',
            "#pmadv"
        ],
        adBlockFinland: [
            ".mainostila",
            fromB64("LnNwb25zb3JpdA=="),
            ".ylamainos",
            fromB64("YVtocmVmKj0iL2NsaWNrdGhyZ2guYXNwPyJd"),
            fromB64("YVtocmVmXj0iaHR0cHM6Ly9hcHAucmVhZHBlYWsuY29tL2FkcyJd")
        ],
        adBlockPersian: [
            "#navbar_notice_50",
            ".kadr",
            'TABLE[width="140px"]',
            "#divAgahi",
            fromB64("YVtocmVmXj0iaHR0cDovL2cxLnYuZndtcm0ubmV0L2FkLyJd")
        ],
        adBlockWarningRemoval: [
            "#adblock-honeypot",
            ".adblocker-root",
            ".wp_adblock_detect",
            fromB64("LmhlYWRlci1ibG9ja2VkLWFk"),
            fromB64("I2FkX2Jsb2NrZXI=")
        ],
        adGuardAnnoyances: [
            ".hs-sosyal",
            "#cookieconsentdiv",
            'div[class^="app_gdpr"]',
            ".as-oil",
            '[data-cypress="soft-push-notification-modal"]'
        ],
        adGuardBase: [
            ".BetterJsPopOverlay",
            fromB64("I2FkXzMwMFgyNTA="),
            fromB64("I2Jhbm5lcmZsb2F0MjI="),
            fromB64("I2NhbXBhaWduLWJhbm5lcg=="),
            fromB64("I0FkLUNvbnRlbnQ=")
        ],
        adGuardChinese: [
            fromB64("LlppX2FkX2FfSA=="),
            fromB64("YVtocmVmKj0iLmh0aGJldDM0LmNvbSJd"),
            "#widget-quan",
            fromB64("YVtocmVmKj0iLzg0OTkyMDIwLnh5eiJd"),
            fromB64("YVtocmVmKj0iLjE5NTZobC5jb20vIl0=")
        ],
        adGuardFrench: [
            "#pavePub",
            fromB64("LmFkLWRlc2t0b3AtcmVjdGFuZ2xl"),
            ".mobile_adhesion",
            ".widgetadv",
            fromB64("LmFkc19iYW4=")
        ],
        adGuardGerman: [
            'aside[data-portal-id="leaderboard"]'
        ],
        adGuardJapanese: [
            "#kauli_yad_1",
            fromB64("YVtocmVmXj0iaHR0cDovL2FkMi50cmFmZmljZ2F0ZS5uZXQvIl0="),
            fromB64("Ll9wb3BJbl9pbmZpbml0ZV9hZA=="),
            fromB64("LmFkZ29vZ2xl"),
            fromB64("Ll9faXNib29zdFJldHVybkFk")
        ],
        adGuardMobile: [
            fromB64("YW1wLWF1dG8tYWRz"),
            fromB64("LmFtcF9hZA=="),
            'amp-embed[type="24smi"]',
            "#mgid_iframe1",
            fromB64("I2FkX2ludmlld19hcmVh")
        ],
        adGuardRussian: [
            fromB64("YVtocmVmXj0iaHR0cHM6Ly9hZC5sZXRtZWFkcy5jb20vIl0="),
            fromB64("LnJlY2xhbWE="),
            'div[id^="smi2adblock"]',
            fromB64("ZGl2W2lkXj0iQWRGb3hfYmFubmVyXyJd"),
            "#psyduckpockeball"
        ],
        adGuardSocial: [
            fromB64("YVtocmVmXj0iLy93d3cuc3R1bWJsZXVwb24uY29tL3N1Ym1pdD91cmw9Il0="),
            fromB64("YVtocmVmXj0iLy90ZWxlZ3JhbS5tZS9zaGFyZS91cmw/Il0="),
            ".etsy-tweet",
            "#inlineShare",
            ".popup-social"
        ],
        adGuardSpanishPortuguese: [
            "#barraPublicidade",
            "#Publicidade",
            "#publiEspecial",
            "#queTooltip",
            ".cnt-publi"
        ],
        adGuardTrackingProtection: [
            "#qoo-counter",
            fromB64("YVtocmVmXj0iaHR0cDovL2NsaWNrLmhvdGxvZy5ydS8iXQ=="),
            fromB64("YVtocmVmXj0iaHR0cDovL2hpdGNvdW50ZXIucnUvdG9wL3N0YXQucGhwIl0="),
            fromB64("YVtocmVmXj0iaHR0cDovL3RvcC5tYWlsLnJ1L2p1bXAiXQ=="),
            "#top100counter"
        ],
        adGuardTurkish: [
            "#backkapat",
            fromB64("I3Jla2xhbWk="),
            fromB64("YVtocmVmXj0iaHR0cDovL2Fkc2Vydi5vbnRlay5jb20udHIvIl0="),
            fromB64("YVtocmVmXj0iaHR0cDovL2l6bGVuemkuY29tL2NhbXBhaWduLyJd"),
            fromB64("YVtocmVmXj0iaHR0cDovL3d3dy5pbnN0YWxsYWRzLm5ldC8iXQ==")
        ],
        bulgarian: [
            fromB64("dGQjZnJlZW5ldF90YWJsZV9hZHM="),
            "#ea_intext_div",
            ".lapni-pop-over",
            "#xenium_hot_offers"
        ],
        easyList: [
            ".yb-floorad",
            fromB64("LndpZGdldF9wb19hZHNfd2lkZ2V0"),
            fromB64("LnRyYWZmaWNqdW5reS1hZA=="),
            ".textad_headline",
            fromB64("LnNwb25zb3JlZC10ZXh0LWxpbmtz")
        ],
        easyListChina: [
            fromB64("LmFwcGd1aWRlLXdyYXBbb25jbGljayo9ImJjZWJvcy5jb20iXQ=="),
            fromB64("LmZyb250cGFnZUFkdk0="),
            "#taotaole",
            "#aafoot.top_box",
            ".cfa_popup"
        ],
        easyListCookie: [
            ".ezmob-footer",
            ".cc-CookieWarning",
            "[data-cookie-number]",
            fromB64("LmF3LWNvb2tpZS1iYW5uZXI="),
            ".sygnal24-gdpr-modal-wrap"
        ],
        easyListCzechSlovak: [
            "#onlajny-stickers",
            fromB64("I3Jla2xhbW5pLWJveA=="),
            fromB64("LnJla2xhbWEtbWVnYWJvYXJk"),
            ".sklik",
            fromB64("W2lkXj0ic2tsaWtSZWtsYW1hIl0=")
        ],
        easyListDutch: [
            fromB64("I2FkdmVydGVudGll"),
            fromB64("I3ZpcEFkbWFya3RCYW5uZXJCbG9jaw=="),
            ".adstekst",
            fromB64("YVtocmVmXj0iaHR0cHM6Ly94bHR1YmUubmwvY2xpY2svIl0="),
            "#semilo-lrectangle"
        ],
        easyListGermany: [
            "#SSpotIMPopSlider",
            fromB64("LnNwb25zb3JsaW5rZ3J1ZW4="),
            fromB64("I3dlcmJ1bmdza3k="),
            fromB64("I3Jla2xhbWUtcmVjaHRzLW1pdHRl"),
            fromB64("YVtocmVmXj0iaHR0cHM6Ly9iZDc0Mi5jb20vIl0=")
        ],
        easyListItaly: [
            fromB64("LmJveF9hZHZfYW5udW5jaQ=="),
            ".sb-box-pubbliredazionale",
            fromB64("YVtocmVmXj0iaHR0cDovL2FmZmlsaWF6aW9uaWFkcy5zbmFpLml0LyJd"),
            fromB64("YVtocmVmXj0iaHR0cHM6Ly9hZHNlcnZlci5odG1sLml0LyJd"),
            fromB64("YVtocmVmXj0iaHR0cHM6Ly9hZmZpbGlhemlvbmlhZHMuc25haS5pdC8iXQ==")
        ],
        easyListLithuania: [
            fromB64("LnJla2xhbW9zX3RhcnBhcw=="),
            fromB64("LnJla2xhbW9zX251b3JvZG9z"),
            fromB64("aW1nW2FsdD0iUmVrbGFtaW5pcyBza3lkZWxpcyJd"),
            fromB64("aW1nW2FsdD0iRGVkaWt1b3RpLmx0IHNlcnZlcmlhaSJd"),
            fromB64("aW1nW2FsdD0iSG9zdGluZ2FzIFNlcnZlcmlhaS5sdCJd")
        ],
        estonian: [
            fromB64("QVtocmVmKj0iaHR0cDovL3BheTRyZXN1bHRzMjQuZXUiXQ==")
        ],
        fanboyAnnoyances: [
            "#ac-lre-player",
            ".navigate-to-top",
            "#subscribe_popup",
            ".newsletter_holder",
            "#back-top"
        ],
        fanboyAntiFacebook: [
            ".util-bar-module-firefly-visible"
        ],
        fanboyEnhancedTrackers: [
            ".open.pushModal",
            "#issuem-leaky-paywall-articles-zero-remaining-nag",
            "#sovrn_container",
            'div[class$="-hide"][zoompage-fontsize][style="display: block;"]',
            ".BlockNag__Card"
        ],
        fanboySocial: [
            "#FollowUs",
            "#meteored_share",
            "#social_follow",
            ".article-sharer",
            ".community__social-desc"
        ],
        frellwitSwedish: [
            fromB64("YVtocmVmKj0iY2FzaW5vcHJvLnNlIl1bdGFyZ2V0PSJfYmxhbmsiXQ=="),
            fromB64("YVtocmVmKj0iZG9rdG9yLXNlLm9uZWxpbmsubWUiXQ=="),
            "article.category-samarbete",
            fromB64("ZGl2LmhvbGlkQWRz"),
            "ul.adsmodern"
        ],
        greekAdBlock: [
            fromB64("QVtocmVmKj0iYWRtYW4ub3RlbmV0LmdyL2NsaWNrPyJd"),
            fromB64("QVtocmVmKj0iaHR0cDovL2F4aWFiYW5uZXJzLmV4b2R1cy5nci8iXQ=="),
            fromB64("QVtocmVmKj0iaHR0cDovL2ludGVyYWN0aXZlLmZvcnRobmV0LmdyL2NsaWNrPyJd"),
            "DIV.agores300",
            "TABLE.advright"
        ],
        hungarian: [
            "#cemp_doboz",
            ".optimonk-iframe-container",
            fromB64("LmFkX19tYWlu"),
            fromB64("W2NsYXNzKj0iR29vZ2xlQWRzIl0="),
            "#hirdetesek_box"
        ],
        iDontCareAboutCookies: [
            '.alert-info[data-block-track*="CookieNotice"]',
            ".ModuleTemplateCookieIndicator",
            ".o--cookies--container",
            "#cookies-policy-sticky",
            "#stickyCookieBar"
        ],
        icelandicAbp: [
            fromB64("QVtocmVmXj0iL2ZyYW1ld29yay9yZXNvdXJjZXMvZm9ybXMvYWRzLmFzcHgiXQ==")
        ],
        latvian: [
            fromB64("YVtocmVmPSJodHRwOi8vd3d3LnNhbGlkemluaS5sdi8iXVtzdHlsZT0iZGlzcGxheTogYmxvY2s7IHdpZHRoOiAxMjBweDsgaGVpZ2h0OiA0MHB4OyBvdmVyZmxvdzogaGlkZGVuOyBwb3NpdGlvbjogcmVsYXRpdmU7Il0="),
            fromB64("YVtocmVmPSJodHRwOi8vd3d3LnNhbGlkemluaS5sdi8iXVtzdHlsZT0iZGlzcGxheTogYmxvY2s7IHdpZHRoOiA4OHB4OyBoZWlnaHQ6IDMxcHg7IG92ZXJmbG93OiBoaWRkZW47IHBvc2l0aW9uOiByZWxhdGl2ZTsiXQ==")
        ],
        listKr: [
            fromB64("YVtocmVmKj0iLy9hZC5wbGFuYnBsdXMuY28ua3IvIl0="),
            fromB64("I2xpdmVyZUFkV3JhcHBlcg=="),
            fromB64("YVtocmVmKj0iLy9hZHYuaW1hZHJlcC5jby5rci8iXQ=="),
            fromB64("aW5zLmZhc3R2aWV3LWFk"),
            ".revenue_unit_item.dable"
        ],
        listeAr: [
            fromB64("LmdlbWluaUxCMUFk"),
            ".right-and-left-sponsers",
            fromB64("YVtocmVmKj0iLmFmbGFtLmluZm8iXQ=="),
            fromB64("YVtocmVmKj0iYm9vcmFxLm9yZyJd"),
            fromB64("YVtocmVmKj0iZHViaXp6bGUuY29tL2FyLz91dG1fc291cmNlPSJd")
        ],
        listeFr: [
            fromB64("YVtocmVmXj0iaHR0cDovL3Byb21vLnZhZG9yLmNvbS8iXQ=="),
            fromB64("I2FkY29udGFpbmVyX3JlY2hlcmNoZQ=="),
            fromB64("YVtocmVmKj0id2Vib3JhbWEuZnIvZmNnaS1iaW4vIl0="),
            ".site-pub-interstitiel",
            'div[id^="crt-"][data-criteo-id]'
        ],
        officialPolish: [
            "#ceneo-placeholder-ceneo-12",
            fromB64("W2hyZWZePSJodHRwczovL2FmZi5zZW5kaHViLnBsLyJd"),
            fromB64("YVtocmVmXj0iaHR0cDovL2Fkdm1hbmFnZXIudGVjaGZ1bi5wbC9yZWRpcmVjdC8iXQ=="),
            fromB64("YVtocmVmXj0iaHR0cDovL3d3dy50cml6ZXIucGwvP3V0bV9zb3VyY2UiXQ=="),
            fromB64("ZGl2I3NrYXBpZWNfYWQ=")
        ],
        ro: [
            fromB64("YVtocmVmXj0iLy9hZmZ0cmsuYWx0ZXgucm8vQ291bnRlci9DbGljayJd"),
            fromB64("YVtocmVmXj0iaHR0cHM6Ly9ibGFja2ZyaWRheXNhbGVzLnJvL3Ryay9zaG9wLyJd"),
            fromB64("YVtocmVmXj0iaHR0cHM6Ly9ldmVudC4ycGVyZm9ybWFudC5jb20vZXZlbnRzL2NsaWNrIl0="),
            fromB64("YVtocmVmXj0iaHR0cHM6Ly9sLnByb2ZpdHNoYXJlLnJvLyJd"),
            'a[href^="/url/"]'
        ],
        ruAd: [
            fromB64("YVtocmVmKj0iLy9mZWJyYXJlLnJ1LyJd"),
            fromB64("YVtocmVmKj0iLy91dGltZy5ydS8iXQ=="),
            fromB64("YVtocmVmKj0iOi8vY2hpa2lkaWtpLnJ1Il0="),
            "#pgeldiz",
            ".yandex-rtb-block"
        ],
        thaiAds: [
            "a[href*=macau-uta-popup]",
            fromB64("I2Fkcy1nb29nbGUtbWlkZGxlX3JlY3RhbmdsZS1ncm91cA=="),
            fromB64("LmFkczMwMHM="),
            ".bumq",
            ".img-kosana"
        ],
        webAnnoyancesUltralist: [
            "#mod-social-share-2",
            "#social-tools",
            fromB64("LmN0cGwtZnVsbGJhbm5lcg=="),
            ".zergnet-recommend",
            ".yt.btn-link.btn-md.btn"
        ]
    };
}
/**
 * The order of the returned array means nothing (it's always sorted alphabetically).
 *
 * Notice that the source is slightly unstable.
 * Safari provides a 2-taps way to disable all content blockers on a page temporarily.
 * Also content blockers can be disabled permanently for a domain, but it requires 4 taps.
 * So empty array shouldn't be treated as "no blockers", it should be treated as "no signal".
 * If you are a website owner, don't make your visitors want to disable content blockers.
 */ function $6c22f100bb55ca27$var$getDomBlockers(_a) {
    var _b = _a === void 0 ? {} : _a, debug = _b.debug;
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, void 0, void 0, function() {
        var filters, filterNames, allSelectors, blockedSelectors, activeBlockers;
        var _c;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_d) {
            switch(_d.label){
                case 0:
                    if (!$6c22f100bb55ca27$var$isApplicable()) return [
                        2 /*return*/ ,
                        undefined
                    ];
                    filters = $6c22f100bb55ca27$var$getFilters();
                    filterNames = Object.keys(filters);
                    allSelectors = (_c = []).concat.apply(_c, filterNames.map(function(filterName) {
                        return filters[filterName];
                    }));
                    return [
                        4 /*yield*/ ,
                        $6c22f100bb55ca27$var$getBlockedSelectors(allSelectors)
                    ];
                case 1:
                    blockedSelectors = _d.sent();
                    if (debug) $6c22f100bb55ca27$var$printDebug(filters, blockedSelectors);
                    activeBlockers = filterNames.filter(function(filterName) {
                        var selectors = filters[filterName];
                        var blockedCount = $6c22f100bb55ca27$var$countTruthy(selectors.map(function(selector) {
                            return blockedSelectors[selector];
                        }));
                        return blockedCount > selectors.length * 0.6;
                    });
                    activeBlockers.sort();
                    return [
                        2 /*return*/ ,
                        activeBlockers
                    ];
            }
        });
    });
}
function $6c22f100bb55ca27$var$isApplicable() {
    // Safari (desktop and mobile) and all Android browsers keep content blockers in both regular and private mode
    return $6c22f100bb55ca27$export$78551043582a6a98() || $6c22f100bb55ca27$export$a11b0059900ceec8();
}
function $6c22f100bb55ca27$var$getBlockedSelectors(selectors) {
    var _a;
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, void 0, void 0, function() {
        var d, root, elements, blockedSelectors, i, element, holder, i;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_b) {
            switch(_b.label){
                case 0:
                    d = document;
                    root = d.createElement("div");
                    elements = new Array(selectors.length);
                    blockedSelectors = {} // Set() isn't used just in case somebody need older browser support
                    ;
                    $6c22f100bb55ca27$var$forceShow(root);
                    // First create all elements that can be blocked. If the DOM steps below are done in a single cycle,
                    // browser will alternate tree modification and layout reading, that is very slow.
                    for(i = 0; i < selectors.length; ++i){
                        element = $6c22f100bb55ca27$var$selectorToElement(selectors[i]);
                        if (element.tagName === "DIALOG") element.show();
                        holder = d.createElement("div") // Protects from unwanted effects of `+` and `~` selectors of filters
                        ;
                        $6c22f100bb55ca27$var$forceShow(holder);
                        holder.appendChild(element);
                        root.appendChild(holder);
                        elements[i] = element;
                    }
                    _b.label = 1;
                case 1:
                    if (!!d.body) return [
                        3 /*break*/ ,
                        3
                    ];
                    return [
                        4 /*yield*/ ,
                        $6c22f100bb55ca27$var$wait(50)
                    ];
                case 2:
                    _b.sent();
                    return [
                        3 /*break*/ ,
                        1
                    ];
                case 3:
                    d.body.appendChild(root);
                    return [
                        4 /*yield*/ ,
                        $6c22f100bb55ca27$var$releaseEventLoop()
                    ];
                case 4:
                    _b.sent();
                    try {
                        // Then check which of the elements are blocked
                        for(i = 0; i < selectors.length; ++i)if (!elements[i].offsetParent) blockedSelectors[selectors[i]] = true;
                    } finally{
                        // Then remove the elements
                        (_a = root.parentNode) === null || _a === void 0 || _a.removeChild(root);
                    }
                    return [
                        2 /*return*/ ,
                        blockedSelectors
                    ];
            }
        });
    });
}
function $6c22f100bb55ca27$var$forceShow(element) {
    element.style.setProperty("visibility", "hidden", "important");
    element.style.setProperty("display", "block", "important");
}
function $6c22f100bb55ca27$var$printDebug(filters, blockedSelectors) {
    var message = "DOM blockers debug:\n```";
    for(var _i = 0, _a = Object.keys(filters); _i < _a.length; _i++){
        var filterName = _a[_i];
        message += "\n".concat(filterName, ":");
        for(var _b = 0, _c = filters[filterName]; _b < _c.length; _b++){
            var selector = _c[_b];
            message += "\n  ".concat(blockedSelectors[selector] ? "\uD83D\uDEAB" : "\u27A1\uFE0F", " ").concat(selector);
        }
    }
    // console.log is ok here because it's under a debug clause
    // eslint-disable-next-line no-console
    console.log("".concat(message, "\n```"));
}
/**
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/@media/color-gamut
 */ function $6c22f100bb55ca27$var$getColorGamut() {
    // rec2020 includes p3 and p3 includes srgb
    for(var _i = 0, _a = [
        "rec2020",
        "p3",
        "srgb"
    ]; _i < _a.length; _i++){
        var gamut = _a[_i];
        if (matchMedia("(color-gamut: ".concat(gamut, ")")).matches) return gamut;
    }
    return undefined;
}
/**
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/@media/inverted-colors
 */ function $6c22f100bb55ca27$var$areColorsInverted() {
    if ($6c22f100bb55ca27$var$doesMatch$5("inverted")) return true;
    if ($6c22f100bb55ca27$var$doesMatch$5("none")) return false;
    return undefined;
}
function $6c22f100bb55ca27$var$doesMatch$5(value) {
    return matchMedia("(inverted-colors: ".concat(value, ")")).matches;
}
/**
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/@media/forced-colors
 */ function $6c22f100bb55ca27$var$areColorsForced() {
    if ($6c22f100bb55ca27$var$doesMatch$4("active")) return true;
    if ($6c22f100bb55ca27$var$doesMatch$4("none")) return false;
    return undefined;
}
function $6c22f100bb55ca27$var$doesMatch$4(value) {
    return matchMedia("(forced-colors: ".concat(value, ")")).matches;
}
var $6c22f100bb55ca27$var$maxValueToCheck = 100;
/**
 * If the display is monochrome (e.g. black&white), the value will be ≥0 and will mean the number of bits per pixel.
 * If the display is not monochrome, the returned value will be 0.
 * If the browser doesn't support this feature, the returned value will be undefined.
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/@media/monochrome
 */ function $6c22f100bb55ca27$var$getMonochromeDepth() {
    if (!matchMedia("(min-monochrome: 0)").matches) // The media feature isn't supported by the browser
    return undefined;
    // A variation of binary search algorithm can be used here.
    // But since expected values are very small (≤10), there is no sense in adding the complexity.
    for(var i = 0; i <= $6c22f100bb55ca27$var$maxValueToCheck; ++i){
        if (matchMedia("(max-monochrome: ".concat(i, ")")).matches) return i;
    }
    throw new Error("Too high value");
}
/**
 * @see https://www.w3.org/TR/mediaqueries-5/#prefers-contrast
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/@media/prefers-contrast
 */ function $6c22f100bb55ca27$var$getContrastPreference() {
    if ($6c22f100bb55ca27$var$doesMatch$3("no-preference")) return 0 /* ContrastPreference.None */ ;
    // The sources contradict on the keywords. Probably 'high' and 'low' will never be implemented.
    // Need to check it when all browsers implement the feature.
    if ($6c22f100bb55ca27$var$doesMatch$3("high") || $6c22f100bb55ca27$var$doesMatch$3("more")) return 1 /* ContrastPreference.More */ ;
    if ($6c22f100bb55ca27$var$doesMatch$3("low") || $6c22f100bb55ca27$var$doesMatch$3("less")) return -1 /* ContrastPreference.Less */ ;
    if ($6c22f100bb55ca27$var$doesMatch$3("forced")) return 10 /* ContrastPreference.ForcedColors */ ;
    return undefined;
}
function $6c22f100bb55ca27$var$doesMatch$3(value) {
    return matchMedia("(prefers-contrast: ".concat(value, ")")).matches;
}
/**
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/@media/prefers-reduced-motion
 */ function $6c22f100bb55ca27$var$isMotionReduced() {
    if ($6c22f100bb55ca27$var$doesMatch$2("reduce")) return true;
    if ($6c22f100bb55ca27$var$doesMatch$2("no-preference")) return false;
    return undefined;
}
function $6c22f100bb55ca27$var$doesMatch$2(value) {
    return matchMedia("(prefers-reduced-motion: ".concat(value, ")")).matches;
}
/**
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/@media/prefers-reduced-transparency
 */ function $6c22f100bb55ca27$var$isTransparencyReduced() {
    if ($6c22f100bb55ca27$var$doesMatch$1("reduce")) return true;
    if ($6c22f100bb55ca27$var$doesMatch$1("no-preference")) return false;
    return undefined;
}
function $6c22f100bb55ca27$var$doesMatch$1(value) {
    return matchMedia("(prefers-reduced-transparency: ".concat(value, ")")).matches;
}
/**
 * @see https://www.w3.org/TR/mediaqueries-5/#dynamic-range
 */ function $6c22f100bb55ca27$var$isHDR() {
    if ($6c22f100bb55ca27$var$doesMatch("high")) return true;
    if ($6c22f100bb55ca27$var$doesMatch("standard")) return false;
    return undefined;
}
function $6c22f100bb55ca27$var$doesMatch(value) {
    return matchMedia("(dynamic-range: ".concat(value, ")")).matches;
}
var $6c22f100bb55ca27$var$M = Math; // To reduce the minified code size
var $6c22f100bb55ca27$var$fallbackFn = function() {
    return 0;
};
/**
 * @see https://gitlab.torproject.org/legacy/trac/-/issues/13018
 * @see https://bugzilla.mozilla.org/show_bug.cgi?id=531915
 */ function $6c22f100bb55ca27$var$getMathFingerprint() {
    // Native operations
    var acos = $6c22f100bb55ca27$var$M.acos || $6c22f100bb55ca27$var$fallbackFn;
    var acosh = $6c22f100bb55ca27$var$M.acosh || $6c22f100bb55ca27$var$fallbackFn;
    var asin = $6c22f100bb55ca27$var$M.asin || $6c22f100bb55ca27$var$fallbackFn;
    var asinh = $6c22f100bb55ca27$var$M.asinh || $6c22f100bb55ca27$var$fallbackFn;
    var atanh = $6c22f100bb55ca27$var$M.atanh || $6c22f100bb55ca27$var$fallbackFn;
    var atan = $6c22f100bb55ca27$var$M.atan || $6c22f100bb55ca27$var$fallbackFn;
    var sin = $6c22f100bb55ca27$var$M.sin || $6c22f100bb55ca27$var$fallbackFn;
    var sinh = $6c22f100bb55ca27$var$M.sinh || $6c22f100bb55ca27$var$fallbackFn;
    var cos = $6c22f100bb55ca27$var$M.cos || $6c22f100bb55ca27$var$fallbackFn;
    var cosh = $6c22f100bb55ca27$var$M.cosh || $6c22f100bb55ca27$var$fallbackFn;
    var tan = $6c22f100bb55ca27$var$M.tan || $6c22f100bb55ca27$var$fallbackFn;
    var tanh = $6c22f100bb55ca27$var$M.tanh || $6c22f100bb55ca27$var$fallbackFn;
    var exp = $6c22f100bb55ca27$var$M.exp || $6c22f100bb55ca27$var$fallbackFn;
    var expm1 = $6c22f100bb55ca27$var$M.expm1 || $6c22f100bb55ca27$var$fallbackFn;
    var log1p = $6c22f100bb55ca27$var$M.log1p || $6c22f100bb55ca27$var$fallbackFn;
    // Operation polyfills
    var powPI = function(value) {
        return $6c22f100bb55ca27$var$M.pow($6c22f100bb55ca27$var$M.PI, value);
    };
    var acoshPf = function(value) {
        return $6c22f100bb55ca27$var$M.log(value + $6c22f100bb55ca27$var$M.sqrt(value * value - 1));
    };
    var asinhPf = function(value) {
        return $6c22f100bb55ca27$var$M.log(value + $6c22f100bb55ca27$var$M.sqrt(value * value + 1));
    };
    var atanhPf = function(value) {
        return $6c22f100bb55ca27$var$M.log((1 + value) / (1 - value)) / 2;
    };
    var sinhPf = function(value) {
        return $6c22f100bb55ca27$var$M.exp(value) - 1 / $6c22f100bb55ca27$var$M.exp(value) / 2;
    };
    var coshPf = function(value) {
        return ($6c22f100bb55ca27$var$M.exp(value) + 1 / $6c22f100bb55ca27$var$M.exp(value)) / 2;
    };
    var expm1Pf = function(value) {
        return $6c22f100bb55ca27$var$M.exp(value) - 1;
    };
    var tanhPf = function(value) {
        return ($6c22f100bb55ca27$var$M.exp(2 * value) - 1) / ($6c22f100bb55ca27$var$M.exp(2 * value) + 1);
    };
    var log1pPf = function(value) {
        return $6c22f100bb55ca27$var$M.log(1 + value);
    };
    // Note: constant values are empirical
    return {
        acos: acos(0.123124234234234242),
        acosh: acosh(1e308),
        acoshPf: acoshPf(1e154),
        asin: asin(0.123124234234234242),
        asinh: asinh(1),
        asinhPf: asinhPf(1),
        atanh: atanh(0.5),
        atanhPf: atanhPf(0.5),
        atan: atan(0.5),
        sin: sin(-1000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000),
        sinh: sinh(1),
        sinhPf: sinhPf(1),
        cos: cos(10.000000000123),
        cosh: cosh(1),
        coshPf: coshPf(1),
        tan: tan(-1000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000),
        tanh: tanh(1),
        tanhPf: tanhPf(1),
        exp: exp(1),
        expm1: expm1(1),
        expm1Pf: expm1Pf(1),
        log1p: log1p(10),
        log1pPf: log1pPf(10),
        powPI: powPI(-100)
    };
}
/**
 * We use m or w because these two characters take up the maximum width.
 * Also there are a couple of ligatures.
 */ var $6c22f100bb55ca27$var$defaultText = "mmMwWLliI0fiflO&1";
/**
 * Settings of text blocks to measure. The keys are random but persistent words.
 */ var $6c22f100bb55ca27$var$presets = {
    /**
     * The default font. User can change it in desktop Chrome, desktop Firefox, IE 11,
     * Android Chrome (but only when the size is ≥ than the default) and Android Firefox.
     */ default: [],
    /** OS font on macOS. User can change its size and weight. Applies after Safari restart. */ apple: [
        {
            font: "-apple-system-body"
        }
    ],
    /** User can change it in desktop Chrome and desktop Firefox. */ serif: [
        {
            fontFamily: "serif"
        }
    ],
    /** User can change it in desktop Chrome and desktop Firefox. */ sans: [
        {
            fontFamily: "sans-serif"
        }
    ],
    /** User can change it in desktop Chrome and desktop Firefox. */ mono: [
        {
            fontFamily: "monospace"
        }
    ],
    /**
     * Check the smallest allowed font size. User can change it in desktop Chrome, desktop Firefox and desktop Safari.
     * The height can be 0 in Chrome on a retina display.
     */ min: [
        {
            fontSize: "1px"
        }
    ],
    /** Tells one OS from another in desktop Chrome. */ system: [
        {
            fontFamily: "system-ui"
        }
    ]
};
/**
 * The result is a dictionary of the width of the text samples.
 * Heights aren't included because they give no extra entropy and are unstable.
 *
 * The result is very stable in IE 11, Edge 18 and Safari 14.
 * The result changes when the OS pixel density changes in Chromium 87. The real pixel density is required to solve,
 * but seems like it's impossible: https://stackoverflow.com/q/1713771/1118709.
 * The "min" and the "mono" (only on Windows) value may change when the page is zoomed in Firefox 87.
 */ function $6c22f100bb55ca27$var$getFontPreferences() {
    return $6c22f100bb55ca27$var$withNaturalFonts(function(document1, container) {
        var elements = {};
        var sizes = {};
        // First create all elements to measure. If the DOM steps below are done in a single cycle,
        // browser will alternate tree modification and layout reading, that is very slow.
        for(var _i = 0, _a = Object.keys($6c22f100bb55ca27$var$presets); _i < _a.length; _i++){
            var key = _a[_i];
            var _b = $6c22f100bb55ca27$var$presets[key], _c = _b[0], style = _c === void 0 ? {} : _c, _d = _b[1], text = _d === void 0 ? $6c22f100bb55ca27$var$defaultText : _d;
            var element = document1.createElement("span");
            element.textContent = text;
            element.style.whiteSpace = "nowrap";
            for(var _e = 0, _f = Object.keys(style); _e < _f.length; _e++){
                var name_1 = _f[_e];
                var value = style[name_1];
                if (value !== undefined) element.style[name_1] = value;
            }
            elements[key] = element;
            container.append(document1.createElement("br"), element);
        }
        // Then measure the created elements
        for(var _g = 0, _h = Object.keys($6c22f100bb55ca27$var$presets); _g < _h.length; _g++){
            var key = _h[_g];
            sizes[key] = elements[key].getBoundingClientRect().width;
        }
        return sizes;
    });
}
/**
 * Creates a DOM environment that provides the most natural font available, including Android OS font.
 * Measurements of the elements are zoom-independent.
 * Don't put a content to measure inside an absolutely positioned element.
 */ function $6c22f100bb55ca27$var$withNaturalFonts(action, containerWidthPx) {
    if (containerWidthPx === void 0) containerWidthPx = 4000;
    /*
     * Requirements for Android Chrome to apply the system font size to a text inside an iframe:
     * - The iframe mustn't have a `display: none;` style;
     * - The text mustn't be positioned absolutely;
     * - The text block must be wide enough.
     *   2560px on some devices in portrait orientation for the biggest font size option (32px);
     * - There must be much enough text to form a few lines (I don't know the exact numbers);
     * - The text must have the `text-size-adjust: none` style. Otherwise the text will scale in "Desktop site" mode;
     *
     * Requirements for Android Firefox to apply the system font size to a text inside an iframe:
     * - The iframe document must have a header: `<meta name="viewport" content="width=device-width, initial-scale=1" />`.
     *   The only way to set it is to use the `srcdoc` attribute of the iframe;
     * - The iframe content must get loaded before adding extra content with JavaScript;
     *
     * https://example.com as the iframe target always inherits Android font settings so it can be used as a reference.
     *
     * Observations on how page zoom affects the measurements:
     * - macOS Safari 11.1, 12.1, 13.1, 14.0: zoom reset + offsetWidth = 100% reliable;
     * - macOS Safari 11.1, 12.1, 13.1, 14.0: zoom reset + getBoundingClientRect = 100% reliable;
     * - macOS Safari 14.0: offsetWidth = 5% fluctuation;
     * - macOS Safari 14.0: getBoundingClientRect = 5% fluctuation;
     * - iOS Safari 9, 10, 11.0, 12.0: haven't found a way to zoom a page (pinch doesn't change layout);
     * - iOS Safari 13.1, 14.0: zoom reset + offsetWidth = 100% reliable;
     * - iOS Safari 13.1, 14.0: zoom reset + getBoundingClientRect = 100% reliable;
     * - iOS Safari 14.0: offsetWidth = 100% reliable;
     * - iOS Safari 14.0: getBoundingClientRect = 100% reliable;
     * - Chrome 42, 65, 80, 87: zoom 1/devicePixelRatio + offsetWidth = 1px fluctuation;
     * - Chrome 42, 65, 80, 87: zoom 1/devicePixelRatio + getBoundingClientRect = 100% reliable;
     * - Chrome 87: offsetWidth = 1px fluctuation;
     * - Chrome 87: getBoundingClientRect = 0.7px fluctuation;
     * - Firefox 48, 51: offsetWidth = 10% fluctuation;
     * - Firefox 48, 51: getBoundingClientRect = 10% fluctuation;
     * - Firefox 52, 53, 57, 62, 66, 67, 68, 71, 75, 80, 84: offsetWidth = width 100% reliable, height 10% fluctuation;
     * - Firefox 52, 53, 57, 62, 66, 67, 68, 71, 75, 80, 84: getBoundingClientRect = width 100% reliable, height 10%
     *   fluctuation;
     * - Android Chrome 86: haven't found a way to zoom a page (pinch doesn't change layout);
     * - Android Firefox 84: font size in accessibility settings changes all the CSS sizes, but offsetWidth and
     *   getBoundingClientRect keep measuring with regular units, so the size reflects the font size setting and doesn't
     *   fluctuate;
     * - IE 11, Edge 18: zoom 1/devicePixelRatio + offsetWidth = 100% reliable;
     * - IE 11, Edge 18: zoom 1/devicePixelRatio + getBoundingClientRect = reflects the zoom level;
     * - IE 11, Edge 18: offsetWidth = 100% reliable;
     * - IE 11, Edge 18: getBoundingClientRect = 100% reliable;
     */ return $6c22f100bb55ca27$export$8b65e2577b8ab46d(function(_, iframeWindow) {
        var iframeDocument = iframeWindow.document;
        var iframeBody = iframeDocument.body;
        var bodyStyle = iframeBody.style;
        bodyStyle.width = "".concat(containerWidthPx, "px");
        bodyStyle.webkitTextSizeAdjust = bodyStyle.textSizeAdjust = "none";
        // See the big comment above
        if ($6c22f100bb55ca27$export$dd401a4677e99039()) iframeBody.style.zoom = "".concat(1 / iframeWindow.devicePixelRatio);
        else if ($6c22f100bb55ca27$export$78551043582a6a98()) iframeBody.style.zoom = "reset";
        // See the big comment above
        var linesOfText = iframeDocument.createElement("div");
        linesOfText.textContent = (0, $5c96a02c592fcff1$export$1216008129fb82ed)([], Array(containerWidthPx / 20 << 0), true).map(function() {
            return "word";
        }).join(" ");
        iframeBody.appendChild(linesOfText);
        return action(iframeDocument, iframeBody);
    }, '<!doctype html><html><head><meta name="viewport" content="width=device-width, initial-scale=1">');
}
function $6c22f100bb55ca27$var$isPdfViewerEnabled() {
    return navigator.pdfViewerEnabled;
}
/**
 * Unlike most other architectures, on x86/x86-64 when floating-point instructions
 * have no NaN arguments, but produce NaN output, the output NaN has sign bit set.
 * We use it to distinguish x86/x86-64 from other architectures, by doing subtraction
 * of two infinities (must produce NaN per IEEE 754 standard).
 *
 * See https://codebrowser.bddppq.com/pytorch/pytorch/third_party/XNNPACK/src/init.c.html#79
 */ function $6c22f100bb55ca27$var$getArchitecture() {
    var f = new Float32Array(1);
    var u8 = new Uint8Array(f.buffer);
    f[0] = Infinity;
    f[0] = f[0] - f[0];
    return u8[3];
}
function $6c22f100bb55ca27$var$getApplePayState() {
    var ApplePaySession = window.ApplePaySession;
    if (typeof (ApplePaySession === null || ApplePaySession === void 0 ? void 0 : ApplePaySession.canMakePayments) !== "function") return -1 /* ApplePayState.NoAPI */ ;
    try {
        return ApplePaySession.canMakePayments() ? 1 /* ApplePayState.Enabled */  : 0 /* ApplePayState.Disabled */ ;
    } catch (error) {
        return $6c22f100bb55ca27$export$d78653bd95c07cf(error);
    }
}
/**
 * The return type is a union instead of the enum, because it's too challenging to embed the const enum into another
 * project. Turning it into a union is a simple and an elegant solution.
 *
 * Warning for package users:
 * This function is out of Semantic Versioning, i.e. can change unexpectedly. Usage is at your own risk.
 */ function $6c22f100bb55ca27$export$d78653bd95c07cf(error) {
    if (error instanceof Error) {
        // See full expected error messages in the test
        if (error.name === "InvalidAccessError") {
            if (/\bfrom\b.*\binsecure\b/i.test(error.message)) return -2 /* ApplePayState.NotAvailableInInsecureContext */ ;
            if (/\bdifferent\b.*\borigin\b.*top.level\b.*\bframe\b/i.test(error.message)) return -3 /* ApplePayState.NotAvailableInFrame */ ;
        }
        if (error.name === "SecurityError") {
            if (/\bthird.party iframes?.*\bnot.allowed\b/i.test(error.message)) return -3 /* ApplePayState.NotAvailableInFrame */ ;
        }
    }
    throw error;
}
/**
 * Checks whether the Safari's Privacy Preserving Ad Measurement setting is on.
 * The setting is on when the value is not undefined.
 * A.k.a. private click measurement, privacy-preserving ad attribution.
 *
 * Unfortunately, it doesn't work in mobile Safari.
 * Probably, it will start working in mobile Safari or stop working in desktop Safari later.
 * We've found no way to detect the setting state in mobile Safari. Help wanted.
 *
 * @see https://webkit.org/blog/11529/introducing-private-click-measurement-pcm/
 * @see https://developer.apple.com/videos/play/wwdc2021/10033
 */ function $6c22f100bb55ca27$var$getPrivateClickMeasurement() {
    var _a;
    var link = document.createElement("a");
    var sourceId = (_a = link.attributionSourceId) !== null && _a !== void 0 ? _a : link.attributionsourceid;
    return sourceId === undefined ? undefined : String(sourceId);
}
/** WebGl context is not available */ var $6c22f100bb55ca27$var$STATUS_NO_GL_CONTEXT = -1;
/** WebGL context `getParameter` method is not a function */ var $6c22f100bb55ca27$var$STATUS_GET_PARAMETER_NOT_A_FUNCTION = -2;
var $6c22f100bb55ca27$var$validContextParameters = new Set([
    10752,
    2849,
    2884,
    2885,
    2886,
    2928,
    2929,
    2930,
    2931,
    2932,
    2960,
    2961,
    2962,
    2963,
    2964,
    2965,
    2966,
    2967,
    2968,
    2978,
    3024,
    3042,
    3088,
    3089,
    3106,
    3107,
    32773,
    32777,
    32777,
    32823,
    32824,
    32936,
    32937,
    32938,
    32939,
    32968,
    32969,
    32970,
    32971,
    3317,
    33170,
    3333,
    3379,
    3386,
    33901,
    33902,
    34016,
    34024,
    34076,
    3408,
    3410,
    3411,
    3412,
    3413,
    3414,
    3415,
    34467,
    34816,
    34817,
    34818,
    34819,
    34877,
    34921,
    34930,
    35660,
    35661,
    35724,
    35738,
    35739,
    36003,
    36004,
    36005,
    36347,
    36348,
    36349,
    37440,
    37441,
    37443,
    7936,
    7937,
    7938
]);
var $6c22f100bb55ca27$var$validExtensionParams = new Set([
    34047,
    35723,
    36063,
    34852,
    34853,
    34854,
    34229,
    36392,
    36795,
    38449
]);
var $6c22f100bb55ca27$var$shaderTypes = [
    "FRAGMENT_SHADER",
    "VERTEX_SHADER"
];
var $6c22f100bb55ca27$var$precisionTypes = [
    "LOW_FLOAT",
    "MEDIUM_FLOAT",
    "HIGH_FLOAT",
    "LOW_INT",
    "MEDIUM_INT",
    "HIGH_INT"
];
var $6c22f100bb55ca27$var$rendererInfoExtensionName = "WEBGL_debug_renderer_info";
/**
 * Gets the basic and simple WebGL parameters
 */ function $6c22f100bb55ca27$var$getWebGlBasics(_a) {
    var _b, _c, _d, _e, _f, _g;
    var cache = _a.cache;
    var gl = $6c22f100bb55ca27$export$c7a808a518b9a146(cache);
    if (!gl) return $6c22f100bb55ca27$var$STATUS_NO_GL_CONTEXT;
    if (!$6c22f100bb55ca27$var$isValidParameterGetter(gl)) return $6c22f100bb55ca27$var$STATUS_GET_PARAMETER_NOT_A_FUNCTION;
    var debugExtension = $6c22f100bb55ca27$var$shouldAvoidDebugRendererInfo() ? null : gl.getExtension($6c22f100bb55ca27$var$rendererInfoExtensionName);
    return {
        version: ((_b = gl.getParameter(gl.VERSION)) === null || _b === void 0 ? void 0 : _b.toString()) || "",
        vendor: ((_c = gl.getParameter(gl.VENDOR)) === null || _c === void 0 ? void 0 : _c.toString()) || "",
        vendorUnmasked: debugExtension ? (_d = gl.getParameter(debugExtension.UNMASKED_VENDOR_WEBGL)) === null || _d === void 0 ? void 0 : _d.toString() : "",
        renderer: ((_e = gl.getParameter(gl.RENDERER)) === null || _e === void 0 ? void 0 : _e.toString()) || "",
        rendererUnmasked: debugExtension ? (_f = gl.getParameter(debugExtension.UNMASKED_RENDERER_WEBGL)) === null || _f === void 0 ? void 0 : _f.toString() : "",
        shadingLanguageVersion: ((_g = gl.getParameter(gl.SHADING_LANGUAGE_VERSION)) === null || _g === void 0 ? void 0 : _g.toString()) || ""
    };
}
/**
 * Gets the advanced and massive WebGL parameters and extensions
 */ function $6c22f100bb55ca27$var$getWebGlExtensions(_a) {
    var cache = _a.cache;
    var gl = $6c22f100bb55ca27$export$c7a808a518b9a146(cache);
    if (!gl) return $6c22f100bb55ca27$var$STATUS_NO_GL_CONTEXT;
    if (!$6c22f100bb55ca27$var$isValidParameterGetter(gl)) return $6c22f100bb55ca27$var$STATUS_GET_PARAMETER_NOT_A_FUNCTION;
    var extensions = gl.getSupportedExtensions();
    var contextAttributes = gl.getContextAttributes();
    // Features
    var attributes = [];
    var parameters = [];
    var extensionParameters = [];
    var shaderPrecisions = [];
    // Context attributes
    if (contextAttributes) for(var _i = 0, _b = Object.keys(contextAttributes); _i < _b.length; _i++){
        var attributeName = _b[_i];
        attributes.push("".concat(attributeName, "=").concat(contextAttributes[attributeName]));
    }
    // Context parameters
    var constants = $6c22f100bb55ca27$var$getConstantsFromPrototype(gl);
    for(var _c = 0, constants_1 = constants; _c < constants_1.length; _c++){
        var constant = constants_1[_c];
        var code = gl[constant];
        parameters.push("".concat(constant, "=").concat(code).concat($6c22f100bb55ca27$var$validContextParameters.has(code) ? "=".concat(gl.getParameter(code)) : ""));
    }
    // Extension parameters
    if (extensions) for(var _d = 0, extensions_1 = extensions; _d < extensions_1.length; _d++){
        var name_1 = extensions_1[_d];
        if (name_1 === $6c22f100bb55ca27$var$rendererInfoExtensionName && $6c22f100bb55ca27$var$shouldAvoidDebugRendererInfo()) continue;
        var extension = gl.getExtension(name_1);
        if (!extension) continue;
        for(var _e = 0, _f = $6c22f100bb55ca27$var$getConstantsFromPrototype(extension); _e < _f.length; _e++){
            var constant = _f[_e];
            var code = extension[constant];
            extensionParameters.push("".concat(constant, "=").concat(code).concat($6c22f100bb55ca27$var$validExtensionParams.has(code) ? "=".concat(gl.getParameter(code)) : ""));
        }
    }
    // Shader precision
    for(var _g = 0, shaderTypes_1 = $6c22f100bb55ca27$var$shaderTypes; _g < shaderTypes_1.length; _g++){
        var shaderType = shaderTypes_1[_g];
        for(var _h = 0, precisionTypes_1 = $6c22f100bb55ca27$var$precisionTypes; _h < precisionTypes_1.length; _h++){
            var precisionType = precisionTypes_1[_h];
            var shaderPrecision = $6c22f100bb55ca27$var$getShaderPrecision(gl, shaderType, precisionType);
            shaderPrecisions.push("".concat(shaderType, ".").concat(precisionType, "=").concat(shaderPrecision.join(",")));
        }
    }
    // Postprocess
    extensionParameters.sort();
    parameters.sort();
    return {
        contextAttributes: attributes,
        parameters: parameters,
        shaderPrecisions: shaderPrecisions,
        extensions: extensions,
        extensionParameters: extensionParameters
    };
}
/**
 * This function usually takes the most time to execute in all the sources, therefore we cache its result.
 *
 * Warning for package users:
 * This function is out of Semantic Versioning, i.e. can change unexpectedly. Usage is at your own risk.
 */ function $6c22f100bb55ca27$export$c7a808a518b9a146(cache) {
    if (cache.webgl) return cache.webgl.context;
    var canvas = document.createElement("canvas");
    var context;
    canvas.addEventListener("webglCreateContextError", function() {
        return context = undefined;
    });
    for(var _i = 0, _a = [
        "webgl",
        "experimental-webgl"
    ]; _i < _a.length; _i++){
        var type = _a[_i];
        try {
            context = canvas.getContext(type);
        } catch (_b) {
        // Ok, continue
        }
        if (context) break;
    }
    cache.webgl = {
        context: context
    };
    return context;
}
/**
 * https://developer.mozilla.org/en-US/docs/Web/API/WebGLShaderPrecisionFormat
 * https://developer.mozilla.org/en-US/docs/Web/API/WebGLRenderingContext/getShaderPrecisionFormat
 * https://www.khronos.org/registry/webgl/specs/latest/1.0/#5.12
 */ function $6c22f100bb55ca27$var$getShaderPrecision(gl, shaderType, precisionType) {
    var shaderPrecision = gl.getShaderPrecisionFormat(gl[shaderType], gl[precisionType]);
    return shaderPrecision ? [
        shaderPrecision.rangeMin,
        shaderPrecision.rangeMax,
        shaderPrecision.precision
    ] : [];
}
function $6c22f100bb55ca27$var$getConstantsFromPrototype(obj) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var keys = Object.keys(obj.__proto__);
    return keys.filter($6c22f100bb55ca27$var$isConstantLike);
}
function $6c22f100bb55ca27$var$isConstantLike(key) {
    return typeof key === "string" && !key.match(/[^A-Z0-9_x]/);
}
/**
 * Some browsers print a console warning when the WEBGL_debug_renderer_info extension is requested.
 * JS Agent aims to avoid printing messages to console, so we avoid this extension in that browsers.
 */ function $6c22f100bb55ca27$var$shouldAvoidDebugRendererInfo() {
    return $6c22f100bb55ca27$export$1127c7d1b8731973();
}
/**
 * Some unknown browsers have no `getParameter` method
 */ function $6c22f100bb55ca27$var$isValidParameterGetter(gl) {
    return typeof gl.getParameter === "function";
}
/**
 * The list of entropy sources used to make visitor identifiers.
 *
 * This value isn't restricted by Semantic Versioning, i.e. it may be changed without bumping minor or major version of
 * this package.
 *
 * Note: Rollup and Webpack are smart enough to remove unused properties of this object during tree-shaking, so there is
 * no need to export the sources individually.
 */ var $6c22f100bb55ca27$export$d1d41f0cda037248 = {
    // READ FIRST:
    // See https://github.com/fingerprintjs/fingerprintjs/blob/master/contributing.md#how-to-make-an-entropy-source
    // to learn how entropy source works and how to make your own.
    // The sources run in this exact order.
    // The asynchronous sources are at the start to run in parallel with other sources.
    fonts: $6c22f100bb55ca27$var$getFonts,
    domBlockers: $6c22f100bb55ca27$var$getDomBlockers,
    fontPreferences: $6c22f100bb55ca27$var$getFontPreferences,
    audio: $6c22f100bb55ca27$var$getAudioFingerprint,
    screenFrame: $6c22f100bb55ca27$var$getScreenFrame,
    canvas: $6c22f100bb55ca27$var$getCanvasFingerprint,
    osCpu: $6c22f100bb55ca27$var$getOsCpu,
    languages: $6c22f100bb55ca27$var$getLanguages,
    colorDepth: $6c22f100bb55ca27$var$getColorDepth,
    deviceMemory: $6c22f100bb55ca27$var$getDeviceMemory,
    screenResolution: $6c22f100bb55ca27$var$getScreenResolution,
    hardwareConcurrency: $6c22f100bb55ca27$var$getHardwareConcurrency,
    timezone: $6c22f100bb55ca27$var$getTimezone,
    sessionStorage: $6c22f100bb55ca27$var$getSessionStorage,
    localStorage: $6c22f100bb55ca27$var$getLocalStorage,
    indexedDB: $6c22f100bb55ca27$var$getIndexedDB,
    openDatabase: $6c22f100bb55ca27$var$getOpenDatabase,
    cpuClass: $6c22f100bb55ca27$var$getCpuClass,
    platform: $6c22f100bb55ca27$var$getPlatform,
    plugins: $6c22f100bb55ca27$var$getPlugins,
    touchSupport: $6c22f100bb55ca27$var$getTouchSupport,
    vendor: $6c22f100bb55ca27$var$getVendor,
    vendorFlavors: $6c22f100bb55ca27$var$getVendorFlavors,
    cookiesEnabled: $6c22f100bb55ca27$var$areCookiesEnabled,
    colorGamut: $6c22f100bb55ca27$var$getColorGamut,
    invertedColors: $6c22f100bb55ca27$var$areColorsInverted,
    forcedColors: $6c22f100bb55ca27$var$areColorsForced,
    monochrome: $6c22f100bb55ca27$var$getMonochromeDepth,
    contrast: $6c22f100bb55ca27$var$getContrastPreference,
    reducedMotion: $6c22f100bb55ca27$var$isMotionReduced,
    reducedTransparency: $6c22f100bb55ca27$var$isTransparencyReduced,
    hdr: $6c22f100bb55ca27$var$isHDR,
    math: $6c22f100bb55ca27$var$getMathFingerprint,
    pdfViewerEnabled: $6c22f100bb55ca27$var$isPdfViewerEnabled,
    architecture: $6c22f100bb55ca27$var$getArchitecture,
    applePay: $6c22f100bb55ca27$var$getApplePayState,
    privateClickMeasurement: $6c22f100bb55ca27$var$getPrivateClickMeasurement,
    // Some sources can affect other sources (e.g. WebGL can affect canvas), so it's important to run these sources
    // after other sources.
    webGlBasics: $6c22f100bb55ca27$var$getWebGlBasics,
    webGlExtensions: $6c22f100bb55ca27$var$getWebGlExtensions
};
/**
 * Loads the built-in entropy sources.
 * Returns a function that collects the entropy components to make the visitor identifier.
 */ function $6c22f100bb55ca27$var$loadBuiltinSources(options) {
    return $6c22f100bb55ca27$export$3c5f4c9f15eeb5cb($6c22f100bb55ca27$export$d1d41f0cda037248, options, []);
}
var $6c22f100bb55ca27$var$commentTemplate = "$ if upgrade to Pro: https://fpjs.dev/pro";
function $6c22f100bb55ca27$var$getConfidence(components) {
    var openConfidenceScore = $6c22f100bb55ca27$var$getOpenConfidenceScore(components);
    var proConfidenceScore = $6c22f100bb55ca27$var$deriveProConfidenceScore(openConfidenceScore);
    return {
        score: openConfidenceScore,
        comment: $6c22f100bb55ca27$var$commentTemplate.replace(/\$/g, "".concat(proConfidenceScore))
    };
}
function $6c22f100bb55ca27$var$getOpenConfidenceScore(components) {
    // In order to calculate the true probability of the visitor identifier being correct, we need to know the number of
    // website visitors (the higher the number, the less the probability because the fingerprint entropy is limited).
    // JS agent doesn't know the number of visitors, so we can only do an approximate assessment.
    if ($6c22f100bb55ca27$export$a11b0059900ceec8()) return 0.4;
    // Safari (mobile and desktop)
    if ($6c22f100bb55ca27$export$78551043582a6a98()) return $6c22f100bb55ca27$export$4949e6bd5097eae9() && !($6c22f100bb55ca27$var$isWebKit616OrNewer() && $6c22f100bb55ca27$var$isSafariWebKit()) ? 0.5 : 0.3;
    var platform = "value" in components.platform ? components.platform.value : "";
    // Windows
    if (/^Win/.test(platform)) // The score is greater than on macOS because of the higher variety of devices running Windows.
    // Chrome provides more entropy than Firefox according too
    // https://netmarketshare.com/browser-market-share.aspx?options=%7B%22filter%22%3A%7B%22%24and%22%3A%5B%7B%22platform%22%3A%7B%22%24in%22%3A%5B%22Windows%22%5D%7D%7D%5D%7D%2C%22dateLabel%22%3A%22Trend%22%2C%22attributes%22%3A%22share%22%2C%22group%22%3A%22browser%22%2C%22sort%22%3A%7B%22share%22%3A-1%7D%2C%22id%22%3A%22browsersDesktop%22%2C%22dateInterval%22%3A%22Monthly%22%2C%22dateStart%22%3A%222019-11%22%2C%22dateEnd%22%3A%222020-10%22%2C%22segments%22%3A%22-1000%22%7D
    // So we assign the same score to them.
    return 0.6;
    // macOS
    if (/^Mac/.test(platform)) // Chrome provides more entropy than Safari and Safari provides more entropy than Firefox.
    // Chrome is more popular than Safari and Safari is more popular than Firefox according to
    // https://netmarketshare.com/browser-market-share.aspx?options=%7B%22filter%22%3A%7B%22%24and%22%3A%5B%7B%22platform%22%3A%7B%22%24in%22%3A%5B%22Mac%20OS%22%5D%7D%7D%5D%7D%2C%22dateLabel%22%3A%22Trend%22%2C%22attributes%22%3A%22share%22%2C%22group%22%3A%22browser%22%2C%22sort%22%3A%7B%22share%22%3A-1%7D%2C%22id%22%3A%22browsersDesktop%22%2C%22dateInterval%22%3A%22Monthly%22%2C%22dateStart%22%3A%222019-11%22%2C%22dateEnd%22%3A%222020-10%22%2C%22segments%22%3A%22-1000%22%7D
    // So we assign the same score to them.
    return 0.5;
    // Another platform, e.g. a desktop Linux. It's rare, so it should be pretty unique.
    return 0.7;
}
function $6c22f100bb55ca27$var$deriveProConfidenceScore(openConfidenceScore) {
    return $6c22f100bb55ca27$var$round(0.99 + 0.01 * openConfidenceScore, 0.0001);
}
function $6c22f100bb55ca27$var$componentsToCanonicalString(components) {
    var result = "";
    for(var _i = 0, _a = Object.keys(components).sort(); _i < _a.length; _i++){
        var componentKey = _a[_i];
        var component = components[componentKey];
        var value = "error" in component ? "error" : JSON.stringify(component.value);
        result += "".concat(result ? "|" : "").concat(componentKey.replace(/([:|\\])/g, "\\$1"), ":").concat(value);
    }
    return result;
}
function $6c22f100bb55ca27$export$6344a95760e963e3(components) {
    return JSON.stringify(components, function(_key, value) {
        if (value instanceof Error) return $6c22f100bb55ca27$var$errorToObject(value);
        return value;
    }, 2);
}
function $6c22f100bb55ca27$export$2f0bdfb2bbf78138(components) {
    return $6c22f100bb55ca27$var$x64hash128($6c22f100bb55ca27$var$componentsToCanonicalString(components));
}
/**
 * Makes a GetResult implementation that calculates the visitor id hash on demand.
 * Designed for optimisation.
 */ function $6c22f100bb55ca27$var$makeLazyGetResult(components) {
    var visitorIdCache;
    // This function runs very fast, so there is no need to make it lazy
    var confidence = $6c22f100bb55ca27$var$getConfidence(components);
    // A plain class isn't used because its getters and setters aren't enumerable.
    return {
        get visitorId () {
            if (visitorIdCache === undefined) visitorIdCache = $6c22f100bb55ca27$export$2f0bdfb2bbf78138(this.components);
            return visitorIdCache;
        },
        set visitorId (visitorId){
            visitorIdCache = visitorId;
        },
        confidence: confidence,
        components: components,
        version: $6c22f100bb55ca27$var$version
    };
}
/**
 * A delay is required to ensure consistent entropy components.
 * See https://github.com/fingerprintjs/fingerprintjs/issues/254
 * and https://github.com/fingerprintjs/fingerprintjs/issues/307
 * and https://github.com/fingerprintjs/fingerprintjs/commit/945633e7c5f67ae38eb0fea37349712f0e669b18
 */ function $6c22f100bb55ca27$export$cbc1b2f4f14b19e1(delayFallback) {
    if (delayFallback === void 0) delayFallback = 50;
    // A proper deadline is unknown. Let it be twice the fallback timeout so that both cases have the same average time.
    return $6c22f100bb55ca27$var$requestIdleCallbackIfAvailable(delayFallback, delayFallback * 2);
}
/**
 * The function isn't exported from the index file to not allow to call it without `load()`.
 * The hiding gives more freedom for future non-breaking updates.
 *
 * A factory function is used instead of a class to shorten the attribute names in the minified code.
 * Native private class fields could've been used, but TypeScript doesn't allow them with `"target": "es5"`.
 */ function $6c22f100bb55ca27$var$makeAgent(getComponents, debug) {
    var creationTime = Date.now();
    return {
        get: function(options) {
            return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, void 0, void 0, function() {
                var startTime, components, result;
                return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            startTime = Date.now();
                            return [
                                4 /*yield*/ ,
                                getComponents()
                            ];
                        case 1:
                            components = _a.sent();
                            result = $6c22f100bb55ca27$var$makeLazyGetResult(components);
                            if (debug || (options === null || options === void 0 ? void 0 : options.debug)) // console.log is ok here because it's under a debug clause
                            // eslint-disable-next-line no-console
                            console.log("Copy the text below to get the debug data:\n\n```\nversion: ".concat(result.version, "\nuserAgent: ").concat(navigator.userAgent, "\ntimeBetweenLoadAndGet: ").concat(startTime - creationTime, "\nvisitorId: ").concat(result.visitorId, "\ncomponents: ").concat($6c22f100bb55ca27$export$6344a95760e963e3(components), "\n```"));
                            return [
                                2 /*return*/ ,
                                result
                            ];
                    }
                });
            });
        }
    };
}
/**
 * Sends an unpersonalized AJAX request to collect installation statistics
 */ function $6c22f100bb55ca27$var$monitor() {
    // The FingerprintJS CDN (https://github.com/fingerprintjs/cdn) replaces `window.__fpjs_d_m` with `true`
    if (window.__fpjs_d_m || Math.random() >= 0.001) return;
    try {
        var request = new XMLHttpRequest();
        request.open("get", "https://m1.openfpcdn.io/fingerprintjs/v".concat($6c22f100bb55ca27$var$version, "/npm-monitoring"), true);
        request.send();
    } catch (error) {
        // console.error is ok here because it's an unexpected error handler
        // eslint-disable-next-line no-console
        console.error(error);
    }
}
/**
 * Builds an instance of Agent and waits a delay required for a proper operation.
 */ function $6c22f100bb55ca27$export$11e63f7b0f3d9900(options) {
    var _a;
    if (options === void 0) options = {};
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, void 0, void 0, function() {
        var delayFallback, debug, getComponents;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_b) {
            switch(_b.label){
                case 0:
                    if ((_a = options.monitoring) !== null && _a !== void 0 ? _a : true) $6c22f100bb55ca27$var$monitor();
                    delayFallback = options.delayFallback, debug = options.debug;
                    return [
                        4 /*yield*/ ,
                        $6c22f100bb55ca27$export$cbc1b2f4f14b19e1(delayFallback)
                    ];
                case 1:
                    _b.sent();
                    getComponents = $6c22f100bb55ca27$var$loadBuiltinSources({
                        cache: {},
                        debug: debug
                    });
                    return [
                        2 /*return*/ ,
                        $6c22f100bb55ca27$var$makeAgent(getComponents, debug)
                    ];
            }
        });
    });
}
// The default export is a syntax sugar (`import * as FP from '...' → import FP from '...'`).
// It should contain all the public exported values.
var $6c22f100bb55ca27$export$2e2bcd8739ae039 = {
    load: $6c22f100bb55ca27$export$11e63f7b0f3d9900,
    hashComponents: $6c22f100bb55ca27$export$2f0bdfb2bbf78138,
    componentsToDebugString: $6c22f100bb55ca27$export$6344a95760e963e3
};
// The exports below are for private usage. They may change unexpectedly. Use them at your own risk.
/** Not documented, out of Semantic Versioning, usage is at your own risk */ var $6c22f100bb55ca27$export$bdcc90ce86afeb19 = $6c22f100bb55ca27$var$x64hash128;


const $cfb72012501f1da3$export$a5c2098c02d2840a = ()=>{
    const [userId, setUserId] = (0, $acw62.useState)("");
    (0, $acw62.useEffect)(()=>{
        // Initialize an agent at application startup.
        const load = async ()=>{
            const fp = await (0, $6c22f100bb55ca27$export$2e2bcd8739ae039).load();
            // Get the visitor identifier when you need it.
            fp.get().then((result)=>{
                // This is the visitor identifier:
                const visitorId = (0, (/*@__PURE__*/$parcel$interopDefault($d82da40f8ecfe37f$exports)))(result.visitorId);
                setUserId(visitorId);
            });
        };
        load();
    }, []);
    return userId;
};


var $7826cd0ffc47939f$export$c31ed58ef4f1e87c;
var $7826cd0ffc47939f$export$e6476b16e931db0d;
var $7826cd0ffc47939f$export$f4c5de44377d2946;
var $7826cd0ffc47939f$export$3c43eca7ae3a5135;
var $7826cd0ffc47939f$export$9c223f06f3c6f246;
var $7826cd0ffc47939f$export$dab320bac350fdc4;
var $7826cd0ffc47939f$export$e77a7bd4958cb909;
var $7826cd0ffc47939f$export$e8e78c978b129247;
var $7826cd0ffc47939f$export$fe13910f56cde4c7;
var $7826cd0ffc47939f$export$73476eae4e993279;
var $7826cd0ffc47939f$export$1de3aa6ac8bf087a;
var $7826cd0ffc47939f$export$96de0d1064d5661a;
var $7826cd0ffc47939f$export$d9aa71f96dda8d28;
$7826cd0ffc47939f$export$c31ed58ef4f1e87c = `jMgrDa_answerInfo`;
$7826cd0ffc47939f$export$e6476b16e931db0d = `jMgrDa_helpline`;
$7826cd0ffc47939f$export$f4c5de44377d2946 = `jMgrDa_loader`;
$7826cd0ffc47939f$export$3c43eca7ae3a5135 = `jMgrDa_loadingView`;
$7826cd0ffc47939f$export$9c223f06f3c6f246 = `jMgrDa_playerButton`;
$7826cd0ffc47939f$export$dab320bac350fdc4 = `jMgrDa_playerScreenInput`;
$7826cd0ffc47939f$export$e77a7bd4958cb909 = `jMgrDa_qrReader`;
$7826cd0ffc47939f$export$e8e78c978b129247 = `jMgrDa_root`;
$7826cd0ffc47939f$export$fe13910f56cde4c7 = `jMgrDa_teamHeadline`;
$7826cd0ffc47939f$export$73476eae4e993279 = `jMgrDa_teamInput`;
$7826cd0ffc47939f$export$1de3aa6ac8bf087a = `jMgrDa_teamInputButton`;
$7826cd0ffc47939f$export$96de0d1064d5661a = `jMgrDa_teamInputWrapper`;
$7826cd0ffc47939f$export$d9aa71f96dda8d28 = `jMgrDa_userId`;


const $b51b99488868c5df$var$noSleep = new $50e735a1de9ac006$exports();
document.addEventListener("click", function enableNoSleep() {
    document.removeEventListener("click", enableNoSleep, false);
    $b51b99488868c5df$var$noSleep.enable();
}, false);
const $b51b99488868c5df$var$PlayerButton = ({ color: color, onClick: onClick })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        className: $7826cd0ffc47939f$export$9c223f06f3c6f246,
        onClick: onClick,
        style: {
            backgroundColor: color
        }
    }, "ANSWER!");
const $b51b99488868c5df$export$f585ae23105e7fac = ()=>{
    const userId = (0, $cfb72012501f1da3$export$a5c2098c02d2840a)();
    const categories = (0, $b090720bc1d5aaf4$export$17897f9a67d1488d)();
    const teams = (0, $b090720bc1d5aaf4$export$6fe02dcc2001dcb0)();
    const signedTeam = teams.filter((team)=>team.members.includes(userId))[0];
    const currentAnswer = categories.flatMap((category)=>category.answers).find((answer)=>answer.show);
    // initShake(userId, signedTeam)
    const handleTeamInput = (teamId)=>{
        const team = teamId.target.value;
        if (team.length < 4) return;
        (0, $b090720bc1d5aaf4$export$c38b5ab6cd57b371)(userId, team).then((_)=>{
            console.log("new team member: ", userId, "for team: ", team);
        }).catch((err)=>console.log(err));
    };
    const handleAnswerClick = (0, $acw62.useCallback)(()=>{
        if (!currentAnswer) return;
        (0, $b090720bc1d5aaf4$export$6bccf8bd051c9fb9)(currentAnswer.id, signedTeam.id).then((_)=>{
            console.log("question:", currentAnswer.id, "team:", signedTeam.id, "user:", userId, "request to answer:", new Date());
        }).catch((err)=>{
            console.log(err);
        });
    }, [
        currentAnswer,
        signedTeam,
        userId
    ]);
    // const handleError = error => {
    // 	return () => {
    // 		console.log("Something went wrong", error);
    // 	};
    // };
    // const handleScan = (data: any) => {
    // 	if (data) {
    // 		console.log("new team member: ", userId, "for team: ", data);
    // 		addToTeam(userId, data);
    // 	}
    // };
    if (!userId) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: $7826cd0ffc47939f$export$3c43eca7ae3a5135
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d5bf021e81f47411$export$dcef8f9bb9a41431), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, "Jeopardy!")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("strong", null, "Jeopardy!")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: $7826cd0ffc47939f$export$f4c5de44377d2946
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f9e25097e7c59d91$exports.PacmanLoader), {
        sizeUnit: "px",
        size: 30,
        color: "#FFD700",
        loading: true
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: $7826cd0ffc47939f$export$e8e78c978b129247
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d5bf021e81f47411$export$dcef8f9bb9a41431), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, "Player ", userId)), signedTeam ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: $7826cd0ffc47939f$export$fe13910f56cde4c7
    }, "Your team: ", signedTeam.name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: $7826cd0ffc47939f$export$d9aa71f96dda8d28
    }, "User id: ", userId), currentAnswer && currentAnswer.type === (0, $c01512cbc56e2fb8$export$44e2388b3736c907).TEXT && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: $7826cd0ffc47939f$export$c31ed58ef4f1e87c
    }, currentAnswer && currentAnswer.answer), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b51b99488868c5df$var$PlayerButton, {
        onClick: handleAnswerClick,
        color: signedTeam.color
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
        onInput: handleTeamInput,
        className: $7826cd0ffc47939f$export$dab320bac350fdc4,
        placeholder: "Enter your team ID",
        type: "text"
    })));
};


const $cd93687958c8007e$export$86fbec116b87613f = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: $353901cfdd316a0a$export$e8e78c978b129247
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66249767282b1118$export$55185c17a0fcbe46), {
        className: $353901cfdd316a0a$export$c2b3f2d5308a7abd
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b51b99488868c5df$export$f585ae23105e7fac), {
        path: "/"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b85c06db64fa360d$export$dc9708c613b75ef5), {
        path: "/gamescreen"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $32ce01693f31f064$export$1860a93e5e8ebd61), {
        path: "/moderator"
    })));
};


(0, (/*@__PURE__*/$parcel$interopDefault($1u0KT))).render(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cd93687958c8007e$export$86fbec116b87613f), null), document.getElementById("root"));


//# sourceMappingURL=index.3bc1943d.js.map
